/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(403);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Convinient base component and ui utilities
	 */
	exports.React = __webpack_require__(2);
	exports.ReactDOM = __webpack_require__(17);
	var events_1 = __webpack_require__(19);
	exports.$ = __webpack_require__(36);
	/** The base component that provides an easy access point for overall app behaviour changes */
	var BaseComponent = /** @class */ (function (_super) {
	    __extends(BaseComponent, _super);
	    function BaseComponent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.disposible = new events_1.CompositeDisposible();
	        _this.isUnmounted = false;
	        _this._afterComponentDidUpdateQueue = [];
	        _this.getParentDomNode = function () {
	            var node = exports.ReactDOM.findDOMNode(_this);
	            return node.parentElement;
	        };
	        return _this;
	    }
	    BaseComponent.prototype.componentWillUnmount = function () {
	        this.disposible.dispose();
	        this.isUnmounted = true;
	    };
	    // Making it easier to deal with refs
	    BaseComponent.prototype.ref = function (name) {
	        return this.refs[name];
	    };
	    /**
	     * Register stuff to call after component did update
	     * Note: For redux-connected component,
	     * - call this *before* calling state action
	     *   (as its a bit undeterministic and sometimes runs render / didUpdate immediately after calling action)
	     */
	    BaseComponent.prototype.afterComponentDidUpdate = function (cb) {
	        this._afterComponentDidUpdateQueue.push(cb);
	    };
	    /**
	     * You generally want afterComponentDidUpdate.
	     */
	    BaseComponent.prototype.componentDidUpdate = function () {
	        this._afterComponentDidUpdateQueue.forEach(function (cb) { return cb(); });
	        this._afterComponentDidUpdateQueue = [];
	    };
	    return BaseComponent;
	}(exports.React.Component));
	exports.BaseComponent = BaseComponent;
	/**
	 * Certain components control when they unmount themselves
	 * e.g. Modals
	 * This gives a convinient point for this logic
	 */
	function getUnmountableNode() {
	    var node = document.createElement('div');
	    var unmount = function () {
	        exports.ReactDOM.unmountComponentAtNode(node);
	        node.remove();
	    };
	    return { node: node, unmount: unmount };
	}
	exports.getUnmountableNode = getUnmountableNode;
	/**
	 * Toggle component
	 * http://instructure-react.github.io/react-toggle/
	 */
	exports.Toggle = __webpack_require__(323);
	__webpack_require__(361);
	/**
	 * Notifications
	 */
	var toastr = __webpack_require__(149);
	__webpack_require__(362);
	function notifyInfoQuickDisappear(message) {
	    toastr.info(message, null, { timeOut: 600 });
	}
	exports.notifyInfoQuickDisappear = notifyInfoQuickDisappear;
	function notifyInfoNormalDisappear(message, options) {
	    toastr.info(message, null, options && { onclick: options.onClick });
	}
	exports.notifyInfoNormalDisappear = notifyInfoNormalDisappear;
	function notifyWarningNormalDisappear(message, options) {
	    toastr.warning(message, null, options && { onclick: options.onClick });
	}
	exports.notifyWarningNormalDisappear = notifyWarningNormalDisappear;
	function notifySuccessNormalDisappear(message, options) {
	    toastr.success(message, null, options && { onclick: options.onClick });
	}
	exports.notifySuccessNormalDisappear = notifySuccessNormalDisappear;
	function comingSoon(featureName) {
	    toastr.info("Coming soon! : " + featureName);
	}
	exports.comingSoon = comingSoon;
	/**
	 * Keyboard handling
	 */
	/** Utility function for keyboard handling */
	function getKeyStates(e) {
	    var event = e; // This is a lie .... but a convinient one as react provides the same stuff
	    var nativeEvent = e.nativeEvent; // This is the truth
	    var tab = event.key == 'Tab';
	    var shift = nativeEvent.shiftKey;
	    var mod = nativeEvent.metaKey || nativeEvent.ctrlKey;
	    var enter = event.key == 'Enter';
	    var up = event.key == 'ArrowUp';
	    var down = event.key == 'ArrowDown';
	    var tabNext = tab && !shift;
	    var tabPrevious = tab && shift;
	    return { tab: tab, tabNext: tabNext, tabPrevious: tabPrevious, up: up, down: down, shift: shift, mod: mod, enter: enter };
	}
	exports.getKeyStates = getKeyStates;
	exports.DraggableCore = __webpack_require__(312).DraggableCore;
	/**
	 * General react utilities
	 */
	/** Creates whitespace from a 0 based indent */
	function indent(indent, tabSize) {
	    if (tabSize === void 0) { tabSize = 4; }
	    return Array((indent * tabSize) + 1).join().split('').map(function (i) { return "\u00a0"; });
	}
	exports.indent = indent;
	/**
	 * General utility for consistent coloring
	 */
	function kindToColor(kind, lighten) {
	    if (lighten === void 0) { lighten = false; }
	    var add = lighten ? 50 : 0;
	    var opacity = lighten ? 0.2 : 1;
	    switch (kind) {
	        case ts.ScriptElementKind.keyword:
	        case 'snippet':
	            // redish
	            return "rgba(" + (0xf9 + add) + "," + (0x26 + add) + "," + (0x72 + add) + "," + opacity + ")";
	        case ts.ScriptElementKind.scriptElement:
	        case ts.ScriptElementKind.moduleElement:
	        case ts.ScriptElementKind.classElement:
	        case ts.ScriptElementKind.localClassElement:
	        case ts.ScriptElementKind.interfaceElement:
	        case ts.ScriptElementKind.typeElement:
	        case ts.ScriptElementKind.enumElement:
	        case ts.ScriptElementKind.alias:
	        case ts.ScriptElementKind.typeParameterElement:
	        case ts.ScriptElementKind.primitiveType:
	            // yelloish
	            // #e6db74
	            return "rgba(" + (0xe6 + add) + "," + (0xdb + add) + "," + (0x74 + add) + "," + opacity + ")";
	        case ts.ScriptElementKind.variableElement:
	        case ts.ScriptElementKind.localVariableElement:
	        case ts.ScriptElementKind.memberVariableElement:
	        case ts.ScriptElementKind.letElement:
	        case ts.ScriptElementKind.constElement:
	        case ts.ScriptElementKind.label:
	        case ts.ScriptElementKind.parameterElement:
	        case ts.ScriptElementKind.indexSignatureElement:
	            // blueish
	            // #66d9ef
	            return "rgba(" + (0x66 + add) + "," + (0xd9 + add) + "," + (0xef + add) + "," + opacity + ")";
	        case ts.ScriptElementKind.functionElement:
	        case ts.ScriptElementKind.localFunctionElement:
	        case ts.ScriptElementKind.memberFunctionElement:
	        case ts.ScriptElementKind.memberGetAccessorElement:
	        case ts.ScriptElementKind.memberSetAccessorElement:
	        case ts.ScriptElementKind.callSignatureElement:
	        case ts.ScriptElementKind.constructorImplementationElement:
	        case 'path':
	            // greenish
	            // #a6e22e
	            return "rgba(" + (0xa6 + add) + "," + (0xe2 + add) + "," + (0x2e + add) + "," + opacity + ")";
	        default:
	            return "rgba(" + (0xaa + add) + "," + (0xaa + add) + "," + (0xaa + add) + "," + opacity + ")";
	    }
	}
	exports.kindToColor = kindToColor;
	/**
	 * For consitent icon lookup against kind
	 */
	var fontAwesomeToCharCode_1 = __webpack_require__(467);
	function kindToIcon(kind) {
	    switch (kind) {
	        case 'snippet':
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.exchange);
	        case 'path':
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.fileText);
	        case ts.ScriptElementKind.keyword:
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.key);
	        case ts.ScriptElementKind.classElement:
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.copyright);
	        case ts.ScriptElementKind.interfaceElement:
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.infoCircle);
	        case ts.ScriptElementKind.scriptElement:
	        case ts.ScriptElementKind.moduleElement:
	        case ts.ScriptElementKind.localClassElement:
	        case ts.ScriptElementKind.typeElement:
	        case ts.ScriptElementKind.enumElement:
	        case ts.ScriptElementKind.alias:
	        case ts.ScriptElementKind.typeParameterElement:
	        case ts.ScriptElementKind.primitiveType:
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.archive);
	        case ts.ScriptElementKind.variableElement:
	        case ts.ScriptElementKind.localVariableElement:
	        case ts.ScriptElementKind.memberVariableElement:
	        case ts.ScriptElementKind.letElement:
	        case ts.ScriptElementKind.constElement:
	        case ts.ScriptElementKind.label:
	        case ts.ScriptElementKind.parameterElement:
	        case ts.ScriptElementKind.indexSignatureElement:
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.at);
	        case ts.ScriptElementKind.functionElement:
	        case ts.ScriptElementKind.localFunctionElement:
	        case ts.ScriptElementKind.memberFunctionElement:
	        case ts.ScriptElementKind.memberGetAccessorElement:
	        case ts.ScriptElementKind.memberSetAccessorElement:
	        case ts.ScriptElementKind.callSignatureElement:
	        case ts.ScriptElementKind.constructorImplementationElement:
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.circleArrowRight);
	        default:
	            return fontAwesomeToCharCode_1.toFontAwesomeCharCode(fontAwesomeToCharCode_1.FAIconName.info);
	    }
	}
	exports.kindToIcon = kindToIcon;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(34);


/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function log() {
	    console.log('log');
	}
	exports.log = log;
	/**
	 * Create a quick lookup map from list
	 */
	function createMap(arr) {
	    return arr.reduce(function (result, key) {
	        result[key] = true;
	        return result;
	    }, {});
	}
	exports.createMap = createMap;
	/**
	 * Create a quick lookup map from list
	 */
	function createMapByKey(arr, getKey) {
	    var result = {};
	    arr.forEach(function (item) {
	        var key = getKey(item);
	        result[key] = result[key] ? result[key].concat(item) : [item];
	    });
	    return result;
	}
	exports.createMapByKey = createMapByKey;
	/**
	 * Turns keys into values and values into keys
	 */
	function reverseKeysAndValues(obj) {
	    var toret = {};
	    Object.keys(obj).forEach(function (key) {
	        toret[obj[key]] = key;
	    });
	    return toret;
	}
	exports.reverseKeysAndValues = reverseKeysAndValues;
	/** Sloppy but effective code to find distinct */
	function distinct(arr) {
	    var map = createMap(arr);
	    return Object.keys(map);
	}
	exports.distinct = distinct;
	exports.uniq = distinct;
	/**
	 * Values for dictionary
	 */
	function values(dict) {
	    return Object.keys(dict).map(function (key) { return dict[key]; });
	}
	exports.values = values;
	/**
	 * Debounce
	 */
	var now = function () { return new Date().getTime(); };
	function debounce(func, milliseconds, immediate) {
	    if (immediate === void 0) { immediate = false; }
	    var timeout, args, context, timestamp, result;
	    var wait = milliseconds;
	    var later = function () {
	        var last = now() - timestamp;
	        if (last < wait && last > 0) {
	            timeout = setTimeout(later, wait - last);
	        }
	        else {
	            timeout = null;
	            if (!immediate) {
	                result = func.apply(context, args);
	                if (!timeout)
	                    context = args = null;
	            }
	        }
	    };
	    return function () {
	        context = this;
	        args = arguments;
	        timestamp = now();
	        var callNow = immediate && !timeout;
	        if (!timeout)
	            timeout = setTimeout(later, wait);
	        if (callNow) {
	            result = func.apply(context, args);
	            context = args = null;
	        }
	        return result;
	    };
	}
	exports.debounce = debounce;
	;
	/**
	 * Like debounce but will also call if a state change is significant enough to not ignore silently
	 * Note:
	 *  - Significant changes : the function is called *immediately* without debouncing (but still marked for future debouncing).
	 */
	function triggeredDebounce(config) {
	    var lastArg, lastCallTimeStamp;
	    var hasALastArg = false; // true if we are `holding back` any previous arg
	    var pendingTimeout = null;
	    var later = function () {
	        var timeSinceLast = now() - lastCallTimeStamp;
	        if (timeSinceLast < config.milliseconds) {
	            if (pendingTimeout) {
	                clearTimeout(pendingTimeout);
	                pendingTimeout = null;
	            }
	            pendingTimeout = setTimeout(later, config.milliseconds - timeSinceLast);
	        }
	        else {
	            config.func(lastArg);
	            hasALastArg = false;
	        }
	    };
	    return function (arg) {
	        var stateChangeSignificant = hasALastArg && config.mustcall(arg, lastArg);
	        if (stateChangeSignificant) {
	            config.func(lastArg);
	        }
	        lastArg = arg;
	        hasALastArg = true;
	        lastCallTimeStamp = now();
	        later();
	    };
	}
	exports.triggeredDebounce = triggeredDebounce;
	;
	function throttle(func, milliseconds, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options)
	        options = {};
	    var gnow = now;
	    var later = function () {
	        previous = options.leading === false ? 0 : gnow();
	        timeout = null;
	        result = func.apply(context, args);
	        if (!timeout)
	            context = args = null;
	    };
	    return function () {
	        var now = gnow();
	        if (!previous && options.leading === false)
	            previous = now;
	        var remaining = milliseconds - (now - previous);
	        context = this;
	        args = arguments;
	        if (remaining <= 0 || remaining > milliseconds) {
	            if (timeout) {
	                clearTimeout(timeout);
	                timeout = null;
	            }
	            previous = now;
	            result = func.apply(context, args);
	            if (!timeout)
	                context = args = null;
	        }
	        else if (!timeout && options.trailing !== false) {
	            timeout = setTimeout(later, remaining);
	        }
	        return result;
	    };
	}
	exports.throttle = throttle;
	;
	function once(func) {
	    var ran = false;
	    var memo = undefined;
	    return function () {
	        if (ran)
	            return memo;
	        ran = true;
	        memo = func.apply(this, arguments);
	        func = null;
	        return memo;
	    };
	}
	exports.once = once;
	function rangeLimited(args) {
	    var num = args.num, min = args.min, max = args.max, loopAround = args.loopAround;
	    var limited = Math.max(Math.min(num, max), min);
	    if (loopAround && limited > num) {
	        return max;
	    }
	    if (loopAround && limited < num) {
	        return min;
	    }
	    return limited;
	}
	exports.rangeLimited = rangeLimited;
	/**
	 * Is TypeSript or is JavaScript file checks
	 */
	exports.isTs = function (filePath, ext) {
	    if (ext === void 0) { ext = getExt(filePath); }
	    return ext == 'ts' || ext == 'tsx';
	};
	exports.isTsx = function (filePath, ext) {
	    if (ext === void 0) { ext = getExt(filePath); }
	    return ext == 'tsx';
	};
	exports.isJs = function (filePath, ext) {
	    if (ext === void 0) { ext = getExt(filePath); }
	    return ext == 'js' || ext == 'jsx';
	};
	exports.isJsOrTs = function (filePath) {
	    var ext = getExt(filePath);
	    return exports.isJs(filePath, ext) || exports.isTs(filePath, ext);
	};
	/** `/asdf/bar/j.ts` => `ts` */
	function getExt(filePath) {
	    var parts = filePath.split('.');
	    return parts[parts.length - 1].toLowerCase();
	}
	exports.getExt = getExt;
	/**
	 * `/asdf/bar/j.ts` => `/asdf/bar/j`
	 * `/asdf/bar/j.d.ts` => `/asdf/bar/j.d`
	 */
	function removeExt(filePath) {
	    var dot = filePath.lastIndexOf('.');
	    if (dot === -1) {
	        return filePath;
	    }
	    return filePath.substring(0, dot);
	}
	exports.removeExt = removeExt;
	/**
	 * asdf/asdf:123 => asdf/asdf + 122
	 * Note: returned line is 0 based
	 */
	function getFilePathLine(query) {
	    var _a = query.split(':'), filePath = _a[0], lineNum = _a[1];
	    var line = lineNum ? parseInt(lineNum) - 1 : 0;
	    line = line > 0 ? line : 0;
	    return { filePath: filePath, line: line };
	}
	exports.getFilePathLine = getFilePathLine;
	/** `/asdf/bar/j.ts` => `j.ts` */
	function getFileName(fullFilePath) {
	    var parts = fullFilePath.split('/');
	    return parts[parts.length - 1];
	}
	exports.getFileName = getFileName;
	/** `/asdf/bar/j.ts` => `/asdf/bar` */
	function getDirectory(filePath) {
	    var directory = filePath.substring(0, filePath.lastIndexOf("/"));
	    return directory;
	}
	exports.getDirectory = getDirectory;
	/** Folder + filename only e.g. `/asdf/something/tsconfig.json` => `something/tsconfig.json` */
	function getDirectoryAndFileName(filePath) {
	    var directoryPath = getDirectory(filePath);
	    var directoryName = getFileName(directoryPath);
	    var fileName = getFileName(filePath);
	    return directoryName + "/" + fileName;
	}
	exports.getDirectoryAndFileName = getDirectoryAndFileName;
	/**
	 * shallow equality of sorted arrays
	 */
	function arraysEqual(a, b) {
	    if (a === b)
	        return true;
	    if (a == null || b == null)
	        return false;
	    if (a.length !== b.length)
	        return false;
	    for (var i = 0; i < a.length; ++i) {
	        if (a[i] !== b[i])
	            return false;
	    }
	    return true;
	}
	exports.arraysEqual = arraysEqual;
	/** Creates a Guid (UUID v4) */
	function createId() {
	    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
	        return v.toString(16);
	    });
	}
	exports.createId = createId;
	/** Creates a Guid (UUID v4) */
	exports.createGuid = createId;
	// Not optimized
	function selectMany(arr) {
	    var result = [];
	    for (var i = 0; i < arr.length; i++) {
	        for (var j = 0; j < arr[i].length; j++) {
	            result.push(arr[i][j]);
	        }
	    }
	    return result;
	}
	exports.selectMany = selectMany;
	/** From `file://filePath` to `filePath` */
	function getFilePathFromUrl(url) {
	    var filePath = getFilePathAndProtocolFromUrl(url).filePath;
	    return filePath;
	}
	exports.getFilePathFromUrl = getFilePathFromUrl;
	/** We consistently have tabs with protocol + filePath */
	function getFilePathAndProtocolFromUrl(url) {
	    // TODO: error handling
	    var protocol = url.substr(0, url.indexOf('://'));
	    var filePath = url.substr((protocol + '://').length);
	    return { protocol: protocol, filePath: filePath };
	}
	exports.getFilePathAndProtocolFromUrl = getFilePathAndProtocolFromUrl;
	function getUrlFromFilePathAndProtocol(config) {
	    return config.protocol + '://' + config.filePath;
	}
	exports.getUrlFromFilePathAndProtocol = getUrlFromFilePathAndProtocol;
	/**
	 * Promise.resolve is something I call the time (allows you to take x|promise and return promise ... aka make sync prog async if needed)
	 */
	exports.resolve = Promise.resolve.bind(Promise);
	/** Useful for various editor related stuff e.g. completions */
	var punctuations = createMap([';', '{', '}', '(', ')', '.', ':', '<', '>', "'", '"']);
	/** Does the prefix end in punctuation */
	exports.prefixEndsInPunctuation = function (prefix) { return prefix.length && prefix.trim().length && punctuations[prefix.trim()[prefix.trim().length - 1]]; };
	/** String based enum pattern */
	function stringEnum(x) {
	    // make values same as keys
	    Object.keys(x).map(function (key) { return x[key] = key; });
	}
	exports.stringEnum = stringEnum;
	/**
	 * Just adds your intercept function to be called whenever the original function is called
	 * Calls your function *before* the original is called
	 */
	function intercepted(config) {
	    return function () {
	        config.intercept.apply(null, arguments);
	        return config.orig.apply(config.context, arguments);
	    };
	}
	exports.intercepted = intercepted;
	/**
	 * path.relative for browser
	 * from : https://github.com/substack/path-browserify/blob/master/index.js
	 * but modified to not depened on `path.resolve` as from and to are already resolved in our case
	 */
	exports.relative = function (from, to) {
	    function trim(arr) {
	        var start = 0;
	        for (; start < arr.length; start++) {
	            if (arr[start] !== '')
	                break;
	        }
	        var end = arr.length - 1;
	        for (; end >= 0; end--) {
	            if (arr[end] !== '')
	                break;
	        }
	        if (start > end)
	            return [];
	        return arr.slice(start, end - start + 1);
	    }
	    var fromParts = trim(from.split('/'));
	    var toParts = trim(to.split('/'));
	    var length = Math.min(fromParts.length, toParts.length);
	    var samePartsLength = length;
	    for (var i = 0; i < length; i++) {
	        if (fromParts[i] !== toParts[i]) {
	            samePartsLength = i;
	            break;
	        }
	    }
	    var outputParts = [];
	    for (var i = samePartsLength; i < fromParts.length; i++) {
	        outputParts.push('..');
	    }
	    outputParts = outputParts.concat(toParts.slice(samePartsLength));
	    return outputParts.join('/');
	};
	exports.imageUrl = '/images';
	var supportedImages = {
	    'svg': 'image/svg+xml',
	    'gif': 'image/gif',
	    'png': 'image/png',
	    'jpg': 'image/jpeg',
	    'jpeg': 'image/jpeg',
	    'bmp': 'image/bmp'
	};
	var imageExtensions = Object.keys(supportedImages);
	/**
	 * Provides info on the image files we support
	 */
	function isImage(url) {
	    return imageExtensions.some(function (ext) { return url.endsWith("." + ext); });
	}
	exports.isImage = isImage;
	function getImageMimeType(filePath) {
	    var ext = getExt(filePath);
	    return supportedImages[ext];
	}
	exports.getImageMimeType = getImageMimeType;
	/**
	 * Great for find and replace
	 */
	function findOptionsToQueryRegex(options) {
	    // Note that Code mirror only takes `query` string *tries* to detect case senstivity, regex on its own
	    // So simpler if we just convert options into regex, and then code mirror will happy use the regex as is
	    var str = options.query;
	    var query;
	    /** This came from search.js in code mirror */
	    var defaultQuery = /x^/;
	    if (!options.isRegex) {
	        // from CMs search.js
	        str = str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	    }
	    if (options.isFullWord) {
	        str = "\\b" + str + "\\b";
	    }
	    try {
	        query = new RegExp(str, options.isCaseSensitive ? "g" : "gi");
	    }
	    catch (e) {
	        query = defaultQuery;
	    }
	    if (query.test("")) {
	        query = defaultQuery;
	    }
	    return query;
	}
	exports.findOptionsToQueryRegex = findOptionsToQueryRegex;
	/**
	 * Quick and dirty pad left
	 */
	function padLeft(str, paddingValue) {
	    var pad = '                                       ';
	    return pad.substring(0, paddingValue - str.length) + str;
	}
	exports.padLeft = padLeft;
	function extend() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var newObj = {};
	    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	        var obj = args_1[_a];
	        for (var key in obj) {
	            //copy all the fields
	            newObj[key] = obj[key];
	        }
	    }
	    return newObj;
	}
	exports.extend = extend;
	;
	/**
	 * Simple timer
	 */
	function timer() {
	    var timeStart = new Date().getTime();
	    return {
	        /** <integer>s e.g 2s etc. */
	        get seconds() {
	            var seconds = Math.ceil((new Date().getTime() - timeStart) / 1000) + 's';
	            return seconds;
	        },
	        /** Milliseconds e.g. 2000ms etc. */
	        get ms() {
	            var ms = (new Date().getTime() - timeStart) + 'ms';
	            return ms;
	        }
	    };
	}
	exports.timer = timer;
	/**
	 * Returns a nice conversion of milliseconds into seconds / mintues as needed
	 */
	function formatMilliseconds(ms) {
	    if (ms < 1000)
	        return ms + "ms";
	    var s = ms / 1000;
	    if (s < 60) {
	        return s.toFixed(2) + "s";
	    }
	    var m = s / 60;
	    return m.toFixed(2) + "min";
	}
	exports.formatMilliseconds = formatMilliseconds;
	/**
	 * If you add a new schema make sure you download its schema as well
	 */
	exports.supportedAutocompleteConfigFileNames = {
	    'tsconfig.json': true,
	    'package.json': true,
	    'tslint.json': true,
	    'alm.json': true,
	};
	/**
	 * Files for which we have autocomplete intelligence
	 */
	function isSupportedConfigFileForAutocomplete(filePath) {
	    var fileName = getFileName(filePath);
	    return !!exports.supportedAutocompleteConfigFileNames[fileName];
	}
	exports.isSupportedConfigFileForAutocomplete = isSupportedConfigFileForAutocomplete;
	exports.supportedHoverConfigFileNames = {
	    'package.json': true,
	};
	/**
	 * Files for which we have hover intelligence
	 */
	function isSupportedConfigFileForHover(filePath) {
	    var fileName = getFileName(filePath);
	    return !!exports.supportedHoverConfigFileNames[fileName];
	}
	exports.isSupportedConfigFileForHover = isSupportedConfigFileForHover;
	exports.cancellationToken = function () {
	    var cancelled = false;
	    return {
	        get isCancelled() {
	            return cancelled;
	        },
	        cancel: function () { return cancelled = true; }
	    };
	};
	exports.cancelled = "cancelled";
	/**
	 * Cancellable For Each
	 */
	function cancellableForEach(config) {
	    return new Promise(function (resolve, reject) {
	        var index = 0;
	        var lookAtNext = function () {
	            // Completed?
	            if (index === config.items.length) {
	                resolve({});
	            }
	            else if (config.cancellationToken.isCancelled) {
	                reject(exports.cancelled);
	            }
	            else {
	                var nextItem = config.items[index++];
	                config.cb(nextItem);
	                // Yield the thread for a bit
	                setTimeout(lookAtNext);
	            }
	        };
	        lookAtNext();
	    });
	}
	exports.cancellableForEach = cancellableForEach;
	/**
	 * https://github.com/facebook/react/issues/5465#issuecomment-157888325
	 */
	var makeCancelable = function (promise) {
	    var hasCanceled_ = false;
	    var wrappedPromise = new Promise(function (resolve, reject) {
	        promise.then(function (val) {
	            return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
	        });
	        promise.catch(function (error) {
	            return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
	        });
	    });
	    return {
	        promise: wrappedPromise,
	        cancel: function () {
	            hasCanceled_ = true;
	        },
	    };
	};
	/**
	 * For promise chains that might become invalid fast
	 */
	function onlyLastCall(call) {
	    /**
	     * Kept the delay to 0 as I am using this in select list view
	     * and that really benifits from immediate feedback.
	     */
	    var delay = 0;
	    var timeout;
	    var _resolve;
	    var _reject;
	    var _cancel = function () { return null; };
	    var later = function () {
	        timeout = null;
	        var _a = makeCancelable(call()), promise = _a.promise, cancel = _a.cancel;
	        _cancel = cancel;
	        promise
	            .then(function (res) {
	            _resolve(res);
	        })
	            .catch(function (rej) {
	            _reject(rej);
	        });
	    };
	    var trueCall = function () { return new Promise(function (resolve, reject) {
	        if (timeout) {
	            clearTimeout(timeout);
	        }
	        // Cancel any pending
	        _cancel();
	        _resolve = resolve;
	        _reject = reject;
	        timeout = setTimeout(later, delay);
	    }); };
	    return trueCall;
	}
	exports.onlyLastCall = onlyLastCall;
	/**
	 * Delay given ms
	 */
	function delay(ms) {
	    return new Promise(function (res) { return setTimeout(res, ms); });
	}
	exports.delay = delay;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var slc = __webpack_require__(474);
	var contract = __webpack_require__(164);
	exports.Types = contract.Types;
	var Client;
	(function (Client) {
	    Client.increment = function (q) {
	        return Promise.resolve({
	            num: ++q.num
	        });
	    };
	})(Client || (Client = {}));
	// Ensure that the namespace follows the contract
	var _checkTypes = Client;
	// launch client
	exports.server = (_a = slc.run({ clientImplementation: Client, serverContract: contract.server, cast: contract.cast }), _a.server), exports.cast = _a.cast, exports.pendingRequestsChanged = _a.pendingRequestsChanged, exports.connectionStatusChanged = _a.connectionStatusChanged;
	// Sample usage
	exports.cast.hello.on(function (p) { console.log(p); });
	var _a;


/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Provides useful `style` primitives
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function extend() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // Defend against user error
	    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	        var obj = args_1[_a];
	        if (obj instanceof Array) {
	            throw new Error("User error: use extend(a,b) instead of extend([a,b]). Object: " + obj);
	        }
	    }
	    var newObj = {};
	    for (var _b = 0, args_2 = args; _b < args_2.length; _b++) {
	        var obj = args_2[_b];
	        for (var key in obj) {
	            //copy all the fields
	            newObj[key] = obj[key];
	        }
	    }
	    return newObj;
	}
	exports.extend = extend;
	;
	/** If you have more than one child prefer horizontal,vertical */
	exports.flexRoot = {
	    display: 'flex',
	};
	/**
	 * A general grouping component that has no impact on the parent flexbox properties e.g.
	 * <vertical>
	 *    <pass>
	 *       <content/>
	 *    </pass>
	 * </vertical>
	 */
	exports.pass = {
	    display: 'inherit',
	    flexDirection: 'inherit',
	    flexGrow: 1,
	};
	exports.inlineRoot = {
	    display: 'inline-flex'
	};
	exports.horizontal = extend(exports.flexRoot, {
	    flexDirection: 'row'
	});
	exports.vertical = extend(exports.flexRoot, {
	    flexDirection: 'column'
	});
	exports.wrap = {
	    flexWrap: 'wrap'
	};
	exports.flexNone = {
	    flex: 'none'
	};
	/**
	 * If you want items to be sized automatically by their children use this
	 * This is because of a bug in various flexbox implementations: http://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/
	 */
	exports.content = {
	    flexShrink: 0
	};
	exports.flex = {
	    flex: 1
	};
	exports.flex1 = exports.flex;
	exports.flex2 = {
	    flex: 2
	};
	exports.flex3 = {
	    flex: 3
	};
	exports.flex4 = {
	    flex: 4
	};
	exports.flex5 = {
	    flex: 5
	};
	exports.flex6 = {
	    flex: 6
	};
	exports.flex7 = {
	    flex: 7
	};
	exports.flex8 = {
	    flex: 8
	};
	exports.flex9 = {
	    flex: 9
	};
	exports.flex10 = {
	    flex: 10
	};
	exports.flex11 = {
	    flex: 11
	};
	exports.flex12 = {
	    flex: 12
	};
	/////////////////////////////
	// Alignment in cross axis //
	/////////////////////////////
	exports.start = {
	    alignItems: 'flex-start'
	};
	exports.center = {
	    alignItems: 'center'
	};
	exports.end = {
	    alignItems: 'flex-end'
	};
	////////////////////////////
	// Alignment in main axis //
	////////////////////////////
	exports.startJustified = {
	    justifyContent: 'flex-start'
	};
	exports.centerJustified = {
	    justifyContent: 'center'
	};
	exports.endJustified = {
	    justifyContent: 'flex-end'
	};
	exports.aroundJustified = {
	    justifyContent: 'space-around'
	};
	exports.betweenJustified = {
	    justifyContent: 'space-between'
	};
	////////////////////////////
	// Alignment in both axes //
	////////////////////////////
	exports.centerCenter = extend(exports.flexRoot, exports.center, exports.centerJustified);
	////////////////////
	// Self alignment //
	////////////////////
	exports.selfStart = {
	    alignSelf: 'flex-start'
	};
	exports.selfCenter = {
	    alignSelf: 'center'
	};
	exports.selfEnd = {
	    alignSelf: 'flex-end'
	};
	exports.selfStretch = {
	    alignSelf: 'stretch'
	};
	//////////////////
	// Other layout //
	//////////////////
	exports.block = {
	    display: 'block'
	};
	exports.hidden = {
	    display: 'none'
	};
	exports.invisible = {
	    visibility: 'hidden'
	};
	exports.relative = {
	    position: 'relative'
	};
	exports.fit = {
	    position: 'absolute',
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0,
	};
	exports.fullBleedBody = {
	    margin: 0,
	    height: '100vh'
	};
	exports.scroll = {
	    overflow: 'auto'
	};
	////////////////////
	// Fixed position //
	////////////////////
	/**
	 * You don't generally need to use this.
	 * Instead use fixedBottom,fixedLeft,fixedRight,fixedTop
	 */
	exports.fixed = {
	    position: 'fixed'
	};
	exports.fixedTop = extend(exports.fixed, {
	    top: 0,
	    left: 0,
	    right: 0,
	});
	exports.fixedRight = extend(exports.fixed, {
	    top: 0,
	    right: 0,
	    bottom: 0,
	});
	exports.fixedBottom = extend(exports.fixed, {
	    right: 0,
	    bottom: 0,
	    left: 0,
	});
	exports.fixedLeft = extend(exports.fixed, {
	    top: 0,
	    bottom: 0,
	    left: 0,
	});
	//////////////////
	// A new layer  //
	//////////////////
	/**
	 * New Layer parent
	 */
	exports.newLayerParent = {
	    position: 'relative',
	};
	/**
	 *  You can have this anywhere and its like you have opened a new body
	 *  This new layer will attach itself to the nearest parent with `position:relative` or `position:absolute` (which is what a new layer is by itself)
	 */
	exports.newLayer = {
	    position: 'absolute',
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	};
	/**
	 * Box helpers
	 * Having top, left, bottom, right seperated makes it easier to override and maintain individual properties
	 */
	var Box;
	(function (Box) {
	    function boxUnitToString(value) {
	        if (typeof value === 'number') {
	            return value.toString() + 'px';
	        }
	        else {
	            return value;
	        }
	    }
	    /**
	     * Takes a function that expects Box to be passed into it
	     * and creates a BoxFunction
	     */
	    function createBoxFunction(mapFromBox) {
	        var result = function (a, b, c, d) {
	            if (b === undefined && c === undefined && d === undefined) {
	                b = c = d = a;
	            }
	            else if (c === undefined && d === undefined) {
	                c = a;
	                d = b;
	            }
	            var box = {
	                top: boxUnitToString(a),
	                right: boxUnitToString(b),
	                bottom: boxUnitToString(c),
	                left: boxUnitToString(d)
	            };
	            return mapFromBox(box);
	        };
	        return result;
	    }
	    Box.padding = createBoxFunction(function (box) {
	        return {
	            paddingTop: box.top,
	            paddingRight: box.right,
	            paddingBottom: box.bottom,
	            paddingLeft: box.left
	        };
	    });
	    Box.margin = createBoxFunction(function (box) {
	        return {
	            marginTop: box.top,
	            marginRight: box.right,
	            marginBottom: box.bottom,
	            marginLeft: box.left
	        };
	    });
	    Box.border = createBoxFunction(function (box) {
	        return {
	            borderTop: box.top,
	            borderRight: box.right,
	            borderBottom: box.bottom,
	            borderLeft: box.left
	        };
	    });
	})(Box = exports.Box || (exports.Box = {}));
	/**
	 * Flexbox Primitives with fallbacks
	 * Because of the `fallbacks` (arrays and vendor prefixes) these should only be used in css generation (not raw styles)
	 * E.g. `free-style` can use these to generate style sheets
	 * NOTE:
	 * -webkit- is needed for mobile safari (iPad)
	 */
	var vendorPrefixed;
	(function (vendorPrefixed) {
	    /** If you have more than one child prefer horizontal,vertical */
	    vendorPrefixed.flexRoot = {
	        display: ['-webkit-flex', 'flex']
	    };
	    vendorPrefixed.content = {
	        '-webkit-flex-shrink': 0,
	        flexShrink: 0,
	    };
	    vendorPrefixed.pass = {
	        display: 'inherit',
	        '-webkit-flex-direction': 'pass',
	        flexDirection: 'inherit',
	        '-webkit-flex-grow': 1,
	        flexGrow: 1,
	    };
	    vendorPrefixed.flex = {
	        '-webkit-flex': 1,
	        flex: 1,
	    };
	    vendorPrefixed.horizontal = extend(vendorPrefixed.flexRoot, {
	        '-webkit-flex-direction': 'row',
	        flexDirection: 'row',
	    });
	    vendorPrefixed.vertical = extend(vendorPrefixed.flexRoot, {
	        '-webkit-flex-direction': 'column',
	        flexDirection: 'column',
	    });
	    vendorPrefixed.selfCenter = {
	        '-webkit-align-self': 'center',
	        alignSelf: 'center',
	    };
	    vendorPrefixed.center = {
	        '-webkit-align-items': 'center',
	        alignItems: 'center'
	    };
	    vendorPrefixed.centerJustified = {
	        '-webkit-justify-content': 'center',
	        justifyContent: 'center'
	    };
	    vendorPrefixed.centerCenter = extend(vendorPrefixed.flexRoot, vendorPrefixed.center, vendorPrefixed.centerJustified);
	    vendorPrefixed.scroll = {
	        '-webkit-overflow-scrolling': 'touch',
	        overflow: 'auto'
	    };
	})(vendorPrefixed = exports.vendorPrefixed || (exports.vendorPrefixed = {}));


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Defines:
	 * commands / command registry / code editor commands
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// Keyboard shortcut origins:
	// c9: cloud9 IDE
	// ca: CodeAnywhere
	// atom: github atom
	// sublime: sublime text
	// code: VScode
	//---------------------------------------------
	//
	// This file also sets up Monaco keybindings
	var Mousetrap = __webpack_require__(63);
	__webpack_require__(241);
	var events = __webpack_require__(19);
	var CommandContext;
	(function (CommandContext) {
	    CommandContext[CommandContext["Global"] = 0] = "Global";
	    CommandContext[CommandContext["Editor"] = 1] = "Editor";
	    CommandContext[CommandContext["TreeView"] = 2] = "TreeView";
	})(CommandContext = exports.CommandContext || (exports.CommandContext = {}));
	/**
	 * The command registry composed of commands that are keyboard only
	 */
	exports.commandRegistry = [];
	/**
	 * A command is just an event emitter with some useful properties relevant to the front end command registry
	 * such commands cannot have a payload
	 */
	var UICommand = /** @class */ (function (_super) {
	    __extends(UICommand, _super);
	    function UICommand(config) {
	        var _this = _super.call(this) || this;
	        _this.config = config;
	        exports.commandRegistry.push(_this);
	        return _this;
	    }
	    return UICommand;
	}(events.TypedEvent));
	exports.UICommand = UICommand;
	/**
	 * BAS
	 */
	// export const bas = new UICommand({
	//     description: "BAS: I map this to whatever command I am currently testing",
	//     context: CommandContext.Global,
	// });
	/**
	 * General purpose UI escape
	 */
	exports.esc = new UICommand({
	    keyboardShortcut: 'esc',
	    description: "Close any open dialogs and focus back to any open tab",
	    context: CommandContext.Global,
	});
	/**
	 * Active list
	 */
	exports.gotoNext = new UICommand({
	    keyboardShortcut: 'mod+f8',
	    description: "Main Panel : Goto next error in project",
	    context: CommandContext.Global,
	});
	exports.gotoPrevious = new UICommand({
	    keyboardShortcut: 'mod+shift+f8',
	    description: "Main Panel : Goto previous error in project",
	    context: CommandContext.Global,
	});
	/**
	 * Tabs
	 */
	exports.nextTab = new UICommand({
	    keyboardShortcut: 'alt+k',
	    description: "Tabs: Focus on the Next Tab",
	    context: CommandContext.Global,
	});
	exports.prevTab = new UICommand({
	    keyboardShortcut: 'alt+j',
	    description: "Tabs: Focus on the Previous Tab",
	    context: CommandContext.Global,
	});
	exports.closeTab = new UICommand({
	    keyboardShortcut: 'alt+w',
	    description: "Tabs: Close current tab",
	    context: CommandContext.Global,
	});
	exports.undoCloseTab = new UICommand({
	    keyboardShortcut: 'shift+alt+w',
	    description: "Tabs: Undo close tab",
	    context: CommandContext.Global,
	});
	exports.saveTab = new UICommand({
	    keyboardShortcut: 'mod+s',
	    description: "Tabs: Save current tab",
	    context: CommandContext.Global,
	});
	exports.closeOtherTabs = new UICommand({
	    description: "Tabs: Close other tabs",
	    context: CommandContext.Global,
	});
	exports.closeAllTabs = new UICommand({
	    description: "Tabs: Close all tabs",
	    context: CommandContext.Global,
	});
	exports.jumpToTab = new UICommand({
	    keyboardShortcut: 'mod+shift+enter',
	    description: "Tabs: Jump to tab",
	    context: CommandContext.Global,
	});
	exports.duplicateTab = new UICommand({
	    description: "Tabs: Duplicate",
	    context: CommandContext.Global,
	});
	exports.duplicateWindow = new UICommand({
	    description: "Window: Duplicate in a new browser window",
	    context: CommandContext.Global,
	});
	/**
	 * Build / output js
	 */
	exports.sync = new UICommand({
	    keyboardShortcut: 'shift+f6',
	    description: "TypeScript: Sync",
	    context: CommandContext.Global,
	});
	exports.build = new UICommand({
	    keyboardShortcut: 'f6',
	    description: "TypeScript: Build",
	    context: CommandContext.Global,
	});
	exports.toggleOutputJS = new UICommand({
	    keyboardShortcut: 'mod+shift+m',
	    description: "TypeScript: Toggle output js file",
	    context: CommandContext.Global,
	});
	exports.enableLiveDemo = new UICommand({
	    description: "TypeScript: Demo file",
	    context: CommandContext.Global,
	});
	exports.disableLiveDemo = new UICommand({
	    description: "TypeScript: Demo stop",
	    context: CommandContext.Global,
	});
	exports.enableLiveDemoReact = new UICommand({
	    description: "TypeScript: Demo react file",
	    context: CommandContext.Global,
	});
	exports.disableLiveDemoReact = new UICommand({
	    description: "TypeScript: Demo react stop",
	    context: CommandContext.Global,
	});
	/**
	 * Tab indexing
	 * // c9, chrome, atom
	 */
	exports.gotoTab1 = new UICommand({
	    keyboardShortcut: 'mod+1',
	    description: "Tabs: Goto Tab 1",
	    context: CommandContext.Global,
	});
	exports.gotoTab2 = new UICommand({
	    keyboardShortcut: 'mod+2',
	    description: "Tabs: Goto Tab 2",
	    context: CommandContext.Global,
	});
	exports.gotoTab3 = new UICommand({
	    keyboardShortcut: 'mod+3',
	    description: "Tabs: Goto Tab 3",
	    context: CommandContext.Global,
	});
	exports.gotoTab4 = new UICommand({
	    keyboardShortcut: 'mod+4',
	    description: "Tabs: Goto Tab 4",
	    context: CommandContext.Global,
	});
	exports.gotoTab5 = new UICommand({
	    keyboardShortcut: 'mod+5',
	    description: "Tabs: Goto Tab 5",
	    context: CommandContext.Global,
	});
	exports.gotoTab6 = new UICommand({
	    keyboardShortcut: 'mod+6',
	    description: "Tabs: Goto Tab 6",
	    context: CommandContext.Global,
	});
	exports.gotoTab7 = new UICommand({
	    keyboardShortcut: 'mod+7',
	    description: "Tabs: Goto Tab 7",
	    context: CommandContext.Global,
	});
	exports.gotoTab8 = new UICommand({
	    keyboardShortcut: 'mod+8',
	    description: "Tabs: Goto Tab 8",
	    context: CommandContext.Global,
	});
	exports.gotoTab9 = new UICommand({
	    keyboardShortcut: 'mod+9',
	    description: "Tabs: Goto Tab 9",
	    context: CommandContext.Global,
	});
	/**
	 * OmniSearch
	 */
	exports.omniFindFile = new UICommand({
	    keyboardShortcut: 'mod+o',
	    description: "Find a file in the working directory",
	    context: CommandContext.Global,
	});
	exports.omniFindCommand = new UICommand({
	    keyboardShortcut: 'mod+shift+p',
	    description: "Find a command",
	    context: CommandContext.Global,
	});
	exports.omniSelectProject = new UICommand({
	    keyboardShortcut: 'alt+shift+p',
	    description: "Find and set active project",
	    context: CommandContext.Global,
	});
	exports.omniProjectSymbols = new UICommand({
	    keyboardShortcut: 'mod+shift+h',
	    description: "Find Symbols (Hieroglyphs) in active project",
	    context: CommandContext.Global,
	});
	exports.omniProjectSourcefile = new UICommand({
	    keyboardShortcut: 'mod+p',
	    description: "Find Source File in active project",
	    context: CommandContext.Global,
	});
	/**
	 * FAR find and replace
	 */
	exports.findAndReplace = new UICommand({
	    keyboardShortcut: 'mod+f',
	    description: "Show find and replace dialog",
	    context: CommandContext.Global,
	});
	exports.findAndReplaceMulti = new UICommand({
	    keyboardShortcut: 'mod+shift+f',
	    description: "Show find and replace in files",
	    context: CommandContext.Global,
	});
	exports.findNext = new UICommand({
	    keyboardShortcut: 'f3',
	    description: "Find the next search result",
	    context: CommandContext.Global,
	});
	exports.findPrevious = new UICommand({
	    keyboardShortcut: 'shift+f3',
	    description: "Find the previous search result",
	    context: CommandContext.Global,
	});
	exports.replaceNext = new events.TypedEvent();
	exports.replacePrevious = new events.TypedEvent();
	exports.replaceAll = new events.TypedEvent();
	/**
	 * Error panel
	 */
	exports.toggleMessagePanel = new UICommand({
	    keyboardShortcut: 'mod+;',
	    description: "Toggle Message Panel",
	    context: CommandContext.Global,
	});
	exports.cycleMessagesPanel = new UICommand({
	    keyboardShortcut: 'mod+shift+;',
	    description: "Cycle Message Panel",
	    context: CommandContext.Global,
	});
	/**
	 * Documentation features
	 */
	exports.toggleDoctor = new UICommand({
	    keyboardShortcut: "mod+'",
	    description: "Editor: Toggle Doctor",
	    context: CommandContext.Global,
	});
	exports.toggleDocumentationBrowser = new UICommand({
	    keyboardShortcut: 'mod+shift+\'',
	    description: "Documentation Browser: Open",
	    context: CommandContext.Global,
	});
	exports.doOpenUmlDiagram = new UICommand({
	    description: "UML Class diagram",
	    context: CommandContext.Global,
	});
	exports.toggleSemanticView = new UICommand({
	    description: "Toggle Semantic View",
	    context: CommandContext.Global,
	});
	exports.launchTsFlow = new UICommand({
	    description: "Launch TypeScript flow based programming",
	    context: CommandContext.Global,
	});
	exports.doOpenTestResultsView = new UICommand({
	    description: "Test Results View",
	    context: CommandContext.Global,
	});
	/**
	 * Cursor history
	 */
	exports.previousCursorLocation = new UICommand({
	    keyboardShortcut: "mod+u",
	    description: "Cursor: Previous Cursor Location",
	    context: CommandContext.Global,
	});
	exports.nextCursorLocation = new UICommand({
	    keyboardShortcut: "mod+shift+u",
	    description: "Cursor: Next Cursor Location",
	    context: CommandContext.Global,
	});
	/**
	 * Clipboard Ring
	 */
	exports.copy = new UICommand({
	    keyboardShortcut: 'mod+c',
	    description: "Copy",
	    context: CommandContext.Global,
	    allowDefault: true
	});
	exports.cut = new UICommand({
	    keyboardShortcut: 'mod+x',
	    description: "Cut",
	    context: CommandContext.Global,
	    allowDefault: true
	});
	exports.pasteFromRing = new UICommand({
	    keyboardShortcut: 'mod+shift+v',
	    description: "PasteFromRing",
	    context: CommandContext.Global,
	    allowDefault: false
	});
	/**
	 * Tree view
	 */
	exports.treeViewToggle = new UICommand({
	    keyboardShortcut: 'mod+\\',
	    description: "Tree View: Toggle",
	    context: CommandContext.Global,
	});
	exports.treeViewRevealActiveFile = new UICommand({
	    keyboardShortcut: 'mod+shift+\\',
	    description: "Tree View: Reveal Active File",
	    context: CommandContext.Global,
	});
	exports.treeViewFocus = new UICommand({
	    keyboardShortcut: 'mod+0',
	    description: "Tree View: Focus",
	    context: CommandContext.Global,
	});
	exports.treeAddFile = new UICommand({
	    keyboardShortcut: 'a',
	    description: "Tree View: Add File",
	    context: CommandContext.TreeView,
	});
	exports.treeAddFolder = new UICommand({
	    keyboardShortcut: 'shift+a',
	    description: "Tree View: Add Folder",
	    context: CommandContext.TreeView,
	});
	exports.treeDuplicateFile = new UICommand({
	    keyboardShortcut: 'd',
	    description: "Tree View: Duplicate File|Folder",
	    context: CommandContext.TreeView,
	});
	exports.treeMoveFile = new UICommand({
	    keyboardShortcut: 'm',
	    description: "Tree View: Move File|Folder",
	    context: CommandContext.TreeView,
	});
	/** Rename is same as `move` but people want to search for it */
	exports.treeRenameFile = new UICommand({
	    keyboardShortcut: 'r',
	    description: "Tree View: Rename File|Folder",
	    context: CommandContext.TreeView,
	});
	exports.treeDeleteFile = new UICommand({
	    keyboardShortcut: 'del',
	    description: "Tree View: Delete File|Folder",
	    context: CommandContext.TreeView,
	});
	exports.treeOpenInExplorerFinder = new UICommand({
	    keyboardShortcut: 'o',
	    description: "Tree View: Open folder in explorer / finder",
	    context: CommandContext.TreeView,
	});
	exports.treeOpenInCmdTerminal = new UICommand({
	    keyboardShortcut: 'shift+o',
	    description: "Tree View: Open folder in cmd / terminal",
	    context: CommandContext.TreeView,
	});
	/**
	 * General purpose file opening
	 * These are handled in appTabsContainer at the moment
	 */
	exports.doOpenFile = new events.TypedEvent();
	exports.doOpenOrFocusFile = new events.TypedEvent();
	exports.openFileFromDisk = new UICommand({
	    keyboardShortcut: 'mod+shift+o',
	    description: 'Open a file present on server disk',
	    context: CommandContext.Global,
	});
	/** needed by cursor history */
	exports.doOpenOrFocusTab = new events.TypedEvent();
	/** needed by file tree */
	exports.closeFilesDirs = new events.TypedEvent();
	/** Needed by file tree, activates the tab but doesn't change focus away from tree view */
	exports.doOpenOrActivateFileTab = new events.TypedEvent();
	/** Needed to toggle output js file. We toggle and also do not steal focus */
	exports.doToggleFileTab = new events.TypedEvent();
	/** Needed to ensure that a demo view is open */
	exports.ensureLiveDemoTab = new events.TypedEvent();
	exports.closeDemoTab = new events.TypedEvent();
	exports.ensureLiveDemoReactTab = new events.TypedEvent();
	exports.closeDemoReactTab = new events.TypedEvent();
	/**
	 * Other tab types
	 */
	exports.doOpenDependencyView = new UICommand({
	    description: 'Open Dependency View',
	    context: CommandContext.Global,
	});
	exports.doOpenASTView = new UICommand({
	    description: 'Open AST View',
	    context: CommandContext.Global,
	});
	exports.doOpenASTFullView = new UICommand({
	    description: 'Open AST-Full View',
	    context: CommandContext.Global,
	});
	/**
	 * Common configuration file creations
	 */
	exports.createEditorconfig = new UICommand({
	    description: 'Create a .editorconfig',
	    context: CommandContext.Global,
	});
	/**
	 * Settings stuff
	 */
	exports.openSettingsFile = new UICommand({
	    description: 'Open settings file',
	    context: CommandContext.Global
	});
	/**
	 * Git
	 */
	exports.gitAddAllCommitAndPush = new UICommand({
	    description: 'Git: Add all, Commit and Push',
	    context: CommandContext.Global
	});
	exports.gitFetchLatestAndRebase = new UICommand({
	    description: 'Git: Fetch + Pull latest, and rebase any local commits',
	    context: CommandContext.Global
	});
	/** Whenever status might be invalid */
	exports.gitStatusNeedsRefresh = new events.TypedEvent();
	/**
	 * Registration
	 */
	function register() {
	    exports.commandRegistry.forEach(function (c) {
	        if (c.config.context == CommandContext.Global
	            && c.config.keyboardShortcut) {
	            Mousetrap.bindGlobal(c.config.keyboardShortcut, function () {
	                c.emit({});
	                return !!c.config.allowDefault;
	            });
	        }
	    });
	}
	exports.register = register;
	/**
	 *
	 * CODE MIRROR
	 *
	 */
	/**
	* Straight out of codemirror.js
	*/
	exports.ios = /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
	exports.mac = exports.ios || /Mac/.test(navigator.platform);
	exports.windows = /win/i.test(navigator.platform);
	/** Nice display name for the mod by user platform */
	exports.modName = exports.mac ? '⌘' : 'Ctrl';
	var mod = exports.mac ? 'Cmd' : 'Ctrl';
	/** Load editor actions + keymaps */
	var monacoActionLoader_1 = __webpack_require__(395);
	var actions = monacoActionLoader_1.getActions();
	// console.log(actions); // DEBUG
	if (exports.mac) {
	    // TODO: mon
	    // Prevent the browser from handling the CMD + SHIFT + [ (or ]) which monaco uses for fold / unfold
	}
	function addEditorMapToCommands(command) {
	    new UICommand({
	        keyboardShortcut: command.kbd,
	        description: "Editor: " + command.label,
	        context: CommandContext.Editor,
	        editorCommandName: command.id,
	    });
	}
	actions.forEach(addEditorMapToCommands);
	/**
	 * This is a consolidation of the `file edited` and `file changed on disk`
	 */
	exports.fileContentsChanged = new events.TypedEvent();
	/**
	 * Setup toasts to hide on esc
	 * Note: this is done here instead of `ui` as some commands depend on `ui` and having depend on commands causes a circular dependency
	 */
	var toastr = __webpack_require__(149);
	exports.esc.on(function () {
	    toastr.clear();
	});
	/* DEBUG
	console.table(
	    commandRegistry
	        .filter(c=>c.config.context == CommandContext.Editor)
	        .map(c=>({cmd:c.config.description, shortcut:c.config.keyboardShortcut}))
	);
	/* DEBUG */
	/**
	 * Mac (the chrome browser in mac) doesn't have *cmd + y* (common redo).
	 * Instead it opens the browser history by mistake.
	 * So we redirect it to redo for any open editor :)
	 */
	Mousetrap.bindGlobal('mod+y', function (event) {
	    // If the focus is on editor than monaco already handles it
	    // If we made it till here .... then ....
	    // Prevent default
	    return false;
	});
	/**
	 * Mac: Cmd + H at the wrong place hides the window.
	 */
	Mousetrap.bindGlobal('mod+h', function (event) {
	    // If the focus is on editor than monaco already handles it
	    // If we made it till here .... then ....
	    // Prevent default
	    return false;
	});


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(21);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var csx = __webpack_require__(6);
	exports.textColor = '#BBB';
	exports.errorColor = '#f92672';
	exports.warningColor = '#f6d675'; // Color from CodeMirror `lint.css` warning squiggly color
	exports.successColor = '#00c990';
	exports.highlightColor = "#6edeef";
	exports.selectedBackgroundColor = '#444';
	exports.monokaiBackgroundColor = '#272822';
	exports.monokaiTextColor = "#e6db74"; // The color of strings
	/**
	 * FA Icon names used in the application
	 */
	exports.icons = {
	    tested: 'futbol-o',
	    testedSuite: 'pagelines',
	    testedTest: 'leaf',
	};
	/**
	 * A background color that looks nice over the "editor" background black
	 */
	exports.blackHighlightColor = "#1C1D18";
	/**
	 * If you expect a child to scroll you need to tell it that I will not give you a scroll bar
	 */
	exports.someChildWillScroll = {
	    overflow: 'hidden'
	};
	exports.tabHeaderContainer = {
	    background: 'grey'
	};
	exports.tabHeader = {
	    fontSize: '.8em',
	    fontFamily: 'Roboto, sans-serif',
	    fontWeight: 'bold',
	    paddingLeft: '10px',
	    paddingRight: '10px',
	    paddingTop: '5px',
	    paddingBottom: '5px',
	    background: "rgb(66, 66, 66)",
	    color: "rgb(150,150,150)",
	    borderLeft: '6px solid rgb(88, 88, 88)',
	    cursor: 'pointer',
	    userSelect: 'none',
	    transition: "color .5s, border-left .5s, background .5s"
	};
	exports.tabHeaderActive = {
	    color: exports.highlightColor,
	    borderLeft: "6px solid " + exports.highlightColor,
	};
	exports.tabHeaderUnsaved = {
	    background: "#777",
	};
	exports.fullWindow = {
	    position: 'absolute',
	    left: '10px',
	    right: '10px',
	    top: '10px',
	    bottom: '10px',
	};
	exports.padded1 = {
	    padding: '.25rem'
	};
	exports.padded1TopBottom = {
	    paddingTop: exports.padded1.padding,
	    paddingBottom: exports.padded1.padding
	};
	exports.padded1LeftRightBottom = {
	    paddingLeft: exports.padded1.padding,
	    paddingRight: exports.padded1.padding,
	    paddingBottom: exports.padded1.padding
	};
	exports.padded2 = {
	    padding: '.5rem'
	};
	exports.fullSize = {
	    width: '100%',
	    height: '100%',
	};
	var statusBarHeight = 25;
	exports.statusBar = {
	    height: statusBarHeight + "px",
	    color: '#999',
	    paddingLeft: '3px',
	    paddingRight: '3px',
	    fontSize: '12px',
	    border: '1px solid #999',
	};
	exports.statusBarSection = {
	    paddingLeft: '3px',
	    paddingRight: '3px',
	};
	exports.statusBarError = {
	    color: exports.errorColor
	};
	exports.statusBarSuccess = {
	    color: exports.successColor
	};
	exports.noSelect = {
	    userSelect: 'none',
	    cursor: 'default'
	};
	exports.hand = {
	    cursor: 'pointer',
	};
	exports.noWrap = {
	    whiteSpace: 'nowrap',
	};
	exports.codeFont = {
	    fontFamily: 'monospace'
	};
	var errorsPanel;
	(function (errorsPanel) {
	    errorsPanel.success = {
	        color: exports.successColor
	    };
	    errorsPanel.main = {
	        color: exports.textColor,
	        fontFamily: exports.codeFont.fontFamily,
	        padding: '6px',
	        overflow: 'hidden',
	        display: 'flex',
	        flexDirection: 'column'
	    };
	    errorsPanel.headerSection = {
	        flexShrink: 0,
	        marginBottom: '5px',
	    };
	    errorsPanel.tooMany = {
	        fontSize: '1.2rem',
	        fontWeight: 'bolder',
	    };
	    errorsPanel.filePath = {
	        fontSize: '1rem',
	        fontWeight: 'bold',
	        padding: '8px 8px 8px 0px',
	        cursor: exports.hand.cursor,
	    };
	    errorsPanel.perFileList = {};
	    var itemDetailsContainer = csx.extend(exports.hand, {
	        padding: '3px'
	    });
	    errorsPanel.errorDetailsContainer = csx.extend(itemDetailsContainer, {
	        borderLeft: '6px solid ' + exports.errorColor
	    });
	    errorsPanel.warningDetailsContainer = csx.extend(itemDetailsContainer, {
	        borderLeft: '6px solid ' + exports.warningColor
	    });
	    errorsPanel.errorDetailsContent = {
	        padding: '3px',
	    };
	    errorsPanel.errorMessage = {
	        paddingBottom: '3px',
	        cursor: 'pointer',
	        userSelect: 'none',
	    };
	    errorsPanel.errorPreview = {
	        padding: '3px',
	        background: 'black',
	        border: '2px solid #999',
	        cursor: 'pointer',
	    };
	})(errorsPanel = exports.errorsPanel || (exports.errorsPanel = {}));
	/**
	 * Used by all our modals
	 */
	var modal;
	(function (modal) {
	    /** Keyboard shortcuts */
	    modal.keyStrokeStyle = {
	        fontSize: '0.9rem',
	        background: '#111',
	        paddingTop: '1px',
	        paddingBottom: '1px',
	        paddingLeft: '4px',
	        paddingRight: '4px',
	        borderRadius: '5px',
	        border: '2px solid'
	    };
	    /** Big input */
	    modal.inputStyleBase = {
	        backgroundColor: 'rgb(42,42,42)',
	        color: 'white',
	        outline: 'none',
	        padding: '2px',
	        fontSize: '1.5rem',
	        lineHeight: '2rem',
	        fontFamily: 'monospace',
	        border: '3px solid #3C3C3C',
	        transition: 'border .2s',
	        '&:focus': {
	            boxShadow: '0px 0px 1px 1px #3C3C3C'
	        }
	    };
	    /** The container around code samples */
	    modal.previewContainerStyle = {
	        background: exports.tabHeader.background,
	        padding: '5px',
	    };
	})(modal = exports.modal || (exports.modal = {}));
	/** Sometimes we need a keyboard input to handle our keyboard events but not be visible in any way */
	exports.hiddenInput = {
	    height: '0px',
	    width: '0px',
	    color: 'transparent',
	    background: 'transparent',
	    position: 'absolute',
	    top: '0px'
	};
	var Input;
	(function (Input) {
	    Input.inputBlackStyleBase = {
	        backgroundColor: '#333',
	        color: 'white',
	        outline: 'none',
	        padding: '2px',
	        border: '2px solid #3C3C3C',
	        transition: 'border .2s',
	        '&:focus': {
	            border: '2px solid #0099E0',
	            boxShadow: '0px 0px 1px 1px #0099E0'
	        }
	    };
	})(Input = exports.Input || (exports.Input = {}));
	/**
	 * Some views have tips at the bottom. This for that
	 */
	var Tip;
	(function (Tip) {
	    Tip.root = csx.extend({
	        color: 'grey',
	        lineHeight: '1.5rem',
	        fontSize: '.8rem',
	    }, exports.padded1);
	    Tip.keyboardShortCutStyle = {
	        border: '2px solid',
	        borderRadius: '6px',
	        padding: '2px',
	        backgroundColor: 'black',
	    };
	})(Tip = exports.Tip || (exports.Tip = {}));
	/**
	 * For when you don't want anything on focus
	 */
	exports.noFocusOutlineBase = {
	    "&:focus": {
	        outline: 'none'
	    }
	};
	/**
	 * When you want text ellipsis
	 * Note: whitespace no wrap is significant
	 * Note: you probably want a limited width on the parent
	 */
	exports.ellipsis = {
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap'
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var types = __webpack_require__(23);
	var simpleRedux_1 = __webpack_require__(452);
	var utils = __webpack_require__(3);
	var initialStoreState = {
	    activeProject: null,
	    errorsExpanded: false,
	    errorsDisplayMode: types.ErrorsDisplayMode.all,
	    errorsFilter: '',
	    activeProjectFilePathTruthTable: {},
	    filePathsInActiveProject: [],
	    outputStatusCache: {},
	    liveBuildResults: {
	        builtCount: 0,
	        totalCount: 0
	    },
	    pendingRequests: [],
	    findOptions: {
	        isShown: false,
	        query: '',
	        isRegex: false,
	        isCaseSensitive: false,
	        isFullWord: false
	    },
	    socketConnected: false,
	    filePaths: [],
	    filePathsCompleted: false,
	    fileTreeShown: false,
	    showDoctor: false,
	    showSemanticView: false,
	    tsWorking: {
	        working: false,
	    },
	    testedWorking: {
	        working: false,
	    },
	};
	var redux = new simpleRedux_1.SimpleRedux(initialStoreState);
	exports.store = redux.store;
	exports.getState = redux.getState;
	exports.subscribe = redux.subscribe;
	exports.subscribeSub = redux.subscribeSub;
	exports.setActiveProject = redux.add('setActiveProject', function (state, payload) {
	    return {
	        activeProject: payload,
	    };
	});
	exports.inActiveProjectFilePath = function (filePath) { return !!exports.getState().activeProjectFilePathTruthTable[filePath]; };
	exports.inActiveProjectUrl = function (url) {
	    if (!url)
	        return false;
	    var protocol = (_a = utils.getFilePathAndProtocolFromUrl(url), _a.protocol), filePath = _a.filePath;
	    if (protocol == 'file' || protocol == 'ast' || protocol == 'astfull') {
	        return exports.inActiveProjectFilePath(filePath);
	    }
	    else {
	        return true;
	    }
	    var _a;
	};
	exports.setFilePathsInActiveProject = redux.add('setActiveProjectFiles', function (state, payload) {
	    // Filter out the `.json` files. These are good for `project data loader` but we don't need it in the UI
	    payload = payload.filter(function (p) { return !p.endsWith('.json'); });
	    var truthTable = utils.createMap(payload);
	    /** Also add all the *folders* in any of the files */
	    payload.forEach(function (fp) {
	        // Basically we go up the file path
	        // If at any point its already in the truth table it means that we've already added everything else that is needed.
	        var folder = utils.getDirectory(fp);
	        while (folder && !truthTable[folder]) {
	            truthTable[folder] = true;
	            folder = utils.getDirectory(folder);
	        }
	    });
	    return {
	        activeProjectFilePathTruthTable: truthTable,
	        filePathsInActiveProject: payload,
	    };
	});
	exports.expandErrors = redux.add('expandErrors', function (state, payload) {
	    return {
	        errorsExpanded: true,
	    };
	});
	exports.collapseErrors = redux.add('collapseErrors', function (state, payload) {
	    return {
	        errorsExpanded: false,
	    };
	});
	exports.setErrorsDisplayMode = redux.add('setErrorsDisplayMode', function (state, payload) {
	    return {
	        errorsDisplayMode: payload,
	    };
	});
	exports.setErrorsFilter = redux.add('setErrorsFilter', function (state, payload) {
	    return {
	        errorsFilter: payload,
	    };
	});
	exports.setPendingRequests = redux.add('setPendingRequests', function (state, payload) {
	    return {
	        pendingRequests: payload
	    };
	});
	exports.setFindOptionsQuery = redux.add('setFindOptionsQuery', function (state, payload) {
	    var findQuery = state.findOptions;
	    var newFindQuery = redux.updateFields({ query: payload })(findQuery);
	    return {
	        findOptions: newFindQuery
	    };
	});
	exports.setFindOptionsIsCaseSensitive = redux.add('setFindOptionsIsCaseSensitive', function (state, payload) {
	    var findQuery = state.findOptions;
	    var newFindQuery = redux.updateFields({ isCaseSensitive: payload })(findQuery);
	    return {
	        findOptions: newFindQuery
	    };
	});
	exports.setFindOptionsIsRegex = redux.add('setFindOptionsIsRegex', function (state, payload) {
	    var findQuery = state.findOptions;
	    var newFindQuery = redux.updateFields({ isRegex: payload })(findQuery);
	    return {
	        findOptions: newFindQuery
	    };
	});
	exports.setFindOptionsIsFullWord = redux.add('setFindOptionsIsFullWord', function (state, payload) {
	    var findQuery = state.findOptions;
	    var newFindQuery = redux.updateFields({ isFullWord: payload })(findQuery);
	    return {
	        findOptions: newFindQuery
	    };
	});
	exports.setFindOptionsIsShown = redux.add('setFindOptionsIsShown', function (state, payload) {
	    var findQuery = state.findOptions;
	    var newFindQuery = redux.updateFields({ isShown: payload })(findQuery);
	    return {
	        findOptions: newFindQuery
	    };
	});
	exports.setSocketConnected = redux.add('setSocketConnected', function (state, payload) {
	    return {
	        socketConnected: payload
	    };
	});
	exports.setFilePaths = redux.add('setFilePaths', function (state, config) {
	    return {
	        filePaths: config.filePaths,
	        rootDir: config.rootDir,
	        filePathsCompleted: config.completed
	    };
	});
	exports.expandFileTree = redux.add('expandFileTree', function (state, payload) {
	    return {
	        fileTreeShown: true,
	    };
	});
	exports.collapseFileTree = redux.add('collapseFileTree', function (state, payload) {
	    return {
	        fileTreeShown: false,
	    };
	});
	exports.toggleDoctor = redux.add('toggleDoctor', function (state, payload) {
	    return {
	        showDoctor: !state.showDoctor
	    };
	});
	exports.setShowDoctor = redux.add('setShowDoctor', function (state, payload) {
	    return {
	        showDoctor: payload
	    };
	});
	exports.toggleSemanticView = redux.add('toggleSemanticView', function (state, payload) {
	    return {
	        showSemanticView: !state.showSemanticView
	    };
	});
	exports.setShowSemanticView = redux.add('setShowSemanticView', function (state, payload) {
	    return {
	        showSemanticView: payload
	    };
	});
	exports.fileOuputStatusUpdated = redux.add('fileOuputStatusUpdated', function (state, payload) {
	    var outputStatusCache = redux.updateFields((_a = {}, _a[payload.inputFilePath] = payload, _a))(state.outputStatusCache);
	    return {
	        outputStatusCache: outputStatusCache
	    };
	    var _a;
	});
	exports.completeOuputStatusCacheUpdated = redux.add('completeOuputStatusCacheUpdated', function (state, payload) {
	    var outputStatusCache = payload;
	    return {
	        outputStatusCache: outputStatusCache
	    };
	});
	exports.setLiveBuildResults = redux.add('setLiveBuildResults', function (state, payload) {
	    return {
	        liveBuildResults: payload
	    };
	});
	exports.ifJSStatusWasCurrentThenMoveToOutOfDate = redux.add('ifJSStatusWasCurrentThenMoveToOutOfDate', function (state, payload) {
	    var oldState = state.outputStatusCache[payload.inputFilePath];
	    // If we didn't think it was up to date then don't care
	    if (!oldState || oldState.state !== types.JSOutputState.JSUpToDate) {
	        return {};
	    }
	    // It might be out of date now. So move it there till the backend tells us something different
	    var newState = {
	        inputFilePath: oldState.inputFilePath,
	        outputFilePath: oldState.outputFilePath,
	        state: types.JSOutputState.JSOutOfDate
	    };
	    var outputStatusCache = redux.updateFields((_a = {}, _a[payload.inputFilePath] = newState, _a))(state.outputStatusCache);
	    return {
	        outputStatusCache: outputStatusCache
	    };
	    var _a;
	});
	exports.setTSWorking = redux.add('setTSWorking', function (state, payload) {
	    return {
	        tsWorking: payload
	    };
	});
	exports.setTestedWorking = redux.add('setTestedWorking', function (state, payload) {
	    return {
	        testedWorking: payload
	    };
	});


/***/ },
/* 12 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var typestyle_1 = __webpack_require__(379);
	/**
	 * All the CSS types in the 'types' namespace
	 */
	var types = __webpack_require__(380);
	exports.types = types;
	/**
	 * Export certain utilities
	 */
	var utilities_1 = __webpack_require__(151);
	exports.extend = utilities_1.extend;
	exports.classes = utilities_1.classes;
	exports.media = utilities_1.media;
	/** Zero configuration, default instance of TypeStyle */
	var ts = new typestyle_1.TypeStyle({ autoGenerateTag: true });
	/** Sets the target tag where we write the css on style updates */
	exports.setStylesTarget = ts.setStylesTarget;
	/**
	 * Insert `raw` CSS as a string. This is useful for e.g.
	 * - third party CSS that you are customizing with template strings
	 * - generating raw CSS in JavaScript
	 * - reset libraries like normalize.css that you can use without loaders
	 */
	exports.cssRaw = ts.cssRaw;
	/**
	 * Takes CSSProperties and registers it to a global selector (body, html, etc.)
	 */
	exports.cssRule = ts.cssRule;
	/**
	 * Renders styles to the singleton tag imediately
	 * NOTE: You should only call it on initial render to prevent any non CSS flash.
	 * After that it is kept sync using `requestAnimationFrame` and we haven't noticed any bad flashes.
	 **/
	exports.forceRenderStyles = ts.forceRenderStyles;
	/**
	 * Utility function to register an @font-face
	 */
	exports.fontFace = ts.fontFace;
	/**
	 * Allows use to use the stylesheet in a node.js environment
	 */
	exports.getStyles = ts.getStyles;
	/**
	 * Takes keyframes and returns a generated animationName
	 */
	exports.keyframes = ts.keyframes;
	/**
	 * Helps with testing. Reinitializes FreeStyle + raw
	 */
	exports.reinit = ts.reinit;
	/**
	 * Takes CSSProperties and return a generated className you can use on your component
	 */
	exports.style = ts.style;
	/**
	 * Creates a new instance of TypeStyle separate from the default instance.
	 *
	 * - Use this for creating a different typestyle instance for a shadow dom component.
	 * - Use this if you don't want an auto tag generated and you just want to collect the CSS.
	 *
	 * NOTE: styles aren't shared between different instances.
	 */
	function createTypeStyle(target) {
	    var instance = new typestyle_1.TypeStyle({ autoGenerateTag: false });
	    if (target) {
	        instance.setStylesTarget(target);
	    }
	    return instance;
	}
	exports.createTypeStyle = createTypeStyle;


/***/ },
/* 14 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMProperty = __webpack_require__(39);
	var ReactDOMComponentFlags = __webpack_require__(110);
	
	var invariant = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(261);


/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var editorOperationCounter = 0;
	function replaceSelection(config) {
	    var selection = config.editor.getSelection();
	    var editOperation = {
	        identifier: {
	            major: 0,
	            minor: ++editorOperationCounter,
	        },
	        text: config.newText,
	        range: selection,
	        forceMoveMarkers: false,
	    };
	    config.editor.getModel().pushEditOperations([], [editOperation], null);
	}
	exports.replaceSelection = replaceSelection;
	function replaceRange(config) {
	    var editOperation = {
	        identifier: {
	            major: 0,
	            minor: ++editorOperationCounter,
	        },
	        text: config.newText,
	        range: new monaco.Range(config.range.startLineNumber, config.range.startColumn, config.range.endLineNumber, config.range.endColumn),
	        forceMoveMarkers: false,
	        isAutoWhitespaceEdit: false,
	    };
	    config.model.pushEditOperations([], [editOperation], null);
	}
	exports.replaceRange = replaceRange;
	function writeString(config) {
	    var editOperation = {
	        identifier: {
	            major: 0,
	            minor: ++editorOperationCounter,
	        },
	        text: config.str,
	        range: new monaco.Range(config.pos.lineNumber, config.pos.column, config.pos.lineNumber, config.pos.column),
	        /** Needed to change selection */
	        forceMoveMarkers: true,
	    };
	    config.model.pushEditOperations([], [editOperation], null);
	}
	exports.writeString = writeString;
	/** Runs format or format selection (if any) */
	function format(config) {
	    var action = config.editor.getAction('editor.action.format');
	    action.run();
	}
	exports.format = format;
	/**
	 * Useful for language query stuff that we want to debounce + cancel if no longer relevant even after the query is made
	 */
	function onlyLastCallWithDelay(call, token) {
	    var delay = 500;
	    var timeout;
	    var p = new Promise(function (resolve, reject) {
	        var later = function () {
	            if (token.isCancellationRequested)
	                reject('cancelled');
	            else {
	                call().then(function (res) {
	                    if (token.isCancellationRequested)
	                        reject('cancelled');
	                    else
	                        resolve(res);
	                });
	            }
	        };
	        timeout = setTimeout(later, delay);
	        token.onCancellationRequested(function () {
	            clearTimeout(timeout);
	            reject('cancelled');
	        });
	    });
	    return p;
	}
	exports.onlyLastCallWithDelay = onlyLastCallWithDelay;
	function setSelection(cfg) {
	    var model = cfg.editor.getModel();
	    var start = model.getPositionAt(cfg.textSpan.start);
	    var end = model.getPositionAt(cfg.textSpan.start + cfg.textSpan.length);
	    cfg.editor.setSelection({
	        startLineNumber: start.lineNumber,
	        startColumn: start.column,
	        endLineNumber: end.lineNumber,
	        endColumn: end.column
	    });
	}
	exports.setSelection = setSelection;
	function gotoPosition(cfg) {
	    var pos = {
	        lineNumber: cfg.position.line + 1,
	        column: cfg.position.ch + 1,
	    };
	    cfg.editor.setPosition(pos);
	    cfg.editor.revealPosition(pos);
	}
	exports.gotoPosition = gotoPosition;
	function getVisibleLines(editor) {
	    // HACK: The current lines visible api
	    var range = editor._view.layoutProvider.getLinesViewportData().visibleRange;
	    return range;
	}
	exports.getVisibleLines = getVisibleLines;
	/** Note: Only useful if in single cursor mode */
	function isCursorInTopHalf(cm) {
	    var cursor = cm.getPosition();
	    var scrollInfo = getVisibleLines(cm);
	    // Closer to top than bottom
	    return (cursor.lineNumber - scrollInfo.startLineNumber) < (scrollInfo.endLineNumber - cursor.lineNumber);
	}
	exports.isCursorInTopHalf = isCursorInTopHalf;
	function getSelectionOrCurrentLine(editor) {
	    var selection = editor.getSelection();
	    var hasSelection = !selection.isEmpty();
	    if (hasSelection) {
	        var selected = editor.getModel().getValueInRange(selection);
	        return selected;
	    }
	    else {
	        var selected = editor.getModel().getLineContent(selection.startLineNumber);
	        return selected;
	    }
	}
	exports.getSelectionOrCurrentLine = getSelectionOrCurrentLine;
	/**
	 * Position conversion functions
	 */
	function getCurrentPosition(editor) {
	    var position = editor.getPosition();
	    return editor.getModel().getOffsetAt(position);
	}
	exports.getCurrentPosition = getCurrentPosition;
	function positionToOffset(model, position) {
	    return model.getOffsetAt(position);
	}
	exports.positionToOffset = positionToOffset;
	function offsetToPosition(model, offset) {
	    return model.getPositionAt(offset);
	}
	exports.offsetToPosition = offsetToPosition;


/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CompositeDisposible = /** @class */ (function () {
	    function CompositeDisposible() {
	        var _this = this;
	        this.disposibles = [];
	        this.add = function (disposible) {
	            _this.disposibles.push(disposible);
	        };
	        this.dispose = function () {
	            _this.disposibles.forEach(function (d) { return d.dispose(); });
	        };
	    }
	    return CompositeDisposible;
	}());
	exports.CompositeDisposible = CompositeDisposible;
	/** passes through events as they happen. You will not get events from before you start listening */
	var TypedEvent = /** @class */ (function () {
	    function TypedEvent() {
	        var _this = this;
	        this.listeners = [];
	        this.listenersOncer = [];
	        this.on = function (listener) {
	            _this.listeners.push(listener);
	            return {
	                dispose: function () { return _this.off(listener); }
	            };
	        };
	        this.once = function (listener) {
	            _this.listenersOncer.push(listener);
	        };
	        this.off = function (listener) {
	            var callbackIndex = _this.listeners.indexOf(listener);
	            if (callbackIndex > -1)
	                _this.listeners.splice(callbackIndex, 1);
	        };
	        this.emit = function (event) {
	            /** Update any `current` listeners */
	            _this._last = event;
	            while (_this._currentQueue.length) {
	                var item = _this._currentQueue.pop();
	                item.resolve(event);
	            }
	            /** Update any general listeners */
	            _this.listeners.forEach(function (listener) { return listener(event); });
	            /** Clear the `once` queue */
	            _this.listenersOncer.forEach(function (listener) { return listener(event); });
	            _this.listenersOncer = [];
	        };
	        this.pipe = function (te) {
	            return _this.on(function (e) { return te.emit(e); });
	        };
	        /**
	         * A promise that is resolved on first event
	         * ... or immediately with the last value
	         */
	        this._currentQueue = [];
	        this._last = null;
	        this.current = function () {
	            if (_this._last != null) {
	                return Promise.resolve(_this._last);
	            }
	            else {
	                var promise_1 = new Promise(function (resolve, reject) {
	                    _this._currentQueue.push({ promise: promise_1, resolve: resolve, reject: reject });
	                });
	                return promise_1;
	            }
	        };
	        /**
	         * Allows you to join in with the last value
	         * So you don't need to do .current + .on
	         */
	        this.join = function (listener) {
	            if (_this._last != null) {
	                listener(_this._last);
	            }
	            return _this.on(listener);
	        };
	    }
	    return TypedEvent;
	}());
	exports.TypedEvent = TypedEvent;
	/** single event listener queue */
	var SingleListenerQueue = /** @class */ (function () {
	    function SingleListenerQueue() {
	        var _this = this;
	        this.listener = null;
	        this.pending = [];
	        this.pendingCount = function () { return _this.pending.length; };
	    }
	    SingleListenerQueue.prototype.on = function (listener) {
	        var _this = this;
	        this.listener = listener;
	        // clear pending
	        this.pending.forEach(function (evt) { return _this.listener(evt); });
	        this.pending = [];
	    };
	    SingleListenerQueue.prototype.off = function () {
	        this.listener = null;
	    };
	    SingleListenerQueue.prototype.emit = function (event) {
	        if (!this.listener) {
	            this.pending.push(event);
	        }
	        else {
	            this.listener(event);
	        }
	    };
	    return SingleListenerQueue;
	}());
	exports.SingleListenerQueue = SingleListenerQueue;


/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 21 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 23 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Its Types (e.g. enums) + constants :)
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.cacheDir = './.alm';
	exports.title = "Application Lifecycle Management tools for TypeScript";
	var TriState;
	(function (TriState) {
	    TriState[TriState["Unknown"] = 0] = "Unknown";
	    TriState[TriState["True"] = 1] = "True";
	    TriState[TriState["False"] = 2] = "False";
	})(TriState = exports.TriState || (exports.TriState = {}));
	exports.errors = {
	    CALLED_WHEN_NO_ACTIVE_PROJECT_FOR_FILE_PATH: "A query *that needs an active project* was made when there is no active project for given filePath",
	    CALLED_WHEN_NO_ACTIVE_PROJECT_GLOBAL: "A query *that needs an active project* was made when there is no active project"
	};
	/**
	 * Some session constants
	 */
	/** When a new server stats up */
	exports.urlHashNormal = "root";
	/** When user requests a new window */
	exports.urlHashNewSession = "new-session";
	/** When alm is started ni debug mode */
	exports.urlHashDebugSession = "debug";
	/**
	 * FARM : Don't want to crash by running out of memory / ui preference
	 */
	exports.maxCountFindAndReplaceMultiResults = 1000;
	/**
	 * Reason is we want to transact by file path
	 * Also, this function sorts per file so you can apply refactorings in order 🌹
	 */
	function getRefactoringsByFilePath(refactorings) {
	    var loc = {};
	    for (var _i = 0, refactorings_1 = refactorings; _i < refactorings_1.length; _i++) {
	        var refac = refactorings_1[_i];
	        if (!loc[refac.filePath])
	            loc[refac.filePath] = [];
	        loc[refac.filePath].push(refac);
	    }
	    // sort each of these in descending by start location
	    for (var filePath in loc) {
	        var refactorings_2 = loc[filePath];
	        refactorings_2.sort(function (a, b) {
	            return (b.span.start - a.span.start);
	        });
	    }
	    return loc;
	}
	exports.getRefactoringsByFilePath = getRefactoringsByFilePath;
	/**
	 * For file listing we like to know if its a dir or file
	 */
	var FilePathType;
	(function (FilePathType) {
	    FilePathType[FilePathType["File"] = 0] = "File";
	    FilePathType[FilePathType["Dir"] = 1] = "Dir";
	})(FilePathType = exports.FilePathType || (exports.FilePathType = {}));
	/** The JS file can only be in one of these states */
	var JSOutputState;
	(function (JSOutputState) {
	    /** If emit skipped (Either emit is blocked or compiler options are noEmit) or perhaps there isn't a JS file emit for this (e.g .d.ts files) */
	    JSOutputState[JSOutputState["NoJSFile"] = 1] = "NoJSFile";
	    /** If JS file then its one of these */
	    JSOutputState[JSOutputState["JSUpToDate"] = 2] = "JSUpToDate";
	    JSOutputState[JSOutputState["JSOutOfDate"] = 3] = "JSOutOfDate";
	})(JSOutputState = exports.JSOutputState || (exports.JSOutputState = {}));
	/**
	 * Complete related stuff
	 */
	/** Some constants */
	exports.completionKindSnippet = "snippet";
	exports.completionKindPath = "path";
	/**
	 * Errors
	 */
	var ErrorsDisplayMode;
	(function (ErrorsDisplayMode) {
	    ErrorsDisplayMode[ErrorsDisplayMode["all"] = 1] = "all";
	    ErrorsDisplayMode[ErrorsDisplayMode["openFiles"] = 2] = "openFiles";
	})(ErrorsDisplayMode = exports.ErrorsDisplayMode || (exports.ErrorsDisplayMode = {}));
	/**
	 * The TypeDoc icons a pretty expansive 🌹 with a few ideas that I disagree with / or think are too difficult.
	 * E.g the type `event`. The "grey" coloring of the global functions. The following is a simpler subset.
	 *
	 * Places that need to be kept in sync:
	 * - typeIcon.tsx: the location in typeIcons.svg
	 * - the legend component
	 * - the server responses
	 */
	var IconType;
	(function (IconType) {
	    /**
	     * There can be only one global
	     * Any of the remaining things can be either in a module or global
	     */
	    IconType[IconType["Global"] = 0] = "Global";
	    IconType[IconType["Namespace"] = 1] = "Namespace";
	    IconType[IconType["Variable"] = 2] = "Variable";
	    IconType[IconType["Function"] = 3] = "Function";
	    IconType[IconType["FunctionGeneric"] = 4] = "FunctionGeneric";
	    IconType[IconType["Enum"] = 5] = "Enum";
	    IconType[IconType["EnumMember"] = 6] = "EnumMember";
	    IconType[IconType["Interface"] = 7] = "Interface";
	    IconType[IconType["InterfaceGeneric"] = 8] = "InterfaceGeneric";
	    IconType[IconType["InterfaceConstructor"] = 9] = "InterfaceConstructor";
	    IconType[IconType["InterfaceProperty"] = 10] = "InterfaceProperty";
	    IconType[IconType["InterfaceMethod"] = 11] = "InterfaceMethod";
	    IconType[IconType["InterfaceMethodGeneric"] = 12] = "InterfaceMethodGeneric";
	    IconType[IconType["InterfaceIndexSignature"] = 13] = "InterfaceIndexSignature";
	    IconType[IconType["Class"] = 14] = "Class";
	    IconType[IconType["ClassGeneric"] = 15] = "ClassGeneric";
	    IconType[IconType["ClassConstructor"] = 16] = "ClassConstructor";
	    IconType[IconType["ClassProperty"] = 17] = "ClassProperty";
	    IconType[IconType["ClassMethod"] = 18] = "ClassMethod";
	    IconType[IconType["ClassMethodGeneric"] = 19] = "ClassMethodGeneric";
	    IconType[IconType["ClassIndexSignature"] = 20] = "ClassIndexSignature";
	})(IconType = exports.IconType || (exports.IconType = {}));
	var UMLClassMemberVisibility;
	(function (UMLClassMemberVisibility) {
	    UMLClassMemberVisibility[UMLClassMemberVisibility["Public"] = 1] = "Public";
	    UMLClassMemberVisibility[UMLClassMemberVisibility["Private"] = 2] = "Private";
	    UMLClassMemberVisibility[UMLClassMemberVisibility["Protected"] = 3] = "Protected";
	})(UMLClassMemberVisibility = exports.UMLClassMemberVisibility || (exports.UMLClassMemberVisibility = {}));
	var UMLClassMemberLifetime;
	(function (UMLClassMemberLifetime) {
	    UMLClassMemberLifetime[UMLClassMemberLifetime["Instance"] = 1] = "Instance";
	    UMLClassMemberLifetime[UMLClassMemberLifetime["Static"] = 2] = "Static";
	})(UMLClassMemberLifetime = exports.UMLClassMemberLifetime || (exports.UMLClassMemberLifetime = {}));
	/**
	 * Tested
	 */
	var TestStatus;
	(function (TestStatus) {
	    TestStatus[TestStatus["NotRunYet"] = 1] = "NotRunYet";
	    TestStatus[TestStatus["Fail"] = 2] = "Fail";
	    TestStatus[TestStatus["Success"] = 3] = "Success";
	    TestStatus[TestStatus["Skipped"] = 4] = "Skipped";
	})(TestStatus = exports.TestStatus || (exports.TestStatus = {}));
	/** Lots of things don't have a good error. But we would like to be consistent even with simple errors */
	function makeBlandError(filePath, error, source) {
	    return {
	        source: source,
	        filePath: filePath,
	        from: {
	            line: 0,
	            ch: 0
	        },
	        to: {
	            line: 0,
	            ch: 0
	        },
	        message: error,
	        preview: null,
	        level: 'error'
	    };
	}
	exports.makeBlandError = makeBlandError;
	//////////////////////
	// Live react demo
	//////////////////////
	exports.liveDemoMountUrl = '/demo';


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(12);
	
	var CallbackQueue = __webpack_require__(107);
	var PooledClass = __webpack_require__(32);
	var ReactFeatureFlags = __webpack_require__(116);
	var ReactReconciler = __webpack_require__(33);
	var Transaction = __webpack_require__(56);
	
	var invariant = __webpack_require__(4);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(166)
	var ieee754 = __webpack_require__(220)
	var isArray = __webpack_require__(222)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer, (function() { return this; }())))

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * This maintains the User interface Tabs for app,
	 * e.g. selected tab, any handling of open tab requests etc.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var tabRegistry = __webpack_require__(163);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var csx = __webpack_require__(6);
	var utils_1 = __webpack_require__(3);
	var types = __webpack_require__(23);
	var tips_1 = __webpack_require__(455);
	var socketClient_1 = __webpack_require__(5);
	var clientSession_1 = __webpack_require__(87);
	var onresize = __webpack_require__(105);
	var events_1 = __webpack_require__(19);
	var state = __webpack_require__(11);
	var pure = __webpack_require__(61);
	var globalErrorCacheClient_1 = __webpack_require__(35);
	/**
	 *
	 * Golden layout
	 *
	 */
	var GoldenLayout = __webpack_require__(218);
	__webpack_require__(355);
	__webpack_require__(356);
	/** Golden layout wants react / react-dom to be global */
	window.React = React;
	window.ReactDOM = ReactDOM;
	/** Some additional styles */
	__webpack_require__(375);
	var AppTabsContainer = /** @class */ (function (_super) {
	    __extends(AppTabsContainer, _super);
	    function AppTabsContainer(props) {
	        var _this = _super.call(this, props) || this;
	        /** Used to undo close tab */
	        _this.closedTabs = [];
	        _this.ctrls = {};
	        /**
	         * Does exactly what it says.
	         */
	        _this.addTabToLayout = function (tab, sendToServer) {
	            if (sendToServer === void 0) { sendToServer = true; }
	            _this.tabs.push(tab);
	            if (sendToServer) {
	                _this.sendTabInfoToServer();
	                _this.tabState.refreshTipHelp();
	            }
	            var url = tab.url, id = tab.id;
	            var _a = utils.getFilePathAndProtocolFromUrl(tab.url), protocol = _a.protocol, filePath = _a.filePath;
	            var props = {
	                url: url,
	                additionalData: tab.additionalData,
	                onSavedChanged: function (saved) { return _this.onSavedChanged(tab, saved); },
	                onFocused: function () {
	                    if (_this.selectedTabInstance && _this.selectedTabInstance.id === id)
	                        return;
	                    _this.tabState.selectTab(id);
	                },
	                api: _this.createTabApi(id),
	                setCodeEditor: function (codeEditor) { return _this.codeEditorMap[id] = codeEditor; }
	            };
	            var title = tabRegistry.getTabConfigByUrl(url).getTitle(url);
	            // Find the active stack if any
	            var currentItemAndParent = _this.getCurrentTabRootStackIfAny();
	            // By default we try to add to (in desending order)
	            //  The current stack
	            //  the root stack
	            //  the root
	            var contentRoot = (currentItemAndParent && currentItemAndParent.parent)
	                || _this.layout.root.contentItems[0]
	                || _this.layout.root;
	            contentRoot.addChild({
	                type: 'react-component',
	                component: protocol,
	                title: title,
	                props: props,
	                id: id
	            });
	        };
	        _this.moveTabUtils = {
	            /**
	             * Utility to create a container that doesn't reinitialize its children
	             */
	            createContainer: function (type) {
	                var item = _this.layout.createContentItem({
	                    type: type,
	                    content: []
	                });
	                item.isInitialised = true; // Prevents initilizing its children
	                return item;
	            },
	            /**
	             * Utility that doesn't *uninitalize* the child it is removing
	             */
	            detachFromParent: function (item) {
	                item.parent.removeChild(item, true);
	            },
	        };
	        _this.moveCurrentTabRightIfAny = function () {
	            var currentItemAndParent = _this.getCurrentTabRootStackIfAny();
	            if (!currentItemAndParent)
	                return;
	            var item = currentItemAndParent.item, parent = currentItemAndParent.parent;
	            var root = parent.parent;
	            /** Can't move the last item */
	            if (parent.contentItems.length === 1) {
	                return;
	            }
	            // If parent.parent is a `row` its prettier to just add to that row ;)
	            if (root.type === 'row') {
	                // Create a new container for just this tab
	                _this.moveTabUtils.detachFromParent(item);
	                var newItemRootElement = _this.moveTabUtils.createContainer('stack');
	                newItemRootElement.addChild(item);
	                // Add this new container to the root
	                root.addChild(newItemRootElement);
	            }
	            else {
	                var indexOfParentInRoot = parent.parent.contentItems.findIndex(function (c) { return c == parent; });
	                // Create a new container for just this tab
	                _this.moveTabUtils.detachFromParent(item);
	                var newItemRootElement = _this.moveTabUtils.createContainer('stack');
	                newItemRootElement.addChild(item);
	                // Create a new layout to be the root of the two stacks
	                var newRootLayout_1 = _this.moveTabUtils.createContainer('row');
	                newRootLayout_1.addChild(newItemRootElement);
	                // Also add the old parent to this new row
	                var doTheDetachAndAdd = function () {
	                    // Doing this detach immediately breaks the layout
	                    // This is because for column / row when a child is removed the splitter is gone
	                    // And by chance this is the splitter that the new item was going to :-/
	                    _this.moveTabUtils.detachFromParent(parent);
	                    newRootLayout_1.addChild(parent, 0);
	                };
	                if (root.type === 'column') {
	                    setTimeout(doTheDetachAndAdd, 10);
	                }
	                else {
	                    // type `root` *must* only have a single item at a time :)
	                    // So we *must* do it sync for that case
	                    doTheDetachAndAdd();
	                }
	                // Add this new container to the root
	                root.addChild(newRootLayout_1, indexOfParentInRoot);
	            }
	        };
	        _this.moveCurrentTabDownIfAny = function () {
	            // Very similar to moveCurrentTabRightIfAny
	            // Just replaced `row` with `column` and `column` with `row`.
	            // This code can be consolidated but leaving as seperate as I suspect they might diverge
	            var currentItemAndParent = _this.getCurrentTabRootStackIfAny();
	            if (!currentItemAndParent)
	                return;
	            var item = currentItemAndParent.item, parent = currentItemAndParent.parent;
	            var root = parent.parent;
	            /** Can't move the last item */
	            if (parent.contentItems.length === 1) {
	                return;
	            }
	            // If parent.parent is a `column` its prettier to just add to that column ;)
	            if (root.type === 'column') {
	                // Create a new container for just this tab
	                _this.moveTabUtils.detachFromParent(item);
	                var newItemRootElement = _this.moveTabUtils.createContainer('stack');
	                newItemRootElement.addChild(item);
	                // Add this new container to the root
	                root.addChild(newItemRootElement);
	            }
	            else {
	                var indexOfParentInRoot = parent.parent.contentItems.findIndex(function (c) { return c == parent; });
	                // Create a new container for just this tab
	                _this.moveTabUtils.detachFromParent(item);
	                var newItemRootElement = _this.moveTabUtils.createContainer('stack');
	                newItemRootElement.addChild(item);
	                // Create a new layout to be the root of the two stacks
	                var newRootLayout_2 = _this.moveTabUtils.createContainer('column');
	                newRootLayout_2.addChild(newItemRootElement);
	                // Also add the old parent to this new row
	                var doTheDetachAndAdd = function () {
	                    // Doing this detach immediately breaks the layout
	                    // This is because for column / row when a child is removed the splitter is gone
	                    // And by chance this is the splitter that the new item was going to :-/
	                    _this.moveTabUtils.detachFromParent(parent);
	                    newRootLayout_2.addChild(parent, 0);
	                };
	                if (root.type === 'row') {
	                    setTimeout(doTheDetachAndAdd, 10);
	                }
	                else {
	                    // type `root` *must* only have a single item at a time :)
	                    // So we *must* do it sync for that case
	                    doTheDetachAndAdd();
	                }
	                // Add this new container to the root
	                root.addChild(newRootLayout_2, indexOfParentInRoot);
	            }
	        };
	        _this.sendTabInfoToServer = function () {
	            var serialized = GLUtil.serializeConfig(_this.layout.toConfig(), _this);
	            socketClient_1.server.setOpenUITabs({
	                sessionId: clientSession_1.getSessionId(),
	                tabLayout: serialized,
	                selectedTabId: _this.selectedTabInstance && _this.selectedTabInstance.id
	            });
	        };
	        /**
	         * Tab State
	         */
	        /** Our way to send stuff (events) down to the tab */
	        _this.tabApi = Object.create(null);
	        /** This is different from the Tab Api in that its stuff *we* render for the tab */
	        _this.tabHandle = Object.create(null);
	        /**
	         * Having access to the current code editor is vital for some parts of the application
	         * For this reason we allow the CodeTab to tell us about its codeEditor instance
	         */
	        _this.codeEditorMap = Object.create(null);
	        _this.tabs = [];
	        /** Tab Sate */
	        _this.tabState = {
	            /**
	             * Resize handling
	             */
	            _resizingDontReFocus: false,
	            debouncedResize: utils.debounce(function () {
	                _this.tabState._resizingDontReFocus = true;
	                _this.tabState.resize();
	            }, 200),
	            resize: function () {
	                _this.layout.updateSize();
	                _this.tabState.resizeTheTabs();
	            },
	            resizeTheTabs: function () {
	                _this.tabs.forEach(function (t) { return _this.tabApi[t.id].resize.emit({}); });
	            },
	            setTabs: function (tabs) {
	                _this.tabs = tabs;
	                _this.sendTabInfoToServer();
	                _this.tabState.refreshTipHelp();
	            },
	            selectTab: function (id) {
	                var lastSelectedTab = _this.selectedTabInstance;
	                if (lastSelectedTab && id !== lastSelectedTab.id) {
	                    _this.tabApi[lastSelectedTab.id] && _this.tabApi[lastSelectedTab.id].willBlur.emit({});
	                }
	                _this.selectedTabInstance = _this.tabs.find(function (t) { return t.id == id; });
	                _this.tabState.focusSelectedTabIfAny();
	                if (!lastSelectedTab || (lastSelectedTab && lastSelectedTab.id !== id)) {
	                    _this.sendTabInfoToServer();
	                }
	            },
	            focusSelectedTabIfAny: function () {
	                _this.selectedTabInstance && _this.tabApi[_this.selectedTabInstance.id].focus.emit({});
	            },
	            triggerFocusAndSetAsSelected: function (id) {
	                _this.tabHandle[id].triggerFocus();
	                _this.tabState.selectTab(id);
	            },
	            refreshTipHelp: function () {
	                // If no tabs show tips
	                // If some tabs hide tips
	                _this.tabs.length ? TipRender.hideTips() : TipRender.showTips();
	            },
	            tabClosedInLayout: function (id) {
	                var closedTabInstance = _this.tabs.find(function (t) { return t.id == id; });
	                _this.closedTabs.push(closedTabInstance);
	                var index = _this.tabs.map(function (t) { return t.id; }).indexOf(id);
	                delete _this.tabHandle[id];
	                delete _this.tabApi[id];
	                delete _this.codeEditorMap[id];
	                _this.tabState.setTabs(_this.tabs.filter(function (t) { return t.id !== id; }));
	                // Figure out the tab which will become active
	                if (_this.selectedTabInstance && _this.selectedTabInstance.id === id) {
	                    _this.selectedTabInstance = GLUtil.prevOnClose({ id: id, config: _this.layout.toConfig() });
	                }
	                // The close tab logic inside golden layout, can disconnect the active tab logic of ours
	                // (we try to preserve current tab if some other tab closes)
	                // So no matter what we need to refocus on the selected tab from within Golden-Layout
	                if (_this.selectedTabInstance) {
	                    _this.tabHandle[_this.selectedTabInstance.id].triggerFocus();
	                }
	            },
	            gotoPosition: function (id, position) {
	                setTimeout(function () { return _this.tabApi[id].gotoPosition.emit(position); });
	            },
	            /**
	             * Tab closing
	             */
	            closeCurrentTab: function () {
	                if (!_this.selectedTabInstance)
	                    return;
	                _this.tabState.closeTabById(_this.selectedTabInstance.id);
	            },
	            closeTabById: function (id) {
	                _this.tabHandle[id].triggerClose();
	            },
	            /**
	             * Fast tab jumping
	             */
	            _showingTabIndexes: false,
	            _jumpToTabNumber: function (oneBasedIndex) {
	                var index = oneBasedIndex - 1;
	                if (!_this.tabs[index]) {
	                    return;
	                }
	                var tab = _this.tabs[index];
	                _this.tabState.triggerFocusAndSetAsSelected(tab.id);
	                _this.tabState.hideTabIndexes();
	            },
	            _fastTabJumpListener: function (evt) {
	                var keyCodeFor1 = 49;
	                var tabNumber = evt.keyCode - keyCodeFor1 + 1;
	                if (tabNumber >= 1 && tabNumber <= 9) {
	                    _this.tabState._jumpToTabNumber(tabNumber);
	                }
	                if (evt.keyCode == 39) {
	                    _this.moveCurrentTabRightIfAny();
	                }
	                if (evt.keyCode == 40) {
	                    _this.moveCurrentTabDownIfAny();
	                }
	                if (evt.keyCode == 68) {
	                    commands.duplicateTab.emit({});
	                }
	                // prevent key prop
	                evt.preventDefault();
	                evt.stopPropagation();
	                evt.stopImmediatePropagation();
	                _this.tabState.hideTabIndexes();
	                // console.log(evt, tabNumber); // DEBUG
	            },
	            _removeOnMouseDown: function (evt) {
	                _this.tabState.hideTabIndexes();
	            },
	            showTabIndexes: function () {
	                if (_this.tabState._showingTabIndexes) {
	                    _this.tabState.hideTabIndexes();
	                }
	                // this.debugLayoutTree(); // DEBUG
	                _this.tabState._showingTabIndexes = true;
	                window.addEventListener('keydown', _this.tabState._fastTabJumpListener);
	                window.addEventListener('mousedown', _this.tabState._removeOnMouseDown);
	                _this.tabs.map(function (t, i) {
	                    if (!_this.tabHandle[t.id]) {
	                        return;
	                    }
	                    _this.tabHandle[t.id].showIndex(i + 1);
	                });
	                if (_this.selectedTabInstance) {
	                    TabMoveHelp.showHelp();
	                }
	            },
	            hideTabIndexes: function () {
	                _this.tabState._showingTabIndexes = false;
	                window.removeEventListener('keydown', _this.tabState._fastTabJumpListener);
	                window.removeEventListener('mousedown', _this.tabState._removeOnMouseDown);
	                _this.tabs.map(function (t, i) {
	                    if (!_this.tabHandle[t.id]) {
	                        return;
	                    }
	                    _this.tabHandle[t.id].hideIndex();
	                });
	                TabMoveHelp.hideHelp();
	            },
	            /**
	             * Not to be used locally.
	             * This is an external API used to drive app tabs contianer for refactorings etc.
	             */
	            getFocusedCodeEditorIfAny: function () {
	                if (!_this.selectedTabInstance
	                    || !_this.selectedTabInstance.id
	                    || !_this.selectedTabInstance.url.startsWith('file:')
	                    || !_this.codeEditorMap[_this.selectedTabInstance.id]) {
	                    return null;
	                }
	                return _this.codeEditorMap[_this.selectedTabInstance.id];
	            },
	            getSelectedTab: function () {
	                return _this.selectedTabInstance;
	            },
	            getSelectedFilePath: function () {
	                var selected = _this.selectedTabInstance;
	                if (selected) {
	                    var url = selected.url;
	                    if (url.startsWith('file://')) {
	                        return utils.getFilePathFromUrl(url);
	                    }
	                }
	            },
	            getOpenFilePaths: function () {
	                return _this.tabs.filter(function (t) { return t.url.startsWith('file://'); }).map(function (t) { return utils.getFilePathFromUrl(t.url); });
	            },
	            addTabs: function (tabs) {
	                tabs.forEach(function (tab) { return _this.addTabToLayout(tab); });
	            },
	            /**
	             * TODO: this function is a bit heavy so can use some caching
	             */
	            errorsByFilePathFiltered: function () {
	                var allState = state.getState();
	                var filter = allState.errorsFilter.trim();
	                var mode = allState.errorsDisplayMode;
	                var allErrors = globalErrorCacheClient_1.errorsCache.getErrors();
	                /** Flatten errors as we need those for "gotoHistory" */
	                var errorsFlattened = utils.selectMany(Object.keys(allErrors).map(function (x) { return allErrors[x]; }));
	                /** Filter by string if any */
	                if (filter) {
	                    errorsFlattened = errorsFlattened.filter(function (e) { return e.filePath.includes(filter) || e.message.includes(filter) || e.preview.includes(filter); });
	                }
	                /** Filter by path if any */
	                if (mode === types.ErrorsDisplayMode.openFiles) {
	                    var openFilePaths_1 = utils.createMap(_this.tabState.getOpenFilePaths());
	                    errorsFlattened = errorsFlattened.filter(function (e) { return openFilePaths_1[e.filePath]; });
	                }
	                return {
	                    errorsFlattened: errorsFlattened,
	                    errorsByFilePath: utils.createMapByKey(errorsFlattened, function (e) { return e.filePath; })
	                };
	            }
	        };
	        /** Setup the singleton */
	        exports.tabState = _this.tabState;
	        return _this;
	    }
	    AppTabsContainer.prototype.componentDidMount = function () {
	        var _this = this;
	        socketClient_1.server.getOpenUITabs({ sessionId: clientSession_1.getSessionId() }).then(function (res) {
	            var config = GLUtil.unserializeConfig(res.tabLayout, _this);
	            /** This is needed as we use this ordered information in quite a few places */
	            _this.tabs = GLUtil.orderedTabs(config);
	            /**
	             * Setup golden layout
	             * https://golden-layout.com/docs/Config.html
	             */
	            _this.layout = new GoldenLayout(config, _this.ctrls.root);
	            /**
	             * Register all the tab components with layout
	             */
	            tabRegistry.getTabConfigs().forEach(function (_a) {
	                var protocol = _a.protocol, config = _a.config;
	                _this.layout.registerComponent(protocol, config.component);
	            });
	            /** Setup window resize */
	            _this.disposible.add(onresize.on(function () { return _this.tabState.resize(); }));
	            /**
	             * Tab selection
	             * I tried to use the config to figure out the selected tab.
	             * That didn't work out so well
	             * So the plan is to intercept the tab clicks to focus
	             * and on state changes just focus on the last selected tab if any
	             */
	            _this.layout.on('tabCreated', function (tabInfo) {
	                _this.createTabHandle(tabInfo);
	            });
	            _this.layout.on('itemDestroyed', function (evt) {
	                if (evt.config && evt.config.id) {
	                    _this.tabState.tabClosedInLayout(evt.config.id);
	                }
	            });
	            var oldConfig = config;
	            var initialStateChange = true;
	            _this.layout.on('stateChanged', function (evt) {
	                if (initialStateChange) {
	                    // Select the last tab
	                    _this.tabs.length
	                        && res.selectedTabId
	                        && _this.tabs.find(function (t) { return t.id === res.selectedTabId; })
	                        && exports.tabState.triggerFocusAndSetAsSelected(res.selectedTabId);
	                    initialStateChange = false;
	                }
	                var newConfig = _this.layout.toConfig();
	                var contentEqual = function (a, b) {
	                    if (a.type !== b.type)
	                        return false;
	                    if (a.activeItemIndex !== b.activeItemIndex)
	                        return false;
	                    if (!pure.shallowEqual(a.dimension, b.dimension))
	                        return false;
	                    if (a.height !== b.height)
	                        return false;
	                    if (a.width !== b.width)
	                        return false;
	                    if (a.content) {
	                        if (!b.content)
	                            return false;
	                        if (a.content.length !== b.content.length)
	                            return false;
	                        return a.content.every(function (c, i) { return contentEqual(c, b.content[i]); });
	                    }
	                    return true;
	                };
	                var equal = contentEqual(oldConfig, newConfig);
	                oldConfig = newConfig;
	                if (equal) {
	                    return;
	                }
	                // Due to state changes layout needs to happen on *all tabs* (because it might expose some other tabs)
	                // PREF : you can go thorough all the `stack` in the layout and only call resize on the active ones.
	                _this.tabState.resizeTheTabs();
	                // Ignore the events where the user is dragging stuff
	                // This is because at this time the `config` doesn't contain the *dragged* item.
	                var orderedtabs = GLUtil.orderedTabs(newConfig);
	                if (orderedtabs.length !== _this.tabs.length) {
	                    return;
	                }
	                // Store the tabs in the right order
	                _this.tabState.setTabs(orderedtabs);
	                // If there was a selected tab focus on it again.
	                if (_this.tabState._resizingDontReFocus) {
	                    _this.tabState._resizingDontReFocus = false;
	                }
	                else {
	                    _this.selectedTabInstance && _this.tabState.selectTab(_this.selectedTabInstance.id);
	                }
	            });
	            // initialize the layout
	            _this.layout.init();
	            // If there are no tabs then show the tip help
	            if (!_this.tabs.length)
	                _this.tabState.refreshTipHelp();
	            /**
	             * General command handling
	             */
	            _this.setupCommandHandling();
	        });
	    };
	    /**
	     * Lots of commands are raised in the app that we need to care about
	     * e.g. tab saving / tab switching / file opening etc.
	     * We do that all in here
	     */
	    AppTabsContainer.prototype.setupCommandHandling = function () {
	        var _this = this;
	        // commands.bas.on((e) => {
	        //     const filePath = getCurrentFilePathOrWarn();
	        //     if (!filePath) return;
	        //     server.gitDiff({ filePath }).then(res => {
	        //         console.log(res);
	        //     });
	        // });
	        commands.saveTab.on(function (e) {
	            _this.getSelectedTabApiIfAny().save.emit({});
	        });
	        commands.esc.on(function () {
	            // Focus selected tab
	            _this.tabState.focusSelectedTabIfAny();
	            // Exit jump tab mode
	            _this.tabState.hideTabIndexes();
	            // Hide search
	            if (_this.tabApi[_this.selectedTabInstance && _this.selectedTabInstance.id]) {
	                _this.tabApi[_this.selectedTabInstance && _this.selectedTabInstance.id].search.hideSearch.emit({});
	            }
	        });
	        commands.jumpToTab.on(function () {
	            // jump to tab
	            _this.tabState.showTabIndexes();
	        });
	        /**
	         * File opening commands
	         */
	        commands.toggleOutputJS.on(function () {
	            var filePath = getCurrentFilePathOrWarn();
	            if (!filePath)
	                return;
	            var outputStatus = state.getState().outputStatusCache[filePath];
	            if (!outputStatus) {
	                ui.notifyWarningNormalDisappear('Your current tab needs to be a TypeScript file in project and project should have compileOnSave enabled');
	                return;
	            }
	            commands.doToggleFileTab.emit({
	                filePath: outputStatus.outputFilePath
	            });
	        });
	        commands.doToggleFileTab.on(function (_a) {
	            var filePath = _a.filePath;
	            // If tab is open we just close it
	            var existing = _this.tabs.find(function (t) {
	                return utils.getFilePathFromUrl(t.url) == filePath;
	            });
	            if (existing) {
	                _this.tabState.closeTabById(existing.id);
	                return;
	            }
	            // Othewise we open the tab, and select back to the current tab
	            var currentTabId = _this.selectedTabInstance && _this.selectedTabInstance.id;
	            commands.doOpenOrActivateFileTab.emit({ filePath: filePath });
	            _this.moveCurrentTabRightIfAny();
	            if (currentTabId) {
	                _this.tabState.triggerFocusAndSetAsSelected(currentTabId);
	            }
	        });
	        commands.doOpenFile.on(function (e) {
	            var codeTab = {
	                id: utils_1.createId(),
	                url: "file://" + e.filePath,
	                additionalData: null,
	            };
	            // Add tab
	            _this.addTabToLayout(codeTab);
	            // Focus
	            _this.tabState.selectTab(codeTab.id);
	            if (e.position) {
	                _this.tabApi[codeTab.id].gotoPosition.emit(e.position);
	            }
	        });
	        commands.doOpenOrFocusFile.on(function (e) {
	            // if open and not focused then focus and goto pos
	            var existingTab = 
	            // Open and current
	            (_this.selectedTabInstance
	                && utils.getFilePathFromUrl(_this.selectedTabInstance.url) === e.filePath
	                && utils.getFilePathAndProtocolFromUrl(_this.selectedTabInstance.url).protocol === tabRegistry.tabs.file.protocol
	                && _this.selectedTabInstance)
	                // Open but not current
	                || _this.tabs.find(function (t) {
	                    return utils.getFilePathFromUrl(t.url) == e.filePath
	                        && utils.getFilePathAndProtocolFromUrl(t.url).protocol === tabRegistry.tabs.file.protocol;
	                });
	            if (existingTab) {
	                // Focus if not focused
	                if (!_this.selectedTabInstance || _this.selectedTabInstance.id !== existingTab.id) {
	                    _this.tabState.triggerFocusAndSetAsSelected(existingTab.id);
	                }
	                if (e.position) {
	                    _this.tabState.gotoPosition(existingTab.id, e.position);
	                }
	            }
	            else {
	                commands.doOpenFile.emit(e);
	            }
	        });
	        commands.doOpenOrActivateFileTab.on(function (e) {
	            // Basically we have to maintain the current focus
	            var activeElement = document.activeElement;
	            commands.doOpenOrFocusFile.emit(e);
	            if (activeElement) {
	                setTimeout(function () { return $(activeElement).focus(); }, 100);
	            }
	        });
	        commands.doOpenOrFocusTab.on(function (e) {
	            // if open and not focused then focus and goto pos
	            var existingTab = _this.tabs.find(function (t) {
	                return t.id == e.tabId;
	            });
	            if (existingTab) {
	                // Focus if not focused
	                if (!_this.selectedTabInstance || _this.selectedTabInstance.id !== existingTab.id) {
	                    _this.tabState.triggerFocusAndSetAsSelected(existingTab.id);
	                }
	                if (e.position) {
	                    _this.tabState.gotoPosition(existingTab.id, e.position);
	                }
	            }
	            else {
	                var codeTab = {
	                    id: e.tabId,
	                    url: e.tabUrl,
	                    additionalData: null
	                };
	                // Add tab
	                _this.addTabToLayout(codeTab);
	                // Focus
	                _this.tabState.selectTab(codeTab.id);
	                if (e.position) {
	                    _this.tabState.gotoPosition(codeTab.id, e.position);
	                }
	            }
	        });
	        commands.closeFilesDirs.on(function (e) {
	            var toClose = function (filePath) {
	                return e.files.indexOf(filePath) !== -1 || e.dirs.some(function (dirPath) { return filePath.startsWith(dirPath); });
	            };
	            var tabsToClose = _this.tabs.filter(function (t, i) {
	                var _a = utils.getFilePathAndProtocolFromUrl(t.url), protocol = _a.protocol, filePath = _a.filePath;
	                return protocol === 'file' && toClose(filePath);
	            });
	            tabsToClose.forEach(function (t) { return _this.tabHandle[t.id].triggerClose(); });
	        });
	        commands.undoCloseTab.on(function () {
	            if (_this.closedTabs.length) {
	                var tab_1 = _this.closedTabs.pop();
	                // Add tab
	                _this.addTabToLayout(tab_1);
	                // Focus
	                _this.tabState.selectTab(tab_1.id);
	            }
	        });
	        commands.duplicateTab.on(function (e) {
	            var currentFilePath = getCurrentFilePathOrWarn();
	            if (!currentFilePath)
	                return;
	            if (!_this.selectedTabInstance)
	                return;
	            var codeTab = {
	                id: utils_1.createId(),
	                url: _this.selectedTabInstance.url,
	                additionalData: _this.selectedTabInstance.additionalData
	            };
	            // Add tab
	            _this.addTabToLayout(codeTab);
	            // Focus
	            _this.tabState.selectTab(codeTab.id);
	        });
	        /**
	         * Goto tab by index
	         */
	        var gotoNumber = this.tabState._jumpToTabNumber;
	        commands.gotoTab1.on(function () { return gotoNumber(1); });
	        commands.gotoTab2.on(function () { return gotoNumber(2); });
	        commands.gotoTab3.on(function () { return gotoNumber(3); });
	        commands.gotoTab4.on(function () { return gotoNumber(4); });
	        commands.gotoTab5.on(function () { return gotoNumber(5); });
	        commands.gotoTab6.on(function () { return gotoNumber(6); });
	        commands.gotoTab7.on(function () { return gotoNumber(7); });
	        commands.gotoTab8.on(function () { return gotoNumber(8); });
	        commands.gotoTab9.on(function () { return gotoNumber(9); });
	        /**
	         * Next and previous tabs
	         */
	        commands.nextTab.on(function () {
	            var currentTabId = _this.selectedTabInstance && _this.selectedTabInstance.id;
	            var currentIndex = _this.tabs.findIndex(function (t) { return t.id === currentTabId; });
	            var nextIndex = utils.rangeLimited({
	                min: 0,
	                max: _this.tabs.length - 1,
	                num: currentIndex + 1,
	                loopAround: true
	            });
	            setTimeout(function () {
	                _this.tabState.triggerFocusAndSetAsSelected(_this.tabs[nextIndex].id);
	            });
	        });
	        commands.prevTab.on(function () {
	            var currentTabId = _this.selectedTabInstance && _this.selectedTabInstance.id;
	            var currentIndex = _this.tabs.findIndex(function (t) { return t.id === currentTabId; });
	            var nextIndex = utils.rangeLimited({
	                min: 0,
	                max: _this.tabs.length - 1,
	                num: currentIndex - 1,
	                loopAround: true
	            });
	            setTimeout(function () {
	                _this.tabState.triggerFocusAndSetAsSelected(_this.tabs[nextIndex].id);
	            });
	        });
	        /**
	         * Close tab commands
	         */
	        commands.closeTab.on(function (e) {
	            // Remove the selected
	            _this.tabState.closeCurrentTab();
	        });
	        commands.closeOtherTabs.on(function (e) {
	            var currentTabId = _this.selectedTabInstance && _this.selectedTabInstance.id;
	            var otherTabs = _this.tabs.filter(function (t) { return t.id !== currentTabId; });
	            otherTabs.forEach(function (t) { return _this.tabHandle[t.id].triggerClose(); });
	        });
	        commands.closeAllTabs.on(function (e) {
	            commands.closeOtherTabs.emit({});
	            commands.closeTab.emit({});
	        });
	        /**
	         * Find and Replace
	         */
	        state.subscribeSub(function (state) { return state.findOptions; }, function (findQuery) {
	            var api = _this.getSelectedTabApiIfAny();
	            var options = state.getState().findOptions;
	            if (options.isShown) {
	                api.search.doSearch.emit(options);
	            }
	            else {
	                api.search.hideSearch.emit(options);
	            }
	        });
	        commands.findNext.on(function () {
	            var component = _this.getSelectedTabApiIfAny();
	            var findOptions = state.getState().findOptions;
	            component.search.findNext.emit(findOptions);
	        });
	        commands.findPrevious.on(function () {
	            var component = _this.getSelectedTabApiIfAny();
	            var findOptions = state.getState().findOptions;
	            component.search.findPrevious.emit(findOptions);
	        });
	        commands.replaceNext.on(function (e) {
	            var component = _this.getSelectedTabApiIfAny();
	            component.search.replaceNext.emit(e);
	        });
	        commands.replacePrevious.on(function (e) {
	            var component = _this.getSelectedTabApiIfAny();
	            component.search.replacePrevious.emit(e);
	        });
	        commands.replaceAll.on(function (e) {
	            var component = _this.getSelectedTabApiIfAny();
	            component.search.replaceAll.emit(e);
	        });
	        /**
	         * Other Types Of tabs
	         */
	        commands.doOpenDependencyView.on(function (e) {
	            var codeTab = {
	                id: utils_1.createId(),
	                url: "dependency://Dependency View",
	                additionalData: null,
	            };
	            // Add tab
	            _this.addTabToLayout(codeTab);
	            // Focus
	            _this.tabState.selectTab(codeTab.id);
	        });
	        /** Only allows a single tab of a type */
	        var openOrFocusSingletonTab = function (_a) {
	            var protocol = _a.protocol, url = _a.url;
	            // if open and active => focus
	            // if open and not active => active
	            // if not open and active
	            if (_this.selectedTabInstance
	                && utils.getFilePathAndProtocolFromUrl(_this.selectedTabInstance && _this.selectedTabInstance.url).protocol === protocol) {
	                _this.tabState.focusSelectedTabIfAny();
	                return;
	            }
	            var openTabIndex = _this.tabs.findIndex(function (t) { return utils.getFilePathAndProtocolFromUrl(t.url).protocol === protocol; });
	            if (openTabIndex != -1) {
	                _this.tabState.triggerFocusAndSetAsSelected(_this.tabs[openTabIndex].id);
	                return;
	            }
	            var newTab = {
	                id: utils_1.createId(),
	                url: url,
	                additionalData: null,
	            };
	            // Add tab
	            _this.addTabToLayout(newTab);
	            // Focus
	            _this.tabState.selectTab(newTab.id);
	        };
	        /** Documentation view */
	        commands.toggleDocumentationBrowser.on(function () {
	            var protocol = tabRegistry.tabs.documentation.protocol;
	            var url = protocol + "://Documentation";
	            openOrFocusSingletonTab({ protocol: protocol, url: url });
	        });
	        /** Tested view */
	        commands.doOpenTestResultsView.on(function () {
	            var protocol = tabRegistry.tabs.tested.protocol;
	            var url = protocol + "://Tested";
	            openOrFocusSingletonTab({ protocol: protocol, url: url });
	        });
	        /** Find and replace multi */
	        commands.findAndReplaceMulti.on(function (e) {
	            var protocol = tabRegistry.tabs.farm.protocol;
	            var url = protocol + "://Find And Replace";
	            openOrFocusSingletonTab({ protocol: protocol, url: url });
	        });
	        /** Live demo view */
	        commands.ensureLiveDemoTab.on(function (e) {
	            var protocol = tabRegistry.tabs.livedemo.protocol;
	            var url = protocol + "://" + e.filePath;
	            var currentTabId = _this.selectedTabInstance && _this.selectedTabInstance.id;
	            openOrFocusSingletonTab({ protocol: protocol, url: url });
	            _this.moveCurrentTabRightIfAny();
	            if (currentTabId) {
	                _this.tabState.triggerFocusAndSetAsSelected(currentTabId);
	            }
	        });
	        commands.closeDemoTab.on(function (e) {
	            // If tab is open we just close it
	            var protocol = tabRegistry.tabs.livedemo.protocol;
	            var existing = _this.tabs.find(function (t) {
	                return utils.getFilePathAndProtocolFromUrl(t.url).protocol == protocol;
	            });
	            if (existing) {
	                _this.tabState.closeTabById(existing.id);
	                return;
	            }
	        });
	        commands.ensureLiveDemoReactTab.on(function (e) {
	            var protocol = tabRegistry.tabs.livedemoreact.protocol;
	            var url = protocol + "://" + e.filePath;
	            var currentTabId = _this.selectedTabInstance && _this.selectedTabInstance.id;
	            openOrFocusSingletonTab({ protocol: protocol, url: url });
	            _this.moveCurrentTabRightIfAny();
	            if (currentTabId) {
	                _this.tabState.triggerFocusAndSetAsSelected(currentTabId);
	            }
	        });
	        commands.closeDemoReactTab.on(function (e) {
	            // If tab is open we just close it
	            var protocol = tabRegistry.tabs.livedemoreact.protocol;
	            var existing = _this.tabs.find(function (t) {
	                return utils.getFilePathAndProtocolFromUrl(t.url).protocol == protocol;
	            });
	            if (existing) {
	                _this.tabState.closeTabById(existing.id);
	                return;
	            }
	        });
	        /** AST view */
	        var getCurrentFilePathOrWarn = function () {
	            var tab = _this.tabState.getSelectedTab();
	            var notify = function () { return ui.notifyWarningNormalDisappear('Need a valid file path for this action. Make sure you have a *file* tab as active'); };
	            if (!tab) {
	                notify();
	                return;
	            }
	            var _a = utils.getFilePathAndProtocolFromUrl(tab.url), protocol = _a.protocol, filePath = _a.filePath;
	            if (protocol !== 'file') {
	                notify();
	                return;
	            }
	            return filePath;
	        };
	        var openAnalysisViewForCurrentFilePath = function (getUrl) {
	            var filePath = getCurrentFilePathOrWarn();
	            if (!filePath)
	                return;
	            var codeTab = {
	                id: utils_1.createId(),
	                url: getUrl(filePath),
	                additionalData: null
	            };
	            // Add tab
	            _this.addTabToLayout(codeTab);
	            // Focus
	            _this.tabState.selectTab(codeTab.id);
	        };
	        commands.doOpenASTView.on(function (e) {
	            openAnalysisViewForCurrentFilePath(function (filePath) {
	                return tabRegistry.tabs.ast.protocol + "://" + filePath;
	            });
	        });
	        commands.doOpenASTFullView.on(function (e) {
	            openAnalysisViewForCurrentFilePath(function (filePath) {
	                return tabRegistry.tabs.astfull.protocol + "://" + filePath;
	            });
	        });
	        commands.doOpenUmlDiagram.on(function (e) {
	            openAnalysisViewForCurrentFilePath(function (filePath) {
	                return tabRegistry.tabs.uml.protocol + "://" + filePath;
	            });
	        });
	        commands.launchTsFlow.on(function (e) {
	            var filePath = getCurrentFilePathOrWarn();
	            if (!filePath)
	                return;
	            var tsFlowTab = {
	                id: utils_1.createId(),
	                url: tabRegistry.tabs.tsflow.protocol + "://" + filePath,
	                additionalData: {
	                    position: 0 /**  TODO: tsflow load from actual file path current cursor */
	                }
	            };
	            // Add tab
	            _this.addTabToLayout(tsFlowTab);
	            // Focus
	            _this.tabState.selectTab(tsFlowTab.id);
	        });
	    };
	    AppTabsContainer.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", { ref: function (root) { return _this.ctrls.root = root; }, style: csx.extend(csx.vertical, csx.flex, { maxWidth: '100%', overflow: 'hidden' }), className: "app-tabs" }));
	    };
	    AppTabsContainer.prototype.onSavedChanged = function (tab, saved) {
	        if (this.tabHandle[tab.id]) {
	            this.tabHandle[tab.id].setSaved(saved);
	        }
	    };
	    AppTabsContainer.prototype.getCurrentTabRootStackIfAny = function () {
	        if (this.selectedTabInstance) {
	            var id = this.selectedTabInstance.id;
	            var item = this.layout.root.contentItems[0].getItemsById(id)[0];
	            if (item && item.parent && item.parent.type == 'stack') {
	                return { item: item, parent: item.parent };
	            }
	        }
	    };
	    AppTabsContainer.prototype.createTabApi = function (id) {
	        var api = newTabApi();
	        this.tabApi[id] = api;
	        return api;
	    };
	    AppTabsContainer.prototype.debugLayoutTree = function () {
	        var config = this.layout.toConfig();
	        var root = config.content;
	        var generateSpaces = function (indent) { return Array((indent * 2) + 1).map(function (i) { return " "; }).join(' '); };
	        var printItem = function (item, depth) {
	            if (depth === void 0) { depth = 0; }
	            if (!depth) {
	                console.log('ROOT-----');
	            }
	            else {
	                var indent = generateSpaces(depth);
	                console.log(indent + item.type);
	            }
	            if (item.content) {
	                item.content.forEach(function (c) { return printItem(c, depth + 1); });
	            }
	        };
	        // console.log(config);
	        printItem(config);
	    };
	    /**
	     * If we have a selected tab we return its api.
	     * Otherwise we create one on the fly so you don't need to worry about
	     * constantly checking if selected tab. (pain from v1).
	     */
	    AppTabsContainer.prototype.getSelectedTabApiIfAny = function () {
	        if (this.selectedTabInstance && this.tabApi[this.selectedTabInstance.id]) {
	            return this.tabApi[this.selectedTabInstance.id];
	        }
	        else {
	            return newTabApi();
	        }
	    };
	    AppTabsContainer.prototype.getTabApi = function (id) {
	        return this.tabApi[id];
	    };
	    AppTabsContainer.prototype.createTabHandle = function (tabInfo) {
	        var _this = this;
	        // console.log(tabInfo);
	        var item = tabInfo.contentItem;
	        var tab = tabInfo.element;
	        var tabConfig = tabInfo.contentItem.config;
	        var id = tabConfig.id;
	        // mouse down because we want tab state to change even if user initiates a drag
	        tab.on('mousedown', function (evt) {
	            // if the user is center clicking, close the tab
	            var centerClick = evt.button === 1;
	            if (centerClick) {
	                tab.find('.lm_close_tab').trigger('click');
	                return;
	            }
	            // But not if the user is clicking the close button
	            var closeButtonClicked = evt.target && evt.target.className == "lm_close_tab";
	            if (closeButtonClicked) {
	                return;
	            }
	            _this.tabState.selectTab(id);
	        });
	        var tabIndexDisplay = null;
	        var removeTabIndexDisplayIfAny = function () {
	            if (tabIndexDisplay) {
	                tabIndexDisplay.remove();
	                tabIndexDisplay = null;
	            }
	        };
	        this.tabHandle[id] = {
	            saved: true,
	            setSaved: function (saved) {
	                _this.tabHandle[id].saved = saved;
	                tab.toggleClass('unsaved', !saved);
	            },
	            triggerFocus: function () {
	                /**
	                 * setTimeout needed because we call `triggerFocus` when
	                 * golden-layout is still in the process of changing tabs sometimes
	                 */
	                setTimeout(function () {
	                    tabInfo.header.parent.setActiveContentItem(item);
	                });
	            },
	            showIndex: function (index) {
	                if (index > 9) {
	                    // Wow this user has too many tabs. Abort
	                    return;
	                }
	                tabIndexDisplay = $('<div class="alm_jumpIndex">' + index + '</div>');
	                tab.append(tabIndexDisplay);
	            },
	            hideIndex: removeTabIndexDisplayIfAny,
	            triggerClose: function () {
	                tab.find('.lm_close_tab').trigger('click');
	            },
	            /** Selected class */
	            addSelectedClass: function () {
	                tab.addClass('alm_selected');
	            },
	            removeSelectedClass: function () {
	                tab.removeClass('alm_selected');
	            },
	        };
	    };
	    Object.defineProperty(AppTabsContainer.prototype, "selectedTabInstance", {
	        get: function () {
	            return this._selectedTabInstance;
	        },
	        set: function (value) {
	            // The active tab class management
	            if (this._selectedTabInstance && this.tabHandle[this._selectedTabInstance.id]) {
	                this.tabHandle[this._selectedTabInstance.id].removeSelectedClass();
	            }
	            if (value && value.id && this.tabHandle[value.id]) {
	                this.tabHandle[value.id].addSelectedClass();
	            }
	            // We don't tell non current tabs about search states.
	            // So we need to tell them if they *come into focus*
	            if (value && value.id && this.tabApi[value.id]) {
	                var api = this.tabApi[value.id];
	                var options = state.getState().findOptions;
	                if (!options.isShown || !options.query) {
	                    api.search.hideSearch.emit({});
	                }
	                else {
	                    api.search.doSearch.emit(options);
	                }
	            }
	            this._selectedTabInstance = value;
	            exports.tabStateChanged.emit({});
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return AppTabsContainer;
	}(ui.BaseComponent));
	exports.AppTabsContainer = AppTabsContainer;
	var NoSelectedTab = -1;
	var newTabApi = function () {
	    // Note : i am using any as `new TypedEvent<FindOptions>()` breaks syntax highlighting
	    // but don't worry api is still type checked for members
	    var api = {
	        resize: new events_1.TypedEvent(),
	        focus: new events_1.TypedEvent(),
	        save: new events_1.TypedEvent(),
	        close: new events_1.TypedEvent(),
	        gotoPosition: new events_1.TypedEvent(),
	        willBlur: new events_1.TypedEvent(),
	        search: {
	            doSearch: new events_1.TypedEvent(),
	            hideSearch: new events_1.TypedEvent(),
	            findNext: new events_1.TypedEvent(),
	            findPrevious: new events_1.TypedEvent(),
	            replaceNext: new events_1.TypedEvent(),
	            replacePrevious: new events_1.TypedEvent(),
	            replaceAll: new events_1.TypedEvent()
	        }
	    };
	    return api;
	};
	/**
	 * Golden layout helpers
	 */
	var GLUtil;
	(function (GLUtil) {
	    /**
	     * A visitor for stack
	     * Navigates down to any root level stack or the stack as a child of an row / columns
	     */
	    GLUtil.visitAllStacks = function (content, cb) {
	        content.forEach(function (c) {
	            if (c.type === 'row' || c.type === 'column') {
	                GLUtil.visitAllStacks(c.content, cb);
	            }
	            if (c.type === 'stack') {
	                cb(c);
	            }
	        });
	    };
	    /**
	     * Gets the tab instaces for a given stack
	     */
	    function toTabStack(stack) {
	        var tabs = (stack.content || []).map(function (c) {
	            var props = c.props;
	            var id = c.id;
	            return { id: id, url: props.url, additionalData: props.additionalData };
	        });
	        return {
	            selectedIndex: stack.activeItemIndex,
	            tabs: tabs
	        };
	    }
	    GLUtil.toTabStack = toTabStack;
	    /**
	     * Get the gl layout instances for a given tab
	     */
	    function fromTabStack(tabs, appTabsContainer) {
	        return tabs.map(function (tab) {
	            var url = tab.url, id = tab.id, additionalData = tab.additionalData;
	            var _a = utils.getFilePathAndProtocolFromUrl(tab.url), protocol = _a.protocol, filePath = _a.filePath;
	            var props = {
	                url: url,
	                additionalData: additionalData,
	                onSavedChanged: function (saved) { return appTabsContainer.onSavedChanged(tab, saved); },
	                onFocused: function () {
	                    if (appTabsContainer.selectedTabInstance && appTabsContainer.selectedTabInstance.id === id)
	                        return;
	                    appTabsContainer.tabState.selectTab(id);
	                },
	                api: appTabsContainer.createTabApi(id),
	                setCodeEditor: function (codeEditor) { return appTabsContainer.codeEditorMap[id] = codeEditor; }
	            };
	            var title = tabRegistry.getTabConfigByUrl(url).getTitle(url);
	            return {
	                type: 'react-component',
	                component: protocol,
	                title: title,
	                props: props,
	                id: id
	            };
	        });
	    }
	    GLUtil.fromTabStack = fromTabStack;
	    /**
	     * Get the tabs in order
	     */
	    function orderedTabs(config) {
	        var result = [];
	        var addFromStack = function (stack) { return result = result.concat(toTabStack(stack).tabs); };
	        // Add from all stacks
	        GLUtil.visitAllStacks(config.content, addFromStack);
	        return result;
	    }
	    GLUtil.orderedTabs = orderedTabs;
	    /**
	     * Serialize the tab layout
	     */
	    function serializeConfig(config, appTabsContainer) {
	        /** Assume its a stack to begin with */
	        var result = {
	            type: 'stack',
	            width: 100,
	            height: 100,
	            tabs: [],
	            subItems: [],
	            activeItemIndex: 0,
	        };
	        /** The root is actually just `root` with a single content item if any */
	        var goldenLayoutRoot = config.content[0];
	        // and its empty so we good
	        if (!goldenLayoutRoot) {
	            return result;
	        }
	        /**
	         * Recursion helpers
	         */
	        function addStackItemsToLayout(layout, glStack) {
	            var stack = {
	                type: 'stack',
	                width: glStack.width || 100,
	                height: glStack.height || 100,
	                tabs: toTabStack(glStack).tabs,
	                subItems: [],
	                activeItemIndex: glStack.activeItemIndex,
	            };
	            layout.subItems.push(stack);
	        }
	        function addRowItemsToLayout(layout, glRow) {
	            var row = {
	                type: 'row',
	                width: glRow.width || 100,
	                height: glRow.height || 100,
	                tabs: [],
	                subItems: [],
	                activeItemIndex: 0,
	            };
	            layout.subItems.push(row);
	            (glRow.content || []).forEach(function (c) { return callRightFunctionForGlChild(row, c); });
	        }
	        function addColumnItemsToLayout(layout, glColumn) {
	            var column = {
	                type: 'column',
	                width: glColumn.width || 100,
	                height: glColumn.height || 100,
	                tabs: [],
	                subItems: [],
	                activeItemIndex: 0,
	            };
	            layout.subItems.push(column);
	            (glColumn.content || []).forEach(function (c) { return callRightFunctionForGlChild(column, c); });
	        }
	        function callRightFunctionForGlChild(layout, c) {
	            if (c.type === 'column') {
	                addColumnItemsToLayout(layout, c);
	            }
	            if (c.type === 'row') {
	                addRowItemsToLayout(layout, c);
	            }
	            if (c.type === 'stack') {
	                addStackItemsToLayout(layout, c);
	            }
	        }
	        // So the root `type` is whatever it really is
	        result.type = goldenLayoutRoot.type;
	        /** If the root is a stack .. we done */
	        if (goldenLayoutRoot.type === 'stack') {
	            result.tabs = toTabStack(goldenLayoutRoot).tabs;
	        }
	        else {
	            /** Start the recursion at the root */
	            (goldenLayoutRoot.content || []).forEach(function (c) { return callRightFunctionForGlChild(result, c); });
	        }
	        // console.log(result);
	        // unserializeConfig(result, appTabsContainer); // DEBUG : how it will unserilize later
	        return result;
	    }
	    GLUtil.serializeConfig = serializeConfig;
	    function unserializeConfig(layout, appTabsContainer) {
	        /**
	         * Recursion helpers
	         */
	        function stackLayout(layout) {
	            var stack = {
	                type: 'stack',
	                width: layout.width || 100,
	                height: layout.height || 100,
	                content: fromTabStack(layout.tabs, appTabsContainer),
	                activeItemIndex: layout.activeItemIndex,
	            };
	            return stack;
	        }
	        function rowLayout(layout) {
	            var row = {
	                type: 'row',
	                width: layout.width || 100,
	                height: layout.height || 100,
	                content: layout.subItems.map(function (c) { return callRightFunctionForLayoutChild(c); }),
	            };
	            return row;
	        }
	        function columnLayout(layout) {
	            var column = {
	                type: 'column',
	                width: layout.width || 100,
	                height: layout.height || 100,
	                content: layout.subItems.map(function (c) { return callRightFunctionForLayoutChild(c); }),
	            };
	            return column;
	        }
	        function callRightFunctionForLayoutChild(layout) {
	            if (layout.type === 'column') {
	                return columnLayout(layout);
	            }
	            if (layout.type === 'row') {
	                return rowLayout(layout);
	            }
	            if (layout.type === 'stack') {
	                return stackLayout(layout);
	            }
	        }
	        var result = {
	            content: [callRightFunctionForLayoutChild(layout)]
	        };
	        // console.log(result); // DEBUG : the outcome of unserialization
	        return result;
	    }
	    GLUtil.unserializeConfig = unserializeConfig;
	    /**
	     * It will be the previous tab on the current stack
	     * and if the stack is empty it will be the active tab on previous stack (if any)
	     */
	    function prevOnClose(args) {
	        var stacksInOrder = [];
	        GLUtil.visitAllStacks(args.config.content, function (stack) { return stacksInOrder.push(toTabStack(stack)); });
	        /** Find the stack that has this id */
	        var stackWithClosingTab = stacksInOrder.find(function (s) { return s.tabs.some(function (t) { return t.id === args.id; }); });
	        /** if the last tab in the stack */
	        if (stackWithClosingTab.tabs.length === 1) {
	            /** if this is the last stack then we will run out of tabs. Return null */
	            if (stacksInOrder.length == 1) {
	                return null;
	            }
	            /** return the active in the previous stack (with loop around) */
	            var previousStackIndex = utils.rangeLimited({
	                num: stacksInOrder.indexOf(stackWithClosingTab) - 1,
	                min: 0,
	                max: stacksInOrder.length - 1,
	                loopAround: true
	            });
	            var previousStack = stacksInOrder[previousStackIndex];
	            return previousStack.tabs[previousStack.selectedIndex];
	        }
	        else {
	            var previousIndex = utils.rangeLimited({
	                num: stackWithClosingTab.tabs.map(function (t) { return t.id; }).indexOf(args.id) - 1,
	                min: 0,
	                max: stackWithClosingTab.tabs.length - 1,
	                loopAround: true
	            });
	            return stackWithClosingTab.tabs[previousIndex];
	        }
	    }
	    GLUtil.prevOnClose = prevOnClose;
	})(GLUtil || (GLUtil = {}));
	var TabMoveHelp;
	(function (TabMoveHelp) {
	    var tabMoveDisplay = null;
	    function showHelp() {
	        tabMoveDisplay = $("\n<div class=\"alm_tabMove\">\n    <div>\n        <span class=\"keyStrokeStyle\">Tab Number</span> Jump to tab\n    </div>\n    <div>\n        <span class=\"keyStrokeStyle\">ESC</span> Exit\n    </div>\n    <div>\n        <span class=\"keyStrokeStyle\"><i class=\"fa fa-arrow-right\"></i></span>\n        Move active tab to a new rightmost pane\n    </div>\n    <div>\n        <span class=\"keyStrokeStyle\"><i class=\"fa fa-arrow-down\"></i></span>\n        Move active tab to a new bottom pane\n    </div>\n    <div>\n        <span class=\"keyStrokeStyle\">d</span> Duplicate current tab\n    </div>\n</div>\n            ");
	        $(document.body).append(tabMoveDisplay);
	    }
	    TabMoveHelp.showHelp = showHelp;
	    function hideHelp() {
	        if (tabMoveDisplay) {
	            tabMoveDisplay.remove();
	            tabMoveDisplay = null;
	        }
	    }
	    TabMoveHelp.hideHelp = hideHelp;
	})(TabMoveHelp || (TabMoveHelp = {}));
	var TipRender;
	(function (TipRender) {
	    var tipDisplay = null;
	    function showTips() {
	        if (!tipDisplay) {
	            var node = document.createElement('div');
	            node.className = "alm_tipRoot";
	            tipDisplay = $(node);
	            $('.lm_root').append(node);
	            ReactDOM.render(React.createElement(tips_1.Tips, null), node);
	        }
	        tipDisplay.show();
	    }
	    TipRender.showTips = showTips;
	    function hideTips() {
	        if (tipDisplay) {
	            tipDisplay.hide();
	        }
	    }
	    TipRender.hideTips = hideTips;
	})(TipRender || (TipRender = {}));
	/**
	 * Emitted whenever the state changes
	 * This bad boy is at the bottom because it broke syntax highlighting in atom :-/
	 */
	exports.tabStateChanged = new events_1.TypedEvent();


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var PooledClass = __webpack_require__(32);
	
	var emptyFunction = __webpack_require__(21);
	var warning = __webpack_require__(8);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(313);
	


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(318);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(319);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ui_1 = __webpack_require__(1);
	var pure = __webpack_require__(61);
	var Icon = /** @class */ (function (_super) {
	    __extends(Icon, _super);
	    function Icon() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Icon.prototype.shouldComponentUpdate = function () {
	        return pure.shouldComponentUpdate.apply(this, arguments);
	    };
	    Icon.prototype.render = function () {
	        var _a = this.props, name = _a.name, size = _a.size, rotate = _a.rotate, flip = _a.flip, spin = _a.spin, fixedWidth = _a.fixedWidth, stack = _a.stack, inverse = _a.inverse, pulse = _a.pulse, className = _a.className, style = _a.style;
	        var props = this.props;
	        var classNames = "fa fa-" + name;
	        if (size) {
	            classNames = classNames + " fa-" + size;
	        }
	        if (rotate) {
	            classNames = classNames + " fa-rotate-" + rotate;
	        }
	        if (flip) {
	            classNames = classNames + " fa-flip-" + flip;
	        }
	        if (fixedWidth) {
	            classNames = classNames + " fa-fw";
	        }
	        if (spin) {
	            classNames = classNames + " fa-spin";
	        }
	        if (pulse) {
	            classNames = classNames + " fa-pulse";
	        }
	        if (stack) {
	            classNames = classNames + " fa-stack-" + stack;
	        }
	        if (inverse) {
	            classNames = classNames + " fa-inverse";
	        }
	        if (className) {
	            classNames = classNames + " " + className;
	        }
	        return (React.createElement("i", { className: classNames, style: style }));
	    };
	    return Icon;
	}(ui_1.BaseComponent));
	exports.Icon = Icon;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(281);
	var ReactInstrumentation = __webpack_require__(22);
	
	var warning = __webpack_require__(8);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var ReactBaseClasses = __webpack_require__(137);
	var ReactChildren = __webpack_require__(327);
	var ReactDOMFactories = __webpack_require__(328);
	var ReactElement = __webpack_require__(40);
	var ReactPropTypes = __webpack_require__(329);
	var ReactVersion = __webpack_require__(330);
	
	var createReactClass = __webpack_require__(331);
	var onlyChild = __webpack_require__(335);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A global view on the errors. Essentially a sink for the errors from the server
	 */
	var errorsCache_1 = __webpack_require__(472);
	exports.errorsCache = new errorsCache_1.ErrorsCache();


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 37 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(65);
	var setInnerHTML = __webpack_require__(58);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(73);
	var setTextContent = __webpack_require__(131);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var ReactCurrentOwner = __webpack_require__(30);
	
	var warning = __webpack_require__(8);
	var canDefineProperty = __webpack_require__(141);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(139);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils = __webpack_require__(3);
	var commands = __webpack_require__(7);
	var appTabsContainer_1 = __webpack_require__(26);
	var docCache = __webpack_require__(162);
	/**
	 * After the app boots up
	 */
	function setup() {
	    /**
	     * Setup all the CM commands to go to the right place
	     */
	    commands.commandRegistry
	        .filter(function (x) { return x.config.context == commands.CommandContext.Editor; })
	        .forEach(function (cmd) {
	        cmd.on(function () {
	            var editorTab = API.getFocusedCodeEditorIfAny();
	            if (editorTab && editorTab.editor) {
	                var editor = editorTab.editor;
	                var action_1 = editor.getAction(cmd.config.editorCommandName);
	                if (!action_1) {
	                    console.error('Failed to find editor action:', cmd.config);
	                }
	                else {
	                    // We need a set timeout as when we trigger from 'command search' the focus changes throws off monaco
	                    // e.g. goto line action (which tries to create its own modal) does not work without the set timeout
	                    setTimeout(function () {
	                        // console.log(action); // DEBUG action details
	                        action_1.run();
	                    });
	                }
	            }
	        });
	    });
	}
	exports.setup = setup;
	/**
	 * Functions that can be provided as API
	 */
	var API;
	(function (API) {
	    function getClosedVsOpenFilePaths(filePaths) {
	        /** lookup all the *file* tabs that are open */
	        var allOpen = appTabsContainer_1.tabState.getOpenFilePaths();
	        var alreadyOpenFilePaths = filePaths.filter(function (fp) { return allOpen.indexOf(fp) != -1; });
	        var currentlyClosedFilePaths = filePaths.filter(function (fp) { return allOpen.indexOf(fp) == -1; });
	        return { alreadyOpenFilePaths: alreadyOpenFilePaths, currentlyClosedFilePaths: currentlyClosedFilePaths };
	    }
	    API.getClosedVsOpenFilePaths = getClosedVsOpenFilePaths;
	    function applyRefactorings(refactorings) {
	        var currentlyClosedFilePaths = getClosedVsOpenFilePaths(Object.keys(refactorings)).currentlyClosedFilePaths;
	        var tabs = currentlyClosedFilePaths.map(function (fp) {
	            var codeTab = {
	                id: utils.createId(),
	                url: "file://" + fp,
	                additionalData: null
	            };
	            return codeTab;
	        });
	        appTabsContainer_1.tabState.addTabs(tabs);
	        // Transact on docs
	        docCache.applyRefactoringsToTsDocs(refactorings);
	    }
	    API.applyRefactorings = applyRefactorings;
	    function getFocusedCodeEditorIfAny() {
	        return appTabsContainer_1.tabState.getFocusedCodeEditorIfAny();
	    }
	    API.getFocusedCodeEditorIfAny = getFocusedCodeEditorIfAny;
	})(API = exports.API || (exports.API = {}));


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventPluginRegistry = __webpack_require__(66);
	var EventPluginUtils = __webpack_require__(67);
	var ReactErrorUtils = __webpack_require__(71);
	
	var accumulateInto = __webpack_require__(125);
	var forEachAccumulated = __webpack_require__(126);
	var invariant = __webpack_require__(4);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(43);
	var EventPluginUtils = __webpack_require__(67);
	
	var accumulateInto = __webpack_require__(125);
	var forEachAccumulated = __webpack_require__(126);
	var warning = __webpack_require__(8);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	var getEventTarget = __webpack_require__(76);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 48 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	/**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */
	function getArg(aArgs, aName, aDefaultValue) {
	  if (aName in aArgs) {
	    return aArgs[aName];
	  } else if (arguments.length === 3) {
	    return aDefaultValue;
	  } else {
	    throw new Error('"' + aName + '" is a required argument.');
	  }
	}
	exports.getArg = getArg;
	
	var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
	var dataUrlRegexp = /^data:.+\,.+$/;
	
	function urlParse(aUrl) {
	  var match = aUrl.match(urlRegexp);
	  if (!match) {
	    return null;
	  }
	  return {
	    scheme: match[1],
	    auth: match[2],
	    host: match[3],
	    port: match[4],
	    path: match[5]
	  };
	}
	exports.urlParse = urlParse;
	
	function urlGenerate(aParsedUrl) {
	  var url = '';
	  if (aParsedUrl.scheme) {
	    url += aParsedUrl.scheme + ':';
	  }
	  url += '//';
	  if (aParsedUrl.auth) {
	    url += aParsedUrl.auth + '@';
	  }
	  if (aParsedUrl.host) {
	    url += aParsedUrl.host;
	  }
	  if (aParsedUrl.port) {
	    url += ":" + aParsedUrl.port
	  }
	  if (aParsedUrl.path) {
	    url += aParsedUrl.path;
	  }
	  return url;
	}
	exports.urlGenerate = urlGenerate;
	
	/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */
	function normalize(aPath) {
	  var path = aPath;
	  var url = urlParse(aPath);
	  if (url) {
	    if (!url.path) {
	      return aPath;
	    }
	    path = url.path;
	  }
	  var isAbsolute = exports.isAbsolute(path);
	
	  var parts = path.split(/\/+/);
	  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
	    part = parts[i];
	    if (part === '.') {
	      parts.splice(i, 1);
	    } else if (part === '..') {
	      up++;
	    } else if (up > 0) {
	      if (part === '') {
	        // The first part is blank if the path is absolute. Trying to go
	        // above the root is a no-op. Therefore we can remove all '..' parts
	        // directly after the root.
	        parts.splice(i + 1, up);
	        up = 0;
	      } else {
	        parts.splice(i, 2);
	        up--;
	      }
	    }
	  }
	  path = parts.join('/');
	
	  if (path === '') {
	    path = isAbsolute ? '/' : '.';
	  }
	
	  if (url) {
	    url.path = path;
	    return urlGenerate(url);
	  }
	  return path;
	}
	exports.normalize = normalize;
	
	/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */
	function join(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	  if (aPath === "") {
	    aPath = ".";
	  }
	  var aPathUrl = urlParse(aPath);
	  var aRootUrl = urlParse(aRoot);
	  if (aRootUrl) {
	    aRoot = aRootUrl.path || '/';
	  }
	
	  // `join(foo, '//www.example.org')`
	  if (aPathUrl && !aPathUrl.scheme) {
	    if (aRootUrl) {
	      aPathUrl.scheme = aRootUrl.scheme;
	    }
	    return urlGenerate(aPathUrl);
	  }
	
	  if (aPathUrl || aPath.match(dataUrlRegexp)) {
	    return aPath;
	  }
	
	  // `join('http://', 'www.example.com')`
	  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
	    aRootUrl.host = aPath;
	    return urlGenerate(aRootUrl);
	  }
	
	  var joined = aPath.charAt(0) === '/'
	    ? aPath
	    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
	  if (aRootUrl) {
	    aRootUrl.path = joined;
	    return urlGenerate(aRootUrl);
	  }
	  return joined;
	}
	exports.join = join;
	
	exports.isAbsolute = function (aPath) {
	  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
	};
	
	/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */
	function relative(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	
	  aRoot = aRoot.replace(/\/$/, '');
	
	  // It is possible for the path to be above the root. In this case, simply
	  // checking whether the root is a prefix of the path won't work. Instead, we
	  // need to remove components from the root one by one, until either we find
	  // a prefix that fits, or we run out of components to remove.
	  var level = 0;
	  while (aPath.indexOf(aRoot + '/') !== 0) {
	    var index = aRoot.lastIndexOf("/");
	    if (index < 0) {
	      return aPath;
	    }
	
	    // If the only part of the root that is left is the scheme (i.e. http://,
	    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
	    // have exhausted all components, so the path is not relative to the root.
	    aRoot = aRoot.slice(0, index);
	    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
	      return aPath;
	    }
	
	    ++level;
	  }
	
	  // Make sure we add a "../" for each component we removed from the root.
	  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
	}
	exports.relative = relative;
	
	var supportsNullProto = (function () {
	  var obj = Object.create(null);
	  return !('__proto__' in obj);
	}());
	
	function identity (s) {
	  return s;
	}
	
	/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */
	function toSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return '$' + aStr;
	  }
	
	  return aStr;
	}
	exports.toSetString = supportsNullProto ? identity : toSetString;
	
	function fromSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return aStr.slice(1);
	  }
	
	  return aStr;
	}
	exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
	function isProtoString(s) {
	  if (!s) {
	    return false;
	  }
	
	  var length = s.length;
	
	  if (length < 9 /* "__proto__".length */) {
	    return false;
	  }
	
	  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
	      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
	      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
	      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 9) !== 95  /* '_' */) {
	    return false;
	  }
	
	  for (var i = length - 10; i >= 0; i--) {
	    if (s.charCodeAt(i) !== 36 /* '$' */) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */
	function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
	  var cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0 || onlyCompareOriginal) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByOriginalPositions = compareByOriginalPositions;
	
	/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */
	function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0 || onlyCompareGenerated) {
	    return cmp;
	  }
	
	  cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
	function strcmp(aStr1, aStr2) {
	  if (aStr1 === aStr2) {
	    return 0;
	  }
	
	  if (aStr1 > aStr2) {
	    return 1;
	  }
	
	  return -1;
	}
	
	/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */
	function compareByGeneratedPositionsInflated(mappingA, mappingB) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = strcmp(mappingA.source, mappingB.source);
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This is a level above CSX
	 *  - It wraps up the CSX primitives into components
	 */
	var csx = __webpack_require__(6);
	var csx_1 = __webpack_require__(6);
	var typestyle = __webpack_require__(13);
	var React = __webpack_require__(2);
	/** Creates a copy of an object without the mentioned keys */
	function _objectWithoutProperties(obj, keys) {
	    var target = {};
	    for (var i in obj) {
	        if (keys.indexOf(i) >= 0)
	            continue;
	        if (!Object.prototype.hasOwnProperty.call(obj, i))
	            continue;
	        target[i] = obj[i];
	    }
	    return target;
	}
	/********
	 *
	 * Primitives
	 *
	 ********/
	/**
	* For that time you just need a visual vertical seperation
	*/
	exports.SmallVerticalSpace = function (props) {
	    return React.createElement("div", { style: { height: props.space || 24 } });
	};
	exports.SmallVerticalSpace.displayName = "SmallVerticalSpace";
	/**
	 * For that time you just need a visual horizontal seperation
	 */
	exports.SmallHorizontalSpace = function (props) {
	    return React.createElement("div", { style: { width: props.space || 24, display: 'inline-block' } });
	};
	exports.SmallVerticalSpace.displayName = "SmallHorizontalSpace";
	;
	var ClassNames;
	(function (ClassNames) {
	    ClassNames.content = typestyle.style(csx_1.vendorPrefixed.content);
	    ClassNames.flex = typestyle.style(csx_1.vendorPrefixed.pass, csx_1.vendorPrefixed.flex);
	    ClassNames.flexScrollY = typestyle.style(csx_1.vendorPrefixed.pass, csx_1.vendorPrefixed.flex, csx_1.vendorPrefixed.vertical, { overflowY: 'auto' });
	    ClassNames.pass = typestyle.style(csx_1.vendorPrefixed.pass);
	    ClassNames.contentVertical = typestyle.style(csx_1.vendorPrefixed.content, csx_1.vendorPrefixed.vertical);
	    ClassNames.contentVerticalCentered = typestyle.style(csx_1.vendorPrefixed.content, csx_1.vendorPrefixed.vertical, csx_1.vendorPrefixed.center);
	    ClassNames.contentHorizontal = typestyle.style(csx_1.vendorPrefixed.content, csx_1.vendorPrefixed.horizontal);
	    ClassNames.contentHorizontalCentered = typestyle.style(csx_1.vendorPrefixed.content, csx_1.vendorPrefixed.horizontal, csx_1.vendorPrefixed.center);
	    ClassNames.flexVertical = typestyle.style(csx_1.vendorPrefixed.flex, csx_1.vendorPrefixed.vertical, { maxWidth: '100%' /*normalizing browser bugs*/ });
	    ClassNames.flexHorizontal = typestyle.style(csx_1.vendorPrefixed.flex, csx_1.vendorPrefixed.horizontal);
	})(ClassNames || (ClassNames = {}));
	/**
	 * Generally prefer an inline block (as that will wrap).
	 * Use this for critical `content` driven *vertical* height
	 *
	 * Takes as much space as it needs, no more, no less
	 */
	exports.Content = function (props) {
	    var className = ClassNames.content + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "Content" }, props, { className: className }), props.children));
	};
	exports.Content.displayName = "Content";
	/**
	 * Takes as much space as it needs, no more, no less
	 */
	exports.InlineBlock = function (props) {
	    var style = csx.extend({ display: 'inline-block' }, props.style || {});
	    return (React.createElement("div", __assign({ "data-comment": "InlineBlock" }, props, { style: style }), props.children));
	};
	exports.InlineBlock.displayName = "InlineBlock";
	/**
	 * Takes up all the parent space, no more, no less
	 */
	exports.Flex = function (props) {
	    var className = ClassNames.flex + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "Flex" }, props, { className: className }), props.children));
	};
	exports.Flex.displayName = "Flex";
	/**
	 * Takes up all the parent space, no more, no less and scrolls the children in Y if needed
	 */
	exports.FlexScrollY = function (props) {
	    var className = ClassNames.flexScrollY + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "FlexScrollY" }, props, { className: className }), props.children));
	};
	exports.FlexScrollY.displayName = "FlexScrollY";
	/**
	 * When you need a general purpose container. Use this instead of a `div`
	 */
	exports.Pass = function (props) {
	    var className = ClassNames.pass + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "Pass" }, props, { className: className }), props.children));
	};
	exports.Pass.displayName = "Pass";
	/**
	 * Provides a Vertical Container. For the parent it behaves like content.
	 */
	exports.ContentVertical = function (props) {
	    var className = ClassNames.contentVertical + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "ContentVertical" }, props, { className: className }), props.children));
	};
	exports.ContentVertical.displayName = "ContentVertical";
	/**
	 * Quite commonly need horizontally centered text
	 */
	exports.ContentVerticalCentered = function (props) {
	    var className = ClassNames.contentVerticalCentered + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "ContentVerticalCentered" }, props, { className: className }), props.children));
	};
	exports.ContentVerticalCentered.displayName = "ContentVerticalCentered";
	/**
	 * Provides a Horizontal Container. For the parent it behaves like content.
	 */
	exports.ContentHorizontal = function (props) {
	    var className = ClassNames.contentHorizontal + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "ContentHorizontal" }, props, { className: className }), props.children));
	};
	exports.ContentHorizontal.displayName = "ContentHorizontal";
	/**
	 * Provides a Horizontal Container and centers its children in the cross dimension
	 */
	exports.ContentHorizontalCentered = function (props) {
	    var className = ClassNames.contentHorizontalCentered + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "ContentHorizontalCentered" }, props, { className: className }), props.children));
	};
	exports.ContentHorizontalCentered.displayName = "ContentHorizontalCentered";
	/**
	 * Provides a Vertical Container. For the parent it behaves like flex.
	 */
	exports.FlexVertical = function (props) {
	    var className = ClassNames.flexVertical + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "FlexVertical" }, props, { className: className }), props.children));
	};
	exports.FlexVertical.displayName = "FlexVertical";
	/**
	 * Provides a Horizontal Container. For the parent it behaves like flex.
	 */
	exports.FlexHorizontal = function (props) {
	    var className = ClassNames.flexHorizontal + (props.className ? " " + props.className : '');
	    return (React.createElement("div", __assign({ "data-comment": "FlexHorizontal" }, props, { className: className }), props.children));
	};
	exports.FlexHorizontal.displayName = "FlexHorizontal";
	/**
	 * Lays out the children horizontally with
	 * - ThisComponent: gets the overall Height (by max) of the children
	 * - Children: get the Width : equally distributed from the parent Width
	 * - Children: get the Height : sized by content
	 * - ThisComponent: Puts a horizontal padding between each item
	 */
	exports.ContentHorizontalFlexPadded = function (props) {
	    var padding = props.padding;
	    var otherProps = _objectWithoutProperties(props, ['padding', 'children']);
	    var children = React.Children.toArray(props.children).filter(function (c) { return !!c; });
	    var last = children.length - 1;
	    var itemPadding = function (index) {
	        if (index == last) {
	            return csx.Box.padding(0);
	        }
	        else {
	            return csx.Box.padding(0, padding, 0, 0);
	        }
	    };
	    return (React.createElement(exports.ContentHorizontal, __assign({}, otherProps), children.map(function (child, i) { return React.createElement(exports.Flex, { key: child.key || i, style: itemPadding(i) }, child); })));
	};
	exports.ContentHorizontalFlexPadded.displayName = "ContentHorizontalFlexPadded";
	/**
	 * Lays out the children horizontally with
	 * - Parent: gets to chose the Width
	 * - ThisComponent: gets the overall Height (by max) of the children
	 * - Children: get the Width : equally distributed from the parent Width
	 * - Children: get the Height : sized by content
	 * - ThisComponent: Puts a horizontal padding between each item
	 */
	exports.FlexHorizontalFlexPadded = function (props) {
	    var padding = props.padding;
	    var otherProps = _objectWithoutProperties(props, ['padding', 'children']);
	    var children = React.Children.toArray(props.children).filter(function (c) { return !!c; });
	    var last = children.length - 1;
	    var itemPadding = function (index) {
	        if (index == last) {
	            return csx.Box.padding(0);
	        }
	        else {
	            return csx.Box.padding(0, padding, 0, 0);
	        }
	    };
	    return (React.createElement(exports.FlexHorizontal, __assign({}, otherProps), children.map(function (child, i) { return React.createElement(exports.Flex, { key: child.key || i, style: itemPadding(i) }, child); })));
	};
	exports.FlexHorizontalFlexPadded.displayName = "FlexHorizontalFlexPadded";
	/**
	 * Lays out the children horizontally with
	 * - Parent: gets to chose the Width
	 * - ThisComponent: gets the overall Height (by max) of the children
	 * - Children: get the Width : equally distributed from the parent Width
	 * - Children: get the Height : sized by content
	 * - ThisComponent: Puts a horizontal padding between each item
	 */
	exports.ContentHorizontalContentPadded = function (props) {
	    var padding = props.padding;
	    var otherProps = _objectWithoutProperties(props, ['padding', 'children']);
	    var children = React.Children.toArray(props.children).filter(function (c) { return !!c; });
	    var last = children.length - 1;
	    var itemPadding = function (index) {
	        if (index == last) {
	            return csx.Box.padding(0);
	        }
	        else {
	            return csx.Box.padding(0, padding, 0, 0);
	        }
	    };
	    return (React.createElement(exports.ContentHorizontal, __assign({}, otherProps), children.map(function (child, i) { return React.createElement(exports.Content, { key: child.key || i, style: itemPadding(i) }, child); })));
	};
	exports.ContentHorizontalContentPadded.displayName = "ContentHorizontalContentPadded";
	/**
	 * Lays out the children vertically with
	 * - Parent: gets to chose the Width
	 * - ThisComponent: gets the Height : (by sum) of the children
	 * - Children: get the Width : parent
	 * - Children: get the Height : sized by content
	 * - ThisComponent: Puts a vertical padding between each item
	 */
	exports.ContentVerticalContentPadded = function (props) {
	    var padding = props.padding;
	    var otherProps = _objectWithoutProperties(props, ['padding', 'children']);
	    var children = React.Children.toArray(props.children).filter(function (c) { return !!c; });
	    var last = children.length - 1;
	    var itemPadding = function (index) {
	        if (index == last) {
	            return csx.Box.padding(0);
	        }
	        else {
	            return csx.Box.padding(0, 0, padding, 0);
	        }
	    };
	    return (React.createElement(exports.ContentVertical, __assign({}, otherProps), children.map(function (child, i) { return React.createElement(exports.Content, { key: child.key || i, style: itemPadding(i) }, child); })));
	};
	exports.ContentVerticalContentPadded.displayName = "ContentVerticalContentPadded";
	/**
	 * Lays out the children vertically with
	 * - Parent: gets to chose the overall Width
	 * - ThisComponent: gets the Height : (by sum) of the children
	 * - Children: get the Width : sized by content
	 * - Children: get the Height : sized by content
	 * - ThisComponent: Puts a margin between each item.
	 * - ThisComponent: Puts a negative margin on itself to offset the margins of the children (prevents them from leaking out)
	 */
	exports.GridMargined = function (props) {
	    var margin = props.margin;
	    var otherProps = _objectWithoutProperties(props, ['margin', 'children']);
	    var marginPx = margin + "px";
	    var style = csx.extend(csx.wrap, { marginTop: '-' + marginPx, marginLeft: '-' + marginPx }, props.style || {});
	    var children = React.Children.toArray(props.children).filter(function (c) { return !!c; });
	    return (React.createElement(exports.ContentHorizontal, __assign({}, otherProps, { style: style }), children.map(function (child, i) { return React.createElement(exports.Content, { key: child.key || i, style: { marginLeft: marginPx, marginTop: marginPx } }, child); })));
	};
	exports.GridMargined.displayName = "GridMargined";


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var ui = __webpack_require__(1);
	var typestyle = __webpack_require__(13);
	var buttonClassName = typestyle.style({
	    height: '18px',
	    padding: '2px 3px',
	    display: 'inline-flex',
	    cursor: 'pointer',
	    backgroundImage: 'linear-gradient(#7B7B7B, #353434)',
	    border: '1px solid #464646',
	    borderRadius: '3px',
	    userSelect: 'none',
	    outline: '0px',
	    $nest: {
	        '&:active': {
	            backgroundImage: 'linear-gradient(#353434, #7B7B7B)',
	        }
	    }
	});
	var clippy = {
	    width: '12px',
	    height: '12px'
	};
	var Clipboard = /** @class */ (function (_super) {
	    __extends(Clipboard, _super);
	    function Clipboard() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Clipboard.prototype.render = function () {
	        return (React.createElement("button", { className: buttonClassName, style: csx.extend(csx.center), "data-clipboard-text": this.props.text, onClick: function (event) { return event.stopPropagation() || ui.notifyInfoQuickDisappear("Copied"); } },
	            React.createElement("img", { src: "assets/clippy.svg", style: clippy })));
	    };
	    return Clipboard;
	}(ui_1.BaseComponent));
	exports.Clipboard = Clipboard;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Provides a simple Select list view style API
	 * similar to atom space pen views
	 */
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var Modal = __webpack_require__(28);
	var styles = __webpack_require__(10);
	var utils_1 = __webpack_require__(3);
	var commands = __webpack_require__(7);
	var fuzzaldrin_1 = __webpack_require__(96);
	var utils = __webpack_require__(3);
	var typestyle = __webpack_require__(13);
	var inputClassName = typestyle.style(styles.modal.inputStyleBase);
	var SelectListView = /** @class */ (function (_super) {
	    __extends(SelectListView, _super);
	    function SelectListView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.maxShowCount = 15;
	        _this.closeOmniSearch = function () {
	            _this.setState({ isOpen: false, filterValue: '' });
	        };
	        _this.onChangeFilter = utils_1.debounce(function (e) {
	            var filterValue = ReactDOM.findDOMNode(_this.refs.omniSearchInput).value;
	            _this.getNewData().then(function () {
	                _this.filteredResults = getFilteredItems({
	                    items: _this.state.data,
	                    textify: _this.state.textify,
	                    filterValue: filterValue
	                });
	                _this.filteredResults = _this.filteredResults.slice(0, _this.maxShowCount);
	                _this.setState({ filterValue: filterValue, selectedIndex: 0 });
	            });
	        }, 50);
	        _this.incrementSelected = utils_1.debounce(function () {
	            _this.setState({ selectedIndex: utils_1.rangeLimited({ num: _this.state.selectedIndex + 1, min: 0, max: Math.min(_this.maxShowCount - 1, _this.filteredResults.length - 1), loopAround: true }) });
	        }, 0, true);
	        _this.decrementSelected = utils_1.debounce(function () {
	            _this.setState({ selectedIndex: utils_1.rangeLimited({ num: _this.state.selectedIndex - 1, min: 0, max: Math.min(_this.maxShowCount - 1, _this.filteredResults.length - 1), loopAround: true }) });
	        }, 0, true);
	        _this.onChangeSelected = function (e) {
	            if (e.key == 'ArrowUp') {
	                e.preventDefault();
	                _this.decrementSelected();
	            }
	            if (e.key == 'ArrowDown') {
	                e.preventDefault();
	                _this.incrementSelected();
	            }
	            if (e.key == 'Enter') {
	                e.preventDefault();
	                _this.selectIndex(_this.state.selectedIndex);
	            }
	        };
	        _this.selectIndex = function (index) {
	            var result = _this.filteredResults[index];
	            _this.state.onSelect(result);
	            _this.closeOmniSearch();
	        };
	        _this.getNewData = utils.onlyLastCall(function () {
	            var filterValue = ReactDOM.findDOMNode(_this.refs.omniSearchInput).value;
	            return _this.state.getNewData(filterValue).then(function (data) {
	                _this.setState({ data: data });
	            });
	        });
	        _this.filteredResults = [];
	        _this.state = {
	            isOpen: false,
	            selectedIndex: 0,
	            header: '',
	            data: [],
	        };
	        return _this;
	    }
	    /*
	    API sample usage
	        this.refs.selectListView.show<ActiveProjectConfigDetails>({
	        header: 'Select the active project',
	        data: availableProjects,
	        render: (d,highlitedText) => <div>{highlitedText}</div>,
	        textify: (d) => d.name,
	        onSelect: (d) => {
	            server.setActiveProjectName({ name: d.name });
	            state.setActiveProject(d.name);
	            state.setInActiveProject(types.TriState.Unknown);
	        }
	    });
	    */
	    /**
	     * The main interaction API
	     */
	    SelectListView.prototype.show = function (args) {
	        this.filteredResults = args.data.concat([]);
	        this.setState({
	            isOpen: true,
	            filterValue: '',
	            selectedIndex: 0,
	            header: args.header,
	            data: args.data,
	            render: args.render,
	            textify: args.textify,
	            onSelect: args.onSelect,
	            getNewData: args.getNewData || (function () { return Promise.resolve(args.data); }),
	        });
	        ReactDOM.findDOMNode(this.refs.omniSearchInput).focus();
	    };
	    SelectListView.prototype.componentDidMount = function () {
	        var _this = this;
	        exports.selectListView = this;
	        commands.esc.on(function () {
	            _this.closeOmniSearch();
	        });
	    };
	    SelectListView.prototype.componentDidUpdate = function () {
	        var _this = this;
	        // get the dom node that is selected
	        // make sure its parent scrolls to make this visible
	        setTimeout(function () {
	            if (_this.refs.selected) {
	                var selected = _this.refs.selected;
	                selected.scrollIntoViewIfNeeded(false);
	            }
	        });
	    };
	    SelectListView.prototype.render = function () {
	        var _this = this;
	        var fileList = this.filteredResults;
	        var selectedIndex = this.state.selectedIndex;
	        var fileListRendered = fileList.map(function (item, i) {
	            // key = i
	            var selected = selectedIndex === i;
	            var selectedStyle = selected ? {
	                background: '#545454',
	                color: 'white'
	            } : {};
	            var ref = selected && "selected";
	            return (React.createElement("div", { key: i, style: csx.extend(selectedStyle, styles.padded2, styles.hand, csx.content), onClick: function () { return _this.selectIndex(i); }, ref: ref }, _this.state.render(item, renderMatchedSegments(_this.state.textify(item), _this.state.filterValue))));
	        });
	        return React.createElement(Modal, { isOpen: this.state.isOpen, onRequestClose: this.closeOmniSearch },
	            React.createElement("div", { style: csx.extend(csx.vertical, csx.flex) },
	                React.createElement("div", { style: csx.extend(csx.horizontal, csx.content) },
	                    React.createElement("h4", null, this.state.header),
	                    React.createElement("div", { style: csx.flex }),
	                    React.createElement("div", { style: { fontSize: '0.9rem', color: 'grey' } },
	                        React.createElement("code", { style: styles.modal.keyStrokeStyle }, "Esc"),
	                        " to exit ",
	                        React.createElement("code", { style: styles.modal.keyStrokeStyle }, "Enter"),
	                        " to select")),
	                React.createElement("div", { style: csx.extend(styles.padded1TopBottom, csx.vertical, csx.content) },
	                    React.createElement("input", { type: "text", ref: "omniSearchInput", placeholder: "Filter", className: inputClassName, onChange: this.onChangeFilter, onKeyDown: this.onChangeSelected })),
	                React.createElement("div", { style: csx.extend(csx.vertical, csx.flex, { overflow: 'auto' }) },
	                    React.createElement("div", { style: csx.vertical }, fileListRendered))));
	    };
	    return SelectListView;
	}(ui_1.BaseComponent));
	exports.SelectListView = SelectListView;
	/**
	 * Applies fuzzy filter to the text version of each item returning the matched items
	 */
	function getFilteredItems(args) {
	    // Store the items for each text value
	    var textValueToItems = Object.create(null);
	    args.items.forEach(function (item) {
	        var text = args.textify(item);
	        if (!textValueToItems[text])
	            textValueToItems[text] = [];
	        textValueToItems[text].push(item);
	    });
	    // Get the unique text values
	    var textValues = Object.keys(utils.createMap(args.items.map(args.textify)));
	    // filter them
	    var filteredTextValues = fuzzaldrin_1.filter(textValues, args.filterValue);
	    return utils.selectMany(filteredTextValues.map(function (textvalue) { return textValueToItems[textvalue]; }));
	}
	exports.getFilteredItems = getFilteredItems;
	/**
	 * Based on https://github.com/atom/fuzzy-finder/blob/51f1f2415ecbfab785596825a011c1d2fa2658d3/lib/fuzzy-finder-view.coffee#L56-L74
	 */
	function renderMatchedSegments(result, query) {
	    // local function that creates the *matched segment* data structure
	    function getMatchedSegments(result, query) {
	        var matches = fuzzaldrin_1.match(result, query);
	        var matchMap = utils_1.createMap(matches);
	        // collapse contiguous sections into a single `<strong>`
	        var currentUnmatchedCharacters = [];
	        var currentMatchedCharacters = [];
	        var combined = [];
	        function closeOffUnmatched() {
	            if (currentUnmatchedCharacters.length) {
	                combined.push({ str: currentUnmatchedCharacters.join(''), matched: false });
	                currentUnmatchedCharacters = [];
	            }
	        }
	        function closeOffMatched() {
	            if (currentMatchedCharacters.length) {
	                combined.push({ str: currentMatchedCharacters.join(''), matched: true });
	                currentMatchedCharacters = [];
	            }
	        }
	        result.split('').forEach(function (c, i) {
	            var isMatched = matchMap[i];
	            if (isMatched) {
	                if (currentMatchedCharacters.length) {
	                    currentMatchedCharacters.push(c);
	                }
	                else {
	                    currentMatchedCharacters = [c];
	                    // close off any unmatched characters
	                    closeOffUnmatched();
	                }
	            }
	            else {
	                if (currentUnmatchedCharacters.length) {
	                    currentUnmatchedCharacters.push(c);
	                }
	                else {
	                    currentUnmatchedCharacters = [c];
	                    // close off any matched characters
	                    closeOffMatched();
	                }
	            }
	        });
	        closeOffMatched();
	        closeOffUnmatched();
	        return combined;
	    }
	    /**
	     * Rendering the matched segment data structure is trivial
	     */
	    var matched = getMatchedSegments(result, query);
	    var matchedStyle = { fontWeight: 'bold', color: '#66d9ef' };
	    return matched.map(function (item, i) {
	        return React.createElement("span", { key: i, style: item.matched ? matchedStyle : {} }, item.str);
	    });
	}
	exports.renderMatchedSegments = renderMatchedSegments;


/***/ },
/* 52 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var EventPluginRegistry = __webpack_require__(66);
	var ReactEventEmitterMixin = __webpack_require__(274);
	var ViewportMetrics = __webpack_require__(124);
	
	var getVendorPrefixedEventName = __webpack_require__(305);
	var isEventSupported = __webpack_require__(78);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(46);
	var ViewportMetrics = __webpack_require__(124);
	
	var getEventModifierState = __webpack_require__(75);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 57 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	var DOMNamespaces = __webpack_require__(65);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(73);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A global view into the error results on the client side
	 */
	var testResultsCache_1 = __webpack_require__(473);
	exports.testResultsCache = new testResultsCache_1.TestResultsCache();


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var socketClient_1 = __webpack_require__(5);
	var docCache = __webpack_require__(162);
	var cursorHistory = __webpack_require__(399);
	var search = __webpack_require__(446);
	var semanticView = __webpack_require__(420);
	var monacoUtils = __webpack_require__(18);
	var gitStatus = __webpack_require__(159);
	var liveAnalysis = __webpack_require__(417);
	var quickFix = __webpack_require__(160);
	var linter = __webpack_require__(416);
	var docblockr = __webpack_require__(408);
	var doctor = __webpack_require__(409);
	var testedMonaco = __webpack_require__(421);
	var utils = __webpack_require__(3);
	var autoCloseTag = __webpack_require__(158);
	// Any other style modifications
	__webpack_require__(372);
	exports.monokai = [
	    { token: '', foreground: 'f8f8f2' },
	    { token: 'comment', foreground: '75715e' },
	    { token: 'string', foreground: 'e6db74' },
	    { token: 'support.property-value.string.value.json', foreground: 'e6db74' },
	    { token: 'constant.numeric', foreground: 'ae81ff' },
	    { token: 'constant.language', foreground: 'ae81ff' },
	    { token: 'constant.character', foreground: 'ae81ff' },
	    { token: 'constant.other', foreground: 'ae81ff' },
	    { token: 'keyword', foreground: 'f92672' },
	    { token: 'support.property-value.keyword.json', foreground: 'f92672' },
	    { token: 'storage', foreground: 'aae354' },
	    { token: 'storage.type', foreground: '66d9ef', fontStyle: 'italic' },
	    { token: 'entity.name.class', foreground: 'a6e22e' },
	    { token: 'entity.other', foreground: 'a6e22e' },
	    { token: 'entity.name.function', foreground: 'a6e22e' },
	    { token: 'entity.name.tag', foreground: 'f92672' },
	    { token: 'entity.other.attribute-name', foreground: 'a6e22e' },
	    { token: 'variable', foreground: 'f8f8f2' },
	    { token: 'variable.parameter', foreground: 'fd971f', fontStyle: 'italic' },
	    { token: 'support.function', foreground: '66d9ef' },
	    { token: 'support.constant', foreground: '66d9ef' },
	    { token: 'support.type', foreground: '66d9ef' },
	    { token: 'support.class', foreground: '66d9ef', fontStyle: 'italic' },
	    /** We use qualifier for `const`, `var`, `private` etc. */
	    { token: 'qualifier', foreground: '00d0ff' },
	    /* `def` does not exist. We like to use it for variable definitions */
	    { token: 'def', foreground: 'fd971f' },
	    /** variable-2 doesn't exist. We use it for identifiers in type positions */
	    { token: 'variable-2', foreground: '9effff' },
	];
	monaco.editor.defineTheme('monokai', {
	    base: 'vs-dark',
	    inherit: true,
	    rules: exports.monokai
	});
	var CodeEditor = /** @class */ (function (_super) {
	    __extends(CodeEditor, _super);
	    function CodeEditor(props) {
	        var _this = _super.call(this, props) || this;
	        /** Ready after the doc is loaded */
	        _this.ready = false;
	        _this.afterReadyQueue = [];
	        /** If already ready it execs ... otherwise waits */
	        _this.afterReady = function (cb) {
	            if (_this.ready)
	                cb();
	            else {
	                _this.afterReadyQueue.push(cb);
	            }
	        };
	        _this.firstFocus = true;
	        _this.focus = function () {
	            if (!_this.ready && _this.firstFocus) {
	                _this.firstFocus = false;
	                _this.afterReadyQueue.push(function () {
	                    _this.resize();
	                    _this.focus();
	                });
	            }
	            else if (_this.editor) {
	                _this.editor.focus();
	            }
	        };
	        _this.resize = function () {
	            if (_this.editor) {
	                var before_1 = _this.editor.getDomNode().scrollHeight;
	                _this.refresh();
	                var after_1 = _this.editor.getDomNode().scrollHeight;
	                var worthRestoringScrollPosition = (after_1 !== before_1) && (after_1 != 0);
	                /** Restore last scroll position on refresh after a blur */
	                if (_this.lastScrollPosition != undefined && worthRestoringScrollPosition) {
	                    setTimeout(function () {
	                        _this.editor.setScrollTop(_this.lastScrollPosition);
	                        // console.log(this.props.filePath, before, after, worthRestoringScrollPosition, this.lastScrollPosition); // DEBUG
	                        _this.lastScrollPosition = undefined;
	                    });
	                }
	            }
	        };
	        _this.lastScrollPosition = undefined;
	        _this.gotoPosition = function (position) {
	            _this.afterReady(function () {
	                _this.lastScrollPosition = undefined; // Don't even think about restoring scroll position
	                /** e.g. if the tab is already active we don't call `focus` from `gotoPosition` ... however it might not have focus */
	                if (!_this.editor.isFocused()) {
	                    _this.editor.focus();
	                }
	                /** SetTimeout because if editor comes out of hidden state we goto position too fast and then the scroll position is off */
	                setTimeout(function () { return monacoUtils.gotoPosition({ editor: _this.editor, position: position }); });
	            });
	        };
	        _this.refresh = function () {
	            _this.editor.layout();
	        };
	        _this.focusChanged = function (focused) {
	            _this.setState({
	                isFocused: focused
	            });
	            _this.props.onFocusChange && _this.props.onFocusChange(focused);
	        };
	        _this.search = function (options) {
	            search.commands.search(_this.editor, options);
	        };
	        _this.hideSearch = function () {
	            search.commands.hideSearch(_this.editor);
	        };
	        _this.findNext = function (options) {
	            search.commands.findNext(_this.editor, options);
	        };
	        _this.findPrevious = function (options) {
	            search.commands.findPrevious(_this.editor, options);
	        };
	        _this.replaceNext = function (newText) {
	            search.commands.replaceNext(_this.editor, newText);
	        };
	        _this.replacePrevious = function (newText) {
	            search.commands.replacePrevious(_this.editor, newText);
	        };
	        _this.replaceAll = function (newText) {
	            search.commands.replaceAll(_this.editor, newText);
	        };
	        _this.handleCursorActivity = function () {
	            var cursor = _this.editor.getSelection();
	            cursorHistory.addEntry({
	                line: cursor.startLineNumber - 1,
	                ch: cursor.startColumn - 1,
	            });
	        };
	        _this.state = {
	            isFocused: false,
	            loading: true,
	        };
	        return _this;
	    }
	    CodeEditor.prototype.componentDidMount = function () {
	        var _this = this;
	        var mountNode = this.refs.codeEditor;
	        var filePath = this.props.filePath;
	        this.editor = monaco.editor.create(mountNode, {
	            value: '...',
	            theme: 'monokai',
	            folding: true,
	            autoClosingBrackets: true,
	            wrappingColumn: 0,
	            readOnly: false,
	            scrollBeyondLastLine: false,
	            formatOnType: true,
	            contextmenu: false,
	            /** Move snippet suggestions to the bottom */
	            snippetSuggestions: 'bottom',
	            /** Since everything else in our UI is Square */
	            roundedSelection: false,
	            /** For git status, find results, errors */
	            overviewRulerLanes: 3,
	            /** Don't reserve too much space for line numbers */
	            lineNumbersMinChars: 4,
	            /** We need the glyph margin to show live analysis stuff */
	            glyphMargin: true,
	            /**
	             * Change the default font.
	             * The default is `consolas` , `courier new`.
	             * This means that if user does not have consolas they get *aweful* courier new.
	             * Don't want that.
	             * Also the default change by OS.
	             * I prefer consistency so going with custom font everywhere
	             */
	            fontFamily: 'consolas, menlo, monospace',
	            /** Also make the font a bit bigger */
	            fontSize: 16,
	        }, []);
	        this.editor.filePath = filePath;
	        // Utility to load editor options
	        var loadEditorOptions = function (editorOptions) {
	            // Feels consistent with https://code.visualstudio.com/Docs/customization/userandworkspace
	            _this.editor.getModel().updateOptions({
	                insertSpaces: editorOptions.convertTabsToSpaces,
	                tabSize: editorOptions.tabSize
	            });
	        };
	        this.disposible.add(socketClient_1.cast.editorOptionsChanged.on(function (res) {
	            if (res.filePath === _this.props.filePath) {
	                loadEditorOptions(res.editorOptions);
	            }
	        }));
	        // load up the doc
	        docCache.getLinkedDoc(this.props.filePath, this.editor).then(function (_a) {
	            var doc = _a.doc, editorOptions = _a.editorOptions;
	            // Load editor options
	            loadEditorOptions(editorOptions);
	            if (_this.props.preview) {
	                _this.gotoPreview(_this.props.preview);
	            }
	            // linter
	            // NOTE: done here because it depends on model :)
	            _this.disposible.add(linter.setup(_this.editor));
	            /** Tested */
	            if (!_this.props.readOnly) {
	                _this.disposible.add(testedMonaco.setup(_this.editor));
	            }
	            /** Auto close tag */
	            var ext = utils.getExt(_this.props.filePath);
	            if (ext === 'tsx') {
	                _this.disposible.add(autoCloseTag.setup(_this.editor));
	            }
	            // Mark as ready and do anything that was waiting for ready to occur 🌹
	            _this.afterReadyQueue.forEach(function (cb) { return cb(); });
	            _this.ready = true;
	            _this.setState({ loading: false });
	        });
	        this.disposible.add(this.editor.onDidFocusEditor(this.focusChanged.bind(this, true)));
	        this.disposible.add(this.editor.onDidBlurEditor(this.focusChanged.bind(this, false)));
	        // cursor history
	        if (!this.props.readOnly) {
	            this.disposible.add(this.editor.onDidChangeCursorPosition(this.handleCursorActivity));
	        }
	        // live analysis
	        this.disposible.add(liveAnalysis.setup(this.editor));
	        // quick fix
	        if (!this.props.readOnly) {
	            this.disposible.add(quickFix.setup(this.editor));
	        }
	        // Git status
	        this.disposible.add(gitStatus.setup(this.editor));
	        // Docblockr
	        this.disposible.add(docblockr.setup(this.editor));
	    };
	    CodeEditor.prototype.componentWillUnmount = function () {
	        _super.prototype.componentWillUnmount.call(this);
	        docCache.removeLinkedDoc(this.props.filePath, this.editor);
	        this.editor.dispose();
	        this.editor = null;
	    };
	    CodeEditor.prototype.willBlur = function () {
	        this.lastScrollPosition = this.editor.getScrollTop();
	        // console.log('Storing:', this.props.filePath, this.lastScrollPosition); // DEBUG
	    };
	    CodeEditor.prototype.getValue = function () {
	        this.editor.getValue();
	    };
	    /**
	     * used to seed the initial search if coming out of hidden
	     */
	    CodeEditor.prototype.getSelectionSearchString = function () {
	        var selection = this.editor.getSelection();
	        if (selection.startLineNumber === selection.endLineNumber) {
	            if (selection.isEmpty()) {
	                var wordAtPosition = this.editor.getModel().getWordAtPosition(selection.getStartPosition());
	                if (wordAtPosition) {
	                    return wordAtPosition.word;
	                }
	            }
	            else {
	                return this.editor.getModel().getValueInRange(selection);
	            }
	        }
	        return undefined;
	    };
	    CodeEditor.prototype.render = function () {
	        var className = 'ReactCodeEditor';
	        if (this.state.isFocused) {
	            className += ' ReactCodeEditor--focused';
	        }
	        var loadingStyle = {
	            position: 'absolute', top: '45%', left: '45%', zIndex: 1,
	            color: '#999',
	            border: '5px solid #999',
	            borderRadius: '5px',
	            fontSize: '2rem',
	            padding: '5px',
	            transition: '.2s opacity',
	            opacity: this.state.loading ? 1 : 0,
	            pointerEvents: 'none',
	        };
	        return (React.createElement("div", { className: className, style: csx.extend(csx.horizontal, csx.flex, { position: 'relative', maxWidth: '100%' }) },
	            !this.props.readOnly && React.createElement(doctor.Doctor, { cm: this.editor, filePath: this.props.filePath }),
	            React.createElement("div", { style: loadingStyle }, "LOADING"),
	            React.createElement("div", { ref: "codeEditor", style: { display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' } }),
	            !this.props.readOnly && React.createElement(semanticView.SemanticView, { editor: this.editor, filePath: this.props.filePath })));
	    };
	    CodeEditor.prototype.componentWillReceiveProps = function (nextProps) {
	        // If next props are getting a preview then old props had them too (based on how we use preview)
	        if (nextProps.preview && nextProps.preview.start !== this.props.preview.start) {
	            this.gotoPreview(nextProps.preview);
	        }
	    };
	    CodeEditor.prototype.gotoPreview = function (preview) {
	        // Re-layout as for preview style editors monaco seems to render faster than CSS 🌹
	        this.editor.layout();
	        var pos = this.editor.getModel().getPositionAt(preview.start);
	        this.editor.revealLineInCenterIfOutsideViewport(pos.lineNumber);
	        this.editor.setPosition(pos);
	    };
	    return CodeEditor;
	}(ui.BaseComponent));
	exports.CodeEditor = CodeEditor;


/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Mutablity helpers
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Shallow Equal and Shallow Compare from
	 * https://github.com/gaearon/react-pure-render/blob/master/src/shallowEqual.js
	 *
	 */
	function shouldComponentUpdate(nextProps, nextState) {
	    return !shallowEqual(this.props, nextProps) ||
	        !shallowEqual(this.state, nextState);
	}
	exports.shouldComponentUpdate = shouldComponentUpdate;
	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	    if (typeof objA !== 'object' || objA === null ||
	        typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.shallowEqual = shallowEqual;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(232),
	    getPrototype = __webpack_require__(234),
	    isObjectLike = __webpack_require__(239);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
	/**
	 * Copyright 2012-2017 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.6.1
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    // Check if mousetrap is used inside browser, if not, return
	    if (!window) {
	        return;
	    }
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	
	        // This needs to use a string cause otherwise since 0 is falsey
	        // mousetrap will never fire for numpad 0 pressed as part of a keydown
	        // event.
	        //
	        // @see https://github.com/ccampbell/mousetrap/pull/258
	        _MAP[i + 96] = i.toString();
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === null || element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * allow custom key mappings
	     */
	    Mousetrap.addKeycodes = function(object) {
	        for (var key in object) {
	            if (object.hasOwnProperty(key)) {
	                _MAP[key] = object[key];
	            }
	        }
	        _REVERSE_MAP = null;
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(38);
	var Danger = __webpack_require__(254);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactInstrumentation = __webpack_require__(22);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(73);
	var setInnerHTML = __webpack_require__(58);
	var setTextContent = __webpack_require__(131);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 65 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactErrorUtils = __webpack_require__(71);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(279);
	var propTypesFactory = __webpack_require__(309);
	
	var React = __webpack_require__(34);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(30);
	var ReactInstanceMap = __webpack_require__(45);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(12);
	
	var ReactCompositeComponent = __webpack_require__(260);
	var ReactEmptyComponent = __webpack_require__(115);
	var ReactHostComponent = __webpack_require__(117);
	
	var getNextDebugID = __webpack_require__(333);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var emptyFunction = __webpack_require__(21);
	var warning = __webpack_require__(8);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(388);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(387);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var csx = __webpack_require__(6);
	var styles_1 = __webpack_require__(10);
	var React = __webpack_require__(2);
	var typestyle = __webpack_require__(13);
	var activeStyle = {
	    backgroundImage: 'linear-gradient(#353434, #7B7B7B)',
	    color: 'white',
	};
	var disabledStyle = {
	    opacity: '.5',
	};
	var buttonBlackClassName = typestyle.style(csx.flexRoot, {
	    fontFamily: 'sans-serif',
	    fontWeight: 'bold',
	    fontSize: '.6rem',
	    transition: '.2s color, .2s opacity',
	    color: styles_1.textColor,
	    padding: '2px 3px',
	    display: 'inline-flex',
	    cursor: 'pointer',
	    backgroundImage: 'linear-gradient(#7B7B7B, #353434)',
	    border: '1px solid #464646',
	    userSelect: 'none',
	    outline: '0px',
	}, {
	    $nest: { '&:active': activeStyle }
	});
	exports.ButtonBlack = function (props) {
	    var style = csx.extend(props.isActive ? activeStyle : {}, props.disabled ? disabledStyle : {});
	    return React.createElement("button", { className: buttonBlackClassName, onClick: props.onClick, style: style, disabled: props.disabled }, props.text);
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * The main dialog
	 */
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var Modal = __webpack_require__(28);
	var styles = __webpack_require__(10);
	var utils_1 = __webpack_require__(3);
	var commands = __webpack_require__(7);
	var typestyle = __webpack_require__(13);
	var inputClassName = typestyle.style(styles.modal.inputStyleBase);
	var InputDialog = /** @class */ (function (_super) {
	    __extends(InputDialog, _super);
	    function InputDialog(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onOk = function () { return null; };
	        _this.onEsc = function () { return null; };
	        _this.handleClose = function () {
	            _this.onEsc();
	            _this.setState({ isOpen: false });
	            _this.clearHandlers();
	        };
	        _this.onChangeFilter = utils_1.debounce(function (e) {
	            var filterValue = _this.refs.mainInput.value;
	            // TODO:
	        }, 50);
	        _this.onChangeSelected = function (e) {
	            if (e.key == 'Enter') {
	                e.preventDefault();
	                _this.onOk(_this.refs.mainInput.value);
	                _this.setState({ isOpen: false });
	                _this.clearHandlers();
	            }
	        };
	        _this.clearHandlers = function () {
	            _this.onEsc = function () { return null; };
	            _this.onOk = function () { return null; };
	        };
	        _this.state = {};
	        return _this;
	    }
	    /**
	     * The main public API from the component
	     */
	    InputDialog.prototype.open = function (options) {
	        var _this = this;
	        this.setState({
	            isOpen: true,
	            header: options.header,
	            hideInput: !!options.hideInput
	        });
	        this.onOk = options.onOk;
	        this.onEsc = options.onEsc;
	        /** When we come here from another modal the input takes a while to load */
	        setTimeout(function () {
	            _this.refs.mainInput.focus();
	            _this.refs.mainInput.value = options.filterValue || '';
	        });
	    };
	    InputDialog.prototype.componentDidMount = function () {
	        var _this = this;
	        /** setup singleton */
	        exports.inputDialog = this;
	        commands.esc.on(function () {
	            _this.handleClose();
	        });
	    };
	    InputDialog.prototype.render = function () {
	        var inputStyle = this.state.hideInput ? { height: '0px', opacity: 0 } : { opacity: 1 };
	        return React.createElement(Modal, { ref: "modal", isOpen: this.state.isOpen, onRequestClose: this.handleClose, 
	            /** We want the modal to be auto fitting in height for this case */
	            style: {
	                content: { bottom: 'auto' }
	            } },
	            React.createElement("div", { style: csx.extend(csx.vertical, csx.flex) },
	                React.createElement("div", { style: csx.horizontal },
	                    React.createElement("h4", null, this.state.header),
	                    React.createElement("div", { style: csx.flex }),
	                    React.createElement("div", { style: { fontSize: '0.9rem', color: 'grey' } },
	                        React.createElement("code", { style: styles.modal.keyStrokeStyle }, "Esc"),
	                        " to exit ",
	                        React.createElement("code", { style: styles.modal.keyStrokeStyle }, "Enter"),
	                        " to commit")),
	                React.createElement("div", { style: csx.extend(styles.padded1TopBottom, csx.vertical) },
	                    React.createElement("input", { type: "text", ref: "mainInput", style: inputStyle, className: inputClassName, onChange: this.onChangeFilter, onKeyDown: this.onChangeSelected }))));
	    };
	    return InputDialog;
	}(ui_1.BaseComponent));
	exports.InputDialog = InputDialog;


/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * From https://github.com/Microsoft/node-jsonc-parser/blob/master/src/main.ts
	 *
	 * Just removed vscode-nls dependency 🌹
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** BAS the function that was provided by vscode-nls */
	var localize = function (a, b) { return b; };
	/**
	 * Rest is copy paste 🌹
	 */
	var ScanError;
	(function (ScanError) {
	    ScanError[ScanError["None"] = 0] = "None";
	    ScanError[ScanError["UnexpectedEndOfComment"] = 1] = "UnexpectedEndOfComment";
	    ScanError[ScanError["UnexpectedEndOfString"] = 2] = "UnexpectedEndOfString";
	    ScanError[ScanError["UnexpectedEndOfNumber"] = 3] = "UnexpectedEndOfNumber";
	    ScanError[ScanError["InvalidUnicode"] = 4] = "InvalidUnicode";
	    ScanError[ScanError["InvalidEscapeCharacter"] = 5] = "InvalidEscapeCharacter";
	})(ScanError = exports.ScanError || (exports.ScanError = {}));
	var SyntaxKind;
	(function (SyntaxKind) {
	    SyntaxKind[SyntaxKind["Unknown"] = 0] = "Unknown";
	    SyntaxKind[SyntaxKind["OpenBraceToken"] = 1] = "OpenBraceToken";
	    SyntaxKind[SyntaxKind["CloseBraceToken"] = 2] = "CloseBraceToken";
	    SyntaxKind[SyntaxKind["OpenBracketToken"] = 3] = "OpenBracketToken";
	    SyntaxKind[SyntaxKind["CloseBracketToken"] = 4] = "CloseBracketToken";
	    SyntaxKind[SyntaxKind["CommaToken"] = 5] = "CommaToken";
	    SyntaxKind[SyntaxKind["ColonToken"] = 6] = "ColonToken";
	    SyntaxKind[SyntaxKind["NullKeyword"] = 7] = "NullKeyword";
	    SyntaxKind[SyntaxKind["TrueKeyword"] = 8] = "TrueKeyword";
	    SyntaxKind[SyntaxKind["FalseKeyword"] = 9] = "FalseKeyword";
	    SyntaxKind[SyntaxKind["StringLiteral"] = 10] = "StringLiteral";
	    SyntaxKind[SyntaxKind["NumericLiteral"] = 11] = "NumericLiteral";
	    SyntaxKind[SyntaxKind["LineCommentTrivia"] = 12] = "LineCommentTrivia";
	    SyntaxKind[SyntaxKind["BlockCommentTrivia"] = 13] = "BlockCommentTrivia";
	    SyntaxKind[SyntaxKind["LineBreakTrivia"] = 14] = "LineBreakTrivia";
	    SyntaxKind[SyntaxKind["Trivia"] = 15] = "Trivia";
	    SyntaxKind[SyntaxKind["EOF"] = 16] = "EOF";
	})(SyntaxKind = exports.SyntaxKind || (exports.SyntaxKind = {}));
	/**
	 * Creates a JSON scanner on the given text.
	 * If ignoreTrivia is set, whitespaces or comments are ignored.
	 */
	function createScanner(text, ignoreTrivia) {
	    if (ignoreTrivia === void 0) { ignoreTrivia = false; }
	    var pos = 0, len = text.length, value = '', tokenOffset = 0, token = SyntaxKind.Unknown, scanError = ScanError.None;
	    function scanHexDigits(count, exact) {
	        var digits = 0;
	        var value = 0;
	        while (digits < count || !exact) {
	            var ch = text.charCodeAt(pos);
	            if (ch >= CharacterCodes._0 && ch <= CharacterCodes._9) {
	                value = value * 16 + ch - CharacterCodes._0;
	            }
	            else if (ch >= CharacterCodes.A && ch <= CharacterCodes.F) {
	                value = value * 16 + ch - CharacterCodes.A + 10;
	            }
	            else if (ch >= CharacterCodes.a && ch <= CharacterCodes.f) {
	                value = value * 16 + ch - CharacterCodes.a + 10;
	            }
	            else {
	                break;
	            }
	            pos++;
	            digits++;
	        }
	        if (digits < count) {
	            value = -1;
	        }
	        return value;
	    }
	    function setPosition(newPosition) {
	        pos = newPosition;
	        value = '';
	        tokenOffset = 0;
	        token = SyntaxKind.Unknown;
	        scanError = ScanError.None;
	    }
	    function scanNumber() {
	        var start = pos;
	        if (text.charCodeAt(pos) === CharacterCodes._0) {
	            pos++;
	        }
	        else {
	            pos++;
	            while (pos < text.length && isDigit(text.charCodeAt(pos))) {
	                pos++;
	            }
	        }
	        if (pos < text.length && text.charCodeAt(pos) === CharacterCodes.dot) {
	            pos++;
	            if (pos < text.length && isDigit(text.charCodeAt(pos))) {
	                pos++;
	                while (pos < text.length && isDigit(text.charCodeAt(pos))) {
	                    pos++;
	                }
	            }
	            else {
	                scanError = ScanError.UnexpectedEndOfNumber;
	                return text.substring(start, pos);
	            }
	        }
	        var end = pos;
	        if (pos < text.length && (text.charCodeAt(pos) === CharacterCodes.E || text.charCodeAt(pos) === CharacterCodes.e)) {
	            pos++;
	            if (pos < text.length && text.charCodeAt(pos) === CharacterCodes.plus || text.charCodeAt(pos) === CharacterCodes.minus) {
	                pos++;
	            }
	            if (pos < text.length && isDigit(text.charCodeAt(pos))) {
	                pos++;
	                while (pos < text.length && isDigit(text.charCodeAt(pos))) {
	                    pos++;
	                }
	                end = pos;
	            }
	            else {
	                scanError = ScanError.UnexpectedEndOfNumber;
	            }
	        }
	        return text.substring(start, end);
	    }
	    function scanString() {
	        var result = '', start = pos;
	        while (true) {
	            if (pos >= len) {
	                result += text.substring(start, pos);
	                scanError = ScanError.UnexpectedEndOfString;
	                break;
	            }
	            var ch = text.charCodeAt(pos);
	            if (ch === CharacterCodes.doubleQuote) {
	                result += text.substring(start, pos);
	                pos++;
	                break;
	            }
	            if (ch === CharacterCodes.backslash) {
	                result += text.substring(start, pos);
	                pos++;
	                if (pos >= len) {
	                    scanError = ScanError.UnexpectedEndOfString;
	                    break;
	                }
	                ch = text.charCodeAt(pos++);
	                switch (ch) {
	                    case CharacterCodes.doubleQuote:
	                        result += '\"';
	                        break;
	                    case CharacterCodes.backslash:
	                        result += '\\';
	                        break;
	                    case CharacterCodes.slash:
	                        result += '/';
	                        break;
	                    case CharacterCodes.b:
	                        result += '\b';
	                        break;
	                    case CharacterCodes.f:
	                        result += '\f';
	                        break;
	                    case CharacterCodes.n:
	                        result += '\n';
	                        break;
	                    case CharacterCodes.r:
	                        result += '\r';
	                        break;
	                    case CharacterCodes.t:
	                        result += '\t';
	                        break;
	                    case CharacterCodes.u:
	                        var ch_1 = scanHexDigits(4, true);
	                        if (ch_1 >= 0) {
	                            result += String.fromCharCode(ch_1);
	                        }
	                        else {
	                            scanError = ScanError.InvalidUnicode;
	                        }
	                        break;
	                    default:
	                        scanError = ScanError.InvalidEscapeCharacter;
	                }
	                start = pos;
	                continue;
	            }
	            if (isLineBreak(ch)) {
	                result += text.substring(start, pos);
	                scanError = ScanError.UnexpectedEndOfString;
	                break;
	            }
	            pos++;
	        }
	        return result;
	    }
	    function scanNext() {
	        value = '';
	        scanError = ScanError.None;
	        tokenOffset = pos;
	        if (pos >= len) {
	            // at the end
	            tokenOffset = len;
	            return token = SyntaxKind.EOF;
	        }
	        var code = text.charCodeAt(pos);
	        // trivia: whitespace
	        if (isWhiteSpace(code)) {
	            do {
	                pos++;
	                value += String.fromCharCode(code);
	                code = text.charCodeAt(pos);
	            } while (isWhiteSpace(code));
	            return token = SyntaxKind.Trivia;
	        }
	        // trivia: newlines
	        if (isLineBreak(code)) {
	            pos++;
	            value += String.fromCharCode(code);
	            if (code === CharacterCodes.carriageReturn && text.charCodeAt(pos) === CharacterCodes.lineFeed) {
	                pos++;
	                value += '\n';
	            }
	            return token = SyntaxKind.LineBreakTrivia;
	        }
	        switch (code) {
	            // tokens: []{}:,
	            case CharacterCodes.openBrace:
	                pos++;
	                return token = SyntaxKind.OpenBraceToken;
	            case CharacterCodes.closeBrace:
	                pos++;
	                return token = SyntaxKind.CloseBraceToken;
	            case CharacterCodes.openBracket:
	                pos++;
	                return token = SyntaxKind.OpenBracketToken;
	            case CharacterCodes.closeBracket:
	                pos++;
	                return token = SyntaxKind.CloseBracketToken;
	            case CharacterCodes.colon:
	                pos++;
	                return token = SyntaxKind.ColonToken;
	            case CharacterCodes.comma:
	                pos++;
	                return token = SyntaxKind.CommaToken;
	            // strings
	            case CharacterCodes.doubleQuote:
	                pos++;
	                value = scanString();
	                return token = SyntaxKind.StringLiteral;
	            // comments
	            case CharacterCodes.slash:
	                var start = pos - 1;
	                // Single-line comment
	                if (text.charCodeAt(pos + 1) === CharacterCodes.slash) {
	                    pos += 2;
	                    while (pos < len) {
	                        if (isLineBreak(text.charCodeAt(pos))) {
	                            break;
	                        }
	                        pos++;
	                    }
	                    value = text.substring(start, pos);
	                    return token = SyntaxKind.LineCommentTrivia;
	                }
	                // Multi-line comment
	                if (text.charCodeAt(pos + 1) === CharacterCodes.asterisk) {
	                    pos += 2;
	                    var safeLength = len - 1; // For lookahead.
	                    var commentClosed = false;
	                    while (pos < safeLength) {
	                        var ch = text.charCodeAt(pos);
	                        if (ch === CharacterCodes.asterisk && text.charCodeAt(pos + 1) === CharacterCodes.slash) {
	                            pos += 2;
	                            commentClosed = true;
	                            break;
	                        }
	                        pos++;
	                    }
	                    if (!commentClosed) {
	                        pos++;
	                        scanError = ScanError.UnexpectedEndOfComment;
	                    }
	                    value = text.substring(start, pos);
	                    return token = SyntaxKind.BlockCommentTrivia;
	                }
	                // just a single slash
	                value += String.fromCharCode(code);
	                pos++;
	                return token = SyntaxKind.Unknown;
	            // numbers
	            case CharacterCodes.minus:
	                value += String.fromCharCode(code);
	                pos++;
	                if (pos === len || !isDigit(text.charCodeAt(pos))) {
	                    return token = SyntaxKind.Unknown;
	                }
	            // found a minus, followed by a number so
	            // we fall through to proceed with scanning
	            // numbers
	            case CharacterCodes._0:
	            case CharacterCodes._1:
	            case CharacterCodes._2:
	            case CharacterCodes._3:
	            case CharacterCodes._4:
	            case CharacterCodes._5:
	            case CharacterCodes._6:
	            case CharacterCodes._7:
	            case CharacterCodes._8:
	            case CharacterCodes._9:
	                value += scanNumber();
	                return token = SyntaxKind.NumericLiteral;
	            // literals and unknown symbols
	            default:
	                // is a literal? Read the full word.
	                while (pos < len && isUnknownContentCharacter(code)) {
	                    pos++;
	                    code = text.charCodeAt(pos);
	                }
	                if (tokenOffset !== pos) {
	                    value = text.substring(tokenOffset, pos);
	                    // keywords: true, false, null
	                    switch (value) {
	                        case 'true': return token = SyntaxKind.TrueKeyword;
	                        case 'false': return token = SyntaxKind.FalseKeyword;
	                        case 'null': return token = SyntaxKind.NullKeyword;
	                    }
	                    return token = SyntaxKind.Unknown;
	                }
	                // some
	                value += String.fromCharCode(code);
	                pos++;
	                return token = SyntaxKind.Unknown;
	        }
	    }
	    function isUnknownContentCharacter(code) {
	        if (isWhiteSpace(code) || isLineBreak(code)) {
	            return false;
	        }
	        switch (code) {
	            case CharacterCodes.closeBrace:
	            case CharacterCodes.closeBracket:
	            case CharacterCodes.openBrace:
	            case CharacterCodes.openBracket:
	            case CharacterCodes.doubleQuote:
	            case CharacterCodes.colon:
	            case CharacterCodes.comma:
	                return false;
	        }
	        return true;
	    }
	    function scanNextNonTrivia() {
	        var result;
	        do {
	            result = scanNext();
	        } while (result >= SyntaxKind.LineCommentTrivia && result <= SyntaxKind.Trivia);
	        return result;
	    }
	    return {
	        setPosition: setPosition,
	        getPosition: function () { return pos; },
	        scan: ignoreTrivia ? scanNextNonTrivia : scanNext,
	        getToken: function () { return token; },
	        getTokenValue: function () { return value; },
	        getTokenOffset: function () { return tokenOffset; },
	        getTokenLength: function () { return pos - tokenOffset; },
	        getTokenError: function () { return scanError; }
	    };
	}
	exports.createScanner = createScanner;
	function isWhiteSpace(ch) {
	    return ch === CharacterCodes.space || ch === CharacterCodes.tab || ch === CharacterCodes.verticalTab || ch === CharacterCodes.formFeed ||
	        ch === CharacterCodes.nonBreakingSpace || ch === CharacterCodes.ogham || ch >= CharacterCodes.enQuad && ch <= CharacterCodes.zeroWidthSpace ||
	        ch === CharacterCodes.narrowNoBreakSpace || ch === CharacterCodes.mathematicalSpace || ch === CharacterCodes.ideographicSpace || ch === CharacterCodes.byteOrderMark;
	}
	function isLineBreak(ch) {
	    return ch === CharacterCodes.lineFeed || ch === CharacterCodes.carriageReturn || ch === CharacterCodes.lineSeparator || ch === CharacterCodes.paragraphSeparator;
	}
	function isDigit(ch) {
	    return ch >= CharacterCodes._0 && ch <= CharacterCodes._9;
	}
	function isLetter(ch) {
	    return ch >= CharacterCodes.a && ch <= CharacterCodes.z || ch >= CharacterCodes.A && ch <= CharacterCodes.Z;
	}
	var CharacterCodes;
	(function (CharacterCodes) {
	    CharacterCodes[CharacterCodes["nullCharacter"] = 0] = "nullCharacter";
	    CharacterCodes[CharacterCodes["maxAsciiCharacter"] = 127] = "maxAsciiCharacter";
	    CharacterCodes[CharacterCodes["lineFeed"] = 10] = "lineFeed";
	    CharacterCodes[CharacterCodes["carriageReturn"] = 13] = "carriageReturn";
	    CharacterCodes[CharacterCodes["lineSeparator"] = 8232] = "lineSeparator";
	    CharacterCodes[CharacterCodes["paragraphSeparator"] = 8233] = "paragraphSeparator";
	    // REVIEW: do we need to support this?  The scanner doesn't, but our IText does.  This seems
	    // like an odd disparity?  (Or maybe it's completely fine for them to be different).
	    CharacterCodes[CharacterCodes["nextLine"] = 133] = "nextLine";
	    // Unicode 3.0 space characters
	    CharacterCodes[CharacterCodes["space"] = 32] = "space";
	    CharacterCodes[CharacterCodes["nonBreakingSpace"] = 160] = "nonBreakingSpace";
	    CharacterCodes[CharacterCodes["enQuad"] = 8192] = "enQuad";
	    CharacterCodes[CharacterCodes["emQuad"] = 8193] = "emQuad";
	    CharacterCodes[CharacterCodes["enSpace"] = 8194] = "enSpace";
	    CharacterCodes[CharacterCodes["emSpace"] = 8195] = "emSpace";
	    CharacterCodes[CharacterCodes["threePerEmSpace"] = 8196] = "threePerEmSpace";
	    CharacterCodes[CharacterCodes["fourPerEmSpace"] = 8197] = "fourPerEmSpace";
	    CharacterCodes[CharacterCodes["sixPerEmSpace"] = 8198] = "sixPerEmSpace";
	    CharacterCodes[CharacterCodes["figureSpace"] = 8199] = "figureSpace";
	    CharacterCodes[CharacterCodes["punctuationSpace"] = 8200] = "punctuationSpace";
	    CharacterCodes[CharacterCodes["thinSpace"] = 8201] = "thinSpace";
	    CharacterCodes[CharacterCodes["hairSpace"] = 8202] = "hairSpace";
	    CharacterCodes[CharacterCodes["zeroWidthSpace"] = 8203] = "zeroWidthSpace";
	    CharacterCodes[CharacterCodes["narrowNoBreakSpace"] = 8239] = "narrowNoBreakSpace";
	    CharacterCodes[CharacterCodes["ideographicSpace"] = 12288] = "ideographicSpace";
	    CharacterCodes[CharacterCodes["mathematicalSpace"] = 8287] = "mathematicalSpace";
	    CharacterCodes[CharacterCodes["ogham"] = 5760] = "ogham";
	    CharacterCodes[CharacterCodes["_"] = 95] = "_";
	    CharacterCodes[CharacterCodes["$"] = 36] = "$";
	    CharacterCodes[CharacterCodes["_0"] = 48] = "_0";
	    CharacterCodes[CharacterCodes["_1"] = 49] = "_1";
	    CharacterCodes[CharacterCodes["_2"] = 50] = "_2";
	    CharacterCodes[CharacterCodes["_3"] = 51] = "_3";
	    CharacterCodes[CharacterCodes["_4"] = 52] = "_4";
	    CharacterCodes[CharacterCodes["_5"] = 53] = "_5";
	    CharacterCodes[CharacterCodes["_6"] = 54] = "_6";
	    CharacterCodes[CharacterCodes["_7"] = 55] = "_7";
	    CharacterCodes[CharacterCodes["_8"] = 56] = "_8";
	    CharacterCodes[CharacterCodes["_9"] = 57] = "_9";
	    CharacterCodes[CharacterCodes["a"] = 97] = "a";
	    CharacterCodes[CharacterCodes["b"] = 98] = "b";
	    CharacterCodes[CharacterCodes["c"] = 99] = "c";
	    CharacterCodes[CharacterCodes["d"] = 100] = "d";
	    CharacterCodes[CharacterCodes["e"] = 101] = "e";
	    CharacterCodes[CharacterCodes["f"] = 102] = "f";
	    CharacterCodes[CharacterCodes["g"] = 103] = "g";
	    CharacterCodes[CharacterCodes["h"] = 104] = "h";
	    CharacterCodes[CharacterCodes["i"] = 105] = "i";
	    CharacterCodes[CharacterCodes["j"] = 106] = "j";
	    CharacterCodes[CharacterCodes["k"] = 107] = "k";
	    CharacterCodes[CharacterCodes["l"] = 108] = "l";
	    CharacterCodes[CharacterCodes["m"] = 109] = "m";
	    CharacterCodes[CharacterCodes["n"] = 110] = "n";
	    CharacterCodes[CharacterCodes["o"] = 111] = "o";
	    CharacterCodes[CharacterCodes["p"] = 112] = "p";
	    CharacterCodes[CharacterCodes["q"] = 113] = "q";
	    CharacterCodes[CharacterCodes["r"] = 114] = "r";
	    CharacterCodes[CharacterCodes["s"] = 115] = "s";
	    CharacterCodes[CharacterCodes["t"] = 116] = "t";
	    CharacterCodes[CharacterCodes["u"] = 117] = "u";
	    CharacterCodes[CharacterCodes["v"] = 118] = "v";
	    CharacterCodes[CharacterCodes["w"] = 119] = "w";
	    CharacterCodes[CharacterCodes["x"] = 120] = "x";
	    CharacterCodes[CharacterCodes["y"] = 121] = "y";
	    CharacterCodes[CharacterCodes["z"] = 122] = "z";
	    CharacterCodes[CharacterCodes["A"] = 65] = "A";
	    CharacterCodes[CharacterCodes["B"] = 66] = "B";
	    CharacterCodes[CharacterCodes["C"] = 67] = "C";
	    CharacterCodes[CharacterCodes["D"] = 68] = "D";
	    CharacterCodes[CharacterCodes["E"] = 69] = "E";
	    CharacterCodes[CharacterCodes["F"] = 70] = "F";
	    CharacterCodes[CharacterCodes["G"] = 71] = "G";
	    CharacterCodes[CharacterCodes["H"] = 72] = "H";
	    CharacterCodes[CharacterCodes["I"] = 73] = "I";
	    CharacterCodes[CharacterCodes["J"] = 74] = "J";
	    CharacterCodes[CharacterCodes["K"] = 75] = "K";
	    CharacterCodes[CharacterCodes["L"] = 76] = "L";
	    CharacterCodes[CharacterCodes["M"] = 77] = "M";
	    CharacterCodes[CharacterCodes["N"] = 78] = "N";
	    CharacterCodes[CharacterCodes["O"] = 79] = "O";
	    CharacterCodes[CharacterCodes["P"] = 80] = "P";
	    CharacterCodes[CharacterCodes["Q"] = 81] = "Q";
	    CharacterCodes[CharacterCodes["R"] = 82] = "R";
	    CharacterCodes[CharacterCodes["S"] = 83] = "S";
	    CharacterCodes[CharacterCodes["T"] = 84] = "T";
	    CharacterCodes[CharacterCodes["U"] = 85] = "U";
	    CharacterCodes[CharacterCodes["V"] = 86] = "V";
	    CharacterCodes[CharacterCodes["W"] = 87] = "W";
	    CharacterCodes[CharacterCodes["X"] = 88] = "X";
	    CharacterCodes[CharacterCodes["Y"] = 89] = "Y";
	    CharacterCodes[CharacterCodes["Z"] = 90] = "Z";
	    CharacterCodes[CharacterCodes["ampersand"] = 38] = "ampersand";
	    CharacterCodes[CharacterCodes["asterisk"] = 42] = "asterisk";
	    CharacterCodes[CharacterCodes["at"] = 64] = "at";
	    CharacterCodes[CharacterCodes["backslash"] = 92] = "backslash";
	    CharacterCodes[CharacterCodes["bar"] = 124] = "bar";
	    CharacterCodes[CharacterCodes["caret"] = 94] = "caret";
	    CharacterCodes[CharacterCodes["closeBrace"] = 125] = "closeBrace";
	    CharacterCodes[CharacterCodes["closeBracket"] = 93] = "closeBracket";
	    CharacterCodes[CharacterCodes["closeParen"] = 41] = "closeParen";
	    CharacterCodes[CharacterCodes["colon"] = 58] = "colon";
	    CharacterCodes[CharacterCodes["comma"] = 44] = "comma";
	    CharacterCodes[CharacterCodes["dot"] = 46] = "dot";
	    CharacterCodes[CharacterCodes["doubleQuote"] = 34] = "doubleQuote";
	    CharacterCodes[CharacterCodes["equals"] = 61] = "equals";
	    CharacterCodes[CharacterCodes["exclamation"] = 33] = "exclamation";
	    CharacterCodes[CharacterCodes["greaterThan"] = 62] = "greaterThan";
	    CharacterCodes[CharacterCodes["lessThan"] = 60] = "lessThan";
	    CharacterCodes[CharacterCodes["minus"] = 45] = "minus";
	    CharacterCodes[CharacterCodes["openBrace"] = 123] = "openBrace";
	    CharacterCodes[CharacterCodes["openBracket"] = 91] = "openBracket";
	    CharacterCodes[CharacterCodes["openParen"] = 40] = "openParen";
	    CharacterCodes[CharacterCodes["percent"] = 37] = "percent";
	    CharacterCodes[CharacterCodes["plus"] = 43] = "plus";
	    CharacterCodes[CharacterCodes["question"] = 63] = "question";
	    CharacterCodes[CharacterCodes["semicolon"] = 59] = "semicolon";
	    CharacterCodes[CharacterCodes["singleQuote"] = 39] = "singleQuote";
	    CharacterCodes[CharacterCodes["slash"] = 47] = "slash";
	    CharacterCodes[CharacterCodes["tilde"] = 126] = "tilde";
	    CharacterCodes[CharacterCodes["backspace"] = 8] = "backspace";
	    CharacterCodes[CharacterCodes["formFeed"] = 12] = "formFeed";
	    CharacterCodes[CharacterCodes["byteOrderMark"] = 65279] = "byteOrderMark";
	    CharacterCodes[CharacterCodes["tab"] = 9] = "tab";
	    CharacterCodes[CharacterCodes["verticalTab"] = 11] = "verticalTab";
	})(CharacterCodes || (CharacterCodes = {}));
	/**
	 * Takes JSON with JavaScript-style comments and remove
	 * them. Optionally replaces every none-newline character
	 * of comments with a replaceCharacter
	 */
	function stripComments(text, replaceCh) {
	    var _scanner = createScanner(text), parts = [], kind, offset = 0, pos;
	    do {
	        pos = _scanner.getPosition();
	        kind = _scanner.scan();
	        switch (kind) {
	            case SyntaxKind.LineCommentTrivia:
	            case SyntaxKind.BlockCommentTrivia:
	            case SyntaxKind.EOF:
	                if (offset !== pos) {
	                    parts.push(text.substring(offset, pos));
	                }
	                if (replaceCh !== void 0) {
	                    parts.push(_scanner.getTokenValue().replace(/[^\r\n]/g, replaceCh));
	                }
	                offset = _scanner.getPosition();
	                break;
	        }
	    } while (kind !== SyntaxKind.EOF);
	    return parts.join('');
	}
	exports.stripComments = stripComments;
	var ParseErrorCode;
	(function (ParseErrorCode) {
	    ParseErrorCode[ParseErrorCode["InvalidSymbol"] = 0] = "InvalidSymbol";
	    ParseErrorCode[ParseErrorCode["InvalidNumberFormat"] = 1] = "InvalidNumberFormat";
	    ParseErrorCode[ParseErrorCode["PropertyNameExpected"] = 2] = "PropertyNameExpected";
	    ParseErrorCode[ParseErrorCode["ValueExpected"] = 3] = "ValueExpected";
	    ParseErrorCode[ParseErrorCode["ColonExpected"] = 4] = "ColonExpected";
	    ParseErrorCode[ParseErrorCode["CommaExpected"] = 5] = "CommaExpected";
	    ParseErrorCode[ParseErrorCode["CloseBraceExpected"] = 6] = "CloseBraceExpected";
	    ParseErrorCode[ParseErrorCode["CloseBracketExpected"] = 7] = "CloseBracketExpected";
	    ParseErrorCode[ParseErrorCode["EndOfFileExpected"] = 8] = "EndOfFileExpected";
	})(ParseErrorCode = exports.ParseErrorCode || (exports.ParseErrorCode = {}));
	function getParseErrorMessage(errorCode) {
	    switch (errorCode) {
	        case ParseErrorCode.InvalidSymbol: return localize('error.invalidSymbol', 'Invalid symbol');
	        case ParseErrorCode.InvalidNumberFormat: return localize('error.invalidNumberFormat', 'Invalid number format');
	        case ParseErrorCode.PropertyNameExpected: return localize('error.propertyNameExpected', 'Property name expected');
	        case ParseErrorCode.ValueExpected: return localize('error.valueExpected', 'Value expected');
	        case ParseErrorCode.ColonExpected: return localize('error.colonExpected', 'Colon expected');
	        case ParseErrorCode.CommaExpected: return localize('error.commaExpected', 'Comma expected');
	        case ParseErrorCode.CloseBraceExpected: return localize('error.closeBraceExpected', 'Closing brace expected');
	        case ParseErrorCode.CloseBracketExpected: return localize('error.closeBracketExpected', 'Closing bracket expected');
	        case ParseErrorCode.EndOfFileExpected: return localize('error.endOfFileExpected', 'End of file expected');
	        default:
	            return '';
	    }
	}
	exports.getParseErrorMessage = getParseErrorMessage;
	/**
	 * For a given offset, evaluate the location in the JSON document. Each segment in a location is either a property names or an array accessors.
	 */
	function getLocation(text, position) {
	    var segments = [];
	    var earlyReturnException = new Object();
	    var previousNode = void 0;
	    var previousNodeInst = {
	        value: void 0,
	        offset: void 0,
	        length: void 0,
	        type: void 0
	    };
	    var completeProperty = false;
	    var hasComma = false;
	    function setPreviousNode(value, offset, length, type) {
	        previousNodeInst.value = value;
	        previousNodeInst.offset = offset;
	        previousNodeInst.length = length;
	        previousNodeInst.type = type;
	        previousNodeInst.columnOffset = void 0;
	        previousNode = previousNodeInst;
	    }
	    try {
	        visit(text, {
	            onObjectBegin: function (offset, length) {
	                if (position <= offset) {
	                    throw earlyReturnException;
	                }
	                previousNode = void 0;
	                completeProperty = position > offset;
	                hasComma = false;
	            },
	            onObjectProperty: function (name, offset, length) {
	                if (position < offset) {
	                    throw earlyReturnException;
	                }
	                setPreviousNode(name, offset, length, 'property');
	                hasComma = false;
	                segments.push(name);
	                if (position <= offset + length) {
	                    throw earlyReturnException;
	                }
	            },
	            onObjectEnd: function (offset, length) {
	                if (position <= offset) {
	                    throw earlyReturnException;
	                }
	                previousNode = void 0;
	                if (!hasComma) {
	                    segments.pop();
	                }
	                hasComma = false;
	            },
	            onArrayBegin: function (offset, length) {
	                if (position <= offset) {
	                    throw earlyReturnException;
	                }
	                previousNode = void 0;
	                segments.push('[0]');
	                hasComma = false;
	            },
	            onArrayEnd: function (offset, length) {
	                if (position <= offset) {
	                    throw earlyReturnException;
	                }
	                previousNode = void 0;
	                if (!hasComma) {
	                    segments.pop();
	                }
	                hasComma = false;
	            },
	            onLiteralValue: function (value, offset, length) {
	                if (position < offset) {
	                    throw earlyReturnException;
	                }
	                setPreviousNode(value, offset, length, value === null ? 'null' : (typeof value === 'string' ? 'string' : 'number'));
	                if (position <= offset + length) {
	                    throw earlyReturnException;
	                }
	            },
	            onSeparator: function (sep, offset, length) {
	                if (position <= offset) {
	                    throw earlyReturnException;
	                }
	                if (sep === ':' && previousNode.type === 'property') {
	                    previousNode.columnOffset = offset;
	                    completeProperty = false;
	                    previousNode = void 0;
	                }
	                else if (sep === ',') {
	                    var last = segments.pop();
	                    if (last[0] === '[' && last[last.length - 1] === ']') {
	                        segments.push('[' + (parseInt(last.substr(1, last.length - 2)) + 1) + ']');
	                    }
	                    else {
	                        completeProperty = true;
	                    }
	                    previousNode = void 0;
	                    hasComma = true;
	                }
	            }
	        });
	    }
	    catch (e) {
	        if (e !== earlyReturnException) {
	            throw e;
	        }
	    }
	    return {
	        segments: segments,
	        previousNode: previousNode,
	        completeProperty: completeProperty,
	        matches: function (pattern) {
	            var k = 0;
	            for (var i = 0; k < pattern.length && i < segments.length; i++) {
	                if (pattern[k] === segments[i] || pattern[k] === '*') {
	                    k++;
	                }
	                else if (pattern[k] !== '**') {
	                    return false;
	                }
	            }
	            return k === pattern.length;
	        }
	    };
	}
	exports.getLocation = getLocation;
	/**
	 * Parses the given text and returns the object the JSON content represents. On invalid input, the parser tries to be as fault lolerant as possible, but still return a result.
	 * Therefore always check the errors list to find out if the input was valid.
	 */
	function parse(text, errors, options) {
	    if (errors === void 0) { errors = []; }
	    var currentProperty = null;
	    var currentParent = [];
	    var previousParents = [];
	    function onValue(value) {
	        if (Array.isArray(currentParent)) {
	            currentParent.push(value);
	        }
	        else if (currentProperty) {
	            currentParent[currentProperty] = value;
	        }
	    }
	    var visitor = {
	        onObjectBegin: function () {
	            var object = {};
	            onValue(object);
	            previousParents.push(currentParent);
	            currentParent = object;
	            currentProperty = null;
	        },
	        onObjectProperty: function (name) {
	            currentProperty = name;
	        },
	        onObjectEnd: function () {
	            currentParent = previousParents.pop();
	        },
	        onArrayBegin: function () {
	            var array = [];
	            onValue(array);
	            previousParents.push(currentParent);
	            currentParent = array;
	            currentProperty = null;
	        },
	        onArrayEnd: function () {
	            currentParent = previousParents.pop();
	        },
	        onLiteralValue: onValue,
	        onError: function (error) {
	            errors.push({ error: error });
	        }
	    };
	    visit(text, visitor, options);
	    return currentParent[0];
	}
	exports.parse = parse;
	/**
	 * Parses the given text and invokes the visitor functions for each object, array and literal reached.
	 */
	function visit(text, visitor, options) {
	    var _scanner = createScanner(text, false);
	    function toNoArgVisit(visitFunction) {
	        return visitFunction ? function () { return visitFunction(_scanner.getTokenOffset(), _scanner.getTokenLength()); } : function () { return true; };
	    }
	    function toOneArgVisit(visitFunction) {
	        return visitFunction ? function (arg) { return visitFunction(arg, _scanner.getTokenOffset(), _scanner.getTokenLength()); } : function () { return true; };
	    }
	    var onObjectBegin = toNoArgVisit(visitor.onObjectBegin), onObjectProperty = toOneArgVisit(visitor.onObjectProperty), onObjectEnd = toNoArgVisit(visitor.onObjectEnd), onArrayBegin = toNoArgVisit(visitor.onArrayBegin), onArrayEnd = toNoArgVisit(visitor.onArrayEnd), onLiteralValue = toOneArgVisit(visitor.onLiteralValue), onSeparator = toOneArgVisit(visitor.onSeparator), onError = toOneArgVisit(visitor.onError);
	    var disallowComments = options && options.disallowComments;
	    function scanNext() {
	        while (true) {
	            var token = _scanner.scan();
	            switch (token) {
	                case SyntaxKind.LineCommentTrivia:
	                case SyntaxKind.BlockCommentTrivia:
	                    if (disallowComments) {
	                        handleError(ParseErrorCode.InvalidSymbol);
	                    }
	                    break;
	                case SyntaxKind.Unknown:
	                    handleError(ParseErrorCode.InvalidSymbol);
	                    break;
	                case SyntaxKind.Trivia:
	                case SyntaxKind.LineBreakTrivia:
	                    break;
	                default:
	                    return token;
	            }
	        }
	    }
	    function handleError(error, skipUntilAfter, skipUntil) {
	        if (skipUntilAfter === void 0) { skipUntilAfter = []; }
	        if (skipUntil === void 0) { skipUntil = []; }
	        onError(error);
	        if (skipUntilAfter.length + skipUntil.length > 0) {
	            var token = _scanner.getToken();
	            while (token !== SyntaxKind.EOF) {
	                if (skipUntilAfter.indexOf(token) !== -1) {
	                    scanNext();
	                    break;
	                }
	                else if (skipUntil.indexOf(token) !== -1) {
	                    break;
	                }
	                token = scanNext();
	            }
	        }
	    }
	    function parseString(isValue) {
	        if (_scanner.getToken() !== SyntaxKind.StringLiteral) {
	            return false;
	        }
	        var value = _scanner.getTokenValue();
	        if (isValue) {
	            onLiteralValue(value);
	        }
	        else {
	            onObjectProperty(value);
	        }
	        scanNext();
	        return true;
	    }
	    function parseLiteral() {
	        switch (_scanner.getToken()) {
	            case SyntaxKind.NumericLiteral:
	                var value = 0;
	                try {
	                    value = JSON.parse(_scanner.getTokenValue());
	                    if (typeof value !== 'number') {
	                        handleError(ParseErrorCode.InvalidNumberFormat);
	                        value = 0;
	                    }
	                }
	                catch (e) {
	                    handleError(ParseErrorCode.InvalidNumberFormat);
	                }
	                onLiteralValue(value);
	                break;
	            case SyntaxKind.NullKeyword:
	                onLiteralValue(null);
	                break;
	            case SyntaxKind.TrueKeyword:
	                onLiteralValue(true);
	                break;
	            case SyntaxKind.FalseKeyword:
	                onLiteralValue(false);
	                break;
	            default:
	                return false;
	        }
	        scanNext();
	        return true;
	    }
	    function parseProperty() {
	        if (!parseString(false)) {
	            handleError(ParseErrorCode.PropertyNameExpected, [], [SyntaxKind.CloseBraceToken, SyntaxKind.CommaToken]);
	            return false;
	        }
	        if (_scanner.getToken() === SyntaxKind.ColonToken) {
	            onSeparator(':');
	            scanNext(); // consume colon
	            if (!parseValue()) {
	                handleError(ParseErrorCode.ValueExpected, [], [SyntaxKind.CloseBraceToken, SyntaxKind.CommaToken]);
	            }
	        }
	        else {
	            handleError(ParseErrorCode.ColonExpected, [], [SyntaxKind.CloseBraceToken, SyntaxKind.CommaToken]);
	        }
	        return true;
	    }
	    function parseObject() {
	        if (_scanner.getToken() !== SyntaxKind.OpenBraceToken) {
	            return false;
	        }
	        onObjectBegin();
	        scanNext(); // consume open brace
	        var needsComma = false;
	        while (_scanner.getToken() !== SyntaxKind.CloseBraceToken && _scanner.getToken() !== SyntaxKind.EOF) {
	            if (_scanner.getToken() === SyntaxKind.CommaToken) {
	                if (!needsComma) {
	                    handleError(ParseErrorCode.ValueExpected, [], []);
	                }
	                onSeparator(',');
	                scanNext(); // consume comma
	            }
	            else if (needsComma) {
	                handleError(ParseErrorCode.CommaExpected, [], []);
	            }
	            if (!parseProperty()) {
	                handleError(ParseErrorCode.ValueExpected, [], [SyntaxKind.CloseBraceToken, SyntaxKind.CommaToken]);
	            }
	            needsComma = true;
	        }
	        onObjectEnd();
	        if (_scanner.getToken() !== SyntaxKind.CloseBraceToken) {
	            handleError(ParseErrorCode.CloseBraceExpected, [SyntaxKind.CloseBraceToken], []);
	        }
	        else {
	            scanNext(); // consume close brace
	        }
	        return true;
	    }
	    function parseArray() {
	        if (_scanner.getToken() !== SyntaxKind.OpenBracketToken) {
	            return false;
	        }
	        onArrayBegin();
	        scanNext(); // consume open bracket
	        var needsComma = false;
	        while (_scanner.getToken() !== SyntaxKind.CloseBracketToken && _scanner.getToken() !== SyntaxKind.EOF) {
	            if (_scanner.getToken() === SyntaxKind.CommaToken) {
	                if (!needsComma) {
	                    handleError(ParseErrorCode.ValueExpected, [], []);
	                }
	                onSeparator(',');
	                scanNext(); // consume comma
	            }
	            else if (needsComma) {
	                handleError(ParseErrorCode.CommaExpected, [], []);
	            }
	            if (!parseValue()) {
	                handleError(ParseErrorCode.ValueExpected, [], [SyntaxKind.CloseBracketToken, SyntaxKind.CommaToken]);
	            }
	            needsComma = true;
	        }
	        onArrayEnd();
	        if (_scanner.getToken() !== SyntaxKind.CloseBracketToken) {
	            handleError(ParseErrorCode.CloseBracketExpected, [SyntaxKind.CloseBracketToken], []);
	        }
	        else {
	            scanNext(); // consume close bracket
	        }
	        return true;
	    }
	    function parseValue() {
	        return parseArray() || parseObject() || parseString(true) || parseLiteral();
	    }
	    scanNext();
	    if (!parseValue()) {
	        handleError(ParseErrorCode.ValueExpected, [], []);
	        return false;
	    }
	    if (_scanner.getToken() !== SyntaxKind.EOF) {
	        handleError(ParseErrorCode.EndOfFileExpected, [], []);
	    }
	    return true;
	}
	exports.visit = visit;


/***/ },
/* 85 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	  * Basic placeholder based formatting like C# string.Format
	  * ('{0} says {1}','la','ba' ) => 'la says ba'
	  */
	function format(str) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    return str.replace(/{(\d+)}/g, function (m, i) {
	        return args[i] !== undefined ? args[i].toString() : m;
	    });
	}
	exports.format = format;
	function localize(key, str) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    return format.apply(void 0, [str].concat(args));
	}
	exports.localize = localize;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lsh = __webpack_require__(470);
	var languageServiceHost = new lsh.LanguageServiceHost(undefined);
	var languageService = ts.createLanguageService(languageServiceHost);
	/**
	 * ts syntax highlighter doesn't handle bom correctly so fix that
	 */
	var BOM_CHAR_CODE = 65279;
	var hasBom = Object.create(null);
	function addFile(filePath, contents) {
	    hasBom[filePath] = contents.charCodeAt(0) === BOM_CHAR_CODE;
	    languageServiceHost.addScript(filePath, contents);
	}
	exports.addFile = addFile;
	function removeFile(filePath) {
	    languageServiceHost.removeFile(filePath);
	}
	exports.removeFile = removeFile;
	function editFile(filePath, codeEdit) {
	    languageServiceHost.applyCodeEdit(filePath, codeEdit.from, codeEdit.to, codeEdit.newText);
	}
	exports.editFile = editFile;
	function setContents(filePath, contents) {
	    hasBom[filePath] = contents.charCodeAt(0) === BOM_CHAR_CODE;
	    languageServiceHost.setContents(filePath, contents);
	}
	exports.setContents = setContents;
	function getLineAndCharacterOfPosition(filePath, pos) {
	    return languageServiceHost.getLineAndCharacterOfPosition(filePath, pos);
	}
	exports.getLineAndCharacterOfPosition = getLineAndCharacterOfPosition;
	function getPositionOfLineAndCharacter(filePath, line, ch) {
	    return languageServiceHost.getPositionOfLineAndCharacter(filePath, line, ch);
	}
	exports.getPositionOfLineAndCharacter = getPositionOfLineAndCharacter;
	function getSourceFile(filePath) {
	    return languageService.getNonBoundSourceFile(filePath);
	}
	exports.getSourceFile = getSourceFile;
	function getClassificationsForLine(filePath, lineStart, string) {
	    var offsetForBom = hasBom[filePath] ? -1 : 0;
	    // don't need this for monaco!
	    /**
	     * Protect against code mirror optimized rendering.
	     * If string does not match expected line contents tokenize as whitespace till the precise call is made.
	     */
	    // const trueLineContents = languageService.getNonBoundSourceFile(filePath).text.substr(lineStart);
	    // if (!trueLineContents.startsWith(string)){
	    //     // console.log({ trueLineContents, string, filePath }); // DEBUG
	    //     const cantDoIt = [{
	    //         textSpan: {
	    //             start:0,
	    //             length: string.length
	    //         },
	    //         startInLine: 0,
	    //         string,
	    //         classificationType: ts.ClassificationType.whiteSpace,
	    //         classificationTypeName: ClassificationTypeNames.whiteSpace,
	    //     }];
	    //     return cantDoIt;
	    // }
	    var lineLength = string.length;
	    var encodedClassifications = languageService.getEncodedSyntacticClassifications(filePath, { start: lineStart, length: lineLength });
	    var classifications = unencodeClassifications(encodedClassifications);
	    /** for some reason we have dupes on first token sometimes. this helps remove them */
	    var lastStartSet = false;
	    var lastStart = 0;
	    // Trim to the query region
	    classifications = classifications
	        .map(function (c, i) {
	        // Compensate each token for bom
	        c.textSpan.start += offsetForBom;
	        // completely outside the range on the left
	        if ((c.textSpan.start + c.textSpan.length) <= lineStart) {
	            return null;
	        }
	        // completely outside the range on the right
	        if (c.textSpan.start > (lineStart + lineLength)) {
	            return null;
	        }
	        // trim the left
	        if (c.textSpan.start < lineStart) {
	            c.textSpan.length = c.textSpan.start + c.textSpan.length - lineStart;
	            c.textSpan.start = lineStart;
	        }
	        // trim the right
	        if ((c.textSpan.start + c.textSpan.length) > (lineStart + lineLength)) {
	            c.textSpan.length = (lineStart + lineLength) - (c.textSpan.start);
	        }
	        // dedupe...first token only
	        if (!lastStartSet) {
	            lastStartSet = true;
	            lastStart = c.textSpan.start;
	        }
	        else {
	            if (c.textSpan.start == lastStart) {
	                return null;
	            }
	        }
	        return c;
	    })
	        .filter(function (c) { return !!c; });
	    // Add a string for easier debugging + startInLine for creating a 'map' of positions later on
	    classifications.forEach(function (c) {
	        c.startInLine = c.textSpan.start - lineStart;
	        c.string = string.substr(c.startInLine, c.textSpan.length);
	    });
	    return classifications;
	}
	exports.getClassificationsForLine = getClassificationsForLine;
	function getIndentationAtPosition(filePath, lineStart, options) {
	    return languageService.getIndentationAtPosition(filePath, lineStart, options);
	}
	exports.getIndentationAtPosition = getIndentationAtPosition;
	function getFormattingEditsAfterKeystroke(filePath, position, key, options) {
	    return languageService.getFormattingEditsAfterKeystroke(filePath, position, key, options);
	}
	exports.getFormattingEditsAfterKeystroke = getFormattingEditsAfterKeystroke;
	/**
	 * ported from services.ts convertClassifications
	 * encoding is [[start,lenght,type]......]
	 * also added whitespace support
	 */
	function unencodeClassifications(classifications) {
	    var dense = classifications.spans;
	    var result = [];
	    var expectedStart = 0; // used for whitespace
	    for (var i = 0, n = dense.length; i < n; i += 3) {
	        if (dense[i] > expectedStart) {
	            result.push({
	                textSpan: ts.createTextSpan(expectedStart, dense[i] - expectedStart),
	                classificationType: ts.ClassificationType.whiteSpace,
	                classificationTypeName: ts.ClassificationTypeNames.whiteSpace,
	            });
	        }
	        result.push({
	            textSpan: ts.createTextSpan(dense[i], dense[i + 1]),
	            classificationType: dense[i + 2],
	            classificationTypeName: getClassificationTypeName(dense[i + 2]),
	        });
	        expectedStart = dense[i] + dense[i + 1];
	    }
	    return result;
	}
	/** brought in as it is */
	var ClassificationType = ts.ClassificationType;
	var ClassificationTypeNames = ts.ClassificationTypeNames;
	function getClassificationTypeName(type) {
	    switch (type) {
	        case ClassificationType.comment: return ClassificationTypeNames.comment;
	        case ClassificationType.identifier: return ClassificationTypeNames.identifier;
	        case ClassificationType.keyword: return ClassificationTypeNames.keyword;
	        case ClassificationType.numericLiteral: return ClassificationTypeNames.numericLiteral;
	        case ClassificationType.operator: return ClassificationTypeNames.operator;
	        case ClassificationType.stringLiteral: return ClassificationTypeNames.stringLiteral;
	        case ClassificationType.whiteSpace: return ClassificationTypeNames.whiteSpace;
	        case ClassificationType.text: return ClassificationTypeNames.text;
	        case ClassificationType.punctuation: return ClassificationTypeNames.punctuation;
	        case ClassificationType.className: return ClassificationTypeNames.className;
	        case ClassificationType.enumName: return ClassificationTypeNames.enumName;
	        case ClassificationType.interfaceName: return ClassificationTypeNames.interfaceName;
	        case ClassificationType.moduleName: return ClassificationTypeNames.moduleName;
	        case ClassificationType.typeParameterName: return ClassificationTypeNames.typeParameterName;
	        case ClassificationType.typeAliasName: return ClassificationTypeNames.typeAliasName;
	        case ClassificationType.parameterName: return ClassificationTypeNames.parameterName;
	        case ClassificationType.docCommentTagName: return ClassificationTypeNames.docCommentTagName;
	        case ClassificationType.jsxOpenTagName: return ClassificationTypeNames.jsxOpenTagName;
	        case ClassificationType.jsxCloseTagName: return ClassificationTypeNames.jsxCloseTagName;
	        case ClassificationType.jsxSelfClosingTagName: return ClassificationTypeNames.jsxSelfClosingTagName;
	    }
	}


/***/ },
/* 87 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Gets / sets the client session id using the url
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getSessionId = function () { return window.location.hash.substr(1); };
	exports.setSessionId = function (sessionId) {
	    // http://stackoverflow.com/questions/12381563/how-to-stop-browser-back-button-using-javascript
	    var hash = '#' + sessionId;
	    window.location.hash = hash;
	    window.location.hash = "Again-No-back-button"; // again because google chrome don't insert first hash into history
	    window.location.hash = hash;
	    window.onhashchange = function () { window.location.hash = hash; };
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Just provides a nice *type* over the simple transient settings
	 */
	var socketClient_1 = __webpack_require__(5);
	var clientSession_1 = __webpack_require__(87);
	function setSetting(key, value) {
	    socketClient_1.server.setSetting({
	        sessionId: clientSession_1.getSessionId(),
	        settingId: key,
	        value: value
	    });
	}
	function getSetting(key) {
	    return socketClient_1.server.getSetting({
	        sessionId: clientSession_1.getSessionId(),
	        settingId: key
	    });
	}
	function createSimpleSetting(key) {
	    return {
	        set: function (value) {
	            setSetting(key, value);
	        },
	        get: function () {
	            return getSetting(key);
	        }
	    };
	}
	/**
	 * DOCTOR
	 */
	exports.showDoctor = createSimpleSetting('showDoctor');
	/**
	 * Semantic View
	 */
	exports.showSemanticView = createSimpleSetting('showSemanticView');
	/**
	 * Errors expanded
	 */
	exports.errorsExpanded = createSimpleSetting('errorsExpanded');
	/**
	 * Errors Display Mode
	 */
	exports.errorsDisplayMode = createSimpleSetting('errorsDisplayMode');
	/**
	 * File Tree expanded
	 */
	exports.fileTreeExpanded = createSimpleSetting('fileTreeExpanded');
	/**
	 * File Tree width
	 */
	exports.fileTreeWidth = createSimpleSetting('fileTreeWidth');
	/**
	 * Main panel height
	 */
	exports.mainPanelHeight = createSimpleSetting('mainPanelHeight');


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(342)
	
	var md5 = toConstructor(__webpack_require__(174))
	var rmd160 = toConstructor(__webpack_require__(340))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(200);
	var isArguments = __webpack_require__(199);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(21);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 93 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * Increment through IDs for FreeStyle, which can't generate hashed IDs.
	 */
	var instanceId = 0;
	/**
	 * The unique id is used to get a unique hash on styles (no merging).
	 */
	var uniqueId = 0;
	/**
	 * Tag styles with this string to get unique hash outputs.
	 */
	exports.IS_UNIQUE = '__DO_NOT_DEDUPE_STYLE__';
	/**
	 * CSS properties that are valid unit-less numbers.
	 */
	var CSS_NUMBER = {
	    'animation-iteration-count': true,
	    'box-flex': true,
	    'box-flex-group': true,
	    'column-count': true,
	    'counter-increment': true,
	    'counter-reset': true,
	    'flex': true,
	    'flex-grow': true,
	    'flex-positive': true,
	    'flex-shrink': true,
	    'flex-negative': true,
	    'font-weight': true,
	    'line-clamp': true,
	    'line-height': true,
	    'opacity': true,
	    'order': true,
	    'orphans': true,
	    'tab-size': true,
	    'widows': true,
	    'z-index': true,
	    'zoom': true,
	    // SVG properties.
	    'fill-opacity': true,
	    'stroke-dashoffset': true,
	    'stroke-opacity': true,
	    'stroke-width': true
	};
	// Add vendor prefixes to all unit-less properties.
	for (var _i = 0, _a = ['-webkit-', '-ms-', '-moz-', '-o-']; _i < _a.length; _i++) {
	    var prefix = _a[_i];
	    for (var _b = 0, _c = Object.keys(CSS_NUMBER); _b < _c.length; _b++) {
	        var property = _c[_b];
	        CSS_NUMBER[prefix + property] = true;
	    }
	}
	/**
	 * Transform a JavaScript property into a CSS property.
	 */
	function hyphenate(propertyName) {
	    return propertyName
	        .replace(/([A-Z])/g, '-$1')
	        .replace(/^ms-/, '-ms-') // Internet Explorer vendor prefix.
	        .toLowerCase();
	}
	/**
	 * Check if a property name should pop to the top level of CSS.
	 */
	function isAtRule(propertyName) {
	    return propertyName.charAt(0) === '@';
	}
	/**
	 * Check if a value is a nested style definition.
	 */
	function isNestedStyle(value) {
	    return value != null && typeof value === 'object' && !Array.isArray(value);
	}
	/**
	 * Generate a hash value from a string.
	 */
	function stringHash(str) {
	    var value = 5381;
	    var i = str.length;
	    while (i) {
	        value = (value * 33) ^ str.charCodeAt(--i);
	    }
	    return (value >>> 0).toString(36);
	}
	exports.stringHash = stringHash;
	/**
	 * Transform a style string to a CSS string.
	 */
	function styleToString(name, value) {
	    if (typeof value === 'number' && value !== 0 && !CSS_NUMBER[name]) {
	        value = value + "px";
	    }
	    return name + ":" + String(value).replace(/([\{\}\[\]])/g, '\\$1');
	}
	/**
	 * Sort an array of tuples by first value.
	 */
	function sortTuples(value) {
	    return value.sort(function (a, b) { return a[0] > b[0] ? 1 : -1; });
	}
	/**
	 * Categorize user styles.
	 */
	function parseUserStyles(styles, hasNestedStyles) {
	    var properties = [];
	    var nestedStyles = [];
	    var isUnique = false;
	    // Sort keys before adding to styles.
	    for (var _i = 0, _a = Object.keys(styles); _i < _a.length; _i++) {
	        var key = _a[_i];
	        var value = styles[key];
	        if (key === exports.IS_UNIQUE) {
	            isUnique = !!value;
	        }
	        else if (isNestedStyle(value)) {
	            nestedStyles.push([key.trim(), value]);
	        }
	        else {
	            properties.push([hyphenate(key.trim()), value]);
	        }
	    }
	    return {
	        properties: sortTuples(properties),
	        nestedStyles: hasNestedStyles ? nestedStyles : sortTuples(nestedStyles),
	        isUnique: isUnique
	    };
	}
	/**
	 * Stringify an array of property tuples.
	 */
	function stringifyProperties(properties) {
	    var result = [];
	    var _loop_1 = function (name_1, value) {
	        if (value != null) {
	            if (Array.isArray(value)) {
	                result.push(value.filter(function (x) { return x != null; }).map(function (x) { return styleToString(name_1, x); }).join(';'));
	            }
	            else {
	                result.push(styleToString(name_1, value));
	            }
	        }
	    };
	    for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
	        var _a = properties_1[_i], name_1 = _a[0], value = _a[1];
	        _loop_1(name_1, value);
	    }
	    return result.join(';');
	}
	/**
	 * Interpolate CSS selectors.
	 */
	function interpolate(selector, parent) {
	    if (selector.indexOf('&') > -1) {
	        return selector.replace(/&/g, parent);
	    }
	    return parent + " " + selector;
	}
	/**
	 * Register all styles, but collect for post-selector correction using the hash.
	 */
	function collectHashedStyles(container, userStyles, isStyle, displayName) {
	    var styles = [];
	    function stylize(cache, userStyles, selector) {
	        var _a = parseUserStyles(userStyles, isStyle), properties = _a.properties, nestedStyles = _a.nestedStyles, isUnique = _a.isUnique;
	        var styleString = stringifyProperties(properties);
	        var pid = styleString;
	        // Only create style instances when styles exists.
	        if (styleString) {
	            var style = new Style(styleString, cache.hash, isUnique ? "u" + (++uniqueId).toString(36) : undefined);
	            cache.add(style);
	            styles.push([cache, selector, style]);
	        }
	        for (var _i = 0, nestedStyles_1 = nestedStyles; _i < nestedStyles_1.length; _i++) {
	            var _b = nestedStyles_1[_i], name_2 = _b[0], value = _b[1];
	            pid += name_2;
	            if (isAtRule(name_2)) {
	                var rule = cache.add(new Rule(name_2, undefined, cache.hash));
	                pid += stylize(rule, value, selector);
	            }
	            else {
	                pid += stylize(cache, value, isStyle ? interpolate(name_2, selector) : name_2);
	            }
	        }
	        return pid;
	    }
	    // Create a temporary cache to handle changes/mutations before re-assigning later.
	    var cache = new Cache(container.hash);
	    var pid = stylize(cache, userStyles, '&');
	    var hash = "f" + cache.hash(pid);
	    var id = displayName ? displayName + "_" + hash : hash;
	    for (var _i = 0, styles_1 = styles; _i < styles_1.length; _i++) {
	        var _a = styles_1[_i], cache_1 = _a[0], selector = _a[1], style = _a[2];
	        var key = isStyle ? interpolate(selector, "." + id) : selector;
	        cache_1.get(style).add(new Selector(key, style.hash, undefined, pid));
	    }
	    container.merge(cache);
	    return { pid: pid, id: id };
	}
	/**
	 * Recursively register styles on a container instance.
	 */
	function registerUserStyles(container, styles, displayName) {
	    return collectHashedStyles(container, styles, true, displayName).id;
	}
	/**
	 * Create user rule. Simplified collection of styles, since it doesn't need a unique id hash.
	 */
	function registerUserRule(container, selector, styles) {
	    var _a = parseUserStyles(styles, false), properties = _a.properties, nestedStyles = _a.nestedStyles, isUnique = _a.isUnique;
	    // Throw when using properties and nested styles together in rule.
	    if (properties.length && nestedStyles.length) {
	        throw new TypeError("Registering a CSS rule can not use properties with nested styles");
	    }
	    var styleString = stringifyProperties(properties);
	    var rule = new Rule(selector, styleString, container.hash, isUnique ? "u" + (++uniqueId).toString(36) : undefined);
	    for (var _i = 0, nestedStyles_2 = nestedStyles; _i < nestedStyles_2.length; _i++) {
	        var _b = nestedStyles_2[_i], name_3 = _b[0], value = _b[1];
	        registerUserRule(rule, name_3, value);
	    }
	    container.add(rule);
	}
	/**
	 * Parse and register keyframes on the current instance.
	 */
	function registerUserHashedRule(container, prefix, styles, displayName) {
	    var bucket = new Cache(container.hash);
	    var _a = collectHashedStyles(bucket, styles, false, displayName), pid = _a.pid, id = _a.id;
	    var atRule = new Rule(prefix + " " + id, undefined, container.hash, undefined, pid);
	    atRule.merge(bucket);
	    container.add(atRule);
	    return id;
	}
	/**
	 * Get the styles string for a container class.
	 */
	function getStyles(container) {
	    return container.values().map(function (style) { return style.getStyles(); }).join('');
	}
	/**
	 * Implement a cache/event emitter.
	 */
	var Cache = (function () {
	    function Cache(hash) {
	        this.hash = hash;
	        this.changeId = 0;
	        this._children = {};
	        this._keys = [];
	        this._counts = {};
	    }
	    Cache.prototype.values = function () {
	        var _this = this;
	        return this._keys.map(function (x) { return _this._children[x]; });
	    };
	    Cache.prototype.add = function (style) {
	        var count = this._counts[style.id] || 0;
	        var item = this._children[style.id] || style.clone();
	        this._counts[style.id] = count + 1;
	        if (count === 0) {
	            this._keys.push(item.id);
	            this._children[item.id] = item;
	            this.changeId++;
	        }
	        else {
	            // Check if contents are different.
	            if (item.getIdentifier() !== style.getIdentifier()) {
	                throw new TypeError("Hash collision: " + style.getStyles() + " === " + item.getStyles());
	            }
	            this._keys.splice(this._keys.indexOf(style.id), 1);
	            this._keys.push(style.id);
	            if (item instanceof Cache && style instanceof Cache) {
	                var prevChangeId = item.changeId;
	                item.merge(style);
	                if (item.changeId !== prevChangeId) {
	                    this.changeId++;
	                }
	            }
	        }
	        return item;
	    };
	    Cache.prototype.remove = function (style) {
	        var count = this._counts[style.id];
	        if (count > 0) {
	            this._counts[style.id] = count - 1;
	            var item = this._children[style.id];
	            if (count === 1) {
	                delete this._counts[style.id];
	                delete this._children[style.id];
	                this._keys.splice(this._keys.indexOf(style.id), 1);
	                this.changeId++;
	            }
	            else if (item instanceof Cache && style instanceof Cache) {
	                var prevChangeId = item.changeId;
	                item.unmerge(style);
	                if (item.changeId !== prevChangeId) {
	                    this.changeId++;
	                }
	            }
	        }
	    };
	    Cache.prototype.get = function (container) {
	        return this._children[container.id];
	    };
	    Cache.prototype.merge = function (cache) {
	        for (var _i = 0, _a = cache.values(); _i < _a.length; _i++) {
	            var value = _a[_i];
	            this.add(value);
	        }
	        return this;
	    };
	    Cache.prototype.unmerge = function (cache) {
	        for (var _i = 0, _a = cache.values(); _i < _a.length; _i++) {
	            var value = _a[_i];
	            this.remove(value);
	        }
	        return this;
	    };
	    Cache.prototype.clone = function () {
	        return new Cache(this.hash).merge(this);
	    };
	    return Cache;
	}());
	exports.Cache = Cache;
	/**
	 * Selector is a dumb class made to represent nested CSS selectors.
	 */
	var Selector = (function () {
	    function Selector(selector, hash, id, pid) {
	        if (id === void 0) { id = "s" + hash(selector); }
	        if (pid === void 0) { pid = ''; }
	        this.selector = selector;
	        this.hash = hash;
	        this.id = id;
	        this.pid = pid;
	    }
	    Selector.prototype.getStyles = function () {
	        return this.selector;
	    };
	    Selector.prototype.getIdentifier = function () {
	        return this.pid + "." + this.selector;
	    };
	    Selector.prototype.clone = function () {
	        return new Selector(this.selector, this.hash, this.id, this.pid);
	    };
	    return Selector;
	}());
	exports.Selector = Selector;
	/**
	 * The style container registers a style string with selectors.
	 */
	var Style = (function (_super) {
	    __extends(Style, _super);
	    function Style(style, hash, id) {
	        if (id === void 0) { id = "c" + hash(style); }
	        var _this = _super.call(this, hash) || this;
	        _this.style = style;
	        _this.hash = hash;
	        _this.id = id;
	        return _this;
	    }
	    Style.prototype.getStyles = function () {
	        return this.values().map(function (x) { return x.selector; }).join(',') + "{" + this.style + "}";
	    };
	    Style.prototype.getIdentifier = function () {
	        return this.style;
	    };
	    Style.prototype.clone = function () {
	        return new Style(this.style, this.hash, this.id).merge(this);
	    };
	    return Style;
	}(Cache));
	exports.Style = Style;
	/**
	 * Implement rule logic for style output.
	 */
	var Rule = (function (_super) {
	    __extends(Rule, _super);
	    function Rule(rule, style, hash, id, pid) {
	        if (style === void 0) { style = ''; }
	        if (id === void 0) { id = "a" + hash(rule + "." + style); }
	        if (pid === void 0) { pid = ''; }
	        var _this = _super.call(this, hash) || this;
	        _this.rule = rule;
	        _this.style = style;
	        _this.hash = hash;
	        _this.id = id;
	        _this.pid = pid;
	        return _this;
	    }
	    Rule.prototype.getStyles = function () {
	        return this.rule + "{" + this.style + getStyles(this) + "}";
	    };
	    Rule.prototype.getIdentifier = function () {
	        return this.pid + "." + this.rule + "." + this.style;
	    };
	    Rule.prototype.clone = function () {
	        return new Rule(this.rule, this.style, this.hash, this.id, this.pid).merge(this);
	    };
	    return Rule;
	}(Cache));
	exports.Rule = Rule;
	/**
	 * The FreeStyle class implements the API for everything else.
	 */
	var FreeStyle = (function (_super) {
	    __extends(FreeStyle, _super);
	    function FreeStyle(hash, debug, id) {
	        if (id === void 0) { id = "f" + (++instanceId).toString(36); }
	        var _this = _super.call(this, hash) || this;
	        _this.hash = hash;
	        _this.debug = debug;
	        _this.id = id;
	        return _this;
	    }
	    FreeStyle.prototype.registerStyle = function (styles, displayName) {
	        return registerUserStyles(this, styles, this.debug ? displayName : undefined);
	    };
	    FreeStyle.prototype.registerKeyframes = function (keyframes, displayName) {
	        return registerUserHashedRule(this, '@keyframes', keyframes, this.debug ? displayName : undefined);
	    };
	    FreeStyle.prototype.registerRule = function (rule, styles) {
	        return registerUserRule(this, rule, styles);
	    };
	    FreeStyle.prototype.getStyles = function () {
	        return getStyles(this);
	    };
	    FreeStyle.prototype.getIdentifier = function () {
	        return this.id;
	    };
	    FreeStyle.prototype.clone = function () {
	        return new FreeStyle(this.hash, this.debug, this.id).merge(this);
	    };
	    return FreeStyle;
	}(Cache));
	exports.FreeStyle = FreeStyle;
	/**
	 * Exports a simple function to create a new instance.
	 */
	function create(hash, debug) {
	    if (hash === void 0) { hash = stringHash; }
	    if (debug === void 0) { debug = ("production") !== 'production'; }
	    return new FreeStyle(hash, debug);
	}
	exports.create = create;
	//# sourceMappingURL=free-style.js.map

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var PathSeparator, SpaceRegex, filter, matcher, scorer;
	
	  scorer = __webpack_require__(97);
	
	  filter = __webpack_require__(216);
	
	  matcher = __webpack_require__(217);
	
	  PathSeparator = __webpack_require__(53).sep;
	
	  SpaceRegex = /\ /g;
	
	  module.exports = {
	    filter: function(candidates, query, options) {
	      var queryHasSlashes;
	      if (query) {
	        queryHasSlashes = query.indexOf(PathSeparator) !== -1;
	        query = query.replace(SpaceRegex, '');
	      }
	      return filter(candidates, query, queryHasSlashes, options);
	    },
	    score: function(string, query) {
	      var queryHasSlashes, score;
	      if (!string) {
	        return 0;
	      }
	      if (!query) {
	        return 0;
	      }
	      if (string === query) {
	        return 2;
	      }
	      queryHasSlashes = query.indexOf(PathSeparator) !== -1;
	      query = query.replace(SpaceRegex, '');
	      score = scorer.score(string, query);
	      if (!queryHasSlashes) {
	        score = scorer.basenameScore(string, query, score);
	      }
	      return score;
	    },
	    match: function(string, query) {
	      var baseMatches, index, matches, queryHasSlashes, seen, _i, _ref, _results;
	      if (!string) {
	        return [];
	      }
	      if (!query) {
	        return [];
	      }
	      if (string === query) {
	        return (function() {
	          _results = [];
	          for (var _i = 0, _ref = string.length; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--){ _results.push(_i); }
	          return _results;
	        }).apply(this);
	      }
	      queryHasSlashes = query.indexOf(PathSeparator) !== -1;
	      query = query.replace(SpaceRegex, '');
	      matches = matcher.match(string, query);
	      if (!queryHasSlashes) {
	        baseMatches = matcher.basenameMatch(string, query);
	        matches = matches.concat(baseMatches).sort(function(a, b) {
	          return a - b;
	        });
	        seen = null;
	        index = 0;
	        while (index < matches.length) {
	          if (index && seen === matches[index]) {
	            matches.splice(index, 1);
	          } else {
	            seen = matches[index];
	            index++;
	          }
	        }
	      }
	      return matches;
	    }
	  };
	
	}).call(this);


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var PathSeparator, queryIsLastPathSegment;
	
	  PathSeparator = __webpack_require__(53).sep;
	
	  exports.basenameScore = function(string, query, score) {
	    var base, depth, index, lastCharacter, segmentCount, slashCount;
	    index = string.length - 1;
	    while (string[index] === PathSeparator) {
	      index--;
	    }
	    slashCount = 0;
	    lastCharacter = index;
	    base = null;
	    while (index >= 0) {
	      if (string[index] === PathSeparator) {
	        slashCount++;
	        if (base == null) {
	          base = string.substring(index + 1, lastCharacter + 1);
	        }
	      } else if (index === 0) {
	        if (lastCharacter < string.length - 1) {
	          if (base == null) {
	            base = string.substring(0, lastCharacter + 1);
	          }
	        } else {
	          if (base == null) {
	            base = string;
	          }
	        }
	      }
	      index--;
	    }
	    if (base === string) {
	      score *= 2;
	    } else if (base) {
	      score += exports.score(base, query);
	    }
	    segmentCount = slashCount + 1;
	    depth = Math.max(1, 10 - segmentCount);
	    score *= depth * 0.01;
	    return score;
	  };
	
	  exports.score = function(string, query) {
	    var character, characterScore, indexInQuery, indexInString, lowerCaseIndex, minIndex, queryLength, queryScore, stringLength, totalCharacterScore, upperCaseIndex, _ref;
	    if (string === query) {
	      return 1;
	    }
	    if (queryIsLastPathSegment(string, query)) {
	      return 1;
	    }
	    totalCharacterScore = 0;
	    queryLength = query.length;
	    stringLength = string.length;
	    indexInQuery = 0;
	    indexInString = 0;
	    while (indexInQuery < queryLength) {
	      character = query[indexInQuery++];
	      lowerCaseIndex = string.indexOf(character.toLowerCase());
	      upperCaseIndex = string.indexOf(character.toUpperCase());
	      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
	      if (minIndex === -1) {
	        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
	      }
	      indexInString = minIndex;
	      if (indexInString === -1) {
	        return 0;
	      }
	      characterScore = 0.1;
	      if (string[indexInString] === character) {
	        characterScore += 0.1;
	      }
	      if (indexInString === 0 || string[indexInString - 1] === PathSeparator) {
	        characterScore += 0.8;
	      } else if ((_ref = string[indexInString - 1]) === '-' || _ref === '_' || _ref === ' ') {
	        characterScore += 0.7;
	      }
	      string = string.substring(indexInString + 1, stringLength);
	      totalCharacterScore += characterScore;
	    }
	    queryScore = totalCharacterScore / queryLength;
	    return ((queryScore * (queryLength / stringLength)) + queryScore) / 2;
	  };
	
	  queryIsLastPathSegment = function(string, query) {
	    if (string[string.length - query.length - 1] === PathSeparator) {
	      return string.lastIndexOf(query) === string.length - query.length;
	    }
	  };
	
	}).call(this);


/***/ },
/* 98 */
/***/ function(module, exports) {

	module.exports = {"title":"JSON schema for the tested configuration files","$schema":"http://json-schema.org/draft-04/schema#","type":"object","additionalProperties":true,"definitions":{"includeDefinition":{"properties":{"include":{"description":"Specifies a list of glob patterns that match files to be included in compilation.","type":"array","items":{"type":"string","format":"uri"}}}},"excludeDefinition":{"properties":{"exclude":{"description":"Specifies a list globs that need to be excluded from compilation. The 'exclude' property only affects the files included via the 'include' property","type":"array","items":{"type":"string","format":"uri"}}}}},"properties":{"tests":{"description":"The directory where the codelytics rules live","type":"object","anyOf":[{"$ref":"#/definitions/includeDefinition"},{"$ref":"#/definitions/excludeDefinition"}]}}}

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","title":"JSON schema for NPM package.json files","definitions":{"person":{"description":"A person who has been involved in creating or maintaining this package","type":["object","string"],"required":["name"],"properties":{"name":{"type":"string"},"url":{"type":"string","format":"uri"},"email":{"type":"string","format":"email"}}},"bundledDependency":{"description":"Array of package names that will be bundled when publishing the package.","type":"array","items":{"type":"string"}},"dependency":{"description":"Dependencies are specified with a simple hash of package name to version range. The version range is a string which has one or more space-separated descriptors. Dependencies can also be identified with a tarball or git URL.","type":"object","additionalProperties":{"type":"string"}},"scriptsInstallAfter":{"description":"Run AFTER the package is installed","type":"string"},"scriptsPublishAfter":{"description":"Run AFTER the package is published","type":"string"},"scriptsRestart":{"description":"Run by the 'npm restart' command. Note: 'npm restart' will run the stop and start scripts if no restart script is provided.","type":"string"},"scriptsStart":{"description":"Run by the 'npm start' command","type":"string"},"scriptsStop":{"description":"Run by the 'npm stop' command","type":"string"},"scriptsTest":{"description":"Run by the 'npm test' command","type":"string"},"scriptsUninstallBefore":{"description":"Run BEFORE the package is uninstalled","type":"string"},"scriptsVersionBefore":{"description":"Run BEFORE bump the package version","type":"string"},"coreProperties":{"type":"object","patternProperties":{"^_":{"description":"Any property starting with _ is valid.","additionalProperties":true,"additionalItems":true}},"properties":{"name":{"description":"The name of the package.","type":"string","maxLength":214,"minLength":1,"pattern":"^[^A-Z]+$"},"version":{"description":"Version must be parseable by node-semver, which is bundled with npm as a dependency.","type":"string"},"description":{"description":"This helps people discover your package, as it's listed in 'npm search'.","type":"string"},"keywords":{"description":"This helps people discover your package as it's listed in 'npm search'.","type":"array","items":{"type":"string"}},"homepage":{"description":"The url to the project homepage.","type":"string","format":"uri"},"bugs":{"description":"The url to your project's issue tracker and / or the email address to which issues should be reported. These are helpful for people who encounter issues with your package.","type":["object","string"],"properties":{"url":{"type":"string","description":"The url to your project's issue tracker.","format":"uri"},"email":{"type":"string","description":"The email address to which issues should be reported.","format":"email"}}},"license":{"type":"string","description":"You should specify a license for your package so that people know how they are permitted to use it, and any restrictions you're placing on it."},"licenses":{"description":"You should specify a license for your package so that people know how they are permitted to use it, and any restrictions you're placing on it.","type":"array","items":{"type":"object","properties":{"type":{"type":"string"},"url":{"type":"string","format":"uri"}}}},"author":{"$ref":"#/definitions/person"},"contributors":{"description":"A list of people who contributed to this package.","type":"array","items":{"$ref":"#/definitions/person"}},"maintainers":{"description":"A list of people who maintains this package.","type":"array","items":{"$ref":"#/definitions/person"}},"files":{"description":"The 'files' field is an array of files to include in your project. If you name a folder in the array, then it will also include the files inside that folder.","type":"array","items":{"type":"string"}},"main":{"description":"The main field is a module ID that is the primary entry point to your program.","type":"string"},"bin":{"type":["string","object"],"additionalProperties":{"type":"string"}},"man":{"type":["array","string"],"description":"Specify either a single file or an array of filenames to put in place for the man program to find.","items":{"type":"string"}},"directories":{"type":"object","properties":{"bin":{"description":"If you specify a 'bin' directory, then all the files in that folder will be used as the 'bin' hash.","type":"string"},"doc":{"description":"Put markdown files in here. Eventually, these will be displayed nicely, maybe, someday.","type":"string"},"example":{"description":"Put example scripts in here. Someday, it might be exposed in some clever way.","type":"string"},"lib":{"description":"Tell people where the bulk of your library is. Nothing special is done with the lib folder in any way, but it's useful meta info.","type":"string"},"man":{"description":"A folder that is full of man pages. Sugar to generate a 'man' array by walking the folder.","type":"string"},"test":{"type":"string"}}},"repository":{"description":"Specify the place where your code lives. This is helpful for people who want to contribute.","type":["object","string"],"properties":{"type":{"type":"string"},"url":{"type":"string","format":"uri"}}},"scripts":{"description":"The 'scripts' member is an object hash of script commands that are run at various times in the lifecycle of your package. The key is the lifecycle event, and the value is the command to run at that point.","type":"object","properties":{"prepublish":{"type":"string","description":"Run BEFORE the package is published (Also run on local npm install without any arguments)"},"publish":{"$ref":"#/definitions/scriptsPublishAfter"},"postpublish":{"$ref":"#/definitions/scriptsPublishAfter"},"preinstall":{"type":"string","description":"Run BEFORE the package is installed"},"install":{"$ref":"#/definitions/scriptsInstallAfter"},"postinstall":{"$ref":"#/definitions/scriptsInstallAfter"},"preuninstall":{"$ref":"#/definitions/scriptsUninstallBefore"},"uninstall":{"$ref":"#/definitions/scriptsUninstallBefore"},"postuninstall":{"type":"string","description":"Run AFTER the package is uninstalled"},"preversion":{"$ref":"#/definitions/scriptsVersionBefore"},"version":{"$ref":"#/definitions/scriptsVersionBefore"},"postversion":{"type":"string","description":"Run AFTER bump the package version"},"pretest":{"$ref":"#/definitions/scriptsTest"},"test":{"$ref":"#/definitions/scriptsTest"},"posttest":{"$ref":"#/definitions/scriptsTest"},"prestop":{"$ref":"#/definitions/scriptsStop"},"stop":{"$ref":"#/definitions/scriptsStop"},"poststop":{"$ref":"#/definitions/scriptsStop"},"prestart":{"$ref":"#/definitions/scriptsStart"},"start":{"$ref":"#/definitions/scriptsStart"},"poststart":{"$ref":"#/definitions/scriptsStart"},"prerestart":{"$ref":"#/definitions/scriptsRestart"},"restart":{"$ref":"#/definitions/scriptsRestart"},"postrestart":{"$ref":"#/definitions/scriptsRestart"}},"additionalProperties":{"type":"string"}},"config":{"description":"A 'config' hash can be used to set configuration parameters used in package scripts that persist across upgrades.","type":"object","additionalProperties":true},"dependencies":{"$ref":"#/definitions/dependency"},"devDependencies":{"$ref":"#/definitions/dependency"},"optionalDependencies":{"$ref":"#/definitions/dependency"},"peerDependencies":{"$ref":"#/definitions/dependency"},"engines":{"type":"object","additionalProperties":{"type":"string"}},"engineStrict":{"type":"boolean"},"os":{"type":"array","items":{"type":"string"}},"cpu":{"type":"array","items":{"type":"string"}},"preferGlobal":{"type":"boolean","description":"If your package is primarily a command-line application that should be installed globally, then set this value to true to provide a warning if it is installed locally."},"private":{"type":"boolean","description":"If set to true, then npm will refuse to publish it."},"publishConfig":{"type":"object","additionalProperties":true},"dist":{"type":"object","properties":{"shasum":{"type":"string"},"tarball":{"type":"string"}}},"readme":{"type":"string"}}},"jspmDefinition":{"properties":{"jspm":{"$ref":"#/definitions/coreProperties"}}}},"allOf":[{"$ref":"#/definitions/coreProperties"},{"$ref":"#/definitions/jspmDefinition"},{"anyOf":[{"properties":{"bundleDependencies":{"$ref":"#/definitions/bundledDependency"}},"not":{"properties":{"bundledDependencies":{}},"required":["bundledDependencies"]}},{"properties":{"bundledDependencies":{"$ref":"#/definitions/bundledDependency"}},"not":{"properties":{"bundleDependencies":{}},"required":["bundleDependencies"]}}]},{"required":["name","version"]}]}

/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports = {"title":"JSON schema for the TypeScript compiler's configuration file","$schema":"http://json-schema.org/draft-04/schema#","definitions":{"filesDefinition":{"properties":{"files":{"description":"If no 'files' or 'include' property is present in a tsconfig.json, the compiler defaults to including all files in the containing directory and subdirectories except those specified by 'exclude'. When a 'files' property is specified, only those files and those specified by 'include' are included.","type":"array","items":{"type":"string"}}}},"excludeDefinition":{"properties":{"exclude":{"description":"Specifies a list of files to be excluded from compilation. The 'exclude' property only affects the files included via the 'include' property and not the 'files' property. Glob patterns require TypeScript version 2.0 or later.","type":"array","items":{"type":"string"}}}},"includeDefinition":{"properties":{"include":{"description":"Specifies a list of glob patterns that match files to be included in compilation. If no 'files' or 'include' property is present in a tsconfig.json, the compiler defaults to including all files in the containing directory and subdirectories except those specified by 'exclude'. Requires TypeScript version 2.0 or later.","type":"array","items":{"type":"string"}}}},"compileOnSaveDefinition":{"properties":{"compileOnSave":{"description":"Enable Compile-on-Save for this project.","type":"boolean"}}},"extendsDefinition":{"properties":{"extends":{"description":"Path to base configuration file to inherit from. Requires TypeScript version 2.1 or later.","type":"string"}}},"compilerOptionsDefinition":{"properties":{"compilerOptions":{"type":"object","description":"Instructs the TypeScript compiler how to compile .ts files.","properties":{"charset":{"description":"The character set of the input files.","type":"string"},"declaration":{"description":"Generates corresponding d.ts files.","type":"boolean"},"declarationDir":{"type":"string","description":"Specify output directory for generated declaration files. Requires TypeScript version 2.0 or later."},"diagnostics":{"description":"Show diagnostic information.","type":"boolean"},"emitBOM":{"description":"Emit a UTF-8 Byte Order Mark (BOM) in the beginning of output files.","type":"boolean"},"inlineSourceMap":{"description":"Emit a single file with source maps instead of having a separate file.","type":"boolean"},"inlineSources":{"description":"Emit the source alongside the sourcemaps within a single file; requires --inlineSourceMap to be set.","type":"boolean"},"jsx":{"description":"Specify JSX code generation: 'preserve' or 'react'.","enum":["preserve","react"]},"reactNamespace":{"description":"Specifies the object invoked for createElement and __spread when targeting 'react' JSX emit.","type":"string"},"listFiles":{"description":"Print names of files part of the compilation.","type":"boolean"},"locale":{"description":"The locale to use to show error messages, e.g. en-us.","type":"string"},"mapRoot":{"description":"Specifies the location where debugger should locate map files instead of generated locations","type":"string"},"module":{"description":"Specify module code generation: 'none', 'CommonJS', 'Amd', 'System', 'UMD', or 'es2015'.","enum":["commonjs","amd","umd","system","es6","es2015","esnext","none"]},"newLine":{"description":"Specifies the end of line sequence to be used when emitting files: 'CRLF' (dos) or 'LF' (unix).","enum":["CRLF","LF"]},"noEmit":{"description":"Do not emit output.","type":"boolean"},"noEmitHelpers":{"description":"Do not generate custom helper functions like __extends in compiled output.","type":"boolean"},"noEmitOnError":{"description":"Do not emit outputs if any type checking errors were reported.","type":"boolean"},"noImplicitAny":{"description":"Warn on expressions and declarations with an implied 'any' type.","type":"boolean"},"noImplicitThis":{"description":"Raise error on 'this' expressions with an implied any type.","type":"boolean"},"noUnusedLocals":{"description":"Report errors on unused locals. Requires TypeScript version 2.0 or later.","type":"boolean"},"noUnusedParameters":{"description":"Report errors on unused parameters. Requires TypeScript version 2.0 or later.","type":"boolean"},"noLib":{"description":"Do not include the default library file (lib.d.ts).","type":"boolean"},"noResolve":{"description":"Do not add triple-slash references or module import targets to the list of compiled files.","type":"boolean"},"skipDefaultLibCheck":{"type":"boolean"},"skipLibCheck":{"description":"Skip type checking of declaration files. Requires TypeScript version 2.0 or later.","type":"boolean"},"outFile":{"description":"Concatenate and emit output to single file.","type":"string"},"outDir":{"description":"Redirect output structure to the directory.","type":"string"},"preserveConstEnums":{"description":"Do not erase const enum declarations in generated code.","type":"boolean"},"pretty":{"description":"Stylize errors and messages using color and context (experimental).","type":"boolean"},"removeComments":{"description":"Do not emit comments to output.","type":"boolean"},"rootDir":{"description":"Specifies the root directory of input files. Use to control the output directory structure with --outDir.","type":"string"},"isolatedModules":{"description":"Unconditionally emit imports for unresolved files.","type":"boolean"},"sourceMap":{"description":"Generates corresponding '.map' file.","type":"boolean"},"sourceRoot":{"description":"Specifies the location where debugger should locate TypeScript files instead of source locations.","type":"string"},"suppressExcessPropertyErrors":{"description":"Suppress excess property checks for object literals.","type":"boolean"},"suppressImplicitAnyIndexErrors":{"description":"Suppress noImplicitAny errors for indexing objects lacking index signatures.","type":"boolean"},"stripInternal":{"description":"Do not emit declarations for code that has an '@internal' annotation.","type":"boolean"},"target":{"description":"Specify ECMAScript target version. Permitted values are 'es3', 'es5', 'es2015', 'es2016', 'es2017' or 'esnext'.","type":"string","pattern":"^([eE][sS]([356]|(201[567])|[nN][eE][xX][tT]))$","default":"es3"},"watch":{"description":"Watch input files.","type":"boolean"},"experimentalDecorators":{"description":"Enables experimental support for ES7 decorators.","type":"boolean"},"emitDecoratorMetadata":{"description":"Emit design-type metadata for decorated declarations in source.","type":"boolean"},"moduleResolution":{"description":"Specifies module resolution strategy: 'node' (Node) or 'classic' (TypeScript pre 1.6) .","type":"string","pattern":"^(([Nn]ode)|([Cc]lassic))$","default":"classic"},"allowUnusedLabels":{"type":"boolean","description":"Do not report errors on unused labels."},"noImplicitReturns":{"description":"Report error when not all code paths in function return a value.","type":"boolean"},"noFallthroughCasesInSwitch":{"description":"Report errors for fallthrough cases in switch statement.","type":"boolean"},"allowUnreachableCode":{"description":"Do not report errors on unreachable code.","type":"boolean"},"forceConsistentCasingInFileNames":{"description":"Disallow inconsistently-cased references to the same file.","type":"boolean"},"baseUrl":{"description":"Base directory to resolve non-relative module names.","type":"string"},"paths":{"description":"Specify path mapping to be computed relative to baseUrl option.","type":"object"},"rootDirs":{"description":"Specify list of root directory to be used when resolving modules.","type":"array","items":{"type":"string"}},"typeRoots":{"description":"Specify list of directory for type definition files to be include. Requires TypeScript version 2.0 or later.","type":"array","items":{"type":"string"}},"types":{"description":"Type declaration files to be included in compilation. Requires TypeScript version 2.0 or later.","type":"array","items":{"type":"string"}},"traceResolution":{"description":"Enable tracing of the name resolution process.","type":"boolean"},"allowJs":{"description":"Allow javascript files to be compiled.","type":"boolean"},"allowSyntheticDefaultImports":{"description":"Allow default imports from modules with no default export. This does not affect code emit, just typechecking.","type":"boolean"},"noImplicitUseStrict":{"description":"Do not emit 'use strict' directives in module output.","type":"boolean"},"listEmittedFiles":{"description":"Enable to list all emitted files. Requires TypeScript version 2.0 or later.","type":"boolean"},"lib":{"description":"Specify library file to be included in the compilation. Requires TypeScript version 2.0 or later.","type":"array","items":{"type":"string","enum":["es5","es6","es2015","es7","es2016","es2017","dom","dom.iterable","webworker","scripthost","es2015.core","es2015.collection","es2015.generator","es2015.iterable","es2015.promise","es2015.proxy","es2015.reflect","es2015.symbol","es2015.symbol.wellknown","es2016.array.include","es2017.object","es2017.sharedmemory"]}},"strictNullChecks":{"description":"Enable strict null checks. Requires TypeScript version 2.0 or later.","type":"boolean"},"maxNodeModuleJsDepth":{"description":"The maximum dependency depth to search under node_modules and load JavaScript files. Only applicable with --allowJs.","type":"number","default":0},"importHelpers":{"description":"Import emit helpers (e.g. '__extends', '__rest', etc..) from tslib. Requires TypeScript version 2.1 or later.","type":"boolean"},"jsxFactory":{"description":"Specify the JSX factory function to use when targeting react JSX emit, e.g. 'React.createElement' or 'h'. Requires TypeScript version 2.1 or later.","type":"string","default":"React.createElement"},"alwaysStrict":{"description":"Parse in strict mode and emit 'use strict' for each source file. Requires TypeScript version 2.1 or later.","type":"boolean"},"checkJs":{"description":"Report errors in .js files. Requires TypeScript version 2.3 or later.","type":"boolean"}}}}},"typeAcquisitionDefinition":{"properties":{"typeAcquisition":{"type":"object","description":"Auto type (.d.ts) acquisition options for this project. Requires TypeScript version 2.1 or later.","properties":{"enable":{"description":"Enable auto type acquisition","type":"boolean","default":false},"include":{"description":"Specifies a list of type declarations to be included in auto type acquisition. Ex. [\"jquery\", \"lodash\"]","type":"array","items":{"type":"string"}},"exclude":{"description":"Specifies a list of type declarations to be excluded from auto type acquisition. Ex. [\"jquery\", \"lodash\"]","type":"array","items":{"type":"string"}}}}}}},"type":"object","allOf":[{"$ref":"#/definitions/compilerOptionsDefinition"},{"$ref":"#/definitions/compileOnSaveDefinition"},{"$ref":"#/definitions/typeAcquisitionDefinition"},{"$ref":"#/definitions/extendsDefinition"},{"anyOf":[{"$ref":"#/definitions/filesDefinition"},{"$ref":"#/definitions/excludeDefinition"},{"$ref":"#/definitions/includeDefinition"}]}]}

/***/ },
/* 101 */
/***/ function(module, exports) {

	module.exports = {"title":"JSON schema for the TSLint configuration files","$schema":"http://json-schema.org/draft-04/schema#","type":"object","additionalProperties":true,"definitions":{"ruledefinitions":{"properties":{"align":{"description":"Enforces vertical alignment for parameters, arguments and/or statements","type":["array"],"items":{"enum":[true,false,"parameters","arguments","statements"]}},"ban":{"description":"Bans the use of specific functions","type":["boolean","array"],"items":{"type":["boolean","array"]}},"class-name":{"description":"Enforces PascalCased class and interface names","type":"boolean"},"comment-format":{"description":"Enforces rules for single-line comments","type":"array","items":{"enum":[true,false,"check-space","check-lowercase","check-uppercase"]}},"component-class-suffix":{"description":"Enforces all components having the suffix of 'Component'","type":"boolean"},"component-selector-name":{"description":"Enforces naming conventions for components","type":"array","items":{"enum":[true,false,"camelCase","kebab-case"]}},"component-selector-prefix":{"description":"Enforces all components to have a uniform prefix","type":"array","items":{"enum":[true,false,"sg"]}},"component-selector-type":{"description":"Enforces the type of a component","type":"array","items":{"enum":[true,false,"attribute","element"]}},"curly":{"description":"Enforces braces for if/for/do/while statements","type":"boolean"},"directive-class-suffix":{"description":"Enforces all components having the suffix of 'Directive'","type":"boolean"},"directive-selector-name":{"description":"Enforces naming conventions for directives","type":"array","items":{"enum":[true,false,"camelCase","kebab-case"]}},"directive-selector-prefix":{"description":"Enforces all directives to have a uniform prefix","type":"array","items":{"enum":[true,false,"sg"]}},"directive-selector-type":{"description":"Enforces the type of a directive","type":"array","items":{"enum":[true,false,"attribute","element"]}},"eofline":{"description":"Enforces the file to end with a newline","type":"boolean"},"forin":{"description":"Enforces a for...in statement to be filtered with an if statement","type":"boolean"},"indent":{"description":"Enforces consistent indentation levels","type":"array","items":{"type":["boolean","integer","string"]}},"interface-name":{"description":"Enforces the rule that interface names must or must not begin with a capital 'I'","type":"array","items":{"enum":[true,false,"always-prefix","never-prefix"]}},"jsdoc-format":{"description":"Enforces basic format rules for jsdoc comments","type":"boolean"},"label-position":{"description":"Enforces labels only on sensible statements","type":"boolean"},"label-undefined":{"description":"Checks that labels are defined before usage","type":"boolean"},"max-line-length":{"description":"Sets the maximum length of a line","type":"array","items":{"type":["boolean","integer"]}},"member-access":{"description":"Enforces using explicit visibility on class members","type":["array","boolean"],"items":{"type":["boolean","string"],"enum":[true,false,"check-accessor","check-constructor"]}},"member-ordering":{"description":"Enforces chosen member ordering","type":"array","items":{"type":["object","boolean","string"]}},"no-any":{"description":"Disallows usages of any as a type decoration","type":"boolean"},"no-arg":{"description":"Disallows access to arguments.callee","type":"boolean"},"no-attribute-parameter-decorator":{"description":"Disallows the @Attribute decorator in constructors","type":"boolean"},"no-bitwise":{"description":"Disallows bitwise operators","type":"boolean"},"no-conditional-assignment":{"description":"Disallows any type of assignment in any conditionals; this applies to do-while, for, if, and while statements","type":"boolean"},"no-console":{"description":"Disallows access to the specified functions on console","type":"array","items":{"enum":[true,false,"assert","count","debug","dir","dirxml","error","group","groupCollapsed","groupEnd","info","log","profile","profileEnd","table","time","timeEnd","timeStamp","trace","warn"]}},"no-consecutive-blank-lines":{"description":"Disallows having more than one blank line in a row in a file","type":"boolean"},"no-construct":{"description":"Disallows access to the constructors of String, Number and Boolean","type":"boolean"},"no-constructor-vars":{"description":"Disallows the public and private modifiers for constructor parameters","type":"boolean"},"no-debugger":{"description":"Disallows debugger statements","type":"boolean"},"no-duplicate-key":{"description":"Disallows duplicate keys in object literals","type":"boolean"},"no-duplicate-variable":{"description":"Disallows duplicate variable declarations in the same block scope","type":"boolean"},"no-shadowed-variable":{"description":"Disallows shadowed variable declarations","type":"boolean"},"no-empty":{"description":"Disallows empty blocks","type":"boolean"},"no-eval":{"description":"Disallows eval function invocations","type":"boolean"},"no-forward-ref":{"description":"Enforces avoidence of utilizing forwardRef's in classes and variables","type":"boolean"},"no-inferrable-types":{"description":"Disallows explicit type declarations for variables or parameters initialized to a number, string, or boolean","type":["boolean","array"]},"no-input-rename":{"description":"Disallows the renaming of input properties","type":"boolean"},"no-internal-module":{"description":"Disallows internal module, use namespace instead","type":"boolean"},"no-output-rename":{"description":"Disallows the renaming of output properties","type":"boolean"},"no-require-imports":{"description":"Disallows require() style imports","type":"boolean"},"no-string-literal":{"description":"Disallows object access via string literals","type":"boolean"},"no-switch-case-fall-through":{"description":"Disallows falling through case statements","type":"boolean"},"no-trailing-comma":{"description":"Disallows trailing comma within object literals","type":"boolean"},"no-trailing-whitespace":{"description":"Disallows trailing whitespace at the end of a line","type":"boolean"},"no-unreachable":{"description":"Disallows unreachable code after break, catch, throw, and return statements","type":"boolean"},"no-unused-expression":{"description":"Disallows unused expression statements","type":"boolean"},"no-unused-variable":{"description":"Disallows unused imports, variables, functions and private class members","type":["array","boolean"],"items":{"type":["boolean","string","object"]}},"no-use-before-declare":{"description":"Disallows usage of variables before their declaration","type":"boolean"},"no-var-keyword":{"description":"Disallows usage of the var keyword, use let or const instead","type":"boolean"},"no-var-requires":{"description":"Disallows the use of require statements except in import statements","type":"boolean"},"one-line":{"description":"Enforces the specified tokens to be on the same line as the expression preceding it","type":"array","items":{"enum":[true,false,"check-open-brace","check-catch","check-finally","check-else","check-whitespace"]}},"pipe-naming":{"description":"Enforces naming conventions for Pipes","type":"array","items":{"enum":[true,"camelCase","sg"]}},"quotemark":{"description":"Enforces consistent single or double quoted string literals","type":"array","items":{"enum":[true,false,"double","single","jsx-double","jsx-single","avoid-escape"]}},"radix":{"description":"Enforces the radix parameter of parseInt","type":"boolean"},"semicolon":{"description":"Enforces semicolons at the end of every statement","type":"array","items":{"enum":[true,false,"always","never"]}},"sort-object-literal-keys":{"description":"Checks that keys in object literals are declared in alphabetical order","type":"boolean"},"switch-default":{"description":"Enforces a default case in switch statements","type":"boolean"},"triple-equals":{"description":"Enforces === and !== in favor of == and !=","type":["array","boolean"],"items":{"type":["boolean","string"],"enum":[true,false,"allow-null-check","allow-undefined-check"]}},"typedef":{"description":"Enforces type definitions to exist","type":"array","items":{"enum":[true,false,"call-signature","parameter","arrow-parameter","property-declaration","variable-declaration","member-variable-declaration"]}},"typedef-whitespace":{"description":"Enforces spacing whitespace for type definitions","type":"array","items":{"type":["object","boolean"]}},"use-host-property-decorator":{"description":"Enforces the use of @HostBindings and @HostListeners instead of the host property","type":"boolean"},"use-input-property-decorator":{"description":"Enforces the use of the @Input property decorator instead of the inputs property","type":"boolean"},"use-life-cycle-interface":{"description":"Enforces all life cycle code using the lifecycle hook interfaces","type":"boolean"},"use-output-property-decorator":{"description":"Enforces the use of the @Output property decorator instead of the outputs property","type":"boolean"},"use-pipe-transform-interface":{"description":"Enforces all pipes using the PipeTransform interface","type":"boolean"},"use-strict":{"description":"Enforces ECMAScript 5's strict mode","type":"array","items":{"enum":[true,false,"check-module","check-function"]}},"variable-name":{"description":"Allows only camelCased or UPPER_CASED variable names","type":["array","boolean"],"items":{"enum":[true,false,"check-format","allow-leading-underscore","allow-trailing-underscore","allow-pascal-case","ban-keywords"]}},"whitespace":{"description":"Enforces spacing whitespace","type":"array","items":{"enum":[true,false,"check-branch","check-decl","check-operator","check-module","check-separator","check-type","check-typecast"]}}},"type":"object"}},"properties":{"rulesDirectory":{"description":"The directory where the codelytics rules live","type":"array","items":{"type":"string"}},"rules":{"$ref":"#/definitions/ruledefinitions"},"extends":{"description":"Extend another configuration (built in config OR a node resolvable .json file) ","type":"string"}}}

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseAssign = __webpack_require__(223),
	    createAssigner = __webpack_require__(226),
	    keys = __webpack_require__(103);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(227),
	    isArguments = __webpack_require__(229),
	    isArray = __webpack_require__(230);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(238);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 105 */
/***/ function(module, exports) {

	// https://developer.mozilla.org/en-US/docs/Web/Events/resize
	var optimizedResize = (function () {
	    var callbacks = [], running = false;
	    var addedFirst = false;
	    // fired on resize event
	    function resize() {
	        if (!running) {
	            running = true;
	            if (window.requestAnimationFrame) {
	                window.requestAnimationFrame(runCallbacks);
	            }
	            else {
	                setTimeout(runCallbacks, 66);
	            }
	        }
	    }
	    // run the actual callbacks
	    function runCallbacks() {
	        callbacks.forEach(function (callback) {
	            callback();
	        });
	        running = false;
	    }
	    // adds callback to loop
	    function addCallback(callback) {
	        if (callback) {
	            callbacks.push(callback);
	        }
	    }
	    function removeCallback(callback) {
	        if (callback) {
	            var callbackIndex = callbacks.indexOf(callback);
	            if (callbackIndex > -1)
	                callbacks.splice(callbackIndex, 1);
	        }
	    }
	    return {
	        /** public method to add additional callback */
	        on: function (callback) {
	            if (!addedFirst) {
	                window.addEventListener('resize', resize);
	                addedFirst = true;
	            }
	            addCallback(callback);
	            return { dispose: function () { return removeCallback(callback); } };
	        },
	        /** public method to remove an existing callback */
	        off: function (callback) {
	            removeCallback(callback);
	        }
	    };
	}());
	module.exports = optimizedResize;


/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(32);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactInstrumentation = __webpack_require__(22);
	
	var quoteAttributeValueForBrowser = __webpack_require__(306);
	var warning = __webpack_require__(8);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(39);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(80);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var LinkedValueUtils = __webpack_require__(69);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(24);
	
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var ReactUpdates = __webpack_require__(24);
	var Transaction = __webpack_require__(56);
	
	var emptyFunction = __webpack_require__(21);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(249);
	var BeforeInputEventPlugin = __webpack_require__(251);
	var ChangeEventPlugin = __webpack_require__(253);
	var DefaultEventPluginOrder = __webpack_require__(255);
	var EnterLeaveEventPlugin = __webpack_require__(256);
	var HTMLDOMPropertyConfig = __webpack_require__(109);
	var ReactComponentBrowserEnvironment = __webpack_require__(259);
	var ReactDOMComponent = __webpack_require__(262);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDOMEmptyComponent = __webpack_require__(263);
	var ReactDOMTreeTraversal = __webpack_require__(272);
	var ReactDOMTextComponent = __webpack_require__(270);
	var ReactDefaultBatchingStrategy = __webpack_require__(113);
	var ReactEventListener = __webpack_require__(275);
	var ReactInjection = __webpack_require__(276);
	var ReactReconcileTransaction = __webpack_require__(280);
	var SVGDOMPropertyConfig = __webpack_require__(285);
	var SelectEventPlugin = __webpack_require__(286);
	var SimpleEventPlugin = __webpack_require__(287);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(268);
	
	var containsNode = __webpack_require__(206);
	var focusNode = __webpack_require__(93);
	var getActiveElement = __webpack_require__(94);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(298);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(38);
	var DOMProperty = __webpack_require__(39);
	var React = __webpack_require__(34);
	var ReactBrowserEventEmitter = __webpack_require__(54);
	var ReactCurrentOwner = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDOMContainerInfo = __webpack_require__(111);
	var ReactDOMFeatureFlags = __webpack_require__(264);
	var ReactFeatureFlags = __webpack_require__(116);
	var ReactInstanceMap = __webpack_require__(45);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactMarkupChecksum = __webpack_require__(119);
	var ReactReconciler = __webpack_require__(33);
	var ReactUpdateQueue = __webpack_require__(72);
	var ReactUpdates = __webpack_require__(24);
	
	var emptyObject = __webpack_require__(42);
	var instantiateReactComponent = __webpack_require__(77);
	var invariant = __webpack_require__(4);
	var setInnerHTML = __webpack_require__(58);
	var shouldUpdateReactComponent = __webpack_require__(79);
	var warning = __webpack_require__(8);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var React = __webpack_require__(34);
	
	var invariant = __webpack_require__(4);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var PooledClass = __webpack_require__(32);
	var Transaction = __webpack_require__(56);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactServerUpdateQueue = __webpack_require__(284);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.0';

/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 126 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(121);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(16);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value bail and don't track value
	    // will cause over reporting of changes, but it's better then a hard failure
	    // (needed for certain tests that spyOn input values)
	    if (node.hasOwnProperty(valueField)) {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 130 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	var escapeTextContentForBrowser = __webpack_require__(57);
	var setInnerHTML = __webpack_require__(58);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(30);
	var REACT_ELEMENT_TYPE = __webpack_require__(273);
	
	var getIteratorFn = __webpack_require__(303);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(68);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(269);


/***/ },
/* 134 */
/***/ function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 136 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(12);
	
	var ReactNoopUpdateQueue = __webpack_require__(140);
	
	var canDefineProperty = __webpack_require__(141);
	var emptyObject = __webpack_require__(42);
	var invariant = __webpack_require__(4);
	var lowPriorityWarning = __webpack_require__(334);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactCurrentOwner = __webpack_require__(30);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 139 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 142 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  } else {
	    var _ret = function () {
	      var last = funcs[funcs.length - 1];
	      var rest = funcs.slice(0, -1);
	      return {
	        v: function v() {
	          return rest.reduceRight(function (composed, f) {
	            return f(composed);
	          }, last.apply(undefined, arguments));
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	}

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(62);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(376);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  var _ref2;
	
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2["default"]] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(143);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(339);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(338);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(337);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(142);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 145 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(48);
	var has = Object.prototype.hasOwnProperty;
	var hasNativeMap = typeof Map !== "undefined";
	
	/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */
	function ArraySet() {
	  this._array = [];
	  this._set = hasNativeMap ? new Map() : Object.create(null);
	}
	
	/**
	 * Static method for creating ArraySet instances from an existing array.
	 */
	ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
	  var set = new ArraySet();
	  for (var i = 0, len = aArray.length; i < len; i++) {
	    set.add(aArray[i], aAllowDuplicates);
	  }
	  return set;
	};
	
	/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */
	ArraySet.prototype.size = function ArraySet_size() {
	  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
	};
	
	/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
	  var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
	  var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
	  var idx = this._array.length;
	  if (!isDuplicate || aAllowDuplicates) {
	    this._array.push(aStr);
	  }
	  if (!isDuplicate) {
	    if (hasNativeMap) {
	      this._set.set(aStr, idx);
	    } else {
	      this._set[sStr] = idx;
	    }
	  }
	};
	
	/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.has = function ArraySet_has(aStr) {
	  if (hasNativeMap) {
	    return this._set.has(aStr);
	  } else {
	    var sStr = util.toSetString(aStr);
	    return has.call(this._set, sStr);
	  }
	};
	
	/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
	  if (hasNativeMap) {
	    var idx = this._set.get(aStr);
	    if (idx >= 0) {
	        return idx;
	    }
	  } else {
	    var sStr = util.toSetString(aStr);
	    if (has.call(this._set, sStr)) {
	      return this._set[sStr];
	    }
	  }
	
	  throw new Error('"' + aStr + '" is not in the set.');
	};
	
	/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */
	ArraySet.prototype.at = function ArraySet_at(aIdx) {
	  if (aIdx >= 0 && aIdx < this._array.length) {
	    return this._array[aIdx];
	  }
	  throw new Error('No element indexed by ' + aIdx);
	};
	
	/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */
	ArraySet.prototype.toArray = function ArraySet_toArray() {
	  return this._array.slice();
	};
	
	exports.ArraySet = ArraySet;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	var base64 = __webpack_require__(347);
	
	// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011
	
	var VLQ_BASE_SHIFT = 5;
	
	// binary: 100000
	var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
	// binary: 011111
	var VLQ_BASE_MASK = VLQ_BASE - 1;
	
	// binary: 100000
	var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
	/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */
	function toVLQSigned(aValue) {
	  return aValue < 0
	    ? ((-aValue) << 1) + 1
	    : (aValue << 1) + 0;
	}
	
	/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */
	function fromVLQSigned(aValue) {
	  var isNegative = (aValue & 1) === 1;
	  var shifted = aValue >> 1;
	  return isNegative
	    ? -shifted
	    : shifted;
	}
	
	/**
	 * Returns the base 64 VLQ encoded value.
	 */
	exports.encode = function base64VLQ_encode(aValue) {
	  var encoded = "";
	  var digit;
	
	  var vlq = toVLQSigned(aValue);
	
	  do {
	    digit = vlq & VLQ_BASE_MASK;
	    vlq >>>= VLQ_BASE_SHIFT;
	    if (vlq > 0) {
	      // There are still more digits in this value, so we must make sure the
	      // continuation bit is marked.
	      digit |= VLQ_CONTINUATION_BIT;
	    }
	    encoded += base64.encode(digit);
	  } while (vlq > 0);
	
	  return encoded;
	};
	
	/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */
	exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
	  var strLen = aStr.length;
	  var result = 0;
	  var shift = 0;
	  var continuation, digit;
	
	  do {
	    if (aIndex >= strLen) {
	      throw new Error("Expected more digits in base 64 VLQ value.");
	    }
	
	    digit = base64.decode(aStr.charCodeAt(aIndex++));
	    if (digit === -1) {
	      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
	    }
	
	    continuation = !!(digit & VLQ_CONTINUATION_BIT);
	    digit &= VLQ_BASE_MASK;
	    result = result + (digit << shift);
	    shift += VLQ_BASE_SHIFT;
	  } while (continuation);
	
	  aOutParam.value = fromVLQSigned(result);
	  aOutParam.rest = aIndex;
	};


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var base64VLQ = __webpack_require__(147);
	var util = __webpack_require__(48);
	var ArraySet = __webpack_require__(146).ArraySet;
	var MappingList = __webpack_require__(349).MappingList;
	
	/**
	 * An instance of the SourceMapGenerator represents a source map which is
	 * being built incrementally. You may pass an object with the following
	 * properties:
	 *
	 *   - file: The filename of the generated source.
	 *   - sourceRoot: A root for all relative URLs in this source map.
	 */
	function SourceMapGenerator(aArgs) {
	  if (!aArgs) {
	    aArgs = {};
	  }
	  this._file = util.getArg(aArgs, 'file', null);
	  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
	  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	  this._mappings = new MappingList();
	  this._sourcesContents = null;
	}
	
	SourceMapGenerator.prototype._version = 3;
	
	/**
	 * Creates a new SourceMapGenerator based on a SourceMapConsumer
	 *
	 * @param aSourceMapConsumer The SourceMap.
	 */
	SourceMapGenerator.fromSourceMap =
	  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
	    var sourceRoot = aSourceMapConsumer.sourceRoot;
	    var generator = new SourceMapGenerator({
	      file: aSourceMapConsumer.file,
	      sourceRoot: sourceRoot
	    });
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      var newMapping = {
	        generated: {
	          line: mapping.generatedLine,
	          column: mapping.generatedColumn
	        }
	      };
	
	      if (mapping.source != null) {
	        newMapping.source = mapping.source;
	        if (sourceRoot != null) {
	          newMapping.source = util.relative(sourceRoot, newMapping.source);
	        }
	
	        newMapping.original = {
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        };
	
	        if (mapping.name != null) {
	          newMapping.name = mapping.name;
	        }
	      }
	
	      generator.addMapping(newMapping);
	    });
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        generator.setSourceContent(sourceFile, content);
	      }
	    });
	    return generator;
	  };
	
	/**
	 * Add a single mapping from original source line and column to the generated
	 * source's line and column for this source map being created. The mapping
	 * object should have the following properties:
	 *
	 *   - generated: An object with the generated line and column positions.
	 *   - original: An object with the original line and column positions.
	 *   - source: The original source file (relative to the sourceRoot).
	 *   - name: An optional original token name for this mapping.
	 */
	SourceMapGenerator.prototype.addMapping =
	  function SourceMapGenerator_addMapping(aArgs) {
	    var generated = util.getArg(aArgs, 'generated');
	    var original = util.getArg(aArgs, 'original', null);
	    var source = util.getArg(aArgs, 'source', null);
	    var name = util.getArg(aArgs, 'name', null);
	
	    if (!this._skipValidation) {
	      this._validateMapping(generated, original, source, name);
	    }
	
	    if (source != null) {
	      source = String(source);
	      if (!this._sources.has(source)) {
	        this._sources.add(source);
	      }
	    }
	
	    if (name != null) {
	      name = String(name);
	      if (!this._names.has(name)) {
	        this._names.add(name);
	      }
	    }
	
	    this._mappings.add({
	      generatedLine: generated.line,
	      generatedColumn: generated.column,
	      originalLine: original != null && original.line,
	      originalColumn: original != null && original.column,
	      source: source,
	      name: name
	    });
	  };
	
	/**
	 * Set the source content for a source file.
	 */
	SourceMapGenerator.prototype.setSourceContent =
	  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
	    var source = aSourceFile;
	    if (this._sourceRoot != null) {
	      source = util.relative(this._sourceRoot, source);
	    }
	
	    if (aSourceContent != null) {
	      // Add the source content to the _sourcesContents map.
	      // Create a new _sourcesContents map if the property is null.
	      if (!this._sourcesContents) {
	        this._sourcesContents = Object.create(null);
	      }
	      this._sourcesContents[util.toSetString(source)] = aSourceContent;
	    } else if (this._sourcesContents) {
	      // Remove the source file from the _sourcesContents map.
	      // If the _sourcesContents map is empty, set the property to null.
	      delete this._sourcesContents[util.toSetString(source)];
	      if (Object.keys(this._sourcesContents).length === 0) {
	        this._sourcesContents = null;
	      }
	    }
	  };
	
	/**
	 * Applies the mappings of a sub-source-map for a specific source file to the
	 * source map being generated. Each mapping to the supplied source file is
	 * rewritten using the supplied source map. Note: The resolution for the
	 * resulting mappings is the minimium of this map and the supplied map.
	 *
	 * @param aSourceMapConsumer The source map to be applied.
	 * @param aSourceFile Optional. The filename of the source file.
	 *        If omitted, SourceMapConsumer's file property will be used.
	 * @param aSourceMapPath Optional. The dirname of the path to the source map
	 *        to be applied. If relative, it is relative to the SourceMapConsumer.
	 *        This parameter is needed when the two source maps aren't in the same
	 *        directory, and the source map to be applied contains relative source
	 *        paths. If so, those relative source paths need to be rewritten
	 *        relative to the SourceMapGenerator.
	 */
	SourceMapGenerator.prototype.applySourceMap =
	  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
	    var sourceFile = aSourceFile;
	    // If aSourceFile is omitted, we will use the file property of the SourceMap
	    if (aSourceFile == null) {
	      if (aSourceMapConsumer.file == null) {
	        throw new Error(
	          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
	          'or the source map\'s "file" property. Both were omitted.'
	        );
	      }
	      sourceFile = aSourceMapConsumer.file;
	    }
	    var sourceRoot = this._sourceRoot;
	    // Make "sourceFile" relative if an absolute Url is passed.
	    if (sourceRoot != null) {
	      sourceFile = util.relative(sourceRoot, sourceFile);
	    }
	    // Applying the SourceMap can add and remove items from the sources and
	    // the names array.
	    var newSources = new ArraySet();
	    var newNames = new ArraySet();
	
	    // Find mappings for the "sourceFile"
	    this._mappings.unsortedForEach(function (mapping) {
	      if (mapping.source === sourceFile && mapping.originalLine != null) {
	        // Check if it can be mapped by the source map, then update the mapping.
	        var original = aSourceMapConsumer.originalPositionFor({
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        });
	        if (original.source != null) {
	          // Copy mapping
	          mapping.source = original.source;
	          if (aSourceMapPath != null) {
	            mapping.source = util.join(aSourceMapPath, mapping.source)
	          }
	          if (sourceRoot != null) {
	            mapping.source = util.relative(sourceRoot, mapping.source);
	          }
	          mapping.originalLine = original.line;
	          mapping.originalColumn = original.column;
	          if (original.name != null) {
	            mapping.name = original.name;
	          }
	        }
	      }
	
	      var source = mapping.source;
	      if (source != null && !newSources.has(source)) {
	        newSources.add(source);
	      }
	
	      var name = mapping.name;
	      if (name != null && !newNames.has(name)) {
	        newNames.add(name);
	      }
	
	    }, this);
	    this._sources = newSources;
	    this._names = newNames;
	
	    // Copy sourcesContents of applied map.
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aSourceMapPath != null) {
	          sourceFile = util.join(aSourceMapPath, sourceFile);
	        }
	        if (sourceRoot != null) {
	          sourceFile = util.relative(sourceRoot, sourceFile);
	        }
	        this.setSourceContent(sourceFile, content);
	      }
	    }, this);
	  };
	
	/**
	 * A mapping can have one of the three levels of data:
	 *
	 *   1. Just the generated position.
	 *   2. The Generated position, original position, and original source.
	 *   3. Generated and original position, original source, as well as a name
	 *      token.
	 *
	 * To maintain consistency, we validate that any new mapping being added falls
	 * in to one of these categories.
	 */
	SourceMapGenerator.prototype._validateMapping =
	  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
	                                              aName) {
	    // When aOriginal is truthy but has empty values for .line and .column,
	    // it is most likely a programmer error. In this case we throw a very
	    // specific error message to try to guide them the right way.
	    // For example: https://github.com/Polymer/polymer-bundler/pull/519
	    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
	        throw new Error(
	            'original.line and original.column are not numbers -- you probably meant to omit ' +
	            'the original mapping entirely and only map the generated position. If so, pass ' +
	            'null for the original mapping instead of an object with empty or null values.'
	        );
	    }
	
	    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	        && aGenerated.line > 0 && aGenerated.column >= 0
	        && !aOriginal && !aSource && !aName) {
	      // Case 1.
	      return;
	    }
	    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
	             && aGenerated.line > 0 && aGenerated.column >= 0
	             && aOriginal.line > 0 && aOriginal.column >= 0
	             && aSource) {
	      // Cases 2 and 3.
	      return;
	    }
	    else {
	      throw new Error('Invalid mapping: ' + JSON.stringify({
	        generated: aGenerated,
	        source: aSource,
	        original: aOriginal,
	        name: aName
	      }));
	    }
	  };
	
	/**
	 * Serialize the accumulated mappings in to the stream of base 64 VLQs
	 * specified by the source map format.
	 */
	SourceMapGenerator.prototype._serializeMappings =
	  function SourceMapGenerator_serializeMappings() {
	    var previousGeneratedColumn = 0;
	    var previousGeneratedLine = 1;
	    var previousOriginalColumn = 0;
	    var previousOriginalLine = 0;
	    var previousName = 0;
	    var previousSource = 0;
	    var result = '';
	    var next;
	    var mapping;
	    var nameIdx;
	    var sourceIdx;
	
	    var mappings = this._mappings.toArray();
	    for (var i = 0, len = mappings.length; i < len; i++) {
	      mapping = mappings[i];
	      next = ''
	
	      if (mapping.generatedLine !== previousGeneratedLine) {
	        previousGeneratedColumn = 0;
	        while (mapping.generatedLine !== previousGeneratedLine) {
	          next += ';';
	          previousGeneratedLine++;
	        }
	      }
	      else {
	        if (i > 0) {
	          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
	            continue;
	          }
	          next += ',';
	        }
	      }
	
	      next += base64VLQ.encode(mapping.generatedColumn
	                                 - previousGeneratedColumn);
	      previousGeneratedColumn = mapping.generatedColumn;
	
	      if (mapping.source != null) {
	        sourceIdx = this._sources.indexOf(mapping.source);
	        next += base64VLQ.encode(sourceIdx - previousSource);
	        previousSource = sourceIdx;
	
	        // lines are stored 0-based in SourceMap spec version 3
	        next += base64VLQ.encode(mapping.originalLine - 1
	                                   - previousOriginalLine);
	        previousOriginalLine = mapping.originalLine - 1;
	
	        next += base64VLQ.encode(mapping.originalColumn
	                                   - previousOriginalColumn);
	        previousOriginalColumn = mapping.originalColumn;
	
	        if (mapping.name != null) {
	          nameIdx = this._names.indexOf(mapping.name);
	          next += base64VLQ.encode(nameIdx - previousName);
	          previousName = nameIdx;
	        }
	      }
	
	      result += next;
	    }
	
	    return result;
	  };
	
	SourceMapGenerator.prototype._generateSourcesContent =
	  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
	    return aSources.map(function (source) {
	      if (!this._sourcesContents) {
	        return null;
	      }
	      if (aSourceRoot != null) {
	        source = util.relative(aSourceRoot, source);
	      }
	      var key = util.toSetString(source);
	      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
	        ? this._sourcesContents[key]
	        : null;
	    }, this);
	  };
	
	/**
	 * Externalize the source map.
	 */
	SourceMapGenerator.prototype.toJSON =
	  function SourceMapGenerator_toJSON() {
	    var map = {
	      version: this._version,
	      sources: this._sources.toArray(),
	      names: this._names.toArray(),
	      mappings: this._serializeMappings()
	    };
	    if (this._file != null) {
	      map.file = this._file;
	    }
	    if (this._sourceRoot != null) {
	      map.sourceRoot = this._sourceRoot;
	    }
	    if (this._sourcesContents) {
	      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
	    }
	
	    return map;
	  };
	
	/**
	 * Render the source map being generated to a string.
	 */
	SourceMapGenerator.prototype.toString =
	  function SourceMapGenerator_toString() {
	    return JSON.stringify(this.toJSON());
	  };
	
	exports.SourceMapGenerator = SourceMapGenerator;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Toastr
	 * Copyright 2012-2015
	 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
	 * All Rights Reserved.
	 * Use, reproduction, distribution, and modification of this code is subject to the terms and
	 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	 *
	 * ARIA Support: Greta Krafsig
	 *
	 * Project: https://github.com/CodeSeven/toastr
	 */
	/* global define */
	(function (define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(36)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	        return (function () {
	            var $container;
	            var listener;
	            var toastId = 0;
	            var toastType = {
	                error: 'error',
	                info: 'info',
	                success: 'success',
	                warning: 'warning'
	            };
	
	            var toastr = {
	                clear: clear,
	                remove: remove,
	                error: error,
	                getContainer: getContainer,
	                info: info,
	                options: {},
	                subscribe: subscribe,
	                success: success,
	                version: '2.1.4',
	                warning: warning
	            };
	
	            var previousToast;
	
	            return toastr;
	
	            ////////////////
	
	            function error(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.error,
	                    iconClass: getOptions().iconClasses.error,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function getContainer(options, create) {
	                if (!options) { options = getOptions(); }
	                $container = $('#' + options.containerId);
	                if ($container.length) {
	                    return $container;
	                }
	                if (create) {
	                    $container = createContainer(options);
	                }
	                return $container;
	            }
	
	            function info(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.info,
	                    iconClass: getOptions().iconClasses.info,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function subscribe(callback) {
	                listener = callback;
	            }
	
	            function success(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.success,
	                    iconClass: getOptions().iconClasses.success,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function warning(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.warning,
	                    iconClass: getOptions().iconClasses.warning,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function clear($toastElement, clearOptions) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if (!clearToast($toastElement, options, clearOptions)) {
	                    clearContainer(options);
	                }
	            }
	
	            function remove($toastElement) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if ($toastElement && $(':focus', $toastElement).length === 0) {
	                    removeToast($toastElement);
	                    return;
	                }
	                if ($container.children().length) {
	                    $container.remove();
	                }
	            }
	
	            // internal functions
	
	            function clearContainer (options) {
	                var toastsToClear = $container.children();
	                for (var i = toastsToClear.length - 1; i >= 0; i--) {
	                    clearToast($(toastsToClear[i]), options);
	                }
	            }
	
	            function clearToast ($toastElement, options, clearOptions) {
	                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
	                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
	                    $toastElement[options.hideMethod]({
	                        duration: options.hideDuration,
	                        easing: options.hideEasing,
	                        complete: function () { removeToast($toastElement); }
	                    });
	                    return true;
	                }
	                return false;
	            }
	
	            function createContainer(options) {
	                $container = $('<div/>')
	                    .attr('id', options.containerId)
	                    .addClass(options.positionClass);
	
	                $container.appendTo($(options.target));
	                return $container;
	            }
	
	            function getDefaults() {
	                return {
	                    tapToDismiss: true,
	                    toastClass: 'toast',
	                    containerId: 'toast-container',
	                    debug: false,
	
	                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
	                    showDuration: 300,
	                    showEasing: 'swing', //swing and linear are built into jQuery
	                    onShown: undefined,
	                    hideMethod: 'fadeOut',
	                    hideDuration: 1000,
	                    hideEasing: 'swing',
	                    onHidden: undefined,
	                    closeMethod: false,
	                    closeDuration: false,
	                    closeEasing: false,
	                    closeOnHover: true,
	
	                    extendedTimeOut: 1000,
	                    iconClasses: {
	                        error: 'toast-error',
	                        info: 'toast-info',
	                        success: 'toast-success',
	                        warning: 'toast-warning'
	                    },
	                    iconClass: 'toast-info',
	                    positionClass: 'toast-top-right',
	                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
	                    titleClass: 'toast-title',
	                    messageClass: 'toast-message',
	                    escapeHtml: false,
	                    target: 'body',
	                    closeHtml: '<button type="button">&times;</button>',
	                    closeClass: 'toast-close-button',
	                    newestOnTop: true,
	                    preventDuplicates: false,
	                    progressBar: false,
	                    progressClass: 'toast-progress',
	                    rtl: false
	                };
	            }
	
	            function publish(args) {
	                if (!listener) { return; }
	                listener(args);
	            }
	
	            function notify(map) {
	                var options = getOptions();
	                var iconClass = map.iconClass || options.iconClass;
	
	                if (typeof (map.optionsOverride) !== 'undefined') {
	                    options = $.extend(options, map.optionsOverride);
	                    iconClass = map.optionsOverride.iconClass || iconClass;
	                }
	
	                if (shouldExit(options, map)) { return; }
	
	                toastId++;
	
	                $container = getContainer(options, true);
	
	                var intervalId = null;
	                var $toastElement = $('<div/>');
	                var $titleElement = $('<div/>');
	                var $messageElement = $('<div/>');
	                var $progressElement = $('<div/>');
	                var $closeElement = $(options.closeHtml);
	                var progressBar = {
	                    intervalId: null,
	                    hideEta: null,
	                    maxHideTime: null
	                };
	                var response = {
	                    toastId: toastId,
	                    state: 'visible',
	                    startTime: new Date(),
	                    options: options,
	                    map: map
	                };
	
	                personalizeToast();
	
	                displayToast();
	
	                handleEvents();
	
	                publish(response);
	
	                if (options.debug && console) {
	                    console.log(response);
	                }
	
	                return $toastElement;
	
	                function escapeHtml(source) {
	                    if (source == null) {
	                        source = '';
	                    }
	
	                    return source
	                        .replace(/&/g, '&amp;')
	                        .replace(/"/g, '&quot;')
	                        .replace(/'/g, '&#39;')
	                        .replace(/</g, '&lt;')
	                        .replace(/>/g, '&gt;');
	                }
	
	                function personalizeToast() {
	                    setIcon();
	                    setTitle();
	                    setMessage();
	                    setCloseButton();
	                    setProgressBar();
	                    setRTL();
	                    setSequence();
	                    setAria();
	                }
	
	                function setAria() {
	                    var ariaValue = '';
	                    switch (map.iconClass) {
	                        case 'toast-success':
	                        case 'toast-info':
	                            ariaValue =  'polite';
	                            break;
	                        default:
	                            ariaValue = 'assertive';
	                    }
	                    $toastElement.attr('aria-live', ariaValue);
	                }
	
	                function handleEvents() {
	                    if (options.closeOnHover) {
	                        $toastElement.hover(stickAround, delayedHideToast);
	                    }
	
	                    if (!options.onclick && options.tapToDismiss) {
	                        $toastElement.click(hideToast);
	                    }
	
	                    if (options.closeButton && $closeElement) {
	                        $closeElement.click(function (event) {
	                            if (event.stopPropagation) {
	                                event.stopPropagation();
	                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
	                                event.cancelBubble = true;
	                            }
	
	                            if (options.onCloseClick) {
	                                options.onCloseClick(event);
	                            }
	
	                            hideToast(true);
	                        });
	                    }
	
	                    if (options.onclick) {
	                        $toastElement.click(function (event) {
	                            options.onclick(event);
	                            hideToast();
	                        });
	                    }
	                }
	
	                function displayToast() {
	                    $toastElement.hide();
	
	                    $toastElement[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
	                    );
	
	                    if (options.timeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.timeOut);
	                        progressBar.maxHideTime = parseFloat(options.timeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                        if (options.progressBar) {
	                            progressBar.intervalId = setInterval(updateProgress, 10);
	                        }
	                    }
	                }
	
	                function setIcon() {
	                    if (map.iconClass) {
	                        $toastElement.addClass(options.toastClass).addClass(iconClass);
	                    }
	                }
	
	                function setSequence() {
	                    if (options.newestOnTop) {
	                        $container.prepend($toastElement);
	                    } else {
	                        $container.append($toastElement);
	                    }
	                }
	
	                function setTitle() {
	                    if (map.title) {
	                        var suffix = map.title;
	                        if (options.escapeHtml) {
	                            suffix = escapeHtml(map.title);
	                        }
	                        $titleElement.append(suffix).addClass(options.titleClass);
	                        $toastElement.append($titleElement);
	                    }
	                }
	
	                function setMessage() {
	                    if (map.message) {
	                        var suffix = map.message;
	                        if (options.escapeHtml) {
	                            suffix = escapeHtml(map.message);
	                        }
	                        $messageElement.append(suffix).addClass(options.messageClass);
	                        $toastElement.append($messageElement);
	                    }
	                }
	
	                function setCloseButton() {
	                    if (options.closeButton) {
	                        $closeElement.addClass(options.closeClass).attr('role', 'button');
	                        $toastElement.prepend($closeElement);
	                    }
	                }
	
	                function setProgressBar() {
	                    if (options.progressBar) {
	                        $progressElement.addClass(options.progressClass);
	                        $toastElement.prepend($progressElement);
	                    }
	                }
	
	                function setRTL() {
	                    if (options.rtl) {
	                        $toastElement.addClass('rtl');
	                    }
	                }
	
	                function shouldExit(options, map) {
	                    if (options.preventDuplicates) {
	                        if (map.message === previousToast) {
	                            return true;
	                        } else {
	                            previousToast = map.message;
	                        }
	                    }
	                    return false;
	                }
	
	                function hideToast(override) {
	                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
	                    var duration = override && options.closeDuration !== false ?
	                        options.closeDuration : options.hideDuration;
	                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
	                    if ($(':focus', $toastElement).length && !override) {
	                        return;
	                    }
	                    clearTimeout(progressBar.intervalId);
	                    return $toastElement[method]({
	                        duration: duration,
	                        easing: easing,
	                        complete: function () {
	                            removeToast($toastElement);
	                            clearTimeout(intervalId);
	                            if (options.onHidden && response.state !== 'hidden') {
	                                options.onHidden();
	                            }
	                            response.state = 'hidden';
	                            response.endTime = new Date();
	                            publish(response);
	                        }
	                    });
	                }
	
	                function delayedHideToast() {
	                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
	                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                    }
	                }
	
	                function stickAround() {
	                    clearTimeout(intervalId);
	                    progressBar.hideEta = 0;
	                    $toastElement.stop(true, true)[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing}
	                    );
	                }
	
	                function updateProgress() {
	                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
	                    $progressElement.width(percentage + '%');
	                }
	            }
	
	            function getOptions() {
	                return $.extend({}, getDefaults(), toastr.options);
	            }
	
	            function removeToast($toastElement) {
	                if (!$container) { $container = getContainer(); }
	                if ($toastElement.is(':visible')) {
	                    return;
	                }
	                $toastElement.remove();
	                $toastElement = null;
	                if ($container.children().length === 0) {
	                    $container.remove();
	                    previousToast = undefined;
	                }
	            }
	
	        })();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(390)));


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, __filename, global, __dirname) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved. 
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0  
	 
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE, 
	MERCHANTABLITY OR NON-INFRINGEMENT. 
	 
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var ts;
	(function (ts) {
	    /* @internal */
	    var Comparison;
	    (function (Comparison) {
	        Comparison[Comparison["LessThan"] = -1] = "LessThan";
	        Comparison[Comparison["EqualTo"] = 0] = "EqualTo";
	        Comparison[Comparison["GreaterThan"] = 1] = "GreaterThan";
	    })(Comparison = ts.Comparison || (ts.Comparison = {}));
	    // token > SyntaxKind.Identifer => token is a keyword
	    // Also, If you add a new SyntaxKind be sure to keep the `Markers` section at the bottom in sync
	    var SyntaxKind;
	    (function (SyntaxKind) {
	        SyntaxKind[SyntaxKind["Unknown"] = 0] = "Unknown";
	        SyntaxKind[SyntaxKind["EndOfFileToken"] = 1] = "EndOfFileToken";
	        SyntaxKind[SyntaxKind["SingleLineCommentTrivia"] = 2] = "SingleLineCommentTrivia";
	        SyntaxKind[SyntaxKind["MultiLineCommentTrivia"] = 3] = "MultiLineCommentTrivia";
	        SyntaxKind[SyntaxKind["NewLineTrivia"] = 4] = "NewLineTrivia";
	        SyntaxKind[SyntaxKind["WhitespaceTrivia"] = 5] = "WhitespaceTrivia";
	        // We detect and preserve #! on the first line
	        SyntaxKind[SyntaxKind["ShebangTrivia"] = 6] = "ShebangTrivia";
	        // We detect and provide better error recovery when we encounter a git merge marker.  This
	        // allows us to edit files with git-conflict markers in them in a much more pleasant manner.
	        SyntaxKind[SyntaxKind["ConflictMarkerTrivia"] = 7] = "ConflictMarkerTrivia";
	        // Literals
	        SyntaxKind[SyntaxKind["NumericLiteral"] = 8] = "NumericLiteral";
	        SyntaxKind[SyntaxKind["StringLiteral"] = 9] = "StringLiteral";
	        SyntaxKind[SyntaxKind["JsxText"] = 10] = "JsxText";
	        SyntaxKind[SyntaxKind["JsxTextAllWhiteSpaces"] = 11] = "JsxTextAllWhiteSpaces";
	        SyntaxKind[SyntaxKind["RegularExpressionLiteral"] = 12] = "RegularExpressionLiteral";
	        SyntaxKind[SyntaxKind["NoSubstitutionTemplateLiteral"] = 13] = "NoSubstitutionTemplateLiteral";
	        // Pseudo-literals
	        SyntaxKind[SyntaxKind["TemplateHead"] = 14] = "TemplateHead";
	        SyntaxKind[SyntaxKind["TemplateMiddle"] = 15] = "TemplateMiddle";
	        SyntaxKind[SyntaxKind["TemplateTail"] = 16] = "TemplateTail";
	        // Punctuation
	        SyntaxKind[SyntaxKind["OpenBraceToken"] = 17] = "OpenBraceToken";
	        SyntaxKind[SyntaxKind["CloseBraceToken"] = 18] = "CloseBraceToken";
	        SyntaxKind[SyntaxKind["OpenParenToken"] = 19] = "OpenParenToken";
	        SyntaxKind[SyntaxKind["CloseParenToken"] = 20] = "CloseParenToken";
	        SyntaxKind[SyntaxKind["OpenBracketToken"] = 21] = "OpenBracketToken";
	        SyntaxKind[SyntaxKind["CloseBracketToken"] = 22] = "CloseBracketToken";
	        SyntaxKind[SyntaxKind["DotToken"] = 23] = "DotToken";
	        SyntaxKind[SyntaxKind["DotDotDotToken"] = 24] = "DotDotDotToken";
	        SyntaxKind[SyntaxKind["SemicolonToken"] = 25] = "SemicolonToken";
	        SyntaxKind[SyntaxKind["CommaToken"] = 26] = "CommaToken";
	        SyntaxKind[SyntaxKind["LessThanToken"] = 27] = "LessThanToken";
	        SyntaxKind[SyntaxKind["LessThanSlashToken"] = 28] = "LessThanSlashToken";
	        SyntaxKind[SyntaxKind["GreaterThanToken"] = 29] = "GreaterThanToken";
	        SyntaxKind[SyntaxKind["LessThanEqualsToken"] = 30] = "LessThanEqualsToken";
	        SyntaxKind[SyntaxKind["GreaterThanEqualsToken"] = 31] = "GreaterThanEqualsToken";
	        SyntaxKind[SyntaxKind["EqualsEqualsToken"] = 32] = "EqualsEqualsToken";
	        SyntaxKind[SyntaxKind["ExclamationEqualsToken"] = 33] = "ExclamationEqualsToken";
	        SyntaxKind[SyntaxKind["EqualsEqualsEqualsToken"] = 34] = "EqualsEqualsEqualsToken";
	        SyntaxKind[SyntaxKind["ExclamationEqualsEqualsToken"] = 35] = "ExclamationEqualsEqualsToken";
	        SyntaxKind[SyntaxKind["EqualsGreaterThanToken"] = 36] = "EqualsGreaterThanToken";
	        SyntaxKind[SyntaxKind["PlusToken"] = 37] = "PlusToken";
	        SyntaxKind[SyntaxKind["MinusToken"] = 38] = "MinusToken";
	        SyntaxKind[SyntaxKind["AsteriskToken"] = 39] = "AsteriskToken";
	        SyntaxKind[SyntaxKind["AsteriskAsteriskToken"] = 40] = "AsteriskAsteriskToken";
	        SyntaxKind[SyntaxKind["SlashToken"] = 41] = "SlashToken";
	        SyntaxKind[SyntaxKind["PercentToken"] = 42] = "PercentToken";
	        SyntaxKind[SyntaxKind["PlusPlusToken"] = 43] = "PlusPlusToken";
	        SyntaxKind[SyntaxKind["MinusMinusToken"] = 44] = "MinusMinusToken";
	        SyntaxKind[SyntaxKind["LessThanLessThanToken"] = 45] = "LessThanLessThanToken";
	        SyntaxKind[SyntaxKind["GreaterThanGreaterThanToken"] = 46] = "GreaterThanGreaterThanToken";
	        SyntaxKind[SyntaxKind["GreaterThanGreaterThanGreaterThanToken"] = 47] = "GreaterThanGreaterThanGreaterThanToken";
	        SyntaxKind[SyntaxKind["AmpersandToken"] = 48] = "AmpersandToken";
	        SyntaxKind[SyntaxKind["BarToken"] = 49] = "BarToken";
	        SyntaxKind[SyntaxKind["CaretToken"] = 50] = "CaretToken";
	        SyntaxKind[SyntaxKind["ExclamationToken"] = 51] = "ExclamationToken";
	        SyntaxKind[SyntaxKind["TildeToken"] = 52] = "TildeToken";
	        SyntaxKind[SyntaxKind["AmpersandAmpersandToken"] = 53] = "AmpersandAmpersandToken";
	        SyntaxKind[SyntaxKind["BarBarToken"] = 54] = "BarBarToken";
	        SyntaxKind[SyntaxKind["QuestionToken"] = 55] = "QuestionToken";
	        SyntaxKind[SyntaxKind["ColonToken"] = 56] = "ColonToken";
	        SyntaxKind[SyntaxKind["AtToken"] = 57] = "AtToken";
	        // Assignments
	        SyntaxKind[SyntaxKind["EqualsToken"] = 58] = "EqualsToken";
	        SyntaxKind[SyntaxKind["PlusEqualsToken"] = 59] = "PlusEqualsToken";
	        SyntaxKind[SyntaxKind["MinusEqualsToken"] = 60] = "MinusEqualsToken";
	        SyntaxKind[SyntaxKind["AsteriskEqualsToken"] = 61] = "AsteriskEqualsToken";
	        SyntaxKind[SyntaxKind["AsteriskAsteriskEqualsToken"] = 62] = "AsteriskAsteriskEqualsToken";
	        SyntaxKind[SyntaxKind["SlashEqualsToken"] = 63] = "SlashEqualsToken";
	        SyntaxKind[SyntaxKind["PercentEqualsToken"] = 64] = "PercentEqualsToken";
	        SyntaxKind[SyntaxKind["LessThanLessThanEqualsToken"] = 65] = "LessThanLessThanEqualsToken";
	        SyntaxKind[SyntaxKind["GreaterThanGreaterThanEqualsToken"] = 66] = "GreaterThanGreaterThanEqualsToken";
	        SyntaxKind[SyntaxKind["GreaterThanGreaterThanGreaterThanEqualsToken"] = 67] = "GreaterThanGreaterThanGreaterThanEqualsToken";
	        SyntaxKind[SyntaxKind["AmpersandEqualsToken"] = 68] = "AmpersandEqualsToken";
	        SyntaxKind[SyntaxKind["BarEqualsToken"] = 69] = "BarEqualsToken";
	        SyntaxKind[SyntaxKind["CaretEqualsToken"] = 70] = "CaretEqualsToken";
	        // Identifiers
	        SyntaxKind[SyntaxKind["Identifier"] = 71] = "Identifier";
	        // Reserved words
	        SyntaxKind[SyntaxKind["BreakKeyword"] = 72] = "BreakKeyword";
	        SyntaxKind[SyntaxKind["CaseKeyword"] = 73] = "CaseKeyword";
	        SyntaxKind[SyntaxKind["CatchKeyword"] = 74] = "CatchKeyword";
	        SyntaxKind[SyntaxKind["ClassKeyword"] = 75] = "ClassKeyword";
	        SyntaxKind[SyntaxKind["ConstKeyword"] = 76] = "ConstKeyword";
	        SyntaxKind[SyntaxKind["ContinueKeyword"] = 77] = "ContinueKeyword";
	        SyntaxKind[SyntaxKind["DebuggerKeyword"] = 78] = "DebuggerKeyword";
	        SyntaxKind[SyntaxKind["DefaultKeyword"] = 79] = "DefaultKeyword";
	        SyntaxKind[SyntaxKind["DeleteKeyword"] = 80] = "DeleteKeyword";
	        SyntaxKind[SyntaxKind["DoKeyword"] = 81] = "DoKeyword";
	        SyntaxKind[SyntaxKind["ElseKeyword"] = 82] = "ElseKeyword";
	        SyntaxKind[SyntaxKind["EnumKeyword"] = 83] = "EnumKeyword";
	        SyntaxKind[SyntaxKind["ExportKeyword"] = 84] = "ExportKeyword";
	        SyntaxKind[SyntaxKind["ExtendsKeyword"] = 85] = "ExtendsKeyword";
	        SyntaxKind[SyntaxKind["FalseKeyword"] = 86] = "FalseKeyword";
	        SyntaxKind[SyntaxKind["FinallyKeyword"] = 87] = "FinallyKeyword";
	        SyntaxKind[SyntaxKind["ForKeyword"] = 88] = "ForKeyword";
	        SyntaxKind[SyntaxKind["FunctionKeyword"] = 89] = "FunctionKeyword";
	        SyntaxKind[SyntaxKind["IfKeyword"] = 90] = "IfKeyword";
	        SyntaxKind[SyntaxKind["ImportKeyword"] = 91] = "ImportKeyword";
	        SyntaxKind[SyntaxKind["InKeyword"] = 92] = "InKeyword";
	        SyntaxKind[SyntaxKind["InstanceOfKeyword"] = 93] = "InstanceOfKeyword";
	        SyntaxKind[SyntaxKind["NewKeyword"] = 94] = "NewKeyword";
	        SyntaxKind[SyntaxKind["NullKeyword"] = 95] = "NullKeyword";
	        SyntaxKind[SyntaxKind["ReturnKeyword"] = 96] = "ReturnKeyword";
	        SyntaxKind[SyntaxKind["SuperKeyword"] = 97] = "SuperKeyword";
	        SyntaxKind[SyntaxKind["SwitchKeyword"] = 98] = "SwitchKeyword";
	        SyntaxKind[SyntaxKind["ThisKeyword"] = 99] = "ThisKeyword";
	        SyntaxKind[SyntaxKind["ThrowKeyword"] = 100] = "ThrowKeyword";
	        SyntaxKind[SyntaxKind["TrueKeyword"] = 101] = "TrueKeyword";
	        SyntaxKind[SyntaxKind["TryKeyword"] = 102] = "TryKeyword";
	        SyntaxKind[SyntaxKind["TypeOfKeyword"] = 103] = "TypeOfKeyword";
	        SyntaxKind[SyntaxKind["VarKeyword"] = 104] = "VarKeyword";
	        SyntaxKind[SyntaxKind["VoidKeyword"] = 105] = "VoidKeyword";
	        SyntaxKind[SyntaxKind["WhileKeyword"] = 106] = "WhileKeyword";
	        SyntaxKind[SyntaxKind["WithKeyword"] = 107] = "WithKeyword";
	        // Strict mode reserved words
	        SyntaxKind[SyntaxKind["ImplementsKeyword"] = 108] = "ImplementsKeyword";
	        SyntaxKind[SyntaxKind["InterfaceKeyword"] = 109] = "InterfaceKeyword";
	        SyntaxKind[SyntaxKind["LetKeyword"] = 110] = "LetKeyword";
	        SyntaxKind[SyntaxKind["PackageKeyword"] = 111] = "PackageKeyword";
	        SyntaxKind[SyntaxKind["PrivateKeyword"] = 112] = "PrivateKeyword";
	        SyntaxKind[SyntaxKind["ProtectedKeyword"] = 113] = "ProtectedKeyword";
	        SyntaxKind[SyntaxKind["PublicKeyword"] = 114] = "PublicKeyword";
	        SyntaxKind[SyntaxKind["StaticKeyword"] = 115] = "StaticKeyword";
	        SyntaxKind[SyntaxKind["YieldKeyword"] = 116] = "YieldKeyword";
	        // Contextual keywords
	        SyntaxKind[SyntaxKind["AbstractKeyword"] = 117] = "AbstractKeyword";
	        SyntaxKind[SyntaxKind["AsKeyword"] = 118] = "AsKeyword";
	        SyntaxKind[SyntaxKind["AnyKeyword"] = 119] = "AnyKeyword";
	        SyntaxKind[SyntaxKind["AsyncKeyword"] = 120] = "AsyncKeyword";
	        SyntaxKind[SyntaxKind["AwaitKeyword"] = 121] = "AwaitKeyword";
	        SyntaxKind[SyntaxKind["BooleanKeyword"] = 122] = "BooleanKeyword";
	        SyntaxKind[SyntaxKind["ConstructorKeyword"] = 123] = "ConstructorKeyword";
	        SyntaxKind[SyntaxKind["DeclareKeyword"] = 124] = "DeclareKeyword";
	        SyntaxKind[SyntaxKind["GetKeyword"] = 125] = "GetKeyword";
	        SyntaxKind[SyntaxKind["InferKeyword"] = 126] = "InferKeyword";
	        SyntaxKind[SyntaxKind["IsKeyword"] = 127] = "IsKeyword";
	        SyntaxKind[SyntaxKind["KeyOfKeyword"] = 128] = "KeyOfKeyword";
	        SyntaxKind[SyntaxKind["ModuleKeyword"] = 129] = "ModuleKeyword";
	        SyntaxKind[SyntaxKind["NamespaceKeyword"] = 130] = "NamespaceKeyword";
	        SyntaxKind[SyntaxKind["NeverKeyword"] = 131] = "NeverKeyword";
	        SyntaxKind[SyntaxKind["ReadonlyKeyword"] = 132] = "ReadonlyKeyword";
	        SyntaxKind[SyntaxKind["RequireKeyword"] = 133] = "RequireKeyword";
	        SyntaxKind[SyntaxKind["NumberKeyword"] = 134] = "NumberKeyword";
	        SyntaxKind[SyntaxKind["ObjectKeyword"] = 135] = "ObjectKeyword";
	        SyntaxKind[SyntaxKind["SetKeyword"] = 136] = "SetKeyword";
	        SyntaxKind[SyntaxKind["StringKeyword"] = 137] = "StringKeyword";
	        SyntaxKind[SyntaxKind["SymbolKeyword"] = 138] = "SymbolKeyword";
	        SyntaxKind[SyntaxKind["TypeKeyword"] = 139] = "TypeKeyword";
	        SyntaxKind[SyntaxKind["UndefinedKeyword"] = 140] = "UndefinedKeyword";
	        SyntaxKind[SyntaxKind["UniqueKeyword"] = 141] = "UniqueKeyword";
	        SyntaxKind[SyntaxKind["FromKeyword"] = 142] = "FromKeyword";
	        SyntaxKind[SyntaxKind["GlobalKeyword"] = 143] = "GlobalKeyword";
	        SyntaxKind[SyntaxKind["OfKeyword"] = 144] = "OfKeyword";
	        // Parse tree nodes
	        // Names
	        SyntaxKind[SyntaxKind["QualifiedName"] = 145] = "QualifiedName";
	        SyntaxKind[SyntaxKind["ComputedPropertyName"] = 146] = "ComputedPropertyName";
	        // Signature elements
	        SyntaxKind[SyntaxKind["TypeParameter"] = 147] = "TypeParameter";
	        SyntaxKind[SyntaxKind["Parameter"] = 148] = "Parameter";
	        SyntaxKind[SyntaxKind["Decorator"] = 149] = "Decorator";
	        // TypeMember
	        SyntaxKind[SyntaxKind["PropertySignature"] = 150] = "PropertySignature";
	        SyntaxKind[SyntaxKind["PropertyDeclaration"] = 151] = "PropertyDeclaration";
	        SyntaxKind[SyntaxKind["MethodSignature"] = 152] = "MethodSignature";
	        SyntaxKind[SyntaxKind["MethodDeclaration"] = 153] = "MethodDeclaration";
	        SyntaxKind[SyntaxKind["Constructor"] = 154] = "Constructor";
	        SyntaxKind[SyntaxKind["GetAccessor"] = 155] = "GetAccessor";
	        SyntaxKind[SyntaxKind["SetAccessor"] = 156] = "SetAccessor";
	        SyntaxKind[SyntaxKind["CallSignature"] = 157] = "CallSignature";
	        SyntaxKind[SyntaxKind["ConstructSignature"] = 158] = "ConstructSignature";
	        SyntaxKind[SyntaxKind["IndexSignature"] = 159] = "IndexSignature";
	        // Type
	        SyntaxKind[SyntaxKind["TypePredicate"] = 160] = "TypePredicate";
	        SyntaxKind[SyntaxKind["TypeReference"] = 161] = "TypeReference";
	        SyntaxKind[SyntaxKind["FunctionType"] = 162] = "FunctionType";
	        SyntaxKind[SyntaxKind["ConstructorType"] = 163] = "ConstructorType";
	        SyntaxKind[SyntaxKind["TypeQuery"] = 164] = "TypeQuery";
	        SyntaxKind[SyntaxKind["TypeLiteral"] = 165] = "TypeLiteral";
	        SyntaxKind[SyntaxKind["ArrayType"] = 166] = "ArrayType";
	        SyntaxKind[SyntaxKind["TupleType"] = 167] = "TupleType";
	        SyntaxKind[SyntaxKind["UnionType"] = 168] = "UnionType";
	        SyntaxKind[SyntaxKind["IntersectionType"] = 169] = "IntersectionType";
	        SyntaxKind[SyntaxKind["ConditionalType"] = 170] = "ConditionalType";
	        SyntaxKind[SyntaxKind["InferType"] = 171] = "InferType";
	        SyntaxKind[SyntaxKind["ParenthesizedType"] = 172] = "ParenthesizedType";
	        SyntaxKind[SyntaxKind["ThisType"] = 173] = "ThisType";
	        SyntaxKind[SyntaxKind["TypeOperator"] = 174] = "TypeOperator";
	        SyntaxKind[SyntaxKind["IndexedAccessType"] = 175] = "IndexedAccessType";
	        SyntaxKind[SyntaxKind["MappedType"] = 176] = "MappedType";
	        SyntaxKind[SyntaxKind["LiteralType"] = 177] = "LiteralType";
	        // Binding patterns
	        SyntaxKind[SyntaxKind["ObjectBindingPattern"] = 178] = "ObjectBindingPattern";
	        SyntaxKind[SyntaxKind["ArrayBindingPattern"] = 179] = "ArrayBindingPattern";
	        SyntaxKind[SyntaxKind["BindingElement"] = 180] = "BindingElement";
	        // Expression
	        SyntaxKind[SyntaxKind["ArrayLiteralExpression"] = 181] = "ArrayLiteralExpression";
	        SyntaxKind[SyntaxKind["ObjectLiteralExpression"] = 182] = "ObjectLiteralExpression";
	        SyntaxKind[SyntaxKind["PropertyAccessExpression"] = 183] = "PropertyAccessExpression";
	        SyntaxKind[SyntaxKind["ElementAccessExpression"] = 184] = "ElementAccessExpression";
	        SyntaxKind[SyntaxKind["CallExpression"] = 185] = "CallExpression";
	        SyntaxKind[SyntaxKind["NewExpression"] = 186] = "NewExpression";
	        SyntaxKind[SyntaxKind["TaggedTemplateExpression"] = 187] = "TaggedTemplateExpression";
	        SyntaxKind[SyntaxKind["TypeAssertionExpression"] = 188] = "TypeAssertionExpression";
	        SyntaxKind[SyntaxKind["ParenthesizedExpression"] = 189] = "ParenthesizedExpression";
	        SyntaxKind[SyntaxKind["FunctionExpression"] = 190] = "FunctionExpression";
	        SyntaxKind[SyntaxKind["ArrowFunction"] = 191] = "ArrowFunction";
	        SyntaxKind[SyntaxKind["DeleteExpression"] = 192] = "DeleteExpression";
	        SyntaxKind[SyntaxKind["TypeOfExpression"] = 193] = "TypeOfExpression";
	        SyntaxKind[SyntaxKind["VoidExpression"] = 194] = "VoidExpression";
	        SyntaxKind[SyntaxKind["AwaitExpression"] = 195] = "AwaitExpression";
	        SyntaxKind[SyntaxKind["PrefixUnaryExpression"] = 196] = "PrefixUnaryExpression";
	        SyntaxKind[SyntaxKind["PostfixUnaryExpression"] = 197] = "PostfixUnaryExpression";
	        SyntaxKind[SyntaxKind["BinaryExpression"] = 198] = "BinaryExpression";
	        SyntaxKind[SyntaxKind["ConditionalExpression"] = 199] = "ConditionalExpression";
	        SyntaxKind[SyntaxKind["TemplateExpression"] = 200] = "TemplateExpression";
	        SyntaxKind[SyntaxKind["YieldExpression"] = 201] = "YieldExpression";
	        SyntaxKind[SyntaxKind["SpreadElement"] = 202] = "SpreadElement";
	        SyntaxKind[SyntaxKind["ClassExpression"] = 203] = "ClassExpression";
	        SyntaxKind[SyntaxKind["OmittedExpression"] = 204] = "OmittedExpression";
	        SyntaxKind[SyntaxKind["ExpressionWithTypeArguments"] = 205] = "ExpressionWithTypeArguments";
	        SyntaxKind[SyntaxKind["AsExpression"] = 206] = "AsExpression";
	        SyntaxKind[SyntaxKind["NonNullExpression"] = 207] = "NonNullExpression";
	        SyntaxKind[SyntaxKind["MetaProperty"] = 208] = "MetaProperty";
	        // Misc
	        SyntaxKind[SyntaxKind["TemplateSpan"] = 209] = "TemplateSpan";
	        SyntaxKind[SyntaxKind["SemicolonClassElement"] = 210] = "SemicolonClassElement";
	        // Element
	        SyntaxKind[SyntaxKind["Block"] = 211] = "Block";
	        SyntaxKind[SyntaxKind["VariableStatement"] = 212] = "VariableStatement";
	        SyntaxKind[SyntaxKind["EmptyStatement"] = 213] = "EmptyStatement";
	        SyntaxKind[SyntaxKind["ExpressionStatement"] = 214] = "ExpressionStatement";
	        SyntaxKind[SyntaxKind["IfStatement"] = 215] = "IfStatement";
	        SyntaxKind[SyntaxKind["DoStatement"] = 216] = "DoStatement";
	        SyntaxKind[SyntaxKind["WhileStatement"] = 217] = "WhileStatement";
	        SyntaxKind[SyntaxKind["ForStatement"] = 218] = "ForStatement";
	        SyntaxKind[SyntaxKind["ForInStatement"] = 219] = "ForInStatement";
	        SyntaxKind[SyntaxKind["ForOfStatement"] = 220] = "ForOfStatement";
	        SyntaxKind[SyntaxKind["ContinueStatement"] = 221] = "ContinueStatement";
	        SyntaxKind[SyntaxKind["BreakStatement"] = 222] = "BreakStatement";
	        SyntaxKind[SyntaxKind["ReturnStatement"] = 223] = "ReturnStatement";
	        SyntaxKind[SyntaxKind["WithStatement"] = 224] = "WithStatement";
	        SyntaxKind[SyntaxKind["SwitchStatement"] = 225] = "SwitchStatement";
	        SyntaxKind[SyntaxKind["LabeledStatement"] = 226] = "LabeledStatement";
	        SyntaxKind[SyntaxKind["ThrowStatement"] = 227] = "ThrowStatement";
	        SyntaxKind[SyntaxKind["TryStatement"] = 228] = "TryStatement";
	        SyntaxKind[SyntaxKind["DebuggerStatement"] = 229] = "DebuggerStatement";
	        SyntaxKind[SyntaxKind["VariableDeclaration"] = 230] = "VariableDeclaration";
	        SyntaxKind[SyntaxKind["VariableDeclarationList"] = 231] = "VariableDeclarationList";
	        SyntaxKind[SyntaxKind["FunctionDeclaration"] = 232] = "FunctionDeclaration";
	        SyntaxKind[SyntaxKind["ClassDeclaration"] = 233] = "ClassDeclaration";
	        SyntaxKind[SyntaxKind["InterfaceDeclaration"] = 234] = "InterfaceDeclaration";
	        SyntaxKind[SyntaxKind["TypeAliasDeclaration"] = 235] = "TypeAliasDeclaration";
	        SyntaxKind[SyntaxKind["EnumDeclaration"] = 236] = "EnumDeclaration";
	        SyntaxKind[SyntaxKind["ModuleDeclaration"] = 237] = "ModuleDeclaration";
	        SyntaxKind[SyntaxKind["ModuleBlock"] = 238] = "ModuleBlock";
	        SyntaxKind[SyntaxKind["CaseBlock"] = 239] = "CaseBlock";
	        SyntaxKind[SyntaxKind["NamespaceExportDeclaration"] = 240] = "NamespaceExportDeclaration";
	        SyntaxKind[SyntaxKind["ImportEqualsDeclaration"] = 241] = "ImportEqualsDeclaration";
	        SyntaxKind[SyntaxKind["ImportDeclaration"] = 242] = "ImportDeclaration";
	        SyntaxKind[SyntaxKind["ImportClause"] = 243] = "ImportClause";
	        SyntaxKind[SyntaxKind["NamespaceImport"] = 244] = "NamespaceImport";
	        SyntaxKind[SyntaxKind["NamedImports"] = 245] = "NamedImports";
	        SyntaxKind[SyntaxKind["ImportSpecifier"] = 246] = "ImportSpecifier";
	        SyntaxKind[SyntaxKind["ExportAssignment"] = 247] = "ExportAssignment";
	        SyntaxKind[SyntaxKind["ExportDeclaration"] = 248] = "ExportDeclaration";
	        SyntaxKind[SyntaxKind["NamedExports"] = 249] = "NamedExports";
	        SyntaxKind[SyntaxKind["ExportSpecifier"] = 250] = "ExportSpecifier";
	        SyntaxKind[SyntaxKind["MissingDeclaration"] = 251] = "MissingDeclaration";
	        // Module references
	        SyntaxKind[SyntaxKind["ExternalModuleReference"] = 252] = "ExternalModuleReference";
	        // JSX
	        SyntaxKind[SyntaxKind["JsxElement"] = 253] = "JsxElement";
	        SyntaxKind[SyntaxKind["JsxSelfClosingElement"] = 254] = "JsxSelfClosingElement";
	        SyntaxKind[SyntaxKind["JsxOpeningElement"] = 255] = "JsxOpeningElement";
	        SyntaxKind[SyntaxKind["JsxClosingElement"] = 256] = "JsxClosingElement";
	        SyntaxKind[SyntaxKind["JsxFragment"] = 257] = "JsxFragment";
	        SyntaxKind[SyntaxKind["JsxOpeningFragment"] = 258] = "JsxOpeningFragment";
	        SyntaxKind[SyntaxKind["JsxClosingFragment"] = 259] = "JsxClosingFragment";
	        SyntaxKind[SyntaxKind["JsxAttribute"] = 260] = "JsxAttribute";
	        SyntaxKind[SyntaxKind["JsxAttributes"] = 261] = "JsxAttributes";
	        SyntaxKind[SyntaxKind["JsxSpreadAttribute"] = 262] = "JsxSpreadAttribute";
	        SyntaxKind[SyntaxKind["JsxExpression"] = 263] = "JsxExpression";
	        // Clauses
	        SyntaxKind[SyntaxKind["CaseClause"] = 264] = "CaseClause";
	        SyntaxKind[SyntaxKind["DefaultClause"] = 265] = "DefaultClause";
	        SyntaxKind[SyntaxKind["HeritageClause"] = 266] = "HeritageClause";
	        SyntaxKind[SyntaxKind["CatchClause"] = 267] = "CatchClause";
	        // Property assignments
	        SyntaxKind[SyntaxKind["PropertyAssignment"] = 268] = "PropertyAssignment";
	        SyntaxKind[SyntaxKind["ShorthandPropertyAssignment"] = 269] = "ShorthandPropertyAssignment";
	        SyntaxKind[SyntaxKind["SpreadAssignment"] = 270] = "SpreadAssignment";
	        // Enum
	        SyntaxKind[SyntaxKind["EnumMember"] = 271] = "EnumMember";
	        // Top-level nodes
	        SyntaxKind[SyntaxKind["SourceFile"] = 272] = "SourceFile";
	        SyntaxKind[SyntaxKind["Bundle"] = 273] = "Bundle";
	        // JSDoc nodes
	        SyntaxKind[SyntaxKind["JSDocTypeExpression"] = 274] = "JSDocTypeExpression";
	        // The * type
	        SyntaxKind[SyntaxKind["JSDocAllType"] = 275] = "JSDocAllType";
	        // The ? type
	        SyntaxKind[SyntaxKind["JSDocUnknownType"] = 276] = "JSDocUnknownType";
	        SyntaxKind[SyntaxKind["JSDocNullableType"] = 277] = "JSDocNullableType";
	        SyntaxKind[SyntaxKind["JSDocNonNullableType"] = 278] = "JSDocNonNullableType";
	        SyntaxKind[SyntaxKind["JSDocOptionalType"] = 279] = "JSDocOptionalType";
	        SyntaxKind[SyntaxKind["JSDocFunctionType"] = 280] = "JSDocFunctionType";
	        SyntaxKind[SyntaxKind["JSDocVariadicType"] = 281] = "JSDocVariadicType";
	        SyntaxKind[SyntaxKind["JSDocComment"] = 282] = "JSDocComment";
	        SyntaxKind[SyntaxKind["JSDocTypeLiteral"] = 283] = "JSDocTypeLiteral";
	        SyntaxKind[SyntaxKind["JSDocTag"] = 284] = "JSDocTag";
	        SyntaxKind[SyntaxKind["JSDocAugmentsTag"] = 285] = "JSDocAugmentsTag";
	        SyntaxKind[SyntaxKind["JSDocClassTag"] = 286] = "JSDocClassTag";
	        SyntaxKind[SyntaxKind["JSDocParameterTag"] = 287] = "JSDocParameterTag";
	        SyntaxKind[SyntaxKind["JSDocReturnTag"] = 288] = "JSDocReturnTag";
	        SyntaxKind[SyntaxKind["JSDocTypeTag"] = 289] = "JSDocTypeTag";
	        SyntaxKind[SyntaxKind["JSDocTemplateTag"] = 290] = "JSDocTemplateTag";
	        SyntaxKind[SyntaxKind["JSDocTypedefTag"] = 291] = "JSDocTypedefTag";
	        SyntaxKind[SyntaxKind["JSDocPropertyTag"] = 292] = "JSDocPropertyTag";
	        // Synthesized list
	        SyntaxKind[SyntaxKind["SyntaxList"] = 293] = "SyntaxList";
	        // Transformation nodes
	        SyntaxKind[SyntaxKind["NotEmittedStatement"] = 294] = "NotEmittedStatement";
	        SyntaxKind[SyntaxKind["PartiallyEmittedExpression"] = 295] = "PartiallyEmittedExpression";
	        SyntaxKind[SyntaxKind["CommaListExpression"] = 296] = "CommaListExpression";
	        SyntaxKind[SyntaxKind["MergeDeclarationMarker"] = 297] = "MergeDeclarationMarker";
	        SyntaxKind[SyntaxKind["EndOfDeclarationMarker"] = 298] = "EndOfDeclarationMarker";
	        // Enum value count
	        SyntaxKind[SyntaxKind["Count"] = 299] = "Count";
	        // Markers
	        SyntaxKind[SyntaxKind["FirstAssignment"] = 58] = "FirstAssignment";
	        SyntaxKind[SyntaxKind["LastAssignment"] = 70] = "LastAssignment";
	        SyntaxKind[SyntaxKind["FirstCompoundAssignment"] = 59] = "FirstCompoundAssignment";
	        SyntaxKind[SyntaxKind["LastCompoundAssignment"] = 70] = "LastCompoundAssignment";
	        SyntaxKind[SyntaxKind["FirstReservedWord"] = 72] = "FirstReservedWord";
	        SyntaxKind[SyntaxKind["LastReservedWord"] = 107] = "LastReservedWord";
	        SyntaxKind[SyntaxKind["FirstKeyword"] = 72] = "FirstKeyword";
	        SyntaxKind[SyntaxKind["LastKeyword"] = 144] = "LastKeyword";
	        SyntaxKind[SyntaxKind["FirstFutureReservedWord"] = 108] = "FirstFutureReservedWord";
	        SyntaxKind[SyntaxKind["LastFutureReservedWord"] = 116] = "LastFutureReservedWord";
	        SyntaxKind[SyntaxKind["FirstTypeNode"] = 160] = "FirstTypeNode";
	        SyntaxKind[SyntaxKind["LastTypeNode"] = 177] = "LastTypeNode";
	        SyntaxKind[SyntaxKind["FirstPunctuation"] = 17] = "FirstPunctuation";
	        SyntaxKind[SyntaxKind["LastPunctuation"] = 70] = "LastPunctuation";
	        SyntaxKind[SyntaxKind["FirstToken"] = 0] = "FirstToken";
	        SyntaxKind[SyntaxKind["LastToken"] = 144] = "LastToken";
	        SyntaxKind[SyntaxKind["FirstTriviaToken"] = 2] = "FirstTriviaToken";
	        SyntaxKind[SyntaxKind["LastTriviaToken"] = 7] = "LastTriviaToken";
	        SyntaxKind[SyntaxKind["FirstLiteralToken"] = 8] = "FirstLiteralToken";
	        SyntaxKind[SyntaxKind["LastLiteralToken"] = 13] = "LastLiteralToken";
	        SyntaxKind[SyntaxKind["FirstTemplateToken"] = 13] = "FirstTemplateToken";
	        SyntaxKind[SyntaxKind["LastTemplateToken"] = 16] = "LastTemplateToken";
	        SyntaxKind[SyntaxKind["FirstBinaryOperator"] = 27] = "FirstBinaryOperator";
	        SyntaxKind[SyntaxKind["LastBinaryOperator"] = 70] = "LastBinaryOperator";
	        SyntaxKind[SyntaxKind["FirstNode"] = 145] = "FirstNode";
	        SyntaxKind[SyntaxKind["FirstJSDocNode"] = 274] = "FirstJSDocNode";
	        SyntaxKind[SyntaxKind["LastJSDocNode"] = 292] = "LastJSDocNode";
	        SyntaxKind[SyntaxKind["FirstJSDocTagNode"] = 284] = "FirstJSDocTagNode";
	        SyntaxKind[SyntaxKind["LastJSDocTagNode"] = 292] = "LastJSDocTagNode";
	        /* @internal */ SyntaxKind[SyntaxKind["FirstContextualKeyword"] = 117] = "FirstContextualKeyword";
	        /* @internal */ SyntaxKind[SyntaxKind["LastContextualKeyword"] = 144] = "LastContextualKeyword";
	    })(SyntaxKind = ts.SyntaxKind || (ts.SyntaxKind = {}));
	    var NodeFlags;
	    (function (NodeFlags) {
	        NodeFlags[NodeFlags["None"] = 0] = "None";
	        NodeFlags[NodeFlags["Let"] = 1] = "Let";
	        NodeFlags[NodeFlags["Const"] = 2] = "Const";
	        NodeFlags[NodeFlags["NestedNamespace"] = 4] = "NestedNamespace";
	        NodeFlags[NodeFlags["Synthesized"] = 8] = "Synthesized";
	        NodeFlags[NodeFlags["Namespace"] = 16] = "Namespace";
	        NodeFlags[NodeFlags["ExportContext"] = 32] = "ExportContext";
	        NodeFlags[NodeFlags["ContainsThis"] = 64] = "ContainsThis";
	        NodeFlags[NodeFlags["HasImplicitReturn"] = 128] = "HasImplicitReturn";
	        NodeFlags[NodeFlags["HasExplicitReturn"] = 256] = "HasExplicitReturn";
	        NodeFlags[NodeFlags["GlobalAugmentation"] = 512] = "GlobalAugmentation";
	        NodeFlags[NodeFlags["HasAsyncFunctions"] = 1024] = "HasAsyncFunctions";
	        NodeFlags[NodeFlags["DisallowInContext"] = 2048] = "DisallowInContext";
	        NodeFlags[NodeFlags["YieldContext"] = 4096] = "YieldContext";
	        NodeFlags[NodeFlags["DecoratorContext"] = 8192] = "DecoratorContext";
	        NodeFlags[NodeFlags["AwaitContext"] = 16384] = "AwaitContext";
	        NodeFlags[NodeFlags["ThisNodeHasError"] = 32768] = "ThisNodeHasError";
	        NodeFlags[NodeFlags["JavaScriptFile"] = 65536] = "JavaScriptFile";
	        NodeFlags[NodeFlags["ThisNodeOrAnySubNodesHasError"] = 131072] = "ThisNodeOrAnySubNodesHasError";
	        NodeFlags[NodeFlags["HasAggregatedChildData"] = 262144] = "HasAggregatedChildData";
	        // This flag will be set when the parser encounters a dynamic import expression so that module resolution
	        // will not have to walk the tree if the flag is not set. However, this flag is just a approximation because
	        // once it is set, the flag never gets cleared (hence why it's named "PossiblyContainsDynamicImport").
	        // During editing, if dynamic import is removed, incremental parsing will *NOT* update this flag. This means that the tree will always be traversed
	        // during module resolution. However, the removal operation should not occur often and in the case of the
	        // removal, it is likely that users will add the import anyway.
	        // The advantage of this approach is its simplicity. For the case of batch compilation,
	        // we guarantee that users won't have to pay the price of walking the tree if a dynamic import isn't used.
	        /* @internal */
	        NodeFlags[NodeFlags["PossiblyContainsDynamicImport"] = 524288] = "PossiblyContainsDynamicImport";
	        NodeFlags[NodeFlags["JSDoc"] = 1048576] = "JSDoc";
	        /* @internal */ NodeFlags[NodeFlags["Ambient"] = 2097152] = "Ambient";
	        /* @internal */ NodeFlags[NodeFlags["InWithStatement"] = 4194304] = "InWithStatement";
	        NodeFlags[NodeFlags["BlockScoped"] = 3] = "BlockScoped";
	        NodeFlags[NodeFlags["ReachabilityCheckFlags"] = 384] = "ReachabilityCheckFlags";
	        NodeFlags[NodeFlags["ReachabilityAndEmitFlags"] = 1408] = "ReachabilityAndEmitFlags";
	        // Parsing context flags
	        NodeFlags[NodeFlags["ContextFlags"] = 6387712] = "ContextFlags";
	        // Exclude these flags when parsing a Type
	        NodeFlags[NodeFlags["TypeExcludesFlags"] = 20480] = "TypeExcludesFlags";
	    })(NodeFlags = ts.NodeFlags || (ts.NodeFlags = {}));
	    var ModifierFlags;
	    (function (ModifierFlags) {
	        ModifierFlags[ModifierFlags["None"] = 0] = "None";
	        ModifierFlags[ModifierFlags["Export"] = 1] = "Export";
	        ModifierFlags[ModifierFlags["Ambient"] = 2] = "Ambient";
	        ModifierFlags[ModifierFlags["Public"] = 4] = "Public";
	        ModifierFlags[ModifierFlags["Private"] = 8] = "Private";
	        ModifierFlags[ModifierFlags["Protected"] = 16] = "Protected";
	        ModifierFlags[ModifierFlags["Static"] = 32] = "Static";
	        ModifierFlags[ModifierFlags["Readonly"] = 64] = "Readonly";
	        ModifierFlags[ModifierFlags["Abstract"] = 128] = "Abstract";
	        ModifierFlags[ModifierFlags["Async"] = 256] = "Async";
	        ModifierFlags[ModifierFlags["Default"] = 512] = "Default";
	        ModifierFlags[ModifierFlags["Const"] = 2048] = "Const";
	        ModifierFlags[ModifierFlags["HasComputedFlags"] = 536870912] = "HasComputedFlags";
	        ModifierFlags[ModifierFlags["AccessibilityModifier"] = 28] = "AccessibilityModifier";
	        // Accessibility modifiers and 'readonly' can be attached to a parameter in a constructor to make it a property.
	        ModifierFlags[ModifierFlags["ParameterPropertyModifier"] = 92] = "ParameterPropertyModifier";
	        ModifierFlags[ModifierFlags["NonPublicAccessibilityModifier"] = 24] = "NonPublicAccessibilityModifier";
	        ModifierFlags[ModifierFlags["TypeScriptModifier"] = 2270] = "TypeScriptModifier";
	        ModifierFlags[ModifierFlags["ExportDefault"] = 513] = "ExportDefault";
	    })(ModifierFlags = ts.ModifierFlags || (ts.ModifierFlags = {}));
	    var JsxFlags;
	    (function (JsxFlags) {
	        JsxFlags[JsxFlags["None"] = 0] = "None";
	        /** An element from a named property of the JSX.IntrinsicElements interface */
	        JsxFlags[JsxFlags["IntrinsicNamedElement"] = 1] = "IntrinsicNamedElement";
	        /** An element inferred from the string index signature of the JSX.IntrinsicElements interface */
	        JsxFlags[JsxFlags["IntrinsicIndexedElement"] = 2] = "IntrinsicIndexedElement";
	        JsxFlags[JsxFlags["IntrinsicElement"] = 3] = "IntrinsicElement";
	    })(JsxFlags = ts.JsxFlags || (ts.JsxFlags = {}));
	    /* @internal */
	    var RelationComparisonResult;
	    (function (RelationComparisonResult) {
	        RelationComparisonResult[RelationComparisonResult["Succeeded"] = 1] = "Succeeded";
	        RelationComparisonResult[RelationComparisonResult["Failed"] = 2] = "Failed";
	        RelationComparisonResult[RelationComparisonResult["FailedAndReported"] = 3] = "FailedAndReported";
	    })(RelationComparisonResult = ts.RelationComparisonResult || (ts.RelationComparisonResult = {}));
	    /*@internal*/
	    var GeneratedIdentifierFlags;
	    (function (GeneratedIdentifierFlags) {
	        // Kinds
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["None"] = 0] = "None";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Auto"] = 1] = "Auto";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Loop"] = 2] = "Loop";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Unique"] = 3] = "Unique";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Node"] = 4] = "Node";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["KindMask"] = 7] = "KindMask";
	        // Flags
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["SkipNameGenerationScope"] = 8] = "SkipNameGenerationScope";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["ReservedInNestedScopes"] = 16] = "ReservedInNestedScopes";
	    })(GeneratedIdentifierFlags = ts.GeneratedIdentifierFlags || (ts.GeneratedIdentifierFlags = {}));
	    /* @internal */
	    var TokenFlags;
	    (function (TokenFlags) {
	        TokenFlags[TokenFlags["None"] = 0] = "None";
	        TokenFlags[TokenFlags["PrecedingLineBreak"] = 1] = "PrecedingLineBreak";
	        TokenFlags[TokenFlags["PrecedingJSDocComment"] = 2] = "PrecedingJSDocComment";
	        TokenFlags[TokenFlags["Unterminated"] = 4] = "Unterminated";
	        TokenFlags[TokenFlags["ExtendedUnicodeEscape"] = 8] = "ExtendedUnicodeEscape";
	        TokenFlags[TokenFlags["Scientific"] = 16] = "Scientific";
	        TokenFlags[TokenFlags["Octal"] = 32] = "Octal";
	        TokenFlags[TokenFlags["HexSpecifier"] = 64] = "HexSpecifier";
	        TokenFlags[TokenFlags["BinarySpecifier"] = 128] = "BinarySpecifier";
	        TokenFlags[TokenFlags["OctalSpecifier"] = 256] = "OctalSpecifier";
	        TokenFlags[TokenFlags["ContainsSeparator"] = 512] = "ContainsSeparator";
	        TokenFlags[TokenFlags["BinaryOrOctalSpecifier"] = 384] = "BinaryOrOctalSpecifier";
	        TokenFlags[TokenFlags["NumericLiteralFlags"] = 1008] = "NumericLiteralFlags";
	    })(TokenFlags = ts.TokenFlags || (ts.TokenFlags = {}));
	    var FlowFlags;
	    (function (FlowFlags) {
	        FlowFlags[FlowFlags["Unreachable"] = 1] = "Unreachable";
	        FlowFlags[FlowFlags["Start"] = 2] = "Start";
	        FlowFlags[FlowFlags["BranchLabel"] = 4] = "BranchLabel";
	        FlowFlags[FlowFlags["LoopLabel"] = 8] = "LoopLabel";
	        FlowFlags[FlowFlags["Assignment"] = 16] = "Assignment";
	        FlowFlags[FlowFlags["TrueCondition"] = 32] = "TrueCondition";
	        FlowFlags[FlowFlags["FalseCondition"] = 64] = "FalseCondition";
	        FlowFlags[FlowFlags["SwitchClause"] = 128] = "SwitchClause";
	        FlowFlags[FlowFlags["ArrayMutation"] = 256] = "ArrayMutation";
	        FlowFlags[FlowFlags["Referenced"] = 512] = "Referenced";
	        FlowFlags[FlowFlags["Shared"] = 1024] = "Shared";
	        FlowFlags[FlowFlags["PreFinally"] = 2048] = "PreFinally";
	        FlowFlags[FlowFlags["AfterFinally"] = 4096] = "AfterFinally";
	        FlowFlags[FlowFlags["Label"] = 12] = "Label";
	        FlowFlags[FlowFlags["Condition"] = 96] = "Condition";
	    })(FlowFlags = ts.FlowFlags || (ts.FlowFlags = {}));
	    var OperationCanceledException = /** @class */ (function () {
	        function OperationCanceledException() {
	        }
	        return OperationCanceledException;
	    }());
	    ts.OperationCanceledException = OperationCanceledException;
	    /* @internal */
	    var StructureIsReused;
	    (function (StructureIsReused) {
	        StructureIsReused[StructureIsReused["Not"] = 0] = "Not";
	        StructureIsReused[StructureIsReused["SafeModules"] = 1] = "SafeModules";
	        StructureIsReused[StructureIsReused["Completely"] = 2] = "Completely";
	    })(StructureIsReused = ts.StructureIsReused || (ts.StructureIsReused = {}));
	    /** Return code used by getEmitOutput function to indicate status of the function */
	    var ExitStatus;
	    (function (ExitStatus) {
	        // Compiler ran successfully.  Either this was a simple do-nothing compilation (for example,
	        // when -version or -help was provided, or this was a normal compilation, no diagnostics
	        // were produced, and all outputs were generated successfully.
	        ExitStatus[ExitStatus["Success"] = 0] = "Success";
	        // Diagnostics were produced and because of them no code was generated.
	        ExitStatus[ExitStatus["DiagnosticsPresent_OutputsSkipped"] = 1] = "DiagnosticsPresent_OutputsSkipped";
	        // Diagnostics were produced and outputs were generated in spite of them.
	        ExitStatus[ExitStatus["DiagnosticsPresent_OutputsGenerated"] = 2] = "DiagnosticsPresent_OutputsGenerated";
	    })(ExitStatus = ts.ExitStatus || (ts.ExitStatus = {}));
	    /* @internal */
	    var UnionReduction;
	    (function (UnionReduction) {
	        UnionReduction[UnionReduction["None"] = 0] = "None";
	        UnionReduction[UnionReduction["Literal"] = 1] = "Literal";
	        UnionReduction[UnionReduction["Subtype"] = 2] = "Subtype";
	    })(UnionReduction = ts.UnionReduction || (ts.UnionReduction = {}));
	    var NodeBuilderFlags;
	    (function (NodeBuilderFlags) {
	        NodeBuilderFlags[NodeBuilderFlags["None"] = 0] = "None";
	        // Options
	        NodeBuilderFlags[NodeBuilderFlags["NoTruncation"] = 1] = "NoTruncation";
	        NodeBuilderFlags[NodeBuilderFlags["WriteArrayAsGenericType"] = 2] = "WriteArrayAsGenericType";
	        // empty space
	        NodeBuilderFlags[NodeBuilderFlags["UseStructuralFallback"] = 8] = "UseStructuralFallback";
	        // empty space
	        NodeBuilderFlags[NodeBuilderFlags["WriteTypeArgumentsOfSignature"] = 32] = "WriteTypeArgumentsOfSignature";
	        NodeBuilderFlags[NodeBuilderFlags["UseFullyQualifiedType"] = 64] = "UseFullyQualifiedType";
	        NodeBuilderFlags[NodeBuilderFlags["UseOnlyExternalAliasing"] = 128] = "UseOnlyExternalAliasing";
	        NodeBuilderFlags[NodeBuilderFlags["SuppressAnyReturnType"] = 256] = "SuppressAnyReturnType";
	        NodeBuilderFlags[NodeBuilderFlags["WriteTypeParametersInQualifiedName"] = 512] = "WriteTypeParametersInQualifiedName";
	        NodeBuilderFlags[NodeBuilderFlags["MultilineObjectLiterals"] = 1024] = "MultilineObjectLiterals";
	        NodeBuilderFlags[NodeBuilderFlags["WriteClassExpressionAsTypeLiteral"] = 2048] = "WriteClassExpressionAsTypeLiteral";
	        NodeBuilderFlags[NodeBuilderFlags["UseTypeOfFunction"] = 4096] = "UseTypeOfFunction";
	        NodeBuilderFlags[NodeBuilderFlags["OmitParameterModifiers"] = 8192] = "OmitParameterModifiers";
	        NodeBuilderFlags[NodeBuilderFlags["UseAliasDefinedOutsideCurrentScope"] = 16384] = "UseAliasDefinedOutsideCurrentScope";
	        // Error handling
	        NodeBuilderFlags[NodeBuilderFlags["AllowThisInObjectLiteral"] = 32768] = "AllowThisInObjectLiteral";
	        NodeBuilderFlags[NodeBuilderFlags["AllowQualifedNameInPlaceOfIdentifier"] = 65536] = "AllowQualifedNameInPlaceOfIdentifier";
	        NodeBuilderFlags[NodeBuilderFlags["AllowAnonymousIdentifier"] = 131072] = "AllowAnonymousIdentifier";
	        NodeBuilderFlags[NodeBuilderFlags["AllowEmptyUnionOrIntersection"] = 262144] = "AllowEmptyUnionOrIntersection";
	        NodeBuilderFlags[NodeBuilderFlags["AllowEmptyTuple"] = 524288] = "AllowEmptyTuple";
	        NodeBuilderFlags[NodeBuilderFlags["AllowUniqueESSymbolType"] = 1048576] = "AllowUniqueESSymbolType";
	        NodeBuilderFlags[NodeBuilderFlags["AllowEmptyIndexInfoType"] = 2097152] = "AllowEmptyIndexInfoType";
	        NodeBuilderFlags[NodeBuilderFlags["IgnoreErrors"] = 3112960] = "IgnoreErrors";
	        // State
	        NodeBuilderFlags[NodeBuilderFlags["InObjectTypeLiteral"] = 4194304] = "InObjectTypeLiteral";
	        NodeBuilderFlags[NodeBuilderFlags["InTypeAlias"] = 8388608] = "InTypeAlias";
	        NodeBuilderFlags[NodeBuilderFlags["InInitialEntityName"] = 16777216] = "InInitialEntityName";
	        NodeBuilderFlags[NodeBuilderFlags["InReverseMappedType"] = 33554432] = "InReverseMappedType";
	    })(NodeBuilderFlags = ts.NodeBuilderFlags || (ts.NodeBuilderFlags = {}));
	    // Ensure the shared flags between this and `NodeBuilderFlags` stay in alignment
	    var TypeFormatFlags;
	    (function (TypeFormatFlags) {
	        TypeFormatFlags[TypeFormatFlags["None"] = 0] = "None";
	        TypeFormatFlags[TypeFormatFlags["NoTruncation"] = 1] = "NoTruncation";
	        TypeFormatFlags[TypeFormatFlags["WriteArrayAsGenericType"] = 2] = "WriteArrayAsGenericType";
	        // hole because there's a hole in node builder flags
	        TypeFormatFlags[TypeFormatFlags["UseStructuralFallback"] = 8] = "UseStructuralFallback";
	        // hole because there's a hole in node builder flags
	        TypeFormatFlags[TypeFormatFlags["WriteTypeArgumentsOfSignature"] = 32] = "WriteTypeArgumentsOfSignature";
	        TypeFormatFlags[TypeFormatFlags["UseFullyQualifiedType"] = 64] = "UseFullyQualifiedType";
	        // hole because `UseOnlyExternalAliasing` is here in node builder flags, but functions which take old flags use `SymbolFormatFlags` instead
	        TypeFormatFlags[TypeFormatFlags["SuppressAnyReturnType"] = 256] = "SuppressAnyReturnType";
	        // hole because `WriteTypeParametersInQualifiedName` is here in node builder flags, but functions which take old flags use `SymbolFormatFlags` for this instead
	        TypeFormatFlags[TypeFormatFlags["MultilineObjectLiterals"] = 1024] = "MultilineObjectLiterals";
	        TypeFormatFlags[TypeFormatFlags["WriteClassExpressionAsTypeLiteral"] = 2048] = "WriteClassExpressionAsTypeLiteral";
	        TypeFormatFlags[TypeFormatFlags["UseTypeOfFunction"] = 4096] = "UseTypeOfFunction";
	        TypeFormatFlags[TypeFormatFlags["OmitParameterModifiers"] = 8192] = "OmitParameterModifiers";
	        TypeFormatFlags[TypeFormatFlags["UseAliasDefinedOutsideCurrentScope"] = 16384] = "UseAliasDefinedOutsideCurrentScope";
	        // even though `T` can't be accessed in the current scope.
	        // Error Handling
	        TypeFormatFlags[TypeFormatFlags["AllowUniqueESSymbolType"] = 1048576] = "AllowUniqueESSymbolType";
	        // TypeFormatFlags exclusive
	        TypeFormatFlags[TypeFormatFlags["AddUndefined"] = 131072] = "AddUndefined";
	        TypeFormatFlags[TypeFormatFlags["WriteArrowStyleSignature"] = 262144] = "WriteArrowStyleSignature";
	        // State
	        TypeFormatFlags[TypeFormatFlags["InArrayType"] = 524288] = "InArrayType";
	        TypeFormatFlags[TypeFormatFlags["InElementType"] = 2097152] = "InElementType";
	        TypeFormatFlags[TypeFormatFlags["InFirstTypeArgument"] = 4194304] = "InFirstTypeArgument";
	        TypeFormatFlags[TypeFormatFlags["InTypeAlias"] = 8388608] = "InTypeAlias";
	        /** @deprecated */ TypeFormatFlags[TypeFormatFlags["WriteOwnNameForAnyLike"] = 0] = "WriteOwnNameForAnyLike";
	        TypeFormatFlags[TypeFormatFlags["NodeBuilderFlagsMask"] = 9469291] = "NodeBuilderFlagsMask";
	    })(TypeFormatFlags = ts.TypeFormatFlags || (ts.TypeFormatFlags = {}));
	    var SymbolFormatFlags;
	    (function (SymbolFormatFlags) {
	        SymbolFormatFlags[SymbolFormatFlags["None"] = 0] = "None";
	        // Write symbols's type argument if it is instantiated symbol
	        // eg. class C<T> { p: T }   <-- Show p as C<T>.p here
	        //     var a: C<number>;
	        //     var p = a.p; <--- Here p is property of C<number> so show it as C<number>.p instead of just C.p
	        SymbolFormatFlags[SymbolFormatFlags["WriteTypeParametersOrArguments"] = 1] = "WriteTypeParametersOrArguments";
	        // Use only external alias information to get the symbol name in the given context
	        // eg.  module m { export class c { } } import x = m.c;
	        // When this flag is specified m.c will be used to refer to the class instead of alias symbol x
	        SymbolFormatFlags[SymbolFormatFlags["UseOnlyExternalAliasing"] = 2] = "UseOnlyExternalAliasing";
	        // Build symbol name using any nodes needed, instead of just components of an entity name
	        SymbolFormatFlags[SymbolFormatFlags["AllowAnyNodeKind"] = 4] = "AllowAnyNodeKind";
	        // Prefer aliases which are not directly visible
	        SymbolFormatFlags[SymbolFormatFlags["UseAliasDefinedOutsideCurrentScope"] = 8] = "UseAliasDefinedOutsideCurrentScope";
	    })(SymbolFormatFlags = ts.SymbolFormatFlags || (ts.SymbolFormatFlags = {}));
	    /* @internal */
	    var SymbolAccessibility;
	    (function (SymbolAccessibility) {
	        SymbolAccessibility[SymbolAccessibility["Accessible"] = 0] = "Accessible";
	        SymbolAccessibility[SymbolAccessibility["NotAccessible"] = 1] = "NotAccessible";
	        SymbolAccessibility[SymbolAccessibility["CannotBeNamed"] = 2] = "CannotBeNamed";
	    })(SymbolAccessibility = ts.SymbolAccessibility || (ts.SymbolAccessibility = {}));
	    /* @internal */
	    var SyntheticSymbolKind;
	    (function (SyntheticSymbolKind) {
	        SyntheticSymbolKind[SyntheticSymbolKind["UnionOrIntersection"] = 0] = "UnionOrIntersection";
	        SyntheticSymbolKind[SyntheticSymbolKind["Spread"] = 1] = "Spread";
	    })(SyntheticSymbolKind = ts.SyntheticSymbolKind || (ts.SyntheticSymbolKind = {}));
	    var TypePredicateKind;
	    (function (TypePredicateKind) {
	        TypePredicateKind[TypePredicateKind["This"] = 0] = "This";
	        TypePredicateKind[TypePredicateKind["Identifier"] = 1] = "Identifier";
	    })(TypePredicateKind = ts.TypePredicateKind || (ts.TypePredicateKind = {}));
	    /** Indicates how to serialize the name for a TypeReferenceNode when emitting decorator metadata */
	    /* @internal */
	    var TypeReferenceSerializationKind;
	    (function (TypeReferenceSerializationKind) {
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["Unknown"] = 0] = "Unknown";
	        // should be emitted using a safe fallback.
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["TypeWithConstructSignatureAndValue"] = 1] = "TypeWithConstructSignatureAndValue";
	        // function that can be reached at runtime (e.g. a `class`
	        // declaration or a `var` declaration for the static side
	        // of a type, such as the global `Promise` type in lib.d.ts).
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["VoidNullableOrNeverType"] = 2] = "VoidNullableOrNeverType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["NumberLikeType"] = 3] = "NumberLikeType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["StringLikeType"] = 4] = "StringLikeType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["BooleanType"] = 5] = "BooleanType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["ArrayLikeType"] = 6] = "ArrayLikeType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["ESSymbolType"] = 7] = "ESSymbolType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["Promise"] = 8] = "Promise";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["TypeWithCallSignature"] = 9] = "TypeWithCallSignature";
	        // with call signatures.
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["ObjectType"] = 10] = "ObjectType";
	    })(TypeReferenceSerializationKind = ts.TypeReferenceSerializationKind || (ts.TypeReferenceSerializationKind = {}));
	    var SymbolFlags;
	    (function (SymbolFlags) {
	        SymbolFlags[SymbolFlags["None"] = 0] = "None";
	        SymbolFlags[SymbolFlags["FunctionScopedVariable"] = 1] = "FunctionScopedVariable";
	        SymbolFlags[SymbolFlags["BlockScopedVariable"] = 2] = "BlockScopedVariable";
	        SymbolFlags[SymbolFlags["Property"] = 4] = "Property";
	        SymbolFlags[SymbolFlags["EnumMember"] = 8] = "EnumMember";
	        SymbolFlags[SymbolFlags["Function"] = 16] = "Function";
	        SymbolFlags[SymbolFlags["Class"] = 32] = "Class";
	        SymbolFlags[SymbolFlags["Interface"] = 64] = "Interface";
	        SymbolFlags[SymbolFlags["ConstEnum"] = 128] = "ConstEnum";
	        SymbolFlags[SymbolFlags["RegularEnum"] = 256] = "RegularEnum";
	        SymbolFlags[SymbolFlags["ValueModule"] = 512] = "ValueModule";
	        SymbolFlags[SymbolFlags["NamespaceModule"] = 1024] = "NamespaceModule";
	        SymbolFlags[SymbolFlags["TypeLiteral"] = 2048] = "TypeLiteral";
	        SymbolFlags[SymbolFlags["ObjectLiteral"] = 4096] = "ObjectLiteral";
	        SymbolFlags[SymbolFlags["Method"] = 8192] = "Method";
	        SymbolFlags[SymbolFlags["Constructor"] = 16384] = "Constructor";
	        SymbolFlags[SymbolFlags["GetAccessor"] = 32768] = "GetAccessor";
	        SymbolFlags[SymbolFlags["SetAccessor"] = 65536] = "SetAccessor";
	        SymbolFlags[SymbolFlags["Signature"] = 131072] = "Signature";
	        SymbolFlags[SymbolFlags["TypeParameter"] = 262144] = "TypeParameter";
	        SymbolFlags[SymbolFlags["TypeAlias"] = 524288] = "TypeAlias";
	        SymbolFlags[SymbolFlags["ExportValue"] = 1048576] = "ExportValue";
	        SymbolFlags[SymbolFlags["Alias"] = 2097152] = "Alias";
	        SymbolFlags[SymbolFlags["Prototype"] = 4194304] = "Prototype";
	        SymbolFlags[SymbolFlags["ExportStar"] = 8388608] = "ExportStar";
	        SymbolFlags[SymbolFlags["Optional"] = 16777216] = "Optional";
	        SymbolFlags[SymbolFlags["Transient"] = 33554432] = "Transient";
	        SymbolFlags[SymbolFlags["JSContainer"] = 67108864] = "JSContainer";
	        /* @internal */
	        SymbolFlags[SymbolFlags["All"] = 67108863] = "All";
	        SymbolFlags[SymbolFlags["Enum"] = 384] = "Enum";
	        SymbolFlags[SymbolFlags["Variable"] = 3] = "Variable";
	        SymbolFlags[SymbolFlags["Value"] = 107455] = "Value";
	        SymbolFlags[SymbolFlags["Type"] = 793064] = "Type";
	        SymbolFlags[SymbolFlags["Namespace"] = 1920] = "Namespace";
	        SymbolFlags[SymbolFlags["Module"] = 1536] = "Module";
	        SymbolFlags[SymbolFlags["Accessor"] = 98304] = "Accessor";
	        // Variables can be redeclared, but can not redeclare a block-scoped declaration with the
	        // same name, or any other value that is not a variable, e.g. ValueModule or Class
	        SymbolFlags[SymbolFlags["FunctionScopedVariableExcludes"] = 107454] = "FunctionScopedVariableExcludes";
	        // Block-scoped declarations are not allowed to be re-declared
	        // they can not merge with anything in the value space
	        SymbolFlags[SymbolFlags["BlockScopedVariableExcludes"] = 107455] = "BlockScopedVariableExcludes";
	        SymbolFlags[SymbolFlags["ParameterExcludes"] = 107455] = "ParameterExcludes";
	        SymbolFlags[SymbolFlags["PropertyExcludes"] = 0] = "PropertyExcludes";
	        SymbolFlags[SymbolFlags["EnumMemberExcludes"] = 900095] = "EnumMemberExcludes";
	        SymbolFlags[SymbolFlags["FunctionExcludes"] = 106927] = "FunctionExcludes";
	        SymbolFlags[SymbolFlags["ClassExcludes"] = 899519] = "ClassExcludes";
	        SymbolFlags[SymbolFlags["InterfaceExcludes"] = 792968] = "InterfaceExcludes";
	        SymbolFlags[SymbolFlags["RegularEnumExcludes"] = 899327] = "RegularEnumExcludes";
	        SymbolFlags[SymbolFlags["ConstEnumExcludes"] = 899967] = "ConstEnumExcludes";
	        SymbolFlags[SymbolFlags["ValueModuleExcludes"] = 106639] = "ValueModuleExcludes";
	        SymbolFlags[SymbolFlags["NamespaceModuleExcludes"] = 0] = "NamespaceModuleExcludes";
	        SymbolFlags[SymbolFlags["MethodExcludes"] = 99263] = "MethodExcludes";
	        SymbolFlags[SymbolFlags["GetAccessorExcludes"] = 41919] = "GetAccessorExcludes";
	        SymbolFlags[SymbolFlags["SetAccessorExcludes"] = 74687] = "SetAccessorExcludes";
	        SymbolFlags[SymbolFlags["TypeParameterExcludes"] = 530920] = "TypeParameterExcludes";
	        SymbolFlags[SymbolFlags["TypeAliasExcludes"] = 793064] = "TypeAliasExcludes";
	        SymbolFlags[SymbolFlags["AliasExcludes"] = 2097152] = "AliasExcludes";
	        SymbolFlags[SymbolFlags["ModuleMember"] = 2623475] = "ModuleMember";
	        SymbolFlags[SymbolFlags["ExportHasLocal"] = 944] = "ExportHasLocal";
	        SymbolFlags[SymbolFlags["HasExports"] = 1952] = "HasExports";
	        SymbolFlags[SymbolFlags["HasMembers"] = 6240] = "HasMembers";
	        SymbolFlags[SymbolFlags["BlockScoped"] = 418] = "BlockScoped";
	        SymbolFlags[SymbolFlags["PropertyOrAccessor"] = 98308] = "PropertyOrAccessor";
	        SymbolFlags[SymbolFlags["ClassMember"] = 106500] = "ClassMember";
	        /* @internal */
	        // The set of things we consider semantically classifiable.  Used to speed up the LS during
	        // classification.
	        SymbolFlags[SymbolFlags["Classifiable"] = 2885600] = "Classifiable";
	        /* @internal */
	        SymbolFlags[SymbolFlags["LateBindingContainer"] = 6240] = "LateBindingContainer";
	    })(SymbolFlags = ts.SymbolFlags || (ts.SymbolFlags = {}));
	    /* @internal */
	    var EnumKind;
	    (function (EnumKind) {
	        EnumKind[EnumKind["Numeric"] = 0] = "Numeric";
	        EnumKind[EnumKind["Literal"] = 1] = "Literal"; // Literal enum (each member has a TypeFlags.EnumLiteral type)
	    })(EnumKind = ts.EnumKind || (ts.EnumKind = {}));
	    /* @internal */
	    var CheckFlags;
	    (function (CheckFlags) {
	        CheckFlags[CheckFlags["Instantiated"] = 1] = "Instantiated";
	        CheckFlags[CheckFlags["SyntheticProperty"] = 2] = "SyntheticProperty";
	        CheckFlags[CheckFlags["SyntheticMethod"] = 4] = "SyntheticMethod";
	        CheckFlags[CheckFlags["Readonly"] = 8] = "Readonly";
	        CheckFlags[CheckFlags["Partial"] = 16] = "Partial";
	        CheckFlags[CheckFlags["HasNonUniformType"] = 32] = "HasNonUniformType";
	        CheckFlags[CheckFlags["ContainsPublic"] = 64] = "ContainsPublic";
	        CheckFlags[CheckFlags["ContainsProtected"] = 128] = "ContainsProtected";
	        CheckFlags[CheckFlags["ContainsPrivate"] = 256] = "ContainsPrivate";
	        CheckFlags[CheckFlags["ContainsStatic"] = 512] = "ContainsStatic";
	        CheckFlags[CheckFlags["Late"] = 1024] = "Late";
	        CheckFlags[CheckFlags["ReverseMapped"] = 2048] = "ReverseMapped";
	        CheckFlags[CheckFlags["Synthetic"] = 6] = "Synthetic";
	    })(CheckFlags = ts.CheckFlags || (ts.CheckFlags = {}));
	    var InternalSymbolName;
	    (function (InternalSymbolName) {
	        InternalSymbolName["Call"] = "__call";
	        InternalSymbolName["Constructor"] = "__constructor";
	        InternalSymbolName["New"] = "__new";
	        InternalSymbolName["Index"] = "__index";
	        InternalSymbolName["ExportStar"] = "__export";
	        InternalSymbolName["Global"] = "__global";
	        InternalSymbolName["Missing"] = "__missing";
	        InternalSymbolName["Type"] = "__type";
	        InternalSymbolName["Object"] = "__object";
	        InternalSymbolName["JSXAttributes"] = "__jsxAttributes";
	        InternalSymbolName["Class"] = "__class";
	        InternalSymbolName["Function"] = "__function";
	        InternalSymbolName["Computed"] = "__computed";
	        InternalSymbolName["Resolving"] = "__resolving__";
	        InternalSymbolName["ExportEquals"] = "export=";
	        InternalSymbolName["Default"] = "default";
	    })(InternalSymbolName = ts.InternalSymbolName || (ts.InternalSymbolName = {}));
	    /* @internal */
	    var NodeCheckFlags;
	    (function (NodeCheckFlags) {
	        NodeCheckFlags[NodeCheckFlags["TypeChecked"] = 1] = "TypeChecked";
	        NodeCheckFlags[NodeCheckFlags["LexicalThis"] = 2] = "LexicalThis";
	        NodeCheckFlags[NodeCheckFlags["CaptureThis"] = 4] = "CaptureThis";
	        NodeCheckFlags[NodeCheckFlags["CaptureNewTarget"] = 8] = "CaptureNewTarget";
	        NodeCheckFlags[NodeCheckFlags["SuperInstance"] = 256] = "SuperInstance";
	        NodeCheckFlags[NodeCheckFlags["SuperStatic"] = 512] = "SuperStatic";
	        NodeCheckFlags[NodeCheckFlags["ContextChecked"] = 1024] = "ContextChecked";
	        NodeCheckFlags[NodeCheckFlags["AsyncMethodWithSuper"] = 2048] = "AsyncMethodWithSuper";
	        NodeCheckFlags[NodeCheckFlags["AsyncMethodWithSuperBinding"] = 4096] = "AsyncMethodWithSuperBinding";
	        NodeCheckFlags[NodeCheckFlags["CaptureArguments"] = 8192] = "CaptureArguments";
	        NodeCheckFlags[NodeCheckFlags["EnumValuesComputed"] = 16384] = "EnumValuesComputed";
	        NodeCheckFlags[NodeCheckFlags["LexicalModuleMergesWithClass"] = 32768] = "LexicalModuleMergesWithClass";
	        NodeCheckFlags[NodeCheckFlags["LoopWithCapturedBlockScopedBinding"] = 65536] = "LoopWithCapturedBlockScopedBinding";
	        NodeCheckFlags[NodeCheckFlags["CapturedBlockScopedBinding"] = 131072] = "CapturedBlockScopedBinding";
	        NodeCheckFlags[NodeCheckFlags["BlockScopedBindingInLoop"] = 262144] = "BlockScopedBindingInLoop";
	        NodeCheckFlags[NodeCheckFlags["ClassWithBodyScopedClassBinding"] = 524288] = "ClassWithBodyScopedClassBinding";
	        NodeCheckFlags[NodeCheckFlags["BodyScopedClassBinding"] = 1048576] = "BodyScopedClassBinding";
	        NodeCheckFlags[NodeCheckFlags["NeedsLoopOutParameter"] = 2097152] = "NeedsLoopOutParameter";
	        NodeCheckFlags[NodeCheckFlags["AssignmentsMarked"] = 4194304] = "AssignmentsMarked";
	        NodeCheckFlags[NodeCheckFlags["ClassWithConstructorReference"] = 8388608] = "ClassWithConstructorReference";
	        NodeCheckFlags[NodeCheckFlags["ConstructorReferenceInClass"] = 16777216] = "ConstructorReferenceInClass";
	    })(NodeCheckFlags = ts.NodeCheckFlags || (ts.NodeCheckFlags = {}));
	    var TypeFlags;
	    (function (TypeFlags) {
	        TypeFlags[TypeFlags["Any"] = 1] = "Any";
	        TypeFlags[TypeFlags["String"] = 2] = "String";
	        TypeFlags[TypeFlags["Number"] = 4] = "Number";
	        TypeFlags[TypeFlags["Boolean"] = 8] = "Boolean";
	        TypeFlags[TypeFlags["Enum"] = 16] = "Enum";
	        TypeFlags[TypeFlags["StringLiteral"] = 32] = "StringLiteral";
	        TypeFlags[TypeFlags["NumberLiteral"] = 64] = "NumberLiteral";
	        TypeFlags[TypeFlags["BooleanLiteral"] = 128] = "BooleanLiteral";
	        TypeFlags[TypeFlags["EnumLiteral"] = 256] = "EnumLiteral";
	        TypeFlags[TypeFlags["ESSymbol"] = 512] = "ESSymbol";
	        TypeFlags[TypeFlags["UniqueESSymbol"] = 1024] = "UniqueESSymbol";
	        TypeFlags[TypeFlags["Void"] = 2048] = "Void";
	        TypeFlags[TypeFlags["Undefined"] = 4096] = "Undefined";
	        TypeFlags[TypeFlags["Null"] = 8192] = "Null";
	        TypeFlags[TypeFlags["Never"] = 16384] = "Never";
	        TypeFlags[TypeFlags["TypeParameter"] = 32768] = "TypeParameter";
	        TypeFlags[TypeFlags["Object"] = 65536] = "Object";
	        TypeFlags[TypeFlags["Union"] = 131072] = "Union";
	        TypeFlags[TypeFlags["Intersection"] = 262144] = "Intersection";
	        TypeFlags[TypeFlags["Index"] = 524288] = "Index";
	        TypeFlags[TypeFlags["IndexedAccess"] = 1048576] = "IndexedAccess";
	        TypeFlags[TypeFlags["Conditional"] = 2097152] = "Conditional";
	        TypeFlags[TypeFlags["Substitution"] = 4194304] = "Substitution";
	        /* @internal */
	        TypeFlags[TypeFlags["FreshLiteral"] = 8388608] = "FreshLiteral";
	        /* @internal */
	        TypeFlags[TypeFlags["ContainsWideningType"] = 16777216] = "ContainsWideningType";
	        /* @internal */
	        TypeFlags[TypeFlags["ContainsObjectLiteral"] = 33554432] = "ContainsObjectLiteral";
	        /* @internal */
	        TypeFlags[TypeFlags["ContainsAnyFunctionType"] = 67108864] = "ContainsAnyFunctionType";
	        TypeFlags[TypeFlags["NonPrimitive"] = 134217728] = "NonPrimitive";
	        /* @internal */
	        TypeFlags[TypeFlags["GenericMappedType"] = 536870912] = "GenericMappedType";
	        /* @internal */
	        TypeFlags[TypeFlags["Nullable"] = 12288] = "Nullable";
	        TypeFlags[TypeFlags["Literal"] = 224] = "Literal";
	        TypeFlags[TypeFlags["Unit"] = 13536] = "Unit";
	        TypeFlags[TypeFlags["StringOrNumberLiteral"] = 96] = "StringOrNumberLiteral";
	        /* @internal */
	        TypeFlags[TypeFlags["StringOrNumberLiteralOrUnique"] = 1120] = "StringOrNumberLiteralOrUnique";
	        /* @internal */
	        TypeFlags[TypeFlags["DefinitelyFalsy"] = 14560] = "DefinitelyFalsy";
	        TypeFlags[TypeFlags["PossiblyFalsy"] = 14574] = "PossiblyFalsy";
	        /* @internal */
	        TypeFlags[TypeFlags["Intrinsic"] = 134249103] = "Intrinsic";
	        /* @internal */
	        TypeFlags[TypeFlags["Primitive"] = 16382] = "Primitive";
	        TypeFlags[TypeFlags["StringLike"] = 524322] = "StringLike";
	        TypeFlags[TypeFlags["NumberLike"] = 84] = "NumberLike";
	        TypeFlags[TypeFlags["BooleanLike"] = 136] = "BooleanLike";
	        TypeFlags[TypeFlags["EnumLike"] = 272] = "EnumLike";
	        TypeFlags[TypeFlags["ESSymbolLike"] = 1536] = "ESSymbolLike";
	        TypeFlags[TypeFlags["UnionOrIntersection"] = 393216] = "UnionOrIntersection";
	        TypeFlags[TypeFlags["StructuredType"] = 458752] = "StructuredType";
	        TypeFlags[TypeFlags["TypeVariable"] = 1081344] = "TypeVariable";
	        TypeFlags[TypeFlags["InstantiableNonPrimitive"] = 7372800] = "InstantiableNonPrimitive";
	        TypeFlags[TypeFlags["InstantiablePrimitive"] = 524288] = "InstantiablePrimitive";
	        TypeFlags[TypeFlags["Instantiable"] = 7897088] = "Instantiable";
	        TypeFlags[TypeFlags["StructuredOrInstantiable"] = 8355840] = "StructuredOrInstantiable";
	        // 'Narrowable' types are types where narrowing actually narrows.
	        // This *should* be every type other than null, undefined, void, and never
	        TypeFlags[TypeFlags["Narrowable"] = 142575359] = "Narrowable";
	        TypeFlags[TypeFlags["NotUnionOrUnit"] = 134283777] = "NotUnionOrUnit";
	        /* @internal */
	        TypeFlags[TypeFlags["RequiresWidening"] = 50331648] = "RequiresWidening";
	        /* @internal */
	        TypeFlags[TypeFlags["PropagatingFlags"] = 117440512] = "PropagatingFlags";
	        /* @internal */
	    })(TypeFlags = ts.TypeFlags || (ts.TypeFlags = {}));
	    var ObjectFlags;
	    (function (ObjectFlags) {
	        ObjectFlags[ObjectFlags["Class"] = 1] = "Class";
	        ObjectFlags[ObjectFlags["Interface"] = 2] = "Interface";
	        ObjectFlags[ObjectFlags["Reference"] = 4] = "Reference";
	        ObjectFlags[ObjectFlags["Tuple"] = 8] = "Tuple";
	        ObjectFlags[ObjectFlags["Anonymous"] = 16] = "Anonymous";
	        ObjectFlags[ObjectFlags["Mapped"] = 32] = "Mapped";
	        ObjectFlags[ObjectFlags["Instantiated"] = 64] = "Instantiated";
	        ObjectFlags[ObjectFlags["ObjectLiteral"] = 128] = "ObjectLiteral";
	        ObjectFlags[ObjectFlags["EvolvingArray"] = 256] = "EvolvingArray";
	        ObjectFlags[ObjectFlags["ObjectLiteralPatternWithComputedProperties"] = 512] = "ObjectLiteralPatternWithComputedProperties";
	        ObjectFlags[ObjectFlags["ContainsSpread"] = 1024] = "ContainsSpread";
	        ObjectFlags[ObjectFlags["ReverseMapped"] = 2048] = "ReverseMapped";
	        ObjectFlags[ObjectFlags["JsxAttributes"] = 4096] = "JsxAttributes";
	        ObjectFlags[ObjectFlags["MarkerType"] = 8192] = "MarkerType";
	        ObjectFlags[ObjectFlags["ClassOrInterface"] = 3] = "ClassOrInterface";
	    })(ObjectFlags = ts.ObjectFlags || (ts.ObjectFlags = {}));
	    /* @internal */
	    var Variance;
	    (function (Variance) {
	        Variance[Variance["Invariant"] = 0] = "Invariant";
	        Variance[Variance["Covariant"] = 1] = "Covariant";
	        Variance[Variance["Contravariant"] = 2] = "Contravariant";
	        Variance[Variance["Bivariant"] = 3] = "Bivariant";
	        Variance[Variance["Independent"] = 4] = "Independent";
	    })(Variance = ts.Variance || (ts.Variance = {}));
	    var SignatureKind;
	    (function (SignatureKind) {
	        SignatureKind[SignatureKind["Call"] = 0] = "Call";
	        SignatureKind[SignatureKind["Construct"] = 1] = "Construct";
	    })(SignatureKind = ts.SignatureKind || (ts.SignatureKind = {}));
	    var IndexKind;
	    (function (IndexKind) {
	        IndexKind[IndexKind["String"] = 0] = "String";
	        IndexKind[IndexKind["Number"] = 1] = "Number";
	    })(IndexKind = ts.IndexKind || (ts.IndexKind = {}));
	    var InferencePriority;
	    (function (InferencePriority) {
	        InferencePriority[InferencePriority["NakedTypeVariable"] = 1] = "NakedTypeVariable";
	        InferencePriority[InferencePriority["MappedType"] = 2] = "MappedType";
	        InferencePriority[InferencePriority["ReturnType"] = 4] = "ReturnType";
	        InferencePriority[InferencePriority["NoConstraints"] = 8] = "NoConstraints";
	        InferencePriority[InferencePriority["AlwaysStrict"] = 16] = "AlwaysStrict";
	    })(InferencePriority = ts.InferencePriority || (ts.InferencePriority = {}));
	    var InferenceFlags;
	    (function (InferenceFlags) {
	        InferenceFlags[InferenceFlags["None"] = 0] = "None";
	        InferenceFlags[InferenceFlags["InferUnionTypes"] = 1] = "InferUnionTypes";
	        InferenceFlags[InferenceFlags["NoDefault"] = 2] = "NoDefault";
	        InferenceFlags[InferenceFlags["AnyDefault"] = 4] = "AnyDefault";
	    })(InferenceFlags = ts.InferenceFlags || (ts.InferenceFlags = {}));
	    /**
	     * Ternary values are defined such that
	     * x & y is False if either x or y is False.
	     * x & y is Maybe if either x or y is Maybe, but neither x or y is False.
	     * x & y is True if both x and y are True.
	     * x | y is False if both x and y are False.
	     * x | y is Maybe if either x or y is Maybe, but neither x or y is True.
	     * x | y is True if either x or y is True.
	     */
	    var Ternary;
	    (function (Ternary) {
	        Ternary[Ternary["False"] = 0] = "False";
	        Ternary[Ternary["Maybe"] = 1] = "Maybe";
	        Ternary[Ternary["True"] = -1] = "True";
	    })(Ternary = ts.Ternary || (ts.Ternary = {}));
	    /* @internal */
	    var SpecialPropertyAssignmentKind;
	    (function (SpecialPropertyAssignmentKind) {
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["None"] = 0] = "None";
	        /// exports.name = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["ExportsProperty"] = 1] = "ExportsProperty";
	        /// module.exports = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["ModuleExports"] = 2] = "ModuleExports";
	        /// className.prototype.name = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["PrototypeProperty"] = 3] = "PrototypeProperty";
	        /// this.name = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["ThisProperty"] = 4] = "ThisProperty";
	        // F.name = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["Property"] = 5] = "Property";
	    })(SpecialPropertyAssignmentKind = ts.SpecialPropertyAssignmentKind || (ts.SpecialPropertyAssignmentKind = {}));
	    var DiagnosticCategory;
	    (function (DiagnosticCategory) {
	        DiagnosticCategory[DiagnosticCategory["Warning"] = 0] = "Warning";
	        DiagnosticCategory[DiagnosticCategory["Error"] = 1] = "Error";
	        DiagnosticCategory[DiagnosticCategory["Message"] = 2] = "Message";
	    })(DiagnosticCategory = ts.DiagnosticCategory || (ts.DiagnosticCategory = {}));
	    var ModuleResolutionKind;
	    (function (ModuleResolutionKind) {
	        ModuleResolutionKind[ModuleResolutionKind["Classic"] = 1] = "Classic";
	        ModuleResolutionKind[ModuleResolutionKind["NodeJs"] = 2] = "NodeJs";
	    })(ModuleResolutionKind = ts.ModuleResolutionKind || (ts.ModuleResolutionKind = {}));
	    var ModuleKind;
	    (function (ModuleKind) {
	        ModuleKind[ModuleKind["None"] = 0] = "None";
	        ModuleKind[ModuleKind["CommonJS"] = 1] = "CommonJS";
	        ModuleKind[ModuleKind["AMD"] = 2] = "AMD";
	        ModuleKind[ModuleKind["UMD"] = 3] = "UMD";
	        ModuleKind[ModuleKind["System"] = 4] = "System";
	        ModuleKind[ModuleKind["ES2015"] = 5] = "ES2015";
	        ModuleKind[ModuleKind["ESNext"] = 6] = "ESNext";
	    })(ModuleKind = ts.ModuleKind || (ts.ModuleKind = {}));
	    var JsxEmit;
	    (function (JsxEmit) {
	        JsxEmit[JsxEmit["None"] = 0] = "None";
	        JsxEmit[JsxEmit["Preserve"] = 1] = "Preserve";
	        JsxEmit[JsxEmit["React"] = 2] = "React";
	        JsxEmit[JsxEmit["ReactNative"] = 3] = "ReactNative";
	    })(JsxEmit = ts.JsxEmit || (ts.JsxEmit = {}));
	    var NewLineKind;
	    (function (NewLineKind) {
	        NewLineKind[NewLineKind["CarriageReturnLineFeed"] = 0] = "CarriageReturnLineFeed";
	        NewLineKind[NewLineKind["LineFeed"] = 1] = "LineFeed";
	    })(NewLineKind = ts.NewLineKind || (ts.NewLineKind = {}));
	    var ScriptKind;
	    (function (ScriptKind) {
	        ScriptKind[ScriptKind["Unknown"] = 0] = "Unknown";
	        ScriptKind[ScriptKind["JS"] = 1] = "JS";
	        ScriptKind[ScriptKind["JSX"] = 2] = "JSX";
	        ScriptKind[ScriptKind["TS"] = 3] = "TS";
	        ScriptKind[ScriptKind["TSX"] = 4] = "TSX";
	        ScriptKind[ScriptKind["External"] = 5] = "External";
	        ScriptKind[ScriptKind["JSON"] = 6] = "JSON";
	    })(ScriptKind = ts.ScriptKind || (ts.ScriptKind = {}));
	    var ScriptTarget;
	    (function (ScriptTarget) {
	        ScriptTarget[ScriptTarget["ES3"] = 0] = "ES3";
	        ScriptTarget[ScriptTarget["ES5"] = 1] = "ES5";
	        ScriptTarget[ScriptTarget["ES2015"] = 2] = "ES2015";
	        ScriptTarget[ScriptTarget["ES2016"] = 3] = "ES2016";
	        ScriptTarget[ScriptTarget["ES2017"] = 4] = "ES2017";
	        ScriptTarget[ScriptTarget["ES2018"] = 5] = "ES2018";
	        ScriptTarget[ScriptTarget["ESNext"] = 6] = "ESNext";
	        ScriptTarget[ScriptTarget["Latest"] = 6] = "Latest";
	    })(ScriptTarget = ts.ScriptTarget || (ts.ScriptTarget = {}));
	    var LanguageVariant;
	    (function (LanguageVariant) {
	        LanguageVariant[LanguageVariant["Standard"] = 0] = "Standard";
	        LanguageVariant[LanguageVariant["JSX"] = 1] = "JSX";
	    })(LanguageVariant = ts.LanguageVariant || (ts.LanguageVariant = {}));
	    /* @internal */
	    var DiagnosticStyle;
	    (function (DiagnosticStyle) {
	        DiagnosticStyle[DiagnosticStyle["Simple"] = 0] = "Simple";
	        DiagnosticStyle[DiagnosticStyle["Pretty"] = 1] = "Pretty";
	    })(DiagnosticStyle = ts.DiagnosticStyle || (ts.DiagnosticStyle = {}));
	    var WatchDirectoryFlags;
	    (function (WatchDirectoryFlags) {
	        WatchDirectoryFlags[WatchDirectoryFlags["None"] = 0] = "None";
	        WatchDirectoryFlags[WatchDirectoryFlags["Recursive"] = 1] = "Recursive";
	    })(WatchDirectoryFlags = ts.WatchDirectoryFlags || (ts.WatchDirectoryFlags = {}));
	    /* @internal */
	    var CharacterCodes;
	    (function (CharacterCodes) {
	        CharacterCodes[CharacterCodes["nullCharacter"] = 0] = "nullCharacter";
	        CharacterCodes[CharacterCodes["maxAsciiCharacter"] = 127] = "maxAsciiCharacter";
	        CharacterCodes[CharacterCodes["lineFeed"] = 10] = "lineFeed";
	        CharacterCodes[CharacterCodes["carriageReturn"] = 13] = "carriageReturn";
	        CharacterCodes[CharacterCodes["lineSeparator"] = 8232] = "lineSeparator";
	        CharacterCodes[CharacterCodes["paragraphSeparator"] = 8233] = "paragraphSeparator";
	        CharacterCodes[CharacterCodes["nextLine"] = 133] = "nextLine";
	        // Unicode 3.0 space characters
	        CharacterCodes[CharacterCodes["space"] = 32] = "space";
	        CharacterCodes[CharacterCodes["nonBreakingSpace"] = 160] = "nonBreakingSpace";
	        CharacterCodes[CharacterCodes["enQuad"] = 8192] = "enQuad";
	        CharacterCodes[CharacterCodes["emQuad"] = 8193] = "emQuad";
	        CharacterCodes[CharacterCodes["enSpace"] = 8194] = "enSpace";
	        CharacterCodes[CharacterCodes["emSpace"] = 8195] = "emSpace";
	        CharacterCodes[CharacterCodes["threePerEmSpace"] = 8196] = "threePerEmSpace";
	        CharacterCodes[CharacterCodes["fourPerEmSpace"] = 8197] = "fourPerEmSpace";
	        CharacterCodes[CharacterCodes["sixPerEmSpace"] = 8198] = "sixPerEmSpace";
	        CharacterCodes[CharacterCodes["figureSpace"] = 8199] = "figureSpace";
	        CharacterCodes[CharacterCodes["punctuationSpace"] = 8200] = "punctuationSpace";
	        CharacterCodes[CharacterCodes["thinSpace"] = 8201] = "thinSpace";
	        CharacterCodes[CharacterCodes["hairSpace"] = 8202] = "hairSpace";
	        CharacterCodes[CharacterCodes["zeroWidthSpace"] = 8203] = "zeroWidthSpace";
	        CharacterCodes[CharacterCodes["narrowNoBreakSpace"] = 8239] = "narrowNoBreakSpace";
	        CharacterCodes[CharacterCodes["ideographicSpace"] = 12288] = "ideographicSpace";
	        CharacterCodes[CharacterCodes["mathematicalSpace"] = 8287] = "mathematicalSpace";
	        CharacterCodes[CharacterCodes["ogham"] = 5760] = "ogham";
	        CharacterCodes[CharacterCodes["_"] = 95] = "_";
	        CharacterCodes[CharacterCodes["$"] = 36] = "$";
	        CharacterCodes[CharacterCodes["_0"] = 48] = "_0";
	        CharacterCodes[CharacterCodes["_1"] = 49] = "_1";
	        CharacterCodes[CharacterCodes["_2"] = 50] = "_2";
	        CharacterCodes[CharacterCodes["_3"] = 51] = "_3";
	        CharacterCodes[CharacterCodes["_4"] = 52] = "_4";
	        CharacterCodes[CharacterCodes["_5"] = 53] = "_5";
	        CharacterCodes[CharacterCodes["_6"] = 54] = "_6";
	        CharacterCodes[CharacterCodes["_7"] = 55] = "_7";
	        CharacterCodes[CharacterCodes["_8"] = 56] = "_8";
	        CharacterCodes[CharacterCodes["_9"] = 57] = "_9";
	        CharacterCodes[CharacterCodes["a"] = 97] = "a";
	        CharacterCodes[CharacterCodes["b"] = 98] = "b";
	        CharacterCodes[CharacterCodes["c"] = 99] = "c";
	        CharacterCodes[CharacterCodes["d"] = 100] = "d";
	        CharacterCodes[CharacterCodes["e"] = 101] = "e";
	        CharacterCodes[CharacterCodes["f"] = 102] = "f";
	        CharacterCodes[CharacterCodes["g"] = 103] = "g";
	        CharacterCodes[CharacterCodes["h"] = 104] = "h";
	        CharacterCodes[CharacterCodes["i"] = 105] = "i";
	        CharacterCodes[CharacterCodes["j"] = 106] = "j";
	        CharacterCodes[CharacterCodes["k"] = 107] = "k";
	        CharacterCodes[CharacterCodes["l"] = 108] = "l";
	        CharacterCodes[CharacterCodes["m"] = 109] = "m";
	        CharacterCodes[CharacterCodes["n"] = 110] = "n";
	        CharacterCodes[CharacterCodes["o"] = 111] = "o";
	        CharacterCodes[CharacterCodes["p"] = 112] = "p";
	        CharacterCodes[CharacterCodes["q"] = 113] = "q";
	        CharacterCodes[CharacterCodes["r"] = 114] = "r";
	        CharacterCodes[CharacterCodes["s"] = 115] = "s";
	        CharacterCodes[CharacterCodes["t"] = 116] = "t";
	        CharacterCodes[CharacterCodes["u"] = 117] = "u";
	        CharacterCodes[CharacterCodes["v"] = 118] = "v";
	        CharacterCodes[CharacterCodes["w"] = 119] = "w";
	        CharacterCodes[CharacterCodes["x"] = 120] = "x";
	        CharacterCodes[CharacterCodes["y"] = 121] = "y";
	        CharacterCodes[CharacterCodes["z"] = 122] = "z";
	        CharacterCodes[CharacterCodes["A"] = 65] = "A";
	        CharacterCodes[CharacterCodes["B"] = 66] = "B";
	        CharacterCodes[CharacterCodes["C"] = 67] = "C";
	        CharacterCodes[CharacterCodes["D"] = 68] = "D";
	        CharacterCodes[CharacterCodes["E"] = 69] = "E";
	        CharacterCodes[CharacterCodes["F"] = 70] = "F";
	        CharacterCodes[CharacterCodes["G"] = 71] = "G";
	        CharacterCodes[CharacterCodes["H"] = 72] = "H";
	        CharacterCodes[CharacterCodes["I"] = 73] = "I";
	        CharacterCodes[CharacterCodes["J"] = 74] = "J";
	        CharacterCodes[CharacterCodes["K"] = 75] = "K";
	        CharacterCodes[CharacterCodes["L"] = 76] = "L";
	        CharacterCodes[CharacterCodes["M"] = 77] = "M";
	        CharacterCodes[CharacterCodes["N"] = 78] = "N";
	        CharacterCodes[CharacterCodes["O"] = 79] = "O";
	        CharacterCodes[CharacterCodes["P"] = 80] = "P";
	        CharacterCodes[CharacterCodes["Q"] = 81] = "Q";
	        CharacterCodes[CharacterCodes["R"] = 82] = "R";
	        CharacterCodes[CharacterCodes["S"] = 83] = "S";
	        CharacterCodes[CharacterCodes["T"] = 84] = "T";
	        CharacterCodes[CharacterCodes["U"] = 85] = "U";
	        CharacterCodes[CharacterCodes["V"] = 86] = "V";
	        CharacterCodes[CharacterCodes["W"] = 87] = "W";
	        CharacterCodes[CharacterCodes["X"] = 88] = "X";
	        CharacterCodes[CharacterCodes["Y"] = 89] = "Y";
	        CharacterCodes[CharacterCodes["Z"] = 90] = "Z";
	        CharacterCodes[CharacterCodes["ampersand"] = 38] = "ampersand";
	        CharacterCodes[CharacterCodes["asterisk"] = 42] = "asterisk";
	        CharacterCodes[CharacterCodes["at"] = 64] = "at";
	        CharacterCodes[CharacterCodes["backslash"] = 92] = "backslash";
	        CharacterCodes[CharacterCodes["backtick"] = 96] = "backtick";
	        CharacterCodes[CharacterCodes["bar"] = 124] = "bar";
	        CharacterCodes[CharacterCodes["caret"] = 94] = "caret";
	        CharacterCodes[CharacterCodes["closeBrace"] = 125] = "closeBrace";
	        CharacterCodes[CharacterCodes["closeBracket"] = 93] = "closeBracket";
	        CharacterCodes[CharacterCodes["closeParen"] = 41] = "closeParen";
	        CharacterCodes[CharacterCodes["colon"] = 58] = "colon";
	        CharacterCodes[CharacterCodes["comma"] = 44] = "comma";
	        CharacterCodes[CharacterCodes["dot"] = 46] = "dot";
	        CharacterCodes[CharacterCodes["doubleQuote"] = 34] = "doubleQuote";
	        CharacterCodes[CharacterCodes["equals"] = 61] = "equals";
	        CharacterCodes[CharacterCodes["exclamation"] = 33] = "exclamation";
	        CharacterCodes[CharacterCodes["greaterThan"] = 62] = "greaterThan";
	        CharacterCodes[CharacterCodes["hash"] = 35] = "hash";
	        CharacterCodes[CharacterCodes["lessThan"] = 60] = "lessThan";
	        CharacterCodes[CharacterCodes["minus"] = 45] = "minus";
	        CharacterCodes[CharacterCodes["openBrace"] = 123] = "openBrace";
	        CharacterCodes[CharacterCodes["openBracket"] = 91] = "openBracket";
	        CharacterCodes[CharacterCodes["openParen"] = 40] = "openParen";
	        CharacterCodes[CharacterCodes["percent"] = 37] = "percent";
	        CharacterCodes[CharacterCodes["plus"] = 43] = "plus";
	        CharacterCodes[CharacterCodes["question"] = 63] = "question";
	        CharacterCodes[CharacterCodes["semicolon"] = 59] = "semicolon";
	        CharacterCodes[CharacterCodes["singleQuote"] = 39] = "singleQuote";
	        CharacterCodes[CharacterCodes["slash"] = 47] = "slash";
	        CharacterCodes[CharacterCodes["tilde"] = 126] = "tilde";
	        CharacterCodes[CharacterCodes["backspace"] = 8] = "backspace";
	        CharacterCodes[CharacterCodes["formFeed"] = 12] = "formFeed";
	        CharacterCodes[CharacterCodes["byteOrderMark"] = 65279] = "byteOrderMark";
	        CharacterCodes[CharacterCodes["tab"] = 9] = "tab";
	        CharacterCodes[CharacterCodes["verticalTab"] = 11] = "verticalTab";
	    })(CharacterCodes = ts.CharacterCodes || (ts.CharacterCodes = {}));
	    var Extension;
	    (function (Extension) {
	        Extension["Ts"] = ".ts";
	        Extension["Tsx"] = ".tsx";
	        Extension["Dts"] = ".d.ts";
	        Extension["Js"] = ".js";
	        Extension["Jsx"] = ".jsx";
	        Extension["Json"] = ".json";
	    })(Extension = ts.Extension || (ts.Extension = {}));
	    /* @internal */
	    var TransformFlags;
	    (function (TransformFlags) {
	        TransformFlags[TransformFlags["None"] = 0] = "None";
	        // Facts
	        // - Flags used to indicate that a node or subtree contains syntax that requires transformation.
	        TransformFlags[TransformFlags["TypeScript"] = 1] = "TypeScript";
	        TransformFlags[TransformFlags["ContainsTypeScript"] = 2] = "ContainsTypeScript";
	        TransformFlags[TransformFlags["ContainsJsx"] = 4] = "ContainsJsx";
	        TransformFlags[TransformFlags["ContainsESNext"] = 8] = "ContainsESNext";
	        TransformFlags[TransformFlags["ContainsES2017"] = 16] = "ContainsES2017";
	        TransformFlags[TransformFlags["ContainsES2016"] = 32] = "ContainsES2016";
	        TransformFlags[TransformFlags["ES2015"] = 64] = "ES2015";
	        TransformFlags[TransformFlags["ContainsES2015"] = 128] = "ContainsES2015";
	        TransformFlags[TransformFlags["Generator"] = 256] = "Generator";
	        TransformFlags[TransformFlags["ContainsGenerator"] = 512] = "ContainsGenerator";
	        TransformFlags[TransformFlags["DestructuringAssignment"] = 1024] = "DestructuringAssignment";
	        TransformFlags[TransformFlags["ContainsDestructuringAssignment"] = 2048] = "ContainsDestructuringAssignment";
	        // Markers
	        // - Flags used to indicate that a subtree contains a specific transformation.
	        TransformFlags[TransformFlags["ContainsDecorators"] = 4096] = "ContainsDecorators";
	        TransformFlags[TransformFlags["ContainsPropertyInitializer"] = 8192] = "ContainsPropertyInitializer";
	        TransformFlags[TransformFlags["ContainsLexicalThis"] = 16384] = "ContainsLexicalThis";
	        TransformFlags[TransformFlags["ContainsCapturedLexicalThis"] = 32768] = "ContainsCapturedLexicalThis";
	        TransformFlags[TransformFlags["ContainsLexicalThisInComputedPropertyName"] = 65536] = "ContainsLexicalThisInComputedPropertyName";
	        TransformFlags[TransformFlags["ContainsDefaultValueAssignments"] = 131072] = "ContainsDefaultValueAssignments";
	        TransformFlags[TransformFlags["ContainsParameterPropertyAssignments"] = 262144] = "ContainsParameterPropertyAssignments";
	        TransformFlags[TransformFlags["ContainsSpread"] = 524288] = "ContainsSpread";
	        TransformFlags[TransformFlags["ContainsObjectSpread"] = 1048576] = "ContainsObjectSpread";
	        TransformFlags[TransformFlags["ContainsRest"] = 524288] = "ContainsRest";
	        TransformFlags[TransformFlags["ContainsObjectRest"] = 1048576] = "ContainsObjectRest";
	        TransformFlags[TransformFlags["ContainsComputedPropertyName"] = 2097152] = "ContainsComputedPropertyName";
	        TransformFlags[TransformFlags["ContainsBlockScopedBinding"] = 4194304] = "ContainsBlockScopedBinding";
	        TransformFlags[TransformFlags["ContainsBindingPattern"] = 8388608] = "ContainsBindingPattern";
	        TransformFlags[TransformFlags["ContainsYield"] = 16777216] = "ContainsYield";
	        TransformFlags[TransformFlags["ContainsHoistedDeclarationOrCompletion"] = 33554432] = "ContainsHoistedDeclarationOrCompletion";
	        TransformFlags[TransformFlags["ContainsDynamicImport"] = 67108864] = "ContainsDynamicImport";
	        TransformFlags[TransformFlags["Super"] = 134217728] = "Super";
	        TransformFlags[TransformFlags["ContainsSuper"] = 268435456] = "ContainsSuper";
	        // Please leave this as 1 << 29.
	        // It is the maximum bit we can set before we outgrow the size of a v8 small integer (SMI) on an x86 system.
	        // It is a good reminder of how much room we have left
	        TransformFlags[TransformFlags["HasComputedFlags"] = 536870912] = "HasComputedFlags";
	        // Assertions
	        // - Bitmasks that are used to assert facts about the syntax of a node and its subtree.
	        TransformFlags[TransformFlags["AssertTypeScript"] = 3] = "AssertTypeScript";
	        TransformFlags[TransformFlags["AssertJsx"] = 4] = "AssertJsx";
	        TransformFlags[TransformFlags["AssertESNext"] = 8] = "AssertESNext";
	        TransformFlags[TransformFlags["AssertES2017"] = 16] = "AssertES2017";
	        TransformFlags[TransformFlags["AssertES2016"] = 32] = "AssertES2016";
	        TransformFlags[TransformFlags["AssertES2015"] = 192] = "AssertES2015";
	        TransformFlags[TransformFlags["AssertGenerator"] = 768] = "AssertGenerator";
	        TransformFlags[TransformFlags["AssertDestructuringAssignment"] = 3072] = "AssertDestructuringAssignment";
	        // Scope Exclusions
	        // - Bitmasks that exclude flags from propagating out of a specific context
	        //   into the subtree flags of their container.
	        TransformFlags[TransformFlags["OuterExpressionExcludes"] = 536872257] = "OuterExpressionExcludes";
	        TransformFlags[TransformFlags["PropertyAccessExcludes"] = 671089985] = "PropertyAccessExcludes";
	        TransformFlags[TransformFlags["NodeExcludes"] = 939525441] = "NodeExcludes";
	        TransformFlags[TransformFlags["ArrowFunctionExcludes"] = 1003902273] = "ArrowFunctionExcludes";
	        TransformFlags[TransformFlags["FunctionExcludes"] = 1003935041] = "FunctionExcludes";
	        TransformFlags[TransformFlags["ConstructorExcludes"] = 1003668801] = "ConstructorExcludes";
	        TransformFlags[TransformFlags["MethodOrAccessorExcludes"] = 1003668801] = "MethodOrAccessorExcludes";
	        TransformFlags[TransformFlags["ClassExcludes"] = 942011713] = "ClassExcludes";
	        TransformFlags[TransformFlags["ModuleExcludes"] = 977327425] = "ModuleExcludes";
	        TransformFlags[TransformFlags["TypeExcludes"] = -3] = "TypeExcludes";
	        TransformFlags[TransformFlags["ObjectLiteralExcludes"] = 942740801] = "ObjectLiteralExcludes";
	        TransformFlags[TransformFlags["ArrayLiteralOrCallOrNewExcludes"] = 940049729] = "ArrayLiteralOrCallOrNewExcludes";
	        TransformFlags[TransformFlags["VariableDeclarationListExcludes"] = 948962625] = "VariableDeclarationListExcludes";
	        TransformFlags[TransformFlags["ParameterExcludes"] = 939525441] = "ParameterExcludes";
	        TransformFlags[TransformFlags["CatchClauseExcludes"] = 940574017] = "CatchClauseExcludes";
	        TransformFlags[TransformFlags["BindingPatternExcludes"] = 940049729] = "BindingPatternExcludes";
	        // Masks
	        // - Additional bitmasks
	        TransformFlags[TransformFlags["TypeScriptClassSyntaxMask"] = 274432] = "TypeScriptClassSyntaxMask";
	        TransformFlags[TransformFlags["ES2015FunctionSyntaxMask"] = 163840] = "ES2015FunctionSyntaxMask";
	    })(TransformFlags = ts.TransformFlags || (ts.TransformFlags = {}));
	    var EmitFlags;
	    (function (EmitFlags) {
	        EmitFlags[EmitFlags["SingleLine"] = 1] = "SingleLine";
	        EmitFlags[EmitFlags["AdviseOnEmitNode"] = 2] = "AdviseOnEmitNode";
	        EmitFlags[EmitFlags["NoSubstitution"] = 4] = "NoSubstitution";
	        EmitFlags[EmitFlags["CapturesThis"] = 8] = "CapturesThis";
	        EmitFlags[EmitFlags["NoLeadingSourceMap"] = 16] = "NoLeadingSourceMap";
	        EmitFlags[EmitFlags["NoTrailingSourceMap"] = 32] = "NoTrailingSourceMap";
	        EmitFlags[EmitFlags["NoSourceMap"] = 48] = "NoSourceMap";
	        EmitFlags[EmitFlags["NoNestedSourceMaps"] = 64] = "NoNestedSourceMaps";
	        EmitFlags[EmitFlags["NoTokenLeadingSourceMaps"] = 128] = "NoTokenLeadingSourceMaps";
	        EmitFlags[EmitFlags["NoTokenTrailingSourceMaps"] = 256] = "NoTokenTrailingSourceMaps";
	        EmitFlags[EmitFlags["NoTokenSourceMaps"] = 384] = "NoTokenSourceMaps";
	        EmitFlags[EmitFlags["NoLeadingComments"] = 512] = "NoLeadingComments";
	        EmitFlags[EmitFlags["NoTrailingComments"] = 1024] = "NoTrailingComments";
	        EmitFlags[EmitFlags["NoComments"] = 1536] = "NoComments";
	        EmitFlags[EmitFlags["NoNestedComments"] = 2048] = "NoNestedComments";
	        EmitFlags[EmitFlags["HelperName"] = 4096] = "HelperName";
	        EmitFlags[EmitFlags["ExportName"] = 8192] = "ExportName";
	        EmitFlags[EmitFlags["LocalName"] = 16384] = "LocalName";
	        EmitFlags[EmitFlags["InternalName"] = 32768] = "InternalName";
	        EmitFlags[EmitFlags["Indented"] = 65536] = "Indented";
	        EmitFlags[EmitFlags["NoIndentation"] = 131072] = "NoIndentation";
	        EmitFlags[EmitFlags["AsyncFunctionBody"] = 262144] = "AsyncFunctionBody";
	        EmitFlags[EmitFlags["ReuseTempVariableScope"] = 524288] = "ReuseTempVariableScope";
	        EmitFlags[EmitFlags["CustomPrologue"] = 1048576] = "CustomPrologue";
	        EmitFlags[EmitFlags["NoHoisting"] = 2097152] = "NoHoisting";
	        EmitFlags[EmitFlags["HasEndOfDeclarationMarker"] = 4194304] = "HasEndOfDeclarationMarker";
	        EmitFlags[EmitFlags["Iterator"] = 8388608] = "Iterator";
	        EmitFlags[EmitFlags["NoAsciiEscaping"] = 16777216] = "NoAsciiEscaping";
	        /*@internal*/ EmitFlags[EmitFlags["TypeScriptClassWrapper"] = 33554432] = "TypeScriptClassWrapper";
	        /*@internal*/ EmitFlags[EmitFlags["NeverApplyImportHelper"] = 67108864] = "NeverApplyImportHelper";
	    })(EmitFlags = ts.EmitFlags || (ts.EmitFlags = {}));
	    /**
	     * Used by the checker, this enum keeps track of external emit helpers that should be type
	     * checked.
	     */
	    /* @internal */
	    var ExternalEmitHelpers;
	    (function (ExternalEmitHelpers) {
	        ExternalEmitHelpers[ExternalEmitHelpers["Extends"] = 1] = "Extends";
	        ExternalEmitHelpers[ExternalEmitHelpers["Assign"] = 2] = "Assign";
	        ExternalEmitHelpers[ExternalEmitHelpers["Rest"] = 4] = "Rest";
	        ExternalEmitHelpers[ExternalEmitHelpers["Decorate"] = 8] = "Decorate";
	        ExternalEmitHelpers[ExternalEmitHelpers["Metadata"] = 16] = "Metadata";
	        ExternalEmitHelpers[ExternalEmitHelpers["Param"] = 32] = "Param";
	        ExternalEmitHelpers[ExternalEmitHelpers["Awaiter"] = 64] = "Awaiter";
	        ExternalEmitHelpers[ExternalEmitHelpers["Generator"] = 128] = "Generator";
	        ExternalEmitHelpers[ExternalEmitHelpers["Values"] = 256] = "Values";
	        ExternalEmitHelpers[ExternalEmitHelpers["Read"] = 512] = "Read";
	        ExternalEmitHelpers[ExternalEmitHelpers["Spread"] = 1024] = "Spread";
	        ExternalEmitHelpers[ExternalEmitHelpers["Await"] = 2048] = "Await";
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncGenerator"] = 4096] = "AsyncGenerator";
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncDelegator"] = 8192] = "AsyncDelegator";
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncValues"] = 16384] = "AsyncValues";
	        ExternalEmitHelpers[ExternalEmitHelpers["ExportStar"] = 32768] = "ExportStar";
	        ExternalEmitHelpers[ExternalEmitHelpers["MakeTemplateObject"] = 65536] = "MakeTemplateObject";
	        ExternalEmitHelpers[ExternalEmitHelpers["FirstEmitHelper"] = 1] = "FirstEmitHelper";
	        ExternalEmitHelpers[ExternalEmitHelpers["LastEmitHelper"] = 65536] = "LastEmitHelper";
	        // Helpers included by ES2015 for..of
	        ExternalEmitHelpers[ExternalEmitHelpers["ForOfIncludes"] = 256] = "ForOfIncludes";
	        // Helpers included by ES2017 for..await..of
	        ExternalEmitHelpers[ExternalEmitHelpers["ForAwaitOfIncludes"] = 16384] = "ForAwaitOfIncludes";
	        // Helpers included by ES2017 async generators
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncGeneratorIncludes"] = 6144] = "AsyncGeneratorIncludes";
	        // Helpers included by yield* in ES2017 async generators
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncDelegatorIncludes"] = 26624] = "AsyncDelegatorIncludes";
	        // Helpers included by ES2015 spread
	        ExternalEmitHelpers[ExternalEmitHelpers["SpreadIncludes"] = 1536] = "SpreadIncludes";
	    })(ExternalEmitHelpers = ts.ExternalEmitHelpers || (ts.ExternalEmitHelpers = {}));
	    var EmitHint;
	    (function (EmitHint) {
	        EmitHint[EmitHint["SourceFile"] = 0] = "SourceFile";
	        EmitHint[EmitHint["Expression"] = 1] = "Expression";
	        EmitHint[EmitHint["IdentifierName"] = 2] = "IdentifierName";
	        EmitHint[EmitHint["MappedTypeParameter"] = 3] = "MappedTypeParameter";
	        EmitHint[EmitHint["Unspecified"] = 4] = "Unspecified";
	    })(EmitHint = ts.EmitHint || (ts.EmitHint = {}));
	    var ListFormat;
	    (function (ListFormat) {
	        ListFormat[ListFormat["None"] = 0] = "None";
	        // Line separators
	        ListFormat[ListFormat["SingleLine"] = 0] = "SingleLine";
	        ListFormat[ListFormat["MultiLine"] = 1] = "MultiLine";
	        ListFormat[ListFormat["PreserveLines"] = 2] = "PreserveLines";
	        ListFormat[ListFormat["LinesMask"] = 3] = "LinesMask";
	        // Delimiters
	        ListFormat[ListFormat["NotDelimited"] = 0] = "NotDelimited";
	        ListFormat[ListFormat["BarDelimited"] = 4] = "BarDelimited";
	        ListFormat[ListFormat["AmpersandDelimited"] = 8] = "AmpersandDelimited";
	        ListFormat[ListFormat["CommaDelimited"] = 16] = "CommaDelimited";
	        ListFormat[ListFormat["DelimitersMask"] = 28] = "DelimitersMask";
	        ListFormat[ListFormat["AllowTrailingComma"] = 32] = "AllowTrailingComma";
	        // Whitespace
	        ListFormat[ListFormat["Indented"] = 64] = "Indented";
	        ListFormat[ListFormat["SpaceBetweenBraces"] = 128] = "SpaceBetweenBraces";
	        ListFormat[ListFormat["SpaceBetweenSiblings"] = 256] = "SpaceBetweenSiblings";
	        // Brackets/Braces
	        ListFormat[ListFormat["Braces"] = 512] = "Braces";
	        ListFormat[ListFormat["Parenthesis"] = 1024] = "Parenthesis";
	        ListFormat[ListFormat["AngleBrackets"] = 2048] = "AngleBrackets";
	        ListFormat[ListFormat["SquareBrackets"] = 4096] = "SquareBrackets";
	        ListFormat[ListFormat["BracketsMask"] = 7680] = "BracketsMask";
	        ListFormat[ListFormat["OptionalIfUndefined"] = 8192] = "OptionalIfUndefined";
	        ListFormat[ListFormat["OptionalIfEmpty"] = 16384] = "OptionalIfEmpty";
	        ListFormat[ListFormat["Optional"] = 24576] = "Optional";
	        // Other
	        ListFormat[ListFormat["PreferNewLine"] = 32768] = "PreferNewLine";
	        ListFormat[ListFormat["NoTrailingNewLine"] = 65536] = "NoTrailingNewLine";
	        ListFormat[ListFormat["NoInterveningComments"] = 131072] = "NoInterveningComments";
	        ListFormat[ListFormat["NoSpaceIfEmpty"] = 262144] = "NoSpaceIfEmpty";
	        ListFormat[ListFormat["SingleElement"] = 524288] = "SingleElement";
	        // Precomputed Formats
	        ListFormat[ListFormat["Modifiers"] = 131328] = "Modifiers";
	        ListFormat[ListFormat["HeritageClauses"] = 256] = "HeritageClauses";
	        ListFormat[ListFormat["SingleLineTypeLiteralMembers"] = 448] = "SingleLineTypeLiteralMembers";
	        ListFormat[ListFormat["MultiLineTypeLiteralMembers"] = 65] = "MultiLineTypeLiteralMembers";
	        ListFormat[ListFormat["TupleTypeElements"] = 336] = "TupleTypeElements";
	        ListFormat[ListFormat["UnionTypeConstituents"] = 260] = "UnionTypeConstituents";
	        ListFormat[ListFormat["IntersectionTypeConstituents"] = 264] = "IntersectionTypeConstituents";
	        ListFormat[ListFormat["ObjectBindingPatternElements"] = 262576] = "ObjectBindingPatternElements";
	        ListFormat[ListFormat["ArrayBindingPatternElements"] = 262448] = "ArrayBindingPatternElements";
	        ListFormat[ListFormat["ObjectLiteralExpressionProperties"] = 263122] = "ObjectLiteralExpressionProperties";
	        ListFormat[ListFormat["ArrayLiteralExpressionElements"] = 4466] = "ArrayLiteralExpressionElements";
	        ListFormat[ListFormat["CommaListElements"] = 272] = "CommaListElements";
	        ListFormat[ListFormat["CallExpressionArguments"] = 1296] = "CallExpressionArguments";
	        ListFormat[ListFormat["NewExpressionArguments"] = 9488] = "NewExpressionArguments";
	        ListFormat[ListFormat["TemplateExpressionSpans"] = 131072] = "TemplateExpressionSpans";
	        ListFormat[ListFormat["SingleLineBlockStatements"] = 384] = "SingleLineBlockStatements";
	        ListFormat[ListFormat["MultiLineBlockStatements"] = 65] = "MultiLineBlockStatements";
	        ListFormat[ListFormat["VariableDeclarationList"] = 272] = "VariableDeclarationList";
	        ListFormat[ListFormat["SingleLineFunctionBodyStatements"] = 384] = "SingleLineFunctionBodyStatements";
	        ListFormat[ListFormat["MultiLineFunctionBodyStatements"] = 1] = "MultiLineFunctionBodyStatements";
	        ListFormat[ListFormat["ClassHeritageClauses"] = 256] = "ClassHeritageClauses";
	        ListFormat[ListFormat["ClassMembers"] = 65] = "ClassMembers";
	        ListFormat[ListFormat["InterfaceMembers"] = 65] = "InterfaceMembers";
	        ListFormat[ListFormat["EnumMembers"] = 81] = "EnumMembers";
	        ListFormat[ListFormat["CaseBlockClauses"] = 65] = "CaseBlockClauses";
	        ListFormat[ListFormat["NamedImportsOrExportsElements"] = 432] = "NamedImportsOrExportsElements";
	        ListFormat[ListFormat["JsxElementOrFragmentChildren"] = 131072] = "JsxElementOrFragmentChildren";
	        ListFormat[ListFormat["JsxElementAttributes"] = 131328] = "JsxElementAttributes";
	        ListFormat[ListFormat["CaseOrDefaultClauseStatements"] = 81985] = "CaseOrDefaultClauseStatements";
	        ListFormat[ListFormat["HeritageClauseTypes"] = 272] = "HeritageClauseTypes";
	        ListFormat[ListFormat["SourceFileStatements"] = 65537] = "SourceFileStatements";
	        ListFormat[ListFormat["Decorators"] = 24577] = "Decorators";
	        ListFormat[ListFormat["TypeArguments"] = 26896] = "TypeArguments";
	        ListFormat[ListFormat["TypeParameters"] = 26896] = "TypeParameters";
	        ListFormat[ListFormat["Parameters"] = 1296] = "Parameters";
	        ListFormat[ListFormat["IndexSignatureParameters"] = 4432] = "IndexSignatureParameters";
	    })(ListFormat = ts.ListFormat || (ts.ListFormat = {}));
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    /** Gets a timestamp with (at least) ms resolution */
	    ts.timestamp = typeof performance !== "undefined" && performance.now ? function () { return performance.now(); } : Date.now ? Date.now : function () { return +(new Date()); };
	})(ts || (ts = {}));
	/*@internal*/
	/** Performance measurements for the compiler. */
	(function (ts) {
	    var performance;
	    (function (performance) {
	        // NOTE: cannot use ts.noop as core.ts loads after this
	        var profilerEvent = typeof onProfilerEvent === "function" && onProfilerEvent.profiler === true ? onProfilerEvent : function () { };
	        var enabled = false;
	        var profilerStart = 0;
	        var counts;
	        var marks;
	        var measures;
	        /**
	         * Marks a performance event.
	         *
	         * @param markName The name of the mark.
	         */
	        function mark(markName) {
	            if (enabled) {
	                marks.set(markName, ts.timestamp());
	                counts.set(markName, (counts.get(markName) || 0) + 1);
	                profilerEvent(markName);
	            }
	        }
	        performance.mark = mark;
	        /**
	         * Adds a performance measurement with the specified name.
	         *
	         * @param measureName The name of the performance measurement.
	         * @param startMarkName The name of the starting mark. If not supplied, the point at which the
	         *      profiler was enabled is used.
	         * @param endMarkName The name of the ending mark. If not supplied, the current timestamp is
	         *      used.
	         */
	        function measure(measureName, startMarkName, endMarkName) {
	            if (enabled) {
	                var end = endMarkName && marks.get(endMarkName) || ts.timestamp();
	                var start = startMarkName && marks.get(startMarkName) || profilerStart;
	                measures.set(measureName, (measures.get(measureName) || 0) + (end - start));
	            }
	        }
	        performance.measure = measure;
	        /**
	         * Gets the number of times a marker was encountered.
	         *
	         * @param markName The name of the mark.
	         */
	        function getCount(markName) {
	            return counts && counts.get(markName) || 0;
	        }
	        performance.getCount = getCount;
	        /**
	         * Gets the total duration of all measurements with the supplied name.
	         *
	         * @param measureName The name of the measure whose durations should be accumulated.
	         */
	        function getDuration(measureName) {
	            return measures && measures.get(measureName) || 0;
	        }
	        performance.getDuration = getDuration;
	        /**
	         * Iterate over each measure, performing some action
	         *
	         * @param cb The action to perform for each measure
	         */
	        function forEachMeasure(cb) {
	            measures.forEach(function (measure, key) {
	                cb(key, measure);
	            });
	        }
	        performance.forEachMeasure = forEachMeasure;
	        /** Enables (and resets) performance measurements for the compiler. */
	        function enable() {
	            counts = ts.createMap();
	            marks = ts.createMap();
	            measures = ts.createMap();
	            enabled = true;
	            profilerStart = ts.timestamp();
	        }
	        performance.enable = enable;
	        /** Disables performance measurements for the compiler. */
	        function disable() {
	            enabled = false;
	        }
	        performance.disable = disable;
	    })(performance = ts.performance || (ts.performance = {}));
	})(ts || (ts = {}));
	/// <reference path="types.ts"/>
	/// <reference path="performance.ts" />
	var ts;
	(function (ts) {
	    // WARNING: The script `configureNightly.ts` uses a regexp to parse out these values.
	    // If changing the text in this section, be sure to test `configureNightly` too.
	    ts.versionMajorMinor = "2.8";
	    /** The version of the TypeScript compiler release */
	    ts.version = ts.versionMajorMinor + ".0-dev.20180224";
	})(ts || (ts = {}));
	(function (ts) {
	    function isExternalModuleNameRelative(moduleName) {
	        // TypeScript 1.0 spec (April 2014): 11.2.1
	        // An external module name is "relative" if the first term is "." or "..".
	        // Update: We also consider a path like `C:\foo.ts` "relative" because we do not search for it in `node_modules` or treat it as an ambient module.
	        return ts.pathIsRelative(moduleName) || ts.isRootedDiskPath(moduleName);
	    }
	    ts.isExternalModuleNameRelative = isExternalModuleNameRelative;
	    function sortAndDeduplicateDiagnostics(diagnostics) {
	        return ts.sortAndDeduplicate(diagnostics, ts.compareDiagnostics);
	    }
	    ts.sortAndDeduplicateDiagnostics = sortAndDeduplicateDiagnostics;
	})(ts || (ts = {}));
	/* @internal */
	(function (ts) {
	    ts.emptyArray = [];
	    /** Create a MapLike with good performance. */
	    function createDictionaryObject() {
	        var map = Object.create(/*prototype*/ null); // tslint:disable-line:no-null-keyword
	        // Using 'delete' on an object causes V8 to put the object in dictionary mode.
	        // This disables creation of hidden classes, which are expensive when an object is
	        // constantly changing shape.
	        map.__ = undefined;
	        delete map.__;
	        return map;
	    }
	    /** Create a new map. If a template object is provided, the map will copy entries from it. */
	    function createMap() {
	        return new MapCtr();
	    }
	    ts.createMap = createMap;
	    /** Create a new escaped identifier map. */
	    function createUnderscoreEscapedMap() {
	        return new MapCtr();
	    }
	    ts.createUnderscoreEscapedMap = createUnderscoreEscapedMap;
	    function createSymbolTable(symbols) {
	        var result = createMap();
	        if (symbols) {
	            for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
	                var symbol = symbols_1[_i];
	                result.set(symbol.escapedName, symbol);
	            }
	        }
	        return result;
	    }
	    ts.createSymbolTable = createSymbolTable;
	    function createMapFromTemplate(template) {
	        var map = new MapCtr();
	        // Copies keys/values from template. Note that for..in will not throw if
	        // template is undefined, and instead will just exit the loop.
	        for (var key in template) {
	            if (hasOwnProperty.call(template, key)) {
	                map.set(key, template[key]);
	            }
	        }
	        return map;
	    }
	    ts.createMapFromTemplate = createMapFromTemplate;
	    // Internet Explorer's Map doesn't support iteration, so don't use it.
	    // tslint:disable-next-line no-in-operator variable-name
	    var MapCtr = typeof Map !== "undefined" && "entries" in Map.prototype ? Map : shimMap();
	    // Keep the class inside a function so it doesn't get compiled if it's not used.
	    function shimMap() {
	        var MapIterator = /** @class */ (function () {
	            function MapIterator(data, selector) {
	                this.index = 0;
	                this.data = data;
	                this.selector = selector;
	                this.keys = Object.keys(data);
	            }
	            MapIterator.prototype.next = function () {
	                var index = this.index;
	                if (index < this.keys.length) {
	                    this.index++;
	                    return { value: this.selector(this.data, this.keys[index]), done: false };
	                }
	                return { value: undefined, done: true };
	            };
	            return MapIterator;
	        }());
	        return /** @class */ (function () {
	            function class_1() {
	                this.data = createDictionaryObject();
	                this.size = 0;
	            }
	            class_1.prototype.get = function (key) {
	                return this.data[key];
	            };
	            class_1.prototype.set = function (key, value) {
	                if (!this.has(key)) {
	                    this.size++;
	                }
	                this.data[key] = value;
	                return this;
	            };
	            class_1.prototype.has = function (key) {
	                // tslint:disable-next-line:no-in-operator
	                return key in this.data;
	            };
	            class_1.prototype.delete = function (key) {
	                if (this.has(key)) {
	                    this.size--;
	                    delete this.data[key];
	                    return true;
	                }
	                return false;
	            };
	            class_1.prototype.clear = function () {
	                this.data = createDictionaryObject();
	                this.size = 0;
	            };
	            class_1.prototype.keys = function () {
	                return new MapIterator(this.data, function (_data, key) { return key; });
	            };
	            class_1.prototype.values = function () {
	                return new MapIterator(this.data, function (data, key) { return data[key]; });
	            };
	            class_1.prototype.entries = function () {
	                return new MapIterator(this.data, function (data, key) { return [key, data[key]]; });
	            };
	            class_1.prototype.forEach = function (action) {
	                for (var key in this.data) {
	                    action(this.data[key], key);
	                }
	            };
	            return class_1;
	        }());
	    }
	    function toPath(fileName, basePath, getCanonicalFileName) {
	        var nonCanonicalizedPath = isRootedDiskPath(fileName)
	            ? normalizePath(fileName)
	            : getNormalizedAbsolutePath(fileName, basePath);
	        return getCanonicalFileName(nonCanonicalizedPath);
	    }
	    ts.toPath = toPath;
	    function length(array) {
	        return array ? array.length : 0;
	    }
	    ts.length = length;
	    /**
	     * Iterates through 'array' by index and performs the callback on each element of array until the callback
	     * returns a truthy value, then returns that value.
	     * If no such value is found, the callback is applied to each element of array and undefined is returned.
	     */
	    function forEach(array, callback) {
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var result = callback(array[i], i);
	                if (result) {
	                    return result;
	                }
	            }
	        }
	        return undefined;
	    }
	    ts.forEach = forEach;
	    /** Like `forEach`, but suitable for use with numbers and strings (which may be falsy). */
	    function firstDefined(array, callback) {
	        if (array === undefined) {
	            return undefined;
	        }
	        for (var i = 0; i < array.length; i++) {
	            var result = callback(array[i], i);
	            if (result !== undefined) {
	                return result;
	            }
	        }
	        return undefined;
	    }
	    ts.firstDefined = firstDefined;
	    function firstDefinedIterator(iter, callback) {
	        while (true) {
	            var _a = iter.next(), value = _a.value, done = _a.done;
	            if (done) {
	                return undefined;
	            }
	            var result = callback(value);
	            if (result !== undefined) {
	                return result;
	            }
	        }
	    }
	    ts.firstDefinedIterator = firstDefinedIterator;
	    function findAncestor(node, callback) {
	        while (node) {
	            var result = callback(node);
	            if (result === "quit") {
	                return undefined;
	            }
	            else if (result) {
	                return node;
	            }
	            node = node.parent;
	        }
	        return undefined;
	    }
	    ts.findAncestor = findAncestor;
	    function zipWith(arrayA, arrayB, callback) {
	        var result = [];
	        Debug.assertEqual(arrayA.length, arrayB.length);
	        for (var i = 0; i < arrayA.length; i++) {
	            result.push(callback(arrayA[i], arrayB[i], i));
	        }
	        return result;
	    }
	    ts.zipWith = zipWith;
	    function zipToIterator(arrayA, arrayB) {
	        Debug.assertEqual(arrayA.length, arrayB.length);
	        var i = 0;
	        return {
	            next: function () {
	                if (i === arrayA.length) {
	                    return { value: undefined, done: true };
	                }
	                i++;
	                return { value: [arrayA[i - 1], arrayB[i - 1]], done: false };
	            }
	        };
	    }
	    ts.zipToIterator = zipToIterator;
	    function zipToMap(keys, values) {
	        Debug.assert(keys.length === values.length);
	        var map = createMap();
	        for (var i = 0; i < keys.length; ++i) {
	            map.set(keys[i], values[i]);
	        }
	        return map;
	    }
	    ts.zipToMap = zipToMap;
	    /**
	     * Iterates through `array` by index and performs the callback on each element of array until the callback
	     * returns a falsey value, then returns false.
	     * If no such value is found, the callback is applied to each element of array and `true` is returned.
	     */
	    function every(array, callback) {
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                if (!callback(array[i], i)) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    }
	    ts.every = every;
	    function find(array, predicate) {
	        for (var i = 0; i < array.length; i++) {
	            var value = array[i];
	            if (predicate(value, i)) {
	                return value;
	            }
	        }
	        return undefined;
	    }
	    ts.find = find;
	    function findLast(array, predicate) {
	        for (var i = array.length - 1; i >= 0; i--) {
	            var value = array[i];
	            if (predicate(value, i)) {
	                return value;
	            }
	        }
	        return undefined;
	    }
	    ts.findLast = findLast;
	    /** Works like Array.prototype.findIndex, returning `-1` if no element satisfying the predicate is found. */
	    function findIndex(array, predicate) {
	        for (var i = 0; i < array.length; i++) {
	            if (predicate(array[i], i)) {
	                return i;
	            }
	        }
	        return -1;
	    }
	    ts.findIndex = findIndex;
	    /**
	     * Returns the first truthy result of `callback`, or else fails.
	     * This is like `forEach`, but never returns undefined.
	     */
	    function findMap(array, callback) {
	        for (var i = 0; i < array.length; i++) {
	            var result = callback(array[i], i);
	            if (result) {
	                return result;
	            }
	        }
	        Debug.fail();
	    }
	    ts.findMap = findMap;
	    function contains(array, value, equalityComparer) {
	        if (equalityComparer === void 0) { equalityComparer = equateValues; }
	        if (array) {
	            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
	                var v = array_1[_i];
	                if (equalityComparer(v, value)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	    ts.contains = contains;
	    function arraysEqual(a, b, equalityComparer) {
	        if (equalityComparer === void 0) { equalityComparer = equateValues; }
	        return a.length === b.length && a.every(function (x, i) { return equalityComparer(x, b[i]); });
	    }
	    ts.arraysEqual = arraysEqual;
	    function indexOfAnyCharCode(text, charCodes, start) {
	        for (var i = start || 0; i < text.length; i++) {
	            if (contains(charCodes, text.charCodeAt(i))) {
	                return i;
	            }
	        }
	        return -1;
	    }
	    ts.indexOfAnyCharCode = indexOfAnyCharCode;
	    function countWhere(array, predicate) {
	        var count = 0;
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var v = array[i];
	                if (predicate(v, i)) {
	                    count++;
	                }
	            }
	        }
	        return count;
	    }
	    ts.countWhere = countWhere;
	    function filter(array, f) {
	        if (array) {
	            var len = array.length;
	            var i = 0;
	            while (i < len && f(array[i]))
	                i++;
	            if (i < len) {
	                var result = array.slice(0, i);
	                i++;
	                while (i < len) {
	                    var item = array[i];
	                    if (f(item)) {
	                        result.push(item);
	                    }
	                    i++;
	                }
	                return result;
	            }
	        }
	        return array;
	    }
	    ts.filter = filter;
	    function filterMutate(array, f) {
	        var outIndex = 0;
	        for (var i = 0; i < array.length; i++) {
	            if (f(array[i], i, array)) {
	                array[outIndex] = array[i];
	                outIndex++;
	            }
	        }
	        array.length = outIndex;
	    }
	    ts.filterMutate = filterMutate;
	    function clear(array) {
	        array.length = 0;
	    }
	    ts.clear = clear;
	    function map(array, f) {
	        var result;
	        if (array) {
	            result = [];
	            for (var i = 0; i < array.length; i++) {
	                result.push(f(array[i], i));
	            }
	        }
	        return result;
	    }
	    ts.map = map;
	    function mapIterator(iter, mapFn) {
	        return {
	            next: function () {
	                var iterRes = iter.next();
	                return iterRes.done ? iterRes : { value: mapFn(iterRes.value), done: false };
	            }
	        };
	    }
	    ts.mapIterator = mapIterator;
	    function sameMap(array, f) {
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var item = array[i];
	                var mapped = f(item, i);
	                if (item !== mapped) {
	                    var result = array.slice(0, i);
	                    result.push(mapped);
	                    for (i++; i < array.length; i++) {
	                        result.push(f(array[i], i));
	                    }
	                    return result;
	                }
	            }
	        }
	        return array;
	    }
	    ts.sameMap = sameMap;
	    /**
	     * Flattens an array containing a mix of array or non-array elements.
	     *
	     * @param array The array to flatten.
	     */
	    function flatten(array) {
	        var result;
	        if (array) {
	            result = [];
	            for (var _i = 0, array_2 = array; _i < array_2.length; _i++) {
	                var v = array_2[_i];
	                if (v) {
	                    if (isArray(v)) {
	                        addRange(result, v);
	                    }
	                    else {
	                        result.push(v);
	                    }
	                }
	            }
	        }
	        return result;
	    }
	    ts.flatten = flatten;
	    /**
	     * Maps an array. If the mapped value is an array, it is spread into the result.
	     *
	     * @param array The array to map.
	     * @param mapfn The callback used to map the result into one or more values.
	     */
	    function flatMap(array, mapfn) {
	        var result;
	        if (array) {
	            result = [];
	            for (var i = 0; i < array.length; i++) {
	                var v = mapfn(array[i], i);
	                if (v) {
	                    if (isArray(v)) {
	                        addRange(result, v);
	                    }
	                    else {
	                        result.push(v);
	                    }
	                }
	            }
	        }
	        return result;
	    }
	    ts.flatMap = flatMap;
	    function flatMapIterator(iter, mapfn) {
	        var first = iter.next();
	        if (first.done) {
	            return ts.emptyIterator;
	        }
	        var currentIter = getIterator(first.value);
	        return {
	            next: function () {
	                while (true) {
	                    var currentRes = currentIter.next();
	                    if (!currentRes.done) {
	                        return currentRes;
	                    }
	                    var iterRes = iter.next();
	                    if (iterRes.done) {
	                        return iterRes;
	                    }
	                    currentIter = getIterator(iterRes.value);
	                }
	            },
	        };
	        function getIterator(x) {
	            var res = mapfn(x);
	            return res === undefined ? ts.emptyIterator : isArray(res) ? arrayIterator(res) : res;
	        }
	    }
	    ts.flatMapIterator = flatMapIterator;
	    function sameFlatMap(array, mapfn) {
	        var result;
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var item = array[i];
	                var mapped = mapfn(item, i);
	                if (result || item !== mapped || isArray(mapped)) {
	                    if (!result) {
	                        result = array.slice(0, i);
	                    }
	                    if (isArray(mapped)) {
	                        addRange(result, mapped);
	                    }
	                    else {
	                        result.push(mapped);
	                    }
	                }
	            }
	        }
	        return result || array;
	    }
	    ts.sameFlatMap = sameFlatMap;
	    function mapAllOrFail(array, mapFn) {
	        var result = [];
	        for (var i = 0; i < array.length; i++) {
	            var mapped = mapFn(array[i], i);
	            if (mapped === undefined) {
	                return undefined;
	            }
	            result.push(mapped);
	        }
	        return result;
	    }
	    ts.mapAllOrFail = mapAllOrFail;
	    function mapDefined(array, mapFn) {
	        var result = [];
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var mapped = mapFn(array[i], i);
	                if (mapped !== undefined) {
	                    result.push(mapped);
	                }
	            }
	        }
	        return result;
	    }
	    ts.mapDefined = mapDefined;
	    function mapDefinedIterator(iter, mapFn) {
	        return {
	            next: function () {
	                while (true) {
	                    var res = iter.next();
	                    if (res.done) {
	                        return res;
	                    }
	                    var value = mapFn(res.value);
	                    if (value !== undefined) {
	                        return { value: value, done: false };
	                    }
	                }
	            }
	        };
	    }
	    ts.mapDefinedIterator = mapDefinedIterator;
	    ts.emptyIterator = { next: function () { return ({ value: undefined, done: true }); } };
	    function singleIterator(value) {
	        var done = false;
	        return {
	            next: function () {
	                var wasDone = done;
	                done = true;
	                return wasDone ? { value: undefined, done: true } : { value: value, done: false };
	            }
	        };
	    }
	    ts.singleIterator = singleIterator;
	    /**
	     * Computes the first matching span of elements and returns a tuple of the first span
	     * and the remaining elements.
	     */
	    function span(array, f) {
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                if (!f(array[i], i)) {
	                    return [array.slice(0, i), array.slice(i)];
	                }
	            }
	            return [array.slice(0), []];
	        }
	        return undefined;
	    }
	    ts.span = span;
	    /**
	     * Maps contiguous spans of values with the same key.
	     *
	     * @param array The array to map.
	     * @param keyfn A callback used to select the key for an element.
	     * @param mapfn A callback used to map a contiguous chunk of values to a single value.
	     */
	    function spanMap(array, keyfn, mapfn) {
	        var result;
	        if (array) {
	            result = [];
	            var len = array.length;
	            var previousKey = void 0;
	            var key = void 0;
	            var start = 0;
	            var pos = 0;
	            while (start < len) {
	                while (pos < len) {
	                    var value = array[pos];
	                    key = keyfn(value, pos);
	                    if (pos === 0) {
	                        previousKey = key;
	                    }
	                    else if (key !== previousKey) {
	                        break;
	                    }
	                    pos++;
	                }
	                if (start < pos) {
	                    var v = mapfn(array.slice(start, pos), previousKey, start, pos);
	                    if (v) {
	                        result.push(v);
	                    }
	                    start = pos;
	                }
	                previousKey = key;
	                pos++;
	            }
	        }
	        return result;
	    }
	    ts.spanMap = spanMap;
	    function mapEntries(map, f) {
	        if (!map) {
	            return undefined;
	        }
	        var result = createMap();
	        map.forEach(function (value, key) {
	            var _a = f(key, value), newKey = _a[0], newValue = _a[1];
	            result.set(newKey, newValue);
	        });
	        return result;
	    }
	    ts.mapEntries = mapEntries;
	    function some(array, predicate) {
	        if (array) {
	            if (predicate) {
	                for (var _i = 0, array_3 = array; _i < array_3.length; _i++) {
	                    var v = array_3[_i];
	                    if (predicate(v)) {
	                        return true;
	                    }
	                }
	            }
	            else {
	                return array.length > 0;
	            }
	        }
	        return false;
	    }
	    ts.some = some;
	    function concatenate(array1, array2) {
	        if (!some(array2))
	            return array1;
	        if (!some(array1))
	            return array2;
	        return array1.concat(array2);
	    }
	    ts.concatenate = concatenate;
	    function deduplicateRelational(array, equalityComparer, comparer) {
	        // Perform a stable sort of the array. This ensures the first entry in a list of
	        // duplicates remains the first entry in the result.
	        var indices = array.map(function (_, i) { return i; });
	        stableSortIndices(array, indices, comparer);
	        var last = array[indices[0]];
	        var deduplicated = [indices[0]];
	        for (var i = 1; i < indices.length; i++) {
	            var index = indices[i];
	            var item = array[index];
	            if (!equalityComparer(last, item)) {
	                deduplicated.push(index);
	                last = item;
	            }
	        }
	        // restore original order
	        deduplicated.sort();
	        return deduplicated.map(function (i) { return array[i]; });
	    }
	    function deduplicateEquality(array, equalityComparer) {
	        var result = [];
	        for (var _i = 0, array_4 = array; _i < array_4.length; _i++) {
	            var item = array_4[_i];
	            pushIfUnique(result, item, equalityComparer);
	        }
	        return result;
	    }
	    /**
	     * Deduplicates an unsorted array.
	     * @param equalityComparer An optional `EqualityComparer` used to determine if two values are duplicates.
	     * @param comparer An optional `Comparer` used to sort entries before comparison, though the
	     * result will remain in the original order in `array`.
	     */
	    function deduplicate(array, equalityComparer, comparer) {
	        return !array ? undefined :
	            array.length === 0 ? [] :
	                array.length === 1 ? array.slice() :
	                    comparer ? deduplicateRelational(array, equalityComparer, comparer) :
	                        deduplicateEquality(array, equalityComparer);
	    }
	    ts.deduplicate = deduplicate;
	    /**
	     * Deduplicates an array that has already been sorted.
	     */
	    function deduplicateSorted(array, comparer) {
	        if (!array)
	            return undefined;
	        if (array.length === 0)
	            return [];
	        var last = array[0];
	        var deduplicated = [last];
	        for (var i = 1; i < array.length; i++) {
	            var next = array[i];
	            switch (comparer(next, last)) {
	                // equality comparison
	                case true:
	                // relational comparison
	                case 0 /* EqualTo */:
	                    continue;
	                case -1 /* LessThan */:
	                    // If `array` is sorted, `next` should **never** be less than `last`.
	                    return Debug.fail("Array is unsorted.");
	            }
	            deduplicated.push(last = next);
	        }
	        return deduplicated;
	    }
	    function insertSorted(array, insert, compare) {
	        if (array.length === 0) {
	            array.push(insert);
	            return;
	        }
	        var insertIndex = binarySearch(array, insert, identity, compare);
	        if (insertIndex < 0) {
	            array.splice(~insertIndex, 0, insert);
	        }
	    }
	    ts.insertSorted = insertSorted;
	    function sortAndDeduplicate(array, comparer, equalityComparer) {
	        return deduplicateSorted(sort(array, comparer), equalityComparer || comparer);
	    }
	    ts.sortAndDeduplicate = sortAndDeduplicate;
	    function arrayIsEqualTo(array1, array2, equalityComparer) {
	        if (equalityComparer === void 0) { equalityComparer = equateValues; }
	        if (!array1 || !array2) {
	            return array1 === array2;
	        }
	        if (array1.length !== array2.length) {
	            return false;
	        }
	        for (var i = 0; i < array1.length; i++) {
	            if (!equalityComparer(array1[i], array2[i])) {
	                return false;
	            }
	        }
	        return true;
	    }
	    ts.arrayIsEqualTo = arrayIsEqualTo;
	    function changesAffectModuleResolution(oldOptions, newOptions) {
	        return !oldOptions ||
	            (oldOptions.module !== newOptions.module) ||
	            (oldOptions.moduleResolution !== newOptions.moduleResolution) ||
	            (oldOptions.noResolve !== newOptions.noResolve) ||
	            (oldOptions.target !== newOptions.target) ||
	            (oldOptions.noLib !== newOptions.noLib) ||
	            (oldOptions.jsx !== newOptions.jsx) ||
	            (oldOptions.allowJs !== newOptions.allowJs) ||
	            (oldOptions.rootDir !== newOptions.rootDir) ||
	            (oldOptions.configFilePath !== newOptions.configFilePath) ||
	            (oldOptions.baseUrl !== newOptions.baseUrl) ||
	            (oldOptions.maxNodeModuleJsDepth !== newOptions.maxNodeModuleJsDepth) ||
	            !arrayIsEqualTo(oldOptions.lib, newOptions.lib) ||
	            !arrayIsEqualTo(oldOptions.typeRoots, newOptions.typeRoots) ||
	            !arrayIsEqualTo(oldOptions.rootDirs, newOptions.rootDirs) ||
	            !equalOwnProperties(oldOptions.paths, newOptions.paths);
	    }
	    ts.changesAffectModuleResolution = changesAffectModuleResolution;
	    function compact(array) {
	        var result;
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var v = array[i];
	                if (result || !v) {
	                    if (!result) {
	                        result = array.slice(0, i);
	                    }
	                    if (v) {
	                        result.push(v);
	                    }
	                }
	            }
	        }
	        return result || array;
	    }
	    ts.compact = compact;
	    /**
	     * Gets the relative complement of `arrayA` with respect to `arrayB`, returning the elements that
	     * are not present in `arrayA` but are present in `arrayB`. Assumes both arrays are sorted
	     * based on the provided comparer.
	     */
	    function relativeComplement(arrayA, arrayB, comparer) {
	        if (!arrayB || !arrayA || arrayB.length === 0 || arrayA.length === 0)
	            return arrayB;
	        var result = [];
	        loopB: for (var offsetA = 0, offsetB = 0; offsetB < arrayB.length; offsetB++) {
	            if (offsetB > 0) {
	                // Ensure `arrayB` is properly sorted.
	                Debug.assertGreaterThanOrEqual(comparer(arrayB[offsetB], arrayB[offsetB - 1]), 0 /* EqualTo */);
	            }
	            loopA: for (var startA = offsetA; offsetA < arrayA.length; offsetA++) {
	                if (offsetA > startA) {
	                    // Ensure `arrayA` is properly sorted. We only need to perform this check if
	                    // `offsetA` has changed since we entered the loop.
	                    Debug.assertGreaterThanOrEqual(comparer(arrayA[offsetA], arrayA[offsetA - 1]), 0 /* EqualTo */);
	                }
	                switch (comparer(arrayB[offsetB], arrayA[offsetA])) {
	                    case -1 /* LessThan */:
	                        // If B is less than A, B does not exist in arrayA. Add B to the result and
	                        // move to the next element in arrayB without changing the current position
	                        // in arrayA.
	                        result.push(arrayB[offsetB]);
	                        continue loopB;
	                    case 0 /* EqualTo */:
	                        // If B is equal to A, B exists in arrayA. Move to the next element in
	                        // arrayB without adding B to the result or changing the current position
	                        // in arrayA.
	                        continue loopB;
	                    case 1 /* GreaterThan */:
	                        // If B is greater than A, we need to keep looking for B in arrayA. Move to
	                        // the next element in arrayA and recheck.
	                        continue loopA;
	                }
	            }
	        }
	        return result;
	    }
	    ts.relativeComplement = relativeComplement;
	    function sum(array, prop) {
	        var result = 0;
	        for (var _i = 0, array_5 = array; _i < array_5.length; _i++) {
	            var v = array_5[_i];
	            // TODO: Remove the following type assertion once the fix for #17069 is merged
	            result += v[prop];
	        }
	        return result;
	    }
	    ts.sum = sum;
	    /**
	     * Appends a value to an array, returning the array.
	     *
	     * @param to The array to which `value` is to be appended. If `to` is `undefined`, a new array
	     * is created if `value` was appended.
	     * @param value The value to append to the array. If `value` is `undefined`, nothing is
	     * appended.
	     */
	    function append(to, value) {
	        if (value === undefined)
	            return to;
	        if (to === undefined)
	            return [value];
	        to.push(value);
	        return to;
	    }
	    ts.append = append;
	    /**
	     * Gets the actual offset into an array for a relative offset. Negative offsets indicate a
	     * position offset from the end of the array.
	     */
	    function toOffset(array, offset) {
	        return offset < 0 ? array.length + offset : offset;
	    }
	    /**
	     * Appends a range of value to an array, returning the array.
	     *
	     * @param to The array to which `value` is to be appended. If `to` is `undefined`, a new array
	     * is created if `value` was appended.
	     * @param from The values to append to the array. If `from` is `undefined`, nothing is
	     * appended. If an element of `from` is `undefined`, that element is not appended.
	     * @param start The offset in `from` at which to start copying values.
	     * @param end The offset in `from` at which to stop copying values (non-inclusive).
	     */
	    function addRange(to, from, start, end) {
	        if (from === undefined || from.length === 0)
	            return to;
	        if (to === undefined)
	            return from.slice(start, end);
	        start = start === undefined ? 0 : toOffset(from, start);
	        end = end === undefined ? from.length : toOffset(from, end);
	        for (var i = start; i < end && i < from.length; i++) {
	            if (from[i] !== undefined) {
	                to.push(from[i]);
	            }
	        }
	        return to;
	    }
	    ts.addRange = addRange;
	    /**
	     * @return Whether the value was added.
	     */
	    function pushIfUnique(array, toAdd, equalityComparer) {
	        if (contains(array, toAdd, equalityComparer)) {
	            return false;
	        }
	        else {
	            array.push(toAdd);
	            return true;
	        }
	    }
	    ts.pushIfUnique = pushIfUnique;
	    /**
	     * Unlike `pushIfUnique`, this can take `undefined` as an input, and returns a new array.
	     */
	    function appendIfUnique(array, toAdd, equalityComparer) {
	        if (array) {
	            pushIfUnique(array, toAdd, equalityComparer);
	            return array;
	        }
	        else {
	            return [toAdd];
	        }
	    }
	    ts.appendIfUnique = appendIfUnique;
	    function stableSortIndices(array, indices, comparer) {
	        // sort indices by value then position
	        indices.sort(function (x, y) { return comparer(array[x], array[y]) || compareValues(x, y); });
	    }
	    /**
	     * Returns a new sorted array.
	     */
	    function sort(array, comparer) {
	        return array.slice().sort(comparer);
	    }
	    ts.sort = sort;
	    function best(iter, isBetter) {
	        var x = iter.next();
	        if (x.done) {
	            return undefined;
	        }
	        var best = x.value;
	        while (true) {
	            var _a = iter.next(), value = _a.value, done = _a.done;
	            if (done) {
	                return best;
	            }
	            if (isBetter(value, best)) {
	                best = value;
	            }
	        }
	    }
	    ts.best = best;
	    function arrayIterator(array) {
	        var i = 0;
	        return { next: function () {
	                if (i === array.length) {
	                    return { value: undefined, done: true };
	                }
	                else {
	                    i++;
	                    return { value: array[i - 1], done: false };
	                }
	            } };
	    }
	    ts.arrayIterator = arrayIterator;
	    /**
	     * Stable sort of an array. Elements equal to each other maintain their relative position in the array.
	     */
	    function stableSort(array, comparer) {
	        var indices = array.map(function (_, i) { return i; });
	        stableSortIndices(array, indices, comparer);
	        return indices.map(function (i) { return array[i]; });
	    }
	    ts.stableSort = stableSort;
	    function rangeEquals(array1, array2, pos, end) {
	        while (pos < end) {
	            if (array1[pos] !== array2[pos]) {
	                return false;
	            }
	            pos++;
	        }
	        return true;
	    }
	    ts.rangeEquals = rangeEquals;
	    /**
	     * Returns the element at a specific offset in an array if non-empty, `undefined` otherwise.
	     * A negative offset indicates the element should be retrieved from the end of the array.
	     */
	    function elementAt(array, offset) {
	        if (array) {
	            offset = toOffset(array, offset);
	            if (offset < array.length) {
	                return array[offset];
	            }
	        }
	        return undefined;
	    }
	    ts.elementAt = elementAt;
	    /**
	     * Returns the first element of an array if non-empty, `undefined` otherwise.
	     */
	    function firstOrUndefined(array) {
	        return elementAt(array, 0);
	    }
	    ts.firstOrUndefined = firstOrUndefined;
	    function first(array) {
	        Debug.assert(array.length !== 0);
	        return array[0];
	    }
	    ts.first = first;
	    /**
	     * Returns the last element of an array if non-empty, `undefined` otherwise.
	     */
	    function lastOrUndefined(array) {
	        return elementAt(array, -1);
	    }
	    ts.lastOrUndefined = lastOrUndefined;
	    function last(array) {
	        Debug.assert(array.length !== 0);
	        return array[array.length - 1];
	    }
	    ts.last = last;
	    /**
	     * Returns the only element of an array if it contains only one element, `undefined` otherwise.
	     */
	    function singleOrUndefined(array) {
	        return array && array.length === 1
	            ? array[0]
	            : undefined;
	    }
	    ts.singleOrUndefined = singleOrUndefined;
	    function singleOrMany(array) {
	        return array && array.length === 1
	            ? array[0]
	            : array;
	    }
	    ts.singleOrMany = singleOrMany;
	    function replaceElement(array, index, value) {
	        var result = array.slice(0);
	        result[index] = value;
	        return result;
	    }
	    ts.replaceElement = replaceElement;
	    /**
	     * Performs a binary search, finding the index at which `value` occurs in `array`.
	     * If no such index is found, returns the 2's-complement of first index at which
	     * `array[index]` exceeds `value`.
	     * @param array A sorted array whose first element must be no larger than number
	     * @param value The value to be searched for in the array.
	     * @param keySelector A callback used to select the search key from `value` and each element of
	     * `array`.
	     * @param keyComparer A callback used to compare two keys in a sorted array.
	     * @param offset An offset into `array` at which to start the search.
	     */
	    function binarySearch(array, value, keySelector, keyComparer, offset) {
	        if (!array || array.length === 0) {
	            return -1;
	        }
	        var low = offset || 0;
	        var high = array.length - 1;
	        var key = keySelector(value);
	        while (low <= high) {
	            var middle = low + ((high - low) >> 1);
	            var midKey = keySelector(array[middle]);
	            switch (keyComparer(midKey, key)) {
	                case -1 /* LessThan */:
	                    low = middle + 1;
	                    break;
	                case 0 /* EqualTo */:
	                    return middle;
	                case 1 /* GreaterThan */:
	                    high = middle - 1;
	                    break;
	            }
	        }
	        return ~low;
	    }
	    ts.binarySearch = binarySearch;
	    function reduceLeft(array, f, initial, start, count) {
	        if (array && array.length > 0) {
	            var size = array.length;
	            if (size > 0) {
	                var pos = start === undefined || start < 0 ? 0 : start;
	                var end = count === undefined || pos + count > size - 1 ? size - 1 : pos + count;
	                var result = void 0;
	                if (arguments.length <= 2) {
	                    result = array[pos];
	                    pos++;
	                }
	                else {
	                    result = initial;
	                }
	                while (pos <= end) {
	                    result = f(result, array[pos], pos);
	                    pos++;
	                }
	                return result;
	            }
	        }
	        return initial;
	    }
	    ts.reduceLeft = reduceLeft;
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    /**
	     * Indicates whether a map-like contains an own property with the specified key.
	     *
	     * @param map A map-like.
	     * @param key A property key.
	     */
	    function hasProperty(map, key) {
	        return hasOwnProperty.call(map, key);
	    }
	    ts.hasProperty = hasProperty;
	    /**
	     * Gets the value of an owned property in a map-like.
	     *
	     * @param map A map-like.
	     * @param key A property key.
	     */
	    function getProperty(map, key) {
	        return hasOwnProperty.call(map, key) ? map[key] : undefined;
	    }
	    ts.getProperty = getProperty;
	    /**
	     * Gets the owned, enumerable property keys of a map-like.
	     */
	    function getOwnKeys(map) {
	        var keys = [];
	        for (var key in map) {
	            if (hasOwnProperty.call(map, key)) {
	                keys.push(key);
	            }
	        }
	        return keys;
	    }
	    ts.getOwnKeys = getOwnKeys;
	    function getOwnValues(sparseArray) {
	        var values = [];
	        for (var key in sparseArray) {
	            if (hasOwnProperty.call(sparseArray, key)) {
	                values.push(sparseArray[key]);
	            }
	        }
	        return values;
	    }
	    ts.getOwnValues = getOwnValues;
	    function arrayFrom(iterator, map) {
	        var result = [];
	        for (var _a = iterator.next(), value = _a.value, done = _a.done; !done; _b = iterator.next(), value = _b.value, done = _b.done, _b) {
	            result.push(map ? map(value) : value);
	        }
	        return result;
	        var _b;
	    }
	    ts.arrayFrom = arrayFrom;
	    function forEachEntry(map, callback) {
	        var iterator = map.entries();
	        for (var _a = iterator.next(), pair = _a.value, done = _a.done; !done; _b = iterator.next(), pair = _b.value, done = _b.done, _b) {
	            var key = pair[0], value = pair[1];
	            var result = callback(value, key);
	            if (result) {
	                return result;
	            }
	        }
	        return undefined;
	        var _b;
	    }
	    ts.forEachEntry = forEachEntry;
	    function forEachKey(map, callback) {
	        var iterator = map.keys();
	        for (var _a = iterator.next(), key = _a.value, done = _a.done; !done; _b = iterator.next(), key = _b.value, done = _b.done, _b) {
	            var result = callback(key);
	            if (result) {
	                return result;
	            }
	        }
	        return undefined;
	        var _b;
	    }
	    ts.forEachKey = forEachKey;
	    function copyEntries(source, target) {
	        source.forEach(function (value, key) {
	            target.set(key, value);
	        });
	    }
	    ts.copyEntries = copyEntries;
	    function assign(t) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	            var arg = args_1[_a];
	            for (var p in arg) {
	                if (hasProperty(arg, p)) {
	                    t[p] = arg[p];
	                }
	            }
	        }
	        return t;
	    }
	    ts.assign = assign;
	    /**
	     * Performs a shallow equality comparison of the contents of two map-likes.
	     *
	     * @param left A map-like whose properties should be compared.
	     * @param right A map-like whose properties should be compared.
	     */
	    function equalOwnProperties(left, right, equalityComparer) {
	        if (equalityComparer === void 0) { equalityComparer = equateValues; }
	        if (left === right)
	            return true;
	        if (!left || !right)
	            return false;
	        for (var key in left) {
	            if (hasOwnProperty.call(left, key)) {
	                if (!hasOwnProperty.call(right, key) === undefined)
	                    return false;
	                if (!equalityComparer(left[key], right[key]))
	                    return false;
	            }
	        }
	        for (var key in right) {
	            if (hasOwnProperty.call(right, key)) {
	                if (!hasOwnProperty.call(left, key))
	                    return false;
	            }
	        }
	        return true;
	    }
	    ts.equalOwnProperties = equalOwnProperties;
	    function arrayToMap(array, makeKey, makeValue) {
	        if (makeValue === void 0) { makeValue = identity; }
	        var result = createMap();
	        for (var _i = 0, array_6 = array; _i < array_6.length; _i++) {
	            var value = array_6[_i];
	            result.set(makeKey(value), makeValue(value));
	        }
	        return result;
	    }
	    ts.arrayToMap = arrayToMap;
	    function arrayToNumericMap(array, makeKey, makeValue) {
	        if (makeValue === void 0) { makeValue = identity; }
	        var result = [];
	        for (var _i = 0, array_7 = array; _i < array_7.length; _i++) {
	            var value = array_7[_i];
	            result[makeKey(value)] = makeValue(value);
	        }
	        return result;
	    }
	    ts.arrayToNumericMap = arrayToNumericMap;
	    function arrayToSet(array, makeKey) {
	        return arrayToMap(array, makeKey || (function (s) { return s; }), function () { return true; });
	    }
	    ts.arrayToSet = arrayToSet;
	    function arrayToMultiMap(values, makeKey, makeValue) {
	        if (makeValue === void 0) { makeValue = identity; }
	        var result = createMultiMap();
	        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
	            var value = values_1[_i];
	            result.add(makeKey(value), makeValue(value));
	        }
	        return result;
	    }
	    ts.arrayToMultiMap = arrayToMultiMap;
	    function group(values, getGroupId) {
	        return arrayFrom(arrayToMultiMap(values, getGroupId).values());
	    }
	    ts.group = group;
	    function cloneMap(map) {
	        var clone = createMap();
	        copyEntries(map, clone);
	        return clone;
	    }
	    ts.cloneMap = cloneMap;
	    function clone(object) {
	        var result = {};
	        for (var id in object) {
	            if (hasOwnProperty.call(object, id)) {
	                result[id] = object[id];
	            }
	        }
	        return result;
	    }
	    ts.clone = clone;
	    function extend(first, second) {
	        var result = {};
	        for (var id in second) {
	            if (hasOwnProperty.call(second, id)) {
	                result[id] = second[id];
	            }
	        }
	        for (var id in first) {
	            if (hasOwnProperty.call(first, id)) {
	                result[id] = first[id];
	            }
	        }
	        return result;
	    }
	    ts.extend = extend;
	    function createMultiMap() {
	        var map = createMap();
	        map.add = multiMapAdd;
	        map.remove = multiMapRemove;
	        return map;
	    }
	    ts.createMultiMap = createMultiMap;
	    function multiMapAdd(key, value) {
	        var values = this.get(key);
	        if (values) {
	            values.push(value);
	        }
	        else {
	            this.set(key, values = [value]);
	        }
	        return values;
	    }
	    function multiMapRemove(key, value) {
	        var values = this.get(key);
	        if (values) {
	            unorderedRemoveItem(values, value);
	            if (!values.length) {
	                this.delete(key);
	            }
	        }
	    }
	    /**
	     * Tests whether a value is an array.
	     */
	    function isArray(value) {
	        return Array.isArray ? Array.isArray(value) : value instanceof Array;
	    }
	    ts.isArray = isArray;
	    function toArray(value) {
	        return isArray(value) ? value : [value];
	    }
	    ts.toArray = toArray;
	    /**
	     * Tests whether a value is string
	     */
	    function isString(text) {
	        return typeof text === "string";
	    }
	    ts.isString = isString;
	    function tryCast(value, test) {
	        return value !== undefined && test(value) ? value : undefined;
	    }
	    ts.tryCast = tryCast;
	    function cast(value, test) {
	        if (value !== undefined && test(value))
	            return value;
	        if (value && typeof value.kind === "number") {
	            Debug.fail("Invalid cast. The supplied " + Debug.showSyntaxKind(value) + " did not pass the test '" + Debug.getFunctionName(test) + "'.");
	        }
	        else {
	            Debug.fail("Invalid cast. The supplied value did not pass the test '" + Debug.getFunctionName(test) + "'.");
	        }
	    }
	    ts.cast = cast;
	    /** Does nothing. */
	    function noop(_) { } // tslint:disable-line no-empty
	    ts.noop = noop;
	    /** Do nothing and return false */
	    function returnFalse() { return false; }
	    ts.returnFalse = returnFalse;
	    /** Do nothing and return true */
	    function returnTrue() { return true; }
	    ts.returnTrue = returnTrue;
	    /** Returns its argument. */
	    function identity(x) { return x; }
	    ts.identity = identity;
	    /** Returns lower case string */
	    function toLowerCase(x) { return x.toLowerCase(); }
	    ts.toLowerCase = toLowerCase;
	    /** Throws an error because a function is not implemented. */
	    function notImplemented() {
	        throw new Error("Not implemented");
	    }
	    ts.notImplemented = notImplemented;
	    function memoize(callback) {
	        var value;
	        return function () {
	            if (callback) {
	                value = callback();
	                callback = undefined;
	            }
	            return value;
	        };
	    }
	    ts.memoize = memoize;
	    function chain(a, b, c, d, e) {
	        if (e) {
	            var args_2 = [];
	            for (var i = 0; i < arguments.length; i++) {
	                args_2[i] = arguments[i];
	            }
	            return function (t) { return compose.apply(void 0, map(args_2, function (f) { return f(t); })); };
	        }
	        else if (d) {
	            return function (t) { return compose(a(t), b(t), c(t), d(t)); };
	        }
	        else if (c) {
	            return function (t) { return compose(a(t), b(t), c(t)); };
	        }
	        else if (b) {
	            return function (t) { return compose(a(t), b(t)); };
	        }
	        else if (a) {
	            return function (t) { return compose(a(t)); };
	        }
	        else {
	            return function (_) { return function (u) { return u; }; };
	        }
	    }
	    ts.chain = chain;
	    function compose(a, b, c, d, e) {
	        if (e) {
	            var args_3 = [];
	            for (var i = 0; i < arguments.length; i++) {
	                args_3[i] = arguments[i];
	            }
	            return function (t) { return reduceLeft(args_3, function (u, f) { return f(u); }, t); };
	        }
	        else if (d) {
	            return function (t) { return d(c(b(a(t)))); };
	        }
	        else if (c) {
	            return function (t) { return c(b(a(t))); };
	        }
	        else if (b) {
	            return function (t) { return b(a(t)); };
	        }
	        else if (a) {
	            return function (t) { return a(t); };
	        }
	        else {
	            return function (t) { return t; };
	        }
	    }
	    ts.compose = compose;
	    function formatStringFromArgs(text, args, baseIndex) {
	        baseIndex = baseIndex || 0;
	        return text.replace(/{(\d+)}/g, function (_match, index) { return args[+index + baseIndex]; });
	    }
	    ts.formatStringFromArgs = formatStringFromArgs;
	    ts.localizedDiagnosticMessages = undefined;
	    function getLocaleSpecificMessage(message) {
	        return ts.localizedDiagnosticMessages && ts.localizedDiagnosticMessages[message.key] || message.message;
	    }
	    ts.getLocaleSpecificMessage = getLocaleSpecificMessage;
	    function createFileDiagnostic(file, start, length, message) {
	        Debug.assertGreaterThanOrEqual(start, 0);
	        Debug.assertGreaterThanOrEqual(length, 0);
	        if (file) {
	            Debug.assertLessThanOrEqual(start, file.text.length);
	            Debug.assertLessThanOrEqual(start + length, file.text.length);
	        }
	        var text = getLocaleSpecificMessage(message);
	        if (arguments.length > 4) {
	            text = formatStringFromArgs(text, arguments, 4);
	        }
	        return {
	            file: file,
	            start: start,
	            length: length,
	            messageText: text,
	            category: message.category,
	            code: message.code,
	        };
	    }
	    ts.createFileDiagnostic = createFileDiagnostic;
	    /* internal */
	    function formatMessage(_dummy, message) {
	        var text = getLocaleSpecificMessage(message);
	        if (arguments.length > 2) {
	            text = formatStringFromArgs(text, arguments, 2);
	        }
	        return text;
	    }
	    ts.formatMessage = formatMessage;
	    function createCompilerDiagnostic(message) {
	        var text = getLocaleSpecificMessage(message);
	        if (arguments.length > 1) {
	            text = formatStringFromArgs(text, arguments, 1);
	        }
	        return {
	            file: undefined,
	            start: undefined,
	            length: undefined,
	            messageText: text,
	            category: message.category,
	            code: message.code
	        };
	    }
	    ts.createCompilerDiagnostic = createCompilerDiagnostic;
	    function createCompilerDiagnosticFromMessageChain(chain) {
	        return {
	            file: undefined,
	            start: undefined,
	            length: undefined,
	            code: chain.code,
	            category: chain.category,
	            messageText: chain.next ? chain : chain.messageText
	        };
	    }
	    ts.createCompilerDiagnosticFromMessageChain = createCompilerDiagnosticFromMessageChain;
	    function chainDiagnosticMessages(details, message) {
	        var text = getLocaleSpecificMessage(message);
	        if (arguments.length > 2) {
	            text = formatStringFromArgs(text, arguments, 2);
	        }
	        return {
	            messageText: text,
	            category: message.category,
	            code: message.code,
	            next: details
	        };
	    }
	    ts.chainDiagnosticMessages = chainDiagnosticMessages;
	    function concatenateDiagnosticMessageChains(headChain, tailChain) {
	        var lastChain = headChain;
	        while (lastChain.next) {
	            lastChain = lastChain.next;
	        }
	        lastChain.next = tailChain;
	        return headChain;
	    }
	    ts.concatenateDiagnosticMessageChains = concatenateDiagnosticMessageChains;
	    function equateValues(a, b) {
	        return a === b;
	    }
	    ts.equateValues = equateValues;
	    /**
	     * Compare the equality of two strings using a case-sensitive ordinal comparison.
	     *
	     * Case-sensitive comparisons compare both strings one code-point at a time using the integer
	     * value of each code-point after applying `toUpperCase` to each string. We always map both
	     * strings to their upper-case form as some unicode characters do not properly round-trip to
	     * lowercase (such as `ẞ` (German sharp capital s)).
	     */
	    function equateStringsCaseInsensitive(a, b) {
	        return a === b
	            || a !== undefined
	                && b !== undefined
	                && a.toUpperCase() === b.toUpperCase();
	    }
	    ts.equateStringsCaseInsensitive = equateStringsCaseInsensitive;
	    /**
	     * Compare the equality of two strings using a case-sensitive ordinal comparison.
	     *
	     * Case-sensitive comparisons compare both strings one code-point at a time using the
	     * integer value of each code-point.
	     */
	    function equateStringsCaseSensitive(a, b) {
	        return equateValues(a, b);
	    }
	    ts.equateStringsCaseSensitive = equateStringsCaseSensitive;
	    function compareComparableValues(a, b) {
	        return a === b ? 0 /* EqualTo */ :
	            a === undefined ? -1 /* LessThan */ :
	                b === undefined ? 1 /* GreaterThan */ :
	                    a < b ? -1 /* LessThan */ :
	                        1 /* GreaterThan */;
	    }
	    /**
	     * Compare two numeric values for their order relative to each other.
	     * To compare strings, use any of the `compareStrings` functions.
	     */
	    function compareValues(a, b) {
	        return compareComparableValues(a, b);
	    }
	    ts.compareValues = compareValues;
	    /**
	     * Compare two strings using a case-insensitive ordinal comparison.
	     *
	     * Ordinal comparisons are based on the difference between the unicode code points of both
	     * strings. Characters with multiple unicode representations are considered unequal. Ordinal
	     * comparisons provide predictable ordering, but place "a" after "B".
	     *
	     * Case-insensitive comparisons compare both strings one code-point at a time using the integer
	     * value of each code-point after applying `toUpperCase` to each string. We always map both
	     * strings to their upper-case form as some unicode characters do not properly round-trip to
	     * lowercase (such as `ẞ` (German sharp capital s)).
	     */
	    function compareStringsCaseInsensitive(a, b) {
	        if (a === b)
	            return 0 /* EqualTo */;
	        if (a === undefined)
	            return -1 /* LessThan */;
	        if (b === undefined)
	            return 1 /* GreaterThan */;
	        a = a.toUpperCase();
	        b = b.toUpperCase();
	        return a < b ? -1 /* LessThan */ : a > b ? 1 /* GreaterThan */ : 0 /* EqualTo */;
	    }
	    ts.compareStringsCaseInsensitive = compareStringsCaseInsensitive;
	    /**
	     * Compare two strings using a case-sensitive ordinal comparison.
	     *
	     * Ordinal comparisons are based on the difference between the unicode code points of both
	     * strings. Characters with multiple unicode representations are considered unequal. Ordinal
	     * comparisons provide predictable ordering, but place "a" after "B".
	     *
	     * Case-sensitive comparisons compare both strings one code-point at a time using the integer
	     * value of each code-point.
	     */
	    function compareStringsCaseSensitive(a, b) {
	        return compareComparableValues(a, b);
	    }
	    ts.compareStringsCaseSensitive = compareStringsCaseSensitive;
	    /**
	     * Creates a string comparer for use with string collation in the UI.
	     */
	    var createUIStringComparer = (function () {
	        var defaultComparer;
	        var enUSComparer;
	        var stringComparerFactory = getStringComparerFactory();
	        return createStringComparer;
	        function compareWithCallback(a, b, comparer) {
	            if (a === b)
	                return 0 /* EqualTo */;
	            if (a === undefined)
	                return -1 /* LessThan */;
	            if (b === undefined)
	                return 1 /* GreaterThan */;
	            var value = comparer(a, b);
	            return value < 0 ? -1 /* LessThan */ : value > 0 ? 1 /* GreaterThan */ : 0 /* EqualTo */;
	        }
	        function createIntlCollatorStringComparer(locale) {
	            // Intl.Collator.prototype.compare is bound to the collator. See NOTE in
	            // http://www.ecma-international.org/ecma-402/2.0/#sec-Intl.Collator.prototype.compare
	            var comparer = new Intl.Collator(locale, { usage: "sort", sensitivity: "variant" }).compare;
	            return function (a, b) { return compareWithCallback(a, b, comparer); };
	        }
	        function createLocaleCompareStringComparer(locale) {
	            // if the locale is not the default locale (`undefined`), use the fallback comparer.
	            if (locale !== undefined)
	                return createFallbackStringComparer();
	            return function (a, b) { return compareWithCallback(a, b, compareStrings); };
	            function compareStrings(a, b) {
	                return a.localeCompare(b);
	            }
	        }
	        function createFallbackStringComparer() {
	            // An ordinal comparison puts "A" after "b", but for the UI we want "A" before "b".
	            // We first sort case insensitively.  So "Aaa" will come before "baa".
	            // Then we sort case sensitively, so "aaa" will come before "Aaa".
	            //
	            // For case insensitive comparisons we always map both strings to their
	            // upper-case form as some unicode characters do not properly round-trip to
	            // lowercase (such as `ẞ` (German sharp capital s)).
	            return function (a, b) { return compareWithCallback(a, b, compareDictionaryOrder); };
	            function compareDictionaryOrder(a, b) {
	                return compareStrings(a.toUpperCase(), b.toUpperCase()) || compareStrings(a, b);
	            }
	            function compareStrings(a, b) {
	                return a < b ? -1 /* LessThan */ : a > b ? 1 /* GreaterThan */ : 0 /* EqualTo */;
	            }
	        }
	        function getStringComparerFactory() {
	            // If the host supports Intl, we use it for comparisons using the default locale.
	            if (typeof Intl === "object" && typeof Intl.Collator === "function") {
	                return createIntlCollatorStringComparer;
	            }
	            // If the host does not support Intl, we fall back to localeCompare.
	            // localeCompare in Node v0.10 is just an ordinal comparison, so don't use it.
	            if (typeof String.prototype.localeCompare === "function" &&
	                typeof String.prototype.toLocaleUpperCase === "function" &&
	                "a".localeCompare("B") < 0) {
	                return createLocaleCompareStringComparer;
	            }
	            // Otherwise, fall back to ordinal comparison:
	            return createFallbackStringComparer;
	        }
	        function createStringComparer(locale) {
	            // Hold onto common string comparers. This avoids constantly reallocating comparers during
	            // tests.
	            if (locale === undefined) {
	                return defaultComparer || (defaultComparer = stringComparerFactory(locale));
	            }
	            else if (locale === "en-US") {
	                return enUSComparer || (enUSComparer = stringComparerFactory(locale));
	            }
	            else {
	                return stringComparerFactory(locale);
	            }
	        }
	    })();
	    var uiComparerCaseSensitive;
	    var uiLocale;
	    function getUILocale() {
	        return uiLocale;
	    }
	    ts.getUILocale = getUILocale;
	    function setUILocale(value) {
	        if (uiLocale !== value) {
	            uiLocale = value;
	            uiComparerCaseSensitive = undefined;
	        }
	    }
	    ts.setUILocale = setUILocale;
	    /**
	     * Compare two strings in a using the case-sensitive sort behavior of the UI locale.
	     *
	     * Ordering is not predictable between different host locales, but is best for displaying
	     * ordered data for UI presentation. Characters with multiple unicode representations may
	     * be considered equal.
	     *
	     * Case-sensitive comparisons compare strings that differ in base characters, or
	     * accents/diacritic marks, or case as unequal.
	     */
	    function compareStringsCaseSensitiveUI(a, b) {
	        var comparer = uiComparerCaseSensitive || (uiComparerCaseSensitive = createUIStringComparer(uiLocale));
	        return comparer(a, b);
	    }
	    ts.compareStringsCaseSensitiveUI = compareStringsCaseSensitiveUI;
	    function compareProperties(a, b, key, comparer) {
	        return a === b ? 0 /* EqualTo */ :
	            a === undefined ? -1 /* LessThan */ :
	                b === undefined ? 1 /* GreaterThan */ :
	                    comparer(a[key], b[key]);
	    }
	    ts.compareProperties = compareProperties;
	    function getDiagnosticFileName(diagnostic) {
	        return diagnostic.file ? diagnostic.file.fileName : undefined;
	    }
	    function compareDiagnostics(d1, d2) {
	        return compareStringsCaseSensitive(getDiagnosticFileName(d1), getDiagnosticFileName(d2)) ||
	            compareValues(d1.start, d2.start) ||
	            compareValues(d1.length, d2.length) ||
	            compareValues(d1.code, d2.code) ||
	            compareMessageText(d1.messageText, d2.messageText) ||
	            0 /* EqualTo */;
	    }
	    ts.compareDiagnostics = compareDiagnostics;
	    /** True is greater than false. */
	    function compareBooleans(a, b) {
	        return compareValues(a ? 1 : 0, b ? 1 : 0);
	    }
	    ts.compareBooleans = compareBooleans;
	    function compareMessageText(text1, text2) {
	        while (text1 && text2) {
	            // We still have both chains.
	            var string1 = isString(text1) ? text1 : text1.messageText;
	            var string2 = isString(text2) ? text2 : text2.messageText;
	            var res = compareStringsCaseSensitive(string1, string2);
	            if (res) {
	                return res;
	            }
	            text1 = isString(text1) ? undefined : text1.next;
	            text2 = isString(text2) ? undefined : text2.next;
	        }
	        if (!text1 && !text2) {
	            // if the chains are done, then these messages are the same.
	            return 0 /* EqualTo */;
	        }
	        // We still have one chain remaining.  The shorter chain should come first.
	        return text1 ? 1 /* GreaterThan */ : -1 /* LessThan */;
	    }
	    function normalizeSlashes(path) {
	        return path.replace(/\\/g, "/");
	    }
	    ts.normalizeSlashes = normalizeSlashes;
	    /**
	     * Returns length of path root (i.e. length of "/", "x:/", "//server/share/, file:///user/files")
	     */
	    function getRootLength(path) {
	        if (path.charCodeAt(0) === 47 /* slash */) {
	            if (path.charCodeAt(1) !== 47 /* slash */)
	                return 1;
	            var p1 = path.indexOf("/", 2);
	            if (p1 < 0)
	                return 2;
	            var p2 = path.indexOf("/", p1 + 1);
	            if (p2 < 0)
	                return p1 + 1;
	            return p2 + 1;
	        }
	        if (path.charCodeAt(1) === 58 /* colon */) {
	            if (path.charCodeAt(2) === 47 /* slash */ || path.charCodeAt(2) === 92 /* backslash */)
	                return 3;
	        }
	        // Per RFC 1738 'file' URI schema has the shape file://<host>/<path>
	        // if <host> is omitted then it is assumed that host value is 'localhost',
	        // however slash after the omitted <host> is not removed.
	        // file:///folder1/file1 - this is a correct URI
	        // file://folder2/file2 - this is an incorrect URI
	        if (path.lastIndexOf("file:///", 0) === 0) {
	            return "file:///".length;
	        }
	        var idx = path.indexOf("://");
	        if (idx !== -1) {
	            return idx + "://".length;
	        }
	        return 0;
	    }
	    ts.getRootLength = getRootLength;
	    /**
	     * Internally, we represent paths as strings with '/' as the directory separator.
	     * When we make system calls (eg: LanguageServiceHost.getDirectory()),
	     * we expect the host to correctly handle paths in our specified format.
	     */
	    ts.directorySeparator = "/";
	    var directorySeparatorCharCode = 47 /* slash */;
	    function getNormalizedParts(normalizedSlashedPath, rootLength) {
	        var parts = normalizedSlashedPath.substr(rootLength).split(ts.directorySeparator);
	        var normalized = [];
	        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
	            var part = parts_1[_i];
	            if (part !== ".") {
	                if (part === ".." && normalized.length > 0 && lastOrUndefined(normalized) !== "..") {
	                    normalized.pop();
	                }
	                else {
	                    // A part may be an empty string (which is 'falsy') if the path had consecutive slashes,
	                    // e.g. "path//file.ts".  Drop these before re-joining the parts.
	                    if (part) {
	                        normalized.push(part);
	                    }
	                }
	            }
	        }
	        return normalized;
	    }
	    function normalizePath(path) {
	        return normalizePathAndParts(path).path;
	    }
	    ts.normalizePath = normalizePath;
	    function normalizePathAndParts(path) {
	        path = normalizeSlashes(path);
	        var rootLength = getRootLength(path);
	        var root = path.substr(0, rootLength);
	        var parts = getNormalizedParts(path, rootLength);
	        if (parts.length) {
	            var joinedParts = root + parts.join(ts.directorySeparator);
	            return { path: pathEndsWithDirectorySeparator(path) ? joinedParts + ts.directorySeparator : joinedParts, parts: parts };
	        }
	        else {
	            return { path: root, parts: parts };
	        }
	    }
	    ts.normalizePathAndParts = normalizePathAndParts;
	    /** A path ending with '/' refers to a directory only, never a file. */
	    function pathEndsWithDirectorySeparator(path) {
	        return path.charCodeAt(path.length - 1) === directorySeparatorCharCode;
	    }
	    ts.pathEndsWithDirectorySeparator = pathEndsWithDirectorySeparator;
	    function getDirectoryPath(path) {
	        return path.substr(0, Math.max(getRootLength(path), path.lastIndexOf(ts.directorySeparator)));
	    }
	    ts.getDirectoryPath = getDirectoryPath;
	    function isUrl(path) {
	        return path && !isRootedDiskPath(path) && stringContains(path, "://");
	    }
	    ts.isUrl = isUrl;
	    function pathIsRelative(path) {
	        return /^\.\.?($|[\\/])/.test(path);
	    }
	    ts.pathIsRelative = pathIsRelative;
	    function getEmitScriptTarget(compilerOptions) {
	        return compilerOptions.target || 0 /* ES3 */;
	    }
	    ts.getEmitScriptTarget = getEmitScriptTarget;
	    function getEmitModuleKind(compilerOptions) {
	        return typeof compilerOptions.module === "number" ?
	            compilerOptions.module :
	            getEmitScriptTarget(compilerOptions) >= 2 /* ES2015 */ ? ts.ModuleKind.ES2015 : ts.ModuleKind.CommonJS;
	    }
	    ts.getEmitModuleKind = getEmitModuleKind;
	    function getEmitModuleResolutionKind(compilerOptions) {
	        var moduleResolution = compilerOptions.moduleResolution;
	        if (moduleResolution === undefined) {
	            moduleResolution = getEmitModuleKind(compilerOptions) === ts.ModuleKind.CommonJS ? ts.ModuleResolutionKind.NodeJs : ts.ModuleResolutionKind.Classic;
	        }
	        return moduleResolution;
	    }
	    ts.getEmitModuleResolutionKind = getEmitModuleResolutionKind;
	    function getAllowSyntheticDefaultImports(compilerOptions) {
	        var moduleKind = getEmitModuleKind(compilerOptions);
	        return compilerOptions.allowSyntheticDefaultImports !== undefined
	            ? compilerOptions.allowSyntheticDefaultImports
	            : compilerOptions.esModuleInterop
	                ? moduleKind !== ts.ModuleKind.None && moduleKind < ts.ModuleKind.ES2015
	                : moduleKind === ts.ModuleKind.System;
	    }
	    ts.getAllowSyntheticDefaultImports = getAllowSyntheticDefaultImports;
	    function getStrictOptionValue(compilerOptions, flag) {
	        return compilerOptions[flag] === undefined ? compilerOptions.strict : compilerOptions[flag];
	    }
	    ts.getStrictOptionValue = getStrictOptionValue;
	    function hasZeroOrOneAsteriskCharacter(str) {
	        var seenAsterisk = false;
	        for (var i = 0; i < str.length; i++) {
	            if (str.charCodeAt(i) === 42 /* asterisk */) {
	                if (!seenAsterisk) {
	                    seenAsterisk = true;
	                }
	                else {
	                    // have already seen asterisk
	                    return false;
	                }
	            }
	        }
	        return true;
	    }
	    ts.hasZeroOrOneAsteriskCharacter = hasZeroOrOneAsteriskCharacter;
	    function isRootedDiskPath(path) {
	        return path && getRootLength(path) !== 0;
	    }
	    ts.isRootedDiskPath = isRootedDiskPath;
	    function convertToRelativePath(absoluteOrRelativePath, basePath, getCanonicalFileName) {
	        return !isRootedDiskPath(absoluteOrRelativePath)
	            ? absoluteOrRelativePath
	            : getRelativePathToDirectoryOrUrl(basePath, absoluteOrRelativePath, basePath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
	    }
	    ts.convertToRelativePath = convertToRelativePath;
	    function normalizedPathComponents(path, rootLength) {
	        var normalizedParts = getNormalizedParts(path, rootLength);
	        return [path.substr(0, rootLength)].concat(normalizedParts);
	    }
	    function getNormalizedPathComponents(path, currentDirectory) {
	        path = normalizeSlashes(path);
	        var rootLength = getRootLength(path);
	        if (rootLength === 0) {
	            // If the path is not rooted it is relative to current directory
	            path = combinePaths(normalizeSlashes(currentDirectory), path);
	            rootLength = getRootLength(path);
	        }
	        return normalizedPathComponents(path, rootLength);
	    }
	    ts.getNormalizedPathComponents = getNormalizedPathComponents;
	    function getNormalizedAbsolutePath(fileName, currentDirectory) {
	        return getNormalizedPathFromPathComponents(getNormalizedPathComponents(fileName, currentDirectory));
	    }
	    ts.getNormalizedAbsolutePath = getNormalizedAbsolutePath;
	    function getNormalizedPathFromPathComponents(pathComponents) {
	        if (pathComponents && pathComponents.length) {
	            return pathComponents[0] + pathComponents.slice(1).join(ts.directorySeparator);
	        }
	    }
	    ts.getNormalizedPathFromPathComponents = getNormalizedPathFromPathComponents;
	    function getNormalizedPathComponentsOfUrl(url) {
	        // Get root length of http://www.website.com/folder1/folder2/
	        // In this example the root is: http://www.website.com/
	        // normalized path components should be ["http://www.website.com/", "folder1", "folder2"]
	        var urlLength = url.length;
	        // Initial root length is http:// part
	        var rootLength = url.indexOf("://") + "://".length;
	        while (rootLength < urlLength) {
	            // Consume all immediate slashes in the protocol
	            // eg.initial rootlength is just file:// but it needs to consume another "/" in file:///
	            if (url.charCodeAt(rootLength) === 47 /* slash */) {
	                rootLength++;
	            }
	            else {
	                // non slash character means we continue proceeding to next component of root search
	                break;
	            }
	        }
	        // there are no parts after http:// just return current string as the pathComponent
	        if (rootLength === urlLength) {
	            return [url];
	        }
	        // Find the index of "/" after website.com so the root can be http://www.website.com/ (from existing http://)
	        var indexOfNextSlash = url.indexOf(ts.directorySeparator, rootLength);
	        if (indexOfNextSlash !== -1) {
	            // Found the "/" after the website.com so the root is length of http://www.website.com/
	            // and get components after the root normally like any other folder components
	            rootLength = indexOfNextSlash + 1;
	            return normalizedPathComponents(url, rootLength);
	        }
	        else {
	            // Can't find the host assume the rest of the string as component
	            // but make sure we append "/" to it as root is not joined using "/"
	            // eg. if url passed in was http://website.com we want to use root as [http://website.com/]
	            // so that other path manipulations will be correct and it can be merged with relative paths correctly
	            return [url + ts.directorySeparator];
	        }
	    }
	    function getNormalizedPathOrUrlComponents(pathOrUrl, currentDirectory) {
	        if (isUrl(pathOrUrl)) {
	            return getNormalizedPathComponentsOfUrl(pathOrUrl);
	        }
	        else {
	            return getNormalizedPathComponents(pathOrUrl, currentDirectory);
	        }
	    }
	    function getRelativePathToDirectoryOrUrl(directoryPathOrUrl, relativeOrAbsolutePath, currentDirectory, getCanonicalFileName, isAbsolutePathAnUrl) {
	        var pathComponents = getNormalizedPathOrUrlComponents(relativeOrAbsolutePath, currentDirectory);
	        var directoryComponents = getNormalizedPathOrUrlComponents(directoryPathOrUrl, currentDirectory);
	        if (directoryComponents.length > 1 && lastOrUndefined(directoryComponents) === "") {
	            // If the directory path given was of type test/cases/ then we really need components of directory to be only till its name
	            // that is ["test", "cases", ""] needs to be actually ["test", "cases"]
	            directoryComponents.pop();
	        }
	        // Find the component that differs
	        var joinStartIndex;
	        for (joinStartIndex = 0; joinStartIndex < pathComponents.length && joinStartIndex < directoryComponents.length; joinStartIndex++) {
	            if (getCanonicalFileName(directoryComponents[joinStartIndex]) !== getCanonicalFileName(pathComponents[joinStartIndex])) {
	                break;
	            }
	        }
	        // Get the relative path
	        if (joinStartIndex) {
	            var relativePath = "";
	            var relativePathComponents = pathComponents.slice(joinStartIndex, pathComponents.length);
	            for (; joinStartIndex < directoryComponents.length; joinStartIndex++) {
	                if (directoryComponents[joinStartIndex] !== "") {
	                    relativePath = relativePath + ".." + ts.directorySeparator;
	                }
	            }
	            return relativePath + relativePathComponents.join(ts.directorySeparator);
	        }
	        // Cant find the relative path, get the absolute path
	        var absolutePath = getNormalizedPathFromPathComponents(pathComponents);
	        if (isAbsolutePathAnUrl && isRootedDiskPath(absolutePath)) {
	            absolutePath = "file:///" + absolutePath;
	        }
	        return absolutePath;
	    }
	    ts.getRelativePathToDirectoryOrUrl = getRelativePathToDirectoryOrUrl;
	    function getBaseFileName(path) {
	        if (path === undefined) {
	            return undefined;
	        }
	        var i = path.lastIndexOf(ts.directorySeparator);
	        return i < 0 ? path : path.substring(i + 1);
	    }
	    ts.getBaseFileName = getBaseFileName;
	    function combinePaths(path1, path2) {
	        if (!(path1 && path1.length))
	            return path2;
	        if (!(path2 && path2.length))
	            return path1;
	        if (getRootLength(path2) !== 0)
	            return path2;
	        if (path1.charAt(path1.length - 1) === ts.directorySeparator)
	            return path1 + path2;
	        return path1 + ts.directorySeparator + path2;
	    }
	    ts.combinePaths = combinePaths;
	    function removeTrailingDirectorySeparator(path) {
	        if (path.charAt(path.length - 1) === ts.directorySeparator) {
	            return path.substr(0, path.length - 1);
	        }
	        return path;
	    }
	    ts.removeTrailingDirectorySeparator = removeTrailingDirectorySeparator;
	    /**
	     * Adds a trailing directory separator to a path, if it does not already have one.
	     * @param path The path.
	     */
	    function ensureTrailingDirectorySeparator(path) {
	        if (path.charAt(path.length - 1) !== ts.directorySeparator) {
	            return path + ts.directorySeparator;
	        }
	        return path;
	    }
	    ts.ensureTrailingDirectorySeparator = ensureTrailingDirectorySeparator;
	    function comparePaths(a, b, currentDirectory, ignoreCase) {
	        if (a === b)
	            return 0 /* EqualTo */;
	        if (a === undefined)
	            return -1 /* LessThan */;
	        if (b === undefined)
	            return 1 /* GreaterThan */;
	        a = removeTrailingDirectorySeparator(a);
	        b = removeTrailingDirectorySeparator(b);
	        var aComponents = getNormalizedPathComponents(a, currentDirectory);
	        var bComponents = getNormalizedPathComponents(b, currentDirectory);
	        var sharedLength = Math.min(aComponents.length, bComponents.length);
	        var comparer = ignoreCase ? compareStringsCaseInsensitive : compareStringsCaseSensitive;
	        for (var i = 0; i < sharedLength; i++) {
	            var result = comparer(aComponents[i], bComponents[i]);
	            if (result !== 0 /* EqualTo */) {
	                return result;
	            }
	        }
	        return compareValues(aComponents.length, bComponents.length);
	    }
	    ts.comparePaths = comparePaths;
	    function containsPath(parent, child, currentDirectory, ignoreCase) {
	        if (parent === undefined || child === undefined)
	            return false;
	        if (parent === child)
	            return true;
	        parent = removeTrailingDirectorySeparator(parent);
	        child = removeTrailingDirectorySeparator(child);
	        if (parent === child)
	            return true;
	        var parentComponents = getNormalizedPathComponents(parent, currentDirectory);
	        var childComponents = getNormalizedPathComponents(child, currentDirectory);
	        if (childComponents.length < parentComponents.length) {
	            return false;
	        }
	        var equalityComparer = ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive;
	        for (var i = 0; i < parentComponents.length; i++) {
	            if (!equalityComparer(parentComponents[i], childComponents[i])) {
	                return false;
	            }
	        }
	        return true;
	    }
	    ts.containsPath = containsPath;
	    function startsWith(str, prefix) {
	        return str.lastIndexOf(prefix, 0) === 0;
	    }
	    ts.startsWith = startsWith;
	    function removePrefix(str, prefix) {
	        return startsWith(str, prefix) ? str.substr(prefix.length) : str;
	    }
	    ts.removePrefix = removePrefix;
	    function endsWith(str, suffix) {
	        var expectedPos = str.length - suffix.length;
	        return expectedPos >= 0 && str.indexOf(suffix, expectedPos) === expectedPos;
	    }
	    ts.endsWith = endsWith;
	    function removeSuffix(str, suffix) {
	        return endsWith(str, suffix) ? str.slice(0, str.length - suffix.length) : str;
	    }
	    ts.removeSuffix = removeSuffix;
	    function stringContains(str, substring) {
	        return str.indexOf(substring) !== -1;
	    }
	    ts.stringContains = stringContains;
	    function hasExtension(fileName) {
	        return stringContains(getBaseFileName(fileName), ".");
	    }
	    ts.hasExtension = hasExtension;
	    function fileExtensionIs(path, extension) {
	        return path.length > extension.length && endsWith(path, extension);
	    }
	    ts.fileExtensionIs = fileExtensionIs;
	    function fileExtensionIsOneOf(path, extensions) {
	        for (var _i = 0, extensions_1 = extensions; _i < extensions_1.length; _i++) {
	            var extension = extensions_1[_i];
	            if (fileExtensionIs(path, extension)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.fileExtensionIsOneOf = fileExtensionIsOneOf;
	    // Reserved characters, forces escaping of any non-word (or digit), non-whitespace character.
	    // It may be inefficient (we could just match (/[-[\]{}()*+?.,\\^$|#\s]/g), but this is future
	    // proof.
	    var reservedCharacterPattern = /[^\w\s\/]/g;
	    var wildcardCharCodes = [42 /* asterisk */, 63 /* question */];
	    ts.commonPackageFolders = ["node_modules", "bower_components", "jspm_packages"];
	    var implicitExcludePathRegexPattern = "(?!(" + ts.commonPackageFolders.join("|") + ")(/|$))";
	    var filesMatcher = {
	        /**
	         * Matches any single directory segment unless it is the last segment and a .min.js file
	         * Breakdown:
	         *  [^./]                   # matches everything up to the first . character (excluding directory seperators)
	         *  (\\.(?!min\\.js$))?     # matches . characters but not if they are part of the .min.js file extension
	         */
	        singleAsteriskRegexFragment: "([^./]|(\\.(?!min\\.js$))?)*",
	        /**
	         * Regex for the ** wildcard. Matches any number of subdirectories. When used for including
	         * files or directories, does not match subdirectories that start with a . character
	         */
	        doubleAsteriskRegexFragment: "(/" + implicitExcludePathRegexPattern + "[^/.][^/]*)*?",
	        replaceWildcardCharacter: function (match) { return replaceWildcardCharacter(match, filesMatcher.singleAsteriskRegexFragment); }
	    };
	    var directoriesMatcher = {
	        singleAsteriskRegexFragment: "[^/]*",
	        /**
	         * Regex for the ** wildcard. Matches any number of subdirectories. When used for including
	         * files or directories, does not match subdirectories that start with a . character
	         */
	        doubleAsteriskRegexFragment: "(/" + implicitExcludePathRegexPattern + "[^/.][^/]*)*?",
	        replaceWildcardCharacter: function (match) { return replaceWildcardCharacter(match, directoriesMatcher.singleAsteriskRegexFragment); }
	    };
	    var excludeMatcher = {
	        singleAsteriskRegexFragment: "[^/]*",
	        doubleAsteriskRegexFragment: "(/.+?)?",
	        replaceWildcardCharacter: function (match) { return replaceWildcardCharacter(match, excludeMatcher.singleAsteriskRegexFragment); }
	    };
	    var wildcardMatchers = {
	        files: filesMatcher,
	        directories: directoriesMatcher,
	        exclude: excludeMatcher
	    };
	    function getRegularExpressionForWildcard(specs, basePath, usage) {
	        var patterns = getRegularExpressionsForWildcards(specs, basePath, usage);
	        if (!patterns || !patterns.length) {
	            return undefined;
	        }
	        var pattern = patterns.map(function (pattern) { return "(" + pattern + ")"; }).join("|");
	        // If excluding, match "foo/bar/baz...", but if including, only allow "foo".
	        var terminator = usage === "exclude" ? "($|/)" : "$";
	        return "^(" + pattern + ")" + terminator;
	    }
	    ts.getRegularExpressionForWildcard = getRegularExpressionForWildcard;
	    function getRegularExpressionsForWildcards(specs, basePath, usage) {
	        if (specs === undefined || specs.length === 0) {
	            return undefined;
	        }
	        return flatMap(specs, function (spec) {
	            return spec && getSubPatternFromSpec(spec, basePath, usage, wildcardMatchers[usage]);
	        });
	    }
	    /**
	     * An "includes" path "foo" is implicitly a glob "foo/** /*" (without the space) if its last component has no extension,
	     * and does not contain any glob characters itself.
	     */
	    function isImplicitGlob(lastPathComponent) {
	        return !/[.*?]/.test(lastPathComponent);
	    }
	    ts.isImplicitGlob = isImplicitGlob;
	    function getSubPatternFromSpec(spec, basePath, usage, _a) {
	        var singleAsteriskRegexFragment = _a.singleAsteriskRegexFragment, doubleAsteriskRegexFragment = _a.doubleAsteriskRegexFragment, replaceWildcardCharacter = _a.replaceWildcardCharacter;
	        var subpattern = "";
	        var hasWrittenComponent = false;
	        var components = getNormalizedPathComponents(spec, basePath);
	        var lastComponent = lastOrUndefined(components);
	        if (usage !== "exclude" && lastComponent === "**") {
	            return undefined;
	        }
	        // getNormalizedPathComponents includes the separator for the root component.
	        // We need to remove to create our regex correctly.
	        components[0] = removeTrailingDirectorySeparator(components[0]);
	        if (isImplicitGlob(lastComponent)) {
	            components.push("**", "*");
	        }
	        var optionalCount = 0;
	        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
	            var component = components_1[_i];
	            if (component === "**") {
	                subpattern += doubleAsteriskRegexFragment;
	            }
	            else {
	                if (usage === "directories") {
	                    subpattern += "(";
	                    optionalCount++;
	                }
	                if (hasWrittenComponent) {
	                    subpattern += ts.directorySeparator;
	                }
	                if (usage !== "exclude") {
	                    var componentPattern = "";
	                    // The * and ? wildcards should not match directories or files that start with . if they
	                    // appear first in a component. Dotted directories and files can be included explicitly
	                    // like so: **/.*/.*
	                    if (component.charCodeAt(0) === 42 /* asterisk */) {
	                        componentPattern += "([^./]" + singleAsteriskRegexFragment + ")?";
	                        component = component.substr(1);
	                    }
	                    else if (component.charCodeAt(0) === 63 /* question */) {
	                        componentPattern += "[^./]";
	                        component = component.substr(1);
	                    }
	                    componentPattern += component.replace(reservedCharacterPattern, replaceWildcardCharacter);
	                    // Patterns should not include subfolders like node_modules unless they are
	                    // explicitly included as part of the path.
	                    //
	                    // As an optimization, if the component pattern is the same as the component,
	                    // then there definitely were no wildcard characters and we do not need to
	                    // add the exclusion pattern.
	                    if (componentPattern !== component) {
	                        subpattern += implicitExcludePathRegexPattern;
	                    }
	                    subpattern += componentPattern;
	                }
	                else {
	                    subpattern += component.replace(reservedCharacterPattern, replaceWildcardCharacter);
	                }
	            }
	            hasWrittenComponent = true;
	        }
	        while (optionalCount > 0) {
	            subpattern += ")?";
	            optionalCount--;
	        }
	        return subpattern;
	    }
	    function replaceWildcardCharacter(match, singleAsteriskRegexFragment) {
	        return match === "*" ? singleAsteriskRegexFragment : match === "?" ? "[^/]" : "\\" + match;
	    }
	    function getFileMatcherPatterns(path, excludes, includes, useCaseSensitiveFileNames, currentDirectory) {
	        path = normalizePath(path);
	        currentDirectory = normalizePath(currentDirectory);
	        var absolutePath = combinePaths(currentDirectory, path);
	        return {
	            includeFilePatterns: map(getRegularExpressionsForWildcards(includes, absolutePath, "files"), function (pattern) { return "^" + pattern + "$"; }),
	            includeFilePattern: getRegularExpressionForWildcard(includes, absolutePath, "files"),
	            includeDirectoryPattern: getRegularExpressionForWildcard(includes, absolutePath, "directories"),
	            excludePattern: getRegularExpressionForWildcard(excludes, absolutePath, "exclude"),
	            basePaths: getBasePaths(path, includes, useCaseSensitiveFileNames)
	        };
	    }
	    ts.getFileMatcherPatterns = getFileMatcherPatterns;
	    function matchFiles(path, extensions, excludes, includes, useCaseSensitiveFileNames, currentDirectory, depth, getFileSystemEntries) {
	        path = normalizePath(path);
	        currentDirectory = normalizePath(currentDirectory);
	        var comparer = useCaseSensitiveFileNames ? compareStringsCaseSensitive : compareStringsCaseInsensitive;
	        var patterns = getFileMatcherPatterns(path, excludes, includes, useCaseSensitiveFileNames, currentDirectory);
	        var regexFlag = useCaseSensitiveFileNames ? "" : "i";
	        var includeFileRegexes = patterns.includeFilePatterns && patterns.includeFilePatterns.map(function (pattern) { return new RegExp(pattern, regexFlag); });
	        var includeDirectoryRegex = patterns.includeDirectoryPattern && new RegExp(patterns.includeDirectoryPattern, regexFlag);
	        var excludeRegex = patterns.excludePattern && new RegExp(patterns.excludePattern, regexFlag);
	        // Associate an array of results with each include regex. This keeps results in order of the "include" order.
	        // If there are no "includes", then just put everything in results[0].
	        var results = includeFileRegexes ? includeFileRegexes.map(function () { return []; }) : [[]];
	        for (var _i = 0, _a = patterns.basePaths; _i < _a.length; _i++) {
	            var basePath = _a[_i];
	            visitDirectory(basePath, combinePaths(currentDirectory, basePath), depth);
	        }
	        return flatten(results);
	        function visitDirectory(path, absolutePath, depth) {
	            var _a = getFileSystemEntries(path), files = _a.files, directories = _a.directories;
	            var _loop_1 = function (current) {
	                var name = combinePaths(path, current);
	                var absoluteName = combinePaths(absolutePath, current);
	                if (extensions && !fileExtensionIsOneOf(name, extensions))
	                    return "continue";
	                if (excludeRegex && excludeRegex.test(absoluteName))
	                    return "continue";
	                if (!includeFileRegexes) {
	                    results[0].push(name);
	                }
	                else {
	                    var includeIndex = findIndex(includeFileRegexes, function (re) { return re.test(absoluteName); });
	                    if (includeIndex !== -1) {
	                        results[includeIndex].push(name);
	                    }
	                }
	            };
	            for (var _i = 0, _b = sort(files, comparer); _i < _b.length; _i++) {
	                var current = _b[_i];
	                _loop_1(current);
	            }
	            if (depth !== undefined) {
	                depth--;
	                if (depth === 0) {
	                    return;
	                }
	            }
	            for (var _c = 0, _d = sort(directories, comparer); _c < _d.length; _c++) {
	                var current = _d[_c];
	                var name = combinePaths(path, current);
	                var absoluteName = combinePaths(absolutePath, current);
	                if ((!includeDirectoryRegex || includeDirectoryRegex.test(absoluteName)) &&
	                    (!excludeRegex || !excludeRegex.test(absoluteName))) {
	                    visitDirectory(name, absoluteName, depth);
	                }
	            }
	        }
	    }
	    ts.matchFiles = matchFiles;
	    /**
	     * Computes the unique non-wildcard base paths amongst the provided include patterns.
	     */
	    function getBasePaths(path, includes, useCaseSensitiveFileNames) {
	        // Storage for our results in the form of literal paths (e.g. the paths as written by the user).
	        var basePaths = [path];
	        if (includes) {
	            // Storage for literal base paths amongst the include patterns.
	            var includeBasePaths = [];
	            for (var _i = 0, includes_1 = includes; _i < includes_1.length; _i++) {
	                var include = includes_1[_i];
	                // We also need to check the relative paths by converting them to absolute and normalizing
	                // in case they escape the base path (e.g "..\somedirectory")
	                var absolute = isRootedDiskPath(include) ? include : normalizePath(combinePaths(path, include));
	                // Append the literal and canonical candidate base paths.
	                includeBasePaths.push(getIncludeBasePath(absolute));
	            }
	            // Sort the offsets array using either the literal or canonical path representations.
	            includeBasePaths.sort(useCaseSensitiveFileNames ? compareStringsCaseSensitive : compareStringsCaseInsensitive);
	            var _loop_2 = function (includeBasePath) {
	                if (ts.every(basePaths, function (basePath) { return !containsPath(basePath, includeBasePath, path, !useCaseSensitiveFileNames); })) {
	                    basePaths.push(includeBasePath);
	                }
	            };
	            // Iterate over each include base path and include unique base paths that are not a
	            // subpath of an existing base path
	            for (var _a = 0, includeBasePaths_1 = includeBasePaths; _a < includeBasePaths_1.length; _a++) {
	                var includeBasePath = includeBasePaths_1[_a];
	                _loop_2(includeBasePath);
	            }
	        }
	        return basePaths;
	    }
	    function getIncludeBasePath(absolute) {
	        var wildcardOffset = indexOfAnyCharCode(absolute, wildcardCharCodes);
	        if (wildcardOffset < 0) {
	            // No "*" or "?" in the path
	            return !hasExtension(absolute)
	                ? absolute
	                : removeTrailingDirectorySeparator(getDirectoryPath(absolute));
	        }
	        return absolute.substring(0, absolute.lastIndexOf(ts.directorySeparator, wildcardOffset));
	    }
	    function ensureScriptKind(fileName, scriptKind) {
	        // Using scriptKind as a condition handles both:
	        // - 'scriptKind' is unspecified and thus it is `undefined`
	        // - 'scriptKind' is set and it is `Unknown` (0)
	        // If the 'scriptKind' is 'undefined' or 'Unknown' then we attempt
	        // to get the ScriptKind from the file name. If it cannot be resolved
	        // from the file name then the default 'TS' script kind is returned.
	        return scriptKind || getScriptKindFromFileName(fileName) || 3 /* TS */;
	    }
	    ts.ensureScriptKind = ensureScriptKind;
	    function getScriptKindFromFileName(fileName) {
	        var ext = fileName.substr(fileName.lastIndexOf("."));
	        switch (ext.toLowerCase()) {
	            case ".js" /* Js */:
	                return 1 /* JS */;
	            case ".jsx" /* Jsx */:
	                return 2 /* JSX */;
	            case ".ts" /* Ts */:
	                return 3 /* TS */;
	            case ".tsx" /* Tsx */:
	                return 4 /* TSX */;
	            case ".json" /* Json */:
	                return 6 /* JSON */;
	            default:
	                return 0 /* Unknown */;
	        }
	    }
	    ts.getScriptKindFromFileName = getScriptKindFromFileName;
	    /**
	     *  List of supported extensions in order of file resolution precedence.
	     */
	    ts.supportedTypeScriptExtensions = [".ts" /* Ts */, ".tsx" /* Tsx */, ".d.ts" /* Dts */];
	    /** Must have ".d.ts" first because if ".ts" goes first, that will be detected as the extension instead of ".d.ts". */
	    ts.supportedTypescriptExtensionsForExtractExtension = [".d.ts" /* Dts */, ".ts" /* Ts */, ".tsx" /* Tsx */];
	    ts.supportedJavascriptExtensions = [".js" /* Js */, ".jsx" /* Jsx */];
	    var allSupportedExtensions = ts.supportedTypeScriptExtensions.concat(ts.supportedJavascriptExtensions);
	    function getSupportedExtensions(options, extraFileExtensions) {
	        var needAllExtensions = options && options.allowJs;
	        if (!extraFileExtensions || extraFileExtensions.length === 0 || !needAllExtensions) {
	            return needAllExtensions ? allSupportedExtensions : ts.supportedTypeScriptExtensions;
	        }
	        return deduplicate(allSupportedExtensions.concat(extraFileExtensions.map(function (e) { return e.extension; })), equateStringsCaseSensitive, compareStringsCaseSensitive);
	    }
	    ts.getSupportedExtensions = getSupportedExtensions;
	    function hasJavaScriptFileExtension(fileName) {
	        return forEach(ts.supportedJavascriptExtensions, function (extension) { return fileExtensionIs(fileName, extension); });
	    }
	    ts.hasJavaScriptFileExtension = hasJavaScriptFileExtension;
	    function hasTypeScriptFileExtension(fileName) {
	        return forEach(ts.supportedTypeScriptExtensions, function (extension) { return fileExtensionIs(fileName, extension); });
	    }
	    ts.hasTypeScriptFileExtension = hasTypeScriptFileExtension;
	    function isSupportedSourceFileName(fileName, compilerOptions, extraFileExtensions) {
	        if (!fileName) {
	            return false;
	        }
	        for (var _i = 0, _a = getSupportedExtensions(compilerOptions, extraFileExtensions); _i < _a.length; _i++) {
	            var extension = _a[_i];
	            if (fileExtensionIs(fileName, extension)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.isSupportedSourceFileName = isSupportedSourceFileName;
	    /**
	     * Extension boundaries by priority. Lower numbers indicate higher priorities, and are
	     * aligned to the offset of the highest priority extension in the
	     * allSupportedExtensions array.
	     */
	    var ExtensionPriority;
	    (function (ExtensionPriority) {
	        ExtensionPriority[ExtensionPriority["TypeScriptFiles"] = 0] = "TypeScriptFiles";
	        ExtensionPriority[ExtensionPriority["DeclarationAndJavaScriptFiles"] = 2] = "DeclarationAndJavaScriptFiles";
	        ExtensionPriority[ExtensionPriority["Highest"] = 0] = "Highest";
	        ExtensionPriority[ExtensionPriority["Lowest"] = 2] = "Lowest";
	    })(ExtensionPriority = ts.ExtensionPriority || (ts.ExtensionPriority = {}));
	    function getExtensionPriority(path, supportedExtensions) {
	        for (var i = supportedExtensions.length - 1; i >= 0; i--) {
	            if (fileExtensionIs(path, supportedExtensions[i])) {
	                return adjustExtensionPriority(i, supportedExtensions);
	            }
	        }
	        // If its not in the list of supported extensions, this is likely a
	        // TypeScript file with a non-ts extension
	        return 0 /* Highest */;
	    }
	    ts.getExtensionPriority = getExtensionPriority;
	    /**
	     * Adjusts an extension priority to be the highest priority within the same range.
	     */
	    function adjustExtensionPriority(extensionPriority, supportedExtensions) {
	        if (extensionPriority < 2 /* DeclarationAndJavaScriptFiles */) {
	            return 0 /* TypeScriptFiles */;
	        }
	        else if (extensionPriority < supportedExtensions.length) {
	            return 2 /* DeclarationAndJavaScriptFiles */;
	        }
	        else {
	            return supportedExtensions.length;
	        }
	    }
	    ts.adjustExtensionPriority = adjustExtensionPriority;
	    /**
	     * Gets the next lowest extension priority for a given priority.
	     */
	    function getNextLowestExtensionPriority(extensionPriority, supportedExtensions) {
	        if (extensionPriority < 2 /* DeclarationAndJavaScriptFiles */) {
	            return 2 /* DeclarationAndJavaScriptFiles */;
	        }
	        else {
	            return supportedExtensions.length;
	        }
	    }
	    ts.getNextLowestExtensionPriority = getNextLowestExtensionPriority;
	    var extensionsToRemove = [".d.ts" /* Dts */, ".ts" /* Ts */, ".js" /* Js */, ".tsx" /* Tsx */, ".jsx" /* Jsx */];
	    function removeFileExtension(path) {
	        for (var _i = 0, extensionsToRemove_1 = extensionsToRemove; _i < extensionsToRemove_1.length; _i++) {
	            var ext = extensionsToRemove_1[_i];
	            var extensionless = tryRemoveExtension(path, ext);
	            if (extensionless !== undefined) {
	                return extensionless;
	            }
	        }
	        return path;
	    }
	    ts.removeFileExtension = removeFileExtension;
	    function tryRemoveExtension(path, extension) {
	        return fileExtensionIs(path, extension) ? removeExtension(path, extension) : undefined;
	    }
	    ts.tryRemoveExtension = tryRemoveExtension;
	    function removeExtension(path, extension) {
	        return path.substring(0, path.length - extension.length);
	    }
	    ts.removeExtension = removeExtension;
	    function changeExtension(path, newExtension) {
	        return (removeFileExtension(path) + newExtension);
	    }
	    ts.changeExtension = changeExtension;
	    /**
	     * Takes a string like "jquery-min.4.2.3" and returns "jquery"
	     */
	    function removeMinAndVersionNumbers(fileName) {
	        // Match a "." or "-" followed by a version number or 'min' at the end of the name
	        var trailingMinOrVersion = /[.-]((min)|(\d+(\.\d+)*))$/;
	        // The "min" or version may both be present, in either order, so try applying the above twice.
	        return fileName.replace(trailingMinOrVersion, "").replace(trailingMinOrVersion, "");
	    }
	    ts.removeMinAndVersionNumbers = removeMinAndVersionNumbers;
	    function Symbol(flags, name) {
	        this.flags = flags;
	        this.escapedName = name;
	        this.declarations = undefined;
	        this.valueDeclaration = undefined;
	        this.id = undefined;
	        this.mergeId = undefined;
	        this.parent = undefined;
	    }
	    function Type(checker, flags) {
	        this.flags = flags;
	        if (Debug.isDebugging) {
	            this.checker = checker;
	        }
	    }
	    function Signature() { } // tslint:disable-line no-empty
	    function Node(kind, pos, end) {
	        this.pos = pos;
	        this.end = end;
	        this.kind = kind;
	        this.id = 0;
	        this.flags = 0 /* None */;
	        this.modifierFlagsCache = 0 /* None */;
	        this.transformFlags = 0 /* None */;
	        this.parent = undefined;
	        this.original = undefined;
	    }
	    function SourceMapSource(fileName, text, skipTrivia) {
	        this.fileName = fileName;
	        this.text = text;
	        this.skipTrivia = skipTrivia || (function (pos) { return pos; });
	    }
	    ts.objectAllocator = {
	        getNodeConstructor: function () { return Node; },
	        getTokenConstructor: function () { return Node; },
	        getIdentifierConstructor: function () { return Node; },
	        getSourceFileConstructor: function () { return Node; },
	        getSymbolConstructor: function () { return Symbol; },
	        getTypeConstructor: function () { return Type; },
	        getSignatureConstructor: function () { return Signature; },
	        getSourceMapSourceConstructor: function () { return SourceMapSource; },
	    };
	    var AssertionLevel;
	    (function (AssertionLevel) {
	        AssertionLevel[AssertionLevel["None"] = 0] = "None";
	        AssertionLevel[AssertionLevel["Normal"] = 1] = "Normal";
	        AssertionLevel[AssertionLevel["Aggressive"] = 2] = "Aggressive";
	        AssertionLevel[AssertionLevel["VeryAggressive"] = 3] = "VeryAggressive";
	    })(AssertionLevel = ts.AssertionLevel || (ts.AssertionLevel = {}));
	    var Debug;
	    (function (Debug) {
	        Debug.currentAssertionLevel = 0 /* None */;
	        Debug.isDebugging = false;
	        function shouldAssert(level) {
	            return Debug.currentAssertionLevel >= level;
	        }
	        Debug.shouldAssert = shouldAssert;
	        function assert(expression, message, verboseDebugInfo, stackCrawlMark) {
	            if (!expression) {
	                if (verboseDebugInfo) {
	                    message += "\r\nVerbose Debug Information: " + (typeof verboseDebugInfo === "string" ? verboseDebugInfo : verboseDebugInfo());
	                }
	                fail(message ? "False expression: " + message : "False expression.", stackCrawlMark || assert);
	            }
	        }
	        Debug.assert = assert;
	        function assertEqual(a, b, msg, msg2) {
	            if (a !== b) {
	                var message = msg ? msg2 ? msg + " " + msg2 : msg : "";
	                fail("Expected " + a + " === " + b + ". " + message);
	            }
	        }
	        Debug.assertEqual = assertEqual;
	        function assertLessThan(a, b, msg) {
	            if (a >= b) {
	                fail("Expected " + a + " < " + b + ". " + (msg || ""));
	            }
	        }
	        Debug.assertLessThan = assertLessThan;
	        function assertLessThanOrEqual(a, b) {
	            if (a > b) {
	                fail("Expected " + a + " <= " + b);
	            }
	        }
	        Debug.assertLessThanOrEqual = assertLessThanOrEqual;
	        function assertGreaterThanOrEqual(a, b) {
	            if (a < b) {
	                fail("Expected " + a + " >= " + b);
	            }
	        }
	        Debug.assertGreaterThanOrEqual = assertGreaterThanOrEqual;
	        function fail(message, stackCrawlMark) {
	            debugger;
	            var e = new Error(message ? "Debug Failure. " + message : "Debug Failure.");
	            if (Error.captureStackTrace) {
	                Error.captureStackTrace(e, stackCrawlMark || fail);
	            }
	            throw e;
	        }
	        Debug.fail = fail;
	        function assertDefined(value, message) {
	            assert(value !== undefined && value !== null, message);
	            return value;
	        }
	        Debug.assertDefined = assertDefined;
	        function assertEachDefined(value, message) {
	            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
	                var v = value_1[_i];
	                assertDefined(v, message);
	            }
	            return value;
	        }
	        Debug.assertEachDefined = assertEachDefined;
	        function assertNever(member, message, stackCrawlMark) {
	            return fail(message || "Illegal value: " + member, stackCrawlMark || assertNever);
	        }
	        Debug.assertNever = assertNever;
	        function getFunctionName(func) {
	            if (typeof func !== "function") {
	                return "";
	            }
	            else if (func.hasOwnProperty("name")) {
	                return func.name;
	            }
	            else {
	                var text = Function.prototype.toString.call(func);
	                var match = /^function\s+([\w\$]+)\s*\(/.exec(text);
	                return match ? match[1] : "";
	            }
	        }
	        Debug.getFunctionName = getFunctionName;
	        function showSymbol(symbol) {
	            var symbolFlags = ts.SymbolFlags;
	            return "{ flags: " + (symbolFlags ? showFlags(symbol.flags, symbolFlags) : symbol.flags) + "; declarations: " + map(symbol.declarations, showSyntaxKind) + " }";
	        }
	        Debug.showSymbol = showSymbol;
	        function showFlags(flags, flagsEnum) {
	            var out = [];
	            for (var pow = 0; pow <= 30; pow++) {
	                var n = 1 << pow;
	                if (flags & n) {
	                    out.push(flagsEnum[n]);
	                }
	            }
	            return out.join("|");
	        }
	        function showSyntaxKind(node) {
	            var syntaxKind = ts.SyntaxKind;
	            return syntaxKind ? syntaxKind[node.kind] : node.kind.toString();
	        }
	        Debug.showSyntaxKind = showSyntaxKind;
	    })(Debug = ts.Debug || (ts.Debug = {}));
	    /** Remove an item from an array, moving everything to its right one space left. */
	    function orderedRemoveItem(array, item) {
	        for (var i = 0; i < array.length; i++) {
	            if (array[i] === item) {
	                orderedRemoveItemAt(array, i);
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.orderedRemoveItem = orderedRemoveItem;
	    /** Remove an item by index from an array, moving everything to its right one space left. */
	    function orderedRemoveItemAt(array, index) {
	        // This seems to be faster than either `array.splice(i, 1)` or `array.copyWithin(i, i+ 1)`.
	        for (var i = index; i < array.length - 1; i++) {
	            array[i] = array[i + 1];
	        }
	        array.pop();
	    }
	    ts.orderedRemoveItemAt = orderedRemoveItemAt;
	    function unorderedRemoveItemAt(array, index) {
	        // Fill in the "hole" left at `index`.
	        array[index] = array[array.length - 1];
	        array.pop();
	    }
	    ts.unorderedRemoveItemAt = unorderedRemoveItemAt;
	    /** Remove the *first* occurrence of `item` from the array. */
	    function unorderedRemoveItem(array, item) {
	        unorderedRemoveFirstItemWhere(array, function (element) { return element === item; });
	    }
	    ts.unorderedRemoveItem = unorderedRemoveItem;
	    /** Remove the *first* element satisfying `predicate`. */
	    function unorderedRemoveFirstItemWhere(array, predicate) {
	        for (var i = 0; i < array.length; i++) {
	            if (predicate(array[i])) {
	                unorderedRemoveItemAt(array, i);
	                break;
	            }
	        }
	    }
	    function createGetCanonicalFileName(useCaseSensitiveFileNames) {
	        return useCaseSensitiveFileNames ? identity : toLowerCase;
	    }
	    ts.createGetCanonicalFileName = createGetCanonicalFileName;
	    /**
	     * patternStrings contains both pattern strings (containing "*") and regular strings.
	     * Return an exact match if possible, or a pattern match, or undefined.
	     * (These are verified by verifyCompilerOptions to have 0 or 1 "*" characters.)
	     */
	    function matchPatternOrExact(patternStrings, candidate) {
	        var patterns = [];
	        for (var _i = 0, patternStrings_1 = patternStrings; _i < patternStrings_1.length; _i++) {
	            var patternString = patternStrings_1[_i];
	            var pattern = tryParsePattern(patternString);
	            if (pattern) {
	                patterns.push(pattern);
	            }
	            else if (patternString === candidate) {
	                // pattern was matched as is - no need to search further
	                return patternString;
	            }
	        }
	        return findBestPatternMatch(patterns, function (_) { return _; }, candidate);
	    }
	    ts.matchPatternOrExact = matchPatternOrExact;
	    function patternText(_a) {
	        var prefix = _a.prefix, suffix = _a.suffix;
	        return prefix + "*" + suffix;
	    }
	    ts.patternText = patternText;
	    /**
	     * Given that candidate matches pattern, returns the text matching the '*'.
	     * E.g.: matchedText(tryParsePattern("foo*baz"), "foobarbaz") === "bar"
	     */
	    function matchedText(pattern, candidate) {
	        Debug.assert(isPatternMatch(pattern, candidate));
	        return candidate.substring(pattern.prefix.length, candidate.length - pattern.suffix.length);
	    }
	    ts.matchedText = matchedText;
	    /** Return the object corresponding to the best pattern to match `candidate`. */
	    function findBestPatternMatch(values, getPattern, candidate) {
	        var matchedValue = undefined;
	        // use length of prefix as betterness criteria
	        var longestMatchPrefixLength = -1;
	        for (var _i = 0, values_2 = values; _i < values_2.length; _i++) {
	            var v = values_2[_i];
	            var pattern = getPattern(v);
	            if (isPatternMatch(pattern, candidate) && pattern.prefix.length > longestMatchPrefixLength) {
	                longestMatchPrefixLength = pattern.prefix.length;
	                matchedValue = v;
	            }
	        }
	        return matchedValue;
	    }
	    ts.findBestPatternMatch = findBestPatternMatch;
	    function isPatternMatch(_a, candidate) {
	        var prefix = _a.prefix, suffix = _a.suffix;
	        return candidate.length >= prefix.length + suffix.length &&
	            startsWith(candidate, prefix) &&
	            endsWith(candidate, suffix);
	    }
	    function tryParsePattern(pattern) {
	        // This should be verified outside of here and a proper error thrown.
	        Debug.assert(hasZeroOrOneAsteriskCharacter(pattern));
	        var indexOfStar = pattern.indexOf("*");
	        return indexOfStar === -1 ? undefined : {
	            prefix: pattern.substr(0, indexOfStar),
	            suffix: pattern.substr(indexOfStar + 1)
	        };
	    }
	    ts.tryParsePattern = tryParsePattern;
	    function positionIsSynthesized(pos) {
	        // This is a fast way of testing the following conditions:
	        //  pos === undefined || pos === null || isNaN(pos) || pos < 0;
	        return !(pos >= 0);
	    }
	    ts.positionIsSynthesized = positionIsSynthesized;
	    /** True if an extension is one of the supported TypeScript extensions. */
	    function extensionIsTypeScript(ext) {
	        return ext === ".ts" /* Ts */ || ext === ".tsx" /* Tsx */ || ext === ".d.ts" /* Dts */;
	    }
	    ts.extensionIsTypeScript = extensionIsTypeScript;
	    /**
	     * Gets the extension from a path.
	     * Path must have a valid extension.
	     */
	    function extensionFromPath(path) {
	        var ext = tryGetExtensionFromPath(path);
	        if (ext !== undefined) {
	            return ext;
	        }
	        Debug.fail("File " + path + " has unknown extension.");
	    }
	    ts.extensionFromPath = extensionFromPath;
	    function isAnySupportedFileExtension(path) {
	        return tryGetExtensionFromPath(path) !== undefined;
	    }
	    ts.isAnySupportedFileExtension = isAnySupportedFileExtension;
	    function tryGetExtensionFromPath(path) {
	        return find(ts.supportedTypescriptExtensionsForExtractExtension, function (e) { return fileExtensionIs(path, e); }) || find(ts.supportedJavascriptExtensions, function (e) { return fileExtensionIs(path, e); });
	    }
	    ts.tryGetExtensionFromPath = tryGetExtensionFromPath;
	    // Retrieves any string from the final "." onwards from a base file name.
	    // Unlike extensionFromPath, which throws an exception on unrecognized extensions.
	    function getAnyExtensionFromPath(path) {
	        var baseFileName = getBaseFileName(path);
	        var extensionIndex = baseFileName.lastIndexOf(".");
	        if (extensionIndex >= 0) {
	            return baseFileName.substring(extensionIndex);
	        }
	    }
	    ts.getAnyExtensionFromPath = getAnyExtensionFromPath;
	    function isCheckJsEnabledForFile(sourceFile, compilerOptions) {
	        return sourceFile.checkJsDirective ? sourceFile.checkJsDirective.enabled : compilerOptions.checkJs;
	    }
	    ts.isCheckJsEnabledForFile = isCheckJsEnabledForFile;
	    function and(f, g) {
	        return function (arg) { return f(arg) && g(arg); };
	    }
	    ts.and = and;
	    function or(f, g) {
	        return function (arg) { return f(arg) || g(arg); };
	    }
	    ts.or = or;
	    function assertTypeIsNever(_) { } // tslint:disable-line no-empty
	    ts.assertTypeIsNever = assertTypeIsNever;
	    ts.emptyFileSystemEntries = {
	        files: ts.emptyArray,
	        directories: ts.emptyArray
	    };
	    function singleElementArray(t) {
	        return t === undefined ? undefined : [t];
	    }
	    ts.singleElementArray = singleElementArray;
	})(ts || (ts = {}));
	/// <reference path="core.ts"/>
	var ts;
	(function (ts) {
	    /**
	     * Set a high stack trace limit to provide more information in case of an error.
	     * Called for command-line and server use cases.
	     * Not called if TypeScript is used as a library.
	     */
	    /* @internal */
	    function setStackTraceLimit() {
	        if (Error.stackTraceLimit < 100) {
	            Error.stackTraceLimit = 100;
	        }
	    }
	    ts.setStackTraceLimit = setStackTraceLimit;
	    var FileWatcherEventKind;
	    (function (FileWatcherEventKind) {
	        FileWatcherEventKind[FileWatcherEventKind["Created"] = 0] = "Created";
	        FileWatcherEventKind[FileWatcherEventKind["Changed"] = 1] = "Changed";
	        FileWatcherEventKind[FileWatcherEventKind["Deleted"] = 2] = "Deleted";
	    })(FileWatcherEventKind = ts.FileWatcherEventKind || (ts.FileWatcherEventKind = {}));
	    function getNodeMajorVersion() {
	        if (typeof process === "undefined") {
	            return undefined;
	        }
	        var version = process.version;
	        if (!version) {
	            return undefined;
	        }
	        var dot = version.indexOf(".");
	        if (dot === -1) {
	            return undefined;
	        }
	        return parseInt(version.substring(1, dot));
	    }
	    ts.getNodeMajorVersion = getNodeMajorVersion;
	    ts.sys = (function () {
	        // NodeJS detects "\uFEFF" at the start of the string and *replaces* it with the actual
	        // byte order mark from the specified encoding. Using any other byte order mark does
	        // not actually work.
	        var byteOrderMarkIndicator = "\uFEFF";
	        function getNodeSystem() {
	            var _fs = __webpack_require__(476);
	            var _path = __webpack_require__(478);
	            var _os = __webpack_require__(477);
	            // crypto can be absent on reduced node installations
	            var _crypto;
	            try {
	                _crypto = __webpack_require__(173);
	            }
	            catch (_a) {
	                _crypto = undefined;
	            }
	            var useNonPollingWatchers = process.env.TSC_NONPOLLING_WATCHER;
	            /**
	             * djb2 hashing algorithm
	             * http://www.cse.yorku.ca/~oz/hash.html
	             */
	            function generateDjb2Hash(data) {
	                var chars = data.split("").map(function (str) { return str.charCodeAt(0); });
	                return "" + chars.reduce(function (prev, curr) { return ((prev << 5) + prev) + curr; }, 5381);
	            }
	            function createMD5HashUsingNativeCrypto(data) {
	                var hash = _crypto.createHash("md5");
	                hash.update(data);
	                return hash.digest("hex");
	            }
	            function createWatchedFileSet() {
	                var dirWatchers = ts.createMap();
	                // One file can have multiple watchers
	                var fileWatcherCallbacks = ts.createMultiMap();
	                return { addFile: addFile, removeFile: removeFile };
	                function reduceDirWatcherRefCountForFile(fileName) {
	                    var dirName = ts.getDirectoryPath(fileName);
	                    var watcher = dirWatchers.get(dirName);
	                    if (watcher) {
	                        watcher.referenceCount -= 1;
	                        if (watcher.referenceCount <= 0) {
	                            watcher.close();
	                            dirWatchers.delete(dirName);
	                        }
	                    }
	                }
	                function addDirWatcher(dirPath) {
	                    var watcher = dirWatchers.get(dirPath);
	                    if (watcher) {
	                        watcher.referenceCount += 1;
	                        return;
	                    }
	                    watcher = fsWatchDirectory(dirPath || ".", function (eventName, relativeFileName) { return fileEventHandler(eventName, relativeFileName, dirPath); });
	                    watcher.referenceCount = 1;
	                    dirWatchers.set(dirPath, watcher);
	                    return;
	                }
	                function addFileWatcherCallback(filePath, callback) {
	                    fileWatcherCallbacks.add(filePath, callback);
	                }
	                function addFile(fileName, callback) {
	                    addFileWatcherCallback(fileName, callback);
	                    addDirWatcher(ts.getDirectoryPath(fileName));
	                    return { fileName: fileName, callback: callback };
	                }
	                function removeFile(watchedFile) {
	                    removeFileWatcherCallback(watchedFile.fileName, watchedFile.callback);
	                    reduceDirWatcherRefCountForFile(watchedFile.fileName);
	                }
	                function removeFileWatcherCallback(filePath, callback) {
	                    fileWatcherCallbacks.remove(filePath, callback);
	                }
	                function fileEventHandler(eventName, relativeFileName, baseDirPath) {
	                    // When files are deleted from disk, the triggered "rename" event would have a relativefileName of "undefined"
	                    var fileName = !ts.isString(relativeFileName)
	                        ? undefined
	                        : ts.getNormalizedAbsolutePath(relativeFileName, baseDirPath);
	                    // Some applications save a working file via rename operations
	                    if ((eventName === "change" || eventName === "rename")) {
	                        var callbacks = fileWatcherCallbacks.get(fileName);
	                        if (callbacks) {
	                            for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
	                                var fileCallback = callbacks_1[_i];
	                                fileCallback(fileName, FileWatcherEventKind.Changed);
	                            }
	                        }
	                    }
	                }
	            }
	            var watchedFileSet = createWatchedFileSet();
	            var nodeVersion = getNodeMajorVersion();
	            var isNode4OrLater = nodeVersion >= 4;
	            function isFileSystemCaseSensitive() {
	                // win32\win64 are case insensitive platforms
	                if (platform === "win32" || platform === "win64") {
	                    return false;
	                }
	                // If this file exists under a different case, we must be case-insensitve.
	                return !fileExists(swapCase(__filename));
	            }
	            /** Convert all lowercase chars to uppercase, and vice-versa */
	            function swapCase(s) {
	                return s.replace(/\w/g, function (ch) {
	                    var up = ch.toUpperCase();
	                    return ch === up ? ch.toLowerCase() : up;
	                });
	            }
	            var platform = _os.platform();
	            var useCaseSensitiveFileNames = isFileSystemCaseSensitive();
	            function fsWatchFile(fileName, callback, pollingInterval) {
	                _fs.watchFile(fileName, { persistent: true, interval: pollingInterval || 250 }, fileChanged);
	                return {
	                    close: function () { return _fs.unwatchFile(fileName, fileChanged); }
	                };
	                function fileChanged(curr, prev) {
	                    var isCurrZero = +curr.mtime === 0;
	                    var isPrevZero = +prev.mtime === 0;
	                    var created = !isCurrZero && isPrevZero;
	                    var deleted = isCurrZero && !isPrevZero;
	                    var eventKind = created
	                        ? FileWatcherEventKind.Created
	                        : deleted
	                            ? FileWatcherEventKind.Deleted
	                            : FileWatcherEventKind.Changed;
	                    if (eventKind === FileWatcherEventKind.Changed && +curr.mtime <= +prev.mtime) {
	                        return;
	                    }
	                    callback(fileName, eventKind);
	                }
	            }
	            function fsWatchDirectory(directoryName, callback, recursive) {
	                var options;
	                /** Watcher for the directory depending on whether it is missing or present */
	                var watcher = !directoryExists(directoryName) ?
	                    watchMissingDirectory() :
	                    watchPresentDirectory();
	                return {
	                    close: function () {
	                        // Close the watcher (either existing directory watcher or missing directory watcher)
	                        watcher.close();
	                    }
	                };
	                /**
	                 * Watch the directory that is currently present
	                 * and when the watched directory is deleted, switch to missing directory watcher
	                 */
	                function watchPresentDirectory() {
	                    // Node 4.0 `fs.watch` function supports the "recursive" option on both OSX and Windows
	                    // (ref: https://github.com/nodejs/node/pull/2649 and https://github.com/Microsoft/TypeScript/issues/4643)
	                    if (options === undefined) {
	                        if (isNode4OrLater && (process.platform === "win32" || process.platform === "darwin")) {
	                            options = { persistent: true, recursive: !!recursive };
	                        }
	                        else {
	                            options = { persistent: true };
	                        }
	                    }
	                    var dirWatcher = _fs.watch(directoryName, options, callback);
	                    dirWatcher.on("error", function () {
	                        if (!directoryExists(directoryName)) {
	                            // Deleting directory
	                            watcher = watchMissingDirectory();
	                            // Call the callback for current directory
	                            callback("rename", "");
	                        }
	                    });
	                    return dirWatcher;
	                }
	                /**
	                 * Watch the directory that is missing
	                 * and switch to existing directory when the directory is created
	                 */
	                function watchMissingDirectory() {
	                    return fsWatchFile(directoryName, function (_fileName, eventKind) {
	                        if (eventKind === FileWatcherEventKind.Created && directoryExists(directoryName)) {
	                            watcher.close();
	                            watcher = watchPresentDirectory();
	                            // Call the callback for current directory
	                            // For now it could be callback for the inner directory creation,
	                            // but just return current directory, better than current no-op
	                            callback("rename", "");
	                        }
	                    });
	                }
	            }
	            function readFile(fileName, _encoding) {
	                if (!fileExists(fileName)) {
	                    return undefined;
	                }
	                var buffer = _fs.readFileSync(fileName);
	                var len = buffer.length;
	                if (len >= 2 && buffer[0] === 0xFE && buffer[1] === 0xFF) {
	                    // Big endian UTF-16 byte order mark detected. Since big endian is not supported by node.js,
	                    // flip all byte pairs and treat as little endian.
	                    len &= ~1; // Round down to a multiple of 2
	                    for (var i = 0; i < len; i += 2) {
	                        var temp = buffer[i];
	                        buffer[i] = buffer[i + 1];
	                        buffer[i + 1] = temp;
	                    }
	                    return buffer.toString("utf16le", 2);
	                }
	                if (len >= 2 && buffer[0] === 0xFF && buffer[1] === 0xFE) {
	                    // Little endian UTF-16 byte order mark detected
	                    return buffer.toString("utf16le", 2);
	                }
	                if (len >= 3 && buffer[0] === 0xEF && buffer[1] === 0xBB && buffer[2] === 0xBF) {
	                    // UTF-8 byte order mark detected
	                    return buffer.toString("utf8", 3);
	                }
	                // Default is UTF-8 with no byte order mark
	                return buffer.toString("utf8");
	            }
	            function writeFile(fileName, data, writeByteOrderMark) {
	                // If a BOM is required, emit one
	                if (writeByteOrderMark) {
	                    data = byteOrderMarkIndicator + data;
	                }
	                var fd;
	                try {
	                    fd = _fs.openSync(fileName, "w");
	                    _fs.writeSync(fd, data, /*position*/ undefined, "utf8");
	                }
	                finally {
	                    if (fd !== undefined) {
	                        _fs.closeSync(fd);
	                    }
	                }
	            }
	            function getAccessibleFileSystemEntries(path) {
	                try {
	                    var entries = _fs.readdirSync(path || ".").sort();
	                    var files = [];
	                    var directories = [];
	                    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                        var entry = entries_1[_i];
	                        // This is necessary because on some file system node fails to exclude
	                        // "." and "..". See https://github.com/nodejs/node/issues/4002
	                        if (entry === "." || entry === "..") {
	                            continue;
	                        }
	                        var name = ts.combinePaths(path, entry);
	                        var stat = void 0;
	                        try {
	                            stat = _fs.statSync(name);
	                        }
	                        catch (e) {
	                            continue;
	                        }
	                        if (stat.isFile()) {
	                            files.push(entry);
	                        }
	                        else if (stat.isDirectory()) {
	                            directories.push(entry);
	                        }
	                    }
	                    return { files: files, directories: directories };
	                }
	                catch (e) {
	                    return ts.emptyFileSystemEntries;
	                }
	            }
	            function readDirectory(path, extensions, excludes, includes, depth) {
	                return ts.matchFiles(path, extensions, excludes, includes, useCaseSensitiveFileNames, process.cwd(), depth, getAccessibleFileSystemEntries);
	            }
	            var FileSystemEntryKind;
	            (function (FileSystemEntryKind) {
	                FileSystemEntryKind[FileSystemEntryKind["File"] = 0] = "File";
	                FileSystemEntryKind[FileSystemEntryKind["Directory"] = 1] = "Directory";
	            })(FileSystemEntryKind || (FileSystemEntryKind = {}));
	            function fileSystemEntryExists(path, entryKind) {
	                try {
	                    var stat = _fs.statSync(path);
	                    switch (entryKind) {
	                        case 0 /* File */: return stat.isFile();
	                        case 1 /* Directory */: return stat.isDirectory();
	                    }
	                }
	                catch (e) {
	                    return false;
	                }
	            }
	            function fileExists(path) {
	                return fileSystemEntryExists(path, 0 /* File */);
	            }
	            function directoryExists(path) {
	                return fileSystemEntryExists(path, 1 /* Directory */);
	            }
	            function getDirectories(path) {
	                return ts.filter(_fs.readdirSync(path), function (dir) { return fileSystemEntryExists(ts.combinePaths(path, dir), 1 /* Directory */); });
	            }
	            var nodeSystem = {
	                clearScreen: function () {
	                    process.stdout.write("\x1Bc");
	                },
	                args: process.argv.slice(2),
	                newLine: _os.EOL,
	                useCaseSensitiveFileNames: useCaseSensitiveFileNames,
	                write: function (s) {
	                    process.stdout.write(s);
	                },
	                readFile: readFile,
	                writeFile: writeFile,
	                watchFile: function (fileName, callback, pollingInterval) {
	                    if (useNonPollingWatchers) {
	                        var watchedFile_1 = watchedFileSet.addFile(fileName, callback);
	                        return {
	                            close: function () { return watchedFileSet.removeFile(watchedFile_1); }
	                        };
	                    }
	                    else {
	                        return fsWatchFile(fileName, callback, pollingInterval);
	                    }
	                },
	                watchDirectory: function (directoryName, callback, recursive) {
	                    // Node 4.0 `fs.watch` function supports the "recursive" option on both OSX and Windows
	                    // (ref: https://github.com/nodejs/node/pull/2649 and https://github.com/Microsoft/TypeScript/issues/4643)
	                    return fsWatchDirectory(directoryName, function (eventName, relativeFileName) {
	                        // In watchDirectory we only care about adding and removing files (when event name is
	                        // "rename"); changes made within files are handled by corresponding fileWatchers (when
	                        // event name is "change")
	                        if (eventName === "rename") {
	                            // When deleting a file, the passed baseFileName is null
	                            callback(!relativeFileName ? relativeFileName : ts.normalizePath(ts.combinePaths(directoryName, relativeFileName)));
	                        }
	                    }, recursive);
	                },
	                resolvePath: function (path) { return _path.resolve(path); },
	                fileExists: fileExists,
	                directoryExists: directoryExists,
	                createDirectory: function (directoryName) {
	                    if (!nodeSystem.directoryExists(directoryName)) {
	                        _fs.mkdirSync(directoryName);
	                    }
	                },
	                getExecutingFilePath: function () {
	                    return __filename;
	                },
	                getCurrentDirectory: function () {
	                    return process.cwd();
	                },
	                getDirectories: getDirectories,
	                getEnvironmentVariable: function (name) {
	                    return process.env[name] || "";
	                },
	                readDirectory: readDirectory,
	                getModifiedTime: function (path) {
	                    try {
	                        return _fs.statSync(path).mtime;
	                    }
	                    catch (e) {
	                        return undefined;
	                    }
	                },
	                createHash: _crypto ? createMD5HashUsingNativeCrypto : generateDjb2Hash,
	                getMemoryUsage: function () {
	                    if (global.gc) {
	                        global.gc();
	                    }
	                    return process.memoryUsage().heapUsed;
	                },
	                getFileSize: function (path) {
	                    try {
	                        var stat = _fs.statSync(path);
	                        if (stat.isFile()) {
	                            return stat.size;
	                        }
	                    }
	                    catch (_a) { }
	                    return 0;
	                },
	                exit: function (exitCode) {
	                    process.exit(exitCode);
	                },
	                realpath: function (path) {
	                    try {
	                        return _fs.realpathSync(path);
	                    }
	                    catch (_a) {
	                        return path;
	                    }
	                },
	                debugMode: ts.some(process.execArgv, function (arg) { return /^--(inspect|debug)(-brk)?(=\d+)?$/i.test(arg); }),
	                tryEnableSourceMapsForHost: function () {
	                    try {
	                        __webpack_require__(346).install();
	                    }
	                    catch (_a) {
	                        // Could not enable source maps.
	                    }
	                },
	                setTimeout: setTimeout,
	                clearTimeout: clearTimeout
	            };
	            return nodeSystem;
	        }
	        function getChakraSystem() {
	            var realpath = ChakraHost.realpath && (function (path) { return ChakraHost.realpath(path); });
	            return {
	                newLine: ChakraHost.newLine || "\r\n",
	                args: ChakraHost.args,
	                useCaseSensitiveFileNames: !!ChakraHost.useCaseSensitiveFileNames,
	                write: ChakraHost.echo,
	                readFile: function (path, _encoding) {
	                    // encoding is automatically handled by the implementation in ChakraHost
	                    return ChakraHost.readFile(path);
	                },
	                writeFile: function (path, data, writeByteOrderMark) {
	                    // If a BOM is required, emit one
	                    if (writeByteOrderMark) {
	                        data = byteOrderMarkIndicator + data;
	                    }
	                    ChakraHost.writeFile(path, data);
	                },
	                resolvePath: ChakraHost.resolvePath,
	                fileExists: ChakraHost.fileExists,
	                directoryExists: ChakraHost.directoryExists,
	                createDirectory: ChakraHost.createDirectory,
	                getExecutingFilePath: function () { return ChakraHost.executingFile; },
	                getCurrentDirectory: function () { return ChakraHost.currentDirectory; },
	                getDirectories: ChakraHost.getDirectories,
	                getEnvironmentVariable: ChakraHost.getEnvironmentVariable || (function () { return ""; }),
	                readDirectory: function (path, extensions, excludes, includes, _depth) {
	                    var pattern = ts.getFileMatcherPatterns(path, excludes, includes, !!ChakraHost.useCaseSensitiveFileNames, ChakraHost.currentDirectory);
	                    return ChakraHost.readDirectory(path, extensions, pattern.basePaths, pattern.excludePattern, pattern.includeFilePattern, pattern.includeDirectoryPattern);
	                },
	                exit: ChakraHost.quit,
	                realpath: realpath
	            };
	        }
	        function recursiveCreateDirectory(directoryPath, sys) {
	            var basePath = ts.getDirectoryPath(directoryPath);
	            var shouldCreateParent = basePath !== "" && directoryPath !== basePath && !sys.directoryExists(basePath);
	            if (shouldCreateParent) {
	                recursiveCreateDirectory(basePath, sys);
	            }
	            if (shouldCreateParent || !sys.directoryExists(directoryPath)) {
	                sys.createDirectory(directoryPath);
	            }
	        }
	        var sys;
	        if (typeof ChakraHost !== "undefined") {
	            sys = getChakraSystem();
	        }
	        else if (typeof process !== "undefined" && process.nextTick && !process.browser && "function" !== "undefined") {
	            // process and process.nextTick checks if current environment is node-like
	            // process.browser check excludes webpack and browserify
	            sys = getNodeSystem();
	        }
	        if (sys) {
	            // patch writefile to create folder before writing the file
	            var originalWriteFile_1 = sys.writeFile;
	            sys.writeFile = function (path, data, writeBom) {
	                var directoryPath = ts.getDirectoryPath(ts.normalizeSlashes(path));
	                if (directoryPath && !sys.directoryExists(directoryPath)) {
	                    recursiveCreateDirectory(directoryPath, sys);
	                }
	                originalWriteFile_1.call(sys, path, data, writeBom);
	            };
	        }
	        return sys;
	    })();
	    if (ts.sys && ts.sys.getEnvironmentVariable) {
	        ts.Debug.currentAssertionLevel = /^development$/i.test(ts.sys.getEnvironmentVariable("NODE_ENV"))
	            ? 1 /* Normal */
	            : 0 /* None */;
	    }
	    if (ts.sys && ts.sys.debugMode) {
	        ts.Debug.isDebugging = true;
	    }
	})(ts || (ts = {}));
	// <auto-generated />
	// generated from './diagnosticInformationMap.generated.ts' by '../../scripts/processDiagnosticMessages.js'
	/// <reference path="types.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    function diag(code, category, key, message) {
	        return { code: code, category: category, key: key, message: message };
	    }
	    // tslint:disable-next-line variable-name
	    ts.Diagnostics = {
	        Unterminated_string_literal: diag(1002, ts.DiagnosticCategory.Error, "Unterminated_string_literal_1002", "Unterminated string literal."),
	        Identifier_expected: diag(1003, ts.DiagnosticCategory.Error, "Identifier_expected_1003", "Identifier expected."),
	        _0_expected: diag(1005, ts.DiagnosticCategory.Error, "_0_expected_1005", "'{0}' expected."),
	        A_file_cannot_have_a_reference_to_itself: diag(1006, ts.DiagnosticCategory.Error, "A_file_cannot_have_a_reference_to_itself_1006", "A file cannot have a reference to itself."),
	        Trailing_comma_not_allowed: diag(1009, ts.DiagnosticCategory.Error, "Trailing_comma_not_allowed_1009", "Trailing comma not allowed."),
	        Asterisk_Slash_expected: diag(1010, ts.DiagnosticCategory.Error, "Asterisk_Slash_expected_1010", "'*/' expected."),
	        Unexpected_token: diag(1012, ts.DiagnosticCategory.Error, "Unexpected_token_1012", "Unexpected token."),
	        A_rest_parameter_must_be_last_in_a_parameter_list: diag(1014, ts.DiagnosticCategory.Error, "A_rest_parameter_must_be_last_in_a_parameter_list_1014", "A rest parameter must be last in a parameter list."),
	        Parameter_cannot_have_question_mark_and_initializer: diag(1015, ts.DiagnosticCategory.Error, "Parameter_cannot_have_question_mark_and_initializer_1015", "Parameter cannot have question mark and initializer."),
	        A_required_parameter_cannot_follow_an_optional_parameter: diag(1016, ts.DiagnosticCategory.Error, "A_required_parameter_cannot_follow_an_optional_parameter_1016", "A required parameter cannot follow an optional parameter."),
	        An_index_signature_cannot_have_a_rest_parameter: diag(1017, ts.DiagnosticCategory.Error, "An_index_signature_cannot_have_a_rest_parameter_1017", "An index signature cannot have a rest parameter."),
	        An_index_signature_parameter_cannot_have_an_accessibility_modifier: diag(1018, ts.DiagnosticCategory.Error, "An_index_signature_parameter_cannot_have_an_accessibility_modifier_1018", "An index signature parameter cannot have an accessibility modifier."),
	        An_index_signature_parameter_cannot_have_a_question_mark: diag(1019, ts.DiagnosticCategory.Error, "An_index_signature_parameter_cannot_have_a_question_mark_1019", "An index signature parameter cannot have a question mark."),
	        An_index_signature_parameter_cannot_have_an_initializer: diag(1020, ts.DiagnosticCategory.Error, "An_index_signature_parameter_cannot_have_an_initializer_1020", "An index signature parameter cannot have an initializer."),
	        An_index_signature_must_have_a_type_annotation: diag(1021, ts.DiagnosticCategory.Error, "An_index_signature_must_have_a_type_annotation_1021", "An index signature must have a type annotation."),
	        An_index_signature_parameter_must_have_a_type_annotation: diag(1022, ts.DiagnosticCategory.Error, "An_index_signature_parameter_must_have_a_type_annotation_1022", "An index signature parameter must have a type annotation."),
	        An_index_signature_parameter_type_must_be_string_or_number: diag(1023, ts.DiagnosticCategory.Error, "An_index_signature_parameter_type_must_be_string_or_number_1023", "An index signature parameter type must be 'string' or 'number'."),
	        readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature: diag(1024, ts.DiagnosticCategory.Error, "readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature_1024", "'readonly' modifier can only appear on a property declaration or index signature."),
	        Accessibility_modifier_already_seen: diag(1028, ts.DiagnosticCategory.Error, "Accessibility_modifier_already_seen_1028", "Accessibility modifier already seen."),
	        _0_modifier_must_precede_1_modifier: diag(1029, ts.DiagnosticCategory.Error, "_0_modifier_must_precede_1_modifier_1029", "'{0}' modifier must precede '{1}' modifier."),
	        _0_modifier_already_seen: diag(1030, ts.DiagnosticCategory.Error, "_0_modifier_already_seen_1030", "'{0}' modifier already seen."),
	        _0_modifier_cannot_appear_on_a_class_element: diag(1031, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_class_element_1031", "'{0}' modifier cannot appear on a class element."),
	        super_must_be_followed_by_an_argument_list_or_member_access: diag(1034, ts.DiagnosticCategory.Error, "super_must_be_followed_by_an_argument_list_or_member_access_1034", "'super' must be followed by an argument list or member access."),
	        Only_ambient_modules_can_use_quoted_names: diag(1035, ts.DiagnosticCategory.Error, "Only_ambient_modules_can_use_quoted_names_1035", "Only ambient modules can use quoted names."),
	        Statements_are_not_allowed_in_ambient_contexts: diag(1036, ts.DiagnosticCategory.Error, "Statements_are_not_allowed_in_ambient_contexts_1036", "Statements are not allowed in ambient contexts."),
	        A_declare_modifier_cannot_be_used_in_an_already_ambient_context: diag(1038, ts.DiagnosticCategory.Error, "A_declare_modifier_cannot_be_used_in_an_already_ambient_context_1038", "A 'declare' modifier cannot be used in an already ambient context."),
	        Initializers_are_not_allowed_in_ambient_contexts: diag(1039, ts.DiagnosticCategory.Error, "Initializers_are_not_allowed_in_ambient_contexts_1039", "Initializers are not allowed in ambient contexts."),
	        _0_modifier_cannot_be_used_in_an_ambient_context: diag(1040, ts.DiagnosticCategory.Error, "_0_modifier_cannot_be_used_in_an_ambient_context_1040", "'{0}' modifier cannot be used in an ambient context."),
	        _0_modifier_cannot_be_used_with_a_class_declaration: diag(1041, ts.DiagnosticCategory.Error, "_0_modifier_cannot_be_used_with_a_class_declaration_1041", "'{0}' modifier cannot be used with a class declaration."),
	        _0_modifier_cannot_be_used_here: diag(1042, ts.DiagnosticCategory.Error, "_0_modifier_cannot_be_used_here_1042", "'{0}' modifier cannot be used here."),
	        _0_modifier_cannot_appear_on_a_data_property: diag(1043, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_data_property_1043", "'{0}' modifier cannot appear on a data property."),
	        _0_modifier_cannot_appear_on_a_module_or_namespace_element: diag(1044, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_module_or_namespace_element_1044", "'{0}' modifier cannot appear on a module or namespace element."),
	        A_0_modifier_cannot_be_used_with_an_interface_declaration: diag(1045, ts.DiagnosticCategory.Error, "A_0_modifier_cannot_be_used_with_an_interface_declaration_1045", "A '{0}' modifier cannot be used with an interface declaration."),
	        A_declare_modifier_is_required_for_a_top_level_declaration_in_a_d_ts_file: diag(1046, ts.DiagnosticCategory.Error, "A_declare_modifier_is_required_for_a_top_level_declaration_in_a_d_ts_file_1046", "A 'declare' modifier is required for a top level declaration in a .d.ts file."),
	        A_rest_parameter_cannot_be_optional: diag(1047, ts.DiagnosticCategory.Error, "A_rest_parameter_cannot_be_optional_1047", "A rest parameter cannot be optional."),
	        A_rest_parameter_cannot_have_an_initializer: diag(1048, ts.DiagnosticCategory.Error, "A_rest_parameter_cannot_have_an_initializer_1048", "A rest parameter cannot have an initializer."),
	        A_set_accessor_must_have_exactly_one_parameter: diag(1049, ts.DiagnosticCategory.Error, "A_set_accessor_must_have_exactly_one_parameter_1049", "A 'set' accessor must have exactly one parameter."),
	        A_set_accessor_cannot_have_an_optional_parameter: diag(1051, ts.DiagnosticCategory.Error, "A_set_accessor_cannot_have_an_optional_parameter_1051", "A 'set' accessor cannot have an optional parameter."),
	        A_set_accessor_parameter_cannot_have_an_initializer: diag(1052, ts.DiagnosticCategory.Error, "A_set_accessor_parameter_cannot_have_an_initializer_1052", "A 'set' accessor parameter cannot have an initializer."),
	        A_set_accessor_cannot_have_rest_parameter: diag(1053, ts.DiagnosticCategory.Error, "A_set_accessor_cannot_have_rest_parameter_1053", "A 'set' accessor cannot have rest parameter."),
	        A_get_accessor_cannot_have_parameters: diag(1054, ts.DiagnosticCategory.Error, "A_get_accessor_cannot_have_parameters_1054", "A 'get' accessor cannot have parameters."),
	        Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value: diag(1055, ts.DiagnosticCategory.Error, "Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Prom_1055", "Type '{0}' is not a valid async function return type in ES5/ES3 because it does not refer to a Promise-compatible constructor value."),
	        Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher: diag(1056, ts.DiagnosticCategory.Error, "Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher_1056", "Accessors are only available when targeting ECMAScript 5 and higher."),
	        An_async_function_or_method_must_have_a_valid_awaitable_return_type: diag(1057, ts.DiagnosticCategory.Error, "An_async_function_or_method_must_have_a_valid_awaitable_return_type_1057", "An async function or method must have a valid awaitable return type."),
	        The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1058, ts.DiagnosticCategory.Error, "The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_t_1058", "The return type of an async function must either be a valid promise or must not contain a callable 'then' member."),
	        A_promise_must_have_a_then_method: diag(1059, ts.DiagnosticCategory.Error, "A_promise_must_have_a_then_method_1059", "A promise must have a 'then' method."),
	        The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback: diag(1060, ts.DiagnosticCategory.Error, "The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback_1060", "The first parameter of the 'then' method of a promise must be a callback."),
	        Enum_member_must_have_initializer: diag(1061, ts.DiagnosticCategory.Error, "Enum_member_must_have_initializer_1061", "Enum member must have initializer."),
	        Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method: diag(1062, ts.DiagnosticCategory.Error, "Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method_1062", "Type is referenced directly or indirectly in the fulfillment callback of its own 'then' method."),
	        An_export_assignment_cannot_be_used_in_a_namespace: diag(1063, ts.DiagnosticCategory.Error, "An_export_assignment_cannot_be_used_in_a_namespace_1063", "An export assignment cannot be used in a namespace."),
	        The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type: diag(1064, ts.DiagnosticCategory.Error, "The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_1064", "The return type of an async function or method must be the global Promise<T> type."),
	        In_ambient_enum_declarations_member_initializer_must_be_constant_expression: diag(1066, ts.DiagnosticCategory.Error, "In_ambient_enum_declarations_member_initializer_must_be_constant_expression_1066", "In ambient enum declarations member initializer must be constant expression."),
	        Unexpected_token_A_constructor_method_accessor_or_property_was_expected: diag(1068, ts.DiagnosticCategory.Error, "Unexpected_token_A_constructor_method_accessor_or_property_was_expected_1068", "Unexpected token. A constructor, method, accessor, or property was expected."),
	        _0_modifier_cannot_appear_on_a_type_member: diag(1070, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_type_member_1070", "'{0}' modifier cannot appear on a type member."),
	        _0_modifier_cannot_appear_on_an_index_signature: diag(1071, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_an_index_signature_1071", "'{0}' modifier cannot appear on an index signature."),
	        A_0_modifier_cannot_be_used_with_an_import_declaration: diag(1079, ts.DiagnosticCategory.Error, "A_0_modifier_cannot_be_used_with_an_import_declaration_1079", "A '{0}' modifier cannot be used with an import declaration."),
	        Invalid_reference_directive_syntax: diag(1084, ts.DiagnosticCategory.Error, "Invalid_reference_directive_syntax_1084", "Invalid 'reference' directive syntax."),
	        Octal_literals_are_not_available_when_targeting_ECMAScript_5_and_higher_Use_the_syntax_0: diag(1085, ts.DiagnosticCategory.Error, "Octal_literals_are_not_available_when_targeting_ECMAScript_5_and_higher_Use_the_syntax_0_1085", "Octal literals are not available when targeting ECMAScript 5 and higher. Use the syntax '{0}'."),
	        An_accessor_cannot_be_declared_in_an_ambient_context: diag(1086, ts.DiagnosticCategory.Error, "An_accessor_cannot_be_declared_in_an_ambient_context_1086", "An accessor cannot be declared in an ambient context."),
	        _0_modifier_cannot_appear_on_a_constructor_declaration: diag(1089, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_constructor_declaration_1089", "'{0}' modifier cannot appear on a constructor declaration."),
	        _0_modifier_cannot_appear_on_a_parameter: diag(1090, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_parameter_1090", "'{0}' modifier cannot appear on a parameter."),
	        Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement: diag(1091, ts.DiagnosticCategory.Error, "Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement_1091", "Only a single variable declaration is allowed in a 'for...in' statement."),
	        Type_parameters_cannot_appear_on_a_constructor_declaration: diag(1092, ts.DiagnosticCategory.Error, "Type_parameters_cannot_appear_on_a_constructor_declaration_1092", "Type parameters cannot appear on a constructor declaration."),
	        Type_annotation_cannot_appear_on_a_constructor_declaration: diag(1093, ts.DiagnosticCategory.Error, "Type_annotation_cannot_appear_on_a_constructor_declaration_1093", "Type annotation cannot appear on a constructor declaration."),
	        An_accessor_cannot_have_type_parameters: diag(1094, ts.DiagnosticCategory.Error, "An_accessor_cannot_have_type_parameters_1094", "An accessor cannot have type parameters."),
	        A_set_accessor_cannot_have_a_return_type_annotation: diag(1095, ts.DiagnosticCategory.Error, "A_set_accessor_cannot_have_a_return_type_annotation_1095", "A 'set' accessor cannot have a return type annotation."),
	        An_index_signature_must_have_exactly_one_parameter: diag(1096, ts.DiagnosticCategory.Error, "An_index_signature_must_have_exactly_one_parameter_1096", "An index signature must have exactly one parameter."),
	        _0_list_cannot_be_empty: diag(1097, ts.DiagnosticCategory.Error, "_0_list_cannot_be_empty_1097", "'{0}' list cannot be empty."),
	        Type_parameter_list_cannot_be_empty: diag(1098, ts.DiagnosticCategory.Error, "Type_parameter_list_cannot_be_empty_1098", "Type parameter list cannot be empty."),
	        Type_argument_list_cannot_be_empty: diag(1099, ts.DiagnosticCategory.Error, "Type_argument_list_cannot_be_empty_1099", "Type argument list cannot be empty."),
	        Invalid_use_of_0_in_strict_mode: diag(1100, ts.DiagnosticCategory.Error, "Invalid_use_of_0_in_strict_mode_1100", "Invalid use of '{0}' in strict mode."),
	        with_statements_are_not_allowed_in_strict_mode: diag(1101, ts.DiagnosticCategory.Error, "with_statements_are_not_allowed_in_strict_mode_1101", "'with' statements are not allowed in strict mode."),
	        delete_cannot_be_called_on_an_identifier_in_strict_mode: diag(1102, ts.DiagnosticCategory.Error, "delete_cannot_be_called_on_an_identifier_in_strict_mode_1102", "'delete' cannot be called on an identifier in strict mode."),
	        A_for_await_of_statement_is_only_allowed_within_an_async_function_or_async_generator: diag(1103, ts.DiagnosticCategory.Error, "A_for_await_of_statement_is_only_allowed_within_an_async_function_or_async_generator_1103", "A 'for-await-of' statement is only allowed within an async function or async generator."),
	        A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement: diag(1104, ts.DiagnosticCategory.Error, "A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement_1104", "A 'continue' statement can only be used within an enclosing iteration statement."),
	        A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement: diag(1105, ts.DiagnosticCategory.Error, "A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement_1105", "A 'break' statement can only be used within an enclosing iteration or switch statement."),
	        Jump_target_cannot_cross_function_boundary: diag(1107, ts.DiagnosticCategory.Error, "Jump_target_cannot_cross_function_boundary_1107", "Jump target cannot cross function boundary."),
	        A_return_statement_can_only_be_used_within_a_function_body: diag(1108, ts.DiagnosticCategory.Error, "A_return_statement_can_only_be_used_within_a_function_body_1108", "A 'return' statement can only be used within a function body."),
	        Expression_expected: diag(1109, ts.DiagnosticCategory.Error, "Expression_expected_1109", "Expression expected."),
	        Type_expected: diag(1110, ts.DiagnosticCategory.Error, "Type_expected_1110", "Type expected."),
	        A_default_clause_cannot_appear_more_than_once_in_a_switch_statement: diag(1113, ts.DiagnosticCategory.Error, "A_default_clause_cannot_appear_more_than_once_in_a_switch_statement_1113", "A 'default' clause cannot appear more than once in a 'switch' statement."),
	        Duplicate_label_0: diag(1114, ts.DiagnosticCategory.Error, "Duplicate_label_0_1114", "Duplicate label '{0}'."),
	        A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement: diag(1115, ts.DiagnosticCategory.Error, "A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement_1115", "A 'continue' statement can only jump to a label of an enclosing iteration statement."),
	        A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement: diag(1116, ts.DiagnosticCategory.Error, "A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement_1116", "A 'break' statement can only jump to a label of an enclosing statement."),
	        An_object_literal_cannot_have_multiple_properties_with_the_same_name_in_strict_mode: diag(1117, ts.DiagnosticCategory.Error, "An_object_literal_cannot_have_multiple_properties_with_the_same_name_in_strict_mode_1117", "An object literal cannot have multiple properties with the same name in strict mode."),
	        An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name: diag(1118, ts.DiagnosticCategory.Error, "An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name_1118", "An object literal cannot have multiple get/set accessors with the same name."),
	        An_object_literal_cannot_have_property_and_accessor_with_the_same_name: diag(1119, ts.DiagnosticCategory.Error, "An_object_literal_cannot_have_property_and_accessor_with_the_same_name_1119", "An object literal cannot have property and accessor with the same name."),
	        An_export_assignment_cannot_have_modifiers: diag(1120, ts.DiagnosticCategory.Error, "An_export_assignment_cannot_have_modifiers_1120", "An export assignment cannot have modifiers."),
	        Octal_literals_are_not_allowed_in_strict_mode: diag(1121, ts.DiagnosticCategory.Error, "Octal_literals_are_not_allowed_in_strict_mode_1121", "Octal literals are not allowed in strict mode."),
	        A_tuple_type_element_list_cannot_be_empty: diag(1122, ts.DiagnosticCategory.Error, "A_tuple_type_element_list_cannot_be_empty_1122", "A tuple type element list cannot be empty."),
	        Variable_declaration_list_cannot_be_empty: diag(1123, ts.DiagnosticCategory.Error, "Variable_declaration_list_cannot_be_empty_1123", "Variable declaration list cannot be empty."),
	        Digit_expected: diag(1124, ts.DiagnosticCategory.Error, "Digit_expected_1124", "Digit expected."),
	        Hexadecimal_digit_expected: diag(1125, ts.DiagnosticCategory.Error, "Hexadecimal_digit_expected_1125", "Hexadecimal digit expected."),
	        Unexpected_end_of_text: diag(1126, ts.DiagnosticCategory.Error, "Unexpected_end_of_text_1126", "Unexpected end of text."),
	        Invalid_character: diag(1127, ts.DiagnosticCategory.Error, "Invalid_character_1127", "Invalid character."),
	        Declaration_or_statement_expected: diag(1128, ts.DiagnosticCategory.Error, "Declaration_or_statement_expected_1128", "Declaration or statement expected."),
	        Statement_expected: diag(1129, ts.DiagnosticCategory.Error, "Statement_expected_1129", "Statement expected."),
	        case_or_default_expected: diag(1130, ts.DiagnosticCategory.Error, "case_or_default_expected_1130", "'case' or 'default' expected."),
	        Property_or_signature_expected: diag(1131, ts.DiagnosticCategory.Error, "Property_or_signature_expected_1131", "Property or signature expected."),
	        Enum_member_expected: diag(1132, ts.DiagnosticCategory.Error, "Enum_member_expected_1132", "Enum member expected."),
	        Variable_declaration_expected: diag(1134, ts.DiagnosticCategory.Error, "Variable_declaration_expected_1134", "Variable declaration expected."),
	        Argument_expression_expected: diag(1135, ts.DiagnosticCategory.Error, "Argument_expression_expected_1135", "Argument expression expected."),
	        Property_assignment_expected: diag(1136, ts.DiagnosticCategory.Error, "Property_assignment_expected_1136", "Property assignment expected."),
	        Expression_or_comma_expected: diag(1137, ts.DiagnosticCategory.Error, "Expression_or_comma_expected_1137", "Expression or comma expected."),
	        Parameter_declaration_expected: diag(1138, ts.DiagnosticCategory.Error, "Parameter_declaration_expected_1138", "Parameter declaration expected."),
	        Type_parameter_declaration_expected: diag(1139, ts.DiagnosticCategory.Error, "Type_parameter_declaration_expected_1139", "Type parameter declaration expected."),
	        Type_argument_expected: diag(1140, ts.DiagnosticCategory.Error, "Type_argument_expected_1140", "Type argument expected."),
	        String_literal_expected: diag(1141, ts.DiagnosticCategory.Error, "String_literal_expected_1141", "String literal expected."),
	        Line_break_not_permitted_here: diag(1142, ts.DiagnosticCategory.Error, "Line_break_not_permitted_here_1142", "Line break not permitted here."),
	        or_expected: diag(1144, ts.DiagnosticCategory.Error, "or_expected_1144", "'{' or ';' expected."),
	        Declaration_expected: diag(1146, ts.DiagnosticCategory.Error, "Declaration_expected_1146", "Declaration expected."),
	        Import_declarations_in_a_namespace_cannot_reference_a_module: diag(1147, ts.DiagnosticCategory.Error, "Import_declarations_in_a_namespace_cannot_reference_a_module_1147", "Import declarations in a namespace cannot reference a module."),
	        Cannot_use_imports_exports_or_module_augmentations_when_module_is_none: diag(1148, ts.DiagnosticCategory.Error, "Cannot_use_imports_exports_or_module_augmentations_when_module_is_none_1148", "Cannot use imports, exports, or module augmentations when '--module' is 'none'."),
	        File_name_0_differs_from_already_included_file_name_1_only_in_casing: diag(1149, ts.DiagnosticCategory.Error, "File_name_0_differs_from_already_included_file_name_1_only_in_casing_1149", "File name '{0}' differs from already included file name '{1}' only in casing."),
	        new_T_cannot_be_used_to_create_an_array_Use_new_Array_T_instead: diag(1150, ts.DiagnosticCategory.Error, "new_T_cannot_be_used_to_create_an_array_Use_new_Array_T_instead_1150", "'new T[]' cannot be used to create an array. Use 'new Array<T>()' instead."),
	        const_declarations_must_be_initialized: diag(1155, ts.DiagnosticCategory.Error, "const_declarations_must_be_initialized_1155", "'const' declarations must be initialized."),
	        const_declarations_can_only_be_declared_inside_a_block: diag(1156, ts.DiagnosticCategory.Error, "const_declarations_can_only_be_declared_inside_a_block_1156", "'const' declarations can only be declared inside a block."),
	        let_declarations_can_only_be_declared_inside_a_block: diag(1157, ts.DiagnosticCategory.Error, "let_declarations_can_only_be_declared_inside_a_block_1157", "'let' declarations can only be declared inside a block."),
	        Unterminated_template_literal: diag(1160, ts.DiagnosticCategory.Error, "Unterminated_template_literal_1160", "Unterminated template literal."),
	        Unterminated_regular_expression_literal: diag(1161, ts.DiagnosticCategory.Error, "Unterminated_regular_expression_literal_1161", "Unterminated regular expression literal."),
	        An_object_member_cannot_be_declared_optional: diag(1162, ts.DiagnosticCategory.Error, "An_object_member_cannot_be_declared_optional_1162", "An object member cannot be declared optional."),
	        A_yield_expression_is_only_allowed_in_a_generator_body: diag(1163, ts.DiagnosticCategory.Error, "A_yield_expression_is_only_allowed_in_a_generator_body_1163", "A 'yield' expression is only allowed in a generator body."),
	        Computed_property_names_are_not_allowed_in_enums: diag(1164, ts.DiagnosticCategory.Error, "Computed_property_names_are_not_allowed_in_enums_1164", "Computed property names are not allowed in enums."),
	        A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1165, ts.DiagnosticCategory.Error, "A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_t_1165", "A computed property name in an ambient context must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_computed_property_name_in_a_class_property_declaration_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1166, ts.DiagnosticCategory.Error, "A_computed_property_name_in_a_class_property_declaration_must_refer_to_an_expression_whose_type_is_a_1166", "A computed property name in a class property declaration must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1168, ts.DiagnosticCategory.Error, "A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_ty_1168", "A computed property name in a method overload must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1169, ts.DiagnosticCategory.Error, "A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_1169", "A computed property name in an interface must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1170, ts.DiagnosticCategory.Error, "A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type__1170", "A computed property name in a type literal must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_comma_expression_is_not_allowed_in_a_computed_property_name: diag(1171, ts.DiagnosticCategory.Error, "A_comma_expression_is_not_allowed_in_a_computed_property_name_1171", "A comma expression is not allowed in a computed property name."),
	        extends_clause_already_seen: diag(1172, ts.DiagnosticCategory.Error, "extends_clause_already_seen_1172", "'extends' clause already seen."),
	        extends_clause_must_precede_implements_clause: diag(1173, ts.DiagnosticCategory.Error, "extends_clause_must_precede_implements_clause_1173", "'extends' clause must precede 'implements' clause."),
	        Classes_can_only_extend_a_single_class: diag(1174, ts.DiagnosticCategory.Error, "Classes_can_only_extend_a_single_class_1174", "Classes can only extend a single class."),
	        implements_clause_already_seen: diag(1175, ts.DiagnosticCategory.Error, "implements_clause_already_seen_1175", "'implements' clause already seen."),
	        Interface_declaration_cannot_have_implements_clause: diag(1176, ts.DiagnosticCategory.Error, "Interface_declaration_cannot_have_implements_clause_1176", "Interface declaration cannot have 'implements' clause."),
	        Binary_digit_expected: diag(1177, ts.DiagnosticCategory.Error, "Binary_digit_expected_1177", "Binary digit expected."),
	        Octal_digit_expected: diag(1178, ts.DiagnosticCategory.Error, "Octal_digit_expected_1178", "Octal digit expected."),
	        Unexpected_token_expected: diag(1179, ts.DiagnosticCategory.Error, "Unexpected_token_expected_1179", "Unexpected token. '{' expected."),
	        Property_destructuring_pattern_expected: diag(1180, ts.DiagnosticCategory.Error, "Property_destructuring_pattern_expected_1180", "Property destructuring pattern expected."),
	        Array_element_destructuring_pattern_expected: diag(1181, ts.DiagnosticCategory.Error, "Array_element_destructuring_pattern_expected_1181", "Array element destructuring pattern expected."),
	        A_destructuring_declaration_must_have_an_initializer: diag(1182, ts.DiagnosticCategory.Error, "A_destructuring_declaration_must_have_an_initializer_1182", "A destructuring declaration must have an initializer."),
	        An_implementation_cannot_be_declared_in_ambient_contexts: diag(1183, ts.DiagnosticCategory.Error, "An_implementation_cannot_be_declared_in_ambient_contexts_1183", "An implementation cannot be declared in ambient contexts."),
	        Modifiers_cannot_appear_here: diag(1184, ts.DiagnosticCategory.Error, "Modifiers_cannot_appear_here_1184", "Modifiers cannot appear here."),
	        Merge_conflict_marker_encountered: diag(1185, ts.DiagnosticCategory.Error, "Merge_conflict_marker_encountered_1185", "Merge conflict marker encountered."),
	        A_rest_element_cannot_have_an_initializer: diag(1186, ts.DiagnosticCategory.Error, "A_rest_element_cannot_have_an_initializer_1186", "A rest element cannot have an initializer."),
	        A_parameter_property_may_not_be_declared_using_a_binding_pattern: diag(1187, ts.DiagnosticCategory.Error, "A_parameter_property_may_not_be_declared_using_a_binding_pattern_1187", "A parameter property may not be declared using a binding pattern."),
	        Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement: diag(1188, ts.DiagnosticCategory.Error, "Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement_1188", "Only a single variable declaration is allowed in a 'for...of' statement."),
	        The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer: diag(1189, ts.DiagnosticCategory.Error, "The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer_1189", "The variable declaration of a 'for...in' statement cannot have an initializer."),
	        The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer: diag(1190, ts.DiagnosticCategory.Error, "The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer_1190", "The variable declaration of a 'for...of' statement cannot have an initializer."),
	        An_import_declaration_cannot_have_modifiers: diag(1191, ts.DiagnosticCategory.Error, "An_import_declaration_cannot_have_modifiers_1191", "An import declaration cannot have modifiers."),
	        Module_0_has_no_default_export: diag(1192, ts.DiagnosticCategory.Error, "Module_0_has_no_default_export_1192", "Module '{0}' has no default export."),
	        An_export_declaration_cannot_have_modifiers: diag(1193, ts.DiagnosticCategory.Error, "An_export_declaration_cannot_have_modifiers_1193", "An export declaration cannot have modifiers."),
	        Export_declarations_are_not_permitted_in_a_namespace: diag(1194, ts.DiagnosticCategory.Error, "Export_declarations_are_not_permitted_in_a_namespace_1194", "Export declarations are not permitted in a namespace."),
	        Catch_clause_variable_cannot_have_a_type_annotation: diag(1196, ts.DiagnosticCategory.Error, "Catch_clause_variable_cannot_have_a_type_annotation_1196", "Catch clause variable cannot have a type annotation."),
	        Catch_clause_variable_cannot_have_an_initializer: diag(1197, ts.DiagnosticCategory.Error, "Catch_clause_variable_cannot_have_an_initializer_1197", "Catch clause variable cannot have an initializer."),
	        An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive: diag(1198, ts.DiagnosticCategory.Error, "An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive_1198", "An extended Unicode escape value must be between 0x0 and 0x10FFFF inclusive."),
	        Unterminated_Unicode_escape_sequence: diag(1199, ts.DiagnosticCategory.Error, "Unterminated_Unicode_escape_sequence_1199", "Unterminated Unicode escape sequence."),
	        Line_terminator_not_permitted_before_arrow: diag(1200, ts.DiagnosticCategory.Error, "Line_terminator_not_permitted_before_arrow_1200", "Line terminator not permitted before arrow."),
	        Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_ns_from_mod_import_a_from_mod_import_d_from_mod_or_another_module_format_instead: diag(1202, ts.DiagnosticCategory.Error, "Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_1202", "Import assignment cannot be used when targeting ECMAScript modules. Consider using 'import * as ns from \"mod\"', 'import {a} from \"mod\"', 'import d from \"mod\"', or another module format instead."),
	        Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or_another_module_format_instead: diag(1203, ts.DiagnosticCategory.Error, "Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or__1203", "Export assignment cannot be used when targeting ECMAScript modules. Consider using 'export default' or another module format instead."),
	        Cannot_re_export_a_type_when_the_isolatedModules_flag_is_provided: diag(1205, ts.DiagnosticCategory.Error, "Cannot_re_export_a_type_when_the_isolatedModules_flag_is_provided_1205", "Cannot re-export a type when the '--isolatedModules' flag is provided."),
	        Decorators_are_not_valid_here: diag(1206, ts.DiagnosticCategory.Error, "Decorators_are_not_valid_here_1206", "Decorators are not valid here."),
	        Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name: diag(1207, ts.DiagnosticCategory.Error, "Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name_1207", "Decorators cannot be applied to multiple get/set accessors of the same name."),
	        Cannot_compile_namespaces_when_the_isolatedModules_flag_is_provided: diag(1208, ts.DiagnosticCategory.Error, "Cannot_compile_namespaces_when_the_isolatedModules_flag_is_provided_1208", "Cannot compile namespaces when the '--isolatedModules' flag is provided."),
	        Ambient_const_enums_are_not_allowed_when_the_isolatedModules_flag_is_provided: diag(1209, ts.DiagnosticCategory.Error, "Ambient_const_enums_are_not_allowed_when_the_isolatedModules_flag_is_provided_1209", "Ambient const enums are not allowed when the '--isolatedModules' flag is provided."),
	        Invalid_use_of_0_Class_definitions_are_automatically_in_strict_mode: diag(1210, ts.DiagnosticCategory.Error, "Invalid_use_of_0_Class_definitions_are_automatically_in_strict_mode_1210", "Invalid use of '{0}'. Class definitions are automatically in strict mode."),
	        A_class_declaration_without_the_default_modifier_must_have_a_name: diag(1211, ts.DiagnosticCategory.Error, "A_class_declaration_without_the_default_modifier_must_have_a_name_1211", "A class declaration without the 'default' modifier must have a name."),
	        Identifier_expected_0_is_a_reserved_word_in_strict_mode: diag(1212, ts.DiagnosticCategory.Error, "Identifier_expected_0_is_a_reserved_word_in_strict_mode_1212", "Identifier expected. '{0}' is a reserved word in strict mode."),
	        Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_strict_mode: diag(1213, ts.DiagnosticCategory.Error, "Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_stric_1213", "Identifier expected. '{0}' is a reserved word in strict mode. Class definitions are automatically in strict mode."),
	        Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode: diag(1214, ts.DiagnosticCategory.Error, "Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode_1214", "Identifier expected. '{0}' is a reserved word in strict mode. Modules are automatically in strict mode."),
	        Invalid_use_of_0_Modules_are_automatically_in_strict_mode: diag(1215, ts.DiagnosticCategory.Error, "Invalid_use_of_0_Modules_are_automatically_in_strict_mode_1215", "Invalid use of '{0}'. Modules are automatically in strict mode."),
	        Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules: diag(1216, ts.DiagnosticCategory.Error, "Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules_1216", "Identifier expected. '__esModule' is reserved as an exported marker when transforming ECMAScript modules."),
	        Export_assignment_is_not_supported_when_module_flag_is_system: diag(1218, ts.DiagnosticCategory.Error, "Export_assignment_is_not_supported_when_module_flag_is_system_1218", "Export assignment is not supported when '--module' flag is 'system'."),
	        Experimental_support_for_decorators_is_a_feature_that_is_subject_to_change_in_a_future_release_Set_the_experimentalDecorators_option_to_remove_this_warning: diag(1219, ts.DiagnosticCategory.Error, "Experimental_support_for_decorators_is_a_feature_that_is_subject_to_change_in_a_future_release_Set_t_1219", "Experimental support for decorators is a feature that is subject to change in a future release. Set the 'experimentalDecorators' option to remove this warning."),
	        Generators_are_only_available_when_targeting_ECMAScript_2015_or_higher: diag(1220, ts.DiagnosticCategory.Error, "Generators_are_only_available_when_targeting_ECMAScript_2015_or_higher_1220", "Generators are only available when targeting ECMAScript 2015 or higher."),
	        Generators_are_not_allowed_in_an_ambient_context: diag(1221, ts.DiagnosticCategory.Error, "Generators_are_not_allowed_in_an_ambient_context_1221", "Generators are not allowed in an ambient context."),
	        An_overload_signature_cannot_be_declared_as_a_generator: diag(1222, ts.DiagnosticCategory.Error, "An_overload_signature_cannot_be_declared_as_a_generator_1222", "An overload signature cannot be declared as a generator."),
	        _0_tag_already_specified: diag(1223, ts.DiagnosticCategory.Error, "_0_tag_already_specified_1223", "'{0}' tag already specified."),
	        Signature_0_must_be_a_type_predicate: diag(1224, ts.DiagnosticCategory.Error, "Signature_0_must_be_a_type_predicate_1224", "Signature '{0}' must be a type predicate."),
	        Cannot_find_parameter_0: diag(1225, ts.DiagnosticCategory.Error, "Cannot_find_parameter_0_1225", "Cannot find parameter '{0}'."),
	        Type_predicate_0_is_not_assignable_to_1: diag(1226, ts.DiagnosticCategory.Error, "Type_predicate_0_is_not_assignable_to_1_1226", "Type predicate '{0}' is not assignable to '{1}'."),
	        Parameter_0_is_not_in_the_same_position_as_parameter_1: diag(1227, ts.DiagnosticCategory.Error, "Parameter_0_is_not_in_the_same_position_as_parameter_1_1227", "Parameter '{0}' is not in the same position as parameter '{1}'."),
	        A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods: diag(1228, ts.DiagnosticCategory.Error, "A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods_1228", "A type predicate is only allowed in return type position for functions and methods."),
	        A_type_predicate_cannot_reference_a_rest_parameter: diag(1229, ts.DiagnosticCategory.Error, "A_type_predicate_cannot_reference_a_rest_parameter_1229", "A type predicate cannot reference a rest parameter."),
	        A_type_predicate_cannot_reference_element_0_in_a_binding_pattern: diag(1230, ts.DiagnosticCategory.Error, "A_type_predicate_cannot_reference_element_0_in_a_binding_pattern_1230", "A type predicate cannot reference element '{0}' in a binding pattern."),
	        An_export_assignment_can_only_be_used_in_a_module: diag(1231, ts.DiagnosticCategory.Error, "An_export_assignment_can_only_be_used_in_a_module_1231", "An export assignment can only be used in a module."),
	        An_import_declaration_can_only_be_used_in_a_namespace_or_module: diag(1232, ts.DiagnosticCategory.Error, "An_import_declaration_can_only_be_used_in_a_namespace_or_module_1232", "An import declaration can only be used in a namespace or module."),
	        An_export_declaration_can_only_be_used_in_a_module: diag(1233, ts.DiagnosticCategory.Error, "An_export_declaration_can_only_be_used_in_a_module_1233", "An export declaration can only be used in a module."),
	        An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file: diag(1234, ts.DiagnosticCategory.Error, "An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file_1234", "An ambient module declaration is only allowed at the top level in a file."),
	        A_namespace_declaration_is_only_allowed_in_a_namespace_or_module: diag(1235, ts.DiagnosticCategory.Error, "A_namespace_declaration_is_only_allowed_in_a_namespace_or_module_1235", "A namespace declaration is only allowed in a namespace or module."),
	        The_return_type_of_a_property_decorator_function_must_be_either_void_or_any: diag(1236, ts.DiagnosticCategory.Error, "The_return_type_of_a_property_decorator_function_must_be_either_void_or_any_1236", "The return type of a property decorator function must be either 'void' or 'any'."),
	        The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any: diag(1237, ts.DiagnosticCategory.Error, "The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any_1237", "The return type of a parameter decorator function must be either 'void' or 'any'."),
	        Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression: diag(1238, ts.DiagnosticCategory.Error, "Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression_1238", "Unable to resolve signature of class decorator when called as an expression."),
	        Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression: diag(1239, ts.DiagnosticCategory.Error, "Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression_1239", "Unable to resolve signature of parameter decorator when called as an expression."),
	        Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression: diag(1240, ts.DiagnosticCategory.Error, "Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression_1240", "Unable to resolve signature of property decorator when called as an expression."),
	        Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression: diag(1241, ts.DiagnosticCategory.Error, "Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression_1241", "Unable to resolve signature of method decorator when called as an expression."),
	        abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration: diag(1242, ts.DiagnosticCategory.Error, "abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration_1242", "'abstract' modifier can only appear on a class, method, or property declaration."),
	        _0_modifier_cannot_be_used_with_1_modifier: diag(1243, ts.DiagnosticCategory.Error, "_0_modifier_cannot_be_used_with_1_modifier_1243", "'{0}' modifier cannot be used with '{1}' modifier."),
	        Abstract_methods_can_only_appear_within_an_abstract_class: diag(1244, ts.DiagnosticCategory.Error, "Abstract_methods_can_only_appear_within_an_abstract_class_1244", "Abstract methods can only appear within an abstract class."),
	        Method_0_cannot_have_an_implementation_because_it_is_marked_abstract: diag(1245, ts.DiagnosticCategory.Error, "Method_0_cannot_have_an_implementation_because_it_is_marked_abstract_1245", "Method '{0}' cannot have an implementation because it is marked abstract."),
	        An_interface_property_cannot_have_an_initializer: diag(1246, ts.DiagnosticCategory.Error, "An_interface_property_cannot_have_an_initializer_1246", "An interface property cannot have an initializer."),
	        A_type_literal_property_cannot_have_an_initializer: diag(1247, ts.DiagnosticCategory.Error, "A_type_literal_property_cannot_have_an_initializer_1247", "A type literal property cannot have an initializer."),
	        A_class_member_cannot_have_the_0_keyword: diag(1248, ts.DiagnosticCategory.Error, "A_class_member_cannot_have_the_0_keyword_1248", "A class member cannot have the '{0}' keyword."),
	        A_decorator_can_only_decorate_a_method_implementation_not_an_overload: diag(1249, ts.DiagnosticCategory.Error, "A_decorator_can_only_decorate_a_method_implementation_not_an_overload_1249", "A decorator can only decorate a method implementation, not an overload."),
	        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5: diag(1250, ts.DiagnosticCategory.Error, "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_1250", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'."),
	        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_definitions_are_automatically_in_strict_mode: diag(1251, ts.DiagnosticCategory.Error, "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_d_1251", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'. Class definitions are automatically in strict mode."),
	        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_are_automatically_in_strict_mode: diag(1252, ts.DiagnosticCategory.Error, "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_1252", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'. Modules are automatically in strict mode."),
	        _0_tag_cannot_be_used_independently_as_a_top_level_JSDoc_tag: diag(1253, ts.DiagnosticCategory.Error, "_0_tag_cannot_be_used_independently_as_a_top_level_JSDoc_tag_1253", "'{0}' tag cannot be used independently as a top level JSDoc tag."),
	        A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal: diag(1254, ts.DiagnosticCategory.Error, "A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal_1254", "A 'const' initializer in an ambient context must be a string or numeric literal."),
	        A_definite_assignment_assertion_is_not_permitted_in_this_context: diag(1255, ts.DiagnosticCategory.Error, "A_definite_assignment_assertion_is_not_permitted_in_this_context_1255", "A definite assignment assertion '!' is not permitted in this context."),
	        with_statements_are_not_allowed_in_an_async_function_block: diag(1300, ts.DiagnosticCategory.Error, "with_statements_are_not_allowed_in_an_async_function_block_1300", "'with' statements are not allowed in an async function block."),
	        await_expression_is_only_allowed_within_an_async_function: diag(1308, ts.DiagnosticCategory.Error, "await_expression_is_only_allowed_within_an_async_function_1308", "'await' expression is only allowed within an async function."),
	        can_only_be_used_in_an_object_literal_property_inside_a_destructuring_assignment: diag(1312, ts.DiagnosticCategory.Error, "can_only_be_used_in_an_object_literal_property_inside_a_destructuring_assignment_1312", "'=' can only be used in an object literal property inside a destructuring assignment."),
	        The_body_of_an_if_statement_cannot_be_the_empty_statement: diag(1313, ts.DiagnosticCategory.Error, "The_body_of_an_if_statement_cannot_be_the_empty_statement_1313", "The body of an 'if' statement cannot be the empty statement."),
	        Global_module_exports_may_only_appear_in_module_files: diag(1314, ts.DiagnosticCategory.Error, "Global_module_exports_may_only_appear_in_module_files_1314", "Global module exports may only appear in module files."),
	        Global_module_exports_may_only_appear_in_declaration_files: diag(1315, ts.DiagnosticCategory.Error, "Global_module_exports_may_only_appear_in_declaration_files_1315", "Global module exports may only appear in declaration files."),
	        Global_module_exports_may_only_appear_at_top_level: diag(1316, ts.DiagnosticCategory.Error, "Global_module_exports_may_only_appear_at_top_level_1316", "Global module exports may only appear at top level."),
	        A_parameter_property_cannot_be_declared_using_a_rest_parameter: diag(1317, ts.DiagnosticCategory.Error, "A_parameter_property_cannot_be_declared_using_a_rest_parameter_1317", "A parameter property cannot be declared using a rest parameter."),
	        An_abstract_accessor_cannot_have_an_implementation: diag(1318, ts.DiagnosticCategory.Error, "An_abstract_accessor_cannot_have_an_implementation_1318", "An abstract accessor cannot have an implementation."),
	        A_default_export_can_only_be_used_in_an_ECMAScript_style_module: diag(1319, ts.DiagnosticCategory.Error, "A_default_export_can_only_be_used_in_an_ECMAScript_style_module_1319", "A default export can only be used in an ECMAScript-style module."),
	        Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1320, ts.DiagnosticCategory.Error, "Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member_1320", "Type of 'await' operand must either be a valid promise or must not contain a callable 'then' member."),
	        Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1321, ts.DiagnosticCategory.Error, "Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_cal_1321", "Type of 'yield' operand in an async generator must either be a valid promise or must not contain a callable 'then' member."),
	        Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1322, ts.DiagnosticCategory.Error, "Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_con_1322", "Type of iterated elements of a 'yield*' operand must either be a valid promise or must not contain a callable 'then' member."),
	        Dynamic_import_cannot_be_used_when_targeting_ECMAScript_2015_modules: diag(1323, ts.DiagnosticCategory.Error, "Dynamic_import_cannot_be_used_when_targeting_ECMAScript_2015_modules_1323", "Dynamic import cannot be used when targeting ECMAScript 2015 modules."),
	        Dynamic_import_must_have_one_specifier_as_an_argument: diag(1324, ts.DiagnosticCategory.Error, "Dynamic_import_must_have_one_specifier_as_an_argument_1324", "Dynamic import must have one specifier as an argument."),
	        Specifier_of_dynamic_import_cannot_be_spread_element: diag(1325, ts.DiagnosticCategory.Error, "Specifier_of_dynamic_import_cannot_be_spread_element_1325", "Specifier of dynamic import cannot be spread element."),
	        Dynamic_import_cannot_have_type_arguments: diag(1326, ts.DiagnosticCategory.Error, "Dynamic_import_cannot_have_type_arguments_1326", "Dynamic import cannot have type arguments"),
	        String_literal_with_double_quotes_expected: diag(1327, ts.DiagnosticCategory.Error, "String_literal_with_double_quotes_expected_1327", "String literal with double quotes expected."),
	        Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_literal: diag(1328, ts.DiagnosticCategory.Error, "Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_li_1328", "Property value can only be string literal, numeric literal, 'true', 'false', 'null', object literal or array literal."),
	        _0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0: diag(1329, ts.DiagnosticCategory.Error, "_0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write__1329", "'{0}' accepts too few arguments to be used as a decorator here. Did you mean to call it first and write '@{0}()'?"),
	        A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly: diag(1330, ts.DiagnosticCategory.Error, "A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly_1330", "A property of an interface or type literal whose type is a 'unique symbol' type must be 'readonly'."),
	        A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly: diag(1331, ts.DiagnosticCategory.Error, "A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly_1331", "A property of a class whose type is a 'unique symbol' type must be both 'static' and 'readonly'."),
	        A_variable_whose_type_is_a_unique_symbol_type_must_be_const: diag(1332, ts.DiagnosticCategory.Error, "A_variable_whose_type_is_a_unique_symbol_type_must_be_const_1332", "A variable whose type is a 'unique symbol' type must be 'const'."),
	        unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name: diag(1333, ts.DiagnosticCategory.Error, "unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name_1333", "'unique symbol' types may not be used on a variable declaration with a binding name."),
	        unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement: diag(1334, ts.DiagnosticCategory.Error, "unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement_1334", "'unique symbol' types are only allowed on variables in a variable statement."),
	        unique_symbol_types_are_not_allowed_here: diag(1335, ts.DiagnosticCategory.Error, "unique_symbol_types_are_not_allowed_here_1335", "'unique symbol' types are not allowed here."),
	        An_index_signature_parameter_type_cannot_be_a_type_alias_Consider_writing_0_Colon_1_Colon_2_instead: diag(1336, ts.DiagnosticCategory.Error, "An_index_signature_parameter_type_cannot_be_a_type_alias_Consider_writing_0_Colon_1_Colon_2_instead_1336", "An index signature parameter type cannot be a type alias. Consider writing '[{0}: {1}]: {2}' instead."),
	        An_index_signature_parameter_type_cannot_be_a_union_type_Consider_using_a_mapped_object_type_instead: diag(1337, ts.DiagnosticCategory.Error, "An_index_signature_parameter_type_cannot_be_a_union_type_Consider_using_a_mapped_object_type_instead_1337", "An index signature parameter type cannot be a union type. Consider using a mapped object type instead."),
	        infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type: diag(1338, ts.DiagnosticCategory.Error, "infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type_1338", "'infer' declarations are only permitted in the 'extends' clause of a conditional type."),
	        Duplicate_identifier_0: diag(2300, ts.DiagnosticCategory.Error, "Duplicate_identifier_0_2300", "Duplicate identifier '{0}'."),
	        Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor: diag(2301, ts.DiagnosticCategory.Error, "Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor_2301", "Initializer of instance member variable '{0}' cannot reference identifier '{1}' declared in the constructor."),
	        Static_members_cannot_reference_class_type_parameters: diag(2302, ts.DiagnosticCategory.Error, "Static_members_cannot_reference_class_type_parameters_2302", "Static members cannot reference class type parameters."),
	        Circular_definition_of_import_alias_0: diag(2303, ts.DiagnosticCategory.Error, "Circular_definition_of_import_alias_0_2303", "Circular definition of import alias '{0}'."),
	        Cannot_find_name_0: diag(2304, ts.DiagnosticCategory.Error, "Cannot_find_name_0_2304", "Cannot find name '{0}'."),
	        Module_0_has_no_exported_member_1: diag(2305, ts.DiagnosticCategory.Error, "Module_0_has_no_exported_member_1_2305", "Module '{0}' has no exported member '{1}'."),
	        File_0_is_not_a_module: diag(2306, ts.DiagnosticCategory.Error, "File_0_is_not_a_module_2306", "File '{0}' is not a module."),
	        Cannot_find_module_0: diag(2307, ts.DiagnosticCategory.Error, "Cannot_find_module_0_2307", "Cannot find module '{0}'."),
	        Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambiguity: diag(2308, ts.DiagnosticCategory.Error, "Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambig_2308", "Module {0} has already exported a member named '{1}'. Consider explicitly re-exporting to resolve the ambiguity."),
	        An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements: diag(2309, ts.DiagnosticCategory.Error, "An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements_2309", "An export assignment cannot be used in a module with other exported elements."),
	        Type_0_recursively_references_itself_as_a_base_type: diag(2310, ts.DiagnosticCategory.Error, "Type_0_recursively_references_itself_as_a_base_type_2310", "Type '{0}' recursively references itself as a base type."),
	        A_class_may_only_extend_another_class: diag(2311, ts.DiagnosticCategory.Error, "A_class_may_only_extend_another_class_2311", "A class may only extend another class."),
	        An_interface_may_only_extend_a_class_or_another_interface: diag(2312, ts.DiagnosticCategory.Error, "An_interface_may_only_extend_a_class_or_another_interface_2312", "An interface may only extend a class or another interface."),
	        Type_parameter_0_has_a_circular_constraint: diag(2313, ts.DiagnosticCategory.Error, "Type_parameter_0_has_a_circular_constraint_2313", "Type parameter '{0}' has a circular constraint."),
	        Generic_type_0_requires_1_type_argument_s: diag(2314, ts.DiagnosticCategory.Error, "Generic_type_0_requires_1_type_argument_s_2314", "Generic type '{0}' requires {1} type argument(s)."),
	        Type_0_is_not_generic: diag(2315, ts.DiagnosticCategory.Error, "Type_0_is_not_generic_2315", "Type '{0}' is not generic."),
	        Global_type_0_must_be_a_class_or_interface_type: diag(2316, ts.DiagnosticCategory.Error, "Global_type_0_must_be_a_class_or_interface_type_2316", "Global type '{0}' must be a class or interface type."),
	        Global_type_0_must_have_1_type_parameter_s: diag(2317, ts.DiagnosticCategory.Error, "Global_type_0_must_have_1_type_parameter_s_2317", "Global type '{0}' must have {1} type parameter(s)."),
	        Cannot_find_global_type_0: diag(2318, ts.DiagnosticCategory.Error, "Cannot_find_global_type_0_2318", "Cannot find global type '{0}'."),
	        Named_property_0_of_types_1_and_2_are_not_identical: diag(2319, ts.DiagnosticCategory.Error, "Named_property_0_of_types_1_and_2_are_not_identical_2319", "Named property '{0}' of types '{1}' and '{2}' are not identical."),
	        Interface_0_cannot_simultaneously_extend_types_1_and_2: diag(2320, ts.DiagnosticCategory.Error, "Interface_0_cannot_simultaneously_extend_types_1_and_2_2320", "Interface '{0}' cannot simultaneously extend types '{1}' and '{2}'."),
	        Excessive_stack_depth_comparing_types_0_and_1: diag(2321, ts.DiagnosticCategory.Error, "Excessive_stack_depth_comparing_types_0_and_1_2321", "Excessive stack depth comparing types '{0}' and '{1}'."),
	        Type_0_is_not_assignable_to_type_1: diag(2322, ts.DiagnosticCategory.Error, "Type_0_is_not_assignable_to_type_1_2322", "Type '{0}' is not assignable to type '{1}'."),
	        Cannot_redeclare_exported_variable_0: diag(2323, ts.DiagnosticCategory.Error, "Cannot_redeclare_exported_variable_0_2323", "Cannot redeclare exported variable '{0}'."),
	        Property_0_is_missing_in_type_1: diag(2324, ts.DiagnosticCategory.Error, "Property_0_is_missing_in_type_1_2324", "Property '{0}' is missing in type '{1}'."),
	        Property_0_is_private_in_type_1_but_not_in_type_2: diag(2325, ts.DiagnosticCategory.Error, "Property_0_is_private_in_type_1_but_not_in_type_2_2325", "Property '{0}' is private in type '{1}' but not in type '{2}'."),
	        Types_of_property_0_are_incompatible: diag(2326, ts.DiagnosticCategory.Error, "Types_of_property_0_are_incompatible_2326", "Types of property '{0}' are incompatible."),
	        Property_0_is_optional_in_type_1_but_required_in_type_2: diag(2327, ts.DiagnosticCategory.Error, "Property_0_is_optional_in_type_1_but_required_in_type_2_2327", "Property '{0}' is optional in type '{1}' but required in type '{2}'."),
	        Types_of_parameters_0_and_1_are_incompatible: diag(2328, ts.DiagnosticCategory.Error, "Types_of_parameters_0_and_1_are_incompatible_2328", "Types of parameters '{0}' and '{1}' are incompatible."),
	        Index_signature_is_missing_in_type_0: diag(2329, ts.DiagnosticCategory.Error, "Index_signature_is_missing_in_type_0_2329", "Index signature is missing in type '{0}'."),
	        Index_signatures_are_incompatible: diag(2330, ts.DiagnosticCategory.Error, "Index_signatures_are_incompatible_2330", "Index signatures are incompatible."),
	        this_cannot_be_referenced_in_a_module_or_namespace_body: diag(2331, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_a_module_or_namespace_body_2331", "'this' cannot be referenced in a module or namespace body."),
	        this_cannot_be_referenced_in_current_location: diag(2332, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_current_location_2332", "'this' cannot be referenced in current location."),
	        this_cannot_be_referenced_in_constructor_arguments: diag(2333, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_constructor_arguments_2333", "'this' cannot be referenced in constructor arguments."),
	        this_cannot_be_referenced_in_a_static_property_initializer: diag(2334, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_a_static_property_initializer_2334", "'this' cannot be referenced in a static property initializer."),
	        super_can_only_be_referenced_in_a_derived_class: diag(2335, ts.DiagnosticCategory.Error, "super_can_only_be_referenced_in_a_derived_class_2335", "'super' can only be referenced in a derived class."),
	        super_cannot_be_referenced_in_constructor_arguments: diag(2336, ts.DiagnosticCategory.Error, "super_cannot_be_referenced_in_constructor_arguments_2336", "'super' cannot be referenced in constructor arguments."),
	        Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors: diag(2337, ts.DiagnosticCategory.Error, "Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors_2337", "Super calls are not permitted outside constructors or in nested functions inside constructors."),
	        super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_derived_class: diag(2338, ts.DiagnosticCategory.Error, "super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_der_2338", "'super' property access is permitted only in a constructor, member function, or member accessor of a derived class."),
	        Property_0_does_not_exist_on_type_1: diag(2339, ts.DiagnosticCategory.Error, "Property_0_does_not_exist_on_type_1_2339", "Property '{0}' does not exist on type '{1}'."),
	        Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword: diag(2340, ts.DiagnosticCategory.Error, "Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword_2340", "Only public and protected methods of the base class are accessible via the 'super' keyword."),
	        Property_0_is_private_and_only_accessible_within_class_1: diag(2341, ts.DiagnosticCategory.Error, "Property_0_is_private_and_only_accessible_within_class_1_2341", "Property '{0}' is private and only accessible within class '{1}'."),
	        An_index_expression_argument_must_be_of_type_string_number_symbol_or_any: diag(2342, ts.DiagnosticCategory.Error, "An_index_expression_argument_must_be_of_type_string_number_symbol_or_any_2342", "An index expression argument must be of type 'string', 'number', 'symbol', or 'any'."),
	        This_syntax_requires_an_imported_helper_named_1_but_module_0_has_no_exported_member_1: diag(2343, ts.DiagnosticCategory.Error, "This_syntax_requires_an_imported_helper_named_1_but_module_0_has_no_exported_member_1_2343", "This syntax requires an imported helper named '{1}', but module '{0}' has no exported member '{1}'."),
	        Type_0_does_not_satisfy_the_constraint_1: diag(2344, ts.DiagnosticCategory.Error, "Type_0_does_not_satisfy_the_constraint_1_2344", "Type '{0}' does not satisfy the constraint '{1}'."),
	        Argument_of_type_0_is_not_assignable_to_parameter_of_type_1: diag(2345, ts.DiagnosticCategory.Error, "Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_2345", "Argument of type '{0}' is not assignable to parameter of type '{1}'."),
	        Call_target_does_not_contain_any_signatures: diag(2346, ts.DiagnosticCategory.Error, "Call_target_does_not_contain_any_signatures_2346", "Call target does not contain any signatures."),
	        Untyped_function_calls_may_not_accept_type_arguments: diag(2347, ts.DiagnosticCategory.Error, "Untyped_function_calls_may_not_accept_type_arguments_2347", "Untyped function calls may not accept type arguments."),
	        Value_of_type_0_is_not_callable_Did_you_mean_to_include_new: diag(2348, ts.DiagnosticCategory.Error, "Value_of_type_0_is_not_callable_Did_you_mean_to_include_new_2348", "Value of type '{0}' is not callable. Did you mean to include 'new'?"),
	        Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures: diag(2349, ts.DiagnosticCategory.Error, "Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatur_2349", "Cannot invoke an expression whose type lacks a call signature. Type '{0}' has no compatible call signatures."),
	        Only_a_void_function_can_be_called_with_the_new_keyword: diag(2350, ts.DiagnosticCategory.Error, "Only_a_void_function_can_be_called_with_the_new_keyword_2350", "Only a void function can be called with the 'new' keyword."),
	        Cannot_use_new_with_an_expression_whose_type_lacks_a_call_or_construct_signature: diag(2351, ts.DiagnosticCategory.Error, "Cannot_use_new_with_an_expression_whose_type_lacks_a_call_or_construct_signature_2351", "Cannot use 'new' with an expression whose type lacks a call or construct signature."),
	        Type_0_cannot_be_converted_to_type_1: diag(2352, ts.DiagnosticCategory.Error, "Type_0_cannot_be_converted_to_type_1_2352", "Type '{0}' cannot be converted to type '{1}'."),
	        Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1: diag(2353, ts.DiagnosticCategory.Error, "Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1_2353", "Object literal may only specify known properties, and '{0}' does not exist in type '{1}'."),
	        This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found: diag(2354, ts.DiagnosticCategory.Error, "This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found_2354", "This syntax requires an imported helper but module '{0}' cannot be found."),
	        A_function_whose_declared_type_is_neither_void_nor_any_must_return_a_value: diag(2355, ts.DiagnosticCategory.Error, "A_function_whose_declared_type_is_neither_void_nor_any_must_return_a_value_2355", "A function whose declared type is neither 'void' nor 'any' must return a value."),
	        An_arithmetic_operand_must_be_of_type_any_number_or_an_enum_type: diag(2356, ts.DiagnosticCategory.Error, "An_arithmetic_operand_must_be_of_type_any_number_or_an_enum_type_2356", "An arithmetic operand must be of type 'any', 'number' or an enum type."),
	        The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access: diag(2357, ts.DiagnosticCategory.Error, "The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access_2357", "The operand of an increment or decrement operator must be a variable or a property access."),
	        The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_parameter: diag(2358, ts.DiagnosticCategory.Error, "The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_paramete_2358", "The left-hand side of an 'instanceof' expression must be of type 'any', an object type or a type parameter."),
	        The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_Function_interface_type: diag(2359, ts.DiagnosticCategory.Error, "The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_F_2359", "The right-hand side of an 'instanceof' expression must be of type 'any' or of a type assignable to the 'Function' interface type."),
	        The_left_hand_side_of_an_in_expression_must_be_of_type_any_string_number_or_symbol: diag(2360, ts.DiagnosticCategory.Error, "The_left_hand_side_of_an_in_expression_must_be_of_type_any_string_number_or_symbol_2360", "The left-hand side of an 'in' expression must be of type 'any', 'string', 'number', or 'symbol'."),
	        The_right_hand_side_of_an_in_expression_must_be_of_type_any_an_object_type_or_a_type_parameter: diag(2361, ts.DiagnosticCategory.Error, "The_right_hand_side_of_an_in_expression_must_be_of_type_any_an_object_type_or_a_type_parameter_2361", "The right-hand side of an 'in' expression must be of type 'any', an object type or a type parameter."),
	        The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type: diag(2362, ts.DiagnosticCategory.Error, "The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type_2362", "The left-hand side of an arithmetic operation must be of type 'any', 'number' or an enum type."),
	        The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type: diag(2363, ts.DiagnosticCategory.Error, "The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type_2363", "The right-hand side of an arithmetic operation must be of type 'any', 'number' or an enum type."),
	        The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access: diag(2364, ts.DiagnosticCategory.Error, "The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access_2364", "The left-hand side of an assignment expression must be a variable or a property access."),
	        Operator_0_cannot_be_applied_to_types_1_and_2: diag(2365, ts.DiagnosticCategory.Error, "Operator_0_cannot_be_applied_to_types_1_and_2_2365", "Operator '{0}' cannot be applied to types '{1}' and '{2}'."),
	        Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined: diag(2366, ts.DiagnosticCategory.Error, "Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined_2366", "Function lacks ending return statement and return type does not include 'undefined'."),
	        Type_parameter_name_cannot_be_0: diag(2368, ts.DiagnosticCategory.Error, "Type_parameter_name_cannot_be_0_2368", "Type parameter name cannot be '{0}'."),
	        A_parameter_property_is_only_allowed_in_a_constructor_implementation: diag(2369, ts.DiagnosticCategory.Error, "A_parameter_property_is_only_allowed_in_a_constructor_implementation_2369", "A parameter property is only allowed in a constructor implementation."),
	        A_rest_parameter_must_be_of_an_array_type: diag(2370, ts.DiagnosticCategory.Error, "A_rest_parameter_must_be_of_an_array_type_2370", "A rest parameter must be of an array type."),
	        A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation: diag(2371, ts.DiagnosticCategory.Error, "A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation_2371", "A parameter initializer is only allowed in a function or constructor implementation."),
	        Parameter_0_cannot_be_referenced_in_its_initializer: diag(2372, ts.DiagnosticCategory.Error, "Parameter_0_cannot_be_referenced_in_its_initializer_2372", "Parameter '{0}' cannot be referenced in its initializer."),
	        Initializer_of_parameter_0_cannot_reference_identifier_1_declared_after_it: diag(2373, ts.DiagnosticCategory.Error, "Initializer_of_parameter_0_cannot_reference_identifier_1_declared_after_it_2373", "Initializer of parameter '{0}' cannot reference identifier '{1}' declared after it."),
	        Duplicate_string_index_signature: diag(2374, ts.DiagnosticCategory.Error, "Duplicate_string_index_signature_2374", "Duplicate string index signature."),
	        Duplicate_number_index_signature: diag(2375, ts.DiagnosticCategory.Error, "Duplicate_number_index_signature_2375", "Duplicate number index signature."),
	        A_super_call_must_be_the_first_statement_in_the_constructor_when_a_class_contains_initialized_properties_or_has_parameter_properties: diag(2376, ts.DiagnosticCategory.Error, "A_super_call_must_be_the_first_statement_in_the_constructor_when_a_class_contains_initialized_proper_2376", "A 'super' call must be the first statement in the constructor when a class contains initialized properties or has parameter properties."),
	        Constructors_for_derived_classes_must_contain_a_super_call: diag(2377, ts.DiagnosticCategory.Error, "Constructors_for_derived_classes_must_contain_a_super_call_2377", "Constructors for derived classes must contain a 'super' call."),
	        A_get_accessor_must_return_a_value: diag(2378, ts.DiagnosticCategory.Error, "A_get_accessor_must_return_a_value_2378", "A 'get' accessor must return a value."),
	        Getter_and_setter_accessors_do_not_agree_in_visibility: diag(2379, ts.DiagnosticCategory.Error, "Getter_and_setter_accessors_do_not_agree_in_visibility_2379", "Getter and setter accessors do not agree in visibility."),
	        get_and_set_accessor_must_have_the_same_type: diag(2380, ts.DiagnosticCategory.Error, "get_and_set_accessor_must_have_the_same_type_2380", "'get' and 'set' accessor must have the same type."),
	        A_signature_with_an_implementation_cannot_use_a_string_literal_type: diag(2381, ts.DiagnosticCategory.Error, "A_signature_with_an_implementation_cannot_use_a_string_literal_type_2381", "A signature with an implementation cannot use a string literal type."),
	        Specialized_overload_signature_is_not_assignable_to_any_non_specialized_signature: diag(2382, ts.DiagnosticCategory.Error, "Specialized_overload_signature_is_not_assignable_to_any_non_specialized_signature_2382", "Specialized overload signature is not assignable to any non-specialized signature."),
	        Overload_signatures_must_all_be_exported_or_non_exported: diag(2383, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_exported_or_non_exported_2383", "Overload signatures must all be exported or non-exported."),
	        Overload_signatures_must_all_be_ambient_or_non_ambient: diag(2384, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_ambient_or_non_ambient_2384", "Overload signatures must all be ambient or non-ambient."),
	        Overload_signatures_must_all_be_public_private_or_protected: diag(2385, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_public_private_or_protected_2385", "Overload signatures must all be public, private or protected."),
	        Overload_signatures_must_all_be_optional_or_required: diag(2386, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_optional_or_required_2386", "Overload signatures must all be optional or required."),
	        Function_overload_must_be_static: diag(2387, ts.DiagnosticCategory.Error, "Function_overload_must_be_static_2387", "Function overload must be static."),
	        Function_overload_must_not_be_static: diag(2388, ts.DiagnosticCategory.Error, "Function_overload_must_not_be_static_2388", "Function overload must not be static."),
	        Function_implementation_name_must_be_0: diag(2389, ts.DiagnosticCategory.Error, "Function_implementation_name_must_be_0_2389", "Function implementation name must be '{0}'."),
	        Constructor_implementation_is_missing: diag(2390, ts.DiagnosticCategory.Error, "Constructor_implementation_is_missing_2390", "Constructor implementation is missing."),
	        Function_implementation_is_missing_or_not_immediately_following_the_declaration: diag(2391, ts.DiagnosticCategory.Error, "Function_implementation_is_missing_or_not_immediately_following_the_declaration_2391", "Function implementation is missing or not immediately following the declaration."),
	        Multiple_constructor_implementations_are_not_allowed: diag(2392, ts.DiagnosticCategory.Error, "Multiple_constructor_implementations_are_not_allowed_2392", "Multiple constructor implementations are not allowed."),
	        Duplicate_function_implementation: diag(2393, ts.DiagnosticCategory.Error, "Duplicate_function_implementation_2393", "Duplicate function implementation."),
	        Overload_signature_is_not_compatible_with_function_implementation: diag(2394, ts.DiagnosticCategory.Error, "Overload_signature_is_not_compatible_with_function_implementation_2394", "Overload signature is not compatible with function implementation."),
	        Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local: diag(2395, ts.DiagnosticCategory.Error, "Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local_2395", "Individual declarations in merged declaration '{0}' must be all exported or all local."),
	        Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters: diag(2396, ts.DiagnosticCategory.Error, "Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters_2396", "Duplicate identifier 'arguments'. Compiler uses 'arguments' to initialize rest parameters."),
	        Declaration_name_conflicts_with_built_in_global_identifier_0: diag(2397, ts.DiagnosticCategory.Error, "Declaration_name_conflicts_with_built_in_global_identifier_0_2397", "Declaration name conflicts with built-in global identifier '{0}'."),
	        Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference: diag(2399, ts.DiagnosticCategory.Error, "Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference_2399", "Duplicate identifier '_this'. Compiler uses variable declaration '_this' to capture 'this' reference."),
	        Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference: diag(2400, ts.DiagnosticCategory.Error, "Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference_2400", "Expression resolves to variable declaration '_this' that compiler uses to capture 'this' reference."),
	        Duplicate_identifier_super_Compiler_uses_super_to_capture_base_class_reference: diag(2401, ts.DiagnosticCategory.Error, "Duplicate_identifier_super_Compiler_uses_super_to_capture_base_class_reference_2401", "Duplicate identifier '_super'. Compiler uses '_super' to capture base class reference."),
	        Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference: diag(2402, ts.DiagnosticCategory.Error, "Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference_2402", "Expression resolves to '_super' that compiler uses to capture base class reference."),
	        Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_type_2: diag(2403, ts.DiagnosticCategory.Error, "Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_t_2403", "Subsequent variable declarations must have the same type.  Variable '{0}' must be of type '{1}', but here has type '{2}'."),
	        The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation: diag(2404, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation_2404", "The left-hand side of a 'for...in' statement cannot use a type annotation."),
	        The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any: diag(2405, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any_2405", "The left-hand side of a 'for...in' statement must be of type 'string' or 'any'."),
	        The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access: diag(2406, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access_2406", "The left-hand side of a 'for...in' statement must be a variable or a property access."),
	        The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter: diag(2407, ts.DiagnosticCategory.Error, "The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_2407", "The right-hand side of a 'for...in' statement must be of type 'any', an object type or a type parameter."),
	        Setters_cannot_return_a_value: diag(2408, ts.DiagnosticCategory.Error, "Setters_cannot_return_a_value_2408", "Setters cannot return a value."),
	        Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class: diag(2409, ts.DiagnosticCategory.Error, "Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class_2409", "Return type of constructor signature must be assignable to the instance type of the class."),
	        The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any: diag(2410, ts.DiagnosticCategory.Error, "The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any_2410", "The 'with' statement is not supported. All symbols in a 'with' block will have type 'any'."),
	        Property_0_of_type_1_is_not_assignable_to_string_index_type_2: diag(2411, ts.DiagnosticCategory.Error, "Property_0_of_type_1_is_not_assignable_to_string_index_type_2_2411", "Property '{0}' of type '{1}' is not assignable to string index type '{2}'."),
	        Property_0_of_type_1_is_not_assignable_to_numeric_index_type_2: diag(2412, ts.DiagnosticCategory.Error, "Property_0_of_type_1_is_not_assignable_to_numeric_index_type_2_2412", "Property '{0}' of type '{1}' is not assignable to numeric index type '{2}'."),
	        Numeric_index_type_0_is_not_assignable_to_string_index_type_1: diag(2413, ts.DiagnosticCategory.Error, "Numeric_index_type_0_is_not_assignable_to_string_index_type_1_2413", "Numeric index type '{0}' is not assignable to string index type '{1}'."),
	        Class_name_cannot_be_0: diag(2414, ts.DiagnosticCategory.Error, "Class_name_cannot_be_0_2414", "Class name cannot be '{0}'."),
	        Class_0_incorrectly_extends_base_class_1: diag(2415, ts.DiagnosticCategory.Error, "Class_0_incorrectly_extends_base_class_1_2415", "Class '{0}' incorrectly extends base class '{1}'."),
	        Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2: diag(2416, ts.DiagnosticCategory.Error, "Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2_2416", "Property '{0}' in type '{1}' is not assignable to the same property in base type '{2}'."),
	        Class_static_side_0_incorrectly_extends_base_class_static_side_1: diag(2417, ts.DiagnosticCategory.Error, "Class_static_side_0_incorrectly_extends_base_class_static_side_1_2417", "Class static side '{0}' incorrectly extends base class static side '{1}'."),
	        Class_0_incorrectly_implements_interface_1: diag(2420, ts.DiagnosticCategory.Error, "Class_0_incorrectly_implements_interface_1_2420", "Class '{0}' incorrectly implements interface '{1}'."),
	        A_class_may_only_implement_another_class_or_interface: diag(2422, ts.DiagnosticCategory.Error, "A_class_may_only_implement_another_class_or_interface_2422", "A class may only implement another class or interface."),
	        Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_accessor: diag(2423, ts.DiagnosticCategory.Error, "Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_access_2423", "Class '{0}' defines instance member function '{1}', but extended class '{2}' defines it as instance member accessor."),
	        Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_property: diag(2424, ts.DiagnosticCategory.Error, "Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_proper_2424", "Class '{0}' defines instance member function '{1}', but extended class '{2}' defines it as instance member property."),
	        Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_function: diag(2425, ts.DiagnosticCategory.Error, "Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_functi_2425", "Class '{0}' defines instance member property '{1}', but extended class '{2}' defines it as instance member function."),
	        Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_function: diag(2426, ts.DiagnosticCategory.Error, "Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_functi_2426", "Class '{0}' defines instance member accessor '{1}', but extended class '{2}' defines it as instance member function."),
	        Interface_name_cannot_be_0: diag(2427, ts.DiagnosticCategory.Error, "Interface_name_cannot_be_0_2427", "Interface name cannot be '{0}'."),
	        All_declarations_of_0_must_have_identical_type_parameters: diag(2428, ts.DiagnosticCategory.Error, "All_declarations_of_0_must_have_identical_type_parameters_2428", "All declarations of '{0}' must have identical type parameters."),
	        Interface_0_incorrectly_extends_interface_1: diag(2430, ts.DiagnosticCategory.Error, "Interface_0_incorrectly_extends_interface_1_2430", "Interface '{0}' incorrectly extends interface '{1}'."),
	        Enum_name_cannot_be_0: diag(2431, ts.DiagnosticCategory.Error, "Enum_name_cannot_be_0_2431", "Enum name cannot be '{0}'."),
	        In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enum_element: diag(2432, ts.DiagnosticCategory.Error, "In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enu_2432", "In an enum with multiple declarations, only one declaration can omit an initializer for its first enum element."),
	        A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merged: diag(2433, ts.DiagnosticCategory.Error, "A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merg_2433", "A namespace declaration cannot be in a different file from a class or function with which it is merged."),
	        A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged: diag(2434, ts.DiagnosticCategory.Error, "A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged_2434", "A namespace declaration cannot be located prior to a class or function with which it is merged."),
	        Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces: diag(2435, ts.DiagnosticCategory.Error, "Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces_2435", "Ambient modules cannot be nested in other modules or namespaces."),
	        Ambient_module_declaration_cannot_specify_relative_module_name: diag(2436, ts.DiagnosticCategory.Error, "Ambient_module_declaration_cannot_specify_relative_module_name_2436", "Ambient module declaration cannot specify relative module name."),
	        Module_0_is_hidden_by_a_local_declaration_with_the_same_name: diag(2437, ts.DiagnosticCategory.Error, "Module_0_is_hidden_by_a_local_declaration_with_the_same_name_2437", "Module '{0}' is hidden by a local declaration with the same name."),
	        Import_name_cannot_be_0: diag(2438, ts.DiagnosticCategory.Error, "Import_name_cannot_be_0_2438", "Import name cannot be '{0}'."),
	        Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relative_module_name: diag(2439, ts.DiagnosticCategory.Error, "Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relati_2439", "Import or export declaration in an ambient module declaration cannot reference module through relative module name."),
	        Import_declaration_conflicts_with_local_declaration_of_0: diag(2440, ts.DiagnosticCategory.Error, "Import_declaration_conflicts_with_local_declaration_of_0_2440", "Import declaration conflicts with local declaration of '{0}'."),
	        Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module: diag(2441, ts.DiagnosticCategory.Error, "Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_2441", "Duplicate identifier '{0}'. Compiler reserves name '{1}' in top level scope of a module."),
	        Types_have_separate_declarations_of_a_private_property_0: diag(2442, ts.DiagnosticCategory.Error, "Types_have_separate_declarations_of_a_private_property_0_2442", "Types have separate declarations of a private property '{0}'."),
	        Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2: diag(2443, ts.DiagnosticCategory.Error, "Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2_2443", "Property '{0}' is protected but type '{1}' is not a class derived from '{2}'."),
	        Property_0_is_protected_in_type_1_but_public_in_type_2: diag(2444, ts.DiagnosticCategory.Error, "Property_0_is_protected_in_type_1_but_public_in_type_2_2444", "Property '{0}' is protected in type '{1}' but public in type '{2}'."),
	        Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses: diag(2445, ts.DiagnosticCategory.Error, "Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses_2445", "Property '{0}' is protected and only accessible within class '{1}' and its subclasses."),
	        Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1: diag(2446, ts.DiagnosticCategory.Error, "Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1_2446", "Property '{0}' is protected and only accessible through an instance of class '{1}'."),
	        The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead: diag(2447, ts.DiagnosticCategory.Error, "The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead_2447", "The '{0}' operator is not allowed for boolean types. Consider using '{1}' instead."),
	        Block_scoped_variable_0_used_before_its_declaration: diag(2448, ts.DiagnosticCategory.Error, "Block_scoped_variable_0_used_before_its_declaration_2448", "Block-scoped variable '{0}' used before its declaration."),
	        Class_0_used_before_its_declaration: diag(2449, ts.DiagnosticCategory.Error, "Class_0_used_before_its_declaration_2449", "Class '{0}' used before its declaration."),
	        Enum_0_used_before_its_declaration: diag(2450, ts.DiagnosticCategory.Error, "Enum_0_used_before_its_declaration_2450", "Enum '{0}' used before its declaration."),
	        Cannot_redeclare_block_scoped_variable_0: diag(2451, ts.DiagnosticCategory.Error, "Cannot_redeclare_block_scoped_variable_0_2451", "Cannot redeclare block-scoped variable '{0}'."),
	        An_enum_member_cannot_have_a_numeric_name: diag(2452, ts.DiagnosticCategory.Error, "An_enum_member_cannot_have_a_numeric_name_2452", "An enum member cannot have a numeric name."),
	        The_type_argument_for_type_parameter_0_cannot_be_inferred_from_the_usage_Consider_specifying_the_type_arguments_explicitly: diag(2453, ts.DiagnosticCategory.Error, "The_type_argument_for_type_parameter_0_cannot_be_inferred_from_the_usage_Consider_specifying_the_typ_2453", "The type argument for type parameter '{0}' cannot be inferred from the usage. Consider specifying the type arguments explicitly."),
	        Variable_0_is_used_before_being_assigned: diag(2454, ts.DiagnosticCategory.Error, "Variable_0_is_used_before_being_assigned_2454", "Variable '{0}' is used before being assigned."),
	        Type_argument_candidate_1_is_not_a_valid_type_argument_because_it_is_not_a_supertype_of_candidate_0: diag(2455, ts.DiagnosticCategory.Error, "Type_argument_candidate_1_is_not_a_valid_type_argument_because_it_is_not_a_supertype_of_candidate_0_2455", "Type argument candidate '{1}' is not a valid type argument because it is not a supertype of candidate '{0}'."),
	        Type_alias_0_circularly_references_itself: diag(2456, ts.DiagnosticCategory.Error, "Type_alias_0_circularly_references_itself_2456", "Type alias '{0}' circularly references itself."),
	        Type_alias_name_cannot_be_0: diag(2457, ts.DiagnosticCategory.Error, "Type_alias_name_cannot_be_0_2457", "Type alias name cannot be '{0}'."),
	        An_AMD_module_cannot_have_multiple_name_assignments: diag(2458, ts.DiagnosticCategory.Error, "An_AMD_module_cannot_have_multiple_name_assignments_2458", "An AMD module cannot have multiple name assignments."),
	        Type_0_has_no_property_1_and_no_string_index_signature: diag(2459, ts.DiagnosticCategory.Error, "Type_0_has_no_property_1_and_no_string_index_signature_2459", "Type '{0}' has no property '{1}' and no string index signature."),
	        Type_0_has_no_property_1: diag(2460, ts.DiagnosticCategory.Error, "Type_0_has_no_property_1_2460", "Type '{0}' has no property '{1}'."),
	        Type_0_is_not_an_array_type: diag(2461, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_2461", "Type '{0}' is not an array type."),
	        A_rest_element_must_be_last_in_a_destructuring_pattern: diag(2462, ts.DiagnosticCategory.Error, "A_rest_element_must_be_last_in_a_destructuring_pattern_2462", "A rest element must be last in a destructuring pattern."),
	        A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature: diag(2463, ts.DiagnosticCategory.Error, "A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature_2463", "A binding pattern parameter cannot be optional in an implementation signature."),
	        A_computed_property_name_must_be_of_type_string_number_symbol_or_any: diag(2464, ts.DiagnosticCategory.Error, "A_computed_property_name_must_be_of_type_string_number_symbol_or_any_2464", "A computed property name must be of type 'string', 'number', 'symbol', or 'any'."),
	        this_cannot_be_referenced_in_a_computed_property_name: diag(2465, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_a_computed_property_name_2465", "'this' cannot be referenced in a computed property name."),
	        super_cannot_be_referenced_in_a_computed_property_name: diag(2466, ts.DiagnosticCategory.Error, "super_cannot_be_referenced_in_a_computed_property_name_2466", "'super' cannot be referenced in a computed property name."),
	        A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type: diag(2467, ts.DiagnosticCategory.Error, "A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type_2467", "A computed property name cannot reference a type parameter from its containing type."),
	        Cannot_find_global_value_0: diag(2468, ts.DiagnosticCategory.Error, "Cannot_find_global_value_0_2468", "Cannot find global value '{0}'."),
	        The_0_operator_cannot_be_applied_to_type_symbol: diag(2469, ts.DiagnosticCategory.Error, "The_0_operator_cannot_be_applied_to_type_symbol_2469", "The '{0}' operator cannot be applied to type 'symbol'."),
	        Symbol_reference_does_not_refer_to_the_global_Symbol_constructor_object: diag(2470, ts.DiagnosticCategory.Error, "Symbol_reference_does_not_refer_to_the_global_Symbol_constructor_object_2470", "'Symbol' reference does not refer to the global Symbol constructor object."),
	        A_computed_property_name_of_the_form_0_must_be_of_type_symbol: diag(2471, ts.DiagnosticCategory.Error, "A_computed_property_name_of_the_form_0_must_be_of_type_symbol_2471", "A computed property name of the form '{0}' must be of type 'symbol'."),
	        Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher: diag(2472, ts.DiagnosticCategory.Error, "Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher_2472", "Spread operator in 'new' expressions is only available when targeting ECMAScript 5 and higher."),
	        Enum_declarations_must_all_be_const_or_non_const: diag(2473, ts.DiagnosticCategory.Error, "Enum_declarations_must_all_be_const_or_non_const_2473", "Enum declarations must all be const or non-const."),
	        In_const_enum_declarations_member_initializer_must_be_constant_expression: diag(2474, ts.DiagnosticCategory.Error, "In_const_enum_declarations_member_initializer_must_be_constant_expression_2474", "In 'const' enum declarations member initializer must be constant expression."),
	        const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_import_declaration_or_export_assignment_or_type_query: diag(2475, ts.DiagnosticCategory.Error, "const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_im_2475", "'const' enums can only be used in property or index access expressions or the right hand side of an import declaration or export assignment or type query."),
	        A_const_enum_member_can_only_be_accessed_using_a_string_literal: diag(2476, ts.DiagnosticCategory.Error, "A_const_enum_member_can_only_be_accessed_using_a_string_literal_2476", "A const enum member can only be accessed using a string literal."),
	        const_enum_member_initializer_was_evaluated_to_a_non_finite_value: diag(2477, ts.DiagnosticCategory.Error, "const_enum_member_initializer_was_evaluated_to_a_non_finite_value_2477", "'const' enum member initializer was evaluated to a non-finite value."),
	        const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN: diag(2478, ts.DiagnosticCategory.Error, "const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN_2478", "'const' enum member initializer was evaluated to disallowed value 'NaN'."),
	        Property_0_does_not_exist_on_const_enum_1: diag(2479, ts.DiagnosticCategory.Error, "Property_0_does_not_exist_on_const_enum_1_2479", "Property '{0}' does not exist on 'const' enum '{1}'."),
	        let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations: diag(2480, ts.DiagnosticCategory.Error, "let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations_2480", "'let' is not allowed to be used as a name in 'let' or 'const' declarations."),
	        Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1: diag(2481, ts.DiagnosticCategory.Error, "Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1_2481", "Cannot initialize outer scoped variable '{0}' in the same scope as block scoped declaration '{1}'."),
	        The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation: diag(2483, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation_2483", "The left-hand side of a 'for...of' statement cannot use a type annotation."),
	        Export_declaration_conflicts_with_exported_declaration_of_0: diag(2484, ts.DiagnosticCategory.Error, "Export_declaration_conflicts_with_exported_declaration_of_0_2484", "Export declaration conflicts with exported declaration of '{0}'."),
	        The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access: diag(2487, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access_2487", "The left-hand side of a 'for...of' statement must be a variable or a property access."),
	        Type_must_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2488, ts.DiagnosticCategory.Error, "Type_must_have_a_Symbol_iterator_method_that_returns_an_iterator_2488", "Type must have a '[Symbol.iterator]()' method that returns an iterator."),
	        An_iterator_must_have_a_next_method: diag(2489, ts.DiagnosticCategory.Error, "An_iterator_must_have_a_next_method_2489", "An iterator must have a 'next()' method."),
	        The_type_returned_by_the_next_method_of_an_iterator_must_have_a_value_property: diag(2490, ts.DiagnosticCategory.Error, "The_type_returned_by_the_next_method_of_an_iterator_must_have_a_value_property_2490", "The type returned by the 'next()' method of an iterator must have a 'value' property."),
	        The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern: diag(2491, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern_2491", "The left-hand side of a 'for...in' statement cannot be a destructuring pattern."),
	        Cannot_redeclare_identifier_0_in_catch_clause: diag(2492, ts.DiagnosticCategory.Error, "Cannot_redeclare_identifier_0_in_catch_clause_2492", "Cannot redeclare identifier '{0}' in catch clause."),
	        Tuple_type_0_with_length_1_cannot_be_assigned_to_tuple_with_length_2: diag(2493, ts.DiagnosticCategory.Error, "Tuple_type_0_with_length_1_cannot_be_assigned_to_tuple_with_length_2_2493", "Tuple type '{0}' with length '{1}' cannot be assigned to tuple with length '{2}'."),
	        Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher: diag(2494, ts.DiagnosticCategory.Error, "Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher_2494", "Using a string in a 'for...of' statement is only supported in ECMAScript 5 and higher."),
	        Type_0_is_not_an_array_type_or_a_string_type: diag(2495, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_or_a_string_type_2495", "Type '{0}' is not an array type or a string type."),
	        The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_standard_function_expression: diag(2496, ts.DiagnosticCategory.Error, "The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_stand_2496", "The 'arguments' object cannot be referenced in an arrow function in ES3 and ES5. Consider using a standard function expression."),
	        Module_0_resolves_to_a_non_module_entity_and_cannot_be_imported_using_this_construct: diag(2497, ts.DiagnosticCategory.Error, "Module_0_resolves_to_a_non_module_entity_and_cannot_be_imported_using_this_construct_2497", "Module '{0}' resolves to a non-module entity and cannot be imported using this construct."),
	        Module_0_uses_export_and_cannot_be_used_with_export_Asterisk: diag(2498, ts.DiagnosticCategory.Error, "Module_0_uses_export_and_cannot_be_used_with_export_Asterisk_2498", "Module '{0}' uses 'export =' and cannot be used with 'export *'."),
	        An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments: diag(2499, ts.DiagnosticCategory.Error, "An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments_2499", "An interface can only extend an identifier/qualified-name with optional type arguments."),
	        A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments: diag(2500, ts.DiagnosticCategory.Error, "A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments_2500", "A class can only implement an identifier/qualified-name with optional type arguments."),
	        A_rest_element_cannot_contain_a_binding_pattern: diag(2501, ts.DiagnosticCategory.Error, "A_rest_element_cannot_contain_a_binding_pattern_2501", "A rest element cannot contain a binding pattern."),
	        _0_is_referenced_directly_or_indirectly_in_its_own_type_annotation: diag(2502, ts.DiagnosticCategory.Error, "_0_is_referenced_directly_or_indirectly_in_its_own_type_annotation_2502", "'{0}' is referenced directly or indirectly in its own type annotation."),
	        Cannot_find_namespace_0: diag(2503, ts.DiagnosticCategory.Error, "Cannot_find_namespace_0_2503", "Cannot find namespace '{0}'."),
	        Type_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator: diag(2504, ts.DiagnosticCategory.Error, "Type_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator_2504", "Type must have a '[Symbol.asyncIterator]()' method that returns an async iterator."),
	        A_generator_cannot_have_a_void_type_annotation: diag(2505, ts.DiagnosticCategory.Error, "A_generator_cannot_have_a_void_type_annotation_2505", "A generator cannot have a 'void' type annotation."),
	        _0_is_referenced_directly_or_indirectly_in_its_own_base_expression: diag(2506, ts.DiagnosticCategory.Error, "_0_is_referenced_directly_or_indirectly_in_its_own_base_expression_2506", "'{0}' is referenced directly or indirectly in its own base expression."),
	        Type_0_is_not_a_constructor_function_type: diag(2507, ts.DiagnosticCategory.Error, "Type_0_is_not_a_constructor_function_type_2507", "Type '{0}' is not a constructor function type."),
	        No_base_constructor_has_the_specified_number_of_type_arguments: diag(2508, ts.DiagnosticCategory.Error, "No_base_constructor_has_the_specified_number_of_type_arguments_2508", "No base constructor has the specified number of type arguments."),
	        Base_constructor_return_type_0_is_not_a_class_or_interface_type: diag(2509, ts.DiagnosticCategory.Error, "Base_constructor_return_type_0_is_not_a_class_or_interface_type_2509", "Base constructor return type '{0}' is not a class or interface type."),
	        Base_constructors_must_all_have_the_same_return_type: diag(2510, ts.DiagnosticCategory.Error, "Base_constructors_must_all_have_the_same_return_type_2510", "Base constructors must all have the same return type."),
	        Cannot_create_an_instance_of_an_abstract_class: diag(2511, ts.DiagnosticCategory.Error, "Cannot_create_an_instance_of_an_abstract_class_2511", "Cannot create an instance of an abstract class."),
	        Overload_signatures_must_all_be_abstract_or_non_abstract: diag(2512, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_abstract_or_non_abstract_2512", "Overload signatures must all be abstract or non-abstract."),
	        Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression: diag(2513, ts.DiagnosticCategory.Error, "Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression_2513", "Abstract method '{0}' in class '{1}' cannot be accessed via super expression."),
	        Classes_containing_abstract_methods_must_be_marked_abstract: diag(2514, ts.DiagnosticCategory.Error, "Classes_containing_abstract_methods_must_be_marked_abstract_2514", "Classes containing abstract methods must be marked abstract."),
	        Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2: diag(2515, ts.DiagnosticCategory.Error, "Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2_2515", "Non-abstract class '{0}' does not implement inherited abstract member '{1}' from class '{2}'."),
	        All_declarations_of_an_abstract_method_must_be_consecutive: diag(2516, ts.DiagnosticCategory.Error, "All_declarations_of_an_abstract_method_must_be_consecutive_2516", "All declarations of an abstract method must be consecutive."),
	        Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type: diag(2517, ts.DiagnosticCategory.Error, "Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type_2517", "Cannot assign an abstract constructor type to a non-abstract constructor type."),
	        A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard: diag(2518, ts.DiagnosticCategory.Error, "A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard_2518", "A 'this'-based type guard is not compatible with a parameter-based type guard."),
	        An_async_iterator_must_have_a_next_method: diag(2519, ts.DiagnosticCategory.Error, "An_async_iterator_must_have_a_next_method_2519", "An async iterator must have a 'next()' method."),
	        Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions: diag(2520, ts.DiagnosticCategory.Error, "Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions_2520", "Duplicate identifier '{0}'. Compiler uses declaration '{1}' to support async functions."),
	        Expression_resolves_to_variable_declaration_0_that_compiler_uses_to_support_async_functions: diag(2521, ts.DiagnosticCategory.Error, "Expression_resolves_to_variable_declaration_0_that_compiler_uses_to_support_async_functions_2521", "Expression resolves to variable declaration '{0}' that compiler uses to support async functions."),
	        The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_using_a_standard_function_or_method: diag(2522, ts.DiagnosticCategory.Error, "The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_usi_2522", "The 'arguments' object cannot be referenced in an async function or method in ES3 and ES5. Consider using a standard function or method."),
	        yield_expressions_cannot_be_used_in_a_parameter_initializer: diag(2523, ts.DiagnosticCategory.Error, "yield_expressions_cannot_be_used_in_a_parameter_initializer_2523", "'yield' expressions cannot be used in a parameter initializer."),
	        await_expressions_cannot_be_used_in_a_parameter_initializer: diag(2524, ts.DiagnosticCategory.Error, "await_expressions_cannot_be_used_in_a_parameter_initializer_2524", "'await' expressions cannot be used in a parameter initializer."),
	        Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value: diag(2525, ts.DiagnosticCategory.Error, "Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value_2525", "Initializer provides no value for this binding element and the binding element has no default value."),
	        A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface: diag(2526, ts.DiagnosticCategory.Error, "A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface_2526", "A 'this' type is available only in a non-static member of a class or interface."),
	        The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary: diag(2527, ts.DiagnosticCategory.Error, "The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary_2527", "The inferred type of '{0}' references an inaccessible '{1}' type. A type annotation is necessary."),
	        A_module_cannot_have_multiple_default_exports: diag(2528, ts.DiagnosticCategory.Error, "A_module_cannot_have_multiple_default_exports_2528", "A module cannot have multiple default exports."),
	        Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_functions: diag(2529, ts.DiagnosticCategory.Error, "Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_func_2529", "Duplicate identifier '{0}'. Compiler reserves name '{1}' in top level scope of a module containing async functions."),
	        Property_0_is_incompatible_with_index_signature: diag(2530, ts.DiagnosticCategory.Error, "Property_0_is_incompatible_with_index_signature_2530", "Property '{0}' is incompatible with index signature."),
	        Object_is_possibly_null: diag(2531, ts.DiagnosticCategory.Error, "Object_is_possibly_null_2531", "Object is possibly 'null'."),
	        Object_is_possibly_undefined: diag(2532, ts.DiagnosticCategory.Error, "Object_is_possibly_undefined_2532", "Object is possibly 'undefined'."),
	        Object_is_possibly_null_or_undefined: diag(2533, ts.DiagnosticCategory.Error, "Object_is_possibly_null_or_undefined_2533", "Object is possibly 'null' or 'undefined'."),
	        A_function_returning_never_cannot_have_a_reachable_end_point: diag(2534, ts.DiagnosticCategory.Error, "A_function_returning_never_cannot_have_a_reachable_end_point_2534", "A function returning 'never' cannot have a reachable end point."),
	        Enum_type_0_has_members_with_initializers_that_are_not_literals: diag(2535, ts.DiagnosticCategory.Error, "Enum_type_0_has_members_with_initializers_that_are_not_literals_2535", "Enum type '{0}' has members with initializers that are not literals."),
	        Type_0_cannot_be_used_to_index_type_1: diag(2536, ts.DiagnosticCategory.Error, "Type_0_cannot_be_used_to_index_type_1_2536", "Type '{0}' cannot be used to index type '{1}'."),
	        Type_0_has_no_matching_index_signature_for_type_1: diag(2537, ts.DiagnosticCategory.Error, "Type_0_has_no_matching_index_signature_for_type_1_2537", "Type '{0}' has no matching index signature for type '{1}'."),
	        Type_0_cannot_be_used_as_an_index_type: diag(2538, ts.DiagnosticCategory.Error, "Type_0_cannot_be_used_as_an_index_type_2538", "Type '{0}' cannot be used as an index type."),
	        Cannot_assign_to_0_because_it_is_not_a_variable: diag(2539, ts.DiagnosticCategory.Error, "Cannot_assign_to_0_because_it_is_not_a_variable_2539", "Cannot assign to '{0}' because it is not a variable."),
	        Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property: diag(2540, ts.DiagnosticCategory.Error, "Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property_2540", "Cannot assign to '{0}' because it is a constant or a read-only property."),
	        The_target_of_an_assignment_must_be_a_variable_or_a_property_access: diag(2541, ts.DiagnosticCategory.Error, "The_target_of_an_assignment_must_be_a_variable_or_a_property_access_2541", "The target of an assignment must be a variable or a property access."),
	        Index_signature_in_type_0_only_permits_reading: diag(2542, ts.DiagnosticCategory.Error, "Index_signature_in_type_0_only_permits_reading_2542", "Index signature in type '{0}' only permits reading."),
	        Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_meta_property_reference: diag(2543, ts.DiagnosticCategory.Error, "Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_me_2543", "Duplicate identifier '_newTarget'. Compiler uses variable declaration '_newTarget' to capture 'new.target' meta-property reference."),
	        Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta_property_reference: diag(2544, ts.DiagnosticCategory.Error, "Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta__2544", "Expression resolves to variable declaration '_newTarget' that compiler uses to capture 'new.target' meta-property reference."),
	        A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any: diag(2545, ts.DiagnosticCategory.Error, "A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any_2545", "A mixin class must have a constructor with a single rest parameter of type 'any[]'."),
	        Property_0_has_conflicting_declarations_and_is_inaccessible_in_type_1: diag(2546, ts.DiagnosticCategory.Error, "Property_0_has_conflicting_declarations_and_is_inaccessible_in_type_1_2546", "Property '{0}' has conflicting declarations and is inaccessible in type '{1}'."),
	        The_type_returned_by_the_next_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property: diag(2547, ts.DiagnosticCategory.Error, "The_type_returned_by_the_next_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value__2547", "The type returned by the 'next()' method of an async iterator must be a promise for a type with a 'value' property."),
	        Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2548, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator_2548", "Type '{0}' is not an array type or does not have a '[Symbol.iterator]()' method that returns an iterator."),
	        Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2549, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns__2549", "Type '{0}' is not an array type or a string type or does not have a '[Symbol.iterator]()' method that returns an iterator."),
	        Generic_type_instantiation_is_excessively_deep_and_possibly_infinite: diag(2550, ts.DiagnosticCategory.Error, "Generic_type_instantiation_is_excessively_deep_and_possibly_infinite_2550", "Generic type instantiation is excessively deep and possibly infinite."),
	        Property_0_does_not_exist_on_type_1_Did_you_mean_2: diag(2551, ts.DiagnosticCategory.Error, "Property_0_does_not_exist_on_type_1_Did_you_mean_2_2551", "Property '{0}' does not exist on type '{1}'. Did you mean '{2}'?"),
	        Cannot_find_name_0_Did_you_mean_1: diag(2552, ts.DiagnosticCategory.Error, "Cannot_find_name_0_Did_you_mean_1_2552", "Cannot find name '{0}'. Did you mean '{1}'?"),
	        Computed_values_are_not_permitted_in_an_enum_with_string_valued_members: diag(2553, ts.DiagnosticCategory.Error, "Computed_values_are_not_permitted_in_an_enum_with_string_valued_members_2553", "Computed values are not permitted in an enum with string valued members."),
	        Expected_0_arguments_but_got_1: diag(2554, ts.DiagnosticCategory.Error, "Expected_0_arguments_but_got_1_2554", "Expected {0} arguments, but got {1}."),
	        Expected_at_least_0_arguments_but_got_1: diag(2555, ts.DiagnosticCategory.Error, "Expected_at_least_0_arguments_but_got_1_2555", "Expected at least {0} arguments, but got {1}."),
	        Expected_0_arguments_but_got_1_or_more: diag(2556, ts.DiagnosticCategory.Error, "Expected_0_arguments_but_got_1_or_more_2556", "Expected {0} arguments, but got {1} or more."),
	        Expected_at_least_0_arguments_but_got_1_or_more: diag(2557, ts.DiagnosticCategory.Error, "Expected_at_least_0_arguments_but_got_1_or_more_2557", "Expected at least {0} arguments, but got {1} or more."),
	        Expected_0_type_arguments_but_got_1: diag(2558, ts.DiagnosticCategory.Error, "Expected_0_type_arguments_but_got_1_2558", "Expected {0} type arguments, but got {1}."),
	        Type_0_has_no_properties_in_common_with_type_1: diag(2559, ts.DiagnosticCategory.Error, "Type_0_has_no_properties_in_common_with_type_1_2559", "Type '{0}' has no properties in common with type '{1}'."),
	        Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it: diag(2560, ts.DiagnosticCategory.Error, "Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it_2560", "Value of type '{0}' has no properties in common with type '{1}'. Did you mean to call it?"),
	        Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_write_2: diag(2561, ts.DiagnosticCategory.Error, "Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_writ_2561", "Object literal may only specify known properties, but '{0}' does not exist in type '{1}'. Did you mean to write '{2}'?"),
	        Base_class_expressions_cannot_reference_class_type_parameters: diag(2562, ts.DiagnosticCategory.Error, "Base_class_expressions_cannot_reference_class_type_parameters_2562", "Base class expressions cannot reference class type parameters."),
	        The_containing_function_or_module_body_is_too_large_for_control_flow_analysis: diag(2563, ts.DiagnosticCategory.Error, "The_containing_function_or_module_body_is_too_large_for_control_flow_analysis_2563", "The containing function or module body is too large for control flow analysis."),
	        Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor: diag(2564, ts.DiagnosticCategory.Error, "Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor_2564", "Property '{0}' has no initializer and is not definitely assigned in the constructor."),
	        Property_0_is_used_before_being_assigned: diag(2565, ts.DiagnosticCategory.Error, "Property_0_is_used_before_being_assigned_2565", "Property '{0}' is used before being assigned."),
	        A_rest_element_cannot_have_a_property_name: diag(2566, ts.DiagnosticCategory.Error, "A_rest_element_cannot_have_a_property_name_2566", "A rest element cannot have a property name."),
	        Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations: diag(2567, ts.DiagnosticCategory.Error, "Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations_2567", "Enum declarations can only merge with namespace or other enum declarations."),
	        JSX_element_attributes_type_0_may_not_be_a_union_type: diag(2600, ts.DiagnosticCategory.Error, "JSX_element_attributes_type_0_may_not_be_a_union_type_2600", "JSX element attributes type '{0}' may not be a union type."),
	        The_return_type_of_a_JSX_element_constructor_must_return_an_object_type: diag(2601, ts.DiagnosticCategory.Error, "The_return_type_of_a_JSX_element_constructor_must_return_an_object_type_2601", "The return type of a JSX element constructor must return an object type."),
	        JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist: diag(2602, ts.DiagnosticCategory.Error, "JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist_2602", "JSX element implicitly has type 'any' because the global type 'JSX.Element' does not exist."),
	        Property_0_in_type_1_is_not_assignable_to_type_2: diag(2603, ts.DiagnosticCategory.Error, "Property_0_in_type_1_is_not_assignable_to_type_2_2603", "Property '{0}' in type '{1}' is not assignable to type '{2}'."),
	        JSX_element_type_0_does_not_have_any_construct_or_call_signatures: diag(2604, ts.DiagnosticCategory.Error, "JSX_element_type_0_does_not_have_any_construct_or_call_signatures_2604", "JSX element type '{0}' does not have any construct or call signatures."),
	        JSX_element_type_0_is_not_a_constructor_function_for_JSX_elements: diag(2605, ts.DiagnosticCategory.Error, "JSX_element_type_0_is_not_a_constructor_function_for_JSX_elements_2605", "JSX element type '{0}' is not a constructor function for JSX elements."),
	        Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property: diag(2606, ts.DiagnosticCategory.Error, "Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property_2606", "Property '{0}' of JSX spread attribute is not assignable to target property."),
	        JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property: diag(2607, ts.DiagnosticCategory.Error, "JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property_2607", "JSX element class does not support attributes because it does not have a '{0}' property."),
	        The_global_type_JSX_0_may_not_have_more_than_one_property: diag(2608, ts.DiagnosticCategory.Error, "The_global_type_JSX_0_may_not_have_more_than_one_property_2608", "The global type 'JSX.{0}' may not have more than one property."),
	        JSX_spread_child_must_be_an_array_type: diag(2609, ts.DiagnosticCategory.Error, "JSX_spread_child_must_be_an_array_type_2609", "JSX spread child must be an array type."),
	        Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity: diag(2649, ts.DiagnosticCategory.Error, "Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity_2649", "Cannot augment module '{0}' with value exports because it resolves to a non-module entity."),
	        A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_members_defined_in_other_enums: diag(2651, ts.DiagnosticCategory.Error, "A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_memb_2651", "A member initializer in a enum declaration cannot reference members declared after it, including members defined in other enums."),
	        Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_default_0_declaration_instead: diag(2652, ts.DiagnosticCategory.Error, "Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_d_2652", "Merged declaration '{0}' cannot include a default export declaration. Consider adding a separate 'export default {0}' declaration instead."),
	        Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1: diag(2653, ts.DiagnosticCategory.Error, "Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1_2653", "Non-abstract class expression does not implement inherited abstract member '{0}' from class '{1}'."),
	        Exported_external_package_typings_file_cannot_contain_tripleslash_references_Please_contact_the_package_author_to_update_the_package_definition: diag(2654, ts.DiagnosticCategory.Error, "Exported_external_package_typings_file_cannot_contain_tripleslash_references_Please_contact_the_pack_2654", "Exported external package typings file cannot contain tripleslash references. Please contact the package author to update the package definition."),
	        Exported_external_package_typings_file_0_is_not_a_module_Please_contact_the_package_author_to_update_the_package_definition: diag(2656, ts.DiagnosticCategory.Error, "Exported_external_package_typings_file_0_is_not_a_module_Please_contact_the_package_author_to_update_2656", "Exported external package typings file '{0}' is not a module. Please contact the package author to update the package definition."),
	        JSX_expressions_must_have_one_parent_element: diag(2657, ts.DiagnosticCategory.Error, "JSX_expressions_must_have_one_parent_element_2657", "JSX expressions must have one parent element."),
	        Type_0_provides_no_match_for_the_signature_1: diag(2658, ts.DiagnosticCategory.Error, "Type_0_provides_no_match_for_the_signature_1_2658", "Type '{0}' provides no match for the signature '{1}'."),
	        super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_higher: diag(2659, ts.DiagnosticCategory.Error, "super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_highe_2659", "'super' is only allowed in members of object literal expressions when option 'target' is 'ES2015' or higher."),
	        super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions: diag(2660, ts.DiagnosticCategory.Error, "super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions_2660", "'super' can only be referenced in members of derived classes or object literal expressions."),
	        Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module: diag(2661, ts.DiagnosticCategory.Error, "Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module_2661", "Cannot export '{0}'. Only local declarations can be exported from a module."),
	        Cannot_find_name_0_Did_you_mean_the_static_member_1_0: diag(2662, ts.DiagnosticCategory.Error, "Cannot_find_name_0_Did_you_mean_the_static_member_1_0_2662", "Cannot find name '{0}'. Did you mean the static member '{1}.{0}'?"),
	        Cannot_find_name_0_Did_you_mean_the_instance_member_this_0: diag(2663, ts.DiagnosticCategory.Error, "Cannot_find_name_0_Did_you_mean_the_instance_member_this_0_2663", "Cannot find name '{0}'. Did you mean the instance member 'this.{0}'?"),
	        Invalid_module_name_in_augmentation_module_0_cannot_be_found: diag(2664, ts.DiagnosticCategory.Error, "Invalid_module_name_in_augmentation_module_0_cannot_be_found_2664", "Invalid module name in augmentation, module '{0}' cannot be found."),
	        Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augmented: diag(2665, ts.DiagnosticCategory.Error, "Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augm_2665", "Invalid module name in augmentation. Module '{0}' resolves to an untyped module at '{1}', which cannot be augmented."),
	        Exports_and_export_assignments_are_not_permitted_in_module_augmentations: diag(2666, ts.DiagnosticCategory.Error, "Exports_and_export_assignments_are_not_permitted_in_module_augmentations_2666", "Exports and export assignments are not permitted in module augmentations."),
	        Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_module: diag(2667, ts.DiagnosticCategory.Error, "Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_mod_2667", "Imports are not permitted in module augmentations. Consider moving them to the enclosing external module."),
	        export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always_visible: diag(2668, ts.DiagnosticCategory.Error, "export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always__2668", "'export' modifier cannot be applied to ambient modules and module augmentations since they are always visible."),
	        Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations: diag(2669, ts.DiagnosticCategory.Error, "Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_2669", "Augmentations for the global scope can only be directly nested in external modules or ambient module declarations."),
	        Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambient_context: diag(2670, ts.DiagnosticCategory.Error, "Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambien_2670", "Augmentations for the global scope should have 'declare' modifier unless they appear in already ambient context."),
	        Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity: diag(2671, ts.DiagnosticCategory.Error, "Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity_2671", "Cannot augment module '{0}' because it resolves to a non-module entity."),
	        Cannot_assign_a_0_constructor_type_to_a_1_constructor_type: diag(2672, ts.DiagnosticCategory.Error, "Cannot_assign_a_0_constructor_type_to_a_1_constructor_type_2672", "Cannot assign a '{0}' constructor type to a '{1}' constructor type."),
	        Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration: diag(2673, ts.DiagnosticCategory.Error, "Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration_2673", "Constructor of class '{0}' is private and only accessible within the class declaration."),
	        Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration: diag(2674, ts.DiagnosticCategory.Error, "Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration_2674", "Constructor of class '{0}' is protected and only accessible within the class declaration."),
	        Cannot_extend_a_class_0_Class_constructor_is_marked_as_private: diag(2675, ts.DiagnosticCategory.Error, "Cannot_extend_a_class_0_Class_constructor_is_marked_as_private_2675", "Cannot extend a class '{0}'. Class constructor is marked as private."),
	        Accessors_must_both_be_abstract_or_non_abstract: diag(2676, ts.DiagnosticCategory.Error, "Accessors_must_both_be_abstract_or_non_abstract_2676", "Accessors must both be abstract or non-abstract."),
	        A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type: diag(2677, ts.DiagnosticCategory.Error, "A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type_2677", "A type predicate's type must be assignable to its parameter's type."),
	        Type_0_is_not_comparable_to_type_1: diag(2678, ts.DiagnosticCategory.Error, "Type_0_is_not_comparable_to_type_1_2678", "Type '{0}' is not comparable to type '{1}'."),
	        A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void: diag(2679, ts.DiagnosticCategory.Error, "A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void_2679", "A function that is called with the 'new' keyword cannot have a 'this' type that is 'void'."),
	        A_0_parameter_must_be_the_first_parameter: diag(2680, ts.DiagnosticCategory.Error, "A_0_parameter_must_be_the_first_parameter_2680", "A '{0}' parameter must be the first parameter."),
	        A_constructor_cannot_have_a_this_parameter: diag(2681, ts.DiagnosticCategory.Error, "A_constructor_cannot_have_a_this_parameter_2681", "A constructor cannot have a 'this' parameter."),
	        get_and_set_accessor_must_have_the_same_this_type: diag(2682, ts.DiagnosticCategory.Error, "get_and_set_accessor_must_have_the_same_this_type_2682", "'get' and 'set' accessor must have the same 'this' type."),
	        this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation: diag(2683, ts.DiagnosticCategory.Error, "this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_2683", "'this' implicitly has type 'any' because it does not have a type annotation."),
	        The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1: diag(2684, ts.DiagnosticCategory.Error, "The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1_2684", "The 'this' context of type '{0}' is not assignable to method's 'this' of type '{1}'."),
	        The_this_types_of_each_signature_are_incompatible: diag(2685, ts.DiagnosticCategory.Error, "The_this_types_of_each_signature_are_incompatible_2685", "The 'this' types of each signature are incompatible."),
	        _0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead: diag(2686, ts.DiagnosticCategory.Error, "_0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead_2686", "'{0}' refers to a UMD global, but the current file is a module. Consider adding an import instead."),
	        All_declarations_of_0_must_have_identical_modifiers: diag(2687, ts.DiagnosticCategory.Error, "All_declarations_of_0_must_have_identical_modifiers_2687", "All declarations of '{0}' must have identical modifiers."),
	        Cannot_find_type_definition_file_for_0: diag(2688, ts.DiagnosticCategory.Error, "Cannot_find_type_definition_file_for_0_2688", "Cannot find type definition file for '{0}'."),
	        Cannot_extend_an_interface_0_Did_you_mean_implements: diag(2689, ts.DiagnosticCategory.Error, "Cannot_extend_an_interface_0_Did_you_mean_implements_2689", "Cannot extend an interface '{0}'. Did you mean 'implements'?"),
	        An_import_path_cannot_end_with_a_0_extension_Consider_importing_1_instead: diag(2691, ts.DiagnosticCategory.Error, "An_import_path_cannot_end_with_a_0_extension_Consider_importing_1_instead_2691", "An import path cannot end with a '{0}' extension. Consider importing '{1}' instead."),
	        _0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible: diag(2692, ts.DiagnosticCategory.Error, "_0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible_2692", "'{0}' is a primitive, but '{1}' is a wrapper object. Prefer using '{0}' when possible."),
	        _0_only_refers_to_a_type_but_is_being_used_as_a_value_here: diag(2693, ts.DiagnosticCategory.Error, "_0_only_refers_to_a_type_but_is_being_used_as_a_value_here_2693", "'{0}' only refers to a type, but is being used as a value here."),
	        Namespace_0_has_no_exported_member_1: diag(2694, ts.DiagnosticCategory.Error, "Namespace_0_has_no_exported_member_1_2694", "Namespace '{0}' has no exported member '{1}'."),
	        Left_side_of_comma_operator_is_unused_and_has_no_side_effects: diag(2695, ts.DiagnosticCategory.Error, "Left_side_of_comma_operator_is_unused_and_has_no_side_effects_2695", "Left side of comma operator is unused and has no side effects."),
	        The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead: diag(2696, ts.DiagnosticCategory.Error, "The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead_2696", "The 'Object' type is assignable to very few other types. Did you mean to use the 'any' type instead?"),
	        An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option: diag(2697, ts.DiagnosticCategory.Error, "An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_in_2697", "An async function or method must return a 'Promise'. Make sure you have a declaration for 'Promise' or include 'ES2015' in your `--lib` option."),
	        Spread_types_may_only_be_created_from_object_types: diag(2698, ts.DiagnosticCategory.Error, "Spread_types_may_only_be_created_from_object_types_2698", "Spread types may only be created from object types."),
	        Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1: diag(2699, ts.DiagnosticCategory.Error, "Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1_2699", "Static property '{0}' conflicts with built-in property 'Function.{0}' of constructor function '{1}'."),
	        Rest_types_may_only_be_created_from_object_types: diag(2700, ts.DiagnosticCategory.Error, "Rest_types_may_only_be_created_from_object_types_2700", "Rest types may only be created from object types."),
	        The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access: diag(2701, ts.DiagnosticCategory.Error, "The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access_2701", "The target of an object rest assignment must be a variable or a property access."),
	        _0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here: diag(2702, ts.DiagnosticCategory.Error, "_0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here_2702", "'{0}' only refers to a type, but is being used as a namespace here."),
	        The_operand_of_a_delete_operator_must_be_a_property_reference: diag(2703, ts.DiagnosticCategory.Error, "The_operand_of_a_delete_operator_must_be_a_property_reference_2703", "The operand of a delete operator must be a property reference."),
	        The_operand_of_a_delete_operator_cannot_be_a_read_only_property: diag(2704, ts.DiagnosticCategory.Error, "The_operand_of_a_delete_operator_cannot_be_a_read_only_property_2704", "The operand of a delete operator cannot be a read-only property."),
	        An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option: diag(2705, ts.DiagnosticCategory.Error, "An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_de_2705", "An async function or method in ES5/ES3 requires the 'Promise' constructor.  Make sure you have a declaration for the 'Promise' constructor or include 'ES2015' in your `--lib` option."),
	        Required_type_parameters_may_not_follow_optional_type_parameters: diag(2706, ts.DiagnosticCategory.Error, "Required_type_parameters_may_not_follow_optional_type_parameters_2706", "Required type parameters may not follow optional type parameters."),
	        Generic_type_0_requires_between_1_and_2_type_arguments: diag(2707, ts.DiagnosticCategory.Error, "Generic_type_0_requires_between_1_and_2_type_arguments_2707", "Generic type '{0}' requires between {1} and {2} type arguments."),
	        Cannot_use_namespace_0_as_a_value: diag(2708, ts.DiagnosticCategory.Error, "Cannot_use_namespace_0_as_a_value_2708", "Cannot use namespace '{0}' as a value."),
	        Cannot_use_namespace_0_as_a_type: diag(2709, ts.DiagnosticCategory.Error, "Cannot_use_namespace_0_as_a_type_2709", "Cannot use namespace '{0}' as a type."),
	        _0_are_specified_twice_The_attribute_named_0_will_be_overwritten: diag(2710, ts.DiagnosticCategory.Error, "_0_are_specified_twice_The_attribute_named_0_will_be_overwritten_2710", "'{0}' are specified twice. The attribute named '{0}' will be overwritten."),
	        A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option: diag(2711, ts.DiagnosticCategory.Error, "A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES20_2711", "A dynamic import call returns a 'Promise'. Make sure you have a declaration for 'Promise' or include 'ES2015' in your `--lib` option."),
	        A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option: diag(2712, ts.DiagnosticCategory.Error, "A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declarat_2712", "A dynamic import call in ES5/ES3 requires the 'Promise' constructor.  Make sure you have a declaration for the 'Promise' constructor or include 'ES2015' in your `--lib` option."),
	        Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1: diag(2713, ts.DiagnosticCategory.Error, "Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_p_2713", "Cannot access '{0}.{1}' because '{0}' is a type, but not a namespace. Did you mean to retrieve the type of the property '{1}' in '{0}' with '{0}[\"{1}\"]'?"),
	        The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context: diag(2714, ts.DiagnosticCategory.Error, "The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context_2714", "The expression of an export assignment must be an identifier or qualified name in an ambient context."),
	        Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor: diag(2715, ts.DiagnosticCategory.Error, "Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor_2715", "Abstract property '{0}' in class '{1}' cannot be accessed in the constructor."),
	        Type_parameter_0_has_a_circular_default: diag(2716, ts.DiagnosticCategory.Error, "Type_parameter_0_has_a_circular_default_2716", "Type parameter '{0}' has a circular default."),
	        Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_type_2: diag(2717, ts.DiagnosticCategory.Error, "Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_t_2717", "Subsequent property declarations must have the same type.  Property '{0}' must be of type '{1}', but here has type '{2}'."),
	        Duplicate_declaration_0: diag(2718, ts.DiagnosticCategory.Error, "Duplicate_declaration_0_2718", "Duplicate declaration '{0}'."),
	        Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated: diag(2719, ts.DiagnosticCategory.Error, "Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated_2719", "Type '{0}' is not assignable to type '{1}'. Two different types with this name exist, but they are unrelated."),
	        Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass: diag(2720, ts.DiagnosticCategory.Error, "Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclas_2720", "Class '{0}' incorrectly implements class '{1}'. Did you mean to extend '{1}' and inherit its members as a subclass?"),
	        Cannot_invoke_an_object_which_is_possibly_null: diag(2721, ts.DiagnosticCategory.Error, "Cannot_invoke_an_object_which_is_possibly_null_2721", "Cannot invoke an object which is possibly 'null'."),
	        Cannot_invoke_an_object_which_is_possibly_undefined: diag(2722, ts.DiagnosticCategory.Error, "Cannot_invoke_an_object_which_is_possibly_undefined_2722", "Cannot invoke an object which is possibly 'undefined'."),
	        Cannot_invoke_an_object_which_is_possibly_null_or_undefined: diag(2723, ts.DiagnosticCategory.Error, "Cannot_invoke_an_object_which_is_possibly_null_or_undefined_2723", "Cannot invoke an object which is possibly 'null' or 'undefined'."),
	        Import_declaration_0_is_using_private_name_1: diag(4000, ts.DiagnosticCategory.Error, "Import_declaration_0_is_using_private_name_1_4000", "Import declaration '{0}' is using private name '{1}'."),
	        Type_parameter_0_of_exported_class_has_or_is_using_private_name_1: diag(4002, ts.DiagnosticCategory.Error, "Type_parameter_0_of_exported_class_has_or_is_using_private_name_1_4002", "Type parameter '{0}' of exported class has or is using private name '{1}'."),
	        Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1: diag(4004, ts.DiagnosticCategory.Error, "Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1_4004", "Type parameter '{0}' of exported interface has or is using private name '{1}'."),
	        Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4006, ts.DiagnosticCategory.Error, "Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1_4006", "Type parameter '{0}' of constructor signature from exported interface has or is using private name '{1}'."),
	        Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4008, ts.DiagnosticCategory.Error, "Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1_4008", "Type parameter '{0}' of call signature from exported interface has or is using private name '{1}'."),
	        Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1: diag(4010, ts.DiagnosticCategory.Error, "Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1_4010", "Type parameter '{0}' of public static method from exported class has or is using private name '{1}'."),
	        Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1: diag(4012, ts.DiagnosticCategory.Error, "Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1_4012", "Type parameter '{0}' of public method from exported class has or is using private name '{1}'."),
	        Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1: diag(4014, ts.DiagnosticCategory.Error, "Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1_4014", "Type parameter '{0}' of method from exported interface has or is using private name '{1}'."),
	        Type_parameter_0_of_exported_function_has_or_is_using_private_name_1: diag(4016, ts.DiagnosticCategory.Error, "Type_parameter_0_of_exported_function_has_or_is_using_private_name_1_4016", "Type parameter '{0}' of exported function has or is using private name '{1}'."),
	        Implements_clause_of_exported_class_0_has_or_is_using_private_name_1: diag(4019, ts.DiagnosticCategory.Error, "Implements_clause_of_exported_class_0_has_or_is_using_private_name_1_4019", "Implements clause of exported class '{0}' has or is using private name '{1}'."),
	        extends_clause_of_exported_class_0_has_or_is_using_private_name_1: diag(4020, ts.DiagnosticCategory.Error, "extends_clause_of_exported_class_0_has_or_is_using_private_name_1_4020", "'extends' clause of exported class '{0}' has or is using private name '{1}'."),
	        extends_clause_of_exported_interface_0_has_or_is_using_private_name_1: diag(4022, ts.DiagnosticCategory.Error, "extends_clause_of_exported_interface_0_has_or_is_using_private_name_1_4022", "'extends' clause of exported interface '{0}' has or is using private name '{1}'."),
	        Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4023, ts.DiagnosticCategory.Error, "Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4023", "Exported variable '{0}' has or is using name '{1}' from external module {2} but cannot be named."),
	        Exported_variable_0_has_or_is_using_name_1_from_private_module_2: diag(4024, ts.DiagnosticCategory.Error, "Exported_variable_0_has_or_is_using_name_1_from_private_module_2_4024", "Exported variable '{0}' has or is using name '{1}' from private module '{2}'."),
	        Exported_variable_0_has_or_is_using_private_name_1: diag(4025, ts.DiagnosticCategory.Error, "Exported_variable_0_has_or_is_using_private_name_1_4025", "Exported variable '{0}' has or is using private name '{1}'."),
	        Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4026, ts.DiagnosticCategory.Error, "Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot__4026", "Public static property '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4027, ts.DiagnosticCategory.Error, "Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4027", "Public static property '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
	        Public_static_property_0_of_exported_class_has_or_is_using_private_name_1: diag(4028, ts.DiagnosticCategory.Error, "Public_static_property_0_of_exported_class_has_or_is_using_private_name_1_4028", "Public static property '{0}' of exported class has or is using private name '{1}'."),
	        Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4029, ts.DiagnosticCategory.Error, "Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_name_4029", "Public property '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4030, ts.DiagnosticCategory.Error, "Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4030", "Public property '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
	        Public_property_0_of_exported_class_has_or_is_using_private_name_1: diag(4031, ts.DiagnosticCategory.Error, "Public_property_0_of_exported_class_has_or_is_using_private_name_1_4031", "Public property '{0}' of exported class has or is using private name '{1}'."),
	        Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4032, ts.DiagnosticCategory.Error, "Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2_4032", "Property '{0}' of exported interface has or is using name '{1}' from private module '{2}'."),
	        Property_0_of_exported_interface_has_or_is_using_private_name_1: diag(4033, ts.DiagnosticCategory.Error, "Property_0_of_exported_interface_has_or_is_using_private_name_1_4033", "Property '{0}' of exported interface has or is using private name '{1}'."),
	        Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4034, ts.DiagnosticCategory.Error, "Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_mod_4034", "Parameter type of public static setter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1: diag(4035, ts.DiagnosticCategory.Error, "Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1_4035", "Parameter type of public static setter '{0}' from exported class has or is using private name '{1}'."),
	        Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4036, ts.DiagnosticCategory.Error, "Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2_4036", "Parameter type of public setter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1: diag(4037, ts.DiagnosticCategory.Error, "Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1_4037", "Parameter type of public setter '{0}' from exported class has or is using private name '{1}'."),
	        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4038, ts.DiagnosticCategory.Error, "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_modul_4038", "Return type of public static getter '{0}' from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4039, ts.DiagnosticCategory.Error, "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_4039", "Return type of public static getter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
	        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1: diag(4040, ts.DiagnosticCategory.Error, "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1_4040", "Return type of public static getter '{0}' from exported class has or is using private name '{1}'."),
	        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4041, ts.DiagnosticCategory.Error, "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_4041", "Return type of public getter '{0}' from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4042, ts.DiagnosticCategory.Error, "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2_4042", "Return type of public getter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
	        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1: diag(4043, ts.DiagnosticCategory.Error, "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1_4043", "Return type of public getter '{0}' from exported class has or is using private name '{1}'."),
	        Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4044, ts.DiagnosticCategory.Error, "Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_mod_4044", "Return type of constructor signature from exported interface has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4045, ts.DiagnosticCategory.Error, "Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0_4045", "Return type of constructor signature from exported interface has or is using private name '{0}'."),
	        Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4046, ts.DiagnosticCategory.Error, "Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4046", "Return type of call signature from exported interface has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4047, ts.DiagnosticCategory.Error, "Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0_4047", "Return type of call signature from exported interface has or is using private name '{0}'."),
	        Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4048, ts.DiagnosticCategory.Error, "Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4048", "Return type of index signature from exported interface has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4049, ts.DiagnosticCategory.Error, "Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0_4049", "Return type of index signature from exported interface has or is using private name '{0}'."),
	        Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4050, ts.DiagnosticCategory.Error, "Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module__4050", "Return type of public static method from exported class has or is using name '{0}' from external module {1} but cannot be named."),
	        Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1: diag(4051, ts.DiagnosticCategory.Error, "Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1_4051", "Return type of public static method from exported class has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0: diag(4052, ts.DiagnosticCategory.Error, "Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0_4052", "Return type of public static method from exported class has or is using private name '{0}'."),
	        Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4053, ts.DiagnosticCategory.Error, "Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_c_4053", "Return type of public method from exported class has or is using name '{0}' from external module {1} but cannot be named."),
	        Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1: diag(4054, ts.DiagnosticCategory.Error, "Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1_4054", "Return type of public method from exported class has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0: diag(4055, ts.DiagnosticCategory.Error, "Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0_4055", "Return type of public method from exported class has or is using private name '{0}'."),
	        Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4056, ts.DiagnosticCategory.Error, "Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4056", "Return type of method from exported interface has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0: diag(4057, ts.DiagnosticCategory.Error, "Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0_4057", "Return type of method from exported interface has or is using private name '{0}'."),
	        Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4058, ts.DiagnosticCategory.Error, "Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named_4058", "Return type of exported function has or is using name '{0}' from external module {1} but cannot be named."),
	        Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1: diag(4059, ts.DiagnosticCategory.Error, "Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1_4059", "Return type of exported function has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_exported_function_has_or_is_using_private_name_0: diag(4060, ts.DiagnosticCategory.Error, "Return_type_of_exported_function_has_or_is_using_private_name_0_4060", "Return type of exported function has or is using private name '{0}'."),
	        Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4061, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_can_4061", "Parameter '{0}' of constructor from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4062, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2_4062", "Parameter '{0}' of constructor from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1: diag(4063, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1_4063", "Parameter '{0}' of constructor from exported class has or is using private name '{1}'."),
	        Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4064, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_mod_4064", "Parameter '{0}' of constructor signature from exported interface has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4065, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1_4065", "Parameter '{0}' of constructor signature from exported interface has or is using private name '{1}'."),
	        Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4066, ts.DiagnosticCategory.Error, "Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4066", "Parameter '{0}' of call signature from exported interface has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4067, ts.DiagnosticCategory.Error, "Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1_4067", "Parameter '{0}' of call signature from exported interface has or is using private name '{1}'."),
	        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4068, ts.DiagnosticCategory.Error, "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module__4068", "Parameter '{0}' of public static method from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4069, ts.DiagnosticCategory.Error, "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2_4069", "Parameter '{0}' of public static method from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1: diag(4070, ts.DiagnosticCategory.Error, "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1_4070", "Parameter '{0}' of public static method from exported class has or is using private name '{1}'."),
	        Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4071, ts.DiagnosticCategory.Error, "Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_c_4071", "Parameter '{0}' of public method from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4072, ts.DiagnosticCategory.Error, "Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2_4072", "Parameter '{0}' of public method from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1: diag(4073, ts.DiagnosticCategory.Error, "Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1_4073", "Parameter '{0}' of public method from exported class has or is using private name '{1}'."),
	        Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4074, ts.DiagnosticCategory.Error, "Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4074", "Parameter '{0}' of method from exported interface has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1: diag(4075, ts.DiagnosticCategory.Error, "Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1_4075", "Parameter '{0}' of method from exported interface has or is using private name '{1}'."),
	        Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4076, ts.DiagnosticCategory.Error, "Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4076", "Parameter '{0}' of exported function has or is using name '{1}' from external module {2} but cannot be named."),
	        Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2: diag(4077, ts.DiagnosticCategory.Error, "Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2_4077", "Parameter '{0}' of exported function has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_exported_function_has_or_is_using_private_name_1: diag(4078, ts.DiagnosticCategory.Error, "Parameter_0_of_exported_function_has_or_is_using_private_name_1_4078", "Parameter '{0}' of exported function has or is using private name '{1}'."),
	        Exported_type_alias_0_has_or_is_using_private_name_1: diag(4081, ts.DiagnosticCategory.Error, "Exported_type_alias_0_has_or_is_using_private_name_1_4081", "Exported type alias '{0}' has or is using private name '{1}'."),
	        Default_export_of_the_module_has_or_is_using_private_name_0: diag(4082, ts.DiagnosticCategory.Error, "Default_export_of_the_module_has_or_is_using_private_name_0_4082", "Default export of the module has or is using private name '{0}'."),
	        Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1: diag(4083, ts.DiagnosticCategory.Error, "Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1_4083", "Type parameter '{0}' of exported type alias has or is using private name '{1}'."),
	        Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_library_to_resolve_the_conflict: diag(4090, ts.DiagnosticCategory.Message, "Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_librar_4090", "Conflicting definitions for '{0}' found at '{1}' and '{2}'. Consider installing a specific version of this library to resolve the conflict."),
	        Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4091, ts.DiagnosticCategory.Error, "Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4091", "Parameter '{0}' of index signature from exported interface has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4092, ts.DiagnosticCategory.Error, "Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1_4092", "Parameter '{0}' of index signature from exported interface has or is using private name '{1}'."),
	        Property_0_of_exported_class_expression_may_not_be_private_or_protected: diag(4094, ts.DiagnosticCategory.Error, "Property_0_of_exported_class_expression_may_not_be_private_or_protected_4094", "Property '{0}' of exported class expression may not be private or protected."),
	        Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4095, ts.DiagnosticCategory.Error, "Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_4095", "Public static method '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4096, ts.DiagnosticCategory.Error, "Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4096", "Public static method '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
	        Public_static_method_0_of_exported_class_has_or_is_using_private_name_1: diag(4097, ts.DiagnosticCategory.Error, "Public_static_method_0_of_exported_class_has_or_is_using_private_name_1_4097", "Public static method '{0}' of exported class has or is using private name '{1}'."),
	        Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4098, ts.DiagnosticCategory.Error, "Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4098", "Public method '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4099, ts.DiagnosticCategory.Error, "Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4099", "Public method '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
	        Public_method_0_of_exported_class_has_or_is_using_private_name_1: diag(4100, ts.DiagnosticCategory.Error, "Public_method_0_of_exported_class_has_or_is_using_private_name_1_4100", "Public method '{0}' of exported class has or is using private name '{1}'."),
	        Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4101, ts.DiagnosticCategory.Error, "Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2_4101", "Method '{0}' of exported interface has or is using name '{1}' from private module '{2}'."),
	        Method_0_of_exported_interface_has_or_is_using_private_name_1: diag(4102, ts.DiagnosticCategory.Error, "Method_0_of_exported_interface_has_or_is_using_private_name_1_4102", "Method '{0}' of exported interface has or is using private name '{1}'."),
	        The_current_host_does_not_support_the_0_option: diag(5001, ts.DiagnosticCategory.Error, "The_current_host_does_not_support_the_0_option_5001", "The current host does not support the '{0}' option."),
	        Cannot_find_the_common_subdirectory_path_for_the_input_files: diag(5009, ts.DiagnosticCategory.Error, "Cannot_find_the_common_subdirectory_path_for_the_input_files_5009", "Cannot find the common subdirectory path for the input files."),
	        File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0: diag(5010, ts.DiagnosticCategory.Error, "File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0_5010", "File specification cannot end in a recursive directory wildcard ('**'): '{0}'."),
	        Cannot_read_file_0_Colon_1: diag(5012, ts.DiagnosticCategory.Error, "Cannot_read_file_0_Colon_1_5012", "Cannot read file '{0}': {1}."),
	        Failed_to_parse_file_0_Colon_1: diag(5014, ts.DiagnosticCategory.Error, "Failed_to_parse_file_0_Colon_1_5014", "Failed to parse file '{0}': {1}."),
	        Unknown_compiler_option_0: diag(5023, ts.DiagnosticCategory.Error, "Unknown_compiler_option_0_5023", "Unknown compiler option '{0}'."),
	        Compiler_option_0_requires_a_value_of_type_1: diag(5024, ts.DiagnosticCategory.Error, "Compiler_option_0_requires_a_value_of_type_1_5024", "Compiler option '{0}' requires a value of type {1}."),
	        Could_not_write_file_0_Colon_1: diag(5033, ts.DiagnosticCategory.Error, "Could_not_write_file_0_Colon_1_5033", "Could not write file '{0}': {1}."),
	        Option_project_cannot_be_mixed_with_source_files_on_a_command_line: diag(5042, ts.DiagnosticCategory.Error, "Option_project_cannot_be_mixed_with_source_files_on_a_command_line_5042", "Option 'project' cannot be mixed with source files on a command line."),
	        Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES2015_or_higher: diag(5047, ts.DiagnosticCategory.Error, "Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES_5047", "Option 'isolatedModules' can only be used when either option '--module' is provided or option 'target' is 'ES2015' or higher."),
	        Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided: diag(5051, ts.DiagnosticCategory.Error, "Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided_5051", "Option '{0} can only be used when either option '--inlineSourceMap' or option '--sourceMap' is provided."),
	        Option_0_cannot_be_specified_without_specifying_option_1: diag(5052, ts.DiagnosticCategory.Error, "Option_0_cannot_be_specified_without_specifying_option_1_5052", "Option '{0}' cannot be specified without specifying option '{1}'."),
	        Option_0_cannot_be_specified_with_option_1: diag(5053, ts.DiagnosticCategory.Error, "Option_0_cannot_be_specified_with_option_1_5053", "Option '{0}' cannot be specified with option '{1}'."),
	        A_tsconfig_json_file_is_already_defined_at_Colon_0: diag(5054, ts.DiagnosticCategory.Error, "A_tsconfig_json_file_is_already_defined_at_Colon_0_5054", "A 'tsconfig.json' file is already defined at: '{0}'."),
	        Cannot_write_file_0_because_it_would_overwrite_input_file: diag(5055, ts.DiagnosticCategory.Error, "Cannot_write_file_0_because_it_would_overwrite_input_file_5055", "Cannot write file '{0}' because it would overwrite input file."),
	        Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files: diag(5056, ts.DiagnosticCategory.Error, "Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files_5056", "Cannot write file '{0}' because it would be overwritten by multiple input files."),
	        Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0: diag(5057, ts.DiagnosticCategory.Error, "Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0_5057", "Cannot find a tsconfig.json file at the specified directory: '{0}'."),
	        The_specified_path_does_not_exist_Colon_0: diag(5058, ts.DiagnosticCategory.Error, "The_specified_path_does_not_exist_Colon_0_5058", "The specified path does not exist: '{0}'."),
	        Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier: diag(5059, ts.DiagnosticCategory.Error, "Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier_5059", "Invalid value for '--reactNamespace'. '{0}' is not a valid identifier."),
	        Option_paths_cannot_be_used_without_specifying_baseUrl_option: diag(5060, ts.DiagnosticCategory.Error, "Option_paths_cannot_be_used_without_specifying_baseUrl_option_5060", "Option 'paths' cannot be used without specifying '--baseUrl' option."),
	        Pattern_0_can_have_at_most_one_Asterisk_character: diag(5061, ts.DiagnosticCategory.Error, "Pattern_0_can_have_at_most_one_Asterisk_character_5061", "Pattern '{0}' can have at most one '*' character."),
	        Substitution_0_in_pattern_1_in_can_have_at_most_one_Asterisk_character: diag(5062, ts.DiagnosticCategory.Error, "Substitution_0_in_pattern_1_in_can_have_at_most_one_Asterisk_character_5062", "Substitution '{0}' in pattern '{1}' in can have at most one '*' character."),
	        Substitutions_for_pattern_0_should_be_an_array: diag(5063, ts.DiagnosticCategory.Error, "Substitutions_for_pattern_0_should_be_an_array_5063", "Substitutions for pattern '{0}' should be an array."),
	        Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2: diag(5064, ts.DiagnosticCategory.Error, "Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2_5064", "Substitution '{0}' for pattern '{1}' has incorrect type, expected 'string', got '{2}'."),
	        File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0: diag(5065, ts.DiagnosticCategory.Error, "File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildca_5065", "File specification cannot contain a parent directory ('..') that appears after a recursive directory wildcard ('**'): '{0}'."),
	        Substitutions_for_pattern_0_shouldn_t_be_an_empty_array: diag(5066, ts.DiagnosticCategory.Error, "Substitutions_for_pattern_0_shouldn_t_be_an_empty_array_5066", "Substitutions for pattern '{0}' shouldn't be an empty array."),
	        Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name: diag(5067, ts.DiagnosticCategory.Error, "Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name_5067", "Invalid value for 'jsxFactory'. '{0}' is not a valid identifier or qualified-name."),
	        Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript_files_Learn_more_at_https_Colon_Slash_Slashaka_ms_Slashtsconfig: diag(5068, ts.DiagnosticCategory.Error, "Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript__5068", "Adding a tsconfig.json file will help organize projects that contain both TypeScript and JavaScript files. Learn more at https://aka.ms/tsconfig."),
	        Concatenate_and_emit_output_to_single_file: diag(6001, ts.DiagnosticCategory.Message, "Concatenate_and_emit_output_to_single_file_6001", "Concatenate and emit output to single file."),
	        Generates_corresponding_d_ts_file: diag(6002, ts.DiagnosticCategory.Message, "Generates_corresponding_d_ts_file_6002", "Generates corresponding '.d.ts' file."),
	        Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations: diag(6003, ts.DiagnosticCategory.Message, "Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations_6003", "Specify the location where debugger should locate map files instead of generated locations."),
	        Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations: diag(6004, ts.DiagnosticCategory.Message, "Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations_6004", "Specify the location where debugger should locate TypeScript files instead of source locations."),
	        Watch_input_files: diag(6005, ts.DiagnosticCategory.Message, "Watch_input_files_6005", "Watch input files."),
	        Redirect_output_structure_to_the_directory: diag(6006, ts.DiagnosticCategory.Message, "Redirect_output_structure_to_the_directory_6006", "Redirect output structure to the directory."),
	        Do_not_erase_const_enum_declarations_in_generated_code: diag(6007, ts.DiagnosticCategory.Message, "Do_not_erase_const_enum_declarations_in_generated_code_6007", "Do not erase const enum declarations in generated code."),
	        Do_not_emit_outputs_if_any_errors_were_reported: diag(6008, ts.DiagnosticCategory.Message, "Do_not_emit_outputs_if_any_errors_were_reported_6008", "Do not emit outputs if any errors were reported."),
	        Do_not_emit_comments_to_output: diag(6009, ts.DiagnosticCategory.Message, "Do_not_emit_comments_to_output_6009", "Do not emit comments to output."),
	        Do_not_emit_outputs: diag(6010, ts.DiagnosticCategory.Message, "Do_not_emit_outputs_6010", "Do not emit outputs."),
	        Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typechecking: diag(6011, ts.DiagnosticCategory.Message, "Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typech_6011", "Allow default imports from modules with no default export. This does not affect code emit, just typechecking."),
	        Skip_type_checking_of_declaration_files: diag(6012, ts.DiagnosticCategory.Message, "Skip_type_checking_of_declaration_files_6012", "Skip type checking of declaration files."),
	        Do_not_resolve_the_real_path_of_symlinks: diag(6013, ts.DiagnosticCategory.Message, "Do_not_resolve_the_real_path_of_symlinks_6013", "Do not resolve the real path of symlinks."),
	        Only_emit_d_ts_declaration_files: diag(6014, ts.DiagnosticCategory.Message, "Only_emit_d_ts_declaration_files_6014", "Only emit '.d.ts' declaration files."),
	        Specify_ECMAScript_target_version_Colon_ES3_default_ES5_ES2015_ES2016_ES2017_ES2018_or_ESNEXT: diag(6015, ts.DiagnosticCategory.Message, "Specify_ECMAScript_target_version_Colon_ES3_default_ES5_ES2015_ES2016_ES2017_ES2018_or_ESNEXT_6015", "Specify ECMAScript target version: 'ES3' (default), 'ES5', 'ES2015', 'ES2016', 'ES2017','ES2018' or 'ESNEXT'."),
	        Specify_module_code_generation_Colon_none_commonjs_amd_system_umd_es2015_or_ESNext: diag(6016, ts.DiagnosticCategory.Message, "Specify_module_code_generation_Colon_none_commonjs_amd_system_umd_es2015_or_ESNext_6016", "Specify module code generation: 'none', 'commonjs', 'amd', 'system', 'umd', 'es2015', or 'ESNext'."),
	        Print_this_message: diag(6017, ts.DiagnosticCategory.Message, "Print_this_message_6017", "Print this message."),
	        Print_the_compiler_s_version: diag(6019, ts.DiagnosticCategory.Message, "Print_the_compiler_s_version_6019", "Print the compiler's version."),
	        Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json: diag(6020, ts.DiagnosticCategory.Message, "Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json_6020", "Compile the project given the path to its configuration file, or to a folder with a 'tsconfig.json'."),
	        Syntax_Colon_0: diag(6023, ts.DiagnosticCategory.Message, "Syntax_Colon_0_6023", "Syntax: {0}"),
	        options: diag(6024, ts.DiagnosticCategory.Message, "options_6024", "options"),
	        file: diag(6025, ts.DiagnosticCategory.Message, "file_6025", "file"),
	        Examples_Colon_0: diag(6026, ts.DiagnosticCategory.Message, "Examples_Colon_0_6026", "Examples: {0}"),
	        Options_Colon: diag(6027, ts.DiagnosticCategory.Message, "Options_Colon_6027", "Options:"),
	        Version_0: diag(6029, ts.DiagnosticCategory.Message, "Version_0_6029", "Version {0}"),
	        Insert_command_line_options_and_files_from_a_file: diag(6030, ts.DiagnosticCategory.Message, "Insert_command_line_options_and_files_from_a_file_6030", "Insert command line options and files from a file."),
	        Starting_compilation_in_watch_mode: diag(6031, ts.DiagnosticCategory.Message, "Starting_compilation_in_watch_mode_6031", "Starting compilation in watch mode..."),
	        File_change_detected_Starting_incremental_compilation: diag(6032, ts.DiagnosticCategory.Message, "File_change_detected_Starting_incremental_compilation_6032", "File change detected. Starting incremental compilation..."),
	        KIND: diag(6034, ts.DiagnosticCategory.Message, "KIND_6034", "KIND"),
	        FILE: diag(6035, ts.DiagnosticCategory.Message, "FILE_6035", "FILE"),
	        VERSION: diag(6036, ts.DiagnosticCategory.Message, "VERSION_6036", "VERSION"),
	        LOCATION: diag(6037, ts.DiagnosticCategory.Message, "LOCATION_6037", "LOCATION"),
	        DIRECTORY: diag(6038, ts.DiagnosticCategory.Message, "DIRECTORY_6038", "DIRECTORY"),
	        STRATEGY: diag(6039, ts.DiagnosticCategory.Message, "STRATEGY_6039", "STRATEGY"),
	        FILE_OR_DIRECTORY: diag(6040, ts.DiagnosticCategory.Message, "FILE_OR_DIRECTORY_6040", "FILE OR DIRECTORY"),
	        Compilation_complete_Watching_for_file_changes: diag(6042, ts.DiagnosticCategory.Message, "Compilation_complete_Watching_for_file_changes_6042", "Compilation complete. Watching for file changes."),
	        Generates_corresponding_map_file: diag(6043, ts.DiagnosticCategory.Message, "Generates_corresponding_map_file_6043", "Generates corresponding '.map' file."),
	        Compiler_option_0_expects_an_argument: diag(6044, ts.DiagnosticCategory.Error, "Compiler_option_0_expects_an_argument_6044", "Compiler option '{0}' expects an argument."),
	        Unterminated_quoted_string_in_response_file_0: diag(6045, ts.DiagnosticCategory.Error, "Unterminated_quoted_string_in_response_file_0_6045", "Unterminated quoted string in response file '{0}'."),
	        Argument_for_0_option_must_be_Colon_1: diag(6046, ts.DiagnosticCategory.Error, "Argument_for_0_option_must_be_Colon_1_6046", "Argument for '{0}' option must be: {1}."),
	        Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1: diag(6048, ts.DiagnosticCategory.Error, "Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1_6048", "Locale must be of the form <language> or <language>-<territory>. For example '{0}' or '{1}'."),
	        Unsupported_locale_0: diag(6049, ts.DiagnosticCategory.Error, "Unsupported_locale_0_6049", "Unsupported locale '{0}'."),
	        Unable_to_open_file_0: diag(6050, ts.DiagnosticCategory.Error, "Unable_to_open_file_0_6050", "Unable to open file '{0}'."),
	        Corrupted_locale_file_0: diag(6051, ts.DiagnosticCategory.Error, "Corrupted_locale_file_0_6051", "Corrupted locale file {0}."),
	        Raise_error_on_expressions_and_declarations_with_an_implied_any_type: diag(6052, ts.DiagnosticCategory.Message, "Raise_error_on_expressions_and_declarations_with_an_implied_any_type_6052", "Raise error on expressions and declarations with an implied 'any' type."),
	        File_0_not_found: diag(6053, ts.DiagnosticCategory.Error, "File_0_not_found_6053", "File '{0}' not found."),
	        File_0_has_unsupported_extension_The_only_supported_extensions_are_1: diag(6054, ts.DiagnosticCategory.Error, "File_0_has_unsupported_extension_The_only_supported_extensions_are_1_6054", "File '{0}' has unsupported extension. The only supported extensions are {1}."),
	        Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures: diag(6055, ts.DiagnosticCategory.Message, "Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures_6055", "Suppress noImplicitAny errors for indexing objects lacking index signatures."),
	        Do_not_emit_declarations_for_code_that_has_an_internal_annotation: diag(6056, ts.DiagnosticCategory.Message, "Do_not_emit_declarations_for_code_that_has_an_internal_annotation_6056", "Do not emit declarations for code that has an '@internal' annotation."),
	        Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir: diag(6058, ts.DiagnosticCategory.Message, "Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir_6058", "Specify the root directory of input files. Use to control the output directory structure with --outDir."),
	        File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files: diag(6059, ts.DiagnosticCategory.Error, "File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files_6059", "File '{0}' is not under 'rootDir' '{1}'. 'rootDir' is expected to contain all source files."),
	        Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix: diag(6060, ts.DiagnosticCategory.Message, "Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix_6060", "Specify the end of line sequence to be used when emitting files: 'CRLF' (dos) or 'LF' (unix)."),
	        NEWLINE: diag(6061, ts.DiagnosticCategory.Message, "NEWLINE_6061", "NEWLINE"),
	        Option_0_can_only_be_specified_in_tsconfig_json_file: diag(6064, ts.DiagnosticCategory.Error, "Option_0_can_only_be_specified_in_tsconfig_json_file_6064", "Option '{0}' can only be specified in 'tsconfig.json' file."),
	        Enables_experimental_support_for_ES7_decorators: diag(6065, ts.DiagnosticCategory.Message, "Enables_experimental_support_for_ES7_decorators_6065", "Enables experimental support for ES7 decorators."),
	        Enables_experimental_support_for_emitting_type_metadata_for_decorators: diag(6066, ts.DiagnosticCategory.Message, "Enables_experimental_support_for_emitting_type_metadata_for_decorators_6066", "Enables experimental support for emitting type metadata for decorators."),
	        Enables_experimental_support_for_ES7_async_functions: diag(6068, ts.DiagnosticCategory.Message, "Enables_experimental_support_for_ES7_async_functions_6068", "Enables experimental support for ES7 async functions."),
	        Specify_module_resolution_strategy_Colon_node_Node_js_or_classic_TypeScript_pre_1_6: diag(6069, ts.DiagnosticCategory.Message, "Specify_module_resolution_strategy_Colon_node_Node_js_or_classic_TypeScript_pre_1_6_6069", "Specify module resolution strategy: 'node' (Node.js) or 'classic' (TypeScript pre-1.6)."),
	        Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file: diag(6070, ts.DiagnosticCategory.Message, "Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file_6070", "Initializes a TypeScript project and creates a tsconfig.json file."),
	        Successfully_created_a_tsconfig_json_file: diag(6071, ts.DiagnosticCategory.Message, "Successfully_created_a_tsconfig_json_file_6071", "Successfully created a tsconfig.json file."),
	        Suppress_excess_property_checks_for_object_literals: diag(6072, ts.DiagnosticCategory.Message, "Suppress_excess_property_checks_for_object_literals_6072", "Suppress excess property checks for object literals."),
	        Stylize_errors_and_messages_using_color_and_context_experimental: diag(6073, ts.DiagnosticCategory.Message, "Stylize_errors_and_messages_using_color_and_context_experimental_6073", "Stylize errors and messages using color and context (experimental)."),
	        Do_not_report_errors_on_unused_labels: diag(6074, ts.DiagnosticCategory.Message, "Do_not_report_errors_on_unused_labels_6074", "Do not report errors on unused labels."),
	        Report_error_when_not_all_code_paths_in_function_return_a_value: diag(6075, ts.DiagnosticCategory.Message, "Report_error_when_not_all_code_paths_in_function_return_a_value_6075", "Report error when not all code paths in function return a value."),
	        Report_errors_for_fallthrough_cases_in_switch_statement: diag(6076, ts.DiagnosticCategory.Message, "Report_errors_for_fallthrough_cases_in_switch_statement_6076", "Report errors for fallthrough cases in switch statement."),
	        Do_not_report_errors_on_unreachable_code: diag(6077, ts.DiagnosticCategory.Message, "Do_not_report_errors_on_unreachable_code_6077", "Do not report errors on unreachable code."),
	        Disallow_inconsistently_cased_references_to_the_same_file: diag(6078, ts.DiagnosticCategory.Message, "Disallow_inconsistently_cased_references_to_the_same_file_6078", "Disallow inconsistently-cased references to the same file."),
	        Specify_library_files_to_be_included_in_the_compilation: diag(6079, ts.DiagnosticCategory.Message, "Specify_library_files_to_be_included_in_the_compilation_6079", "Specify library files to be included in the compilation."),
	        Specify_JSX_code_generation_Colon_preserve_react_native_or_react: diag(6080, ts.DiagnosticCategory.Message, "Specify_JSX_code_generation_Colon_preserve_react_native_or_react_6080", "Specify JSX code generation: 'preserve', 'react-native', or 'react'."),
	        File_0_has_an_unsupported_extension_so_skipping_it: diag(6081, ts.DiagnosticCategory.Message, "File_0_has_an_unsupported_extension_so_skipping_it_6081", "File '{0}' has an unsupported extension, so skipping it."),
	        Only_amd_and_system_modules_are_supported_alongside_0: diag(6082, ts.DiagnosticCategory.Error, "Only_amd_and_system_modules_are_supported_alongside_0_6082", "Only 'amd' and 'system' modules are supported alongside --{0}."),
	        Base_directory_to_resolve_non_absolute_module_names: diag(6083, ts.DiagnosticCategory.Message, "Base_directory_to_resolve_non_absolute_module_names_6083", "Base directory to resolve non-absolute module names."),
	        Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react_JSX_emit: diag(6084, ts.DiagnosticCategory.Message, "Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react__6084", "[Deprecated] Use '--jsxFactory' instead. Specify the object invoked for createElement when targeting 'react' JSX emit"),
	        Enable_tracing_of_the_name_resolution_process: diag(6085, ts.DiagnosticCategory.Message, "Enable_tracing_of_the_name_resolution_process_6085", "Enable tracing of the name resolution process."),
	        Resolving_module_0_from_1: diag(6086, ts.DiagnosticCategory.Message, "Resolving_module_0_from_1_6086", "======== Resolving module '{0}' from '{1}'. ========"),
	        Explicitly_specified_module_resolution_kind_Colon_0: diag(6087, ts.DiagnosticCategory.Message, "Explicitly_specified_module_resolution_kind_Colon_0_6087", "Explicitly specified module resolution kind: '{0}'."),
	        Module_resolution_kind_is_not_specified_using_0: diag(6088, ts.DiagnosticCategory.Message, "Module_resolution_kind_is_not_specified_using_0_6088", "Module resolution kind is not specified, using '{0}'."),
	        Module_name_0_was_successfully_resolved_to_1: diag(6089, ts.DiagnosticCategory.Message, "Module_name_0_was_successfully_resolved_to_1_6089", "======== Module name '{0}' was successfully resolved to '{1}'. ========"),
	        Module_name_0_was_not_resolved: diag(6090, ts.DiagnosticCategory.Message, "Module_name_0_was_not_resolved_6090", "======== Module name '{0}' was not resolved. ========"),
	        paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0: diag(6091, ts.DiagnosticCategory.Message, "paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0_6091", "'paths' option is specified, looking for a pattern to match module name '{0}'."),
	        Module_name_0_matched_pattern_1: diag(6092, ts.DiagnosticCategory.Message, "Module_name_0_matched_pattern_1_6092", "Module name '{0}', matched pattern '{1}'."),
	        Trying_substitution_0_candidate_module_location_Colon_1: diag(6093, ts.DiagnosticCategory.Message, "Trying_substitution_0_candidate_module_location_Colon_1_6093", "Trying substitution '{0}', candidate module location: '{1}'."),
	        Resolving_module_name_0_relative_to_base_url_1_2: diag(6094, ts.DiagnosticCategory.Message, "Resolving_module_name_0_relative_to_base_url_1_2_6094", "Resolving module name '{0}' relative to base url '{1}' - '{2}'."),
	        Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_type_1: diag(6095, ts.DiagnosticCategory.Message, "Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_type_1_6095", "Loading module as file / folder, candidate module location '{0}', target file type '{1}'."),
	        File_0_does_not_exist: diag(6096, ts.DiagnosticCategory.Message, "File_0_does_not_exist_6096", "File '{0}' does not exist."),
	        File_0_exist_use_it_as_a_name_resolution_result: diag(6097, ts.DiagnosticCategory.Message, "File_0_exist_use_it_as_a_name_resolution_result_6097", "File '{0}' exist - use it as a name resolution result."),
	        Loading_module_0_from_node_modules_folder_target_file_type_1: diag(6098, ts.DiagnosticCategory.Message, "Loading_module_0_from_node_modules_folder_target_file_type_1_6098", "Loading module '{0}' from 'node_modules' folder, target file type '{1}'."),
	        Found_package_json_at_0: diag(6099, ts.DiagnosticCategory.Message, "Found_package_json_at_0_6099", "Found 'package.json' at '{0}'."),
	        package_json_does_not_have_a_0_field: diag(6100, ts.DiagnosticCategory.Message, "package_json_does_not_have_a_0_field_6100", "'package.json' does not have a '{0}' field."),
	        package_json_has_0_field_1_that_references_2: diag(6101, ts.DiagnosticCategory.Message, "package_json_has_0_field_1_that_references_2_6101", "'package.json' has '{0}' field '{1}' that references '{2}'."),
	        Allow_javascript_files_to_be_compiled: diag(6102, ts.DiagnosticCategory.Message, "Allow_javascript_files_to_be_compiled_6102", "Allow javascript files to be compiled."),
	        Option_0_should_have_array_of_strings_as_a_value: diag(6103, ts.DiagnosticCategory.Error, "Option_0_should_have_array_of_strings_as_a_value_6103", "Option '{0}' should have array of strings as a value."),
	        Checking_if_0_is_the_longest_matching_prefix_for_1_2: diag(6104, ts.DiagnosticCategory.Message, "Checking_if_0_is_the_longest_matching_prefix_for_1_2_6104", "Checking if '{0}' is the longest matching prefix for '{1}' - '{2}'."),
	        Expected_type_of_0_field_in_package_json_to_be_string_got_1: diag(6105, ts.DiagnosticCategory.Message, "Expected_type_of_0_field_in_package_json_to_be_string_got_1_6105", "Expected type of '{0}' field in 'package.json' to be 'string', got '{1}'."),
	        baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1: diag(6106, ts.DiagnosticCategory.Message, "baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1_6106", "'baseUrl' option is set to '{0}', using this value to resolve non-relative module name '{1}'."),
	        rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0: diag(6107, ts.DiagnosticCategory.Message, "rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0_6107", "'rootDirs' option is set, using it to resolve relative module name '{0}'."),
	        Longest_matching_prefix_for_0_is_1: diag(6108, ts.DiagnosticCategory.Message, "Longest_matching_prefix_for_0_is_1_6108", "Longest matching prefix for '{0}' is '{1}'."),
	        Loading_0_from_the_root_dir_1_candidate_location_2: diag(6109, ts.DiagnosticCategory.Message, "Loading_0_from_the_root_dir_1_candidate_location_2_6109", "Loading '{0}' from the root dir '{1}', candidate location '{2}'."),
	        Trying_other_entries_in_rootDirs: diag(6110, ts.DiagnosticCategory.Message, "Trying_other_entries_in_rootDirs_6110", "Trying other entries in 'rootDirs'."),
	        Module_resolution_using_rootDirs_has_failed: diag(6111, ts.DiagnosticCategory.Message, "Module_resolution_using_rootDirs_has_failed_6111", "Module resolution using 'rootDirs' has failed."),
	        Do_not_emit_use_strict_directives_in_module_output: diag(6112, ts.DiagnosticCategory.Message, "Do_not_emit_use_strict_directives_in_module_output_6112", "Do not emit 'use strict' directives in module output."),
	        Enable_strict_null_checks: diag(6113, ts.DiagnosticCategory.Message, "Enable_strict_null_checks_6113", "Enable strict null checks."),
	        Unknown_option_excludes_Did_you_mean_exclude: diag(6114, ts.DiagnosticCategory.Error, "Unknown_option_excludes_Did_you_mean_exclude_6114", "Unknown option 'excludes'. Did you mean 'exclude'?"),
	        Raise_error_on_this_expressions_with_an_implied_any_type: diag(6115, ts.DiagnosticCategory.Message, "Raise_error_on_this_expressions_with_an_implied_any_type_6115", "Raise error on 'this' expressions with an implied 'any' type."),
	        Resolving_type_reference_directive_0_containing_file_1_root_directory_2: diag(6116, ts.DiagnosticCategory.Message, "Resolving_type_reference_directive_0_containing_file_1_root_directory_2_6116", "======== Resolving type reference directive '{0}', containing file '{1}', root directory '{2}'. ========"),
	        Resolving_using_primary_search_paths: diag(6117, ts.DiagnosticCategory.Message, "Resolving_using_primary_search_paths_6117", "Resolving using primary search paths..."),
	        Resolving_from_node_modules_folder: diag(6118, ts.DiagnosticCategory.Message, "Resolving_from_node_modules_folder_6118", "Resolving from node_modules folder..."),
	        Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2: diag(6119, ts.DiagnosticCategory.Message, "Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2_6119", "======== Type reference directive '{0}' was successfully resolved to '{1}', primary: {2}. ========"),
	        Type_reference_directive_0_was_not_resolved: diag(6120, ts.DiagnosticCategory.Message, "Type_reference_directive_0_was_not_resolved_6120", "======== Type reference directive '{0}' was not resolved. ========"),
	        Resolving_with_primary_search_path_0: diag(6121, ts.DiagnosticCategory.Message, "Resolving_with_primary_search_path_0_6121", "Resolving with primary search path '{0}'."),
	        Root_directory_cannot_be_determined_skipping_primary_search_paths: diag(6122, ts.DiagnosticCategory.Message, "Root_directory_cannot_be_determined_skipping_primary_search_paths_6122", "Root directory cannot be determined, skipping primary search paths."),
	        Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set: diag(6123, ts.DiagnosticCategory.Message, "Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set_6123", "======== Resolving type reference directive '{0}', containing file '{1}', root directory not set. ========"),
	        Type_declaration_files_to_be_included_in_compilation: diag(6124, ts.DiagnosticCategory.Message, "Type_declaration_files_to_be_included_in_compilation_6124", "Type declaration files to be included in compilation."),
	        Looking_up_in_node_modules_folder_initial_location_0: diag(6125, ts.DiagnosticCategory.Message, "Looking_up_in_node_modules_folder_initial_location_0_6125", "Looking up in 'node_modules' folder, initial location '{0}'."),
	        Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_modules_folder: diag(6126, ts.DiagnosticCategory.Message, "Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_mod_6126", "Containing file is not specified and root directory cannot be determined, skipping lookup in 'node_modules' folder."),
	        Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1: diag(6127, ts.DiagnosticCategory.Message, "Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1_6127", "======== Resolving type reference directive '{0}', containing file not set, root directory '{1}'. ========"),
	        Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set: diag(6128, ts.DiagnosticCategory.Message, "Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set_6128", "======== Resolving type reference directive '{0}', containing file not set, root directory not set. ========"),
	        Resolving_real_path_for_0_result_1: diag(6130, ts.DiagnosticCategory.Message, "Resolving_real_path_for_0_result_1_6130", "Resolving real path for '{0}', result '{1}'."),
	        Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system: diag(6131, ts.DiagnosticCategory.Error, "Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system_6131", "Cannot compile modules using option '{0}' unless the '--module' flag is 'amd' or 'system'."),
	        File_name_0_has_a_1_extension_stripping_it: diag(6132, ts.DiagnosticCategory.Message, "File_name_0_has_a_1_extension_stripping_it_6132", "File name '{0}' has a '{1}' extension - stripping it."),
	        _0_is_declared_but_its_value_is_never_read: diag(6133, ts.DiagnosticCategory.Error, "_0_is_declared_but_its_value_is_never_read_6133", "'{0}' is declared but its value is never read."),
	        Report_errors_on_unused_locals: diag(6134, ts.DiagnosticCategory.Message, "Report_errors_on_unused_locals_6134", "Report errors on unused locals."),
	        Report_errors_on_unused_parameters: diag(6135, ts.DiagnosticCategory.Message, "Report_errors_on_unused_parameters_6135", "Report errors on unused parameters."),
	        The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files: diag(6136, ts.DiagnosticCategory.Message, "The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files_6136", "The maximum dependency depth to search under node_modules and load JavaScript files."),
	        Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1: diag(6137, ts.DiagnosticCategory.Error, "Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1_6137", "Cannot import type declaration files. Consider importing '{0}' instead of '{1}'."),
	        Property_0_is_declared_but_its_value_is_never_read: diag(6138, ts.DiagnosticCategory.Error, "Property_0_is_declared_but_its_value_is_never_read_6138", "Property '{0}' is declared but its value is never read."),
	        Import_emit_helpers_from_tslib: diag(6139, ts.DiagnosticCategory.Message, "Import_emit_helpers_from_tslib_6139", "Import emit helpers from 'tslib'."),
	        Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using_cache_location_2: diag(6140, ts.DiagnosticCategory.Error, "Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using__6140", "Auto discovery for typings is enabled in project '{0}'. Running extra resolution pass for module '{1}' using cache location '{2}'."),
	        Parse_in_strict_mode_and_emit_use_strict_for_each_source_file: diag(6141, ts.DiagnosticCategory.Message, "Parse_in_strict_mode_and_emit_use_strict_for_each_source_file_6141", "Parse in strict mode and emit \"use strict\" for each source file."),
	        Module_0_was_resolved_to_1_but_jsx_is_not_set: diag(6142, ts.DiagnosticCategory.Error, "Module_0_was_resolved_to_1_but_jsx_is_not_set_6142", "Module '{0}' was resolved to '{1}', but '--jsx' is not set."),
	        Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1: diag(6144, ts.DiagnosticCategory.Message, "Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1_6144", "Module '{0}' was resolved as locally declared ambient module in file '{1}'."),
	        Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified: diag(6145, ts.DiagnosticCategory.Message, "Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified_6145", "Module '{0}' was resolved as ambient module declared in '{1}' since this file was not modified."),
	        Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h: diag(6146, ts.DiagnosticCategory.Message, "Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h_6146", "Specify the JSX factory function to use when targeting 'react' JSX emit, e.g. 'React.createElement' or 'h'."),
	        Resolution_for_module_0_was_found_in_cache: diag(6147, ts.DiagnosticCategory.Message, "Resolution_for_module_0_was_found_in_cache_6147", "Resolution for module '{0}' was found in cache."),
	        Directory_0_does_not_exist_skipping_all_lookups_in_it: diag(6148, ts.DiagnosticCategory.Message, "Directory_0_does_not_exist_skipping_all_lookups_in_it_6148", "Directory '{0}' does not exist, skipping all lookups in it."),
	        Show_diagnostic_information: diag(6149, ts.DiagnosticCategory.Message, "Show_diagnostic_information_6149", "Show diagnostic information."),
	        Show_verbose_diagnostic_information: diag(6150, ts.DiagnosticCategory.Message, "Show_verbose_diagnostic_information_6150", "Show verbose diagnostic information."),
	        Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file: diag(6151, ts.DiagnosticCategory.Message, "Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file_6151", "Emit a single file with source maps instead of having a separate file."),
	        Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap_to_be_set: diag(6152, ts.DiagnosticCategory.Message, "Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap__6152", "Emit the source alongside the sourcemaps within a single file; requires '--inlineSourceMap' or '--sourceMap' to be set."),
	        Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule: diag(6153, ts.DiagnosticCategory.Message, "Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule_6153", "Transpile each file as a separate module (similar to 'ts.transpileModule')."),
	        Print_names_of_generated_files_part_of_the_compilation: diag(6154, ts.DiagnosticCategory.Message, "Print_names_of_generated_files_part_of_the_compilation_6154", "Print names of generated files part of the compilation."),
	        Print_names_of_files_part_of_the_compilation: diag(6155, ts.DiagnosticCategory.Message, "Print_names_of_files_part_of_the_compilation_6155", "Print names of files part of the compilation."),
	        The_locale_used_when_displaying_messages_to_the_user_e_g_en_us: diag(6156, ts.DiagnosticCategory.Message, "The_locale_used_when_displaying_messages_to_the_user_e_g_en_us_6156", "The locale used when displaying messages to the user (e.g. 'en-us')"),
	        Do_not_generate_custom_helper_functions_like_extends_in_compiled_output: diag(6157, ts.DiagnosticCategory.Message, "Do_not_generate_custom_helper_functions_like_extends_in_compiled_output_6157", "Do not generate custom helper functions like '__extends' in compiled output."),
	        Do_not_include_the_default_library_file_lib_d_ts: diag(6158, ts.DiagnosticCategory.Message, "Do_not_include_the_default_library_file_lib_d_ts_6158", "Do not include the default library file (lib.d.ts)."),
	        Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files: diag(6159, ts.DiagnosticCategory.Message, "Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files_6159", "Do not add triple-slash references or imported modules to the list of compiled files."),
	        Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files: diag(6160, ts.DiagnosticCategory.Message, "Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files_6160", "[Deprecated] Use '--skipLibCheck' instead. Skip type checking of default library declaration files."),
	        List_of_folders_to_include_type_definitions_from: diag(6161, ts.DiagnosticCategory.Message, "List_of_folders_to_include_type_definitions_from_6161", "List of folders to include type definitions from."),
	        Disable_size_limitations_on_JavaScript_projects: diag(6162, ts.DiagnosticCategory.Message, "Disable_size_limitations_on_JavaScript_projects_6162", "Disable size limitations on JavaScript projects."),
	        The_character_set_of_the_input_files: diag(6163, ts.DiagnosticCategory.Message, "The_character_set_of_the_input_files_6163", "The character set of the input files."),
	        Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files: diag(6164, ts.DiagnosticCategory.Message, "Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files_6164", "Emit a UTF-8 Byte Order Mark (BOM) in the beginning of output files."),
	        Do_not_truncate_error_messages: diag(6165, ts.DiagnosticCategory.Message, "Do_not_truncate_error_messages_6165", "Do not truncate error messages."),
	        Output_directory_for_generated_declaration_files: diag(6166, ts.DiagnosticCategory.Message, "Output_directory_for_generated_declaration_files_6166", "Output directory for generated declaration files."),
	        A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl: diag(6167, ts.DiagnosticCategory.Message, "A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl_6167", "A series of entries which re-map imports to lookup locations relative to the 'baseUrl'."),
	        List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime: diag(6168, ts.DiagnosticCategory.Message, "List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime_6168", "List of root folders whose combined content represents the structure of the project at runtime."),
	        Show_all_compiler_options: diag(6169, ts.DiagnosticCategory.Message, "Show_all_compiler_options_6169", "Show all compiler options."),
	        Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file: diag(6170, ts.DiagnosticCategory.Message, "Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file_6170", "[Deprecated] Use '--outFile' instead. Concatenate and emit output to single file"),
	        Command_line_Options: diag(6171, ts.DiagnosticCategory.Message, "Command_line_Options_6171", "Command-line Options"),
	        Basic_Options: diag(6172, ts.DiagnosticCategory.Message, "Basic_Options_6172", "Basic Options"),
	        Strict_Type_Checking_Options: diag(6173, ts.DiagnosticCategory.Message, "Strict_Type_Checking_Options_6173", "Strict Type-Checking Options"),
	        Module_Resolution_Options: diag(6174, ts.DiagnosticCategory.Message, "Module_Resolution_Options_6174", "Module Resolution Options"),
	        Source_Map_Options: diag(6175, ts.DiagnosticCategory.Message, "Source_Map_Options_6175", "Source Map Options"),
	        Additional_Checks: diag(6176, ts.DiagnosticCategory.Message, "Additional_Checks_6176", "Additional Checks"),
	        Experimental_Options: diag(6177, ts.DiagnosticCategory.Message, "Experimental_Options_6177", "Experimental Options"),
	        Advanced_Options: diag(6178, ts.DiagnosticCategory.Message, "Advanced_Options_6178", "Advanced Options"),
	        Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_or_ES3: diag(6179, ts.DiagnosticCategory.Message, "Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_or_ES3_6179", "Provide full support for iterables in 'for-of', spread, and destructuring when targeting 'ES5' or 'ES3'."),
	        Enable_all_strict_type_checking_options: diag(6180, ts.DiagnosticCategory.Message, "Enable_all_strict_type_checking_options_6180", "Enable all strict type-checking options."),
	        List_of_language_service_plugins: diag(6181, ts.DiagnosticCategory.Message, "List_of_language_service_plugins_6181", "List of language service plugins."),
	        Scoped_package_detected_looking_in_0: diag(6182, ts.DiagnosticCategory.Message, "Scoped_package_detected_looking_in_0_6182", "Scoped package detected, looking in '{0}'"),
	        Reusing_resolution_of_module_0_to_file_1_from_old_program: diag(6183, ts.DiagnosticCategory.Message, "Reusing_resolution_of_module_0_to_file_1_from_old_program_6183", "Reusing resolution of module '{0}' to file '{1}' from old program."),
	        Reusing_module_resolutions_originating_in_0_since_resolutions_are_unchanged_from_old_program: diag(6184, ts.DiagnosticCategory.Message, "Reusing_module_resolutions_originating_in_0_since_resolutions_are_unchanged_from_old_program_6184", "Reusing module resolutions originating in '{0}' since resolutions are unchanged from old program."),
	        Disable_strict_checking_of_generic_signatures_in_function_types: diag(6185, ts.DiagnosticCategory.Message, "Disable_strict_checking_of_generic_signatures_in_function_types_6185", "Disable strict checking of generic signatures in function types."),
	        Enable_strict_checking_of_function_types: diag(6186, ts.DiagnosticCategory.Message, "Enable_strict_checking_of_function_types_6186", "Enable strict checking of function types."),
	        Enable_strict_checking_of_property_initialization_in_classes: diag(6187, ts.DiagnosticCategory.Message, "Enable_strict_checking_of_property_initialization_in_classes_6187", "Enable strict checking of property initialization in classes."),
	        Numeric_separators_are_not_allowed_here: diag(6188, ts.DiagnosticCategory.Error, "Numeric_separators_are_not_allowed_here_6188", "Numeric separators are not allowed here."),
	        Multiple_consecutive_numeric_separators_are_not_permitted: diag(6189, ts.DiagnosticCategory.Error, "Multiple_consecutive_numeric_separators_are_not_permitted_6189", "Multiple consecutive numeric separators are not permitted."),
	        Found_package_json_at_0_Package_ID_is_1: diag(6190, ts.DiagnosticCategory.Message, "Found_package_json_at_0_Package_ID_is_1_6190", "Found 'package.json' at '{0}'. Package ID is '{1}'."),
	        Variable_0_implicitly_has_an_1_type: diag(7005, ts.DiagnosticCategory.Error, "Variable_0_implicitly_has_an_1_type_7005", "Variable '{0}' implicitly has an '{1}' type."),
	        Parameter_0_implicitly_has_an_1_type: diag(7006, ts.DiagnosticCategory.Error, "Parameter_0_implicitly_has_an_1_type_7006", "Parameter '{0}' implicitly has an '{1}' type."),
	        Member_0_implicitly_has_an_1_type: diag(7008, ts.DiagnosticCategory.Error, "Member_0_implicitly_has_an_1_type_7008", "Member '{0}' implicitly has an '{1}' type."),
	        new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type: diag(7009, ts.DiagnosticCategory.Error, "new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type_7009", "'new' expression, whose target lacks a construct signature, implicitly has an 'any' type."),
	        _0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type: diag(7010, ts.DiagnosticCategory.Error, "_0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type_7010", "'{0}', which lacks return-type annotation, implicitly has an '{1}' return type."),
	        Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type: diag(7011, ts.DiagnosticCategory.Error, "Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type_7011", "Function expression, which lacks return-type annotation, implicitly has an '{0}' return type."),
	        Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type: diag(7013, ts.DiagnosticCategory.Error, "Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type_7013", "Construct signature, which lacks return-type annotation, implicitly has an 'any' return type."),
	        Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number: diag(7015, ts.DiagnosticCategory.Error, "Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number_7015", "Element implicitly has an 'any' type because index expression is not of type 'number'."),
	        Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type: diag(7016, ts.DiagnosticCategory.Error, "Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type_7016", "Could not find a declaration file for module '{0}'. '{1}' implicitly has an 'any' type."),
	        Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature: diag(7017, ts.DiagnosticCategory.Error, "Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_7017", "Element implicitly has an 'any' type because type '{0}' has no index signature."),
	        Object_literal_s_property_0_implicitly_has_an_1_type: diag(7018, ts.DiagnosticCategory.Error, "Object_literal_s_property_0_implicitly_has_an_1_type_7018", "Object literal's property '{0}' implicitly has an '{1}' type."),
	        Rest_parameter_0_implicitly_has_an_any_type: diag(7019, ts.DiagnosticCategory.Error, "Rest_parameter_0_implicitly_has_an_any_type_7019", "Rest parameter '{0}' implicitly has an 'any[]' type."),
	        Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type: diag(7020, ts.DiagnosticCategory.Error, "Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type_7020", "Call signature, which lacks return-type annotation, implicitly has an 'any' return type."),
	        _0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or_indirectly_in_its_own_initializer: diag(7022, ts.DiagnosticCategory.Error, "_0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or__7022", "'{0}' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer."),
	        _0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions: diag(7023, ts.DiagnosticCategory.Error, "_0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_reference_7023", "'{0}' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions."),
	        Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions: diag(7024, ts.DiagnosticCategory.Error, "Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_ref_7024", "Function implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions."),
	        Generator_implicitly_has_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_return_type: diag(7025, ts.DiagnosticCategory.Error, "Generator_implicitly_has_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_return_typ_7025", "Generator implicitly has type '{0}' because it does not yield any values. Consider supplying a return type."),
	        JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists: diag(7026, ts.DiagnosticCategory.Error, "JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists_7026", "JSX element implicitly has type 'any' because no interface 'JSX.{0}' exists."),
	        Unreachable_code_detected: diag(7027, ts.DiagnosticCategory.Error, "Unreachable_code_detected_7027", "Unreachable code detected."),
	        Unused_label: diag(7028, ts.DiagnosticCategory.Error, "Unused_label_7028", "Unused label."),
	        Fallthrough_case_in_switch: diag(7029, ts.DiagnosticCategory.Error, "Fallthrough_case_in_switch_7029", "Fallthrough case in switch."),
	        Not_all_code_paths_return_a_value: diag(7030, ts.DiagnosticCategory.Error, "Not_all_code_paths_return_a_value_7030", "Not all code paths return a value."),
	        Binding_element_0_implicitly_has_an_1_type: diag(7031, ts.DiagnosticCategory.Error, "Binding_element_0_implicitly_has_an_1_type_7031", "Binding element '{0}' implicitly has an '{1}' type."),
	        Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation: diag(7032, ts.DiagnosticCategory.Error, "Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation_7032", "Property '{0}' implicitly has type 'any', because its set accessor lacks a parameter type annotation."),
	        Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation: diag(7033, ts.DiagnosticCategory.Error, "Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation_7033", "Property '{0}' implicitly has type 'any', because its get accessor lacks a return type annotation."),
	        Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined: diag(7034, ts.DiagnosticCategory.Error, "Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined_7034", "Variable '{0}' implicitly has type '{1}' in some locations where its type cannot be determined."),
	        Try_npm_install_types_Slash_0_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_module_0: diag(7035, ts.DiagnosticCategory.Error, "Try_npm_install_types_Slash_0_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_mod_7035", "Try `npm install @types/{0}` if it exists or add a new declaration (.d.ts) file containing `declare module '{0}';`"),
	        Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0: diag(7036, ts.DiagnosticCategory.Error, "Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0_7036", "Dynamic import's specifier must be of type 'string', but here has type '{0}'."),
	        Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for_all_imports_Implies_allowSyntheticDefaultImports: diag(7037, ts.DiagnosticCategory.Message, "Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for__7037", "Enables emit interoperability between CommonJS and ES Modules via creation of namespace objects for all imports. Implies 'allowSyntheticDefaultImports'."),
	        A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime: diag(7038, ts.DiagnosticCategory.Error, "A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime_7038", "A namespace-style import cannot be called or constructed, and will cause a failure at runtime."),
	        Mapped_object_type_implicitly_has_an_any_template_type: diag(7039, ts.DiagnosticCategory.Error, "Mapped_object_type_implicitly_has_an_any_template_type_7039", "Mapped object type implicitly has an 'any' template type."),
	        You_cannot_rename_this_element: diag(8000, ts.DiagnosticCategory.Error, "You_cannot_rename_this_element_8000", "You cannot rename this element."),
	        You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library: diag(8001, ts.DiagnosticCategory.Error, "You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library_8001", "You cannot rename elements that are defined in the standard TypeScript library."),
	        import_can_only_be_used_in_a_ts_file: diag(8002, ts.DiagnosticCategory.Error, "import_can_only_be_used_in_a_ts_file_8002", "'import ... =' can only be used in a .ts file."),
	        export_can_only_be_used_in_a_ts_file: diag(8003, ts.DiagnosticCategory.Error, "export_can_only_be_used_in_a_ts_file_8003", "'export=' can only be used in a .ts file."),
	        type_parameter_declarations_can_only_be_used_in_a_ts_file: diag(8004, ts.DiagnosticCategory.Error, "type_parameter_declarations_can_only_be_used_in_a_ts_file_8004", "'type parameter declarations' can only be used in a .ts file."),
	        implements_clauses_can_only_be_used_in_a_ts_file: diag(8005, ts.DiagnosticCategory.Error, "implements_clauses_can_only_be_used_in_a_ts_file_8005", "'implements clauses' can only be used in a .ts file."),
	        interface_declarations_can_only_be_used_in_a_ts_file: diag(8006, ts.DiagnosticCategory.Error, "interface_declarations_can_only_be_used_in_a_ts_file_8006", "'interface declarations' can only be used in a .ts file."),
	        module_declarations_can_only_be_used_in_a_ts_file: diag(8007, ts.DiagnosticCategory.Error, "module_declarations_can_only_be_used_in_a_ts_file_8007", "'module declarations' can only be used in a .ts file."),
	        type_aliases_can_only_be_used_in_a_ts_file: diag(8008, ts.DiagnosticCategory.Error, "type_aliases_can_only_be_used_in_a_ts_file_8008", "'type aliases' can only be used in a .ts file."),
	        _0_can_only_be_used_in_a_ts_file: diag(8009, ts.DiagnosticCategory.Error, "_0_can_only_be_used_in_a_ts_file_8009", "'{0}' can only be used in a .ts file."),
	        types_can_only_be_used_in_a_ts_file: diag(8010, ts.DiagnosticCategory.Error, "types_can_only_be_used_in_a_ts_file_8010", "'types' can only be used in a .ts file."),
	        type_arguments_can_only_be_used_in_a_ts_file: diag(8011, ts.DiagnosticCategory.Error, "type_arguments_can_only_be_used_in_a_ts_file_8011", "'type arguments' can only be used in a .ts file."),
	        parameter_modifiers_can_only_be_used_in_a_ts_file: diag(8012, ts.DiagnosticCategory.Error, "parameter_modifiers_can_only_be_used_in_a_ts_file_8012", "'parameter modifiers' can only be used in a .ts file."),
	        non_null_assertions_can_only_be_used_in_a_ts_file: diag(8013, ts.DiagnosticCategory.Error, "non_null_assertions_can_only_be_used_in_a_ts_file_8013", "'non-null assertions' can only be used in a .ts file."),
	        enum_declarations_can_only_be_used_in_a_ts_file: diag(8015, ts.DiagnosticCategory.Error, "enum_declarations_can_only_be_used_in_a_ts_file_8015", "'enum declarations' can only be used in a .ts file."),
	        type_assertion_expressions_can_only_be_used_in_a_ts_file: diag(8016, ts.DiagnosticCategory.Error, "type_assertion_expressions_can_only_be_used_in_a_ts_file_8016", "'type assertion expressions' can only be used in a .ts file."),
	        Octal_literal_types_must_use_ES2015_syntax_Use_the_syntax_0: diag(8017, ts.DiagnosticCategory.Error, "Octal_literal_types_must_use_ES2015_syntax_Use_the_syntax_0_8017", "Octal literal types must use ES2015 syntax. Use the syntax '{0}'."),
	        Octal_literals_are_not_allowed_in_enums_members_initializer_Use_the_syntax_0: diag(8018, ts.DiagnosticCategory.Error, "Octal_literals_are_not_allowed_in_enums_members_initializer_Use_the_syntax_0_8018", "Octal literals are not allowed in enums members initializer. Use the syntax '{0}'."),
	        Report_errors_in_js_files: diag(8019, ts.DiagnosticCategory.Message, "Report_errors_in_js_files_8019", "Report errors in .js files."),
	        JSDoc_types_can_only_be_used_inside_documentation_comments: diag(8020, ts.DiagnosticCategory.Error, "JSDoc_types_can_only_be_used_inside_documentation_comments_8020", "JSDoc types can only be used inside documentation comments."),
	        JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags: diag(8021, ts.DiagnosticCategory.Error, "JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags_8021", "JSDoc '@typedef' tag should either have a type annotation or be followed by '@property' or '@member' tags."),
	        JSDoc_0_is_not_attached_to_a_class: diag(8022, ts.DiagnosticCategory.Error, "JSDoc_0_is_not_attached_to_a_class_8022", "JSDoc '@{0}' is not attached to a class."),
	        JSDoc_0_1_does_not_match_the_extends_2_clause: diag(8023, ts.DiagnosticCategory.Error, "JSDoc_0_1_does_not_match_the_extends_2_clause_8023", "JSDoc '@{0} {1}' does not match the 'extends {2}' clause."),
	        JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name: diag(8024, ts.DiagnosticCategory.Error, "JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_8024", "JSDoc '@param' tag has name '{0}', but there is no parameter with that name."),
	        Class_declarations_cannot_have_more_than_one_augments_or_extends_tag: diag(8025, ts.DiagnosticCategory.Error, "Class_declarations_cannot_have_more_than_one_augments_or_extends_tag_8025", "Class declarations cannot have more than one `@augments` or `@extends` tag."),
	        Expected_0_type_arguments_provide_these_with_an_extends_tag: diag(8026, ts.DiagnosticCategory.Error, "Expected_0_type_arguments_provide_these_with_an_extends_tag_8026", "Expected {0} type arguments; provide these with an '@extends' tag."),
	        Expected_0_1_type_arguments_provide_these_with_an_extends_tag: diag(8027, ts.DiagnosticCategory.Error, "Expected_0_1_type_arguments_provide_these_with_an_extends_tag_8027", "Expected {0}-{1} type arguments; provide these with an '@extends' tag."),
	        JSDoc_may_only_appear_in_the_last_parameter_of_a_signature: diag(8028, ts.DiagnosticCategory.Error, "JSDoc_may_only_appear_in_the_last_parameter_of_a_signature_8028", "JSDoc '...' may only appear in the last parameter of a signature."),
	        Only_identifiers_Slashqualified_names_with_optional_type_arguments_are_currently_supported_in_a_class_extends_clause: diag(9002, ts.DiagnosticCategory.Error, "Only_identifiers_Slashqualified_names_with_optional_type_arguments_are_currently_supported_in_a_clas_9002", "Only identifiers/qualified-names with optional type arguments are currently supported in a class 'extends' clause."),
	        class_expressions_are_not_currently_supported: diag(9003, ts.DiagnosticCategory.Error, "class_expressions_are_not_currently_supported_9003", "'class' expressions are not currently supported."),
	        Language_service_is_disabled: diag(9004, ts.DiagnosticCategory.Error, "Language_service_is_disabled_9004", "Language service is disabled."),
	        JSX_attributes_must_only_be_assigned_a_non_empty_expression: diag(17000, ts.DiagnosticCategory.Error, "JSX_attributes_must_only_be_assigned_a_non_empty_expression_17000", "JSX attributes must only be assigned a non-empty 'expression'."),
	        JSX_elements_cannot_have_multiple_attributes_with_the_same_name: diag(17001, ts.DiagnosticCategory.Error, "JSX_elements_cannot_have_multiple_attributes_with_the_same_name_17001", "JSX elements cannot have multiple attributes with the same name."),
	        Expected_corresponding_JSX_closing_tag_for_0: diag(17002, ts.DiagnosticCategory.Error, "Expected_corresponding_JSX_closing_tag_for_0_17002", "Expected corresponding JSX closing tag for '{0}'."),
	        JSX_attribute_expected: diag(17003, ts.DiagnosticCategory.Error, "JSX_attribute_expected_17003", "JSX attribute expected."),
	        Cannot_use_JSX_unless_the_jsx_flag_is_provided: diag(17004, ts.DiagnosticCategory.Error, "Cannot_use_JSX_unless_the_jsx_flag_is_provided_17004", "Cannot use JSX unless the '--jsx' flag is provided."),
	        A_constructor_cannot_contain_a_super_call_when_its_class_extends_null: diag(17005, ts.DiagnosticCategory.Error, "A_constructor_cannot_contain_a_super_call_when_its_class_extends_null_17005", "A constructor cannot contain a 'super' call when its class extends 'null'."),
	        An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses: diag(17006, ts.DiagnosticCategory.Error, "An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_ex_17006", "An unary expression with the '{0}' operator is not allowed in the left-hand side of an exponentiation expression. Consider enclosing the expression in parentheses."),
	        A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses: diag(17007, ts.DiagnosticCategory.Error, "A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Con_17007", "A type assertion expression is not allowed in the left-hand side of an exponentiation expression. Consider enclosing the expression in parentheses."),
	        JSX_element_0_has_no_corresponding_closing_tag: diag(17008, ts.DiagnosticCategory.Error, "JSX_element_0_has_no_corresponding_closing_tag_17008", "JSX element '{0}' has no corresponding closing tag."),
	        super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class: diag(17009, ts.DiagnosticCategory.Error, "super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class_17009", "'super' must be called before accessing 'this' in the constructor of a derived class."),
	        Unknown_type_acquisition_option_0: diag(17010, ts.DiagnosticCategory.Error, "Unknown_type_acquisition_option_0_17010", "Unknown type acquisition option '{0}'."),
	        super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class: diag(17011, ts.DiagnosticCategory.Error, "super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class_17011", "'super' must be called before accessing a property of 'super' in the constructor of a derived class."),
	        _0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2: diag(17012, ts.DiagnosticCategory.Error, "_0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2_17012", "'{0}' is not a valid meta-property for keyword '{1}'. Did you mean '{2}'?"),
	        Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constructor: diag(17013, ts.DiagnosticCategory.Error, "Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constru_17013", "Meta-property '{0}' is only allowed in the body of a function declaration, function expression, or constructor."),
	        JSX_fragment_has_no_corresponding_closing_tag: diag(17014, ts.DiagnosticCategory.Error, "JSX_fragment_has_no_corresponding_closing_tag_17014", "JSX fragment has no corresponding closing tag."),
	        Expected_corresponding_closing_tag_for_JSX_fragment: diag(17015, ts.DiagnosticCategory.Error, "Expected_corresponding_closing_tag_for_JSX_fragment_17015", "Expected corresponding closing tag for JSX fragment."),
	        JSX_fragment_is_not_supported_when_using_jsxFactory: diag(17016, ts.DiagnosticCategory.Error, "JSX_fragment_is_not_supported_when_using_jsxFactory_17016", "JSX fragment is not supported when using --jsxFactory"),
	        Circularity_detected_while_resolving_configuration_Colon_0: diag(18000, ts.DiagnosticCategory.Error, "Circularity_detected_while_resolving_configuration_Colon_0_18000", "Circularity detected while resolving configuration: {0}"),
	        A_path_in_an_extends_option_must_be_relative_or_rooted_but_0_is_not: diag(18001, ts.DiagnosticCategory.Error, "A_path_in_an_extends_option_must_be_relative_or_rooted_but_0_is_not_18001", "A path in an 'extends' option must be relative or rooted, but '{0}' is not."),
	        The_files_list_in_config_file_0_is_empty: diag(18002, ts.DiagnosticCategory.Error, "The_files_list_in_config_file_0_is_empty_18002", "The 'files' list in config file '{0}' is empty."),
	        No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2: diag(18003, ts.DiagnosticCategory.Error, "No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2_18003", "No inputs were found in config file '{0}'. Specified 'include' paths were '{1}' and 'exclude' paths were '{2}'."),
	        Add_missing_super_call: diag(90001, ts.DiagnosticCategory.Message, "Add_missing_super_call_90001", "Add missing 'super()' call"),
	        Make_super_call_the_first_statement_in_the_constructor: diag(90002, ts.DiagnosticCategory.Message, "Make_super_call_the_first_statement_in_the_constructor_90002", "Make 'super()' call the first statement in the constructor"),
	        Change_extends_to_implements: diag(90003, ts.DiagnosticCategory.Message, "Change_extends_to_implements_90003", "Change 'extends' to 'implements'"),
	        Remove_declaration_for_Colon_0: diag(90004, ts.DiagnosticCategory.Message, "Remove_declaration_for_Colon_0_90004", "Remove declaration for: '{0}'"),
	        Implement_interface_0: diag(90006, ts.DiagnosticCategory.Message, "Implement_interface_0_90006", "Implement interface '{0}'"),
	        Implement_inherited_abstract_class: diag(90007, ts.DiagnosticCategory.Message, "Implement_inherited_abstract_class_90007", "Implement inherited abstract class"),
	        Add_this_to_unresolved_variable: diag(90008, ts.DiagnosticCategory.Message, "Add_this_to_unresolved_variable_90008", "Add 'this.' to unresolved variable"),
	        Import_0_from_module_1: diag(90013, ts.DiagnosticCategory.Message, "Import_0_from_module_1_90013", "Import '{0}' from module \"{1}\""),
	        Change_0_to_1: diag(90014, ts.DiagnosticCategory.Message, "Change_0_to_1_90014", "Change '{0}' to '{1}'"),
	        Add_0_to_existing_import_declaration_from_1: diag(90015, ts.DiagnosticCategory.Message, "Add_0_to_existing_import_declaration_from_1_90015", "Add '{0}' to existing import declaration from \"{1}\""),
	        Declare_property_0: diag(90016, ts.DiagnosticCategory.Message, "Declare_property_0_90016", "Declare property '{0}'"),
	        Add_index_signature_for_property_0: diag(90017, ts.DiagnosticCategory.Message, "Add_index_signature_for_property_0_90017", "Add index signature for property '{0}'"),
	        Disable_checking_for_this_file: diag(90018, ts.DiagnosticCategory.Message, "Disable_checking_for_this_file_90018", "Disable checking for this file"),
	        Ignore_this_error_message: diag(90019, ts.DiagnosticCategory.Message, "Ignore_this_error_message_90019", "Ignore this error message"),
	        Initialize_property_0_in_the_constructor: diag(90020, ts.DiagnosticCategory.Message, "Initialize_property_0_in_the_constructor_90020", "Initialize property '{0}' in the constructor"),
	        Initialize_static_property_0: diag(90021, ts.DiagnosticCategory.Message, "Initialize_static_property_0_90021", "Initialize static property '{0}'"),
	        Change_spelling_to_0: diag(90022, ts.DiagnosticCategory.Message, "Change_spelling_to_0_90022", "Change spelling to '{0}'"),
	        Declare_method_0: diag(90023, ts.DiagnosticCategory.Message, "Declare_method_0_90023", "Declare method '{0}'"),
	        Declare_static_method_0: diag(90024, ts.DiagnosticCategory.Message, "Declare_static_method_0_90024", "Declare static method '{0}'"),
	        Prefix_0_with_an_underscore: diag(90025, ts.DiagnosticCategory.Message, "Prefix_0_with_an_underscore_90025", "Prefix '{0}' with an underscore"),
	        Rewrite_as_the_indexed_access_type_0: diag(90026, ts.DiagnosticCategory.Message, "Rewrite_as_the_indexed_access_type_0_90026", "Rewrite as the indexed access type '{0}'"),
	        Declare_static_property_0: diag(90027, ts.DiagnosticCategory.Message, "Declare_static_property_0_90027", "Declare static property '{0}'"),
	        Call_decorator_expression: diag(90028, ts.DiagnosticCategory.Message, "Call_decorator_expression_90028", "Call decorator expression"),
	        Add_async_modifier_to_containing_function: diag(90029, ts.DiagnosticCategory.Message, "Add_async_modifier_to_containing_function_90029", "Add async modifier to containing function"),
	        Convert_function_to_an_ES2015_class: diag(95001, ts.DiagnosticCategory.Message, "Convert_function_to_an_ES2015_class_95001", "Convert function to an ES2015 class"),
	        Convert_function_0_to_class: diag(95002, ts.DiagnosticCategory.Message, "Convert_function_0_to_class_95002", "Convert function '{0}' to class"),
	        Extract_to_0_in_1: diag(95004, ts.DiagnosticCategory.Message, "Extract_to_0_in_1_95004", "Extract to {0} in {1}"),
	        Extract_function: diag(95005, ts.DiagnosticCategory.Message, "Extract_function_95005", "Extract function"),
	        Extract_constant: diag(95006, ts.DiagnosticCategory.Message, "Extract_constant_95006", "Extract constant"),
	        Extract_to_0_in_enclosing_scope: diag(95007, ts.DiagnosticCategory.Message, "Extract_to_0_in_enclosing_scope_95007", "Extract to {0} in enclosing scope"),
	        Extract_to_0_in_1_scope: diag(95008, ts.DiagnosticCategory.Message, "Extract_to_0_in_1_scope_95008", "Extract to {0} in {1} scope"),
	        Annotate_with_type_from_JSDoc: diag(95009, ts.DiagnosticCategory.Message, "Annotate_with_type_from_JSDoc_95009", "Annotate with type from JSDoc"),
	        Annotate_with_types_from_JSDoc: diag(95010, ts.DiagnosticCategory.Message, "Annotate_with_types_from_JSDoc_95010", "Annotate with types from JSDoc"),
	        Infer_type_of_0_from_usage: diag(95011, ts.DiagnosticCategory.Message, "Infer_type_of_0_from_usage_95011", "Infer type of '{0}' from usage"),
	        Infer_parameter_types_from_usage: diag(95012, ts.DiagnosticCategory.Message, "Infer_parameter_types_from_usage_95012", "Infer parameter types from usage"),
	        Convert_to_default_import: diag(95013, ts.DiagnosticCategory.Message, "Convert_to_default_import_95013", "Convert to default import"),
	        Install_0: diag(95014, ts.DiagnosticCategory.Message, "Install_0_95014", "Install '{0}'"),
	        Replace_import_with_0: diag(95015, ts.DiagnosticCategory.Message, "Replace_import_with_0_95015", "Replace import with '{0}'."),
	        Use_synthetic_default_member: diag(95016, ts.DiagnosticCategory.Message, "Use_synthetic_default_member_95016", "Use synthetic 'default' member."),
	        Convert_to_ES6_module: diag(95017, ts.DiagnosticCategory.Message, "Convert_to_ES6_module_95017", "Convert to ES6 module"),
	        Add_undefined_type_to_property_0: diag(95018, ts.DiagnosticCategory.Message, "Add_undefined_type_to_property_0_95018", "Add 'undefined' type to property '{0}'"),
	        Add_initializer_to_property_0: diag(95019, ts.DiagnosticCategory.Message, "Add_initializer_to_property_0_95019", "Add initializer to property '{0}'"),
	        Add_definite_assignment_assertion_to_property_0: diag(95020, ts.DiagnosticCategory.Message, "Add_definite_assignment_assertion_to_property_0_95020", "Add definite assignment assertion to property '{0}'"),
	    };
	})(ts || (ts = {}));
	/// <reference path="core.ts"/>
	/// <reference path="diagnosticInformationMap.generated.ts"/>
	var ts;
	(function (ts) {
	    /* @internal */
	    function tokenIsIdentifierOrKeyword(token) {
	        return token >= 71 /* Identifier */;
	    }
	    ts.tokenIsIdentifierOrKeyword = tokenIsIdentifierOrKeyword;
	    /* @internal */
	    function tokenIsIdentifierOrKeywordOrGreaterThan(token) {
	        return token === 29 /* GreaterThanToken */ || tokenIsIdentifierOrKeyword(token);
	    }
	    ts.tokenIsIdentifierOrKeywordOrGreaterThan = tokenIsIdentifierOrKeywordOrGreaterThan;
	    var textToToken = ts.createMapFromTemplate({
	        "abstract": 117 /* AbstractKeyword */,
	        "any": 119 /* AnyKeyword */,
	        "as": 118 /* AsKeyword */,
	        "boolean": 122 /* BooleanKeyword */,
	        "break": 72 /* BreakKeyword */,
	        "case": 73 /* CaseKeyword */,
	        "catch": 74 /* CatchKeyword */,
	        "class": 75 /* ClassKeyword */,
	        "continue": 77 /* ContinueKeyword */,
	        "const": 76 /* ConstKeyword */,
	        "constructor": 123 /* ConstructorKeyword */,
	        "debugger": 78 /* DebuggerKeyword */,
	        "declare": 124 /* DeclareKeyword */,
	        "default": 79 /* DefaultKeyword */,
	        "delete": 80 /* DeleteKeyword */,
	        "do": 81 /* DoKeyword */,
	        "else": 82 /* ElseKeyword */,
	        "enum": 83 /* EnumKeyword */,
	        "export": 84 /* ExportKeyword */,
	        "extends": 85 /* ExtendsKeyword */,
	        "false": 86 /* FalseKeyword */,
	        "finally": 87 /* FinallyKeyword */,
	        "for": 88 /* ForKeyword */,
	        "from": 142 /* FromKeyword */,
	        "function": 89 /* FunctionKeyword */,
	        "get": 125 /* GetKeyword */,
	        "if": 90 /* IfKeyword */,
	        "implements": 108 /* ImplementsKeyword */,
	        "import": 91 /* ImportKeyword */,
	        "in": 92 /* InKeyword */,
	        "infer": 126 /* InferKeyword */,
	        "instanceof": 93 /* InstanceOfKeyword */,
	        "interface": 109 /* InterfaceKeyword */,
	        "is": 127 /* IsKeyword */,
	        "keyof": 128 /* KeyOfKeyword */,
	        "let": 110 /* LetKeyword */,
	        "module": 129 /* ModuleKeyword */,
	        "namespace": 130 /* NamespaceKeyword */,
	        "never": 131 /* NeverKeyword */,
	        "new": 94 /* NewKeyword */,
	        "null": 95 /* NullKeyword */,
	        "number": 134 /* NumberKeyword */,
	        "object": 135 /* ObjectKeyword */,
	        "package": 111 /* PackageKeyword */,
	        "private": 112 /* PrivateKeyword */,
	        "protected": 113 /* ProtectedKeyword */,
	        "public": 114 /* PublicKeyword */,
	        "readonly": 132 /* ReadonlyKeyword */,
	        "require": 133 /* RequireKeyword */,
	        "global": 143 /* GlobalKeyword */,
	        "return": 96 /* ReturnKeyword */,
	        "set": 136 /* SetKeyword */,
	        "static": 115 /* StaticKeyword */,
	        "string": 137 /* StringKeyword */,
	        "super": 97 /* SuperKeyword */,
	        "switch": 98 /* SwitchKeyword */,
	        "symbol": 138 /* SymbolKeyword */,
	        "this": 99 /* ThisKeyword */,
	        "throw": 100 /* ThrowKeyword */,
	        "true": 101 /* TrueKeyword */,
	        "try": 102 /* TryKeyword */,
	        "type": 139 /* TypeKeyword */,
	        "typeof": 103 /* TypeOfKeyword */,
	        "undefined": 140 /* UndefinedKeyword */,
	        "unique": 141 /* UniqueKeyword */,
	        "var": 104 /* VarKeyword */,
	        "void": 105 /* VoidKeyword */,
	        "while": 106 /* WhileKeyword */,
	        "with": 107 /* WithKeyword */,
	        "yield": 116 /* YieldKeyword */,
	        "async": 120 /* AsyncKeyword */,
	        "await": 121 /* AwaitKeyword */,
	        "of": 144 /* OfKeyword */,
	        "{": 17 /* OpenBraceToken */,
	        "}": 18 /* CloseBraceToken */,
	        "(": 19 /* OpenParenToken */,
	        ")": 20 /* CloseParenToken */,
	        "[": 21 /* OpenBracketToken */,
	        "]": 22 /* CloseBracketToken */,
	        ".": 23 /* DotToken */,
	        "...": 24 /* DotDotDotToken */,
	        ";": 25 /* SemicolonToken */,
	        ",": 26 /* CommaToken */,
	        "<": 27 /* LessThanToken */,
	        ">": 29 /* GreaterThanToken */,
	        "<=": 30 /* LessThanEqualsToken */,
	        ">=": 31 /* GreaterThanEqualsToken */,
	        "==": 32 /* EqualsEqualsToken */,
	        "!=": 33 /* ExclamationEqualsToken */,
	        "===": 34 /* EqualsEqualsEqualsToken */,
	        "!==": 35 /* ExclamationEqualsEqualsToken */,
	        "=>": 36 /* EqualsGreaterThanToken */,
	        "+": 37 /* PlusToken */,
	        "-": 38 /* MinusToken */,
	        "**": 40 /* AsteriskAsteriskToken */,
	        "*": 39 /* AsteriskToken */,
	        "/": 41 /* SlashToken */,
	        "%": 42 /* PercentToken */,
	        "++": 43 /* PlusPlusToken */,
	        "--": 44 /* MinusMinusToken */,
	        "<<": 45 /* LessThanLessThanToken */,
	        "</": 28 /* LessThanSlashToken */,
	        ">>": 46 /* GreaterThanGreaterThanToken */,
	        ">>>": 47 /* GreaterThanGreaterThanGreaterThanToken */,
	        "&": 48 /* AmpersandToken */,
	        "|": 49 /* BarToken */,
	        "^": 50 /* CaretToken */,
	        "!": 51 /* ExclamationToken */,
	        "~": 52 /* TildeToken */,
	        "&&": 53 /* AmpersandAmpersandToken */,
	        "||": 54 /* BarBarToken */,
	        "?": 55 /* QuestionToken */,
	        ":": 56 /* ColonToken */,
	        "=": 58 /* EqualsToken */,
	        "+=": 59 /* PlusEqualsToken */,
	        "-=": 60 /* MinusEqualsToken */,
	        "*=": 61 /* AsteriskEqualsToken */,
	        "**=": 62 /* AsteriskAsteriskEqualsToken */,
	        "/=": 63 /* SlashEqualsToken */,
	        "%=": 64 /* PercentEqualsToken */,
	        "<<=": 65 /* LessThanLessThanEqualsToken */,
	        ">>=": 66 /* GreaterThanGreaterThanEqualsToken */,
	        ">>>=": 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */,
	        "&=": 68 /* AmpersandEqualsToken */,
	        "|=": 69 /* BarEqualsToken */,
	        "^=": 70 /* CaretEqualsToken */,
	        "@": 57 /* AtToken */,
	    });
	    /*
	        As per ECMAScript Language Specification 3th Edition, Section 7.6: Identifiers
	        IdentifierStart ::
	            Can contain Unicode 3.0.0 categories:
	            Uppercase letter (Lu),
	            Lowercase letter (Ll),
	            Titlecase letter (Lt),
	            Modifier letter (Lm),
	            Other letter (Lo), or
	            Letter number (Nl).
	        IdentifierPart :: =
	            Can contain IdentifierStart + Unicode 3.0.0 categories:
	            Non-spacing mark (Mn),
	            Combining spacing mark (Mc),
	            Decimal number (Nd), or
	            Connector punctuation (Pc).
	
	        Codepoint ranges for ES3 Identifiers are extracted from the Unicode 3.0.0 specification at:
	        http://www.unicode.org/Public/3.0-Update/UnicodeData-3.0.0.txt
	    */
	    var unicodeES3IdentifierStart = [170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 543, 546, 563, 592, 685, 688, 696, 699, 705, 720, 721, 736, 740, 750, 750, 890, 890, 902, 902, 904, 906, 908, 908, 910, 929, 931, 974, 976, 983, 986, 1011, 1024, 1153, 1164, 1220, 1223, 1224, 1227, 1228, 1232, 1269, 1272, 1273, 1329, 1366, 1369, 1369, 1377, 1415, 1488, 1514, 1520, 1522, 1569, 1594, 1600, 1610, 1649, 1747, 1749, 1749, 1765, 1766, 1786, 1788, 1808, 1808, 1810, 1836, 1920, 1957, 2309, 2361, 2365, 2365, 2384, 2384, 2392, 2401, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2524, 2525, 2527, 2529, 2544, 2545, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2649, 2652, 2654, 2654, 2674, 2676, 2693, 2699, 2701, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2749, 2749, 2768, 2768, 2784, 2784, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2870, 2873, 2877, 2877, 2908, 2909, 2911, 2913, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 2997, 2999, 3001, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3168, 3169, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3294, 3294, 3296, 3297, 3333, 3340, 3342, 3344, 3346, 3368, 3370, 3385, 3424, 3425, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3585, 3632, 3634, 3635, 3648, 3654, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3782, 3782, 3804, 3805, 3840, 3840, 3904, 3911, 3913, 3946, 3976, 3979, 4096, 4129, 4131, 4135, 4137, 4138, 4176, 4181, 4256, 4293, 4304, 4342, 4352, 4441, 4447, 4514, 4520, 4601, 4608, 4614, 4616, 4678, 4680, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4742, 4744, 4744, 4746, 4749, 4752, 4782, 4784, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4814, 4816, 4822, 4824, 4846, 4848, 4878, 4880, 4880, 4882, 4885, 4888, 4894, 4896, 4934, 4936, 4954, 5024, 5108, 5121, 5740, 5743, 5750, 5761, 5786, 5792, 5866, 6016, 6067, 6176, 6263, 6272, 6312, 7680, 7835, 7840, 7929, 7936, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8319, 8319, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8497, 8499, 8505, 8544, 8579, 12293, 12295, 12321, 12329, 12337, 12341, 12344, 12346, 12353, 12436, 12445, 12446, 12449, 12538, 12540, 12542, 12549, 12588, 12593, 12686, 12704, 12727, 13312, 19893, 19968, 40869, 40960, 42124, 44032, 55203, 63744, 64045, 64256, 64262, 64275, 64279, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65136, 65138, 65140, 65140, 65142, 65276, 65313, 65338, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500,];
	    var unicodeES3IdentifierPart = [170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 543, 546, 563, 592, 685, 688, 696, 699, 705, 720, 721, 736, 740, 750, 750, 768, 846, 864, 866, 890, 890, 902, 902, 904, 906, 908, 908, 910, 929, 931, 974, 976, 983, 986, 1011, 1024, 1153, 1155, 1158, 1164, 1220, 1223, 1224, 1227, 1228, 1232, 1269, 1272, 1273, 1329, 1366, 1369, 1369, 1377, 1415, 1425, 1441, 1443, 1465, 1467, 1469, 1471, 1471, 1473, 1474, 1476, 1476, 1488, 1514, 1520, 1522, 1569, 1594, 1600, 1621, 1632, 1641, 1648, 1747, 1749, 1756, 1759, 1768, 1770, 1773, 1776, 1788, 1808, 1836, 1840, 1866, 1920, 1968, 2305, 2307, 2309, 2361, 2364, 2381, 2384, 2388, 2392, 2403, 2406, 2415, 2433, 2435, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2492, 2492, 2494, 2500, 2503, 2504, 2507, 2509, 2519, 2519, 2524, 2525, 2527, 2531, 2534, 2545, 2562, 2562, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2620, 2620, 2622, 2626, 2631, 2632, 2635, 2637, 2649, 2652, 2654, 2654, 2662, 2676, 2689, 2691, 2693, 2699, 2701, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2748, 2757, 2759, 2761, 2763, 2765, 2768, 2768, 2784, 2784, 2790, 2799, 2817, 2819, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2870, 2873, 2876, 2883, 2887, 2888, 2891, 2893, 2902, 2903, 2908, 2909, 2911, 2913, 2918, 2927, 2946, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 2997, 2999, 3001, 3006, 3010, 3014, 3016, 3018, 3021, 3031, 3031, 3047, 3055, 3073, 3075, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3134, 3140, 3142, 3144, 3146, 3149, 3157, 3158, 3168, 3169, 3174, 3183, 3202, 3203, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3262, 3268, 3270, 3272, 3274, 3277, 3285, 3286, 3294, 3294, 3296, 3297, 3302, 3311, 3330, 3331, 3333, 3340, 3342, 3344, 3346, 3368, 3370, 3385, 3390, 3395, 3398, 3400, 3402, 3405, 3415, 3415, 3424, 3425, 3430, 3439, 3458, 3459, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3530, 3530, 3535, 3540, 3542, 3542, 3544, 3551, 3570, 3571, 3585, 3642, 3648, 3662, 3664, 3673, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3769, 3771, 3773, 3776, 3780, 3782, 3782, 3784, 3789, 3792, 3801, 3804, 3805, 3840, 3840, 3864, 3865, 3872, 3881, 3893, 3893, 3895, 3895, 3897, 3897, 3902, 3911, 3913, 3946, 3953, 3972, 3974, 3979, 3984, 3991, 3993, 4028, 4038, 4038, 4096, 4129, 4131, 4135, 4137, 4138, 4140, 4146, 4150, 4153, 4160, 4169, 4176, 4185, 4256, 4293, 4304, 4342, 4352, 4441, 4447, 4514, 4520, 4601, 4608, 4614, 4616, 4678, 4680, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4742, 4744, 4744, 4746, 4749, 4752, 4782, 4784, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4814, 4816, 4822, 4824, 4846, 4848, 4878, 4880, 4880, 4882, 4885, 4888, 4894, 4896, 4934, 4936, 4954, 4969, 4977, 5024, 5108, 5121, 5740, 5743, 5750, 5761, 5786, 5792, 5866, 6016, 6099, 6112, 6121, 6160, 6169, 6176, 6263, 6272, 6313, 7680, 7835, 7840, 7929, 7936, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8255, 8256, 8319, 8319, 8400, 8412, 8417, 8417, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8497, 8499, 8505, 8544, 8579, 12293, 12295, 12321, 12335, 12337, 12341, 12344, 12346, 12353, 12436, 12441, 12442, 12445, 12446, 12449, 12542, 12549, 12588, 12593, 12686, 12704, 12727, 13312, 19893, 19968, 40869, 40960, 42124, 44032, 55203, 63744, 64045, 64256, 64262, 64275, 64279, 64285, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65056, 65059, 65075, 65076, 65101, 65103, 65136, 65138, 65140, 65140, 65142, 65276, 65296, 65305, 65313, 65338, 65343, 65343, 65345, 65370, 65381, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500,];
	    /*
	        As per ECMAScript Language Specification 5th Edition, Section 7.6: ISyntaxToken Names and Identifiers
	        IdentifierStart ::
	            Can contain Unicode 6.2 categories:
	            Uppercase letter (Lu),
	            Lowercase letter (Ll),
	            Titlecase letter (Lt),
	            Modifier letter (Lm),
	            Other letter (Lo), or
	            Letter number (Nl).
	        IdentifierPart ::
	            Can contain IdentifierStart + Unicode 6.2 categories:
	            Non-spacing mark (Mn),
	            Combining spacing mark (Mc),
	            Decimal number (Nd),
	            Connector punctuation (Pc),
	            <ZWNJ>, or
	            <ZWJ>.
	
	        Codepoint ranges for ES5 Identifiers are extracted from the Unicode 6.2 specification at:
	        http://www.unicode.org/Public/6.2.0/ucd/UnicodeData.txt
	    */
	    var unicodeES5IdentifierStart = [170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 705, 710, 721, 736, 740, 748, 748, 750, 750, 880, 884, 886, 887, 890, 893, 902, 902, 904, 906, 908, 908, 910, 929, 931, 1013, 1015, 1153, 1162, 1319, 1329, 1366, 1369, 1369, 1377, 1415, 1488, 1514, 1520, 1522, 1568, 1610, 1646, 1647, 1649, 1747, 1749, 1749, 1765, 1766, 1774, 1775, 1786, 1788, 1791, 1791, 1808, 1808, 1810, 1839, 1869, 1957, 1969, 1969, 1994, 2026, 2036, 2037, 2042, 2042, 2048, 2069, 2074, 2074, 2084, 2084, 2088, 2088, 2112, 2136, 2208, 2208, 2210, 2220, 2308, 2361, 2365, 2365, 2384, 2384, 2392, 2401, 2417, 2423, 2425, 2431, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2493, 2493, 2510, 2510, 2524, 2525, 2527, 2529, 2544, 2545, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2649, 2652, 2654, 2654, 2674, 2676, 2693, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2749, 2749, 2768, 2768, 2784, 2785, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2869, 2873, 2877, 2877, 2908, 2909, 2911, 2913, 2929, 2929, 2947, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 3001, 3024, 3024, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3133, 3133, 3160, 3161, 3168, 3169, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3261, 3261, 3294, 3294, 3296, 3297, 3313, 3314, 3333, 3340, 3342, 3344, 3346, 3386, 3389, 3389, 3406, 3406, 3424, 3425, 3450, 3455, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3585, 3632, 3634, 3635, 3648, 3654, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3782, 3782, 3804, 3807, 3840, 3840, 3904, 3911, 3913, 3948, 3976, 3980, 4096, 4138, 4159, 4159, 4176, 4181, 4186, 4189, 4193, 4193, 4197, 4198, 4206, 4208, 4213, 4225, 4238, 4238, 4256, 4293, 4295, 4295, 4301, 4301, 4304, 4346, 4348, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4744, 4746, 4749, 4752, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4822, 4824, 4880, 4882, 4885, 4888, 4954, 4992, 5007, 5024, 5108, 5121, 5740, 5743, 5759, 5761, 5786, 5792, 5866, 5870, 5872, 5888, 5900, 5902, 5905, 5920, 5937, 5952, 5969, 5984, 5996, 5998, 6000, 6016, 6067, 6103, 6103, 6108, 6108, 6176, 6263, 6272, 6312, 6314, 6314, 6320, 6389, 6400, 6428, 6480, 6509, 6512, 6516, 6528, 6571, 6593, 6599, 6656, 6678, 6688, 6740, 6823, 6823, 6917, 6963, 6981, 6987, 7043, 7072, 7086, 7087, 7098, 7141, 7168, 7203, 7245, 7247, 7258, 7293, 7401, 7404, 7406, 7409, 7413, 7414, 7424, 7615, 7680, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8305, 8305, 8319, 8319, 8336, 8348, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8505, 8508, 8511, 8517, 8521, 8526, 8526, 8544, 8584, 11264, 11310, 11312, 11358, 11360, 11492, 11499, 11502, 11506, 11507, 11520, 11557, 11559, 11559, 11565, 11565, 11568, 11623, 11631, 11631, 11648, 11670, 11680, 11686, 11688, 11694, 11696, 11702, 11704, 11710, 11712, 11718, 11720, 11726, 11728, 11734, 11736, 11742, 11823, 11823, 12293, 12295, 12321, 12329, 12337, 12341, 12344, 12348, 12353, 12438, 12445, 12447, 12449, 12538, 12540, 12543, 12549, 12589, 12593, 12686, 12704, 12730, 12784, 12799, 13312, 19893, 19968, 40908, 40960, 42124, 42192, 42237, 42240, 42508, 42512, 42527, 42538, 42539, 42560, 42606, 42623, 42647, 42656, 42735, 42775, 42783, 42786, 42888, 42891, 42894, 42896, 42899, 42912, 42922, 43000, 43009, 43011, 43013, 43015, 43018, 43020, 43042, 43072, 43123, 43138, 43187, 43250, 43255, 43259, 43259, 43274, 43301, 43312, 43334, 43360, 43388, 43396, 43442, 43471, 43471, 43520, 43560, 43584, 43586, 43588, 43595, 43616, 43638, 43642, 43642, 43648, 43695, 43697, 43697, 43701, 43702, 43705, 43709, 43712, 43712, 43714, 43714, 43739, 43741, 43744, 43754, 43762, 43764, 43777, 43782, 43785, 43790, 43793, 43798, 43808, 43814, 43816, 43822, 43968, 44002, 44032, 55203, 55216, 55238, 55243, 55291, 63744, 64109, 64112, 64217, 64256, 64262, 64275, 64279, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65136, 65140, 65142, 65276, 65313, 65338, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500,];
	    var unicodeES5IdentifierPart = [170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 705, 710, 721, 736, 740, 748, 748, 750, 750, 768, 884, 886, 887, 890, 893, 902, 902, 904, 906, 908, 908, 910, 929, 931, 1013, 1015, 1153, 1155, 1159, 1162, 1319, 1329, 1366, 1369, 1369, 1377, 1415, 1425, 1469, 1471, 1471, 1473, 1474, 1476, 1477, 1479, 1479, 1488, 1514, 1520, 1522, 1552, 1562, 1568, 1641, 1646, 1747, 1749, 1756, 1759, 1768, 1770, 1788, 1791, 1791, 1808, 1866, 1869, 1969, 1984, 2037, 2042, 2042, 2048, 2093, 2112, 2139, 2208, 2208, 2210, 2220, 2276, 2302, 2304, 2403, 2406, 2415, 2417, 2423, 2425, 2431, 2433, 2435, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2492, 2500, 2503, 2504, 2507, 2510, 2519, 2519, 2524, 2525, 2527, 2531, 2534, 2545, 2561, 2563, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2620, 2620, 2622, 2626, 2631, 2632, 2635, 2637, 2641, 2641, 2649, 2652, 2654, 2654, 2662, 2677, 2689, 2691, 2693, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2748, 2757, 2759, 2761, 2763, 2765, 2768, 2768, 2784, 2787, 2790, 2799, 2817, 2819, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2869, 2873, 2876, 2884, 2887, 2888, 2891, 2893, 2902, 2903, 2908, 2909, 2911, 2915, 2918, 2927, 2929, 2929, 2946, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 3001, 3006, 3010, 3014, 3016, 3018, 3021, 3024, 3024, 3031, 3031, 3046, 3055, 3073, 3075, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3133, 3140, 3142, 3144, 3146, 3149, 3157, 3158, 3160, 3161, 3168, 3171, 3174, 3183, 3202, 3203, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3260, 3268, 3270, 3272, 3274, 3277, 3285, 3286, 3294, 3294, 3296, 3299, 3302, 3311, 3313, 3314, 3330, 3331, 3333, 3340, 3342, 3344, 3346, 3386, 3389, 3396, 3398, 3400, 3402, 3406, 3415, 3415, 3424, 3427, 3430, 3439, 3450, 3455, 3458, 3459, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3530, 3530, 3535, 3540, 3542, 3542, 3544, 3551, 3570, 3571, 3585, 3642, 3648, 3662, 3664, 3673, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3769, 3771, 3773, 3776, 3780, 3782, 3782, 3784, 3789, 3792, 3801, 3804, 3807, 3840, 3840, 3864, 3865, 3872, 3881, 3893, 3893, 3895, 3895, 3897, 3897, 3902, 3911, 3913, 3948, 3953, 3972, 3974, 3991, 3993, 4028, 4038, 4038, 4096, 4169, 4176, 4253, 4256, 4293, 4295, 4295, 4301, 4301, 4304, 4346, 4348, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4744, 4746, 4749, 4752, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4822, 4824, 4880, 4882, 4885, 4888, 4954, 4957, 4959, 4992, 5007, 5024, 5108, 5121, 5740, 5743, 5759, 5761, 5786, 5792, 5866, 5870, 5872, 5888, 5900, 5902, 5908, 5920, 5940, 5952, 5971, 5984, 5996, 5998, 6000, 6002, 6003, 6016, 6099, 6103, 6103, 6108, 6109, 6112, 6121, 6155, 6157, 6160, 6169, 6176, 6263, 6272, 6314, 6320, 6389, 6400, 6428, 6432, 6443, 6448, 6459, 6470, 6509, 6512, 6516, 6528, 6571, 6576, 6601, 6608, 6617, 6656, 6683, 6688, 6750, 6752, 6780, 6783, 6793, 6800, 6809, 6823, 6823, 6912, 6987, 6992, 7001, 7019, 7027, 7040, 7155, 7168, 7223, 7232, 7241, 7245, 7293, 7376, 7378, 7380, 7414, 7424, 7654, 7676, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8204, 8205, 8255, 8256, 8276, 8276, 8305, 8305, 8319, 8319, 8336, 8348, 8400, 8412, 8417, 8417, 8421, 8432, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8505, 8508, 8511, 8517, 8521, 8526, 8526, 8544, 8584, 11264, 11310, 11312, 11358, 11360, 11492, 11499, 11507, 11520, 11557, 11559, 11559, 11565, 11565, 11568, 11623, 11631, 11631, 11647, 11670, 11680, 11686, 11688, 11694, 11696, 11702, 11704, 11710, 11712, 11718, 11720, 11726, 11728, 11734, 11736, 11742, 11744, 11775, 11823, 11823, 12293, 12295, 12321, 12335, 12337, 12341, 12344, 12348, 12353, 12438, 12441, 12442, 12445, 12447, 12449, 12538, 12540, 12543, 12549, 12589, 12593, 12686, 12704, 12730, 12784, 12799, 13312, 19893, 19968, 40908, 40960, 42124, 42192, 42237, 42240, 42508, 42512, 42539, 42560, 42607, 42612, 42621, 42623, 42647, 42655, 42737, 42775, 42783, 42786, 42888, 42891, 42894, 42896, 42899, 42912, 42922, 43000, 43047, 43072, 43123, 43136, 43204, 43216, 43225, 43232, 43255, 43259, 43259, 43264, 43309, 43312, 43347, 43360, 43388, 43392, 43456, 43471, 43481, 43520, 43574, 43584, 43597, 43600, 43609, 43616, 43638, 43642, 43643, 43648, 43714, 43739, 43741, 43744, 43759, 43762, 43766, 43777, 43782, 43785, 43790, 43793, 43798, 43808, 43814, 43816, 43822, 43968, 44010, 44012, 44013, 44016, 44025, 44032, 55203, 55216, 55238, 55243, 55291, 63744, 64109, 64112, 64217, 64256, 64262, 64275, 64279, 64285, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65024, 65039, 65056, 65062, 65075, 65076, 65101, 65103, 65136, 65140, 65142, 65276, 65296, 65305, 65313, 65338, 65343, 65343, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500,];
	    function lookupInUnicodeMap(code, map) {
	        // Bail out quickly if it couldn't possibly be in the map.
	        if (code < map[0]) {
	            return false;
	        }
	        // Perform binary search in one of the Unicode range maps
	        var lo = 0;
	        var hi = map.length;
	        var mid;
	        while (lo + 1 < hi) {
	            mid = lo + (hi - lo) / 2;
	            // mid has to be even to catch a range's beginning
	            mid -= mid % 2;
	            if (map[mid] <= code && code <= map[mid + 1]) {
	                return true;
	            }
	            if (code < map[mid]) {
	                hi = mid;
	            }
	            else {
	                lo = mid + 2;
	            }
	        }
	        return false;
	    }
	    /* @internal */ function isUnicodeIdentifierStart(code, languageVersion) {
	        return languageVersion >= 1 /* ES5 */ ?
	            lookupInUnicodeMap(code, unicodeES5IdentifierStart) :
	            lookupInUnicodeMap(code, unicodeES3IdentifierStart);
	    }
	    ts.isUnicodeIdentifierStart = isUnicodeIdentifierStart;
	    function isUnicodeIdentifierPart(code, languageVersion) {
	        return languageVersion >= 1 /* ES5 */ ?
	            lookupInUnicodeMap(code, unicodeES5IdentifierPart) :
	            lookupInUnicodeMap(code, unicodeES3IdentifierPart);
	    }
	    function makeReverseMap(source) {
	        var result = [];
	        source.forEach(function (value, name) {
	            result[value] = name;
	        });
	        return result;
	    }
	    var tokenStrings = makeReverseMap(textToToken);
	    function tokenToString(t) {
	        return tokenStrings[t];
	    }
	    ts.tokenToString = tokenToString;
	    /* @internal */
	    function stringToToken(s) {
	        return textToToken.get(s);
	    }
	    ts.stringToToken = stringToToken;
	    /* @internal */
	    function computeLineStarts(text) {
	        var result = new Array();
	        var pos = 0;
	        var lineStart = 0;
	        while (pos < text.length) {
	            var ch = text.charCodeAt(pos);
	            pos++;
	            switch (ch) {
	                case 13 /* carriageReturn */:
	                    if (text.charCodeAt(pos) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                // falls through
	                case 10 /* lineFeed */:
	                    result.push(lineStart);
	                    lineStart = pos;
	                    break;
	                default:
	                    if (ch > 127 /* maxAsciiCharacter */ && isLineBreak(ch)) {
	                        result.push(lineStart);
	                        lineStart = pos;
	                    }
	                    break;
	            }
	        }
	        result.push(lineStart);
	        return result;
	    }
	    ts.computeLineStarts = computeLineStarts;
	    function getPositionOfLineAndCharacter(sourceFile, line, character) {
	        return computePositionOfLineAndCharacter(getLineStarts(sourceFile), line, character, sourceFile.text);
	    }
	    ts.getPositionOfLineAndCharacter = getPositionOfLineAndCharacter;
	    /* @internal */
	    function computePositionOfLineAndCharacter(lineStarts, line, character, debugText) {
	        if (line < 0 || line >= lineStarts.length) {
	            ts.Debug.fail("Bad line number. Line: " + line + ", lineStarts.length: " + lineStarts.length + " , line map is correct? " + (debugText !== undefined ? ts.arraysEqual(lineStarts, computeLineStarts(debugText)) : "unknown"));
	        }
	        var res = lineStarts[line] + character;
	        if (line < lineStarts.length - 1) {
	            ts.Debug.assert(res < lineStarts[line + 1]);
	        }
	        else if (debugText !== undefined) {
	            ts.Debug.assert(res <= debugText.length); // Allow single character overflow for trailing newline
	        }
	        return res;
	    }
	    ts.computePositionOfLineAndCharacter = computePositionOfLineAndCharacter;
	    /* @internal */
	    function getLineStarts(sourceFile) {
	        return sourceFile.lineMap || (sourceFile.lineMap = computeLineStarts(sourceFile.text));
	    }
	    ts.getLineStarts = getLineStarts;
	    /* @internal */
	    /**
	     * We assume the first line starts at position 0 and 'position' is non-negative.
	     */
	    function computeLineAndCharacterOfPosition(lineStarts, position) {
	        var lineNumber = ts.binarySearch(lineStarts, position, ts.identity, ts.compareValues);
	        if (lineNumber < 0) {
	            // If the actual position was not found,
	            // the binary search returns the 2's-complement of the next line start
	            // e.g. if the line starts at [5, 10, 23, 80] and the position requested was 20
	            // then the search will return -2.
	            //
	            // We want the index of the previous line start, so we subtract 1.
	            // Review 2's-complement if this is confusing.
	            lineNumber = ~lineNumber - 1;
	            ts.Debug.assert(lineNumber !== -1, "position cannot precede the beginning of the file");
	        }
	        return {
	            line: lineNumber,
	            character: position - lineStarts[lineNumber]
	        };
	    }
	    ts.computeLineAndCharacterOfPosition = computeLineAndCharacterOfPosition;
	    function getLineAndCharacterOfPosition(sourceFile, position) {
	        return computeLineAndCharacterOfPosition(getLineStarts(sourceFile), position);
	    }
	    ts.getLineAndCharacterOfPosition = getLineAndCharacterOfPosition;
	    function isWhiteSpaceLike(ch) {
	        return isWhiteSpaceSingleLine(ch) || isLineBreak(ch);
	    }
	    ts.isWhiteSpaceLike = isWhiteSpaceLike;
	    /** Does not include line breaks. For that, see isWhiteSpaceLike. */
	    function isWhiteSpaceSingleLine(ch) {
	        // Note: nextLine is in the Zs space, and should be considered to be a whitespace.
	        // It is explicitly not a line-break as it isn't in the exact set specified by EcmaScript.
	        return ch === 32 /* space */ ||
	            ch === 9 /* tab */ ||
	            ch === 11 /* verticalTab */ ||
	            ch === 12 /* formFeed */ ||
	            ch === 160 /* nonBreakingSpace */ ||
	            ch === 133 /* nextLine */ ||
	            ch === 5760 /* ogham */ ||
	            ch >= 8192 /* enQuad */ && ch <= 8203 /* zeroWidthSpace */ ||
	            ch === 8239 /* narrowNoBreakSpace */ ||
	            ch === 8287 /* mathematicalSpace */ ||
	            ch === 12288 /* ideographicSpace */ ||
	            ch === 65279 /* byteOrderMark */;
	    }
	    ts.isWhiteSpaceSingleLine = isWhiteSpaceSingleLine;
	    function isLineBreak(ch) {
	        // ES5 7.3:
	        // The ECMAScript line terminator characters are listed in Table 3.
	        //     Table 3: Line Terminator Characters
	        //     Code Unit Value     Name                    Formal Name
	        //     \u000A              Line Feed               <LF>
	        //     \u000D              Carriage Return         <CR>
	        //     \u2028              Line separator          <LS>
	        //     \u2029              Paragraph separator     <PS>
	        // Only the characters in Table 3 are treated as line terminators. Other new line or line
	        // breaking characters are treated as white space but not as line terminators.
	        return ch === 10 /* lineFeed */ ||
	            ch === 13 /* carriageReturn */ ||
	            ch === 8232 /* lineSeparator */ ||
	            ch === 8233 /* paragraphSeparator */;
	    }
	    ts.isLineBreak = isLineBreak;
	    function isDigit(ch) {
	        return ch >= 48 /* _0 */ && ch <= 57 /* _9 */;
	    }
	    /* @internal */
	    function isOctalDigit(ch) {
	        return ch >= 48 /* _0 */ && ch <= 55 /* _7 */;
	    }
	    ts.isOctalDigit = isOctalDigit;
	    function couldStartTrivia(text, pos) {
	        // Keep in sync with skipTrivia
	        var ch = text.charCodeAt(pos);
	        switch (ch) {
	            case 13 /* carriageReturn */:
	            case 10 /* lineFeed */:
	            case 9 /* tab */:
	            case 11 /* verticalTab */:
	            case 12 /* formFeed */:
	            case 32 /* space */:
	            case 47 /* slash */:
	            // starts of normal trivia
	            case 60 /* lessThan */:
	            case 124 /* bar */:
	            case 61 /* equals */:
	            case 62 /* greaterThan */:
	                // Starts of conflict marker trivia
	                return true;
	            case 35 /* hash */:
	                // Only if its the beginning can we have #! trivia
	                return pos === 0;
	            default:
	                return ch > 127 /* maxAsciiCharacter */;
	        }
	    }
	    ts.couldStartTrivia = couldStartTrivia;
	    /* @internal */
	    function skipTrivia(text, pos, stopAfterLineBreak, stopAtComments) {
	        if (stopAtComments === void 0) { stopAtComments = false; }
	        if (ts.positionIsSynthesized(pos)) {
	            return pos;
	        }
	        // Keep in sync with couldStartTrivia
	        while (true) {
	            var ch = text.charCodeAt(pos);
	            switch (ch) {
	                case 13 /* carriageReturn */:
	                    if (text.charCodeAt(pos + 1) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                // falls through
	                case 10 /* lineFeed */:
	                    pos++;
	                    if (stopAfterLineBreak) {
	                        return pos;
	                    }
	                    continue;
	                case 9 /* tab */:
	                case 11 /* verticalTab */:
	                case 12 /* formFeed */:
	                case 32 /* space */:
	                    pos++;
	                    continue;
	                case 47 /* slash */:
	                    if (stopAtComments) {
	                        break;
	                    }
	                    if (text.charCodeAt(pos + 1) === 47 /* slash */) {
	                        pos += 2;
	                        while (pos < text.length) {
	                            if (isLineBreak(text.charCodeAt(pos))) {
	                                break;
	                            }
	                            pos++;
	                        }
	                        continue;
	                    }
	                    if (text.charCodeAt(pos + 1) === 42 /* asterisk */) {
	                        pos += 2;
	                        while (pos < text.length) {
	                            if (text.charCodeAt(pos) === 42 /* asterisk */ && text.charCodeAt(pos + 1) === 47 /* slash */) {
	                                pos += 2;
	                                break;
	                            }
	                            pos++;
	                        }
	                        continue;
	                    }
	                    break;
	                case 60 /* lessThan */:
	                case 124 /* bar */:
	                case 61 /* equals */:
	                case 62 /* greaterThan */:
	                    if (isConflictMarkerTrivia(text, pos)) {
	                        pos = scanConflictMarkerTrivia(text, pos);
	                        continue;
	                    }
	                    break;
	                case 35 /* hash */:
	                    if (pos === 0 && isShebangTrivia(text, pos)) {
	                        pos = scanShebangTrivia(text, pos);
	                        continue;
	                    }
	                    break;
	                default:
	                    if (ch > 127 /* maxAsciiCharacter */ && (isWhiteSpaceLike(ch))) {
	                        pos++;
	                        continue;
	                    }
	                    break;
	            }
	            return pos;
	        }
	    }
	    ts.skipTrivia = skipTrivia;
	    // All conflict markers consist of the same character repeated seven times.  If it is
	    // a <<<<<<< or >>>>>>> marker then it is also followed by a space.
	    var mergeConflictMarkerLength = "<<<<<<<".length;
	    function isConflictMarkerTrivia(text, pos) {
	        ts.Debug.assert(pos >= 0);
	        // Conflict markers must be at the start of a line.
	        if (pos === 0 || isLineBreak(text.charCodeAt(pos - 1))) {
	            var ch = text.charCodeAt(pos);
	            if ((pos + mergeConflictMarkerLength) < text.length) {
	                for (var i = 0; i < mergeConflictMarkerLength; i++) {
	                    if (text.charCodeAt(pos + i) !== ch) {
	                        return false;
	                    }
	                }
	                return ch === 61 /* equals */ ||
	                    text.charCodeAt(pos + mergeConflictMarkerLength) === 32 /* space */;
	            }
	        }
	        return false;
	    }
	    function scanConflictMarkerTrivia(text, pos, error) {
	        if (error) {
	            error(ts.Diagnostics.Merge_conflict_marker_encountered, pos, mergeConflictMarkerLength);
	        }
	        var ch = text.charCodeAt(pos);
	        var len = text.length;
	        if (ch === 60 /* lessThan */ || ch === 62 /* greaterThan */) {
	            while (pos < len && !isLineBreak(text.charCodeAt(pos))) {
	                pos++;
	            }
	        }
	        else {
	            ts.Debug.assert(ch === 124 /* bar */ || ch === 61 /* equals */);
	            // Consume everything from the start of a ||||||| or ======= marker to the start
	            // of the next ======= or >>>>>>> marker.
	            while (pos < len) {
	                var currentChar = text.charCodeAt(pos);
	                if ((currentChar === 61 /* equals */ || currentChar === 62 /* greaterThan */) && currentChar !== ch && isConflictMarkerTrivia(text, pos)) {
	                    break;
	                }
	                pos++;
	            }
	        }
	        return pos;
	    }
	    var shebangTriviaRegex = /^#!.*/;
	    function isShebangTrivia(text, pos) {
	        // Shebangs check must only be done at the start of the file
	        ts.Debug.assert(pos === 0);
	        return shebangTriviaRegex.test(text);
	    }
	    function scanShebangTrivia(text, pos) {
	        var shebang = shebangTriviaRegex.exec(text)[0];
	        pos = pos + shebang.length;
	        return pos;
	    }
	    /**
	     * Invokes a callback for each comment range following the provided position.
	     *
	     * Single-line comment ranges include the leading double-slash characters but not the ending
	     * line break. Multi-line comment ranges include the leading slash-asterisk and trailing
	     * asterisk-slash characters.
	     *
	     * @param reduce If true, accumulates the result of calling the callback in a fashion similar
	     *      to reduceLeft. If false, iteration stops when the callback returns a truthy value.
	     * @param text The source text to scan.
	     * @param pos The position at which to start scanning.
	     * @param trailing If false, whitespace is skipped until the first line break and comments
	     *      between that location and the next token are returned. If true, comments occurring
	     *      between the given position and the next line break are returned.
	     * @param cb The callback to execute as each comment range is encountered.
	     * @param state A state value to pass to each iteration of the callback.
	     * @param initial An initial value to pass when accumulating results (when "reduce" is true).
	     * @returns If "reduce" is true, the accumulated value. If "reduce" is false, the first truthy
	     *      return value of the callback.
	     */
	    function iterateCommentRanges(reduce, text, pos, trailing, cb, state, initial) {
	        var pendingPos;
	        var pendingEnd;
	        var pendingKind;
	        var pendingHasTrailingNewLine;
	        var hasPendingCommentRange = false;
	        var collecting = trailing || pos === 0;
	        var accumulator = initial;
	        scan: while (pos >= 0 && pos < text.length) {
	            var ch = text.charCodeAt(pos);
	            switch (ch) {
	                case 13 /* carriageReturn */:
	                    if (text.charCodeAt(pos + 1) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                // falls through
	                case 10 /* lineFeed */:
	                    pos++;
	                    if (trailing) {
	                        break scan;
	                    }
	                    collecting = true;
	                    if (hasPendingCommentRange) {
	                        pendingHasTrailingNewLine = true;
	                    }
	                    continue;
	                case 9 /* tab */:
	                case 11 /* verticalTab */:
	                case 12 /* formFeed */:
	                case 32 /* space */:
	                    pos++;
	                    continue;
	                case 47 /* slash */:
	                    var nextChar = text.charCodeAt(pos + 1);
	                    var hasTrailingNewLine = false;
	                    if (nextChar === 47 /* slash */ || nextChar === 42 /* asterisk */) {
	                        var kind = nextChar === 47 /* slash */ ? 2 /* SingleLineCommentTrivia */ : 3 /* MultiLineCommentTrivia */;
	                        var startPos = pos;
	                        pos += 2;
	                        if (nextChar === 47 /* slash */) {
	                            while (pos < text.length) {
	                                if (isLineBreak(text.charCodeAt(pos))) {
	                                    hasTrailingNewLine = true;
	                                    break;
	                                }
	                                pos++;
	                            }
	                        }
	                        else {
	                            while (pos < text.length) {
	                                if (text.charCodeAt(pos) === 42 /* asterisk */ && text.charCodeAt(pos + 1) === 47 /* slash */) {
	                                    pos += 2;
	                                    break;
	                                }
	                                pos++;
	                            }
	                        }
	                        if (collecting) {
	                            if (hasPendingCommentRange) {
	                                accumulator = cb(pendingPos, pendingEnd, pendingKind, pendingHasTrailingNewLine, state, accumulator);
	                                if (!reduce && accumulator) {
	                                    // If we are not reducing and we have a truthy result, return it.
	                                    return accumulator;
	                                }
	                                hasPendingCommentRange = false;
	                            }
	                            pendingPos = startPos;
	                            pendingEnd = pos;
	                            pendingKind = kind;
	                            pendingHasTrailingNewLine = hasTrailingNewLine;
	                            hasPendingCommentRange = true;
	                        }
	                        continue;
	                    }
	                    break scan;
	                default:
	                    if (ch > 127 /* maxAsciiCharacter */ && (isWhiteSpaceLike(ch))) {
	                        if (hasPendingCommentRange && isLineBreak(ch)) {
	                            pendingHasTrailingNewLine = true;
	                        }
	                        pos++;
	                        continue;
	                    }
	                    break scan;
	            }
	        }
	        if (hasPendingCommentRange) {
	            accumulator = cb(pendingPos, pendingEnd, pendingKind, pendingHasTrailingNewLine, state, accumulator);
	        }
	        return accumulator;
	    }
	    function forEachLeadingCommentRange(text, pos, cb, state) {
	        return iterateCommentRanges(/*reduce*/ false, text, pos, /*trailing*/ false, cb, state);
	    }
	    ts.forEachLeadingCommentRange = forEachLeadingCommentRange;
	    function forEachTrailingCommentRange(text, pos, cb, state) {
	        return iterateCommentRanges(/*reduce*/ false, text, pos, /*trailing*/ true, cb, state);
	    }
	    ts.forEachTrailingCommentRange = forEachTrailingCommentRange;
	    function reduceEachLeadingCommentRange(text, pos, cb, state, initial) {
	        return iterateCommentRanges(/*reduce*/ true, text, pos, /*trailing*/ false, cb, state, initial);
	    }
	    ts.reduceEachLeadingCommentRange = reduceEachLeadingCommentRange;
	    function reduceEachTrailingCommentRange(text, pos, cb, state, initial) {
	        return iterateCommentRanges(/*reduce*/ true, text, pos, /*trailing*/ true, cb, state, initial);
	    }
	    ts.reduceEachTrailingCommentRange = reduceEachTrailingCommentRange;
	    function appendCommentRange(pos, end, kind, hasTrailingNewLine, _state, comments) {
	        if (!comments) {
	            comments = [];
	        }
	        comments.push({ kind: kind, pos: pos, end: end, hasTrailingNewLine: hasTrailingNewLine });
	        return comments;
	    }
	    function getLeadingCommentRanges(text, pos) {
	        return reduceEachLeadingCommentRange(text, pos, appendCommentRange, /*state*/ undefined, /*initial*/ undefined);
	    }
	    ts.getLeadingCommentRanges = getLeadingCommentRanges;
	    function getTrailingCommentRanges(text, pos) {
	        return reduceEachTrailingCommentRange(text, pos, appendCommentRange, /*state*/ undefined, /*initial*/ undefined);
	    }
	    ts.getTrailingCommentRanges = getTrailingCommentRanges;
	    /** Optionally, get the shebang */
	    function getShebang(text) {
	        var match = shebangTriviaRegex.exec(text);
	        if (match) {
	            return match[0];
	        }
	    }
	    ts.getShebang = getShebang;
	    function isIdentifierStart(ch, languageVersion) {
	        return ch >= 65 /* A */ && ch <= 90 /* Z */ || ch >= 97 /* a */ && ch <= 122 /* z */ ||
	            ch === 36 /* $ */ || ch === 95 /* _ */ ||
	            ch > 127 /* maxAsciiCharacter */ && isUnicodeIdentifierStart(ch, languageVersion);
	    }
	    ts.isIdentifierStart = isIdentifierStart;
	    function isIdentifierPart(ch, languageVersion) {
	        return ch >= 65 /* A */ && ch <= 90 /* Z */ || ch >= 97 /* a */ && ch <= 122 /* z */ ||
	            ch >= 48 /* _0 */ && ch <= 57 /* _9 */ || ch === 36 /* $ */ || ch === 95 /* _ */ ||
	            ch > 127 /* maxAsciiCharacter */ && isUnicodeIdentifierPart(ch, languageVersion);
	    }
	    ts.isIdentifierPart = isIdentifierPart;
	    /* @internal */
	    function isIdentifierText(name, languageVersion) {
	        if (!isIdentifierStart(name.charCodeAt(0), languageVersion)) {
	            return false;
	        }
	        for (var i = 1; i < name.length; i++) {
	            if (!isIdentifierPart(name.charCodeAt(i), languageVersion)) {
	                return false;
	            }
	        }
	        return true;
	    }
	    ts.isIdentifierText = isIdentifierText;
	    // Creates a scanner over a (possibly unspecified) range of a piece of text.
	    function createScanner(languageVersion, skipTrivia, languageVariant, text, onError, start, length) {
	        if (languageVariant === void 0) { languageVariant = 0 /* Standard */; }
	        // Current position (end position of text of current token)
	        var pos;
	        // end of text
	        var end;
	        // Start position of whitespace before current token
	        var startPos;
	        // Start position of text of current token
	        var tokenPos;
	        var token;
	        var tokenValue;
	        var tokenFlags;
	        setText(text, start, length);
	        return {
	            getStartPos: function () { return startPos; },
	            getTextPos: function () { return pos; },
	            getToken: function () { return token; },
	            getTokenPos: function () { return tokenPos; },
	            getTokenText: function () { return text.substring(tokenPos, pos); },
	            getTokenValue: function () { return tokenValue; },
	            hasExtendedUnicodeEscape: function () { return (tokenFlags & 8 /* ExtendedUnicodeEscape */) !== 0; },
	            hasPrecedingLineBreak: function () { return (tokenFlags & 1 /* PrecedingLineBreak */) !== 0; },
	            isIdentifier: function () { return token === 71 /* Identifier */ || token > 107 /* LastReservedWord */; },
	            isReservedWord: function () { return token >= 72 /* FirstReservedWord */ && token <= 107 /* LastReservedWord */; },
	            isUnterminated: function () { return (tokenFlags & 4 /* Unterminated */) !== 0; },
	            getTokenFlags: function () { return tokenFlags; },
	            reScanGreaterToken: reScanGreaterToken,
	            reScanSlashToken: reScanSlashToken,
	            reScanTemplateToken: reScanTemplateToken,
	            scanJsxIdentifier: scanJsxIdentifier,
	            scanJsxAttributeValue: scanJsxAttributeValue,
	            reScanJsxToken: reScanJsxToken,
	            scanJsxToken: scanJsxToken,
	            scanJSDocToken: scanJSDocToken,
	            scan: scan,
	            getText: getText,
	            setText: setText,
	            setScriptTarget: setScriptTarget,
	            setLanguageVariant: setLanguageVariant,
	            setOnError: setOnError,
	            setTextPos: setTextPos,
	            tryScan: tryScan,
	            lookAhead: lookAhead,
	            scanRange: scanRange,
	        };
	        function error(message, errPos, length) {
	            if (errPos === void 0) { errPos = pos; }
	            if (onError) {
	                var oldPos = pos;
	                pos = errPos;
	                onError(message, length || 0);
	                pos = oldPos;
	            }
	        }
	        function scanNumberFragment() {
	            var start = pos;
	            var allowSeparator = false;
	            var isPreviousTokenSeparator = false;
	            var result = "";
	            while (true) {
	                var ch = text.charCodeAt(pos);
	                if (ch === 95 /* _ */) {
	                    tokenFlags |= 512 /* ContainsSeparator */;
	                    if (allowSeparator) {
	                        allowSeparator = false;
	                        isPreviousTokenSeparator = true;
	                        result += text.substring(start, pos);
	                    }
	                    else if (isPreviousTokenSeparator) {
	                        error(ts.Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
	                    }
	                    else {
	                        error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
	                    }
	                    pos++;
	                    start = pos;
	                    continue;
	                }
	                if (isDigit(ch)) {
	                    allowSeparator = true;
	                    isPreviousTokenSeparator = false;
	                    pos++;
	                    continue;
	                }
	                break;
	            }
	            if (text.charCodeAt(pos - 1) === 95 /* _ */) {
	                error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
	            }
	            return result + text.substring(start, pos);
	        }
	        function scanNumber() {
	            var start = pos;
	            var mainFragment = scanNumberFragment();
	            var decimalFragment;
	            var scientificFragment;
	            if (text.charCodeAt(pos) === 46 /* dot */) {
	                pos++;
	                decimalFragment = scanNumberFragment();
	            }
	            var end = pos;
	            if (text.charCodeAt(pos) === 69 /* E */ || text.charCodeAt(pos) === 101 /* e */) {
	                pos++;
	                tokenFlags |= 16 /* Scientific */;
	                if (text.charCodeAt(pos) === 43 /* plus */ || text.charCodeAt(pos) === 45 /* minus */)
	                    pos++;
	                var preNumericPart = pos;
	                var finalFragment = scanNumberFragment();
	                if (!finalFragment) {
	                    error(ts.Diagnostics.Digit_expected);
	                }
	                else {
	                    scientificFragment = text.substring(end, preNumericPart) + finalFragment;
	                    end = pos;
	                }
	            }
	            if (tokenFlags & 512 /* ContainsSeparator */) {
	                var result = mainFragment;
	                if (decimalFragment) {
	                    result += "." + decimalFragment;
	                }
	                if (scientificFragment) {
	                    result += scientificFragment;
	                }
	                return "" + +result;
	            }
	            else {
	                return "" + +(text.substring(start, end)); // No need to use all the fragments; no _ removal needed
	            }
	        }
	        function scanOctalDigits() {
	            var start = pos;
	            while (isOctalDigit(text.charCodeAt(pos))) {
	                pos++;
	            }
	            return +(text.substring(start, pos));
	        }
	        /**
	         * Scans the given number of hexadecimal digits in the text,
	         * returning -1 if the given number is unavailable.
	         */
	        function scanExactNumberOfHexDigits(count, canHaveSeparators) {
	            return scanHexDigits(/*minCount*/ count, /*scanAsManyAsPossible*/ false, canHaveSeparators);
	        }
	        /**
	         * Scans as many hexadecimal digits as are available in the text,
	         * returning -1 if the given number of digits was unavailable.
	         */
	        function scanMinimumNumberOfHexDigits(count, canHaveSeparators) {
	            return scanHexDigits(/*minCount*/ count, /*scanAsManyAsPossible*/ true, canHaveSeparators);
	        }
	        function scanHexDigits(minCount, scanAsManyAsPossible, canHaveSeparators) {
	            var digits = 0;
	            var value = 0;
	            var allowSeparator = false;
	            var isPreviousTokenSeparator = false;
	            while (digits < minCount || scanAsManyAsPossible) {
	                var ch = text.charCodeAt(pos);
	                if (canHaveSeparators && ch === 95 /* _ */) {
	                    tokenFlags |= 512 /* ContainsSeparator */;
	                    if (allowSeparator) {
	                        allowSeparator = false;
	                        isPreviousTokenSeparator = true;
	                    }
	                    else if (isPreviousTokenSeparator) {
	                        error(ts.Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
	                    }
	                    else {
	                        error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
	                    }
	                    pos++;
	                    continue;
	                }
	                allowSeparator = canHaveSeparators;
	                if (ch >= 48 /* _0 */ && ch <= 57 /* _9 */) {
	                    value = value * 16 + ch - 48 /* _0 */;
	                }
	                else if (ch >= 65 /* A */ && ch <= 70 /* F */) {
	                    value = value * 16 + ch - 65 /* A */ + 10;
	                }
	                else if (ch >= 97 /* a */ && ch <= 102 /* f */) {
	                    value = value * 16 + ch - 97 /* a */ + 10;
	                }
	                else {
	                    break;
	                }
	                pos++;
	                digits++;
	                isPreviousTokenSeparator = false;
	            }
	            if (digits < minCount) {
	                value = -1;
	            }
	            if (text.charCodeAt(pos - 1) === 95 /* _ */) {
	                error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
	            }
	            return value;
	        }
	        function scanString(jsxAttributeString) {
	            if (jsxAttributeString === void 0) { jsxAttributeString = false; }
	            var quote = text.charCodeAt(pos);
	            pos++;
	            var result = "";
	            var start = pos;
	            while (true) {
	                if (pos >= end) {
	                    result += text.substring(start, pos);
	                    tokenFlags |= 4 /* Unterminated */;
	                    error(ts.Diagnostics.Unterminated_string_literal);
	                    break;
	                }
	                var ch = text.charCodeAt(pos);
	                if (ch === quote) {
	                    result += text.substring(start, pos);
	                    pos++;
	                    break;
	                }
	                if (ch === 92 /* backslash */ && !jsxAttributeString) {
	                    result += text.substring(start, pos);
	                    result += scanEscapeSequence();
	                    start = pos;
	                    continue;
	                }
	                if (isLineBreak(ch) && !jsxAttributeString) {
	                    result += text.substring(start, pos);
	                    tokenFlags |= 4 /* Unterminated */;
	                    error(ts.Diagnostics.Unterminated_string_literal);
	                    break;
	                }
	                pos++;
	            }
	            return result;
	        }
	        /**
	         * Sets the current 'tokenValue' and returns a NoSubstitutionTemplateLiteral or
	         * a literal component of a TemplateExpression.
	         */
	        function scanTemplateAndSetTokenValue() {
	            var startedWithBacktick = text.charCodeAt(pos) === 96 /* backtick */;
	            pos++;
	            var start = pos;
	            var contents = "";
	            var resultingToken;
	            while (true) {
	                if (pos >= end) {
	                    contents += text.substring(start, pos);
	                    tokenFlags |= 4 /* Unterminated */;
	                    error(ts.Diagnostics.Unterminated_template_literal);
	                    resultingToken = startedWithBacktick ? 13 /* NoSubstitutionTemplateLiteral */ : 16 /* TemplateTail */;
	                    break;
	                }
	                var currChar = text.charCodeAt(pos);
	                // '`'
	                if (currChar === 96 /* backtick */) {
	                    contents += text.substring(start, pos);
	                    pos++;
	                    resultingToken = startedWithBacktick ? 13 /* NoSubstitutionTemplateLiteral */ : 16 /* TemplateTail */;
	                    break;
	                }
	                // '${'
	                if (currChar === 36 /* $ */ && pos + 1 < end && text.charCodeAt(pos + 1) === 123 /* openBrace */) {
	                    contents += text.substring(start, pos);
	                    pos += 2;
	                    resultingToken = startedWithBacktick ? 14 /* TemplateHead */ : 15 /* TemplateMiddle */;
	                    break;
	                }
	                // Escape character
	                if (currChar === 92 /* backslash */) {
	                    contents += text.substring(start, pos);
	                    contents += scanEscapeSequence();
	                    start = pos;
	                    continue;
	                }
	                // Speculated ECMAScript 6 Spec 11.8.6.1:
	                // <CR><LF> and <CR> LineTerminatorSequences are normalized to <LF> for Template Values
	                if (currChar === 13 /* carriageReturn */) {
	                    contents += text.substring(start, pos);
	                    pos++;
	                    if (pos < end && text.charCodeAt(pos) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                    contents += "\n";
	                    start = pos;
	                    continue;
	                }
	                pos++;
	            }
	            ts.Debug.assert(resultingToken !== undefined);
	            tokenValue = contents;
	            return resultingToken;
	        }
	        function scanEscapeSequence() {
	            pos++;
	            if (pos >= end) {
	                error(ts.Diagnostics.Unexpected_end_of_text);
	                return "";
	            }
	            var ch = text.charCodeAt(pos);
	            pos++;
	            switch (ch) {
	                case 48 /* _0 */:
	                    return "\0";
	                case 98 /* b */:
	                    return "\b";
	                case 116 /* t */:
	                    return "\t";
	                case 110 /* n */:
	                    return "\n";
	                case 118 /* v */:
	                    return "\v";
	                case 102 /* f */:
	                    return "\f";
	                case 114 /* r */:
	                    return "\r";
	                case 39 /* singleQuote */:
	                    return "\'";
	                case 34 /* doubleQuote */:
	                    return "\"";
	                case 117 /* u */:
	                    // '\u{DDDDDDDD}'
	                    if (pos < end && text.charCodeAt(pos) === 123 /* openBrace */) {
	                        tokenFlags |= 8 /* ExtendedUnicodeEscape */;
	                        pos++;
	                        return scanExtendedUnicodeEscape();
	                    }
	                    // '\uDDDD'
	                    return scanHexadecimalEscape(/*numDigits*/ 4);
	                case 120 /* x */:
	                    // '\xDD'
	                    return scanHexadecimalEscape(/*numDigits*/ 2);
	                // when encountering a LineContinuation (i.e. a backslash and a line terminator sequence),
	                // the line terminator is interpreted to be "the empty code unit sequence".
	                case 13 /* carriageReturn */:
	                    if (pos < end && text.charCodeAt(pos) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                // falls through
	                case 10 /* lineFeed */:
	                case 8232 /* lineSeparator */:
	                case 8233 /* paragraphSeparator */:
	                    return "";
	                default:
	                    return String.fromCharCode(ch);
	            }
	        }
	        function scanHexadecimalEscape(numDigits) {
	            var escapedValue = scanExactNumberOfHexDigits(numDigits, /*canHaveSeparators*/ false);
	            if (escapedValue >= 0) {
	                return String.fromCharCode(escapedValue);
	            }
	            else {
	                error(ts.Diagnostics.Hexadecimal_digit_expected);
	                return "";
	            }
	        }
	        function scanExtendedUnicodeEscape() {
	            var escapedValue = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ false);
	            var isInvalidExtendedEscape = false;
	            // Validate the value of the digit
	            if (escapedValue < 0) {
	                error(ts.Diagnostics.Hexadecimal_digit_expected);
	                isInvalidExtendedEscape = true;
	            }
	            else if (escapedValue > 0x10FFFF) {
	                error(ts.Diagnostics.An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive);
	                isInvalidExtendedEscape = true;
	            }
	            if (pos >= end) {
	                error(ts.Diagnostics.Unexpected_end_of_text);
	                isInvalidExtendedEscape = true;
	            }
	            else if (text.charCodeAt(pos) === 125 /* closeBrace */) {
	                // Only swallow the following character up if it's a '}'.
	                pos++;
	            }
	            else {
	                error(ts.Diagnostics.Unterminated_Unicode_escape_sequence);
	                isInvalidExtendedEscape = true;
	            }
	            if (isInvalidExtendedEscape) {
	                return "";
	            }
	            return utf16EncodeAsString(escapedValue);
	        }
	        // Derived from the 10.1.1 UTF16Encoding of the ES6 Spec.
	        function utf16EncodeAsString(codePoint) {
	            ts.Debug.assert(0x0 <= codePoint && codePoint <= 0x10FFFF);
	            if (codePoint <= 65535) {
	                return String.fromCharCode(codePoint);
	            }
	            var codeUnit1 = Math.floor((codePoint - 65536) / 1024) + 0xD800;
	            var codeUnit2 = ((codePoint - 65536) % 1024) + 0xDC00;
	            return String.fromCharCode(codeUnit1, codeUnit2);
	        }
	        // Current character is known to be a backslash. Check for Unicode escape of the form '\uXXXX'
	        // and return code point value if valid Unicode escape is found. Otherwise return -1.
	        function peekUnicodeEscape() {
	            if (pos + 5 < end && text.charCodeAt(pos + 1) === 117 /* u */) {
	                var start_1 = pos;
	                pos += 2;
	                var value = scanExactNumberOfHexDigits(4, /*canHaveSeparators*/ false);
	                pos = start_1;
	                return value;
	            }
	            return -1;
	        }
	        function scanIdentifierParts() {
	            var result = "";
	            var start = pos;
	            while (pos < end) {
	                var ch = text.charCodeAt(pos);
	                if (isIdentifierPart(ch, languageVersion)) {
	                    pos++;
	                }
	                else if (ch === 92 /* backslash */) {
	                    ch = peekUnicodeEscape();
	                    if (!(ch >= 0 && isIdentifierPart(ch, languageVersion))) {
	                        break;
	                    }
	                    result += text.substring(start, pos);
	                    result += String.fromCharCode(ch);
	                    // Valid Unicode escape is always six characters
	                    pos += 6;
	                    start = pos;
	                }
	                else {
	                    break;
	                }
	            }
	            result += text.substring(start, pos);
	            return result;
	        }
	        function getIdentifierToken() {
	            // Reserved words are between 2 and 11 characters long and start with a lowercase letter
	            var len = tokenValue.length;
	            if (len >= 2 && len <= 11) {
	                var ch = tokenValue.charCodeAt(0);
	                if (ch >= 97 /* a */ && ch <= 122 /* z */) {
	                    token = textToToken.get(tokenValue);
	                    if (token !== undefined) {
	                        return token;
	                    }
	                }
	            }
	            return token = 71 /* Identifier */;
	        }
	        function scanBinaryOrOctalDigits(base) {
	            ts.Debug.assert(base === 2 || base === 8, "Expected either base 2 or base 8");
	            var value = 0;
	            // For counting number of digits; Valid binaryIntegerLiteral must have at least one binary digit following B or b.
	            // Similarly valid octalIntegerLiteral must have at least one octal digit following o or O.
	            var numberOfDigits = 0;
	            var separatorAllowed = false;
	            var isPreviousTokenSeparator = false;
	            while (true) {
	                var ch = text.charCodeAt(pos);
	                // Numeric seperators are allowed anywhere within a numeric literal, except not at the beginning, or following another separator
	                if (ch === 95 /* _ */) {
	                    tokenFlags |= 512 /* ContainsSeparator */;
	                    if (separatorAllowed) {
	                        separatorAllowed = false;
	                        isPreviousTokenSeparator = true;
	                    }
	                    else if (isPreviousTokenSeparator) {
	                        error(ts.Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
	                    }
	                    else {
	                        error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
	                    }
	                    pos++;
	                    continue;
	                }
	                separatorAllowed = true;
	                var valueOfCh = ch - 48 /* _0 */;
	                if (!isDigit(ch) || valueOfCh >= base) {
	                    break;
	                }
	                value = value * base + valueOfCh;
	                pos++;
	                numberOfDigits++;
	                isPreviousTokenSeparator = false;
	            }
	            // Invalid binaryIntegerLiteral or octalIntegerLiteral
	            if (numberOfDigits === 0) {
	                return -1;
	            }
	            if (text.charCodeAt(pos - 1) === 95 /* _ */) {
	                // Literal ends with underscore - not allowed
	                error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
	                return value;
	            }
	            return value;
	        }
	        function scan() {
	            startPos = pos;
	            tokenFlags = 0;
	            while (true) {
	                tokenPos = pos;
	                if (pos >= end) {
	                    return token = 1 /* EndOfFileToken */;
	                }
	                var ch = text.charCodeAt(pos);
	                // Special handling for shebang
	                if (ch === 35 /* hash */ && pos === 0 && isShebangTrivia(text, pos)) {
	                    pos = scanShebangTrivia(text, pos);
	                    if (skipTrivia) {
	                        continue;
	                    }
	                    else {
	                        return token = 6 /* ShebangTrivia */;
	                    }
	                }
	                switch (ch) {
	                    case 10 /* lineFeed */:
	                    case 13 /* carriageReturn */:
	                        tokenFlags |= 1 /* PrecedingLineBreak */;
	                        if (skipTrivia) {
	                            pos++;
	                            continue;
	                        }
	                        else {
	                            if (ch === 13 /* carriageReturn */ && pos + 1 < end && text.charCodeAt(pos + 1) === 10 /* lineFeed */) {
	                                // consume both CR and LF
	                                pos += 2;
	                            }
	                            else {
	                                pos++;
	                            }
	                            return token = 4 /* NewLineTrivia */;
	                        }
	                    case 9 /* tab */:
	                    case 11 /* verticalTab */:
	                    case 12 /* formFeed */:
	                    case 32 /* space */:
	                        if (skipTrivia) {
	                            pos++;
	                            continue;
	                        }
	                        else {
	                            while (pos < end && isWhiteSpaceSingleLine(text.charCodeAt(pos))) {
	                                pos++;
	                            }
	                            return token = 5 /* WhitespaceTrivia */;
	                        }
	                    case 33 /* exclamation */:
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                                return pos += 3, token = 35 /* ExclamationEqualsEqualsToken */;
	                            }
	                            return pos += 2, token = 33 /* ExclamationEqualsToken */;
	                        }
	                        pos++;
	                        return token = 51 /* ExclamationToken */;
	                    case 34 /* doubleQuote */:
	                    case 39 /* singleQuote */:
	                        tokenValue = scanString();
	                        return token = 9 /* StringLiteral */;
	                    case 96 /* backtick */:
	                        return token = scanTemplateAndSetTokenValue();
	                    case 37 /* percent */:
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 64 /* PercentEqualsToken */;
	                        }
	                        pos++;
	                        return token = 42 /* PercentToken */;
	                    case 38 /* ampersand */:
	                        if (text.charCodeAt(pos + 1) === 38 /* ampersand */) {
	                            return pos += 2, token = 53 /* AmpersandAmpersandToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 68 /* AmpersandEqualsToken */;
	                        }
	                        pos++;
	                        return token = 48 /* AmpersandToken */;
	                    case 40 /* openParen */:
	                        pos++;
	                        return token = 19 /* OpenParenToken */;
	                    case 41 /* closeParen */:
	                        pos++;
	                        return token = 20 /* CloseParenToken */;
	                    case 42 /* asterisk */:
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 61 /* AsteriskEqualsToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 42 /* asterisk */) {
	                            if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                                return pos += 3, token = 62 /* AsteriskAsteriskEqualsToken */;
	                            }
	                            return pos += 2, token = 40 /* AsteriskAsteriskToken */;
	                        }
	                        pos++;
	                        return token = 39 /* AsteriskToken */;
	                    case 43 /* plus */:
	                        if (text.charCodeAt(pos + 1) === 43 /* plus */) {
	                            return pos += 2, token = 43 /* PlusPlusToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 59 /* PlusEqualsToken */;
	                        }
	                        pos++;
	                        return token = 37 /* PlusToken */;
	                    case 44 /* comma */:
	                        pos++;
	                        return token = 26 /* CommaToken */;
	                    case 45 /* minus */:
	                        if (text.charCodeAt(pos + 1) === 45 /* minus */) {
	                            return pos += 2, token = 44 /* MinusMinusToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 60 /* MinusEqualsToken */;
	                        }
	                        pos++;
	                        return token = 38 /* MinusToken */;
	                    case 46 /* dot */:
	                        if (isDigit(text.charCodeAt(pos + 1))) {
	                            tokenValue = scanNumber();
	                            return token = 8 /* NumericLiteral */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 46 /* dot */ && text.charCodeAt(pos + 2) === 46 /* dot */) {
	                            return pos += 3, token = 24 /* DotDotDotToken */;
	                        }
	                        pos++;
	                        return token = 23 /* DotToken */;
	                    case 47 /* slash */:
	                        // Single-line comment
	                        if (text.charCodeAt(pos + 1) === 47 /* slash */) {
	                            pos += 2;
	                            while (pos < end) {
	                                if (isLineBreak(text.charCodeAt(pos))) {
	                                    break;
	                                }
	                                pos++;
	                            }
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 2 /* SingleLineCommentTrivia */;
	                            }
	                        }
	                        // Multi-line comment
	                        if (text.charCodeAt(pos + 1) === 42 /* asterisk */) {
	                            pos += 2;
	                            if (text.charCodeAt(pos) === 42 /* asterisk */ && text.charCodeAt(pos + 1) !== 47 /* slash */) {
	                                tokenFlags |= 2 /* PrecedingJSDocComment */;
	                            }
	                            var commentClosed = false;
	                            while (pos < end) {
	                                var ch_1 = text.charCodeAt(pos);
	                                if (ch_1 === 42 /* asterisk */ && text.charCodeAt(pos + 1) === 47 /* slash */) {
	                                    pos += 2;
	                                    commentClosed = true;
	                                    break;
	                                }
	                                if (isLineBreak(ch_1)) {
	                                    tokenFlags |= 1 /* PrecedingLineBreak */;
	                                }
	                                pos++;
	                            }
	                            if (!commentClosed) {
	                                error(ts.Diagnostics.Asterisk_Slash_expected);
	                            }
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                if (!commentClosed) {
	                                    tokenFlags |= 4 /* Unterminated */;
	                                }
	                                return token = 3 /* MultiLineCommentTrivia */;
	                            }
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 63 /* SlashEqualsToken */;
	                        }
	                        pos++;
	                        return token = 41 /* SlashToken */;
	                    case 48 /* _0 */:
	                        if (pos + 2 < end && (text.charCodeAt(pos + 1) === 88 /* X */ || text.charCodeAt(pos + 1) === 120 /* x */)) {
	                            pos += 2;
	                            var value = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ true);
	                            if (value < 0) {
	                                error(ts.Diagnostics.Hexadecimal_digit_expected);
	                                value = 0;
	                            }
	                            tokenValue = "" + value;
	                            tokenFlags |= 64 /* HexSpecifier */;
	                            return token = 8 /* NumericLiteral */;
	                        }
	                        else if (pos + 2 < end && (text.charCodeAt(pos + 1) === 66 /* B */ || text.charCodeAt(pos + 1) === 98 /* b */)) {
	                            pos += 2;
	                            var value = scanBinaryOrOctalDigits(/* base */ 2);
	                            if (value < 0) {
	                                error(ts.Diagnostics.Binary_digit_expected);
	                                value = 0;
	                            }
	                            tokenValue = "" + value;
	                            tokenFlags |= 128 /* BinarySpecifier */;
	                            return token = 8 /* NumericLiteral */;
	                        }
	                        else if (pos + 2 < end && (text.charCodeAt(pos + 1) === 79 /* O */ || text.charCodeAt(pos + 1) === 111 /* o */)) {
	                            pos += 2;
	                            var value = scanBinaryOrOctalDigits(/* base */ 8);
	                            if (value < 0) {
	                                error(ts.Diagnostics.Octal_digit_expected);
	                                value = 0;
	                            }
	                            tokenValue = "" + value;
	                            tokenFlags |= 256 /* OctalSpecifier */;
	                            return token = 8 /* NumericLiteral */;
	                        }
	                        // Try to parse as an octal
	                        if (pos + 1 < end && isOctalDigit(text.charCodeAt(pos + 1))) {
	                            tokenValue = "" + scanOctalDigits();
	                            tokenFlags |= 32 /* Octal */;
	                            return token = 8 /* NumericLiteral */;
	                        }
	                    // This fall-through is a deviation from the EcmaScript grammar. The grammar says that a leading zero
	                    // can only be followed by an octal digit, a dot, or the end of the number literal. However, we are being
	                    // permissive and allowing decimal digits of the form 08* and 09* (which many browsers also do).
	                    // falls through
	                    case 49 /* _1 */:
	                    case 50 /* _2 */:
	                    case 51 /* _3 */:
	                    case 52 /* _4 */:
	                    case 53 /* _5 */:
	                    case 54 /* _6 */:
	                    case 55 /* _7 */:
	                    case 56 /* _8 */:
	                    case 57 /* _9 */:
	                        tokenValue = scanNumber();
	                        return token = 8 /* NumericLiteral */;
	                    case 58 /* colon */:
	                        pos++;
	                        return token = 56 /* ColonToken */;
	                    case 59 /* semicolon */:
	                        pos++;
	                        return token = 25 /* SemicolonToken */;
	                    case 60 /* lessThan */:
	                        if (isConflictMarkerTrivia(text, pos)) {
	                            pos = scanConflictMarkerTrivia(text, pos, error);
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 7 /* ConflictMarkerTrivia */;
	                            }
	                        }
	                        if (text.charCodeAt(pos + 1) === 60 /* lessThan */) {
	                            if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                                return pos += 3, token = 65 /* LessThanLessThanEqualsToken */;
	                            }
	                            return pos += 2, token = 45 /* LessThanLessThanToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 30 /* LessThanEqualsToken */;
	                        }
	                        if (languageVariant === 1 /* JSX */ &&
	                            text.charCodeAt(pos + 1) === 47 /* slash */ &&
	                            text.charCodeAt(pos + 2) !== 42 /* asterisk */) {
	                            return pos += 2, token = 28 /* LessThanSlashToken */;
	                        }
	                        pos++;
	                        return token = 27 /* LessThanToken */;
	                    case 61 /* equals */:
	                        if (isConflictMarkerTrivia(text, pos)) {
	                            pos = scanConflictMarkerTrivia(text, pos, error);
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 7 /* ConflictMarkerTrivia */;
	                            }
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                                return pos += 3, token = 34 /* EqualsEqualsEqualsToken */;
	                            }
	                            return pos += 2, token = 32 /* EqualsEqualsToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 62 /* greaterThan */) {
	                            return pos += 2, token = 36 /* EqualsGreaterThanToken */;
	                        }
	                        pos++;
	                        return token = 58 /* EqualsToken */;
	                    case 62 /* greaterThan */:
	                        if (isConflictMarkerTrivia(text, pos)) {
	                            pos = scanConflictMarkerTrivia(text, pos, error);
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 7 /* ConflictMarkerTrivia */;
	                            }
	                        }
	                        pos++;
	                        return token = 29 /* GreaterThanToken */;
	                    case 63 /* question */:
	                        pos++;
	                        return token = 55 /* QuestionToken */;
	                    case 91 /* openBracket */:
	                        pos++;
	                        return token = 21 /* OpenBracketToken */;
	                    case 93 /* closeBracket */:
	                        pos++;
	                        return token = 22 /* CloseBracketToken */;
	                    case 94 /* caret */:
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 70 /* CaretEqualsToken */;
	                        }
	                        pos++;
	                        return token = 50 /* CaretToken */;
	                    case 123 /* openBrace */:
	                        pos++;
	                        return token = 17 /* OpenBraceToken */;
	                    case 124 /* bar */:
	                        if (isConflictMarkerTrivia(text, pos)) {
	                            pos = scanConflictMarkerTrivia(text, pos, error);
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 7 /* ConflictMarkerTrivia */;
	                            }
	                        }
	                        if (text.charCodeAt(pos + 1) === 124 /* bar */) {
	                            return pos += 2, token = 54 /* BarBarToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 69 /* BarEqualsToken */;
	                        }
	                        pos++;
	                        return token = 49 /* BarToken */;
	                    case 125 /* closeBrace */:
	                        pos++;
	                        return token = 18 /* CloseBraceToken */;
	                    case 126 /* tilde */:
	                        pos++;
	                        return token = 52 /* TildeToken */;
	                    case 64 /* at */:
	                        pos++;
	                        return token = 57 /* AtToken */;
	                    case 92 /* backslash */:
	                        var cookedChar = peekUnicodeEscape();
	                        if (cookedChar >= 0 && isIdentifierStart(cookedChar, languageVersion)) {
	                            pos += 6;
	                            tokenValue = String.fromCharCode(cookedChar) + scanIdentifierParts();
	                            return token = getIdentifierToken();
	                        }
	                        error(ts.Diagnostics.Invalid_character);
	                        pos++;
	                        return token = 0 /* Unknown */;
	                    default:
	                        if (isIdentifierStart(ch, languageVersion)) {
	                            pos++;
	                            while (pos < end && isIdentifierPart(ch = text.charCodeAt(pos), languageVersion))
	                                pos++;
	                            tokenValue = text.substring(tokenPos, pos);
	                            if (ch === 92 /* backslash */) {
	                                tokenValue += scanIdentifierParts();
	                            }
	                            return token = getIdentifierToken();
	                        }
	                        else if (isWhiteSpaceSingleLine(ch)) {
	                            pos++;
	                            continue;
	                        }
	                        else if (isLineBreak(ch)) {
	                            tokenFlags |= 1 /* PrecedingLineBreak */;
	                            pos++;
	                            continue;
	                        }
	                        error(ts.Diagnostics.Invalid_character);
	                        pos++;
	                        return token = 0 /* Unknown */;
	                }
	            }
	        }
	        function reScanGreaterToken() {
	            if (token === 29 /* GreaterThanToken */) {
	                if (text.charCodeAt(pos) === 62 /* greaterThan */) {
	                    if (text.charCodeAt(pos + 1) === 62 /* greaterThan */) {
	                        if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                            return pos += 3, token = 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */;
	                        }
	                        return pos += 2, token = 47 /* GreaterThanGreaterThanGreaterThanToken */;
	                    }
	                    if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                        return pos += 2, token = 66 /* GreaterThanGreaterThanEqualsToken */;
	                    }
	                    pos++;
	                    return token = 46 /* GreaterThanGreaterThanToken */;
	                }
	                if (text.charCodeAt(pos) === 61 /* equals */) {
	                    pos++;
	                    return token = 31 /* GreaterThanEqualsToken */;
	                }
	            }
	            return token;
	        }
	        function reScanSlashToken() {
	            if (token === 41 /* SlashToken */ || token === 63 /* SlashEqualsToken */) {
	                var p = tokenPos + 1;
	                var inEscape = false;
	                var inCharacterClass = false;
	                while (true) {
	                    // If we reach the end of a file, or hit a newline, then this is an unterminated
	                    // regex.  Report error and return what we have so far.
	                    if (p >= end) {
	                        tokenFlags |= 4 /* Unterminated */;
	                        error(ts.Diagnostics.Unterminated_regular_expression_literal);
	                        break;
	                    }
	                    var ch = text.charCodeAt(p);
	                    if (isLineBreak(ch)) {
	                        tokenFlags |= 4 /* Unterminated */;
	                        error(ts.Diagnostics.Unterminated_regular_expression_literal);
	                        break;
	                    }
	                    if (inEscape) {
	                        // Parsing an escape character;
	                        // reset the flag and just advance to the next char.
	                        inEscape = false;
	                    }
	                    else if (ch === 47 /* slash */ && !inCharacterClass) {
	                        // A slash within a character class is permissible,
	                        // but in general it signals the end of the regexp literal.
	                        p++;
	                        break;
	                    }
	                    else if (ch === 91 /* openBracket */) {
	                        inCharacterClass = true;
	                    }
	                    else if (ch === 92 /* backslash */) {
	                        inEscape = true;
	                    }
	                    else if (ch === 93 /* closeBracket */) {
	                        inCharacterClass = false;
	                    }
	                    p++;
	                }
	                while (p < end && isIdentifierPart(text.charCodeAt(p), languageVersion)) {
	                    p++;
	                }
	                pos = p;
	                tokenValue = text.substring(tokenPos, pos);
	                token = 12 /* RegularExpressionLiteral */;
	            }
	            return token;
	        }
	        /**
	         * Unconditionally back up and scan a template expression portion.
	         */
	        function reScanTemplateToken() {
	            ts.Debug.assert(token === 18 /* CloseBraceToken */, "'reScanTemplateToken' should only be called on a '}'");
	            pos = tokenPos;
	            return token = scanTemplateAndSetTokenValue();
	        }
	        function reScanJsxToken() {
	            pos = tokenPos = startPos;
	            return token = scanJsxToken();
	        }
	        function scanJsxToken() {
	            startPos = tokenPos = pos;
	            if (pos >= end) {
	                return token = 1 /* EndOfFileToken */;
	            }
	            var char = text.charCodeAt(pos);
	            if (char === 60 /* lessThan */) {
	                if (text.charCodeAt(pos + 1) === 47 /* slash */) {
	                    pos += 2;
	                    return token = 28 /* LessThanSlashToken */;
	                }
	                pos++;
	                return token = 27 /* LessThanToken */;
	            }
	            if (char === 123 /* openBrace */) {
	                pos++;
	                return token = 17 /* OpenBraceToken */;
	            }
	            // First non-whitespace character on this line.
	            var firstNonWhitespace = 0;
	            // These initial values are special because the first line is:
	            // firstNonWhitespace = 0 to indicate that we want leading whitspace,
	            while (pos < end) {
	                char = text.charCodeAt(pos);
	                if (char === 123 /* openBrace */) {
	                    break;
	                }
	                if (char === 60 /* lessThan */) {
	                    if (isConflictMarkerTrivia(text, pos)) {
	                        pos = scanConflictMarkerTrivia(text, pos, error);
	                        return token = 7 /* ConflictMarkerTrivia */;
	                    }
	                    break;
	                }
	                // FirstNonWhitespace is 0, then we only see whitespaces so far. If we see a linebreak, we want to ignore that whitespaces.
	                // i.e (- : whitespace)
	                //      <div>----
	                //      </div> becomes <div></div>
	                //
	                //      <div>----</div> becomes <div>----</div>
	                if (isLineBreak(char) && firstNonWhitespace === 0) {
	                    firstNonWhitespace = -1;
	                }
	                else if (!isWhiteSpaceLike(char)) {
	                    firstNonWhitespace = pos;
	                }
	                pos++;
	            }
	            return firstNonWhitespace === -1 ? 11 /* JsxTextAllWhiteSpaces */ : 10 /* JsxText */;
	        }
	        // Scans a JSX identifier; these differ from normal identifiers in that
	        // they allow dashes
	        function scanJsxIdentifier() {
	            if (tokenIsIdentifierOrKeyword(token)) {
	                var firstCharPosition = pos;
	                while (pos < end) {
	                    var ch = text.charCodeAt(pos);
	                    if (ch === 45 /* minus */ || ((firstCharPosition === pos) ? isIdentifierStart(ch, languageVersion) : isIdentifierPart(ch, languageVersion))) {
	                        pos++;
	                    }
	                    else {
	                        break;
	                    }
	                }
	                tokenValue += text.substring(firstCharPosition, pos);
	            }
	            return token;
	        }
	        function scanJsxAttributeValue() {
	            startPos = pos;
	            switch (text.charCodeAt(pos)) {
	                case 34 /* doubleQuote */:
	                case 39 /* singleQuote */:
	                    tokenValue = scanString(/*jsxAttributeString*/ true);
	                    return token = 9 /* StringLiteral */;
	                default:
	                    // If this scans anything other than `{`, it's a parse error.
	                    return scan();
	            }
	        }
	        function scanJSDocToken() {
	            if (pos >= end) {
	                return token = 1 /* EndOfFileToken */;
	            }
	            startPos = pos;
	            tokenPos = pos;
	            var ch = text.charCodeAt(pos);
	            pos++;
	            switch (ch) {
	                case 9 /* tab */:
	                case 11 /* verticalTab */:
	                case 12 /* formFeed */:
	                case 32 /* space */:
	                    while (pos < end && isWhiteSpaceSingleLine(text.charCodeAt(pos))) {
	                        pos++;
	                    }
	                    return token = 5 /* WhitespaceTrivia */;
	                case 64 /* at */:
	                    return token = 57 /* AtToken */;
	                case 10 /* lineFeed */:
	                case 13 /* carriageReturn */:
	                    return token = 4 /* NewLineTrivia */;
	                case 42 /* asterisk */:
	                    return token = 39 /* AsteriskToken */;
	                case 123 /* openBrace */:
	                    return token = 17 /* OpenBraceToken */;
	                case 125 /* closeBrace */:
	                    return token = 18 /* CloseBraceToken */;
	                case 91 /* openBracket */:
	                    return token = 21 /* OpenBracketToken */;
	                case 93 /* closeBracket */:
	                    return token = 22 /* CloseBracketToken */;
	                case 60 /* lessThan */:
	                    return token = 27 /* LessThanToken */;
	                case 61 /* equals */:
	                    return token = 58 /* EqualsToken */;
	                case 44 /* comma */:
	                    return token = 26 /* CommaToken */;
	                case 46 /* dot */:
	                    return token = 23 /* DotToken */;
	            }
	            if (isIdentifierStart(ch, 6 /* Latest */)) {
	                while (isIdentifierPart(text.charCodeAt(pos), 6 /* Latest */) && pos < end) {
	                    pos++;
	                }
	                tokenValue = text.substring(tokenPos, pos);
	                return token = 71 /* Identifier */;
	            }
	            else {
	                return token = 0 /* Unknown */;
	            }
	        }
	        function speculationHelper(callback, isLookahead) {
	            var savePos = pos;
	            var saveStartPos = startPos;
	            var saveTokenPos = tokenPos;
	            var saveToken = token;
	            var saveTokenValue = tokenValue;
	            var saveTokenFlags = tokenFlags;
	            var result = callback();
	            // If our callback returned something 'falsy' or we're just looking ahead,
	            // then unconditionally restore us to where we were.
	            if (!result || isLookahead) {
	                pos = savePos;
	                startPos = saveStartPos;
	                tokenPos = saveTokenPos;
	                token = saveToken;
	                tokenValue = saveTokenValue;
	                tokenFlags = saveTokenFlags;
	            }
	            return result;
	        }
	        function scanRange(start, length, callback) {
	            var saveEnd = end;
	            var savePos = pos;
	            var saveStartPos = startPos;
	            var saveTokenPos = tokenPos;
	            var saveToken = token;
	            var saveTokenValue = tokenValue;
	            var saveTokenFlags = tokenFlags;
	            setText(text, start, length);
	            var result = callback();
	            end = saveEnd;
	            pos = savePos;
	            startPos = saveStartPos;
	            tokenPos = saveTokenPos;
	            token = saveToken;
	            tokenValue = saveTokenValue;
	            tokenFlags = saveTokenFlags;
	            return result;
	        }
	        function lookAhead(callback) {
	            return speculationHelper(callback, /*isLookahead*/ true);
	        }
	        function tryScan(callback) {
	            return speculationHelper(callback, /*isLookahead*/ false);
	        }
	        function getText() {
	            return text;
	        }
	        function setText(newText, start, length) {
	            text = newText || "";
	            end = length === undefined ? text.length : start + length;
	            setTextPos(start || 0);
	        }
	        function setOnError(errorCallback) {
	            onError = errorCallback;
	        }
	        function setScriptTarget(scriptTarget) {
	            languageVersion = scriptTarget;
	        }
	        function setLanguageVariant(variant) {
	            languageVariant = variant;
	        }
	        function setTextPos(textPos) {
	            ts.Debug.assert(textPos >= 0);
	            pos = textPos;
	            startPos = textPos;
	            tokenPos = textPos;
	            token = 0 /* Unknown */;
	            tokenValue = undefined;
	            tokenFlags = 0;
	        }
	    }
	    ts.createScanner = createScanner;
	})(ts || (ts = {}));
	/// <reference path="sys.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    ts.resolvingEmptyArray = [];
	    ts.emptyMap = ts.createMap();
	    ts.emptyUnderscoreEscapedMap = ts.emptyMap;
	    ts.externalHelpersModuleNameText = "tslib";
	    function getDeclarationOfKind(symbol, kind) {
	        var declarations = symbol.declarations;
	        if (declarations) {
	            for (var _i = 0, declarations_1 = declarations; _i < declarations_1.length; _i++) {
	                var declaration = declarations_1[_i];
	                if (declaration.kind === kind) {
	                    return declaration;
	                }
	            }
	        }
	        return undefined;
	    }
	    ts.getDeclarationOfKind = getDeclarationOfKind;
	    var stringWriter = createSingleLineStringWriter();
	    function createSingleLineStringWriter() {
	        var str = "";
	        var writeText = function (text) { return str += text; };
	        return {
	            getText: function () { return str; },
	            write: writeText,
	            rawWrite: writeText,
	            writeTextOfNode: writeText,
	            writeKeyword: writeText,
	            writeOperator: writeText,
	            writePunctuation: writeText,
	            writeSpace: writeText,
	            writeStringLiteral: writeText,
	            writeLiteral: writeText,
	            writeParameter: writeText,
	            writeProperty: writeText,
	            writeSymbol: writeText,
	            getTextPos: function () { return str.length; },
	            getLine: function () { return 0; },
	            getColumn: function () { return 0; },
	            getIndent: function () { return 0; },
	            isAtStartOfLine: function () { return false; },
	            // Completely ignore indentation for string writers.  And map newlines to
	            // a single space.
	            writeLine: function () { return str += " "; },
	            increaseIndent: ts.noop,
	            decreaseIndent: ts.noop,
	            clear: function () { return str = ""; },
	            trackSymbol: ts.noop,
	            reportInaccessibleThisError: ts.noop,
	            reportInaccessibleUniqueSymbolError: ts.noop,
	            reportPrivateInBaseOfClassExpression: ts.noop,
	        };
	    }
	    function usingSingleLineStringWriter(action) {
	        var oldString = stringWriter.getText();
	        try {
	            action(stringWriter);
	            return stringWriter.getText();
	        }
	        finally {
	            stringWriter.clear();
	            stringWriter.writeKeyword(oldString);
	        }
	    }
	    ts.usingSingleLineStringWriter = usingSingleLineStringWriter;
	    function getFullWidth(node) {
	        return node.end - node.pos;
	    }
	    ts.getFullWidth = getFullWidth;
	    function getResolvedModule(sourceFile, moduleNameText) {
	        return sourceFile && sourceFile.resolvedModules && sourceFile.resolvedModules.get(moduleNameText);
	    }
	    ts.getResolvedModule = getResolvedModule;
	    function setResolvedModule(sourceFile, moduleNameText, resolvedModule) {
	        if (!sourceFile.resolvedModules) {
	            sourceFile.resolvedModules = ts.createMap();
	        }
	        sourceFile.resolvedModules.set(moduleNameText, resolvedModule);
	    }
	    ts.setResolvedModule = setResolvedModule;
	    function setResolvedTypeReferenceDirective(sourceFile, typeReferenceDirectiveName, resolvedTypeReferenceDirective) {
	        if (!sourceFile.resolvedTypeReferenceDirectiveNames) {
	            sourceFile.resolvedTypeReferenceDirectiveNames = ts.createMap();
	        }
	        sourceFile.resolvedTypeReferenceDirectiveNames.set(typeReferenceDirectiveName, resolvedTypeReferenceDirective);
	    }
	    ts.setResolvedTypeReferenceDirective = setResolvedTypeReferenceDirective;
	    function moduleResolutionIsEqualTo(oldResolution, newResolution) {
	        return oldResolution.isExternalLibraryImport === newResolution.isExternalLibraryImport &&
	            oldResolution.extension === newResolution.extension &&
	            oldResolution.resolvedFileName === newResolution.resolvedFileName &&
	            oldResolution.originalPath === newResolution.originalPath &&
	            packageIdIsEqual(oldResolution.packageId, newResolution.packageId);
	    }
	    ts.moduleResolutionIsEqualTo = moduleResolutionIsEqualTo;
	    function packageIdIsEqual(a, b) {
	        return a === b || a && b && a.name === b.name && a.subModuleName === b.subModuleName && a.version === b.version;
	    }
	    function packageIdToString(_a) {
	        var name = _a.name, subModuleName = _a.subModuleName, version = _a.version;
	        var fullName = subModuleName ? name + "/" + subModuleName : name;
	        return fullName + "@" + version;
	    }
	    ts.packageIdToString = packageIdToString;
	    function typeDirectiveIsEqualTo(oldResolution, newResolution) {
	        return oldResolution.resolvedFileName === newResolution.resolvedFileName && oldResolution.primary === newResolution.primary;
	    }
	    ts.typeDirectiveIsEqualTo = typeDirectiveIsEqualTo;
	    function hasChangesInResolutions(names, newResolutions, oldResolutions, comparer) {
	        ts.Debug.assert(names.length === newResolutions.length);
	        for (var i = 0; i < names.length; i++) {
	            var newResolution = newResolutions[i];
	            var oldResolution = oldResolutions && oldResolutions.get(names[i]);
	            var changed = oldResolution
	                ? !newResolution || !comparer(oldResolution, newResolution)
	                : newResolution;
	            if (changed) {
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.hasChangesInResolutions = hasChangesInResolutions;
	    // Returns true if this node contains a parse error anywhere underneath it.
	    function containsParseError(node) {
	        aggregateChildData(node);
	        return (node.flags & 131072 /* ThisNodeOrAnySubNodesHasError */) !== 0;
	    }
	    ts.containsParseError = containsParseError;
	    function aggregateChildData(node) {
	        if (!(node.flags & 262144 /* HasAggregatedChildData */)) {
	            // A node is considered to contain a parse error if:
	            //  a) the parser explicitly marked that it had an error
	            //  b) any of it's children reported that it had an error.
	            var thisNodeOrAnySubNodesHasError = ((node.flags & 32768 /* ThisNodeHasError */) !== 0) ||
	                ts.forEachChild(node, containsParseError);
	            // If so, mark ourselves accordingly.
	            if (thisNodeOrAnySubNodesHasError) {
	                node.flags |= 131072 /* ThisNodeOrAnySubNodesHasError */;
	            }
	            // Also mark that we've propagated the child information to this node.  This way we can
	            // always consult the bit directly on this node without needing to check its children
	            // again.
	            node.flags |= 262144 /* HasAggregatedChildData */;
	        }
	    }
	    function getSourceFileOfNode(node) {
	        while (node && node.kind !== 272 /* SourceFile */) {
	            node = node.parent;
	        }
	        return node;
	    }
	    ts.getSourceFileOfNode = getSourceFileOfNode;
	    function isStatementWithLocals(node) {
	        switch (node.kind) {
	            case 211 /* Block */:
	            case 239 /* CaseBlock */:
	            case 218 /* ForStatement */:
	            case 219 /* ForInStatement */:
	            case 220 /* ForOfStatement */:
	                return true;
	        }
	        return false;
	    }
	    ts.isStatementWithLocals = isStatementWithLocals;
	    function getStartPositionOfLine(line, sourceFile) {
	        ts.Debug.assert(line >= 0);
	        return ts.getLineStarts(sourceFile)[line];
	    }
	    ts.getStartPositionOfLine = getStartPositionOfLine;
	    // This is a useful function for debugging purposes.
	    function nodePosToString(node) {
	        var file = getSourceFileOfNode(node);
	        var loc = ts.getLineAndCharacterOfPosition(file, node.pos);
	        return file.fileName + "(" + (loc.line + 1) + "," + (loc.character + 1) + ")";
	    }
	    ts.nodePosToString = nodePosToString;
	    function getEndLinePosition(line, sourceFile) {
	        ts.Debug.assert(line >= 0);
	        var lineStarts = ts.getLineStarts(sourceFile);
	        var lineIndex = line;
	        var sourceText = sourceFile.text;
	        if (lineIndex + 1 === lineStarts.length) {
	            // last line - return EOF
	            return sourceText.length - 1;
	        }
	        else {
	            // current line start
	            var start = lineStarts[lineIndex];
	            // take the start position of the next line - 1 = it should be some line break
	            var pos = lineStarts[lineIndex + 1] - 1;
	            ts.Debug.assert(ts.isLineBreak(sourceText.charCodeAt(pos)));
	            // walk backwards skipping line breaks, stop the the beginning of current line.
	            // i.e:
	            // <some text>
	            // $ <- end of line for this position should match the start position
	            while (start <= pos && ts.isLineBreak(sourceText.charCodeAt(pos))) {
	                pos--;
	            }
	            return pos;
	        }
	    }
	    ts.getEndLinePosition = getEndLinePosition;
	    // Returns true if this node is missing from the actual source code. A 'missing' node is different
	    // from 'undefined/defined'. When a node is undefined (which can happen for optional nodes
	    // in the tree), it is definitely missing. However, a node may be defined, but still be
	    // missing.  This happens whenever the parser knows it needs to parse something, but can't
	    // get anything in the source code that it expects at that location. For example:
	    //
	    //          let a: ;
	    //
	    // Here, the Type in the Type-Annotation is not-optional (as there is a colon in the source
	    // code). So the parser will attempt to parse out a type, and will create an actual node.
	    // However, this node will be 'missing' in the sense that no actual source-code/tokens are
	    // contained within it.
	    function nodeIsMissing(node) {
	        if (node === undefined) {
	            return true;
	        }
	        return node.pos === node.end && node.pos >= 0 && node.kind !== 1 /* EndOfFileToken */;
	    }
	    ts.nodeIsMissing = nodeIsMissing;
	    function nodeIsPresent(node) {
	        return !nodeIsMissing(node);
	    }
	    ts.nodeIsPresent = nodeIsPresent;
	    /**
	     * Determine if the given comment is a triple-slash
	     *
	     * @return true if the comment is a triple-slash comment else false
	     */
	    function isRecognizedTripleSlashComment(text, commentPos, commentEnd) {
	        // Verify this is /// comment, but do the regexp match only when we first can find /// in the comment text
	        // so that we don't end up computing comment string and doing match for all // comments
	        if (text.charCodeAt(commentPos + 1) === 47 /* slash */ &&
	            commentPos + 2 < commentEnd &&
	            text.charCodeAt(commentPos + 2) === 47 /* slash */) {
	            var textSubStr = text.substring(commentPos, commentEnd);
	            return textSubStr.match(ts.fullTripleSlashReferencePathRegEx) ||
	                textSubStr.match(ts.fullTripleSlashAMDReferencePathRegEx) ||
	                textSubStr.match(fullTripleSlashReferenceTypeReferenceDirectiveRegEx) ||
	                textSubStr.match(defaultLibReferenceRegEx) ?
	                true : false;
	        }
	        return false;
	    }
	    ts.isRecognizedTripleSlashComment = isRecognizedTripleSlashComment;
	    function isPinnedComment(text, comment) {
	        return text.charCodeAt(comment.pos + 1) === 42 /* asterisk */ &&
	            text.charCodeAt(comment.pos + 2) === 33 /* exclamation */;
	    }
	    ts.isPinnedComment = isPinnedComment;
	    function getTokenPosOfNode(node, sourceFile, includeJsDoc) {
	        // With nodes that have no width (i.e. 'Missing' nodes), we actually *don't*
	        // want to skip trivia because this will launch us forward to the next token.
	        if (nodeIsMissing(node)) {
	            return node.pos;
	        }
	        if (ts.isJSDocNode(node)) {
	            return ts.skipTrivia((sourceFile || getSourceFileOfNode(node)).text, node.pos, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
	        }
	        if (includeJsDoc && ts.hasJSDocNodes(node)) {
	            return getTokenPosOfNode(node.jsDoc[0]);
	        }
	        // For a syntax list, it is possible that one of its children has JSDocComment nodes, while
	        // the syntax list itself considers them as normal trivia. Therefore if we simply skip
	        // trivia for the list, we may have skipped the JSDocComment as well. So we should process its
	        // first child to determine the actual position of its first token.
	        if (node.kind === 293 /* SyntaxList */ && node._children.length > 0) {
	            return getTokenPosOfNode(node._children[0], sourceFile, includeJsDoc);
	        }
	        return ts.skipTrivia((sourceFile || getSourceFileOfNode(node)).text, node.pos);
	    }
	    ts.getTokenPosOfNode = getTokenPosOfNode;
	    function getNonDecoratorTokenPosOfNode(node, sourceFile) {
	        if (nodeIsMissing(node) || !node.decorators) {
	            return getTokenPosOfNode(node, sourceFile);
	        }
	        return ts.skipTrivia((sourceFile || getSourceFileOfNode(node)).text, node.decorators.end);
	    }
	    ts.getNonDecoratorTokenPosOfNode = getNonDecoratorTokenPosOfNode;
	    function getSourceTextOfNodeFromSourceFile(sourceFile, node, includeTrivia) {
	        if (includeTrivia === void 0) { includeTrivia = false; }
	        if (nodeIsMissing(node)) {
	            return "";
	        }
	        var text = sourceFile.text;
	        return text.substring(includeTrivia ? node.pos : ts.skipTrivia(text, node.pos), node.end);
	    }
	    ts.getSourceTextOfNodeFromSourceFile = getSourceTextOfNodeFromSourceFile;
	    function getTextOfNodeFromSourceText(sourceText, node) {
	        if (nodeIsMissing(node)) {
	            return "";
	        }
	        return sourceText.substring(ts.skipTrivia(sourceText, node.pos), node.end);
	    }
	    ts.getTextOfNodeFromSourceText = getTextOfNodeFromSourceText;
	    function getTextOfNode(node, includeTrivia) {
	        if (includeTrivia === void 0) { includeTrivia = false; }
	        return getSourceTextOfNodeFromSourceFile(getSourceFileOfNode(node), node, includeTrivia);
	    }
	    ts.getTextOfNode = getTextOfNode;
	    function getPos(range) {
	        return range.pos;
	    }
	    /**
	     * Note: it is expected that the `nodeArray` and the `node` are within the same file.
	     * For example, searching for a `SourceFile` in a `SourceFile[]` wouldn't work.
	     */
	    function indexOfNode(nodeArray, node) {
	        return ts.binarySearch(nodeArray, node, getPos, ts.compareValues);
	    }
	    ts.indexOfNode = indexOfNode;
	    /**
	     * Gets flags that control emit behavior of a node.
	     */
	    function getEmitFlags(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.flags;
	    }
	    ts.getEmitFlags = getEmitFlags;
	    function getLiteralText(node, sourceFile) {
	        // If we don't need to downlevel and we can reach the original source text using
	        // the node's parent reference, then simply get the text as it was originally written.
	        if (!nodeIsSynthesized(node) && node.parent && !(ts.isNumericLiteral(node) && node.numericLiteralFlags & 512 /* ContainsSeparator */)) {
	            return getSourceTextOfNodeFromSourceFile(sourceFile, node);
	        }
	        var escapeText = getEmitFlags(node) & 16777216 /* NoAsciiEscaping */ ? escapeString : escapeNonAsciiString;
	        // If we can't reach the original source text, use the canonical form if it's a number,
	        // or a (possibly escaped) quoted form of the original text if it's string-like.
	        switch (node.kind) {
	            case 9 /* StringLiteral */:
	                if (node.singleQuote) {
	                    return "'" + escapeText(node.text, 39 /* singleQuote */) + "'";
	                }
	                else {
	                    return '"' + escapeText(node.text, 34 /* doubleQuote */) + '"';
	                }
	            case 13 /* NoSubstitutionTemplateLiteral */:
	                return "`" + escapeText(node.text, 96 /* backtick */) + "`";
	            case 14 /* TemplateHead */:
	                // tslint:disable-next-line no-invalid-template-strings
	                return "`" + escapeText(node.text, 96 /* backtick */) + "${";
	            case 15 /* TemplateMiddle */:
	                // tslint:disable-next-line no-invalid-template-strings
	                return "}" + escapeText(node.text, 96 /* backtick */) + "${";
	            case 16 /* TemplateTail */:
	                return "}" + escapeText(node.text, 96 /* backtick */) + "`";
	            case 8 /* NumericLiteral */:
	            case 12 /* RegularExpressionLiteral */:
	                return node.text;
	        }
	        ts.Debug.fail("Literal kind '" + node.kind + "' not accounted for.");
	    }
	    ts.getLiteralText = getLiteralText;
	    function getTextOfConstantValue(value) {
	        return ts.isString(value) ? '"' + escapeNonAsciiString(value) + '"' : "" + value;
	    }
	    ts.getTextOfConstantValue = getTextOfConstantValue;
	    // Add an extra underscore to identifiers that start with two underscores to avoid issues with magic names like '__proto__'
	    function escapeLeadingUnderscores(identifier) {
	        return (identifier.length >= 2 && identifier.charCodeAt(0) === 95 /* _ */ && identifier.charCodeAt(1) === 95 /* _ */ ? "_" + identifier : identifier);
	    }
	    ts.escapeLeadingUnderscores = escapeLeadingUnderscores;
	    /**
	     * @deprecated Use `id.escapedText` to get the escaped text of an Identifier.
	     * @param identifier The identifier to escape
	     */
	    function escapeIdentifier(identifier) {
	        return identifier;
	    }
	    ts.escapeIdentifier = escapeIdentifier;
	    // Make an identifier from an external module name by extracting the string after the last "/" and replacing
	    // all non-alphanumeric characters with underscores
	    function makeIdentifierFromModuleName(moduleName) {
	        return ts.getBaseFileName(moduleName).replace(/^(\d)/, "_$1").replace(/\W/g, "_");
	    }
	    ts.makeIdentifierFromModuleName = makeIdentifierFromModuleName;
	    function isBlockOrCatchScoped(declaration) {
	        return (ts.getCombinedNodeFlags(declaration) & 3 /* BlockScoped */) !== 0 ||
	            isCatchClauseVariableDeclarationOrBindingElement(declaration);
	    }
	    ts.isBlockOrCatchScoped = isBlockOrCatchScoped;
	    function isCatchClauseVariableDeclarationOrBindingElement(declaration) {
	        var node = getRootDeclaration(declaration);
	        return node.kind === 230 /* VariableDeclaration */ && node.parent.kind === 267 /* CatchClause */;
	    }
	    ts.isCatchClauseVariableDeclarationOrBindingElement = isCatchClauseVariableDeclarationOrBindingElement;
	    function isAmbientModule(node) {
	        return node && ts.isModuleDeclaration(node) &&
	            (node.name.kind === 9 /* StringLiteral */ || isGlobalScopeAugmentation(node));
	    }
	    ts.isAmbientModule = isAmbientModule;
	    function isModuleWithStringLiteralName(node) {
	        return ts.isModuleDeclaration(node) && node.name.kind === 9 /* StringLiteral */;
	    }
	    ts.isModuleWithStringLiteralName = isModuleWithStringLiteralName;
	    function isNonGlobalAmbientModule(node) {
	        return ts.isModuleDeclaration(node) && ts.isStringLiteral(node.name);
	    }
	    ts.isNonGlobalAmbientModule = isNonGlobalAmbientModule;
	    /** Given a symbol for a module, checks that it is a shorthand ambient module. */
	    function isShorthandAmbientModuleSymbol(moduleSymbol) {
	        return isShorthandAmbientModule(moduleSymbol.valueDeclaration);
	    }
	    ts.isShorthandAmbientModuleSymbol = isShorthandAmbientModuleSymbol;
	    function isShorthandAmbientModule(node) {
	        // The only kind of module that can be missing a body is a shorthand ambient module.
	        return node && node.kind === 237 /* ModuleDeclaration */ && (!node.body);
	    }
	    function isBlockScopedContainerTopLevel(node) {
	        return node.kind === 272 /* SourceFile */ ||
	            node.kind === 237 /* ModuleDeclaration */ ||
	            ts.isFunctionLike(node);
	    }
	    ts.isBlockScopedContainerTopLevel = isBlockScopedContainerTopLevel;
	    function isGlobalScopeAugmentation(module) {
	        return !!(module.flags & 512 /* GlobalAugmentation */);
	    }
	    ts.isGlobalScopeAugmentation = isGlobalScopeAugmentation;
	    function isExternalModuleAugmentation(node) {
	        // external module augmentation is a ambient module declaration that is either:
	        // - defined in the top level scope and source file is an external module
	        // - defined inside ambient module declaration located in the top level scope and source file not an external module
	        if (!node || !isAmbientModule(node)) {
	            return false;
	        }
	        switch (node.parent.kind) {
	            case 272 /* SourceFile */:
	                return ts.isExternalModule(node.parent);
	            case 238 /* ModuleBlock */:
	                return isAmbientModule(node.parent.parent) && !ts.isExternalModule(node.parent.parent.parent);
	        }
	        return false;
	    }
	    ts.isExternalModuleAugmentation = isExternalModuleAugmentation;
	    function isEffectiveExternalModule(node, compilerOptions) {
	        return ts.isExternalModule(node) || compilerOptions.isolatedModules || ((ts.getEmitModuleKind(compilerOptions) === ts.ModuleKind.CommonJS) && !!node.commonJsModuleIndicator);
	    }
	    ts.isEffectiveExternalModule = isEffectiveExternalModule;
	    function isBlockScope(node, parentNode) {
	        switch (node.kind) {
	            case 272 /* SourceFile */:
	            case 239 /* CaseBlock */:
	            case 267 /* CatchClause */:
	            case 237 /* ModuleDeclaration */:
	            case 218 /* ForStatement */:
	            case 219 /* ForInStatement */:
	            case 220 /* ForOfStatement */:
	            case 154 /* Constructor */:
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 232 /* FunctionDeclaration */:
	            case 190 /* FunctionExpression */:
	            case 191 /* ArrowFunction */:
	                return true;
	            case 211 /* Block */:
	                // function block is not considered block-scope container
	                // see comment in binder.ts: bind(...), case for SyntaxKind.Block
	                return parentNode && !ts.isFunctionLike(parentNode);
	        }
	        return false;
	    }
	    ts.isBlockScope = isBlockScope;
	    function isDeclarationWithTypeParameters(node) {
	        switch (node.kind) {
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 152 /* MethodSignature */:
	            case 159 /* IndexSignature */:
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	            case 280 /* JSDocFunctionType */:
	            case 233 /* ClassDeclaration */:
	            case 203 /* ClassExpression */:
	            case 234 /* InterfaceDeclaration */:
	            case 235 /* TypeAliasDeclaration */:
	            case 290 /* JSDocTemplateTag */:
	            case 232 /* FunctionDeclaration */:
	            case 153 /* MethodDeclaration */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 190 /* FunctionExpression */:
	            case 191 /* ArrowFunction */:
	                return true;
	            default:
	                ts.assertTypeIsNever(node);
	                return false;
	        }
	    }
	    ts.isDeclarationWithTypeParameters = isDeclarationWithTypeParameters;
	    function isAnyImportSyntax(node) {
	        switch (node.kind) {
	            case 242 /* ImportDeclaration */:
	            case 241 /* ImportEqualsDeclaration */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isAnyImportSyntax = isAnyImportSyntax;
	    // Gets the nearest enclosing block scope container that has the provided node
	    // as a descendant, that is not the provided node.
	    function getEnclosingBlockScopeContainer(node) {
	        var current = node.parent;
	        while (current) {
	            if (isBlockScope(current, current.parent)) {
	                return current;
	            }
	            current = current.parent;
	        }
	    }
	    ts.getEnclosingBlockScopeContainer = getEnclosingBlockScopeContainer;
	    // Return display name of an identifier
	    // Computed property names will just be emitted as "[<expr>]", where <expr> is the source
	    // text of the expression in the computed property.
	    function declarationNameToString(name) {
	        return getFullWidth(name) === 0 ? "(Missing)" : getTextOfNode(name);
	    }
	    ts.declarationNameToString = declarationNameToString;
	    function getNameFromIndexInfo(info) {
	        return info.declaration ? declarationNameToString(info.declaration.parameters[0].name) : undefined;
	    }
	    ts.getNameFromIndexInfo = getNameFromIndexInfo;
	    function getTextOfPropertyName(name) {
	        switch (name.kind) {
	            case 71 /* Identifier */:
	                return name.escapedText;
	            case 9 /* StringLiteral */:
	            case 8 /* NumericLiteral */:
	                return escapeLeadingUnderscores(name.text);
	            case 146 /* ComputedPropertyName */:
	                return isStringOrNumericLiteral(name.expression) ? escapeLeadingUnderscores(name.expression.text) : undefined;
	            default:
	                ts.Debug.assertNever(name);
	        }
	    }
	    ts.getTextOfPropertyName = getTextOfPropertyName;
	    function entityNameToString(name) {
	        switch (name.kind) {
	            case 71 /* Identifier */:
	                return getFullWidth(name) === 0 ? ts.idText(name) : getTextOfNode(name);
	            case 145 /* QualifiedName */:
	                return entityNameToString(name.left) + "." + entityNameToString(name.right);
	            case 183 /* PropertyAccessExpression */:
	                return entityNameToString(name.expression) + "." + entityNameToString(name.name);
	        }
	    }
	    ts.entityNameToString = entityNameToString;
	    function createDiagnosticForNode(node, message, arg0, arg1, arg2, arg3) {
	        var sourceFile = getSourceFileOfNode(node);
	        return createDiagnosticForNodeInSourceFile(sourceFile, node, message, arg0, arg1, arg2, arg3);
	    }
	    ts.createDiagnosticForNode = createDiagnosticForNode;
	    function createDiagnosticForNodeArray(sourceFile, nodes, message, arg0, arg1, arg2, arg3) {
	        var start = ts.skipTrivia(sourceFile.text, nodes.pos);
	        return ts.createFileDiagnostic(sourceFile, start, nodes.end - start, message, arg0, arg1, arg2, arg3);
	    }
	    ts.createDiagnosticForNodeArray = createDiagnosticForNodeArray;
	    function createDiagnosticForNodeInSourceFile(sourceFile, node, message, arg0, arg1, arg2, arg3) {
	        var span = getErrorSpanForNode(sourceFile, node);
	        return ts.createFileDiagnostic(sourceFile, span.start, span.length, message, arg0, arg1, arg2, arg3);
	    }
	    ts.createDiagnosticForNodeInSourceFile = createDiagnosticForNodeInSourceFile;
	    function createDiagnosticForNodeFromMessageChain(node, messageChain) {
	        var sourceFile = getSourceFileOfNode(node);
	        var span = getErrorSpanForNode(sourceFile, node);
	        return {
	            file: sourceFile,
	            start: span.start,
	            length: span.length,
	            code: messageChain.code,
	            category: messageChain.category,
	            messageText: messageChain.next ? messageChain : messageChain.messageText
	        };
	    }
	    ts.createDiagnosticForNodeFromMessageChain = createDiagnosticForNodeFromMessageChain;
	    function getSpanOfTokenAtPosition(sourceFile, pos) {
	        var scanner = ts.createScanner(sourceFile.languageVersion, /*skipTrivia*/ true, sourceFile.languageVariant, sourceFile.text, /*onError:*/ undefined, pos);
	        scanner.scan();
	        var start = scanner.getTokenPos();
	        return ts.createTextSpanFromBounds(start, scanner.getTextPos());
	    }
	    ts.getSpanOfTokenAtPosition = getSpanOfTokenAtPosition;
	    function getErrorSpanForArrowFunction(sourceFile, node) {
	        var pos = ts.skipTrivia(sourceFile.text, node.pos);
	        if (node.body && node.body.kind === 211 /* Block */) {
	            var startLine = ts.getLineAndCharacterOfPosition(sourceFile, node.body.pos).line;
	            var endLine = ts.getLineAndCharacterOfPosition(sourceFile, node.body.end).line;
	            if (startLine < endLine) {
	                // The arrow function spans multiple lines,
	                // make the error span be the first line, inclusive.
	                return ts.createTextSpan(pos, getEndLinePosition(startLine, sourceFile) - pos + 1);
	            }
	        }
	        return ts.createTextSpanFromBounds(pos, node.end);
	    }
	    function getErrorSpanForNode(sourceFile, node) {
	        var errorNode = node;
	        switch (node.kind) {
	            case 272 /* SourceFile */:
	                var pos_1 = ts.skipTrivia(sourceFile.text, 0, /*stopAfterLineBreak*/ false);
	                if (pos_1 === sourceFile.text.length) {
	                    // file is empty - return span for the beginning of the file
	                    return ts.createTextSpan(0, 0);
	                }
	                return getSpanOfTokenAtPosition(sourceFile, pos_1);
	            // This list is a work in progress. Add missing node kinds to improve their error
	            // spans.
	            case 230 /* VariableDeclaration */:
	            case 180 /* BindingElement */:
	            case 233 /* ClassDeclaration */:
	            case 203 /* ClassExpression */:
	            case 234 /* InterfaceDeclaration */:
	            case 237 /* ModuleDeclaration */:
	            case 236 /* EnumDeclaration */:
	            case 271 /* EnumMember */:
	            case 232 /* FunctionDeclaration */:
	            case 190 /* FunctionExpression */:
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 235 /* TypeAliasDeclaration */:
	                errorNode = node.name;
	                break;
	            case 191 /* ArrowFunction */:
	                return getErrorSpanForArrowFunction(sourceFile, node);
	        }
	        if (errorNode === undefined) {
	            // If we don't have a better node, then just set the error on the first token of
	            // construct.
	            return getSpanOfTokenAtPosition(sourceFile, node.pos);
	        }
	        var isMissing = nodeIsMissing(errorNode);
	        var pos = isMissing
	            ? errorNode.pos
	            : ts.skipTrivia(sourceFile.text, errorNode.pos);
	        // These asserts should all be satisfied for a properly constructed `errorNode`.
	        if (isMissing) {
	            ts.Debug.assert(pos === errorNode.pos, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	            ts.Debug.assert(pos === errorNode.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	        }
	        else {
	            ts.Debug.assert(pos >= errorNode.pos, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	            ts.Debug.assert(pos <= errorNode.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	        }
	        return ts.createTextSpanFromBounds(pos, errorNode.end);
	    }
	    ts.getErrorSpanForNode = getErrorSpanForNode;
	    function isExternalOrCommonJsModule(file) {
	        return (file.externalModuleIndicator || file.commonJsModuleIndicator) !== undefined;
	    }
	    ts.isExternalOrCommonJsModule = isExternalOrCommonJsModule;
	    function isConstEnumDeclaration(node) {
	        return node.kind === 236 /* EnumDeclaration */ && isConst(node);
	    }
	    ts.isConstEnumDeclaration = isConstEnumDeclaration;
	    function isConst(node) {
	        return !!(ts.getCombinedNodeFlags(node) & 2 /* Const */)
	            || !!(ts.getCombinedModifierFlags(node) & 2048 /* Const */);
	    }
	    ts.isConst = isConst;
	    function isLet(node) {
	        return !!(ts.getCombinedNodeFlags(node) & 1 /* Let */);
	    }
	    ts.isLet = isLet;
	    function isSuperCall(n) {
	        return n.kind === 185 /* CallExpression */ && n.expression.kind === 97 /* SuperKeyword */;
	    }
	    ts.isSuperCall = isSuperCall;
	    function isImportCall(n) {
	        return n.kind === 185 /* CallExpression */ && n.expression.kind === 91 /* ImportKeyword */;
	    }
	    ts.isImportCall = isImportCall;
	    function isPrologueDirective(node) {
	        return node.kind === 214 /* ExpressionStatement */
	            && node.expression.kind === 9 /* StringLiteral */;
	    }
	    ts.isPrologueDirective = isPrologueDirective;
	    function getLeadingCommentRangesOfNode(node, sourceFileOfNode) {
	        return node.kind !== 10 /* JsxText */ ? ts.getLeadingCommentRanges(sourceFileOfNode.text, node.pos) : undefined;
	    }
	    ts.getLeadingCommentRangesOfNode = getLeadingCommentRangesOfNode;
	    function getJSDocCommentRanges(node, text) {
	        var commentRanges = (node.kind === 148 /* Parameter */ ||
	            node.kind === 147 /* TypeParameter */ ||
	            node.kind === 190 /* FunctionExpression */ ||
	            node.kind === 191 /* ArrowFunction */ ||
	            node.kind === 189 /* ParenthesizedExpression */) ?
	            ts.concatenate(ts.getTrailingCommentRanges(text, node.pos), ts.getLeadingCommentRanges(text, node.pos)) :
	            ts.getLeadingCommentRanges(text, node.pos);
	        // True if the comment starts with '/**' but not if it is '/**/'
	        return ts.filter(commentRanges, function (comment) {
	            return text.charCodeAt(comment.pos + 1) === 42 /* asterisk */ &&
	                text.charCodeAt(comment.pos + 2) === 42 /* asterisk */ &&
	                text.charCodeAt(comment.pos + 3) !== 47 /* slash */;
	        });
	    }
	    ts.getJSDocCommentRanges = getJSDocCommentRanges;
	    ts.fullTripleSlashReferencePathRegEx = /^(\/\/\/\s*<reference\s+path\s*=\s*)('|")(.+?)\2.*?\/>/;
	    var fullTripleSlashReferenceTypeReferenceDirectiveRegEx = /^(\/\/\/\s*<reference\s+types\s*=\s*)('|")(.+?)\2.*?\/>/;
	    ts.fullTripleSlashAMDReferencePathRegEx = /^(\/\/\/\s*<amd-dependency\s+path\s*=\s*)('|")(.+?)\2.*?\/>/;
	    var defaultLibReferenceRegEx = /^(\/\/\/\s*<reference\s+no-default-lib\s*=\s*)('|")(.+?)\2\s*\/>/;
	    function isPartOfTypeNode(node) {
	        if (160 /* FirstTypeNode */ <= node.kind && node.kind <= 177 /* LastTypeNode */) {
	            return true;
	        }
	        switch (node.kind) {
	            case 119 /* AnyKeyword */:
	            case 134 /* NumberKeyword */:
	            case 137 /* StringKeyword */:
	            case 122 /* BooleanKeyword */:
	            case 138 /* SymbolKeyword */:
	            case 140 /* UndefinedKeyword */:
	            case 131 /* NeverKeyword */:
	                return true;
	            case 105 /* VoidKeyword */:
	                return node.parent.kind !== 194 /* VoidExpression */;
	            case 205 /* ExpressionWithTypeArguments */:
	                return !isExpressionWithTypeArgumentsInClassExtendsClause(node);
	            case 147 /* TypeParameter */:
	                return node.parent.kind === 176 /* MappedType */ || node.parent.kind === 171 /* InferType */;
	            // Identifiers and qualified names may be type nodes, depending on their context. Climb
	            // above them to find the lowest container
	            case 71 /* Identifier */:
	                // If the identifier is the RHS of a qualified name, then it's a type iff its parent is.
	                if (node.parent.kind === 145 /* QualifiedName */ && node.parent.right === node) {
	                    node = node.parent;
	                }
	                else if (node.parent.kind === 183 /* PropertyAccessExpression */ && node.parent.name === node) {
	                    node = node.parent;
	                }
	                // At this point, node is either a qualified name or an identifier
	                ts.Debug.assert(node.kind === 71 /* Identifier */ || node.kind === 145 /* QualifiedName */ || node.kind === 183 /* PropertyAccessExpression */, "'node' was expected to be a qualified name, identifier or property access in 'isPartOfTypeNode'.");
	            // falls through
	            case 145 /* QualifiedName */:
	            case 183 /* PropertyAccessExpression */:
	            case 99 /* ThisKeyword */:
	                var parent = node.parent;
	                if (parent.kind === 164 /* TypeQuery */) {
	                    return false;
	                }
	                // Do not recursively call isPartOfTypeNode on the parent. In the example:
	                //
	                //     let a: A.B.C;
	                //
	                // Calling isPartOfTypeNode would consider the qualified name A.B a type node.
	                // Only C and A.B.C are type nodes.
	                if (160 /* FirstTypeNode */ <= parent.kind && parent.kind <= 177 /* LastTypeNode */) {
	                    return true;
	                }
	                switch (parent.kind) {
	                    case 205 /* ExpressionWithTypeArguments */:
	                        return !isExpressionWithTypeArgumentsInClassExtendsClause(parent);
	                    case 147 /* TypeParameter */:
	                        return node === parent.constraint;
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 148 /* Parameter */:
	                    case 230 /* VariableDeclaration */:
	                        return node === parent.type;
	                    case 232 /* FunctionDeclaration */:
	                    case 190 /* FunctionExpression */:
	                    case 191 /* ArrowFunction */:
	                    case 154 /* Constructor */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        return node === parent.type;
	                    case 157 /* CallSignature */:
	                    case 158 /* ConstructSignature */:
	                    case 159 /* IndexSignature */:
	                        return node === parent.type;
	                    case 188 /* TypeAssertionExpression */:
	                        return node === parent.type;
	                    case 185 /* CallExpression */:
	                    case 186 /* NewExpression */:
	                        return ts.contains(parent.typeArguments, node);
	                    case 187 /* TaggedTemplateExpression */:
	                        // TODO (drosen): TaggedTemplateExpressions may eventually support type arguments.
	                        return false;
	                }
	        }
	        return false;
	    }
	    ts.isPartOfTypeNode = isPartOfTypeNode;
	    function isChildOfNodeWithKind(node, kind) {
	        while (node) {
	            if (node.kind === kind) {
	                return true;
	            }
	            node = node.parent;
	        }
	        return false;
	    }
	    ts.isChildOfNodeWithKind = isChildOfNodeWithKind;
	    // Warning: This has the same semantics as the forEach family of functions,
	    //          in that traversal terminates in the event that 'visitor' supplies a truthy value.
	    function forEachReturnStatement(body, visitor) {
	        return traverse(body);
	        function traverse(node) {
	            switch (node.kind) {
	                case 223 /* ReturnStatement */:
	                    return visitor(node);
	                case 239 /* CaseBlock */:
	                case 211 /* Block */:
	                case 215 /* IfStatement */:
	                case 216 /* DoStatement */:
	                case 217 /* WhileStatement */:
	                case 218 /* ForStatement */:
	                case 219 /* ForInStatement */:
	                case 220 /* ForOfStatement */:
	                case 224 /* WithStatement */:
	                case 225 /* SwitchStatement */:
	                case 264 /* CaseClause */:
	                case 265 /* DefaultClause */:
	                case 226 /* LabeledStatement */:
	                case 228 /* TryStatement */:
	                case 267 /* CatchClause */:
	                    return ts.forEachChild(node, traverse);
	            }
	        }
	    }
	    ts.forEachReturnStatement = forEachReturnStatement;
	    function forEachYieldExpression(body, visitor) {
	        return traverse(body);
	        function traverse(node) {
	            switch (node.kind) {
	                case 201 /* YieldExpression */:
	                    visitor(node);
	                    var operand = node.expression;
	                    if (operand) {
	                        traverse(operand);
	                    }
	                    return;
	                case 236 /* EnumDeclaration */:
	                case 234 /* InterfaceDeclaration */:
	                case 237 /* ModuleDeclaration */:
	                case 235 /* TypeAliasDeclaration */:
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                    // These are not allowed inside a generator now, but eventually they may be allowed
	                    // as local types. Regardless, any yield statements contained within them should be
	                    // skipped in this traversal.
	                    return;
	                default:
	                    if (ts.isFunctionLike(node)) {
	                        if (node.name && node.name.kind === 146 /* ComputedPropertyName */) {
	                            // Note that we will not include methods/accessors of a class because they would require
	                            // first descending into the class. This is by design.
	                            traverse(node.name.expression);
	                            return;
	                        }
	                    }
	                    else if (!isPartOfTypeNode(node)) {
	                        // This is the general case, which should include mostly expressions and statements.
	                        // Also includes NodeArrays.
	                        ts.forEachChild(node, traverse);
	                    }
	            }
	        }
	    }
	    ts.forEachYieldExpression = forEachYieldExpression;
	    /**
	     * Gets the most likely element type for a TypeNode. This is not an exhaustive test
	     * as it assumes a rest argument can only be an array type (either T[], or Array<T>).
	     *
	     * @param node The type node.
	     */
	    function getRestParameterElementType(node) {
	        if (node && node.kind === 166 /* ArrayType */) {
	            return node.elementType;
	        }
	        else if (node && node.kind === 161 /* TypeReference */) {
	            return ts.singleOrUndefined(node.typeArguments);
	        }
	        else {
	            return undefined;
	        }
	    }
	    ts.getRestParameterElementType = getRestParameterElementType;
	    function getMembersOfDeclaration(node) {
	        switch (node.kind) {
	            case 234 /* InterfaceDeclaration */:
	            case 233 /* ClassDeclaration */:
	            case 203 /* ClassExpression */:
	            case 165 /* TypeLiteral */:
	                return node.members;
	            case 182 /* ObjectLiteralExpression */:
	                return node.properties;
	        }
	    }
	    ts.getMembersOfDeclaration = getMembersOfDeclaration;
	    function isVariableLike(node) {
	        if (node) {
	            switch (node.kind) {
	                case 180 /* BindingElement */:
	                case 271 /* EnumMember */:
	                case 148 /* Parameter */:
	                case 268 /* PropertyAssignment */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 269 /* ShorthandPropertyAssignment */:
	                case 230 /* VariableDeclaration */:
	                    return true;
	            }
	        }
	        return false;
	    }
	    ts.isVariableLike = isVariableLike;
	    function isVariableDeclarationInVariableStatement(node) {
	        return node.parent.kind === 231 /* VariableDeclarationList */
	            && node.parent.parent.kind === 212 /* VariableStatement */;
	    }
	    ts.isVariableDeclarationInVariableStatement = isVariableDeclarationInVariableStatement;
	    function isValidESSymbolDeclaration(node) {
	        return ts.isVariableDeclaration(node) ? isConst(node) && ts.isIdentifier(node.name) && isVariableDeclarationInVariableStatement(node) :
	            ts.isPropertyDeclaration(node) ? hasReadonlyModifier(node) && hasStaticModifier(node) :
	                ts.isPropertySignature(node) && hasReadonlyModifier(node);
	    }
	    ts.isValidESSymbolDeclaration = isValidESSymbolDeclaration;
	    function introducesArgumentsExoticObject(node) {
	        switch (node.kind) {
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 232 /* FunctionDeclaration */:
	            case 190 /* FunctionExpression */:
	                return true;
	        }
	        return false;
	    }
	    ts.introducesArgumentsExoticObject = introducesArgumentsExoticObject;
	    function unwrapInnermostStatementOfLabel(node, beforeUnwrapLabelCallback) {
	        while (true) {
	            if (beforeUnwrapLabelCallback) {
	                beforeUnwrapLabelCallback(node);
	            }
	            if (node.statement.kind !== 226 /* LabeledStatement */) {
	                return node.statement;
	            }
	            node = node.statement;
	        }
	    }
	    ts.unwrapInnermostStatementOfLabel = unwrapInnermostStatementOfLabel;
	    function isFunctionBlock(node) {
	        return node && node.kind === 211 /* Block */ && ts.isFunctionLike(node.parent);
	    }
	    ts.isFunctionBlock = isFunctionBlock;
	    function isObjectLiteralMethod(node) {
	        return node && node.kind === 153 /* MethodDeclaration */ && node.parent.kind === 182 /* ObjectLiteralExpression */;
	    }
	    ts.isObjectLiteralMethod = isObjectLiteralMethod;
	    function isObjectLiteralOrClassExpressionMethod(node) {
	        return node.kind === 153 /* MethodDeclaration */ &&
	            (node.parent.kind === 182 /* ObjectLiteralExpression */ ||
	                node.parent.kind === 203 /* ClassExpression */);
	    }
	    ts.isObjectLiteralOrClassExpressionMethod = isObjectLiteralOrClassExpressionMethod;
	    function isIdentifierTypePredicate(predicate) {
	        return predicate && predicate.kind === 1 /* Identifier */;
	    }
	    ts.isIdentifierTypePredicate = isIdentifierTypePredicate;
	    function isThisTypePredicate(predicate) {
	        return predicate && predicate.kind === 0 /* This */;
	    }
	    ts.isThisTypePredicate = isThisTypePredicate;
	    function getPropertyAssignment(objectLiteral, key, key2) {
	        return ts.filter(objectLiteral.properties, function (property) {
	            if (property.kind === 268 /* PropertyAssignment */) {
	                var propName = getTextOfPropertyName(property.name);
	                return key === propName || (key2 && key2 === propName);
	            }
	        });
	    }
	    ts.getPropertyAssignment = getPropertyAssignment;
	    function getContainingFunction(node) {
	        return ts.findAncestor(node.parent, ts.isFunctionLike);
	    }
	    ts.getContainingFunction = getContainingFunction;
	    function getContainingClass(node) {
	        return ts.findAncestor(node.parent, ts.isClassLike);
	    }
	    ts.getContainingClass = getContainingClass;
	    function getThisContainer(node, includeArrowFunctions) {
	        while (true) {
	            node = node.parent;
	            if (!node) {
	                return undefined;
	            }
	            switch (node.kind) {
	                case 146 /* ComputedPropertyName */:
	                    // If the grandparent node is an object literal (as opposed to a class),
	                    // then the computed property is not a 'this' container.
	                    // A computed property name in a class needs to be a this container
	                    // so that we can error on it.
	                    if (ts.isClassLike(node.parent.parent)) {
	                        return node;
	                    }
	                    // If this is a computed property, then the parent should not
	                    // make it a this container. The parent might be a property
	                    // in an object literal, like a method or accessor. But in order for
	                    // such a parent to be a this container, the reference must be in
	                    // the *body* of the container.
	                    node = node.parent;
	                    break;
	                case 149 /* Decorator */:
	                    // Decorators are always applied outside of the body of a class or method.
	                    if (node.parent.kind === 148 /* Parameter */ && ts.isClassElement(node.parent.parent)) {
	                        // If the decorator's parent is a Parameter, we resolve the this container from
	                        // the grandparent class declaration.
	                        node = node.parent.parent;
	                    }
	                    else if (ts.isClassElement(node.parent)) {
	                        // If the decorator's parent is a class element, we resolve the 'this' container
	                        // from the parent class declaration.
	                        node = node.parent;
	                    }
	                    break;
	                case 191 /* ArrowFunction */:
	                    if (!includeArrowFunctions) {
	                        continue;
	                    }
	                // falls through
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 237 /* ModuleDeclaration */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 154 /* Constructor */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 159 /* IndexSignature */:
	                case 236 /* EnumDeclaration */:
	                case 272 /* SourceFile */:
	                    return node;
	            }
	        }
	    }
	    ts.getThisContainer = getThisContainer;
	    function getNewTargetContainer(node) {
	        var container = getThisContainer(node, /*includeArrowFunctions*/ false);
	        if (container) {
	            switch (container.kind) {
	                case 154 /* Constructor */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                    return container;
	            }
	        }
	        return undefined;
	    }
	    ts.getNewTargetContainer = getNewTargetContainer;
	    /**
	     * Given an super call/property node, returns the closest node where
	     * - a super call/property access is legal in the node and not legal in the parent node the node.
	     *   i.e. super call is legal in constructor but not legal in the class body.
	     * - the container is an arrow function (so caller might need to call getSuperContainer again in case it needs to climb higher)
	     * - a super call/property is definitely illegal in the container (but might be legal in some subnode)
	     *   i.e. super property access is illegal in function declaration but can be legal in the statement list
	     */
	    function getSuperContainer(node, stopOnFunctions) {
	        while (true) {
	            node = node.parent;
	            if (!node) {
	                return node;
	            }
	            switch (node.kind) {
	                case 146 /* ComputedPropertyName */:
	                    node = node.parent;
	                    break;
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                    if (!stopOnFunctions) {
	                        continue;
	                    }
	                // falls through
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 154 /* Constructor */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return node;
	                case 149 /* Decorator */:
	                    // Decorators are always applied outside of the body of a class or method.
	                    if (node.parent.kind === 148 /* Parameter */ && ts.isClassElement(node.parent.parent)) {
	                        // If the decorator's parent is a Parameter, we resolve the this container from
	                        // the grandparent class declaration.
	                        node = node.parent.parent;
	                    }
	                    else if (ts.isClassElement(node.parent)) {
	                        // If the decorator's parent is a class element, we resolve the 'this' container
	                        // from the parent class declaration.
	                        node = node.parent;
	                    }
	                    break;
	            }
	        }
	    }
	    ts.getSuperContainer = getSuperContainer;
	    function getImmediatelyInvokedFunctionExpression(func) {
	        if (func.kind === 190 /* FunctionExpression */ || func.kind === 191 /* ArrowFunction */) {
	            var prev = func;
	            var parent = func.parent;
	            while (parent.kind === 189 /* ParenthesizedExpression */) {
	                prev = parent;
	                parent = parent.parent;
	            }
	            if (parent.kind === 185 /* CallExpression */ && parent.expression === prev) {
	                return parent;
	            }
	        }
	    }
	    ts.getImmediatelyInvokedFunctionExpression = getImmediatelyInvokedFunctionExpression;
	    /**
	     * Determines whether a node is a property or element access expression for `super`.
	     */
	    function isSuperProperty(node) {
	        var kind = node.kind;
	        return (kind === 183 /* PropertyAccessExpression */ || kind === 184 /* ElementAccessExpression */)
	            && node.expression.kind === 97 /* SuperKeyword */;
	    }
	    ts.isSuperProperty = isSuperProperty;
	    /**
	     * Determines whether a node is a property or element access expression for `this`.
	     */
	    function isThisProperty(node) {
	        var kind = node.kind;
	        return (kind === 183 /* PropertyAccessExpression */ || kind === 184 /* ElementAccessExpression */)
	            && node.expression.kind === 99 /* ThisKeyword */;
	    }
	    ts.isThisProperty = isThisProperty;
	    function getEntityNameFromTypeNode(node) {
	        switch (node.kind) {
	            case 161 /* TypeReference */:
	                return node.typeName;
	            case 205 /* ExpressionWithTypeArguments */:
	                return isEntityNameExpression(node.expression)
	                    ? node.expression
	                    : undefined;
	            case 71 /* Identifier */:
	            case 145 /* QualifiedName */:
	                return node;
	        }
	        return undefined;
	    }
	    ts.getEntityNameFromTypeNode = getEntityNameFromTypeNode;
	    function getInvokedExpression(node) {
	        switch (node.kind) {
	            case 187 /* TaggedTemplateExpression */:
	                return node.tag;
	            case 255 /* JsxOpeningElement */:
	            case 254 /* JsxSelfClosingElement */:
	                return node.tagName;
	            default:
	                return node.expression;
	        }
	    }
	    ts.getInvokedExpression = getInvokedExpression;
	    function nodeCanBeDecorated(node, parent, grandparent) {
	        switch (node.kind) {
	            case 233 /* ClassDeclaration */:
	                // classes are valid targets
	                return true;
	            case 151 /* PropertyDeclaration */:
	                // property declarations are valid if their parent is a class declaration.
	                return parent.kind === 233 /* ClassDeclaration */;
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 153 /* MethodDeclaration */:
	                // if this method has a body and its parent is a class declaration, this is a valid target.
	                return node.body !== undefined
	                    && parent.kind === 233 /* ClassDeclaration */;
	            case 148 /* Parameter */:
	                // if the parameter's parent has a body and its grandparent is a class declaration, this is a valid target;
	                return parent.body !== undefined
	                    && (parent.kind === 154 /* Constructor */
	                        || parent.kind === 153 /* MethodDeclaration */
	                        || parent.kind === 156 /* SetAccessor */)
	                    && grandparent.kind === 233 /* ClassDeclaration */;
	        }
	        return false;
	    }
	    ts.nodeCanBeDecorated = nodeCanBeDecorated;
	    function nodeIsDecorated(node, parent, grandparent) {
	        return node.decorators !== undefined
	            && nodeCanBeDecorated(node, parent, grandparent);
	    }
	    ts.nodeIsDecorated = nodeIsDecorated;
	    function nodeOrChildIsDecorated(node, parent, grandparent) {
	        return nodeIsDecorated(node, parent, grandparent) || childIsDecorated(node, parent);
	    }
	    ts.nodeOrChildIsDecorated = nodeOrChildIsDecorated;
	    function childIsDecorated(node, parent) {
	        switch (node.kind) {
	            case 233 /* ClassDeclaration */:
	                return ts.forEach(node.members, function (m) { return nodeOrChildIsDecorated(m, node, parent); });
	            case 153 /* MethodDeclaration */:
	            case 156 /* SetAccessor */:
	                return ts.forEach(node.parameters, function (p) { return nodeIsDecorated(p, node, parent); });
	        }
	    }
	    ts.childIsDecorated = childIsDecorated;
	    function isJSXTagName(node) {
	        var parent = node.parent;
	        if (parent.kind === 255 /* JsxOpeningElement */ ||
	            parent.kind === 254 /* JsxSelfClosingElement */ ||
	            parent.kind === 256 /* JsxClosingElement */) {
	            return parent.tagName === node;
	        }
	        return false;
	    }
	    ts.isJSXTagName = isJSXTagName;
	    function isExpressionNode(node) {
	        switch (node.kind) {
	            case 97 /* SuperKeyword */:
	            case 95 /* NullKeyword */:
	            case 101 /* TrueKeyword */:
	            case 86 /* FalseKeyword */:
	            case 12 /* RegularExpressionLiteral */:
	            case 181 /* ArrayLiteralExpression */:
	            case 182 /* ObjectLiteralExpression */:
	            case 183 /* PropertyAccessExpression */:
	            case 184 /* ElementAccessExpression */:
	            case 185 /* CallExpression */:
	            case 186 /* NewExpression */:
	            case 187 /* TaggedTemplateExpression */:
	            case 206 /* AsExpression */:
	            case 188 /* TypeAssertionExpression */:
	            case 207 /* NonNullExpression */:
	            case 189 /* ParenthesizedExpression */:
	            case 190 /* FunctionExpression */:
	            case 203 /* ClassExpression */:
	            case 191 /* ArrowFunction */:
	            case 194 /* VoidExpression */:
	            case 192 /* DeleteExpression */:
	            case 193 /* TypeOfExpression */:
	            case 196 /* PrefixUnaryExpression */:
	            case 197 /* PostfixUnaryExpression */:
	            case 198 /* BinaryExpression */:
	            case 199 /* ConditionalExpression */:
	            case 202 /* SpreadElement */:
	            case 200 /* TemplateExpression */:
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 204 /* OmittedExpression */:
	            case 253 /* JsxElement */:
	            case 254 /* JsxSelfClosingElement */:
	            case 257 /* JsxFragment */:
	            case 201 /* YieldExpression */:
	            case 195 /* AwaitExpression */:
	            case 208 /* MetaProperty */:
	                return true;
	            case 145 /* QualifiedName */:
	                while (node.parent.kind === 145 /* QualifiedName */) {
	                    node = node.parent;
	                }
	                return node.parent.kind === 164 /* TypeQuery */ || isJSXTagName(node);
	            case 71 /* Identifier */:
	                if (node.parent.kind === 164 /* TypeQuery */ || isJSXTagName(node)) {
	                    return true;
	                }
	            // falls through
	            case 8 /* NumericLiteral */:
	            case 9 /* StringLiteral */:
	            case 99 /* ThisKeyword */:
	                return isInExpressionContext(node);
	            default:
	                return false;
	        }
	    }
	    ts.isExpressionNode = isExpressionNode;
	    function isInExpressionContext(node) {
	        var parent = node.parent;
	        switch (parent.kind) {
	            case 230 /* VariableDeclaration */:
	            case 148 /* Parameter */:
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 271 /* EnumMember */:
	            case 268 /* PropertyAssignment */:
	            case 180 /* BindingElement */:
	                return parent.initializer === node;
	            case 214 /* ExpressionStatement */:
	            case 215 /* IfStatement */:
	            case 216 /* DoStatement */:
	            case 217 /* WhileStatement */:
	            case 223 /* ReturnStatement */:
	            case 224 /* WithStatement */:
	            case 225 /* SwitchStatement */:
	            case 264 /* CaseClause */:
	            case 227 /* ThrowStatement */:
	                return parent.expression === node;
	            case 218 /* ForStatement */:
	                var forStatement = parent;
	                return (forStatement.initializer === node && forStatement.initializer.kind !== 231 /* VariableDeclarationList */) ||
	                    forStatement.condition === node ||
	                    forStatement.incrementor === node;
	            case 219 /* ForInStatement */:
	            case 220 /* ForOfStatement */:
	                var forInStatement = parent;
	                return (forInStatement.initializer === node && forInStatement.initializer.kind !== 231 /* VariableDeclarationList */) ||
	                    forInStatement.expression === node;
	            case 188 /* TypeAssertionExpression */:
	            case 206 /* AsExpression */:
	                return node === parent.expression;
	            case 209 /* TemplateSpan */:
	                return node === parent.expression;
	            case 146 /* ComputedPropertyName */:
	                return node === parent.expression;
	            case 149 /* Decorator */:
	            case 263 /* JsxExpression */:
	            case 262 /* JsxSpreadAttribute */:
	            case 270 /* SpreadAssignment */:
	                return true;
	            case 205 /* ExpressionWithTypeArguments */:
	                return parent.expression === node && isExpressionWithTypeArgumentsInClassExtendsClause(parent);
	            default:
	                return isExpressionNode(parent);
	        }
	    }
	    ts.isInExpressionContext = isInExpressionContext;
	    function isExternalModuleImportEqualsDeclaration(node) {
	        return node.kind === 241 /* ImportEqualsDeclaration */ && node.moduleReference.kind === 252 /* ExternalModuleReference */;
	    }
	    ts.isExternalModuleImportEqualsDeclaration = isExternalModuleImportEqualsDeclaration;
	    function getExternalModuleImportEqualsDeclarationExpression(node) {
	        ts.Debug.assert(isExternalModuleImportEqualsDeclaration(node));
	        return node.moduleReference.expression;
	    }
	    ts.getExternalModuleImportEqualsDeclarationExpression = getExternalModuleImportEqualsDeclarationExpression;
	    function isInternalModuleImportEqualsDeclaration(node) {
	        return node.kind === 241 /* ImportEqualsDeclaration */ && node.moduleReference.kind !== 252 /* ExternalModuleReference */;
	    }
	    ts.isInternalModuleImportEqualsDeclaration = isInternalModuleImportEqualsDeclaration;
	    function isSourceFileJavaScript(file) {
	        return isInJavaScriptFile(file);
	    }
	    ts.isSourceFileJavaScript = isSourceFileJavaScript;
	    function isInJavaScriptFile(node) {
	        return node && !!(node.flags & 65536 /* JavaScriptFile */);
	    }
	    ts.isInJavaScriptFile = isInJavaScriptFile;
	    function isInJSDoc(node) {
	        return node && !!(node.flags & 1048576 /* JSDoc */);
	    }
	    ts.isInJSDoc = isInJSDoc;
	    function isJSDocIndexSignature(node) {
	        return ts.isTypeReferenceNode(node) &&
	            ts.isIdentifier(node.typeName) &&
	            node.typeName.escapedText === "Object" &&
	            node.typeArguments && node.typeArguments.length === 2 &&
	            (node.typeArguments[0].kind === 137 /* StringKeyword */ || node.typeArguments[0].kind === 134 /* NumberKeyword */);
	    }
	    ts.isJSDocIndexSignature = isJSDocIndexSignature;
	    function isRequireCall(callExpression, checkArgumentIsStringLiteral) {
	        if (callExpression.kind !== 185 /* CallExpression */) {
	            return false;
	        }
	        var _a = callExpression, expression = _a.expression, args = _a.arguments;
	        if (expression.kind !== 71 /* Identifier */ || expression.escapedText !== "require") {
	            return false;
	        }
	        if (args.length !== 1) {
	            return false;
	        }
	        var arg = args[0];
	        return !checkArgumentIsStringLiteral || arg.kind === 9 /* StringLiteral */ || arg.kind === 13 /* NoSubstitutionTemplateLiteral */;
	    }
	    ts.isRequireCall = isRequireCall;
	    function isSingleOrDoubleQuote(charCode) {
	        return charCode === 39 /* singleQuote */ || charCode === 34 /* doubleQuote */;
	    }
	    ts.isSingleOrDoubleQuote = isSingleOrDoubleQuote;
	    function isStringDoubleQuoted(str, sourceFile) {
	        return getSourceTextOfNodeFromSourceFile(sourceFile, str).charCodeAt(0) === 34 /* doubleQuote */;
	    }
	    ts.isStringDoubleQuoted = isStringDoubleQuoted;
	    /**
	     * Returns true if the node is a variable declaration whose initializer is a function or class expression.
	     * This function does not test if the node is in a JavaScript file or not.
	     */
	    function isDeclarationOfFunctionOrClassExpression(s) {
	        if (s.valueDeclaration && s.valueDeclaration.kind === 230 /* VariableDeclaration */) {
	            var declaration = s.valueDeclaration;
	            return declaration.initializer && (declaration.initializer.kind === 190 /* FunctionExpression */ || declaration.initializer.kind === 203 /* ClassExpression */);
	        }
	        return false;
	    }
	    ts.isDeclarationOfFunctionOrClassExpression = isDeclarationOfFunctionOrClassExpression;
	    function getRightMostAssignedExpression(node) {
	        while (isAssignmentExpression(node, /*excludeCompoundAssignements*/ true)) {
	            node = node.right;
	        }
	        return node;
	    }
	    ts.getRightMostAssignedExpression = getRightMostAssignedExpression;
	    function isExportsIdentifier(node) {
	        return ts.isIdentifier(node) && node.escapedText === "exports";
	    }
	    ts.isExportsIdentifier = isExportsIdentifier;
	    function isModuleExportsPropertyAccessExpression(node) {
	        return ts.isPropertyAccessExpression(node) && ts.isIdentifier(node.expression) && node.expression.escapedText === "module" && node.name.escapedText === "exports";
	    }
	    ts.isModuleExportsPropertyAccessExpression = isModuleExportsPropertyAccessExpression;
	    /// Given a BinaryExpression, returns SpecialPropertyAssignmentKind for the various kinds of property
	    /// assignments we treat as special in the binder
	    function getSpecialPropertyAssignmentKind(expr) {
	        if (!isInJavaScriptFile(expr)) {
	            return 0 /* None */;
	        }
	        if (expr.operatorToken.kind !== 58 /* EqualsToken */ || expr.left.kind !== 183 /* PropertyAccessExpression */) {
	            return 0 /* None */;
	        }
	        var lhs = expr.left;
	        if (lhs.expression.kind === 71 /* Identifier */) {
	            var lhsId = lhs.expression;
	            if (lhsId.escapedText === "exports") {
	                // exports.name = expr
	                return 1 /* ExportsProperty */;
	            }
	            else if (lhsId.escapedText === "module" && lhs.name.escapedText === "exports") {
	                // module.exports = expr
	                return 2 /* ModuleExports */;
	            }
	            else {
	                // F.x = expr
	                return 5 /* Property */;
	            }
	        }
	        else if (lhs.expression.kind === 99 /* ThisKeyword */) {
	            return 4 /* ThisProperty */;
	        }
	        else if (lhs.expression.kind === 183 /* PropertyAccessExpression */) {
	            // chained dot, e.g. x.y.z = expr; this var is the 'x.y' part
	            var innerPropertyAccess = lhs.expression;
	            if (innerPropertyAccess.expression.kind === 71 /* Identifier */) {
	                // module.exports.name = expr
	                var innerPropertyAccessIdentifier = innerPropertyAccess.expression;
	                if (innerPropertyAccessIdentifier.escapedText === "module" && innerPropertyAccess.name.escapedText === "exports") {
	                    return 1 /* ExportsProperty */;
	                }
	                if (innerPropertyAccess.name.escapedText === "prototype") {
	                    return 3 /* PrototypeProperty */;
	                }
	            }
	        }
	        return 0 /* None */;
	    }
	    ts.getSpecialPropertyAssignmentKind = getSpecialPropertyAssignmentKind;
	    function isSpecialPropertyDeclaration(expr) {
	        return isInJavaScriptFile(expr) &&
	            expr.parent && expr.parent.kind === 214 /* ExpressionStatement */ &&
	            !!ts.getJSDocTypeTag(expr.parent);
	    }
	    ts.isSpecialPropertyDeclaration = isSpecialPropertyDeclaration;
	    function getExternalModuleName(node) {
	        if (node.kind === 242 /* ImportDeclaration */) {
	            return node.moduleSpecifier;
	        }
	        if (node.kind === 241 /* ImportEqualsDeclaration */) {
	            var reference = node.moduleReference;
	            if (reference.kind === 252 /* ExternalModuleReference */) {
	                return reference.expression;
	            }
	        }
	        if (node.kind === 248 /* ExportDeclaration */) {
	            return node.moduleSpecifier;
	        }
	        if (isModuleWithStringLiteralName(node)) {
	            return node.name;
	        }
	    }
	    ts.getExternalModuleName = getExternalModuleName;
	    function getNamespaceDeclarationNode(node) {
	        switch (node.kind) {
	            case 242 /* ImportDeclaration */:
	                return node.importClause && ts.tryCast(node.importClause.namedBindings, ts.isNamespaceImport);
	            case 241 /* ImportEqualsDeclaration */:
	                return node;
	            case 248 /* ExportDeclaration */:
	                return undefined;
	            default:
	                return ts.Debug.assertNever(node);
	        }
	    }
	    ts.getNamespaceDeclarationNode = getNamespaceDeclarationNode;
	    function isDefaultImport(node) {
	        return node.kind === 242 /* ImportDeclaration */ && node.importClause && !!node.importClause.name;
	    }
	    ts.isDefaultImport = isDefaultImport;
	    function hasQuestionToken(node) {
	        if (node) {
	            switch (node.kind) {
	                case 148 /* Parameter */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 269 /* ShorthandPropertyAssignment */:
	                case 268 /* PropertyAssignment */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return node.questionToken !== undefined;
	            }
	        }
	        return false;
	    }
	    ts.hasQuestionToken = hasQuestionToken;
	    function isJSDocConstructSignature(node) {
	        return node.kind === 280 /* JSDocFunctionType */ &&
	            node.parameters.length > 0 &&
	            node.parameters[0].name &&
	            node.parameters[0].name.escapedText === "new";
	    }
	    ts.isJSDocConstructSignature = isJSDocConstructSignature;
	    function getSourceOfAssignment(node) {
	        return ts.isExpressionStatement(node) &&
	            node.expression && ts.isBinaryExpression(node.expression) &&
	            node.expression.operatorToken.kind === 58 /* EqualsToken */ &&
	            node.expression.right;
	    }
	    function getSingleInitializerOfVariableStatementOrPropertyDeclaration(node) {
	        switch (node.kind) {
	            case 212 /* VariableStatement */:
	                var v = getSingleVariableOfVariableStatement(node);
	                return v && v.initializer;
	            case 151 /* PropertyDeclaration */:
	                return node.initializer;
	        }
	    }
	    function getSingleVariableOfVariableStatement(node) {
	        return ts.isVariableStatement(node) &&
	            node.declarationList.declarations.length > 0 &&
	            node.declarationList.declarations[0];
	    }
	    function getNestedModuleDeclaration(node) {
	        return node.kind === 237 /* ModuleDeclaration */ &&
	            node.body &&
	            node.body.kind === 237 /* ModuleDeclaration */ &&
	            node.body;
	    }
	    function getJSDocCommentsAndTags(node) {
	        var result;
	        getJSDocCommentsAndTagsWorker(node);
	        return result || ts.emptyArray;
	        function getJSDocCommentsAndTagsWorker(node) {
	            var parent = node.parent;
	            if (parent && (parent.kind === 268 /* PropertyAssignment */ || parent.kind === 151 /* PropertyDeclaration */ || getNestedModuleDeclaration(parent))) {
	                getJSDocCommentsAndTagsWorker(parent);
	            }
	            // Try to recognize this pattern when node is initializer of variable declaration and JSDoc comments are on containing variable statement.
	            // /**
	            //   * @param {number} name
	            //   * @returns {number}
	            //   */
	            // var x = function(name) { return name.length; }
	            if (parent && parent.parent &&
	                (getSingleVariableOfVariableStatement(parent.parent) === node || getSourceOfAssignment(parent.parent))) {
	                getJSDocCommentsAndTagsWorker(parent.parent);
	            }
	            if (parent && parent.parent && parent.parent.parent && getSingleInitializerOfVariableStatementOrPropertyDeclaration(parent.parent.parent) === node) {
	                getJSDocCommentsAndTagsWorker(parent.parent.parent);
	            }
	            if (ts.isBinaryExpression(node) && getSpecialPropertyAssignmentKind(node) !== 0 /* None */ ||
	                node.kind === 183 /* PropertyAccessExpression */ && node.parent && node.parent.kind === 214 /* ExpressionStatement */) {
	                getJSDocCommentsAndTagsWorker(parent);
	            }
	            // Pull parameter comments from declaring function as well
	            if (node.kind === 148 /* Parameter */) {
	                result = ts.addRange(result, ts.getJSDocParameterTags(node));
	            }
	            if (isVariableLike(node) && ts.hasInitializer(node) && ts.hasJSDocNodes(node.initializer)) {
	                result = ts.addRange(result, node.initializer.jsDoc);
	            }
	            if (ts.hasJSDocNodes(node)) {
	                result = ts.addRange(result, node.jsDoc);
	            }
	        }
	    }
	    ts.getJSDocCommentsAndTags = getJSDocCommentsAndTags;
	    /** Does the opposite of `getJSDocParameterTags`: given a JSDoc parameter, finds the parameter corresponding to it. */
	    function getParameterSymbolFromJSDoc(node) {
	        if (node.symbol) {
	            return node.symbol;
	        }
	        if (!ts.isIdentifier(node.name)) {
	            return undefined;
	        }
	        var name = node.name.escapedText;
	        var decl = getHostSignatureFromJSDoc(node);
	        if (!decl) {
	            return undefined;
	        }
	        var parameter = ts.find(decl.parameters, function (p) { return p.name.kind === 71 /* Identifier */ && p.name.escapedText === name; });
	        return parameter && parameter.symbol;
	    }
	    ts.getParameterSymbolFromJSDoc = getParameterSymbolFromJSDoc;
	    function getHostSignatureFromJSDoc(node) {
	        var host = getJSDocHost(node);
	        var decl = getSourceOfAssignment(host) ||
	            getSingleInitializerOfVariableStatementOrPropertyDeclaration(host) ||
	            getSingleVariableOfVariableStatement(host) ||
	            getNestedModuleDeclaration(host) ||
	            host;
	        return decl && ts.isFunctionLike(decl) ? decl : undefined;
	    }
	    ts.getHostSignatureFromJSDoc = getHostSignatureFromJSDoc;
	    function getJSDocHost(node) {
	        ts.Debug.assert(node.parent.kind === 282 /* JSDocComment */);
	        return node.parent.parent;
	    }
	    ts.getJSDocHost = getJSDocHost;
	    function getTypeParameterFromJsDoc(node) {
	        var name = node.name.escapedText;
	        var typeParameters = node.parent.parent.parent.typeParameters;
	        return ts.find(typeParameters, function (p) { return p.name.escapedText === name; });
	    }
	    ts.getTypeParameterFromJsDoc = getTypeParameterFromJsDoc;
	    function hasRestParameter(s) {
	        var last = ts.lastOrUndefined(s.parameters);
	        return last && isRestParameter(last);
	    }
	    ts.hasRestParameter = hasRestParameter;
	    function isRestParameter(node) {
	        return node.dotDotDotToken !== undefined;
	    }
	    ts.isRestParameter = isRestParameter;
	    var AssignmentKind;
	    (function (AssignmentKind) {
	        AssignmentKind[AssignmentKind["None"] = 0] = "None";
	        AssignmentKind[AssignmentKind["Definite"] = 1] = "Definite";
	        AssignmentKind[AssignmentKind["Compound"] = 2] = "Compound";
	    })(AssignmentKind = ts.AssignmentKind || (ts.AssignmentKind = {}));
	    function getAssignmentTargetKind(node) {
	        var parent = node.parent;
	        while (true) {
	            switch (parent.kind) {
	                case 198 /* BinaryExpression */:
	                    var binaryOperator = parent.operatorToken.kind;
	                    return isAssignmentOperator(binaryOperator) && parent.left === node ?
	                        binaryOperator === 58 /* EqualsToken */ ? 1 /* Definite */ : 2 /* Compound */ :
	                        0 /* None */;
	                case 196 /* PrefixUnaryExpression */:
	                case 197 /* PostfixUnaryExpression */:
	                    var unaryOperator = parent.operator;
	                    return unaryOperator === 43 /* PlusPlusToken */ || unaryOperator === 44 /* MinusMinusToken */ ? 2 /* Compound */ : 0 /* None */;
	                case 219 /* ForInStatement */:
	                case 220 /* ForOfStatement */:
	                    return parent.initializer === node ? 1 /* Definite */ : 0 /* None */;
	                case 189 /* ParenthesizedExpression */:
	                case 181 /* ArrayLiteralExpression */:
	                case 202 /* SpreadElement */:
	                case 207 /* NonNullExpression */:
	                    node = parent;
	                    break;
	                case 269 /* ShorthandPropertyAssignment */:
	                    if (parent.name !== node) {
	                        return 0 /* None */;
	                    }
	                    node = parent.parent;
	                    break;
	                case 268 /* PropertyAssignment */:
	                    if (parent.name === node) {
	                        return 0 /* None */;
	                    }
	                    node = parent.parent;
	                    break;
	                default:
	                    return 0 /* None */;
	            }
	            parent = node.parent;
	        }
	    }
	    ts.getAssignmentTargetKind = getAssignmentTargetKind;
	    // A node is an assignment target if it is on the left hand side of an '=' token, if it is parented by a property
	    // assignment in an object literal that is an assignment target, or if it is parented by an array literal that is
	    // an assignment target. Examples include 'a = xxx', '{ p: a } = xxx', '[{ a }] = xxx'.
	    // (Note that `p` is not a target in the above examples, only `a`.)
	    function isAssignmentTarget(node) {
	        return getAssignmentTargetKind(node) !== 0 /* None */;
	    }
	    ts.isAssignmentTarget = isAssignmentTarget;
	    /**
	     * Indicates whether a node could contain a `var` VariableDeclarationList that contributes to
	     * the same `var` declaration scope as the node's parent.
	     */
	    function isNodeWithPossibleHoistedDeclaration(node) {
	        switch (node.kind) {
	            case 211 /* Block */:
	            case 212 /* VariableStatement */:
	            case 224 /* WithStatement */:
	            case 215 /* IfStatement */:
	            case 225 /* SwitchStatement */:
	            case 239 /* CaseBlock */:
	            case 264 /* CaseClause */:
	            case 265 /* DefaultClause */:
	            case 226 /* LabeledStatement */:
	            case 218 /* ForStatement */:
	            case 219 /* ForInStatement */:
	            case 220 /* ForOfStatement */:
	            case 216 /* DoStatement */:
	            case 217 /* WhileStatement */:
	            case 228 /* TryStatement */:
	            case 267 /* CatchClause */:
	                return true;
	        }
	        return false;
	    }
	    ts.isNodeWithPossibleHoistedDeclaration = isNodeWithPossibleHoistedDeclaration;
	    function walkUp(node, kind) {
	        while (node && node.kind === kind) {
	            node = node.parent;
	        }
	        return node;
	    }
	    function walkUpParenthesizedTypes(node) {
	        return walkUp(node, 172 /* ParenthesizedType */);
	    }
	    ts.walkUpParenthesizedTypes = walkUpParenthesizedTypes;
	    function walkUpParenthesizedExpressions(node) {
	        return walkUp(node, 189 /* ParenthesizedExpression */);
	    }
	    ts.walkUpParenthesizedExpressions = walkUpParenthesizedExpressions;
	    // a node is delete target iff. it is PropertyAccessExpression/ElementAccessExpression with parentheses skipped
	    function isDeleteTarget(node) {
	        if (node.kind !== 183 /* PropertyAccessExpression */ && node.kind !== 184 /* ElementAccessExpression */) {
	            return false;
	        }
	        node = walkUpParenthesizedExpressions(node.parent);
	        return node && node.kind === 192 /* DeleteExpression */;
	    }
	    ts.isDeleteTarget = isDeleteTarget;
	    function isNodeDescendantOf(node, ancestor) {
	        while (node) {
	            if (node === ancestor)
	                return true;
	            node = node.parent;
	        }
	        return false;
	    }
	    ts.isNodeDescendantOf = isNodeDescendantOf;
	    // True if `name` is the name of a declaration node
	    function isDeclarationName(name) {
	        return !ts.isSourceFile(name) && !ts.isBindingPattern(name) && ts.isDeclaration(name.parent) && name.parent.name === name;
	    }
	    ts.isDeclarationName = isDeclarationName;
	    // See GH#16030
	    function isAnyDeclarationName(name) {
	        switch (name.kind) {
	            case 71 /* Identifier */:
	            case 9 /* StringLiteral */:
	            case 8 /* NumericLiteral */:
	                if (ts.isDeclaration(name.parent)) {
	                    return name.parent.name === name;
	                }
	                var binExp = name.parent.parent;
	                return ts.isBinaryExpression(binExp) && getSpecialPropertyAssignmentKind(binExp) !== 0 /* None */ && ts.getNameOfDeclaration(binExp) === name;
	            default:
	                return false;
	        }
	    }
	    ts.isAnyDeclarationName = isAnyDeclarationName;
	    function isLiteralComputedPropertyDeclarationName(node) {
	        return (node.kind === 9 /* StringLiteral */ || node.kind === 8 /* NumericLiteral */) &&
	            node.parent.kind === 146 /* ComputedPropertyName */ &&
	            ts.isDeclaration(node.parent.parent);
	    }
	    ts.isLiteralComputedPropertyDeclarationName = isLiteralComputedPropertyDeclarationName;
	    // Return true if the given identifier is classified as an IdentifierName
	    function isIdentifierName(node) {
	        var parent = node.parent;
	        switch (parent.kind) {
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 271 /* EnumMember */:
	            case 268 /* PropertyAssignment */:
	            case 183 /* PropertyAccessExpression */:
	                // Name in member declaration or property name in property access
	                return parent.name === node;
	            case 145 /* QualifiedName */:
	                // Name on right hand side of dot in a type query
	                if (parent.right === node) {
	                    while (parent.kind === 145 /* QualifiedName */) {
	                        parent = parent.parent;
	                    }
	                    return parent.kind === 164 /* TypeQuery */;
	                }
	                return false;
	            case 180 /* BindingElement */:
	            case 246 /* ImportSpecifier */:
	                // Property name in binding element or import specifier
	                return parent.propertyName === node;
	            case 250 /* ExportSpecifier */:
	            case 260 /* JsxAttribute */:
	                // Any name in an export specifier or JSX Attribute
	                return true;
	        }
	        return false;
	    }
	    ts.isIdentifierName = isIdentifierName;
	    // An alias symbol is created by one of the following declarations:
	    // import <symbol> = ...
	    // import <symbol> from ...
	    // import * as <symbol> from ...
	    // import { x as <symbol> } from ...
	    // export { x as <symbol> } from ...
	    // export = <EntityNameExpression>
	    // export default <EntityNameExpression>
	    function isAliasSymbolDeclaration(node) {
	        return node.kind === 241 /* ImportEqualsDeclaration */ ||
	            node.kind === 240 /* NamespaceExportDeclaration */ ||
	            node.kind === 243 /* ImportClause */ && !!node.name ||
	            node.kind === 244 /* NamespaceImport */ ||
	            node.kind === 246 /* ImportSpecifier */ ||
	            node.kind === 250 /* ExportSpecifier */ ||
	            node.kind === 247 /* ExportAssignment */ && exportAssignmentIsAlias(node);
	    }
	    ts.isAliasSymbolDeclaration = isAliasSymbolDeclaration;
	    function exportAssignmentIsAlias(node) {
	        return isEntityNameExpression(node.expression);
	    }
	    ts.exportAssignmentIsAlias = exportAssignmentIsAlias;
	    function getClassExtendsHeritageClauseElement(node) {
	        var heritageClause = getHeritageClause(node.heritageClauses, 85 /* ExtendsKeyword */);
	        return heritageClause && heritageClause.types.length > 0 ? heritageClause.types[0] : undefined;
	    }
	    ts.getClassExtendsHeritageClauseElement = getClassExtendsHeritageClauseElement;
	    function getClassImplementsHeritageClauseElements(node) {
	        var heritageClause = getHeritageClause(node.heritageClauses, 108 /* ImplementsKeyword */);
	        return heritageClause ? heritageClause.types : undefined;
	    }
	    ts.getClassImplementsHeritageClauseElements = getClassImplementsHeritageClauseElements;
	    function getInterfaceBaseTypeNodes(node) {
	        var heritageClause = getHeritageClause(node.heritageClauses, 85 /* ExtendsKeyword */);
	        return heritageClause ? heritageClause.types : undefined;
	    }
	    ts.getInterfaceBaseTypeNodes = getInterfaceBaseTypeNodes;
	    function getHeritageClause(clauses, kind) {
	        if (clauses) {
	            for (var _i = 0, clauses_1 = clauses; _i < clauses_1.length; _i++) {
	                var clause = clauses_1[_i];
	                if (clause.token === kind) {
	                    return clause;
	                }
	            }
	        }
	        return undefined;
	    }
	    ts.getHeritageClause = getHeritageClause;
	    function tryResolveScriptReference(host, sourceFile, reference) {
	        if (!host.getCompilerOptions().noResolve) {
	            var referenceFileName = ts.isRootedDiskPath(reference.fileName) ? reference.fileName : ts.combinePaths(ts.getDirectoryPath(sourceFile.fileName), reference.fileName);
	            return host.getSourceFile(referenceFileName);
	        }
	    }
	    ts.tryResolveScriptReference = tryResolveScriptReference;
	    function getAncestor(node, kind) {
	        while (node) {
	            if (node.kind === kind) {
	                return node;
	            }
	            node = node.parent;
	        }
	        return undefined;
	    }
	    ts.getAncestor = getAncestor;
	    function getFileReferenceFromReferencePath(comment, commentRange) {
	        var simpleReferenceRegEx = /^\/\/\/\s*<reference\s+/gim;
	        var isNoDefaultLibRegEx = new RegExp(defaultLibReferenceRegEx.source, "gim");
	        if (simpleReferenceRegEx.test(comment)) {
	            if (isNoDefaultLibRegEx.test(comment)) {
	                return { isNoDefaultLib: true };
	            }
	            else {
	                var refMatchResult = ts.fullTripleSlashReferencePathRegEx.exec(comment);
	                var refLibResult = !refMatchResult && fullTripleSlashReferenceTypeReferenceDirectiveRegEx.exec(comment);
	                var match = refMatchResult || refLibResult;
	                if (match) {
	                    var pos = commentRange.pos + match[1].length + match[2].length;
	                    return {
	                        fileReference: {
	                            pos: pos,
	                            end: pos + match[3].length,
	                            fileName: match[3]
	                        },
	                        isNoDefaultLib: false,
	                        isTypeReferenceDirective: !!refLibResult
	                    };
	                }
	                return {
	                    diagnosticMessage: ts.Diagnostics.Invalid_reference_directive_syntax,
	                    isNoDefaultLib: false
	                };
	            }
	        }
	        return undefined;
	    }
	    ts.getFileReferenceFromReferencePath = getFileReferenceFromReferencePath;
	    function isKeyword(token) {
	        return 72 /* FirstKeyword */ <= token && token <= 144 /* LastKeyword */;
	    }
	    ts.isKeyword = isKeyword;
	    function isContextualKeyword(token) {
	        return 117 /* FirstContextualKeyword */ <= token && token <= 144 /* LastContextualKeyword */;
	    }
	    ts.isContextualKeyword = isContextualKeyword;
	    function isNonContextualKeyword(token) {
	        return isKeyword(token) && !isContextualKeyword(token);
	    }
	    ts.isNonContextualKeyword = isNonContextualKeyword;
	    function isStringANonContextualKeyword(name) {
	        var token = ts.stringToToken(name);
	        return token !== undefined && isNonContextualKeyword(token);
	    }
	    ts.isStringANonContextualKeyword = isStringANonContextualKeyword;
	    function isTrivia(token) {
	        return 2 /* FirstTriviaToken */ <= token && token <= 7 /* LastTriviaToken */;
	    }
	    ts.isTrivia = isTrivia;
	    var FunctionFlags;
	    (function (FunctionFlags) {
	        FunctionFlags[FunctionFlags["Normal"] = 0] = "Normal";
	        FunctionFlags[FunctionFlags["Generator"] = 1] = "Generator";
	        FunctionFlags[FunctionFlags["Async"] = 2] = "Async";
	        FunctionFlags[FunctionFlags["Invalid"] = 4] = "Invalid";
	        FunctionFlags[FunctionFlags["AsyncGenerator"] = 3] = "AsyncGenerator";
	    })(FunctionFlags = ts.FunctionFlags || (ts.FunctionFlags = {}));
	    function getFunctionFlags(node) {
	        if (!node) {
	            return 4 /* Invalid */;
	        }
	        var flags = 0 /* Normal */;
	        switch (node.kind) {
	            case 232 /* FunctionDeclaration */:
	            case 190 /* FunctionExpression */:
	            case 153 /* MethodDeclaration */:
	                if (node.asteriskToken) {
	                    flags |= 1 /* Generator */;
	                }
	            // falls through
	            case 191 /* ArrowFunction */:
	                if (hasModifier(node, 256 /* Async */)) {
	                    flags |= 2 /* Async */;
	                }
	                break;
	        }
	        if (!node.body) {
	            flags |= 4 /* Invalid */;
	        }
	        return flags;
	    }
	    ts.getFunctionFlags = getFunctionFlags;
	    function isAsyncFunction(node) {
	        switch (node.kind) {
	            case 232 /* FunctionDeclaration */:
	            case 190 /* FunctionExpression */:
	            case 191 /* ArrowFunction */:
	            case 153 /* MethodDeclaration */:
	                return node.body !== undefined
	                    && node.asteriskToken === undefined
	                    && hasModifier(node, 256 /* Async */);
	        }
	        return false;
	    }
	    ts.isAsyncFunction = isAsyncFunction;
	    function isStringOrNumericLiteral(node) {
	        var kind = node.kind;
	        return kind === 9 /* StringLiteral */
	            || kind === 8 /* NumericLiteral */;
	    }
	    ts.isStringOrNumericLiteral = isStringOrNumericLiteral;
	    /**
	     * A declaration has a dynamic name if both of the following are true:
	     *   1. The declaration has a computed property name
	     *   2. The computed name is *not* expressed as Symbol.<name>, where name
	     *      is a property of the Symbol constructor that denotes a built in
	     *      Symbol.
	     */
	    function hasDynamicName(declaration) {
	        var name = ts.getNameOfDeclaration(declaration);
	        return name && isDynamicName(name);
	    }
	    ts.hasDynamicName = hasDynamicName;
	    function isDynamicName(name) {
	        return name.kind === 146 /* ComputedPropertyName */ &&
	            !isStringOrNumericLiteral(name.expression) &&
	            !isWellKnownSymbolSyntactically(name.expression);
	    }
	    ts.isDynamicName = isDynamicName;
	    /**
	     * Checks if the expression is of the form:
	     *    Symbol.name
	     * where Symbol is literally the word "Symbol", and name is any identifierName
	     */
	    function isWellKnownSymbolSyntactically(node) {
	        return ts.isPropertyAccessExpression(node) && isESSymbolIdentifier(node.expression);
	    }
	    ts.isWellKnownSymbolSyntactically = isWellKnownSymbolSyntactically;
	    function getPropertyNameForPropertyNameNode(name) {
	        if (name.kind === 71 /* Identifier */) {
	            return name.escapedText;
	        }
	        if (name.kind === 9 /* StringLiteral */ || name.kind === 8 /* NumericLiteral */) {
	            return escapeLeadingUnderscores(name.text);
	        }
	        if (name.kind === 146 /* ComputedPropertyName */) {
	            var nameExpression = name.expression;
	            if (isWellKnownSymbolSyntactically(nameExpression)) {
	                return getPropertyNameForKnownSymbolName(ts.idText(nameExpression.name));
	            }
	            else if (nameExpression.kind === 9 /* StringLiteral */ || nameExpression.kind === 8 /* NumericLiteral */) {
	                return escapeLeadingUnderscores(nameExpression.text);
	            }
	        }
	        return undefined;
	    }
	    ts.getPropertyNameForPropertyNameNode = getPropertyNameForPropertyNameNode;
	    function isPropertyNameLiteral(node) {
	        switch (node.kind) {
	            case 71 /* Identifier */:
	            case 9 /* StringLiteral */:
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 8 /* NumericLiteral */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isPropertyNameLiteral = isPropertyNameLiteral;
	    function getTextOfIdentifierOrLiteral(node) {
	        return node.kind === 71 /* Identifier */ ? ts.idText(node) : node.text;
	    }
	    ts.getTextOfIdentifierOrLiteral = getTextOfIdentifierOrLiteral;
	    function getEscapedTextOfIdentifierOrLiteral(node) {
	        return node.kind === 71 /* Identifier */ ? node.escapedText : escapeLeadingUnderscores(node.text);
	    }
	    ts.getEscapedTextOfIdentifierOrLiteral = getEscapedTextOfIdentifierOrLiteral;
	    function getPropertyNameForKnownSymbolName(symbolName) {
	        return "__@" + symbolName;
	    }
	    ts.getPropertyNameForKnownSymbolName = getPropertyNameForKnownSymbolName;
	    function isKnownSymbol(symbol) {
	        return ts.startsWith(symbol.escapedName, "__@");
	    }
	    ts.isKnownSymbol = isKnownSymbol;
	    /**
	     * Includes the word "Symbol" with unicode escapes
	     */
	    function isESSymbolIdentifier(node) {
	        return node.kind === 71 /* Identifier */ && node.escapedText === "Symbol";
	    }
	    ts.isESSymbolIdentifier = isESSymbolIdentifier;
	    function isPushOrUnshiftIdentifier(node) {
	        return node.escapedText === "push" || node.escapedText === "unshift";
	    }
	    ts.isPushOrUnshiftIdentifier = isPushOrUnshiftIdentifier;
	    function isParameterDeclaration(node) {
	        var root = getRootDeclaration(node);
	        return root.kind === 148 /* Parameter */;
	    }
	    ts.isParameterDeclaration = isParameterDeclaration;
	    function getRootDeclaration(node) {
	        while (node.kind === 180 /* BindingElement */) {
	            node = node.parent.parent;
	        }
	        return node;
	    }
	    ts.getRootDeclaration = getRootDeclaration;
	    function nodeStartsNewLexicalEnvironment(node) {
	        var kind = node.kind;
	        return kind === 154 /* Constructor */
	            || kind === 190 /* FunctionExpression */
	            || kind === 232 /* FunctionDeclaration */
	            || kind === 191 /* ArrowFunction */
	            || kind === 153 /* MethodDeclaration */
	            || kind === 155 /* GetAccessor */
	            || kind === 156 /* SetAccessor */
	            || kind === 237 /* ModuleDeclaration */
	            || kind === 272 /* SourceFile */;
	    }
	    ts.nodeStartsNewLexicalEnvironment = nodeStartsNewLexicalEnvironment;
	    function nodeIsSynthesized(range) {
	        return ts.positionIsSynthesized(range.pos)
	            || ts.positionIsSynthesized(range.end);
	    }
	    ts.nodeIsSynthesized = nodeIsSynthesized;
	    function getOriginalSourceFile(sourceFile) {
	        return ts.getParseTreeNode(sourceFile, ts.isSourceFile) || sourceFile;
	    }
	    ts.getOriginalSourceFile = getOriginalSourceFile;
	    var Associativity;
	    (function (Associativity) {
	        Associativity[Associativity["Left"] = 0] = "Left";
	        Associativity[Associativity["Right"] = 1] = "Right";
	    })(Associativity = ts.Associativity || (ts.Associativity = {}));
	    function getExpressionAssociativity(expression) {
	        var operator = getOperator(expression);
	        var hasArguments = expression.kind === 186 /* NewExpression */ && expression.arguments !== undefined;
	        return getOperatorAssociativity(expression.kind, operator, hasArguments);
	    }
	    ts.getExpressionAssociativity = getExpressionAssociativity;
	    function getOperatorAssociativity(kind, operator, hasArguments) {
	        switch (kind) {
	            case 186 /* NewExpression */:
	                return hasArguments ? 0 /* Left */ : 1 /* Right */;
	            case 196 /* PrefixUnaryExpression */:
	            case 193 /* TypeOfExpression */:
	            case 194 /* VoidExpression */:
	            case 192 /* DeleteExpression */:
	            case 195 /* AwaitExpression */:
	            case 199 /* ConditionalExpression */:
	            case 201 /* YieldExpression */:
	                return 1 /* Right */;
	            case 198 /* BinaryExpression */:
	                switch (operator) {
	                    case 40 /* AsteriskAsteriskToken */:
	                    case 58 /* EqualsToken */:
	                    case 59 /* PlusEqualsToken */:
	                    case 60 /* MinusEqualsToken */:
	                    case 62 /* AsteriskAsteriskEqualsToken */:
	                    case 61 /* AsteriskEqualsToken */:
	                    case 63 /* SlashEqualsToken */:
	                    case 64 /* PercentEqualsToken */:
	                    case 65 /* LessThanLessThanEqualsToken */:
	                    case 66 /* GreaterThanGreaterThanEqualsToken */:
	                    case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                    case 68 /* AmpersandEqualsToken */:
	                    case 70 /* CaretEqualsToken */:
	                    case 69 /* BarEqualsToken */:
	                        return 1 /* Right */;
	                }
	        }
	        return 0 /* Left */;
	    }
	    ts.getOperatorAssociativity = getOperatorAssociativity;
	    function getExpressionPrecedence(expression) {
	        var operator = getOperator(expression);
	        var hasArguments = expression.kind === 186 /* NewExpression */ && expression.arguments !== undefined;
	        return getOperatorPrecedence(expression.kind, operator, hasArguments);
	    }
	    ts.getExpressionPrecedence = getExpressionPrecedence;
	    function getOperator(expression) {
	        if (expression.kind === 198 /* BinaryExpression */) {
	            return expression.operatorToken.kind;
	        }
	        else if (expression.kind === 196 /* PrefixUnaryExpression */ || expression.kind === 197 /* PostfixUnaryExpression */) {
	            return expression.operator;
	        }
	        else {
	            return expression.kind;
	        }
	    }
	    ts.getOperator = getOperator;
	    function getOperatorPrecedence(nodeKind, operatorKind, hasArguments) {
	        switch (nodeKind) {
	            case 99 /* ThisKeyword */:
	            case 97 /* SuperKeyword */:
	            case 71 /* Identifier */:
	            case 95 /* NullKeyword */:
	            case 101 /* TrueKeyword */:
	            case 86 /* FalseKeyword */:
	            case 8 /* NumericLiteral */:
	            case 9 /* StringLiteral */:
	            case 181 /* ArrayLiteralExpression */:
	            case 182 /* ObjectLiteralExpression */:
	            case 190 /* FunctionExpression */:
	            case 191 /* ArrowFunction */:
	            case 203 /* ClassExpression */:
	            case 253 /* JsxElement */:
	            case 254 /* JsxSelfClosingElement */:
	            case 257 /* JsxFragment */:
	            case 12 /* RegularExpressionLiteral */:
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 200 /* TemplateExpression */:
	            case 189 /* ParenthesizedExpression */:
	            case 204 /* OmittedExpression */:
	                return 19;
	            case 187 /* TaggedTemplateExpression */:
	            case 183 /* PropertyAccessExpression */:
	            case 184 /* ElementAccessExpression */:
	                return 18;
	            case 186 /* NewExpression */:
	                return hasArguments ? 18 : 17;
	            case 185 /* CallExpression */:
	                return 17;
	            case 197 /* PostfixUnaryExpression */:
	                return 16;
	            case 196 /* PrefixUnaryExpression */:
	            case 193 /* TypeOfExpression */:
	            case 194 /* VoidExpression */:
	            case 192 /* DeleteExpression */:
	            case 195 /* AwaitExpression */:
	                return 15;
	            case 198 /* BinaryExpression */:
	                switch (operatorKind) {
	                    case 51 /* ExclamationToken */:
	                    case 52 /* TildeToken */:
	                        return 15;
	                    case 40 /* AsteriskAsteriskToken */:
	                    case 39 /* AsteriskToken */:
	                    case 41 /* SlashToken */:
	                    case 42 /* PercentToken */:
	                        return 14;
	                    case 37 /* PlusToken */:
	                    case 38 /* MinusToken */:
	                        return 13;
	                    case 45 /* LessThanLessThanToken */:
	                    case 46 /* GreaterThanGreaterThanToken */:
	                    case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                        return 12;
	                    case 27 /* LessThanToken */:
	                    case 30 /* LessThanEqualsToken */:
	                    case 29 /* GreaterThanToken */:
	                    case 31 /* GreaterThanEqualsToken */:
	                    case 92 /* InKeyword */:
	                    case 93 /* InstanceOfKeyword */:
	                        return 11;
	                    case 32 /* EqualsEqualsToken */:
	                    case 34 /* EqualsEqualsEqualsToken */:
	                    case 33 /* ExclamationEqualsToken */:
	                    case 35 /* ExclamationEqualsEqualsToken */:
	                        return 10;
	                    case 48 /* AmpersandToken */:
	                        return 9;
	                    case 50 /* CaretToken */:
	                        return 8;
	                    case 49 /* BarToken */:
	                        return 7;
	                    case 53 /* AmpersandAmpersandToken */:
	                        return 6;
	                    case 54 /* BarBarToken */:
	                        return 5;
	                    case 58 /* EqualsToken */:
	                    case 59 /* PlusEqualsToken */:
	                    case 60 /* MinusEqualsToken */:
	                    case 62 /* AsteriskAsteriskEqualsToken */:
	                    case 61 /* AsteriskEqualsToken */:
	                    case 63 /* SlashEqualsToken */:
	                    case 64 /* PercentEqualsToken */:
	                    case 65 /* LessThanLessThanEqualsToken */:
	                    case 66 /* GreaterThanGreaterThanEqualsToken */:
	                    case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                    case 68 /* AmpersandEqualsToken */:
	                    case 70 /* CaretEqualsToken */:
	                    case 69 /* BarEqualsToken */:
	                        return 3;
	                    case 26 /* CommaToken */:
	                        return 0;
	                    default:
	                        return -1;
	                }
	            case 199 /* ConditionalExpression */:
	                return 4;
	            case 201 /* YieldExpression */:
	                return 2;
	            case 202 /* SpreadElement */:
	                return 1;
	            case 296 /* CommaListExpression */:
	                return 0;
	            default:
	                return -1;
	        }
	    }
	    ts.getOperatorPrecedence = getOperatorPrecedence;
	    function createDiagnosticCollection() {
	        var nonFileDiagnostics = [];
	        var filesWithDiagnostics = [];
	        var fileDiagnostics = ts.createMap();
	        var hasReadNonFileDiagnostics = false;
	        var modificationCount = 0;
	        return {
	            add: add,
	            getGlobalDiagnostics: getGlobalDiagnostics,
	            getDiagnostics: getDiagnostics,
	            getModificationCount: getModificationCount,
	            reattachFileDiagnostics: reattachFileDiagnostics
	        };
	        function getModificationCount() {
	            return modificationCount;
	        }
	        function reattachFileDiagnostics(newFile) {
	            ts.forEach(fileDiagnostics.get(newFile.fileName), function (diagnostic) { return diagnostic.file = newFile; });
	        }
	        function add(diagnostic) {
	            var diagnostics;
	            if (diagnostic.file) {
	                diagnostics = fileDiagnostics.get(diagnostic.file.fileName);
	                if (!diagnostics) {
	                    diagnostics = [];
	                    fileDiagnostics.set(diagnostic.file.fileName, diagnostics);
	                    ts.insertSorted(filesWithDiagnostics, diagnostic.file.fileName, ts.compareStringsCaseSensitive);
	                }
	            }
	            else {
	                // If we've already read the non-file diagnostics, do not modify the existing array.
	                if (hasReadNonFileDiagnostics) {
	                    hasReadNonFileDiagnostics = false;
	                    nonFileDiagnostics = nonFileDiagnostics.slice();
	                }
	                diagnostics = nonFileDiagnostics;
	            }
	            ts.insertSorted(diagnostics, diagnostic, ts.compareDiagnostics);
	            modificationCount++;
	        }
	        function getGlobalDiagnostics() {
	            hasReadNonFileDiagnostics = true;
	            return nonFileDiagnostics;
	        }
	        function getDiagnostics(fileName) {
	            if (fileName) {
	                return fileDiagnostics.get(fileName) || [];
	            }
	            var fileDiags = ts.flatMap(filesWithDiagnostics, function (f) { return fileDiagnostics.get(f); });
	            if (!nonFileDiagnostics.length) {
	                return fileDiags;
	            }
	            fileDiags.unshift.apply(fileDiags, nonFileDiagnostics);
	            return fileDiags;
	        }
	    }
	    ts.createDiagnosticCollection = createDiagnosticCollection;
	    // This consists of the first 19 unprintable ASCII characters, canonical escapes, lineSeparator,
	    // paragraphSeparator, and nextLine. The latter three are just desirable to suppress new lines in
	    // the language service. These characters should be escaped when printing, and if any characters are added,
	    // the map below must be updated. Note that this regexp *does not* include the 'delete' character.
	    // There is no reason for this other than that JSON.stringify does not handle it either.
	    var doubleQuoteEscapedCharsRegExp = /[\\\"\u0000-\u001f\t\v\f\b\r\n\u2028\u2029\u0085]/g;
	    var singleQuoteEscapedCharsRegExp = /[\\\'\u0000-\u001f\t\v\f\b\r\n\u2028\u2029\u0085]/g;
	    var backtickQuoteEscapedCharsRegExp = /[\\\`\u0000-\u001f\t\v\f\b\r\n\u2028\u2029\u0085]/g;
	    var escapedCharsMap = ts.createMapFromTemplate({
	        "\0": "\\0",
	        "\t": "\\t",
	        "\v": "\\v",
	        "\f": "\\f",
	        "\b": "\\b",
	        "\r": "\\r",
	        "\n": "\\n",
	        "\\": "\\\\",
	        "\"": "\\\"",
	        "\'": "\\\'",
	        "\`": "\\\`",
	        "\u2028": "\\u2028",
	        "\u2029": "\\u2029",
	        "\u0085": "\\u0085" // nextLine
	    });
	    var escapedNullRegExp = /\\0[0-9]/g;
	    /**
	     * Based heavily on the abstract 'Quote'/'QuoteJSONString' operation from ECMA-262 (24.3.2.2),
	     * but augmented for a few select characters (e.g. lineSeparator, paragraphSeparator, nextLine)
	     * Note that this doesn't actually wrap the input in double quotes.
	     */
	    function escapeString(s, quoteChar) {
	        var escapedCharsRegExp = quoteChar === 96 /* backtick */ ? backtickQuoteEscapedCharsRegExp :
	            quoteChar === 39 /* singleQuote */ ? singleQuoteEscapedCharsRegExp :
	                doubleQuoteEscapedCharsRegExp;
	        return s.replace(escapedCharsRegExp, getReplacement).replace(escapedNullRegExp, nullReplacement);
	    }
	    ts.escapeString = escapeString;
	    function nullReplacement(c) {
	        return "\\x00" + c.charAt(c.length - 1);
	    }
	    function getReplacement(c) {
	        return escapedCharsMap.get(c) || get16BitUnicodeEscapeSequence(c.charCodeAt(0));
	    }
	    function isIntrinsicJsxName(name) {
	        var ch = name.charCodeAt(0);
	        return (ch >= 97 /* a */ && ch <= 122 /* z */) || name.indexOf("-") > -1;
	    }
	    ts.isIntrinsicJsxName = isIntrinsicJsxName;
	    function get16BitUnicodeEscapeSequence(charCode) {
	        var hexCharCode = charCode.toString(16).toUpperCase();
	        var paddedHexCode = ("0000" + hexCharCode).slice(-4);
	        return "\\u" + paddedHexCode;
	    }
	    var nonAsciiCharacters = /[^\u0000-\u007F]/g;
	    function escapeNonAsciiString(s, quoteChar) {
	        s = escapeString(s, quoteChar);
	        // Replace non-ASCII characters with '\uNNNN' escapes if any exist.
	        // Otherwise just return the original string.
	        return nonAsciiCharacters.test(s) ?
	            s.replace(nonAsciiCharacters, function (c) { return get16BitUnicodeEscapeSequence(c.charCodeAt(0)); }) :
	            s;
	    }
	    ts.escapeNonAsciiString = escapeNonAsciiString;
	    var indentStrings = ["", "    "];
	    function getIndentString(level) {
	        if (indentStrings[level] === undefined) {
	            indentStrings[level] = getIndentString(level - 1) + indentStrings[1];
	        }
	        return indentStrings[level];
	    }
	    ts.getIndentString = getIndentString;
	    function getIndentSize() {
	        return indentStrings[1].length;
	    }
	    ts.getIndentSize = getIndentSize;
	    function createTextWriter(newLine) {
	        var output;
	        var indent;
	        var lineStart;
	        var lineCount;
	        var linePos;
	        function write(s) {
	            if (s && s.length) {
	                if (lineStart) {
	                    output += getIndentString(indent);
	                    lineStart = false;
	                }
	                output += s;
	            }
	        }
	        function reset() {
	            output = "";
	            indent = 0;
	            lineStart = true;
	            lineCount = 0;
	            linePos = 0;
	        }
	        function rawWrite(s) {
	            if (s !== undefined) {
	                if (lineStart) {
	                    lineStart = false;
	                }
	                output += s;
	            }
	        }
	        function writeLiteral(s) {
	            if (s && s.length) {
	                write(s);
	                var lineStartsOfS = ts.computeLineStarts(s);
	                if (lineStartsOfS.length > 1) {
	                    lineCount = lineCount + lineStartsOfS.length - 1;
	                    linePos = output.length - s.length + ts.lastOrUndefined(lineStartsOfS);
	                }
	            }
	        }
	        function writeLine() {
	            if (!lineStart) {
	                output += newLine;
	                lineCount++;
	                linePos = output.length;
	                lineStart = true;
	            }
	        }
	        function writeTextOfNode(text, node) {
	            write(getTextOfNodeFromSourceText(text, node));
	        }
	        reset();
	        return {
	            write: write,
	            rawWrite: rawWrite,
	            writeTextOfNode: writeTextOfNode,
	            writeLiteral: writeLiteral,
	            writeLine: writeLine,
	            increaseIndent: function () { indent++; },
	            decreaseIndent: function () { indent--; },
	            getIndent: function () { return indent; },
	            getTextPos: function () { return output.length; },
	            getLine: function () { return lineCount + 1; },
	            getColumn: function () { return lineStart ? indent * getIndentSize() + 1 : output.length - linePos + 1; },
	            getText: function () { return output; },
	            isAtStartOfLine: function () { return lineStart; },
	            clear: reset,
	            reportInaccessibleThisError: ts.noop,
	            reportPrivateInBaseOfClassExpression: ts.noop,
	            reportInaccessibleUniqueSymbolError: ts.noop,
	            trackSymbol: ts.noop,
	            writeKeyword: write,
	            writeOperator: write,
	            writeParameter: write,
	            writeProperty: write,
	            writePunctuation: write,
	            writeSpace: write,
	            writeStringLiteral: write,
	            writeSymbol: write
	        };
	    }
	    ts.createTextWriter = createTextWriter;
	    function getResolvedExternalModuleName(host, file) {
	        return file.moduleName || getExternalModuleNameFromPath(host, file.fileName);
	    }
	    ts.getResolvedExternalModuleName = getResolvedExternalModuleName;
	    function getExternalModuleNameFromDeclaration(host, resolver, declaration) {
	        var file = resolver.getExternalModuleFileFromDeclaration(declaration);
	        if (!file || file.isDeclarationFile) {
	            return undefined;
	        }
	        return getResolvedExternalModuleName(host, file);
	    }
	    ts.getExternalModuleNameFromDeclaration = getExternalModuleNameFromDeclaration;
	    /**
	     * Resolves a local path to a path which is absolute to the base of the emit
	     */
	    function getExternalModuleNameFromPath(host, fileName) {
	        var getCanonicalFileName = function (f) { return host.getCanonicalFileName(f); };
	        var dir = ts.toPath(host.getCommonSourceDirectory(), host.getCurrentDirectory(), getCanonicalFileName);
	        var filePath = ts.getNormalizedAbsolutePath(fileName, host.getCurrentDirectory());
	        var relativePath = ts.getRelativePathToDirectoryOrUrl(dir, filePath, dir, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
	        return ts.removeFileExtension(relativePath);
	    }
	    ts.getExternalModuleNameFromPath = getExternalModuleNameFromPath;
	    function getOwnEmitOutputFilePath(sourceFile, host, extension) {
	        var compilerOptions = host.getCompilerOptions();
	        var emitOutputFilePathWithoutExtension;
	        if (compilerOptions.outDir) {
	            emitOutputFilePathWithoutExtension = ts.removeFileExtension(getSourceFilePathInNewDir(sourceFile, host, compilerOptions.outDir));
	        }
	        else {
	            emitOutputFilePathWithoutExtension = ts.removeFileExtension(sourceFile.fileName);
	        }
	        return emitOutputFilePathWithoutExtension + extension;
	    }
	    ts.getOwnEmitOutputFilePath = getOwnEmitOutputFilePath;
	    function getDeclarationEmitOutputFilePath(sourceFile, host) {
	        var options = host.getCompilerOptions();
	        var outputDir = options.declarationDir || options.outDir; // Prefer declaration folder if specified
	        var path = outputDir
	            ? getSourceFilePathInNewDir(sourceFile, host, outputDir)
	            : sourceFile.fileName;
	        return ts.removeFileExtension(path) + ".d.ts" /* Dts */;
	    }
	    ts.getDeclarationEmitOutputFilePath = getDeclarationEmitOutputFilePath;
	    /**
	     * Gets the source files that are expected to have an emit output.
	     *
	     * Originally part of `forEachExpectedEmitFile`, this functionality was extracted to support
	     * transformations.
	     *
	     * @param host An EmitHost.
	     * @param targetSourceFile An optional target source file to emit.
	     */
	    function getSourceFilesToEmit(host, targetSourceFile) {
	        var options = host.getCompilerOptions();
	        var isSourceFileFromExternalLibrary = function (file) { return host.isSourceFileFromExternalLibrary(file); };
	        if (options.outFile || options.out) {
	            var moduleKind = ts.getEmitModuleKind(options);
	            var moduleEmitEnabled_1 = moduleKind === ts.ModuleKind.AMD || moduleKind === ts.ModuleKind.System;
	            // Can emit only sources that are not declaration file and are either non module code or module with --module or --target es6 specified
	            return ts.filter(host.getSourceFiles(), function (sourceFile) {
	                return (moduleEmitEnabled_1 || !ts.isExternalModule(sourceFile)) && sourceFileMayBeEmitted(sourceFile, options, isSourceFileFromExternalLibrary);
	            });
	        }
	        else {
	            var sourceFiles = targetSourceFile === undefined ? host.getSourceFiles() : [targetSourceFile];
	            return ts.filter(sourceFiles, function (sourceFile) { return sourceFileMayBeEmitted(sourceFile, options, isSourceFileFromExternalLibrary); });
	        }
	    }
	    ts.getSourceFilesToEmit = getSourceFilesToEmit;
	    /** Don't call this for `--outFile`, just for `--outDir` or plain emit. `--outFile` needs additional checks. */
	    function sourceFileMayBeEmitted(sourceFile, options, isSourceFileFromExternalLibrary) {
	        return !(options.noEmitForJsFiles && isSourceFileJavaScript(sourceFile)) && !sourceFile.isDeclarationFile && !isSourceFileFromExternalLibrary(sourceFile);
	    }
	    ts.sourceFileMayBeEmitted = sourceFileMayBeEmitted;
	    function getSourceFilePathInNewDir(sourceFile, host, newDirPath) {
	        var sourceFilePath = ts.getNormalizedAbsolutePath(sourceFile.fileName, host.getCurrentDirectory());
	        var commonSourceDirectory = host.getCommonSourceDirectory();
	        var isSourceFileInCommonSourceDirectory = host.getCanonicalFileName(sourceFilePath).indexOf(host.getCanonicalFileName(commonSourceDirectory)) === 0;
	        sourceFilePath = isSourceFileInCommonSourceDirectory ? sourceFilePath.substring(commonSourceDirectory.length) : sourceFilePath;
	        return ts.combinePaths(newDirPath, sourceFilePath);
	    }
	    ts.getSourceFilePathInNewDir = getSourceFilePathInNewDir;
	    function writeFile(host, diagnostics, fileName, data, writeByteOrderMark, sourceFiles) {
	        host.writeFile(fileName, data, writeByteOrderMark, function (hostErrorMessage) {
	            diagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.Could_not_write_file_0_Colon_1, fileName, hostErrorMessage));
	        }, sourceFiles);
	    }
	    ts.writeFile = writeFile;
	    function getLineOfLocalPosition(currentSourceFile, pos) {
	        return ts.getLineAndCharacterOfPosition(currentSourceFile, pos).line;
	    }
	    ts.getLineOfLocalPosition = getLineOfLocalPosition;
	    function getLineOfLocalPositionFromLineMap(lineMap, pos) {
	        return ts.computeLineAndCharacterOfPosition(lineMap, pos).line;
	    }
	    ts.getLineOfLocalPositionFromLineMap = getLineOfLocalPositionFromLineMap;
	    function getFirstConstructorWithBody(node) {
	        return ts.forEach(node.members, function (member) {
	            if (member.kind === 154 /* Constructor */ && nodeIsPresent(member.body)) {
	                return member;
	            }
	        });
	    }
	    ts.getFirstConstructorWithBody = getFirstConstructorWithBody;
	    function getSetAccessorValueParameter(accessor) {
	        if (accessor && accessor.parameters.length > 0) {
	            var hasThis = accessor.parameters.length === 2 && parameterIsThisKeyword(accessor.parameters[0]);
	            return accessor.parameters[hasThis ? 1 : 0];
	        }
	    }
	    /** Get the type annotation for the value parameter. */
	    function getSetAccessorTypeAnnotationNode(accessor) {
	        var parameter = getSetAccessorValueParameter(accessor);
	        return parameter && parameter.type;
	    }
	    ts.getSetAccessorTypeAnnotationNode = getSetAccessorTypeAnnotationNode;
	    function getThisParameter(signature) {
	        if (signature.parameters.length) {
	            var thisParameter = signature.parameters[0];
	            if (parameterIsThisKeyword(thisParameter)) {
	                return thisParameter;
	            }
	        }
	    }
	    ts.getThisParameter = getThisParameter;
	    function parameterIsThisKeyword(parameter) {
	        return isThisIdentifier(parameter.name);
	    }
	    ts.parameterIsThisKeyword = parameterIsThisKeyword;
	    function isThisIdentifier(node) {
	        return node && node.kind === 71 /* Identifier */ && identifierIsThisKeyword(node);
	    }
	    ts.isThisIdentifier = isThisIdentifier;
	    function identifierIsThisKeyword(id) {
	        return id.originalKeywordKind === 99 /* ThisKeyword */;
	    }
	    ts.identifierIsThisKeyword = identifierIsThisKeyword;
	    function getAllAccessorDeclarations(declarations, accessor) {
	        var firstAccessor;
	        var secondAccessor;
	        var getAccessor;
	        var setAccessor;
	        if (hasDynamicName(accessor)) {
	            firstAccessor = accessor;
	            if (accessor.kind === 155 /* GetAccessor */) {
	                getAccessor = accessor;
	            }
	            else if (accessor.kind === 156 /* SetAccessor */) {
	                setAccessor = accessor;
	            }
	            else {
	                ts.Debug.fail("Accessor has wrong kind");
	            }
	        }
	        else {
	            ts.forEach(declarations, function (member) {
	                if ((member.kind === 155 /* GetAccessor */ || member.kind === 156 /* SetAccessor */)
	                    && hasModifier(member, 32 /* Static */) === hasModifier(accessor, 32 /* Static */)) {
	                    var memberName = getPropertyNameForPropertyNameNode(member.name);
	                    var accessorName = getPropertyNameForPropertyNameNode(accessor.name);
	                    if (memberName === accessorName) {
	                        if (!firstAccessor) {
	                            firstAccessor = member;
	                        }
	                        else if (!secondAccessor) {
	                            secondAccessor = member;
	                        }
	                        if (member.kind === 155 /* GetAccessor */ && !getAccessor) {
	                            getAccessor = member;
	                        }
	                        if (member.kind === 156 /* SetAccessor */ && !setAccessor) {
	                            setAccessor = member;
	                        }
	                    }
	                }
	            });
	        }
	        return {
	            firstAccessor: firstAccessor,
	            secondAccessor: secondAccessor,
	            getAccessor: getAccessor,
	            setAccessor: setAccessor
	        };
	    }
	    ts.getAllAccessorDeclarations = getAllAccessorDeclarations;
	    /**
	     * Gets the effective type annotation of a variable, parameter, or property. If the node was
	     * parsed in a JavaScript file, gets the type annotation from JSDoc.
	     */
	    function getEffectiveTypeAnnotationNode(node, checkJSDoc) {
	        if (ts.hasType(node)) {
	            return node.type;
	        }
	        if (checkJSDoc || isInJavaScriptFile(node)) {
	            return ts.getJSDocType(node);
	        }
	    }
	    ts.getEffectiveTypeAnnotationNode = getEffectiveTypeAnnotationNode;
	    /**
	     * Gets the effective return type annotation of a signature. If the node was parsed in a
	     * JavaScript file, gets the return type annotation from JSDoc.
	     */
	    function getEffectiveReturnTypeNode(node, checkJSDoc) {
	        if (node.type) {
	            return node.type;
	        }
	        if (checkJSDoc || isInJavaScriptFile(node)) {
	            return ts.getJSDocReturnType(node);
	        }
	    }
	    ts.getEffectiveReturnTypeNode = getEffectiveReturnTypeNode;
	    /**
	     * Gets the effective type parameters. If the node was parsed in a
	     * JavaScript file, gets the type parameters from the `@template` tag from JSDoc.
	     */
	    function getEffectiveTypeParameterDeclarations(node, checkJSDoc) {
	        if (node.typeParameters) {
	            return node.typeParameters;
	        }
	        if (checkJSDoc || isInJavaScriptFile(node)) {
	            var templateTag = ts.getJSDocTemplateTag(node);
	            return templateTag && templateTag.typeParameters;
	        }
	    }
	    ts.getEffectiveTypeParameterDeclarations = getEffectiveTypeParameterDeclarations;
	    /**
	     * Gets the effective type annotation of the value parameter of a set accessor. If the node
	     * was parsed in a JavaScript file, gets the type annotation from JSDoc.
	     */
	    function getEffectiveSetAccessorTypeAnnotationNode(node, checkJSDoc) {
	        var parameter = getSetAccessorValueParameter(node);
	        return parameter && getEffectiveTypeAnnotationNode(parameter, checkJSDoc);
	    }
	    ts.getEffectiveSetAccessorTypeAnnotationNode = getEffectiveSetAccessorTypeAnnotationNode;
	    function emitNewLineBeforeLeadingComments(lineMap, writer, node, leadingComments) {
	        emitNewLineBeforeLeadingCommentsOfPosition(lineMap, writer, node.pos, leadingComments);
	    }
	    ts.emitNewLineBeforeLeadingComments = emitNewLineBeforeLeadingComments;
	    function emitNewLineBeforeLeadingCommentsOfPosition(lineMap, writer, pos, leadingComments) {
	        // If the leading comments start on different line than the start of node, write new line
	        if (leadingComments && leadingComments.length && pos !== leadingComments[0].pos &&
	            getLineOfLocalPositionFromLineMap(lineMap, pos) !== getLineOfLocalPositionFromLineMap(lineMap, leadingComments[0].pos)) {
	            writer.writeLine();
	        }
	    }
	    ts.emitNewLineBeforeLeadingCommentsOfPosition = emitNewLineBeforeLeadingCommentsOfPosition;
	    function emitNewLineBeforeLeadingCommentOfPosition(lineMap, writer, pos, commentPos) {
	        // If the leading comments start on different line than the start of node, write new line
	        if (pos !== commentPos &&
	            getLineOfLocalPositionFromLineMap(lineMap, pos) !== getLineOfLocalPositionFromLineMap(lineMap, commentPos)) {
	            writer.writeLine();
	        }
	    }
	    ts.emitNewLineBeforeLeadingCommentOfPosition = emitNewLineBeforeLeadingCommentOfPosition;
	    function emitComments(text, lineMap, writer, comments, leadingSeparator, trailingSeparator, newLine, writeComment) {
	        if (comments && comments.length > 0) {
	            if (leadingSeparator) {
	                writer.write(" ");
	            }
	            var emitInterveningSeparator = false;
	            for (var _i = 0, comments_1 = comments; _i < comments_1.length; _i++) {
	                var comment = comments_1[_i];
	                if (emitInterveningSeparator) {
	                    writer.write(" ");
	                    emitInterveningSeparator = false;
	                }
	                writeComment(text, lineMap, writer, comment.pos, comment.end, newLine);
	                if (comment.hasTrailingNewLine) {
	                    writer.writeLine();
	                }
	                else {
	                    emitInterveningSeparator = true;
	                }
	            }
	            if (emitInterveningSeparator && trailingSeparator) {
	                writer.write(" ");
	            }
	        }
	    }
	    ts.emitComments = emitComments;
	    /**
	     * Detached comment is a comment at the top of file or function body that is separated from
	     * the next statement by space.
	     */
	    function emitDetachedComments(text, lineMap, writer, writeComment, node, newLine, removeComments) {
	        var leadingComments;
	        var currentDetachedCommentInfo;
	        if (removeComments) {
	            // removeComments is true, only reserve pinned comment at the top of file
	            // For example:
	            //      /*! Pinned Comment */
	            //
	            //      var x = 10;
	            if (node.pos === 0) {
	                leadingComments = ts.filter(ts.getLeadingCommentRanges(text, node.pos), isPinnedCommentLocal);
	            }
	        }
	        else {
	            // removeComments is false, just get detached as normal and bypass the process to filter comment
	            leadingComments = ts.getLeadingCommentRanges(text, node.pos);
	        }
	        if (leadingComments) {
	            var detachedComments = [];
	            var lastComment = void 0;
	            for (var _i = 0, leadingComments_1 = leadingComments; _i < leadingComments_1.length; _i++) {
	                var comment = leadingComments_1[_i];
	                if (lastComment) {
	                    var lastCommentLine = getLineOfLocalPositionFromLineMap(lineMap, lastComment.end);
	                    var commentLine = getLineOfLocalPositionFromLineMap(lineMap, comment.pos);
	                    if (commentLine >= lastCommentLine + 2) {
	                        // There was a blank line between the last comment and this comment.  This
	                        // comment is not part of the copyright comments.  Return what we have so
	                        // far.
	                        break;
	                    }
	                }
	                detachedComments.push(comment);
	                lastComment = comment;
	            }
	            if (detachedComments.length) {
	                // All comments look like they could have been part of the copyright header.  Make
	                // sure there is at least one blank line between it and the node.  If not, it's not
	                // a copyright header.
	                var lastCommentLine = getLineOfLocalPositionFromLineMap(lineMap, ts.lastOrUndefined(detachedComments).end);
	                var nodeLine = getLineOfLocalPositionFromLineMap(lineMap, ts.skipTrivia(text, node.pos));
	                if (nodeLine >= lastCommentLine + 2) {
	                    // Valid detachedComments
	                    emitNewLineBeforeLeadingComments(lineMap, writer, node, leadingComments);
	                    emitComments(text, lineMap, writer, detachedComments, /*leadingSeparator*/ false, /*trailingSeparator*/ true, newLine, writeComment);
	                    currentDetachedCommentInfo = { nodePos: node.pos, detachedCommentEndPos: ts.lastOrUndefined(detachedComments).end };
	                }
	            }
	        }
	        return currentDetachedCommentInfo;
	        function isPinnedCommentLocal(comment) {
	            return isPinnedComment(text, comment);
	        }
	    }
	    ts.emitDetachedComments = emitDetachedComments;
	    function writeCommentRange(text, lineMap, writer, commentPos, commentEnd, newLine) {
	        if (text.charCodeAt(commentPos + 1) === 42 /* asterisk */) {
	            var firstCommentLineAndCharacter = ts.computeLineAndCharacterOfPosition(lineMap, commentPos);
	            var lineCount = lineMap.length;
	            var firstCommentLineIndent = void 0;
	            for (var pos = commentPos, currentLine = firstCommentLineAndCharacter.line; pos < commentEnd; currentLine++) {
	                var nextLineStart = (currentLine + 1) === lineCount
	                    ? text.length + 1
	                    : lineMap[currentLine + 1];
	                if (pos !== commentPos) {
	                    // If we are not emitting first line, we need to write the spaces to adjust the alignment
	                    if (firstCommentLineIndent === undefined) {
	                        firstCommentLineIndent = calculateIndent(text, lineMap[firstCommentLineAndCharacter.line], commentPos);
	                    }
	                    // These are number of spaces writer is going to write at current indent
	                    var currentWriterIndentSpacing = writer.getIndent() * getIndentSize();
	                    // Number of spaces we want to be writing
	                    // eg: Assume writer indent
	                    // module m {
	                    //         /* starts at character 9 this is line 1
	                    //    * starts at character pos 4 line                        --1  = 8 - 8 + 3
	                    //   More left indented comment */                            --2  = 8 - 8 + 2
	                    //     class c { }
	                    // }
	                    // module m {
	                    //     /* this is line 1 -- Assume current writer indent 8
	                    //      * line                                                --3 = 8 - 4 + 5
	                    //            More right indented comment */                  --4 = 8 - 4 + 11
	                    //     class c { }
	                    // }
	                    var spacesToEmit = currentWriterIndentSpacing - firstCommentLineIndent + calculateIndent(text, pos, nextLineStart);
	                    if (spacesToEmit > 0) {
	                        var numberOfSingleSpacesToEmit = spacesToEmit % getIndentSize();
	                        var indentSizeSpaceString = getIndentString((spacesToEmit - numberOfSingleSpacesToEmit) / getIndentSize());
	                        // Write indent size string ( in eg 1: = "", 2: "" , 3: string with 8 spaces 4: string with 12 spaces
	                        writer.rawWrite(indentSizeSpaceString);
	                        // Emit the single spaces (in eg: 1: 3 spaces, 2: 2 spaces, 3: 1 space, 4: 3 spaces)
	                        while (numberOfSingleSpacesToEmit) {
	                            writer.rawWrite(" ");
	                            numberOfSingleSpacesToEmit--;
	                        }
	                    }
	                    else {
	                        // No spaces to emit write empty string
	                        writer.rawWrite("");
	                    }
	                }
	                // Write the comment line text
	                writeTrimmedCurrentLine(text, commentEnd, writer, newLine, pos, nextLineStart);
	                pos = nextLineStart;
	            }
	        }
	        else {
	            // Single line comment of style //....
	            writer.write(text.substring(commentPos, commentEnd));
	        }
	    }
	    ts.writeCommentRange = writeCommentRange;
	    function writeTrimmedCurrentLine(text, commentEnd, writer, newLine, pos, nextLineStart) {
	        var end = Math.min(commentEnd, nextLineStart - 1);
	        var currentLineText = text.substring(pos, end).replace(/^\s+|\s+$/g, "");
	        if (currentLineText) {
	            // trimmed forward and ending spaces text
	            writer.write(currentLineText);
	            if (end !== commentEnd) {
	                writer.writeLine();
	            }
	        }
	        else {
	            // Empty string - make sure we write empty line
	            writer.writeLiteral(newLine);
	        }
	    }
	    function calculateIndent(text, pos, end) {
	        var currentLineIndent = 0;
	        for (; pos < end && ts.isWhiteSpaceSingleLine(text.charCodeAt(pos)); pos++) {
	            if (text.charCodeAt(pos) === 9 /* tab */) {
	                // Tabs = TabSize = indent size and go to next tabStop
	                currentLineIndent += getIndentSize() - (currentLineIndent % getIndentSize());
	            }
	            else {
	                // Single space
	                currentLineIndent++;
	            }
	        }
	        return currentLineIndent;
	    }
	    function hasModifiers(node) {
	        return getModifierFlags(node) !== 0 /* None */;
	    }
	    ts.hasModifiers = hasModifiers;
	    function hasModifier(node, flags) {
	        return !!getSelectedModifierFlags(node, flags);
	    }
	    ts.hasModifier = hasModifier;
	    function hasStaticModifier(node) {
	        return hasModifier(node, 32 /* Static */);
	    }
	    ts.hasStaticModifier = hasStaticModifier;
	    function hasReadonlyModifier(node) {
	        return hasModifier(node, 64 /* Readonly */);
	    }
	    ts.hasReadonlyModifier = hasReadonlyModifier;
	    function getSelectedModifierFlags(node, flags) {
	        return getModifierFlags(node) & flags;
	    }
	    ts.getSelectedModifierFlags = getSelectedModifierFlags;
	    function getModifierFlags(node) {
	        if (node.modifierFlagsCache & 536870912 /* HasComputedFlags */) {
	            return node.modifierFlagsCache & ~536870912 /* HasComputedFlags */;
	        }
	        var flags = getModifierFlagsNoCache(node);
	        node.modifierFlagsCache = flags | 536870912 /* HasComputedFlags */;
	        return flags;
	    }
	    ts.getModifierFlags = getModifierFlags;
	    function getModifierFlagsNoCache(node) {
	        var flags = 0 /* None */;
	        if (node.modifiers) {
	            for (var _i = 0, _a = node.modifiers; _i < _a.length; _i++) {
	                var modifier = _a[_i];
	                flags |= modifierToFlag(modifier.kind);
	            }
	        }
	        if (node.flags & 4 /* NestedNamespace */ || (node.kind === 71 /* Identifier */ && node.isInJSDocNamespace)) {
	            flags |= 1 /* Export */;
	        }
	        return flags;
	    }
	    ts.getModifierFlagsNoCache = getModifierFlagsNoCache;
	    function modifierToFlag(token) {
	        switch (token) {
	            case 115 /* StaticKeyword */: return 32 /* Static */;
	            case 114 /* PublicKeyword */: return 4 /* Public */;
	            case 113 /* ProtectedKeyword */: return 16 /* Protected */;
	            case 112 /* PrivateKeyword */: return 8 /* Private */;
	            case 117 /* AbstractKeyword */: return 128 /* Abstract */;
	            case 84 /* ExportKeyword */: return 1 /* Export */;
	            case 124 /* DeclareKeyword */: return 2 /* Ambient */;
	            case 76 /* ConstKeyword */: return 2048 /* Const */;
	            case 79 /* DefaultKeyword */: return 512 /* Default */;
	            case 120 /* AsyncKeyword */: return 256 /* Async */;
	            case 132 /* ReadonlyKeyword */: return 64 /* Readonly */;
	        }
	        return 0 /* None */;
	    }
	    ts.modifierToFlag = modifierToFlag;
	    function isLogicalOperator(token) {
	        return token === 54 /* BarBarToken */
	            || token === 53 /* AmpersandAmpersandToken */
	            || token === 51 /* ExclamationToken */;
	    }
	    ts.isLogicalOperator = isLogicalOperator;
	    function isAssignmentOperator(token) {
	        return token >= 58 /* FirstAssignment */ && token <= 70 /* LastAssignment */;
	    }
	    ts.isAssignmentOperator = isAssignmentOperator;
	    /** Get `C` given `N` if `N` is in the position `class C extends N` where `N` is an ExpressionWithTypeArguments. */
	    function tryGetClassExtendingExpressionWithTypeArguments(node) {
	        if (node.kind === 205 /* ExpressionWithTypeArguments */ &&
	            node.parent.token === 85 /* ExtendsKeyword */ &&
	            ts.isClassLike(node.parent.parent)) {
	            return node.parent.parent;
	        }
	    }
	    ts.tryGetClassExtendingExpressionWithTypeArguments = tryGetClassExtendingExpressionWithTypeArguments;
	    function isAssignmentExpression(node, excludeCompoundAssignment) {
	        return ts.isBinaryExpression(node)
	            && (excludeCompoundAssignment
	                ? node.operatorToken.kind === 58 /* EqualsToken */
	                : isAssignmentOperator(node.operatorToken.kind))
	            && ts.isLeftHandSideExpression(node.left);
	    }
	    ts.isAssignmentExpression = isAssignmentExpression;
	    function isDestructuringAssignment(node) {
	        if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
	            var kind = node.left.kind;
	            return kind === 182 /* ObjectLiteralExpression */
	                || kind === 181 /* ArrayLiteralExpression */;
	        }
	        return false;
	    }
	    ts.isDestructuringAssignment = isDestructuringAssignment;
	    function isExpressionWithTypeArgumentsInClassExtendsClause(node) {
	        return tryGetClassExtendingExpressionWithTypeArguments(node) !== undefined;
	    }
	    ts.isExpressionWithTypeArgumentsInClassExtendsClause = isExpressionWithTypeArgumentsInClassExtendsClause;
	    function isExpressionWithTypeArgumentsInClassImplementsClause(node) {
	        return node.kind === 205 /* ExpressionWithTypeArguments */
	            && isEntityNameExpression(node.expression)
	            && node.parent
	            && node.parent.token === 108 /* ImplementsKeyword */
	            && node.parent.parent
	            && ts.isClassLike(node.parent.parent);
	    }
	    ts.isExpressionWithTypeArgumentsInClassImplementsClause = isExpressionWithTypeArgumentsInClassImplementsClause;
	    function isEntityNameExpression(node) {
	        return node.kind === 71 /* Identifier */ ||
	            node.kind === 183 /* PropertyAccessExpression */ && isEntityNameExpression(node.expression);
	    }
	    ts.isEntityNameExpression = isEntityNameExpression;
	    function isRightSideOfQualifiedNameOrPropertyAccess(node) {
	        return (node.parent.kind === 145 /* QualifiedName */ && node.parent.right === node) ||
	            (node.parent.kind === 183 /* PropertyAccessExpression */ && node.parent.name === node);
	    }
	    ts.isRightSideOfQualifiedNameOrPropertyAccess = isRightSideOfQualifiedNameOrPropertyAccess;
	    function isEmptyObjectLiteral(expression) {
	        return expression.kind === 182 /* ObjectLiteralExpression */ &&
	            expression.properties.length === 0;
	    }
	    ts.isEmptyObjectLiteral = isEmptyObjectLiteral;
	    function isEmptyArrayLiteral(expression) {
	        return expression.kind === 181 /* ArrayLiteralExpression */ &&
	            expression.elements.length === 0;
	    }
	    ts.isEmptyArrayLiteral = isEmptyArrayLiteral;
	    function getLocalSymbolForExportDefault(symbol) {
	        return isExportDefaultSymbol(symbol) ? symbol.declarations[0].localSymbol : undefined;
	    }
	    ts.getLocalSymbolForExportDefault = getLocalSymbolForExportDefault;
	    function isExportDefaultSymbol(symbol) {
	        return symbol && ts.length(symbol.declarations) > 0 && hasModifier(symbol.declarations[0], 512 /* Default */);
	    }
	    /** Return ".ts", ".d.ts", or ".tsx", if that is the extension. */
	    function tryExtractTypeScriptExtension(fileName) {
	        return ts.find(ts.supportedTypescriptExtensionsForExtractExtension, function (extension) { return ts.fileExtensionIs(fileName, extension); });
	    }
	    ts.tryExtractTypeScriptExtension = tryExtractTypeScriptExtension;
	    /**
	     * Replace each instance of non-ascii characters by one, two, three, or four escape sequences
	     * representing the UTF-8 encoding of the character, and return the expanded char code list.
	     */
	    function getExpandedCharCodes(input) {
	        var output = [];
	        var length = input.length;
	        for (var i = 0; i < length; i++) {
	            var charCode = input.charCodeAt(i);
	            // handel utf8
	            if (charCode < 0x80) {
	                output.push(charCode);
	            }
	            else if (charCode < 0x800) {
	                output.push((charCode >> 6) | 192);
	                output.push((charCode & 63) | 128);
	            }
	            else if (charCode < 0x10000) {
	                output.push((charCode >> 12) | 224);
	                output.push(((charCode >> 6) & 63) | 128);
	                output.push((charCode & 63) | 128);
	            }
	            else if (charCode < 0x20000) {
	                output.push((charCode >> 18) | 240);
	                output.push(((charCode >> 12) & 63) | 128);
	                output.push(((charCode >> 6) & 63) | 128);
	                output.push((charCode & 63) | 128);
	            }
	            else {
	                ts.Debug.assert(false, "Unexpected code point");
	            }
	        }
	        return output;
	    }
	    var base64Digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	    /**
	     * Converts a string to a base-64 encoded ASCII string.
	     */
	    function convertToBase64(input) {
	        var result = "";
	        var charCodes = getExpandedCharCodes(input);
	        var i = 0;
	        var length = charCodes.length;
	        var byte1, byte2, byte3, byte4;
	        while (i < length) {
	            // Convert every 6-bits in the input 3 character points
	            // into a base64 digit
	            byte1 = charCodes[i] >> 2;
	            byte2 = (charCodes[i] & 3) << 4 | charCodes[i + 1] >> 4;
	            byte3 = (charCodes[i + 1] & 15) << 2 | charCodes[i + 2] >> 6;
	            byte4 = charCodes[i + 2] & 63;
	            // We are out of characters in the input, set the extra
	            // digits to 64 (padding character).
	            if (i + 1 >= length) {
	                byte3 = byte4 = 64;
	            }
	            else if (i + 2 >= length) {
	                byte4 = 64;
	            }
	            // Write to the output
	            result += base64Digits.charAt(byte1) + base64Digits.charAt(byte2) + base64Digits.charAt(byte3) + base64Digits.charAt(byte4);
	            i += 3;
	        }
	        return result;
	    }
	    ts.convertToBase64 = convertToBase64;
	    var carriageReturnLineFeed = "\r\n";
	    var lineFeed = "\n";
	    function getNewLineCharacter(options, getNewLine) {
	        switch (options.newLine) {
	            case 0 /* CarriageReturnLineFeed */:
	                return carriageReturnLineFeed;
	            case 1 /* LineFeed */:
	                return lineFeed;
	        }
	        return getNewLine ? getNewLine() : ts.sys ? ts.sys.newLine : carriageReturnLineFeed;
	    }
	    ts.getNewLineCharacter = getNewLineCharacter;
	    /**
	     * Formats an enum value as a string for debugging and debug assertions.
	     */
	    function formatEnum(value, enumObject, isFlags) {
	        if (value === void 0) { value = 0; }
	        var members = getEnumMembers(enumObject);
	        if (value === 0) {
	            return members.length > 0 && members[0][0] === 0 ? members[0][1] : "0";
	        }
	        if (isFlags) {
	            var result = "";
	            var remainingFlags = value;
	            for (var i = members.length - 1; i >= 0 && remainingFlags !== 0; i--) {
	                var _a = members[i], enumValue = _a[0], enumName = _a[1];
	                if (enumValue !== 0 && (remainingFlags & enumValue) === enumValue) {
	                    remainingFlags &= ~enumValue;
	                    result = "" + enumName + (result ? ", " : "") + result;
	                }
	            }
	            if (remainingFlags === 0) {
	                return result;
	            }
	        }
	        else {
	            for (var _i = 0, members_1 = members; _i < members_1.length; _i++) {
	                var _b = members_1[_i], enumValue = _b[0], enumName = _b[1];
	                if (enumValue === value) {
	                    return enumName;
	                }
	            }
	        }
	        return value.toString();
	    }
	    function getEnumMembers(enumObject) {
	        var result = [];
	        for (var name in enumObject) {
	            var value = enumObject[name];
	            if (typeof value === "number") {
	                result.push([value, name]);
	            }
	        }
	        return ts.stableSort(result, function (x, y) { return ts.compareValues(x[0], y[0]); });
	    }
	    function formatSyntaxKind(kind) {
	        return formatEnum(kind, ts.SyntaxKind, /*isFlags*/ false);
	    }
	    ts.formatSyntaxKind = formatSyntaxKind;
	    function formatModifierFlags(flags) {
	        return formatEnum(flags, ts.ModifierFlags, /*isFlags*/ true);
	    }
	    ts.formatModifierFlags = formatModifierFlags;
	    function formatTransformFlags(flags) {
	        return formatEnum(flags, ts.TransformFlags, /*isFlags*/ true);
	    }
	    ts.formatTransformFlags = formatTransformFlags;
	    function formatEmitFlags(flags) {
	        return formatEnum(flags, ts.EmitFlags, /*isFlags*/ true);
	    }
	    ts.formatEmitFlags = formatEmitFlags;
	    function formatSymbolFlags(flags) {
	        return formatEnum(flags, ts.SymbolFlags, /*isFlags*/ true);
	    }
	    ts.formatSymbolFlags = formatSymbolFlags;
	    function formatTypeFlags(flags) {
	        return formatEnum(flags, ts.TypeFlags, /*isFlags*/ true);
	    }
	    ts.formatTypeFlags = formatTypeFlags;
	    function formatObjectFlags(flags) {
	        return formatEnum(flags, ts.ObjectFlags, /*isFlags*/ true);
	    }
	    ts.formatObjectFlags = formatObjectFlags;
	    /**
	     * Creates a new TextRange from the provided pos and end.
	     *
	     * @param pos The start position.
	     * @param end The end position.
	     */
	    function createRange(pos, end) {
	        return { pos: pos, end: end };
	    }
	    ts.createRange = createRange;
	    /**
	     * Creates a new TextRange from a provided range with a new end position.
	     *
	     * @param range A TextRange.
	     * @param end The new end position.
	     */
	    function moveRangeEnd(range, end) {
	        return createRange(range.pos, end);
	    }
	    ts.moveRangeEnd = moveRangeEnd;
	    /**
	     * Creates a new TextRange from a provided range with a new start position.
	     *
	     * @param range A TextRange.
	     * @param pos The new Start position.
	     */
	    function moveRangePos(range, pos) {
	        return createRange(pos, range.end);
	    }
	    ts.moveRangePos = moveRangePos;
	    /**
	     * Moves the start position of a range past any decorators.
	     */
	    function moveRangePastDecorators(node) {
	        return node.decorators && node.decorators.length > 0
	            ? moveRangePos(node, node.decorators.end)
	            : node;
	    }
	    ts.moveRangePastDecorators = moveRangePastDecorators;
	    /**
	     * Moves the start position of a range past any decorators or modifiers.
	     */
	    function moveRangePastModifiers(node) {
	        return node.modifiers && node.modifiers.length > 0
	            ? moveRangePos(node, node.modifiers.end)
	            : moveRangePastDecorators(node);
	    }
	    ts.moveRangePastModifiers = moveRangePastModifiers;
	    /**
	     * Determines whether a TextRange has the same start and end positions.
	     *
	     * @param range A TextRange.
	     */
	    function isCollapsedRange(range) {
	        return range.pos === range.end;
	    }
	    ts.isCollapsedRange = isCollapsedRange;
	    /**
	     * Creates a new TextRange for a token at the provides start position.
	     *
	     * @param pos The start position.
	     * @param token The token.
	     */
	    function createTokenRange(pos, token) {
	        return createRange(pos, pos + ts.tokenToString(token).length);
	    }
	    ts.createTokenRange = createTokenRange;
	    function rangeIsOnSingleLine(range, sourceFile) {
	        return rangeStartIsOnSameLineAsRangeEnd(range, range, sourceFile);
	    }
	    ts.rangeIsOnSingleLine = rangeIsOnSingleLine;
	    function rangeStartPositionsAreOnSameLine(range1, range2, sourceFile) {
	        return positionsAreOnSameLine(getStartPositionOfRange(range1, sourceFile), getStartPositionOfRange(range2, sourceFile), sourceFile);
	    }
	    ts.rangeStartPositionsAreOnSameLine = rangeStartPositionsAreOnSameLine;
	    function rangeEndPositionsAreOnSameLine(range1, range2, sourceFile) {
	        return positionsAreOnSameLine(range1.end, range2.end, sourceFile);
	    }
	    ts.rangeEndPositionsAreOnSameLine = rangeEndPositionsAreOnSameLine;
	    function rangeStartIsOnSameLineAsRangeEnd(range1, range2, sourceFile) {
	        return positionsAreOnSameLine(getStartPositionOfRange(range1, sourceFile), range2.end, sourceFile);
	    }
	    ts.rangeStartIsOnSameLineAsRangeEnd = rangeStartIsOnSameLineAsRangeEnd;
	    function rangeEndIsOnSameLineAsRangeStart(range1, range2, sourceFile) {
	        return positionsAreOnSameLine(range1.end, getStartPositionOfRange(range2, sourceFile), sourceFile);
	    }
	    ts.rangeEndIsOnSameLineAsRangeStart = rangeEndIsOnSameLineAsRangeStart;
	    function positionsAreOnSameLine(pos1, pos2, sourceFile) {
	        return pos1 === pos2 ||
	            getLineOfLocalPosition(sourceFile, pos1) === getLineOfLocalPosition(sourceFile, pos2);
	    }
	    ts.positionsAreOnSameLine = positionsAreOnSameLine;
	    function getStartPositionOfRange(range, sourceFile) {
	        return ts.positionIsSynthesized(range.pos) ? -1 : ts.skipTrivia(sourceFile.text, range.pos);
	    }
	    ts.getStartPositionOfRange = getStartPositionOfRange;
	    /**
	     * Determines whether a name was originally the declaration name of an enum or namespace
	     * declaration.
	     */
	    function isDeclarationNameOfEnumOrNamespace(node) {
	        var parseNode = ts.getParseTreeNode(node);
	        if (parseNode) {
	            switch (parseNode.parent.kind) {
	                case 236 /* EnumDeclaration */:
	                case 237 /* ModuleDeclaration */:
	                    return parseNode === parseNode.parent.name;
	            }
	        }
	        return false;
	    }
	    ts.isDeclarationNameOfEnumOrNamespace = isDeclarationNameOfEnumOrNamespace;
	    function getInitializedVariables(node) {
	        return ts.filter(node.declarations, isInitializedVariable);
	    }
	    ts.getInitializedVariables = getInitializedVariables;
	    function isInitializedVariable(node) {
	        return node.initializer !== undefined;
	    }
	    function isWatchSet(options) {
	        // Firefox has Object.prototype.watch
	        return options.watch && options.hasOwnProperty("watch");
	    }
	    ts.isWatchSet = isWatchSet;
	    function getCheckFlags(symbol) {
	        return symbol.flags & 33554432 /* Transient */ ? symbol.checkFlags : 0;
	    }
	    ts.getCheckFlags = getCheckFlags;
	    function getDeclarationModifierFlagsFromSymbol(s) {
	        if (s.valueDeclaration) {
	            var flags = ts.getCombinedModifierFlags(s.valueDeclaration);
	            return s.parent && s.parent.flags & 32 /* Class */ ? flags : flags & ~28 /* AccessibilityModifier */;
	        }
	        if (getCheckFlags(s) & 6 /* Synthetic */) {
	            var checkFlags = s.checkFlags;
	            var accessModifier = checkFlags & 256 /* ContainsPrivate */ ? 8 /* Private */ :
	                checkFlags & 64 /* ContainsPublic */ ? 4 /* Public */ :
	                    16 /* Protected */;
	            var staticModifier = checkFlags & 512 /* ContainsStatic */ ? 32 /* Static */ : 0;
	            return accessModifier | staticModifier;
	        }
	        if (s.flags & 4194304 /* Prototype */) {
	            return 4 /* Public */ | 32 /* Static */;
	        }
	        return 0;
	    }
	    ts.getDeclarationModifierFlagsFromSymbol = getDeclarationModifierFlagsFromSymbol;
	    function skipAlias(symbol, checker) {
	        return symbol.flags & 2097152 /* Alias */ ? checker.getAliasedSymbol(symbol) : symbol;
	    }
	    ts.skipAlias = skipAlias;
	    /** See comment on `declareModuleMember` in `binder.ts`. */
	    function getCombinedLocalAndExportSymbolFlags(symbol) {
	        return symbol.exportSymbol ? symbol.exportSymbol.flags | symbol.flags : symbol.flags;
	    }
	    ts.getCombinedLocalAndExportSymbolFlags = getCombinedLocalAndExportSymbolFlags;
	    function isWriteOnlyAccess(node) {
	        return accessKind(node) === 1 /* Write */;
	    }
	    ts.isWriteOnlyAccess = isWriteOnlyAccess;
	    function isWriteAccess(node) {
	        return accessKind(node) !== 0 /* Read */;
	    }
	    ts.isWriteAccess = isWriteAccess;
	    var AccessKind;
	    (function (AccessKind) {
	        /** Only reads from a variable. */
	        AccessKind[AccessKind["Read"] = 0] = "Read";
	        /** Only writes to a variable without using the result. E.g.: `x++;`. */
	        AccessKind[AccessKind["Write"] = 1] = "Write";
	        /** Writes to a variable and uses the result as an expression. E.g.: `f(x++);`. */
	        AccessKind[AccessKind["ReadWrite"] = 2] = "ReadWrite";
	    })(AccessKind || (AccessKind = {}));
	    function accessKind(node) {
	        var parent = node.parent;
	        if (!parent)
	            return 0 /* Read */;
	        switch (parent.kind) {
	            case 197 /* PostfixUnaryExpression */:
	            case 196 /* PrefixUnaryExpression */:
	                var operator = parent.operator;
	                return operator === 43 /* PlusPlusToken */ || operator === 44 /* MinusMinusToken */ ? writeOrReadWrite() : 0 /* Read */;
	            case 198 /* BinaryExpression */:
	                var _a = parent, left = _a.left, operatorToken = _a.operatorToken;
	                return left === node && isAssignmentOperator(operatorToken.kind) ? writeOrReadWrite() : 0 /* Read */;
	            case 183 /* PropertyAccessExpression */:
	                return parent.name !== node ? 0 /* Read */ : accessKind(parent);
	            default:
	                return 0 /* Read */;
	        }
	        function writeOrReadWrite() {
	            // If grandparent is not an ExpressionStatement, this is used as an expression in addition to having a side effect.
	            return parent.parent && parent.parent.kind === 214 /* ExpressionStatement */ ? 1 /* Write */ : 2 /* ReadWrite */;
	        }
	    }
	    function compareDataObjects(dst, src) {
	        if (!dst || !src || Object.keys(dst).length !== Object.keys(src).length) {
	            return false;
	        }
	        for (var e in dst) {
	            if (typeof dst[e] === "object") {
	                if (!compareDataObjects(dst[e], src[e])) {
	                    return false;
	                }
	            }
	            else if (typeof dst[e] !== "function") {
	                if (dst[e] !== src[e]) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    }
	    ts.compareDataObjects = compareDataObjects;
	    /**
	     * clears already present map by calling onDeleteExistingValue callback before deleting that key/value
	     */
	    function clearMap(map, onDeleteValue) {
	        // Remove all
	        map.forEach(onDeleteValue);
	        map.clear();
	    }
	    ts.clearMap = clearMap;
	    /**
	     * Mutates the map with newMap such that keys in map will be same as newMap.
	     */
	    function mutateMap(map, newMap, options) {
	        var createNewValue = options.createNewValue, onDeleteValue = options.onDeleteValue, onExistingValue = options.onExistingValue;
	        // Needs update
	        map.forEach(function (existingValue, key) {
	            var valueInNewMap = newMap.get(key);
	            // Not present any more in new map, remove it
	            if (valueInNewMap === undefined) {
	                map.delete(key);
	                onDeleteValue(existingValue, key);
	            }
	            else if (onExistingValue) {
	                onExistingValue(existingValue, valueInNewMap, key);
	            }
	        });
	        // Add new values that are not already present
	        newMap.forEach(function (valueInNewMap, key) {
	            if (!map.has(key)) {
	                // New values
	                map.set(key, createNewValue(key, valueInNewMap));
	            }
	        });
	    }
	    ts.mutateMap = mutateMap;
	    /** Calls `callback` on `directory` and every ancestor directory it has, returning the first defined result. */
	    function forEachAncestorDirectory(directory, callback) {
	        while (true) {
	            var result = callback(directory);
	            if (result !== undefined) {
	                return result;
	            }
	            var parentPath = ts.getDirectoryPath(directory);
	            if (parentPath === directory) {
	                return undefined;
	            }
	            directory = parentPath;
	        }
	    }
	    ts.forEachAncestorDirectory = forEachAncestorDirectory;
	    // Return true if the given type is the constructor type for an abstract class
	    function isAbstractConstructorType(type) {
	        return !!(getObjectFlags(type) & 16 /* Anonymous */) && !!type.symbol && isAbstractConstructorSymbol(type.symbol);
	    }
	    ts.isAbstractConstructorType = isAbstractConstructorType;
	    function isAbstractConstructorSymbol(symbol) {
	        if (symbol.flags & 32 /* Class */) {
	            var declaration = getClassLikeDeclarationOfSymbol(symbol);
	            return !!declaration && hasModifier(declaration, 128 /* Abstract */);
	        }
	        return false;
	    }
	    ts.isAbstractConstructorSymbol = isAbstractConstructorSymbol;
	    function getClassLikeDeclarationOfSymbol(symbol) {
	        return ts.find(symbol.declarations, ts.isClassLike);
	    }
	    ts.getClassLikeDeclarationOfSymbol = getClassLikeDeclarationOfSymbol;
	    function getObjectFlags(type) {
	        return type.flags & 65536 /* Object */ ? type.objectFlags : 0;
	    }
	    ts.getObjectFlags = getObjectFlags;
	    function typeHasCallOrConstructSignatures(type, checker) {
	        return checker.getSignaturesOfType(type, 0 /* Call */).length !== 0 || checker.getSignaturesOfType(type, 1 /* Construct */).length !== 0;
	    }
	    ts.typeHasCallOrConstructSignatures = typeHasCallOrConstructSignatures;
	    function forSomeAncestorDirectory(directory, callback) {
	        return !!forEachAncestorDirectory(directory, function (d) { return callback(d) ? true : undefined; });
	    }
	    ts.forSomeAncestorDirectory = forSomeAncestorDirectory;
	    function isUMDExportSymbol(symbol) {
	        return symbol && symbol.declarations && symbol.declarations[0] && ts.isNamespaceExportDeclaration(symbol.declarations[0]);
	    }
	    ts.isUMDExportSymbol = isUMDExportSymbol;
	})(ts || (ts = {}));
	(function (ts) {
	    function getDefaultLibFileName(options) {
	        switch (options.target) {
	            case 6 /* ESNext */:
	                return "lib.esnext.full.d.ts";
	            case 4 /* ES2017 */:
	                return "lib.es2017.full.d.ts";
	            case 3 /* ES2016 */:
	                return "lib.es2016.full.d.ts";
	            case 2 /* ES2015 */:
	                return "lib.es6.d.ts"; // We don't use lib.es2015.full.d.ts due to breaking change.
	            default:
	                return "lib.d.ts";
	        }
	    }
	    ts.getDefaultLibFileName = getDefaultLibFileName;
	    function textSpanEnd(span) {
	        return span.start + span.length;
	    }
	    ts.textSpanEnd = textSpanEnd;
	    function textSpanIsEmpty(span) {
	        return span.length === 0;
	    }
	    ts.textSpanIsEmpty = textSpanIsEmpty;
	    function textSpanContainsPosition(span, position) {
	        return position >= span.start && position < textSpanEnd(span);
	    }
	    ts.textSpanContainsPosition = textSpanContainsPosition;
	    // Returns true if 'span' contains 'other'.
	    function textSpanContainsTextSpan(span, other) {
	        return other.start >= span.start && textSpanEnd(other) <= textSpanEnd(span);
	    }
	    ts.textSpanContainsTextSpan = textSpanContainsTextSpan;
	    function textSpanOverlapsWith(span, other) {
	        var overlapStart = Math.max(span.start, other.start);
	        var overlapEnd = Math.min(textSpanEnd(span), textSpanEnd(other));
	        return overlapStart < overlapEnd;
	    }
	    ts.textSpanOverlapsWith = textSpanOverlapsWith;
	    function textSpanOverlap(span1, span2) {
	        var overlapStart = Math.max(span1.start, span2.start);
	        var overlapEnd = Math.min(textSpanEnd(span1), textSpanEnd(span2));
	        if (overlapStart < overlapEnd) {
	            return createTextSpanFromBounds(overlapStart, overlapEnd);
	        }
	        return undefined;
	    }
	    ts.textSpanOverlap = textSpanOverlap;
	    function textSpanIntersectsWithTextSpan(span, other) {
	        return other.start <= textSpanEnd(span) && textSpanEnd(other) >= span.start;
	    }
	    ts.textSpanIntersectsWithTextSpan = textSpanIntersectsWithTextSpan;
	    function textSpanIntersectsWith(span, start, length) {
	        var end = start + length;
	        return start <= textSpanEnd(span) && end >= span.start;
	    }
	    ts.textSpanIntersectsWith = textSpanIntersectsWith;
	    function decodedTextSpanIntersectsWith(start1, length1, start2, length2) {
	        var end1 = start1 + length1;
	        var end2 = start2 + length2;
	        return start2 <= end1 && end2 >= start1;
	    }
	    ts.decodedTextSpanIntersectsWith = decodedTextSpanIntersectsWith;
	    function textSpanIntersectsWithPosition(span, position) {
	        return position <= textSpanEnd(span) && position >= span.start;
	    }
	    ts.textSpanIntersectsWithPosition = textSpanIntersectsWithPosition;
	    function textSpanIntersection(span1, span2) {
	        var intersectStart = Math.max(span1.start, span2.start);
	        var intersectEnd = Math.min(textSpanEnd(span1), textSpanEnd(span2));
	        if (intersectStart <= intersectEnd) {
	            return createTextSpanFromBounds(intersectStart, intersectEnd);
	        }
	        return undefined;
	    }
	    ts.textSpanIntersection = textSpanIntersection;
	    function createTextSpan(start, length) {
	        if (start < 0) {
	            throw new Error("start < 0");
	        }
	        if (length < 0) {
	            throw new Error("length < 0");
	        }
	        return { start: start, length: length };
	    }
	    ts.createTextSpan = createTextSpan;
	    function createTextSpanFromBounds(start, end) {
	        return createTextSpan(start, end - start);
	    }
	    ts.createTextSpanFromBounds = createTextSpanFromBounds;
	    function textChangeRangeNewSpan(range) {
	        return createTextSpan(range.span.start, range.newLength);
	    }
	    ts.textChangeRangeNewSpan = textChangeRangeNewSpan;
	    function textChangeRangeIsUnchanged(range) {
	        return textSpanIsEmpty(range.span) && range.newLength === 0;
	    }
	    ts.textChangeRangeIsUnchanged = textChangeRangeIsUnchanged;
	    function createTextChangeRange(span, newLength) {
	        if (newLength < 0) {
	            throw new Error("newLength < 0");
	        }
	        return { span: span, newLength: newLength };
	    }
	    ts.createTextChangeRange = createTextChangeRange;
	    ts.unchangedTextChangeRange = createTextChangeRange(createTextSpan(0, 0), 0);
	    /**
	     * Called to merge all the changes that occurred across several versions of a script snapshot
	     * into a single change.  i.e. if a user keeps making successive edits to a script we will
	     * have a text change from V1 to V2, V2 to V3, ..., Vn.
	     *
	     * This function will then merge those changes into a single change range valid between V1 and
	     * Vn.
	     */
	    function collapseTextChangeRangesAcrossMultipleVersions(changes) {
	        if (changes.length === 0) {
	            return ts.unchangedTextChangeRange;
	        }
	        if (changes.length === 1) {
	            return changes[0];
	        }
	        // We change from talking about { { oldStart, oldLength }, newLength } to { oldStart, oldEnd, newEnd }
	        // as it makes things much easier to reason about.
	        var change0 = changes[0];
	        var oldStartN = change0.span.start;
	        var oldEndN = textSpanEnd(change0.span);
	        var newEndN = oldStartN + change0.newLength;
	        for (var i = 1; i < changes.length; i++) {
	            var nextChange = changes[i];
	            // Consider the following case:
	            // i.e. two edits.  The first represents the text change range { { 10, 50 }, 30 }.  i.e. The span starting
	            // at 10, with length 50 is reduced to length 30.  The second represents the text change range { { 30, 30 }, 40 }.
	            // i.e. the span starting at 30 with length 30 is increased to length 40.
	            //
	            //      0         10        20        30        40        50        60        70        80        90        100
	            //      -------------------------------------------------------------------------------------------------------
	            //                |                                                 /
	            //                |                                            /----
	            //  T1            |                                       /----
	            //                |                                  /----
	            //                |                             /----
	            //      -------------------------------------------------------------------------------------------------------
	            //                                     |                            \
	            //                                     |                               \
	            //   T2                                |                                 \
	            //                                     |                                   \
	            //                                     |                                      \
	            //      -------------------------------------------------------------------------------------------------------
	            //
	            // Merging these turns out to not be too difficult.  First, determining the new start of the change is trivial
	            // it's just the min of the old and new starts.  i.e.:
	            //
	            //      0         10        20        30        40        50        60        70        80        90        100
	            //      ------------------------------------------------------------*------------------------------------------
	            //                |                                                 /
	            //                |                                            /----
	            //  T1            |                                       /----
	            //                |                                  /----
	            //                |                             /----
	            //      ----------------------------------------$-------------------$------------------------------------------
	            //                .                    |                            \
	            //                .                    |                               \
	            //   T2           .                    |                                 \
	            //                .                    |                                   \
	            //                .                    |                                      \
	            //      ----------------------------------------------------------------------*--------------------------------
	            //
	            // (Note the dots represent the newly inferred start.
	            // Determining the new and old end is also pretty simple.  Basically it boils down to paying attention to the
	            // absolute positions at the asterisks, and the relative change between the dollar signs. Basically, we see
	            // which if the two $'s precedes the other, and we move that one forward until they line up.  in this case that
	            // means:
	            //
	            //      0         10        20        30        40        50        60        70        80        90        100
	            //      --------------------------------------------------------------------------------*----------------------
	            //                |                                                                     /
	            //                |                                                                /----
	            //  T1            |                                                           /----
	            //                |                                                      /----
	            //                |                                                 /----
	            //      ------------------------------------------------------------$------------------------------------------
	            //                .                    |                            \
	            //                .                    |                               \
	            //   T2           .                    |                                 \
	            //                .                    |                                   \
	            //                .                    |                                      \
	            //      ----------------------------------------------------------------------*--------------------------------
	            //
	            // In other words (in this case), we're recognizing that the second edit happened after where the first edit
	            // ended with a delta of 20 characters (60 - 40).  Thus, if we go back in time to where the first edit started
	            // that's the same as if we started at char 80 instead of 60.
	            //
	            // As it so happens, the same logic applies if the second edit precedes the first edit.  In that case rather
	            // than pushing the first edit forward to match the second, we'll push the second edit forward to match the
	            // first.
	            //
	            // In this case that means we have { oldStart: 10, oldEnd: 80, newEnd: 70 } or, in TextChangeRange
	            // semantics: { { start: 10, length: 70 }, newLength: 60 }
	            //
	            // The math then works out as follows.
	            // If we have { oldStart1, oldEnd1, newEnd1 } and { oldStart2, oldEnd2, newEnd2 } then we can compute the
	            // final result like so:
	            //
	            // {
	            //      oldStart3: Min(oldStart1, oldStart2),
	            //      oldEnd3: Max(oldEnd1, oldEnd1 + (oldEnd2 - newEnd1)),
	            //      newEnd3: Max(newEnd2, newEnd2 + (newEnd1 - oldEnd2))
	            // }
	            var oldStart1 = oldStartN;
	            var oldEnd1 = oldEndN;
	            var newEnd1 = newEndN;
	            var oldStart2 = nextChange.span.start;
	            var oldEnd2 = textSpanEnd(nextChange.span);
	            var newEnd2 = oldStart2 + nextChange.newLength;
	            oldStartN = Math.min(oldStart1, oldStart2);
	            oldEndN = Math.max(oldEnd1, oldEnd1 + (oldEnd2 - newEnd1));
	            newEndN = Math.max(newEnd2, newEnd2 + (newEnd1 - oldEnd2));
	        }
	        return createTextChangeRange(createTextSpanFromBounds(oldStartN, oldEndN), /*newLength*/ newEndN - oldStartN);
	    }
	    ts.collapseTextChangeRangesAcrossMultipleVersions = collapseTextChangeRangesAcrossMultipleVersions;
	    function getTypeParameterOwner(d) {
	        if (d && d.kind === 147 /* TypeParameter */) {
	            for (var current = d; current; current = current.parent) {
	                if (ts.isFunctionLike(current) || ts.isClassLike(current) || current.kind === 234 /* InterfaceDeclaration */) {
	                    return current;
	                }
	            }
	        }
	    }
	    ts.getTypeParameterOwner = getTypeParameterOwner;
	    function isParameterPropertyDeclaration(node) {
	        return ts.hasModifier(node, 92 /* ParameterPropertyModifier */) && node.parent.kind === 154 /* Constructor */ && ts.isClassLike(node.parent.parent);
	    }
	    ts.isParameterPropertyDeclaration = isParameterPropertyDeclaration;
	    function isEmptyBindingPattern(node) {
	        if (ts.isBindingPattern(node)) {
	            return ts.every(node.elements, isEmptyBindingElement);
	        }
	        return false;
	    }
	    ts.isEmptyBindingPattern = isEmptyBindingPattern;
	    function isEmptyBindingElement(node) {
	        if (ts.isOmittedExpression(node)) {
	            return true;
	        }
	        return isEmptyBindingPattern(node.name);
	    }
	    ts.isEmptyBindingElement = isEmptyBindingElement;
	    function walkUpBindingElementsAndPatterns(node) {
	        while (node && (node.kind === 180 /* BindingElement */ || ts.isBindingPattern(node))) {
	            node = node.parent;
	        }
	        return node;
	    }
	    function getCombinedModifierFlags(node) {
	        node = walkUpBindingElementsAndPatterns(node);
	        var flags = ts.getModifierFlags(node);
	        if (node.kind === 230 /* VariableDeclaration */) {
	            node = node.parent;
	        }
	        if (node && node.kind === 231 /* VariableDeclarationList */) {
	            flags |= ts.getModifierFlags(node);
	            node = node.parent;
	        }
	        if (node && node.kind === 212 /* VariableStatement */) {
	            flags |= ts.getModifierFlags(node);
	        }
	        return flags;
	    }
	    ts.getCombinedModifierFlags = getCombinedModifierFlags;
	    // Returns the node flags for this node and all relevant parent nodes.  This is done so that
	    // nodes like variable declarations and binding elements can returned a view of their flags
	    // that includes the modifiers from their container.  i.e. flags like export/declare aren't
	    // stored on the variable declaration directly, but on the containing variable statement
	    // (if it has one).  Similarly, flags for let/const are store on the variable declaration
	    // list.  By calling this function, all those flags are combined so that the client can treat
	    // the node as if it actually had those flags.
	    function getCombinedNodeFlags(node) {
	        node = walkUpBindingElementsAndPatterns(node);
	        var flags = node.flags;
	        if (node.kind === 230 /* VariableDeclaration */) {
	            node = node.parent;
	        }
	        if (node && node.kind === 231 /* VariableDeclarationList */) {
	            flags |= node.flags;
	            node = node.parent;
	        }
	        if (node && node.kind === 212 /* VariableStatement */) {
	            flags |= node.flags;
	        }
	        return flags;
	    }
	    ts.getCombinedNodeFlags = getCombinedNodeFlags;
	    /**
	     * Checks to see if the locale is in the appropriate format,
	     * and if it is, attempts to set the appropriate language.
	     */
	    function validateLocaleAndSetLanguage(locale, sys, errors) {
	        var matchResult = /^([a-z]+)([_\-]([a-z]+))?$/.exec(locale.toLowerCase());
	        if (!matchResult) {
	            if (errors) {
	                errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1, "en", "ja-jp"));
	            }
	            return;
	        }
	        var language = matchResult[1];
	        var territory = matchResult[3];
	        // First try the entire locale, then fall back to just language if that's all we have.
	        // Either ways do not fail, and fallback to the English diagnostic strings.
	        if (!trySetLanguageAndTerritory(language, territory, errors)) {
	            trySetLanguageAndTerritory(language, /*territory*/ undefined, errors);
	        }
	        // Set the UI locale for string collation
	        ts.setUILocale(locale);
	        function trySetLanguageAndTerritory(language, territory, errors) {
	            var compilerFilePath = ts.normalizePath(sys.getExecutingFilePath());
	            var containingDirectoryPath = ts.getDirectoryPath(compilerFilePath);
	            var filePath = ts.combinePaths(containingDirectoryPath, language);
	            if (territory) {
	                filePath = filePath + "-" + territory;
	            }
	            filePath = sys.resolvePath(ts.combinePaths(filePath, "diagnosticMessages.generated.json"));
	            if (!sys.fileExists(filePath)) {
	                return false;
	            }
	            // TODO: Add codePage support for readFile?
	            var fileContents = "";
	            try {
	                fileContents = sys.readFile(filePath);
	            }
	            catch (e) {
	                if (errors) {
	                    errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Unable_to_open_file_0, filePath));
	                }
	                return false;
	            }
	            try {
	                ts.localizedDiagnosticMessages = JSON.parse(fileContents);
	            }
	            catch (e) {
	                if (errors) {
	                    errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Corrupted_locale_file_0, filePath));
	                }
	                return false;
	            }
	            return true;
	        }
	    }
	    ts.validateLocaleAndSetLanguage = validateLocaleAndSetLanguage;
	    function getOriginalNode(node, nodeTest) {
	        if (node) {
	            while (node.original !== undefined) {
	                node = node.original;
	            }
	        }
	        return !nodeTest || nodeTest(node) ? node : undefined;
	    }
	    ts.getOriginalNode = getOriginalNode;
	    /**
	     * Gets a value indicating whether a node originated in the parse tree.
	     *
	     * @param node The node to test.
	     */
	    function isParseTreeNode(node) {
	        return (node.flags & 8 /* Synthesized */) === 0;
	    }
	    ts.isParseTreeNode = isParseTreeNode;
	    function getParseTreeNode(node, nodeTest) {
	        if (node === undefined || isParseTreeNode(node)) {
	            return node;
	        }
	        node = getOriginalNode(node);
	        if (isParseTreeNode(node) && (!nodeTest || nodeTest(node))) {
	            return node;
	        }
	        return undefined;
	    }
	    ts.getParseTreeNode = getParseTreeNode;
	    /**
	     * Remove extra underscore from escaped identifier text content.
	     *
	     * @param identifier The escaped identifier text.
	     * @returns The unescaped identifier text.
	     */
	    function unescapeLeadingUnderscores(identifier) {
	        var id = identifier;
	        return id.length >= 3 && id.charCodeAt(0) === 95 /* _ */ && id.charCodeAt(1) === 95 /* _ */ && id.charCodeAt(2) === 95 /* _ */ ? id.substr(1) : id;
	    }
	    ts.unescapeLeadingUnderscores = unescapeLeadingUnderscores;
	    function idText(identifier) {
	        return unescapeLeadingUnderscores(identifier.escapedText);
	    }
	    ts.idText = idText;
	    function symbolName(symbol) {
	        return unescapeLeadingUnderscores(symbol.escapedName);
	    }
	    ts.symbolName = symbolName;
	    /**
	     * Remove extra underscore from escaped identifier text content.
	     * @deprecated Use `id.text` for the unescaped text.
	     * @param identifier The escaped identifier text.
	     * @returns The unescaped identifier text.
	     */
	    function unescapeIdentifier(id) {
	        return id;
	    }
	    ts.unescapeIdentifier = unescapeIdentifier;
	    /**
	     * A JSDocTypedef tag has an _optional_ name field - if a name is not directly present, we should
	     * attempt to draw the name from the node the declaration is on (as that declaration is what its' symbol
	     * will be merged with)
	     */
	    function nameForNamelessJSDocTypedef(declaration) {
	        var hostNode = declaration.parent.parent;
	        if (!hostNode) {
	            return undefined;
	        }
	        // Covers classes, functions - any named declaration host node
	        if (ts.isDeclaration(hostNode)) {
	            return getDeclarationIdentifier(hostNode);
	        }
	        // Covers remaining cases
	        switch (hostNode.kind) {
	            case 212 /* VariableStatement */:
	                if (hostNode.declarationList && hostNode.declarationList.declarations[0]) {
	                    return getDeclarationIdentifier(hostNode.declarationList.declarations[0]);
	                }
	                return undefined;
	            case 214 /* ExpressionStatement */:
	                var expr = hostNode.expression;
	                switch (expr.kind) {
	                    case 183 /* PropertyAccessExpression */:
	                        return expr.name;
	                    case 184 /* ElementAccessExpression */:
	                        var arg = expr.argumentExpression;
	                        if (ts.isIdentifier(arg)) {
	                            return arg;
	                        }
	                }
	                return undefined;
	            case 1 /* EndOfFileToken */:
	                return undefined;
	            case 189 /* ParenthesizedExpression */: {
	                return getDeclarationIdentifier(hostNode.expression);
	            }
	            case 226 /* LabeledStatement */: {
	                if (ts.isDeclaration(hostNode.statement) || ts.isExpression(hostNode.statement)) {
	                    return getDeclarationIdentifier(hostNode.statement);
	                }
	                return undefined;
	            }
	            default:
	                ts.Debug.assertNever(hostNode, "Found typedef tag attached to node which it should not be!");
	        }
	    }
	    function getDeclarationIdentifier(node) {
	        var name = getNameOfDeclaration(node);
	        return ts.isIdentifier(name) ? name : undefined;
	    }
	    function getNameOfJSDocTypedef(declaration) {
	        return declaration.name || nameForNamelessJSDocTypedef(declaration);
	    }
	    ts.getNameOfJSDocTypedef = getNameOfJSDocTypedef;
	    function getNameOfDeclaration(declaration) {
	        if (!declaration) {
	            return undefined;
	        }
	        switch (declaration.kind) {
	            case 71 /* Identifier */:
	                return declaration;
	            case 292 /* JSDocPropertyTag */:
	            case 287 /* JSDocParameterTag */: {
	                var name = declaration.name;
	                if (name.kind === 145 /* QualifiedName */) {
	                    return name.right;
	                }
	                break;
	            }
	            case 198 /* BinaryExpression */: {
	                var expr = declaration;
	                switch (ts.getSpecialPropertyAssignmentKind(expr)) {
	                    case 1 /* ExportsProperty */:
	                    case 4 /* ThisProperty */:
	                    case 5 /* Property */:
	                    case 3 /* PrototypeProperty */:
	                        return expr.left.name;
	                    default:
	                        return undefined;
	                }
	            }
	            case 291 /* JSDocTypedefTag */:
	                return getNameOfJSDocTypedef(declaration);
	            case 247 /* ExportAssignment */: {
	                var expression = declaration.expression;
	                return ts.isIdentifier(expression) ? expression : undefined;
	            }
	        }
	        return declaration.name;
	    }
	    ts.getNameOfDeclaration = getNameOfDeclaration;
	    /**
	     * Gets the JSDoc parameter tags for the node if present.
	     *
	     * @remarks Returns any JSDoc param tag that matches the provided
	     * parameter, whether a param tag on a containing function
	     * expression, or a param tag on a variable declaration whose
	     * initializer is the containing function. The tags closest to the
	     * node are returned first, so in the previous example, the param
	     * tag on the containing function expression would be first.
	     *
	     * Does not return tags for binding patterns, because JSDoc matches
	     * parameters by name and binding patterns do not have a name.
	     */
	    function getJSDocParameterTags(param) {
	        if (param.name && ts.isIdentifier(param.name)) {
	            var name_1 = param.name.escapedText;
	            return getJSDocTags(param.parent).filter(function (tag) { return ts.isJSDocParameterTag(tag) && ts.isIdentifier(tag.name) && tag.name.escapedText === name_1; });
	        }
	        // a binding pattern doesn't have a name, so it's not possible to match it a JSDoc parameter, which is identified by name
	        return undefined;
	    }
	    ts.getJSDocParameterTags = getJSDocParameterTags;
	    /**
	     * Return true if the node has JSDoc parameter tags.
	     *
	     * @remarks Includes parameter tags that are not directly on the node,
	     * for example on a variable declaration whose initializer is a function expression.
	     */
	    function hasJSDocParameterTags(node) {
	        return !!getFirstJSDocTag(node, 287 /* JSDocParameterTag */);
	    }
	    ts.hasJSDocParameterTags = hasJSDocParameterTags;
	    /** Gets the JSDoc augments tag for the node if present */
	    function getJSDocAugmentsTag(node) {
	        return getFirstJSDocTag(node, 285 /* JSDocAugmentsTag */);
	    }
	    ts.getJSDocAugmentsTag = getJSDocAugmentsTag;
	    /** Gets the JSDoc class tag for the node if present */
	    function getJSDocClassTag(node) {
	        return getFirstJSDocTag(node, 286 /* JSDocClassTag */);
	    }
	    ts.getJSDocClassTag = getJSDocClassTag;
	    /** Gets the JSDoc return tag for the node if present */
	    function getJSDocReturnTag(node) {
	        return getFirstJSDocTag(node, 288 /* JSDocReturnTag */);
	    }
	    ts.getJSDocReturnTag = getJSDocReturnTag;
	    /** Gets the JSDoc template tag for the node if present */
	    function getJSDocTemplateTag(node) {
	        return getFirstJSDocTag(node, 290 /* JSDocTemplateTag */);
	    }
	    ts.getJSDocTemplateTag = getJSDocTemplateTag;
	    /** Gets the JSDoc type tag for the node if present and valid */
	    function getJSDocTypeTag(node) {
	        // We should have already issued an error if there were multiple type jsdocs, so just use the first one.
	        var tag = getFirstJSDocTag(node, 289 /* JSDocTypeTag */);
	        if (tag && tag.typeExpression && tag.typeExpression.type) {
	            return tag;
	        }
	        return undefined;
	    }
	    ts.getJSDocTypeTag = getJSDocTypeTag;
	    /**
	     * Gets the type node for the node if provided via JSDoc.
	     *
	     * @remarks The search includes any JSDoc param tag that relates
	     * to the provided parameter, for example a type tag on the
	     * parameter itself, or a param tag on a containing function
	     * expression, or a param tag on a variable declaration whose
	     * initializer is the containing function. The tags closest to the
	     * node are examined first, so in the previous example, the type
	     * tag directly on the node would be returned.
	     */
	    function getJSDocType(node) {
	        var tag = getFirstJSDocTag(node, 289 /* JSDocTypeTag */);
	        if (!tag && node.kind === 148 /* Parameter */) {
	            var paramTags = getJSDocParameterTags(node);
	            if (paramTags) {
	                tag = ts.find(paramTags, function (tag) { return !!tag.typeExpression; });
	            }
	        }
	        return tag && tag.typeExpression && tag.typeExpression.type;
	    }
	    ts.getJSDocType = getJSDocType;
	    /**
	     * Gets the return type node for the node if provided via JSDoc's return tag.
	     *
	     * @remarks `getJSDocReturnTag` just gets the whole JSDoc tag. This function
	     * gets the type from inside the braces.
	     */
	    function getJSDocReturnType(node) {
	        var returnTag = getJSDocReturnTag(node);
	        return returnTag && returnTag.typeExpression && returnTag.typeExpression.type;
	    }
	    ts.getJSDocReturnType = getJSDocReturnType;
	    /** Get all JSDoc tags related to a node, including those on parent nodes. */
	    function getJSDocTags(node) {
	        var tags = node.jsDocCache;
	        // If cache is 'null', that means we did the work of searching for JSDoc tags and came up with nothing.
	        if (tags === undefined) {
	            node.jsDocCache = tags = ts.flatMap(ts.getJSDocCommentsAndTags(node), function (j) { return ts.isJSDoc(j) ? j.tags : j; });
	        }
	        return tags;
	    }
	    ts.getJSDocTags = getJSDocTags;
	    /** Get the first JSDoc tag of a specified kind, or undefined if not present. */
	    function getFirstJSDocTag(node, kind) {
	        var tags = getJSDocTags(node);
	        return ts.find(tags, function (doc) { return doc.kind === kind; });
	    }
	    /** Gets all JSDoc tags of a specified kind, or undefined if not present. */
	    function getAllJSDocTagsOfKind(node, kind) {
	        var tags = getJSDocTags(node);
	        return ts.filter(tags, function (doc) { return doc.kind === kind; });
	    }
	    ts.getAllJSDocTagsOfKind = getAllJSDocTagsOfKind;
	})(ts || (ts = {}));
	// Simple node tests of the form `node.kind === SyntaxKind.Foo`.
	(function (ts) {
	    // Literals
	    function isNumericLiteral(node) {
	        return node.kind === 8 /* NumericLiteral */;
	    }
	    ts.isNumericLiteral = isNumericLiteral;
	    function isStringLiteral(node) {
	        return node.kind === 9 /* StringLiteral */;
	    }
	    ts.isStringLiteral = isStringLiteral;
	    function isJsxText(node) {
	        return node.kind === 10 /* JsxText */;
	    }
	    ts.isJsxText = isJsxText;
	    function isRegularExpressionLiteral(node) {
	        return node.kind === 12 /* RegularExpressionLiteral */;
	    }
	    ts.isRegularExpressionLiteral = isRegularExpressionLiteral;
	    function isNoSubstitutionTemplateLiteral(node) {
	        return node.kind === 13 /* NoSubstitutionTemplateLiteral */;
	    }
	    ts.isNoSubstitutionTemplateLiteral = isNoSubstitutionTemplateLiteral;
	    // Pseudo-literals
	    function isTemplateHead(node) {
	        return node.kind === 14 /* TemplateHead */;
	    }
	    ts.isTemplateHead = isTemplateHead;
	    function isTemplateMiddle(node) {
	        return node.kind === 15 /* TemplateMiddle */;
	    }
	    ts.isTemplateMiddle = isTemplateMiddle;
	    function isTemplateTail(node) {
	        return node.kind === 16 /* TemplateTail */;
	    }
	    ts.isTemplateTail = isTemplateTail;
	    function isIdentifier(node) {
	        return node.kind === 71 /* Identifier */;
	    }
	    ts.isIdentifier = isIdentifier;
	    // Names
	    function isQualifiedName(node) {
	        return node.kind === 145 /* QualifiedName */;
	    }
	    ts.isQualifiedName = isQualifiedName;
	    function isComputedPropertyName(node) {
	        return node.kind === 146 /* ComputedPropertyName */;
	    }
	    ts.isComputedPropertyName = isComputedPropertyName;
	    // Signature elements
	    function isTypeParameterDeclaration(node) {
	        return node.kind === 147 /* TypeParameter */;
	    }
	    ts.isTypeParameterDeclaration = isTypeParameterDeclaration;
	    function isParameter(node) {
	        return node.kind === 148 /* Parameter */;
	    }
	    ts.isParameter = isParameter;
	    function isDecorator(node) {
	        return node.kind === 149 /* Decorator */;
	    }
	    ts.isDecorator = isDecorator;
	    // TypeMember
	    function isPropertySignature(node) {
	        return node.kind === 150 /* PropertySignature */;
	    }
	    ts.isPropertySignature = isPropertySignature;
	    function isPropertyDeclaration(node) {
	        return node.kind === 151 /* PropertyDeclaration */;
	    }
	    ts.isPropertyDeclaration = isPropertyDeclaration;
	    function isMethodSignature(node) {
	        return node.kind === 152 /* MethodSignature */;
	    }
	    ts.isMethodSignature = isMethodSignature;
	    function isMethodDeclaration(node) {
	        return node.kind === 153 /* MethodDeclaration */;
	    }
	    ts.isMethodDeclaration = isMethodDeclaration;
	    function isConstructorDeclaration(node) {
	        return node.kind === 154 /* Constructor */;
	    }
	    ts.isConstructorDeclaration = isConstructorDeclaration;
	    function isGetAccessorDeclaration(node) {
	        return node.kind === 155 /* GetAccessor */;
	    }
	    ts.isGetAccessorDeclaration = isGetAccessorDeclaration;
	    function isSetAccessorDeclaration(node) {
	        return node.kind === 156 /* SetAccessor */;
	    }
	    ts.isSetAccessorDeclaration = isSetAccessorDeclaration;
	    function isCallSignatureDeclaration(node) {
	        return node.kind === 157 /* CallSignature */;
	    }
	    ts.isCallSignatureDeclaration = isCallSignatureDeclaration;
	    function isConstructSignatureDeclaration(node) {
	        return node.kind === 158 /* ConstructSignature */;
	    }
	    ts.isConstructSignatureDeclaration = isConstructSignatureDeclaration;
	    function isIndexSignatureDeclaration(node) {
	        return node.kind === 159 /* IndexSignature */;
	    }
	    ts.isIndexSignatureDeclaration = isIndexSignatureDeclaration;
	    // Type
	    function isTypePredicateNode(node) {
	        return node.kind === 160 /* TypePredicate */;
	    }
	    ts.isTypePredicateNode = isTypePredicateNode;
	    function isTypeReferenceNode(node) {
	        return node.kind === 161 /* TypeReference */;
	    }
	    ts.isTypeReferenceNode = isTypeReferenceNode;
	    function isFunctionTypeNode(node) {
	        return node.kind === 162 /* FunctionType */;
	    }
	    ts.isFunctionTypeNode = isFunctionTypeNode;
	    function isConstructorTypeNode(node) {
	        return node.kind === 163 /* ConstructorType */;
	    }
	    ts.isConstructorTypeNode = isConstructorTypeNode;
	    function isTypeQueryNode(node) {
	        return node.kind === 164 /* TypeQuery */;
	    }
	    ts.isTypeQueryNode = isTypeQueryNode;
	    function isTypeLiteralNode(node) {
	        return node.kind === 165 /* TypeLiteral */;
	    }
	    ts.isTypeLiteralNode = isTypeLiteralNode;
	    function isArrayTypeNode(node) {
	        return node.kind === 166 /* ArrayType */;
	    }
	    ts.isArrayTypeNode = isArrayTypeNode;
	    function isTupleTypeNode(node) {
	        return node.kind === 167 /* TupleType */;
	    }
	    ts.isTupleTypeNode = isTupleTypeNode;
	    function isUnionTypeNode(node) {
	        return node.kind === 168 /* UnionType */;
	    }
	    ts.isUnionTypeNode = isUnionTypeNode;
	    function isIntersectionTypeNode(node) {
	        return node.kind === 169 /* IntersectionType */;
	    }
	    ts.isIntersectionTypeNode = isIntersectionTypeNode;
	    function isConditionalTypeNode(node) {
	        return node.kind === 170 /* ConditionalType */;
	    }
	    ts.isConditionalTypeNode = isConditionalTypeNode;
	    function isInferTypeNode(node) {
	        return node.kind === 171 /* InferType */;
	    }
	    ts.isInferTypeNode = isInferTypeNode;
	    function isParenthesizedTypeNode(node) {
	        return node.kind === 172 /* ParenthesizedType */;
	    }
	    ts.isParenthesizedTypeNode = isParenthesizedTypeNode;
	    function isThisTypeNode(node) {
	        return node.kind === 173 /* ThisType */;
	    }
	    ts.isThisTypeNode = isThisTypeNode;
	    function isTypeOperatorNode(node) {
	        return node.kind === 174 /* TypeOperator */;
	    }
	    ts.isTypeOperatorNode = isTypeOperatorNode;
	    function isIndexedAccessTypeNode(node) {
	        return node.kind === 175 /* IndexedAccessType */;
	    }
	    ts.isIndexedAccessTypeNode = isIndexedAccessTypeNode;
	    function isMappedTypeNode(node) {
	        return node.kind === 176 /* MappedType */;
	    }
	    ts.isMappedTypeNode = isMappedTypeNode;
	    function isLiteralTypeNode(node) {
	        return node.kind === 177 /* LiteralType */;
	    }
	    ts.isLiteralTypeNode = isLiteralTypeNode;
	    // Binding patterns
	    function isObjectBindingPattern(node) {
	        return node.kind === 178 /* ObjectBindingPattern */;
	    }
	    ts.isObjectBindingPattern = isObjectBindingPattern;
	    function isArrayBindingPattern(node) {
	        return node.kind === 179 /* ArrayBindingPattern */;
	    }
	    ts.isArrayBindingPattern = isArrayBindingPattern;
	    function isBindingElement(node) {
	        return node.kind === 180 /* BindingElement */;
	    }
	    ts.isBindingElement = isBindingElement;
	    // Expression
	    function isArrayLiteralExpression(node) {
	        return node.kind === 181 /* ArrayLiteralExpression */;
	    }
	    ts.isArrayLiteralExpression = isArrayLiteralExpression;
	    function isObjectLiteralExpression(node) {
	        return node.kind === 182 /* ObjectLiteralExpression */;
	    }
	    ts.isObjectLiteralExpression = isObjectLiteralExpression;
	    function isPropertyAccessExpression(node) {
	        return node.kind === 183 /* PropertyAccessExpression */;
	    }
	    ts.isPropertyAccessExpression = isPropertyAccessExpression;
	    function isElementAccessExpression(node) {
	        return node.kind === 184 /* ElementAccessExpression */;
	    }
	    ts.isElementAccessExpression = isElementAccessExpression;
	    function isCallExpression(node) {
	        return node.kind === 185 /* CallExpression */;
	    }
	    ts.isCallExpression = isCallExpression;
	    function isNewExpression(node) {
	        return node.kind === 186 /* NewExpression */;
	    }
	    ts.isNewExpression = isNewExpression;
	    function isTaggedTemplateExpression(node) {
	        return node.kind === 187 /* TaggedTemplateExpression */;
	    }
	    ts.isTaggedTemplateExpression = isTaggedTemplateExpression;
	    function isTypeAssertion(node) {
	        return node.kind === 188 /* TypeAssertionExpression */;
	    }
	    ts.isTypeAssertion = isTypeAssertion;
	    function isParenthesizedExpression(node) {
	        return node.kind === 189 /* ParenthesizedExpression */;
	    }
	    ts.isParenthesizedExpression = isParenthesizedExpression;
	    function skipPartiallyEmittedExpressions(node) {
	        while (node.kind === 295 /* PartiallyEmittedExpression */) {
	            node = node.expression;
	        }
	        return node;
	    }
	    ts.skipPartiallyEmittedExpressions = skipPartiallyEmittedExpressions;
	    function isFunctionExpression(node) {
	        return node.kind === 190 /* FunctionExpression */;
	    }
	    ts.isFunctionExpression = isFunctionExpression;
	    function isArrowFunction(node) {
	        return node.kind === 191 /* ArrowFunction */;
	    }
	    ts.isArrowFunction = isArrowFunction;
	    function isDeleteExpression(node) {
	        return node.kind === 192 /* DeleteExpression */;
	    }
	    ts.isDeleteExpression = isDeleteExpression;
	    function isTypeOfExpression(node) {
	        return node.kind === 193 /* TypeOfExpression */;
	    }
	    ts.isTypeOfExpression = isTypeOfExpression;
	    function isVoidExpression(node) {
	        return node.kind === 194 /* VoidExpression */;
	    }
	    ts.isVoidExpression = isVoidExpression;
	    function isAwaitExpression(node) {
	        return node.kind === 195 /* AwaitExpression */;
	    }
	    ts.isAwaitExpression = isAwaitExpression;
	    function isPrefixUnaryExpression(node) {
	        return node.kind === 196 /* PrefixUnaryExpression */;
	    }
	    ts.isPrefixUnaryExpression = isPrefixUnaryExpression;
	    function isPostfixUnaryExpression(node) {
	        return node.kind === 197 /* PostfixUnaryExpression */;
	    }
	    ts.isPostfixUnaryExpression = isPostfixUnaryExpression;
	    function isBinaryExpression(node) {
	        return node.kind === 198 /* BinaryExpression */;
	    }
	    ts.isBinaryExpression = isBinaryExpression;
	    function isConditionalExpression(node) {
	        return node.kind === 199 /* ConditionalExpression */;
	    }
	    ts.isConditionalExpression = isConditionalExpression;
	    function isTemplateExpression(node) {
	        return node.kind === 200 /* TemplateExpression */;
	    }
	    ts.isTemplateExpression = isTemplateExpression;
	    function isYieldExpression(node) {
	        return node.kind === 201 /* YieldExpression */;
	    }
	    ts.isYieldExpression = isYieldExpression;
	    function isSpreadElement(node) {
	        return node.kind === 202 /* SpreadElement */;
	    }
	    ts.isSpreadElement = isSpreadElement;
	    function isClassExpression(node) {
	        return node.kind === 203 /* ClassExpression */;
	    }
	    ts.isClassExpression = isClassExpression;
	    function isOmittedExpression(node) {
	        return node.kind === 204 /* OmittedExpression */;
	    }
	    ts.isOmittedExpression = isOmittedExpression;
	    function isExpressionWithTypeArguments(node) {
	        return node.kind === 205 /* ExpressionWithTypeArguments */;
	    }
	    ts.isExpressionWithTypeArguments = isExpressionWithTypeArguments;
	    function isAsExpression(node) {
	        return node.kind === 206 /* AsExpression */;
	    }
	    ts.isAsExpression = isAsExpression;
	    function isNonNullExpression(node) {
	        return node.kind === 207 /* NonNullExpression */;
	    }
	    ts.isNonNullExpression = isNonNullExpression;
	    function isMetaProperty(node) {
	        return node.kind === 208 /* MetaProperty */;
	    }
	    ts.isMetaProperty = isMetaProperty;
	    // Misc
	    function isTemplateSpan(node) {
	        return node.kind === 209 /* TemplateSpan */;
	    }
	    ts.isTemplateSpan = isTemplateSpan;
	    function isSemicolonClassElement(node) {
	        return node.kind === 210 /* SemicolonClassElement */;
	    }
	    ts.isSemicolonClassElement = isSemicolonClassElement;
	    // Block
	    function isBlock(node) {
	        return node.kind === 211 /* Block */;
	    }
	    ts.isBlock = isBlock;
	    function isVariableStatement(node) {
	        return node.kind === 212 /* VariableStatement */;
	    }
	    ts.isVariableStatement = isVariableStatement;
	    function isEmptyStatement(node) {
	        return node.kind === 213 /* EmptyStatement */;
	    }
	    ts.isEmptyStatement = isEmptyStatement;
	    function isExpressionStatement(node) {
	        return node.kind === 214 /* ExpressionStatement */;
	    }
	    ts.isExpressionStatement = isExpressionStatement;
	    function isIfStatement(node) {
	        return node.kind === 215 /* IfStatement */;
	    }
	    ts.isIfStatement = isIfStatement;
	    function isDoStatement(node) {
	        return node.kind === 216 /* DoStatement */;
	    }
	    ts.isDoStatement = isDoStatement;
	    function isWhileStatement(node) {
	        return node.kind === 217 /* WhileStatement */;
	    }
	    ts.isWhileStatement = isWhileStatement;
	    function isForStatement(node) {
	        return node.kind === 218 /* ForStatement */;
	    }
	    ts.isForStatement = isForStatement;
	    function isForInStatement(node) {
	        return node.kind === 219 /* ForInStatement */;
	    }
	    ts.isForInStatement = isForInStatement;
	    function isForOfStatement(node) {
	        return node.kind === 220 /* ForOfStatement */;
	    }
	    ts.isForOfStatement = isForOfStatement;
	    function isContinueStatement(node) {
	        return node.kind === 221 /* ContinueStatement */;
	    }
	    ts.isContinueStatement = isContinueStatement;
	    function isBreakStatement(node) {
	        return node.kind === 222 /* BreakStatement */;
	    }
	    ts.isBreakStatement = isBreakStatement;
	    function isBreakOrContinueStatement(node) {
	        return node.kind === 222 /* BreakStatement */ || node.kind === 221 /* ContinueStatement */;
	    }
	    ts.isBreakOrContinueStatement = isBreakOrContinueStatement;
	    function isReturnStatement(node) {
	        return node.kind === 223 /* ReturnStatement */;
	    }
	    ts.isReturnStatement = isReturnStatement;
	    function isWithStatement(node) {
	        return node.kind === 224 /* WithStatement */;
	    }
	    ts.isWithStatement = isWithStatement;
	    function isSwitchStatement(node) {
	        return node.kind === 225 /* SwitchStatement */;
	    }
	    ts.isSwitchStatement = isSwitchStatement;
	    function isLabeledStatement(node) {
	        return node.kind === 226 /* LabeledStatement */;
	    }
	    ts.isLabeledStatement = isLabeledStatement;
	    function isThrowStatement(node) {
	        return node.kind === 227 /* ThrowStatement */;
	    }
	    ts.isThrowStatement = isThrowStatement;
	    function isTryStatement(node) {
	        return node.kind === 228 /* TryStatement */;
	    }
	    ts.isTryStatement = isTryStatement;
	    function isDebuggerStatement(node) {
	        return node.kind === 229 /* DebuggerStatement */;
	    }
	    ts.isDebuggerStatement = isDebuggerStatement;
	    function isVariableDeclaration(node) {
	        return node.kind === 230 /* VariableDeclaration */;
	    }
	    ts.isVariableDeclaration = isVariableDeclaration;
	    function isVariableDeclarationList(node) {
	        return node.kind === 231 /* VariableDeclarationList */;
	    }
	    ts.isVariableDeclarationList = isVariableDeclarationList;
	    function isFunctionDeclaration(node) {
	        return node.kind === 232 /* FunctionDeclaration */;
	    }
	    ts.isFunctionDeclaration = isFunctionDeclaration;
	    function isClassDeclaration(node) {
	        return node.kind === 233 /* ClassDeclaration */;
	    }
	    ts.isClassDeclaration = isClassDeclaration;
	    function isInterfaceDeclaration(node) {
	        return node.kind === 234 /* InterfaceDeclaration */;
	    }
	    ts.isInterfaceDeclaration = isInterfaceDeclaration;
	    function isTypeAliasDeclaration(node) {
	        return node.kind === 235 /* TypeAliasDeclaration */;
	    }
	    ts.isTypeAliasDeclaration = isTypeAliasDeclaration;
	    function isEnumDeclaration(node) {
	        return node.kind === 236 /* EnumDeclaration */;
	    }
	    ts.isEnumDeclaration = isEnumDeclaration;
	    function isModuleDeclaration(node) {
	        return node.kind === 237 /* ModuleDeclaration */;
	    }
	    ts.isModuleDeclaration = isModuleDeclaration;
	    function isModuleBlock(node) {
	        return node.kind === 238 /* ModuleBlock */;
	    }
	    ts.isModuleBlock = isModuleBlock;
	    function isCaseBlock(node) {
	        return node.kind === 239 /* CaseBlock */;
	    }
	    ts.isCaseBlock = isCaseBlock;
	    function isNamespaceExportDeclaration(node) {
	        return node.kind === 240 /* NamespaceExportDeclaration */;
	    }
	    ts.isNamespaceExportDeclaration = isNamespaceExportDeclaration;
	    function isImportEqualsDeclaration(node) {
	        return node.kind === 241 /* ImportEqualsDeclaration */;
	    }
	    ts.isImportEqualsDeclaration = isImportEqualsDeclaration;
	    function isImportDeclaration(node) {
	        return node.kind === 242 /* ImportDeclaration */;
	    }
	    ts.isImportDeclaration = isImportDeclaration;
	    function isImportClause(node) {
	        return node.kind === 243 /* ImportClause */;
	    }
	    ts.isImportClause = isImportClause;
	    function isNamespaceImport(node) {
	        return node.kind === 244 /* NamespaceImport */;
	    }
	    ts.isNamespaceImport = isNamespaceImport;
	    function isNamedImports(node) {
	        return node.kind === 245 /* NamedImports */;
	    }
	    ts.isNamedImports = isNamedImports;
	    function isImportSpecifier(node) {
	        return node.kind === 246 /* ImportSpecifier */;
	    }
	    ts.isImportSpecifier = isImportSpecifier;
	    function isExportAssignment(node) {
	        return node.kind === 247 /* ExportAssignment */;
	    }
	    ts.isExportAssignment = isExportAssignment;
	    function isExportDeclaration(node) {
	        return node.kind === 248 /* ExportDeclaration */;
	    }
	    ts.isExportDeclaration = isExportDeclaration;
	    function isNamedExports(node) {
	        return node.kind === 249 /* NamedExports */;
	    }
	    ts.isNamedExports = isNamedExports;
	    function isExportSpecifier(node) {
	        return node.kind === 250 /* ExportSpecifier */;
	    }
	    ts.isExportSpecifier = isExportSpecifier;
	    function isMissingDeclaration(node) {
	        return node.kind === 251 /* MissingDeclaration */;
	    }
	    ts.isMissingDeclaration = isMissingDeclaration;
	    // Module References
	    function isExternalModuleReference(node) {
	        return node.kind === 252 /* ExternalModuleReference */;
	    }
	    ts.isExternalModuleReference = isExternalModuleReference;
	    // JSX
	    function isJsxElement(node) {
	        return node.kind === 253 /* JsxElement */;
	    }
	    ts.isJsxElement = isJsxElement;
	    function isJsxSelfClosingElement(node) {
	        return node.kind === 254 /* JsxSelfClosingElement */;
	    }
	    ts.isJsxSelfClosingElement = isJsxSelfClosingElement;
	    function isJsxOpeningElement(node) {
	        return node.kind === 255 /* JsxOpeningElement */;
	    }
	    ts.isJsxOpeningElement = isJsxOpeningElement;
	    function isJsxClosingElement(node) {
	        return node.kind === 256 /* JsxClosingElement */;
	    }
	    ts.isJsxClosingElement = isJsxClosingElement;
	    function isJsxFragment(node) {
	        return node.kind === 257 /* JsxFragment */;
	    }
	    ts.isJsxFragment = isJsxFragment;
	    function isJsxOpeningFragment(node) {
	        return node.kind === 258 /* JsxOpeningFragment */;
	    }
	    ts.isJsxOpeningFragment = isJsxOpeningFragment;
	    function isJsxClosingFragment(node) {
	        return node.kind === 259 /* JsxClosingFragment */;
	    }
	    ts.isJsxClosingFragment = isJsxClosingFragment;
	    function isJsxAttribute(node) {
	        return node.kind === 260 /* JsxAttribute */;
	    }
	    ts.isJsxAttribute = isJsxAttribute;
	    function isJsxAttributes(node) {
	        return node.kind === 261 /* JsxAttributes */;
	    }
	    ts.isJsxAttributes = isJsxAttributes;
	    function isJsxSpreadAttribute(node) {
	        return node.kind === 262 /* JsxSpreadAttribute */;
	    }
	    ts.isJsxSpreadAttribute = isJsxSpreadAttribute;
	    function isJsxExpression(node) {
	        return node.kind === 263 /* JsxExpression */;
	    }
	    ts.isJsxExpression = isJsxExpression;
	    // Clauses
	    function isCaseClause(node) {
	        return node.kind === 264 /* CaseClause */;
	    }
	    ts.isCaseClause = isCaseClause;
	    function isDefaultClause(node) {
	        return node.kind === 265 /* DefaultClause */;
	    }
	    ts.isDefaultClause = isDefaultClause;
	    function isHeritageClause(node) {
	        return node.kind === 266 /* HeritageClause */;
	    }
	    ts.isHeritageClause = isHeritageClause;
	    function isCatchClause(node) {
	        return node.kind === 267 /* CatchClause */;
	    }
	    ts.isCatchClause = isCatchClause;
	    // Property assignments
	    function isPropertyAssignment(node) {
	        return node.kind === 268 /* PropertyAssignment */;
	    }
	    ts.isPropertyAssignment = isPropertyAssignment;
	    function isShorthandPropertyAssignment(node) {
	        return node.kind === 269 /* ShorthandPropertyAssignment */;
	    }
	    ts.isShorthandPropertyAssignment = isShorthandPropertyAssignment;
	    function isSpreadAssignment(node) {
	        return node.kind === 270 /* SpreadAssignment */;
	    }
	    ts.isSpreadAssignment = isSpreadAssignment;
	    // Enum
	    function isEnumMember(node) {
	        return node.kind === 271 /* EnumMember */;
	    }
	    ts.isEnumMember = isEnumMember;
	    // Top-level nodes
	    function isSourceFile(node) {
	        return node.kind === 272 /* SourceFile */;
	    }
	    ts.isSourceFile = isSourceFile;
	    function isBundle(node) {
	        return node.kind === 273 /* Bundle */;
	    }
	    ts.isBundle = isBundle;
	    // JSDoc
	    function isJSDocTypeExpression(node) {
	        return node.kind === 274 /* JSDocTypeExpression */;
	    }
	    ts.isJSDocTypeExpression = isJSDocTypeExpression;
	    function isJSDocAllType(node) {
	        return node.kind === 275 /* JSDocAllType */;
	    }
	    ts.isJSDocAllType = isJSDocAllType;
	    function isJSDocUnknownType(node) {
	        return node.kind === 276 /* JSDocUnknownType */;
	    }
	    ts.isJSDocUnknownType = isJSDocUnknownType;
	    function isJSDocNullableType(node) {
	        return node.kind === 277 /* JSDocNullableType */;
	    }
	    ts.isJSDocNullableType = isJSDocNullableType;
	    function isJSDocNonNullableType(node) {
	        return node.kind === 278 /* JSDocNonNullableType */;
	    }
	    ts.isJSDocNonNullableType = isJSDocNonNullableType;
	    function isJSDocOptionalType(node) {
	        return node.kind === 279 /* JSDocOptionalType */;
	    }
	    ts.isJSDocOptionalType = isJSDocOptionalType;
	    function isJSDocFunctionType(node) {
	        return node.kind === 280 /* JSDocFunctionType */;
	    }
	    ts.isJSDocFunctionType = isJSDocFunctionType;
	    function isJSDocVariadicType(node) {
	        return node.kind === 281 /* JSDocVariadicType */;
	    }
	    ts.isJSDocVariadicType = isJSDocVariadicType;
	    function isJSDoc(node) {
	        return node.kind === 282 /* JSDocComment */;
	    }
	    ts.isJSDoc = isJSDoc;
	    function isJSDocAugmentsTag(node) {
	        return node.kind === 285 /* JSDocAugmentsTag */;
	    }
	    ts.isJSDocAugmentsTag = isJSDocAugmentsTag;
	    function isJSDocParameterTag(node) {
	        return node.kind === 287 /* JSDocParameterTag */;
	    }
	    ts.isJSDocParameterTag = isJSDocParameterTag;
	    function isJSDocReturnTag(node) {
	        return node.kind === 288 /* JSDocReturnTag */;
	    }
	    ts.isJSDocReturnTag = isJSDocReturnTag;
	    function isJSDocTypeTag(node) {
	        return node.kind === 289 /* JSDocTypeTag */;
	    }
	    ts.isJSDocTypeTag = isJSDocTypeTag;
	    function isJSDocTemplateTag(node) {
	        return node.kind === 290 /* JSDocTemplateTag */;
	    }
	    ts.isJSDocTemplateTag = isJSDocTemplateTag;
	    function isJSDocTypedefTag(node) {
	        return node.kind === 291 /* JSDocTypedefTag */;
	    }
	    ts.isJSDocTypedefTag = isJSDocTypedefTag;
	    function isJSDocPropertyTag(node) {
	        return node.kind === 292 /* JSDocPropertyTag */;
	    }
	    ts.isJSDocPropertyTag = isJSDocPropertyTag;
	    function isJSDocPropertyLikeTag(node) {
	        return node.kind === 292 /* JSDocPropertyTag */ || node.kind === 287 /* JSDocParameterTag */;
	    }
	    ts.isJSDocPropertyLikeTag = isJSDocPropertyLikeTag;
	    function isJSDocTypeLiteral(node) {
	        return node.kind === 283 /* JSDocTypeLiteral */;
	    }
	    ts.isJSDocTypeLiteral = isJSDocTypeLiteral;
	})(ts || (ts = {}));
	// Node tests
	//
	// All node tests in the following list should *not* reference parent pointers so that
	// they may be used with transformations.
	(function (ts) {
	    /* @internal */
	    function isSyntaxList(n) {
	        return n.kind === 293 /* SyntaxList */;
	    }
	    ts.isSyntaxList = isSyntaxList;
	    /* @internal */
	    function isNode(node) {
	        return isNodeKind(node.kind);
	    }
	    ts.isNode = isNode;
	    /* @internal */
	    function isNodeKind(kind) {
	        return kind >= 145 /* FirstNode */;
	    }
	    ts.isNodeKind = isNodeKind;
	    /**
	     * True if node is of some token syntax kind.
	     * For example, this is true for an IfKeyword but not for an IfStatement.
	     * Literals are considered tokens, except TemplateLiteral, but does include TemplateHead/Middle/Tail.
	     */
	    function isToken(n) {
	        return n.kind >= 0 /* FirstToken */ && n.kind <= 144 /* LastToken */;
	    }
	    ts.isToken = isToken;
	    // Node Arrays
	    /* @internal */
	    function isNodeArray(array) {
	        return array.hasOwnProperty("pos") && array.hasOwnProperty("end");
	    }
	    ts.isNodeArray = isNodeArray;
	    // Literals
	    /* @internal */
	    function isLiteralKind(kind) {
	        return 8 /* FirstLiteralToken */ <= kind && kind <= 13 /* LastLiteralToken */;
	    }
	    ts.isLiteralKind = isLiteralKind;
	    function isLiteralExpression(node) {
	        return isLiteralKind(node.kind);
	    }
	    ts.isLiteralExpression = isLiteralExpression;
	    // Pseudo-literals
	    /* @internal */
	    function isTemplateLiteralKind(kind) {
	        return 13 /* FirstTemplateToken */ <= kind && kind <= 16 /* LastTemplateToken */;
	    }
	    ts.isTemplateLiteralKind = isTemplateLiteralKind;
	    function isTemplateMiddleOrTemplateTail(node) {
	        var kind = node.kind;
	        return kind === 15 /* TemplateMiddle */
	            || kind === 16 /* TemplateTail */;
	    }
	    ts.isTemplateMiddleOrTemplateTail = isTemplateMiddleOrTemplateTail;
	    function isStringTextContainingNode(node) {
	        return node.kind === 9 /* StringLiteral */ || isTemplateLiteralKind(node.kind);
	    }
	    ts.isStringTextContainingNode = isStringTextContainingNode;
	    // Identifiers
	    /* @internal */
	    function isGeneratedIdentifier(node) {
	        // Using `>` here catches both `GeneratedIdentifierKind.None` and `undefined`.
	        return ts.isIdentifier(node) && (node.autoGenerateFlags & 7 /* KindMask */) > 0 /* None */;
	    }
	    ts.isGeneratedIdentifier = isGeneratedIdentifier;
	    // Keywords
	    /* @internal */
	    function isModifierKind(token) {
	        switch (token) {
	            case 117 /* AbstractKeyword */:
	            case 120 /* AsyncKeyword */:
	            case 76 /* ConstKeyword */:
	            case 124 /* DeclareKeyword */:
	            case 79 /* DefaultKeyword */:
	            case 84 /* ExportKeyword */:
	            case 114 /* PublicKeyword */:
	            case 112 /* PrivateKeyword */:
	            case 113 /* ProtectedKeyword */:
	            case 132 /* ReadonlyKeyword */:
	            case 115 /* StaticKeyword */:
	                return true;
	        }
	        return false;
	    }
	    ts.isModifierKind = isModifierKind;
	    function isModifier(node) {
	        return isModifierKind(node.kind);
	    }
	    ts.isModifier = isModifier;
	    function isEntityName(node) {
	        var kind = node.kind;
	        return kind === 145 /* QualifiedName */
	            || kind === 71 /* Identifier */;
	    }
	    ts.isEntityName = isEntityName;
	    function isPropertyName(node) {
	        var kind = node.kind;
	        return kind === 71 /* Identifier */
	            || kind === 9 /* StringLiteral */
	            || kind === 8 /* NumericLiteral */
	            || kind === 146 /* ComputedPropertyName */;
	    }
	    ts.isPropertyName = isPropertyName;
	    function isBindingName(node) {
	        var kind = node.kind;
	        return kind === 71 /* Identifier */
	            || kind === 178 /* ObjectBindingPattern */
	            || kind === 179 /* ArrayBindingPattern */;
	    }
	    ts.isBindingName = isBindingName;
	    // Functions
	    function isFunctionLike(node) {
	        return node && isFunctionLikeKind(node.kind);
	    }
	    ts.isFunctionLike = isFunctionLike;
	    /* @internal */
	    function isFunctionLikeDeclaration(node) {
	        return node && isFunctionLikeDeclarationKind(node.kind);
	    }
	    ts.isFunctionLikeDeclaration = isFunctionLikeDeclaration;
	    function isFunctionLikeDeclarationKind(kind) {
	        switch (kind) {
	            case 232 /* FunctionDeclaration */:
	            case 153 /* MethodDeclaration */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 190 /* FunctionExpression */:
	            case 191 /* ArrowFunction */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    /* @internal */
	    function isFunctionLikeKind(kind) {
	        switch (kind) {
	            case 152 /* MethodSignature */:
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	            case 162 /* FunctionType */:
	            case 280 /* JSDocFunctionType */:
	            case 163 /* ConstructorType */:
	                return true;
	            default:
	                return isFunctionLikeDeclarationKind(kind);
	        }
	    }
	    ts.isFunctionLikeKind = isFunctionLikeKind;
	    /* @internal */
	    function isFunctionOrModuleBlock(node) {
	        return ts.isSourceFile(node) || ts.isModuleBlock(node) || ts.isBlock(node) && isFunctionLike(node.parent);
	    }
	    ts.isFunctionOrModuleBlock = isFunctionOrModuleBlock;
	    // Classes
	    function isClassElement(node) {
	        var kind = node.kind;
	        return kind === 154 /* Constructor */
	            || kind === 151 /* PropertyDeclaration */
	            || kind === 153 /* MethodDeclaration */
	            || kind === 155 /* GetAccessor */
	            || kind === 156 /* SetAccessor */
	            || kind === 159 /* IndexSignature */
	            || kind === 210 /* SemicolonClassElement */
	            || kind === 251 /* MissingDeclaration */;
	    }
	    ts.isClassElement = isClassElement;
	    function isClassLike(node) {
	        return node && (node.kind === 233 /* ClassDeclaration */ || node.kind === 203 /* ClassExpression */);
	    }
	    ts.isClassLike = isClassLike;
	    function isAccessor(node) {
	        return node && (node.kind === 155 /* GetAccessor */ || node.kind === 156 /* SetAccessor */);
	    }
	    ts.isAccessor = isAccessor;
	    /* @internal */
	    function isMethodOrAccessor(node) {
	        switch (node.kind) {
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isMethodOrAccessor = isMethodOrAccessor;
	    // Type members
	    function isTypeElement(node) {
	        var kind = node.kind;
	        return kind === 158 /* ConstructSignature */
	            || kind === 157 /* CallSignature */
	            || kind === 150 /* PropertySignature */
	            || kind === 152 /* MethodSignature */
	            || kind === 159 /* IndexSignature */
	            || kind === 251 /* MissingDeclaration */;
	    }
	    ts.isTypeElement = isTypeElement;
	    function isObjectLiteralElementLike(node) {
	        var kind = node.kind;
	        return kind === 268 /* PropertyAssignment */
	            || kind === 269 /* ShorthandPropertyAssignment */
	            || kind === 270 /* SpreadAssignment */
	            || kind === 153 /* MethodDeclaration */
	            || kind === 155 /* GetAccessor */
	            || kind === 156 /* SetAccessor */
	            || kind === 251 /* MissingDeclaration */;
	    }
	    ts.isObjectLiteralElementLike = isObjectLiteralElementLike;
	    // Type
	    function isTypeNodeKind(kind) {
	        return (kind >= 160 /* FirstTypeNode */ && kind <= 177 /* LastTypeNode */)
	            || kind === 119 /* AnyKeyword */
	            || kind === 134 /* NumberKeyword */
	            || kind === 135 /* ObjectKeyword */
	            || kind === 122 /* BooleanKeyword */
	            || kind === 137 /* StringKeyword */
	            || kind === 138 /* SymbolKeyword */
	            || kind === 99 /* ThisKeyword */
	            || kind === 105 /* VoidKeyword */
	            || kind === 140 /* UndefinedKeyword */
	            || kind === 95 /* NullKeyword */
	            || kind === 131 /* NeverKeyword */
	            || kind === 205 /* ExpressionWithTypeArguments */
	            || kind === 275 /* JSDocAllType */
	            || kind === 276 /* JSDocUnknownType */
	            || kind === 277 /* JSDocNullableType */
	            || kind === 278 /* JSDocNonNullableType */
	            || kind === 279 /* JSDocOptionalType */
	            || kind === 280 /* JSDocFunctionType */
	            || kind === 281 /* JSDocVariadicType */;
	    }
	    /**
	     * Node test that determines whether a node is a valid type node.
	     * This differs from the `isPartOfTypeNode` function which determines whether a node is *part*
	     * of a TypeNode.
	     */
	    function isTypeNode(node) {
	        return isTypeNodeKind(node.kind);
	    }
	    ts.isTypeNode = isTypeNode;
	    function isFunctionOrConstructorTypeNode(node) {
	        switch (node.kind) {
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	                return true;
	        }
	        return false;
	    }
	    ts.isFunctionOrConstructorTypeNode = isFunctionOrConstructorTypeNode;
	    // Binding patterns
	    /* @internal */
	    function isBindingPattern(node) {
	        if (node) {
	            var kind = node.kind;
	            return kind === 179 /* ArrayBindingPattern */
	                || kind === 178 /* ObjectBindingPattern */;
	        }
	        return false;
	    }
	    ts.isBindingPattern = isBindingPattern;
	    /* @internal */
	    function isAssignmentPattern(node) {
	        var kind = node.kind;
	        return kind === 181 /* ArrayLiteralExpression */
	            || kind === 182 /* ObjectLiteralExpression */;
	    }
	    ts.isAssignmentPattern = isAssignmentPattern;
	    /* @internal */
	    function isArrayBindingElement(node) {
	        var kind = node.kind;
	        return kind === 180 /* BindingElement */
	            || kind === 204 /* OmittedExpression */;
	    }
	    ts.isArrayBindingElement = isArrayBindingElement;
	    /**
	     * Determines whether the BindingOrAssignmentElement is a BindingElement-like declaration
	     */
	    /* @internal */
	    function isDeclarationBindingElement(bindingElement) {
	        switch (bindingElement.kind) {
	            case 230 /* VariableDeclaration */:
	            case 148 /* Parameter */:
	            case 180 /* BindingElement */:
	                return true;
	        }
	        return false;
	    }
	    ts.isDeclarationBindingElement = isDeclarationBindingElement;
	    /**
	     * Determines whether a node is a BindingOrAssignmentPattern
	     */
	    /* @internal */
	    function isBindingOrAssignmentPattern(node) {
	        return isObjectBindingOrAssignmentPattern(node)
	            || isArrayBindingOrAssignmentPattern(node);
	    }
	    ts.isBindingOrAssignmentPattern = isBindingOrAssignmentPattern;
	    /**
	     * Determines whether a node is an ObjectBindingOrAssignmentPattern
	     */
	    /* @internal */
	    function isObjectBindingOrAssignmentPattern(node) {
	        switch (node.kind) {
	            case 178 /* ObjectBindingPattern */:
	            case 182 /* ObjectLiteralExpression */:
	                return true;
	        }
	        return false;
	    }
	    ts.isObjectBindingOrAssignmentPattern = isObjectBindingOrAssignmentPattern;
	    /**
	     * Determines whether a node is an ArrayBindingOrAssignmentPattern
	     */
	    /* @internal */
	    function isArrayBindingOrAssignmentPattern(node) {
	        switch (node.kind) {
	            case 179 /* ArrayBindingPattern */:
	            case 181 /* ArrayLiteralExpression */:
	                return true;
	        }
	        return false;
	    }
	    ts.isArrayBindingOrAssignmentPattern = isArrayBindingOrAssignmentPattern;
	    // Expression
	    function isPropertyAccessOrQualifiedName(node) {
	        var kind = node.kind;
	        return kind === 183 /* PropertyAccessExpression */
	            || kind === 145 /* QualifiedName */;
	    }
	    ts.isPropertyAccessOrQualifiedName = isPropertyAccessOrQualifiedName;
	    function isCallLikeExpression(node) {
	        switch (node.kind) {
	            case 255 /* JsxOpeningElement */:
	            case 254 /* JsxSelfClosingElement */:
	            case 185 /* CallExpression */:
	            case 186 /* NewExpression */:
	            case 187 /* TaggedTemplateExpression */:
	            case 149 /* Decorator */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isCallLikeExpression = isCallLikeExpression;
	    function isCallOrNewExpression(node) {
	        return node.kind === 185 /* CallExpression */ || node.kind === 186 /* NewExpression */;
	    }
	    ts.isCallOrNewExpression = isCallOrNewExpression;
	    function isTemplateLiteral(node) {
	        var kind = node.kind;
	        return kind === 200 /* TemplateExpression */
	            || kind === 13 /* NoSubstitutionTemplateLiteral */;
	    }
	    ts.isTemplateLiteral = isTemplateLiteral;
	    /* @internal */
	    function isLeftHandSideExpression(node) {
	        return isLeftHandSideExpressionKind(ts.skipPartiallyEmittedExpressions(node).kind);
	    }
	    ts.isLeftHandSideExpression = isLeftHandSideExpression;
	    function isLeftHandSideExpressionKind(kind) {
	        switch (kind) {
	            case 183 /* PropertyAccessExpression */:
	            case 184 /* ElementAccessExpression */:
	            case 186 /* NewExpression */:
	            case 185 /* CallExpression */:
	            case 253 /* JsxElement */:
	            case 254 /* JsxSelfClosingElement */:
	            case 257 /* JsxFragment */:
	            case 187 /* TaggedTemplateExpression */:
	            case 181 /* ArrayLiteralExpression */:
	            case 189 /* ParenthesizedExpression */:
	            case 182 /* ObjectLiteralExpression */:
	            case 203 /* ClassExpression */:
	            case 190 /* FunctionExpression */:
	            case 71 /* Identifier */:
	            case 12 /* RegularExpressionLiteral */:
	            case 8 /* NumericLiteral */:
	            case 9 /* StringLiteral */:
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 200 /* TemplateExpression */:
	            case 86 /* FalseKeyword */:
	            case 95 /* NullKeyword */:
	            case 99 /* ThisKeyword */:
	            case 101 /* TrueKeyword */:
	            case 97 /* SuperKeyword */:
	            case 207 /* NonNullExpression */:
	            case 208 /* MetaProperty */:
	            case 91 /* ImportKeyword */:// technically this is only an Expression if it's in a CallExpression
	                return true;
	            default:
	                return false;
	        }
	    }
	    /* @internal */
	    function isUnaryExpression(node) {
	        return isUnaryExpressionKind(ts.skipPartiallyEmittedExpressions(node).kind);
	    }
	    ts.isUnaryExpression = isUnaryExpression;
	    function isUnaryExpressionKind(kind) {
	        switch (kind) {
	            case 196 /* PrefixUnaryExpression */:
	            case 197 /* PostfixUnaryExpression */:
	            case 192 /* DeleteExpression */:
	            case 193 /* TypeOfExpression */:
	            case 194 /* VoidExpression */:
	            case 195 /* AwaitExpression */:
	            case 188 /* TypeAssertionExpression */:
	                return true;
	            default:
	                return isLeftHandSideExpressionKind(kind);
	        }
	    }
	    /* @internal */
	    function isUnaryExpressionWithWrite(expr) {
	        switch (expr.kind) {
	            case 197 /* PostfixUnaryExpression */:
	                return true;
	            case 196 /* PrefixUnaryExpression */:
	                return expr.operator === 43 /* PlusPlusToken */ ||
	                    expr.operator === 44 /* MinusMinusToken */;
	            default:
	                return false;
	        }
	    }
	    ts.isUnaryExpressionWithWrite = isUnaryExpressionWithWrite;
	    /* @internal */
	    /**
	     * Determines whether a node is an expression based only on its kind.
	     * Use `isExpressionNode` if not in transforms.
	     */
	    function isExpression(node) {
	        return isExpressionKind(ts.skipPartiallyEmittedExpressions(node).kind);
	    }
	    ts.isExpression = isExpression;
	    function isExpressionKind(kind) {
	        switch (kind) {
	            case 199 /* ConditionalExpression */:
	            case 201 /* YieldExpression */:
	            case 191 /* ArrowFunction */:
	            case 198 /* BinaryExpression */:
	            case 202 /* SpreadElement */:
	            case 206 /* AsExpression */:
	            case 204 /* OmittedExpression */:
	            case 296 /* CommaListExpression */:
	            case 295 /* PartiallyEmittedExpression */:
	                return true;
	            default:
	                return isUnaryExpressionKind(kind);
	        }
	    }
	    function isAssertionExpression(node) {
	        var kind = node.kind;
	        return kind === 188 /* TypeAssertionExpression */
	            || kind === 206 /* AsExpression */;
	    }
	    ts.isAssertionExpression = isAssertionExpression;
	    /* @internal */
	    function isPartiallyEmittedExpression(node) {
	        return node.kind === 295 /* PartiallyEmittedExpression */;
	    }
	    ts.isPartiallyEmittedExpression = isPartiallyEmittedExpression;
	    /* @internal */
	    function isNotEmittedStatement(node) {
	        return node.kind === 294 /* NotEmittedStatement */;
	    }
	    ts.isNotEmittedStatement = isNotEmittedStatement;
	    /* @internal */
	    function isNotEmittedOrPartiallyEmittedNode(node) {
	        return isNotEmittedStatement(node)
	            || isPartiallyEmittedExpression(node);
	    }
	    ts.isNotEmittedOrPartiallyEmittedNode = isNotEmittedOrPartiallyEmittedNode;
	    // Statement
	    function isIterationStatement(node, lookInLabeledStatements) {
	        switch (node.kind) {
	            case 218 /* ForStatement */:
	            case 219 /* ForInStatement */:
	            case 220 /* ForOfStatement */:
	            case 216 /* DoStatement */:
	            case 217 /* WhileStatement */:
	                return true;
	            case 226 /* LabeledStatement */:
	                return lookInLabeledStatements && isIterationStatement(node.statement, lookInLabeledStatements);
	        }
	        return false;
	    }
	    ts.isIterationStatement = isIterationStatement;
	    /* @internal */
	    function isForInOrOfStatement(node) {
	        return node.kind === 219 /* ForInStatement */ || node.kind === 220 /* ForOfStatement */;
	    }
	    ts.isForInOrOfStatement = isForInOrOfStatement;
	    // Element
	    /* @internal */
	    function isConciseBody(node) {
	        return ts.isBlock(node)
	            || isExpression(node);
	    }
	    ts.isConciseBody = isConciseBody;
	    /* @internal */
	    function isFunctionBody(node) {
	        return ts.isBlock(node);
	    }
	    ts.isFunctionBody = isFunctionBody;
	    /* @internal */
	    function isForInitializer(node) {
	        return ts.isVariableDeclarationList(node)
	            || isExpression(node);
	    }
	    ts.isForInitializer = isForInitializer;
	    /* @internal */
	    function isModuleBody(node) {
	        var kind = node.kind;
	        return kind === 238 /* ModuleBlock */
	            || kind === 237 /* ModuleDeclaration */
	            || kind === 71 /* Identifier */;
	    }
	    ts.isModuleBody = isModuleBody;
	    /* @internal */
	    function isNamespaceBody(node) {
	        var kind = node.kind;
	        return kind === 238 /* ModuleBlock */
	            || kind === 237 /* ModuleDeclaration */;
	    }
	    ts.isNamespaceBody = isNamespaceBody;
	    /* @internal */
	    function isJSDocNamespaceBody(node) {
	        var kind = node.kind;
	        return kind === 71 /* Identifier */
	            || kind === 237 /* ModuleDeclaration */;
	    }
	    ts.isJSDocNamespaceBody = isJSDocNamespaceBody;
	    /* @internal */
	    function isNamedImportBindings(node) {
	        var kind = node.kind;
	        return kind === 245 /* NamedImports */
	            || kind === 244 /* NamespaceImport */;
	    }
	    ts.isNamedImportBindings = isNamedImportBindings;
	    /* @internal */
	    function isModuleOrEnumDeclaration(node) {
	        return node.kind === 237 /* ModuleDeclaration */ || node.kind === 236 /* EnumDeclaration */;
	    }
	    ts.isModuleOrEnumDeclaration = isModuleOrEnumDeclaration;
	    function isDeclarationKind(kind) {
	        return kind === 191 /* ArrowFunction */
	            || kind === 180 /* BindingElement */
	            || kind === 233 /* ClassDeclaration */
	            || kind === 203 /* ClassExpression */
	            || kind === 154 /* Constructor */
	            || kind === 236 /* EnumDeclaration */
	            || kind === 271 /* EnumMember */
	            || kind === 250 /* ExportSpecifier */
	            || kind === 232 /* FunctionDeclaration */
	            || kind === 190 /* FunctionExpression */
	            || kind === 155 /* GetAccessor */
	            || kind === 243 /* ImportClause */
	            || kind === 241 /* ImportEqualsDeclaration */
	            || kind === 246 /* ImportSpecifier */
	            || kind === 234 /* InterfaceDeclaration */
	            || kind === 260 /* JsxAttribute */
	            || kind === 153 /* MethodDeclaration */
	            || kind === 152 /* MethodSignature */
	            || kind === 237 /* ModuleDeclaration */
	            || kind === 240 /* NamespaceExportDeclaration */
	            || kind === 244 /* NamespaceImport */
	            || kind === 148 /* Parameter */
	            || kind === 268 /* PropertyAssignment */
	            || kind === 151 /* PropertyDeclaration */
	            || kind === 150 /* PropertySignature */
	            || kind === 156 /* SetAccessor */
	            || kind === 269 /* ShorthandPropertyAssignment */
	            || kind === 235 /* TypeAliasDeclaration */
	            || kind === 147 /* TypeParameter */
	            || kind === 230 /* VariableDeclaration */
	            || kind === 291 /* JSDocTypedefTag */;
	    }
	    function isDeclarationStatementKind(kind) {
	        return kind === 232 /* FunctionDeclaration */
	            || kind === 251 /* MissingDeclaration */
	            || kind === 233 /* ClassDeclaration */
	            || kind === 234 /* InterfaceDeclaration */
	            || kind === 235 /* TypeAliasDeclaration */
	            || kind === 236 /* EnumDeclaration */
	            || kind === 237 /* ModuleDeclaration */
	            || kind === 242 /* ImportDeclaration */
	            || kind === 241 /* ImportEqualsDeclaration */
	            || kind === 248 /* ExportDeclaration */
	            || kind === 247 /* ExportAssignment */
	            || kind === 240 /* NamespaceExportDeclaration */;
	    }
	    function isStatementKindButNotDeclarationKind(kind) {
	        return kind === 222 /* BreakStatement */
	            || kind === 221 /* ContinueStatement */
	            || kind === 229 /* DebuggerStatement */
	            || kind === 216 /* DoStatement */
	            || kind === 214 /* ExpressionStatement */
	            || kind === 213 /* EmptyStatement */
	            || kind === 219 /* ForInStatement */
	            || kind === 220 /* ForOfStatement */
	            || kind === 218 /* ForStatement */
	            || kind === 215 /* IfStatement */
	            || kind === 226 /* LabeledStatement */
	            || kind === 223 /* ReturnStatement */
	            || kind === 225 /* SwitchStatement */
	            || kind === 227 /* ThrowStatement */
	            || kind === 228 /* TryStatement */
	            || kind === 212 /* VariableStatement */
	            || kind === 217 /* WhileStatement */
	            || kind === 224 /* WithStatement */
	            || kind === 294 /* NotEmittedStatement */
	            || kind === 298 /* EndOfDeclarationMarker */
	            || kind === 297 /* MergeDeclarationMarker */;
	    }
	    /* @internal */
	    function isDeclaration(node) {
	        if (node.kind === 147 /* TypeParameter */) {
	            return node.parent.kind !== 290 /* JSDocTemplateTag */ || ts.isInJavaScriptFile(node);
	        }
	        return isDeclarationKind(node.kind);
	    }
	    ts.isDeclaration = isDeclaration;
	    /* @internal */
	    function isDeclarationStatement(node) {
	        return isDeclarationStatementKind(node.kind);
	    }
	    ts.isDeclarationStatement = isDeclarationStatement;
	    /**
	     * Determines whether the node is a statement that is not also a declaration
	     */
	    /* @internal */
	    function isStatementButNotDeclaration(node) {
	        return isStatementKindButNotDeclarationKind(node.kind);
	    }
	    ts.isStatementButNotDeclaration = isStatementButNotDeclaration;
	    /* @internal */
	    function isStatement(node) {
	        var kind = node.kind;
	        return isStatementKindButNotDeclarationKind(kind)
	            || isDeclarationStatementKind(kind)
	            || isBlockStatement(node);
	    }
	    ts.isStatement = isStatement;
	    function isBlockStatement(node) {
	        if (node.kind !== 211 /* Block */)
	            return false;
	        if (node.parent !== undefined) {
	            if (node.parent.kind === 228 /* TryStatement */ || node.parent.kind === 267 /* CatchClause */) {
	                return false;
	            }
	        }
	        return !ts.isFunctionBlock(node);
	    }
	    // Module references
	    /* @internal */
	    function isModuleReference(node) {
	        var kind = node.kind;
	        return kind === 252 /* ExternalModuleReference */
	            || kind === 145 /* QualifiedName */
	            || kind === 71 /* Identifier */;
	    }
	    ts.isModuleReference = isModuleReference;
	    // JSX
	    /* @internal */
	    function isJsxTagNameExpression(node) {
	        var kind = node.kind;
	        return kind === 99 /* ThisKeyword */
	            || kind === 71 /* Identifier */
	            || kind === 183 /* PropertyAccessExpression */;
	    }
	    ts.isJsxTagNameExpression = isJsxTagNameExpression;
	    /* @internal */
	    function isJsxChild(node) {
	        var kind = node.kind;
	        return kind === 253 /* JsxElement */
	            || kind === 263 /* JsxExpression */
	            || kind === 254 /* JsxSelfClosingElement */
	            || kind === 10 /* JsxText */
	            || kind === 257 /* JsxFragment */;
	    }
	    ts.isJsxChild = isJsxChild;
	    /* @internal */
	    function isJsxAttributeLike(node) {
	        var kind = node.kind;
	        return kind === 260 /* JsxAttribute */
	            || kind === 262 /* JsxSpreadAttribute */;
	    }
	    ts.isJsxAttributeLike = isJsxAttributeLike;
	    /* @internal */
	    function isStringLiteralOrJsxExpression(node) {
	        var kind = node.kind;
	        return kind === 9 /* StringLiteral */
	            || kind === 263 /* JsxExpression */;
	    }
	    ts.isStringLiteralOrJsxExpression = isStringLiteralOrJsxExpression;
	    function isJsxOpeningLikeElement(node) {
	        var kind = node.kind;
	        return kind === 255 /* JsxOpeningElement */
	            || kind === 254 /* JsxSelfClosingElement */;
	    }
	    ts.isJsxOpeningLikeElement = isJsxOpeningLikeElement;
	    // Clauses
	    function isCaseOrDefaultClause(node) {
	        var kind = node.kind;
	        return kind === 264 /* CaseClause */
	            || kind === 265 /* DefaultClause */;
	    }
	    ts.isCaseOrDefaultClause = isCaseOrDefaultClause;
	    // JSDoc
	    /** True if node is of some JSDoc syntax kind. */
	    /* @internal */
	    function isJSDocNode(node) {
	        return node.kind >= 274 /* FirstJSDocNode */ && node.kind <= 292 /* LastJSDocNode */;
	    }
	    ts.isJSDocNode = isJSDocNode;
	    /** True if node is of a kind that may contain comment text. */
	    function isJSDocCommentContainingNode(node) {
	        return node.kind === 282 /* JSDocComment */ || isJSDocTag(node) || ts.isJSDocTypeLiteral(node);
	    }
	    ts.isJSDocCommentContainingNode = isJSDocCommentContainingNode;
	    // TODO: determine what this does before making it public.
	    /* @internal */
	    function isJSDocTag(node) {
	        return node.kind >= 284 /* FirstJSDocTagNode */ && node.kind <= 292 /* LastJSDocTagNode */;
	    }
	    ts.isJSDocTag = isJSDocTag;
	    function isSetAccessor(node) {
	        return node.kind === 156 /* SetAccessor */;
	    }
	    ts.isSetAccessor = isSetAccessor;
	    function isGetAccessor(node) {
	        return node.kind === 155 /* GetAccessor */;
	    }
	    ts.isGetAccessor = isGetAccessor;
	    /** True if has jsdoc nodes attached to it. */
	    /* @internal */
	    function hasJSDocNodes(node) {
	        return !!node.jsDoc && node.jsDoc.length > 0;
	    }
	    ts.hasJSDocNodes = hasJSDocNodes;
	    /** True if has type node attached to it. */
	    /* @internal */
	    function hasType(node) {
	        return !!node.type;
	    }
	    ts.hasType = hasType;
	    /** True if has initializer node attached to it. */
	    /* @internal */
	    function hasInitializer(node) {
	        return !!node.initializer;
	    }
	    ts.hasInitializer = hasInitializer;
	    /** True if has initializer node attached to it. */
	    /* @internal */
	    function hasOnlyExpressionInitializer(node) {
	        return hasInitializer(node) && !ts.isForStatement(node) && !ts.isForInStatement(node) && !ts.isForOfStatement(node) && !ts.isJsxAttribute(node);
	    }
	    ts.hasOnlyExpressionInitializer = hasOnlyExpressionInitializer;
	    function isObjectLiteralElement(node) {
	        switch (node.kind) {
	            case 260 /* JsxAttribute */:
	            case 262 /* JsxSpreadAttribute */:
	            case 268 /* PropertyAssignment */:
	            case 269 /* ShorthandPropertyAssignment */:
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isObjectLiteralElement = isObjectLiteralElement;
	    /* @internal */
	    function isTypeReferenceType(node) {
	        return node.kind === 161 /* TypeReference */ || node.kind === 205 /* ExpressionWithTypeArguments */;
	    }
	    ts.isTypeReferenceType = isTypeReferenceType;
	    function isStringLiteralLike(node) {
	        return node.kind === 9 /* StringLiteral */ || node.kind === 13 /* NoSubstitutionTemplateLiteral */;
	    }
	    ts.isStringLiteralLike = isStringLiteralLike;
	})(ts || (ts = {}));
	/// <reference path="utilities.ts"/>
	/// <reference path="scanner.ts"/>
	var ts;
	(function (ts) {
	    var SignatureFlags;
	    (function (SignatureFlags) {
	        SignatureFlags[SignatureFlags["None"] = 0] = "None";
	        SignatureFlags[SignatureFlags["Yield"] = 1] = "Yield";
	        SignatureFlags[SignatureFlags["Await"] = 2] = "Await";
	        SignatureFlags[SignatureFlags["Type"] = 4] = "Type";
	        SignatureFlags[SignatureFlags["RequireCompleteParameterList"] = 8] = "RequireCompleteParameterList";
	        SignatureFlags[SignatureFlags["IgnoreMissingOpenBrace"] = 16] = "IgnoreMissingOpenBrace";
	        SignatureFlags[SignatureFlags["JSDoc"] = 32] = "JSDoc";
	    })(SignatureFlags || (SignatureFlags = {}));
	    // tslint:disable variable-name
	    var NodeConstructor;
	    var TokenConstructor;
	    var IdentifierConstructor;
	    var SourceFileConstructor;
	    // tslint:enable variable-name
	    function createNode(kind, pos, end) {
	        if (kind === 272 /* SourceFile */) {
	            return new (SourceFileConstructor || (SourceFileConstructor = ts.objectAllocator.getSourceFileConstructor()))(kind, pos, end);
	        }
	        else if (kind === 71 /* Identifier */) {
	            return new (IdentifierConstructor || (IdentifierConstructor = ts.objectAllocator.getIdentifierConstructor()))(kind, pos, end);
	        }
	        else if (!ts.isNodeKind(kind)) {
	            return new (TokenConstructor || (TokenConstructor = ts.objectAllocator.getTokenConstructor()))(kind, pos, end);
	        }
	        else {
	            return new (NodeConstructor || (NodeConstructor = ts.objectAllocator.getNodeConstructor()))(kind, pos, end);
	        }
	    }
	    ts.createNode = createNode;
	    function visitNode(cbNode, node) {
	        return node && cbNode(node);
	    }
	    function visitNodes(cbNode, cbNodes, nodes) {
	        if (nodes) {
	            if (cbNodes) {
	                return cbNodes(nodes);
	            }
	            for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
	                var node = nodes_1[_i];
	                var result = cbNode(node);
	                if (result) {
	                    return result;
	                }
	            }
	        }
	    }
	    /**
	     * Invokes a callback for each child of the given node. The 'cbNode' callback is invoked for all child nodes
	     * stored in properties. If a 'cbNodes' callback is specified, it is invoked for embedded arrays; otherwise,
	     * embedded arrays are flattened and the 'cbNode' callback is invoked for each element. If a callback returns
	     * a truthy value, iteration stops and that value is returned. Otherwise, undefined is returned.
	     *
	     * @param node a given node to visit its children
	     * @param cbNode a callback to be invoked for all child nodes
	     * @param cbNodes a callback to be invoked for embedded array
	     *
	     * @remarks `forEachChild` must visit the children of a node in the order
	     * that they appear in the source code. The language service depends on this property to locate nodes by position.
	     */
	    function forEachChild(node, cbNode, cbNodes) {
	        if (!node || node.kind <= 144 /* LastToken */) {
	            return;
	        }
	        switch (node.kind) {
	            case 145 /* QualifiedName */:
	                return visitNode(cbNode, node.left) ||
	                    visitNode(cbNode, node.right);
	            case 147 /* TypeParameter */:
	                return visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.constraint) ||
	                    visitNode(cbNode, node.default) ||
	                    visitNode(cbNode, node.expression);
	            case 269 /* ShorthandPropertyAssignment */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.equalsToken) ||
	                    visitNode(cbNode, node.objectAssignmentInitializer);
	            case 270 /* SpreadAssignment */:
	                return visitNode(cbNode, node.expression);
	            case 148 /* Parameter */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.dotDotDotToken) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.initializer);
	            case 151 /* PropertyDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.exclamationToken) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.initializer);
	            case 150 /* PropertySignature */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.initializer);
	            case 268 /* PropertyAssignment */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.initializer);
	            case 230 /* VariableDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.exclamationToken) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.initializer);
	            case 180 /* BindingElement */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.dotDotDotToken) ||
	                    visitNode(cbNode, node.propertyName) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.initializer);
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.parameters) ||
	                    visitNode(cbNode, node.type);
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 190 /* FunctionExpression */:
	            case 232 /* FunctionDeclaration */:
	            case 191 /* ArrowFunction */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.asteriskToken) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.parameters) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.equalsGreaterThanToken) ||
	                    visitNode(cbNode, node.body);
	            case 161 /* TypeReference */:
	                return visitNode(cbNode, node.typeName) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments);
	            case 160 /* TypePredicate */:
	                return visitNode(cbNode, node.parameterName) ||
	                    visitNode(cbNode, node.type);
	            case 164 /* TypeQuery */:
	                return visitNode(cbNode, node.exprName);
	            case 165 /* TypeLiteral */:
	                return visitNodes(cbNode, cbNodes, node.members);
	            case 166 /* ArrayType */:
	                return visitNode(cbNode, node.elementType);
	            case 167 /* TupleType */:
	                return visitNodes(cbNode, cbNodes, node.elementTypes);
	            case 168 /* UnionType */:
	            case 169 /* IntersectionType */:
	                return visitNodes(cbNode, cbNodes, node.types);
	            case 170 /* ConditionalType */:
	                return visitNode(cbNode, node.checkType) ||
	                    visitNode(cbNode, node.extendsType) ||
	                    visitNode(cbNode, node.trueType) ||
	                    visitNode(cbNode, node.falseType);
	            case 171 /* InferType */:
	                return visitNode(cbNode, node.typeParameter);
	            case 172 /* ParenthesizedType */:
	            case 174 /* TypeOperator */:
	                return visitNode(cbNode, node.type);
	            case 175 /* IndexedAccessType */:
	                return visitNode(cbNode, node.objectType) ||
	                    visitNode(cbNode, node.indexType);
	            case 176 /* MappedType */:
	                return visitNode(cbNode, node.readonlyToken) ||
	                    visitNode(cbNode, node.typeParameter) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.type);
	            case 177 /* LiteralType */:
	                return visitNode(cbNode, node.literal);
	            case 178 /* ObjectBindingPattern */:
	            case 179 /* ArrayBindingPattern */:
	                return visitNodes(cbNode, cbNodes, node.elements);
	            case 181 /* ArrayLiteralExpression */:
	                return visitNodes(cbNode, cbNodes, node.elements);
	            case 182 /* ObjectLiteralExpression */:
	                return visitNodes(cbNode, cbNodes, node.properties);
	            case 183 /* PropertyAccessExpression */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.name);
	            case 184 /* ElementAccessExpression */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.argumentExpression);
	            case 185 /* CallExpression */:
	            case 186 /* NewExpression */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments) ||
	                    visitNodes(cbNode, cbNodes, node.arguments);
	            case 187 /* TaggedTemplateExpression */:
	                return visitNode(cbNode, node.tag) ||
	                    visitNode(cbNode, node.template);
	            case 188 /* TypeAssertionExpression */:
	                return visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.expression);
	            case 189 /* ParenthesizedExpression */:
	                return visitNode(cbNode, node.expression);
	            case 192 /* DeleteExpression */:
	                return visitNode(cbNode, node.expression);
	            case 193 /* TypeOfExpression */:
	                return visitNode(cbNode, node.expression);
	            case 194 /* VoidExpression */:
	                return visitNode(cbNode, node.expression);
	            case 196 /* PrefixUnaryExpression */:
	                return visitNode(cbNode, node.operand);
	            case 201 /* YieldExpression */:
	                return visitNode(cbNode, node.asteriskToken) ||
	                    visitNode(cbNode, node.expression);
	            case 195 /* AwaitExpression */:
	                return visitNode(cbNode, node.expression);
	            case 197 /* PostfixUnaryExpression */:
	                return visitNode(cbNode, node.operand);
	            case 198 /* BinaryExpression */:
	                return visitNode(cbNode, node.left) ||
	                    visitNode(cbNode, node.operatorToken) ||
	                    visitNode(cbNode, node.right);
	            case 206 /* AsExpression */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.type);
	            case 207 /* NonNullExpression */:
	                return visitNode(cbNode, node.expression);
	            case 208 /* MetaProperty */:
	                return visitNode(cbNode, node.name);
	            case 199 /* ConditionalExpression */:
	                return visitNode(cbNode, node.condition) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.whenTrue) ||
	                    visitNode(cbNode, node.colonToken) ||
	                    visitNode(cbNode, node.whenFalse);
	            case 202 /* SpreadElement */:
	                return visitNode(cbNode, node.expression);
	            case 211 /* Block */:
	            case 238 /* ModuleBlock */:
	                return visitNodes(cbNode, cbNodes, node.statements);
	            case 272 /* SourceFile */:
	                return visitNodes(cbNode, cbNodes, node.statements) ||
	                    visitNode(cbNode, node.endOfFileToken);
	            case 212 /* VariableStatement */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.declarationList);
	            case 231 /* VariableDeclarationList */:
	                return visitNodes(cbNode, cbNodes, node.declarations);
	            case 214 /* ExpressionStatement */:
	                return visitNode(cbNode, node.expression);
	            case 215 /* IfStatement */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.thenStatement) ||
	                    visitNode(cbNode, node.elseStatement);
	            case 216 /* DoStatement */:
	                return visitNode(cbNode, node.statement) ||
	                    visitNode(cbNode, node.expression);
	            case 217 /* WhileStatement */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.statement);
	            case 218 /* ForStatement */:
	                return visitNode(cbNode, node.initializer) ||
	                    visitNode(cbNode, node.condition) ||
	                    visitNode(cbNode, node.incrementor) ||
	                    visitNode(cbNode, node.statement);
	            case 219 /* ForInStatement */:
	                return visitNode(cbNode, node.initializer) ||
	                    visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.statement);
	            case 220 /* ForOfStatement */:
	                return visitNode(cbNode, node.awaitModifier) ||
	                    visitNode(cbNode, node.initializer) ||
	                    visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.statement);
	            case 221 /* ContinueStatement */:
	            case 222 /* BreakStatement */:
	                return visitNode(cbNode, node.label);
	            case 223 /* ReturnStatement */:
	                return visitNode(cbNode, node.expression);
	            case 224 /* WithStatement */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.statement);
	            case 225 /* SwitchStatement */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.caseBlock);
	            case 239 /* CaseBlock */:
	                return visitNodes(cbNode, cbNodes, node.clauses);
	            case 264 /* CaseClause */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNodes(cbNode, cbNodes, node.statements);
	            case 265 /* DefaultClause */:
	                return visitNodes(cbNode, cbNodes, node.statements);
	            case 226 /* LabeledStatement */:
	                return visitNode(cbNode, node.label) ||
	                    visitNode(cbNode, node.statement);
	            case 227 /* ThrowStatement */:
	                return visitNode(cbNode, node.expression);
	            case 228 /* TryStatement */:
	                return visitNode(cbNode, node.tryBlock) ||
	                    visitNode(cbNode, node.catchClause) ||
	                    visitNode(cbNode, node.finallyBlock);
	            case 267 /* CatchClause */:
	                return visitNode(cbNode, node.variableDeclaration) ||
	                    visitNode(cbNode, node.block);
	            case 149 /* Decorator */:
	                return visitNode(cbNode, node.expression);
	            case 233 /* ClassDeclaration */:
	            case 203 /* ClassExpression */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.heritageClauses) ||
	                    visitNodes(cbNode, cbNodes, node.members);
	            case 234 /* InterfaceDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.heritageClauses) ||
	                    visitNodes(cbNode, cbNodes, node.members);
	            case 235 /* TypeAliasDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNode(cbNode, node.type);
	            case 236 /* EnumDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNodes(cbNode, cbNodes, node.members);
	            case 271 /* EnumMember */:
	                return visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.initializer);
	            case 237 /* ModuleDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.body);
	            case 241 /* ImportEqualsDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.moduleReference);
	            case 242 /* ImportDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.importClause) ||
	                    visitNode(cbNode, node.moduleSpecifier);
	            case 243 /* ImportClause */:
	                return visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.namedBindings);
	            case 240 /* NamespaceExportDeclaration */:
	                return visitNode(cbNode, node.name);
	            case 244 /* NamespaceImport */:
	                return visitNode(cbNode, node.name);
	            case 245 /* NamedImports */:
	            case 249 /* NamedExports */:
	                return visitNodes(cbNode, cbNodes, node.elements);
	            case 248 /* ExportDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.exportClause) ||
	                    visitNode(cbNode, node.moduleSpecifier);
	            case 246 /* ImportSpecifier */:
	            case 250 /* ExportSpecifier */:
	                return visitNode(cbNode, node.propertyName) ||
	                    visitNode(cbNode, node.name);
	            case 247 /* ExportAssignment */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.expression);
	            case 200 /* TemplateExpression */:
	                return visitNode(cbNode, node.head) || visitNodes(cbNode, cbNodes, node.templateSpans);
	            case 209 /* TemplateSpan */:
	                return visitNode(cbNode, node.expression) || visitNode(cbNode, node.literal);
	            case 146 /* ComputedPropertyName */:
	                return visitNode(cbNode, node.expression);
	            case 266 /* HeritageClause */:
	                return visitNodes(cbNode, cbNodes, node.types);
	            case 205 /* ExpressionWithTypeArguments */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments);
	            case 252 /* ExternalModuleReference */:
	                return visitNode(cbNode, node.expression);
	            case 251 /* MissingDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators);
	            case 296 /* CommaListExpression */:
	                return visitNodes(cbNode, cbNodes, node.elements);
	            case 253 /* JsxElement */:
	                return visitNode(cbNode, node.openingElement) ||
	                    visitNodes(cbNode, cbNodes, node.children) ||
	                    visitNode(cbNode, node.closingElement);
	            case 257 /* JsxFragment */:
	                return visitNode(cbNode, node.openingFragment) ||
	                    visitNodes(cbNode, cbNodes, node.children) ||
	                    visitNode(cbNode, node.closingFragment);
	            case 254 /* JsxSelfClosingElement */:
	            case 255 /* JsxOpeningElement */:
	                return visitNode(cbNode, node.tagName) ||
	                    visitNode(cbNode, node.attributes);
	            case 261 /* JsxAttributes */:
	                return visitNodes(cbNode, cbNodes, node.properties);
	            case 260 /* JsxAttribute */:
	                return visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.initializer);
	            case 262 /* JsxSpreadAttribute */:
	                return visitNode(cbNode, node.expression);
	            case 263 /* JsxExpression */:
	                return visitNode(cbNode, node.dotDotDotToken) ||
	                    visitNode(cbNode, node.expression);
	            case 256 /* JsxClosingElement */:
	                return visitNode(cbNode, node.tagName);
	            case 274 /* JSDocTypeExpression */:
	                return visitNode(cbNode, node.type);
	            case 278 /* JSDocNonNullableType */:
	                return visitNode(cbNode, node.type);
	            case 277 /* JSDocNullableType */:
	                return visitNode(cbNode, node.type);
	            case 279 /* JSDocOptionalType */:
	                return visitNode(cbNode, node.type);
	            case 280 /* JSDocFunctionType */:
	                return visitNodes(cbNode, cbNodes, node.parameters) ||
	                    visitNode(cbNode, node.type);
	            case 281 /* JSDocVariadicType */:
	                return visitNode(cbNode, node.type);
	            case 282 /* JSDocComment */:
	                return visitNodes(cbNode, cbNodes, node.tags);
	            case 287 /* JSDocParameterTag */:
	            case 292 /* JSDocPropertyTag */:
	                if (node.isNameFirst) {
	                    return visitNode(cbNode, node.name) ||
	                        visitNode(cbNode, node.typeExpression);
	                }
	                else {
	                    return visitNode(cbNode, node.typeExpression) ||
	                        visitNode(cbNode, node.name);
	                }
	            case 288 /* JSDocReturnTag */:
	                return visitNode(cbNode, node.typeExpression);
	            case 289 /* JSDocTypeTag */:
	                return visitNode(cbNode, node.typeExpression);
	            case 285 /* JSDocAugmentsTag */:
	                return visitNode(cbNode, node.class);
	            case 290 /* JSDocTemplateTag */:
	                return visitNodes(cbNode, cbNodes, node.typeParameters);
	            case 291 /* JSDocTypedefTag */:
	                if (node.typeExpression &&
	                    node.typeExpression.kind === 274 /* JSDocTypeExpression */) {
	                    return visitNode(cbNode, node.typeExpression) ||
	                        visitNode(cbNode, node.fullName);
	                }
	                else {
	                    return visitNode(cbNode, node.fullName) ||
	                        visitNode(cbNode, node.typeExpression);
	                }
	            case 283 /* JSDocTypeLiteral */:
	                if (node.jsDocPropertyTags) {
	                    for (var _i = 0, _a = node.jsDocPropertyTags; _i < _a.length; _i++) {
	                        var tag = _a[_i];
	                        visitNode(cbNode, tag);
	                    }
	                }
	                return;
	            case 295 /* PartiallyEmittedExpression */:
	                return visitNode(cbNode, node.expression);
	        }
	    }
	    ts.forEachChild = forEachChild;
	    function createSourceFile(fileName, sourceText, languageVersion, setParentNodes, scriptKind) {
	        if (setParentNodes === void 0) { setParentNodes = false; }
	        ts.performance.mark("beforeParse");
	        var result = Parser.parseSourceFile(fileName, sourceText, languageVersion, /*syntaxCursor*/ undefined, setParentNodes, scriptKind);
	        ts.performance.mark("afterParse");
	        ts.performance.measure("Parse", "beforeParse", "afterParse");
	        return result;
	    }
	    ts.createSourceFile = createSourceFile;
	    function parseIsolatedEntityName(text, languageVersion) {
	        return Parser.parseIsolatedEntityName(text, languageVersion);
	    }
	    ts.parseIsolatedEntityName = parseIsolatedEntityName;
	    /**
	     * Parse json text into SyntaxTree and return node and parse errors if any
	     * @param fileName
	     * @param sourceText
	     */
	    function parseJsonText(fileName, sourceText) {
	        return Parser.parseJsonText(fileName, sourceText);
	    }
	    ts.parseJsonText = parseJsonText;
	    // See also `isExternalOrCommonJsModule` in utilities.ts
	    function isExternalModule(file) {
	        return file.externalModuleIndicator !== undefined;
	    }
	    ts.isExternalModule = isExternalModule;
	    // Produces a new SourceFile for the 'newText' provided. The 'textChangeRange' parameter
	    // indicates what changed between the 'text' that this SourceFile has and the 'newText'.
	    // The SourceFile will be created with the compiler attempting to reuse as many nodes from
	    // this file as possible.
	    //
	    // Note: this function mutates nodes from this SourceFile. That means any existing nodes
	    // from this SourceFile that are being held onto may change as a result (including
	    // becoming detached from any SourceFile).  It is recommended that this SourceFile not
	    // be used once 'update' is called on it.
	    function updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks) {
	        var newSourceFile = IncrementalParser.updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks);
	        // Because new source file node is created, it may not have the flag PossiblyContainDynamicImport. This is the case if there is no new edit to add dynamic import.
	        // We will manually port the flag to the new source file.
	        newSourceFile.flags |= (sourceFile.flags & 524288 /* PossiblyContainsDynamicImport */);
	        return newSourceFile;
	    }
	    ts.updateSourceFile = updateSourceFile;
	    /* @internal */
	    function parseIsolatedJSDocComment(content, start, length) {
	        var result = Parser.JSDocParser.parseIsolatedJSDocComment(content, start, length);
	        if (result && result.jsDoc) {
	            // because the jsDocComment was parsed out of the source file, it might
	            // not be covered by the fixupParentReferences.
	            Parser.fixupParentReferences(result.jsDoc);
	        }
	        return result;
	    }
	    ts.parseIsolatedJSDocComment = parseIsolatedJSDocComment;
	    /* @internal */
	    // Exposed only for testing.
	    function parseJSDocTypeExpressionForTests(content, start, length) {
	        return Parser.JSDocParser.parseJSDocTypeExpressionForTests(content, start, length);
	    }
	    ts.parseJSDocTypeExpressionForTests = parseJSDocTypeExpressionForTests;
	    // Implement the parser as a singleton module.  We do this for perf reasons because creating
	    // parser instances can actually be expensive enough to impact us on projects with many source
	    // files.
	    var Parser;
	    (function (Parser) {
	        // Share a single scanner across all calls to parse a source file.  This helps speed things
	        // up by avoiding the cost of creating/compiling scanners over and over again.
	        var scanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ true);
	        var disallowInAndDecoratorContext = 2048 /* DisallowInContext */ | 8192 /* DecoratorContext */;
	        // capture constructors in 'initializeState' to avoid null checks
	        // tslint:disable variable-name
	        var NodeConstructor;
	        var TokenConstructor;
	        var IdentifierConstructor;
	        var SourceFileConstructor;
	        // tslint:enable variable-name
	        var sourceFile;
	        var parseDiagnostics;
	        var syntaxCursor;
	        var currentToken;
	        var sourceText;
	        var nodeCount;
	        var identifiers;
	        var identifierCount;
	        var parsingContext;
	        // Flags that dictate what parsing context we're in.  For example:
	        // Whether or not we are in strict parsing mode.  All that changes in strict parsing mode is
	        // that some tokens that would be considered identifiers may be considered keywords.
	        //
	        // When adding more parser context flags, consider which is the more common case that the
	        // flag will be in.  This should be the 'false' state for that flag.  The reason for this is
	        // that we don't store data in our nodes unless the value is in the *non-default* state.  So,
	        // for example, more often than code 'allows-in' (or doesn't 'disallow-in').  We opt for
	        // 'disallow-in' set to 'false'.  Otherwise, if we had 'allowsIn' set to 'true', then almost
	        // all nodes would need extra state on them to store this info.
	        //
	        // Note: 'allowIn' and 'allowYield' track 1:1 with the [in] and [yield] concepts in the ES6
	        // grammar specification.
	        //
	        // An important thing about these context concepts.  By default they are effectively inherited
	        // while parsing through every grammar production.  i.e. if you don't change them, then when
	        // you parse a sub-production, it will have the same context values as the parent production.
	        // This is great most of the time.  After all, consider all the 'expression' grammar productions
	        // and how nearly all of them pass along the 'in' and 'yield' context values:
	        //
	        // EqualityExpression[In, Yield] :
	        //      RelationalExpression[?In, ?Yield]
	        //      EqualityExpression[?In, ?Yield] == RelationalExpression[?In, ?Yield]
	        //      EqualityExpression[?In, ?Yield] != RelationalExpression[?In, ?Yield]
	        //      EqualityExpression[?In, ?Yield] === RelationalExpression[?In, ?Yield]
	        //      EqualityExpression[?In, ?Yield] !== RelationalExpression[?In, ?Yield]
	        //
	        // Where you have to be careful is then understanding what the points are in the grammar
	        // where the values are *not* passed along.  For example:
	        //
	        // SingleNameBinding[Yield,GeneratorParameter]
	        //      [+GeneratorParameter]BindingIdentifier[Yield] Initializer[In]opt
	        //      [~GeneratorParameter]BindingIdentifier[?Yield]Initializer[In, ?Yield]opt
	        //
	        // Here this is saying that if the GeneratorParameter context flag is set, that we should
	        // explicitly set the 'yield' context flag to false before calling into the BindingIdentifier
	        // and we should explicitly unset the 'yield' context flag before calling into the Initializer.
	        // production.  Conversely, if the GeneratorParameter context flag is not set, then we
	        // should leave the 'yield' context flag alone.
	        //
	        // Getting this all correct is tricky and requires careful reading of the grammar to
	        // understand when these values should be changed versus when they should be inherited.
	        //
	        // Note: it should not be necessary to save/restore these flags during speculative/lookahead
	        // parsing.  These context flags are naturally stored and restored through normal recursive
	        // descent parsing and unwinding.
	        var contextFlags;
	        // Whether or not we've had a parse error since creating the last AST node.  If we have
	        // encountered an error, it will be stored on the next AST node we create.  Parse errors
	        // can be broken down into three categories:
	        //
	        // 1) An error that occurred during scanning.  For example, an unterminated literal, or a
	        //    character that was completely not understood.
	        //
	        // 2) A token was expected, but was not present.  This type of error is commonly produced
	        //    by the 'parseExpected' function.
	        //
	        // 3) A token was present that no parsing function was able to consume.  This type of error
	        //    only occurs in the 'abortParsingListOrMoveToNextToken' function when the parser
	        //    decides to skip the token.
	        //
	        // In all of these cases, we want to mark the next node as having had an error before it.
	        // With this mark, we can know in incremental settings if this node can be reused, or if
	        // we have to reparse it.  If we don't keep this information around, we may just reuse the
	        // node.  in that event we would then not produce the same errors as we did before, causing
	        // significant confusion problems.
	        //
	        // Note: it is necessary that this value be saved/restored during speculative/lookahead
	        // parsing.  During lookahead parsing, we will often create a node.  That node will have
	        // this value attached, and then this value will be set back to 'false'.  If we decide to
	        // rewind, we must get back to the same value we had prior to the lookahead.
	        //
	        // Note: any errors at the end of the file that do not precede a regular node, should get
	        // attached to the EOF token.
	        var parseErrorBeforeNextFinishedNode = false;
	        function parseSourceFile(fileName, sourceText, languageVersion, syntaxCursor, setParentNodes, scriptKind) {
	            scriptKind = ts.ensureScriptKind(fileName, scriptKind);
	            initializeState(sourceText, languageVersion, syntaxCursor, scriptKind);
	            var result = parseSourceFileWorker(fileName, languageVersion, setParentNodes, scriptKind);
	            clearState();
	            return result;
	        }
	        Parser.parseSourceFile = parseSourceFile;
	        function parseIsolatedEntityName(content, languageVersion) {
	            // Choice of `isDeclarationFile` should be arbitrary
	            initializeState(content, languageVersion, /*syntaxCursor*/ undefined, 1 /* JS */);
	            // Prime the scanner.
	            nextToken();
	            var entityName = parseEntityName(/*allowReservedWords*/ true);
	            var isInvalid = token() === 1 /* EndOfFileToken */ && !parseDiagnostics.length;
	            clearState();
	            return isInvalid ? entityName : undefined;
	        }
	        Parser.parseIsolatedEntityName = parseIsolatedEntityName;
	        function parseJsonText(fileName, sourceText) {
	            initializeState(sourceText, 2 /* ES2015 */, /*syntaxCursor*/ undefined, 6 /* JSON */);
	            // Set source file so that errors will be reported with this file name
	            sourceFile = createSourceFile(fileName, 2 /* ES2015 */, 6 /* JSON */, /*isDeclaration*/ false);
	            var result = sourceFile;
	            // Prime the scanner.
	            nextToken();
	            if (token() === 1 /* EndOfFileToken */) {
	                sourceFile.endOfFileToken = parseTokenNode();
	            }
	            else if (token() === 17 /* OpenBraceToken */ ||
	                lookAhead(function () { return token() === 9 /* StringLiteral */; })) {
	                result.jsonObject = parseObjectLiteralExpression();
	                sourceFile.endOfFileToken = parseExpectedToken(1 /* EndOfFileToken */, ts.Diagnostics.Unexpected_token);
	            }
	            else {
	                parseExpected(17 /* OpenBraceToken */);
	            }
	            sourceFile.parseDiagnostics = parseDiagnostics;
	            clearState();
	            return result;
	        }
	        Parser.parseJsonText = parseJsonText;
	        function getLanguageVariant(scriptKind) {
	            // .tsx and .jsx files are treated as jsx language variant.
	            return scriptKind === 4 /* TSX */ || scriptKind === 2 /* JSX */ || scriptKind === 1 /* JS */ || scriptKind === 6 /* JSON */ ? 1 /* JSX */ : 0 /* Standard */;
	        }
	        function initializeState(_sourceText, languageVersion, _syntaxCursor, scriptKind) {
	            NodeConstructor = ts.objectAllocator.getNodeConstructor();
	            TokenConstructor = ts.objectAllocator.getTokenConstructor();
	            IdentifierConstructor = ts.objectAllocator.getIdentifierConstructor();
	            SourceFileConstructor = ts.objectAllocator.getSourceFileConstructor();
	            sourceText = _sourceText;
	            syntaxCursor = _syntaxCursor;
	            parseDiagnostics = [];
	            parsingContext = 0;
	            identifiers = ts.createMap();
	            identifierCount = 0;
	            nodeCount = 0;
	            switch (scriptKind) {
	                case 1 /* JS */:
	                case 2 /* JSX */:
	                case 6 /* JSON */:
	                    contextFlags = 65536 /* JavaScriptFile */;
	                    break;
	                default:
	                    contextFlags = 0 /* None */;
	                    break;
	            }
	            parseErrorBeforeNextFinishedNode = false;
	            // Initialize and prime the scanner before parsing the source elements.
	            scanner.setText(sourceText);
	            scanner.setOnError(scanError);
	            scanner.setScriptTarget(languageVersion);
	            scanner.setLanguageVariant(getLanguageVariant(scriptKind));
	        }
	        function clearState() {
	            // Clear out the text the scanner is pointing at, so it doesn't keep anything alive unnecessarily.
	            scanner.setText("");
	            scanner.setOnError(undefined);
	            // Clear any data.  We don't want to accidentally hold onto it for too long.
	            parseDiagnostics = undefined;
	            sourceFile = undefined;
	            identifiers = undefined;
	            syntaxCursor = undefined;
	            sourceText = undefined;
	        }
	        function parseSourceFileWorker(fileName, languageVersion, setParentNodes, scriptKind) {
	            var isDeclarationFile = isDeclarationFileName(fileName);
	            if (isDeclarationFile) {
	                contextFlags |= 2097152 /* Ambient */;
	            }
	            sourceFile = createSourceFile(fileName, languageVersion, scriptKind, isDeclarationFile);
	            sourceFile.flags = contextFlags;
	            // Prime the scanner.
	            nextToken();
	            processReferenceComments(sourceFile);
	            sourceFile.statements = parseList(0 /* SourceElements */, parseStatement);
	            ts.Debug.assert(token() === 1 /* EndOfFileToken */);
	            sourceFile.endOfFileToken = addJSDocComment(parseTokenNode());
	            setExternalModuleIndicator(sourceFile);
	            sourceFile.nodeCount = nodeCount;
	            sourceFile.identifierCount = identifierCount;
	            sourceFile.identifiers = identifiers;
	            sourceFile.parseDiagnostics = parseDiagnostics;
	            if (setParentNodes) {
	                fixupParentReferences(sourceFile);
	            }
	            return sourceFile;
	        }
	        function addJSDocComment(node) {
	            var comments = ts.getJSDocCommentRanges(node, sourceFile.text);
	            if (comments) {
	                for (var _i = 0, comments_2 = comments; _i < comments_2.length; _i++) {
	                    var comment = comments_2[_i];
	                    node.jsDoc = ts.append(node.jsDoc, JSDocParser.parseJSDocComment(node, comment.pos, comment.end - comment.pos));
	                }
	            }
	            return node;
	        }
	        function fixupParentReferences(rootNode) {
	            // normally parent references are set during binding. However, for clients that only need
	            // a syntax tree, and no semantic features, then the binding process is an unnecessary
	            // overhead.  This functions allows us to set all the parents, without all the expense of
	            // binding.
	            var parent = rootNode;
	            forEachChild(rootNode, visitNode);
	            return;
	            function visitNode(n) {
	                // walk down setting parents that differ from the parent we think it should be.  This
	                // allows us to quickly bail out of setting parents for subtrees during incremental
	                // parsing
	                if (n.parent !== parent) {
	                    n.parent = parent;
	                    var saveParent = parent;
	                    parent = n;
	                    forEachChild(n, visitNode);
	                    if (ts.hasJSDocNodes(n)) {
	                        for (var _i = 0, _a = n.jsDoc; _i < _a.length; _i++) {
	                            var jsDoc = _a[_i];
	                            jsDoc.parent = n;
	                            parent = jsDoc;
	                            forEachChild(jsDoc, visitNode);
	                        }
	                    }
	                    parent = saveParent;
	                }
	            }
	        }
	        Parser.fixupParentReferences = fixupParentReferences;
	        function createSourceFile(fileName, languageVersion, scriptKind, isDeclarationFile) {
	            // code from createNode is inlined here so createNode won't have to deal with special case of creating source files
	            // this is quite rare comparing to other nodes and createNode should be as fast as possible
	            var sourceFile = new SourceFileConstructor(272 /* SourceFile */, /*pos*/ 0, /* end */ sourceText.length);
	            nodeCount++;
	            sourceFile.text = sourceText;
	            sourceFile.bindDiagnostics = [];
	            sourceFile.languageVersion = languageVersion;
	            sourceFile.fileName = ts.normalizePath(fileName);
	            sourceFile.languageVariant = getLanguageVariant(scriptKind);
	            sourceFile.isDeclarationFile = isDeclarationFile;
	            sourceFile.scriptKind = scriptKind;
	            return sourceFile;
	        }
	        function setContextFlag(val, flag) {
	            if (val) {
	                contextFlags |= flag;
	            }
	            else {
	                contextFlags &= ~flag;
	            }
	        }
	        function setDisallowInContext(val) {
	            setContextFlag(val, 2048 /* DisallowInContext */);
	        }
	        function setYieldContext(val) {
	            setContextFlag(val, 4096 /* YieldContext */);
	        }
	        function setDecoratorContext(val) {
	            setContextFlag(val, 8192 /* DecoratorContext */);
	        }
	        function setAwaitContext(val) {
	            setContextFlag(val, 16384 /* AwaitContext */);
	        }
	        function doOutsideOfContext(context, func) {
	            // contextFlagsToClear will contain only the context flags that are
	            // currently set that we need to temporarily clear
	            // We don't just blindly reset to the previous flags to ensure
	            // that we do not mutate cached flags for the incremental
	            // parser (ThisNodeHasError, ThisNodeOrAnySubNodesHasError, and
	            // HasAggregatedChildData).
	            var contextFlagsToClear = context & contextFlags;
	            if (contextFlagsToClear) {
	                // clear the requested context flags
	                setContextFlag(/*val*/ false, contextFlagsToClear);
	                var result = func();
	                // restore the context flags we just cleared
	                setContextFlag(/*val*/ true, contextFlagsToClear);
	                return result;
	            }
	            // no need to do anything special as we are not in any of the requested contexts
	            return func();
	        }
	        function doInsideOfContext(context, func) {
	            // contextFlagsToSet will contain only the context flags that
	            // are not currently set that we need to temporarily enable.
	            // We don't just blindly reset to the previous flags to ensure
	            // that we do not mutate cached flags for the incremental
	            // parser (ThisNodeHasError, ThisNodeOrAnySubNodesHasError, and
	            // HasAggregatedChildData).
	            var contextFlagsToSet = context & ~contextFlags;
	            if (contextFlagsToSet) {
	                // set the requested context flags
	                setContextFlag(/*val*/ true, contextFlagsToSet);
	                var result = func();
	                // reset the context flags we just set
	                setContextFlag(/*val*/ false, contextFlagsToSet);
	                return result;
	            }
	            // no need to do anything special as we are already in all of the requested contexts
	            return func();
	        }
	        function allowInAnd(func) {
	            return doOutsideOfContext(2048 /* DisallowInContext */, func);
	        }
	        function disallowInAnd(func) {
	            return doInsideOfContext(2048 /* DisallowInContext */, func);
	        }
	        function doInYieldContext(func) {
	            return doInsideOfContext(4096 /* YieldContext */, func);
	        }
	        function doInDecoratorContext(func) {
	            return doInsideOfContext(8192 /* DecoratorContext */, func);
	        }
	        function doInAwaitContext(func) {
	            return doInsideOfContext(16384 /* AwaitContext */, func);
	        }
	        function doOutsideOfAwaitContext(func) {
	            return doOutsideOfContext(16384 /* AwaitContext */, func);
	        }
	        function doInYieldAndAwaitContext(func) {
	            return doInsideOfContext(4096 /* YieldContext */ | 16384 /* AwaitContext */, func);
	        }
	        function inContext(flags) {
	            return (contextFlags & flags) !== 0;
	        }
	        function inYieldContext() {
	            return inContext(4096 /* YieldContext */);
	        }
	        function inDisallowInContext() {
	            return inContext(2048 /* DisallowInContext */);
	        }
	        function inDecoratorContext() {
	            return inContext(8192 /* DecoratorContext */);
	        }
	        function inAwaitContext() {
	            return inContext(16384 /* AwaitContext */);
	        }
	        function parseErrorAtCurrentToken(message, arg0) {
	            var start = scanner.getTokenPos();
	            var length = scanner.getTextPos() - start;
	            parseErrorAtPosition(start, length, message, arg0);
	        }
	        function parseErrorAtPosition(start, length, message, arg0) {
	            // Don't report another error if it would just be at the same position as the last error.
	            var lastError = ts.lastOrUndefined(parseDiagnostics);
	            if (!lastError || start !== lastError.start) {
	                parseDiagnostics.push(ts.createFileDiagnostic(sourceFile, start, length, message, arg0));
	            }
	            // Mark that we've encountered an error.  We'll set an appropriate bit on the next
	            // node we finish so that it can't be reused incrementally.
	            parseErrorBeforeNextFinishedNode = true;
	        }
	        function scanError(message, length) {
	            var pos = scanner.getTextPos();
	            parseErrorAtPosition(pos, length || 0, message);
	        }
	        function getNodePos() {
	            return scanner.getStartPos();
	        }
	        // Use this function to access the current token instead of reading the currentToken
	        // variable. Since function results aren't narrowed in control flow analysis, this ensures
	        // that the type checker doesn't make wrong assumptions about the type of the current
	        // token (e.g. a call to nextToken() changes the current token but the checker doesn't
	        // reason about this side effect).  Mainstream VMs inline simple functions like this, so
	        // there is no performance penalty.
	        function token() {
	            return currentToken;
	        }
	        function nextToken() {
	            return currentToken = scanner.scan();
	        }
	        function reScanGreaterToken() {
	            return currentToken = scanner.reScanGreaterToken();
	        }
	        function reScanSlashToken() {
	            return currentToken = scanner.reScanSlashToken();
	        }
	        function reScanTemplateToken() {
	            return currentToken = scanner.reScanTemplateToken();
	        }
	        function scanJsxIdentifier() {
	            return currentToken = scanner.scanJsxIdentifier();
	        }
	        function scanJsxText() {
	            return currentToken = scanner.scanJsxToken();
	        }
	        function scanJsxAttributeValue() {
	            return currentToken = scanner.scanJsxAttributeValue();
	        }
	        function speculationHelper(callback, isLookAhead) {
	            // Keep track of the state we'll need to rollback to if lookahead fails (or if the
	            // caller asked us to always reset our state).
	            var saveToken = currentToken;
	            var saveParseDiagnosticsLength = parseDiagnostics.length;
	            var saveParseErrorBeforeNextFinishedNode = parseErrorBeforeNextFinishedNode;
	            // Note: it is not actually necessary to save/restore the context flags here.  That's
	            // because the saving/restoring of these flags happens naturally through the recursive
	            // descent nature of our parser.  However, we still store this here just so we can
	            // assert that invariant holds.
	            var saveContextFlags = contextFlags;
	            // If we're only looking ahead, then tell the scanner to only lookahead as well.
	            // Otherwise, if we're actually speculatively parsing, then tell the scanner to do the
	            // same.
	            var result = isLookAhead
	                ? scanner.lookAhead(callback)
	                : scanner.tryScan(callback);
	            ts.Debug.assert(saveContextFlags === contextFlags);
	            // If our callback returned something 'falsy' or we're just looking ahead,
	            // then unconditionally restore us to where we were.
	            if (!result || isLookAhead) {
	                currentToken = saveToken;
	                parseDiagnostics.length = saveParseDiagnosticsLength;
	                parseErrorBeforeNextFinishedNode = saveParseErrorBeforeNextFinishedNode;
	            }
	            return result;
	        }
	        /** Invokes the provided callback then unconditionally restores the parser to the state it
	         * was in immediately prior to invoking the callback.  The result of invoking the callback
	         * is returned from this function.
	         */
	        function lookAhead(callback) {
	            return speculationHelper(callback, /*isLookAhead*/ true);
	        }
	        /** Invokes the provided callback.  If the callback returns something falsy, then it restores
	         * the parser to the state it was in immediately prior to invoking the callback.  If the
	         * callback returns something truthy, then the parser state is not rolled back.  The result
	         * of invoking the callback is returned from this function.
	         */
	        function tryParse(callback) {
	            return speculationHelper(callback, /*isLookAhead*/ false);
	        }
	        // Ignore strict mode flag because we will report an error in type checker instead.
	        function isIdentifier() {
	            if (token() === 71 /* Identifier */) {
	                return true;
	            }
	            // If we have a 'yield' keyword, and we're in the [yield] context, then 'yield' is
	            // considered a keyword and is not an identifier.
	            if (token() === 116 /* YieldKeyword */ && inYieldContext()) {
	                return false;
	            }
	            // If we have a 'await' keyword, and we're in the [Await] context, then 'await' is
	            // considered a keyword and is not an identifier.
	            if (token() === 121 /* AwaitKeyword */ && inAwaitContext()) {
	                return false;
	            }
	            return token() > 107 /* LastReservedWord */;
	        }
	        function parseExpected(kind, diagnosticMessage, shouldAdvance) {
	            if (shouldAdvance === void 0) { shouldAdvance = true; }
	            if (token() === kind) {
	                if (shouldAdvance) {
	                    nextToken();
	                }
	                return true;
	            }
	            // Report specific message if provided with one.  Otherwise, report generic fallback message.
	            if (diagnosticMessage) {
	                parseErrorAtCurrentToken(diagnosticMessage);
	            }
	            else {
	                parseErrorAtCurrentToken(ts.Diagnostics._0_expected, ts.tokenToString(kind));
	            }
	            return false;
	        }
	        function parseOptional(t) {
	            if (token() === t) {
	                nextToken();
	                return true;
	            }
	            return false;
	        }
	        function parseOptionalToken(t) {
	            if (token() === t) {
	                return parseTokenNode();
	            }
	            return undefined;
	        }
	        function parseExpectedToken(t, diagnosticMessage, arg0) {
	            return parseOptionalToken(t) ||
	                createMissingNode(t, /*reportAtCurrentPosition*/ false, diagnosticMessage || ts.Diagnostics._0_expected, arg0 || ts.tokenToString(t));
	        }
	        function parseTokenNode() {
	            var node = createNode(token());
	            nextToken();
	            return finishNode(node);
	        }
	        function canParseSemicolon() {
	            // If there's a real semicolon, then we can always parse it out.
	            if (token() === 25 /* SemicolonToken */) {
	                return true;
	            }
	            // We can parse out an optional semicolon in ASI cases in the following cases.
	            return token() === 18 /* CloseBraceToken */ || token() === 1 /* EndOfFileToken */ || scanner.hasPrecedingLineBreak();
	        }
	        function parseSemicolon() {
	            if (canParseSemicolon()) {
	                if (token() === 25 /* SemicolonToken */) {
	                    // consume the semicolon if it was explicitly provided.
	                    nextToken();
	                }
	                return true;
	            }
	            else {
	                return parseExpected(25 /* SemicolonToken */);
	            }
	        }
	        function createNode(kind, pos) {
	            nodeCount++;
	            var p = pos >= 0 ? pos : scanner.getStartPos();
	            return ts.isNodeKind(kind) || kind === 0 /* Unknown */ ? new NodeConstructor(kind, p, p) :
	                kind === 71 /* Identifier */ ? new IdentifierConstructor(kind, p, p) :
	                    new TokenConstructor(kind, p, p);
	        }
	        function createNodeWithJSDoc(kind) {
	            var node = createNode(kind);
	            if (scanner.getTokenFlags() & 2 /* PrecedingJSDocComment */) {
	                addJSDocComment(node);
	            }
	            return node;
	        }
	        function createNodeArray(elements, pos, end) {
	            // Since the element list of a node array is typically created by starting with an empty array and
	            // repeatedly calling push(), the list may not have the optimal memory layout. We invoke slice() for
	            // small arrays (1 to 4 elements) to give the VM a chance to allocate an optimal representation.
	            var length = elements.length;
	            var array = (length >= 1 && length <= 4 ? elements.slice() : elements);
	            array.pos = pos;
	            array.end = end === undefined ? scanner.getStartPos() : end;
	            return array;
	        }
	        function finishNode(node, end) {
	            node.end = end === undefined ? scanner.getStartPos() : end;
	            if (contextFlags) {
	                node.flags |= contextFlags;
	            }
	            // Keep track on the node if we encountered an error while parsing it.  If we did, then
	            // we cannot reuse the node incrementally.  Once we've marked this node, clear out the
	            // flag so that we don't mark any subsequent nodes.
	            if (parseErrorBeforeNextFinishedNode) {
	                parseErrorBeforeNextFinishedNode = false;
	                node.flags |= 32768 /* ThisNodeHasError */;
	            }
	            return node;
	        }
	        function createMissingNode(kind, reportAtCurrentPosition, diagnosticMessage, arg0) {
	            if (reportAtCurrentPosition) {
	                parseErrorAtPosition(scanner.getStartPos(), 0, diagnosticMessage, arg0);
	            }
	            else {
	                parseErrorAtCurrentToken(diagnosticMessage, arg0);
	            }
	            var result = createNode(kind);
	            if (kind === 71 /* Identifier */) {
	                result.escapedText = "";
	            }
	            else if (ts.isLiteralKind(kind) || ts.isTemplateLiteralKind(kind)) {
	                result.text = "";
	            }
	            return finishNode(result);
	        }
	        function internIdentifier(text) {
	            var identifier = identifiers.get(text);
	            if (identifier === undefined) {
	                identifiers.set(text, identifier = text);
	            }
	            return identifier;
	        }
	        // An identifier that starts with two underscores has an extra underscore character prepended to it to avoid issues
	        // with magic property names like '__proto__'. The 'identifiers' object is used to share a single string instance for
	        // each identifier in order to reduce memory consumption.
	        function createIdentifier(isIdentifier, diagnosticMessage) {
	            identifierCount++;
	            if (isIdentifier) {
	                var node = createNode(71 /* Identifier */);
	                // Store original token kind if it is not just an Identifier so we can report appropriate error later in type checker
	                if (token() !== 71 /* Identifier */) {
	                    node.originalKeywordKind = token();
	                }
	                node.escapedText = ts.escapeLeadingUnderscores(internIdentifier(scanner.getTokenValue()));
	                nextToken();
	                return finishNode(node);
	            }
	            // Only for end of file because the error gets reported incorrectly on embedded script tags.
	            var reportAtCurrentPosition = token() === 1 /* EndOfFileToken */;
	            return createMissingNode(71 /* Identifier */, reportAtCurrentPosition, diagnosticMessage || ts.Diagnostics.Identifier_expected);
	        }
	        function parseIdentifier(diagnosticMessage) {
	            return createIdentifier(isIdentifier(), diagnosticMessage);
	        }
	        function parseIdentifierName(diagnosticMessage) {
	            return createIdentifier(ts.tokenIsIdentifierOrKeyword(token()), diagnosticMessage);
	        }
	        function isLiteralPropertyName() {
	            return ts.tokenIsIdentifierOrKeyword(token()) ||
	                token() === 9 /* StringLiteral */ ||
	                token() === 8 /* NumericLiteral */;
	        }
	        function parsePropertyNameWorker(allowComputedPropertyNames) {
	            if (token() === 9 /* StringLiteral */ || token() === 8 /* NumericLiteral */) {
	                var node = parseLiteralNode();
	                node.text = internIdentifier(node.text);
	                return node;
	            }
	            if (allowComputedPropertyNames && token() === 21 /* OpenBracketToken */) {
	                return parseComputedPropertyName();
	            }
	            return parseIdentifierName();
	        }
	        function parsePropertyName() {
	            return parsePropertyNameWorker(/*allowComputedPropertyNames*/ true);
	        }
	        function parseComputedPropertyName() {
	            // PropertyName [Yield]:
	            //      LiteralPropertyName
	            //      ComputedPropertyName[?Yield]
	            var node = createNode(146 /* ComputedPropertyName */);
	            parseExpected(21 /* OpenBracketToken */);
	            // We parse any expression (including a comma expression). But the grammar
	            // says that only an assignment expression is allowed, so the grammar checker
	            // will error if it sees a comma expression.
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(22 /* CloseBracketToken */);
	            return finishNode(node);
	        }
	        function parseContextualModifier(t) {
	            return token() === t && tryParse(nextTokenCanFollowModifier);
	        }
	        function nextTokenIsOnSameLineAndCanFollowModifier() {
	            nextToken();
	            if (scanner.hasPrecedingLineBreak()) {
	                return false;
	            }
	            return canFollowModifier();
	        }
	        function nextTokenCanFollowModifier() {
	            if (token() === 76 /* ConstKeyword */) {
	                // 'const' is only a modifier if followed by 'enum'.
	                return nextToken() === 83 /* EnumKeyword */;
	            }
	            if (token() === 84 /* ExportKeyword */) {
	                nextToken();
	                if (token() === 79 /* DefaultKeyword */) {
	                    return lookAhead(nextTokenCanFollowDefaultKeyword);
	                }
	                return token() !== 39 /* AsteriskToken */ && token() !== 118 /* AsKeyword */ && token() !== 17 /* OpenBraceToken */ && canFollowModifier();
	            }
	            if (token() === 79 /* DefaultKeyword */) {
	                return nextTokenCanFollowDefaultKeyword();
	            }
	            if (token() === 115 /* StaticKeyword */) {
	                nextToken();
	                return canFollowModifier();
	            }
	            return nextTokenIsOnSameLineAndCanFollowModifier();
	        }
	        function parseAnyContextualModifier() {
	            return ts.isModifierKind(token()) && tryParse(nextTokenCanFollowModifier);
	        }
	        function canFollowModifier() {
	            return token() === 21 /* OpenBracketToken */
	                || token() === 17 /* OpenBraceToken */
	                || token() === 39 /* AsteriskToken */
	                || token() === 24 /* DotDotDotToken */
	                || isLiteralPropertyName();
	        }
	        function nextTokenCanFollowDefaultKeyword() {
	            nextToken();
	            return token() === 75 /* ClassKeyword */ || token() === 89 /* FunctionKeyword */ ||
	                token() === 109 /* InterfaceKeyword */ ||
	                (token() === 117 /* AbstractKeyword */ && lookAhead(nextTokenIsClassKeywordOnSameLine)) ||
	                (token() === 120 /* AsyncKeyword */ && lookAhead(nextTokenIsFunctionKeywordOnSameLine));
	        }
	        // True if positioned at the start of a list element
	        function isListElement(parsingContext, inErrorRecovery) {
	            var node = currentNode(parsingContext);
	            if (node) {
	                return true;
	            }
	            switch (parsingContext) {
	                case 0 /* SourceElements */:
	                case 1 /* BlockStatements */:
	                case 3 /* SwitchClauseStatements */:
	                    // If we're in error recovery, then we don't want to treat ';' as an empty statement.
	                    // The problem is that ';' can show up in far too many contexts, and if we see one
	                    // and assume it's a statement, then we may bail out inappropriately from whatever
	                    // we're parsing.  For example, if we have a semicolon in the middle of a class, then
	                    // we really don't want to assume the class is over and we're on a statement in the
	                    // outer module.  We just want to consume and move on.
	                    return !(token() === 25 /* SemicolonToken */ && inErrorRecovery) && isStartOfStatement();
	                case 2 /* SwitchClauses */:
	                    return token() === 73 /* CaseKeyword */ || token() === 79 /* DefaultKeyword */;
	                case 4 /* TypeMembers */:
	                    return lookAhead(isTypeMemberStart);
	                case 5 /* ClassMembers */:
	                    // We allow semicolons as class elements (as specified by ES6) as long as we're
	                    // not in error recovery.  If we're in error recovery, we don't want an errant
	                    // semicolon to be treated as a class member (since they're almost always used
	                    // for statements.
	                    return lookAhead(isClassMemberStart) || (token() === 25 /* SemicolonToken */ && !inErrorRecovery);
	                case 6 /* EnumMembers */:
	                    // Include open bracket computed properties. This technically also lets in indexers,
	                    // which would be a candidate for improved error reporting.
	                    return token() === 21 /* OpenBracketToken */ || isLiteralPropertyName();
	                case 12 /* ObjectLiteralMembers */:
	                    return token() === 21 /* OpenBracketToken */ || token() === 39 /* AsteriskToken */ || token() === 24 /* DotDotDotToken */ || isLiteralPropertyName();
	                case 17 /* RestProperties */:
	                    return isLiteralPropertyName();
	                case 9 /* ObjectBindingElements */:
	                    return token() === 21 /* OpenBracketToken */ || token() === 24 /* DotDotDotToken */ || isLiteralPropertyName();
	                case 7 /* HeritageClauseElement */:
	                    // If we see `{ ... }` then only consume it as an expression if it is followed by `,` or `{`
	                    // That way we won't consume the body of a class in its heritage clause.
	                    if (token() === 17 /* OpenBraceToken */) {
	                        return lookAhead(isValidHeritageClauseObjectLiteral);
	                    }
	                    if (!inErrorRecovery) {
	                        return isStartOfLeftHandSideExpression() && !isHeritageClauseExtendsOrImplementsKeyword();
	                    }
	                    else {
	                        // If we're in error recovery we tighten up what we're willing to match.
	                        // That way we don't treat something like "this" as a valid heritage clause
	                        // element during recovery.
	                        return isIdentifier() && !isHeritageClauseExtendsOrImplementsKeyword();
	                    }
	                case 8 /* VariableDeclarations */:
	                    return isIdentifierOrPattern();
	                case 10 /* ArrayBindingElements */:
	                    return token() === 26 /* CommaToken */ || token() === 24 /* DotDotDotToken */ || isIdentifierOrPattern();
	                case 18 /* TypeParameters */:
	                    return isIdentifier();
	                case 15 /* ArrayLiteralMembers */:
	                    if (token() === 26 /* CommaToken */) {
	                        return true;
	                    }
	                // falls through
	                case 11 /* ArgumentExpressions */:
	                    return token() === 24 /* DotDotDotToken */ || isStartOfExpression();
	                case 16 /* Parameters */:
	                    return isStartOfParameter();
	                case 19 /* TypeArguments */:
	                case 20 /* TupleElementTypes */:
	                    return token() === 26 /* CommaToken */ || isStartOfType();
	                case 21 /* HeritageClauses */:
	                    return isHeritageClause();
	                case 22 /* ImportOrExportSpecifiers */:
	                    return ts.tokenIsIdentifierOrKeyword(token());
	                case 13 /* JsxAttributes */:
	                    return ts.tokenIsIdentifierOrKeyword(token()) || token() === 17 /* OpenBraceToken */;
	                case 14 /* JsxChildren */:
	                    return true;
	            }
	            ts.Debug.fail("Non-exhaustive case in 'isListElement'.");
	        }
	        function isValidHeritageClauseObjectLiteral() {
	            ts.Debug.assert(token() === 17 /* OpenBraceToken */);
	            if (nextToken() === 18 /* CloseBraceToken */) {
	                // if we see "extends {}" then only treat the {} as what we're extending (and not
	                // the class body) if we have:
	                //
	                //      extends {} {
	                //      extends {},
	                //      extends {} extends
	                //      extends {} implements
	                var next = nextToken();
	                return next === 26 /* CommaToken */ || next === 17 /* OpenBraceToken */ || next === 85 /* ExtendsKeyword */ || next === 108 /* ImplementsKeyword */;
	            }
	            return true;
	        }
	        function nextTokenIsIdentifier() {
	            nextToken();
	            return isIdentifier();
	        }
	        function nextTokenIsIdentifierOrKeyword() {
	            nextToken();
	            return ts.tokenIsIdentifierOrKeyword(token());
	        }
	        function nextTokenIsIdentifierOrKeywordOrGreaterThan() {
	            nextToken();
	            return ts.tokenIsIdentifierOrKeywordOrGreaterThan(token());
	        }
	        function isHeritageClauseExtendsOrImplementsKeyword() {
	            if (token() === 108 /* ImplementsKeyword */ ||
	                token() === 85 /* ExtendsKeyword */) {
	                return lookAhead(nextTokenIsStartOfExpression);
	            }
	            return false;
	        }
	        function nextTokenIsStartOfExpression() {
	            nextToken();
	            return isStartOfExpression();
	        }
	        function nextTokenIsStartOfType() {
	            nextToken();
	            return isStartOfType();
	        }
	        // True if positioned at a list terminator
	        function isListTerminator(kind) {
	            if (token() === 1 /* EndOfFileToken */) {
	                // Being at the end of the file ends all lists.
	                return true;
	            }
	            switch (kind) {
	                case 1 /* BlockStatements */:
	                case 2 /* SwitchClauses */:
	                case 4 /* TypeMembers */:
	                case 5 /* ClassMembers */:
	                case 6 /* EnumMembers */:
	                case 12 /* ObjectLiteralMembers */:
	                case 9 /* ObjectBindingElements */:
	                case 22 /* ImportOrExportSpecifiers */:
	                    return token() === 18 /* CloseBraceToken */;
	                case 3 /* SwitchClauseStatements */:
	                    return token() === 18 /* CloseBraceToken */ || token() === 73 /* CaseKeyword */ || token() === 79 /* DefaultKeyword */;
	                case 7 /* HeritageClauseElement */:
	                    return token() === 17 /* OpenBraceToken */ || token() === 85 /* ExtendsKeyword */ || token() === 108 /* ImplementsKeyword */;
	                case 8 /* VariableDeclarations */:
	                    return isVariableDeclaratorListTerminator();
	                case 18 /* TypeParameters */:
	                    // Tokens other than '>' are here for better error recovery
	                    return token() === 29 /* GreaterThanToken */ || token() === 19 /* OpenParenToken */ || token() === 17 /* OpenBraceToken */ || token() === 85 /* ExtendsKeyword */ || token() === 108 /* ImplementsKeyword */;
	                case 11 /* ArgumentExpressions */:
	                    // Tokens other than ')' are here for better error recovery
	                    return token() === 20 /* CloseParenToken */ || token() === 25 /* SemicolonToken */;
	                case 15 /* ArrayLiteralMembers */:
	                case 20 /* TupleElementTypes */:
	                case 10 /* ArrayBindingElements */:
	                    return token() === 22 /* CloseBracketToken */;
	                case 16 /* Parameters */:
	                case 17 /* RestProperties */:
	                    // Tokens other than ')' and ']' (the latter for index signatures) are here for better error recovery
	                    return token() === 20 /* CloseParenToken */ || token() === 22 /* CloseBracketToken */ /*|| token === SyntaxKind.OpenBraceToken*/;
	                case 19 /* TypeArguments */:
	                    // All other tokens should cause the type-argument to terminate except comma token
	                    return token() !== 26 /* CommaToken */;
	                case 21 /* HeritageClauses */:
	                    return token() === 17 /* OpenBraceToken */ || token() === 18 /* CloseBraceToken */;
	                case 13 /* JsxAttributes */:
	                    return token() === 29 /* GreaterThanToken */ || token() === 41 /* SlashToken */;
	                case 14 /* JsxChildren */:
	                    return token() === 27 /* LessThanToken */ && lookAhead(nextTokenIsSlash);
	            }
	        }
	        function isVariableDeclaratorListTerminator() {
	            // If we can consume a semicolon (either explicitly, or with ASI), then consider us done
	            // with parsing the list of variable declarators.
	            if (canParseSemicolon()) {
	                return true;
	            }
	            // in the case where we're parsing the variable declarator of a 'for-in' statement, we
	            // are done if we see an 'in' keyword in front of us. Same with for-of
	            if (isInOrOfKeyword(token())) {
	                return true;
	            }
	            // ERROR RECOVERY TWEAK:
	            // For better error recovery, if we see an '=>' then we just stop immediately.  We've got an
	            // arrow function here and it's going to be very unlikely that we'll resynchronize and get
	            // another variable declaration.
	            if (token() === 36 /* EqualsGreaterThanToken */) {
	                return true;
	            }
	            // Keep trying to parse out variable declarators.
	            return false;
	        }
	        // True if positioned at element or terminator of the current list or any enclosing list
	        function isInSomeParsingContext() {
	            for (var kind = 0; kind < 23 /* Count */; kind++) {
	                if (parsingContext & (1 << kind)) {
	                    if (isListElement(kind, /*inErrorRecovery*/ true) || isListTerminator(kind)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        // Parses a list of elements
	        function parseList(kind, parseElement) {
	            var saveParsingContext = parsingContext;
	            parsingContext |= 1 << kind;
	            var list = [];
	            var listPos = getNodePos();
	            while (!isListTerminator(kind)) {
	                if (isListElement(kind, /*inErrorRecovery*/ false)) {
	                    var element = parseListElement(kind, parseElement);
	                    list.push(element);
	                    continue;
	                }
	                if (abortParsingListOrMoveToNextToken(kind)) {
	                    break;
	                }
	            }
	            parsingContext = saveParsingContext;
	            return createNodeArray(list, listPos);
	        }
	        function parseListElement(parsingContext, parseElement) {
	            var node = currentNode(parsingContext);
	            if (node) {
	                return consumeNode(node);
	            }
	            return parseElement();
	        }
	        function currentNode(parsingContext) {
	            // If there is an outstanding parse error that we've encountered, but not attached to
	            // some node, then we cannot get a node from the old source tree.  This is because we
	            // want to mark the next node we encounter as being unusable.
	            //
	            // Note: This may be too conservative.  Perhaps we could reuse the node and set the bit
	            // on it (or its leftmost child) as having the error.  For now though, being conservative
	            // is nice and likely won't ever affect perf.
	            if (parseErrorBeforeNextFinishedNode) {
	                return undefined;
	            }
	            if (!syntaxCursor) {
	                // if we don't have a cursor, we could never return a node from the old tree.
	                return undefined;
	            }
	            var node = syntaxCursor.currentNode(scanner.getStartPos());
	            // Can't reuse a missing node.
	            if (ts.nodeIsMissing(node)) {
	                return undefined;
	            }
	            // Can't reuse a node that intersected the change range.
	            if (node.intersectsChange) {
	                return undefined;
	            }
	            // Can't reuse a node that contains a parse error.  This is necessary so that we
	            // produce the same set of errors again.
	            if (ts.containsParseError(node)) {
	                return undefined;
	            }
	            // We can only reuse a node if it was parsed under the same strict mode that we're
	            // currently in.  i.e. if we originally parsed a node in non-strict mode, but then
	            // the user added 'using strict' at the top of the file, then we can't use that node
	            // again as the presence of strict mode may cause us to parse the tokens in the file
	            // differently.
	            //
	            // Note: we *can* reuse tokens when the strict mode changes.  That's because tokens
	            // are unaffected by strict mode.  It's just the parser will decide what to do with it
	            // differently depending on what mode it is in.
	            //
	            // This also applies to all our other context flags as well.
	            var nodeContextFlags = node.flags & 6387712 /* ContextFlags */;
	            if (nodeContextFlags !== contextFlags) {
	                return undefined;
	            }
	            // Ok, we have a node that looks like it could be reused.  Now verify that it is valid
	            // in the current list parsing context that we're currently at.
	            if (!canReuseNode(node, parsingContext)) {
	                return undefined;
	            }
	            if (node.jsDocCache) {
	                // jsDocCache may include tags from parent nodes, which might have been modified.
	                node.jsDocCache = undefined;
	            }
	            return node;
	        }
	        function consumeNode(node) {
	            // Move the scanner so it is after the node we just consumed.
	            scanner.setTextPos(node.end);
	            nextToken();
	            return node;
	        }
	        function canReuseNode(node, parsingContext) {
	            switch (parsingContext) {
	                case 5 /* ClassMembers */:
	                    return isReusableClassMember(node);
	                case 2 /* SwitchClauses */:
	                    return isReusableSwitchClause(node);
	                case 0 /* SourceElements */:
	                case 1 /* BlockStatements */:
	                case 3 /* SwitchClauseStatements */:
	                    return isReusableStatement(node);
	                case 6 /* EnumMembers */:
	                    return isReusableEnumMember(node);
	                case 4 /* TypeMembers */:
	                    return isReusableTypeMember(node);
	                case 8 /* VariableDeclarations */:
	                    return isReusableVariableDeclaration(node);
	                case 16 /* Parameters */:
	                    return isReusableParameter(node);
	                case 17 /* RestProperties */:
	                    return false;
	                // Any other lists we do not care about reusing nodes in.  But feel free to add if
	                // you can do so safely.  Danger areas involve nodes that may involve speculative
	                // parsing.  If speculative parsing is involved with the node, then the range the
	                // parser reached while looking ahead might be in the edited range (see the example
	                // in canReuseVariableDeclaratorNode for a good case of this).
	                case 21 /* HeritageClauses */:
	                // This would probably be safe to reuse.  There is no speculative parsing with
	                // heritage clauses.
	                case 18 /* TypeParameters */:
	                // This would probably be safe to reuse.  There is no speculative parsing with
	                // type parameters.  Note that that's because type *parameters* only occur in
	                // unambiguous *type* contexts.  While type *arguments* occur in very ambiguous
	                // *expression* contexts.
	                case 20 /* TupleElementTypes */:
	                // This would probably be safe to reuse.  There is no speculative parsing with
	                // tuple types.
	                // Technically, type argument list types are probably safe to reuse.  While
	                // speculative parsing is involved with them (since type argument lists are only
	                // produced from speculative parsing a < as a type argument list), we only have
	                // the types because speculative parsing succeeded.  Thus, the lookahead never
	                // went past the end of the list and rewound.
	                case 19 /* TypeArguments */:
	                // Note: these are almost certainly not safe to ever reuse.  Expressions commonly
	                // need a large amount of lookahead, and we should not reuse them as they may
	                // have actually intersected the edit.
	                case 11 /* ArgumentExpressions */:
	                // This is not safe to reuse for the same reason as the 'AssignmentExpression'
	                // cases.  i.e. a property assignment may end with an expression, and thus might
	                // have lookahead far beyond it's old node.
	                case 12 /* ObjectLiteralMembers */:
	                // This is probably not safe to reuse.  There can be speculative parsing with
	                // type names in a heritage clause.  There can be generic names in the type
	                // name list, and there can be left hand side expressions (which can have type
	                // arguments.)
	                case 7 /* HeritageClauseElement */:
	                // Perhaps safe to reuse, but it's unlikely we'd see more than a dozen attributes
	                // on any given element. Same for children.
	                case 13 /* JsxAttributes */:
	                case 14 /* JsxChildren */:
	            }
	            return false;
	        }
	        function isReusableClassMember(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 154 /* Constructor */:
	                    case 159 /* IndexSignature */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 151 /* PropertyDeclaration */:
	                    case 210 /* SemicolonClassElement */:
	                        return true;
	                    case 153 /* MethodDeclaration */:
	                        // Method declarations are not necessarily reusable.  An object-literal
	                        // may have a method calls "constructor(...)" and we must reparse that
	                        // into an actual .ConstructorDeclaration.
	                        var methodDeclaration = node;
	                        var nameIsConstructor = methodDeclaration.name.kind === 71 /* Identifier */ &&
	                            methodDeclaration.name.originalKeywordKind === 123 /* ConstructorKeyword */;
	                        return !nameIsConstructor;
	                }
	            }
	            return false;
	        }
	        function isReusableSwitchClause(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 264 /* CaseClause */:
	                    case 265 /* DefaultClause */:
	                        return true;
	                }
	            }
	            return false;
	        }
	        function isReusableStatement(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 232 /* FunctionDeclaration */:
	                    case 212 /* VariableStatement */:
	                    case 211 /* Block */:
	                    case 215 /* IfStatement */:
	                    case 214 /* ExpressionStatement */:
	                    case 227 /* ThrowStatement */:
	                    case 223 /* ReturnStatement */:
	                    case 225 /* SwitchStatement */:
	                    case 222 /* BreakStatement */:
	                    case 221 /* ContinueStatement */:
	                    case 219 /* ForInStatement */:
	                    case 220 /* ForOfStatement */:
	                    case 218 /* ForStatement */:
	                    case 217 /* WhileStatement */:
	                    case 224 /* WithStatement */:
	                    case 213 /* EmptyStatement */:
	                    case 228 /* TryStatement */:
	                    case 226 /* LabeledStatement */:
	                    case 216 /* DoStatement */:
	                    case 229 /* DebuggerStatement */:
	                    case 242 /* ImportDeclaration */:
	                    case 241 /* ImportEqualsDeclaration */:
	                    case 248 /* ExportDeclaration */:
	                    case 247 /* ExportAssignment */:
	                    case 237 /* ModuleDeclaration */:
	                    case 233 /* ClassDeclaration */:
	                    case 234 /* InterfaceDeclaration */:
	                    case 236 /* EnumDeclaration */:
	                    case 235 /* TypeAliasDeclaration */:
	                        return true;
	                }
	            }
	            return false;
	        }
	        function isReusableEnumMember(node) {
	            return node.kind === 271 /* EnumMember */;
	        }
	        function isReusableTypeMember(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 158 /* ConstructSignature */:
	                    case 152 /* MethodSignature */:
	                    case 159 /* IndexSignature */:
	                    case 150 /* PropertySignature */:
	                    case 157 /* CallSignature */:
	                        return true;
	                }
	            }
	            return false;
	        }
	        function isReusableVariableDeclaration(node) {
	            if (node.kind !== 230 /* VariableDeclaration */) {
	                return false;
	            }
	            // Very subtle incremental parsing bug.  Consider the following code:
	            //
	            //      let v = new List < A, B
	            //
	            // This is actually legal code.  It's a list of variable declarators "v = new List<A"
	            // on one side and "B" on the other. If you then change that to:
	            //
	            //      let v = new List < A, B >()
	            //
	            // then we have a problem.  "v = new List<A" doesn't intersect the change range, so we
	            // start reparsing at "B" and we completely fail to handle this properly.
	            //
	            // In order to prevent this, we do not allow a variable declarator to be reused if it
	            // has an initializer.
	            var variableDeclarator = node;
	            return variableDeclarator.initializer === undefined;
	        }
	        function isReusableParameter(node) {
	            if (node.kind !== 148 /* Parameter */) {
	                return false;
	            }
	            // See the comment in isReusableVariableDeclaration for why we do this.
	            var parameter = node;
	            return parameter.initializer === undefined;
	        }
	        // Returns true if we should abort parsing.
	        function abortParsingListOrMoveToNextToken(kind) {
	            parseErrorAtCurrentToken(parsingContextErrors(kind));
	            if (isInSomeParsingContext()) {
	                return true;
	            }
	            nextToken();
	            return false;
	        }
	        function parsingContextErrors(context) {
	            switch (context) {
	                case 0 /* SourceElements */: return ts.Diagnostics.Declaration_or_statement_expected;
	                case 1 /* BlockStatements */: return ts.Diagnostics.Declaration_or_statement_expected;
	                case 2 /* SwitchClauses */: return ts.Diagnostics.case_or_default_expected;
	                case 3 /* SwitchClauseStatements */: return ts.Diagnostics.Statement_expected;
	                case 17 /* RestProperties */: // fallthrough
	                case 4 /* TypeMembers */: return ts.Diagnostics.Property_or_signature_expected;
	                case 5 /* ClassMembers */: return ts.Diagnostics.Unexpected_token_A_constructor_method_accessor_or_property_was_expected;
	                case 6 /* EnumMembers */: return ts.Diagnostics.Enum_member_expected;
	                case 7 /* HeritageClauseElement */: return ts.Diagnostics.Expression_expected;
	                case 8 /* VariableDeclarations */: return ts.Diagnostics.Variable_declaration_expected;
	                case 9 /* ObjectBindingElements */: return ts.Diagnostics.Property_destructuring_pattern_expected;
	                case 10 /* ArrayBindingElements */: return ts.Diagnostics.Array_element_destructuring_pattern_expected;
	                case 11 /* ArgumentExpressions */: return ts.Diagnostics.Argument_expression_expected;
	                case 12 /* ObjectLiteralMembers */: return ts.Diagnostics.Property_assignment_expected;
	                case 15 /* ArrayLiteralMembers */: return ts.Diagnostics.Expression_or_comma_expected;
	                case 16 /* Parameters */: return ts.Diagnostics.Parameter_declaration_expected;
	                case 18 /* TypeParameters */: return ts.Diagnostics.Type_parameter_declaration_expected;
	                case 19 /* TypeArguments */: return ts.Diagnostics.Type_argument_expected;
	                case 20 /* TupleElementTypes */: return ts.Diagnostics.Type_expected;
	                case 21 /* HeritageClauses */: return ts.Diagnostics.Unexpected_token_expected;
	                case 22 /* ImportOrExportSpecifiers */: return ts.Diagnostics.Identifier_expected;
	                case 13 /* JsxAttributes */: return ts.Diagnostics.Identifier_expected;
	                case 14 /* JsxChildren */: return ts.Diagnostics.Identifier_expected;
	            }
	        }
	        // Parses a comma-delimited list of elements
	        function parseDelimitedList(kind, parseElement, considerSemicolonAsDelimiter) {
	            var saveParsingContext = parsingContext;
	            parsingContext |= 1 << kind;
	            var list = [];
	            var listPos = getNodePos();
	            var commaStart = -1; // Meaning the previous token was not a comma
	            while (true) {
	                if (isListElement(kind, /*inErrorRecovery*/ false)) {
	                    var startPos = scanner.getStartPos();
	                    list.push(parseListElement(kind, parseElement));
	                    commaStart = scanner.getTokenPos();
	                    if (parseOptional(26 /* CommaToken */)) {
	                        // No need to check for a zero length node since we know we parsed a comma
	                        continue;
	                    }
	                    commaStart = -1; // Back to the state where the last token was not a comma
	                    if (isListTerminator(kind)) {
	                        break;
	                    }
	                    // We didn't get a comma, and the list wasn't terminated, explicitly parse
	                    // out a comma so we give a good error message.
	                    parseExpected(26 /* CommaToken */);
	                    // If the token was a semicolon, and the caller allows that, then skip it and
	                    // continue.  This ensures we get back on track and don't result in tons of
	                    // parse errors.  For example, this can happen when people do things like use
	                    // a semicolon to delimit object literal members.   Note: we'll have already
	                    // reported an error when we called parseExpected above.
	                    if (considerSemicolonAsDelimiter && token() === 25 /* SemicolonToken */ && !scanner.hasPrecedingLineBreak()) {
	                        nextToken();
	                    }
	                    if (startPos === scanner.getStartPos()) {
	                        // What we're parsing isn't actually remotely recognizable as a element and we've consumed no tokens whatsoever
	                        // Consume a token to advance the parser in some way and avoid an infinite loop
	                        // This can happen when we're speculatively parsing parenthesized expressions which we think may be arrow functions,
	                        // or when a modifier keyword which is disallowed as a parameter name (ie, `static` in strict mode) is supplied
	                        nextToken();
	                    }
	                    continue;
	                }
	                if (isListTerminator(kind)) {
	                    break;
	                }
	                if (abortParsingListOrMoveToNextToken(kind)) {
	                    break;
	                }
	            }
	            parsingContext = saveParsingContext;
	            var result = createNodeArray(list, listPos);
	            // Recording the trailing comma is deliberately done after the previous
	            // loop, and not just if we see a list terminator. This is because the list
	            // may have ended incorrectly, but it is still important to know if there
	            // was a trailing comma.
	            // Check if the last token was a comma.
	            if (commaStart >= 0) {
	                // Always preserve a trailing comma by marking it on the NodeArray
	                result.hasTrailingComma = true;
	            }
	            return result;
	        }
	        function createMissingList() {
	            return createNodeArray([], getNodePos());
	        }
	        function parseBracketedList(kind, parseElement, open, close) {
	            if (parseExpected(open)) {
	                var result = parseDelimitedList(kind, parseElement);
	                parseExpected(close);
	                return result;
	            }
	            return createMissingList();
	        }
	        function parseEntityName(allowReservedWords, diagnosticMessage) {
	            var entity = allowReservedWords ? parseIdentifierName(diagnosticMessage) : parseIdentifier(diagnosticMessage);
	            var dotPos = scanner.getStartPos();
	            while (parseOptional(23 /* DotToken */)) {
	                if (token() === 27 /* LessThanToken */) {
	                    // the entity is part of a JSDoc-style generic, so record the trailing dot for later error reporting
	                    entity.jsdocDotPos = dotPos;
	                    break;
	                }
	                dotPos = scanner.getStartPos();
	                entity = createQualifiedName(entity, parseRightSideOfDot(allowReservedWords));
	            }
	            return entity;
	        }
	        function createQualifiedName(entity, name) {
	            var node = createNode(145 /* QualifiedName */, entity.pos);
	            node.left = entity;
	            node.right = name;
	            return finishNode(node);
	        }
	        function parseRightSideOfDot(allowIdentifierNames) {
	            // Technically a keyword is valid here as all identifiers and keywords are identifier names.
	            // However, often we'll encounter this in error situations when the identifier or keyword
	            // is actually starting another valid construct.
	            //
	            // So, we check for the following specific case:
	            //
	            //      name.
	            //      identifierOrKeyword identifierNameOrKeyword
	            //
	            // Note: the newlines are important here.  For example, if that above code
	            // were rewritten into:
	            //
	            //      name.identifierOrKeyword
	            //      identifierNameOrKeyword
	            //
	            // Then we would consider it valid.  That's because ASI would take effect and
	            // the code would be implicitly: "name.identifierOrKeyword; identifierNameOrKeyword".
	            // In the first case though, ASI will not take effect because there is not a
	            // line terminator after the identifier or keyword.
	            if (scanner.hasPrecedingLineBreak() && ts.tokenIsIdentifierOrKeyword(token())) {
	                var matchesPattern = lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine);
	                if (matchesPattern) {
	                    // Report that we need an identifier.  However, report it right after the dot,
	                    // and not on the next token.  This is because the next token might actually
	                    // be an identifier and the error would be quite confusing.
	                    return createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.Identifier_expected);
	                }
	            }
	            return allowIdentifierNames ? parseIdentifierName() : parseIdentifier();
	        }
	        function parseTemplateExpression() {
	            var template = createNode(200 /* TemplateExpression */);
	            template.head = parseTemplateHead();
	            ts.Debug.assert(template.head.kind === 14 /* TemplateHead */, "Template head has wrong token kind");
	            var list = [];
	            var listPos = getNodePos();
	            do {
	                list.push(parseTemplateSpan());
	            } while (ts.lastOrUndefined(list).literal.kind === 15 /* TemplateMiddle */);
	            template.templateSpans = createNodeArray(list, listPos);
	            return finishNode(template);
	        }
	        function parseTemplateSpan() {
	            var span = createNode(209 /* TemplateSpan */);
	            span.expression = allowInAnd(parseExpression);
	            var literal;
	            if (token() === 18 /* CloseBraceToken */) {
	                reScanTemplateToken();
	                literal = parseTemplateMiddleOrTemplateTail();
	            }
	            else {
	                literal = parseExpectedToken(16 /* TemplateTail */, ts.Diagnostics._0_expected, ts.tokenToString(18 /* CloseBraceToken */));
	            }
	            span.literal = literal;
	            return finishNode(span);
	        }
	        function parseLiteralNode() {
	            return parseLiteralLikeNode(token());
	        }
	        function parseTemplateHead() {
	            var fragment = parseLiteralLikeNode(token());
	            ts.Debug.assert(fragment.kind === 14 /* TemplateHead */, "Template head has wrong token kind");
	            return fragment;
	        }
	        function parseTemplateMiddleOrTemplateTail() {
	            var fragment = parseLiteralLikeNode(token());
	            ts.Debug.assert(fragment.kind === 15 /* TemplateMiddle */ || fragment.kind === 16 /* TemplateTail */, "Template fragment has wrong token kind");
	            return fragment;
	        }
	        function parseLiteralLikeNode(kind) {
	            var node = createNode(kind);
	            var text = scanner.getTokenValue();
	            node.text = text;
	            if (scanner.hasExtendedUnicodeEscape()) {
	                node.hasExtendedUnicodeEscape = true;
	            }
	            if (scanner.isUnterminated()) {
	                node.isUnterminated = true;
	            }
	            // Octal literals are not allowed in strict mode or ES5
	            // Note that theoretically the following condition would hold true literals like 009,
	            // which is not octal.But because of how the scanner separates the tokens, we would
	            // never get a token like this. Instead, we would get 00 and 9 as two separate tokens.
	            // We also do not need to check for negatives because any prefix operator would be part of a
	            // parent unary expression.
	            if (node.kind === 8 /* NumericLiteral */) {
	                node.numericLiteralFlags = scanner.getTokenFlags() & 1008 /* NumericLiteralFlags */;
	            }
	            nextToken();
	            finishNode(node);
	            return node;
	        }
	        // TYPES
	        function parseTypeReference() {
	            var node = createNode(161 /* TypeReference */);
	            node.typeName = parseEntityName(/*allowReservedWords*/ true, ts.Diagnostics.Type_expected);
	            if (!scanner.hasPrecedingLineBreak() && token() === 27 /* LessThanToken */) {
	                node.typeArguments = parseBracketedList(19 /* TypeArguments */, parseType, 27 /* LessThanToken */, 29 /* GreaterThanToken */);
	            }
	            return finishNode(node);
	        }
	        function parseThisTypePredicate(lhs) {
	            nextToken();
	            var node = createNode(160 /* TypePredicate */, lhs.pos);
	            node.parameterName = lhs;
	            node.type = parseType();
	            return finishNode(node);
	        }
	        function parseThisTypeNode() {
	            var node = createNode(173 /* ThisType */);
	            nextToken();
	            return finishNode(node);
	        }
	        function parseJSDocAllType() {
	            var result = createNode(275 /* JSDocAllType */);
	            nextToken();
	            return finishNode(result);
	        }
	        function parseJSDocUnknownOrNullableType() {
	            var pos = scanner.getStartPos();
	            // skip the ?
	            nextToken();
	            // Need to lookahead to decide if this is a nullable or unknown type.
	            // Here are cases where we'll pick the unknown type:
	            //
	            //      Foo(?,
	            //      { a: ? }
	            //      Foo(?)
	            //      Foo<?>
	            //      Foo(?=
	            //      (?|
	            if (token() === 26 /* CommaToken */ ||
	                token() === 18 /* CloseBraceToken */ ||
	                token() === 20 /* CloseParenToken */ ||
	                token() === 29 /* GreaterThanToken */ ||
	                token() === 58 /* EqualsToken */ ||
	                token() === 49 /* BarToken */) {
	                var result = createNode(276 /* JSDocUnknownType */, pos);
	                return finishNode(result);
	            }
	            else {
	                var result = createNode(277 /* JSDocNullableType */, pos);
	                result.type = parseType();
	                return finishNode(result);
	            }
	        }
	        function parseJSDocFunctionType() {
	            if (lookAhead(nextTokenIsOpenParen)) {
	                var result = createNodeWithJSDoc(280 /* JSDocFunctionType */);
	                nextToken();
	                fillSignature(56 /* ColonToken */, 4 /* Type */ | 32 /* JSDoc */, result);
	                return finishNode(result);
	            }
	            var node = createNode(161 /* TypeReference */);
	            node.typeName = parseIdentifierName();
	            return finishNode(node);
	        }
	        function parseJSDocParameter() {
	            var parameter = createNode(148 /* Parameter */);
	            if (token() === 99 /* ThisKeyword */ || token() === 94 /* NewKeyword */) {
	                parameter.name = parseIdentifierName();
	                parseExpected(56 /* ColonToken */);
	            }
	            parameter.type = parseType();
	            return finishNode(parameter);
	        }
	        function parseJSDocNodeWithType(kind) {
	            var result = createNode(kind);
	            nextToken();
	            result.type = parseNonArrayType();
	            return finishNode(result);
	        }
	        function parseTypeQuery() {
	            var node = createNode(164 /* TypeQuery */);
	            parseExpected(103 /* TypeOfKeyword */);
	            node.exprName = parseEntityName(/*allowReservedWords*/ true);
	            return finishNode(node);
	        }
	        function parseTypeParameter() {
	            var node = createNode(147 /* TypeParameter */);
	            node.name = parseIdentifier();
	            if (parseOptional(85 /* ExtendsKeyword */)) {
	                // It's not uncommon for people to write improper constraints to a generic.  If the
	                // user writes a constraint that is an expression and not an actual type, then parse
	                // it out as an expression (so we can recover well), but report that a type is needed
	                // instead.
	                if (isStartOfType() || !isStartOfExpression()) {
	                    node.constraint = parseType();
	                }
	                else {
	                    // It was not a type, and it looked like an expression.  Parse out an expression
	                    // here so we recover well.  Note: it is important that we call parseUnaryExpression
	                    // and not parseExpression here.  If the user has:
	                    //
	                    //      <T extends "">
	                    //
	                    // We do *not* want to consume the `>` as we're consuming the expression for "".
	                    node.expression = parseUnaryExpressionOrHigher();
	                }
	            }
	            if (parseOptional(58 /* EqualsToken */)) {
	                node.default = parseType();
	            }
	            return finishNode(node);
	        }
	        function parseTypeParameters() {
	            if (token() === 27 /* LessThanToken */) {
	                return parseBracketedList(18 /* TypeParameters */, parseTypeParameter, 27 /* LessThanToken */, 29 /* GreaterThanToken */);
	            }
	        }
	        function parseParameterType() {
	            if (parseOptional(56 /* ColonToken */)) {
	                return parseType();
	            }
	            return undefined;
	        }
	        function isStartOfParameter() {
	            return token() === 24 /* DotDotDotToken */ ||
	                isIdentifierOrPattern() ||
	                ts.isModifierKind(token()) ||
	                token() === 57 /* AtToken */ ||
	                isStartOfType(/*inStartOfParameter*/ true);
	        }
	        function parseParameter() {
	            var node = createNodeWithJSDoc(148 /* Parameter */);
	            if (token() === 99 /* ThisKeyword */) {
	                node.name = createIdentifier(/*isIdentifier*/ true);
	                node.type = parseParameterType();
	                return finishNode(node);
	            }
	            node.decorators = parseDecorators();
	            node.modifiers = parseModifiers();
	            node.dotDotDotToken = parseOptionalToken(24 /* DotDotDotToken */);
	            // FormalParameter [Yield,Await]:
	            //      BindingElement[?Yield,?Await]
	            node.name = parseIdentifierOrPattern();
	            if (ts.getFullWidth(node.name) === 0 && !ts.hasModifiers(node) && ts.isModifierKind(token())) {
	                // in cases like
	                // 'use strict'
	                // function foo(static)
	                // isParameter('static') === true, because of isModifier('static')
	                // however 'static' is not a legal identifier in a strict mode.
	                // so result of this function will be ParameterDeclaration (flags = 0, name = missing, type = undefined, initializer = undefined)
	                // and current token will not change => parsing of the enclosing parameter list will last till the end of time (or OOM)
	                // to avoid this we'll advance cursor to the next token.
	                nextToken();
	            }
	            node.questionToken = parseOptionalToken(55 /* QuestionToken */);
	            node.type = parseParameterType();
	            node.initializer = parseInitializer();
	            return finishNode(node);
	        }
	        function fillSignature(returnToken, flags, signature) {
	            if (!(flags & 32 /* JSDoc */)) {
	                signature.typeParameters = parseTypeParameters();
	            }
	            signature.parameters = parseParameterList(flags);
	            signature.type = parseReturnType(returnToken, !!(flags & 4 /* Type */));
	        }
	        function parseReturnType(returnToken, isType) {
	            return shouldParseReturnType(returnToken, isType) ? parseTypeOrTypePredicate() : undefined;
	        }
	        function shouldParseReturnType(returnToken, isType) {
	            if (returnToken === 36 /* EqualsGreaterThanToken */) {
	                parseExpected(returnToken);
	                return true;
	            }
	            else if (parseOptional(56 /* ColonToken */)) {
	                return true;
	            }
	            else if (isType && token() === 36 /* EqualsGreaterThanToken */) {
	                // This is easy to get backward, especially in type contexts, so parse the type anyway
	                parseErrorAtCurrentToken(ts.Diagnostics._0_expected, ts.tokenToString(56 /* ColonToken */));
	                nextToken();
	                return true;
	            }
	            return false;
	        }
	        function parseParameterList(flags) {
	            // FormalParameters [Yield,Await]: (modified)
	            //      [empty]
	            //      FormalParameterList[?Yield,Await]
	            //
	            // FormalParameter[Yield,Await]: (modified)
	            //      BindingElement[?Yield,Await]
	            //
	            // BindingElement [Yield,Await]: (modified)
	            //      SingleNameBinding[?Yield,?Await]
	            //      BindingPattern[?Yield,?Await]Initializer [In, ?Yield,?Await] opt
	            //
	            // SingleNameBinding [Yield,Await]:
	            //      BindingIdentifier[?Yield,?Await]Initializer [In, ?Yield,?Await] opt
	            if (parseExpected(19 /* OpenParenToken */)) {
	                var savedYieldContext = inYieldContext();
	                var savedAwaitContext = inAwaitContext();
	                setYieldContext(!!(flags & 1 /* Yield */));
	                setAwaitContext(!!(flags & 2 /* Await */));
	                var result = parseDelimitedList(16 /* Parameters */, flags & 32 /* JSDoc */ ? parseJSDocParameter : parseParameter);
	                setYieldContext(savedYieldContext);
	                setAwaitContext(savedAwaitContext);
	                if (!parseExpected(20 /* CloseParenToken */) && (flags & 8 /* RequireCompleteParameterList */)) {
	                    // Caller insisted that we had to end with a )   We didn't.  So just return
	                    // undefined here.
	                    return undefined;
	                }
	                return result;
	            }
	            // We didn't even have an open paren.  If the caller requires a complete parameter list,
	            // we definitely can't provide that.  However, if they're ok with an incomplete one,
	            // then just return an empty set of parameters.
	            return (flags & 8 /* RequireCompleteParameterList */) ? undefined : createMissingList();
	        }
	        function parseTypeMemberSemicolon() {
	            // We allow type members to be separated by commas or (possibly ASI) semicolons.
	            // First check if it was a comma.  If so, we're done with the member.
	            if (parseOptional(26 /* CommaToken */)) {
	                return;
	            }
	            // Didn't have a comma.  We must have a (possible ASI) semicolon.
	            parseSemicolon();
	        }
	        function parseSignatureMember(kind) {
	            var node = createNodeWithJSDoc(kind);
	            if (kind === 158 /* ConstructSignature */) {
	                parseExpected(94 /* NewKeyword */);
	            }
	            fillSignature(56 /* ColonToken */, 4 /* Type */, node);
	            parseTypeMemberSemicolon();
	            return finishNode(node);
	        }
	        function isIndexSignature() {
	            return token() === 21 /* OpenBracketToken */ && lookAhead(isUnambiguouslyIndexSignature);
	        }
	        function isUnambiguouslyIndexSignature() {
	            // The only allowed sequence is:
	            //
	            //   [id:
	            //
	            // However, for error recovery, we also check the following cases:
	            //
	            //   [...
	            //   [id,
	            //   [id?,
	            //   [id?:
	            //   [id?]
	            //   [public id
	            //   [private id
	            //   [protected id
	            //   []
	            //
	            nextToken();
	            if (token() === 24 /* DotDotDotToken */ || token() === 22 /* CloseBracketToken */) {
	                return true;
	            }
	            if (ts.isModifierKind(token())) {
	                nextToken();
	                if (isIdentifier()) {
	                    return true;
	                }
	            }
	            else if (!isIdentifier()) {
	                return false;
	            }
	            else {
	                // Skip the identifier
	                nextToken();
	            }
	            // A colon signifies a well formed indexer
	            // A comma should be a badly formed indexer because comma expressions are not allowed
	            // in computed properties.
	            if (token() === 56 /* ColonToken */ || token() === 26 /* CommaToken */) {
	                return true;
	            }
	            // Question mark could be an indexer with an optional property,
	            // or it could be a conditional expression in a computed property.
	            if (token() !== 55 /* QuestionToken */) {
	                return false;
	            }
	            // If any of the following tokens are after the question mark, it cannot
	            // be a conditional expression, so treat it as an indexer.
	            nextToken();
	            return token() === 56 /* ColonToken */ || token() === 26 /* CommaToken */ || token() === 22 /* CloseBracketToken */;
	        }
	        function parseIndexSignatureDeclaration(node) {
	            node.kind = 159 /* IndexSignature */;
	            node.parameters = parseBracketedList(16 /* Parameters */, parseParameter, 21 /* OpenBracketToken */, 22 /* CloseBracketToken */);
	            node.type = parseTypeAnnotation();
	            parseTypeMemberSemicolon();
	            return finishNode(node);
	        }
	        function parsePropertyOrMethodSignature(node) {
	            node.name = parsePropertyName();
	            node.questionToken = parseOptionalToken(55 /* QuestionToken */);
	            if (token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                node.kind = 152 /* MethodSignature */;
	                // Method signatures don't exist in expression contexts.  So they have neither
	                // [Yield] nor [Await]
	                fillSignature(56 /* ColonToken */, 4 /* Type */, node);
	            }
	            else {
	                node.kind = 150 /* PropertySignature */;
	                node.type = parseTypeAnnotation();
	                if (token() === 58 /* EqualsToken */) {
	                    // Although type literal properties cannot not have initializers, we attempt
	                    // to parse an initializer so we can report in the checker that an interface
	                    // property or type literal property cannot have an initializer.
	                    node.initializer = parseInitializer();
	                }
	            }
	            parseTypeMemberSemicolon();
	            return finishNode(node);
	        }
	        function isTypeMemberStart() {
	            // Return true if we have the start of a signature member
	            if (token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                return true;
	            }
	            var idToken;
	            // Eat up all modifiers, but hold on to the last one in case it is actually an identifier
	            while (ts.isModifierKind(token())) {
	                idToken = true;
	                nextToken();
	            }
	            // Index signatures and computed property names are type members
	            if (token() === 21 /* OpenBracketToken */) {
	                return true;
	            }
	            // Try to get the first property-like token following all modifiers
	            if (isLiteralPropertyName()) {
	                idToken = true;
	                nextToken();
	            }
	            // If we were able to get any potential identifier, check that it is
	            // the start of a member declaration
	            if (idToken) {
	                return token() === 19 /* OpenParenToken */ ||
	                    token() === 27 /* LessThanToken */ ||
	                    token() === 55 /* QuestionToken */ ||
	                    token() === 56 /* ColonToken */ ||
	                    token() === 26 /* CommaToken */ ||
	                    canParseSemicolon();
	            }
	            return false;
	        }
	        function parseTypeMember() {
	            if (token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                return parseSignatureMember(157 /* CallSignature */);
	            }
	            if (token() === 94 /* NewKeyword */ && lookAhead(nextTokenIsOpenParenOrLessThan)) {
	                return parseSignatureMember(158 /* ConstructSignature */);
	            }
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            node.modifiers = parseModifiers();
	            if (isIndexSignature()) {
	                return parseIndexSignatureDeclaration(node);
	            }
	            return parsePropertyOrMethodSignature(node);
	        }
	        function nextTokenIsOpenParenOrLessThan() {
	            nextToken();
	            return token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */;
	        }
	        function parseTypeLiteral() {
	            var node = createNode(165 /* TypeLiteral */);
	            node.members = parseObjectTypeMembers();
	            return finishNode(node);
	        }
	        function parseObjectTypeMembers() {
	            var members;
	            if (parseExpected(17 /* OpenBraceToken */)) {
	                members = parseList(4 /* TypeMembers */, parseTypeMember);
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                members = createMissingList();
	            }
	            return members;
	        }
	        function isStartOfMappedType() {
	            nextToken();
	            if (token() === 37 /* PlusToken */ || token() === 38 /* MinusToken */) {
	                return nextToken() === 132 /* ReadonlyKeyword */;
	            }
	            if (token() === 132 /* ReadonlyKeyword */) {
	                nextToken();
	            }
	            return token() === 21 /* OpenBracketToken */ && nextTokenIsIdentifier() && nextToken() === 92 /* InKeyword */;
	        }
	        function parseMappedTypeParameter() {
	            var node = createNode(147 /* TypeParameter */);
	            node.name = parseIdentifier();
	            parseExpected(92 /* InKeyword */);
	            node.constraint = parseType();
	            return finishNode(node);
	        }
	        function parseMappedType() {
	            var node = createNode(176 /* MappedType */);
	            parseExpected(17 /* OpenBraceToken */);
	            if (token() === 132 /* ReadonlyKeyword */ || token() === 37 /* PlusToken */ || token() === 38 /* MinusToken */) {
	                node.readonlyToken = parseTokenNode();
	                if (node.readonlyToken.kind !== 132 /* ReadonlyKeyword */) {
	                    parseExpectedToken(132 /* ReadonlyKeyword */);
	                }
	            }
	            parseExpected(21 /* OpenBracketToken */);
	            node.typeParameter = parseMappedTypeParameter();
	            parseExpected(22 /* CloseBracketToken */);
	            if (token() === 55 /* QuestionToken */ || token() === 37 /* PlusToken */ || token() === 38 /* MinusToken */) {
	                node.questionToken = parseTokenNode();
	                if (node.questionToken.kind !== 55 /* QuestionToken */) {
	                    parseExpectedToken(55 /* QuestionToken */);
	                }
	            }
	            node.type = parseTypeAnnotation();
	            parseSemicolon();
	            parseExpected(18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseTupleType() {
	            var node = createNode(167 /* TupleType */);
	            node.elementTypes = parseBracketedList(20 /* TupleElementTypes */, parseType, 21 /* OpenBracketToken */, 22 /* CloseBracketToken */);
	            return finishNode(node);
	        }
	        function parseParenthesizedType() {
	            var node = createNode(172 /* ParenthesizedType */);
	            parseExpected(19 /* OpenParenToken */);
	            node.type = parseType();
	            parseExpected(20 /* CloseParenToken */);
	            return finishNode(node);
	        }
	        function parseFunctionOrConstructorType(kind) {
	            var node = createNodeWithJSDoc(kind);
	            if (kind === 163 /* ConstructorType */) {
	                parseExpected(94 /* NewKeyword */);
	            }
	            fillSignature(36 /* EqualsGreaterThanToken */, 4 /* Type */, node);
	            return finishNode(node);
	        }
	        function parseKeywordAndNoDot() {
	            var node = parseTokenNode();
	            return token() === 23 /* DotToken */ ? undefined : node;
	        }
	        function parseLiteralTypeNode(negative) {
	            var node = createNode(177 /* LiteralType */);
	            var unaryMinusExpression;
	            if (negative) {
	                unaryMinusExpression = createNode(196 /* PrefixUnaryExpression */);
	                unaryMinusExpression.operator = 38 /* MinusToken */;
	                nextToken();
	            }
	            var expression = token() === 101 /* TrueKeyword */ || token() === 86 /* FalseKeyword */
	                ? parseTokenNode()
	                : parseLiteralLikeNode(token());
	            if (negative) {
	                unaryMinusExpression.operand = expression;
	                finishNode(unaryMinusExpression);
	                expression = unaryMinusExpression;
	            }
	            node.literal = expression;
	            return finishNode(node);
	        }
	        function nextTokenIsNumericLiteral() {
	            return nextToken() === 8 /* NumericLiteral */;
	        }
	        function parseNonArrayType() {
	            switch (token()) {
	                case 119 /* AnyKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 131 /* NeverKeyword */:
	                case 135 /* ObjectKeyword */:
	                    // If these are followed by a dot, then parse these out as a dotted type reference instead.
	                    return tryParse(parseKeywordAndNoDot) || parseTypeReference();
	                case 39 /* AsteriskToken */:
	                    return parseJSDocAllType();
	                case 55 /* QuestionToken */:
	                    return parseJSDocUnknownOrNullableType();
	                case 89 /* FunctionKeyword */:
	                    return parseJSDocFunctionType();
	                case 51 /* ExclamationToken */:
	                    return parseJSDocNodeWithType(278 /* JSDocNonNullableType */);
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                    return parseLiteralTypeNode();
	                case 38 /* MinusToken */:
	                    return lookAhead(nextTokenIsNumericLiteral) ? parseLiteralTypeNode(/*negative*/ true) : parseTypeReference();
	                case 105 /* VoidKeyword */:
	                case 95 /* NullKeyword */:
	                    return parseTokenNode();
	                case 99 /* ThisKeyword */: {
	                    var thisKeyword = parseThisTypeNode();
	                    if (token() === 127 /* IsKeyword */ && !scanner.hasPrecedingLineBreak()) {
	                        return parseThisTypePredicate(thisKeyword);
	                    }
	                    else {
	                        return thisKeyword;
	                    }
	                }
	                case 103 /* TypeOfKeyword */:
	                    return parseTypeQuery();
	                case 17 /* OpenBraceToken */:
	                    return lookAhead(isStartOfMappedType) ? parseMappedType() : parseTypeLiteral();
	                case 21 /* OpenBracketToken */:
	                    return parseTupleType();
	                case 19 /* OpenParenToken */:
	                    return parseParenthesizedType();
	                default:
	                    return parseTypeReference();
	            }
	        }
	        function isStartOfType(inStartOfParameter) {
	            switch (token()) {
	                case 119 /* AnyKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 141 /* UniqueKeyword */:
	                case 105 /* VoidKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 95 /* NullKeyword */:
	                case 99 /* ThisKeyword */:
	                case 103 /* TypeOfKeyword */:
	                case 131 /* NeverKeyword */:
	                case 17 /* OpenBraceToken */:
	                case 21 /* OpenBracketToken */:
	                case 27 /* LessThanToken */:
	                case 49 /* BarToken */:
	                case 48 /* AmpersandToken */:
	                case 94 /* NewKeyword */:
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                case 135 /* ObjectKeyword */:
	                case 39 /* AsteriskToken */:
	                case 55 /* QuestionToken */:
	                case 51 /* ExclamationToken */:
	                case 24 /* DotDotDotToken */:
	                case 126 /* InferKeyword */:
	                    return true;
	                case 38 /* MinusToken */:
	                    return !inStartOfParameter && lookAhead(nextTokenIsNumericLiteral);
	                case 19 /* OpenParenToken */:
	                    // Only consider '(' the start of a type if followed by ')', '...', an identifier, a modifier,
	                    // or something that starts a type. We don't want to consider things like '(1)' a type.
	                    return !inStartOfParameter && lookAhead(isStartOfParenthesizedOrFunctionType);
	                default:
	                    return isIdentifier();
	            }
	        }
	        function isStartOfParenthesizedOrFunctionType() {
	            nextToken();
	            return token() === 20 /* CloseParenToken */ || isStartOfParameter() || isStartOfType();
	        }
	        function parsePostfixTypeOrHigher() {
	            var type = parseNonArrayType();
	            while (!scanner.hasPrecedingLineBreak()) {
	                switch (token()) {
	                    case 58 /* EqualsToken */:
	                        // only parse postfix = inside jsdoc, because it's ambiguous elsewhere
	                        if (!(contextFlags & 1048576 /* JSDoc */)) {
	                            return type;
	                        }
	                        type = createJSDocPostfixType(279 /* JSDocOptionalType */, type);
	                        break;
	                    case 51 /* ExclamationToken */:
	                        type = createJSDocPostfixType(278 /* JSDocNonNullableType */, type);
	                        break;
	                    case 55 /* QuestionToken */:
	                        // If not in JSDoc and next token is start of a type we have a conditional type
	                        if (!(contextFlags & 1048576 /* JSDoc */) && lookAhead(nextTokenIsStartOfType)) {
	                            return type;
	                        }
	                        type = createJSDocPostfixType(277 /* JSDocNullableType */, type);
	                        break;
	                    case 21 /* OpenBracketToken */:
	                        parseExpected(21 /* OpenBracketToken */);
	                        if (isStartOfType()) {
	                            var node = createNode(175 /* IndexedAccessType */, type.pos);
	                            node.objectType = type;
	                            node.indexType = parseType();
	                            parseExpected(22 /* CloseBracketToken */);
	                            type = finishNode(node);
	                        }
	                        else {
	                            var node = createNode(166 /* ArrayType */, type.pos);
	                            node.elementType = type;
	                            parseExpected(22 /* CloseBracketToken */);
	                            type = finishNode(node);
	                        }
	                        break;
	                    default:
	                        return type;
	                }
	            }
	            return type;
	        }
	        function createJSDocPostfixType(kind, type) {
	            nextToken();
	            var postfix = createNode(kind, type.pos);
	            postfix.type = type;
	            return finishNode(postfix);
	        }
	        function parseTypeOperator(operator) {
	            var node = createNode(174 /* TypeOperator */);
	            parseExpected(operator);
	            node.operator = operator;
	            node.type = parseTypeOperatorOrHigher();
	            return finishNode(node);
	        }
	        function parseInferType() {
	            var node = createNode(171 /* InferType */);
	            parseExpected(126 /* InferKeyword */);
	            var typeParameter = createNode(147 /* TypeParameter */);
	            typeParameter.name = parseIdentifier();
	            node.typeParameter = finishNode(typeParameter);
	            return finishNode(node);
	        }
	        function parseTypeOperatorOrHigher() {
	            var operator = token();
	            switch (operator) {
	                case 128 /* KeyOfKeyword */:
	                case 141 /* UniqueKeyword */:
	                    return parseTypeOperator(operator);
	                case 126 /* InferKeyword */:
	                    return parseInferType();
	                case 24 /* DotDotDotToken */: {
	                    var result = createNode(281 /* JSDocVariadicType */);
	                    nextToken();
	                    result.type = parsePostfixTypeOrHigher();
	                    return finishNode(result);
	                }
	            }
	            return parsePostfixTypeOrHigher();
	        }
	        function parseUnionOrIntersectionType(kind, parseConstituentType, operator) {
	            parseOptional(operator);
	            var type = parseConstituentType();
	            if (token() === operator) {
	                var types = [type];
	                while (parseOptional(operator)) {
	                    types.push(parseConstituentType());
	                }
	                var node = createNode(kind, type.pos);
	                node.types = createNodeArray(types, type.pos);
	                type = finishNode(node);
	            }
	            return type;
	        }
	        function parseIntersectionTypeOrHigher() {
	            return parseUnionOrIntersectionType(169 /* IntersectionType */, parseTypeOperatorOrHigher, 48 /* AmpersandToken */);
	        }
	        function parseUnionTypeOrHigher() {
	            return parseUnionOrIntersectionType(168 /* UnionType */, parseIntersectionTypeOrHigher, 49 /* BarToken */);
	        }
	        function isStartOfFunctionType() {
	            if (token() === 27 /* LessThanToken */) {
	                return true;
	            }
	            return token() === 19 /* OpenParenToken */ && lookAhead(isUnambiguouslyStartOfFunctionType);
	        }
	        function skipParameterStart() {
	            if (ts.isModifierKind(token())) {
	                // Skip modifiers
	                parseModifiers();
	            }
	            if (isIdentifier() || token() === 99 /* ThisKeyword */) {
	                nextToken();
	                return true;
	            }
	            if (token() === 21 /* OpenBracketToken */ || token() === 17 /* OpenBraceToken */) {
	                // Return true if we can parse an array or object binding pattern with no errors
	                var previousErrorCount = parseDiagnostics.length;
	                parseIdentifierOrPattern();
	                return previousErrorCount === parseDiagnostics.length;
	            }
	            return false;
	        }
	        function isUnambiguouslyStartOfFunctionType() {
	            nextToken();
	            if (token() === 20 /* CloseParenToken */ || token() === 24 /* DotDotDotToken */) {
	                // ( )
	                // ( ...
	                return true;
	            }
	            if (skipParameterStart()) {
	                // We successfully skipped modifiers (if any) and an identifier or binding pattern,
	                // now see if we have something that indicates a parameter declaration
	                if (token() === 56 /* ColonToken */ || token() === 26 /* CommaToken */ ||
	                    token() === 55 /* QuestionToken */ || token() === 58 /* EqualsToken */) {
	                    // ( xxx :
	                    // ( xxx ,
	                    // ( xxx ?
	                    // ( xxx =
	                    return true;
	                }
	                if (token() === 20 /* CloseParenToken */) {
	                    nextToken();
	                    if (token() === 36 /* EqualsGreaterThanToken */) {
	                        // ( xxx ) =>
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function parseTypeOrTypePredicate() {
	            var typePredicateVariable = isIdentifier() && tryParse(parseTypePredicatePrefix);
	            var type = parseType();
	            if (typePredicateVariable) {
	                var node = createNode(160 /* TypePredicate */, typePredicateVariable.pos);
	                node.parameterName = typePredicateVariable;
	                node.type = type;
	                return finishNode(node);
	            }
	            else {
	                return type;
	            }
	        }
	        function parseTypePredicatePrefix() {
	            var id = parseIdentifier();
	            if (token() === 127 /* IsKeyword */ && !scanner.hasPrecedingLineBreak()) {
	                nextToken();
	                return id;
	            }
	        }
	        function parseType() {
	            // The rules about 'yield' only apply to actual code/expression contexts.  They don't
	            // apply to 'type' contexts.  So we disable these parameters here before moving on.
	            return doOutsideOfContext(20480 /* TypeExcludesFlags */, parseTypeWorker);
	        }
	        function parseTypeWorker(noConditionalTypes) {
	            if (isStartOfFunctionType()) {
	                return parseFunctionOrConstructorType(162 /* FunctionType */);
	            }
	            if (token() === 94 /* NewKeyword */) {
	                return parseFunctionOrConstructorType(163 /* ConstructorType */);
	            }
	            var type = parseUnionTypeOrHigher();
	            if (!noConditionalTypes && !scanner.hasPrecedingLineBreak() && parseOptional(85 /* ExtendsKeyword */)) {
	                var node = createNode(170 /* ConditionalType */, type.pos);
	                node.checkType = type;
	                // The type following 'extends' is not permitted to be another conditional type
	                node.extendsType = parseTypeWorker(/*noConditionalTypes*/ true);
	                parseExpected(55 /* QuestionToken */);
	                node.trueType = parseTypeWorker();
	                parseExpected(56 /* ColonToken */);
	                node.falseType = parseTypeWorker();
	                return finishNode(node);
	            }
	            return type;
	        }
	        function parseTypeAnnotation() {
	            return parseOptional(56 /* ColonToken */) ? parseType() : undefined;
	        }
	        // EXPRESSIONS
	        function isStartOfLeftHandSideExpression() {
	            switch (token()) {
	                case 99 /* ThisKeyword */:
	                case 97 /* SuperKeyword */:
	                case 95 /* NullKeyword */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                case 8 /* NumericLiteral */:
	                case 9 /* StringLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 14 /* TemplateHead */:
	                case 19 /* OpenParenToken */:
	                case 21 /* OpenBracketToken */:
	                case 17 /* OpenBraceToken */:
	                case 89 /* FunctionKeyword */:
	                case 75 /* ClassKeyword */:
	                case 94 /* NewKeyword */:
	                case 41 /* SlashToken */:
	                case 63 /* SlashEqualsToken */:
	                case 71 /* Identifier */:
	                    return true;
	                case 91 /* ImportKeyword */:
	                    return lookAhead(nextTokenIsOpenParenOrLessThan);
	                default:
	                    return isIdentifier();
	            }
	        }
	        function isStartOfExpression() {
	            if (isStartOfLeftHandSideExpression()) {
	                return true;
	            }
	            switch (token()) {
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                case 52 /* TildeToken */:
	                case 51 /* ExclamationToken */:
	                case 80 /* DeleteKeyword */:
	                case 103 /* TypeOfKeyword */:
	                case 105 /* VoidKeyword */:
	                case 43 /* PlusPlusToken */:
	                case 44 /* MinusMinusToken */:
	                case 27 /* LessThanToken */:
	                case 121 /* AwaitKeyword */:
	                case 116 /* YieldKeyword */:
	                    // Yield/await always starts an expression.  Either it is an identifier (in which case
	                    // it is definitely an expression).  Or it's a keyword (either because we're in
	                    // a generator or async function, or in strict mode (or both)) and it started a yield or await expression.
	                    return true;
	                default:
	                    // Error tolerance.  If we see the start of some binary operator, we consider
	                    // that the start of an expression.  That way we'll parse out a missing identifier,
	                    // give a good message about an identifier being missing, and then consume the
	                    // rest of the binary expression.
	                    if (isBinaryOperator()) {
	                        return true;
	                    }
	                    return isIdentifier();
	            }
	        }
	        function isStartOfExpressionStatement() {
	            // As per the grammar, none of '{' or 'function' or 'class' can start an expression statement.
	            return token() !== 17 /* OpenBraceToken */ &&
	                token() !== 89 /* FunctionKeyword */ &&
	                token() !== 75 /* ClassKeyword */ &&
	                token() !== 57 /* AtToken */ &&
	                isStartOfExpression();
	        }
	        function parseExpression() {
	            // Expression[in]:
	            //      AssignmentExpression[in]
	            //      Expression[in] , AssignmentExpression[in]
	            // clear the decorator context when parsing Expression, as it should be unambiguous when parsing a decorator
	            var saveDecoratorContext = inDecoratorContext();
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ false);
	            }
	            var expr = parseAssignmentExpressionOrHigher();
	            var operatorToken;
	            while ((operatorToken = parseOptionalToken(26 /* CommaToken */))) {
	                expr = makeBinaryExpression(expr, operatorToken, parseAssignmentExpressionOrHigher());
	            }
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ true);
	            }
	            return expr;
	        }
	        function parseInitializer() {
	            return parseOptional(58 /* EqualsToken */) ? parseAssignmentExpressionOrHigher() : undefined;
	        }
	        function parseAssignmentExpressionOrHigher() {
	            //  AssignmentExpression[in,yield]:
	            //      1) ConditionalExpression[?in,?yield]
	            //      2) LeftHandSideExpression = AssignmentExpression[?in,?yield]
	            //      3) LeftHandSideExpression AssignmentOperator AssignmentExpression[?in,?yield]
	            //      4) ArrowFunctionExpression[?in,?yield]
	            //      5) AsyncArrowFunctionExpression[in,yield,await]
	            //      6) [+Yield] YieldExpression[?In]
	            //
	            // Note: for ease of implementation we treat productions '2' and '3' as the same thing.
	            // (i.e. they're both BinaryExpressions with an assignment operator in it).
	            // First, do the simple check if we have a YieldExpression (production '6').
	            if (isYieldExpression()) {
	                return parseYieldExpression();
	            }
	            // Then, check if we have an arrow function (production '4' and '5') that starts with a parenthesized
	            // parameter list or is an async arrow function.
	            // AsyncArrowFunctionExpression:
	            //      1) async[no LineTerminator here]AsyncArrowBindingIdentifier[?Yield][no LineTerminator here]=>AsyncConciseBody[?In]
	            //      2) CoverCallExpressionAndAsyncArrowHead[?Yield, ?Await][no LineTerminator here]=>AsyncConciseBody[?In]
	            // Production (1) of AsyncArrowFunctionExpression is parsed in "tryParseAsyncSimpleArrowFunctionExpression".
	            // And production (2) is parsed in "tryParseParenthesizedArrowFunctionExpression".
	            //
	            // If we do successfully parse arrow-function, we must *not* recurse for productions 1, 2 or 3. An ArrowFunction is
	            // not a LeftHandSideExpression, nor does it start a ConditionalExpression.  So we are done
	            // with AssignmentExpression if we see one.
	            var arrowExpression = tryParseParenthesizedArrowFunctionExpression() || tryParseAsyncSimpleArrowFunctionExpression();
	            if (arrowExpression) {
	                return arrowExpression;
	            }
	            // Now try to see if we're in production '1', '2' or '3'.  A conditional expression can
	            // start with a LogicalOrExpression, while the assignment productions can only start with
	            // LeftHandSideExpressions.
	            //
	            // So, first, we try to just parse out a BinaryExpression.  If we get something that is a
	            // LeftHandSide or higher, then we can try to parse out the assignment expression part.
	            // Otherwise, we try to parse out the conditional expression bit.  We want to allow any
	            // binary expression here, so we pass in the 'lowest' precedence here so that it matches
	            // and consumes anything.
	            var expr = parseBinaryExpressionOrHigher(/*precedence*/ 0);
	            // To avoid a look-ahead, we did not handle the case of an arrow function with a single un-parenthesized
	            // parameter ('x => ...') above. We handle it here by checking if the parsed expression was a single
	            // identifier and the current token is an arrow.
	            if (expr.kind === 71 /* Identifier */ && token() === 36 /* EqualsGreaterThanToken */) {
	                return parseSimpleArrowFunctionExpression(expr);
	            }
	            // Now see if we might be in cases '2' or '3'.
	            // If the expression was a LHS expression, and we have an assignment operator, then
	            // we're in '2' or '3'. Consume the assignment and return.
	            //
	            // Note: we call reScanGreaterToken so that we get an appropriately merged token
	            // for cases like `> > =` becoming `>>=`
	            if (ts.isLeftHandSideExpression(expr) && ts.isAssignmentOperator(reScanGreaterToken())) {
	                return makeBinaryExpression(expr, parseTokenNode(), parseAssignmentExpressionOrHigher());
	            }
	            // It wasn't an assignment or a lambda.  This is a conditional expression:
	            return parseConditionalExpressionRest(expr);
	        }
	        function isYieldExpression() {
	            if (token() === 116 /* YieldKeyword */) {
	                // If we have a 'yield' keyword, and this is a context where yield expressions are
	                // allowed, then definitely parse out a yield expression.
	                if (inYieldContext()) {
	                    return true;
	                }
	                // We're in a context where 'yield expr' is not allowed.  However, if we can
	                // definitely tell that the user was trying to parse a 'yield expr' and not
	                // just a normal expr that start with a 'yield' identifier, then parse out
	                // a 'yield expr'.  We can then report an error later that they are only
	                // allowed in generator expressions.
	                //
	                // for example, if we see 'yield(foo)', then we'll have to treat that as an
	                // invocation expression of something called 'yield'.  However, if we have
	                // 'yield foo' then that is not legal as a normal expression, so we can
	                // definitely recognize this as a yield expression.
	                //
	                // for now we just check if the next token is an identifier.  More heuristics
	                // can be added here later as necessary.  We just need to make sure that we
	                // don't accidentally consume something legal.
	                return lookAhead(nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine);
	            }
	            return false;
	        }
	        function nextTokenIsIdentifierOnSameLine() {
	            nextToken();
	            return !scanner.hasPrecedingLineBreak() && isIdentifier();
	        }
	        function parseYieldExpression() {
	            var node = createNode(201 /* YieldExpression */);
	            // YieldExpression[In] :
	            //      yield
	            //      yield [no LineTerminator here] [Lexical goal InputElementRegExp]AssignmentExpression[?In, Yield]
	            //      yield [no LineTerminator here] * [Lexical goal InputElementRegExp]AssignmentExpression[?In, Yield]
	            nextToken();
	            if (!scanner.hasPrecedingLineBreak() &&
	                (token() === 39 /* AsteriskToken */ || isStartOfExpression())) {
	                node.asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	                node.expression = parseAssignmentExpressionOrHigher();
	                return finishNode(node);
	            }
	            else {
	                // if the next token is not on the same line as yield.  or we don't have an '*' or
	                // the start of an expression, then this is just a simple "yield" expression.
	                return finishNode(node);
	            }
	        }
	        function parseSimpleArrowFunctionExpression(identifier, asyncModifier) {
	            ts.Debug.assert(token() === 36 /* EqualsGreaterThanToken */, "parseSimpleArrowFunctionExpression should only have been called if we had a =>");
	            var node;
	            if (asyncModifier) {
	                node = createNode(191 /* ArrowFunction */, asyncModifier.pos);
	                node.modifiers = asyncModifier;
	            }
	            else {
	                node = createNode(191 /* ArrowFunction */, identifier.pos);
	            }
	            var parameter = createNode(148 /* Parameter */, identifier.pos);
	            parameter.name = identifier;
	            finishNode(parameter);
	            node.parameters = createNodeArray([parameter], parameter.pos, parameter.end);
	            node.equalsGreaterThanToken = parseExpectedToken(36 /* EqualsGreaterThanToken */);
	            node.body = parseArrowFunctionExpressionBody(/*isAsync*/ !!asyncModifier);
	            return addJSDocComment(finishNode(node));
	        }
	        function tryParseParenthesizedArrowFunctionExpression() {
	            var triState = isParenthesizedArrowFunctionExpression();
	            if (triState === 0 /* False */) {
	                // It's definitely not a parenthesized arrow function expression.
	                return undefined;
	            }
	            // If we definitely have an arrow function, then we can just parse one, not requiring a
	            // following => or { token. Otherwise, we *might* have an arrow function.  Try to parse
	            // it out, but don't allow any ambiguity, and return 'undefined' if this could be an
	            // expression instead.
	            var arrowFunction = triState === 1 /* True */
	                ? parseParenthesizedArrowFunctionExpressionHead(/*allowAmbiguity*/ true)
	                : tryParse(parsePossibleParenthesizedArrowFunctionExpressionHead);
	            if (!arrowFunction) {
	                // Didn't appear to actually be a parenthesized arrow function.  Just bail out.
	                return undefined;
	            }
	            var isAsync = ts.hasModifier(arrowFunction, 256 /* Async */);
	            // If we have an arrow, then try to parse the body. Even if not, try to parse if we
	            // have an opening brace, just in case we're in an error state.
	            var lastToken = token();
	            arrowFunction.equalsGreaterThanToken = parseExpectedToken(36 /* EqualsGreaterThanToken */);
	            arrowFunction.body = (lastToken === 36 /* EqualsGreaterThanToken */ || lastToken === 17 /* OpenBraceToken */)
	                ? parseArrowFunctionExpressionBody(isAsync)
	                : parseIdentifier();
	            return finishNode(arrowFunction);
	        }
	        //  True        -> We definitely expect a parenthesized arrow function here.
	        //  False       -> There *cannot* be a parenthesized arrow function here.
	        //  Unknown     -> There *might* be a parenthesized arrow function here.
	        //                 Speculatively look ahead to be sure, and rollback if not.
	        function isParenthesizedArrowFunctionExpression() {
	            if (token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */ || token() === 120 /* AsyncKeyword */) {
	                return lookAhead(isParenthesizedArrowFunctionExpressionWorker);
	            }
	            if (token() === 36 /* EqualsGreaterThanToken */) {
	                // ERROR RECOVERY TWEAK:
	                // If we see a standalone => try to parse it as an arrow function expression as that's
	                // likely what the user intended to write.
	                return 1 /* True */;
	            }
	            // Definitely not a parenthesized arrow function.
	            return 0 /* False */;
	        }
	        function isParenthesizedArrowFunctionExpressionWorker() {
	            if (token() === 120 /* AsyncKeyword */) {
	                nextToken();
	                if (scanner.hasPrecedingLineBreak()) {
	                    return 0 /* False */;
	                }
	                if (token() !== 19 /* OpenParenToken */ && token() !== 27 /* LessThanToken */) {
	                    return 0 /* False */;
	                }
	            }
	            var first = token();
	            var second = nextToken();
	            if (first === 19 /* OpenParenToken */) {
	                if (second === 20 /* CloseParenToken */) {
	                    // Simple cases: "() =>", "(): ", and "() {".
	                    // This is an arrow function with no parameters.
	                    // The last one is not actually an arrow function,
	                    // but this is probably what the user intended.
	                    var third = nextToken();
	                    switch (third) {
	                        case 36 /* EqualsGreaterThanToken */:
	                        case 56 /* ColonToken */:
	                        case 17 /* OpenBraceToken */:
	                            return 1 /* True */;
	                        default:
	                            return 0 /* False */;
	                    }
	                }
	                // If encounter "([" or "({", this could be the start of a binding pattern.
	                // Examples:
	                //      ([ x ]) => { }
	                //      ({ x }) => { }
	                //      ([ x ])
	                //      ({ x })
	                if (second === 21 /* OpenBracketToken */ || second === 17 /* OpenBraceToken */) {
	                    return 2 /* Unknown */;
	                }
	                // Simple case: "(..."
	                // This is an arrow function with a rest parameter.
	                if (second === 24 /* DotDotDotToken */) {
	                    return 1 /* True */;
	                }
	                // Check for "(xxx yyy", where xxx is a modifier and yyy is an identifier. This
	                // isn't actually allowed, but we want to treat it as a lambda so we can provide
	                // a good error message.
	                if (ts.isModifierKind(second) && second !== 120 /* AsyncKeyword */ && lookAhead(nextTokenIsIdentifier)) {
	                    return 1 /* True */;
	                }
	                // If we had "(" followed by something that's not an identifier,
	                // then this definitely doesn't look like a lambda.
	                if (!isIdentifier()) {
	                    return 0 /* False */;
	                }
	                switch (nextToken()) {
	                    case 56 /* ColonToken */:
	                        // If we have something like "(a:", then we must have a
	                        // type-annotated parameter in an arrow function expression.
	                        return 1 /* True */;
	                    case 55 /* QuestionToken */:
	                        nextToken();
	                        // If we have "(a?:" or "(a?," or "(a?=" or "(a?)" then it is definitely a lambda.
	                        if (token() === 56 /* ColonToken */ || token() === 26 /* CommaToken */ || token() === 58 /* EqualsToken */ || token() === 20 /* CloseParenToken */) {
	                            return 1 /* True */;
	                        }
	                        // Otherwise it is definitely not a lambda.
	                        return 0 /* False */;
	                    case 26 /* CommaToken */:
	                    case 58 /* EqualsToken */:
	                    case 20 /* CloseParenToken */:
	                        // If we have "(a," or "(a=" or "(a)" this *could* be an arrow function
	                        return 2 /* Unknown */;
	                }
	                // It is definitely not an arrow function
	                return 0 /* False */;
	            }
	            else {
	                ts.Debug.assert(first === 27 /* LessThanToken */);
	                // If we have "<" not followed by an identifier,
	                // then this definitely is not an arrow function.
	                if (!isIdentifier()) {
	                    return 0 /* False */;
	                }
	                // JSX overrides
	                if (sourceFile.languageVariant === 1 /* JSX */) {
	                    var isArrowFunctionInJsx = lookAhead(function () {
	                        var third = nextToken();
	                        if (third === 85 /* ExtendsKeyword */) {
	                            var fourth = nextToken();
	                            switch (fourth) {
	                                case 58 /* EqualsToken */:
	                                case 29 /* GreaterThanToken */:
	                                    return false;
	                                default:
	                                    return true;
	                            }
	                        }
	                        else if (third === 26 /* CommaToken */) {
	                            return true;
	                        }
	                        return false;
	                    });
	                    if (isArrowFunctionInJsx) {
	                        return 1 /* True */;
	                    }
	                    return 0 /* False */;
	                }
	                // This *could* be a parenthesized arrow function.
	                return 2 /* Unknown */;
	            }
	        }
	        function parsePossibleParenthesizedArrowFunctionExpressionHead() {
	            return parseParenthesizedArrowFunctionExpressionHead(/*allowAmbiguity*/ false);
	        }
	        function tryParseAsyncSimpleArrowFunctionExpression() {
	            // We do a check here so that we won't be doing unnecessarily call to "lookAhead"
	            if (token() === 120 /* AsyncKeyword */) {
	                if (lookAhead(isUnParenthesizedAsyncArrowFunctionWorker) === 1 /* True */) {
	                    var asyncModifier = parseModifiersForArrowFunction();
	                    var expr = parseBinaryExpressionOrHigher(/*precedence*/ 0);
	                    return parseSimpleArrowFunctionExpression(expr, asyncModifier);
	                }
	            }
	            return undefined;
	        }
	        function isUnParenthesizedAsyncArrowFunctionWorker() {
	            // AsyncArrowFunctionExpression:
	            //      1) async[no LineTerminator here]AsyncArrowBindingIdentifier[?Yield][no LineTerminator here]=>AsyncConciseBody[?In]
	            //      2) CoverCallExpressionAndAsyncArrowHead[?Yield, ?Await][no LineTerminator here]=>AsyncConciseBody[?In]
	            if (token() === 120 /* AsyncKeyword */) {
	                nextToken();
	                // If the "async" is followed by "=>" token then it is not a begining of an async arrow-function
	                // but instead a simple arrow-function which will be parsed inside "parseAssignmentExpressionOrHigher"
	                if (scanner.hasPrecedingLineBreak() || token() === 36 /* EqualsGreaterThanToken */) {
	                    return 0 /* False */;
	                }
	                // Check for un-parenthesized AsyncArrowFunction
	                var expr = parseBinaryExpressionOrHigher(/*precedence*/ 0);
	                if (!scanner.hasPrecedingLineBreak() && expr.kind === 71 /* Identifier */ && token() === 36 /* EqualsGreaterThanToken */) {
	                    return 1 /* True */;
	                }
	            }
	            return 0 /* False */;
	        }
	        function parseParenthesizedArrowFunctionExpressionHead(allowAmbiguity) {
	            var node = createNodeWithJSDoc(191 /* ArrowFunction */);
	            node.modifiers = parseModifiersForArrowFunction();
	            var isAsync = ts.hasModifier(node, 256 /* Async */) ? 2 /* Await */ : 0 /* None */;
	            // Arrow functions are never generators.
	            //
	            // If we're speculatively parsing a signature for a parenthesized arrow function, then
	            // we have to have a complete parameter list.  Otherwise we might see something like
	            // a => (b => c)
	            // And think that "(b =>" was actually a parenthesized arrow function with a missing
	            // close paren.
	            fillSignature(56 /* ColonToken */, isAsync | (allowAmbiguity ? 0 /* None */ : 8 /* RequireCompleteParameterList */), node);
	            // If we couldn't get parameters, we definitely could not parse out an arrow function.
	            if (!node.parameters) {
	                return undefined;
	            }
	            // Parsing a signature isn't enough.
	            // Parenthesized arrow signatures often look like other valid expressions.
	            // For instance:
	            //  - "(x = 10)" is an assignment expression parsed as a signature with a default parameter value.
	            //  - "(x,y)" is a comma expression parsed as a signature with two parameters.
	            //  - "a ? (b): c" will have "(b):" parsed as a signature with a return type annotation.
	            //
	            // So we need just a bit of lookahead to ensure that it can only be a signature.
	            if (!allowAmbiguity && token() !== 36 /* EqualsGreaterThanToken */ && token() !== 17 /* OpenBraceToken */) {
	                // Returning undefined here will cause our caller to rewind to where we started from.
	                return undefined;
	            }
	            return node;
	        }
	        function parseArrowFunctionExpressionBody(isAsync) {
	            if (token() === 17 /* OpenBraceToken */) {
	                return parseFunctionBlock(isAsync ? 2 /* Await */ : 0 /* None */);
	            }
	            if (token() !== 25 /* SemicolonToken */ &&
	                token() !== 89 /* FunctionKeyword */ &&
	                token() !== 75 /* ClassKeyword */ &&
	                isStartOfStatement() &&
	                !isStartOfExpressionStatement()) {
	                // Check if we got a plain statement (i.e. no expression-statements, no function/class expressions/declarations)
	                //
	                // Here we try to recover from a potential error situation in the case where the
	                // user meant to supply a block. For example, if the user wrote:
	                //
	                //  a =>
	                //      let v = 0;
	                //  }
	                //
	                // they may be missing an open brace.  Check to see if that's the case so we can
	                // try to recover better.  If we don't do this, then the next close curly we see may end
	                // up preemptively closing the containing construct.
	                //
	                // Note: even when 'IgnoreMissingOpenBrace' is passed, parseBody will still error.
	                return parseFunctionBlock(16 /* IgnoreMissingOpenBrace */ | (isAsync ? 2 /* Await */ : 0 /* None */));
	            }
	            return isAsync
	                ? doInAwaitContext(parseAssignmentExpressionOrHigher)
	                : doOutsideOfAwaitContext(parseAssignmentExpressionOrHigher);
	        }
	        function parseConditionalExpressionRest(leftOperand) {
	            // Note: we are passed in an expression which was produced from parseBinaryExpressionOrHigher.
	            var questionToken = parseOptionalToken(55 /* QuestionToken */);
	            if (!questionToken) {
	                return leftOperand;
	            }
	            // Note: we explicitly 'allowIn' in the whenTrue part of the condition expression, and
	            // we do not that for the 'whenFalse' part.
	            var node = createNode(199 /* ConditionalExpression */, leftOperand.pos);
	            node.condition = leftOperand;
	            node.questionToken = questionToken;
	            node.whenTrue = doOutsideOfContext(disallowInAndDecoratorContext, parseAssignmentExpressionOrHigher);
	            node.colonToken = parseExpectedToken(56 /* ColonToken */);
	            node.whenFalse = ts.nodeIsPresent(node.colonToken)
	                ? parseAssignmentExpressionOrHigher()
	                : createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ false, ts.Diagnostics._0_expected, ts.tokenToString(56 /* ColonToken */));
	            return finishNode(node);
	        }
	        function parseBinaryExpressionOrHigher(precedence) {
	            var leftOperand = parseUnaryExpressionOrHigher();
	            return parseBinaryExpressionRest(precedence, leftOperand);
	        }
	        function isInOrOfKeyword(t) {
	            return t === 92 /* InKeyword */ || t === 144 /* OfKeyword */;
	        }
	        function parseBinaryExpressionRest(precedence, leftOperand) {
	            while (true) {
	                // We either have a binary operator here, or we're finished.  We call
	                // reScanGreaterToken so that we merge token sequences like > and = into >=
	                reScanGreaterToken();
	                var newPrecedence = getBinaryOperatorPrecedence();
	                // Check the precedence to see if we should "take" this operator
	                // - For left associative operator (all operator but **), consume the operator,
	                //   recursively call the function below, and parse binaryExpression as a rightOperand
	                //   of the caller if the new precedence of the operator is greater then or equal to the current precedence.
	                //   For example:
	                //      a - b - c;
	                //            ^token; leftOperand = b. Return b to the caller as a rightOperand
	                //      a * b - c
	                //            ^token; leftOperand = b. Return b to the caller as a rightOperand
	                //      a - b * c;
	                //            ^token; leftOperand = b. Return b * c to the caller as a rightOperand
	                // - For right associative operator (**), consume the operator, recursively call the function
	                //   and parse binaryExpression as a rightOperand of the caller if the new precedence of
	                //   the operator is strictly grater than the current precedence
	                //   For example:
	                //      a ** b ** c;
	                //             ^^token; leftOperand = b. Return b ** c to the caller as a rightOperand
	                //      a - b ** c;
	                //            ^^token; leftOperand = b. Return b ** c to the caller as a rightOperand
	                //      a ** b - c
	                //             ^token; leftOperand = b. Return b to the caller as a rightOperand
	                var consumeCurrentOperator = token() === 40 /* AsteriskAsteriskToken */ ?
	                    newPrecedence >= precedence :
	                    newPrecedence > precedence;
	                if (!consumeCurrentOperator) {
	                    break;
	                }
	                if (token() === 92 /* InKeyword */ && inDisallowInContext()) {
	                    break;
	                }
	                if (token() === 118 /* AsKeyword */) {
	                    // Make sure we *do* perform ASI for constructs like this:
	                    //    var x = foo
	                    //    as (Bar)
	                    // This should be parsed as an initialized variable, followed
	                    // by a function call to 'as' with the argument 'Bar'
	                    if (scanner.hasPrecedingLineBreak()) {
	                        break;
	                    }
	                    else {
	                        nextToken();
	                        leftOperand = makeAsExpression(leftOperand, parseType());
	                    }
	                }
	                else {
	                    leftOperand = makeBinaryExpression(leftOperand, parseTokenNode(), parseBinaryExpressionOrHigher(newPrecedence));
	                }
	            }
	            return leftOperand;
	        }
	        function isBinaryOperator() {
	            if (inDisallowInContext() && token() === 92 /* InKeyword */) {
	                return false;
	            }
	            return getBinaryOperatorPrecedence() > 0;
	        }
	        function getBinaryOperatorPrecedence() {
	            switch (token()) {
	                case 54 /* BarBarToken */:
	                    return 1;
	                case 53 /* AmpersandAmpersandToken */:
	                    return 2;
	                case 49 /* BarToken */:
	                    return 3;
	                case 50 /* CaretToken */:
	                    return 4;
	                case 48 /* AmpersandToken */:
	                    return 5;
	                case 32 /* EqualsEqualsToken */:
	                case 33 /* ExclamationEqualsToken */:
	                case 34 /* EqualsEqualsEqualsToken */:
	                case 35 /* ExclamationEqualsEqualsToken */:
	                    return 6;
	                case 27 /* LessThanToken */:
	                case 29 /* GreaterThanToken */:
	                case 30 /* LessThanEqualsToken */:
	                case 31 /* GreaterThanEqualsToken */:
	                case 93 /* InstanceOfKeyword */:
	                case 92 /* InKeyword */:
	                case 118 /* AsKeyword */:
	                    return 7;
	                case 45 /* LessThanLessThanToken */:
	                case 46 /* GreaterThanGreaterThanToken */:
	                case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                    return 8;
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                    return 9;
	                case 39 /* AsteriskToken */:
	                case 41 /* SlashToken */:
	                case 42 /* PercentToken */:
	                    return 10;
	                case 40 /* AsteriskAsteriskToken */:
	                    return 11;
	            }
	            // -1 is lower than all other precedences.  Returning it will cause binary expression
	            // parsing to stop.
	            return -1;
	        }
	        function makeBinaryExpression(left, operatorToken, right) {
	            var node = createNode(198 /* BinaryExpression */, left.pos);
	            node.left = left;
	            node.operatorToken = operatorToken;
	            node.right = right;
	            return finishNode(node);
	        }
	        function makeAsExpression(left, right) {
	            var node = createNode(206 /* AsExpression */, left.pos);
	            node.expression = left;
	            node.type = right;
	            return finishNode(node);
	        }
	        function parsePrefixUnaryExpression() {
	            var node = createNode(196 /* PrefixUnaryExpression */);
	            node.operator = token();
	            nextToken();
	            node.operand = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function parseDeleteExpression() {
	            var node = createNode(192 /* DeleteExpression */);
	            nextToken();
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function parseTypeOfExpression() {
	            var node = createNode(193 /* TypeOfExpression */);
	            nextToken();
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function parseVoidExpression() {
	            var node = createNode(194 /* VoidExpression */);
	            nextToken();
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function isAwaitExpression() {
	            if (token() === 121 /* AwaitKeyword */) {
	                if (inAwaitContext()) {
	                    return true;
	                }
	                // here we are using similar heuristics as 'isYieldExpression'
	                return lookAhead(nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine);
	            }
	            return false;
	        }
	        function parseAwaitExpression() {
	            var node = createNode(195 /* AwaitExpression */);
	            nextToken();
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        /**
	         * Parse ES7 exponential expression and await expression
	         *
	         * ES7 ExponentiationExpression:
	         *      1) UnaryExpression[?Yield]
	         *      2) UpdateExpression[?Yield] ** ExponentiationExpression[?Yield]
	         *
	         */
	        function parseUnaryExpressionOrHigher() {
	            /**
	             * ES7 UpdateExpression:
	             *      1) LeftHandSideExpression[?Yield]
	             *      2) LeftHandSideExpression[?Yield][no LineTerminator here]++
	             *      3) LeftHandSideExpression[?Yield][no LineTerminator here]--
	             *      4) ++UnaryExpression[?Yield]
	             *      5) --UnaryExpression[?Yield]
	             */
	            if (isUpdateExpression()) {
	                var updateExpression = parseUpdateExpression();
	                return token() === 40 /* AsteriskAsteriskToken */ ?
	                    parseBinaryExpressionRest(getBinaryOperatorPrecedence(), updateExpression) :
	                    updateExpression;
	            }
	            /**
	             * ES7 UnaryExpression:
	             *      1) UpdateExpression[?yield]
	             *      2) delete UpdateExpression[?yield]
	             *      3) void UpdateExpression[?yield]
	             *      4) typeof UpdateExpression[?yield]
	             *      5) + UpdateExpression[?yield]
	             *      6) - UpdateExpression[?yield]
	             *      7) ~ UpdateExpression[?yield]
	             *      8) ! UpdateExpression[?yield]
	             */
	            var unaryOperator = token();
	            var simpleUnaryExpression = parseSimpleUnaryExpression();
	            if (token() === 40 /* AsteriskAsteriskToken */) {
	                var start = ts.skipTrivia(sourceText, simpleUnaryExpression.pos);
	                if (simpleUnaryExpression.kind === 188 /* TypeAssertionExpression */) {
	                    parseErrorAtPosition(start, simpleUnaryExpression.end - start, ts.Diagnostics.A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses);
	                }
	                else {
	                    parseErrorAtPosition(start, simpleUnaryExpression.end - start, ts.Diagnostics.An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses, ts.tokenToString(unaryOperator));
	                }
	            }
	            return simpleUnaryExpression;
	        }
	        /**
	         * Parse ES7 simple-unary expression or higher:
	         *
	         * ES7 UnaryExpression:
	         *      1) UpdateExpression[?yield]
	         *      2) delete UnaryExpression[?yield]
	         *      3) void UnaryExpression[?yield]
	         *      4) typeof UnaryExpression[?yield]
	         *      5) + UnaryExpression[?yield]
	         *      6) - UnaryExpression[?yield]
	         *      7) ~ UnaryExpression[?yield]
	         *      8) ! UnaryExpression[?yield]
	         *      9) [+Await] await UnaryExpression[?yield]
	         */
	        function parseSimpleUnaryExpression() {
	            switch (token()) {
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                case 52 /* TildeToken */:
	                case 51 /* ExclamationToken */:
	                    return parsePrefixUnaryExpression();
	                case 80 /* DeleteKeyword */:
	                    return parseDeleteExpression();
	                case 103 /* TypeOfKeyword */:
	                    return parseTypeOfExpression();
	                case 105 /* VoidKeyword */:
	                    return parseVoidExpression();
	                case 27 /* LessThanToken */:
	                    // This is modified UnaryExpression grammar in TypeScript
	                    //  UnaryExpression (modified):
	                    //      < type > UnaryExpression
	                    return parseTypeAssertion();
	                case 121 /* AwaitKeyword */:
	                    if (isAwaitExpression()) {
	                        return parseAwaitExpression();
	                    }
	                // falls through
	                default:
	                    return parseUpdateExpression();
	            }
	        }
	        /**
	         * Check if the current token can possibly be an ES7 increment expression.
	         *
	         * ES7 UpdateExpression:
	         *      LeftHandSideExpression[?Yield]
	         *      LeftHandSideExpression[?Yield][no LineTerminator here]++
	         *      LeftHandSideExpression[?Yield][no LineTerminator here]--
	         *      ++LeftHandSideExpression[?Yield]
	         *      --LeftHandSideExpression[?Yield]
	         */
	        function isUpdateExpression() {
	            // This function is called inside parseUnaryExpression to decide
	            // whether to call parseSimpleUnaryExpression or call parseUpdateExpression directly
	            switch (token()) {
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                case 52 /* TildeToken */:
	                case 51 /* ExclamationToken */:
	                case 80 /* DeleteKeyword */:
	                case 103 /* TypeOfKeyword */:
	                case 105 /* VoidKeyword */:
	                case 121 /* AwaitKeyword */:
	                    return false;
	                case 27 /* LessThanToken */:
	                    // If we are not in JSX context, we are parsing TypeAssertion which is an UnaryExpression
	                    if (sourceFile.languageVariant !== 1 /* JSX */) {
	                        return false;
	                    }
	                // We are in JSX context and the token is part of JSXElement.
	                // falls through
	                default:
	                    return true;
	            }
	        }
	        /**
	         * Parse ES7 UpdateExpression. UpdateExpression is used instead of ES6's PostFixExpression.
	         *
	         * ES7 UpdateExpression[yield]:
	         *      1) LeftHandSideExpression[?yield]
	         *      2) LeftHandSideExpression[?yield] [[no LineTerminator here]]++
	         *      3) LeftHandSideExpression[?yield] [[no LineTerminator here]]--
	         *      4) ++LeftHandSideExpression[?yield]
	         *      5) --LeftHandSideExpression[?yield]
	         * In TypeScript (2), (3) are parsed as PostfixUnaryExpression. (4), (5) are parsed as PrefixUnaryExpression
	         */
	        function parseUpdateExpression() {
	            if (token() === 43 /* PlusPlusToken */ || token() === 44 /* MinusMinusToken */) {
	                var node = createNode(196 /* PrefixUnaryExpression */);
	                node.operator = token();
	                nextToken();
	                node.operand = parseLeftHandSideExpressionOrHigher();
	                return finishNode(node);
	            }
	            else if (sourceFile.languageVariant === 1 /* JSX */ && token() === 27 /* LessThanToken */ && lookAhead(nextTokenIsIdentifierOrKeywordOrGreaterThan)) {
	                // JSXElement is part of primaryExpression
	                return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true);
	            }
	            var expression = parseLeftHandSideExpressionOrHigher();
	            ts.Debug.assert(ts.isLeftHandSideExpression(expression));
	            if ((token() === 43 /* PlusPlusToken */ || token() === 44 /* MinusMinusToken */) && !scanner.hasPrecedingLineBreak()) {
	                var node = createNode(197 /* PostfixUnaryExpression */, expression.pos);
	                node.operand = expression;
	                node.operator = token();
	                nextToken();
	                return finishNode(node);
	            }
	            return expression;
	        }
	        function parseLeftHandSideExpressionOrHigher() {
	            // Original Ecma:
	            // LeftHandSideExpression: See 11.2
	            //      NewExpression
	            //      CallExpression
	            //
	            // Our simplification:
	            //
	            // LeftHandSideExpression: See 11.2
	            //      MemberExpression
	            //      CallExpression
	            //
	            // See comment in parseMemberExpressionOrHigher on how we replaced NewExpression with
	            // MemberExpression to make our lives easier.
	            //
	            // to best understand the below code, it's important to see how CallExpression expands
	            // out into its own productions:
	            //
	            // CallExpression:
	            //      MemberExpression Arguments
	            //      CallExpression Arguments
	            //      CallExpression[Expression]
	            //      CallExpression.IdentifierName
	            //      import (AssignmentExpression)
	            //      super Arguments
	            //      super.IdentifierName
	            //
	            // Because of the recursion in these calls, we need to bottom out first. There are three
	            // bottom out states we can run into: 1) We see 'super' which must start either of
	            // the last two CallExpression productions. 2) We see 'import' which must start import call.
	            // 3)we have a MemberExpression which either completes the LeftHandSideExpression,
	            // or starts the beginning of the first four CallExpression productions.
	            var expression;
	            if (token() === 91 /* ImportKeyword */ && lookAhead(nextTokenIsOpenParenOrLessThan)) {
	                // We don't want to eagerly consume all import keyword as import call expression so we look a head to find "("
	                // For example:
	                //      var foo3 = require("subfolder
	                //      import * as foo1 from "module-from-node
	                // We want this import to be a statement rather than import call expression
	                sourceFile.flags |= 524288 /* PossiblyContainsDynamicImport */;
	                expression = parseTokenNode();
	            }
	            else {
	                expression = token() === 97 /* SuperKeyword */ ? parseSuperExpression() : parseMemberExpressionOrHigher();
	            }
	            // Now, we *may* be complete.  However, we might have consumed the start of a
	            // CallExpression.  As such, we need to consume the rest of it here to be complete.
	            return parseCallExpressionRest(expression);
	        }
	        function parseMemberExpressionOrHigher() {
	            // Note: to make our lives simpler, we decompose the NewExpression productions and
	            // place ObjectCreationExpression and FunctionExpression into PrimaryExpression.
	            // like so:
	            //
	            //   PrimaryExpression : See 11.1
	            //      this
	            //      Identifier
	            //      Literal
	            //      ArrayLiteral
	            //      ObjectLiteral
	            //      (Expression)
	            //      FunctionExpression
	            //      new MemberExpression Arguments?
	            //
	            //   MemberExpression : See 11.2
	            //      PrimaryExpression
	            //      MemberExpression[Expression]
	            //      MemberExpression.IdentifierName
	            //
	            //   CallExpression : See 11.2
	            //      MemberExpression
	            //      CallExpression Arguments
	            //      CallExpression[Expression]
	            //      CallExpression.IdentifierName
	            //
	            // Technically this is ambiguous.  i.e. CallExpression defines:
	            //
	            //   CallExpression:
	            //      CallExpression Arguments
	            //
	            // If you see: "new Foo()"
	            //
	            // Then that could be treated as a single ObjectCreationExpression, or it could be
	            // treated as the invocation of "new Foo".  We disambiguate that in code (to match
	            // the original grammar) by making sure that if we see an ObjectCreationExpression
	            // we always consume arguments if they are there. So we treat "new Foo()" as an
	            // object creation only, and not at all as an invocation.  Another way to think
	            // about this is that for every "new" that we see, we will consume an argument list if
	            // it is there as part of the *associated* object creation node.  Any additional
	            // argument lists we see, will become invocation expressions.
	            //
	            // Because there are no other places in the grammar now that refer to FunctionExpression
	            // or ObjectCreationExpression, it is safe to push down into the PrimaryExpression
	            // production.
	            //
	            // Because CallExpression and MemberExpression are left recursive, we need to bottom out
	            // of the recursion immediately.  So we parse out a primary expression to start with.
	            var expression = parsePrimaryExpression();
	            return parseMemberExpressionRest(expression);
	        }
	        function parseSuperExpression() {
	            var expression = parseTokenNode();
	            if (token() === 19 /* OpenParenToken */ || token() === 23 /* DotToken */ || token() === 21 /* OpenBracketToken */) {
	                return expression;
	            }
	            // If we have seen "super" it must be followed by '(' or '.'.
	            // If it wasn't then just try to parse out a '.' and report an error.
	            var node = createNode(183 /* PropertyAccessExpression */, expression.pos);
	            node.expression = expression;
	            parseExpectedToken(23 /* DotToken */, ts.Diagnostics.super_must_be_followed_by_an_argument_list_or_member_access);
	            node.name = parseRightSideOfDot(/*allowIdentifierNames*/ true);
	            return finishNode(node);
	        }
	        function tagNamesAreEquivalent(lhs, rhs) {
	            if (lhs.kind !== rhs.kind) {
	                return false;
	            }
	            if (lhs.kind === 71 /* Identifier */) {
	                return lhs.escapedText === rhs.escapedText;
	            }
	            if (lhs.kind === 99 /* ThisKeyword */) {
	                return true;
	            }
	            // If we are at this statement then we must have PropertyAccessExpression and because tag name in Jsx element can only
	            // take forms of JsxTagNameExpression which includes an identifier, "this" expression, or another propertyAccessExpression
	            // it is safe to case the expression property as such. See parseJsxElementName for how we parse tag name in Jsx element
	            return lhs.name.escapedText === rhs.name.escapedText &&
	                tagNamesAreEquivalent(lhs.expression, rhs.expression);
	        }
	        function parseJsxElementOrSelfClosingElementOrFragment(inExpressionContext) {
	            var opening = parseJsxOpeningOrSelfClosingElementOrOpeningFragment(inExpressionContext);
	            var result;
	            if (opening.kind === 255 /* JsxOpeningElement */) {
	                var node = createNode(253 /* JsxElement */, opening.pos);
	                node.openingElement = opening;
	                node.children = parseJsxChildren(node.openingElement);
	                node.closingElement = parseJsxClosingElement(inExpressionContext);
	                if (!tagNamesAreEquivalent(node.openingElement.tagName, node.closingElement.tagName)) {
	                    parseErrorAtPosition(node.closingElement.pos, node.closingElement.end - node.closingElement.pos, ts.Diagnostics.Expected_corresponding_JSX_closing_tag_for_0, ts.getTextOfNodeFromSourceText(sourceText, node.openingElement.tagName));
	                }
	                result = finishNode(node);
	            }
	            else if (opening.kind === 258 /* JsxOpeningFragment */) {
	                var node = createNode(257 /* JsxFragment */, opening.pos);
	                node.openingFragment = opening;
	                node.children = parseJsxChildren(node.openingFragment);
	                node.closingFragment = parseJsxClosingFragment(inExpressionContext);
	                result = finishNode(node);
	            }
	            else {
	                ts.Debug.assert(opening.kind === 254 /* JsxSelfClosingElement */);
	                // Nothing else to do for self-closing elements
	                result = opening;
	            }
	            // If the user writes the invalid code '<div></div><div></div>' in an expression context (i.e. not wrapped in
	            // an enclosing tag), we'll naively try to parse   ^ this as a 'less than' operator and the remainder of the tag
	            // as garbage, which will cause the formatter to badly mangle the JSX. Perform a speculative parse of a JSX
	            // element if we see a < token so that we can wrap it in a synthetic binary expression so the formatter
	            // does less damage and we can report a better error.
	            // Since JSX elements are invalid < operands anyway, this lookahead parse will only occur in error scenarios
	            // of one sort or another.
	            if (inExpressionContext && token() === 27 /* LessThanToken */) {
	                var invalidElement = tryParse(function () { return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true); });
	                if (invalidElement) {
	                    parseErrorAtCurrentToken(ts.Diagnostics.JSX_expressions_must_have_one_parent_element);
	                    var badNode = createNode(198 /* BinaryExpression */, result.pos);
	                    badNode.end = invalidElement.end;
	                    badNode.left = result;
	                    badNode.right = invalidElement;
	                    badNode.operatorToken = createMissingNode(26 /* CommaToken */, /*reportAtCurrentPosition*/ false, /*diagnosticMessage*/ undefined);
	                    badNode.operatorToken.pos = badNode.operatorToken.end = badNode.right.pos;
	                    return badNode;
	                }
	            }
	            return result;
	        }
	        function parseJsxText() {
	            var node = createNode(10 /* JsxText */);
	            node.containsOnlyWhiteSpaces = currentToken === 11 /* JsxTextAllWhiteSpaces */;
	            currentToken = scanner.scanJsxToken();
	            return finishNode(node);
	        }
	        function parseJsxChild() {
	            switch (token()) {
	                case 10 /* JsxText */:
	                case 11 /* JsxTextAllWhiteSpaces */:
	                    return parseJsxText();
	                case 17 /* OpenBraceToken */:
	                    return parseJsxExpression(/*inExpressionContext*/ false);
	                case 27 /* LessThanToken */:
	                    return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ false);
	            }
	            ts.Debug.fail("Unknown JSX child kind " + token());
	        }
	        function parseJsxChildren(openingTag) {
	            var list = [];
	            var listPos = getNodePos();
	            var saveParsingContext = parsingContext;
	            parsingContext |= 1 << 14 /* JsxChildren */;
	            while (true) {
	                currentToken = scanner.reScanJsxToken();
	                if (token() === 28 /* LessThanSlashToken */) {
	                    // Closing tag
	                    break;
	                }
	                else if (token() === 1 /* EndOfFileToken */) {
	                    // If we hit EOF, issue the error at the tag that lacks the closing element
	                    // rather than at the end of the file (which is useless)
	                    if (ts.isJsxOpeningFragment(openingTag)) {
	                        parseErrorAtPosition(openingTag.pos, openingTag.end - openingTag.pos, ts.Diagnostics.JSX_fragment_has_no_corresponding_closing_tag);
	                    }
	                    else {
	                        var openingTagName = openingTag.tagName;
	                        parseErrorAtPosition(openingTagName.pos, openingTagName.end - openingTagName.pos, ts.Diagnostics.JSX_element_0_has_no_corresponding_closing_tag, ts.getTextOfNodeFromSourceText(sourceText, openingTagName));
	                    }
	                    break;
	                }
	                else if (token() === 7 /* ConflictMarkerTrivia */) {
	                    break;
	                }
	                var child = parseJsxChild();
	                if (child) {
	                    list.push(child);
	                }
	            }
	            parsingContext = saveParsingContext;
	            return createNodeArray(list, listPos);
	        }
	        function parseJsxAttributes() {
	            var jsxAttributes = createNode(261 /* JsxAttributes */);
	            jsxAttributes.properties = parseList(13 /* JsxAttributes */, parseJsxAttribute);
	            return finishNode(jsxAttributes);
	        }
	        function parseJsxOpeningOrSelfClosingElementOrOpeningFragment(inExpressionContext) {
	            var fullStart = scanner.getStartPos();
	            parseExpected(27 /* LessThanToken */);
	            if (token() === 29 /* GreaterThanToken */) {
	                parseExpected(29 /* GreaterThanToken */);
	                var node_1 = createNode(258 /* JsxOpeningFragment */, fullStart);
	                return finishNode(node_1);
	            }
	            var tagName = parseJsxElementName();
	            var attributes = parseJsxAttributes();
	            var node;
	            if (token() === 29 /* GreaterThanToken */) {
	                // Closing tag, so scan the immediately-following text with the JSX scanning instead
	                // of regular scanning to avoid treating illegal characters (e.g. '#') as immediate
	                // scanning errors
	                node = createNode(255 /* JsxOpeningElement */, fullStart);
	                scanJsxText();
	            }
	            else {
	                parseExpected(41 /* SlashToken */);
	                if (inExpressionContext) {
	                    parseExpected(29 /* GreaterThanToken */);
	                }
	                else {
	                    parseExpected(29 /* GreaterThanToken */, /*diagnostic*/ undefined, /*shouldAdvance*/ false);
	                    scanJsxText();
	                }
	                node = createNode(254 /* JsxSelfClosingElement */, fullStart);
	            }
	            node.tagName = tagName;
	            node.attributes = attributes;
	            return finishNode(node);
	        }
	        function parseJsxElementName() {
	            scanJsxIdentifier();
	            // JsxElement can have name in the form of
	            //      propertyAccessExpression
	            //      primaryExpression in the form of an identifier and "this" keyword
	            // We can't just simply use parseLeftHandSideExpressionOrHigher because then we will start consider class,function etc as a keyword
	            // We only want to consider "this" as a primaryExpression
	            var expression = token() === 99 /* ThisKeyword */ ?
	                parseTokenNode() : parseIdentifierName();
	            while (parseOptional(23 /* DotToken */)) {
	                var propertyAccess = createNode(183 /* PropertyAccessExpression */, expression.pos);
	                propertyAccess.expression = expression;
	                propertyAccess.name = parseRightSideOfDot(/*allowIdentifierNames*/ true);
	                expression = finishNode(propertyAccess);
	            }
	            return expression;
	        }
	        function parseJsxExpression(inExpressionContext) {
	            var node = createNode(263 /* JsxExpression */);
	            parseExpected(17 /* OpenBraceToken */);
	            if (token() !== 18 /* CloseBraceToken */) {
	                node.dotDotDotToken = parseOptionalToken(24 /* DotDotDotToken */);
	                node.expression = parseAssignmentExpressionOrHigher();
	            }
	            if (inExpressionContext) {
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                parseExpected(18 /* CloseBraceToken */, /*message*/ undefined, /*shouldAdvance*/ false);
	                scanJsxText();
	            }
	            return finishNode(node);
	        }
	        function parseJsxAttribute() {
	            if (token() === 17 /* OpenBraceToken */) {
	                return parseJsxSpreadAttribute();
	            }
	            scanJsxIdentifier();
	            var node = createNode(260 /* JsxAttribute */);
	            node.name = parseIdentifierName();
	            if (token() === 58 /* EqualsToken */) {
	                switch (scanJsxAttributeValue()) {
	                    case 9 /* StringLiteral */:
	                        node.initializer = parseLiteralNode();
	                        break;
	                    default:
	                        node.initializer = parseJsxExpression(/*inExpressionContext*/ true);
	                        break;
	                }
	            }
	            return finishNode(node);
	        }
	        function parseJsxSpreadAttribute() {
	            var node = createNode(262 /* JsxSpreadAttribute */);
	            parseExpected(17 /* OpenBraceToken */);
	            parseExpected(24 /* DotDotDotToken */);
	            node.expression = parseExpression();
	            parseExpected(18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseJsxClosingElement(inExpressionContext) {
	            var node = createNode(256 /* JsxClosingElement */);
	            parseExpected(28 /* LessThanSlashToken */);
	            node.tagName = parseJsxElementName();
	            if (inExpressionContext) {
	                parseExpected(29 /* GreaterThanToken */);
	            }
	            else {
	                parseExpected(29 /* GreaterThanToken */, /*diagnostic*/ undefined, /*shouldAdvance*/ false);
	                scanJsxText();
	            }
	            return finishNode(node);
	        }
	        function parseJsxClosingFragment(inExpressionContext) {
	            var node = createNode(259 /* JsxClosingFragment */);
	            parseExpected(28 /* LessThanSlashToken */);
	            if (ts.tokenIsIdentifierOrKeyword(token())) {
	                var unexpectedTagName = parseJsxElementName();
	                parseErrorAtPosition(unexpectedTagName.pos, unexpectedTagName.end - unexpectedTagName.pos, ts.Diagnostics.Expected_corresponding_closing_tag_for_JSX_fragment);
	            }
	            if (inExpressionContext) {
	                parseExpected(29 /* GreaterThanToken */);
	            }
	            else {
	                parseExpected(29 /* GreaterThanToken */, /*diagnostic*/ undefined, /*shouldAdvance*/ false);
	                scanJsxText();
	            }
	            return finishNode(node);
	        }
	        function parseTypeAssertion() {
	            var node = createNode(188 /* TypeAssertionExpression */);
	            parseExpected(27 /* LessThanToken */);
	            node.type = parseType();
	            parseExpected(29 /* GreaterThanToken */);
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function parseMemberExpressionRest(expression) {
	            while (true) {
	                var dotToken = parseOptionalToken(23 /* DotToken */);
	                if (dotToken) {
	                    var propertyAccess = createNode(183 /* PropertyAccessExpression */, expression.pos);
	                    propertyAccess.expression = expression;
	                    propertyAccess.name = parseRightSideOfDot(/*allowIdentifierNames*/ true);
	                    expression = finishNode(propertyAccess);
	                    continue;
	                }
	                if (token() === 51 /* ExclamationToken */ && !scanner.hasPrecedingLineBreak()) {
	                    nextToken();
	                    var nonNullExpression = createNode(207 /* NonNullExpression */, expression.pos);
	                    nonNullExpression.expression = expression;
	                    expression = finishNode(nonNullExpression);
	                    continue;
	                }
	                // when in the [Decorator] context, we do not parse ElementAccess as it could be part of a ComputedPropertyName
	                if (!inDecoratorContext() && parseOptional(21 /* OpenBracketToken */)) {
	                    var indexedAccess = createNode(184 /* ElementAccessExpression */, expression.pos);
	                    indexedAccess.expression = expression;
	                    // It's not uncommon for a user to write: "new Type[]".
	                    // Check for that common pattern and report a better error message.
	                    if (token() !== 22 /* CloseBracketToken */) {
	                        indexedAccess.argumentExpression = allowInAnd(parseExpression);
	                        if (indexedAccess.argumentExpression.kind === 9 /* StringLiteral */ || indexedAccess.argumentExpression.kind === 8 /* NumericLiteral */) {
	                            var literal = indexedAccess.argumentExpression;
	                            literal.text = internIdentifier(literal.text);
	                        }
	                    }
	                    parseExpected(22 /* CloseBracketToken */);
	                    expression = finishNode(indexedAccess);
	                    continue;
	                }
	                if (token() === 13 /* NoSubstitutionTemplateLiteral */ || token() === 14 /* TemplateHead */) {
	                    var tagExpression = createNode(187 /* TaggedTemplateExpression */, expression.pos);
	                    tagExpression.tag = expression;
	                    tagExpression.template = token() === 13 /* NoSubstitutionTemplateLiteral */
	                        ? parseLiteralNode()
	                        : parseTemplateExpression();
	                    expression = finishNode(tagExpression);
	                    continue;
	                }
	                return expression;
	            }
	        }
	        function parseCallExpressionRest(expression) {
	            while (true) {
	                expression = parseMemberExpressionRest(expression);
	                if (token() === 27 /* LessThanToken */) {
	                    // See if this is the start of a generic invocation.  If so, consume it and
	                    // keep checking for postfix expressions.  Otherwise, it's just a '<' that's
	                    // part of an arithmetic expression.  Break out so we consume it higher in the
	                    // stack.
	                    var typeArguments = tryParse(parseTypeArgumentsInExpression);
	                    if (!typeArguments) {
	                        return expression;
	                    }
	                    var callExpr = createNode(185 /* CallExpression */, expression.pos);
	                    callExpr.expression = expression;
	                    callExpr.typeArguments = typeArguments;
	                    callExpr.arguments = parseArgumentList();
	                    expression = finishNode(callExpr);
	                    continue;
	                }
	                else if (token() === 19 /* OpenParenToken */) {
	                    var callExpr = createNode(185 /* CallExpression */, expression.pos);
	                    callExpr.expression = expression;
	                    callExpr.arguments = parseArgumentList();
	                    expression = finishNode(callExpr);
	                    continue;
	                }
	                return expression;
	            }
	        }
	        function parseArgumentList() {
	            parseExpected(19 /* OpenParenToken */);
	            var result = parseDelimitedList(11 /* ArgumentExpressions */, parseArgumentExpression);
	            parseExpected(20 /* CloseParenToken */);
	            return result;
	        }
	        function parseTypeArgumentsInExpression() {
	            if (!parseOptional(27 /* LessThanToken */)) {
	                return undefined;
	            }
	            var typeArguments = parseDelimitedList(19 /* TypeArguments */, parseType);
	            if (!parseExpected(29 /* GreaterThanToken */)) {
	                // If it doesn't have the closing `>` then it's definitely not an type argument list.
	                return undefined;
	            }
	            // If we have a '<', then only parse this as a argument list if the type arguments
	            // are complete and we have an open paren.  if we don't, rewind and return nothing.
	            return typeArguments && canFollowTypeArgumentsInExpression()
	                ? typeArguments
	                : undefined;
	        }
	        function canFollowTypeArgumentsInExpression() {
	            switch (token()) {
	                case 19 /* OpenParenToken */: // foo<x>(
	                // this case are the only case where this token can legally follow a type argument
	                // list.  So we definitely want to treat this as a type arg list.
	                case 23 /* DotToken */: // foo<x>.
	                case 20 /* CloseParenToken */: // foo<x>)
	                case 22 /* CloseBracketToken */: // foo<x>]
	                case 56 /* ColonToken */: // foo<x>:
	                case 25 /* SemicolonToken */: // foo<x>;
	                case 55 /* QuestionToken */: // foo<x>?
	                case 32 /* EqualsEqualsToken */: // foo<x> ==
	                case 34 /* EqualsEqualsEqualsToken */: // foo<x> ===
	                case 33 /* ExclamationEqualsToken */: // foo<x> !=
	                case 35 /* ExclamationEqualsEqualsToken */: // foo<x> !==
	                case 53 /* AmpersandAmpersandToken */: // foo<x> &&
	                case 54 /* BarBarToken */: // foo<x> ||
	                case 50 /* CaretToken */: // foo<x> ^
	                case 48 /* AmpersandToken */: // foo<x> &
	                case 49 /* BarToken */: // foo<x> |
	                case 18 /* CloseBraceToken */: // foo<x> }
	                case 1 /* EndOfFileToken */:// foo<x>
	                    // these cases can't legally follow a type arg list.  However, they're not legal
	                    // expressions either.  The user is probably in the middle of a generic type. So
	                    // treat it as such.
	                    return true;
	                case 26 /* CommaToken */: // foo<x>,
	                case 17 /* OpenBraceToken */: // foo<x> {
	                // We don't want to treat these as type arguments.  Otherwise we'll parse this
	                // as an invocation expression.  Instead, we want to parse out the expression
	                // in isolation from the type arguments.
	                default:
	                    // Anything else treat as an expression.
	                    return false;
	            }
	        }
	        function parsePrimaryExpression() {
	            switch (token()) {
	                case 8 /* NumericLiteral */:
	                case 9 /* StringLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                    return parseLiteralNode();
	                case 99 /* ThisKeyword */:
	                case 97 /* SuperKeyword */:
	                case 95 /* NullKeyword */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                    return parseTokenNode();
	                case 19 /* OpenParenToken */:
	                    return parseParenthesizedExpression();
	                case 21 /* OpenBracketToken */:
	                    return parseArrayLiteralExpression();
	                case 17 /* OpenBraceToken */:
	                    return parseObjectLiteralExpression();
	                case 120 /* AsyncKeyword */:
	                    // Async arrow functions are parsed earlier in parseAssignmentExpressionOrHigher.
	                    // If we encounter `async [no LineTerminator here] function` then this is an async
	                    // function; otherwise, its an identifier.
	                    if (!lookAhead(nextTokenIsFunctionKeywordOnSameLine)) {
	                        break;
	                    }
	                    return parseFunctionExpression();
	                case 75 /* ClassKeyword */:
	                    return parseClassExpression();
	                case 89 /* FunctionKeyword */:
	                    return parseFunctionExpression();
	                case 94 /* NewKeyword */:
	                    return parseNewExpression();
	                case 41 /* SlashToken */:
	                case 63 /* SlashEqualsToken */:
	                    if (reScanSlashToken() === 12 /* RegularExpressionLiteral */) {
	                        return parseLiteralNode();
	                    }
	                    break;
	                case 14 /* TemplateHead */:
	                    return parseTemplateExpression();
	            }
	            return parseIdentifier(ts.Diagnostics.Expression_expected);
	        }
	        function parseParenthesizedExpression() {
	            var node = createNodeWithJSDoc(189 /* ParenthesizedExpression */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            return finishNode(node);
	        }
	        function parseSpreadElement() {
	            var node = createNode(202 /* SpreadElement */);
	            parseExpected(24 /* DotDotDotToken */);
	            node.expression = parseAssignmentExpressionOrHigher();
	            return finishNode(node);
	        }
	        function parseArgumentOrArrayLiteralElement() {
	            return token() === 24 /* DotDotDotToken */ ? parseSpreadElement() :
	                token() === 26 /* CommaToken */ ? createNode(204 /* OmittedExpression */) :
	                    parseAssignmentExpressionOrHigher();
	        }
	        function parseArgumentExpression() {
	            return doOutsideOfContext(disallowInAndDecoratorContext, parseArgumentOrArrayLiteralElement);
	        }
	        function parseArrayLiteralExpression() {
	            var node = createNode(181 /* ArrayLiteralExpression */);
	            parseExpected(21 /* OpenBracketToken */);
	            if (scanner.hasPrecedingLineBreak()) {
	                node.multiLine = true;
	            }
	            node.elements = parseDelimitedList(15 /* ArrayLiteralMembers */, parseArgumentOrArrayLiteralElement);
	            parseExpected(22 /* CloseBracketToken */);
	            return finishNode(node);
	        }
	        function parseObjectLiteralElement() {
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            if (parseOptionalToken(24 /* DotDotDotToken */)) {
	                node.kind = 270 /* SpreadAssignment */;
	                node.expression = parseAssignmentExpressionOrHigher();
	                return finishNode(node);
	            }
	            node.decorators = parseDecorators();
	            node.modifiers = parseModifiers();
	            if (parseContextualModifier(125 /* GetKeyword */)) {
	                return parseAccessorDeclaration(node, 155 /* GetAccessor */);
	            }
	            if (parseContextualModifier(136 /* SetKeyword */)) {
	                return parseAccessorDeclaration(node, 156 /* SetAccessor */);
	            }
	            var asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	            var tokenIsIdentifier = isIdentifier();
	            node.name = parsePropertyName();
	            // Disallowing of optional property assignments happens in the grammar checker.
	            node.questionToken = parseOptionalToken(55 /* QuestionToken */);
	            if (asteriskToken || token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                return parseMethodDeclaration(node, asteriskToken);
	            }
	            // check if it is short-hand property assignment or normal property assignment
	            // NOTE: if token is EqualsToken it is interpreted as CoverInitializedName production
	            // CoverInitializedName[Yield] :
	            //     IdentifierReference[?Yield] Initializer[In, ?Yield]
	            // this is necessary because ObjectLiteral productions are also used to cover grammar for ObjectAssignmentPattern
	            var isShorthandPropertyAssignment = tokenIsIdentifier && (token() === 26 /* CommaToken */ || token() === 18 /* CloseBraceToken */ || token() === 58 /* EqualsToken */);
	            if (isShorthandPropertyAssignment) {
	                node.kind = 269 /* ShorthandPropertyAssignment */;
	                var equalsToken = parseOptionalToken(58 /* EqualsToken */);
	                if (equalsToken) {
	                    node.equalsToken = equalsToken;
	                    node.objectAssignmentInitializer = allowInAnd(parseAssignmentExpressionOrHigher);
	                }
	            }
	            else {
	                node.kind = 268 /* PropertyAssignment */;
	                parseExpected(56 /* ColonToken */);
	                node.initializer = allowInAnd(parseAssignmentExpressionOrHigher);
	            }
	            return finishNode(node);
	        }
	        function parseObjectLiteralExpression() {
	            var node = createNode(182 /* ObjectLiteralExpression */);
	            parseExpected(17 /* OpenBraceToken */);
	            if (scanner.hasPrecedingLineBreak()) {
	                node.multiLine = true;
	            }
	            node.properties = parseDelimitedList(12 /* ObjectLiteralMembers */, parseObjectLiteralElement, /*considerSemicolonAsDelimiter*/ true);
	            parseExpected(18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseFunctionExpression() {
	            // GeneratorExpression:
	            //      function* BindingIdentifier [Yield][opt](FormalParameters[Yield]){ GeneratorBody }
	            //
	            // FunctionExpression:
	            //      function BindingIdentifier[opt](FormalParameters){ FunctionBody }
	            var saveDecoratorContext = inDecoratorContext();
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ false);
	            }
	            var node = createNodeWithJSDoc(190 /* FunctionExpression */);
	            node.modifiers = parseModifiers();
	            parseExpected(89 /* FunctionKeyword */);
	            node.asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	            var isGenerator = node.asteriskToken ? 1 /* Yield */ : 0 /* None */;
	            var isAsync = ts.hasModifier(node, 256 /* Async */) ? 2 /* Await */ : 0 /* None */;
	            node.name =
	                isGenerator && isAsync ? doInYieldAndAwaitContext(parseOptionalIdentifier) :
	                    isGenerator ? doInYieldContext(parseOptionalIdentifier) :
	                        isAsync ? doInAwaitContext(parseOptionalIdentifier) :
	                            parseOptionalIdentifier();
	            fillSignature(56 /* ColonToken */, isGenerator | isAsync, node);
	            node.body = parseFunctionBlock(isGenerator | isAsync);
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ true);
	            }
	            return finishNode(node);
	        }
	        function parseOptionalIdentifier() {
	            return isIdentifier() ? parseIdentifier() : undefined;
	        }
	        function parseNewExpression() {
	            var fullStart = scanner.getStartPos();
	            parseExpected(94 /* NewKeyword */);
	            if (parseOptional(23 /* DotToken */)) {
	                var node_2 = createNode(208 /* MetaProperty */, fullStart);
	                node_2.keywordToken = 94 /* NewKeyword */;
	                node_2.name = parseIdentifierName();
	                return finishNode(node_2);
	            }
	            var node = createNode(186 /* NewExpression */, fullStart);
	            node.expression = parseMemberExpressionOrHigher();
	            node.typeArguments = tryParse(parseTypeArgumentsInExpression);
	            if (node.typeArguments || token() === 19 /* OpenParenToken */) {
	                node.arguments = parseArgumentList();
	            }
	            return finishNode(node);
	        }
	        // STATEMENTS
	        function parseBlock(ignoreMissingOpenBrace, diagnosticMessage) {
	            var node = createNode(211 /* Block */);
	            if (parseExpected(17 /* OpenBraceToken */, diagnosticMessage) || ignoreMissingOpenBrace) {
	                if (scanner.hasPrecedingLineBreak()) {
	                    node.multiLine = true;
	                }
	                node.statements = parseList(1 /* BlockStatements */, parseStatement);
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                node.statements = createMissingList();
	            }
	            return finishNode(node);
	        }
	        function parseFunctionBlock(flags, diagnosticMessage) {
	            var savedYieldContext = inYieldContext();
	            setYieldContext(!!(flags & 1 /* Yield */));
	            var savedAwaitContext = inAwaitContext();
	            setAwaitContext(!!(flags & 2 /* Await */));
	            // We may be in a [Decorator] context when parsing a function expression or
	            // arrow function. The body of the function is not in [Decorator] context.
	            var saveDecoratorContext = inDecoratorContext();
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ false);
	            }
	            var block = parseBlock(!!(flags & 16 /* IgnoreMissingOpenBrace */), diagnosticMessage);
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ true);
	            }
	            setYieldContext(savedYieldContext);
	            setAwaitContext(savedAwaitContext);
	            return block;
	        }
	        function parseEmptyStatement() {
	            var node = createNode(213 /* EmptyStatement */);
	            parseExpected(25 /* SemicolonToken */);
	            return finishNode(node);
	        }
	        function parseIfStatement() {
	            var node = createNode(215 /* IfStatement */);
	            parseExpected(90 /* IfKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            node.thenStatement = parseStatement();
	            node.elseStatement = parseOptional(82 /* ElseKeyword */) ? parseStatement() : undefined;
	            return finishNode(node);
	        }
	        function parseDoStatement() {
	            var node = createNode(216 /* DoStatement */);
	            parseExpected(81 /* DoKeyword */);
	            node.statement = parseStatement();
	            parseExpected(106 /* WhileKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            // From: https://mail.mozilla.org/pipermail/es-discuss/2011-August/016188.html
	            // 157 min --- All allen at wirfs-brock.com CONF --- "do{;}while(false)false" prohibited in
	            // spec but allowed in consensus reality. Approved -- this is the de-facto standard whereby
	            //  do;while(0)x will have a semicolon inserted before x.
	            parseOptional(25 /* SemicolonToken */);
	            return finishNode(node);
	        }
	        function parseWhileStatement() {
	            var node = createNode(217 /* WhileStatement */);
	            parseExpected(106 /* WhileKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            node.statement = parseStatement();
	            return finishNode(node);
	        }
	        function parseForOrForInOrForOfStatement() {
	            var pos = getNodePos();
	            parseExpected(88 /* ForKeyword */);
	            var awaitToken = parseOptionalToken(121 /* AwaitKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            var initializer = undefined;
	            if (token() !== 25 /* SemicolonToken */) {
	                if (token() === 104 /* VarKeyword */ || token() === 110 /* LetKeyword */ || token() === 76 /* ConstKeyword */) {
	                    initializer = parseVariableDeclarationList(/*inForStatementInitializer*/ true);
	                }
	                else {
	                    initializer = disallowInAnd(parseExpression);
	                }
	            }
	            var forOrForInOrForOfStatement;
	            if (awaitToken ? parseExpected(144 /* OfKeyword */) : parseOptional(144 /* OfKeyword */)) {
	                var forOfStatement = createNode(220 /* ForOfStatement */, pos);
	                forOfStatement.awaitModifier = awaitToken;
	                forOfStatement.initializer = initializer;
	                forOfStatement.expression = allowInAnd(parseAssignmentExpressionOrHigher);
	                parseExpected(20 /* CloseParenToken */);
	                forOrForInOrForOfStatement = forOfStatement;
	            }
	            else if (parseOptional(92 /* InKeyword */)) {
	                var forInStatement = createNode(219 /* ForInStatement */, pos);
	                forInStatement.initializer = initializer;
	                forInStatement.expression = allowInAnd(parseExpression);
	                parseExpected(20 /* CloseParenToken */);
	                forOrForInOrForOfStatement = forInStatement;
	            }
	            else {
	                var forStatement = createNode(218 /* ForStatement */, pos);
	                forStatement.initializer = initializer;
	                parseExpected(25 /* SemicolonToken */);
	                if (token() !== 25 /* SemicolonToken */ && token() !== 20 /* CloseParenToken */) {
	                    forStatement.condition = allowInAnd(parseExpression);
	                }
	                parseExpected(25 /* SemicolonToken */);
	                if (token() !== 20 /* CloseParenToken */) {
	                    forStatement.incrementor = allowInAnd(parseExpression);
	                }
	                parseExpected(20 /* CloseParenToken */);
	                forOrForInOrForOfStatement = forStatement;
	            }
	            forOrForInOrForOfStatement.statement = parseStatement();
	            return finishNode(forOrForInOrForOfStatement);
	        }
	        function parseBreakOrContinueStatement(kind) {
	            var node = createNode(kind);
	            parseExpected(kind === 222 /* BreakStatement */ ? 72 /* BreakKeyword */ : 77 /* ContinueKeyword */);
	            if (!canParseSemicolon()) {
	                node.label = parseIdentifier();
	            }
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseReturnStatement() {
	            var node = createNode(223 /* ReturnStatement */);
	            parseExpected(96 /* ReturnKeyword */);
	            if (!canParseSemicolon()) {
	                node.expression = allowInAnd(parseExpression);
	            }
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseWithStatement() {
	            var node = createNode(224 /* WithStatement */);
	            parseExpected(107 /* WithKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            node.statement = doInsideOfContext(4194304 /* InWithStatement */, parseStatement);
	            return finishNode(node);
	        }
	        function parseCaseClause() {
	            var node = createNode(264 /* CaseClause */);
	            parseExpected(73 /* CaseKeyword */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(56 /* ColonToken */);
	            node.statements = parseList(3 /* SwitchClauseStatements */, parseStatement);
	            return finishNode(node);
	        }
	        function parseDefaultClause() {
	            var node = createNode(265 /* DefaultClause */);
	            parseExpected(79 /* DefaultKeyword */);
	            parseExpected(56 /* ColonToken */);
	            node.statements = parseList(3 /* SwitchClauseStatements */, parseStatement);
	            return finishNode(node);
	        }
	        function parseCaseOrDefaultClause() {
	            return token() === 73 /* CaseKeyword */ ? parseCaseClause() : parseDefaultClause();
	        }
	        function parseSwitchStatement() {
	            var node = createNode(225 /* SwitchStatement */);
	            parseExpected(98 /* SwitchKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            var caseBlock = createNode(239 /* CaseBlock */);
	            parseExpected(17 /* OpenBraceToken */);
	            caseBlock.clauses = parseList(2 /* SwitchClauses */, parseCaseOrDefaultClause);
	            parseExpected(18 /* CloseBraceToken */);
	            node.caseBlock = finishNode(caseBlock);
	            return finishNode(node);
	        }
	        function parseThrowStatement() {
	            // ThrowStatement[Yield] :
	            //      throw [no LineTerminator here]Expression[In, ?Yield];
	            // Because of automatic semicolon insertion, we need to report error if this
	            // throw could be terminated with a semicolon.  Note: we can't call 'parseExpression'
	            // directly as that might consume an expression on the following line.
	            // We just return 'undefined' in that case.  The actual error will be reported in the
	            // grammar walker.
	            var node = createNode(227 /* ThrowStatement */);
	            parseExpected(100 /* ThrowKeyword */);
	            node.expression = scanner.hasPrecedingLineBreak() ? undefined : allowInAnd(parseExpression);
	            parseSemicolon();
	            return finishNode(node);
	        }
	        // TODO: Review for error recovery
	        function parseTryStatement() {
	            var node = createNode(228 /* TryStatement */);
	            parseExpected(102 /* TryKeyword */);
	            node.tryBlock = parseBlock(/*ignoreMissingOpenBrace*/ false);
	            node.catchClause = token() === 74 /* CatchKeyword */ ? parseCatchClause() : undefined;
	            // If we don't have a catch clause, then we must have a finally clause.  Try to parse
	            // one out no matter what.
	            if (!node.catchClause || token() === 87 /* FinallyKeyword */) {
	                parseExpected(87 /* FinallyKeyword */);
	                node.finallyBlock = parseBlock(/*ignoreMissingOpenBrace*/ false);
	            }
	            return finishNode(node);
	        }
	        function parseCatchClause() {
	            var result = createNode(267 /* CatchClause */);
	            parseExpected(74 /* CatchKeyword */);
	            if (parseOptional(19 /* OpenParenToken */)) {
	                result.variableDeclaration = parseVariableDeclaration();
	                parseExpected(20 /* CloseParenToken */);
	            }
	            else {
	                // Keep shape of node to avoid degrading performance.
	                result.variableDeclaration = undefined;
	            }
	            result.block = parseBlock(/*ignoreMissingOpenBrace*/ false);
	            return finishNode(result);
	        }
	        function parseDebuggerStatement() {
	            var node = createNode(229 /* DebuggerStatement */);
	            parseExpected(78 /* DebuggerKeyword */);
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseExpressionOrLabeledStatement() {
	            // Avoiding having to do the lookahead for a labeled statement by just trying to parse
	            // out an expression, seeing if it is identifier and then seeing if it is followed by
	            // a colon.
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            var expression = allowInAnd(parseExpression);
	            if (expression.kind === 71 /* Identifier */ && parseOptional(56 /* ColonToken */)) {
	                node.kind = 226 /* LabeledStatement */;
	                node.label = expression;
	                node.statement = parseStatement();
	            }
	            else {
	                node.kind = 214 /* ExpressionStatement */;
	                node.expression = expression;
	                parseSemicolon();
	            }
	            return finishNode(node);
	        }
	        function nextTokenIsIdentifierOrKeywordOnSameLine() {
	            nextToken();
	            return ts.tokenIsIdentifierOrKeyword(token()) && !scanner.hasPrecedingLineBreak();
	        }
	        function nextTokenIsClassKeywordOnSameLine() {
	            nextToken();
	            return token() === 75 /* ClassKeyword */ && !scanner.hasPrecedingLineBreak();
	        }
	        function nextTokenIsFunctionKeywordOnSameLine() {
	            nextToken();
	            return token() === 89 /* FunctionKeyword */ && !scanner.hasPrecedingLineBreak();
	        }
	        function nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine() {
	            nextToken();
	            return (ts.tokenIsIdentifierOrKeyword(token()) || token() === 8 /* NumericLiteral */ || token() === 9 /* StringLiteral */) && !scanner.hasPrecedingLineBreak();
	        }
	        function isDeclaration() {
	            while (true) {
	                switch (token()) {
	                    case 104 /* VarKeyword */:
	                    case 110 /* LetKeyword */:
	                    case 76 /* ConstKeyword */:
	                    case 89 /* FunctionKeyword */:
	                    case 75 /* ClassKeyword */:
	                    case 83 /* EnumKeyword */:
	                        return true;
	                    // 'declare', 'module', 'namespace', 'interface'* and 'type' are all legal JavaScript identifiers;
	                    // however, an identifier cannot be followed by another identifier on the same line. This is what we
	                    // count on to parse out the respective declarations. For instance, we exploit this to say that
	                    //
	                    //    namespace n
	                    //
	                    // can be none other than the beginning of a namespace declaration, but need to respect that JavaScript sees
	                    //
	                    //    namespace
	                    //    n
	                    //
	                    // as the identifier 'namespace' on one line followed by the identifier 'n' on another.
	                    // We need to look one token ahead to see if it permissible to try parsing a declaration.
	                    //
	                    // *Note*: 'interface' is actually a strict mode reserved word. So while
	                    //
	                    //   "use strict"
	                    //   interface
	                    //   I {}
	                    //
	                    // could be legal, it would add complexity for very little gain.
	                    case 109 /* InterfaceKeyword */:
	                    case 139 /* TypeKeyword */:
	                        return nextTokenIsIdentifierOnSameLine();
	                    case 129 /* ModuleKeyword */:
	                    case 130 /* NamespaceKeyword */:
	                        return nextTokenIsIdentifierOrStringLiteralOnSameLine();
	                    case 117 /* AbstractKeyword */:
	                    case 120 /* AsyncKeyword */:
	                    case 124 /* DeclareKeyword */:
	                    case 112 /* PrivateKeyword */:
	                    case 113 /* ProtectedKeyword */:
	                    case 114 /* PublicKeyword */:
	                    case 132 /* ReadonlyKeyword */:
	                        nextToken();
	                        // ASI takes effect for this modifier.
	                        if (scanner.hasPrecedingLineBreak()) {
	                            return false;
	                        }
	                        continue;
	                    case 143 /* GlobalKeyword */:
	                        nextToken();
	                        return token() === 17 /* OpenBraceToken */ || token() === 71 /* Identifier */ || token() === 84 /* ExportKeyword */;
	                    case 91 /* ImportKeyword */:
	                        nextToken();
	                        return token() === 9 /* StringLiteral */ || token() === 39 /* AsteriskToken */ ||
	                            token() === 17 /* OpenBraceToken */ || ts.tokenIsIdentifierOrKeyword(token());
	                    case 84 /* ExportKeyword */:
	                        nextToken();
	                        if (token() === 58 /* EqualsToken */ || token() === 39 /* AsteriskToken */ ||
	                            token() === 17 /* OpenBraceToken */ || token() === 79 /* DefaultKeyword */ ||
	                            token() === 118 /* AsKeyword */) {
	                            return true;
	                        }
	                        continue;
	                    case 115 /* StaticKeyword */:
	                        nextToken();
	                        continue;
	                    default:
	                        return false;
	                }
	            }
	        }
	        function isStartOfDeclaration() {
	            return lookAhead(isDeclaration);
	        }
	        function isStartOfStatement() {
	            switch (token()) {
	                case 57 /* AtToken */:
	                case 25 /* SemicolonToken */:
	                case 17 /* OpenBraceToken */:
	                case 104 /* VarKeyword */:
	                case 110 /* LetKeyword */:
	                case 89 /* FunctionKeyword */:
	                case 75 /* ClassKeyword */:
	                case 83 /* EnumKeyword */:
	                case 90 /* IfKeyword */:
	                case 81 /* DoKeyword */:
	                case 106 /* WhileKeyword */:
	                case 88 /* ForKeyword */:
	                case 77 /* ContinueKeyword */:
	                case 72 /* BreakKeyword */:
	                case 96 /* ReturnKeyword */:
	                case 107 /* WithKeyword */:
	                case 98 /* SwitchKeyword */:
	                case 100 /* ThrowKeyword */:
	                case 102 /* TryKeyword */:
	                case 78 /* DebuggerKeyword */:
	                // 'catch' and 'finally' do not actually indicate that the code is part of a statement,
	                // however, we say they are here so that we may gracefully parse them and error later.
	                case 74 /* CatchKeyword */:
	                case 87 /* FinallyKeyword */:
	                    return true;
	                case 91 /* ImportKeyword */:
	                    return isStartOfDeclaration() || lookAhead(nextTokenIsOpenParenOrLessThan);
	                case 76 /* ConstKeyword */:
	                case 84 /* ExportKeyword */:
	                    return isStartOfDeclaration();
	                case 120 /* AsyncKeyword */:
	                case 124 /* DeclareKeyword */:
	                case 109 /* InterfaceKeyword */:
	                case 129 /* ModuleKeyword */:
	                case 130 /* NamespaceKeyword */:
	                case 139 /* TypeKeyword */:
	                case 143 /* GlobalKeyword */:
	                    // When these don't start a declaration, they're an identifier in an expression statement
	                    return true;
	                case 114 /* PublicKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 115 /* StaticKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                    // When these don't start a declaration, they may be the start of a class member if an identifier
	                    // immediately follows. Otherwise they're an identifier in an expression statement.
	                    return isStartOfDeclaration() || !lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine);
	                default:
	                    return isStartOfExpression();
	            }
	        }
	        function nextTokenIsIdentifierOrStartOfDestructuring() {
	            nextToken();
	            return isIdentifier() || token() === 17 /* OpenBraceToken */ || token() === 21 /* OpenBracketToken */;
	        }
	        function isLetDeclaration() {
	            // In ES6 'let' always starts a lexical declaration if followed by an identifier or {
	            // or [.
	            return lookAhead(nextTokenIsIdentifierOrStartOfDestructuring);
	        }
	        function parseStatement() {
	            switch (token()) {
	                case 25 /* SemicolonToken */:
	                    return parseEmptyStatement();
	                case 17 /* OpenBraceToken */:
	                    return parseBlock(/*ignoreMissingOpenBrace*/ false);
	                case 104 /* VarKeyword */:
	                    return parseVariableStatement(createNodeWithJSDoc(230 /* VariableDeclaration */));
	                case 110 /* LetKeyword */:
	                    if (isLetDeclaration()) {
	                        return parseVariableStatement(createNodeWithJSDoc(230 /* VariableDeclaration */));
	                    }
	                    break;
	                case 89 /* FunctionKeyword */:
	                    return parseFunctionDeclaration(createNodeWithJSDoc(232 /* FunctionDeclaration */));
	                case 75 /* ClassKeyword */:
	                    return parseClassDeclaration(createNodeWithJSDoc(233 /* ClassDeclaration */));
	                case 90 /* IfKeyword */:
	                    return parseIfStatement();
	                case 81 /* DoKeyword */:
	                    return parseDoStatement();
	                case 106 /* WhileKeyword */:
	                    return parseWhileStatement();
	                case 88 /* ForKeyword */:
	                    return parseForOrForInOrForOfStatement();
	                case 77 /* ContinueKeyword */:
	                    return parseBreakOrContinueStatement(221 /* ContinueStatement */);
	                case 72 /* BreakKeyword */:
	                    return parseBreakOrContinueStatement(222 /* BreakStatement */);
	                case 96 /* ReturnKeyword */:
	                    return parseReturnStatement();
	                case 107 /* WithKeyword */:
	                    return parseWithStatement();
	                case 98 /* SwitchKeyword */:
	                    return parseSwitchStatement();
	                case 100 /* ThrowKeyword */:
	                    return parseThrowStatement();
	                case 102 /* TryKeyword */:
	                // Include 'catch' and 'finally' for error recovery.
	                case 74 /* CatchKeyword */:
	                case 87 /* FinallyKeyword */:
	                    return parseTryStatement();
	                case 78 /* DebuggerKeyword */:
	                    return parseDebuggerStatement();
	                case 57 /* AtToken */:
	                    return parseDeclaration();
	                case 120 /* AsyncKeyword */:
	                case 109 /* InterfaceKeyword */:
	                case 139 /* TypeKeyword */:
	                case 129 /* ModuleKeyword */:
	                case 130 /* NamespaceKeyword */:
	                case 124 /* DeclareKeyword */:
	                case 76 /* ConstKeyword */:
	                case 83 /* EnumKeyword */:
	                case 84 /* ExportKeyword */:
	                case 91 /* ImportKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 114 /* PublicKeyword */:
	                case 117 /* AbstractKeyword */:
	                case 115 /* StaticKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                case 143 /* GlobalKeyword */:
	                    if (isStartOfDeclaration()) {
	                        return parseDeclaration();
	                    }
	                    break;
	            }
	            return parseExpressionOrLabeledStatement();
	        }
	        function isDeclareModifier(modifier) {
	            return modifier.kind === 124 /* DeclareKeyword */;
	        }
	        function parseDeclaration() {
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            node.decorators = parseDecorators();
	            node.modifiers = parseModifiers();
	            if (ts.some(node.modifiers, isDeclareModifier)) {
	                for (var _i = 0, _a = node.modifiers; _i < _a.length; _i++) {
	                    var m = _a[_i];
	                    m.flags |= 2097152 /* Ambient */;
	                }
	                return doInsideOfContext(2097152 /* Ambient */, function () { return parseDeclarationWorker(node); });
	            }
	            else {
	                return parseDeclarationWorker(node);
	            }
	        }
	        function parseDeclarationWorker(node) {
	            switch (token()) {
	                case 104 /* VarKeyword */:
	                case 110 /* LetKeyword */:
	                case 76 /* ConstKeyword */:
	                    return parseVariableStatement(node);
	                case 89 /* FunctionKeyword */:
	                    return parseFunctionDeclaration(node);
	                case 75 /* ClassKeyword */:
	                    return parseClassDeclaration(node);
	                case 109 /* InterfaceKeyword */:
	                    return parseInterfaceDeclaration(node);
	                case 139 /* TypeKeyword */:
	                    return parseTypeAliasDeclaration(node);
	                case 83 /* EnumKeyword */:
	                    return parseEnumDeclaration(node);
	                case 143 /* GlobalKeyword */:
	                case 129 /* ModuleKeyword */:
	                case 130 /* NamespaceKeyword */:
	                    return parseModuleDeclaration(node);
	                case 91 /* ImportKeyword */:
	                    return parseImportDeclarationOrImportEqualsDeclaration(node);
	                case 84 /* ExportKeyword */:
	                    nextToken();
	                    switch (token()) {
	                        case 79 /* DefaultKeyword */:
	                        case 58 /* EqualsToken */:
	                            return parseExportAssignment(node);
	                        case 118 /* AsKeyword */:
	                            return parseNamespaceExportDeclaration(node);
	                        default:
	                            return parseExportDeclaration(node);
	                    }
	                default:
	                    if (node.decorators || node.modifiers) {
	                        // We reached this point because we encountered decorators and/or modifiers and assumed a declaration
	                        // would follow. For recovery and error reporting purposes, return an incomplete declaration.
	                        var missing = createMissingNode(251 /* MissingDeclaration */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.Declaration_expected);
	                        missing.pos = node.pos;
	                        missing.decorators = node.decorators;
	                        missing.modifiers = node.modifiers;
	                        return finishNode(missing);
	                    }
	            }
	        }
	        function nextTokenIsIdentifierOrStringLiteralOnSameLine() {
	            nextToken();
	            return !scanner.hasPrecedingLineBreak() && (isIdentifier() || token() === 9 /* StringLiteral */);
	        }
	        function parseFunctionBlockOrSemicolon(flags, diagnosticMessage) {
	            if (token() !== 17 /* OpenBraceToken */ && canParseSemicolon()) {
	                parseSemicolon();
	                return;
	            }
	            return parseFunctionBlock(flags, diagnosticMessage);
	        }
	        // DECLARATIONS
	        function parseArrayBindingElement() {
	            if (token() === 26 /* CommaToken */) {
	                return createNode(204 /* OmittedExpression */);
	            }
	            var node = createNode(180 /* BindingElement */);
	            node.dotDotDotToken = parseOptionalToken(24 /* DotDotDotToken */);
	            node.name = parseIdentifierOrPattern();
	            node.initializer = parseInitializer();
	            return finishNode(node);
	        }
	        function parseObjectBindingElement() {
	            var node = createNode(180 /* BindingElement */);
	            node.dotDotDotToken = parseOptionalToken(24 /* DotDotDotToken */);
	            var tokenIsIdentifier = isIdentifier();
	            var propertyName = parsePropertyName();
	            if (tokenIsIdentifier && token() !== 56 /* ColonToken */) {
	                node.name = propertyName;
	            }
	            else {
	                parseExpected(56 /* ColonToken */);
	                node.propertyName = propertyName;
	                node.name = parseIdentifierOrPattern();
	            }
	            node.initializer = parseInitializer();
	            return finishNode(node);
	        }
	        function parseObjectBindingPattern() {
	            var node = createNode(178 /* ObjectBindingPattern */);
	            parseExpected(17 /* OpenBraceToken */);
	            node.elements = parseDelimitedList(9 /* ObjectBindingElements */, parseObjectBindingElement);
	            parseExpected(18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseArrayBindingPattern() {
	            var node = createNode(179 /* ArrayBindingPattern */);
	            parseExpected(21 /* OpenBracketToken */);
	            node.elements = parseDelimitedList(10 /* ArrayBindingElements */, parseArrayBindingElement);
	            parseExpected(22 /* CloseBracketToken */);
	            return finishNode(node);
	        }
	        function isIdentifierOrPattern() {
	            return token() === 17 /* OpenBraceToken */ || token() === 21 /* OpenBracketToken */ || isIdentifier();
	        }
	        function parseIdentifierOrPattern() {
	            if (token() === 21 /* OpenBracketToken */) {
	                return parseArrayBindingPattern();
	            }
	            if (token() === 17 /* OpenBraceToken */) {
	                return parseObjectBindingPattern();
	            }
	            return parseIdentifier();
	        }
	        function parseVariableDeclarationAllowExclamation() {
	            return parseVariableDeclaration(/*allowExclamation*/ true);
	        }
	        function parseVariableDeclaration(allowExclamation) {
	            var node = createNode(230 /* VariableDeclaration */);
	            node.name = parseIdentifierOrPattern();
	            if (allowExclamation && node.name.kind === 71 /* Identifier */ &&
	                token() === 51 /* ExclamationToken */ && !scanner.hasPrecedingLineBreak()) {
	                node.exclamationToken = parseTokenNode();
	            }
	            node.type = parseTypeAnnotation();
	            if (!isInOrOfKeyword(token())) {
	                node.initializer = parseInitializer();
	            }
	            return finishNode(node);
	        }
	        function parseVariableDeclarationList(inForStatementInitializer) {
	            var node = createNode(231 /* VariableDeclarationList */);
	            switch (token()) {
	                case 104 /* VarKeyword */:
	                    break;
	                case 110 /* LetKeyword */:
	                    node.flags |= 1 /* Let */;
	                    break;
	                case 76 /* ConstKeyword */:
	                    node.flags |= 2 /* Const */;
	                    break;
	                default:
	                    ts.Debug.fail();
	            }
	            nextToken();
	            // The user may have written the following:
	            //
	            //    for (let of X) { }
	            //
	            // In this case, we want to parse an empty declaration list, and then parse 'of'
	            // as a keyword. The reason this is not automatic is that 'of' is a valid identifier.
	            // So we need to look ahead to determine if 'of' should be treated as a keyword in
	            // this context.
	            // The checker will then give an error that there is an empty declaration list.
	            if (token() === 144 /* OfKeyword */ && lookAhead(canFollowContextualOfKeyword)) {
	                node.declarations = createMissingList();
	            }
	            else {
	                var savedDisallowIn = inDisallowInContext();
	                setDisallowInContext(inForStatementInitializer);
	                node.declarations = parseDelimitedList(8 /* VariableDeclarations */, inForStatementInitializer ? parseVariableDeclaration : parseVariableDeclarationAllowExclamation);
	                setDisallowInContext(savedDisallowIn);
	            }
	            return finishNode(node);
	        }
	        function canFollowContextualOfKeyword() {
	            return nextTokenIsIdentifier() && nextToken() === 20 /* CloseParenToken */;
	        }
	        function parseVariableStatement(node) {
	            node.kind = 212 /* VariableStatement */;
	            node.declarationList = parseVariableDeclarationList(/*inForStatementInitializer*/ false);
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseFunctionDeclaration(node) {
	            node.kind = 232 /* FunctionDeclaration */;
	            parseExpected(89 /* FunctionKeyword */);
	            node.asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	            node.name = ts.hasModifier(node, 512 /* Default */) ? parseOptionalIdentifier() : parseIdentifier();
	            var isGenerator = node.asteriskToken ? 1 /* Yield */ : 0 /* None */;
	            var isAsync = ts.hasModifier(node, 256 /* Async */) ? 2 /* Await */ : 0 /* None */;
	            fillSignature(56 /* ColonToken */, isGenerator | isAsync, node);
	            node.body = parseFunctionBlockOrSemicolon(isGenerator | isAsync, ts.Diagnostics.or_expected);
	            return finishNode(node);
	        }
	        function parseConstructorDeclaration(node) {
	            node.kind = 154 /* Constructor */;
	            parseExpected(123 /* ConstructorKeyword */);
	            fillSignature(56 /* ColonToken */, 0 /* None */, node);
	            node.body = parseFunctionBlockOrSemicolon(0 /* None */, ts.Diagnostics.or_expected);
	            return finishNode(node);
	        }
	        function parseMethodDeclaration(node, asteriskToken, diagnosticMessage) {
	            node.kind = 153 /* MethodDeclaration */;
	            node.asteriskToken = asteriskToken;
	            var isGenerator = asteriskToken ? 1 /* Yield */ : 0 /* None */;
	            var isAsync = ts.hasModifier(node, 256 /* Async */) ? 2 /* Await */ : 0 /* None */;
	            fillSignature(56 /* ColonToken */, isGenerator | isAsync, node);
	            node.body = parseFunctionBlockOrSemicolon(isGenerator | isAsync, diagnosticMessage);
	            return finishNode(node);
	        }
	        function parsePropertyDeclaration(node) {
	            node.kind = 151 /* PropertyDeclaration */;
	            if (!node.questionToken && token() === 51 /* ExclamationToken */ && !scanner.hasPrecedingLineBreak()) {
	                node.exclamationToken = parseTokenNode();
	            }
	            node.type = parseTypeAnnotation();
	            // For instance properties specifically, since they are evaluated inside the constructor,
	            // we do *not * want to parse yield expressions, so we specifically turn the yield context
	            // off. The grammar would look something like this:
	            //
	            //    MemberVariableDeclaration[Yield]:
	            //        AccessibilityModifier_opt PropertyName TypeAnnotation_opt Initializer_opt[In];
	            //        AccessibilityModifier_opt static_opt PropertyName TypeAnnotation_opt Initializer_opt[In, ?Yield];
	            //
	            // The checker may still error in the static case to explicitly disallow the yield expression.
	            node.initializer = ts.hasModifier(node, 32 /* Static */)
	                ? allowInAnd(parseInitializer)
	                : doOutsideOfContext(4096 /* YieldContext */ | 2048 /* DisallowInContext */, parseInitializer);
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parsePropertyOrMethodDeclaration(node) {
	            var asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	            node.name = parsePropertyName();
	            // Note: this is not legal as per the grammar.  But we allow it in the parser and
	            // report an error in the grammar checker.
	            node.questionToken = parseOptionalToken(55 /* QuestionToken */);
	            if (asteriskToken || token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                return parseMethodDeclaration(node, asteriskToken, ts.Diagnostics.or_expected);
	            }
	            return parsePropertyDeclaration(node);
	        }
	        function parseAccessorDeclaration(node, kind) {
	            node.kind = kind;
	            node.name = parsePropertyName();
	            fillSignature(56 /* ColonToken */, 0 /* None */, node);
	            node.body = parseFunctionBlockOrSemicolon(0 /* None */);
	            return finishNode(node);
	        }
	        function isClassMemberModifier(idToken) {
	            switch (idToken) {
	                case 114 /* PublicKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 115 /* StaticKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function isClassMemberStart() {
	            var idToken;
	            if (token() === 57 /* AtToken */) {
	                return true;
	            }
	            // Eat up all modifiers, but hold on to the last one in case it is actually an identifier.
	            while (ts.isModifierKind(token())) {
	                idToken = token();
	                // If the idToken is a class modifier (protected, private, public, and static), it is
	                // certain that we are starting to parse class member. This allows better error recovery
	                // Example:
	                //      public foo() ...     // true
	                //      public @dec blah ... // true; we will then report an error later
	                //      export public ...    // true; we will then report an error later
	                if (isClassMemberModifier(idToken)) {
	                    return true;
	                }
	                nextToken();
	            }
	            if (token() === 39 /* AsteriskToken */) {
	                return true;
	            }
	            // Try to get the first property-like token following all modifiers.
	            // This can either be an identifier or the 'get' or 'set' keywords.
	            if (isLiteralPropertyName()) {
	                idToken = token();
	                nextToken();
	            }
	            // Index signatures and computed properties are class members; we can parse.
	            if (token() === 21 /* OpenBracketToken */) {
	                return true;
	            }
	            // If we were able to get any potential identifier...
	            if (idToken !== undefined) {
	                // If we have a non-keyword identifier, or if we have an accessor, then it's safe to parse.
	                if (!ts.isKeyword(idToken) || idToken === 136 /* SetKeyword */ || idToken === 125 /* GetKeyword */) {
	                    return true;
	                }
	                // If it *is* a keyword, but not an accessor, check a little farther along
	                // to see if it should actually be parsed as a class member.
	                switch (token()) {
	                    case 19 /* OpenParenToken */: // Method declaration
	                    case 27 /* LessThanToken */: // Generic Method declaration
	                    case 51 /* ExclamationToken */: // Non-null assertion on property name
	                    case 56 /* ColonToken */: // Type Annotation for declaration
	                    case 58 /* EqualsToken */: // Initializer for declaration
	                    case 55 /* QuestionToken */:// Not valid, but permitted so that it gets caught later on.
	                        return true;
	                    default:
	                        // Covers
	                        //  - Semicolons     (declaration termination)
	                        //  - Closing braces (end-of-class, must be declaration)
	                        //  - End-of-files   (not valid, but permitted so that it gets caught later on)
	                        //  - Line-breaks    (enabling *automatic semicolon insertion*)
	                        return canParseSemicolon();
	                }
	            }
	            return false;
	        }
	        function parseDecorators() {
	            var list;
	            var listPos = getNodePos();
	            while (true) {
	                var decoratorStart = getNodePos();
	                if (!parseOptional(57 /* AtToken */)) {
	                    break;
	                }
	                var decorator = createNode(149 /* Decorator */, decoratorStart);
	                decorator.expression = doInDecoratorContext(parseLeftHandSideExpressionOrHigher);
	                finishNode(decorator);
	                (list || (list = [])).push(decorator);
	            }
	            return list && createNodeArray(list, listPos);
	        }
	        /*
	         * There are situations in which a modifier like 'const' will appear unexpectedly, such as on a class member.
	         * In those situations, if we are entirely sure that 'const' is not valid on its own (such as when ASI takes effect
	         * and turns it into a standalone declaration), then it is better to parse it and report an error later.
	         *
	         * In such situations, 'permitInvalidConstAsModifier' should be set to true.
	         */
	        function parseModifiers(permitInvalidConstAsModifier) {
	            var list;
	            var listPos = getNodePos();
	            while (true) {
	                var modifierStart = scanner.getStartPos();
	                var modifierKind = token();
	                if (token() === 76 /* ConstKeyword */ && permitInvalidConstAsModifier) {
	                    // We need to ensure that any subsequent modifiers appear on the same line
	                    // so that when 'const' is a standalone declaration, we don't issue an error.
	                    if (!tryParse(nextTokenIsOnSameLineAndCanFollowModifier)) {
	                        break;
	                    }
	                }
	                else {
	                    if (!parseAnyContextualModifier()) {
	                        break;
	                    }
	                }
	                var modifier = finishNode(createNode(modifierKind, modifierStart));
	                (list || (list = [])).push(modifier);
	            }
	            return list && createNodeArray(list, listPos);
	        }
	        function parseModifiersForArrowFunction() {
	            var modifiers;
	            if (token() === 120 /* AsyncKeyword */) {
	                var modifierStart = scanner.getStartPos();
	                var modifierKind = token();
	                nextToken();
	                var modifier = finishNode(createNode(modifierKind, modifierStart));
	                modifiers = createNodeArray([modifier], modifierStart);
	            }
	            return modifiers;
	        }
	        function parseClassElement() {
	            if (token() === 25 /* SemicolonToken */) {
	                var result = createNode(210 /* SemicolonClassElement */);
	                nextToken();
	                return finishNode(result);
	            }
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            node.decorators = parseDecorators();
	            node.modifiers = parseModifiers(/*permitInvalidConstAsModifier*/ true);
	            if (parseContextualModifier(125 /* GetKeyword */)) {
	                return parseAccessorDeclaration(node, 155 /* GetAccessor */);
	            }
	            if (parseContextualModifier(136 /* SetKeyword */)) {
	                return parseAccessorDeclaration(node, 156 /* SetAccessor */);
	            }
	            if (token() === 123 /* ConstructorKeyword */) {
	                return parseConstructorDeclaration(node);
	            }
	            if (isIndexSignature()) {
	                return parseIndexSignatureDeclaration(node);
	            }
	            // It is very important that we check this *after* checking indexers because
	            // the [ token can start an index signature or a computed property name
	            if (ts.tokenIsIdentifierOrKeyword(token()) ||
	                token() === 9 /* StringLiteral */ ||
	                token() === 8 /* NumericLiteral */ ||
	                token() === 39 /* AsteriskToken */ ||
	                token() === 21 /* OpenBracketToken */) {
	                return parsePropertyOrMethodDeclaration(node);
	            }
	            if (node.decorators || node.modifiers) {
	                // treat this as a property declaration with a missing name.
	                node.name = createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.Declaration_expected);
	                return parsePropertyDeclaration(node);
	            }
	            // 'isClassMemberStart' should have hinted not to attempt parsing.
	            ts.Debug.fail("Should not have attempted to parse class member declaration.");
	        }
	        function parseClassExpression() {
	            return parseClassDeclarationOrExpression(createNodeWithJSDoc(0 /* Unknown */), 203 /* ClassExpression */);
	        }
	        function parseClassDeclaration(node) {
	            return parseClassDeclarationOrExpression(node, 233 /* ClassDeclaration */);
	        }
	        function parseClassDeclarationOrExpression(node, kind) {
	            node.kind = kind;
	            parseExpected(75 /* ClassKeyword */);
	            node.name = parseNameOfClassDeclarationOrExpression();
	            node.typeParameters = parseTypeParameters();
	            node.heritageClauses = parseHeritageClauses();
	            if (parseExpected(17 /* OpenBraceToken */)) {
	                // ClassTail[Yield,Await] : (Modified) See 14.5
	                //      ClassHeritage[?Yield,?Await]opt { ClassBody[?Yield,?Await]opt }
	                node.members = parseClassMembers();
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                node.members = createMissingList();
	            }
	            return finishNode(node);
	        }
	        function parseNameOfClassDeclarationOrExpression() {
	            // implements is a future reserved word so
	            // 'class implements' might mean either
	            // - class expression with omitted name, 'implements' starts heritage clause
	            // - class with name 'implements'
	            // 'isImplementsClause' helps to disambiguate between these two cases
	            return isIdentifier() && !isImplementsClause()
	                ? parseIdentifier()
	                : undefined;
	        }
	        function isImplementsClause() {
	            return token() === 108 /* ImplementsKeyword */ && lookAhead(nextTokenIsIdentifierOrKeyword);
	        }
	        function parseHeritageClauses() {
	            // ClassTail[Yield,Await] : (Modified) See 14.5
	            //      ClassHeritage[?Yield,?Await]opt { ClassBody[?Yield,?Await]opt }
	            if (isHeritageClause()) {
	                return parseList(21 /* HeritageClauses */, parseHeritageClause);
	            }
	            return undefined;
	        }
	        function parseHeritageClause() {
	            var tok = token();
	            if (tok === 85 /* ExtendsKeyword */ || tok === 108 /* ImplementsKeyword */) {
	                var node = createNode(266 /* HeritageClause */);
	                node.token = tok;
	                nextToken();
	                node.types = parseDelimitedList(7 /* HeritageClauseElement */, parseExpressionWithTypeArguments);
	                return finishNode(node);
	            }
	            return undefined;
	        }
	        function parseExpressionWithTypeArguments() {
	            var node = createNode(205 /* ExpressionWithTypeArguments */);
	            node.expression = parseLeftHandSideExpressionOrHigher();
	            node.typeArguments = tryParseTypeArguments();
	            return finishNode(node);
	        }
	        function tryParseTypeArguments() {
	            return token() === 27 /* LessThanToken */
	                ? parseBracketedList(19 /* TypeArguments */, parseType, 27 /* LessThanToken */, 29 /* GreaterThanToken */)
	                : undefined;
	        }
	        function isHeritageClause() {
	            return token() === 85 /* ExtendsKeyword */ || token() === 108 /* ImplementsKeyword */;
	        }
	        function parseClassMembers() {
	            return parseList(5 /* ClassMembers */, parseClassElement);
	        }
	        function parseInterfaceDeclaration(node) {
	            node.kind = 234 /* InterfaceDeclaration */;
	            parseExpected(109 /* InterfaceKeyword */);
	            node.name = parseIdentifier();
	            node.typeParameters = parseTypeParameters();
	            node.heritageClauses = parseHeritageClauses();
	            node.members = parseObjectTypeMembers();
	            return finishNode(node);
	        }
	        function parseTypeAliasDeclaration(node) {
	            node.kind = 235 /* TypeAliasDeclaration */;
	            parseExpected(139 /* TypeKeyword */);
	            node.name = parseIdentifier();
	            node.typeParameters = parseTypeParameters();
	            parseExpected(58 /* EqualsToken */);
	            node.type = parseType();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        // In an ambient declaration, the grammar only allows integer literals as initializers.
	        // In a non-ambient declaration, the grammar allows uninitialized members only in a
	        // ConstantEnumMemberSection, which starts at the beginning of an enum declaration
	        // or any time an integer literal initializer is encountered.
	        function parseEnumMember() {
	            var node = createNodeWithJSDoc(271 /* EnumMember */);
	            node.name = parsePropertyName();
	            node.initializer = allowInAnd(parseInitializer);
	            return finishNode(node);
	        }
	        function parseEnumDeclaration(node) {
	            node.kind = 236 /* EnumDeclaration */;
	            parseExpected(83 /* EnumKeyword */);
	            node.name = parseIdentifier();
	            if (parseExpected(17 /* OpenBraceToken */)) {
	                node.members = parseDelimitedList(6 /* EnumMembers */, parseEnumMember);
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                node.members = createMissingList();
	            }
	            return finishNode(node);
	        }
	        function parseModuleBlock() {
	            var node = createNode(238 /* ModuleBlock */);
	            if (parseExpected(17 /* OpenBraceToken */)) {
	                node.statements = parseList(1 /* BlockStatements */, parseStatement);
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                node.statements = createMissingList();
	            }
	            return finishNode(node);
	        }
	        function parseModuleOrNamespaceDeclaration(node, flags) {
	            node.kind = 237 /* ModuleDeclaration */;
	            // If we are parsing a dotted namespace name, we want to
	            // propagate the 'Namespace' flag across the names if set.
	            var namespaceFlag = flags & 16 /* Namespace */;
	            node.flags |= flags;
	            node.name = parseIdentifier();
	            node.body = parseOptional(23 /* DotToken */)
	                ? parseModuleOrNamespaceDeclaration(createNode(0 /* Unknown */), 4 /* NestedNamespace */ | namespaceFlag)
	                : parseModuleBlock();
	            return finishNode(node);
	        }
	        function parseAmbientExternalModuleDeclaration(node) {
	            node.kind = 237 /* ModuleDeclaration */;
	            if (token() === 143 /* GlobalKeyword */) {
	                // parse 'global' as name of global scope augmentation
	                node.name = parseIdentifier();
	                node.flags |= 512 /* GlobalAugmentation */;
	            }
	            else {
	                node.name = parseLiteralNode();
	                node.name.text = internIdentifier(node.name.text);
	            }
	            if (token() === 17 /* OpenBraceToken */) {
	                node.body = parseModuleBlock();
	            }
	            else {
	                parseSemicolon();
	            }
	            return finishNode(node);
	        }
	        function parseModuleDeclaration(node) {
	            var flags = 0;
	            if (token() === 143 /* GlobalKeyword */) {
	                // global augmentation
	                return parseAmbientExternalModuleDeclaration(node);
	            }
	            else if (parseOptional(130 /* NamespaceKeyword */)) {
	                flags |= 16 /* Namespace */;
	            }
	            else {
	                parseExpected(129 /* ModuleKeyword */);
	                if (token() === 9 /* StringLiteral */) {
	                    return parseAmbientExternalModuleDeclaration(node);
	                }
	            }
	            return parseModuleOrNamespaceDeclaration(node, flags);
	        }
	        function isExternalModuleReference() {
	            return token() === 133 /* RequireKeyword */ &&
	                lookAhead(nextTokenIsOpenParen);
	        }
	        function nextTokenIsOpenParen() {
	            return nextToken() === 19 /* OpenParenToken */;
	        }
	        function nextTokenIsSlash() {
	            return nextToken() === 41 /* SlashToken */;
	        }
	        function parseNamespaceExportDeclaration(node) {
	            node.kind = 240 /* NamespaceExportDeclaration */;
	            parseExpected(118 /* AsKeyword */);
	            parseExpected(130 /* NamespaceKeyword */);
	            node.name = parseIdentifier();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseImportDeclarationOrImportEqualsDeclaration(node) {
	            parseExpected(91 /* ImportKeyword */);
	            var afterImportPos = scanner.getStartPos();
	            var identifier;
	            if (isIdentifier()) {
	                identifier = parseIdentifier();
	                if (token() !== 26 /* CommaToken */ && token() !== 142 /* FromKeyword */) {
	                    return parseImportEqualsDeclaration(node, identifier);
	                }
	            }
	            // Import statement
	            node.kind = 242 /* ImportDeclaration */;
	            // ImportDeclaration:
	            //  import ImportClause from ModuleSpecifier ;
	            //  import ModuleSpecifier;
	            if (identifier || // import id
	                token() === 39 /* AsteriskToken */ || // import *
	                token() === 17 /* OpenBraceToken */) {
	                node.importClause = parseImportClause(identifier, afterImportPos);
	                parseExpected(142 /* FromKeyword */);
	            }
	            node.moduleSpecifier = parseModuleSpecifier();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseImportEqualsDeclaration(node, identifier) {
	            node.kind = 241 /* ImportEqualsDeclaration */;
	            node.name = identifier;
	            parseExpected(58 /* EqualsToken */);
	            node.moduleReference = parseModuleReference();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseImportClause(identifier, fullStart) {
	            // ImportClause:
	            //  ImportedDefaultBinding
	            //  NameSpaceImport
	            //  NamedImports
	            //  ImportedDefaultBinding, NameSpaceImport
	            //  ImportedDefaultBinding, NamedImports
	            var importClause = createNode(243 /* ImportClause */, fullStart);
	            if (identifier) {
	                // ImportedDefaultBinding:
	                //  ImportedBinding
	                importClause.name = identifier;
	            }
	            // If there was no default import or if there is comma token after default import
	            // parse namespace or named imports
	            if (!importClause.name ||
	                parseOptional(26 /* CommaToken */)) {
	                importClause.namedBindings = token() === 39 /* AsteriskToken */ ? parseNamespaceImport() : parseNamedImportsOrExports(245 /* NamedImports */);
	            }
	            return finishNode(importClause);
	        }
	        function parseModuleReference() {
	            return isExternalModuleReference()
	                ? parseExternalModuleReference()
	                : parseEntityName(/*allowReservedWords*/ false);
	        }
	        function parseExternalModuleReference() {
	            var node = createNode(252 /* ExternalModuleReference */);
	            parseExpected(133 /* RequireKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = parseModuleSpecifier();
	            parseExpected(20 /* CloseParenToken */);
	            return finishNode(node);
	        }
	        function parseModuleSpecifier() {
	            if (token() === 9 /* StringLiteral */) {
	                var result = parseLiteralNode();
	                result.text = internIdentifier(result.text);
	                return result;
	            }
	            else {
	                // We allow arbitrary expressions here, even though the grammar only allows string
	                // literals.  We check to ensure that it is only a string literal later in the grammar
	                // check pass.
	                return parseExpression();
	            }
	        }
	        function parseNamespaceImport() {
	            // NameSpaceImport:
	            //  * as ImportedBinding
	            var namespaceImport = createNode(244 /* NamespaceImport */);
	            parseExpected(39 /* AsteriskToken */);
	            parseExpected(118 /* AsKeyword */);
	            namespaceImport.name = parseIdentifier();
	            return finishNode(namespaceImport);
	        }
	        function parseNamedImportsOrExports(kind) {
	            var node = createNode(kind);
	            // NamedImports:
	            //  { }
	            //  { ImportsList }
	            //  { ImportsList, }
	            // ImportsList:
	            //  ImportSpecifier
	            //  ImportsList, ImportSpecifier
	            node.elements = parseBracketedList(22 /* ImportOrExportSpecifiers */, kind === 245 /* NamedImports */ ? parseImportSpecifier : parseExportSpecifier, 17 /* OpenBraceToken */, 18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseExportSpecifier() {
	            return parseImportOrExportSpecifier(250 /* ExportSpecifier */);
	        }
	        function parseImportSpecifier() {
	            return parseImportOrExportSpecifier(246 /* ImportSpecifier */);
	        }
	        function parseImportOrExportSpecifier(kind) {
	            var node = createNode(kind);
	            // ImportSpecifier:
	            //   BindingIdentifier
	            //   IdentifierName as BindingIdentifier
	            // ExportSpecifier:
	            //   IdentifierName
	            //   IdentifierName as IdentifierName
	            var checkIdentifierIsKeyword = ts.isKeyword(token()) && !isIdentifier();
	            var checkIdentifierStart = scanner.getTokenPos();
	            var checkIdentifierEnd = scanner.getTextPos();
	            var identifierName = parseIdentifierName();
	            if (token() === 118 /* AsKeyword */) {
	                node.propertyName = identifierName;
	                parseExpected(118 /* AsKeyword */);
	                checkIdentifierIsKeyword = ts.isKeyword(token()) && !isIdentifier();
	                checkIdentifierStart = scanner.getTokenPos();
	                checkIdentifierEnd = scanner.getTextPos();
	                node.name = parseIdentifierName();
	            }
	            else {
	                node.name = identifierName;
	            }
	            if (kind === 246 /* ImportSpecifier */ && checkIdentifierIsKeyword) {
	                // Report error identifier expected
	                parseErrorAtPosition(checkIdentifierStart, checkIdentifierEnd - checkIdentifierStart, ts.Diagnostics.Identifier_expected);
	            }
	            return finishNode(node);
	        }
	        function parseExportDeclaration(node) {
	            node.kind = 248 /* ExportDeclaration */;
	            if (parseOptional(39 /* AsteriskToken */)) {
	                parseExpected(142 /* FromKeyword */);
	                node.moduleSpecifier = parseModuleSpecifier();
	            }
	            else {
	                node.exportClause = parseNamedImportsOrExports(249 /* NamedExports */);
	                // It is not uncommon to accidentally omit the 'from' keyword. Additionally, in editing scenarios,
	                // the 'from' keyword can be parsed as a named export when the export clause is unterminated (i.e. `export { from "moduleName";`)
	                // If we don't have a 'from' keyword, see if we have a string literal such that ASI won't take effect.
	                if (token() === 142 /* FromKeyword */ || (token() === 9 /* StringLiteral */ && !scanner.hasPrecedingLineBreak())) {
	                    parseExpected(142 /* FromKeyword */);
	                    node.moduleSpecifier = parseModuleSpecifier();
	                }
	            }
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseExportAssignment(node) {
	            node.kind = 247 /* ExportAssignment */;
	            if (parseOptional(58 /* EqualsToken */)) {
	                node.isExportEquals = true;
	            }
	            else {
	                parseExpected(79 /* DefaultKeyword */);
	            }
	            node.expression = parseAssignmentExpressionOrHigher();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function processReferenceComments(sourceFile) {
	            var triviaScanner = ts.createScanner(sourceFile.languageVersion, /*skipTrivia*/ false, 0 /* Standard */, sourceText);
	            var referencedFiles = [];
	            var typeReferenceDirectives = [];
	            var amdDependencies = [];
	            var amdModuleName;
	            var checkJsDirective = undefined;
	            // Keep scanning all the leading trivia in the file until we get to something that
	            // isn't trivia.  Any single line comment will be analyzed to see if it is a
	            // reference comment.
	            while (true) {
	                var kind = triviaScanner.scan();
	                if (kind !== 2 /* SingleLineCommentTrivia */) {
	                    if (ts.isTrivia(kind)) {
	                        continue;
	                    }
	                    else {
	                        break;
	                    }
	                }
	                var range = {
	                    kind: triviaScanner.getToken(),
	                    pos: triviaScanner.getTokenPos(),
	                    end: triviaScanner.getTextPos(),
	                };
	                var comment = sourceText.substring(range.pos, range.end);
	                var referencePathMatchResult = ts.getFileReferenceFromReferencePath(comment, range);
	                if (referencePathMatchResult) {
	                    var fileReference = referencePathMatchResult.fileReference;
	                    sourceFile.hasNoDefaultLib = referencePathMatchResult.isNoDefaultLib;
	                    var diagnosticMessage = referencePathMatchResult.diagnosticMessage;
	                    if (fileReference) {
	                        if (referencePathMatchResult.isTypeReferenceDirective) {
	                            typeReferenceDirectives.push(fileReference);
	                        }
	                        else {
	                            referencedFiles.push(fileReference);
	                        }
	                    }
	                    if (diagnosticMessage) {
	                        parseDiagnostics.push(ts.createFileDiagnostic(sourceFile, range.pos, range.end - range.pos, diagnosticMessage));
	                    }
	                }
	                else {
	                    var amdModuleNameRegEx = /^\/\/\/\s*<amd-module\s+name\s*=\s*('|")(.+?)\1/gim;
	                    var amdModuleNameMatchResult = amdModuleNameRegEx.exec(comment);
	                    if (amdModuleNameMatchResult) {
	                        if (amdModuleName) {
	                            parseDiagnostics.push(ts.createFileDiagnostic(sourceFile, range.pos, range.end - range.pos, ts.Diagnostics.An_AMD_module_cannot_have_multiple_name_assignments));
	                        }
	                        amdModuleName = amdModuleNameMatchResult[2];
	                    }
	                    var amdDependencyRegEx = /^\/\/\/\s*<amd-dependency\s/gim;
	                    var pathRegex = /\spath\s*=\s*('|")(.+?)\1/gim;
	                    var nameRegex = /\sname\s*=\s*('|")(.+?)\1/gim;
	                    var amdDependencyMatchResult = amdDependencyRegEx.exec(comment);
	                    if (amdDependencyMatchResult) {
	                        var pathMatchResult = pathRegex.exec(comment);
	                        var nameMatchResult = nameRegex.exec(comment);
	                        if (pathMatchResult) {
	                            var amdDependency = { path: pathMatchResult[2], name: nameMatchResult ? nameMatchResult[2] : undefined };
	                            amdDependencies.push(amdDependency);
	                        }
	                    }
	                    var checkJsDirectiveRegEx = /^\/\/\/?\s*(@ts-check|@ts-nocheck)\s*$/gim;
	                    var checkJsDirectiveMatchResult = checkJsDirectiveRegEx.exec(comment);
	                    if (checkJsDirectiveMatchResult) {
	                        checkJsDirective = {
	                            enabled: ts.equateStringsCaseInsensitive(checkJsDirectiveMatchResult[1], "@ts-check"),
	                            end: range.end,
	                            pos: range.pos
	                        };
	                    }
	                }
	            }
	            sourceFile.referencedFiles = referencedFiles;
	            sourceFile.typeReferenceDirectives = typeReferenceDirectives;
	            sourceFile.amdDependencies = amdDependencies;
	            sourceFile.moduleName = amdModuleName;
	            sourceFile.checkJsDirective = checkJsDirective;
	        }
	        function setExternalModuleIndicator(sourceFile) {
	            sourceFile.externalModuleIndicator = ts.forEach(sourceFile.statements, function (node) {
	                return ts.hasModifier(node, 1 /* Export */)
	                    || node.kind === 241 /* ImportEqualsDeclaration */ && node.moduleReference.kind === 252 /* ExternalModuleReference */
	                    || node.kind === 242 /* ImportDeclaration */
	                    || node.kind === 247 /* ExportAssignment */
	                    || node.kind === 248 /* ExportDeclaration */
	                    ? node
	                    : undefined;
	            });
	        }
	        var ParsingContext;
	        (function (ParsingContext) {
	            ParsingContext[ParsingContext["SourceElements"] = 0] = "SourceElements";
	            ParsingContext[ParsingContext["BlockStatements"] = 1] = "BlockStatements";
	            ParsingContext[ParsingContext["SwitchClauses"] = 2] = "SwitchClauses";
	            ParsingContext[ParsingContext["SwitchClauseStatements"] = 3] = "SwitchClauseStatements";
	            ParsingContext[ParsingContext["TypeMembers"] = 4] = "TypeMembers";
	            ParsingContext[ParsingContext["ClassMembers"] = 5] = "ClassMembers";
	            ParsingContext[ParsingContext["EnumMembers"] = 6] = "EnumMembers";
	            ParsingContext[ParsingContext["HeritageClauseElement"] = 7] = "HeritageClauseElement";
	            ParsingContext[ParsingContext["VariableDeclarations"] = 8] = "VariableDeclarations";
	            ParsingContext[ParsingContext["ObjectBindingElements"] = 9] = "ObjectBindingElements";
	            ParsingContext[ParsingContext["ArrayBindingElements"] = 10] = "ArrayBindingElements";
	            ParsingContext[ParsingContext["ArgumentExpressions"] = 11] = "ArgumentExpressions";
	            ParsingContext[ParsingContext["ObjectLiteralMembers"] = 12] = "ObjectLiteralMembers";
	            ParsingContext[ParsingContext["JsxAttributes"] = 13] = "JsxAttributes";
	            ParsingContext[ParsingContext["JsxChildren"] = 14] = "JsxChildren";
	            ParsingContext[ParsingContext["ArrayLiteralMembers"] = 15] = "ArrayLiteralMembers";
	            ParsingContext[ParsingContext["Parameters"] = 16] = "Parameters";
	            ParsingContext[ParsingContext["RestProperties"] = 17] = "RestProperties";
	            ParsingContext[ParsingContext["TypeParameters"] = 18] = "TypeParameters";
	            ParsingContext[ParsingContext["TypeArguments"] = 19] = "TypeArguments";
	            ParsingContext[ParsingContext["TupleElementTypes"] = 20] = "TupleElementTypes";
	            ParsingContext[ParsingContext["HeritageClauses"] = 21] = "HeritageClauses";
	            ParsingContext[ParsingContext["ImportOrExportSpecifiers"] = 22] = "ImportOrExportSpecifiers";
	            ParsingContext[ParsingContext["Count"] = 23] = "Count"; // Number of parsing contexts
	        })(ParsingContext || (ParsingContext = {}));
	        var Tristate;
	        (function (Tristate) {
	            Tristate[Tristate["False"] = 0] = "False";
	            Tristate[Tristate["True"] = 1] = "True";
	            Tristate[Tristate["Unknown"] = 2] = "Unknown";
	        })(Tristate || (Tristate = {}));
	        var JSDocParser;
	        (function (JSDocParser) {
	            function parseJSDocTypeExpressionForTests(content, start, length) {
	                initializeState(content, 6 /* Latest */, /*_syntaxCursor:*/ undefined, 1 /* JS */);
	                sourceFile = createSourceFile("file.js", 6 /* Latest */, 1 /* JS */, /*isDeclarationFile*/ false);
	                scanner.setText(content, start, length);
	                currentToken = scanner.scan();
	                var jsDocTypeExpression = parseJSDocTypeExpression();
	                var diagnostics = parseDiagnostics;
	                clearState();
	                return jsDocTypeExpression ? { jsDocTypeExpression: jsDocTypeExpression, diagnostics: diagnostics } : undefined;
	            }
	            JSDocParser.parseJSDocTypeExpressionForTests = parseJSDocTypeExpressionForTests;
	            // Parses out a JSDoc type expression.
	            function parseJSDocTypeExpression(mayOmitBraces) {
	                var result = createNode(274 /* JSDocTypeExpression */, scanner.getTokenPos());
	                var hasBrace = (mayOmitBraces ? parseOptional : parseExpected)(17 /* OpenBraceToken */);
	                result.type = doInsideOfContext(1048576 /* JSDoc */, parseType);
	                if (!mayOmitBraces || hasBrace) {
	                    parseExpected(18 /* CloseBraceToken */);
	                }
	                fixupParentReferences(result);
	                return finishNode(result);
	            }
	            JSDocParser.parseJSDocTypeExpression = parseJSDocTypeExpression;
	            function parseIsolatedJSDocComment(content, start, length) {
	                initializeState(content, 6 /* Latest */, /*_syntaxCursor:*/ undefined, 1 /* JS */);
	                sourceFile = { languageVariant: 0 /* Standard */, text: content }; // tslint:disable-line no-object-literal-type-assertion
	                var jsDoc = parseJSDocCommentWorker(start, length);
	                var diagnostics = parseDiagnostics;
	                clearState();
	                return jsDoc ? { jsDoc: jsDoc, diagnostics: diagnostics } : undefined;
	            }
	            JSDocParser.parseIsolatedJSDocComment = parseIsolatedJSDocComment;
	            function parseJSDocComment(parent, start, length) {
	                var saveToken = currentToken;
	                var saveParseDiagnosticsLength = parseDiagnostics.length;
	                var saveParseErrorBeforeNextFinishedNode = parseErrorBeforeNextFinishedNode;
	                var comment = parseJSDocCommentWorker(start, length);
	                if (comment) {
	                    comment.parent = parent;
	                }
	                if (contextFlags & 65536 /* JavaScriptFile */) {
	                    if (!sourceFile.jsDocDiagnostics) {
	                        sourceFile.jsDocDiagnostics = [];
	                    }
	                    (_a = sourceFile.jsDocDiagnostics).push.apply(_a, parseDiagnostics);
	                }
	                currentToken = saveToken;
	                parseDiagnostics.length = saveParseDiagnosticsLength;
	                parseErrorBeforeNextFinishedNode = saveParseErrorBeforeNextFinishedNode;
	                return comment;
	                var _a;
	            }
	            JSDocParser.parseJSDocComment = parseJSDocComment;
	            var JSDocState;
	            (function (JSDocState) {
	                JSDocState[JSDocState["BeginningOfLine"] = 0] = "BeginningOfLine";
	                JSDocState[JSDocState["SawAsterisk"] = 1] = "SawAsterisk";
	                JSDocState[JSDocState["SavingComments"] = 2] = "SavingComments";
	            })(JSDocState || (JSDocState = {}));
	            var PropertyLikeParse;
	            (function (PropertyLikeParse) {
	                PropertyLikeParse[PropertyLikeParse["Property"] = 0] = "Property";
	                PropertyLikeParse[PropertyLikeParse["Parameter"] = 1] = "Parameter";
	            })(PropertyLikeParse || (PropertyLikeParse = {}));
	            function parseJSDocCommentWorker(start, length) {
	                var content = sourceText;
	                start = start || 0;
	                var end = length === undefined ? content.length : start + length;
	                length = end - start;
	                ts.Debug.assert(start >= 0);
	                ts.Debug.assert(start <= end);
	                ts.Debug.assert(end <= content.length);
	                var tags;
	                var tagsPos;
	                var tagsEnd;
	                var comments = [];
	                var result;
	                // Check for /** (JSDoc opening part)
	                if (!isJsDocStart(content, start)) {
	                    return result;
	                }
	                // + 3 for leading /**, - 5 in total for /** */
	                scanner.scanRange(start + 3, length - 5, function () {
	                    // Initially we can parse out a tag.  We also have seen a starting asterisk.
	                    // This is so that /** * @type */ doesn't parse.
	                    var state = 1 /* SawAsterisk */;
	                    var margin = undefined;
	                    // + 4 for leading '/** '
	                    var indent = start - Math.max(content.lastIndexOf("\n", start), 0) + 4;
	                    function pushComment(text) {
	                        if (!margin) {
	                            margin = indent;
	                        }
	                        comments.push(text);
	                        indent += text.length;
	                    }
	                    var t = nextJSDocToken();
	                    while (t === 5 /* WhitespaceTrivia */) {
	                        t = nextJSDocToken();
	                    }
	                    if (t === 4 /* NewLineTrivia */) {
	                        state = 0 /* BeginningOfLine */;
	                        indent = 0;
	                        t = nextJSDocToken();
	                    }
	                    loop: while (true) {
	                        switch (t) {
	                            case 57 /* AtToken */:
	                                if (state === 0 /* BeginningOfLine */ || state === 1 /* SawAsterisk */) {
	                                    removeTrailingNewlines(comments);
	                                    parseTag(indent);
	                                    // NOTE: According to usejsdoc.org, a tag goes to end of line, except the last tag.
	                                    // Real-world comments may break this rule, so "BeginningOfLine" will not be a real line beginning
	                                    // for malformed examples like `/** @param {string} x @returns {number} the length */`
	                                    state = 0 /* BeginningOfLine */;
	                                    margin = undefined;
	                                    indent++;
	                                }
	                                else {
	                                    pushComment(scanner.getTokenText());
	                                }
	                                break;
	                            case 4 /* NewLineTrivia */:
	                                comments.push(scanner.getTokenText());
	                                state = 0 /* BeginningOfLine */;
	                                indent = 0;
	                                break;
	                            case 39 /* AsteriskToken */:
	                                var asterisk = scanner.getTokenText();
	                                if (state === 1 /* SawAsterisk */ || state === 2 /* SavingComments */) {
	                                    // If we've already seen an asterisk, then we can no longer parse a tag on this line
	                                    state = 2 /* SavingComments */;
	                                    pushComment(asterisk);
	                                }
	                                else {
	                                    // Ignore the first asterisk on a line
	                                    state = 1 /* SawAsterisk */;
	                                    indent += asterisk.length;
	                                }
	                                break;
	                            case 71 /* Identifier */:
	                                // Anything else is doc comment text. We just save it. Because it
	                                // wasn't a tag, we can no longer parse a tag on this line until we hit the next
	                                // line break.
	                                pushComment(scanner.getTokenText());
	                                state = 2 /* SavingComments */;
	                                break;
	                            case 5 /* WhitespaceTrivia */:
	                                // only collect whitespace if we're already saving comments or have just crossed the comment indent margin
	                                var whitespace = scanner.getTokenText();
	                                if (state === 2 /* SavingComments */) {
	                                    comments.push(whitespace);
	                                }
	                                else if (margin !== undefined && indent + whitespace.length > margin) {
	                                    comments.push(whitespace.slice(margin - indent - 1));
	                                }
	                                indent += whitespace.length;
	                                break;
	                            case 1 /* EndOfFileToken */:
	                                break loop;
	                            default:
	                                // anything other than whitespace or asterisk at the beginning of the line starts the comment text
	                                state = 2 /* SavingComments */;
	                                pushComment(scanner.getTokenText());
	                                break;
	                        }
	                        t = nextJSDocToken();
	                    }
	                    removeLeadingNewlines(comments);
	                    removeTrailingNewlines(comments);
	                    result = createJSDocComment();
	                });
	                return result;
	                function removeLeadingNewlines(comments) {
	                    while (comments.length && (comments[0] === "\n" || comments[0] === "\r")) {
	                        comments.shift();
	                    }
	                }
	                function removeTrailingNewlines(comments) {
	                    while (comments.length && (comments[comments.length - 1] === "\n" || comments[comments.length - 1] === "\r")) {
	                        comments.pop();
	                    }
	                }
	                function isJsDocStart(content, start) {
	                    return content.charCodeAt(start) === 47 /* slash */ &&
	                        content.charCodeAt(start + 1) === 42 /* asterisk */ &&
	                        content.charCodeAt(start + 2) === 42 /* asterisk */ &&
	                        content.charCodeAt(start + 3) !== 42 /* asterisk */;
	                }
	                function createJSDocComment() {
	                    var result = createNode(282 /* JSDocComment */, start);
	                    result.tags = tags && createNodeArray(tags, tagsPos, tagsEnd);
	                    result.comment = comments.length ? comments.join("") : undefined;
	                    return finishNode(result, end);
	                }
	                function skipWhitespace() {
	                    while (token() === 5 /* WhitespaceTrivia */ || token() === 4 /* NewLineTrivia */) {
	                        nextJSDocToken();
	                    }
	                }
	                function parseTag(indent) {
	                    ts.Debug.assert(token() === 57 /* AtToken */);
	                    var atToken = createNode(57 /* AtToken */, scanner.getTokenPos());
	                    atToken.end = scanner.getTextPos();
	                    nextJSDocToken();
	                    var tagName = parseJSDocIdentifierName();
	                    skipWhitespace();
	                    if (!tagName) {
	                        return;
	                    }
	                    var tag;
	                    if (tagName) {
	                        switch (tagName.escapedText) {
	                            case "augments":
	                            case "extends":
	                                tag = parseAugmentsTag(atToken, tagName);
	                                break;
	                            case "class":
	                            case "constructor":
	                                tag = parseClassTag(atToken, tagName);
	                                break;
	                            case "arg":
	                            case "argument":
	                            case "param":
	                                tag = parseParameterOrPropertyTag(atToken, tagName, 1 /* Parameter */);
	                                break;
	                            case "return":
	                            case "returns":
	                                tag = parseReturnTag(atToken, tagName);
	                                break;
	                            case "template":
	                                tag = parseTemplateTag(atToken, tagName);
	                                break;
	                            case "type":
	                                tag = parseTypeTag(atToken, tagName);
	                                break;
	                            case "typedef":
	                                tag = parseTypedefTag(atToken, tagName);
	                                break;
	                            default:
	                                tag = parseUnknownTag(atToken, tagName);
	                                break;
	                        }
	                    }
	                    else {
	                        tag = parseUnknownTag(atToken, tagName);
	                    }
	                    if (!tag) {
	                        // a badly malformed tag should not be added to the list of tags
	                        return;
	                    }
	                    tag.comment = parseTagComments(indent + tag.end - tag.pos);
	                    addTag(tag);
	                }
	                function parseTagComments(indent) {
	                    var comments = [];
	                    var state = 0 /* BeginningOfLine */;
	                    var margin;
	                    function pushComment(text) {
	                        if (!margin) {
	                            margin = indent;
	                        }
	                        comments.push(text);
	                        indent += text.length;
	                    }
	                    var tok = token();
	                    loop: while (true) {
	                        switch (tok) {
	                            case 4 /* NewLineTrivia */:
	                                if (state >= 1 /* SawAsterisk */) {
	                                    state = 0 /* BeginningOfLine */;
	                                    comments.push(scanner.getTokenText());
	                                }
	                                indent = 0;
	                                break;
	                            case 57 /* AtToken */:
	                                scanner.setTextPos(scanner.getTextPos() - 1);
	                            // falls through
	                            case 1 /* EndOfFileToken */:
	                                // Done
	                                break loop;
	                            case 5 /* WhitespaceTrivia */:
	                                if (state === 2 /* SavingComments */) {
	                                    pushComment(scanner.getTokenText());
	                                }
	                                else {
	                                    var whitespace = scanner.getTokenText();
	                                    // if the whitespace crosses the margin, take only the whitespace that passes the margin
	                                    if (margin !== undefined && indent + whitespace.length > margin) {
	                                        comments.push(whitespace.slice(margin - indent - 1));
	                                    }
	                                    indent += whitespace.length;
	                                }
	                                break;
	                            case 39 /* AsteriskToken */:
	                                if (state === 0 /* BeginningOfLine */) {
	                                    // leading asterisks start recording on the *next* (non-whitespace) token
	                                    state = 1 /* SawAsterisk */;
	                                    indent += 1;
	                                    break;
	                                }
	                            // record the * as a comment
	                            // falls through
	                            default:
	                                state = 2 /* SavingComments */; // leading identifiers start recording as well
	                                pushComment(scanner.getTokenText());
	                                break;
	                        }
	                        tok = nextJSDocToken();
	                    }
	                    removeLeadingNewlines(comments);
	                    removeTrailingNewlines(comments);
	                    return comments.length === 0 ? undefined : comments.join("");
	                }
	                function parseUnknownTag(atToken, tagName) {
	                    var result = createNode(284 /* JSDocTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    return finishNode(result);
	                }
	                function addTag(tag) {
	                    if (!tags) {
	                        tags = [tag];
	                        tagsPos = tag.pos;
	                    }
	                    else {
	                        tags.push(tag);
	                    }
	                    tagsEnd = tag.end;
	                }
	                function tryParseTypeExpression() {
	                    skipWhitespace();
	                    return token() === 17 /* OpenBraceToken */ ? parseJSDocTypeExpression() : undefined;
	                }
	                function parseBracketNameInPropertyAndParamTag() {
	                    // Looking for something like '[foo]', 'foo', '[foo.bar]' or 'foo.bar'
	                    var isBracketed = parseOptional(21 /* OpenBracketToken */);
	                    var name = parseJSDocEntityName();
	                    if (isBracketed) {
	                        skipWhitespace();
	                        // May have an optional default, e.g. '[foo = 42]'
	                        if (parseOptionalToken(58 /* EqualsToken */)) {
	                            parseExpression();
	                        }
	                        parseExpected(22 /* CloseBracketToken */);
	                    }
	                    return { name: name, isBracketed: isBracketed };
	                }
	                function isObjectOrObjectArrayTypeReference(node) {
	                    switch (node.kind) {
	                        case 135 /* ObjectKeyword */:
	                            return true;
	                        case 166 /* ArrayType */:
	                            return isObjectOrObjectArrayTypeReference(node.elementType);
	                        default:
	                            return ts.isTypeReferenceNode(node) && ts.isIdentifier(node.typeName) && node.typeName.escapedText === "Object";
	                    }
	                }
	                function parseParameterOrPropertyTag(atToken, tagName, target) {
	                    var typeExpression = tryParseTypeExpression();
	                    var isNameFirst = !typeExpression;
	                    skipWhitespace();
	                    var _a = parseBracketNameInPropertyAndParamTag(), name = _a.name, isBracketed = _a.isBracketed;
	                    skipWhitespace();
	                    if (isNameFirst) {
	                        typeExpression = tryParseTypeExpression();
	                    }
	                    var result = target === 1 /* Parameter */ ?
	                        createNode(287 /* JSDocParameterTag */, atToken.pos) :
	                        createNode(292 /* JSDocPropertyTag */, atToken.pos);
	                    var nestedTypeLiteral = parseNestedTypeLiteral(typeExpression, name);
	                    if (nestedTypeLiteral) {
	                        typeExpression = nestedTypeLiteral;
	                        isNameFirst = true;
	                    }
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.typeExpression = typeExpression;
	                    result.name = name;
	                    result.isNameFirst = isNameFirst;
	                    result.isBracketed = isBracketed;
	                    return finishNode(result);
	                }
	                function parseNestedTypeLiteral(typeExpression, name) {
	                    if (typeExpression && isObjectOrObjectArrayTypeReference(typeExpression.type)) {
	                        var typeLiteralExpression = createNode(274 /* JSDocTypeExpression */, scanner.getTokenPos());
	                        var child = void 0;
	                        var jsdocTypeLiteral = void 0;
	                        var start_2 = scanner.getStartPos();
	                        var children = void 0;
	                        while (child = tryParse(function () { return parseChildParameterOrPropertyTag(1 /* Parameter */, name); })) {
	                            children = ts.append(children, child);
	                        }
	                        if (children) {
	                            jsdocTypeLiteral = createNode(283 /* JSDocTypeLiteral */, start_2);
	                            jsdocTypeLiteral.jsDocPropertyTags = children;
	                            if (typeExpression.type.kind === 166 /* ArrayType */) {
	                                jsdocTypeLiteral.isArrayType = true;
	                            }
	                            typeLiteralExpression.type = finishNode(jsdocTypeLiteral);
	                            return finishNode(typeLiteralExpression);
	                        }
	                    }
	                }
	                function parseReturnTag(atToken, tagName) {
	                    if (ts.forEach(tags, function (t) { return t.kind === 288 /* JSDocReturnTag */; })) {
	                        parseErrorAtPosition(tagName.pos, scanner.getTokenPos() - tagName.pos, ts.Diagnostics._0_tag_already_specified, tagName.escapedText);
	                    }
	                    var result = createNode(288 /* JSDocReturnTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.typeExpression = tryParseTypeExpression();
	                    return finishNode(result);
	                }
	                function parseTypeTag(atToken, tagName) {
	                    if (ts.forEach(tags, function (t) { return t.kind === 289 /* JSDocTypeTag */; })) {
	                        parseErrorAtPosition(tagName.pos, scanner.getTokenPos() - tagName.pos, ts.Diagnostics._0_tag_already_specified, tagName.escapedText);
	                    }
	                    var result = createNode(289 /* JSDocTypeTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ true);
	                    return finishNode(result);
	                }
	                function parseAugmentsTag(atToken, tagName) {
	                    var result = createNode(285 /* JSDocAugmentsTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.class = parseExpressionWithTypeArgumentsForAugments();
	                    return finishNode(result);
	                }
	                function parseExpressionWithTypeArgumentsForAugments() {
	                    var usedBrace = parseOptional(17 /* OpenBraceToken */);
	                    var node = createNode(205 /* ExpressionWithTypeArguments */);
	                    node.expression = parsePropertyAccessEntityNameExpression();
	                    node.typeArguments = tryParseTypeArguments();
	                    var res = finishNode(node);
	                    if (usedBrace) {
	                        parseExpected(18 /* CloseBraceToken */);
	                    }
	                    return res;
	                }
	                function parsePropertyAccessEntityNameExpression() {
	                    var node = parseJSDocIdentifierName(/*createIfMissing*/ true);
	                    while (parseOptional(23 /* DotToken */)) {
	                        var prop = createNode(183 /* PropertyAccessExpression */, node.pos);
	                        prop.expression = node;
	                        prop.name = parseJSDocIdentifierName();
	                        node = finishNode(prop);
	                    }
	                    return node;
	                }
	                function parseClassTag(atToken, tagName) {
	                    var tag = createNode(286 /* JSDocClassTag */, atToken.pos);
	                    tag.atToken = atToken;
	                    tag.tagName = tagName;
	                    return finishNode(tag);
	                }
	                function parseTypedefTag(atToken, tagName) {
	                    var typeExpression = tryParseTypeExpression();
	                    skipWhitespace();
	                    var typedefTag = createNode(291 /* JSDocTypedefTag */, atToken.pos);
	                    typedefTag.atToken = atToken;
	                    typedefTag.tagName = tagName;
	                    typedefTag.fullName = parseJSDocTypeNameWithNamespace(/*flags*/ 0);
	                    if (typedefTag.fullName) {
	                        var rightNode = typedefTag.fullName;
	                        while (true) {
	                            if (rightNode.kind === 71 /* Identifier */ || !rightNode.body) {
	                                // if node is identifier - use it as name
	                                // otherwise use name of the rightmost part that we were able to parse
	                                typedefTag.name = rightNode.kind === 71 /* Identifier */ ? rightNode : rightNode.name;
	                                break;
	                            }
	                            rightNode = rightNode.body;
	                        }
	                    }
	                    skipWhitespace();
	                    typedefTag.typeExpression = typeExpression;
	                    if (!typeExpression || isObjectOrObjectArrayTypeReference(typeExpression.type)) {
	                        var child = void 0;
	                        var jsdocTypeLiteral = void 0;
	                        var childTypeTag = void 0;
	                        var start_3 = scanner.getStartPos();
	                        while (child = tryParse(function () { return parseChildParameterOrPropertyTag(0 /* Property */); })) {
	                            if (!jsdocTypeLiteral) {
	                                jsdocTypeLiteral = createNode(283 /* JSDocTypeLiteral */, start_3);
	                            }
	                            if (child.kind === 289 /* JSDocTypeTag */) {
	                                if (childTypeTag) {
	                                    break;
	                                }
	                                else {
	                                    childTypeTag = child;
	                                }
	                            }
	                            else {
	                                jsdocTypeLiteral.jsDocPropertyTags = ts.append(jsdocTypeLiteral.jsDocPropertyTags, child);
	                            }
	                        }
	                        if (jsdocTypeLiteral) {
	                            if (typeExpression && typeExpression.type.kind === 166 /* ArrayType */) {
	                                jsdocTypeLiteral.isArrayType = true;
	                            }
	                            typedefTag.typeExpression = childTypeTag && childTypeTag.typeExpression && !isObjectOrObjectArrayTypeReference(childTypeTag.typeExpression.type) ?
	                                childTypeTag.typeExpression :
	                                finishNode(jsdocTypeLiteral);
	                        }
	                    }
	                    return finishNode(typedefTag);
	                    function parseJSDocTypeNameWithNamespace(flags) {
	                        var pos = scanner.getTokenPos();
	                        var typeNameOrNamespaceName = parseJSDocIdentifierName();
	                        if (typeNameOrNamespaceName && parseOptional(23 /* DotToken */)) {
	                            var jsDocNamespaceNode = createNode(237 /* ModuleDeclaration */, pos);
	                            jsDocNamespaceNode.flags |= flags;
	                            jsDocNamespaceNode.name = typeNameOrNamespaceName;
	                            jsDocNamespaceNode.body = parseJSDocTypeNameWithNamespace(4 /* NestedNamespace */);
	                            return finishNode(jsDocNamespaceNode);
	                        }
	                        if (typeNameOrNamespaceName && flags & 4 /* NestedNamespace */) {
	                            typeNameOrNamespaceName.isInJSDocNamespace = true;
	                        }
	                        return typeNameOrNamespaceName;
	                    }
	                }
	                function escapedTextsEqual(a, b) {
	                    while (!ts.isIdentifier(a) || !ts.isIdentifier(b)) {
	                        if (!ts.isIdentifier(a) && !ts.isIdentifier(b) && a.right.escapedText === b.right.escapedText) {
	                            a = a.left;
	                            b = b.left;
	                        }
	                        else {
	                            return false;
	                        }
	                    }
	                    return a.escapedText === b.escapedText;
	                }
	                function parseChildParameterOrPropertyTag(target, name) {
	                    var canParseTag = true;
	                    var seenAsterisk = false;
	                    while (true) {
	                        switch (nextJSDocToken()) {
	                            case 57 /* AtToken */:
	                                if (canParseTag) {
	                                    var child = tryParseChildTag(target);
	                                    if (child && child.kind === 287 /* JSDocParameterTag */ &&
	                                        (ts.isIdentifier(child.name) || !escapedTextsEqual(name, child.name.left))) {
	                                        return false;
	                                    }
	                                    return child;
	                                }
	                                seenAsterisk = false;
	                                break;
	                            case 4 /* NewLineTrivia */:
	                                canParseTag = true;
	                                seenAsterisk = false;
	                                break;
	                            case 39 /* AsteriskToken */:
	                                if (seenAsterisk) {
	                                    canParseTag = false;
	                                }
	                                seenAsterisk = true;
	                                break;
	                            case 71 /* Identifier */:
	                                canParseTag = false;
	                                break;
	                            case 1 /* EndOfFileToken */:
	                                return false;
	                        }
	                    }
	                }
	                function tryParseChildTag(target) {
	                    ts.Debug.assert(token() === 57 /* AtToken */);
	                    var atToken = createNode(57 /* AtToken */);
	                    atToken.end = scanner.getTextPos();
	                    nextJSDocToken();
	                    var tagName = parseJSDocIdentifierName();
	                    skipWhitespace();
	                    if (!tagName) {
	                        return false;
	                    }
	                    var t;
	                    switch (tagName.escapedText) {
	                        case "type":
	                            return target === 0 /* Property */ && parseTypeTag(atToken, tagName);
	                        case "prop":
	                        case "property":
	                            t = 0 /* Property */;
	                            break;
	                        case "arg":
	                        case "argument":
	                        case "param":
	                            t = 1 /* Parameter */;
	                            break;
	                        default:
	                            return false;
	                    }
	                    if (target !== t) {
	                        return false;
	                    }
	                    var tag = parseParameterOrPropertyTag(atToken, tagName, target);
	                    tag.comment = parseTagComments(tag.end - tag.pos);
	                    return tag;
	                }
	                function parseTemplateTag(atToken, tagName) {
	                    if (ts.some(tags, ts.isJSDocTemplateTag)) {
	                        parseErrorAtPosition(tagName.pos, scanner.getTokenPos() - tagName.pos, ts.Diagnostics._0_tag_already_specified, tagName.escapedText);
	                    }
	                    // Type parameter list looks like '@template T,U,V'
	                    var typeParameters = [];
	                    var typeParametersPos = getNodePos();
	                    while (true) {
	                        var typeParameter = createNode(147 /* TypeParameter */);
	                        var name = parseJSDocIdentifierNameWithOptionalBraces();
	                        skipWhitespace();
	                        if (!name) {
	                            parseErrorAtPosition(scanner.getStartPos(), 0, ts.Diagnostics.Identifier_expected);
	                            return undefined;
	                        }
	                        typeParameter.name = name;
	                        finishNode(typeParameter);
	                        typeParameters.push(typeParameter);
	                        if (token() === 26 /* CommaToken */) {
	                            nextJSDocToken();
	                            skipWhitespace();
	                        }
	                        else {
	                            break;
	                        }
	                    }
	                    var result = createNode(290 /* JSDocTemplateTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.typeParameters = createNodeArray(typeParameters, typeParametersPos);
	                    finishNode(result);
	                    return result;
	                }
	                function parseJSDocIdentifierNameWithOptionalBraces() {
	                    var parsedBrace = parseOptional(17 /* OpenBraceToken */);
	                    var res = parseJSDocIdentifierName();
	                    if (parsedBrace) {
	                        parseExpected(18 /* CloseBraceToken */);
	                    }
	                    return res;
	                }
	                function nextJSDocToken() {
	                    return currentToken = scanner.scanJSDocToken();
	                }
	                function parseJSDocEntityName() {
	                    var entity = parseJSDocIdentifierName(/*createIfMissing*/ true);
	                    if (parseOptional(21 /* OpenBracketToken */)) {
	                        parseExpected(22 /* CloseBracketToken */);
	                        // Note that y[] is accepted as an entity name, but the postfix brackets are not saved for checking.
	                        // Technically usejsdoc.org requires them for specifying a property of a type equivalent to Array<{ x: ...}>
	                        // but it's not worth it to enforce that restriction.
	                    }
	                    while (parseOptional(23 /* DotToken */)) {
	                        var name = parseJSDocIdentifierName(/*createIfMissing*/ true);
	                        if (parseOptional(21 /* OpenBracketToken */)) {
	                            parseExpected(22 /* CloseBracketToken */);
	                        }
	                        entity = createQualifiedName(entity, name);
	                    }
	                    return entity;
	                }
	                function parseJSDocIdentifierName(createIfMissing) {
	                    if (createIfMissing === void 0) { createIfMissing = false; }
	                    if (!ts.tokenIsIdentifierOrKeyword(token())) {
	                        if (createIfMissing) {
	                            return createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.Identifier_expected);
	                        }
	                        else {
	                            parseErrorAtCurrentToken(ts.Diagnostics.Identifier_expected);
	                            return undefined;
	                        }
	                    }
	                    var pos = scanner.getTokenPos();
	                    var end = scanner.getTextPos();
	                    var result = createNode(71 /* Identifier */, pos);
	                    result.escapedText = ts.escapeLeadingUnderscores(content.substring(pos, end));
	                    finishNode(result, end);
	                    nextJSDocToken();
	                    return result;
	                }
	            }
	            JSDocParser.parseJSDocCommentWorker = parseJSDocCommentWorker;
	        })(JSDocParser = Parser.JSDocParser || (Parser.JSDocParser = {}));
	    })(Parser || (Parser = {}));
	    var IncrementalParser;
	    (function (IncrementalParser) {
	        function updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks) {
	            aggressiveChecks = aggressiveChecks || ts.Debug.shouldAssert(2 /* Aggressive */);
	            checkChangeRange(sourceFile, newText, textChangeRange, aggressiveChecks);
	            if (ts.textChangeRangeIsUnchanged(textChangeRange)) {
	                // if the text didn't change, then we can just return our current source file as-is.
	                return sourceFile;
	            }
	            if (sourceFile.statements.length === 0) {
	                // If we don't have any statements in the current source file, then there's no real
	                // way to incrementally parse.  So just do a full parse instead.
	                return Parser.parseSourceFile(sourceFile.fileName, newText, sourceFile.languageVersion, /*syntaxCursor*/ undefined, /*setParentNodes*/ true, sourceFile.scriptKind);
	            }
	            // Make sure we're not trying to incrementally update a source file more than once.  Once
	            // we do an update the original source file is considered unusable from that point onwards.
	            //
	            // This is because we do incremental parsing in-place.  i.e. we take nodes from the old
	            // tree and give them new positions and parents.  From that point on, trusting the old
	            // tree at all is not possible as far too much of it may violate invariants.
	            var incrementalSourceFile = sourceFile;
	            ts.Debug.assert(!incrementalSourceFile.hasBeenIncrementallyParsed);
	            incrementalSourceFile.hasBeenIncrementallyParsed = true;
	            var oldText = sourceFile.text;
	            var syntaxCursor = createSyntaxCursor(sourceFile);
	            // Make the actual change larger so that we know to reparse anything whose lookahead
	            // might have intersected the change.
	            var changeRange = extendToAffectedRange(sourceFile, textChangeRange);
	            checkChangeRange(sourceFile, newText, changeRange, aggressiveChecks);
	            // Ensure that extending the affected range only moved the start of the change range
	            // earlier in the file.
	            ts.Debug.assert(changeRange.span.start <= textChangeRange.span.start);
	            ts.Debug.assert(ts.textSpanEnd(changeRange.span) === ts.textSpanEnd(textChangeRange.span));
	            ts.Debug.assert(ts.textSpanEnd(ts.textChangeRangeNewSpan(changeRange)) === ts.textSpanEnd(ts.textChangeRangeNewSpan(textChangeRange)));
	            // The is the amount the nodes after the edit range need to be adjusted.  It can be
	            // positive (if the edit added characters), negative (if the edit deleted characters)
	            // or zero (if this was a pure overwrite with nothing added/removed).
	            var delta = ts.textChangeRangeNewSpan(changeRange).length - changeRange.span.length;
	            // If we added or removed characters during the edit, then we need to go and adjust all
	            // the nodes after the edit.  Those nodes may move forward (if we inserted chars) or they
	            // may move backward (if we deleted chars).
	            //
	            // Doing this helps us out in two ways.  First, it means that any nodes/tokens we want
	            // to reuse are already at the appropriate position in the new text.  That way when we
	            // reuse them, we don't have to figure out if they need to be adjusted.  Second, it makes
	            // it very easy to determine if we can reuse a node.  If the node's position is at where
	            // we are in the text, then we can reuse it.  Otherwise we can't.  If the node's position
	            // is ahead of us, then we'll need to rescan tokens.  If the node's position is behind
	            // us, then we'll need to skip it or crumble it as appropriate
	            //
	            // We will also adjust the positions of nodes that intersect the change range as well.
	            // By doing this, we ensure that all the positions in the old tree are consistent, not
	            // just the positions of nodes entirely before/after the change range.  By being
	            // consistent, we can then easily map from positions to nodes in the old tree easily.
	            //
	            // Also, mark any syntax elements that intersect the changed span.  We know, up front,
	            // that we cannot reuse these elements.
	            updateTokenPositionsAndMarkElements(incrementalSourceFile, changeRange.span.start, ts.textSpanEnd(changeRange.span), ts.textSpanEnd(ts.textChangeRangeNewSpan(changeRange)), delta, oldText, newText, aggressiveChecks);
	            // Now that we've set up our internal incremental state just proceed and parse the
	            // source file in the normal fashion.  When possible the parser will retrieve and
	            // reuse nodes from the old tree.
	            //
	            // Note: passing in 'true' for setNodeParents is very important.  When incrementally
	            // parsing, we will be reusing nodes from the old tree, and placing it into new
	            // parents.  If we don't set the parents now, we'll end up with an observably
	            // inconsistent tree.  Setting the parents on the new tree should be very fast.  We
	            // will immediately bail out of walking any subtrees when we can see that their parents
	            // are already correct.
	            var result = Parser.parseSourceFile(sourceFile.fileName, newText, sourceFile.languageVersion, syntaxCursor, /*setParentNodes*/ true, sourceFile.scriptKind);
	            return result;
	        }
	        IncrementalParser.updateSourceFile = updateSourceFile;
	        function moveElementEntirelyPastChangeRange(element, isArray, delta, oldText, newText, aggressiveChecks) {
	            if (isArray) {
	                visitArray(element);
	            }
	            else {
	                visitNode(element);
	            }
	            return;
	            function visitNode(node) {
	                var text = "";
	                if (aggressiveChecks && shouldCheckNode(node)) {
	                    text = oldText.substring(node.pos, node.end);
	                }
	                // Ditch any existing LS children we may have created.  This way we can avoid
	                // moving them forward.
	                if (node._children) {
	                    node._children = undefined;
	                }
	                node.pos += delta;
	                node.end += delta;
	                if (aggressiveChecks && shouldCheckNode(node)) {
	                    ts.Debug.assert(text === newText.substring(node.pos, node.end));
	                }
	                forEachChild(node, visitNode, visitArray);
	                if (ts.hasJSDocNodes(node)) {
	                    for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                        var jsDocComment = _a[_i];
	                        forEachChild(jsDocComment, visitNode, visitArray);
	                    }
	                }
	                checkNodePositions(node, aggressiveChecks);
	            }
	            function visitArray(array) {
	                array._children = undefined;
	                array.pos += delta;
	                array.end += delta;
	                for (var _i = 0, array_8 = array; _i < array_8.length; _i++) {
	                    var node = array_8[_i];
	                    visitNode(node);
	                }
	            }
	        }
	        function shouldCheckNode(node) {
	            switch (node.kind) {
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                case 71 /* Identifier */:
	                    return true;
	            }
	            return false;
	        }
	        function adjustIntersectingElement(element, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta) {
	            ts.Debug.assert(element.end >= changeStart, "Adjusting an element that was entirely before the change range");
	            ts.Debug.assert(element.pos <= changeRangeOldEnd, "Adjusting an element that was entirely after the change range");
	            ts.Debug.assert(element.pos <= element.end);
	            // We have an element that intersects the change range in some way.  It may have its
	            // start, or its end (or both) in the changed range.  We want to adjust any part
	            // that intersects such that the final tree is in a consistent state.  i.e. all
	            // children have spans within the span of their parent, and all siblings are ordered
	            // properly.
	            // We may need to update both the 'pos' and the 'end' of the element.
	            // If the 'pos' is before the start of the change, then we don't need to touch it.
	            // If it isn't, then the 'pos' must be inside the change.  How we update it will
	            // depend if delta is positive or negative. If delta is positive then we have
	            // something like:
	            //
	            //  -------------------AAA-----------------
	            //  -------------------BBBCCCCCCC-----------------
	            //
	            // In this case, we consider any node that started in the change range to still be
	            // starting at the same position.
	            //
	            // however, if the delta is negative, then we instead have something like this:
	            //
	            //  -------------------XXXYYYYYYY-----------------
	            //  -------------------ZZZ-----------------
	            //
	            // In this case, any element that started in the 'X' range will keep its position.
	            // However any element that started after that will have their pos adjusted to be
	            // at the end of the new range.  i.e. any node that started in the 'Y' range will
	            // be adjusted to have their start at the end of the 'Z' range.
	            //
	            // The element will keep its position if possible.  Or Move backward to the new-end
	            // if it's in the 'Y' range.
	            element.pos = Math.min(element.pos, changeRangeNewEnd);
	            // If the 'end' is after the change range, then we always adjust it by the delta
	            // amount.  However, if the end is in the change range, then how we adjust it
	            // will depend on if delta is positive or negative.  If delta is positive then we
	            // have something like:
	            //
	            //  -------------------AAA-----------------
	            //  -------------------BBBCCCCCCC-----------------
	            //
	            // In this case, we consider any node that ended inside the change range to keep its
	            // end position.
	            //
	            // however, if the delta is negative, then we instead have something like this:
	            //
	            //  -------------------XXXYYYYYYY-----------------
	            //  -------------------ZZZ-----------------
	            //
	            // In this case, any element that ended in the 'X' range will keep its position.
	            // However any element that ended after that will have their pos adjusted to be
	            // at the end of the new range.  i.e. any node that ended in the 'Y' range will
	            // be adjusted to have their end at the end of the 'Z' range.
	            if (element.end >= changeRangeOldEnd) {
	                // Element ends after the change range.  Always adjust the end pos.
	                element.end += delta;
	            }
	            else {
	                // Element ends in the change range.  The element will keep its position if
	                // possible. Or Move backward to the new-end if it's in the 'Y' range.
	                element.end = Math.min(element.end, changeRangeNewEnd);
	            }
	            ts.Debug.assert(element.pos <= element.end);
	            if (element.parent) {
	                ts.Debug.assert(element.pos >= element.parent.pos);
	                ts.Debug.assert(element.end <= element.parent.end);
	            }
	        }
	        function checkNodePositions(node, aggressiveChecks) {
	            if (aggressiveChecks) {
	                var pos_2 = node.pos;
	                forEachChild(node, function (child) {
	                    ts.Debug.assert(child.pos >= pos_2);
	                    pos_2 = child.end;
	                });
	                ts.Debug.assert(pos_2 <= node.end);
	            }
	        }
	        function updateTokenPositionsAndMarkElements(sourceFile, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta, oldText, newText, aggressiveChecks) {
	            visitNode(sourceFile);
	            return;
	            function visitNode(child) {
	                ts.Debug.assert(child.pos <= child.end);
	                if (child.pos > changeRangeOldEnd) {
	                    // Node is entirely past the change range.  We need to move both its pos and
	                    // end, forward or backward appropriately.
	                    moveElementEntirelyPastChangeRange(child, /*isArray*/ false, delta, oldText, newText, aggressiveChecks);
	                    return;
	                }
	                // Check if the element intersects the change range.  If it does, then it is not
	                // reusable.  Also, we'll need to recurse to see what constituent portions we may
	                // be able to use.
	                var fullEnd = child.end;
	                if (fullEnd >= changeStart) {
	                    child.intersectsChange = true;
	                    child._children = undefined;
	                    // Adjust the pos or end (or both) of the intersecting element accordingly.
	                    adjustIntersectingElement(child, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta);
	                    forEachChild(child, visitNode, visitArray);
	                    checkNodePositions(child, aggressiveChecks);
	                    return;
	                }
	                // Otherwise, the node is entirely before the change range.  No need to do anything with it.
	                ts.Debug.assert(fullEnd < changeStart);
	            }
	            function visitArray(array) {
	                ts.Debug.assert(array.pos <= array.end);
	                if (array.pos > changeRangeOldEnd) {
	                    // Array is entirely after the change range.  We need to move it, and move any of
	                    // its children.
	                    moveElementEntirelyPastChangeRange(array, /*isArray*/ true, delta, oldText, newText, aggressiveChecks);
	                    return;
	                }
	                // Check if the element intersects the change range.  If it does, then it is not
	                // reusable.  Also, we'll need to recurse to see what constituent portions we may
	                // be able to use.
	                var fullEnd = array.end;
	                if (fullEnd >= changeStart) {
	                    array.intersectsChange = true;
	                    array._children = undefined;
	                    // Adjust the pos or end (or both) of the intersecting array accordingly.
	                    adjustIntersectingElement(array, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta);
	                    for (var _i = 0, array_9 = array; _i < array_9.length; _i++) {
	                        var node = array_9[_i];
	                        visitNode(node);
	                    }
	                    return;
	                }
	                // Otherwise, the array is entirely before the change range.  No need to do anything with it.
	                ts.Debug.assert(fullEnd < changeStart);
	            }
	        }
	        function extendToAffectedRange(sourceFile, changeRange) {
	            // Consider the following code:
	            //      void foo() { /; }
	            //
	            // If the text changes with an insertion of / just before the semicolon then we end up with:
	            //      void foo() { //; }
	            //
	            // If we were to just use the changeRange a is, then we would not rescan the { token
	            // (as it does not intersect the actual original change range).  Because an edit may
	            // change the token touching it, we actually need to look back *at least* one token so
	            // that the prior token sees that change.
	            var maxLookahead = 1;
	            var start = changeRange.span.start;
	            // the first iteration aligns us with the change start. subsequent iteration move us to
	            // the left by maxLookahead tokens.  We only need to do this as long as we're not at the
	            // start of the tree.
	            for (var i = 0; start > 0 && i <= maxLookahead; i++) {
	                var nearestNode = findNearestNodeStartingBeforeOrAtPosition(sourceFile, start);
	                ts.Debug.assert(nearestNode.pos <= start);
	                var position = nearestNode.pos;
	                start = Math.max(0, position - 1);
	            }
	            var finalSpan = ts.createTextSpanFromBounds(start, ts.textSpanEnd(changeRange.span));
	            var finalLength = changeRange.newLength + (changeRange.span.start - start);
	            return ts.createTextChangeRange(finalSpan, finalLength);
	        }
	        function findNearestNodeStartingBeforeOrAtPosition(sourceFile, position) {
	            var bestResult = sourceFile;
	            var lastNodeEntirelyBeforePosition;
	            forEachChild(sourceFile, visit);
	            if (lastNodeEntirelyBeforePosition) {
	                var lastChildOfLastEntireNodeBeforePosition = getLastChild(lastNodeEntirelyBeforePosition);
	                if (lastChildOfLastEntireNodeBeforePosition.pos > bestResult.pos) {
	                    bestResult = lastChildOfLastEntireNodeBeforePosition;
	                }
	            }
	            return bestResult;
	            function getLastChild(node) {
	                while (true) {
	                    var lastChild = getLastChildWorker(node);
	                    if (lastChild) {
	                        node = lastChild;
	                    }
	                    else {
	                        return node;
	                    }
	                }
	            }
	            function getLastChildWorker(node) {
	                var last = undefined;
	                forEachChild(node, function (child) {
	                    if (ts.nodeIsPresent(child)) {
	                        last = child;
	                    }
	                });
	                return last;
	            }
	            function visit(child) {
	                if (ts.nodeIsMissing(child)) {
	                    // Missing nodes are effectively invisible to us.  We never even consider them
	                    // When trying to find the nearest node before us.
	                    return;
	                }
	                // If the child intersects this position, then this node is currently the nearest
	                // node that starts before the position.
	                if (child.pos <= position) {
	                    if (child.pos >= bestResult.pos) {
	                        // This node starts before the position, and is closer to the position than
	                        // the previous best node we found.  It is now the new best node.
	                        bestResult = child;
	                    }
	                    // Now, the node may overlap the position, or it may end entirely before the
	                    // position.  If it overlaps with the position, then either it, or one of its
	                    // children must be the nearest node before the position.  So we can just
	                    // recurse into this child to see if we can find something better.
	                    if (position < child.end) {
	                        // The nearest node is either this child, or one of the children inside
	                        // of it.  We've already marked this child as the best so far.  Recurse
	                        // in case one of the children is better.
	                        forEachChild(child, visit);
	                        // Once we look at the children of this node, then there's no need to
	                        // continue any further.
	                        return true;
	                    }
	                    else {
	                        ts.Debug.assert(child.end <= position);
	                        // The child ends entirely before this position.  Say you have the following
	                        // (where $ is the position)
	                        //
	                        //      <complex expr 1> ? <complex expr 2> $ : <...> <...>
	                        //
	                        // We would want to find the nearest preceding node in "complex expr 2".
	                        // To support that, we keep track of this node, and once we're done searching
	                        // for a best node, we recurse down this node to see if we can find a good
	                        // result in it.
	                        //
	                        // This approach allows us to quickly skip over nodes that are entirely
	                        // before the position, while still allowing us to find any nodes in the
	                        // last one that might be what we want.
	                        lastNodeEntirelyBeforePosition = child;
	                    }
	                }
	                else {
	                    ts.Debug.assert(child.pos > position);
	                    // We're now at a node that is entirely past the position we're searching for.
	                    // This node (and all following nodes) could never contribute to the result,
	                    // so just skip them by returning 'true' here.
	                    return true;
	                }
	            }
	        }
	        function checkChangeRange(sourceFile, newText, textChangeRange, aggressiveChecks) {
	            var oldText = sourceFile.text;
	            if (textChangeRange) {
	                ts.Debug.assert((oldText.length - textChangeRange.span.length + textChangeRange.newLength) === newText.length);
	                if (aggressiveChecks || ts.Debug.shouldAssert(3 /* VeryAggressive */)) {
	                    var oldTextPrefix = oldText.substr(0, textChangeRange.span.start);
	                    var newTextPrefix = newText.substr(0, textChangeRange.span.start);
	                    ts.Debug.assert(oldTextPrefix === newTextPrefix);
	                    var oldTextSuffix = oldText.substring(ts.textSpanEnd(textChangeRange.span), oldText.length);
	                    var newTextSuffix = newText.substring(ts.textSpanEnd(ts.textChangeRangeNewSpan(textChangeRange)), newText.length);
	                    ts.Debug.assert(oldTextSuffix === newTextSuffix);
	                }
	            }
	        }
	        function createSyntaxCursor(sourceFile) {
	            var currentArray = sourceFile.statements;
	            var currentArrayIndex = 0;
	            ts.Debug.assert(currentArrayIndex < currentArray.length);
	            var current = currentArray[currentArrayIndex];
	            var lastQueriedPosition = -1 /* Value */;
	            return {
	                currentNode: function (position) {
	                    // Only compute the current node if the position is different than the last time
	                    // we were asked.  The parser commonly asks for the node at the same position
	                    // twice.  Once to know if can read an appropriate list element at a certain point,
	                    // and then to actually read and consume the node.
	                    if (position !== lastQueriedPosition) {
	                        // Much of the time the parser will need the very next node in the array that
	                        // we just returned a node from.So just simply check for that case and move
	                        // forward in the array instead of searching for the node again.
	                        if (current && current.end === position && currentArrayIndex < (currentArray.length - 1)) {
	                            currentArrayIndex++;
	                            current = currentArray[currentArrayIndex];
	                        }
	                        // If we don't have a node, or the node we have isn't in the right position,
	                        // then try to find a viable node at the position requested.
	                        if (!current || current.pos !== position) {
	                            findHighestListElementThatStartsAtPosition(position);
	                        }
	                    }
	                    // Cache this query so that we don't do any extra work if the parser calls back
	                    // into us.  Note: this is very common as the parser will make pairs of calls like
	                    // 'isListElement -> parseListElement'.  If we were unable to find a node when
	                    // called with 'isListElement', we don't want to redo the work when parseListElement
	                    // is called immediately after.
	                    lastQueriedPosition = position;
	                    // Either we don'd have a node, or we have a node at the position being asked for.
	                    ts.Debug.assert(!current || current.pos === position);
	                    return current;
	                }
	            };
	            // Finds the highest element in the tree we can find that starts at the provided position.
	            // The element must be a direct child of some node list in the tree.  This way after we
	            // return it, we can easily return its next sibling in the list.
	            function findHighestListElementThatStartsAtPosition(position) {
	                // Clear out any cached state about the last node we found.
	                currentArray = undefined;
	                currentArrayIndex = -1 /* Value */;
	                current = undefined;
	                // Recurse into the source file to find the highest node at this position.
	                forEachChild(sourceFile, visitNode, visitArray);
	                return;
	                function visitNode(node) {
	                    if (position >= node.pos && position < node.end) {
	                        // Position was within this node.  Keep searching deeper to find the node.
	                        forEachChild(node, visitNode, visitArray);
	                        // don't proceed any further in the search.
	                        return true;
	                    }
	                    // position wasn't in this node, have to keep searching.
	                    return false;
	                }
	                function visitArray(array) {
	                    if (position >= array.pos && position < array.end) {
	                        // position was in this array.  Search through this array to see if we find a
	                        // viable element.
	                        for (var i = 0; i < array.length; i++) {
	                            var child = array[i];
	                            if (child) {
	                                if (child.pos === position) {
	                                    // Found the right node.  We're done.
	                                    currentArray = array;
	                                    currentArrayIndex = i;
	                                    current = child;
	                                    return true;
	                                }
	                                else {
	                                    if (child.pos < position && position < child.end) {
	                                        // Position in somewhere within this child.  Search in it and
	                                        // stop searching in this array.
	                                        forEachChild(child, visitNode, visitArray);
	                                        return true;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                    // position wasn't in this array, have to keep searching.
	                    return false;
	                }
	            }
	        }
	        var InvalidPosition;
	        (function (InvalidPosition) {
	            InvalidPosition[InvalidPosition["Value"] = -1] = "Value";
	        })(InvalidPosition || (InvalidPosition = {}));
	    })(IncrementalParser || (IncrementalParser = {}));
	    function isDeclarationFileName(fileName) {
	        return ts.fileExtensionIs(fileName, ".d.ts" /* Dts */);
	    }
	})(ts || (ts = {}));
	/// <reference path="utilities.ts"/>
	/// <reference path="parser.ts"/>
	/* @internal */
	var ts;
	(function (ts) {
	    var ModuleInstanceState;
	    (function (ModuleInstanceState) {
	        ModuleInstanceState[ModuleInstanceState["NonInstantiated"] = 0] = "NonInstantiated";
	        ModuleInstanceState[ModuleInstanceState["Instantiated"] = 1] = "Instantiated";
	        ModuleInstanceState[ModuleInstanceState["ConstEnumOnly"] = 2] = "ConstEnumOnly";
	    })(ModuleInstanceState = ts.ModuleInstanceState || (ts.ModuleInstanceState = {}));
	    function getModuleInstanceState(node) {
	        return node.body ? getModuleInstanceStateWorker(node.body) : 1 /* Instantiated */;
	    }
	    ts.getModuleInstanceState = getModuleInstanceState;
	    function getModuleInstanceStateWorker(node) {
	        // A module is uninstantiated if it contains only
	        switch (node.kind) {
	            // 1. interface declarations, type alias declarations
	            case 234 /* InterfaceDeclaration */:
	            case 235 /* TypeAliasDeclaration */:
	                return 0 /* NonInstantiated */;
	            // 2. const enum declarations
	            case 236 /* EnumDeclaration */:
	                if (ts.isConst(node)) {
	                    return 2 /* ConstEnumOnly */;
	                }
	                break;
	            // 3. non-exported import declarations
	            case 242 /* ImportDeclaration */:
	            case 241 /* ImportEqualsDeclaration */:
	                if (!(ts.hasModifier(node, 1 /* Export */))) {
	                    return 0 /* NonInstantiated */;
	                }
	                break;
	            // 4. other uninstantiated module declarations.
	            case 238 /* ModuleBlock */: {
	                var state_1 = 0 /* NonInstantiated */;
	                ts.forEachChild(node, function (n) {
	                    var childState = getModuleInstanceStateWorker(n);
	                    switch (childState) {
	                        case 0 /* NonInstantiated */:
	                            // child is non-instantiated - continue searching
	                            return;
	                        case 2 /* ConstEnumOnly */:
	                            // child is const enum only - record state and continue searching
	                            state_1 = 2 /* ConstEnumOnly */;
	                            return;
	                        case 1 /* Instantiated */:
	                            // child is instantiated - record state and stop
	                            state_1 = 1 /* Instantiated */;
	                            return true;
	                        default:
	                            ts.Debug.assertNever(childState);
	                    }
	                });
	                return state_1;
	            }
	            case 237 /* ModuleDeclaration */:
	                return getModuleInstanceState(node);
	            case 71 /* Identifier */:
	                // Only jsdoc typedef definition can exist in jsdoc namespace, and it should
	                // be considered the same as type alias
	                if (node.isInJSDocNamespace) {
	                    return 0 /* NonInstantiated */;
	                }
	        }
	        return 1 /* Instantiated */;
	    }
	    var ContainerFlags;
	    (function (ContainerFlags) {
	        // The current node is not a container, and no container manipulation should happen before
	        // recursing into it.
	        ContainerFlags[ContainerFlags["None"] = 0] = "None";
	        // The current node is a container.  It should be set as the current container (and block-
	        // container) before recursing into it.  The current node does not have locals.  Examples:
	        //
	        //      Classes, ObjectLiterals, TypeLiterals, Interfaces...
	        ContainerFlags[ContainerFlags["IsContainer"] = 1] = "IsContainer";
	        // The current node is a block-scoped-container.  It should be set as the current block-
	        // container before recursing into it.  Examples:
	        //
	        //      Blocks (when not parented by functions), Catch clauses, For/For-in/For-of statements...
	        ContainerFlags[ContainerFlags["IsBlockScopedContainer"] = 2] = "IsBlockScopedContainer";
	        // The current node is the container of a control flow path. The current control flow should
	        // be saved and restored, and a new control flow initialized within the container.
	        ContainerFlags[ContainerFlags["IsControlFlowContainer"] = 4] = "IsControlFlowContainer";
	        ContainerFlags[ContainerFlags["IsFunctionLike"] = 8] = "IsFunctionLike";
	        ContainerFlags[ContainerFlags["IsFunctionExpression"] = 16] = "IsFunctionExpression";
	        ContainerFlags[ContainerFlags["HasLocals"] = 32] = "HasLocals";
	        ContainerFlags[ContainerFlags["IsInterface"] = 64] = "IsInterface";
	        ContainerFlags[ContainerFlags["IsObjectLiteralOrClassExpressionMethod"] = 128] = "IsObjectLiteralOrClassExpressionMethod";
	        ContainerFlags[ContainerFlags["IsInferenceContainer"] = 256] = "IsInferenceContainer";
	    })(ContainerFlags || (ContainerFlags = {}));
	    var binder = createBinder();
	    function bindSourceFile(file, options) {
	        ts.performance.mark("beforeBind");
	        binder(file, options);
	        ts.performance.mark("afterBind");
	        ts.performance.measure("Bind", "beforeBind", "afterBind");
	    }
	    ts.bindSourceFile = bindSourceFile;
	    function createBinder() {
	        var file;
	        var options;
	        var languageVersion;
	        var parent;
	        var container;
	        var blockScopeContainer;
	        var inferenceContainer;
	        var lastContainer;
	        var seenThisKeyword;
	        // state used by control flow analysis
	        var currentFlow;
	        var currentBreakTarget;
	        var currentContinueTarget;
	        var currentReturnTarget;
	        var currentTrueTarget;
	        var currentFalseTarget;
	        var preSwitchCaseFlow;
	        var activeLabels;
	        var hasExplicitReturn;
	        // state used for emit helpers
	        var emitFlags;
	        // If this file is an external module, then it is automatically in strict-mode according to
	        // ES6.  If it is not an external module, then we'll determine if it is in strict mode or
	        // not depending on if we see "use strict" in certain places or if we hit a class/namespace
	        // or if compiler options contain alwaysStrict.
	        var inStrictMode;
	        var symbolCount = 0;
	        var Symbol; // tslint:disable-line variable-name
	        var classifiableNames;
	        var unreachableFlow = { flags: 1 /* Unreachable */ };
	        var reportedUnreachableFlow = { flags: 1 /* Unreachable */ };
	        // state used to aggregate transform flags during bind.
	        var subtreeTransformFlags = 0 /* None */;
	        var skipTransformFlagAggregation;
	        /**
	         * Inside the binder, we may create a diagnostic for an as-yet unbound node (with potentially no parent pointers, implying no accessible source file)
	         * If so, the node _must_ be in the current file (as that's the only way anything could have traversed to it to yield it as the error node)
	         * This version of `createDiagnosticForNode` uses the binder's context to account for this, and always yields correct diagnostics even in these situations.
	         */
	        function createDiagnosticForNode(node, message, arg0, arg1, arg2) {
	            return ts.createDiagnosticForNodeInSourceFile(ts.getSourceFileOfNode(node) || file, node, message, arg0, arg1, arg2);
	        }
	        function bindSourceFile(f, opts) {
	            file = f;
	            options = opts;
	            languageVersion = ts.getEmitScriptTarget(options);
	            inStrictMode = bindInStrictMode(file, opts);
	            classifiableNames = ts.createUnderscoreEscapedMap();
	            symbolCount = 0;
	            skipTransformFlagAggregation = file.isDeclarationFile;
	            Symbol = ts.objectAllocator.getSymbolConstructor();
	            if (!file.locals) {
	                bind(file);
	                file.symbolCount = symbolCount;
	                file.classifiableNames = classifiableNames;
	            }
	            file = undefined;
	            options = undefined;
	            languageVersion = undefined;
	            parent = undefined;
	            container = undefined;
	            blockScopeContainer = undefined;
	            inferenceContainer = undefined;
	            lastContainer = undefined;
	            seenThisKeyword = false;
	            currentFlow = undefined;
	            currentBreakTarget = undefined;
	            currentContinueTarget = undefined;
	            currentReturnTarget = undefined;
	            currentTrueTarget = undefined;
	            currentFalseTarget = undefined;
	            activeLabels = undefined;
	            hasExplicitReturn = false;
	            emitFlags = 0 /* None */;
	            subtreeTransformFlags = 0 /* None */;
	        }
	        return bindSourceFile;
	        function bindInStrictMode(file, opts) {
	            if (ts.getStrictOptionValue(opts, "alwaysStrict") && !file.isDeclarationFile) {
	                // bind in strict mode source files with alwaysStrict option
	                return true;
	            }
	            else {
	                return !!file.externalModuleIndicator;
	            }
	        }
	        function createSymbol(flags, name) {
	            symbolCount++;
	            return new Symbol(flags, name);
	        }
	        function addDeclarationToSymbol(symbol, node, symbolFlags) {
	            symbol.flags |= symbolFlags;
	            node.symbol = symbol;
	            if (!symbol.declarations) {
	                symbol.declarations = [node];
	            }
	            else {
	                symbol.declarations.push(node);
	            }
	            if (symbolFlags & 1952 /* HasExports */ && !symbol.exports) {
	                symbol.exports = ts.createSymbolTable();
	            }
	            if (symbolFlags & 6240 /* HasMembers */ && !symbol.members) {
	                symbol.members = ts.createSymbolTable();
	            }
	            if (symbolFlags & 107455 /* Value */) {
	                var valueDeclaration = symbol.valueDeclaration;
	                if (!valueDeclaration ||
	                    (valueDeclaration.kind !== node.kind && valueDeclaration.kind === 237 /* ModuleDeclaration */)) {
	                    // other kinds of value declarations take precedence over modules
	                    symbol.valueDeclaration = node;
	                }
	            }
	        }
	        // Should not be called on a declaration with a computed property name,
	        // unless it is a well known Symbol.
	        function getDeclarationName(node) {
	            if (node.kind === 247 /* ExportAssignment */) {
	                return node.isExportEquals ? "export=" /* ExportEquals */ : "default" /* Default */;
	            }
	            var name = ts.getNameOfDeclaration(node);
	            if (name) {
	                if (ts.isAmbientModule(node)) {
	                    var moduleName = ts.getTextOfIdentifierOrLiteral(name);
	                    return (ts.isGlobalScopeAugmentation(node) ? "__global" : "\"" + moduleName + "\"");
	                }
	                if (name.kind === 146 /* ComputedPropertyName */) {
	                    var nameExpression = name.expression;
	                    // treat computed property names where expression is string/numeric literal as just string/numeric literal
	                    if (ts.isStringOrNumericLiteral(nameExpression)) {
	                        return ts.escapeLeadingUnderscores(nameExpression.text);
	                    }
	                    ts.Debug.assert(ts.isWellKnownSymbolSyntactically(nameExpression));
	                    return ts.getPropertyNameForKnownSymbolName(ts.idText(nameExpression.name));
	                }
	                return ts.isPropertyNameLiteral(name) ? ts.getEscapedTextOfIdentifierOrLiteral(name) : undefined;
	            }
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                    return "__constructor" /* Constructor */;
	                case 162 /* FunctionType */:
	                case 157 /* CallSignature */:
	                    return "__call" /* Call */;
	                case 163 /* ConstructorType */:
	                case 158 /* ConstructSignature */:
	                    return "__new" /* New */;
	                case 159 /* IndexSignature */:
	                    return "__index" /* Index */;
	                case 248 /* ExportDeclaration */:
	                    return "__export" /* ExportStar */;
	                case 198 /* BinaryExpression */:
	                    if (ts.getSpecialPropertyAssignmentKind(node) === 2 /* ModuleExports */) {
	                        // module.exports = ...
	                        return "export=" /* ExportEquals */;
	                    }
	                    ts.Debug.fail("Unknown binary declaration kind");
	                    break;
	                case 232 /* FunctionDeclaration */:
	                case 233 /* ClassDeclaration */:
	                    return (ts.hasModifier(node, 512 /* Default */) ? "default" /* Default */ : undefined);
	                case 280 /* JSDocFunctionType */:
	                    return (ts.isJSDocConstructSignature(node) ? "__new" /* New */ : "__call" /* Call */);
	                case 148 /* Parameter */:
	                    // Parameters with names are handled at the top of this function.  Parameters
	                    // without names can only come from JSDocFunctionTypes.
	                    ts.Debug.assert(node.parent.kind === 280 /* JSDocFunctionType */);
	                    var functionType = node.parent;
	                    var index = functionType.parameters.indexOf(node);
	                    return "arg" + index;
	                case 291 /* JSDocTypedefTag */:
	                    var name_2 = ts.getNameOfJSDocTypedef(node);
	                    return typeof name_2 !== "undefined" ? name_2.escapedText : undefined;
	            }
	        }
	        function getDisplayName(node) {
	            return node.name ? ts.declarationNameToString(node.name) : ts.unescapeLeadingUnderscores(getDeclarationName(node));
	        }
	        /**
	         * Declares a Symbol for the node and adds it to symbols. Reports errors for conflicting identifier names.
	         * @param symbolTable - The symbol table which node will be added to.
	         * @param parent - node's parent declaration.
	         * @param node - The declaration to be added to the symbol table
	         * @param includes - The SymbolFlags that node has in addition to its declaration type (eg: export, ambient, etc.)
	         * @param excludes - The flags which node cannot be declared alongside in a symbol table. Used to report forbidden declarations.
	         */
	        function declareSymbol(symbolTable, parent, node, includes, excludes, isReplaceableByMethod) {
	            ts.Debug.assert(!ts.hasDynamicName(node));
	            var isDefaultExport = ts.hasModifier(node, 512 /* Default */);
	            // The exported symbol for an export default function/class node is always named "default"
	            var name = isDefaultExport && parent ? "default" /* Default */ : getDeclarationName(node);
	            var symbol;
	            if (name === undefined) {
	                symbol = createSymbol(0 /* None */, "__missing" /* Missing */);
	            }
	            else {
	                // Check and see if the symbol table already has a symbol with this name.  If not,
	                // create a new symbol with this name and add it to the table.  Note that we don't
	                // give the new symbol any flags *yet*.  This ensures that it will not conflict
	                // with the 'excludes' flags we pass in.
	                //
	                // If we do get an existing symbol, see if it conflicts with the new symbol we're
	                // creating.  For example, a 'var' symbol and a 'class' symbol will conflict within
	                // the same symbol table.  If we have a conflict, report the issue on each
	                // declaration we have for this symbol, and then create a new symbol for this
	                // declaration.
	                //
	                // Note that when properties declared in Javascript constructors
	                // (marked by isReplaceableByMethod) conflict with another symbol, the property loses.
	                // Always. This allows the common Javascript pattern of overwriting a prototype method
	                // with an bound instance method of the same type: `this.method = this.method.bind(this)`
	                //
	                // If we created a new symbol, either because we didn't have a symbol with this name
	                // in the symbol table, or we conflicted with an existing symbol, then just add this
	                // node as the sole declaration of the new symbol.
	                //
	                // Otherwise, we'll be merging into a compatible existing symbol (for example when
	                // you have multiple 'vars' with the same name in the same container).  In this case
	                // just add this node into the declarations list of the symbol.
	                symbol = symbolTable.get(name);
	                if (includes & 2885600 /* Classifiable */) {
	                    classifiableNames.set(name, true);
	                }
	                if (!symbol) {
	                    symbolTable.set(name, symbol = createSymbol(0 /* None */, name));
	                    if (isReplaceableByMethod)
	                        symbol.isReplaceableByMethod = true;
	                }
	                else if (isReplaceableByMethod && !symbol.isReplaceableByMethod) {
	                    // A symbol already exists, so don't add this as a declaration.
	                    return symbol;
	                }
	                else if (symbol.flags & excludes) {
	                    if (symbol.isReplaceableByMethod) {
	                        // Javascript constructor-declared symbols can be discarded in favor of
	                        // prototype symbols like methods.
	                        symbolTable.set(name, symbol = createSymbol(0 /* None */, name));
	                    }
	                    else {
	                        if (node.name) {
	                            node.name.parent = node;
	                        }
	                        // Report errors every position with duplicate declaration
	                        // Report errors on previous encountered declarations
	                        var message_1 = symbol.flags & 2 /* BlockScopedVariable */
	                            ? ts.Diagnostics.Cannot_redeclare_block_scoped_variable_0
	                            : ts.Diagnostics.Duplicate_identifier_0;
	                        if (symbol.flags & 384 /* Enum */ || includes & 384 /* Enum */) {
	                            message_1 = ts.Diagnostics.Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations;
	                        }
	                        if (symbol.declarations && symbol.declarations.length) {
	                            // If the current node is a default export of some sort, then check if
	                            // there are any other default exports that we need to error on.
	                            // We'll know whether we have other default exports depending on if `symbol` already has a declaration list set.
	                            if (isDefaultExport) {
	                                message_1 = ts.Diagnostics.A_module_cannot_have_multiple_default_exports;
	                            }
	                            else {
	                                // This is to properly report an error in the case "export default { }" is after export default of class declaration or function declaration.
	                                // Error on multiple export default in the following case:
	                                // 1. multiple export default of class declaration or function declaration by checking NodeFlags.Default
	                                // 2. multiple export default of export assignment. This one doesn't have NodeFlags.Default on (as export default doesn't considered as modifiers)
	                                if (symbol.declarations && symbol.declarations.length &&
	                                    (isDefaultExport || (node.kind === 247 /* ExportAssignment */ && !node.isExportEquals))) {
	                                    message_1 = ts.Diagnostics.A_module_cannot_have_multiple_default_exports;
	                                }
	                            }
	                        }
	                        ts.forEach(symbol.declarations, function (declaration) {
	                            file.bindDiagnostics.push(createDiagnosticForNode(ts.getNameOfDeclaration(declaration) || declaration, message_1, getDisplayName(declaration)));
	                        });
	                        file.bindDiagnostics.push(createDiagnosticForNode(ts.getNameOfDeclaration(node) || node, message_1, getDisplayName(node)));
	                        symbol = createSymbol(0 /* None */, name);
	                    }
	                }
	            }
	            addDeclarationToSymbol(symbol, node, includes);
	            symbol.parent = parent;
	            return symbol;
	        }
	        function declareModuleMember(node, symbolFlags, symbolExcludes) {
	            var hasExportModifier = ts.getCombinedModifierFlags(node) & 1 /* Export */;
	            if (symbolFlags & 2097152 /* Alias */) {
	                if (node.kind === 250 /* ExportSpecifier */ || (node.kind === 241 /* ImportEqualsDeclaration */ && hasExportModifier)) {
	                    return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
	                }
	                else {
	                    return declareSymbol(container.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	                }
	            }
	            else {
	                // Exported module members are given 2 symbols: A local symbol that is classified with an ExportValue flag,
	                // and an associated export symbol with all the correct flags set on it. There are 2 main reasons:
	                //
	                //   1. We treat locals and exports of the same name as mutually exclusive within a container.
	                //      That means the binder will issue a Duplicate Identifier error if you mix locals and exports
	                //      with the same name in the same container.
	                //      TODO: Make this a more specific error and decouple it from the exclusion logic.
	                //   2. When we checkIdentifier in the checker, we set its resolved symbol to the local symbol,
	                //      but return the export symbol (by calling getExportSymbolOfValueSymbolIfExported). That way
	                //      when the emitter comes back to it, it knows not to qualify the name if it was found in a containing scope.
	                // NOTE: Nested ambient modules always should go to to 'locals' table to prevent their automatic merge
	                //       during global merging in the checker. Why? The only case when ambient module is permitted inside another module is module augmentation
	                //       and this case is specially handled. Module augmentations should only be merged with original module definition
	                //       and should never be merged directly with other augmentation, and the latter case would be possible if automatic merge is allowed.
	                if (node.kind === 291 /* JSDocTypedefTag */)
	                    ts.Debug.assert(ts.isInJavaScriptFile(node)); // We shouldn't add symbols for JSDoc nodes if not in a JS file.
	                var isJSDocTypedefInJSDocNamespace = ts.isJSDocTypedefTag(node) && node.name && node.name.kind === 71 /* Identifier */ && node.name.isInJSDocNamespace;
	                if ((!ts.isAmbientModule(node) && (hasExportModifier || container.flags & 32 /* ExportContext */)) || isJSDocTypedefInJSDocNamespace) {
	                    var exportKind = symbolFlags & 107455 /* Value */ ? 1048576 /* ExportValue */ : 0;
	                    var local = declareSymbol(container.locals, /*parent*/ undefined, node, exportKind, symbolExcludes);
	                    local.exportSymbol = declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
	                    node.localSymbol = local;
	                    return local;
	                }
	                else {
	                    return declareSymbol(container.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	                }
	            }
	        }
	        // All container nodes are kept on a linked list in declaration order. This list is used by
	        // the getLocalNameOfContainer function in the type checker to validate that the local name
	        // used for a container is unique.
	        function bindContainer(node, containerFlags) {
	            // Before we recurse into a node's children, we first save the existing parent, container
	            // and block-container.  Then after we pop out of processing the children, we restore
	            // these saved values.
	            var saveContainer = container;
	            var savedBlockScopeContainer = blockScopeContainer;
	            // Depending on what kind of node this is, we may have to adjust the current container
	            // and block-container.   If the current node is a container, then it is automatically
	            // considered the current block-container as well.  Also, for containers that we know
	            // may contain locals, we proactively initialize the .locals field. We do this because
	            // it's highly likely that the .locals will be needed to place some child in (for example,
	            // a parameter, or variable declaration).
	            //
	            // However, we do not proactively create the .locals for block-containers because it's
	            // totally normal and common for block-containers to never actually have a block-scoped
	            // variable in them.  We don't want to end up allocating an object for every 'block' we
	            // run into when most of them won't be necessary.
	            //
	            // Finally, if this is a block-container, then we clear out any existing .locals object
	            // it may contain within it.  This happens in incremental scenarios.  Because we can be
	            // reusing a node from a previous compilation, that node may have had 'locals' created
	            // for it.  We must clear this so we don't accidentally move any stale data forward from
	            // a previous compilation.
	            if (containerFlags & 1 /* IsContainer */) {
	                container = blockScopeContainer = node;
	                if (containerFlags & 32 /* HasLocals */) {
	                    container.locals = ts.createSymbolTable();
	                }
	                addToContainerChain(container);
	            }
	            else if (containerFlags & 2 /* IsBlockScopedContainer */) {
	                blockScopeContainer = node;
	                blockScopeContainer.locals = undefined;
	            }
	            if (containerFlags & 4 /* IsControlFlowContainer */) {
	                var saveCurrentFlow = currentFlow;
	                var saveBreakTarget = currentBreakTarget;
	                var saveContinueTarget = currentContinueTarget;
	                var saveReturnTarget = currentReturnTarget;
	                var saveActiveLabels = activeLabels;
	                var saveHasExplicitReturn = hasExplicitReturn;
	                var isIIFE = containerFlags & 16 /* IsFunctionExpression */ && !ts.hasModifier(node, 256 /* Async */) && !!ts.getImmediatelyInvokedFunctionExpression(node);
	                // A non-async IIFE is considered part of the containing control flow. Return statements behave
	                // similarly to break statements that exit to a label just past the statement body.
	                if (!isIIFE) {
	                    currentFlow = { flags: 2 /* Start */ };
	                    if (containerFlags & (16 /* IsFunctionExpression */ | 128 /* IsObjectLiteralOrClassExpressionMethod */)) {
	                        currentFlow.container = node;
	                    }
	                }
	                // We create a return control flow graph for IIFEs and constructors. For constructors
	                // we use the return control flow graph in strict property intialization checks.
	                currentReturnTarget = isIIFE || node.kind === 154 /* Constructor */ ? createBranchLabel() : undefined;
	                currentBreakTarget = undefined;
	                currentContinueTarget = undefined;
	                activeLabels = undefined;
	                hasExplicitReturn = false;
	                bindChildren(node);
	                // Reset all reachability check related flags on node (for incremental scenarios)
	                node.flags &= ~1408 /* ReachabilityAndEmitFlags */;
	                if (!(currentFlow.flags & 1 /* Unreachable */) && containerFlags & 8 /* IsFunctionLike */ && ts.nodeIsPresent(node.body)) {
	                    node.flags |= 128 /* HasImplicitReturn */;
	                    if (hasExplicitReturn)
	                        node.flags |= 256 /* HasExplicitReturn */;
	                }
	                if (node.kind === 272 /* SourceFile */) {
	                    node.flags |= emitFlags;
	                }
	                if (currentReturnTarget) {
	                    addAntecedent(currentReturnTarget, currentFlow);
	                    currentFlow = finishFlowLabel(currentReturnTarget);
	                    if (node.kind === 154 /* Constructor */) {
	                        node.returnFlowNode = currentFlow;
	                    }
	                }
	                if (!isIIFE) {
	                    currentFlow = saveCurrentFlow;
	                }
	                currentBreakTarget = saveBreakTarget;
	                currentContinueTarget = saveContinueTarget;
	                currentReturnTarget = saveReturnTarget;
	                activeLabels = saveActiveLabels;
	                hasExplicitReturn = saveHasExplicitReturn;
	            }
	            else if (containerFlags & 64 /* IsInterface */) {
	                seenThisKeyword = false;
	                bindChildren(node);
	                node.flags = seenThisKeyword ? node.flags | 64 /* ContainsThis */ : node.flags & ~64 /* ContainsThis */;
	            }
	            else if (containerFlags & 256 /* IsInferenceContainer */) {
	                var saveInferenceContainer = inferenceContainer;
	                inferenceContainer = node;
	                node.locals = undefined;
	                bindChildren(node);
	                inferenceContainer = saveInferenceContainer;
	            }
	            else {
	                bindChildren(node);
	            }
	            container = saveContainer;
	            blockScopeContainer = savedBlockScopeContainer;
	        }
	        function bindChildren(node) {
	            if (skipTransformFlagAggregation) {
	                bindChildrenWorker(node);
	            }
	            else if (node.transformFlags & 536870912 /* HasComputedFlags */) {
	                skipTransformFlagAggregation = true;
	                bindChildrenWorker(node);
	                skipTransformFlagAggregation = false;
	                subtreeTransformFlags |= node.transformFlags & ~getTransformFlagsSubtreeExclusions(node.kind);
	            }
	            else {
	                var savedSubtreeTransformFlags = subtreeTransformFlags;
	                subtreeTransformFlags = 0;
	                bindChildrenWorker(node);
	                subtreeTransformFlags = savedSubtreeTransformFlags | computeTransformFlagsForNode(node, subtreeTransformFlags);
	            }
	        }
	        function bindEach(nodes) {
	            if (nodes === undefined) {
	                return;
	            }
	            if (skipTransformFlagAggregation) {
	                ts.forEach(nodes, bind);
	            }
	            else {
	                var savedSubtreeTransformFlags = subtreeTransformFlags;
	                subtreeTransformFlags = 0 /* None */;
	                var nodeArrayFlags = 0 /* None */;
	                for (var _i = 0, nodes_2 = nodes; _i < nodes_2.length; _i++) {
	                    var node = nodes_2[_i];
	                    bind(node);
	                    nodeArrayFlags |= node.transformFlags & ~536870912 /* HasComputedFlags */;
	                }
	                nodes.transformFlags = nodeArrayFlags | 536870912 /* HasComputedFlags */;
	                subtreeTransformFlags |= savedSubtreeTransformFlags;
	            }
	        }
	        function bindEachChild(node) {
	            ts.forEachChild(node, bind, bindEach);
	        }
	        function bindChildrenWorker(node) {
	            // Binding of JsDocComment should be done before the current block scope container changes.
	            // because the scope of JsDocComment should not be affected by whether the current node is a
	            // container or not.
	            if (ts.hasJSDocNodes(node)) {
	                if (ts.isInJavaScriptFile(node)) {
	                    for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                        var j = _a[_i];
	                        bind(j);
	                    }
	                }
	                else {
	                    for (var _b = 0, _c = node.jsDoc; _b < _c.length; _b++) {
	                        var j = _c[_b];
	                        setParentPointers(node, j);
	                    }
	                }
	            }
	            if (checkUnreachable(node)) {
	                bindEachChild(node);
	                return;
	            }
	            switch (node.kind) {
	                case 217 /* WhileStatement */:
	                    bindWhileStatement(node);
	                    break;
	                case 216 /* DoStatement */:
	                    bindDoStatement(node);
	                    break;
	                case 218 /* ForStatement */:
	                    bindForStatement(node);
	                    break;
	                case 219 /* ForInStatement */:
	                case 220 /* ForOfStatement */:
	                    bindForInOrForOfStatement(node);
	                    break;
	                case 215 /* IfStatement */:
	                    bindIfStatement(node);
	                    break;
	                case 223 /* ReturnStatement */:
	                case 227 /* ThrowStatement */:
	                    bindReturnOrThrow(node);
	                    break;
	                case 222 /* BreakStatement */:
	                case 221 /* ContinueStatement */:
	                    bindBreakOrContinueStatement(node);
	                    break;
	                case 228 /* TryStatement */:
	                    bindTryStatement(node);
	                    break;
	                case 225 /* SwitchStatement */:
	                    bindSwitchStatement(node);
	                    break;
	                case 239 /* CaseBlock */:
	                    bindCaseBlock(node);
	                    break;
	                case 264 /* CaseClause */:
	                    bindCaseClause(node);
	                    break;
	                case 226 /* LabeledStatement */:
	                    bindLabeledStatement(node);
	                    break;
	                case 196 /* PrefixUnaryExpression */:
	                    bindPrefixUnaryExpressionFlow(node);
	                    break;
	                case 197 /* PostfixUnaryExpression */:
	                    bindPostfixUnaryExpressionFlow(node);
	                    break;
	                case 198 /* BinaryExpression */:
	                    bindBinaryExpressionFlow(node);
	                    break;
	                case 192 /* DeleteExpression */:
	                    bindDeleteExpressionFlow(node);
	                    break;
	                case 199 /* ConditionalExpression */:
	                    bindConditionalExpressionFlow(node);
	                    break;
	                case 230 /* VariableDeclaration */:
	                    bindVariableDeclarationFlow(node);
	                    break;
	                case 185 /* CallExpression */:
	                    bindCallExpressionFlow(node);
	                    break;
	                case 282 /* JSDocComment */:
	                    bindJSDocComment(node);
	                    break;
	                case 291 /* JSDocTypedefTag */:
	                    bindJSDocTypedefTag(node);
	                    break;
	                default:
	                    bindEachChild(node);
	                    break;
	            }
	        }
	        function isNarrowingExpression(expr) {
	            switch (expr.kind) {
	                case 71 /* Identifier */:
	                case 99 /* ThisKeyword */:
	                case 183 /* PropertyAccessExpression */:
	                    return isNarrowableReference(expr);
	                case 185 /* CallExpression */:
	                    return hasNarrowableArgument(expr);
	                case 189 /* ParenthesizedExpression */:
	                    return isNarrowingExpression(expr.expression);
	                case 198 /* BinaryExpression */:
	                    return isNarrowingBinaryExpression(expr);
	                case 196 /* PrefixUnaryExpression */:
	                    return expr.operator === 51 /* ExclamationToken */ && isNarrowingExpression(expr.operand);
	            }
	            return false;
	        }
	        function isNarrowableReference(expr) {
	            return expr.kind === 71 /* Identifier */ ||
	                expr.kind === 99 /* ThisKeyword */ ||
	                expr.kind === 97 /* SuperKeyword */ ||
	                expr.kind === 183 /* PropertyAccessExpression */ && isNarrowableReference(expr.expression);
	        }
	        function hasNarrowableArgument(expr) {
	            if (expr.arguments) {
	                for (var _i = 0, _a = expr.arguments; _i < _a.length; _i++) {
	                    var argument = _a[_i];
	                    if (isNarrowableReference(argument)) {
	                        return true;
	                    }
	                }
	            }
	            if (expr.expression.kind === 183 /* PropertyAccessExpression */ &&
	                isNarrowableReference(expr.expression.expression)) {
	                return true;
	            }
	            return false;
	        }
	        function isNarrowingTypeofOperands(expr1, expr2) {
	            return ts.isTypeOfExpression(expr1) && isNarrowableOperand(expr1.expression) && ts.isStringLiteralLike(expr2);
	        }
	        function isNarrowableInOperands(left, right) {
	            return ts.isStringLiteralLike(left) && isNarrowingExpression(right);
	        }
	        function isNarrowingBinaryExpression(expr) {
	            switch (expr.operatorToken.kind) {
	                case 58 /* EqualsToken */:
	                    return isNarrowableReference(expr.left);
	                case 32 /* EqualsEqualsToken */:
	                case 33 /* ExclamationEqualsToken */:
	                case 34 /* EqualsEqualsEqualsToken */:
	                case 35 /* ExclamationEqualsEqualsToken */:
	                    return isNarrowableOperand(expr.left) || isNarrowableOperand(expr.right) ||
	                        isNarrowingTypeofOperands(expr.right, expr.left) || isNarrowingTypeofOperands(expr.left, expr.right);
	                case 93 /* InstanceOfKeyword */:
	                    return isNarrowableOperand(expr.left);
	                case 92 /* InKeyword */:
	                    return isNarrowableInOperands(expr.left, expr.right);
	                case 26 /* CommaToken */:
	                    return isNarrowingExpression(expr.right);
	            }
	            return false;
	        }
	        function isNarrowableOperand(expr) {
	            switch (expr.kind) {
	                case 189 /* ParenthesizedExpression */:
	                    return isNarrowableOperand(expr.expression);
	                case 198 /* BinaryExpression */:
	                    switch (expr.operatorToken.kind) {
	                        case 58 /* EqualsToken */:
	                            return isNarrowableOperand(expr.left);
	                        case 26 /* CommaToken */:
	                            return isNarrowableOperand(expr.right);
	                    }
	            }
	            return isNarrowableReference(expr);
	        }
	        function createBranchLabel() {
	            return {
	                flags: 4 /* BranchLabel */,
	                antecedents: undefined
	            };
	        }
	        function createLoopLabel() {
	            return {
	                flags: 8 /* LoopLabel */,
	                antecedents: undefined
	            };
	        }
	        function setFlowNodeReferenced(flow) {
	            // On first reference we set the Referenced flag, thereafter we set the Shared flag
	            flow.flags |= flow.flags & 512 /* Referenced */ ? 1024 /* Shared */ : 512 /* Referenced */;
	        }
	        function addAntecedent(label, antecedent) {
	            if (!(antecedent.flags & 1 /* Unreachable */) && !ts.contains(label.antecedents, antecedent)) {
	                (label.antecedents || (label.antecedents = [])).push(antecedent);
	                setFlowNodeReferenced(antecedent);
	            }
	        }
	        function createFlowCondition(flags, antecedent, expression) {
	            if (antecedent.flags & 1 /* Unreachable */) {
	                return antecedent;
	            }
	            if (!expression) {
	                return flags & 32 /* TrueCondition */ ? antecedent : unreachableFlow;
	            }
	            if (expression.kind === 101 /* TrueKeyword */ && flags & 64 /* FalseCondition */ ||
	                expression.kind === 86 /* FalseKeyword */ && flags & 32 /* TrueCondition */) {
	                return unreachableFlow;
	            }
	            if (!isNarrowingExpression(expression)) {
	                return antecedent;
	            }
	            setFlowNodeReferenced(antecedent);
	            return { flags: flags, expression: expression, antecedent: antecedent };
	        }
	        function createFlowSwitchClause(antecedent, switchStatement, clauseStart, clauseEnd) {
	            if (!isNarrowingExpression(switchStatement.expression)) {
	                return antecedent;
	            }
	            setFlowNodeReferenced(antecedent);
	            return { flags: 128 /* SwitchClause */, switchStatement: switchStatement, clauseStart: clauseStart, clauseEnd: clauseEnd, antecedent: antecedent };
	        }
	        function createFlowAssignment(antecedent, node) {
	            setFlowNodeReferenced(antecedent);
	            return { flags: 16 /* Assignment */, antecedent: antecedent, node: node };
	        }
	        function createFlowArrayMutation(antecedent, node) {
	            setFlowNodeReferenced(antecedent);
	            var res = { flags: 256 /* ArrayMutation */, antecedent: antecedent, node: node };
	            return res;
	        }
	        function finishFlowLabel(flow) {
	            var antecedents = flow.antecedents;
	            if (!antecedents) {
	                return unreachableFlow;
	            }
	            if (antecedents.length === 1) {
	                return antecedents[0];
	            }
	            return flow;
	        }
	        function isStatementCondition(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 215 /* IfStatement */:
	                case 217 /* WhileStatement */:
	                case 216 /* DoStatement */:
	                    return parent.expression === node;
	                case 218 /* ForStatement */:
	                case 199 /* ConditionalExpression */:
	                    return parent.condition === node;
	            }
	            return false;
	        }
	        function isLogicalExpression(node) {
	            while (true) {
	                if (node.kind === 189 /* ParenthesizedExpression */) {
	                    node = node.expression;
	                }
	                else if (node.kind === 196 /* PrefixUnaryExpression */ && node.operator === 51 /* ExclamationToken */) {
	                    node = node.operand;
	                }
	                else {
	                    return node.kind === 198 /* BinaryExpression */ && (node.operatorToken.kind === 53 /* AmpersandAmpersandToken */ ||
	                        node.operatorToken.kind === 54 /* BarBarToken */);
	                }
	            }
	        }
	        function isTopLevelLogicalExpression(node) {
	            while (node.parent.kind === 189 /* ParenthesizedExpression */ ||
	                node.parent.kind === 196 /* PrefixUnaryExpression */ &&
	                    node.parent.operator === 51 /* ExclamationToken */) {
	                node = node.parent;
	            }
	            return !isStatementCondition(node) && !isLogicalExpression(node.parent);
	        }
	        function bindCondition(node, trueTarget, falseTarget) {
	            var saveTrueTarget = currentTrueTarget;
	            var saveFalseTarget = currentFalseTarget;
	            currentTrueTarget = trueTarget;
	            currentFalseTarget = falseTarget;
	            bind(node);
	            currentTrueTarget = saveTrueTarget;
	            currentFalseTarget = saveFalseTarget;
	            if (!node || !isLogicalExpression(node)) {
	                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */, currentFlow, node));
	                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */, currentFlow, node));
	            }
	        }
	        function bindIterativeStatement(node, breakTarget, continueTarget) {
	            var saveBreakTarget = currentBreakTarget;
	            var saveContinueTarget = currentContinueTarget;
	            currentBreakTarget = breakTarget;
	            currentContinueTarget = continueTarget;
	            bind(node);
	            currentBreakTarget = saveBreakTarget;
	            currentContinueTarget = saveContinueTarget;
	        }
	        function bindWhileStatement(node) {
	            var preWhileLabel = createLoopLabel();
	            var preBodyLabel = createBranchLabel();
	            var postWhileLabel = createBranchLabel();
	            addAntecedent(preWhileLabel, currentFlow);
	            currentFlow = preWhileLabel;
	            bindCondition(node.expression, preBodyLabel, postWhileLabel);
	            currentFlow = finishFlowLabel(preBodyLabel);
	            bindIterativeStatement(node.statement, postWhileLabel, preWhileLabel);
	            addAntecedent(preWhileLabel, currentFlow);
	            currentFlow = finishFlowLabel(postWhileLabel);
	        }
	        function bindDoStatement(node) {
	            var preDoLabel = createLoopLabel();
	            var enclosingLabeledStatement = node.parent.kind === 226 /* LabeledStatement */
	                ? ts.lastOrUndefined(activeLabels)
	                : undefined;
	            // if do statement is wrapped in labeled statement then target labels for break/continue with or without
	            // label should be the same
	            var preConditionLabel = enclosingLabeledStatement ? enclosingLabeledStatement.continueTarget : createBranchLabel();
	            var postDoLabel = enclosingLabeledStatement ? enclosingLabeledStatement.breakTarget : createBranchLabel();
	            addAntecedent(preDoLabel, currentFlow);
	            currentFlow = preDoLabel;
	            bindIterativeStatement(node.statement, postDoLabel, preConditionLabel);
	            addAntecedent(preConditionLabel, currentFlow);
	            currentFlow = finishFlowLabel(preConditionLabel);
	            bindCondition(node.expression, preDoLabel, postDoLabel);
	            currentFlow = finishFlowLabel(postDoLabel);
	        }
	        function bindForStatement(node) {
	            var preLoopLabel = createLoopLabel();
	            var preBodyLabel = createBranchLabel();
	            var postLoopLabel = createBranchLabel();
	            bind(node.initializer);
	            addAntecedent(preLoopLabel, currentFlow);
	            currentFlow = preLoopLabel;
	            bindCondition(node.condition, preBodyLabel, postLoopLabel);
	            currentFlow = finishFlowLabel(preBodyLabel);
	            bindIterativeStatement(node.statement, postLoopLabel, preLoopLabel);
	            bind(node.incrementor);
	            addAntecedent(preLoopLabel, currentFlow);
	            currentFlow = finishFlowLabel(postLoopLabel);
	        }
	        function bindForInOrForOfStatement(node) {
	            var preLoopLabel = createLoopLabel();
	            var postLoopLabel = createBranchLabel();
	            addAntecedent(preLoopLabel, currentFlow);
	            currentFlow = preLoopLabel;
	            if (node.kind === 220 /* ForOfStatement */) {
	                bind(node.awaitModifier);
	            }
	            bind(node.expression);
	            addAntecedent(postLoopLabel, currentFlow);
	            bind(node.initializer);
	            if (node.initializer.kind !== 231 /* VariableDeclarationList */) {
	                bindAssignmentTargetFlow(node.initializer);
	            }
	            bindIterativeStatement(node.statement, postLoopLabel, preLoopLabel);
	            addAntecedent(preLoopLabel, currentFlow);
	            currentFlow = finishFlowLabel(postLoopLabel);
	        }
	        function bindIfStatement(node) {
	            var thenLabel = createBranchLabel();
	            var elseLabel = createBranchLabel();
	            var postIfLabel = createBranchLabel();
	            bindCondition(node.expression, thenLabel, elseLabel);
	            currentFlow = finishFlowLabel(thenLabel);
	            bind(node.thenStatement);
	            addAntecedent(postIfLabel, currentFlow);
	            currentFlow = finishFlowLabel(elseLabel);
	            bind(node.elseStatement);
	            addAntecedent(postIfLabel, currentFlow);
	            currentFlow = finishFlowLabel(postIfLabel);
	        }
	        function bindReturnOrThrow(node) {
	            bind(node.expression);
	            if (node.kind === 223 /* ReturnStatement */) {
	                hasExplicitReturn = true;
	                if (currentReturnTarget) {
	                    addAntecedent(currentReturnTarget, currentFlow);
	                }
	            }
	            currentFlow = unreachableFlow;
	        }
	        function findActiveLabel(name) {
	            if (activeLabels) {
	                for (var _i = 0, activeLabels_1 = activeLabels; _i < activeLabels_1.length; _i++) {
	                    var label = activeLabels_1[_i];
	                    if (label.name === name) {
	                        return label;
	                    }
	                }
	            }
	            return undefined;
	        }
	        function bindBreakOrContinueFlow(node, breakTarget, continueTarget) {
	            var flowLabel = node.kind === 222 /* BreakStatement */ ? breakTarget : continueTarget;
	            if (flowLabel) {
	                addAntecedent(flowLabel, currentFlow);
	                currentFlow = unreachableFlow;
	            }
	        }
	        function bindBreakOrContinueStatement(node) {
	            bind(node.label);
	            if (node.label) {
	                var activeLabel = findActiveLabel(node.label.escapedText);
	                if (activeLabel) {
	                    activeLabel.referenced = true;
	                    bindBreakOrContinueFlow(node, activeLabel.breakTarget, activeLabel.continueTarget);
	                }
	            }
	            else {
	                bindBreakOrContinueFlow(node, currentBreakTarget, currentContinueTarget);
	            }
	        }
	        function bindTryStatement(node) {
	            var preFinallyLabel = createBranchLabel();
	            var preTryFlow = currentFlow;
	            // TODO: Every statement in try block is potentially an exit point!
	            bind(node.tryBlock);
	            addAntecedent(preFinallyLabel, currentFlow);
	            var flowAfterTry = currentFlow;
	            var flowAfterCatch = unreachableFlow;
	            if (node.catchClause) {
	                currentFlow = preTryFlow;
	                bind(node.catchClause);
	                addAntecedent(preFinallyLabel, currentFlow);
	                flowAfterCatch = currentFlow;
	            }
	            if (node.finallyBlock) {
	                // in finally flow is combined from pre-try/flow from try/flow from catch
	                // pre-flow is necessary to make sure that finally is reachable even if finally flows in both try and finally blocks are unreachable
	                // also for finally blocks we inject two extra edges into the flow graph.
	                // first -> edge that connects pre-try flow with the label at the beginning of the finally block, it has lock associated with it
	                // second -> edge that represents post-finally flow.
	                // these edges are used in following scenario:
	                // let a; (1)
	                // try { a = someOperation(); (2)}
	                // finally { (3) console.log(a) } (4)
	                // (5) a
	                // flow graph for this case looks roughly like this (arrows show ):
	                // (1-pre-try-flow) <--.. <-- (2-post-try-flow)
	                //  ^                                ^
	                //  |*****(3-pre-finally-label) -----|
	                //                ^
	                //                |-- ... <-- (4-post-finally-label) <--- (5)
	                // In case when we walk the flow starting from inside the finally block we want to take edge '*****' into account
	                // since it ensures that finally is always reachable. However when we start outside the finally block and go through label (5)
	                // then edge '*****' should be discarded because label 4 is only reachable if post-finally label-4 is reachable
	                // Simply speaking code inside finally block is treated as reachable as pre-try-flow
	                // since we conservatively assume that any line in try block can throw or return in which case we'll enter finally.
	                // However code after finally is reachable only if control flow was not abrupted in try/catch or finally blocks - it should be composed from
	                // final flows of these blocks without taking pre-try flow into account.
	                //
	                // extra edges that we inject allows to control this behavior
	                // if when walking the flow we step on post-finally edge - we can mark matching pre-finally edge as locked so it will be skipped.
	                var preFinallyFlow = { flags: 2048 /* PreFinally */, antecedent: preTryFlow, lock: {} };
	                addAntecedent(preFinallyLabel, preFinallyFlow);
	                currentFlow = finishFlowLabel(preFinallyLabel);
	                bind(node.finallyBlock);
	                // if flow after finally is unreachable - keep it
	                // otherwise check if flows after try and after catch are unreachable
	                // if yes - convert current flow to unreachable
	                // i.e.
	                // try { return "1" } finally { console.log(1); }
	                // console.log(2); // this line should be unreachable even if flow falls out of finally block
	                if (!(currentFlow.flags & 1 /* Unreachable */)) {
	                    if ((flowAfterTry.flags & 1 /* Unreachable */) && (flowAfterCatch.flags & 1 /* Unreachable */)) {
	                        currentFlow = flowAfterTry === reportedUnreachableFlow || flowAfterCatch === reportedUnreachableFlow
	                            ? reportedUnreachableFlow
	                            : unreachableFlow;
	                    }
	                }
	                if (!(currentFlow.flags & 1 /* Unreachable */)) {
	                    var afterFinallyFlow = { flags: 4096 /* AfterFinally */, antecedent: currentFlow };
	                    preFinallyFlow.lock = afterFinallyFlow;
	                    currentFlow = afterFinallyFlow;
	                }
	            }
	            else {
	                currentFlow = finishFlowLabel(preFinallyLabel);
	            }
	        }
	        function bindSwitchStatement(node) {
	            var postSwitchLabel = createBranchLabel();
	            bind(node.expression);
	            var saveBreakTarget = currentBreakTarget;
	            var savePreSwitchCaseFlow = preSwitchCaseFlow;
	            currentBreakTarget = postSwitchLabel;
	            preSwitchCaseFlow = currentFlow;
	            bind(node.caseBlock);
	            addAntecedent(postSwitchLabel, currentFlow);
	            var hasDefault = ts.forEach(node.caseBlock.clauses, function (c) { return c.kind === 265 /* DefaultClause */; });
	            // We mark a switch statement as possibly exhaustive if it has no default clause and if all
	            // case clauses have unreachable end points (e.g. they all return).
	            node.possiblyExhaustive = !hasDefault && !postSwitchLabel.antecedents;
	            if (!hasDefault) {
	                addAntecedent(postSwitchLabel, createFlowSwitchClause(preSwitchCaseFlow, node, 0, 0));
	            }
	            currentBreakTarget = saveBreakTarget;
	            preSwitchCaseFlow = savePreSwitchCaseFlow;
	            currentFlow = finishFlowLabel(postSwitchLabel);
	        }
	        function bindCaseBlock(node) {
	            var savedSubtreeTransformFlags = subtreeTransformFlags;
	            subtreeTransformFlags = 0;
	            var clauses = node.clauses;
	            var fallthroughFlow = unreachableFlow;
	            for (var i = 0; i < clauses.length; i++) {
	                var clauseStart = i;
	                while (!clauses[i].statements.length && i + 1 < clauses.length) {
	                    bind(clauses[i]);
	                    i++;
	                }
	                var preCaseLabel = createBranchLabel();
	                addAntecedent(preCaseLabel, createFlowSwitchClause(preSwitchCaseFlow, node.parent, clauseStart, i + 1));
	                addAntecedent(preCaseLabel, fallthroughFlow);
	                currentFlow = finishFlowLabel(preCaseLabel);
	                var clause = clauses[i];
	                bind(clause);
	                fallthroughFlow = currentFlow;
	                if (!(currentFlow.flags & 1 /* Unreachable */) && i !== clauses.length - 1 && options.noFallthroughCasesInSwitch) {
	                    errorOnFirstToken(clause, ts.Diagnostics.Fallthrough_case_in_switch);
	                }
	            }
	            clauses.transformFlags = subtreeTransformFlags | 536870912 /* HasComputedFlags */;
	            subtreeTransformFlags |= savedSubtreeTransformFlags;
	        }
	        function bindCaseClause(node) {
	            var saveCurrentFlow = currentFlow;
	            currentFlow = preSwitchCaseFlow;
	            bind(node.expression);
	            currentFlow = saveCurrentFlow;
	            bindEach(node.statements);
	        }
	        function pushActiveLabel(name, breakTarget, continueTarget) {
	            var activeLabel = {
	                name: name,
	                breakTarget: breakTarget,
	                continueTarget: continueTarget,
	                referenced: false
	            };
	            (activeLabels || (activeLabels = [])).push(activeLabel);
	            return activeLabel;
	        }
	        function popActiveLabel() {
	            activeLabels.pop();
	        }
	        function bindLabeledStatement(node) {
	            var preStatementLabel = createLoopLabel();
	            var postStatementLabel = createBranchLabel();
	            bind(node.label);
	            addAntecedent(preStatementLabel, currentFlow);
	            var activeLabel = pushActiveLabel(node.label.escapedText, postStatementLabel, preStatementLabel);
	            bind(node.statement);
	            popActiveLabel();
	            if (!activeLabel.referenced && !options.allowUnusedLabels) {
	                file.bindDiagnostics.push(createDiagnosticForNode(node.label, ts.Diagnostics.Unused_label));
	            }
	            if (!node.statement || node.statement.kind !== 216 /* DoStatement */) {
	                // do statement sets current flow inside bindDoStatement
	                addAntecedent(postStatementLabel, currentFlow);
	                currentFlow = finishFlowLabel(postStatementLabel);
	            }
	        }
	        function bindDestructuringTargetFlow(node) {
	            if (node.kind === 198 /* BinaryExpression */ && node.operatorToken.kind === 58 /* EqualsToken */) {
	                bindAssignmentTargetFlow(node.left);
	            }
	            else {
	                bindAssignmentTargetFlow(node);
	            }
	        }
	        function bindAssignmentTargetFlow(node) {
	            if (isNarrowableReference(node)) {
	                currentFlow = createFlowAssignment(currentFlow, node);
	            }
	            else if (node.kind === 181 /* ArrayLiteralExpression */) {
	                for (var _i = 0, _a = node.elements; _i < _a.length; _i++) {
	                    var e = _a[_i];
	                    if (e.kind === 202 /* SpreadElement */) {
	                        bindAssignmentTargetFlow(e.expression);
	                    }
	                    else {
	                        bindDestructuringTargetFlow(e);
	                    }
	                }
	            }
	            else if (node.kind === 182 /* ObjectLiteralExpression */) {
	                for (var _b = 0, _c = node.properties; _b < _c.length; _b++) {
	                    var p = _c[_b];
	                    if (p.kind === 268 /* PropertyAssignment */) {
	                        bindDestructuringTargetFlow(p.initializer);
	                    }
	                    else if (p.kind === 269 /* ShorthandPropertyAssignment */) {
	                        bindAssignmentTargetFlow(p.name);
	                    }
	                    else if (p.kind === 270 /* SpreadAssignment */) {
	                        bindAssignmentTargetFlow(p.expression);
	                    }
	                }
	            }
	        }
	        function bindLogicalExpression(node, trueTarget, falseTarget) {
	            var preRightLabel = createBranchLabel();
	            if (node.operatorToken.kind === 53 /* AmpersandAmpersandToken */) {
	                bindCondition(node.left, preRightLabel, falseTarget);
	            }
	            else {
	                bindCondition(node.left, trueTarget, preRightLabel);
	            }
	            currentFlow = finishFlowLabel(preRightLabel);
	            bind(node.operatorToken);
	            bindCondition(node.right, trueTarget, falseTarget);
	        }
	        function bindPrefixUnaryExpressionFlow(node) {
	            if (node.operator === 51 /* ExclamationToken */) {
	                var saveTrueTarget = currentTrueTarget;
	                currentTrueTarget = currentFalseTarget;
	                currentFalseTarget = saveTrueTarget;
	                bindEachChild(node);
	                currentFalseTarget = currentTrueTarget;
	                currentTrueTarget = saveTrueTarget;
	            }
	            else {
	                bindEachChild(node);
	                if (node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */) {
	                    bindAssignmentTargetFlow(node.operand);
	                }
	            }
	        }
	        function bindPostfixUnaryExpressionFlow(node) {
	            bindEachChild(node);
	            if (node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */) {
	                bindAssignmentTargetFlow(node.operand);
	            }
	        }
	        function bindBinaryExpressionFlow(node) {
	            var operator = node.operatorToken.kind;
	            if (operator === 53 /* AmpersandAmpersandToken */ || operator === 54 /* BarBarToken */) {
	                if (isTopLevelLogicalExpression(node)) {
	                    var postExpressionLabel = createBranchLabel();
	                    bindLogicalExpression(node, postExpressionLabel, postExpressionLabel);
	                    currentFlow = finishFlowLabel(postExpressionLabel);
	                }
	                else {
	                    bindLogicalExpression(node, currentTrueTarget, currentFalseTarget);
	                }
	            }
	            else {
	                bindEachChild(node);
	                if (ts.isAssignmentOperator(operator) && !ts.isAssignmentTarget(node)) {
	                    bindAssignmentTargetFlow(node.left);
	                    if (operator === 58 /* EqualsToken */ && node.left.kind === 184 /* ElementAccessExpression */) {
	                        var elementAccess = node.left;
	                        if (isNarrowableOperand(elementAccess.expression)) {
	                            currentFlow = createFlowArrayMutation(currentFlow, node);
	                        }
	                    }
	                }
	            }
	        }
	        function bindDeleteExpressionFlow(node) {
	            bindEachChild(node);
	            if (node.expression.kind === 183 /* PropertyAccessExpression */) {
	                bindAssignmentTargetFlow(node.expression);
	            }
	        }
	        function bindConditionalExpressionFlow(node) {
	            var trueLabel = createBranchLabel();
	            var falseLabel = createBranchLabel();
	            var postExpressionLabel = createBranchLabel();
	            bindCondition(node.condition, trueLabel, falseLabel);
	            currentFlow = finishFlowLabel(trueLabel);
	            bind(node.questionToken);
	            bind(node.whenTrue);
	            addAntecedent(postExpressionLabel, currentFlow);
	            currentFlow = finishFlowLabel(falseLabel);
	            bind(node.colonToken);
	            bind(node.whenFalse);
	            addAntecedent(postExpressionLabel, currentFlow);
	            currentFlow = finishFlowLabel(postExpressionLabel);
	        }
	        function bindInitializedVariableFlow(node) {
	            var name = !ts.isOmittedExpression(node) ? node.name : undefined;
	            if (ts.isBindingPattern(name)) {
	                for (var _i = 0, _a = name.elements; _i < _a.length; _i++) {
	                    var child = _a[_i];
	                    bindInitializedVariableFlow(child);
	                }
	            }
	            else {
	                currentFlow = createFlowAssignment(currentFlow, node);
	            }
	        }
	        function bindVariableDeclarationFlow(node) {
	            bindEachChild(node);
	            if (node.initializer || ts.isForInOrOfStatement(node.parent.parent)) {
	                bindInitializedVariableFlow(node);
	            }
	        }
	        function bindJSDocComment(node) {
	            ts.forEachChild(node, function (n) {
	                if (n.kind !== 291 /* JSDocTypedefTag */) {
	                    bind(n);
	                }
	            });
	        }
	        function bindJSDocTypedefTag(node) {
	            ts.forEachChild(node, function (n) {
	                // if the node has a fullName "A.B.C", that means symbol "C" was already bound
	                // when we visit "fullName"; so when we visit the name "C" as the next child of
	                // the jsDocTypedefTag, we should skip binding it.
	                if (node.fullName && n === node.name && node.fullName.kind !== 71 /* Identifier */) {
	                    return;
	                }
	                bind(n);
	            });
	        }
	        function bindCallExpressionFlow(node) {
	            // If the target of the call expression is a function expression or arrow function we have
	            // an immediately invoked function expression (IIFE). Initialize the flowNode property to
	            // the current control flow (which includes evaluation of the IIFE arguments).
	            var expr = node.expression;
	            while (expr.kind === 189 /* ParenthesizedExpression */) {
	                expr = expr.expression;
	            }
	            if (expr.kind === 190 /* FunctionExpression */ || expr.kind === 191 /* ArrowFunction */) {
	                bindEach(node.typeArguments);
	                bindEach(node.arguments);
	                bind(node.expression);
	            }
	            else {
	                bindEachChild(node);
	            }
	            if (node.expression.kind === 183 /* PropertyAccessExpression */) {
	                var propertyAccess = node.expression;
	                if (isNarrowableOperand(propertyAccess.expression) && ts.isPushOrUnshiftIdentifier(propertyAccess.name)) {
	                    currentFlow = createFlowArrayMutation(currentFlow, node);
	                }
	            }
	        }
	        function getContainerFlags(node) {
	            switch (node.kind) {
	                case 203 /* ClassExpression */:
	                case 233 /* ClassDeclaration */:
	                case 236 /* EnumDeclaration */:
	                case 182 /* ObjectLiteralExpression */:
	                case 165 /* TypeLiteral */:
	                case 283 /* JSDocTypeLiteral */:
	                case 261 /* JsxAttributes */:
	                    return 1 /* IsContainer */;
	                case 234 /* InterfaceDeclaration */:
	                    return 1 /* IsContainer */ | 64 /* IsInterface */;
	                case 237 /* ModuleDeclaration */:
	                case 235 /* TypeAliasDeclaration */:
	                case 176 /* MappedType */:
	                    return 1 /* IsContainer */ | 32 /* HasLocals */;
	                case 170 /* ConditionalType */:
	                    return 256 /* IsInferenceContainer */;
	                case 272 /* SourceFile */:
	                    return 1 /* IsContainer */ | 4 /* IsControlFlowContainer */ | 32 /* HasLocals */;
	                case 153 /* MethodDeclaration */:
	                    if (ts.isObjectLiteralOrClassExpressionMethod(node)) {
	                        return 1 /* IsContainer */ | 4 /* IsControlFlowContainer */ | 32 /* HasLocals */ | 8 /* IsFunctionLike */ | 128 /* IsObjectLiteralOrClassExpressionMethod */;
	                    }
	                // falls through
	                case 154 /* Constructor */:
	                case 232 /* FunctionDeclaration */:
	                case 152 /* MethodSignature */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 157 /* CallSignature */:
	                case 280 /* JSDocFunctionType */:
	                case 162 /* FunctionType */:
	                case 158 /* ConstructSignature */:
	                case 159 /* IndexSignature */:
	                case 163 /* ConstructorType */:
	                    return 1 /* IsContainer */ | 4 /* IsControlFlowContainer */ | 32 /* HasLocals */ | 8 /* IsFunctionLike */;
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                    return 1 /* IsContainer */ | 4 /* IsControlFlowContainer */ | 32 /* HasLocals */ | 8 /* IsFunctionLike */ | 16 /* IsFunctionExpression */;
	                case 238 /* ModuleBlock */:
	                    return 4 /* IsControlFlowContainer */;
	                case 151 /* PropertyDeclaration */:
	                    return node.initializer ? 4 /* IsControlFlowContainer */ : 0;
	                case 267 /* CatchClause */:
	                case 218 /* ForStatement */:
	                case 219 /* ForInStatement */:
	                case 220 /* ForOfStatement */:
	                case 239 /* CaseBlock */:
	                    return 2 /* IsBlockScopedContainer */;
	                case 211 /* Block */:
	                    // do not treat blocks directly inside a function as a block-scoped-container.
	                    // Locals that reside in this block should go to the function locals. Otherwise 'x'
	                    // would not appear to be a redeclaration of a block scoped local in the following
	                    // example:
	                    //
	                    //      function foo() {
	                    //          var x;
	                    //          let x;
	                    //      }
	                    //
	                    // If we placed 'var x' into the function locals and 'let x' into the locals of
	                    // the block, then there would be no collision.
	                    //
	                    // By not creating a new block-scoped-container here, we ensure that both 'var x'
	                    // and 'let x' go into the Function-container's locals, and we do get a collision
	                    // conflict.
	                    return ts.isFunctionLike(node.parent) ? 0 /* None */ : 2 /* IsBlockScopedContainer */;
	            }
	            return 0 /* None */;
	        }
	        function addToContainerChain(next) {
	            if (lastContainer) {
	                lastContainer.nextContainer = next;
	            }
	            lastContainer = next;
	        }
	        function declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes) {
	            switch (container.kind) {
	                // Modules, source files, and classes need specialized handling for how their
	                // members are declared (for example, a member of a class will go into a specific
	                // symbol table depending on if it is static or not). We defer to specialized
	                // handlers to take care of declaring these child members.
	                case 237 /* ModuleDeclaration */:
	                    return declareModuleMember(node, symbolFlags, symbolExcludes);
	                case 272 /* SourceFile */:
	                    return declareSourceFileMember(node, symbolFlags, symbolExcludes);
	                case 203 /* ClassExpression */:
	                case 233 /* ClassDeclaration */:
	                    return declareClassMember(node, symbolFlags, symbolExcludes);
	                case 236 /* EnumDeclaration */:
	                    return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
	                case 165 /* TypeLiteral */:
	                case 283 /* JSDocTypeLiteral */:
	                case 182 /* ObjectLiteralExpression */:
	                case 234 /* InterfaceDeclaration */:
	                case 261 /* JsxAttributes */:
	                    // Interface/Object-types always have their children added to the 'members' of
	                    // their container. They are only accessible through an instance of their
	                    // container, and are never in scope otherwise (even inside the body of the
	                    // object / type / interface declaring them). An exception is type parameters,
	                    // which are in scope without qualification (similar to 'locals').
	                    return declareSymbol(container.symbol.members, container.symbol, node, symbolFlags, symbolExcludes);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 159 /* IndexSignature */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 154 /* Constructor */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                case 280 /* JSDocFunctionType */:
	                case 235 /* TypeAliasDeclaration */:
	                case 176 /* MappedType */:
	                    // All the children of these container types are never visible through another
	                    // symbol (i.e. through another symbol's 'exports' or 'members').  Instead,
	                    // they're only accessed 'lexically' (i.e. from code that exists underneath
	                    // their container in the tree). To accomplish this, we simply add their declared
	                    // symbol to the 'locals' of the container.  These symbols can then be found as
	                    // the type checker walks up the containers, checking them for matching names.
	                    return declareSymbol(container.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	            }
	        }
	        function declareClassMember(node, symbolFlags, symbolExcludes) {
	            return ts.hasModifier(node, 32 /* Static */)
	                ? declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes)
	                : declareSymbol(container.symbol.members, container.symbol, node, symbolFlags, symbolExcludes);
	        }
	        function declareSourceFileMember(node, symbolFlags, symbolExcludes) {
	            return ts.isExternalModule(file)
	                ? declareModuleMember(node, symbolFlags, symbolExcludes)
	                : declareSymbol(file.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	        }
	        function hasExportDeclarations(node) {
	            var body = node.kind === 272 /* SourceFile */ ? node : node.body;
	            if (body && (body.kind === 272 /* SourceFile */ || body.kind === 238 /* ModuleBlock */)) {
	                for (var _i = 0, _a = body.statements; _i < _a.length; _i++) {
	                    var stat = _a[_i];
	                    if (stat.kind === 248 /* ExportDeclaration */ || stat.kind === 247 /* ExportAssignment */) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function setExportContextFlag(node) {
	            // A declaration source file or ambient module declaration that contains no export declarations (but possibly regular
	            // declarations with export modifiers) is an export context in which declarations are implicitly exported.
	            if (node.flags & 2097152 /* Ambient */ && !hasExportDeclarations(node)) {
	                node.flags |= 32 /* ExportContext */;
	            }
	            else {
	                node.flags &= ~32 /* ExportContext */;
	            }
	        }
	        function bindModuleDeclaration(node) {
	            setExportContextFlag(node);
	            if (ts.isAmbientModule(node)) {
	                if (ts.hasModifier(node, 1 /* Export */)) {
	                    errorOnFirstToken(node, ts.Diagnostics.export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always_visible);
	                }
	                if (ts.isExternalModuleAugmentation(node)) {
	                    declareModuleSymbol(node);
	                }
	                else {
	                    var pattern = void 0;
	                    if (node.name.kind === 9 /* StringLiteral */) {
	                        var text = node.name.text;
	                        if (ts.hasZeroOrOneAsteriskCharacter(text)) {
	                            pattern = ts.tryParsePattern(text);
	                        }
	                        else {
	                            errorOnFirstToken(node.name, ts.Diagnostics.Pattern_0_can_have_at_most_one_Asterisk_character, text);
	                        }
	                    }
	                    var symbol = declareSymbolAndAddToSymbolTable(node, 512 /* ValueModule */, 106639 /* ValueModuleExcludes */);
	                    if (pattern) {
	                        (file.patternAmbientModules || (file.patternAmbientModules = [])).push({ pattern: pattern, symbol: symbol });
	                    }
	                }
	            }
	            else {
	                var state = declareModuleSymbol(node);
	                if (state !== 0 /* NonInstantiated */) {
	                    var symbol = node.symbol;
	                    // if module was already merged with some function, class or non-const enum, treat it as non-const-enum-only
	                    symbol.constEnumOnlyModule = (!(symbol.flags & (16 /* Function */ | 32 /* Class */ | 256 /* RegularEnum */)))
	                        // Current must be `const enum` only
	                        && state === 2 /* ConstEnumOnly */
	                        // Can't have been set to 'false' in a previous merged symbol. ('undefined' OK)
	                        && symbol.constEnumOnlyModule !== false;
	                }
	            }
	        }
	        function declareModuleSymbol(node) {
	            var state = getModuleInstanceState(node);
	            var instantiated = state !== 0 /* NonInstantiated */;
	            declareSymbolAndAddToSymbolTable(node, instantiated ? 512 /* ValueModule */ : 1024 /* NamespaceModule */, instantiated ? 106639 /* ValueModuleExcludes */ : 0 /* NamespaceModuleExcludes */);
	            return state;
	        }
	        function bindFunctionOrConstructorType(node) {
	            // For a given function symbol "<...>(...) => T" we want to generate a symbol identical
	            // to the one we would get for: { <...>(...): T }
	            //
	            // We do that by making an anonymous type literal symbol, and then setting the function
	            // symbol as its sole member. To the rest of the system, this symbol will be indistinguishable
	            // from an actual type literal symbol you would have gotten had you used the long form.
	            var symbol = createSymbol(131072 /* Signature */, getDeclarationName(node));
	            addDeclarationToSymbol(symbol, node, 131072 /* Signature */);
	            var typeLiteralSymbol = createSymbol(2048 /* TypeLiteral */, "__type" /* Type */);
	            addDeclarationToSymbol(typeLiteralSymbol, node, 2048 /* TypeLiteral */);
	            typeLiteralSymbol.members = ts.createSymbolTable();
	            typeLiteralSymbol.members.set(symbol.escapedName, symbol);
	        }
	        function bindObjectLiteralExpression(node) {
	            var ElementKind;
	            (function (ElementKind) {
	                ElementKind[ElementKind["Property"] = 1] = "Property";
	                ElementKind[ElementKind["Accessor"] = 2] = "Accessor";
	            })(ElementKind || (ElementKind = {}));
	            if (inStrictMode) {
	                var seen = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (prop.kind === 270 /* SpreadAssignment */ || prop.name.kind !== 71 /* Identifier */) {
	                        continue;
	                    }
	                    var identifier = prop.name;
	                    // ECMA-262 11.1.5 Object Initializer
	                    // If previous is not undefined then throw a SyntaxError exception if any of the following conditions are true
	                    // a.This production is contained in strict code and IsDataDescriptor(previous) is true and
	                    // IsDataDescriptor(propId.descriptor) is true.
	                    //    b.IsDataDescriptor(previous) is true and IsAccessorDescriptor(propId.descriptor) is true.
	                    //    c.IsAccessorDescriptor(previous) is true and IsDataDescriptor(propId.descriptor) is true.
	                    //    d.IsAccessorDescriptor(previous) is true and IsAccessorDescriptor(propId.descriptor) is true
	                    // and either both previous and propId.descriptor have[[Get]] fields or both previous and propId.descriptor have[[Set]] fields
	                    var currentKind = prop.kind === 268 /* PropertyAssignment */ || prop.kind === 269 /* ShorthandPropertyAssignment */ || prop.kind === 153 /* MethodDeclaration */
	                        ? 1 /* Property */
	                        : 2 /* Accessor */;
	                    var existingKind = seen.get(identifier.escapedText);
	                    if (!existingKind) {
	                        seen.set(identifier.escapedText, currentKind);
	                        continue;
	                    }
	                    if (currentKind === 1 /* Property */ && existingKind === 1 /* Property */) {
	                        var span_1 = ts.getErrorSpanForNode(file, identifier);
	                        file.bindDiagnostics.push(ts.createFileDiagnostic(file, span_1.start, span_1.length, ts.Diagnostics.An_object_literal_cannot_have_multiple_properties_with_the_same_name_in_strict_mode));
	                    }
	                }
	            }
	            return bindAnonymousDeclaration(node, 4096 /* ObjectLiteral */, "__object" /* Object */);
	        }
	        function bindJsxAttributes(node) {
	            return bindAnonymousDeclaration(node, 4096 /* ObjectLiteral */, "__jsxAttributes" /* JSXAttributes */);
	        }
	        function bindJsxAttribute(node, symbolFlags, symbolExcludes) {
	            return declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes);
	        }
	        function bindAnonymousDeclaration(node, symbolFlags, name) {
	            var symbol = createSymbol(symbolFlags, name);
	            if (symbolFlags & (8 /* EnumMember */ | 106500 /* ClassMember */)) {
	                symbol.parent = container.symbol;
	            }
	            addDeclarationToSymbol(symbol, node, symbolFlags);
	        }
	        function bindBlockScopedDeclaration(node, symbolFlags, symbolExcludes) {
	            switch (blockScopeContainer.kind) {
	                case 237 /* ModuleDeclaration */:
	                    declareModuleMember(node, symbolFlags, symbolExcludes);
	                    break;
	                case 272 /* SourceFile */:
	                    if (ts.isExternalModule(container)) {
	                        declareModuleMember(node, symbolFlags, symbolExcludes);
	                        break;
	                    }
	                // falls through
	                default:
	                    if (!blockScopeContainer.locals) {
	                        blockScopeContainer.locals = ts.createSymbolTable();
	                        addToContainerChain(blockScopeContainer);
	                    }
	                    declareSymbol(blockScopeContainer.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	            }
	        }
	        function bindBlockScopedVariableDeclaration(node) {
	            bindBlockScopedDeclaration(node, 2 /* BlockScopedVariable */, 107455 /* BlockScopedVariableExcludes */);
	        }
	        // The binder visits every node in the syntax tree so it is a convenient place to perform a single localized
	        // check for reserved words used as identifiers in strict mode code.
	        function checkStrictModeIdentifier(node) {
	            if (inStrictMode &&
	                node.originalKeywordKind >= 108 /* FirstFutureReservedWord */ &&
	                node.originalKeywordKind <= 116 /* LastFutureReservedWord */ &&
	                !ts.isIdentifierName(node) &&
	                !(node.flags & 2097152 /* Ambient */)) {
	                // Report error only if there are no parse errors in file
	                if (!file.parseDiagnostics.length) {
	                    file.bindDiagnostics.push(createDiagnosticForNode(node, getStrictModeIdentifierMessage(node), ts.declarationNameToString(node)));
	                }
	            }
	        }
	        function getStrictModeIdentifierMessage(node) {
	            // Provide specialized messages to help the user understand why we think they're in
	            // strict mode.
	            if (ts.getContainingClass(node)) {
	                return ts.Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_strict_mode;
	            }
	            if (file.externalModuleIndicator) {
	                return ts.Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode;
	            }
	            return ts.Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode;
	        }
	        function checkStrictModeBinaryExpression(node) {
	            if (inStrictMode && ts.isLeftHandSideExpression(node.left) && ts.isAssignmentOperator(node.operatorToken.kind)) {
	                // ECMA 262 (Annex C) The identifier eval or arguments may not appear as the LeftHandSideExpression of an
	                // Assignment operator(11.13) or of a PostfixExpression(11.3)
	                checkStrictModeEvalOrArguments(node, node.left);
	            }
	        }
	        function checkStrictModeCatchClause(node) {
	            // It is a SyntaxError if a TryStatement with a Catch occurs within strict code and the Identifier of the
	            // Catch production is eval or arguments
	            if (inStrictMode && node.variableDeclaration) {
	                checkStrictModeEvalOrArguments(node, node.variableDeclaration.name);
	            }
	        }
	        function checkStrictModeDeleteExpression(node) {
	            // Grammar checking
	            if (inStrictMode && node.expression.kind === 71 /* Identifier */) {
	                // When a delete operator occurs within strict mode code, a SyntaxError is thrown if its
	                // UnaryExpression is a direct reference to a variable, function argument, or function name
	                var span_2 = ts.getErrorSpanForNode(file, node.expression);
	                file.bindDiagnostics.push(ts.createFileDiagnostic(file, span_2.start, span_2.length, ts.Diagnostics.delete_cannot_be_called_on_an_identifier_in_strict_mode));
	            }
	        }
	        function isEvalOrArgumentsIdentifier(node) {
	            return ts.isIdentifier(node) && (node.escapedText === "eval" || node.escapedText === "arguments");
	        }
	        function checkStrictModeEvalOrArguments(contextNode, name) {
	            if (name && name.kind === 71 /* Identifier */) {
	                var identifier = name;
	                if (isEvalOrArgumentsIdentifier(identifier)) {
	                    // We check first if the name is inside class declaration or class expression; if so give explicit message
	                    // otherwise report generic error message.
	                    var span_3 = ts.getErrorSpanForNode(file, name);
	                    file.bindDiagnostics.push(ts.createFileDiagnostic(file, span_3.start, span_3.length, getStrictModeEvalOrArgumentsMessage(contextNode), ts.idText(identifier)));
	                }
	            }
	        }
	        function getStrictModeEvalOrArgumentsMessage(node) {
	            // Provide specialized messages to help the user understand why we think they're in
	            // strict mode.
	            if (ts.getContainingClass(node)) {
	                return ts.Diagnostics.Invalid_use_of_0_Class_definitions_are_automatically_in_strict_mode;
	            }
	            if (file.externalModuleIndicator) {
	                return ts.Diagnostics.Invalid_use_of_0_Modules_are_automatically_in_strict_mode;
	            }
	            return ts.Diagnostics.Invalid_use_of_0_in_strict_mode;
	        }
	        function checkStrictModeFunctionName(node) {
	            if (inStrictMode) {
	                // It is a SyntaxError if the identifier eval or arguments appears within a FormalParameterList of a strict mode FunctionDeclaration or FunctionExpression (13.1))
	                checkStrictModeEvalOrArguments(node, node.name);
	            }
	        }
	        function getStrictModeBlockScopeFunctionDeclarationMessage(node) {
	            // Provide specialized messages to help the user understand why we think they're in
	            // strict mode.
	            if (ts.getContainingClass(node)) {
	                return ts.Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_definitions_are_automatically_in_strict_mode;
	            }
	            if (file.externalModuleIndicator) {
	                return ts.Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_are_automatically_in_strict_mode;
	            }
	            return ts.Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5;
	        }
	        function checkStrictModeFunctionDeclaration(node) {
	            if (languageVersion < 2 /* ES2015 */) {
	                // Report error if function is not top level function declaration
	                if (blockScopeContainer.kind !== 272 /* SourceFile */ &&
	                    blockScopeContainer.kind !== 237 /* ModuleDeclaration */ &&
	                    !ts.isFunctionLike(blockScopeContainer)) {
	                    // We check first if the name is inside class declaration or class expression; if so give explicit message
	                    // otherwise report generic error message.
	                    var errorSpan = ts.getErrorSpanForNode(file, node);
	                    file.bindDiagnostics.push(ts.createFileDiagnostic(file, errorSpan.start, errorSpan.length, getStrictModeBlockScopeFunctionDeclarationMessage(node)));
	                }
	            }
	        }
	        function checkStrictModeNumericLiteral(node) {
	            if (inStrictMode && node.numericLiteralFlags & 32 /* Octal */) {
	                file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Octal_literals_are_not_allowed_in_strict_mode));
	            }
	        }
	        function checkStrictModePostfixUnaryExpression(node) {
	            // Grammar checking
	            // The identifier eval or arguments may not appear as the LeftHandSideExpression of an
	            // Assignment operator(11.13) or of a PostfixExpression(11.3) or as the UnaryExpression
	            // operated upon by a Prefix Increment(11.4.4) or a Prefix Decrement(11.4.5) operator.
	            if (inStrictMode) {
	                checkStrictModeEvalOrArguments(node, node.operand);
	            }
	        }
	        function checkStrictModePrefixUnaryExpression(node) {
	            // Grammar checking
	            if (inStrictMode) {
	                if (node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */) {
	                    checkStrictModeEvalOrArguments(node, node.operand);
	                }
	            }
	        }
	        function checkStrictModeWithStatement(node) {
	            // Grammar checking for withStatement
	            if (inStrictMode) {
	                errorOnFirstToken(node, ts.Diagnostics.with_statements_are_not_allowed_in_strict_mode);
	            }
	        }
	        function errorOnFirstToken(node, message, arg0, arg1, arg2) {
	            var span = ts.getSpanOfTokenAtPosition(file, node.pos);
	            file.bindDiagnostics.push(ts.createFileDiagnostic(file, span.start, span.length, message, arg0, arg1, arg2));
	        }
	        function bind(node) {
	            if (!node) {
	                return;
	            }
	            node.parent = parent;
	            var saveInStrictMode = inStrictMode;
	            // Even though in the AST the jsdoc @typedef node belongs to the current node,
	            // its symbol might be in the same scope with the current node's symbol. Consider:
	            //
	            //     /** @typedef {string | number} MyType */
	            //     function foo();
	            //
	            // Here the current node is "foo", which is a container, but the scope of "MyType" should
	            // not be inside "foo". Therefore we always bind @typedef before bind the parent node,
	            // and skip binding this tag later when binding all the other jsdoc tags.
	            if (ts.isInJavaScriptFile(node))
	                bindJSDocTypedefTagIfAny(node);
	            // First we bind declaration nodes to a symbol if possible. We'll both create a symbol
	            // and then potentially add the symbol to an appropriate symbol table. Possible
	            // destination symbol tables are:
	            //
	            //  1) The 'exports' table of the current container's symbol.
	            //  2) The 'members' table of the current container's symbol.
	            //  3) The 'locals' table of the current container.
	            //
	            // However, not all symbols will end up in any of these tables. 'Anonymous' symbols
	            // (like TypeLiterals for example) will not be put in any table.
	            bindWorker(node);
	            // Then we recurse into the children of the node to bind them as well. For certain
	            // symbols we do specialized work when we recurse. For example, we'll keep track of
	            // the current 'container' node when it changes. This helps us know which symbol table
	            // a local should go into for example. Since terminal nodes are known not to have
	            // children, as an optimization we don't process those.
	            if (node.kind > 144 /* LastToken */) {
	                var saveParent = parent;
	                parent = node;
	                var containerFlags = getContainerFlags(node);
	                if (containerFlags === 0 /* None */) {
	                    bindChildren(node);
	                }
	                else {
	                    bindContainer(node, containerFlags);
	                }
	                parent = saveParent;
	            }
	            else if (!skipTransformFlagAggregation && (node.transformFlags & 536870912 /* HasComputedFlags */) === 0) {
	                subtreeTransformFlags |= computeTransformFlagsForNode(node, 0);
	            }
	            inStrictMode = saveInStrictMode;
	        }
	        function bindJSDocTypedefTagIfAny(node) {
	            if (!ts.hasJSDocNodes(node)) {
	                return;
	            }
	            for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                var jsDoc = _a[_i];
	                if (!jsDoc.tags) {
	                    continue;
	                }
	                for (var _b = 0, _c = jsDoc.tags; _b < _c.length; _b++) {
	                    var tag = _c[_b];
	                    if (tag.kind === 291 /* JSDocTypedefTag */) {
	                        var savedParent = parent;
	                        parent = jsDoc;
	                        bind(tag);
	                        parent = savedParent;
	                    }
	                }
	            }
	        }
	        function updateStrictModeStatementList(statements) {
	            if (!inStrictMode) {
	                for (var _i = 0, statements_1 = statements; _i < statements_1.length; _i++) {
	                    var statement = statements_1[_i];
	                    if (!ts.isPrologueDirective(statement)) {
	                        return;
	                    }
	                    if (isUseStrictPrologueDirective(statement)) {
	                        inStrictMode = true;
	                        return;
	                    }
	                }
	            }
	        }
	        /// Should be called only on prologue directives (isPrologueDirective(node) should be true)
	        function isUseStrictPrologueDirective(node) {
	            var nodeText = ts.getTextOfNodeFromSourceText(file.text, node.expression);
	            // Note: the node text must be exactly "use strict" or 'use strict'.  It is not ok for the
	            // string to contain unicode escapes (as per ES5).
	            return nodeText === '"use strict"' || nodeText === "'use strict'";
	        }
	        function bindWorker(node) {
	            switch (node.kind) {
	                /* Strict mode checks */
	                case 71 /* Identifier */:
	                    // for typedef type names with namespaces, bind the new jsdoc type symbol here
	                    // because it requires all containing namespaces to be in effect, namely the
	                    // current "blockScopeContainer" needs to be set to its immediate namespace parent.
	                    if (node.isInJSDocNamespace) {
	                        var parentNode = node.parent;
	                        while (parentNode && parentNode.kind !== 291 /* JSDocTypedefTag */) {
	                            parentNode = parentNode.parent;
	                        }
	                        bindBlockScopedDeclaration(parentNode, 524288 /* TypeAlias */, 793064 /* TypeAliasExcludes */);
	                        break;
	                    }
	                // falls through
	                case 99 /* ThisKeyword */:
	                    if (currentFlow && (ts.isExpression(node) || parent.kind === 269 /* ShorthandPropertyAssignment */)) {
	                        node.flowNode = currentFlow;
	                    }
	                    return checkStrictModeIdentifier(node);
	                case 183 /* PropertyAccessExpression */:
	                    if (currentFlow && isNarrowableReference(node)) {
	                        node.flowNode = currentFlow;
	                    }
	                    if (ts.isSpecialPropertyDeclaration(node)) {
	                        bindSpecialPropertyDeclaration(node);
	                    }
	                    break;
	                case 198 /* BinaryExpression */:
	                    var specialKind = ts.getSpecialPropertyAssignmentKind(node);
	                    switch (specialKind) {
	                        case 1 /* ExportsProperty */:
	                            bindExportsPropertyAssignment(node);
	                            break;
	                        case 2 /* ModuleExports */:
	                            bindModuleExportsAssignment(node);
	                            break;
	                        case 3 /* PrototypeProperty */:
	                            bindPrototypePropertyAssignment(node);
	                            break;
	                        case 4 /* ThisProperty */:
	                            bindThisPropertyAssignment(node);
	                            break;
	                        case 5 /* Property */:
	                            bindStaticPropertyAssignment(node);
	                            break;
	                        case 0 /* None */:
	                            // Nothing to do
	                            break;
	                        default:
	                            ts.Debug.fail("Unknown special property assignment kind");
	                    }
	                    return checkStrictModeBinaryExpression(node);
	                case 267 /* CatchClause */:
	                    return checkStrictModeCatchClause(node);
	                case 192 /* DeleteExpression */:
	                    return checkStrictModeDeleteExpression(node);
	                case 8 /* NumericLiteral */:
	                    return checkStrictModeNumericLiteral(node);
	                case 197 /* PostfixUnaryExpression */:
	                    return checkStrictModePostfixUnaryExpression(node);
	                case 196 /* PrefixUnaryExpression */:
	                    return checkStrictModePrefixUnaryExpression(node);
	                case 224 /* WithStatement */:
	                    return checkStrictModeWithStatement(node);
	                case 173 /* ThisType */:
	                    seenThisKeyword = true;
	                    return;
	                case 160 /* TypePredicate */:
	                    return checkTypePredicate(node);
	                case 147 /* TypeParameter */:
	                    return bindTypeParameter(node);
	                case 148 /* Parameter */:
	                    return bindParameter(node);
	                case 230 /* VariableDeclaration */:
	                    return bindVariableDeclarationOrBindingElement(node);
	                case 180 /* BindingElement */:
	                    node.flowNode = currentFlow;
	                    return bindVariableDeclarationOrBindingElement(node);
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return bindPropertyWorker(node);
	                case 268 /* PropertyAssignment */:
	                case 269 /* ShorthandPropertyAssignment */:
	                    return bindPropertyOrMethodOrAccessor(node, 4 /* Property */, 0 /* PropertyExcludes */);
	                case 271 /* EnumMember */:
	                    return bindPropertyOrMethodOrAccessor(node, 8 /* EnumMember */, 900095 /* EnumMemberExcludes */);
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 159 /* IndexSignature */:
	                    return declareSymbolAndAddToSymbolTable(node, 131072 /* Signature */, 0 /* None */);
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    // If this is an ObjectLiteralExpression method, then it sits in the same space
	                    // as other properties in the object literal.  So we use SymbolFlags.PropertyExcludes
	                    // so that it will conflict with any other object literal members with the same
	                    // name.
	                    return bindPropertyOrMethodOrAccessor(node, 8192 /* Method */ | (node.questionToken ? 16777216 /* Optional */ : 0 /* None */), ts.isObjectLiteralMethod(node) ? 0 /* PropertyExcludes */ : 99263 /* MethodExcludes */);
	                case 232 /* FunctionDeclaration */:
	                    return bindFunctionDeclaration(node);
	                case 154 /* Constructor */:
	                    return declareSymbolAndAddToSymbolTable(node, 16384 /* Constructor */, /*symbolExcludes:*/ 0 /* None */);
	                case 155 /* GetAccessor */:
	                    return bindPropertyOrMethodOrAccessor(node, 32768 /* GetAccessor */, 41919 /* GetAccessorExcludes */);
	                case 156 /* SetAccessor */:
	                    return bindPropertyOrMethodOrAccessor(node, 65536 /* SetAccessor */, 74687 /* SetAccessorExcludes */);
	                case 162 /* FunctionType */:
	                case 280 /* JSDocFunctionType */:
	                case 163 /* ConstructorType */:
	                    return bindFunctionOrConstructorType(node);
	                case 165 /* TypeLiteral */:
	                case 283 /* JSDocTypeLiteral */:
	                case 176 /* MappedType */:
	                    return bindAnonymousTypeWorker(node);
	                case 182 /* ObjectLiteralExpression */:
	                    return bindObjectLiteralExpression(node);
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                    return bindFunctionExpression(node);
	                case 185 /* CallExpression */:
	                    if (ts.isInJavaScriptFile(node)) {
	                        bindCallExpression(node);
	                    }
	                    break;
	                // Members of classes, interfaces, and modules
	                case 203 /* ClassExpression */:
	                case 233 /* ClassDeclaration */:
	                    // All classes are automatically in strict mode in ES6.
	                    inStrictMode = true;
	                    return bindClassLikeDeclaration(node);
	                case 234 /* InterfaceDeclaration */:
	                    return bindBlockScopedDeclaration(node, 64 /* Interface */, 792968 /* InterfaceExcludes */);
	                case 235 /* TypeAliasDeclaration */:
	                    return bindBlockScopedDeclaration(node, 524288 /* TypeAlias */, 793064 /* TypeAliasExcludes */);
	                case 236 /* EnumDeclaration */:
	                    return bindEnumDeclaration(node);
	                case 237 /* ModuleDeclaration */:
	                    return bindModuleDeclaration(node);
	                // Jsx-attributes
	                case 261 /* JsxAttributes */:
	                    return bindJsxAttributes(node);
	                case 260 /* JsxAttribute */:
	                    return bindJsxAttribute(node, 4 /* Property */, 0 /* PropertyExcludes */);
	                // Imports and exports
	                case 241 /* ImportEqualsDeclaration */:
	                case 244 /* NamespaceImport */:
	                case 246 /* ImportSpecifier */:
	                case 250 /* ExportSpecifier */:
	                    return declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */, 2097152 /* AliasExcludes */);
	                case 240 /* NamespaceExportDeclaration */:
	                    return bindNamespaceExportDeclaration(node);
	                case 243 /* ImportClause */:
	                    return bindImportClause(node);
	                case 248 /* ExportDeclaration */:
	                    return bindExportDeclaration(node);
	                case 247 /* ExportAssignment */:
	                    return bindExportAssignment(node);
	                case 272 /* SourceFile */:
	                    updateStrictModeStatementList(node.statements);
	                    return bindSourceFileIfExternalModule();
	                case 211 /* Block */:
	                    if (!ts.isFunctionLike(node.parent)) {
	                        return;
	                    }
	                // falls through
	                case 238 /* ModuleBlock */:
	                    return updateStrictModeStatementList(node.statements);
	                case 287 /* JSDocParameterTag */:
	                    if (node.parent.kind !== 283 /* JSDocTypeLiteral */) {
	                        break;
	                    }
	                // falls through
	                case 292 /* JSDocPropertyTag */:
	                    var propTag = node;
	                    var flags = propTag.isBracketed || propTag.typeExpression && propTag.typeExpression.type.kind === 279 /* JSDocOptionalType */ ?
	                        4 /* Property */ | 16777216 /* Optional */ :
	                        4 /* Property */;
	                    return declareSymbolAndAddToSymbolTable(propTag, flags, 0 /* PropertyExcludes */);
	                case 291 /* JSDocTypedefTag */: {
	                    var fullName = node.fullName;
	                    if (!fullName || fullName.kind === 71 /* Identifier */) {
	                        return bindBlockScopedDeclaration(node, 524288 /* TypeAlias */, 793064 /* TypeAliasExcludes */);
	                    }
	                    break;
	                }
	            }
	        }
	        function bindPropertyWorker(node) {
	            return bindPropertyOrMethodOrAccessor(node, 4 /* Property */ | (node.questionToken ? 16777216 /* Optional */ : 0 /* None */), 0 /* PropertyExcludes */);
	        }
	        function bindAnonymousTypeWorker(node) {
	            return bindAnonymousDeclaration(node, 2048 /* TypeLiteral */, "__type" /* Type */);
	        }
	        function checkTypePredicate(node) {
	            var parameterName = node.parameterName, type = node.type;
	            if (parameterName && parameterName.kind === 71 /* Identifier */) {
	                checkStrictModeIdentifier(parameterName);
	            }
	            if (parameterName && parameterName.kind === 173 /* ThisType */) {
	                seenThisKeyword = true;
	            }
	            bind(type);
	        }
	        function bindSourceFileIfExternalModule() {
	            setExportContextFlag(file);
	            if (ts.isExternalModule(file)) {
	                bindSourceFileAsExternalModule();
	            }
	        }
	        function bindSourceFileAsExternalModule() {
	            bindAnonymousDeclaration(file, 512 /* ValueModule */, "\"" + ts.removeFileExtension(file.fileName) + "\"");
	        }
	        function bindExportAssignment(node) {
	            if (!container.symbol || !container.symbol.exports) {
	                // Export assignment in some sort of block construct
	                bindAnonymousDeclaration(node, 2097152 /* Alias */, getDeclarationName(node));
	            }
	            else {
	                var flags = node.kind === 247 /* ExportAssignment */ && ts.exportAssignmentIsAlias(node)
	                    // An export default clause with an EntityNameExpression exports all meanings of that identifier
	                    ? 2097152 /* Alias */
	                    // An export default clause with any other expression exports a value
	                    : 4 /* Property */;
	                // If there is an `export default x;` alias declaration, can't `export default` anything else.
	                // (In contrast, you can still have `export default function f() {}` and `export default interface I {}`.)
	                declareSymbol(container.symbol.exports, container.symbol, node, flags, 67108863 /* All */);
	            }
	        }
	        function bindNamespaceExportDeclaration(node) {
	            if (node.modifiers && node.modifiers.length) {
	                file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Modifiers_cannot_appear_here));
	            }
	            if (node.parent.kind !== 272 /* SourceFile */) {
	                file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Global_module_exports_may_only_appear_at_top_level));
	                return;
	            }
	            else {
	                var parent_1 = node.parent;
	                if (!ts.isExternalModule(parent_1)) {
	                    file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Global_module_exports_may_only_appear_in_module_files));
	                    return;
	                }
	                if (!parent_1.isDeclarationFile) {
	                    file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Global_module_exports_may_only_appear_in_declaration_files));
	                    return;
	                }
	            }
	            file.symbol.globalExports = file.symbol.globalExports || ts.createSymbolTable();
	            declareSymbol(file.symbol.globalExports, file.symbol, node, 2097152 /* Alias */, 2097152 /* AliasExcludes */);
	        }
	        function bindExportDeclaration(node) {
	            if (!container.symbol || !container.symbol.exports) {
	                // Export * in some sort of block construct
	                bindAnonymousDeclaration(node, 8388608 /* ExportStar */, getDeclarationName(node));
	            }
	            else if (!node.exportClause) {
	                // All export * declarations are collected in an __export symbol
	                declareSymbol(container.symbol.exports, container.symbol, node, 8388608 /* ExportStar */, 0 /* None */);
	            }
	        }
	        function bindImportClause(node) {
	            if (node.name) {
	                declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */, 2097152 /* AliasExcludes */);
	            }
	        }
	        function setCommonJsModuleIndicator(node) {
	            if (!file.commonJsModuleIndicator) {
	                file.commonJsModuleIndicator = node;
	                if (!file.externalModuleIndicator) {
	                    bindSourceFileAsExternalModule();
	                }
	            }
	        }
	        function bindExportsPropertyAssignment(node) {
	            // When we create a property via 'exports.foo = bar', the 'exports.foo' property access
	            // expression is the declaration
	            setCommonJsModuleIndicator(node);
	            declareSymbol(file.symbol.exports, file.symbol, node.left, 4 /* Property */ | 1048576 /* ExportValue */, 0 /* None */);
	        }
	        function bindModuleExportsAssignment(node) {
	            // A common practice in node modules is to set 'export = module.exports = {}', this ensures that 'exports'
	            // is still pointing to 'module.exports'.
	            // We do not want to consider this as 'export=' since a module can have only one of these.
	            // Similarly we do not want to treat 'module.exports = exports' as an 'export='.
	            var assignedExpression = ts.getRightMostAssignedExpression(node.right);
	            if (ts.isEmptyObjectLiteral(assignedExpression) || container === file && isExportsOrModuleExportsOrAlias(file, assignedExpression)) {
	                // Mark it as a module in case there are no other exports in the file
	                setCommonJsModuleIndicator(node);
	                return;
	            }
	            // 'module.exports = expr' assignment
	            setCommonJsModuleIndicator(node);
	            declareSymbol(file.symbol.exports, file.symbol, node, 4 /* Property */ | 1048576 /* ExportValue */ | 512 /* ValueModule */, 0 /* None */);
	        }
	        function bindThisPropertyAssignment(node) {
	            ts.Debug.assert(ts.isInJavaScriptFile(node));
	            var container = ts.getThisContainer(node, /*includeArrowFunctions*/ false);
	            switch (container.kind) {
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                    // Declare a 'member' if the container is an ES5 class or ES6 constructor
	                    container.symbol.members = container.symbol.members || ts.createSymbolTable();
	                    // It's acceptable for multiple 'this' assignments of the same identifier to occur
	                    declareSymbol(container.symbol.members, container.symbol, node, 4 /* Property */, 0 /* PropertyExcludes */ & ~4 /* Property */);
	                    break;
	                case 154 /* Constructor */:
	                case 151 /* PropertyDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    // this.foo assignment in a JavaScript class
	                    // Bind this property to the containing class
	                    var containingClass = container.parent;
	                    var symbolTable = ts.hasModifier(container, 32 /* Static */) ? containingClass.symbol.exports : containingClass.symbol.members;
	                    declareSymbol(symbolTable, containingClass.symbol, node, 4 /* Property */, 0 /* None */, /*isReplaceableByMethod*/ true);
	                    break;
	            }
	        }
	        function bindSpecialPropertyDeclaration(node) {
	            ts.Debug.assert(ts.isInJavaScriptFile(node));
	            if (node.expression.kind === 99 /* ThisKeyword */) {
	                bindThisPropertyAssignment(node);
	            }
	            else if ((node.expression.kind === 71 /* Identifier */ || node.expression.kind === 183 /* PropertyAccessExpression */) &&
	                node.parent.parent.kind === 272 /* SourceFile */) {
	                bindStaticPropertyAssignment(node);
	            }
	        }
	        function bindPrototypePropertyAssignment(node) {
	            // We saw a node of the form 'x.prototype.y = z'. Declare a 'member' y on x if x is a function or class, or not declared.
	            // Look up the function in the local scope, since prototype assignments should
	            // follow the function declaration
	            var leftSideOfAssignment = node.left;
	            var classPrototype = leftSideOfAssignment.expression;
	            var constructorFunction = classPrototype.expression;
	            // Fix up parent pointers since we're going to use these nodes before we bind into them
	            leftSideOfAssignment.parent = node;
	            constructorFunction.parent = classPrototype;
	            classPrototype.parent = leftSideOfAssignment;
	            bindPropertyAssignment(constructorFunction.escapedText, leftSideOfAssignment, /*isPrototypeProperty*/ true);
	        }
	        /**
	         * For nodes like `x.y = z`, declare a member 'y' on 'x' if x is a function or class, or not declared.
	         * Also works for expression statements preceded by JSDoc, like / ** @type number * / x.y;
	         */
	        function bindStaticPropertyAssignment(node) {
	            // Look up the function in the local scope, since static assignments should
	            // follow the function declaration
	            var leftSideOfAssignment = node.kind === 183 /* PropertyAccessExpression */ ? node : node.left;
	            var target = leftSideOfAssignment.expression;
	            if (ts.isIdentifier(target)) {
	                // Fix up parent pointers since we're going to use these nodes before we bind into them
	                target.parent = leftSideOfAssignment;
	                if (node.kind === 198 /* BinaryExpression */) {
	                    leftSideOfAssignment.parent = node;
	                }
	                if (container === file && isNameOfExportsOrModuleExportsAliasDeclaration(file, target)) {
	                    // This can be an alias for the 'exports' or 'module.exports' names, e.g.
	                    //    var util = module.exports;
	                    //    util.property = function ...
	                    bindExportsPropertyAssignment(node);
	                }
	                else {
	                    bindPropertyAssignment(target.escapedText, leftSideOfAssignment, /*isPrototypeProperty*/ false);
	                }
	            }
	        }
	        function lookupSymbolForName(name) {
	            return lookupSymbolForNameWorker(container, name);
	        }
	        function bindPropertyAssignment(functionName, propertyAccess, isPrototypeProperty) {
	            var symbol = lookupSymbolForName(functionName);
	            var targetSymbol = symbol && ts.isDeclarationOfFunctionOrClassExpression(symbol) ?
	                symbol.valueDeclaration.initializer.symbol :
	                symbol;
	            ts.Debug.assert(propertyAccess.parent.kind === 198 /* BinaryExpression */ || propertyAccess.parent.kind === 214 /* ExpressionStatement */);
	            var isLegalPosition;
	            if (propertyAccess.parent.kind === 198 /* BinaryExpression */) {
	                var initializerKind = propertyAccess.parent.right.kind;
	                isLegalPosition = (initializerKind === 203 /* ClassExpression */ || initializerKind === 190 /* FunctionExpression */) &&
	                    propertyAccess.parent.parent.parent.kind === 272 /* SourceFile */;
	            }
	            else {
	                isLegalPosition = propertyAccess.parent.parent.kind === 272 /* SourceFile */;
	            }
	            if (!isPrototypeProperty && (!targetSymbol || !(targetSymbol.flags & 1920 /* Namespace */)) && isLegalPosition) {
	                ts.Debug.assert(ts.isIdentifier(propertyAccess.expression));
	                var identifier = propertyAccess.expression;
	                var flags = 1536 /* Module */ | 67108864 /* JSContainer */;
	                var excludeFlags = 106639 /* ValueModuleExcludes */ & ~67108864 /* JSContainer */;
	                if (targetSymbol) {
	                    addDeclarationToSymbol(symbol, identifier, flags);
	                }
	                else {
	                    targetSymbol = declareSymbol(container.locals, /*parent*/ undefined, identifier, flags, excludeFlags);
	                }
	            }
	            if (!targetSymbol || !(targetSymbol.flags & (16 /* Function */ | 32 /* Class */ | 1024 /* NamespaceModule */))) {
	                return;
	            }
	            // Set up the members collection if it doesn't exist already
	            var symbolTable = isPrototypeProperty ?
	                (targetSymbol.members || (targetSymbol.members = ts.createSymbolTable())) :
	                (targetSymbol.exports || (targetSymbol.exports = ts.createSymbolTable()));
	            // Declare the method/property
	            declareSymbol(symbolTable, targetSymbol, propertyAccess, 4 /* Property */, 0 /* PropertyExcludes */);
	        }
	        function bindCallExpression(node) {
	            // We're only inspecting call expressions to detect CommonJS modules, so we can skip
	            // this check if we've already seen the module indicator
	            if (!file.commonJsModuleIndicator && ts.isRequireCall(node, /*checkArgumentIsStringLiteral*/ false)) {
	                setCommonJsModuleIndicator(node);
	            }
	        }
	        function bindClassLikeDeclaration(node) {
	            if (node.kind === 233 /* ClassDeclaration */) {
	                bindBlockScopedDeclaration(node, 32 /* Class */, 899519 /* ClassExcludes */);
	            }
	            else {
	                var bindingName = node.name ? node.name.escapedText : "__class" /* Class */;
	                bindAnonymousDeclaration(node, 32 /* Class */, bindingName);
	                // Add name of class expression into the map for semantic classifier
	                if (node.name) {
	                    classifiableNames.set(node.name.escapedText, true);
	                }
	            }
	            var symbol = node.symbol;
	            // TypeScript 1.0 spec (April 2014): 8.4
	            // Every class automatically contains a static property member named 'prototype', the
	            // type of which is an instantiation of the class type with type Any supplied as a type
	            // argument for each type parameter. It is an error to explicitly declare a static
	            // property member with the name 'prototype'.
	            //
	            // Note: we check for this here because this class may be merging into a module.  The
	            // module might have an exported variable called 'prototype'.  We can't allow that as
	            // that would clash with the built-in 'prototype' for the class.
	            var prototypeSymbol = createSymbol(4 /* Property */ | 4194304 /* Prototype */, "prototype");
	            var symbolExport = symbol.exports.get(prototypeSymbol.escapedName);
	            if (symbolExport) {
	                if (node.name) {
	                    node.name.parent = node;
	                }
	                file.bindDiagnostics.push(createDiagnosticForNode(symbolExport.declarations[0], ts.Diagnostics.Duplicate_identifier_0, ts.symbolName(prototypeSymbol)));
	            }
	            symbol.exports.set(prototypeSymbol.escapedName, prototypeSymbol);
	            prototypeSymbol.parent = symbol;
	        }
	        function bindEnumDeclaration(node) {
	            return ts.isConst(node)
	                ? bindBlockScopedDeclaration(node, 128 /* ConstEnum */, 899967 /* ConstEnumExcludes */)
	                : bindBlockScopedDeclaration(node, 256 /* RegularEnum */, 899327 /* RegularEnumExcludes */);
	        }
	        function bindVariableDeclarationOrBindingElement(node) {
	            if (inStrictMode) {
	                checkStrictModeEvalOrArguments(node, node.name);
	            }
	            if (!ts.isBindingPattern(node.name)) {
	                if (ts.isBlockOrCatchScoped(node)) {
	                    bindBlockScopedVariableDeclaration(node);
	                }
	                else if (ts.isParameterDeclaration(node)) {
	                    // It is safe to walk up parent chain to find whether the node is a destructing parameter declaration
	                    // because its parent chain has already been set up, since parents are set before descending into children.
	                    //
	                    // If node is a binding element in parameter declaration, we need to use ParameterExcludes.
	                    // Using ParameterExcludes flag allows the compiler to report an error on duplicate identifiers in Parameter Declaration
	                    // For example:
	                    //      function foo([a,a]) {} // Duplicate Identifier error
	                    //      function bar(a,a) {}   // Duplicate Identifier error, parameter declaration in this case is handled in bindParameter
	                    //                             // which correctly set excluded symbols
	                    declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */, 107455 /* ParameterExcludes */);
	                }
	                else {
	                    declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */, 107454 /* FunctionScopedVariableExcludes */);
	                }
	            }
	        }
	        function bindParameter(node) {
	            if (inStrictMode && !(node.flags & 2097152 /* Ambient */)) {
	                // It is a SyntaxError if the identifier eval or arguments appears within a FormalParameterList of a
	                // strict mode FunctionLikeDeclaration or FunctionExpression(13.1)
	                checkStrictModeEvalOrArguments(node, node.name);
	            }
	            if (ts.isBindingPattern(node.name)) {
	                bindAnonymousDeclaration(node, 1 /* FunctionScopedVariable */, "__" + node.parent.parameters.indexOf(node));
	            }
	            else {
	                declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */, 107455 /* ParameterExcludes */);
	            }
	            // If this is a property-parameter, then also declare the property symbol into the
	            // containing class.
	            if (ts.isParameterPropertyDeclaration(node)) {
	                var classDeclaration = node.parent.parent;
	                declareSymbol(classDeclaration.symbol.members, classDeclaration.symbol, node, 4 /* Property */ | (node.questionToken ? 16777216 /* Optional */ : 0 /* None */), 0 /* PropertyExcludes */);
	            }
	        }
	        function bindFunctionDeclaration(node) {
	            if (!file.isDeclarationFile && !(node.flags & 2097152 /* Ambient */)) {
	                if (ts.isAsyncFunction(node)) {
	                    emitFlags |= 1024 /* HasAsyncFunctions */;
	                }
	            }
	            checkStrictModeFunctionName(node);
	            if (inStrictMode) {
	                checkStrictModeFunctionDeclaration(node);
	                bindBlockScopedDeclaration(node, 16 /* Function */, 106927 /* FunctionExcludes */);
	            }
	            else {
	                declareSymbolAndAddToSymbolTable(node, 16 /* Function */, 106927 /* FunctionExcludes */);
	            }
	        }
	        function bindFunctionExpression(node) {
	            if (!file.isDeclarationFile && !(node.flags & 2097152 /* Ambient */)) {
	                if (ts.isAsyncFunction(node)) {
	                    emitFlags |= 1024 /* HasAsyncFunctions */;
	                }
	            }
	            if (currentFlow) {
	                node.flowNode = currentFlow;
	            }
	            checkStrictModeFunctionName(node);
	            var bindingName = node.name ? node.name.escapedText : "__function" /* Function */;
	            return bindAnonymousDeclaration(node, 16 /* Function */, bindingName);
	        }
	        function bindPropertyOrMethodOrAccessor(node, symbolFlags, symbolExcludes) {
	            if (!file.isDeclarationFile && !(node.flags & 2097152 /* Ambient */) && ts.isAsyncFunction(node)) {
	                emitFlags |= 1024 /* HasAsyncFunctions */;
	            }
	            if (currentFlow && ts.isObjectLiteralOrClassExpressionMethod(node)) {
	                node.flowNode = currentFlow;
	            }
	            return ts.hasDynamicName(node)
	                ? bindAnonymousDeclaration(node, symbolFlags, "__computed" /* Computed */)
	                : declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes);
	        }
	        function bindTypeParameter(node) {
	            if (node.parent.kind === 171 /* InferType */) {
	                if (inferenceContainer) {
	                    if (!inferenceContainer.locals) {
	                        inferenceContainer.locals = ts.createSymbolTable();
	                    }
	                    declareSymbol(inferenceContainer.locals, /*parent*/ undefined, node, 262144 /* TypeParameter */, 530920 /* TypeParameterExcludes */);
	                }
	                else {
	                    bindAnonymousDeclaration(node, 262144 /* TypeParameter */, getDeclarationName(node));
	                }
	            }
	            else {
	                declareSymbolAndAddToSymbolTable(node, 262144 /* TypeParameter */, 530920 /* TypeParameterExcludes */);
	            }
	        }
	        // reachability checks
	        function shouldReportErrorOnModuleDeclaration(node) {
	            var instanceState = getModuleInstanceState(node);
	            return instanceState === 1 /* Instantiated */ || (instanceState === 2 /* ConstEnumOnly */ && options.preserveConstEnums);
	        }
	        function checkUnreachable(node) {
	            if (!(currentFlow.flags & 1 /* Unreachable */)) {
	                return false;
	            }
	            if (currentFlow === unreachableFlow) {
	                var reportError = 
	                // report error on all statements except empty ones
	                (ts.isStatementButNotDeclaration(node) && node.kind !== 213 /* EmptyStatement */) ||
	                    // report error on class declarations
	                    node.kind === 233 /* ClassDeclaration */ ||
	                    // report error on instantiated modules or const-enums only modules if preserveConstEnums is set
	                    (node.kind === 237 /* ModuleDeclaration */ && shouldReportErrorOnModuleDeclaration(node)) ||
	                    // report error on regular enums and const enums if preserveConstEnums is set
	                    (node.kind === 236 /* EnumDeclaration */ && (!ts.isConstEnumDeclaration(node) || options.preserveConstEnums));
	                if (reportError) {
	                    currentFlow = reportedUnreachableFlow;
	                    // unreachable code is reported if
	                    // - user has explicitly asked about it AND
	                    // - statement is in not ambient context (statements in ambient context is already an error
	                    //   so we should not report extras) AND
	                    //   - node is not variable statement OR
	                    //   - node is block scoped variable statement OR
	                    //   - node is not block scoped variable statement and at least one variable declaration has initializer
	                    //   Rationale: we don't want to report errors on non-initialized var's since they are hoisted
	                    //   On the other side we do want to report errors on non-initialized 'lets' because of TDZ
	                    var reportUnreachableCode = !options.allowUnreachableCode &&
	                        !(node.flags & 2097152 /* Ambient */) &&
	                        (node.kind !== 212 /* VariableStatement */ ||
	                            ts.getCombinedNodeFlags(node.declarationList) & 3 /* BlockScoped */ ||
	                            ts.forEach(node.declarationList.declarations, function (d) { return d.initializer; }));
	                    if (reportUnreachableCode) {
	                        errorOnFirstToken(node, ts.Diagnostics.Unreachable_code_detected);
	                    }
	                }
	            }
	            return true;
	        }
	    }
	    /* @internal */
	    function isExportsOrModuleExportsOrAlias(sourceFile, node) {
	        return ts.isExportsIdentifier(node) ||
	            ts.isModuleExportsPropertyAccessExpression(node) ||
	            ts.isIdentifier(node) && isNameOfExportsOrModuleExportsAliasDeclaration(sourceFile, node);
	    }
	    ts.isExportsOrModuleExportsOrAlias = isExportsOrModuleExportsOrAlias;
	    function isNameOfExportsOrModuleExportsAliasDeclaration(sourceFile, node) {
	        var symbol = lookupSymbolForNameWorker(sourceFile, node.escapedText);
	        return symbol && symbol.valueDeclaration && ts.isVariableDeclaration(symbol.valueDeclaration) &&
	            symbol.valueDeclaration.initializer && isExportsOrModuleExportsOrAliasOrAssignment(sourceFile, symbol.valueDeclaration.initializer);
	    }
	    function isExportsOrModuleExportsOrAliasOrAssignment(sourceFile, node) {
	        return isExportsOrModuleExportsOrAlias(sourceFile, node) ||
	            (ts.isAssignmentExpression(node, /*excludeCompoundAssignements*/ true) && (isExportsOrModuleExportsOrAliasOrAssignment(sourceFile, node.left) || isExportsOrModuleExportsOrAliasOrAssignment(sourceFile, node.right)));
	    }
	    function lookupSymbolForNameWorker(container, name) {
	        var local = container.locals && container.locals.get(name);
	        if (local) {
	            return local.exportSymbol || local;
	        }
	        return container.symbol && container.symbol.exports && container.symbol.exports.get(name);
	    }
	    /**
	     * Computes the transform flags for a node, given the transform flags of its subtree
	     *
	     * @param node The node to analyze
	     * @param subtreeFlags Transform flags computed for this node's subtree
	     */
	    function computeTransformFlagsForNode(node, subtreeFlags) {
	        var kind = node.kind;
	        switch (kind) {
	            case 185 /* CallExpression */:
	                return computeCallExpression(node, subtreeFlags);
	            case 186 /* NewExpression */:
	                return computeNewExpression(node, subtreeFlags);
	            case 237 /* ModuleDeclaration */:
	                return computeModuleDeclaration(node, subtreeFlags);
	            case 189 /* ParenthesizedExpression */:
	                return computeParenthesizedExpression(node, subtreeFlags);
	            case 198 /* BinaryExpression */:
	                return computeBinaryExpression(node, subtreeFlags);
	            case 214 /* ExpressionStatement */:
	                return computeExpressionStatement(node, subtreeFlags);
	            case 148 /* Parameter */:
	                return computeParameter(node, subtreeFlags);
	            case 191 /* ArrowFunction */:
	                return computeArrowFunction(node, subtreeFlags);
	            case 190 /* FunctionExpression */:
	                return computeFunctionExpression(node, subtreeFlags);
	            case 232 /* FunctionDeclaration */:
	                return computeFunctionDeclaration(node, subtreeFlags);
	            case 230 /* VariableDeclaration */:
	                return computeVariableDeclaration(node, subtreeFlags);
	            case 231 /* VariableDeclarationList */:
	                return computeVariableDeclarationList(node, subtreeFlags);
	            case 212 /* VariableStatement */:
	                return computeVariableStatement(node, subtreeFlags);
	            case 226 /* LabeledStatement */:
	                return computeLabeledStatement(node, subtreeFlags);
	            case 233 /* ClassDeclaration */:
	                return computeClassDeclaration(node, subtreeFlags);
	            case 203 /* ClassExpression */:
	                return computeClassExpression(node, subtreeFlags);
	            case 266 /* HeritageClause */:
	                return computeHeritageClause(node, subtreeFlags);
	            case 267 /* CatchClause */:
	                return computeCatchClause(node, subtreeFlags);
	            case 205 /* ExpressionWithTypeArguments */:
	                return computeExpressionWithTypeArguments(node, subtreeFlags);
	            case 154 /* Constructor */:
	                return computeConstructor(node, subtreeFlags);
	            case 151 /* PropertyDeclaration */:
	                return computePropertyDeclaration(node, subtreeFlags);
	            case 153 /* MethodDeclaration */:
	                return computeMethod(node, subtreeFlags);
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return computeAccessor(node, subtreeFlags);
	            case 241 /* ImportEqualsDeclaration */:
	                return computeImportEquals(node, subtreeFlags);
	            case 183 /* PropertyAccessExpression */:
	                return computePropertyAccess(node, subtreeFlags);
	            case 184 /* ElementAccessExpression */:
	                return computeElementAccess(node, subtreeFlags);
	            default:
	                return computeOther(node, kind, subtreeFlags);
	        }
	    }
	    ts.computeTransformFlagsForNode = computeTransformFlagsForNode;
	    function computeCallExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var expression = node.expression;
	        if (node.typeArguments) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        if (subtreeFlags & 524288 /* ContainsSpread */
	            || (expression.transformFlags & (134217728 /* Super */ | 268435456 /* ContainsSuper */))) {
	            // If the this node contains a SpreadExpression, or is a super call, then it is an ES6
	            // node.
	            transformFlags |= 192 /* AssertES2015 */;
	            // super property or element accesses could be inside lambdas, etc, and need a captured `this`,
	            // while super keyword for super calls (indicated by TransformFlags.Super) does not (since it can only be top-level in a constructor)
	            if (expression.transformFlags & 268435456 /* ContainsSuper */) {
	                transformFlags |= 16384 /* ContainsLexicalThis */;
	            }
	        }
	        if (expression.kind === 91 /* ImportKeyword */) {
	            transformFlags |= 67108864 /* ContainsDynamicImport */;
	            // A dynamic 'import()' call that contains a lexical 'this' will
	            // require a captured 'this' when emitting down-level.
	            if (subtreeFlags & 16384 /* ContainsLexicalThis */) {
	                transformFlags |= 32768 /* ContainsCapturedLexicalThis */;
	            }
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~940049729 /* ArrayLiteralOrCallOrNewExcludes */;
	    }
	    function computeNewExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        if (node.typeArguments) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        if (subtreeFlags & 524288 /* ContainsSpread */) {
	            // If the this node contains a SpreadElementExpression then it is an ES6
	            // node.
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~940049729 /* ArrayLiteralOrCallOrNewExcludes */;
	    }
	    function computeBinaryExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var operatorTokenKind = node.operatorToken.kind;
	        var leftKind = node.left.kind;
	        if (operatorTokenKind === 58 /* EqualsToken */ && leftKind === 182 /* ObjectLiteralExpression */) {
	            // Destructuring object assignments with are ES2015 syntax
	            // and possibly ESNext if they contain rest
	            transformFlags |= 8 /* AssertESNext */ | 192 /* AssertES2015 */ | 3072 /* AssertDestructuringAssignment */;
	        }
	        else if (operatorTokenKind === 58 /* EqualsToken */ && leftKind === 181 /* ArrayLiteralExpression */) {
	            // Destructuring assignments are ES2015 syntax.
	            transformFlags |= 192 /* AssertES2015 */ | 3072 /* AssertDestructuringAssignment */;
	        }
	        else if (operatorTokenKind === 40 /* AsteriskAsteriskToken */
	            || operatorTokenKind === 62 /* AsteriskAsteriskEqualsToken */) {
	            // Exponentiation is ES2016 syntax.
	            transformFlags |= 32 /* AssertES2016 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeParameter(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var name = node.name;
	        var initializer = node.initializer;
	        var dotDotDotToken = node.dotDotDotToken;
	        // The '?' token, type annotations, decorators, and 'this' parameters are TypeSCript
	        // syntax.
	        if (node.questionToken
	            || node.type
	            || subtreeFlags & 4096 /* ContainsDecorators */
	            || ts.isThisIdentifier(name)) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // If a parameter has an accessibility modifier, then it is TypeScript syntax.
	        if (ts.hasModifier(node, 92 /* ParameterPropertyModifier */)) {
	            transformFlags |= 3 /* AssertTypeScript */ | 262144 /* ContainsParameterPropertyAssignments */;
	        }
	        // parameters with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // If a parameter has an initializer, a binding pattern or a dotDotDot token, then
	        // it is ES6 syntax and its container must emit default value assignments or parameter destructuring downlevel.
	        if (subtreeFlags & 8388608 /* ContainsBindingPattern */ || initializer || dotDotDotToken) {
	            transformFlags |= 192 /* AssertES2015 */ | 131072 /* ContainsDefaultValueAssignments */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* ParameterExcludes */;
	    }
	    function computeParenthesizedExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var expression = node.expression;
	        var expressionKind = expression.kind;
	        var expressionTransformFlags = expression.transformFlags;
	        // If the node is synthesized, it means the emitter put the parentheses there,
	        // not the user. If we didn't want them, the emitter would not have put them
	        // there.
	        if (expressionKind === 206 /* AsExpression */
	            || expressionKind === 188 /* TypeAssertionExpression */) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // If the expression of a ParenthesizedExpression is a destructuring assignment,
	        // then the ParenthesizedExpression is a destructuring assignment.
	        if (expressionTransformFlags & 1024 /* DestructuringAssignment */) {
	            transformFlags |= 1024 /* DestructuringAssignment */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~536872257 /* OuterExpressionExcludes */;
	    }
	    function computeClassDeclaration(node, subtreeFlags) {
	        var transformFlags;
	        if (ts.hasModifier(node, 2 /* Ambient */)) {
	            // An ambient declaration is TypeScript syntax.
	            transformFlags = 3 /* AssertTypeScript */;
	        }
	        else {
	            // A ClassDeclaration is ES6 syntax.
	            transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	            // A class with a parameter property assignment, property initializer, or decorator is
	            // TypeScript syntax.
	            // An exported declaration may be TypeScript syntax, but is handled by the visitor
	            // for a namespace declaration.
	            if ((subtreeFlags & 274432 /* TypeScriptClassSyntaxMask */)
	                || node.typeParameters) {
	                transformFlags |= 3 /* AssertTypeScript */;
	            }
	            if (subtreeFlags & 65536 /* ContainsLexicalThisInComputedPropertyName */) {
	                // A computed property name containing `this` might need to be rewritten,
	                // so propagate the ContainsLexicalThis flag upward.
	                transformFlags |= 16384 /* ContainsLexicalThis */;
	            }
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~942011713 /* ClassExcludes */;
	    }
	    function computeClassExpression(node, subtreeFlags) {
	        // A ClassExpression is ES6 syntax.
	        var transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	        // A class with a parameter property assignment, property initializer, or decorator is
	        // TypeScript syntax.
	        if (subtreeFlags & 274432 /* TypeScriptClassSyntaxMask */
	            || node.typeParameters) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        if (subtreeFlags & 65536 /* ContainsLexicalThisInComputedPropertyName */) {
	            // A computed property name containing `this` might need to be rewritten,
	            // so propagate the ContainsLexicalThis flag upward.
	            transformFlags |= 16384 /* ContainsLexicalThis */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~942011713 /* ClassExcludes */;
	    }
	    function computeHeritageClause(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        switch (node.token) {
	            case 85 /* ExtendsKeyword */:
	                // An `extends` HeritageClause is ES6 syntax.
	                transformFlags |= 192 /* AssertES2015 */;
	                break;
	            case 108 /* ImplementsKeyword */:
	                // An `implements` HeritageClause is TypeScript syntax.
	                transformFlags |= 3 /* AssertTypeScript */;
	                break;
	            default:
	                ts.Debug.fail("Unexpected token for heritage clause");
	                break;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeCatchClause(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        if (!node.variableDeclaration) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        else if (ts.isBindingPattern(node.variableDeclaration.name)) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~940574017 /* CatchClauseExcludes */;
	    }
	    function computeExpressionWithTypeArguments(node, subtreeFlags) {
	        // An ExpressionWithTypeArguments is ES6 syntax, as it is used in the
	        // extends clause of a class.
	        var transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	        // If an ExpressionWithTypeArguments contains type arguments, then it
	        // is TypeScript syntax.
	        if (node.typeArguments) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeConstructor(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // TypeScript-specific modifiers and overloads are TypeScript syntax
	        if (ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || !node.body) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // function declarations with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003668801 /* ConstructorExcludes */;
	    }
	    function computeMethod(node, subtreeFlags) {
	        // A MethodDeclaration is ES6 syntax.
	        var transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	        // Decorators, TypeScript-specific modifiers, type parameters, type annotations, and
	        // overloads are TypeScript syntax.
	        if (node.decorators
	            || ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || node.typeParameters
	            || node.type
	            || (node.name && ts.isComputedPropertyName(node.name)) // While computed method names aren't typescript, the TS transform must visit them to emit property declarations correctly
	            || !node.body) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // function declarations with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // An async method declaration is ES2017 syntax.
	        if (ts.hasModifier(node, 256 /* Async */)) {
	            transformFlags |= node.asteriskToken ? 8 /* AssertESNext */ : 16 /* AssertES2017 */;
	        }
	        if (node.asteriskToken) {
	            transformFlags |= 768 /* AssertGenerator */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003668801 /* MethodOrAccessorExcludes */;
	    }
	    function computeAccessor(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // Decorators, TypeScript-specific modifiers, type annotations, and overloads are
	        // TypeScript syntax.
	        if (node.decorators
	            || ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || node.type
	            || (node.name && ts.isComputedPropertyName(node.name)) // While computed accessor names aren't typescript, the TS transform must visit them to emit property declarations correctly
	            || !node.body) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // function declarations with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003668801 /* MethodOrAccessorExcludes */;
	    }
	    function computePropertyDeclaration(node, subtreeFlags) {
	        // A PropertyDeclaration is TypeScript syntax.
	        var transformFlags = subtreeFlags | 3 /* AssertTypeScript */;
	        // If the PropertyDeclaration has an initializer, we need to inform its ancestor
	        // so that it handle the transformation.
	        if (node.initializer) {
	            transformFlags |= 8192 /* ContainsPropertyInitializer */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeFunctionDeclaration(node, subtreeFlags) {
	        var transformFlags;
	        var modifierFlags = ts.getModifierFlags(node);
	        var body = node.body;
	        if (!body || (modifierFlags & 2 /* Ambient */)) {
	            // An ambient declaration is TypeScript syntax.
	            // A FunctionDeclaration without a body is an overload and is TypeScript syntax.
	            transformFlags = 3 /* AssertTypeScript */;
	        }
	        else {
	            transformFlags = subtreeFlags | 33554432 /* ContainsHoistedDeclarationOrCompletion */;
	            // TypeScript-specific modifiers, type parameters, and type annotations are TypeScript
	            // syntax.
	            if (modifierFlags & 2270 /* TypeScriptModifier */
	                || node.typeParameters
	                || node.type) {
	                transformFlags |= 3 /* AssertTypeScript */;
	            }
	            // An async function declaration is ES2017 syntax.
	            if (modifierFlags & 256 /* Async */) {
	                transformFlags |= node.asteriskToken ? 8 /* AssertESNext */ : 16 /* AssertES2017 */;
	            }
	            // function declarations with object rest destructuring are ES Next syntax
	            if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	                transformFlags |= 8 /* AssertESNext */;
	            }
	            // If a FunctionDeclaration's subtree has marked the container as needing to capture the
	            // lexical this, or the function contains parameters with initializers, then this node is
	            // ES6 syntax.
	            if (subtreeFlags & 163840 /* ES2015FunctionSyntaxMask */) {
	                transformFlags |= 192 /* AssertES2015 */;
	            }
	            // If a FunctionDeclaration is generator function and is the body of a
	            // transformed async function, then this node can be transformed to a
	            // down-level generator.
	            // Currently we do not support transforming any other generator fucntions
	            // down level.
	            if (node.asteriskToken) {
	                transformFlags |= 768 /* AssertGenerator */;
	            }
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003935041 /* FunctionExcludes */;
	    }
	    function computeFunctionExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // TypeScript-specific modifiers, type parameters, and type annotations are TypeScript
	        // syntax.
	        if (ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || node.typeParameters
	            || node.type) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // An async function expression is ES2017 syntax.
	        if (ts.hasModifier(node, 256 /* Async */)) {
	            transformFlags |= node.asteriskToken ? 8 /* AssertESNext */ : 16 /* AssertES2017 */;
	        }
	        // function expressions with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // If a FunctionExpression's subtree has marked the container as needing to capture the
	        // lexical this, or the function contains parameters with initializers, then this node is
	        // ES6 syntax.
	        if (subtreeFlags & 163840 /* ES2015FunctionSyntaxMask */) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        // If a FunctionExpression is generator function and is the body of a
	        // transformed async function, then this node can be transformed to a
	        // down-level generator.
	        if (node.asteriskToken) {
	            transformFlags |= 768 /* AssertGenerator */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003935041 /* FunctionExcludes */;
	    }
	    function computeArrowFunction(node, subtreeFlags) {
	        // An ArrowFunction is ES6 syntax, and excludes markers that should not escape the scope of an ArrowFunction.
	        var transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	        // TypeScript-specific modifiers, type parameters, and type annotations are TypeScript
	        // syntax.
	        if (ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || node.typeParameters
	            || node.type) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // An async arrow function is ES2017 syntax.
	        if (ts.hasModifier(node, 256 /* Async */)) {
	            transformFlags |= 16 /* AssertES2017 */;
	        }
	        // arrow functions with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // If an ArrowFunction contains a lexical this, its container must capture the lexical this.
	        if (subtreeFlags & 16384 /* ContainsLexicalThis */) {
	            transformFlags |= 32768 /* ContainsCapturedLexicalThis */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003902273 /* ArrowFunctionExcludes */;
	    }
	    function computePropertyAccess(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // If a PropertyAccessExpression starts with a super keyword, then it is
	        // ES6 syntax, and requires a lexical `this` binding.
	        if (transformFlags & 134217728 /* Super */) {
	            transformFlags ^= 134217728 /* Super */;
	            transformFlags |= 268435456 /* ContainsSuper */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~671089985 /* PropertyAccessExcludes */;
	    }
	    function computeElementAccess(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var expression = node.expression;
	        var expressionFlags = expression.transformFlags; // We do not want to aggregate flags from the argument expression for super/this capturing
	        // If an ElementAccessExpression starts with a super keyword, then it is
	        // ES6 syntax, and requires a lexical `this` binding.
	        if (expressionFlags & 134217728 /* Super */) {
	            transformFlags &= ~134217728 /* Super */;
	            transformFlags |= 268435456 /* ContainsSuper */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~671089985 /* PropertyAccessExcludes */;
	    }
	    function computeVariableDeclaration(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        transformFlags |= 192 /* AssertES2015 */ | 8388608 /* ContainsBindingPattern */;
	        // A VariableDeclaration containing ObjectRest is ESNext syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // Type annotations are TypeScript syntax.
	        if (node.type) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeVariableStatement(node, subtreeFlags) {
	        var transformFlags;
	        var declarationListTransformFlags = node.declarationList.transformFlags;
	        // An ambient declaration is TypeScript syntax.
	        if (ts.hasModifier(node, 2 /* Ambient */)) {
	            transformFlags = 3 /* AssertTypeScript */;
	        }
	        else {
	            transformFlags = subtreeFlags;
	            if (declarationListTransformFlags & 8388608 /* ContainsBindingPattern */) {
	                transformFlags |= 192 /* AssertES2015 */;
	            }
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeLabeledStatement(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // A labeled statement containing a block scoped binding *may* need to be transformed from ES6.
	        if (subtreeFlags & 4194304 /* ContainsBlockScopedBinding */
	            && ts.isIterationStatement(node, /*lookInLabeledStatements*/ true)) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeImportEquals(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // An ImportEqualsDeclaration with a namespace reference is TypeScript.
	        if (!ts.isExternalModuleImportEqualsDeclaration(node)) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeExpressionStatement(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // If the expression of an expression statement is a destructuring assignment,
	        // then we treat the statement as ES6 so that we can indicate that we do not
	        // need to hold on to the right-hand side.
	        if (node.expression.transformFlags & 1024 /* DestructuringAssignment */) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeModuleDeclaration(node, subtreeFlags) {
	        var transformFlags = 3 /* AssertTypeScript */;
	        var modifierFlags = ts.getModifierFlags(node);
	        if ((modifierFlags & 2 /* Ambient */) === 0) {
	            transformFlags |= subtreeFlags;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~977327425 /* ModuleExcludes */;
	    }
	    function computeVariableDeclarationList(node, subtreeFlags) {
	        var transformFlags = subtreeFlags | 33554432 /* ContainsHoistedDeclarationOrCompletion */;
	        if (subtreeFlags & 8388608 /* ContainsBindingPattern */) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        // If a VariableDeclarationList is `let` or `const`, then it is ES6 syntax.
	        if (node.flags & 3 /* BlockScoped */) {
	            transformFlags |= 192 /* AssertES2015 */ | 4194304 /* ContainsBlockScopedBinding */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~948962625 /* VariableDeclarationListExcludes */;
	    }
	    function computeOther(node, kind, subtreeFlags) {
	        // Mark transformations needed for each node
	        var transformFlags = subtreeFlags;
	        var excludeFlags = 939525441 /* NodeExcludes */;
	        switch (kind) {
	            case 120 /* AsyncKeyword */:
	            case 195 /* AwaitExpression */:
	                // async/await is ES2017 syntax, but may be ESNext syntax (for async generators)
	                transformFlags |= 8 /* AssertESNext */ | 16 /* AssertES2017 */;
	                break;
	            case 188 /* TypeAssertionExpression */:
	            case 206 /* AsExpression */:
	            case 295 /* PartiallyEmittedExpression */:
	                // These nodes are TypeScript syntax.
	                transformFlags |= 3 /* AssertTypeScript */;
	                excludeFlags = 536872257 /* OuterExpressionExcludes */;
	                break;
	            case 114 /* PublicKeyword */:
	            case 112 /* PrivateKeyword */:
	            case 113 /* ProtectedKeyword */:
	            case 117 /* AbstractKeyword */:
	            case 124 /* DeclareKeyword */:
	            case 76 /* ConstKeyword */:
	            case 236 /* EnumDeclaration */:
	            case 271 /* EnumMember */:
	            case 207 /* NonNullExpression */:
	            case 132 /* ReadonlyKeyword */:
	                // These nodes are TypeScript syntax.
	                transformFlags |= 3 /* AssertTypeScript */;
	                break;
	            case 253 /* JsxElement */:
	            case 254 /* JsxSelfClosingElement */:
	            case 255 /* JsxOpeningElement */:
	            case 10 /* JsxText */:
	            case 256 /* JsxClosingElement */:
	            case 257 /* JsxFragment */:
	            case 258 /* JsxOpeningFragment */:
	            case 259 /* JsxClosingFragment */:
	            case 260 /* JsxAttribute */:
	            case 261 /* JsxAttributes */:
	            case 262 /* JsxSpreadAttribute */:
	            case 263 /* JsxExpression */:
	                // These nodes are Jsx syntax.
	                transformFlags |= 4 /* AssertJsx */;
	                break;
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 14 /* TemplateHead */:
	            case 15 /* TemplateMiddle */:
	            case 16 /* TemplateTail */:
	            case 200 /* TemplateExpression */:
	            case 187 /* TaggedTemplateExpression */:
	            case 269 /* ShorthandPropertyAssignment */:
	            case 115 /* StaticKeyword */:
	            case 208 /* MetaProperty */:
	                // These nodes are ES6 syntax.
	                transformFlags |= 192 /* AssertES2015 */;
	                break;
	            case 9 /* StringLiteral */:
	                if (node.hasExtendedUnicodeEscape) {
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 8 /* NumericLiteral */:
	                if (node.numericLiteralFlags & 384 /* BinaryOrOctalSpecifier */) {
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 220 /* ForOfStatement */:
	                // This node is either ES2015 syntax or ES2017 syntax (if it is a for-await-of).
	                if (node.awaitModifier) {
	                    transformFlags |= 8 /* AssertESNext */;
	                }
	                transformFlags |= 192 /* AssertES2015 */;
	                break;
	            case 201 /* YieldExpression */:
	                // This node is either ES2015 syntax (in a generator) or ES2017 syntax (in an async
	                // generator).
	                transformFlags |= 8 /* AssertESNext */ | 192 /* AssertES2015 */ | 16777216 /* ContainsYield */;
	                break;
	            case 119 /* AnyKeyword */:
	            case 134 /* NumberKeyword */:
	            case 131 /* NeverKeyword */:
	            case 135 /* ObjectKeyword */:
	            case 137 /* StringKeyword */:
	            case 122 /* BooleanKeyword */:
	            case 138 /* SymbolKeyword */:
	            case 105 /* VoidKeyword */:
	            case 147 /* TypeParameter */:
	            case 150 /* PropertySignature */:
	            case 152 /* MethodSignature */:
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	            case 160 /* TypePredicate */:
	            case 161 /* TypeReference */:
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	            case 164 /* TypeQuery */:
	            case 165 /* TypeLiteral */:
	            case 166 /* ArrayType */:
	            case 167 /* TupleType */:
	            case 168 /* UnionType */:
	            case 169 /* IntersectionType */:
	            case 170 /* ConditionalType */:
	            case 171 /* InferType */:
	            case 172 /* ParenthesizedType */:
	            case 234 /* InterfaceDeclaration */:
	            case 235 /* TypeAliasDeclaration */:
	            case 173 /* ThisType */:
	            case 174 /* TypeOperator */:
	            case 175 /* IndexedAccessType */:
	            case 176 /* MappedType */:
	            case 177 /* LiteralType */:
	            case 240 /* NamespaceExportDeclaration */:
	                // Types and signatures are TypeScript syntax, and exclude all other facts.
	                transformFlags = 3 /* AssertTypeScript */;
	                excludeFlags = -3 /* TypeExcludes */;
	                break;
	            case 146 /* ComputedPropertyName */:
	                // Even though computed property names are ES6, we don't treat them as such.
	                // This is so that they can flow through PropertyName transforms unaffected.
	                // Instead, we mark the container as ES6, so that it can properly handle the transform.
	                transformFlags |= 2097152 /* ContainsComputedPropertyName */;
	                if (subtreeFlags & 16384 /* ContainsLexicalThis */) {
	                    // A computed method name like `[this.getName()](x: string) { ... }` needs to
	                    // distinguish itself from the normal case of a method body containing `this`:
	                    // `this` inside a method doesn't need to be rewritten (the method provides `this`),
	                    // whereas `this` inside a computed name *might* need to be rewritten if the class/object
	                    // is inside an arrow function:
	                    // `_this = this; () => class K { [_this.getName()]() { ... } }`
	                    // To make this distinction, use ContainsLexicalThisInComputedPropertyName
	                    // instead of ContainsLexicalThis for computed property names
	                    transformFlags |= 65536 /* ContainsLexicalThisInComputedPropertyName */;
	                }
	                break;
	            case 202 /* SpreadElement */:
	                transformFlags |= 192 /* AssertES2015 */ | 524288 /* ContainsSpread */;
	                break;
	            case 270 /* SpreadAssignment */:
	                transformFlags |= 8 /* AssertESNext */ | 1048576 /* ContainsObjectSpread */;
	                break;
	            case 97 /* SuperKeyword */:
	                // This node is ES6 syntax.
	                transformFlags |= 192 /* AssertES2015 */ | 134217728 /* Super */;
	                excludeFlags = 536872257 /* OuterExpressionExcludes */; // must be set to persist `Super`
	                break;
	            case 99 /* ThisKeyword */:
	                // Mark this node and its ancestors as containing a lexical `this` keyword.
	                transformFlags |= 16384 /* ContainsLexicalThis */;
	                break;
	            case 178 /* ObjectBindingPattern */:
	                transformFlags |= 192 /* AssertES2015 */ | 8388608 /* ContainsBindingPattern */;
	                if (subtreeFlags & 524288 /* ContainsRest */) {
	                    transformFlags |= 8 /* AssertESNext */ | 1048576 /* ContainsObjectRest */;
	                }
	                excludeFlags = 940049729 /* BindingPatternExcludes */;
	                break;
	            case 179 /* ArrayBindingPattern */:
	                transformFlags |= 192 /* AssertES2015 */ | 8388608 /* ContainsBindingPattern */;
	                excludeFlags = 940049729 /* BindingPatternExcludes */;
	                break;
	            case 180 /* BindingElement */:
	                transformFlags |= 192 /* AssertES2015 */;
	                if (node.dotDotDotToken) {
	                    transformFlags |= 524288 /* ContainsRest */;
	                }
	                break;
	            case 149 /* Decorator */:
	                // This node is TypeScript syntax, and marks its container as also being TypeScript syntax.
	                transformFlags |= 3 /* AssertTypeScript */ | 4096 /* ContainsDecorators */;
	                break;
	            case 182 /* ObjectLiteralExpression */:
	                excludeFlags = 942740801 /* ObjectLiteralExcludes */;
	                if (subtreeFlags & 2097152 /* ContainsComputedPropertyName */) {
	                    // If an ObjectLiteralExpression contains a ComputedPropertyName, then it
	                    // is an ES6 node.
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                if (subtreeFlags & 65536 /* ContainsLexicalThisInComputedPropertyName */) {
	                    // A computed property name containing `this` might need to be rewritten,
	                    // so propagate the ContainsLexicalThis flag upward.
	                    transformFlags |= 16384 /* ContainsLexicalThis */;
	                }
	                if (subtreeFlags & 1048576 /* ContainsObjectSpread */) {
	                    // If an ObjectLiteralExpression contains a spread element, then it
	                    // is an ES next node.
	                    transformFlags |= 8 /* AssertESNext */;
	                }
	                break;
	            case 181 /* ArrayLiteralExpression */:
	            case 186 /* NewExpression */:
	                excludeFlags = 940049729 /* ArrayLiteralOrCallOrNewExcludes */;
	                if (subtreeFlags & 524288 /* ContainsSpread */) {
	                    // If the this node contains a SpreadExpression, then it is an ES6
	                    // node.
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 216 /* DoStatement */:
	            case 217 /* WhileStatement */:
	            case 218 /* ForStatement */:
	            case 219 /* ForInStatement */:
	                // A loop containing a block scoped binding *may* need to be transformed from ES6.
	                if (subtreeFlags & 4194304 /* ContainsBlockScopedBinding */) {
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 272 /* SourceFile */:
	                if (subtreeFlags & 32768 /* ContainsCapturedLexicalThis */) {
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 223 /* ReturnStatement */:
	            case 221 /* ContinueStatement */:
	            case 222 /* BreakStatement */:
	                transformFlags |= 33554432 /* ContainsHoistedDeclarationOrCompletion */;
	                break;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~excludeFlags;
	    }
	    /**
	     * Gets the transform flags to exclude when unioning the transform flags of a subtree.
	     *
	     * NOTE: This needs to be kept up-to-date with the exclusions used in `computeTransformFlagsForNode`.
	     *       For performance reasons, `computeTransformFlagsForNode` uses local constant values rather
	     *       than calling this function.
	     */
	    /* @internal */
	    function getTransformFlagsSubtreeExclusions(kind) {
	        if (kind >= 160 /* FirstTypeNode */ && kind <= 177 /* LastTypeNode */) {
	            return -3 /* TypeExcludes */;
	        }
	        switch (kind) {
	            case 185 /* CallExpression */:
	            case 186 /* NewExpression */:
	            case 181 /* ArrayLiteralExpression */:
	                return 940049729 /* ArrayLiteralOrCallOrNewExcludes */;
	            case 237 /* ModuleDeclaration */:
	                return 977327425 /* ModuleExcludes */;
	            case 148 /* Parameter */:
	                return 939525441 /* ParameterExcludes */;
	            case 191 /* ArrowFunction */:
	                return 1003902273 /* ArrowFunctionExcludes */;
	            case 190 /* FunctionExpression */:
	            case 232 /* FunctionDeclaration */:
	                return 1003935041 /* FunctionExcludes */;
	            case 231 /* VariableDeclarationList */:
	                return 948962625 /* VariableDeclarationListExcludes */;
	            case 233 /* ClassDeclaration */:
	            case 203 /* ClassExpression */:
	                return 942011713 /* ClassExcludes */;
	            case 154 /* Constructor */:
	                return 1003668801 /* ConstructorExcludes */;
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return 1003668801 /* MethodOrAccessorExcludes */;
	            case 119 /* AnyKeyword */:
	            case 134 /* NumberKeyword */:
	            case 131 /* NeverKeyword */:
	            case 137 /* StringKeyword */:
	            case 135 /* ObjectKeyword */:
	            case 122 /* BooleanKeyword */:
	            case 138 /* SymbolKeyword */:
	            case 105 /* VoidKeyword */:
	            case 147 /* TypeParameter */:
	            case 150 /* PropertySignature */:
	            case 152 /* MethodSignature */:
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	            case 234 /* InterfaceDeclaration */:
	            case 235 /* TypeAliasDeclaration */:
	                return -3 /* TypeExcludes */;
	            case 182 /* ObjectLiteralExpression */:
	                return 942740801 /* ObjectLiteralExcludes */;
	            case 267 /* CatchClause */:
	                return 940574017 /* CatchClauseExcludes */;
	            case 178 /* ObjectBindingPattern */:
	            case 179 /* ArrayBindingPattern */:
	                return 940049729 /* BindingPatternExcludes */;
	            case 188 /* TypeAssertionExpression */:
	            case 206 /* AsExpression */:
	            case 295 /* PartiallyEmittedExpression */:
	            case 189 /* ParenthesizedExpression */:
	            case 97 /* SuperKeyword */:
	                return 536872257 /* OuterExpressionExcludes */;
	            case 183 /* PropertyAccessExpression */:
	            case 184 /* ElementAccessExpression */:
	                return 671089985 /* PropertyAccessExcludes */;
	            default:
	                return 939525441 /* NodeExcludes */;
	        }
	    }
	    ts.getTransformFlagsSubtreeExclusions = getTransformFlagsSubtreeExclusions;
	    /**
	     * "Binds" JSDoc nodes in TypeScript code.
	     * Since we will never create symbols for JSDoc, we just set parent pointers instead.
	     */
	    function setParentPointers(parent, child) {
	        child.parent = parent;
	        ts.forEachChild(child, function (childsChild) { return setParentPointers(child, childsChild); });
	    }
	})(ts || (ts = {}));
	/** @internal */
	var ts;
	(function (ts) {
	    function createGetSymbolWalker(getRestTypeOfSignature, getTypePredicateOfSignature, getReturnTypeOfSignature, getBaseTypes, resolveStructuredTypeMembers, getTypeOfSymbol, getResolvedSymbol, getIndexTypeOfStructuredType, getConstraintFromTypeParameter, getFirstIdentifier) {
	        return getSymbolWalker;
	        function getSymbolWalker(accept) {
	            if (accept === void 0) { accept = function () { return true; }; }
	            var visitedTypes = []; // Sparse array from id to type
	            var visitedSymbols = []; // Sparse array from id to symbol
	            return {
	                walkType: function (type) {
	                    try {
	                        visitType(type);
	                        return { visitedTypes: ts.getOwnValues(visitedTypes), visitedSymbols: ts.getOwnValues(visitedSymbols) };
	                    }
	                    finally {
	                        ts.clear(visitedTypes);
	                        ts.clear(visitedSymbols);
	                    }
	                },
	                walkSymbol: function (symbol) {
	                    try {
	                        visitSymbol(symbol);
	                        return { visitedTypes: ts.getOwnValues(visitedTypes), visitedSymbols: ts.getOwnValues(visitedSymbols) };
	                    }
	                    finally {
	                        ts.clear(visitedTypes);
	                        ts.clear(visitedSymbols);
	                    }
	                },
	            };
	            function visitType(type) {
	                if (!type) {
	                    return;
	                }
	                if (visitedTypes[type.id]) {
	                    return;
	                }
	                visitedTypes[type.id] = type;
	                // Reuse visitSymbol to visit the type's symbol,
	                //  but be sure to bail on recuring into the type if accept declines the symbol.
	                var shouldBail = visitSymbol(type.symbol);
	                if (shouldBail)
	                    return;
	                // Visit the type's related types, if any
	                if (type.flags & 65536 /* Object */) {
	                    var objectType = type;
	                    var objectFlags = objectType.objectFlags;
	                    if (objectFlags & 4 /* Reference */) {
	                        visitTypeReference(type);
	                    }
	                    if (objectFlags & 32 /* Mapped */) {
	                        visitMappedType(type);
	                    }
	                    if (objectFlags & (1 /* Class */ | 2 /* Interface */)) {
	                        visitInterfaceType(type);
	                    }
	                    if (objectFlags & (8 /* Tuple */ | 16 /* Anonymous */)) {
	                        visitObjectType(objectType);
	                    }
	                }
	                if (type.flags & 32768 /* TypeParameter */) {
	                    visitTypeParameter(type);
	                }
	                if (type.flags & 393216 /* UnionOrIntersection */) {
	                    visitUnionOrIntersectionType(type);
	                }
	                if (type.flags & 524288 /* Index */) {
	                    visitIndexType(type);
	                }
	                if (type.flags & 1048576 /* IndexedAccess */) {
	                    visitIndexedAccessType(type);
	                }
	            }
	            function visitTypeReference(type) {
	                visitType(type.target);
	                ts.forEach(type.typeArguments, visitType);
	            }
	            function visitTypeParameter(type) {
	                visitType(getConstraintFromTypeParameter(type));
	            }
	            function visitUnionOrIntersectionType(type) {
	                ts.forEach(type.types, visitType);
	            }
	            function visitIndexType(type) {
	                visitType(type.type);
	            }
	            function visitIndexedAccessType(type) {
	                visitType(type.objectType);
	                visitType(type.indexType);
	                visitType(type.constraint);
	            }
	            function visitMappedType(type) {
	                visitType(type.typeParameter);
	                visitType(type.constraintType);
	                visitType(type.templateType);
	                visitType(type.modifiersType);
	            }
	            function visitSignature(signature) {
	                var typePredicate = getTypePredicateOfSignature(signature);
	                if (typePredicate) {
	                    visitType(typePredicate.type);
	                }
	                ts.forEach(signature.typeParameters, visitType);
	                for (var _i = 0, _a = signature.parameters; _i < _a.length; _i++) {
	                    var parameter = _a[_i];
	                    visitSymbol(parameter);
	                }
	                visitType(getRestTypeOfSignature(signature));
	                visitType(getReturnTypeOfSignature(signature));
	            }
	            function visitInterfaceType(interfaceT) {
	                visitObjectType(interfaceT);
	                ts.forEach(interfaceT.typeParameters, visitType);
	                ts.forEach(getBaseTypes(interfaceT), visitType);
	                visitType(interfaceT.thisType);
	            }
	            function visitObjectType(type) {
	                var stringIndexType = getIndexTypeOfStructuredType(type, 0 /* String */);
	                visitType(stringIndexType);
	                var numberIndexType = getIndexTypeOfStructuredType(type, 1 /* Number */);
	                visitType(numberIndexType);
	                // The two checks above *should* have already resolved the type (if needed), so this should be cached
	                var resolved = resolveStructuredTypeMembers(type);
	                for (var _i = 0, _a = resolved.callSignatures; _i < _a.length; _i++) {
	                    var signature = _a[_i];
	                    visitSignature(signature);
	                }
	                for (var _b = 0, _c = resolved.constructSignatures; _b < _c.length; _b++) {
	                    var signature = _c[_b];
	                    visitSignature(signature);
	                }
	                for (var _d = 0, _e = resolved.properties; _d < _e.length; _d++) {
	                    var p = _e[_d];
	                    visitSymbol(p);
	                }
	            }
	            function visitSymbol(symbol) {
	                if (!symbol) {
	                    return;
	                }
	                var symbolId = ts.getSymbolId(symbol);
	                if (visitedSymbols[symbolId]) {
	                    return;
	                }
	                visitedSymbols[symbolId] = symbol;
	                if (!accept(symbol)) {
	                    return true;
	                }
	                var t = getTypeOfSymbol(symbol);
	                visitType(t); // Should handle members on classes and such
	                if (symbol.flags & 1952 /* HasExports */) {
	                    symbol.exports.forEach(visitSymbol);
	                }
	                ts.forEach(symbol.declarations, function (d) {
	                    // Type queries are too far resolved when we just visit the symbol's type
	                    //  (their type resolved directly to the member deeply referenced)
	                    // So to get the intervening symbols, we need to check if there's a type
	                    // query node on any of the symbol's declarations and get symbols there
	                    if (d.type && d.type.kind === 164 /* TypeQuery */) {
	                        var query = d.type;
	                        var entity = getResolvedSymbol(getFirstIdentifier(query.exprName));
	                        visitSymbol(entity);
	                    }
	                });
	            }
	        }
	    }
	    ts.createGetSymbolWalker = createGetSymbolWalker;
	})(ts || (ts = {}));
	/// <reference path="core.ts" />
	/// <reference path="diagnosticInformationMap.generated.ts" />
	var ts;
	(function (ts) {
	    function trace(host) {
	        host.trace(ts.formatMessage.apply(undefined, arguments));
	    }
	    ts.trace = trace;
	    /* @internal */
	    function isTraceEnabled(compilerOptions, host) {
	        return compilerOptions.traceResolution && host.trace !== undefined;
	    }
	    ts.isTraceEnabled = isTraceEnabled;
	    function withPackageId(packageId, r) {
	        return r && { path: r.path, extension: r.ext, packageId: packageId };
	    }
	    function noPackageId(r) {
	        return withPackageId(/*packageId*/ undefined, r);
	    }
	    /**
	     * Kinds of file that we are currently looking for.
	     * Typically there is one pass with Extensions.TypeScript, then a second pass with Extensions.JavaScript.
	     */
	    var Extensions;
	    (function (Extensions) {
	        Extensions[Extensions["TypeScript"] = 0] = "TypeScript";
	        Extensions[Extensions["JavaScript"] = 1] = "JavaScript";
	        Extensions[Extensions["DtsOnly"] = 2] = "DtsOnly"; /** Only '.d.ts' */
	    })(Extensions || (Extensions = {}));
	    /** Used with `Extensions.DtsOnly` to extract the path from TypeScript results. */
	    function resolvedTypeScriptOnly(resolved) {
	        if (!resolved) {
	            return undefined;
	        }
	        ts.Debug.assert(ts.extensionIsTypeScript(resolved.extension));
	        return { fileName: resolved.path, packageId: resolved.packageId };
	    }
	    function createResolvedModuleWithFailedLookupLocations(resolved, originalPath, isExternalLibraryImport, failedLookupLocations) {
	        return {
	            resolvedModule: resolved && { resolvedFileName: resolved.path, originalPath: originalPath, extension: resolved.extension, isExternalLibraryImport: isExternalLibraryImport, packageId: resolved.packageId },
	            failedLookupLocations: failedLookupLocations
	        };
	    }
	    /** Reads from "main" or "types"/"typings" depending on `extensions`. */
	    function tryReadPackageJsonFields(readTypes, jsonContent, baseDirectory, state) {
	        return readTypes ? tryReadFromField("typings") || tryReadFromField("types") : tryReadFromField("main");
	        function tryReadFromField(fieldName) {
	            if (!ts.hasProperty(jsonContent, fieldName)) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.package_json_does_not_have_a_0_field, fieldName);
	                }
	                return;
	            }
	            var fileName = jsonContent[fieldName];
	            if (!ts.isString(fileName)) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Expected_type_of_0_field_in_package_json_to_be_string_got_1, fieldName, typeof fileName);
	                }
	                return;
	            }
	            var path = ts.normalizePath(ts.combinePaths(baseDirectory, fileName));
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.package_json_has_0_field_1_that_references_2, fieldName, fileName, path);
	            }
	            return path;
	        }
	    }
	    function readJson(path, host) {
	        try {
	            var jsonText = host.readFile(path);
	            return jsonText ? JSON.parse(jsonText) : {};
	        }
	        catch (e) {
	            // gracefully handle if readFile fails or returns not JSON
	            return {};
	        }
	    }
	    function getEffectiveTypeRoots(options, host) {
	        if (options.typeRoots) {
	            return options.typeRoots;
	        }
	        var currentDirectory;
	        if (options.configFilePath) {
	            currentDirectory = ts.getDirectoryPath(options.configFilePath);
	        }
	        else if (host.getCurrentDirectory) {
	            currentDirectory = host.getCurrentDirectory();
	        }
	        if (currentDirectory !== undefined) {
	            return getDefaultTypeRoots(currentDirectory, host);
	        }
	    }
	    ts.getEffectiveTypeRoots = getEffectiveTypeRoots;
	    /**
	     * Returns the path to every node_modules/@types directory from some ancestor directory.
	     * Returns undefined if there are none.
	     */
	    function getDefaultTypeRoots(currentDirectory, host) {
	        if (!host.directoryExists) {
	            return [ts.combinePaths(currentDirectory, nodeModulesAtTypes)];
	            // And if it doesn't exist, tough.
	        }
	        var typeRoots;
	        ts.forEachAncestorDirectory(ts.normalizePath(currentDirectory), function (directory) {
	            var atTypes = ts.combinePaths(directory, nodeModulesAtTypes);
	            if (host.directoryExists(atTypes)) {
	                (typeRoots || (typeRoots = [])).push(atTypes);
	            }
	            return undefined;
	        });
	        return typeRoots;
	    }
	    var nodeModulesAtTypes = ts.combinePaths("node_modules", "@types");
	    /**
	     * @param {string | undefined} containingFile - file that contains type reference directive, can be undefined if containing file is unknown.
	     * This is possible in case if resolution is performed for directives specified via 'types' parameter. In this case initial path for secondary lookups
	     * is assumed to be the same as root directory of the project.
	     */
	    function resolveTypeReferenceDirective(typeReferenceDirectiveName, containingFile, options, host) {
	        var traceEnabled = isTraceEnabled(options, host);
	        var moduleResolutionState = { compilerOptions: options, host: host, traceEnabled: traceEnabled };
	        var typeRoots = getEffectiveTypeRoots(options, host);
	        if (traceEnabled) {
	            if (containingFile === undefined) {
	                if (typeRoots === undefined) {
	                    trace(host, ts.Diagnostics.Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set, typeReferenceDirectiveName);
	                }
	                else {
	                    trace(host, ts.Diagnostics.Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1, typeReferenceDirectiveName, typeRoots);
	                }
	            }
	            else {
	                if (typeRoots === undefined) {
	                    trace(host, ts.Diagnostics.Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set, typeReferenceDirectiveName, containingFile);
	                }
	                else {
	                    trace(host, ts.Diagnostics.Resolving_type_reference_directive_0_containing_file_1_root_directory_2, typeReferenceDirectiveName, containingFile, typeRoots);
	                }
	            }
	        }
	        var failedLookupLocations = [];
	        var resolved = primaryLookup();
	        var primary = true;
	        if (!resolved) {
	            resolved = secondaryLookup();
	            primary = false;
	        }
	        var resolvedTypeReferenceDirective;
	        if (resolved) {
	            if (!options.preserveSymlinks) {
	                resolved = __assign({}, resolved, { fileName: realPath(resolved.fileName, host, traceEnabled) });
	            }
	            if (traceEnabled) {
	                trace(host, ts.Diagnostics.Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2, typeReferenceDirectiveName, resolved.fileName, primary);
	            }
	            resolvedTypeReferenceDirective = { primary: primary, resolvedFileName: resolved.fileName, packageId: resolved.packageId };
	        }
	        return { resolvedTypeReferenceDirective: resolvedTypeReferenceDirective, failedLookupLocations: failedLookupLocations };
	        function primaryLookup() {
	            // Check primary library paths
	            if (typeRoots && typeRoots.length) {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Resolving_with_primary_search_path_0, typeRoots.join(", "));
	                }
	                return ts.forEach(typeRoots, function (typeRoot) {
	                    var candidate = ts.combinePaths(typeRoot, typeReferenceDirectiveName);
	                    var candidateDirectory = ts.getDirectoryPath(candidate);
	                    var directoryExists = directoryProbablyExists(candidateDirectory, host);
	                    if (!directoryExists && traceEnabled) {
	                        trace(host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, candidateDirectory);
	                    }
	                    return resolvedTypeScriptOnly(loadNodeModuleFromDirectory(Extensions.DtsOnly, candidate, failedLookupLocations, !directoryExists, moduleResolutionState));
	                });
	            }
	            else {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Root_directory_cannot_be_determined_skipping_primary_search_paths);
	                }
	            }
	        }
	        function secondaryLookup() {
	            var resolvedFile;
	            var initialLocationForSecondaryLookup = containingFile && ts.getDirectoryPath(containingFile);
	            if (initialLocationForSecondaryLookup !== undefined) {
	                // check secondary locations
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Looking_up_in_node_modules_folder_initial_location_0, initialLocationForSecondaryLookup);
	                }
	                var result = loadModuleFromNodeModules(Extensions.DtsOnly, typeReferenceDirectiveName, initialLocationForSecondaryLookup, failedLookupLocations, moduleResolutionState, /*cache*/ undefined);
	                resolvedFile = resolvedTypeScriptOnly(result && result.value);
	                if (!resolvedFile && traceEnabled) {
	                    trace(host, ts.Diagnostics.Type_reference_directive_0_was_not_resolved, typeReferenceDirectiveName);
	                }
	                return resolvedFile;
	            }
	            else {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_modules_folder);
	                }
	            }
	        }
	    }
	    ts.resolveTypeReferenceDirective = resolveTypeReferenceDirective;
	    /**
	     * Given a set of options, returns the set of type directive names
	     *   that should be included for this program automatically.
	     * This list could either come from the config file,
	     *   or from enumerating the types root + initial secondary types lookup location.
	     * More type directives might appear in the program later as a result of loading actual source files;
	     *   this list is only the set of defaults that are implicitly included.
	     */
	    function getAutomaticTypeDirectiveNames(options, host) {
	        // Use explicit type list from tsconfig.json
	        if (options.types) {
	            return options.types;
	        }
	        // Walk the primary type lookup locations
	        var result = [];
	        if (host.directoryExists && host.getDirectories) {
	            var typeRoots = getEffectiveTypeRoots(options, host);
	            if (typeRoots) {
	                for (var _i = 0, typeRoots_1 = typeRoots; _i < typeRoots_1.length; _i++) {
	                    var root = typeRoots_1[_i];
	                    if (host.directoryExists(root)) {
	                        for (var _a = 0, _b = host.getDirectories(root); _a < _b.length; _a++) {
	                            var typeDirectivePath = _b[_a];
	                            var normalized = ts.normalizePath(typeDirectivePath);
	                            var packageJsonPath = pathToPackageJson(ts.combinePaths(root, normalized));
	                            // `types-publisher` sometimes creates packages with `"typings": null` for packages that don't provide their own types.
	                            // See `createNotNeededPackageJSON` in the types-publisher` repo.
	                            // tslint:disable-next-line:no-null-keyword
	                            var isNotNeededPackage = host.fileExists(packageJsonPath) && readJson(packageJsonPath, host).typings === null;
	                            if (!isNotNeededPackage) {
	                                // Return just the type directive names
	                                result.push(ts.getBaseFileName(normalized));
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return result;
	    }
	    ts.getAutomaticTypeDirectiveNames = getAutomaticTypeDirectiveNames;
	    function createModuleResolutionCache(currentDirectory, getCanonicalFileName) {
	        var directoryToModuleNameMap = ts.createMap();
	        var moduleNameToDirectoryMap = ts.createMap();
	        return { getOrCreateCacheForDirectory: getOrCreateCacheForDirectory, getOrCreateCacheForModuleName: getOrCreateCacheForModuleName };
	        function getOrCreateCacheForDirectory(directoryName) {
	            var path = ts.toPath(directoryName, currentDirectory, getCanonicalFileName);
	            var perFolderCache = directoryToModuleNameMap.get(path);
	            if (!perFolderCache) {
	                perFolderCache = ts.createMap();
	                directoryToModuleNameMap.set(path, perFolderCache);
	            }
	            return perFolderCache;
	        }
	        function getOrCreateCacheForModuleName(nonRelativeModuleName) {
	            if (ts.isExternalModuleNameRelative(nonRelativeModuleName)) {
	                return undefined;
	            }
	            var perModuleNameCache = moduleNameToDirectoryMap.get(nonRelativeModuleName);
	            if (!perModuleNameCache) {
	                perModuleNameCache = createPerModuleNameCache();
	                moduleNameToDirectoryMap.set(nonRelativeModuleName, perModuleNameCache);
	            }
	            return perModuleNameCache;
	        }
	        function createPerModuleNameCache() {
	            var directoryPathMap = ts.createMap();
	            return { get: get, set: set };
	            function get(directory) {
	                return directoryPathMap.get(ts.toPath(directory, currentDirectory, getCanonicalFileName));
	            }
	            /**
	             * At first this function add entry directory -> module resolution result to the table.
	             * Then it computes the set of parent folders for 'directory' that should have the same module resolution result
	             * and for every parent folder in set it adds entry: parent -> module resolution. .
	             * Lets say we first directory name: /a/b/c/d/e and resolution result is: /a/b/bar.ts.
	             * Set of parent folders that should have the same result will be:
	             * [
	             *     /a/b/c/d, /a/b/c, /a/b
	             * ]
	             * this means that request for module resolution from file in any of these folder will be immediately found in cache.
	             */
	            function set(directory, result) {
	                var path = ts.toPath(directory, currentDirectory, getCanonicalFileName);
	                // if entry is already in cache do nothing
	                if (directoryPathMap.has(path)) {
	                    return;
	                }
	                directoryPathMap.set(path, result);
	                var resolvedFileName = result.resolvedModule && result.resolvedModule.resolvedFileName;
	                // find common prefix between directory and resolved file name
	                // this common prefix should be the shorted path that has the same resolution
	                // directory: /a/b/c/d/e
	                // resolvedFileName: /a/b/foo.d.ts
	                var commonPrefix = getCommonPrefix(path, resolvedFileName);
	                var current = path;
	                while (true) {
	                    var parent = ts.getDirectoryPath(current);
	                    if (parent === current || directoryPathMap.has(parent)) {
	                        break;
	                    }
	                    directoryPathMap.set(parent, result);
	                    current = parent;
	                    if (current === commonPrefix) {
	                        break;
	                    }
	                }
	            }
	            function getCommonPrefix(directory, resolution) {
	                if (resolution === undefined) {
	                    return undefined;
	                }
	                var resolutionDirectory = ts.toPath(ts.getDirectoryPath(resolution), currentDirectory, getCanonicalFileName);
	                // find first position where directory and resolution differs
	                var i = 0;
	                while (i < Math.min(directory.length, resolutionDirectory.length) && directory.charCodeAt(i) === resolutionDirectory.charCodeAt(i)) {
	                    i++;
	                }
	                // find last directory separator before position i
	                var sep = directory.lastIndexOf(ts.directorySeparator, i);
	                if (sep < 0) {
	                    return undefined;
	                }
	                return directory.substr(0, sep);
	            }
	        }
	    }
	    ts.createModuleResolutionCache = createModuleResolutionCache;
	    function resolveModuleName(moduleName, containingFile, compilerOptions, host, cache) {
	        var traceEnabled = isTraceEnabled(compilerOptions, host);
	        if (traceEnabled) {
	            trace(host, ts.Diagnostics.Resolving_module_0_from_1, moduleName, containingFile);
	        }
	        var containingDirectory = ts.getDirectoryPath(containingFile);
	        var perFolderCache = cache && cache.getOrCreateCacheForDirectory(containingDirectory);
	        var result = perFolderCache && perFolderCache.get(moduleName);
	        if (result) {
	            if (traceEnabled) {
	                trace(host, ts.Diagnostics.Resolution_for_module_0_was_found_in_cache, moduleName);
	            }
	        }
	        else {
	            var moduleResolution = compilerOptions.moduleResolution;
	            if (moduleResolution === undefined) {
	                moduleResolution = ts.getEmitModuleKind(compilerOptions) === ts.ModuleKind.CommonJS ? ts.ModuleResolutionKind.NodeJs : ts.ModuleResolutionKind.Classic;
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Module_resolution_kind_is_not_specified_using_0, ts.ModuleResolutionKind[moduleResolution]);
	                }
	            }
	            else {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Explicitly_specified_module_resolution_kind_Colon_0, ts.ModuleResolutionKind[moduleResolution]);
	                }
	            }
	            switch (moduleResolution) {
	                case ts.ModuleResolutionKind.NodeJs:
	                    result = nodeModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache);
	                    break;
	                case ts.ModuleResolutionKind.Classic:
	                    result = classicNameResolver(moduleName, containingFile, compilerOptions, host, cache);
	                    break;
	                default:
	                    ts.Debug.fail("Unexpected moduleResolution: " + moduleResolution);
	            }
	            if (perFolderCache) {
	                perFolderCache.set(moduleName, result);
	                // put result in per-module name cache
	                var perModuleNameCache = cache.getOrCreateCacheForModuleName(moduleName);
	                if (perModuleNameCache) {
	                    perModuleNameCache.set(containingDirectory, result);
	                }
	            }
	        }
	        if (traceEnabled) {
	            if (result.resolvedModule) {
	                trace(host, ts.Diagnostics.Module_name_0_was_successfully_resolved_to_1, moduleName, result.resolvedModule.resolvedFileName);
	            }
	            else {
	                trace(host, ts.Diagnostics.Module_name_0_was_not_resolved, moduleName);
	            }
	        }
	        return result;
	    }
	    ts.resolveModuleName = resolveModuleName;
	    /**
	     * Any module resolution kind can be augmented with optional settings: 'baseUrl', 'paths' and 'rootDirs' - they are used to
	     * mitigate differences between design time structure of the project and its runtime counterpart so the same import name
	     * can be resolved successfully by TypeScript compiler and runtime module loader.
	     * If these settings are set then loading procedure will try to use them to resolve module name and it can of failure it will
	     * fallback to standard resolution routine.
	     *
	     * - baseUrl - this setting controls how non-relative module names are resolved. If this setting is specified then non-relative
	     * names will be resolved relative to baseUrl: i.e. if baseUrl is '/a/b' then candidate location to resolve module name 'c/d' will
	     * be '/a/b/c/d'
	     * - paths - this setting can only be used when baseUrl is specified. allows to tune how non-relative module names
	     * will be resolved based on the content of the module name.
	     * Structure of 'paths' compiler options
	     * 'paths': {
	     *    pattern-1: [...substitutions],
	     *    pattern-2: [...substitutions],
	     *    ...
	     *    pattern-n: [...substitutions]
	     * }
	     * Pattern here is a string that can contain zero or one '*' character. During module resolution module name will be matched against
	     * all patterns in the list. Matching for patterns that don't contain '*' means that module name must be equal to pattern respecting the case.
	     * If pattern contains '*' then to match pattern "<prefix>*<suffix>" module name must start with the <prefix> and end with <suffix>.
	     * <MatchedStar> denotes part of the module name between <prefix> and <suffix>.
	     * If module name can be matches with multiple patterns then pattern with the longest prefix will be picked.
	     * After selecting pattern we'll use list of substitutions to get candidate locations of the module and the try to load module
	     * from the candidate location.
	     * Substitution is a string that can contain zero or one '*'. To get candidate location from substitution we'll pick every
	     * substitution in the list and replace '*' with <MatchedStar> string. If candidate location is not rooted it
	     * will be converted to absolute using baseUrl.
	     * For example:
	     * baseUrl: /a/b/c
	     * "paths": {
	     *     // match all module names
	     *     "*": [
	     *         "*",        // use matched name as is,
	     *                     // <matched name> will be looked as /a/b/c/<matched name>
	     *
	     *         "folder1/*" // substitution will convert matched name to 'folder1/<matched name>',
	     *                     // since it is not rooted then final candidate location will be /a/b/c/folder1/<matched name>
	     *     ],
	     *     // match module names that start with 'components/'
	     *     "components/*": [ "/root/components/*" ] // substitution will convert /components/folder1/<matched name> to '/root/components/folder1/<matched name>',
	     *                                              // it is rooted so it will be final candidate location
	     * }
	     *
	     * 'rootDirs' allows the project to be spreaded across multiple locations and resolve modules with relative names as if
	     * they were in the same location. For example lets say there are two files
	     * '/local/src/content/file1.ts'
	     * '/shared/components/contracts/src/content/protocols/file2.ts'
	     * After bundling content of '/shared/components/contracts/src' will be merged with '/local/src' so
	     * if file1 has the following import 'import {x} from "./protocols/file2"' it will be resolved successfully in runtime.
	     * 'rootDirs' provides the way to tell compiler that in order to get the whole project it should behave as if content of all
	     * root dirs were merged together.
	     * I.e. for the example above 'rootDirs' will have two entries: [ '/local/src', '/shared/components/contracts/src' ].
	     * Compiler will first convert './protocols/file2' into absolute path relative to the location of containing file:
	     * '/local/src/content/protocols/file2' and try to load it - failure.
	     * Then it will search 'rootDirs' looking for a longest matching prefix of this absolute path and if such prefix is found - absolute path will
	     * be converted to a path relative to found rootDir entry './content/protocols/file2' (*). As a last step compiler will check all remaining
	     * entries in 'rootDirs', use them to build absolute path out of (*) and try to resolve module from this location.
	     */
	    function tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loader, failedLookupLocations, state) {
	        if (!ts.isExternalModuleNameRelative(moduleName)) {
	            return tryLoadModuleUsingBaseUrl(extensions, moduleName, loader, failedLookupLocations, state);
	        }
	        else {
	            return tryLoadModuleUsingRootDirs(extensions, moduleName, containingDirectory, loader, failedLookupLocations, state);
	        }
	    }
	    function tryLoadModuleUsingRootDirs(extensions, moduleName, containingDirectory, loader, failedLookupLocations, state) {
	        if (!state.compilerOptions.rootDirs) {
	            return undefined;
	        }
	        if (state.traceEnabled) {
	            trace(state.host, ts.Diagnostics.rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0, moduleName);
	        }
	        var candidate = ts.normalizePath(ts.combinePaths(containingDirectory, moduleName));
	        var matchedRootDir;
	        var matchedNormalizedPrefix;
	        for (var _i = 0, _a = state.compilerOptions.rootDirs; _i < _a.length; _i++) {
	            var rootDir = _a[_i];
	            // rootDirs are expected to be absolute
	            // in case of tsconfig.json this will happen automatically - compiler will expand relative names
	            // using location of tsconfig.json as base location
	            var normalizedRoot = ts.normalizePath(rootDir);
	            if (!ts.endsWith(normalizedRoot, ts.directorySeparator)) {
	                normalizedRoot += ts.directorySeparator;
	            }
	            var isLongestMatchingPrefix = ts.startsWith(candidate, normalizedRoot) &&
	                (matchedNormalizedPrefix === undefined || matchedNormalizedPrefix.length < normalizedRoot.length);
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Checking_if_0_is_the_longest_matching_prefix_for_1_2, normalizedRoot, candidate, isLongestMatchingPrefix);
	            }
	            if (isLongestMatchingPrefix) {
	                matchedNormalizedPrefix = normalizedRoot;
	                matchedRootDir = rootDir;
	            }
	        }
	        if (matchedNormalizedPrefix) {
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Longest_matching_prefix_for_0_is_1, candidate, matchedNormalizedPrefix);
	            }
	            var suffix = candidate.substr(matchedNormalizedPrefix.length);
	            // first - try to load from a initial location
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Loading_0_from_the_root_dir_1_candidate_location_2, suffix, matchedNormalizedPrefix, candidate);
	            }
	            var resolvedFileName = loader(extensions, candidate, failedLookupLocations, !directoryProbablyExists(containingDirectory, state.host), state);
	            if (resolvedFileName) {
	                return resolvedFileName;
	            }
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Trying_other_entries_in_rootDirs);
	            }
	            // then try to resolve using remaining entries in rootDirs
	            for (var _b = 0, _c = state.compilerOptions.rootDirs; _b < _c.length; _b++) {
	                var rootDir = _c[_b];
	                if (rootDir === matchedRootDir) {
	                    // skip the initially matched entry
	                    continue;
	                }
	                var candidate_1 = ts.combinePaths(ts.normalizePath(rootDir), suffix);
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Loading_0_from_the_root_dir_1_candidate_location_2, suffix, rootDir, candidate_1);
	                }
	                var baseDirectory = ts.getDirectoryPath(candidate_1);
	                var resolvedFileName_1 = loader(extensions, candidate_1, failedLookupLocations, !directoryProbablyExists(baseDirectory, state.host), state);
	                if (resolvedFileName_1) {
	                    return resolvedFileName_1;
	                }
	            }
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Module_resolution_using_rootDirs_has_failed);
	            }
	        }
	        return undefined;
	    }
	    function tryLoadModuleUsingBaseUrl(extensions, moduleName, loader, failedLookupLocations, state) {
	        if (!state.compilerOptions.baseUrl) {
	            return undefined;
	        }
	        if (state.traceEnabled) {
	            trace(state.host, ts.Diagnostics.baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1, state.compilerOptions.baseUrl, moduleName);
	        }
	        // string is for exact match
	        var matchedPattern = undefined;
	        if (state.compilerOptions.paths) {
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0, moduleName);
	            }
	            matchedPattern = ts.matchPatternOrExact(ts.getOwnKeys(state.compilerOptions.paths), moduleName);
	        }
	        if (matchedPattern) {
	            var matchedStar_1 = ts.isString(matchedPattern) ? undefined : ts.matchedText(matchedPattern, moduleName);
	            var matchedPatternText = ts.isString(matchedPattern) ? matchedPattern : ts.patternText(matchedPattern);
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Module_name_0_matched_pattern_1, moduleName, matchedPatternText);
	            }
	            return ts.forEach(state.compilerOptions.paths[matchedPatternText], function (subst) {
	                var path = matchedStar_1 ? subst.replace("*", matchedStar_1) : subst;
	                var candidate = ts.normalizePath(ts.combinePaths(state.compilerOptions.baseUrl, path));
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Trying_substitution_0_candidate_module_location_Colon_1, subst, path);
	                }
	                // A path mapping may have an extension, in contrast to an import, which should omit it.
	                var extension = ts.tryGetExtensionFromPath(candidate);
	                if (extension !== undefined) {
	                    var path_1 = tryFile(candidate, failedLookupLocations, /*onlyRecordFailures*/ false, state);
	                    if (path_1 !== undefined) {
	                        return noPackageId({ path: path_1, ext: extension });
	                    }
	                }
	                return loader(extensions, candidate, failedLookupLocations, !directoryProbablyExists(ts.getDirectoryPath(candidate), state.host), state);
	            });
	        }
	        else {
	            var candidate = ts.normalizePath(ts.combinePaths(state.compilerOptions.baseUrl, moduleName));
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Resolving_module_name_0_relative_to_base_url_1_2, moduleName, state.compilerOptions.baseUrl, candidate);
	            }
	            return loader(extensions, candidate, failedLookupLocations, !directoryProbablyExists(ts.getDirectoryPath(candidate), state.host), state);
	        }
	    }
	    function nodeModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache) {
	        return nodeModuleNameResolverWorker(moduleName, ts.getDirectoryPath(containingFile), compilerOptions, host, cache, /*jsOnly*/ false);
	    }
	    ts.nodeModuleNameResolver = nodeModuleNameResolver;
	    /**
	     * Expose resolution logic to allow us to use Node module resolution logic from arbitrary locations.
	     * No way to do this with `require()`: https://github.com/nodejs/node/issues/5963
	     * Throws an error if the module can't be resolved.
	     */
	    /* @internal */
	    function resolveJavaScriptModule(moduleName, initialDir, host) {
	        var _a = nodeModuleNameResolverWorker(moduleName, initialDir, { moduleResolution: ts.ModuleResolutionKind.NodeJs, allowJs: true }, host, /*cache*/ undefined, /*jsOnly*/ true), resolvedModule = _a.resolvedModule, failedLookupLocations = _a.failedLookupLocations;
	        if (!resolvedModule) {
	            throw new Error("Could not resolve JS module '" + moduleName + "' starting at '" + initialDir + "'. Looked in: " + failedLookupLocations.join(", "));
	        }
	        return resolvedModule.resolvedFileName;
	    }
	    ts.resolveJavaScriptModule = resolveJavaScriptModule;
	    function nodeModuleNameResolverWorker(moduleName, containingDirectory, compilerOptions, host, cache, jsOnly) {
	        var traceEnabled = isTraceEnabled(compilerOptions, host);
	        var failedLookupLocations = [];
	        var state = { compilerOptions: compilerOptions, host: host, traceEnabled: traceEnabled };
	        var result = jsOnly ? tryResolve(Extensions.JavaScript) : (tryResolve(Extensions.TypeScript) || tryResolve(Extensions.JavaScript));
	        if (result && result.value) {
	            var _a = result.value, resolved = _a.resolved, originalPath = _a.originalPath, isExternalLibraryImport = _a.isExternalLibraryImport;
	            return createResolvedModuleWithFailedLookupLocations(resolved, originalPath, isExternalLibraryImport, failedLookupLocations);
	        }
	        return { resolvedModule: undefined, failedLookupLocations: failedLookupLocations };
	        function tryResolve(extensions) {
	            var loader = function (extensions, candidate, failedLookupLocations, onlyRecordFailures, state) { return nodeLoadModuleByRelativeName(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, /*considerPackageJson*/ true); };
	            var resolved = tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loader, failedLookupLocations, state);
	            if (resolved) {
	                return toSearchResult({ resolved: resolved, isExternalLibraryImport: false });
	            }
	            if (!ts.isExternalModuleNameRelative(moduleName)) {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Loading_module_0_from_node_modules_folder_target_file_type_1, moduleName, Extensions[extensions]);
	                }
	                var resolved_1 = loadModuleFromNodeModules(extensions, moduleName, containingDirectory, failedLookupLocations, state, cache);
	                if (!resolved_1)
	                    return undefined;
	                var resolvedValue = resolved_1.value;
	                var originalPath = void 0;
	                if (!compilerOptions.preserveSymlinks && resolvedValue) {
	                    originalPath = resolvedValue.path;
	                    var path = realPath(resolved_1.value.path, host, traceEnabled);
	                    if (path === originalPath) {
	                        originalPath = undefined;
	                    }
	                    resolvedValue = __assign({}, resolvedValue, { path: path });
	                }
	                // For node_modules lookups, get the real path so that multiple accesses to an `npm link`-ed module do not create duplicate files.
	                return { value: resolvedValue && { resolved: resolvedValue, originalPath: originalPath, isExternalLibraryImport: true } };
	            }
	            else {
	                var _a = ts.normalizePathAndParts(ts.combinePaths(containingDirectory, moduleName)), candidate = _a.path, parts = _a.parts;
	                var resolved_2 = nodeLoadModuleByRelativeName(extensions, candidate, failedLookupLocations, /*onlyRecordFailures*/ false, state, /*considerPackageJson*/ true);
	                // Treat explicit "node_modules" import as an external library import.
	                return resolved_2 && toSearchResult({ resolved: resolved_2, isExternalLibraryImport: ts.contains(parts, "node_modules") });
	            }
	        }
	    }
	    function realPath(path, host, traceEnabled) {
	        if (!host.realpath) {
	            return path;
	        }
	        var real = ts.normalizePath(host.realpath(path));
	        if (traceEnabled) {
	            trace(host, ts.Diagnostics.Resolving_real_path_for_0_result_1, path, real);
	        }
	        return real;
	    }
	    function nodeLoadModuleByRelativeName(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, considerPackageJson) {
	        if (state.traceEnabled) {
	            trace(state.host, ts.Diagnostics.Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_type_1, candidate, Extensions[extensions]);
	        }
	        if (!ts.pathEndsWithDirectorySeparator(candidate)) {
	            if (!onlyRecordFailures) {
	                var parentOfCandidate = ts.getDirectoryPath(candidate);
	                if (!directoryProbablyExists(parentOfCandidate, state.host)) {
	                    if (state.traceEnabled) {
	                        trace(state.host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, parentOfCandidate);
	                    }
	                    onlyRecordFailures = true;
	                }
	            }
	            var resolvedFromFile = loadModuleFromFile(extensions, candidate, failedLookupLocations, onlyRecordFailures, state);
	            if (resolvedFromFile) {
	                var nm = considerPackageJson ? parseNodeModuleFromPath(resolvedFromFile) : undefined;
	                var packageId = nm && getPackageJsonInfo(nm.packageDirectory, nm.subModuleName, failedLookupLocations, /*onlyRecordFailures*/ false, state).packageId;
	                return withPackageId(packageId, resolvedFromFile);
	            }
	        }
	        if (!onlyRecordFailures) {
	            var candidateExists = directoryProbablyExists(candidate, state.host);
	            if (!candidateExists) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, candidate);
	                }
	                onlyRecordFailures = true;
	            }
	        }
	        return loadNodeModuleFromDirectory(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, considerPackageJson);
	    }
	    var nodeModulesPathPart = "/node_modules/";
	    /**
	     * This will be called on the successfully resolved path from `loadModuleFromFile`.
	     * (Not neeeded for `loadModuleFromNodeModules` as that looks up the `package.json` as part of resolution.)
	     *
	     * packageDirectory is the directory of the package itself.
	     * subModuleName is the path within the package.
	     *   For `blah/node_modules/foo/index.d.ts` this is { packageDirectory: "foo", subModuleName: "index.d.ts" }. (Part before "/node_modules/" is ignored.)
	     *   For `/node_modules/foo/bar.d.ts` this is { packageDirectory: "foo", subModuleName": "bar/index.d.ts" }.
	     *   For `/node_modules/@types/foo/bar/index.d.ts` this is { packageDirectory: "@types/foo", subModuleName: "bar/index.d.ts" }.
	     *   For `/node_modules/foo/bar/index.d.ts` this is { packageDirectory: "foo", subModuleName": "bar/index.d.ts" }.
	     */
	    function parseNodeModuleFromPath(resolved) {
	        var path = ts.normalizePath(resolved.path);
	        var idx = path.lastIndexOf(nodeModulesPathPart);
	        if (idx === -1) {
	            return undefined;
	        }
	        var indexAfterNodeModules = idx + nodeModulesPathPart.length;
	        var indexAfterPackageName = moveToNextDirectorySeparatorIfAvailable(path, indexAfterNodeModules);
	        if (path.charCodeAt(indexAfterNodeModules) === 64 /* at */) {
	            indexAfterPackageName = moveToNextDirectorySeparatorIfAvailable(path, indexAfterPackageName);
	        }
	        var packageDirectory = path.slice(0, indexAfterPackageName);
	        var subModuleName = ts.removeExtension(path.slice(indexAfterPackageName + 1), resolved.ext) + ".d.ts" /* Dts */;
	        return { packageDirectory: packageDirectory, subModuleName: subModuleName };
	    }
	    function moveToNextDirectorySeparatorIfAvailable(path, prevSeparatorIndex) {
	        var nextSeparatorIndex = path.indexOf(ts.directorySeparator, prevSeparatorIndex + 1);
	        return nextSeparatorIndex === -1 ? prevSeparatorIndex : nextSeparatorIndex;
	    }
	    function addExtensionAndIndex(path) {
	        if (path === "") {
	            return "index.d.ts";
	        }
	        if (ts.endsWith(path, ".d.ts")) {
	            return path;
	        }
	        if (ts.endsWith(path, "/index")) {
	            return path + ".d.ts";
	        }
	        return path + "/index.d.ts";
	    }
	    /* @internal */
	    function directoryProbablyExists(directoryName, host) {
	        // if host does not support 'directoryExists' assume that directory will exist
	        return !host.directoryExists || host.directoryExists(directoryName);
	    }
	    ts.directoryProbablyExists = directoryProbablyExists;
	    function loadModuleFromFileNoPackageId(extensions, candidate, failedLookupLocations, onlyRecordFailures, state) {
	        return noPackageId(loadModuleFromFile(extensions, candidate, failedLookupLocations, onlyRecordFailures, state));
	    }
	    /**
	     * @param {boolean} onlyRecordFailures - if true then function won't try to actually load files but instead record all attempts as failures. This flag is necessary
	     * in cases when we know upfront that all load attempts will fail (because containing folder does not exists) however we still need to record all failed lookup locations.
	     */
	    function loadModuleFromFile(extensions, candidate, failedLookupLocations, onlyRecordFailures, state) {
	        // First, try adding an extension. An import of "foo" could be matched by a file "foo.ts", or "foo.js" by "foo.js.ts"
	        var resolvedByAddingExtension = tryAddingExtensions(candidate, extensions, failedLookupLocations, onlyRecordFailures, state);
	        if (resolvedByAddingExtension) {
	            return resolvedByAddingExtension;
	        }
	        // If that didn't work, try stripping a ".js" or ".jsx" extension and replacing it with a TypeScript one;
	        // e.g. "./foo.js" can be matched by "./foo.ts" or "./foo.d.ts"
	        if (ts.hasJavaScriptFileExtension(candidate)) {
	            var extensionless = ts.removeFileExtension(candidate);
	            if (state.traceEnabled) {
	                var extension = candidate.substring(extensionless.length);
	                trace(state.host, ts.Diagnostics.File_name_0_has_a_1_extension_stripping_it, candidate, extension);
	            }
	            return tryAddingExtensions(extensionless, extensions, failedLookupLocations, onlyRecordFailures, state);
	        }
	    }
	    /** Try to return an existing file that adds one of the `extensions` to `candidate`. */
	    function tryAddingExtensions(candidate, extensions, failedLookupLocations, onlyRecordFailures, state) {
	        if (!onlyRecordFailures) {
	            // check if containing folder exists - if it doesn't then just record failures for all supported extensions without disk probing
	            var directory = ts.getDirectoryPath(candidate);
	            if (directory) {
	                onlyRecordFailures = !directoryProbablyExists(directory, state.host);
	            }
	        }
	        switch (extensions) {
	            case Extensions.DtsOnly:
	                return tryExtension(".d.ts" /* Dts */);
	            case Extensions.TypeScript:
	                return tryExtension(".ts" /* Ts */) || tryExtension(".tsx" /* Tsx */) || tryExtension(".d.ts" /* Dts */);
	            case Extensions.JavaScript:
	                return tryExtension(".js" /* Js */) || tryExtension(".jsx" /* Jsx */);
	        }
	        function tryExtension(ext) {
	            var path = tryFile(candidate + ext, failedLookupLocations, onlyRecordFailures, state);
	            return path && { path: path, ext: ext };
	        }
	    }
	    /** Return the file if it exists. */
	    function tryFile(fileName, failedLookupLocations, onlyRecordFailures, state) {
	        if (!onlyRecordFailures) {
	            if (state.host.fileExists(fileName)) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.File_0_exist_use_it_as_a_name_resolution_result, fileName);
	                }
	                return fileName;
	            }
	            else {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.File_0_does_not_exist, fileName);
	                }
	            }
	        }
	        failedLookupLocations.push(fileName);
	        return undefined;
	    }
	    function loadNodeModuleFromDirectory(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, considerPackageJson) {
	        if (considerPackageJson === void 0) { considerPackageJson = true; }
	        var _a = considerPackageJson
	            ? getPackageJsonInfo(candidate, "", failedLookupLocations, onlyRecordFailures, state)
	            : { packageJsonContent: undefined, packageId: undefined }, packageJsonContent = _a.packageJsonContent, packageId = _a.packageId;
	        return withPackageId(packageId, loadNodeModuleFromDirectoryWorker(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, packageJsonContent));
	    }
	    function loadNodeModuleFromDirectoryWorker(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, packageJsonContent) {
	        var fromPackageJson = packageJsonContent && loadModuleFromPackageJson(packageJsonContent, extensions, candidate, failedLookupLocations, state);
	        if (fromPackageJson) {
	            return fromPackageJson;
	        }
	        var directoryExists = !onlyRecordFailures && directoryProbablyExists(candidate, state.host);
	        return loadModuleFromFile(extensions, ts.combinePaths(candidate, "index"), failedLookupLocations, !directoryExists, state);
	    }
	    function getPackageJsonInfo(nodeModuleDirectory, subModuleName, failedLookupLocations, onlyRecordFailures, state) {
	        var host = state.host, traceEnabled = state.traceEnabled;
	        var directoryExists = !onlyRecordFailures && directoryProbablyExists(nodeModuleDirectory, host);
	        var packageJsonPath = pathToPackageJson(nodeModuleDirectory);
	        if (directoryExists && host.fileExists(packageJsonPath)) {
	            var packageJsonContent = readJson(packageJsonPath, host);
	            if (subModuleName === "") {
	                var path = tryReadPackageJsonFields(/*readTypes*/ true, packageJsonContent, nodeModuleDirectory, state);
	                if (typeof path === "string") {
	                    subModuleName = addExtensionAndIndex(path.substring(nodeModuleDirectory.length + 1));
	                }
	                else {
	                    var jsPath = tryReadPackageJsonFields(/*readTypes*/ false, packageJsonContent, nodeModuleDirectory, state);
	                    if (typeof jsPath === "string") {
	                        subModuleName = ts.removeExtension(ts.removeExtension(jsPath.substring(nodeModuleDirectory.length + 1), ".js" /* Js */), ".jsx" /* Jsx */) + ".d.ts" /* Dts */;
	                    }
	                    else {
	                        subModuleName = "index.d.ts";
	                    }
	                }
	            }
	            if (!ts.endsWith(subModuleName, ".d.ts" /* Dts */)) {
	                subModuleName = addExtensionAndIndex(subModuleName);
	            }
	            var packageId = typeof packageJsonContent.name === "string" && typeof packageJsonContent.version === "string"
	                ? { name: packageJsonContent.name, subModuleName: subModuleName, version: packageJsonContent.version }
	                : undefined;
	            if (traceEnabled) {
	                if (packageId) {
	                    trace(host, ts.Diagnostics.Found_package_json_at_0_Package_ID_is_1, packageJsonPath, ts.packageIdToString(packageId));
	                }
	                else {
	                    trace(host, ts.Diagnostics.Found_package_json_at_0, packageJsonPath);
	                }
	            }
	            return { found: true, packageJsonContent: packageJsonContent, packageId: packageId };
	        }
	        else {
	            if (directoryExists && traceEnabled) {
	                trace(host, ts.Diagnostics.File_0_does_not_exist, packageJsonPath);
	            }
	            // record package json as one of failed lookup locations - in the future if this file will appear it will invalidate resolution results
	            failedLookupLocations.push(packageJsonPath);
	            return { found: false, packageJsonContent: undefined, packageId: undefined };
	        }
	    }
	    function loadModuleFromPackageJson(jsonContent, extensions, candidate, failedLookupLocations, state) {
	        var file = tryReadPackageJsonFields(extensions !== Extensions.JavaScript, jsonContent, candidate, state);
	        if (!file) {
	            return undefined;
	        }
	        var onlyRecordFailures = !directoryProbablyExists(ts.getDirectoryPath(file), state.host);
	        var fromFile = tryFile(file, failedLookupLocations, onlyRecordFailures, state);
	        if (fromFile) {
	            var resolved = fromFile && resolvedIfExtensionMatches(extensions, fromFile);
	            if (resolved) {
	                return resolved;
	            }
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.File_0_has_an_unsupported_extension_so_skipping_it, fromFile);
	            }
	        }
	        // Even if extensions is DtsOnly, we can still look up a .ts file as a result of package.json "types"
	        var nextExtensions = extensions === Extensions.DtsOnly ? Extensions.TypeScript : extensions;
	        // Don't do package.json lookup recursively, because Node.js' package lookup doesn't.
	        var result = nodeLoadModuleByRelativeName(nextExtensions, file, failedLookupLocations, onlyRecordFailures, state, /*considerPackageJson*/ false);
	        if (result) {
	            // It won't have a `packageId` set, because we disabled `considerPackageJson`.
	            ts.Debug.assert(result.packageId === undefined);
	            return { path: result.path, ext: result.extension };
	        }
	    }
	    /** Resolve from an arbitrarily specified file. Return `undefined` if it has an unsupported extension. */
	    function resolvedIfExtensionMatches(extensions, path) {
	        var ext = ts.tryGetExtensionFromPath(path);
	        return ext !== undefined && extensionIsOk(extensions, ext) ? { path: path, ext: ext } : undefined;
	    }
	    /** True if `extension` is one of the supported `extensions`. */
	    function extensionIsOk(extensions, extension) {
	        switch (extensions) {
	            case Extensions.JavaScript:
	                return extension === ".js" /* Js */ || extension === ".jsx" /* Jsx */;
	            case Extensions.TypeScript:
	                return extension === ".ts" /* Ts */ || extension === ".tsx" /* Tsx */ || extension === ".d.ts" /* Dts */;
	            case Extensions.DtsOnly:
	                return extension === ".d.ts" /* Dts */;
	        }
	    }
	    function pathToPackageJson(directory) {
	        return ts.combinePaths(directory, "package.json");
	    }
	    function loadModuleFromNodeModulesFolder(extensions, moduleName, nodeModulesFolder, nodeModulesFolderExists, failedLookupLocations, state) {
	        var candidate = ts.normalizePath(ts.combinePaths(nodeModulesFolder, moduleName));
	        // First look for a nested package.json, as in `node_modules/foo/bar/package.json`.
	        var packageJsonContent;
	        var packageId;
	        var packageInfo = getPackageJsonInfo(candidate, "", failedLookupLocations, /*onlyRecordFailures*/ !nodeModulesFolderExists, state);
	        if (packageInfo.found) {
	            (packageJsonContent = packageInfo.packageJsonContent, packageId = packageInfo.packageId);
	        }
	        else {
	            var _a = getPackageName(moduleName), packageName = _a.packageName, rest = _a.rest;
	            if (rest !== "") {
	                var packageRootPath = ts.combinePaths(nodeModulesFolder, packageName);
	                // Don't use a "types" or "main" from here because we're not loading the root, but a subdirectory -- just here for the packageId.
	                packageId = getPackageJsonInfo(packageRootPath, rest, failedLookupLocations, !nodeModulesFolderExists, state).packageId;
	            }
	        }
	        var pathAndExtension = loadModuleFromFile(extensions, candidate, failedLookupLocations, !nodeModulesFolderExists, state) ||
	            loadNodeModuleFromDirectoryWorker(extensions, candidate, failedLookupLocations, !nodeModulesFolderExists, state, packageJsonContent);
	        return withPackageId(packageId, pathAndExtension);
	    }
	    /* @internal */
	    function getPackageName(moduleName) {
	        var idx = moduleName.indexOf(ts.directorySeparator);
	        if (moduleName[0] === "@") {
	            idx = moduleName.indexOf(ts.directorySeparator, idx + 1);
	        }
	        return idx === -1 ? { packageName: moduleName, rest: "" } : { packageName: moduleName.slice(0, idx), rest: moduleName.slice(idx + 1) };
	    }
	    ts.getPackageName = getPackageName;
	    function loadModuleFromNodeModules(extensions, moduleName, directory, failedLookupLocations, state, cache) {
	        return loadModuleFromNodeModulesWorker(extensions, moduleName, directory, failedLookupLocations, state, /*typesOnly*/ false, cache);
	    }
	    function loadModuleFromNodeModulesAtTypes(moduleName, directory, failedLookupLocations, state) {
	        // Extensions parameter here doesn't actually matter, because typesOnly ensures we're just doing @types lookup, which is always DtsOnly.
	        return loadModuleFromNodeModulesWorker(Extensions.DtsOnly, moduleName, directory, failedLookupLocations, state, /*typesOnly*/ true, /*cache*/ undefined);
	    }
	    function loadModuleFromNodeModulesWorker(extensions, moduleName, directory, failedLookupLocations, state, typesOnly, cache) {
	        var perModuleNameCache = cache && cache.getOrCreateCacheForModuleName(moduleName);
	        return ts.forEachAncestorDirectory(ts.normalizeSlashes(directory), function (ancestorDirectory) {
	            if (ts.getBaseFileName(ancestorDirectory) !== "node_modules") {
	                var resolutionFromCache = tryFindNonRelativeModuleNameInCache(perModuleNameCache, moduleName, ancestorDirectory, state.traceEnabled, state.host);
	                if (resolutionFromCache) {
	                    return resolutionFromCache;
	                }
	                return toSearchResult(loadModuleFromNodeModulesOneLevel(extensions, moduleName, ancestorDirectory, failedLookupLocations, state, typesOnly));
	            }
	        });
	    }
	    /** Load a module from a single node_modules directory, but not from any ancestors' node_modules directories. */
	    function loadModuleFromNodeModulesOneLevel(extensions, moduleName, directory, failedLookupLocations, state, typesOnly) {
	        if (typesOnly === void 0) { typesOnly = false; }
	        var nodeModulesFolder = ts.combinePaths(directory, "node_modules");
	        var nodeModulesFolderExists = directoryProbablyExists(nodeModulesFolder, state.host);
	        if (!nodeModulesFolderExists && state.traceEnabled) {
	            trace(state.host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, nodeModulesFolder);
	        }
	        var packageResult = typesOnly ? undefined : loadModuleFromNodeModulesFolder(extensions, moduleName, nodeModulesFolder, nodeModulesFolderExists, failedLookupLocations, state);
	        if (packageResult) {
	            return packageResult;
	        }
	        if (extensions !== Extensions.JavaScript) {
	            var nodeModulesAtTypes_1 = ts.combinePaths(nodeModulesFolder, "@types");
	            var nodeModulesAtTypesExists = nodeModulesFolderExists;
	            if (nodeModulesFolderExists && !directoryProbablyExists(nodeModulesAtTypes_1, state.host)) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, nodeModulesAtTypes_1);
	                }
	                nodeModulesAtTypesExists = false;
	            }
	            return loadModuleFromNodeModulesFolder(Extensions.DtsOnly, mangleScopedPackage(moduleName, state), nodeModulesAtTypes_1, nodeModulesAtTypesExists, failedLookupLocations, state);
	        }
	    }
	    /** Double underscores are used in DefinitelyTyped to delimit scoped packages. */
	    var mangledScopedPackageSeparator = "__";
	    /** For a scoped package, we must look in `@types/foo__bar` instead of `@types/@foo/bar`. */
	    function mangleScopedPackage(packageName, state) {
	        var mangled = getMangledNameForScopedPackage(packageName);
	        if (state.traceEnabled && mangled !== packageName) {
	            trace(state.host, ts.Diagnostics.Scoped_package_detected_looking_in_0, mangled);
	        }
	        return mangled;
	    }
	    /* @internal */
	    function getTypesPackageName(packageName) {
	        return "@types/" + getMangledNameForScopedPackage(packageName);
	    }
	    ts.getTypesPackageName = getTypesPackageName;
	    function getMangledNameForScopedPackage(packageName) {
	        if (ts.startsWith(packageName, "@")) {
	            var replaceSlash = packageName.replace(ts.directorySeparator, mangledScopedPackageSeparator);
	            if (replaceSlash !== packageName) {
	                return replaceSlash.slice(1); // Take off the "@"
	            }
	        }
	        return packageName;
	    }
	    /* @internal */
	    function getPackageNameFromAtTypesDirectory(mangledName) {
	        var withoutAtTypePrefix = ts.removePrefix(mangledName, "@types/");
	        if (withoutAtTypePrefix !== mangledName) {
	            return getUnmangledNameForScopedPackage(withoutAtTypePrefix);
	        }
	        return mangledName;
	    }
	    ts.getPackageNameFromAtTypesDirectory = getPackageNameFromAtTypesDirectory;
	    /* @internal */
	    function getUnmangledNameForScopedPackage(typesPackageName) {
	        return ts.stringContains(typesPackageName, mangledScopedPackageSeparator) ?
	            "@" + typesPackageName.replace(mangledScopedPackageSeparator, ts.directorySeparator) :
	            typesPackageName;
	    }
	    ts.getUnmangledNameForScopedPackage = getUnmangledNameForScopedPackage;
	    function tryFindNonRelativeModuleNameInCache(cache, moduleName, containingDirectory, traceEnabled, host) {
	        var result = cache && cache.get(containingDirectory);
	        if (result) {
	            if (traceEnabled) {
	                trace(host, ts.Diagnostics.Resolution_for_module_0_was_found_in_cache, moduleName);
	            }
	            return { value: result.resolvedModule && { path: result.resolvedModule.resolvedFileName, extension: result.resolvedModule.extension, packageId: result.resolvedModule.packageId } };
	        }
	    }
	    function classicNameResolver(moduleName, containingFile, compilerOptions, host, cache) {
	        var traceEnabled = isTraceEnabled(compilerOptions, host);
	        var state = { compilerOptions: compilerOptions, host: host, traceEnabled: traceEnabled };
	        var failedLookupLocations = [];
	        var containingDirectory = ts.getDirectoryPath(containingFile);
	        var resolved = tryResolve(Extensions.TypeScript) || tryResolve(Extensions.JavaScript);
	        // No originalPath because classic resolution doesn't resolve realPath
	        return createResolvedModuleWithFailedLookupLocations(resolved && resolved.value, /*originalPath*/ undefined, /*isExternalLibraryImport*/ false, failedLookupLocations);
	        function tryResolve(extensions) {
	            var resolvedUsingSettings = tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loadModuleFromFileNoPackageId, failedLookupLocations, state);
	            if (resolvedUsingSettings) {
	                return { value: resolvedUsingSettings };
	            }
	            var perModuleNameCache = cache && cache.getOrCreateCacheForModuleName(moduleName);
	            if (!ts.isExternalModuleNameRelative(moduleName)) {
	                // Climb up parent directories looking for a module.
	                var resolved_3 = ts.forEachAncestorDirectory(containingDirectory, function (directory) {
	                    var resolutionFromCache = tryFindNonRelativeModuleNameInCache(perModuleNameCache, moduleName, directory, traceEnabled, host);
	                    if (resolutionFromCache) {
	                        return resolutionFromCache;
	                    }
	                    var searchName = ts.normalizePath(ts.combinePaths(directory, moduleName));
	                    return toSearchResult(loadModuleFromFileNoPackageId(extensions, searchName, failedLookupLocations, /*onlyRecordFailures*/ false, state));
	                });
	                if (resolved_3) {
	                    return resolved_3;
	                }
	                if (extensions === Extensions.TypeScript) {
	                    // If we didn't find the file normally, look it up in @types.
	                    return loadModuleFromNodeModulesAtTypes(moduleName, containingDirectory, failedLookupLocations, state);
	                }
	            }
	            else {
	                var candidate = ts.normalizePath(ts.combinePaths(containingDirectory, moduleName));
	                return toSearchResult(loadModuleFromFileNoPackageId(extensions, candidate, failedLookupLocations, /*onlyRecordFailures*/ false, state));
	            }
	        }
	    }
	    ts.classicNameResolver = classicNameResolver;
	    /**
	     * LSHost may load a module from a global cache of typings.
	     * This is the minumum code needed to expose that functionality; the rest is in LSHost.
	     */
	    /* @internal */
	    function loadModuleFromGlobalCache(moduleName, projectName, compilerOptions, host, globalCache) {
	        var traceEnabled = isTraceEnabled(compilerOptions, host);
	        if (traceEnabled) {
	            trace(host, ts.Diagnostics.Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using_cache_location_2, projectName, moduleName, globalCache);
	        }
	        var state = { compilerOptions: compilerOptions, host: host, traceEnabled: traceEnabled };
	        var failedLookupLocations = [];
	        var resolved = loadModuleFromNodeModulesOneLevel(Extensions.DtsOnly, moduleName, globalCache, failedLookupLocations, state);
	        return createResolvedModuleWithFailedLookupLocations(resolved, /*originalPath*/ undefined, /*isExternalLibraryImport*/ true, failedLookupLocations);
	    }
	    ts.loadModuleFromGlobalCache = loadModuleFromGlobalCache;
	    /**
	     * Wraps value to SearchResult.
	     * @returns undefined if value is undefined or { value } otherwise
	     */
	    function toSearchResult(value) {
	        return value !== undefined ? { value: value } : undefined;
	    }
	})(ts || (ts = {}));
	/// <reference path="moduleNameResolver.ts"/>
	/// <reference path="binder.ts"/>
	/// <reference path="symbolWalker.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    var ambientModuleSymbolRegex = /^".+"$/;
	    var nextSymbolId = 1;
	    var nextNodeId = 1;
	    var nextMergeId = 1;
	    var nextFlowId = 1;
	    function getNodeId(node) {
	        if (!node.id) {
	            node.id = nextNodeId;
	            nextNodeId++;
	        }
	        return node.id;
	    }
	    ts.getNodeId = getNodeId;
	    function getSymbolId(symbol) {
	        if (!symbol.id) {
	            symbol.id = nextSymbolId;
	            nextSymbolId++;
	        }
	        return symbol.id;
	    }
	    ts.getSymbolId = getSymbolId;
	    function isInstantiatedModule(node, preserveConstEnums) {
	        var moduleState = ts.getModuleInstanceState(node);
	        return moduleState === 1 /* Instantiated */ ||
	            (preserveConstEnums && moduleState === 2 /* ConstEnumOnly */);
	    }
	    ts.isInstantiatedModule = isInstantiatedModule;
	    function createTypeChecker(host, produceDiagnostics) {
	        // Cancellation that controls whether or not we can cancel in the middle of type checking.
	        // In general cancelling is *not* safe for the type checker.  We might be in the middle of
	        // computing something, and we will leave our internals in an inconsistent state.  Callers
	        // who set the cancellation token should catch if a cancellation exception occurs, and
	        // should throw away and create a new TypeChecker.
	        //
	        // Currently we only support setting the cancellation token when getting diagnostics.  This
	        // is because diagnostics can be quite expensive, and we want to allow hosts to bail out if
	        // they no longer need the information (for example, if the user started editing again).
	        var cancellationToken;
	        var requestedExternalEmitHelpers;
	        var externalHelpersModule;
	        // tslint:disable variable-name
	        var Symbol = ts.objectAllocator.getSymbolConstructor();
	        var Type = ts.objectAllocator.getTypeConstructor();
	        var Signature = ts.objectAllocator.getSignatureConstructor();
	        // tslint:enable variable-name
	        var typeCount = 0;
	        var symbolCount = 0;
	        var enumCount = 0;
	        var symbolInstantiationDepth = 0;
	        var emptySymbols = ts.createSymbolTable();
	        var identityMapper = ts.identity;
	        var compilerOptions = host.getCompilerOptions();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var modulekind = ts.getEmitModuleKind(compilerOptions);
	        var noUnusedIdentifiers = !!compilerOptions.noUnusedLocals || !!compilerOptions.noUnusedParameters;
	        var allowSyntheticDefaultImports = ts.getAllowSyntheticDefaultImports(compilerOptions);
	        var strictNullChecks = ts.getStrictOptionValue(compilerOptions, "strictNullChecks");
	        var strictFunctionTypes = ts.getStrictOptionValue(compilerOptions, "strictFunctionTypes");
	        var strictPropertyInitialization = ts.getStrictOptionValue(compilerOptions, "strictPropertyInitialization");
	        var noImplicitAny = ts.getStrictOptionValue(compilerOptions, "noImplicitAny");
	        var noImplicitThis = ts.getStrictOptionValue(compilerOptions, "noImplicitThis");
	        var emitResolver = createResolver();
	        var nodeBuilder = createNodeBuilder();
	        var undefinedSymbol = createSymbol(4 /* Property */, "undefined");
	        undefinedSymbol.declarations = [];
	        var argumentsSymbol = createSymbol(4 /* Property */, "arguments");
	        /** This will be set during calls to `getResolvedSignature` where services determines an apparent number of arguments greater than what is actually provided. */
	        var apparentArgumentCount;
	        // for public members that accept a Node or one of its subtypes, we must guard against
	        // synthetic nodes created during transformations by calling `getParseTreeNode`.
	        // for most of these, we perform the guard only on `checker` to avoid any possible
	        // extra cost of calling `getParseTreeNode` when calling these functions from inside the
	        // checker.
	        var checker = {
	            getNodeCount: function () { return ts.sum(host.getSourceFiles(), "nodeCount"); },
	            getIdentifierCount: function () { return ts.sum(host.getSourceFiles(), "identifierCount"); },
	            getSymbolCount: function () { return ts.sum(host.getSourceFiles(), "symbolCount") + symbolCount; },
	            getTypeCount: function () { return typeCount; },
	            isUndefinedSymbol: function (symbol) { return symbol === undefinedSymbol; },
	            isArgumentsSymbol: function (symbol) { return symbol === argumentsSymbol; },
	            isUnknownSymbol: function (symbol) { return symbol === unknownSymbol; },
	            getMergedSymbol: getMergedSymbol,
	            getDiagnostics: getDiagnostics,
	            getGlobalDiagnostics: getGlobalDiagnostics,
	            getTypeOfSymbolAtLocation: function (symbol, location) {
	                location = ts.getParseTreeNode(location);
	                return location ? getTypeOfSymbolAtLocation(symbol, location) : unknownType;
	            },
	            getSymbolsOfParameterPropertyDeclaration: function (parameter, parameterName) {
	                parameter = ts.getParseTreeNode(parameter, ts.isParameter);
	                ts.Debug.assert(parameter !== undefined, "Cannot get symbols of a synthetic parameter that cannot be resolved to a parse-tree node.");
	                return getSymbolsOfParameterPropertyDeclaration(parameter, ts.escapeLeadingUnderscores(parameterName));
	            },
	            getDeclaredTypeOfSymbol: getDeclaredTypeOfSymbol,
	            getPropertiesOfType: getPropertiesOfType,
	            getPropertyOfType: function (type, name) { return getPropertyOfType(type, ts.escapeLeadingUnderscores(name)); },
	            getIndexInfoOfType: getIndexInfoOfType,
	            getSignaturesOfType: getSignaturesOfType,
	            getIndexTypeOfType: getIndexTypeOfType,
	            getBaseTypes: getBaseTypes,
	            getBaseTypeOfLiteralType: getBaseTypeOfLiteralType,
	            getWidenedType: getWidenedType,
	            getTypeFromTypeNode: function (node) {
	                node = ts.getParseTreeNode(node, ts.isTypeNode);
	                return node ? getTypeFromTypeNode(node) : unknownType;
	            },
	            getParameterType: getTypeAtPosition,
	            getReturnTypeOfSignature: getReturnTypeOfSignature,
	            getNullableType: getNullableType,
	            getNonNullableType: getNonNullableType,
	            typeToTypeNode: nodeBuilder.typeToTypeNode,
	            indexInfoToIndexSignatureDeclaration: nodeBuilder.indexInfoToIndexSignatureDeclaration,
	            signatureToSignatureDeclaration: nodeBuilder.signatureToSignatureDeclaration,
	            symbolToEntityName: nodeBuilder.symbolToEntityName,
	            symbolToExpression: nodeBuilder.symbolToExpression,
	            symbolToTypeParameterDeclarations: nodeBuilder.symbolToTypeParameterDeclarations,
	            symbolToParameterDeclaration: nodeBuilder.symbolToParameterDeclaration,
	            typeParameterToDeclaration: nodeBuilder.typeParameterToDeclaration,
	            getSymbolsInScope: function (location, meaning) {
	                location = ts.getParseTreeNode(location);
	                return location ? getSymbolsInScope(location, meaning) : [];
	            },
	            getSymbolAtLocation: function (node) {
	                node = ts.getParseTreeNode(node);
	                return node ? getSymbolAtLocation(node) : undefined;
	            },
	            getShorthandAssignmentValueSymbol: function (node) {
	                node = ts.getParseTreeNode(node);
	                return node ? getShorthandAssignmentValueSymbol(node) : undefined;
	            },
	            getExportSpecifierLocalTargetSymbol: function (node) {
	                node = ts.getParseTreeNode(node, ts.isExportSpecifier);
	                return node ? getExportSpecifierLocalTargetSymbol(node) : undefined;
	            },
	            getExportSymbolOfSymbol: function (symbol) {
	                return getMergedSymbol(symbol.exportSymbol || symbol);
	            },
	            getTypeAtLocation: function (node) {
	                node = ts.getParseTreeNode(node);
	                return node ? getTypeOfNode(node) : unknownType;
	            },
	            getPropertySymbolOfDestructuringAssignment: function (location) {
	                location = ts.getParseTreeNode(location, ts.isIdentifier);
	                return location ? getPropertySymbolOfDestructuringAssignment(location) : undefined;
	            },
	            signatureToString: function (signature, enclosingDeclaration, flags, kind) {
	                return signatureToString(signature, ts.getParseTreeNode(enclosingDeclaration), flags, kind);
	            },
	            typeToString: function (type, enclosingDeclaration, flags) {
	                return typeToString(type, ts.getParseTreeNode(enclosingDeclaration), flags);
	            },
	            symbolToString: function (symbol, enclosingDeclaration, meaning, flags) {
	                return symbolToString(symbol, ts.getParseTreeNode(enclosingDeclaration), meaning, flags);
	            },
	            typePredicateToString: function (predicate, enclosingDeclaration, flags) {
	                return typePredicateToString(predicate, ts.getParseTreeNode(enclosingDeclaration), flags);
	            },
	            writeSignature: function (signature, enclosingDeclaration, flags, kind, writer) {
	                return signatureToString(signature, ts.getParseTreeNode(enclosingDeclaration), flags, kind, writer);
	            },
	            writeType: function (type, enclosingDeclaration, flags, writer) {
	                return typeToString(type, ts.getParseTreeNode(enclosingDeclaration), flags, writer);
	            },
	            writeSymbol: function (symbol, enclosingDeclaration, meaning, flags, writer) {
	                return symbolToString(symbol, ts.getParseTreeNode(enclosingDeclaration), meaning, flags, writer);
	            },
	            writeTypePredicate: function (predicate, enclosingDeclaration, flags, writer) {
	                return typePredicateToString(predicate, ts.getParseTreeNode(enclosingDeclaration), flags, writer);
	            },
	            getSymbolDisplayBuilder: getSymbolDisplayBuilder,
	            getAugmentedPropertiesOfType: getAugmentedPropertiesOfType,
	            getRootSymbols: getRootSymbols,
	            getContextualType: function (node) {
	                node = ts.getParseTreeNode(node, ts.isExpression);
	                return node ? getContextualType(node) : undefined;
	            },
	            getContextualTypeForArgumentAtIndex: function (node, argIndex) {
	                node = ts.getParseTreeNode(node, ts.isCallLikeExpression);
	                return node && getContextualTypeForArgumentAtIndex(node, argIndex);
	            },
	            getContextualTypeForJsxAttribute: function (node) {
	                node = ts.getParseTreeNode(node, ts.isJsxAttributeLike);
	                return node && getContextualTypeForJsxAttribute(node);
	            },
	            isContextSensitive: isContextSensitive,
	            getFullyQualifiedName: getFullyQualifiedName,
	            getResolvedSignature: function (node, candidatesOutArray, theArgumentCount) {
	                node = ts.getParseTreeNode(node, ts.isCallLikeExpression);
	                apparentArgumentCount = theArgumentCount;
	                var res = node ? getResolvedSignature(node, candidatesOutArray) : undefined;
	                apparentArgumentCount = undefined;
	                return res;
	            },
	            getConstantValue: function (node) {
	                node = ts.getParseTreeNode(node, canHaveConstantValue);
	                return node ? getConstantValue(node) : undefined;
	            },
	            isValidPropertyAccess: function (node, propertyName) {
	                node = ts.getParseTreeNode(node, ts.isPropertyAccessOrQualifiedName);
	                return !!node && isValidPropertyAccess(node, ts.escapeLeadingUnderscores(propertyName));
	            },
	            isValidPropertyAccessForCompletions: function (node, type, property) {
	                node = ts.getParseTreeNode(node, ts.isPropertyAccessExpression);
	                return !!node && isValidPropertyAccessForCompletions(node, type, property);
	            },
	            getSignatureFromDeclaration: function (declaration) {
	                declaration = ts.getParseTreeNode(declaration, ts.isFunctionLike);
	                return declaration ? getSignatureFromDeclaration(declaration) : undefined;
	            },
	            isImplementationOfOverload: function (node) {
	                var parsed = ts.getParseTreeNode(node, ts.isFunctionLike);
	                return parsed ? isImplementationOfOverload(parsed) : undefined;
	            },
	            getImmediateAliasedSymbol: function (symbol) {
	                ts.Debug.assert((symbol.flags & 2097152 /* Alias */) !== 0, "Should only get Alias here.");
	                var links = getSymbolLinks(symbol);
	                if (!links.immediateTarget) {
	                    var node = getDeclarationOfAliasSymbol(symbol);
	                    ts.Debug.assert(!!node);
	                    links.immediateTarget = getTargetOfAliasDeclaration(node, /*dontRecursivelyResolve*/ true);
	                }
	                return links.immediateTarget;
	            },
	            getAliasedSymbol: resolveAlias,
	            getEmitResolver: getEmitResolver,
	            getExportsOfModule: getExportsOfModuleAsArray,
	            getExportsAndPropertiesOfModule: getExportsAndPropertiesOfModule,
	            getSymbolWalker: ts.createGetSymbolWalker(getRestTypeOfSignature, getTypePredicateOfSignature, getReturnTypeOfSignature, getBaseTypes, resolveStructuredTypeMembers, getTypeOfSymbol, getResolvedSymbol, getIndexTypeOfStructuredType, getConstraintFromTypeParameter, getFirstIdentifier),
	            getAmbientModules: getAmbientModules,
	            getAllAttributesTypeFromJsxOpeningLikeElement: function (node) {
	                node = ts.getParseTreeNode(node, ts.isJsxOpeningLikeElement);
	                return node ? getAllAttributesTypeFromJsxOpeningLikeElement(node) : undefined;
	            },
	            getJsxIntrinsicTagNames: getJsxIntrinsicTagNames,
	            isOptionalParameter: function (node) {
	                node = ts.getParseTreeNode(node, ts.isParameter);
	                return node ? isOptionalParameter(node) : false;
	            },
	            tryGetMemberInModuleExports: function (name, symbol) { return tryGetMemberInModuleExports(ts.escapeLeadingUnderscores(name), symbol); },
	            tryGetMemberInModuleExportsAndProperties: function (name, symbol) { return tryGetMemberInModuleExportsAndProperties(ts.escapeLeadingUnderscores(name), symbol); },
	            tryFindAmbientModuleWithoutAugmentations: function (moduleName) {
	                // we deliberately exclude augmentations
	                // since we are only interested in declarations of the module itself
	                return tryFindAmbientModule(moduleName, /*withAugmentations*/ false);
	            },
	            getApparentType: getApparentType,
	            getUnionType: getUnionType,
	            createAnonymousType: createAnonymousType,
	            createSignature: createSignature,
	            createSymbol: createSymbol,
	            createIndexInfo: createIndexInfo,
	            getAnyType: function () { return anyType; },
	            getStringType: function () { return stringType; },
	            getNumberType: function () { return numberType; },
	            createPromiseType: createPromiseType,
	            createArrayType: createArrayType,
	            getBooleanType: function () { return booleanType; },
	            getVoidType: function () { return voidType; },
	            getUndefinedType: function () { return undefinedType; },
	            getNullType: function () { return nullType; },
	            getESSymbolType: function () { return esSymbolType; },
	            getNeverType: function () { return neverType; },
	            isSymbolAccessible: isSymbolAccessible,
	            isArrayLikeType: isArrayLikeType,
	            getAllPossiblePropertiesOfTypes: getAllPossiblePropertiesOfTypes,
	            getSuggestionForNonexistentProperty: function (node, type) { return getSuggestionForNonexistentProperty(node, type); },
	            getSuggestionForNonexistentSymbol: function (location, name, meaning) { return getSuggestionForNonexistentSymbol(location, ts.escapeLeadingUnderscores(name), meaning); },
	            getBaseConstraintOfType: getBaseConstraintOfType,
	            getDefaultFromTypeParameter: function (type) { return type && type.flags & 32768 /* TypeParameter */ ? getDefaultFromTypeParameter(type) : undefined; },
	            resolveName: function (name, location, meaning, excludeGlobals) {
	                return resolveName(location, ts.escapeLeadingUnderscores(name), meaning, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false, excludeGlobals);
	            },
	            getJsxNamespace: function () { return ts.unescapeLeadingUnderscores(getJsxNamespace()); },
	            getAccessibleSymbolChain: getAccessibleSymbolChain,
	            getTypePredicateOfSignature: getTypePredicateOfSignature,
	            resolveExternalModuleSymbol: resolveExternalModuleSymbol,
	            tryGetThisTypeAt: function (node) {
	                node = ts.getParseTreeNode(node);
	                return node && tryGetThisTypeAt(node);
	            },
	            getTypeArgumentConstraint: function (node) {
	                node = ts.getParseTreeNode(node, ts.isTypeNode);
	                return node && getTypeArgumentConstraint(node);
	            },
	        };
	        var tupleTypes = [];
	        var unionTypes = ts.createMap();
	        var intersectionTypes = ts.createMap();
	        var literalTypes = ts.createMap();
	        var indexedAccessTypes = ts.createMap();
	        var conditionalTypes = ts.createMap();
	        var evolvingArrayTypes = [];
	        var undefinedProperties = ts.createMap();
	        var unknownSymbol = createSymbol(4 /* Property */, "unknown");
	        var resolvingSymbol = createSymbol(0, "__resolving__" /* Resolving */);
	        var anyType = createIntrinsicType(1 /* Any */, "any");
	        var autoType = createIntrinsicType(1 /* Any */, "any");
	        var wildcardType = createIntrinsicType(1 /* Any */, "any");
	        var unknownType = createIntrinsicType(1 /* Any */, "unknown");
	        var undefinedType = createIntrinsicType(4096 /* Undefined */, "undefined");
	        var undefinedWideningType = strictNullChecks ? undefinedType : createIntrinsicType(4096 /* Undefined */ | 16777216 /* ContainsWideningType */, "undefined");
	        var nullType = createIntrinsicType(8192 /* Null */, "null");
	        var nullWideningType = strictNullChecks ? nullType : createIntrinsicType(8192 /* Null */ | 16777216 /* ContainsWideningType */, "null");
	        var stringType = createIntrinsicType(2 /* String */, "string");
	        var numberType = createIntrinsicType(4 /* Number */, "number");
	        var trueType = createIntrinsicType(128 /* BooleanLiteral */, "true");
	        var falseType = createIntrinsicType(128 /* BooleanLiteral */, "false");
	        var booleanType = createBooleanType([trueType, falseType]);
	        var esSymbolType = createIntrinsicType(512 /* ESSymbol */, "symbol");
	        var voidType = createIntrinsicType(2048 /* Void */, "void");
	        var neverType = createIntrinsicType(16384 /* Never */, "never");
	        var silentNeverType = createIntrinsicType(16384 /* Never */, "never");
	        var implicitNeverType = createIntrinsicType(16384 /* Never */, "never");
	        var nonPrimitiveType = createIntrinsicType(134217728 /* NonPrimitive */, "object");
	        var emptyObjectType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var emptyTypeLiteralSymbol = createSymbol(2048 /* TypeLiteral */, "__type" /* Type */);
	        emptyTypeLiteralSymbol.members = ts.createSymbolTable();
	        var emptyTypeLiteralType = createAnonymousType(emptyTypeLiteralSymbol, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var emptyGenericType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        emptyGenericType.instantiations = ts.createMap();
	        var anyFunctionType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        // The anyFunctionType contains the anyFunctionType by definition. The flag is further propagated
	        // in getPropagatingFlagsOfTypes, and it is checked in inferFromTypes.
	        anyFunctionType.flags |= 67108864 /* ContainsAnyFunctionType */;
	        var noConstraintType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var circularConstraintType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var resolvingDefaultType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var markerSuperType = createType(32768 /* TypeParameter */);
	        var markerSubType = createType(32768 /* TypeParameter */);
	        markerSubType.constraint = markerSuperType;
	        var markerOtherType = createType(32768 /* TypeParameter */);
	        var noTypePredicate = createIdentifierTypePredicate("<<unresolved>>", 0, anyType);
	        var anySignature = createSignature(undefined, undefined, undefined, ts.emptyArray, anyType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	        var unknownSignature = createSignature(undefined, undefined, undefined, ts.emptyArray, unknownType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	        var resolvingSignature = createSignature(undefined, undefined, undefined, ts.emptyArray, anyType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	        var silentNeverSignature = createSignature(undefined, undefined, undefined, ts.emptyArray, silentNeverType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	        var enumNumberIndexInfo = createIndexInfo(stringType, /*isReadonly*/ true);
	        var jsObjectLiteralIndexInfo = createIndexInfo(anyType, /*isReadonly*/ false);
	        var globals = ts.createSymbolTable();
	        var reverseMappedCache = ts.createMap();
	        var ambientModulesCache;
	        /**
	         * List of every ambient module with a "*" wildcard.
	         * Unlike other ambient modules, these can't be stored in `globals` because symbol tables only deal with exact matches.
	         * This is only used if there is no exact match.
	         */
	        var patternAmbientModules;
	        var globalObjectType;
	        var globalFunctionType;
	        var globalArrayType;
	        var globalReadonlyArrayType;
	        var globalStringType;
	        var globalNumberType;
	        var globalBooleanType;
	        var globalRegExpType;
	        var globalThisType;
	        var anyArrayType;
	        var autoArrayType;
	        var anyReadonlyArrayType;
	        // The library files are only loaded when the feature is used.
	        // This allows users to just specify library files they want to used through --lib
	        // and they will not get an error from not having unrelated library files
	        var deferredGlobalESSymbolConstructorSymbol;
	        var deferredGlobalESSymbolType;
	        var deferredGlobalTypedPropertyDescriptorType;
	        var deferredGlobalPromiseType;
	        var deferredGlobalPromiseConstructorSymbol;
	        var deferredGlobalPromiseConstructorLikeType;
	        var deferredGlobalIterableType;
	        var deferredGlobalIteratorType;
	        var deferredGlobalIterableIteratorType;
	        var deferredGlobalAsyncIterableType;
	        var deferredGlobalAsyncIteratorType;
	        var deferredGlobalAsyncIterableIteratorType;
	        var deferredGlobalTemplateStringsArrayType;
	        var deferredJsxElementClassType;
	        var deferredJsxElementType;
	        var deferredJsxStatelessElementType;
	        var deferredNodes;
	        var deferredUnusedIdentifierNodes;
	        var flowLoopStart = 0;
	        var flowLoopCount = 0;
	        var sharedFlowCount = 0;
	        var flowAnalysisDisabled = false;
	        var emptyStringType = getLiteralType("");
	        var zeroType = getLiteralType(0);
	        var resolutionTargets = [];
	        var resolutionResults = [];
	        var resolutionPropertyNames = [];
	        var suggestionCount = 0;
	        var maximumSuggestionCount = 10;
	        var mergedSymbols = [];
	        var symbolLinks = [];
	        var nodeLinks = [];
	        var flowLoopCaches = [];
	        var flowLoopNodes = [];
	        var flowLoopKeys = [];
	        var flowLoopTypes = [];
	        var sharedFlowNodes = [];
	        var sharedFlowTypes = [];
	        var potentialThisCollisions = [];
	        var potentialNewTargetCollisions = [];
	        var awaitedTypeStack = [];
	        var diagnostics = ts.createDiagnosticCollection();
	        var TypeFacts;
	        (function (TypeFacts) {
	            TypeFacts[TypeFacts["None"] = 0] = "None";
	            TypeFacts[TypeFacts["TypeofEQString"] = 1] = "TypeofEQString";
	            TypeFacts[TypeFacts["TypeofEQNumber"] = 2] = "TypeofEQNumber";
	            TypeFacts[TypeFacts["TypeofEQBoolean"] = 4] = "TypeofEQBoolean";
	            TypeFacts[TypeFacts["TypeofEQSymbol"] = 8] = "TypeofEQSymbol";
	            TypeFacts[TypeFacts["TypeofEQObject"] = 16] = "TypeofEQObject";
	            TypeFacts[TypeFacts["TypeofEQFunction"] = 32] = "TypeofEQFunction";
	            TypeFacts[TypeFacts["TypeofEQHostObject"] = 64] = "TypeofEQHostObject";
	            TypeFacts[TypeFacts["TypeofNEString"] = 128] = "TypeofNEString";
	            TypeFacts[TypeFacts["TypeofNENumber"] = 256] = "TypeofNENumber";
	            TypeFacts[TypeFacts["TypeofNEBoolean"] = 512] = "TypeofNEBoolean";
	            TypeFacts[TypeFacts["TypeofNESymbol"] = 1024] = "TypeofNESymbol";
	            TypeFacts[TypeFacts["TypeofNEObject"] = 2048] = "TypeofNEObject";
	            TypeFacts[TypeFacts["TypeofNEFunction"] = 4096] = "TypeofNEFunction";
	            TypeFacts[TypeFacts["TypeofNEHostObject"] = 8192] = "TypeofNEHostObject";
	            TypeFacts[TypeFacts["EQUndefined"] = 16384] = "EQUndefined";
	            TypeFacts[TypeFacts["EQNull"] = 32768] = "EQNull";
	            TypeFacts[TypeFacts["EQUndefinedOrNull"] = 65536] = "EQUndefinedOrNull";
	            TypeFacts[TypeFacts["NEUndefined"] = 131072] = "NEUndefined";
	            TypeFacts[TypeFacts["NENull"] = 262144] = "NENull";
	            TypeFacts[TypeFacts["NEUndefinedOrNull"] = 524288] = "NEUndefinedOrNull";
	            TypeFacts[TypeFacts["Truthy"] = 1048576] = "Truthy";
	            TypeFacts[TypeFacts["Falsy"] = 2097152] = "Falsy";
	            TypeFacts[TypeFacts["Discriminatable"] = 4194304] = "Discriminatable";
	            TypeFacts[TypeFacts["All"] = 8388607] = "All";
	            // The following members encode facts about particular kinds of types for use in the getTypeFacts function.
	            // The presence of a particular fact means that the given test is true for some (and possibly all) values
	            // of that kind of type.
	            TypeFacts[TypeFacts["BaseStringStrictFacts"] = 933633] = "BaseStringStrictFacts";
	            TypeFacts[TypeFacts["BaseStringFacts"] = 3145473] = "BaseStringFacts";
	            TypeFacts[TypeFacts["StringStrictFacts"] = 4079361] = "StringStrictFacts";
	            TypeFacts[TypeFacts["StringFacts"] = 4194049] = "StringFacts";
	            TypeFacts[TypeFacts["EmptyStringStrictFacts"] = 3030785] = "EmptyStringStrictFacts";
	            TypeFacts[TypeFacts["EmptyStringFacts"] = 3145473] = "EmptyStringFacts";
	            TypeFacts[TypeFacts["NonEmptyStringStrictFacts"] = 1982209] = "NonEmptyStringStrictFacts";
	            TypeFacts[TypeFacts["NonEmptyStringFacts"] = 4194049] = "NonEmptyStringFacts";
	            TypeFacts[TypeFacts["BaseNumberStrictFacts"] = 933506] = "BaseNumberStrictFacts";
	            TypeFacts[TypeFacts["BaseNumberFacts"] = 3145346] = "BaseNumberFacts";
	            TypeFacts[TypeFacts["NumberStrictFacts"] = 4079234] = "NumberStrictFacts";
	            TypeFacts[TypeFacts["NumberFacts"] = 4193922] = "NumberFacts";
	            TypeFacts[TypeFacts["ZeroStrictFacts"] = 3030658] = "ZeroStrictFacts";
	            TypeFacts[TypeFacts["ZeroFacts"] = 3145346] = "ZeroFacts";
	            TypeFacts[TypeFacts["NonZeroStrictFacts"] = 1982082] = "NonZeroStrictFacts";
	            TypeFacts[TypeFacts["NonZeroFacts"] = 4193922] = "NonZeroFacts";
	            TypeFacts[TypeFacts["BaseBooleanStrictFacts"] = 933252] = "BaseBooleanStrictFacts";
	            TypeFacts[TypeFacts["BaseBooleanFacts"] = 3145092] = "BaseBooleanFacts";
	            TypeFacts[TypeFacts["BooleanStrictFacts"] = 4078980] = "BooleanStrictFacts";
	            TypeFacts[TypeFacts["BooleanFacts"] = 4193668] = "BooleanFacts";
	            TypeFacts[TypeFacts["FalseStrictFacts"] = 3030404] = "FalseStrictFacts";
	            TypeFacts[TypeFacts["FalseFacts"] = 3145092] = "FalseFacts";
	            TypeFacts[TypeFacts["TrueStrictFacts"] = 1981828] = "TrueStrictFacts";
	            TypeFacts[TypeFacts["TrueFacts"] = 4193668] = "TrueFacts";
	            TypeFacts[TypeFacts["SymbolStrictFacts"] = 1981320] = "SymbolStrictFacts";
	            TypeFacts[TypeFacts["SymbolFacts"] = 4193160] = "SymbolFacts";
	            TypeFacts[TypeFacts["ObjectStrictFacts"] = 6166480] = "ObjectStrictFacts";
	            TypeFacts[TypeFacts["ObjectFacts"] = 8378320] = "ObjectFacts";
	            TypeFacts[TypeFacts["FunctionStrictFacts"] = 6164448] = "FunctionStrictFacts";
	            TypeFacts[TypeFacts["FunctionFacts"] = 8376288] = "FunctionFacts";
	            TypeFacts[TypeFacts["UndefinedFacts"] = 2457472] = "UndefinedFacts";
	            TypeFacts[TypeFacts["NullFacts"] = 2340752] = "NullFacts";
	        })(TypeFacts || (TypeFacts = {}));
	        var typeofEQFacts = ts.createMapFromTemplate({
	            string: 1 /* TypeofEQString */,
	            number: 2 /* TypeofEQNumber */,
	            boolean: 4 /* TypeofEQBoolean */,
	            symbol: 8 /* TypeofEQSymbol */,
	            undefined: 16384 /* EQUndefined */,
	            object: 16 /* TypeofEQObject */,
	            function: 32 /* TypeofEQFunction */
	        });
	        var typeofNEFacts = ts.createMapFromTemplate({
	            string: 128 /* TypeofNEString */,
	            number: 256 /* TypeofNENumber */,
	            boolean: 512 /* TypeofNEBoolean */,
	            symbol: 1024 /* TypeofNESymbol */,
	            undefined: 131072 /* NEUndefined */,
	            object: 2048 /* TypeofNEObject */,
	            function: 4096 /* TypeofNEFunction */
	        });
	        var typeofTypesByName = ts.createMapFromTemplate({
	            string: stringType,
	            number: numberType,
	            boolean: booleanType,
	            symbol: esSymbolType,
	            undefined: undefinedType
	        });
	        var typeofType = createTypeofType();
	        var _jsxNamespace;
	        var _jsxFactoryEntity;
	        var _jsxElementPropertiesName;
	        var _hasComputedJsxElementPropertiesName = false;
	        var _jsxElementChildrenPropertyName;
	        var _hasComputedJsxElementChildrenPropertyName = false;
	        /** Things we lazy load from the JSX namespace */
	        var jsxTypes = ts.createUnderscoreEscapedMap();
	        var subtypeRelation = ts.createMap();
	        var assignableRelation = ts.createMap();
	        var definitelyAssignableRelation = ts.createMap();
	        var comparableRelation = ts.createMap();
	        var identityRelation = ts.createMap();
	        var enumRelation = ts.createMap();
	        var TypeSystemPropertyName;
	        (function (TypeSystemPropertyName) {
	            TypeSystemPropertyName[TypeSystemPropertyName["Type"] = 0] = "Type";
	            TypeSystemPropertyName[TypeSystemPropertyName["ResolvedBaseConstructorType"] = 1] = "ResolvedBaseConstructorType";
	            TypeSystemPropertyName[TypeSystemPropertyName["DeclaredType"] = 2] = "DeclaredType";
	            TypeSystemPropertyName[TypeSystemPropertyName["ResolvedReturnType"] = 3] = "ResolvedReturnType";
	            TypeSystemPropertyName[TypeSystemPropertyName["ResolvedBaseConstraint"] = 4] = "ResolvedBaseConstraint";
	        })(TypeSystemPropertyName || (TypeSystemPropertyName = {}));
	        var CheckMode;
	        (function (CheckMode) {
	            CheckMode[CheckMode["Normal"] = 0] = "Normal";
	            CheckMode[CheckMode["SkipContextSensitive"] = 1] = "SkipContextSensitive";
	            CheckMode[CheckMode["Inferential"] = 2] = "Inferential";
	            CheckMode[CheckMode["Contextual"] = 3] = "Contextual";
	        })(CheckMode || (CheckMode = {}));
	        var CallbackCheck;
	        (function (CallbackCheck) {
	            CallbackCheck[CallbackCheck["None"] = 0] = "None";
	            CallbackCheck[CallbackCheck["Bivariant"] = 1] = "Bivariant";
	            CallbackCheck[CallbackCheck["Strict"] = 2] = "Strict";
	        })(CallbackCheck || (CallbackCheck = {}));
	        var MappedTypeModifiers;
	        (function (MappedTypeModifiers) {
	            MappedTypeModifiers[MappedTypeModifiers["IncludeReadonly"] = 1] = "IncludeReadonly";
	            MappedTypeModifiers[MappedTypeModifiers["ExcludeReadonly"] = 2] = "ExcludeReadonly";
	            MappedTypeModifiers[MappedTypeModifiers["IncludeOptional"] = 4] = "IncludeOptional";
	            MappedTypeModifiers[MappedTypeModifiers["ExcludeOptional"] = 8] = "ExcludeOptional";
	        })(MappedTypeModifiers || (MappedTypeModifiers = {}));
	        var ExpandingFlags;
	        (function (ExpandingFlags) {
	            ExpandingFlags[ExpandingFlags["None"] = 0] = "None";
	            ExpandingFlags[ExpandingFlags["Source"] = 1] = "Source";
	            ExpandingFlags[ExpandingFlags["Target"] = 2] = "Target";
	            ExpandingFlags[ExpandingFlags["Both"] = 3] = "Both";
	        })(ExpandingFlags || (ExpandingFlags = {}));
	        var TypeIncludes;
	        (function (TypeIncludes) {
	            TypeIncludes[TypeIncludes["Any"] = 1] = "Any";
	            TypeIncludes[TypeIncludes["Undefined"] = 2] = "Undefined";
	            TypeIncludes[TypeIncludes["Null"] = 4] = "Null";
	            TypeIncludes[TypeIncludes["Never"] = 8] = "Never";
	            TypeIncludes[TypeIncludes["NonWideningType"] = 16] = "NonWideningType";
	            TypeIncludes[TypeIncludes["String"] = 32] = "String";
	            TypeIncludes[TypeIncludes["Number"] = 64] = "Number";
	            TypeIncludes[TypeIncludes["ESSymbol"] = 128] = "ESSymbol";
	            TypeIncludes[TypeIncludes["LiteralOrUniqueESSymbol"] = 256] = "LiteralOrUniqueESSymbol";
	            TypeIncludes[TypeIncludes["ObjectType"] = 512] = "ObjectType";
	            TypeIncludes[TypeIncludes["EmptyObject"] = 1024] = "EmptyObject";
	            TypeIncludes[TypeIncludes["Union"] = 2048] = "Union";
	        })(TypeIncludes || (TypeIncludes = {}));
	        var MembersOrExportsResolutionKind;
	        (function (MembersOrExportsResolutionKind) {
	            MembersOrExportsResolutionKind["resolvedExports"] = "resolvedExports";
	            MembersOrExportsResolutionKind["resolvedMembers"] = "resolvedMembers";
	        })(MembersOrExportsResolutionKind || (MembersOrExportsResolutionKind = {}));
	        var builtinGlobals = ts.createSymbolTable();
	        builtinGlobals.set(undefinedSymbol.escapedName, undefinedSymbol);
	        var isNotOverloadAndNotAccessor = ts.and(isNotOverload, isNotAccessor);
	        initializeTypeChecker();
	        return checker;
	        /**
	         * @deprecated
	         */
	        function getSymbolDisplayBuilder() {
	            return {
	                buildTypeDisplay: function (type, writer, enclosingDeclaration, flags) {
	                    typeToString(type, enclosingDeclaration, flags, emitTextWriterWrapper(writer));
	                },
	                buildSymbolDisplay: function (symbol, writer, enclosingDeclaration, meaning, flags) {
	                    symbolToString(symbol, enclosingDeclaration, meaning, flags | 4 /* AllowAnyNodeKind */, emitTextWriterWrapper(writer));
	                },
	                buildSignatureDisplay: function (signature, writer, enclosing, flags, kind) {
	                    signatureToString(signature, enclosing, flags, kind, emitTextWriterWrapper(writer));
	                },
	                buildIndexSignatureDisplay: function (info, writer, kind, enclosing, flags) {
	                    var sig = nodeBuilder.indexInfoToIndexSignatureDeclaration(info, kind, enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeNode(4 /* Unspecified */, sig, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildParameterDisplay: function (symbol, writer, enclosing, flags) {
	                    var node = nodeBuilder.symbolToParameterDeclaration(symbol, enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeNode(4 /* Unspecified */, node, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildTypeParameterDisplay: function (tp, writer, enclosing, flags) {
	                    var node = nodeBuilder.typeParameterToDeclaration(tp, enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */ | 8192 /* OmitParameterModifiers */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeNode(4 /* Unspecified */, node, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildTypePredicateDisplay: function (predicate, writer, enclosing, flags) {
	                    typePredicateToString(predicate, enclosing, flags, emitTextWriterWrapper(writer));
	                },
	                buildTypeParameterDisplayFromSymbol: function (symbol, writer, enclosing, flags) {
	                    var nodes = nodeBuilder.symbolToTypeParameterDeclarations(symbol, enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeList(26896 /* TypeParameters */, nodes, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildDisplayForParametersAndDelimiters: function (thisParameter, parameters, writer, enclosing, originalFlags) {
	                    var printer = ts.createPrinter({ removeComments: true });
	                    var flags = 8192 /* OmitParameterModifiers */ | 3112960 /* IgnoreErrors */ | toNodeBuilderFlags(originalFlags);
	                    var thisParameterArray = thisParameter ? [nodeBuilder.symbolToParameterDeclaration(thisParameter, enclosing, flags)] : [];
	                    var params = ts.createNodeArray(thisParameterArray.concat(ts.map(parameters, function (param) { return nodeBuilder.symbolToParameterDeclaration(param, enclosing, flags); })));
	                    printer.writeList(1296 /* CallExpressionArguments */, params, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildDisplayForTypeParametersAndDelimiters: function (typeParameters, writer, enclosing, flags) {
	                    var printer = ts.createPrinter({ removeComments: true });
	                    var args = ts.createNodeArray(ts.map(typeParameters, function (p) { return nodeBuilder.typeParameterToDeclaration(p, enclosing, toNodeBuilderFlags(flags)); }));
	                    printer.writeList(26896 /* TypeParameters */, args, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildReturnTypeDisplay: function (signature, writer, enclosing, flags) {
	                    writer.writePunctuation(":");
	                    writer.writeSpace(" ");
	                    var predicate = getTypePredicateOfSignature(signature);
	                    if (predicate) {
	                        return typePredicateToString(predicate, enclosing, flags, emitTextWriterWrapper(writer));
	                    }
	                    var node = nodeBuilder.typeToTypeNode(getReturnTypeOfSignature(signature), enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeNode(4 /* Unspecified */, node, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                }
	            };
	            function emitTextWriterWrapper(underlying) {
	                return {
	                    write: ts.noop,
	                    writeTextOfNode: ts.noop,
	                    writeLine: ts.noop,
	                    increaseIndent: function () {
	                        return underlying.increaseIndent();
	                    },
	                    decreaseIndent: function () {
	                        return underlying.decreaseIndent();
	                    },
	                    getText: function () {
	                        return "";
	                    },
	                    rawWrite: ts.noop,
	                    writeLiteral: function (s) {
	                        return underlying.writeStringLiteral(s);
	                    },
	                    getTextPos: function () {
	                        return 0;
	                    },
	                    getLine: function () {
	                        return 0;
	                    },
	                    getColumn: function () {
	                        return 0;
	                    },
	                    getIndent: function () {
	                        return 0;
	                    },
	                    isAtStartOfLine: function () {
	                        return false;
	                    },
	                    clear: function () {
	                        return underlying.clear();
	                    },
	                    writeKeyword: function (text) {
	                        return underlying.writeKeyword(text);
	                    },
	                    writeOperator: function (text) {
	                        return underlying.writeOperator(text);
	                    },
	                    writePunctuation: function (text) {
	                        return underlying.writePunctuation(text);
	                    },
	                    writeSpace: function (text) {
	                        return underlying.writeSpace(text);
	                    },
	                    writeStringLiteral: function (text) {
	                        return underlying.writeStringLiteral(text);
	                    },
	                    writeParameter: function (text) {
	                        return underlying.writeParameter(text);
	                    },
	                    writeProperty: function (text) {
	                        return underlying.writeProperty(text);
	                    },
	                    writeSymbol: function (text, symbol) {
	                        return underlying.writeSymbol(text, symbol);
	                    },
	                    trackSymbol: function (symbol, enclosing, meaning) {
	                        return underlying.trackSymbol && underlying.trackSymbol(symbol, enclosing, meaning);
	                    },
	                    reportInaccessibleThisError: function () {
	                        return underlying.reportInaccessibleThisError && underlying.reportInaccessibleThisError();
	                    },
	                    reportPrivateInBaseOfClassExpression: function (name) {
	                        return underlying.reportPrivateInBaseOfClassExpression && underlying.reportPrivateInBaseOfClassExpression(name);
	                    },
	                    reportInaccessibleUniqueSymbolError: function () {
	                        return underlying.reportInaccessibleUniqueSymbolError && underlying.reportInaccessibleUniqueSymbolError();
	                    }
	                };
	            }
	        }
	        function getJsxNamespace() {
	            if (!_jsxNamespace) {
	                _jsxNamespace = "React";
	                if (compilerOptions.jsxFactory) {
	                    _jsxFactoryEntity = ts.parseIsolatedEntityName(compilerOptions.jsxFactory, languageVersion);
	                    if (_jsxFactoryEntity) {
	                        _jsxNamespace = getFirstIdentifier(_jsxFactoryEntity).escapedText;
	                    }
	                }
	                else if (compilerOptions.reactNamespace) {
	                    _jsxNamespace = ts.escapeLeadingUnderscores(compilerOptions.reactNamespace);
	                }
	            }
	            return _jsxNamespace;
	        }
	        function getEmitResolver(sourceFile, cancellationToken) {
	            // Ensure we have all the type information in place for this file so that all the
	            // emitter questions of this resolver will return the right information.
	            getDiagnostics(sourceFile, cancellationToken);
	            return emitResolver;
	        }
	        function error(location, message, arg0, arg1, arg2, arg3) {
	            var diagnostic = location
	                ? ts.createDiagnosticForNode(location, message, arg0, arg1, arg2, arg3)
	                : ts.createCompilerDiagnostic(message, arg0, arg1, arg2, arg3);
	            diagnostics.add(diagnostic);
	        }
	        function createSymbol(flags, name, checkFlags) {
	            symbolCount++;
	            var symbol = (new Symbol(flags | 33554432 /* Transient */, name));
	            symbol.checkFlags = checkFlags || 0;
	            return symbol;
	        }
	        function isTransientSymbol(symbol) {
	            return (symbol.flags & 33554432 /* Transient */) !== 0;
	        }
	        function getExcludedSymbolFlags(flags) {
	            var result = 0;
	            if (flags & 2 /* BlockScopedVariable */)
	                result |= 107455 /* BlockScopedVariableExcludes */;
	            if (flags & 1 /* FunctionScopedVariable */)
	                result |= 107454 /* FunctionScopedVariableExcludes */;
	            if (flags & 4 /* Property */)
	                result |= 0 /* PropertyExcludes */;
	            if (flags & 8 /* EnumMember */)
	                result |= 900095 /* EnumMemberExcludes */;
	            if (flags & 16 /* Function */)
	                result |= 106927 /* FunctionExcludes */;
	            if (flags & 32 /* Class */)
	                result |= 899519 /* ClassExcludes */;
	            if (flags & 64 /* Interface */)
	                result |= 792968 /* InterfaceExcludes */;
	            if (flags & 256 /* RegularEnum */)
	                result |= 899327 /* RegularEnumExcludes */;
	            if (flags & 128 /* ConstEnum */)
	                result |= 899967 /* ConstEnumExcludes */;
	            if (flags & 512 /* ValueModule */)
	                result |= 106639 /* ValueModuleExcludes */;
	            if (flags & 8192 /* Method */)
	                result |= 99263 /* MethodExcludes */;
	            if (flags & 32768 /* GetAccessor */)
	                result |= 41919 /* GetAccessorExcludes */;
	            if (flags & 65536 /* SetAccessor */)
	                result |= 74687 /* SetAccessorExcludes */;
	            if (flags & 262144 /* TypeParameter */)
	                result |= 530920 /* TypeParameterExcludes */;
	            if (flags & 524288 /* TypeAlias */)
	                result |= 793064 /* TypeAliasExcludes */;
	            if (flags & 2097152 /* Alias */)
	                result |= 2097152 /* AliasExcludes */;
	            return result;
	        }
	        function recordMergedSymbol(target, source) {
	            if (!source.mergeId) {
	                source.mergeId = nextMergeId;
	                nextMergeId++;
	            }
	            mergedSymbols[source.mergeId] = target;
	        }
	        function cloneSymbol(symbol) {
	            var result = createSymbol(symbol.flags, symbol.escapedName);
	            result.declarations = symbol.declarations ? symbol.declarations.slice() : [];
	            result.parent = symbol.parent;
	            if (symbol.valueDeclaration)
	                result.valueDeclaration = symbol.valueDeclaration;
	            if (symbol.constEnumOnlyModule)
	                result.constEnumOnlyModule = true;
	            if (symbol.members)
	                result.members = ts.cloneMap(symbol.members);
	            if (symbol.exports)
	                result.exports = ts.cloneMap(symbol.exports);
	            recordMergedSymbol(result, symbol);
	            return result;
	        }
	        function mergeSymbol(target, source) {
	            if (!(target.flags & getExcludedSymbolFlags(source.flags)) ||
	                source.flags & 67108864 /* JSContainer */ || target.flags & 67108864 /* JSContainer */) {
	                // Javascript static-property-assignment declarations always merge, even though they are also values
	                if (source.flags & 512 /* ValueModule */ && target.flags & 512 /* ValueModule */ && target.constEnumOnlyModule && !source.constEnumOnlyModule) {
	                    // reset flag when merging instantiated module into value module that has only const enums
	                    target.constEnumOnlyModule = false;
	                }
	                target.flags |= source.flags;
	                if (source.valueDeclaration &&
	                    (!target.valueDeclaration ||
	                        (target.valueDeclaration.kind === 237 /* ModuleDeclaration */ && source.valueDeclaration.kind !== 237 /* ModuleDeclaration */))) {
	                    // other kinds of value declarations take precedence over modules
	                    target.valueDeclaration = source.valueDeclaration;
	                }
	                ts.addRange(target.declarations, source.declarations);
	                if (source.members) {
	                    if (!target.members)
	                        target.members = ts.createSymbolTable();
	                    mergeSymbolTable(target.members, source.members);
	                }
	                if (source.exports) {
	                    if (!target.exports)
	                        target.exports = ts.createSymbolTable();
	                    mergeSymbolTable(target.exports, source.exports);
	                }
	                recordMergedSymbol(target, source);
	            }
	            else if (target.flags & 1024 /* NamespaceModule */) {
	                error(ts.getNameOfDeclaration(source.declarations[0]), ts.Diagnostics.Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity, symbolToString(target));
	            }
	            else {
	                var message_2 = target.flags & 384 /* Enum */ || source.flags & 384 /* Enum */
	                    ? ts.Diagnostics.Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations
	                    : target.flags & 2 /* BlockScopedVariable */ || source.flags & 2 /* BlockScopedVariable */
	                        ? ts.Diagnostics.Cannot_redeclare_block_scoped_variable_0
	                        : ts.Diagnostics.Duplicate_identifier_0;
	                ts.forEach(source.declarations, function (node) {
	                    error(ts.getNameOfDeclaration(node) || node, message_2, symbolToString(source));
	                });
	                ts.forEach(target.declarations, function (node) {
	                    error(ts.getNameOfDeclaration(node) || node, message_2, symbolToString(source));
	                });
	            }
	        }
	        function combineSymbolTables(first, second) {
	            if (!first || first.size === 0)
	                return second;
	            if (!second || second.size === 0)
	                return first;
	            var combined = ts.createSymbolTable();
	            mergeSymbolTable(combined, first);
	            mergeSymbolTable(combined, second);
	            return combined;
	        }
	        function mergeSymbolTable(target, source) {
	            source.forEach(function (sourceSymbol, id) {
	                var targetSymbol = target.get(id);
	                if (!targetSymbol) {
	                    target.set(id, sourceSymbol);
	                }
	                else {
	                    if (!(targetSymbol.flags & 33554432 /* Transient */)) {
	                        targetSymbol = cloneSymbol(targetSymbol);
	                        target.set(id, targetSymbol);
	                    }
	                    mergeSymbol(targetSymbol, sourceSymbol);
	                }
	            });
	        }
	        function mergeModuleAugmentation(moduleName) {
	            var moduleAugmentation = moduleName.parent;
	            if (moduleAugmentation.symbol.declarations[0] !== moduleAugmentation) {
	                // this is a combined symbol for multiple augmentations within the same file.
	                // its symbol already has accumulated information for all declarations
	                // so we need to add it just once - do the work only for first declaration
	                ts.Debug.assert(moduleAugmentation.symbol.declarations.length > 1);
	                return;
	            }
	            if (ts.isGlobalScopeAugmentation(moduleAugmentation)) {
	                mergeSymbolTable(globals, moduleAugmentation.symbol.exports);
	            }
	            else {
	                // find a module that about to be augmented
	                // do not validate names of augmentations that are defined in ambient context
	                var moduleNotFoundError = !(moduleName.parent.parent.flags & 2097152 /* Ambient */)
	                    ? ts.Diagnostics.Invalid_module_name_in_augmentation_module_0_cannot_be_found
	                    : undefined;
	                var mainModule = resolveExternalModuleNameWorker(moduleName, moduleName, moduleNotFoundError, /*isForAugmentation*/ true);
	                if (!mainModule) {
	                    return;
	                }
	                // obtain item referenced by 'export='
	                mainModule = resolveExternalModuleSymbol(mainModule);
	                if (mainModule.flags & 1920 /* Namespace */) {
	                    // if module symbol has already been merged - it is safe to use it.
	                    // otherwise clone it
	                    mainModule = mainModule.flags & 33554432 /* Transient */ ? mainModule : cloneSymbol(mainModule);
	                    mergeSymbol(mainModule, moduleAugmentation.symbol);
	                }
	                else {
	                    // moduleName will be a StringLiteral since this is not `declare global`.
	                    error(moduleName, ts.Diagnostics.Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity, moduleName.text);
	                }
	            }
	        }
	        function addToSymbolTable(target, source, message) {
	            source.forEach(function (sourceSymbol, id) {
	                var targetSymbol = target.get(id);
	                if (targetSymbol) {
	                    // Error on redeclarations
	                    ts.forEach(targetSymbol.declarations, addDeclarationDiagnostic(ts.unescapeLeadingUnderscores(id), message));
	                }
	                else {
	                    target.set(id, sourceSymbol);
	                }
	            });
	            function addDeclarationDiagnostic(id, message) {
	                return function (declaration) { return diagnostics.add(ts.createDiagnosticForNode(declaration, message, id)); };
	            }
	        }
	        function getSymbolLinks(symbol) {
	            if (symbol.flags & 33554432 /* Transient */)
	                return symbol;
	            var id = getSymbolId(symbol);
	            return symbolLinks[id] || (symbolLinks[id] = {});
	        }
	        function getNodeLinks(node) {
	            var nodeId = getNodeId(node);
	            return nodeLinks[nodeId] || (nodeLinks[nodeId] = { flags: 0 });
	        }
	        function isGlobalSourceFile(node) {
	            return node.kind === 272 /* SourceFile */ && !ts.isExternalOrCommonJsModule(node);
	        }
	        function getSymbol(symbols, name, meaning) {
	            if (meaning) {
	                var symbol = symbols.get(name);
	                if (symbol) {
	                    ts.Debug.assert((ts.getCheckFlags(symbol) & 1 /* Instantiated */) === 0, "Should never get an instantiated symbol here.");
	                    if (symbol.flags & meaning) {
	                        return symbol;
	                    }
	                    if (symbol.flags & 2097152 /* Alias */) {
	                        var target = resolveAlias(symbol);
	                        // Unknown symbol means an error occurred in alias resolution, treat it as positive answer to avoid cascading errors
	                        if (target === unknownSymbol || target.flags & meaning) {
	                            return symbol;
	                        }
	                    }
	                }
	            }
	            // return undefined if we can't find a symbol.
	        }
	        /**
	         * Get symbols that represent parameter-property-declaration as parameter and as property declaration
	         * @param parameter a parameterDeclaration node
	         * @param parameterName a name of the parameter to get the symbols for.
	         * @return a tuple of two symbols
	         */
	        function getSymbolsOfParameterPropertyDeclaration(parameter, parameterName) {
	            var constructorDeclaration = parameter.parent;
	            var classDeclaration = parameter.parent.parent;
	            var parameterSymbol = getSymbol(constructorDeclaration.locals, parameterName, 107455 /* Value */);
	            var propertySymbol = getSymbol(getMembersOfSymbol(classDeclaration.symbol), parameterName, 107455 /* Value */);
	            if (parameterSymbol && propertySymbol) {
	                return [parameterSymbol, propertySymbol];
	            }
	            ts.Debug.fail("There should exist two symbols, one as property declaration and one as parameter declaration");
	        }
	        function isBlockScopedNameDeclaredBeforeUse(declaration, usage) {
	            var declarationFile = ts.getSourceFileOfNode(declaration);
	            var useFile = ts.getSourceFileOfNode(usage);
	            if (declarationFile !== useFile) {
	                if ((modulekind && (declarationFile.externalModuleIndicator || useFile.externalModuleIndicator)) ||
	                    (!compilerOptions.outFile && !compilerOptions.out) ||
	                    isInTypeQuery(usage) ||
	                    declaration.flags & 2097152 /* Ambient */) {
	                    // nodes are in different files and order cannot be determined
	                    return true;
	                }
	                // declaration is after usage
	                // can be legal if usage is deferred (i.e. inside function or in initializer of instance property)
	                if (isUsedInFunctionOrInstanceProperty(usage, declaration)) {
	                    return true;
	                }
	                var sourceFiles = host.getSourceFiles();
	                return sourceFiles.indexOf(declarationFile) <= sourceFiles.indexOf(useFile);
	            }
	            if (declaration.pos <= usage.pos) {
	                // declaration is before usage
	                if (declaration.kind === 180 /* BindingElement */) {
	                    // still might be illegal if declaration and usage are both binding elements (eg var [a = b, b = b] = [1, 2])
	                    var errorBindingElement = ts.getAncestor(usage, 180 /* BindingElement */);
	                    if (errorBindingElement) {
	                        return ts.findAncestor(errorBindingElement, ts.isBindingElement) !== ts.findAncestor(declaration, ts.isBindingElement) ||
	                            declaration.pos < errorBindingElement.pos;
	                    }
	                    // or it might be illegal if usage happens before parent variable is declared (eg var [a] = a)
	                    return isBlockScopedNameDeclaredBeforeUse(ts.getAncestor(declaration, 230 /* VariableDeclaration */), usage);
	                }
	                else if (declaration.kind === 230 /* VariableDeclaration */) {
	                    // still might be illegal if usage is in the initializer of the variable declaration (eg var a = a)
	                    return !isImmediatelyUsedInInitializerOfBlockScopedVariable(declaration, usage);
	                }
	                return true;
	            }
	            // declaration is after usage, but it can still be legal if usage is deferred:
	            // 1. inside an export specifier
	            // 2. inside a function
	            // 3. inside an instance property initializer, a reference to a non-instance property
	            // 4. inside a static property initializer, a reference to a static method in the same class
	            // 5. inside a TS export= declaration (since we will move the export statement during emit to avoid TDZ)
	            // or if usage is in a type context:
	            // 1. inside a type query (typeof in type position)
	            if (usage.parent.kind === 250 /* ExportSpecifier */ || (usage.parent.kind === 247 /* ExportAssignment */ && usage.parent.isExportEquals)) {
	                // export specifiers do not use the variable, they only make it available for use
	                return true;
	            }
	            // When resolving symbols for exports, the `usage` location passed in can be the export site directly
	            if (usage.kind === 247 /* ExportAssignment */ && usage.isExportEquals) {
	                return true;
	            }
	            var container = ts.getEnclosingBlockScopeContainer(declaration);
	            return isInTypeQuery(usage) || isUsedInFunctionOrInstanceProperty(usage, declaration, container);
	            function isImmediatelyUsedInInitializerOfBlockScopedVariable(declaration, usage) {
	                var container = ts.getEnclosingBlockScopeContainer(declaration);
	                switch (declaration.parent.parent.kind) {
	                    case 212 /* VariableStatement */:
	                    case 218 /* ForStatement */:
	                    case 220 /* ForOfStatement */:
	                        // variable statement/for/for-of statement case,
	                        // use site should not be inside variable declaration (initializer of declaration or binding element)
	                        if (isSameScopeDescendentOf(usage, declaration, container)) {
	                            return true;
	                        }
	                        break;
	                }
	                // ForIn/ForOf case - use site should not be used in expression part
	                return ts.isForInOrOfStatement(declaration.parent.parent) && isSameScopeDescendentOf(usage, declaration.parent.parent.expression, container);
	            }
	            function isUsedInFunctionOrInstanceProperty(usage, declaration, container) {
	                return !!ts.findAncestor(usage, function (current) {
	                    if (current === container) {
	                        return "quit";
	                    }
	                    if (ts.isFunctionLike(current)) {
	                        return true;
	                    }
	                    var initializerOfProperty = current.parent &&
	                        current.parent.kind === 151 /* PropertyDeclaration */ &&
	                        current.parent.initializer === current;
	                    if (initializerOfProperty) {
	                        if (ts.hasModifier(current.parent, 32 /* Static */)) {
	                            if (declaration.kind === 153 /* MethodDeclaration */) {
	                                return true;
	                            }
	                        }
	                        else {
	                            var isDeclarationInstanceProperty = declaration.kind === 151 /* PropertyDeclaration */ && !ts.hasModifier(declaration, 32 /* Static */);
	                            if (!isDeclarationInstanceProperty || ts.getContainingClass(usage) !== ts.getContainingClass(declaration)) {
	                                return true;
	                            }
	                        }
	                    }
	                });
	            }
	        }
	        /**
	         * Resolve a given name for a given meaning at a given location. An error is reported if the name was not found and
	         * the nameNotFoundMessage argument is not undefined. Returns the resolved symbol, or undefined if no symbol with
	         * the given name can be found.
	         *
	         * @param isUse If true, this will count towards --noUnusedLocals / --noUnusedParameters.
	         */
	        function resolveName(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals, suggestedNameNotFoundMessage) {
	            if (excludeGlobals === void 0) { excludeGlobals = false; }
	            return resolveNameHelper(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals, getSymbol, suggestedNameNotFoundMessage);
	        }
	        function resolveNameHelper(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals, lookup, suggestedNameNotFoundMessage) {
	            var originalLocation = location; // needed for did-you-mean error reporting, which gathers candidates starting from the original location
	            var result;
	            var lastLocation;
	            var lastSelfReferenceLocation;
	            var propertyWithInvalidInitializer;
	            var errorLocation = location;
	            var grandparent;
	            var isInExternalModule = false;
	            loop: while (location) {
	                // Locals of a source file are not in scope (because they get merged into the global symbol table)
	                if (location.locals && !isGlobalSourceFile(location)) {
	                    if (result = lookup(location.locals, name, meaning)) {
	                        var useResult = true;
	                        if (ts.isFunctionLike(location) && lastLocation && lastLocation !== location.body) {
	                            // symbol lookup restrictions for function-like declarations
	                            // - Type parameters of a function are in scope in the entire function declaration, including the parameter
	                            //   list and return type. However, local types are only in scope in the function body.
	                            // - parameters are only in the scope of function body
	                            // This restriction does not apply to JSDoc comment types because they are parented
	                            // at a higher level than type parameters would normally be
	                            if (meaning & result.flags & 793064 /* Type */ && lastLocation.kind !== 282 /* JSDocComment */) {
	                                useResult = result.flags & 262144 /* TypeParameter */
	                                    // type parameters are visible in parameter list, return type and type parameter list
	                                    ? lastLocation === location.type ||
	                                        lastLocation.kind === 148 /* Parameter */ ||
	                                        lastLocation.kind === 147 /* TypeParameter */
	                                    // local types not visible outside the function body
	                                    : false;
	                            }
	                            if (meaning & 107455 /* Value */ && result.flags & 1 /* FunctionScopedVariable */) {
	                                // parameters are visible only inside function body, parameter list and return type
	                                // technically for parameter list case here we might mix parameters and variables declared in function,
	                                // however it is detected separately when checking initializers of parameters
	                                // to make sure that they reference no variables declared after them.
	                                useResult =
	                                    lastLocation.kind === 148 /* Parameter */ ||
	                                        (lastLocation === location.type &&
	                                            result.valueDeclaration.kind === 148 /* Parameter */);
	                            }
	                        }
	                        else if (location.kind === 170 /* ConditionalType */) {
	                            // A type parameter declared using 'infer T' in a conditional type is visible only in
	                            // the true branch of the conditional type.
	                            useResult = lastLocation === location.trueType;
	                        }
	                        if (useResult) {
	                            break loop;
	                        }
	                        else {
	                            result = undefined;
	                        }
	                    }
	                }
	                switch (location.kind) {
	                    case 272 /* SourceFile */:
	                        if (!ts.isExternalOrCommonJsModule(location))
	                            break;
	                        isInExternalModule = true;
	                    // falls through
	                    case 237 /* ModuleDeclaration */:
	                        var moduleExports = getSymbolOfNode(location).exports;
	                        if (location.kind === 272 /* SourceFile */ || ts.isAmbientModule(location)) {
	                            // It's an external module. First see if the module has an export default and if the local
	                            // name of that export default matches.
	                            if (result = moduleExports.get("default" /* Default */)) {
	                                var localSymbol = ts.getLocalSymbolForExportDefault(result);
	                                if (localSymbol && (result.flags & meaning) && localSymbol.escapedName === name) {
	                                    break loop;
	                                }
	                                result = undefined;
	                            }
	                            // Because of module/namespace merging, a module's exports are in scope,
	                            // yet we never want to treat an export specifier as putting a member in scope.
	                            // Therefore, if the name we find is purely an export specifier, it is not actually considered in scope.
	                            // Two things to note about this:
	                            //     1. We have to check this without calling getSymbol. The problem with calling getSymbol
	                            //        on an export specifier is that it might find the export specifier itself, and try to
	                            //        resolve it as an alias. This will cause the checker to consider the export specifier
	                            //        a circular alias reference when it might not be.
	                            //     2. We check === SymbolFlags.Alias in order to check that the symbol is *purely*
	                            //        an alias. If we used &, we'd be throwing out symbols that have non alias aspects,
	                            //        which is not the desired behavior.
	                            var moduleExport = moduleExports.get(name);
	                            if (moduleExport &&
	                                moduleExport.flags === 2097152 /* Alias */ &&
	                                ts.getDeclarationOfKind(moduleExport, 250 /* ExportSpecifier */)) {
	                                break;
	                            }
	                        }
	                        if (result = lookup(moduleExports, name, meaning & 2623475 /* ModuleMember */)) {
	                            break loop;
	                        }
	                        break;
	                    case 236 /* EnumDeclaration */:
	                        if (result = lookup(getSymbolOfNode(location).exports, name, meaning & 8 /* EnumMember */)) {
	                            break loop;
	                        }
	                        break;
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                        // TypeScript 1.0 spec (April 2014): 8.4.1
	                        // Initializer expressions for instance member variables are evaluated in the scope
	                        // of the class constructor body but are not permitted to reference parameters or
	                        // local variables of the constructor. This effectively means that entities from outer scopes
	                        // by the same name as a constructor parameter or local variable are inaccessible
	                        // in initializer expressions for instance member variables.
	                        if (ts.isClassLike(location.parent) && !ts.hasModifier(location, 32 /* Static */)) {
	                            var ctor = findConstructorDeclaration(location.parent);
	                            if (ctor && ctor.locals) {
	                                if (lookup(ctor.locals, name, meaning & 107455 /* Value */)) {
	                                    // Remember the property node, it will be used later to report appropriate error
	                                    propertyWithInvalidInitializer = location;
	                                }
	                            }
	                        }
	                        break;
	                    case 233 /* ClassDeclaration */:
	                    case 203 /* ClassExpression */:
	                    case 234 /* InterfaceDeclaration */:
	                        if (result = lookup(getMembersOfSymbol(getSymbolOfNode(location)), name, meaning & 793064 /* Type */)) {
	                            if (!isTypeParameterSymbolDeclaredInContainer(result, location)) {
	                                // ignore type parameters not declared in this container
	                                result = undefined;
	                                break;
	                            }
	                            if (lastLocation && ts.hasModifier(lastLocation, 32 /* Static */)) {
	                                // TypeScript 1.0 spec (April 2014): 3.4.1
	                                // The scope of a type parameter extends over the entire declaration with which the type
	                                // parameter list is associated, with the exception of static member declarations in classes.
	                                error(errorLocation, ts.Diagnostics.Static_members_cannot_reference_class_type_parameters);
	                                return undefined;
	                            }
	                            break loop;
	                        }
	                        if (location.kind === 203 /* ClassExpression */ && meaning & 32 /* Class */) {
	                            var className = location.name;
	                            if (className && name === className.escapedText) {
	                                result = location.symbol;
	                                break loop;
	                            }
	                        }
	                        break;
	                    case 205 /* ExpressionWithTypeArguments */:
	                        // The type parameters of a class are not in scope in the base class expression.
	                        if (lastLocation === location.expression && location.parent.token === 85 /* ExtendsKeyword */) {
	                            var container = location.parent.parent;
	                            if (ts.isClassLike(container) && (result = lookup(getSymbolOfNode(container).members, name, meaning & 793064 /* Type */))) {
	                                if (nameNotFoundMessage) {
	                                    error(errorLocation, ts.Diagnostics.Base_class_expressions_cannot_reference_class_type_parameters);
	                                }
	                                return undefined;
	                            }
	                        }
	                        break;
	                    // It is not legal to reference a class's own type parameters from a computed property name that
	                    // belongs to the class. For example:
	                    //
	                    //   function foo<T>() { return '' }
	                    //   class C<T> { // <-- Class's own type parameter T
	                    //       [foo<T>()]() { } // <-- Reference to T from class's own computed property
	                    //   }
	                    //
	                    case 146 /* ComputedPropertyName */:
	                        grandparent = location.parent.parent;
	                        if (ts.isClassLike(grandparent) || grandparent.kind === 234 /* InterfaceDeclaration */) {
	                            // A reference to this grandparent's type parameters would be an error
	                            if (result = lookup(getSymbolOfNode(grandparent).members, name, meaning & 793064 /* Type */)) {
	                                error(errorLocation, ts.Diagnostics.A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type);
	                                return undefined;
	                            }
	                        }
	                        break;
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                    case 154 /* Constructor */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 232 /* FunctionDeclaration */:
	                    case 191 /* ArrowFunction */:
	                        if (meaning & 3 /* Variable */ && name === "arguments") {
	                            result = argumentsSymbol;
	                            break loop;
	                        }
	                        break;
	                    case 190 /* FunctionExpression */:
	                        if (meaning & 3 /* Variable */ && name === "arguments") {
	                            result = argumentsSymbol;
	                            break loop;
	                        }
	                        if (meaning & 16 /* Function */) {
	                            var functionName = location.name;
	                            if (functionName && name === functionName.escapedText) {
	                                result = location.symbol;
	                                break loop;
	                            }
	                        }
	                        break;
	                    case 149 /* Decorator */:
	                        // Decorators are resolved at the class declaration. Resolving at the parameter
	                        // or member would result in looking up locals in the method.
	                        //
	                        //   function y() {}
	                        //   class C {
	                        //       method(@y x, y) {} // <-- decorator y should be resolved at the class declaration, not the parameter.
	                        //   }
	                        //
	                        if (location.parent && location.parent.kind === 148 /* Parameter */) {
	                            location = location.parent;
	                        }
	                        //
	                        //   function y() {}
	                        //   class C {
	                        //       @y method(x, y) {} // <-- decorator y should be resolved at the class declaration, not the method.
	                        //   }
	                        //
	                        if (location.parent && ts.isClassElement(location.parent)) {
	                            location = location.parent;
	                        }
	                        break;
	                }
	                if (isSelfReferenceLocation(location)) {
	                    lastSelfReferenceLocation = location;
	                }
	                lastLocation = location;
	                location = location.parent;
	            }
	            // We just climbed up parents looking for the name, meaning that we started in a descendant node of `lastLocation`.
	            // If `result === lastSelfReferenceLocation.symbol`, that means that we are somewhere inside `lastSelfReferenceLocation` looking up a name, and resolving to `lastLocation` itself.
	            // That means that this is a self-reference of `lastLocation`, and shouldn't count this when considering whether `lastLocation` is used.
	            if (isUse && result && nameNotFoundMessage && noUnusedIdentifiers && (!lastSelfReferenceLocation || result !== lastSelfReferenceLocation.symbol)) {
	                result.isReferenced |= meaning;
	            }
	            if (!result) {
	                if (lastLocation) {
	                    ts.Debug.assert(lastLocation.kind === 272 /* SourceFile */);
	                    if (lastLocation.commonJsModuleIndicator && name === "exports") {
	                        return lastLocation.symbol;
	                    }
	                }
	                if (!excludeGlobals) {
	                    result = lookup(globals, name, meaning);
	                }
	            }
	            if (!result) {
	                if (nameNotFoundMessage) {
	                    if (!errorLocation ||
	                        !checkAndReportErrorForMissingPrefix(errorLocation, name, nameArg) &&
	                            !checkAndReportErrorForExtendingInterface(errorLocation) &&
	                            !checkAndReportErrorForUsingTypeAsNamespace(errorLocation, name, meaning) &&
	                            !checkAndReportErrorForUsingTypeAsValue(errorLocation, name, meaning) &&
	                            !checkAndReportErrorForUsingNamespaceModuleAsValue(errorLocation, name, meaning)) {
	                        var suggestion = void 0;
	                        if (suggestedNameNotFoundMessage && suggestionCount < maximumSuggestionCount) {
	                            suggestion = getSuggestionForNonexistentSymbol(originalLocation, name, meaning);
	                            if (suggestion) {
	                                error(errorLocation, suggestedNameNotFoundMessage, diagnosticName(nameArg), suggestion);
	                            }
	                        }
	                        if (!suggestion) {
	                            error(errorLocation, nameNotFoundMessage, diagnosticName(nameArg));
	                        }
	                        suggestionCount++;
	                    }
	                }
	                return undefined;
	            }
	            // Perform extra checks only if error reporting was requested
	            if (nameNotFoundMessage) {
	                if (propertyWithInvalidInitializer) {
	                    // We have a match, but the reference occurred within a property initializer and the identifier also binds
	                    // to a local variable in the constructor where the code will be emitted.
	                    var propertyName = propertyWithInvalidInitializer.name;
	                    error(errorLocation, ts.Diagnostics.Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor, ts.declarationNameToString(propertyName), diagnosticName(nameArg));
	                    return undefined;
	                }
	                // Only check for block-scoped variable if we have an error location and are looking for the
	                // name with variable meaning
	                //      For example,
	                //          declare module foo {
	                //              interface bar {}
	                //          }
	                //      const foo/*1*/: foo/*2*/.bar;
	                // The foo at /*1*/ and /*2*/ will share same symbol with two meanings:
	                // block-scoped variable and namespace module. However, only when we
	                // try to resolve name in /*1*/ which is used in variable position,
	                // we want to check for block-scoped
	                if (errorLocation &&
	                    (meaning & 2 /* BlockScopedVariable */ ||
	                        ((meaning & 32 /* Class */ || meaning & 384 /* Enum */) && (meaning & 107455 /* Value */) === 107455 /* Value */))) {
	                    var exportOrLocalSymbol = getExportSymbolOfValueSymbolIfExported(result);
	                    if (exportOrLocalSymbol.flags & 2 /* BlockScopedVariable */ || exportOrLocalSymbol.flags & 32 /* Class */ || exportOrLocalSymbol.flags & 384 /* Enum */) {
	                        checkResolvedBlockScopedVariable(exportOrLocalSymbol, errorLocation);
	                    }
	                }
	                // If we're in an external module, we can't reference value symbols created from UMD export declarations
	                if (result && isInExternalModule && (meaning & 107455 /* Value */) === 107455 /* Value */) {
	                    var decls = result.declarations;
	                    if (decls && decls.length === 1 && decls[0].kind === 240 /* NamespaceExportDeclaration */) {
	                        error(errorLocation, ts.Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead, ts.unescapeLeadingUnderscores(name));
	                    }
	                }
	            }
	            return result;
	        }
	        function isSelfReferenceLocation(node) {
	            switch (node.kind) {
	                case 232 /* FunctionDeclaration */:
	                case 233 /* ClassDeclaration */:
	                case 234 /* InterfaceDeclaration */:
	                case 236 /* EnumDeclaration */:
	                case 235 /* TypeAliasDeclaration */:
	                case 237 /* ModuleDeclaration */:// For `namespace N { N; }`
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function diagnosticName(nameArg) {
	            return ts.isString(nameArg) ? ts.unescapeLeadingUnderscores(nameArg) : ts.declarationNameToString(nameArg);
	        }
	        function isTypeParameterSymbolDeclaredInContainer(symbol, container) {
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var decl = _a[_i];
	                if (decl.kind === 147 /* TypeParameter */ && decl.parent === container) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function checkAndReportErrorForMissingPrefix(errorLocation, name, nameArg) {
	            if (!ts.isIdentifier(errorLocation) || errorLocation.escapedText !== name || isTypeReferenceIdentifier(errorLocation) || isInTypeQuery(errorLocation)) {
	                return false;
	            }
	            var container = ts.getThisContainer(errorLocation, /*includeArrowFunctions*/ true);
	            var location = container;
	            while (location) {
	                if (ts.isClassLike(location.parent)) {
	                    var classSymbol = getSymbolOfNode(location.parent);
	                    if (!classSymbol) {
	                        break;
	                    }
	                    // Check to see if a static member exists.
	                    var constructorType = getTypeOfSymbol(classSymbol);
	                    if (getPropertyOfType(constructorType, name)) {
	                        error(errorLocation, ts.Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0, diagnosticName(nameArg), symbolToString(classSymbol));
	                        return true;
	                    }
	                    // No static member is present.
	                    // Check if we're in an instance method and look for a relevant instance member.
	                    if (location === container && !ts.hasModifier(location, 32 /* Static */)) {
	                        var instanceType = getDeclaredTypeOfSymbol(classSymbol).thisType;
	                        if (getPropertyOfType(instanceType, name)) {
	                            error(errorLocation, ts.Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0, diagnosticName(nameArg));
	                            return true;
	                        }
	                    }
	                }
	                location = location.parent;
	            }
	            return false;
	        }
	        function checkAndReportErrorForExtendingInterface(errorLocation) {
	            var expression = getEntityNameForExtendingInterface(errorLocation);
	            var isError = !!(expression && resolveEntityName(expression, 64 /* Interface */, /*ignoreErrors*/ true));
	            if (isError) {
	                error(errorLocation, ts.Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements, ts.getTextOfNode(expression));
	            }
	            return isError;
	        }
	        /**
	         * Climbs up parents to an ExpressionWithTypeArguments, and returns its expression,
	         * but returns undefined if that expression is not an EntityNameExpression.
	         */
	        function getEntityNameForExtendingInterface(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                case 183 /* PropertyAccessExpression */:
	                    return node.parent ? getEntityNameForExtendingInterface(node.parent) : undefined;
	                case 205 /* ExpressionWithTypeArguments */:
	                    if (ts.isEntityNameExpression(node.expression)) {
	                        return node.expression;
	                    }
	                // falls through
	                default:
	                    return undefined;
	            }
	        }
	        function checkAndReportErrorForUsingTypeAsNamespace(errorLocation, name, meaning) {
	            if (meaning === 1920 /* Namespace */) {
	                var symbol = resolveSymbol(resolveName(errorLocation, name, 793064 /* Type */ & ~1920 /* Namespace */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false));
	                var parent = errorLocation.parent;
	                if (symbol) {
	                    if (ts.isQualifiedName(parent)) {
	                        ts.Debug.assert(parent.left === errorLocation, "Should only be resolving left side of qualified name as a namespace");
	                        var propName = parent.right.escapedText;
	                        var propType = getPropertyOfType(getDeclaredTypeOfSymbol(symbol), propName);
	                        if (propType) {
	                            error(parent, ts.Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1, ts.unescapeLeadingUnderscores(name), ts.unescapeLeadingUnderscores(propName));
	                            return true;
	                        }
	                    }
	                    error(errorLocation, ts.Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	            }
	            return false;
	        }
	        function checkAndReportErrorForUsingTypeAsValue(errorLocation, name, meaning) {
	            if (meaning & (107455 /* Value */ & ~1024 /* NamespaceModule */)) {
	                if (name === "any" || name === "string" || name === "number" || name === "boolean" || name === "never") {
	                    error(errorLocation, ts.Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	                var symbol = resolveSymbol(resolveName(errorLocation, name, 793064 /* Type */ & ~107455 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false));
	                if (symbol && !(symbol.flags & 1024 /* NamespaceModule */)) {
	                    error(errorLocation, ts.Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	            }
	            return false;
	        }
	        function checkAndReportErrorForUsingNamespaceModuleAsValue(errorLocation, name, meaning) {
	            if (meaning & (107455 /* Value */ & ~1024 /* NamespaceModule */ & ~793064 /* Type */)) {
	                var symbol = resolveSymbol(resolveName(errorLocation, name, 1024 /* NamespaceModule */ & ~107455 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false));
	                if (symbol) {
	                    error(errorLocation, ts.Diagnostics.Cannot_use_namespace_0_as_a_value, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	            }
	            else if (meaning & (793064 /* Type */ & ~1024 /* NamespaceModule */ & ~107455 /* Value */)) {
	                var symbol = resolveSymbol(resolveName(errorLocation, name, (512 /* ValueModule */ | 1024 /* NamespaceModule */) & ~793064 /* Type */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false));
	                if (symbol) {
	                    error(errorLocation, ts.Diagnostics.Cannot_use_namespace_0_as_a_type, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	            }
	            return false;
	        }
	        function checkResolvedBlockScopedVariable(result, errorLocation) {
	            ts.Debug.assert(!!(result.flags & 2 /* BlockScopedVariable */ || result.flags & 32 /* Class */ || result.flags & 384 /* Enum */));
	            // Block-scoped variables cannot be used before their definition
	            var declaration = ts.forEach(result.declarations, function (d) { return ts.isBlockOrCatchScoped(d) || ts.isClassLike(d) || (d.kind === 236 /* EnumDeclaration */) ? d : undefined; });
	            ts.Debug.assert(declaration !== undefined, "Declaration to checkResolvedBlockScopedVariable is undefined");
	            if (!(declaration.flags & 2097152 /* Ambient */) && !isBlockScopedNameDeclaredBeforeUse(declaration, errorLocation)) {
	                if (result.flags & 2 /* BlockScopedVariable */) {
	                    error(errorLocation, ts.Diagnostics.Block_scoped_variable_0_used_before_its_declaration, ts.declarationNameToString(ts.getNameOfDeclaration(declaration)));
	                }
	                else if (result.flags & 32 /* Class */) {
	                    error(errorLocation, ts.Diagnostics.Class_0_used_before_its_declaration, ts.declarationNameToString(ts.getNameOfDeclaration(declaration)));
	                }
	                else if (result.flags & 256 /* RegularEnum */) {
	                    error(errorLocation, ts.Diagnostics.Enum_0_used_before_its_declaration, ts.declarationNameToString(ts.getNameOfDeclaration(declaration)));
	                }
	            }
	        }
	        /* Starting from 'initial' node walk up the parent chain until 'stopAt' node is reached.
	         * If at any point current node is equal to 'parent' node - return true.
	         * Return false if 'stopAt' node is reached or isFunctionLike(current) === true.
	         */
	        function isSameScopeDescendentOf(initial, parent, stopAt) {
	            return parent && !!ts.findAncestor(initial, function (n) { return n === stopAt || ts.isFunctionLike(n) ? "quit" : n === parent; });
	        }
	        function getAnyImportSyntax(node) {
	            switch (node.kind) {
	                case 241 /* ImportEqualsDeclaration */:
	                    return node;
	                case 243 /* ImportClause */:
	                    return node.parent;
	                case 244 /* NamespaceImport */:
	                    return node.parent.parent;
	                case 246 /* ImportSpecifier */:
	                    return node.parent.parent.parent;
	                default:
	                    return undefined;
	            }
	        }
	        function getDeclarationOfAliasSymbol(symbol) {
	            return ts.find(symbol.declarations, ts.isAliasSymbolDeclaration);
	        }
	        function getTargetOfImportEqualsDeclaration(node, dontResolveAlias) {
	            if (node.moduleReference.kind === 252 /* ExternalModuleReference */) {
	                return resolveExternalModuleSymbol(resolveExternalModuleName(node, ts.getExternalModuleImportEqualsDeclarationExpression(node)));
	            }
	            return getSymbolOfPartOfRightHandSideOfImportEquals(node.moduleReference, dontResolveAlias);
	        }
	        function resolveExportByName(moduleSymbol, name, dontResolveAlias) {
	            var exportValue = moduleSymbol.exports.get("export=" /* ExportEquals */);
	            return exportValue
	                ? getPropertyOfType(getTypeOfSymbol(exportValue), name)
	                : resolveSymbol(moduleSymbol.exports.get(name), dontResolveAlias);
	        }
	        function canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias) {
	            if (!allowSyntheticDefaultImports) {
	                return false;
	            }
	            // Declaration files (and ambient modules)
	            if (!file || file.isDeclarationFile) {
	                // Definitely cannot have a synthetic default if they have a default member specified
	                if (resolveExportByName(moduleSymbol, "default" /* Default */, dontResolveAlias)) {
	                    return false;
	                }
	                // It _might_ still be incorrect to assume there is no __esModule marker on the import at runtime, even if there is no `default` member
	                // So we check a bit more,
	                if (resolveExportByName(moduleSymbol, ts.escapeLeadingUnderscores("__esModule"), dontResolveAlias)) {
	                    // If there is an `__esModule` specified in the declaration (meaning someone explicitly added it or wrote it in their code),
	                    // it definitely is a module and does not have a synthetic default
	                    return false;
	                }
	                // There are _many_ declaration files not written with esmodules in mind that still get compiled into a format with __esModule set
	                // Meaning there may be no default at runtime - however to be on the permissive side, we allow access to a synthetic default member
	                // as there is no marker to indicate if the accompanying JS has `__esModule` or not, or is even native esm
	                return true;
	            }
	            // TypeScript files never have a synthetic default (as they are always emitted with an __esModule marker) _unless_ they contain an export= statement
	            if (!ts.isSourceFileJavaScript(file)) {
	                return hasExportAssignmentSymbol(moduleSymbol);
	            }
	            // JS files have a synthetic default if they do not contain ES2015+ module syntax (export = is not valid in js) _and_ do not have an __esModule marker
	            return !file.externalModuleIndicator && !resolveExportByName(moduleSymbol, ts.escapeLeadingUnderscores("__esModule"), dontResolveAlias);
	        }
	        function getTargetOfImportClause(node, dontResolveAlias) {
	            var moduleSymbol = resolveExternalModuleName(node, node.parent.moduleSpecifier);
	            if (moduleSymbol) {
	                var exportDefaultSymbol = void 0;
	                if (ts.isShorthandAmbientModuleSymbol(moduleSymbol)) {
	                    exportDefaultSymbol = moduleSymbol;
	                }
	                else {
	                    exportDefaultSymbol = resolveExportByName(moduleSymbol, "default" /* Default */, dontResolveAlias);
	                }
	                var file = ts.find(moduleSymbol.declarations, ts.isSourceFile);
	                var hasSyntheticDefault = canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias);
	                if (!exportDefaultSymbol && !hasSyntheticDefault) {
	                    error(node.name, ts.Diagnostics.Module_0_has_no_default_export, symbolToString(moduleSymbol));
	                }
	                else if (!exportDefaultSymbol && hasSyntheticDefault) {
	                    // per emit behavior, a synthetic default overrides a "real" .default member if `__esModule` is not present
	                    return resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) || resolveSymbol(moduleSymbol, dontResolveAlias);
	                }
	                return exportDefaultSymbol;
	            }
	        }
	        function getTargetOfNamespaceImport(node, dontResolveAlias) {
	            var moduleSpecifier = node.parent.parent.moduleSpecifier;
	            return resolveESModuleSymbol(resolveExternalModuleName(node, moduleSpecifier), moduleSpecifier, dontResolveAlias);
	        }
	        // This function creates a synthetic symbol that combines the value side of one symbol with the
	        // type/namespace side of another symbol. Consider this example:
	        //
	        //   declare module graphics {
	        //       interface Point {
	        //           x: number;
	        //           y: number;
	        //       }
	        //   }
	        //   declare var graphics: {
	        //       Point: new (x: number, y: number) => graphics.Point;
	        //   }
	        //   declare module "graphics" {
	        //       export = graphics;
	        //   }
	        //
	        // An 'import { Point } from "graphics"' needs to create a symbol that combines the value side 'Point'
	        // property with the type/namespace side interface 'Point'.
	        function combineValueAndTypeSymbols(valueSymbol, typeSymbol) {
	            if (valueSymbol === unknownSymbol && typeSymbol === unknownSymbol) {
	                return unknownSymbol;
	            }
	            if (valueSymbol.flags & (793064 /* Type */ | 1920 /* Namespace */)) {
	                return valueSymbol;
	            }
	            var result = createSymbol(valueSymbol.flags | typeSymbol.flags, valueSymbol.escapedName);
	            result.declarations = ts.concatenate(valueSymbol.declarations, typeSymbol.declarations);
	            result.parent = valueSymbol.parent || typeSymbol.parent;
	            if (valueSymbol.valueDeclaration)
	                result.valueDeclaration = valueSymbol.valueDeclaration;
	            if (typeSymbol.members)
	                result.members = typeSymbol.members;
	            if (valueSymbol.exports)
	                result.exports = valueSymbol.exports;
	            return result;
	        }
	        function getExportOfModule(symbol, name, dontResolveAlias) {
	            if (symbol.flags & 1536 /* Module */) {
	                return resolveSymbol(getExportsOfSymbol(symbol).get(name), dontResolveAlias);
	            }
	        }
	        function getPropertyOfVariable(symbol, name) {
	            if (symbol.flags & 3 /* Variable */) {
	                var typeAnnotation = symbol.valueDeclaration.type;
	                if (typeAnnotation) {
	                    return resolveSymbol(getPropertyOfType(getTypeFromTypeNode(typeAnnotation), name));
	                }
	            }
	        }
	        function getExternalModuleMember(node, specifier, dontResolveAlias) {
	            var moduleSymbol = resolveExternalModuleName(node, node.moduleSpecifier);
	            var targetSymbol = resolveESModuleSymbol(moduleSymbol, node.moduleSpecifier, dontResolveAlias);
	            if (targetSymbol) {
	                var name = specifier.propertyName || specifier.name;
	                if (name.escapedText) {
	                    if (ts.isShorthandAmbientModuleSymbol(moduleSymbol)) {
	                        return moduleSymbol;
	                    }
	                    var symbolFromVariable = void 0;
	                    // First check if module was specified with "export=". If so, get the member from the resolved type
	                    if (moduleSymbol && moduleSymbol.exports && moduleSymbol.exports.get("export=")) {
	                        symbolFromVariable = getPropertyOfType(getTypeOfSymbol(targetSymbol), name.escapedText);
	                    }
	                    else {
	                        symbolFromVariable = getPropertyOfVariable(targetSymbol, name.escapedText);
	                    }
	                    // if symbolFromVariable is export - get its final target
	                    symbolFromVariable = resolveSymbol(symbolFromVariable, dontResolveAlias);
	                    var symbolFromModule = getExportOfModule(targetSymbol, name.escapedText, dontResolveAlias);
	                    // If the export member we're looking for is default, and there is no real default but allowSyntheticDefaultImports is on, return the entire module as the default
	                    if (!symbolFromModule && allowSyntheticDefaultImports && name.escapedText === "default" /* Default */) {
	                        symbolFromModule = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) || resolveSymbol(moduleSymbol, dontResolveAlias);
	                    }
	                    var symbol = symbolFromModule && symbolFromVariable ?
	                        combineValueAndTypeSymbols(symbolFromVariable, symbolFromModule) :
	                        symbolFromModule || symbolFromVariable;
	                    if (!symbol) {
	                        error(name, ts.Diagnostics.Module_0_has_no_exported_member_1, getFullyQualifiedName(moduleSymbol), ts.declarationNameToString(name));
	                    }
	                    return symbol;
	                }
	            }
	        }
	        function getTargetOfImportSpecifier(node, dontResolveAlias) {
	            return getExternalModuleMember(node.parent.parent.parent, node, dontResolveAlias);
	        }
	        function getTargetOfNamespaceExportDeclaration(node, dontResolveAlias) {
	            return resolveExternalModuleSymbol(node.parent.symbol, dontResolveAlias);
	        }
	        function getTargetOfExportSpecifier(node, meaning, dontResolveAlias) {
	            return node.parent.parent.moduleSpecifier ?
	                getExternalModuleMember(node.parent.parent, node, dontResolveAlias) :
	                resolveEntityName(node.propertyName || node.name, meaning, /*ignoreErrors*/ false, dontResolveAlias);
	        }
	        function getTargetOfExportAssignment(node, dontResolveAlias) {
	            return resolveEntityName(node.expression, 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */, /*ignoreErrors*/ false, dontResolveAlias);
	        }
	        function getTargetOfAliasDeclaration(node, dontRecursivelyResolve) {
	            switch (node.kind) {
	                case 241 /* ImportEqualsDeclaration */:
	                    return getTargetOfImportEqualsDeclaration(node, dontRecursivelyResolve);
	                case 243 /* ImportClause */:
	                    return getTargetOfImportClause(node, dontRecursivelyResolve);
	                case 244 /* NamespaceImport */:
	                    return getTargetOfNamespaceImport(node, dontRecursivelyResolve);
	                case 246 /* ImportSpecifier */:
	                    return getTargetOfImportSpecifier(node, dontRecursivelyResolve);
	                case 250 /* ExportSpecifier */:
	                    return getTargetOfExportSpecifier(node, 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */, dontRecursivelyResolve);
	                case 247 /* ExportAssignment */:
	                    return getTargetOfExportAssignment(node, dontRecursivelyResolve);
	                case 240 /* NamespaceExportDeclaration */:
	                    return getTargetOfNamespaceExportDeclaration(node, dontRecursivelyResolve);
	            }
	        }
	        /**
	         * Indicates that a symbol is an alias that does not merge with a local declaration.
	         */
	        function isNonLocalAlias(symbol, excludes) {
	            if (excludes === void 0) { excludes = 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */; }
	            return symbol && (symbol.flags & (2097152 /* Alias */ | excludes)) === 2097152 /* Alias */;
	        }
	        function resolveSymbol(symbol, dontResolveAlias) {
	            var shouldResolve = !dontResolveAlias && isNonLocalAlias(symbol);
	            return shouldResolve ? resolveAlias(symbol) : symbol;
	        }
	        function resolveAlias(symbol) {
	            ts.Debug.assert((symbol.flags & 2097152 /* Alias */) !== 0, "Should only get Alias here.");
	            var links = getSymbolLinks(symbol);
	            if (!links.target) {
	                links.target = resolvingSymbol;
	                var node = getDeclarationOfAliasSymbol(symbol);
	                ts.Debug.assert(!!node);
	                var target = getTargetOfAliasDeclaration(node);
	                if (links.target === resolvingSymbol) {
	                    links.target = target || unknownSymbol;
	                }
	                else {
	                    error(node, ts.Diagnostics.Circular_definition_of_import_alias_0, symbolToString(symbol));
	                }
	            }
	            else if (links.target === resolvingSymbol) {
	                links.target = unknownSymbol;
	            }
	            return links.target;
	        }
	        function markExportAsReferenced(node) {
	            var symbol = getSymbolOfNode(node);
	            var target = resolveAlias(symbol);
	            if (target) {
	                var markAlias = target === unknownSymbol ||
	                    ((target.flags & 107455 /* Value */) && !isConstEnumOrConstEnumOnlyModule(target));
	                if (markAlias) {
	                    markAliasSymbolAsReferenced(symbol);
	                }
	            }
	        }
	        // When an alias symbol is referenced, we need to mark the entity it references as referenced and in turn repeat that until
	        // we reach a non-alias or an exported entity (which is always considered referenced). We do this by checking the target of
	        // the alias as an expression (which recursively takes us back here if the target references another alias).
	        function markAliasSymbolAsReferenced(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.referenced) {
	                links.referenced = true;
	                var node = getDeclarationOfAliasSymbol(symbol);
	                ts.Debug.assert(!!node);
	                if (node.kind === 247 /* ExportAssignment */) {
	                    // export default <symbol>
	                    checkExpressionCached(node.expression);
	                }
	                else if (node.kind === 250 /* ExportSpecifier */) {
	                    // export { <symbol> } or export { <symbol> as foo }
	                    checkExpressionCached(node.propertyName || node.name);
	                }
	                else if (ts.isInternalModuleImportEqualsDeclaration(node)) {
	                    // import foo = <symbol>
	                    checkExpressionCached(node.moduleReference);
	                }
	            }
	        }
	        // This function is only for imports with entity names
	        function getSymbolOfPartOfRightHandSideOfImportEquals(entityName, dontResolveAlias) {
	            // There are three things we might try to look for. In the following examples,
	            // the search term is enclosed in |...|:
	            //
	            //     import a = |b|; // Namespace
	            //     import a = |b.c|; // Value, type, namespace
	            //     import a = |b.c|.d; // Namespace
	            if (entityName.kind === 71 /* Identifier */ && ts.isRightSideOfQualifiedNameOrPropertyAccess(entityName)) {
	                entityName = entityName.parent;
	            }
	            // Check for case 1 and 3 in the above example
	            if (entityName.kind === 71 /* Identifier */ || entityName.parent.kind === 145 /* QualifiedName */) {
	                return resolveEntityName(entityName, 1920 /* Namespace */, /*ignoreErrors*/ false, dontResolveAlias);
	            }
	            else {
	                // Case 2 in above example
	                // entityName.kind could be a QualifiedName or a Missing identifier
	                ts.Debug.assert(entityName.parent.kind === 241 /* ImportEqualsDeclaration */);
	                return resolveEntityName(entityName, 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */, /*ignoreErrors*/ false, dontResolveAlias);
	            }
	        }
	        function getFullyQualifiedName(symbol) {
	            return symbol.parent ? getFullyQualifiedName(symbol.parent) + "." + symbolToString(symbol) : symbolToString(symbol);
	        }
	        /**
	         * Resolves a qualified name and any involved aliases.
	         */
	        function resolveEntityName(name, meaning, ignoreErrors, dontResolveAlias, location) {
	            if (ts.nodeIsMissing(name)) {
	                return undefined;
	            }
	            var symbol;
	            if (name.kind === 71 /* Identifier */) {
	                var message = meaning === 1920 /* Namespace */ ? ts.Diagnostics.Cannot_find_namespace_0 : ts.Diagnostics.Cannot_find_name_0;
	                symbol = resolveName(location || name, name.escapedText, meaning, ignoreErrors ? undefined : message, name, /*isUse*/ true);
	                if (!symbol) {
	                    return undefined;
	                }
	            }
	            else if (name.kind === 145 /* QualifiedName */ || name.kind === 183 /* PropertyAccessExpression */) {
	                var left = void 0;
	                if (name.kind === 145 /* QualifiedName */) {
	                    left = name.left;
	                }
	                else if (name.kind === 183 /* PropertyAccessExpression */) {
	                    left = name.expression;
	                }
	                else {
	                    // If the expression in property-access expression is not entity-name or parenthsizedExpression (e.g. it is a call expression), it won't be able to successfully resolve the name.
	                    // This is the case when we are trying to do any language service operation in heritage clauses. By return undefined, the getSymbolOfEntityNameOrPropertyAccessExpression
	                    // will attempt to checkPropertyAccessExpression to resolve symbol.
	                    // i.e class C extends foo()./*do language service operation here*/B {}
	                    return undefined;
	                }
	                var right = name.kind === 145 /* QualifiedName */ ? name.right : name.name;
	                var namespace = resolveEntityName(left, 1920 /* Namespace */, ignoreErrors, /*dontResolveAlias*/ false, location);
	                if (!namespace || ts.nodeIsMissing(right)) {
	                    return undefined;
	                }
	                else if (namespace === unknownSymbol) {
	                    return namespace;
	                }
	                if (ts.isInJavaScriptFile(name) && ts.isDeclarationOfFunctionOrClassExpression(namespace)) {
	                    namespace = getSymbolOfNode(namespace.valueDeclaration.initializer);
	                }
	                symbol = getSymbol(getExportsOfSymbol(namespace), right.escapedText, meaning);
	                if (!symbol) {
	                    if (!ignoreErrors) {
	                        error(right, ts.Diagnostics.Namespace_0_has_no_exported_member_1, getFullyQualifiedName(namespace), ts.declarationNameToString(right));
	                    }
	                    return undefined;
	                }
	            }
	            else {
	                ts.Debug.assertNever(name, "Unknown entity name kind.");
	            }
	            ts.Debug.assert((ts.getCheckFlags(symbol) & 1 /* Instantiated */) === 0, "Should never get an instantiated symbol here.");
	            return (symbol.flags & meaning) || dontResolveAlias ? symbol : resolveAlias(symbol);
	        }
	        function resolveExternalModuleName(location, moduleReferenceExpression) {
	            return resolveExternalModuleNameWorker(location, moduleReferenceExpression, ts.Diagnostics.Cannot_find_module_0);
	        }
	        function resolveExternalModuleNameWorker(location, moduleReferenceExpression, moduleNotFoundError, isForAugmentation) {
	            if (isForAugmentation === void 0) { isForAugmentation = false; }
	            return ts.isStringLiteralLike(moduleReferenceExpression)
	                ? resolveExternalModule(location, moduleReferenceExpression.text, moduleNotFoundError, moduleReferenceExpression, isForAugmentation)
	                : undefined;
	        }
	        function resolveExternalModule(location, moduleReference, moduleNotFoundError, errorNode, isForAugmentation) {
	            if (isForAugmentation === void 0) { isForAugmentation = false; }
	            if (moduleReference === undefined) {
	                return;
	            }
	            if (ts.startsWith(moduleReference, "@types/")) {
	                var diag = ts.Diagnostics.Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1;
	                var withoutAtTypePrefix = ts.removePrefix(moduleReference, "@types/");
	                error(errorNode, diag, withoutAtTypePrefix, moduleReference);
	            }
	            var ambientModule = tryFindAmbientModule(moduleReference, /*withAugmentations*/ true);
	            if (ambientModule) {
	                return ambientModule;
	            }
	            var resolvedModule = ts.getResolvedModule(ts.getSourceFileOfNode(location), moduleReference);
	            var resolutionDiagnostic = resolvedModule && ts.getResolutionDiagnostic(compilerOptions, resolvedModule);
	            var sourceFile = resolvedModule && !resolutionDiagnostic && host.getSourceFile(resolvedModule.resolvedFileName);
	            if (sourceFile) {
	                if (sourceFile.symbol) {
	                    // merged symbol is module declaration symbol combined with all augmentations
	                    return getMergedSymbol(sourceFile.symbol);
	                }
	                if (moduleNotFoundError) {
	                    // report errors only if it was requested
	                    error(errorNode, ts.Diagnostics.File_0_is_not_a_module, sourceFile.fileName);
	                }
	                return undefined;
	            }
	            if (patternAmbientModules) {
	                var pattern = ts.findBestPatternMatch(patternAmbientModules, function (_) { return _.pattern; }, moduleReference);
	                if (pattern) {
	                    return getMergedSymbol(pattern.symbol);
	                }
	            }
	            // May be an untyped module. If so, ignore resolutionDiagnostic.
	            if (resolvedModule && !ts.extensionIsTypeScript(resolvedModule.extension) && resolutionDiagnostic === undefined || resolutionDiagnostic === ts.Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type) {
	                if (isForAugmentation) {
	                    var diag = ts.Diagnostics.Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augmented;
	                    error(errorNode, diag, moduleReference, resolvedModule.resolvedFileName);
	                }
	                else if (noImplicitAny && moduleNotFoundError) {
	                    var errorInfo = resolvedModule.packageId && ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.Try_npm_install_types_Slash_0_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_module_0, resolvedModule.packageId.name);
	                    errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type, moduleReference, resolvedModule.resolvedFileName);
	                    diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(errorNode, errorInfo));
	                }
	                // Failed imports and untyped modules are both treated in an untyped manner; only difference is whether we give a diagnostic first.
	                return undefined;
	            }
	            if (moduleNotFoundError) {
	                // report errors only if it was requested
	                if (resolutionDiagnostic) {
	                    error(errorNode, resolutionDiagnostic, moduleReference, resolvedModule.resolvedFileName);
	                }
	                else {
	                    var tsExtension = ts.tryExtractTypeScriptExtension(moduleReference);
	                    if (tsExtension) {
	                        var diag = ts.Diagnostics.An_import_path_cannot_end_with_a_0_extension_Consider_importing_1_instead;
	                        error(errorNode, diag, tsExtension, ts.removeExtension(moduleReference, tsExtension));
	                    }
	                    else {
	                        error(errorNode, moduleNotFoundError, moduleReference);
	                    }
	                }
	            }
	            return undefined;
	        }
	        // An external module with an 'export =' declaration resolves to the target of the 'export =' declaration,
	        // and an external module with no 'export =' declaration resolves to the module itself.
	        function resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) {
	            return moduleSymbol && getMergedSymbol(resolveSymbol(moduleSymbol.exports.get("export=" /* ExportEquals */), dontResolveAlias)) || moduleSymbol;
	        }
	        // An external module with an 'export =' declaration may be referenced as an ES6 module provided the 'export ='
	        // references a symbol that is at least declared as a module or a variable. The target of the 'export =' may
	        // combine other declarations with the module or variable (e.g. a class/module, function/module, interface/variable).
	        function resolveESModuleSymbol(moduleSymbol, moduleReferenceExpression, dontResolveAlias) {
	            var symbol = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias);
	            if (!dontResolveAlias && symbol) {
	                if (!(symbol.flags & (1536 /* Module */ | 3 /* Variable */))) {
	                    error(moduleReferenceExpression, ts.Diagnostics.Module_0_resolves_to_a_non_module_entity_and_cannot_be_imported_using_this_construct, symbolToString(moduleSymbol));
	                    return symbol;
	                }
	                if (compilerOptions.esModuleInterop) {
	                    var referenceParent = moduleReferenceExpression.parent;
	                    if ((ts.isImportDeclaration(referenceParent) && ts.getNamespaceDeclarationNode(referenceParent)) ||
	                        ts.isImportCall(referenceParent)) {
	                        var type = getTypeOfSymbol(symbol);
	                        var sigs = getSignaturesOfStructuredType(type, 0 /* Call */);
	                        if (!sigs || !sigs.length) {
	                            sigs = getSignaturesOfStructuredType(type, 1 /* Construct */);
	                        }
	                        if (sigs && sigs.length) {
	                            var moduleType = getTypeWithSyntheticDefaultImportType(type, symbol, moduleSymbol);
	                            // Create a new symbol which has the module's type less the call and construct signatures
	                            var result = createSymbol(symbol.flags, symbol.escapedName);
	                            result.declarations = symbol.declarations ? symbol.declarations.slice() : [];
	                            result.parent = symbol.parent;
	                            result.target = symbol;
	                            result.originatingImport = referenceParent;
	                            if (symbol.valueDeclaration)
	                                result.valueDeclaration = symbol.valueDeclaration;
	                            if (symbol.constEnumOnlyModule)
	                                result.constEnumOnlyModule = true;
	                            if (symbol.members)
	                                result.members = ts.cloneMap(symbol.members);
	                            if (symbol.exports)
	                                result.exports = ts.cloneMap(symbol.exports);
	                            var resolvedModuleType = resolveStructuredTypeMembers(moduleType); // Should already be resolved from the signature checks above
	                            result.type = createAnonymousType(result, resolvedModuleType.members, ts.emptyArray, ts.emptyArray, resolvedModuleType.stringIndexInfo, resolvedModuleType.numberIndexInfo);
	                            return result;
	                        }
	                    }
	                }
	            }
	            return symbol;
	        }
	        function hasExportAssignmentSymbol(moduleSymbol) {
	            return moduleSymbol.exports.get("export=" /* ExportEquals */) !== undefined;
	        }
	        function getExportsOfModuleAsArray(moduleSymbol) {
	            return symbolsToArray(getExportsOfModule(moduleSymbol));
	        }
	        function getExportsAndPropertiesOfModule(moduleSymbol) {
	            var exports = getExportsOfModuleAsArray(moduleSymbol);
	            var exportEquals = resolveExternalModuleSymbol(moduleSymbol);
	            if (exportEquals !== moduleSymbol) {
	                ts.addRange(exports, getPropertiesOfType(getTypeOfSymbol(exportEquals)));
	            }
	            return exports;
	        }
	        function tryGetMemberInModuleExports(memberName, moduleSymbol) {
	            var symbolTable = getExportsOfModule(moduleSymbol);
	            if (symbolTable) {
	                return symbolTable.get(memberName);
	            }
	        }
	        function tryGetMemberInModuleExportsAndProperties(memberName, moduleSymbol) {
	            var symbol = tryGetMemberInModuleExports(memberName, moduleSymbol);
	            if (symbol) {
	                return symbol;
	            }
	            var exportEquals = resolveExternalModuleSymbol(moduleSymbol);
	            if (exportEquals === moduleSymbol) {
	                return undefined;
	            }
	            var type = getTypeOfSymbol(exportEquals);
	            return type.flags & 16382 /* Primitive */ ? undefined : getPropertyOfType(type, memberName);
	        }
	        function getExportsOfSymbol(symbol) {
	            return symbol.flags & 32 /* Class */ ? getResolvedMembersOrExportsOfSymbol(symbol, "resolvedExports" /* resolvedExports */) :
	                symbol.flags & 1536 /* Module */ ? getExportsOfModule(symbol) :
	                    symbol.exports || emptySymbols;
	        }
	        function getExportsOfModule(moduleSymbol) {
	            var links = getSymbolLinks(moduleSymbol);
	            return links.resolvedExports || (links.resolvedExports = getExportsOfModuleWorker(moduleSymbol));
	        }
	        /**
	         * Extends one symbol table with another while collecting information on name collisions for error message generation into the `lookupTable` argument
	         * Not passing `lookupTable` and `exportNode` disables this collection, and just extends the tables
	         */
	        function extendExportSymbols(target, source, lookupTable, exportNode) {
	            if (!source)
	                return;
	            source.forEach(function (sourceSymbol, id) {
	                if (id === "default" /* Default */)
	                    return;
	                var targetSymbol = target.get(id);
	                if (!targetSymbol) {
	                    target.set(id, sourceSymbol);
	                    if (lookupTable && exportNode) {
	                        lookupTable.set(id, {
	                            specifierText: ts.getTextOfNode(exportNode.moduleSpecifier)
	                        });
	                    }
	                }
	                else if (lookupTable && exportNode && targetSymbol && resolveSymbol(targetSymbol) !== resolveSymbol(sourceSymbol)) {
	                    var collisionTracker = lookupTable.get(id);
	                    if (!collisionTracker.exportsWithDuplicate) {
	                        collisionTracker.exportsWithDuplicate = [exportNode];
	                    }
	                    else {
	                        collisionTracker.exportsWithDuplicate.push(exportNode);
	                    }
	                }
	            });
	        }
	        function getExportsOfModuleWorker(moduleSymbol) {
	            var visitedSymbols = [];
	            // A module defined by an 'export=' consists on one export that needs to be resolved
	            moduleSymbol = resolveExternalModuleSymbol(moduleSymbol);
	            return visit(moduleSymbol) || emptySymbols;
	            // The ES6 spec permits export * declarations in a module to circularly reference the module itself. For example,
	            // module 'a' can 'export * from "b"' and 'b' can 'export * from "a"' without error.
	            function visit(symbol) {
	                if (!(symbol && symbol.flags & 1952 /* HasExports */ && ts.pushIfUnique(visitedSymbols, symbol))) {
	                    return;
	                }
	                var symbols = ts.cloneMap(symbol.exports);
	                // All export * declarations are collected in an __export symbol by the binder
	                var exportStars = symbol.exports.get("__export" /* ExportStar */);
	                if (exportStars) {
	                    var nestedSymbols = ts.createSymbolTable();
	                    var lookupTable_1 = ts.createMap();
	                    for (var _i = 0, _a = exportStars.declarations; _i < _a.length; _i++) {
	                        var node = _a[_i];
	                        var resolvedModule = resolveExternalModuleName(node, node.moduleSpecifier);
	                        var exportedSymbols = visit(resolvedModule);
	                        extendExportSymbols(nestedSymbols, exportedSymbols, lookupTable_1, node);
	                    }
	                    lookupTable_1.forEach(function (_a, id) {
	                        var exportsWithDuplicate = _a.exportsWithDuplicate;
	                        // It's not an error if the file with multiple `export *`s with duplicate names exports a member with that name itself
	                        if (id === "export=" || !(exportsWithDuplicate && exportsWithDuplicate.length) || symbols.has(id)) {
	                            return;
	                        }
	                        for (var _i = 0, exportsWithDuplicate_1 = exportsWithDuplicate; _i < exportsWithDuplicate_1.length; _i++) {
	                            var node = exportsWithDuplicate_1[_i];
	                            diagnostics.add(ts.createDiagnosticForNode(node, ts.Diagnostics.Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambiguity, lookupTable_1.get(id).specifierText, ts.unescapeLeadingUnderscores(id)));
	                        }
	                    });
	                    extendExportSymbols(symbols, nestedSymbols);
	                }
	                return symbols;
	            }
	        }
	        function getMergedSymbol(symbol) {
	            var merged;
	            return symbol && symbol.mergeId && (merged = mergedSymbols[symbol.mergeId]) ? merged : symbol;
	        }
	        function getSymbolOfNode(node) {
	            return getMergedSymbol(node.symbol && getLateBoundSymbol(node.symbol));
	        }
	        function getParentOfSymbol(symbol) {
	            return getMergedSymbol(symbol.parent && getLateBoundSymbol(symbol.parent));
	        }
	        function getExportSymbolOfValueSymbolIfExported(symbol) {
	            return symbol && (symbol.flags & 1048576 /* ExportValue */) !== 0
	                ? getMergedSymbol(symbol.exportSymbol)
	                : symbol;
	        }
	        function symbolIsValue(symbol) {
	            return !!(symbol.flags & 107455 /* Value */ || symbol.flags & 2097152 /* Alias */ && resolveAlias(symbol).flags & 107455 /* Value */);
	        }
	        function findConstructorDeclaration(node) {
	            var members = node.members;
	            for (var _i = 0, members_2 = members; _i < members_2.length; _i++) {
	                var member = members_2[_i];
	                if (member.kind === 154 /* Constructor */ && ts.nodeIsPresent(member.body)) {
	                    return member;
	                }
	            }
	        }
	        function createType(flags) {
	            var result = new Type(checker, flags);
	            typeCount++;
	            result.id = typeCount;
	            return result;
	        }
	        function createIntrinsicType(kind, intrinsicName) {
	            var type = createType(kind);
	            type.intrinsicName = intrinsicName;
	            return type;
	        }
	        function createBooleanType(trueFalseTypes) {
	            var type = getUnionType(trueFalseTypes);
	            type.flags |= 8 /* Boolean */;
	            type.intrinsicName = "boolean";
	            return type;
	        }
	        function createObjectType(objectFlags, symbol) {
	            var type = createType(65536 /* Object */);
	            type.objectFlags = objectFlags;
	            type.symbol = symbol;
	            return type;
	        }
	        function createTypeofType() {
	            return getUnionType(ts.arrayFrom(typeofEQFacts.keys(), getLiteralType));
	        }
	        // A reserved member name starts with two underscores, but the third character cannot be an underscore
	        // or the @ symbol. A third underscore indicates an escaped form of an identifer that started
	        // with at least two underscores. The @ character indicates that the name is denoted by a well known ES
	        // Symbol instance.
	        function isReservedMemberName(name) {
	            return name.charCodeAt(0) === 95 /* _ */ &&
	                name.charCodeAt(1) === 95 /* _ */ &&
	                name.charCodeAt(2) !== 95 /* _ */ &&
	                name.charCodeAt(2) !== 64 /* at */;
	        }
	        function getNamedMembers(members) {
	            var result;
	            members.forEach(function (symbol, id) {
	                if (!isReservedMemberName(id)) {
	                    if (!result)
	                        result = [];
	                    if (symbolIsValue(symbol)) {
	                        result.push(symbol);
	                    }
	                }
	            });
	            return result || ts.emptyArray;
	        }
	        function setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo) {
	            type.members = members;
	            type.properties = getNamedMembers(members);
	            type.callSignatures = callSignatures;
	            type.constructSignatures = constructSignatures;
	            if (stringIndexInfo)
	                type.stringIndexInfo = stringIndexInfo;
	            if (numberIndexInfo)
	                type.numberIndexInfo = numberIndexInfo;
	            return type;
	        }
	        function createAnonymousType(symbol, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo) {
	            return setStructuredTypeMembers(createObjectType(16 /* Anonymous */, symbol), members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	        }
	        function forEachSymbolTableInScope(enclosingDeclaration, callback) {
	            var result;
	            for (var location = enclosingDeclaration; location; location = location.parent) {
	                // Locals of a source file are not in scope (because they get merged into the global symbol table)
	                if (location.locals && !isGlobalSourceFile(location)) {
	                    if (result = callback(location.locals)) {
	                        return result;
	                    }
	                }
	                switch (location.kind) {
	                    case 272 /* SourceFile */:
	                        if (!ts.isExternalOrCommonJsModule(location)) {
	                            break;
	                        }
	                    // falls through
	                    case 237 /* ModuleDeclaration */:
	                        if (result = callback(getSymbolOfNode(location).exports)) {
	                            return result;
	                        }
	                        break;
	                }
	            }
	            return callback(globals);
	        }
	        function getQualifiedLeftMeaning(rightMeaning) {
	            // If we are looking in value space, the parent meaning is value, other wise it is namespace
	            return rightMeaning === 107455 /* Value */ ? 107455 /* Value */ : 1920 /* Namespace */;
	        }
	        function getAccessibleSymbolChain(symbol, enclosingDeclaration, meaning, useOnlyExternalAliasing) {
	            if (!(symbol && !isPropertyOrMethodDeclarationSymbol(symbol))) {
	                return undefined;
	            }
	            var visitedSymbolTables = [];
	            return forEachSymbolTableInScope(enclosingDeclaration, getAccessibleSymbolChainFromSymbolTable);
	            /**
	             * @param {ignoreQualification} boolean Set when a symbol is being looked for through the exports of another symbol (meaning we have a route to qualify it already)
	             */
	            function getAccessibleSymbolChainFromSymbolTable(symbols, ignoreQualification) {
	                if (!ts.pushIfUnique(visitedSymbolTables, symbols)) {
	                    return undefined;
	                }
	                var result = trySymbolTable(symbols, ignoreQualification);
	                visitedSymbolTables.pop();
	                return result;
	            }
	            function canQualifySymbol(symbolFromSymbolTable, meaning) {
	                // If the symbol is equivalent and doesn't need further qualification, this symbol is accessible
	                return !needsQualification(symbolFromSymbolTable, enclosingDeclaration, meaning) ||
	                    // If symbol needs qualification, make sure that parent is accessible, if it is then this symbol is accessible too
	                    !!getAccessibleSymbolChain(symbolFromSymbolTable.parent, enclosingDeclaration, getQualifiedLeftMeaning(meaning), useOnlyExternalAliasing);
	            }
	            function isAccessible(symbolFromSymbolTable, resolvedAliasSymbol, ignoreQualification) {
	                return symbol === (resolvedAliasSymbol || symbolFromSymbolTable) &&
	                    // if the symbolFromSymbolTable is not external module (it could be if it was determined as ambient external module and would be in globals table)
	                    // and if symbolFromSymbolTable or alias resolution matches the symbol,
	                    // check the symbol can be qualified, it is only then this symbol is accessible
	                    !ts.some(symbolFromSymbolTable.declarations, hasExternalModuleSymbol) &&
	                    (ignoreQualification || canQualifySymbol(symbolFromSymbolTable, meaning));
	            }
	            function trySymbolTable(symbols, ignoreQualification) {
	                // If symbol is directly available by its name in the symbol table
	                if (isAccessible(symbols.get(symbol.escapedName), /*resolvedAliasSymbol*/ undefined, ignoreQualification)) {
	                    return [symbol];
	                }
	                // Check if symbol is any of the alias
	                return ts.forEachEntry(symbols, function (symbolFromSymbolTable) {
	                    if (symbolFromSymbolTable.flags & 2097152 /* Alias */
	                        && symbolFromSymbolTable.escapedName !== "export="
	                        && !(ts.isUMDExportSymbol(symbolFromSymbolTable) && enclosingDeclaration && ts.isExternalModule(ts.getSourceFileOfNode(enclosingDeclaration)))
	                        // If `!useOnlyExternalAliasing`, we can use any type of alias to get the name
	                        && (!useOnlyExternalAliasing || ts.some(symbolFromSymbolTable.declarations, ts.isExternalModuleImportEqualsDeclaration))) {
	                        var resolvedImportedSymbol = resolveAlias(symbolFromSymbolTable);
	                        if (isAccessible(symbolFromSymbolTable, resolvedImportedSymbol, ignoreQualification)) {
	                            return [symbolFromSymbolTable];
	                        }
	                        // Look in the exported members, if we can find accessibleSymbolChain, symbol is accessible using this chain
	                        // but only if the symbolFromSymbolTable can be qualified
	                        var candidateTable = getExportsOfSymbol(resolvedImportedSymbol);
	                        var accessibleSymbolsFromExports = candidateTable && getAccessibleSymbolChainFromSymbolTable(candidateTable, /*ignoreQualification*/ true);
	                        if (accessibleSymbolsFromExports && canQualifySymbol(symbolFromSymbolTable, getQualifiedLeftMeaning(meaning))) {
	                            return [symbolFromSymbolTable].concat(accessibleSymbolsFromExports);
	                        }
	                    }
	                });
	            }
	        }
	        function needsQualification(symbol, enclosingDeclaration, meaning) {
	            var qualify = false;
	            forEachSymbolTableInScope(enclosingDeclaration, function (symbolTable) {
	                // If symbol of this name is not available in the symbol table we are ok
	                var symbolFromSymbolTable = symbolTable.get(symbol.escapedName);
	                if (!symbolFromSymbolTable) {
	                    // Continue to the next symbol table
	                    return false;
	                }
	                // If the symbol with this name is present it should refer to the symbol
	                if (symbolFromSymbolTable === symbol) {
	                    // No need to qualify
	                    return true;
	                }
	                // Qualify if the symbol from symbol table has same meaning as expected
	                symbolFromSymbolTable = (symbolFromSymbolTable.flags & 2097152 /* Alias */ && !ts.getDeclarationOfKind(symbolFromSymbolTable, 250 /* ExportSpecifier */)) ? resolveAlias(symbolFromSymbolTable) : symbolFromSymbolTable;
	                if (symbolFromSymbolTable.flags & meaning) {
	                    qualify = true;
	                    return true;
	                }
	                // Continue to the next symbol table
	                return false;
	            });
	            return qualify;
	        }
	        function isPropertyOrMethodDeclarationSymbol(symbol) {
	            if (symbol.declarations && symbol.declarations.length) {
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    switch (declaration.kind) {
	                        case 151 /* PropertyDeclaration */:
	                        case 153 /* MethodDeclaration */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                            continue;
	                        default:
	                            return false;
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function isTypeSymbolAccessible(typeSymbol, enclosingDeclaration) {
	            var access = isSymbolAccessible(typeSymbol, enclosingDeclaration, 793064 /* Type */, /*shouldComputeAliasesToMakeVisible*/ false);
	            return access.accessibility === 0 /* Accessible */;
	        }
	        function isValueSymbolAccessible(typeSymbol, enclosingDeclaration) {
	            var access = isSymbolAccessible(typeSymbol, enclosingDeclaration, 107455 /* Value */, /*shouldComputeAliasesToMakeVisible*/ false);
	            return access.accessibility === 0 /* Accessible */;
	        }
	        /**
	         * Check if the given symbol in given enclosing declaration is accessible and mark all associated alias to be visible if requested
	         *
	         * @param symbol a Symbol to check if accessible
	         * @param enclosingDeclaration a Node containing reference to the symbol
	         * @param meaning a SymbolFlags to check if such meaning of the symbol is accessible
	         * @param shouldComputeAliasToMakeVisible a boolean value to indicate whether to return aliases to be mark visible in case the symbol is accessible
	         */
	        function isSymbolAccessible(symbol, enclosingDeclaration, meaning, shouldComputeAliasesToMakeVisible) {
	            if (symbol && enclosingDeclaration && !(symbol.flags & 262144 /* TypeParameter */)) {
	                var initialSymbol = symbol;
	                var meaningToLook = meaning;
	                while (symbol) {
	                    // Symbol is accessible if it by itself is accessible
	                    var accessibleSymbolChain = getAccessibleSymbolChain(symbol, enclosingDeclaration, meaningToLook, /*useOnlyExternalAliasing*/ false);
	                    if (accessibleSymbolChain) {
	                        var hasAccessibleDeclarations = hasVisibleDeclarations(accessibleSymbolChain[0], shouldComputeAliasesToMakeVisible);
	                        if (!hasAccessibleDeclarations) {
	                            return {
	                                accessibility: 1 /* NotAccessible */,
	                                errorSymbolName: symbolToString(initialSymbol, enclosingDeclaration, meaning),
	                                errorModuleName: symbol !== initialSymbol ? symbolToString(symbol, enclosingDeclaration, 1920 /* Namespace */) : undefined,
	                            };
	                        }
	                        return hasAccessibleDeclarations;
	                    }
	                    // If we haven't got the accessible symbol, it doesn't mean the symbol is actually inaccessible.
	                    // It could be a qualified symbol and hence verify the path
	                    // e.g.:
	                    // module m {
	                    //     export class c {
	                    //     }
	                    // }
	                    // const x: typeof m.c
	                    // In the above example when we start with checking if typeof m.c symbol is accessible,
	                    // we are going to see if c can be accessed in scope directly.
	                    // But it can't, hence the accessible is going to be undefined, but that doesn't mean m.c is inaccessible
	                    // It is accessible if the parent m is accessible because then m.c can be accessed through qualification
	                    meaningToLook = getQualifiedLeftMeaning(meaning);
	                    symbol = getParentOfSymbol(symbol);
	                }
	                // This could be a symbol that is not exported in the external module
	                // or it could be a symbol from different external module that is not aliased and hence cannot be named
	                var symbolExternalModule = ts.forEach(initialSymbol.declarations, getExternalModuleContainer);
	                if (symbolExternalModule) {
	                    var enclosingExternalModule = getExternalModuleContainer(enclosingDeclaration);
	                    if (symbolExternalModule !== enclosingExternalModule) {
	                        // name from different external module that is not visible
	                        return {
	                            accessibility: 2 /* CannotBeNamed */,
	                            errorSymbolName: symbolToString(initialSymbol, enclosingDeclaration, meaning),
	                            errorModuleName: symbolToString(symbolExternalModule)
	                        };
	                    }
	                }
	                // Just a local name that is not accessible
	                return {
	                    accessibility: 1 /* NotAccessible */,
	                    errorSymbolName: symbolToString(initialSymbol, enclosingDeclaration, meaning),
	                };
	            }
	            return { accessibility: 0 /* Accessible */ };
	            function getExternalModuleContainer(declaration) {
	                var node = ts.findAncestor(declaration, hasExternalModuleSymbol);
	                return node && getSymbolOfNode(node);
	            }
	        }
	        function hasExternalModuleSymbol(declaration) {
	            return ts.isAmbientModule(declaration) || (declaration.kind === 272 /* SourceFile */ && ts.isExternalOrCommonJsModule(declaration));
	        }
	        function hasVisibleDeclarations(symbol, shouldComputeAliasToMakeVisible) {
	            var aliasesToMakeVisible;
	            if (ts.forEach(symbol.declarations, function (declaration) { return !getIsDeclarationVisible(declaration); })) {
	                return undefined;
	            }
	            return { accessibility: 0 /* Accessible */, aliasesToMakeVisible: aliasesToMakeVisible };
	            function getIsDeclarationVisible(declaration) {
	                if (!isDeclarationVisible(declaration)) {
	                    // Mark the unexported alias as visible if its parent is visible
	                    // because these kind of aliases can be used to name types in declaration file
	                    var anyImportSyntax = getAnyImportSyntax(declaration);
	                    if (anyImportSyntax &&
	                        !ts.hasModifier(anyImportSyntax, 1 /* Export */) && // import clause without export
	                        isDeclarationVisible(anyImportSyntax.parent)) {
	                        // In function "buildTypeDisplay" where we decide whether to write type-alias or serialize types,
	                        // we want to just check if type- alias is accessible or not but we don't care about emitting those alias at that time
	                        // since we will do the emitting later in trackSymbol.
	                        if (shouldComputeAliasToMakeVisible) {
	                            getNodeLinks(declaration).isVisible = true;
	                            aliasesToMakeVisible = ts.appendIfUnique(aliasesToMakeVisible, anyImportSyntax);
	                        }
	                        return true;
	                    }
	                    // Declaration is not visible
	                    return false;
	                }
	                return true;
	            }
	        }
	        function isEntityNameVisible(entityName, enclosingDeclaration) {
	            // get symbol of the first identifier of the entityName
	            var meaning;
	            if (entityName.parent.kind === 164 /* TypeQuery */ ||
	                ts.isExpressionWithTypeArgumentsInClassExtendsClause(entityName.parent) ||
	                entityName.parent.kind === 146 /* ComputedPropertyName */) {
	                // Typeof value
	                meaning = 107455 /* Value */ | 1048576 /* ExportValue */;
	            }
	            else if (entityName.kind === 145 /* QualifiedName */ || entityName.kind === 183 /* PropertyAccessExpression */ ||
	                entityName.parent.kind === 241 /* ImportEqualsDeclaration */) {
	                // Left identifier from type reference or TypeAlias
	                // Entity name of the import declaration
	                meaning = 1920 /* Namespace */;
	            }
	            else {
	                // Type Reference or TypeAlias entity = Identifier
	                meaning = 793064 /* Type */;
	            }
	            var firstIdentifier = getFirstIdentifier(entityName);
	            var symbol = resolveName(enclosingDeclaration, firstIdentifier.escapedText, meaning, /*nodeNotFoundErrorMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false);
	            // Verify if the symbol is accessible
	            return (symbol && hasVisibleDeclarations(symbol, /*shouldComputeAliasToMakeVisible*/ true)) || {
	                accessibility: 1 /* NotAccessible */,
	                errorSymbolName: ts.getTextOfNode(firstIdentifier),
	                errorNode: firstIdentifier
	            };
	        }
	        function symbolToString(symbol, enclosingDeclaration, meaning, flags, writer) {
	            if (flags === void 0) { flags = 4 /* AllowAnyNodeKind */; }
	            var nodeFlags = 3112960 /* IgnoreErrors */;
	            if (flags & 2 /* UseOnlyExternalAliasing */) {
	                nodeFlags |= 128 /* UseOnlyExternalAliasing */;
	            }
	            if (flags & 1 /* WriteTypeParametersOrArguments */) {
	                nodeFlags |= 512 /* WriteTypeParametersInQualifiedName */;
	            }
	            if (flags & 8 /* UseAliasDefinedOutsideCurrentScope */) {
	                nodeFlags |= 16384 /* UseAliasDefinedOutsideCurrentScope */;
	            }
	            var builder = flags & 4 /* AllowAnyNodeKind */ ? nodeBuilder.symbolToExpression : nodeBuilder.symbolToEntityName;
	            return writer ? symbolToStringWorker(writer).getText() : ts.usingSingleLineStringWriter(symbolToStringWorker);
	            function symbolToStringWorker(writer) {
	                var entity = builder(symbol, meaning, enclosingDeclaration, nodeFlags);
	                var printer = ts.createPrinter({ removeComments: true });
	                var sourceFile = enclosingDeclaration && ts.getSourceFileOfNode(enclosingDeclaration);
	                printer.writeNode(4 /* Unspecified */, entity, /*sourceFile*/ sourceFile, writer);
	                return writer;
	            }
	        }
	        function signatureToString(signature, enclosingDeclaration, flags, kind, writer) {
	            return writer ? signatureToStringWorker(writer).getText() : ts.usingSingleLineStringWriter(signatureToStringWorker);
	            function signatureToStringWorker(writer) {
	                var sigOutput;
	                if (flags & 262144 /* WriteArrowStyleSignature */) {
	                    sigOutput = kind === 1 /* Construct */ ? 163 /* ConstructorType */ : 162 /* FunctionType */;
	                }
	                else {
	                    sigOutput = kind === 1 /* Construct */ ? 158 /* ConstructSignature */ : 157 /* CallSignature */;
	                }
	                var sig = nodeBuilder.signatureToSignatureDeclaration(signature, sigOutput, enclosingDeclaration, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */ | 512 /* WriteTypeParametersInQualifiedName */);
	                var printer = ts.createPrinter({ removeComments: true, omitTrailingSemicolon: true });
	                var sourceFile = enclosingDeclaration && ts.getSourceFileOfNode(enclosingDeclaration);
	                printer.writeNode(4 /* Unspecified */, sig, /*sourceFile*/ sourceFile, writer);
	                return writer;
	            }
	        }
	        function typeToString(type, enclosingDeclaration, flags, writer) {
	            if (writer === void 0) { writer = ts.createTextWriter(""); }
	            var typeNode = nodeBuilder.typeToTypeNode(type, enclosingDeclaration, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	            ts.Debug.assert(typeNode !== undefined, "should always get typenode");
	            var options = { removeComments: true };
	            var printer = ts.createPrinter(options);
	            var sourceFile = enclosingDeclaration && ts.getSourceFileOfNode(enclosingDeclaration);
	            printer.writeNode(4 /* Unspecified */, typeNode, /*sourceFile*/ sourceFile, writer);
	            var result = writer.getText();
	            var maxLength = compilerOptions.noErrorTruncation || flags & 1 /* NoTruncation */ ? undefined : 100;
	            if (maxLength && result && result.length >= maxLength) {
	                return result.substr(0, maxLength - "...".length) + "...";
	            }
	            return result;
	        }
	        function toNodeBuilderFlags(flags) {
	            return flags & 9469291 /* NodeBuilderFlagsMask */;
	        }
	        function createNodeBuilder() {
	            return {
	                typeToTypeNode: function (type, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = typeToTypeNodeHelper(type, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                indexInfoToIndexSignatureDeclaration: function (indexInfo, kind, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = indexInfoToIndexSignatureDeclarationHelper(indexInfo, kind, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                signatureToSignatureDeclaration: function (signature, kind, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = signatureToSignatureDeclarationHelper(signature, kind, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                symbolToEntityName: function (symbol, meaning, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = symbolToName(symbol, context, meaning, /*expectsIdentifier*/ false);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                symbolToExpression: function (symbol, meaning, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = symbolToExpression(symbol, context, meaning);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                symbolToTypeParameterDeclarations: function (symbol, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = typeParametersToTypeParameterDeclarations(symbol, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                symbolToParameterDeclaration: function (symbol, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = symbolToParameterDeclaration(symbol, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                typeParameterToDeclaration: function (parameter, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = typeParameterToDeclaration(parameter, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	            };
	            function createNodeBuilderContext(enclosingDeclaration, flags, tracker) {
	                return {
	                    enclosingDeclaration: enclosingDeclaration,
	                    flags: flags,
	                    tracker: tracker && tracker.trackSymbol ? tracker : { trackSymbol: ts.noop },
	                    encounteredError: false,
	                    symbolStack: undefined
	                };
	            }
	            function typeToTypeNodeHelper(type, context) {
	                var inTypeAlias = context.flags & 8388608 /* InTypeAlias */;
	                context.flags &= ~8388608 /* InTypeAlias */;
	                if (!type) {
	                    context.encounteredError = true;
	                    return undefined;
	                }
	                if (type.flags & 1 /* Any */) {
	                    return ts.createKeywordTypeNode(119 /* AnyKeyword */);
	                }
	                if (type.flags & 2 /* String */) {
	                    return ts.createKeywordTypeNode(137 /* StringKeyword */);
	                }
	                if (type.flags & 4 /* Number */) {
	                    return ts.createKeywordTypeNode(134 /* NumberKeyword */);
	                }
	                if (type.flags & 8 /* Boolean */) {
	                    return ts.createKeywordTypeNode(122 /* BooleanKeyword */);
	                }
	                if (type.flags & 256 /* EnumLiteral */ && !(type.flags & 131072 /* Union */)) {
	                    var parentSymbol = getParentOfSymbol(type.symbol);
	                    var parentName = symbolToName(parentSymbol, context, 793064 /* Type */, /*expectsIdentifier*/ false);
	                    var enumLiteralName = getDeclaredTypeOfSymbol(parentSymbol) === type ? parentName : ts.createQualifiedName(parentName, ts.symbolName(type.symbol));
	                    return ts.createTypeReferenceNode(enumLiteralName, /*typeArguments*/ undefined);
	                }
	                if (type.flags & 272 /* EnumLike */) {
	                    var name = symbolToName(type.symbol, context, 793064 /* Type */, /*expectsIdentifier*/ false);
	                    return ts.createTypeReferenceNode(name, /*typeArguments*/ undefined);
	                }
	                if (type.flags & (32 /* StringLiteral */)) {
	                    return ts.createLiteralTypeNode(ts.setEmitFlags(ts.createLiteral(type.value), 16777216 /* NoAsciiEscaping */));
	                }
	                if (type.flags & (64 /* NumberLiteral */)) {
	                    return ts.createLiteralTypeNode((ts.createLiteral(type.value)));
	                }
	                if (type.flags & 128 /* BooleanLiteral */) {
	                    return type.intrinsicName === "true" ? ts.createTrue() : ts.createFalse();
	                }
	                if (type.flags & 1024 /* UniqueESSymbol */) {
	                    if (!(context.flags & 1048576 /* AllowUniqueESSymbolType */)) {
	                        if (context.tracker.reportInaccessibleUniqueSymbolError) {
	                            context.tracker.reportInaccessibleUniqueSymbolError();
	                        }
	                    }
	                    return ts.createTypeOperatorNode(141 /* UniqueKeyword */, ts.createKeywordTypeNode(138 /* SymbolKeyword */));
	                }
	                if (type.flags & 2048 /* Void */) {
	                    return ts.createKeywordTypeNode(105 /* VoidKeyword */);
	                }
	                if (type.flags & 4096 /* Undefined */) {
	                    return ts.createKeywordTypeNode(140 /* UndefinedKeyword */);
	                }
	                if (type.flags & 8192 /* Null */) {
	                    return ts.createKeywordTypeNode(95 /* NullKeyword */);
	                }
	                if (type.flags & 16384 /* Never */) {
	                    return ts.createKeywordTypeNode(131 /* NeverKeyword */);
	                }
	                if (type.flags & 512 /* ESSymbol */) {
	                    return ts.createKeywordTypeNode(138 /* SymbolKeyword */);
	                }
	                if (type.flags & 134217728 /* NonPrimitive */) {
	                    return ts.createKeywordTypeNode(135 /* ObjectKeyword */);
	                }
	                if (type.flags & 32768 /* TypeParameter */ && type.isThisType) {
	                    if (context.flags & 4194304 /* InObjectTypeLiteral */) {
	                        if (!context.encounteredError && !(context.flags & 32768 /* AllowThisInObjectLiteral */)) {
	                            context.encounteredError = true;
	                        }
	                        if (context.tracker.reportInaccessibleThisError) {
	                            context.tracker.reportInaccessibleThisError();
	                        }
	                    }
	                    return ts.createThis();
	                }
	                var objectFlags = ts.getObjectFlags(type);
	                if (objectFlags & 4 /* Reference */) {
	                    ts.Debug.assert(!!(type.flags & 65536 /* Object */));
	                    return typeReferenceToTypeNode(type);
	                }
	                if (type.flags & 32768 /* TypeParameter */ || objectFlags & 3 /* ClassOrInterface */) {
	                    var name = type.symbol ? symbolToName(type.symbol, context, 793064 /* Type */, /*expectsIdentifier*/ false) : ts.createIdentifier("?");
	                    // Ignore constraint/default when creating a usage (as opposed to declaration) of a type parameter.
	                    return ts.createTypeReferenceNode(name, /*typeArguments*/ undefined);
	                }
	                if (!inTypeAlias && type.aliasSymbol && (context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */ || isTypeSymbolAccessible(type.aliasSymbol, context.enclosingDeclaration))) {
	                    var name = symbolToTypeReferenceName(type.aliasSymbol);
	                    var typeArgumentNodes = mapToTypeNodes(type.aliasTypeArguments, context);
	                    return ts.createTypeReferenceNode(name, typeArgumentNodes);
	                }
	                if (type.flags & (131072 /* Union */ | 262144 /* Intersection */)) {
	                    var types = type.flags & 131072 /* Union */ ? formatUnionTypes(type.types) : type.types;
	                    var typeNodes = mapToTypeNodes(types, context);
	                    if (typeNodes && typeNodes.length > 0) {
	                        var unionOrIntersectionTypeNode = ts.createUnionOrIntersectionTypeNode(type.flags & 131072 /* Union */ ? 168 /* UnionType */ : 169 /* IntersectionType */, typeNodes);
	                        return unionOrIntersectionTypeNode;
	                    }
	                    else {
	                        if (!context.encounteredError && !(context.flags & 262144 /* AllowEmptyUnionOrIntersection */)) {
	                            context.encounteredError = true;
	                        }
	                        return undefined;
	                    }
	                }
	                if (objectFlags & (16 /* Anonymous */ | 32 /* Mapped */)) {
	                    ts.Debug.assert(!!(type.flags & 65536 /* Object */));
	                    // The type is an object literal type.
	                    return createAnonymousTypeNode(type);
	                }
	                if (type.flags & 524288 /* Index */) {
	                    var indexedType = type.type;
	                    var indexTypeNode = typeToTypeNodeHelper(indexedType, context);
	                    return ts.createTypeOperatorNode(indexTypeNode);
	                }
	                if (type.flags & 1048576 /* IndexedAccess */) {
	                    var objectTypeNode = typeToTypeNodeHelper(type.objectType, context);
	                    var indexTypeNode = typeToTypeNodeHelper(type.indexType, context);
	                    return ts.createIndexedAccessTypeNode(objectTypeNode, indexTypeNode);
	                }
	                if (type.flags & 2097152 /* Conditional */) {
	                    var checkTypeNode = typeToTypeNodeHelper(type.checkType, context);
	                    var extendsTypeNode = typeToTypeNodeHelper(type.extendsType, context);
	                    var trueTypeNode = typeToTypeNodeHelper(type.trueType, context);
	                    var falseTypeNode = typeToTypeNodeHelper(type.falseType, context);
	                    return ts.createConditionalTypeNode(checkTypeNode, extendsTypeNode, trueTypeNode, falseTypeNode);
	                }
	                if (type.flags & 4194304 /* Substitution */) {
	                    return typeToTypeNodeHelper(type.typeParameter, context);
	                }
	                ts.Debug.fail("Should be unreachable.");
	                function createMappedTypeNodeFromType(type) {
	                    ts.Debug.assert(!!(type.flags & 65536 /* Object */));
	                    var readonlyToken = type.declaration.readonlyToken ? ts.createToken(type.declaration.readonlyToken.kind) : undefined;
	                    var questionToken = type.declaration.questionToken ? ts.createToken(type.declaration.questionToken.kind) : undefined;
	                    var typeParameterNode = typeParameterToDeclaration(getTypeParameterFromMappedType(type), context, getConstraintTypeFromMappedType(type));
	                    var templateTypeNode = typeToTypeNodeHelper(getTemplateTypeFromMappedType(type), context);
	                    var mappedTypeNode = ts.createMappedTypeNode(readonlyToken, typeParameterNode, questionToken, templateTypeNode);
	                    return ts.setEmitFlags(mappedTypeNode, 1 /* SingleLine */);
	                }
	                function createAnonymousTypeNode(type) {
	                    var symbol = type.symbol;
	                    if (symbol) {
	                        // Always use 'typeof T' for type of class, enum, and module objects
	                        if (symbol.flags & 32 /* Class */ && !getBaseTypeVariableOfClass(symbol) && !(symbol.valueDeclaration.kind === 203 /* ClassExpression */ && context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */) ||
	                            symbol.flags & (384 /* Enum */ | 512 /* ValueModule */) ||
	                            shouldWriteTypeOfFunctionSymbol()) {
	                            return createTypeQueryNodeFromSymbol(symbol, 107455 /* Value */);
	                        }
	                        else if (ts.contains(context.symbolStack, symbol)) {
	                            // If type is an anonymous type literal in a type alias declaration, use type alias name
	                            var typeAlias = getTypeAliasForTypeLiteral(type);
	                            if (typeAlias) {
	                                // The specified symbol flags need to be reinterpreted as type flags
	                                var entityName = symbolToName(typeAlias, context, 793064 /* Type */, /*expectsIdentifier*/ false);
	                                return ts.createTypeReferenceNode(entityName, /*typeArguments*/ undefined);
	                            }
	                            else {
	                                return ts.createKeywordTypeNode(119 /* AnyKeyword */);
	                            }
	                        }
	                        else {
	                            // Since instantiations of the same anonymous type have the same symbol, tracking symbols instead
	                            // of types allows us to catch circular references to instantiations of the same anonymous type
	                            if (!context.symbolStack) {
	                                context.symbolStack = [];
	                            }
	                            var isConstructorObject = ts.getObjectFlags(type) & 16 /* Anonymous */ && type.symbol && type.symbol.flags & 32 /* Class */;
	                            if (isConstructorObject) {
	                                return createTypeNodeFromObjectType(type);
	                            }
	                            else {
	                                context.symbolStack.push(symbol);
	                                var result = createTypeNodeFromObjectType(type);
	                                context.symbolStack.pop();
	                                return result;
	                            }
	                        }
	                    }
	                    else {
	                        // Anonymous types without a symbol are never circular.
	                        return createTypeNodeFromObjectType(type);
	                    }
	                    function shouldWriteTypeOfFunctionSymbol() {
	                        var isStaticMethodSymbol = !!(symbol.flags & 8192 /* Method */) && // typeof static method
	                            ts.some(symbol.declarations, function (declaration) { return ts.hasModifier(declaration, 32 /* Static */); });
	                        var isNonLocalFunctionSymbol = !!(symbol.flags & 16 /* Function */) &&
	                            (symbol.parent || // is exported function symbol
	                                ts.forEach(symbol.declarations, function (declaration) {
	                                    return declaration.parent.kind === 272 /* SourceFile */ || declaration.parent.kind === 238 /* ModuleBlock */;
	                                }));
	                        if (isStaticMethodSymbol || isNonLocalFunctionSymbol) {
	                            // typeof is allowed only for static/non local functions
	                            return (!!(context.flags & 4096 /* UseTypeOfFunction */) || ts.contains(context.symbolStack, symbol)) && // it is type of the symbol uses itself recursively
	                                (!(context.flags & 8 /* UseStructuralFallback */) || isValueSymbolAccessible(symbol, context.enclosingDeclaration)); // And the build is going to succeed without visibility error or there is no structural fallback allowed
	                        }
	                    }
	                }
	                function createTypeNodeFromObjectType(type) {
	                    if (isGenericMappedType(type)) {
	                        return createMappedTypeNodeFromType(type);
	                    }
	                    var resolved = resolveStructuredTypeMembers(type);
	                    if (!resolved.properties.length && !resolved.stringIndexInfo && !resolved.numberIndexInfo) {
	                        if (!resolved.callSignatures.length && !resolved.constructSignatures.length) {
	                            return ts.setEmitFlags(ts.createTypeLiteralNode(/*members*/ undefined), 1 /* SingleLine */);
	                        }
	                        if (resolved.callSignatures.length === 1 && !resolved.constructSignatures.length) {
	                            var signature = resolved.callSignatures[0];
	                            var signatureNode = signatureToSignatureDeclarationHelper(signature, 162 /* FunctionType */, context);
	                            return signatureNode;
	                        }
	                        if (resolved.constructSignatures.length === 1 && !resolved.callSignatures.length) {
	                            var signature = resolved.constructSignatures[0];
	                            var signatureNode = signatureToSignatureDeclarationHelper(signature, 163 /* ConstructorType */, context);
	                            return signatureNode;
	                        }
	                    }
	                    var savedFlags = context.flags;
	                    context.flags |= 4194304 /* InObjectTypeLiteral */;
	                    var members = createTypeNodesFromResolvedType(resolved);
	                    context.flags = savedFlags;
	                    var typeLiteralNode = ts.createTypeLiteralNode(members);
	                    return ts.setEmitFlags(typeLiteralNode, (context.flags & 1024 /* MultilineObjectLiterals */) ? 0 : 1 /* SingleLine */);
	                }
	                function createTypeQueryNodeFromSymbol(symbol, symbolFlags) {
	                    var entityName = symbolToName(symbol, context, symbolFlags, /*expectsIdentifier*/ false);
	                    return ts.createTypeQueryNode(entityName);
	                }
	                function symbolToTypeReferenceName(symbol) {
	                    // Unnamed function expressions and arrow functions have reserved names that we don't want to display
	                    var entityName = symbol.flags & 32 /* Class */ || !isReservedMemberName(symbol.escapedName) ? symbolToName(symbol, context, 793064 /* Type */, /*expectsIdentifier*/ false) : ts.createIdentifier("");
	                    return entityName;
	                }
	                function typeReferenceToTypeNode(type) {
	                    var typeArguments = type.typeArguments || ts.emptyArray;
	                    if (type.target === globalArrayType) {
	                        if (context.flags & 2 /* WriteArrayAsGenericType */) {
	                            var typeArgumentNode = typeToTypeNodeHelper(typeArguments[0], context);
	                            return ts.createTypeReferenceNode("Array", [typeArgumentNode]);
	                        }
	                        var elementType = typeToTypeNodeHelper(typeArguments[0], context);
	                        return ts.createArrayTypeNode(elementType);
	                    }
	                    else if (type.target.objectFlags & 8 /* Tuple */) {
	                        if (typeArguments.length > 0) {
	                            var tupleConstituentNodes = mapToTypeNodes(typeArguments.slice(0, getTypeReferenceArity(type)), context);
	                            if (tupleConstituentNodes && tupleConstituentNodes.length > 0) {
	                                return ts.createTupleTypeNode(tupleConstituentNodes);
	                            }
	                        }
	                        if (context.encounteredError || (context.flags & 524288 /* AllowEmptyTuple */)) {
	                            return ts.createTupleTypeNode([]);
	                        }
	                        context.encounteredError = true;
	                        return undefined;
	                    }
	                    else if (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */ &&
	                        type.symbol.valueDeclaration &&
	                        type.symbol.valueDeclaration.kind === 203 /* ClassExpression */) {
	                        return createAnonymousTypeNode(type);
	                    }
	                    else {
	                        var outerTypeParameters = type.target.outerTypeParameters;
	                        var i = 0;
	                        var qualifiedName = void 0;
	                        if (outerTypeParameters) {
	                            var length_1 = outerTypeParameters.length;
	                            while (i < length_1) {
	                                // Find group of type arguments for type parameters with the same declaring container.
	                                var start = i;
	                                var parent = getParentSymbolOfTypeParameter(outerTypeParameters[i]);
	                                do {
	                                    i++;
	                                } while (i < length_1 && getParentSymbolOfTypeParameter(outerTypeParameters[i]) === parent);
	                                // When type parameters are their own type arguments for the whole group (i.e. we have
	                                // the default outer type arguments), we don't show the group.
	                                if (!ts.rangeEquals(outerTypeParameters, typeArguments, start, i)) {
	                                    var typeArgumentSlice = mapToTypeNodes(typeArguments.slice(start, i), context);
	                                    var typeArgumentNodes_1 = typeArgumentSlice && ts.createNodeArray(typeArgumentSlice);
	                                    var namePart = symbolToTypeReferenceName(parent);
	                                    (namePart.kind === 71 /* Identifier */ ? namePart : namePart.right).typeArguments = typeArgumentNodes_1;
	                                    if (qualifiedName) {
	                                        ts.Debug.assert(!qualifiedName.right);
	                                        qualifiedName = addToQualifiedNameMissingRightIdentifier(qualifiedName, namePart);
	                                        qualifiedName = ts.createQualifiedName(qualifiedName, /*right*/ undefined);
	                                    }
	                                    else {
	                                        qualifiedName = ts.createQualifiedName(namePart, /*right*/ undefined);
	                                    }
	                                }
	                            }
	                        }
	                        var entityName = undefined;
	                        var nameIdentifier = symbolToTypeReferenceName(type.symbol);
	                        if (qualifiedName) {
	                            ts.Debug.assert(!qualifiedName.right);
	                            qualifiedName = addToQualifiedNameMissingRightIdentifier(qualifiedName, nameIdentifier);
	                            entityName = qualifiedName;
	                        }
	                        else {
	                            entityName = nameIdentifier;
	                        }
	                        var typeArgumentNodes = void 0;
	                        if (typeArguments.length > 0) {
	                            var typeParameterCount = (type.target.typeParameters || ts.emptyArray).length;
	                            typeArgumentNodes = mapToTypeNodes(typeArguments.slice(i, typeParameterCount), context);
	                        }
	                        if (typeArgumentNodes) {
	                            var lastIdentifier = entityName.kind === 71 /* Identifier */ ? entityName : entityName.right;
	                            lastIdentifier.typeArguments = undefined;
	                        }
	                        return ts.createTypeReferenceNode(entityName, typeArgumentNodes);
	                    }
	                }
	                function addToQualifiedNameMissingRightIdentifier(left, right) {
	                    ts.Debug.assert(left.right === undefined);
	                    if (right.kind === 71 /* Identifier */) {
	                        left.right = right;
	                        return left;
	                    }
	                    var rightPart = right;
	                    while (rightPart.left.kind !== 71 /* Identifier */) {
	                        rightPart = rightPart.left;
	                    }
	                    left.right = rightPart.left;
	                    rightPart.left = left;
	                    return right;
	                }
	                function createTypeNodesFromResolvedType(resolvedType) {
	                    var typeElements = [];
	                    for (var _i = 0, _a = resolvedType.callSignatures; _i < _a.length; _i++) {
	                        var signature = _a[_i];
	                        typeElements.push(signatureToSignatureDeclarationHelper(signature, 157 /* CallSignature */, context));
	                    }
	                    for (var _b = 0, _c = resolvedType.constructSignatures; _b < _c.length; _b++) {
	                        var signature = _c[_b];
	                        typeElements.push(signatureToSignatureDeclarationHelper(signature, 158 /* ConstructSignature */, context));
	                    }
	                    if (resolvedType.stringIndexInfo) {
	                        var indexInfo = resolvedType.objectFlags & 2048 /* ReverseMapped */ ?
	                            createIndexInfo(anyType, resolvedType.stringIndexInfo.isReadonly, resolvedType.stringIndexInfo.declaration) :
	                            resolvedType.stringIndexInfo;
	                        typeElements.push(indexInfoToIndexSignatureDeclarationHelper(indexInfo, 0 /* String */, context));
	                    }
	                    if (resolvedType.numberIndexInfo) {
	                        typeElements.push(indexInfoToIndexSignatureDeclarationHelper(resolvedType.numberIndexInfo, 1 /* Number */, context));
	                    }
	                    var properties = resolvedType.properties;
	                    if (!properties) {
	                        return typeElements;
	                    }
	                    for (var _d = 0, properties_1 = properties; _d < properties_1.length; _d++) {
	                        var propertySymbol = properties_1[_d];
	                        if (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */) {
	                            if (propertySymbol.flags & 4194304 /* Prototype */) {
	                                continue;
	                            }
	                            if (ts.getDeclarationModifierFlagsFromSymbol(propertySymbol) & (8 /* Private */ | 16 /* Protected */) && context.tracker.reportPrivateInBaseOfClassExpression) {
	                                context.tracker.reportPrivateInBaseOfClassExpression(ts.unescapeLeadingUnderscores(propertySymbol.escapedName));
	                            }
	                        }
	                        var propertyType = ts.getCheckFlags(propertySymbol) & 2048 /* ReverseMapped */ && context.flags & 33554432 /* InReverseMappedType */ ?
	                            anyType : getTypeOfSymbol(propertySymbol);
	                        var saveEnclosingDeclaration = context.enclosingDeclaration;
	                        context.enclosingDeclaration = undefined;
	                        if (ts.getCheckFlags(propertySymbol) & 1024 /* Late */) {
	                            var decl = ts.firstOrUndefined(propertySymbol.declarations);
	                            var name = hasLateBindableName(decl) && resolveEntityName(decl.name.expression, 107455 /* Value */);
	                            if (name && context.tracker.trackSymbol) {
	                                context.tracker.trackSymbol(name, saveEnclosingDeclaration, 107455 /* Value */);
	                            }
	                        }
	                        var propertyName = symbolToName(propertySymbol, context, 107455 /* Value */, /*expectsIdentifier*/ true);
	                        context.enclosingDeclaration = saveEnclosingDeclaration;
	                        var optionalToken = propertySymbol.flags & 16777216 /* Optional */ ? ts.createToken(55 /* QuestionToken */) : undefined;
	                        if (propertySymbol.flags & (16 /* Function */ | 8192 /* Method */) && !getPropertiesOfObjectType(propertyType).length) {
	                            var signatures = getSignaturesOfType(propertyType, 0 /* Call */);
	                            for (var _e = 0, signatures_1 = signatures; _e < signatures_1.length; _e++) {
	                                var signature = signatures_1[_e];
	                                var methodDeclaration = signatureToSignatureDeclarationHelper(signature, 152 /* MethodSignature */, context);
	                                methodDeclaration.name = propertyName;
	                                methodDeclaration.questionToken = optionalToken;
	                                typeElements.push(methodDeclaration);
	                            }
	                        }
	                        else {
	                            var savedFlags = context.flags;
	                            context.flags |= !!(ts.getCheckFlags(propertySymbol) & 2048 /* ReverseMapped */) ? 33554432 /* InReverseMappedType */ : 0;
	                            var propertyTypeNode = propertyType ? typeToTypeNodeHelper(propertyType, context) : ts.createKeywordTypeNode(119 /* AnyKeyword */);
	                            context.flags = savedFlags;
	                            var modifiers = isReadonlySymbol(propertySymbol) ? [ts.createToken(132 /* ReadonlyKeyword */)] : undefined;
	                            var propertySignature = ts.createPropertySignature(modifiers, propertyName, optionalToken, propertyTypeNode, 
	                            /*initializer*/ undefined);
	                            typeElements.push(propertySignature);
	                        }
	                    }
	                    return typeElements.length ? typeElements : undefined;
	                }
	            }
	            function mapToTypeNodes(types, context) {
	                if (ts.some(types)) {
	                    var result = [];
	                    for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
	                        var type = types_1[_i];
	                        var typeNode = typeToTypeNodeHelper(type, context);
	                        if (typeNode) {
	                            result.push(typeNode);
	                        }
	                    }
	                    return result;
	                }
	            }
	            function indexInfoToIndexSignatureDeclarationHelper(indexInfo, kind, context) {
	                var name = ts.getNameFromIndexInfo(indexInfo) || "x";
	                var indexerTypeNode = ts.createKeywordTypeNode(kind === 0 /* String */ ? 137 /* StringKeyword */ : 134 /* NumberKeyword */);
	                var indexingParameter = ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, name, 
	                /*questionToken*/ undefined, indexerTypeNode, 
	                /*initializer*/ undefined);
	                var typeNode = indexInfo.type ? typeToTypeNodeHelper(indexInfo.type, context) : typeToTypeNodeHelper(anyType, context);
	                if (!indexInfo.type && !(context.flags & 2097152 /* AllowEmptyIndexInfoType */)) {
	                    context.encounteredError = true;
	                }
	                return ts.createIndexSignature(
	                /*decorators*/ undefined, indexInfo.isReadonly ? [ts.createToken(132 /* ReadonlyKeyword */)] : undefined, [indexingParameter], typeNode);
	            }
	            function signatureToSignatureDeclarationHelper(signature, kind, context) {
	                var typeParameters;
	                var typeArguments;
	                if (context.flags & 32 /* WriteTypeArgumentsOfSignature */ && signature.target && signature.mapper && signature.target.typeParameters) {
	                    typeArguments = signature.target.typeParameters.map(function (parameter) { return typeToTypeNodeHelper(instantiateType(parameter, signature.mapper), context); });
	                }
	                else {
	                    typeParameters = signature.typeParameters && signature.typeParameters.map(function (parameter) { return typeParameterToDeclaration(parameter, context); });
	                }
	                var parameters = signature.parameters.map(function (parameter) { return symbolToParameterDeclaration(parameter, context); });
	                if (signature.thisParameter) {
	                    var thisParameter = symbolToParameterDeclaration(signature.thisParameter, context);
	                    parameters.unshift(thisParameter);
	                }
	                var returnTypeNode;
	                var typePredicate = getTypePredicateOfSignature(signature);
	                if (typePredicate) {
	                    var parameterName = typePredicate.kind === 1 /* Identifier */ ?
	                        ts.setEmitFlags(ts.createIdentifier(typePredicate.parameterName), 16777216 /* NoAsciiEscaping */) :
	                        ts.createThisTypeNode();
	                    var typeNode = typeToTypeNodeHelper(typePredicate.type, context);
	                    returnTypeNode = ts.createTypePredicateNode(parameterName, typeNode);
	                }
	                else {
	                    var returnType = getReturnTypeOfSignature(signature);
	                    returnTypeNode = returnType && typeToTypeNodeHelper(returnType, context);
	                }
	                if (context.flags & 256 /* SuppressAnyReturnType */) {
	                    if (returnTypeNode && returnTypeNode.kind === 119 /* AnyKeyword */) {
	                        returnTypeNode = undefined;
	                    }
	                }
	                else if (!returnTypeNode) {
	                    returnTypeNode = ts.createKeywordTypeNode(119 /* AnyKeyword */);
	                }
	                return ts.createSignatureDeclaration(kind, typeParameters, parameters, returnTypeNode, typeArguments);
	            }
	            function typeParameterToDeclaration(type, context, constraint) {
	                if (constraint === void 0) { constraint = getConstraintFromTypeParameter(type); }
	                var savedContextFlags = context.flags;
	                context.flags &= ~512 /* WriteTypeParametersInQualifiedName */; // Avoids potential infinite loop when building for a claimspace with a generic
	                var name = symbolToName(type.symbol, context, 793064 /* Type */, /*expectsIdentifier*/ true);
	                var constraintNode = constraint && typeToTypeNodeHelper(constraint, context);
	                var defaultParameter = getDefaultFromTypeParameter(type);
	                var defaultParameterNode = defaultParameter && typeToTypeNodeHelper(defaultParameter, context);
	                context.flags = savedContextFlags;
	                return ts.createTypeParameterDeclaration(name, constraintNode, defaultParameterNode);
	            }
	            function symbolToParameterDeclaration(parameterSymbol, context) {
	                var parameterDeclaration = ts.getDeclarationOfKind(parameterSymbol, 148 /* Parameter */);
	                ts.Debug.assert(!!parameterDeclaration || isTransientSymbol(parameterSymbol) && !!parameterSymbol.isRestParameter);
	                var parameterType = getTypeOfSymbol(parameterSymbol);
	                if (parameterDeclaration && isRequiredInitializedParameter(parameterDeclaration)) {
	                    parameterType = getOptionalType(parameterType);
	                }
	                var parameterTypeNode = typeToTypeNodeHelper(parameterType, context);
	                var modifiers = !(context.flags & 8192 /* OmitParameterModifiers */) && parameterDeclaration && parameterDeclaration.modifiers && parameterDeclaration.modifiers.map(ts.getSynthesizedClone);
	                var dotDotDotToken = !parameterDeclaration || ts.isRestParameter(parameterDeclaration) ? ts.createToken(24 /* DotDotDotToken */) : undefined;
	                var name = parameterDeclaration
	                    ? parameterDeclaration.name ?
	                        parameterDeclaration.name.kind === 71 /* Identifier */ ?
	                            ts.setEmitFlags(ts.getSynthesizedClone(parameterDeclaration.name), 16777216 /* NoAsciiEscaping */) :
	                            cloneBindingName(parameterDeclaration.name) :
	                        ts.symbolName(parameterSymbol)
	                    : ts.symbolName(parameterSymbol);
	                var questionToken = parameterDeclaration && isOptionalParameter(parameterDeclaration) ? ts.createToken(55 /* QuestionToken */) : undefined;
	                var parameterNode = ts.createParameter(
	                /*decorators*/ undefined, modifiers, dotDotDotToken, name, questionToken, parameterTypeNode, 
	                /*initializer*/ undefined);
	                return parameterNode;
	                function cloneBindingName(node) {
	                    return elideInitializerAndSetEmitFlags(node);
	                    function elideInitializerAndSetEmitFlags(node) {
	                        var visited = ts.visitEachChild(node, elideInitializerAndSetEmitFlags, ts.nullTransformationContext, /*nodesVisitor*/ undefined, elideInitializerAndSetEmitFlags);
	                        var clone = ts.nodeIsSynthesized(visited) ? visited : ts.getSynthesizedClone(visited);
	                        if (clone.kind === 180 /* BindingElement */) {
	                            clone.initializer = undefined;
	                        }
	                        return ts.setEmitFlags(clone, 1 /* SingleLine */ | 16777216 /* NoAsciiEscaping */);
	                    }
	                }
	            }
	            function lookupSymbolChain(symbol, context, meaning) {
	                context.tracker.trackSymbol(symbol, context.enclosingDeclaration, meaning);
	                // Try to get qualified name if the symbol is not a type parameter and there is an enclosing declaration.
	                var chain;
	                var isTypeParameter = symbol.flags & 262144 /* TypeParameter */;
	                if (!isTypeParameter && (context.enclosingDeclaration || context.flags & 64 /* UseFullyQualifiedType */)) {
	                    chain = getSymbolChain(symbol, meaning, /*endOfChain*/ true);
	                    ts.Debug.assert(chain && chain.length > 0);
	                }
	                else {
	                    chain = [symbol];
	                }
	                return chain;
	                /** @param endOfChain Set to false for recursive calls; non-recursive calls should always output something. */
	                function getSymbolChain(symbol, meaning, endOfChain) {
	                    var accessibleSymbolChain = getAccessibleSymbolChain(symbol, context.enclosingDeclaration, meaning, !!(context.flags & 128 /* UseOnlyExternalAliasing */));
	                    var parentSymbol;
	                    if (!accessibleSymbolChain ||
	                        needsQualification(accessibleSymbolChain[0], context.enclosingDeclaration, accessibleSymbolChain.length === 1 ? meaning : getQualifiedLeftMeaning(meaning))) {
	                        // Go up and add our parent.
	                        var parent = getParentOfSymbol(accessibleSymbolChain ? accessibleSymbolChain[0] : symbol);
	                        if (parent) {
	                            var parentChain = getSymbolChain(parent, getQualifiedLeftMeaning(meaning), /*endOfChain*/ false);
	                            if (parentChain) {
	                                parentSymbol = parent;
	                                accessibleSymbolChain = parentChain.concat(accessibleSymbolChain || [symbol]);
	                            }
	                        }
	                    }
	                    if (accessibleSymbolChain) {
	                        return accessibleSymbolChain;
	                    }
	                    if (
	                    // If this is the last part of outputting the symbol, always output. The cases apply only to parent symbols.
	                    endOfChain ||
	                        // If a parent symbol is an external module, don't write it. (We prefer just `x` vs `"foo/bar".x`.)
	                        !(!parentSymbol && ts.forEach(symbol.declarations, hasExternalModuleSymbol)) &&
	                            // If a parent symbol is an anonymous type, don't write it.
	                            !(symbol.flags & (2048 /* TypeLiteral */ | 4096 /* ObjectLiteral */))) {
	                        return [symbol];
	                    }
	                }
	            }
	            function typeParametersToTypeParameterDeclarations(symbol, context) {
	                var typeParameterNodes;
	                var targetSymbol = getTargetSymbol(symbol);
	                if (targetSymbol.flags & (32 /* Class */ | 64 /* Interface */ | 524288 /* TypeAlias */)) {
	                    typeParameterNodes = ts.createNodeArray(ts.map(getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol), function (tp) { return typeParameterToDeclaration(tp, context); }));
	                }
	                return typeParameterNodes;
	            }
	            function lookupTypeParameterNodes(chain, index, context) {
	                ts.Debug.assert(chain && 0 <= index && index < chain.length);
	                var symbol = chain[index];
	                var typeParameterNodes;
	                if (context.flags & 512 /* WriteTypeParametersInQualifiedName */ && index < (chain.length - 1)) {
	                    var parentSymbol = symbol;
	                    var nextSymbol = chain[index + 1];
	                    if (ts.getCheckFlags(nextSymbol) & 1 /* Instantiated */) {
	                        var params = getTypeParametersOfClassOrInterface(parentSymbol.flags & 2097152 /* Alias */ ? resolveAlias(parentSymbol) : parentSymbol);
	                        typeParameterNodes = mapToTypeNodes(ts.map(params, nextSymbol.mapper), context);
	                    }
	                    else {
	                        typeParameterNodes = typeParametersToTypeParameterDeclarations(symbol, context);
	                    }
	                }
	                return typeParameterNodes;
	            }
	            function symbolToName(symbol, context, meaning, expectsIdentifier) {
	                var chain = lookupSymbolChain(symbol, context, meaning);
	                if (expectsIdentifier && chain.length !== 1
	                    && !context.encounteredError
	                    && !(context.flags & 65536 /* AllowQualifedNameInPlaceOfIdentifier */)) {
	                    context.encounteredError = true;
	                }
	                return createEntityNameFromSymbolChain(chain, chain.length - 1);
	                function createEntityNameFromSymbolChain(chain, index) {
	                    var typeParameterNodes = lookupTypeParameterNodes(chain, index, context);
	                    var symbol = chain[index];
	                    if (index === 0) {
	                        context.flags |= 16777216 /* InInitialEntityName */;
	                    }
	                    var symbolName = getNameOfSymbolAsWritten(symbol, context);
	                    if (index === 0) {
	                        context.flags ^= 16777216 /* InInitialEntityName */;
	                    }
	                    var identifier = ts.setEmitFlags(ts.createIdentifier(symbolName, typeParameterNodes), 16777216 /* NoAsciiEscaping */);
	                    identifier.symbol = symbol;
	                    return index > 0 ? ts.createQualifiedName(createEntityNameFromSymbolChain(chain, index - 1), identifier) : identifier;
	                }
	            }
	            function symbolToExpression(symbol, context, meaning) {
	                var chain = lookupSymbolChain(symbol, context, meaning);
	                return createExpressionFromSymbolChain(chain, chain.length - 1);
	                function createExpressionFromSymbolChain(chain, index) {
	                    var typeParameterNodes = lookupTypeParameterNodes(chain, index, context);
	                    var symbol = chain[index];
	                    if (index === 0) {
	                        context.flags |= 16777216 /* InInitialEntityName */;
	                    }
	                    var symbolName = getNameOfSymbolAsWritten(symbol, context);
	                    if (index === 0) {
	                        context.flags ^= 16777216 /* InInitialEntityName */;
	                    }
	                    var firstChar = symbolName.charCodeAt(0);
	                    var canUsePropertyAccess = ts.isIdentifierStart(firstChar, languageVersion);
	                    if (index === 0 || canUsePropertyAccess) {
	                        var identifier = ts.setEmitFlags(ts.createIdentifier(symbolName, typeParameterNodes), 16777216 /* NoAsciiEscaping */);
	                        identifier.symbol = symbol;
	                        return index > 0 ? ts.createPropertyAccess(createExpressionFromSymbolChain(chain, index - 1), identifier) : identifier;
	                    }
	                    else {
	                        if (firstChar === 91 /* openBracket */) {
	                            symbolName = symbolName.substring(1, symbolName.length - 1);
	                            firstChar = symbolName.charCodeAt(0);
	                        }
	                        var expression = void 0;
	                        if (ts.isSingleOrDoubleQuote(firstChar)) {
	                            expression = ts.createLiteral(symbolName.substring(1, symbolName.length - 1).replace(/\\./g, function (s) { return s.substring(1); }));
	                            expression.singleQuote = firstChar === 39 /* singleQuote */;
	                        }
	                        else if (("" + +symbolName) === symbolName) {
	                            expression = ts.createLiteral(+symbolName);
	                        }
	                        if (!expression) {
	                            expression = ts.setEmitFlags(ts.createIdentifier(symbolName, typeParameterNodes), 16777216 /* NoAsciiEscaping */);
	                            expression.symbol = symbol;
	                        }
	                        return ts.createElementAccess(createExpressionFromSymbolChain(chain, index - 1), expression);
	                    }
	                }
	            }
	        }
	        function typePredicateToString(typePredicate, enclosingDeclaration, flags, writer) {
	            return writer ? typePredicateToStringWorker(writer).getText() : ts.usingSingleLineStringWriter(typePredicateToStringWorker);
	            function typePredicateToStringWorker(writer) {
	                var predicate = ts.createTypePredicateNode(typePredicate.kind === 1 /* Identifier */ ? ts.createIdentifier(typePredicate.parameterName) : ts.createThisTypeNode(), nodeBuilder.typeToTypeNode(typePredicate.type, enclosingDeclaration, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */ | 512 /* WriteTypeParametersInQualifiedName */));
	                var printer = ts.createPrinter({ removeComments: true });
	                var sourceFile = enclosingDeclaration && ts.getSourceFileOfNode(enclosingDeclaration);
	                printer.writeNode(4 /* Unspecified */, predicate, /*sourceFile*/ sourceFile, writer);
	                return writer;
	            }
	        }
	        function formatUnionTypes(types) {
	            var result = [];
	            var flags = 0;
	            for (var i = 0; i < types.length; i++) {
	                var t = types[i];
	                flags |= t.flags;
	                if (!(t.flags & 12288 /* Nullable */)) {
	                    if (t.flags & (128 /* BooleanLiteral */ | 256 /* EnumLiteral */)) {
	                        var baseType = t.flags & 128 /* BooleanLiteral */ ? booleanType : getBaseTypeOfEnumLiteralType(t);
	                        if (baseType.flags & 131072 /* Union */) {
	                            var count = baseType.types.length;
	                            if (i + count <= types.length && types[i + count - 1] === baseType.types[count - 1]) {
	                                result.push(baseType);
	                                i += count - 1;
	                                continue;
	                            }
	                        }
	                    }
	                    result.push(t);
	                }
	            }
	            if (flags & 8192 /* Null */)
	                result.push(nullType);
	            if (flags & 4096 /* Undefined */)
	                result.push(undefinedType);
	            return result || types;
	        }
	        function visibilityToString(flags) {
	            if (flags === 8 /* Private */) {
	                return "private";
	            }
	            if (flags === 16 /* Protected */) {
	                return "protected";
	            }
	            return "public";
	        }
	        function getTypeAliasForTypeLiteral(type) {
	            if (type.symbol && type.symbol.flags & 2048 /* TypeLiteral */) {
	                var node = ts.findAncestor(type.symbol.declarations[0].parent, function (n) { return n.kind !== 172 /* ParenthesizedType */; });
	                if (node.kind === 235 /* TypeAliasDeclaration */) {
	                    return getSymbolOfNode(node);
	                }
	            }
	            return undefined;
	        }
	        function isTopLevelInExternalModuleAugmentation(node) {
	            return node && node.parent &&
	                node.parent.kind === 238 /* ModuleBlock */ &&
	                ts.isExternalModuleAugmentation(node.parent.parent);
	        }
	        function literalTypeToString(type) {
	            return type.flags & 32 /* StringLiteral */ ? '"' + ts.escapeString(type.value) + '"' : "" + type.value;
	        }
	        function isDefaultBindingContext(location) {
	            return location.kind === 272 /* SourceFile */ || ts.isAmbientModule(location);
	        }
	        /**
	         * Gets a human-readable name for a symbol.
	         * Should *not* be used for the right-hand side of a `.` -- use `symbolName(symbol)` for that instead.
	         *
	         * Unlike `symbolName(symbol)`, this will include quotes if the name is from a string literal.
	         * It will also use a representation of a number as written instead of a decimal form, e.g. `0o11` instead of `9`.
	         */
	        function getNameOfSymbolAsWritten(symbol, context) {
	            if (context && symbol.escapedName === "default" /* Default */ && !(context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */) &&
	                // If it's not the first part of an entity name, it must print as `default`
	                (!(context.flags & 16777216 /* InInitialEntityName */) ||
	                    // if the symbol is synthesized, it will only be referenced externally it must print as `default`
	                    !symbol.declarations ||
	                    // if not in the same binding context (source file, module declaration), it must print as `default`
	                    (context.enclosingDeclaration && ts.findAncestor(symbol.declarations[0], isDefaultBindingContext) !== ts.findAncestor(context.enclosingDeclaration, isDefaultBindingContext)))) {
	                return "default";
	            }
	            if (symbol.declarations && symbol.declarations.length) {
	                var declaration = symbol.declarations[0];
	                var name = ts.getNameOfDeclaration(declaration);
	                if (name) {
	                    return ts.declarationNameToString(name);
	                }
	                if (declaration.parent && declaration.parent.kind === 230 /* VariableDeclaration */) {
	                    return ts.declarationNameToString(declaration.parent.name);
	                }
	                if (context && !context.encounteredError && !(context.flags & 131072 /* AllowAnonymousIdentifier */)) {
	                    context.encounteredError = true;
	                }
	                switch (declaration.kind) {
	                    case 203 /* ClassExpression */:
	                        return "(Anonymous class)";
	                    case 190 /* FunctionExpression */:
	                    case 191 /* ArrowFunction */:
	                        return "(Anonymous function)";
	                }
	            }
	            if (symbol.syntheticLiteralTypeOrigin) {
	                var stringValue = symbol.syntheticLiteralTypeOrigin.value;
	                if (!ts.isIdentifierText(stringValue, compilerOptions.target)) {
	                    return "\"" + ts.escapeString(stringValue, 34 /* doubleQuote */) + "\"";
	                }
	            }
	            return ts.symbolName(symbol);
	        }
	        function isDeclarationVisible(node) {
	            if (node) {
	                var links = getNodeLinks(node);
	                if (links.isVisible === undefined) {
	                    links.isVisible = !!determineIfDeclarationIsVisible();
	                }
	                return links.isVisible;
	            }
	            return false;
	            function determineIfDeclarationIsVisible() {
	                switch (node.kind) {
	                    case 180 /* BindingElement */:
	                        return isDeclarationVisible(node.parent.parent);
	                    case 230 /* VariableDeclaration */:
	                        if (ts.isBindingPattern(node.name) &&
	                            !node.name.elements.length) {
	                            // If the binding pattern is empty, this variable declaration is not visible
	                            return false;
	                        }
	                    // falls through
	                    case 237 /* ModuleDeclaration */:
	                    case 233 /* ClassDeclaration */:
	                    case 234 /* InterfaceDeclaration */:
	                    case 235 /* TypeAliasDeclaration */:
	                    case 232 /* FunctionDeclaration */:
	                    case 236 /* EnumDeclaration */:
	                    case 241 /* ImportEqualsDeclaration */:
	                        // external module augmentation is always visible
	                        if (ts.isExternalModuleAugmentation(node)) {
	                            return true;
	                        }
	                        var parent = getDeclarationContainer(node);
	                        // If the node is not exported or it is not ambient module element (except import declaration)
	                        if (!(ts.getCombinedModifierFlags(node) & 1 /* Export */) &&
	                            !(node.kind !== 241 /* ImportEqualsDeclaration */ && parent.kind !== 272 /* SourceFile */ && parent.flags & 2097152 /* Ambient */)) {
	                            return isGlobalSourceFile(parent);
	                        }
	                        // Exported members/ambient module elements (exception import declaration) are visible if parent is visible
	                        return isDeclarationVisible(parent);
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        if (ts.hasModifier(node, 8 /* Private */ | 16 /* Protected */)) {
	                            // Private/protected properties/methods are not visible
	                            return false;
	                        }
	                    // Public properties/methods are visible if its parents are visible, so:
	                    // falls through
	                    case 154 /* Constructor */:
	                    case 158 /* ConstructSignature */:
	                    case 157 /* CallSignature */:
	                    case 159 /* IndexSignature */:
	                    case 148 /* Parameter */:
	                    case 238 /* ModuleBlock */:
	                    case 162 /* FunctionType */:
	                    case 163 /* ConstructorType */:
	                    case 165 /* TypeLiteral */:
	                    case 161 /* TypeReference */:
	                    case 166 /* ArrayType */:
	                    case 167 /* TupleType */:
	                    case 168 /* UnionType */:
	                    case 169 /* IntersectionType */:
	                    case 172 /* ParenthesizedType */:
	                        return isDeclarationVisible(node.parent);
	                    // Default binding, import specifier and namespace import is visible
	                    // only on demand so by default it is not visible
	                    case 243 /* ImportClause */:
	                    case 244 /* NamespaceImport */:
	                    case 246 /* ImportSpecifier */:
	                        return false;
	                    // Type parameters are always visible
	                    case 147 /* TypeParameter */:
	                    // Source file and namespace export are always visible
	                    case 272 /* SourceFile */:
	                    case 240 /* NamespaceExportDeclaration */:
	                        return true;
	                    // Export assignments do not create name bindings outside the module
	                    case 247 /* ExportAssignment */:
	                        return false;
	                    default:
	                        return false;
	                }
	            }
	        }
	        function collectLinkedAliases(node, setVisibility) {
	            var exportSymbol;
	            if (node.parent && node.parent.kind === 247 /* ExportAssignment */) {
	                exportSymbol = resolveName(node, node.escapedText, 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */, /*nameNotFoundMessage*/ undefined, node, /*isUse*/ false);
	            }
	            else if (node.parent.kind === 250 /* ExportSpecifier */) {
	                exportSymbol = getTargetOfExportSpecifier(node.parent, 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */);
	            }
	            var result;
	            if (exportSymbol) {
	                buildVisibleNodeList(exportSymbol.declarations);
	            }
	            return result;
	            function buildVisibleNodeList(declarations) {
	                ts.forEach(declarations, function (declaration) {
	                    var resultNode = getAnyImportSyntax(declaration) || declaration;
	                    if (setVisibility) {
	                        getNodeLinks(declaration).isVisible = true;
	                    }
	                    else {
	                        result = result || [];
	                        ts.pushIfUnique(result, resultNode);
	                    }
	                    if (ts.isInternalModuleImportEqualsDeclaration(declaration)) {
	                        // Add the referenced top container visible
	                        var internalModuleReference = declaration.moduleReference;
	                        var firstIdentifier = getFirstIdentifier(internalModuleReference);
	                        var importSymbol = resolveName(declaration, firstIdentifier.escapedText, 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */, undefined, undefined, /*isUse*/ false);
	                        if (importSymbol) {
	                            buildVisibleNodeList(importSymbol.declarations);
	                        }
	                    }
	                });
	            }
	        }
	        /**
	         * Push an entry on the type resolution stack. If an entry with the given target and the given property name
	         * is already on the stack, and no entries in between already have a type, then a circularity has occurred.
	         * In this case, the result values of the existing entry and all entries pushed after it are changed to false,
	         * and the value false is returned. Otherwise, the new entry is just pushed onto the stack, and true is returned.
	         * In order to see if the same query has already been done before, the target object and the propertyName both
	         * must match the one passed in.
	         *
	         * @param target The symbol, type, or signature whose type is being queried
	         * @param propertyName The property name that should be used to query the target for its type
	         */
	        function pushTypeResolution(target, propertyName) {
	            var resolutionCycleStartIndex = findResolutionCycleStartIndex(target, propertyName);
	            if (resolutionCycleStartIndex >= 0) {
	                // A cycle was found
	                var length_2 = resolutionTargets.length;
	                for (var i = resolutionCycleStartIndex; i < length_2; i++) {
	                    resolutionResults[i] = false;
	                }
	                return false;
	            }
	            resolutionTargets.push(target);
	            resolutionResults.push(/*items*/ true);
	            resolutionPropertyNames.push(propertyName);
	            return true;
	        }
	        function findResolutionCycleStartIndex(target, propertyName) {
	            for (var i = resolutionTargets.length - 1; i >= 0; i--) {
	                if (hasType(resolutionTargets[i], resolutionPropertyNames[i])) {
	                    return -1;
	                }
	                if (resolutionTargets[i] === target && resolutionPropertyNames[i] === propertyName) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	        function hasType(target, propertyName) {
	            if (propertyName === 0 /* Type */) {
	                return getSymbolLinks(target).type;
	            }
	            if (propertyName === 2 /* DeclaredType */) {
	                return getSymbolLinks(target).declaredType;
	            }
	            if (propertyName === 1 /* ResolvedBaseConstructorType */) {
	                return target.resolvedBaseConstructorType;
	            }
	            if (propertyName === 3 /* ResolvedReturnType */) {
	                return target.resolvedReturnType;
	            }
	            if (propertyName === 4 /* ResolvedBaseConstraint */) {
	                var bc = target.resolvedBaseConstraint;
	                return bc && bc !== circularConstraintType;
	            }
	            ts.Debug.fail("Unhandled TypeSystemPropertyName " + propertyName);
	        }
	        // Pop an entry from the type resolution stack and return its associated result value. The result value will
	        // be true if no circularities were detected, or false if a circularity was found.
	        function popTypeResolution() {
	            resolutionTargets.pop();
	            resolutionPropertyNames.pop();
	            return resolutionResults.pop();
	        }
	        function getDeclarationContainer(node) {
	            node = ts.findAncestor(ts.getRootDeclaration(node), function (node) {
	                switch (node.kind) {
	                    case 230 /* VariableDeclaration */:
	                    case 231 /* VariableDeclarationList */:
	                    case 246 /* ImportSpecifier */:
	                    case 245 /* NamedImports */:
	                    case 244 /* NamespaceImport */:
	                    case 243 /* ImportClause */:
	                        return false;
	                    default:
	                        return true;
	                }
	            });
	            return node && node.parent;
	        }
	        function getTypeOfPrototypeProperty(prototype) {
	            // TypeScript 1.0 spec (April 2014): 8.4
	            // Every class automatically contains a static property member named 'prototype',
	            // the type of which is an instantiation of the class type with type Any supplied as a type argument for each type parameter.
	            // It is an error to explicitly declare a static property member with the name 'prototype'.
	            var classType = getDeclaredTypeOfSymbol(getParentOfSymbol(prototype));
	            return classType.typeParameters ? createTypeReference(classType, ts.map(classType.typeParameters, function (_) { return anyType; })) : classType;
	        }
	        // Return the type of the given property in the given type, or undefined if no such property exists
	        function getTypeOfPropertyOfType(type, name) {
	            var prop = getPropertyOfType(type, name);
	            return prop ? getTypeOfSymbol(prop) : undefined;
	        }
	        function isTypeAny(type) {
	            return type && (type.flags & 1 /* Any */) !== 0;
	        }
	        // Return the type of a binding element parent. We check SymbolLinks first to see if a type has been
	        // assigned by contextual typing.
	        function getTypeForBindingElementParent(node) {
	            var symbol = getSymbolOfNode(node);
	            return symbol && getSymbolLinks(symbol).type || getTypeForVariableLikeDeclaration(node, /*includeOptionality*/ false);
	        }
	        function isComputedNonLiteralName(name) {
	            return name.kind === 146 /* ComputedPropertyName */ && !ts.isStringOrNumericLiteral(name.expression);
	        }
	        function getRestType(source, properties, symbol) {
	            source = filterType(source, function (t) { return !(t.flags & 12288 /* Nullable */); });
	            if (source.flags & 16384 /* Never */) {
	                return emptyObjectType;
	            }
	            if (source.flags & 131072 /* Union */) {
	                return mapType(source, function (t) { return getRestType(t, properties, symbol); });
	            }
	            var members = ts.createSymbolTable();
	            var names = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, properties_2 = properties; _i < properties_2.length; _i++) {
	                var name = properties_2[_i];
	                names.set(ts.getTextOfPropertyName(name), true);
	            }
	            for (var _a = 0, _b = getPropertiesOfType(source); _a < _b.length; _a++) {
	                var prop = _b[_a];
	                var inNamesToRemove = names.has(prop.escapedName);
	                var isPrivate = ts.getDeclarationModifierFlagsFromSymbol(prop) & (8 /* Private */ | 16 /* Protected */);
	                var isSetOnlyAccessor = prop.flags & 65536 /* SetAccessor */ && !(prop.flags & 32768 /* GetAccessor */);
	                if (!inNamesToRemove && !isPrivate && !isClassMethod(prop) && !isSetOnlyAccessor) {
	                    members.set(prop.escapedName, prop);
	                }
	            }
	            var stringIndexInfo = getIndexInfoOfType(source, 0 /* String */);
	            var numberIndexInfo = getIndexInfoOfType(source, 1 /* Number */);
	            return createAnonymousType(symbol, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, numberIndexInfo);
	        }
	        /** Return the inferred type for a binding element */
	        function getTypeForBindingElement(declaration) {
	            var pattern = declaration.parent;
	            var parentType = getTypeForBindingElementParent(pattern.parent);
	            // If parent has the unknown (error) type, then so does this binding element
	            if (parentType === unknownType) {
	                return unknownType;
	            }
	            // If no type was specified or inferred for parent,
	            // infer from the initializer of the binding element if one is present.
	            // Otherwise, go with the undefined type of the parent.
	            if (!parentType) {
	                return declaration.initializer ? checkDeclarationInitializer(declaration) : parentType;
	            }
	            if (isTypeAny(parentType)) {
	                return parentType;
	            }
	            var type;
	            if (pattern.kind === 178 /* ObjectBindingPattern */) {
	                if (declaration.dotDotDotToken) {
	                    if (!isValidSpreadType(parentType)) {
	                        error(declaration, ts.Diagnostics.Rest_types_may_only_be_created_from_object_types);
	                        return unknownType;
	                    }
	                    var literalMembers = [];
	                    for (var _i = 0, _a = pattern.elements; _i < _a.length; _i++) {
	                        var element = _a[_i];
	                        if (!element.dotDotDotToken) {
	                            literalMembers.push(element.propertyName || element.name);
	                        }
	                    }
	                    type = getRestType(parentType, literalMembers, declaration.symbol);
	                }
	                else {
	                    // Use explicitly specified property name ({ p: xxx } form), or otherwise the implied name ({ p } form)
	                    var name = declaration.propertyName || declaration.name;
	                    if (isComputedNonLiteralName(name)) {
	                        // computed properties with non-literal names are treated as 'any'
	                        return anyType;
	                    }
	                    // Use type of the specified property, or otherwise, for a numeric name, the type of the numeric index signature,
	                    // or otherwise the type of the string index signature.
	                    var text = ts.getTextOfPropertyName(name);
	                    // Relax null check on ambient destructuring parameters, since the parameters have no implementation and are just documentation
	                    if (strictNullChecks && declaration.flags & 2097152 /* Ambient */ && ts.isParameterDeclaration(declaration)) {
	                        parentType = getNonNullableType(parentType);
	                    }
	                    var propType = getTypeOfPropertyOfType(parentType, text);
	                    var declaredType = propType && getConstraintForLocation(propType, declaration.name);
	                    type = declaredType && getFlowTypeOfReference(declaration, declaredType) ||
	                        isNumericLiteralName(text) && getIndexTypeOfType(parentType, 1 /* Number */) ||
	                        getIndexTypeOfType(parentType, 0 /* String */);
	                    if (!type) {
	                        error(name, ts.Diagnostics.Type_0_has_no_property_1_and_no_string_index_signature, typeToString(parentType), ts.declarationNameToString(name));
	                        return unknownType;
	                    }
	                }
	            }
	            else {
	                // This elementType will be used if the specific property corresponding to this index is not
	                // present (aka the tuple element property). This call also checks that the parentType is in
	                // fact an iterable or array (depending on target language).
	                var elementType = checkIteratedTypeOrElementType(parentType, pattern, /*allowStringInput*/ false, /*allowAsyncIterables*/ false);
	                if (declaration.dotDotDotToken) {
	                    // Rest element has an array type with the same element type as the parent type
	                    type = createArrayType(elementType);
	                }
	                else {
	                    // Use specific property type when parent is a tuple or numeric index type when parent is an array
	                    var propName = "" + pattern.elements.indexOf(declaration);
	                    type = isTupleLikeType(parentType)
	                        ? getTypeOfPropertyOfType(parentType, propName)
	                        : elementType;
	                    if (!type) {
	                        if (isTupleType(parentType)) {
	                            error(declaration, ts.Diagnostics.Tuple_type_0_with_length_1_cannot_be_assigned_to_tuple_with_length_2, typeToString(parentType), getTypeReferenceArity(parentType), pattern.elements.length);
	                        }
	                        else {
	                            error(declaration, ts.Diagnostics.Type_0_has_no_property_1, typeToString(parentType), propName);
	                        }
	                        return unknownType;
	                    }
	                }
	            }
	            // In strict null checking mode, if a default value of a non-undefined type is specified, remove
	            // undefined from the final type.
	            if (strictNullChecks && declaration.initializer && !(getFalsyFlags(checkExpressionCached(declaration.initializer)) & 4096 /* Undefined */)) {
	                type = getTypeWithFacts(type, 131072 /* NEUndefined */);
	            }
	            return declaration.initializer ?
	                getUnionType([type, checkExpressionCached(declaration.initializer)], 2 /* Subtype */) :
	                type;
	        }
	        function getTypeForDeclarationFromJSDocComment(declaration) {
	            var jsdocType = ts.getJSDocType(declaration);
	            if (jsdocType) {
	                return getTypeFromTypeNode(jsdocType);
	            }
	            return undefined;
	        }
	        function isNullOrUndefined(node) {
	            var expr = ts.skipParentheses(node);
	            return expr.kind === 95 /* NullKeyword */ || expr.kind === 71 /* Identifier */ && getResolvedSymbol(expr) === undefinedSymbol;
	        }
	        function isEmptyArrayLiteral(node) {
	            var expr = ts.skipParentheses(node);
	            return expr.kind === 181 /* ArrayLiteralExpression */ && expr.elements.length === 0;
	        }
	        function addOptionality(type, optional) {
	            if (optional === void 0) { optional = true; }
	            return strictNullChecks && optional ? getOptionalType(type) : type;
	        }
	        // Return the inferred type for a variable, parameter, or property declaration
	        function getTypeForVariableLikeDeclaration(declaration, includeOptionality) {
	            // A variable declared in a for..in statement is of type string, or of type keyof T when the
	            // right hand expression is of a type parameter type.
	            if (ts.isVariableDeclaration(declaration) && declaration.parent.parent.kind === 219 /* ForInStatement */) {
	                var indexType = getIndexType(checkNonNullExpression(declaration.parent.parent.expression));
	                return indexType.flags & (32768 /* TypeParameter */ | 524288 /* Index */) ? indexType : stringType;
	            }
	            if (ts.isVariableDeclaration(declaration) && declaration.parent.parent.kind === 220 /* ForOfStatement */) {
	                // checkRightHandSideOfForOf will return undefined if the for-of expression type was
	                // missing properties/signatures required to get its iteratedType (like
	                // [Symbol.iterator] or next). This may be because we accessed properties from anyType,
	                // or it may have led to an error inside getElementTypeOfIterable.
	                var forOfStatement = declaration.parent.parent;
	                return checkRightHandSideOfForOf(forOfStatement.expression, forOfStatement.awaitModifier) || anyType;
	            }
	            if (ts.isBindingPattern(declaration.parent)) {
	                return getTypeForBindingElement(declaration);
	            }
	            var isOptional = !ts.isBindingElement(declaration) && !ts.isVariableDeclaration(declaration) && !!declaration.questionToken && includeOptionality;
	            // Use type from type annotation if one is present
	            var declaredType = tryGetTypeFromEffectiveTypeNode(declaration);
	            if (declaredType) {
	                return addOptionality(declaredType, isOptional);
	            }
	            if ((noImplicitAny || ts.isInJavaScriptFile(declaration)) &&
	                declaration.kind === 230 /* VariableDeclaration */ && !ts.isBindingPattern(declaration.name) &&
	                !(ts.getCombinedModifierFlags(declaration) & 1 /* Export */) && !(declaration.flags & 2097152 /* Ambient */)) {
	                // If --noImplicitAny is on or the declaration is in a Javascript file,
	                // use control flow tracked 'any' type for non-ambient, non-exported var or let variables with no
	                // initializer or a 'null' or 'undefined' initializer.
	                if (!(ts.getCombinedNodeFlags(declaration) & 2 /* Const */) && (!declaration.initializer || isNullOrUndefined(declaration.initializer))) {
	                    return autoType;
	                }
	                // Use control flow tracked 'any[]' type for non-ambient, non-exported variables with an empty array
	                // literal initializer.
	                if (declaration.initializer && isEmptyArrayLiteral(declaration.initializer)) {
	                    return autoArrayType;
	                }
	            }
	            if (declaration.kind === 148 /* Parameter */) {
	                var func = declaration.parent;
	                // For a parameter of a set accessor, use the type of the get accessor if one is present
	                if (func.kind === 156 /* SetAccessor */ && !hasNonBindableDynamicName(func)) {
	                    var getter = ts.getDeclarationOfKind(getSymbolOfNode(declaration.parent), 155 /* GetAccessor */);
	                    if (getter) {
	                        var getterSignature = getSignatureFromDeclaration(getter);
	                        var thisParameter = getAccessorThisParameter(func);
	                        if (thisParameter && declaration === thisParameter) {
	                            // Use the type from the *getter*
	                            ts.Debug.assert(!thisParameter.type);
	                            return getTypeOfSymbol(getterSignature.thisParameter);
	                        }
	                        return getReturnTypeOfSignature(getterSignature);
	                    }
	                }
	                // Use contextual parameter type if one is available
	                var type = void 0;
	                if (declaration.symbol.escapedName === "this") {
	                    type = getContextualThisParameterType(func);
	                }
	                else {
	                    type = getContextuallyTypedParameterType(declaration);
	                }
	                if (type) {
	                    return addOptionality(type, isOptional);
	                }
	            }
	            // Use the type of the initializer expression if one is present
	            if (declaration.initializer) {
	                var type = checkDeclarationInitializer(declaration);
	                return addOptionality(type, isOptional);
	            }
	            if (ts.isJsxAttribute(declaration)) {
	                // if JSX attribute doesn't have initializer, by default the attribute will have boolean value of true.
	                // I.e <Elem attr /> is sugar for <Elem attr={true} />
	                return trueType;
	            }
	            // If the declaration specifies a binding pattern, use the type implied by the binding pattern
	            if (ts.isBindingPattern(declaration.name)) {
	                return getTypeFromBindingPattern(declaration.name, /*includePatternInType*/ false, /*reportErrors*/ true);
	            }
	            // No type specified and nothing can be inferred
	            return undefined;
	        }
	        function getWidenedTypeFromJSSpecialPropertyDeclarations(symbol) {
	            var types = [];
	            var definedInConstructor = false;
	            var definedInMethod = false;
	            var jsDocType;
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var declaration = _a[_i];
	                var expression = declaration.kind === 198 /* BinaryExpression */ ? declaration :
	                    declaration.kind === 183 /* PropertyAccessExpression */ ? ts.getAncestor(declaration, 198 /* BinaryExpression */) :
	                        undefined;
	                if (!expression) {
	                    return unknownType;
	                }
	                if (ts.isPropertyAccessExpression(expression.left) && expression.left.expression.kind === 99 /* ThisKeyword */) {
	                    if (ts.getThisContainer(expression, /*includeArrowFunctions*/ false).kind === 154 /* Constructor */) {
	                        definedInConstructor = true;
	                    }
	                    else {
	                        definedInMethod = true;
	                    }
	                }
	                // If there is a JSDoc type, use it
	                var type_1 = getTypeForDeclarationFromJSDocComment(expression.parent);
	                if (type_1) {
	                    var declarationType = getWidenedType(type_1);
	                    if (!jsDocType) {
	                        jsDocType = declarationType;
	                    }
	                    else if (jsDocType !== unknownType && declarationType !== unknownType &&
	                        !isTypeIdenticalTo(jsDocType, declarationType) &&
	                        !(symbol.flags & 67108864 /* JSContainer */)) {
	                        errorNextVariableOrPropertyDeclarationMustHaveSameType(jsDocType, declaration, declarationType);
	                    }
	                }
	                else if (!jsDocType) {
	                    // If we don't have an explicit JSDoc type, get the type from the expression.
	                    types.push(getWidenedLiteralType(checkExpressionCached(expression.right)));
	                }
	            }
	            var type = jsDocType || getUnionType(types, 2 /* Subtype */);
	            return getWidenedType(addOptionality(type, definedInMethod && !definedInConstructor));
	        }
	        // Return the type implied by a binding pattern element. This is the type of the initializer of the element if
	        // one is present. Otherwise, if the element is itself a binding pattern, it is the type implied by the binding
	        // pattern. Otherwise, it is the type any.
	        function getTypeFromBindingElement(element, includePatternInType, reportErrors) {
	            if (element.initializer) {
	                return checkDeclarationInitializer(element);
	            }
	            if (ts.isBindingPattern(element.name)) {
	                return getTypeFromBindingPattern(element.name, includePatternInType, reportErrors);
	            }
	            if (reportErrors && noImplicitAny && !declarationBelongsToPrivateAmbientMember(element)) {
	                reportImplicitAnyError(element, anyType);
	            }
	            return anyType;
	        }
	        // Return the type implied by an object binding pattern
	        function getTypeFromObjectBindingPattern(pattern, includePatternInType, reportErrors) {
	            var members = ts.createSymbolTable();
	            var stringIndexInfo;
	            var hasComputedProperties = false;
	            ts.forEach(pattern.elements, function (e) {
	                var name = e.propertyName || e.name;
	                if (isComputedNonLiteralName(name)) {
	                    // do not include computed properties in the implied type
	                    hasComputedProperties = true;
	                    return;
	                }
	                if (e.dotDotDotToken) {
	                    stringIndexInfo = createIndexInfo(anyType, /*isReadonly*/ false);
	                    return;
	                }
	                var text = ts.getTextOfPropertyName(name);
	                var flags = 4 /* Property */ | (e.initializer ? 16777216 /* Optional */ : 0);
	                var symbol = createSymbol(flags, text);
	                symbol.type = getTypeFromBindingElement(e, includePatternInType, reportErrors);
	                symbol.bindingElement = e;
	                members.set(symbol.escapedName, symbol);
	            });
	            var result = createAnonymousType(undefined, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, undefined);
	            if (includePatternInType) {
	                result.pattern = pattern;
	            }
	            if (hasComputedProperties) {
	                result.objectFlags |= 512 /* ObjectLiteralPatternWithComputedProperties */;
	            }
	            return result;
	        }
	        // Return the type implied by an array binding pattern
	        function getTypeFromArrayBindingPattern(pattern, includePatternInType, reportErrors) {
	            var elements = pattern.elements;
	            var lastElement = ts.lastOrUndefined(elements);
	            if (elements.length === 0 || (!ts.isOmittedExpression(lastElement) && lastElement.dotDotDotToken)) {
	                return languageVersion >= 2 /* ES2015 */ ? createIterableType(anyType) : anyArrayType;
	            }
	            // If the pattern has at least one element, and no rest element, then it should imply a tuple type.
	            var elementTypes = ts.map(elements, function (e) { return ts.isOmittedExpression(e) ? anyType : getTypeFromBindingElement(e, includePatternInType, reportErrors); });
	            var result = createTupleType(elementTypes);
	            if (includePatternInType) {
	                result = cloneTypeReference(result);
	                result.pattern = pattern;
	            }
	            return result;
	        }
	        // Return the type implied by a binding pattern. This is the type implied purely by the binding pattern itself
	        // and without regard to its context (i.e. without regard any type annotation or initializer associated with the
	        // declaration in which the binding pattern is contained). For example, the implied type of [x, y] is [any, any]
	        // and the implied type of { x, y: z = 1 } is { x: any; y: number; }. The type implied by a binding pattern is
	        // used as the contextual type of an initializer associated with the binding pattern. Also, for a destructuring
	        // parameter with no type annotation or initializer, the type implied by the binding pattern becomes the type of
	        // the parameter.
	        function getTypeFromBindingPattern(pattern, includePatternInType, reportErrors) {
	            return pattern.kind === 178 /* ObjectBindingPattern */
	                ? getTypeFromObjectBindingPattern(pattern, includePatternInType, reportErrors)
	                : getTypeFromArrayBindingPattern(pattern, includePatternInType, reportErrors);
	        }
	        // Return the type associated with a variable, parameter, or property declaration. In the simple case this is the type
	        // specified in a type annotation or inferred from an initializer. However, in the case of a destructuring declaration it
	        // is a bit more involved. For example:
	        //
	        //   var [x, s = ""] = [1, "one"];
	        //
	        // Here, the array literal [1, "one"] is contextually typed by the type [any, string], which is the implied type of the
	        // binding pattern [x, s = ""]. Because the contextual type is a tuple type, the resulting type of [1, "one"] is the
	        // tuple type [number, string]. Thus, the type inferred for 'x' is number and the type inferred for 's' is string.
	        function getWidenedTypeForVariableLikeDeclaration(declaration, reportErrors) {
	            var type = getTypeForVariableLikeDeclaration(declaration, /*includeOptionality*/ true);
	            if (type) {
	                if (reportErrors) {
	                    reportErrorsFromWidening(declaration, type);
	                }
	                // always widen a 'unique symbol' type if the type was created for a different declaration.
	                if (type.flags & 1024 /* UniqueESSymbol */ && (ts.isBindingElement(declaration) || !declaration.type) && type.symbol !== getSymbolOfNode(declaration)) {
	                    type = esSymbolType;
	                }
	                return getWidenedType(type);
	            }
	            // Rest parameters default to type any[], other parameters default to type any
	            type = ts.isParameter(declaration) && declaration.dotDotDotToken ? anyArrayType : anyType;
	            // Report implicit any errors unless this is a private property within an ambient declaration
	            if (reportErrors && noImplicitAny) {
	                if (!declarationBelongsToPrivateAmbientMember(declaration)) {
	                    reportImplicitAnyError(declaration, type);
	                }
	            }
	            return type;
	        }
	        function declarationBelongsToPrivateAmbientMember(declaration) {
	            var root = ts.getRootDeclaration(declaration);
	            var memberDeclaration = root.kind === 148 /* Parameter */ ? root.parent : root;
	            return isPrivateWithinAmbient(memberDeclaration);
	        }
	        function tryGetTypeFromEffectiveTypeNode(declaration) {
	            var typeNode = ts.getEffectiveTypeAnnotationNode(declaration);
	            if (typeNode) {
	                return getTypeFromTypeNode(typeNode);
	            }
	        }
	        function getTypeOfVariableOrParameterOrProperty(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                // Handle prototype property
	                if (symbol.flags & 4194304 /* Prototype */) {
	                    return links.type = getTypeOfPrototypeProperty(symbol);
	                }
	                // Handle catch clause variables
	                var declaration = symbol.valueDeclaration;
	                if (ts.isCatchClauseVariableDeclarationOrBindingElement(declaration)) {
	                    return links.type = anyType;
	                }
	                // Handle export default expressions
	                if (declaration.kind === 247 /* ExportAssignment */) {
	                    return links.type = checkExpression(declaration.expression);
	                }
	                if (ts.isInJavaScriptFile(declaration) && ts.isJSDocPropertyLikeTag(declaration) && declaration.typeExpression) {
	                    return links.type = getTypeFromTypeNode(declaration.typeExpression.type);
	                }
	                // Handle variable, parameter or property
	                if (!pushTypeResolution(symbol, 0 /* Type */)) {
	                    return unknownType;
	                }
	                var type = void 0;
	                // Handle certain special assignment kinds, which happen to union across multiple declarations:
	                // * module.exports = expr
	                // * exports.p = expr
	                // * this.p = expr
	                // * className.prototype.method = expr
	                if (declaration.kind === 198 /* BinaryExpression */ ||
	                    declaration.kind === 183 /* PropertyAccessExpression */ && declaration.parent.kind === 198 /* BinaryExpression */) {
	                    type = getWidenedTypeFromJSSpecialPropertyDeclarations(symbol);
	                }
	                else if (ts.isJSDocPropertyTag(declaration)
	                    || ts.isPropertyAccessExpression(declaration)
	                    || ts.isIdentifier(declaration)
	                    || (ts.isMethodDeclaration(declaration) && !ts.isObjectLiteralMethod(declaration))
	                    || ts.isMethodSignature(declaration)) {
	                    // Symbol is property of some kind that is merged with something - should use `getTypeOfFuncClassEnumModule` and not `getTypeOfVariableOrParameterOrProperty`
	                    if (symbol.flags & (16 /* Function */ | 8192 /* Method */ | 32 /* Class */ | 384 /* Enum */ | 512 /* ValueModule */)) {
	                        return getTypeOfFuncClassEnumModule(symbol);
	                    }
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || anyType;
	                }
	                else if (ts.isPropertyAssignment(declaration)) {
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || checkPropertyAssignment(declaration);
	                }
	                else if (ts.isJsxAttribute(declaration)) {
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || checkJsxAttribute(declaration);
	                }
	                else if (ts.isShorthandPropertyAssignment(declaration)) {
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || checkExpressionForMutableLocation(declaration.name, 0 /* Normal */);
	                }
	                else if (ts.isObjectLiteralMethod(declaration)) {
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || checkObjectLiteralMethod(declaration, 0 /* Normal */);
	                }
	                else if (ts.isParameter(declaration)
	                    || ts.isPropertyDeclaration(declaration)
	                    || ts.isPropertySignature(declaration)
	                    || ts.isVariableDeclaration(declaration)
	                    || ts.isBindingElement(declaration)) {
	                    type = getWidenedTypeForVariableLikeDeclaration(declaration, /*reportErrors*/ true);
	                }
	                else {
	                    ts.Debug.fail("Unhandled declaration kind! " + ts.Debug.showSyntaxKind(declaration));
	                }
	                if (!popTypeResolution()) {
	                    type = reportCircularityError(symbol);
	                }
	                links.type = type;
	            }
	            return links.type;
	        }
	        function getAnnotatedAccessorType(accessor) {
	            if (accessor) {
	                if (accessor.kind === 155 /* GetAccessor */) {
	                    var getterTypeAnnotation = ts.getEffectiveReturnTypeNode(accessor);
	                    return getterTypeAnnotation && getTypeFromTypeNode(getterTypeAnnotation);
	                }
	                else {
	                    var setterTypeAnnotation = ts.getEffectiveSetAccessorTypeAnnotationNode(accessor);
	                    return setterTypeAnnotation && getTypeFromTypeNode(setterTypeAnnotation);
	                }
	            }
	            return undefined;
	        }
	        function getAnnotatedAccessorThisParameter(accessor) {
	            var parameter = getAccessorThisParameter(accessor);
	            return parameter && parameter.symbol;
	        }
	        function getThisTypeOfDeclaration(declaration) {
	            return getThisTypeOfSignature(getSignatureFromDeclaration(declaration));
	        }
	        function getTypeOfAccessors(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                var getter = ts.getDeclarationOfKind(symbol, 155 /* GetAccessor */);
	                var setter = ts.getDeclarationOfKind(symbol, 156 /* SetAccessor */);
	                if (getter && ts.isInJavaScriptFile(getter)) {
	                    var jsDocType = getTypeForDeclarationFromJSDocComment(getter);
	                    if (jsDocType) {
	                        return links.type = jsDocType;
	                    }
	                }
	                if (!pushTypeResolution(symbol, 0 /* Type */)) {
	                    return unknownType;
	                }
	                var type = void 0;
	                // First try to see if the user specified a return type on the get-accessor.
	                var getterReturnType = getAnnotatedAccessorType(getter);
	                if (getterReturnType) {
	                    type = getterReturnType;
	                }
	                else {
	                    // If the user didn't specify a return type, try to use the set-accessor's parameter type.
	                    var setterParameterType = getAnnotatedAccessorType(setter);
	                    if (setterParameterType) {
	                        type = setterParameterType;
	                    }
	                    else {
	                        // If there are no specified types, try to infer it from the body of the get accessor if it exists.
	                        if (getter && getter.body) {
	                            type = getReturnTypeFromBody(getter);
	                        }
	                        else {
	                            if (noImplicitAny) {
	                                if (setter) {
	                                    error(setter, ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation, symbolToString(symbol));
	                                }
	                                else {
	                                    ts.Debug.assert(!!getter, "there must existed getter as we are current checking either setter or getter in this function");
	                                    error(getter, ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation, symbolToString(symbol));
	                                }
	                            }
	                            type = anyType;
	                        }
	                    }
	                }
	                if (!popTypeResolution()) {
	                    type = anyType;
	                    if (noImplicitAny) {
	                        var getter_1 = ts.getDeclarationOfKind(symbol, 155 /* GetAccessor */);
	                        error(getter_1, ts.Diagnostics._0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions, symbolToString(symbol));
	                    }
	                }
	                links.type = type;
	            }
	            return links.type;
	        }
	        function getBaseTypeVariableOfClass(symbol) {
	            var baseConstructorType = getBaseConstructorTypeOfClass(getDeclaredTypeOfClassOrInterface(symbol));
	            return baseConstructorType.flags & 1081344 /* TypeVariable */ ? baseConstructorType : undefined;
	        }
	        function getTypeOfFuncClassEnumModule(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                if (symbol.flags & 1536 /* Module */ && ts.isShorthandAmbientModuleSymbol(symbol)) {
	                    links.type = anyType;
	                }
	                else {
	                    var type = createObjectType(16 /* Anonymous */, symbol);
	                    if (symbol.flags & 32 /* Class */) {
	                        var baseTypeVariable = getBaseTypeVariableOfClass(symbol);
	                        links.type = baseTypeVariable ? getIntersectionType([type, baseTypeVariable]) : type;
	                    }
	                    else {
	                        links.type = strictNullChecks && symbol.flags & 16777216 /* Optional */ ? getOptionalType(type) : type;
	                    }
	                }
	            }
	            return links.type;
	        }
	        function getTypeOfEnumMember(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                links.type = getDeclaredTypeOfEnumMember(symbol);
	            }
	            return links.type;
	        }
	        function getTypeOfAlias(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                var targetSymbol = resolveAlias(symbol);
	                // It only makes sense to get the type of a value symbol. If the result of resolving
	                // the alias is not a value, then it has no type. To get the type associated with a
	                // type symbol, call getDeclaredTypeOfSymbol.
	                // This check is important because without it, a call to getTypeOfSymbol could end
	                // up recursively calling getTypeOfAlias, causing a stack overflow.
	                links.type = targetSymbol.flags & 107455 /* Value */
	                    ? getTypeOfSymbol(targetSymbol)
	                    : unknownType;
	            }
	            return links.type;
	        }
	        function getTypeOfInstantiatedSymbol(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                if (symbolInstantiationDepth === 100) {
	                    error(symbol.valueDeclaration, ts.Diagnostics.Generic_type_instantiation_is_excessively_deep_and_possibly_infinite);
	                    links.type = unknownType;
	                }
	                else {
	                    if (!pushTypeResolution(symbol, 0 /* Type */)) {
	                        return unknownType;
	                    }
	                    symbolInstantiationDepth++;
	                    var type = instantiateType(getTypeOfSymbol(links.target), links.mapper);
	                    symbolInstantiationDepth--;
	                    if (!popTypeResolution()) {
	                        type = reportCircularityError(symbol);
	                    }
	                    links.type = type;
	                }
	            }
	            return links.type;
	        }
	        function reportCircularityError(symbol) {
	            // Check if variable has type annotation that circularly references the variable itself
	            if (ts.getEffectiveTypeAnnotationNode(symbol.valueDeclaration)) {
	                error(symbol.valueDeclaration, ts.Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
	                return unknownType;
	            }
	            // Otherwise variable has initializer that circularly references the variable itself
	            if (noImplicitAny) {
	                error(symbol.valueDeclaration, ts.Diagnostics._0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or_indirectly_in_its_own_initializer, symbolToString(symbol));
	            }
	            return anyType;
	        }
	        function getTypeOfSymbol(symbol) {
	            if (ts.getCheckFlags(symbol) & 1 /* Instantiated */) {
	                return getTypeOfInstantiatedSymbol(symbol);
	            }
	            if (ts.getCheckFlags(symbol) & 2048 /* ReverseMapped */) {
	                return getTypeOfReverseMappedSymbol(symbol);
	            }
	            if (symbol.flags & (3 /* Variable */ | 4 /* Property */)) {
	                return getTypeOfVariableOrParameterOrProperty(symbol);
	            }
	            if (symbol.flags & (16 /* Function */ | 8192 /* Method */ | 32 /* Class */ | 384 /* Enum */ | 512 /* ValueModule */)) {
	                return getTypeOfFuncClassEnumModule(symbol);
	            }
	            if (symbol.flags & 8 /* EnumMember */) {
	                return getTypeOfEnumMember(symbol);
	            }
	            if (symbol.flags & 98304 /* Accessor */) {
	                return getTypeOfAccessors(symbol);
	            }
	            if (symbol.flags & 2097152 /* Alias */) {
	                return getTypeOfAlias(symbol);
	            }
	            return unknownType;
	        }
	        function isReferenceToType(type, target) {
	            return type !== undefined
	                && target !== undefined
	                && (ts.getObjectFlags(type) & 4 /* Reference */) !== 0
	                && type.target === target;
	        }
	        function getTargetType(type) {
	            return ts.getObjectFlags(type) & 4 /* Reference */ ? type.target : type;
	        }
	        function hasBaseType(type, checkBase) {
	            return check(type);
	            function check(type) {
	                if (ts.getObjectFlags(type) & (3 /* ClassOrInterface */ | 4 /* Reference */)) {
	                    var target = getTargetType(type);
	                    return target === checkBase || ts.forEach(getBaseTypes(target), check);
	                }
	                else if (type.flags & 262144 /* Intersection */) {
	                    return ts.forEach(type.types, check);
	                }
	            }
	        }
	        // Appends the type parameters given by a list of declarations to a set of type parameters and returns the resulting set.
	        // The function allocates a new array if the input type parameter set is undefined, but otherwise it modifies the set
	        // in-place and returns the same array.
	        function appendTypeParameters(typeParameters, declarations) {
	            for (var _i = 0, declarations_2 = declarations; _i < declarations_2.length; _i++) {
	                var declaration = declarations_2[_i];
	                var tp = getDeclaredTypeOfTypeParameter(getSymbolOfNode(declaration));
	                typeParameters = ts.appendIfUnique(typeParameters, tp);
	            }
	            return typeParameters;
	        }
	        // Return the outer type parameters of a node or undefined if the node has no outer type parameters.
	        function getOuterTypeParameters(node, includeThisTypes) {
	            while (true) {
	                node = node.parent;
	                if (!node) {
	                    return undefined;
	                }
	                switch (node.kind) {
	                    case 233 /* ClassDeclaration */:
	                    case 203 /* ClassExpression */:
	                    case 234 /* InterfaceDeclaration */:
	                    case 157 /* CallSignature */:
	                    case 158 /* ConstructSignature */:
	                    case 152 /* MethodSignature */:
	                    case 162 /* FunctionType */:
	                    case 163 /* ConstructorType */:
	                    case 280 /* JSDocFunctionType */:
	                    case 232 /* FunctionDeclaration */:
	                    case 153 /* MethodDeclaration */:
	                    case 190 /* FunctionExpression */:
	                    case 191 /* ArrowFunction */:
	                    case 235 /* TypeAliasDeclaration */:
	                    case 290 /* JSDocTemplateTag */:
	                    case 176 /* MappedType */:
	                    case 170 /* ConditionalType */:
	                        var outerTypeParameters = getOuterTypeParameters(node, includeThisTypes);
	                        if (node.kind === 176 /* MappedType */) {
	                            return ts.append(outerTypeParameters, getDeclaredTypeOfTypeParameter(getSymbolOfNode(node.typeParameter)));
	                        }
	                        else if (node.kind === 170 /* ConditionalType */) {
	                            return ts.concatenate(outerTypeParameters, getInferTypeParameters(node));
	                        }
	                        var outerAndOwnTypeParameters = appendTypeParameters(outerTypeParameters, ts.getEffectiveTypeParameterDeclarations(node) || ts.emptyArray);
	                        var thisType = includeThisTypes &&
	                            (node.kind === 233 /* ClassDeclaration */ || node.kind === 203 /* ClassExpression */ || node.kind === 234 /* InterfaceDeclaration */) &&
	                            getDeclaredTypeOfClassOrInterface(getSymbolOfNode(node)).thisType;
	                        return thisType ? ts.append(outerAndOwnTypeParameters, thisType) : outerAndOwnTypeParameters;
	                }
	            }
	        }
	        // The outer type parameters are those defined by enclosing generic classes, methods, or functions.
	        function getOuterTypeParametersOfClassOrInterface(symbol) {
	            var declaration = symbol.flags & 32 /* Class */ ? symbol.valueDeclaration : ts.getDeclarationOfKind(symbol, 234 /* InterfaceDeclaration */);
	            return getOuterTypeParameters(declaration);
	        }
	        // The local type parameters are the combined set of type parameters from all declarations of the class,
	        // interface, or type alias.
	        function getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol) {
	            var result;
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var node = _a[_i];
	                if (node.kind === 234 /* InterfaceDeclaration */ || node.kind === 233 /* ClassDeclaration */ ||
	                    node.kind === 203 /* ClassExpression */ || node.kind === 235 /* TypeAliasDeclaration */) {
	                    var declaration = node;
	                    if (declaration.typeParameters) {
	                        result = appendTypeParameters(result, declaration.typeParameters);
	                    }
	                }
	            }
	            return result;
	        }
	        // The full set of type parameters for a generic class or interface type consists of its outer type parameters plus
	        // its locally declared type parameters.
	        function getTypeParametersOfClassOrInterface(symbol) {
	            return ts.concatenate(getOuterTypeParametersOfClassOrInterface(symbol), getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol));
	        }
	        // A type is a mixin constructor if it has a single construct signature taking no type parameters and a single
	        // rest parameter of type any[].
	        function isMixinConstructorType(type) {
	            var signatures = getSignaturesOfType(type, 1 /* Construct */);
	            if (signatures.length === 1) {
	                var s = signatures[0];
	                return !s.typeParameters && s.parameters.length === 1 && s.hasRestParameter && getTypeOfParameter(s.parameters[0]) === anyArrayType;
	            }
	            return false;
	        }
	        function isConstructorType(type) {
	            if (isValidBaseType(type) && getSignaturesOfType(type, 1 /* Construct */).length > 0) {
	                return true;
	            }
	            if (type.flags & 1081344 /* TypeVariable */) {
	                var constraint = getBaseConstraintOfType(type);
	                return constraint && isValidBaseType(constraint) && isMixinConstructorType(constraint);
	            }
	            return false;
	        }
	        function getBaseTypeNodeOfClass(type) {
	            var decl = type.symbol.valueDeclaration;
	            if (ts.isInJavaScriptFile(decl)) {
	                // Prefer an @augments tag because it may have type parameters.
	                var tag = ts.getJSDocAugmentsTag(decl);
	                if (tag) {
	                    return tag.class;
	                }
	            }
	            return ts.getClassExtendsHeritageClauseElement(decl);
	        }
	        function getConstructorsForTypeArguments(type, typeArgumentNodes, location) {
	            var typeArgCount = ts.length(typeArgumentNodes);
	            var isJavaScript = ts.isInJavaScriptFile(location);
	            return ts.filter(getSignaturesOfType(type, 1 /* Construct */), function (sig) { return (isJavaScript || typeArgCount >= getMinTypeArgumentCount(sig.typeParameters)) && typeArgCount <= ts.length(sig.typeParameters); });
	        }
	        function getInstantiatedConstructorsForTypeArguments(type, typeArgumentNodes, location) {
	            var signatures = getConstructorsForTypeArguments(type, typeArgumentNodes, location);
	            var typeArguments = ts.map(typeArgumentNodes, getTypeFromTypeNode);
	            return ts.sameMap(signatures, function (sig) { return ts.some(sig.typeParameters) ? getSignatureInstantiation(sig, typeArguments, ts.isInJavaScriptFile(location)) : sig; });
	        }
	        /**
	         * The base constructor of a class can resolve to
	         * * undefinedType if the class has no extends clause,
	         * * unknownType if an error occurred during resolution of the extends expression,
	         * * nullType if the extends expression is the null value,
	         * * anyType if the extends expression has type any, or
	         * * an object type with at least one construct signature.
	         */
	        function getBaseConstructorTypeOfClass(type) {
	            if (!type.resolvedBaseConstructorType) {
	                var decl = type.symbol.valueDeclaration;
	                var extended = ts.getClassExtendsHeritageClauseElement(decl);
	                var baseTypeNode = getBaseTypeNodeOfClass(type);
	                if (!baseTypeNode) {
	                    return type.resolvedBaseConstructorType = undefinedType;
	                }
	                if (!pushTypeResolution(type, 1 /* ResolvedBaseConstructorType */)) {
	                    return unknownType;
	                }
	                var baseConstructorType = checkExpression(baseTypeNode.expression);
	                if (extended && baseTypeNode !== extended) {
	                    ts.Debug.assert(!extended.typeArguments); // Because this is in a JS file, and baseTypeNode is in an @extends tag
	                    checkExpression(extended.expression);
	                }
	                if (baseConstructorType.flags & (65536 /* Object */ | 262144 /* Intersection */)) {
	                    // Resolving the members of a class requires us to resolve the base class of that class.
	                    // We force resolution here such that we catch circularities now.
	                    resolveStructuredTypeMembers(baseConstructorType);
	                }
	                if (!popTypeResolution()) {
	                    error(type.symbol.valueDeclaration, ts.Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_base_expression, symbolToString(type.symbol));
	                    return type.resolvedBaseConstructorType = unknownType;
	                }
	                if (!(baseConstructorType.flags & 1 /* Any */) && baseConstructorType !== nullWideningType && !isConstructorType(baseConstructorType)) {
	                    error(baseTypeNode.expression, ts.Diagnostics.Type_0_is_not_a_constructor_function_type, typeToString(baseConstructorType));
	                    return type.resolvedBaseConstructorType = unknownType;
	                }
	                type.resolvedBaseConstructorType = baseConstructorType;
	            }
	            return type.resolvedBaseConstructorType;
	        }
	        function getBaseTypes(type) {
	            if (!type.resolvedBaseTypes) {
	                if (type.objectFlags & 8 /* Tuple */) {
	                    type.resolvedBaseTypes = [createArrayType(getUnionType(type.typeParameters))];
	                }
	                else if (type.symbol.flags & (32 /* Class */ | 64 /* Interface */)) {
	                    if (type.symbol.flags & 32 /* Class */) {
	                        resolveBaseTypesOfClass(type);
	                    }
	                    if (type.symbol.flags & 64 /* Interface */) {
	                        resolveBaseTypesOfInterface(type);
	                    }
	                }
	                else {
	                    ts.Debug.fail("type must be class or interface");
	                }
	            }
	            return type.resolvedBaseTypes;
	        }
	        function resolveBaseTypesOfClass(type) {
	            type.resolvedBaseTypes = ts.resolvingEmptyArray;
	            var baseConstructorType = getApparentType(getBaseConstructorTypeOfClass(type));
	            if (!(baseConstructorType.flags & (65536 /* Object */ | 262144 /* Intersection */ | 1 /* Any */))) {
	                return type.resolvedBaseTypes = ts.emptyArray;
	            }
	            var baseTypeNode = getBaseTypeNodeOfClass(type);
	            var typeArgs = typeArgumentsFromTypeReferenceNode(baseTypeNode);
	            var baseType;
	            var originalBaseType = baseConstructorType && baseConstructorType.symbol ? getDeclaredTypeOfSymbol(baseConstructorType.symbol) : undefined;
	            if (baseConstructorType.symbol && baseConstructorType.symbol.flags & 32 /* Class */ &&
	                areAllOuterTypeParametersApplied(originalBaseType)) {
	                // When base constructor type is a class with no captured type arguments we know that the constructors all have the same type parameters as the
	                // class and all return the instance type of the class. There is no need for further checks and we can apply the
	                // type arguments in the same manner as a type reference to get the same error reporting experience.
	                baseType = getTypeFromClassOrInterfaceReference(baseTypeNode, baseConstructorType.symbol, typeArgs);
	            }
	            else if (baseConstructorType.flags & 1 /* Any */) {
	                baseType = baseConstructorType;
	            }
	            else {
	                // The class derives from a "class-like" constructor function, check that we have at least one construct signature
	                // with a matching number of type parameters and use the return type of the first instantiated signature. Elsewhere
	                // we check that all instantiated signatures return the same type.
	                var constructors = getInstantiatedConstructorsForTypeArguments(baseConstructorType, baseTypeNode.typeArguments, baseTypeNode);
	                if (!constructors.length) {
	                    error(baseTypeNode.expression, ts.Diagnostics.No_base_constructor_has_the_specified_number_of_type_arguments);
	                    return type.resolvedBaseTypes = ts.emptyArray;
	                }
	                baseType = getReturnTypeOfSignature(constructors[0]);
	            }
	            if (baseType === unknownType) {
	                return type.resolvedBaseTypes = ts.emptyArray;
	            }
	            if (!isValidBaseType(baseType)) {
	                error(baseTypeNode.expression, ts.Diagnostics.Base_constructor_return_type_0_is_not_a_class_or_interface_type, typeToString(baseType));
	                return type.resolvedBaseTypes = ts.emptyArray;
	            }
	            if (type === baseType || hasBaseType(baseType, type)) {
	                error(type.symbol.valueDeclaration, ts.Diagnostics.Type_0_recursively_references_itself_as_a_base_type, typeToString(type, /*enclosingDeclaration*/ undefined, 2 /* WriteArrayAsGenericType */));
	                return type.resolvedBaseTypes = ts.emptyArray;
	            }
	            if (type.resolvedBaseTypes === ts.resolvingEmptyArray) {
	                // Circular reference, likely through instantiation of default parameters
	                // (otherwise there'd be an error from hasBaseType) - this is fine, but `.members` should be reset
	                // as `getIndexedAccessType` via `instantiateType` via `getTypeFromClassOrInterfaceReference` forces a
	                // partial instantiation of the members without the base types fully resolved
	                type.members = undefined;
	            }
	            return type.resolvedBaseTypes = [baseType];
	        }
	        function areAllOuterTypeParametersApplied(type) {
	            // An unapplied type parameter has its symbol still the same as the matching argument symbol.
	            // Since parameters are applied outer-to-inner, only the last outer parameter needs to be checked.
	            var outerTypeParameters = type.outerTypeParameters;
	            if (outerTypeParameters) {
	                var last_1 = outerTypeParameters.length - 1;
	                var typeArguments = type.typeArguments;
	                return outerTypeParameters[last_1].symbol !== typeArguments[last_1].symbol;
	            }
	            return true;
	        }
	        // A valid base type is `any`, any non-generic object type or intersection of non-generic
	        // object types.
	        function isValidBaseType(type) {
	            return type.flags & (65536 /* Object */ | 134217728 /* NonPrimitive */ | 1 /* Any */) && !isGenericMappedType(type) ||
	                type.flags & 262144 /* Intersection */ && !ts.forEach(type.types, function (t) { return !isValidBaseType(t); });
	        }
	        function resolveBaseTypesOfInterface(type) {
	            type.resolvedBaseTypes = type.resolvedBaseTypes || ts.emptyArray;
	            for (var _i = 0, _a = type.symbol.declarations; _i < _a.length; _i++) {
	                var declaration = _a[_i];
	                if (declaration.kind === 234 /* InterfaceDeclaration */ && ts.getInterfaceBaseTypeNodes(declaration)) {
	                    for (var _b = 0, _c = ts.getInterfaceBaseTypeNodes(declaration); _b < _c.length; _b++) {
	                        var node = _c[_b];
	                        var baseType = getTypeFromTypeNode(node);
	                        if (baseType !== unknownType) {
	                            if (isValidBaseType(baseType)) {
	                                if (type !== baseType && !hasBaseType(baseType, type)) {
	                                    if (type.resolvedBaseTypes === ts.emptyArray) {
	                                        type.resolvedBaseTypes = [baseType];
	                                    }
	                                    else {
	                                        type.resolvedBaseTypes.push(baseType);
	                                    }
	                                }
	                                else {
	                                    error(declaration, ts.Diagnostics.Type_0_recursively_references_itself_as_a_base_type, typeToString(type, /*enclosingDeclaration*/ undefined, 2 /* WriteArrayAsGenericType */));
	                                }
	                            }
	                            else {
	                                error(node, ts.Diagnostics.An_interface_may_only_extend_a_class_or_another_interface);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        /**
	         * Returns true if the interface given by the symbol is free of "this" references.
	         *
	         * Specifically, the result is true if the interface itself contains no references
	         * to "this" in its body, if all base types are interfaces,
	         * and if none of the base interfaces have a "this" type.
	         */
	        function isThislessInterface(symbol) {
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var declaration = _a[_i];
	                if (declaration.kind === 234 /* InterfaceDeclaration */) {
	                    if (declaration.flags & 64 /* ContainsThis */) {
	                        return false;
	                    }
	                    var baseTypeNodes = ts.getInterfaceBaseTypeNodes(declaration);
	                    if (baseTypeNodes) {
	                        for (var _b = 0, baseTypeNodes_1 = baseTypeNodes; _b < baseTypeNodes_1.length; _b++) {
	                            var node = baseTypeNodes_1[_b];
	                            if (ts.isEntityNameExpression(node.expression)) {
	                                var baseSymbol = resolveEntityName(node.expression, 793064 /* Type */, /*ignoreErrors*/ true);
	                                if (!baseSymbol || !(baseSymbol.flags & 64 /* Interface */) || getDeclaredTypeOfClassOrInterface(baseSymbol).thisType) {
	                                    return false;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            return true;
	        }
	        function getDeclaredTypeOfClassOrInterface(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                var kind = symbol.flags & 32 /* Class */ ? 1 /* Class */ : 2 /* Interface */;
	                var type = links.declaredType = createObjectType(kind, symbol);
	                var outerTypeParameters = getOuterTypeParametersOfClassOrInterface(symbol);
	                var localTypeParameters = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
	                // A class or interface is generic if it has type parameters or a "this" type. We always give classes a "this" type
	                // because it is not feasible to analyze all members to determine if the "this" type escapes the class (in particular,
	                // property types inferred from initializers and method return types inferred from return statements are very hard
	                // to exhaustively analyze). We give interfaces a "this" type if we can't definitely determine that they are free of
	                // "this" references.
	                if (outerTypeParameters || localTypeParameters || kind === 1 /* Class */ || !isThislessInterface(symbol)) {
	                    type.objectFlags |= 4 /* Reference */;
	                    type.typeParameters = ts.concatenate(outerTypeParameters, localTypeParameters);
	                    type.outerTypeParameters = outerTypeParameters;
	                    type.localTypeParameters = localTypeParameters;
	                    type.instantiations = ts.createMap();
	                    type.instantiations.set(getTypeListId(type.typeParameters), type);
	                    type.target = type;
	                    type.typeArguments = type.typeParameters;
	                    type.thisType = createType(32768 /* TypeParameter */);
	                    type.thisType.isThisType = true;
	                    type.thisType.symbol = symbol;
	                    type.thisType.constraint = type;
	                }
	            }
	            return links.declaredType;
	        }
	        function getDeclaredTypeOfTypeAlias(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                // Note that we use the links object as the target here because the symbol object is used as the unique
	                // identity for resolution of the 'type' property in SymbolLinks.
	                if (!pushTypeResolution(symbol, 2 /* DeclaredType */)) {
	                    return unknownType;
	                }
	                var declaration = ts.find(symbol.declarations, function (d) {
	                    return d.kind === 291 /* JSDocTypedefTag */ || d.kind === 235 /* TypeAliasDeclaration */;
	                });
	                var typeNode = declaration.kind === 291 /* JSDocTypedefTag */ ? declaration.typeExpression : declaration.type;
	                // If typeNode is missing, we will error in checkJSDocTypedefTag.
	                var type = typeNode ? getTypeFromTypeNode(typeNode) : unknownType;
	                if (popTypeResolution()) {
	                    var typeParameters = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
	                    if (typeParameters) {
	                        // Initialize the instantiation cache for generic type aliases. The declared type corresponds to
	                        // an instantiation of the type alias with the type parameters supplied as type arguments.
	                        links.typeParameters = typeParameters;
	                        links.instantiations = ts.createMap();
	                        links.instantiations.set(getTypeListId(typeParameters), type);
	                    }
	                }
	                else {
	                    type = unknownType;
	                    error(declaration.name, ts.Diagnostics.Type_alias_0_circularly_references_itself, symbolToString(symbol));
	                }
	                links.declaredType = type;
	            }
	            return links.declaredType;
	        }
	        function isLiteralEnumMember(member) {
	            var expr = member.initializer;
	            if (!expr) {
	                return !(member.flags & 2097152 /* Ambient */);
	            }
	            switch (expr.kind) {
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                    return true;
	                case 196 /* PrefixUnaryExpression */:
	                    return expr.operator === 38 /* MinusToken */ &&
	                        expr.operand.kind === 8 /* NumericLiteral */;
	                case 71 /* Identifier */:
	                    return ts.nodeIsMissing(expr) || !!getSymbolOfNode(member.parent).exports.get(expr.escapedText);
	                default:
	                    return false;
	            }
	        }
	        function getEnumKind(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (links.enumKind !== undefined) {
	                return links.enumKind;
	            }
	            var hasNonLiteralMember = false;
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var declaration = _a[_i];
	                if (declaration.kind === 236 /* EnumDeclaration */) {
	                    for (var _b = 0, _c = declaration.members; _b < _c.length; _b++) {
	                        var member = _c[_b];
	                        if (member.initializer && member.initializer.kind === 9 /* StringLiteral */) {
	                            return links.enumKind = 1 /* Literal */;
	                        }
	                        if (!isLiteralEnumMember(member)) {
	                            hasNonLiteralMember = true;
	                        }
	                    }
	                }
	            }
	            return links.enumKind = hasNonLiteralMember ? 0 /* Numeric */ : 1 /* Literal */;
	        }
	        function getBaseTypeOfEnumLiteralType(type) {
	            return type.flags & 256 /* EnumLiteral */ && !(type.flags & 131072 /* Union */) ? getDeclaredTypeOfSymbol(getParentOfSymbol(type.symbol)) : type;
	        }
	        function getDeclaredTypeOfEnum(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (links.declaredType) {
	                return links.declaredType;
	            }
	            if (getEnumKind(symbol) === 1 /* Literal */) {
	                enumCount++;
	                var memberTypeList = [];
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    if (declaration.kind === 236 /* EnumDeclaration */) {
	                        for (var _b = 0, _c = declaration.members; _b < _c.length; _b++) {
	                            var member = _c[_b];
	                            var memberType = getLiteralType(getEnumMemberValue(member), enumCount, getSymbolOfNode(member));
	                            getSymbolLinks(getSymbolOfNode(member)).declaredType = memberType;
	                            memberTypeList.push(memberType);
	                        }
	                    }
	                }
	                if (memberTypeList.length) {
	                    var enumType_1 = getUnionType(memberTypeList, 1 /* Literal */, symbol, /*aliasTypeArguments*/ undefined);
	                    if (enumType_1.flags & 131072 /* Union */) {
	                        enumType_1.flags |= 256 /* EnumLiteral */;
	                        enumType_1.symbol = symbol;
	                    }
	                    return links.declaredType = enumType_1;
	                }
	            }
	            var enumType = createType(16 /* Enum */);
	            enumType.symbol = symbol;
	            return links.declaredType = enumType;
	        }
	        function getDeclaredTypeOfEnumMember(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                var enumType = getDeclaredTypeOfEnum(getParentOfSymbol(symbol));
	                if (!links.declaredType) {
	                    links.declaredType = enumType;
	                }
	            }
	            return links.declaredType;
	        }
	        function getDeclaredTypeOfTypeParameter(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                var type = createType(32768 /* TypeParameter */);
	                type.symbol = symbol;
	                links.declaredType = type;
	            }
	            return links.declaredType;
	        }
	        function getDeclaredTypeOfAlias(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                links.declaredType = getDeclaredTypeOfSymbol(resolveAlias(symbol));
	            }
	            return links.declaredType;
	        }
	        function getDeclaredTypeOfSymbol(symbol) {
	            return tryGetDeclaredTypeOfSymbol(symbol) || unknownType;
	        }
	        function tryGetDeclaredTypeOfSymbol(symbol) {
	            if (symbol.flags & (32 /* Class */ | 64 /* Interface */)) {
	                return getDeclaredTypeOfClassOrInterface(symbol);
	            }
	            if (symbol.flags & 524288 /* TypeAlias */) {
	                return getDeclaredTypeOfTypeAlias(symbol);
	            }
	            if (symbol.flags & 262144 /* TypeParameter */) {
	                return getDeclaredTypeOfTypeParameter(symbol);
	            }
	            if (symbol.flags & 384 /* Enum */) {
	                return getDeclaredTypeOfEnum(symbol);
	            }
	            if (symbol.flags & 8 /* EnumMember */) {
	                return getDeclaredTypeOfEnumMember(symbol);
	            }
	            if (symbol.flags & 2097152 /* Alias */) {
	                return getDeclaredTypeOfAlias(symbol);
	            }
	            return undefined;
	        }
	        /**
	         * A type is free of this references if it's the any, string, number, boolean, symbol, or void keyword, a string
	         * literal type, an array with an element type that is free of this references, or a type reference that is
	         * free of this references.
	         */
	        function isThislessType(node) {
	            switch (node.kind) {
	                case 119 /* AnyKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 135 /* ObjectKeyword */:
	                case 105 /* VoidKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 95 /* NullKeyword */:
	                case 131 /* NeverKeyword */:
	                case 177 /* LiteralType */:
	                    return true;
	                case 166 /* ArrayType */:
	                    return isThislessType(node.elementType);
	                case 161 /* TypeReference */:
	                    return !node.typeArguments || node.typeArguments.every(isThislessType);
	            }
	            return false;
	        }
	        /** A type parameter is thisless if its contraint is thisless, or if it has no constraint. */
	        function isThislessTypeParameter(node) {
	            return !node.constraint || isThislessType(node.constraint);
	        }
	        /**
	         * A variable-like declaration is free of this references if it has a type annotation
	         * that is thisless, or if it has no type annotation and no initializer (and is thus of type any).
	         */
	        function isThislessVariableLikeDeclaration(node) {
	            var typeNode = ts.getEffectiveTypeAnnotationNode(node);
	            return typeNode ? isThislessType(typeNode) : !ts.hasInitializer(node);
	        }
	        /**
	         * A function-like declaration is considered free of `this` references if it has a return type
	         * annotation that is free of this references and if each parameter is thisless and if
	         * each type parameter (if present) is thisless.
	         */
	        function isThislessFunctionLikeDeclaration(node) {
	            var returnType = ts.getEffectiveReturnTypeNode(node);
	            return (node.kind === 154 /* Constructor */ || (returnType && isThislessType(returnType))) &&
	                node.parameters.every(isThislessVariableLikeDeclaration) &&
	                (!node.typeParameters || node.typeParameters.every(isThislessTypeParameter));
	        }
	        /**
	         * Returns true if the class or interface member given by the symbol is free of "this" references. The
	         * function may return false for symbols that are actually free of "this" references because it is not
	         * feasible to perform a complete analysis in all cases. In particular, property members with types
	         * inferred from their initializers and function members with inferred return types are conservatively
	         * assumed not to be free of "this" references.
	         */
	        function isThisless(symbol) {
	            if (symbol.declarations && symbol.declarations.length === 1) {
	                var declaration = symbol.declarations[0];
	                if (declaration) {
	                    switch (declaration.kind) {
	                        case 151 /* PropertyDeclaration */:
	                        case 150 /* PropertySignature */:
	                            return isThislessVariableLikeDeclaration(declaration);
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 154 /* Constructor */:
	                            return isThislessFunctionLikeDeclaration(declaration);
	                    }
	                }
	            }
	            return false;
	        }
	        // The mappingThisOnly flag indicates that the only type parameter being mapped is "this". When the flag is true,
	        // we check symbols to see if we can quickly conclude they are free of "this" references, thus needing no instantiation.
	        function createInstantiatedSymbolTable(symbols, mapper, mappingThisOnly) {
	            var result = ts.createSymbolTable();
	            for (var _i = 0, symbols_2 = symbols; _i < symbols_2.length; _i++) {
	                var symbol = symbols_2[_i];
	                result.set(symbol.escapedName, mappingThisOnly && isThisless(symbol) ? symbol : instantiateSymbol(symbol, mapper));
	            }
	            return result;
	        }
	        function addInheritedMembers(symbols, baseSymbols) {
	            for (var _i = 0, baseSymbols_1 = baseSymbols; _i < baseSymbols_1.length; _i++) {
	                var s = baseSymbols_1[_i];
	                if (!symbols.has(s.escapedName)) {
	                    symbols.set(s.escapedName, s);
	                }
	            }
	        }
	        function resolveDeclaredMembers(type) {
	            if (!type.declaredProperties) {
	                var symbol = type.symbol;
	                var members = getMembersOfSymbol(symbol);
	                type.declaredProperties = getNamedMembers(members);
	                type.declaredCallSignatures = getSignaturesOfSymbol(members.get("__call" /* Call */));
	                type.declaredConstructSignatures = getSignaturesOfSymbol(members.get("__new" /* New */));
	                type.declaredStringIndexInfo = getIndexInfoOfSymbol(symbol, 0 /* String */);
	                type.declaredNumberIndexInfo = getIndexInfoOfSymbol(symbol, 1 /* Number */);
	            }
	            return type;
	        }
	        /**
	         * Indicates whether a type can be used as a late-bound name.
	         */
	        function isTypeUsableAsLateBoundName(type) {
	            return !!(type.flags & 1120 /* StringOrNumberLiteralOrUnique */);
	        }
	        /**
	         * Indicates whether a declaration name is definitely late-bindable.
	         * A declaration name is only late-bindable if:
	         * - It is a `ComputedPropertyName`.
	         * - Its expression is an `Identifier` or either a `PropertyAccessExpression` an
	         * `ElementAccessExpression` consisting only of these same three types of nodes.
	         * - The type of its expression is a string or numeric literal type, or is a `unique symbol` type.
	         */
	        function isLateBindableName(node) {
	            return ts.isComputedPropertyName(node)
	                && ts.isEntityNameExpression(node.expression)
	                && isTypeUsableAsLateBoundName(checkComputedPropertyName(node));
	        }
	        /**
	         * Indicates whether a declaration has a late-bindable dynamic name.
	         */
	        function hasLateBindableName(node) {
	            var name = ts.getNameOfDeclaration(node);
	            return name && isLateBindableName(name);
	        }
	        /**
	         * Indicates whether a declaration has a dynamic name that cannot be late-bound.
	         */
	        function hasNonBindableDynamicName(node) {
	            return ts.hasDynamicName(node) && !hasLateBindableName(node);
	        }
	        /**
	         * Indicates whether a declaration name is a dynamic name that cannot be late-bound.
	         */
	        function isNonBindableDynamicName(node) {
	            return ts.isDynamicName(node) && !isLateBindableName(node);
	        }
	        /**
	         * Gets the symbolic name for a late-bound member from its type.
	         */
	        function getLateBoundNameFromType(type) {
	            if (type.flags & 1024 /* UniqueESSymbol */) {
	                return "__@" + type.symbol.escapedName + "@" + getSymbolId(type.symbol);
	            }
	            if (type.flags & 96 /* StringOrNumberLiteral */) {
	                return ts.escapeLeadingUnderscores("" + type.value);
	            }
	        }
	        /**
	         * Adds a declaration to a late-bound dynamic member. This performs the same function for
	         * late-bound members that `addDeclarationToSymbol` in binder.ts performs for early-bound
	         * members.
	         */
	        function addDeclarationToLateBoundSymbol(symbol, member, symbolFlags) {
	            ts.Debug.assert(!!(ts.getCheckFlags(symbol) & 1024 /* Late */), "Expected a late-bound symbol.");
	            symbol.flags |= symbolFlags;
	            getSymbolLinks(member.symbol).lateSymbol = symbol;
	            if (!symbol.declarations) {
	                symbol.declarations = [member];
	            }
	            else {
	                symbol.declarations.push(member);
	            }
	            if (symbolFlags & 107455 /* Value */) {
	                var valueDeclaration = symbol.valueDeclaration;
	                if (!valueDeclaration || valueDeclaration.kind !== member.kind) {
	                    symbol.valueDeclaration = member;
	                }
	            }
	        }
	        /**
	         * Performs late-binding of a dynamic member. This performs the same function for
	         * late-bound members that `declareSymbol` in binder.ts performs for early-bound
	         * members.
	         *
	         * If a symbol is a dynamic name from a computed property, we perform an additional "late"
	         * binding phase to attempt to resolve the name for the symbol from the type of the computed
	         * property's expression. If the type of the expression is a string-literal, numeric-literal,
	         * or unique symbol type, we can use that type as the name of the symbol.
	         *
	         * For example, given:
	         *
	         *   const x = Symbol();
	         *
	         *   interface I {
	         *     [x]: number;
	         *   }
	         *
	         * The binder gives the property `[x]: number` a special symbol with the name "__computed".
	         * In the late-binding phase we can type-check the expression `x` and see that it has a
	         * unique symbol type which we can then use as the name of the member. This allows users
	         * to define custom symbols that can be used in the members of an object type.
	         *
	         * @param parent The containing symbol for the member.
	         * @param earlySymbols The early-bound symbols of the parent.
	         * @param lateSymbols The late-bound symbols of the parent.
	         * @param decl The member to bind.
	         */
	        function lateBindMember(parent, earlySymbols, lateSymbols, decl) {
	            ts.Debug.assert(!!decl.symbol, "The member is expected to have a symbol.");
	            var links = getNodeLinks(decl);
	            if (!links.resolvedSymbol) {
	                // In the event we attempt to resolve the late-bound name of this member recursively,
	                // fall back to the early-bound name of this member.
	                links.resolvedSymbol = decl.symbol;
	                var type = checkComputedPropertyName(decl.name);
	                if (isTypeUsableAsLateBoundName(type)) {
	                    var memberName = getLateBoundNameFromType(type);
	                    var symbolFlags = decl.symbol.flags;
	                    // Get or add a late-bound symbol for the member. This allows us to merge late-bound accessor declarations.
	                    var lateSymbol = lateSymbols.get(memberName);
	                    if (!lateSymbol)
	                        lateSymbols.set(memberName, lateSymbol = createSymbol(0 /* None */, memberName, 1024 /* Late */));
	                    // Report an error if a late-bound member has the same name as an early-bound member,
	                    // or if we have another early-bound symbol declaration with the same name and
	                    // conflicting flags.
	                    var earlySymbol = earlySymbols && earlySymbols.get(memberName);
	                    if (lateSymbol.flags & getExcludedSymbolFlags(symbolFlags) || earlySymbol) {
	                        // If we have an existing early-bound member, combine its declarations so that we can
	                        // report an error at each declaration.
	                        var declarations = earlySymbol ? ts.concatenate(earlySymbol.declarations, lateSymbol.declarations) : lateSymbol.declarations;
	                        var name_3 = ts.declarationNameToString(decl.name);
	                        ts.forEach(declarations, function (declaration) { return error(ts.getNameOfDeclaration(declaration) || declaration, ts.Diagnostics.Duplicate_declaration_0, name_3); });
	                        error(decl.name || decl, ts.Diagnostics.Duplicate_declaration_0, name_3);
	                        lateSymbol = createSymbol(0 /* None */, memberName, 1024 /* Late */);
	                    }
	                    addDeclarationToLateBoundSymbol(lateSymbol, decl, symbolFlags);
	                    lateSymbol.parent = parent;
	                    return links.resolvedSymbol = lateSymbol;
	                }
	            }
	            return links.resolvedSymbol;
	        }
	        function getResolvedMembersOrExportsOfSymbol(symbol, resolutionKind) {
	            var links = getSymbolLinks(symbol);
	            if (!links[resolutionKind]) {
	                var isStatic = resolutionKind === "resolvedExports" /* resolvedExports */;
	                var earlySymbols = !isStatic ? symbol.members :
	                    symbol.flags & 1536 /* Module */ ? getExportsOfModuleWorker(symbol) :
	                        symbol.exports;
	                // In the event we recursively resolve the members/exports of the symbol, we
	                // set the initial value of resolvedMembers/resolvedExports to the early-bound
	                // members/exports of the symbol.
	                links[resolutionKind] = earlySymbols || emptySymbols;
	                // fill in any as-yet-unresolved late-bound members.
	                var lateSymbols = ts.createSymbolTable();
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var members = ts.getMembersOfDeclaration(decl);
	                    if (members) {
	                        for (var _b = 0, members_3 = members; _b < members_3.length; _b++) {
	                            var member = members_3[_b];
	                            if (isStatic === ts.hasStaticModifier(member) && hasLateBindableName(member)) {
	                                lateBindMember(symbol, earlySymbols, lateSymbols, member);
	                            }
	                        }
	                    }
	                }
	                links[resolutionKind] = combineSymbolTables(earlySymbols, lateSymbols) || emptySymbols;
	            }
	            return links[resolutionKind];
	        }
	        /**
	         * Gets a SymbolTable containing both the early- and late-bound members of a symbol.
	         *
	         * For a description of late-binding, see `lateBindMember`.
	         */
	        function getMembersOfSymbol(symbol) {
	            return symbol.flags & 6240 /* LateBindingContainer */
	                ? getResolvedMembersOrExportsOfSymbol(symbol, "resolvedMembers" /* resolvedMembers */)
	                : symbol.members || emptySymbols;
	        }
	        /**
	         * If a symbol is the dynamic name of the member of an object type, get the late-bound
	         * symbol of the member.
	         *
	         * For a description of late-binding, see `lateBindMember`.
	         */
	        function getLateBoundSymbol(symbol) {
	            if (symbol.flags & 106500 /* ClassMember */ && symbol.escapedName === "__computed" /* Computed */) {
	                var links = getSymbolLinks(symbol);
	                if (!links.lateSymbol && ts.some(symbol.declarations, hasLateBindableName)) {
	                    // force late binding of members/exports. This will set the late-bound symbol
	                    if (ts.some(symbol.declarations, ts.hasStaticModifier)) {
	                        getExportsOfSymbol(symbol.parent);
	                    }
	                    else {
	                        getMembersOfSymbol(symbol.parent);
	                    }
	                }
	                return links.lateSymbol || (links.lateSymbol = symbol);
	            }
	            return symbol;
	        }
	        function getTypeWithThisArgument(type, thisArgument, needApparentType) {
	            if (ts.getObjectFlags(type) & 4 /* Reference */) {
	                var target = type.target;
	                var typeArguments = type.typeArguments;
	                if (ts.length(target.typeParameters) === ts.length(typeArguments)) {
	                    var ref = createTypeReference(target, ts.concatenate(typeArguments, [thisArgument || target.thisType]));
	                    return needApparentType ? getApparentType(ref) : ref;
	                }
	            }
	            else if (type.flags & 262144 /* Intersection */) {
	                return getIntersectionType(ts.map(type.types, function (t) { return getTypeWithThisArgument(t, thisArgument, needApparentType); }));
	            }
	            return needApparentType ? getApparentType(type) : type;
	        }
	        function resolveObjectTypeMembers(type, source, typeParameters, typeArguments) {
	            var mapper;
	            var members;
	            var callSignatures;
	            var constructSignatures;
	            var stringIndexInfo;
	            var numberIndexInfo;
	            if (ts.rangeEquals(typeParameters, typeArguments, 0, typeParameters.length)) {
	                mapper = identityMapper;
	                members = source.symbol ? getMembersOfSymbol(source.symbol) : ts.createSymbolTable(source.declaredProperties);
	                callSignatures = source.declaredCallSignatures;
	                constructSignatures = source.declaredConstructSignatures;
	                stringIndexInfo = source.declaredStringIndexInfo;
	                numberIndexInfo = source.declaredNumberIndexInfo;
	            }
	            else {
	                mapper = createTypeMapper(typeParameters, typeArguments);
	                members = createInstantiatedSymbolTable(source.declaredProperties, mapper, /*mappingThisOnly*/ typeParameters.length === 1);
	                callSignatures = instantiateSignatures(source.declaredCallSignatures, mapper);
	                constructSignatures = instantiateSignatures(source.declaredConstructSignatures, mapper);
	                stringIndexInfo = instantiateIndexInfo(source.declaredStringIndexInfo, mapper);
	                numberIndexInfo = instantiateIndexInfo(source.declaredNumberIndexInfo, mapper);
	            }
	            var baseTypes = getBaseTypes(source);
	            if (baseTypes.length) {
	                if (source.symbol && members === getMembersOfSymbol(source.symbol)) {
	                    members = ts.createSymbolTable(source.declaredProperties);
	                }
	                setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	                var thisArgument = ts.lastOrUndefined(typeArguments);
	                for (var _i = 0, baseTypes_1 = baseTypes; _i < baseTypes_1.length; _i++) {
	                    var baseType = baseTypes_1[_i];
	                    var instantiatedBaseType = thisArgument ? getTypeWithThisArgument(instantiateType(baseType, mapper), thisArgument) : baseType;
	                    addInheritedMembers(members, getPropertiesOfType(instantiatedBaseType));
	                    callSignatures = ts.concatenate(callSignatures, getSignaturesOfType(instantiatedBaseType, 0 /* Call */));
	                    constructSignatures = ts.concatenate(constructSignatures, getSignaturesOfType(instantiatedBaseType, 1 /* Construct */));
	                    if (!stringIndexInfo) {
	                        stringIndexInfo = instantiatedBaseType === anyType ?
	                            createIndexInfo(anyType, /*isReadonly*/ false) :
	                            getIndexInfoOfType(instantiatedBaseType, 0 /* String */);
	                    }
	                    numberIndexInfo = numberIndexInfo || getIndexInfoOfType(instantiatedBaseType, 1 /* Number */);
	                }
	            }
	            setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	        }
	        function resolveClassOrInterfaceMembers(type) {
	            resolveObjectTypeMembers(type, resolveDeclaredMembers(type), ts.emptyArray, ts.emptyArray);
	        }
	        function resolveTypeReferenceMembers(type) {
	            var source = resolveDeclaredMembers(type.target);
	            var typeParameters = ts.concatenate(source.typeParameters, [source.thisType]);
	            var typeArguments = type.typeArguments && type.typeArguments.length === typeParameters.length ?
	                type.typeArguments : ts.concatenate(type.typeArguments, [type]);
	            resolveObjectTypeMembers(type, source, typeParameters, typeArguments);
	        }
	        function createSignature(declaration, typeParameters, thisParameter, parameters, resolvedReturnType, resolvedTypePredicate, minArgumentCount, hasRestParameter, hasLiteralTypes) {
	            var sig = new Signature(checker);
	            sig.declaration = declaration;
	            sig.typeParameters = typeParameters;
	            sig.parameters = parameters;
	            sig.thisParameter = thisParameter;
	            sig.resolvedReturnType = resolvedReturnType;
	            sig.resolvedTypePredicate = resolvedTypePredicate;
	            sig.minArgumentCount = minArgumentCount;
	            sig.hasRestParameter = hasRestParameter;
	            sig.hasLiteralTypes = hasLiteralTypes;
	            sig.target = undefined;
	            sig.mapper = undefined;
	            return sig;
	        }
	        function cloneSignature(sig) {
	            return createSignature(sig.declaration, sig.typeParameters, sig.thisParameter, sig.parameters, /*resolvedReturnType*/ undefined, 
	            /*resolvedTypePredicate*/ undefined, sig.minArgumentCount, sig.hasRestParameter, sig.hasLiteralTypes);
	        }
	        function getDefaultConstructSignatures(classType) {
	            var baseConstructorType = getBaseConstructorTypeOfClass(classType);
	            var baseSignatures = getSignaturesOfType(baseConstructorType, 1 /* Construct */);
	            if (baseSignatures.length === 0) {
	                return [createSignature(undefined, classType.localTypeParameters, undefined, ts.emptyArray, classType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false)];
	            }
	            var baseTypeNode = getBaseTypeNodeOfClass(classType);
	            var isJavaScript = ts.isInJavaScriptFile(baseTypeNode);
	            var typeArguments = typeArgumentsFromTypeReferenceNode(baseTypeNode);
	            var typeArgCount = ts.length(typeArguments);
	            var result = [];
	            for (var _i = 0, baseSignatures_1 = baseSignatures; _i < baseSignatures_1.length; _i++) {
	                var baseSig = baseSignatures_1[_i];
	                var minTypeArgumentCount = getMinTypeArgumentCount(baseSig.typeParameters);
	                var typeParamCount = ts.length(baseSig.typeParameters);
	                if (isJavaScript || typeArgCount >= minTypeArgumentCount && typeArgCount <= typeParamCount) {
	                    var sig = typeParamCount ? createSignatureInstantiation(baseSig, fillMissingTypeArguments(typeArguments, baseSig.typeParameters, minTypeArgumentCount, isJavaScript)) : cloneSignature(baseSig);
	                    sig.typeParameters = classType.localTypeParameters;
	                    sig.resolvedReturnType = classType;
	                    result.push(sig);
	                }
	            }
	            return result;
	        }
	        function findMatchingSignature(signatureList, signature, partialMatch, ignoreThisTypes, ignoreReturnTypes) {
	            for (var _i = 0, signatureList_1 = signatureList; _i < signatureList_1.length; _i++) {
	                var s = signatureList_1[_i];
	                if (compareSignaturesIdentical(s, signature, partialMatch, ignoreThisTypes, ignoreReturnTypes, compareTypesIdentical)) {
	                    return s;
	                }
	            }
	        }
	        function findMatchingSignatures(signatureLists, signature, listIndex) {
	            if (signature.typeParameters) {
	                // We require an exact match for generic signatures, so we only return signatures from the first
	                // signature list and only if they have exact matches in the other signature lists.
	                if (listIndex > 0) {
	                    return undefined;
	                }
	                for (var i = 1; i < signatureLists.length; i++) {
	                    if (!findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false)) {
	                        return undefined;
	                    }
	                }
	                return [signature];
	            }
	            var result = undefined;
	            for (var i = 0; i < signatureLists.length; i++) {
	                // Allow matching non-generic signatures to have excess parameters and different return types
	                var match = i === listIndex ? signature : findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ true, /*ignoreThisTypes*/ true, /*ignoreReturnTypes*/ true);
	                if (!match) {
	                    return undefined;
	                }
	                result = ts.appendIfUnique(result, match);
	            }
	            return result;
	        }
	        // The signatures of a union type are those signatures that are present in each of the constituent types.
	        // Generic signatures must match exactly, but non-generic signatures are allowed to have extra optional
	        // parameters and may differ in return types. When signatures differ in return types, the resulting return
	        // type is the union of the constituent return types.
	        function getUnionSignatures(types, kind) {
	            var signatureLists = ts.map(types, function (t) { return getSignaturesOfType(t, kind); });
	            var result = undefined;
	            for (var i = 0; i < signatureLists.length; i++) {
	                for (var _i = 0, _a = signatureLists[i]; _i < _a.length; _i++) {
	                    var signature = _a[_i];
	                    // Only process signatures with parameter lists that aren't already in the result list
	                    if (!result || !findMatchingSignature(result, signature, /*partialMatch*/ false, /*ignoreThisTypes*/ true, /*ignoreReturnTypes*/ true)) {
	                        var unionSignatures = findMatchingSignatures(signatureLists, signature, i);
	                        if (unionSignatures) {
	                            var s = signature;
	                            // Union the result types when more than one signature matches
	                            if (unionSignatures.length > 1) {
	                                var thisParameter = signature.thisParameter;
	                                if (ts.forEach(unionSignatures, function (sig) { return sig.thisParameter; })) {
	                                    var thisType = getUnionType(ts.map(unionSignatures, function (sig) { return sig.thisParameter ? getTypeOfSymbol(sig.thisParameter) : anyType; }), 2 /* Subtype */);
	                                    thisParameter = createSymbolWithType(signature.thisParameter, thisType);
	                                }
	                                s = cloneSignature(signature);
	                                s.thisParameter = thisParameter;
	                                s.unionSignatures = unionSignatures;
	                            }
	                            (result || (result = [])).push(s);
	                        }
	                    }
	                }
	            }
	            return result || ts.emptyArray;
	        }
	        function getUnionIndexInfo(types, kind) {
	            var indexTypes = [];
	            var isAnyReadonly = false;
	            for (var _i = 0, types_2 = types; _i < types_2.length; _i++) {
	                var type = types_2[_i];
	                var indexInfo = getIndexInfoOfType(type, kind);
	                if (!indexInfo) {
	                    return undefined;
	                }
	                indexTypes.push(indexInfo.type);
	                isAnyReadonly = isAnyReadonly || indexInfo.isReadonly;
	            }
	            return createIndexInfo(getUnionType(indexTypes, 2 /* Subtype */), isAnyReadonly);
	        }
	        function resolveUnionTypeMembers(type) {
	            // The members and properties collections are empty for union types. To get all properties of a union
	            // type use getPropertiesOfType (only the language service uses this).
	            var callSignatures = getUnionSignatures(type.types, 0 /* Call */);
	            var constructSignatures = getUnionSignatures(type.types, 1 /* Construct */);
	            var stringIndexInfo = getUnionIndexInfo(type.types, 0 /* String */);
	            var numberIndexInfo = getUnionIndexInfo(type.types, 1 /* Number */);
	            setStructuredTypeMembers(type, emptySymbols, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	        }
	        function intersectTypes(type1, type2) {
	            return !type1 ? type2 : !type2 ? type1 : getIntersectionType([type1, type2]);
	        }
	        function intersectIndexInfos(info1, info2) {
	            return !info1 ? info2 : !info2 ? info1 : createIndexInfo(getIntersectionType([info1.type, info2.type]), info1.isReadonly && info2.isReadonly);
	        }
	        function unionSpreadIndexInfos(info1, info2) {
	            return info1 && info2 && createIndexInfo(getUnionType([info1.type, info2.type]), info1.isReadonly || info2.isReadonly);
	        }
	        function includeMixinType(type, types, index) {
	            var mixedTypes = [];
	            for (var i = 0; i < types.length; i++) {
	                if (i === index) {
	                    mixedTypes.push(type);
	                }
	                else if (isMixinConstructorType(types[i])) {
	                    mixedTypes.push(getReturnTypeOfSignature(getSignaturesOfType(types[i], 1 /* Construct */)[0]));
	                }
	            }
	            return getIntersectionType(mixedTypes);
	        }
	        function resolveIntersectionTypeMembers(type) {
	            // The members and properties collections are empty for intersection types. To get all properties of an
	            // intersection type use getPropertiesOfType (only the language service uses this).
	            var callSignatures = ts.emptyArray;
	            var constructSignatures = ts.emptyArray;
	            var stringIndexInfo;
	            var numberIndexInfo;
	            var types = type.types;
	            var mixinCount = ts.countWhere(types, isMixinConstructorType);
	            var _loop_3 = function (i) {
	                var t = type.types[i];
	                // When an intersection type contains mixin constructor types, the construct signatures from
	                // those types are discarded and their return types are mixed into the return types of all
	                // other construct signatures in the intersection type. For example, the intersection type
	                // '{ new(...args: any[]) => A } & { new(s: string) => B }' has a single construct signature
	                // 'new(s: string) => A & B'.
	                if (mixinCount === 0 || mixinCount === types.length && i === 0 || !isMixinConstructorType(t)) {
	                    var signatures = getSignaturesOfType(t, 1 /* Construct */);
	                    if (signatures.length && mixinCount > 0) {
	                        signatures = ts.map(signatures, function (s) {
	                            var clone = cloneSignature(s);
	                            clone.resolvedReturnType = includeMixinType(getReturnTypeOfSignature(s), types, i);
	                            return clone;
	                        });
	                    }
	                    constructSignatures = ts.concatenate(constructSignatures, signatures);
	                }
	                callSignatures = ts.concatenate(callSignatures, getSignaturesOfType(t, 0 /* Call */));
	                stringIndexInfo = intersectIndexInfos(stringIndexInfo, getIndexInfoOfType(t, 0 /* String */));
	                numberIndexInfo = intersectIndexInfos(numberIndexInfo, getIndexInfoOfType(t, 1 /* Number */));
	            };
	            for (var i = 0; i < types.length; i++) {
	                _loop_3(i);
	            }
	            setStructuredTypeMembers(type, emptySymbols, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	        }
	        /**
	         * Converts an AnonymousType to a ResolvedType.
	         */
	        function resolveAnonymousTypeMembers(type) {
	            var symbol = type.symbol;
	            if (type.target) {
	                var members = createInstantiatedSymbolTable(getPropertiesOfObjectType(type.target), type.mapper, /*mappingThisOnly*/ false);
	                var callSignatures = instantiateSignatures(getSignaturesOfType(type.target, 0 /* Call */), type.mapper);
	                var constructSignatures = instantiateSignatures(getSignaturesOfType(type.target, 1 /* Construct */), type.mapper);
	                var stringIndexInfo = instantiateIndexInfo(getIndexInfoOfType(type.target, 0 /* String */), type.mapper);
	                var numberIndexInfo = instantiateIndexInfo(getIndexInfoOfType(type.target, 1 /* Number */), type.mapper);
	                setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	            }
	            else if (symbol.flags & 2048 /* TypeLiteral */) {
	                var members = getMembersOfSymbol(symbol);
	                var callSignatures = getSignaturesOfSymbol(members.get("__call" /* Call */));
	                var constructSignatures = getSignaturesOfSymbol(members.get("__new" /* New */));
	                var stringIndexInfo = getIndexInfoOfSymbol(symbol, 0 /* String */);
	                var numberIndexInfo = getIndexInfoOfSymbol(symbol, 1 /* Number */);
	                setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	            }
	            else {
	                // Combinations of function, class, enum and module
	                var members = emptySymbols;
	                var stringIndexInfo = undefined;
	                if (symbol.exports) {
	                    members = getExportsOfSymbol(symbol);
	                }
	                setStructuredTypeMembers(type, members, ts.emptyArray, ts.emptyArray, undefined, undefined);
	                if (symbol.flags & 32 /* Class */) {
	                    var classType = getDeclaredTypeOfClassOrInterface(symbol);
	                    var baseConstructorType = getBaseConstructorTypeOfClass(classType);
	                    if (baseConstructorType.flags & (65536 /* Object */ | 262144 /* Intersection */ | 1081344 /* TypeVariable */)) {
	                        members = ts.createSymbolTable(getNamedMembers(members));
	                        addInheritedMembers(members, getPropertiesOfType(baseConstructorType));
	                    }
	                    else if (baseConstructorType === anyType) {
	                        stringIndexInfo = createIndexInfo(anyType, /*isReadonly*/ false);
	                    }
	                }
	                var numberIndexInfo = symbol.flags & 384 /* Enum */ ? enumNumberIndexInfo : undefined;
	                setStructuredTypeMembers(type, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, numberIndexInfo);
	                // We resolve the members before computing the signatures because a signature may use
	                // typeof with a qualified name expression that circularly references the type we are
	                // in the process of resolving (see issue #6072). The temporarily empty signature list
	                // will never be observed because a qualified name can't reference signatures.
	                if (symbol.flags & (16 /* Function */ | 8192 /* Method */)) {
	                    type.callSignatures = getSignaturesOfSymbol(symbol);
	                }
	                // And likewise for construct signatures for classes
	                if (symbol.flags & 32 /* Class */) {
	                    var classType = getDeclaredTypeOfClassOrInterface(symbol);
	                    var constructSignatures = getSignaturesOfSymbol(symbol.members.get("__constructor" /* Constructor */));
	                    if (!constructSignatures.length) {
	                        constructSignatures = getDefaultConstructSignatures(classType);
	                    }
	                    type.constructSignatures = constructSignatures;
	                }
	            }
	        }
	        function resolveReverseMappedTypeMembers(type) {
	            var indexInfo = getIndexInfoOfType(type.source, 0 /* String */);
	            var modifiers = getMappedTypeModifiers(type.mappedType);
	            var readonlyMask = modifiers & 1 /* IncludeReadonly */ ? false : true;
	            var optionalMask = modifiers & 4 /* IncludeOptional */ ? 0 : 16777216 /* Optional */;
	            var stringIndexInfo = indexInfo && createIndexInfo(inferReverseMappedType(indexInfo.type, type.mappedType), readonlyMask && indexInfo.isReadonly);
	            var members = ts.createSymbolTable();
	            for (var _i = 0, _a = getPropertiesOfType(type.source); _i < _a.length; _i++) {
	                var prop = _a[_i];
	                var checkFlags = 2048 /* ReverseMapped */ | (readonlyMask && isReadonlySymbol(prop) ? 8 /* Readonly */ : 0);
	                var inferredProp = createSymbol(4 /* Property */ | prop.flags & optionalMask, prop.escapedName, checkFlags);
	                inferredProp.declarations = prop.declarations;
	                inferredProp.propertyType = getTypeOfSymbol(prop);
	                inferredProp.mappedType = type.mappedType;
	                members.set(prop.escapedName, inferredProp);
	            }
	            setStructuredTypeMembers(type, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, undefined);
	        }
	        /** Resolve the members of a mapped type { [P in K]: T } */
	        function resolveMappedTypeMembers(type) {
	            var members = ts.createSymbolTable();
	            var stringIndexInfo;
	            // Resolve upfront such that recursive references see an empty object type.
	            setStructuredTypeMembers(type, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	            // In { [P in K]: T }, we refer to P as the type parameter type, K as the constraint type,
	            // and T as the template type.
	            var typeParameter = getTypeParameterFromMappedType(type);
	            var constraintType = getConstraintTypeFromMappedType(type);
	            var templateType = getTemplateTypeFromMappedType(type.target || type);
	            var modifiersType = getApparentType(getModifiersTypeFromMappedType(type)); // The 'T' in 'keyof T'
	            var templateModifiers = getMappedTypeModifiers(type);
	            var constraintDeclaration = type.declaration.typeParameter.constraint;
	            if (constraintDeclaration.kind === 174 /* TypeOperator */ &&
	                constraintDeclaration.operator === 128 /* KeyOfKeyword */) {
	                // We have a { [P in keyof T]: X }
	                for (var _i = 0, _a = getPropertiesOfType(modifiersType); _i < _a.length; _i++) {
	                    var propertySymbol = _a[_i];
	                    addMemberForKeyType(getLiteralTypeFromPropertyName(propertySymbol), propertySymbol);
	                }
	                if (modifiersType.flags & 1 /* Any */ || getIndexInfoOfType(modifiersType, 0 /* String */)) {
	                    addMemberForKeyType(stringType);
	                }
	            }
	            else {
	                // First, if the constraint type is a type parameter, obtain the base constraint. Then,
	                // if the key type is a 'keyof X', obtain 'keyof C' where C is the base constraint of X.
	                // Finally, iterate over the constituents of the resulting iteration type.
	                var keyType = constraintType.flags & 7372800 /* InstantiableNonPrimitive */ ? getApparentType(constraintType) : constraintType;
	                var iterationType = keyType.flags & 524288 /* Index */ ? getIndexType(getApparentType(keyType.type)) : keyType;
	                forEachType(iterationType, addMemberForKeyType);
	            }
	            setStructuredTypeMembers(type, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, undefined);
	            function addMemberForKeyType(t, propertySymbolOrIndex) {
	                var propertySymbol;
	                // forEachType delegates to forEach, which calls with a numeric second argument
	                //  the type system currently doesn't catch this incompatibility, so we annotate
	                //  the function ourselves to indicate the runtime behavior and deal with it here
	                if (typeof propertySymbolOrIndex === "object") {
	                    propertySymbol = propertySymbolOrIndex;
	                }
	                // Create a mapper from T to the current iteration type constituent. Then, if the
	                // mapped type is itself an instantiated type, combine the iteration mapper with the
	                // instantiation mapper.
	                var iterationMapper = createTypeMapper([typeParameter], [t]);
	                var templateMapper = type.mapper ? combineTypeMappers(type.mapper, iterationMapper) : iterationMapper;
	                var propType = instantiateType(templateType, templateMapper);
	                // If the current iteration type constituent is a string literal type, create a property.
	                // Otherwise, for type string create a string index signature.
	                if (t.flags & 32 /* StringLiteral */) {
	                    var propName = ts.escapeLeadingUnderscores(t.value);
	                    var modifiersProp = getPropertyOfType(modifiersType, propName);
	                    var isOptional = !!(templateModifiers & 4 /* IncludeOptional */ ||
	                        !(templateModifiers & 8 /* ExcludeOptional */) && modifiersProp && modifiersProp.flags & 16777216 /* Optional */);
	                    var isReadonly = !!(templateModifiers & 1 /* IncludeReadonly */ ||
	                        !(templateModifiers & 2 /* ExcludeReadonly */) && modifiersProp && isReadonlySymbol(modifiersProp));
	                    var prop = createSymbol(4 /* Property */ | (isOptional ? 16777216 /* Optional */ : 0), propName, isReadonly ? 8 /* Readonly */ : 0);
	                    // When creating an optional property in strictNullChecks mode, if 'undefined' isn't assignable to the
	                    // type, we include 'undefined' in the type. Similarly, when creating a non-optional property in strictNullChecks
	                    // mode, if the underlying property is optional we remove 'undefined' from the type.
	                    prop.type = strictNullChecks && isOptional && !isTypeAssignableTo(undefinedType, propType) ? getOptionalType(propType) :
	                        strictNullChecks && !isOptional && modifiersProp && modifiersProp.flags & 16777216 /* Optional */ ? getTypeWithFacts(propType, 131072 /* NEUndefined */) :
	                            propType;
	                    if (propertySymbol) {
	                        prop.syntheticOrigin = propertySymbol;
	                        prop.declarations = propertySymbol.declarations;
	                    }
	                    prop.syntheticLiteralTypeOrigin = t;
	                    members.set(propName, prop);
	                }
	                else if (t.flags & (1 /* Any */ | 2 /* String */)) {
	                    stringIndexInfo = createIndexInfo(propType, !!(templateModifiers & 1 /* IncludeReadonly */));
	                }
	            }
	        }
	        function getTypeParameterFromMappedType(type) {
	            return type.typeParameter ||
	                (type.typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfNode(type.declaration.typeParameter)));
	        }
	        function getConstraintTypeFromMappedType(type) {
	            return type.constraintType ||
	                (type.constraintType = instantiateType(getConstraintOfTypeParameter(getTypeParameterFromMappedType(type)), type.mapper || identityMapper) || unknownType);
	        }
	        function getTemplateTypeFromMappedType(type) {
	            return type.templateType ||
	                (type.templateType = type.declaration.type ?
	                    instantiateType(addOptionality(getTypeFromTypeNode(type.declaration.type), !!(getMappedTypeModifiers(type) & 4 /* IncludeOptional */)), type.mapper || identityMapper) :
	                    unknownType);
	        }
	        function getModifiersTypeFromMappedType(type) {
	            if (!type.modifiersType) {
	                var constraintDeclaration = type.declaration.typeParameter.constraint;
	                if (constraintDeclaration.kind === 174 /* TypeOperator */ &&
	                    constraintDeclaration.operator === 128 /* KeyOfKeyword */) {
	                    // If the constraint declaration is a 'keyof T' node, the modifiers type is T. We check
	                    // AST nodes here because, when T is a non-generic type, the logic below eagerly resolves
	                    // 'keyof T' to a literal union type and we can't recover T from that type.
	                    type.modifiersType = instantiateType(getTypeFromTypeNode(constraintDeclaration.type), type.mapper || identityMapper);
	                }
	                else {
	                    // Otherwise, get the declared constraint type, and if the constraint type is a type parameter,
	                    // get the constraint of that type parameter. If the resulting type is an indexed type 'keyof T',
	                    // the modifiers type is T. Otherwise, the modifiers type is {}.
	                    var declaredType = getTypeFromMappedTypeNode(type.declaration);
	                    var constraint = getConstraintTypeFromMappedType(declaredType);
	                    var extendedConstraint = constraint && constraint.flags & 32768 /* TypeParameter */ ? getConstraintOfTypeParameter(constraint) : constraint;
	                    type.modifiersType = extendedConstraint && extendedConstraint.flags & 524288 /* Index */ ? instantiateType(extendedConstraint.type, type.mapper || identityMapper) : emptyObjectType;
	                }
	            }
	            return type.modifiersType;
	        }
	        function getMappedTypeModifiers(type) {
	            var declaration = type.declaration;
	            return (declaration.readonlyToken ? declaration.readonlyToken.kind === 38 /* MinusToken */ ? 2 /* ExcludeReadonly */ : 1 /* IncludeReadonly */ : 0) |
	                (declaration.questionToken ? declaration.questionToken.kind === 38 /* MinusToken */ ? 8 /* ExcludeOptional */ : 4 /* IncludeOptional */ : 0);
	        }
	        function getMappedTypeOptionality(type) {
	            var modifiers = getMappedTypeModifiers(type);
	            return modifiers & 8 /* ExcludeOptional */ ? -1 : modifiers & 4 /* IncludeOptional */ ? 1 : 0;
	        }
	        function getCombinedMappedTypeOptionality(type) {
	            var optionality = getMappedTypeOptionality(type);
	            var modifiersType = getModifiersTypeFromMappedType(type);
	            return optionality || (isGenericMappedType(modifiersType) ? getMappedTypeOptionality(modifiersType) : 0);
	        }
	        function isPartialMappedType(type) {
	            return !!(ts.getObjectFlags(type) & 32 /* Mapped */ && getMappedTypeModifiers(type) & 4 /* IncludeOptional */);
	        }
	        function isGenericMappedType(type) {
	            return ts.getObjectFlags(type) & 32 /* Mapped */ && isGenericIndexType(getConstraintTypeFromMappedType(type));
	        }
	        function resolveStructuredTypeMembers(type) {
	            if (!type.members) {
	                if (type.flags & 65536 /* Object */) {
	                    if (type.objectFlags & 4 /* Reference */) {
	                        resolveTypeReferenceMembers(type);
	                    }
	                    else if (type.objectFlags & 3 /* ClassOrInterface */) {
	                        resolveClassOrInterfaceMembers(type);
	                    }
	                    else if (type.objectFlags & 2048 /* ReverseMapped */) {
	                        resolveReverseMappedTypeMembers(type);
	                    }
	                    else if (type.objectFlags & 16 /* Anonymous */) {
	                        resolveAnonymousTypeMembers(type);
	                    }
	                    else if (type.objectFlags & 32 /* Mapped */) {
	                        resolveMappedTypeMembers(type);
	                    }
	                }
	                else if (type.flags & 131072 /* Union */) {
	                    resolveUnionTypeMembers(type);
	                }
	                else if (type.flags & 262144 /* Intersection */) {
	                    resolveIntersectionTypeMembers(type);
	                }
	            }
	            return type;
	        }
	        /** Return properties of an object type or an empty array for other types */
	        function getPropertiesOfObjectType(type) {
	            if (type.flags & 65536 /* Object */) {
	                return resolveStructuredTypeMembers(type).properties;
	            }
	            return ts.emptyArray;
	        }
	        /** If the given type is an object type and that type has a property by the given name,
	         * return the symbol for that property. Otherwise return undefined.
	         */
	        function getPropertyOfObjectType(type, name) {
	            if (type.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                var symbol = resolved.members.get(name);
	                if (symbol && symbolIsValue(symbol)) {
	                    return symbol;
	                }
	            }
	        }
	        function getPropertiesOfUnionOrIntersectionType(type) {
	            if (!type.resolvedProperties) {
	                var members = ts.createSymbolTable();
	                for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                    var current = _a[_i];
	                    for (var _b = 0, _c = getPropertiesOfType(current); _b < _c.length; _b++) {
	                        var prop = _c[_b];
	                        if (!members.has(prop.escapedName)) {
	                            var combinedProp = getPropertyOfUnionOrIntersectionType(type, prop.escapedName);
	                            if (combinedProp) {
	                                members.set(prop.escapedName, combinedProp);
	                            }
	                        }
	                    }
	                    // The properties of a union type are those that are present in all constituent types, so
	                    // we only need to check the properties of the first type
	                    if (type.flags & 131072 /* Union */) {
	                        break;
	                    }
	                }
	                type.resolvedProperties = getNamedMembers(members);
	            }
	            return type.resolvedProperties;
	        }
	        function getPropertiesOfType(type) {
	            type = getApparentType(type);
	            return type.flags & 393216 /* UnionOrIntersection */ ?
	                getPropertiesOfUnionOrIntersectionType(type) :
	                getPropertiesOfObjectType(type);
	        }
	        function getAllPossiblePropertiesOfTypes(types) {
	            var unionType = getUnionType(types);
	            if (!(unionType.flags & 131072 /* Union */)) {
	                return getAugmentedPropertiesOfType(unionType);
	            }
	            var props = ts.createSymbolTable();
	            for (var _i = 0, types_3 = types; _i < types_3.length; _i++) {
	                var memberType = types_3[_i];
	                for (var _a = 0, _b = getAugmentedPropertiesOfType(memberType); _a < _b.length; _a++) {
	                    var escapedName = _b[_a].escapedName;
	                    if (!props.has(escapedName)) {
	                        var prop = createUnionOrIntersectionProperty(unionType, escapedName);
	                        // May be undefined if the property is private
	                        if (prop)
	                            props.set(escapedName, prop);
	                    }
	                }
	            }
	            return ts.arrayFrom(props.values());
	        }
	        function getConstraintOfType(type) {
	            return type.flags & 32768 /* TypeParameter */ ? getConstraintOfTypeParameter(type) :
	                type.flags & 1048576 /* IndexedAccess */ ? getConstraintOfIndexedAccess(type) :
	                    type.flags & 2097152 /* Conditional */ ? getConstraintOfConditionalType(type) :
	                        getBaseConstraintOfType(type);
	        }
	        function getConstraintOfTypeParameter(typeParameter) {
	            return hasNonCircularBaseConstraint(typeParameter) ? getConstraintFromTypeParameter(typeParameter) : undefined;
	        }
	        function getConstraintOfIndexedAccess(type) {
	            var transformed = getSimplifiedIndexedAccessType(type);
	            if (transformed) {
	                return transformed;
	            }
	            var baseObjectType = getBaseConstraintOfType(type.objectType);
	            var baseIndexType = getBaseConstraintOfType(type.indexType);
	            if (baseIndexType === stringType && !getIndexInfoOfType(baseObjectType || type.objectType, 0 /* String */)) {
	                // getIndexedAccessType returns `any` for X[string] where X doesn't have an index signature.
	                // to avoid this, return `undefined`.
	                return undefined;
	            }
	            return baseObjectType || baseIndexType ? getIndexedAccessType(baseObjectType || type.objectType, baseIndexType || type.indexType) : undefined;
	        }
	        function getDefaultConstraintOfConditionalType(type) {
	            return getUnionType([type.trueType, type.falseType]);
	        }
	        function getConstraintOfDistributiveConditionalType(type) {
	            // Check if we have a conditional type of the form 'T extends U ? X : Y', where T is a constrained
	            // type parameter. If so, create an instantiation of the conditional type where T is replaced
	            // with its constraint. We do this because if the constraint is a union type it will be distributed
	            // over the conditional type and possibly reduced. For example, 'T extends undefined ? never : T'
	            // removes 'undefined' from T.
	            if (isDistributiveConditionalType(type)) {
	                var constraint = getConstraintOfType(type.checkType);
	                if (constraint) {
	                    var target = type.target || type;
	                    var mapper = createTypeMapper([target.checkType], [constraint]);
	                    var combinedMapper = type.mapper ? combineTypeMappers(mapper, type.mapper) : mapper;
	                    return instantiateType(target, combinedMapper);
	                }
	            }
	            return undefined;
	        }
	        function getConstraintOfConditionalType(type) {
	            return getConstraintOfDistributiveConditionalType(type) || getDefaultConstraintOfConditionalType(type);
	        }
	        function getBaseConstraintOfInstantiableNonPrimitiveUnionOrIntersection(type) {
	            if (type.flags & (7372800 /* InstantiableNonPrimitive */ | 393216 /* UnionOrIntersection */)) {
	                var constraint = getResolvedBaseConstraint(type);
	                if (constraint !== noConstraintType && constraint !== circularConstraintType) {
	                    return constraint;
	                }
	            }
	        }
	        function getBaseConstraintOfType(type) {
	            var constraint = getBaseConstraintOfInstantiableNonPrimitiveUnionOrIntersection(type);
	            if (!constraint && type.flags & 524288 /* Index */) {
	                return stringType;
	            }
	            return constraint;
	        }
	        /**
	         * This is similar to `getBaseConstraintOfType` except it returns the input type if there's no base constraint, instead of `undefined`
	         * It also doesn't map indexes to `string`, as where this is used this would be unneeded (and likely undesirable)
	         */
	        function getBaseConstraintOrType(type) {
	            return getBaseConstraintOfType(type) || type;
	        }
	        function hasNonCircularBaseConstraint(type) {
	            return getResolvedBaseConstraint(type) !== circularConstraintType;
	        }
	        /**
	         * Return the resolved base constraint of a type variable. The noConstraintType singleton is returned if the
	         * type variable has no constraint, and the circularConstraintType singleton is returned if the constraint
	         * circularly references the type variable.
	         */
	        function getResolvedBaseConstraint(type) {
	            var circular;
	            if (!type.resolvedBaseConstraint) {
	                var constraint = getBaseConstraint(type);
	                type.resolvedBaseConstraint = circular ? circularConstraintType : getTypeWithThisArgument(constraint || noConstraintType, type);
	            }
	            return type.resolvedBaseConstraint;
	            function getBaseConstraint(t) {
	                if (!pushTypeResolution(t, 4 /* ResolvedBaseConstraint */)) {
	                    circular = true;
	                    return undefined;
	                }
	                var result = computeBaseConstraint(t);
	                if (!popTypeResolution()) {
	                    circular = true;
	                    return undefined;
	                }
	                return result;
	            }
	            function computeBaseConstraint(t) {
	                if (t.flags & 32768 /* TypeParameter */) {
	                    var constraint = getConstraintFromTypeParameter(t);
	                    return t.isThisType || !constraint ?
	                        constraint :
	                        getBaseConstraint(constraint);
	                }
	                if (t.flags & 393216 /* UnionOrIntersection */) {
	                    var types = t.types;
	                    var baseTypes = [];
	                    for (var _i = 0, types_4 = types; _i < types_4.length; _i++) {
	                        var type_2 = types_4[_i];
	                        var baseType = getBaseConstraint(type_2);
	                        if (baseType) {
	                            baseTypes.push(baseType);
	                        }
	                    }
	                    return t.flags & 131072 /* Union */ && baseTypes.length === types.length ? getUnionType(baseTypes) :
	                        t.flags & 262144 /* Intersection */ && baseTypes.length ? getIntersectionType(baseTypes) :
	                            undefined;
	                }
	                if (t.flags & 524288 /* Index */) {
	                    return stringType;
	                }
	                if (t.flags & 1048576 /* IndexedAccess */) {
	                    var transformed = getSimplifiedIndexedAccessType(t);
	                    if (transformed) {
	                        return getBaseConstraint(transformed);
	                    }
	                    var baseObjectType = getBaseConstraint(t.objectType);
	                    var baseIndexType = getBaseConstraint(t.indexType);
	                    var baseIndexedAccess = baseObjectType && baseIndexType ? getIndexedAccessType(baseObjectType, baseIndexType) : undefined;
	                    return baseIndexedAccess && baseIndexedAccess !== unknownType ? getBaseConstraint(baseIndexedAccess) : undefined;
	                }
	                if (t.flags & 2097152 /* Conditional */) {
	                    return getBaseConstraint(getConstraintOfConditionalType(t));
	                }
	                if (t.flags & 4194304 /* Substitution */) {
	                    return getBaseConstraint(t.substitute);
	                }
	                if (isGenericMappedType(t)) {
	                    return emptyObjectType;
	                }
	                return t;
	            }
	        }
	        function getApparentTypeOfIntersectionType(type) {
	            return type.resolvedApparentType || (type.resolvedApparentType = getTypeWithThisArgument(type, type, /*apparentType*/ true));
	        }
	        function getResolvedTypeParameterDefault(typeParameter) {
	            if (!typeParameter.default) {
	                if (typeParameter.target) {
	                    var targetDefault = getResolvedTypeParameterDefault(typeParameter.target);
	                    typeParameter.default = targetDefault ? instantiateType(targetDefault, typeParameter.mapper) : noConstraintType;
	                }
	                else {
	                    // To block recursion, set the initial value to the resolvingDefaultType.
	                    typeParameter.default = resolvingDefaultType;
	                    var defaultDeclaration = typeParameter.symbol && ts.forEach(typeParameter.symbol.declarations, function (decl) { return ts.isTypeParameterDeclaration(decl) && decl.default; });
	                    var defaultType = defaultDeclaration ? getTypeFromTypeNode(defaultDeclaration) : noConstraintType;
	                    if (typeParameter.default === resolvingDefaultType) {
	                        // If we have not been called recursively, set the correct default type.
	                        typeParameter.default = defaultType;
	                    }
	                }
	            }
	            else if (typeParameter.default === resolvingDefaultType) {
	                // If we are called recursively for this type parameter, mark the default as circular.
	                typeParameter.default = circularConstraintType;
	            }
	            return typeParameter.default;
	        }
	        /**
	         * Gets the default type for a type parameter.
	         *
	         * If the type parameter is the result of an instantiation, this gets the instantiated
	         * default type of its target. If the type parameter has no default type or the default is
	         * circular, `undefined` is returned.
	         */
	        function getDefaultFromTypeParameter(typeParameter) {
	            var defaultType = getResolvedTypeParameterDefault(typeParameter);
	            return defaultType !== noConstraintType && defaultType !== circularConstraintType ? defaultType : undefined;
	        }
	        function hasNonCircularTypeParameterDefault(typeParameter) {
	            return getResolvedTypeParameterDefault(typeParameter) !== circularConstraintType;
	        }
	        /**
	         * Indicates whether the declaration of a typeParameter has a default type.
	         */
	        function hasTypeParameterDefault(typeParameter) {
	            return !!(typeParameter.symbol && ts.forEach(typeParameter.symbol.declarations, function (decl) { return ts.isTypeParameterDeclaration(decl) && decl.default; }));
	        }
	        /**
	         * For a type parameter, return the base constraint of the type parameter. For the string, number,
	         * boolean, and symbol primitive types, return the corresponding object types. Otherwise return the
	         * type itself. Note that the apparent type of a union type is the union type itself.
	         */
	        function getApparentType(type) {
	            var t = type.flags & 7897088 /* Instantiable */ ? getBaseConstraintOfType(type) || emptyObjectType : type;
	            return t.flags & 262144 /* Intersection */ ? getApparentTypeOfIntersectionType(t) :
	                t.flags & 524322 /* StringLike */ ? globalStringType :
	                    t.flags & 84 /* NumberLike */ ? globalNumberType :
	                        t.flags & 136 /* BooleanLike */ ? globalBooleanType :
	                            t.flags & 1536 /* ESSymbolLike */ ? getGlobalESSymbolType(/*reportErrors*/ languageVersion >= 2 /* ES2015 */) :
	                                t.flags & 134217728 /* NonPrimitive */ ? emptyObjectType :
	                                    t;
	        }
	        function createUnionOrIntersectionProperty(containingType, name) {
	            var props;
	            var isUnion = containingType.flags & 131072 /* Union */;
	            var excludeModifiers = isUnion ? 24 /* NonPublicAccessibilityModifier */ : 0;
	            // Flags we want to propagate to the result if they exist in all source symbols
	            var commonFlags = isUnion ? 0 /* None */ : 16777216 /* Optional */;
	            var syntheticFlag = 4 /* SyntheticMethod */;
	            var checkFlags = 0;
	            for (var _i = 0, _a = containingType.types; _i < _a.length; _i++) {
	                var current = _a[_i];
	                var type = getApparentType(current);
	                if (type !== unknownType) {
	                    var prop = getPropertyOfType(type, name);
	                    var modifiers = prop ? ts.getDeclarationModifierFlagsFromSymbol(prop) : 0;
	                    if (prop && !(modifiers & excludeModifiers)) {
	                        commonFlags &= prop.flags;
	                        props = ts.appendIfUnique(props, prop);
	                        checkFlags |= (isReadonlySymbol(prop) ? 8 /* Readonly */ : 0) |
	                            (!(modifiers & 24 /* NonPublicAccessibilityModifier */) ? 64 /* ContainsPublic */ : 0) |
	                            (modifiers & 16 /* Protected */ ? 128 /* ContainsProtected */ : 0) |
	                            (modifiers & 8 /* Private */ ? 256 /* ContainsPrivate */ : 0) |
	                            (modifiers & 32 /* Static */ ? 512 /* ContainsStatic */ : 0);
	                        if (!isMethodLike(prop)) {
	                            syntheticFlag = 2 /* SyntheticProperty */;
	                        }
	                    }
	                    else if (isUnion) {
	                        checkFlags |= 16 /* Partial */;
	                    }
	                }
	            }
	            if (!props) {
	                return undefined;
	            }
	            if (props.length === 1 && !(checkFlags & 16 /* Partial */)) {
	                return props[0];
	            }
	            var propTypes = [];
	            var declarations = [];
	            var commonType = undefined;
	            for (var _b = 0, props_1 = props; _b < props_1.length; _b++) {
	                var prop = props_1[_b];
	                if (prop.declarations) {
	                    ts.addRange(declarations, prop.declarations);
	                }
	                var type = getTypeOfSymbol(prop);
	                if (!commonType) {
	                    commonType = type;
	                }
	                else if (type !== commonType) {
	                    checkFlags |= 32 /* HasNonUniformType */;
	                }
	                propTypes.push(type);
	            }
	            var result = createSymbol(4 /* Property */ | commonFlags, name, syntheticFlag | checkFlags);
	            result.containingType = containingType;
	            result.declarations = declarations;
	            result.type = isUnion ? getUnionType(propTypes) : getIntersectionType(propTypes);
	            return result;
	        }
	        // Return the symbol for a given property in a union or intersection type, or undefined if the property
	        // does not exist in any constituent type. Note that the returned property may only be present in some
	        // constituents, in which case the isPartial flag is set when the containing type is union type. We need
	        // these partial properties when identifying discriminant properties, but otherwise they are filtered out
	        // and do not appear to be present in the union type.
	        function getUnionOrIntersectionProperty(type, name) {
	            var properties = type.propertyCache || (type.propertyCache = ts.createSymbolTable());
	            var property = properties.get(name);
	            if (!property) {
	                property = createUnionOrIntersectionProperty(type, name);
	                if (property) {
	                    properties.set(name, property);
	                }
	            }
	            return property;
	        }
	        function getPropertyOfUnionOrIntersectionType(type, name) {
	            var property = getUnionOrIntersectionProperty(type, name);
	            // We need to filter out partial properties in union types
	            return property && !(ts.getCheckFlags(property) & 16 /* Partial */) ? property : undefined;
	        }
	        /**
	         * Return the symbol for the property with the given name in the given type. Creates synthetic union properties when
	         * necessary, maps primitive types and type parameters are to their apparent types, and augments with properties from
	         * Object and Function as appropriate.
	         *
	         * @param type a type to look up property from
	         * @param name a name of property to look up in a given type
	         */
	        function getPropertyOfType(type, name) {
	            type = getApparentType(type);
	            if (type.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                var symbol = resolved.members.get(name);
	                if (symbol && symbolIsValue(symbol)) {
	                    return symbol;
	                }
	                if (resolved === anyFunctionType || resolved.callSignatures.length || resolved.constructSignatures.length) {
	                    var symbol_1 = getPropertyOfObjectType(globalFunctionType, name);
	                    if (symbol_1) {
	                        return symbol_1;
	                    }
	                }
	                return getPropertyOfObjectType(globalObjectType, name);
	            }
	            if (type.flags & 393216 /* UnionOrIntersection */) {
	                return getPropertyOfUnionOrIntersectionType(type, name);
	            }
	            return undefined;
	        }
	        function getSignaturesOfStructuredType(type, kind) {
	            if (type.flags & 458752 /* StructuredType */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                return kind === 0 /* Call */ ? resolved.callSignatures : resolved.constructSignatures;
	            }
	            return ts.emptyArray;
	        }
	        /**
	         * Return the signatures of the given kind in the given type. Creates synthetic union signatures when necessary and
	         * maps primitive types and type parameters are to their apparent types.
	         */
	        function getSignaturesOfType(type, kind) {
	            return getSignaturesOfStructuredType(getApparentType(type), kind);
	        }
	        function getIndexInfoOfStructuredType(type, kind) {
	            if (type.flags & 458752 /* StructuredType */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                return kind === 0 /* String */ ? resolved.stringIndexInfo : resolved.numberIndexInfo;
	            }
	        }
	        function getIndexTypeOfStructuredType(type, kind) {
	            var info = getIndexInfoOfStructuredType(type, kind);
	            return info && info.type;
	        }
	        // Return the indexing info of the given kind in the given type. Creates synthetic union index types when necessary and
	        // maps primitive types and type parameters are to their apparent types.
	        function getIndexInfoOfType(type, kind) {
	            return getIndexInfoOfStructuredType(getApparentType(type), kind);
	        }
	        // Return the index type of the given kind in the given type. Creates synthetic union index types when necessary and
	        // maps primitive types and type parameters are to their apparent types.
	        function getIndexTypeOfType(type, kind) {
	            return getIndexTypeOfStructuredType(getApparentType(type), kind);
	        }
	        function getImplicitIndexTypeOfType(type, kind) {
	            if (isObjectTypeWithInferableIndex(type)) {
	                var propTypes = [];
	                for (var _i = 0, _a = getPropertiesOfType(type); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (kind === 0 /* String */ || isNumericLiteralName(prop.escapedName)) {
	                        propTypes.push(getTypeOfSymbol(prop));
	                    }
	                }
	                if (propTypes.length) {
	                    return getUnionType(propTypes, 2 /* Subtype */);
	                }
	            }
	            return undefined;
	        }
	        // Return list of type parameters with duplicates removed (duplicate identifier errors are generated in the actual
	        // type checking functions).
	        function getTypeParametersFromDeclaration(declaration) {
	            var result;
	            ts.forEach(ts.getEffectiveTypeParameterDeclarations(declaration), function (node) {
	                var tp = getDeclaredTypeOfTypeParameter(node.symbol);
	                result = ts.appendIfUnique(result, tp);
	            });
	            return result;
	        }
	        function symbolsToArray(symbols) {
	            var result = [];
	            symbols.forEach(function (symbol, id) {
	                if (!isReservedMemberName(id)) {
	                    result.push(symbol);
	                }
	            });
	            return result;
	        }
	        function isJSDocOptionalParameter(node) {
	            if (ts.isInJavaScriptFile(node)) {
	                if (node.type && node.type.kind === 279 /* JSDocOptionalType */) {
	                    return true;
	                }
	                var paramTags = ts.getJSDocParameterTags(node);
	                if (paramTags) {
	                    for (var _i = 0, paramTags_1 = paramTags; _i < paramTags_1.length; _i++) {
	                        var paramTag = paramTags_1[_i];
	                        if (paramTag.isBracketed) {
	                            return true;
	                        }
	                        if (paramTag.typeExpression) {
	                            return paramTag.typeExpression.type.kind === 279 /* JSDocOptionalType */;
	                        }
	                    }
	                }
	            }
	        }
	        function tryFindAmbientModule(moduleName, withAugmentations) {
	            if (ts.isExternalModuleNameRelative(moduleName)) {
	                return undefined;
	            }
	            var symbol = getSymbol(globals, '"' + moduleName + '"', 512 /* ValueModule */);
	            // merged symbol is module declaration symbol combined with all augmentations
	            return symbol && withAugmentations ? getMergedSymbol(symbol) : symbol;
	        }
	        function isOptionalParameter(node) {
	            if (ts.hasQuestionToken(node) || isJSDocOptionalParameter(node)) {
	                return true;
	            }
	            if (node.initializer) {
	                var signature = getSignatureFromDeclaration(node.parent);
	                var parameterIndex = node.parent.parameters.indexOf(node);
	                ts.Debug.assert(parameterIndex >= 0);
	                return parameterIndex >= signature.minArgumentCount;
	            }
	            var iife = ts.getImmediatelyInvokedFunctionExpression(node.parent);
	            if (iife) {
	                return !node.type &&
	                    !node.dotDotDotToken &&
	                    node.parent.parameters.indexOf(node) >= iife.arguments.length;
	            }
	            return false;
	        }
	        function createTypePredicateFromTypePredicateNode(node) {
	            var parameterName = node.parameterName;
	            var type = getTypeFromTypeNode(node.type);
	            if (parameterName.kind === 71 /* Identifier */) {
	                return createIdentifierTypePredicate(parameterName && parameterName.escapedText, // TODO: GH#18217
	                parameterName && getTypePredicateParameterIndex(node.parent.parameters, parameterName), type);
	            }
	            else {
	                return createThisTypePredicate(type);
	            }
	        }
	        function createIdentifierTypePredicate(parameterName, parameterIndex, type) {
	            return { kind: 1 /* Identifier */, parameterName: parameterName, parameterIndex: parameterIndex, type: type };
	        }
	        function createThisTypePredicate(type) {
	            return { kind: 0 /* This */, type: type };
	        }
	        /**
	         * Gets the minimum number of type arguments needed to satisfy all non-optional type
	         * parameters.
	         */
	        function getMinTypeArgumentCount(typeParameters) {
	            var minTypeArgumentCount = 0;
	            if (typeParameters) {
	                for (var i = 0; i < typeParameters.length; i++) {
	                    if (!hasTypeParameterDefault(typeParameters[i])) {
	                        minTypeArgumentCount = i + 1;
	                    }
	                }
	            }
	            return minTypeArgumentCount;
	        }
	        /**
	         * Fill in default types for unsupplied type arguments. If `typeArguments` is undefined
	         * when a default type is supplied, a new array will be created and returned.
	         *
	         * @param typeArguments The supplied type arguments.
	         * @param typeParameters The requested type parameters.
	         * @param minTypeArgumentCount The minimum number of required type arguments.
	         */
	        function fillMissingTypeArguments(typeArguments, typeParameters, minTypeArgumentCount, isJavaScriptImplicitAny) {
	            var numTypeParameters = ts.length(typeParameters);
	            if (numTypeParameters) {
	                var numTypeArguments = ts.length(typeArguments);
	                if (isJavaScriptImplicitAny || (numTypeArguments >= minTypeArgumentCount && numTypeArguments <= numTypeParameters)) {
	                    if (!typeArguments) {
	                        typeArguments = [];
	                    }
	                    // Map an unsatisfied type parameter with a default type.
	                    // If a type parameter does not have a default type, or if the default type
	                    // is a forward reference, the empty object type is used.
	                    for (var i = numTypeArguments; i < numTypeParameters; i++) {
	                        typeArguments[i] = getDefaultTypeArgumentType(isJavaScriptImplicitAny);
	                    }
	                    for (var i = numTypeArguments; i < numTypeParameters; i++) {
	                        var mapper = createTypeMapper(typeParameters, typeArguments);
	                        var defaultType = getDefaultFromTypeParameter(typeParameters[i]);
	                        if (defaultType && isTypeIdenticalTo(defaultType, emptyObjectType) && isJavaScriptImplicitAny) {
	                            defaultType = anyType;
	                        }
	                        typeArguments[i] = defaultType ? instantiateType(defaultType, mapper) : getDefaultTypeArgumentType(isJavaScriptImplicitAny);
	                    }
	                    typeArguments.length = typeParameters.length;
	                }
	            }
	            return typeArguments;
	        }
	        function getSignatureFromDeclaration(declaration) {
	            var links = getNodeLinks(declaration);
	            if (!links.resolvedSignature) {
	                var parameters = [];
	                var hasLiteralTypes = false;
	                var minArgumentCount = 0;
	                var thisParameter = undefined;
	                var hasThisParameter = void 0;
	                var iife = ts.getImmediatelyInvokedFunctionExpression(declaration);
	                var isJSConstructSignature = ts.isJSDocConstructSignature(declaration);
	                var isUntypedSignatureInJSFile = !iife && !isJSConstructSignature && ts.isInJavaScriptFile(declaration) && !ts.hasJSDocParameterTags(declaration);
	                // If this is a JSDoc construct signature, then skip the first parameter in the
	                // parameter list.  The first parameter represents the return type of the construct
	                // signature.
	                for (var i = isJSConstructSignature ? 1 : 0; i < declaration.parameters.length; i++) {
	                    var param = declaration.parameters[i];
	                    var paramSymbol = param.symbol;
	                    // Include parameter symbol instead of property symbol in the signature
	                    if (paramSymbol && !!(paramSymbol.flags & 4 /* Property */) && !ts.isBindingPattern(param.name)) {
	                        var resolvedSymbol = resolveName(param, paramSymbol.escapedName, 107455 /* Value */, undefined, undefined, /*isUse*/ false);
	                        paramSymbol = resolvedSymbol;
	                    }
	                    if (i === 0 && paramSymbol.escapedName === "this") {
	                        hasThisParameter = true;
	                        thisParameter = param.symbol;
	                    }
	                    else {
	                        parameters.push(paramSymbol);
	                    }
	                    if (param.type && param.type.kind === 177 /* LiteralType */) {
	                        hasLiteralTypes = true;
	                    }
	                    // Record a new minimum argument count if this is not an optional parameter
	                    var isOptionalParameter_1 = param.initializer || param.questionToken || param.dotDotDotToken ||
	                        iife && parameters.length > iife.arguments.length && !param.type ||
	                        isJSDocOptionalParameter(param) ||
	                        isUntypedSignatureInJSFile;
	                    if (!isOptionalParameter_1) {
	                        minArgumentCount = parameters.length;
	                    }
	                }
	                // If only one accessor includes a this-type annotation, the other behaves as if it had the same type annotation
	                if ((declaration.kind === 155 /* GetAccessor */ || declaration.kind === 156 /* SetAccessor */) &&
	                    !hasNonBindableDynamicName(declaration) &&
	                    (!hasThisParameter || !thisParameter)) {
	                    var otherKind = declaration.kind === 155 /* GetAccessor */ ? 156 /* SetAccessor */ : 155 /* GetAccessor */;
	                    var other = ts.getDeclarationOfKind(getSymbolOfNode(declaration), otherKind);
	                    if (other) {
	                        thisParameter = getAnnotatedAccessorThisParameter(other);
	                    }
	                }
	                var classType = declaration.kind === 154 /* Constructor */ ?
	                    getDeclaredTypeOfClassOrInterface(getMergedSymbol(declaration.parent.symbol))
	                    : undefined;
	                var typeParameters = classType ? classType.localTypeParameters : getTypeParametersFromDeclaration(declaration);
	                var returnType = getSignatureReturnTypeFromDeclaration(declaration, isJSConstructSignature, classType);
	                var hasRestLikeParameter = ts.hasRestParameter(declaration) || ts.isInJavaScriptFile(declaration) && maybeAddJsSyntheticRestParameter(declaration, parameters);
	                links.resolvedSignature = createSignature(declaration, typeParameters, thisParameter, parameters, returnType, /*resolvedTypePredicate*/ undefined, minArgumentCount, hasRestLikeParameter, hasLiteralTypes);
	            }
	            return links.resolvedSignature;
	        }
	        function maybeAddJsSyntheticRestParameter(declaration, parameters) {
	            // JS functions get a free rest parameter if:
	            // a) The last parameter has `...` preceding its type
	            // b) It references `arguments` somewhere
	            var lastParam = ts.lastOrUndefined(declaration.parameters);
	            var lastParamTags = lastParam && ts.getJSDocParameterTags(lastParam);
	            var lastParamVariadicType = ts.firstDefined(lastParamTags, function (p) {
	                return p.typeExpression && ts.isJSDocVariadicType(p.typeExpression.type) ? p.typeExpression.type : undefined;
	            });
	            if (!lastParamVariadicType && !containsArgumentsReference(declaration)) {
	                return false;
	            }
	            var syntheticArgsSymbol = createSymbol(3 /* Variable */, "args");
	            syntheticArgsSymbol.type = lastParamVariadicType ? createArrayType(getTypeFromTypeNode(lastParamVariadicType.type)) : anyArrayType;
	            syntheticArgsSymbol.isRestParameter = true;
	            if (lastParamVariadicType) {
	                // Replace the last parameter with a rest parameter.
	                parameters.pop();
	            }
	            parameters.push(syntheticArgsSymbol);
	            return true;
	        }
	        function getSignatureReturnTypeFromDeclaration(declaration, isJSConstructSignature, classType) {
	            if (isJSConstructSignature) {
	                return getTypeFromTypeNode(declaration.parameters[0].type);
	            }
	            else if (classType) {
	                return classType;
	            }
	            var typeNode = ts.getEffectiveReturnTypeNode(declaration);
	            if (typeNode) {
	                return getTypeFromTypeNode(typeNode);
	            }
	            // TypeScript 1.0 spec (April 2014):
	            // If only one accessor includes a type annotation, the other behaves as if it had the same type annotation.
	            if (declaration.kind === 155 /* GetAccessor */ && !hasNonBindableDynamicName(declaration)) {
	                var setter = ts.getDeclarationOfKind(getSymbolOfNode(declaration), 156 /* SetAccessor */);
	                return getAnnotatedAccessorType(setter);
	            }
	            if (ts.nodeIsMissing(declaration.body)) {
	                return anyType;
	            }
	        }
	        function containsArgumentsReference(declaration) {
	            var links = getNodeLinks(declaration);
	            if (links.containsArgumentsReference === undefined) {
	                if (links.flags & 8192 /* CaptureArguments */) {
	                    links.containsArgumentsReference = true;
	                }
	                else {
	                    links.containsArgumentsReference = traverse(declaration.body);
	                }
	            }
	            return links.containsArgumentsReference;
	            function traverse(node) {
	                if (!node)
	                    return false;
	                switch (node.kind) {
	                    case 71 /* Identifier */:
	                        return node.escapedText === "arguments" && ts.isExpressionNode(node);
	                    case 151 /* PropertyDeclaration */:
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        return node.name.kind === 146 /* ComputedPropertyName */
	                            && traverse(node.name);
	                    default:
	                        return !ts.nodeStartsNewLexicalEnvironment(node) && !ts.isPartOfTypeNode(node) && ts.forEachChild(node, traverse);
	                }
	            }
	        }
	        function getSignaturesOfSymbol(symbol) {
	            if (!symbol)
	                return ts.emptyArray;
	            var result = [];
	            for (var i = 0; i < symbol.declarations.length; i++) {
	                var node = symbol.declarations[i];
	                switch (node.kind) {
	                    case 162 /* FunctionType */:
	                    case 163 /* ConstructorType */:
	                    case 232 /* FunctionDeclaration */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                    case 154 /* Constructor */:
	                    case 157 /* CallSignature */:
	                    case 158 /* ConstructSignature */:
	                    case 159 /* IndexSignature */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 190 /* FunctionExpression */:
	                    case 191 /* ArrowFunction */:
	                    case 280 /* JSDocFunctionType */:
	                        // Don't include signature if node is the implementation of an overloaded function. A node is considered
	                        // an implementation node if it has a body and the previous node is of the same kind and immediately
	                        // precedes the implementation node (i.e. has the same parent and ends where the implementation starts).
	                        if (i > 0 && node.body) {
	                            var previous = symbol.declarations[i - 1];
	                            if (node.parent === previous.parent && node.kind === previous.kind && node.pos === previous.end) {
	                                break;
	                            }
	                        }
	                        result.push(getSignatureFromDeclaration(node));
	                }
	            }
	            return result;
	        }
	        function resolveExternalModuleTypeByLiteral(name) {
	            var moduleSym = resolveExternalModuleName(name, name);
	            if (moduleSym) {
	                var resolvedModuleSymbol = resolveExternalModuleSymbol(moduleSym);
	                if (resolvedModuleSymbol) {
	                    return getTypeOfSymbol(resolvedModuleSymbol);
	                }
	            }
	            return anyType;
	        }
	        function getThisTypeOfSignature(signature) {
	            if (signature.thisParameter) {
	                return getTypeOfSymbol(signature.thisParameter);
	            }
	        }
	        function signatureHasTypePredicate(signature) {
	            return getTypePredicateOfSignature(signature) !== undefined;
	        }
	        function getTypePredicateOfSignature(signature) {
	            if (!signature.resolvedTypePredicate) {
	                if (signature.target) {
	                    var targetTypePredicate = getTypePredicateOfSignature(signature.target);
	                    signature.resolvedTypePredicate = targetTypePredicate ? instantiateTypePredicate(targetTypePredicate, signature.mapper) : noTypePredicate;
	                }
	                else if (signature.unionSignatures) {
	                    signature.resolvedTypePredicate = getUnionTypePredicate(signature.unionSignatures) || noTypePredicate;
	                }
	                else {
	                    var declaration = signature.declaration;
	                    signature.resolvedTypePredicate = declaration && declaration.type && declaration.type.kind === 160 /* TypePredicate */ ?
	                        createTypePredicateFromTypePredicateNode(declaration.type) :
	                        noTypePredicate;
	                }
	                ts.Debug.assert(!!signature.resolvedTypePredicate);
	            }
	            return signature.resolvedTypePredicate === noTypePredicate ? undefined : signature.resolvedTypePredicate;
	        }
	        function getReturnTypeOfSignature(signature) {
	            if (!signature.resolvedReturnType) {
	                if (!pushTypeResolution(signature, 3 /* ResolvedReturnType */)) {
	                    return unknownType;
	                }
	                var type = void 0;
	                if (signature.target) {
	                    type = instantiateType(getReturnTypeOfSignature(signature.target), signature.mapper);
	                }
	                else if (signature.unionSignatures) {
	                    type = getUnionType(ts.map(signature.unionSignatures, getReturnTypeOfSignature), 2 /* Subtype */);
	                }
	                else {
	                    type = getReturnTypeFromBody(signature.declaration);
	                }
	                if (!popTypeResolution()) {
	                    type = anyType;
	                    if (noImplicitAny) {
	                        var declaration = signature.declaration;
	                        var name = ts.getNameOfDeclaration(declaration);
	                        if (name) {
	                            error(name, ts.Diagnostics._0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions, ts.declarationNameToString(name));
	                        }
	                        else {
	                            error(declaration, ts.Diagnostics.Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions);
	                        }
	                    }
	                }
	                signature.resolvedReturnType = type;
	            }
	            return signature.resolvedReturnType;
	        }
	        function isResolvingReturnTypeOfSignature(signature) {
	            return !signature.resolvedReturnType && findResolutionCycleStartIndex(signature, 3 /* ResolvedReturnType */) >= 0;
	        }
	        function getRestTypeOfSignature(signature) {
	            if (signature.hasRestParameter) {
	                var type = getTypeOfSymbol(ts.lastOrUndefined(signature.parameters));
	                if (ts.getObjectFlags(type) & 4 /* Reference */ && type.target === globalArrayType) {
	                    return type.typeArguments[0];
	                }
	            }
	            return anyType;
	        }
	        function getSignatureInstantiation(signature, typeArguments, isJavascript) {
	            typeArguments = fillMissingTypeArguments(typeArguments, signature.typeParameters, getMinTypeArgumentCount(signature.typeParameters), isJavascript);
	            var instantiations = signature.instantiations || (signature.instantiations = ts.createMap());
	            var id = getTypeListId(typeArguments);
	            var instantiation = instantiations.get(id);
	            if (!instantiation) {
	                instantiations.set(id, instantiation = createSignatureInstantiation(signature, typeArguments));
	            }
	            return instantiation;
	        }
	        function createSignatureInstantiation(signature, typeArguments) {
	            return instantiateSignature(signature, createTypeMapper(signature.typeParameters, typeArguments), /*eraseTypeParameters*/ true);
	        }
	        function getErasedSignature(signature) {
	            return signature.typeParameters ?
	                signature.erasedSignatureCache || (signature.erasedSignatureCache = createErasedSignature(signature)) :
	                signature;
	        }
	        function createErasedSignature(signature) {
	            // Create an instantiation of the signature where all type arguments are the any type.
	            return instantiateSignature(signature, createTypeEraser(signature.typeParameters), /*eraseTypeParameters*/ true);
	        }
	        function getCanonicalSignature(signature) {
	            return signature.typeParameters ?
	                signature.canonicalSignatureCache || (signature.canonicalSignatureCache = createCanonicalSignature(signature)) :
	                signature;
	        }
	        function createCanonicalSignature(signature) {
	            // Create an instantiation of the signature where each unconstrained type parameter is replaced with
	            // its original. When a generic class or interface is instantiated, each generic method in the class or
	            // interface is instantiated with a fresh set of cloned type parameters (which we need to handle scenarios
	            // where different generations of the same type parameter are in scope). This leads to a lot of new type
	            // identities, and potentially a lot of work comparing those identities, so here we create an instantiation
	            // that uses the original type identities for all unconstrained type parameters.
	            return getSignatureInstantiation(signature, ts.map(signature.typeParameters, function (tp) { return tp.target && !getConstraintOfTypeParameter(tp.target) ? tp.target : tp; }), ts.isInJavaScriptFile(signature.declaration));
	        }
	        function getBaseSignature(signature) {
	            var typeParameters = signature.typeParameters;
	            if (typeParameters) {
	                var typeEraser_1 = createTypeEraser(typeParameters);
	                var baseConstraints = ts.map(typeParameters, function (tp) { return instantiateType(getBaseConstraintOfType(tp), typeEraser_1) || emptyObjectType; });
	                return instantiateSignature(signature, createTypeMapper(typeParameters, baseConstraints), /*eraseTypeParameters*/ true);
	            }
	            return signature;
	        }
	        function getOrCreateTypeFromSignature(signature) {
	            // There are two ways to declare a construct signature, one is by declaring a class constructor
	            // using the constructor keyword, and the other is declaring a bare construct signature in an
	            // object type literal or interface (using the new keyword). Each way of declaring a constructor
	            // will result in a different declaration kind.
	            if (!signature.isolatedSignatureType) {
	                var isConstructor = signature.declaration.kind === 154 /* Constructor */ || signature.declaration.kind === 158 /* ConstructSignature */;
	                var type = createObjectType(16 /* Anonymous */);
	                type.members = emptySymbols;
	                type.properties = ts.emptyArray;
	                type.callSignatures = !isConstructor ? [signature] : ts.emptyArray;
	                type.constructSignatures = isConstructor ? [signature] : ts.emptyArray;
	                signature.isolatedSignatureType = type;
	            }
	            return signature.isolatedSignatureType;
	        }
	        function getIndexSymbol(symbol) {
	            return symbol.members.get("__index" /* Index */);
	        }
	        function getIndexDeclarationOfSymbol(symbol, kind) {
	            var syntaxKind = kind === 1 /* Number */ ? 134 /* NumberKeyword */ : 137 /* StringKeyword */;
	            var indexSymbol = getIndexSymbol(symbol);
	            if (indexSymbol) {
	                for (var _i = 0, _a = indexSymbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var node = decl;
	                    if (node.parameters.length === 1) {
	                        var parameter = node.parameters[0];
	                        if (parameter && parameter.type && parameter.type.kind === syntaxKind) {
	                            return node;
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function createIndexInfo(type, isReadonly, declaration) {
	            return { type: type, isReadonly: isReadonly, declaration: declaration };
	        }
	        function getIndexInfoOfSymbol(symbol, kind) {
	            var declaration = getIndexDeclarationOfSymbol(symbol, kind);
	            if (declaration) {
	                return createIndexInfo(declaration.type ? getTypeFromTypeNode(declaration.type) : anyType, ts.hasModifier(declaration, 64 /* Readonly */), declaration);
	            }
	            return undefined;
	        }
	        function getConstraintDeclaration(type) {
	            return type.symbol && ts.getDeclarationOfKind(type.symbol, 147 /* TypeParameter */).constraint;
	        }
	        function getInferredTypeParameterConstraint(typeParameter) {
	            var inferences;
	            if (typeParameter.symbol) {
	                for (var _i = 0, _a = typeParameter.symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    // When an 'infer T' declaration is immediately contained in a type reference node
	                    // (such as 'Foo<infer T>'), T's constraint is inferred from the constraint of the
	                    // corresponding type parameter in 'Foo'. When multiple 'infer T' declarations are
	                    // present, we form an intersection of the inferred constraint types.
	                    if (declaration.parent.kind === 171 /* InferType */ && declaration.parent.parent.kind === 161 /* TypeReference */) {
	                        var typeReference = declaration.parent.parent;
	                        var typeParameters = getTypeParametersForTypeReference(typeReference);
	                        if (typeParameters) {
	                            var index = typeReference.typeArguments.indexOf(declaration.parent);
	                            if (index < typeParameters.length) {
	                                var declaredConstraint = getConstraintOfTypeParameter(typeParameters[index]);
	                                if (declaredConstraint) {
	                                    // Type parameter constraints can reference other type parameters so
	                                    // constraints need to be instantiated. If instantiation produces the
	                                    // type parameter itself, we discard that inference. For example, in
	                                    //   type Foo<T extends string, U extends T> = [T, U];
	                                    //   type Bar<T> = T extends Foo<infer X, infer X> ? Foo<X, X> : T;
	                                    // the instantiated constraint for U is X, so we discard that inference.
	                                    var mapper = createTypeMapper(typeParameters, getEffectiveTypeArguments(typeReference, typeParameters));
	                                    var constraint = instantiateType(declaredConstraint, mapper);
	                                    if (constraint !== typeParameter) {
	                                        inferences = ts.append(inferences, constraint);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            return inferences && getIntersectionType(inferences);
	        }
	        function getConstraintFromTypeParameter(typeParameter) {
	            if (!typeParameter.constraint) {
	                if (typeParameter.target) {
	                    var targetConstraint = getConstraintOfTypeParameter(typeParameter.target);
	                    typeParameter.constraint = targetConstraint ? instantiateType(targetConstraint, typeParameter.mapper) : noConstraintType;
	                }
	                else {
	                    var constraintDeclaration = getConstraintDeclaration(typeParameter);
	                    typeParameter.constraint = constraintDeclaration ? getTypeFromTypeNode(constraintDeclaration) :
	                        getInferredTypeParameterConstraint(typeParameter) || noConstraintType;
	                }
	            }
	            return typeParameter.constraint === noConstraintType ? undefined : typeParameter.constraint;
	        }
	        function getParentSymbolOfTypeParameter(typeParameter) {
	            return getSymbolOfNode(ts.getDeclarationOfKind(typeParameter.symbol, 147 /* TypeParameter */).parent);
	        }
	        function getTypeListId(types) {
	            var result = "";
	            if (types) {
	                var length_3 = types.length;
	                var i = 0;
	                while (i < length_3) {
	                    var startId = types[i].id;
	                    var count = 1;
	                    while (i + count < length_3 && types[i + count].id === startId + count) {
	                        count++;
	                    }
	                    if (result.length) {
	                        result += ",";
	                    }
	                    result += startId;
	                    if (count > 1) {
	                        result += ":" + count;
	                    }
	                    i += count;
	                }
	            }
	            return result;
	        }
	        // This function is used to propagate certain flags when creating new object type references and union types.
	        // It is only necessary to do so if a constituent type might be the undefined type, the null type, the type
	        // of an object literal or the anyFunctionType. This is because there are operations in the type checker
	        // that care about the presence of such types at arbitrary depth in a containing type.
	        function getPropagatingFlagsOfTypes(types, excludeKinds) {
	            var result = 0;
	            for (var _i = 0, types_5 = types; _i < types_5.length; _i++) {
	                var type = types_5[_i];
	                if (!(type.flags & excludeKinds)) {
	                    result |= type.flags;
	                }
	            }
	            return result & 117440512 /* PropagatingFlags */;
	        }
	        function createTypeReference(target, typeArguments) {
	            var id = getTypeListId(typeArguments);
	            var type = target.instantiations.get(id);
	            if (!type) {
	                type = createObjectType(4 /* Reference */, target.symbol);
	                target.instantiations.set(id, type);
	                type.flags |= typeArguments ? getPropagatingFlagsOfTypes(typeArguments, /*excludeKinds*/ 0) : 0;
	                type.target = target;
	                type.typeArguments = typeArguments;
	            }
	            return type;
	        }
	        function cloneTypeReference(source) {
	            var type = createType(source.flags);
	            type.symbol = source.symbol;
	            type.objectFlags = source.objectFlags;
	            type.target = source.target;
	            type.typeArguments = source.typeArguments;
	            return type;
	        }
	        function getTypeReferenceArity(type) {
	            return ts.length(type.target.typeParameters);
	        }
	        /**
	         * Get type from type-reference that reference to class or interface
	         */
	        function getTypeFromClassOrInterfaceReference(node, symbol, typeArgs) {
	            var type = getDeclaredTypeOfSymbol(getMergedSymbol(symbol));
	            var typeParameters = type.localTypeParameters;
	            if (typeParameters) {
	                var numTypeArguments = ts.length(node.typeArguments);
	                var minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
	                var isJs = ts.isInJavaScriptFile(node);
	                var isJsImplicitAny = !noImplicitAny && isJs;
	                if (!isJsImplicitAny && (numTypeArguments < minTypeArgumentCount || numTypeArguments > typeParameters.length)) {
	                    var missingAugmentsTag = isJs && node.parent.kind !== 285 /* JSDocAugmentsTag */;
	                    var diag = minTypeArgumentCount === typeParameters.length
	                        ? missingAugmentsTag
	                            ? ts.Diagnostics.Expected_0_type_arguments_provide_these_with_an_extends_tag
	                            : ts.Diagnostics.Generic_type_0_requires_1_type_argument_s
	                        : missingAugmentsTag
	                            ? ts.Diagnostics.Expected_0_1_type_arguments_provide_these_with_an_extends_tag
	                            : ts.Diagnostics.Generic_type_0_requires_between_1_and_2_type_arguments;
	                    var typeStr = typeToString(type, /*enclosingDeclaration*/ undefined, 2 /* WriteArrayAsGenericType */);
	                    error(node, diag, typeStr, minTypeArgumentCount, typeParameters.length);
	                    if (!isJs) {
	                        // TODO: Adopt same permissive behavior in TS as in JS to reduce follow-on editing experience failures (requires editing fillMissingTypeArguments)
	                        return unknownType;
	                    }
	                }
	                // In a type reference, the outer type parameters of the referenced class or interface are automatically
	                // supplied as type arguments and the type reference only specifies arguments for the local type parameters
	                // of the class or interface.
	                var typeArguments = ts.concatenate(type.outerTypeParameters, fillMissingTypeArguments(typeArgs, typeParameters, minTypeArgumentCount, isJs));
	                return createTypeReference(type, typeArguments);
	            }
	            return checkNoTypeArguments(node, symbol) ? type : unknownType;
	        }
	        function getTypeAliasInstantiation(symbol, typeArguments) {
	            var type = getDeclaredTypeOfSymbol(symbol);
	            var links = getSymbolLinks(symbol);
	            var typeParameters = links.typeParameters;
	            var id = getTypeListId(typeArguments);
	            var instantiation = links.instantiations.get(id);
	            if (!instantiation) {
	                links.instantiations.set(id, instantiation = instantiateType(type, createTypeMapper(typeParameters, fillMissingTypeArguments(typeArguments, typeParameters, getMinTypeArgumentCount(typeParameters), ts.isInJavaScriptFile(symbol.valueDeclaration)))));
	            }
	            return instantiation;
	        }
	        /**
	         * Get type from reference to type alias. When a type alias is generic, the declared type of the type alias may include
	         * references to the type parameters of the alias. We replace those with the actual type arguments by instantiating the
	         * declared type. Instantiations are cached using the type identities of the type arguments as the key.
	         */
	        function getTypeFromTypeAliasReference(node, symbol, typeArguments) {
	            var type = getDeclaredTypeOfSymbol(symbol);
	            var typeParameters = getSymbolLinks(symbol).typeParameters;
	            if (typeParameters) {
	                var numTypeArguments = ts.length(node.typeArguments);
	                var minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
	                if (numTypeArguments < minTypeArgumentCount || numTypeArguments > typeParameters.length) {
	                    error(node, minTypeArgumentCount === typeParameters.length
	                        ? ts.Diagnostics.Generic_type_0_requires_1_type_argument_s
	                        : ts.Diagnostics.Generic_type_0_requires_between_1_and_2_type_arguments, symbolToString(symbol), minTypeArgumentCount, typeParameters.length);
	                    return unknownType;
	                }
	                return getTypeAliasInstantiation(symbol, typeArguments);
	            }
	            return checkNoTypeArguments(node, symbol) ? type : unknownType;
	        }
	        function getTypeReferenceName(node) {
	            switch (node.kind) {
	                case 161 /* TypeReference */:
	                    return node.typeName;
	                case 205 /* ExpressionWithTypeArguments */:
	                    // We only support expressions that are simple qualified names. For other
	                    // expressions this produces undefined.
	                    var expr = node.expression;
	                    if (ts.isEntityNameExpression(expr)) {
	                        return expr;
	                    }
	            }
	            return undefined;
	        }
	        function resolveTypeReferenceName(typeReferenceName, meaning) {
	            if (!typeReferenceName) {
	                return unknownSymbol;
	            }
	            return resolveEntityName(typeReferenceName, meaning) || unknownSymbol;
	        }
	        function getTypeReferenceType(node, symbol) {
	            var typeArguments = typeArgumentsFromTypeReferenceNode(node); // Do unconditionally so we mark type arguments as referenced.
	            if (symbol === unknownSymbol) {
	                return unknownType;
	            }
	            var type = getTypeReferenceTypeWorker(node, symbol, typeArguments);
	            if (type) {
	                return type;
	            }
	            // Get type from reference to named type that cannot be generic (enum or type parameter)
	            var res = tryGetDeclaredTypeOfSymbol(symbol);
	            if (res) {
	                return checkNoTypeArguments(node, symbol) ?
	                    res.flags & 32768 /* TypeParameter */ ? getConstrainedTypeParameter(res, node) : res :
	                    unknownType;
	            }
	            if (!(symbol.flags & 107455 /* Value */ && isJSDocTypeReference(node))) {
	                return unknownType;
	            }
	            // A jsdoc TypeReference may have resolved to a value (as opposed to a type). If
	            // the symbol is a constructor function, return the inferred class type; otherwise,
	            // the type of this reference is just the type of the value we resolved to.
	            var valueType = getTypeOfSymbol(symbol);
	            if (valueType.symbol && !isInferredClassType(valueType)) {
	                var referenceType = getTypeReferenceTypeWorker(node, valueType.symbol, typeArguments);
	                if (referenceType) {
	                    return referenceType;
	                }
	            }
	            // Resolve the type reference as a Type for the purpose of reporting errors.
	            resolveTypeReferenceName(getTypeReferenceName(node), 793064 /* Type */);
	            return valueType;
	        }
	        function getTypeReferenceTypeWorker(node, symbol, typeArguments) {
	            if (symbol.flags & (32 /* Class */ | 64 /* Interface */)) {
	                return getTypeFromClassOrInterfaceReference(node, symbol, typeArguments);
	            }
	            if (symbol.flags & 524288 /* TypeAlias */) {
	                return getTypeFromTypeAliasReference(node, symbol, typeArguments);
	            }
	            if (symbol.flags & 16 /* Function */ &&
	                isJSDocTypeReference(node) &&
	                (symbol.members || ts.getJSDocClassTag(symbol.valueDeclaration))) {
	                return getInferredClassType(symbol);
	            }
	        }
	        function getSubstitutionType(typeParameter, substitute) {
	            var result = createType(4194304 /* Substitution */);
	            result.typeParameter = typeParameter;
	            result.substitute = substitute;
	            return result;
	        }
	        function getConstrainedTypeParameter(typeParameter, node) {
	            var constraints;
	            while (ts.isPartOfTypeNode(node)) {
	                var parent = node.parent;
	                if (parent.kind === 170 /* ConditionalType */ && node === parent.trueType) {
	                    if (getTypeFromTypeNode(parent.checkType) === typeParameter) {
	                        constraints = ts.append(constraints, getTypeFromTypeNode(parent.extendsType));
	                    }
	                }
	                node = parent;
	            }
	            return constraints ? getSubstitutionType(typeParameter, getIntersectionType(ts.append(constraints, typeParameter))) : typeParameter;
	        }
	        function isJSDocTypeReference(node) {
	            return node.flags & 1048576 /* JSDoc */ && node.kind === 161 /* TypeReference */;
	        }
	        function checkNoTypeArguments(node, symbol) {
	            if (node.typeArguments) {
	                error(node, ts.Diagnostics.Type_0_is_not_generic, symbol ? symbolToString(symbol) : ts.declarationNameToString(node.typeName));
	                return false;
	            }
	            return true;
	        }
	        function getIntendedTypeFromJSDocTypeReference(node) {
	            if (ts.isIdentifier(node.typeName)) {
	                var typeArgs = node.typeArguments;
	                switch (node.typeName.escapedText) {
	                    case "String":
	                        checkNoTypeArguments(node);
	                        return stringType;
	                    case "Number":
	                        checkNoTypeArguments(node);
	                        return numberType;
	                    case "Boolean":
	                        checkNoTypeArguments(node);
	                        return booleanType;
	                    case "Void":
	                        checkNoTypeArguments(node);
	                        return voidType;
	                    case "Undefined":
	                        checkNoTypeArguments(node);
	                        return undefinedType;
	                    case "Null":
	                        checkNoTypeArguments(node);
	                        return nullType;
	                    case "Function":
	                    case "function":
	                        checkNoTypeArguments(node);
	                        return globalFunctionType;
	                    case "Array":
	                    case "array":
	                        return !typeArgs || !typeArgs.length ? anyArrayType : undefined;
	                    case "Promise":
	                    case "promise":
	                        return !typeArgs || !typeArgs.length ? createPromiseType(anyType) : undefined;
	                    case "Object":
	                        if (typeArgs && typeArgs.length === 2) {
	                            if (ts.isJSDocIndexSignature(node)) {
	                                var indexed = getTypeFromTypeNode(typeArgs[0]);
	                                var target = getTypeFromTypeNode(typeArgs[1]);
	                                var index = createIndexInfo(target, /*isReadonly*/ false);
	                                return createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, indexed === stringType && index, indexed === numberType && index);
	                            }
	                            return anyType;
	                        }
	                        checkNoTypeArguments(node);
	                        return anyType;
	                }
	            }
	        }
	        function getTypeFromJSDocNullableTypeNode(node) {
	            var type = getTypeFromTypeNode(node.type);
	            return strictNullChecks ? getNullableType(type, 8192 /* Null */) : type;
	        }
	        function getTypeFromTypeReference(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                var symbol = void 0;
	                var type = void 0;
	                var meaning = 793064 /* Type */;
	                if (isJSDocTypeReference(node)) {
	                    type = getIntendedTypeFromJSDocTypeReference(node);
	                    meaning |= 107455 /* Value */;
	                }
	                if (!type) {
	                    symbol = resolveTypeReferenceName(getTypeReferenceName(node), meaning);
	                    type = getTypeReferenceType(node, symbol);
	                }
	                // Cache both the resolved symbol and the resolved type. The resolved symbol is needed in when we check the
	                // type reference in checkTypeReferenceNode.
	                links.resolvedSymbol = symbol;
	                links.resolvedType = type;
	            }
	            return links.resolvedType;
	        }
	        function typeArgumentsFromTypeReferenceNode(node) {
	            return ts.map(node.typeArguments, getTypeFromTypeNode);
	        }
	        function getTypeFromTypeQueryNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                // TypeScript 1.0 spec (April 2014): 3.6.3
	                // The expression is processed as an identifier expression (section 4.3)
	                // or property access expression(section 4.10),
	                // the widened type(section 3.9) of which becomes the result.
	                links.resolvedType = getWidenedType(checkExpression(node.exprName));
	            }
	            return links.resolvedType;
	        }
	        function getTypeOfGlobalSymbol(symbol, arity) {
	            function getTypeDeclaration(symbol) {
	                var declarations = symbol.declarations;
	                for (var _i = 0, declarations_3 = declarations; _i < declarations_3.length; _i++) {
	                    var declaration = declarations_3[_i];
	                    switch (declaration.kind) {
	                        case 233 /* ClassDeclaration */:
	                        case 234 /* InterfaceDeclaration */:
	                        case 236 /* EnumDeclaration */:
	                            return declaration;
	                    }
	                }
	            }
	            if (!symbol) {
	                return arity ? emptyGenericType : emptyObjectType;
	            }
	            var type = getDeclaredTypeOfSymbol(symbol);
	            if (!(type.flags & 65536 /* Object */)) {
	                error(getTypeDeclaration(symbol), ts.Diagnostics.Global_type_0_must_be_a_class_or_interface_type, ts.symbolName(symbol));
	                return arity ? emptyGenericType : emptyObjectType;
	            }
	            if (ts.length(type.typeParameters) !== arity) {
	                error(getTypeDeclaration(symbol), ts.Diagnostics.Global_type_0_must_have_1_type_parameter_s, ts.symbolName(symbol), arity);
	                return arity ? emptyGenericType : emptyObjectType;
	            }
	            return type;
	        }
	        function getGlobalValueSymbol(name, reportErrors) {
	            return getGlobalSymbol(name, 107455 /* Value */, reportErrors ? ts.Diagnostics.Cannot_find_global_value_0 : undefined);
	        }
	        function getGlobalTypeSymbol(name, reportErrors) {
	            return getGlobalSymbol(name, 793064 /* Type */, reportErrors ? ts.Diagnostics.Cannot_find_global_type_0 : undefined);
	        }
	        function getGlobalSymbol(name, meaning, diagnostic) {
	            // Don't track references for global symbols anyway, so value if `isReference` is arbitrary
	            return resolveName(undefined, name, meaning, diagnostic, name, /*isUse*/ false);
	        }
	        function getGlobalType(name, arity, reportErrors) {
	            var symbol = getGlobalTypeSymbol(name, reportErrors);
	            return symbol || reportErrors ? getTypeOfGlobalSymbol(symbol, arity) : undefined;
	        }
	        function getGlobalTypedPropertyDescriptorType() {
	            return deferredGlobalTypedPropertyDescriptorType || (deferredGlobalTypedPropertyDescriptorType = getGlobalType("TypedPropertyDescriptor", /*arity*/ 1, /*reportErrors*/ true)) || emptyGenericType;
	        }
	        function getGlobalTemplateStringsArrayType() {
	            return deferredGlobalTemplateStringsArrayType || (deferredGlobalTemplateStringsArrayType = getGlobalType("TemplateStringsArray", /*arity*/ 0, /*reportErrors*/ true)) || emptyObjectType;
	        }
	        function getGlobalESSymbolConstructorSymbol(reportErrors) {
	            return deferredGlobalESSymbolConstructorSymbol || (deferredGlobalESSymbolConstructorSymbol = getGlobalValueSymbol("Symbol", reportErrors));
	        }
	        function getGlobalESSymbolType(reportErrors) {
	            return deferredGlobalESSymbolType || (deferredGlobalESSymbolType = getGlobalType("Symbol", /*arity*/ 0, reportErrors)) || emptyObjectType;
	        }
	        function getGlobalPromiseType(reportErrors) {
	            return deferredGlobalPromiseType || (deferredGlobalPromiseType = getGlobalType("Promise", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalPromiseConstructorSymbol(reportErrors) {
	            return deferredGlobalPromiseConstructorSymbol || (deferredGlobalPromiseConstructorSymbol = getGlobalValueSymbol("Promise", reportErrors));
	        }
	        function getGlobalPromiseConstructorLikeType(reportErrors) {
	            return deferredGlobalPromiseConstructorLikeType || (deferredGlobalPromiseConstructorLikeType = getGlobalType("PromiseConstructorLike", /*arity*/ 0, reportErrors)) || emptyObjectType;
	        }
	        function getGlobalAsyncIterableType(reportErrors) {
	            return deferredGlobalAsyncIterableType || (deferredGlobalAsyncIterableType = getGlobalType("AsyncIterable", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalAsyncIteratorType(reportErrors) {
	            return deferredGlobalAsyncIteratorType || (deferredGlobalAsyncIteratorType = getGlobalType("AsyncIterator", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalAsyncIterableIteratorType(reportErrors) {
	            return deferredGlobalAsyncIterableIteratorType || (deferredGlobalAsyncIterableIteratorType = getGlobalType("AsyncIterableIterator", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalIterableType(reportErrors) {
	            return deferredGlobalIterableType || (deferredGlobalIterableType = getGlobalType("Iterable", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalIteratorType(reportErrors) {
	            return deferredGlobalIteratorType || (deferredGlobalIteratorType = getGlobalType("Iterator", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalIterableIteratorType(reportErrors) {
	            return deferredGlobalIterableIteratorType || (deferredGlobalIterableIteratorType = getGlobalType("IterableIterator", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalTypeOrUndefined(name, arity) {
	            if (arity === void 0) { arity = 0; }
	            var symbol = getGlobalSymbol(name, 793064 /* Type */, /*diagnostic*/ undefined);
	            return symbol && getTypeOfGlobalSymbol(symbol, arity);
	        }
	        /**
	         * Returns a type that is inside a namespace at the global scope, e.g.
	         * getExportedTypeFromNamespace('JSX', 'Element') returns the JSX.Element type
	         */
	        function getExportedTypeFromNamespace(namespace, name) {
	            var namespaceSymbol = getGlobalSymbol(namespace, 1920 /* Namespace */, /*diagnosticMessage*/ undefined);
	            var typeSymbol = namespaceSymbol && getSymbol(namespaceSymbol.exports, name, 793064 /* Type */);
	            return typeSymbol && getDeclaredTypeOfSymbol(typeSymbol);
	        }
	        /**
	         * Instantiates a global type that is generic with some element type, and returns that instantiation.
	         */
	        function createTypeFromGenericGlobalType(genericGlobalType, typeArguments) {
	            return genericGlobalType !== emptyGenericType ? createTypeReference(genericGlobalType, typeArguments) : emptyObjectType;
	        }
	        function createTypedPropertyDescriptorType(propertyType) {
	            return createTypeFromGenericGlobalType(getGlobalTypedPropertyDescriptorType(), [propertyType]);
	        }
	        function createAsyncIterableType(iteratedType) {
	            return createTypeFromGenericGlobalType(getGlobalAsyncIterableType(/*reportErrors*/ true), [iteratedType]);
	        }
	        function createAsyncIterableIteratorType(iteratedType) {
	            return createTypeFromGenericGlobalType(getGlobalAsyncIterableIteratorType(/*reportErrors*/ true), [iteratedType]);
	        }
	        function createIterableType(iteratedType) {
	            return createTypeFromGenericGlobalType(getGlobalIterableType(/*reportErrors*/ true), [iteratedType]);
	        }
	        function createIterableIteratorType(iteratedType) {
	            return createTypeFromGenericGlobalType(getGlobalIterableIteratorType(/*reportErrors*/ true), [iteratedType]);
	        }
	        function createArrayType(elementType) {
	            return createTypeFromGenericGlobalType(globalArrayType, [elementType]);
	        }
	        function getTypeFromArrayTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = createArrayType(getTypeFromTypeNode(node.elementType));
	            }
	            return links.resolvedType;
	        }
	        // We represent tuple types as type references to synthesized generic interface types created by
	        // this function. The types are of the form:
	        //
	        //   interface Tuple<T0, T1, T2, ...> extends Array<T0 | T1 | T2 | ...> { 0: T0, 1: T1, 2: T2, ... }
	        //
	        // Note that the generic type created by this function has no symbol associated with it. The same
	        // is true for each of the synthesized type parameters.
	        function createTupleTypeOfArity(arity) {
	            var typeParameters = [];
	            var properties = [];
	            for (var i = 0; i < arity; i++) {
	                var typeParameter = createType(32768 /* TypeParameter */);
	                typeParameters.push(typeParameter);
	                var property = createSymbol(4 /* Property */, "" + i);
	                property.type = typeParameter;
	                properties.push(property);
	            }
	            var lengthSymbol = createSymbol(4 /* Property */, "length");
	            lengthSymbol.type = getLiteralType(arity);
	            properties.push(lengthSymbol);
	            var type = createObjectType(8 /* Tuple */ | 4 /* Reference */);
	            type.typeParameters = typeParameters;
	            type.outerTypeParameters = undefined;
	            type.localTypeParameters = typeParameters;
	            type.instantiations = ts.createMap();
	            type.instantiations.set(getTypeListId(type.typeParameters), type);
	            type.target = type;
	            type.typeArguments = type.typeParameters;
	            type.thisType = createType(32768 /* TypeParameter */);
	            type.thisType.isThisType = true;
	            type.thisType.constraint = type;
	            type.declaredProperties = properties;
	            type.declaredCallSignatures = ts.emptyArray;
	            type.declaredConstructSignatures = ts.emptyArray;
	            type.declaredStringIndexInfo = undefined;
	            type.declaredNumberIndexInfo = undefined;
	            return type;
	        }
	        function getTupleTypeOfArity(arity) {
	            return tupleTypes[arity] || (tupleTypes[arity] = createTupleTypeOfArity(arity));
	        }
	        function createTupleType(elementTypes) {
	            return createTypeReference(getTupleTypeOfArity(elementTypes.length), elementTypes);
	        }
	        function getTypeFromTupleTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = createTupleType(ts.map(node.elementTypes, getTypeFromTypeNode));
	            }
	            return links.resolvedType;
	        }
	        function getTypeId(type) {
	            return type.id;
	        }
	        function containsType(types, type) {
	            return ts.binarySearch(types, type, getTypeId, ts.compareValues) >= 0;
	        }
	        // Return true if the given intersection type contains (a) more than one unit type or (b) an object
	        // type and a nullable type (null or undefined).
	        function isEmptyIntersectionType(type) {
	            var combined = 0;
	            for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (t.flags & 13536 /* Unit */ && combined & 13536 /* Unit */) {
	                    return true;
	                }
	                combined |= t.flags;
	                if (combined & 12288 /* Nullable */ && combined & (65536 /* Object */ | 134217728 /* NonPrimitive */)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function addTypeToUnion(typeSet, includes, type) {
	            var flags = type.flags;
	            if (flags & 131072 /* Union */) {
	                includes = addTypesToUnion(typeSet, includes, type.types);
	            }
	            else if (flags & 1 /* Any */) {
	                includes |= 1 /* Any */;
	            }
	            else if (!strictNullChecks && flags & 12288 /* Nullable */) {
	                if (flags & 4096 /* Undefined */)
	                    includes |= 2 /* Undefined */;
	                if (flags & 8192 /* Null */)
	                    includes |= 4 /* Null */;
	                if (!(flags & 16777216 /* ContainsWideningType */))
	                    includes |= 16 /* NonWideningType */;
	            }
	            else if (!(flags & 16384 /* Never */ || flags & 262144 /* Intersection */ && isEmptyIntersectionType(type))) {
	                // We ignore 'never' types in unions. Likewise, we ignore intersections of unit types as they are
	                // another form of 'never' (in that they have an empty value domain). We could in theory turn
	                // intersections of unit types into 'never' upon construction, but deferring the reduction makes it
	                // easier to reason about their origin.
	                if (flags & 2 /* String */)
	                    includes |= 32 /* String */;
	                if (flags & 4 /* Number */)
	                    includes |= 64 /* Number */;
	                if (flags & 512 /* ESSymbol */)
	                    includes |= 128 /* ESSymbol */;
	                if (flags & 1120 /* StringOrNumberLiteralOrUnique */)
	                    includes |= 256 /* LiteralOrUniqueESSymbol */;
	                var len = typeSet.length;
	                var index = len && type.id > typeSet[len - 1].id ? ~len : ts.binarySearch(typeSet, type, getTypeId, ts.compareValues);
	                if (index < 0) {
	                    if (!(flags & 65536 /* Object */ && type.objectFlags & 16 /* Anonymous */ &&
	                        type.symbol && type.symbol.flags & (16 /* Function */ | 8192 /* Method */) && containsIdenticalType(typeSet, type))) {
	                        typeSet.splice(~index, 0, type);
	                    }
	                }
	            }
	            return includes;
	        }
	        // Add the given types to the given type set. Order is preserved, duplicates are removed,
	        // and nested types of the given kind are flattened into the set.
	        function addTypesToUnion(typeSet, includes, types) {
	            for (var _i = 0, types_6 = types; _i < types_6.length; _i++) {
	                var type = types_6[_i];
	                includes = addTypeToUnion(typeSet, includes, type);
	            }
	            return includes;
	        }
	        function containsIdenticalType(types, type) {
	            for (var _i = 0, types_7 = types; _i < types_7.length; _i++) {
	                var t = types_7[_i];
	                if (isTypeIdenticalTo(t, type)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function isSubtypeOfAny(source, targets) {
	            for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
	                var target = targets_1[_i];
	                if (source !== target && isTypeSubtypeOf(source, target) && (!(ts.getObjectFlags(getTargetType(source)) & 1 /* Class */) ||
	                    !(ts.getObjectFlags(getTargetType(target)) & 1 /* Class */) ||
	                    isTypeDerivedFrom(source, target))) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function isSetOfLiteralsFromSameEnum(types) {
	            var first = types[0];
	            if (first.flags & 256 /* EnumLiteral */) {
	                var firstEnum = getParentOfSymbol(first.symbol);
	                for (var i = 1; i < types.length; i++) {
	                    var other = types[i];
	                    if (!(other.flags & 256 /* EnumLiteral */) || (firstEnum !== getParentOfSymbol(other.symbol))) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function removeSubtypes(types) {
	            if (types.length === 0 || isSetOfLiteralsFromSameEnum(types)) {
	                return;
	            }
	            var i = types.length;
	            while (i > 0) {
	                i--;
	                if (isSubtypeOfAny(types[i], types)) {
	                    ts.orderedRemoveItemAt(types, i);
	                }
	            }
	        }
	        function removeRedundantLiteralTypes(types, includes) {
	            var i = types.length;
	            while (i > 0) {
	                i--;
	                var t = types[i];
	                var remove = t.flags & 32 /* StringLiteral */ && includes & 32 /* String */ ||
	                    t.flags & 64 /* NumberLiteral */ && includes & 64 /* Number */ ||
	                    t.flags & 1024 /* UniqueESSymbol */ && includes & 128 /* ESSymbol */ ||
	                    t.flags & 96 /* StringOrNumberLiteral */ && t.flags & 8388608 /* FreshLiteral */ && containsType(types, t.regularType);
	                if (remove) {
	                    ts.orderedRemoveItemAt(types, i);
	                }
	            }
	        }
	        // We sort and deduplicate the constituent types based on object identity. If the subtypeReduction
	        // flag is specified we also reduce the constituent type set to only include types that aren't subtypes
	        // of other types. Subtype reduction is expensive for large union types and is possible only when union
	        // types are known not to circularly reference themselves (as is the case with union types created by
	        // expression constructs such as array literals and the || and ?: operators). Named types can
	        // circularly reference themselves and therefore cannot be subtype reduced during their declaration.
	        // For example, "type Item = string | (() => Item" is a named type that circularly references itself.
	        function getUnionType(types, unionReduction, aliasSymbol, aliasTypeArguments) {
	            if (unionReduction === void 0) { unionReduction = 1 /* Literal */; }
	            if (types.length === 0) {
	                return neverType;
	            }
	            if (types.length === 1) {
	                return types[0];
	            }
	            var typeSet = [];
	            var includes = addTypesToUnion(typeSet, 0, types);
	            if (includes & 1 /* Any */) {
	                return anyType;
	            }
	            switch (unionReduction) {
	                case 1 /* Literal */:
	                    if (includes & 256 /* LiteralOrUniqueESSymbol */) {
	                        removeRedundantLiteralTypes(typeSet, includes);
	                    }
	                    break;
	                case 2 /* Subtype */:
	                    removeSubtypes(typeSet);
	                    break;
	            }
	            if (typeSet.length === 0) {
	                return includes & 4 /* Null */ ? includes & 16 /* NonWideningType */ ? nullType : nullWideningType :
	                    includes & 2 /* Undefined */ ? includes & 16 /* NonWideningType */ ? undefinedType : undefinedWideningType :
	                        neverType;
	            }
	            return getUnionTypeFromSortedList(typeSet, aliasSymbol, aliasTypeArguments);
	        }
	        function getUnionTypePredicate(signatures) {
	            var first;
	            var types = [];
	            for (var _i = 0, signatures_2 = signatures; _i < signatures_2.length; _i++) {
	                var sig = signatures_2[_i];
	                var pred = getTypePredicateOfSignature(sig);
	                if (!pred) {
	                    continue;
	                }
	                if (first) {
	                    if (!typePredicateKindsMatch(first, pred)) {
	                        // No common type predicate.
	                        return undefined;
	                    }
	                }
	                else {
	                    first = pred;
	                }
	                types.push(pred.type);
	            }
	            if (!first) {
	                // No union signatures had a type predicate.
	                return undefined;
	            }
	            var unionType = getUnionType(types);
	            return ts.isIdentifierTypePredicate(first)
	                ? createIdentifierTypePredicate(first.parameterName, first.parameterIndex, unionType)
	                : createThisTypePredicate(unionType);
	        }
	        function typePredicateKindsMatch(a, b) {
	            return ts.isIdentifierTypePredicate(a)
	                ? ts.isIdentifierTypePredicate(b) && a.parameterIndex === b.parameterIndex
	                : !ts.isIdentifierTypePredicate(b);
	        }
	        // This function assumes the constituent type list is sorted and deduplicated.
	        function getUnionTypeFromSortedList(types, aliasSymbol, aliasTypeArguments) {
	            if (types.length === 0) {
	                return neverType;
	            }
	            if (types.length === 1) {
	                return types[0];
	            }
	            var id = getTypeListId(types);
	            var type = unionTypes.get(id);
	            if (!type) {
	                var propagatedFlags = getPropagatingFlagsOfTypes(types, /*excludeKinds*/ 12288 /* Nullable */);
	                type = createType(131072 /* Union */ | propagatedFlags);
	                unionTypes.set(id, type);
	                type.types = types;
	                /*
	                Note: This is the alias symbol (or lack thereof) that we see when we first encounter this union type.
	                For aliases of identical unions, eg `type T = A | B; type U = A | B`, the symbol of the first alias encountered is the aliasSymbol.
	                (In the language service, the order may depend on the order in which a user takes actions, such as hovering over symbols.)
	                It's important that we create equivalent union types only once, so that's an unfortunate side effect.
	                */
	                type.aliasSymbol = aliasSymbol;
	                type.aliasTypeArguments = aliasTypeArguments;
	            }
	            return type;
	        }
	        function getTypeFromUnionTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getUnionType(ts.map(node.types, getTypeFromTypeNode), 1 /* Literal */, getAliasSymbolForTypeNode(node), getAliasTypeArgumentsForTypeNode(node));
	            }
	            return links.resolvedType;
	        }
	        function addTypeToIntersection(typeSet, includes, type) {
	            var flags = type.flags;
	            if (flags & 262144 /* Intersection */) {
	                includes = addTypesToIntersection(typeSet, includes, type.types);
	            }
	            else if (flags & 1 /* Any */) {
	                includes |= 1 /* Any */;
	            }
	            else if (flags & 16384 /* Never */) {
	                includes |= 8 /* Never */;
	            }
	            else if (ts.getObjectFlags(type) & 16 /* Anonymous */ && isEmptyObjectType(type)) {
	                includes |= 1024 /* EmptyObject */;
	            }
	            else if ((strictNullChecks || !(flags & 12288 /* Nullable */)) && !ts.contains(typeSet, type)) {
	                if (flags & 65536 /* Object */) {
	                    includes |= 512 /* ObjectType */;
	                }
	                if (flags & 131072 /* Union */) {
	                    includes |= 2048 /* Union */;
	                }
	                if (!(flags & 65536 /* Object */ && type.objectFlags & 16 /* Anonymous */ &&
	                    type.symbol && type.symbol.flags & (16 /* Function */ | 8192 /* Method */) && containsIdenticalType(typeSet, type))) {
	                    typeSet.push(type);
	                }
	            }
	            return includes;
	        }
	        // Add the given types to the given type set. Order is preserved, freshness is removed from literal
	        // types, duplicates are removed, and nested types of the given kind are flattened into the set.
	        function addTypesToIntersection(typeSet, includes, types) {
	            for (var _i = 0, types_8 = types; _i < types_8.length; _i++) {
	                var type = types_8[_i];
	                includes = addTypeToIntersection(typeSet, includes, getRegularTypeOfLiteralType(type));
	            }
	            return includes;
	        }
	        // We normalize combinations of intersection and union types based on the distributive property of the '&'
	        // operator. Specifically, because X & (A | B) is equivalent to X & A | X & B, we can transform intersection
	        // types with union type constituents into equivalent union types with intersection type constituents and
	        // effectively ensure that union types are always at the top level in type representations.
	        //
	        // We do not perform structural deduplication on intersection types. Intersection types are created only by the &
	        // type operator and we can't reduce those because we want to support recursive intersection types. For example,
	        // a type alias of the form "type List<T> = T & { next: List<T> }" cannot be reduced during its declaration.
	        // Also, unlike union types, the order of the constituent types is preserved in order that overload resolution
	        // for intersections of types with signatures can be deterministic.
	        function getIntersectionType(types, aliasSymbol, aliasTypeArguments) {
	            if (types.length === 0) {
	                return emptyObjectType;
	            }
	            var typeSet = [];
	            var includes = addTypesToIntersection(typeSet, 0, types);
	            if (includes & 8 /* Never */) {
	                return neverType;
	            }
	            if (includes & 1 /* Any */) {
	                return anyType;
	            }
	            if (includes & 1024 /* EmptyObject */ && !(includes & 512 /* ObjectType */)) {
	                typeSet.push(emptyObjectType);
	            }
	            if (typeSet.length === 1) {
	                return typeSet[0];
	            }
	            if (includes & 2048 /* Union */) {
	                // We are attempting to construct a type of the form X & (A | B) & Y. Transform this into a type of
	                // the form X & A & Y | X & B & Y and recursively reduce until no union type constituents remain.
	                var unionIndex_1 = ts.findIndex(typeSet, function (t) { return (t.flags & 131072 /* Union */) !== 0; });
	                var unionType = typeSet[unionIndex_1];
	                return getUnionType(ts.map(unionType.types, function (t) { return getIntersectionType(ts.replaceElement(typeSet, unionIndex_1, t)); }), 1 /* Literal */, aliasSymbol, aliasTypeArguments);
	            }
	            var id = getTypeListId(typeSet);
	            var type = intersectionTypes.get(id);
	            if (!type) {
	                var propagatedFlags = getPropagatingFlagsOfTypes(typeSet, /*excludeKinds*/ 12288 /* Nullable */);
	                type = createType(262144 /* Intersection */ | propagatedFlags);
	                intersectionTypes.set(id, type);
	                type.types = typeSet;
	                type.aliasSymbol = aliasSymbol; // See comment in `getUnionTypeFromSortedList`.
	                type.aliasTypeArguments = aliasTypeArguments;
	            }
	            return type;
	        }
	        function getTypeFromIntersectionTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getIntersectionType(ts.map(node.types, getTypeFromTypeNode), getAliasSymbolForTypeNode(node), getAliasTypeArgumentsForTypeNode(node));
	            }
	            return links.resolvedType;
	        }
	        function getIndexTypeForGenericType(type) {
	            if (!type.resolvedIndexType) {
	                type.resolvedIndexType = createType(524288 /* Index */);
	                type.resolvedIndexType.type = type;
	            }
	            return type.resolvedIndexType;
	        }
	        function getLiteralTypeFromPropertyName(prop) {
	            return ts.getDeclarationModifierFlagsFromSymbol(prop) & 24 /* NonPublicAccessibilityModifier */ || ts.isKnownSymbol(prop) ?
	                neverType :
	                getLiteralType(ts.symbolName(prop));
	        }
	        function getLiteralTypeFromPropertyNames(type) {
	            return getUnionType(ts.map(getPropertiesOfType(type), getLiteralTypeFromPropertyName));
	        }
	        function getIndexType(type) {
	            return maybeTypeOfKind(type, 7372800 /* InstantiableNonPrimitive */) ? getIndexTypeForGenericType(type) :
	                ts.getObjectFlags(type) & 32 /* Mapped */ ? getConstraintTypeFromMappedType(type) :
	                    type === wildcardType ? wildcardType :
	                        type.flags & 1 /* Any */ || getIndexInfoOfType(type, 0 /* String */) ? stringType :
	                            getLiteralTypeFromPropertyNames(type);
	        }
	        function getIndexTypeOrString(type) {
	            var indexType = getIndexType(type);
	            return indexType.flags & 16384 /* Never */ ? stringType : indexType;
	        }
	        function getTypeFromTypeOperatorNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                switch (node.operator) {
	                    case 128 /* KeyOfKeyword */:
	                        links.resolvedType = getIndexType(getTypeFromTypeNode(node.type));
	                        break;
	                    case 141 /* UniqueKeyword */:
	                        links.resolvedType = node.type.kind === 138 /* SymbolKeyword */
	                            ? getESSymbolLikeTypeForNode(ts.walkUpParenthesizedTypes(node.parent))
	                            : unknownType;
	                        break;
	                }
	            }
	            return links.resolvedType;
	        }
	        function createIndexedAccessType(objectType, indexType) {
	            var type = createType(1048576 /* IndexedAccess */);
	            type.objectType = objectType;
	            type.indexType = indexType;
	            return type;
	        }
	        function getPropertyTypeForIndexType(objectType, indexType, accessNode, cacheSymbol) {
	            var accessExpression = accessNode && accessNode.kind === 184 /* ElementAccessExpression */ ? accessNode : undefined;
	            var propName = isTypeUsableAsLateBoundName(indexType) ? getLateBoundNameFromType(indexType) :
	                accessExpression && checkThatExpressionIsProperSymbolReference(accessExpression.argumentExpression, indexType, /*reportError*/ false) ?
	                    ts.getPropertyNameForKnownSymbolName(ts.idText(accessExpression.argumentExpression.name)) :
	                    undefined;
	            if (propName !== undefined) {
	                var prop = getPropertyOfType(objectType, propName);
	                if (prop) {
	                    if (accessExpression) {
	                        markPropertyAsReferenced(prop, accessExpression, /*isThisAccess*/ accessExpression.expression.kind === 99 /* ThisKeyword */);
	                        if (ts.isAssignmentTarget(accessExpression) && (isReferenceToReadonlyEntity(accessExpression, prop) || isReferenceThroughNamespaceImport(accessExpression))) {
	                            error(accessExpression.argumentExpression, ts.Diagnostics.Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property, symbolToString(prop));
	                            return unknownType;
	                        }
	                        if (cacheSymbol) {
	                            getNodeLinks(accessNode).resolvedSymbol = prop;
	                        }
	                    }
	                    return getTypeOfSymbol(prop);
	                }
	            }
	            if (!(indexType.flags & 12288 /* Nullable */) && isTypeAssignableToKind(indexType, 524322 /* StringLike */ | 84 /* NumberLike */ | 1536 /* ESSymbolLike */)) {
	                if (isTypeAny(objectType)) {
	                    return objectType;
	                }
	                var indexInfo = isTypeAssignableToKind(indexType, 84 /* NumberLike */) && getIndexInfoOfType(objectType, 1 /* Number */) ||
	                    getIndexInfoOfType(objectType, 0 /* String */) ||
	                    undefined;
	                if (indexInfo) {
	                    if (accessExpression && indexInfo.isReadonly && (ts.isAssignmentTarget(accessExpression) || ts.isDeleteTarget(accessExpression))) {
	                        error(accessExpression, ts.Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(objectType));
	                    }
	                    return indexInfo.type;
	                }
	                if (accessExpression && !isConstEnumObjectType(objectType)) {
	                    if (noImplicitAny && !compilerOptions.suppressImplicitAnyIndexErrors) {
	                        if (getIndexTypeOfType(objectType, 1 /* Number */)) {
	                            error(accessExpression.argumentExpression, ts.Diagnostics.Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number);
	                        }
	                        else {
	                            error(accessExpression, ts.Diagnostics.Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature, typeToString(objectType));
	                        }
	                    }
	                    return anyType;
	                }
	            }
	            if (accessNode) {
	                var indexNode = accessNode.kind === 184 /* ElementAccessExpression */ ? accessNode.argumentExpression : accessNode.indexType;
	                if (indexType.flags & (32 /* StringLiteral */ | 64 /* NumberLiteral */)) {
	                    error(indexNode, ts.Diagnostics.Property_0_does_not_exist_on_type_1, "" + indexType.value, typeToString(objectType));
	                }
	                else if (indexType.flags & (2 /* String */ | 4 /* Number */)) {
	                    error(indexNode, ts.Diagnostics.Type_0_has_no_matching_index_signature_for_type_1, typeToString(objectType), typeToString(indexType));
	                }
	                else {
	                    error(indexNode, ts.Diagnostics.Type_0_cannot_be_used_as_an_index_type, typeToString(indexType));
	                }
	                return unknownType;
	            }
	            return anyType;
	        }
	        function isGenericObjectType(type) {
	            return maybeTypeOfKind(type, 7372800 /* InstantiableNonPrimitive */ | 536870912 /* GenericMappedType */);
	        }
	        function isGenericIndexType(type) {
	            return maybeTypeOfKind(type, 7372800 /* InstantiableNonPrimitive */ | 524288 /* Index */);
	        }
	        // Return true if the given type is a non-generic object type with a string index signature and no
	        // other members.
	        function isStringIndexOnlyType(type) {
	            if (type.flags & 65536 /* Object */ && !isGenericMappedType(type)) {
	                var t = resolveStructuredTypeMembers(type);
	                return t.properties.length === 0 &&
	                    t.callSignatures.length === 0 && t.constructSignatures.length === 0 &&
	                    t.stringIndexInfo && !t.numberIndexInfo;
	            }
	            return false;
	        }
	        function isMappedTypeToNever(type) {
	            return ts.getObjectFlags(type) & 32 /* Mapped */ && getTemplateTypeFromMappedType(type) === neverType;
	        }
	        // Transform an indexed access to a simpler form, if possible. Return the simpler form, or return
	        // undefined if no transformation is possible.
	        function getSimplifiedIndexedAccessType(type) {
	            var objectType = type.objectType;
	            if (objectType.flags & 262144 /* Intersection */ && isGenericObjectType(objectType)) {
	                // Given an indexed access type T[K], if T is an intersection containing one or more generic types and one or
	                // more object types with only a string index signature, e.g. '(U & V & { [x: string]: D })[K]', return a
	                // transformed type of the form '(U & V)[K] | D'. This allows us to properly reason about higher order indexed
	                // access types with default property values as expressed by D.
	                if (ts.some(objectType.types, isStringIndexOnlyType)) {
	                    var regularTypes = [];
	                    var stringIndexTypes = [];
	                    for (var _i = 0, _a = objectType.types; _i < _a.length; _i++) {
	                        var t = _a[_i];
	                        if (isStringIndexOnlyType(t)) {
	                            stringIndexTypes.push(getIndexTypeOfType(t, 0 /* String */));
	                        }
	                        else {
	                            regularTypes.push(t);
	                        }
	                    }
	                    return getUnionType([
	                        getIndexedAccessType(getIntersectionType(regularTypes), type.indexType),
	                        getIntersectionType(stringIndexTypes)
	                    ]);
	                }
	                // Given an indexed access type T[K], if T is an intersection containing one or more generic types and one or
	                // more mapped types with a template type `never`, '(U & V & { [P in T]: never })[K]', return a
	                // transformed type that removes the never-mapped type: '(U & V)[K]'. This mirrors what would happen
	                // eventually anyway, but it easier to reason about.
	                if (ts.some(objectType.types, isMappedTypeToNever)) {
	                    var nonNeverTypes = ts.filter(objectType.types, function (t) { return !isMappedTypeToNever(t); });
	                    return getIndexedAccessType(getIntersectionType(nonNeverTypes), type.indexType);
	                }
	            }
	            // If the object type is a mapped type { [P in K]: E }, where K is generic, instantiate E using a mapper
	            // that substitutes the index type for P. For example, for an index access { [P in K]: Box<T[P]> }[X], we
	            // construct the type Box<T[X]>.
	            if (isGenericMappedType(objectType)) {
	                return substituteIndexedMappedType(objectType, type);
	            }
	            if (objectType.flags & 32768 /* TypeParameter */) {
	                var constraint = getConstraintFromTypeParameter(objectType);
	                if (constraint && isGenericMappedType(constraint)) {
	                    return substituteIndexedMappedType(constraint, type);
	                }
	            }
	            return undefined;
	        }
	        function substituteIndexedMappedType(objectType, type) {
	            var mapper = createTypeMapper([getTypeParameterFromMappedType(objectType)], [type.indexType]);
	            var templateMapper = objectType.mapper ? combineTypeMappers(objectType.mapper, mapper) : mapper;
	            return instantiateType(getTemplateTypeFromMappedType(objectType), templateMapper);
	        }
	        function getIndexedAccessType(objectType, indexType, accessNode) {
	            // If the index type is generic, or if the object type is generic and doesn't originate in an expression,
	            // we are performing a higher-order index access where we cannot meaningfully access the properties of the
	            // object type. Note that for a generic T and a non-generic K, we eagerly resolve T[K] if it originates in
	            // an expression. This is to preserve backwards compatibility. For example, an element access 'this["foo"]'
	            // has always been resolved eagerly using the constraint type of 'this' at the given location.
	            if (isGenericIndexType(indexType) || !(accessNode && accessNode.kind === 184 /* ElementAccessExpression */) && isGenericObjectType(objectType)) {
	                if (objectType.flags & 1 /* Any */) {
	                    return objectType;
	                }
	                // Defer the operation by creating an indexed access type.
	                var id = objectType.id + "," + indexType.id;
	                var type = indexedAccessTypes.get(id);
	                if (!type) {
	                    indexedAccessTypes.set(id, type = createIndexedAccessType(objectType, indexType));
	                }
	                return type;
	            }
	            // In the following we resolve T[K] to the type of the property in T selected by K.
	            // We treat boolean as different from other unions to improve errors;
	            // skipping straight to getPropertyTypeForIndexType gives errors with 'boolean' instead of 'true'.
	            var apparentObjectType = getApparentType(objectType);
	            if (indexType.flags & 131072 /* Union */ && !(indexType.flags & 8 /* Boolean */)) {
	                var propTypes = [];
	                for (var _i = 0, _a = indexType.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    var propType = getPropertyTypeForIndexType(apparentObjectType, t, accessNode, /*cacheSymbol*/ false);
	                    if (propType === unknownType) {
	                        return unknownType;
	                    }
	                    propTypes.push(propType);
	                }
	                return getUnionType(propTypes);
	            }
	            return getPropertyTypeForIndexType(apparentObjectType, indexType, accessNode, /*cacheSymbol*/ true);
	        }
	        function getTypeFromIndexedAccessTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getIndexedAccessType(getTypeFromTypeNode(node.objectType), getTypeFromTypeNode(node.indexType), node);
	            }
	            return links.resolvedType;
	        }
	        function getTypeFromMappedTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                var type = createObjectType(32 /* Mapped */, node.symbol);
	                type.declaration = node;
	                type.aliasSymbol = getAliasSymbolForTypeNode(node);
	                type.aliasTypeArguments = getAliasTypeArgumentsForTypeNode(node);
	                links.resolvedType = type;
	                // Eagerly resolve the constraint type which forces an error if the constraint type circularly
	                // references itself through one or more type aliases.
	                getConstraintTypeFromMappedType(type);
	            }
	            return links.resolvedType;
	        }
	        function getActualTypeParameter(type) {
	            return type.flags & 4194304 /* Substitution */ ? type.typeParameter : type;
	        }
	        function createConditionalType(checkType, extendsType, trueType, falseType, inferTypeParameters, target, mapper, aliasSymbol, aliasTypeArguments) {
	            var type = createType(2097152 /* Conditional */);
	            type.checkType = checkType;
	            type.extendsType = extendsType;
	            type.trueType = trueType;
	            type.falseType = falseType;
	            type.inferTypeParameters = inferTypeParameters;
	            type.target = target;
	            type.mapper = mapper;
	            type.aliasSymbol = aliasSymbol;
	            type.aliasTypeArguments = aliasTypeArguments;
	            return type;
	        }
	        function getConditionalType(checkType, baseExtendsType, baseTrueType, baseFalseType, inferTypeParameters, target, mapper, aliasSymbol, baseAliasTypeArguments) {
	            // Instantiate extends type without instantiating any 'infer T' type parameters
	            var extendsType = instantiateType(baseExtendsType, mapper);
	            // Return falseType for a definitely false extends check. We check an instantations of the two
	            // types with type parameters mapped to the wildcard type, the most permissive instantiations
	            // possible (the wildcard type is assignable to and from all types). If those are not related,
	            // then no instatiations will be and we can just return the false branch type.
	            if (!typeMaybeAssignableTo(getWildcardInstantiation(checkType), getWildcardInstantiation(extendsType))) {
	                return instantiateType(baseFalseType, mapper);
	            }
	            // The check could be true for some instantiation
	            var combinedMapper;
	            if (inferTypeParameters) {
	                var inferences = ts.map(inferTypeParameters, createInferenceInfo);
	                // We don't want inferences from constraints as they may cause us to eagerly resolve the
	                // conditional type instead of deferring resolution. Also, we always want strict function
	                // types rules (i.e. proper contravariance) for inferences.
	                inferTypes(inferences, checkType, extendsType, 8 /* NoConstraints */ | 16 /* AlwaysStrict */);
	                // We infer 'never' when there are no candidates for a type parameter
	                var inferredTypes = ts.map(inferences, function (inference) { return getTypeFromInference(inference) || neverType; });
	                var inferenceMapper = createTypeMapper(inferTypeParameters, inferredTypes);
	                combinedMapper = mapper ? combineTypeMappers(mapper, inferenceMapper) : inferenceMapper;
	            }
	            // Return union of trueType and falseType for any and never since they match anything
	            if (checkType.flags & 1 /* Any */ || (checkType.flags & 16384 /* Never */ && !(extendsType.flags & 16384 /* Never */))) {
	                return getUnionType([instantiateType(baseTrueType, combinedMapper || mapper), instantiateType(baseFalseType, mapper)]);
	            }
	            // Instantiate the extends type including inferences for 'infer T' type parameters
	            var inferredExtendsType = combinedMapper ? instantiateType(baseExtendsType, combinedMapper) : extendsType;
	            // Return trueType for a definitely true extends check. The definitely assignable relation excludes
	            // type variable constraints from consideration. Without the definitely assignable relation, the type
	            //   type Foo<T extends { x: any }> = T extends { x: string } ? string : number
	            // would immediately resolve to 'string' instead of being deferred.
	            if (checkTypeRelatedTo(checkType, inferredExtendsType, definitelyAssignableRelation, /*errorNode*/ undefined)) {
	                return instantiateType(baseTrueType, combinedMapper || mapper);
	            }
	            // Return a deferred type for a check that is neither definitely true nor definitely false
	            var erasedCheckType = getActualTypeParameter(checkType);
	            var trueType = instantiateType(baseTrueType, mapper);
	            var falseType = instantiateType(baseFalseType, mapper);
	            // We compute the cache key from the ids of the four constituent types, plus an indicator of whether the
	            // type is distributive (i.e. whether the original declaration has a type parameter as the check type).
	            var isDistributive = (target ? target.checkType : erasedCheckType).flags & 32768 /* TypeParameter */ ? 1 : 0;
	            var id = erasedCheckType.id + "," + extendsType.id + "," + trueType.id + "," + falseType.id + "," + isDistributive;
	            var cached = conditionalTypes.get(id);
	            if (cached) {
	                return cached;
	            }
	            var result = createConditionalType(erasedCheckType, extendsType, trueType, falseType, inferTypeParameters, target, mapper, aliasSymbol, instantiateTypes(baseAliasTypeArguments, mapper));
	            conditionalTypes.set(id, result);
	            return result;
	        }
	        function isDistributiveConditionalType(type) {
	            return !!((type.target || type).checkType.flags & 32768 /* TypeParameter */);
	        }
	        function getInferTypeParameters(node) {
	            var result;
	            if (node.locals) {
	                node.locals.forEach(function (symbol) {
	                    if (symbol.flags & 262144 /* TypeParameter */) {
	                        result = ts.append(result, getDeclaredTypeOfSymbol(symbol));
	                    }
	                });
	            }
	            return result;
	        }
	        function getTypeFromConditionalTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getConditionalType(getTypeFromTypeNode(node.checkType), getTypeFromTypeNode(node.extendsType), getTypeFromTypeNode(node.trueType), getTypeFromTypeNode(node.falseType), getInferTypeParameters(node), /*target*/ undefined, /*mapper*/ undefined, getAliasSymbolForTypeNode(node), getAliasTypeArgumentsForTypeNode(node));
	            }
	            return links.resolvedType;
	        }
	        function getTypeFromInferTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getDeclaredTypeOfTypeParameter(getSymbolOfNode(node.typeParameter));
	            }
	            return links.resolvedType;
	        }
	        function getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                // Deferred resolution of members is handled by resolveObjectTypeMembers
	                var aliasSymbol = getAliasSymbolForTypeNode(node);
	                if (getMembersOfSymbol(node.symbol).size === 0 && !aliasSymbol) {
	                    links.resolvedType = emptyTypeLiteralType;
	                }
	                else {
	                    var type = createObjectType(16 /* Anonymous */, node.symbol);
	                    type.aliasSymbol = aliasSymbol;
	                    type.aliasTypeArguments = getAliasTypeArgumentsForTypeNode(node);
	                    if (ts.isJSDocTypeLiteral(node) && node.isArrayType) {
	                        type = createArrayType(type);
	                    }
	                    links.resolvedType = type;
	                }
	            }
	            return links.resolvedType;
	        }
	        function getAliasSymbolForTypeNode(node) {
	            return node.parent.kind === 235 /* TypeAliasDeclaration */ ? getSymbolOfNode(node.parent) : undefined;
	        }
	        function getAliasTypeArgumentsForTypeNode(node) {
	            var symbol = getAliasSymbolForTypeNode(node);
	            return symbol ? getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol) : undefined;
	        }
	        /**
	         * Since the source of spread types are object literals, which are not binary,
	         * this function should be called in a left folding style, with left = previous result of getSpreadType
	         * and right = the new element to be spread.
	         */
	        function getSpreadType(left, right, symbol, typeFlags, objectFlags) {
	            if (left.flags & 1 /* Any */ || right.flags & 1 /* Any */) {
	                return anyType;
	            }
	            if (left.flags & 16384 /* Never */) {
	                return right;
	            }
	            if (right.flags & 16384 /* Never */) {
	                return left;
	            }
	            if (left.flags & 131072 /* Union */) {
	                return mapType(left, function (t) { return getSpreadType(t, right, symbol, typeFlags, objectFlags); });
	            }
	            if (right.flags & 131072 /* Union */) {
	                return mapType(right, function (t) { return getSpreadType(left, t, symbol, typeFlags, objectFlags); });
	            }
	            if (right.flags & (136 /* BooleanLike */ | 84 /* NumberLike */ | 524322 /* StringLike */ | 272 /* EnumLike */ | 134217728 /* NonPrimitive */)) {
	                return left;
	            }
	            var members = ts.createSymbolTable();
	            var skippedPrivateMembers = ts.createUnderscoreEscapedMap();
	            var stringIndexInfo;
	            var numberIndexInfo;
	            if (left === emptyObjectType) {
	                // for the first spread element, left === emptyObjectType, so take the right's string indexer
	                stringIndexInfo = getIndexInfoOfType(right, 0 /* String */);
	                numberIndexInfo = getIndexInfoOfType(right, 1 /* Number */);
	            }
	            else {
	                stringIndexInfo = unionSpreadIndexInfos(getIndexInfoOfType(left, 0 /* String */), getIndexInfoOfType(right, 0 /* String */));
	                numberIndexInfo = unionSpreadIndexInfos(getIndexInfoOfType(left, 1 /* Number */), getIndexInfoOfType(right, 1 /* Number */));
	            }
	            for (var _i = 0, _a = getPropertiesOfType(right); _i < _a.length; _i++) {
	                var rightProp = _a[_i];
	                // we approximate own properties as non-methods plus methods that are inside the object literal
	                var isSetterWithoutGetter = rightProp.flags & 65536 /* SetAccessor */ && !(rightProp.flags & 32768 /* GetAccessor */);
	                if (ts.getDeclarationModifierFlagsFromSymbol(rightProp) & (8 /* Private */ | 16 /* Protected */)) {
	                    skippedPrivateMembers.set(rightProp.escapedName, true);
	                }
	                else if (!isClassMethod(rightProp) && !isSetterWithoutGetter) {
	                    members.set(rightProp.escapedName, getNonReadonlySymbol(rightProp));
	                }
	            }
	            for (var _b = 0, _c = getPropertiesOfType(left); _b < _c.length; _b++) {
	                var leftProp = _c[_b];
	                if (leftProp.flags & 65536 /* SetAccessor */ && !(leftProp.flags & 32768 /* GetAccessor */)
	                    || skippedPrivateMembers.has(leftProp.escapedName)
	                    || isClassMethod(leftProp)) {
	                    continue;
	                }
	                if (members.has(leftProp.escapedName)) {
	                    var rightProp = members.get(leftProp.escapedName);
	                    var rightType = getTypeOfSymbol(rightProp);
	                    if (rightProp.flags & 16777216 /* Optional */) {
	                        var declarations = ts.concatenate(leftProp.declarations, rightProp.declarations);
	                        var flags = 4 /* Property */ | (leftProp.flags & 16777216 /* Optional */);
	                        var result = createSymbol(flags, leftProp.escapedName);
	                        result.type = getUnionType([getTypeOfSymbol(leftProp), getTypeWithFacts(rightType, 131072 /* NEUndefined */)]);
	                        result.leftSpread = leftProp;
	                        result.rightSpread = rightProp;
	                        result.declarations = declarations;
	                        members.set(leftProp.escapedName, result);
	                    }
	                }
	                else {
	                    members.set(leftProp.escapedName, getNonReadonlySymbol(leftProp));
	                }
	            }
	            var spread = createAnonymousType(symbol, members, ts.emptyArray, ts.emptyArray, getNonReadonlyIndexSignature(stringIndexInfo), getNonReadonlyIndexSignature(numberIndexInfo));
	            spread.flags |= typeFlags | 33554432 /* ContainsObjectLiteral */;
	            spread.objectFlags |= objectFlags | (128 /* ObjectLiteral */ | 1024 /* ContainsSpread */);
	            return spread;
	        }
	        function getNonReadonlySymbol(prop) {
	            if (!isReadonlySymbol(prop)) {
	                return prop;
	            }
	            var flags = 4 /* Property */ | (prop.flags & 16777216 /* Optional */);
	            var result = createSymbol(flags, prop.escapedName);
	            result.type = getTypeOfSymbol(prop);
	            result.declarations = prop.declarations;
	            result.syntheticOrigin = prop;
	            return result;
	        }
	        function getNonReadonlyIndexSignature(index) {
	            if (index && index.isReadonly) {
	                return createIndexInfo(index.type, /*isReadonly*/ false, index.declaration);
	            }
	            return index;
	        }
	        function isClassMethod(prop) {
	            return prop.flags & 8192 /* Method */ && ts.find(prop.declarations, function (decl) { return ts.isClassLike(decl.parent); });
	        }
	        function createLiteralType(flags, value, symbol) {
	            var type = createType(flags);
	            type.symbol = symbol;
	            type.value = value;
	            return type;
	        }
	        function getFreshTypeOfLiteralType(type) {
	            if (type.flags & 96 /* StringOrNumberLiteral */ && !(type.flags & 8388608 /* FreshLiteral */)) {
	                if (!type.freshType) {
	                    var freshType = createLiteralType(type.flags | 8388608 /* FreshLiteral */, type.value, type.symbol);
	                    freshType.regularType = type;
	                    type.freshType = freshType;
	                }
	                return type.freshType;
	            }
	            return type;
	        }
	        function getRegularTypeOfLiteralType(type) {
	            return type.flags & 96 /* StringOrNumberLiteral */ && type.flags & 8388608 /* FreshLiteral */ ? type.regularType : type;
	        }
	        function getLiteralType(value, enumId, symbol) {
	            // We store all literal types in a single map with keys of the form '#NNN' and '@SSS',
	            // where NNN is the text representation of a numeric literal and SSS are the characters
	            // of a string literal. For literal enum members we use 'EEE#NNN' and 'EEE@SSS', where
	            // EEE is a unique id for the containing enum type.
	            var qualifier = typeof value === "number" ? "#" : "@";
	            var key = enumId ? enumId + qualifier + value : qualifier + value;
	            var type = literalTypes.get(key);
	            if (!type) {
	                var flags = (typeof value === "number" ? 64 /* NumberLiteral */ : 32 /* StringLiteral */) | (enumId ? 256 /* EnumLiteral */ : 0);
	                literalTypes.set(key, type = createLiteralType(flags, value, symbol));
	            }
	            return type;
	        }
	        function getTypeFromLiteralTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getRegularTypeOfLiteralType(checkExpression(node.literal));
	            }
	            return links.resolvedType;
	        }
	        function createUniqueESSymbolType(symbol) {
	            var type = createType(1024 /* UniqueESSymbol */);
	            type.symbol = symbol;
	            return type;
	        }
	        function getESSymbolLikeTypeForNode(node) {
	            if (ts.isValidESSymbolDeclaration(node)) {
	                var symbol = getSymbolOfNode(node);
	                var links = getSymbolLinks(symbol);
	                return links.uniqueESSymbolType || (links.uniqueESSymbolType = createUniqueESSymbolType(symbol));
	            }
	            return esSymbolType;
	        }
	        function getThisType(node) {
	            var container = ts.getThisContainer(node, /*includeArrowFunctions*/ false);
	            var parent = container && container.parent;
	            if (parent && (ts.isClassLike(parent) || parent.kind === 234 /* InterfaceDeclaration */)) {
	                if (!ts.hasModifier(container, 32 /* Static */) &&
	                    (container.kind !== 154 /* Constructor */ || ts.isNodeDescendantOf(node, container.body))) {
	                    return getDeclaredTypeOfClassOrInterface(getSymbolOfNode(parent)).thisType;
	                }
	            }
	            error(node, ts.Diagnostics.A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface);
	            return unknownType;
	        }
	        function getTypeFromThisTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getThisType(node);
	            }
	            return links.resolvedType;
	        }
	        function getTypeFromTypeNode(node) {
	            switch (node.kind) {
	                case 119 /* AnyKeyword */:
	                case 275 /* JSDocAllType */:
	                case 276 /* JSDocUnknownType */:
	                    return anyType;
	                case 137 /* StringKeyword */:
	                    return stringType;
	                case 134 /* NumberKeyword */:
	                    return numberType;
	                case 122 /* BooleanKeyword */:
	                    return booleanType;
	                case 138 /* SymbolKeyword */:
	                    return esSymbolType;
	                case 105 /* VoidKeyword */:
	                    return voidType;
	                case 140 /* UndefinedKeyword */:
	                    return undefinedType;
	                case 95 /* NullKeyword */:
	                    return nullType;
	                case 131 /* NeverKeyword */:
	                    return neverType;
	                case 135 /* ObjectKeyword */:
	                    return node.flags & 65536 /* JavaScriptFile */ ? anyType : nonPrimitiveType;
	                case 173 /* ThisType */:
	                case 99 /* ThisKeyword */:
	                    return getTypeFromThisTypeNode(node);
	                case 177 /* LiteralType */:
	                    return getTypeFromLiteralTypeNode(node);
	                case 161 /* TypeReference */:
	                    return getTypeFromTypeReference(node);
	                case 160 /* TypePredicate */:
	                    return booleanType;
	                case 205 /* ExpressionWithTypeArguments */:
	                    return getTypeFromTypeReference(node);
	                case 164 /* TypeQuery */:
	                    return getTypeFromTypeQueryNode(node);
	                case 166 /* ArrayType */:
	                    return getTypeFromArrayTypeNode(node);
	                case 167 /* TupleType */:
	                    return getTypeFromTupleTypeNode(node);
	                case 168 /* UnionType */:
	                    return getTypeFromUnionTypeNode(node);
	                case 169 /* IntersectionType */:
	                    return getTypeFromIntersectionTypeNode(node);
	                case 277 /* JSDocNullableType */:
	                    return getTypeFromJSDocNullableTypeNode(node);
	                case 172 /* ParenthesizedType */:
	                case 278 /* JSDocNonNullableType */:
	                case 279 /* JSDocOptionalType */:
	                case 274 /* JSDocTypeExpression */:
	                    return getTypeFromTypeNode(node.type);
	                case 281 /* JSDocVariadicType */:
	                    return getTypeFromJSDocVariadicType(node);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                case 165 /* TypeLiteral */:
	                case 283 /* JSDocTypeLiteral */:
	                case 280 /* JSDocFunctionType */:
	                    return getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node);
	                case 174 /* TypeOperator */:
	                    return getTypeFromTypeOperatorNode(node);
	                case 175 /* IndexedAccessType */:
	                    return getTypeFromIndexedAccessTypeNode(node);
	                case 176 /* MappedType */:
	                    return getTypeFromMappedTypeNode(node);
	                case 170 /* ConditionalType */:
	                    return getTypeFromConditionalTypeNode(node);
	                case 171 /* InferType */:
	                    return getTypeFromInferTypeNode(node);
	                // This function assumes that an identifier or qualified name is a type expression
	                // Callers should first ensure this by calling isTypeNode
	                case 71 /* Identifier */:
	                case 145 /* QualifiedName */:
	                    var symbol = getSymbolAtLocation(node);
	                    return symbol && getDeclaredTypeOfSymbol(symbol);
	                default:
	                    return unknownType;
	            }
	        }
	        function instantiateList(items, mapper, instantiator) {
	            if (items && items.length) {
	                for (var i = 0; i < items.length; i++) {
	                    var item = items[i];
	                    var mapped = instantiator(item, mapper);
	                    if (item !== mapped) {
	                        var result = i === 0 ? [] : items.slice(0, i);
	                        result.push(mapped);
	                        for (i++; i < items.length; i++) {
	                            result.push(instantiator(items[i], mapper));
	                        }
	                        return result;
	                    }
	                }
	            }
	            return items;
	        }
	        function instantiateTypes(types, mapper) {
	            return instantiateList(types, mapper, instantiateType);
	        }
	        function instantiateSignatures(signatures, mapper) {
	            return instantiateList(signatures, mapper, instantiateSignature);
	        }
	        function makeUnaryTypeMapper(source, target) {
	            return function (t) { return t === source ? target : t; };
	        }
	        function makeBinaryTypeMapper(source1, target1, source2, target2) {
	            return function (t) { return t === source1 ? target1 : t === source2 ? target2 : t; };
	        }
	        function makeArrayTypeMapper(sources, targets) {
	            return function (t) {
	                for (var i = 0; i < sources.length; i++) {
	                    if (t === sources[i]) {
	                        return targets ? targets[i] : anyType;
	                    }
	                }
	                return t;
	            };
	        }
	        function createTypeMapper(sources, targets) {
	            ts.Debug.assert(targets === undefined || sources.length === targets.length);
	            return sources.length === 1 ? makeUnaryTypeMapper(sources[0], targets ? targets[0] : anyType) :
	                sources.length === 2 ? makeBinaryTypeMapper(sources[0], targets ? targets[0] : anyType, sources[1], targets ? targets[1] : anyType) :
	                    makeArrayTypeMapper(sources, targets);
	        }
	        function createTypeEraser(sources) {
	            return createTypeMapper(sources, /*targets*/ undefined);
	        }
	        /**
	         * Maps forward-references to later types parameters to the empty object type.
	         * This is used during inference when instantiating type parameter defaults.
	         */
	        function createBackreferenceMapper(typeParameters, index) {
	            return function (t) { return typeParameters.indexOf(t) >= index ? emptyObjectType : t; };
	        }
	        function isInferenceContext(mapper) {
	            return !!mapper.signature;
	        }
	        function cloneTypeMapper(mapper) {
	            return mapper && isInferenceContext(mapper) ?
	                createInferenceContext(mapper.signature, mapper.flags | 2 /* NoDefault */, mapper.compareTypes, mapper.inferences) :
	                mapper;
	        }
	        function combineTypeMappers(mapper1, mapper2) {
	            return function (t) { return instantiateType(mapper1(t), mapper2); };
	        }
	        function createReplacementMapper(source, target, baseMapper) {
	            return function (t) { return t === source ? target : baseMapper(t); };
	        }
	        function wildcardMapper(type) {
	            return type.flags & 32768 /* TypeParameter */ ? wildcardType : type;
	        }
	        function cloneTypeParameter(typeParameter) {
	            var result = createType(32768 /* TypeParameter */);
	            result.symbol = typeParameter.symbol;
	            result.target = typeParameter;
	            return result;
	        }
	        function instantiateTypePredicate(predicate, mapper) {
	            if (ts.isIdentifierTypePredicate(predicate)) {
	                return {
	                    kind: 1 /* Identifier */,
	                    parameterName: predicate.parameterName,
	                    parameterIndex: predicate.parameterIndex,
	                    type: instantiateType(predicate.type, mapper)
	                };
	            }
	            else {
	                return {
	                    kind: 0 /* This */,
	                    type: instantiateType(predicate.type, mapper)
	                };
	            }
	        }
	        function instantiateSignature(signature, mapper, eraseTypeParameters) {
	            var freshTypeParameters;
	            if (signature.typeParameters && !eraseTypeParameters) {
	                // First create a fresh set of type parameters, then include a mapping from the old to the
	                // new type parameters in the mapper function. Finally store this mapper in the new type
	                // parameters such that we can use it when instantiating constraints.
	                freshTypeParameters = ts.map(signature.typeParameters, cloneTypeParameter);
	                mapper = combineTypeMappers(createTypeMapper(signature.typeParameters, freshTypeParameters), mapper);
	                for (var _i = 0, freshTypeParameters_1 = freshTypeParameters; _i < freshTypeParameters_1.length; _i++) {
	                    var tp = freshTypeParameters_1[_i];
	                    tp.mapper = mapper;
	                }
	            }
	            // Don't compute resolvedReturnType and resolvedTypePredicate now,
	            // because using `mapper` now could trigger inferences to become fixed. (See `createInferenceContext`.)
	            // See GH#17600.
	            var result = createSignature(signature.declaration, freshTypeParameters, signature.thisParameter && instantiateSymbol(signature.thisParameter, mapper), instantiateList(signature.parameters, mapper, instantiateSymbol), 
	            /*resolvedReturnType*/ undefined, 
	            /*resolvedTypePredicate*/ undefined, signature.minArgumentCount, signature.hasRestParameter, signature.hasLiteralTypes);
	            result.target = signature;
	            result.mapper = mapper;
	            return result;
	        }
	        function instantiateSymbol(symbol, mapper) {
	            var links = getSymbolLinks(symbol);
	            if (links.type && !maybeTypeOfKind(links.type, 65536 /* Object */ | 7897088 /* Instantiable */)) {
	                // If the type of the symbol is already resolved, and if that type could not possibly
	                // be affected by instantiation, simply return the symbol itself.
	                return symbol;
	            }
	            if (ts.getCheckFlags(symbol) & 1 /* Instantiated */) {
	                // If symbol being instantiated is itself a instantiation, fetch the original target and combine the
	                // type mappers. This ensures that original type identities are properly preserved and that aliases
	                // always reference a non-aliases.
	                symbol = links.target;
	                mapper = combineTypeMappers(links.mapper, mapper);
	            }
	            // Keep the flags from the symbol we're instantiating.  Mark that is instantiated, and
	            // also transient so that we can just store data on it directly.
	            var result = createSymbol(symbol.flags, symbol.escapedName, 1 /* Instantiated */);
	            result.declarations = symbol.declarations;
	            result.parent = symbol.parent;
	            result.target = symbol;
	            result.mapper = mapper;
	            if (symbol.valueDeclaration) {
	                result.valueDeclaration = symbol.valueDeclaration;
	            }
	            if (symbol.isRestParameter) {
	                result.isRestParameter = symbol.isRestParameter;
	            }
	            return result;
	        }
	        function getAnonymousTypeInstantiation(type, mapper) {
	            var target = type.objectFlags & 64 /* Instantiated */ ? type.target : type;
	            var symbol = target.symbol;
	            var links = getSymbolLinks(symbol);
	            var typeParameters = links.outerTypeParameters;
	            if (!typeParameters) {
	                // The first time an anonymous type is instantiated we compute and store a list of the type
	                // parameters that are in scope (and therefore potentially referenced). For type literals that
	                // aren't the right hand side of a generic type alias declaration we optimize by reducing the
	                // set of type parameters to those that are possibly referenced in the literal.
	                var declaration_1 = symbol.declarations[0];
	                var outerTypeParameters = getOuterTypeParameters(declaration_1, /*includeThisTypes*/ true) || ts.emptyArray;
	                typeParameters = symbol.flags & 2048 /* TypeLiteral */ && !target.aliasTypeArguments ?
	                    ts.filter(outerTypeParameters, function (tp) { return isTypeParameterPossiblyReferenced(tp, declaration_1); }) :
	                    outerTypeParameters;
	                links.outerTypeParameters = typeParameters;
	                if (typeParameters.length) {
	                    links.instantiations = ts.createMap();
	                    links.instantiations.set(getTypeListId(typeParameters), target);
	                }
	            }
	            if (typeParameters.length) {
	                // We are instantiating an anonymous type that has one or more type parameters in scope. Apply the
	                // mapper to the type parameters to produce the effective list of type arguments, and compute the
	                // instantiation cache key from the type IDs of the type arguments.
	                var combinedMapper = type.objectFlags & 64 /* Instantiated */ ? combineTypeMappers(type.mapper, mapper) : mapper;
	                var typeArguments = ts.map(typeParameters, combinedMapper);
	                var id = getTypeListId(typeArguments);
	                var result = links.instantiations.get(id);
	                if (!result) {
	                    var newMapper = createTypeMapper(typeParameters, typeArguments);
	                    result = target.objectFlags & 32 /* Mapped */ ? instantiateMappedType(target, newMapper) : instantiateAnonymousType(target, newMapper);
	                    links.instantiations.set(id, result);
	                }
	                return result;
	            }
	            return type;
	        }
	        function isTypeParameterPossiblyReferenced(tp, node) {
	            // If the type parameter doesn't have exactly one declaration, if there are invening statement blocks
	            // between the node and the type parameter declaration, if the node contains actual references to the
	            // type parameter, or if the node contains type queries, we consider the type parameter possibly referenced.
	            if (tp.symbol && tp.symbol.declarations && tp.symbol.declarations.length === 1) {
	                var container_1 = tp.symbol.declarations[0].parent;
	                if (ts.findAncestor(node, function (n) { return n.kind === 211 /* Block */ ? "quit" : n === container_1; })) {
	                    return ts.forEachChild(node, containsReference);
	                }
	            }
	            return true;
	            function containsReference(node) {
	                switch (node.kind) {
	                    case 173 /* ThisType */:
	                        return tp.isThisType;
	                    case 71 /* Identifier */:
	                        return !tp.isThisType && ts.isPartOfTypeNode(node) && getTypeFromTypeNode(node) === tp;
	                    case 164 /* TypeQuery */:
	                        return true;
	                }
	                return ts.forEachChild(node, containsReference);
	            }
	        }
	        function instantiateMappedType(type, mapper) {
	            // Check if we have a homomorphic mapped type, i.e. a type of the form { [P in keyof T]: X } for some
	            // type variable T. If so, the mapped type is distributive over a union type and when T is instantiated
	            // to a union type A | B, we produce { [P in keyof A]: X } | { [P in keyof B]: X }. Furthermore, for
	            // homomorphic mapped types we leave primitive types alone. For example, when T is instantiated to a
	            // union type A | undefined, we produce { [P in keyof A]: X } | undefined.
	            var constraintType = getConstraintTypeFromMappedType(type);
	            if (constraintType.flags & 524288 /* Index */) {
	                var typeVariable_1 = constraintType.type;
	                if (typeVariable_1.flags & 32768 /* TypeParameter */) {
	                    var mappedTypeVariable = instantiateType(typeVariable_1, mapper);
	                    if (typeVariable_1 !== mappedTypeVariable) {
	                        return mapType(mappedTypeVariable, function (t) {
	                            if (isMappableType(t)) {
	                                return instantiateAnonymousType(type, createReplacementMapper(typeVariable_1, t, mapper));
	                            }
	                            return t;
	                        });
	                    }
	                }
	            }
	            return instantiateAnonymousType(type, mapper);
	        }
	        function isMappableType(type) {
	            return type.flags & (1 /* Any */ | 7372800 /* InstantiableNonPrimitive */ | 65536 /* Object */ | 262144 /* Intersection */);
	        }
	        function instantiateAnonymousType(type, mapper) {
	            var result = createObjectType(type.objectFlags | 64 /* Instantiated */, type.symbol);
	            if (type.objectFlags & 32 /* Mapped */) {
	                result.declaration = type.declaration;
	            }
	            result.target = type;
	            result.mapper = mapper;
	            result.aliasSymbol = type.aliasSymbol;
	            result.aliasTypeArguments = instantiateTypes(type.aliasTypeArguments, mapper);
	            return result;
	        }
	        function getConditionalTypeInstantiation(type, mapper) {
	            var target = type.target || type;
	            var combinedMapper = type.mapper ? combineTypeMappers(type.mapper, mapper) : mapper;
	            // Check if we have a conditional type where the check type is a naked type parameter. If so,
	            // the conditional type is distributive over union types and when T is instantiated to a union
	            // type A | B, we produce (A extends U ? X : Y) | (B extends U ? X : Y).
	            if (isDistributiveConditionalType(target)) {
	                var checkType_1 = target.checkType;
	                var instantiatedType = combinedMapper(checkType_1);
	                if (checkType_1 !== instantiatedType && instantiatedType.flags & 131072 /* Union */) {
	                    return mapType(instantiatedType, function (t) { return instantiateConditionalType(target, createReplacementMapper(checkType_1, t, combinedMapper)); });
	                }
	            }
	            return instantiateConditionalType(target, combinedMapper);
	        }
	        function instantiateConditionalType(type, mapper) {
	            return getConditionalType(instantiateType(type.checkType, mapper), type.extendsType, type.trueType, type.falseType, type.inferTypeParameters, type, mapper, type.aliasSymbol, type.aliasTypeArguments);
	        }
	        function instantiateType(type, mapper) {
	            if (type && mapper && mapper !== identityMapper) {
	                if (type.flags & 32768 /* TypeParameter */) {
	                    return mapper(type);
	                }
	                if (type.flags & 65536 /* Object */) {
	                    if (type.objectFlags & 16 /* Anonymous */) {
	                        // If the anonymous type originates in a declaration of a function, method, class, or
	                        // interface, in an object type literal, or in an object literal expression, we may need
	                        // to instantiate the type because it might reference a type parameter.
	                        return type.symbol && type.symbol.flags & (16 /* Function */ | 8192 /* Method */ | 32 /* Class */ | 2048 /* TypeLiteral */ | 4096 /* ObjectLiteral */) && type.symbol.declarations ?
	                            getAnonymousTypeInstantiation(type, mapper) : type;
	                    }
	                    if (type.objectFlags & 32 /* Mapped */) {
	                        return getAnonymousTypeInstantiation(type, mapper);
	                    }
	                    if (type.objectFlags & 4 /* Reference */) {
	                        var typeArguments = type.typeArguments;
	                        var newTypeArguments = instantiateTypes(typeArguments, mapper);
	                        return newTypeArguments !== typeArguments ? createTypeReference(type.target, newTypeArguments) : type;
	                    }
	                }
	                if (type.flags & 131072 /* Union */ && !(type.flags & 16382 /* Primitive */)) {
	                    var types = type.types;
	                    var newTypes = instantiateTypes(types, mapper);
	                    return newTypes !== types ? getUnionType(newTypes, 1 /* Literal */, type.aliasSymbol, instantiateTypes(type.aliasTypeArguments, mapper)) : type;
	                }
	                if (type.flags & 262144 /* Intersection */) {
	                    var types = type.types;
	                    var newTypes = instantiateTypes(types, mapper);
	                    return newTypes !== types ? getIntersectionType(newTypes, type.aliasSymbol, instantiateTypes(type.aliasTypeArguments, mapper)) : type;
	                }
	                if (type.flags & 524288 /* Index */) {
	                    return getIndexType(instantiateType(type.type, mapper));
	                }
	                if (type.flags & 1048576 /* IndexedAccess */) {
	                    return getIndexedAccessType(instantiateType(type.objectType, mapper), instantiateType(type.indexType, mapper));
	                }
	                if (type.flags & 2097152 /* Conditional */) {
	                    return getConditionalTypeInstantiation(type, mapper);
	                }
	                if (type.flags & 4194304 /* Substitution */) {
	                    return mapper(type.typeParameter);
	                }
	            }
	            return type;
	        }
	        function getWildcardInstantiation(type) {
	            return type.flags & (16382 /* Primitive */ | 1 /* Any */ | 16384 /* Never */) ? type :
	                type.wildcardInstantiation || (type.wildcardInstantiation = instantiateType(type, wildcardMapper));
	        }
	        function instantiateIndexInfo(info, mapper) {
	            return info && createIndexInfo(instantiateType(info.type, mapper), info.isReadonly, info.declaration);
	        }
	        // Returns true if the given expression contains (at any level of nesting) a function or arrow expression
	        // that is subject to contextual typing.
	        function isContextSensitive(node) {
	            ts.Debug.assert(node.kind !== 153 /* MethodDeclaration */ || ts.isObjectLiteralMethod(node));
	            switch (node.kind) {
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                case 153 /* MethodDeclaration */:
	                    return isContextSensitiveFunctionLikeDeclaration(node);
	                case 182 /* ObjectLiteralExpression */:
	                    return ts.forEach(node.properties, isContextSensitive);
	                case 181 /* ArrayLiteralExpression */:
	                    return ts.forEach(node.elements, isContextSensitive);
	                case 199 /* ConditionalExpression */:
	                    return isContextSensitive(node.whenTrue) ||
	                        isContextSensitive(node.whenFalse);
	                case 198 /* BinaryExpression */:
	                    return node.operatorToken.kind === 54 /* BarBarToken */ &&
	                        (isContextSensitive(node.left) || isContextSensitive(node.right));
	                case 268 /* PropertyAssignment */:
	                    return isContextSensitive(node.initializer);
	                case 189 /* ParenthesizedExpression */:
	                    return isContextSensitive(node.expression);
	                case 261 /* JsxAttributes */:
	                    return ts.forEach(node.properties, isContextSensitive);
	                case 260 /* JsxAttribute */:
	                    // If there is no initializer, JSX attribute has a boolean value of true which is not context sensitive.
	                    return node.initializer && isContextSensitive(node.initializer);
	                case 263 /* JsxExpression */:
	                    // It is possible to that node.expression is undefined (e.g <div x={} />)
	                    return node.expression && isContextSensitive(node.expression);
	            }
	            return false;
	        }
	        function isContextSensitiveFunctionLikeDeclaration(node) {
	            // Functions with type parameters are not context sensitive.
	            if (node.typeParameters) {
	                return false;
	            }
	            // Functions with any parameters that lack type annotations are context sensitive.
	            if (ts.forEach(node.parameters, function (p) { return !ts.getEffectiveTypeAnnotationNode(p); })) {
	                return true;
	            }
	            if (node.kind !== 191 /* ArrowFunction */) {
	                // If the first parameter is not an explicit 'this' parameter, then the function has
	                // an implicit 'this' parameter which is subject to contextual typing.
	                var parameter = ts.firstOrUndefined(node.parameters);
	                if (!(parameter && ts.parameterIsThisKeyword(parameter))) {
	                    return true;
	                }
	            }
	            // TODO(anhans): A block should be context-sensitive if it has a context-sensitive return value.
	            return node.body.kind === 211 /* Block */ ? false : isContextSensitive(node.body);
	        }
	        function isContextSensitiveFunctionOrObjectLiteralMethod(func) {
	            return (isFunctionExpressionOrArrowFunction(func) || ts.isObjectLiteralMethod(func)) && isContextSensitiveFunctionLikeDeclaration(func);
	        }
	        function getTypeWithoutSignatures(type) {
	            if (type.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                if (resolved.constructSignatures.length) {
	                    var result = createObjectType(16 /* Anonymous */, type.symbol);
	                    result.members = resolved.members;
	                    result.properties = resolved.properties;
	                    result.callSignatures = ts.emptyArray;
	                    result.constructSignatures = ts.emptyArray;
	                    return result;
	                }
	            }
	            else if (type.flags & 262144 /* Intersection */) {
	                return getIntersectionType(ts.map(type.types, getTypeWithoutSignatures));
	            }
	            return type;
	        }
	        // TYPE CHECKING
	        function isTypeIdenticalTo(source, target) {
	            return isTypeRelatedTo(source, target, identityRelation);
	        }
	        function compareTypesIdentical(source, target) {
	            return isTypeRelatedTo(source, target, identityRelation) ? -1 /* True */ : 0 /* False */;
	        }
	        function compareTypesAssignable(source, target) {
	            return isTypeRelatedTo(source, target, assignableRelation) ? -1 /* True */ : 0 /* False */;
	        }
	        function isTypeSubtypeOf(source, target) {
	            return isTypeRelatedTo(source, target, subtypeRelation);
	        }
	        function isTypeAssignableTo(source, target) {
	            return isTypeRelatedTo(source, target, assignableRelation);
	        }
	        // An object type S is considered to be derived from an object type T if
	        // S is a union type and every constituent of S is derived from T,
	        // T is a union type and S is derived from at least one constituent of T, or
	        // S is a type variable with a base constraint that is derived from T,
	        // T is one of the global types Object and Function and S is a subtype of T, or
	        // T occurs directly or indirectly in an 'extends' clause of S.
	        // Note that this check ignores type parameters and only considers the
	        // inheritance hierarchy.
	        function isTypeDerivedFrom(source, target) {
	            return source.flags & 131072 /* Union */ ? ts.every(source.types, function (t) { return isTypeDerivedFrom(t, target); }) :
	                target.flags & 131072 /* Union */ ? ts.some(target.types, function (t) { return isTypeDerivedFrom(source, t); }) :
	                    source.flags & 7372800 /* InstantiableNonPrimitive */ ? isTypeDerivedFrom(getBaseConstraintOfType(source) || emptyObjectType, target) :
	                        target === globalObjectType || target === globalFunctionType ? isTypeSubtypeOf(source, target) :
	                            hasBaseType(source, getTargetType(target));
	        }
	        /**
	         * This is *not* a bi-directional relationship.
	         * If one needs to check both directions for comparability, use a second call to this function or 'checkTypeComparableTo'.
	         *
	         * A type S is comparable to a type T if some (but not necessarily all) of the possible values of S are also possible values of T.
	         * It is used to check following cases:
	         *   - the types of the left and right sides of equality/inequality operators (`===`, `!==`, `==`, `!=`).
	         *   - the types of `case` clause expressions and their respective `switch` expressions.
	         *   - the type of an expression in a type assertion with the type being asserted.
	         */
	        function isTypeComparableTo(source, target) {
	            return isTypeRelatedTo(source, target, comparableRelation);
	        }
	        function areTypesComparable(type1, type2) {
	            return isTypeComparableTo(type1, type2) || isTypeComparableTo(type2, type1);
	        }
	        function checkTypeAssignableTo(source, target, errorNode, headMessage, containingMessageChain) {
	            return checkTypeRelatedTo(source, target, assignableRelation, errorNode, headMessage, containingMessageChain);
	        }
	        /**
	         * This is *not* a bi-directional relationship.
	         * If one needs to check both directions for comparability, use a second call to this function or 'isTypeComparableTo'.
	         */
	        function checkTypeComparableTo(source, target, errorNode, headMessage, containingMessageChain) {
	            return checkTypeRelatedTo(source, target, comparableRelation, errorNode, headMessage, containingMessageChain);
	        }
	        function isSignatureAssignableTo(source, target, ignoreReturnTypes) {
	            return compareSignaturesRelated(source, target, 0 /* None */, ignoreReturnTypes, /*reportErrors*/ false, 
	            /*errorReporter*/ undefined, compareTypesAssignable) !== 0 /* False */;
	        }
	        /**
	         * See signatureRelatedTo, compareSignaturesIdentical
	         */
	        function compareSignaturesRelated(source, target, callbackCheck, ignoreReturnTypes, reportErrors, errorReporter, compareTypes) {
	            // TODO (drosen): De-duplicate code between related functions.
	            if (source === target) {
	                return -1 /* True */;
	            }
	            if (!target.hasRestParameter && source.minArgumentCount > target.parameters.length) {
	                return 0 /* False */;
	            }
	            if (source.typeParameters && source.typeParameters !== target.typeParameters) {
	                target = getCanonicalSignature(target);
	                source = instantiateSignatureInContextOf(source, target, /*contextualMapper*/ undefined, compareTypes);
	            }
	            var kind = target.declaration ? target.declaration.kind : 0 /* Unknown */;
	            var strictVariance = !callbackCheck && strictFunctionTypes && kind !== 153 /* MethodDeclaration */ &&
	                kind !== 152 /* MethodSignature */ && kind !== 154 /* Constructor */;
	            var result = -1 /* True */;
	            var sourceThisType = getThisTypeOfSignature(source);
	            if (sourceThisType && sourceThisType !== voidType) {
	                var targetThisType = getThisTypeOfSignature(target);
	                if (targetThisType) {
	                    // void sources are assignable to anything.
	                    var related = !strictVariance && compareTypes(sourceThisType, targetThisType, /*reportErrors*/ false)
	                        || compareTypes(targetThisType, sourceThisType, reportErrors);
	                    if (!related) {
	                        if (reportErrors) {
	                            errorReporter(ts.Diagnostics.The_this_types_of_each_signature_are_incompatible);
	                        }
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	            }
	            var sourceMax = getNumNonRestParameters(source);
	            var targetMax = getNumNonRestParameters(target);
	            var checkCount = getNumParametersToCheckForSignatureRelatability(source, sourceMax, target, targetMax);
	            var sourceParams = source.parameters;
	            var targetParams = target.parameters;
	            for (var i = 0; i < checkCount; i++) {
	                var sourceType = i < sourceMax ? getTypeOfParameter(sourceParams[i]) : getRestTypeOfSignature(source);
	                var targetType = i < targetMax ? getTypeOfParameter(targetParams[i]) : getRestTypeOfSignature(target);
	                // In order to ensure that any generic type Foo<T> is at least co-variant with respect to T no matter
	                // how Foo uses T, we need to relate parameters bi-variantly (given that parameters are input positions,
	                // they naturally relate only contra-variantly). However, if the source and target parameters both have
	                // function types with a single call signature, we know we are relating two callback parameters. In
	                // that case it is sufficient to only relate the parameters of the signatures co-variantly because,
	                // similar to return values, callback parameters are output positions. This means that a Promise<T>,
	                // where T is used only in callback parameter positions, will be co-variant (as opposed to bi-variant)
	                // with respect to T.
	                var sourceSig = callbackCheck ? undefined : getSingleCallSignature(getNonNullableType(sourceType));
	                var targetSig = callbackCheck ? undefined : getSingleCallSignature(getNonNullableType(targetType));
	                var callbacks = sourceSig && targetSig && !signatureHasTypePredicate(sourceSig) && !signatureHasTypePredicate(targetSig) &&
	                    (getFalsyFlags(sourceType) & 12288 /* Nullable */) === (getFalsyFlags(targetType) & 12288 /* Nullable */);
	                var related = callbacks ?
	                    compareSignaturesRelated(targetSig, sourceSig, strictVariance ? 2 /* Strict */ : 1 /* Bivariant */, /*ignoreReturnTypes*/ false, reportErrors, errorReporter, compareTypes) :
	                    !callbackCheck && !strictVariance && compareTypes(sourceType, targetType, /*reportErrors*/ false) || compareTypes(targetType, sourceType, reportErrors);
	                if (!related) {
	                    if (reportErrors) {
	                        errorReporter(ts.Diagnostics.Types_of_parameters_0_and_1_are_incompatible, ts.symbolName(sourceParams[i < sourceMax ? i : sourceMax]), ts.symbolName(targetParams[i < targetMax ? i : targetMax]));
	                    }
	                    return 0 /* False */;
	                }
	                result &= related;
	            }
	            if (!ignoreReturnTypes) {
	                var targetReturnType = getReturnTypeOfSignature(target);
	                if (targetReturnType === voidType) {
	                    return result;
	                }
	                var sourceReturnType = getReturnTypeOfSignature(source);
	                // The following block preserves behavior forbidding boolean returning functions from being assignable to type guard returning functions
	                var targetTypePredicate = getTypePredicateOfSignature(target);
	                if (targetTypePredicate) {
	                    var sourceTypePredicate = getTypePredicateOfSignature(source);
	                    if (sourceTypePredicate) {
	                        result &= compareTypePredicateRelatedTo(sourceTypePredicate, targetTypePredicate, source.declaration, target.declaration, reportErrors, errorReporter, compareTypes);
	                    }
	                    else if (ts.isIdentifierTypePredicate(targetTypePredicate)) {
	                        if (reportErrors) {
	                            errorReporter(ts.Diagnostics.Signature_0_must_be_a_type_predicate, signatureToString(source));
	                        }
	                        return 0 /* False */;
	                    }
	                }
	                else {
	                    // When relating callback signatures, we still need to relate return types bi-variantly as otherwise
	                    // the containing type wouldn't be co-variant. For example, interface Foo<T> { add(cb: () => T): void }
	                    // wouldn't be co-variant for T without this rule.
	                    result &= callbackCheck === 1 /* Bivariant */ && compareTypes(targetReturnType, sourceReturnType, /*reportErrors*/ false) ||
	                        compareTypes(sourceReturnType, targetReturnType, reportErrors);
	                }
	            }
	            return result;
	        }
	        function compareTypePredicateRelatedTo(source, target, sourceDeclaration, targetDeclaration, reportErrors, errorReporter, compareTypes) {
	            if (source.kind !== target.kind) {
	                if (reportErrors) {
	                    errorReporter(ts.Diagnostics.A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard);
	                    errorReporter(ts.Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
	                }
	                return 0 /* False */;
	            }
	            if (source.kind === 1 /* Identifier */) {
	                var targetPredicate = target;
	                var sourceIndex = source.parameterIndex - (ts.getThisParameter(sourceDeclaration) ? 1 : 0);
	                var targetIndex = targetPredicate.parameterIndex - (ts.getThisParameter(targetDeclaration) ? 1 : 0);
	                if (sourceIndex !== targetIndex) {
	                    if (reportErrors) {
	                        errorReporter(ts.Diagnostics.Parameter_0_is_not_in_the_same_position_as_parameter_1, source.parameterName, targetPredicate.parameterName);
	                        errorReporter(ts.Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
	                    }
	                    return 0 /* False */;
	                }
	            }
	            var related = compareTypes(source.type, target.type, reportErrors);
	            if (related === 0 /* False */ && reportErrors) {
	                errorReporter(ts.Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
	            }
	            return related;
	        }
	        function isImplementationCompatibleWithOverload(implementation, overload) {
	            var erasedSource = getErasedSignature(implementation);
	            var erasedTarget = getErasedSignature(overload);
	            // First see if the return types are compatible in either direction.
	            var sourceReturnType = getReturnTypeOfSignature(erasedSource);
	            var targetReturnType = getReturnTypeOfSignature(erasedTarget);
	            if (targetReturnType === voidType
	                || isTypeRelatedTo(targetReturnType, sourceReturnType, assignableRelation)
	                || isTypeRelatedTo(sourceReturnType, targetReturnType, assignableRelation)) {
	                return isSignatureAssignableTo(erasedSource, erasedTarget, /*ignoreReturnTypes*/ true);
	            }
	            return false;
	        }
	        function getNumNonRestParameters(signature) {
	            var numParams = signature.parameters.length;
	            return signature.hasRestParameter ?
	                numParams - 1 :
	                numParams;
	        }
	        function getNumParametersToCheckForSignatureRelatability(source, sourceNonRestParamCount, target, targetNonRestParamCount) {
	            if (source.hasRestParameter === target.hasRestParameter) {
	                if (source.hasRestParameter) {
	                    // If both have rest parameters, get the max and add 1 to
	                    // compensate for the rest parameter.
	                    return Math.max(sourceNonRestParamCount, targetNonRestParamCount) + 1;
	                }
	                else {
	                    return Math.min(sourceNonRestParamCount, targetNonRestParamCount);
	                }
	            }
	            else {
	                // Return the count for whichever signature doesn't have rest parameters.
	                return source.hasRestParameter ?
	                    targetNonRestParamCount :
	                    sourceNonRestParamCount;
	            }
	        }
	        function isEmptyResolvedType(t) {
	            return t.properties.length === 0 &&
	                t.callSignatures.length === 0 &&
	                t.constructSignatures.length === 0 &&
	                !t.stringIndexInfo &&
	                !t.numberIndexInfo;
	        }
	        function isEmptyObjectType(type) {
	            return type.flags & 65536 /* Object */ ? isEmptyResolvedType(resolveStructuredTypeMembers(type)) :
	                type.flags & 134217728 /* NonPrimitive */ ? true :
	                    type.flags & 131072 /* Union */ ? ts.forEach(type.types, isEmptyObjectType) :
	                        type.flags & 262144 /* Intersection */ ? !ts.forEach(type.types, function (t) { return !isEmptyObjectType(t); }) :
	                            false;
	        }
	        function isEnumTypeRelatedTo(sourceSymbol, targetSymbol, errorReporter) {
	            if (sourceSymbol === targetSymbol) {
	                return true;
	            }
	            var id = getSymbolId(sourceSymbol) + "," + getSymbolId(targetSymbol);
	            var relation = enumRelation.get(id);
	            if (relation !== undefined) {
	                return relation;
	            }
	            if (sourceSymbol.escapedName !== targetSymbol.escapedName || !(sourceSymbol.flags & 256 /* RegularEnum */) || !(targetSymbol.flags & 256 /* RegularEnum */)) {
	                enumRelation.set(id, false);
	                return false;
	            }
	            var targetEnumType = getTypeOfSymbol(targetSymbol);
	            for (var _i = 0, _a = getPropertiesOfType(getTypeOfSymbol(sourceSymbol)); _i < _a.length; _i++) {
	                var property = _a[_i];
	                if (property.flags & 8 /* EnumMember */) {
	                    var targetProperty = getPropertyOfType(targetEnumType, property.escapedName);
	                    if (!targetProperty || !(targetProperty.flags & 8 /* EnumMember */)) {
	                        if (errorReporter) {
	                            errorReporter(ts.Diagnostics.Property_0_is_missing_in_type_1, ts.symbolName(property), typeToString(getDeclaredTypeOfSymbol(targetSymbol), /*enclosingDeclaration*/ undefined, 64 /* UseFullyQualifiedType */));
	                        }
	                        enumRelation.set(id, false);
	                        return false;
	                    }
	                }
	            }
	            enumRelation.set(id, true);
	            return true;
	        }
	        function isSimpleTypeRelatedTo(source, target, relation, errorReporter) {
	            var s = source.flags;
	            var t = target.flags;
	            if (t & 1 /* Any */ || s & 16384 /* Never */ || source === wildcardType)
	                return true;
	            if (t & 16384 /* Never */)
	                return false;
	            if (s & 524322 /* StringLike */ && t & 2 /* String */)
	                return true;
	            if (s & 32 /* StringLiteral */ && s & 256 /* EnumLiteral */ &&
	                t & 32 /* StringLiteral */ && !(t & 256 /* EnumLiteral */) &&
	                source.value === target.value)
	                return true;
	            if (s & 84 /* NumberLike */ && t & 4 /* Number */)
	                return true;
	            if (s & 64 /* NumberLiteral */ && s & 256 /* EnumLiteral */ &&
	                t & 64 /* NumberLiteral */ && !(t & 256 /* EnumLiteral */) &&
	                source.value === target.value)
	                return true;
	            if (s & 136 /* BooleanLike */ && t & 8 /* Boolean */)
	                return true;
	            if (s & 1536 /* ESSymbolLike */ && t & 512 /* ESSymbol */)
	                return true;
	            if (s & 16 /* Enum */ && t & 16 /* Enum */ && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter))
	                return true;
	            if (s & 256 /* EnumLiteral */ && t & 256 /* EnumLiteral */) {
	                if (s & 131072 /* Union */ && t & 131072 /* Union */ && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter))
	                    return true;
	                if (s & 224 /* Literal */ && t & 224 /* Literal */ &&
	                    source.value === target.value &&
	                    isEnumTypeRelatedTo(getParentOfSymbol(source.symbol), getParentOfSymbol(target.symbol), errorReporter))
	                    return true;
	            }
	            if (s & 4096 /* Undefined */ && (!strictNullChecks || t & (4096 /* Undefined */ | 2048 /* Void */)))
	                return true;
	            if (s & 8192 /* Null */ && (!strictNullChecks || t & 8192 /* Null */))
	                return true;
	            if (s & 65536 /* Object */ && t & 134217728 /* NonPrimitive */)
	                return true;
	            if (s & 1024 /* UniqueESSymbol */ || t & 1024 /* UniqueESSymbol */)
	                return false;
	            if (relation === assignableRelation || relation === definitelyAssignableRelation || relation === comparableRelation) {
	                if (s & 1 /* Any */)
	                    return true;
	                // Type number or any numeric literal type is assignable to any numeric enum type or any
	                // numeric enum literal type. This rule exists for backwards compatibility reasons because
	                // bit-flag enum types sometimes look like literal enum types with numeric literal values.
	                if (s & (4 /* Number */ | 64 /* NumberLiteral */) && !(s & 256 /* EnumLiteral */) && (t & 16 /* Enum */ || t & 64 /* NumberLiteral */ && t & 256 /* EnumLiteral */))
	                    return true;
	            }
	            return false;
	        }
	        function isTypeRelatedTo(source, target, relation) {
	            if (source.flags & 96 /* StringOrNumberLiteral */ && source.flags & 8388608 /* FreshLiteral */) {
	                source = source.regularType;
	            }
	            if (target.flags & 96 /* StringOrNumberLiteral */ && target.flags & 8388608 /* FreshLiteral */) {
	                target = target.regularType;
	            }
	            if (source === target ||
	                relation === comparableRelation && !(target.flags & 16384 /* Never */) && isSimpleTypeRelatedTo(target, source, relation) ||
	                relation !== identityRelation && isSimpleTypeRelatedTo(source, target, relation)) {
	                return true;
	            }
	            if (source.flags & 65536 /* Object */ && target.flags & 65536 /* Object */) {
	                var related = relation.get(getRelationKey(source, target, relation));
	                if (related !== undefined) {
	                    return related === 1 /* Succeeded */;
	                }
	            }
	            if (source.flags & 8355840 /* StructuredOrInstantiable */ || target.flags & 8355840 /* StructuredOrInstantiable */) {
	                return checkTypeRelatedTo(source, target, relation, /*errorNode*/ undefined);
	            }
	            return false;
	        }
	        function isIgnoredJsxProperty(source, sourceProp, targetMemberType) {
	            return ts.getObjectFlags(source) & 4096 /* JsxAttributes */ && !(isUnhyphenatedJsxName(sourceProp.escapedName) || targetMemberType);
	        }
	        /**
	         * Checks if 'source' is related to 'target' (e.g.: is a assignable to).
	         * @param source The left-hand-side of the relation.
	         * @param target The right-hand-side of the relation.
	         * @param relation The relation considered. One of 'identityRelation', 'subtypeRelation', 'assignableRelation', or 'comparableRelation'.
	         * Used as both to determine which checks are performed and as a cache of previously computed results.
	         * @param errorNode The suggested node upon which all errors will be reported, if defined. This may or may not be the actual node used.
	         * @param headMessage If the error chain should be prepended by a head message, then headMessage will be used.
	         * @param containingMessageChain A chain of errors to prepend any new errors found.
	         */
	        function checkTypeRelatedTo(source, target, relation, errorNode, headMessage, containingMessageChain) {
	            var errorInfo;
	            var maybeKeys;
	            var sourceStack;
	            var targetStack;
	            var maybeCount = 0;
	            var depth = 0;
	            var expandingFlags = 0 /* None */;
	            var overflow = false;
	            var isIntersectionConstituent = false;
	            ts.Debug.assert(relation !== identityRelation || !errorNode, "no error reporting in identity checking");
	            var result = isRelatedTo(source, target, /*reportErrors*/ !!errorNode, headMessage);
	            if (overflow) {
	                error(errorNode, ts.Diagnostics.Excessive_stack_depth_comparing_types_0_and_1, typeToString(source), typeToString(target));
	            }
	            else if (errorInfo) {
	                if (containingMessageChain) {
	                    var chain_1 = containingMessageChain();
	                    if (chain_1) {
	                        errorInfo = ts.concatenateDiagnosticMessageChains(chain_1, errorInfo);
	                    }
	                }
	                diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(errorNode, errorInfo));
	            }
	            // Check if we should issue an extra diagnostic to produce a quickfix for a slightly incorrect import statement
	            if (headMessage && errorNode && !result && source.symbol) {
	                var links = getSymbolLinks(source.symbol);
	                if (links.originatingImport && !ts.isImportCall(links.originatingImport)) {
	                    var helpfulRetry = checkTypeRelatedTo(getTypeOfSymbol(links.target), target, relation, /*errorNode*/ undefined);
	                    if (helpfulRetry) {
	                        // Likely an incorrect import. Issue a helpful diagnostic to produce a quickfix to change the import
	                        diagnostics.add(ts.createDiagnosticForNode(links.originatingImport, ts.Diagnostics.A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime));
	                    }
	                }
	            }
	            return result !== 0 /* False */;
	            function reportError(message, arg0, arg1, arg2) {
	                ts.Debug.assert(!!errorNode);
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, message, arg0, arg1, arg2);
	            }
	            function reportRelationError(message, source, target) {
	                var sourceType = typeToString(source);
	                var targetType = typeToString(target);
	                if (sourceType === targetType) {
	                    sourceType = typeToString(source, /*enclosingDeclaration*/ undefined, 64 /* UseFullyQualifiedType */);
	                    targetType = typeToString(target, /*enclosingDeclaration*/ undefined, 64 /* UseFullyQualifiedType */);
	                }
	                if (!message) {
	                    if (relation === comparableRelation) {
	                        message = ts.Diagnostics.Type_0_is_not_comparable_to_type_1;
	                    }
	                    else if (sourceType === targetType) {
	                        message = ts.Diagnostics.Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated;
	                    }
	                    else {
	                        message = ts.Diagnostics.Type_0_is_not_assignable_to_type_1;
	                    }
	                }
	                reportError(message, sourceType, targetType);
	            }
	            function tryElaborateErrorsForPrimitivesAndObjects(source, target) {
	                var sourceType = typeToString(source);
	                var targetType = typeToString(target);
	                if ((globalStringType === source && stringType === target) ||
	                    (globalNumberType === source && numberType === target) ||
	                    (globalBooleanType === source && booleanType === target) ||
	                    (getGlobalESSymbolType(/*reportErrors*/ false) === source && esSymbolType === target)) {
	                    reportError(ts.Diagnostics._0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible, targetType, sourceType);
	                }
	            }
	            function isUnionOrIntersectionTypeWithoutNullableConstituents(type) {
	                if (!(type.flags & 393216 /* UnionOrIntersection */)) {
	                    return false;
	                }
	                // at this point we know that this is union or intersection type possibly with nullable constituents.
	                // check if we still will have compound type if we ignore nullable components.
	                var seenNonNullable = false;
	                for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    if (t.flags & 12288 /* Nullable */) {
	                        continue;
	                    }
	                    if (seenNonNullable) {
	                        return true;
	                    }
	                    seenNonNullable = true;
	                }
	                return false;
	            }
	            /**
	             * Compare two types and return
	             * * Ternary.True if they are related with no assumptions,
	             * * Ternary.Maybe if they are related with assumptions of other relationships, or
	             * * Ternary.False if they are not related.
	             */
	            function isRelatedTo(source, target, reportErrors, headMessage) {
	                if (source.flags & 96 /* StringOrNumberLiteral */ && source.flags & 8388608 /* FreshLiteral */) {
	                    source = source.regularType;
	                }
	                if (target.flags & 96 /* StringOrNumberLiteral */ && target.flags & 8388608 /* FreshLiteral */) {
	                    target = target.regularType;
	                }
	                if (source.flags & 4194304 /* Substitution */) {
	                    source = relation === definitelyAssignableRelation ? source.typeParameter : source.substitute;
	                }
	                if (target.flags & 4194304 /* Substitution */) {
	                    target = target.typeParameter;
	                }
	                // both types are the same - covers 'they are the same primitive type or both are Any' or the same type parameter cases
	                if (source === target)
	                    return -1 /* True */;
	                if (relation === identityRelation) {
	                    return isIdenticalTo(source, target);
	                }
	                if (relation === comparableRelation && !(target.flags & 16384 /* Never */) && isSimpleTypeRelatedTo(target, source, relation) ||
	                    isSimpleTypeRelatedTo(source, target, relation, reportErrors ? reportError : undefined))
	                    return -1 /* True */;
	                if (isObjectLiteralType(source) && source.flags & 8388608 /* FreshLiteral */) {
	                    var discriminantType = target.flags & 131072 /* Union */ ? findMatchingDiscriminantType(source, target) : undefined;
	                    if (hasExcessProperties(source, target, discriminantType, reportErrors)) {
	                        if (reportErrors) {
	                            reportRelationError(headMessage, source, target);
	                        }
	                        return 0 /* False */;
	                    }
	                    // Above we check for excess properties with respect to the entire target type. When union
	                    // and intersection types are further deconstructed on the target side, we don't want to
	                    // make the check again (as it might fail for a partial target type). Therefore we obtain
	                    // the regular source type and proceed with that.
	                    if (isUnionOrIntersectionTypeWithoutNullableConstituents(target) && !discriminantType) {
	                        source = getRegularTypeOfObjectLiteral(source);
	                    }
	                }
	                if (relation !== comparableRelation &&
	                    !(source.flags & 393216 /* UnionOrIntersection */) &&
	                    !(target.flags & 131072 /* Union */) &&
	                    !isIntersectionConstituent &&
	                    source !== globalObjectType &&
	                    (getPropertiesOfType(source).length > 0 || typeHasCallOrConstructSignatures(source)) &&
	                    isWeakType(target) &&
	                    !hasCommonProperties(source, target)) {
	                    if (reportErrors) {
	                        var calls = getSignaturesOfType(source, 0 /* Call */);
	                        var constructs = getSignaturesOfType(source, 1 /* Construct */);
	                        if (calls.length > 0 && isRelatedTo(getReturnTypeOfSignature(calls[0]), target, /*reportErrors*/ false) ||
	                            constructs.length > 0 && isRelatedTo(getReturnTypeOfSignature(constructs[0]), target, /*reportErrors*/ false)) {
	                            reportError(ts.Diagnostics.Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it, typeToString(source), typeToString(target));
	                        }
	                        else {
	                            reportError(ts.Diagnostics.Type_0_has_no_properties_in_common_with_type_1, typeToString(source), typeToString(target));
	                        }
	                    }
	                    return 0 /* False */;
	                }
	                var result = 0 /* False */;
	                var saveErrorInfo = errorInfo;
	                var saveIsIntersectionConstituent = isIntersectionConstituent;
	                isIntersectionConstituent = false;
	                // Note that these checks are specifically ordered to produce correct results. In particular,
	                // we need to deconstruct unions before intersections (because unions are always at the top),
	                // and we need to handle "each" relations before "some" relations for the same kind of type.
	                if (source.flags & 131072 /* Union */) {
	                    result = relation === comparableRelation ?
	                        someTypeRelatedToType(source, target, reportErrors && !(source.flags & 16382 /* Primitive */)) :
	                        eachTypeRelatedToType(source, target, reportErrors && !(source.flags & 16382 /* Primitive */));
	                }
	                else {
	                    if (target.flags & 131072 /* Union */) {
	                        result = typeRelatedToSomeType(source, target, reportErrors && !(source.flags & 16382 /* Primitive */) && !(target.flags & 16382 /* Primitive */));
	                    }
	                    else if (target.flags & 262144 /* Intersection */) {
	                        isIntersectionConstituent = true;
	                        result = typeRelatedToEachType(source, target, reportErrors);
	                    }
	                    else if (source.flags & 262144 /* Intersection */) {
	                        // Check to see if any constituents of the intersection are immediately related to the target.
	                        //
	                        // Don't report errors though. Checking whether a constituent is related to the source is not actually
	                        // useful and leads to some confusing error messages. Instead it is better to let the below checks
	                        // take care of this, or to not elaborate at all. For instance,
	                        //
	                        //    - For an object type (such as 'C = A & B'), users are usually more interested in structural errors.
	                        //
	                        //    - For a union type (such as '(A | B) = (C & D)'), it's better to hold onto the whole intersection
	                        //          than to report that 'D' is not assignable to 'A' or 'B'.
	                        //
	                        //    - For a primitive type or type parameter (such as 'number = A & B') there is no point in
	                        //          breaking the intersection apart.
	                        result = someTypeRelatedToType(source, target, /*reportErrors*/ false);
	                    }
	                    if (!result && (source.flags & 8355840 /* StructuredOrInstantiable */ || target.flags & 8355840 /* StructuredOrInstantiable */)) {
	                        if (result = recursiveTypeRelatedTo(source, target, reportErrors)) {
	                            errorInfo = saveErrorInfo;
	                        }
	                    }
	                }
	                isIntersectionConstituent = saveIsIntersectionConstituent;
	                if (!result && reportErrors) {
	                    if (source.flags & 65536 /* Object */ && target.flags & 16382 /* Primitive */) {
	                        tryElaborateErrorsForPrimitivesAndObjects(source, target);
	                    }
	                    else if (source.symbol && source.flags & 65536 /* Object */ && globalObjectType === source) {
	                        reportError(ts.Diagnostics.The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead);
	                    }
	                    reportRelationError(headMessage, source, target);
	                }
	                return result;
	            }
	            function isIdenticalTo(source, target) {
	                var result;
	                var flags = source.flags & target.flags;
	                if (flags & 65536 /* Object */) {
	                    return recursiveTypeRelatedTo(source, target, /*reportErrors*/ false);
	                }
	                if (flags & (131072 /* Union */ | 262144 /* Intersection */)) {
	                    if (result = eachTypeRelatedToSomeType(source, target)) {
	                        if (result &= eachTypeRelatedToSomeType(target, source)) {
	                            return result;
	                        }
	                    }
	                }
	                if (flags & 524288 /* Index */) {
	                    return isRelatedTo(source.type, target.type, /*reportErrors*/ false);
	                }
	                if (flags & 1048576 /* IndexedAccess */) {
	                    if (result = isRelatedTo(source.objectType, target.objectType, /*reportErrors*/ false)) {
	                        if (result &= isRelatedTo(source.indexType, target.indexType, /*reportErrors*/ false)) {
	                            return result;
	                        }
	                    }
	                }
	                if (flags & 2097152 /* Conditional */) {
	                    if (result = isRelatedTo(source.checkType, target.checkType, /*reportErrors*/ false)) {
	                        if (result &= isRelatedTo(source.extendsType, target.extendsType, /*reportErrors*/ false)) {
	                            if (result &= isRelatedTo(source.trueType, target.trueType, /*reportErrors*/ false)) {
	                                if (result &= isRelatedTo(source.falseType, target.falseType, /*reportErrors*/ false)) {
	                                    if (isDistributiveConditionalType(source) === isDistributiveConditionalType(target)) {
	                                        return result;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                if (flags & 4194304 /* Substitution */) {
	                    return isRelatedTo(source.substitute, target.substitute, /*reportErrors*/ false);
	                }
	                return 0 /* False */;
	            }
	            function hasExcessProperties(source, target, discriminant, reportErrors) {
	                if (maybeTypeOfKind(target, 65536 /* Object */) && !(ts.getObjectFlags(target) & 512 /* ObjectLiteralPatternWithComputedProperties */)) {
	                    var isComparingJsxAttributes = !!(ts.getObjectFlags(source) & 4096 /* JsxAttributes */);
	                    if ((relation === assignableRelation || relation === definitelyAssignableRelation || relation === comparableRelation) &&
	                        (isTypeSubsetOf(globalObjectType, target) || (!isComparingJsxAttributes && isEmptyObjectType(target)))) {
	                        return false;
	                    }
	                    if (discriminant) {
	                        // check excess properties against discriminant type only, not the entire union
	                        return hasExcessProperties(source, discriminant, /*discriminant*/ undefined, reportErrors);
	                    }
	                    var _loop_4 = function (prop) {
	                        if (!isKnownProperty(target, prop.escapedName, isComparingJsxAttributes)) {
	                            if (reportErrors) {
	                                // We know *exactly* where things went wrong when comparing the types.
	                                // Use this property as the error node as this will be more helpful in
	                                // reasoning about what went wrong.
	                                ts.Debug.assert(!!errorNode);
	                                if (ts.isJsxAttributes(errorNode) || ts.isJsxOpeningLikeElement(errorNode)) {
	                                    // JsxAttributes has an object-literal flag and undergo same type-assignablity check as normal object-literal.
	                                    // However, using an object-literal error message will be very confusing to the users so we give different a message.
	                                    reportError(ts.Diagnostics.Property_0_does_not_exist_on_type_1, symbolToString(prop), typeToString(target));
	                                }
	                                else {
	                                    // use the property's value declaration if the property is assigned inside the literal itself
	                                    var objectLiteralDeclaration_1 = source.symbol && ts.firstOrUndefined(source.symbol.declarations);
	                                    var suggestion = void 0;
	                                    if (prop.valueDeclaration && ts.findAncestor(prop.valueDeclaration, function (d) { return d === objectLiteralDeclaration_1; })) {
	                                        var propDeclaration = prop.valueDeclaration;
	                                        ts.Debug.assertNode(propDeclaration, ts.isObjectLiteralElementLike);
	                                        errorNode = propDeclaration;
	                                        if (ts.isIdentifier(propDeclaration.name)) {
	                                            suggestion = getSuggestionForNonexistentProperty(propDeclaration.name, target);
	                                        }
	                                    }
	                                    if (suggestion !== undefined) {
	                                        reportError(ts.Diagnostics.Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_write_2, symbolToString(prop), typeToString(target), suggestion);
	                                    }
	                                    else {
	                                        reportError(ts.Diagnostics.Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1, symbolToString(prop), typeToString(target));
	                                    }
	                                }
	                            }
	                            return { value: true };
	                        }
	                    };
	                    for (var _i = 0, _a = getPropertiesOfObjectType(source); _i < _a.length; _i++) {
	                        var prop = _a[_i];
	                        var state_2 = _loop_4(prop);
	                        if (typeof state_2 === "object")
	                            return state_2.value;
	                    }
	                }
	                return false;
	            }
	            function eachTypeRelatedToSomeType(source, target) {
	                var result = -1 /* True */;
	                var sourceTypes = source.types;
	                for (var _i = 0, sourceTypes_1 = sourceTypes; _i < sourceTypes_1.length; _i++) {
	                    var sourceType = sourceTypes_1[_i];
	                    var related = typeRelatedToSomeType(sourceType, target, /*reportErrors*/ false);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function typeRelatedToSomeType(source, target, reportErrors) {
	                var targetTypes = target.types;
	                if (target.flags & 131072 /* Union */ && containsType(targetTypes, source)) {
	                    return -1 /* True */;
	                }
	                for (var _i = 0, targetTypes_1 = targetTypes; _i < targetTypes_1.length; _i++) {
	                    var type = targetTypes_1[_i];
	                    var related = isRelatedTo(source, type, /*reportErrors*/ false);
	                    if (related) {
	                        return related;
	                    }
	                }
	                if (reportErrors) {
	                    var discriminantType = findMatchingDiscriminantType(source, target);
	                    isRelatedTo(source, discriminantType || targetTypes[targetTypes.length - 1], /*reportErrors*/ true);
	                }
	                return 0 /* False */;
	            }
	            // Keep this up-to-date with the same logic within `getApparentTypeOfContextualType`, since they should behave similarly
	            function findMatchingDiscriminantType(source, target) {
	                var match;
	                var sourceProperties = getPropertiesOfObjectType(source);
	                if (sourceProperties) {
	                    var sourcePropertiesFiltered = findDiscriminantProperties(sourceProperties, target);
	                    if (sourcePropertiesFiltered) {
	                        for (var _i = 0, sourcePropertiesFiltered_1 = sourcePropertiesFiltered; _i < sourcePropertiesFiltered_1.length; _i++) {
	                            var sourceProperty = sourcePropertiesFiltered_1[_i];
	                            var sourceType = getTypeOfSymbol(sourceProperty);
	                            for (var _a = 0, _b = target.types; _a < _b.length; _a++) {
	                                var type = _b[_a];
	                                var targetType = getTypeOfPropertyOfType(type, sourceProperty.escapedName);
	                                if (targetType && isRelatedTo(sourceType, targetType)) {
	                                    if (type === match)
	                                        continue; // Finding multiple fields which discriminate to the same type is fine
	                                    if (match) {
	                                        return undefined;
	                                    }
	                                    match = type;
	                                }
	                            }
	                        }
	                    }
	                }
	                return match;
	            }
	            function typeRelatedToEachType(source, target, reportErrors) {
	                var result = -1 /* True */;
	                var targetTypes = target.types;
	                for (var _i = 0, targetTypes_2 = targetTypes; _i < targetTypes_2.length; _i++) {
	                    var targetType = targetTypes_2[_i];
	                    var related = isRelatedTo(source, targetType, reportErrors);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function someTypeRelatedToType(source, target, reportErrors) {
	                var sourceTypes = source.types;
	                if (source.flags & 131072 /* Union */ && containsType(sourceTypes, target)) {
	                    return -1 /* True */;
	                }
	                var len = sourceTypes.length;
	                for (var i = 0; i < len; i++) {
	                    var related = isRelatedTo(sourceTypes[i], target, reportErrors && i === len - 1);
	                    if (related) {
	                        return related;
	                    }
	                }
	                return 0 /* False */;
	            }
	            function eachTypeRelatedToType(source, target, reportErrors) {
	                var result = -1 /* True */;
	                var sourceTypes = source.types;
	                for (var _i = 0, sourceTypes_2 = sourceTypes; _i < sourceTypes_2.length; _i++) {
	                    var sourceType = sourceTypes_2[_i];
	                    var related = isRelatedTo(sourceType, target, reportErrors);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function typeArgumentsRelatedTo(source, target, variances, reportErrors) {
	                var sources = source.typeArguments || ts.emptyArray;
	                var targets = target.typeArguments || ts.emptyArray;
	                if (sources.length !== targets.length && relation === identityRelation) {
	                    return 0 /* False */;
	                }
	                var length = sources.length <= targets.length ? sources.length : targets.length;
	                var result = -1 /* True */;
	                for (var i = 0; i < length; i++) {
	                    // When variance information isn't available we default to covariance. This happens
	                    // in the process of computing variance information for recursive types and when
	                    // comparing 'this' type arguments.
	                    var variance = i < variances.length ? variances[i] : 1 /* Covariant */;
	                    // We ignore arguments for independent type parameters (because they're never witnessed).
	                    if (variance !== 4 /* Independent */) {
	                        var s = sources[i];
	                        var t = targets[i];
	                        var related = -1 /* True */;
	                        if (variance === 1 /* Covariant */) {
	                            related = isRelatedTo(s, t, reportErrors);
	                        }
	                        else if (variance === 2 /* Contravariant */) {
	                            related = isRelatedTo(t, s, reportErrors);
	                        }
	                        else if (variance === 3 /* Bivariant */) {
	                            // In the bivariant case we first compare contravariantly without reporting
	                            // errors. Then, if that doesn't succeed, we compare covariantly with error
	                            // reporting. Thus, error elaboration will be based on the the covariant check,
	                            // which is generally easier to reason about.
	                            related = isRelatedTo(t, s, /*reportErrors*/ false);
	                            if (!related) {
	                                related = isRelatedTo(s, t, reportErrors);
	                            }
	                        }
	                        else {
	                            // In the invariant case we first compare covariantly, and only when that
	                            // succeeds do we proceed to compare contravariantly. Thus, error elaboration
	                            // will typically be based on the covariant check.
	                            related = isRelatedTo(s, t, reportErrors);
	                            if (related) {
	                                related &= isRelatedTo(t, s, reportErrors);
	                            }
	                        }
	                        if (!related) {
	                            return 0 /* False */;
	                        }
	                        result &= related;
	                    }
	                }
	                return result;
	            }
	            // Determine if possibly recursive types are related. First, check if the result is already available in the global cache.
	            // Second, check if we have already started a comparison of the given two types in which case we assume the result to be true.
	            // Third, check if both types are part of deeply nested chains of generic type instantiations and if so assume the types are
	            // equal and infinitely expanding. Fourth, if we have reached a depth of 100 nested comparisons, assume we have runaway recursion
	            // and issue an error. Otherwise, actually compare the structure of the two types.
	            function recursiveTypeRelatedTo(source, target, reportErrors) {
	                if (overflow) {
	                    return 0 /* False */;
	                }
	                var id = getRelationKey(source, target, relation);
	                var related = relation.get(id);
	                if (related !== undefined) {
	                    if (reportErrors && related === 2 /* Failed */) {
	                        // We are elaborating errors and the cached result is an unreported failure. Record the result as a reported
	                        // failure and continue computing the relation such that errors get reported.
	                        relation.set(id, 3 /* FailedAndReported */);
	                    }
	                    else {
	                        return related === 1 /* Succeeded */ ? -1 /* True */ : 0 /* False */;
	                    }
	                }
	                if (!maybeKeys) {
	                    maybeKeys = [];
	                    sourceStack = [];
	                    targetStack = [];
	                }
	                else {
	                    for (var i = 0; i < maybeCount; i++) {
	                        // If source and target are already being compared, consider them related with assumptions
	                        if (id === maybeKeys[i]) {
	                            return 1 /* Maybe */;
	                        }
	                    }
	                    if (depth === 100) {
	                        overflow = true;
	                        return 0 /* False */;
	                    }
	                }
	                var maybeStart = maybeCount;
	                maybeKeys[maybeCount] = id;
	                maybeCount++;
	                sourceStack[depth] = source;
	                targetStack[depth] = target;
	                depth++;
	                var saveExpandingFlags = expandingFlags;
	                if (!(expandingFlags & 1 /* Source */) && isDeeplyNestedType(source, sourceStack, depth))
	                    expandingFlags |= 1 /* Source */;
	                if (!(expandingFlags & 2 /* Target */) && isDeeplyNestedType(target, targetStack, depth))
	                    expandingFlags |= 2 /* Target */;
	                var result = expandingFlags !== 3 /* Both */ ? structuredTypeRelatedTo(source, target, reportErrors) : 1 /* Maybe */;
	                expandingFlags = saveExpandingFlags;
	                depth--;
	                if (result) {
	                    if (result === -1 /* True */ || depth === 0) {
	                        // If result is definitely true, record all maybe keys as having succeeded
	                        for (var i = maybeStart; i < maybeCount; i++) {
	                            relation.set(maybeKeys[i], 1 /* Succeeded */);
	                        }
	                        maybeCount = maybeStart;
	                    }
	                }
	                else {
	                    // A false result goes straight into global cache (when something is false under
	                    // assumptions it will also be false without assumptions)
	                    relation.set(id, reportErrors ? 3 /* FailedAndReported */ : 2 /* Failed */);
	                    maybeCount = maybeStart;
	                }
	                return result;
	            }
	            function getConstraintForRelation(type) {
	                return relation === definitelyAssignableRelation ? undefined : getConstraintOfType(type);
	            }
	            function structuredTypeRelatedTo(source, target, reportErrors) {
	                var result;
	                var originalErrorInfo;
	                var saveErrorInfo = errorInfo;
	                if (target.flags & 32768 /* TypeParameter */) {
	                    // A source type { [P in keyof T]: X } is related to a target type T if X is related to T[P].
	                    if (ts.getObjectFlags(source) & 32 /* Mapped */ && getConstraintTypeFromMappedType(source) === getIndexType(target)) {
	                        if (!(getMappedTypeModifiers(source) & 4 /* IncludeOptional */)) {
	                            var templateType = getTemplateTypeFromMappedType(source);
	                            var indexedAccessType = getIndexedAccessType(target, getTypeParameterFromMappedType(source));
	                            if (result = isRelatedTo(templateType, indexedAccessType, reportErrors)) {
	                                return result;
	                            }
	                        }
	                    }
	                }
	                else if (target.flags & 524288 /* Index */) {
	                    // A keyof S is related to a keyof T if T is related to S.
	                    if (source.flags & 524288 /* Index */) {
	                        if (result = isRelatedTo(target.type, source.type, /*reportErrors*/ false)) {
	                            return result;
	                        }
	                    }
	                    // A type S is assignable to keyof T if S is assignable to keyof C, where C is the
	                    // constraint of T.
	                    var constraint = getConstraintForRelation(target.type);
	                    if (constraint) {
	                        if (result = isRelatedTo(source, getIndexType(constraint), reportErrors)) {
	                            return result;
	                        }
	                    }
	                }
	                else if (target.flags & 1048576 /* IndexedAccess */) {
	                    // A type S is related to a type T[K] if S is related to A[K], where K is string-like and
	                    // A is the apparent type of T.
	                    var constraint = getConstraintForRelation(target);
	                    if (constraint) {
	                        if (result = isRelatedTo(source, constraint, reportErrors)) {
	                            errorInfo = saveErrorInfo;
	                            return result;
	                        }
	                    }
	                }
	                else if (isGenericMappedType(target)) {
	                    // A source type T is related to a target type { [P in X]: T[P] }
	                    var template = getTemplateTypeFromMappedType(target);
	                    var modifiers = getMappedTypeModifiers(target);
	                    if (!(modifiers & 8 /* ExcludeOptional */)) {
	                        if (template.flags & 1048576 /* IndexedAccess */ && template.objectType === source &&
	                            template.indexType === getTypeParameterFromMappedType(target)) {
	                            return -1 /* True */;
	                        }
	                        // A source type T is related to a target type { [P in keyof T]: X } if T[P] is related to X.
	                        if (!isGenericMappedType(source) && getConstraintTypeFromMappedType(target) === getIndexType(source)) {
	                            var indexedAccessType = getIndexedAccessType(source, getTypeParameterFromMappedType(target));
	                            var templateType = getTemplateTypeFromMappedType(target);
	                            if (result = isRelatedTo(indexedAccessType, templateType, reportErrors)) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                        }
	                    }
	                }
	                if (source.flags & 32768 /* TypeParameter */) {
	                    var constraint = getConstraintForRelation(source);
	                    // A type parameter with no constraint is not related to the non-primitive object type.
	                    if (constraint || !(target.flags & 134217728 /* NonPrimitive */)) {
	                        if (!constraint || constraint.flags & 1 /* Any */) {
	                            constraint = emptyObjectType;
	                        }
	                        // Report constraint errors only if the constraint is not the empty object type
	                        var reportConstraintErrors = reportErrors && constraint !== emptyObjectType;
	                        if (result = isRelatedTo(constraint, target, reportConstraintErrors)) {
	                            errorInfo = saveErrorInfo;
	                            return result;
	                        }
	                    }
	                }
	                else if (source.flags & 1048576 /* IndexedAccess */) {
	                    // A type S[K] is related to a type T if A[K] is related to T, where K is string-like and
	                    // A is the apparent type of S.
	                    var constraint = getConstraintForRelation(source);
	                    if (constraint) {
	                        if (result = isRelatedTo(constraint, target, reportErrors)) {
	                            errorInfo = saveErrorInfo;
	                            return result;
	                        }
	                    }
	                    else if (target.flags & 1048576 /* IndexedAccess */) {
	                        if (result = isRelatedTo(source.objectType, target.objectType, reportErrors)) {
	                            result &= isRelatedTo(source.indexType, target.indexType, reportErrors);
	                        }
	                        if (result) {
	                            errorInfo = saveErrorInfo;
	                            return result;
	                        }
	                    }
	                }
	                else if (source.flags & 2097152 /* Conditional */) {
	                    if (relation !== definitelyAssignableRelation) {
	                        var constraint = getConstraintOfDistributiveConditionalType(source);
	                        if (constraint) {
	                            if (result = isRelatedTo(constraint, target, reportErrors)) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                        }
	                    }
	                    if (target.flags & 2097152 /* Conditional */) {
	                        if (isTypeIdenticalTo(source.checkType, target.checkType) &&
	                            isTypeIdenticalTo(source.extendsType, target.extendsType)) {
	                            if (result = isRelatedTo(source.trueType, target.trueType, reportErrors)) {
	                                result &= isRelatedTo(source.falseType, target.falseType, reportErrors);
	                            }
	                            if (result) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                        }
	                    }
	                    else if (result = isRelatedTo(getDefaultConstraintOfConditionalType(source), target, reportErrors)) {
	                        errorInfo = saveErrorInfo;
	                        return result;
	                    }
	                }
	                else {
	                    if (ts.getObjectFlags(source) & 4 /* Reference */ && ts.getObjectFlags(target) & 4 /* Reference */ && source.target === target.target &&
	                        !(ts.getObjectFlags(source) & 8192 /* MarkerType */ || ts.getObjectFlags(target) & 8192 /* MarkerType */)) {
	                        // We have type references to the same generic type, and the type references are not marker
	                        // type references (which are intended by be compared structurally). Obtain the variance
	                        // information for the type parameters and relate the type arguments accordingly.
	                        var variances = getVariances(source.target);
	                        if (result = typeArgumentsRelatedTo(source, target, variances, reportErrors)) {
	                            return result;
	                        }
	                        // The type arguments did not relate appropriately, but it may be because we have no variance
	                        // information (in which case typeArgumentsRelatedTo defaulted to covariance for all type
	                        // arguments). It might also be the case that the target type has a 'void' type argument for
	                        // a covariant type parameter that is only used in return positions within the generic type
	                        // (in which case any type argument is permitted on the source side). In those cases we proceed
	                        // with a structural comparison. Otherwise, we know for certain the instantiations aren't
	                        // related and we can return here.
	                        if (variances !== ts.emptyArray && !hasCovariantVoidArgument(target, variances)) {
	                            // In some cases generic types that are covariant in regular type checking mode become
	                            // invariant in --strictFunctionTypes mode because one or more type parameters are used in
	                            // both co- and contravariant positions. In order to make it easier to diagnose *why* such
	                            // types are invariant, if any of the type parameters are invariant we reset the reported
	                            // errors and instead force a structural comparison (which will include elaborations that
	                            // reveal the reason).
	                            if (!(reportErrors && ts.some(variances, function (v) { return v === 0 /* Invariant */; }))) {
	                                return 0 /* False */;
	                            }
	                            // We remember the original error information so we can restore it in case the structural
	                            // comparison unexpectedly succeeds. This can happen when the structural comparison result
	                            // is a Ternary.Maybe for example caused by the recursion depth limiter.
	                            originalErrorInfo = errorInfo;
	                            errorInfo = saveErrorInfo;
	                        }
	                    }
	                    // Even if relationship doesn't hold for unions, intersections, or generic type references,
	                    // it may hold in a structural comparison.
	                    var sourceIsPrimitive = !!(source.flags & 16382 /* Primitive */);
	                    if (relation !== identityRelation) {
	                        source = getApparentType(source);
	                    }
	                    // In a check of the form X = A & B, we will have previously checked if A relates to X or B relates
	                    // to X. Failing both of those we want to check if the aggregation of A and B's members structurally
	                    // relates to X. Thus, we include intersection types on the source side here.
	                    if (source.flags & (65536 /* Object */ | 262144 /* Intersection */) && target.flags & 65536 /* Object */) {
	                        // Report structural errors only if we haven't reported any errors yet
	                        var reportStructuralErrors = reportErrors && errorInfo === saveErrorInfo && !sourceIsPrimitive;
	                        // An empty object type is related to any mapped type that includes a '?' modifier.
	                        if (isPartialMappedType(target) && !isGenericMappedType(source) && isEmptyObjectType(source)) {
	                            result = -1 /* True */;
	                        }
	                        else if (isGenericMappedType(target)) {
	                            result = isGenericMappedType(source) ? mappedTypeRelatedTo(source, target, reportStructuralErrors) : 0 /* False */;
	                        }
	                        else {
	                            result = propertiesRelatedTo(source, target, reportStructuralErrors);
	                            if (result) {
	                                result &= signaturesRelatedTo(source, target, 0 /* Call */, reportStructuralErrors);
	                                if (result) {
	                                    result &= signaturesRelatedTo(source, target, 1 /* Construct */, reportStructuralErrors);
	                                    if (result) {
	                                        result &= indexTypesRelatedTo(source, target, 0 /* String */, sourceIsPrimitive, reportStructuralErrors);
	                                        if (result) {
	                                            result &= indexTypesRelatedTo(source, target, 1 /* Number */, sourceIsPrimitive, reportStructuralErrors);
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                        if (result) {
	                            if (!originalErrorInfo) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                            errorInfo = originalErrorInfo;
	                        }
	                    }
	                }
	                return 0 /* False */;
	            }
	            // A type [P in S]: X is related to a type [Q in T]: Y if T is related to S and X' is
	            // related to Y, where X' is an instantiation of X in which P is replaced with Q. Notice
	            // that S and T are contra-variant whereas X and Y are co-variant.
	            function mappedTypeRelatedTo(source, target, reportErrors) {
	                var modifiersRelated = relation === comparableRelation || (relation === identityRelation ? getMappedTypeModifiers(source) === getMappedTypeModifiers(target) :
	                    getCombinedMappedTypeOptionality(source) <= getCombinedMappedTypeOptionality(target));
	                if (modifiersRelated) {
	                    var result_1;
	                    if (result_1 = isRelatedTo(getConstraintTypeFromMappedType(target), getConstraintTypeFromMappedType(source), reportErrors)) {
	                        var mapper = createTypeMapper([getTypeParameterFromMappedType(source)], [getTypeParameterFromMappedType(target)]);
	                        return result_1 & isRelatedTo(instantiateType(getTemplateTypeFromMappedType(source), mapper), getTemplateTypeFromMappedType(target), reportErrors);
	                    }
	                }
	                return 0 /* False */;
	            }
	            function propertiesRelatedTo(source, target, reportErrors) {
	                if (relation === identityRelation) {
	                    return propertiesIdenticalTo(source, target);
	                }
	                var requireOptionalProperties = relation === subtypeRelation && !isObjectLiteralType(source) && !isEmptyArrayLiteralType(source);
	                var unmatchedProperty = getUnmatchedProperty(source, target, requireOptionalProperties);
	                if (unmatchedProperty) {
	                    if (reportErrors) {
	                        reportError(ts.Diagnostics.Property_0_is_missing_in_type_1, symbolToString(unmatchedProperty), typeToString(source));
	                    }
	                    return 0 /* False */;
	                }
	                if (isObjectLiteralType(target)) {
	                    for (var _i = 0, _a = getPropertiesOfType(source); _i < _a.length; _i++) {
	                        var sourceProp = _a[_i];
	                        if (!getPropertyOfObjectType(target, sourceProp.escapedName)) {
	                            var sourceType = getTypeOfSymbol(sourceProp);
	                            if (!(sourceType === undefinedType || sourceType === undefinedWideningType)) {
	                                if (reportErrors) {
	                                    reportError(ts.Diagnostics.Property_0_does_not_exist_on_type_1, symbolToString(sourceProp), typeToString(target));
	                                }
	                                return 0 /* False */;
	                            }
	                        }
	                    }
	                }
	                var result = -1 /* True */;
	                var properties = getPropertiesOfObjectType(target);
	                for (var _b = 0, properties_3 = properties; _b < properties_3.length; _b++) {
	                    var targetProp = properties_3[_b];
	                    if (!(targetProp.flags & 4194304 /* Prototype */)) {
	                        var sourceProp = getPropertyOfType(source, targetProp.escapedName);
	                        if (sourceProp && sourceProp !== targetProp) {
	                            if (isIgnoredJsxProperty(source, sourceProp, getTypeOfSymbol(targetProp))) {
	                                continue;
	                            }
	                            var sourcePropFlags = ts.getDeclarationModifierFlagsFromSymbol(sourceProp);
	                            var targetPropFlags = ts.getDeclarationModifierFlagsFromSymbol(targetProp);
	                            if (sourcePropFlags & 8 /* Private */ || targetPropFlags & 8 /* Private */) {
	                                if (ts.getCheckFlags(sourceProp) & 256 /* ContainsPrivate */) {
	                                    if (reportErrors) {
	                                        reportError(ts.Diagnostics.Property_0_has_conflicting_declarations_and_is_inaccessible_in_type_1, symbolToString(sourceProp), typeToString(source));
	                                    }
	                                    return 0 /* False */;
	                                }
	                                if (sourceProp.valueDeclaration !== targetProp.valueDeclaration) {
	                                    if (reportErrors) {
	                                        if (sourcePropFlags & 8 /* Private */ && targetPropFlags & 8 /* Private */) {
	                                            reportError(ts.Diagnostics.Types_have_separate_declarations_of_a_private_property_0, symbolToString(targetProp));
	                                        }
	                                        else {
	                                            reportError(ts.Diagnostics.Property_0_is_private_in_type_1_but_not_in_type_2, symbolToString(targetProp), typeToString(sourcePropFlags & 8 /* Private */ ? source : target), typeToString(sourcePropFlags & 8 /* Private */ ? target : source));
	                                        }
	                                    }
	                                    return 0 /* False */;
	                                }
	                            }
	                            else if (targetPropFlags & 16 /* Protected */) {
	                                if (!isValidOverrideOf(sourceProp, targetProp)) {
	                                    if (reportErrors) {
	                                        reportError(ts.Diagnostics.Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2, symbolToString(targetProp), typeToString(getDeclaringClass(sourceProp) || source), typeToString(getDeclaringClass(targetProp) || target));
	                                    }
	                                    return 0 /* False */;
	                                }
	                            }
	                            else if (sourcePropFlags & 16 /* Protected */) {
	                                if (reportErrors) {
	                                    reportError(ts.Diagnostics.Property_0_is_protected_in_type_1_but_public_in_type_2, symbolToString(targetProp), typeToString(source), typeToString(target));
	                                }
	                                return 0 /* False */;
	                            }
	                            var related = isRelatedTo(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp), reportErrors);
	                            if (!related) {
	                                if (reportErrors) {
	                                    reportError(ts.Diagnostics.Types_of_property_0_are_incompatible, symbolToString(targetProp));
	                                }
	                                return 0 /* False */;
	                            }
	                            result &= related;
	                            // When checking for comparability, be more lenient with optional properties.
	                            if (relation !== comparableRelation && sourceProp.flags & 16777216 /* Optional */ && !(targetProp.flags & 16777216 /* Optional */)) {
	                                // TypeScript 1.0 spec (April 2014): 3.8.3
	                                // S is a subtype of a type T, and T is a supertype of S if ...
	                                // S' and T are object types and, for each member M in T..
	                                // M is a property and S' contains a property N where
	                                // if M is a required property, N is also a required property
	                                // (M - property in T)
	                                // (N - property in S)
	                                if (reportErrors) {
	                                    reportError(ts.Diagnostics.Property_0_is_optional_in_type_1_but_required_in_type_2, symbolToString(targetProp), typeToString(source), typeToString(target));
	                                }
	                                return 0 /* False */;
	                            }
	                        }
	                    }
	                }
	                return result;
	            }
	            /**
	             * A type is 'weak' if it is an object type with at least one optional property
	             * and no required properties, call/construct signatures or index signatures
	             */
	            function isWeakType(type) {
	                if (type.flags & 65536 /* Object */) {
	                    var resolved = resolveStructuredTypeMembers(type);
	                    return resolved.callSignatures.length === 0 && resolved.constructSignatures.length === 0 &&
	                        !resolved.stringIndexInfo && !resolved.numberIndexInfo &&
	                        resolved.properties.length > 0 &&
	                        ts.every(resolved.properties, function (p) { return !!(p.flags & 16777216 /* Optional */); });
	                }
	                if (type.flags & 262144 /* Intersection */) {
	                    return ts.every(type.types, isWeakType);
	                }
	                return false;
	            }
	            function hasCommonProperties(source, target) {
	                var isComparingJsxAttributes = !!(ts.getObjectFlags(source) & 4096 /* JsxAttributes */);
	                for (var _i = 0, _a = getPropertiesOfType(source); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (isKnownProperty(target, prop.escapedName, isComparingJsxAttributes)) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	            function propertiesIdenticalTo(source, target) {
	                if (!(source.flags & 65536 /* Object */ && target.flags & 65536 /* Object */)) {
	                    return 0 /* False */;
	                }
	                var sourceProperties = getPropertiesOfObjectType(source);
	                var targetProperties = getPropertiesOfObjectType(target);
	                if (sourceProperties.length !== targetProperties.length) {
	                    return 0 /* False */;
	                }
	                var result = -1 /* True */;
	                for (var _i = 0, sourceProperties_1 = sourceProperties; _i < sourceProperties_1.length; _i++) {
	                    var sourceProp = sourceProperties_1[_i];
	                    var targetProp = getPropertyOfObjectType(target, sourceProp.escapedName);
	                    if (!targetProp) {
	                        return 0 /* False */;
	                    }
	                    var related = compareProperties(sourceProp, targetProp, isRelatedTo);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function signaturesRelatedTo(source, target, kind, reportErrors) {
	                if (relation === identityRelation) {
	                    return signaturesIdenticalTo(source, target, kind);
	                }
	                if (target === anyFunctionType || source === anyFunctionType) {
	                    return -1 /* True */;
	                }
	                var sourceSignatures = getSignaturesOfType(source, kind);
	                var targetSignatures = getSignaturesOfType(target, kind);
	                if (kind === 1 /* Construct */ && sourceSignatures.length && targetSignatures.length) {
	                    if (ts.isAbstractConstructorType(source) && !ts.isAbstractConstructorType(target)) {
	                        // An abstract constructor type is not assignable to a non-abstract constructor type
	                        // as it would otherwise be possible to new an abstract class. Note that the assignability
	                        // check we perform for an extends clause excludes construct signatures from the target,
	                        // so this check never proceeds.
	                        if (reportErrors) {
	                            reportError(ts.Diagnostics.Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type);
	                        }
	                        return 0 /* False */;
	                    }
	                    if (!constructorVisibilitiesAreCompatible(sourceSignatures[0], targetSignatures[0], reportErrors)) {
	                        return 0 /* False */;
	                    }
	                }
	                var result = -1 /* True */;
	                var saveErrorInfo = errorInfo;
	                if (ts.getObjectFlags(source) & 64 /* Instantiated */ && ts.getObjectFlags(target) & 64 /* Instantiated */ && source.symbol === target.symbol) {
	                    // We have instantiations of the same anonymous type (which typically will be the type of a
	                    // method). Simply do a pairwise comparison of the signatures in the two signature lists instead
	                    // of the much more expensive N * M comparison matrix we explore below. We erase type parameters
	                    // as they are known to always be the same.
	                    for (var i = 0; i < targetSignatures.length; i++) {
	                        var related = signatureRelatedTo(sourceSignatures[i], targetSignatures[i], /*erase*/ true, reportErrors);
	                        if (!related) {
	                            return 0 /* False */;
	                        }
	                        result &= related;
	                    }
	                }
	                else if (sourceSignatures.length === 1 && targetSignatures.length === 1) {
	                    // For simple functions (functions with a single signature) we only erase type parameters for
	                    // the comparable relation. Otherwise, if the source signature is generic, we instantiate it
	                    // in the context of the target signature before checking the relationship. Ideally we'd do
	                    // this regardless of the number of signatures, but the potential costs are prohibitive due
	                    // to the quadratic nature of the logic below.
	                    var eraseGenerics = relation === comparableRelation || compilerOptions.noStrictGenericChecks;
	                    result = signatureRelatedTo(sourceSignatures[0], targetSignatures[0], eraseGenerics, reportErrors);
	                }
	                else {
	                    outer: for (var _i = 0, targetSignatures_1 = targetSignatures; _i < targetSignatures_1.length; _i++) {
	                        var t = targetSignatures_1[_i];
	                        // Only elaborate errors from the first failure
	                        var shouldElaborateErrors = reportErrors;
	                        for (var _a = 0, sourceSignatures_1 = sourceSignatures; _a < sourceSignatures_1.length; _a++) {
	                            var s = sourceSignatures_1[_a];
	                            var related = signatureRelatedTo(s, t, /*erase*/ true, shouldElaborateErrors);
	                            if (related) {
	                                result &= related;
	                                errorInfo = saveErrorInfo;
	                                continue outer;
	                            }
	                            shouldElaborateErrors = false;
	                        }
	                        if (shouldElaborateErrors) {
	                            reportError(ts.Diagnostics.Type_0_provides_no_match_for_the_signature_1, typeToString(source), signatureToString(t, /*enclosingDeclaration*/ undefined, /*flags*/ undefined, kind));
	                        }
	                        return 0 /* False */;
	                    }
	                }
	                return result;
	            }
	            /**
	             * See signatureAssignableTo, compareSignaturesIdentical
	             */
	            function signatureRelatedTo(source, target, erase, reportErrors) {
	                return compareSignaturesRelated(erase ? getErasedSignature(source) : source, erase ? getErasedSignature(target) : target, 0 /* None */, /*ignoreReturnTypes*/ false, reportErrors, reportError, isRelatedTo);
	            }
	            function signaturesIdenticalTo(source, target, kind) {
	                var sourceSignatures = getSignaturesOfType(source, kind);
	                var targetSignatures = getSignaturesOfType(target, kind);
	                if (sourceSignatures.length !== targetSignatures.length) {
	                    return 0 /* False */;
	                }
	                var result = -1 /* True */;
	                for (var i = 0; i < sourceSignatures.length; i++) {
	                    var related = compareSignaturesIdentical(sourceSignatures[i], targetSignatures[i], /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false, isRelatedTo);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function eachPropertyRelatedTo(source, target, kind, reportErrors) {
	                var result = -1 /* True */;
	                for (var _i = 0, _a = getPropertiesOfObjectType(source); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (isIgnoredJsxProperty(source, prop, /*targetMemberType*/ undefined)) {
	                        continue;
	                    }
	                    if (kind === 0 /* String */ || isNumericLiteralName(prop.escapedName)) {
	                        var related = isRelatedTo(getTypeOfSymbol(prop), target, reportErrors);
	                        if (!related) {
	                            if (reportErrors) {
	                                reportError(ts.Diagnostics.Property_0_is_incompatible_with_index_signature, symbolToString(prop));
	                            }
	                            return 0 /* False */;
	                        }
	                        result &= related;
	                    }
	                }
	                return result;
	            }
	            function indexInfoRelatedTo(sourceInfo, targetInfo, reportErrors) {
	                var related = isRelatedTo(sourceInfo.type, targetInfo.type, reportErrors);
	                if (!related && reportErrors) {
	                    reportError(ts.Diagnostics.Index_signatures_are_incompatible);
	                }
	                return related;
	            }
	            function indexTypesRelatedTo(source, target, kind, sourceIsPrimitive, reportErrors) {
	                if (relation === identityRelation) {
	                    return indexTypesIdenticalTo(source, target, kind);
	                }
	                var targetInfo = getIndexInfoOfType(target, kind);
	                if (!targetInfo || targetInfo.type.flags & 1 /* Any */ && !sourceIsPrimitive) {
	                    // Index signature of type any permits assignment from everything but primitives
	                    return -1 /* True */;
	                }
	                var sourceInfo = getIndexInfoOfType(source, kind) ||
	                    kind === 1 /* Number */ && getIndexInfoOfType(source, 0 /* String */);
	                if (sourceInfo) {
	                    return indexInfoRelatedTo(sourceInfo, targetInfo, reportErrors);
	                }
	                if (isGenericMappedType(source)) {
	                    // A generic mapped type { [P in K]: T } is related to an index signature { [x: string]: U }
	                    // if T is related to U.
	                    return kind === 0 /* String */ && isRelatedTo(getTemplateTypeFromMappedType(source), targetInfo.type, reportErrors);
	                }
	                if (isObjectTypeWithInferableIndex(source)) {
	                    var related = -1 /* True */;
	                    if (kind === 0 /* String */) {
	                        var sourceNumberInfo = getIndexInfoOfType(source, 1 /* Number */);
	                        if (sourceNumberInfo) {
	                            related = indexInfoRelatedTo(sourceNumberInfo, targetInfo, reportErrors);
	                        }
	                    }
	                    if (related) {
	                        related &= eachPropertyRelatedTo(source, targetInfo.type, kind, reportErrors);
	                    }
	                    return related;
	                }
	                if (reportErrors) {
	                    reportError(ts.Diagnostics.Index_signature_is_missing_in_type_0, typeToString(source));
	                }
	                return 0 /* False */;
	            }
	            function indexTypesIdenticalTo(source, target, indexKind) {
	                var targetInfo = getIndexInfoOfType(target, indexKind);
	                var sourceInfo = getIndexInfoOfType(source, indexKind);
	                if (!sourceInfo && !targetInfo) {
	                    return -1 /* True */;
	                }
	                if (sourceInfo && targetInfo && sourceInfo.isReadonly === targetInfo.isReadonly) {
	                    return isRelatedTo(sourceInfo.type, targetInfo.type);
	                }
	                return 0 /* False */;
	            }
	            function constructorVisibilitiesAreCompatible(sourceSignature, targetSignature, reportErrors) {
	                if (!sourceSignature.declaration || !targetSignature.declaration) {
	                    return true;
	                }
	                var sourceAccessibility = ts.getSelectedModifierFlags(sourceSignature.declaration, 24 /* NonPublicAccessibilityModifier */);
	                var targetAccessibility = ts.getSelectedModifierFlags(targetSignature.declaration, 24 /* NonPublicAccessibilityModifier */);
	                // A public, protected and private signature is assignable to a private signature.
	                if (targetAccessibility === 8 /* Private */) {
	                    return true;
	                }
	                // A public and protected signature is assignable to a protected signature.
	                if (targetAccessibility === 16 /* Protected */ && sourceAccessibility !== 8 /* Private */) {
	                    return true;
	                }
	                // Only a public signature is assignable to public signature.
	                if (targetAccessibility !== 16 /* Protected */ && !sourceAccessibility) {
	                    return true;
	                }
	                if (reportErrors) {
	                    reportError(ts.Diagnostics.Cannot_assign_a_0_constructor_type_to_a_1_constructor_type, visibilityToString(sourceAccessibility), visibilityToString(targetAccessibility));
	                }
	                return false;
	            }
	        }
	        // Return a type reference where the source type parameter is replaced with the target marker
	        // type, and flag the result as a marker type reference.
	        function getMarkerTypeReference(type, source, target) {
	            var result = createTypeReference(type, ts.map(type.typeParameters, function (t) { return t === source ? target : t; }));
	            result.objectFlags |= 8192 /* MarkerType */;
	            return result;
	        }
	        // Return an array containing the variance of each type parameter. The variance is effectively
	        // a digest of the type comparisons that occur for each type argument when instantiations of the
	        // generic type are structurally compared. We infer the variance information by comparing
	        // instantiations of the generic type for type arguments with known relations. The function
	        // returns the emptyArray singleton if we're not in strictFunctionTypes mode or if the function
	        // has been invoked recursively for the given generic type.
	        function getVariances(type) {
	            if (!strictFunctionTypes) {
	                return ts.emptyArray;
	            }
	            var typeParameters = type.typeParameters || ts.emptyArray;
	            var variances = type.variances;
	            if (!variances) {
	                if (type === globalArrayType || type === globalReadonlyArrayType) {
	                    // Arrays are known to be covariant, no need to spend time computing this
	                    variances = [1 /* Covariant */];
	                }
	                else {
	                    // The emptyArray singleton is used to signal a recursive invocation.
	                    type.variances = ts.emptyArray;
	                    variances = [];
	                    for (var _i = 0, typeParameters_1 = typeParameters; _i < typeParameters_1.length; _i++) {
	                        var tp = typeParameters_1[_i];
	                        // We first compare instantiations where the type parameter is replaced with
	                        // marker types that have a known subtype relationship. From this we can infer
	                        // invariance, covariance, contravariance or bivariance.
	                        var typeWithSuper = getMarkerTypeReference(type, tp, markerSuperType);
	                        var typeWithSub = getMarkerTypeReference(type, tp, markerSubType);
	                        var variance = (isTypeAssignableTo(typeWithSub, typeWithSuper) ? 1 /* Covariant */ : 0) |
	                            (isTypeAssignableTo(typeWithSuper, typeWithSub) ? 2 /* Contravariant */ : 0);
	                        // If the instantiations appear to be related bivariantly it may be because the
	                        // type parameter is independent (i.e. it isn't witnessed anywhere in the generic
	                        // type). To determine this we compare instantiations where the type parameter is
	                        // replaced with marker types that are known to be unrelated.
	                        if (variance === 3 /* Bivariant */ && isTypeAssignableTo(getMarkerTypeReference(type, tp, markerOtherType), typeWithSuper)) {
	                            variance = 4 /* Independent */;
	                        }
	                        variances.push(variance);
	                    }
	                }
	                type.variances = variances;
	            }
	            return variances;
	        }
	        // Return true if the given type reference has a 'void' type argument for a covariant type parameter.
	        // See comment at call in recursiveTypeRelatedTo for when this case matters.
	        function hasCovariantVoidArgument(type, variances) {
	            for (var i = 0; i < variances.length; i++) {
	                if (variances[i] === 1 /* Covariant */ && type.typeArguments[i].flags & 2048 /* Void */) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function isUnconstrainedTypeParameter(type) {
	            return type.flags & 32768 /* TypeParameter */ && !getConstraintFromTypeParameter(type);
	        }
	        function isTypeReferenceWithGenericArguments(type) {
	            return ts.getObjectFlags(type) & 4 /* Reference */ && ts.some(type.typeArguments, function (t) { return isUnconstrainedTypeParameter(t) || isTypeReferenceWithGenericArguments(t); });
	        }
	        /**
	         * getTypeReferenceId(A<T, number, U>) returns "111=0-12=1"
	         *   where A.id=111 and number.id=12
	         */
	        function getTypeReferenceId(type, typeParameters, depth) {
	            if (depth === void 0) { depth = 0; }
	            var result = "" + type.target.id;
	            for (var _i = 0, _a = type.typeArguments; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (isUnconstrainedTypeParameter(t)) {
	                    var index = typeParameters.indexOf(t);
	                    if (index < 0) {
	                        index = typeParameters.length;
	                        typeParameters.push(t);
	                    }
	                    result += "=" + index;
	                }
	                else if (depth < 4 && isTypeReferenceWithGenericArguments(t)) {
	                    result += "<" + getTypeReferenceId(t, typeParameters, depth + 1) + ">";
	                }
	                else {
	                    result += "-" + t.id;
	                }
	            }
	            return result;
	        }
	        /**
	         * To improve caching, the relation key for two generic types uses the target's id plus ids of the type parameters.
	         * For other cases, the types ids are used.
	         */
	        function getRelationKey(source, target, relation) {
	            if (relation === identityRelation && source.id > target.id) {
	                var temp = source;
	                source = target;
	                target = temp;
	            }
	            if (isTypeReferenceWithGenericArguments(source) && isTypeReferenceWithGenericArguments(target)) {
	                var typeParameters = [];
	                return getTypeReferenceId(source, typeParameters) + "," + getTypeReferenceId(target, typeParameters);
	            }
	            return source.id + "," + target.id;
	        }
	        // Invoke the callback for each underlying property symbol of the given symbol and return the first
	        // value that isn't undefined.
	        function forEachProperty(prop, callback) {
	            if (ts.getCheckFlags(prop) & 6 /* Synthetic */) {
	                for (var _i = 0, _a = prop.containingType.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    var p = getPropertyOfType(t, prop.escapedName);
	                    var result = p && forEachProperty(p, callback);
	                    if (result) {
	                        return result;
	                    }
	                }
	                return undefined;
	            }
	            return callback(prop);
	        }
	        // Return the declaring class type of a property or undefined if property not declared in class
	        function getDeclaringClass(prop) {
	            return prop.parent && prop.parent.flags & 32 /* Class */ ? getDeclaredTypeOfSymbol(getParentOfSymbol(prop)) : undefined;
	        }
	        // Return true if some underlying source property is declared in a class that derives
	        // from the given base class.
	        function isPropertyInClassDerivedFrom(prop, baseClass) {
	            return forEachProperty(prop, function (sp) {
	                var sourceClass = getDeclaringClass(sp);
	                return sourceClass ? hasBaseType(sourceClass, baseClass) : false;
	            });
	        }
	        // Return true if source property is a valid override of protected parts of target property.
	        function isValidOverrideOf(sourceProp, targetProp) {
	            return !forEachProperty(targetProp, function (tp) { return ts.getDeclarationModifierFlagsFromSymbol(tp) & 16 /* Protected */ ?
	                !isPropertyInClassDerivedFrom(sourceProp, getDeclaringClass(tp)) : false; });
	        }
	        // Return true if the given class derives from each of the declaring classes of the protected
	        // constituents of the given property.
	        function isClassDerivedFromDeclaringClasses(checkClass, prop) {
	            return forEachProperty(prop, function (p) { return ts.getDeclarationModifierFlagsFromSymbol(p) & 16 /* Protected */ ?
	                !hasBaseType(checkClass, getDeclaringClass(p)) : false; }) ? undefined : checkClass;
	        }
	        // Return true if the given type is deeply nested. We consider this to be the case when structural type comparisons
	        // for 5 or more occurrences or instantiations of the type have been recorded on the given stack. It is possible,
	        // though highly unlikely, for this test to be true in a situation where a chain of instantiations is not infinitely
	        // expanding. Effectively, we will generate a false positive when two types are structurally equal to at least 5
	        // levels, but unequal at some level beyond that.
	        function isDeeplyNestedType(type, stack, depth) {
	            // We track all object types that have an associated symbol (representing the origin of the type)
	            if (depth >= 5 && type.flags & 65536 /* Object */) {
	                var symbol = type.symbol;
	                if (symbol) {
	                    var count = 0;
	                    for (var i = 0; i < depth; i++) {
	                        var t = stack[i];
	                        if (t.flags & 65536 /* Object */ && t.symbol === symbol) {
	                            count++;
	                            if (count >= 5)
	                                return true;
	                        }
	                    }
	                }
	            }
	            return false;
	        }
	        function isPropertyIdenticalTo(sourceProp, targetProp) {
	            return compareProperties(sourceProp, targetProp, compareTypesIdentical) !== 0 /* False */;
	        }
	        function compareProperties(sourceProp, targetProp, compareTypes) {
	            // Two members are considered identical when
	            // - they are public properties with identical names, optionality, and types,
	            // - they are private or protected properties originating in the same declaration and having identical types
	            if (sourceProp === targetProp) {
	                return -1 /* True */;
	            }
	            var sourcePropAccessibility = ts.getDeclarationModifierFlagsFromSymbol(sourceProp) & 24 /* NonPublicAccessibilityModifier */;
	            var targetPropAccessibility = ts.getDeclarationModifierFlagsFromSymbol(targetProp) & 24 /* NonPublicAccessibilityModifier */;
	            if (sourcePropAccessibility !== targetPropAccessibility) {
	                return 0 /* False */;
	            }
	            if (sourcePropAccessibility) {
	                if (getTargetSymbol(sourceProp) !== getTargetSymbol(targetProp)) {
	                    return 0 /* False */;
	                }
	            }
	            else {
	                if ((sourceProp.flags & 16777216 /* Optional */) !== (targetProp.flags & 16777216 /* Optional */)) {
	                    return 0 /* False */;
	                }
	            }
	            if (isReadonlySymbol(sourceProp) !== isReadonlySymbol(targetProp)) {
	                return 0 /* False */;
	            }
	            return compareTypes(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp));
	        }
	        function isMatchingSignature(source, target, partialMatch) {
	            // A source signature matches a target signature if the two signatures have the same number of required,
	            // optional, and rest parameters.
	            if (source.parameters.length === target.parameters.length &&
	                source.minArgumentCount === target.minArgumentCount &&
	                source.hasRestParameter === target.hasRestParameter) {
	                return true;
	            }
	            // A source signature partially matches a target signature if the target signature has no fewer required
	            // parameters and no more overall parameters than the source signature (where a signature with a rest
	            // parameter is always considered to have more overall parameters than one without).
	            var sourceRestCount = source.hasRestParameter ? 1 : 0;
	            var targetRestCount = target.hasRestParameter ? 1 : 0;
	            if (partialMatch && source.minArgumentCount <= target.minArgumentCount && (sourceRestCount > targetRestCount ||
	                sourceRestCount === targetRestCount && source.parameters.length >= target.parameters.length)) {
	                return true;
	            }
	            return false;
	        }
	        /**
	         * See signatureRelatedTo, compareSignaturesIdentical
	         */
	        function compareSignaturesIdentical(source, target, partialMatch, ignoreThisTypes, ignoreReturnTypes, compareTypes) {
	            // TODO (drosen): De-duplicate code between related functions.
	            if (source === target) {
	                return -1 /* True */;
	            }
	            if (!(isMatchingSignature(source, target, partialMatch))) {
	                return 0 /* False */;
	            }
	            // Check that the two signatures have the same number of type parameters. We might consider
	            // also checking that any type parameter constraints match, but that would require instantiating
	            // the constraints with a common set of type arguments to get relatable entities in places where
	            // type parameters occur in the constraints. The complexity of doing that doesn't seem worthwhile,
	            // particularly as we're comparing erased versions of the signatures below.
	            if (ts.length(source.typeParameters) !== ts.length(target.typeParameters)) {
	                return 0 /* False */;
	            }
	            // Spec 1.0 Section 3.8.3 & 3.8.4:
	            // M and N (the signatures) are instantiated using type Any as the type argument for all type parameters declared by M and N
	            source = getErasedSignature(source);
	            target = getErasedSignature(target);
	            var result = -1 /* True */;
	            if (!ignoreThisTypes) {
	                var sourceThisType = getThisTypeOfSignature(source);
	                if (sourceThisType) {
	                    var targetThisType = getThisTypeOfSignature(target);
	                    if (targetThisType) {
	                        var related = compareTypes(sourceThisType, targetThisType);
	                        if (!related) {
	                            return 0 /* False */;
	                        }
	                        result &= related;
	                    }
	                }
	            }
	            var targetLen = target.parameters.length;
	            for (var i = 0; i < targetLen; i++) {
	                var s = isRestParameterIndex(source, i) ? getRestTypeOfSignature(source) : getTypeOfParameter(source.parameters[i]);
	                var t = isRestParameterIndex(target, i) ? getRestTypeOfSignature(target) : getTypeOfParameter(target.parameters[i]);
	                var related = compareTypes(s, t);
	                if (!related) {
	                    return 0 /* False */;
	                }
	                result &= related;
	            }
	            if (!ignoreReturnTypes) {
	                var sourceTypePredicate = getTypePredicateOfSignature(source);
	                var targetTypePredicate = getTypePredicateOfSignature(target);
	                result &= sourceTypePredicate !== undefined || targetTypePredicate !== undefined
	                    ? compareTypePredicatesIdentical(sourceTypePredicate, targetTypePredicate, compareTypes)
	                    // If they're both type predicates their return types will both be `boolean`, so no need to compare those.
	                    : compareTypes(getReturnTypeOfSignature(source), getReturnTypeOfSignature(target));
	            }
	            return result;
	        }
	        function compareTypePredicatesIdentical(source, target, compareTypes) {
	            return source === undefined || target === undefined || !typePredicateKindsMatch(source, target) ? 0 /* False */ : compareTypes(source.type, target.type);
	        }
	        function isRestParameterIndex(signature, parameterIndex) {
	            return signature.hasRestParameter && parameterIndex >= signature.parameters.length - 1;
	        }
	        function literalTypesWithSameBaseType(types) {
	            var commonBaseType;
	            for (var _i = 0, types_9 = types; _i < types_9.length; _i++) {
	                var t = types_9[_i];
	                var baseType = getBaseTypeOfLiteralType(t);
	                if (!commonBaseType) {
	                    commonBaseType = baseType;
	                }
	                if (baseType === t || baseType !== commonBaseType) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        // When the candidate types are all literal types with the same base type, return a union
	        // of those literal types. Otherwise, return the leftmost type for which no type to the
	        // right is a supertype.
	        function getSupertypeOrUnion(types) {
	            return literalTypesWithSameBaseType(types) ?
	                getUnionType(types) :
	                ts.reduceLeft(types, function (s, t) { return isTypeSubtypeOf(s, t) ? t : s; });
	        }
	        function getCommonSupertype(types) {
	            if (!strictNullChecks) {
	                return getSupertypeOrUnion(types);
	            }
	            var primaryTypes = ts.filter(types, function (t) { return !(t.flags & 12288 /* Nullable */); });
	            return primaryTypes.length ?
	                getNullableType(getSupertypeOrUnion(primaryTypes), getFalsyFlagsOfTypes(types) & 12288 /* Nullable */) :
	                getUnionType(types, 2 /* Subtype */);
	        }
	        // Return the leftmost type for which no type to the right is a subtype.
	        function getCommonSubtype(types) {
	            return ts.reduceLeft(types, function (s, t) { return isTypeSubtypeOf(t, s) ? t : s; });
	        }
	        function isArrayType(type) {
	            return ts.getObjectFlags(type) & 4 /* Reference */ && type.target === globalArrayType;
	        }
	        function isArrayLikeType(type) {
	            // A type is array-like if it is a reference to the global Array or global ReadonlyArray type,
	            // or if it is not the undefined or null type and if it is assignable to ReadonlyArray<any>
	            return ts.getObjectFlags(type) & 4 /* Reference */ && (type.target === globalArrayType || type.target === globalReadonlyArrayType) ||
	                !(type.flags & 12288 /* Nullable */) && isTypeAssignableTo(type, anyReadonlyArrayType);
	        }
	        function isEmptyArrayLiteralType(type) {
	            var elementType = isArrayType(type) ? type.typeArguments[0] : undefined;
	            return elementType === undefinedWideningType || elementType === implicitNeverType;
	        }
	        function isTupleLikeType(type) {
	            return !!getPropertyOfType(type, "0");
	        }
	        function isUnitType(type) {
	            return !!(type.flags & 13536 /* Unit */);
	        }
	        function isLiteralType(type) {
	            return type.flags & 8 /* Boolean */ ? true :
	                type.flags & 131072 /* Union */ ? type.flags & 256 /* EnumLiteral */ ? true : !ts.forEach(type.types, function (t) { return !isUnitType(t); }) :
	                    isUnitType(type);
	        }
	        function getBaseTypeOfLiteralType(type) {
	            return type.flags & 256 /* EnumLiteral */ ? getBaseTypeOfEnumLiteralType(type) :
	                type.flags & 32 /* StringLiteral */ ? stringType :
	                    type.flags & 64 /* NumberLiteral */ ? numberType :
	                        type.flags & 128 /* BooleanLiteral */ ? booleanType :
	                            type.flags & 131072 /* Union */ ? getUnionType(ts.sameMap(type.types, getBaseTypeOfLiteralType)) :
	                                type;
	        }
	        function getWidenedLiteralType(type) {
	            return type.flags & 256 /* EnumLiteral */ ? getBaseTypeOfEnumLiteralType(type) :
	                type.flags & 32 /* StringLiteral */ && type.flags & 8388608 /* FreshLiteral */ ? stringType :
	                    type.flags & 64 /* NumberLiteral */ && type.flags & 8388608 /* FreshLiteral */ ? numberType :
	                        type.flags & 128 /* BooleanLiteral */ ? booleanType :
	                            type.flags & 131072 /* Union */ ? getUnionType(ts.sameMap(type.types, getWidenedLiteralType)) :
	                                type;
	        }
	        function getWidenedUniqueESSymbolType(type) {
	            return type.flags & 1024 /* UniqueESSymbol */ ? esSymbolType :
	                type.flags & 131072 /* Union */ ? getUnionType(ts.sameMap(type.types, getWidenedUniqueESSymbolType)) :
	                    type;
	        }
	        function getWidenedLiteralLikeTypeForContextualType(type, contextualType) {
	            if (!isLiteralOfContextualType(type, contextualType)) {
	                type = getWidenedUniqueESSymbolType(getWidenedLiteralType(type));
	            }
	            return type;
	        }
	        /**
	         * Check if a Type was written as a tuple type literal.
	         * Prefer using isTupleLikeType() unless the use of `elementTypes` is required.
	         */
	        function isTupleType(type) {
	            return !!(ts.getObjectFlags(type) & 4 /* Reference */ && type.target.objectFlags & 8 /* Tuple */);
	        }
	        function getFalsyFlagsOfTypes(types) {
	            var result = 0;
	            for (var _i = 0, types_10 = types; _i < types_10.length; _i++) {
	                var t = types_10[_i];
	                result |= getFalsyFlags(t);
	            }
	            return result;
	        }
	        // Returns the String, Number, Boolean, StringLiteral, NumberLiteral, BooleanLiteral, Void, Undefined, or Null
	        // flags for the string, number, boolean, "", 0, false, void, undefined, or null types respectively. Returns
	        // no flags for all other types (including non-falsy literal types).
	        function getFalsyFlags(type) {
	            return type.flags & 131072 /* Union */ ? getFalsyFlagsOfTypes(type.types) :
	                type.flags & 32 /* StringLiteral */ ? type.value === "" ? 32 /* StringLiteral */ : 0 :
	                    type.flags & 64 /* NumberLiteral */ ? type.value === 0 ? 64 /* NumberLiteral */ : 0 :
	                        type.flags & 128 /* BooleanLiteral */ ? type === falseType ? 128 /* BooleanLiteral */ : 0 :
	                            type.flags & 14574 /* PossiblyFalsy */;
	        }
	        function removeDefinitelyFalsyTypes(type) {
	            return getFalsyFlags(type) & 14560 /* DefinitelyFalsy */ ?
	                filterType(type, function (t) { return !(getFalsyFlags(t) & 14560 /* DefinitelyFalsy */); }) :
	                type;
	        }
	        function extractDefinitelyFalsyTypes(type) {
	            return mapType(type, getDefinitelyFalsyPartOfType);
	        }
	        function getDefinitelyFalsyPartOfType(type) {
	            return type.flags & 2 /* String */ ? emptyStringType :
	                type.flags & 4 /* Number */ ? zeroType :
	                    type.flags & 8 /* Boolean */ || type === falseType ? falseType :
	                        type.flags & (2048 /* Void */ | 4096 /* Undefined */ | 8192 /* Null */) ||
	                            type.flags & 32 /* StringLiteral */ && type.value === "" ||
	                            type.flags & 64 /* NumberLiteral */ && type.value === 0 ? type :
	                            neverType;
	        }
	        /**
	         * Add undefined or null or both to a type if they are missing.
	         * @param type - type to add undefined and/or null to if not present
	         * @param flags - Either TypeFlags.Undefined or TypeFlags.Null, or both
	         */
	        function getNullableType(type, flags) {
	            var missing = (flags & ~type.flags) & (4096 /* Undefined */ | 8192 /* Null */);
	            return missing === 0 ? type :
	                missing === 4096 /* Undefined */ ? getUnionType([type, undefinedType]) :
	                    missing === 8192 /* Null */ ? getUnionType([type, nullType]) :
	                        getUnionType([type, undefinedType, nullType]);
	        }
	        function getOptionalType(type) {
	            ts.Debug.assert(strictNullChecks);
	            return type.flags & 4096 /* Undefined */ ? type : getUnionType([type, undefinedType]);
	        }
	        function getNonNullableType(type) {
	            return strictNullChecks ? getTypeWithFacts(type, 524288 /* NEUndefinedOrNull */) : type;
	        }
	        /**
	         * Return true if type was inferred from an object literal, written as an object type literal, or is the shape of a module
	         * with no call or construct signatures.
	         */
	        function isObjectTypeWithInferableIndex(type) {
	            return type.symbol && (type.symbol.flags & (4096 /* ObjectLiteral */ | 2048 /* TypeLiteral */ | 512 /* ValueModule */)) !== 0 &&
	                !typeHasCallOrConstructSignatures(type);
	        }
	        function createSymbolWithType(source, type) {
	            var symbol = createSymbol(source.flags, source.escapedName);
	            symbol.declarations = source.declarations;
	            symbol.parent = source.parent;
	            symbol.type = type;
	            symbol.target = source;
	            if (source.valueDeclaration) {
	                symbol.valueDeclaration = source.valueDeclaration;
	            }
	            return symbol;
	        }
	        function transformTypeOfMembers(type, f) {
	            var members = ts.createSymbolTable();
	            for (var _i = 0, _a = getPropertiesOfObjectType(type); _i < _a.length; _i++) {
	                var property = _a[_i];
	                var original = getTypeOfSymbol(property);
	                var updated = f(original);
	                members.set(property.escapedName, updated === original ? property : createSymbolWithType(property, updated));
	            }
	            return members;
	        }
	        /**
	         * If the the provided object literal is subject to the excess properties check,
	         * create a new that is exempt. Recursively mark object literal members as exempt.
	         * Leave signatures alone since they are not subject to the check.
	         */
	        function getRegularTypeOfObjectLiteral(type) {
	            if (!(isObjectLiteralType(type) && type.flags & 8388608 /* FreshLiteral */)) {
	                return type;
	            }
	            var regularType = type.regularType;
	            if (regularType) {
	                return regularType;
	            }
	            var resolved = type;
	            var members = transformTypeOfMembers(type, getRegularTypeOfObjectLiteral);
	            var regularNew = createAnonymousType(resolved.symbol, members, resolved.callSignatures, resolved.constructSignatures, resolved.stringIndexInfo, resolved.numberIndexInfo);
	            regularNew.flags = resolved.flags & ~8388608 /* FreshLiteral */;
	            regularNew.objectFlags |= 128 /* ObjectLiteral */;
	            type.regularType = regularNew;
	            return regularNew;
	        }
	        function createWideningContext(parent, propertyName, siblings) {
	            return { parent: parent, propertyName: propertyName, siblings: siblings, resolvedPropertyNames: undefined };
	        }
	        function getSiblingsOfContext(context) {
	            if (!context.siblings) {
	                var siblings_1 = [];
	                for (var _i = 0, _a = getSiblingsOfContext(context.parent); _i < _a.length; _i++) {
	                    var type = _a[_i];
	                    if (isObjectLiteralType(type)) {
	                        var prop = getPropertyOfObjectType(type, context.propertyName);
	                        if (prop) {
	                            forEachType(getTypeOfSymbol(prop), function (t) {
	                                siblings_1.push(t);
	                            });
	                        }
	                    }
	                }
	                context.siblings = siblings_1;
	            }
	            return context.siblings;
	        }
	        function getPropertyNamesOfContext(context) {
	            if (!context.resolvedPropertyNames) {
	                var names = ts.createMap();
	                for (var _i = 0, _a = getSiblingsOfContext(context); _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    if (isObjectLiteralType(t) && !(ts.getObjectFlags(t) & 1024 /* ContainsSpread */)) {
	                        for (var _b = 0, _c = getPropertiesOfType(t); _b < _c.length; _b++) {
	                            var prop = _c[_b];
	                            names.set(prop.escapedName, true);
	                        }
	                    }
	                }
	                context.resolvedPropertyNames = ts.arrayFrom(names.keys());
	            }
	            return context.resolvedPropertyNames;
	        }
	        function getWidenedProperty(prop, context) {
	            var original = getTypeOfSymbol(prop);
	            var propContext = context && createWideningContext(context, prop.escapedName, /*siblings*/ undefined);
	            var widened = getWidenedTypeWithContext(original, propContext);
	            return widened === original ? prop : createSymbolWithType(prop, widened);
	        }
	        function getUndefinedProperty(name) {
	            var cached = undefinedProperties.get(name);
	            if (cached) {
	                return cached;
	            }
	            var result = createSymbol(4 /* Property */ | 16777216 /* Optional */, name);
	            result.type = undefinedType;
	            undefinedProperties.set(name, result);
	            return result;
	        }
	        function getWidenedTypeOfObjectLiteral(type, context) {
	            var members = ts.createSymbolTable();
	            for (var _i = 0, _a = getPropertiesOfObjectType(type); _i < _a.length; _i++) {
	                var prop = _a[_i];
	                // Since get accessors already widen their return value there is no need to
	                // widen accessor based properties here.
	                members.set(prop.escapedName, prop.flags & 4 /* Property */ ? getWidenedProperty(prop, context) : prop);
	            }
	            if (context) {
	                for (var _b = 0, _c = getPropertyNamesOfContext(context); _b < _c.length; _b++) {
	                    var name = _c[_b];
	                    if (!members.has(name)) {
	                        members.set(name, getUndefinedProperty(name));
	                    }
	                }
	            }
	            var stringIndexInfo = getIndexInfoOfType(type, 0 /* String */);
	            var numberIndexInfo = getIndexInfoOfType(type, 1 /* Number */);
	            return createAnonymousType(type.symbol, members, ts.emptyArray, ts.emptyArray, stringIndexInfo && createIndexInfo(getWidenedType(stringIndexInfo.type), stringIndexInfo.isReadonly), numberIndexInfo && createIndexInfo(getWidenedType(numberIndexInfo.type), numberIndexInfo.isReadonly));
	        }
	        function getWidenedType(type) {
	            return getWidenedTypeWithContext(type, /*context*/ undefined);
	        }
	        function getWidenedTypeWithContext(type, context) {
	            if (type.flags & 50331648 /* RequiresWidening */) {
	                if (type.flags & 12288 /* Nullable */) {
	                    return anyType;
	                }
	                if (isObjectLiteralType(type)) {
	                    return getWidenedTypeOfObjectLiteral(type, context);
	                }
	                if (type.flags & 131072 /* Union */) {
	                    var unionContext_1 = context || createWideningContext(/*parent*/ undefined, /*propertyName*/ undefined, type.types);
	                    var widenedTypes = ts.sameMap(type.types, function (t) { return t.flags & 12288 /* Nullable */ ? t : getWidenedTypeWithContext(t, unionContext_1); });
	                    // Widening an empty object literal transitions from a highly restrictive type to
	                    // a highly inclusive one. For that reason we perform subtype reduction here if the
	                    // union includes empty object types (e.g. reducing {} | string to just {}).
	                    return getUnionType(widenedTypes, ts.some(widenedTypes, isEmptyObjectType) ? 2 /* Subtype */ : 1 /* Literal */);
	                }
	                if (isArrayType(type) || isTupleType(type)) {
	                    return createTypeReference(type.target, ts.sameMap(type.typeArguments, getWidenedType));
	                }
	            }
	            return type;
	        }
	        /**
	         * Reports implicit any errors that occur as a result of widening 'null' and 'undefined'
	         * to 'any'. A call to reportWideningErrorsInType is normally accompanied by a call to
	         * getWidenedType. But in some cases getWidenedType is called without reporting errors
	         * (type argument inference is an example).
	         *
	         * The return value indicates whether an error was in fact reported. The particular circumstances
	         * are on a best effort basis. Currently, if the null or undefined that causes widening is inside
	         * an object literal property (arbitrarily deeply), this function reports an error. If no error is
	         * reported, reportImplicitAnyError is a suitable fallback to report a general error.
	         */
	        function reportWideningErrorsInType(type) {
	            var errorReported = false;
	            if (type.flags & 16777216 /* ContainsWideningType */) {
	                if (type.flags & 131072 /* Union */) {
	                    if (ts.some(type.types, isEmptyObjectType)) {
	                        errorReported = true;
	                    }
	                    else {
	                        for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                            var t = _a[_i];
	                            if (reportWideningErrorsInType(t)) {
	                                errorReported = true;
	                            }
	                        }
	                    }
	                }
	                if (isArrayType(type) || isTupleType(type)) {
	                    for (var _b = 0, _c = type.typeArguments; _b < _c.length; _b++) {
	                        var t = _c[_b];
	                        if (reportWideningErrorsInType(t)) {
	                            errorReported = true;
	                        }
	                    }
	                }
	                if (isObjectLiteralType(type)) {
	                    for (var _d = 0, _e = getPropertiesOfObjectType(type); _d < _e.length; _d++) {
	                        var p = _e[_d];
	                        var t = getTypeOfSymbol(p);
	                        if (t.flags & 16777216 /* ContainsWideningType */) {
	                            if (!reportWideningErrorsInType(t)) {
	                                error(p.valueDeclaration, ts.Diagnostics.Object_literal_s_property_0_implicitly_has_an_1_type, symbolToString(p), typeToString(getWidenedType(t)));
	                            }
	                            errorReported = true;
	                        }
	                    }
	                }
	            }
	            return errorReported;
	        }
	        function reportImplicitAnyError(declaration, type) {
	            var typeAsString = typeToString(getWidenedType(type));
	            var diagnostic;
	            switch (declaration.kind) {
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    diagnostic = ts.Diagnostics.Member_0_implicitly_has_an_1_type;
	                    break;
	                case 148 /* Parameter */:
	                    diagnostic = declaration.dotDotDotToken ?
	                        ts.Diagnostics.Rest_parameter_0_implicitly_has_an_any_type :
	                        ts.Diagnostics.Parameter_0_implicitly_has_an_1_type;
	                    break;
	                case 180 /* BindingElement */:
	                    diagnostic = ts.Diagnostics.Binding_element_0_implicitly_has_an_1_type;
	                    break;
	                case 232 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                    if (!declaration.name) {
	                        error(declaration, ts.Diagnostics.Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type, typeAsString);
	                        return;
	                    }
	                    diagnostic = ts.Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type;
	                    break;
	                case 176 /* MappedType */:
	                    error(declaration, ts.Diagnostics.Mapped_object_type_implicitly_has_an_any_template_type);
	                    return;
	                default:
	                    diagnostic = ts.Diagnostics.Variable_0_implicitly_has_an_1_type;
	            }
	            error(declaration, diagnostic, ts.declarationNameToString(ts.getNameOfDeclaration(declaration)), typeAsString);
	        }
	        function reportErrorsFromWidening(declaration, type) {
	            if (produceDiagnostics && noImplicitAny && type.flags & 16777216 /* ContainsWideningType */) {
	                // Report implicit any error within type if possible, otherwise report error on declaration
	                if (!reportWideningErrorsInType(type)) {
	                    reportImplicitAnyError(declaration, type);
	                }
	            }
	        }
	        function forEachMatchingParameterType(source, target, callback) {
	            var sourceMax = source.parameters.length;
	            var targetMax = target.parameters.length;
	            var count;
	            if (source.hasRestParameter && target.hasRestParameter) {
	                count = Math.max(sourceMax, targetMax);
	            }
	            else if (source.hasRestParameter) {
	                count = targetMax;
	            }
	            else if (target.hasRestParameter) {
	                count = sourceMax;
	            }
	            else {
	                count = Math.min(sourceMax, targetMax);
	            }
	            for (var i = 0; i < count; i++) {
	                callback(getTypeAtPosition(source, i), getTypeAtPosition(target, i));
	            }
	        }
	        function createInferenceContext(signature, flags, compareTypes, baseInferences) {
	            var inferences = baseInferences ? ts.map(baseInferences, cloneInferenceInfo) : ts.map(signature.typeParameters, createInferenceInfo);
	            var context = mapper;
	            context.signature = signature;
	            context.inferences = inferences;
	            context.flags = flags;
	            context.compareTypes = compareTypes || compareTypesAssignable;
	            return context;
	            function mapper(t) {
	                for (var i = 0; i < inferences.length; i++) {
	                    if (t === inferences[i].typeParameter) {
	                        inferences[i].isFixed = true;
	                        return getInferredType(context, i);
	                    }
	                }
	                return t;
	            }
	        }
	        function createInferenceInfo(typeParameter) {
	            return {
	                typeParameter: typeParameter,
	                candidates: undefined,
	                contraCandidates: undefined,
	                inferredType: undefined,
	                priority: undefined,
	                topLevel: true,
	                isFixed: false
	            };
	        }
	        function cloneInferenceInfo(inference) {
	            return {
	                typeParameter: inference.typeParameter,
	                candidates: inference.candidates && inference.candidates.slice(),
	                contraCandidates: inference.contraCandidates && inference.contraCandidates.slice(),
	                inferredType: inference.inferredType,
	                priority: inference.priority,
	                topLevel: inference.topLevel,
	                isFixed: inference.isFixed
	            };
	        }
	        // Return true if the given type could possibly reference a type parameter for which
	        // we perform type inference (i.e. a type parameter of a generic function). We cache
	        // results for union and intersection types for performance reasons.
	        function couldContainTypeVariables(type) {
	            var objectFlags = ts.getObjectFlags(type);
	            return !!(type.flags & 7897088 /* Instantiable */ ||
	                objectFlags & 4 /* Reference */ && ts.forEach(type.typeArguments, couldContainTypeVariables) ||
	                objectFlags & 16 /* Anonymous */ && type.symbol && type.symbol.flags & (16 /* Function */ | 8192 /* Method */ | 2048 /* TypeLiteral */ | 32 /* Class */) ||
	                objectFlags & 32 /* Mapped */ ||
	                type.flags & 393216 /* UnionOrIntersection */ && couldUnionOrIntersectionContainTypeVariables(type));
	        }
	        function couldUnionOrIntersectionContainTypeVariables(type) {
	            if (type.couldContainTypeVariables === undefined) {
	                type.couldContainTypeVariables = ts.forEach(type.types, couldContainTypeVariables);
	            }
	            return type.couldContainTypeVariables;
	        }
	        function isTypeParameterAtTopLevel(type, typeParameter) {
	            return type === typeParameter || type.flags & 393216 /* UnionOrIntersection */ && ts.forEach(type.types, function (t) { return isTypeParameterAtTopLevel(t, typeParameter); });
	        }
	        /** Create an object with properties named in the string literal type. Every property has type `any` */
	        function createEmptyObjectTypeFromStringLiteral(type) {
	            var members = ts.createSymbolTable();
	            forEachType(type, function (t) {
	                if (!(t.flags & 32 /* StringLiteral */)) {
	                    return;
	                }
	                var name = ts.escapeLeadingUnderscores(t.value);
	                var literalProp = createSymbol(4 /* Property */, name);
	                literalProp.type = anyType;
	                if (t.symbol) {
	                    literalProp.declarations = t.symbol.declarations;
	                    literalProp.valueDeclaration = t.symbol.valueDeclaration;
	                }
	                members.set(name, literalProp);
	            });
	            var indexInfo = type.flags & 2 /* String */ ? createIndexInfo(emptyObjectType, /*isReadonly*/ false) : undefined;
	            return createAnonymousType(undefined, members, ts.emptyArray, ts.emptyArray, indexInfo, undefined);
	        }
	        /**
	         * Infer a suitable input type for a homomorphic mapped type { [P in keyof T]: X }. We construct
	         * an object type with the same set of properties as the source type, where the type of each
	         * property is computed by inferring from the source property type to X for the type
	         * variable T[P] (i.e. we treat the type T[P] as the type variable we're inferring for).
	         */
	        function inferTypeForHomomorphicMappedType(source, target) {
	            var key = source.id + "," + target.id;
	            if (reverseMappedCache.has(key)) {
	                return reverseMappedCache.get(key);
	            }
	            reverseMappedCache.set(key, undefined);
	            var type = createReverseMappedType(source, target);
	            reverseMappedCache.set(key, type);
	            return type;
	        }
	        function createReverseMappedType(source, target) {
	            var properties = getPropertiesOfType(source);
	            if (properties.length === 0 && !getIndexInfoOfType(source, 0 /* String */)) {
	                return undefined;
	            }
	            // If any property contains context sensitive functions that have been skipped, the source type
	            // is incomplete and we can't infer a meaningful input type.
	            for (var _i = 0, properties_4 = properties; _i < properties_4.length; _i++) {
	                var prop = properties_4[_i];
	                if (getTypeOfSymbol(prop).flags & 67108864 /* ContainsAnyFunctionType */) {
	                    return undefined;
	                }
	            }
	            var reversed = createObjectType(2048 /* ReverseMapped */ | 16 /* Anonymous */, /*symbol*/ undefined);
	            reversed.source = source;
	            reversed.mappedType = target;
	            return reversed;
	        }
	        function getTypeOfReverseMappedSymbol(symbol) {
	            return inferReverseMappedType(symbol.propertyType, symbol.mappedType);
	        }
	        function inferReverseMappedType(sourceType, target) {
	            var typeParameter = getIndexedAccessType(getConstraintTypeFromMappedType(target).type, getTypeParameterFromMappedType(target));
	            var templateType = getTemplateTypeFromMappedType(target);
	            var inference = createInferenceInfo(typeParameter);
	            inferTypes([inference], sourceType, templateType);
	            return getTypeFromInference(inference) || emptyObjectType;
	        }
	        function getUnmatchedProperty(source, target, requireOptionalProperties) {
	            var properties = target.flags & 262144 /* Intersection */ ? getPropertiesOfUnionOrIntersectionType(target) : getPropertiesOfObjectType(target);
	            for (var _i = 0, properties_5 = properties; _i < properties_5.length; _i++) {
	                var targetProp = properties_5[_i];
	                if (requireOptionalProperties || !(targetProp.flags & 16777216 /* Optional */)) {
	                    var sourceProp = getPropertyOfType(source, targetProp.escapedName);
	                    if (!sourceProp) {
	                        return targetProp;
	                    }
	                }
	            }
	            return undefined;
	        }
	        function getTypeFromInference(inference) {
	            return inference.candidates ? getUnionType(inference.candidates, 2 /* Subtype */) :
	                inference.contraCandidates ? getIntersectionType(inference.contraCandidates) :
	                    undefined;
	        }
	        function inferTypes(inferences, originalSource, originalTarget, priority) {
	            if (priority === void 0) { priority = 0; }
	            var symbolStack;
	            var visited;
	            var contravariant = false;
	            inferFromTypes(originalSource, originalTarget);
	            function inferFromTypes(source, target) {
	                if (!couldContainTypeVariables(target)) {
	                    return;
	                }
	                if (source.aliasSymbol && source.aliasTypeArguments && source.aliasSymbol === target.aliasSymbol) {
	                    // Source and target are types originating in the same generic type alias declaration.
	                    // Simply infer from source type arguments to target type arguments.
	                    var sourceTypes = source.aliasTypeArguments;
	                    var targetTypes = target.aliasTypeArguments;
	                    for (var i = 0; i < sourceTypes.length; i++) {
	                        inferFromTypes(sourceTypes[i], targetTypes[i]);
	                    }
	                    return;
	                }
	                if (source.flags & 131072 /* Union */ && target.flags & 131072 /* Union */ && !(source.flags & 256 /* EnumLiteral */ && target.flags & 256 /* EnumLiteral */) ||
	                    source.flags & 262144 /* Intersection */ && target.flags & 262144 /* Intersection */) {
	                    // Source and target are both unions or both intersections. If source and target
	                    // are the same type, just relate each constituent type to itself.
	                    if (source === target) {
	                        for (var _i = 0, _a = source.types; _i < _a.length; _i++) {
	                            var t = _a[_i];
	                            inferFromTypes(t, t);
	                        }
	                        return;
	                    }
	                    // Find each source constituent type that has an identically matching target constituent
	                    // type, and for each such type infer from the type to itself. When inferring from a
	                    // type to itself we effectively find all type parameter occurrences within that type
	                    // and infer themselves as their type arguments. We have special handling for numeric
	                    // and string literals because the number and string types are not represented as unions
	                    // of all their possible values.
	                    var matchingTypes = void 0;
	                    for (var _b = 0, _c = source.types; _b < _c.length; _b++) {
	                        var t = _c[_b];
	                        if (typeIdenticalToSomeType(t, target.types)) {
	                            (matchingTypes || (matchingTypes = [])).push(t);
	                            inferFromTypes(t, t);
	                        }
	                        else if (t.flags & (64 /* NumberLiteral */ | 32 /* StringLiteral */)) {
	                            var b = getBaseTypeOfLiteralType(t);
	                            if (typeIdenticalToSomeType(b, target.types)) {
	                                (matchingTypes || (matchingTypes = [])).push(t, b);
	                            }
	                        }
	                    }
	                    // Next, to improve the quality of inferences, reduce the source and target types by
	                    // removing the identically matched constituents. For example, when inferring from
	                    // 'string | string[]' to 'string | T' we reduce the types to 'string[]' and 'T'.
	                    if (matchingTypes) {
	                        source = removeTypesFromUnionOrIntersection(source, matchingTypes);
	                        target = removeTypesFromUnionOrIntersection(target, matchingTypes);
	                    }
	                }
	                if (target.flags & 1081344 /* TypeVariable */) {
	                    // If target is a type parameter, make an inference, unless the source type contains
	                    // the anyFunctionType (the wildcard type that's used to avoid contextually typing functions).
	                    // Because the anyFunctionType is internal, it should not be exposed to the user by adding
	                    // it as an inference candidate. Hopefully, a better candidate will come along that does
	                    // not contain anyFunctionType when we come back to this argument for its second round
	                    // of inference. Also, we exclude inferences for silentNeverType (which is used as a wildcard
	                    // when constructing types from type parameters that had no inference candidates).
	                    if (source.flags & 67108864 /* ContainsAnyFunctionType */ || source === silentNeverType) {
	                        return;
	                    }
	                    var inference = getInferenceInfoForType(target);
	                    if (inference) {
	                        if (!inference.isFixed) {
	                            if (inference.priority === undefined || priority < inference.priority) {
	                                inference.candidates = undefined;
	                                inference.contraCandidates = undefined;
	                                inference.priority = priority;
	                            }
	                            if (priority === inference.priority) {
	                                if (contravariant) {
	                                    inference.contraCandidates = ts.append(inference.contraCandidates, source);
	                                }
	                                else {
	                                    inference.candidates = ts.append(inference.candidates, source);
	                                }
	                            }
	                            if (!(priority & 4 /* ReturnType */) && target.flags & 32768 /* TypeParameter */ && !isTypeParameterAtTopLevel(originalTarget, target)) {
	                                inference.topLevel = false;
	                            }
	                        }
	                        return;
	                    }
	                }
	                if (ts.getObjectFlags(source) & 4 /* Reference */ && ts.getObjectFlags(target) & 4 /* Reference */ && source.target === target.target) {
	                    // If source and target are references to the same generic type, infer from type arguments
	                    var sourceTypes = source.typeArguments || ts.emptyArray;
	                    var targetTypes = target.typeArguments || ts.emptyArray;
	                    var count = sourceTypes.length < targetTypes.length ? sourceTypes.length : targetTypes.length;
	                    var variances = getVariances(source.target);
	                    for (var i = 0; i < count; i++) {
	                        if (i < variances.length && variances[i] === 2 /* Contravariant */) {
	                            inferFromContravariantTypes(sourceTypes[i], targetTypes[i]);
	                        }
	                        else {
	                            inferFromTypes(sourceTypes[i], targetTypes[i]);
	                        }
	                    }
	                }
	                else if (source.flags & 524288 /* Index */ && target.flags & 524288 /* Index */) {
	                    contravariant = !contravariant;
	                    inferFromTypes(source.type, target.type);
	                    contravariant = !contravariant;
	                }
	                else if ((isLiteralType(source) || source.flags & 2 /* String */) && target.flags & 524288 /* Index */) {
	                    var empty = createEmptyObjectTypeFromStringLiteral(source);
	                    contravariant = !contravariant;
	                    inferFromTypes(empty, target.type);
	                    contravariant = !contravariant;
	                }
	                else if (source.flags & 1048576 /* IndexedAccess */ && target.flags & 1048576 /* IndexedAccess */) {
	                    inferFromTypes(source.objectType, target.objectType);
	                    inferFromTypes(source.indexType, target.indexType);
	                }
	                else if (source.flags & 2097152 /* Conditional */ && target.flags & 2097152 /* Conditional */) {
	                    inferFromTypes(source.checkType, target.checkType);
	                    inferFromTypes(source.extendsType, target.extendsType);
	                    inferFromTypes(source.trueType, target.trueType);
	                    inferFromTypes(source.falseType, target.falseType);
	                }
	                else if (target.flags & 393216 /* UnionOrIntersection */) {
	                    var targetTypes = target.types;
	                    var typeVariableCount = 0;
	                    var typeVariable = void 0;
	                    // First infer to each type in union or intersection that isn't a type variable
	                    for (var _d = 0, targetTypes_3 = targetTypes; _d < targetTypes_3.length; _d++) {
	                        var t = targetTypes_3[_d];
	                        if (getInferenceInfoForType(t)) {
	                            typeVariable = t;
	                            typeVariableCount++;
	                        }
	                        else {
	                            inferFromTypes(source, t);
	                        }
	                    }
	                    // Next, if target containings a single naked type variable, make a secondary inference to that type
	                    // variable. This gives meaningful results for union types in co-variant positions and intersection
	                    // types in contra-variant positions (such as callback parameters).
	                    if (typeVariableCount === 1) {
	                        var savePriority = priority;
	                        priority |= 1 /* NakedTypeVariable */;
	                        inferFromTypes(source, typeVariable);
	                        priority = savePriority;
	                    }
	                }
	                else if (source.flags & 131072 /* Union */) {
	                    // Source is a union or intersection type, infer from each constituent type
	                    var sourceTypes = source.types;
	                    for (var _e = 0, sourceTypes_3 = sourceTypes; _e < sourceTypes_3.length; _e++) {
	                        var sourceType = sourceTypes_3[_e];
	                        inferFromTypes(sourceType, target);
	                    }
	                }
	                else {
	                    if (!(priority && 8 /* NoConstraints */ && source.flags & (262144 /* Intersection */ | 7897088 /* Instantiable */))) {
	                        source = getApparentType(source);
	                    }
	                    if (source.flags & (65536 /* Object */ | 262144 /* Intersection */)) {
	                        var key = source.id + "," + target.id;
	                        if (visited && visited.get(key)) {
	                            return;
	                        }
	                        (visited || (visited = ts.createMap())).set(key, true);
	                        // If we are already processing another target type with the same associated symbol (such as
	                        // an instantiation of the same generic type), we do not explore this target as it would yield
	                        // no further inferences. We exclude the static side of classes from this check since it shares
	                        // its symbol with the instance side which would lead to false positives.
	                        var isNonConstructorObject = target.flags & 65536 /* Object */ &&
	                            !(ts.getObjectFlags(target) & 16 /* Anonymous */ && target.symbol && target.symbol.flags & 32 /* Class */);
	                        var symbol = isNonConstructorObject ? target.symbol : undefined;
	                        if (symbol) {
	                            if (ts.contains(symbolStack, symbol)) {
	                                return;
	                            }
	                            (symbolStack || (symbolStack = [])).push(symbol);
	                            inferFromObjectTypes(source, target);
	                            symbolStack.pop();
	                        }
	                        else {
	                            inferFromObjectTypes(source, target);
	                        }
	                    }
	                }
	            }
	            function inferFromContravariantTypes(source, target) {
	                if (strictFunctionTypes || priority & 16 /* AlwaysStrict */) {
	                    contravariant = !contravariant;
	                    inferFromTypes(source, target);
	                    contravariant = !contravariant;
	                }
	                else {
	                    inferFromTypes(source, target);
	                }
	            }
	            function getInferenceInfoForType(type) {
	                if (type.flags & 1081344 /* TypeVariable */) {
	                    for (var _i = 0, inferences_1 = inferences; _i < inferences_1.length; _i++) {
	                        var inference = inferences_1[_i];
	                        if (type === inference.typeParameter) {
	                            return inference;
	                        }
	                    }
	                }
	                return undefined;
	            }
	            function inferFromObjectTypes(source, target) {
	                if (isGenericMappedType(source) && isGenericMappedType(target)) {
	                    // The source and target types are generic types { [P in S]: X } and { [P in T]: Y }, so we infer
	                    // from S to T and from X to Y.
	                    inferFromTypes(getConstraintTypeFromMappedType(source), getConstraintTypeFromMappedType(target));
	                    inferFromTypes(getTemplateTypeFromMappedType(source), getTemplateTypeFromMappedType(target));
	                }
	                if (ts.getObjectFlags(target) & 32 /* Mapped */) {
	                    var constraintType = getConstraintTypeFromMappedType(target);
	                    if (constraintType.flags & 524288 /* Index */) {
	                        // We're inferring from some source type S to a homomorphic mapped type { [P in keyof T]: X },
	                        // where T is a type variable. Use inferTypeForHomomorphicMappedType to infer a suitable source
	                        // type and then make a secondary inference from that type to T. We make a secondary inference
	                        // such that direct inferences to T get priority over inferences to Partial<T>, for example.
	                        var inference = getInferenceInfoForType(constraintType.type);
	                        if (inference && !inference.isFixed) {
	                            var inferredType = inferTypeForHomomorphicMappedType(source, target);
	                            if (inferredType) {
	                                var savePriority = priority;
	                                priority |= 2 /* MappedType */;
	                                inferFromTypes(inferredType, inference.typeParameter);
	                                priority = savePriority;
	                            }
	                        }
	                        return;
	                    }
	                    if (constraintType.flags & 32768 /* TypeParameter */) {
	                        // We're inferring from some source type S to a mapped type { [P in T]: X }, where T is a type
	                        // parameter. Infer from 'keyof S' to T and infer from a union of each property type in S to X.
	                        inferFromTypes(getIndexType(source), constraintType);
	                        inferFromTypes(getUnionType(ts.map(getPropertiesOfType(source), getTypeOfSymbol)), getTemplateTypeFromMappedType(target));
	                        return;
	                    }
	                }
	                // Infer from the members of source and target only if the two types are possibly related. We check
	                // in both directions because we may be inferring for a co-variant or a contra-variant position.
	                if (!getUnmatchedProperty(source, target, /*requireOptionalProperties*/ false) || !getUnmatchedProperty(target, source, /*requireOptionalProperties*/ false)) {
	                    inferFromProperties(source, target);
	                    inferFromSignatures(source, target, 0 /* Call */);
	                    inferFromSignatures(source, target, 1 /* Construct */);
	                    inferFromIndexTypes(source, target);
	                }
	            }
	            function inferFromProperties(source, target) {
	                var properties = getPropertiesOfObjectType(target);
	                for (var _i = 0, properties_6 = properties; _i < properties_6.length; _i++) {
	                    var targetProp = properties_6[_i];
	                    var sourceProp = getPropertyOfType(source, targetProp.escapedName);
	                    if (sourceProp) {
	                        inferFromTypes(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp));
	                    }
	                }
	            }
	            function inferFromSignatures(source, target, kind) {
	                var sourceSignatures = getSignaturesOfType(source, kind);
	                var targetSignatures = getSignaturesOfType(target, kind);
	                var sourceLen = sourceSignatures.length;
	                var targetLen = targetSignatures.length;
	                var len = sourceLen < targetLen ? sourceLen : targetLen;
	                for (var i = 0; i < len; i++) {
	                    inferFromSignature(getBaseSignature(sourceSignatures[sourceLen - len + i]), getBaseSignature(targetSignatures[targetLen - len + i]));
	                }
	            }
	            function inferFromSignature(source, target) {
	                forEachMatchingParameterType(source, target, inferFromContravariantTypes);
	                var sourceTypePredicate = getTypePredicateOfSignature(source);
	                var targetTypePredicate = getTypePredicateOfSignature(target);
	                if (sourceTypePredicate && targetTypePredicate && sourceTypePredicate.kind === targetTypePredicate.kind) {
	                    inferFromTypes(sourceTypePredicate.type, targetTypePredicate.type);
	                }
	                else {
	                    inferFromTypes(getReturnTypeOfSignature(source), getReturnTypeOfSignature(target));
	                }
	            }
	            function inferFromIndexTypes(source, target) {
	                var targetStringIndexType = getIndexTypeOfType(target, 0 /* String */);
	                if (targetStringIndexType) {
	                    var sourceIndexType = getIndexTypeOfType(source, 0 /* String */) ||
	                        getImplicitIndexTypeOfType(source, 0 /* String */);
	                    if (sourceIndexType) {
	                        inferFromTypes(sourceIndexType, targetStringIndexType);
	                    }
	                }
	                var targetNumberIndexType = getIndexTypeOfType(target, 1 /* Number */);
	                if (targetNumberIndexType) {
	                    var sourceIndexType = getIndexTypeOfType(source, 1 /* Number */) ||
	                        getIndexTypeOfType(source, 0 /* String */) ||
	                        getImplicitIndexTypeOfType(source, 1 /* Number */);
	                    if (sourceIndexType) {
	                        inferFromTypes(sourceIndexType, targetNumberIndexType);
	                    }
	                }
	            }
	        }
	        function typeIdenticalToSomeType(type, types) {
	            for (var _i = 0, types_11 = types; _i < types_11.length; _i++) {
	                var t = types_11[_i];
	                if (isTypeIdenticalTo(t, type)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        /**
	         * Return a new union or intersection type computed by removing a given set of types
	         * from a given union or intersection type.
	         */
	        function removeTypesFromUnionOrIntersection(type, typesToRemove) {
	            var reducedTypes = [];
	            for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (!typeIdenticalToSomeType(t, typesToRemove)) {
	                    reducedTypes.push(t);
	                }
	            }
	            return type.flags & 131072 /* Union */ ? getUnionType(reducedTypes) : getIntersectionType(reducedTypes);
	        }
	        function hasPrimitiveConstraint(type) {
	            var constraint = getConstraintOfTypeParameter(type);
	            return constraint && maybeTypeOfKind(constraint, 16382 /* Primitive */ | 524288 /* Index */);
	        }
	        function isObjectLiteralType(type) {
	            return !!(ts.getObjectFlags(type) & 128 /* ObjectLiteral */);
	        }
	        function widenObjectLiteralCandidates(candidates) {
	            if (candidates.length > 1) {
	                var objectLiterals = ts.filter(candidates, isObjectLiteralType);
	                if (objectLiterals.length) {
	                    var objectLiteralsType = getWidenedType(getUnionType(objectLiterals, 2 /* Subtype */));
	                    return ts.concatenate(ts.filter(candidates, function (t) { return !isObjectLiteralType(t); }), [objectLiteralsType]);
	                }
	            }
	            return candidates;
	        }
	        function getInferredType(context, index) {
	            var inference = context.inferences[index];
	            var inferredType = inference.inferredType;
	            if (!inferredType) {
	                if (inference.candidates) {
	                    // Extract all object literal types and replace them with a single widened and normalized type.
	                    var candidates = widenObjectLiteralCandidates(inference.candidates);
	                    // We widen inferred literal types if
	                    // all inferences were made to top-level ocurrences of the type parameter, and
	                    // the type parameter has no constraint or its constraint includes no primitive or literal types, and
	                    // the type parameter was fixed during inference or does not occur at top-level in the return type.
	                    var signature = context.signature;
	                    var widenLiteralTypes = inference.topLevel &&
	                        !hasPrimitiveConstraint(inference.typeParameter) &&
	                        (inference.isFixed || !isTypeParameterAtTopLevel(getReturnTypeOfSignature(signature), inference.typeParameter));
	                    var baseCandidates = widenLiteralTypes ? ts.sameMap(candidates, getWidenedLiteralType) : candidates;
	                    // If all inferences were made from contravariant positions, infer a common subtype. Otherwise, if
	                    // union types were requested or if all inferences were made from the return type position, infer a
	                    // union type. Otherwise, infer a common supertype.
	                    var unwidenedType = context.flags & 1 /* InferUnionTypes */ || inference.priority & 4 /* ReturnType */ ?
	                        getUnionType(baseCandidates, 2 /* Subtype */) :
	                        getCommonSupertype(baseCandidates);
	                    inferredType = getWidenedType(unwidenedType);
	                    // If we have inferred 'never' but have contravariant candidates. To get a more specific type we
	                    // infer from the contravariant candidates instead.
	                    if (inferredType.flags & 16384 /* Never */ && inference.contraCandidates) {
	                        inferredType = getCommonSubtype(inference.contraCandidates);
	                    }
	                }
	                else if (inference.contraCandidates) {
	                    // We only have contravariant inferences, infer the best common subtype of those
	                    inferredType = getCommonSubtype(inference.contraCandidates);
	                }
	                else if (context.flags & 2 /* NoDefault */) {
	                    // We use silentNeverType as the wildcard that signals no inferences.
	                    inferredType = silentNeverType;
	                }
	                else {
	                    // Infer either the default or the empty object type when no inferences were
	                    // made. It is important to remember that in this case, inference still
	                    // succeeds, meaning there is no error for not having inference candidates. An
	                    // inference error only occurs when there are *conflicting* candidates, i.e.
	                    // candidates with no common supertype.
	                    var defaultType = getDefaultFromTypeParameter(inference.typeParameter);
	                    if (defaultType) {
	                        // Instantiate the default type. Any forward reference to a type
	                        // parameter should be instantiated to the empty object type.
	                        inferredType = instantiateType(defaultType, combineTypeMappers(createBackreferenceMapper(context.signature.typeParameters, index), context));
	                    }
	                    else {
	                        inferredType = getDefaultTypeArgumentType(!!(context.flags & 4 /* AnyDefault */));
	                    }
	                }
	                inferredType = getWidenedUniqueESSymbolType(inferredType);
	                inference.inferredType = inferredType;
	                var constraint = getConstraintOfTypeParameter(context.signature.typeParameters[index]);
	                if (constraint) {
	                    var instantiatedConstraint = instantiateType(constraint, context);
	                    if (!context.compareTypes(inferredType, getTypeWithThisArgument(instantiatedConstraint, inferredType))) {
	                        inference.inferredType = inferredType = getWidenedUniqueESSymbolType(instantiatedConstraint);
	                    }
	                }
	            }
	            return inferredType;
	        }
	        function getDefaultTypeArgumentType(isInJavaScriptFile) {
	            return isInJavaScriptFile ? anyType : emptyObjectType;
	        }
	        function getInferredTypes(context) {
	            var result = [];
	            for (var i = 0; i < context.inferences.length; i++) {
	                result.push(getInferredType(context, i));
	            }
	            return result;
	        }
	        // EXPRESSION TYPE CHECKING
	        function getResolvedSymbol(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedSymbol) {
	                links.resolvedSymbol = !ts.nodeIsMissing(node) &&
	                    resolveName(node, node.escapedText, 107455 /* Value */ | 1048576 /* ExportValue */, ts.Diagnostics.Cannot_find_name_0, node, !ts.isWriteOnlyAccess(node), 
	                    /*excludeGlobals*/ false, ts.Diagnostics.Cannot_find_name_0_Did_you_mean_1) || unknownSymbol;
	            }
	            return links.resolvedSymbol;
	        }
	        function isInTypeQuery(node) {
	            // TypeScript 1.0 spec (April 2014): 3.6.3
	            // A type query consists of the keyword typeof followed by an expression.
	            // The expression is restricted to a single identifier or a sequence of identifiers separated by periods
	            return !!ts.findAncestor(node, function (n) { return n.kind === 164 /* TypeQuery */ ? true : n.kind === 71 /* Identifier */ || n.kind === 145 /* QualifiedName */ ? false : "quit"; });
	        }
	        // Return the flow cache key for a "dotted name" (i.e. a sequence of identifiers
	        // separated by dots). The key consists of the id of the symbol referenced by the
	        // leftmost identifier followed by zero or more property names separated by dots.
	        // The result is undefined if the reference isn't a dotted name. We prefix nodes
	        // occurring in an apparent type position with '@' because the control flow type
	        // of such nodes may be based on the apparent type instead of the declared type.
	        function getFlowCacheKey(node) {
	            if (node.kind === 71 /* Identifier */) {
	                var symbol = getResolvedSymbol(node);
	                return symbol !== unknownSymbol ? (isConstraintPosition(node) ? "@" : "") + getSymbolId(symbol) : undefined;
	            }
	            if (node.kind === 99 /* ThisKeyword */) {
	                return "0";
	            }
	            if (node.kind === 183 /* PropertyAccessExpression */) {
	                var key = getFlowCacheKey(node.expression);
	                return key && key + "." + ts.idText(node.name);
	            }
	            if (node.kind === 180 /* BindingElement */) {
	                var container = node.parent.parent;
	                var key = container.kind === 180 /* BindingElement */ ? getFlowCacheKey(container) : (container.initializer && getFlowCacheKey(container.initializer));
	                var text = getBindingElementNameText(node);
	                var result = key && text && (key + "." + text);
	                return result;
	            }
	            return undefined;
	        }
	        function getBindingElementNameText(element) {
	            if (element.parent.kind === 178 /* ObjectBindingPattern */) {
	                var name = element.propertyName || element.name;
	                switch (name.kind) {
	                    case 71 /* Identifier */:
	                        return ts.idText(name);
	                    case 146 /* ComputedPropertyName */:
	                        return ts.isStringOrNumericLiteral(name.expression) ? name.expression.text : undefined;
	                    case 9 /* StringLiteral */:
	                    case 8 /* NumericLiteral */:
	                        return name.text;
	                    default:
	                        // Per types, array and object binding patterns remain, however they should never be present if propertyName is not defined
	                        ts.Debug.fail("Unexpected name kind for binding element name");
	                }
	            }
	            else {
	                return "" + element.parent.elements.indexOf(element);
	            }
	        }
	        function isMatchingReference(source, target) {
	            switch (source.kind) {
	                case 71 /* Identifier */:
	                    return target.kind === 71 /* Identifier */ && getResolvedSymbol(source) === getResolvedSymbol(target) ||
	                        (target.kind === 230 /* VariableDeclaration */ || target.kind === 180 /* BindingElement */) &&
	                            getExportSymbolOfValueSymbolIfExported(getResolvedSymbol(source)) === getSymbolOfNode(target);
	                case 99 /* ThisKeyword */:
	                    return target.kind === 99 /* ThisKeyword */;
	                case 97 /* SuperKeyword */:
	                    return target.kind === 97 /* SuperKeyword */;
	                case 183 /* PropertyAccessExpression */:
	                    return target.kind === 183 /* PropertyAccessExpression */ &&
	                        source.name.escapedText === target.name.escapedText &&
	                        isMatchingReference(source.expression, target.expression);
	                case 180 /* BindingElement */:
	                    if (target.kind !== 183 /* PropertyAccessExpression */)
	                        return false;
	                    var t = target;
	                    if (t.name.escapedText !== getBindingElementNameText(source))
	                        return false;
	                    if (source.parent.parent.kind === 180 /* BindingElement */ && isMatchingReference(source.parent.parent, t.expression)) {
	                        return true;
	                    }
	                    if (source.parent.parent.kind === 230 /* VariableDeclaration */) {
	                        var maybeId = source.parent.parent.initializer;
	                        return maybeId && isMatchingReference(maybeId, t.expression);
	                    }
	            }
	            return false;
	        }
	        function containsMatchingReference(source, target) {
	            while (source.kind === 183 /* PropertyAccessExpression */) {
	                source = source.expression;
	                if (isMatchingReference(source, target)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        // Return true if target is a property access xxx.yyy, source is a property access xxx.zzz, the declared
	        // type of xxx is a union type, and yyy is a property that is possibly a discriminant. We consider a property
	        // a possible discriminant if its type differs in the constituents of containing union type, and if every
	        // choice is a unit type or a union of unit types.
	        function containsMatchingReferenceDiscriminant(source, target) {
	            return target.kind === 183 /* PropertyAccessExpression */ &&
	                containsMatchingReference(source, target.expression) &&
	                isDiscriminantProperty(getDeclaredTypeOfReference(target.expression), target.name.escapedText);
	        }
	        function getDeclaredTypeOfReference(expr) {
	            if (expr.kind === 71 /* Identifier */) {
	                return getTypeOfSymbol(getResolvedSymbol(expr));
	            }
	            if (expr.kind === 183 /* PropertyAccessExpression */) {
	                var type = getDeclaredTypeOfReference(expr.expression);
	                return type && getTypeOfPropertyOfType(type, expr.name.escapedText);
	            }
	            return undefined;
	        }
	        function isDiscriminantProperty(type, name) {
	            if (type && type.flags & 131072 /* Union */) {
	                var prop = getUnionOrIntersectionProperty(type, name);
	                if (prop && ts.getCheckFlags(prop) & 2 /* SyntheticProperty */) {
	                    if (prop.isDiscriminantProperty === undefined) {
	                        prop.isDiscriminantProperty = prop.checkFlags & 32 /* HasNonUniformType */ && isLiteralType(getTypeOfSymbol(prop));
	                    }
	                    return prop.isDiscriminantProperty;
	                }
	            }
	            return false;
	        }
	        function findDiscriminantProperties(sourceProperties, target) {
	            var result;
	            for (var _i = 0, sourceProperties_2 = sourceProperties; _i < sourceProperties_2.length; _i++) {
	                var sourceProperty = sourceProperties_2[_i];
	                if (isDiscriminantProperty(target, sourceProperty.escapedName)) {
	                    if (result) {
	                        result.push(sourceProperty);
	                        continue;
	                    }
	                    result = [sourceProperty];
	                }
	            }
	            return result;
	        }
	        function isOrContainsMatchingReference(source, target) {
	            return isMatchingReference(source, target) || containsMatchingReference(source, target);
	        }
	        function hasMatchingArgument(callExpression, reference) {
	            if (callExpression.arguments) {
	                for (var _i = 0, _a = callExpression.arguments; _i < _a.length; _i++) {
	                    var argument = _a[_i];
	                    if (isOrContainsMatchingReference(reference, argument)) {
	                        return true;
	                    }
	                }
	            }
	            if (callExpression.expression.kind === 183 /* PropertyAccessExpression */ &&
	                isOrContainsMatchingReference(reference, callExpression.expression.expression)) {
	                return true;
	            }
	            return false;
	        }
	        function getFlowNodeId(flow) {
	            if (!flow.id) {
	                flow.id = nextFlowId;
	                nextFlowId++;
	            }
	            return flow.id;
	        }
	        function typeMaybeAssignableTo(source, target) {
	            if (!(source.flags & 131072 /* Union */)) {
	                return isTypeAssignableTo(source, target);
	            }
	            for (var _i = 0, _a = source.types; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (isTypeAssignableTo(t, target)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        // Remove those constituent types of declaredType to which no constituent type of assignedType is assignable.
	        // For example, when a variable of type number | string | boolean is assigned a value of type number | boolean,
	        // we remove type string.
	        function getAssignmentReducedType(declaredType, assignedType) {
	            if (declaredType !== assignedType) {
	                if (assignedType.flags & 16384 /* Never */) {
	                    return assignedType;
	                }
	                var reducedType = filterType(declaredType, function (t) { return typeMaybeAssignableTo(assignedType, t); });
	                if (!(reducedType.flags & 16384 /* Never */)) {
	                    return reducedType;
	                }
	            }
	            return declaredType;
	        }
	        function getTypeFactsOfTypes(types) {
	            var result = 0 /* None */;
	            for (var _i = 0, types_12 = types; _i < types_12.length; _i++) {
	                var t = types_12[_i];
	                result |= getTypeFacts(t);
	            }
	            return result;
	        }
	        function isFunctionObjectType(type) {
	            // We do a quick check for a "bind" property before performing the more expensive subtype
	            // check. This gives us a quicker out in the common case where an object type is not a function.
	            var resolved = resolveStructuredTypeMembers(type);
	            return !!(resolved.callSignatures.length || resolved.constructSignatures.length ||
	                resolved.members.get("bind") && isTypeSubtypeOf(type, globalFunctionType));
	        }
	        function getTypeFacts(type) {
	            var flags = type.flags;
	            if (flags & 2 /* String */) {
	                return strictNullChecks ? 4079361 /* StringStrictFacts */ : 4194049 /* StringFacts */;
	            }
	            if (flags & 32 /* StringLiteral */) {
	                var isEmpty = type.value === "";
	                return strictNullChecks ?
	                    isEmpty ? 3030785 /* EmptyStringStrictFacts */ : 1982209 /* NonEmptyStringStrictFacts */ :
	                    isEmpty ? 3145473 /* EmptyStringFacts */ : 4194049 /* NonEmptyStringFacts */;
	            }
	            if (flags & (4 /* Number */ | 16 /* Enum */)) {
	                return strictNullChecks ? 4079234 /* NumberStrictFacts */ : 4193922 /* NumberFacts */;
	            }
	            if (flags & 64 /* NumberLiteral */) {
	                var isZero = type.value === 0;
	                return strictNullChecks ?
	                    isZero ? 3030658 /* ZeroStrictFacts */ : 1982082 /* NonZeroStrictFacts */ :
	                    isZero ? 3145346 /* ZeroFacts */ : 4193922 /* NonZeroFacts */;
	            }
	            if (flags & 8 /* Boolean */) {
	                return strictNullChecks ? 4078980 /* BooleanStrictFacts */ : 4193668 /* BooleanFacts */;
	            }
	            if (flags & 136 /* BooleanLike */) {
	                return strictNullChecks ?
	                    type === falseType ? 3030404 /* FalseStrictFacts */ : 1981828 /* TrueStrictFacts */ :
	                    type === falseType ? 3145092 /* FalseFacts */ : 4193668 /* TrueFacts */;
	            }
	            if (flags & 65536 /* Object */) {
	                return isFunctionObjectType(type) ?
	                    strictNullChecks ? 6164448 /* FunctionStrictFacts */ : 8376288 /* FunctionFacts */ :
	                    strictNullChecks ? 6166480 /* ObjectStrictFacts */ : 8378320 /* ObjectFacts */;
	            }
	            if (flags & (2048 /* Void */ | 4096 /* Undefined */)) {
	                return 2457472 /* UndefinedFacts */;
	            }
	            if (flags & 8192 /* Null */) {
	                return 2340752 /* NullFacts */;
	            }
	            if (flags & 1536 /* ESSymbolLike */) {
	                return strictNullChecks ? 1981320 /* SymbolStrictFacts */ : 4193160 /* SymbolFacts */;
	            }
	            if (flags & 134217728 /* NonPrimitive */) {
	                return strictNullChecks ? 6166480 /* ObjectStrictFacts */ : 8378320 /* ObjectFacts */;
	            }
	            if (flags & 7897088 /* Instantiable */) {
	                return getTypeFacts(getBaseConstraintOfType(type) || emptyObjectType);
	            }
	            if (flags & 393216 /* UnionOrIntersection */) {
	                return getTypeFactsOfTypes(type.types);
	            }
	            return 8388607 /* All */;
	        }
	        function getTypeWithFacts(type, include) {
	            return filterType(type, function (t) { return (getTypeFacts(t) & include) !== 0; });
	        }
	        function getTypeWithDefault(type, defaultExpression) {
	            if (defaultExpression) {
	                var defaultType = getTypeOfExpression(defaultExpression);
	                return getUnionType([getTypeWithFacts(type, 131072 /* NEUndefined */), defaultType]);
	            }
	            return type;
	        }
	        function getTypeOfDestructuredProperty(type, name) {
	            var text = ts.getTextOfPropertyName(name);
	            return getTypeOfPropertyOfType(type, text) ||
	                isNumericLiteralName(text) && getIndexTypeOfType(type, 1 /* Number */) ||
	                getIndexTypeOfType(type, 0 /* String */) ||
	                unknownType;
	        }
	        function getTypeOfDestructuredArrayElement(type, index) {
	            return isTupleLikeType(type) && getTypeOfPropertyOfType(type, "" + index) ||
	                checkIteratedTypeOrElementType(type, /*errorNode*/ undefined, /*allowStringInput*/ false, /*allowAsyncIterables*/ false) ||
	                unknownType;
	        }
	        function getTypeOfDestructuredSpreadExpression(type) {
	            return createArrayType(checkIteratedTypeOrElementType(type, /*errorNode*/ undefined, /*allowStringInput*/ false, /*allowAsyncIterables*/ false) || unknownType);
	        }
	        function getAssignedTypeOfBinaryExpression(node) {
	            var isDestructuringDefaultAssignment = node.parent.kind === 181 /* ArrayLiteralExpression */ && isDestructuringAssignmentTarget(node.parent) ||
	                node.parent.kind === 268 /* PropertyAssignment */ && isDestructuringAssignmentTarget(node.parent.parent);
	            return isDestructuringDefaultAssignment ?
	                getTypeWithDefault(getAssignedType(node), node.right) :
	                getTypeOfExpression(node.right);
	        }
	        function isDestructuringAssignmentTarget(parent) {
	            return parent.parent.kind === 198 /* BinaryExpression */ && parent.parent.left === parent ||
	                parent.parent.kind === 220 /* ForOfStatement */ && parent.parent.initializer === parent;
	        }
	        function getAssignedTypeOfArrayLiteralElement(node, element) {
	            return getTypeOfDestructuredArrayElement(getAssignedType(node), node.elements.indexOf(element));
	        }
	        function getAssignedTypeOfSpreadExpression(node) {
	            return getTypeOfDestructuredSpreadExpression(getAssignedType(node.parent));
	        }
	        function getAssignedTypeOfPropertyAssignment(node) {
	            return getTypeOfDestructuredProperty(getAssignedType(node.parent), node.name);
	        }
	        function getAssignedTypeOfShorthandPropertyAssignment(node) {
	            return getTypeWithDefault(getAssignedTypeOfPropertyAssignment(node), node.objectAssignmentInitializer);
	        }
	        function getAssignedType(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 219 /* ForInStatement */:
	                    return stringType;
	                case 220 /* ForOfStatement */:
	                    return checkRightHandSideOfForOf(parent.expression, parent.awaitModifier) || unknownType;
	                case 198 /* BinaryExpression */:
	                    return getAssignedTypeOfBinaryExpression(parent);
	                case 192 /* DeleteExpression */:
	                    return undefinedType;
	                case 181 /* ArrayLiteralExpression */:
	                    return getAssignedTypeOfArrayLiteralElement(parent, node);
	                case 202 /* SpreadElement */:
	                    return getAssignedTypeOfSpreadExpression(parent);
	                case 268 /* PropertyAssignment */:
	                    return getAssignedTypeOfPropertyAssignment(parent);
	                case 269 /* ShorthandPropertyAssignment */:
	                    return getAssignedTypeOfShorthandPropertyAssignment(parent);
	            }
	            return unknownType;
	        }
	        function getInitialTypeOfBindingElement(node) {
	            var pattern = node.parent;
	            var parentType = getInitialType(pattern.parent);
	            var type = pattern.kind === 178 /* ObjectBindingPattern */ ?
	                getTypeOfDestructuredProperty(parentType, node.propertyName || node.name) :
	                !node.dotDotDotToken ?
	                    getTypeOfDestructuredArrayElement(parentType, pattern.elements.indexOf(node)) :
	                    getTypeOfDestructuredSpreadExpression(parentType);
	            return getTypeWithDefault(type, node.initializer);
	        }
	        function getTypeOfInitializer(node) {
	            // Return the cached type if one is available. If the type of the variable was inferred
	            // from its initializer, we'll already have cached the type. Otherwise we compute it now
	            // without caching such that transient types are reflected.
	            var links = getNodeLinks(node);
	            return links.resolvedType || getTypeOfExpression(node);
	        }
	        function getInitialTypeOfVariableDeclaration(node) {
	            if (node.initializer) {
	                return getTypeOfInitializer(node.initializer);
	            }
	            if (node.parent.parent.kind === 219 /* ForInStatement */) {
	                return stringType;
	            }
	            if (node.parent.parent.kind === 220 /* ForOfStatement */) {
	                return checkRightHandSideOfForOf(node.parent.parent.expression, node.parent.parent.awaitModifier) || unknownType;
	            }
	            return unknownType;
	        }
	        function getInitialType(node) {
	            return node.kind === 230 /* VariableDeclaration */ ?
	                getInitialTypeOfVariableDeclaration(node) :
	                getInitialTypeOfBindingElement(node);
	        }
	        function getInitialOrAssignedType(node) {
	            return node.kind === 230 /* VariableDeclaration */ || node.kind === 180 /* BindingElement */ ?
	                getInitialType(node) :
	                getAssignedType(node);
	        }
	        function isEmptyArrayAssignment(node) {
	            return node.kind === 230 /* VariableDeclaration */ && node.initializer &&
	                isEmptyArrayLiteral(node.initializer) ||
	                node.kind !== 180 /* BindingElement */ && node.parent.kind === 198 /* BinaryExpression */ &&
	                    isEmptyArrayLiteral(node.parent.right);
	        }
	        function getReferenceCandidate(node) {
	            switch (node.kind) {
	                case 189 /* ParenthesizedExpression */:
	                    return getReferenceCandidate(node.expression);
	                case 198 /* BinaryExpression */:
	                    switch (node.operatorToken.kind) {
	                        case 58 /* EqualsToken */:
	                            return getReferenceCandidate(node.left);
	                        case 26 /* CommaToken */:
	                            return getReferenceCandidate(node.right);
	                    }
	            }
	            return node;
	        }
	        function getReferenceRoot(node) {
	            var parent = node.parent;
	            return parent.kind === 189 /* ParenthesizedExpression */ ||
	                parent.kind === 198 /* BinaryExpression */ && parent.operatorToken.kind === 58 /* EqualsToken */ && parent.left === node ||
	                parent.kind === 198 /* BinaryExpression */ && parent.operatorToken.kind === 26 /* CommaToken */ && parent.right === node ?
	                getReferenceRoot(parent) : node;
	        }
	        function getTypeOfSwitchClause(clause) {
	            if (clause.kind === 264 /* CaseClause */) {
	                var caseType = getRegularTypeOfLiteralType(getTypeOfExpression(clause.expression));
	                return isUnitType(caseType) ? caseType : undefined;
	            }
	            return neverType;
	        }
	        function getSwitchClauseTypes(switchStatement) {
	            var links = getNodeLinks(switchStatement);
	            if (!links.switchTypes) {
	                // If all case clauses specify expressions that have unit types, we return an array
	                // of those unit types. Otherwise we return an empty array.
	                links.switchTypes = [];
	                for (var _i = 0, _a = switchStatement.caseBlock.clauses; _i < _a.length; _i++) {
	                    var clause = _a[_i];
	                    var type = getTypeOfSwitchClause(clause);
	                    if (type === undefined) {
	                        return links.switchTypes = ts.emptyArray;
	                    }
	                    links.switchTypes.push(type);
	                }
	            }
	            return links.switchTypes;
	        }
	        function eachTypeContainedIn(source, types) {
	            return source.flags & 131072 /* Union */ ? !ts.forEach(source.types, function (t) { return !ts.contains(types, t); }) : ts.contains(types, source);
	        }
	        function isTypeSubsetOf(source, target) {
	            return source === target || target.flags & 131072 /* Union */ && isTypeSubsetOfUnion(source, target);
	        }
	        function isTypeSubsetOfUnion(source, target) {
	            if (source.flags & 131072 /* Union */) {
	                for (var _i = 0, _a = source.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    if (!containsType(target.types, t)) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	            if (source.flags & 256 /* EnumLiteral */ && getBaseTypeOfEnumLiteralType(source) === target) {
	                return true;
	            }
	            return containsType(target.types, source);
	        }
	        function forEachType(type, f) {
	            return type.flags & 131072 /* Union */ ? ts.forEach(type.types, f) : f(type);
	        }
	        function filterType(type, f) {
	            if (type.flags & 131072 /* Union */) {
	                var types = type.types;
	                var filtered = ts.filter(types, f);
	                return filtered === types ? type : getUnionTypeFromSortedList(filtered);
	            }
	            return f(type) ? type : neverType;
	        }
	        // Apply a mapping function to a type and return the resulting type. If the source type
	        // is a union type, the mapping function is applied to each constituent type and a union
	        // of the resulting types is returned.
	        function mapType(type, mapper, noReductions) {
	            if (!(type.flags & 131072 /* Union */)) {
	                return mapper(type);
	            }
	            var types = type.types;
	            var mappedType;
	            var mappedTypes;
	            for (var _i = 0, types_13 = types; _i < types_13.length; _i++) {
	                var current = types_13[_i];
	                var t = mapper(current);
	                if (t) {
	                    if (!mappedType) {
	                        mappedType = t;
	                    }
	                    else if (!mappedTypes) {
	                        mappedTypes = [mappedType, t];
	                    }
	                    else {
	                        mappedTypes.push(t);
	                    }
	                }
	            }
	            return mappedTypes ? getUnionType(mappedTypes, noReductions ? 0 /* None */ : 1 /* Literal */) : mappedType;
	        }
	        function extractTypesOfKind(type, kind) {
	            return filterType(type, function (t) { return (t.flags & kind) !== 0; });
	        }
	        // Return a new type in which occurrences of the string and number primitive types in
	        // typeWithPrimitives have been replaced with occurrences of string literals and numeric
	        // literals in typeWithLiterals, respectively.
	        function replacePrimitivesWithLiterals(typeWithPrimitives, typeWithLiterals) {
	            if (isTypeSubsetOf(stringType, typeWithPrimitives) && maybeTypeOfKind(typeWithLiterals, 32 /* StringLiteral */) ||
	                isTypeSubsetOf(numberType, typeWithPrimitives) && maybeTypeOfKind(typeWithLiterals, 64 /* NumberLiteral */)) {
	                return mapType(typeWithPrimitives, function (t) {
	                    return t.flags & 2 /* String */ ? extractTypesOfKind(typeWithLiterals, 2 /* String */ | 32 /* StringLiteral */) :
	                        t.flags & 4 /* Number */ ? extractTypesOfKind(typeWithLiterals, 4 /* Number */ | 64 /* NumberLiteral */) :
	                            t;
	                });
	            }
	            return typeWithPrimitives;
	        }
	        function isIncomplete(flowType) {
	            return flowType.flags === 0;
	        }
	        function getTypeFromFlowType(flowType) {
	            return flowType.flags === 0 ? flowType.type : flowType;
	        }
	        function createFlowType(type, incomplete) {
	            return incomplete ? { flags: 0, type: type } : type;
	        }
	        // An evolving array type tracks the element types that have so far been seen in an
	        // 'x.push(value)' or 'x[n] = value' operation along the control flow graph. Evolving
	        // array types are ultimately converted into manifest array types (using getFinalArrayType)
	        // and never escape the getFlowTypeOfReference function.
	        function createEvolvingArrayType(elementType) {
	            var result = createObjectType(256 /* EvolvingArray */);
	            result.elementType = elementType;
	            return result;
	        }
	        function getEvolvingArrayType(elementType) {
	            return evolvingArrayTypes[elementType.id] || (evolvingArrayTypes[elementType.id] = createEvolvingArrayType(elementType));
	        }
	        // When adding evolving array element types we do not perform subtype reduction. Instead,
	        // we defer subtype reduction until the evolving array type is finalized into a manifest
	        // array type.
	        function addEvolvingArrayElementType(evolvingArrayType, node) {
	            var elementType = getBaseTypeOfLiteralType(getContextFreeTypeOfExpression(node));
	            return isTypeSubsetOf(elementType, evolvingArrayType.elementType) ? evolvingArrayType : getEvolvingArrayType(getUnionType([evolvingArrayType.elementType, elementType]));
	        }
	        function createFinalArrayType(elementType) {
	            return elementType.flags & 16384 /* Never */ ?
	                autoArrayType :
	                createArrayType(elementType.flags & 131072 /* Union */ ?
	                    getUnionType(elementType.types, 2 /* Subtype */) :
	                    elementType);
	        }
	        // We perform subtype reduction upon obtaining the final array type from an evolving array type.
	        function getFinalArrayType(evolvingArrayType) {
	            return evolvingArrayType.finalArrayType || (evolvingArrayType.finalArrayType = createFinalArrayType(evolvingArrayType.elementType));
	        }
	        function finalizeEvolvingArrayType(type) {
	            return ts.getObjectFlags(type) & 256 /* EvolvingArray */ ? getFinalArrayType(type) : type;
	        }
	        function getElementTypeOfEvolvingArrayType(type) {
	            return ts.getObjectFlags(type) & 256 /* EvolvingArray */ ? type.elementType : neverType;
	        }
	        function isEvolvingArrayTypeList(types) {
	            var hasEvolvingArrayType = false;
	            for (var _i = 0, types_14 = types; _i < types_14.length; _i++) {
	                var t = types_14[_i];
	                if (!(t.flags & 16384 /* Never */)) {
	                    if (!(ts.getObjectFlags(t) & 256 /* EvolvingArray */)) {
	                        return false;
	                    }
	                    hasEvolvingArrayType = true;
	                }
	            }
	            return hasEvolvingArrayType;
	        }
	        // At flow control branch or loop junctions, if the type along every antecedent code path
	        // is an evolving array type, we construct a combined evolving array type. Otherwise we
	        // finalize all evolving array types.
	        function getUnionOrEvolvingArrayType(types, subtypeReduction) {
	            return isEvolvingArrayTypeList(types) ?
	                getEvolvingArrayType(getUnionType(ts.map(types, getElementTypeOfEvolvingArrayType))) :
	                getUnionType(ts.sameMap(types, finalizeEvolvingArrayType), subtypeReduction);
	        }
	        // Return true if the given node is 'x' in an 'x.length', x.push(value)', 'x.unshift(value)' or
	        // 'x[n] = value' operation, where 'n' is an expression of type any, undefined, or a number-like type.
	        function isEvolvingArrayOperationTarget(node) {
	            var root = getReferenceRoot(node);
	            var parent = root.parent;
	            var isLengthPushOrUnshift = parent.kind === 183 /* PropertyAccessExpression */ && (parent.name.escapedText === "length" ||
	                parent.parent.kind === 185 /* CallExpression */ && ts.isPushOrUnshiftIdentifier(parent.name));
	            var isElementAssignment = parent.kind === 184 /* ElementAccessExpression */ &&
	                parent.expression === root &&
	                parent.parent.kind === 198 /* BinaryExpression */ &&
	                parent.parent.operatorToken.kind === 58 /* EqualsToken */ &&
	                parent.parent.left === parent &&
	                !ts.isAssignmentTarget(parent.parent) &&
	                isTypeAssignableToKind(getTypeOfExpression(parent.argumentExpression), 84 /* NumberLike */);
	            return isLengthPushOrUnshift || isElementAssignment;
	        }
	        function maybeTypePredicateCall(node) {
	            var links = getNodeLinks(node);
	            if (links.maybeTypePredicate === undefined) {
	                links.maybeTypePredicate = getMaybeTypePredicate(node);
	            }
	            return links.maybeTypePredicate;
	        }
	        function getMaybeTypePredicate(node) {
	            if (node.expression.kind !== 97 /* SuperKeyword */) {
	                var funcType = checkNonNullExpression(node.expression);
	                if (funcType !== silentNeverType) {
	                    var apparentType = getApparentType(funcType);
	                    return apparentType !== unknownType && ts.some(getSignaturesOfType(apparentType, 0 /* Call */), signatureHasTypePredicate);
	                }
	            }
	            return false;
	        }
	        function reportFlowControlError(node) {
	            var block = ts.findAncestor(node, ts.isFunctionOrModuleBlock);
	            var sourceFile = ts.getSourceFileOfNode(node);
	            var span = ts.getSpanOfTokenAtPosition(sourceFile, block.statements.pos);
	            diagnostics.add(ts.createFileDiagnostic(sourceFile, span.start, span.length, ts.Diagnostics.The_containing_function_or_module_body_is_too_large_for_control_flow_analysis));
	        }
	        function getFlowTypeOfReference(reference, declaredType, initialType, flowContainer, couldBeUninitialized) {
	            if (initialType === void 0) { initialType = declaredType; }
	            var key;
	            var flowDepth = 0;
	            if (flowAnalysisDisabled) {
	                return unknownType;
	            }
	            if (!reference.flowNode || !couldBeUninitialized && !(declaredType.flags & 142575359 /* Narrowable */)) {
	                return declaredType;
	            }
	            var sharedFlowStart = sharedFlowCount;
	            var evolvedType = getTypeFromFlowType(getTypeAtFlowNode(reference.flowNode));
	            sharedFlowCount = sharedFlowStart;
	            // When the reference is 'x' in an 'x.length', 'x.push(value)', 'x.unshift(value)' or x[n] = value' operation,
	            // we give type 'any[]' to 'x' instead of using the type determined by control flow analysis such that operations
	            // on empty arrays are possible without implicit any errors and new element types can be inferred without
	            // type mismatch errors.
	            var resultType = ts.getObjectFlags(evolvedType) & 256 /* EvolvingArray */ && isEvolvingArrayOperationTarget(reference) ? anyArrayType : finalizeEvolvingArrayType(evolvedType);
	            if (reference.parent && reference.parent.kind === 207 /* NonNullExpression */ && getTypeWithFacts(resultType, 524288 /* NEUndefinedOrNull */).flags & 16384 /* Never */) {
	                return declaredType;
	            }
	            return resultType;
	            function getTypeAtFlowNode(flow) {
	                if (flowDepth === 2500) {
	                    // We have made 2500 recursive invocations. To avoid overflowing the call stack we report an error
	                    // and disable further control flow analysis in the containing function or module body.
	                    flowAnalysisDisabled = true;
	                    reportFlowControlError(reference);
	                    return unknownType;
	                }
	                flowDepth++;
	                while (true) {
	                    var flags = flow.flags;
	                    if (flags & 1024 /* Shared */) {
	                        // We cache results of flow type resolution for shared nodes that were previously visited in
	                        // the same getFlowTypeOfReference invocation. A node is considered shared when it is the
	                        // antecedent of more than one node.
	                        for (var i = sharedFlowStart; i < sharedFlowCount; i++) {
	                            if (sharedFlowNodes[i] === flow) {
	                                flowDepth--;
	                                return sharedFlowTypes[i];
	                            }
	                        }
	                    }
	                    var type = void 0;
	                    if (flags & 4096 /* AfterFinally */) {
	                        // block flow edge: finally -> pre-try (for larger explanation check comment in binder.ts - bindTryStatement
	                        flow.locked = true;
	                        type = getTypeAtFlowNode(flow.antecedent);
	                        flow.locked = false;
	                    }
	                    else if (flags & 2048 /* PreFinally */) {
	                        // locked pre-finally flows are filtered out in getTypeAtFlowBranchLabel
	                        // so here just redirect to antecedent
	                        flow = flow.antecedent;
	                        continue;
	                    }
	                    else if (flags & 16 /* Assignment */) {
	                        type = getTypeAtFlowAssignment(flow);
	                        if (!type) {
	                            flow = flow.antecedent;
	                            continue;
	                        }
	                    }
	                    else if (flags & 96 /* Condition */) {
	                        type = getTypeAtFlowCondition(flow);
	                    }
	                    else if (flags & 128 /* SwitchClause */) {
	                        type = getTypeAtSwitchClause(flow);
	                    }
	                    else if (flags & 12 /* Label */) {
	                        if (flow.antecedents.length === 1) {
	                            flow = flow.antecedents[0];
	                            continue;
	                        }
	                        type = flags & 4 /* BranchLabel */ ?
	                            getTypeAtFlowBranchLabel(flow) :
	                            getTypeAtFlowLoopLabel(flow);
	                    }
	                    else if (flags & 256 /* ArrayMutation */) {
	                        type = getTypeAtFlowArrayMutation(flow);
	                        if (!type) {
	                            flow = flow.antecedent;
	                            continue;
	                        }
	                    }
	                    else if (flags & 2 /* Start */) {
	                        // Check if we should continue with the control flow of the containing function.
	                        var container = flow.container;
	                        if (container && container !== flowContainer && reference.kind !== 183 /* PropertyAccessExpression */ && reference.kind !== 99 /* ThisKeyword */) {
	                            flow = container.flowNode;
	                            continue;
	                        }
	                        // At the top of the flow we have the initial type.
	                        type = initialType;
	                    }
	                    else {
	                        // Unreachable code errors are reported in the binding phase. Here we
	                        // simply return the non-auto declared type to reduce follow-on errors.
	                        type = convertAutoToAny(declaredType);
	                    }
	                    if (flags & 1024 /* Shared */) {
	                        // Record visited node and the associated type in the cache.
	                        sharedFlowNodes[sharedFlowCount] = flow;
	                        sharedFlowTypes[sharedFlowCount] = type;
	                        sharedFlowCount++;
	                    }
	                    flowDepth--;
	                    return type;
	                }
	            }
	            function getTypeAtFlowAssignment(flow) {
	                var node = flow.node;
	                // Assignments only narrow the computed type if the declared type is a union type. Thus, we
	                // only need to evaluate the assigned type if the declared type is a union type.
	                if (isMatchingReference(reference, node)) {
	                    if (ts.getAssignmentTargetKind(node) === 2 /* Compound */) {
	                        var flowType = getTypeAtFlowNode(flow.antecedent);
	                        return createFlowType(getBaseTypeOfLiteralType(getTypeFromFlowType(flowType)), isIncomplete(flowType));
	                    }
	                    if (declaredType === autoType || declaredType === autoArrayType) {
	                        if (isEmptyArrayAssignment(node)) {
	                            return getEvolvingArrayType(neverType);
	                        }
	                        var assignedType = getBaseTypeOfLiteralType(getInitialOrAssignedType(node));
	                        return isTypeAssignableTo(assignedType, declaredType) ? assignedType : anyArrayType;
	                    }
	                    if (declaredType.flags & 131072 /* Union */) {
	                        return getAssignmentReducedType(declaredType, getInitialOrAssignedType(node));
	                    }
	                    return declaredType;
	                }
	                // We didn't have a direct match. However, if the reference is a dotted name, this
	                // may be an assignment to a left hand part of the reference. For example, for a
	                // reference 'x.y.z', we may be at an assignment to 'x.y' or 'x'. In that case,
	                // return the declared type.
	                if (containsMatchingReference(reference, node)) {
	                    return declaredType;
	                }
	                // Assignment doesn't affect reference
	                return undefined;
	            }
	            function getTypeAtFlowArrayMutation(flow) {
	                if (declaredType === autoType || declaredType === autoArrayType) {
	                    var node = flow.node;
	                    var expr = node.kind === 185 /* CallExpression */ ?
	                        node.expression.expression :
	                        node.left.expression;
	                    if (isMatchingReference(reference, getReferenceCandidate(expr))) {
	                        var flowType = getTypeAtFlowNode(flow.antecedent);
	                        var type = getTypeFromFlowType(flowType);
	                        if (ts.getObjectFlags(type) & 256 /* EvolvingArray */) {
	                            var evolvedType_1 = type;
	                            if (node.kind === 185 /* CallExpression */) {
	                                for (var _i = 0, _a = node.arguments; _i < _a.length; _i++) {
	                                    var arg = _a[_i];
	                                    evolvedType_1 = addEvolvingArrayElementType(evolvedType_1, arg);
	                                }
	                            }
	                            else {
	                                var indexType = getTypeOfExpression(node.left.argumentExpression);
	                                if (isTypeAssignableToKind(indexType, 84 /* NumberLike */)) {
	                                    evolvedType_1 = addEvolvingArrayElementType(evolvedType_1, node.right);
	                                }
	                            }
	                            return evolvedType_1 === type ? flowType : createFlowType(evolvedType_1, isIncomplete(flowType));
	                        }
	                        return flowType;
	                    }
	                }
	                return undefined;
	            }
	            function getTypeAtFlowCondition(flow) {
	                var flowType = getTypeAtFlowNode(flow.antecedent);
	                var type = getTypeFromFlowType(flowType);
	                if (type.flags & 16384 /* Never */) {
	                    return flowType;
	                }
	                // If we have an antecedent type (meaning we're reachable in some way), we first
	                // attempt to narrow the antecedent type. If that produces the never type, and if
	                // the antecedent type is incomplete (i.e. a transient type in a loop), then we
	                // take the type guard as an indication that control *could* reach here once we
	                // have the complete type. We proceed by switching to the silent never type which
	                // doesn't report errors when operators are applied to it. Note that this is the
	                // *only* place a silent never type is ever generated.
	                var assumeTrue = (flow.flags & 32 /* TrueCondition */) !== 0;
	                var nonEvolvingType = finalizeEvolvingArrayType(type);
	                var narrowedType = narrowType(nonEvolvingType, flow.expression, assumeTrue);
	                if (narrowedType === nonEvolvingType) {
	                    return flowType;
	                }
	                var incomplete = isIncomplete(flowType);
	                var resultType = incomplete && narrowedType.flags & 16384 /* Never */ ? silentNeverType : narrowedType;
	                return createFlowType(resultType, incomplete);
	            }
	            function getTypeAtSwitchClause(flow) {
	                var flowType = getTypeAtFlowNode(flow.antecedent);
	                var type = getTypeFromFlowType(flowType);
	                var expr = flow.switchStatement.expression;
	                if (isMatchingReference(reference, expr)) {
	                    type = narrowTypeBySwitchOnDiscriminant(type, flow.switchStatement, flow.clauseStart, flow.clauseEnd);
	                }
	                else if (isMatchingReferenceDiscriminant(expr, type)) {
	                    type = narrowTypeByDiscriminant(type, expr, function (t) { return narrowTypeBySwitchOnDiscriminant(t, flow.switchStatement, flow.clauseStart, flow.clauseEnd); });
	                }
	                return createFlowType(type, isIncomplete(flowType));
	            }
	            function getTypeAtFlowBranchLabel(flow) {
	                var antecedentTypes = [];
	                var subtypeReduction = false;
	                var seenIncomplete = false;
	                for (var _i = 0, _a = flow.antecedents; _i < _a.length; _i++) {
	                    var antecedent = _a[_i];
	                    if (antecedent.flags & 2048 /* PreFinally */ && antecedent.lock.locked) {
	                        // if flow correspond to branch from pre-try to finally and this branch is locked - this means that
	                        // we initially have started following the flow outside the finally block.
	                        // in this case we should ignore this branch.
	                        continue;
	                    }
	                    var flowType = getTypeAtFlowNode(antecedent);
	                    var type = getTypeFromFlowType(flowType);
	                    // If the type at a particular antecedent path is the declared type and the
	                    // reference is known to always be assigned (i.e. when declared and initial types
	                    // are the same), there is no reason to process more antecedents since the only
	                    // possible outcome is subtypes that will be removed in the final union type anyway.
	                    if (type === declaredType && declaredType === initialType) {
	                        return type;
	                    }
	                    ts.pushIfUnique(antecedentTypes, type);
	                    // If an antecedent type is not a subset of the declared type, we need to perform
	                    // subtype reduction. This happens when a "foreign" type is injected into the control
	                    // flow using the instanceof operator or a user defined type predicate.
	                    if (!isTypeSubsetOf(type, declaredType)) {
	                        subtypeReduction = true;
	                    }
	                    if (isIncomplete(flowType)) {
	                        seenIncomplete = true;
	                    }
	                }
	                return createFlowType(getUnionOrEvolvingArrayType(antecedentTypes, subtypeReduction ? 2 /* Subtype */ : 1 /* Literal */), seenIncomplete);
	            }
	            function getTypeAtFlowLoopLabel(flow) {
	                // If we have previously computed the control flow type for the reference at
	                // this flow loop junction, return the cached type.
	                var id = getFlowNodeId(flow);
	                var cache = flowLoopCaches[id] || (flowLoopCaches[id] = ts.createMap());
	                if (!key) {
	                    key = getFlowCacheKey(reference);
	                    // No cache key is generated when binding patterns are in unnarrowable situations
	                    if (!key) {
	                        return declaredType;
	                    }
	                }
	                var cached = cache.get(key);
	                if (cached) {
	                    return cached;
	                }
	                // If this flow loop junction and reference are already being processed, return
	                // the union of the types computed for each branch so far, marked as incomplete.
	                // It is possible to see an empty array in cases where loops are nested and the
	                // back edge of the outer loop reaches an inner loop that is already being analyzed.
	                // In such cases we restart the analysis of the inner loop, which will then see
	                // a non-empty in-process array for the outer loop and eventually terminate because
	                // the first antecedent of a loop junction is always the non-looping control flow
	                // path that leads to the top.
	                for (var i = flowLoopStart; i < flowLoopCount; i++) {
	                    if (flowLoopNodes[i] === flow && flowLoopKeys[i] === key && flowLoopTypes[i].length) {
	                        return createFlowType(getUnionOrEvolvingArrayType(flowLoopTypes[i], 1 /* Literal */), /*incomplete*/ true);
	                    }
	                }
	                // Add the flow loop junction and reference to the in-process stack and analyze
	                // each antecedent code path.
	                var antecedentTypes = [];
	                var subtypeReduction = false;
	                var firstAntecedentType;
	                flowLoopNodes[flowLoopCount] = flow;
	                flowLoopKeys[flowLoopCount] = key;
	                flowLoopTypes[flowLoopCount] = antecedentTypes;
	                for (var _i = 0, _a = flow.antecedents; _i < _a.length; _i++) {
	                    var antecedent = _a[_i];
	                    flowLoopCount++;
	                    var flowType = getTypeAtFlowNode(antecedent);
	                    flowLoopCount--;
	                    if (!firstAntecedentType) {
	                        firstAntecedentType = flowType;
	                    }
	                    var type = getTypeFromFlowType(flowType);
	                    // If we see a value appear in the cache it is a sign that control flow analysis
	                    // was restarted and completed by checkExpressionCached. We can simply pick up
	                    // the resulting type and bail out.
	                    var cached_1 = cache.get(key);
	                    if (cached_1) {
	                        return cached_1;
	                    }
	                    ts.pushIfUnique(antecedentTypes, type);
	                    // If an antecedent type is not a subset of the declared type, we need to perform
	                    // subtype reduction. This happens when a "foreign" type is injected into the control
	                    // flow using the instanceof operator or a user defined type predicate.
	                    if (!isTypeSubsetOf(type, declaredType)) {
	                        subtypeReduction = true;
	                    }
	                    // If the type at a particular antecedent path is the declared type there is no
	                    // reason to process more antecedents since the only possible outcome is subtypes
	                    // that will be removed in the final union type anyway.
	                    if (type === declaredType) {
	                        break;
	                    }
	                }
	                // The result is incomplete if the first antecedent (the non-looping control flow path)
	                // is incomplete.
	                var result = getUnionOrEvolvingArrayType(antecedentTypes, subtypeReduction ? 2 /* Subtype */ : 1 /* Literal */);
	                if (isIncomplete(firstAntecedentType)) {
	                    return createFlowType(result, /*incomplete*/ true);
	                }
	                cache.set(key, result);
	                return result;
	            }
	            function isMatchingReferenceDiscriminant(expr, computedType) {
	                return expr.kind === 183 /* PropertyAccessExpression */ &&
	                    computedType.flags & 131072 /* Union */ &&
	                    isMatchingReference(reference, expr.expression) &&
	                    isDiscriminantProperty(computedType, expr.name.escapedText);
	            }
	            function narrowTypeByDiscriminant(type, propAccess, narrowType) {
	                var propName = propAccess.name.escapedText;
	                var propType = getTypeOfPropertyOfType(type, propName);
	                var narrowedPropType = propType && narrowType(propType);
	                return propType === narrowedPropType ? type : filterType(type, function (t) { return isTypeComparableTo(getTypeOfPropertyOfType(t, propName), narrowedPropType); });
	            }
	            function narrowTypeByTruthiness(type, expr, assumeTrue) {
	                if (isMatchingReference(reference, expr)) {
	                    return getTypeWithFacts(type, assumeTrue ? 1048576 /* Truthy */ : 2097152 /* Falsy */);
	                }
	                if (isMatchingReferenceDiscriminant(expr, declaredType)) {
	                    return narrowTypeByDiscriminant(type, expr, function (t) { return getTypeWithFacts(t, assumeTrue ? 1048576 /* Truthy */ : 2097152 /* Falsy */); });
	                }
	                if (containsMatchingReferenceDiscriminant(reference, expr)) {
	                    return declaredType;
	                }
	                return type;
	            }
	            function isTypePresencePossible(type, propName, assumeTrue) {
	                if (getIndexInfoOfType(type, 0 /* String */)) {
	                    return true;
	                }
	                var prop = getPropertyOfType(type, propName);
	                if (prop) {
	                    return prop.flags & 16777216 /* Optional */ ? true : assumeTrue;
	                }
	                return !assumeTrue;
	            }
	            function narrowByInKeyword(type, literal, assumeTrue) {
	                if ((type.flags & (131072 /* Union */ | 65536 /* Object */)) || (type.flags & 32768 /* TypeParameter */ && type.isThisType)) {
	                    var propName_1 = ts.escapeLeadingUnderscores(literal.text);
	                    return filterType(type, function (t) { return isTypePresencePossible(t, propName_1, assumeTrue); });
	                }
	                return type;
	            }
	            function narrowTypeByBinaryExpression(type, expr, assumeTrue) {
	                switch (expr.operatorToken.kind) {
	                    case 58 /* EqualsToken */:
	                        return narrowTypeByTruthiness(type, expr.left, assumeTrue);
	                    case 32 /* EqualsEqualsToken */:
	                    case 33 /* ExclamationEqualsToken */:
	                    case 34 /* EqualsEqualsEqualsToken */:
	                    case 35 /* ExclamationEqualsEqualsToken */:
	                        var operator_1 = expr.operatorToken.kind;
	                        var left_1 = getReferenceCandidate(expr.left);
	                        var right_1 = getReferenceCandidate(expr.right);
	                        if (left_1.kind === 193 /* TypeOfExpression */ && ts.isStringLiteralLike(right_1)) {
	                            return narrowTypeByTypeof(type, left_1, operator_1, right_1, assumeTrue);
	                        }
	                        if (right_1.kind === 193 /* TypeOfExpression */ && ts.isStringLiteralLike(left_1)) {
	                            return narrowTypeByTypeof(type, right_1, operator_1, left_1, assumeTrue);
	                        }
	                        if (isMatchingReference(reference, left_1)) {
	                            return narrowTypeByEquality(type, operator_1, right_1, assumeTrue);
	                        }
	                        if (isMatchingReference(reference, right_1)) {
	                            return narrowTypeByEquality(type, operator_1, left_1, assumeTrue);
	                        }
	                        if (isMatchingReferenceDiscriminant(left_1, declaredType)) {
	                            return narrowTypeByDiscriminant(type, left_1, function (t) { return narrowTypeByEquality(t, operator_1, right_1, assumeTrue); });
	                        }
	                        if (isMatchingReferenceDiscriminant(right_1, declaredType)) {
	                            return narrowTypeByDiscriminant(type, right_1, function (t) { return narrowTypeByEquality(t, operator_1, left_1, assumeTrue); });
	                        }
	                        if (containsMatchingReferenceDiscriminant(reference, left_1) || containsMatchingReferenceDiscriminant(reference, right_1)) {
	                            return declaredType;
	                        }
	                        break;
	                    case 93 /* InstanceOfKeyword */:
	                        return narrowTypeByInstanceof(type, expr, assumeTrue);
	                    case 92 /* InKeyword */:
	                        var target = getReferenceCandidate(expr.right);
	                        if (ts.isStringLiteralLike(expr.left) && isMatchingReference(reference, target)) {
	                            return narrowByInKeyword(type, expr.left, assumeTrue);
	                        }
	                        break;
	                    case 26 /* CommaToken */:
	                        return narrowType(type, expr.right, assumeTrue);
	                }
	                return type;
	            }
	            function narrowTypeByEquality(type, operator, value, assumeTrue) {
	                if (type.flags & 1 /* Any */) {
	                    return type;
	                }
	                if (operator === 33 /* ExclamationEqualsToken */ || operator === 35 /* ExclamationEqualsEqualsToken */) {
	                    assumeTrue = !assumeTrue;
	                }
	                var valueType = getTypeOfExpression(value);
	                if (valueType.flags & 12288 /* Nullable */) {
	                    if (!strictNullChecks) {
	                        return type;
	                    }
	                    var doubleEquals = operator === 32 /* EqualsEqualsToken */ || operator === 33 /* ExclamationEqualsToken */;
	                    var facts = doubleEquals ?
	                        assumeTrue ? 65536 /* EQUndefinedOrNull */ : 524288 /* NEUndefinedOrNull */ :
	                        value.kind === 95 /* NullKeyword */ ?
	                            assumeTrue ? 32768 /* EQNull */ : 262144 /* NENull */ :
	                            assumeTrue ? 16384 /* EQUndefined */ : 131072 /* NEUndefined */;
	                    return getTypeWithFacts(type, facts);
	                }
	                if (type.flags & 134283777 /* NotUnionOrUnit */) {
	                    return type;
	                }
	                if (assumeTrue) {
	                    var narrowedType = filterType(type, function (t) { return areTypesComparable(t, valueType); });
	                    return narrowedType.flags & 16384 /* Never */ ? type : replacePrimitivesWithLiterals(narrowedType, valueType);
	                }
	                if (isUnitType(valueType)) {
	                    var regularType_1 = getRegularTypeOfLiteralType(valueType);
	                    return filterType(type, function (t) { return getRegularTypeOfLiteralType(t) !== regularType_1; });
	                }
	                return type;
	            }
	            function narrowTypeByTypeof(type, typeOfExpr, operator, literal, assumeTrue) {
	                // We have '==', '!=', '====', or !==' operator with 'typeof xxx' and string literal operands
	                var target = getReferenceCandidate(typeOfExpr.expression);
	                if (!isMatchingReference(reference, target)) {
	                    // For a reference of the form 'x.y', a 'typeof x === ...' type guard resets the
	                    // narrowed type of 'y' to its declared type.
	                    if (containsMatchingReference(reference, target)) {
	                        return declaredType;
	                    }
	                    return type;
	                }
	                if (operator === 33 /* ExclamationEqualsToken */ || operator === 35 /* ExclamationEqualsEqualsToken */) {
	                    assumeTrue = !assumeTrue;
	                }
	                if (assumeTrue && !(type.flags & 131072 /* Union */)) {
	                    // We narrow a non-union type to an exact primitive type if the non-union type
	                    // is a supertype of that primitive type. For example, type 'any' can be narrowed
	                    // to one of the primitive types.
	                    var targetType = typeofTypesByName.get(literal.text);
	                    if (targetType) {
	                        if (isTypeSubtypeOf(targetType, type)) {
	                            return targetType;
	                        }
	                        if (type.flags & 7897088 /* Instantiable */) {
	                            var constraint = getBaseConstraintOfType(type) || anyType;
	                            if (isTypeSubtypeOf(targetType, constraint)) {
	                                return getIntersectionType([type, targetType]);
	                            }
	                        }
	                    }
	                }
	                var facts = assumeTrue ?
	                    typeofEQFacts.get(literal.text) || 64 /* TypeofEQHostObject */ :
	                    typeofNEFacts.get(literal.text) || 8192 /* TypeofNEHostObject */;
	                return getTypeWithFacts(type, facts);
	            }
	            function narrowTypeBySwitchOnDiscriminant(type, switchStatement, clauseStart, clauseEnd) {
	                // We only narrow if all case expressions specify values with unit types
	                var switchTypes = getSwitchClauseTypes(switchStatement);
	                if (!switchTypes.length) {
	                    return type;
	                }
	                var clauseTypes = switchTypes.slice(clauseStart, clauseEnd);
	                var hasDefaultClause = clauseStart === clauseEnd || ts.contains(clauseTypes, neverType);
	                var discriminantType = getUnionType(clauseTypes);
	                var caseType = discriminantType.flags & 16384 /* Never */ ? neverType :
	                    replacePrimitivesWithLiterals(filterType(type, function (t) { return areTypesComparable(discriminantType, t); }), discriminantType);
	                if (!hasDefaultClause) {
	                    return caseType;
	                }
	                var defaultType = filterType(type, function (t) { return !(isUnitType(t) && ts.contains(switchTypes, getRegularTypeOfLiteralType(t))); });
	                return caseType.flags & 16384 /* Never */ ? defaultType : getUnionType([caseType, defaultType]);
	            }
	            function narrowTypeByInstanceof(type, expr, assumeTrue) {
	                var left = getReferenceCandidate(expr.left);
	                if (!isMatchingReference(reference, left)) {
	                    // For a reference of the form 'x.y', an 'x instanceof T' type guard resets the
	                    // narrowed type of 'y' to its declared type.
	                    if (containsMatchingReference(reference, left)) {
	                        return declaredType;
	                    }
	                    return type;
	                }
	                // Check that right operand is a function type with a prototype property
	                var rightType = getTypeOfExpression(expr.right);
	                if (!isTypeSubtypeOf(rightType, globalFunctionType)) {
	                    return type;
	                }
	                var targetType;
	                var prototypeProperty = getPropertyOfType(rightType, "prototype");
	                if (prototypeProperty) {
	                    // Target type is type of the prototype property
	                    var prototypePropertyType = getTypeOfSymbol(prototypeProperty);
	                    if (!isTypeAny(prototypePropertyType)) {
	                        targetType = prototypePropertyType;
	                    }
	                }
	                // Don't narrow from 'any' if the target type is exactly 'Object' or 'Function'
	                if (isTypeAny(type) && (targetType === globalObjectType || targetType === globalFunctionType)) {
	                    return type;
	                }
	                if (!targetType) {
	                    // Target type is type of construct signature
	                    var constructSignatures = void 0;
	                    if (ts.getObjectFlags(rightType) & 2 /* Interface */) {
	                        constructSignatures = resolveDeclaredMembers(rightType).declaredConstructSignatures;
	                    }
	                    else if (ts.getObjectFlags(rightType) & 16 /* Anonymous */) {
	                        constructSignatures = getSignaturesOfType(rightType, 1 /* Construct */);
	                    }
	                    if (constructSignatures && constructSignatures.length) {
	                        targetType = getUnionType(ts.map(constructSignatures, function (signature) { return getReturnTypeOfSignature(getErasedSignature(signature)); }));
	                    }
	                }
	                if (targetType) {
	                    return getNarrowedType(type, targetType, assumeTrue, isTypeDerivedFrom);
	                }
	                return type;
	            }
	            function getNarrowedType(type, candidate, assumeTrue, isRelated) {
	                if (!assumeTrue) {
	                    return filterType(type, function (t) { return !isRelated(t, candidate); });
	                }
	                // If the current type is a union type, remove all constituents that couldn't be instances of
	                // the candidate type. If one or more constituents remain, return a union of those.
	                if (type.flags & 131072 /* Union */) {
	                    var assignableType = filterType(type, function (t) { return isRelated(t, candidate); });
	                    if (!(assignableType.flags & 16384 /* Never */)) {
	                        return assignableType;
	                    }
	                }
	                // If the candidate type is a subtype of the target type, narrow to the candidate type.
	                // Otherwise, if the target type is assignable to the candidate type, keep the target type.
	                // Otherwise, if the candidate type is assignable to the target type, narrow to the candidate
	                // type. Otherwise, the types are completely unrelated, so narrow to an intersection of the
	                // two types.
	                return isTypeSubtypeOf(candidate, type) ? candidate :
	                    isTypeAssignableTo(type, candidate) ? type :
	                        isTypeAssignableTo(candidate, type) ? candidate :
	                            getIntersectionType([type, candidate]);
	            }
	            function narrowTypeByTypePredicate(type, callExpression, assumeTrue) {
	                if (!hasMatchingArgument(callExpression, reference) || !maybeTypePredicateCall(callExpression)) {
	                    return type;
	                }
	                var signature = getResolvedSignature(callExpression);
	                var predicate = getTypePredicateOfSignature(signature);
	                if (!predicate) {
	                    return type;
	                }
	                // Don't narrow from 'any' if the predicate type is exactly 'Object' or 'Function'
	                if (isTypeAny(type) && (predicate.type === globalObjectType || predicate.type === globalFunctionType)) {
	                    return type;
	                }
	                if (ts.isIdentifierTypePredicate(predicate)) {
	                    var predicateArgument = callExpression.arguments[predicate.parameterIndex - (signature.thisParameter ? 1 : 0)];
	                    if (predicateArgument) {
	                        if (isMatchingReference(reference, predicateArgument)) {
	                            return getNarrowedType(type, predicate.type, assumeTrue, isTypeSubtypeOf);
	                        }
	                        if (containsMatchingReference(reference, predicateArgument)) {
	                            return declaredType;
	                        }
	                    }
	                }
	                else {
	                    var invokedExpression = ts.skipParentheses(callExpression.expression);
	                    if (invokedExpression.kind === 184 /* ElementAccessExpression */ || invokedExpression.kind === 183 /* PropertyAccessExpression */) {
	                        var accessExpression = invokedExpression;
	                        var possibleReference = ts.skipParentheses(accessExpression.expression);
	                        if (isMatchingReference(reference, possibleReference)) {
	                            return getNarrowedType(type, predicate.type, assumeTrue, isTypeSubtypeOf);
	                        }
	                        if (containsMatchingReference(reference, possibleReference)) {
	                            return declaredType;
	                        }
	                    }
	                }
	                return type;
	            }
	            // Narrow the given type based on the given expression having the assumed boolean value. The returned type
	            // will be a subtype or the same type as the argument.
	            function narrowType(type, expr, assumeTrue) {
	                switch (expr.kind) {
	                    case 71 /* Identifier */:
	                    case 99 /* ThisKeyword */:
	                    case 97 /* SuperKeyword */:
	                    case 183 /* PropertyAccessExpression */:
	                        return narrowTypeByTruthiness(type, expr, assumeTrue);
	                    case 185 /* CallExpression */:
	                        return narrowTypeByTypePredicate(type, expr, assumeTrue);
	                    case 189 /* ParenthesizedExpression */:
	                        return narrowType(type, expr.expression, assumeTrue);
	                    case 198 /* BinaryExpression */:
	                        return narrowTypeByBinaryExpression(type, expr, assumeTrue);
	                    case 196 /* PrefixUnaryExpression */:
	                        if (expr.operator === 51 /* ExclamationToken */) {
	                            return narrowType(type, expr.operand, !assumeTrue);
	                        }
	                        break;
	                }
	                return type;
	            }
	        }
	        function getTypeOfSymbolAtLocation(symbol, location) {
	            symbol = symbol.exportSymbol || symbol;
	            // If we have an identifier or a property access at the given location, if the location is
	            // an dotted name expression, and if the location is not an assignment target, obtain the type
	            // of the expression (which will reflect control flow analysis). If the expression indeed
	            // resolved to the given symbol, return the narrowed type.
	            if (location.kind === 71 /* Identifier */) {
	                if (ts.isRightSideOfQualifiedNameOrPropertyAccess(location)) {
	                    location = location.parent;
	                }
	                if (ts.isExpressionNode(location) && !ts.isAssignmentTarget(location)) {
	                    var type = getTypeOfExpression(location);
	                    if (getExportSymbolOfValueSymbolIfExported(getNodeLinks(location).resolvedSymbol) === symbol) {
	                        return type;
	                    }
	                }
	            }
	            // The location isn't a reference to the given symbol, meaning we're being asked
	            // a hypothetical question of what type the symbol would have if there was a reference
	            // to it at the given location. Since we have no control flow information for the
	            // hypothetical reference (control flow information is created and attached by the
	            // binder), we simply return the declared type of the symbol.
	            return getTypeOfSymbol(symbol);
	        }
	        function getControlFlowContainer(node) {
	            return ts.findAncestor(node.parent, function (node) {
	                return ts.isFunctionLike(node) && !ts.getImmediatelyInvokedFunctionExpression(node) ||
	                    node.kind === 238 /* ModuleBlock */ ||
	                    node.kind === 272 /* SourceFile */ ||
	                    node.kind === 151 /* PropertyDeclaration */;
	            });
	        }
	        // Check if a parameter is assigned anywhere within its declaring function.
	        function isParameterAssigned(symbol) {
	            var func = ts.getRootDeclaration(symbol.valueDeclaration).parent;
	            var links = getNodeLinks(func);
	            if (!(links.flags & 4194304 /* AssignmentsMarked */)) {
	                links.flags |= 4194304 /* AssignmentsMarked */;
	                if (!hasParentWithAssignmentsMarked(func)) {
	                    markParameterAssignments(func);
	                }
	            }
	            return symbol.isAssigned || false;
	        }
	        function hasParentWithAssignmentsMarked(node) {
	            return !!ts.findAncestor(node.parent, function (node) { return ts.isFunctionLike(node) && !!(getNodeLinks(node).flags & 4194304 /* AssignmentsMarked */); });
	        }
	        function markParameterAssignments(node) {
	            if (node.kind === 71 /* Identifier */) {
	                if (ts.isAssignmentTarget(node)) {
	                    var symbol = getResolvedSymbol(node);
	                    if (symbol.valueDeclaration && ts.getRootDeclaration(symbol.valueDeclaration).kind === 148 /* Parameter */) {
	                        symbol.isAssigned = true;
	                    }
	                }
	            }
	            else {
	                ts.forEachChild(node, markParameterAssignments);
	            }
	        }
	        function isConstVariable(symbol) {
	            return symbol.flags & 3 /* Variable */ && (getDeclarationNodeFlagsFromSymbol(symbol) & 2 /* Const */) !== 0 && getTypeOfSymbol(symbol) !== autoArrayType;
	        }
	        /** remove undefined from the annotated type of a parameter when there is an initializer (that doesn't include undefined) */
	        function removeOptionalityFromDeclaredType(declaredType, declaration) {
	            var annotationIncludesUndefined = strictNullChecks &&
	                declaration.kind === 148 /* Parameter */ &&
	                declaration.initializer &&
	                getFalsyFlags(declaredType) & 4096 /* Undefined */ &&
	                !(getFalsyFlags(checkExpression(declaration.initializer)) & 4096 /* Undefined */);
	            return annotationIncludesUndefined ? getTypeWithFacts(declaredType, 131072 /* NEUndefined */) : declaredType;
	        }
	        function isConstraintPosition(node) {
	            var parent = node.parent;
	            return parent.kind === 183 /* PropertyAccessExpression */ ||
	                parent.kind === 185 /* CallExpression */ && parent.expression === node ||
	                parent.kind === 184 /* ElementAccessExpression */ && parent.expression === node ||
	                parent.kind === 207 /* NonNullExpression */ ||
	                parent.kind === 180 /* BindingElement */ && parent.name === node && !!parent.initializer;
	        }
	        function typeHasNullableConstraint(type) {
	            return type.flags & 7372800 /* InstantiableNonPrimitive */ && maybeTypeOfKind(getBaseConstraintOfType(type) || emptyObjectType, 12288 /* Nullable */);
	        }
	        function getConstraintForLocation(type, node) {
	            // When a node is the left hand expression of a property access, element access, or call expression,
	            // and the type of the node includes type variables with constraints that are nullable, we fetch the
	            // apparent type of the node *before* performing control flow analysis such that narrowings apply to
	            // the constraint type.
	            if (isConstraintPosition(node) && forEachType(type, typeHasNullableConstraint)) {
	                return mapType(getWidenedType(type), getBaseConstraintOrType);
	            }
	            return type;
	        }
	        function markAliasReferenced(symbol, location) {
	            if (isNonLocalAlias(symbol, /*excludes*/ 107455 /* Value */) && !isInTypeQuery(location) && !isConstEnumOrConstEnumOnlyModule(resolveAlias(symbol))) {
	                markAliasSymbolAsReferenced(symbol);
	            }
	        }
	        function checkIdentifier(node) {
	            var symbol = getResolvedSymbol(node);
	            if (symbol === unknownSymbol) {
	                return unknownType;
	            }
	            // As noted in ECMAScript 6 language spec, arrow functions never have an arguments objects.
	            // Although in down-level emit of arrow function, we emit it using function expression which means that
	            // arguments objects will be bound to the inner object; emitting arrow function natively in ES6, arguments objects
	            // will be bound to non-arrow function that contain this arrow function. This results in inconsistent behavior.
	            // To avoid that we will give an error to users if they use arguments objects in arrow function so that they
	            // can explicitly bound arguments objects
	            if (symbol === argumentsSymbol) {
	                var container = ts.getContainingFunction(node);
	                if (languageVersion < 2 /* ES2015 */) {
	                    if (container.kind === 191 /* ArrowFunction */) {
	                        error(node, ts.Diagnostics.The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_standard_function_expression);
	                    }
	                    else if (ts.hasModifier(container, 256 /* Async */)) {
	                        error(node, ts.Diagnostics.The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_using_a_standard_function_or_method);
	                    }
	                }
	                getNodeLinks(container).flags |= 8192 /* CaptureArguments */;
	                return getTypeOfSymbol(symbol);
	            }
	            // We should only mark aliases as referenced if there isn't a local value declaration
	            // for the symbol. Also, don't mark any property access expression LHS - checkPropertyAccessExpression will handle that
	            if (!(node.parent && ts.isPropertyAccessExpression(node.parent) && node.parent.expression === node)) {
	                markAliasReferenced(symbol, node);
	            }
	            var localOrExportSymbol = getExportSymbolOfValueSymbolIfExported(symbol);
	            var declaration = localOrExportSymbol.valueDeclaration;
	            if (localOrExportSymbol.flags & 32 /* Class */) {
	                // Due to the emit for class decorators, any reference to the class from inside of the class body
	                // must instead be rewritten to point to a temporary variable to avoid issues with the double-bind
	                // behavior of class names in ES6.
	                if (declaration.kind === 233 /* ClassDeclaration */
	                    && ts.nodeIsDecorated(declaration)) {
	                    var container = ts.getContainingClass(node);
	                    while (container !== undefined) {
	                        if (container === declaration && container.name !== node) {
	                            getNodeLinks(declaration).flags |= 8388608 /* ClassWithConstructorReference */;
	                            getNodeLinks(node).flags |= 16777216 /* ConstructorReferenceInClass */;
	                            break;
	                        }
	                        container = ts.getContainingClass(container);
	                    }
	                }
	                else if (declaration.kind === 203 /* ClassExpression */) {
	                    // When we emit a class expression with static members that contain a reference
	                    // to the constructor in the initializer, we will need to substitute that
	                    // binding with an alias as the class name is not in scope.
	                    var container = ts.getThisContainer(node, /*includeArrowFunctions*/ false);
	                    while (container !== undefined) {
	                        if (container.parent === declaration) {
	                            if (container.kind === 151 /* PropertyDeclaration */ && ts.hasModifier(container, 32 /* Static */)) {
	                                getNodeLinks(declaration).flags |= 8388608 /* ClassWithConstructorReference */;
	                                getNodeLinks(node).flags |= 16777216 /* ConstructorReferenceInClass */;
	                            }
	                            break;
	                        }
	                        container = ts.getThisContainer(container, /*includeArrowFunctions*/ false);
	                    }
	                }
	            }
	            checkCollisionWithCapturedSuperVariable(node, node);
	            checkCollisionWithCapturedThisVariable(node, node);
	            checkCollisionWithCapturedNewTargetVariable(node, node);
	            checkNestedBlockScopedBinding(node, symbol);
	            var type = getConstraintForLocation(getTypeOfSymbol(localOrExportSymbol), node);
	            var assignmentKind = ts.getAssignmentTargetKind(node);
	            if (assignmentKind) {
	                if (!(localOrExportSymbol.flags & 3 /* Variable */)) {
	                    error(node, ts.Diagnostics.Cannot_assign_to_0_because_it_is_not_a_variable, symbolToString(symbol));
	                    return unknownType;
	                }
	                if (isReadonlySymbol(localOrExportSymbol)) {
	                    error(node, ts.Diagnostics.Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property, symbolToString(symbol));
	                    return unknownType;
	                }
	            }
	            var isAlias = localOrExportSymbol.flags & 2097152 /* Alias */;
	            // We only narrow variables and parameters occurring in a non-assignment position. For all other
	            // entities we simply return the declared type.
	            if (localOrExportSymbol.flags & 3 /* Variable */) {
	                if (assignmentKind === 1 /* Definite */) {
	                    return type;
	                }
	            }
	            else if (isAlias) {
	                declaration = ts.find(symbol.declarations, isSomeImportDeclaration);
	            }
	            else {
	                return type;
	            }
	            if (!declaration) {
	                return type;
	            }
	            // The declaration container is the innermost function that encloses the declaration of the variable
	            // or parameter. The flow container is the innermost function starting with which we analyze the control
	            // flow graph to determine the control flow based type.
	            var isParameter = ts.getRootDeclaration(declaration).kind === 148 /* Parameter */;
	            var declarationContainer = getControlFlowContainer(declaration);
	            var flowContainer = getControlFlowContainer(node);
	            var isOuterVariable = flowContainer !== declarationContainer;
	            var isSpreadDestructuringAsignmentTarget = node.parent && node.parent.parent && ts.isSpreadAssignment(node.parent) && isDestructuringAssignmentTarget(node.parent.parent);
	            // When the control flow originates in a function expression or arrow function and we are referencing
	            // a const variable or parameter from an outer function, we extend the origin of the control flow
	            // analysis to include the immediately enclosing function.
	            while (flowContainer !== declarationContainer && (flowContainer.kind === 190 /* FunctionExpression */ ||
	                flowContainer.kind === 191 /* ArrowFunction */ || ts.isObjectLiteralOrClassExpressionMethod(flowContainer)) &&
	                (isConstVariable(localOrExportSymbol) || isParameter && !isParameterAssigned(localOrExportSymbol))) {
	                flowContainer = getControlFlowContainer(flowContainer);
	            }
	            // We only look for uninitialized variables in strict null checking mode, and only when we can analyze
	            // the entire control flow graph from the variable's declaration (i.e. when the flow container and
	            // declaration container are the same).
	            var assumeInitialized = isParameter || isAlias || isOuterVariable || isSpreadDestructuringAsignmentTarget ||
	                type !== autoType && type !== autoArrayType && (!strictNullChecks || (type.flags & 1 /* Any */) !== 0 ||
	                    isInTypeQuery(node) || node.parent.kind === 250 /* ExportSpecifier */) ||
	                node.parent.kind === 207 /* NonNullExpression */ ||
	                declaration.kind === 230 /* VariableDeclaration */ && declaration.exclamationToken ||
	                declaration.flags & 2097152 /* Ambient */;
	            var initialType = assumeInitialized ? (isParameter ? removeOptionalityFromDeclaredType(type, declaration) : type) :
	                type === autoType || type === autoArrayType ? undefinedType :
	                    getOptionalType(type);
	            var flowType = getFlowTypeOfReference(node, type, initialType, flowContainer, !assumeInitialized);
	            // A variable is considered uninitialized when it is possible to analyze the entire control flow graph
	            // from declaration to use, and when the variable's declared type doesn't include undefined but the
	            // control flow based type does include undefined.
	            if (type === autoType || type === autoArrayType) {
	                if (flowType === autoType || flowType === autoArrayType) {
	                    if (noImplicitAny) {
	                        error(ts.getNameOfDeclaration(declaration), ts.Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined, symbolToString(symbol), typeToString(flowType));
	                        error(node, ts.Diagnostics.Variable_0_implicitly_has_an_1_type, symbolToString(symbol), typeToString(flowType));
	                    }
	                    return convertAutoToAny(flowType);
	                }
	            }
	            else if (!assumeInitialized && !(getFalsyFlags(type) & 4096 /* Undefined */) && getFalsyFlags(flowType) & 4096 /* Undefined */) {
	                error(node, ts.Diagnostics.Variable_0_is_used_before_being_assigned, symbolToString(symbol));
	                // Return the declared type to reduce follow-on errors
	                return type;
	            }
	            return assignmentKind ? getBaseTypeOfLiteralType(flowType) : flowType;
	        }
	        function isInsideFunction(node, threshold) {
	            return !!ts.findAncestor(node, function (n) { return n === threshold ? "quit" : ts.isFunctionLike(n); });
	        }
	        function checkNestedBlockScopedBinding(node, symbol) {
	            if (languageVersion >= 2 /* ES2015 */ ||
	                (symbol.flags & (2 /* BlockScopedVariable */ | 32 /* Class */)) === 0 ||
	                symbol.valueDeclaration.parent.kind === 267 /* CatchClause */) {
	                return;
	            }
	            // 1. walk from the use site up to the declaration and check
	            // if there is anything function like between declaration and use-site (is binding/class is captured in function).
	            // 2. walk from the declaration up to the boundary of lexical environment and check
	            // if there is an iteration statement in between declaration and boundary (is binding/class declared inside iteration statement)
	            var container = ts.getEnclosingBlockScopeContainer(symbol.valueDeclaration);
	            var usedInFunction = isInsideFunction(node.parent, container);
	            var current = container;
	            var containedInIterationStatement = false;
	            while (current && !ts.nodeStartsNewLexicalEnvironment(current)) {
	                if (ts.isIterationStatement(current, /*lookInLabeledStatements*/ false)) {
	                    containedInIterationStatement = true;
	                    break;
	                }
	                current = current.parent;
	            }
	            if (containedInIterationStatement) {
	                if (usedInFunction) {
	                    // mark iteration statement as containing block-scoped binding captured in some function
	                    getNodeLinks(current).flags |= 65536 /* LoopWithCapturedBlockScopedBinding */;
	                }
	                // mark variables that are declared in loop initializer and reassigned inside the body of ForStatement.
	                // if body of ForStatement will be converted to function then we'll need a extra machinery to propagate reassigned values back.
	                if (container.kind === 218 /* ForStatement */ &&
	                    ts.getAncestor(symbol.valueDeclaration, 231 /* VariableDeclarationList */).parent === container &&
	                    isAssignedInBodyOfForStatement(node, container)) {
	                    getNodeLinks(symbol.valueDeclaration).flags |= 2097152 /* NeedsLoopOutParameter */;
	                }
	                // set 'declared inside loop' bit on the block-scoped binding
	                getNodeLinks(symbol.valueDeclaration).flags |= 262144 /* BlockScopedBindingInLoop */;
	            }
	            if (usedInFunction) {
	                getNodeLinks(symbol.valueDeclaration).flags |= 131072 /* CapturedBlockScopedBinding */;
	            }
	        }
	        function isAssignedInBodyOfForStatement(node, container) {
	            // skip parenthesized nodes
	            var current = node;
	            while (current.parent.kind === 189 /* ParenthesizedExpression */) {
	                current = current.parent;
	            }
	            // check if node is used as LHS in some assignment expression
	            var isAssigned = false;
	            if (ts.isAssignmentTarget(current)) {
	                isAssigned = true;
	            }
	            else if ((current.parent.kind === 196 /* PrefixUnaryExpression */ || current.parent.kind === 197 /* PostfixUnaryExpression */)) {
	                var expr = current.parent;
	                isAssigned = expr.operator === 43 /* PlusPlusToken */ || expr.operator === 44 /* MinusMinusToken */;
	            }
	            if (!isAssigned) {
	                return false;
	            }
	            // at this point we know that node is the target of assignment
	            // now check that modification happens inside the statement part of the ForStatement
	            return !!ts.findAncestor(current, function (n) { return n === container ? "quit" : n === container.statement; });
	        }
	        function captureLexicalThis(node, container) {
	            getNodeLinks(node).flags |= 2 /* LexicalThis */;
	            if (container.kind === 151 /* PropertyDeclaration */ || container.kind === 154 /* Constructor */) {
	                var classNode = container.parent;
	                getNodeLinks(classNode).flags |= 4 /* CaptureThis */;
	            }
	            else {
	                getNodeLinks(container).flags |= 4 /* CaptureThis */;
	            }
	        }
	        function findFirstSuperCall(n) {
	            if (ts.isSuperCall(n)) {
	                return n;
	            }
	            else if (ts.isFunctionLike(n)) {
	                return undefined;
	            }
	            return ts.forEachChild(n, findFirstSuperCall);
	        }
	        /**
	         * Return a cached result if super-statement is already found.
	         * Otherwise, find a super statement in a given constructor function and cache the result in the node-links of the constructor
	         *
	         * @param constructor constructor-function to look for super statement
	         */
	        function getSuperCallInConstructor(constructor) {
	            var links = getNodeLinks(constructor);
	            // Only trying to find super-call if we haven't yet tried to find one.  Once we try, we will record the result
	            if (links.hasSuperCall === undefined) {
	                links.superCall = findFirstSuperCall(constructor.body);
	                links.hasSuperCall = links.superCall ? true : false;
	            }
	            return links.superCall;
	        }
	        /**
	         * Check if the given class-declaration extends null then return true.
	         * Otherwise, return false
	         * @param classDecl a class declaration to check if it extends null
	         */
	        function classDeclarationExtendsNull(classDecl) {
	            var classSymbol = getSymbolOfNode(classDecl);
	            var classInstanceType = getDeclaredTypeOfSymbol(classSymbol);
	            var baseConstructorType = getBaseConstructorTypeOfClass(classInstanceType);
	            return baseConstructorType === nullWideningType;
	        }
	        function checkThisBeforeSuper(node, container, diagnosticMessage) {
	            var containingClassDecl = container.parent;
	            var baseTypeNode = ts.getClassExtendsHeritageClauseElement(containingClassDecl);
	            // If a containing class does not have extends clause or the class extends null
	            // skip checking whether super statement is called before "this" accessing.
	            if (baseTypeNode && !classDeclarationExtendsNull(containingClassDecl)) {
	                var superCall = getSuperCallInConstructor(container);
	                // We should give an error in the following cases:
	                //      - No super-call
	                //      - "this" is accessing before super-call.
	                //          i.e super(this)
	                //              this.x; super();
	                // We want to make sure that super-call is done before accessing "this" so that
	                // "this" is not accessed as a parameter of the super-call.
	                if (!superCall || superCall.end > node.pos) {
	                    // In ES6, super inside constructor of class-declaration has to precede "this" accessing
	                    error(node, diagnosticMessage);
	                }
	            }
	        }
	        function checkThisExpression(node) {
	            // Stop at the first arrow function so that we can
	            // tell whether 'this' needs to be captured.
	            var container = ts.getThisContainer(node, /* includeArrowFunctions */ true);
	            var needToCaptureLexicalThis = false;
	            if (container.kind === 154 /* Constructor */) {
	                checkThisBeforeSuper(node, container, ts.Diagnostics.super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class);
	            }
	            // Now skip arrow functions to get the "real" owner of 'this'.
	            if (container.kind === 191 /* ArrowFunction */) {
	                container = ts.getThisContainer(container, /* includeArrowFunctions */ false);
	                // When targeting es6, arrow function lexically bind "this" so we do not need to do the work of binding "this" in emitted code
	                needToCaptureLexicalThis = (languageVersion < 2 /* ES2015 */);
	            }
	            switch (container.kind) {
	                case 237 /* ModuleDeclaration */:
	                    error(node, ts.Diagnostics.this_cannot_be_referenced_in_a_module_or_namespace_body);
	                    // do not return here so in case if lexical this is captured - it will be reflected in flags on NodeLinks
	                    break;
	                case 236 /* EnumDeclaration */:
	                    error(node, ts.Diagnostics.this_cannot_be_referenced_in_current_location);
	                    // do not return here so in case if lexical this is captured - it will be reflected in flags on NodeLinks
	                    break;
	                case 154 /* Constructor */:
	                    if (isInConstructorArgumentInitializer(node, container)) {
	                        error(node, ts.Diagnostics.this_cannot_be_referenced_in_constructor_arguments);
	                        // do not return here so in case if lexical this is captured - it will be reflected in flags on NodeLinks
	                    }
	                    break;
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    if (ts.hasModifier(container, 32 /* Static */)) {
	                        error(node, ts.Diagnostics.this_cannot_be_referenced_in_a_static_property_initializer);
	                        // do not return here so in case if lexical this is captured - it will be reflected in flags on NodeLinks
	                    }
	                    break;
	                case 146 /* ComputedPropertyName */:
	                    error(node, ts.Diagnostics.this_cannot_be_referenced_in_a_computed_property_name);
	                    break;
	            }
	            if (needToCaptureLexicalThis) {
	                captureLexicalThis(node, container);
	            }
	            var type = tryGetThisTypeAt(node, container);
	            if (!type && noImplicitThis) {
	                // With noImplicitThis, functions may not reference 'this' if it has type 'any'
	                error(node, ts.Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation);
	            }
	            return type || anyType;
	        }
	        function tryGetThisTypeAt(node, container) {
	            if (container === void 0) { container = ts.getThisContainer(node, /*includeArrowFunctions*/ false); }
	            if (ts.isFunctionLike(container) &&
	                (!isInParameterInitializerBeforeContainingFunction(node) || ts.getThisParameter(container))) {
	                // Note: a parameter initializer should refer to class-this unless function-this is explicitly annotated.
	                // If this is a function in a JS file, it might be a class method. Check if it's the RHS
	                // of a x.prototype.y = function [name]() { .... }
	                if (container.kind === 190 /* FunctionExpression */ &&
	                    container.parent.kind === 198 /* BinaryExpression */ &&
	                    ts.getSpecialPropertyAssignmentKind(container.parent) === 3 /* PrototypeProperty */) {
	                    // Get the 'x' of 'x.prototype.y = f' (here, 'f' is 'container')
	                    var className = container.parent // x.prototype.y = f
	                        .left // x.prototype.y
	                        .expression // x.prototype
	                        .expression; // x
	                    var classSymbol = checkExpression(className).symbol;
	                    if (classSymbol && classSymbol.members && (classSymbol.flags & 16 /* Function */)) {
	                        return getFlowTypeOfReference(node, getInferredClassType(classSymbol));
	                    }
	                }
	                var thisType = getThisTypeOfDeclaration(container) || getContextualThisParameterType(container);
	                if (thisType) {
	                    return getFlowTypeOfReference(node, thisType);
	                }
	            }
	            if (ts.isClassLike(container.parent)) {
	                var symbol = getSymbolOfNode(container.parent);
	                var type = ts.hasModifier(container, 32 /* Static */) ? getTypeOfSymbol(symbol) : getDeclaredTypeOfSymbol(symbol).thisType;
	                return getFlowTypeOfReference(node, type);
	            }
	            if (ts.isInJavaScriptFile(node)) {
	                var type = getTypeForThisExpressionFromJSDoc(container);
	                if (type && type !== unknownType) {
	                    return getFlowTypeOfReference(node, type);
	                }
	            }
	        }
	        function getTypeForThisExpressionFromJSDoc(node) {
	            var jsdocType = ts.getJSDocType(node);
	            if (jsdocType && jsdocType.kind === 280 /* JSDocFunctionType */) {
	                var jsDocFunctionType = jsdocType;
	                if (jsDocFunctionType.parameters.length > 0 &&
	                    jsDocFunctionType.parameters[0].name &&
	                    jsDocFunctionType.parameters[0].name.escapedText === "this") {
	                    return getTypeFromTypeNode(jsDocFunctionType.parameters[0].type);
	                }
	            }
	        }
	        function isInConstructorArgumentInitializer(node, constructorDecl) {
	            return !!ts.findAncestor(node, function (n) { return n === constructorDecl ? "quit" : n.kind === 148 /* Parameter */; });
	        }
	        function checkSuperExpression(node) {
	            var isCallExpression = node.parent.kind === 185 /* CallExpression */ && node.parent.expression === node;
	            var container = ts.getSuperContainer(node, /*stopOnFunctions*/ true);
	            var needToCaptureLexicalThis = false;
	            // adjust the container reference in case if super is used inside arrow functions with arbitrarily deep nesting
	            if (!isCallExpression) {
	                while (container && container.kind === 191 /* ArrowFunction */) {
	                    container = ts.getSuperContainer(container, /*stopOnFunctions*/ true);
	                    needToCaptureLexicalThis = languageVersion < 2 /* ES2015 */;
	                }
	            }
	            var canUseSuperExpression = isLegalUsageOfSuperExpression(container);
	            var nodeCheckFlag = 0;
	            if (!canUseSuperExpression) {
	                // issue more specific error if super is used in computed property name
	                // class A { foo() { return "1" }}
	                // class B {
	                //     [super.foo()]() {}
	                // }
	                var current = ts.findAncestor(node, function (n) { return n === container ? "quit" : n.kind === 146 /* ComputedPropertyName */; });
	                if (current && current.kind === 146 /* ComputedPropertyName */) {
	                    error(node, ts.Diagnostics.super_cannot_be_referenced_in_a_computed_property_name);
	                }
	                else if (isCallExpression) {
	                    error(node, ts.Diagnostics.Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors);
	                }
	                else if (!container || !container.parent || !(ts.isClassLike(container.parent) || container.parent.kind === 182 /* ObjectLiteralExpression */)) {
	                    error(node, ts.Diagnostics.super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions);
	                }
	                else {
	                    error(node, ts.Diagnostics.super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_derived_class);
	                }
	                return unknownType;
	            }
	            if (!isCallExpression && container.kind === 154 /* Constructor */) {
	                checkThisBeforeSuper(node, container, ts.Diagnostics.super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class);
	            }
	            if (ts.hasModifier(container, 32 /* Static */) || isCallExpression) {
	                nodeCheckFlag = 512 /* SuperStatic */;
	            }
	            else {
	                nodeCheckFlag = 256 /* SuperInstance */;
	            }
	            getNodeLinks(node).flags |= nodeCheckFlag;
	            // Due to how we emit async functions, we need to specialize the emit for an async method that contains a `super` reference.
	            // This is due to the fact that we emit the body of an async function inside of a generator function. As generator
	            // functions cannot reference `super`, we emit a helper inside of the method body, but outside of the generator. This helper
	            // uses an arrow function, which is permitted to reference `super`.
	            //
	            // There are two primary ways we can access `super` from within an async method. The first is getting the value of a property
	            // or indexed access on super, either as part of a right-hand-side expression or call expression. The second is when setting the value
	            // of a property or indexed access, either as part of an assignment expression or destructuring assignment.
	            //
	            // The simplest case is reading a value, in which case we will emit something like the following:
	            //
	            //  // ts
	            //  ...
	            //  async asyncMethod() {
	            //    let x = await super.asyncMethod();
	            //    return x;
	            //  }
	            //  ...
	            //
	            //  // js
	            //  ...
	            //  asyncMethod() {
	            //      const _super = name => super[name];
	            //      return __awaiter(this, arguments, Promise, function *() {
	            //          let x = yield _super("asyncMethod").call(this);
	            //          return x;
	            //      });
	            //  }
	            //  ...
	            //
	            // The more complex case is when we wish to assign a value, especially as part of a destructuring assignment. As both cases
	            // are legal in ES6, but also likely less frequent, we emit the same more complex helper for both scenarios:
	            //
	            //  // ts
	            //  ...
	            //  async asyncMethod(ar: Promise<any[]>) {
	            //      [super.a, super.b] = await ar;
	            //  }
	            //  ...
	            //
	            //  // js
	            //  ...
	            //  asyncMethod(ar) {
	            //      const _super = (function (geti, seti) {
	            //          const cache = Object.create(null);
	            //          return name => cache[name] || (cache[name] = { get value() { return geti(name); }, set value(v) { seti(name, v); } });
	            //      })(name => super[name], (name, value) => super[name] = value);
	            //      return __awaiter(this, arguments, Promise, function *() {
	            //          [_super("a").value, _super("b").value] = yield ar;
	            //      });
	            //  }
	            //  ...
	            //
	            // This helper creates an object with a "value" property that wraps the `super` property or indexed access for both get and set.
	            // This is required for destructuring assignments, as a call expression cannot be used as the target of a destructuring assignment
	            // while a property access can.
	            if (container.kind === 153 /* MethodDeclaration */ && ts.hasModifier(container, 256 /* Async */)) {
	                if (ts.isSuperProperty(node.parent) && ts.isAssignmentTarget(node.parent)) {
	                    getNodeLinks(container).flags |= 4096 /* AsyncMethodWithSuperBinding */;
	                }
	                else {
	                    getNodeLinks(container).flags |= 2048 /* AsyncMethodWithSuper */;
	                }
	            }
	            if (needToCaptureLexicalThis) {
	                // call expressions are allowed only in constructors so they should always capture correct 'this'
	                // super property access expressions can also appear in arrow functions -
	                // in this case they should also use correct lexical this
	                captureLexicalThis(node.parent, container);
	            }
	            if (container.parent.kind === 182 /* ObjectLiteralExpression */) {
	                if (languageVersion < 2 /* ES2015 */) {
	                    error(node, ts.Diagnostics.super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_higher);
	                    return unknownType;
	                }
	                else {
	                    // for object literal assume that type of 'super' is 'any'
	                    return anyType;
	                }
	            }
	            // at this point the only legal case for parent is ClassLikeDeclaration
	            var classLikeDeclaration = container.parent;
	            if (!ts.getClassExtendsHeritageClauseElement(classLikeDeclaration)) {
	                error(node, ts.Diagnostics.super_can_only_be_referenced_in_a_derived_class);
	                return unknownType;
	            }
	            var classType = getDeclaredTypeOfSymbol(getSymbolOfNode(classLikeDeclaration));
	            var baseClassType = classType && getBaseTypes(classType)[0];
	            if (!baseClassType) {
	                return unknownType;
	            }
	            if (container.kind === 154 /* Constructor */ && isInConstructorArgumentInitializer(node, container)) {
	                // issue custom error message for super property access in constructor arguments (to be aligned with old compiler)
	                error(node, ts.Diagnostics.super_cannot_be_referenced_in_constructor_arguments);
	                return unknownType;
	            }
	            return nodeCheckFlag === 512 /* SuperStatic */
	                ? getBaseConstructorTypeOfClass(classType)
	                : getTypeWithThisArgument(baseClassType, classType.thisType);
	            function isLegalUsageOfSuperExpression(container) {
	                if (!container) {
	                    return false;
	                }
	                if (isCallExpression) {
	                    // TS 1.0 SPEC (April 2014): 4.8.1
	                    // Super calls are only permitted in constructors of derived classes
	                    return container.kind === 154 /* Constructor */;
	                }
	                else {
	                    // TS 1.0 SPEC (April 2014)
	                    // 'super' property access is allowed
	                    // - In a constructor, instance member function, instance member accessor, or instance member variable initializer where this references a derived class instance
	                    // - In a static member function or static member accessor
	                    // topmost container must be something that is directly nested in the class declaration\object literal expression
	                    if (ts.isClassLike(container.parent) || container.parent.kind === 182 /* ObjectLiteralExpression */) {
	                        if (ts.hasModifier(container, 32 /* Static */)) {
	                            return container.kind === 153 /* MethodDeclaration */ ||
	                                container.kind === 152 /* MethodSignature */ ||
	                                container.kind === 155 /* GetAccessor */ ||
	                                container.kind === 156 /* SetAccessor */;
	                        }
	                        else {
	                            return container.kind === 153 /* MethodDeclaration */ ||
	                                container.kind === 152 /* MethodSignature */ ||
	                                container.kind === 155 /* GetAccessor */ ||
	                                container.kind === 156 /* SetAccessor */ ||
	                                container.kind === 151 /* PropertyDeclaration */ ||
	                                container.kind === 150 /* PropertySignature */ ||
	                                container.kind === 154 /* Constructor */;
	                        }
	                    }
	                }
	                return false;
	            }
	        }
	        function getContainingObjectLiteral(func) {
	            return (func.kind === 153 /* MethodDeclaration */ ||
	                func.kind === 155 /* GetAccessor */ ||
	                func.kind === 156 /* SetAccessor */) && func.parent.kind === 182 /* ObjectLiteralExpression */ ? func.parent :
	                func.kind === 190 /* FunctionExpression */ && func.parent.kind === 268 /* PropertyAssignment */ ? func.parent.parent :
	                    undefined;
	        }
	        function getThisTypeArgument(type) {
	            return ts.getObjectFlags(type) & 4 /* Reference */ && type.target === globalThisType ? type.typeArguments[0] : undefined;
	        }
	        function getThisTypeFromContextualType(type) {
	            return mapType(type, function (t) {
	                return t.flags & 262144 /* Intersection */ ? ts.forEach(t.types, getThisTypeArgument) : getThisTypeArgument(t);
	            });
	        }
	        function getContextualThisParameterType(func) {
	            if (func.kind === 191 /* ArrowFunction */) {
	                return undefined;
	            }
	            if (isContextSensitiveFunctionOrObjectLiteralMethod(func)) {
	                var contextualSignature = getContextualSignature(func);
	                if (contextualSignature) {
	                    var thisParameter = contextualSignature.thisParameter;
	                    if (thisParameter) {
	                        return getTypeOfSymbol(thisParameter);
	                    }
	                }
	            }
	            var inJs = ts.isInJavaScriptFile(func);
	            if (noImplicitThis || inJs) {
	                var containingLiteral = getContainingObjectLiteral(func);
	                if (containingLiteral) {
	                    // We have an object literal method. Check if the containing object literal has a contextual type
	                    // that includes a ThisType<T>. If so, T is the contextual type for 'this'. We continue looking in
	                    // any directly enclosing object literals.
	                    var contextualType = getApparentTypeOfContextualType(containingLiteral);
	                    var literal = containingLiteral;
	                    var type = contextualType;
	                    while (type) {
	                        var thisType = getThisTypeFromContextualType(type);
	                        if (thisType) {
	                            return instantiateType(thisType, getContextualMapper(containingLiteral));
	                        }
	                        if (literal.parent.kind !== 268 /* PropertyAssignment */) {
	                            break;
	                        }
	                        literal = literal.parent.parent;
	                        type = getApparentTypeOfContextualType(literal);
	                    }
	                    // There was no contextual ThisType<T> for the containing object literal, so the contextual type
	                    // for 'this' is the non-null form of the contextual type for the containing object literal or
	                    // the type of the object literal itself.
	                    return contextualType ? getNonNullableType(contextualType) : checkExpressionCached(containingLiteral);
	                }
	                // In an assignment of the form 'obj.xxx = function(...)' or 'obj[xxx] = function(...)', the
	                // contextual type for 'this' is 'obj'.
	                var parent = func.parent;
	                if (parent.kind === 198 /* BinaryExpression */ && parent.operatorToken.kind === 58 /* EqualsToken */) {
	                    var target = parent.left;
	                    if (target.kind === 183 /* PropertyAccessExpression */ || target.kind === 184 /* ElementAccessExpression */) {
	                        var expression = target.expression;
	                        // Don't contextually type `this` as `exports` in `exports.Point = function(x, y) { this.x = x; this.y = y; }`
	                        if (inJs && ts.isIdentifier(expression)) {
	                            var sourceFile = ts.getSourceFileOfNode(parent);
	                            if (sourceFile.commonJsModuleIndicator && getResolvedSymbol(expression) === sourceFile.symbol) {
	                                return undefined;
	                            }
	                        }
	                        return checkExpressionCached(expression);
	                    }
	                }
	            }
	            return undefined;
	        }
	        // Return contextual type of parameter or undefined if no contextual type is available
	        function getContextuallyTypedParameterType(parameter) {
	            var func = parameter.parent;
	            if (isContextSensitiveFunctionOrObjectLiteralMethod(func)) {
	                var iife = ts.getImmediatelyInvokedFunctionExpression(func);
	                if (iife && iife.arguments) {
	                    var indexOfParameter = func.parameters.indexOf(parameter);
	                    if (parameter.dotDotDotToken) {
	                        var restTypes = [];
	                        for (var i = indexOfParameter; i < iife.arguments.length; i++) {
	                            restTypes.push(getWidenedLiteralType(checkExpression(iife.arguments[i])));
	                        }
	                        return restTypes.length ? createArrayType(getUnionType(restTypes)) : undefined;
	                    }
	                    var links = getNodeLinks(iife);
	                    var cached = links.resolvedSignature;
	                    links.resolvedSignature = anySignature;
	                    var type = indexOfParameter < iife.arguments.length ?
	                        getWidenedLiteralType(checkExpression(iife.arguments[indexOfParameter])) :
	                        parameter.initializer ? undefined : undefinedWideningType;
	                    links.resolvedSignature = cached;
	                    return type;
	                }
	                var contextualSignature = getContextualSignature(func);
	                if (contextualSignature) {
	                    var funcHasRestParameters = ts.hasRestParameter(func);
	                    var len = func.parameters.length - (funcHasRestParameters ? 1 : 0);
	                    var indexOfParameter = func.parameters.indexOf(parameter);
	                    if (ts.getThisParameter(func) !== undefined && !contextualSignature.thisParameter) {
	                        ts.Debug.assert(indexOfParameter !== 0); // Otherwise we should not have called `getContextuallyTypedParameterType`.
	                        indexOfParameter -= 1;
	                    }
	                    if (indexOfParameter < len) {
	                        return getTypeAtPosition(contextualSignature, indexOfParameter);
	                    }
	                    // If last parameter is contextually rest parameter get its type
	                    if (funcHasRestParameters &&
	                        indexOfParameter === (func.parameters.length - 1) &&
	                        isRestParameterIndex(contextualSignature, func.parameters.length - 1)) {
	                        return getTypeOfSymbol(ts.lastOrUndefined(contextualSignature.parameters));
	                    }
	                }
	            }
	            return undefined;
	        }
	        // In a variable, parameter or property declaration with a type annotation,
	        //   the contextual type of an initializer expression is the type of the variable, parameter or property.
	        // Otherwise, in a parameter declaration of a contextually typed function expression,
	        //   the contextual type of an initializer expression is the contextual type of the parameter.
	        // Otherwise, in a variable or parameter declaration with a binding pattern name,
	        //   the contextual type of an initializer expression is the type implied by the binding pattern.
	        // Otherwise, in a binding pattern inside a variable or parameter declaration,
	        //   the contextual type of an initializer expression is the type annotation of the containing declaration, if present.
	        function getContextualTypeForInitializerExpression(node) {
	            var declaration = node.parent;
	            if (ts.hasInitializer(declaration) && node === declaration.initializer) {
	                var typeNode = ts.getEffectiveTypeAnnotationNode(declaration);
	                if (typeNode) {
	                    return getTypeFromTypeNode(typeNode);
	                }
	                if (declaration.kind === 148 /* Parameter */) {
	                    var type = getContextuallyTypedParameterType(declaration);
	                    if (type) {
	                        return type;
	                    }
	                }
	                if (ts.isBindingPattern(declaration.name)) {
	                    return getTypeFromBindingPattern(declaration.name, /*includePatternInType*/ true, /*reportErrors*/ false);
	                }
	                if (ts.isBindingPattern(declaration.parent)) {
	                    var parentDeclaration = declaration.parent.parent;
	                    var name = declaration.propertyName || declaration.name;
	                    if (parentDeclaration.kind !== 180 /* BindingElement */) {
	                        var parentTypeNode = ts.getEffectiveTypeAnnotationNode(parentDeclaration);
	                        if (parentTypeNode && !ts.isBindingPattern(name)) {
	                            var text = ts.getTextOfPropertyName(name);
	                            if (text) {
	                                return getTypeOfPropertyOfType(getTypeFromTypeNode(parentTypeNode), text);
	                            }
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function getContextualTypeForReturnExpression(node) {
	            var func = ts.getContainingFunction(node);
	            if (func) {
	                var functionFlags = ts.getFunctionFlags(func);
	                if (functionFlags & 1 /* Generator */) {
	                    return undefined;
	                }
	                var contextualReturnType = getContextualReturnType(func);
	                return functionFlags & 2 /* Async */
	                    ? contextualReturnType && getAwaitedTypeOfPromise(contextualReturnType) // Async function
	                    : contextualReturnType; // Regular function
	            }
	            return undefined;
	        }
	        function getContextualTypeForYieldOperand(node) {
	            var func = ts.getContainingFunction(node);
	            if (func) {
	                var functionFlags = ts.getFunctionFlags(func);
	                var contextualReturnType = getContextualReturnType(func);
	                if (contextualReturnType) {
	                    return node.asteriskToken
	                        ? contextualReturnType
	                        : getIteratedTypeOfGenerator(contextualReturnType, (functionFlags & 2 /* Async */) !== 0);
	                }
	            }
	            return undefined;
	        }
	        function isInParameterInitializerBeforeContainingFunction(node) {
	            var inBindingInitializer = false;
	            while (node.parent && !ts.isFunctionLike(node.parent)) {
	                if (ts.isParameter(node.parent) && (inBindingInitializer || node.parent.initializer === node)) {
	                    return true;
	                }
	                if (ts.isBindingElement(node.parent) && node.parent.initializer === node) {
	                    inBindingInitializer = true;
	                }
	                node = node.parent;
	            }
	            return false;
	        }
	        function getContextualReturnType(functionDecl) {
	            // If the containing function has a return type annotation, is a constructor, or is a get accessor whose
	            // corresponding set accessor has a type annotation, return statements in the function are contextually typed
	            if (functionDecl.kind === 154 /* Constructor */ ||
	                ts.getEffectiveReturnTypeNode(functionDecl) ||
	                isGetAccessorWithAnnotatedSetAccessor(functionDecl)) {
	                return getReturnTypeOfSignature(getSignatureFromDeclaration(functionDecl));
	            }
	            // Otherwise, if the containing function is contextually typed by a function type with exactly one call signature
	            // and that call signature is non-generic, return statements are contextually typed by the return type of the signature
	            var signature = getContextualSignatureForFunctionLikeDeclaration(functionDecl);
	            if (signature && !isResolvingReturnTypeOfSignature(signature)) {
	                return getReturnTypeOfSignature(signature);
	            }
	            return undefined;
	        }
	        // In a typed function call, an argument or substitution expression is contextually typed by the type of the corresponding parameter.
	        function getContextualTypeForArgument(callTarget, arg) {
	            var args = getEffectiveCallArguments(callTarget);
	            var argIndex = args.indexOf(arg); // -1 for e.g. the expression of a CallExpression, or the tag of a TaggedTemplateExpression
	            return argIndex === -1 ? undefined : getContextualTypeForArgumentAtIndex(callTarget, argIndex);
	        }
	        function getContextualTypeForArgumentAtIndex(callTarget, argIndex) {
	            // If we're already in the process of resolving the given signature, don't resolve again as
	            // that could cause infinite recursion. Instead, return anySignature.
	            var signature = getNodeLinks(callTarget).resolvedSignature === resolvingSignature ? resolvingSignature : getResolvedSignature(callTarget);
	            return getTypeAtPosition(signature, argIndex);
	        }
	        function getContextualTypeForSubstitutionExpression(template, substitutionExpression) {
	            if (template.parent.kind === 187 /* TaggedTemplateExpression */) {
	                return getContextualTypeForArgument(template.parent, substitutionExpression);
	            }
	            return undefined;
	        }
	        function getContextualTypeForBinaryOperand(node) {
	            var binaryExpression = node.parent;
	            var left = binaryExpression.left, operatorToken = binaryExpression.operatorToken, right = binaryExpression.right;
	            switch (operatorToken.kind) {
	                case 58 /* EqualsToken */:
	                    return node === right && isContextSensitiveAssignment(binaryExpression) ? getTypeOfExpression(left) : undefined;
	                case 54 /* BarBarToken */:
	                    // When an || expression has a contextual type, the operands are contextually typed by that type. When an ||
	                    // expression has no contextual type, the right operand is contextually typed by the type of the left operand.
	                    var type = getContextualType(binaryExpression);
	                    return !type && node === right ? getTypeOfExpression(left, /*cache*/ true) : type;
	                case 53 /* AmpersandAmpersandToken */:
	                case 26 /* CommaToken */:
	                    return node === right ? getContextualType(binaryExpression) : undefined;
	                default:
	                    return undefined;
	            }
	        }
	        // In an assignment expression, the right operand is contextually typed by the type of the left operand.
	        // Don't do this for special property assignments to avoid circularity.
	        function isContextSensitiveAssignment(binaryExpression) {
	            var kind = ts.getSpecialPropertyAssignmentKind(binaryExpression);
	            switch (kind) {
	                case 0 /* None */:
	                    return true;
	                case 5 /* Property */:
	                    // If `binaryExpression.left` was assigned a symbol, then this is a new declaration; otherwise it is an assignment to an existing declaration.
	                    // See `bindStaticPropertyAssignment` in `binder.ts`.
	                    return !binaryExpression.left.symbol;
	                case 1 /* ExportsProperty */:
	                case 2 /* ModuleExports */:
	                case 3 /* PrototypeProperty */:
	                case 4 /* ThisProperty */:
	                    return false;
	                default:
	                    ts.Debug.assertNever(kind);
	            }
	        }
	        function getTypeOfPropertyOfContextualType(type, name) {
	            return mapType(type, function (t) {
	                var prop = t.flags & 458752 /* StructuredType */ ? getPropertyOfType(t, name) : undefined;
	                return prop ? getTypeOfSymbol(prop) : undefined;
	            }, /*noReductions*/ true);
	        }
	        function getIndexTypeOfContextualType(type, kind) {
	            return mapType(type, function (t) { return getIndexTypeOfStructuredType(t, kind); }, /*noReductions*/ true);
	        }
	        // Return true if the given contextual type is a tuple-like type
	        function contextualTypeIsTupleLikeType(type) {
	            return !!(type.flags & 131072 /* Union */ ? ts.forEach(type.types, isTupleLikeType) : isTupleLikeType(type));
	        }
	        // In an object literal contextually typed by a type T, the contextual type of a property assignment is the type of
	        // the matching property in T, if one exists. Otherwise, it is the type of the numeric index signature in T, if one
	        // exists. Otherwise, it is the type of the string index signature in T, if one exists.
	        function getContextualTypeForObjectLiteralMethod(node) {
	            ts.Debug.assert(ts.isObjectLiteralMethod(node));
	            if (node.flags & 4194304 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return undefined;
	            }
	            return getContextualTypeForObjectLiteralElement(node);
	        }
	        function getContextualTypeForObjectLiteralElement(element) {
	            var objectLiteral = element.parent;
	            var type = getApparentTypeOfContextualType(objectLiteral);
	            if (type) {
	                if (!hasNonBindableDynamicName(element)) {
	                    // For a (non-symbol) computed property, there is no reason to look up the name
	                    // in the type. It will just be "__computed", which does not appear in any
	                    // SymbolTable.
	                    var symbolName_1 = getSymbolOfNode(element).escapedName;
	                    var propertyType = getTypeOfPropertyOfContextualType(type, symbolName_1);
	                    if (propertyType) {
	                        return propertyType;
	                    }
	                }
	                return isNumericName(element.name) && getIndexTypeOfContextualType(type, 1 /* Number */) ||
	                    getIndexTypeOfContextualType(type, 0 /* String */);
	            }
	            return undefined;
	        }
	        // In an array literal contextually typed by a type T, the contextual type of an element expression at index N is
	        // the type of the property with the numeric name N in T, if one exists. Otherwise, if T has a numeric index signature,
	        // it is the type of the numeric index signature in T. Otherwise, in ES6 and higher, the contextual type is the iterated
	        // type of T.
	        function getContextualTypeForElementExpression(arrayContextualType, index) {
	            return arrayContextualType && (getTypeOfPropertyOfContextualType(arrayContextualType, "" + index)
	                || getIndexTypeOfContextualType(arrayContextualType, 1 /* Number */)
	                || getIteratedTypeOrElementType(arrayContextualType, /*errorNode*/ undefined, /*allowStringInput*/ false, /*allowAsyncIterables*/ false, /*checkAssignability*/ false));
	        }
	        // In a contextually typed conditional expression, the true/false expressions are contextually typed by the same type.
	        function getContextualTypeForConditionalOperand(node) {
	            var conditional = node.parent;
	            return node === conditional.whenTrue || node === conditional.whenFalse ? getContextualType(conditional) : undefined;
	        }
	        function getContextualTypeForChildJsxExpression(node) {
	            var attributesType = getApparentTypeOfContextualType(node.openingElement.tagName);
	            // JSX expression is in children of JSX Element, we will look for an "children" atttribute (we get the name from JSX.ElementAttributesProperty)
	            var jsxChildrenPropertyName = getJsxElementChildrenPropertyName();
	            return attributesType && !isTypeAny(attributesType) && jsxChildrenPropertyName && jsxChildrenPropertyName !== "" ? getTypeOfPropertyOfContextualType(attributesType, jsxChildrenPropertyName) : undefined;
	        }
	        function getContextualTypeForJsxExpression(node) {
	            var exprParent = node.parent;
	            return ts.isJsxAttributeLike(exprParent)
	                ? getContextualType(node)
	                : ts.isJsxElement(exprParent)
	                    ? getContextualTypeForChildJsxExpression(exprParent)
	                    : undefined;
	        }
	        function getContextualTypeForJsxAttribute(attribute) {
	            // When we trying to resolve JsxOpeningLikeElement as a stateless function element, we will already give its attributes a contextual type
	            // which is a type of the parameter of the signature we are trying out.
	            // If there is no contextual type (e.g. we are trying to resolve stateful component), get attributes type from resolving element's tagName
	            if (ts.isJsxAttribute(attribute)) {
	                var attributesType = getApparentTypeOfContextualType(attribute.parent);
	                if (!attributesType || isTypeAny(attributesType)) {
	                    return undefined;
	                }
	                return getTypeOfPropertyOfContextualType(attributesType, attribute.name.escapedText);
	            }
	            else {
	                return getContextualType(attribute.parent);
	            }
	        }
	        // Return the contextual type for a given expression node. During overload resolution, a contextual type may temporarily
	        // be "pushed" onto a node using the contextualType property.
	        function getApparentTypeOfContextualType(node) {
	            var contextualType = getContextualType(node);
	            contextualType = contextualType && mapType(contextualType, getApparentType);
	            if (!(contextualType && contextualType.flags & 131072 /* Union */ && ts.isObjectLiteralExpression(node))) {
	                return contextualType;
	            }
	            // Keep the below up-to-date with the work done within `isRelatedTo` by `findMatchingDiscriminantType`
	            var match;
	            propLoop: for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                var prop = _a[_i];
	                if (!prop.symbol)
	                    continue;
	                if (prop.kind !== 268 /* PropertyAssignment */)
	                    continue;
	                if (isDiscriminantProperty(contextualType, prop.symbol.escapedName)) {
	                    var discriminatingType = getTypeOfNode(prop.initializer);
	                    for (var _b = 0, _c = contextualType.types; _b < _c.length; _b++) {
	                        var type = _c[_b];
	                        var targetType = getTypeOfPropertyOfType(type, prop.symbol.escapedName);
	                        if (targetType && checkTypeAssignableTo(discriminatingType, targetType, /*errorNode*/ undefined)) {
	                            if (match) {
	                                if (type === match)
	                                    continue; // Finding multiple fields which discriminate to the same type is fine
	                                match = undefined;
	                                break propLoop;
	                            }
	                            match = type;
	                        }
	                    }
	                }
	            }
	            return match || contextualType;
	        }
	        /**
	         * Woah! Do you really want to use this function?
	         *
	         * Unless you're trying to get the *non-apparent* type for a
	         * value-literal type or you're authoring relevant portions of this algorithm,
	         * you probably meant to use 'getApparentTypeOfContextualType'.
	         * Otherwise this may not be very useful.
	         *
	         * In cases where you *are* working on this function, you should understand
	         * when it is appropriate to use 'getContextualType' and 'getApparentTypeOfContextualType'.
	         *
	         *   - Use 'getContextualType' when you are simply going to propagate the result to the expression.
	         *   - Use 'getApparentTypeOfContextualType' when you're going to need the members of the type.
	         *
	         * @param node the expression whose contextual type will be returned.
	         * @returns the contextual type of an expression.
	         */
	        function getContextualType(node) {
	            if (node.flags & 4194304 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return undefined;
	            }
	            if (node.contextualType) {
	                return node.contextualType;
	            }
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 230 /* VariableDeclaration */:
	                case 148 /* Parameter */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 180 /* BindingElement */:
	                    return getContextualTypeForInitializerExpression(node);
	                case 191 /* ArrowFunction */:
	                case 223 /* ReturnStatement */:
	                    return getContextualTypeForReturnExpression(node);
	                case 201 /* YieldExpression */:
	                    return getContextualTypeForYieldOperand(parent);
	                case 185 /* CallExpression */:
	                case 186 /* NewExpression */:
	                    return getContextualTypeForArgument(parent, node);
	                case 188 /* TypeAssertionExpression */:
	                case 206 /* AsExpression */:
	                    return getTypeFromTypeNode(parent.type);
	                case 198 /* BinaryExpression */:
	                    return getContextualTypeForBinaryOperand(node);
	                case 268 /* PropertyAssignment */:
	                case 269 /* ShorthandPropertyAssignment */:
	                    return getContextualTypeForObjectLiteralElement(parent);
	                case 270 /* SpreadAssignment */:
	                    return getApparentTypeOfContextualType(parent.parent);
	                case 181 /* ArrayLiteralExpression */: {
	                    var arrayLiteral = parent;
	                    var type = getApparentTypeOfContextualType(arrayLiteral);
	                    return getContextualTypeForElementExpression(type, ts.indexOfNode(arrayLiteral.elements, node));
	                }
	                case 199 /* ConditionalExpression */:
	                    return getContextualTypeForConditionalOperand(node);
	                case 209 /* TemplateSpan */:
	                    ts.Debug.assert(parent.parent.kind === 200 /* TemplateExpression */);
	                    return getContextualTypeForSubstitutionExpression(parent.parent, node);
	                case 189 /* ParenthesizedExpression */: {
	                    // Like in `checkParenthesizedExpression`, an `/** @type {xyz} */` comment before a parenthesized expression acts as a type cast.
	                    var tag = ts.isInJavaScriptFile(parent) ? ts.getJSDocTypeTag(parent) : undefined;
	                    return tag ? getTypeFromTypeNode(tag.typeExpression.type) : getContextualType(parent);
	                }
	                case 263 /* JsxExpression */:
	                    return getContextualTypeForJsxExpression(parent);
	                case 260 /* JsxAttribute */:
	                case 262 /* JsxSpreadAttribute */:
	                    return getContextualTypeForJsxAttribute(parent);
	                case 255 /* JsxOpeningElement */:
	                case 254 /* JsxSelfClosingElement */:
	                    return getContextualJsxElementAttributesType(parent);
	            }
	            return undefined;
	        }
	        function getContextualMapper(node) {
	            node = ts.findAncestor(node, function (n) { return !!n.contextualMapper; });
	            return node ? node.contextualMapper : identityMapper;
	        }
	        function getContextualJsxElementAttributesType(node) {
	            if (isJsxIntrinsicIdentifier(node.tagName)) {
	                return getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node);
	            }
	            var valueType = checkExpression(node.tagName);
	            if (isTypeAny(valueType)) {
	                // Short-circuit if the class tag is using an element type 'any'
	                return anyType;
	            }
	            var isJs = ts.isInJavaScriptFile(node);
	            return mapType(valueType, isJs ? getJsxSignaturesParameterTypesJs : getJsxSignaturesParameterTypes);
	        }
	        function getJsxSignaturesParameterTypes(valueType) {
	            return getJsxSignaturesParameterTypesInternal(valueType, /*isJs*/ false);
	        }
	        function getJsxSignaturesParameterTypesJs(valueType) {
	            return getJsxSignaturesParameterTypesInternal(valueType, /*isJs*/ true);
	        }
	        function getJsxSignaturesParameterTypesInternal(valueType, isJs) {
	            // If the elemType is a string type, we have to return anyType to prevent an error downstream as we will try to find construct or call signature of the type
	            if (valueType.flags & 2 /* String */) {
	                return anyType;
	            }
	            else if (valueType.flags & 32 /* StringLiteral */) {
	                // If the elemType is a stringLiteral type, we can then provide a check to make sure that the string literal type is one of the Jsx intrinsic element type
	                // For example:
	                //      var CustomTag: "h1" = "h1";
	                //      <CustomTag> Hello World </CustomTag>
	                var intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements);
	                if (intrinsicElementsType !== unknownType) {
	                    var stringLiteralTypeName = valueType.value;
	                    var intrinsicProp = getPropertyOfType(intrinsicElementsType, ts.escapeLeadingUnderscores(stringLiteralTypeName));
	                    if (intrinsicProp) {
	                        return getTypeOfSymbol(intrinsicProp);
	                    }
	                    var indexSignatureType = getIndexTypeOfType(intrinsicElementsType, 0 /* String */);
	                    if (indexSignatureType) {
	                        return indexSignatureType;
	                    }
	                }
	                return anyType;
	            }
	            // Resolve the signatures, preferring constructor
	            var signatures = getSignaturesOfType(valueType, 1 /* Construct */);
	            var ctor = true;
	            if (signatures.length === 0) {
	                // No construct signatures, try call signatures
	                signatures = getSignaturesOfType(valueType, 0 /* Call */);
	                ctor = false;
	                if (signatures.length === 0) {
	                    // We found no signatures at all, which is an error
	                    return unknownType;
	                }
	            }
	            return getUnionType(ts.map(signatures, ctor ? isJs ? getJsxPropsTypeFromConstructSignatureJs : getJsxPropsTypeFromConstructSignature : getJsxPropsTypeFromCallSignature), 0 /* None */);
	        }
	        function getJsxPropsTypeFromCallSignature(sig) {
	            var propsType = getTypeOfFirstParameterOfSignature(sig);
	            var intrinsicAttribs = getJsxType(JsxNames.IntrinsicAttributes);
	            if (intrinsicAttribs !== unknownType) {
	                propsType = intersectTypes(intrinsicAttribs, propsType);
	            }
	            return propsType;
	        }
	        function getJsxPropsTypeFromClassType(hostClassType, isJs) {
	            if (isTypeAny(hostClassType)) {
	                return hostClassType;
	            }
	            var propsName = getJsxElementPropertiesName();
	            if (propsName === undefined) {
	                // There is no type ElementAttributesProperty, return 'any'
	                return anyType;
	            }
	            else if (propsName === "") {
	                // If there is no e.g. 'props' member in ElementAttributesProperty, use the element class type instead
	                return hostClassType;
	            }
	            else {
	                var attributesType = getTypeOfPropertyOfType(hostClassType, propsName);
	                if (!attributesType) {
	                    // There is no property named 'props' on this instance type
	                    return emptyObjectType;
	                }
	                else if (isTypeAny(attributesType)) {
	                    // Props is of type 'any' or unknown
	                    return attributesType;
	                }
	                else {
	                    // Normal case -- add in IntrinsicClassElements<T> and IntrinsicElements
	                    var apparentAttributesType = attributesType;
	                    var intrinsicClassAttribs = getJsxType(JsxNames.IntrinsicClassAttributes);
	                    if (intrinsicClassAttribs !== unknownType) {
	                        var typeParams = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(intrinsicClassAttribs.symbol);
	                        apparentAttributesType = intersectTypes(typeParams
	                            ? createTypeReference(intrinsicClassAttribs, fillMissingTypeArguments([hostClassType], typeParams, getMinTypeArgumentCount(typeParams), isJs))
	                            : intrinsicClassAttribs, apparentAttributesType);
	                    }
	                    var intrinsicAttribs = getJsxType(JsxNames.IntrinsicAttributes);
	                    if (intrinsicAttribs !== unknownType) {
	                        apparentAttributesType = intersectTypes(intrinsicAttribs, apparentAttributesType);
	                    }
	                    return apparentAttributesType;
	                }
	            }
	        }
	        function getJsxPropsTypeFromConstructSignatureJs(sig) {
	            return getJsxPropsTypeFromConstructSignatureInternal(sig, /*isJs*/ true);
	        }
	        function getJsxPropsTypeFromConstructSignature(sig) {
	            return getJsxPropsTypeFromConstructSignatureInternal(sig, /*isJs*/ false);
	        }
	        function getJsxPropsTypeFromConstructSignatureInternal(sig, isJs) {
	            var hostClassType = getReturnTypeOfSignature(sig);
	            if (hostClassType) {
	                return getJsxPropsTypeFromClassType(hostClassType, isJs);
	            }
	            return getJsxPropsTypeFromCallSignature(sig);
	        }
	        // If the given type is an object or union type with a single signature, and if that signature has at
	        // least as many parameters as the given function, return the signature. Otherwise return undefined.
	        function getContextualCallSignature(type, node) {
	            var signatures = getSignaturesOfType(type, 0 /* Call */);
	            if (signatures.length === 1) {
	                var signature = signatures[0];
	                if (!isAritySmaller(signature, node)) {
	                    return signature;
	                }
	            }
	        }
	        /** If the contextual signature has fewer parameters than the function expression, do not use it */
	        function isAritySmaller(signature, target) {
	            var targetParameterCount = 0;
	            for (; targetParameterCount < target.parameters.length; targetParameterCount++) {
	                var param = target.parameters[targetParameterCount];
	                if (param.initializer || param.questionToken || param.dotDotDotToken || isJSDocOptionalParameter(param)) {
	                    break;
	                }
	            }
	            if (target.parameters.length && ts.parameterIsThisKeyword(target.parameters[0])) {
	                targetParameterCount--;
	            }
	            var sourceLength = signature.hasRestParameter ? Number.MAX_VALUE : signature.parameters.length;
	            return sourceLength < targetParameterCount;
	        }
	        function isFunctionExpressionOrArrowFunction(node) {
	            return node.kind === 190 /* FunctionExpression */ || node.kind === 191 /* ArrowFunction */;
	        }
	        function getContextualSignatureForFunctionLikeDeclaration(node) {
	            // Only function expressions, arrow functions, and object literal methods are contextually typed.
	            return isFunctionExpressionOrArrowFunction(node) || ts.isObjectLiteralMethod(node)
	                ? getContextualSignature(node)
	                : undefined;
	        }
	        function getContextualTypeForFunctionLikeDeclaration(node) {
	            return ts.isObjectLiteralMethod(node) ?
	                getContextualTypeForObjectLiteralMethod(node) :
	                getApparentTypeOfContextualType(node);
	        }
	        // Return the contextual signature for a given expression node. A contextual type provides a
	        // contextual signature if it has a single call signature and if that call signature is non-generic.
	        // If the contextual type is a union type, get the signature from each type possible and if they are
	        // all identical ignoring their return type, the result is same signature but with return type as
	        // union type of return types from these signatures
	        function getContextualSignature(node) {
	            ts.Debug.assert(node.kind !== 153 /* MethodDeclaration */ || ts.isObjectLiteralMethod(node));
	            var type = getContextualTypeForFunctionLikeDeclaration(node);
	            if (!type) {
	                return undefined;
	            }
	            if (!(type.flags & 131072 /* Union */)) {
	                return getContextualCallSignature(type, node);
	            }
	            var signatureList;
	            var types = type.types;
	            for (var _i = 0, types_15 = types; _i < types_15.length; _i++) {
	                var current = types_15[_i];
	                var signature = getContextualCallSignature(current, node);
	                if (signature) {
	                    if (!signatureList) {
	                        // This signature will contribute to contextual union signature
	                        signatureList = [signature];
	                    }
	                    else if (!compareSignaturesIdentical(signatureList[0], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ true, /*ignoreReturnTypes*/ true, compareTypesIdentical)) {
	                        // Signatures aren't identical, do not use
	                        return undefined;
	                    }
	                    else {
	                        // Use this signature for contextual union signature
	                        signatureList.push(signature);
	                    }
	                }
	            }
	            // Result is union of signatures collected (return type is union of return types of this signature set)
	            var result;
	            if (signatureList) {
	                result = cloneSignature(signatureList[0]);
	                result.unionSignatures = signatureList;
	            }
	            return result;
	        }
	        function checkSpreadExpression(node, checkMode) {
	            if (languageVersion < 2 /* ES2015 */ && compilerOptions.downlevelIteration) {
	                checkExternalEmitHelpers(node, 1536 /* SpreadIncludes */);
	            }
	            var arrayOrIterableType = checkExpression(node.expression, checkMode);
	            return checkIteratedTypeOrElementType(arrayOrIterableType, node.expression, /*allowStringInput*/ false, /*allowAsyncIterables*/ false);
	        }
	        function hasDefaultValue(node) {
	            return (node.kind === 180 /* BindingElement */ && !!node.initializer) ||
	                (node.kind === 198 /* BinaryExpression */ && node.operatorToken.kind === 58 /* EqualsToken */);
	        }
	        function checkArrayLiteral(node, checkMode) {
	            var elements = node.elements;
	            var hasSpreadElement = false;
	            var elementTypes = [];
	            var inDestructuringPattern = ts.isAssignmentTarget(node);
	            var contextualType = getApparentTypeOfContextualType(node);
	            for (var index = 0; index < elements.length; index++) {
	                var e = elements[index];
	                if (inDestructuringPattern && e.kind === 202 /* SpreadElement */) {
	                    // Given the following situation:
	                    //    var c: {};
	                    //    [...c] = ["", 0];
	                    //
	                    // c is represented in the tree as a spread element in an array literal.
	                    // But c really functions as a rest element, and its purpose is to provide
	                    // a contextual type for the right hand side of the assignment. Therefore,
	                    // instead of calling checkExpression on "...c", which will give an error
	                    // if c is not iterable/array-like, we need to act as if we are trying to
	                    // get the contextual element type from it. So we do something similar to
	                    // getContextualTypeForElementExpression, which will crucially not error
	                    // if there is no index type / iterated type.
	                    var restArrayType = checkExpression(e.expression, checkMode);
	                    var restElementType = getIndexTypeOfType(restArrayType, 1 /* Number */) ||
	                        getIteratedTypeOrElementType(restArrayType, /*errorNode*/ undefined, /*allowStringInput*/ false, /*allowAsyncIterables*/ false, /*checkAssignability*/ false);
	                    if (restElementType) {
	                        elementTypes.push(restElementType);
	                    }
	                }
	                else {
	                    var elementContextualType = getContextualTypeForElementExpression(contextualType, index);
	                    var type = checkExpressionForMutableLocation(e, checkMode, elementContextualType);
	                    elementTypes.push(type);
	                }
	                hasSpreadElement = hasSpreadElement || e.kind === 202 /* SpreadElement */;
	            }
	            if (!hasSpreadElement) {
	                // If array literal is actually a destructuring pattern, mark it as an implied type. We do this such
	                // that we get the same behavior for "var [x, y] = []" and "[x, y] = []".
	                if (inDestructuringPattern && elementTypes.length) {
	                    var type = cloneTypeReference(createTupleType(elementTypes));
	                    type.pattern = node;
	                    return type;
	                }
	                if (contextualType && contextualTypeIsTupleLikeType(contextualType)) {
	                    var pattern = contextualType.pattern;
	                    // If array literal is contextually typed by a binding pattern or an assignment pattern, pad the resulting
	                    // tuple type with the corresponding binding or assignment element types to make the lengths equal.
	                    if (pattern && (pattern.kind === 179 /* ArrayBindingPattern */ || pattern.kind === 181 /* ArrayLiteralExpression */)) {
	                        var patternElements = pattern.elements;
	                        for (var i = elementTypes.length; i < patternElements.length; i++) {
	                            var patternElement = patternElements[i];
	                            if (hasDefaultValue(patternElement)) {
	                                elementTypes.push(contextualType.typeArguments[i]);
	                            }
	                            else {
	                                if (patternElement.kind !== 204 /* OmittedExpression */) {
	                                    error(patternElement, ts.Diagnostics.Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value);
	                                }
	                                elementTypes.push(strictNullChecks ? implicitNeverType : undefinedWideningType);
	                            }
	                        }
	                    }
	                    if (elementTypes.length) {
	                        return createTupleType(elementTypes);
	                    }
	                }
	            }
	            return createArrayType(elementTypes.length ?
	                getUnionType(elementTypes, 2 /* Subtype */) :
	                strictNullChecks ? implicitNeverType : undefinedWideningType);
	        }
	        function isNumericName(name) {
	            switch (name.kind) {
	                case 146 /* ComputedPropertyName */:
	                    return isNumericComputedName(name);
	                case 71 /* Identifier */:
	                    return isNumericLiteralName(name.escapedText);
	                case 8 /* NumericLiteral */:
	                case 9 /* StringLiteral */:
	                    return isNumericLiteralName(name.text);
	                default:
	                    return false;
	            }
	        }
	        function isNumericComputedName(name) {
	            // It seems odd to consider an expression of type Any to result in a numeric name,
	            // but this behavior is consistent with checkIndexedAccess
	            return isTypeAssignableToKind(checkComputedPropertyName(name), 84 /* NumberLike */);
	        }
	        function isInfinityOrNaNString(name) {
	            return name === "Infinity" || name === "-Infinity" || name === "NaN";
	        }
	        function isNumericLiteralName(name) {
	            // The intent of numeric names is that
	            //     - they are names with text in a numeric form, and that
	            //     - setting properties/indexing with them is always equivalent to doing so with the numeric literal 'numLit',
	            //         acquired by applying the abstract 'ToNumber' operation on the name's text.
	            //
	            // The subtlety is in the latter portion, as we cannot reliably say that anything that looks like a numeric literal is a numeric name.
	            // In fact, it is the case that the text of the name must be equal to 'ToString(numLit)' for this to hold.
	            //
	            // Consider the property name '"0xF00D"'. When one indexes with '0xF00D', they are actually indexing with the value of 'ToString(0xF00D)'
	            // according to the ECMAScript specification, so it is actually as if the user indexed with the string '"61453"'.
	            // Thus, the text of all numeric literals equivalent to '61543' such as '0xF00D', '0xf00D', '0170015', etc. are not valid numeric names
	            // because their 'ToString' representation is not equal to their original text.
	            // This is motivated by ECMA-262 sections 9.3.1, 9.8.1, 11.1.5, and 11.2.1.
	            //
	            // Here, we test whether 'ToString(ToNumber(name))' is exactly equal to 'name'.
	            // The '+' prefix operator is equivalent here to applying the abstract ToNumber operation.
	            // Applying the 'toString()' method on a number gives us the abstract ToString operation on a number.
	            //
	            // Note that this accepts the values 'Infinity', '-Infinity', and 'NaN', and that this is intentional.
	            // This is desired behavior, because when indexing with them as numeric entities, you are indexing
	            // with the strings '"Infinity"', '"-Infinity"', and '"NaN"' respectively.
	            return (+name).toString() === name;
	        }
	        function checkComputedPropertyName(node) {
	            var links = getNodeLinks(node.expression);
	            if (!links.resolvedType) {
	                links.resolvedType = checkExpression(node.expression);
	                // This will allow types number, string, symbol or any. It will also allow enums, the unknown
	                // type, and any union of these types (like string | number).
	                if (links.resolvedType.flags & 12288 /* Nullable */ ||
	                    !isTypeAssignableToKind(links.resolvedType, 524322 /* StringLike */ | 84 /* NumberLike */ | 1536 /* ESSymbolLike */) &&
	                        !isTypeAssignableTo(links.resolvedType, getUnionType([stringType, numberType, esSymbolType]))) {
	                    error(node, ts.Diagnostics.A_computed_property_name_must_be_of_type_string_number_symbol_or_any);
	                }
	                else {
	                    checkThatExpressionIsProperSymbolReference(node.expression, links.resolvedType, /*reportError*/ true);
	                }
	            }
	            return links.resolvedType;
	        }
	        function getObjectLiteralIndexInfo(propertyNodes, offset, properties, kind) {
	            var propTypes = [];
	            for (var i = 0; i < properties.length; i++) {
	                if (kind === 0 /* String */ || isNumericName(propertyNodes[i + offset].name)) {
	                    propTypes.push(getTypeOfSymbol(properties[i]));
	                }
	            }
	            var unionType = propTypes.length ? getUnionType(propTypes, 2 /* Subtype */) : undefinedType;
	            return createIndexInfo(unionType, /*isReadonly*/ false);
	        }
	        function checkObjectLiteral(node, checkMode) {
	            var inDestructuringPattern = ts.isAssignmentTarget(node);
	            // Grammar checking
	            checkGrammarObjectLiteralExpression(node, inDestructuringPattern);
	            var propertiesTable = ts.createSymbolTable();
	            var propertiesArray = [];
	            var spread = emptyObjectType;
	            var propagatedFlags = 8388608 /* FreshLiteral */;
	            var contextualType = getApparentTypeOfContextualType(node);
	            var contextualTypeHasPattern = contextualType && contextualType.pattern &&
	                (contextualType.pattern.kind === 178 /* ObjectBindingPattern */ || contextualType.pattern.kind === 182 /* ObjectLiteralExpression */);
	            var isJSObjectLiteral = !contextualType && ts.isInJavaScriptFile(node);
	            var typeFlags = 0;
	            var patternWithComputedProperties = false;
	            var hasComputedStringProperty = false;
	            var hasComputedNumberProperty = false;
	            var isInJSFile = ts.isInJavaScriptFile(node);
	            var offset = 0;
	            for (var i = 0; i < node.properties.length; i++) {
	                var memberDecl = node.properties[i];
	                var member = getSymbolOfNode(memberDecl);
	                var literalName = void 0;
	                if (memberDecl.kind === 268 /* PropertyAssignment */ ||
	                    memberDecl.kind === 269 /* ShorthandPropertyAssignment */ ||
	                    ts.isObjectLiteralMethod(memberDecl)) {
	                    var jsdocType = void 0;
	                    if (isInJSFile) {
	                        jsdocType = getTypeForDeclarationFromJSDocComment(memberDecl);
	                    }
	                    var type = void 0;
	                    if (memberDecl.kind === 268 /* PropertyAssignment */) {
	                        if (memberDecl.name.kind === 146 /* ComputedPropertyName */) {
	                            var t = checkComputedPropertyName(memberDecl.name);
	                            if (t.flags & 224 /* Literal */) {
	                                literalName = ts.escapeLeadingUnderscores("" + t.value);
	                            }
	                        }
	                        type = checkPropertyAssignment(memberDecl, checkMode);
	                    }
	                    else if (memberDecl.kind === 153 /* MethodDeclaration */) {
	                        type = checkObjectLiteralMethod(memberDecl, checkMode);
	                    }
	                    else {
	                        ts.Debug.assert(memberDecl.kind === 269 /* ShorthandPropertyAssignment */);
	                        type = checkExpressionForMutableLocation(memberDecl.name, checkMode);
	                    }
	                    if (jsdocType) {
	                        checkTypeAssignableTo(type, jsdocType, memberDecl);
	                        type = jsdocType;
	                    }
	                    typeFlags |= type.flags;
	                    var nameType = hasLateBindableName(memberDecl) ? checkComputedPropertyName(memberDecl.name) : undefined;
	                    var prop = nameType && isTypeUsableAsLateBoundName(nameType)
	                        ? createSymbol(4 /* Property */ | member.flags, getLateBoundNameFromType(nameType), 1024 /* Late */)
	                        : createSymbol(4 /* Property */ | member.flags, literalName || member.escapedName);
	                    if (inDestructuringPattern) {
	                        // If object literal is an assignment pattern and if the assignment pattern specifies a default value
	                        // for the property, make the property optional.
	                        var isOptional = (memberDecl.kind === 268 /* PropertyAssignment */ && hasDefaultValue(memberDecl.initializer)) ||
	                            (memberDecl.kind === 269 /* ShorthandPropertyAssignment */ && memberDecl.objectAssignmentInitializer);
	                        if (isOptional) {
	                            prop.flags |= 16777216 /* Optional */;
	                        }
	                        if (!literalName && ts.hasDynamicName(memberDecl)) {
	                            patternWithComputedProperties = true;
	                        }
	                    }
	                    else if (contextualTypeHasPattern && !(ts.getObjectFlags(contextualType) & 512 /* ObjectLiteralPatternWithComputedProperties */)) {
	                        // If object literal is contextually typed by the implied type of a binding pattern, and if the
	                        // binding pattern specifies a default value for the property, make the property optional.
	                        var impliedProp = getPropertyOfType(contextualType, member.escapedName);
	                        if (impliedProp) {
	                            prop.flags |= impliedProp.flags & 16777216 /* Optional */;
	                        }
	                        else if (!compilerOptions.suppressExcessPropertyErrors && !getIndexInfoOfType(contextualType, 0 /* String */)) {
	                            error(memberDecl.name, ts.Diagnostics.Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1, symbolToString(member), typeToString(contextualType));
	                        }
	                    }
	                    prop.declarations = member.declarations;
	                    prop.parent = member.parent;
	                    if (member.valueDeclaration) {
	                        prop.valueDeclaration = member.valueDeclaration;
	                    }
	                    prop.type = type;
	                    prop.target = member;
	                    member = prop;
	                }
	                else if (memberDecl.kind === 270 /* SpreadAssignment */) {
	                    if (languageVersion < 2 /* ES2015 */) {
	                        checkExternalEmitHelpers(memberDecl, 2 /* Assign */);
	                    }
	                    if (propertiesArray.length > 0) {
	                        spread = getSpreadType(spread, createObjectLiteralType(), node.symbol, propagatedFlags, /*objectFlags*/ 0);
	                        propertiesArray = [];
	                        propertiesTable = ts.createSymbolTable();
	                        hasComputedStringProperty = false;
	                        hasComputedNumberProperty = false;
	                        typeFlags = 0;
	                    }
	                    var type = checkExpression(memberDecl.expression);
	                    if (!isValidSpreadType(type)) {
	                        error(memberDecl, ts.Diagnostics.Spread_types_may_only_be_created_from_object_types);
	                        return unknownType;
	                    }
	                    spread = getSpreadType(spread, type, node.symbol, propagatedFlags, /*objectFlags*/ 0);
	                    offset = i + 1;
	                    continue;
	                }
	                else {
	                    // TypeScript 1.0 spec (April 2014)
	                    // A get accessor declaration is processed in the same manner as
	                    // an ordinary function declaration(section 6.1) with no parameters.
	                    // A set accessor declaration is processed in the same manner
	                    // as an ordinary function declaration with a single parameter and a Void return type.
	                    ts.Debug.assert(memberDecl.kind === 155 /* GetAccessor */ || memberDecl.kind === 156 /* SetAccessor */);
	                    checkNodeDeferred(memberDecl);
	                }
	                if (!literalName && hasNonBindableDynamicName(memberDecl)) {
	                    if (isNumericName(memberDecl.name)) {
	                        hasComputedNumberProperty = true;
	                    }
	                    else {
	                        hasComputedStringProperty = true;
	                    }
	                }
	                else {
	                    propertiesTable.set(member.escapedName, member);
	                }
	                propertiesArray.push(member);
	            }
	            // If object literal is contextually typed by the implied type of a binding pattern, augment the result
	            // type with those properties for which the binding pattern specifies a default value.
	            if (contextualTypeHasPattern) {
	                for (var _i = 0, _a = getPropertiesOfType(contextualType); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (!propertiesTable.get(prop.escapedName) && !(spread && getPropertyOfType(spread, prop.escapedName))) {
	                        if (!(prop.flags & 16777216 /* Optional */)) {
	                            error(prop.valueDeclaration || prop.bindingElement, ts.Diagnostics.Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value);
	                        }
	                        propertiesTable.set(prop.escapedName, prop);
	                        propertiesArray.push(prop);
	                    }
	                }
	            }
	            if (spread !== emptyObjectType) {
	                if (propertiesArray.length > 0) {
	                    spread = getSpreadType(spread, createObjectLiteralType(), node.symbol, propagatedFlags, /*objectFlags*/ 0);
	                }
	                return spread;
	            }
	            return createObjectLiteralType();
	            function createObjectLiteralType() {
	                var stringIndexInfo = isJSObjectLiteral ? jsObjectLiteralIndexInfo : hasComputedStringProperty ? getObjectLiteralIndexInfo(node.properties, offset, propertiesArray, 0 /* String */) : undefined;
	                var numberIndexInfo = hasComputedNumberProperty && !isJSObjectLiteral ? getObjectLiteralIndexInfo(node.properties, offset, propertiesArray, 1 /* Number */) : undefined;
	                var result = createAnonymousType(node.symbol, propertiesTable, ts.emptyArray, ts.emptyArray, stringIndexInfo, numberIndexInfo);
	                var freshObjectLiteralFlag = compilerOptions.suppressExcessPropertyErrors ? 0 : 8388608 /* FreshLiteral */;
	                result.flags |= 33554432 /* ContainsObjectLiteral */ | freshObjectLiteralFlag | (typeFlags & 117440512 /* PropagatingFlags */);
	                result.objectFlags |= 128 /* ObjectLiteral */;
	                if (patternWithComputedProperties) {
	                    result.objectFlags |= 512 /* ObjectLiteralPatternWithComputedProperties */;
	                }
	                if (inDestructuringPattern) {
	                    result.pattern = node;
	                }
	                if (!(result.flags & 12288 /* Nullable */)) {
	                    propagatedFlags |= (result.flags & 117440512 /* PropagatingFlags */);
	                }
	                return result;
	            }
	        }
	        function isValidSpreadType(type) {
	            return !!(type.flags & (1 /* Any */ | 134217728 /* NonPrimitive */) ||
	                getFalsyFlags(type) & 14560 /* DefinitelyFalsy */ && isValidSpreadType(removeDefinitelyFalsyTypes(type)) ||
	                type.flags & 65536 /* Object */ && !isGenericMappedType(type) ||
	                type.flags & 393216 /* UnionOrIntersection */ && !ts.forEach(type.types, function (t) { return !isValidSpreadType(t); }));
	        }
	        function checkJsxSelfClosingElement(node, checkMode) {
	            checkJsxOpeningLikeElementOrOpeningFragment(node, checkMode);
	            return getJsxGlobalElementType() || anyType;
	        }
	        function checkJsxElement(node, checkMode) {
	            // Check attributes
	            checkJsxOpeningLikeElementOrOpeningFragment(node.openingElement, checkMode);
	            // Perform resolution on the closing tag so that rename/go to definition/etc work
	            if (isJsxIntrinsicIdentifier(node.closingElement.tagName)) {
	                getIntrinsicTagSymbol(node.closingElement);
	            }
	            else {
	                checkExpression(node.closingElement.tagName);
	            }
	            return getJsxGlobalElementType() || anyType;
	        }
	        function checkJsxFragment(node, checkMode) {
	            checkJsxOpeningLikeElementOrOpeningFragment(node.openingFragment, checkMode);
	            if (compilerOptions.jsx === 2 /* React */ && compilerOptions.jsxFactory) {
	                error(node, ts.Diagnostics.JSX_fragment_is_not_supported_when_using_jsxFactory);
	            }
	            return getJsxGlobalElementType() || anyType;
	        }
	        /**
	         * Returns true iff the JSX element name would be a valid JS identifier, ignoring restrictions about keywords not being identifiers
	         */
	        function isUnhyphenatedJsxName(name) {
	            // - is the only character supported in JSX attribute names that isn't valid in JavaScript identifiers
	            return !ts.stringContains(name, "-");
	        }
	        /**
	         * Returns true iff React would emit this tag name as a string rather than an identifier or qualified name
	         */
	        function isJsxIntrinsicIdentifier(tagName) {
	            // TODO (yuisu): comment
	            switch (tagName.kind) {
	                case 183 /* PropertyAccessExpression */:
	                case 99 /* ThisKeyword */:
	                    return false;
	                case 71 /* Identifier */:
	                    return ts.isIntrinsicJsxName(tagName.escapedText);
	                default:
	                    ts.Debug.fail();
	            }
	        }
	        function checkJsxAttribute(node, checkMode) {
	            return node.initializer
	                ? checkExpressionForMutableLocation(node.initializer, checkMode)
	                : trueType; // <Elem attr /> is sugar for <Elem attr={true} />
	        }
	        /**
	         * Get attributes type of the JSX opening-like element. The result is from resolving "attributes" property of the opening-like element.
	         *
	         * @param openingLikeElement a JSX opening-like element
	         * @param filter a function to remove attributes that will not participate in checking whether attributes are assignable
	         * @return an anonymous type (similar to the one returned by checkObjectLiteral) in which its properties are attributes property.
	         * @remarks Because this function calls getSpreadType, it needs to use the same checks as checkObjectLiteral,
	         * which also calls getSpreadType.
	         */
	        function createJsxAttributesTypeFromAttributesProperty(openingLikeElement, checkMode) {
	            var attributes = openingLikeElement.attributes;
	            var attributesTable = ts.createSymbolTable();
	            var spread = emptyObjectType;
	            var hasSpreadAnyType = false;
	            var typeToIntersect;
	            var explicitlySpecifyChildrenAttribute = false;
	            var jsxChildrenPropertyName = getJsxElementChildrenPropertyName();
	            for (var _i = 0, _a = attributes.properties; _i < _a.length; _i++) {
	                var attributeDecl = _a[_i];
	                var member = attributeDecl.symbol;
	                if (ts.isJsxAttribute(attributeDecl)) {
	                    var exprType = checkJsxAttribute(attributeDecl, checkMode);
	                    var attributeSymbol = createSymbol(4 /* Property */ | 33554432 /* Transient */ | member.flags, member.escapedName);
	                    attributeSymbol.declarations = member.declarations;
	                    attributeSymbol.parent = member.parent;
	                    if (member.valueDeclaration) {
	                        attributeSymbol.valueDeclaration = member.valueDeclaration;
	                    }
	                    attributeSymbol.type = exprType;
	                    attributeSymbol.target = member;
	                    attributesTable.set(attributeSymbol.escapedName, attributeSymbol);
	                    if (attributeDecl.name.escapedText === jsxChildrenPropertyName) {
	                        explicitlySpecifyChildrenAttribute = true;
	                    }
	                }
	                else {
	                    ts.Debug.assert(attributeDecl.kind === 262 /* JsxSpreadAttribute */);
	                    if (attributesTable.size > 0) {
	                        spread = getSpreadType(spread, createJsxAttributesType(), attributes.symbol, /*typeFlags*/ 0, 4096 /* JsxAttributes */);
	                        attributesTable = ts.createSymbolTable();
	                    }
	                    var exprType = checkExpressionCached(attributeDecl.expression, checkMode);
	                    if (isTypeAny(exprType)) {
	                        hasSpreadAnyType = true;
	                    }
	                    if (isValidSpreadType(exprType)) {
	                        spread = getSpreadType(spread, exprType, openingLikeElement.symbol, /*typeFlags*/ 0, 4096 /* JsxAttributes */);
	                    }
	                    else {
	                        typeToIntersect = typeToIntersect ? getIntersectionType([typeToIntersect, exprType]) : exprType;
	                    }
	                }
	            }
	            if (!hasSpreadAnyType) {
	                if (attributesTable.size > 0) {
	                    spread = getSpreadType(spread, createJsxAttributesType(), attributes.symbol, /*typeFlags*/ 0, 4096 /* JsxAttributes */);
	                }
	            }
	            // Handle children attribute
	            var parent = openingLikeElement.parent.kind === 253 /* JsxElement */ ? openingLikeElement.parent : undefined;
	            // We have to check that openingElement of the parent is the one we are visiting as this may not be true for selfClosingElement
	            if (parent && parent.openingElement === openingLikeElement && parent.children.length > 0) {
	                var childrenTypes = checkJsxChildren(parent, checkMode);
	                if (!hasSpreadAnyType && jsxChildrenPropertyName && jsxChildrenPropertyName !== "") {
	                    // Error if there is a attribute named "children" explicitly specified and children element.
	                    // This is because children element will overwrite the value from attributes.
	                    // Note: we will not warn "children" attribute overwritten if "children" attribute is specified in object spread.
	                    if (explicitlySpecifyChildrenAttribute) {
	                        error(attributes, ts.Diagnostics._0_are_specified_twice_The_attribute_named_0_will_be_overwritten, ts.unescapeLeadingUnderscores(jsxChildrenPropertyName));
	                    }
	                    // If there are children in the body of JSX element, create dummy attribute "children" with the union of children types so that it will pass the attribute checking process
	                    var childrenPropSymbol = createSymbol(4 /* Property */ | 33554432 /* Transient */, jsxChildrenPropertyName);
	                    childrenPropSymbol.type = childrenTypes.length === 1 ?
	                        childrenTypes[0] :
	                        createArrayType(getUnionType(childrenTypes));
	                    var childPropMap = ts.createSymbolTable();
	                    childPropMap.set(jsxChildrenPropertyName, childrenPropSymbol);
	                    spread = getSpreadType(spread, createAnonymousType(attributes.symbol, childPropMap, ts.emptyArray, ts.emptyArray, /*stringIndexInfo*/ undefined, /*numberIndexInfo*/ undefined), attributes.symbol, /*typeFlags*/ 0, 4096 /* JsxAttributes */);
	                }
	            }
	            if (hasSpreadAnyType) {
	                return anyType;
	            }
	            return typeToIntersect && spread !== emptyObjectType ? getIntersectionType([typeToIntersect, spread]) : (typeToIntersect || spread);
	            /**
	             * Create anonymous type from given attributes symbol table.
	             * @param symbol a symbol of JsxAttributes containing attributes corresponding to attributesTable
	             * @param attributesTable a symbol table of attributes property
	             */
	            function createJsxAttributesType() {
	                var result = createAnonymousType(attributes.symbol, attributesTable, ts.emptyArray, ts.emptyArray, /*stringIndexInfo*/ undefined, /*numberIndexInfo*/ undefined);
	                result.flags |= 33554432 /* ContainsObjectLiteral */;
	                result.objectFlags |= 128 /* ObjectLiteral */ | 4096 /* JsxAttributes */;
	                return result;
	            }
	        }
	        function checkJsxChildren(node, checkMode) {
	            var childrenTypes = [];
	            for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
	                var child = _a[_i];
	                // In React, JSX text that contains only whitespaces will be ignored so we don't want to type-check that
	                // because then type of children property will have constituent of string type.
	                if (child.kind === 10 /* JsxText */) {
	                    if (!child.containsOnlyWhiteSpaces) {
	                        childrenTypes.push(stringType);
	                    }
	                }
	                else {
	                    childrenTypes.push(checkExpressionForMutableLocation(child, checkMode));
	                }
	            }
	            return childrenTypes;
	        }
	        /**
	         * Check attributes property of opening-like element. This function is called during chooseOverload to get call signature of a JSX opening-like element.
	         * (See "checkApplicableSignatureForJsxOpeningLikeElement" for how the function is used)
	         * @param node a JSXAttributes to be resolved of its type
	         */
	        function checkJsxAttributes(node, checkMode) {
	            return createJsxAttributesTypeFromAttributesProperty(node.parent, checkMode);
	        }
	        function getJsxType(name) {
	            var jsxType = jsxTypes.get(name);
	            if (jsxType === undefined) {
	                jsxTypes.set(name, jsxType = getExportedTypeFromNamespace(JsxNames.JSX, name) || unknownType);
	            }
	            return jsxType;
	        }
	        /**
	         * Looks up an intrinsic tag name and returns a symbol that either points to an intrinsic
	         * property (in which case nodeLinks.jsxFlags will be IntrinsicNamedElement) or an intrinsic
	         * string index signature (in which case nodeLinks.jsxFlags will be IntrinsicIndexedElement).
	         * May also return unknownSymbol if both of these lookups fail.
	         */
	        function getIntrinsicTagSymbol(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedSymbol) {
	                var intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements);
	                if (intrinsicElementsType !== unknownType) {
	                    // Property case
	                    if (!ts.isIdentifier(node.tagName))
	                        throw ts.Debug.fail();
	                    var intrinsicProp = getPropertyOfType(intrinsicElementsType, node.tagName.escapedText);
	                    if (intrinsicProp) {
	                        links.jsxFlags |= 1 /* IntrinsicNamedElement */;
	                        return links.resolvedSymbol = intrinsicProp;
	                    }
	                    // Intrinsic string indexer case
	                    var indexSignatureType = getIndexTypeOfType(intrinsicElementsType, 0 /* String */);
	                    if (indexSignatureType) {
	                        links.jsxFlags |= 2 /* IntrinsicIndexedElement */;
	                        return links.resolvedSymbol = intrinsicElementsType.symbol;
	                    }
	                    // Wasn't found
	                    error(node, ts.Diagnostics.Property_0_does_not_exist_on_type_1, ts.idText(node.tagName), "JSX." + JsxNames.IntrinsicElements);
	                    return links.resolvedSymbol = unknownSymbol;
	                }
	                else {
	                    if (noImplicitAny) {
	                        error(node, ts.Diagnostics.JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists, ts.unescapeLeadingUnderscores(JsxNames.IntrinsicElements));
	                    }
	                    return links.resolvedSymbol = unknownSymbol;
	                }
	            }
	            return links.resolvedSymbol;
	        }
	        /**
	         * Given a JSX element that is a class element, finds the Element Instance Type. If the
	         * element is not a class element, or the class element type cannot be determined, returns 'undefined'.
	         * For example, in the element <MyClass>, the element instance type is `MyClass` (not `typeof MyClass`).
	         */
	        function getJsxElementInstanceType(node, valueType) {
	            ts.Debug.assert(!(valueType.flags & 131072 /* Union */));
	            if (isTypeAny(valueType)) {
	                // Short-circuit if the class tag is using an element type 'any'
	                return anyType;
	            }
	            // Resolve the signatures, preferring constructor
	            var signatures = getSignaturesOfType(valueType, 1 /* Construct */);
	            if (signatures.length === 0) {
	                // No construct signatures, try call signatures
	                signatures = getSignaturesOfType(valueType, 0 /* Call */);
	                if (signatures.length === 0) {
	                    // We found no signatures at all, which is an error
	                    error(node.tagName, ts.Diagnostics.JSX_element_type_0_does_not_have_any_construct_or_call_signatures, ts.getTextOfNode(node.tagName));
	                    return unknownType;
	                }
	            }
	            // Instantiate in context of source type
	            var instantiatedSignatures = [];
	            for (var _i = 0, signatures_3 = signatures; _i < signatures_3.length; _i++) {
	                var signature = signatures_3[_i];
	                if (signature.typeParameters) {
	                    var isJavascript = ts.isInJavaScriptFile(node);
	                    var inferenceContext = createInferenceContext(signature, /*flags*/ isJavascript ? 4 /* AnyDefault */ : 0 /* None */);
	                    var typeArguments = inferJsxTypeArguments(signature, node, inferenceContext);
	                    instantiatedSignatures.push(getSignatureInstantiation(signature, typeArguments, isJavascript));
	                }
	                else {
	                    instantiatedSignatures.push(signature);
	                }
	            }
	            return getUnionType(ts.map(instantiatedSignatures, getReturnTypeOfSignature), 2 /* Subtype */);
	        }
	        /**
	         * Look into JSX namespace and then look for container with matching name as nameOfAttribPropContainer.
	         * Get a single property from that container if existed. Report an error if there are more than one property.
	         *
	         * @param nameOfAttribPropContainer a string of value JsxNames.ElementAttributesPropertyNameContainer or JsxNames.ElementChildrenAttributeNameContainer
	         *          if other string is given or the container doesn't exist, return undefined.
	         */
	        function getNameFromJsxElementAttributesContainer(nameOfAttribPropContainer) {
	            // JSX
	            var jsxNamespace = getGlobalSymbol(JsxNames.JSX, 1920 /* Namespace */, /*diagnosticMessage*/ undefined);
	            // JSX.ElementAttributesProperty | JSX.ElementChildrenAttribute [symbol]
	            var jsxElementAttribPropInterfaceSym = jsxNamespace && getSymbol(jsxNamespace.exports, nameOfAttribPropContainer, 793064 /* Type */);
	            // JSX.ElementAttributesProperty | JSX.ElementChildrenAttribute [type]
	            var jsxElementAttribPropInterfaceType = jsxElementAttribPropInterfaceSym && getDeclaredTypeOfSymbol(jsxElementAttribPropInterfaceSym);
	            // The properties of JSX.ElementAttributesProperty | JSX.ElementChildrenAttribute
	            var propertiesOfJsxElementAttribPropInterface = jsxElementAttribPropInterfaceType && getPropertiesOfType(jsxElementAttribPropInterfaceType);
	            if (propertiesOfJsxElementAttribPropInterface) {
	                // Element Attributes has zero properties, so the element attributes type will be the class instance type
	                if (propertiesOfJsxElementAttribPropInterface.length === 0) {
	                    return "";
	                }
	                else if (propertiesOfJsxElementAttribPropInterface.length === 1) {
	                    return propertiesOfJsxElementAttribPropInterface[0].escapedName;
	                }
	                else if (propertiesOfJsxElementAttribPropInterface.length > 1) {
	                    // More than one property on ElementAttributesProperty is an error
	                    error(jsxElementAttribPropInterfaceSym.declarations[0], ts.Diagnostics.The_global_type_JSX_0_may_not_have_more_than_one_property, ts.unescapeLeadingUnderscores(nameOfAttribPropContainer));
	                }
	            }
	            return undefined;
	        }
	        /// e.g. "props" for React.d.ts,
	        /// or 'undefined' if ElementAttributesProperty doesn't exist (which means all
	        ///     non-intrinsic elements' attributes type is 'any'),
	        /// or '' if it has 0 properties (which means every
	        ///     non-intrinsic elements' attributes type is the element instance type)
	        function getJsxElementPropertiesName() {
	            if (!_hasComputedJsxElementPropertiesName) {
	                _hasComputedJsxElementPropertiesName = true;
	                _jsxElementPropertiesName = getNameFromJsxElementAttributesContainer(JsxNames.ElementAttributesPropertyNameContainer);
	            }
	            return _jsxElementPropertiesName;
	        }
	        function getJsxElementChildrenPropertyName() {
	            if (!_hasComputedJsxElementChildrenPropertyName) {
	                _hasComputedJsxElementChildrenPropertyName = true;
	                _jsxElementChildrenPropertyName = getNameFromJsxElementAttributesContainer(JsxNames.ElementChildrenAttributeNameContainer);
	            }
	            return _jsxElementChildrenPropertyName;
	        }
	        function getApparentTypeOfJsxPropsType(propsType) {
	            if (!propsType) {
	                return undefined;
	            }
	            if (propsType.flags & 262144 /* Intersection */) {
	                var propsApparentType = [];
	                for (var _i = 0, _a = propsType.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    propsApparentType.push(getApparentType(t));
	                }
	                return getIntersectionType(propsApparentType);
	            }
	            return getApparentType(propsType);
	        }
	        /**
	         * Get JSX attributes type by trying to resolve openingLikeElement as a stateless function component.
	         * Return only attributes type of successfully resolved call signature.
	         * This function assumes that the caller handled other possible element type of the JSX element (e.g. stateful component)
	         * Unlike tryGetAllJsxStatelessFunctionAttributesType, this function is a default behavior of type-checkers.
	         * @param openingLikeElement a JSX opening-like element to find attributes type
	         * @param elementType a type of the opening-like element. This elementType can't be an union type
	         * @param elemInstanceType an element instance type (the result of newing or invoking this tag)
	         * @param elementClassType a JSX-ElementClass type. This is a result of looking up ElementClass interface in the JSX global
	         */
	        function defaultTryGetJsxStatelessFunctionAttributesType(openingLikeElement, elementType, elemInstanceType, elementClassType) {
	            ts.Debug.assert(!(elementType.flags & 131072 /* Union */));
	            if (!elementClassType || !isTypeAssignableTo(elemInstanceType, elementClassType)) {
	                var jsxStatelessElementType = getJsxGlobalStatelessElementType();
	                if (jsxStatelessElementType) {
	                    // We don't call getResolvedSignature here because we have already resolve the type of JSX Element.
	                    var callSignature = getResolvedJsxStatelessFunctionSignature(openingLikeElement, elementType, /*candidatesOutArray*/ undefined);
	                    if (callSignature !== unknownSignature) {
	                        var callReturnType = callSignature && getReturnTypeOfSignature(callSignature);
	                        var paramType = callReturnType && (callSignature.parameters.length === 0 ? emptyObjectType : getTypeOfSymbol(callSignature.parameters[0]));
	                        paramType = getApparentTypeOfJsxPropsType(paramType);
	                        if (callReturnType && isTypeAssignableTo(callReturnType, jsxStatelessElementType)) {
	                            // Intersect in JSX.IntrinsicAttributes if it exists
	                            var intrinsicAttributes = getJsxType(JsxNames.IntrinsicAttributes);
	                            if (intrinsicAttributes !== unknownType) {
	                                paramType = intersectTypes(intrinsicAttributes, paramType);
	                            }
	                            return paramType;
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        /**
	         * Get JSX attributes type by trying to resolve openingLikeElement as a stateless function component.
	         * Return all attributes type of resolved call signature including candidate signatures.
	         * This function assumes that the caller handled other possible element type of the JSX element.
	         * This function is a behavior used by language service when looking up completion in JSX element.
	         * @param openingLikeElement a JSX opening-like element to find attributes type
	         * @param elementType a type of the opening-like element. This elementType can't be an union type
	         * @param elemInstanceType an element instance type (the result of newing or invoking this tag)
	         * @param elementClassType a JSX-ElementClass type. This is a result of looking up ElementClass interface in the JSX global
	         */
	        function tryGetAllJsxStatelessFunctionAttributesType(openingLikeElement, elementType, elemInstanceType, elementClassType) {
	            ts.Debug.assert(!(elementType.flags & 131072 /* Union */));
	            if (!elementClassType || !isTypeAssignableTo(elemInstanceType, elementClassType)) {
	                // Is this is a stateless function component? See if its single signature's return type is assignable to the JSX Element Type
	                var jsxStatelessElementType = getJsxGlobalStatelessElementType();
	                if (jsxStatelessElementType) {
	                    // We don't call getResolvedSignature because here we have already resolve the type of JSX Element.
	                    var candidatesOutArray = [];
	                    getResolvedJsxStatelessFunctionSignature(openingLikeElement, elementType, candidatesOutArray);
	                    var result = void 0;
	                    var allMatchingAttributesType = void 0;
	                    for (var _i = 0, candidatesOutArray_1 = candidatesOutArray; _i < candidatesOutArray_1.length; _i++) {
	                        var candidate = candidatesOutArray_1[_i];
	                        var callReturnType = getReturnTypeOfSignature(candidate);
	                        var paramType = callReturnType && (candidate.parameters.length === 0 ? emptyObjectType : getTypeOfSymbol(candidate.parameters[0]));
	                        paramType = getApparentTypeOfJsxPropsType(paramType);
	                        if (callReturnType && isTypeAssignableTo(callReturnType, jsxStatelessElementType)) {
	                            var shouldBeCandidate = true;
	                            for (var _a = 0, _b = openingLikeElement.attributes.properties; _a < _b.length; _a++) {
	                                var attribute = _b[_a];
	                                if (ts.isJsxAttribute(attribute) &&
	                                    isUnhyphenatedJsxName(attribute.name.escapedText) &&
	                                    !getPropertyOfType(paramType, attribute.name.escapedText)) {
	                                    shouldBeCandidate = false;
	                                    break;
	                                }
	                            }
	                            if (shouldBeCandidate) {
	                                result = intersectTypes(result, paramType);
	                            }
	                            allMatchingAttributesType = intersectTypes(allMatchingAttributesType, paramType);
	                        }
	                    }
	                    // If we can't find any matching, just return everything.
	                    if (!result) {
	                        result = allMatchingAttributesType;
	                    }
	                    // Intersect in JSX.IntrinsicAttributes if it exists
	                    var intrinsicAttributes = getJsxType(JsxNames.IntrinsicAttributes);
	                    if (intrinsicAttributes !== unknownType) {
	                        result = intersectTypes(intrinsicAttributes, result);
	                    }
	                    return result;
	                }
	            }
	            return undefined;
	        }
	        /**
	         * Resolve attributes type of the given opening-like element. The attributes type is a type of attributes associated with the given elementType.
	         * For instance:
	         *      declare function Foo(attr: { p1: string}): JSX.Element;
	         *      <Foo p1={10} />;  // This function will try resolve "Foo" and return an attributes type of "Foo" which is "{ p1: string }"
	         *
	         * The function is intended to initially be called from getAttributesTypeFromJsxOpeningLikeElement which already handle JSX-intrinsic-element..
	         * This function will try to resolve custom JSX attributes type in following order: string literal, stateless function, and stateful component
	         *
	         * @param openingLikeElement a non-intrinsic JSXOPeningLikeElement
	         * @param shouldIncludeAllStatelessAttributesType a boolean indicating whether to include all attributes types from all stateless function signature
	         * @param sourceAttributesType Is the attributes type the user passed, and is used to create inferences in the target type if present
	         * @param elementType an instance type of the given opening-like element. If undefined, the function will check type openinglikeElement's tagname.
	         * @param elementClassType a JSX-ElementClass type. This is a result of looking up ElementClass interface in the JSX global (imported from react.d.ts)
	         * @return attributes type if able to resolve the type of node
	         *         anyType if there is no type ElementAttributesProperty or there is an error
	         *         emptyObjectType if there is no "prop" in the element instance type
	         */
	        function resolveCustomJsxElementAttributesType(openingLikeElement, shouldIncludeAllStatelessAttributesType, elementType, elementClassType) {
	            if (elementType.flags & 131072 /* Union */) {
	                var types = elementType.types;
	                return getUnionType(types.map(function (type) {
	                    return resolveCustomJsxElementAttributesType(openingLikeElement, shouldIncludeAllStatelessAttributesType, type, elementClassType);
	                }), 2 /* Subtype */);
	            }
	            // If the elemType is a string type, we have to return anyType to prevent an error downstream as we will try to find construct or call signature of the type
	            if (elementType.flags & 2 /* String */) {
	                return anyType;
	            }
	            else if (elementType.flags & 32 /* StringLiteral */) {
	                // If the elemType is a stringLiteral type, we can then provide a check to make sure that the string literal type is one of the Jsx intrinsic element type
	                // For example:
	                //      var CustomTag: "h1" = "h1";
	                //      <CustomTag> Hello World </CustomTag>
	                var intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements);
	                if (intrinsicElementsType !== unknownType) {
	                    var stringLiteralTypeName = elementType.value;
	                    var intrinsicProp = getPropertyOfType(intrinsicElementsType, ts.escapeLeadingUnderscores(stringLiteralTypeName));
	                    if (intrinsicProp) {
	                        return getTypeOfSymbol(intrinsicProp);
	                    }
	                    var indexSignatureType = getIndexTypeOfType(intrinsicElementsType, 0 /* String */);
	                    if (indexSignatureType) {
	                        return indexSignatureType;
	                    }
	                    error(openingLikeElement, ts.Diagnostics.Property_0_does_not_exist_on_type_1, stringLiteralTypeName, "JSX." + JsxNames.IntrinsicElements);
	                }
	                // If we need to report an error, we already done so here. So just return any to prevent any more error downstream
	                return anyType;
	            }
	            // Get the element instance type (the result of newing or invoking this tag)
	            var elemInstanceType = getJsxElementInstanceType(openingLikeElement, elementType);
	            // If we should include all stateless attributes type, then get all attributes type from all stateless function signature.
	            // Otherwise get only attributes type from the signature picked by choose-overload logic.
	            var statelessAttributesType = shouldIncludeAllStatelessAttributesType ?
	                tryGetAllJsxStatelessFunctionAttributesType(openingLikeElement, elementType, elemInstanceType, elementClassType) :
	                defaultTryGetJsxStatelessFunctionAttributesType(openingLikeElement, elementType, elemInstanceType, elementClassType);
	            if (statelessAttributesType) {
	                return statelessAttributesType;
	            }
	            // Issue an error if this return type isn't assignable to JSX.ElementClass
	            if (elementClassType) {
	                checkTypeRelatedTo(elemInstanceType, elementClassType, assignableRelation, openingLikeElement, ts.Diagnostics.JSX_element_type_0_is_not_a_constructor_function_for_JSX_elements);
	            }
	            return getJsxPropsTypeFromClassType(elemInstanceType, ts.isInJavaScriptFile(openingLikeElement));
	        }
	        /**
	         * Get attributes type of the given intrinsic opening-like Jsx element by resolving the tag name.
	         * The function is intended to be called from a function which has checked that the opening element is an intrinsic element.
	         * @param node an intrinsic JSX opening-like element
	         */
	        function getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node) {
	            ts.Debug.assert(isJsxIntrinsicIdentifier(node.tagName));
	            var links = getNodeLinks(node);
	            if (!links.resolvedJsxElementAttributesType) {
	                var symbol = getIntrinsicTagSymbol(node);
	                if (links.jsxFlags & 1 /* IntrinsicNamedElement */) {
	                    return links.resolvedJsxElementAttributesType = getTypeOfSymbol(symbol);
	                }
	                else if (links.jsxFlags & 2 /* IntrinsicIndexedElement */) {
	                    return links.resolvedJsxElementAttributesType = getIndexInfoOfSymbol(symbol, 0 /* String */).type;
	                }
	                else {
	                    return links.resolvedJsxElementAttributesType = unknownType;
	                }
	            }
	            return links.resolvedJsxElementAttributesType;
	        }
	        /**
	         * Get attributes type of the given custom opening-like JSX element.
	         * This function is intended to be called from a caller that handles intrinsic JSX element already.
	         * @param node a custom JSX opening-like element
	         * @param shouldIncludeAllStatelessAttributesType a boolean value used by language service to get all possible attributes type from an overload stateless function component
	         */
	        function getCustomJsxElementAttributesType(node, shouldIncludeAllStatelessAttributesType) {
	            return resolveCustomJsxElementAttributesType(node, shouldIncludeAllStatelessAttributesType, checkExpression(node.tagName), getJsxGlobalElementClassType());
	        }
	        /**
	         * Get all possible attributes type, especially from an overload stateless function component, of the given JSX opening-like element.
	         * This function is called by language service (see: completions-tryGetGlobalSymbols).
	         * @param node a JSX opening-like element to get attributes type for
	         */
	        function getAllAttributesTypeFromJsxOpeningLikeElement(node) {
	            if (isJsxIntrinsicIdentifier(node.tagName)) {
	                return getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node);
	            }
	            else {
	                // Because in language service, the given JSX opening-like element may be incomplete and therefore,
	                // we can't resolve to exact signature if the element is a stateless function component so the best thing to do is return all attributes type from all overloads.
	                return getCustomJsxElementAttributesType(node, /*shouldIncludeAllStatelessAttributesType*/ true);
	            }
	        }
	        /**
	         * Get the attributes type, which indicates the attributes that are valid on the given JSXOpeningLikeElement.
	         * @param node a JSXOpeningLikeElement node
	         * @return an attributes type of the given node
	         */
	        function getAttributesTypeFromJsxOpeningLikeElement(node) {
	            if (isJsxIntrinsicIdentifier(node.tagName)) {
	                return getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node);
	            }
	            else {
	                return getCustomJsxElementAttributesType(node, /*shouldIncludeAllStatelessAttributesType*/ false);
	            }
	        }
	        /**
	         * Given a JSX attribute, returns the symbol for the corresponds property
	         * of the element attributes type. Will return unknownSymbol for attributes
	         * that have no matching element attributes type property.
	         */
	        function getJsxAttributePropertySymbol(attrib) {
	            var attributesType = getAttributesTypeFromJsxOpeningLikeElement(attrib.parent.parent);
	            var prop = getPropertyOfType(attributesType, attrib.name.escapedText);
	            return prop || unknownSymbol;
	        }
	        function getJsxGlobalElementClassType() {
	            if (!deferredJsxElementClassType) {
	                deferredJsxElementClassType = getExportedTypeFromNamespace(JsxNames.JSX, JsxNames.ElementClass);
	            }
	            return deferredJsxElementClassType;
	        }
	        function getJsxGlobalElementType() {
	            if (!deferredJsxElementType) {
	                deferredJsxElementType = getExportedTypeFromNamespace(JsxNames.JSX, JsxNames.Element);
	            }
	            return deferredJsxElementType;
	        }
	        function getJsxGlobalStatelessElementType() {
	            if (!deferredJsxStatelessElementType) {
	                var jsxElementType = getJsxGlobalElementType();
	                if (jsxElementType) {
	                    deferredJsxStatelessElementType = getUnionType([jsxElementType, nullType]);
	                }
	            }
	            return deferredJsxStatelessElementType;
	        }
	        /**
	         * Returns all the properties of the Jsx.IntrinsicElements interface
	         */
	        function getJsxIntrinsicTagNames() {
	            var intrinsics = getJsxType(JsxNames.IntrinsicElements);
	            return intrinsics ? getPropertiesOfType(intrinsics) : ts.emptyArray;
	        }
	        function checkJsxPreconditions(errorNode) {
	            // Preconditions for using JSX
	            if ((compilerOptions.jsx || 0 /* None */) === 0 /* None */) {
	                error(errorNode, ts.Diagnostics.Cannot_use_JSX_unless_the_jsx_flag_is_provided);
	            }
	            if (getJsxGlobalElementType() === undefined) {
	                if (noImplicitAny) {
	                    error(errorNode, ts.Diagnostics.JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist);
	                }
	            }
	        }
	        function checkJsxOpeningLikeElementOrOpeningFragment(node, checkMode) {
	            var isNodeOpeningLikeElement = ts.isJsxOpeningLikeElement(node);
	            if (isNodeOpeningLikeElement) {
	                checkGrammarJsxElement(node);
	            }
	            checkJsxPreconditions(node);
	            // The reactNamespace/jsxFactory's root symbol should be marked as 'used' so we don't incorrectly elide its import.
	            // And if there is no reactNamespace/jsxFactory's symbol in scope when targeting React emit, we should issue an error.
	            var reactRefErr = diagnostics && compilerOptions.jsx === 2 /* React */ ? ts.Diagnostics.Cannot_find_name_0 : undefined;
	            var reactNamespace = getJsxNamespace();
	            var reactLocation = isNodeOpeningLikeElement ? node.tagName : node;
	            var reactSym = resolveName(reactLocation, reactNamespace, 107455 /* Value */, reactRefErr, reactNamespace, /*isUse*/ true);
	            if (reactSym) {
	                // Mark local symbol as referenced here because it might not have been marked
	                // if jsx emit was not react as there wont be error being emitted
	                reactSym.isReferenced = 67108863 /* All */;
	                // If react symbol is alias, mark it as refereced
	                if (reactSym.flags & 2097152 /* Alias */ && !isConstEnumOrConstEnumOnlyModule(resolveAlias(reactSym))) {
	                    markAliasSymbolAsReferenced(reactSym);
	                }
	            }
	            if (isNodeOpeningLikeElement) {
	                checkJsxAttributesAssignableToTagNameAttributes(node, checkMode);
	            }
	            else {
	                checkJsxChildren(node.parent);
	            }
	        }
	        /**
	         * Check if a property with the given name is known anywhere in the given type. In an object type, a property
	         * is considered known if
	         * 1. the object type is empty and the check is for assignability, or
	         * 2. if the object type has index signatures, or
	         * 3. if the property is actually declared in the object type
	         *    (this means that 'toString', for example, is not usually a known property).
	         * 4. In a union or intersection type,
	         *    a property is considered known if it is known in any constituent type.
	         * @param targetType a type to search a given name in
	         * @param name a property name to search
	         * @param isComparingJsxAttributes a boolean flag indicating whether we are searching in JsxAttributesType
	         */
	        function isKnownProperty(targetType, name, isComparingJsxAttributes) {
	            if (targetType.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(targetType);
	                if (resolved.stringIndexInfo ||
	                    resolved.numberIndexInfo && isNumericLiteralName(name) ||
	                    getPropertyOfObjectType(targetType, name) ||
	                    isComparingJsxAttributes && !isUnhyphenatedJsxName(name)) {
	                    // For JSXAttributes, if the attribute has a hyphenated name, consider that the attribute to be known.
	                    return true;
	                }
	            }
	            else if (targetType.flags & 393216 /* UnionOrIntersection */) {
	                for (var _i = 0, _a = targetType.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    if (isKnownProperty(t, name, isComparingJsxAttributes)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        /**
	         * Check whether the given attributes of JSX opening-like element is assignable to the tagName attributes.
	         *      Get the attributes type of the opening-like element through resolving the tagName, "target attributes"
	         *      Check assignablity between given attributes property, "source attributes", and the "target attributes"
	         * @param openingLikeElement an opening-like JSX element to check its JSXAttributes
	         */
	        function checkJsxAttributesAssignableToTagNameAttributes(openingLikeElement, checkMode) {
	            // The function involves following steps:
	            //      1. Figure out expected attributes type by resolving tagName of the JSX opening-like element, targetAttributesType.
	            //         During these steps, we will try to resolve the tagName as intrinsic name, stateless function, stateful component (in the order)
	            //      2. Solved JSX attributes type given by users, sourceAttributesType, which is by resolving "attributes" property of the JSX opening-like element.
	            //      3. Check if the two are assignable to each other
	            // targetAttributesType is a type of an attribute from resolving tagName of an opening-like JSX element.
	            var targetAttributesType = isJsxIntrinsicIdentifier(openingLikeElement.tagName) ?
	                getIntrinsicAttributesTypeFromJsxOpeningLikeElement(openingLikeElement) :
	                getCustomJsxElementAttributesType(openingLikeElement, /*shouldIncludeAllStatelessAttributesType*/ false);
	            // sourceAttributesType is a type of an attributes properties.
	            // i.e <div attr1={10} attr2="string" />
	            //     attr1 and attr2 are treated as JSXAttributes attached in the JsxOpeningLikeElement as "attributes".
	            var sourceAttributesType = createJsxAttributesTypeFromAttributesProperty(openingLikeElement, checkMode);
	            // If the targetAttributesType is an emptyObjectType, indicating that there is no property named 'props' on this instance type.
	            // but there exists a sourceAttributesType, we need to explicitly give an error as normal assignability check allow excess properties and will pass.
	            if (targetAttributesType === emptyObjectType && (isTypeAny(sourceAttributesType) || getPropertiesOfType(sourceAttributesType).length > 0)) {
	                error(openingLikeElement, ts.Diagnostics.JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property, ts.unescapeLeadingUnderscores(getJsxElementPropertiesName()));
	            }
	            else {
	                // Check if sourceAttributesType assignable to targetAttributesType though this check will allow excess properties
	                var isSourceAttributeTypeAssignableToTarget = checkTypeAssignableTo(sourceAttributesType, targetAttributesType, openingLikeElement.attributes.properties.length > 0 ? openingLikeElement.attributes : openingLikeElement);
	                // After we check for assignability, we will do another pass to check that all explicitly specified attributes have correct name corresponding in targetAttributeType.
	                // This will allow excess properties in spread type as it is very common pattern to spread outer attributes into React component in its render method.
	                if (isSourceAttributeTypeAssignableToTarget && !isTypeAny(sourceAttributesType) && !isTypeAny(targetAttributesType)) {
	                    for (var _i = 0, _a = openingLikeElement.attributes.properties; _i < _a.length; _i++) {
	                        var attribute = _a[_i];
	                        if (!ts.isJsxAttribute(attribute)) {
	                            continue;
	                        }
	                        var attrName = attribute.name;
	                        var isNotIgnoredJsxProperty = (isUnhyphenatedJsxName(ts.idText(attrName)) || !!(getPropertyOfType(targetAttributesType, attrName.escapedText)));
	                        if (isNotIgnoredJsxProperty && !isKnownProperty(targetAttributesType, attrName.escapedText, /*isComparingJsxAttributes*/ true)) {
	                            error(attribute, ts.Diagnostics.Property_0_does_not_exist_on_type_1, ts.idText(attrName), typeToString(targetAttributesType));
	                            // We break here so that errors won't be cascading
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	        function checkJsxExpression(node, checkMode) {
	            if (node.expression) {
	                var type = checkExpression(node.expression, checkMode);
	                if (node.dotDotDotToken && type !== anyType && !isArrayType(type)) {
	                    error(node, ts.Diagnostics.JSX_spread_child_must_be_an_array_type);
	                }
	                return type;
	            }
	            else {
	                return unknownType;
	            }
	        }
	        // If a symbol is a synthesized symbol with no value declaration, we assume it is a property. Example of this are the synthesized
	        // '.prototype' property as well as synthesized tuple index properties.
	        function getDeclarationKindFromSymbol(s) {
	            return s.valueDeclaration ? s.valueDeclaration.kind : 151 /* PropertyDeclaration */;
	        }
	        function getDeclarationNodeFlagsFromSymbol(s) {
	            return s.valueDeclaration ? ts.getCombinedNodeFlags(s.valueDeclaration) : 0;
	        }
	        function isMethodLike(symbol) {
	            return !!(symbol.flags & 8192 /* Method */ || ts.getCheckFlags(symbol) & 4 /* SyntheticMethod */);
	        }
	        /**
	         * Check whether the requested property access is valid.
	         * Returns true if node is a valid property access, and false otherwise.
	         * @param node The node to be checked.
	         * @param left The left hand side of the property access (e.g.: the super in `super.foo`).
	         * @param type The type of left.
	         * @param prop The symbol for the right hand side of the property access.
	         */
	        function checkPropertyAccessibility(node, left, type, prop) {
	            var flags = ts.getDeclarationModifierFlagsFromSymbol(prop);
	            var errorNode = node.kind === 183 /* PropertyAccessExpression */ || node.kind === 230 /* VariableDeclaration */ ?
	                node.name :
	                node.right;
	            if (ts.getCheckFlags(prop) & 256 /* ContainsPrivate */) {
	                // Synthetic property with private constituent property
	                error(errorNode, ts.Diagnostics.Property_0_has_conflicting_declarations_and_is_inaccessible_in_type_1, symbolToString(prop), typeToString(type));
	                return false;
	            }
	            if (left.kind === 97 /* SuperKeyword */) {
	                // TS 1.0 spec (April 2014): 4.8.2
	                // - In a constructor, instance member function, instance member accessor, or
	                //   instance member variable initializer where this references a derived class instance,
	                //   a super property access is permitted and must specify a public instance member function of the base class.
	                // - In a static member function or static member accessor
	                //   where this references the constructor function object of a derived class,
	                //   a super property access is permitted and must specify a public static member function of the base class.
	                if (languageVersion < 2 /* ES2015 */) {
	                    if (symbolHasNonMethodDeclaration(prop)) {
	                        error(errorNode, ts.Diagnostics.Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword);
	                        return false;
	                    }
	                }
	                if (flags & 128 /* Abstract */) {
	                    // A method cannot be accessed in a super property access if the method is abstract.
	                    // This error could mask a private property access error. But, a member
	                    // cannot simultaneously be private and abstract, so this will trigger an
	                    // additional error elsewhere.
	                    error(errorNode, ts.Diagnostics.Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression, symbolToString(prop), typeToString(getDeclaringClass(prop)));
	                    return false;
	                }
	            }
	            // Referencing abstract properties within their own constructors is not allowed
	            if ((flags & 128 /* Abstract */) && ts.isThisProperty(node) && symbolHasNonMethodDeclaration(prop)) {
	                var declaringClassDeclaration = ts.getClassLikeDeclarationOfSymbol(getParentOfSymbol(prop));
	                if (declaringClassDeclaration && isNodeWithinConstructorOfClass(node, declaringClassDeclaration)) {
	                    error(errorNode, ts.Diagnostics.Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor, symbolToString(prop), ts.getTextOfIdentifierOrLiteral(declaringClassDeclaration.name));
	                    return false;
	                }
	            }
	            // Public properties are otherwise accessible.
	            if (!(flags & 24 /* NonPublicAccessibilityModifier */)) {
	                return true;
	            }
	            // Property is known to be private or protected at this point
	            // Private property is accessible if the property is within the declaring class
	            if (flags & 8 /* Private */) {
	                var declaringClassDeclaration = ts.getClassLikeDeclarationOfSymbol(getParentOfSymbol(prop));
	                if (!isNodeWithinClass(node, declaringClassDeclaration)) {
	                    error(errorNode, ts.Diagnostics.Property_0_is_private_and_only_accessible_within_class_1, symbolToString(prop), typeToString(getDeclaringClass(prop)));
	                    return false;
	                }
	                return true;
	            }
	            // Property is known to be protected at this point
	            // All protected properties of a supertype are accessible in a super access
	            if (left.kind === 97 /* SuperKeyword */) {
	                return true;
	            }
	            // Find the first enclosing class that has the declaring classes of the protected constituents
	            // of the property as base classes
	            var enclosingClass = forEachEnclosingClass(node, function (enclosingDeclaration) {
	                var enclosingClass = getDeclaredTypeOfSymbol(getSymbolOfNode(enclosingDeclaration));
	                return isClassDerivedFromDeclaringClasses(enclosingClass, prop) ? enclosingClass : undefined;
	            });
	            // A protected property is accessible if the property is within the declaring class or classes derived from it
	            if (!enclosingClass) {
	                error(errorNode, ts.Diagnostics.Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses, symbolToString(prop), typeToString(getDeclaringClass(prop) || type));
	                return false;
	            }
	            // No further restrictions for static properties
	            if (flags & 32 /* Static */) {
	                return true;
	            }
	            if (type.flags & 32768 /* TypeParameter */) {
	                // get the original type -- represented as the type constraint of the 'this' type
	                type = type.isThisType ? getConstraintOfTypeParameter(type) : getBaseConstraintOfType(type);
	            }
	            if (!type || !hasBaseType(type, enclosingClass)) {
	                error(errorNode, ts.Diagnostics.Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1, symbolToString(prop), typeToString(enclosingClass));
	                return false;
	            }
	            return true;
	        }
	        function symbolHasNonMethodDeclaration(symbol) {
	            return forEachProperty(symbol, function (prop) {
	                var propKind = getDeclarationKindFromSymbol(prop);
	                return propKind !== 153 /* MethodDeclaration */ && propKind !== 152 /* MethodSignature */;
	            });
	        }
	        function checkNonNullExpression(node, nullDiagnostic, undefinedDiagnostic, nullOrUndefinedDiagnostic) {
	            return checkNonNullType(checkExpression(node), node, nullDiagnostic, undefinedDiagnostic, nullOrUndefinedDiagnostic);
	        }
	        function checkNonNullType(type, node, nullDiagnostic, undefinedDiagnostic, nullOrUndefinedDiagnostic) {
	            var kind = (strictNullChecks ? getFalsyFlags(type) : type.flags) & 12288 /* Nullable */;
	            if (kind) {
	                error(node, kind & 4096 /* Undefined */ ? kind & 8192 /* Null */ ?
	                    (nullOrUndefinedDiagnostic || ts.Diagnostics.Object_is_possibly_null_or_undefined) :
	                    (undefinedDiagnostic || ts.Diagnostics.Object_is_possibly_undefined) :
	                    (nullDiagnostic || ts.Diagnostics.Object_is_possibly_null));
	                var t = getNonNullableType(type);
	                return t.flags & (12288 /* Nullable */ | 16384 /* Never */) ? unknownType : t;
	            }
	            return type;
	        }
	        function checkPropertyAccessExpression(node) {
	            return checkPropertyAccessExpressionOrQualifiedName(node, node.expression, node.name);
	        }
	        function checkQualifiedName(node) {
	            return checkPropertyAccessExpressionOrQualifiedName(node, node.left, node.right);
	        }
	        function checkPropertyAccessExpressionOrQualifiedName(node, left, right) {
	            var propType;
	            var leftType = checkNonNullExpression(left);
	            var parentSymbol = getNodeLinks(left).resolvedSymbol;
	            var apparentType = getApparentType(getWidenedType(leftType));
	            if (isTypeAny(apparentType) || apparentType === silentNeverType) {
	                if (ts.isIdentifier(left) && parentSymbol) {
	                    markAliasReferenced(parentSymbol, node);
	                }
	                return apparentType;
	            }
	            var assignmentKind = ts.getAssignmentTargetKind(node);
	            var prop = getPropertyOfType(apparentType, right.escapedText);
	            if (ts.isIdentifier(left) && parentSymbol && !(prop && isConstEnumOrConstEnumOnlyModule(prop))) {
	                markAliasReferenced(parentSymbol, node);
	            }
	            if (!prop) {
	                var indexInfo = getIndexInfoOfType(apparentType, 0 /* String */);
	                if (!(indexInfo && indexInfo.type)) {
	                    if (right.escapedText && !checkAndReportErrorForExtendingInterface(node)) {
	                        reportNonexistentProperty(right, leftType.flags & 32768 /* TypeParameter */ && leftType.isThisType ? apparentType : leftType);
	                    }
	                    return unknownType;
	                }
	                if (indexInfo.isReadonly && (ts.isAssignmentTarget(node) || ts.isDeleteTarget(node))) {
	                    error(node, ts.Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(apparentType));
	                }
	                propType = indexInfo.type;
	            }
	            else {
	                checkPropertyNotUsedBeforeDeclaration(prop, node, right);
	                markPropertyAsReferenced(prop, node, left.kind === 99 /* ThisKeyword */);
	                getNodeLinks(node).resolvedSymbol = prop;
	                checkPropertyAccessibility(node, left, apparentType, prop);
	                if (assignmentKind) {
	                    if (isReferenceToReadonlyEntity(node, prop) || isReferenceThroughNamespaceImport(node)) {
	                        error(right, ts.Diagnostics.Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property, ts.idText(right));
	                        return unknownType;
	                    }
	                }
	                propType = getConstraintForLocation(getTypeOfSymbol(prop), node);
	            }
	            // Only compute control flow type if this is a property access expression that isn't an
	            // assignment target, and the referenced property was declared as a variable, property,
	            // accessor, or optional method.
	            if (node.kind !== 183 /* PropertyAccessExpression */ ||
	                assignmentKind === 1 /* Definite */ ||
	                prop && !(prop.flags & (3 /* Variable */ | 4 /* Property */ | 98304 /* Accessor */)) && !(prop.flags & 8192 /* Method */ && propType.flags & 131072 /* Union */)) {
	                return propType;
	            }
	            // If strict null checks and strict property initialization checks are enabled, if we have
	            // a this.xxx property access, if the property is an instance property without an initializer,
	            // and if we are in a constructor of the same class as the property declaration, assume that
	            // the property is uninitialized at the top of the control flow.
	            var assumeUninitialized = false;
	            if (strictNullChecks && strictPropertyInitialization && left.kind === 99 /* ThisKeyword */) {
	                var declaration = prop && prop.valueDeclaration;
	                if (declaration && isInstancePropertyWithoutInitializer(declaration)) {
	                    var flowContainer = getControlFlowContainer(node);
	                    if (flowContainer.kind === 154 /* Constructor */ && flowContainer.parent === declaration.parent) {
	                        assumeUninitialized = true;
	                    }
	                }
	            }
	            var flowType = getFlowTypeOfReference(node, propType, assumeUninitialized ? getOptionalType(propType) : propType);
	            if (assumeUninitialized && !(getFalsyFlags(propType) & 4096 /* Undefined */) && getFalsyFlags(flowType) & 4096 /* Undefined */) {
	                error(right, ts.Diagnostics.Property_0_is_used_before_being_assigned, symbolToString(prop));
	                // Return the declared type to reduce follow-on errors
	                return propType;
	            }
	            return assignmentKind ? getBaseTypeOfLiteralType(flowType) : flowType;
	        }
	        function checkPropertyNotUsedBeforeDeclaration(prop, node, right) {
	            var valueDeclaration = prop.valueDeclaration;
	            if (!valueDeclaration) {
	                return;
	            }
	            if (isInPropertyInitializer(node) &&
	                !isBlockScopedNameDeclaredBeforeUse(valueDeclaration, right)
	                && !isPropertyDeclaredInAncestorClass(prop)) {
	                error(right, ts.Diagnostics.Block_scoped_variable_0_used_before_its_declaration, ts.idText(right));
	            }
	            else if (valueDeclaration.kind === 233 /* ClassDeclaration */ &&
	                node.parent.kind !== 161 /* TypeReference */ &&
	                !(valueDeclaration.flags & 2097152 /* Ambient */) &&
	                !isBlockScopedNameDeclaredBeforeUse(valueDeclaration, right)) {
	                error(right, ts.Diagnostics.Class_0_used_before_its_declaration, ts.idText(right));
	            }
	        }
	        function isInPropertyInitializer(node) {
	            return !!ts.findAncestor(node, function (node) {
	                switch (node.kind) {
	                    case 151 /* PropertyDeclaration */:
	                        return true;
	                    case 268 /* PropertyAssignment */:
	                        // We might be in `a = { b: this.b }`, so keep looking. See `tests/cases/compiler/useBeforeDeclaration_propertyAssignment.ts`.
	                        return false;
	                    default:
	                        return ts.isExpressionNode(node) ? false : "quit";
	                }
	            });
	        }
	        /**
	         * It's possible that "prop.valueDeclaration" is a local declaration, but the property was also declared in a superclass.
	         * In that case we won't consider it used before its declaration, because it gets its value from the superclass' declaration.
	         */
	        function isPropertyDeclaredInAncestorClass(prop) {
	            if (!(prop.parent.flags & 32 /* Class */)) {
	                return false;
	            }
	            var classType = getTypeOfSymbol(prop.parent);
	            while (true) {
	                classType = getSuperClass(classType);
	                if (!classType) {
	                    return false;
	                }
	                var superProperty = getPropertyOfObjectType(classType, prop.escapedName);
	                if (superProperty && superProperty.valueDeclaration) {
	                    return true;
	                }
	            }
	        }
	        function getSuperClass(classType) {
	            var x = getBaseTypes(classType);
	            if (x.length === 0) {
	                return undefined;
	            }
	            ts.Debug.assert(x.length === 1);
	            return x[0];
	        }
	        function reportNonexistentProperty(propNode, containingType) {
	            var errorInfo;
	            if (containingType.flags & 131072 /* Union */ && !(containingType.flags & 16382 /* Primitive */)) {
	                for (var _i = 0, _a = containingType.types; _i < _a.length; _i++) {
	                    var subtype = _a[_i];
	                    if (!getPropertyOfType(subtype, propNode.escapedText)) {
	                        errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Property_0_does_not_exist_on_type_1, ts.declarationNameToString(propNode), typeToString(subtype));
	                        break;
	                    }
	                }
	            }
	            var suggestion = getSuggestionForNonexistentProperty(propNode, containingType);
	            if (suggestion !== undefined) {
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2, ts.declarationNameToString(propNode), typeToString(containingType), suggestion);
	            }
	            else {
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Property_0_does_not_exist_on_type_1, ts.declarationNameToString(propNode), typeToString(containingType));
	            }
	            diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(propNode, errorInfo));
	        }
	        function getSuggestionForNonexistentProperty(node, containingType) {
	            var suggestion = getSpellingSuggestionForName(ts.idText(node), getPropertiesOfType(containingType), 107455 /* Value */);
	            return suggestion && ts.symbolName(suggestion);
	        }
	        function getSuggestionForNonexistentSymbol(location, outerName, meaning) {
	            ts.Debug.assert(outerName !== undefined, "outername should always be defined");
	            var result = resolveNameHelper(location, outerName, meaning, /*nameNotFoundMessage*/ undefined, outerName, /*isUse*/ false, /*excludeGlobals*/ false, function (symbols, name, meaning) {
	                ts.Debug.assertEqual(outerName, name, "name should equal outerName");
	                var symbol = getSymbol(symbols, name, meaning);
	                // Sometimes the symbol is found when location is a return type of a function: `typeof x` and `x` is declared in the body of the function
	                // So the table *contains* `x` but `x` isn't actually in scope.
	                // However, resolveNameHelper will continue and call this callback again, so we'll eventually get a correct suggestion.
	                return symbol || getSpellingSuggestionForName(ts.unescapeLeadingUnderscores(name), ts.arrayFrom(symbols.values()), meaning);
	            });
	            return result && ts.symbolName(result);
	        }
	        /**
	         * Given a name and a list of symbols whose names are *not* equal to the name, return a spelling suggestion if there is one that is close enough.
	         * Names less than length 3 only check for case-insensitive equality, not levenshtein distance.
	         *
	         * If there is a candidate that's the same except for case, return that.
	         * If there is a candidate that's within one edit of the name, return that.
	         * Otherwise, return the candidate with the smallest Levenshtein distance,
	         *    except for candidates:
	         *      * With no name
	         *      * Whose meaning doesn't match the `meaning` parameter.
	         *      * Whose length differs from the target name by more than 0.34 of the length of the name.
	         *      * Whose levenshtein distance is more than 0.4 of the length of the name
	         *        (0.4 allows 1 substitution/transposition for every 5 characters,
	         *         and 1 insertion/deletion at 3 characters)
	         */
	        function getSpellingSuggestionForName(name, symbols, meaning) {
	            var maximumLengthDifference = Math.min(2, Math.floor(name.length * 0.34));
	            var bestDistance = Math.floor(name.length * 0.4) + 1; // If the best result isn't better than this, don't bother.
	            var bestCandidate;
	            var justCheckExactMatches = false;
	            var nameLowerCase = name.toLowerCase();
	            for (var _i = 0, symbols_3 = symbols; _i < symbols_3.length; _i++) {
	                var candidate = symbols_3[_i];
	                var candidateName = ts.symbolName(candidate);
	                if (!(candidate.flags & meaning && Math.abs(candidateName.length - nameLowerCase.length) <= maximumLengthDifference)) {
	                    continue;
	                }
	                var candidateNameLowerCase = candidateName.toLowerCase();
	                if (candidateNameLowerCase === nameLowerCase) {
	                    return candidate;
	                }
	                if (justCheckExactMatches) {
	                    continue;
	                }
	                if (candidateName.length < 3) {
	                    // Don't bother, user would have noticed a 2-character name having an extra character
	                    continue;
	                }
	                // Only care about a result better than the best so far.
	                var distance = levenshteinWithMax(nameLowerCase, candidateNameLowerCase, bestDistance - 1);
	                if (distance === undefined) {
	                    continue;
	                }
	                if (distance < 3) {
	                    justCheckExactMatches = true;
	                    bestCandidate = candidate;
	                }
	                else {
	                    ts.Debug.assert(distance < bestDistance); // Else `levenshteinWithMax` should return undefined
	                    bestDistance = distance;
	                    bestCandidate = candidate;
	                }
	            }
	            return bestCandidate;
	        }
	        function levenshteinWithMax(s1, s2, max) {
	            var previous = new Array(s2.length + 1);
	            var current = new Array(s2.length + 1);
	            /** Represents any value > max. We don't care about the particular value. */
	            var big = max + 1;
	            for (var i = 0; i <= s2.length; i++) {
	                previous[i] = i;
	            }
	            for (var i = 1; i <= s1.length; i++) {
	                var c1 = s1.charCodeAt(i - 1);
	                var minJ = i > max ? i - max : 1;
	                var maxJ = s2.length > max + i ? max + i : s2.length;
	                current[0] = i;
	                /** Smallest value of the matrix in the ith column. */
	                var colMin = i;
	                for (var j = 1; j < minJ; j++) {
	                    current[j] = big;
	                }
	                for (var j = minJ; j <= maxJ; j++) {
	                    var dist = c1 === s2.charCodeAt(j - 1)
	                        ? previous[j - 1]
	                        : Math.min(/*delete*/ previous[j] + 1, /*insert*/ current[j - 1] + 1, /*substitute*/ previous[j - 1] + 2);
	                    current[j] = dist;
	                    colMin = Math.min(colMin, dist);
	                }
	                for (var j = maxJ + 1; j <= s2.length; j++) {
	                    current[j] = big;
	                }
	                if (colMin > max) {
	                    // Give up -- everything in this column is > max and it can't get better in future columns.
	                    return undefined;
	                }
	                var temp = previous;
	                previous = current;
	                current = temp;
	            }
	            var res = previous[s2.length];
	            return res > max ? undefined : res;
	        }
	        function markPropertyAsReferenced(prop, nodeForCheckWriteOnly, isThisAccess) {
	            if (!prop || !noUnusedIdentifiers || !(prop.flags & 106500 /* ClassMember */) || !prop.valueDeclaration || !ts.hasModifier(prop.valueDeclaration, 8 /* Private */)) {
	                return;
	            }
	            if (nodeForCheckWriteOnly && ts.isWriteOnlyAccess(nodeForCheckWriteOnly) && !(prop.flags & 65536 /* SetAccessor */ && !(prop.flags & 32768 /* GetAccessor */))) {
	                return;
	            }
	            if (isThisAccess) {
	                // Find any FunctionLikeDeclaration because those create a new 'this' binding. But this should only matter for methods (or getters/setters).
	                var containingMethod = ts.findAncestor(nodeForCheckWriteOnly, ts.isFunctionLikeDeclaration);
	                if (containingMethod && containingMethod.symbol === prop) {
	                    return;
	                }
	            }
	            (ts.getCheckFlags(prop) & 1 /* Instantiated */ ? getSymbolLinks(prop).target : prop).isReferenced = 67108863 /* All */;
	        }
	        function isValidPropertyAccess(node, propertyName) {
	            var left = node.kind === 183 /* PropertyAccessExpression */ ? node.expression : node.left;
	            return isValidPropertyAccessWithType(node, left, propertyName, getWidenedType(checkExpression(left)));
	        }
	        function isValidPropertyAccessForCompletions(node, type, property) {
	            return isValidPropertyAccessWithType(node, node.expression, property.escapedName, type)
	                && (!(property.flags & 8192 /* Method */) || isValidMethodAccess(property, type));
	        }
	        function isValidMethodAccess(method, type) {
	            var propType = getTypeOfFuncClassEnumModule(method);
	            var signatures = getSignaturesOfType(getNonNullableType(propType), 0 /* Call */);
	            ts.Debug.assert(signatures.length !== 0);
	            return signatures.some(function (sig) {
	                var thisType = getThisTypeOfSignature(sig);
	                return !thisType || isTypeAssignableTo(type, thisType);
	            });
	        }
	        function isValidPropertyAccessWithType(node, left, propertyName, type) {
	            if (type === unknownType || isTypeAny(type)) {
	                return true;
	            }
	            var prop = getPropertyOfType(type, propertyName);
	            return prop ? checkPropertyAccessibility(node, left, type, prop)
	                // In js files properties of unions are allowed in completion
	                : ts.isInJavaScriptFile(node) && (type.flags & 131072 /* Union */) && type.types.some(function (elementType) { return isValidPropertyAccessWithType(node, left, propertyName, elementType); });
	        }
	        /**
	         * Return the symbol of the for-in variable declared or referenced by the given for-in statement.
	         */
	        function getForInVariableSymbol(node) {
	            var initializer = node.initializer;
	            if (initializer.kind === 231 /* VariableDeclarationList */) {
	                var variable = initializer.declarations[0];
	                if (variable && !ts.isBindingPattern(variable.name)) {
	                    return getSymbolOfNode(variable);
	                }
	            }
	            else if (initializer.kind === 71 /* Identifier */) {
	                return getResolvedSymbol(initializer);
	            }
	            return undefined;
	        }
	        /**
	         * Return true if the given type is considered to have numeric property names.
	         */
	        function hasNumericPropertyNames(type) {
	            return getIndexTypeOfType(type, 1 /* Number */) && !getIndexTypeOfType(type, 0 /* String */);
	        }
	        /**
	         * Return true if given node is an expression consisting of an identifier (possibly parenthesized)
	         * that references a for-in variable for an object with numeric property names.
	         */
	        function isForInVariableForNumericPropertyNames(expr) {
	            var e = ts.skipParentheses(expr);
	            if (e.kind === 71 /* Identifier */) {
	                var symbol = getResolvedSymbol(e);
	                if (symbol.flags & 3 /* Variable */) {
	                    var child = expr;
	                    var node = expr.parent;
	                    while (node) {
	                        if (node.kind === 219 /* ForInStatement */ &&
	                            child === node.statement &&
	                            getForInVariableSymbol(node) === symbol &&
	                            hasNumericPropertyNames(getTypeOfExpression(node.expression))) {
	                            return true;
	                        }
	                        child = node;
	                        node = node.parent;
	                    }
	                }
	            }
	            return false;
	        }
	        function checkIndexedAccess(node) {
	            var objectType = checkNonNullExpression(node.expression);
	            var indexExpression = node.argumentExpression;
	            if (!indexExpression) {
	                var sourceFile = ts.getSourceFileOfNode(node);
	                if (node.parent.kind === 186 /* NewExpression */ && node.parent.expression === node) {
	                    var start = ts.skipTrivia(sourceFile.text, node.expression.end);
	                    var end = node.end;
	                    grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.new_T_cannot_be_used_to_create_an_array_Use_new_Array_T_instead);
	                }
	                else {
	                    var start = node.end - "]".length;
	                    var end = node.end;
	                    grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.Expression_expected);
	                }
	                return unknownType;
	            }
	            var indexType = isForInVariableForNumericPropertyNames(indexExpression) ? numberType : checkExpression(indexExpression);
	            if (objectType === unknownType || objectType === silentNeverType) {
	                return objectType;
	            }
	            if (isConstEnumObjectType(objectType) && indexExpression.kind !== 9 /* StringLiteral */) {
	                error(indexExpression, ts.Diagnostics.A_const_enum_member_can_only_be_accessed_using_a_string_literal);
	                return unknownType;
	            }
	            return checkIndexedAccessIndexType(getIndexedAccessType(objectType, indexType, node), node);
	        }
	        function checkThatExpressionIsProperSymbolReference(expression, expressionType, reportError) {
	            if (expressionType === unknownType) {
	                // There is already an error, so no need to report one.
	                return false;
	            }
	            if (!ts.isWellKnownSymbolSyntactically(expression)) {
	                return false;
	            }
	            // Make sure the property type is the primitive symbol type
	            if ((expressionType.flags & 1536 /* ESSymbolLike */) === 0) {
	                if (reportError) {
	                    error(expression, ts.Diagnostics.A_computed_property_name_of_the_form_0_must_be_of_type_symbol, ts.getTextOfNode(expression));
	                }
	                return false;
	            }
	            // The name is Symbol.<someName>, so make sure Symbol actually resolves to the
	            // global Symbol object
	            var leftHandSide = expression.expression;
	            var leftHandSideSymbol = getResolvedSymbol(leftHandSide);
	            if (!leftHandSideSymbol) {
	                return false;
	            }
	            var globalESSymbol = getGlobalESSymbolConstructorSymbol(/*reportErrors*/ true);
	            if (!globalESSymbol) {
	                // Already errored when we tried to look up the symbol
	                return false;
	            }
	            if (leftHandSideSymbol !== globalESSymbol) {
	                if (reportError) {
	                    error(leftHandSide, ts.Diagnostics.Symbol_reference_does_not_refer_to_the_global_Symbol_constructor_object);
	                }
	                return false;
	            }
	            return true;
	        }
	        function callLikeExpressionMayHaveTypeArguments(node) {
	            // TODO: Also include tagged templates (https://github.com/Microsoft/TypeScript/issues/11947)
	            return ts.isCallOrNewExpression(node);
	        }
	        function resolveUntypedCall(node) {
	            if (callLikeExpressionMayHaveTypeArguments(node)) {
	                // Check type arguments even though we will give an error that untyped calls may not accept type arguments.
	                // This gets us diagnostics for the type arguments and marks them as referenced.
	                ts.forEach(node.typeArguments, checkSourceElement);
	            }
	            if (node.kind === 187 /* TaggedTemplateExpression */) {
	                checkExpression(node.template);
	            }
	            else if (node.kind !== 149 /* Decorator */) {
	                ts.forEach(node.arguments, function (argument) {
	                    checkExpression(argument);
	                });
	            }
	            return anySignature;
	        }
	        function resolveErrorCall(node) {
	            resolveUntypedCall(node);
	            return unknownSignature;
	        }
	        // Re-order candidate signatures into the result array. Assumes the result array to be empty.
	        // The candidate list orders groups in reverse, but within a group signatures are kept in declaration order
	        // A nit here is that we reorder only signatures that belong to the same symbol,
	        // so order how inherited signatures are processed is still preserved.
	        // interface A { (x: string): void }
	        // interface B extends A { (x: 'foo'): string }
	        // const b: B;
	        // b('foo') // <- here overloads should be processed as [(x:'foo'): string, (x: string): void]
	        function reorderCandidates(signatures, result) {
	            var lastParent;
	            var lastSymbol;
	            var cutoffIndex = 0;
	            var index;
	            var specializedIndex = -1;
	            var spliceIndex;
	            ts.Debug.assert(!result.length);
	            for (var _i = 0, signatures_4 = signatures; _i < signatures_4.length; _i++) {
	                var signature = signatures_4[_i];
	                var symbol = signature.declaration && getSymbolOfNode(signature.declaration);
	                var parent = signature.declaration && signature.declaration.parent;
	                if (!lastSymbol || symbol === lastSymbol) {
	                    if (lastParent && parent === lastParent) {
	                        index++;
	                    }
	                    else {
	                        lastParent = parent;
	                        index = cutoffIndex;
	                    }
	                }
	                else {
	                    // current declaration belongs to a different symbol
	                    // set cutoffIndex so re-orderings in the future won't change result set from 0 to cutoffIndex
	                    index = cutoffIndex = result.length;
	                    lastParent = parent;
	                }
	                lastSymbol = symbol;
	                // specialized signatures always need to be placed before non-specialized signatures regardless
	                // of the cutoff position; see GH#1133
	                if (signature.hasLiteralTypes) {
	                    specializedIndex++;
	                    spliceIndex = specializedIndex;
	                    // The cutoff index always needs to be greater than or equal to the specialized signature index
	                    // in order to prevent non-specialized signatures from being added before a specialized
	                    // signature.
	                    cutoffIndex++;
	                }
	                else {
	                    spliceIndex = index;
	                }
	                result.splice(spliceIndex, 0, signature);
	            }
	        }
	        function getSpreadArgumentIndex(args) {
	            for (var i = 0; i < args.length; i++) {
	                var arg = args[i];
	                if (arg && arg.kind === 202 /* SpreadElement */) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	        function hasCorrectArity(node, args, signature, signatureHelpTrailingComma) {
	            if (signatureHelpTrailingComma === void 0) { signatureHelpTrailingComma = false; }
	            var argCount; // Apparent number of arguments we will have in this call
	            var typeArguments; // Type arguments (undefined if none)
	            var callIsIncomplete; // In incomplete call we want to be lenient when we have too few arguments
	            var spreadArgIndex = -1;
	            if (ts.isJsxOpeningLikeElement(node)) {
	                // The arity check will be done in "checkApplicableSignatureForJsxOpeningLikeElement".
	                return true;
	            }
	            if (node.kind === 187 /* TaggedTemplateExpression */) {
	                // Even if the call is incomplete, we'll have a missing expression as our last argument,
	                // so we can say the count is just the arg list length
	                argCount = args.length;
	                typeArguments = undefined;
	                if (node.template.kind === 200 /* TemplateExpression */) {
	                    // If a tagged template expression lacks a tail literal, the call is incomplete.
	                    // Specifically, a template only can end in a TemplateTail or a Missing literal.
	                    var lastSpan = ts.lastOrUndefined(node.template.templateSpans);
	                    ts.Debug.assert(lastSpan !== undefined); // we should always have at least one span.
	                    callIsIncomplete = ts.nodeIsMissing(lastSpan.literal) || !!lastSpan.literal.isUnterminated;
	                }
	                else {
	                    // If the template didn't end in a backtick, or its beginning occurred right prior to EOF,
	                    // then this might actually turn out to be a TemplateHead in the future;
	                    // so we consider the call to be incomplete.
	                    var templateLiteral = node.template;
	                    ts.Debug.assert(templateLiteral.kind === 13 /* NoSubstitutionTemplateLiteral */);
	                    callIsIncomplete = !!templateLiteral.isUnterminated;
	                }
	            }
	            else if (node.kind === 149 /* Decorator */) {
	                typeArguments = undefined;
	                argCount = getEffectiveArgumentCount(node, /*args*/ undefined, signature);
	            }
	            else {
	                if (!node.arguments) {
	                    // This only happens when we have something of the form: 'new C'
	                    ts.Debug.assert(node.kind === 186 /* NewExpression */);
	                    return signature.minArgumentCount === 0;
	                }
	                argCount = signatureHelpTrailingComma ? args.length + 1 : args.length;
	                // If we are missing the close parenthesis, the call is incomplete.
	                callIsIncomplete = node.arguments.end === node.end;
	                typeArguments = node.typeArguments;
	                spreadArgIndex = getSpreadArgumentIndex(args);
	            }
	            // If the user supplied type arguments, but the number of type arguments does not match
	            // the declared number of type parameters, the call has an incorrect arity.
	            var numTypeParameters = ts.length(signature.typeParameters);
	            var minTypeArgumentCount = getMinTypeArgumentCount(signature.typeParameters);
	            var hasRightNumberOfTypeArgs = !typeArguments ||
	                (typeArguments.length >= minTypeArgumentCount && typeArguments.length <= numTypeParameters);
	            if (!hasRightNumberOfTypeArgs) {
	                return false;
	            }
	            // If a spread argument is present, check that it corresponds to a rest parameter or at least that it's in the valid range.
	            if (spreadArgIndex >= 0) {
	                return isRestParameterIndex(signature, spreadArgIndex) ||
	                    signature.minArgumentCount <= spreadArgIndex && spreadArgIndex < signature.parameters.length;
	            }
	            // Too many arguments implies incorrect arity.
	            if (!signature.hasRestParameter && argCount > signature.parameters.length) {
	                return false;
	            }
	            // If the call is incomplete, we should skip the lower bound check.
	            var hasEnoughArguments = argCount >= signature.minArgumentCount;
	            return callIsIncomplete || hasEnoughArguments;
	        }
	        // If type has a single call signature and no other members, return that signature. Otherwise, return undefined.
	        function getSingleCallSignature(type) {
	            if (type.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                if (resolved.callSignatures.length === 1 && resolved.constructSignatures.length === 0 &&
	                    resolved.properties.length === 0 && !resolved.stringIndexInfo && !resolved.numberIndexInfo) {
	                    return resolved.callSignatures[0];
	                }
	            }
	            return undefined;
	        }
	        // Instantiate a generic signature in the context of a non-generic signature (section 3.8.5 in TypeScript spec)
	        function instantiateSignatureInContextOf(signature, contextualSignature, contextualMapper, compareTypes) {
	            var context = createInferenceContext(signature, 1 /* InferUnionTypes */, compareTypes);
	            forEachMatchingParameterType(contextualSignature, signature, function (source, target) {
	                // Type parameters from outer context referenced by source type are fixed by instantiation of the source type
	                inferTypes(context.inferences, instantiateType(source, contextualMapper || identityMapper), target);
	            });
	            if (!contextualMapper) {
	                inferTypes(context.inferences, getReturnTypeOfSignature(contextualSignature), getReturnTypeOfSignature(signature), 4 /* ReturnType */);
	            }
	            return getSignatureInstantiation(signature, getInferredTypes(context), ts.isInJavaScriptFile(contextualSignature.declaration));
	        }
	        function inferJsxTypeArguments(signature, node, context) {
	            // Skip context sensitive pass
	            var skipContextParamType = getTypeAtPosition(signature, 0);
	            var checkAttrTypeSkipContextSensitive = checkExpressionWithContextualType(node.attributes, skipContextParamType, identityMapper);
	            inferTypes(context.inferences, checkAttrTypeSkipContextSensitive, skipContextParamType);
	            // Standard pass
	            var paramType = getTypeAtPosition(signature, 0);
	            var checkAttrType = checkExpressionWithContextualType(node.attributes, paramType, context);
	            inferTypes(context.inferences, checkAttrType, paramType);
	            return getInferredTypes(context);
	        }
	        function inferTypeArguments(node, signature, args, excludeArgument, context) {
	            // Clear out all the inference results from the last time inferTypeArguments was called on this context
	            for (var _i = 0, _a = context.inferences; _i < _a.length; _i++) {
	                var inference = _a[_i];
	                // As an optimization, we don't have to clear (and later recompute) inferred types
	                // for type parameters that have already been fixed on the previous call to inferTypeArguments.
	                // It would be just as correct to reset all of them. But then we'd be repeating the same work
	                // for the type parameters that were fixed, namely the work done by getInferredType.
	                if (!inference.isFixed) {
	                    inference.inferredType = undefined;
	                }
	            }
	            // If a contextual type is available, infer from that type to the return type of the call expression. For
	            // example, given a 'function wrap<T, U>(cb: (x: T) => U): (x: T) => U' and a call expression
	            // 'let f: (x: string) => number = wrap(s => s.length)', we infer from the declared type of 'f' to the
	            // return type of 'wrap'.
	            if (node.kind !== 149 /* Decorator */) {
	                var contextualType = getContextualType(node);
	                if (contextualType) {
	                    // We clone the contextual mapper to avoid disturbing a resolution in progress for an
	                    // outer call expression. Effectively we just want a snapshot of whatever has been
	                    // inferred for any outer call expression so far.
	                    var instantiatedType = instantiateType(contextualType, cloneTypeMapper(getContextualMapper(node)));
	                    // If the contextual type is a generic function type with a single call signature, we
	                    // instantiate the type with its own type parameters and type arguments. This ensures that
	                    // the type parameters are not erased to type any during type inference such that they can
	                    // be inferred as actual types from the contextual type. For example:
	                    //   declare function arrayMap<T, U>(f: (x: T) => U): (a: T[]) => U[];
	                    //   const boxElements: <A>(a: A[]) => { value: A }[] = arrayMap(value => ({ value }));
	                    // Above, the type of the 'value' parameter is inferred to be 'A'.
	                    var contextualSignature = getSingleCallSignature(instantiatedType);
	                    var inferenceSourceType = contextualSignature && contextualSignature.typeParameters ?
	                        getOrCreateTypeFromSignature(getSignatureInstantiation(contextualSignature, contextualSignature.typeParameters, ts.isInJavaScriptFile(node))) :
	                        instantiatedType;
	                    var inferenceTargetType = getReturnTypeOfSignature(signature);
	                    // Inferences made from return types have lower priority than all other inferences.
	                    inferTypes(context.inferences, inferenceSourceType, inferenceTargetType, 4 /* ReturnType */);
	                }
	            }
	            var thisType = getThisTypeOfSignature(signature);
	            if (thisType) {
	                var thisArgumentNode = getThisArgumentOfCall(node);
	                var thisArgumentType = thisArgumentNode ? checkExpression(thisArgumentNode) : voidType;
	                inferTypes(context.inferences, thisArgumentType, thisType);
	            }
	            // We perform two passes over the arguments. In the first pass we infer from all arguments, but use
	            // wildcards for all context sensitive function expressions.
	            var argCount = getEffectiveArgumentCount(node, args, signature);
	            for (var i = 0; i < argCount; i++) {
	                var arg = getEffectiveArgument(node, args, i);
	                // If the effective argument is 'undefined', then it is an argument that is present but is synthetic.
	                if (arg === undefined || arg.kind !== 204 /* OmittedExpression */) {
	                    var paramType = getTypeAtPosition(signature, i);
	                    var argType = getEffectiveArgumentType(node, i);
	                    // If the effective argument type is 'undefined', there is no synthetic type
	                    // for the argument. In that case, we should check the argument.
	                    if (argType === undefined) {
	                        // For context sensitive arguments we pass the identityMapper, which is a signal to treat all
	                        // context sensitive function expressions as wildcards
	                        var mapper = excludeArgument && excludeArgument[i] !== undefined ? identityMapper : context;
	                        argType = checkExpressionWithContextualType(arg, paramType, mapper);
	                    }
	                    inferTypes(context.inferences, argType, paramType);
	                }
	            }
	            // In the second pass we visit only context sensitive arguments, and only those that aren't excluded, this
	            // time treating function expressions normally (which may cause previously inferred type arguments to be fixed
	            // as we construct types for contextually typed parameters)
	            // Decorators will not have `excludeArgument`, as their arguments cannot be contextually typed.
	            // Tagged template expressions will always have `undefined` for `excludeArgument[0]`.
	            if (excludeArgument) {
	                for (var i = 0; i < argCount; i++) {
	                    // No need to check for omitted args and template expressions, their exclusion value is always undefined
	                    if (excludeArgument[i] === false) {
	                        var arg = args[i];
	                        var paramType = getTypeAtPosition(signature, i);
	                        inferTypes(context.inferences, checkExpressionWithContextualType(arg, paramType, context), paramType);
	                    }
	                }
	            }
	            return getInferredTypes(context);
	        }
	        function checkTypeArguments(signature, typeArgumentNodes, reportErrors, headMessage) {
	            var isJavascript = ts.isInJavaScriptFile(signature.declaration);
	            var typeParameters = signature.typeParameters;
	            var typeArgumentTypes = fillMissingTypeArguments(ts.map(typeArgumentNodes, getTypeFromTypeNode), typeParameters, getMinTypeArgumentCount(typeParameters), isJavascript);
	            var mapper;
	            for (var i = 0; i < typeArgumentNodes.length; i++) {
	                ts.Debug.assert(typeParameters[i] !== undefined, "Should not call checkTypeArguments with too many type arguments");
	                var constraint = getConstraintOfTypeParameter(typeParameters[i]);
	                if (!constraint)
	                    continue;
	                var errorInfo = reportErrors && headMessage && (function () { return ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.Type_0_does_not_satisfy_the_constraint_1); });
	                var typeArgumentHeadMessage = headMessage || ts.Diagnostics.Type_0_does_not_satisfy_the_constraint_1;
	                if (!mapper) {
	                    mapper = createTypeMapper(typeParameters, typeArgumentTypes);
	                }
	                var typeArgument = typeArgumentTypes[i];
	                if (!checkTypeAssignableTo(typeArgument, getTypeWithThisArgument(instantiateType(constraint, mapper), typeArgument), reportErrors ? typeArgumentNodes[i] : undefined, typeArgumentHeadMessage, errorInfo)) {
	                    return false;
	                }
	            }
	            return typeArgumentTypes;
	        }
	        /**
	         * Check if the given signature can possibly be a signature called by the JSX opening-like element.
	         * @param node a JSX opening-like element we are trying to figure its call signature
	         * @param signature a candidate signature we are trying whether it is a call signature
	         * @param relation a relationship to check parameter and argument type
	         * @param excludeArgument
	         */
	        function checkApplicableSignatureForJsxOpeningLikeElement(node, signature, relation) {
	            // JSX opening-like element has correct arity for stateless-function component if the one of the following condition is true:
	            //      1. callIsIncomplete
	            //      2. attributes property has same number of properties as the parameter object type.
	            //         We can figure that out by resolving attributes property and check number of properties in the resolved type
	            // If the call has correct arity, we will then check if the argument type and parameter type is assignable
	            var callIsIncomplete = node.attributes.end === node.end; // If we are missing the close "/>", the call is incomplete
	            if (callIsIncomplete) {
	                return true;
	            }
	            var headMessage = ts.Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1;
	            // Stateless function components can have maximum of three arguments: "props", "context", and "updater".
	            // However "context" and "updater" are implicit and can't be specify by users. Only the first parameter, props,
	            // can be specified by users through attributes property.
	            var paramType = getTypeAtPosition(signature, 0);
	            var attributesType = checkExpressionWithContextualType(node.attributes, paramType, /*contextualMapper*/ undefined);
	            var argProperties = getPropertiesOfType(attributesType);
	            for (var _i = 0, argProperties_1 = argProperties; _i < argProperties_1.length; _i++) {
	                var arg = argProperties_1[_i];
	                if (!getPropertyOfType(paramType, arg.escapedName) && isUnhyphenatedJsxName(arg.escapedName)) {
	                    return false;
	                }
	            }
	            return checkTypeRelatedTo(attributesType, paramType, relation, /*errorNode*/ undefined, headMessage);
	        }
	        function checkApplicableSignature(node, args, signature, relation, excludeArgument, reportErrors) {
	            if (ts.isJsxOpeningLikeElement(node)) {
	                return checkApplicableSignatureForJsxOpeningLikeElement(node, signature, relation);
	            }
	            var thisType = getThisTypeOfSignature(signature);
	            if (thisType && thisType !== voidType && node.kind !== 186 /* NewExpression */) {
	                // If the called expression is not of the form `x.f` or `x["f"]`, then sourceType = voidType
	                // If the signature's 'this' type is voidType, then the check is skipped -- anything is compatible.
	                // If the expression is a new expression, then the check is skipped.
	                var thisArgumentNode = getThisArgumentOfCall(node);
	                var thisArgumentType = thisArgumentNode ? checkExpression(thisArgumentNode) : voidType;
	                var errorNode = reportErrors ? (thisArgumentNode || node) : undefined;
	                var headMessage_1 = ts.Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1;
	                if (!checkTypeRelatedTo(thisArgumentType, getThisTypeOfSignature(signature), relation, errorNode, headMessage_1)) {
	                    return false;
	                }
	            }
	            var headMessage = ts.Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1;
	            var argCount = getEffectiveArgumentCount(node, args, signature);
	            for (var i = 0; i < argCount; i++) {
	                var arg = getEffectiveArgument(node, args, i);
	                // If the effective argument is 'undefined', then it is an argument that is present but is synthetic.
	                if (arg === undefined || arg.kind !== 204 /* OmittedExpression */) {
	                    // Check spread elements against rest type (from arity check we know spread argument corresponds to a rest parameter)
	                    var paramType = getTypeAtPosition(signature, i);
	                    // If the effective argument type is undefined, there is no synthetic type for the argument.
	                    // In that case, we should check the argument.
	                    var argType = getEffectiveArgumentType(node, i) ||
	                        checkExpressionWithContextualType(arg, paramType, excludeArgument && excludeArgument[i] ? identityMapper : undefined);
	                    // If one or more arguments are still excluded (as indicated by a non-null excludeArgument parameter),
	                    // we obtain the regular type of any object literal arguments because we may not have inferred complete
	                    // parameter types yet and therefore excess property checks may yield false positives (see #17041).
	                    var checkArgType = excludeArgument ? getRegularTypeOfObjectLiteral(argType) : argType;
	                    // Use argument expression as error location when reporting errors
	                    var errorNode = reportErrors ? getEffectiveArgumentErrorNode(node, i, arg) : undefined;
	                    if (!checkTypeRelatedTo(checkArgType, paramType, relation, errorNode, headMessage)) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }
	        /**
	         * Returns the this argument in calls like x.f(...) and x[f](...). Undefined otherwise.
	         */
	        function getThisArgumentOfCall(node) {
	            if (node.kind === 185 /* CallExpression */) {
	                var callee = node.expression;
	                if (callee.kind === 183 /* PropertyAccessExpression */) {
	                    return callee.expression;
	                }
	                else if (callee.kind === 184 /* ElementAccessExpression */) {
	                    return callee.expression;
	                }
	            }
	        }
	        /**
	         * Returns the effective arguments for an expression that works like a function invocation.
	         *
	         * If 'node' is a CallExpression or a NewExpression, then its argument list is returned.
	         * If 'node' is a TaggedTemplateExpression, a new argument list is constructed from the substitution
	         *    expressions, where the first element of the list is `undefined`.
	         * If 'node' is a Decorator, the argument list will be `undefined`, and its arguments and types
	         *    will be supplied from calls to `getEffectiveArgumentCount` and `getEffectiveArgumentType`.
	         */
	        function getEffectiveCallArguments(node) {
	            if (node.kind === 187 /* TaggedTemplateExpression */) {
	                var template = node.template;
	                var args_4 = [undefined];
	                if (template.kind === 200 /* TemplateExpression */) {
	                    ts.forEach(template.templateSpans, function (span) {
	                        args_4.push(span.expression);
	                    });
	                }
	                return args_4;
	            }
	            else if (node.kind === 149 /* Decorator */) {
	                // For a decorator, we return undefined as we will determine
	                // the number and types of arguments for a decorator using
	                // `getEffectiveArgumentCount` and `getEffectiveArgumentType` below.
	                return undefined;
	            }
	            else if (ts.isJsxOpeningLikeElement(node)) {
	                return node.attributes.properties.length > 0 ? [node.attributes] : ts.emptyArray;
	            }
	            else {
	                return node.arguments || ts.emptyArray;
	            }
	        }
	        /**
	         * Returns the effective argument count for a node that works like a function invocation.
	         * If 'node' is a Decorator, the number of arguments is derived from the decoration
	         *    target and the signature:
	         *    If 'node.target' is a class declaration or class expression, the effective argument
	         *       count is 1.
	         *    If 'node.target' is a parameter declaration, the effective argument count is 3.
	         *    If 'node.target' is a property declaration, the effective argument count is 2.
	         *    If 'node.target' is a method or accessor declaration, the effective argument count
	         *       is 3, although it can be 2 if the signature only accepts two arguments, allowing
	         *       us to match a property decorator.
	         * Otherwise, the argument count is the length of the 'args' array.
	         */
	        function getEffectiveArgumentCount(node, args, signature) {
	            if (node.kind === 149 /* Decorator */) {
	                switch (node.parent.kind) {
	                    case 233 /* ClassDeclaration */:
	                    case 203 /* ClassExpression */:
	                        // A class decorator will have one argument (see `ClassDecorator` in core.d.ts)
	                        return 1;
	                    case 151 /* PropertyDeclaration */:
	                        // A property declaration decorator will have two arguments (see
	                        // `PropertyDecorator` in core.d.ts)
	                        return 2;
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        // A method or accessor declaration decorator will have two or three arguments (see
	                        // `PropertyDecorator` and `MethodDecorator` in core.d.ts)
	                        // If we are emitting decorators for ES3, we will only pass two arguments.
	                        if (languageVersion === 0 /* ES3 */) {
	                            return 2;
	                        }
	                        // If the method decorator signature only accepts a target and a key, we will only
	                        // type check those arguments.
	                        return signature.parameters.length >= 3 ? 3 : 2;
	                    case 148 /* Parameter */:
	                        // A parameter declaration decorator will have three arguments (see
	                        // `ParameterDecorator` in core.d.ts)
	                        return 3;
	                }
	            }
	            else {
	                return args.length;
	            }
	        }
	        /**
	         * Returns the effective type of the first argument to a decorator.
	         * If 'node' is a class declaration or class expression, the effective argument type
	         *    is the type of the static side of the class.
	         * If 'node' is a parameter declaration, the effective argument type is either the type
	         *    of the static or instance side of the class for the parameter's parent method,
	         *    depending on whether the method is declared static.
	         *    For a constructor, the type is always the type of the static side of the class.
	         * If 'node' is a property, method, or accessor declaration, the effective argument
	         *    type is the type of the static or instance side of the parent class for class
	         *    element, depending on whether the element is declared static.
	         */
	        function getEffectiveDecoratorFirstArgumentType(node) {
	            // The first argument to a decorator is its `target`.
	            if (node.kind === 233 /* ClassDeclaration */) {
	                // For a class decorator, the `target` is the type of the class (e.g. the
	                // "static" or "constructor" side of the class)
	                var classSymbol = getSymbolOfNode(node);
	                return getTypeOfSymbol(classSymbol);
	            }
	            if (node.kind === 148 /* Parameter */) {
	                // For a parameter decorator, the `target` is the parent type of the
	                // parameter's containing method.
	                node = node.parent;
	                if (node.kind === 154 /* Constructor */) {
	                    var classSymbol = getSymbolOfNode(node);
	                    return getTypeOfSymbol(classSymbol);
	                }
	            }
	            if (node.kind === 151 /* PropertyDeclaration */ ||
	                node.kind === 153 /* MethodDeclaration */ ||
	                node.kind === 155 /* GetAccessor */ ||
	                node.kind === 156 /* SetAccessor */) {
	                // For a property or method decorator, the `target` is the
	                // "static"-side type of the parent of the member if the member is
	                // declared "static"; otherwise, it is the "instance"-side type of the
	                // parent of the member.
	                return getParentTypeOfClassElement(node);
	            }
	            ts.Debug.fail("Unsupported decorator target.");
	            return unknownType;
	        }
	        /**
	         * Returns the effective type for the second argument to a decorator.
	         * If 'node' is a parameter, its effective argument type is one of the following:
	         *    If 'node.parent' is a constructor, the effective argument type is 'any', as we
	         *       will emit `undefined`.
	         *    If 'node.parent' is a member with an identifier, numeric, or string literal name,
	         *       the effective argument type will be a string literal type for the member name.
	         *    If 'node.parent' is a computed property name, the effective argument type will
	         *       either be a symbol type or the string type.
	         * If 'node' is a member with an identifier, numeric, or string literal name, the
	         *    effective argument type will be a string literal type for the member name.
	         * If 'node' is a computed property name, the effective argument type will either
	         *    be a symbol type or the string type.
	         * A class decorator does not have a second argument type.
	         */
	        function getEffectiveDecoratorSecondArgumentType(node) {
	            // The second argument to a decorator is its `propertyKey`
	            if (node.kind === 233 /* ClassDeclaration */) {
	                ts.Debug.fail("Class decorators should not have a second synthetic argument.");
	                return unknownType;
	            }
	            if (node.kind === 148 /* Parameter */) {
	                node = node.parent;
	                if (node.kind === 154 /* Constructor */) {
	                    // For a constructor parameter decorator, the `propertyKey` will be `undefined`.
	                    return anyType;
	                }
	                // For a non-constructor parameter decorator, the `propertyKey` will be either
	                // a string or a symbol, based on the name of the parameter's containing method.
	            }
	            if (node.kind === 151 /* PropertyDeclaration */ ||
	                node.kind === 153 /* MethodDeclaration */ ||
	                node.kind === 155 /* GetAccessor */ ||
	                node.kind === 156 /* SetAccessor */) {
	                // The `propertyKey` for a property or method decorator will be a
	                // string literal type if the member name is an identifier, number, or string;
	                // otherwise, if the member name is a computed property name it will
	                // be either string or symbol.
	                var element = node;
	                switch (element.name.kind) {
	                    case 71 /* Identifier */:
	                        return getLiteralType(ts.idText(element.name));
	                    case 8 /* NumericLiteral */:
	                    case 9 /* StringLiteral */:
	                        return getLiteralType(element.name.text);
	                    case 146 /* ComputedPropertyName */:
	                        var nameType = checkComputedPropertyName(element.name);
	                        if (isTypeAssignableToKind(nameType, 1536 /* ESSymbolLike */)) {
	                            return nameType;
	                        }
	                        else {
	                            return stringType;
	                        }
	                    default:
	                        ts.Debug.fail("Unsupported property name.");
	                        return unknownType;
	                }
	            }
	            ts.Debug.fail("Unsupported decorator target.");
	            return unknownType;
	        }
	        /**
	         * Returns the effective argument type for the third argument to a decorator.
	         * If 'node' is a parameter, the effective argument type is the number type.
	         * If 'node' is a method or accessor, the effective argument type is a
	         *    `TypedPropertyDescriptor<T>` instantiated with the type of the member.
	         * Class and property decorators do not have a third effective argument.
	         */
	        function getEffectiveDecoratorThirdArgumentType(node) {
	            // The third argument to a decorator is either its `descriptor` for a method decorator
	            // or its `parameterIndex` for a parameter decorator
	            if (node.kind === 233 /* ClassDeclaration */) {
	                ts.Debug.fail("Class decorators should not have a third synthetic argument.");
	                return unknownType;
	            }
	            if (node.kind === 148 /* Parameter */) {
	                // The `parameterIndex` for a parameter decorator is always a number
	                return numberType;
	            }
	            if (node.kind === 151 /* PropertyDeclaration */) {
	                ts.Debug.fail("Property decorators should not have a third synthetic argument.");
	                return unknownType;
	            }
	            if (node.kind === 153 /* MethodDeclaration */ ||
	                node.kind === 155 /* GetAccessor */ ||
	                node.kind === 156 /* SetAccessor */) {
	                // The `descriptor` for a method decorator will be a `TypedPropertyDescriptor<T>`
	                // for the type of the member.
	                var propertyType = getTypeOfNode(node);
	                return createTypedPropertyDescriptorType(propertyType);
	            }
	            ts.Debug.fail("Unsupported decorator target.");
	            return unknownType;
	        }
	        /**
	         * Returns the effective argument type for the provided argument to a decorator.
	         */
	        function getEffectiveDecoratorArgumentType(node, argIndex) {
	            if (argIndex === 0) {
	                return getEffectiveDecoratorFirstArgumentType(node.parent);
	            }
	            else if (argIndex === 1) {
	                return getEffectiveDecoratorSecondArgumentType(node.parent);
	            }
	            else if (argIndex === 2) {
	                return getEffectiveDecoratorThirdArgumentType(node.parent);
	            }
	            ts.Debug.fail("Decorators should not have a fourth synthetic argument.");
	            return unknownType;
	        }
	        /**
	         * Gets the effective argument type for an argument in a call expression.
	         */
	        function getEffectiveArgumentType(node, argIndex) {
	            // Decorators provide special arguments, a tagged template expression provides
	            // a special first argument, and string literals get string literal types
	            // unless we're reporting errors
	            if (node.kind === 149 /* Decorator */) {
	                return getEffectiveDecoratorArgumentType(node, argIndex);
	            }
	            else if (argIndex === 0 && node.kind === 187 /* TaggedTemplateExpression */) {
	                return getGlobalTemplateStringsArrayType();
	            }
	            // This is not a synthetic argument, so we return 'undefined'
	            // to signal that the caller needs to check the argument.
	            return undefined;
	        }
	        /**
	         * Gets the effective argument expression for an argument in a call expression.
	         */
	        function getEffectiveArgument(node, args, argIndex) {
	            // For a decorator or the first argument of a tagged template expression we return undefined.
	            if (node.kind === 149 /* Decorator */ ||
	                (argIndex === 0 && node.kind === 187 /* TaggedTemplateExpression */)) {
	                return undefined;
	            }
	            return args[argIndex];
	        }
	        /**
	         * Gets the error node to use when reporting errors for an effective argument.
	         */
	        function getEffectiveArgumentErrorNode(node, argIndex, arg) {
	            if (node.kind === 149 /* Decorator */) {
	                // For a decorator, we use the expression of the decorator for error reporting.
	                return node.expression;
	            }
	            else if (argIndex === 0 && node.kind === 187 /* TaggedTemplateExpression */) {
	                // For a the first argument of a tagged template expression, we use the template of the tag for error reporting.
	                return node.template;
	            }
	            else {
	                return arg;
	            }
	        }
	        function resolveCall(node, signatures, candidatesOutArray, fallbackError) {
	            var isTaggedTemplate = node.kind === 187 /* TaggedTemplateExpression */;
	            var isDecorator = node.kind === 149 /* Decorator */;
	            var isJsxOpeningOrSelfClosingElement = ts.isJsxOpeningLikeElement(node);
	            var typeArguments;
	            if (!isTaggedTemplate && !isDecorator && !isJsxOpeningOrSelfClosingElement) {
	                typeArguments = node.typeArguments;
	                // We already perform checking on the type arguments on the class declaration itself.
	                if (node.expression.kind !== 97 /* SuperKeyword */) {
	                    ts.forEach(typeArguments, checkSourceElement);
	                }
	            }
	            var candidates = candidatesOutArray || [];
	            // reorderCandidates fills up the candidates array directly
	            reorderCandidates(signatures, candidates);
	            if (!candidates.length) {
	                diagnostics.add(ts.createDiagnosticForNode(node, ts.Diagnostics.Call_target_does_not_contain_any_signatures));
	                return resolveErrorCall(node);
	            }
	            var args = getEffectiveCallArguments(node);
	            // The following applies to any value of 'excludeArgument[i]':
	            //    - true:      the argument at 'i' is susceptible to a one-time permanent contextual typing.
	            //    - undefined: the argument at 'i' is *not* susceptible to permanent contextual typing.
	            //    - false:     the argument at 'i' *was* and *has been* permanently contextually typed.
	            //
	            // The idea is that we will perform type argument inference & assignability checking once
	            // without using the susceptible parameters that are functions, and once more for each of those
	            // parameters, contextually typing each as we go along.
	            //
	            // For a tagged template, then the first argument be 'undefined' if necessary
	            // because it represents a TemplateStringsArray.
	            //
	            // For a decorator, no arguments are susceptible to contextual typing due to the fact
	            // decorators are applied to a declaration by the emitter, and not to an expression.
	            var isSingleNonGenericCandidate = candidates.length === 1 && !candidates[0].typeParameters;
	            var excludeArgument;
	            var excludeCount = 0;
	            if (!isDecorator && !isSingleNonGenericCandidate) {
	                // We do not need to call `getEffectiveArgumentCount` here as it only
	                // applies when calculating the number of arguments for a decorator.
	                for (var i = isTaggedTemplate ? 1 : 0; i < args.length; i++) {
	                    if (isContextSensitive(args[i])) {
	                        if (!excludeArgument) {
	                            excludeArgument = new Array(args.length);
	                        }
	                        excludeArgument[i] = true;
	                        excludeCount++;
	                    }
	                }
	            }
	            // The following variables are captured and modified by calls to chooseOverload.
	            // If overload resolution or type argument inference fails, we want to report the
	            // best error possible. The best error is one which says that an argument was not
	            // assignable to a parameter. This implies that everything else about the overload
	            // was fine. So if there is any overload that is only incorrect because of an
	            // argument, we will report an error on that one.
	            //
	            //     function foo(s: string): void;
	            //     function foo(n: number): void; // Report argument error on this overload
	            //     function foo(): void;
	            //     foo(true);
	            //
	            // If none of the overloads even made it that far, there are two possibilities.
	            // There was a problem with type arguments for some overload, in which case
	            // report an error on that. Or none of the overloads even had correct arity,
	            // in which case give an arity error.
	            //
	            //     function foo<T extends string>(x: T): void; // Report type argument error
	            //     function foo(): void;
	            //     foo<number>(0);
	            //
	            var candidateForArgumentError;
	            var candidateForTypeArgumentError;
	            var result;
	            // If we are in signature help, a trailing comma indicates that we intend to provide another argument,
	            // so we will only accept overloads with arity at least 1 higher than the current number of provided arguments.
	            var signatureHelpTrailingComma = candidatesOutArray && node.kind === 185 /* CallExpression */ && node.arguments.hasTrailingComma;
	            // Section 4.12.1:
	            // if the candidate list contains one or more signatures for which the type of each argument
	            // expression is a subtype of each corresponding parameter type, the return type of the first
	            // of those signatures becomes the return type of the function call.
	            // Otherwise, the return type of the first signature in the candidate list becomes the return
	            // type of the function call.
	            //
	            // Whether the call is an error is determined by assignability of the arguments. The subtype pass
	            // is just important for choosing the best signature. So in the case where there is only one
	            // signature, the subtype pass is useless. So skipping it is an optimization.
	            if (candidates.length > 1) {
	                result = chooseOverload(candidates, subtypeRelation, signatureHelpTrailingComma);
	            }
	            if (!result) {
	                result = chooseOverload(candidates, assignableRelation, signatureHelpTrailingComma);
	            }
	            if (result) {
	                return result;
	            }
	            // No signatures were applicable. Now report errors based on the last applicable signature with
	            // no arguments excluded from assignability checks.
	            // If candidate is undefined, it means that no candidates had a suitable arity. In that case,
	            // skip the checkApplicableSignature check.
	            if (candidateForArgumentError) {
	                if (isJsxOpeningOrSelfClosingElement) {
	                    // We do not report any error here because any error will be handled in "resolveCustomJsxElementAttributesType".
	                    return candidateForArgumentError;
	                }
	                // excludeArgument is undefined, in this case also equivalent to [undefined, undefined, ...]
	                // The importance of excludeArgument is to prevent us from typing function expression parameters
	                // in arguments too early. If possible, we'd like to only type them once we know the correct
	                // overload. However, this matters for the case where the call is correct. When the call is
	                // an error, we don't need to exclude any arguments, although it would cause no harm to do so.
	                checkApplicableSignature(node, args, candidateForArgumentError, assignableRelation, /*excludeArgument*/ undefined, /*reportErrors*/ true);
	            }
	            else if (candidateForTypeArgumentError) {
	                checkTypeArguments(candidateForTypeArgumentError, node.typeArguments, /*reportErrors*/ true, fallbackError);
	            }
	            else if (typeArguments && ts.every(signatures, function (sig) { return ts.length(sig.typeParameters) !== typeArguments.length; })) {
	                var min = Number.POSITIVE_INFINITY;
	                var max = Number.NEGATIVE_INFINITY;
	                for (var _i = 0, signatures_5 = signatures; _i < signatures_5.length; _i++) {
	                    var sig = signatures_5[_i];
	                    min = Math.min(min, getMinTypeArgumentCount(sig.typeParameters));
	                    max = Math.max(max, ts.length(sig.typeParameters));
	                }
	                var paramCount = min < max ? min + "-" + max : min;
	                diagnostics.add(ts.createDiagnosticForNodeArray(ts.getSourceFileOfNode(node), typeArguments, ts.Diagnostics.Expected_0_type_arguments_but_got_1, paramCount, typeArguments.length));
	            }
	            else if (args) {
	                var min = Number.POSITIVE_INFINITY;
	                var max = Number.NEGATIVE_INFINITY;
	                for (var _a = 0, signatures_6 = signatures; _a < signatures_6.length; _a++) {
	                    var sig = signatures_6[_a];
	                    min = Math.min(min, sig.minArgumentCount);
	                    max = Math.max(max, sig.parameters.length);
	                }
	                var hasRestParameter_1 = ts.some(signatures, function (sig) { return sig.hasRestParameter; });
	                var hasSpreadArgument = getSpreadArgumentIndex(args) > -1;
	                var paramCount = hasRestParameter_1 ? min :
	                    min < max ? min + "-" + max :
	                        min;
	                var argCount = args.length;
	                if (argCount <= max && hasSpreadArgument) {
	                    argCount--;
	                }
	                var error_1 = hasRestParameter_1 && hasSpreadArgument ? ts.Diagnostics.Expected_at_least_0_arguments_but_got_1_or_more :
	                    hasRestParameter_1 ? ts.Diagnostics.Expected_at_least_0_arguments_but_got_1 :
	                        hasSpreadArgument ? ts.Diagnostics.Expected_0_arguments_but_got_1_or_more :
	                            ts.Diagnostics.Expected_0_arguments_but_got_1;
	                diagnostics.add(ts.createDiagnosticForNode(node, error_1, paramCount, argCount));
	            }
	            else if (fallbackError) {
	                diagnostics.add(ts.createDiagnosticForNode(node, fallbackError));
	            }
	            // No signature was applicable. We have already reported the errors for the invalid signature.
	            // If this is a type resolution session, e.g. Language Service, try to get better information than anySignature.
	            // Pick the longest signature. This way we can get a contextual type for cases like:
	            //     declare function f(a: { xa: number; xb: number; }, b: number);
	            //     f({ |
	            // Also, use explicitly-supplied type arguments if they are provided, so we can get a contextual signature in cases like:
	            //     declare function f<T>(k: keyof T);
	            //     f<Foo>("
	            if (!produceDiagnostics) {
	                ts.Debug.assert(candidates.length > 0); // Else would have exited above.
	                var bestIndex = getLongestCandidateIndex(candidates, apparentArgumentCount === undefined ? args.length : apparentArgumentCount);
	                var candidate = candidates[bestIndex];
	                var typeParameters = candidate.typeParameters;
	                if (typeParameters && callLikeExpressionMayHaveTypeArguments(node) && node.typeArguments) {
	                    var typeArguments_1 = node.typeArguments.map(getTypeOfNode);
	                    while (typeArguments_1.length > typeParameters.length) {
	                        typeArguments_1.pop();
	                    }
	                    while (typeArguments_1.length < typeParameters.length) {
	                        typeArguments_1.push(getDefaultTypeArgumentType(ts.isInJavaScriptFile(node)));
	                    }
	                    var instantiated = createSignatureInstantiation(candidate, typeArguments_1);
	                    candidates[bestIndex] = instantiated;
	                    return instantiated;
	                }
	                return candidate;
	            }
	            return resolveErrorCall(node);
	            function chooseOverload(candidates, relation, signatureHelpTrailingComma) {
	                if (signatureHelpTrailingComma === void 0) { signatureHelpTrailingComma = false; }
	                candidateForArgumentError = undefined;
	                candidateForTypeArgumentError = undefined;
	                if (isSingleNonGenericCandidate) {
	                    var candidate = candidates[0];
	                    if (!hasCorrectArity(node, args, candidate, signatureHelpTrailingComma)) {
	                        return undefined;
	                    }
	                    if (!checkApplicableSignature(node, args, candidate, relation, excludeArgument, /*reportErrors*/ false)) {
	                        candidateForArgumentError = candidate;
	                        return undefined;
	                    }
	                    return candidate;
	                }
	                for (var candidateIndex = 0; candidateIndex < candidates.length; candidateIndex++) {
	                    var originalCandidate = candidates[candidateIndex];
	                    if (!hasCorrectArity(node, args, originalCandidate, signatureHelpTrailingComma)) {
	                        continue;
	                    }
	                    var candidate = void 0;
	                    var inferenceContext = originalCandidate.typeParameters ?
	                        createInferenceContext(originalCandidate, /*flags*/ ts.isInJavaScriptFile(node) ? 4 /* AnyDefault */ : 0 /* None */) :
	                        undefined;
	                    while (true) {
	                        candidate = originalCandidate;
	                        if (candidate.typeParameters) {
	                            var typeArgumentTypes = void 0;
	                            if (typeArguments) {
	                                var typeArgumentResult = checkTypeArguments(candidate, typeArguments, /*reportErrors*/ false);
	                                if (typeArgumentResult) {
	                                    typeArgumentTypes = typeArgumentResult;
	                                }
	                                else {
	                                    candidateForTypeArgumentError = originalCandidate;
	                                    break;
	                                }
	                            }
	                            else {
	                                typeArgumentTypes = inferTypeArguments(node, candidate, args, excludeArgument, inferenceContext);
	                            }
	                            var isJavascript = ts.isInJavaScriptFile(candidate.declaration);
	                            candidate = getSignatureInstantiation(candidate, typeArgumentTypes, isJavascript);
	                        }
	                        if (!checkApplicableSignature(node, args, candidate, relation, excludeArgument, /*reportErrors*/ false)) {
	                            candidateForArgumentError = candidate;
	                            break;
	                        }
	                        if (excludeCount === 0) {
	                            candidates[candidateIndex] = candidate;
	                            return candidate;
	                        }
	                        excludeCount--;
	                        if (excludeCount > 0) {
	                            excludeArgument[excludeArgument.indexOf(/*value*/ true)] = false;
	                        }
	                        else {
	                            excludeArgument = undefined;
	                        }
	                    }
	                }
	                return undefined;
	            }
	        }
	        function getLongestCandidateIndex(candidates, argsCount) {
	            var maxParamsIndex = -1;
	            var maxParams = -1;
	            for (var i = 0; i < candidates.length; i++) {
	                var candidate = candidates[i];
	                if (candidate.hasRestParameter || candidate.parameters.length >= argsCount) {
	                    return i;
	                }
	                if (candidate.parameters.length > maxParams) {
	                    maxParams = candidate.parameters.length;
	                    maxParamsIndex = i;
	                }
	            }
	            return maxParamsIndex;
	        }
	        function resolveCallExpression(node, candidatesOutArray) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                var superType = checkSuperExpression(node.expression);
	                if (superType !== unknownType) {
	                    // In super call, the candidate signatures are the matching arity signatures of the base constructor function instantiated
	                    // with the type arguments specified in the extends clause.
	                    var baseTypeNode = ts.getClassExtendsHeritageClauseElement(ts.getContainingClass(node));
	                    if (baseTypeNode) {
	                        var baseConstructors = getInstantiatedConstructorsForTypeArguments(superType, baseTypeNode.typeArguments, baseTypeNode);
	                        return resolveCall(node, baseConstructors, candidatesOutArray);
	                    }
	                }
	                return resolveUntypedCall(node);
	            }
	            var funcType = checkNonNullExpression(node.expression, ts.Diagnostics.Cannot_invoke_an_object_which_is_possibly_null, ts.Diagnostics.Cannot_invoke_an_object_which_is_possibly_undefined, ts.Diagnostics.Cannot_invoke_an_object_which_is_possibly_null_or_undefined);
	            if (funcType === silentNeverType) {
	                return silentNeverSignature;
	            }
	            var apparentType = getApparentType(funcType);
	            if (apparentType === unknownType) {
	                // Another error has already been reported
	                return resolveErrorCall(node);
	            }
	            // Technically, this signatures list may be incomplete. We are taking the apparent type,
	            // but we are not including call signatures that may have been added to the Object or
	            // Function interface, since they have none by default. This is a bit of a leap of faith
	            // that the user will not add any.
	            var callSignatures = getSignaturesOfType(apparentType, 0 /* Call */);
	            var constructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */);
	            // TS 1.0 Spec: 4.12
	            // In an untyped function call no TypeArgs are permitted, Args can be any argument list, no contextual
	            // types are provided for the argument expressions, and the result is always of type Any.
	            if (isUntypedFunctionCall(funcType, apparentType, callSignatures.length, constructSignatures.length)) {
	                // The unknownType indicates that an error already occurred (and was reported).  No
	                // need to report another error in this case.
	                if (funcType !== unknownType && node.typeArguments) {
	                    error(node, ts.Diagnostics.Untyped_function_calls_may_not_accept_type_arguments);
	                }
	                return resolveUntypedCall(node);
	            }
	            // If FuncExpr's apparent type(section 3.8.1) is a function type, the call is a typed function call.
	            // TypeScript employs overload resolution in typed function calls in order to support functions
	            // with multiple call signatures.
	            if (!callSignatures.length) {
	                if (constructSignatures.length) {
	                    error(node, ts.Diagnostics.Value_of_type_0_is_not_callable_Did_you_mean_to_include_new, typeToString(funcType));
	                }
	                else {
	                    invocationError(node, apparentType, 0 /* Call */);
	                }
	                return resolveErrorCall(node);
	            }
	            return resolveCall(node, callSignatures, candidatesOutArray);
	        }
	        /**
	         * TS 1.0 spec: 4.12
	         * If FuncExpr is of type Any, or of an object type that has no call or construct signatures
	         * but is a subtype of the Function interface, the call is an untyped function call.
	         */
	        function isUntypedFunctionCall(funcType, apparentFuncType, numCallSignatures, numConstructSignatures) {
	            // We exclude union types because we may have a union of function types that happen to have no common signatures.
	            return isTypeAny(funcType) || isTypeAny(apparentFuncType) && funcType.flags & 32768 /* TypeParameter */ ||
	                !numCallSignatures && !numConstructSignatures && !(apparentFuncType.flags & (131072 /* Union */ | 16384 /* Never */)) && isTypeAssignableTo(funcType, globalFunctionType);
	        }
	        function resolveNewExpression(node, candidatesOutArray) {
	            if (node.arguments && languageVersion < 1 /* ES5 */) {
	                var spreadIndex = getSpreadArgumentIndex(node.arguments);
	                if (spreadIndex >= 0) {
	                    error(node.arguments[spreadIndex], ts.Diagnostics.Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher);
	                }
	            }
	            var expressionType = checkNonNullExpression(node.expression);
	            if (expressionType === silentNeverType) {
	                return silentNeverSignature;
	            }
	            // If expressionType's apparent type(section 3.8.1) is an object type with one or
	            // more construct signatures, the expression is processed in the same manner as a
	            // function call, but using the construct signatures as the initial set of candidate
	            // signatures for overload resolution. The result type of the function call becomes
	            // the result type of the operation.
	            expressionType = getApparentType(expressionType);
	            if (expressionType === unknownType) {
	                // Another error has already been reported
	                return resolveErrorCall(node);
	            }
	            // TS 1.0 spec: 4.11
	            // If expressionType is of type Any, Args can be any argument
	            // list and the result of the operation is of type Any.
	            if (isTypeAny(expressionType)) {
	                if (node.typeArguments) {
	                    error(node, ts.Diagnostics.Untyped_function_calls_may_not_accept_type_arguments);
	                }
	                return resolveUntypedCall(node);
	            }
	            // Technically, this signatures list may be incomplete. We are taking the apparent type,
	            // but we are not including construct signatures that may have been added to the Object or
	            // Function interface, since they have none by default. This is a bit of a leap of faith
	            // that the user will not add any.
	            var constructSignatures = getSignaturesOfType(expressionType, 1 /* Construct */);
	            if (constructSignatures.length) {
	                if (!isConstructorAccessible(node, constructSignatures[0])) {
	                    return resolveErrorCall(node);
	                }
	                // If the expression is a class of abstract type, then it cannot be instantiated.
	                // Note, only class declarations can be declared abstract.
	                // In the case of a merged class-module or class-interface declaration,
	                // only the class declaration node will have the Abstract flag set.
	                var valueDecl = expressionType.symbol && ts.getClassLikeDeclarationOfSymbol(expressionType.symbol);
	                if (valueDecl && ts.hasModifier(valueDecl, 128 /* Abstract */)) {
	                    error(node, ts.Diagnostics.Cannot_create_an_instance_of_an_abstract_class);
	                    return resolveErrorCall(node);
	                }
	                return resolveCall(node, constructSignatures, candidatesOutArray);
	            }
	            // If expressionType's apparent type is an object type with no construct signatures but
	            // one or more call signatures, the expression is processed as a function call. A compile-time
	            // error occurs if the result of the function call is not Void. The type of the result of the
	            // operation is Any. It is an error to have a Void this type.
	            var callSignatures = getSignaturesOfType(expressionType, 0 /* Call */);
	            if (callSignatures.length) {
	                var signature = resolveCall(node, callSignatures, candidatesOutArray);
	                if (!isJavaScriptConstructor(signature.declaration) && getReturnTypeOfSignature(signature) !== voidType) {
	                    error(node, ts.Diagnostics.Only_a_void_function_can_be_called_with_the_new_keyword);
	                }
	                if (getThisTypeOfSignature(signature) === voidType) {
	                    error(node, ts.Diagnostics.A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void);
	                }
	                return signature;
	            }
	            invocationError(node, expressionType, 1 /* Construct */);
	            return resolveErrorCall(node);
	        }
	        function isConstructorAccessible(node, signature) {
	            if (!signature || !signature.declaration) {
	                return true;
	            }
	            var declaration = signature.declaration;
	            var modifiers = ts.getSelectedModifierFlags(declaration, 24 /* NonPublicAccessibilityModifier */);
	            // Public constructor is accessible.
	            if (!modifiers) {
	                return true;
	            }
	            var declaringClassDeclaration = ts.getClassLikeDeclarationOfSymbol(declaration.parent.symbol);
	            var declaringClass = getDeclaredTypeOfSymbol(declaration.parent.symbol);
	            // A private or protected constructor can only be instantiated within its own class (or a subclass, for protected)
	            if (!isNodeWithinClass(node, declaringClassDeclaration)) {
	                var containingClass = ts.getContainingClass(node);
	                if (containingClass) {
	                    var containingType = getTypeOfNode(containingClass);
	                    var baseTypes = getBaseTypes(containingType);
	                    while (baseTypes.length) {
	                        var baseType = baseTypes[0];
	                        if (modifiers & 16 /* Protected */ &&
	                            baseType.symbol === declaration.parent.symbol) {
	                            return true;
	                        }
	                        baseTypes = getBaseTypes(baseType);
	                    }
	                }
	                if (modifiers & 8 /* Private */) {
	                    error(node, ts.Diagnostics.Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration, typeToString(declaringClass));
	                }
	                if (modifiers & 16 /* Protected */) {
	                    error(node, ts.Diagnostics.Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration, typeToString(declaringClass));
	                }
	                return false;
	            }
	            return true;
	        }
	        function invocationError(node, apparentType, kind) {
	            error(node, kind === 0 /* Call */
	                ? ts.Diagnostics.Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures
	                : ts.Diagnostics.Cannot_use_new_with_an_expression_whose_type_lacks_a_call_or_construct_signature, typeToString(apparentType));
	            invocationErrorRecovery(apparentType, kind);
	        }
	        function invocationErrorRecovery(apparentType, kind) {
	            if (!apparentType.symbol) {
	                return;
	            }
	            var importNode = getSymbolLinks(apparentType.symbol).originatingImport;
	            // Create a diagnostic on the originating import if possible onto which we can attach a quickfix
	            //  An import call expression cannot be rewritten into another form to correct the error - the only solution is to use `.default` at the use-site
	            if (importNode && !ts.isImportCall(importNode)) {
	                var sigs = getSignaturesOfType(getTypeOfSymbol(getSymbolLinks(apparentType.symbol).target), kind);
	                if (!sigs || !sigs.length)
	                    return;
	                error(importNode, ts.Diagnostics.A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime);
	            }
	        }
	        function resolveTaggedTemplateExpression(node, candidatesOutArray) {
	            var tagType = checkExpression(node.tag);
	            var apparentType = getApparentType(tagType);
	            if (apparentType === unknownType) {
	                // Another error has already been reported
	                return resolveErrorCall(node);
	            }
	            var callSignatures = getSignaturesOfType(apparentType, 0 /* Call */);
	            var constructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */);
	            if (isUntypedFunctionCall(tagType, apparentType, callSignatures.length, constructSignatures.length)) {
	                return resolveUntypedCall(node);
	            }
	            if (!callSignatures.length) {
	                invocationError(node, apparentType, 0 /* Call */);
	                return resolveErrorCall(node);
	            }
	            return resolveCall(node, callSignatures, candidatesOutArray);
	        }
	        /**
	         * Gets the localized diagnostic head message to use for errors when resolving a decorator as a call expression.
	         */
	        function getDiagnosticHeadMessageForDecoratorResolution(node) {
	            switch (node.parent.kind) {
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                    return ts.Diagnostics.Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression;
	                case 148 /* Parameter */:
	                    return ts.Diagnostics.Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression;
	                case 151 /* PropertyDeclaration */:
	                    return ts.Diagnostics.Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression;
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return ts.Diagnostics.Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression;
	            }
	        }
	        /**
	         * Resolves a decorator as if it were a call expression.
	         */
	        function resolveDecorator(node, candidatesOutArray) {
	            var funcType = checkExpression(node.expression);
	            var apparentType = getApparentType(funcType);
	            if (apparentType === unknownType) {
	                return resolveErrorCall(node);
	            }
	            var callSignatures = getSignaturesOfType(apparentType, 0 /* Call */);
	            var constructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */);
	            if (isUntypedFunctionCall(funcType, apparentType, callSignatures.length, constructSignatures.length)) {
	                return resolveUntypedCall(node);
	            }
	            if (isPotentiallyUncalledDecorator(node, callSignatures)) {
	                var nodeStr = ts.getTextOfNode(node.expression, /*includeTrivia*/ false);
	                error(node, ts.Diagnostics._0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0, nodeStr);
	                return resolveErrorCall(node);
	            }
	            var headMessage = getDiagnosticHeadMessageForDecoratorResolution(node);
	            if (!callSignatures.length) {
	                var errorInfo = void 0;
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures, typeToString(apparentType));
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, headMessage);
	                diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(node, errorInfo));
	                invocationErrorRecovery(apparentType, 0 /* Call */);
	                return resolveErrorCall(node);
	            }
	            return resolveCall(node, callSignatures, candidatesOutArray, headMessage);
	        }
	        /**
	         * Sometimes, we have a decorator that could accept zero arguments,
	         * but is receiving too many arguments as part of the decorator invocation.
	         * In those cases, a user may have meant to *call* the expression before using it as a decorator.
	         */
	        function isPotentiallyUncalledDecorator(decorator, signatures) {
	            return signatures.length && ts.every(signatures, function (signature) {
	                return signature.minArgumentCount === 0 &&
	                    !signature.hasRestParameter &&
	                    signature.parameters.length < getEffectiveArgumentCount(decorator, /*args*/ undefined, signature);
	            });
	        }
	        /**
	         * This function is similar to getResolvedSignature but is exclusively for trying to resolve JSX stateless-function component.
	         * The main reason we have to use this function instead of getResolvedSignature because, the caller of this function will already check the type of openingLikeElement's tagName
	         * and pass the type as elementType. The elementType can not be a union (as such case should be handled by the caller of this function)
	         * Note: at this point, we are still not sure whether the opening-like element is a stateless function component or not.
	         * @param openingLikeElement an opening-like JSX element to try to resolve as JSX stateless function
	         * @param elementType an element type of the opneing-like element by checking opening-like element's tagname.
	         * @param candidatesOutArray an array of signature to be filled in by the function. It is passed by signature help in the language service;
	         *                           the function will fill it up with appropriate candidate signatures
	         */
	        function getResolvedJsxStatelessFunctionSignature(openingLikeElement, elementType, candidatesOutArray) {
	            ts.Debug.assert(!(elementType.flags & 131072 /* Union */));
	            return resolveStatelessJsxOpeningLikeElement(openingLikeElement, elementType, candidatesOutArray);
	        }
	        /**
	         * Try treating a given opening-like element as stateless function component and resolve a tagName to a function signature.
	         * @param openingLikeElement an JSX opening-like element we want to try resolve its stateless function if possible
	         * @param elementType a type of the opening-like JSX element, a result of resolving tagName in opening-like element.
	         * @param candidatesOutArray an array of signature to be filled in by the function. It is passed by signature help in the language service;
	         *                           the function will fill it up with appropriate candidate signatures
	         * @return a resolved signature if we can find function matching function signature through resolve call or a first signature in the list of functions.
	         *         otherwise return undefined if tag-name of the opening-like element doesn't have call signatures
	         */
	        function resolveStatelessJsxOpeningLikeElement(openingLikeElement, elementType, candidatesOutArray) {
	            // If this function is called from language service, elementType can be a union type. This is not possible if the function is called from compiler (see: resolveCustomJsxElementAttributesType)
	            if (elementType.flags & 131072 /* Union */) {
	                var types = elementType.types;
	                var result = void 0;
	                for (var _i = 0, types_16 = types; _i < types_16.length; _i++) {
	                    var type = types_16[_i];
	                    result = result || resolveStatelessJsxOpeningLikeElement(openingLikeElement, type, candidatesOutArray);
	                }
	                return result;
	            }
	            var callSignatures = elementType && getSignaturesOfType(elementType, 0 /* Call */);
	            if (callSignatures && callSignatures.length > 0) {
	                return resolveCall(openingLikeElement, callSignatures, candidatesOutArray);
	            }
	            return undefined;
	        }
	        function resolveSignature(node, candidatesOutArray) {
	            switch (node.kind) {
	                case 185 /* CallExpression */:
	                    return resolveCallExpression(node, candidatesOutArray);
	                case 186 /* NewExpression */:
	                    return resolveNewExpression(node, candidatesOutArray);
	                case 187 /* TaggedTemplateExpression */:
	                    return resolveTaggedTemplateExpression(node, candidatesOutArray);
	                case 149 /* Decorator */:
	                    return resolveDecorator(node, candidatesOutArray);
	                case 255 /* JsxOpeningElement */:
	                case 254 /* JsxSelfClosingElement */:
	                    // This code-path is called by language service
	                    return resolveStatelessJsxOpeningLikeElement(node, checkExpression(node.tagName), candidatesOutArray) || unknownSignature;
	            }
	            ts.Debug.assertNever(node, "Branch in 'resolveSignature' should be unreachable.");
	        }
	        /**
	         * Resolve a signature of a given call-like expression.
	         * @param node a call-like expression to try resolve a signature for
	         * @param candidatesOutArray an array of signature to be filled in by the function. It is passed by signature help in the language service;
	         *                           the function will fill it up with appropriate candidate signatures
	         * @return a signature of the call-like expression or undefined if one can't be found
	         */
	        function getResolvedSignature(node, candidatesOutArray) {
	            var links = getNodeLinks(node);
	            // If getResolvedSignature has already been called, we will have cached the resolvedSignature.
	            // However, it is possible that either candidatesOutArray was not passed in the first time,
	            // or that a different candidatesOutArray was passed in. Therefore, we need to redo the work
	            // to correctly fill the candidatesOutArray.
	            var cached = links.resolvedSignature;
	            if (cached && cached !== resolvingSignature && !candidatesOutArray) {
	                return cached;
	            }
	            links.resolvedSignature = resolvingSignature;
	            var result = resolveSignature(node, candidatesOutArray);
	            // If signature resolution originated in control flow type analysis (for example to compute the
	            // assigned type in a flow assignment) we don't cache the result as it may be based on temporary
	            // types from the control flow analysis.
	            links.resolvedSignature = flowLoopStart === flowLoopCount ? result : cached;
	            return result;
	        }
	        /**
	         * Indicates whether a declaration can be treated as a constructor in a JavaScript
	         * file.
	         */
	        function isJavaScriptConstructor(node) {
	            if (node && ts.isInJavaScriptFile(node)) {
	                // If the node has a @class tag, treat it like a constructor.
	                if (ts.getJSDocClassTag(node))
	                    return true;
	                // If the symbol of the node has members, treat it like a constructor.
	                var symbol = ts.isFunctionDeclaration(node) || ts.isFunctionExpression(node) ? getSymbolOfNode(node) :
	                    ts.isVariableDeclaration(node) && node.initializer && ts.isFunctionExpression(node.initializer) ? getSymbolOfNode(node.initializer) :
	                        undefined;
	                return symbol && symbol.members !== undefined;
	            }
	            return false;
	        }
	        function getJavaScriptClassType(symbol) {
	            if (ts.isDeclarationOfFunctionOrClassExpression(symbol)) {
	                symbol = getSymbolOfNode(symbol.valueDeclaration.initializer);
	            }
	            if (isJavaScriptConstructor(symbol.valueDeclaration)) {
	                return getInferredClassType(symbol);
	            }
	            if (symbol.flags & 3 /* Variable */) {
	                var valueType = getTypeOfSymbol(symbol);
	                if (valueType.symbol && !isInferredClassType(valueType) && isJavaScriptConstructor(valueType.symbol.valueDeclaration)) {
	                    return getInferredClassType(valueType.symbol);
	                }
	            }
	        }
	        function getInferredClassType(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.inferredClassType) {
	                links.inferredClassType = createAnonymousType(symbol, getMembersOfSymbol(symbol) || emptySymbols, ts.emptyArray, ts.emptyArray, /*stringIndexType*/ undefined, /*numberIndexType*/ undefined);
	            }
	            return links.inferredClassType;
	        }
	        function isInferredClassType(type) {
	            return type.symbol
	                && ts.getObjectFlags(type) & 16 /* Anonymous */
	                && getSymbolLinks(type.symbol).inferredClassType === type;
	        }
	        /**
	         * Syntactically and semantically checks a call or new expression.
	         * @param node The call/new expression to be checked.
	         * @returns On success, the expression's signature's return type. On failure, anyType.
	         */
	        function checkCallExpression(node) {
	            if (!checkGrammarTypeArguments(node, node.typeArguments))
	                checkGrammarArguments(node.arguments);
	            var signature = getResolvedSignature(node);
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return voidType;
	            }
	            if (node.kind === 186 /* NewExpression */) {
	                var declaration = signature.declaration;
	                if (declaration &&
	                    declaration.kind !== 154 /* Constructor */ &&
	                    declaration.kind !== 158 /* ConstructSignature */ &&
	                    declaration.kind !== 163 /* ConstructorType */ &&
	                    !ts.isJSDocConstructSignature(declaration)) {
	                    // When resolved signature is a call signature (and not a construct signature) the result type is any, unless
	                    // the declaring function had members created through 'x.prototype.y = expr' or 'this.y = expr' psuedodeclarations
	                    // in a JS file
	                    // Note:JS inferred classes might come from a variable declaration instead of a function declaration.
	                    // In this case, using getResolvedSymbol directly is required to avoid losing the members from the declaration.
	                    var funcSymbol = checkExpression(node.expression).symbol;
	                    if (!funcSymbol && node.expression.kind === 71 /* Identifier */) {
	                        funcSymbol = getResolvedSymbol(node.expression);
	                    }
	                    var type = funcSymbol && getJavaScriptClassType(funcSymbol);
	                    if (type) {
	                        return type;
	                    }
	                    if (noImplicitAny) {
	                        error(node, ts.Diagnostics.new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type);
	                    }
	                    return anyType;
	                }
	            }
	            // In JavaScript files, calls to any identifier 'require' are treated as external module imports
	            if (ts.isInJavaScriptFile(node) && isCommonJsRequire(node)) {
	                return resolveExternalModuleTypeByLiteral(node.arguments[0]);
	            }
	            var returnType = getReturnTypeOfSignature(signature);
	            // Treat any call to the global 'Symbol' function that is part of a const variable or readonly property
	            // as a fresh unique symbol literal type.
	            if (returnType.flags & 1536 /* ESSymbolLike */ && isSymbolOrSymbolForCall(node)) {
	                return getESSymbolLikeTypeForNode(ts.walkUpParenthesizedExpressions(node.parent));
	            }
	            return returnType;
	        }
	        function isSymbolOrSymbolForCall(node) {
	            if (!ts.isCallExpression(node))
	                return false;
	            var left = node.expression;
	            if (ts.isPropertyAccessExpression(left) && left.name.escapedText === "for") {
	                left = left.expression;
	            }
	            if (!ts.isIdentifier(left) || left.escapedText !== "Symbol") {
	                return false;
	            }
	            // make sure `Symbol` is the global symbol
	            var globalESSymbol = getGlobalESSymbolConstructorSymbol(/*reportErrors*/ false);
	            if (!globalESSymbol) {
	                return false;
	            }
	            return globalESSymbol === resolveName(left, "Symbol", 107455 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false);
	        }
	        function checkImportCallExpression(node) {
	            // Check grammar of dynamic import
	            if (!checkGrammarArguments(node.arguments))
	                checkGrammarImportCallExpression(node);
	            if (node.arguments.length === 0) {
	                return createPromiseReturnType(node, anyType);
	            }
	            var specifier = node.arguments[0];
	            var specifierType = checkExpressionCached(specifier);
	            // Even though multiple arugments is grammatically incorrect, type-check extra arguments for completion
	            for (var i = 1; i < node.arguments.length; ++i) {
	                checkExpressionCached(node.arguments[i]);
	            }
	            if (specifierType.flags & 4096 /* Undefined */ || specifierType.flags & 8192 /* Null */ || !isTypeAssignableTo(specifierType, stringType)) {
	                error(specifier, ts.Diagnostics.Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0, typeToString(specifierType));
	            }
	            // resolveExternalModuleName will return undefined if the moduleReferenceExpression is not a string literal
	            var moduleSymbol = resolveExternalModuleName(node, specifier);
	            if (moduleSymbol) {
	                var esModuleSymbol = resolveESModuleSymbol(moduleSymbol, specifier, /*dontRecursivelyResolve*/ true);
	                if (esModuleSymbol) {
	                    return createPromiseReturnType(node, getTypeWithSyntheticDefaultImportType(getTypeOfSymbol(esModuleSymbol), esModuleSymbol, moduleSymbol));
	                }
	            }
	            return createPromiseReturnType(node, anyType);
	        }
	        function getTypeWithSyntheticDefaultImportType(type, symbol, originalSymbol) {
	            if (allowSyntheticDefaultImports && type && type !== unknownType) {
	                var synthType = type;
	                if (!synthType.syntheticType) {
	                    var file = ts.find(originalSymbol.declarations, ts.isSourceFile);
	                    var hasSyntheticDefault = canHaveSyntheticDefault(file, originalSymbol, /*dontResolveAlias*/ false);
	                    if (hasSyntheticDefault) {
	                        var memberTable = ts.createSymbolTable();
	                        var newSymbol = createSymbol(2097152 /* Alias */, "default" /* Default */);
	                        newSymbol.target = resolveSymbol(symbol);
	                        memberTable.set("default" /* Default */, newSymbol);
	                        var anonymousSymbol = createSymbol(2048 /* TypeLiteral */, "__type" /* Type */);
	                        var defaultContainingObject = createAnonymousType(anonymousSymbol, memberTable, ts.emptyArray, ts.emptyArray, /*stringIndexInfo*/ undefined, /*numberIndexInfo*/ undefined);
	                        anonymousSymbol.type = defaultContainingObject;
	                        synthType.syntheticType = isValidSpreadType(type) ? getSpreadType(type, defaultContainingObject, anonymousSymbol, /*typeFLags*/ 0, /*objectFlags*/ 0) : defaultContainingObject;
	                    }
	                    else {
	                        synthType.syntheticType = type;
	                    }
	                }
	                return synthType.syntheticType;
	            }
	            return type;
	        }
	        function isCommonJsRequire(node) {
	            if (!ts.isRequireCall(node, /*checkArgumentIsStringLiteral*/ true)) {
	                return false;
	            }
	            // Make sure require is not a local function
	            if (!ts.isIdentifier(node.expression))
	                throw ts.Debug.fail();
	            var resolvedRequire = resolveName(node.expression, node.expression.escapedText, 107455 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ true);
	            if (!resolvedRequire) {
	                // project does not contain symbol named 'require' - assume commonjs require
	                return true;
	            }
	            // project includes symbol named 'require' - make sure that it it ambient and local non-alias
	            if (resolvedRequire.flags & 2097152 /* Alias */) {
	                return false;
	            }
	            var targetDeclarationKind = resolvedRequire.flags & 16 /* Function */
	                ? 232 /* FunctionDeclaration */
	                : resolvedRequire.flags & 3 /* Variable */
	                    ? 230 /* VariableDeclaration */
	                    : 0 /* Unknown */;
	            if (targetDeclarationKind !== 0 /* Unknown */) {
	                var decl = ts.getDeclarationOfKind(resolvedRequire, targetDeclarationKind);
	                // function/variable declaration should be ambient
	                return !!decl && !!(decl.flags & 2097152 /* Ambient */);
	            }
	            return false;
	        }
	        function checkTaggedTemplateExpression(node) {
	            if (languageVersion < 2 /* ES2015 */) {
	                checkExternalEmitHelpers(node, 65536 /* MakeTemplateObject */);
	            }
	            return getReturnTypeOfSignature(getResolvedSignature(node));
	        }
	        function checkAssertion(node) {
	            return checkAssertionWorker(node, node.type, node.expression);
	        }
	        function checkAssertionWorker(errNode, type, expression, checkMode) {
	            var exprType = getRegularTypeOfObjectLiteral(getBaseTypeOfLiteralType(checkExpression(expression, checkMode)));
	            checkSourceElement(type);
	            var targetType = getTypeFromTypeNode(type);
	            if (produceDiagnostics && targetType !== unknownType) {
	                var widenedType = getWidenedType(exprType);
	                if (!isTypeComparableTo(targetType, widenedType)) {
	                    checkTypeComparableTo(exprType, targetType, errNode, ts.Diagnostics.Type_0_cannot_be_converted_to_type_1);
	                }
	            }
	            return targetType;
	        }
	        function checkNonNullAssertion(node) {
	            return getNonNullableType(checkExpression(node.expression));
	        }
	        function checkMetaProperty(node) {
	            checkGrammarMetaProperty(node);
	            var container = ts.getNewTargetContainer(node);
	            if (!container) {
	                error(node, ts.Diagnostics.Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constructor, "new.target");
	                return unknownType;
	            }
	            else if (container.kind === 154 /* Constructor */) {
	                var symbol = getSymbolOfNode(container.parent);
	                return getTypeOfSymbol(symbol);
	            }
	            else {
	                var symbol = getSymbolOfNode(container);
	                return getTypeOfSymbol(symbol);
	            }
	        }
	        function getTypeOfParameter(symbol) {
	            var type = getTypeOfSymbol(symbol);
	            if (strictNullChecks) {
	                var declaration = symbol.valueDeclaration;
	                if (declaration && ts.hasInitializer(declaration)) {
	                    return getOptionalType(type);
	                }
	            }
	            return type;
	        }
	        function getTypeAtPosition(signature, pos) {
	            return signature.hasRestParameter ?
	                pos < signature.parameters.length - 1 ? getTypeOfParameter(signature.parameters[pos]) : getRestTypeOfSignature(signature) :
	                pos < signature.parameters.length ? getTypeOfParameter(signature.parameters[pos]) : anyType;
	        }
	        function getTypeOfFirstParameterOfSignature(signature) {
	            return signature.parameters.length > 0 ? getTypeAtPosition(signature, 0) : neverType;
	        }
	        function inferFromAnnotatedParameters(signature, context, mapper) {
	            var len = signature.parameters.length - (signature.hasRestParameter ? 1 : 0);
	            for (var i = 0; i < len; i++) {
	                var declaration = signature.parameters[i].valueDeclaration;
	                if (declaration.type) {
	                    var typeNode = ts.getEffectiveTypeAnnotationNode(declaration);
	                    if (typeNode) {
	                        inferTypes(mapper.inferences, getTypeFromTypeNode(typeNode), getTypeAtPosition(context, i));
	                    }
	                }
	            }
	        }
	        function assignContextualParameterTypes(signature, context) {
	            signature.typeParameters = context.typeParameters;
	            if (context.thisParameter) {
	                var parameter = signature.thisParameter;
	                if (!parameter || parameter.valueDeclaration && !parameter.valueDeclaration.type) {
	                    if (!parameter) {
	                        signature.thisParameter = createSymbolWithType(context.thisParameter, /*type*/ undefined);
	                    }
	                    assignTypeToParameterAndFixTypeParameters(signature.thisParameter, getTypeOfSymbol(context.thisParameter));
	                }
	            }
	            var len = signature.parameters.length - (signature.hasRestParameter ? 1 : 0);
	            for (var i = 0; i < len; i++) {
	                var parameter = signature.parameters[i];
	                if (!ts.getEffectiveTypeAnnotationNode(parameter.valueDeclaration)) {
	                    var contextualParameterType = getTypeAtPosition(context, i);
	                    assignTypeToParameterAndFixTypeParameters(parameter, contextualParameterType);
	                }
	            }
	            if (signature.hasRestParameter && isRestParameterIndex(context, signature.parameters.length - 1)) {
	                // parameter might be a transient symbol generated by use of `arguments` in the function body.
	                var parameter = ts.lastOrUndefined(signature.parameters);
	                if (isTransientSymbol(parameter) || !ts.getEffectiveTypeAnnotationNode(parameter.valueDeclaration)) {
	                    var contextualParameterType = getTypeOfSymbol(ts.lastOrUndefined(context.parameters));
	                    assignTypeToParameterAndFixTypeParameters(parameter, contextualParameterType);
	                }
	            }
	        }
	        // When contextual typing assigns a type to a parameter that contains a binding pattern, we also need to push
	        // the destructured type into the contained binding elements.
	        function assignBindingElementTypes(pattern) {
	            for (var _i = 0, _a = pattern.elements; _i < _a.length; _i++) {
	                var element = _a[_i];
	                if (!ts.isOmittedExpression(element)) {
	                    if (element.name.kind === 71 /* Identifier */) {
	                        getSymbolLinks(getSymbolOfNode(element)).type = getTypeForBindingElement(element);
	                    }
	                    else {
	                        assignBindingElementTypes(element.name);
	                    }
	                }
	            }
	        }
	        function assignTypeToParameterAndFixTypeParameters(parameter, contextualType) {
	            var links = getSymbolLinks(parameter);
	            if (!links.type) {
	                links.type = contextualType;
	                var decl = parameter.valueDeclaration;
	                if (decl.name.kind !== 71 /* Identifier */) {
	                    // if inference didn't come up with anything but {}, fall back to the binding pattern if present.
	                    if (links.type === emptyObjectType) {
	                        links.type = getTypeFromBindingPattern(decl.name);
	                    }
	                    assignBindingElementTypes(decl.name);
	                }
	            }
	        }
	        function createPromiseType(promisedType) {
	            // creates a `Promise<T>` type where `T` is the promisedType argument
	            var globalPromiseType = getGlobalPromiseType(/*reportErrors*/ true);
	            if (globalPromiseType !== emptyGenericType) {
	                // if the promised type is itself a promise, get the underlying type; otherwise, fallback to the promised type
	                promisedType = getAwaitedType(promisedType) || emptyObjectType;
	                return createTypeReference(globalPromiseType, [promisedType]);
	            }
	            return emptyObjectType;
	        }
	        function createPromiseReturnType(func, promisedType) {
	            var promiseType = createPromiseType(promisedType);
	            if (promiseType === emptyObjectType) {
	                error(func, ts.isImportCall(func) ?
	                    ts.Diagnostics.A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option :
	                    ts.Diagnostics.An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option);
	                return unknownType;
	            }
	            else if (!getGlobalPromiseConstructorSymbol(/*reportErrors*/ true)) {
	                error(func, ts.isImportCall(func) ?
	                    ts.Diagnostics.A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option :
	                    ts.Diagnostics.An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option);
	            }
	            return promiseType;
	        }
	        function getReturnTypeFromBody(func, checkMode) {
	            if (!func.body) {
	                return unknownType;
	            }
	            var functionFlags = ts.getFunctionFlags(func);
	            var type;
	            if (func.body.kind !== 211 /* Block */) {
	                type = checkExpressionCached(func.body, checkMode);
	                if (functionFlags & 2 /* Async */) {
	                    // From within an async function you can return either a non-promise value or a promise. Any
	                    // Promise/A+ compatible implementation will always assimilate any foreign promise, so the
	                    // return type of the body should be unwrapped to its awaited type, which we will wrap in
	                    // the native Promise<T> type later in this function.
	                    type = checkAwaitedType(type, /*errorNode*/ func, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                }
	            }
	            else {
	                var types = checkAndAggregateReturnExpressionTypes(func, checkMode);
	                if (functionFlags & 1 /* Generator */) {
	                    types = ts.concatenate(checkAndAggregateYieldOperandTypes(func, checkMode), types);
	                    if (!types || types.length === 0) {
	                        var iterableIteratorAny = functionFlags & 2 /* Async */
	                            ? createAsyncIterableIteratorType(anyType) // AsyncGenerator function
	                            : createIterableIteratorType(anyType); // Generator function
	                        if (noImplicitAny) {
	                            error(func.asteriskToken, ts.Diagnostics.Generator_implicitly_has_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_return_type, typeToString(iterableIteratorAny));
	                        }
	                        return iterableIteratorAny;
	                    }
	                }
	                else {
	                    if (!types) {
	                        // For an async function, the return type will not be never, but rather a Promise for never.
	                        return functionFlags & 2 /* Async */
	                            ? createPromiseReturnType(func, neverType) // Async function
	                            : neverType; // Normal function
	                    }
	                    if (types.length === 0) {
	                        // For an async function, the return type will not be void, but rather a Promise for void.
	                        return functionFlags & 2 /* Async */
	                            ? createPromiseReturnType(func, voidType) // Async function
	                            : voidType; // Normal function
	                    }
	                }
	                // Return a union of the return expression types.
	                type = getUnionType(types, 2 /* Subtype */);
	            }
	            var contextualSignature = getContextualSignatureForFunctionLikeDeclaration(func);
	            if (!contextualSignature) {
	                reportErrorsFromWidening(func, type);
	            }
	            if (isUnitType(type)) {
	                var contextualType = !contextualSignature ? undefined :
	                    contextualSignature === getSignatureFromDeclaration(func) ? type :
	                        getReturnTypeOfSignature(contextualSignature);
	                if (contextualType) {
	                    switch (functionFlags & 3 /* AsyncGenerator */) {
	                        case 3 /* AsyncGenerator */:
	                            contextualType = getIteratedTypeOfGenerator(contextualType, /*isAsyncGenerator*/ true);
	                            break;
	                        case 1 /* Generator */:
	                            contextualType = getIteratedTypeOfGenerator(contextualType, /*isAsyncGenerator*/ false);
	                            break;
	                        case 2 /* Async */:
	                            contextualType = getPromisedTypeOfPromise(contextualType);
	                            break;
	                    }
	                }
	                type = getWidenedLiteralLikeTypeForContextualType(type, contextualType);
	            }
	            var widenedType = getWidenedType(type);
	            switch (functionFlags & 3 /* AsyncGenerator */) {
	                case 3 /* AsyncGenerator */:
	                    return createAsyncIterableIteratorType(widenedType);
	                case 1 /* Generator */:
	                    return createIterableIteratorType(widenedType);
	                case 2 /* Async */:
	                    // From within an async function you can return either a non-promise value or a promise. Any
	                    // Promise/A+ compatible implementation will always assimilate any foreign promise, so the
	                    // return type of the body is awaited type of the body, wrapped in a native Promise<T> type.
	                    return createPromiseType(widenedType);
	                default:
	                    return widenedType;
	            }
	        }
	        function checkAndAggregateYieldOperandTypes(func, checkMode) {
	            var aggregatedTypes = [];
	            var functionFlags = ts.getFunctionFlags(func);
	            ts.forEachYieldExpression(func.body, function (yieldExpression) {
	                var expr = yieldExpression.expression;
	                if (expr) {
	                    var type = checkExpressionCached(expr, checkMode);
	                    if (yieldExpression.asteriskToken) {
	                        // A yield* expression effectively yields everything that its operand yields
	                        type = checkIteratedTypeOrElementType(type, yieldExpression.expression, /*allowStringInput*/ false, (functionFlags & 2 /* Async */) !== 0);
	                    }
	                    if (functionFlags & 2 /* Async */) {
	                        type = checkAwaitedType(type, expr, yieldExpression.asteriskToken
	                            ? ts.Diagnostics.Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member
	                            : ts.Diagnostics.Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                    }
	                    ts.pushIfUnique(aggregatedTypes, type);
	                }
	            });
	            return aggregatedTypes;
	        }
	        function isExhaustiveSwitchStatement(node) {
	            if (!node.possiblyExhaustive) {
	                return false;
	            }
	            var type = getTypeOfExpression(node.expression);
	            if (!isLiteralType(type)) {
	                return false;
	            }
	            var switchTypes = getSwitchClauseTypes(node);
	            if (!switchTypes.length) {
	                return false;
	            }
	            return eachTypeContainedIn(mapType(type, getRegularTypeOfLiteralType), switchTypes);
	        }
	        function functionHasImplicitReturn(func) {
	            if (!(func.flags & 128 /* HasImplicitReturn */)) {
	                return false;
	            }
	            if (ts.some(func.body.statements, function (statement) { return statement.kind === 225 /* SwitchStatement */ && isExhaustiveSwitchStatement(statement); })) {
	                return false;
	            }
	            return true;
	        }
	        /** NOTE: Return value of `[]` means a different thing than `undefined`. `[]` means return `void`, `undefined` means return `never`. */
	        function checkAndAggregateReturnExpressionTypes(func, checkMode) {
	            var functionFlags = ts.getFunctionFlags(func);
	            var aggregatedTypes = [];
	            var hasReturnWithNoExpression = functionHasImplicitReturn(func);
	            var hasReturnOfTypeNever = false;
	            ts.forEachReturnStatement(func.body, function (returnStatement) {
	                var expr = returnStatement.expression;
	                if (expr) {
	                    var type = checkExpressionCached(expr, checkMode);
	                    if (functionFlags & 2 /* Async */) {
	                        // From within an async function you can return either a non-promise value or a promise. Any
	                        // Promise/A+ compatible implementation will always assimilate any foreign promise, so the
	                        // return type of the body should be unwrapped to its awaited type, which should be wrapped in
	                        // the native Promise<T> type by the caller.
	                        type = checkAwaitedType(type, func, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                    }
	                    if (type.flags & 16384 /* Never */) {
	                        hasReturnOfTypeNever = true;
	                    }
	                    ts.pushIfUnique(aggregatedTypes, type);
	                }
	                else {
	                    hasReturnWithNoExpression = true;
	                }
	            });
	            if (aggregatedTypes.length === 0 && !hasReturnWithNoExpression && (hasReturnOfTypeNever || mayReturnNever(func))) {
	                return undefined;
	            }
	            if (strictNullChecks && aggregatedTypes.length && hasReturnWithNoExpression) {
	                ts.pushIfUnique(aggregatedTypes, undefinedType);
	            }
	            return aggregatedTypes;
	        }
	        function mayReturnNever(func) {
	            switch (func.kind) {
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                    return true;
	                case 153 /* MethodDeclaration */:
	                    return func.parent.kind === 182 /* ObjectLiteralExpression */;
	                default:
	                    return false;
	            }
	        }
	        /**
	         * TypeScript Specification 1.0 (6.3) - July 2014
	         *   An explicitly typed function whose return type isn't the Void type,
	         *   the Any type, or a union type containing the Void or Any type as a constituent
	         *   must have at least one return statement somewhere in its body.
	         *   An exception to this rule is if the function implementation consists of a single 'throw' statement.
	         *
	         * @param returnType - return type of the function, can be undefined if return type is not explicitly specified
	         */
	        function checkAllCodePathsInNonVoidFunctionReturnOrThrow(func, returnType) {
	            if (!produceDiagnostics) {
	                return;
	            }
	            // Functions with with an explicitly specified 'void' or 'any' return type don't need any return expressions.
	            if (returnType && maybeTypeOfKind(returnType, 1 /* Any */ | 2048 /* Void */)) {
	                return;
	            }
	            // If all we have is a function signature, or an arrow function with an expression body, then there is nothing to check.
	            // also if HasImplicitReturn flag is not set this means that all codepaths in function body end with return or throw
	            if (func.kind === 152 /* MethodSignature */ || ts.nodeIsMissing(func.body) || func.body.kind !== 211 /* Block */ || !functionHasImplicitReturn(func)) {
	                return;
	            }
	            var hasExplicitReturn = func.flags & 256 /* HasExplicitReturn */;
	            if (returnType && returnType.flags & 16384 /* Never */) {
	                error(ts.getEffectiveReturnTypeNode(func), ts.Diagnostics.A_function_returning_never_cannot_have_a_reachable_end_point);
	            }
	            else if (returnType && !hasExplicitReturn) {
	                // minimal check: function has syntactic return type annotation and no explicit return statements in the body
	                // this function does not conform to the specification.
	                // NOTE: having returnType !== undefined is a precondition for entering this branch so func.type will always be present
	                error(ts.getEffectiveReturnTypeNode(func), ts.Diagnostics.A_function_whose_declared_type_is_neither_void_nor_any_must_return_a_value);
	            }
	            else if (returnType && strictNullChecks && !isTypeAssignableTo(undefinedType, returnType)) {
	                error(ts.getEffectiveReturnTypeNode(func), ts.Diagnostics.Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined);
	            }
	            else if (compilerOptions.noImplicitReturns) {
	                if (!returnType) {
	                    // If return type annotation is omitted check if function has any explicit return statements.
	                    // If it does not have any - its inferred return type is void - don't do any checks.
	                    // Otherwise get inferred return type from function body and report error only if it is not void / anytype
	                    if (!hasExplicitReturn) {
	                        return;
	                    }
	                    var inferredReturnType = getReturnTypeOfSignature(getSignatureFromDeclaration(func));
	                    if (isUnwrappedReturnTypeVoidOrAny(func, inferredReturnType)) {
	                        return;
	                    }
	                }
	                error(ts.getEffectiveReturnTypeNode(func) || func, ts.Diagnostics.Not_all_code_paths_return_a_value);
	            }
	        }
	        function checkFunctionExpressionOrObjectLiteralMethod(node, checkMode) {
	            ts.Debug.assert(node.kind !== 153 /* MethodDeclaration */ || ts.isObjectLiteralMethod(node));
	            // The identityMapper object is used to indicate that function expressions are wildcards
	            if (checkMode === 1 /* SkipContextSensitive */ && isContextSensitive(node)) {
	                checkNodeDeferred(node);
	                return anyFunctionType;
	            }
	            // Grammar checking
	            var hasGrammarError = checkGrammarFunctionLikeDeclaration(node);
	            if (!hasGrammarError && node.kind === 190 /* FunctionExpression */) {
	                checkGrammarForGenerator(node);
	            }
	            var links = getNodeLinks(node);
	            var type = getTypeOfSymbol(node.symbol);
	            // Check if function expression is contextually typed and assign parameter types if so.
	            if (!(links.flags & 1024 /* ContextChecked */)) {
	                var contextualSignature = getContextualSignature(node);
	                // If a type check is started at a function expression that is an argument of a function call, obtaining the
	                // contextual type may recursively get back to here during overload resolution of the call. If so, we will have
	                // already assigned contextual types.
	                if (!(links.flags & 1024 /* ContextChecked */)) {
	                    links.flags |= 1024 /* ContextChecked */;
	                    if (contextualSignature) {
	                        var signature = getSignaturesOfType(type, 0 /* Call */)[0];
	                        if (isContextSensitive(node)) {
	                            var contextualMapper = getContextualMapper(node);
	                            if (checkMode === 2 /* Inferential */) {
	                                inferFromAnnotatedParameters(signature, contextualSignature, contextualMapper);
	                            }
	                            var instantiatedContextualSignature = contextualMapper === identityMapper ?
	                                contextualSignature : instantiateSignature(contextualSignature, contextualMapper);
	                            assignContextualParameterTypes(signature, instantiatedContextualSignature);
	                        }
	                        if (!ts.getEffectiveReturnTypeNode(node) && !signature.resolvedReturnType) {
	                            var returnType = getReturnTypeFromBody(node, checkMode);
	                            if (!signature.resolvedReturnType) {
	                                signature.resolvedReturnType = returnType;
	                            }
	                        }
	                    }
	                    checkSignatureDeclaration(node);
	                    checkNodeDeferred(node);
	                }
	            }
	            if (produceDiagnostics && node.kind !== 153 /* MethodDeclaration */) {
	                checkCollisionWithCapturedSuperVariable(node, node.name);
	                checkCollisionWithCapturedThisVariable(node, node.name);
	                checkCollisionWithCapturedNewTargetVariable(node, node.name);
	            }
	            return type;
	        }
	        function checkFunctionExpressionOrObjectLiteralMethodDeferred(node) {
	            ts.Debug.assert(node.kind !== 153 /* MethodDeclaration */ || ts.isObjectLiteralMethod(node));
	            var functionFlags = ts.getFunctionFlags(node);
	            var returnTypeNode = ts.getEffectiveReturnTypeNode(node);
	            var returnOrPromisedType = returnTypeNode &&
	                ((functionFlags & 3 /* AsyncGenerator */) === 2 /* Async */ ?
	                    checkAsyncFunctionReturnType(node) : // Async function
	                    getTypeFromTypeNode(returnTypeNode)); // AsyncGenerator function, Generator function, or normal function
	            if ((functionFlags & 1 /* Generator */) === 0) {
	                // return is not necessary in the body of generators
	                checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnOrPromisedType);
	            }
	            if (node.body) {
	                if (!returnTypeNode) {
	                    // There are some checks that are only performed in getReturnTypeFromBody, that may produce errors
	                    // we need. An example is the noImplicitAny errors resulting from widening the return expression
	                    // of a function. Because checking of function expression bodies is deferred, there was never an
	                    // appropriate time to do this during the main walk of the file (see the comment at the top of
	                    // checkFunctionExpressionBodies). So it must be done now.
	                    getReturnTypeOfSignature(getSignatureFromDeclaration(node));
	                }
	                if (node.body.kind === 211 /* Block */) {
	                    checkSourceElement(node.body);
	                }
	                else {
	                    // From within an async function you can return either a non-promise value or a promise. Any
	                    // Promise/A+ compatible implementation will always assimilate any foreign promise, so we
	                    // should not be checking assignability of a promise to the return type. Instead, we need to
	                    // check assignability of the awaited type of the expression body against the promised type of
	                    // its return type annotation.
	                    var exprType = checkExpression(node.body);
	                    if (returnOrPromisedType) {
	                        if ((functionFlags & 3 /* AsyncGenerator */) === 2 /* Async */) {
	                            var awaitedType = checkAwaitedType(exprType, node.body, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                            checkTypeAssignableTo(awaitedType, returnOrPromisedType, node.body);
	                        }
	                        else {
	                            checkTypeAssignableTo(exprType, returnOrPromisedType, node.body);
	                        }
	                    }
	                }
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkArithmeticOperandType(operand, type, diagnostic) {
	            if (!isTypeAssignableToKind(type, 84 /* NumberLike */)) {
	                error(operand, diagnostic);
	                return false;
	            }
	            return true;
	        }
	        function isReadonlySymbol(symbol) {
	            // The following symbols are considered read-only:
	            // Properties with a 'readonly' modifier
	            // Variables declared with 'const'
	            // Get accessors without matching set accessors
	            // Enum members
	            // Unions and intersections of the above (unions and intersections eagerly set isReadonly on creation)
	            return !!(ts.getCheckFlags(symbol) & 8 /* Readonly */ ||
	                symbol.flags & 4 /* Property */ && ts.getDeclarationModifierFlagsFromSymbol(symbol) & 64 /* Readonly */ ||
	                symbol.flags & 3 /* Variable */ && getDeclarationNodeFlagsFromSymbol(symbol) & 2 /* Const */ ||
	                symbol.flags & 98304 /* Accessor */ && !(symbol.flags & 65536 /* SetAccessor */) ||
	                symbol.flags & 8 /* EnumMember */);
	        }
	        function isReferenceToReadonlyEntity(expr, symbol) {
	            if (isReadonlySymbol(symbol)) {
	                // Allow assignments to readonly properties within constructors of the same class declaration.
	                if (symbol.flags & 4 /* Property */ &&
	                    (expr.kind === 183 /* PropertyAccessExpression */ || expr.kind === 184 /* ElementAccessExpression */) &&
	                    expr.expression.kind === 99 /* ThisKeyword */) {
	                    // Look for if this is the constructor for the class that `symbol` is a property of.
	                    var func = ts.getContainingFunction(expr);
	                    if (!(func && func.kind === 154 /* Constructor */)) {
	                        return true;
	                    }
	                    // If func.parent is a class and symbol is a (readonly) property of that class, or
	                    // if func is a constructor and symbol is a (readonly) parameter property declared in it,
	                    // then symbol is writeable here.
	                    return !(func.parent === symbol.valueDeclaration.parent || func === symbol.valueDeclaration.parent);
	                }
	                return true;
	            }
	            return false;
	        }
	        function isReferenceThroughNamespaceImport(expr) {
	            if (expr.kind === 183 /* PropertyAccessExpression */ || expr.kind === 184 /* ElementAccessExpression */) {
	                var node = ts.skipParentheses(expr.expression);
	                if (node.kind === 71 /* Identifier */) {
	                    var symbol = getNodeLinks(node).resolvedSymbol;
	                    if (symbol.flags & 2097152 /* Alias */) {
	                        var declaration = getDeclarationOfAliasSymbol(symbol);
	                        return declaration && declaration.kind === 244 /* NamespaceImport */;
	                    }
	                }
	            }
	            return false;
	        }
	        function checkReferenceExpression(expr, invalidReferenceMessage) {
	            // References are combinations of identifiers, parentheses, and property accesses.
	            var node = ts.skipOuterExpressions(expr, 2 /* Assertions */ | 1 /* Parentheses */);
	            if (node.kind !== 71 /* Identifier */ && node.kind !== 183 /* PropertyAccessExpression */ && node.kind !== 184 /* ElementAccessExpression */) {
	                error(expr, invalidReferenceMessage);
	                return false;
	            }
	            return true;
	        }
	        function checkDeleteExpression(node) {
	            checkExpression(node.expression);
	            var expr = ts.skipParentheses(node.expression);
	            if (expr.kind !== 183 /* PropertyAccessExpression */ && expr.kind !== 184 /* ElementAccessExpression */) {
	                error(expr, ts.Diagnostics.The_operand_of_a_delete_operator_must_be_a_property_reference);
	                return booleanType;
	            }
	            var links = getNodeLinks(expr);
	            var symbol = getExportSymbolOfValueSymbolIfExported(links.resolvedSymbol);
	            if (symbol && isReadonlySymbol(symbol)) {
	                error(expr, ts.Diagnostics.The_operand_of_a_delete_operator_cannot_be_a_read_only_property);
	            }
	            return booleanType;
	        }
	        function checkTypeOfExpression(node) {
	            checkExpression(node.expression);
	            return typeofType;
	        }
	        function checkVoidExpression(node) {
	            checkExpression(node.expression);
	            return undefinedWideningType;
	        }
	        function checkAwaitExpression(node) {
	            // Grammar checking
	            if (produceDiagnostics) {
	                if (!(node.flags & 16384 /* AwaitContext */)) {
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.await_expression_is_only_allowed_within_an_async_function);
	                }
	                if (isInParameterInitializerBeforeContainingFunction(node)) {
	                    error(node, ts.Diagnostics.await_expressions_cannot_be_used_in_a_parameter_initializer);
	                }
	            }
	            var operandType = checkExpression(node.expression);
	            return checkAwaitedType(operandType, node, ts.Diagnostics.Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	        }
	        function checkPrefixUnaryExpression(node) {
	            var operandType = checkExpression(node.operand);
	            if (operandType === silentNeverType) {
	                return silentNeverType;
	            }
	            if (node.operand.kind === 8 /* NumericLiteral */) {
	                if (node.operator === 38 /* MinusToken */) {
	                    return getFreshTypeOfLiteralType(getLiteralType(-node.operand.text));
	                }
	                else if (node.operator === 37 /* PlusToken */) {
	                    return getFreshTypeOfLiteralType(getLiteralType(+node.operand.text));
	                }
	            }
	            switch (node.operator) {
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                case 52 /* TildeToken */:
	                    checkNonNullType(operandType, node.operand);
	                    if (maybeTypeOfKind(operandType, 1536 /* ESSymbolLike */)) {
	                        error(node.operand, ts.Diagnostics.The_0_operator_cannot_be_applied_to_type_symbol, ts.tokenToString(node.operator));
	                    }
	                    return numberType;
	                case 51 /* ExclamationToken */:
	                    var facts = getTypeFacts(operandType) & (1048576 /* Truthy */ | 2097152 /* Falsy */);
	                    return facts === 1048576 /* Truthy */ ? falseType :
	                        facts === 2097152 /* Falsy */ ? trueType :
	                            booleanType;
	                case 43 /* PlusPlusToken */:
	                case 44 /* MinusMinusToken */:
	                    var ok = checkArithmeticOperandType(node.operand, checkNonNullType(operandType, node.operand), ts.Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_or_an_enum_type);
	                    if (ok) {
	                        // run check only if former checks succeeded to avoid reporting cascading errors
	                        checkReferenceExpression(node.operand, ts.Diagnostics.The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access);
	                    }
	                    return numberType;
	            }
	            return unknownType;
	        }
	        function checkPostfixUnaryExpression(node) {
	            var operandType = checkExpression(node.operand);
	            if (operandType === silentNeverType) {
	                return silentNeverType;
	            }
	            var ok = checkArithmeticOperandType(node.operand, checkNonNullType(operandType, node.operand), ts.Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_or_an_enum_type);
	            if (ok) {
	                // run check only if former checks succeeded to avoid reporting cascading errors
	                checkReferenceExpression(node.operand, ts.Diagnostics.The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access);
	            }
	            return numberType;
	        }
	        // Return true if type might be of the given kind. A union or intersection type might be of a given
	        // kind if at least one constituent type is of the given kind.
	        function maybeTypeOfKind(type, kind) {
	            if (type.flags & kind || kind & 536870912 /* GenericMappedType */ && isGenericMappedType(type)) {
	                return true;
	            }
	            if (type.flags & 393216 /* UnionOrIntersection */) {
	                var types = type.types;
	                for (var _i = 0, types_17 = types; _i < types_17.length; _i++) {
	                    var t = types_17[_i];
	                    if (maybeTypeOfKind(t, kind)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function isTypeAssignableToKind(source, kind, strict) {
	            if (source.flags & kind) {
	                return true;
	            }
	            if (strict && source.flags & (1 /* Any */ | 2048 /* Void */ | 4096 /* Undefined */ | 8192 /* Null */)) {
	                return false;
	            }
	            return (kind & 84 /* NumberLike */ && isTypeAssignableTo(source, numberType)) ||
	                (kind & 524322 /* StringLike */ && isTypeAssignableTo(source, stringType)) ||
	                (kind & 136 /* BooleanLike */ && isTypeAssignableTo(source, booleanType)) ||
	                (kind & 2048 /* Void */ && isTypeAssignableTo(source, voidType)) ||
	                (kind & 16384 /* Never */ && isTypeAssignableTo(source, neverType)) ||
	                (kind & 8192 /* Null */ && isTypeAssignableTo(source, nullType)) ||
	                (kind & 4096 /* Undefined */ && isTypeAssignableTo(source, undefinedType)) ||
	                (kind & 512 /* ESSymbol */ && isTypeAssignableTo(source, esSymbolType)) ||
	                (kind & 134217728 /* NonPrimitive */ && isTypeAssignableTo(source, nonPrimitiveType));
	        }
	        function allTypesAssignableToKind(source, kind, strict) {
	            return source.flags & 131072 /* Union */ ?
	                ts.every(source.types, function (subType) { return allTypesAssignableToKind(subType, kind, strict); }) :
	                isTypeAssignableToKind(source, kind, strict);
	        }
	        function isConstEnumObjectType(type) {
	            return ts.getObjectFlags(type) & 16 /* Anonymous */ && type.symbol && isConstEnumSymbol(type.symbol);
	        }
	        function isConstEnumSymbol(symbol) {
	            return (symbol.flags & 128 /* ConstEnum */) !== 0;
	        }
	        function checkInstanceOfExpression(left, right, leftType, rightType) {
	            if (leftType === silentNeverType || rightType === silentNeverType) {
	                return silentNeverType;
	            }
	            // TypeScript 1.0 spec (April 2014): 4.15.4
	            // The instanceof operator requires the left operand to be of type Any, an object type, or a type parameter type,
	            // and the right operand to be of type Any, a subtype of the 'Function' interface type, or have a call or construct signature.
	            // The result is always of the Boolean primitive type.
	            // NOTE: do not raise error if leftType is unknown as related error was already reported
	            if (!isTypeAny(leftType) &&
	                allTypesAssignableToKind(leftType, 16382 /* Primitive */)) {
	                error(left, ts.Diagnostics.The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_parameter);
	            }
	            // NOTE: do not raise error if right is unknown as related error was already reported
	            if (!(isTypeAny(rightType) || typeHasCallOrConstructSignatures(rightType) || isTypeSubtypeOf(rightType, globalFunctionType))) {
	                error(right, ts.Diagnostics.The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_Function_interface_type);
	            }
	            return booleanType;
	        }
	        function checkInExpression(left, right, leftType, rightType) {
	            if (leftType === silentNeverType || rightType === silentNeverType) {
	                return silentNeverType;
	            }
	            leftType = checkNonNullType(leftType, left);
	            rightType = checkNonNullType(rightType, right);
	            // TypeScript 1.0 spec (April 2014): 4.15.5
	            // The in operator requires the left operand to be of type Any, the String primitive type, or the Number primitive type,
	            // and the right operand to be of type Any, an object type, or a type parameter type.
	            // The result is always of the Boolean primitive type.
	            if (!(isTypeComparableTo(leftType, stringType) || isTypeAssignableToKind(leftType, 84 /* NumberLike */ | 1536 /* ESSymbolLike */))) {
	                error(left, ts.Diagnostics.The_left_hand_side_of_an_in_expression_must_be_of_type_any_string_number_or_symbol);
	            }
	            if (!isTypeAssignableToKind(rightType, 134217728 /* NonPrimitive */ | 7372800 /* InstantiableNonPrimitive */)) {
	                error(right, ts.Diagnostics.The_right_hand_side_of_an_in_expression_must_be_of_type_any_an_object_type_or_a_type_parameter);
	            }
	            return booleanType;
	        }
	        function checkObjectLiteralAssignment(node, sourceType) {
	            var properties = node.properties;
	            if (strictNullChecks && properties.length === 0) {
	                return checkNonNullType(sourceType, node);
	            }
	            for (var _i = 0, properties_7 = properties; _i < properties_7.length; _i++) {
	                var p = properties_7[_i];
	                checkObjectLiteralDestructuringPropertyAssignment(sourceType, p, properties);
	            }
	            return sourceType;
	        }
	        /** Note: If property cannot be a SpreadAssignment, then allProperties does not need to be provided */
	        function checkObjectLiteralDestructuringPropertyAssignment(objectLiteralType, property, allProperties) {
	            if (property.kind === 268 /* PropertyAssignment */ || property.kind === 269 /* ShorthandPropertyAssignment */) {
	                var name = property.name;
	                if (name.kind === 146 /* ComputedPropertyName */) {
	                    checkComputedPropertyName(name);
	                }
	                if (isComputedNonLiteralName(name)) {
	                    return undefined;
	                }
	                var text = ts.getTextOfPropertyName(name);
	                var type = isTypeAny(objectLiteralType)
	                    ? objectLiteralType
	                    : getTypeOfPropertyOfType(objectLiteralType, text) ||
	                        isNumericLiteralName(text) && getIndexTypeOfType(objectLiteralType, 1 /* Number */) ||
	                        getIndexTypeOfType(objectLiteralType, 0 /* String */);
	                if (type) {
	                    if (property.kind === 269 /* ShorthandPropertyAssignment */) {
	                        return checkDestructuringAssignment(property, type);
	                    }
	                    else {
	                        // non-shorthand property assignments should always have initializers
	                        return checkDestructuringAssignment(property.initializer, type);
	                    }
	                }
	                else {
	                    error(name, ts.Diagnostics.Type_0_has_no_property_1_and_no_string_index_signature, typeToString(objectLiteralType), ts.declarationNameToString(name));
	                }
	            }
	            else if (property.kind === 270 /* SpreadAssignment */) {
	                if (languageVersion < 6 /* ESNext */) {
	                    checkExternalEmitHelpers(property, 4 /* Rest */);
	                }
	                var nonRestNames = [];
	                if (allProperties) {
	                    for (var i = 0; i < allProperties.length - 1; i++) {
	                        nonRestNames.push(allProperties[i].name);
	                    }
	                }
	                var type = getRestType(objectLiteralType, nonRestNames, objectLiteralType.symbol);
	                return checkDestructuringAssignment(property.expression, type);
	            }
	            else {
	                error(property, ts.Diagnostics.Property_assignment_expected);
	            }
	        }
	        function checkArrayLiteralAssignment(node, sourceType, checkMode) {
	            if (languageVersion < 2 /* ES2015 */ && compilerOptions.downlevelIteration) {
	                checkExternalEmitHelpers(node, 512 /* Read */);
	            }
	            // This elementType will be used if the specific property corresponding to this index is not
	            // present (aka the tuple element property). This call also checks that the parentType is in
	            // fact an iterable or array (depending on target language).
	            var elementType = checkIteratedTypeOrElementType(sourceType, node, /*allowStringInput*/ false, /*allowAsyncIterables*/ false) || unknownType;
	            var elements = node.elements;
	            for (var i = 0; i < elements.length; i++) {
	                checkArrayLiteralDestructuringElementAssignment(node, sourceType, i, elementType, checkMode);
	            }
	            return sourceType;
	        }
	        function checkArrayLiteralDestructuringElementAssignment(node, sourceType, elementIndex, elementType, checkMode) {
	            var elements = node.elements;
	            var element = elements[elementIndex];
	            if (element.kind !== 204 /* OmittedExpression */) {
	                if (element.kind !== 202 /* SpreadElement */) {
	                    var propName = "" + elementIndex;
	                    var type = isTypeAny(sourceType)
	                        ? sourceType
	                        : isTupleLikeType(sourceType)
	                            ? getTypeOfPropertyOfType(sourceType, propName)
	                            : elementType;
	                    if (type) {
	                        return checkDestructuringAssignment(element, type, checkMode);
	                    }
	                    else {
	                        // We still need to check element expression here because we may need to set appropriate flag on the expression
	                        // such as NodeCheckFlags.LexicalThis on "this"expression.
	                        checkExpression(element);
	                        if (isTupleType(sourceType)) {
	                            error(element, ts.Diagnostics.Tuple_type_0_with_length_1_cannot_be_assigned_to_tuple_with_length_2, typeToString(sourceType), getTypeReferenceArity(sourceType), elements.length);
	                        }
	                        else {
	                            error(element, ts.Diagnostics.Type_0_has_no_property_1, typeToString(sourceType), propName);
	                        }
	                    }
	                }
	                else {
	                    if (elementIndex < elements.length - 1) {
	                        error(element, ts.Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
	                    }
	                    else {
	                        var restExpression = element.expression;
	                        if (restExpression.kind === 198 /* BinaryExpression */ && restExpression.operatorToken.kind === 58 /* EqualsToken */) {
	                            error(restExpression.operatorToken, ts.Diagnostics.A_rest_element_cannot_have_an_initializer);
	                        }
	                        else {
	                            return checkDestructuringAssignment(restExpression, createArrayType(elementType), checkMode);
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function checkDestructuringAssignment(exprOrAssignment, sourceType, checkMode) {
	            var target;
	            if (exprOrAssignment.kind === 269 /* ShorthandPropertyAssignment */) {
	                var prop = exprOrAssignment;
	                if (prop.objectAssignmentInitializer) {
	                    // In strict null checking mode, if a default value of a non-undefined type is specified, remove
	                    // undefined from the final type.
	                    if (strictNullChecks &&
	                        !(getFalsyFlags(checkExpression(prop.objectAssignmentInitializer)) & 4096 /* Undefined */)) {
	                        sourceType = getTypeWithFacts(sourceType, 131072 /* NEUndefined */);
	                    }
	                    checkBinaryLikeExpression(prop.name, prop.equalsToken, prop.objectAssignmentInitializer, checkMode);
	                }
	                target = exprOrAssignment.name;
	            }
	            else {
	                target = exprOrAssignment;
	            }
	            if (target.kind === 198 /* BinaryExpression */ && target.operatorToken.kind === 58 /* EqualsToken */) {
	                checkBinaryExpression(target, checkMode);
	                target = target.left;
	            }
	            if (target.kind === 182 /* ObjectLiteralExpression */) {
	                return checkObjectLiteralAssignment(target, sourceType);
	            }
	            if (target.kind === 181 /* ArrayLiteralExpression */) {
	                return checkArrayLiteralAssignment(target, sourceType, checkMode);
	            }
	            return checkReferenceAssignment(target, sourceType, checkMode);
	        }
	        function checkReferenceAssignment(target, sourceType, checkMode) {
	            var targetType = checkExpression(target, checkMode);
	            var error = target.parent.kind === 270 /* SpreadAssignment */ ?
	                ts.Diagnostics.The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access :
	                ts.Diagnostics.The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access;
	            if (checkReferenceExpression(target, error)) {
	                checkTypeAssignableTo(sourceType, targetType, target, /*headMessage*/ undefined);
	            }
	            return sourceType;
	        }
	        /**
	         * This is a *shallow* check: An expression is side-effect-free if the
	         * evaluation of the expression *itself* cannot produce side effects.
	         * For example, x++ / 3 is side-effect free because the / operator
	         * does not have side effects.
	         * The intent is to "smell test" an expression for correctness in positions where
	         * its value is discarded (e.g. the left side of the comma operator).
	         */
	        function isSideEffectFree(node) {
	            node = ts.skipParentheses(node);
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                case 9 /* StringLiteral */:
	                case 12 /* RegularExpressionLiteral */:
	                case 187 /* TaggedTemplateExpression */:
	                case 200 /* TemplateExpression */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 8 /* NumericLiteral */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                case 95 /* NullKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 190 /* FunctionExpression */:
	                case 203 /* ClassExpression */:
	                case 191 /* ArrowFunction */:
	                case 181 /* ArrayLiteralExpression */:
	                case 182 /* ObjectLiteralExpression */:
	                case 193 /* TypeOfExpression */:
	                case 207 /* NonNullExpression */:
	                case 254 /* JsxSelfClosingElement */:
	                case 253 /* JsxElement */:
	                    return true;
	                case 199 /* ConditionalExpression */:
	                    return isSideEffectFree(node.whenTrue) &&
	                        isSideEffectFree(node.whenFalse);
	                case 198 /* BinaryExpression */:
	                    if (ts.isAssignmentOperator(node.operatorToken.kind)) {
	                        return false;
	                    }
	                    return isSideEffectFree(node.left) &&
	                        isSideEffectFree(node.right);
	                case 196 /* PrefixUnaryExpression */:
	                case 197 /* PostfixUnaryExpression */:
	                    // Unary operators ~, !, +, and - have no side effects.
	                    // The rest do.
	                    switch (node.operator) {
	                        case 51 /* ExclamationToken */:
	                        case 37 /* PlusToken */:
	                        case 38 /* MinusToken */:
	                        case 52 /* TildeToken */:
	                            return true;
	                    }
	                    return false;
	                // Some forms listed here for clarity
	                case 194 /* VoidExpression */: // Explicit opt-out
	                case 188 /* TypeAssertionExpression */: // Not SEF, but can produce useful type warnings
	                case 206 /* AsExpression */: // Not SEF, but can produce useful type warnings
	                default:
	                    return false;
	            }
	        }
	        function isTypeEqualityComparableTo(source, target) {
	            return (target.flags & 12288 /* Nullable */) !== 0 || isTypeComparableTo(source, target);
	        }
	        function checkBinaryExpression(node, checkMode) {
	            return checkBinaryLikeExpression(node.left, node.operatorToken, node.right, checkMode, node);
	        }
	        function checkBinaryLikeExpression(left, operatorToken, right, checkMode, errorNode) {
	            var operator = operatorToken.kind;
	            if (operator === 58 /* EqualsToken */ && (left.kind === 182 /* ObjectLiteralExpression */ || left.kind === 181 /* ArrayLiteralExpression */)) {
	                return checkDestructuringAssignment(left, checkExpression(right, checkMode), checkMode);
	            }
	            var leftType = checkExpression(left, checkMode);
	            var rightType = checkExpression(right, checkMode);
	            switch (operator) {
	                case 39 /* AsteriskToken */:
	                case 40 /* AsteriskAsteriskToken */:
	                case 61 /* AsteriskEqualsToken */:
	                case 62 /* AsteriskAsteriskEqualsToken */:
	                case 41 /* SlashToken */:
	                case 63 /* SlashEqualsToken */:
	                case 42 /* PercentToken */:
	                case 64 /* PercentEqualsToken */:
	                case 38 /* MinusToken */:
	                case 60 /* MinusEqualsToken */:
	                case 45 /* LessThanLessThanToken */:
	                case 65 /* LessThanLessThanEqualsToken */:
	                case 46 /* GreaterThanGreaterThanToken */:
	                case 66 /* GreaterThanGreaterThanEqualsToken */:
	                case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                case 49 /* BarToken */:
	                case 69 /* BarEqualsToken */:
	                case 50 /* CaretToken */:
	                case 70 /* CaretEqualsToken */:
	                case 48 /* AmpersandToken */:
	                case 68 /* AmpersandEqualsToken */:
	                    if (leftType === silentNeverType || rightType === silentNeverType) {
	                        return silentNeverType;
	                    }
	                    leftType = checkNonNullType(leftType, left);
	                    rightType = checkNonNullType(rightType, right);
	                    var suggestedOperator = void 0;
	                    // if a user tries to apply a bitwise operator to 2 boolean operands
	                    // try and return them a helpful suggestion
	                    if ((leftType.flags & 136 /* BooleanLike */) &&
	                        (rightType.flags & 136 /* BooleanLike */) &&
	                        (suggestedOperator = getSuggestedBooleanOperator(operatorToken.kind)) !== undefined) {
	                        error(errorNode || operatorToken, ts.Diagnostics.The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead, ts.tokenToString(operatorToken.kind), ts.tokenToString(suggestedOperator));
	                    }
	                    else {
	                        // otherwise just check each operand separately and report errors as normal
	                        var leftOk = checkArithmeticOperandType(left, leftType, ts.Diagnostics.The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type);
	                        var rightOk = checkArithmeticOperandType(right, rightType, ts.Diagnostics.The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type);
	                        if (leftOk && rightOk) {
	                            checkAssignmentOperator(numberType);
	                        }
	                    }
	                    return numberType;
	                case 37 /* PlusToken */:
	                case 59 /* PlusEqualsToken */:
	                    if (leftType === silentNeverType || rightType === silentNeverType) {
	                        return silentNeverType;
	                    }
	                    if (!isTypeAssignableToKind(leftType, 524322 /* StringLike */) && !isTypeAssignableToKind(rightType, 524322 /* StringLike */)) {
	                        leftType = checkNonNullType(leftType, left);
	                        rightType = checkNonNullType(rightType, right);
	                    }
	                    var resultType = void 0;
	                    if (isTypeAssignableToKind(leftType, 84 /* NumberLike */, /*strict*/ true) && isTypeAssignableToKind(rightType, 84 /* NumberLike */, /*strict*/ true)) {
	                        // Operands of an enum type are treated as having the primitive type Number.
	                        // If both operands are of the Number primitive type, the result is of the Number primitive type.
	                        resultType = numberType;
	                    }
	                    else if (isTypeAssignableToKind(leftType, 524322 /* StringLike */, /*strict*/ true) || isTypeAssignableToKind(rightType, 524322 /* StringLike */, /*strict*/ true)) {
	                        // If one or both operands are of the String primitive type, the result is of the String primitive type.
	                        resultType = stringType;
	                    }
	                    else if (isTypeAny(leftType) || isTypeAny(rightType)) {
	                        // Otherwise, the result is of type Any.
	                        // NOTE: unknown type here denotes error type. Old compiler treated this case as any type so do we.
	                        resultType = leftType === unknownType || rightType === unknownType ? unknownType : anyType;
	                    }
	                    // Symbols are not allowed at all in arithmetic expressions
	                    if (resultType && !checkForDisallowedESSymbolOperand(operator)) {
	                        return resultType;
	                    }
	                    if (!resultType) {
	                        reportOperatorError();
	                        return anyType;
	                    }
	                    if (operator === 59 /* PlusEqualsToken */) {
	                        checkAssignmentOperator(resultType);
	                    }
	                    return resultType;
	                case 27 /* LessThanToken */:
	                case 29 /* GreaterThanToken */:
	                case 30 /* LessThanEqualsToken */:
	                case 31 /* GreaterThanEqualsToken */:
	                    if (checkForDisallowedESSymbolOperand(operator)) {
	                        leftType = getBaseTypeOfLiteralType(checkNonNullType(leftType, left));
	                        rightType = getBaseTypeOfLiteralType(checkNonNullType(rightType, right));
	                        if (!isTypeComparableTo(leftType, rightType) && !isTypeComparableTo(rightType, leftType)) {
	                            reportOperatorError();
	                        }
	                    }
	                    return booleanType;
	                case 32 /* EqualsEqualsToken */:
	                case 33 /* ExclamationEqualsToken */:
	                case 34 /* EqualsEqualsEqualsToken */:
	                case 35 /* ExclamationEqualsEqualsToken */:
	                    var leftIsLiteral = isLiteralType(leftType);
	                    var rightIsLiteral = isLiteralType(rightType);
	                    if (!leftIsLiteral || !rightIsLiteral) {
	                        leftType = leftIsLiteral ? getBaseTypeOfLiteralType(leftType) : leftType;
	                        rightType = rightIsLiteral ? getBaseTypeOfLiteralType(rightType) : rightType;
	                    }
	                    if (!isTypeEqualityComparableTo(leftType, rightType) && !isTypeEqualityComparableTo(rightType, leftType)) {
	                        reportOperatorError();
	                    }
	                    return booleanType;
	                case 93 /* InstanceOfKeyword */:
	                    return checkInstanceOfExpression(left, right, leftType, rightType);
	                case 92 /* InKeyword */:
	                    return checkInExpression(left, right, leftType, rightType);
	                case 53 /* AmpersandAmpersandToken */:
	                    return getTypeFacts(leftType) & 1048576 /* Truthy */ ?
	                        getUnionType([extractDefinitelyFalsyTypes(strictNullChecks ? leftType : getBaseTypeOfLiteralType(rightType)), rightType]) :
	                        leftType;
	                case 54 /* BarBarToken */:
	                    return getTypeFacts(leftType) & 2097152 /* Falsy */ ?
	                        getUnionType([removeDefinitelyFalsyTypes(leftType), rightType], 2 /* Subtype */) :
	                        leftType;
	                case 58 /* EqualsToken */:
	                    checkAssignmentOperator(rightType);
	                    return getRegularTypeOfObjectLiteral(rightType);
	                case 26 /* CommaToken */:
	                    if (!compilerOptions.allowUnreachableCode && isSideEffectFree(left) && !isEvalNode(right)) {
	                        error(left, ts.Diagnostics.Left_side_of_comma_operator_is_unused_and_has_no_side_effects);
	                    }
	                    return rightType;
	            }
	            function isEvalNode(node) {
	                return node.kind === 71 /* Identifier */ && node.escapedText === "eval";
	            }
	            // Return true if there was no error, false if there was an error.
	            function checkForDisallowedESSymbolOperand(operator) {
	                var offendingSymbolOperand = maybeTypeOfKind(leftType, 1536 /* ESSymbolLike */) ? left :
	                    maybeTypeOfKind(rightType, 1536 /* ESSymbolLike */) ? right :
	                        undefined;
	                if (offendingSymbolOperand) {
	                    error(offendingSymbolOperand, ts.Diagnostics.The_0_operator_cannot_be_applied_to_type_symbol, ts.tokenToString(operator));
	                    return false;
	                }
	                return true;
	            }
	            function getSuggestedBooleanOperator(operator) {
	                switch (operator) {
	                    case 49 /* BarToken */:
	                    case 69 /* BarEqualsToken */:
	                        return 54 /* BarBarToken */;
	                    case 50 /* CaretToken */:
	                    case 70 /* CaretEqualsToken */:
	                        return 35 /* ExclamationEqualsEqualsToken */;
	                    case 48 /* AmpersandToken */:
	                    case 68 /* AmpersandEqualsToken */:
	                        return 53 /* AmpersandAmpersandToken */;
	                    default:
	                        return undefined;
	                }
	            }
	            function checkAssignmentOperator(valueType) {
	                if (produceDiagnostics && ts.isAssignmentOperator(operator)) {
	                    // TypeScript 1.0 spec (April 2014): 4.17
	                    // An assignment of the form
	                    //    VarExpr = ValueExpr
	                    // requires VarExpr to be classified as a reference
	                    // A compound assignment furthermore requires VarExpr to be classified as a reference (section 4.1)
	                    // and the type of the non - compound operation to be assignable to the type of VarExpr.
	                    if (checkReferenceExpression(left, ts.Diagnostics.The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access)) {
	                        // to avoid cascading errors check assignability only if 'isReference' check succeeded and no errors were reported
	                        checkTypeAssignableTo(valueType, leftType, left, /*headMessage*/ undefined);
	                    }
	                }
	            }
	            function reportOperatorError() {
	                error(errorNode || operatorToken, ts.Diagnostics.Operator_0_cannot_be_applied_to_types_1_and_2, ts.tokenToString(operatorToken.kind), typeToString(leftType), typeToString(rightType));
	            }
	        }
	        function isYieldExpressionInClass(node) {
	            var current = node;
	            var parent = node.parent;
	            while (parent) {
	                if (ts.isFunctionLike(parent) && current === parent.body) {
	                    return false;
	                }
	                else if (ts.isClassLike(current)) {
	                    return true;
	                }
	                current = parent;
	                parent = parent.parent;
	            }
	            return false;
	        }
	        function checkYieldExpression(node) {
	            // Grammar checking
	            if (produceDiagnostics) {
	                if (!(node.flags & 4096 /* YieldContext */) || isYieldExpressionInClass(node)) {
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.A_yield_expression_is_only_allowed_in_a_generator_body);
	                }
	                if (isInParameterInitializerBeforeContainingFunction(node)) {
	                    error(node, ts.Diagnostics.yield_expressions_cannot_be_used_in_a_parameter_initializer);
	                }
	            }
	            if (node.expression) {
	                var func = ts.getContainingFunction(node);
	                // If the user's code is syntactically correct, the func should always have a star. After all,
	                // we are in a yield context.
	                var functionFlags = func && ts.getFunctionFlags(func);
	                if (node.asteriskToken) {
	                    // Async generator functions prior to ESNext require the __await, __asyncDelegator,
	                    // and __asyncValues helpers
	                    if ((functionFlags & 3 /* AsyncGenerator */) === 3 /* AsyncGenerator */ &&
	                        languageVersion < 6 /* ESNext */) {
	                        checkExternalEmitHelpers(node, 26624 /* AsyncDelegatorIncludes */);
	                    }
	                    // Generator functions prior to ES2015 require the __values helper
	                    if ((functionFlags & 3 /* AsyncGenerator */) === 1 /* Generator */ &&
	                        languageVersion < 2 /* ES2015 */ && compilerOptions.downlevelIteration) {
	                        checkExternalEmitHelpers(node, 256 /* Values */);
	                    }
	                }
	                if (functionFlags & 1 /* Generator */) {
	                    var expressionType = checkExpressionCached(node.expression);
	                    var expressionElementType = void 0;
	                    var nodeIsYieldStar = !!node.asteriskToken;
	                    if (nodeIsYieldStar) {
	                        expressionElementType = checkIteratedTypeOrElementType(expressionType, node.expression, /*allowStringInput*/ false, (functionFlags & 2 /* Async */) !== 0);
	                    }
	                    // There is no point in doing an assignability check if the function
	                    // has no explicit return type because the return type is directly computed
	                    // from the yield expressions.
	                    var returnType = ts.getEffectiveReturnTypeNode(func);
	                    if (returnType) {
	                        var signatureElementType = getIteratedTypeOfGenerator(getTypeFromTypeNode(returnType), (functionFlags & 2 /* Async */) !== 0) || anyType;
	                        if (nodeIsYieldStar) {
	                            checkTypeAssignableTo(functionFlags & 2 /* Async */
	                                ? getAwaitedType(expressionElementType, node.expression, ts.Diagnostics.Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member)
	                                : expressionElementType, signatureElementType, node.expression, 
	                            /*headMessage*/ undefined);
	                        }
	                        else {
	                            checkTypeAssignableTo(functionFlags & 2 /* Async */
	                                ? getAwaitedType(expressionType, node.expression, ts.Diagnostics.Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member)
	                                : expressionType, signatureElementType, node.expression, 
	                            /*headMessage*/ undefined);
	                        }
	                    }
	                }
	            }
	            // Both yield and yield* expressions have type 'any'
	            return anyType;
	        }
	        function checkConditionalExpression(node, checkMode) {
	            checkExpression(node.condition);
	            var type1 = checkExpression(node.whenTrue, checkMode);
	            var type2 = checkExpression(node.whenFalse, checkMode);
	            return getUnionType([type1, type2], 2 /* Subtype */);
	        }
	        function checkTemplateExpression(node) {
	            // We just want to check each expressions, but we are unconcerned with
	            // the type of each expression, as any value may be coerced into a string.
	            // It is worth asking whether this is what we really want though.
	            // A place where we actually *are* concerned with the expressions' types are
	            // in tagged templates.
	            ts.forEach(node.templateSpans, function (templateSpan) {
	                checkExpression(templateSpan.expression);
	            });
	            return stringType;
	        }
	        function getContextNode(node) {
	            if (node.kind === 261 /* JsxAttributes */) {
	                return node.parent.parent; // Needs to be the root JsxElement, so it encompasses the attributes _and_ the children (which are essentially part of the attributes)
	            }
	            return node;
	        }
	        function checkExpressionWithContextualType(node, contextualType, contextualMapper) {
	            var context = getContextNode(node);
	            var saveContextualType = context.contextualType;
	            var saveContextualMapper = context.contextualMapper;
	            context.contextualType = contextualType;
	            context.contextualMapper = contextualMapper;
	            var checkMode = contextualMapper === identityMapper ? 1 /* SkipContextSensitive */ :
	                contextualMapper ? 2 /* Inferential */ : 3 /* Contextual */;
	            var result = checkExpression(node, checkMode);
	            context.contextualType = saveContextualType;
	            context.contextualMapper = saveContextualMapper;
	            return result;
	        }
	        function checkExpressionCached(node, checkMode) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                if (checkMode) {
	                    return checkExpression(node, checkMode);
	                }
	                // When computing a type that we're going to cache, we need to ignore any ongoing control flow
	                // analysis because variables may have transient types in indeterminable states. Moving flowLoopStart
	                // to the top of the stack ensures all transient types are computed from a known point.
	                var saveFlowLoopStart = flowLoopStart;
	                flowLoopStart = flowLoopCount;
	                links.resolvedType = checkExpression(node, checkMode);
	                flowLoopStart = saveFlowLoopStart;
	            }
	            return links.resolvedType;
	        }
	        function isTypeAssertion(node) {
	            node = ts.skipParentheses(node);
	            return node.kind === 188 /* TypeAssertionExpression */ || node.kind === 206 /* AsExpression */;
	        }
	        function checkDeclarationInitializer(declaration) {
	            var type = getTypeOfExpression(declaration.initializer, /*cache*/ true);
	            return ts.getCombinedNodeFlags(declaration) & 2 /* Const */ ||
	                (ts.getCombinedModifierFlags(declaration) & 64 /* Readonly */ && !ts.isParameterPropertyDeclaration(declaration)) ||
	                isTypeAssertion(declaration.initializer) ? type : getWidenedLiteralType(type);
	        }
	        function isLiteralOfContextualType(candidateType, contextualType) {
	            if (contextualType) {
	                if (contextualType.flags & 393216 /* UnionOrIntersection */) {
	                    var types = contextualType.types;
	                    return ts.some(types, function (t) { return isLiteralOfContextualType(candidateType, t); });
	                }
	                if (contextualType.flags & 7372800 /* InstantiableNonPrimitive */) {
	                    // If the contextual type is a type variable constrained to a primitive type, consider
	                    // this a literal context for literals of that primitive type. For example, given a
	                    // type parameter 'T extends string', infer string literal types for T.
	                    var constraint = getBaseConstraintOfType(contextualType) || emptyObjectType;
	                    return constraint.flags & 2 /* String */ && maybeTypeOfKind(candidateType, 32 /* StringLiteral */) ||
	                        constraint.flags & 4 /* Number */ && maybeTypeOfKind(candidateType, 64 /* NumberLiteral */) ||
	                        constraint.flags & 8 /* Boolean */ && maybeTypeOfKind(candidateType, 128 /* BooleanLiteral */) ||
	                        constraint.flags & 512 /* ESSymbol */ && maybeTypeOfKind(candidateType, 1024 /* UniqueESSymbol */) ||
	                        isLiteralOfContextualType(candidateType, constraint);
	                }
	                // If the contextual type is a literal of a particular primitive type, we consider this a
	                // literal context for all literals of that primitive type.
	                return contextualType.flags & (32 /* StringLiteral */ | 524288 /* Index */) && maybeTypeOfKind(candidateType, 32 /* StringLiteral */) ||
	                    contextualType.flags & 64 /* NumberLiteral */ && maybeTypeOfKind(candidateType, 64 /* NumberLiteral */) ||
	                    contextualType.flags & 128 /* BooleanLiteral */ && maybeTypeOfKind(candidateType, 128 /* BooleanLiteral */) ||
	                    contextualType.flags & 1024 /* UniqueESSymbol */ && maybeTypeOfKind(candidateType, 1024 /* UniqueESSymbol */);
	            }
	            return false;
	        }
	        function checkExpressionForMutableLocation(node, checkMode, contextualType) {
	            if (arguments.length === 2) {
	                contextualType = getContextualType(node);
	            }
	            var type = checkExpression(node, checkMode);
	            return isTypeAssertion(node) ? type :
	                getWidenedLiteralLikeTypeForContextualType(type, contextualType);
	        }
	        function checkPropertyAssignment(node, checkMode) {
	            // Do not use hasDynamicName here, because that returns false for well known symbols.
	            // We want to perform checkComputedPropertyName for all computed properties, including
	            // well known symbols.
	            if (node.name.kind === 146 /* ComputedPropertyName */) {
	                checkComputedPropertyName(node.name);
	            }
	            return checkExpressionForMutableLocation(node.initializer, checkMode);
	        }
	        function checkObjectLiteralMethod(node, checkMode) {
	            // Grammar checking
	            checkGrammarMethod(node);
	            // Do not use hasDynamicName here, because that returns false for well known symbols.
	            // We want to perform checkComputedPropertyName for all computed properties, including
	            // well known symbols.
	            if (node.name.kind === 146 /* ComputedPropertyName */) {
	                checkComputedPropertyName(node.name);
	            }
	            var uninstantiatedType = checkFunctionExpressionOrObjectLiteralMethod(node, checkMode);
	            return instantiateTypeWithSingleGenericCallSignature(node, uninstantiatedType, checkMode);
	        }
	        function instantiateTypeWithSingleGenericCallSignature(node, type, checkMode) {
	            if (checkMode === 2 /* Inferential */) {
	                var signature = getSingleCallSignature(type);
	                if (signature && signature.typeParameters) {
	                    var contextualType = getApparentTypeOfContextualType(node);
	                    if (contextualType) {
	                        var contextualSignature = getSingleCallSignature(getNonNullableType(contextualType));
	                        if (contextualSignature && !contextualSignature.typeParameters) {
	                            return getOrCreateTypeFromSignature(instantiateSignatureInContextOf(signature, contextualSignature, getContextualMapper(node)));
	                        }
	                    }
	                }
	            }
	            return type;
	        }
	        /**
	         * Returns the type of an expression. Unlike checkExpression, this function is simply concerned
	         * with computing the type and may not fully check all contained sub-expressions for errors.
	         * A cache argument of true indicates that if the function performs a full type check, it is ok
	         * to cache the result.
	         */
	        function getTypeOfExpression(node, cache) {
	            // Optimize for the common case of a call to a function with a single non-generic call
	            // signature where we can just fetch the return type without checking the arguments.
	            if (node.kind === 185 /* CallExpression */ && node.expression.kind !== 97 /* SuperKeyword */ && !ts.isRequireCall(node, /*checkArgumentIsStringLiteral*/ true) && !isSymbolOrSymbolForCall(node)) {
	                var funcType = checkNonNullExpression(node.expression);
	                var signature = getSingleCallSignature(funcType);
	                if (signature && !signature.typeParameters) {
	                    return getReturnTypeOfSignature(signature);
	                }
	            }
	            // Otherwise simply call checkExpression. Ideally, the entire family of checkXXX functions
	            // should have a parameter that indicates whether full error checking is required such that
	            // we can perform the optimizations locally.
	            return cache ? checkExpressionCached(node) : checkExpression(node);
	        }
	        /**
	         * Returns the type of an expression. Unlike checkExpression, this function is simply concerned
	         * with computing the type and may not fully check all contained sub-expressions for errors.
	         * It is intended for uses where you know there is no contextual type,
	         * and requesting the contextual type might cause a circularity or other bad behaviour.
	         * It sets the contextual type of the node to any before calling getTypeOfExpression.
	         */
	        function getContextFreeTypeOfExpression(node) {
	            var saveContextualType = node.contextualType;
	            node.contextualType = anyType;
	            var type = getTypeOfExpression(node);
	            node.contextualType = saveContextualType;
	            return type;
	        }
	        // Checks an expression and returns its type. The contextualMapper parameter serves two purposes: When
	        // contextualMapper is not undefined and not equal to the identityMapper function object it indicates that the
	        // expression is being inferentially typed (section 4.15.2 in spec) and provides the type mapper to use in
	        // conjunction with the generic contextual type. When contextualMapper is equal to the identityMapper function
	        // object, it serves as an indicator that all contained function and arrow expressions should be considered to
	        // have the wildcard function type; this form of type check is used during overload resolution to exclude
	        // contextually typed function and arrow expressions in the initial phase.
	        function checkExpression(node, checkMode) {
	            var type;
	            if (node.kind === 145 /* QualifiedName */) {
	                type = checkQualifiedName(node);
	            }
	            else {
	                var uninstantiatedType = checkExpressionWorker(node, checkMode);
	                type = instantiateTypeWithSingleGenericCallSignature(node, uninstantiatedType, checkMode);
	            }
	            if (isConstEnumObjectType(type)) {
	                // enum object type for const enums are only permitted in:
	                // - 'left' in property access
	                // - 'object' in indexed access
	                // - target in rhs of import statement
	                var ok = (node.parent.kind === 183 /* PropertyAccessExpression */ && node.parent.expression === node) ||
	                    (node.parent.kind === 184 /* ElementAccessExpression */ && node.parent.expression === node) ||
	                    ((node.kind === 71 /* Identifier */ || node.kind === 145 /* QualifiedName */) && isInRightSideOfImportOrExportAssignment(node) ||
	                        (node.parent.kind === 164 /* TypeQuery */ && node.parent.exprName === node));
	                if (!ok) {
	                    error(node, ts.Diagnostics.const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_import_declaration_or_export_assignment_or_type_query);
	                }
	            }
	            return type;
	        }
	        function checkParenthesizedExpression(node, checkMode) {
	            var tag = ts.isInJavaScriptFile(node) ? ts.getJSDocTypeTag(node) : undefined;
	            if (tag) {
	                return checkAssertionWorker(tag, tag.typeExpression.type, node.expression, checkMode);
	            }
	            return checkExpression(node.expression, checkMode);
	        }
	        function checkExpressionWorker(node, checkMode) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return checkIdentifier(node);
	                case 99 /* ThisKeyword */:
	                    return checkThisExpression(node);
	                case 97 /* SuperKeyword */:
	                    return checkSuperExpression(node);
	                case 95 /* NullKeyword */:
	                    return nullWideningType;
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 9 /* StringLiteral */:
	                    return getFreshTypeOfLiteralType(getLiteralType(node.text));
	                case 8 /* NumericLiteral */:
	                    checkGrammarNumericLiteral(node);
	                    return getFreshTypeOfLiteralType(getLiteralType(+node.text));
	                case 101 /* TrueKeyword */:
	                    return trueType;
	                case 86 /* FalseKeyword */:
	                    return falseType;
	                case 200 /* TemplateExpression */:
	                    return checkTemplateExpression(node);
	                case 12 /* RegularExpressionLiteral */:
	                    return globalRegExpType;
	                case 181 /* ArrayLiteralExpression */:
	                    return checkArrayLiteral(node, checkMode);
	                case 182 /* ObjectLiteralExpression */:
	                    return checkObjectLiteral(node, checkMode);
	                case 183 /* PropertyAccessExpression */:
	                    return checkPropertyAccessExpression(node);
	                case 184 /* ElementAccessExpression */:
	                    return checkIndexedAccess(node);
	                case 185 /* CallExpression */:
	                    if (node.expression.kind === 91 /* ImportKeyword */) {
	                        return checkImportCallExpression(node);
	                    }
	                /* falls through */
	                case 186 /* NewExpression */:
	                    return checkCallExpression(node);
	                case 187 /* TaggedTemplateExpression */:
	                    return checkTaggedTemplateExpression(node);
	                case 189 /* ParenthesizedExpression */:
	                    return checkParenthesizedExpression(node, checkMode);
	                case 203 /* ClassExpression */:
	                    return checkClassExpression(node);
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                    return checkFunctionExpressionOrObjectLiteralMethod(node, checkMode);
	                case 193 /* TypeOfExpression */:
	                    return checkTypeOfExpression(node);
	                case 188 /* TypeAssertionExpression */:
	                case 206 /* AsExpression */:
	                    return checkAssertion(node);
	                case 207 /* NonNullExpression */:
	                    return checkNonNullAssertion(node);
	                case 208 /* MetaProperty */:
	                    return checkMetaProperty(node);
	                case 192 /* DeleteExpression */:
	                    return checkDeleteExpression(node);
	                case 194 /* VoidExpression */:
	                    return checkVoidExpression(node);
	                case 195 /* AwaitExpression */:
	                    return checkAwaitExpression(node);
	                case 196 /* PrefixUnaryExpression */:
	                    return checkPrefixUnaryExpression(node);
	                case 197 /* PostfixUnaryExpression */:
	                    return checkPostfixUnaryExpression(node);
	                case 198 /* BinaryExpression */:
	                    return checkBinaryExpression(node, checkMode);
	                case 199 /* ConditionalExpression */:
	                    return checkConditionalExpression(node, checkMode);
	                case 202 /* SpreadElement */:
	                    return checkSpreadExpression(node, checkMode);
	                case 204 /* OmittedExpression */:
	                    return undefinedWideningType;
	                case 201 /* YieldExpression */:
	                    return checkYieldExpression(node);
	                case 263 /* JsxExpression */:
	                    return checkJsxExpression(node, checkMode);
	                case 253 /* JsxElement */:
	                    return checkJsxElement(node, checkMode);
	                case 254 /* JsxSelfClosingElement */:
	                    return checkJsxSelfClosingElement(node, checkMode);
	                case 257 /* JsxFragment */:
	                    return checkJsxFragment(node, checkMode);
	                case 261 /* JsxAttributes */:
	                    return checkJsxAttributes(node, checkMode);
	                case 255 /* JsxOpeningElement */:
	                    ts.Debug.fail("Shouldn't ever directly check a JsxOpeningElement");
	            }
	            return unknownType;
	        }
	        // DECLARATION AND STATEMENT TYPE CHECKING
	        function checkTypeParameter(node) {
	            // Grammar Checking
	            if (node.expression) {
	                grammarErrorOnFirstToken(node.expression, ts.Diagnostics.Type_expected);
	            }
	            checkSourceElement(node.constraint);
	            checkSourceElement(node.default);
	            var typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfNode(node));
	            if (!hasNonCircularBaseConstraint(typeParameter)) {
	                error(node.constraint, ts.Diagnostics.Type_parameter_0_has_a_circular_constraint, typeToString(typeParameter));
	            }
	            if (!hasNonCircularTypeParameterDefault(typeParameter)) {
	                error(node.default, ts.Diagnostics.Type_parameter_0_has_a_circular_default, typeToString(typeParameter));
	            }
	            var constraintType = getConstraintOfTypeParameter(typeParameter);
	            var defaultType = getDefaultFromTypeParameter(typeParameter);
	            if (constraintType && defaultType) {
	                checkTypeAssignableTo(defaultType, getTypeWithThisArgument(constraintType, defaultType), node.default, ts.Diagnostics.Type_0_does_not_satisfy_the_constraint_1);
	            }
	            if (produceDiagnostics) {
	                checkTypeNameIsReserved(node.name, ts.Diagnostics.Type_parameter_name_cannot_be_0);
	            }
	        }
	        function checkParameter(node) {
	            // Grammar checking
	            // It is a SyntaxError if the Identifier "eval" or the Identifier "arguments" occurs as the
	            // Identifier in a PropertySetParameterList of a PropertyAssignment that is contained in strict code
	            // or if its FunctionBody is strict code(11.1.5).
	            checkGrammarDecoratorsAndModifiers(node);
	            checkVariableLikeDeclaration(node);
	            var func = ts.getContainingFunction(node);
	            if (ts.hasModifier(node, 92 /* ParameterPropertyModifier */)) {
	                if (!(func.kind === 154 /* Constructor */ && ts.nodeIsPresent(func.body))) {
	                    error(node, ts.Diagnostics.A_parameter_property_is_only_allowed_in_a_constructor_implementation);
	                }
	            }
	            if (node.questionToken && ts.isBindingPattern(node.name) && func.body) {
	                error(node, ts.Diagnostics.A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature);
	            }
	            if (node.name && ts.isIdentifier(node.name) && (node.name.escapedText === "this" || node.name.escapedText === "new")) {
	                if (func.parameters.indexOf(node) !== 0) {
	                    error(node, ts.Diagnostics.A_0_parameter_must_be_the_first_parameter, node.name.escapedText);
	                }
	                if (func.kind === 154 /* Constructor */ || func.kind === 158 /* ConstructSignature */ || func.kind === 163 /* ConstructorType */) {
	                    error(node, ts.Diagnostics.A_constructor_cannot_have_a_this_parameter);
	                }
	            }
	            // Only check rest parameter type if it's not a binding pattern. Since binding patterns are
	            // not allowed in a rest parameter, we already have an error from checkGrammarParameterList.
	            if (node.dotDotDotToken && !ts.isBindingPattern(node.name) && !isArrayType(getTypeOfSymbol(node.symbol))) {
	                error(node, ts.Diagnostics.A_rest_parameter_must_be_of_an_array_type);
	            }
	        }
	        function getTypePredicateParameterIndex(parameterList, parameter) {
	            if (parameterList) {
	                for (var i = 0; i < parameterList.length; i++) {
	                    var param = parameterList[i];
	                    if (param.name.kind === 71 /* Identifier */ && param.name.escapedText === parameter.escapedText) {
	                        return i;
	                    }
	                }
	            }
	            return -1;
	        }
	        function checkTypePredicate(node) {
	            var parent = getTypePredicateParent(node);
	            if (!parent) {
	                // The parent must not be valid.
	                error(node, ts.Diagnostics.A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods);
	                return;
	            }
	            var typePredicate = getTypePredicateOfSignature(getSignatureFromDeclaration(parent));
	            if (!typePredicate) {
	                return;
	            }
	            checkSourceElement(node.type);
	            var parameterName = node.parameterName;
	            if (ts.isThisTypePredicate(typePredicate)) {
	                getTypeFromThisTypeNode(parameterName);
	            }
	            else {
	                if (typePredicate.parameterIndex >= 0) {
	                    if (parent.parameters[typePredicate.parameterIndex].dotDotDotToken) {
	                        error(parameterName, ts.Diagnostics.A_type_predicate_cannot_reference_a_rest_parameter);
	                    }
	                    else {
	                        var leadingError = function () { return ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type); };
	                        checkTypeAssignableTo(typePredicate.type, getTypeOfNode(parent.parameters[typePredicate.parameterIndex]), node.type, 
	                        /*headMessage*/ undefined, leadingError);
	                    }
	                }
	                else if (parameterName) {
	                    var hasReportedError = false;
	                    for (var _i = 0, _a = parent.parameters; _i < _a.length; _i++) {
	                        var name = _a[_i].name;
	                        if (ts.isBindingPattern(name) &&
	                            checkIfTypePredicateVariableIsDeclaredInBindingPattern(name, parameterName, typePredicate.parameterName)) {
	                            hasReportedError = true;
	                            break;
	                        }
	                    }
	                    if (!hasReportedError) {
	                        error(node.parameterName, ts.Diagnostics.Cannot_find_parameter_0, typePredicate.parameterName);
	                    }
	                }
	            }
	        }
	        function getTypePredicateParent(node) {
	            switch (node.parent.kind) {
	                case 191 /* ArrowFunction */:
	                case 157 /* CallSignature */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 162 /* FunctionType */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    var parent = node.parent;
	                    if (node === parent.type) {
	                        return parent;
	                    }
	            }
	        }
	        function checkIfTypePredicateVariableIsDeclaredInBindingPattern(pattern, predicateVariableNode, predicateVariableName) {
	            for (var _i = 0, _a = pattern.elements; _i < _a.length; _i++) {
	                var element = _a[_i];
	                if (ts.isOmittedExpression(element)) {
	                    continue;
	                }
	                var name = element.name;
	                if (name.kind === 71 /* Identifier */ && name.escapedText === predicateVariableName) {
	                    error(predicateVariableNode, ts.Diagnostics.A_type_predicate_cannot_reference_element_0_in_a_binding_pattern, predicateVariableName);
	                    return true;
	                }
	                else if (name.kind === 179 /* ArrayBindingPattern */ || name.kind === 178 /* ObjectBindingPattern */) {
	                    if (checkIfTypePredicateVariableIsDeclaredInBindingPattern(name, predicateVariableNode, predicateVariableName)) {
	                        return true;
	                    }
	                }
	            }
	        }
	        function checkSignatureDeclaration(node) {
	            // Grammar checking
	            if (node.kind === 159 /* IndexSignature */) {
	                checkGrammarIndexSignature(node);
	            }
	            else if (node.kind === 162 /* FunctionType */ || node.kind === 232 /* FunctionDeclaration */ || node.kind === 163 /* ConstructorType */ ||
	                node.kind === 157 /* CallSignature */ || node.kind === 154 /* Constructor */ ||
	                node.kind === 158 /* ConstructSignature */) {
	                checkGrammarFunctionLikeDeclaration(node);
	            }
	            var functionFlags = ts.getFunctionFlags(node);
	            if (!(functionFlags & 4 /* Invalid */)) {
	                // Async generators prior to ESNext require the __await and __asyncGenerator helpers
	                if ((functionFlags & 3 /* AsyncGenerator */) === 3 /* AsyncGenerator */ && languageVersion < 6 /* ESNext */) {
	                    checkExternalEmitHelpers(node, 6144 /* AsyncGeneratorIncludes */);
	                }
	                // Async functions prior to ES2017 require the __awaiter helper
	                if ((functionFlags & 3 /* AsyncGenerator */) === 2 /* Async */ && languageVersion < 4 /* ES2017 */) {
	                    checkExternalEmitHelpers(node, 64 /* Awaiter */);
	                }
	                // Generator functions, Async functions, and Async Generator functions prior to
	                // ES2015 require the __generator helper
	                if ((functionFlags & 3 /* AsyncGenerator */) !== 0 /* Normal */ && languageVersion < 2 /* ES2015 */) {
	                    checkExternalEmitHelpers(node, 128 /* Generator */);
	                }
	            }
	            checkTypeParameters(node.typeParameters);
	            ts.forEach(node.parameters, checkParameter);
	            // TODO(rbuckton): Should we start checking JSDoc types?
	            if (node.type) {
	                checkSourceElement(node.type);
	            }
	            if (produceDiagnostics) {
	                checkCollisionWithArgumentsInGeneratedCode(node);
	                var returnTypeNode = ts.getEffectiveReturnTypeNode(node);
	                if (noImplicitAny && !returnTypeNode) {
	                    switch (node.kind) {
	                        case 158 /* ConstructSignature */:
	                            error(node, ts.Diagnostics.Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type);
	                            break;
	                        case 157 /* CallSignature */:
	                            error(node, ts.Diagnostics.Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type);
	                            break;
	                    }
	                }
	                if (returnTypeNode) {
	                    var functionFlags_1 = ts.getFunctionFlags(node);
	                    if ((functionFlags_1 & (4 /* Invalid */ | 1 /* Generator */)) === 1 /* Generator */) {
	                        var returnType = getTypeFromTypeNode(returnTypeNode);
	                        if (returnType === voidType) {
	                            error(returnTypeNode, ts.Diagnostics.A_generator_cannot_have_a_void_type_annotation);
	                        }
	                        else {
	                            var generatorElementType = getIteratedTypeOfGenerator(returnType, (functionFlags_1 & 2 /* Async */) !== 0) || anyType;
	                            var iterableIteratorInstantiation = functionFlags_1 & 2 /* Async */
	                                ? createAsyncIterableIteratorType(generatorElementType) // AsyncGenerator function
	                                : createIterableIteratorType(generatorElementType); // Generator function
	                            // Naively, one could check that IterableIterator<any> is assignable to the return type annotation.
	                            // However, that would not catch the error in the following case.
	                            //
	                            //    interface BadGenerator extends Iterable<number>, Iterator<string> { }
	                            //    function* g(): BadGenerator { } // Iterable and Iterator have different types!
	                            //
	                            checkTypeAssignableTo(iterableIteratorInstantiation, returnType, returnTypeNode);
	                        }
	                    }
	                    else if ((functionFlags_1 & 3 /* AsyncGenerator */) === 2 /* Async */) {
	                        checkAsyncFunctionReturnType(node);
	                    }
	                }
	                if (noUnusedIdentifiers && !node.body) {
	                    checkUnusedTypeParameters(node);
	                }
	            }
	        }
	        function checkClassForDuplicateDeclarations(node) {
	            var Declaration;
	            (function (Declaration) {
	                Declaration[Declaration["Getter"] = 1] = "Getter";
	                Declaration[Declaration["Setter"] = 2] = "Setter";
	                Declaration[Declaration["Method"] = 4] = "Method";
	                Declaration[Declaration["Property"] = 3] = "Property";
	            })(Declaration || (Declaration = {}));
	            var instanceNames = ts.createUnderscoreEscapedMap();
	            var staticNames = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                if (member.kind === 154 /* Constructor */) {
	                    for (var _b = 0, _c = member.parameters; _b < _c.length; _b++) {
	                        var param = _c[_b];
	                        if (ts.isParameterPropertyDeclaration(param) && !ts.isBindingPattern(param.name)) {
	                            addName(instanceNames, param.name, param.name.escapedText, 3 /* Property */);
	                        }
	                    }
	                }
	                else {
	                    var isStatic = ts.hasModifier(member, 32 /* Static */);
	                    var names = isStatic ? staticNames : instanceNames;
	                    var memberName = member.name && ts.getPropertyNameForPropertyNameNode(member.name);
	                    if (memberName) {
	                        switch (member.kind) {
	                            case 155 /* GetAccessor */:
	                                addName(names, member.name, memberName, 1 /* Getter */);
	                                break;
	                            case 156 /* SetAccessor */:
	                                addName(names, member.name, memberName, 2 /* Setter */);
	                                break;
	                            case 151 /* PropertyDeclaration */:
	                                addName(names, member.name, memberName, 3 /* Property */);
	                                break;
	                            case 153 /* MethodDeclaration */:
	                                addName(names, member.name, memberName, 4 /* Method */);
	                                break;
	                        }
	                    }
	                }
	            }
	            function addName(names, location, name, meaning) {
	                var prev = names.get(name);
	                if (prev) {
	                    if (prev & 4 /* Method */) {
	                        if (meaning !== 4 /* Method */) {
	                            error(location, ts.Diagnostics.Duplicate_identifier_0, ts.getTextOfNode(location));
	                        }
	                    }
	                    else if (prev & meaning) {
	                        error(location, ts.Diagnostics.Duplicate_identifier_0, ts.getTextOfNode(location));
	                    }
	                    else {
	                        names.set(name, prev | meaning);
	                    }
	                }
	                else {
	                    names.set(name, meaning);
	                }
	            }
	        }
	        /**
	         * Static members being set on a constructor function may conflict with built-in properties
	         * of Function. Esp. in ECMAScript 5 there are non-configurable and non-writable
	         * built-in properties. This check issues a transpile error when a class has a static
	         * member with the same name as a non-writable built-in property.
	         *
	         * @see http://www.ecma-international.org/ecma-262/5.1/#sec-15.3.3
	         * @see http://www.ecma-international.org/ecma-262/5.1/#sec-15.3.5
	         * @see http://www.ecma-international.org/ecma-262/6.0/#sec-properties-of-the-function-constructor
	         * @see http://www.ecma-international.org/ecma-262/6.0/#sec-function-instances
	         */
	        function checkClassForStaticPropertyNameConflicts(node) {
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                var memberNameNode = member.name;
	                var isStatic = ts.hasModifier(member, 32 /* Static */);
	                if (isStatic && memberNameNode) {
	                    var memberName = ts.getPropertyNameForPropertyNameNode(memberNameNode);
	                    switch (memberName) {
	                        case "name":
	                        case "length":
	                        case "caller":
	                        case "arguments":
	                        case "prototype":
	                            var message = ts.Diagnostics.Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1;
	                            var className = getNameOfSymbolAsWritten(getSymbolOfNode(node));
	                            error(memberNameNode, message, memberName, className);
	                            break;
	                    }
	                }
	            }
	        }
	        function checkObjectTypeForDuplicateDeclarations(node) {
	            var names = ts.createMap();
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                if (member.kind === 150 /* PropertySignature */) {
	                    var memberName = void 0;
	                    switch (member.name.kind) {
	                        case 9 /* StringLiteral */:
	                        case 8 /* NumericLiteral */:
	                            memberName = member.name.text;
	                            break;
	                        case 71 /* Identifier */:
	                            memberName = ts.idText(member.name);
	                            break;
	                        default:
	                            continue;
	                    }
	                    if (names.get(memberName)) {
	                        error(ts.getNameOfDeclaration(member.symbol.valueDeclaration), ts.Diagnostics.Duplicate_identifier_0, memberName);
	                        error(member.name, ts.Diagnostics.Duplicate_identifier_0, memberName);
	                    }
	                    else {
	                        names.set(memberName, true);
	                    }
	                }
	            }
	        }
	        function checkTypeForDuplicateIndexSignatures(node) {
	            if (node.kind === 234 /* InterfaceDeclaration */) {
	                var nodeSymbol = getSymbolOfNode(node);
	                // in case of merging interface declaration it is possible that we'll enter this check procedure several times for every declaration
	                // to prevent this run check only for the first declaration of a given kind
	                if (nodeSymbol.declarations.length > 0 && nodeSymbol.declarations[0] !== node) {
	                    return;
	                }
	            }
	            // TypeScript 1.0 spec (April 2014)
	            // 3.7.4: An object type can contain at most one string index signature and one numeric index signature.
	            // 8.5: A class declaration can have at most one string index member declaration and one numeric index member declaration
	            var indexSymbol = getIndexSymbol(getSymbolOfNode(node));
	            if (indexSymbol) {
	                var seenNumericIndexer = false;
	                var seenStringIndexer = false;
	                for (var _i = 0, _a = indexSymbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var declaration = decl;
	                    if (declaration.parameters.length === 1 && declaration.parameters[0].type) {
	                        switch (declaration.parameters[0].type.kind) {
	                            case 137 /* StringKeyword */:
	                                if (!seenStringIndexer) {
	                                    seenStringIndexer = true;
	                                }
	                                else {
	                                    error(declaration, ts.Diagnostics.Duplicate_string_index_signature);
	                                }
	                                break;
	                            case 134 /* NumberKeyword */:
	                                if (!seenNumericIndexer) {
	                                    seenNumericIndexer = true;
	                                }
	                                else {
	                                    error(declaration, ts.Diagnostics.Duplicate_number_index_signature);
	                                }
	                                break;
	                        }
	                    }
	                }
	            }
	        }
	        function checkPropertyDeclaration(node) {
	            // Grammar checking
	            if (!checkGrammarDecoratorsAndModifiers(node) && !checkGrammarProperty(node))
	                checkGrammarComputedPropertyName(node.name);
	            checkVariableLikeDeclaration(node);
	        }
	        function checkMethodDeclaration(node) {
	            // Grammar checking
	            if (!checkGrammarMethod(node))
	                checkGrammarComputedPropertyName(node.name);
	            // Grammar checking for modifiers is done inside the function checkGrammarFunctionLikeDeclaration
	            checkFunctionOrMethodDeclaration(node);
	            // Abstract methods cannot have an implementation.
	            // Extra checks are to avoid reporting multiple errors relating to the "abstractness" of the node.
	            if (ts.hasModifier(node, 128 /* Abstract */) && node.kind === 153 /* MethodDeclaration */ && node.body) {
	                error(node, ts.Diagnostics.Method_0_cannot_have_an_implementation_because_it_is_marked_abstract, ts.declarationNameToString(node.name));
	            }
	        }
	        function checkConstructorDeclaration(node) {
	            // Grammar check on signature of constructor and modifier of the constructor is done in checkSignatureDeclaration function.
	            checkSignatureDeclaration(node);
	            // Grammar check for checking only related to constructorDeclaration
	            if (!checkGrammarConstructorTypeParameters(node))
	                checkGrammarConstructorTypeAnnotation(node);
	            checkSourceElement(node.body);
	            registerForUnusedIdentifiersCheck(node);
	            var symbol = getSymbolOfNode(node);
	            var firstDeclaration = ts.getDeclarationOfKind(symbol, node.kind);
	            // Only type check the symbol once
	            if (node === firstDeclaration) {
	                checkFunctionOrConstructorSymbol(symbol);
	            }
	            // exit early in the case of signature - super checks are not relevant to them
	            if (ts.nodeIsMissing(node.body)) {
	                return;
	            }
	            if (!produceDiagnostics) {
	                return;
	            }
	            function isInstancePropertyWithInitializer(n) {
	                return n.kind === 151 /* PropertyDeclaration */ &&
	                    !ts.hasModifier(n, 32 /* Static */) &&
	                    !!n.initializer;
	            }
	            // TS 1.0 spec (April 2014): 8.3.2
	            // Constructors of classes with no extends clause may not contain super calls, whereas
	            // constructors of derived classes must contain at least one super call somewhere in their function body.
	            var containingClassDecl = node.parent;
	            if (ts.getClassExtendsHeritageClauseElement(containingClassDecl)) {
	                captureLexicalThis(node.parent, containingClassDecl);
	                var classExtendsNull = classDeclarationExtendsNull(containingClassDecl);
	                var superCall = getSuperCallInConstructor(node);
	                if (superCall) {
	                    if (classExtendsNull) {
	                        error(superCall, ts.Diagnostics.A_constructor_cannot_contain_a_super_call_when_its_class_extends_null);
	                    }
	                    // The first statement in the body of a constructor (excluding prologue directives) must be a super call
	                    // if both of the following are true:
	                    // - The containing class is a derived class.
	                    // - The constructor declares parameter properties
	                    //   or the containing class declares instance member variables with initializers.
	                    var superCallShouldBeFirst = ts.some(node.parent.members, isInstancePropertyWithInitializer) ||
	                        ts.some(node.parameters, function (p) { return ts.hasModifier(p, 92 /* ParameterPropertyModifier */); });
	                    // Skip past any prologue directives to find the first statement
	                    // to ensure that it was a super call.
	                    if (superCallShouldBeFirst) {
	                        var statements = node.body.statements;
	                        var superCallStatement = void 0;
	                        for (var _i = 0, statements_2 = statements; _i < statements_2.length; _i++) {
	                            var statement = statements_2[_i];
	                            if (statement.kind === 214 /* ExpressionStatement */ && ts.isSuperCall(statement.expression)) {
	                                superCallStatement = statement;
	                                break;
	                            }
	                            if (!ts.isPrologueDirective(statement)) {
	                                break;
	                            }
	                        }
	                        if (!superCallStatement) {
	                            error(node, ts.Diagnostics.A_super_call_must_be_the_first_statement_in_the_constructor_when_a_class_contains_initialized_properties_or_has_parameter_properties);
	                        }
	                    }
	                }
	                else if (!classExtendsNull) {
	                    error(node, ts.Diagnostics.Constructors_for_derived_classes_must_contain_a_super_call);
	                }
	            }
	        }
	        function checkAccessorDeclaration(node) {
	            if (produceDiagnostics) {
	                // Grammar checking accessors
	                if (!checkGrammarFunctionLikeDeclaration(node) && !checkGrammarAccessor(node))
	                    checkGrammarComputedPropertyName(node.name);
	                checkDecorators(node);
	                checkSignatureDeclaration(node);
	                if (node.kind === 155 /* GetAccessor */) {
	                    if (!(node.flags & 2097152 /* Ambient */) && ts.nodeIsPresent(node.body) && (node.flags & 128 /* HasImplicitReturn */)) {
	                        if (!(node.flags & 256 /* HasExplicitReturn */)) {
	                            error(node.name, ts.Diagnostics.A_get_accessor_must_return_a_value);
	                        }
	                    }
	                }
	                // Do not use hasDynamicName here, because that returns false for well known symbols.
	                // We want to perform checkComputedPropertyName for all computed properties, including
	                // well known symbols.
	                if (node.name.kind === 146 /* ComputedPropertyName */) {
	                    checkComputedPropertyName(node.name);
	                }
	                if (!hasNonBindableDynamicName(node)) {
	                    // TypeScript 1.0 spec (April 2014): 8.4.3
	                    // Accessors for the same member name must specify the same accessibility.
	                    var otherKind = node.kind === 155 /* GetAccessor */ ? 156 /* SetAccessor */ : 155 /* GetAccessor */;
	                    var otherAccessor = ts.getDeclarationOfKind(getSymbolOfNode(node), otherKind);
	                    if (otherAccessor) {
	                        var nodeFlags = ts.getModifierFlags(node);
	                        var otherFlags = ts.getModifierFlags(otherAccessor);
	                        if ((nodeFlags & 28 /* AccessibilityModifier */) !== (otherFlags & 28 /* AccessibilityModifier */)) {
	                            error(node.name, ts.Diagnostics.Getter_and_setter_accessors_do_not_agree_in_visibility);
	                        }
	                        if ((nodeFlags & 128 /* Abstract */) !== (otherFlags & 128 /* Abstract */)) {
	                            error(node.name, ts.Diagnostics.Accessors_must_both_be_abstract_or_non_abstract);
	                        }
	                        // TypeScript 1.0 spec (April 2014): 4.5
	                        // If both accessors include type annotations, the specified types must be identical.
	                        checkAccessorDeclarationTypesIdentical(node, otherAccessor, getAnnotatedAccessorType, ts.Diagnostics.get_and_set_accessor_must_have_the_same_type);
	                        checkAccessorDeclarationTypesIdentical(node, otherAccessor, getThisTypeOfDeclaration, ts.Diagnostics.get_and_set_accessor_must_have_the_same_this_type);
	                    }
	                }
	                var returnType = getTypeOfAccessors(getSymbolOfNode(node));
	                if (node.kind === 155 /* GetAccessor */) {
	                    checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnType);
	                }
	            }
	            checkSourceElement(node.body);
	            registerForUnusedIdentifiersCheck(node);
	        }
	        function checkAccessorDeclarationTypesIdentical(first, second, getAnnotatedType, message) {
	            var firstType = getAnnotatedType(first);
	            var secondType = getAnnotatedType(second);
	            if (firstType && secondType && !isTypeIdenticalTo(firstType, secondType)) {
	                error(first, message);
	            }
	        }
	        function checkMissingDeclaration(node) {
	            checkDecorators(node);
	        }
	        function getEffectiveTypeArguments(node, typeParameters) {
	            return fillMissingTypeArguments(ts.map(node.typeArguments, getTypeFromTypeNode), typeParameters, getMinTypeArgumentCount(typeParameters), ts.isInJavaScriptFile(node));
	        }
	        function checkTypeArgumentConstraints(node, typeParameters) {
	            var typeArguments;
	            var mapper;
	            var result = true;
	            for (var i = 0; i < typeParameters.length; i++) {
	                var constraint = getConstraintOfTypeParameter(typeParameters[i]);
	                if (constraint) {
	                    if (!typeArguments) {
	                        typeArguments = getEffectiveTypeArguments(node, typeParameters);
	                        mapper = createTypeMapper(typeParameters, typeArguments);
	                    }
	                    result = result && checkTypeAssignableTo(typeArguments[i], instantiateType(constraint, mapper), node.typeArguments[i], ts.Diagnostics.Type_0_does_not_satisfy_the_constraint_1);
	                }
	            }
	            return result;
	        }
	        function getTypeParametersForTypeReference(node) {
	            var type = getTypeFromTypeReference(node);
	            if (type !== unknownType) {
	                var symbol = getNodeLinks(node).resolvedSymbol;
	                if (symbol) {
	                    return symbol.flags & 524288 /* TypeAlias */ && getSymbolLinks(symbol).typeParameters ||
	                        (ts.getObjectFlags(type) & 4 /* Reference */ ? type.target.localTypeParameters : undefined);
	                }
	            }
	            return undefined;
	        }
	        function checkTypeReferenceNode(node) {
	            checkGrammarTypeArguments(node, node.typeArguments);
	            if (node.kind === 161 /* TypeReference */ && node.typeName.jsdocDotPos !== undefined && !ts.isInJavaScriptFile(node) && !ts.isInJSDoc(node)) {
	                grammarErrorAtPos(node, node.typeName.jsdocDotPos, 1, ts.Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments);
	            }
	            var type = getTypeFromTypeReference(node);
	            if (type !== unknownType) {
	                if (node.typeArguments) {
	                    // Do type argument local checks only if referenced type is successfully resolved
	                    ts.forEach(node.typeArguments, checkSourceElement);
	                    if (produceDiagnostics) {
	                        var typeParameters = getTypeParametersForTypeReference(node);
	                        if (typeParameters) {
	                            checkTypeArgumentConstraints(node, typeParameters);
	                        }
	                    }
	                }
	                if (type.flags & 16 /* Enum */ && getNodeLinks(node).resolvedSymbol.flags & 8 /* EnumMember */) {
	                    error(node, ts.Diagnostics.Enum_type_0_has_members_with_initializers_that_are_not_literals, typeToString(type));
	                }
	            }
	        }
	        function getTypeArgumentConstraint(node) {
	            var typeReferenceNode = ts.tryCast(node.parent, ts.isTypeReferenceType);
	            if (!typeReferenceNode)
	                return undefined;
	            var typeParameters = getTypeParametersForTypeReference(typeReferenceNode);
	            var constraint = getConstraintOfTypeParameter(typeParameters[typeReferenceNode.typeArguments.indexOf(node)]);
	            return constraint && instantiateType(constraint, createTypeMapper(typeParameters, getEffectiveTypeArguments(typeReferenceNode, typeParameters)));
	        }
	        function checkTypeQuery(node) {
	            getTypeFromTypeQueryNode(node);
	        }
	        function checkTypeLiteral(node) {
	            ts.forEach(node.members, checkSourceElement);
	            if (produceDiagnostics) {
	                var type = getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node);
	                checkIndexConstraints(type);
	                checkTypeForDuplicateIndexSignatures(node);
	                checkObjectTypeForDuplicateDeclarations(node);
	            }
	        }
	        function checkArrayType(node) {
	            checkSourceElement(node.elementType);
	        }
	        function checkTupleType(node) {
	            // Grammar checking
	            var hasErrorFromDisallowedTrailingComma = checkGrammarForDisallowedTrailingComma(node.elementTypes);
	            if (!hasErrorFromDisallowedTrailingComma && node.elementTypes.length === 0) {
	                grammarErrorOnNode(node, ts.Diagnostics.A_tuple_type_element_list_cannot_be_empty);
	            }
	            ts.forEach(node.elementTypes, checkSourceElement);
	        }
	        function checkUnionOrIntersectionType(node) {
	            ts.forEach(node.types, checkSourceElement);
	        }
	        function checkIndexedAccessIndexType(type, accessNode) {
	            if (!(type.flags & 1048576 /* IndexedAccess */)) {
	                return type;
	            }
	            // Check if the index type is assignable to 'keyof T' for the object type.
	            var objectType = type.objectType;
	            var indexType = type.indexType;
	            if (isTypeAssignableTo(indexType, getIndexType(objectType))) {
	                if (accessNode.kind === 184 /* ElementAccessExpression */ && ts.isAssignmentTarget(accessNode) &&
	                    ts.getObjectFlags(objectType) & 32 /* Mapped */ && getMappedTypeModifiers(objectType) & 1 /* IncludeReadonly */) {
	                    error(accessNode, ts.Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(objectType));
	                }
	                return type;
	            }
	            // Check if we're indexing with a numeric type and if either object or index types
	            // is a generic type with a constraint that has a numeric index signature.
	            if (getIndexInfoOfType(getApparentType(objectType), 1 /* Number */) && isTypeAssignableToKind(indexType, 84 /* NumberLike */)) {
	                return type;
	            }
	            error(accessNode, ts.Diagnostics.Type_0_cannot_be_used_to_index_type_1, typeToString(indexType), typeToString(objectType));
	            return type;
	        }
	        function checkIndexedAccessType(node) {
	            checkSourceElement(node.objectType);
	            checkSourceElement(node.indexType);
	            checkIndexedAccessIndexType(getTypeFromIndexedAccessTypeNode(node), node);
	        }
	        function checkMappedType(node) {
	            checkSourceElement(node.typeParameter);
	            checkSourceElement(node.type);
	            if (noImplicitAny && !node.type) {
	                reportImplicitAnyError(node, anyType);
	            }
	            var type = getTypeFromMappedTypeNode(node);
	            var constraintType = getConstraintTypeFromMappedType(type);
	            checkTypeAssignableTo(constraintType, stringType, node.typeParameter.constraint);
	        }
	        function checkTypeOperator(node) {
	            checkGrammarTypeOperatorNode(node);
	            checkSourceElement(node.type);
	        }
	        function checkConditionalType(node) {
	            ts.forEachChild(node, checkSourceElement);
	        }
	        function checkInferType(node) {
	            if (!ts.findAncestor(node, function (n) { return n.parent && n.parent.kind === 170 /* ConditionalType */ && n.parent.extendsType === n; })) {
	                grammarErrorOnNode(node, ts.Diagnostics.infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type);
	            }
	            checkSourceElement(node.typeParameter);
	        }
	        function isPrivateWithinAmbient(node) {
	            return ts.hasModifier(node, 8 /* Private */) && !!(node.flags & 2097152 /* Ambient */);
	        }
	        function getEffectiveDeclarationFlags(n, flagsToCheck) {
	            var flags = ts.getCombinedModifierFlags(n);
	            // children of classes (even ambient classes) should not be marked as ambient or export
	            // because those flags have no useful semantics there.
	            if (n.parent.kind !== 234 /* InterfaceDeclaration */ &&
	                n.parent.kind !== 233 /* ClassDeclaration */ &&
	                n.parent.kind !== 203 /* ClassExpression */ &&
	                n.flags & 2097152 /* Ambient */) {
	                if (!(flags & 2 /* Ambient */)) {
	                    // It is nested in an ambient context, which means it is automatically exported
	                    flags |= 1 /* Export */;
	                }
	                flags |= 2 /* Ambient */;
	            }
	            return flags & flagsToCheck;
	        }
	        function checkFunctionOrConstructorSymbol(symbol) {
	            if (!produceDiagnostics) {
	                return;
	            }
	            function getCanonicalOverload(overloads, implementation) {
	                // Consider the canonical set of flags to be the flags of the bodyDeclaration or the first declaration
	                // Error on all deviations from this canonical set of flags
	                // The caveat is that if some overloads are defined in lib.d.ts, we don't want to
	                // report the errors on those. To achieve this, we will say that the implementation is
	                // the canonical signature only if it is in the same container as the first overload
	                var implementationSharesContainerWithFirstOverload = implementation !== undefined && implementation.parent === overloads[0].parent;
	                return implementationSharesContainerWithFirstOverload ? implementation : overloads[0];
	            }
	            function checkFlagAgreementBetweenOverloads(overloads, implementation, flagsToCheck, someOverloadFlags, allOverloadFlags) {
	                // Error if some overloads have a flag that is not shared by all overloads. To find the
	                // deviations, we XOR someOverloadFlags with allOverloadFlags
	                var someButNotAllOverloadFlags = someOverloadFlags ^ allOverloadFlags;
	                if (someButNotAllOverloadFlags !== 0) {
	                    var canonicalFlags_1 = getEffectiveDeclarationFlags(getCanonicalOverload(overloads, implementation), flagsToCheck);
	                    ts.forEach(overloads, function (o) {
	                        var deviation = getEffectiveDeclarationFlags(o, flagsToCheck) ^ canonicalFlags_1;
	                        if (deviation & 1 /* Export */) {
	                            error(ts.getNameOfDeclaration(o), ts.Diagnostics.Overload_signatures_must_all_be_exported_or_non_exported);
	                        }
	                        else if (deviation & 2 /* Ambient */) {
	                            error(ts.getNameOfDeclaration(o), ts.Diagnostics.Overload_signatures_must_all_be_ambient_or_non_ambient);
	                        }
	                        else if (deviation & (8 /* Private */ | 16 /* Protected */)) {
	                            error(ts.getNameOfDeclaration(o) || o, ts.Diagnostics.Overload_signatures_must_all_be_public_private_or_protected);
	                        }
	                        else if (deviation & 128 /* Abstract */) {
	                            error(ts.getNameOfDeclaration(o), ts.Diagnostics.Overload_signatures_must_all_be_abstract_or_non_abstract);
	                        }
	                    });
	                }
	            }
	            function checkQuestionTokenAgreementBetweenOverloads(overloads, implementation, someHaveQuestionToken, allHaveQuestionToken) {
	                if (someHaveQuestionToken !== allHaveQuestionToken) {
	                    var canonicalHasQuestionToken_1 = ts.hasQuestionToken(getCanonicalOverload(overloads, implementation));
	                    ts.forEach(overloads, function (o) {
	                        var deviation = ts.hasQuestionToken(o) !== canonicalHasQuestionToken_1;
	                        if (deviation) {
	                            error(ts.getNameOfDeclaration(o), ts.Diagnostics.Overload_signatures_must_all_be_optional_or_required);
	                        }
	                    });
	                }
	            }
	            var flagsToCheck = 1 /* Export */ | 2 /* Ambient */ | 8 /* Private */ | 16 /* Protected */ | 128 /* Abstract */;
	            var someNodeFlags = 0 /* None */;
	            var allNodeFlags = flagsToCheck;
	            var someHaveQuestionToken = false;
	            var allHaveQuestionToken = true;
	            var hasOverloads = false;
	            var bodyDeclaration;
	            var lastSeenNonAmbientDeclaration;
	            var previousDeclaration;
	            var declarations = symbol.declarations;
	            var isConstructor = (symbol.flags & 16384 /* Constructor */) !== 0;
	            function reportImplementationExpectedError(node) {
	                if (node.name && ts.nodeIsMissing(node.name)) {
	                    return;
	                }
	                var seen = false;
	                var subsequentNode = ts.forEachChild(node.parent, function (c) {
	                    if (seen) {
	                        return c;
	                    }
	                    else {
	                        seen = c === node;
	                    }
	                });
	                // We may be here because of some extra nodes between overloads that could not be parsed into a valid node.
	                // In this case the subsequent node is not really consecutive (.pos !== node.end), and we must ignore it here.
	                if (subsequentNode && subsequentNode.pos === node.end) {
	                    if (subsequentNode.kind === node.kind) {
	                        var errorNode_1 = subsequentNode.name || subsequentNode;
	                        // TODO: GH#17345: These are methods, so handle computed name case. (`Always allowing computed property names is *not* the correct behavior!)
	                        var subsequentName = subsequentNode.name;
	                        if (node.name && subsequentName &&
	                            (ts.isComputedPropertyName(node.name) && ts.isComputedPropertyName(subsequentName) ||
	                                !ts.isComputedPropertyName(node.name) && !ts.isComputedPropertyName(subsequentName) && ts.getEscapedTextOfIdentifierOrLiteral(node.name) === ts.getEscapedTextOfIdentifierOrLiteral(subsequentName))) {
	                            var reportError = (node.kind === 153 /* MethodDeclaration */ || node.kind === 152 /* MethodSignature */) &&
	                                ts.hasModifier(node, 32 /* Static */) !== ts.hasModifier(subsequentNode, 32 /* Static */);
	                            // we can get here in two cases
	                            // 1. mixed static and instance class members
	                            // 2. something with the same name was defined before the set of overloads that prevents them from merging
	                            // here we'll report error only for the first case since for second we should already report error in binder
	                            if (reportError) {
	                                var diagnostic = ts.hasModifier(node, 32 /* Static */) ? ts.Diagnostics.Function_overload_must_be_static : ts.Diagnostics.Function_overload_must_not_be_static;
	                                error(errorNode_1, diagnostic);
	                            }
	                            return;
	                        }
	                        else if (ts.nodeIsPresent(subsequentNode.body)) {
	                            error(errorNode_1, ts.Diagnostics.Function_implementation_name_must_be_0, ts.declarationNameToString(node.name));
	                            return;
	                        }
	                    }
	                }
	                var errorNode = node.name || node;
	                if (isConstructor) {
	                    error(errorNode, ts.Diagnostics.Constructor_implementation_is_missing);
	                }
	                else {
	                    // Report different errors regarding non-consecutive blocks of declarations depending on whether
	                    // the node in question is abstract.
	                    if (ts.hasModifier(node, 128 /* Abstract */)) {
	                        error(errorNode, ts.Diagnostics.All_declarations_of_an_abstract_method_must_be_consecutive);
	                    }
	                    else {
	                        error(errorNode, ts.Diagnostics.Function_implementation_is_missing_or_not_immediately_following_the_declaration);
	                    }
	                }
	            }
	            var duplicateFunctionDeclaration = false;
	            var multipleConstructorImplementation = false;
	            for (var _i = 0, declarations_4 = declarations; _i < declarations_4.length; _i++) {
	                var current = declarations_4[_i];
	                var node = current;
	                var inAmbientContext = node.flags & 2097152 /* Ambient */;
	                var inAmbientContextOrInterface = node.parent.kind === 234 /* InterfaceDeclaration */ || node.parent.kind === 165 /* TypeLiteral */ || inAmbientContext;
	                if (inAmbientContextOrInterface) {
	                    // check if declarations are consecutive only if they are non-ambient
	                    // 1. ambient declarations can be interleaved
	                    // i.e. this is legal
	                    //     declare function foo();
	                    //     declare function bar();
	                    //     declare function foo();
	                    // 2. mixing ambient and non-ambient declarations is a separate error that will be reported - do not want to report an extra one
	                    previousDeclaration = undefined;
	                }
	                if (node.kind === 232 /* FunctionDeclaration */ || node.kind === 153 /* MethodDeclaration */ || node.kind === 152 /* MethodSignature */ || node.kind === 154 /* Constructor */) {
	                    var currentNodeFlags = getEffectiveDeclarationFlags(node, flagsToCheck);
	                    someNodeFlags |= currentNodeFlags;
	                    allNodeFlags &= currentNodeFlags;
	                    someHaveQuestionToken = someHaveQuestionToken || ts.hasQuestionToken(node);
	                    allHaveQuestionToken = allHaveQuestionToken && ts.hasQuestionToken(node);
	                    if (ts.nodeIsPresent(node.body) && bodyDeclaration) {
	                        if (isConstructor) {
	                            multipleConstructorImplementation = true;
	                        }
	                        else {
	                            duplicateFunctionDeclaration = true;
	                        }
	                    }
	                    else if (previousDeclaration && previousDeclaration.parent === node.parent && previousDeclaration.end !== node.pos) {
	                        reportImplementationExpectedError(previousDeclaration);
	                    }
	                    if (ts.nodeIsPresent(node.body)) {
	                        if (!bodyDeclaration) {
	                            bodyDeclaration = node;
	                        }
	                    }
	                    else {
	                        hasOverloads = true;
	                    }
	                    previousDeclaration = node;
	                    if (!inAmbientContextOrInterface) {
	                        lastSeenNonAmbientDeclaration = node;
	                    }
	                }
	            }
	            if (multipleConstructorImplementation) {
	                ts.forEach(declarations, function (declaration) {
	                    error(declaration, ts.Diagnostics.Multiple_constructor_implementations_are_not_allowed);
	                });
	            }
	            if (duplicateFunctionDeclaration) {
	                ts.forEach(declarations, function (declaration) {
	                    error(ts.getNameOfDeclaration(declaration), ts.Diagnostics.Duplicate_function_implementation);
	                });
	            }
	            // Abstract methods can't have an implementation -- in particular, they don't need one.
	            if (lastSeenNonAmbientDeclaration && !lastSeenNonAmbientDeclaration.body &&
	                !ts.hasModifier(lastSeenNonAmbientDeclaration, 128 /* Abstract */) && !lastSeenNonAmbientDeclaration.questionToken) {
	                reportImplementationExpectedError(lastSeenNonAmbientDeclaration);
	            }
	            if (hasOverloads) {
	                checkFlagAgreementBetweenOverloads(declarations, bodyDeclaration, flagsToCheck, someNodeFlags, allNodeFlags);
	                checkQuestionTokenAgreementBetweenOverloads(declarations, bodyDeclaration, someHaveQuestionToken, allHaveQuestionToken);
	                if (bodyDeclaration) {
	                    var signatures = getSignaturesOfSymbol(symbol);
	                    var bodySignature = getSignatureFromDeclaration(bodyDeclaration);
	                    for (var _a = 0, signatures_7 = signatures; _a < signatures_7.length; _a++) {
	                        var signature = signatures_7[_a];
	                        if (!isImplementationCompatibleWithOverload(bodySignature, signature)) {
	                            error(signature.declaration, ts.Diagnostics.Overload_signature_is_not_compatible_with_function_implementation);
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	        function checkExportsOnMergedDeclarations(node) {
	            if (!produceDiagnostics) {
	                return;
	            }
	            // if localSymbol is defined on node then node itself is exported - check is required
	            var symbol = node.localSymbol;
	            if (!symbol) {
	                // local symbol is undefined => this declaration is non-exported.
	                // however symbol might contain other declarations that are exported
	                symbol = getSymbolOfNode(node);
	                if (!symbol.exportSymbol) {
	                    // this is a pure local symbol (all declarations are non-exported) - no need to check anything
	                    return;
	                }
	            }
	            // run the check only for the first declaration in the list
	            if (ts.getDeclarationOfKind(symbol, node.kind) !== node) {
	                return;
	            }
	            var exportedDeclarationSpaces = 0 /* None */;
	            var nonExportedDeclarationSpaces = 0 /* None */;
	            var defaultExportedDeclarationSpaces = 0 /* None */;
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var d = _a[_i];
	                var declarationSpaces = getDeclarationSpaces(d);
	                var effectiveDeclarationFlags = getEffectiveDeclarationFlags(d, 1 /* Export */ | 512 /* Default */);
	                if (effectiveDeclarationFlags & 1 /* Export */) {
	                    if (effectiveDeclarationFlags & 512 /* Default */) {
	                        defaultExportedDeclarationSpaces |= declarationSpaces;
	                    }
	                    else {
	                        exportedDeclarationSpaces |= declarationSpaces;
	                    }
	                }
	                else {
	                    nonExportedDeclarationSpaces |= declarationSpaces;
	                }
	            }
	            // Spaces for anything not declared a 'default export'.
	            var nonDefaultExportedDeclarationSpaces = exportedDeclarationSpaces | nonExportedDeclarationSpaces;
	            var commonDeclarationSpacesForExportsAndLocals = exportedDeclarationSpaces & nonExportedDeclarationSpaces;
	            var commonDeclarationSpacesForDefaultAndNonDefault = defaultExportedDeclarationSpaces & nonDefaultExportedDeclarationSpaces;
	            if (commonDeclarationSpacesForExportsAndLocals || commonDeclarationSpacesForDefaultAndNonDefault) {
	                // declaration spaces for exported and non-exported declarations intersect
	                for (var _b = 0, _c = symbol.declarations; _b < _c.length; _b++) {
	                    var d = _c[_b];
	                    var declarationSpaces = getDeclarationSpaces(d);
	                    var name = ts.getNameOfDeclaration(d);
	                    // Only error on the declarations that contributed to the intersecting spaces.
	                    if (declarationSpaces & commonDeclarationSpacesForDefaultAndNonDefault) {
	                        error(name, ts.Diagnostics.Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_default_0_declaration_instead, ts.declarationNameToString(name));
	                    }
	                    else if (declarationSpaces & commonDeclarationSpacesForExportsAndLocals) {
	                        error(name, ts.Diagnostics.Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local, ts.declarationNameToString(name));
	                    }
	                }
	            }
	            var DeclarationSpaces;
	            (function (DeclarationSpaces) {
	                DeclarationSpaces[DeclarationSpaces["None"] = 0] = "None";
	                DeclarationSpaces[DeclarationSpaces["ExportValue"] = 1] = "ExportValue";
	                DeclarationSpaces[DeclarationSpaces["ExportType"] = 2] = "ExportType";
	                DeclarationSpaces[DeclarationSpaces["ExportNamespace"] = 4] = "ExportNamespace";
	            })(DeclarationSpaces || (DeclarationSpaces = {}));
	            function getDeclarationSpaces(d) {
	                switch (d.kind) {
	                    case 234 /* InterfaceDeclaration */:
	                    case 235 /* TypeAliasDeclaration */:
	                    // A jsdoc typedef is, by definition, a type alias
	                    case 291 /* JSDocTypedefTag */:
	                        return 2 /* ExportType */;
	                    case 237 /* ModuleDeclaration */:
	                        return ts.isAmbientModule(d) || ts.getModuleInstanceState(d) !== 0 /* NonInstantiated */
	                            ? 4 /* ExportNamespace */ | 1 /* ExportValue */
	                            : 4 /* ExportNamespace */;
	                    case 233 /* ClassDeclaration */:
	                    case 236 /* EnumDeclaration */:
	                        return 2 /* ExportType */ | 1 /* ExportValue */;
	                    case 272 /* SourceFile */:
	                        return 2 /* ExportType */ | 1 /* ExportValue */ | 4 /* ExportNamespace */;
	                    // The below options all declare an Alias, which is allowed to merge with other values within the importing module
	                    case 241 /* ImportEqualsDeclaration */:
	                    case 244 /* NamespaceImport */:
	                    case 243 /* ImportClause */:
	                        var result_2 = 0 /* None */;
	                        var target = resolveAlias(getSymbolOfNode(d));
	                        ts.forEach(target.declarations, function (d) { result_2 |= getDeclarationSpaces(d); });
	                        return result_2;
	                    case 230 /* VariableDeclaration */:
	                    case 180 /* BindingElement */:
	                    case 232 /* FunctionDeclaration */:
	                    case 246 /* ImportSpecifier */:// https://github.com/Microsoft/TypeScript/pull/7591
	                        return 1 /* ExportValue */;
	                    default:
	                        ts.Debug.fail(ts.Debug.showSyntaxKind(d));
	                }
	            }
	        }
	        function getAwaitedTypeOfPromise(type, errorNode, diagnosticMessage) {
	            var promisedType = getPromisedTypeOfPromise(type, errorNode);
	            return promisedType && getAwaitedType(promisedType, errorNode, diagnosticMessage);
	        }
	        /**
	         * Gets the "promised type" of a promise.
	         * @param type The type of the promise.
	         * @remarks The "promised type" of a type is the type of the "value" parameter of the "onfulfilled" callback.
	         */
	        function getPromisedTypeOfPromise(promise, errorNode) {
	            //
	            //  { // promise
	            //      then( // thenFunction
	            //          onfulfilled: ( // onfulfilledParameterType
	            //              value: T // valueParameterType
	            //          ) => any
	            //      ): any;
	            //  }
	            //
	            if (isTypeAny(promise)) {
	                return undefined;
	            }
	            var typeAsPromise = promise;
	            if (typeAsPromise.promisedTypeOfPromise) {
	                return typeAsPromise.promisedTypeOfPromise;
	            }
	            if (isReferenceToType(promise, getGlobalPromiseType(/*reportErrors*/ false))) {
	                return typeAsPromise.promisedTypeOfPromise = promise.typeArguments[0];
	            }
	            var thenFunction = getTypeOfPropertyOfType(promise, "then");
	            if (isTypeAny(thenFunction)) {
	                return undefined;
	            }
	            var thenSignatures = thenFunction ? getSignaturesOfType(thenFunction, 0 /* Call */) : ts.emptyArray;
	            if (thenSignatures.length === 0) {
	                if (errorNode) {
	                    error(errorNode, ts.Diagnostics.A_promise_must_have_a_then_method);
	                }
	                return undefined;
	            }
	            var onfulfilledParameterType = getTypeWithFacts(getUnionType(ts.map(thenSignatures, getTypeOfFirstParameterOfSignature)), 524288 /* NEUndefinedOrNull */);
	            if (isTypeAny(onfulfilledParameterType)) {
	                return undefined;
	            }
	            var onfulfilledParameterSignatures = getSignaturesOfType(onfulfilledParameterType, 0 /* Call */);
	            if (onfulfilledParameterSignatures.length === 0) {
	                if (errorNode) {
	                    error(errorNode, ts.Diagnostics.The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback);
	                }
	                return undefined;
	            }
	            return typeAsPromise.promisedTypeOfPromise = getUnionType(ts.map(onfulfilledParameterSignatures, getTypeOfFirstParameterOfSignature), 2 /* Subtype */);
	        }
	        /**
	         * Gets the "awaited type" of a type.
	         * @param type The type to await.
	         * @remarks The "awaited type" of an expression is its "promised type" if the expression is a
	         * Promise-like type; otherwise, it is the type of the expression. This is used to reflect
	         * The runtime behavior of the `await` keyword.
	         */
	        function checkAwaitedType(type, errorNode, diagnosticMessage) {
	            return getAwaitedType(type, errorNode, diagnosticMessage) || unknownType;
	        }
	        function getAwaitedType(type, errorNode, diagnosticMessage) {
	            var typeAsAwaitable = type;
	            if (typeAsAwaitable.awaitedTypeOfType) {
	                return typeAsAwaitable.awaitedTypeOfType;
	            }
	            if (isTypeAny(type)) {
	                return typeAsAwaitable.awaitedTypeOfType = type;
	            }
	            if (type.flags & 131072 /* Union */) {
	                var types = void 0;
	                for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                    var constituentType = _a[_i];
	                    types = ts.append(types, getAwaitedType(constituentType, errorNode, diagnosticMessage));
	                }
	                if (!types) {
	                    return undefined;
	                }
	                return typeAsAwaitable.awaitedTypeOfType = getUnionType(types);
	            }
	            var promisedType = getPromisedTypeOfPromise(type);
	            if (promisedType) {
	                if (type.id === promisedType.id || awaitedTypeStack.indexOf(promisedType.id) >= 0) {
	                    // Verify that we don't have a bad actor in the form of a promise whose
	                    // promised type is the same as the promise type, or a mutually recursive
	                    // promise. If so, we return undefined as we cannot guess the shape. If this
	                    // were the actual case in the JavaScript, this Promise would never resolve.
	                    //
	                    // An example of a bad actor with a singly-recursive promise type might
	                    // be:
	                    //
	                    //  interface BadPromise {
	                    //      then(
	                    //          onfulfilled: (value: BadPromise) => any,
	                    //          onrejected: (error: any) => any): BadPromise;
	                    //  }
	                    // The above interface will pass the PromiseLike check, and return a
	                    // promised type of `BadPromise`. Since this is a self reference, we
	                    // don't want to keep recursing ad infinitum.
	                    //
	                    // An example of a bad actor in the form of a mutually-recursive
	                    // promise type might be:
	                    //
	                    //  interface BadPromiseA {
	                    //      then(
	                    //          onfulfilled: (value: BadPromiseB) => any,
	                    //          onrejected: (error: any) => any): BadPromiseB;
	                    //  }
	                    //
	                    //  interface BadPromiseB {
	                    //      then(
	                    //          onfulfilled: (value: BadPromiseA) => any,
	                    //          onrejected: (error: any) => any): BadPromiseA;
	                    //  }
	                    //
	                    if (errorNode) {
	                        error(errorNode, ts.Diagnostics.Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method);
	                    }
	                    return undefined;
	                }
	                // Keep track of the type we're about to unwrap to avoid bad recursive promise types.
	                // See the comments above for more information.
	                awaitedTypeStack.push(type.id);
	                var awaitedType = getAwaitedType(promisedType, errorNode, diagnosticMessage);
	                awaitedTypeStack.pop();
	                if (!awaitedType) {
	                    return undefined;
	                }
	                return typeAsAwaitable.awaitedTypeOfType = awaitedType;
	            }
	            // The type was not a promise, so it could not be unwrapped any further.
	            // As long as the type does not have a callable "then" property, it is
	            // safe to return the type; otherwise, an error will be reported in
	            // the call to getNonThenableType and we will return undefined.
	            //
	            // An example of a non-promise "thenable" might be:
	            //
	            //  await { then(): void {} }
	            //
	            // The "thenable" does not match the minimal definition for a promise. When
	            // a Promise/A+-compatible or ES6 promise tries to adopt this value, the promise
	            // will never settle. We treat this as an error to help flag an early indicator
	            // of a runtime problem. If the user wants to return this value from an async
	            // function, they would need to wrap it in some other value. If they want it to
	            // be treated as a promise, they can cast to <any>.
	            var thenFunction = getTypeOfPropertyOfType(type, "then");
	            if (thenFunction && getSignaturesOfType(thenFunction, 0 /* Call */).length > 0) {
	                if (errorNode) {
	                    ts.Debug.assert(!!diagnosticMessage);
	                    error(errorNode, diagnosticMessage);
	                }
	                return undefined;
	            }
	            return typeAsAwaitable.awaitedTypeOfType = type;
	        }
	        /**
	         * Checks the return type of an async function to ensure it is a compatible
	         * Promise implementation.
	         *
	         * This checks that an async function has a valid Promise-compatible return type,
	         * and returns the *awaited type* of the promise. An async function has a valid
	         * Promise-compatible return type if the resolved value of the return type has a
	         * construct signature that takes in an `initializer` function that in turn supplies
	         * a `resolve` function as one of its arguments and results in an object with a
	         * callable `then` signature.
	         *
	         * @param node The signature to check
	         */
	        function checkAsyncFunctionReturnType(node) {
	            // As part of our emit for an async function, we will need to emit the entity name of
	            // the return type annotation as an expression. To meet the necessary runtime semantics
	            // for __awaiter, we must also check that the type of the declaration (e.g. the static
	            // side or "constructor" of the promise type) is compatible `PromiseConstructorLike`.
	            //
	            // An example might be (from lib.es6.d.ts):
	            //
	            //  interface Promise<T> { ... }
	            //  interface PromiseConstructor {
	            //      new <T>(...): Promise<T>;
	            //  }
	            //  declare var Promise: PromiseConstructor;
	            //
	            // When an async function declares a return type annotation of `Promise<T>`, we
	            // need to get the type of the `Promise` variable declaration above, which would
	            // be `PromiseConstructor`.
	            //
	            // The same case applies to a class:
	            //
	            //  declare class Promise<T> {
	            //      constructor(...);
	            //      then<U>(...): Promise<U>;
	            //  }
	            //
	            var returnTypeNode = ts.getEffectiveReturnTypeNode(node);
	            var returnType = getTypeFromTypeNode(returnTypeNode);
	            if (languageVersion >= 2 /* ES2015 */) {
	                if (returnType === unknownType) {
	                    return unknownType;
	                }
	                var globalPromiseType = getGlobalPromiseType(/*reportErrors*/ true);
	                if (globalPromiseType !== emptyGenericType && !isReferenceToType(returnType, globalPromiseType)) {
	                    // The promise type was not a valid type reference to the global promise type, so we
	                    // report an error and return the unknown type.
	                    error(returnTypeNode, ts.Diagnostics.The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type);
	                    return unknownType;
	                }
	            }
	            else {
	                // Always mark the type node as referenced if it points to a value
	                markTypeNodeAsReferenced(returnTypeNode);
	                if (returnType === unknownType) {
	                    return unknownType;
	                }
	                var promiseConstructorName = ts.getEntityNameFromTypeNode(returnTypeNode);
	                if (promiseConstructorName === undefined) {
	                    error(returnTypeNode, ts.Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, typeToString(returnType));
	                    return unknownType;
	                }
	                var promiseConstructorSymbol = resolveEntityName(promiseConstructorName, 107455 /* Value */, /*ignoreErrors*/ true);
	                var promiseConstructorType = promiseConstructorSymbol ? getTypeOfSymbol(promiseConstructorSymbol) : unknownType;
	                if (promiseConstructorType === unknownType) {
	                    if (promiseConstructorName.kind === 71 /* Identifier */ && promiseConstructorName.escapedText === "Promise" && getTargetType(returnType) === getGlobalPromiseType(/*reportErrors*/ false)) {
	                        error(returnTypeNode, ts.Diagnostics.An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option);
	                    }
	                    else {
	                        error(returnTypeNode, ts.Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, ts.entityNameToString(promiseConstructorName));
	                    }
	                    return unknownType;
	                }
	                var globalPromiseConstructorLikeType = getGlobalPromiseConstructorLikeType(/*reportErrors*/ true);
	                if (globalPromiseConstructorLikeType === emptyObjectType) {
	                    // If we couldn't resolve the global PromiseConstructorLike type we cannot verify
	                    // compatibility with __awaiter.
	                    error(returnTypeNode, ts.Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, ts.entityNameToString(promiseConstructorName));
	                    return unknownType;
	                }
	                if (!checkTypeAssignableTo(promiseConstructorType, globalPromiseConstructorLikeType, returnTypeNode, ts.Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value)) {
	                    return unknownType;
	                }
	                // Verify there is no local declaration that could collide with the promise constructor.
	                var rootName = promiseConstructorName && getFirstIdentifier(promiseConstructorName);
	                var collidingSymbol = getSymbol(node.locals, rootName.escapedText, 107455 /* Value */);
	                if (collidingSymbol) {
	                    error(collidingSymbol.valueDeclaration, ts.Diagnostics.Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions, ts.idText(rootName), ts.entityNameToString(promiseConstructorName));
	                    return unknownType;
	                }
	            }
	            // Get and return the awaited type of the return type.
	            return checkAwaitedType(returnType, node, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	        }
	        /** Check a decorator */
	        function checkDecorator(node) {
	            var signature = getResolvedSignature(node);
	            var returnType = getReturnTypeOfSignature(signature);
	            if (returnType.flags & 1 /* Any */) {
	                return;
	            }
	            var expectedReturnType;
	            var headMessage = getDiagnosticHeadMessageForDecoratorResolution(node);
	            var errorInfo;
	            switch (node.parent.kind) {
	                case 233 /* ClassDeclaration */:
	                    var classSymbol = getSymbolOfNode(node.parent);
	                    var classConstructorType = getTypeOfSymbol(classSymbol);
	                    expectedReturnType = getUnionType([classConstructorType, voidType]);
	                    break;
	                case 148 /* Parameter */:
	                    expectedReturnType = voidType;
	                    errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any);
	                    break;
	                case 151 /* PropertyDeclaration */:
	                    expectedReturnType = voidType;
	                    errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.The_return_type_of_a_property_decorator_function_must_be_either_void_or_any);
	                    break;
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    var methodType = getTypeOfNode(node.parent);
	                    var descriptorType = createTypedPropertyDescriptorType(methodType);
	                    expectedReturnType = getUnionType([descriptorType, voidType]);
	                    break;
	            }
	            checkTypeAssignableTo(returnType, expectedReturnType, node, headMessage, function () { return errorInfo; });
	        }
	        /**
	         * If a TypeNode can be resolved to a value symbol imported from an external module, it is
	         * marked as referenced to prevent import elision.
	         */
	        function markTypeNodeAsReferenced(node) {
	            markEntityNameOrEntityExpressionAsReference(node && ts.getEntityNameFromTypeNode(node));
	        }
	        function markEntityNameOrEntityExpressionAsReference(typeName) {
	            if (!typeName)
	                return;
	            var rootName = getFirstIdentifier(typeName);
	            var meaning = (typeName.kind === 71 /* Identifier */ ? 793064 /* Type */ : 1920 /* Namespace */) | 2097152 /* Alias */;
	            var rootSymbol = resolveName(rootName, rootName.escapedText, meaning, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isRefernce*/ true);
	            if (rootSymbol
	                && rootSymbol.flags & 2097152 /* Alias */
	                && symbolIsValue(rootSymbol)
	                && !isConstEnumOrConstEnumOnlyModule(resolveAlias(rootSymbol))) {
	                markAliasSymbolAsReferenced(rootSymbol);
	            }
	        }
	        /**
	         * This function marks the type used for metadata decorator as referenced if it is import
	         * from external module.
	         * This is different from markTypeNodeAsReferenced because it tries to simplify type nodes in
	         * union and intersection type
	         * @param node
	         */
	        function markDecoratorMedataDataTypeNodeAsReferenced(node) {
	            var entityName = getEntityNameForDecoratorMetadata(node);
	            if (entityName && ts.isEntityName(entityName)) {
	                markEntityNameOrEntityExpressionAsReference(entityName);
	            }
	        }
	        function getEntityNameForDecoratorMetadata(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 169 /* IntersectionType */:
	                    case 168 /* UnionType */:
	                        var commonEntityName = void 0;
	                        for (var _i = 0, _a = node.types; _i < _a.length; _i++) {
	                            var typeNode = _a[_i];
	                            while (typeNode.kind === 172 /* ParenthesizedType */) {
	                                typeNode = typeNode.type; // Skip parens if need be
	                            }
	                            if (typeNode.kind === 131 /* NeverKeyword */) {
	                                continue; // Always elide `never` from the union/intersection if possible
	                            }
	                            if (!strictNullChecks && (typeNode.kind === 95 /* NullKeyword */ || typeNode.kind === 140 /* UndefinedKeyword */)) {
	                                continue; // Elide null and undefined from unions for metadata, just like what we did prior to the implementation of strict null checks
	                            }
	                            var individualEntityName = getEntityNameForDecoratorMetadata(typeNode);
	                            if (!individualEntityName) {
	                                // Individual is something like string number
	                                // So it would be serialized to either that type or object
	                                // Safe to return here
	                                return undefined;
	                            }
	                            if (commonEntityName) {
	                                // Note this is in sync with the transformation that happens for type node.
	                                // Keep this in sync with serializeUnionOrIntersectionType
	                                // Verify if they refer to same entity and is identifier
	                                // return undefined if they dont match because we would emit object
	                                if (!ts.isIdentifier(commonEntityName) ||
	                                    !ts.isIdentifier(individualEntityName) ||
	                                    commonEntityName.escapedText !== individualEntityName.escapedText) {
	                                    return undefined;
	                                }
	                            }
	                            else {
	                                commonEntityName = individualEntityName;
	                            }
	                        }
	                        return commonEntityName;
	                    case 172 /* ParenthesizedType */:
	                        return getEntityNameForDecoratorMetadata(node.type);
	                    case 161 /* TypeReference */:
	                        return node.typeName;
	                }
	            }
	        }
	        function getParameterTypeNodeForDecoratorCheck(node) {
	            var typeNode = ts.getEffectiveTypeAnnotationNode(node);
	            return ts.isRestParameter(node) ? ts.getRestParameterElementType(typeNode) : typeNode;
	        }
	        /** Check the decorators of a node */
	        function checkDecorators(node) {
	            if (!node.decorators) {
	                return;
	            }
	            // skip this check for nodes that cannot have decorators. These should have already had an error reported by
	            // checkGrammarDecorators.
	            if (!ts.nodeCanBeDecorated(node, node.parent, node.parent.parent)) {
	                return;
	            }
	            if (!compilerOptions.experimentalDecorators) {
	                error(node, ts.Diagnostics.Experimental_support_for_decorators_is_a_feature_that_is_subject_to_change_in_a_future_release_Set_the_experimentalDecorators_option_to_remove_this_warning);
	            }
	            var firstDecorator = node.decorators[0];
	            checkExternalEmitHelpers(firstDecorator, 8 /* Decorate */);
	            if (node.kind === 148 /* Parameter */) {
	                checkExternalEmitHelpers(firstDecorator, 32 /* Param */);
	            }
	            if (compilerOptions.emitDecoratorMetadata) {
	                checkExternalEmitHelpers(firstDecorator, 16 /* Metadata */);
	                // we only need to perform these checks if we are emitting serialized type metadata for the target of a decorator.
	                switch (node.kind) {
	                    case 233 /* ClassDeclaration */:
	                        var constructor = ts.getFirstConstructorWithBody(node);
	                        if (constructor) {
	                            for (var _i = 0, _a = constructor.parameters; _i < _a.length; _i++) {
	                                var parameter = _a[_i];
	                                markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
	                            }
	                        }
	                        break;
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        for (var _b = 0, _c = node.parameters; _b < _c.length; _b++) {
	                            var parameter = _c[_b];
	                            markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
	                        }
	                        markDecoratorMedataDataTypeNodeAsReferenced(ts.getEffectiveReturnTypeNode(node));
	                        break;
	                    case 151 /* PropertyDeclaration */:
	                        markDecoratorMedataDataTypeNodeAsReferenced(ts.getEffectiveTypeAnnotationNode(node));
	                        break;
	                    case 148 /* Parameter */:
	                        markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(node));
	                        var containingSignature = node.parent;
	                        for (var _d = 0, _e = containingSignature.parameters; _d < _e.length; _d++) {
	                            var parameter = _e[_d];
	                            markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
	                        }
	                        break;
	                }
	            }
	            ts.forEach(node.decorators, checkDecorator);
	        }
	        function checkFunctionDeclaration(node) {
	            if (produceDiagnostics) {
	                checkFunctionOrMethodDeclaration(node);
	                checkGrammarForGenerator(node);
	                checkCollisionWithCapturedSuperVariable(node, node.name);
	                checkCollisionWithCapturedThisVariable(node, node.name);
	                checkCollisionWithCapturedNewTargetVariable(node, node.name);
	                checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	                checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            }
	        }
	        function checkJSDocTypedefTag(node) {
	            if (!node.typeExpression) {
	                // If the node had `@property` tags, `typeExpression` would have been set to the first property tag.
	                error(node.name, ts.Diagnostics.JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags);
	            }
	        }
	        function checkJSDocParameterTag(node) {
	            checkSourceElement(node.typeExpression);
	            if (!ts.getParameterSymbolFromJSDoc(node)) {
	                error(node.name, ts.Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name, ts.idText(node.name.kind === 145 /* QualifiedName */ ? node.name.right : node.name));
	            }
	        }
	        function checkJSDocAugmentsTag(node) {
	            var classLike = ts.getJSDocHost(node);
	            if (!ts.isClassDeclaration(classLike) && !ts.isClassExpression(classLike)) {
	                error(classLike, ts.Diagnostics.JSDoc_0_is_not_attached_to_a_class, ts.idText(node.tagName));
	                return;
	            }
	            var augmentsTags = ts.getAllJSDocTagsOfKind(classLike, 285 /* JSDocAugmentsTag */);
	            ts.Debug.assert(augmentsTags.length > 0);
	            if (augmentsTags.length > 1) {
	                error(augmentsTags[1], ts.Diagnostics.Class_declarations_cannot_have_more_than_one_augments_or_extends_tag);
	            }
	            var name = getIdentifierFromEntityNameExpression(node.class.expression);
	            var extend = ts.getClassExtendsHeritageClauseElement(classLike);
	            if (extend) {
	                var className = getIdentifierFromEntityNameExpression(extend.expression);
	                if (className && name.escapedText !== className.escapedText) {
	                    error(name, ts.Diagnostics.JSDoc_0_1_does_not_match_the_extends_2_clause, ts.idText(node.tagName), ts.idText(name), ts.idText(className));
	                }
	            }
	        }
	        function getIdentifierFromEntityNameExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return node;
	                case 183 /* PropertyAccessExpression */:
	                    return node.name;
	                default:
	                    return undefined;
	            }
	        }
	        function checkFunctionOrMethodDeclaration(node) {
	            checkDecorators(node);
	            checkSignatureDeclaration(node);
	            var functionFlags = ts.getFunctionFlags(node);
	            // Do not use hasDynamicName here, because that returns false for well known symbols.
	            // We want to perform checkComputedPropertyName for all computed properties, including
	            // well known symbols.
	            if (node.name && node.name.kind === 146 /* ComputedPropertyName */) {
	                // This check will account for methods in class/interface declarations,
	                // as well as accessors in classes/object literals
	                checkComputedPropertyName(node.name);
	            }
	            if (!hasNonBindableDynamicName(node)) {
	                // first we want to check the local symbol that contain this declaration
	                // - if node.localSymbol !== undefined - this is current declaration is exported and localSymbol points to the local symbol
	                // - if node.localSymbol === undefined - this node is non-exported so we can just pick the result of getSymbolOfNode
	                var symbol = getSymbolOfNode(node);
	                var localSymbol = node.localSymbol || symbol;
	                // Since the javascript won't do semantic analysis like typescript,
	                // if the javascript file comes before the typescript file and both contain same name functions,
	                // checkFunctionOrConstructorSymbol wouldn't be called if we didnt ignore javascript function.
	                var firstDeclaration = ts.find(localSymbol.declarations, 
	                // Get first non javascript function declaration
	                function (declaration) { return declaration.kind === node.kind && !(declaration.flags & 65536 /* JavaScriptFile */); });
	                // Only type check the symbol once
	                if (node === firstDeclaration) {
	                    checkFunctionOrConstructorSymbol(localSymbol);
	                }
	                if (symbol.parent) {
	                    // run check once for the first declaration
	                    if (ts.getDeclarationOfKind(symbol, node.kind) === node) {
	                        // run check on export symbol to check that modifiers agree across all exported declarations
	                        checkFunctionOrConstructorSymbol(symbol);
	                    }
	                }
	            }
	            var body = node.kind === 152 /* MethodSignature */ ? undefined : node.body;
	            checkSourceElement(body);
	            var returnTypeNode = ts.getEffectiveReturnTypeNode(node);
	            if ((functionFlags & 1 /* Generator */) === 0) {
	                var returnOrPromisedType = returnTypeNode && (functionFlags & 2 /* Async */
	                    ? checkAsyncFunctionReturnType(node) // Async function
	                    : getTypeFromTypeNode(returnTypeNode)); // normal function
	                checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnOrPromisedType);
	            }
	            if (produceDiagnostics && !returnTypeNode) {
	                // Report an implicit any error if there is no body, no explicit return type, and node is not a private method
	                // in an ambient context
	                if (noImplicitAny && ts.nodeIsMissing(body) && !isPrivateWithinAmbient(node)) {
	                    reportImplicitAnyError(node, anyType);
	                }
	                if (functionFlags & 1 /* Generator */ && ts.nodeIsPresent(body)) {
	                    // A generator with a body and no type annotation can still cause errors. It can error if the
	                    // yielded values have no common supertype, or it can give an implicit any error if it has no
	                    // yielded values. The only way to trigger these errors is to try checking its return type.
	                    getReturnTypeOfSignature(getSignatureFromDeclaration(node));
	                }
	            }
	            registerForUnusedIdentifiersCheck(node);
	        }
	        function registerForUnusedIdentifiersCheck(node) {
	            if (deferredUnusedIdentifierNodes) {
	                deferredUnusedIdentifierNodes.push(node);
	            }
	        }
	        function checkUnusedIdentifiers() {
	            if (deferredUnusedIdentifierNodes) {
	                for (var _i = 0, deferredUnusedIdentifierNodes_1 = deferredUnusedIdentifierNodes; _i < deferredUnusedIdentifierNodes_1.length; _i++) {
	                    var node = deferredUnusedIdentifierNodes_1[_i];
	                    switch (node.kind) {
	                        case 272 /* SourceFile */:
	                        case 237 /* ModuleDeclaration */:
	                            checkUnusedModuleMembers(node);
	                            break;
	                        case 233 /* ClassDeclaration */:
	                        case 203 /* ClassExpression */:
	                            checkUnusedClassMembers(node);
	                            checkUnusedTypeParameters(node);
	                            break;
	                        case 234 /* InterfaceDeclaration */:
	                            checkUnusedTypeParameters(node);
	                            break;
	                        case 211 /* Block */:
	                        case 239 /* CaseBlock */:
	                        case 218 /* ForStatement */:
	                        case 219 /* ForInStatement */:
	                        case 220 /* ForOfStatement */:
	                            checkUnusedLocalsAndParameters(node);
	                            break;
	                        case 154 /* Constructor */:
	                        case 190 /* FunctionExpression */:
	                        case 232 /* FunctionDeclaration */:
	                        case 191 /* ArrowFunction */:
	                        case 153 /* MethodDeclaration */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                            if (node.body) {
	                                checkUnusedLocalsAndParameters(node);
	                            }
	                            checkUnusedTypeParameters(node);
	                            break;
	                        case 152 /* MethodSignature */:
	                        case 157 /* CallSignature */:
	                        case 158 /* ConstructSignature */:
	                        case 162 /* FunctionType */:
	                        case 163 /* ConstructorType */:
	                        case 235 /* TypeAliasDeclaration */:
	                            checkUnusedTypeParameters(node);
	                            break;
	                        default:
	                            ts.Debug.fail("Node should not have been registered for unused identifiers check");
	                    }
	                }
	            }
	        }
	        function checkUnusedLocalsAndParameters(node) {
	            if (noUnusedIdentifiers && !(node.flags & 2097152 /* Ambient */)) {
	                node.locals.forEach(function (local) {
	                    // If it's purely a type parameter, ignore, will be checked in `checkUnusedTypeParameters`.
	                    // If it's a type parameter merged with a parameter, check if the parameter-side is used.
	                    if (local.flags & 262144 /* TypeParameter */ ? (local.flags & 3 /* Variable */ && !(local.isReferenced & 3 /* Variable */)) : !local.isReferenced) {
	                        if (local.valueDeclaration && ts.getRootDeclaration(local.valueDeclaration).kind === 148 /* Parameter */) {
	                            var parameter = ts.getRootDeclaration(local.valueDeclaration);
	                            var name = ts.getNameOfDeclaration(local.valueDeclaration);
	                            if (compilerOptions.noUnusedParameters &&
	                                !ts.isParameterPropertyDeclaration(parameter) &&
	                                !ts.parameterIsThisKeyword(parameter) &&
	                                !parameterNameStartsWithUnderscore(name)) {
	                                error(name, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, ts.symbolName(local));
	                            }
	                        }
	                        else if (compilerOptions.noUnusedLocals) {
	                            ts.forEach(local.declarations, function (d) { return errorUnusedLocal(d, ts.symbolName(local)); });
	                        }
	                    }
	                });
	            }
	        }
	        function isRemovedPropertyFromObjectSpread(node) {
	            if (ts.isBindingElement(node) && ts.isObjectBindingPattern(node.parent)) {
	                var lastElement = ts.lastOrUndefined(node.parent.elements);
	                return lastElement !== node && !!lastElement.dotDotDotToken;
	            }
	            return false;
	        }
	        function errorUnusedLocal(declaration, name) {
	            var node = ts.getNameOfDeclaration(declaration) || declaration;
	            if (isIdentifierThatStartsWithUnderScore(node)) {
	                var declaration_2 = ts.getRootDeclaration(node.parent);
	                if ((declaration_2.kind === 230 /* VariableDeclaration */ && ts.isForInOrOfStatement(declaration_2.parent.parent)) ||
	                    declaration_2.kind === 147 /* TypeParameter */) {
	                    return;
	                }
	            }
	            if (!isRemovedPropertyFromObjectSpread(node.kind === 71 /* Identifier */ ? node.parent : node)) {
	                error(node, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, name);
	            }
	        }
	        function parameterNameStartsWithUnderscore(parameterName) {
	            return parameterName && isIdentifierThatStartsWithUnderScore(parameterName);
	        }
	        function isIdentifierThatStartsWithUnderScore(node) {
	            return node.kind === 71 /* Identifier */ && ts.idText(node).charCodeAt(0) === 95 /* _ */;
	        }
	        function checkUnusedClassMembers(node) {
	            if (compilerOptions.noUnusedLocals && !(node.flags & 2097152 /* Ambient */)) {
	                for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                    var member = _a[_i];
	                    switch (member.kind) {
	                        case 153 /* MethodDeclaration */:
	                        case 151 /* PropertyDeclaration */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                            if (member.kind === 156 /* SetAccessor */ && member.symbol.flags & 32768 /* GetAccessor */) {
	                                // Already would have reported an error on the getter.
	                                break;
	                            }
	                            var symbol = getSymbolOfNode(member);
	                            if (!symbol.isReferenced && ts.hasModifier(member, 8 /* Private */)) {
	                                error(member.name, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, symbolToString(symbol));
	                            }
	                            break;
	                        case 154 /* Constructor */:
	                            for (var _b = 0, _c = member.parameters; _b < _c.length; _b++) {
	                                var parameter = _c[_b];
	                                if (!parameter.symbol.isReferenced && ts.hasModifier(parameter, 8 /* Private */)) {
	                                    error(parameter.name, ts.Diagnostics.Property_0_is_declared_but_its_value_is_never_read, ts.symbolName(parameter.symbol));
	                                }
	                            }
	                            break;
	                        case 159 /* IndexSignature */:
	                        case 210 /* SemicolonClassElement */:
	                            // Can't be private
	                            break;
	                        default:
	                            ts.Debug.fail();
	                    }
	                }
	            }
	        }
	        function checkUnusedTypeParameters(node) {
	            if (compilerOptions.noUnusedParameters && !(node.flags & 2097152 /* Ambient */)) {
	                if (node.typeParameters) {
	                    // Only report errors on the last declaration for the type parameter container;
	                    // this ensures that all uses have been accounted for.
	                    var symbol = getSymbolOfNode(node);
	                    var lastDeclaration = symbol && symbol.declarations && ts.lastOrUndefined(symbol.declarations);
	                    if (lastDeclaration !== node) {
	                        return;
	                    }
	                    for (var _i = 0, _a = node.typeParameters; _i < _a.length; _i++) {
	                        var typeParameter = _a[_i];
	                        if (!(getMergedSymbol(typeParameter.symbol).isReferenced & 262144 /* TypeParameter */) && !isIdentifierThatStartsWithUnderScore(typeParameter.name)) {
	                            error(typeParameter.name, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, ts.symbolName(typeParameter.symbol));
	                        }
	                    }
	                }
	            }
	        }
	        function checkUnusedModuleMembers(node) {
	            if (compilerOptions.noUnusedLocals && !(node.flags & 2097152 /* Ambient */)) {
	                node.locals.forEach(function (local) {
	                    if (!local.isReferenced && !local.exportSymbol) {
	                        for (var _i = 0, _a = local.declarations; _i < _a.length; _i++) {
	                            var declaration = _a[_i];
	                            if (!ts.isAmbientModule(declaration)) {
	                                errorUnusedLocal(declaration, ts.symbolName(local));
	                            }
	                        }
	                    }
	                });
	            }
	        }
	        function checkBlock(node) {
	            // Grammar checking for SyntaxKind.Block
	            if (node.kind === 211 /* Block */) {
	                checkGrammarStatementInAmbientContext(node);
	            }
	            if (ts.isFunctionOrModuleBlock(node)) {
	                var saveFlowAnalysisDisabled = flowAnalysisDisabled;
	                ts.forEach(node.statements, checkSourceElement);
	                flowAnalysisDisabled = saveFlowAnalysisDisabled;
	            }
	            else {
	                ts.forEach(node.statements, checkSourceElement);
	            }
	            if (node.locals) {
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkCollisionWithArgumentsInGeneratedCode(node) {
	            // no rest parameters \ declaration context \ overload - no codegen impact
	            if (!ts.hasRestParameter(node) || node.flags & 2097152 /* Ambient */ || ts.nodeIsMissing(node.body)) {
	                return;
	            }
	            ts.forEach(node.parameters, function (p) {
	                if (p.name && !ts.isBindingPattern(p.name) && p.name.escapedText === argumentsSymbol.escapedName) {
	                    error(p, ts.Diagnostics.Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters);
	                }
	            });
	        }
	        function needCollisionCheckForIdentifier(node, identifier, name) {
	            if (!(identifier && identifier.escapedText === name)) {
	                return false;
	            }
	            if (node.kind === 151 /* PropertyDeclaration */ ||
	                node.kind === 150 /* PropertySignature */ ||
	                node.kind === 153 /* MethodDeclaration */ ||
	                node.kind === 152 /* MethodSignature */ ||
	                node.kind === 155 /* GetAccessor */ ||
	                node.kind === 156 /* SetAccessor */) {
	                // it is ok to have member named '_super' or '_this' - member access is always qualified
	                return false;
	            }
	            if (node.flags & 2097152 /* Ambient */) {
	                // ambient context - no codegen impact
	                return false;
	            }
	            var root = ts.getRootDeclaration(node);
	            if (root.kind === 148 /* Parameter */ && ts.nodeIsMissing(root.parent.body)) {
	                // just an overload - no codegen impact
	                return false;
	            }
	            return true;
	        }
	        function checkCollisionWithCapturedThisVariable(node, name) {
	            if (needCollisionCheckForIdentifier(node, name, "_this")) {
	                potentialThisCollisions.push(node);
	            }
	        }
	        function checkCollisionWithCapturedNewTargetVariable(node, name) {
	            if (needCollisionCheckForIdentifier(node, name, "_newTarget")) {
	                potentialNewTargetCollisions.push(node);
	            }
	        }
	        // this function will run after checking the source file so 'CaptureThis' is correct for all nodes
	        function checkIfThisIsCapturedInEnclosingScope(node) {
	            ts.findAncestor(node, function (current) {
	                if (getNodeCheckFlags(current) & 4 /* CaptureThis */) {
	                    var isDeclaration_1 = node.kind !== 71 /* Identifier */;
	                    if (isDeclaration_1) {
	                        error(ts.getNameOfDeclaration(node), ts.Diagnostics.Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference);
	                    }
	                    else {
	                        error(node, ts.Diagnostics.Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference);
	                    }
	                    return true;
	                }
	            });
	        }
	        function checkIfNewTargetIsCapturedInEnclosingScope(node) {
	            ts.findAncestor(node, function (current) {
	                if (getNodeCheckFlags(current) & 8 /* CaptureNewTarget */) {
	                    var isDeclaration_2 = node.kind !== 71 /* Identifier */;
	                    if (isDeclaration_2) {
	                        error(ts.getNameOfDeclaration(node), ts.Diagnostics.Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_meta_property_reference);
	                    }
	                    else {
	                        error(node, ts.Diagnostics.Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta_property_reference);
	                    }
	                    return true;
	                }
	            });
	        }
	        function checkCollisionWithCapturedSuperVariable(node, name) {
	            if (!needCollisionCheckForIdentifier(node, name, "_super")) {
	                return;
	            }
	            // bubble up and find containing type
	            var enclosingClass = ts.getContainingClass(node);
	            // if containing type was not found or it is ambient - exit (no codegen)
	            if (!enclosingClass || enclosingClass.flags & 2097152 /* Ambient */) {
	                return;
	            }
	            if (ts.getClassExtendsHeritageClauseElement(enclosingClass)) {
	                var isDeclaration_3 = node.kind !== 71 /* Identifier */;
	                if (isDeclaration_3) {
	                    error(node, ts.Diagnostics.Duplicate_identifier_super_Compiler_uses_super_to_capture_base_class_reference);
	                }
	                else {
	                    error(node, ts.Diagnostics.Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference);
	                }
	            }
	        }
	        function checkCollisionWithRequireExportsInGeneratedCode(node, name) {
	            // No need to check for require or exports for ES6 modules and later
	            if (modulekind >= ts.ModuleKind.ES2015) {
	                return;
	            }
	            if (!needCollisionCheckForIdentifier(node, name, "require") && !needCollisionCheckForIdentifier(node, name, "exports")) {
	                return;
	            }
	            // Uninstantiated modules shouldnt do this check
	            if (ts.isModuleDeclaration(node) && ts.getModuleInstanceState(node) !== 1 /* Instantiated */) {
	                return;
	            }
	            // In case of variable declaration, node.parent is variable statement so look at the variable statement's parent
	            var parent = getDeclarationContainer(node);
	            if (parent.kind === 272 /* SourceFile */ && ts.isExternalOrCommonJsModule(parent)) {
	                // If the declaration happens to be in external module, report error that require and exports are reserved keywords
	                error(name, ts.Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module, ts.declarationNameToString(name), ts.declarationNameToString(name));
	            }
	        }
	        function checkCollisionWithGlobalPromiseInGeneratedCode(node, name) {
	            if (languageVersion >= 4 /* ES2017 */ || !needCollisionCheckForIdentifier(node, name, "Promise")) {
	                return;
	            }
	            // Uninstantiated modules shouldnt do this check
	            if (ts.isModuleDeclaration(node) && ts.getModuleInstanceState(node) !== 1 /* Instantiated */) {
	                return;
	            }
	            // In case of variable declaration, node.parent is variable statement so look at the variable statement's parent
	            var parent = getDeclarationContainer(node);
	            if (parent.kind === 272 /* SourceFile */ && ts.isExternalOrCommonJsModule(parent) && parent.flags & 1024 /* HasAsyncFunctions */) {
	                // If the declaration happens to be in external module, report error that Promise is a reserved identifier.
	                error(name, ts.Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_functions, ts.declarationNameToString(name), ts.declarationNameToString(name));
	            }
	        }
	        function checkVarDeclaredNamesNotShadowed(node) {
	            // - ScriptBody : StatementList
	            // It is a Syntax Error if any element of the LexicallyDeclaredNames of StatementList
	            // also occurs in the VarDeclaredNames of StatementList.
	            // - Block : { StatementList }
	            // It is a Syntax Error if any element of the LexicallyDeclaredNames of StatementList
	            // also occurs in the VarDeclaredNames of StatementList.
	            // Variable declarations are hoisted to the top of their function scope. They can shadow
	            // block scoped declarations, which bind tighter. this will not be flagged as duplicate definition
	            // by the binder as the declaration scope is different.
	            // A non-initialized declaration is a no-op as the block declaration will resolve before the var
	            // declaration. the problem is if the declaration has an initializer. this will act as a write to the
	            // block declared value. this is fine for let, but not const.
	            // Only consider declarations with initializers, uninitialized const declarations will not
	            // step on a let/const variable.
	            // Do not consider const and const declarations, as duplicate block-scoped declarations
	            // are handled by the binder.
	            // We are only looking for const declarations that step on let\const declarations from a
	            // different scope. e.g.:
	            //      {
	            //          const x = 0; // localDeclarationSymbol obtained after name resolution will correspond to this declaration
	            //          const x = 0; // symbol for this declaration will be 'symbol'
	            //      }
	            // skip block-scoped variables and parameters
	            if ((ts.getCombinedNodeFlags(node) & 3 /* BlockScoped */) !== 0 || ts.isParameterDeclaration(node)) {
	                return;
	            }
	            // skip variable declarations that don't have initializers
	            // NOTE: in ES6 spec initializer is required in variable declarations where name is binding pattern
	            // so we'll always treat binding elements as initialized
	            if (node.kind === 230 /* VariableDeclaration */ && !node.initializer) {
	                return;
	            }
	            var symbol = getSymbolOfNode(node);
	            if (symbol.flags & 1 /* FunctionScopedVariable */) {
	                if (!ts.isIdentifier(node.name))
	                    throw ts.Debug.fail();
	                var localDeclarationSymbol = resolveName(node, node.name.escapedText, 3 /* Variable */, /*nodeNotFoundErrorMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false);
	                if (localDeclarationSymbol &&
	                    localDeclarationSymbol !== symbol &&
	                    localDeclarationSymbol.flags & 2 /* BlockScopedVariable */) {
	                    if (getDeclarationNodeFlagsFromSymbol(localDeclarationSymbol) & 3 /* BlockScoped */) {
	                        var varDeclList = ts.getAncestor(localDeclarationSymbol.valueDeclaration, 231 /* VariableDeclarationList */);
	                        var container = varDeclList.parent.kind === 212 /* VariableStatement */ && varDeclList.parent.parent
	                            ? varDeclList.parent.parent
	                            : undefined;
	                        // names of block-scoped and function scoped variables can collide only
	                        // if block scoped variable is defined in the function\module\source file scope (because of variable hoisting)
	                        var namesShareScope = container &&
	                            (container.kind === 211 /* Block */ && ts.isFunctionLike(container.parent) ||
	                                container.kind === 238 /* ModuleBlock */ ||
	                                container.kind === 237 /* ModuleDeclaration */ ||
	                                container.kind === 272 /* SourceFile */);
	                        // here we know that function scoped variable is shadowed by block scoped one
	                        // if they are defined in the same scope - binder has already reported redeclaration error
	                        // otherwise if variable has an initializer - show error that initialization will fail
	                        // since LHS will be block scoped name instead of function scoped
	                        if (!namesShareScope) {
	                            var name = symbolToString(localDeclarationSymbol);
	                            error(node, ts.Diagnostics.Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1, name, name);
	                        }
	                    }
	                }
	            }
	        }
	        // Check that a parameter initializer contains no references to parameters declared to the right of itself
	        function checkParameterInitializer(node) {
	            if (ts.getRootDeclaration(node).kind !== 148 /* Parameter */) {
	                return;
	            }
	            var func = ts.getContainingFunction(node);
	            visit(node.initializer);
	            function visit(n) {
	                if (ts.isTypeNode(n) || ts.isDeclarationName(n)) {
	                    // do not dive in types
	                    // skip declaration names (i.e. in object literal expressions)
	                    return;
	                }
	                if (n.kind === 183 /* PropertyAccessExpression */) {
	                    // skip property names in property access expression
	                    return visit(n.expression);
	                }
	                else if (n.kind === 71 /* Identifier */) {
	                    // check FunctionLikeDeclaration.locals (stores parameters\function local variable)
	                    // if it contains entry with a specified name
	                    var symbol = resolveName(n, n.escapedText, 107455 /* Value */ | 2097152 /* Alias */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false);
	                    if (!symbol || symbol === unknownSymbol || !symbol.valueDeclaration) {
	                        return;
	                    }
	                    if (symbol.valueDeclaration === node) {
	                        error(n, ts.Diagnostics.Parameter_0_cannot_be_referenced_in_its_initializer, ts.declarationNameToString(node.name));
	                        return;
	                    }
	                    // locals map for function contain both parameters and function locals
	                    // so we need to do a bit of extra work to check if reference is legal
	                    var enclosingContainer = ts.getEnclosingBlockScopeContainer(symbol.valueDeclaration);
	                    if (enclosingContainer === func) {
	                        if (symbol.valueDeclaration.kind === 148 /* Parameter */ ||
	                            symbol.valueDeclaration.kind === 180 /* BindingElement */) {
	                            // it is ok to reference parameter in initializer if either
	                            // - parameter is located strictly on the left of current parameter declaration
	                            if (symbol.valueDeclaration.pos < node.pos) {
	                                return;
	                            }
	                            // - parameter is wrapped in function-like entity
	                            if (ts.findAncestor(n, function (current) {
	                                if (current === node.initializer) {
	                                    return "quit";
	                                }
	                                return ts.isFunctionLike(current.parent) ||
	                                    // computed property names/initializers in instance property declaration of class like entities
	                                    // are executed in constructor and thus deferred
	                                    (current.parent.kind === 151 /* PropertyDeclaration */ &&
	                                        !(ts.hasModifier(current.parent, 32 /* Static */)) &&
	                                        ts.isClassLike(current.parent.parent));
	                            })) {
	                                return;
	                            }
	                            // fall through to report error
	                        }
	                        error(n, ts.Diagnostics.Initializer_of_parameter_0_cannot_reference_identifier_1_declared_after_it, ts.declarationNameToString(node.name), ts.declarationNameToString(n));
	                    }
	                }
	                else {
	                    return ts.forEachChild(n, visit);
	                }
	            }
	        }
	        function convertAutoToAny(type) {
	            return type === autoType ? anyType : type === autoArrayType ? anyArrayType : type;
	        }
	        // Check variable, parameter, or property declaration
	        function checkVariableLikeDeclaration(node) {
	            checkDecorators(node);
	            if (!ts.isBindingElement(node)) {
	                checkSourceElement(node.type);
	            }
	            // JSDoc `function(string, string): string` syntax results in parameters with no name
	            if (!node.name) {
	                return;
	            }
	            // For a computed property, just check the initializer and exit
	            // Do not use hasDynamicName here, because that returns false for well known symbols.
	            // We want to perform checkComputedPropertyName for all computed properties, including
	            // well known symbols.
	            if (node.name.kind === 146 /* ComputedPropertyName */) {
	                checkComputedPropertyName(node.name);
	                if (node.initializer) {
	                    checkExpressionCached(node.initializer);
	                }
	            }
	            if (node.kind === 180 /* BindingElement */) {
	                if (node.parent.kind === 178 /* ObjectBindingPattern */ && languageVersion < 6 /* ESNext */) {
	                    checkExternalEmitHelpers(node, 4 /* Rest */);
	                }
	                // check computed properties inside property names of binding elements
	                if (node.propertyName && node.propertyName.kind === 146 /* ComputedPropertyName */) {
	                    checkComputedPropertyName(node.propertyName);
	                }
	                // check private/protected variable access
	                var parent = node.parent.parent;
	                var parentType = getTypeForBindingElementParent(parent);
	                var name = node.propertyName || node.name;
	                if (!ts.isBindingPattern(name)) {
	                    var property = getPropertyOfType(parentType, ts.getTextOfPropertyName(name));
	                    markPropertyAsReferenced(property, /*nodeForCheckWriteOnly*/ undefined, /*isThisAccess*/ false); // A destructuring is never a write-only reference.
	                    if (parent.initializer && property) {
	                        checkPropertyAccessibility(parent, parent.initializer, parentType, property);
	                    }
	                }
	            }
	            // For a binding pattern, check contained binding elements
	            if (ts.isBindingPattern(node.name)) {
	                if (node.name.kind === 179 /* ArrayBindingPattern */ && languageVersion < 2 /* ES2015 */ && compilerOptions.downlevelIteration) {
	                    checkExternalEmitHelpers(node, 512 /* Read */);
	                }
	                ts.forEach(node.name.elements, checkSourceElement);
	            }
	            // For a parameter declaration with an initializer, error and exit if the containing function doesn't have a body
	            if (node.initializer && ts.getRootDeclaration(node).kind === 148 /* Parameter */ && ts.nodeIsMissing(ts.getContainingFunction(node).body)) {
	                error(node, ts.Diagnostics.A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation);
	                return;
	            }
	            // For a binding pattern, validate the initializer and exit
	            if (ts.isBindingPattern(node.name)) {
	                // Don't validate for-in initializer as it is already an error
	                if (node.initializer && node.parent.parent.kind !== 219 /* ForInStatement */) {
	                    var initializerType = checkExpressionCached(node.initializer);
	                    if (strictNullChecks && node.name.elements.length === 0) {
	                        checkNonNullType(initializerType, node);
	                    }
	                    else {
	                        checkTypeAssignableTo(initializerType, getWidenedTypeForVariableLikeDeclaration(node), node, /*headMessage*/ undefined);
	                    }
	                    checkParameterInitializer(node);
	                }
	                return;
	            }
	            var symbol = getSymbolOfNode(node);
	            var type = convertAutoToAny(getTypeOfSymbol(symbol));
	            if (node === symbol.valueDeclaration) {
	                // Node is the primary declaration of the symbol, just validate the initializer
	                // Don't validate for-in initializer as it is already an error
	                if (node.initializer && node.parent.parent.kind !== 219 /* ForInStatement */) {
	                    checkTypeAssignableTo(checkExpressionCached(node.initializer), type, node, /*headMessage*/ undefined);
	                    checkParameterInitializer(node);
	                }
	            }
	            else {
	                // Node is a secondary declaration, check that type is identical to primary declaration and check that
	                // initializer is consistent with type associated with the node
	                var declarationType = convertAutoToAny(getWidenedTypeForVariableLikeDeclaration(node));
	                if (type !== unknownType && declarationType !== unknownType &&
	                    !isTypeIdenticalTo(type, declarationType) &&
	                    !(symbol.flags & 67108864 /* JSContainer */)) {
	                    errorNextVariableOrPropertyDeclarationMustHaveSameType(type, node, declarationType);
	                }
	                if (node.initializer) {
	                    checkTypeAssignableTo(checkExpressionCached(node.initializer), declarationType, node, /*headMessage*/ undefined);
	                }
	                if (!areDeclarationFlagsIdentical(node, symbol.valueDeclaration)) {
	                    error(ts.getNameOfDeclaration(symbol.valueDeclaration), ts.Diagnostics.All_declarations_of_0_must_have_identical_modifiers, ts.declarationNameToString(node.name));
	                    error(node.name, ts.Diagnostics.All_declarations_of_0_must_have_identical_modifiers, ts.declarationNameToString(node.name));
	                }
	            }
	            if (node.kind !== 151 /* PropertyDeclaration */ && node.kind !== 150 /* PropertySignature */) {
	                // We know we don't have a binding pattern or computed name here
	                checkExportsOnMergedDeclarations(node);
	                if (node.kind === 230 /* VariableDeclaration */ || node.kind === 180 /* BindingElement */) {
	                    checkVarDeclaredNamesNotShadowed(node);
	                }
	                checkCollisionWithCapturedSuperVariable(node, node.name);
	                checkCollisionWithCapturedThisVariable(node, node.name);
	                checkCollisionWithCapturedNewTargetVariable(node, node.name);
	                checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	                checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            }
	        }
	        function errorNextVariableOrPropertyDeclarationMustHaveSameType(firstType, nextDeclaration, nextType) {
	            var nextDeclarationName = ts.getNameOfDeclaration(nextDeclaration);
	            var message = nextDeclaration.kind === 151 /* PropertyDeclaration */ || nextDeclaration.kind === 150 /* PropertySignature */
	                ? ts.Diagnostics.Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_type_2
	                : ts.Diagnostics.Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_type_2;
	            error(nextDeclarationName, message, ts.declarationNameToString(nextDeclarationName), typeToString(firstType), typeToString(nextType));
	        }
	        function areDeclarationFlagsIdentical(left, right) {
	            if ((left.kind === 148 /* Parameter */ && right.kind === 230 /* VariableDeclaration */) ||
	                (left.kind === 230 /* VariableDeclaration */ && right.kind === 148 /* Parameter */)) {
	                // Differences in optionality between parameters and variables are allowed.
	                return true;
	            }
	            if (ts.hasQuestionToken(left) !== ts.hasQuestionToken(right)) {
	                return false;
	            }
	            var interestingFlags = 8 /* Private */ |
	                16 /* Protected */ |
	                256 /* Async */ |
	                128 /* Abstract */ |
	                64 /* Readonly */ |
	                32 /* Static */;
	            return ts.getSelectedModifierFlags(left, interestingFlags) === ts.getSelectedModifierFlags(right, interestingFlags);
	        }
	        function checkVariableDeclaration(node) {
	            checkGrammarVariableDeclaration(node);
	            return checkVariableLikeDeclaration(node);
	        }
	        function checkBindingElement(node) {
	            checkGrammarBindingElement(node);
	            return checkVariableLikeDeclaration(node);
	        }
	        function checkVariableStatement(node) {
	            // Grammar checking
	            if (!checkGrammarDecoratorsAndModifiers(node) && !checkGrammarVariableDeclarationList(node.declarationList))
	                checkGrammarForDisallowedLetOrConstStatement(node);
	            ts.forEach(node.declarationList.declarations, checkSourceElement);
	        }
	        function checkExpressionStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkExpression(node.expression);
	        }
	        function checkIfStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkExpression(node.expression);
	            checkSourceElement(node.thenStatement);
	            if (node.thenStatement.kind === 213 /* EmptyStatement */) {
	                error(node.thenStatement, ts.Diagnostics.The_body_of_an_if_statement_cannot_be_the_empty_statement);
	            }
	            checkSourceElement(node.elseStatement);
	        }
	        function checkDoStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkSourceElement(node.statement);
	            checkExpression(node.expression);
	        }
	        function checkWhileStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkExpression(node.expression);
	            checkSourceElement(node.statement);
	        }
	        function checkForStatement(node) {
	            // Grammar checking
	            if (!checkGrammarStatementInAmbientContext(node)) {
	                if (node.initializer && node.initializer.kind === 231 /* VariableDeclarationList */) {
	                    checkGrammarVariableDeclarationList(node.initializer);
	                }
	            }
	            if (node.initializer) {
	                if (node.initializer.kind === 231 /* VariableDeclarationList */) {
	                    ts.forEach(node.initializer.declarations, checkVariableDeclaration);
	                }
	                else {
	                    checkExpression(node.initializer);
	                }
	            }
	            if (node.condition)
	                checkExpression(node.condition);
	            if (node.incrementor)
	                checkExpression(node.incrementor);
	            checkSourceElement(node.statement);
	            if (node.locals) {
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkForOfStatement(node) {
	            checkGrammarForInOrForOfStatement(node);
	            if (node.kind === 220 /* ForOfStatement */) {
	                if (node.awaitModifier) {
	                    var functionFlags = ts.getFunctionFlags(ts.getContainingFunction(node));
	                    if ((functionFlags & (4 /* Invalid */ | 2 /* Async */)) === 2 /* Async */ && languageVersion < 6 /* ESNext */) {
	                        // for..await..of in an async function or async generator function prior to ESNext requires the __asyncValues helper
	                        checkExternalEmitHelpers(node, 16384 /* ForAwaitOfIncludes */);
	                    }
	                }
	                else if (compilerOptions.downlevelIteration && languageVersion < 2 /* ES2015 */) {
	                    // for..of prior to ES2015 requires the __values helper when downlevelIteration is enabled
	                    checkExternalEmitHelpers(node, 256 /* ForOfIncludes */);
	                }
	            }
	            // Check the LHS and RHS
	            // If the LHS is a declaration, just check it as a variable declaration, which will in turn check the RHS
	            // via checkRightHandSideOfForOf.
	            // If the LHS is an expression, check the LHS, as a destructuring assignment or as a reference.
	            // Then check that the RHS is assignable to it.
	            if (node.initializer.kind === 231 /* VariableDeclarationList */) {
	                checkForInOrForOfVariableDeclaration(node);
	            }
	            else {
	                var varExpr = node.initializer;
	                var iteratedType = checkRightHandSideOfForOf(node.expression, node.awaitModifier);
	                // There may be a destructuring assignment on the left side
	                if (varExpr.kind === 181 /* ArrayLiteralExpression */ || varExpr.kind === 182 /* ObjectLiteralExpression */) {
	                    // iteratedType may be undefined. In this case, we still want to check the structure of
	                    // varExpr, in particular making sure it's a valid LeftHandSideExpression. But we'd like
	                    // to short circuit the type relation checking as much as possible, so we pass the unknownType.
	                    checkDestructuringAssignment(varExpr, iteratedType || unknownType);
	                }
	                else {
	                    var leftType = checkExpression(varExpr);
	                    checkReferenceExpression(varExpr, ts.Diagnostics.The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access);
	                    // iteratedType will be undefined if the rightType was missing properties/signatures
	                    // required to get its iteratedType (like [Symbol.iterator] or next). This may be
	                    // because we accessed properties from anyType, or it may have led to an error inside
	                    // getElementTypeOfIterable.
	                    if (iteratedType) {
	                        checkTypeAssignableTo(iteratedType, leftType, varExpr, /*headMessage*/ undefined);
	                    }
	                }
	            }
	            checkSourceElement(node.statement);
	            if (node.locals) {
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkForInStatement(node) {
	            // Grammar checking
	            checkGrammarForInOrForOfStatement(node);
	            var rightType = checkNonNullExpression(node.expression);
	            // TypeScript 1.0 spec (April 2014): 5.4
	            // In a 'for-in' statement of the form
	            // for (let VarDecl in Expr) Statement
	            //   VarDecl must be a variable declaration without a type annotation that declares a variable of type Any,
	            //   and Expr must be an expression of type Any, an object type, or a type parameter type.
	            if (node.initializer.kind === 231 /* VariableDeclarationList */) {
	                var variable = node.initializer.declarations[0];
	                if (variable && ts.isBindingPattern(variable.name)) {
	                    error(variable.name, ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern);
	                }
	                checkForInOrForOfVariableDeclaration(node);
	            }
	            else {
	                // In a 'for-in' statement of the form
	                // for (Var in Expr) Statement
	                //   Var must be an expression classified as a reference of type Any or the String primitive type,
	                //   and Expr must be an expression of type Any, an object type, or a type parameter type.
	                var varExpr = node.initializer;
	                var leftType = checkExpression(varExpr);
	                if (varExpr.kind === 181 /* ArrayLiteralExpression */ || varExpr.kind === 182 /* ObjectLiteralExpression */) {
	                    error(varExpr, ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern);
	                }
	                else if (!isTypeAssignableTo(getIndexTypeOrString(rightType), leftType)) {
	                    error(varExpr, ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any);
	                }
	                else {
	                    // run check only former check succeeded to avoid cascading errors
	                    checkReferenceExpression(varExpr, ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access);
	                }
	            }
	            // unknownType is returned i.e. if node.expression is identifier whose name cannot be resolved
	            // in this case error about missing name is already reported - do not report extra one
	            if (!isTypeAssignableToKind(rightType, 134217728 /* NonPrimitive */ | 7372800 /* InstantiableNonPrimitive */)) {
	                error(node.expression, ts.Diagnostics.The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter);
	            }
	            checkSourceElement(node.statement);
	            if (node.locals) {
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkForInOrForOfVariableDeclaration(iterationStatement) {
	            var variableDeclarationList = iterationStatement.initializer;
	            // checkGrammarForInOrForOfStatement will check that there is exactly one declaration.
	            if (variableDeclarationList.declarations.length >= 1) {
	                var decl = variableDeclarationList.declarations[0];
	                checkVariableDeclaration(decl);
	            }
	        }
	        function checkRightHandSideOfForOf(rhsExpression, awaitModifier) {
	            var expressionType = checkNonNullExpression(rhsExpression);
	            return checkIteratedTypeOrElementType(expressionType, rhsExpression, /*allowStringInput*/ true, awaitModifier !== undefined);
	        }
	        function checkIteratedTypeOrElementType(inputType, errorNode, allowStringInput, allowAsyncIterables) {
	            if (isTypeAny(inputType)) {
	                return inputType;
	            }
	            return getIteratedTypeOrElementType(inputType, errorNode, allowStringInput, allowAsyncIterables, /*checkAssignability*/ true) || anyType;
	        }
	        /**
	         * When consuming an iterable type in a for..of, spread, or iterator destructuring assignment
	         * we want to get the iterated type of an iterable for ES2015 or later, or the iterated type
	         * of a iterable (if defined globally) or element type of an array like for ES2015 or earlier.
	         */
	        function getIteratedTypeOrElementType(inputType, errorNode, allowStringInput, allowAsyncIterables, checkAssignability) {
	            var uplevelIteration = languageVersion >= 2 /* ES2015 */;
	            var downlevelIteration = !uplevelIteration && compilerOptions.downlevelIteration;
	            // Get the iterated type of an `Iterable<T>` or `IterableIterator<T>` only in ES2015
	            // or higher, when inside of an async generator or for-await-if, or when
	            // downlevelIteration is requested.
	            if (uplevelIteration || downlevelIteration || allowAsyncIterables) {
	                // We only report errors for an invalid iterable type in ES2015 or higher.
	                var iteratedType = getIteratedTypeOfIterable(inputType, uplevelIteration ? errorNode : undefined, allowAsyncIterables, /*allowSyncIterables*/ true, checkAssignability);
	                if (iteratedType || uplevelIteration) {
	                    return iteratedType;
	                }
	            }
	            var arrayType = inputType;
	            var reportedError = false;
	            var hasStringConstituent = false;
	            // If strings are permitted, remove any string-like constituents from the array type.
	            // This allows us to find other non-string element types from an array unioned with
	            // a string.
	            if (allowStringInput) {
	                if (arrayType.flags & 131072 /* Union */) {
	                    // After we remove all types that are StringLike, we will know if there was a string constituent
	                    // based on whether the result of filter is a new array.
	                    var arrayTypes = inputType.types;
	                    var filteredTypes = ts.filter(arrayTypes, function (t) { return !(t.flags & 524322 /* StringLike */); });
	                    if (filteredTypes !== arrayTypes) {
	                        arrayType = getUnionType(filteredTypes, 2 /* Subtype */);
	                    }
	                }
	                else if (arrayType.flags & 524322 /* StringLike */) {
	                    arrayType = neverType;
	                }
	                hasStringConstituent = arrayType !== inputType;
	                if (hasStringConstituent) {
	                    if (languageVersion < 1 /* ES5 */) {
	                        if (errorNode) {
	                            error(errorNode, ts.Diagnostics.Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher);
	                            reportedError = true;
	                        }
	                    }
	                    // Now that we've removed all the StringLike types, if no constituents remain, then the entire
	                    // arrayOrStringType was a string.
	                    if (arrayType.flags & 16384 /* Never */) {
	                        return stringType;
	                    }
	                }
	            }
	            if (!isArrayLikeType(arrayType)) {
	                if (errorNode && !reportedError) {
	                    // Which error we report depends on whether we allow strings or if there was a
	                    // string constituent. For example, if the input type is number | string, we
	                    // want to say that number is not an array type. But if the input was just
	                    // number and string input is allowed, we want to say that number is not an
	                    // array type or a string type.
	                    var diagnostic = !allowStringInput || hasStringConstituent
	                        ? downlevelIteration
	                            ? ts.Diagnostics.Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator
	                            : ts.Diagnostics.Type_0_is_not_an_array_type
	                        : downlevelIteration
	                            ? ts.Diagnostics.Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator
	                            : ts.Diagnostics.Type_0_is_not_an_array_type_or_a_string_type;
	                    error(errorNode, diagnostic, typeToString(arrayType));
	                }
	                return hasStringConstituent ? stringType : undefined;
	            }
	            var arrayElementType = getIndexTypeOfType(arrayType, 1 /* Number */);
	            if (hasStringConstituent && arrayElementType) {
	                // This is just an optimization for the case where arrayOrStringType is string | string[]
	                if (arrayElementType.flags & 524322 /* StringLike */) {
	                    return stringType;
	                }
	                return getUnionType([arrayElementType, stringType], 2 /* Subtype */);
	            }
	            return arrayElementType;
	        }
	        /**
	         * We want to treat type as an iterable, and get the type it is an iterable of. The iterable
	         * must have the following structure (annotated with the names of the variables below):
	         *
	         *     { // iterable
	         *         [Symbol.iterator]: { // iteratorMethod
	         *             (): Iterator<T>
	         *         }
	         *     }
	         *
	         * For an async iterable, we expect the following structure:
	         *
	         *     { // iterable
	         *         [Symbol.asyncIterator]: { // iteratorMethod
	         *             (): AsyncIterator<T>
	         *         }
	         *     }
	         *
	         * T is the type we are after. At every level that involves analyzing return types
	         * of signatures, we union the return types of all the signatures.
	         *
	         * Another thing to note is that at any step of this process, we could run into a dead end,
	         * meaning either the property is missing, or we run into the anyType. If either of these things
	         * happens, we return undefined to signal that we could not find the iterated type. If a property
	         * is missing, and the previous step did not result in 'any', then we also give an error if the
	         * caller requested it. Then the caller can decide what to do in the case where there is no iterated
	         * type. This is different from returning anyType, because that would signify that we have matched the
	         * whole pattern and that T (above) is 'any'.
	         *
	         * For a **for-of** statement, `yield*` (in a normal generator), spread, array
	         * destructuring, or normal generator we will only ever look for a `[Symbol.iterator]()`
	         * method.
	         *
	         * For an async generator we will only ever look at the `[Symbol.asyncIterator]()` method.
	         *
	         * For a **for-await-of** statement or a `yield*` in an async generator we will look for
	         * the `[Symbol.asyncIterator]()` method first, and then the `[Symbol.iterator]()` method.
	         */
	        function getIteratedTypeOfIterable(type, errorNode, allowAsyncIterables, allowSyncIterables, checkAssignability) {
	            if (isTypeAny(type)) {
	                return undefined;
	            }
	            return mapType(type, getIteratedType);
	            function getIteratedType(type) {
	                var typeAsIterable = type;
	                if (allowAsyncIterables) {
	                    if (typeAsIterable.iteratedTypeOfAsyncIterable) {
	                        return typeAsIterable.iteratedTypeOfAsyncIterable;
	                    }
	                    // As an optimization, if the type is an instantiation of the global `AsyncIterable<T>`
	                    // or the global `AsyncIterableIterator<T>` then just grab its type argument.
	                    if (isReferenceToType(type, getGlobalAsyncIterableType(/*reportErrors*/ false)) ||
	                        isReferenceToType(type, getGlobalAsyncIterableIteratorType(/*reportErrors*/ false))) {
	                        return typeAsIterable.iteratedTypeOfAsyncIterable = type.typeArguments[0];
	                    }
	                }
	                if (allowSyncIterables) {
	                    if (typeAsIterable.iteratedTypeOfIterable) {
	                        return typeAsIterable.iteratedTypeOfIterable;
	                    }
	                    // As an optimization, if the type is an instantiation of the global `Iterable<T>` or
	                    // `IterableIterator<T>` then just grab its type argument.
	                    if (isReferenceToType(type, getGlobalIterableType(/*reportErrors*/ false)) ||
	                        isReferenceToType(type, getGlobalIterableIteratorType(/*reportErrors*/ false))) {
	                        return typeAsIterable.iteratedTypeOfIterable = type.typeArguments[0];
	                    }
	                }
	                var asyncMethodType = allowAsyncIterables && getTypeOfPropertyOfType(type, ts.getPropertyNameForKnownSymbolName("asyncIterator"));
	                var methodType = asyncMethodType || (allowSyncIterables && getTypeOfPropertyOfType(type, ts.getPropertyNameForKnownSymbolName("iterator")));
	                if (isTypeAny(methodType)) {
	                    return undefined;
	                }
	                var signatures = methodType && getSignaturesOfType(methodType, 0 /* Call */);
	                if (!ts.some(signatures)) {
	                    if (errorNode) {
	                        error(errorNode, allowAsyncIterables
	                            ? ts.Diagnostics.Type_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator
	                            : ts.Diagnostics.Type_must_have_a_Symbol_iterator_method_that_returns_an_iterator);
	                        // only report on the first error
	                        errorNode = undefined;
	                    }
	                    return undefined;
	                }
	                var returnType = getUnionType(ts.map(signatures, getReturnTypeOfSignature), 2 /* Subtype */);
	                var iteratedType = getIteratedTypeOfIterator(returnType, errorNode, /*isAsyncIterator*/ !!asyncMethodType);
	                if (checkAssignability && errorNode && iteratedType) {
	                    // If `checkAssignability` was specified, we were called from
	                    // `checkIteratedTypeOrElementType`. As such, we need to validate that
	                    // the type passed in is actually an Iterable.
	                    checkTypeAssignableTo(type, asyncMethodType
	                        ? createAsyncIterableType(iteratedType)
	                        : createIterableType(iteratedType), errorNode);
	                }
	                return asyncMethodType
	                    ? typeAsIterable.iteratedTypeOfAsyncIterable = iteratedType
	                    : typeAsIterable.iteratedTypeOfIterable = iteratedType;
	            }
	        }
	        /**
	         * This function has very similar logic as getIteratedTypeOfIterable, except that it operates on
	         * Iterators instead of Iterables. Here is the structure:
	         *
	         *  { // iterator
	         *      next: { // nextMethod
	         *          (): { // nextResult
	         *              value: T // nextValue
	         *          }
	         *      }
	         *  }
	         *
	         * For an async iterator, we expect the following structure:
	         *
	         *  { // iterator
	         *      next: { // nextMethod
	         *          (): PromiseLike<{ // nextResult
	         *              value: T // nextValue
	         *          }>
	         *      }
	         *  }
	         */
	        function getIteratedTypeOfIterator(type, errorNode, isAsyncIterator) {
	            if (isTypeAny(type)) {
	                return undefined;
	            }
	            var typeAsIterator = type;
	            if (isAsyncIterator ? typeAsIterator.iteratedTypeOfAsyncIterator : typeAsIterator.iteratedTypeOfIterator) {
	                return isAsyncIterator ? typeAsIterator.iteratedTypeOfAsyncIterator : typeAsIterator.iteratedTypeOfIterator;
	            }
	            // As an optimization, if the type is an instantiation of the global `Iterator<T>` (for
	            // a non-async iterator) or the global `AsyncIterator<T>` (for an async-iterator) then
	            // just grab its type argument.
	            var getIteratorType = isAsyncIterator ? getGlobalAsyncIteratorType : getGlobalIteratorType;
	            if (isReferenceToType(type, getIteratorType(/*reportErrors*/ false))) {
	                return isAsyncIterator
	                    ? typeAsIterator.iteratedTypeOfAsyncIterator = type.typeArguments[0]
	                    : typeAsIterator.iteratedTypeOfIterator = type.typeArguments[0];
	            }
	            // Both async and non-async iterators must have a `next` method.
	            var nextMethod = getTypeOfPropertyOfType(type, "next");
	            if (isTypeAny(nextMethod)) {
	                return undefined;
	            }
	            var nextMethodSignatures = nextMethod ? getSignaturesOfType(nextMethod, 0 /* Call */) : ts.emptyArray;
	            if (nextMethodSignatures.length === 0) {
	                if (errorNode) {
	                    error(errorNode, isAsyncIterator
	                        ? ts.Diagnostics.An_async_iterator_must_have_a_next_method
	                        : ts.Diagnostics.An_iterator_must_have_a_next_method);
	                }
	                return undefined;
	            }
	            var nextResult = getUnionType(ts.map(nextMethodSignatures, getReturnTypeOfSignature), 2 /* Subtype */);
	            if (isTypeAny(nextResult)) {
	                return undefined;
	            }
	            // For an async iterator, we must get the awaited type of the return type.
	            if (isAsyncIterator) {
	                nextResult = getAwaitedTypeOfPromise(nextResult, errorNode, ts.Diagnostics.The_type_returned_by_the_next_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property);
	                if (isTypeAny(nextResult)) {
	                    return undefined;
	                }
	            }
	            var nextValue = nextResult && getTypeOfPropertyOfType(nextResult, "value");
	            if (!nextValue) {
	                if (errorNode) {
	                    error(errorNode, isAsyncIterator
	                        ? ts.Diagnostics.The_type_returned_by_the_next_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property
	                        : ts.Diagnostics.The_type_returned_by_the_next_method_of_an_iterator_must_have_a_value_property);
	                }
	                return undefined;
	            }
	            return isAsyncIterator
	                ? typeAsIterator.iteratedTypeOfAsyncIterator = nextValue
	                : typeAsIterator.iteratedTypeOfIterator = nextValue;
	        }
	        /**
	         * A generator may have a return type of `Iterator<T>`, `Iterable<T>`, or
	         * `IterableIterator<T>`. An async generator may have a return type of `AsyncIterator<T>`,
	         * `AsyncIterable<T>`, or `AsyncIterableIterator<T>`. This function can be used to extract
	         * the iterated type from this return type for contextual typing and verifying signatures.
	         */
	        function getIteratedTypeOfGenerator(returnType, isAsyncGenerator) {
	            if (isTypeAny(returnType)) {
	                return undefined;
	            }
	            return getIteratedTypeOfIterable(returnType, /*errorNode*/ undefined, /*allowAsyncIterables*/ isAsyncGenerator, /*allowSyncIterables*/ !isAsyncGenerator, /*checkAssignability*/ false)
	                || getIteratedTypeOfIterator(returnType, /*errorNode*/ undefined, isAsyncGenerator);
	        }
	        function checkBreakOrContinueStatement(node) {
	            // Grammar checking
	            if (!checkGrammarStatementInAmbientContext(node))
	                checkGrammarBreakOrContinueStatement(node);
	            // TODO: Check that target label is valid
	        }
	        function isGetAccessorWithAnnotatedSetAccessor(node) {
	            return node.kind === 155 /* GetAccessor */
	                && ts.getEffectiveSetAccessorTypeAnnotationNode(ts.getDeclarationOfKind(node.symbol, 156 /* SetAccessor */)) !== undefined;
	        }
	        function isUnwrappedReturnTypeVoidOrAny(func, returnType) {
	            var unwrappedReturnType = (ts.getFunctionFlags(func) & 3 /* AsyncGenerator */) === 2 /* Async */
	                ? getPromisedTypeOfPromise(returnType) // Async function
	                : returnType; // AsyncGenerator function, Generator function, or normal function
	            return unwrappedReturnType && maybeTypeOfKind(unwrappedReturnType, 2048 /* Void */ | 1 /* Any */);
	        }
	        function checkReturnStatement(node) {
	            // Grammar checking
	            if (checkGrammarStatementInAmbientContext(node)) {
	                return;
	            }
	            var func = ts.getContainingFunction(node);
	            if (!func) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.A_return_statement_can_only_be_used_within_a_function_body);
	                return;
	            }
	            var signature = getSignatureFromDeclaration(func);
	            var returnType = getReturnTypeOfSignature(signature);
	            var functionFlags = ts.getFunctionFlags(func);
	            var isGenerator = functionFlags & 1 /* Generator */;
	            if (strictNullChecks || node.expression || returnType.flags & 16384 /* Never */) {
	                var exprType = node.expression ? checkExpressionCached(node.expression) : undefinedType;
	                if (isGenerator) {
	                    // A generator does not need its return expressions checked against its return type.
	                    // Instead, the yield expressions are checked against the element type.
	                    // TODO: Check return types of generators when return type tracking is added
	                    // for generators.
	                    return;
	                }
	                else if (func.kind === 156 /* SetAccessor */) {
	                    if (node.expression) {
	                        error(node, ts.Diagnostics.Setters_cannot_return_a_value);
	                    }
	                }
	                else if (func.kind === 154 /* Constructor */) {
	                    if (node.expression && !checkTypeAssignableTo(exprType, returnType, node)) {
	                        error(node, ts.Diagnostics.Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class);
	                    }
	                }
	                else if (ts.getEffectiveReturnTypeNode(func) || isGetAccessorWithAnnotatedSetAccessor(func)) {
	                    if (functionFlags & 2 /* Async */) {
	                        var promisedType = getPromisedTypeOfPromise(returnType);
	                        var awaitedType = checkAwaitedType(exprType, node, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                        if (promisedType) {
	                            // If the function has a return type, but promisedType is
	                            // undefined, an error will be reported in checkAsyncFunctionReturnType
	                            // so we don't need to report one here.
	                            checkTypeAssignableTo(awaitedType, promisedType, node);
	                        }
	                    }
	                    else {
	                        checkTypeAssignableTo(exprType, returnType, node);
	                    }
	                }
	            }
	            else if (func.kind !== 154 /* Constructor */ && compilerOptions.noImplicitReturns && !isUnwrappedReturnTypeVoidOrAny(func, returnType) && !isGenerator) {
	                // The function has a return type, but the return statement doesn't have an expression.
	                error(node, ts.Diagnostics.Not_all_code_paths_return_a_value);
	            }
	        }
	        function checkWithStatement(node) {
	            // Grammar checking for withStatement
	            if (!checkGrammarStatementInAmbientContext(node)) {
	                if (node.flags & 16384 /* AwaitContext */) {
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.with_statements_are_not_allowed_in_an_async_function_block);
	                }
	            }
	            checkExpression(node.expression);
	            var sourceFile = ts.getSourceFileOfNode(node);
	            if (!hasParseDiagnostics(sourceFile)) {
	                var start = ts.getSpanOfTokenAtPosition(sourceFile, node.pos).start;
	                var end = node.statement.pos;
	                grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any);
	            }
	        }
	        function checkSwitchStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            var firstDefaultClause;
	            var hasDuplicateDefaultClause = false;
	            var expressionType = checkExpression(node.expression);
	            var expressionIsLiteral = isLiteralType(expressionType);
	            ts.forEach(node.caseBlock.clauses, function (clause) {
	                // Grammar check for duplicate default clauses, skip if we already report duplicate default clause
	                if (clause.kind === 265 /* DefaultClause */ && !hasDuplicateDefaultClause) {
	                    if (firstDefaultClause === undefined) {
	                        firstDefaultClause = clause;
	                    }
	                    else {
	                        var sourceFile = ts.getSourceFileOfNode(node);
	                        var start = ts.skipTrivia(sourceFile.text, clause.pos);
	                        var end = clause.statements.length > 0 ? clause.statements[0].pos : clause.end;
	                        grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.A_default_clause_cannot_appear_more_than_once_in_a_switch_statement);
	                        hasDuplicateDefaultClause = true;
	                    }
	                }
	                if (produceDiagnostics && clause.kind === 264 /* CaseClause */) {
	                    // TypeScript 1.0 spec (April 2014): 5.9
	                    // In a 'switch' statement, each 'case' expression must be of a type that is comparable
	                    // to or from the type of the 'switch' expression.
	                    var caseType = checkExpression(clause.expression);
	                    var caseIsLiteral = isLiteralType(caseType);
	                    var comparedExpressionType = expressionType;
	                    if (!caseIsLiteral || !expressionIsLiteral) {
	                        caseType = caseIsLiteral ? getBaseTypeOfLiteralType(caseType) : caseType;
	                        comparedExpressionType = getBaseTypeOfLiteralType(expressionType);
	                    }
	                    if (!isTypeEqualityComparableTo(comparedExpressionType, caseType)) {
	                        // expressionType is not comparable to caseType, try the reversed check and report errors if it fails
	                        checkTypeComparableTo(caseType, comparedExpressionType, clause.expression, /*headMessage*/ undefined);
	                    }
	                }
	                ts.forEach(clause.statements, checkSourceElement);
	            });
	            if (node.caseBlock.locals) {
	                registerForUnusedIdentifiersCheck(node.caseBlock);
	            }
	        }
	        function checkLabeledStatement(node) {
	            // Grammar checking
	            if (!checkGrammarStatementInAmbientContext(node)) {
	                ts.findAncestor(node.parent, function (current) {
	                    if (ts.isFunctionLike(current)) {
	                        return "quit";
	                    }
	                    if (current.kind === 226 /* LabeledStatement */ && current.label.escapedText === node.label.escapedText) {
	                        var sourceFile = ts.getSourceFileOfNode(node);
	                        grammarErrorOnNode(node.label, ts.Diagnostics.Duplicate_label_0, ts.getTextOfNodeFromSourceText(sourceFile.text, node.label));
	                        return true;
	                    }
	                });
	            }
	            // ensure that label is unique
	            checkSourceElement(node.statement);
	        }
	        function checkThrowStatement(node) {
	            // Grammar checking
	            if (!checkGrammarStatementInAmbientContext(node)) {
	                if (node.expression === undefined) {
	                    grammarErrorAfterFirstToken(node, ts.Diagnostics.Line_break_not_permitted_here);
	                }
	            }
	            if (node.expression) {
	                checkExpression(node.expression);
	            }
	        }
	        function checkTryStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkBlock(node.tryBlock);
	            var catchClause = node.catchClause;
	            if (catchClause) {
	                // Grammar checking
	                if (catchClause.variableDeclaration) {
	                    if (catchClause.variableDeclaration.type) {
	                        grammarErrorOnFirstToken(catchClause.variableDeclaration.type, ts.Diagnostics.Catch_clause_variable_cannot_have_a_type_annotation);
	                    }
	                    else if (catchClause.variableDeclaration.initializer) {
	                        grammarErrorOnFirstToken(catchClause.variableDeclaration.initializer, ts.Diagnostics.Catch_clause_variable_cannot_have_an_initializer);
	                    }
	                    else {
	                        var blockLocals_1 = catchClause.block.locals;
	                        if (blockLocals_1) {
	                            ts.forEachKey(catchClause.locals, function (caughtName) {
	                                var blockLocal = blockLocals_1.get(caughtName);
	                                if (blockLocal && (blockLocal.flags & 2 /* BlockScopedVariable */) !== 0) {
	                                    grammarErrorOnNode(blockLocal.valueDeclaration, ts.Diagnostics.Cannot_redeclare_identifier_0_in_catch_clause, caughtName);
	                                }
	                            });
	                        }
	                    }
	                }
	                checkBlock(catchClause.block);
	            }
	            if (node.finallyBlock) {
	                checkBlock(node.finallyBlock);
	            }
	        }
	        function checkIndexConstraints(type) {
	            var declaredNumberIndexer = getIndexDeclarationOfSymbol(type.symbol, 1 /* Number */);
	            var declaredStringIndexer = getIndexDeclarationOfSymbol(type.symbol, 0 /* String */);
	            var stringIndexType = getIndexTypeOfType(type, 0 /* String */);
	            var numberIndexType = getIndexTypeOfType(type, 1 /* Number */);
	            if (stringIndexType || numberIndexType) {
	                ts.forEach(getPropertiesOfObjectType(type), function (prop) {
	                    var propType = getTypeOfSymbol(prop);
	                    checkIndexConstraintForProperty(prop, propType, type, declaredStringIndexer, stringIndexType, 0 /* String */);
	                    checkIndexConstraintForProperty(prop, propType, type, declaredNumberIndexer, numberIndexType, 1 /* Number */);
	                });
	                if (ts.getObjectFlags(type) & 1 /* Class */ && ts.isClassLike(type.symbol.valueDeclaration)) {
	                    var classDeclaration = type.symbol.valueDeclaration;
	                    for (var _i = 0, _a = classDeclaration.members; _i < _a.length; _i++) {
	                        var member = _a[_i];
	                        // Only process instance properties with computed names here.
	                        // Static properties cannot be in conflict with indexers,
	                        // and properties with literal names were already checked.
	                        if (!ts.hasModifier(member, 32 /* Static */) && hasNonBindableDynamicName(member)) {
	                            var symbol = getSymbolOfNode(member);
	                            var propType = getTypeOfSymbol(symbol);
	                            checkIndexConstraintForProperty(symbol, propType, type, declaredStringIndexer, stringIndexType, 0 /* String */);
	                            checkIndexConstraintForProperty(symbol, propType, type, declaredNumberIndexer, numberIndexType, 1 /* Number */);
	                        }
	                    }
	                }
	            }
	            var errorNode;
	            if (stringIndexType && numberIndexType) {
	                errorNode = declaredNumberIndexer || declaredStringIndexer;
	                // condition 'errorNode === undefined' may appear if types does not declare nor string neither number indexer
	                if (!errorNode && (ts.getObjectFlags(type) & 2 /* Interface */)) {
	                    var someBaseTypeHasBothIndexers = ts.forEach(getBaseTypes(type), function (base) { return getIndexTypeOfType(base, 0 /* String */) && getIndexTypeOfType(base, 1 /* Number */); });
	                    errorNode = someBaseTypeHasBothIndexers ? undefined : type.symbol.declarations[0];
	                }
	            }
	            if (errorNode && !isTypeAssignableTo(numberIndexType, stringIndexType)) {
	                error(errorNode, ts.Diagnostics.Numeric_index_type_0_is_not_assignable_to_string_index_type_1, typeToString(numberIndexType), typeToString(stringIndexType));
	            }
	            function checkIndexConstraintForProperty(prop, propertyType, containingType, indexDeclaration, indexType, indexKind) {
	                // ESSymbol properties apply to neither string nor numeric indexers.
	                if (!indexType || ts.isKnownSymbol(prop)) {
	                    return;
	                }
	                var propDeclaration = prop.valueDeclaration;
	                // index is numeric and property name is not valid numeric literal
	                if (indexKind === 1 /* Number */ && !(propDeclaration ? isNumericName(ts.getNameOfDeclaration(propDeclaration)) : isNumericLiteralName(prop.escapedName))) {
	                    return;
	                }
	                // perform property check if property or indexer is declared in 'type'
	                // this allows us to rule out cases when both property and indexer are inherited from the base class
	                var errorNode;
	                if (propDeclaration &&
	                    (propDeclaration.kind === 198 /* BinaryExpression */ ||
	                        ts.getNameOfDeclaration(propDeclaration).kind === 146 /* ComputedPropertyName */ ||
	                        prop.parent === containingType.symbol)) {
	                    errorNode = propDeclaration;
	                }
	                else if (indexDeclaration) {
	                    errorNode = indexDeclaration;
	                }
	                else if (ts.getObjectFlags(containingType) & 2 /* Interface */) {
	                    // for interfaces property and indexer might be inherited from different bases
	                    // check if any base class already has both property and indexer.
	                    // check should be performed only if 'type' is the first type that brings property\indexer together
	                    var someBaseClassHasBothPropertyAndIndexer = ts.forEach(getBaseTypes(containingType), function (base) { return getPropertyOfObjectType(base, prop.escapedName) && getIndexTypeOfType(base, indexKind); });
	                    errorNode = someBaseClassHasBothPropertyAndIndexer ? undefined : containingType.symbol.declarations[0];
	                }
	                if (errorNode && !isTypeAssignableTo(propertyType, indexType)) {
	                    var errorMessage = indexKind === 0 /* String */
	                        ? ts.Diagnostics.Property_0_of_type_1_is_not_assignable_to_string_index_type_2
	                        : ts.Diagnostics.Property_0_of_type_1_is_not_assignable_to_numeric_index_type_2;
	                    error(errorNode, errorMessage, symbolToString(prop), typeToString(propertyType), typeToString(indexType));
	                }
	            }
	        }
	        function checkTypeNameIsReserved(name, message) {
	            // TS 1.0 spec (April 2014): 3.6.1
	            // The predefined type keywords are reserved and cannot be used as names of user defined types.
	            switch (name.escapedText) {
	                case "any":
	                case "number":
	                case "boolean":
	                case "string":
	                case "symbol":
	                case "void":
	                case "object":
	                    error(name, message, name.escapedText);
	            }
	        }
	        /**
	         * Check each type parameter and check that type parameters have no duplicate type parameter declarations
	         */
	        function checkTypeParameters(typeParameterDeclarations) {
	            if (typeParameterDeclarations) {
	                var seenDefault = false;
	                for (var i = 0; i < typeParameterDeclarations.length; i++) {
	                    var node = typeParameterDeclarations[i];
	                    checkTypeParameter(node);
	                    if (produceDiagnostics) {
	                        if (node.default) {
	                            seenDefault = true;
	                        }
	                        else if (seenDefault) {
	                            error(node, ts.Diagnostics.Required_type_parameters_may_not_follow_optional_type_parameters);
	                        }
	                        for (var j = 0; j < i; j++) {
	                            if (typeParameterDeclarations[j].symbol === node.symbol) {
	                                error(node.name, ts.Diagnostics.Duplicate_identifier_0, ts.declarationNameToString(node.name));
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        /** Check that type parameter lists are identical across multiple declarations */
	        function checkTypeParameterListsIdentical(symbol) {
	            if (symbol.declarations.length === 1) {
	                return;
	            }
	            var links = getSymbolLinks(symbol);
	            if (!links.typeParametersChecked) {
	                links.typeParametersChecked = true;
	                var declarations = getClassOrInterfaceDeclarationsOfSymbol(symbol);
	                if (declarations.length <= 1) {
	                    return;
	                }
	                var type = getDeclaredTypeOfSymbol(symbol);
	                if (!areTypeParametersIdentical(declarations, type.localTypeParameters)) {
	                    // Report an error on every conflicting declaration.
	                    var name = symbolToString(symbol);
	                    for (var _i = 0, declarations_5 = declarations; _i < declarations_5.length; _i++) {
	                        var declaration = declarations_5[_i];
	                        error(declaration.name, ts.Diagnostics.All_declarations_of_0_must_have_identical_type_parameters, name);
	                    }
	                }
	            }
	        }
	        function areTypeParametersIdentical(declarations, typeParameters) {
	            var maxTypeArgumentCount = ts.length(typeParameters);
	            var minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
	            for (var _i = 0, declarations_6 = declarations; _i < declarations_6.length; _i++) {
	                var declaration = declarations_6[_i];
	                // If this declaration has too few or too many type parameters, we report an error
	                var numTypeParameters = ts.length(declaration.typeParameters);
	                if (numTypeParameters < minTypeArgumentCount || numTypeParameters > maxTypeArgumentCount) {
	                    return false;
	                }
	                for (var i = 0; i < numTypeParameters; i++) {
	                    var source = declaration.typeParameters[i];
	                    var target = typeParameters[i];
	                    // If the type parameter node does not have the same as the resolved type
	                    // parameter at this position, we report an error.
	                    if (source.name.escapedText !== target.symbol.escapedName) {
	                        return false;
	                    }
	                    // If the type parameter node does not have an identical constraint as the resolved
	                    // type parameter at this position, we report an error.
	                    var sourceConstraint = source.constraint && getTypeFromTypeNode(source.constraint);
	                    var targetConstraint = getConstraintFromTypeParameter(target);
	                    if (sourceConstraint) {
	                        // relax check if later interface augmentation has no constraint
	                        if (!targetConstraint || !isTypeIdenticalTo(sourceConstraint, targetConstraint)) {
	                            return false;
	                        }
	                    }
	                    // If the type parameter node has a default and it is not identical to the default
	                    // for the type parameter at this position, we report an error.
	                    var sourceDefault = source.default && getTypeFromTypeNode(source.default);
	                    var targetDefault = getDefaultFromTypeParameter(target);
	                    if (sourceDefault && targetDefault && !isTypeIdenticalTo(sourceDefault, targetDefault)) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }
	        function checkClassExpression(node) {
	            checkClassLikeDeclaration(node);
	            checkNodeDeferred(node);
	            return getTypeOfSymbol(getSymbolOfNode(node));
	        }
	        function checkClassExpressionDeferred(node) {
	            ts.forEach(node.members, checkSourceElement);
	            registerForUnusedIdentifiersCheck(node);
	        }
	        function checkClassDeclaration(node) {
	            if (!node.name && !ts.hasModifier(node, 512 /* Default */)) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.A_class_declaration_without_the_default_modifier_must_have_a_name);
	            }
	            checkClassLikeDeclaration(node);
	            ts.forEach(node.members, checkSourceElement);
	            registerForUnusedIdentifiersCheck(node);
	        }
	        function checkClassLikeDeclaration(node) {
	            checkGrammarClassLikeDeclaration(node);
	            checkDecorators(node);
	            if (node.name) {
	                checkTypeNameIsReserved(node.name, ts.Diagnostics.Class_name_cannot_be_0);
	                checkCollisionWithCapturedThisVariable(node, node.name);
	                checkCollisionWithCapturedNewTargetVariable(node, node.name);
	                checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	                checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            }
	            checkTypeParameters(node.typeParameters);
	            checkExportsOnMergedDeclarations(node);
	            var symbol = getSymbolOfNode(node);
	            var type = getDeclaredTypeOfSymbol(symbol);
	            var typeWithThis = getTypeWithThisArgument(type);
	            var staticType = getTypeOfSymbol(symbol);
	            checkTypeParameterListsIdentical(symbol);
	            checkClassForDuplicateDeclarations(node);
	            // Only check for reserved static identifiers on non-ambient context.
	            if (!(node.flags & 2097152 /* Ambient */)) {
	                checkClassForStaticPropertyNameConflicts(node);
	            }
	            var baseTypeNode = ts.getClassExtendsHeritageClauseElement(node);
	            if (baseTypeNode) {
	                if (languageVersion < 2 /* ES2015 */) {
	                    checkExternalEmitHelpers(baseTypeNode.parent, 1 /* Extends */);
	                }
	                var baseTypes = getBaseTypes(type);
	                if (baseTypes.length && produceDiagnostics) {
	                    var baseType_1 = baseTypes[0];
	                    var baseConstructorType = getBaseConstructorTypeOfClass(type);
	                    var staticBaseType = getApparentType(baseConstructorType);
	                    checkBaseTypeAccessibility(staticBaseType, baseTypeNode);
	                    checkSourceElement(baseTypeNode.expression);
	                    if (ts.some(baseTypeNode.typeArguments)) {
	                        ts.forEach(baseTypeNode.typeArguments, checkSourceElement);
	                        for (var _i = 0, _a = getConstructorsForTypeArguments(staticBaseType, baseTypeNode.typeArguments, baseTypeNode); _i < _a.length; _i++) {
	                            var constructor = _a[_i];
	                            if (!checkTypeArgumentConstraints(baseTypeNode, constructor.typeParameters)) {
	                                break;
	                            }
	                        }
	                    }
	                    var baseWithThis = getTypeWithThisArgument(baseType_1, type.thisType);
	                    if (!checkTypeAssignableTo(typeWithThis, baseWithThis, /*errorNode*/ undefined)) {
	                        issueMemberSpecificError(node, typeWithThis, baseWithThis, ts.Diagnostics.Class_0_incorrectly_extends_base_class_1);
	                    }
	                    checkTypeAssignableTo(staticType, getTypeWithoutSignatures(staticBaseType), node.name || node, ts.Diagnostics.Class_static_side_0_incorrectly_extends_base_class_static_side_1);
	                    if (baseConstructorType.flags & 1081344 /* TypeVariable */ && !isMixinConstructorType(staticType)) {
	                        error(node.name || node, ts.Diagnostics.A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any);
	                    }
	                    if (!(staticBaseType.symbol && staticBaseType.symbol.flags & 32 /* Class */) && !(baseConstructorType.flags & 1081344 /* TypeVariable */)) {
	                        // When the static base type is a "class-like" constructor function (but not actually a class), we verify
	                        // that all instantiated base constructor signatures return the same type. We can simply compare the type
	                        // references (as opposed to checking the structure of the types) because elsewhere we have already checked
	                        // that the base type is a class or interface type (and not, for example, an anonymous object type).
	                        var constructors = getInstantiatedConstructorsForTypeArguments(staticBaseType, baseTypeNode.typeArguments, baseTypeNode);
	                        if (ts.forEach(constructors, function (sig) { return getReturnTypeOfSignature(sig) !== baseType_1; })) {
	                            error(baseTypeNode.expression, ts.Diagnostics.Base_constructors_must_all_have_the_same_return_type);
	                        }
	                    }
	                    checkKindsOfPropertyMemberOverrides(type, baseType_1);
	                }
	            }
	            var implementedTypeNodes = ts.getClassImplementsHeritageClauseElements(node);
	            if (implementedTypeNodes) {
	                for (var _b = 0, implementedTypeNodes_1 = implementedTypeNodes; _b < implementedTypeNodes_1.length; _b++) {
	                    var typeRefNode = implementedTypeNodes_1[_b];
	                    if (!ts.isEntityNameExpression(typeRefNode.expression)) {
	                        error(typeRefNode.expression, ts.Diagnostics.A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments);
	                    }
	                    checkTypeReferenceNode(typeRefNode);
	                    if (produceDiagnostics) {
	                        var t = getTypeFromTypeNode(typeRefNode);
	                        if (t !== unknownType) {
	                            if (isValidBaseType(t)) {
	                                var genericDiag = t.symbol && t.symbol.flags & 32 /* Class */ ?
	                                    ts.Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass :
	                                    ts.Diagnostics.Class_0_incorrectly_implements_interface_1;
	                                var baseWithThis = getTypeWithThisArgument(t, type.thisType);
	                                if (!checkTypeAssignableTo(typeWithThis, baseWithThis, /*errorNode*/ undefined)) {
	                                    issueMemberSpecificError(node, typeWithThis, baseWithThis, genericDiag);
	                                }
	                            }
	                            else {
	                                error(typeRefNode, ts.Diagnostics.A_class_may_only_implement_another_class_or_interface);
	                            }
	                        }
	                    }
	                }
	            }
	            if (produceDiagnostics) {
	                checkIndexConstraints(type);
	                checkTypeForDuplicateIndexSignatures(node);
	                checkPropertyInitialization(node);
	            }
	        }
	        function issueMemberSpecificError(node, typeWithThis, baseWithThis, broadDiag) {
	            // iterate over all implemented properties and issue errors on each one which isn't compatible, rather than the class as a whole, if possible
	            var issuedMemberError = false;
	            var _loop_5 = function (member) {
	                if (ts.hasStaticModifier(member)) {
	                    return "continue";
	                }
	                var declaredProp = member.name && getSymbolAtLocation(member.name) || getSymbolAtLocation(member);
	                if (declaredProp) {
	                    var prop = getPropertyOfType(typeWithThis, declaredProp.escapedName);
	                    var baseProp = getPropertyOfType(baseWithThis, declaredProp.escapedName);
	                    if (prop && baseProp) {
	                        var rootChain = function () { return ts.chainDiagnosticMessages(
	                        /*details*/ undefined, ts.Diagnostics.Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2, symbolToString(declaredProp), typeToString(typeWithThis), typeToString(baseWithThis)); };
	                        if (!checkTypeAssignableTo(getTypeOfSymbol(prop), getTypeOfSymbol(baseProp), member.name || member, /*message*/ undefined, rootChain)) {
	                            issuedMemberError = true;
	                        }
	                    }
	                }
	            };
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                _loop_5(member);
	            }
	            if (!issuedMemberError) {
	                // check again with diagnostics to generate a less-specific error
	                checkTypeAssignableTo(typeWithThis, baseWithThis, node.name || node, broadDiag);
	            }
	        }
	        function checkBaseTypeAccessibility(type, node) {
	            var signatures = getSignaturesOfType(type, 1 /* Construct */);
	            if (signatures.length) {
	                var declaration = signatures[0].declaration;
	                if (declaration && ts.hasModifier(declaration, 8 /* Private */)) {
	                    var typeClassDeclaration = ts.getClassLikeDeclarationOfSymbol(type.symbol);
	                    if (!isNodeWithinClass(node, typeClassDeclaration)) {
	                        error(node, ts.Diagnostics.Cannot_extend_a_class_0_Class_constructor_is_marked_as_private, getFullyQualifiedName(type.symbol));
	                    }
	                }
	            }
	        }
	        function getTargetSymbol(s) {
	            // if symbol is instantiated its flags are not copied from the 'target'
	            // so we'll need to get back original 'target' symbol to work with correct set of flags
	            return ts.getCheckFlags(s) & 1 /* Instantiated */ ? s.target : s;
	        }
	        function getClassOrInterfaceDeclarationsOfSymbol(symbol) {
	            return ts.filter(symbol.declarations, function (d) {
	                return d.kind === 233 /* ClassDeclaration */ || d.kind === 234 /* InterfaceDeclaration */;
	            });
	        }
	        function checkKindsOfPropertyMemberOverrides(type, baseType) {
	            // TypeScript 1.0 spec (April 2014): 8.2.3
	            // A derived class inherits all members from its base class it doesn't override.
	            // Inheritance means that a derived class implicitly contains all non - overridden members of the base class.
	            // Both public and private property members are inherited, but only public property members can be overridden.
	            // A property member in a derived class is said to override a property member in a base class
	            // when the derived class property member has the same name and kind(instance or static)
	            // as the base class property member.
	            // The type of an overriding property member must be assignable(section 3.8.4)
	            // to the type of the overridden property member, or otherwise a compile - time error occurs.
	            // Base class instance member functions can be overridden by derived class instance member functions,
	            // but not by other kinds of members.
	            // Base class instance member variables and accessors can be overridden by
	            // derived class instance member variables and accessors, but not by other kinds of members.
	            // NOTE: assignability is checked in checkClassDeclaration
	            var baseProperties = getPropertiesOfType(baseType);
	            for (var _i = 0, baseProperties_1 = baseProperties; _i < baseProperties_1.length; _i++) {
	                var baseProperty = baseProperties_1[_i];
	                var base = getTargetSymbol(baseProperty);
	                if (base.flags & 4194304 /* Prototype */) {
	                    continue;
	                }
	                var derived = getTargetSymbol(getPropertyOfObjectType(type, base.escapedName));
	                var baseDeclarationFlags = ts.getDeclarationModifierFlagsFromSymbol(base);
	                ts.Debug.assert(!!derived, "derived should point to something, even if it is the base class' declaration.");
	                if (derived) {
	                    // In order to resolve whether the inherited method was overridden in the base class or not,
	                    // we compare the Symbols obtained. Since getTargetSymbol returns the symbol on the *uninstantiated*
	                    // type declaration, derived and base resolve to the same symbol even in the case of generic classes.
	                    if (derived === base) {
	                        // derived class inherits base without override/redeclaration
	                        var derivedClassDecl = ts.getClassLikeDeclarationOfSymbol(type.symbol);
	                        // It is an error to inherit an abstract member without implementing it or being declared abstract.
	                        // If there is no declaration for the derived class (as in the case of class expressions),
	                        // then the class cannot be declared abstract.
	                        if (baseDeclarationFlags & 128 /* Abstract */ && (!derivedClassDecl || !ts.hasModifier(derivedClassDecl, 128 /* Abstract */))) {
	                            if (derivedClassDecl.kind === 203 /* ClassExpression */) {
	                                error(derivedClassDecl, ts.Diagnostics.Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1, symbolToString(baseProperty), typeToString(baseType));
	                            }
	                            else {
	                                error(derivedClassDecl, ts.Diagnostics.Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2, typeToString(type), symbolToString(baseProperty), typeToString(baseType));
	                            }
	                        }
	                    }
	                    else {
	                        // derived overrides base.
	                        var derivedDeclarationFlags = ts.getDeclarationModifierFlagsFromSymbol(derived);
	                        if (baseDeclarationFlags & 8 /* Private */ || derivedDeclarationFlags & 8 /* Private */) {
	                            // either base or derived property is private - not override, skip it
	                            continue;
	                        }
	                        if (isMethodLike(base) && isMethodLike(derived) || base.flags & 98308 /* PropertyOrAccessor */ && derived.flags & 98308 /* PropertyOrAccessor */) {
	                            // method is overridden with method or property/accessor is overridden with property/accessor - correct case
	                            continue;
	                        }
	                        var errorMessage = void 0;
	                        if (isMethodLike(base)) {
	                            if (derived.flags & 98304 /* Accessor */) {
	                                errorMessage = ts.Diagnostics.Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_accessor;
	                            }
	                            else {
	                                errorMessage = ts.Diagnostics.Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_property;
	                            }
	                        }
	                        else if (base.flags & 4 /* Property */) {
	                            errorMessage = ts.Diagnostics.Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_function;
	                        }
	                        else {
	                            errorMessage = ts.Diagnostics.Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_function;
	                        }
	                        error(ts.getNameOfDeclaration(derived.valueDeclaration) || derived.valueDeclaration, errorMessage, typeToString(baseType), symbolToString(base), typeToString(type));
	                    }
	                }
	            }
	        }
	        function checkInheritedPropertiesAreIdentical(type, typeNode) {
	            var baseTypes = getBaseTypes(type);
	            if (baseTypes.length < 2) {
	                return true;
	            }
	            var seen = ts.createUnderscoreEscapedMap();
	            ts.forEach(resolveDeclaredMembers(type).declaredProperties, function (p) { seen.set(p.escapedName, { prop: p, containingType: type }); });
	            var ok = true;
	            for (var _i = 0, baseTypes_2 = baseTypes; _i < baseTypes_2.length; _i++) {
	                var base = baseTypes_2[_i];
	                var properties = getPropertiesOfType(getTypeWithThisArgument(base, type.thisType));
	                for (var _a = 0, properties_8 = properties; _a < properties_8.length; _a++) {
	                    var prop = properties_8[_a];
	                    var existing = seen.get(prop.escapedName);
	                    if (!existing) {
	                        seen.set(prop.escapedName, { prop: prop, containingType: base });
	                    }
	                    else {
	                        var isInheritedProperty = existing.containingType !== type;
	                        if (isInheritedProperty && !isPropertyIdenticalTo(existing.prop, prop)) {
	                            ok = false;
	                            var typeName1 = typeToString(existing.containingType);
	                            var typeName2 = typeToString(base);
	                            var errorInfo = ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.Named_property_0_of_types_1_and_2_are_not_identical, symbolToString(prop), typeName1, typeName2);
	                            errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Interface_0_cannot_simultaneously_extend_types_1_and_2, typeToString(type), typeName1, typeName2);
	                            diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(typeNode, errorInfo));
	                        }
	                    }
	                }
	            }
	            return ok;
	        }
	        function checkPropertyInitialization(node) {
	            if (!strictNullChecks || !strictPropertyInitialization || node.flags & 2097152 /* Ambient */) {
	                return;
	            }
	            var constructor = findConstructorDeclaration(node);
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                if (isInstancePropertyWithoutInitializer(member)) {
	                    var propName = member.name;
	                    if (ts.isIdentifier(propName)) {
	                        var type = getTypeOfSymbol(getSymbolOfNode(member));
	                        if (!(type.flags & 1 /* Any */ || getFalsyFlags(type) & 4096 /* Undefined */)) {
	                            if (!constructor || !isPropertyInitializedInConstructor(propName, type, constructor)) {
	                                error(member.name, ts.Diagnostics.Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor, ts.declarationNameToString(propName));
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        function isInstancePropertyWithoutInitializer(node) {
	            return node.kind === 151 /* PropertyDeclaration */ &&
	                !ts.hasModifier(node, 32 /* Static */ | 128 /* Abstract */) &&
	                !node.exclamationToken &&
	                !node.initializer;
	        }
	        function isPropertyInitializedInConstructor(propName, propType, constructor) {
	            var reference = ts.createPropertyAccess(ts.createThis(), propName);
	            reference.flowNode = constructor.returnFlowNode;
	            var flowType = getFlowTypeOfReference(reference, propType, getOptionalType(propType));
	            return !(getFalsyFlags(flowType) & 4096 /* Undefined */);
	        }
	        function checkInterfaceDeclaration(node) {
	            // Grammar checking
	            if (!checkGrammarDecoratorsAndModifiers(node))
	                checkGrammarInterfaceDeclaration(node);
	            checkTypeParameters(node.typeParameters);
	            if (produceDiagnostics) {
	                checkTypeNameIsReserved(node.name, ts.Diagnostics.Interface_name_cannot_be_0);
	                checkExportsOnMergedDeclarations(node);
	                var symbol = getSymbolOfNode(node);
	                checkTypeParameterListsIdentical(symbol);
	                // Only check this symbol once
	                var firstInterfaceDecl = ts.getDeclarationOfKind(symbol, 234 /* InterfaceDeclaration */);
	                if (node === firstInterfaceDecl) {
	                    var type = getDeclaredTypeOfSymbol(symbol);
	                    var typeWithThis = getTypeWithThisArgument(type);
	                    // run subsequent checks only if first set succeeded
	                    if (checkInheritedPropertiesAreIdentical(type, node.name)) {
	                        for (var _i = 0, _a = getBaseTypes(type); _i < _a.length; _i++) {
	                            var baseType = _a[_i];
	                            checkTypeAssignableTo(typeWithThis, getTypeWithThisArgument(baseType, type.thisType), node.name, ts.Diagnostics.Interface_0_incorrectly_extends_interface_1);
	                        }
	                        checkIndexConstraints(type);
	                    }
	                }
	                checkObjectTypeForDuplicateDeclarations(node);
	            }
	            ts.forEach(ts.getInterfaceBaseTypeNodes(node), function (heritageElement) {
	                if (!ts.isEntityNameExpression(heritageElement.expression)) {
	                    error(heritageElement.expression, ts.Diagnostics.An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments);
	                }
	                checkTypeReferenceNode(heritageElement);
	            });
	            ts.forEach(node.members, checkSourceElement);
	            if (produceDiagnostics) {
	                checkTypeForDuplicateIndexSignatures(node);
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkTypeAliasDeclaration(node) {
	            // Grammar checking
	            checkGrammarDecoratorsAndModifiers(node);
	            checkTypeNameIsReserved(node.name, ts.Diagnostics.Type_alias_name_cannot_be_0);
	            checkTypeParameters(node.typeParameters);
	            checkSourceElement(node.type);
	            registerForUnusedIdentifiersCheck(node);
	        }
	        function computeEnumMemberValues(node) {
	            var nodeLinks = getNodeLinks(node);
	            if (!(nodeLinks.flags & 16384 /* EnumValuesComputed */)) {
	                nodeLinks.flags |= 16384 /* EnumValuesComputed */;
	                var autoValue = 0;
	                for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                    var member = _a[_i];
	                    var value = computeMemberValue(member, autoValue);
	                    getNodeLinks(member).enumMemberValue = value;
	                    autoValue = typeof value === "number" ? value + 1 : undefined;
	                }
	            }
	        }
	        function computeMemberValue(member, autoValue) {
	            if (isComputedNonLiteralName(member.name)) {
	                error(member.name, ts.Diagnostics.Computed_property_names_are_not_allowed_in_enums);
	            }
	            else {
	                var text = ts.getTextOfPropertyName(member.name);
	                if (isNumericLiteralName(text) && !isInfinityOrNaNString(text)) {
	                    error(member.name, ts.Diagnostics.An_enum_member_cannot_have_a_numeric_name);
	                }
	            }
	            if (member.initializer) {
	                return computeConstantValue(member);
	            }
	            // In ambient enum declarations that specify no const modifier, enum member declarations that omit
	            // a value are considered computed members (as opposed to having auto-incremented values).
	            if (member.parent.flags & 2097152 /* Ambient */ && !ts.isConst(member.parent)) {
	                return undefined;
	            }
	            // If the member declaration specifies no value, the member is considered a constant enum member.
	            // If the member is the first member in the enum declaration, it is assigned the value zero.
	            // Otherwise, it is assigned the value of the immediately preceding member plus one, and an error
	            // occurs if the immediately preceding member is not a constant enum member.
	            if (autoValue !== undefined) {
	                return autoValue;
	            }
	            error(member.name, ts.Diagnostics.Enum_member_must_have_initializer);
	            return undefined;
	        }
	        function computeConstantValue(member) {
	            var enumKind = getEnumKind(getSymbolOfNode(member.parent));
	            var isConstEnum = ts.isConst(member.parent);
	            var initializer = member.initializer;
	            var value = enumKind === 1 /* Literal */ && !isLiteralEnumMember(member) ? undefined : evaluate(initializer);
	            if (value !== undefined) {
	                if (isConstEnum && typeof value === "number" && !isFinite(value)) {
	                    error(initializer, isNaN(value) ?
	                        ts.Diagnostics.const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN :
	                        ts.Diagnostics.const_enum_member_initializer_was_evaluated_to_a_non_finite_value);
	                }
	            }
	            else if (enumKind === 1 /* Literal */) {
	                error(initializer, ts.Diagnostics.Computed_values_are_not_permitted_in_an_enum_with_string_valued_members);
	                return 0;
	            }
	            else if (isConstEnum) {
	                error(initializer, ts.Diagnostics.In_const_enum_declarations_member_initializer_must_be_constant_expression);
	            }
	            else if (member.parent.flags & 2097152 /* Ambient */) {
	                error(initializer, ts.Diagnostics.In_ambient_enum_declarations_member_initializer_must_be_constant_expression);
	            }
	            else {
	                // Only here do we need to check that the initializer is assignable to the enum type.
	                checkTypeAssignableTo(checkExpression(initializer), getDeclaredTypeOfSymbol(getSymbolOfNode(member.parent)), initializer, /*headMessage*/ undefined);
	            }
	            return value;
	            function evaluate(expr) {
	                switch (expr.kind) {
	                    case 196 /* PrefixUnaryExpression */:
	                        var value_2 = evaluate(expr.operand);
	                        if (typeof value_2 === "number") {
	                            switch (expr.operator) {
	                                case 37 /* PlusToken */: return value_2;
	                                case 38 /* MinusToken */: return -value_2;
	                                case 52 /* TildeToken */: return ~value_2;
	                            }
	                        }
	                        break;
	                    case 198 /* BinaryExpression */:
	                        var left = evaluate(expr.left);
	                        var right = evaluate(expr.right);
	                        if (typeof left === "number" && typeof right === "number") {
	                            switch (expr.operatorToken.kind) {
	                                case 49 /* BarToken */: return left | right;
	                                case 48 /* AmpersandToken */: return left & right;
	                                case 46 /* GreaterThanGreaterThanToken */: return left >> right;
	                                case 47 /* GreaterThanGreaterThanGreaterThanToken */: return left >>> right;
	                                case 45 /* LessThanLessThanToken */: return left << right;
	                                case 50 /* CaretToken */: return left ^ right;
	                                case 39 /* AsteriskToken */: return left * right;
	                                case 41 /* SlashToken */: return left / right;
	                                case 37 /* PlusToken */: return left + right;
	                                case 38 /* MinusToken */: return left - right;
	                                case 42 /* PercentToken */: return left % right;
	                                case 40 /* AsteriskAsteriskToken */: return Math.pow(left, right);
	                            }
	                        }
	                        break;
	                    case 9 /* StringLiteral */:
	                        return expr.text;
	                    case 8 /* NumericLiteral */:
	                        checkGrammarNumericLiteral(expr);
	                        return +expr.text;
	                    case 189 /* ParenthesizedExpression */:
	                        return evaluate(expr.expression);
	                    case 71 /* Identifier */:
	                        return ts.nodeIsMissing(expr) ? 0 : evaluateEnumMember(expr, getSymbolOfNode(member.parent), expr.escapedText);
	                    case 184 /* ElementAccessExpression */:
	                    case 183 /* PropertyAccessExpression */:
	                        var ex = expr;
	                        if (isConstantMemberAccess(ex)) {
	                            var type = getTypeOfExpression(ex.expression);
	                            if (type.symbol && type.symbol.flags & 384 /* Enum */) {
	                                var name = void 0;
	                                if (ex.kind === 183 /* PropertyAccessExpression */) {
	                                    name = ex.name.escapedText;
	                                }
	                                else {
	                                    var argument = ex.argumentExpression;
	                                    ts.Debug.assert(ts.isLiteralExpression(argument));
	                                    name = ts.escapeLeadingUnderscores(argument.text);
	                                }
	                                return evaluateEnumMember(expr, type.symbol, name);
	                            }
	                        }
	                        break;
	                }
	                return undefined;
	            }
	            function evaluateEnumMember(expr, enumSymbol, name) {
	                var memberSymbol = enumSymbol.exports.get(name);
	                if (memberSymbol) {
	                    var declaration = memberSymbol.valueDeclaration;
	                    if (declaration !== member) {
	                        if (isBlockScopedNameDeclaredBeforeUse(declaration, member)) {
	                            return getEnumMemberValue(declaration);
	                        }
	                        error(expr, ts.Diagnostics.A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_members_defined_in_other_enums);
	                        return 0;
	                    }
	                }
	                return undefined;
	            }
	        }
	        function isConstantMemberAccess(node) {
	            return node.kind === 71 /* Identifier */ ||
	                node.kind === 183 /* PropertyAccessExpression */ && isConstantMemberAccess(node.expression) ||
	                node.kind === 184 /* ElementAccessExpression */ && isConstantMemberAccess(node.expression) &&
	                    node.argumentExpression.kind === 9 /* StringLiteral */;
	        }
	        function checkEnumDeclaration(node) {
	            if (!produceDiagnostics) {
	                return;
	            }
	            // Grammar checking
	            checkGrammarDecoratorsAndModifiers(node);
	            checkTypeNameIsReserved(node.name, ts.Diagnostics.Enum_name_cannot_be_0);
	            checkCollisionWithCapturedThisVariable(node, node.name);
	            checkCollisionWithCapturedNewTargetVariable(node, node.name);
	            checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	            checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            checkExportsOnMergedDeclarations(node);
	            computeEnumMemberValues(node);
	            var enumIsConst = ts.isConst(node);
	            if (compilerOptions.isolatedModules && enumIsConst && node.flags & 2097152 /* Ambient */) {
	                error(node.name, ts.Diagnostics.Ambient_const_enums_are_not_allowed_when_the_isolatedModules_flag_is_provided);
	            }
	            // Spec 2014 - Section 9.3:
	            // It isn't possible for one enum declaration to continue the automatic numbering sequence of another,
	            // and when an enum type has multiple declarations, only one declaration is permitted to omit a value
	            // for the first member.
	            //
	            // Only perform this check once per symbol
	            var enumSymbol = getSymbolOfNode(node);
	            var firstDeclaration = ts.getDeclarationOfKind(enumSymbol, node.kind);
	            if (node === firstDeclaration) {
	                if (enumSymbol.declarations.length > 1) {
	                    // check that const is placed\omitted on all enum declarations
	                    ts.forEach(enumSymbol.declarations, function (decl) {
	                        if (ts.isConstEnumDeclaration(decl) !== enumIsConst) {
	                            error(ts.getNameOfDeclaration(decl), ts.Diagnostics.Enum_declarations_must_all_be_const_or_non_const);
	                        }
	                    });
	                }
	                var seenEnumMissingInitialInitializer_1 = false;
	                ts.forEach(enumSymbol.declarations, function (declaration) {
	                    // return true if we hit a violation of the rule, false otherwise
	                    if (declaration.kind !== 236 /* EnumDeclaration */) {
	                        return false;
	                    }
	                    var enumDeclaration = declaration;
	                    if (!enumDeclaration.members.length) {
	                        return false;
	                    }
	                    var firstEnumMember = enumDeclaration.members[0];
	                    if (!firstEnumMember.initializer) {
	                        if (seenEnumMissingInitialInitializer_1) {
	                            error(firstEnumMember.name, ts.Diagnostics.In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enum_element);
	                        }
	                        else {
	                            seenEnumMissingInitialInitializer_1 = true;
	                        }
	                    }
	                });
	            }
	        }
	        function getFirstNonAmbientClassOrFunctionDeclaration(symbol) {
	            var declarations = symbol.declarations;
	            for (var _i = 0, declarations_7 = declarations; _i < declarations_7.length; _i++) {
	                var declaration = declarations_7[_i];
	                if ((declaration.kind === 233 /* ClassDeclaration */ ||
	                    (declaration.kind === 232 /* FunctionDeclaration */ && ts.nodeIsPresent(declaration.body))) &&
	                    !(declaration.flags & 2097152 /* Ambient */)) {
	                    return declaration;
	                }
	            }
	            return undefined;
	        }
	        function inSameLexicalScope(node1, node2) {
	            var container1 = ts.getEnclosingBlockScopeContainer(node1);
	            var container2 = ts.getEnclosingBlockScopeContainer(node2);
	            if (isGlobalSourceFile(container1)) {
	                return isGlobalSourceFile(container2);
	            }
	            else if (isGlobalSourceFile(container2)) {
	                return false;
	            }
	            else {
	                return container1 === container2;
	            }
	        }
	        function checkModuleDeclaration(node) {
	            if (produceDiagnostics) {
	                // Grammar checking
	                var isGlobalAugmentation = ts.isGlobalScopeAugmentation(node);
	                var inAmbientContext = node.flags & 2097152 /* Ambient */;
	                if (isGlobalAugmentation && !inAmbientContext) {
	                    error(node.name, ts.Diagnostics.Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambient_context);
	                }
	                var isAmbientExternalModule = ts.isAmbientModule(node);
	                var contextErrorMessage = isAmbientExternalModule
	                    ? ts.Diagnostics.An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file
	                    : ts.Diagnostics.A_namespace_declaration_is_only_allowed_in_a_namespace_or_module;
	                if (checkGrammarModuleElementContext(node, contextErrorMessage)) {
	                    // If we hit a module declaration in an illegal context, just bail out to avoid cascading errors.
	                    return;
	                }
	                if (!checkGrammarDecoratorsAndModifiers(node)) {
	                    if (!inAmbientContext && node.name.kind === 9 /* StringLiteral */) {
	                        grammarErrorOnNode(node.name, ts.Diagnostics.Only_ambient_modules_can_use_quoted_names);
	                    }
	                }
	                if (ts.isIdentifier(node.name)) {
	                    checkCollisionWithCapturedThisVariable(node, node.name);
	                    checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	                    checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	                }
	                checkExportsOnMergedDeclarations(node);
	                var symbol = getSymbolOfNode(node);
	                // The following checks only apply on a non-ambient instantiated module declaration.
	                if (symbol.flags & 512 /* ValueModule */
	                    && symbol.declarations.length > 1
	                    && !inAmbientContext
	                    && isInstantiatedModule(node, compilerOptions.preserveConstEnums || compilerOptions.isolatedModules)) {
	                    var firstNonAmbientClassOrFunc = getFirstNonAmbientClassOrFunctionDeclaration(symbol);
	                    if (firstNonAmbientClassOrFunc) {
	                        if (ts.getSourceFileOfNode(node) !== ts.getSourceFileOfNode(firstNonAmbientClassOrFunc)) {
	                            error(node.name, ts.Diagnostics.A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merged);
	                        }
	                        else if (node.pos < firstNonAmbientClassOrFunc.pos) {
	                            error(node.name, ts.Diagnostics.A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged);
	                        }
	                    }
	                    // if the module merges with a class declaration in the same lexical scope,
	                    // we need to track this to ensure the correct emit.
	                    var mergedClass = ts.getDeclarationOfKind(symbol, 233 /* ClassDeclaration */);
	                    if (mergedClass &&
	                        inSameLexicalScope(node, mergedClass)) {
	                        getNodeLinks(node).flags |= 32768 /* LexicalModuleMergesWithClass */;
	                    }
	                }
	                if (isAmbientExternalModule) {
	                    if (ts.isExternalModuleAugmentation(node)) {
	                        // body of the augmentation should be checked for consistency only if augmentation was applied to its target (either global scope or module)
	                        // otherwise we'll be swamped in cascading errors.
	                        // We can detect if augmentation was applied using following rules:
	                        // - augmentation for a global scope is always applied
	                        // - augmentation for some external module is applied if symbol for augmentation is merged (it was combined with target module).
	                        var checkBody = isGlobalAugmentation || (getSymbolOfNode(node).flags & 33554432 /* Transient */);
	                        if (checkBody && node.body) {
	                            // body of ambient external module is always a module block
	                            for (var _i = 0, _a = node.body.statements; _i < _a.length; _i++) {
	                                var statement = _a[_i];
	                                checkModuleAugmentationElement(statement, isGlobalAugmentation);
	                            }
	                        }
	                    }
	                    else if (isGlobalSourceFile(node.parent)) {
	                        if (isGlobalAugmentation) {
	                            error(node.name, ts.Diagnostics.Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations);
	                        }
	                        else if (ts.isExternalModuleNameRelative(ts.getTextOfIdentifierOrLiteral(node.name))) {
	                            error(node.name, ts.Diagnostics.Ambient_module_declaration_cannot_specify_relative_module_name);
	                        }
	                    }
	                    else {
	                        if (isGlobalAugmentation) {
	                            error(node.name, ts.Diagnostics.Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations);
	                        }
	                        else {
	                            // Node is not an augmentation and is not located on the script level.
	                            // This means that this is declaration of ambient module that is located in other module or namespace which is prohibited.
	                            error(node.name, ts.Diagnostics.Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces);
	                        }
	                    }
	                }
	            }
	            if (node.body) {
	                checkSourceElement(node.body);
	                if (!ts.isGlobalScopeAugmentation(node)) {
	                    registerForUnusedIdentifiersCheck(node);
	                }
	            }
	        }
	        function checkModuleAugmentationElement(node, isGlobalAugmentation) {
	            switch (node.kind) {
	                case 212 /* VariableStatement */:
	                    // error each individual name in variable statement instead of marking the entire variable statement
	                    for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                        var decl = _a[_i];
	                        checkModuleAugmentationElement(decl, isGlobalAugmentation);
	                    }
	                    break;
	                case 247 /* ExportAssignment */:
	                case 248 /* ExportDeclaration */:
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.Exports_and_export_assignments_are_not_permitted_in_module_augmentations);
	                    break;
	                case 241 /* ImportEqualsDeclaration */:
	                case 242 /* ImportDeclaration */:
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_module);
	                    break;
	                case 180 /* BindingElement */:
	                case 230 /* VariableDeclaration */:
	                    var name = node.name;
	                    if (ts.isBindingPattern(name)) {
	                        for (var _b = 0, _c = name.elements; _b < _c.length; _b++) {
	                            var el = _c[_b];
	                            // mark individual names in binding pattern
	                            checkModuleAugmentationElement(el, isGlobalAugmentation);
	                        }
	                        break;
	                    }
	                // falls through
	                case 233 /* ClassDeclaration */:
	                case 236 /* EnumDeclaration */:
	                case 232 /* FunctionDeclaration */:
	                case 234 /* InterfaceDeclaration */:
	                case 237 /* ModuleDeclaration */:
	                case 235 /* TypeAliasDeclaration */:
	                    if (isGlobalAugmentation) {
	                        return;
	                    }
	                    var symbol = getSymbolOfNode(node);
	                    if (symbol) {
	                        // module augmentations cannot introduce new names on the top level scope of the module
	                        // this is done it two steps
	                        // 1. quick check - if symbol for node is not merged - this is local symbol to this augmentation - report error
	                        // 2. main check - report error if value declaration of the parent symbol is module augmentation)
	                        var reportError = !(symbol.flags & 33554432 /* Transient */);
	                        if (!reportError) {
	                            // symbol should not originate in augmentation
	                            reportError = ts.isExternalModuleAugmentation(symbol.parent.declarations[0]);
	                        }
	                    }
	                    break;
	            }
	        }
	        function getFirstIdentifier(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return node;
	                case 145 /* QualifiedName */:
	                    do {
	                        node = node.left;
	                    } while (node.kind !== 71 /* Identifier */);
	                    return node;
	                case 183 /* PropertyAccessExpression */:
	                    do {
	                        node = node.expression;
	                    } while (node.kind !== 71 /* Identifier */);
	                    return node;
	            }
	        }
	        function checkExternalImportOrExportDeclaration(node) {
	            var moduleName = ts.getExternalModuleName(node);
	            if (ts.nodeIsMissing(moduleName)) {
	                // Should be a parse error.
	                return false;
	            }
	            if (!ts.isStringLiteral(moduleName)) {
	                error(moduleName, ts.Diagnostics.String_literal_expected);
	                return false;
	            }
	            var inAmbientExternalModule = node.parent.kind === 238 /* ModuleBlock */ && ts.isAmbientModule(node.parent.parent);
	            if (node.parent.kind !== 272 /* SourceFile */ && !inAmbientExternalModule) {
	                error(moduleName, node.kind === 248 /* ExportDeclaration */ ?
	                    ts.Diagnostics.Export_declarations_are_not_permitted_in_a_namespace :
	                    ts.Diagnostics.Import_declarations_in_a_namespace_cannot_reference_a_module);
	                return false;
	            }
	            if (inAmbientExternalModule && ts.isExternalModuleNameRelative(moduleName.text)) {
	                // we have already reported errors on top level imports\exports in external module augmentations in checkModuleDeclaration
	                // no need to do this again.
	                if (!isTopLevelInExternalModuleAugmentation(node)) {
	                    // TypeScript 1.0 spec (April 2013): 12.1.6
	                    // An ExternalImportDeclaration in an AmbientExternalModuleDeclaration may reference
	                    // other external modules only through top - level external module names.
	                    // Relative external module names are not permitted.
	                    error(node, ts.Diagnostics.Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relative_module_name);
	                    return false;
	                }
	            }
	            return true;
	        }
	        function checkAliasSymbol(node) {
	            var symbol = getSymbolOfNode(node);
	            var target = resolveAlias(symbol);
	            if (target !== unknownSymbol) {
	                // For external modules symbol represent local symbol for an alias.
	                // This local symbol will merge any other local declarations (excluding other aliases)
	                // and symbol.flags will contains combined representation for all merged declaration.
	                // Based on symbol.flags we can compute a set of excluded meanings (meaning that resolved alias should not have,
	                // otherwise it will conflict with some local declaration). Note that in addition to normal flags we include matching SymbolFlags.Export*
	                // in order to prevent collisions with declarations that were exported from the current module (they still contribute to local names).
	                var excludedMeanings = (symbol.flags & (107455 /* Value */ | 1048576 /* ExportValue */) ? 107455 /* Value */ : 0) |
	                    (symbol.flags & 793064 /* Type */ ? 793064 /* Type */ : 0) |
	                    (symbol.flags & 1920 /* Namespace */ ? 1920 /* Namespace */ : 0);
	                if (target.flags & excludedMeanings) {
	                    var message = node.kind === 250 /* ExportSpecifier */ ?
	                        ts.Diagnostics.Export_declaration_conflicts_with_exported_declaration_of_0 :
	                        ts.Diagnostics.Import_declaration_conflicts_with_local_declaration_of_0;
	                    error(node, message, symbolToString(symbol));
	                }
	                // Don't allow to re-export something with no value side when `--isolatedModules` is set.
	                if (compilerOptions.isolatedModules
	                    && node.kind === 250 /* ExportSpecifier */
	                    && !(target.flags & 107455 /* Value */)
	                    && !(node.flags & 2097152 /* Ambient */)) {
	                    error(node, ts.Diagnostics.Cannot_re_export_a_type_when_the_isolatedModules_flag_is_provided);
	                }
	            }
	        }
	        function checkImportBinding(node) {
	            checkCollisionWithCapturedThisVariable(node, node.name);
	            checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	            checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            checkAliasSymbol(node);
	        }
	        function checkImportDeclaration(node) {
	            if (checkGrammarModuleElementContext(node, ts.Diagnostics.An_import_declaration_can_only_be_used_in_a_namespace_or_module)) {
	                // If we hit an import declaration in an illegal context, just bail out to avoid cascading errors.
	                return;
	            }
	            if (!checkGrammarDecoratorsAndModifiers(node) && ts.hasModifiers(node)) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.An_import_declaration_cannot_have_modifiers);
	            }
	            if (checkExternalImportOrExportDeclaration(node)) {
	                var importClause = node.importClause;
	                if (importClause) {
	                    if (importClause.name) {
	                        checkImportBinding(importClause);
	                    }
	                    if (importClause.namedBindings) {
	                        if (importClause.namedBindings.kind === 244 /* NamespaceImport */) {
	                            checkImportBinding(importClause.namedBindings);
	                        }
	                        else {
	                            ts.forEach(importClause.namedBindings.elements, checkImportBinding);
	                        }
	                    }
	                }
	            }
	        }
	        function checkImportEqualsDeclaration(node) {
	            if (checkGrammarModuleElementContext(node, ts.Diagnostics.An_import_declaration_can_only_be_used_in_a_namespace_or_module)) {
	                // If we hit an import declaration in an illegal context, just bail out to avoid cascading errors.
	                return;
	            }
	            checkGrammarDecoratorsAndModifiers(node);
	            if (ts.isInternalModuleImportEqualsDeclaration(node) || checkExternalImportOrExportDeclaration(node)) {
	                checkImportBinding(node);
	                if (ts.hasModifier(node, 1 /* Export */)) {
	                    markExportAsReferenced(node);
	                }
	                if (node.moduleReference.kind !== 252 /* ExternalModuleReference */) {
	                    var target = resolveAlias(getSymbolOfNode(node));
	                    if (target !== unknownSymbol) {
	                        if (target.flags & 107455 /* Value */) {
	                            // Target is a value symbol, check that it is not hidden by a local declaration with the same name
	                            var moduleName = getFirstIdentifier(node.moduleReference);
	                            if (!(resolveEntityName(moduleName, 107455 /* Value */ | 1920 /* Namespace */).flags & 1920 /* Namespace */)) {
	                                error(moduleName, ts.Diagnostics.Module_0_is_hidden_by_a_local_declaration_with_the_same_name, ts.declarationNameToString(moduleName));
	                            }
	                        }
	                        if (target.flags & 793064 /* Type */) {
	                            checkTypeNameIsReserved(node.name, ts.Diagnostics.Import_name_cannot_be_0);
	                        }
	                    }
	                }
	                else {
	                    if (modulekind >= ts.ModuleKind.ES2015 && !(node.flags & 2097152 /* Ambient */)) {
	                        // Import equals declaration is deprecated in es6 or above
	                        grammarErrorOnNode(node, ts.Diagnostics.Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_ns_from_mod_import_a_from_mod_import_d_from_mod_or_another_module_format_instead);
	                    }
	                }
	            }
	        }
	        function checkExportDeclaration(node) {
	            if (checkGrammarModuleElementContext(node, ts.Diagnostics.An_export_declaration_can_only_be_used_in_a_module)) {
	                // If we hit an export in an illegal context, just bail out to avoid cascading errors.
	                return;
	            }
	            if (!checkGrammarDecoratorsAndModifiers(node) && ts.hasModifiers(node)) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.An_export_declaration_cannot_have_modifiers);
	            }
	            if (!node.moduleSpecifier || checkExternalImportOrExportDeclaration(node)) {
	                if (node.exportClause) {
	                    // export { x, y }
	                    // export { x, y } from "foo"
	                    ts.forEach(node.exportClause.elements, checkExportSpecifier);
	                    var inAmbientExternalModule = node.parent.kind === 238 /* ModuleBlock */ && ts.isAmbientModule(node.parent.parent);
	                    var inAmbientNamespaceDeclaration = !inAmbientExternalModule && node.parent.kind === 238 /* ModuleBlock */ &&
	                        !node.moduleSpecifier && node.flags & 2097152 /* Ambient */;
	                    if (node.parent.kind !== 272 /* SourceFile */ && !inAmbientExternalModule && !inAmbientNamespaceDeclaration) {
	                        error(node, ts.Diagnostics.Export_declarations_are_not_permitted_in_a_namespace);
	                    }
	                }
	                else {
	                    // export * from "foo"
	                    var moduleSymbol = resolveExternalModuleName(node, node.moduleSpecifier);
	                    if (moduleSymbol && hasExportAssignmentSymbol(moduleSymbol)) {
	                        error(node.moduleSpecifier, ts.Diagnostics.Module_0_uses_export_and_cannot_be_used_with_export_Asterisk, symbolToString(moduleSymbol));
	                    }
	                    if (modulekind !== ts.ModuleKind.System && modulekind !== ts.ModuleKind.ES2015 && modulekind !== ts.ModuleKind.ESNext) {
	                        checkExternalEmitHelpers(node, 32768 /* ExportStar */);
	                    }
	                }
	            }
	        }
	        function checkGrammarModuleElementContext(node, errorMessage) {
	            var isInAppropriateContext = node.parent.kind === 272 /* SourceFile */ || node.parent.kind === 238 /* ModuleBlock */ || node.parent.kind === 237 /* ModuleDeclaration */;
	            if (!isInAppropriateContext) {
	                grammarErrorOnFirstToken(node, errorMessage);
	            }
	            return !isInAppropriateContext;
	        }
	        function checkExportSpecifier(node) {
	            checkAliasSymbol(node);
	            if (compilerOptions.declaration) {
	                collectLinkedAliases(node.propertyName || node.name, /*setVisibility*/ true);
	            }
	            if (!node.parent.parent.moduleSpecifier) {
	                var exportedName = node.propertyName || node.name;
	                // find immediate value referenced by exported name (SymbolFlags.Alias is set so we don't chase down aliases)
	                var symbol = resolveName(exportedName, exportedName.escapedText, 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */, 
	                /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ true);
	                if (symbol && (symbol === undefinedSymbol || isGlobalSourceFile(getDeclarationContainer(symbol.declarations[0])))) {
	                    error(exportedName, ts.Diagnostics.Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module, ts.idText(exportedName));
	                }
	                else {
	                    markExportAsReferenced(node);
	                }
	            }
	        }
	        function checkExportAssignment(node) {
	            if (checkGrammarModuleElementContext(node, ts.Diagnostics.An_export_assignment_can_only_be_used_in_a_module)) {
	                // If we hit an export assignment in an illegal context, just bail out to avoid cascading errors.
	                return;
	            }
	            var container = node.parent.kind === 272 /* SourceFile */ ? node.parent : node.parent.parent;
	            if (container.kind === 237 /* ModuleDeclaration */ && !ts.isAmbientModule(container)) {
	                if (node.isExportEquals) {
	                    error(node, ts.Diagnostics.An_export_assignment_cannot_be_used_in_a_namespace);
	                }
	                else {
	                    error(node, ts.Diagnostics.A_default_export_can_only_be_used_in_an_ECMAScript_style_module);
	                }
	                return;
	            }
	            // Grammar checking
	            if (!checkGrammarDecoratorsAndModifiers(node) && ts.hasModifiers(node)) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.An_export_assignment_cannot_have_modifiers);
	            }
	            if (node.expression.kind === 71 /* Identifier */) {
	                markExportAsReferenced(node);
	                if (compilerOptions.declaration) {
	                    collectLinkedAliases(node.expression, /*setVisibility*/ true);
	                }
	            }
	            else {
	                checkExpressionCached(node.expression);
	            }
	            checkExternalModuleExports(container);
	            if ((node.flags & 2097152 /* Ambient */) && !ts.isEntityNameExpression(node.expression)) {
	                grammarErrorOnNode(node.expression, ts.Diagnostics.The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context);
	            }
	            if (node.isExportEquals && !(node.flags & 2097152 /* Ambient */)) {
	                if (modulekind >= ts.ModuleKind.ES2015) {
	                    // export assignment is not supported in es6 modules
	                    grammarErrorOnNode(node, ts.Diagnostics.Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or_another_module_format_instead);
	                }
	                else if (modulekind === ts.ModuleKind.System) {
	                    // system modules does not support export assignment
	                    grammarErrorOnNode(node, ts.Diagnostics.Export_assignment_is_not_supported_when_module_flag_is_system);
	                }
	            }
	        }
	        function hasExportedMembers(moduleSymbol) {
	            return ts.forEachEntry(moduleSymbol.exports, function (_, id) { return id !== "export="; });
	        }
	        function checkExternalModuleExports(node) {
	            var moduleSymbol = getSymbolOfNode(node);
	            var links = getSymbolLinks(moduleSymbol);
	            if (!links.exportsChecked) {
	                var exportEqualsSymbol = moduleSymbol.exports.get("export=");
	                if (exportEqualsSymbol && hasExportedMembers(moduleSymbol)) {
	                    var declaration = getDeclarationOfAliasSymbol(exportEqualsSymbol) || exportEqualsSymbol.valueDeclaration;
	                    if (!isTopLevelInExternalModuleAugmentation(declaration)) {
	                        error(declaration, ts.Diagnostics.An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements);
	                    }
	                }
	                // Checks for export * conflicts
	                var exports = getExportsOfModule(moduleSymbol);
	                if (exports) {
	                    exports.forEach(function (_a, id) {
	                        var declarations = _a.declarations, flags = _a.flags;
	                        if (id === "__export") {
	                            return;
	                        }
	                        // ECMA262: 15.2.1.1 It is a Syntax Error if the ExportedNames of ModuleItemList contains any duplicate entries.
	                        // (TS Exceptions: namespaces, function overloads, enums, and interfaces)
	                        if (flags & (1920 /* Namespace */ | 64 /* Interface */ | 384 /* Enum */)) {
	                            return;
	                        }
	                        var exportedDeclarationsCount = ts.countWhere(declarations, isNotOverloadAndNotAccessor);
	                        if (flags & 524288 /* TypeAlias */ && exportedDeclarationsCount <= 2) {
	                            // it is legal to merge type alias with other values
	                            // so count should be either 1 (just type alias) or 2 (type alias + merged value)
	                            return;
	                        }
	                        if (exportedDeclarationsCount > 1) {
	                            for (var _i = 0, declarations_8 = declarations; _i < declarations_8.length; _i++) {
	                                var declaration = declarations_8[_i];
	                                if (isNotOverload(declaration)) {
	                                    diagnostics.add(ts.createDiagnosticForNode(declaration, ts.Diagnostics.Cannot_redeclare_exported_variable_0, ts.unescapeLeadingUnderscores(id)));
	                                }
	                            }
	                        }
	                    });
	                }
	                links.exportsChecked = true;
	            }
	        }
	        function isNotAccessor(declaration) {
	            // Accessors check for their own matching duplicates, and in contexts where they are valid, there are already duplicate identifier checks
	            return !ts.isAccessor(declaration);
	        }
	        function isNotOverload(declaration) {
	            return (declaration.kind !== 232 /* FunctionDeclaration */ && declaration.kind !== 153 /* MethodDeclaration */) ||
	                !!declaration.body;
	        }
	        function checkSourceElement(node) {
	            if (!node) {
	                return;
	            }
	            if (ts.isInJavaScriptFile(node) && node.jsDoc) {
	                for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                    var tags = _a[_i].tags;
	                    ts.forEach(tags, checkSourceElement);
	                }
	            }
	            var kind = node.kind;
	            if (cancellationToken) {
	                // Only bother checking on a few construct kinds.  We don't want to be excessively
	                // hitting the cancellation token on every node we check.
	                switch (kind) {
	                    case 237 /* ModuleDeclaration */:
	                    case 233 /* ClassDeclaration */:
	                    case 234 /* InterfaceDeclaration */:
	                    case 232 /* FunctionDeclaration */:
	                        cancellationToken.throwIfCancellationRequested();
	                }
	            }
	            switch (kind) {
	                case 147 /* TypeParameter */:
	                    return checkTypeParameter(node);
	                case 148 /* Parameter */:
	                    return checkParameter(node);
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return checkPropertyDeclaration(node);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                    return checkSignatureDeclaration(node);
	                case 159 /* IndexSignature */:
	                    return checkSignatureDeclaration(node);
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    return checkMethodDeclaration(node);
	                case 154 /* Constructor */:
	                    return checkConstructorDeclaration(node);
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return checkAccessorDeclaration(node);
	                case 161 /* TypeReference */:
	                    return checkTypeReferenceNode(node);
	                case 160 /* TypePredicate */:
	                    return checkTypePredicate(node);
	                case 164 /* TypeQuery */:
	                    return checkTypeQuery(node);
	                case 165 /* TypeLiteral */:
	                    return checkTypeLiteral(node);
	                case 166 /* ArrayType */:
	                    return checkArrayType(node);
	                case 167 /* TupleType */:
	                    return checkTupleType(node);
	                case 168 /* UnionType */:
	                case 169 /* IntersectionType */:
	                    return checkUnionOrIntersectionType(node);
	                case 172 /* ParenthesizedType */:
	                    return checkSourceElement(node.type);
	                case 174 /* TypeOperator */:
	                    return checkTypeOperator(node);
	                case 170 /* ConditionalType */:
	                    return checkConditionalType(node);
	                case 171 /* InferType */:
	                    return checkInferType(node);
	                case 285 /* JSDocAugmentsTag */:
	                    return checkJSDocAugmentsTag(node);
	                case 291 /* JSDocTypedefTag */:
	                    return checkJSDocTypedefTag(node);
	                case 287 /* JSDocParameterTag */:
	                    return checkJSDocParameterTag(node);
	                case 280 /* JSDocFunctionType */:
	                    checkSignatureDeclaration(node);
	                // falls through
	                case 278 /* JSDocNonNullableType */:
	                case 277 /* JSDocNullableType */:
	                case 275 /* JSDocAllType */:
	                case 276 /* JSDocUnknownType */:
	                    checkJSDocTypeIsInJsFile(node);
	                    ts.forEachChild(node, checkSourceElement);
	                    return;
	                case 281 /* JSDocVariadicType */:
	                    checkJSDocVariadicType(node);
	                    return;
	                case 274 /* JSDocTypeExpression */:
	                    return checkSourceElement(node.type);
	                case 175 /* IndexedAccessType */:
	                    return checkIndexedAccessType(node);
	                case 176 /* MappedType */:
	                    return checkMappedType(node);
	                case 232 /* FunctionDeclaration */:
	                    return checkFunctionDeclaration(node);
	                case 211 /* Block */:
	                case 238 /* ModuleBlock */:
	                    return checkBlock(node);
	                case 212 /* VariableStatement */:
	                    return checkVariableStatement(node);
	                case 214 /* ExpressionStatement */:
	                    return checkExpressionStatement(node);
	                case 215 /* IfStatement */:
	                    return checkIfStatement(node);
	                case 216 /* DoStatement */:
	                    return checkDoStatement(node);
	                case 217 /* WhileStatement */:
	                    return checkWhileStatement(node);
	                case 218 /* ForStatement */:
	                    return checkForStatement(node);
	                case 219 /* ForInStatement */:
	                    return checkForInStatement(node);
	                case 220 /* ForOfStatement */:
	                    return checkForOfStatement(node);
	                case 221 /* ContinueStatement */:
	                case 222 /* BreakStatement */:
	                    return checkBreakOrContinueStatement(node);
	                case 223 /* ReturnStatement */:
	                    return checkReturnStatement(node);
	                case 224 /* WithStatement */:
	                    return checkWithStatement(node);
	                case 225 /* SwitchStatement */:
	                    return checkSwitchStatement(node);
	                case 226 /* LabeledStatement */:
	                    return checkLabeledStatement(node);
	                case 227 /* ThrowStatement */:
	                    return checkThrowStatement(node);
	                case 228 /* TryStatement */:
	                    return checkTryStatement(node);
	                case 230 /* VariableDeclaration */:
	                    return checkVariableDeclaration(node);
	                case 180 /* BindingElement */:
	                    return checkBindingElement(node);
	                case 233 /* ClassDeclaration */:
	                    return checkClassDeclaration(node);
	                case 234 /* InterfaceDeclaration */:
	                    return checkInterfaceDeclaration(node);
	                case 235 /* TypeAliasDeclaration */:
	                    return checkTypeAliasDeclaration(node);
	                case 236 /* EnumDeclaration */:
	                    return checkEnumDeclaration(node);
	                case 237 /* ModuleDeclaration */:
	                    return checkModuleDeclaration(node);
	                case 242 /* ImportDeclaration */:
	                    return checkImportDeclaration(node);
	                case 241 /* ImportEqualsDeclaration */:
	                    return checkImportEqualsDeclaration(node);
	                case 248 /* ExportDeclaration */:
	                    return checkExportDeclaration(node);
	                case 247 /* ExportAssignment */:
	                    return checkExportAssignment(node);
	                case 213 /* EmptyStatement */:
	                    checkGrammarStatementInAmbientContext(node);
	                    return;
	                case 229 /* DebuggerStatement */:
	                    checkGrammarStatementInAmbientContext(node);
	                    return;
	                case 251 /* MissingDeclaration */:
	                    return checkMissingDeclaration(node);
	            }
	        }
	        function checkJSDocTypeIsInJsFile(node) {
	            if (!ts.isInJavaScriptFile(node)) {
	                grammarErrorOnNode(node, ts.Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments);
	            }
	        }
	        function checkJSDocVariadicType(node) {
	            checkJSDocTypeIsInJsFile(node);
	            checkSourceElement(node.type);
	            // Only legal location is in the *last* parameter tag.
	            var parent = node.parent;
	            if (!ts.isJSDocTypeExpression(parent)) {
	                error(node, ts.Diagnostics.JSDoc_may_only_appear_in_the_last_parameter_of_a_signature);
	            }
	            var paramTag = parent.parent;
	            if (!ts.isJSDocParameterTag(paramTag)) {
	                error(node, ts.Diagnostics.JSDoc_may_only_appear_in_the_last_parameter_of_a_signature);
	                return;
	            }
	            var param = ts.getParameterSymbolFromJSDoc(paramTag);
	            if (!param) {
	                // We will error in `checkJSDocParameterTag`.
	                return;
	            }
	            var host = ts.getHostSignatureFromJSDoc(paramTag);
	            if (!host || ts.last(host.parameters).symbol !== param) {
	                error(node, ts.Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
	            }
	        }
	        function getTypeFromJSDocVariadicType(node) {
	            var type = getTypeFromTypeNode(node.type);
	            var parent = node.parent;
	            var paramTag = parent.parent;
	            if (ts.isJSDocTypeExpression(parent) && ts.isJSDocParameterTag(paramTag)) {
	                // Else we will add a diagnostic, see `checkJSDocVariadicType`.
	                var param = ts.getParameterSymbolFromJSDoc(paramTag);
	                if (param) {
	                    var host_1 = ts.getHostSignatureFromJSDoc(paramTag);
	                    /*
	                    Only return an array type if the corresponding parameter is marked as a rest parameter.
	                    So in the following situation we will not create an array type:
	                        /** @param {...number} a * /
	                        function f(a) {}
	                    Because `a` will just be of type `number | undefined`. A synthetic `...args` will also be added, which *will* get an array type.
	                    */
	                    var lastParamDeclaration = host_1 && ts.last(host_1.parameters);
	                    if (lastParamDeclaration.symbol === param && ts.isRestParameter(lastParamDeclaration)) {
	                        return createArrayType(type);
	                    }
	                }
	            }
	            return addOptionality(type);
	        }
	        // Function and class expression bodies are checked after all statements in the enclosing body. This is
	        // to ensure constructs like the following are permitted:
	        //     const foo = function () {
	        //        const s = foo();
	        //        return "hello";
	        //     }
	        // Here, performing a full type check of the body of the function expression whilst in the process of
	        // determining the type of foo would cause foo to be given type any because of the recursive reference.
	        // Delaying the type check of the body ensures foo has been assigned a type.
	        function checkNodeDeferred(node) {
	            if (deferredNodes) {
	                deferredNodes.push(node);
	            }
	        }
	        function checkDeferredNodes() {
	            for (var _i = 0, deferredNodes_1 = deferredNodes; _i < deferredNodes_1.length; _i++) {
	                var node = deferredNodes_1[_i];
	                switch (node.kind) {
	                    case 190 /* FunctionExpression */:
	                    case 191 /* ArrowFunction */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        checkFunctionExpressionOrObjectLiteralMethodDeferred(node);
	                        break;
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        checkAccessorDeclaration(node);
	                        break;
	                    case 203 /* ClassExpression */:
	                        checkClassExpressionDeferred(node);
	                        break;
	                }
	            }
	        }
	        function checkSourceFile(node) {
	            ts.performance.mark("beforeCheck");
	            checkSourceFileWorker(node);
	            ts.performance.mark("afterCheck");
	            ts.performance.measure("Check", "beforeCheck", "afterCheck");
	        }
	        // Fully type check a source file and collect the relevant diagnostics.
	        function checkSourceFileWorker(node) {
	            var links = getNodeLinks(node);
	            if (!(links.flags & 1 /* TypeChecked */)) {
	                // If skipLibCheck is enabled, skip type checking if file is a declaration file.
	                // If skipDefaultLibCheck is enabled, skip type checking if file contains a
	                // '/// <reference no-default-lib="true"/>' directive.
	                if (compilerOptions.skipLibCheck && node.isDeclarationFile || compilerOptions.skipDefaultLibCheck && node.hasNoDefaultLib) {
	                    return;
	                }
	                // Grammar checking
	                checkGrammarSourceFile(node);
	                ts.clear(potentialThisCollisions);
	                ts.clear(potentialNewTargetCollisions);
	                deferredNodes = [];
	                deferredUnusedIdentifierNodes = produceDiagnostics && noUnusedIdentifiers ? [] : undefined;
	                flowAnalysisDisabled = false;
	                ts.forEach(node.statements, checkSourceElement);
	                checkDeferredNodes();
	                if (ts.isExternalOrCommonJsModule(node)) {
	                    registerForUnusedIdentifiersCheck(node);
	                }
	                if (!node.isDeclarationFile) {
	                    checkUnusedIdentifiers();
	                }
	                deferredNodes = undefined;
	                deferredUnusedIdentifierNodes = undefined;
	                if (ts.isExternalOrCommonJsModule(node)) {
	                    checkExternalModuleExports(node);
	                }
	                if (potentialThisCollisions.length) {
	                    ts.forEach(potentialThisCollisions, checkIfThisIsCapturedInEnclosingScope);
	                    ts.clear(potentialThisCollisions);
	                }
	                if (potentialNewTargetCollisions.length) {
	                    ts.forEach(potentialNewTargetCollisions, checkIfNewTargetIsCapturedInEnclosingScope);
	                    ts.clear(potentialNewTargetCollisions);
	                }
	                links.flags |= 1 /* TypeChecked */;
	            }
	        }
	        function getDiagnostics(sourceFile, ct) {
	            try {
	                // Record the cancellation token so it can be checked later on during checkSourceElement.
	                // Do this in a finally block so we can ensure that it gets reset back to nothing after
	                // this call is done.
	                cancellationToken = ct;
	                return getDiagnosticsWorker(sourceFile);
	            }
	            finally {
	                cancellationToken = undefined;
	            }
	        }
	        function getDiagnosticsWorker(sourceFile) {
	            throwIfNonDiagnosticsProducing();
	            if (sourceFile) {
	                // Some global diagnostics are deferred until they are needed and
	                // may not be reported in the firt call to getGlobalDiagnostics.
	                // We should catch these changes and report them.
	                var previousGlobalDiagnostics = diagnostics.getGlobalDiagnostics();
	                var previousGlobalDiagnosticsSize = previousGlobalDiagnostics.length;
	                checkSourceFile(sourceFile);
	                var semanticDiagnostics = diagnostics.getDiagnostics(sourceFile.fileName);
	                var currentGlobalDiagnostics = diagnostics.getGlobalDiagnostics();
	                if (currentGlobalDiagnostics !== previousGlobalDiagnostics) {
	                    // If the arrays are not the same reference, new diagnostics were added.
	                    var deferredGlobalDiagnostics = ts.relativeComplement(previousGlobalDiagnostics, currentGlobalDiagnostics, ts.compareDiagnostics);
	                    return ts.concatenate(deferredGlobalDiagnostics, semanticDiagnostics);
	                }
	                else if (previousGlobalDiagnosticsSize === 0 && currentGlobalDiagnostics.length > 0) {
	                    // If the arrays are the same reference, but the length has changed, a single
	                    // new diagnostic was added as DiagnosticCollection attempts to reuse the
	                    // same array.
	                    return ts.concatenate(currentGlobalDiagnostics, semanticDiagnostics);
	                }
	                return semanticDiagnostics;
	            }
	            // Global diagnostics are always added when a file is not provided to
	            // getDiagnostics
	            ts.forEach(host.getSourceFiles(), checkSourceFile);
	            return diagnostics.getDiagnostics();
	        }
	        function getGlobalDiagnostics() {
	            throwIfNonDiagnosticsProducing();
	            return diagnostics.getGlobalDiagnostics();
	        }
	        function throwIfNonDiagnosticsProducing() {
	            if (!produceDiagnostics) {
	                throw new Error("Trying to get diagnostics from a type checker that does not produce them.");
	            }
	        }
	        // Language service support
	        function getSymbolsInScope(location, meaning) {
	            if (location.flags & 4194304 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return [];
	            }
	            var symbols = ts.createSymbolTable();
	            var isStatic = false;
	            populateSymbols();
	            return symbolsToArray(symbols);
	            function populateSymbols() {
	                while (location) {
	                    if (location.locals && !isGlobalSourceFile(location)) {
	                        copySymbols(location.locals, meaning);
	                    }
	                    switch (location.kind) {
	                        case 237 /* ModuleDeclaration */:
	                            copySymbols(getSymbolOfNode(location).exports, meaning & 2623475 /* ModuleMember */);
	                            break;
	                        case 236 /* EnumDeclaration */:
	                            copySymbols(getSymbolOfNode(location).exports, meaning & 8 /* EnumMember */);
	                            break;
	                        case 203 /* ClassExpression */:
	                            var className = location.name;
	                            if (className) {
	                                copySymbol(location.symbol, meaning);
	                            }
	                        // falls through
	                        // this fall-through is necessary because we would like to handle
	                        // type parameter inside class expression similar to how we handle it in classDeclaration and interface Declaration
	                        case 233 /* ClassDeclaration */:
	                        case 234 /* InterfaceDeclaration */:
	                            // If we didn't come from static member of class or interface,
	                            // add the type parameters into the symbol table
	                            // (type parameters of classDeclaration/classExpression and interface are in member property of the symbol.
	                            // Note: that the memberFlags come from previous iteration.
	                            if (!isStatic) {
	                                copySymbols(getMembersOfSymbol(getSymbolOfNode(location)), meaning & 793064 /* Type */);
	                            }
	                            break;
	                        case 190 /* FunctionExpression */:
	                            var funcName = location.name;
	                            if (funcName) {
	                                copySymbol(location.symbol, meaning);
	                            }
	                            break;
	                    }
	                    if (ts.introducesArgumentsExoticObject(location)) {
	                        copySymbol(argumentsSymbol, meaning);
	                    }
	                    isStatic = ts.hasModifier(location, 32 /* Static */);
	                    location = location.parent;
	                }
	                copySymbols(globals, meaning);
	            }
	            /**
	             * Copy the given symbol into symbol tables if the symbol has the given meaning
	             * and it doesn't already existed in the symbol table
	             * @param key a key for storing in symbol table; if undefined, use symbol.name
	             * @param symbol the symbol to be added into symbol table
	             * @param meaning meaning of symbol to filter by before adding to symbol table
	             */
	            function copySymbol(symbol, meaning) {
	                if (ts.getCombinedLocalAndExportSymbolFlags(symbol) & meaning) {
	                    var id = symbol.escapedName;
	                    // We will copy all symbol regardless of its reserved name because
	                    // symbolsToArray will check whether the key is a reserved name and
	                    // it will not copy symbol with reserved name to the array
	                    if (!symbols.has(id)) {
	                        symbols.set(id, symbol);
	                    }
	                }
	            }
	            function copySymbols(source, meaning) {
	                if (meaning) {
	                    source.forEach(function (symbol) {
	                        copySymbol(symbol, meaning);
	                    });
	                }
	            }
	        }
	        function isTypeDeclarationName(name) {
	            return name.kind === 71 /* Identifier */ &&
	                isTypeDeclaration(name.parent) &&
	                name.parent.name === name;
	        }
	        function isTypeDeclaration(node) {
	            switch (node.kind) {
	                case 147 /* TypeParameter */:
	                case 233 /* ClassDeclaration */:
	                case 234 /* InterfaceDeclaration */:
	                case 235 /* TypeAliasDeclaration */:
	                case 236 /* EnumDeclaration */:
	                    return true;
	            }
	        }
	        // True if the given identifier is part of a type reference
	        function isTypeReferenceIdentifier(entityName) {
	            var node = entityName;
	            while (node.parent && node.parent.kind === 145 /* QualifiedName */) {
	                node = node.parent;
	            }
	            return node.parent && node.parent.kind === 161 /* TypeReference */;
	        }
	        function isHeritageClauseElementIdentifier(entityName) {
	            var node = entityName;
	            while (node.parent && node.parent.kind === 183 /* PropertyAccessExpression */) {
	                node = node.parent;
	            }
	            return node.parent && node.parent.kind === 205 /* ExpressionWithTypeArguments */;
	        }
	        function forEachEnclosingClass(node, callback) {
	            var result;
	            while (true) {
	                node = ts.getContainingClass(node);
	                if (!node)
	                    break;
	                if (result = callback(node))
	                    break;
	            }
	            return result;
	        }
	        function isNodeWithinConstructorOfClass(node, classDeclaration) {
	            return ts.findAncestor(node, function (element) {
	                if (ts.isConstructorDeclaration(element) && ts.nodeIsPresent(element.body) && element.parent === classDeclaration) {
	                    return true;
	                }
	                else if (element === classDeclaration || ts.isFunctionLikeDeclaration(element)) {
	                    return "quit";
	                }
	                return false;
	            });
	        }
	        function isNodeWithinClass(node, classDeclaration) {
	            return !!forEachEnclosingClass(node, function (n) { return n === classDeclaration; });
	        }
	        function getLeftSideOfImportEqualsOrExportAssignment(nodeOnRightSide) {
	            while (nodeOnRightSide.parent.kind === 145 /* QualifiedName */) {
	                nodeOnRightSide = nodeOnRightSide.parent;
	            }
	            if (nodeOnRightSide.parent.kind === 241 /* ImportEqualsDeclaration */) {
	                return nodeOnRightSide.parent.moduleReference === nodeOnRightSide && nodeOnRightSide.parent;
	            }
	            if (nodeOnRightSide.parent.kind === 247 /* ExportAssignment */) {
	                return nodeOnRightSide.parent.expression === nodeOnRightSide && nodeOnRightSide.parent;
	            }
	            return undefined;
	        }
	        function isInRightSideOfImportOrExportAssignment(node) {
	            return getLeftSideOfImportEqualsOrExportAssignment(node) !== undefined;
	        }
	        function getSpecialPropertyAssignmentSymbolFromEntityName(entityName) {
	            var specialPropertyAssignmentKind = ts.getSpecialPropertyAssignmentKind(entityName.parent.parent);
	            switch (specialPropertyAssignmentKind) {
	                case 1 /* ExportsProperty */:
	                case 3 /* PrototypeProperty */:
	                    return getSymbolOfNode(entityName.parent);
	                case 4 /* ThisProperty */:
	                case 2 /* ModuleExports */:
	                case 5 /* Property */:
	                    return getSymbolOfNode(entityName.parent.parent);
	            }
	        }
	        function getSymbolOfEntityNameOrPropertyAccessExpression(entityName) {
	            if (ts.isDeclarationName(entityName)) {
	                return getSymbolOfNode(entityName.parent);
	            }
	            if (ts.isInJavaScriptFile(entityName) &&
	                entityName.parent.kind === 183 /* PropertyAccessExpression */ &&
	                entityName.parent === entityName.parent.parent.left) {
	                // Check if this is a special property assignment
	                var specialPropertyAssignmentSymbol = getSpecialPropertyAssignmentSymbolFromEntityName(entityName);
	                if (specialPropertyAssignmentSymbol) {
	                    return specialPropertyAssignmentSymbol;
	                }
	            }
	            if (entityName.parent.kind === 247 /* ExportAssignment */ && ts.isEntityNameExpression(entityName)) {
	                return resolveEntityName(entityName, 
	                /*all meanings*/ 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */);
	            }
	            if (entityName.kind !== 183 /* PropertyAccessExpression */ && isInRightSideOfImportOrExportAssignment(entityName)) {
	                // Since we already checked for ExportAssignment, this really could only be an Import
	                var importEqualsDeclaration = ts.getAncestor(entityName, 241 /* ImportEqualsDeclaration */);
	                ts.Debug.assert(importEqualsDeclaration !== undefined);
	                return getSymbolOfPartOfRightHandSideOfImportEquals(entityName, /*dontResolveAlias*/ true);
	            }
	            if (ts.isRightSideOfQualifiedNameOrPropertyAccess(entityName)) {
	                entityName = entityName.parent;
	            }
	            if (isHeritageClauseElementIdentifier(entityName)) {
	                var meaning = 0 /* None */;
	                // In an interface or class, we're definitely interested in a type.
	                if (entityName.parent.kind === 205 /* ExpressionWithTypeArguments */) {
	                    meaning = 793064 /* Type */;
	                    // In a class 'extends' clause we are also looking for a value.
	                    if (ts.isExpressionWithTypeArgumentsInClassExtendsClause(entityName.parent)) {
	                        meaning |= 107455 /* Value */;
	                    }
	                }
	                else {
	                    meaning = 1920 /* Namespace */;
	                }
	                meaning |= 2097152 /* Alias */;
	                var entityNameSymbol = ts.isEntityNameExpression(entityName) ? resolveEntityName(entityName, meaning) : undefined;
	                if (entityNameSymbol) {
	                    return entityNameSymbol;
	                }
	            }
	            if (entityName.parent.kind === 287 /* JSDocParameterTag */) {
	                return ts.getParameterSymbolFromJSDoc(entityName.parent);
	            }
	            if (entityName.parent.kind === 147 /* TypeParameter */ && entityName.parent.parent.kind === 290 /* JSDocTemplateTag */) {
	                ts.Debug.assert(!ts.isInJavaScriptFile(entityName)); // Otherwise `isDeclarationName` would have been true.
	                var typeParameter = ts.getTypeParameterFromJsDoc(entityName.parent);
	                return typeParameter && typeParameter.symbol;
	            }
	            if (ts.isExpressionNode(entityName)) {
	                if (ts.nodeIsMissing(entityName)) {
	                    // Missing entity name.
	                    return undefined;
	                }
	                if (entityName.kind === 71 /* Identifier */) {
	                    if (ts.isJSXTagName(entityName) && isJsxIntrinsicIdentifier(entityName)) {
	                        var symbol = getIntrinsicTagSymbol(entityName.parent);
	                        return symbol === unknownSymbol ? undefined : symbol;
	                    }
	                    return resolveEntityName(entityName, 107455 /* Value */, /*ignoreErrors*/ false, /*dontResolveAlias*/ true);
	                }
	                else if (entityName.kind === 183 /* PropertyAccessExpression */ || entityName.kind === 145 /* QualifiedName */) {
	                    var links = getNodeLinks(entityName);
	                    if (links.resolvedSymbol) {
	                        return links.resolvedSymbol;
	                    }
	                    if (entityName.kind === 183 /* PropertyAccessExpression */) {
	                        checkPropertyAccessExpression(entityName);
	                    }
	                    else {
	                        checkQualifiedName(entityName);
	                    }
	                    return links.resolvedSymbol;
	                }
	            }
	            else if (isTypeReferenceIdentifier(entityName)) {
	                var meaning = entityName.parent.kind === 161 /* TypeReference */ ? 793064 /* Type */ : 1920 /* Namespace */;
	                return resolveEntityName(entityName, meaning, /*ignoreErrors*/ false, /*dontResolveAlias*/ true);
	            }
	            else if (entityName.parent.kind === 260 /* JsxAttribute */) {
	                return getJsxAttributePropertySymbol(entityName.parent);
	            }
	            if (entityName.parent.kind === 160 /* TypePredicate */) {
	                return resolveEntityName(entityName, /*meaning*/ 1 /* FunctionScopedVariable */);
	            }
	            // Do we want to return undefined here?
	            return undefined;
	        }
	        function getSymbolAtLocation(node) {
	            if (node.kind === 272 /* SourceFile */) {
	                return ts.isExternalModule(node) ? getMergedSymbol(node.symbol) : undefined;
	            }
	            if (node.flags & 4194304 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return undefined;
	            }
	            if (isDeclarationNameOrImportPropertyName(node)) {
	                // This is a declaration, call getSymbolOfNode
	                return getSymbolOfNode(node.parent);
	            }
	            else if (ts.isLiteralComputedPropertyDeclarationName(node)) {
	                return getSymbolOfNode(node.parent.parent);
	            }
	            if (node.kind === 71 /* Identifier */) {
	                if (isInRightSideOfImportOrExportAssignment(node)) {
	                    return getSymbolOfEntityNameOrPropertyAccessExpression(node);
	                }
	                else if (node.parent.kind === 180 /* BindingElement */ &&
	                    node.parent.parent.kind === 178 /* ObjectBindingPattern */ &&
	                    node === node.parent.propertyName) {
	                    var typeOfPattern = getTypeOfNode(node.parent.parent);
	                    var propertyDeclaration = typeOfPattern && getPropertyOfType(typeOfPattern, node.escapedText);
	                    if (propertyDeclaration) {
	                        return propertyDeclaration;
	                    }
	                }
	            }
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                case 183 /* PropertyAccessExpression */:
	                case 145 /* QualifiedName */:
	                    return getSymbolOfEntityNameOrPropertyAccessExpression(node);
	                case 99 /* ThisKeyword */:
	                    var container = ts.getThisContainer(node, /*includeArrowFunctions*/ false);
	                    if (ts.isFunctionLike(container)) {
	                        var sig = getSignatureFromDeclaration(container);
	                        if (sig.thisParameter) {
	                            return sig.thisParameter;
	                        }
	                    }
	                    if (ts.isInExpressionContext(node)) {
	                        return checkExpression(node).symbol;
	                    }
	                // falls through
	                case 173 /* ThisType */:
	                    return getTypeFromThisTypeNode(node).symbol;
	                case 97 /* SuperKeyword */:
	                    return checkExpression(node).symbol;
	                case 123 /* ConstructorKeyword */:
	                    // constructor keyword for an overload, should take us to the definition if it exist
	                    var constructorDeclaration = node.parent;
	                    if (constructorDeclaration && constructorDeclaration.kind === 154 /* Constructor */) {
	                        return constructorDeclaration.parent.symbol;
	                    }
	                    return undefined;
	                case 9 /* StringLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                    // 1). import x = require("./mo/*gotToDefinitionHere*/d")
	                    // 2). External module name in an import declaration
	                    // 3). Dynamic import call or require in javascript
	                    if ((ts.isExternalModuleImportEqualsDeclaration(node.parent.parent) && ts.getExternalModuleImportEqualsDeclarationExpression(node.parent.parent) === node) ||
	                        ((node.parent.kind === 242 /* ImportDeclaration */ || node.parent.kind === 248 /* ExportDeclaration */) && node.parent.moduleSpecifier === node) ||
	                        ((ts.isInJavaScriptFile(node) && ts.isRequireCall(node.parent, /*checkArgumentIsStringLiteral*/ false)) || ts.isImportCall(node.parent))) {
	                        return resolveExternalModuleName(node, node);
	                    }
	                // falls through
	                case 8 /* NumericLiteral */:
	                    // index access
	                    var objectType = ts.isElementAccessExpression(node.parent)
	                        ? node.parent.argumentExpression === node ? getTypeOfExpression(node.parent.expression) : undefined
	                        : ts.isLiteralTypeNode(node.parent) && ts.isIndexedAccessTypeNode(node.parent.parent)
	                            ? getTypeFromTypeNode(node.parent.parent.objectType)
	                            : undefined;
	                    return objectType && getPropertyOfType(objectType, ts.escapeLeadingUnderscores(node.text));
	                case 79 /* DefaultKeyword */:
	                case 89 /* FunctionKeyword */:
	                case 36 /* EqualsGreaterThanToken */:
	                    return getSymbolOfNode(node.parent);
	                default:
	                    return undefined;
	            }
	        }
	        function getShorthandAssignmentValueSymbol(location) {
	            // The function returns a value symbol of an identifier in the short-hand property assignment.
	            // This is necessary as an identifier in short-hand property assignment can contains two meaning:
	            // property name and property value.
	            if (location && location.kind === 269 /* ShorthandPropertyAssignment */) {
	                return resolveEntityName(location.name, 107455 /* Value */ | 2097152 /* Alias */);
	            }
	            return undefined;
	        }
	        /** Returns the target of an export specifier without following aliases */
	        function getExportSpecifierLocalTargetSymbol(node) {
	            return node.parent.parent.moduleSpecifier ?
	                getExternalModuleMember(node.parent.parent, node) :
	                resolveEntityName(node.propertyName || node.name, 107455 /* Value */ | 793064 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */);
	        }
	        function getTypeOfNode(node) {
	            if (node.flags & 4194304 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return unknownType;
	            }
	            if (ts.isPartOfTypeNode(node)) {
	                var typeFromTypeNode = getTypeFromTypeNode(node);
	                if (typeFromTypeNode && ts.isExpressionWithTypeArgumentsInClassImplementsClause(node)) {
	                    var containingClass = ts.getContainingClass(node);
	                    var classType = getTypeOfNode(containingClass);
	                    typeFromTypeNode = getTypeWithThisArgument(typeFromTypeNode, classType.thisType);
	                }
	                return typeFromTypeNode;
	            }
	            if (ts.isExpressionNode(node)) {
	                return getRegularTypeOfExpression(node);
	            }
	            if (ts.isExpressionWithTypeArgumentsInClassExtendsClause(node)) {
	                // A SyntaxKind.ExpressionWithTypeArguments is considered a type node, except when it occurs in the
	                // extends clause of a class. We handle that case here.
	                var classNode = ts.getContainingClass(node);
	                var classType = getDeclaredTypeOfSymbol(getSymbolOfNode(classNode));
	                var baseType = getBaseTypes(classType)[0];
	                return baseType && getTypeWithThisArgument(baseType, classType.thisType);
	            }
	            if (isTypeDeclaration(node)) {
	                // In this case, we call getSymbolOfNode instead of getSymbolAtLocation because it is a declaration
	                var symbol = getSymbolOfNode(node);
	                return getDeclaredTypeOfSymbol(symbol);
	            }
	            if (isTypeDeclarationName(node)) {
	                var symbol = getSymbolAtLocation(node);
	                return symbol && getDeclaredTypeOfSymbol(symbol);
	            }
	            if (ts.isDeclaration(node)) {
	                // In this case, we call getSymbolOfNode instead of getSymbolAtLocation because it is a declaration
	                var symbol = getSymbolOfNode(node);
	                return getTypeOfSymbol(symbol);
	            }
	            if (isDeclarationNameOrImportPropertyName(node)) {
	                var symbol = getSymbolAtLocation(node);
	                return symbol && getTypeOfSymbol(symbol);
	            }
	            if (ts.isBindingPattern(node)) {
	                return getTypeForVariableLikeDeclaration(node.parent, /*includeOptionality*/ true);
	            }
	            if (isInRightSideOfImportOrExportAssignment(node)) {
	                var symbol = getSymbolAtLocation(node);
	                if (symbol) {
	                    var declaredType = getDeclaredTypeOfSymbol(symbol);
	                    return declaredType !== unknownType ? declaredType : getTypeOfSymbol(symbol);
	                }
	            }
	            return unknownType;
	        }
	        // Gets the type of object literal or array literal of destructuring assignment.
	        // { a } from
	        //     for ( { a } of elems) {
	        //     }
	        // [ a ] from
	        //     [a] = [ some array ...]
	        function getTypeOfArrayLiteralOrObjectLiteralDestructuringAssignment(expr) {
	            ts.Debug.assert(expr.kind === 182 /* ObjectLiteralExpression */ || expr.kind === 181 /* ArrayLiteralExpression */);
	            // If this is from "for of"
	            //     for ( { a } of elems) {
	            //     }
	            if (expr.parent.kind === 220 /* ForOfStatement */) {
	                var iteratedType = checkRightHandSideOfForOf(expr.parent.expression, expr.parent.awaitModifier);
	                return checkDestructuringAssignment(expr, iteratedType || unknownType);
	            }
	            // If this is from "for" initializer
	            //     for ({a } = elems[0];.....) { }
	            if (expr.parent.kind === 198 /* BinaryExpression */) {
	                var iteratedType = getTypeOfExpression(expr.parent.right);
	                return checkDestructuringAssignment(expr, iteratedType || unknownType);
	            }
	            // If this is from nested object binding pattern
	            //     for ({ skills: { primary, secondary } } = multiRobot, i = 0; i < 1; i++) {
	            if (expr.parent.kind === 268 /* PropertyAssignment */) {
	                var typeOfParentObjectLiteral = getTypeOfArrayLiteralOrObjectLiteralDestructuringAssignment(expr.parent.parent);
	                return checkObjectLiteralDestructuringPropertyAssignment(typeOfParentObjectLiteral || unknownType, expr.parent);
	            }
	            // Array literal assignment - array destructuring pattern
	            ts.Debug.assert(expr.parent.kind === 181 /* ArrayLiteralExpression */);
	            //    [{ property1: p1, property2 }] = elems;
	            var typeOfArrayLiteral = getTypeOfArrayLiteralOrObjectLiteralDestructuringAssignment(expr.parent);
	            var elementType = checkIteratedTypeOrElementType(typeOfArrayLiteral || unknownType, expr.parent, /*allowStringInput*/ false, /*allowAsyncIterables*/ false) || unknownType;
	            return checkArrayLiteralDestructuringElementAssignment(expr.parent, typeOfArrayLiteral, expr.parent.elements.indexOf(expr), elementType || unknownType);
	        }
	        // Gets the property symbol corresponding to the property in destructuring assignment
	        // 'property1' from
	        //     for ( { property1: a } of elems) {
	        //     }
	        // 'property1' at location 'a' from:
	        //     [a] = [ property1, property2 ]
	        function getPropertySymbolOfDestructuringAssignment(location) {
	            // Get the type of the object or array literal and then look for property of given name in the type
	            var typeOfObjectLiteral = getTypeOfArrayLiteralOrObjectLiteralDestructuringAssignment(location.parent.parent);
	            return typeOfObjectLiteral && getPropertyOfType(typeOfObjectLiteral, location.escapedText);
	        }
	        function getRegularTypeOfExpression(expr) {
	            if (ts.isRightSideOfQualifiedNameOrPropertyAccess(expr)) {
	                expr = expr.parent;
	            }
	            return getRegularTypeOfLiteralType(getTypeOfExpression(expr));
	        }
	        /**
	         * Gets either the static or instance type of a class element, based on
	         * whether the element is declared as "static".
	         */
	        function getParentTypeOfClassElement(node) {
	            var classSymbol = getSymbolOfNode(node.parent);
	            return ts.hasModifier(node, 32 /* Static */)
	                ? getTypeOfSymbol(classSymbol)
	                : getDeclaredTypeOfSymbol(classSymbol);
	        }
	        // Return the list of properties of the given type, augmented with properties from Function
	        // if the type has call or construct signatures
	        function getAugmentedPropertiesOfType(type) {
	            type = getApparentType(type);
	            var propsByName = ts.createSymbolTable(getPropertiesOfType(type));
	            if (typeHasCallOrConstructSignatures(type)) {
	                ts.forEach(getPropertiesOfType(globalFunctionType), function (p) {
	                    if (!propsByName.has(p.escapedName)) {
	                        propsByName.set(p.escapedName, p);
	                    }
	                });
	            }
	            return getNamedMembers(propsByName);
	        }
	        function typeHasCallOrConstructSignatures(type) {
	            return ts.typeHasCallOrConstructSignatures(type, checker);
	        }
	        function getRootSymbols(symbol) {
	            var roots = getImmediateRootSymbols(symbol);
	            return roots ? ts.flatMap(roots, getRootSymbols) : [symbol];
	        }
	        function getImmediateRootSymbols(symbol) {
	            if (ts.getCheckFlags(symbol) & 6 /* Synthetic */) {
	                return ts.mapDefined(getSymbolLinks(symbol).containingType.types, function (type) { return getPropertyOfType(type, symbol.escapedName); });
	            }
	            else if (symbol.flags & 33554432 /* Transient */) {
	                var _a = symbol, leftSpread = _a.leftSpread, rightSpread = _a.rightSpread, syntheticOrigin = _a.syntheticOrigin;
	                return leftSpread ? [leftSpread, rightSpread]
	                    : syntheticOrigin ? [syntheticOrigin]
	                        : ts.singleElementArray(tryGetAliasTarget(symbol));
	            }
	            return undefined;
	        }
	        function tryGetAliasTarget(symbol) {
	            var target;
	            var next = symbol;
	            while (next = getSymbolLinks(next).target) {
	                target = next;
	            }
	            return target;
	        }
	        // Emitter support
	        function isArgumentsLocalBinding(node) {
	            if (!ts.isGeneratedIdentifier(node)) {
	                node = ts.getParseTreeNode(node, ts.isIdentifier);
	                if (node) {
	                    var isPropertyName_1 = node.parent.kind === 183 /* PropertyAccessExpression */ && node.parent.name === node;
	                    return !isPropertyName_1 && getReferencedValueSymbol(node) === argumentsSymbol;
	                }
	            }
	            return false;
	        }
	        function moduleExportsSomeValue(moduleReferenceExpression) {
	            var moduleSymbol = resolveExternalModuleName(moduleReferenceExpression.parent, moduleReferenceExpression);
	            if (!moduleSymbol || ts.isShorthandAmbientModuleSymbol(moduleSymbol)) {
	                // If the module is not found or is shorthand, assume that it may export a value.
	                return true;
	            }
	            var hasExportAssignment = hasExportAssignmentSymbol(moduleSymbol);
	            // if module has export assignment then 'resolveExternalModuleSymbol' will return resolved symbol for export assignment
	            // otherwise it will return moduleSymbol itself
	            moduleSymbol = resolveExternalModuleSymbol(moduleSymbol);
	            var symbolLinks = getSymbolLinks(moduleSymbol);
	            if (symbolLinks.exportsSomeValue === undefined) {
	                // for export assignments - check if resolved symbol for RHS is itself a value
	                // otherwise - check if at least one export is value
	                symbolLinks.exportsSomeValue = hasExportAssignment
	                    ? !!(moduleSymbol.flags & 107455 /* Value */)
	                    : ts.forEachEntry(getExportsOfModule(moduleSymbol), isValue);
	            }
	            return symbolLinks.exportsSomeValue;
	            function isValue(s) {
	                s = resolveSymbol(s);
	                return s && !!(s.flags & 107455 /* Value */);
	            }
	        }
	        function isNameOfModuleOrEnumDeclaration(node) {
	            var parent = node.parent;
	            return parent && ts.isModuleOrEnumDeclaration(parent) && node === parent.name;
	        }
	        // When resolved as an expression identifier, if the given node references an exported entity, return the declaration
	        // node of the exported entity's container. Otherwise, return undefined.
	        function getReferencedExportContainer(node, prefixLocals) {
	            node = ts.getParseTreeNode(node, ts.isIdentifier);
	            if (node) {
	                // When resolving the export container for the name of a module or enum
	                // declaration, we need to start resolution at the declaration's container.
	                // Otherwise, we could incorrectly resolve the export container as the
	                // declaration if it contains an exported member with the same name.
	                var symbol = getReferencedValueSymbol(node, /*startInDeclarationContainer*/ isNameOfModuleOrEnumDeclaration(node));
	                if (symbol) {
	                    if (symbol.flags & 1048576 /* ExportValue */) {
	                        // If we reference an exported entity within the same module declaration, then whether
	                        // we prefix depends on the kind of entity. SymbolFlags.ExportHasLocal encompasses all the
	                        // kinds that we do NOT prefix.
	                        var exportSymbol = getMergedSymbol(symbol.exportSymbol);
	                        if (!prefixLocals && exportSymbol.flags & 944 /* ExportHasLocal */ && !(exportSymbol.flags & 3 /* Variable */)) {
	                            return undefined;
	                        }
	                        symbol = exportSymbol;
	                    }
	                    var parentSymbol_1 = getParentOfSymbol(symbol);
	                    if (parentSymbol_1) {
	                        if (parentSymbol_1.flags & 512 /* ValueModule */ && parentSymbol_1.valueDeclaration.kind === 272 /* SourceFile */) {
	                            var symbolFile = parentSymbol_1.valueDeclaration;
	                            var referenceFile = ts.getSourceFileOfNode(node);
	                            // If `node` accesses an export and that export isn't in the same file, then symbol is a namespace export, so return undefined.
	                            var symbolIsUmdExport = symbolFile !== referenceFile;
	                            return symbolIsUmdExport ? undefined : symbolFile;
	                        }
	                        return ts.findAncestor(node.parent, function (n) { return ts.isModuleOrEnumDeclaration(n) && getSymbolOfNode(n) === parentSymbol_1; });
	                    }
	                }
	            }
	        }
	        // When resolved as an expression identifier, if the given node references an import, return the declaration of
	        // that import. Otherwise, return undefined.
	        function getReferencedImportDeclaration(node) {
	            node = ts.getParseTreeNode(node, ts.isIdentifier);
	            if (node) {
	                var symbol = getReferencedValueSymbol(node);
	                // We should only get the declaration of an alias if there isn't a local value
	                // declaration for the symbol
	                if (isNonLocalAlias(symbol, /*excludes*/ 107455 /* Value */)) {
	                    return getDeclarationOfAliasSymbol(symbol);
	                }
	            }
	            return undefined;
	        }
	        function isSymbolOfDeclarationWithCollidingName(symbol) {
	            if (symbol.flags & 418 /* BlockScoped */) {
	                var links = getSymbolLinks(symbol);
	                if (links.isDeclarationWithCollidingName === undefined) {
	                    var container = ts.getEnclosingBlockScopeContainer(symbol.valueDeclaration);
	                    if (ts.isStatementWithLocals(container)) {
	                        var nodeLinks_1 = getNodeLinks(symbol.valueDeclaration);
	                        if (resolveName(container.parent, symbol.escapedName, 107455 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false)) {
	                            // redeclaration - always should be renamed
	                            links.isDeclarationWithCollidingName = true;
	                        }
	                        else if (nodeLinks_1.flags & 131072 /* CapturedBlockScopedBinding */) {
	                            // binding is captured in the function
	                            // should be renamed if:
	                            // - binding is not top level - top level bindings never collide with anything
	                            // AND
	                            //   - binding is not declared in loop, should be renamed to avoid name reuse across siblings
	                            //     let a, b
	                            //     { let x = 1; a = () => x; }
	                            //     { let x = 100; b = () => x; }
	                            //     console.log(a()); // should print '1'
	                            //     console.log(b()); // should print '100'
	                            //     OR
	                            //   - binding is declared inside loop but not in inside initializer of iteration statement or directly inside loop body
	                            //     * variables from initializer are passed to rewritten loop body as parameters so they are not captured directly
	                            //     * variables that are declared immediately in loop body will become top level variable after loop is rewritten and thus
	                            //       they will not collide with anything
	                            var isDeclaredInLoop = nodeLinks_1.flags & 262144 /* BlockScopedBindingInLoop */;
	                            var inLoopInitializer = ts.isIterationStatement(container, /*lookInLabeledStatements*/ false);
	                            var inLoopBodyBlock = container.kind === 211 /* Block */ && ts.isIterationStatement(container.parent, /*lookInLabeledStatements*/ false);
	                            links.isDeclarationWithCollidingName = !ts.isBlockScopedContainerTopLevel(container) && (!isDeclaredInLoop || (!inLoopInitializer && !inLoopBodyBlock));
	                        }
	                        else {
	                            links.isDeclarationWithCollidingName = false;
	                        }
	                    }
	                }
	                return links.isDeclarationWithCollidingName;
	            }
	            return false;
	        }
	        // When resolved as an expression identifier, if the given node references a nested block scoped entity with
	        // a name that either hides an existing name or might hide it when compiled downlevel,
	        // return the declaration of that entity. Otherwise, return undefined.
	        function getReferencedDeclarationWithCollidingName(node) {
	            if (!ts.isGeneratedIdentifier(node)) {
	                node = ts.getParseTreeNode(node, ts.isIdentifier);
	                if (node) {
	                    var symbol = getReferencedValueSymbol(node);
	                    if (symbol && isSymbolOfDeclarationWithCollidingName(symbol)) {
	                        return symbol.valueDeclaration;
	                    }
	                }
	            }
	            return undefined;
	        }
	        // Return true if the given node is a declaration of a nested block scoped entity with a name that either hides an
	        // existing name or might hide a name when compiled downlevel
	        function isDeclarationWithCollidingName(node) {
	            node = ts.getParseTreeNode(node, ts.isDeclaration);
	            if (node) {
	                var symbol = getSymbolOfNode(node);
	                if (symbol) {
	                    return isSymbolOfDeclarationWithCollidingName(symbol);
	                }
	            }
	            return false;
	        }
	        function isValueAliasDeclaration(node) {
	            switch (node.kind) {
	                case 241 /* ImportEqualsDeclaration */:
	                case 243 /* ImportClause */:
	                case 244 /* NamespaceImport */:
	                case 246 /* ImportSpecifier */:
	                case 250 /* ExportSpecifier */:
	                    return isAliasResolvedToValue(getSymbolOfNode(node) || unknownSymbol);
	                case 248 /* ExportDeclaration */:
	                    var exportClause = node.exportClause;
	                    return exportClause && ts.forEach(exportClause.elements, isValueAliasDeclaration);
	                case 247 /* ExportAssignment */:
	                    return node.expression
	                        && node.expression.kind === 71 /* Identifier */
	                        ? isAliasResolvedToValue(getSymbolOfNode(node) || unknownSymbol)
	                        : true;
	            }
	            return false;
	        }
	        function isTopLevelValueImportEqualsWithEntityName(node) {
	            node = ts.getParseTreeNode(node, ts.isImportEqualsDeclaration);
	            if (node === undefined || node.parent.kind !== 272 /* SourceFile */ || !ts.isInternalModuleImportEqualsDeclaration(node)) {
	                // parent is not source file or it is not reference to internal module
	                return false;
	            }
	            var isValue = isAliasResolvedToValue(getSymbolOfNode(node));
	            return isValue && node.moduleReference && !ts.nodeIsMissing(node.moduleReference);
	        }
	        function isAliasResolvedToValue(symbol) {
	            var target = resolveAlias(symbol);
	            if (target === unknownSymbol) {
	                return true;
	            }
	            // const enums and modules that contain only const enums are not considered values from the emit perspective
	            // unless 'preserveConstEnums' option is set to true
	            return target.flags & 107455 /* Value */ &&
	                (compilerOptions.preserveConstEnums || !isConstEnumOrConstEnumOnlyModule(target));
	        }
	        function isConstEnumOrConstEnumOnlyModule(s) {
	            return isConstEnumSymbol(s) || s.constEnumOnlyModule;
	        }
	        function isReferencedAliasDeclaration(node, checkChildren) {
	            if (ts.isAliasSymbolDeclaration(node)) {
	                var symbol = getSymbolOfNode(node);
	                if (symbol && getSymbolLinks(symbol).referenced) {
	                    return true;
	                }
	                var target = getSymbolLinks(symbol).target;
	                if (target && ts.getModifierFlags(node) & 1 /* Export */ && target.flags & 107455 /* Value */) {
	                    // An `export import ... =` of a value symbol is always considered referenced
	                    return true;
	                }
	            }
	            if (checkChildren) {
	                return ts.forEachChild(node, function (node) { return isReferencedAliasDeclaration(node, checkChildren); });
	            }
	            return false;
	        }
	        function isImplementationOfOverload(node) {
	            if (ts.nodeIsPresent(node.body)) {
	                var symbol = getSymbolOfNode(node);
	                var signaturesOfSymbol = getSignaturesOfSymbol(symbol);
	                // If this function body corresponds to function with multiple signature, it is implementation of overload
	                // e.g.: function foo(a: string): string;
	                //       function foo(a: number): number;
	                //       function foo(a: any) { // This is implementation of the overloads
	                //           return a;
	                //       }
	                return signaturesOfSymbol.length > 1 ||
	                    // If there is single signature for the symbol, it is overload if that signature isn't coming from the node
	                    // e.g.: function foo(a: string): string;
	                    //       function foo(a: any) { // This is implementation of the overloads
	                    //           return a;
	                    //       }
	                    (signaturesOfSymbol.length === 1 && signaturesOfSymbol[0].declaration !== node);
	            }
	            return false;
	        }
	        function isRequiredInitializedParameter(parameter) {
	            return strictNullChecks &&
	                !isOptionalParameter(parameter) &&
	                parameter.initializer &&
	                !ts.hasModifier(parameter, 92 /* ParameterPropertyModifier */);
	        }
	        function isOptionalUninitializedParameterProperty(parameter) {
	            return strictNullChecks &&
	                isOptionalParameter(parameter) &&
	                !parameter.initializer &&
	                ts.hasModifier(parameter, 92 /* ParameterPropertyModifier */);
	        }
	        function getNodeCheckFlags(node) {
	            return getNodeLinks(node).flags;
	        }
	        function getEnumMemberValue(node) {
	            computeEnumMemberValues(node.parent);
	            return getNodeLinks(node).enumMemberValue;
	        }
	        function canHaveConstantValue(node) {
	            switch (node.kind) {
	                case 271 /* EnumMember */:
	                case 183 /* PropertyAccessExpression */:
	                case 184 /* ElementAccessExpression */:
	                    return true;
	            }
	            return false;
	        }
	        function getConstantValue(node) {
	            if (node.kind === 271 /* EnumMember */) {
	                return getEnumMemberValue(node);
	            }
	            var symbol = getNodeLinks(node).resolvedSymbol;
	            if (symbol && (symbol.flags & 8 /* EnumMember */)) {
	                // inline property\index accesses only for const enums
	                if (ts.isConstEnumDeclaration(symbol.valueDeclaration.parent)) {
	                    return getEnumMemberValue(symbol.valueDeclaration);
	                }
	            }
	            return undefined;
	        }
	        function isFunctionType(type) {
	            return type.flags & 65536 /* Object */ && getSignaturesOfType(type, 0 /* Call */).length > 0;
	        }
	        function getTypeReferenceSerializationKind(typeName, location) {
	            // ensure both `typeName` and `location` are parse tree nodes.
	            typeName = ts.getParseTreeNode(typeName, ts.isEntityName);
	            if (!typeName)
	                return ts.TypeReferenceSerializationKind.Unknown;
	            if (location) {
	                location = ts.getParseTreeNode(location);
	                if (!location)
	                    return ts.TypeReferenceSerializationKind.Unknown;
	            }
	            // Resolve the symbol as a value to ensure the type can be reached at runtime during emit.
	            var valueSymbol = resolveEntityName(typeName, 107455 /* Value */, /*ignoreErrors*/ true, /*dontResolveAlias*/ false, location);
	            // Resolve the symbol as a type so that we can provide a more useful hint for the type serializer.
	            var typeSymbol = resolveEntityName(typeName, 793064 /* Type */, /*ignoreErrors*/ true, /*dontResolveAlias*/ false, location);
	            if (valueSymbol && valueSymbol === typeSymbol) {
	                var globalPromiseSymbol = getGlobalPromiseConstructorSymbol(/*reportErrors*/ false);
	                if (globalPromiseSymbol && valueSymbol === globalPromiseSymbol) {
	                    return ts.TypeReferenceSerializationKind.Promise;
	                }
	                var constructorType = getTypeOfSymbol(valueSymbol);
	                if (constructorType && isConstructorType(constructorType)) {
	                    return ts.TypeReferenceSerializationKind.TypeWithConstructSignatureAndValue;
	                }
	            }
	            // We might not be able to resolve type symbol so use unknown type in that case (eg error case)
	            if (!typeSymbol) {
	                return ts.TypeReferenceSerializationKind.ObjectType;
	            }
	            var type = getDeclaredTypeOfSymbol(typeSymbol);
	            if (type === unknownType) {
	                return ts.TypeReferenceSerializationKind.Unknown;
	            }
	            else if (type.flags & 1 /* Any */) {
	                return ts.TypeReferenceSerializationKind.ObjectType;
	            }
	            else if (isTypeAssignableToKind(type, 2048 /* Void */ | 12288 /* Nullable */ | 16384 /* Never */)) {
	                return ts.TypeReferenceSerializationKind.VoidNullableOrNeverType;
	            }
	            else if (isTypeAssignableToKind(type, 136 /* BooleanLike */)) {
	                return ts.TypeReferenceSerializationKind.BooleanType;
	            }
	            else if (isTypeAssignableToKind(type, 84 /* NumberLike */)) {
	                return ts.TypeReferenceSerializationKind.NumberLikeType;
	            }
	            else if (isTypeAssignableToKind(type, 524322 /* StringLike */)) {
	                return ts.TypeReferenceSerializationKind.StringLikeType;
	            }
	            else if (isTupleType(type)) {
	                return ts.TypeReferenceSerializationKind.ArrayLikeType;
	            }
	            else if (isTypeAssignableToKind(type, 1536 /* ESSymbolLike */)) {
	                return ts.TypeReferenceSerializationKind.ESSymbolType;
	            }
	            else if (isFunctionType(type)) {
	                return ts.TypeReferenceSerializationKind.TypeWithCallSignature;
	            }
	            else if (isArrayType(type)) {
	                return ts.TypeReferenceSerializationKind.ArrayLikeType;
	            }
	            else {
	                return ts.TypeReferenceSerializationKind.ObjectType;
	            }
	        }
	        function writeTypeOfDeclaration(declaration, enclosingDeclaration, flags, writer) {
	            // Get type of the symbol if this is the valid symbol otherwise get type at location
	            var symbol = getSymbolOfNode(declaration);
	            var type = symbol && !(symbol.flags & (2048 /* TypeLiteral */ | 131072 /* Signature */))
	                ? getWidenedLiteralType(getTypeOfSymbol(symbol))
	                : unknownType;
	            if (type.flags & 1024 /* UniqueESSymbol */ &&
	                type.symbol === symbol) {
	                flags |= 1048576 /* AllowUniqueESSymbolType */;
	            }
	            if (flags & 131072 /* AddUndefined */) {
	                type = getOptionalType(type);
	            }
	            typeToString(type, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */, writer);
	        }
	        function writeReturnTypeOfSignatureDeclaration(signatureDeclaration, enclosingDeclaration, flags, writer) {
	            var signature = getSignatureFromDeclaration(signatureDeclaration);
	            typeToString(getReturnTypeOfSignature(signature), enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */, writer);
	        }
	        function writeTypeOfExpression(expr, enclosingDeclaration, flags, writer) {
	            var type = getWidenedType(getRegularTypeOfExpression(expr));
	            typeToString(type, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */, writer);
	        }
	        function hasGlobalName(name) {
	            return globals.has(ts.escapeLeadingUnderscores(name));
	        }
	        function getReferencedValueSymbol(reference, startInDeclarationContainer) {
	            var resolvedSymbol = getNodeLinks(reference).resolvedSymbol;
	            if (resolvedSymbol) {
	                return resolvedSymbol;
	            }
	            var location = reference;
	            if (startInDeclarationContainer) {
	                // When resolving the name of a declaration as a value, we need to start resolution
	                // at a point outside of the declaration.
	                var parent = reference.parent;
	                if (ts.isDeclaration(parent) && reference === parent.name) {
	                    location = getDeclarationContainer(parent);
	                }
	            }
	            return resolveName(location, reference.escapedText, 107455 /* Value */ | 1048576 /* ExportValue */ | 2097152 /* Alias */, /*nodeNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ true);
	        }
	        function getReferencedValueDeclaration(reference) {
	            if (!ts.isGeneratedIdentifier(reference)) {
	                reference = ts.getParseTreeNode(reference, ts.isIdentifier);
	                if (reference) {
	                    var symbol = getReferencedValueSymbol(reference);
	                    if (symbol) {
	                        return getExportSymbolOfValueSymbolIfExported(symbol).valueDeclaration;
	                    }
	                }
	            }
	            return undefined;
	        }
	        function isLiteralConstDeclaration(node) {
	            if (ts.isConst(node)) {
	                var type = getTypeOfSymbol(getSymbolOfNode(node));
	                return !!(type.flags & 96 /* StringOrNumberLiteral */ && type.flags & 8388608 /* FreshLiteral */);
	            }
	            return false;
	        }
	        function writeLiteralConstValue(node, writer) {
	            var type = getTypeOfSymbol(getSymbolOfNode(node));
	            writer.writeStringLiteral(literalTypeToString(type));
	        }
	        function createResolver() {
	            // this variable and functions that use it are deliberately moved here from the outer scope
	            // to avoid scope pollution
	            var resolvedTypeReferenceDirectives = host.getResolvedTypeReferenceDirectives();
	            var fileToDirective;
	            if (resolvedTypeReferenceDirectives) {
	                // populate reverse mapping: file path -> type reference directive that was resolved to this file
	                fileToDirective = ts.createMap();
	                resolvedTypeReferenceDirectives.forEach(function (resolvedDirective, key) {
	                    if (!resolvedDirective) {
	                        return;
	                    }
	                    var file = host.getSourceFile(resolvedDirective.resolvedFileName);
	                    fileToDirective.set(file.path, key);
	                });
	            }
	            return {
	                getReferencedExportContainer: getReferencedExportContainer,
	                getReferencedImportDeclaration: getReferencedImportDeclaration,
	                getReferencedDeclarationWithCollidingName: getReferencedDeclarationWithCollidingName,
	                isDeclarationWithCollidingName: isDeclarationWithCollidingName,
	                isValueAliasDeclaration: function (node) {
	                    node = ts.getParseTreeNode(node);
	                    // Synthesized nodes are always treated like values.
	                    return node ? isValueAliasDeclaration(node) : true;
	                },
	                hasGlobalName: hasGlobalName,
	                isReferencedAliasDeclaration: function (node, checkChildren) {
	                    node = ts.getParseTreeNode(node);
	                    // Synthesized nodes are always treated as referenced.
	                    return node ? isReferencedAliasDeclaration(node, checkChildren) : true;
	                },
	                getNodeCheckFlags: function (node) {
	                    node = ts.getParseTreeNode(node);
	                    return node ? getNodeCheckFlags(node) : undefined;
	                },
	                isTopLevelValueImportEqualsWithEntityName: isTopLevelValueImportEqualsWithEntityName,
	                isDeclarationVisible: isDeclarationVisible,
	                isImplementationOfOverload: isImplementationOfOverload,
	                isRequiredInitializedParameter: isRequiredInitializedParameter,
	                isOptionalUninitializedParameterProperty: isOptionalUninitializedParameterProperty,
	                writeTypeOfDeclaration: writeTypeOfDeclaration,
	                writeReturnTypeOfSignatureDeclaration: writeReturnTypeOfSignatureDeclaration,
	                writeTypeOfExpression: writeTypeOfExpression,
	                isSymbolAccessible: isSymbolAccessible,
	                isEntityNameVisible: isEntityNameVisible,
	                getConstantValue: function (node) {
	                    node = ts.getParseTreeNode(node, canHaveConstantValue);
	                    return node ? getConstantValue(node) : undefined;
	                },
	                collectLinkedAliases: collectLinkedAliases,
	                getReferencedValueDeclaration: getReferencedValueDeclaration,
	                getTypeReferenceSerializationKind: getTypeReferenceSerializationKind,
	                isOptionalParameter: isOptionalParameter,
	                moduleExportsSomeValue: moduleExportsSomeValue,
	                isArgumentsLocalBinding: isArgumentsLocalBinding,
	                getExternalModuleFileFromDeclaration: getExternalModuleFileFromDeclaration,
	                getTypeReferenceDirectivesForEntityName: getTypeReferenceDirectivesForEntityName,
	                getTypeReferenceDirectivesForSymbol: getTypeReferenceDirectivesForSymbol,
	                isLiteralConstDeclaration: isLiteralConstDeclaration,
	                isLateBound: function (node) {
	                    node = ts.getParseTreeNode(node, ts.isDeclaration);
	                    var symbol = node && getSymbolOfNode(node);
	                    return !!(symbol && ts.getCheckFlags(symbol) & 1024 /* Late */);
	                },
	                writeLiteralConstValue: writeLiteralConstValue,
	                getJsxFactoryEntity: function () { return _jsxFactoryEntity; }
	            };
	            // defined here to avoid outer scope pollution
	            function getTypeReferenceDirectivesForEntityName(node) {
	                // program does not have any files with type reference directives - bail out
	                if (!fileToDirective) {
	                    return undefined;
	                }
	                // property access can only be used as values
	                // qualified names can only be used as types\namespaces
	                // identifiers are treated as values only if they appear in type queries
	                var meaning = (node.kind === 183 /* PropertyAccessExpression */) || (node.kind === 71 /* Identifier */ && isInTypeQuery(node))
	                    ? 107455 /* Value */ | 1048576 /* ExportValue */
	                    : 793064 /* Type */ | 1920 /* Namespace */;
	                var symbol = resolveEntityName(node, meaning, /*ignoreErrors*/ true);
	                return symbol && symbol !== unknownSymbol ? getTypeReferenceDirectivesForSymbol(symbol, meaning) : undefined;
	            }
	            // defined here to avoid outer scope pollution
	            function getTypeReferenceDirectivesForSymbol(symbol, meaning) {
	                // program does not have any files with type reference directives - bail out
	                if (!fileToDirective) {
	                    return undefined;
	                }
	                if (!isSymbolFromTypeDeclarationFile(symbol)) {
	                    return undefined;
	                }
	                // check what declarations in the symbol can contribute to the target meaning
	                var typeReferenceDirectives;
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    // check meaning of the local symbol to see if declaration needs to be analyzed further
	                    if (decl.symbol && decl.symbol.flags & meaning) {
	                        var file = ts.getSourceFileOfNode(decl);
	                        var typeReferenceDirective = fileToDirective.get(file.path);
	                        if (typeReferenceDirective) {
	                            (typeReferenceDirectives || (typeReferenceDirectives = [])).push(typeReferenceDirective);
	                        }
	                        else {
	                            // found at least one entry that does not originate from type reference directive
	                            return undefined;
	                        }
	                    }
	                }
	                return typeReferenceDirectives;
	            }
	            function isSymbolFromTypeDeclarationFile(symbol) {
	                // bail out if symbol does not have associated declarations (i.e. this is transient symbol created for property in binding pattern)
	                if (!symbol.declarations) {
	                    return false;
	                }
	                // walk the parent chain for symbols to make sure that top level parent symbol is in the global scope
	                // external modules cannot define or contribute to type declaration files
	                var current = symbol;
	                while (true) {
	                    var parent = getParentOfSymbol(current);
	                    if (parent) {
	                        current = parent;
	                    }
	                    else {
	                        break;
	                    }
	                }
	                if (current.valueDeclaration && current.valueDeclaration.kind === 272 /* SourceFile */ && current.flags & 512 /* ValueModule */) {
	                    return false;
	                }
	                // check that at least one declaration of top level symbol originates from type declaration file
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var file = ts.getSourceFileOfNode(decl);
	                    if (fileToDirective.has(file.path)) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        }
	        function getExternalModuleFileFromDeclaration(declaration) {
	            var specifier = ts.getExternalModuleName(declaration);
	            var moduleSymbol = resolveExternalModuleNameWorker(specifier, specifier, /*moduleNotFoundError*/ undefined);
	            if (!moduleSymbol) {
	                return undefined;
	            }
	            return ts.getDeclarationOfKind(moduleSymbol, 272 /* SourceFile */);
	        }
	        function initializeTypeChecker() {
	            // Bind all source files and propagate errors
	            for (var _i = 0, _a = host.getSourceFiles(); _i < _a.length; _i++) {
	                var file = _a[_i];
	                ts.bindSourceFile(file, compilerOptions);
	            }
	            // Initialize global symbol table
	            var augmentations;
	            for (var _b = 0, _c = host.getSourceFiles(); _b < _c.length; _b++) {
	                var file = _c[_b];
	                if (!ts.isExternalOrCommonJsModule(file)) {
	                    mergeSymbolTable(globals, file.locals);
	                }
	                if (file.patternAmbientModules && file.patternAmbientModules.length) {
	                    patternAmbientModules = ts.concatenate(patternAmbientModules, file.patternAmbientModules);
	                }
	                if (file.moduleAugmentations.length) {
	                    (augmentations || (augmentations = [])).push(file.moduleAugmentations);
	                }
	                if (file.symbol && file.symbol.globalExports) {
	                    // Merge in UMD exports with first-in-wins semantics (see #9771)
	                    var source = file.symbol.globalExports;
	                    source.forEach(function (sourceSymbol, id) {
	                        if (!globals.has(id)) {
	                            globals.set(id, sourceSymbol);
	                        }
	                    });
	                }
	            }
	            // We do global augmentations seperately from module augmentations (and before creating global types) because they
	            //  1. Affect global types. We won't have the correct global types until global augmentations are merged. Also,
	            //  2. Module augmentation instantiation requires creating the type of a module, which, in turn, can require
	            //       checking for an export or property on the module (if export=) which, in turn, can fall back to the
	            //       apparent type of the module - either globalObjectType or globalFunctionType - which wouldn't exist if we
	            //       did module augmentations prior to finalizing the global types.
	            if (augmentations) {
	                // merge _global_ module augmentations.
	                // this needs to be done after global symbol table is initialized to make sure that all ambient modules are indexed
	                for (var _d = 0, augmentations_1 = augmentations; _d < augmentations_1.length; _d++) {
	                    var list = augmentations_1[_d];
	                    for (var _e = 0, list_1 = list; _e < list_1.length; _e++) {
	                        var augmentation = list_1[_e];
	                        if (!ts.isGlobalScopeAugmentation(augmentation.parent))
	                            continue;
	                        mergeModuleAugmentation(augmentation);
	                    }
	                }
	            }
	            // Setup global builtins
	            addToSymbolTable(globals, builtinGlobals, ts.Diagnostics.Declaration_name_conflicts_with_built_in_global_identifier_0);
	            getSymbolLinks(undefinedSymbol).type = undefinedWideningType;
	            getSymbolLinks(argumentsSymbol).type = getGlobalType("IArguments", /*arity*/ 0, /*reportErrors*/ true);
	            getSymbolLinks(unknownSymbol).type = unknownType;
	            // Initialize special types
	            globalArrayType = getGlobalType("Array", /*arity*/ 1, /*reportErrors*/ true);
	            globalObjectType = getGlobalType("Object", /*arity*/ 0, /*reportErrors*/ true);
	            globalFunctionType = getGlobalType("Function", /*arity*/ 0, /*reportErrors*/ true);
	            globalStringType = getGlobalType("String", /*arity*/ 0, /*reportErrors*/ true);
	            globalNumberType = getGlobalType("Number", /*arity*/ 0, /*reportErrors*/ true);
	            globalBooleanType = getGlobalType("Boolean", /*arity*/ 0, /*reportErrors*/ true);
	            globalRegExpType = getGlobalType("RegExp", /*arity*/ 0, /*reportErrors*/ true);
	            anyArrayType = createArrayType(anyType);
	            autoArrayType = createArrayType(autoType);
	            if (autoArrayType === emptyObjectType) {
	                // autoArrayType is used as a marker, so even if global Array type is not defined, it needs to be a unique type
	                autoArrayType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	            }
	            globalReadonlyArrayType = getGlobalTypeOrUndefined("ReadonlyArray", /*arity*/ 1);
	            anyReadonlyArrayType = globalReadonlyArrayType ? createTypeFromGenericGlobalType(globalReadonlyArrayType, [anyType]) : anyArrayType;
	            globalThisType = getGlobalTypeOrUndefined("ThisType", /*arity*/ 1);
	            if (augmentations) {
	                // merge _nonglobal_ module augmentations.
	                // this needs to be done after global symbol table is initialized to make sure that all ambient modules are indexed
	                for (var _f = 0, augmentations_2 = augmentations; _f < augmentations_2.length; _f++) {
	                    var list = augmentations_2[_f];
	                    for (var _g = 0, list_2 = list; _g < list_2.length; _g++) {
	                        var augmentation = list_2[_g];
	                        if (ts.isGlobalScopeAugmentation(augmentation.parent))
	                            continue;
	                        mergeModuleAugmentation(augmentation);
	                    }
	                }
	            }
	        }
	        function checkExternalEmitHelpers(location, helpers) {
	            if ((requestedExternalEmitHelpers & helpers) !== helpers && compilerOptions.importHelpers) {
	                var sourceFile = ts.getSourceFileOfNode(location);
	                if (ts.isEffectiveExternalModule(sourceFile, compilerOptions) && !(location.flags & 2097152 /* Ambient */)) {
	                    var helpersModule = resolveHelpersModule(sourceFile, location);
	                    if (helpersModule !== unknownSymbol) {
	                        var uncheckedHelpers = helpers & ~requestedExternalEmitHelpers;
	                        for (var helper = 1 /* FirstEmitHelper */; helper <= 65536 /* LastEmitHelper */; helper <<= 1) {
	                            if (uncheckedHelpers & helper) {
	                                var name = getHelperName(helper);
	                                var symbol = getSymbol(helpersModule.exports, ts.escapeLeadingUnderscores(name), 107455 /* Value */);
	                                if (!symbol) {
	                                    error(location, ts.Diagnostics.This_syntax_requires_an_imported_helper_named_1_but_module_0_has_no_exported_member_1, ts.externalHelpersModuleNameText, name);
	                                }
	                            }
	                        }
	                    }
	                    requestedExternalEmitHelpers |= helpers;
	                }
	            }
	        }
	        function getHelperName(helper) {
	            switch (helper) {
	                case 1 /* Extends */: return "__extends";
	                case 2 /* Assign */: return "__assign";
	                case 4 /* Rest */: return "__rest";
	                case 8 /* Decorate */: return "__decorate";
	                case 16 /* Metadata */: return "__metadata";
	                case 32 /* Param */: return "__param";
	                case 64 /* Awaiter */: return "__awaiter";
	                case 128 /* Generator */: return "__generator";
	                case 256 /* Values */: return "__values";
	                case 512 /* Read */: return "__read";
	                case 1024 /* Spread */: return "__spread";
	                case 2048 /* Await */: return "__await";
	                case 4096 /* AsyncGenerator */: return "__asyncGenerator";
	                case 8192 /* AsyncDelegator */: return "__asyncDelegator";
	                case 16384 /* AsyncValues */: return "__asyncValues";
	                case 32768 /* ExportStar */: return "__exportStar";
	                case 65536 /* MakeTemplateObject */: return "__makeTemplateObject";
	                default: ts.Debug.fail("Unrecognized helper");
	            }
	        }
	        function resolveHelpersModule(node, errorNode) {
	            if (!externalHelpersModule) {
	                externalHelpersModule = resolveExternalModule(node, ts.externalHelpersModuleNameText, ts.Diagnostics.This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found, errorNode) || unknownSymbol;
	            }
	            return externalHelpersModule;
	        }
	        // GRAMMAR CHECKING
	        function checkGrammarDecoratorsAndModifiers(node) {
	            return checkGrammarDecorators(node) || checkGrammarModifiers(node);
	        }
	        function checkGrammarDecorators(node) {
	            if (!node.decorators) {
	                return false;
	            }
	            if (!ts.nodeCanBeDecorated(node, node.parent, node.parent.parent)) {
	                if (node.kind === 153 /* MethodDeclaration */ && !ts.nodeIsPresent(node.body)) {
	                    return grammarErrorOnFirstToken(node, ts.Diagnostics.A_decorator_can_only_decorate_a_method_implementation_not_an_overload);
	                }
	                else {
	                    return grammarErrorOnFirstToken(node, ts.Diagnostics.Decorators_are_not_valid_here);
	                }
	            }
	            else if (node.kind === 155 /* GetAccessor */ || node.kind === 156 /* SetAccessor */) {
	                var accessors = ts.getAllAccessorDeclarations(node.parent.members, node);
	                if (accessors.firstAccessor.decorators && node === accessors.secondAccessor) {
	                    return grammarErrorOnFirstToken(node, ts.Diagnostics.Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name);
	                }
	            }
	            return false;
	        }
	        function checkGrammarModifiers(node) {
	            var quickResult = reportObviousModifierErrors(node);
	            if (quickResult !== undefined) {
	                return quickResult;
	            }
	            var lastStatic, lastDeclare, lastAsync, lastReadonly;
	            var flags = 0 /* None */;
	            for (var _i = 0, _a = node.modifiers; _i < _a.length; _i++) {
	                var modifier = _a[_i];
	                if (modifier.kind !== 132 /* ReadonlyKeyword */) {
	                    if (node.kind === 150 /* PropertySignature */ || node.kind === 152 /* MethodSignature */) {
	                        return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_type_member, ts.tokenToString(modifier.kind));
	                    }
	                    if (node.kind === 159 /* IndexSignature */) {
	                        return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_an_index_signature, ts.tokenToString(modifier.kind));
	                    }
	                }
	                switch (modifier.kind) {
	                    case 76 /* ConstKeyword */:
	                        if (node.kind !== 236 /* EnumDeclaration */ && node.parent.kind === 233 /* ClassDeclaration */) {
	                            return grammarErrorOnNode(node, ts.Diagnostics.A_class_member_cannot_have_the_0_keyword, ts.tokenToString(76 /* ConstKeyword */));
	                        }
	                        break;
	                    case 114 /* PublicKeyword */:
	                    case 113 /* ProtectedKeyword */:
	                    case 112 /* PrivateKeyword */:
	                        var text = visibilityToString(ts.modifierToFlag(modifier.kind));
	                        if (flags & 28 /* AccessibilityModifier */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics.Accessibility_modifier_already_seen);
	                        }
	                        else if (flags & 32 /* Static */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, text, "static");
	                        }
	                        else if (flags & 64 /* Readonly */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, text, "readonly");
	                        }
	                        else if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, text, "async");
	                        }
	                        else if (node.parent.kind === 238 /* ModuleBlock */ || node.parent.kind === 272 /* SourceFile */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element, text);
	                        }
	                        else if (flags & 128 /* Abstract */) {
	                            if (modifier.kind === 112 /* PrivateKeyword */) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_with_1_modifier, text, "abstract");
	                            }
	                            else {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, text, "abstract");
	                            }
	                        }
	                        flags |= ts.modifierToFlag(modifier.kind);
	                        break;
	                    case 115 /* StaticKeyword */:
	                        if (flags & 32 /* Static */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "static");
	                        }
	                        else if (flags & 64 /* Readonly */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "static", "readonly");
	                        }
	                        else if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "static", "async");
	                        }
	                        else if (node.parent.kind === 238 /* ModuleBlock */ || node.parent.kind === 272 /* SourceFile */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element, "static");
	                        }
	                        else if (node.kind === 148 /* Parameter */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_parameter, "static");
	                        }
	                        else if (flags & 128 /* Abstract */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "static", "abstract");
	                        }
	                        flags |= 32 /* Static */;
	                        lastStatic = modifier;
	                        break;
	                    case 132 /* ReadonlyKeyword */:
	                        if (flags & 64 /* Readonly */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "readonly");
	                        }
	                        else if (node.kind !== 151 /* PropertyDeclaration */ && node.kind !== 150 /* PropertySignature */ && node.kind !== 159 /* IndexSignature */ && node.kind !== 148 /* Parameter */) {
	                            // If node.kind === SyntaxKind.Parameter, checkParameter report an error if it's not a parameter property.
	                            return grammarErrorOnNode(modifier, ts.Diagnostics.readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature);
	                        }
	                        flags |= 64 /* Readonly */;
	                        lastReadonly = modifier;
	                        break;
	                    case 84 /* ExportKeyword */:
	                        if (flags & 1 /* Export */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "export");
	                        }
	                        else if (flags & 2 /* Ambient */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "export", "declare");
	                        }
	                        else if (flags & 128 /* Abstract */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "export", "abstract");
	                        }
	                        else if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "export", "async");
	                        }
	                        else if (node.parent.kind === 233 /* ClassDeclaration */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_class_element, "export");
	                        }
	                        else if (node.kind === 148 /* Parameter */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_parameter, "export");
	                        }
	                        flags |= 1 /* Export */;
	                        break;
	                    case 79 /* DefaultKeyword */:
	                        var container = node.parent.kind === 272 /* SourceFile */ ? node.parent : node.parent.parent;
	                        if (container.kind === 237 /* ModuleDeclaration */ && !ts.isAmbientModule(container)) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics.A_default_export_can_only_be_used_in_an_ECMAScript_style_module);
	                        }
	                        flags |= 512 /* Default */;
	                        break;
	                    case 124 /* DeclareKeyword */:
	                        if (flags & 2 /* Ambient */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "declare");
	                        }
	                        else if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "async");
	                        }
	                        else if (node.parent.kind === 233 /* ClassDeclaration */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_class_element, "declare");
	                        }
	                        else if (node.kind === 148 /* Parameter */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_parameter, "declare");
	                        }
	                        else if ((node.parent.flags & 2097152 /* Ambient */) && node.parent.kind === 238 /* ModuleBlock */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics.A_declare_modifier_cannot_be_used_in_an_already_ambient_context);
	                        }
	                        flags |= 2 /* Ambient */;
	                        lastDeclare = modifier;
	                        break;
	                    case 117 /* AbstractKeyword */:
	                        if (flags & 128 /* Abstract */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "abstract");
	                        }
	                        if (node.kind !== 233 /* ClassDeclaration */) {
	                            if (node.kind !== 153 /* MethodDeclaration */ &&
	                                node.kind !== 151 /* PropertyDeclaration */ &&
	                                node.kind !== 155 /* GetAccessor */ &&
	                                node.kind !== 156 /* SetAccessor */) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics.abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration);
	                            }
	                            if (!(node.parent.kind === 233 /* ClassDeclaration */ && ts.hasModifier(node.parent, 128 /* Abstract */))) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics.Abstract_methods_can_only_appear_within_an_abstract_class);
	                            }
	                            if (flags & 32 /* Static */) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "static", "abstract");
	                            }
	                            if (flags & 8 /* Private */) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "private", "abstract");
	                            }
	                        }
	                        flags |= 128 /* Abstract */;
	                        break;
	                    case 120 /* AsyncKeyword */:
	                        if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "async");
	                        }
	                        else if (flags & 2 /* Ambient */ || node.parent.flags & 2097152 /* Ambient */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "async");
	                        }
	                        else if (node.kind === 148 /* Parameter */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_parameter, "async");
	                        }
	                        flags |= 256 /* Async */;
	                        lastAsync = modifier;
	                        break;
	                }
	            }
	            if (node.kind === 154 /* Constructor */) {
	                if (flags & 32 /* Static */) {
	                    return grammarErrorOnNode(lastStatic, ts.Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "static");
	                }
	                if (flags & 128 /* Abstract */) {
	                    return grammarErrorOnNode(lastStatic, ts.Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "abstract");
	                }
	                else if (flags & 256 /* Async */) {
	                    return grammarErrorOnNode(lastAsync, ts.Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "async");
	                }
	                else if (flags & 64 /* Readonly */) {
	                    return grammarErrorOnNode(lastReadonly, ts.Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "readonly");
	                }
	                return;
	            }
	            else if ((node.kind === 242 /* ImportDeclaration */ || node.kind === 241 /* ImportEqualsDeclaration */) && flags & 2 /* Ambient */) {
	                return grammarErrorOnNode(lastDeclare, ts.Diagnostics.A_0_modifier_cannot_be_used_with_an_import_declaration, "declare");
	            }
	            else if (node.kind === 148 /* Parameter */ && (flags & 92 /* ParameterPropertyModifier */) && ts.isBindingPattern(node.name)) {
	                return grammarErrorOnNode(node, ts.Diagnostics.A_parameter_property_may_not_be_declared_using_a_binding_pattern);
	            }
	            else if (node.kind === 148 /* Parameter */ && (flags & 92 /* ParameterPropertyModifier */) && node.dotDotDotToken) {
	                return grammarErrorOnNode(node, ts.Diagnostics.A_parameter_property_cannot_be_declared_using_a_rest_parameter);
	            }
	            if (flags & 256 /* Async */) {
	                return checkGrammarAsyncModifier(node, lastAsync);
	            }
	        }
	        /**
	         * true | false: Early return this value from checkGrammarModifiers.
	         * undefined: Need to do full checking on the modifiers.
	         */
	        function reportObviousModifierErrors(node) {
	            return !node.modifiers
	                ? false
	                : shouldReportBadModifier(node)
	                    ? grammarErrorOnFirstToken(node, ts.Diagnostics.Modifiers_cannot_appear_here)
	                    : undefined;
	        }
	        function shouldReportBadModifier(node) {
	            switch (node.kind) {
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 154 /* Constructor */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 159 /* IndexSignature */:
	                case 237 /* ModuleDeclaration */:
	                case 242 /* ImportDeclaration */:
	                case 241 /* ImportEqualsDeclaration */:
	                case 248 /* ExportDeclaration */:
	                case 247 /* ExportAssignment */:
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                case 148 /* Parameter */:
	                    return false;
	                default:
	                    if (node.parent.kind === 238 /* ModuleBlock */ || node.parent.kind === 272 /* SourceFile */) {
	                        return false;
	                    }
	                    switch (node.kind) {
	                        case 232 /* FunctionDeclaration */:
	                            return nodeHasAnyModifiersExcept(node, 120 /* AsyncKeyword */);
	                        case 233 /* ClassDeclaration */:
	                            return nodeHasAnyModifiersExcept(node, 117 /* AbstractKeyword */);
	                        case 234 /* InterfaceDeclaration */:
	                        case 212 /* VariableStatement */:
	                        case 235 /* TypeAliasDeclaration */:
	                            return true;
	                        case 236 /* EnumDeclaration */:
	                            return nodeHasAnyModifiersExcept(node, 76 /* ConstKeyword */);
	                        default:
	                            ts.Debug.fail();
	                            return false;
	                    }
	            }
	        }
	        function nodeHasAnyModifiersExcept(node, allowedModifier) {
	            return node.modifiers.length > 1 || node.modifiers[0].kind !== allowedModifier;
	        }
	        function checkGrammarAsyncModifier(node, asyncModifier) {
	            switch (node.kind) {
	                case 153 /* MethodDeclaration */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                    return false;
	            }
	            return grammarErrorOnNode(asyncModifier, ts.Diagnostics._0_modifier_cannot_be_used_here, "async");
	        }
	        function checkGrammarForDisallowedTrailingComma(list) {
	            if (list && list.hasTrailingComma) {
	                var start = list.end - ",".length;
	                var end = list.end;
	                return grammarErrorAtPos(list[0], start, end - start, ts.Diagnostics.Trailing_comma_not_allowed);
	            }
	        }
	        function checkGrammarTypeParameterList(typeParameters, file) {
	            if (typeParameters && typeParameters.length === 0) {
	                var start = typeParameters.pos - "<".length;
	                var end = ts.skipTrivia(file.text, typeParameters.end) + ">".length;
	                return grammarErrorAtPos(file, start, end - start, ts.Diagnostics.Type_parameter_list_cannot_be_empty);
	            }
	        }
	        function checkGrammarParameterList(parameters) {
	            var seenOptionalParameter = false;
	            var parameterCount = parameters.length;
	            for (var i = 0; i < parameterCount; i++) {
	                var parameter = parameters[i];
	                if (parameter.dotDotDotToken) {
	                    if (i !== (parameterCount - 1)) {
	                        return grammarErrorOnNode(parameter.dotDotDotToken, ts.Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
	                    }
	                    if (ts.isBindingPattern(parameter.name)) {
	                        return grammarErrorOnNode(parameter.name, ts.Diagnostics.A_rest_element_cannot_contain_a_binding_pattern);
	                    }
	                    if (parameter.questionToken) {
	                        return grammarErrorOnNode(parameter.questionToken, ts.Diagnostics.A_rest_parameter_cannot_be_optional);
	                    }
	                    if (parameter.initializer) {
	                        return grammarErrorOnNode(parameter.name, ts.Diagnostics.A_rest_parameter_cannot_have_an_initializer);
	                    }
	                }
	                else if (parameter.questionToken) {
	                    seenOptionalParameter = true;
	                    if (parameter.initializer) {
	                        return grammarErrorOnNode(parameter.name, ts.Diagnostics.Parameter_cannot_have_question_mark_and_initializer);
	                    }
	                }
	                else if (seenOptionalParameter && !parameter.initializer) {
	                    return grammarErrorOnNode(parameter.name, ts.Diagnostics.A_required_parameter_cannot_follow_an_optional_parameter);
	                }
	            }
	        }
	        function checkGrammarFunctionLikeDeclaration(node) {
	            // Prevent cascading error by short-circuit
	            var file = ts.getSourceFileOfNode(node);
	            return checkGrammarDecoratorsAndModifiers(node) || checkGrammarTypeParameterList(node.typeParameters, file) ||
	                checkGrammarParameterList(node.parameters) || checkGrammarArrowFunction(node, file);
	        }
	        function checkGrammarClassLikeDeclaration(node) {
	            var file = ts.getSourceFileOfNode(node);
	            return checkGrammarClassDeclarationHeritageClauses(node) || checkGrammarTypeParameterList(node.typeParameters, file);
	        }
	        function checkGrammarArrowFunction(node, file) {
	            if (!ts.isArrowFunction(node)) {
	                return false;
	            }
	            var equalsGreaterThanToken = node.equalsGreaterThanToken;
	            var startLine = ts.getLineAndCharacterOfPosition(file, equalsGreaterThanToken.pos).line;
	            var endLine = ts.getLineAndCharacterOfPosition(file, equalsGreaterThanToken.end).line;
	            return startLine !== endLine && grammarErrorOnNode(equalsGreaterThanToken, ts.Diagnostics.Line_terminator_not_permitted_before_arrow);
	        }
	        function checkGrammarIndexSignatureParameters(node) {
	            var parameter = node.parameters[0];
	            if (node.parameters.length !== 1) {
	                if (parameter) {
	                    return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_must_have_exactly_one_parameter);
	                }
	                else {
	                    return grammarErrorOnNode(node, ts.Diagnostics.An_index_signature_must_have_exactly_one_parameter);
	                }
	            }
	            if (parameter.dotDotDotToken) {
	                return grammarErrorOnNode(parameter.dotDotDotToken, ts.Diagnostics.An_index_signature_cannot_have_a_rest_parameter);
	            }
	            if (ts.hasModifiers(parameter)) {
	                return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_cannot_have_an_accessibility_modifier);
	            }
	            if (parameter.questionToken) {
	                return grammarErrorOnNode(parameter.questionToken, ts.Diagnostics.An_index_signature_parameter_cannot_have_a_question_mark);
	            }
	            if (parameter.initializer) {
	                return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_cannot_have_an_initializer);
	            }
	            if (!parameter.type) {
	                return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_must_have_a_type_annotation);
	            }
	            if (parameter.type.kind !== 137 /* StringKeyword */ && parameter.type.kind !== 134 /* NumberKeyword */) {
	                var type = getTypeFromTypeNode(parameter.type);
	                if (type.flags & 2 /* String */ || type.flags & 4 /* Number */) {
	                    return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_type_cannot_be_a_type_alias_Consider_writing_0_Colon_1_Colon_2_instead, ts.getTextOfNode(parameter.name), typeToString(type), typeToString(getTypeFromTypeNode(node.type)));
	                }
	                if (allTypesAssignableToKind(type, 32 /* StringLiteral */, /*strict*/ true)) {
	                    return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_type_cannot_be_a_union_type_Consider_using_a_mapped_object_type_instead);
	                }
	                return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_type_must_be_string_or_number);
	            }
	            if (!node.type) {
	                return grammarErrorOnNode(node, ts.Diagnostics.An_index_signature_must_have_a_type_annotation);
	            }
	        }
	        function checkGrammarIndexSignature(node) {
	            // Prevent cascading error by short-circuit
	            return checkGrammarDecoratorsAndModifiers(node) || checkGrammarIndexSignatureParameters(node);
	        }
	        function checkGrammarForAtLeastOneTypeArgument(node, typeArguments) {
	            if (typeArguments && typeArguments.length === 0) {
	                var sourceFile = ts.getSourceFileOfNode(node);
	                var start = typeArguments.pos - "<".length;
	                var end = ts.skipTrivia(sourceFile.text, typeArguments.end) + ">".length;
	                return grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.Type_argument_list_cannot_be_empty);
	            }
	        }
	        function checkGrammarTypeArguments(node, typeArguments) {
	            return checkGrammarForDisallowedTrailingComma(typeArguments) ||
	                checkGrammarForAtLeastOneTypeArgument(node, typeArguments);
	        }
	        function checkGrammarForOmittedArgument(args) {
	            if (args) {
	                for (var _i = 0, args_5 = args; _i < args_5.length; _i++) {
	                    var arg = args_5[_i];
	                    if (arg.kind === 204 /* OmittedExpression */) {
	                        return grammarErrorAtPos(arg, arg.pos, 0, ts.Diagnostics.Argument_expression_expected);
	                    }
	                }
	            }
	        }
	        function checkGrammarArguments(args) {
	            return checkGrammarForOmittedArgument(args);
	        }
	        function checkGrammarHeritageClause(node) {
	            var types = node.types;
	            if (checkGrammarForDisallowedTrailingComma(types)) {
	                return true;
	            }
	            if (types && types.length === 0) {
	                var listType = ts.tokenToString(node.token);
	                return grammarErrorAtPos(node, types.pos, 0, ts.Diagnostics._0_list_cannot_be_empty, listType);
	            }
	            return ts.forEach(types, checkGrammarExpressionWithTypeArguments);
	        }
	        function checkGrammarExpressionWithTypeArguments(node) {
	            return checkGrammarTypeArguments(node, node.typeArguments);
	        }
	        function checkGrammarClassDeclarationHeritageClauses(node) {
	            var seenExtendsClause = false;
	            var seenImplementsClause = false;
	            if (!checkGrammarDecoratorsAndModifiers(node) && node.heritageClauses) {
	                for (var _i = 0, _a = node.heritageClauses; _i < _a.length; _i++) {
	                    var heritageClause = _a[_i];
	                    if (heritageClause.token === 85 /* ExtendsKeyword */) {
	                        if (seenExtendsClause) {
	                            return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.extends_clause_already_seen);
	                        }
	                        if (seenImplementsClause) {
	                            return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.extends_clause_must_precede_implements_clause);
	                        }
	                        if (heritageClause.types.length > 1) {
	                            return grammarErrorOnFirstToken(heritageClause.types[1], ts.Diagnostics.Classes_can_only_extend_a_single_class);
	                        }
	                        seenExtendsClause = true;
	                    }
	                    else {
	                        ts.Debug.assert(heritageClause.token === 108 /* ImplementsKeyword */);
	                        if (seenImplementsClause) {
	                            return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.implements_clause_already_seen);
	                        }
	                        seenImplementsClause = true;
	                    }
	                    // Grammar checking heritageClause inside class declaration
	                    checkGrammarHeritageClause(heritageClause);
	                }
	            }
	        }
	        function checkGrammarInterfaceDeclaration(node) {
	            var seenExtendsClause = false;
	            if (node.heritageClauses) {
	                for (var _i = 0, _a = node.heritageClauses; _i < _a.length; _i++) {
	                    var heritageClause = _a[_i];
	                    if (heritageClause.token === 85 /* ExtendsKeyword */) {
	                        if (seenExtendsClause) {
	                            return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.extends_clause_already_seen);
	                        }
	                        seenExtendsClause = true;
	                    }
	                    else {
	                        ts.Debug.assert(heritageClause.token === 108 /* ImplementsKeyword */);
	                        return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.Interface_declaration_cannot_have_implements_clause);
	                    }
	                    // Grammar checking heritageClause inside class declaration
	                    checkGrammarHeritageClause(heritageClause);
	                }
	            }
	            return false;
	        }
	        function checkGrammarComputedPropertyName(node) {
	            // If node is not a computedPropertyName, just skip the grammar checking
	            if (node.kind !== 146 /* ComputedPropertyName */) {
	                return false;
	            }
	            var computedPropertyName = node;
	            if (computedPropertyName.expression.kind === 198 /* BinaryExpression */ && computedPropertyName.expression.operatorToken.kind === 26 /* CommaToken */) {
	                return grammarErrorOnNode(computedPropertyName.expression, ts.Diagnostics.A_comma_expression_is_not_allowed_in_a_computed_property_name);
	            }
	        }
	        function checkGrammarForGenerator(node) {
	            if (node.asteriskToken) {
	                ts.Debug.assert(node.kind === 232 /* FunctionDeclaration */ ||
	                    node.kind === 190 /* FunctionExpression */ ||
	                    node.kind === 153 /* MethodDeclaration */);
	                if (node.flags & 2097152 /* Ambient */) {
	                    return grammarErrorOnNode(node.asteriskToken, ts.Diagnostics.Generators_are_not_allowed_in_an_ambient_context);
	                }
	                if (!node.body) {
	                    return grammarErrorOnNode(node.asteriskToken, ts.Diagnostics.An_overload_signature_cannot_be_declared_as_a_generator);
	                }
	            }
	        }
	        function checkGrammarForInvalidQuestionMark(questionToken, message) {
	            if (questionToken) {
	                return grammarErrorOnNode(questionToken, message);
	            }
	        }
	        function checkGrammarObjectLiteralExpression(node, inDestructuring) {
	            var Flags;
	            (function (Flags) {
	                Flags[Flags["Property"] = 1] = "Property";
	                Flags[Flags["GetAccessor"] = 2] = "GetAccessor";
	                Flags[Flags["SetAccessor"] = 4] = "SetAccessor";
	                Flags[Flags["GetOrSetAccessor"] = 6] = "GetOrSetAccessor";
	            })(Flags || (Flags = {}));
	            var seen = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                var prop = _a[_i];
	                if (prop.kind === 270 /* SpreadAssignment */) {
	                    continue;
	                }
	                var name = prop.name;
	                if (name.kind === 146 /* ComputedPropertyName */) {
	                    // If the name is not a ComputedPropertyName, the grammar checking will skip it
	                    checkGrammarComputedPropertyName(name);
	                }
	                if (prop.kind === 269 /* ShorthandPropertyAssignment */ && !inDestructuring && prop.objectAssignmentInitializer) {
	                    // having objectAssignmentInitializer is only valid in ObjectAssignmentPattern
	                    // outside of destructuring it is a syntax error
	                    return grammarErrorOnNode(prop.equalsToken, ts.Diagnostics.can_only_be_used_in_an_object_literal_property_inside_a_destructuring_assignment);
	                }
	                // Modifiers are never allowed on properties except for 'async' on a method declaration
	                if (prop.modifiers) {
	                    for (var _b = 0, _c = prop.modifiers; _b < _c.length; _b++) {
	                        var mod = _c[_b];
	                        if (mod.kind !== 120 /* AsyncKeyword */ || prop.kind !== 153 /* MethodDeclaration */) {
	                            grammarErrorOnNode(mod, ts.Diagnostics._0_modifier_cannot_be_used_here, ts.getTextOfNode(mod));
	                        }
	                    }
	                }
	                // ECMA-262 11.1.5 Object Initializer
	                // If previous is not undefined then throw a SyntaxError exception if any of the following conditions are true
	                // a.This production is contained in strict code and IsDataDescriptor(previous) is true and
	                // IsDataDescriptor(propId.descriptor) is true.
	                //    b.IsDataDescriptor(previous) is true and IsAccessorDescriptor(propId.descriptor) is true.
	                //    c.IsAccessorDescriptor(previous) is true and IsDataDescriptor(propId.descriptor) is true.
	                //    d.IsAccessorDescriptor(previous) is true and IsAccessorDescriptor(propId.descriptor) is true
	                // and either both previous and propId.descriptor have[[Get]] fields or both previous and propId.descriptor have[[Set]] fields
	                var currentKind = void 0;
	                switch (prop.kind) {
	                    case 268 /* PropertyAssignment */:
	                    case 269 /* ShorthandPropertyAssignment */:
	                        // Grammar checking for computedPropertyName and shorthandPropertyAssignment
	                        checkGrammarForInvalidQuestionMark(prop.questionToken, ts.Diagnostics.An_object_member_cannot_be_declared_optional);
	                        if (name.kind === 8 /* NumericLiteral */) {
	                            checkGrammarNumericLiteral(name);
	                        }
	                    // falls through
	                    case 153 /* MethodDeclaration */:
	                        currentKind = 1 /* Property */;
	                        break;
	                    case 155 /* GetAccessor */:
	                        currentKind = 2 /* GetAccessor */;
	                        break;
	                    case 156 /* SetAccessor */:
	                        currentKind = 4 /* SetAccessor */;
	                        break;
	                    default:
	                        ts.Debug.assertNever(prop, "Unexpected syntax kind:" + prop.kind);
	                }
	                var effectiveName = ts.getPropertyNameForPropertyNameNode(name);
	                if (effectiveName === undefined) {
	                    continue;
	                }
	                var existingKind = seen.get(effectiveName);
	                if (!existingKind) {
	                    seen.set(effectiveName, currentKind);
	                }
	                else {
	                    if (currentKind === 1 /* Property */ && existingKind === 1 /* Property */) {
	                        grammarErrorOnNode(name, ts.Diagnostics.Duplicate_identifier_0, ts.getTextOfNode(name));
	                    }
	                    else if ((currentKind & 6 /* GetOrSetAccessor */) && (existingKind & 6 /* GetOrSetAccessor */)) {
	                        if (existingKind !== 6 /* GetOrSetAccessor */ && currentKind !== existingKind) {
	                            seen.set(effectiveName, currentKind | existingKind);
	                        }
	                        else {
	                            return grammarErrorOnNode(name, ts.Diagnostics.An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name);
	                        }
	                    }
	                    else {
	                        return grammarErrorOnNode(name, ts.Diagnostics.An_object_literal_cannot_have_property_and_accessor_with_the_same_name);
	                    }
	                }
	            }
	        }
	        function checkGrammarJsxElement(node) {
	            var seen = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, _a = node.attributes.properties; _i < _a.length; _i++) {
	                var attr = _a[_i];
	                if (attr.kind === 262 /* JsxSpreadAttribute */) {
	                    continue;
	                }
	                var name = attr.name, initializer = attr.initializer;
	                if (!seen.get(name.escapedText)) {
	                    seen.set(name.escapedText, true);
	                }
	                else {
	                    return grammarErrorOnNode(name, ts.Diagnostics.JSX_elements_cannot_have_multiple_attributes_with_the_same_name);
	                }
	                if (initializer && initializer.kind === 263 /* JsxExpression */ && !initializer.expression) {
	                    return grammarErrorOnNode(initializer, ts.Diagnostics.JSX_attributes_must_only_be_assigned_a_non_empty_expression);
	                }
	            }
	        }
	        function checkGrammarForInOrForOfStatement(forInOrOfStatement) {
	            if (checkGrammarStatementInAmbientContext(forInOrOfStatement)) {
	                return true;
	            }
	            if (forInOrOfStatement.kind === 220 /* ForOfStatement */ && forInOrOfStatement.awaitModifier) {
	                if ((forInOrOfStatement.flags & 16384 /* AwaitContext */) === 0 /* None */) {
	                    return grammarErrorOnNode(forInOrOfStatement.awaitModifier, ts.Diagnostics.A_for_await_of_statement_is_only_allowed_within_an_async_function_or_async_generator);
	                }
	            }
	            if (forInOrOfStatement.initializer.kind === 231 /* VariableDeclarationList */) {
	                var variableList = forInOrOfStatement.initializer;
	                if (!checkGrammarVariableDeclarationList(variableList)) {
	                    var declarations = variableList.declarations;
	                    // declarations.length can be zero if there is an error in variable declaration in for-of or for-in
	                    // See http://www.ecma-international.org/ecma-262/6.0/#sec-for-in-and-for-of-statements for details
	                    // For example:
	                    //      var let = 10;
	                    //      for (let of [1,2,3]) {} // this is invalid ES6 syntax
	                    //      for (let in [1,2,3]) {} // this is invalid ES6 syntax
	                    // We will then want to skip on grammar checking on variableList declaration
	                    if (!declarations.length) {
	                        return false;
	                    }
	                    if (declarations.length > 1) {
	                        var diagnostic = forInOrOfStatement.kind === 219 /* ForInStatement */
	                            ? ts.Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement
	                            : ts.Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement;
	                        return grammarErrorOnFirstToken(variableList.declarations[1], diagnostic);
	                    }
	                    var firstDeclaration = declarations[0];
	                    if (firstDeclaration.initializer) {
	                        var diagnostic = forInOrOfStatement.kind === 219 /* ForInStatement */
	                            ? ts.Diagnostics.The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer
	                            : ts.Diagnostics.The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer;
	                        return grammarErrorOnNode(firstDeclaration.name, diagnostic);
	                    }
	                    if (firstDeclaration.type) {
	                        var diagnostic = forInOrOfStatement.kind === 219 /* ForInStatement */
	                            ? ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation
	                            : ts.Diagnostics.The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation;
	                        return grammarErrorOnNode(firstDeclaration, diagnostic);
	                    }
	                }
	            }
	            return false;
	        }
	        function checkGrammarAccessor(accessor) {
	            var kind = accessor.kind;
	            if (languageVersion < 1 /* ES5 */) {
	                return grammarErrorOnNode(accessor.name, ts.Diagnostics.Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher);
	            }
	            else if (accessor.flags & 2097152 /* Ambient */) {
	                return grammarErrorOnNode(accessor.name, ts.Diagnostics.An_accessor_cannot_be_declared_in_an_ambient_context);
	            }
	            else if (accessor.body === undefined && !ts.hasModifier(accessor, 128 /* Abstract */)) {
	                return grammarErrorAtPos(accessor, accessor.end - 1, ";".length, ts.Diagnostics._0_expected, "{");
	            }
	            else if (accessor.body && ts.hasModifier(accessor, 128 /* Abstract */)) {
	                return grammarErrorOnNode(accessor, ts.Diagnostics.An_abstract_accessor_cannot_have_an_implementation);
	            }
	            else if (accessor.typeParameters) {
	                return grammarErrorOnNode(accessor.name, ts.Diagnostics.An_accessor_cannot_have_type_parameters);
	            }
	            else if (!doesAccessorHaveCorrectParameterCount(accessor)) {
	                return grammarErrorOnNode(accessor.name, kind === 155 /* GetAccessor */ ?
	                    ts.Diagnostics.A_get_accessor_cannot_have_parameters :
	                    ts.Diagnostics.A_set_accessor_must_have_exactly_one_parameter);
	            }
	            else if (kind === 156 /* SetAccessor */) {
	                if (accessor.type) {
	                    return grammarErrorOnNode(accessor.name, ts.Diagnostics.A_set_accessor_cannot_have_a_return_type_annotation);
	                }
	                else {
	                    var parameter = accessor.parameters[0];
	                    if (parameter.dotDotDotToken) {
	                        return grammarErrorOnNode(parameter.dotDotDotToken, ts.Diagnostics.A_set_accessor_cannot_have_rest_parameter);
	                    }
	                    else if (parameter.questionToken) {
	                        return grammarErrorOnNode(parameter.questionToken, ts.Diagnostics.A_set_accessor_cannot_have_an_optional_parameter);
	                    }
	                    else if (parameter.initializer) {
	                        return grammarErrorOnNode(accessor.name, ts.Diagnostics.A_set_accessor_parameter_cannot_have_an_initializer);
	                    }
	                }
	            }
	        }
	        /** Does the accessor have the right number of parameters?
	         * A get accessor has no parameters or a single `this` parameter.
	         * A set accessor has one parameter or a `this` parameter and one more parameter.
	         */
	        function doesAccessorHaveCorrectParameterCount(accessor) {
	            return getAccessorThisParameter(accessor) || accessor.parameters.length === (accessor.kind === 155 /* GetAccessor */ ? 0 : 1);
	        }
	        function getAccessorThisParameter(accessor) {
	            if (accessor.parameters.length === (accessor.kind === 155 /* GetAccessor */ ? 1 : 2)) {
	                return ts.getThisParameter(accessor);
	            }
	        }
	        function checkGrammarTypeOperatorNode(node) {
	            if (node.operator === 141 /* UniqueKeyword */) {
	                if (node.type.kind !== 138 /* SymbolKeyword */) {
	                    return grammarErrorOnNode(node.type, ts.Diagnostics._0_expected, ts.tokenToString(138 /* SymbolKeyword */));
	                }
	                var parent = ts.walkUpParenthesizedTypes(node.parent);
	                switch (parent.kind) {
	                    case 230 /* VariableDeclaration */:
	                        var decl = parent;
	                        if (decl.name.kind !== 71 /* Identifier */) {
	                            return grammarErrorOnNode(node, ts.Diagnostics.unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name);
	                        }
	                        if (!ts.isVariableDeclarationInVariableStatement(decl)) {
	                            return grammarErrorOnNode(node, ts.Diagnostics.unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement);
	                        }
	                        if (!(decl.parent.flags & 2 /* Const */)) {
	                            return grammarErrorOnNode(parent.name, ts.Diagnostics.A_variable_whose_type_is_a_unique_symbol_type_must_be_const);
	                        }
	                        break;
	                    case 151 /* PropertyDeclaration */:
	                        if (!ts.hasModifier(parent, 32 /* Static */) ||
	                            !ts.hasModifier(parent, 64 /* Readonly */)) {
	                            return grammarErrorOnNode(parent.name, ts.Diagnostics.A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly);
	                        }
	                        break;
	                    case 150 /* PropertySignature */:
	                        if (!ts.hasModifier(parent, 64 /* Readonly */)) {
	                            return grammarErrorOnNode(parent.name, ts.Diagnostics.A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly);
	                        }
	                        break;
	                    default:
	                        return grammarErrorOnNode(node, ts.Diagnostics.unique_symbol_types_are_not_allowed_here);
	                }
	            }
	        }
	        function checkGrammarForInvalidDynamicName(node, message) {
	            if (isNonBindableDynamicName(node)) {
	                return grammarErrorOnNode(node, message);
	            }
	        }
	        function checkGrammarMethod(node) {
	            if (checkGrammarFunctionLikeDeclaration(node)) {
	                return true;
	            }
	            if (node.kind === 153 /* MethodDeclaration */) {
	                if (node.parent.kind === 182 /* ObjectLiteralExpression */) {
	                    // We only disallow modifier on a method declaration if it is a property of object-literal-expression
	                    if (node.modifiers && !(node.modifiers.length === 1 && ts.first(node.modifiers).kind === 120 /* AsyncKeyword */)) {
	                        return grammarErrorOnFirstToken(node, ts.Diagnostics.Modifiers_cannot_appear_here);
	                    }
	                    else if (checkGrammarForInvalidQuestionMark(node.questionToken, ts.Diagnostics.An_object_member_cannot_be_declared_optional)) {
	                        return true;
	                    }
	                    else if (node.body === undefined) {
	                        return grammarErrorAtPos(node, node.end - 1, ";".length, ts.Diagnostics._0_expected, "{");
	                    }
	                }
	                if (checkGrammarForGenerator(node)) {
	                    return true;
	                }
	            }
	            if (ts.isClassLike(node.parent)) {
	                // Technically, computed properties in ambient contexts is disallowed
	                // for property declarations and accessors too, not just methods.
	                // However, property declarations disallow computed names in general,
	                // and accessors are not allowed in ambient contexts in general,
	                // so this error only really matters for methods.
	                if (node.flags & 2097152 /* Ambient */) {
	                    return checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
	                }
	                else if (node.kind === 153 /* MethodDeclaration */ && !node.body) {
	                    return checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
	                }
	            }
	            else if (node.parent.kind === 234 /* InterfaceDeclaration */) {
	                return checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
	            }
	            else if (node.parent.kind === 165 /* TypeLiteral */) {
	                return checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
	            }
	        }
	        function checkGrammarBreakOrContinueStatement(node) {
	            var current = node;
	            while (current) {
	                if (ts.isFunctionLike(current)) {
	                    return grammarErrorOnNode(node, ts.Diagnostics.Jump_target_cannot_cross_function_boundary);
	                }
	                switch (current.kind) {
	                    case 226 /* LabeledStatement */:
	                        if (node.label && current.label.escapedText === node.label.escapedText) {
	                            // found matching label - verify that label usage is correct
	                            // continue can only target labels that are on iteration statements
	                            var isMisplacedContinueLabel = node.kind === 221 /* ContinueStatement */
	                                && !ts.isIterationStatement(current.statement, /*lookInLabeledStatement*/ true);
	                            if (isMisplacedContinueLabel) {
	                                return grammarErrorOnNode(node, ts.Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement);
	                            }
	                            return false;
	                        }
	                        break;
	                    case 225 /* SwitchStatement */:
	                        if (node.kind === 222 /* BreakStatement */ && !node.label) {
	                            // unlabeled break within switch statement - ok
	                            return false;
	                        }
	                        break;
	                    default:
	                        if (ts.isIterationStatement(current, /*lookInLabeledStatement*/ false) && !node.label) {
	                            // unlabeled break or continue within iteration statement - ok
	                            return false;
	                        }
	                        break;
	                }
	                current = current.parent;
	            }
	            if (node.label) {
	                var message = node.kind === 222 /* BreakStatement */
	                    ? ts.Diagnostics.A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement
	                    : ts.Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement;
	                return grammarErrorOnNode(node, message);
	            }
	            else {
	                var message = node.kind === 222 /* BreakStatement */
	                    ? ts.Diagnostics.A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement
	                    : ts.Diagnostics.A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement;
	                return grammarErrorOnNode(node, message);
	            }
	        }
	        function checkGrammarBindingElement(node) {
	            if (node.dotDotDotToken) {
	                var elements = node.parent.elements;
	                if (node !== ts.last(elements)) {
	                    return grammarErrorOnNode(node, ts.Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
	                }
	                if (node.name.kind === 179 /* ArrayBindingPattern */ || node.name.kind === 178 /* ObjectBindingPattern */) {
	                    return grammarErrorOnNode(node.name, ts.Diagnostics.A_rest_element_cannot_contain_a_binding_pattern);
	                }
	                if (node.propertyName) {
	                    return grammarErrorOnNode(node.name, ts.Diagnostics.A_rest_element_cannot_have_a_property_name);
	                }
	                if (node.initializer) {
	                    // Error on equals token which immediately precedes the initializer
	                    return grammarErrorAtPos(node, node.initializer.pos - 1, 1, ts.Diagnostics.A_rest_element_cannot_have_an_initializer);
	                }
	            }
	        }
	        function isStringOrNumberLiteralExpression(expr) {
	            return expr.kind === 9 /* StringLiteral */ || expr.kind === 8 /* NumericLiteral */ ||
	                expr.kind === 196 /* PrefixUnaryExpression */ && expr.operator === 38 /* MinusToken */ &&
	                    expr.operand.kind === 8 /* NumericLiteral */;
	        }
	        function checkGrammarVariableDeclaration(node) {
	            if (node.parent.parent.kind !== 219 /* ForInStatement */ && node.parent.parent.kind !== 220 /* ForOfStatement */) {
	                if (node.flags & 2097152 /* Ambient */) {
	                    if (node.initializer) {
	                        if (ts.isConst(node) && !node.type) {
	                            if (!isStringOrNumberLiteralExpression(node.initializer)) {
	                                return grammarErrorOnNode(node.initializer, ts.Diagnostics.A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal);
	                            }
	                        }
	                        else {
	                            // Error on equals token which immediate precedes the initializer
	                            var equalsTokenLength = "=".length;
	                            return grammarErrorAtPos(node, node.initializer.pos - equalsTokenLength, equalsTokenLength, ts.Diagnostics.Initializers_are_not_allowed_in_ambient_contexts);
	                        }
	                    }
	                    if (node.initializer && !(ts.isConst(node) && isStringOrNumberLiteralExpression(node.initializer))) {
	                        // Error on equals token which immediate precedes the initializer
	                        var equalsTokenLength = "=".length;
	                        return grammarErrorAtPos(node, node.initializer.pos - equalsTokenLength, equalsTokenLength, ts.Diagnostics.Initializers_are_not_allowed_in_ambient_contexts);
	                    }
	                }
	                else if (!node.initializer) {
	                    if (ts.isBindingPattern(node.name) && !ts.isBindingPattern(node.parent)) {
	                        return grammarErrorOnNode(node, ts.Diagnostics.A_destructuring_declaration_must_have_an_initializer);
	                    }
	                    if (ts.isConst(node)) {
	                        return grammarErrorOnNode(node, ts.Diagnostics.const_declarations_must_be_initialized);
	                    }
	                }
	            }
	            if (node.exclamationToken && (node.parent.parent.kind !== 212 /* VariableStatement */ || !node.type || node.initializer || node.flags & 2097152 /* Ambient */)) {
	                return grammarErrorOnNode(node.exclamationToken, ts.Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context);
	            }
	            if (compilerOptions.module !== ts.ModuleKind.ES2015 && compilerOptions.module !== ts.ModuleKind.ESNext && compilerOptions.module !== ts.ModuleKind.System && !compilerOptions.noEmit &&
	                !(node.parent.parent.flags & 2097152 /* Ambient */) && ts.hasModifier(node.parent.parent, 1 /* Export */)) {
	                checkESModuleMarker(node.name);
	            }
	            var checkLetConstNames = (ts.isLet(node) || ts.isConst(node));
	            // 1. LexicalDeclaration : LetOrConst BindingList ;
	            // It is a Syntax Error if the BoundNames of BindingList contains "let".
	            // 2. ForDeclaration: ForDeclaration : LetOrConst ForBinding
	            // It is a Syntax Error if the BoundNames of ForDeclaration contains "let".
	            // It is a SyntaxError if a VariableDeclaration or VariableDeclarationNoIn occurs within strict code
	            // and its Identifier is eval or arguments
	            return checkLetConstNames && checkGrammarNameInLetOrConstDeclarations(node.name);
	        }
	        function checkESModuleMarker(name) {
	            if (name.kind === 71 /* Identifier */) {
	                if (ts.idText(name) === "__esModule") {
	                    return grammarErrorOnNode(name, ts.Diagnostics.Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules);
	                }
	            }
	            else {
	                var elements = name.elements;
	                for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
	                    var element = elements_1[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        return checkESModuleMarker(element.name);
	                    }
	                }
	            }
	        }
	        function checkGrammarNameInLetOrConstDeclarations(name) {
	            if (name.kind === 71 /* Identifier */) {
	                if (name.originalKeywordKind === 110 /* LetKeyword */) {
	                    return grammarErrorOnNode(name, ts.Diagnostics.let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations);
	                }
	            }
	            else {
	                var elements = name.elements;
	                for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
	                    var element = elements_2[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        checkGrammarNameInLetOrConstDeclarations(element.name);
	                    }
	                }
	            }
	        }
	        function checkGrammarVariableDeclarationList(declarationList) {
	            var declarations = declarationList.declarations;
	            if (checkGrammarForDisallowedTrailingComma(declarationList.declarations)) {
	                return true;
	            }
	            if (!declarationList.declarations.length) {
	                return grammarErrorAtPos(declarationList, declarations.pos, declarations.end - declarations.pos, ts.Diagnostics.Variable_declaration_list_cannot_be_empty);
	            }
	        }
	        function allowLetAndConstDeclarations(parent) {
	            switch (parent.kind) {
	                case 215 /* IfStatement */:
	                case 216 /* DoStatement */:
	                case 217 /* WhileStatement */:
	                case 224 /* WithStatement */:
	                case 218 /* ForStatement */:
	                case 219 /* ForInStatement */:
	                case 220 /* ForOfStatement */:
	                    return false;
	                case 226 /* LabeledStatement */:
	                    return allowLetAndConstDeclarations(parent.parent);
	            }
	            return true;
	        }
	        function checkGrammarForDisallowedLetOrConstStatement(node) {
	            if (!allowLetAndConstDeclarations(node.parent)) {
	                if (ts.isLet(node.declarationList)) {
	                    return grammarErrorOnNode(node, ts.Diagnostics.let_declarations_can_only_be_declared_inside_a_block);
	                }
	                else if (ts.isConst(node.declarationList)) {
	                    return grammarErrorOnNode(node, ts.Diagnostics.const_declarations_can_only_be_declared_inside_a_block);
	                }
	            }
	        }
	        function checkGrammarMetaProperty(node) {
	            if (node.keywordToken === 94 /* NewKeyword */) {
	                if (node.name.escapedText !== "target") {
	                    return grammarErrorOnNode(node.name, ts.Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2, node.name.escapedText, ts.tokenToString(node.keywordToken), "target");
	                }
	            }
	        }
	        function hasParseDiagnostics(sourceFile) {
	            return sourceFile.parseDiagnostics.length > 0;
	        }
	        function grammarErrorOnFirstToken(node, message, arg0, arg1, arg2) {
	            var sourceFile = ts.getSourceFileOfNode(node);
	            if (!hasParseDiagnostics(sourceFile)) {
	                var span_4 = ts.getSpanOfTokenAtPosition(sourceFile, node.pos);
	                diagnostics.add(ts.createFileDiagnostic(sourceFile, span_4.start, span_4.length, message, arg0, arg1, arg2));
	                return true;
	            }
	        }
	        function grammarErrorAtPos(nodeForSourceFile, start, length, message, arg0, arg1, arg2) {
	            var sourceFile = ts.getSourceFileOfNode(nodeForSourceFile);
	            if (!hasParseDiagnostics(sourceFile)) {
	                diagnostics.add(ts.createFileDiagnostic(sourceFile, start, length, message, arg0, arg1, arg2));
	                return true;
	            }
	        }
	        function grammarErrorOnNode(node, message, arg0, arg1, arg2) {
	            var sourceFile = ts.getSourceFileOfNode(node);
	            if (!hasParseDiagnostics(sourceFile)) {
	                diagnostics.add(ts.createDiagnosticForNode(node, message, arg0, arg1, arg2));
	                return true;
	            }
	        }
	        function checkGrammarConstructorTypeParameters(node) {
	            var typeParameters = ts.getEffectiveTypeParameterDeclarations(node);
	            if (typeParameters) {
	                var _a = ts.isNodeArray(typeParameters) ? typeParameters : ts.first(typeParameters), pos = _a.pos, end = _a.end;
	                return grammarErrorAtPos(node, pos, end - pos, ts.Diagnostics.Type_parameters_cannot_appear_on_a_constructor_declaration);
	            }
	        }
	        function checkGrammarConstructorTypeAnnotation(node) {
	            var type = ts.getEffectiveReturnTypeNode(node);
	            if (type) {
	                return grammarErrorOnNode(type, ts.Diagnostics.Type_annotation_cannot_appear_on_a_constructor_declaration);
	            }
	        }
	        function checkGrammarProperty(node) {
	            if (ts.isClassLike(node.parent)) {
	                if (checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_a_class_property_declaration_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) {
	                    return true;
	                }
	            }
	            else if (node.parent.kind === 234 /* InterfaceDeclaration */) {
	                if (checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) {
	                    return true;
	                }
	                if (node.initializer) {
	                    return grammarErrorOnNode(node.initializer, ts.Diagnostics.An_interface_property_cannot_have_an_initializer);
	                }
	            }
	            else if (node.parent.kind === 165 /* TypeLiteral */) {
	                if (checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) {
	                    return true;
	                }
	                if (node.initializer) {
	                    return grammarErrorOnNode(node.initializer, ts.Diagnostics.A_type_literal_property_cannot_have_an_initializer);
	                }
	            }
	            if (node.flags & 2097152 /* Ambient */ && node.initializer) {
	                return grammarErrorOnFirstToken(node.initializer, ts.Diagnostics.Initializers_are_not_allowed_in_ambient_contexts);
	            }
	            if (ts.isPropertyDeclaration(node) && node.exclamationToken && (!ts.isClassLike(node.parent) || !node.type || node.initializer ||
	                node.flags & 2097152 /* Ambient */ || ts.hasModifier(node, 32 /* Static */ | 128 /* Abstract */))) {
	                return grammarErrorOnNode(node.exclamationToken, ts.Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context);
	            }
	        }
	        function checkGrammarTopLevelElementForRequiredDeclareModifier(node) {
	            // A declare modifier is required for any top level .d.ts declaration except export=, export default, export as namespace
	            // interfaces and imports categories:
	            //
	            //  DeclarationElement:
	            //     ExportAssignment
	            //     export_opt   InterfaceDeclaration
	            //     export_opt   TypeAliasDeclaration
	            //     export_opt   ImportDeclaration
	            //     export_opt   ExternalImportDeclaration
	            //     export_opt   AmbientDeclaration
	            //
	            // TODO: The spec needs to be amended to reflect this grammar.
	            if (node.kind === 234 /* InterfaceDeclaration */ ||
	                node.kind === 235 /* TypeAliasDeclaration */ ||
	                node.kind === 242 /* ImportDeclaration */ ||
	                node.kind === 241 /* ImportEqualsDeclaration */ ||
	                node.kind === 248 /* ExportDeclaration */ ||
	                node.kind === 247 /* ExportAssignment */ ||
	                node.kind === 240 /* NamespaceExportDeclaration */ ||
	                ts.hasModifier(node, 2 /* Ambient */ | 1 /* Export */ | 512 /* Default */)) {
	                return false;
	            }
	            return grammarErrorOnFirstToken(node, ts.Diagnostics.A_declare_modifier_is_required_for_a_top_level_declaration_in_a_d_ts_file);
	        }
	        function checkGrammarTopLevelElementsForRequiredDeclareModifier(file) {
	            for (var _i = 0, _a = file.statements; _i < _a.length; _i++) {
	                var decl = _a[_i];
	                if (ts.isDeclaration(decl) || decl.kind === 212 /* VariableStatement */) {
	                    if (checkGrammarTopLevelElementForRequiredDeclareModifier(decl)) {
	                        return true;
	                    }
	                }
	            }
	        }
	        function checkGrammarSourceFile(node) {
	            return !!(node.flags & 2097152 /* Ambient */) && checkGrammarTopLevelElementsForRequiredDeclareModifier(node);
	        }
	        function checkGrammarStatementInAmbientContext(node) {
	            if (node.flags & 2097152 /* Ambient */) {
	                // An accessors is already reported about the ambient context
	                if (ts.isAccessor(node.parent)) {
	                    return getNodeLinks(node).hasReportedStatementInAmbientContext = true;
	                }
	                // Find containing block which is either Block, ModuleBlock, SourceFile
	                var links = getNodeLinks(node);
	                if (!links.hasReportedStatementInAmbientContext && ts.isFunctionLike(node.parent)) {
	                    return getNodeLinks(node).hasReportedStatementInAmbientContext = grammarErrorOnFirstToken(node, ts.Diagnostics.An_implementation_cannot_be_declared_in_ambient_contexts);
	                }
	                // We are either parented by another statement, or some sort of block.
	                // If we're in a block, we only want to really report an error once
	                // to prevent noisiness.  So use a bit on the block to indicate if
	                // this has already been reported, and don't report if it has.
	                //
	                if (node.parent.kind === 211 /* Block */ || node.parent.kind === 238 /* ModuleBlock */ || node.parent.kind === 272 /* SourceFile */) {
	                    var links_1 = getNodeLinks(node.parent);
	                    // Check if the containing block ever report this error
	                    if (!links_1.hasReportedStatementInAmbientContext) {
	                        return links_1.hasReportedStatementInAmbientContext = grammarErrorOnFirstToken(node, ts.Diagnostics.Statements_are_not_allowed_in_ambient_contexts);
	                    }
	                }
	                else {
	                    // We must be parented by a statement.  If so, there's no need
	                    // to report the error as our parent will have already done it.
	                    // Debug.assert(isStatement(node.parent));
	                }
	            }
	        }
	        function checkGrammarNumericLiteral(node) {
	            // Grammar checking
	            if (node.numericLiteralFlags & 32 /* Octal */) {
	                var diagnosticMessage = void 0;
	                if (languageVersion >= 1 /* ES5 */) {
	                    diagnosticMessage = ts.Diagnostics.Octal_literals_are_not_available_when_targeting_ECMAScript_5_and_higher_Use_the_syntax_0;
	                }
	                else if (ts.isChildOfNodeWithKind(node, 177 /* LiteralType */)) {
	                    diagnosticMessage = ts.Diagnostics.Octal_literal_types_must_use_ES2015_syntax_Use_the_syntax_0;
	                }
	                else if (ts.isChildOfNodeWithKind(node, 271 /* EnumMember */)) {
	                    diagnosticMessage = ts.Diagnostics.Octal_literals_are_not_allowed_in_enums_members_initializer_Use_the_syntax_0;
	                }
	                if (diagnosticMessage) {
	                    var withMinus = ts.isPrefixUnaryExpression(node.parent) && node.parent.operator === 38 /* MinusToken */;
	                    var literal = (withMinus ? "-" : "") + "0o" + node.text;
	                    return grammarErrorOnNode(withMinus ? node.parent : node, diagnosticMessage, literal);
	                }
	            }
	        }
	        function grammarErrorAfterFirstToken(node, message, arg0, arg1, arg2) {
	            var sourceFile = ts.getSourceFileOfNode(node);
	            if (!hasParseDiagnostics(sourceFile)) {
	                var span_5 = ts.getSpanOfTokenAtPosition(sourceFile, node.pos);
	                diagnostics.add(ts.createFileDiagnostic(sourceFile, ts.textSpanEnd(span_5), /*length*/ 0, message, arg0, arg1, arg2));
	                return true;
	            }
	        }
	        function getAmbientModules() {
	            if (!ambientModulesCache) {
	                ambientModulesCache = [];
	                globals.forEach(function (global, sym) {
	                    // No need to `unescapeLeadingUnderscores`, an escaped symbol is never an ambient module.
	                    if (ambientModuleSymbolRegex.test(sym)) {
	                        ambientModulesCache.push(global);
	                    }
	                });
	            }
	            return ambientModulesCache;
	        }
	        function checkGrammarImportCallExpression(node) {
	            if (modulekind === ts.ModuleKind.ES2015) {
	                return grammarErrorOnNode(node, ts.Diagnostics.Dynamic_import_cannot_be_used_when_targeting_ECMAScript_2015_modules);
	            }
	            if (node.typeArguments) {
	                return grammarErrorOnNode(node, ts.Diagnostics.Dynamic_import_cannot_have_type_arguments);
	            }
	            var nodeArguments = node.arguments;
	            if (nodeArguments.length !== 1) {
	                return grammarErrorOnNode(node, ts.Diagnostics.Dynamic_import_must_have_one_specifier_as_an_argument);
	            }
	            // see: parseArgumentOrArrayLiteralElement...we use this function which parse arguments of callExpression to parse specifier for dynamic import.
	            // parseArgumentOrArrayLiteralElement allows spread element to be in an argument list which is not allowed as specifier in dynamic import.
	            if (ts.isSpreadElement(nodeArguments[0])) {
	                return grammarErrorOnNode(nodeArguments[0], ts.Diagnostics.Specifier_of_dynamic_import_cannot_be_spread_element);
	            }
	        }
	    }
	    ts.createTypeChecker = createTypeChecker;
	    /** Like 'isDeclarationName', but returns true for LHS of `import { x as y }` or `export { x as y }`. */
	    function isDeclarationNameOrImportPropertyName(name) {
	        switch (name.parent.kind) {
	            case 246 /* ImportSpecifier */:
	            case 250 /* ExportSpecifier */:
	                return ts.isIdentifier(name);
	            default:
	                return ts.isDeclarationName(name);
	        }
	    }
	    function isSomeImportDeclaration(decl) {
	        switch (decl.kind) {
	            case 243 /* ImportClause */: // For default import
	            case 241 /* ImportEqualsDeclaration */:
	            case 244 /* NamespaceImport */:
	            case 246 /* ImportSpecifier */:// For rename import `x as y`
	                return true;
	            case 71 /* Identifier */:
	                // For regular import, `decl` is an Identifier under the ImportSpecifier.
	                return decl.parent.kind === 246 /* ImportSpecifier */;
	            default:
	                return false;
	        }
	    }
	    var JsxNames;
	    (function (JsxNames) {
	        // tslint:disable variable-name
	        JsxNames.JSX = "JSX";
	        JsxNames.IntrinsicElements = "IntrinsicElements";
	        JsxNames.ElementClass = "ElementClass";
	        JsxNames.ElementAttributesPropertyNameContainer = "ElementAttributesProperty";
	        JsxNames.ElementChildrenAttributeNameContainer = "ElementChildrenAttribute";
	        JsxNames.Element = "Element";
	        JsxNames.IntrinsicAttributes = "IntrinsicAttributes";
	        JsxNames.IntrinsicClassAttributes = "IntrinsicClassAttributes";
	        // tslint:enable variable-name
	    })(JsxNames || (JsxNames = {}));
	})(ts || (ts = {}));
	/// <reference path="core.ts"/>
	/// <reference path="utilities.ts"/>
	var ts;
	(function (ts) {
	    function createSynthesizedNode(kind) {
	        var node = ts.createNode(kind, -1, -1);
	        node.flags |= 8 /* Synthesized */;
	        return node;
	    }
	    /* @internal */
	    function updateNode(updated, original) {
	        if (updated !== original) {
	            setOriginalNode(updated, original);
	            setTextRange(updated, original);
	            ts.aggregateTransformFlags(updated);
	        }
	        return updated;
	    }
	    ts.updateNode = updateNode;
	    /**
	     * Make `elements` into a `NodeArray<T>`. If `elements` is `undefined`, returns an empty `NodeArray<T>`.
	     */
	    function createNodeArray(elements, hasTrailingComma) {
	        if (elements) {
	            if (ts.isNodeArray(elements)) {
	                return elements;
	            }
	        }
	        else {
	            elements = [];
	        }
	        var array = elements;
	        array.pos = -1;
	        array.end = -1;
	        array.hasTrailingComma = hasTrailingComma;
	        return array;
	    }
	    ts.createNodeArray = createNodeArray;
	    /**
	     * Creates a shallow, memberwise clone of a node with no source map location.
	     */
	    /* @internal */
	    function getSynthesizedClone(node) {
	        // We don't use "clone" from core.ts here, as we need to preserve the prototype chain of
	        // the original node. We also need to exclude specific properties and only include own-
	        // properties (to skip members already defined on the shared prototype).
	        if (node === undefined) {
	            return undefined;
	        }
	        var clone = createSynthesizedNode(node.kind);
	        clone.flags |= node.flags;
	        setOriginalNode(clone, node);
	        for (var key in node) {
	            if (clone.hasOwnProperty(key) || !node.hasOwnProperty(key)) {
	                continue;
	            }
	            clone[key] = node[key];
	        }
	        return clone;
	    }
	    ts.getSynthesizedClone = getSynthesizedClone;
	    function createLiteral(value) {
	        if (typeof value === "number") {
	            return createNumericLiteral(value + "");
	        }
	        if (typeof value === "boolean") {
	            return value ? createTrue() : createFalse();
	        }
	        if (ts.isString(value)) {
	            return createStringLiteral(value);
	        }
	        return createLiteralFromNode(value);
	    }
	    ts.createLiteral = createLiteral;
	    function createNumericLiteral(value) {
	        var node = createSynthesizedNode(8 /* NumericLiteral */);
	        node.text = value;
	        node.numericLiteralFlags = 0;
	        return node;
	    }
	    ts.createNumericLiteral = createNumericLiteral;
	    function createStringLiteral(text) {
	        var node = createSynthesizedNode(9 /* StringLiteral */);
	        node.text = text;
	        return node;
	    }
	    function createLiteralFromNode(sourceNode) {
	        var node = createStringLiteral(ts.getTextOfIdentifierOrLiteral(sourceNode));
	        node.textSourceNode = sourceNode;
	        return node;
	    }
	    function createIdentifier(text, typeArguments) {
	        var node = createSynthesizedNode(71 /* Identifier */);
	        node.escapedText = ts.escapeLeadingUnderscores(text);
	        node.originalKeywordKind = text ? ts.stringToToken(text) : 0 /* Unknown */;
	        node.autoGenerateFlags = 0 /* None */;
	        node.autoGenerateId = 0;
	        if (typeArguments) {
	            node.typeArguments = createNodeArray(typeArguments);
	        }
	        return node;
	    }
	    ts.createIdentifier = createIdentifier;
	    function updateIdentifier(node, typeArguments) {
	        return node.typeArguments !== typeArguments
	            ? updateNode(createIdentifier(ts.idText(node), typeArguments), node)
	            : node;
	    }
	    ts.updateIdentifier = updateIdentifier;
	    var nextAutoGenerateId = 0;
	    function createTempVariable(recordTempVariable, reservedInNestedScopes) {
	        var name = createIdentifier("");
	        name.autoGenerateFlags = 1 /* Auto */;
	        name.autoGenerateId = nextAutoGenerateId;
	        nextAutoGenerateId++;
	        if (recordTempVariable) {
	            recordTempVariable(name);
	        }
	        if (reservedInNestedScopes) {
	            name.autoGenerateFlags |= 16 /* ReservedInNestedScopes */;
	        }
	        return name;
	    }
	    ts.createTempVariable = createTempVariable;
	    /** Create a unique temporary variable for use in a loop. */
	    function createLoopVariable() {
	        var name = createIdentifier("");
	        name.autoGenerateFlags = 2 /* Loop */;
	        name.autoGenerateId = nextAutoGenerateId;
	        nextAutoGenerateId++;
	        return name;
	    }
	    ts.createLoopVariable = createLoopVariable;
	    /** Create a unique name based on the supplied text. */
	    function createUniqueName(text) {
	        var name = createIdentifier(text);
	        name.autoGenerateFlags = 3 /* Unique */;
	        name.autoGenerateId = nextAutoGenerateId;
	        nextAutoGenerateId++;
	        return name;
	    }
	    ts.createUniqueName = createUniqueName;
	    function getGeneratedNameForNode(node, shouldSkipNameGenerationScope) {
	        var name = createIdentifier("");
	        name.autoGenerateFlags = 4 /* Node */;
	        name.autoGenerateId = nextAutoGenerateId;
	        name.original = node;
	        if (shouldSkipNameGenerationScope) {
	            name.autoGenerateFlags |= 8 /* SkipNameGenerationScope */;
	        }
	        nextAutoGenerateId++;
	        return name;
	    }
	    ts.getGeneratedNameForNode = getGeneratedNameForNode;
	    // Punctuation
	    function createToken(token) {
	        return createSynthesizedNode(token);
	    }
	    ts.createToken = createToken;
	    // Reserved words
	    function createSuper() {
	        return createSynthesizedNode(97 /* SuperKeyword */);
	    }
	    ts.createSuper = createSuper;
	    function createThis() {
	        return createSynthesizedNode(99 /* ThisKeyword */);
	    }
	    ts.createThis = createThis;
	    function createNull() {
	        return createSynthesizedNode(95 /* NullKeyword */);
	    }
	    ts.createNull = createNull;
	    function createTrue() {
	        return createSynthesizedNode(101 /* TrueKeyword */);
	    }
	    ts.createTrue = createTrue;
	    function createFalse() {
	        return createSynthesizedNode(86 /* FalseKeyword */);
	    }
	    ts.createFalse = createFalse;
	    // Names
	    function createQualifiedName(left, right) {
	        var node = createSynthesizedNode(145 /* QualifiedName */);
	        node.left = left;
	        node.right = asName(right);
	        return node;
	    }
	    ts.createQualifiedName = createQualifiedName;
	    function updateQualifiedName(node, left, right) {
	        return node.left !== left
	            || node.right !== right
	            ? updateNode(createQualifiedName(left, right), node)
	            : node;
	    }
	    ts.updateQualifiedName = updateQualifiedName;
	    function createComputedPropertyName(expression) {
	        var node = createSynthesizedNode(146 /* ComputedPropertyName */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createComputedPropertyName = createComputedPropertyName;
	    function updateComputedPropertyName(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createComputedPropertyName(expression), node)
	            : node;
	    }
	    ts.updateComputedPropertyName = updateComputedPropertyName;
	    // Signature elements
	    function createTypeParameterDeclaration(name, constraint, defaultType) {
	        var node = createSynthesizedNode(147 /* TypeParameter */);
	        node.name = asName(name);
	        node.constraint = constraint;
	        node.default = defaultType;
	        return node;
	    }
	    ts.createTypeParameterDeclaration = createTypeParameterDeclaration;
	    function updateTypeParameterDeclaration(node, name, constraint, defaultType) {
	        return node.name !== name
	            || node.constraint !== constraint
	            || node.default !== defaultType
	            ? updateNode(createTypeParameterDeclaration(name, constraint, defaultType), node)
	            : node;
	    }
	    ts.updateTypeParameterDeclaration = updateTypeParameterDeclaration;
	    function createParameter(decorators, modifiers, dotDotDotToken, name, questionToken, type, initializer) {
	        var node = createSynthesizedNode(148 /* Parameter */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.dotDotDotToken = dotDotDotToken;
	        node.name = asName(name);
	        node.questionToken = questionToken;
	        node.type = type;
	        node.initializer = initializer ? ts.parenthesizeExpressionForList(initializer) : undefined;
	        return node;
	    }
	    ts.createParameter = createParameter;
	    function updateParameter(node, decorators, modifiers, dotDotDotToken, name, questionToken, type, initializer) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.dotDotDotToken !== dotDotDotToken
	            || node.name !== name
	            || node.questionToken !== questionToken
	            || node.type !== type
	            || node.initializer !== initializer
	            ? updateNode(createParameter(decorators, modifiers, dotDotDotToken, name, questionToken, type, initializer), node)
	            : node;
	    }
	    ts.updateParameter = updateParameter;
	    function createDecorator(expression) {
	        var node = createSynthesizedNode(149 /* Decorator */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        return node;
	    }
	    ts.createDecorator = createDecorator;
	    function updateDecorator(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createDecorator(expression), node)
	            : node;
	    }
	    ts.updateDecorator = updateDecorator;
	    // Type Elements
	    function createPropertySignature(modifiers, name, questionToken, type, initializer) {
	        var node = createSynthesizedNode(150 /* PropertySignature */);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.questionToken = questionToken;
	        node.type = type;
	        node.initializer = initializer;
	        return node;
	    }
	    ts.createPropertySignature = createPropertySignature;
	    function updatePropertySignature(node, modifiers, name, questionToken, type, initializer) {
	        return node.modifiers !== modifiers
	            || node.name !== name
	            || node.questionToken !== questionToken
	            || node.type !== type
	            || node.initializer !== initializer
	            ? updateNode(createPropertySignature(modifiers, name, questionToken, type, initializer), node)
	            : node;
	    }
	    ts.updatePropertySignature = updatePropertySignature;
	    function createProperty(decorators, modifiers, name, questionOrExclamationToken, type, initializer) {
	        var node = createSynthesizedNode(151 /* PropertyDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.questionToken = questionOrExclamationToken !== undefined && questionOrExclamationToken.kind === 55 /* QuestionToken */ ? questionOrExclamationToken : undefined;
	        node.exclamationToken = questionOrExclamationToken !== undefined && questionOrExclamationToken.kind === 51 /* ExclamationToken */ ? questionOrExclamationToken : undefined;
	        node.type = type;
	        node.initializer = initializer;
	        return node;
	    }
	    ts.createProperty = createProperty;
	    function updateProperty(node, decorators, modifiers, name, questionOrExclamationToken, type, initializer) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.questionToken !== (questionOrExclamationToken !== undefined && questionOrExclamationToken.kind === 55 /* QuestionToken */ ? questionOrExclamationToken : undefined)
	            || node.exclamationToken !== (questionOrExclamationToken !== undefined && questionOrExclamationToken.kind === 51 /* ExclamationToken */ ? questionOrExclamationToken : undefined)
	            || node.type !== type
	            || node.initializer !== initializer
	            ? updateNode(createProperty(decorators, modifiers, name, questionOrExclamationToken, type, initializer), node)
	            : node;
	    }
	    ts.updateProperty = updateProperty;
	    function createMethodSignature(typeParameters, parameters, type, name, questionToken) {
	        var node = createSignatureDeclaration(152 /* MethodSignature */, typeParameters, parameters, type);
	        node.name = asName(name);
	        node.questionToken = questionToken;
	        return node;
	    }
	    ts.createMethodSignature = createMethodSignature;
	    function updateMethodSignature(node, typeParameters, parameters, type, name, questionToken) {
	        return node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.name !== name
	            || node.questionToken !== questionToken
	            ? updateNode(createMethodSignature(typeParameters, parameters, type, name, questionToken), node)
	            : node;
	    }
	    ts.updateMethodSignature = updateMethodSignature;
	    function createMethod(decorators, modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body) {
	        var node = createSynthesizedNode(153 /* MethodDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.asteriskToken = asteriskToken;
	        node.name = asName(name);
	        node.questionToken = questionToken;
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.body = body;
	        return node;
	    }
	    ts.createMethod = createMethod;
	    function updateMethod(node, decorators, modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.asteriskToken !== asteriskToken
	            || node.name !== name
	            || node.questionToken !== questionToken
	            || node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.body !== body
	            ? updateNode(createMethod(decorators, modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body), node)
	            : node;
	    }
	    ts.updateMethod = updateMethod;
	    function createConstructor(decorators, modifiers, parameters, body) {
	        var node = createSynthesizedNode(154 /* Constructor */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.typeParameters = undefined;
	        node.parameters = createNodeArray(parameters);
	        node.type = undefined;
	        node.body = body;
	        return node;
	    }
	    ts.createConstructor = createConstructor;
	    function updateConstructor(node, decorators, modifiers, parameters, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.parameters !== parameters
	            || node.body !== body
	            ? updateNode(createConstructor(decorators, modifiers, parameters, body), node)
	            : node;
	    }
	    ts.updateConstructor = updateConstructor;
	    function createGetAccessor(decorators, modifiers, name, parameters, type, body) {
	        var node = createSynthesizedNode(155 /* GetAccessor */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = undefined;
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.body = body;
	        return node;
	    }
	    ts.createGetAccessor = createGetAccessor;
	    function updateGetAccessor(node, decorators, modifiers, name, parameters, type, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.body !== body
	            ? updateNode(createGetAccessor(decorators, modifiers, name, parameters, type, body), node)
	            : node;
	    }
	    ts.updateGetAccessor = updateGetAccessor;
	    function createSetAccessor(decorators, modifiers, name, parameters, body) {
	        var node = createSynthesizedNode(156 /* SetAccessor */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = undefined;
	        node.parameters = createNodeArray(parameters);
	        node.body = body;
	        return node;
	    }
	    ts.createSetAccessor = createSetAccessor;
	    function updateSetAccessor(node, decorators, modifiers, name, parameters, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.parameters !== parameters
	            || node.body !== body
	            ? updateNode(createSetAccessor(decorators, modifiers, name, parameters, body), node)
	            : node;
	    }
	    ts.updateSetAccessor = updateSetAccessor;
	    function createCallSignature(typeParameters, parameters, type) {
	        return createSignatureDeclaration(157 /* CallSignature */, typeParameters, parameters, type);
	    }
	    ts.createCallSignature = createCallSignature;
	    function updateCallSignature(node, typeParameters, parameters, type) {
	        return updateSignatureDeclaration(node, typeParameters, parameters, type);
	    }
	    ts.updateCallSignature = updateCallSignature;
	    function createConstructSignature(typeParameters, parameters, type) {
	        return createSignatureDeclaration(158 /* ConstructSignature */, typeParameters, parameters, type);
	    }
	    ts.createConstructSignature = createConstructSignature;
	    function updateConstructSignature(node, typeParameters, parameters, type) {
	        return updateSignatureDeclaration(node, typeParameters, parameters, type);
	    }
	    ts.updateConstructSignature = updateConstructSignature;
	    function createIndexSignature(decorators, modifiers, parameters, type) {
	        var node = createSynthesizedNode(159 /* IndexSignature */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        return node;
	    }
	    ts.createIndexSignature = createIndexSignature;
	    function updateIndexSignature(node, decorators, modifiers, parameters, type) {
	        return node.parameters !== parameters
	            || node.type !== type
	            || node.decorators !== decorators
	            || node.modifiers !== modifiers
	            ? updateNode(createIndexSignature(decorators, modifiers, parameters, type), node)
	            : node;
	    }
	    ts.updateIndexSignature = updateIndexSignature;
	    /* @internal */
	    function createSignatureDeclaration(kind, typeParameters, parameters, type, typeArguments) {
	        var node = createSynthesizedNode(kind);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = asNodeArray(parameters);
	        node.type = type;
	        node.typeArguments = asNodeArray(typeArguments);
	        return node;
	    }
	    ts.createSignatureDeclaration = createSignatureDeclaration;
	    function updateSignatureDeclaration(node, typeParameters, parameters, type) {
	        return node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            ? updateNode(createSignatureDeclaration(node.kind, typeParameters, parameters, type), node)
	            : node;
	    }
	    // Types
	    function createKeywordTypeNode(kind) {
	        return createSynthesizedNode(kind);
	    }
	    ts.createKeywordTypeNode = createKeywordTypeNode;
	    function createTypePredicateNode(parameterName, type) {
	        var node = createSynthesizedNode(160 /* TypePredicate */);
	        node.parameterName = asName(parameterName);
	        node.type = type;
	        return node;
	    }
	    ts.createTypePredicateNode = createTypePredicateNode;
	    function updateTypePredicateNode(node, parameterName, type) {
	        return node.parameterName !== parameterName
	            || node.type !== type
	            ? updateNode(createTypePredicateNode(parameterName, type), node)
	            : node;
	    }
	    ts.updateTypePredicateNode = updateTypePredicateNode;
	    function createTypeReferenceNode(typeName, typeArguments) {
	        var node = createSynthesizedNode(161 /* TypeReference */);
	        node.typeName = asName(typeName);
	        node.typeArguments = typeArguments && ts.parenthesizeTypeParameters(typeArguments);
	        return node;
	    }
	    ts.createTypeReferenceNode = createTypeReferenceNode;
	    function updateTypeReferenceNode(node, typeName, typeArguments) {
	        return node.typeName !== typeName
	            || node.typeArguments !== typeArguments
	            ? updateNode(createTypeReferenceNode(typeName, typeArguments), node)
	            : node;
	    }
	    ts.updateTypeReferenceNode = updateTypeReferenceNode;
	    function createFunctionTypeNode(typeParameters, parameters, type) {
	        return createSignatureDeclaration(162 /* FunctionType */, typeParameters, parameters, type);
	    }
	    ts.createFunctionTypeNode = createFunctionTypeNode;
	    function updateFunctionTypeNode(node, typeParameters, parameters, type) {
	        return updateSignatureDeclaration(node, typeParameters, parameters, type);
	    }
	    ts.updateFunctionTypeNode = updateFunctionTypeNode;
	    function createConstructorTypeNode(typeParameters, parameters, type) {
	        return createSignatureDeclaration(163 /* ConstructorType */, typeParameters, parameters, type);
	    }
	    ts.createConstructorTypeNode = createConstructorTypeNode;
	    function updateConstructorTypeNode(node, typeParameters, parameters, type) {
	        return updateSignatureDeclaration(node, typeParameters, parameters, type);
	    }
	    ts.updateConstructorTypeNode = updateConstructorTypeNode;
	    function createTypeQueryNode(exprName) {
	        var node = createSynthesizedNode(164 /* TypeQuery */);
	        node.exprName = exprName;
	        return node;
	    }
	    ts.createTypeQueryNode = createTypeQueryNode;
	    function updateTypeQueryNode(node, exprName) {
	        return node.exprName !== exprName
	            ? updateNode(createTypeQueryNode(exprName), node)
	            : node;
	    }
	    ts.updateTypeQueryNode = updateTypeQueryNode;
	    function createTypeLiteralNode(members) {
	        var node = createSynthesizedNode(165 /* TypeLiteral */);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createTypeLiteralNode = createTypeLiteralNode;
	    function updateTypeLiteralNode(node, members) {
	        return node.members !== members
	            ? updateNode(createTypeLiteralNode(members), node)
	            : node;
	    }
	    ts.updateTypeLiteralNode = updateTypeLiteralNode;
	    function createArrayTypeNode(elementType) {
	        var node = createSynthesizedNode(166 /* ArrayType */);
	        node.elementType = ts.parenthesizeArrayTypeMember(elementType);
	        return node;
	    }
	    ts.createArrayTypeNode = createArrayTypeNode;
	    function updateArrayTypeNode(node, elementType) {
	        return node.elementType !== elementType
	            ? updateNode(createArrayTypeNode(elementType), node)
	            : node;
	    }
	    ts.updateArrayTypeNode = updateArrayTypeNode;
	    function createTupleTypeNode(elementTypes) {
	        var node = createSynthesizedNode(167 /* TupleType */);
	        node.elementTypes = createNodeArray(elementTypes);
	        return node;
	    }
	    ts.createTupleTypeNode = createTupleTypeNode;
	    function updateTypleTypeNode(node, elementTypes) {
	        return node.elementTypes !== elementTypes
	            ? updateNode(createTupleTypeNode(elementTypes), node)
	            : node;
	    }
	    ts.updateTypleTypeNode = updateTypleTypeNode;
	    function createUnionTypeNode(types) {
	        return createUnionOrIntersectionTypeNode(168 /* UnionType */, types);
	    }
	    ts.createUnionTypeNode = createUnionTypeNode;
	    function updateUnionTypeNode(node, types) {
	        return updateUnionOrIntersectionTypeNode(node, types);
	    }
	    ts.updateUnionTypeNode = updateUnionTypeNode;
	    function createIntersectionTypeNode(types) {
	        return createUnionOrIntersectionTypeNode(169 /* IntersectionType */, types);
	    }
	    ts.createIntersectionTypeNode = createIntersectionTypeNode;
	    function updateIntersectionTypeNode(node, types) {
	        return updateUnionOrIntersectionTypeNode(node, types);
	    }
	    ts.updateIntersectionTypeNode = updateIntersectionTypeNode;
	    function createUnionOrIntersectionTypeNode(kind, types) {
	        var node = createSynthesizedNode(kind);
	        node.types = ts.parenthesizeElementTypeMembers(types);
	        return node;
	    }
	    ts.createUnionOrIntersectionTypeNode = createUnionOrIntersectionTypeNode;
	    function updateUnionOrIntersectionTypeNode(node, types) {
	        return node.types !== types
	            ? updateNode(createUnionOrIntersectionTypeNode(node.kind, types), node)
	            : node;
	    }
	    function createConditionalTypeNode(checkType, extendsType, trueType, falseType) {
	        var node = createSynthesizedNode(170 /* ConditionalType */);
	        node.checkType = ts.parenthesizeConditionalTypeMember(checkType);
	        node.extendsType = ts.parenthesizeConditionalTypeMember(extendsType);
	        node.trueType = trueType;
	        node.falseType = falseType;
	        return node;
	    }
	    ts.createConditionalTypeNode = createConditionalTypeNode;
	    function updateConditionalTypeNode(node, checkType, extendsType, trueType, falseType) {
	        return node.checkType !== checkType
	            || node.extendsType !== extendsType
	            || node.trueType !== trueType
	            || node.falseType !== falseType
	            ? updateNode(createConditionalTypeNode(checkType, extendsType, trueType, falseType), node)
	            : node;
	    }
	    ts.updateConditionalTypeNode = updateConditionalTypeNode;
	    function createInferTypeNode(typeParameter) {
	        var node = createSynthesizedNode(171 /* InferType */);
	        node.typeParameter = typeParameter;
	        return node;
	    }
	    ts.createInferTypeNode = createInferTypeNode;
	    function updateInferTypeNode(node, typeParameter) {
	        return node.typeParameter !== typeParameter
	            ? updateNode(createInferTypeNode(typeParameter), node)
	            : node;
	    }
	    ts.updateInferTypeNode = updateInferTypeNode;
	    function createParenthesizedType(type) {
	        var node = createSynthesizedNode(172 /* ParenthesizedType */);
	        node.type = type;
	        return node;
	    }
	    ts.createParenthesizedType = createParenthesizedType;
	    function updateParenthesizedType(node, type) {
	        return node.type !== type
	            ? updateNode(createParenthesizedType(type), node)
	            : node;
	    }
	    ts.updateParenthesizedType = updateParenthesizedType;
	    function createThisTypeNode() {
	        return createSynthesizedNode(173 /* ThisType */);
	    }
	    ts.createThisTypeNode = createThisTypeNode;
	    function createTypeOperatorNode(operatorOrType, type) {
	        var node = createSynthesizedNode(174 /* TypeOperator */);
	        node.operator = typeof operatorOrType === "number" ? operatorOrType : 128 /* KeyOfKeyword */;
	        node.type = ts.parenthesizeElementTypeMember(typeof operatorOrType === "number" ? type : operatorOrType);
	        return node;
	    }
	    ts.createTypeOperatorNode = createTypeOperatorNode;
	    function updateTypeOperatorNode(node, type) {
	        return node.type !== type ? updateNode(createTypeOperatorNode(node.operator, type), node) : node;
	    }
	    ts.updateTypeOperatorNode = updateTypeOperatorNode;
	    function createIndexedAccessTypeNode(objectType, indexType) {
	        var node = createSynthesizedNode(175 /* IndexedAccessType */);
	        node.objectType = ts.parenthesizeElementTypeMember(objectType);
	        node.indexType = indexType;
	        return node;
	    }
	    ts.createIndexedAccessTypeNode = createIndexedAccessTypeNode;
	    function updateIndexedAccessTypeNode(node, objectType, indexType) {
	        return node.objectType !== objectType
	            || node.indexType !== indexType
	            ? updateNode(createIndexedAccessTypeNode(objectType, indexType), node)
	            : node;
	    }
	    ts.updateIndexedAccessTypeNode = updateIndexedAccessTypeNode;
	    function createMappedTypeNode(readonlyToken, typeParameter, questionToken, type) {
	        var node = createSynthesizedNode(176 /* MappedType */);
	        node.readonlyToken = readonlyToken;
	        node.typeParameter = typeParameter;
	        node.questionToken = questionToken;
	        node.type = type;
	        return node;
	    }
	    ts.createMappedTypeNode = createMappedTypeNode;
	    function updateMappedTypeNode(node, readonlyToken, typeParameter, questionToken, type) {
	        return node.readonlyToken !== readonlyToken
	            || node.typeParameter !== typeParameter
	            || node.questionToken !== questionToken
	            || node.type !== type
	            ? updateNode(createMappedTypeNode(readonlyToken, typeParameter, questionToken, type), node)
	            : node;
	    }
	    ts.updateMappedTypeNode = updateMappedTypeNode;
	    function createLiteralTypeNode(literal) {
	        var node = createSynthesizedNode(177 /* LiteralType */);
	        node.literal = literal;
	        return node;
	    }
	    ts.createLiteralTypeNode = createLiteralTypeNode;
	    function updateLiteralTypeNode(node, literal) {
	        return node.literal !== literal
	            ? updateNode(createLiteralTypeNode(literal), node)
	            : node;
	    }
	    ts.updateLiteralTypeNode = updateLiteralTypeNode;
	    // Binding Patterns
	    function createObjectBindingPattern(elements) {
	        var node = createSynthesizedNode(178 /* ObjectBindingPattern */);
	        node.elements = createNodeArray(elements);
	        return node;
	    }
	    ts.createObjectBindingPattern = createObjectBindingPattern;
	    function updateObjectBindingPattern(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createObjectBindingPattern(elements), node)
	            : node;
	    }
	    ts.updateObjectBindingPattern = updateObjectBindingPattern;
	    function createArrayBindingPattern(elements) {
	        var node = createSynthesizedNode(179 /* ArrayBindingPattern */);
	        node.elements = createNodeArray(elements);
	        return node;
	    }
	    ts.createArrayBindingPattern = createArrayBindingPattern;
	    function updateArrayBindingPattern(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createArrayBindingPattern(elements), node)
	            : node;
	    }
	    ts.updateArrayBindingPattern = updateArrayBindingPattern;
	    function createBindingElement(dotDotDotToken, propertyName, name, initializer) {
	        var node = createSynthesizedNode(180 /* BindingElement */);
	        node.dotDotDotToken = dotDotDotToken;
	        node.propertyName = asName(propertyName);
	        node.name = asName(name);
	        node.initializer = initializer;
	        return node;
	    }
	    ts.createBindingElement = createBindingElement;
	    function updateBindingElement(node, dotDotDotToken, propertyName, name, initializer) {
	        return node.propertyName !== propertyName
	            || node.dotDotDotToken !== dotDotDotToken
	            || node.name !== name
	            || node.initializer !== initializer
	            ? updateNode(createBindingElement(dotDotDotToken, propertyName, name, initializer), node)
	            : node;
	    }
	    ts.updateBindingElement = updateBindingElement;
	    // Expression
	    function createArrayLiteral(elements, multiLine) {
	        var node = createSynthesizedNode(181 /* ArrayLiteralExpression */);
	        node.elements = ts.parenthesizeListElements(createNodeArray(elements));
	        if (multiLine)
	            node.multiLine = true;
	        return node;
	    }
	    ts.createArrayLiteral = createArrayLiteral;
	    function updateArrayLiteral(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createArrayLiteral(elements, node.multiLine), node)
	            : node;
	    }
	    ts.updateArrayLiteral = updateArrayLiteral;
	    function createObjectLiteral(properties, multiLine) {
	        var node = createSynthesizedNode(182 /* ObjectLiteralExpression */);
	        node.properties = createNodeArray(properties);
	        if (multiLine)
	            node.multiLine = true;
	        return node;
	    }
	    ts.createObjectLiteral = createObjectLiteral;
	    function updateObjectLiteral(node, properties) {
	        return node.properties !== properties
	            ? updateNode(createObjectLiteral(properties, node.multiLine), node)
	            : node;
	    }
	    ts.updateObjectLiteral = updateObjectLiteral;
	    function createPropertyAccess(expression, name) {
	        var node = createSynthesizedNode(183 /* PropertyAccessExpression */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        node.name = asName(name);
	        setEmitFlags(node, 131072 /* NoIndentation */);
	        return node;
	    }
	    ts.createPropertyAccess = createPropertyAccess;
	    function updatePropertyAccess(node, expression, name) {
	        // Because we are updating existed propertyAccess we want to inherit its emitFlags
	        // instead of using the default from createPropertyAccess
	        return node.expression !== expression
	            || node.name !== name
	            ? updateNode(setEmitFlags(createPropertyAccess(expression, name), ts.getEmitFlags(node)), node)
	            : node;
	    }
	    ts.updatePropertyAccess = updatePropertyAccess;
	    function createElementAccess(expression, index) {
	        var node = createSynthesizedNode(184 /* ElementAccessExpression */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        node.argumentExpression = asExpression(index);
	        return node;
	    }
	    ts.createElementAccess = createElementAccess;
	    function updateElementAccess(node, expression, argumentExpression) {
	        return node.expression !== expression
	            || node.argumentExpression !== argumentExpression
	            ? updateNode(createElementAccess(expression, argumentExpression), node)
	            : node;
	    }
	    ts.updateElementAccess = updateElementAccess;
	    function createCall(expression, typeArguments, argumentsArray) {
	        var node = createSynthesizedNode(185 /* CallExpression */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        node.typeArguments = asNodeArray(typeArguments);
	        node.arguments = ts.parenthesizeListElements(createNodeArray(argumentsArray));
	        return node;
	    }
	    ts.createCall = createCall;
	    function updateCall(node, expression, typeArguments, argumentsArray) {
	        return node.expression !== expression
	            || node.typeArguments !== typeArguments
	            || node.arguments !== argumentsArray
	            ? updateNode(createCall(expression, typeArguments, argumentsArray), node)
	            : node;
	    }
	    ts.updateCall = updateCall;
	    function createNew(expression, typeArguments, argumentsArray) {
	        var node = createSynthesizedNode(186 /* NewExpression */);
	        node.expression = ts.parenthesizeForNew(expression);
	        node.typeArguments = asNodeArray(typeArguments);
	        node.arguments = argumentsArray ? ts.parenthesizeListElements(createNodeArray(argumentsArray)) : undefined;
	        return node;
	    }
	    ts.createNew = createNew;
	    function updateNew(node, expression, typeArguments, argumentsArray) {
	        return node.expression !== expression
	            || node.typeArguments !== typeArguments
	            || node.arguments !== argumentsArray
	            ? updateNode(createNew(expression, typeArguments, argumentsArray), node)
	            : node;
	    }
	    ts.updateNew = updateNew;
	    function createTaggedTemplate(tag, template) {
	        var node = createSynthesizedNode(187 /* TaggedTemplateExpression */);
	        node.tag = ts.parenthesizeForAccess(tag);
	        node.template = template;
	        return node;
	    }
	    ts.createTaggedTemplate = createTaggedTemplate;
	    function updateTaggedTemplate(node, tag, template) {
	        return node.tag !== tag
	            || node.template !== template
	            ? updateNode(createTaggedTemplate(tag, template), node)
	            : node;
	    }
	    ts.updateTaggedTemplate = updateTaggedTemplate;
	    function createTypeAssertion(type, expression) {
	        var node = createSynthesizedNode(188 /* TypeAssertionExpression */);
	        node.type = type;
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createTypeAssertion = createTypeAssertion;
	    function updateTypeAssertion(node, type, expression) {
	        return node.type !== type
	            || node.expression !== expression
	            ? updateNode(createTypeAssertion(type, expression), node)
	            : node;
	    }
	    ts.updateTypeAssertion = updateTypeAssertion;
	    function createParen(expression) {
	        var node = createSynthesizedNode(189 /* ParenthesizedExpression */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createParen = createParen;
	    function updateParen(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createParen(expression), node)
	            : node;
	    }
	    ts.updateParen = updateParen;
	    function createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
	        var node = createSynthesizedNode(190 /* FunctionExpression */);
	        node.modifiers = asNodeArray(modifiers);
	        node.asteriskToken = asteriskToken;
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.body = body;
	        return node;
	    }
	    ts.createFunctionExpression = createFunctionExpression;
	    function updateFunctionExpression(node, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
	        return node.name !== name
	            || node.modifiers !== modifiers
	            || node.asteriskToken !== asteriskToken
	            || node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.body !== body
	            ? updateNode(createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body), node)
	            : node;
	    }
	    ts.updateFunctionExpression = updateFunctionExpression;
	    function createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body) {
	        var node = createSynthesizedNode(191 /* ArrowFunction */);
	        node.modifiers = asNodeArray(modifiers);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.equalsGreaterThanToken = equalsGreaterThanToken || createToken(36 /* EqualsGreaterThanToken */);
	        node.body = ts.parenthesizeConciseBody(body);
	        return node;
	    }
	    ts.createArrowFunction = createArrowFunction;
	    function updateArrowFunction(node, modifiers, typeParameters, parameters, type, equalsGreaterThanTokenOrBody, bodyOrUndefined) {
	        var equalsGreaterThanToken;
	        var body;
	        if (bodyOrUndefined === undefined) {
	            equalsGreaterThanToken = node.equalsGreaterThanToken;
	            body = ts.cast(equalsGreaterThanTokenOrBody, ts.isConciseBody);
	        }
	        else {
	            equalsGreaterThanToken = ts.cast(equalsGreaterThanTokenOrBody, function (n) {
	                return n.kind === 36 /* EqualsGreaterThanToken */;
	            });
	            body = bodyOrUndefined;
	        }
	        return node.modifiers !== modifiers
	            || node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.equalsGreaterThanToken !== equalsGreaterThanToken
	            || node.body !== body
	            ? updateNode(createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body), node)
	            : node;
	    }
	    ts.updateArrowFunction = updateArrowFunction;
	    function createDelete(expression) {
	        var node = createSynthesizedNode(192 /* DeleteExpression */);
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createDelete = createDelete;
	    function updateDelete(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createDelete(expression), node)
	            : node;
	    }
	    ts.updateDelete = updateDelete;
	    function createTypeOf(expression) {
	        var node = createSynthesizedNode(193 /* TypeOfExpression */);
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createTypeOf = createTypeOf;
	    function updateTypeOf(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createTypeOf(expression), node)
	            : node;
	    }
	    ts.updateTypeOf = updateTypeOf;
	    function createVoid(expression) {
	        var node = createSynthesizedNode(194 /* VoidExpression */);
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createVoid = createVoid;
	    function updateVoid(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createVoid(expression), node)
	            : node;
	    }
	    ts.updateVoid = updateVoid;
	    function createAwait(expression) {
	        var node = createSynthesizedNode(195 /* AwaitExpression */);
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createAwait = createAwait;
	    function updateAwait(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createAwait(expression), node)
	            : node;
	    }
	    ts.updateAwait = updateAwait;
	    function createPrefix(operator, operand) {
	        var node = createSynthesizedNode(196 /* PrefixUnaryExpression */);
	        node.operator = operator;
	        node.operand = ts.parenthesizePrefixOperand(operand);
	        return node;
	    }
	    ts.createPrefix = createPrefix;
	    function updatePrefix(node, operand) {
	        return node.operand !== operand
	            ? updateNode(createPrefix(node.operator, operand), node)
	            : node;
	    }
	    ts.updatePrefix = updatePrefix;
	    function createPostfix(operand, operator) {
	        var node = createSynthesizedNode(197 /* PostfixUnaryExpression */);
	        node.operand = ts.parenthesizePostfixOperand(operand);
	        node.operator = operator;
	        return node;
	    }
	    ts.createPostfix = createPostfix;
	    function updatePostfix(node, operand) {
	        return node.operand !== operand
	            ? updateNode(createPostfix(operand, node.operator), node)
	            : node;
	    }
	    ts.updatePostfix = updatePostfix;
	    function createBinary(left, operator, right) {
	        var node = createSynthesizedNode(198 /* BinaryExpression */);
	        var operatorToken = asToken(operator);
	        var operatorKind = operatorToken.kind;
	        node.left = ts.parenthesizeBinaryOperand(operatorKind, left, /*isLeftSideOfBinary*/ true, /*leftOperand*/ undefined);
	        node.operatorToken = operatorToken;
	        node.right = ts.parenthesizeBinaryOperand(operatorKind, right, /*isLeftSideOfBinary*/ false, node.left);
	        return node;
	    }
	    ts.createBinary = createBinary;
	    function updateBinary(node, left, right, operator) {
	        return node.left !== left
	            || node.right !== right
	            ? updateNode(createBinary(left, operator || node.operatorToken, right), node)
	            : node;
	    }
	    ts.updateBinary = updateBinary;
	    function createConditional(condition, questionTokenOrWhenTrue, whenTrueOrWhenFalse, colonToken, whenFalse) {
	        var node = createSynthesizedNode(199 /* ConditionalExpression */);
	        node.condition = ts.parenthesizeForConditionalHead(condition);
	        node.questionToken = whenFalse ? questionTokenOrWhenTrue : createToken(55 /* QuestionToken */);
	        node.whenTrue = ts.parenthesizeSubexpressionOfConditionalExpression(whenFalse ? whenTrueOrWhenFalse : questionTokenOrWhenTrue);
	        node.colonToken = whenFalse ? colonToken : createToken(56 /* ColonToken */);
	        node.whenFalse = ts.parenthesizeSubexpressionOfConditionalExpression(whenFalse ? whenFalse : whenTrueOrWhenFalse);
	        return node;
	    }
	    ts.createConditional = createConditional;
	    function updateConditional(node, condition) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        if (args.length === 2) {
	            var whenTrue_1 = args[0], whenFalse_1 = args[1];
	            return updateConditional(node, condition, node.questionToken, whenTrue_1, node.colonToken, whenFalse_1);
	        }
	        ts.Debug.assert(args.length === 4);
	        var questionToken = args[0], whenTrue = args[1], colonToken = args[2], whenFalse = args[3];
	        return node.condition !== condition
	            || node.questionToken !== questionToken
	            || node.whenTrue !== whenTrue
	            || node.colonToken !== colonToken
	            || node.whenFalse !== whenFalse
	            ? updateNode(createConditional(condition, questionToken, whenTrue, colonToken, whenFalse), node)
	            : node;
	    }
	    ts.updateConditional = updateConditional;
	    function createTemplateExpression(head, templateSpans) {
	        var node = createSynthesizedNode(200 /* TemplateExpression */);
	        node.head = head;
	        node.templateSpans = createNodeArray(templateSpans);
	        return node;
	    }
	    ts.createTemplateExpression = createTemplateExpression;
	    function updateTemplateExpression(node, head, templateSpans) {
	        return node.head !== head
	            || node.templateSpans !== templateSpans
	            ? updateNode(createTemplateExpression(head, templateSpans), node)
	            : node;
	    }
	    ts.updateTemplateExpression = updateTemplateExpression;
	    function createTemplateHead(text) {
	        var node = createSynthesizedNode(14 /* TemplateHead */);
	        node.text = text;
	        return node;
	    }
	    ts.createTemplateHead = createTemplateHead;
	    function createTemplateMiddle(text) {
	        var node = createSynthesizedNode(15 /* TemplateMiddle */);
	        node.text = text;
	        return node;
	    }
	    ts.createTemplateMiddle = createTemplateMiddle;
	    function createTemplateTail(text) {
	        var node = createSynthesizedNode(16 /* TemplateTail */);
	        node.text = text;
	        return node;
	    }
	    ts.createTemplateTail = createTemplateTail;
	    function createNoSubstitutionTemplateLiteral(text) {
	        var node = createSynthesizedNode(13 /* NoSubstitutionTemplateLiteral */);
	        node.text = text;
	        return node;
	    }
	    ts.createNoSubstitutionTemplateLiteral = createNoSubstitutionTemplateLiteral;
	    function createYield(asteriskTokenOrExpression, expression) {
	        var node = createSynthesizedNode(201 /* YieldExpression */);
	        node.asteriskToken = asteriskTokenOrExpression && asteriskTokenOrExpression.kind === 39 /* AsteriskToken */ ? asteriskTokenOrExpression : undefined;
	        node.expression = asteriskTokenOrExpression && asteriskTokenOrExpression.kind !== 39 /* AsteriskToken */ ? asteriskTokenOrExpression : expression;
	        return node;
	    }
	    ts.createYield = createYield;
	    function updateYield(node, asteriskToken, expression) {
	        return node.expression !== expression
	            || node.asteriskToken !== asteriskToken
	            ? updateNode(createYield(asteriskToken, expression), node)
	            : node;
	    }
	    ts.updateYield = updateYield;
	    function createSpread(expression) {
	        var node = createSynthesizedNode(202 /* SpreadElement */);
	        node.expression = ts.parenthesizeExpressionForList(expression);
	        return node;
	    }
	    ts.createSpread = createSpread;
	    function updateSpread(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createSpread(expression), node)
	            : node;
	    }
	    ts.updateSpread = updateSpread;
	    function createClassExpression(modifiers, name, typeParameters, heritageClauses, members) {
	        var node = createSynthesizedNode(203 /* ClassExpression */);
	        node.decorators = undefined;
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.heritageClauses = asNodeArray(heritageClauses);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createClassExpression = createClassExpression;
	    function updateClassExpression(node, modifiers, name, typeParameters, heritageClauses, members) {
	        return node.modifiers !== modifiers
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.heritageClauses !== heritageClauses
	            || node.members !== members
	            ? updateNode(createClassExpression(modifiers, name, typeParameters, heritageClauses, members), node)
	            : node;
	    }
	    ts.updateClassExpression = updateClassExpression;
	    function createOmittedExpression() {
	        return createSynthesizedNode(204 /* OmittedExpression */);
	    }
	    ts.createOmittedExpression = createOmittedExpression;
	    function createExpressionWithTypeArguments(typeArguments, expression) {
	        var node = createSynthesizedNode(205 /* ExpressionWithTypeArguments */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        node.typeArguments = asNodeArray(typeArguments);
	        return node;
	    }
	    ts.createExpressionWithTypeArguments = createExpressionWithTypeArguments;
	    function updateExpressionWithTypeArguments(node, typeArguments, expression) {
	        return node.typeArguments !== typeArguments
	            || node.expression !== expression
	            ? updateNode(createExpressionWithTypeArguments(typeArguments, expression), node)
	            : node;
	    }
	    ts.updateExpressionWithTypeArguments = updateExpressionWithTypeArguments;
	    function createAsExpression(expression, type) {
	        var node = createSynthesizedNode(206 /* AsExpression */);
	        node.expression = expression;
	        node.type = type;
	        return node;
	    }
	    ts.createAsExpression = createAsExpression;
	    function updateAsExpression(node, expression, type) {
	        return node.expression !== expression
	            || node.type !== type
	            ? updateNode(createAsExpression(expression, type), node)
	            : node;
	    }
	    ts.updateAsExpression = updateAsExpression;
	    function createNonNullExpression(expression) {
	        var node = createSynthesizedNode(207 /* NonNullExpression */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        return node;
	    }
	    ts.createNonNullExpression = createNonNullExpression;
	    function updateNonNullExpression(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createNonNullExpression(expression), node)
	            : node;
	    }
	    ts.updateNonNullExpression = updateNonNullExpression;
	    function createMetaProperty(keywordToken, name) {
	        var node = createSynthesizedNode(208 /* MetaProperty */);
	        node.keywordToken = keywordToken;
	        node.name = name;
	        return node;
	    }
	    ts.createMetaProperty = createMetaProperty;
	    function updateMetaProperty(node, name) {
	        return node.name !== name
	            ? updateNode(createMetaProperty(node.keywordToken, name), node)
	            : node;
	    }
	    ts.updateMetaProperty = updateMetaProperty;
	    // Misc
	    function createTemplateSpan(expression, literal) {
	        var node = createSynthesizedNode(209 /* TemplateSpan */);
	        node.expression = expression;
	        node.literal = literal;
	        return node;
	    }
	    ts.createTemplateSpan = createTemplateSpan;
	    function updateTemplateSpan(node, expression, literal) {
	        return node.expression !== expression
	            || node.literal !== literal
	            ? updateNode(createTemplateSpan(expression, literal), node)
	            : node;
	    }
	    ts.updateTemplateSpan = updateTemplateSpan;
	    function createSemicolonClassElement() {
	        return createSynthesizedNode(210 /* SemicolonClassElement */);
	    }
	    ts.createSemicolonClassElement = createSemicolonClassElement;
	    // Element
	    function createBlock(statements, multiLine) {
	        var block = createSynthesizedNode(211 /* Block */);
	        block.statements = createNodeArray(statements);
	        if (multiLine)
	            block.multiLine = multiLine;
	        return block;
	    }
	    ts.createBlock = createBlock;
	    function updateBlock(node, statements) {
	        return node.statements !== statements
	            ? updateNode(createBlock(statements, node.multiLine), node)
	            : node;
	    }
	    ts.updateBlock = updateBlock;
	    function createVariableStatement(modifiers, declarationList) {
	        var node = createSynthesizedNode(212 /* VariableStatement */);
	        node.decorators = undefined;
	        node.modifiers = asNodeArray(modifiers);
	        node.declarationList = ts.isArray(declarationList) ? createVariableDeclarationList(declarationList) : declarationList;
	        return node;
	    }
	    ts.createVariableStatement = createVariableStatement;
	    function updateVariableStatement(node, modifiers, declarationList) {
	        return node.modifiers !== modifiers
	            || node.declarationList !== declarationList
	            ? updateNode(createVariableStatement(modifiers, declarationList), node)
	            : node;
	    }
	    ts.updateVariableStatement = updateVariableStatement;
	    function createEmptyStatement() {
	        return createSynthesizedNode(213 /* EmptyStatement */);
	    }
	    ts.createEmptyStatement = createEmptyStatement;
	    function createStatement(expression) {
	        var node = createSynthesizedNode(214 /* ExpressionStatement */);
	        node.expression = ts.parenthesizeExpressionForExpressionStatement(expression);
	        return node;
	    }
	    ts.createStatement = createStatement;
	    function updateStatement(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createStatement(expression), node)
	            : node;
	    }
	    ts.updateStatement = updateStatement;
	    function createIf(expression, thenStatement, elseStatement) {
	        var node = createSynthesizedNode(215 /* IfStatement */);
	        node.expression = expression;
	        node.thenStatement = thenStatement;
	        node.elseStatement = elseStatement;
	        return node;
	    }
	    ts.createIf = createIf;
	    function updateIf(node, expression, thenStatement, elseStatement) {
	        return node.expression !== expression
	            || node.thenStatement !== thenStatement
	            || node.elseStatement !== elseStatement
	            ? updateNode(createIf(expression, thenStatement, elseStatement), node)
	            : node;
	    }
	    ts.updateIf = updateIf;
	    function createDo(statement, expression) {
	        var node = createSynthesizedNode(216 /* DoStatement */);
	        node.statement = statement;
	        node.expression = expression;
	        return node;
	    }
	    ts.createDo = createDo;
	    function updateDo(node, statement, expression) {
	        return node.statement !== statement
	            || node.expression !== expression
	            ? updateNode(createDo(statement, expression), node)
	            : node;
	    }
	    ts.updateDo = updateDo;
	    function createWhile(expression, statement) {
	        var node = createSynthesizedNode(217 /* WhileStatement */);
	        node.expression = expression;
	        node.statement = statement;
	        return node;
	    }
	    ts.createWhile = createWhile;
	    function updateWhile(node, expression, statement) {
	        return node.expression !== expression
	            || node.statement !== statement
	            ? updateNode(createWhile(expression, statement), node)
	            : node;
	    }
	    ts.updateWhile = updateWhile;
	    function createFor(initializer, condition, incrementor, statement) {
	        var node = createSynthesizedNode(218 /* ForStatement */);
	        node.initializer = initializer;
	        node.condition = condition;
	        node.incrementor = incrementor;
	        node.statement = statement;
	        return node;
	    }
	    ts.createFor = createFor;
	    function updateFor(node, initializer, condition, incrementor, statement) {
	        return node.initializer !== initializer
	            || node.condition !== condition
	            || node.incrementor !== incrementor
	            || node.statement !== statement
	            ? updateNode(createFor(initializer, condition, incrementor, statement), node)
	            : node;
	    }
	    ts.updateFor = updateFor;
	    function createForIn(initializer, expression, statement) {
	        var node = createSynthesizedNode(219 /* ForInStatement */);
	        node.initializer = initializer;
	        node.expression = expression;
	        node.statement = statement;
	        return node;
	    }
	    ts.createForIn = createForIn;
	    function updateForIn(node, initializer, expression, statement) {
	        return node.initializer !== initializer
	            || node.expression !== expression
	            || node.statement !== statement
	            ? updateNode(createForIn(initializer, expression, statement), node)
	            : node;
	    }
	    ts.updateForIn = updateForIn;
	    function createForOf(awaitModifier, initializer, expression, statement) {
	        var node = createSynthesizedNode(220 /* ForOfStatement */);
	        node.awaitModifier = awaitModifier;
	        node.initializer = initializer;
	        node.expression = expression;
	        node.statement = statement;
	        return node;
	    }
	    ts.createForOf = createForOf;
	    function updateForOf(node, awaitModifier, initializer, expression, statement) {
	        return node.awaitModifier !== awaitModifier
	            || node.initializer !== initializer
	            || node.expression !== expression
	            || node.statement !== statement
	            ? updateNode(createForOf(awaitModifier, initializer, expression, statement), node)
	            : node;
	    }
	    ts.updateForOf = updateForOf;
	    function createContinue(label) {
	        var node = createSynthesizedNode(221 /* ContinueStatement */);
	        node.label = asName(label);
	        return node;
	    }
	    ts.createContinue = createContinue;
	    function updateContinue(node, label) {
	        return node.label !== label
	            ? updateNode(createContinue(label), node)
	            : node;
	    }
	    ts.updateContinue = updateContinue;
	    function createBreak(label) {
	        var node = createSynthesizedNode(222 /* BreakStatement */);
	        node.label = asName(label);
	        return node;
	    }
	    ts.createBreak = createBreak;
	    function updateBreak(node, label) {
	        return node.label !== label
	            ? updateNode(createBreak(label), node)
	            : node;
	    }
	    ts.updateBreak = updateBreak;
	    function createReturn(expression) {
	        var node = createSynthesizedNode(223 /* ReturnStatement */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createReturn = createReturn;
	    function updateReturn(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createReturn(expression), node)
	            : node;
	    }
	    ts.updateReturn = updateReturn;
	    function createWith(expression, statement) {
	        var node = createSynthesizedNode(224 /* WithStatement */);
	        node.expression = expression;
	        node.statement = statement;
	        return node;
	    }
	    ts.createWith = createWith;
	    function updateWith(node, expression, statement) {
	        return node.expression !== expression
	            || node.statement !== statement
	            ? updateNode(createWith(expression, statement), node)
	            : node;
	    }
	    ts.updateWith = updateWith;
	    function createSwitch(expression, caseBlock) {
	        var node = createSynthesizedNode(225 /* SwitchStatement */);
	        node.expression = ts.parenthesizeExpressionForList(expression);
	        node.caseBlock = caseBlock;
	        return node;
	    }
	    ts.createSwitch = createSwitch;
	    function updateSwitch(node, expression, caseBlock) {
	        return node.expression !== expression
	            || node.caseBlock !== caseBlock
	            ? updateNode(createSwitch(expression, caseBlock), node)
	            : node;
	    }
	    ts.updateSwitch = updateSwitch;
	    function createLabel(label, statement) {
	        var node = createSynthesizedNode(226 /* LabeledStatement */);
	        node.label = asName(label);
	        node.statement = statement;
	        return node;
	    }
	    ts.createLabel = createLabel;
	    function updateLabel(node, label, statement) {
	        return node.label !== label
	            || node.statement !== statement
	            ? updateNode(createLabel(label, statement), node)
	            : node;
	    }
	    ts.updateLabel = updateLabel;
	    function createThrow(expression) {
	        var node = createSynthesizedNode(227 /* ThrowStatement */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createThrow = createThrow;
	    function updateThrow(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createThrow(expression), node)
	            : node;
	    }
	    ts.updateThrow = updateThrow;
	    function createTry(tryBlock, catchClause, finallyBlock) {
	        var node = createSynthesizedNode(228 /* TryStatement */);
	        node.tryBlock = tryBlock;
	        node.catchClause = catchClause;
	        node.finallyBlock = finallyBlock;
	        return node;
	    }
	    ts.createTry = createTry;
	    function updateTry(node, tryBlock, catchClause, finallyBlock) {
	        return node.tryBlock !== tryBlock
	            || node.catchClause !== catchClause
	            || node.finallyBlock !== finallyBlock
	            ? updateNode(createTry(tryBlock, catchClause, finallyBlock), node)
	            : node;
	    }
	    ts.updateTry = updateTry;
	    function createDebuggerStatement() {
	        return createSynthesizedNode(229 /* DebuggerStatement */);
	    }
	    ts.createDebuggerStatement = createDebuggerStatement;
	    function createVariableDeclaration(name, type, initializer) {
	        var node = createSynthesizedNode(230 /* VariableDeclaration */);
	        node.name = asName(name);
	        node.type = type;
	        node.initializer = initializer !== undefined ? ts.parenthesizeExpressionForList(initializer) : undefined;
	        return node;
	    }
	    ts.createVariableDeclaration = createVariableDeclaration;
	    function updateVariableDeclaration(node, name, type, initializer) {
	        return node.name !== name
	            || node.type !== type
	            || node.initializer !== initializer
	            ? updateNode(createVariableDeclaration(name, type, initializer), node)
	            : node;
	    }
	    ts.updateVariableDeclaration = updateVariableDeclaration;
	    function createVariableDeclarationList(declarations, flags) {
	        var node = createSynthesizedNode(231 /* VariableDeclarationList */);
	        node.flags |= flags & 3 /* BlockScoped */;
	        node.declarations = createNodeArray(declarations);
	        return node;
	    }
	    ts.createVariableDeclarationList = createVariableDeclarationList;
	    function updateVariableDeclarationList(node, declarations) {
	        return node.declarations !== declarations
	            ? updateNode(createVariableDeclarationList(declarations, node.flags), node)
	            : node;
	    }
	    ts.updateVariableDeclarationList = updateVariableDeclarationList;
	    function createFunctionDeclaration(decorators, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
	        var node = createSynthesizedNode(232 /* FunctionDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.asteriskToken = asteriskToken;
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.body = body;
	        return node;
	    }
	    ts.createFunctionDeclaration = createFunctionDeclaration;
	    function updateFunctionDeclaration(node, decorators, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.asteriskToken !== asteriskToken
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.body !== body
	            ? updateNode(createFunctionDeclaration(decorators, modifiers, asteriskToken, name, typeParameters, parameters, type, body), node)
	            : node;
	    }
	    ts.updateFunctionDeclaration = updateFunctionDeclaration;
	    function createClassDeclaration(decorators, modifiers, name, typeParameters, heritageClauses, members) {
	        var node = createSynthesizedNode(233 /* ClassDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.heritageClauses = asNodeArray(heritageClauses);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createClassDeclaration = createClassDeclaration;
	    function updateClassDeclaration(node, decorators, modifiers, name, typeParameters, heritageClauses, members) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.heritageClauses !== heritageClauses
	            || node.members !== members
	            ? updateNode(createClassDeclaration(decorators, modifiers, name, typeParameters, heritageClauses, members), node)
	            : node;
	    }
	    ts.updateClassDeclaration = updateClassDeclaration;
	    function createInterfaceDeclaration(decorators, modifiers, name, typeParameters, heritageClauses, members) {
	        var node = createSynthesizedNode(234 /* InterfaceDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.heritageClauses = asNodeArray(heritageClauses);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createInterfaceDeclaration = createInterfaceDeclaration;
	    function updateInterfaceDeclaration(node, decorators, modifiers, name, typeParameters, heritageClauses, members) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.heritageClauses !== heritageClauses
	            || node.members !== members
	            ? updateNode(createInterfaceDeclaration(decorators, modifiers, name, typeParameters, heritageClauses, members), node)
	            : node;
	    }
	    ts.updateInterfaceDeclaration = updateInterfaceDeclaration;
	    function createTypeAliasDeclaration(decorators, modifiers, name, typeParameters, type) {
	        var node = createSynthesizedNode(235 /* TypeAliasDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.type = type;
	        return node;
	    }
	    ts.createTypeAliasDeclaration = createTypeAliasDeclaration;
	    function updateTypeAliasDeclaration(node, decorators, modifiers, name, typeParameters, type) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.type !== type
	            ? updateNode(createTypeAliasDeclaration(decorators, modifiers, name, typeParameters, type), node)
	            : node;
	    }
	    ts.updateTypeAliasDeclaration = updateTypeAliasDeclaration;
	    function createEnumDeclaration(decorators, modifiers, name, members) {
	        var node = createSynthesizedNode(236 /* EnumDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createEnumDeclaration = createEnumDeclaration;
	    function updateEnumDeclaration(node, decorators, modifiers, name, members) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.members !== members
	            ? updateNode(createEnumDeclaration(decorators, modifiers, name, members), node)
	            : node;
	    }
	    ts.updateEnumDeclaration = updateEnumDeclaration;
	    function createModuleDeclaration(decorators, modifiers, name, body, flags) {
	        var node = createSynthesizedNode(237 /* ModuleDeclaration */);
	        node.flags |= flags & (16 /* Namespace */ | 4 /* NestedNamespace */ | 512 /* GlobalAugmentation */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = name;
	        node.body = body;
	        return node;
	    }
	    ts.createModuleDeclaration = createModuleDeclaration;
	    function updateModuleDeclaration(node, decorators, modifiers, name, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.body !== body
	            ? updateNode(createModuleDeclaration(decorators, modifiers, name, body, node.flags), node)
	            : node;
	    }
	    ts.updateModuleDeclaration = updateModuleDeclaration;
	    function createModuleBlock(statements) {
	        var node = createSynthesizedNode(238 /* ModuleBlock */);
	        node.statements = createNodeArray(statements);
	        return node;
	    }
	    ts.createModuleBlock = createModuleBlock;
	    function updateModuleBlock(node, statements) {
	        return node.statements !== statements
	            ? updateNode(createModuleBlock(statements), node)
	            : node;
	    }
	    ts.updateModuleBlock = updateModuleBlock;
	    function createCaseBlock(clauses) {
	        var node = createSynthesizedNode(239 /* CaseBlock */);
	        node.clauses = createNodeArray(clauses);
	        return node;
	    }
	    ts.createCaseBlock = createCaseBlock;
	    function updateCaseBlock(node, clauses) {
	        return node.clauses !== clauses
	            ? updateNode(createCaseBlock(clauses), node)
	            : node;
	    }
	    ts.updateCaseBlock = updateCaseBlock;
	    function createNamespaceExportDeclaration(name) {
	        var node = createSynthesizedNode(240 /* NamespaceExportDeclaration */);
	        node.name = asName(name);
	        return node;
	    }
	    ts.createNamespaceExportDeclaration = createNamespaceExportDeclaration;
	    function updateNamespaceExportDeclaration(node, name) {
	        return node.name !== name
	            ? updateNode(createNamespaceExportDeclaration(name), node)
	            : node;
	    }
	    ts.updateNamespaceExportDeclaration = updateNamespaceExportDeclaration;
	    function createImportEqualsDeclaration(decorators, modifiers, name, moduleReference) {
	        var node = createSynthesizedNode(241 /* ImportEqualsDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.moduleReference = moduleReference;
	        return node;
	    }
	    ts.createImportEqualsDeclaration = createImportEqualsDeclaration;
	    function updateImportEqualsDeclaration(node, decorators, modifiers, name, moduleReference) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.moduleReference !== moduleReference
	            ? updateNode(createImportEqualsDeclaration(decorators, modifiers, name, moduleReference), node)
	            : node;
	    }
	    ts.updateImportEqualsDeclaration = updateImportEqualsDeclaration;
	    function createImportDeclaration(decorators, modifiers, importClause, moduleSpecifier) {
	        var node = createSynthesizedNode(242 /* ImportDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.importClause = importClause;
	        node.moduleSpecifier = moduleSpecifier;
	        return node;
	    }
	    ts.createImportDeclaration = createImportDeclaration;
	    function updateImportDeclaration(node, decorators, modifiers, importClause, moduleSpecifier) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.importClause !== importClause
	            || node.moduleSpecifier !== moduleSpecifier
	            ? updateNode(createImportDeclaration(decorators, modifiers, importClause, moduleSpecifier), node)
	            : node;
	    }
	    ts.updateImportDeclaration = updateImportDeclaration;
	    function createImportClause(name, namedBindings) {
	        var node = createSynthesizedNode(243 /* ImportClause */);
	        node.name = name;
	        node.namedBindings = namedBindings;
	        return node;
	    }
	    ts.createImportClause = createImportClause;
	    function updateImportClause(node, name, namedBindings) {
	        return node.name !== name
	            || node.namedBindings !== namedBindings
	            ? updateNode(createImportClause(name, namedBindings), node)
	            : node;
	    }
	    ts.updateImportClause = updateImportClause;
	    function createNamespaceImport(name) {
	        var node = createSynthesizedNode(244 /* NamespaceImport */);
	        node.name = name;
	        return node;
	    }
	    ts.createNamespaceImport = createNamespaceImport;
	    function updateNamespaceImport(node, name) {
	        return node.name !== name
	            ? updateNode(createNamespaceImport(name), node)
	            : node;
	    }
	    ts.updateNamespaceImport = updateNamespaceImport;
	    function createNamedImports(elements) {
	        var node = createSynthesizedNode(245 /* NamedImports */);
	        node.elements = createNodeArray(elements);
	        return node;
	    }
	    ts.createNamedImports = createNamedImports;
	    function updateNamedImports(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createNamedImports(elements), node)
	            : node;
	    }
	    ts.updateNamedImports = updateNamedImports;
	    function createImportSpecifier(propertyName, name) {
	        var node = createSynthesizedNode(246 /* ImportSpecifier */);
	        node.propertyName = propertyName;
	        node.name = name;
	        return node;
	    }
	    ts.createImportSpecifier = createImportSpecifier;
	    function updateImportSpecifier(node, propertyName, name) {
	        return node.propertyName !== propertyName
	            || node.name !== name
	            ? updateNode(createImportSpecifier(propertyName, name), node)
	            : node;
	    }
	    ts.updateImportSpecifier = updateImportSpecifier;
	    function createExportAssignment(decorators, modifiers, isExportEquals, expression) {
	        var node = createSynthesizedNode(247 /* ExportAssignment */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.isExportEquals = isExportEquals;
	        node.expression = isExportEquals ? ts.parenthesizeBinaryOperand(58 /* EqualsToken */, expression, /*isLeftSideOfBinary*/ false, /*leftOperand*/ undefined) : ts.parenthesizeDefaultExpression(expression);
	        return node;
	    }
	    ts.createExportAssignment = createExportAssignment;
	    function updateExportAssignment(node, decorators, modifiers, expression) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.expression !== expression
	            ? updateNode(createExportAssignment(decorators, modifiers, node.isExportEquals, expression), node)
	            : node;
	    }
	    ts.updateExportAssignment = updateExportAssignment;
	    function createExportDeclaration(decorators, modifiers, exportClause, moduleSpecifier) {
	        var node = createSynthesizedNode(248 /* ExportDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.exportClause = exportClause;
	        node.moduleSpecifier = moduleSpecifier;
	        return node;
	    }
	    ts.createExportDeclaration = createExportDeclaration;
	    function updateExportDeclaration(node, decorators, modifiers, exportClause, moduleSpecifier) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.exportClause !== exportClause
	            || node.moduleSpecifier !== moduleSpecifier
	            ? updateNode(createExportDeclaration(decorators, modifiers, exportClause, moduleSpecifier), node)
	            : node;
	    }
	    ts.updateExportDeclaration = updateExportDeclaration;
	    function createNamedExports(elements) {
	        var node = createSynthesizedNode(249 /* NamedExports */);
	        node.elements = createNodeArray(elements);
	        return node;
	    }
	    ts.createNamedExports = createNamedExports;
	    function updateNamedExports(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createNamedExports(elements), node)
	            : node;
	    }
	    ts.updateNamedExports = updateNamedExports;
	    function createExportSpecifier(propertyName, name) {
	        var node = createSynthesizedNode(250 /* ExportSpecifier */);
	        node.propertyName = asName(propertyName);
	        node.name = asName(name);
	        return node;
	    }
	    ts.createExportSpecifier = createExportSpecifier;
	    function updateExportSpecifier(node, propertyName, name) {
	        return node.propertyName !== propertyName
	            || node.name !== name
	            ? updateNode(createExportSpecifier(propertyName, name), node)
	            : node;
	    }
	    ts.updateExportSpecifier = updateExportSpecifier;
	    // Module references
	    function createExternalModuleReference(expression) {
	        var node = createSynthesizedNode(252 /* ExternalModuleReference */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createExternalModuleReference = createExternalModuleReference;
	    function updateExternalModuleReference(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createExternalModuleReference(expression), node)
	            : node;
	    }
	    ts.updateExternalModuleReference = updateExternalModuleReference;
	    // JSX
	    function createJsxElement(openingElement, children, closingElement) {
	        var node = createSynthesizedNode(253 /* JsxElement */);
	        node.openingElement = openingElement;
	        node.children = createNodeArray(children);
	        node.closingElement = closingElement;
	        return node;
	    }
	    ts.createJsxElement = createJsxElement;
	    function updateJsxElement(node, openingElement, children, closingElement) {
	        return node.openingElement !== openingElement
	            || node.children !== children
	            || node.closingElement !== closingElement
	            ? updateNode(createJsxElement(openingElement, children, closingElement), node)
	            : node;
	    }
	    ts.updateJsxElement = updateJsxElement;
	    function createJsxSelfClosingElement(tagName, attributes) {
	        var node = createSynthesizedNode(254 /* JsxSelfClosingElement */);
	        node.tagName = tagName;
	        node.attributes = attributes;
	        return node;
	    }
	    ts.createJsxSelfClosingElement = createJsxSelfClosingElement;
	    function updateJsxSelfClosingElement(node, tagName, attributes) {
	        return node.tagName !== tagName
	            || node.attributes !== attributes
	            ? updateNode(createJsxSelfClosingElement(tagName, attributes), node)
	            : node;
	    }
	    ts.updateJsxSelfClosingElement = updateJsxSelfClosingElement;
	    function createJsxOpeningElement(tagName, attributes) {
	        var node = createSynthesizedNode(255 /* JsxOpeningElement */);
	        node.tagName = tagName;
	        node.attributes = attributes;
	        return node;
	    }
	    ts.createJsxOpeningElement = createJsxOpeningElement;
	    function updateJsxOpeningElement(node, tagName, attributes) {
	        return node.tagName !== tagName
	            || node.attributes !== attributes
	            ? updateNode(createJsxOpeningElement(tagName, attributes), node)
	            : node;
	    }
	    ts.updateJsxOpeningElement = updateJsxOpeningElement;
	    function createJsxClosingElement(tagName) {
	        var node = createSynthesizedNode(256 /* JsxClosingElement */);
	        node.tagName = tagName;
	        return node;
	    }
	    ts.createJsxClosingElement = createJsxClosingElement;
	    function updateJsxClosingElement(node, tagName) {
	        return node.tagName !== tagName
	            ? updateNode(createJsxClosingElement(tagName), node)
	            : node;
	    }
	    ts.updateJsxClosingElement = updateJsxClosingElement;
	    function createJsxFragment(openingFragment, children, closingFragment) {
	        var node = createSynthesizedNode(257 /* JsxFragment */);
	        node.openingFragment = openingFragment;
	        node.children = createNodeArray(children);
	        node.closingFragment = closingFragment;
	        return node;
	    }
	    ts.createJsxFragment = createJsxFragment;
	    function updateJsxFragment(node, openingFragment, children, closingFragment) {
	        return node.openingFragment !== openingFragment
	            || node.children !== children
	            || node.closingFragment !== closingFragment
	            ? updateNode(createJsxFragment(openingFragment, children, closingFragment), node)
	            : node;
	    }
	    ts.updateJsxFragment = updateJsxFragment;
	    function createJsxAttribute(name, initializer) {
	        var node = createSynthesizedNode(260 /* JsxAttribute */);
	        node.name = name;
	        node.initializer = initializer;
	        return node;
	    }
	    ts.createJsxAttribute = createJsxAttribute;
	    function updateJsxAttribute(node, name, initializer) {
	        return node.name !== name
	            || node.initializer !== initializer
	            ? updateNode(createJsxAttribute(name, initializer), node)
	            : node;
	    }
	    ts.updateJsxAttribute = updateJsxAttribute;
	    function createJsxAttributes(properties) {
	        var node = createSynthesizedNode(261 /* JsxAttributes */);
	        node.properties = createNodeArray(properties);
	        return node;
	    }
	    ts.createJsxAttributes = createJsxAttributes;
	    function updateJsxAttributes(node, properties) {
	        return node.properties !== properties
	            ? updateNode(createJsxAttributes(properties), node)
	            : node;
	    }
	    ts.updateJsxAttributes = updateJsxAttributes;
	    function createJsxSpreadAttribute(expression) {
	        var node = createSynthesizedNode(262 /* JsxSpreadAttribute */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createJsxSpreadAttribute = createJsxSpreadAttribute;
	    function updateJsxSpreadAttribute(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createJsxSpreadAttribute(expression), node)
	            : node;
	    }
	    ts.updateJsxSpreadAttribute = updateJsxSpreadAttribute;
	    function createJsxExpression(dotDotDotToken, expression) {
	        var node = createSynthesizedNode(263 /* JsxExpression */);
	        node.dotDotDotToken = dotDotDotToken;
	        node.expression = expression;
	        return node;
	    }
	    ts.createJsxExpression = createJsxExpression;
	    function updateJsxExpression(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createJsxExpression(node.dotDotDotToken, expression), node)
	            : node;
	    }
	    ts.updateJsxExpression = updateJsxExpression;
	    // Clauses
	    function createCaseClause(expression, statements) {
	        var node = createSynthesizedNode(264 /* CaseClause */);
	        node.expression = ts.parenthesizeExpressionForList(expression);
	        node.statements = createNodeArray(statements);
	        return node;
	    }
	    ts.createCaseClause = createCaseClause;
	    function updateCaseClause(node, expression, statements) {
	        return node.expression !== expression
	            || node.statements !== statements
	            ? updateNode(createCaseClause(expression, statements), node)
	            : node;
	    }
	    ts.updateCaseClause = updateCaseClause;
	    function createDefaultClause(statements) {
	        var node = createSynthesizedNode(265 /* DefaultClause */);
	        node.statements = createNodeArray(statements);
	        return node;
	    }
	    ts.createDefaultClause = createDefaultClause;
	    function updateDefaultClause(node, statements) {
	        return node.statements !== statements
	            ? updateNode(createDefaultClause(statements), node)
	            : node;
	    }
	    ts.updateDefaultClause = updateDefaultClause;
	    function createHeritageClause(token, types) {
	        var node = createSynthesizedNode(266 /* HeritageClause */);
	        node.token = token;
	        node.types = createNodeArray(types);
	        return node;
	    }
	    ts.createHeritageClause = createHeritageClause;
	    function updateHeritageClause(node, types) {
	        return node.types !== types
	            ? updateNode(createHeritageClause(node.token, types), node)
	            : node;
	    }
	    ts.updateHeritageClause = updateHeritageClause;
	    function createCatchClause(variableDeclaration, block) {
	        var node = createSynthesizedNode(267 /* CatchClause */);
	        node.variableDeclaration = ts.isString(variableDeclaration) ? createVariableDeclaration(variableDeclaration) : variableDeclaration;
	        node.block = block;
	        return node;
	    }
	    ts.createCatchClause = createCatchClause;
	    function updateCatchClause(node, variableDeclaration, block) {
	        return node.variableDeclaration !== variableDeclaration
	            || node.block !== block
	            ? updateNode(createCatchClause(variableDeclaration, block), node)
	            : node;
	    }
	    ts.updateCatchClause = updateCatchClause;
	    // Property assignments
	    function createPropertyAssignment(name, initializer) {
	        var node = createSynthesizedNode(268 /* PropertyAssignment */);
	        node.name = asName(name);
	        node.questionToken = undefined;
	        node.initializer = initializer !== undefined ? ts.parenthesizeExpressionForList(initializer) : undefined;
	        return node;
	    }
	    ts.createPropertyAssignment = createPropertyAssignment;
	    function updatePropertyAssignment(node, name, initializer) {
	        return node.name !== name
	            || node.initializer !== initializer
	            ? updateNode(createPropertyAssignment(name, initializer), node)
	            : node;
	    }
	    ts.updatePropertyAssignment = updatePropertyAssignment;
	    function createShorthandPropertyAssignment(name, objectAssignmentInitializer) {
	        var node = createSynthesizedNode(269 /* ShorthandPropertyAssignment */);
	        node.name = asName(name);
	        node.objectAssignmentInitializer = objectAssignmentInitializer !== undefined ? ts.parenthesizeExpressionForList(objectAssignmentInitializer) : undefined;
	        return node;
	    }
	    ts.createShorthandPropertyAssignment = createShorthandPropertyAssignment;
	    function updateShorthandPropertyAssignment(node, name, objectAssignmentInitializer) {
	        return node.name !== name
	            || node.objectAssignmentInitializer !== objectAssignmentInitializer
	            ? updateNode(createShorthandPropertyAssignment(name, objectAssignmentInitializer), node)
	            : node;
	    }
	    ts.updateShorthandPropertyAssignment = updateShorthandPropertyAssignment;
	    function createSpreadAssignment(expression) {
	        var node = createSynthesizedNode(270 /* SpreadAssignment */);
	        node.expression = expression !== undefined ? ts.parenthesizeExpressionForList(expression) : undefined;
	        return node;
	    }
	    ts.createSpreadAssignment = createSpreadAssignment;
	    function updateSpreadAssignment(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createSpreadAssignment(expression), node)
	            : node;
	    }
	    ts.updateSpreadAssignment = updateSpreadAssignment;
	    // Enum
	    function createEnumMember(name, initializer) {
	        var node = createSynthesizedNode(271 /* EnumMember */);
	        node.name = asName(name);
	        node.initializer = initializer && ts.parenthesizeExpressionForList(initializer);
	        return node;
	    }
	    ts.createEnumMember = createEnumMember;
	    function updateEnumMember(node, name, initializer) {
	        return node.name !== name
	            || node.initializer !== initializer
	            ? updateNode(createEnumMember(name, initializer), node)
	            : node;
	    }
	    ts.updateEnumMember = updateEnumMember;
	    // Top-level nodes
	    function updateSourceFileNode(node, statements) {
	        if (node.statements !== statements) {
	            var updated = createSynthesizedNode(272 /* SourceFile */);
	            updated.flags |= node.flags;
	            updated.statements = createNodeArray(statements);
	            updated.endOfFileToken = node.endOfFileToken;
	            updated.fileName = node.fileName;
	            updated.path = node.path;
	            updated.text = node.text;
	            if (node.amdDependencies !== undefined)
	                updated.amdDependencies = node.amdDependencies;
	            if (node.moduleName !== undefined)
	                updated.moduleName = node.moduleName;
	            if (node.referencedFiles !== undefined)
	                updated.referencedFiles = node.referencedFiles;
	            if (node.typeReferenceDirectives !== undefined)
	                updated.typeReferenceDirectives = node.typeReferenceDirectives;
	            if (node.languageVariant !== undefined)
	                updated.languageVariant = node.languageVariant;
	            if (node.isDeclarationFile !== undefined)
	                updated.isDeclarationFile = node.isDeclarationFile;
	            if (node.renamedDependencies !== undefined)
	                updated.renamedDependencies = node.renamedDependencies;
	            if (node.hasNoDefaultLib !== undefined)
	                updated.hasNoDefaultLib = node.hasNoDefaultLib;
	            if (node.languageVersion !== undefined)
	                updated.languageVersion = node.languageVersion;
	            if (node.scriptKind !== undefined)
	                updated.scriptKind = node.scriptKind;
	            if (node.externalModuleIndicator !== undefined)
	                updated.externalModuleIndicator = node.externalModuleIndicator;
	            if (node.commonJsModuleIndicator !== undefined)
	                updated.commonJsModuleIndicator = node.commonJsModuleIndicator;
	            if (node.identifiers !== undefined)
	                updated.identifiers = node.identifiers;
	            if (node.nodeCount !== undefined)
	                updated.nodeCount = node.nodeCount;
	            if (node.identifierCount !== undefined)
	                updated.identifierCount = node.identifierCount;
	            if (node.symbolCount !== undefined)
	                updated.symbolCount = node.symbolCount;
	            if (node.parseDiagnostics !== undefined)
	                updated.parseDiagnostics = node.parseDiagnostics;
	            if (node.bindDiagnostics !== undefined)
	                updated.bindDiagnostics = node.bindDiagnostics;
	            if (node.lineMap !== undefined)
	                updated.lineMap = node.lineMap;
	            if (node.classifiableNames !== undefined)
	                updated.classifiableNames = node.classifiableNames;
	            if (node.resolvedModules !== undefined)
	                updated.resolvedModules = node.resolvedModules;
	            if (node.resolvedTypeReferenceDirectiveNames !== undefined)
	                updated.resolvedTypeReferenceDirectiveNames = node.resolvedTypeReferenceDirectiveNames;
	            if (node.imports !== undefined)
	                updated.imports = node.imports;
	            if (node.moduleAugmentations !== undefined)
	                updated.moduleAugmentations = node.moduleAugmentations;
	            return updateNode(updated, node);
	        }
	        return node;
	    }
	    ts.updateSourceFileNode = updateSourceFileNode;
	    /**
	     * Creates a shallow, memberwise clone of a node for mutation.
	     */
	    function getMutableClone(node) {
	        var clone = getSynthesizedClone(node);
	        clone.pos = node.pos;
	        clone.end = node.end;
	        clone.parent = node.parent;
	        return clone;
	    }
	    ts.getMutableClone = getMutableClone;
	    // Transformation nodes
	    /**
	     * Creates a synthetic statement to act as a placeholder for a not-emitted statement in
	     * order to preserve comments.
	     *
	     * @param original The original statement.
	     */
	    function createNotEmittedStatement(original) {
	        var node = createSynthesizedNode(294 /* NotEmittedStatement */);
	        node.original = original;
	        setTextRange(node, original);
	        return node;
	    }
	    ts.createNotEmittedStatement = createNotEmittedStatement;
	    /**
	     * Creates a synthetic element to act as a placeholder for the end of an emitted declaration in
	     * order to properly emit exports.
	     */
	    /* @internal */
	    function createEndOfDeclarationMarker(original) {
	        var node = createSynthesizedNode(298 /* EndOfDeclarationMarker */);
	        node.emitNode = {};
	        node.original = original;
	        return node;
	    }
	    ts.createEndOfDeclarationMarker = createEndOfDeclarationMarker;
	    /**
	     * Creates a synthetic element to act as a placeholder for the beginning of a merged declaration in
	     * order to properly emit exports.
	     */
	    /* @internal */
	    function createMergeDeclarationMarker(original) {
	        var node = createSynthesizedNode(297 /* MergeDeclarationMarker */);
	        node.emitNode = {};
	        node.original = original;
	        return node;
	    }
	    ts.createMergeDeclarationMarker = createMergeDeclarationMarker;
	    /**
	     * Creates a synthetic expression to act as a placeholder for a not-emitted expression in
	     * order to preserve comments or sourcemap positions.
	     *
	     * @param expression The inner expression to emit.
	     * @param original The original outer expression.
	     * @param location The location for the expression. Defaults to the positions from "original" if provided.
	     */
	    function createPartiallyEmittedExpression(expression, original) {
	        var node = createSynthesizedNode(295 /* PartiallyEmittedExpression */);
	        node.expression = expression;
	        node.original = original;
	        setTextRange(node, original);
	        return node;
	    }
	    ts.createPartiallyEmittedExpression = createPartiallyEmittedExpression;
	    function updatePartiallyEmittedExpression(node, expression) {
	        if (node.expression !== expression) {
	            return updateNode(createPartiallyEmittedExpression(expression, node.original), node);
	        }
	        return node;
	    }
	    ts.updatePartiallyEmittedExpression = updatePartiallyEmittedExpression;
	    function flattenCommaElements(node) {
	        if (ts.nodeIsSynthesized(node) && !ts.isParseTreeNode(node) && !node.original && !node.emitNode && !node.id) {
	            if (node.kind === 296 /* CommaListExpression */) {
	                return node.elements;
	            }
	            if (ts.isBinaryExpression(node) && node.operatorToken.kind === 26 /* CommaToken */) {
	                return [node.left, node.right];
	            }
	        }
	        return node;
	    }
	    function createCommaList(elements) {
	        var node = createSynthesizedNode(296 /* CommaListExpression */);
	        node.elements = createNodeArray(ts.sameFlatMap(elements, flattenCommaElements));
	        return node;
	    }
	    ts.createCommaList = createCommaList;
	    function updateCommaList(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createCommaList(elements), node)
	            : node;
	    }
	    ts.updateCommaList = updateCommaList;
	    function createBundle(sourceFiles) {
	        var node = ts.createNode(273 /* Bundle */);
	        node.sourceFiles = sourceFiles;
	        return node;
	    }
	    ts.createBundle = createBundle;
	    function updateBundle(node, sourceFiles) {
	        if (node.sourceFiles !== sourceFiles) {
	            return createBundle(sourceFiles);
	        }
	        return node;
	    }
	    ts.updateBundle = updateBundle;
	    function createImmediatelyInvokedFunctionExpression(statements, param, paramValue) {
	        return createCall(createFunctionExpression(
	        /*modifiers*/ undefined, 
	        /*asteriskToken*/ undefined, 
	        /*name*/ undefined, 
	        /*typeParameters*/ undefined, 
	        /*parameters*/ param ? [param] : [], 
	        /*type*/ undefined, createBlock(statements, /*multiLine*/ true)), 
	        /*typeArguments*/ undefined, 
	        /*argumentsArray*/ paramValue ? [paramValue] : []);
	    }
	    ts.createImmediatelyInvokedFunctionExpression = createImmediatelyInvokedFunctionExpression;
	    function createImmediatelyInvokedArrowFunction(statements, param, paramValue) {
	        return createCall(createArrowFunction(
	        /*modifiers*/ undefined, 
	        /*typeParameters*/ undefined, 
	        /*parameters*/ param ? [param] : [], 
	        /*type*/ undefined, 
	        /*equalsGreaterThanToken*/ undefined, createBlock(statements, /*multiLine*/ true)), 
	        /*typeArguments*/ undefined, 
	        /*argumentsArray*/ paramValue ? [paramValue] : []);
	    }
	    ts.createImmediatelyInvokedArrowFunction = createImmediatelyInvokedArrowFunction;
	    function createComma(left, right) {
	        return createBinary(left, 26 /* CommaToken */, right);
	    }
	    ts.createComma = createComma;
	    function createLessThan(left, right) {
	        return createBinary(left, 27 /* LessThanToken */, right);
	    }
	    ts.createLessThan = createLessThan;
	    function createAssignment(left, right) {
	        return createBinary(left, 58 /* EqualsToken */, right);
	    }
	    ts.createAssignment = createAssignment;
	    function createStrictEquality(left, right) {
	        return createBinary(left, 34 /* EqualsEqualsEqualsToken */, right);
	    }
	    ts.createStrictEquality = createStrictEquality;
	    function createStrictInequality(left, right) {
	        return createBinary(left, 35 /* ExclamationEqualsEqualsToken */, right);
	    }
	    ts.createStrictInequality = createStrictInequality;
	    function createAdd(left, right) {
	        return createBinary(left, 37 /* PlusToken */, right);
	    }
	    ts.createAdd = createAdd;
	    function createSubtract(left, right) {
	        return createBinary(left, 38 /* MinusToken */, right);
	    }
	    ts.createSubtract = createSubtract;
	    function createPostfixIncrement(operand) {
	        return createPostfix(operand, 43 /* PlusPlusToken */);
	    }
	    ts.createPostfixIncrement = createPostfixIncrement;
	    function createLogicalAnd(left, right) {
	        return createBinary(left, 53 /* AmpersandAmpersandToken */, right);
	    }
	    ts.createLogicalAnd = createLogicalAnd;
	    function createLogicalOr(left, right) {
	        return createBinary(left, 54 /* BarBarToken */, right);
	    }
	    ts.createLogicalOr = createLogicalOr;
	    function createLogicalNot(operand) {
	        return createPrefix(51 /* ExclamationToken */, operand);
	    }
	    ts.createLogicalNot = createLogicalNot;
	    function createVoidZero() {
	        return createVoid(createLiteral(0));
	    }
	    ts.createVoidZero = createVoidZero;
	    function createExportDefault(expression) {
	        return createExportAssignment(/*decorators*/ undefined, /*modifiers*/ undefined, /*isExportEquals*/ false, expression);
	    }
	    ts.createExportDefault = createExportDefault;
	    function createExternalModuleExport(exportName) {
	        return createExportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, createNamedExports([createExportSpecifier(/*propertyName*/ undefined, exportName)]));
	    }
	    ts.createExternalModuleExport = createExternalModuleExport;
	    function asName(name) {
	        return ts.isString(name) ? createIdentifier(name) : name;
	    }
	    function asExpression(value) {
	        return ts.isString(value) || typeof value === "number" ? createLiteral(value) : value;
	    }
	    function asNodeArray(array) {
	        return array ? createNodeArray(array) : undefined;
	    }
	    function asToken(value) {
	        return typeof value === "number" ? createToken(value) : value;
	    }
	    /**
	     * Clears any EmitNode entries from parse-tree nodes.
	     * @param sourceFile A source file.
	     */
	    function disposeEmitNodes(sourceFile) {
	        // During transformation we may need to annotate a parse tree node with transient
	        // transformation properties. As parse tree nodes live longer than transformation
	        // nodes, we need to make sure we reclaim any memory allocated for custom ranges
	        // from these nodes to ensure we do not hold onto entire subtrees just for position
	        // information. We also need to reset these nodes to a pre-transformation state
	        // for incremental parsing scenarios so that we do not impact later emit.
	        sourceFile = ts.getSourceFileOfNode(ts.getParseTreeNode(sourceFile));
	        var emitNode = sourceFile && sourceFile.emitNode;
	        var annotatedNodes = emitNode && emitNode.annotatedNodes;
	        if (annotatedNodes) {
	            for (var _i = 0, annotatedNodes_1 = annotatedNodes; _i < annotatedNodes_1.length; _i++) {
	                var node = annotatedNodes_1[_i];
	                node.emitNode = undefined;
	            }
	        }
	    }
	    ts.disposeEmitNodes = disposeEmitNodes;
	    /**
	     * Associates a node with the current transformation, initializing
	     * various transient transformation properties.
	     */
	    /* @internal */
	    function getOrCreateEmitNode(node) {
	        if (!node.emitNode) {
	            if (ts.isParseTreeNode(node)) {
	                // To avoid holding onto transformation artifacts, we keep track of any
	                // parse tree node we are annotating. This allows us to clean them up after
	                // all transformations have completed.
	                if (node.kind === 272 /* SourceFile */) {
	                    return node.emitNode = { annotatedNodes: [node] };
	                }
	                var sourceFile = ts.getSourceFileOfNode(node);
	                getOrCreateEmitNode(sourceFile).annotatedNodes.push(node);
	            }
	            node.emitNode = {};
	        }
	        return node.emitNode;
	    }
	    ts.getOrCreateEmitNode = getOrCreateEmitNode;
	    function setTextRange(range, location) {
	        if (location) {
	            range.pos = location.pos;
	            range.end = location.end;
	        }
	        return range;
	    }
	    ts.setTextRange = setTextRange;
	    /**
	     * Sets flags that control emit behavior of a node.
	     */
	    function setEmitFlags(node, emitFlags) {
	        getOrCreateEmitNode(node).flags = emitFlags;
	        return node;
	    }
	    ts.setEmitFlags = setEmitFlags;
	    /**
	     * Sets flags that control emit behavior of a node.
	     */
	    /* @internal */
	    function addEmitFlags(node, emitFlags) {
	        var emitNode = getOrCreateEmitNode(node);
	        emitNode.flags = emitNode.flags | emitFlags;
	        return node;
	    }
	    ts.addEmitFlags = addEmitFlags;
	    /**
	     * Gets a custom text range to use when emitting source maps.
	     */
	    function getSourceMapRange(node) {
	        var emitNode = node.emitNode;
	        return (emitNode && emitNode.sourceMapRange) || node;
	    }
	    ts.getSourceMapRange = getSourceMapRange;
	    /**
	     * Sets a custom text range to use when emitting source maps.
	     */
	    function setSourceMapRange(node, range) {
	        getOrCreateEmitNode(node).sourceMapRange = range;
	        return node;
	    }
	    ts.setSourceMapRange = setSourceMapRange;
	    // tslint:disable-next-line variable-name
	    var SourceMapSource;
	    /**
	     * Create an external source map source file reference
	     */
	    function createSourceMapSource(fileName, text, skipTrivia) {
	        return new (SourceMapSource || (SourceMapSource = ts.objectAllocator.getSourceMapSourceConstructor()))(fileName, text, skipTrivia);
	    }
	    ts.createSourceMapSource = createSourceMapSource;
	    /**
	     * Gets the TextRange to use for source maps for a token of a node.
	     */
	    function getTokenSourceMapRange(node, token) {
	        var emitNode = node.emitNode;
	        var tokenSourceMapRanges = emitNode && emitNode.tokenSourceMapRanges;
	        return tokenSourceMapRanges && tokenSourceMapRanges[token];
	    }
	    ts.getTokenSourceMapRange = getTokenSourceMapRange;
	    /**
	     * Sets the TextRange to use for source maps for a token of a node.
	     */
	    function setTokenSourceMapRange(node, token, range) {
	        var emitNode = getOrCreateEmitNode(node);
	        var tokenSourceMapRanges = emitNode.tokenSourceMapRanges || (emitNode.tokenSourceMapRanges = []);
	        tokenSourceMapRanges[token] = range;
	        return node;
	    }
	    ts.setTokenSourceMapRange = setTokenSourceMapRange;
	    /**
	     * Gets a custom text range to use when emitting comments.
	     */
	    /*@internal*/
	    function getStartsOnNewLine(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.startsOnNewLine;
	    }
	    ts.getStartsOnNewLine = getStartsOnNewLine;
	    /**
	     * Sets a custom text range to use when emitting comments.
	     */
	    /*@internal*/
	    function setStartsOnNewLine(node, newLine) {
	        getOrCreateEmitNode(node).startsOnNewLine = newLine;
	        return node;
	    }
	    ts.setStartsOnNewLine = setStartsOnNewLine;
	    /**
	     * Gets a custom text range to use when emitting comments.
	     */
	    function getCommentRange(node) {
	        var emitNode = node.emitNode;
	        return (emitNode && emitNode.commentRange) || node;
	    }
	    ts.getCommentRange = getCommentRange;
	    /**
	     * Sets a custom text range to use when emitting comments.
	     */
	    function setCommentRange(node, range) {
	        getOrCreateEmitNode(node).commentRange = range;
	        return node;
	    }
	    ts.setCommentRange = setCommentRange;
	    function getSyntheticLeadingComments(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.leadingComments;
	    }
	    ts.getSyntheticLeadingComments = getSyntheticLeadingComments;
	    function setSyntheticLeadingComments(node, comments) {
	        getOrCreateEmitNode(node).leadingComments = comments;
	        return node;
	    }
	    ts.setSyntheticLeadingComments = setSyntheticLeadingComments;
	    function addSyntheticLeadingComment(node, kind, text, hasTrailingNewLine) {
	        return setSyntheticLeadingComments(node, ts.append(getSyntheticLeadingComments(node), { kind: kind, pos: -1, end: -1, hasTrailingNewLine: hasTrailingNewLine, text: text }));
	    }
	    ts.addSyntheticLeadingComment = addSyntheticLeadingComment;
	    function getSyntheticTrailingComments(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.trailingComments;
	    }
	    ts.getSyntheticTrailingComments = getSyntheticTrailingComments;
	    function setSyntheticTrailingComments(node, comments) {
	        getOrCreateEmitNode(node).trailingComments = comments;
	        return node;
	    }
	    ts.setSyntheticTrailingComments = setSyntheticTrailingComments;
	    function addSyntheticTrailingComment(node, kind, text, hasTrailingNewLine) {
	        return setSyntheticTrailingComments(node, ts.append(getSyntheticTrailingComments(node), { kind: kind, pos: -1, end: -1, hasTrailingNewLine: hasTrailingNewLine, text: text }));
	    }
	    ts.addSyntheticTrailingComment = addSyntheticTrailingComment;
	    /**
	     * Gets the constant value to emit for an expression.
	     */
	    function getConstantValue(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.constantValue;
	    }
	    ts.getConstantValue = getConstantValue;
	    /**
	     * Sets the constant value to emit for an expression.
	     */
	    function setConstantValue(node, value) {
	        var emitNode = getOrCreateEmitNode(node);
	        emitNode.constantValue = value;
	        return node;
	    }
	    ts.setConstantValue = setConstantValue;
	    /**
	     * Adds an EmitHelper to a node.
	     */
	    function addEmitHelper(node, helper) {
	        var emitNode = getOrCreateEmitNode(node);
	        emitNode.helpers = ts.append(emitNode.helpers, helper);
	        return node;
	    }
	    ts.addEmitHelper = addEmitHelper;
	    /**
	     * Add EmitHelpers to a node.
	     */
	    function addEmitHelpers(node, helpers) {
	        if (ts.some(helpers)) {
	            var emitNode = getOrCreateEmitNode(node);
	            for (var _i = 0, helpers_1 = helpers; _i < helpers_1.length; _i++) {
	                var helper = helpers_1[_i];
	                emitNode.helpers = ts.appendIfUnique(emitNode.helpers, helper);
	            }
	        }
	        return node;
	    }
	    ts.addEmitHelpers = addEmitHelpers;
	    /**
	     * Removes an EmitHelper from a node.
	     */
	    function removeEmitHelper(node, helper) {
	        var emitNode = node.emitNode;
	        if (emitNode) {
	            var helpers = emitNode.helpers;
	            if (helpers) {
	                return ts.orderedRemoveItem(helpers, helper);
	            }
	        }
	        return false;
	    }
	    ts.removeEmitHelper = removeEmitHelper;
	    /**
	     * Gets the EmitHelpers of a node.
	     */
	    function getEmitHelpers(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.helpers;
	    }
	    ts.getEmitHelpers = getEmitHelpers;
	    /**
	     * Moves matching emit helpers from a source node to a target node.
	     */
	    function moveEmitHelpers(source, target, predicate) {
	        var sourceEmitNode = source.emitNode;
	        var sourceEmitHelpers = sourceEmitNode && sourceEmitNode.helpers;
	        if (!ts.some(sourceEmitHelpers))
	            return;
	        var targetEmitNode = getOrCreateEmitNode(target);
	        var helpersRemoved = 0;
	        for (var i = 0; i < sourceEmitHelpers.length; i++) {
	            var helper = sourceEmitHelpers[i];
	            if (predicate(helper)) {
	                helpersRemoved++;
	                targetEmitNode.helpers = ts.appendIfUnique(targetEmitNode.helpers, helper);
	            }
	            else if (helpersRemoved > 0) {
	                sourceEmitHelpers[i - helpersRemoved] = helper;
	            }
	        }
	        if (helpersRemoved > 0) {
	            sourceEmitHelpers.length -= helpersRemoved;
	        }
	    }
	    ts.moveEmitHelpers = moveEmitHelpers;
	    /* @internal */
	    function compareEmitHelpers(x, y) {
	        if (x === y)
	            return 0 /* EqualTo */;
	        if (x.priority === y.priority)
	            return 0 /* EqualTo */;
	        if (x.priority === undefined)
	            return 1 /* GreaterThan */;
	        if (y.priority === undefined)
	            return -1 /* LessThan */;
	        return ts.compareValues(x.priority, y.priority);
	    }
	    ts.compareEmitHelpers = compareEmitHelpers;
	    function setOriginalNode(node, original) {
	        node.original = original;
	        if (original) {
	            var emitNode = original.emitNode;
	            if (emitNode)
	                node.emitNode = mergeEmitNode(emitNode, node.emitNode);
	        }
	        return node;
	    }
	    ts.setOriginalNode = setOriginalNode;
	    function mergeEmitNode(sourceEmitNode, destEmitNode) {
	        var flags = sourceEmitNode.flags, leadingComments = sourceEmitNode.leadingComments, trailingComments = sourceEmitNode.trailingComments, commentRange = sourceEmitNode.commentRange, sourceMapRange = sourceEmitNode.sourceMapRange, tokenSourceMapRanges = sourceEmitNode.tokenSourceMapRanges, constantValue = sourceEmitNode.constantValue, helpers = sourceEmitNode.helpers, startsOnNewLine = sourceEmitNode.startsOnNewLine;
	        if (!destEmitNode)
	            destEmitNode = {};
	        // We are using `.slice()` here in case `destEmitNode.leadingComments` is pushed to later.
	        if (leadingComments)
	            destEmitNode.leadingComments = ts.addRange(leadingComments.slice(), destEmitNode.leadingComments);
	        if (trailingComments)
	            destEmitNode.trailingComments = ts.addRange(trailingComments.slice(), destEmitNode.trailingComments);
	        if (flags)
	            destEmitNode.flags = flags;
	        if (commentRange)
	            destEmitNode.commentRange = commentRange;
	        if (sourceMapRange)
	            destEmitNode.sourceMapRange = sourceMapRange;
	        if (tokenSourceMapRanges)
	            destEmitNode.tokenSourceMapRanges = mergeTokenSourceMapRanges(tokenSourceMapRanges, destEmitNode.tokenSourceMapRanges);
	        if (constantValue !== undefined)
	            destEmitNode.constantValue = constantValue;
	        if (helpers)
	            destEmitNode.helpers = ts.addRange(destEmitNode.helpers, helpers);
	        if (startsOnNewLine !== undefined)
	            destEmitNode.startsOnNewLine = startsOnNewLine;
	        return destEmitNode;
	    }
	    function mergeTokenSourceMapRanges(sourceRanges, destRanges) {
	        if (!destRanges)
	            destRanges = [];
	        for (var key in sourceRanges) {
	            destRanges[key] = sourceRanges[key];
	        }
	        return destRanges;
	    }
	})(ts || (ts = {}));
	/* @internal */
	(function (ts) {
	    ts.nullTransformationContext = {
	        enableEmitNotification: ts.noop,
	        enableSubstitution: ts.noop,
	        endLexicalEnvironment: function () { return undefined; },
	        getCompilerOptions: ts.notImplemented,
	        getEmitHost: ts.notImplemented,
	        getEmitResolver: ts.notImplemented,
	        hoistFunctionDeclaration: ts.noop,
	        hoistVariableDeclaration: ts.noop,
	        isEmitNotificationEnabled: ts.notImplemented,
	        isSubstitutionEnabled: ts.notImplemented,
	        onEmitNode: ts.noop,
	        onSubstituteNode: ts.notImplemented,
	        readEmitHelpers: ts.notImplemented,
	        requestEmitHelper: ts.noop,
	        resumeLexicalEnvironment: ts.noop,
	        startLexicalEnvironment: ts.noop,
	        suspendLexicalEnvironment: ts.noop
	    };
	    function createTypeCheck(value, tag) {
	        return tag === "undefined"
	            ? ts.createStrictEquality(value, ts.createVoidZero())
	            : ts.createStrictEquality(ts.createTypeOf(value), ts.createLiteral(tag));
	    }
	    ts.createTypeCheck = createTypeCheck;
	    function createMemberAccessForPropertyName(target, memberName, location) {
	        if (ts.isComputedPropertyName(memberName)) {
	            return ts.setTextRange(ts.createElementAccess(target, memberName.expression), location);
	        }
	        else {
	            var expression = ts.setTextRange(ts.isIdentifier(memberName)
	                ? ts.createPropertyAccess(target, memberName)
	                : ts.createElementAccess(target, memberName), memberName);
	            ts.getOrCreateEmitNode(expression).flags |= 64 /* NoNestedSourceMaps */;
	            return expression;
	        }
	    }
	    ts.createMemberAccessForPropertyName = createMemberAccessForPropertyName;
	    function createFunctionCall(func, thisArg, argumentsList, location) {
	        return ts.setTextRange(ts.createCall(ts.createPropertyAccess(func, "call"), 
	        /*typeArguments*/ undefined, [
	            thisArg
	        ].concat(argumentsList)), location);
	    }
	    ts.createFunctionCall = createFunctionCall;
	    function createFunctionApply(func, thisArg, argumentsExpression, location) {
	        return ts.setTextRange(ts.createCall(ts.createPropertyAccess(func, "apply"), 
	        /*typeArguments*/ undefined, [
	            thisArg,
	            argumentsExpression
	        ]), location);
	    }
	    ts.createFunctionApply = createFunctionApply;
	    function createArraySlice(array, start) {
	        var argumentsList = [];
	        if (start !== undefined) {
	            argumentsList.push(typeof start === "number" ? ts.createLiteral(start) : start);
	        }
	        return ts.createCall(ts.createPropertyAccess(array, "slice"), /*typeArguments*/ undefined, argumentsList);
	    }
	    ts.createArraySlice = createArraySlice;
	    function createArrayConcat(array, values) {
	        return ts.createCall(ts.createPropertyAccess(array, "concat"), 
	        /*typeArguments*/ undefined, values);
	    }
	    ts.createArrayConcat = createArrayConcat;
	    function createMathPow(left, right, location) {
	        return ts.setTextRange(ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Math"), "pow"), 
	        /*typeArguments*/ undefined, [left, right]), location);
	    }
	    ts.createMathPow = createMathPow;
	    function createReactNamespace(reactNamespace, parent) {
	        // To ensure the emit resolver can properly resolve the namespace, we need to
	        // treat this identifier as if it were a source tree node by clearing the `Synthesized`
	        // flag and setting a parent node.
	        var react = ts.createIdentifier(reactNamespace || "React");
	        react.flags &= ~8 /* Synthesized */;
	        // Set the parent that is in parse tree
	        // this makes sure that parent chain is intact for checker to traverse complete scope tree
	        react.parent = ts.getParseTreeNode(parent);
	        return react;
	    }
	    function createJsxFactoryExpressionFromEntityName(jsxFactory, parent) {
	        if (ts.isQualifiedName(jsxFactory)) {
	            var left = createJsxFactoryExpressionFromEntityName(jsxFactory.left, parent);
	            var right = ts.createIdentifier(ts.idText(jsxFactory.right));
	            right.escapedText = jsxFactory.right.escapedText;
	            return ts.createPropertyAccess(left, right);
	        }
	        else {
	            return createReactNamespace(ts.idText(jsxFactory), parent);
	        }
	    }
	    function createJsxFactoryExpression(jsxFactoryEntity, reactNamespace, parent) {
	        return jsxFactoryEntity ?
	            createJsxFactoryExpressionFromEntityName(jsxFactoryEntity, parent) :
	            ts.createPropertyAccess(createReactNamespace(reactNamespace, parent), "createElement");
	    }
	    function createExpressionForJsxElement(jsxFactoryEntity, reactNamespace, tagName, props, children, parentElement, location) {
	        var argumentsList = [tagName];
	        if (props) {
	            argumentsList.push(props);
	        }
	        if (children && children.length > 0) {
	            if (!props) {
	                argumentsList.push(ts.createNull());
	            }
	            if (children.length > 1) {
	                for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
	                    var child = children_1[_i];
	                    startOnNewLine(child);
	                    argumentsList.push(child);
	                }
	            }
	            else {
	                argumentsList.push(children[0]);
	            }
	        }
	        return ts.setTextRange(ts.createCall(createJsxFactoryExpression(jsxFactoryEntity, reactNamespace, parentElement), 
	        /*typeArguments*/ undefined, argumentsList), location);
	    }
	    ts.createExpressionForJsxElement = createExpressionForJsxElement;
	    function createExpressionForJsxFragment(jsxFactoryEntity, reactNamespace, children, parentElement, location) {
	        var tagName = ts.createPropertyAccess(createReactNamespace(reactNamespace, parentElement), "Fragment");
	        var argumentsList = [tagName];
	        argumentsList.push(ts.createNull());
	        if (children && children.length > 0) {
	            if (children.length > 1) {
	                for (var _i = 0, children_2 = children; _i < children_2.length; _i++) {
	                    var child = children_2[_i];
	                    startOnNewLine(child);
	                    argumentsList.push(child);
	                }
	            }
	            else {
	                argumentsList.push(children[0]);
	            }
	        }
	        return ts.setTextRange(ts.createCall(createJsxFactoryExpression(jsxFactoryEntity, reactNamespace, parentElement), 
	        /*typeArguments*/ undefined, argumentsList), location);
	    }
	    ts.createExpressionForJsxFragment = createExpressionForJsxFragment;
	    // Helpers
	    function getHelperName(name) {
	        return ts.setEmitFlags(ts.createIdentifier(name), 4096 /* HelperName */ | 2 /* AdviseOnEmitNode */);
	    }
	    ts.getHelperName = getHelperName;
	    var valuesHelper = {
	        name: "typescript:values",
	        scoped: false,
	        text: "\n            var __values = (this && this.__values) || function (o) {\n                var m = typeof Symbol === \"function\" && o[Symbol.iterator], i = 0;\n                if (m) return m.call(o);\n                return {\n                    next: function () {\n                        if (o && i >= o.length) o = void 0;\n                        return { value: o && o[i++], done: !o };\n                    }\n                };\n            };\n        "
	    };
	    function createValuesHelper(context, expression, location) {
	        context.requestEmitHelper(valuesHelper);
	        return ts.setTextRange(ts.createCall(getHelperName("__values"), 
	        /*typeArguments*/ undefined, [expression]), location);
	    }
	    ts.createValuesHelper = createValuesHelper;
	    var readHelper = {
	        name: "typescript:read",
	        scoped: false,
	        text: "\n            var __read = (this && this.__read) || function (o, n) {\n                var m = typeof Symbol === \"function\" && o[Symbol.iterator];\n                if (!m) return o;\n                var i = m.call(o), r, ar = [], e;\n                try {\n                    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);\n                }\n                catch (error) { e = { error: error }; }\n                finally {\n                    try {\n                        if (r && !r.done && (m = i[\"return\"])) m.call(i);\n                    }\n                    finally { if (e) throw e.error; }\n                }\n                return ar;\n            };\n        "
	    };
	    function createReadHelper(context, iteratorRecord, count, location) {
	        context.requestEmitHelper(readHelper);
	        return ts.setTextRange(ts.createCall(getHelperName("__read"), 
	        /*typeArguments*/ undefined, count !== undefined
	            ? [iteratorRecord, ts.createLiteral(count)]
	            : [iteratorRecord]), location);
	    }
	    ts.createReadHelper = createReadHelper;
	    var spreadHelper = {
	        name: "typescript:spread",
	        scoped: false,
	        text: "\n            var __spread = (this && this.__spread) || function () {\n                for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));\n                return ar;\n            };"
	    };
	    function createSpreadHelper(context, argumentList, location) {
	        context.requestEmitHelper(readHelper);
	        context.requestEmitHelper(spreadHelper);
	        return ts.setTextRange(ts.createCall(getHelperName("__spread"), 
	        /*typeArguments*/ undefined, argumentList), location);
	    }
	    ts.createSpreadHelper = createSpreadHelper;
	    // Utilities
	    function createForOfBindingStatement(node, boundValue) {
	        if (ts.isVariableDeclarationList(node)) {
	            var firstDeclaration = ts.firstOrUndefined(node.declarations);
	            var updatedDeclaration = ts.updateVariableDeclaration(firstDeclaration, firstDeclaration.name, 
	            /*typeNode*/ undefined, boundValue);
	            return ts.setTextRange(ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.updateVariableDeclarationList(node, [updatedDeclaration])), 
	            /*location*/ node);
	        }
	        else {
	            var updatedExpression = ts.setTextRange(ts.createAssignment(node, boundValue), /*location*/ node);
	            return ts.setTextRange(ts.createStatement(updatedExpression), /*location*/ node);
	        }
	    }
	    ts.createForOfBindingStatement = createForOfBindingStatement;
	    function insertLeadingStatement(dest, source) {
	        if (ts.isBlock(dest)) {
	            return ts.updateBlock(dest, ts.setTextRange(ts.createNodeArray([source].concat(dest.statements)), dest.statements));
	        }
	        else {
	            return ts.createBlock(ts.createNodeArray([dest, source]), /*multiLine*/ true);
	        }
	    }
	    ts.insertLeadingStatement = insertLeadingStatement;
	    function restoreEnclosingLabel(node, outermostLabeledStatement, afterRestoreLabelCallback) {
	        if (!outermostLabeledStatement) {
	            return node;
	        }
	        var updated = ts.updateLabel(outermostLabeledStatement, outermostLabeledStatement.label, outermostLabeledStatement.statement.kind === 226 /* LabeledStatement */
	            ? restoreEnclosingLabel(node, outermostLabeledStatement.statement)
	            : node);
	        if (afterRestoreLabelCallback) {
	            afterRestoreLabelCallback(outermostLabeledStatement);
	        }
	        return updated;
	    }
	    ts.restoreEnclosingLabel = restoreEnclosingLabel;
	    function shouldBeCapturedInTempVariable(node, cacheIdentifiers) {
	        var target = skipParentheses(node);
	        switch (target.kind) {
	            case 71 /* Identifier */:
	                return cacheIdentifiers;
	            case 99 /* ThisKeyword */:
	            case 8 /* NumericLiteral */:
	            case 9 /* StringLiteral */:
	                return false;
	            case 181 /* ArrayLiteralExpression */:
	                var elements = target.elements;
	                if (elements.length === 0) {
	                    return false;
	                }
	                return true;
	            case 182 /* ObjectLiteralExpression */:
	                return target.properties.length > 0;
	            default:
	                return true;
	        }
	    }
	    function createCallBinding(expression, recordTempVariable, languageVersion, cacheIdentifiers) {
	        var callee = skipOuterExpressions(expression, 7 /* All */);
	        var thisArg;
	        var target;
	        if (ts.isSuperProperty(callee)) {
	            thisArg = ts.createThis();
	            target = callee;
	        }
	        else if (callee.kind === 97 /* SuperKeyword */) {
	            thisArg = ts.createThis();
	            target = languageVersion < 2 /* ES2015 */
	                ? ts.setTextRange(ts.createIdentifier("_super"), callee)
	                : callee;
	        }
	        else if (ts.getEmitFlags(callee) & 4096 /* HelperName */) {
	            thisArg = ts.createVoidZero();
	            target = parenthesizeForAccess(callee);
	        }
	        else {
	            switch (callee.kind) {
	                case 183 /* PropertyAccessExpression */: {
	                    if (shouldBeCapturedInTempVariable(callee.expression, cacheIdentifiers)) {
	                        // for `a.b()` target is `(_a = a).b` and thisArg is `_a`
	                        thisArg = ts.createTempVariable(recordTempVariable);
	                        target = ts.createPropertyAccess(ts.setTextRange(ts.createAssignment(thisArg, callee.expression), callee.expression), callee.name);
	                        ts.setTextRange(target, callee);
	                    }
	                    else {
	                        thisArg = callee.expression;
	                        target = callee;
	                    }
	                    break;
	                }
	                case 184 /* ElementAccessExpression */: {
	                    if (shouldBeCapturedInTempVariable(callee.expression, cacheIdentifiers)) {
	                        // for `a[b]()` target is `(_a = a)[b]` and thisArg is `_a`
	                        thisArg = ts.createTempVariable(recordTempVariable);
	                        target = ts.createElementAccess(ts.setTextRange(ts.createAssignment(thisArg, callee.expression), callee.expression), callee.argumentExpression);
	                        ts.setTextRange(target, callee);
	                    }
	                    else {
	                        thisArg = callee.expression;
	                        target = callee;
	                    }
	                    break;
	                }
	                default: {
	                    // for `a()` target is `a` and thisArg is `void 0`
	                    thisArg = ts.createVoidZero();
	                    target = parenthesizeForAccess(expression);
	                    break;
	                }
	            }
	        }
	        return { target: target, thisArg: thisArg };
	    }
	    ts.createCallBinding = createCallBinding;
	    function inlineExpressions(expressions) {
	        // Avoid deeply nested comma expressions as traversing them during emit can result in "Maximum call
	        // stack size exceeded" errors.
	        return expressions.length > 10
	            ? ts.createCommaList(expressions)
	            : ts.reduceLeft(expressions, ts.createComma);
	    }
	    ts.inlineExpressions = inlineExpressions;
	    function createExpressionFromEntityName(node) {
	        if (ts.isQualifiedName(node)) {
	            var left = createExpressionFromEntityName(node.left);
	            var right = ts.getMutableClone(node.right);
	            return ts.setTextRange(ts.createPropertyAccess(left, right), node);
	        }
	        else {
	            return ts.getMutableClone(node);
	        }
	    }
	    ts.createExpressionFromEntityName = createExpressionFromEntityName;
	    function createExpressionForPropertyName(memberName) {
	        if (ts.isIdentifier(memberName)) {
	            return ts.createLiteral(memberName);
	        }
	        else if (ts.isComputedPropertyName(memberName)) {
	            return ts.getMutableClone(memberName.expression);
	        }
	        else {
	            return ts.getMutableClone(memberName);
	        }
	    }
	    ts.createExpressionForPropertyName = createExpressionForPropertyName;
	    function createExpressionForObjectLiteralElementLike(node, property, receiver) {
	        switch (property.kind) {
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return createExpressionForAccessorDeclaration(node.properties, property, receiver, node.multiLine);
	            case 268 /* PropertyAssignment */:
	                return createExpressionForPropertyAssignment(property, receiver);
	            case 269 /* ShorthandPropertyAssignment */:
	                return createExpressionForShorthandPropertyAssignment(property, receiver);
	            case 153 /* MethodDeclaration */:
	                return createExpressionForMethodDeclaration(property, receiver);
	        }
	    }
	    ts.createExpressionForObjectLiteralElementLike = createExpressionForObjectLiteralElementLike;
	    function createExpressionForAccessorDeclaration(properties, property, receiver, multiLine) {
	        var _a = ts.getAllAccessorDeclarations(properties, property), firstAccessor = _a.firstAccessor, getAccessor = _a.getAccessor, setAccessor = _a.setAccessor;
	        if (property === firstAccessor) {
	            var properties_9 = [];
	            if (getAccessor) {
	                var getterFunction = ts.createFunctionExpression(getAccessor.modifiers, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, getAccessor.parameters, 
	                /*type*/ undefined, getAccessor.body);
	                ts.setTextRange(getterFunction, getAccessor);
	                ts.setOriginalNode(getterFunction, getAccessor);
	                var getter = ts.createPropertyAssignment("get", getterFunction);
	                properties_9.push(getter);
	            }
	            if (setAccessor) {
	                var setterFunction = ts.createFunctionExpression(setAccessor.modifiers, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, setAccessor.parameters, 
	                /*type*/ undefined, setAccessor.body);
	                ts.setTextRange(setterFunction, setAccessor);
	                ts.setOriginalNode(setterFunction, setAccessor);
	                var setter = ts.createPropertyAssignment("set", setterFunction);
	                properties_9.push(setter);
	            }
	            properties_9.push(ts.createPropertyAssignment("enumerable", ts.createTrue()));
	            properties_9.push(ts.createPropertyAssignment("configurable", ts.createTrue()));
	            var expression = ts.setTextRange(ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Object"), "defineProperty"), 
	            /*typeArguments*/ undefined, [
	                receiver,
	                createExpressionForPropertyName(property.name),
	                ts.createObjectLiteral(properties_9, multiLine)
	            ]), 
	            /*location*/ firstAccessor);
	            return ts.aggregateTransformFlags(expression);
	        }
	        return undefined;
	    }
	    function createExpressionForPropertyAssignment(property, receiver) {
	        return ts.aggregateTransformFlags(ts.setOriginalNode(ts.setTextRange(ts.createAssignment(createMemberAccessForPropertyName(receiver, property.name, /*location*/ property.name), property.initializer), property), property));
	    }
	    function createExpressionForShorthandPropertyAssignment(property, receiver) {
	        return ts.aggregateTransformFlags(ts.setOriginalNode(ts.setTextRange(ts.createAssignment(createMemberAccessForPropertyName(receiver, property.name, /*location*/ property.name), ts.getSynthesizedClone(property.name)), 
	        /*location*/ property), 
	        /*original*/ property));
	    }
	    function createExpressionForMethodDeclaration(method, receiver) {
	        return ts.aggregateTransformFlags(ts.setOriginalNode(ts.setTextRange(ts.createAssignment(createMemberAccessForPropertyName(receiver, method.name, /*location*/ method.name), ts.setOriginalNode(ts.setTextRange(ts.createFunctionExpression(method.modifiers, method.asteriskToken, 
	        /*name*/ undefined, 
	        /*typeParameters*/ undefined, method.parameters, 
	        /*type*/ undefined, method.body), 
	        /*location*/ method), 
	        /*original*/ method)), 
	        /*location*/ method), 
	        /*original*/ method));
	    }
	    /**
	     * Gets the internal name of a declaration. This is primarily used for declarations that can be
	     * referred to by name in the body of an ES5 class function body. An internal name will *never*
	     * be prefixed with an module or namespace export modifier like "exports." when emitted as an
	     * expression. An internal name will also *never* be renamed due to a collision with a block
	     * scoped variable.
	     *
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getInternalName(node, allowComments, allowSourceMaps) {
	        return getName(node, allowComments, allowSourceMaps, 16384 /* LocalName */ | 32768 /* InternalName */);
	    }
	    ts.getInternalName = getInternalName;
	    /**
	     * Gets whether an identifier should only be referred to by its internal name.
	     */
	    function isInternalName(node) {
	        return (ts.getEmitFlags(node) & 32768 /* InternalName */) !== 0;
	    }
	    ts.isInternalName = isInternalName;
	    /**
	     * Gets the local name of a declaration. This is primarily used for declarations that can be
	     * referred to by name in the declaration's immediate scope (classes, enums, namespaces). A
	     * local name will *never* be prefixed with an module or namespace export modifier like
	     * "exports." when emitted as an expression.
	     *
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getLocalName(node, allowComments, allowSourceMaps) {
	        return getName(node, allowComments, allowSourceMaps, 16384 /* LocalName */);
	    }
	    ts.getLocalName = getLocalName;
	    /**
	     * Gets whether an identifier should only be referred to by its local name.
	     */
	    function isLocalName(node) {
	        return (ts.getEmitFlags(node) & 16384 /* LocalName */) !== 0;
	    }
	    ts.isLocalName = isLocalName;
	    /**
	     * Gets the export name of a declaration. This is primarily used for declarations that can be
	     * referred to by name in the declaration's immediate scope (classes, enums, namespaces). An
	     * export name will *always* be prefixed with an module or namespace export modifier like
	     * `"exports."` when emitted as an expression if the name points to an exported symbol.
	     *
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getExportName(node, allowComments, allowSourceMaps) {
	        return getName(node, allowComments, allowSourceMaps, 8192 /* ExportName */);
	    }
	    ts.getExportName = getExportName;
	    /**
	     * Gets whether an identifier should only be referred to by its export representation if the
	     * name points to an exported symbol.
	     */
	    function isExportName(node) {
	        return (ts.getEmitFlags(node) & 8192 /* ExportName */) !== 0;
	    }
	    ts.isExportName = isExportName;
	    /**
	     * Gets the name of a declaration for use in declarations.
	     *
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getDeclarationName(node, allowComments, allowSourceMaps) {
	        return getName(node, allowComments, allowSourceMaps);
	    }
	    ts.getDeclarationName = getDeclarationName;
	    function getName(node, allowComments, allowSourceMaps, emitFlags) {
	        var nodeName = ts.getNameOfDeclaration(node);
	        if (nodeName && ts.isIdentifier(nodeName) && !ts.isGeneratedIdentifier(nodeName)) {
	            var name = ts.getMutableClone(nodeName);
	            emitFlags |= ts.getEmitFlags(nodeName);
	            if (!allowSourceMaps)
	                emitFlags |= 48 /* NoSourceMap */;
	            if (!allowComments)
	                emitFlags |= 1536 /* NoComments */;
	            if (emitFlags)
	                ts.setEmitFlags(name, emitFlags);
	            return name;
	        }
	        return ts.getGeneratedNameForNode(node);
	    }
	    /**
	     * Gets the exported name of a declaration for use in expressions.
	     *
	     * An exported name will *always* be prefixed with an module or namespace export modifier like
	     * "exports." if the name points to an exported symbol.
	     *
	     * @param ns The namespace identifier.
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getExternalModuleOrNamespaceExportName(ns, node, allowComments, allowSourceMaps) {
	        if (ns && ts.hasModifier(node, 1 /* Export */)) {
	            return getNamespaceMemberName(ns, getName(node), allowComments, allowSourceMaps);
	        }
	        return getExportName(node, allowComments, allowSourceMaps);
	    }
	    ts.getExternalModuleOrNamespaceExportName = getExternalModuleOrNamespaceExportName;
	    /**
	     * Gets a namespace-qualified name for use in expressions.
	     *
	     * @param ns The namespace identifier.
	     * @param name The name.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getNamespaceMemberName(ns, name, allowComments, allowSourceMaps) {
	        var qualifiedName = ts.createPropertyAccess(ns, ts.nodeIsSynthesized(name) ? name : ts.getSynthesizedClone(name));
	        ts.setTextRange(qualifiedName, name);
	        var emitFlags;
	        if (!allowSourceMaps)
	            emitFlags |= 48 /* NoSourceMap */;
	        if (!allowComments)
	            emitFlags |= 1536 /* NoComments */;
	        if (emitFlags)
	            ts.setEmitFlags(qualifiedName, emitFlags);
	        return qualifiedName;
	    }
	    ts.getNamespaceMemberName = getNamespaceMemberName;
	    function convertToFunctionBody(node, multiLine) {
	        return ts.isBlock(node) ? node : ts.setTextRange(ts.createBlock([ts.setTextRange(ts.createReturn(node), node)], multiLine), node);
	    }
	    ts.convertToFunctionBody = convertToFunctionBody;
	    function convertFunctionDeclarationToExpression(node) {
	        ts.Debug.assert(!!node.body);
	        var updated = ts.createFunctionExpression(node.modifiers, node.asteriskToken, node.name, node.typeParameters, node.parameters, node.type, node.body);
	        ts.setOriginalNode(updated, node);
	        ts.setTextRange(updated, node);
	        if (ts.getStartsOnNewLine(node)) {
	            ts.setStartsOnNewLine(updated, /*newLine*/ true);
	        }
	        ts.aggregateTransformFlags(updated);
	        return updated;
	    }
	    ts.convertFunctionDeclarationToExpression = convertFunctionDeclarationToExpression;
	    function isUseStrictPrologue(node) {
	        return ts.isStringLiteral(node.expression) && node.expression.text === "use strict";
	    }
	    /**
	     * Add any necessary prologue-directives into target statement-array.
	     * The function needs to be called during each transformation step.
	     * This function needs to be called whenever we transform the statement
	     * list of a source file, namespace, or function-like body.
	     *
	     * @param target: result statements array
	     * @param source: origin statements array
	     * @param ensureUseStrict: boolean determining whether the function need to add prologue-directives
	     * @param visitor: Optional callback used to visit any custom prologue directives.
	     */
	    function addPrologue(target, source, ensureUseStrict, visitor) {
	        var offset = addStandardPrologue(target, source, ensureUseStrict);
	        return addCustomPrologue(target, source, offset, visitor);
	    }
	    ts.addPrologue = addPrologue;
	    /**
	     * Add just the standard (string-expression) prologue-directives into target statement-array.
	     * The function needs to be called during each transformation step.
	     * This function needs to be called whenever we transform the statement
	     * list of a source file, namespace, or function-like body.
	     */
	    function addStandardPrologue(target, source, ensureUseStrict) {
	        ts.Debug.assert(target.length === 0, "Prologue directives should be at the first statement in the target statements array");
	        var foundUseStrict = false;
	        var statementOffset = 0;
	        var numStatements = source.length;
	        while (statementOffset < numStatements) {
	            var statement = source[statementOffset];
	            if (ts.isPrologueDirective(statement)) {
	                if (isUseStrictPrologue(statement)) {
	                    foundUseStrict = true;
	                }
	                target.push(statement);
	            }
	            else {
	                break;
	            }
	            statementOffset++;
	        }
	        if (ensureUseStrict && !foundUseStrict) {
	            target.push(startOnNewLine(ts.createStatement(ts.createLiteral("use strict"))));
	        }
	        return statementOffset;
	    }
	    ts.addStandardPrologue = addStandardPrologue;
	    /**
	     * Add just the custom prologue-directives into target statement-array.
	     * The function needs to be called during each transformation step.
	     * This function needs to be called whenever we transform the statement
	     * list of a source file, namespace, or function-like body.
	     */
	    function addCustomPrologue(target, source, statementOffset, visitor) {
	        var numStatements = source.length;
	        while (statementOffset < numStatements) {
	            var statement = source[statementOffset];
	            if (ts.getEmitFlags(statement) & 1048576 /* CustomPrologue */) {
	                ts.append(target, visitor ? ts.visitNode(statement, visitor, ts.isStatement) : statement);
	            }
	            else {
	                break;
	            }
	            statementOffset++;
	        }
	        return statementOffset;
	    }
	    ts.addCustomPrologue = addCustomPrologue;
	    function startsWithUseStrict(statements) {
	        var firstStatement = ts.firstOrUndefined(statements);
	        return firstStatement !== undefined
	            && ts.isPrologueDirective(firstStatement)
	            && isUseStrictPrologue(firstStatement);
	    }
	    ts.startsWithUseStrict = startsWithUseStrict;
	    /**
	     * Ensures "use strict" directive is added
	     *
	     * @param statements An array of statements
	     */
	    function ensureUseStrict(statements) {
	        var foundUseStrict = false;
	        for (var _i = 0, statements_3 = statements; _i < statements_3.length; _i++) {
	            var statement = statements_3[_i];
	            if (ts.isPrologueDirective(statement)) {
	                if (isUseStrictPrologue(statement)) {
	                    foundUseStrict = true;
	                    break;
	                }
	            }
	            else {
	                break;
	            }
	        }
	        if (!foundUseStrict) {
	            return ts.setTextRange(ts.createNodeArray([
	                startOnNewLine(ts.createStatement(ts.createLiteral("use strict")))
	            ].concat(statements)), statements);
	        }
	        return statements;
	    }
	    ts.ensureUseStrict = ensureUseStrict;
	    /**
	     * Wraps the operand to a BinaryExpression in parentheses if they are needed to preserve the intended
	     * order of operations.
	     *
	     * @param binaryOperator The operator for the BinaryExpression.
	     * @param operand The operand for the BinaryExpression.
	     * @param isLeftSideOfBinary A value indicating whether the operand is the left side of the
	     *                           BinaryExpression.
	     */
	    function parenthesizeBinaryOperand(binaryOperator, operand, isLeftSideOfBinary, leftOperand) {
	        var skipped = ts.skipPartiallyEmittedExpressions(operand);
	        // If the resulting expression is already parenthesized, we do not need to do any further processing.
	        if (skipped.kind === 189 /* ParenthesizedExpression */) {
	            return operand;
	        }
	        return binaryOperandNeedsParentheses(binaryOperator, operand, isLeftSideOfBinary, leftOperand)
	            ? ts.createParen(operand)
	            : operand;
	    }
	    ts.parenthesizeBinaryOperand = parenthesizeBinaryOperand;
	    /**
	     * Determines whether the operand to a BinaryExpression needs to be parenthesized.
	     *
	     * @param binaryOperator The operator for the BinaryExpression.
	     * @param operand The operand for the BinaryExpression.
	     * @param isLeftSideOfBinary A value indicating whether the operand is the left side of the
	     *                           BinaryExpression.
	     */
	    function binaryOperandNeedsParentheses(binaryOperator, operand, isLeftSideOfBinary, leftOperand) {
	        // If the operand has lower precedence, then it needs to be parenthesized to preserve the
	        // intent of the expression. For example, if the operand is `a + b` and the operator is
	        // `*`, then we need to parenthesize the operand to preserve the intended order of
	        // operations: `(a + b) * x`.
	        //
	        // If the operand has higher precedence, then it does not need to be parenthesized. For
	        // example, if the operand is `a * b` and the operator is `+`, then we do not need to
	        // parenthesize to preserve the intended order of operations: `a * b + x`.
	        //
	        // If the operand has the same precedence, then we need to check the associativity of
	        // the operator based on whether this is the left or right operand of the expression.
	        //
	        // For example, if `a / d` is on the right of operator `*`, we need to parenthesize
	        // to preserve the intended order of operations: `x * (a / d)`
	        //
	        // If `a ** d` is on the left of operator `**`, we need to parenthesize to preserve
	        // the intended order of operations: `(a ** b) ** c`
	        var binaryOperatorPrecedence = ts.getOperatorPrecedence(198 /* BinaryExpression */, binaryOperator);
	        var binaryOperatorAssociativity = ts.getOperatorAssociativity(198 /* BinaryExpression */, binaryOperator);
	        var emittedOperand = ts.skipPartiallyEmittedExpressions(operand);
	        var operandPrecedence = ts.getExpressionPrecedence(emittedOperand);
	        switch (ts.compareValues(operandPrecedence, binaryOperatorPrecedence)) {
	            case -1 /* LessThan */:
	                // If the operand is the right side of a right-associative binary operation
	                // and is a yield expression, then we do not need parentheses.
	                if (!isLeftSideOfBinary
	                    && binaryOperatorAssociativity === 1 /* Right */
	                    && operand.kind === 201 /* YieldExpression */) {
	                    return false;
	                }
	                return true;
	            case 1 /* GreaterThan */:
	                return false;
	            case 0 /* EqualTo */:
	                if (isLeftSideOfBinary) {
	                    // No need to parenthesize the left operand when the binary operator is
	                    // left associative:
	                    //  (a*b)/x    -> a*b/x
	                    //  (a**b)/x   -> a**b/x
	                    //
	                    // Parentheses are needed for the left operand when the binary operator is
	                    // right associative:
	                    //  (a/b)**x   -> (a/b)**x
	                    //  (a**b)**x  -> (a**b)**x
	                    return binaryOperatorAssociativity === 1 /* Right */;
	                }
	                else {
	                    if (ts.isBinaryExpression(emittedOperand)
	                        && emittedOperand.operatorToken.kind === binaryOperator) {
	                        // No need to parenthesize the right operand when the binary operator and
	                        // operand are the same and one of the following:
	                        //  x*(a*b)     => x*a*b
	                        //  x|(a|b)     => x|a|b
	                        //  x&(a&b)     => x&a&b
	                        //  x^(a^b)     => x^a^b
	                        if (operatorHasAssociativeProperty(binaryOperator)) {
	                            return false;
	                        }
	                        // No need to parenthesize the right operand when the binary operator
	                        // is plus (+) if both the left and right operands consist solely of either
	                        // literals of the same kind or binary plus (+) expressions for literals of
	                        // the same kind (recursively).
	                        //  "a"+(1+2)       => "a"+(1+2)
	                        //  "a"+("b"+"c")   => "a"+"b"+"c"
	                        if (binaryOperator === 37 /* PlusToken */) {
	                            var leftKind = leftOperand ? getLiteralKindOfBinaryPlusOperand(leftOperand) : 0 /* Unknown */;
	                            if (ts.isLiteralKind(leftKind) && leftKind === getLiteralKindOfBinaryPlusOperand(emittedOperand)) {
	                                return false;
	                            }
	                        }
	                    }
	                    // No need to parenthesize the right operand when the operand is right
	                    // associative:
	                    //  x/(a**b)    -> x/a**b
	                    //  x**(a**b)   -> x**a**b
	                    //
	                    // Parentheses are needed for the right operand when the operand is left
	                    // associative:
	                    //  x/(a*b)     -> x/(a*b)
	                    //  x**(a/b)    -> x**(a/b)
	                    var operandAssociativity = ts.getExpressionAssociativity(emittedOperand);
	                    return operandAssociativity === 0 /* Left */;
	                }
	        }
	    }
	    /**
	     * Determines whether a binary operator is mathematically associative.
	     *
	     * @param binaryOperator The binary operator.
	     */
	    function operatorHasAssociativeProperty(binaryOperator) {
	        // The following operators are associative in JavaScript:
	        //  (a*b)*c     -> a*(b*c)  -> a*b*c
	        //  (a|b)|c     -> a|(b|c)  -> a|b|c
	        //  (a&b)&c     -> a&(b&c)  -> a&b&c
	        //  (a^b)^c     -> a^(b^c)  -> a^b^c
	        //
	        // While addition is associative in mathematics, JavaScript's `+` is not
	        // guaranteed to be associative as it is overloaded with string concatenation.
	        return binaryOperator === 39 /* AsteriskToken */
	            || binaryOperator === 49 /* BarToken */
	            || binaryOperator === 48 /* AmpersandToken */
	            || binaryOperator === 50 /* CaretToken */;
	    }
	    /**
	     * This function determines whether an expression consists of a homogeneous set of
	     * literal expressions or binary plus expressions that all share the same literal kind.
	     * It is used to determine whether the right-hand operand of a binary plus expression can be
	     * emitted without parentheses.
	     */
	    function getLiteralKindOfBinaryPlusOperand(node) {
	        node = ts.skipPartiallyEmittedExpressions(node);
	        if (ts.isLiteralKind(node.kind)) {
	            return node.kind;
	        }
	        if (node.kind === 198 /* BinaryExpression */ && node.operatorToken.kind === 37 /* PlusToken */) {
	            if (node.cachedLiteralKind !== undefined) {
	                return node.cachedLiteralKind;
	            }
	            var leftKind = getLiteralKindOfBinaryPlusOperand(node.left);
	            var literalKind = ts.isLiteralKind(leftKind)
	                && leftKind === getLiteralKindOfBinaryPlusOperand(node.right)
	                ? leftKind
	                : 0 /* Unknown */;
	            node.cachedLiteralKind = literalKind;
	            return literalKind;
	        }
	        return 0 /* Unknown */;
	    }
	    function parenthesizeForConditionalHead(condition) {
	        var conditionalPrecedence = ts.getOperatorPrecedence(199 /* ConditionalExpression */, 55 /* QuestionToken */);
	        var emittedCondition = ts.skipPartiallyEmittedExpressions(condition);
	        var conditionPrecedence = ts.getExpressionPrecedence(emittedCondition);
	        if (ts.compareValues(conditionPrecedence, conditionalPrecedence) === -1 /* LessThan */) {
	            return ts.createParen(condition);
	        }
	        return condition;
	    }
	    ts.parenthesizeForConditionalHead = parenthesizeForConditionalHead;
	    function parenthesizeSubexpressionOfConditionalExpression(e) {
	        // per ES grammar both 'whenTrue' and 'whenFalse' parts of conditional expression are assignment expressions
	        // so in case when comma expression is introduced as a part of previous transformations
	        // if should be wrapped in parens since comma operator has the lowest precedence
	        var emittedExpression = ts.skipPartiallyEmittedExpressions(e);
	        return emittedExpression.kind === 198 /* BinaryExpression */ && emittedExpression.operatorToken.kind === 26 /* CommaToken */ ||
	            emittedExpression.kind === 296 /* CommaListExpression */
	            ? ts.createParen(e)
	            : e;
	    }
	    ts.parenthesizeSubexpressionOfConditionalExpression = parenthesizeSubexpressionOfConditionalExpression;
	    /**
	     *  [Per the spec](https://tc39.github.io/ecma262/#prod-ExportDeclaration), `export default` accepts _AssigmentExpression_ but
	     *  has a lookahead restriction for `function`, `async function`, and `class`.
	     *
	     * Basically, that means we need to parenthesize in the following cases:
	     *
	     * - BinaryExpression of CommaToken
	     * - CommaList (synthetic list of multiple comma expressions)
	     * - FunctionExpression
	     * - ClassExpression
	     */
	    function parenthesizeDefaultExpression(e) {
	        var check = ts.skipPartiallyEmittedExpressions(e);
	        return (check.kind === 203 /* ClassExpression */ ||
	            check.kind === 190 /* FunctionExpression */ ||
	            check.kind === 296 /* CommaListExpression */ ||
	            ts.isBinaryExpression(check) && check.operatorToken.kind === 26 /* CommaToken */)
	            ? ts.createParen(e)
	            : e;
	    }
	    ts.parenthesizeDefaultExpression = parenthesizeDefaultExpression;
	    /**
	     * Wraps an expression in parentheses if it is needed in order to use the expression
	     * as the expression of a NewExpression node.
	     *
	     * @param expression The Expression node.
	     */
	    function parenthesizeForNew(expression) {
	        var leftmostExpr = getLeftmostExpression(expression, /*stopAtCallExpressions*/ true);
	        switch (leftmostExpr.kind) {
	            case 185 /* CallExpression */:
	                return ts.createParen(expression);
	            case 186 /* NewExpression */:
	                return !leftmostExpr.arguments
	                    ? ts.createParen(expression)
	                    : expression;
	        }
	        return parenthesizeForAccess(expression);
	    }
	    ts.parenthesizeForNew = parenthesizeForNew;
	    /**
	     * Wraps an expression in parentheses if it is needed in order to use the expression for
	     * property or element access.
	     *
	     * @param expr The expression node.
	     */
	    function parenthesizeForAccess(expression) {
	        // isLeftHandSideExpression is almost the correct criterion for when it is not necessary
	        // to parenthesize the expression before a dot. The known exception is:
	        //
	        //    NewExpression:
	        //       new C.x        -> not the same as (new C).x
	        //
	        var emittedExpression = ts.skipPartiallyEmittedExpressions(expression);
	        if (ts.isLeftHandSideExpression(emittedExpression)
	            && (emittedExpression.kind !== 186 /* NewExpression */ || emittedExpression.arguments)) {
	            return expression;
	        }
	        return ts.setTextRange(ts.createParen(expression), expression);
	    }
	    ts.parenthesizeForAccess = parenthesizeForAccess;
	    function parenthesizePostfixOperand(operand) {
	        return ts.isLeftHandSideExpression(operand)
	            ? operand
	            : ts.setTextRange(ts.createParen(operand), operand);
	    }
	    ts.parenthesizePostfixOperand = parenthesizePostfixOperand;
	    function parenthesizePrefixOperand(operand) {
	        return ts.isUnaryExpression(operand)
	            ? operand
	            : ts.setTextRange(ts.createParen(operand), operand);
	    }
	    ts.parenthesizePrefixOperand = parenthesizePrefixOperand;
	    function parenthesizeListElements(elements) {
	        var result;
	        for (var i = 0; i < elements.length; i++) {
	            var element = parenthesizeExpressionForList(elements[i]);
	            if (result !== undefined || element !== elements[i]) {
	                if (result === undefined) {
	                    result = elements.slice(0, i);
	                }
	                result.push(element);
	            }
	        }
	        if (result !== undefined) {
	            return ts.setTextRange(ts.createNodeArray(result, elements.hasTrailingComma), elements);
	        }
	        return elements;
	    }
	    ts.parenthesizeListElements = parenthesizeListElements;
	    function parenthesizeExpressionForList(expression) {
	        var emittedExpression = ts.skipPartiallyEmittedExpressions(expression);
	        var expressionPrecedence = ts.getExpressionPrecedence(emittedExpression);
	        var commaPrecedence = ts.getOperatorPrecedence(198 /* BinaryExpression */, 26 /* CommaToken */);
	        return expressionPrecedence > commaPrecedence
	            ? expression
	            : ts.setTextRange(ts.createParen(expression), expression);
	    }
	    ts.parenthesizeExpressionForList = parenthesizeExpressionForList;
	    function parenthesizeExpressionForExpressionStatement(expression) {
	        var emittedExpression = ts.skipPartiallyEmittedExpressions(expression);
	        if (ts.isCallExpression(emittedExpression)) {
	            var callee = emittedExpression.expression;
	            var kind = ts.skipPartiallyEmittedExpressions(callee).kind;
	            if (kind === 190 /* FunctionExpression */ || kind === 191 /* ArrowFunction */) {
	                var mutableCall = ts.getMutableClone(emittedExpression);
	                mutableCall.expression = ts.setTextRange(ts.createParen(callee), callee);
	                return recreateOuterExpressions(expression, mutableCall, 4 /* PartiallyEmittedExpressions */);
	            }
	        }
	        var leftmostExpressionKind = getLeftmostExpression(emittedExpression, /*stopAtCallExpressions*/ false).kind;
	        if (leftmostExpressionKind === 182 /* ObjectLiteralExpression */ || leftmostExpressionKind === 190 /* FunctionExpression */) {
	            return ts.setTextRange(ts.createParen(expression), expression);
	        }
	        return expression;
	    }
	    ts.parenthesizeExpressionForExpressionStatement = parenthesizeExpressionForExpressionStatement;
	    function parenthesizeConditionalTypeMember(member) {
	        return member.kind === 170 /* ConditionalType */ ? ts.createParenthesizedType(member) : member;
	    }
	    ts.parenthesizeConditionalTypeMember = parenthesizeConditionalTypeMember;
	    function parenthesizeElementTypeMember(member) {
	        switch (member.kind) {
	            case 168 /* UnionType */:
	            case 169 /* IntersectionType */:
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	                return ts.createParenthesizedType(member);
	        }
	        return parenthesizeConditionalTypeMember(member);
	    }
	    ts.parenthesizeElementTypeMember = parenthesizeElementTypeMember;
	    function parenthesizeArrayTypeMember(member) {
	        switch (member.kind) {
	            case 164 /* TypeQuery */:
	            case 174 /* TypeOperator */:
	                return ts.createParenthesizedType(member);
	        }
	        return parenthesizeElementTypeMember(member);
	    }
	    ts.parenthesizeArrayTypeMember = parenthesizeArrayTypeMember;
	    function parenthesizeElementTypeMembers(members) {
	        return ts.createNodeArray(ts.sameMap(members, parenthesizeElementTypeMember));
	    }
	    ts.parenthesizeElementTypeMembers = parenthesizeElementTypeMembers;
	    function parenthesizeTypeParameters(typeParameters) {
	        if (ts.some(typeParameters)) {
	            var params = [];
	            for (var i = 0; i < typeParameters.length; ++i) {
	                var entry = typeParameters[i];
	                params.push(i === 0 && ts.isFunctionOrConstructorTypeNode(entry) && entry.typeParameters ?
	                    ts.createParenthesizedType(entry) :
	                    entry);
	            }
	            return ts.createNodeArray(params);
	        }
	    }
	    ts.parenthesizeTypeParameters = parenthesizeTypeParameters;
	    function getLeftmostExpression(node, stopAtCallExpressions) {
	        while (true) {
	            switch (node.kind) {
	                case 197 /* PostfixUnaryExpression */:
	                    node = node.operand;
	                    continue;
	                case 198 /* BinaryExpression */:
	                    node = node.left;
	                    continue;
	                case 199 /* ConditionalExpression */:
	                    node = node.condition;
	                    continue;
	                case 185 /* CallExpression */:
	                    if (stopAtCallExpressions) {
	                        return node;
	                    }
	                // falls through
	                case 184 /* ElementAccessExpression */:
	                case 183 /* PropertyAccessExpression */:
	                    node = node.expression;
	                    continue;
	                case 295 /* PartiallyEmittedExpression */:
	                    node = node.expression;
	                    continue;
	            }
	            return node;
	        }
	    }
	    function parenthesizeConciseBody(body) {
	        if (!ts.isBlock(body) && getLeftmostExpression(body, /*stopAtCallExpressions*/ false).kind === 182 /* ObjectLiteralExpression */) {
	            return ts.setTextRange(ts.createParen(body), body);
	        }
	        return body;
	    }
	    ts.parenthesizeConciseBody = parenthesizeConciseBody;
	    var OuterExpressionKinds;
	    (function (OuterExpressionKinds) {
	        OuterExpressionKinds[OuterExpressionKinds["Parentheses"] = 1] = "Parentheses";
	        OuterExpressionKinds[OuterExpressionKinds["Assertions"] = 2] = "Assertions";
	        OuterExpressionKinds[OuterExpressionKinds["PartiallyEmittedExpressions"] = 4] = "PartiallyEmittedExpressions";
	        OuterExpressionKinds[OuterExpressionKinds["All"] = 7] = "All";
	    })(OuterExpressionKinds = ts.OuterExpressionKinds || (ts.OuterExpressionKinds = {}));
	    function isOuterExpression(node, kinds) {
	        if (kinds === void 0) { kinds = 7 /* All */; }
	        switch (node.kind) {
	            case 189 /* ParenthesizedExpression */:
	                return (kinds & 1 /* Parentheses */) !== 0;
	            case 188 /* TypeAssertionExpression */:
	            case 206 /* AsExpression */:
	            case 207 /* NonNullExpression */:
	                return (kinds & 2 /* Assertions */) !== 0;
	            case 295 /* PartiallyEmittedExpression */:
	                return (kinds & 4 /* PartiallyEmittedExpressions */) !== 0;
	        }
	        return false;
	    }
	    ts.isOuterExpression = isOuterExpression;
	    function skipOuterExpressions(node, kinds) {
	        if (kinds === void 0) { kinds = 7 /* All */; }
	        var previousNode;
	        do {
	            previousNode = node;
	            if (kinds & 1 /* Parentheses */) {
	                node = skipParentheses(node);
	            }
	            if (kinds & 2 /* Assertions */) {
	                node = skipAssertions(node);
	            }
	            if (kinds & 4 /* PartiallyEmittedExpressions */) {
	                node = ts.skipPartiallyEmittedExpressions(node);
	            }
	        } while (previousNode !== node);
	        return node;
	    }
	    ts.skipOuterExpressions = skipOuterExpressions;
	    function skipParentheses(node) {
	        while (node.kind === 189 /* ParenthesizedExpression */) {
	            node = node.expression;
	        }
	        return node;
	    }
	    ts.skipParentheses = skipParentheses;
	    function skipAssertions(node) {
	        while (ts.isAssertionExpression(node) || node.kind === 207 /* NonNullExpression */) {
	            node = node.expression;
	        }
	        return node;
	    }
	    ts.skipAssertions = skipAssertions;
	    function updateOuterExpression(outerExpression, expression) {
	        switch (outerExpression.kind) {
	            case 189 /* ParenthesizedExpression */: return ts.updateParen(outerExpression, expression);
	            case 188 /* TypeAssertionExpression */: return ts.updateTypeAssertion(outerExpression, outerExpression.type, expression);
	            case 206 /* AsExpression */: return ts.updateAsExpression(outerExpression, expression, outerExpression.type);
	            case 207 /* NonNullExpression */: return ts.updateNonNullExpression(outerExpression, expression);
	            case 295 /* PartiallyEmittedExpression */: return ts.updatePartiallyEmittedExpression(outerExpression, expression);
	        }
	    }
	    /**
	     * Determines whether a node is a parenthesized expression that can be ignored when recreating outer expressions.
	     *
	     * A parenthesized expression can be ignored when all of the following are true:
	     *
	     * - It's `pos` and `end` are not -1
	     * - It does not have a custom source map range
	     * - It does not have a custom comment range
	     * - It does not have synthetic leading or trailing comments
	     *
	     * If an outermost parenthesized expression is ignored, but the containing expression requires a parentheses around
	     * the expression to maintain precedence, a new parenthesized expression should be created automatically when
	     * the containing expression is created/updated.
	     */
	    function isIgnorableParen(node) {
	        return node.kind === 189 /* ParenthesizedExpression */
	            && ts.nodeIsSynthesized(node)
	            && ts.nodeIsSynthesized(ts.getSourceMapRange(node))
	            && ts.nodeIsSynthesized(ts.getCommentRange(node))
	            && !ts.some(ts.getSyntheticLeadingComments(node))
	            && !ts.some(ts.getSyntheticTrailingComments(node));
	    }
	    function recreateOuterExpressions(outerExpression, innerExpression, kinds) {
	        if (kinds === void 0) { kinds = 7 /* All */; }
	        if (outerExpression && isOuterExpression(outerExpression, kinds) && !isIgnorableParen(outerExpression)) {
	            return updateOuterExpression(outerExpression, recreateOuterExpressions(outerExpression.expression, innerExpression));
	        }
	        return innerExpression;
	    }
	    ts.recreateOuterExpressions = recreateOuterExpressions;
	    function startOnNewLine(node) {
	        return ts.setStartsOnNewLine(node, /*newLine*/ true);
	    }
	    ts.startOnNewLine = startOnNewLine;
	    function getExternalHelpersModuleName(node) {
	        var parseNode = ts.getOriginalNode(node, ts.isSourceFile);
	        var emitNode = parseNode && parseNode.emitNode;
	        return emitNode && emitNode.externalHelpersModuleName;
	    }
	    ts.getExternalHelpersModuleName = getExternalHelpersModuleName;
	    function getOrCreateExternalHelpersModuleNameIfNeeded(node, compilerOptions, hasExportStarsToExportValues, hasImportStarOrImportDefault) {
	        if (compilerOptions.importHelpers && ts.isEffectiveExternalModule(node, compilerOptions)) {
	            var externalHelpersModuleName = getExternalHelpersModuleName(node);
	            if (externalHelpersModuleName) {
	                return externalHelpersModuleName;
	            }
	            var moduleKind = ts.getEmitModuleKind(compilerOptions);
	            var create = (hasExportStarsToExportValues || (compilerOptions.esModuleInterop && hasImportStarOrImportDefault))
	                && moduleKind !== ts.ModuleKind.System
	                && moduleKind !== ts.ModuleKind.ES2015
	                && moduleKind !== ts.ModuleKind.ESNext;
	            if (!create) {
	                var helpers = ts.getEmitHelpers(node);
	                if (helpers) {
	                    for (var _i = 0, helpers_2 = helpers; _i < helpers_2.length; _i++) {
	                        var helper = helpers_2[_i];
	                        if (!helper.scoped) {
	                            create = true;
	                            break;
	                        }
	                    }
	                }
	            }
	            if (create) {
	                var parseNode = ts.getOriginalNode(node, ts.isSourceFile);
	                var emitNode = ts.getOrCreateEmitNode(parseNode);
	                return emitNode.externalHelpersModuleName || (emitNode.externalHelpersModuleName = ts.createUniqueName(ts.externalHelpersModuleNameText));
	            }
	        }
	    }
	    ts.getOrCreateExternalHelpersModuleNameIfNeeded = getOrCreateExternalHelpersModuleNameIfNeeded;
	    /**
	     * Get the name of that target module from an import or export declaration
	     */
	    function getLocalNameForExternalImport(node, sourceFile) {
	        var namespaceDeclaration = ts.getNamespaceDeclarationNode(node);
	        if (namespaceDeclaration && !ts.isDefaultImport(node)) {
	            var name = namespaceDeclaration.name;
	            return ts.isGeneratedIdentifier(name) ? name : ts.createIdentifier(ts.getSourceTextOfNodeFromSourceFile(sourceFile, name) || ts.idText(name));
	        }
	        if (node.kind === 242 /* ImportDeclaration */ && node.importClause) {
	            return ts.getGeneratedNameForNode(node);
	        }
	        if (node.kind === 248 /* ExportDeclaration */ && node.moduleSpecifier) {
	            return ts.getGeneratedNameForNode(node);
	        }
	        return undefined;
	    }
	    ts.getLocalNameForExternalImport = getLocalNameForExternalImport;
	    /**
	     * Get the name of a target module from an import/export declaration as should be written in the emitted output.
	     * The emitted output name can be different from the input if:
	     *  1. The module has a /// <amd-module name="<new name>" />
	     *  2. --out or --outFile is used, making the name relative to the rootDir
	     *  3- The containing SourceFile has an entry in renamedDependencies for the import as requested by some module loaders (e.g. System).
	     * Otherwise, a new StringLiteral node representing the module name will be returned.
	     */
	    function getExternalModuleNameLiteral(importNode, sourceFile, host, resolver, compilerOptions) {
	        var moduleName = ts.getExternalModuleName(importNode);
	        if (moduleName.kind === 9 /* StringLiteral */) {
	            return tryGetModuleNameFromDeclaration(importNode, host, resolver, compilerOptions)
	                || tryRenameExternalModule(moduleName, sourceFile)
	                || ts.getSynthesizedClone(moduleName);
	        }
	        return undefined;
	    }
	    ts.getExternalModuleNameLiteral = getExternalModuleNameLiteral;
	    /**
	     * Some bundlers (SystemJS builder) sometimes want to rename dependencies.
	     * Here we check if alternative name was provided for a given moduleName and return it if possible.
	     */
	    function tryRenameExternalModule(moduleName, sourceFile) {
	        var rename = sourceFile.renamedDependencies && sourceFile.renamedDependencies.get(moduleName.text);
	        return rename && ts.createLiteral(rename);
	    }
	    /**
	     * Get the name of a module as should be written in the emitted output.
	     * The emitted output name can be different from the input if:
	     *  1. The module has a /// <amd-module name="<new name>" />
	     *  2. --out or --outFile is used, making the name relative to the rootDir
	     * Otherwise, a new StringLiteral node representing the module name will be returned.
	     */
	    function tryGetModuleNameFromFile(file, host, options) {
	        if (!file) {
	            return undefined;
	        }
	        if (file.moduleName) {
	            return ts.createLiteral(file.moduleName);
	        }
	        if (!file.isDeclarationFile && (options.out || options.outFile)) {
	            return ts.createLiteral(ts.getExternalModuleNameFromPath(host, file.fileName));
	        }
	        return undefined;
	    }
	    ts.tryGetModuleNameFromFile = tryGetModuleNameFromFile;
	    function tryGetModuleNameFromDeclaration(declaration, host, resolver, compilerOptions) {
	        return tryGetModuleNameFromFile(resolver.getExternalModuleFileFromDeclaration(declaration), host, compilerOptions);
	    }
	    /**
	     * Gets the initializer of an BindingOrAssignmentElement.
	     */
	    function getInitializerOfBindingOrAssignmentElement(bindingElement) {
	        if (ts.isDeclarationBindingElement(bindingElement)) {
	            // `1` in `let { a = 1 } = ...`
	            // `1` in `let { a: b = 1 } = ...`
	            // `1` in `let { a: {b} = 1 } = ...`
	            // `1` in `let { a: [b] = 1 } = ...`
	            // `1` in `let [a = 1] = ...`
	            // `1` in `let [{a} = 1] = ...`
	            // `1` in `let [[a] = 1] = ...`
	            return bindingElement.initializer;
	        }
	        if (ts.isPropertyAssignment(bindingElement)) {
	            // `1` in `({ a: b = 1 } = ...)`
	            // `1` in `({ a: {b} = 1 } = ...)`
	            // `1` in `({ a: [b] = 1 } = ...)`
	            return ts.isAssignmentExpression(bindingElement.initializer, /*excludeCompoundAssignment*/ true)
	                ? bindingElement.initializer.right
	                : undefined;
	        }
	        if (ts.isShorthandPropertyAssignment(bindingElement)) {
	            // `1` in `({ a = 1 } = ...)`
	            return bindingElement.objectAssignmentInitializer;
	        }
	        if (ts.isAssignmentExpression(bindingElement, /*excludeCompoundAssignment*/ true)) {
	            // `1` in `[a = 1] = ...`
	            // `1` in `[{a} = 1] = ...`
	            // `1` in `[[a] = 1] = ...`
	            return bindingElement.right;
	        }
	        if (ts.isSpreadElement(bindingElement)) {
	            // Recovery consistent with existing emit.
	            return getInitializerOfBindingOrAssignmentElement(bindingElement.expression);
	        }
	    }
	    ts.getInitializerOfBindingOrAssignmentElement = getInitializerOfBindingOrAssignmentElement;
	    /**
	     * Gets the name of an BindingOrAssignmentElement.
	     */
	    function getTargetOfBindingOrAssignmentElement(bindingElement) {
	        if (ts.isDeclarationBindingElement(bindingElement)) {
	            // `a` in `let { a } = ...`
	            // `a` in `let { a = 1 } = ...`
	            // `b` in `let { a: b } = ...`
	            // `b` in `let { a: b = 1 } = ...`
	            // `a` in `let { ...a } = ...`
	            // `{b}` in `let { a: {b} } = ...`
	            // `{b}` in `let { a: {b} = 1 } = ...`
	            // `[b]` in `let { a: [b] } = ...`
	            // `[b]` in `let { a: [b] = 1 } = ...`
	            // `a` in `let [a] = ...`
	            // `a` in `let [a = 1] = ...`
	            // `a` in `let [...a] = ...`
	            // `{a}` in `let [{a}] = ...`
	            // `{a}` in `let [{a} = 1] = ...`
	            // `[a]` in `let [[a]] = ...`
	            // `[a]` in `let [[a] = 1] = ...`
	            return bindingElement.name;
	        }
	        if (ts.isObjectLiteralElementLike(bindingElement)) {
	            switch (bindingElement.kind) {
	                case 268 /* PropertyAssignment */:
	                    // `b` in `({ a: b } = ...)`
	                    // `b` in `({ a: b = 1 } = ...)`
	                    // `{b}` in `({ a: {b} } = ...)`
	                    // `{b}` in `({ a: {b} = 1 } = ...)`
	                    // `[b]` in `({ a: [b] } = ...)`
	                    // `[b]` in `({ a: [b] = 1 } = ...)`
	                    // `b.c` in `({ a: b.c } = ...)`
	                    // `b.c` in `({ a: b.c = 1 } = ...)`
	                    // `b[0]` in `({ a: b[0] } = ...)`
	                    // `b[0]` in `({ a: b[0] = 1 } = ...)`
	                    return getTargetOfBindingOrAssignmentElement(bindingElement.initializer);
	                case 269 /* ShorthandPropertyAssignment */:
	                    // `a` in `({ a } = ...)`
	                    // `a` in `({ a = 1 } = ...)`
	                    return bindingElement.name;
	                case 270 /* SpreadAssignment */:
	                    // `a` in `({ ...a } = ...)`
	                    return getTargetOfBindingOrAssignmentElement(bindingElement.expression);
	            }
	            // no target
	            return undefined;
	        }
	        if (ts.isAssignmentExpression(bindingElement, /*excludeCompoundAssignment*/ true)) {
	            // `a` in `[a = 1] = ...`
	            // `{a}` in `[{a} = 1] = ...`
	            // `[a]` in `[[a] = 1] = ...`
	            // `a.b` in `[a.b = 1] = ...`
	            // `a[0]` in `[a[0] = 1] = ...`
	            return getTargetOfBindingOrAssignmentElement(bindingElement.left);
	        }
	        if (ts.isSpreadElement(bindingElement)) {
	            // `a` in `[...a] = ...`
	            return getTargetOfBindingOrAssignmentElement(bindingElement.expression);
	        }
	        // `a` in `[a] = ...`
	        // `{a}` in `[{a}] = ...`
	        // `[a]` in `[[a]] = ...`
	        // `a.b` in `[a.b] = ...`
	        // `a[0]` in `[a[0]] = ...`
	        return bindingElement;
	    }
	    ts.getTargetOfBindingOrAssignmentElement = getTargetOfBindingOrAssignmentElement;
	    /**
	     * Determines whether an BindingOrAssignmentElement is a rest element.
	     */
	    function getRestIndicatorOfBindingOrAssignmentElement(bindingElement) {
	        switch (bindingElement.kind) {
	            case 148 /* Parameter */:
	            case 180 /* BindingElement */:
	                // `...` in `let [...a] = ...`
	                return bindingElement.dotDotDotToken;
	            case 202 /* SpreadElement */:
	            case 270 /* SpreadAssignment */:
	                // `...` in `[...a] = ...`
	                return bindingElement;
	        }
	        return undefined;
	    }
	    ts.getRestIndicatorOfBindingOrAssignmentElement = getRestIndicatorOfBindingOrAssignmentElement;
	    /**
	     * Gets the property name of a BindingOrAssignmentElement
	     */
	    function getPropertyNameOfBindingOrAssignmentElement(bindingElement) {
	        switch (bindingElement.kind) {
	            case 180 /* BindingElement */:
	                // `a` in `let { a: b } = ...`
	                // `[a]` in `let { [a]: b } = ...`
	                // `"a"` in `let { "a": b } = ...`
	                // `1` in `let { 1: b } = ...`
	                if (bindingElement.propertyName) {
	                    var propertyName = bindingElement.propertyName;
	                    return ts.isComputedPropertyName(propertyName) && ts.isStringOrNumericLiteral(propertyName.expression)
	                        ? propertyName.expression
	                        : propertyName;
	                }
	                break;
	            case 268 /* PropertyAssignment */:
	                // `a` in `({ a: b } = ...)`
	                // `[a]` in `({ [a]: b } = ...)`
	                // `"a"` in `({ "a": b } = ...)`
	                // `1` in `({ 1: b } = ...)`
	                if (bindingElement.name) {
	                    var propertyName = bindingElement.name;
	                    return ts.isComputedPropertyName(propertyName) && ts.isStringOrNumericLiteral(propertyName.expression)
	                        ? propertyName.expression
	                        : propertyName;
	                }
	                break;
	            case 270 /* SpreadAssignment */:
	                // `a` in `({ ...a } = ...)`
	                return bindingElement.name;
	        }
	        var target = getTargetOfBindingOrAssignmentElement(bindingElement);
	        if (target && ts.isPropertyName(target)) {
	            return ts.isComputedPropertyName(target) && ts.isStringOrNumericLiteral(target.expression)
	                ? target.expression
	                : target;
	        }
	        ts.Debug.fail("Invalid property name for binding element.");
	    }
	    ts.getPropertyNameOfBindingOrAssignmentElement = getPropertyNameOfBindingOrAssignmentElement;
	    /**
	     * Gets the elements of a BindingOrAssignmentPattern
	     */
	    function getElementsOfBindingOrAssignmentPattern(name) {
	        switch (name.kind) {
	            case 178 /* ObjectBindingPattern */:
	            case 179 /* ArrayBindingPattern */:
	            case 181 /* ArrayLiteralExpression */:
	                // `a` in `{a}`
	                // `a` in `[a]`
	                return name.elements;
	            case 182 /* ObjectLiteralExpression */:
	                // `a` in `{a}`
	                return name.properties;
	        }
	    }
	    ts.getElementsOfBindingOrAssignmentPattern = getElementsOfBindingOrAssignmentPattern;
	    function convertToArrayAssignmentElement(element) {
	        if (ts.isBindingElement(element)) {
	            if (element.dotDotDotToken) {
	                ts.Debug.assertNode(element.name, ts.isIdentifier);
	                return ts.setOriginalNode(ts.setTextRange(ts.createSpread(element.name), element), element);
	            }
	            var expression = convertToAssignmentElementTarget(element.name);
	            return element.initializer
	                ? ts.setOriginalNode(ts.setTextRange(ts.createAssignment(expression, element.initializer), element), element)
	                : expression;
	        }
	        ts.Debug.assertNode(element, ts.isExpression);
	        return element;
	    }
	    ts.convertToArrayAssignmentElement = convertToArrayAssignmentElement;
	    function convertToObjectAssignmentElement(element) {
	        if (ts.isBindingElement(element)) {
	            if (element.dotDotDotToken) {
	                ts.Debug.assertNode(element.name, ts.isIdentifier);
	                return ts.setOriginalNode(ts.setTextRange(ts.createSpreadAssignment(element.name), element), element);
	            }
	            if (element.propertyName) {
	                var expression = convertToAssignmentElementTarget(element.name);
	                return ts.setOriginalNode(ts.setTextRange(ts.createPropertyAssignment(element.propertyName, element.initializer ? ts.createAssignment(expression, element.initializer) : expression), element), element);
	            }
	            ts.Debug.assertNode(element.name, ts.isIdentifier);
	            return ts.setOriginalNode(ts.setTextRange(ts.createShorthandPropertyAssignment(element.name, element.initializer), element), element);
	        }
	        ts.Debug.assertNode(element, ts.isObjectLiteralElementLike);
	        return element;
	    }
	    ts.convertToObjectAssignmentElement = convertToObjectAssignmentElement;
	    function convertToAssignmentPattern(node) {
	        switch (node.kind) {
	            case 179 /* ArrayBindingPattern */:
	            case 181 /* ArrayLiteralExpression */:
	                return convertToArrayAssignmentPattern(node);
	            case 178 /* ObjectBindingPattern */:
	            case 182 /* ObjectLiteralExpression */:
	                return convertToObjectAssignmentPattern(node);
	        }
	    }
	    ts.convertToAssignmentPattern = convertToAssignmentPattern;
	    function convertToObjectAssignmentPattern(node) {
	        if (ts.isObjectBindingPattern(node)) {
	            return ts.setOriginalNode(ts.setTextRange(ts.createObjectLiteral(ts.map(node.elements, convertToObjectAssignmentElement)), node), node);
	        }
	        ts.Debug.assertNode(node, ts.isObjectLiteralExpression);
	        return node;
	    }
	    ts.convertToObjectAssignmentPattern = convertToObjectAssignmentPattern;
	    function convertToArrayAssignmentPattern(node) {
	        if (ts.isArrayBindingPattern(node)) {
	            return ts.setOriginalNode(ts.setTextRange(ts.createArrayLiteral(ts.map(node.elements, convertToArrayAssignmentElement)), node), node);
	        }
	        ts.Debug.assertNode(node, ts.isArrayLiteralExpression);
	        return node;
	    }
	    ts.convertToArrayAssignmentPattern = convertToArrayAssignmentPattern;
	    function convertToAssignmentElementTarget(node) {
	        if (ts.isBindingPattern(node)) {
	            return convertToAssignmentPattern(node);
	        }
	        ts.Debug.assertNode(node, ts.isExpression);
	        return node;
	    }
	    ts.convertToAssignmentElementTarget = convertToAssignmentElementTarget;
	})(ts || (ts = {}));
	/// <reference path="checker.ts" />
	/// <reference path="factory.ts" />
	/// <reference path="utilities.ts" />
	var ts;
	(function (ts) {
	    var isTypeNodeOrTypeParameterDeclaration = ts.or(ts.isTypeNode, ts.isTypeParameterDeclaration);
	    function visitNode(node, visitor, test, lift) {
	        if (node === undefined || visitor === undefined) {
	            return node;
	        }
	        ts.aggregateTransformFlags(node);
	        var visited = visitor(node);
	        if (visited === node) {
	            return node;
	        }
	        var visitedNode;
	        if (visited === undefined) {
	            return undefined;
	        }
	        else if (ts.isArray(visited)) {
	            visitedNode = (lift || extractSingleNode)(visited);
	        }
	        else {
	            visitedNode = visited;
	        }
	        ts.Debug.assertNode(visitedNode, test);
	        ts.aggregateTransformFlags(visitedNode);
	        return visitedNode;
	    }
	    ts.visitNode = visitNode;
	    /**
	     * Visits a NodeArray using the supplied visitor, possibly returning a new NodeArray in its place.
	     *
	     * @param nodes The NodeArray to visit.
	     * @param visitor The callback used to visit a Node.
	     * @param test A node test to execute for each node.
	     * @param start An optional value indicating the starting offset at which to start visiting.
	     * @param count An optional value indicating the maximum number of nodes to visit.
	     */
	    function visitNodes(nodes, visitor, test, start, count) {
	        if (nodes === undefined || visitor === undefined) {
	            return nodes;
	        }
	        var updated;
	        // Ensure start and count have valid values
	        var length = nodes.length;
	        if (start === undefined || start < 0) {
	            start = 0;
	        }
	        if (count === undefined || count > length - start) {
	            count = length - start;
	        }
	        if (start > 0 || count < length) {
	            // If we are not visiting all of the original nodes, we must always create a new array.
	            // Since this is a fragment of a node array, we do not copy over the previous location
	            // and will only copy over `hasTrailingComma` if we are including the last element.
	            updated = ts.createNodeArray([], /*hasTrailingComma*/ nodes.hasTrailingComma && start + count === length);
	        }
	        // Visit each original node.
	        for (var i = 0; i < count; i++) {
	            var node = nodes[i + start];
	            ts.aggregateTransformFlags(node);
	            var visited = node !== undefined ? visitor(node) : undefined;
	            if (updated !== undefined || visited === undefined || visited !== node) {
	                if (updated === undefined) {
	                    // Ensure we have a copy of `nodes`, up to the current index.
	                    updated = ts.createNodeArray(nodes.slice(0, i), nodes.hasTrailingComma);
	                    ts.setTextRange(updated, nodes);
	                }
	                if (visited) {
	                    if (ts.isArray(visited)) {
	                        for (var _i = 0, visited_1 = visited; _i < visited_1.length; _i++) {
	                            var visitedNode = visited_1[_i];
	                            ts.Debug.assertNode(visitedNode, test);
	                            ts.aggregateTransformFlags(visitedNode);
	                            updated.push(visitedNode);
	                        }
	                    }
	                    else {
	                        ts.Debug.assertNode(visited, test);
	                        ts.aggregateTransformFlags(visited);
	                        updated.push(visited);
	                    }
	                }
	            }
	        }
	        return updated || nodes;
	    }
	    ts.visitNodes = visitNodes;
	    /**
	     * Starts a new lexical environment and visits a statement list, ending the lexical environment
	     * and merging hoisted declarations upon completion.
	     */
	    function visitLexicalEnvironment(statements, visitor, context, start, ensureUseStrict) {
	        context.startLexicalEnvironment();
	        statements = visitNodes(statements, visitor, ts.isStatement, start);
	        if (ensureUseStrict && !ts.startsWithUseStrict(statements)) {
	            statements = ts.setTextRange(ts.createNodeArray([ts.createStatement(ts.createLiteral("use strict"))].concat(statements)), statements);
	        }
	        var declarations = context.endLexicalEnvironment();
	        return ts.setTextRange(ts.createNodeArray(ts.concatenate(statements, declarations)), statements);
	    }
	    ts.visitLexicalEnvironment = visitLexicalEnvironment;
	    /**
	     * Starts a new lexical environment and visits a parameter list, suspending the lexical
	     * environment upon completion.
	     */
	    function visitParameterList(nodes, visitor, context, nodesVisitor) {
	        if (nodesVisitor === void 0) { nodesVisitor = visitNodes; }
	        context.startLexicalEnvironment();
	        var updated = nodesVisitor(nodes, visitor, ts.isParameterDeclaration);
	        context.suspendLexicalEnvironment();
	        return updated;
	    }
	    ts.visitParameterList = visitParameterList;
	    function visitFunctionBody(node, visitor, context) {
	        context.resumeLexicalEnvironment();
	        var updated = visitNode(node, visitor, ts.isConciseBody);
	        var declarations = context.endLexicalEnvironment();
	        if (ts.some(declarations)) {
	            var block = ts.convertToFunctionBody(updated);
	            var statements = ts.mergeLexicalEnvironment(block.statements, declarations);
	            return ts.updateBlock(block, statements);
	        }
	        return updated;
	    }
	    ts.visitFunctionBody = visitFunctionBody;
	    function visitEachChild(node, visitor, context, nodesVisitor, tokenVisitor) {
	        if (nodesVisitor === void 0) { nodesVisitor = visitNodes; }
	        if (node === undefined) {
	            return undefined;
	        }
	        var kind = node.kind;
	        // No need to visit nodes with no children.
	        if ((kind > 0 /* FirstToken */ && kind <= 144 /* LastToken */) || kind === 173 /* ThisType */) {
	            return node;
	        }
	        switch (kind) {
	            // Names
	            case 71 /* Identifier */:
	                return ts.updateIdentifier(node, nodesVisitor(node.typeArguments, visitor, isTypeNodeOrTypeParameterDeclaration));
	            case 145 /* QualifiedName */:
	                return ts.updateQualifiedName(node, visitNode(node.left, visitor, ts.isEntityName), visitNode(node.right, visitor, ts.isIdentifier));
	            case 146 /* ComputedPropertyName */:
	                return ts.updateComputedPropertyName(node, visitNode(node.expression, visitor, ts.isExpression));
	            // Signature elements
	            case 147 /* TypeParameter */:
	                return ts.updateTypeParameterDeclaration(node, visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.constraint, visitor, ts.isTypeNode), visitNode(node.default, visitor, ts.isTypeNode));
	            case 148 /* Parameter */:
	                return ts.updateParameter(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.dotDotDotToken, tokenVisitor, ts.isToken), visitNode(node.name, visitor, ts.isBindingName), visitNode(node.questionToken, tokenVisitor, ts.isToken), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.initializer, visitor, ts.isExpression));
	            case 149 /* Decorator */:
	                return ts.updateDecorator(node, visitNode(node.expression, visitor, ts.isExpression));
	            // Type elements
	            case 150 /* PropertySignature */:
	                return ts.updatePropertySignature(node, nodesVisitor(node.modifiers, visitor, ts.isToken), visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.questionToken, tokenVisitor, ts.isToken), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.initializer, visitor, ts.isExpression));
	            case 151 /* PropertyDeclaration */:
	                return ts.updateProperty(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.questionToken, tokenVisitor, ts.isToken), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.initializer, visitor, ts.isExpression));
	            case 152 /* MethodSignature */:
	                return ts.updateMethodSignature(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.questionToken, tokenVisitor, ts.isToken));
	            case 153 /* MethodDeclaration */:
	                return ts.updateMethod(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.asteriskToken, tokenVisitor, ts.isToken), visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.questionToken, tokenVisitor, ts.isToken), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitFunctionBody(node.body, visitor, context));
	            case 154 /* Constructor */:
	                return ts.updateConstructor(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitFunctionBody(node.body, visitor, context));
	            case 155 /* GetAccessor */:
	                return ts.updateGetAccessor(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isPropertyName), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitFunctionBody(node.body, visitor, context));
	            case 156 /* SetAccessor */:
	                return ts.updateSetAccessor(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isPropertyName), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitFunctionBody(node.body, visitor, context));
	            case 157 /* CallSignature */:
	                return ts.updateCallSignature(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 158 /* ConstructSignature */:
	                return ts.updateConstructSignature(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 159 /* IndexSignature */:
	                return ts.updateIndexSignature(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            // Types
	            case 160 /* TypePredicate */:
	                return ts.updateTypePredicateNode(node, visitNode(node.parameterName, visitor), visitNode(node.type, visitor, ts.isTypeNode));
	            case 161 /* TypeReference */:
	                return ts.updateTypeReferenceNode(node, visitNode(node.typeName, visitor, ts.isEntityName), nodesVisitor(node.typeArguments, visitor, ts.isTypeNode));
	            case 162 /* FunctionType */:
	                return ts.updateFunctionTypeNode(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 163 /* ConstructorType */:
	                return ts.updateConstructorTypeNode(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 164 /* TypeQuery */:
	                return ts.updateTypeQueryNode(node, visitNode(node.exprName, visitor, ts.isEntityName));
	            case 165 /* TypeLiteral */:
	                return ts.updateTypeLiteralNode(node, nodesVisitor(node.members, visitor, ts.isTypeElement));
	            case 166 /* ArrayType */:
	                return ts.updateArrayTypeNode(node, visitNode(node.elementType, visitor, ts.isTypeNode));
	            case 167 /* TupleType */:
	                return ts.updateTypleTypeNode(node, nodesVisitor(node.elementTypes, visitor, ts.isTypeNode));
	            case 168 /* UnionType */:
	                return ts.updateUnionTypeNode(node, nodesVisitor(node.types, visitor, ts.isTypeNode));
	            case 169 /* IntersectionType */:
	                return ts.updateIntersectionTypeNode(node, nodesVisitor(node.types, visitor, ts.isTypeNode));
	            case 170 /* ConditionalType */:
	                return ts.updateConditionalTypeNode(node, visitNode(node.checkType, visitor, ts.isTypeNode), visitNode(node.extendsType, visitor, ts.isTypeNode), visitNode(node.trueType, visitor, ts.isTypeNode), visitNode(node.falseType, visitor, ts.isTypeNode));
	            case 171 /* InferType */:
	                return ts.updateInferTypeNode(node, visitNode(node.typeParameter, visitor, ts.isTypeParameterDeclaration));
	            case 172 /* ParenthesizedType */:
	                return ts.updateParenthesizedType(node, visitNode(node.type, visitor, ts.isTypeNode));
	            case 174 /* TypeOperator */:
	                return ts.updateTypeOperatorNode(node, visitNode(node.type, visitor, ts.isTypeNode));
	            case 175 /* IndexedAccessType */:
	                return ts.updateIndexedAccessTypeNode(node, visitNode(node.objectType, visitor, ts.isTypeNode), visitNode(node.indexType, visitor, ts.isTypeNode));
	            case 176 /* MappedType */:
	                return ts.updateMappedTypeNode(node, visitNode(node.readonlyToken, tokenVisitor, ts.isToken), visitNode(node.typeParameter, visitor, ts.isTypeParameterDeclaration), visitNode(node.questionToken, tokenVisitor, ts.isToken), visitNode(node.type, visitor, ts.isTypeNode));
	            case 177 /* LiteralType */:
	                return ts.updateLiteralTypeNode(node, visitNode(node.literal, visitor, ts.isExpression));
	            // Binding patterns
	            case 178 /* ObjectBindingPattern */:
	                return ts.updateObjectBindingPattern(node, nodesVisitor(node.elements, visitor, ts.isBindingElement));
	            case 179 /* ArrayBindingPattern */:
	                return ts.updateArrayBindingPattern(node, nodesVisitor(node.elements, visitor, ts.isArrayBindingElement));
	            case 180 /* BindingElement */:
	                return ts.updateBindingElement(node, visitNode(node.dotDotDotToken, tokenVisitor, ts.isToken), visitNode(node.propertyName, visitor, ts.isPropertyName), visitNode(node.name, visitor, ts.isBindingName), visitNode(node.initializer, visitor, ts.isExpression));
	            // Expression
	            case 181 /* ArrayLiteralExpression */:
	                return ts.updateArrayLiteral(node, nodesVisitor(node.elements, visitor, ts.isExpression));
	            case 182 /* ObjectLiteralExpression */:
	                return ts.updateObjectLiteral(node, nodesVisitor(node.properties, visitor, ts.isObjectLiteralElementLike));
	            case 183 /* PropertyAccessExpression */:
	                return ts.updatePropertyAccess(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.name, visitor, ts.isIdentifier));
	            case 184 /* ElementAccessExpression */:
	                return ts.updateElementAccess(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.argumentExpression, visitor, ts.isExpression));
	            case 185 /* CallExpression */:
	                return ts.updateCall(node, visitNode(node.expression, visitor, ts.isExpression), nodesVisitor(node.typeArguments, visitor, ts.isTypeNode), nodesVisitor(node.arguments, visitor, ts.isExpression));
	            case 186 /* NewExpression */:
	                return ts.updateNew(node, visitNode(node.expression, visitor, ts.isExpression), nodesVisitor(node.typeArguments, visitor, ts.isTypeNode), nodesVisitor(node.arguments, visitor, ts.isExpression));
	            case 187 /* TaggedTemplateExpression */:
	                return ts.updateTaggedTemplate(node, visitNode(node.tag, visitor, ts.isExpression), visitNode(node.template, visitor, ts.isTemplateLiteral));
	            case 188 /* TypeAssertionExpression */:
	                return ts.updateTypeAssertion(node, visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.expression, visitor, ts.isExpression));
	            case 189 /* ParenthesizedExpression */:
	                return ts.updateParen(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 190 /* FunctionExpression */:
	                return ts.updateFunctionExpression(node, nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.asteriskToken, tokenVisitor, ts.isToken), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitFunctionBody(node.body, visitor, context));
	            case 191 /* ArrowFunction */:
	                return ts.updateArrowFunction(node, nodesVisitor(node.modifiers, visitor, ts.isModifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.equalsGreaterThanToken, visitor, ts.isToken), visitFunctionBody(node.body, visitor, context));
	            case 192 /* DeleteExpression */:
	                return ts.updateDelete(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 193 /* TypeOfExpression */:
	                return ts.updateTypeOf(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 194 /* VoidExpression */:
	                return ts.updateVoid(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 195 /* AwaitExpression */:
	                return ts.updateAwait(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 196 /* PrefixUnaryExpression */:
	                return ts.updatePrefix(node, visitNode(node.operand, visitor, ts.isExpression));
	            case 197 /* PostfixUnaryExpression */:
	                return ts.updatePostfix(node, visitNode(node.operand, visitor, ts.isExpression));
	            case 198 /* BinaryExpression */:
	                return ts.updateBinary(node, visitNode(node.left, visitor, ts.isExpression), visitNode(node.right, visitor, ts.isExpression), visitNode(node.operatorToken, visitor, ts.isToken));
	            case 199 /* ConditionalExpression */:
	                return ts.updateConditional(node, visitNode(node.condition, visitor, ts.isExpression), visitNode(node.questionToken, visitor, ts.isToken), visitNode(node.whenTrue, visitor, ts.isExpression), visitNode(node.colonToken, visitor, ts.isToken), visitNode(node.whenFalse, visitor, ts.isExpression));
	            case 200 /* TemplateExpression */:
	                return ts.updateTemplateExpression(node, visitNode(node.head, visitor, ts.isTemplateHead), nodesVisitor(node.templateSpans, visitor, ts.isTemplateSpan));
	            case 201 /* YieldExpression */:
	                return ts.updateYield(node, visitNode(node.asteriskToken, tokenVisitor, ts.isToken), visitNode(node.expression, visitor, ts.isExpression));
	            case 202 /* SpreadElement */:
	                return ts.updateSpread(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 203 /* ClassExpression */:
	                return ts.updateClassExpression(node, nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, ts.isHeritageClause), nodesVisitor(node.members, visitor, ts.isClassElement));
	            case 205 /* ExpressionWithTypeArguments */:
	                return ts.updateExpressionWithTypeArguments(node, nodesVisitor(node.typeArguments, visitor, ts.isTypeNode), visitNode(node.expression, visitor, ts.isExpression));
	            case 206 /* AsExpression */:
	                return ts.updateAsExpression(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.type, visitor, ts.isTypeNode));
	            case 207 /* NonNullExpression */:
	                return ts.updateNonNullExpression(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 208 /* MetaProperty */:
	                return ts.updateMetaProperty(node, visitNode(node.name, visitor, ts.isIdentifier));
	            // Misc
	            case 209 /* TemplateSpan */:
	                return ts.updateTemplateSpan(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.literal, visitor, ts.isTemplateMiddleOrTemplateTail));
	            // Element
	            case 211 /* Block */:
	                return ts.updateBlock(node, nodesVisitor(node.statements, visitor, ts.isStatement));
	            case 212 /* VariableStatement */:
	                return ts.updateVariableStatement(node, nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.declarationList, visitor, ts.isVariableDeclarationList));
	            case 214 /* ExpressionStatement */:
	                return ts.updateStatement(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 215 /* IfStatement */:
	                return ts.updateIf(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.thenStatement, visitor, ts.isStatement, ts.liftToBlock), visitNode(node.elseStatement, visitor, ts.isStatement, ts.liftToBlock));
	            case 216 /* DoStatement */:
	                return ts.updateDo(node, visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock), visitNode(node.expression, visitor, ts.isExpression));
	            case 217 /* WhileStatement */:
	                return ts.updateWhile(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 218 /* ForStatement */:
	                return ts.updateFor(node, visitNode(node.initializer, visitor, ts.isForInitializer), visitNode(node.condition, visitor, ts.isExpression), visitNode(node.incrementor, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 219 /* ForInStatement */:
	                return ts.updateForIn(node, visitNode(node.initializer, visitor, ts.isForInitializer), visitNode(node.expression, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 220 /* ForOfStatement */:
	                return ts.updateForOf(node, visitNode(node.awaitModifier, visitor, ts.isToken), visitNode(node.initializer, visitor, ts.isForInitializer), visitNode(node.expression, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 221 /* ContinueStatement */:
	                return ts.updateContinue(node, visitNode(node.label, visitor, ts.isIdentifier));
	            case 222 /* BreakStatement */:
	                return ts.updateBreak(node, visitNode(node.label, visitor, ts.isIdentifier));
	            case 223 /* ReturnStatement */:
	                return ts.updateReturn(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 224 /* WithStatement */:
	                return ts.updateWith(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 225 /* SwitchStatement */:
	                return ts.updateSwitch(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.caseBlock, visitor, ts.isCaseBlock));
	            case 226 /* LabeledStatement */:
	                return ts.updateLabel(node, visitNode(node.label, visitor, ts.isIdentifier), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 227 /* ThrowStatement */:
	                return ts.updateThrow(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 228 /* TryStatement */:
	                return ts.updateTry(node, visitNode(node.tryBlock, visitor, ts.isBlock), visitNode(node.catchClause, visitor, ts.isCatchClause), visitNode(node.finallyBlock, visitor, ts.isBlock));
	            case 230 /* VariableDeclaration */:
	                return ts.updateVariableDeclaration(node, visitNode(node.name, visitor, ts.isBindingName), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.initializer, visitor, ts.isExpression));
	            case 231 /* VariableDeclarationList */:
	                return ts.updateVariableDeclarationList(node, nodesVisitor(node.declarations, visitor, ts.isVariableDeclaration));
	            case 232 /* FunctionDeclaration */:
	                return ts.updateFunctionDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.asteriskToken, tokenVisitor, ts.isToken), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitFunctionBody(node.body, visitor, context));
	            case 233 /* ClassDeclaration */:
	                return ts.updateClassDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, ts.isHeritageClause), nodesVisitor(node.members, visitor, ts.isClassElement));
	            case 234 /* InterfaceDeclaration */:
	                return ts.updateInterfaceDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, ts.isHeritageClause), nodesVisitor(node.members, visitor, ts.isTypeElement));
	            case 235 /* TypeAliasDeclaration */:
	                return ts.updateTypeAliasDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 236 /* EnumDeclaration */:
	                return ts.updateEnumDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.members, visitor, ts.isEnumMember));
	            case 237 /* ModuleDeclaration */:
	                return ts.updateModuleDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.body, visitor, ts.isModuleBody));
	            case 238 /* ModuleBlock */:
	                return ts.updateModuleBlock(node, nodesVisitor(node.statements, visitor, ts.isStatement));
	            case 239 /* CaseBlock */:
	                return ts.updateCaseBlock(node, nodesVisitor(node.clauses, visitor, ts.isCaseOrDefaultClause));
	            case 240 /* NamespaceExportDeclaration */:
	                return ts.updateNamespaceExportDeclaration(node, visitNode(node.name, visitor, ts.isIdentifier));
	            case 241 /* ImportEqualsDeclaration */:
	                return ts.updateImportEqualsDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.moduleReference, visitor, ts.isModuleReference));
	            case 242 /* ImportDeclaration */:
	                return ts.updateImportDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.importClause, visitor, ts.isImportClause), visitNode(node.moduleSpecifier, visitor, ts.isExpression));
	            case 243 /* ImportClause */:
	                return ts.updateImportClause(node, visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.namedBindings, visitor, ts.isNamedImportBindings));
	            case 244 /* NamespaceImport */:
	                return ts.updateNamespaceImport(node, visitNode(node.name, visitor, ts.isIdentifier));
	            case 245 /* NamedImports */:
	                return ts.updateNamedImports(node, nodesVisitor(node.elements, visitor, ts.isImportSpecifier));
	            case 246 /* ImportSpecifier */:
	                return ts.updateImportSpecifier(node, visitNode(node.propertyName, visitor, ts.isIdentifier), visitNode(node.name, visitor, ts.isIdentifier));
	            case 247 /* ExportAssignment */:
	                return ts.updateExportAssignment(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.expression, visitor, ts.isExpression));
	            case 248 /* ExportDeclaration */:
	                return ts.updateExportDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.exportClause, visitor, ts.isNamedExports), visitNode(node.moduleSpecifier, visitor, ts.isExpression));
	            case 249 /* NamedExports */:
	                return ts.updateNamedExports(node, nodesVisitor(node.elements, visitor, ts.isExportSpecifier));
	            case 250 /* ExportSpecifier */:
	                return ts.updateExportSpecifier(node, visitNode(node.propertyName, visitor, ts.isIdentifier), visitNode(node.name, visitor, ts.isIdentifier));
	            // Module references
	            case 252 /* ExternalModuleReference */:
	                return ts.updateExternalModuleReference(node, visitNode(node.expression, visitor, ts.isExpression));
	            // JSX
	            case 253 /* JsxElement */:
	                return ts.updateJsxElement(node, visitNode(node.openingElement, visitor, ts.isJsxOpeningElement), nodesVisitor(node.children, visitor, ts.isJsxChild), visitNode(node.closingElement, visitor, ts.isJsxClosingElement));
	            case 254 /* JsxSelfClosingElement */:
	                return ts.updateJsxSelfClosingElement(node, visitNode(node.tagName, visitor, ts.isJsxTagNameExpression), visitNode(node.attributes, visitor, ts.isJsxAttributes));
	            case 255 /* JsxOpeningElement */:
	                return ts.updateJsxOpeningElement(node, visitNode(node.tagName, visitor, ts.isJsxTagNameExpression), visitNode(node.attributes, visitor, ts.isJsxAttributes));
	            case 256 /* JsxClosingElement */:
	                return ts.updateJsxClosingElement(node, visitNode(node.tagName, visitor, ts.isJsxTagNameExpression));
	            case 257 /* JsxFragment */:
	                return ts.updateJsxFragment(node, visitNode(node.openingFragment, visitor, ts.isJsxOpeningFragment), nodesVisitor(node.children, visitor, ts.isJsxChild), visitNode(node.closingFragment, visitor, ts.isJsxClosingFragment));
	            case 260 /* JsxAttribute */:
	                return ts.updateJsxAttribute(node, visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.initializer, visitor, ts.isStringLiteralOrJsxExpression));
	            case 261 /* JsxAttributes */:
	                return ts.updateJsxAttributes(node, nodesVisitor(node.properties, visitor, ts.isJsxAttributeLike));
	            case 262 /* JsxSpreadAttribute */:
	                return ts.updateJsxSpreadAttribute(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 263 /* JsxExpression */:
	                return ts.updateJsxExpression(node, visitNode(node.expression, visitor, ts.isExpression));
	            // Clauses
	            case 264 /* CaseClause */:
	                return ts.updateCaseClause(node, visitNode(node.expression, visitor, ts.isExpression), nodesVisitor(node.statements, visitor, ts.isStatement));
	            case 265 /* DefaultClause */:
	                return ts.updateDefaultClause(node, nodesVisitor(node.statements, visitor, ts.isStatement));
	            case 266 /* HeritageClause */:
	                return ts.updateHeritageClause(node, nodesVisitor(node.types, visitor, ts.isExpressionWithTypeArguments));
	            case 267 /* CatchClause */:
	                return ts.updateCatchClause(node, visitNode(node.variableDeclaration, visitor, ts.isVariableDeclaration), visitNode(node.block, visitor, ts.isBlock));
	            // Property assignments
	            case 268 /* PropertyAssignment */:
	                return ts.updatePropertyAssignment(node, visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.initializer, visitor, ts.isExpression));
	            case 269 /* ShorthandPropertyAssignment */:
	                return ts.updateShorthandPropertyAssignment(node, visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.objectAssignmentInitializer, visitor, ts.isExpression));
	            case 270 /* SpreadAssignment */:
	                return ts.updateSpreadAssignment(node, visitNode(node.expression, visitor, ts.isExpression));
	            // Enum
	            case 271 /* EnumMember */:
	                return ts.updateEnumMember(node, visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.initializer, visitor, ts.isExpression));
	            // Top-level nodes
	            case 272 /* SourceFile */:
	                return ts.updateSourceFileNode(node, visitLexicalEnvironment(node.statements, visitor, context));
	            // Transformation nodes
	            case 295 /* PartiallyEmittedExpression */:
	                return ts.updatePartiallyEmittedExpression(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 296 /* CommaListExpression */:
	                return ts.updateCommaList(node, nodesVisitor(node.elements, visitor, ts.isExpression));
	            default:
	                // No need to visit nodes with no children.
	                return node;
	        }
	    }
	    ts.visitEachChild = visitEachChild;
	    /**
	     * Extracts the single node from a NodeArray.
	     *
	     * @param nodes The NodeArray.
	     */
	    function extractSingleNode(nodes) {
	        ts.Debug.assert(nodes.length <= 1, "Too many nodes written to output.");
	        return ts.singleOrUndefined(nodes);
	    }
	})(ts || (ts = {}));
	/* @internal */
	(function (ts) {
	    function reduceNode(node, f, initial) {
	        return node ? f(initial, node) : initial;
	    }
	    function reduceNodeArray(nodes, f, initial) {
	        return nodes ? f(initial, nodes) : initial;
	    }
	    /**
	     * Similar to `reduceLeft`, performs a reduction against each child of a node.
	     * NOTE: Unlike `forEachChild`, this does *not* visit every node.
	     *
	     * @param node The node containing the children to reduce.
	     * @param initial The initial value to supply to the reduction.
	     * @param f The callback function
	     */
	    function reduceEachChild(node, initial, cbNode, cbNodeArray) {
	        if (node === undefined) {
	            return initial;
	        }
	        var reduceNodes = cbNodeArray ? reduceNodeArray : ts.reduceLeft;
	        var cbNodes = cbNodeArray || cbNode;
	        var kind = node.kind;
	        // No need to visit nodes with no children.
	        if ((kind > 0 /* FirstToken */ && kind <= 144 /* LastToken */)) {
	            return initial;
	        }
	        // We do not yet support types.
	        if ((kind >= 160 /* TypePredicate */ && kind <= 177 /* LiteralType */)) {
	            return initial;
	        }
	        var result = initial;
	        switch (node.kind) {
	            // Leaf nodes
	            case 210 /* SemicolonClassElement */:
	            case 213 /* EmptyStatement */:
	            case 204 /* OmittedExpression */:
	            case 229 /* DebuggerStatement */:
	            case 294 /* NotEmittedStatement */:
	                // No need to visit nodes with no children.
	                break;
	            // Names
	            case 145 /* QualifiedName */:
	                result = reduceNode(node.left, cbNode, result);
	                result = reduceNode(node.right, cbNode, result);
	                break;
	            case 146 /* ComputedPropertyName */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // Signature elements
	            case 148 /* Parameter */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 149 /* Decorator */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // Type member
	            case 150 /* PropertySignature */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.questionToken, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 151 /* PropertyDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 153 /* MethodDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 154 /* Constructor */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 155 /* GetAccessor */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 156 /* SetAccessor */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            // Binding patterns
	            case 178 /* ObjectBindingPattern */:
	            case 179 /* ArrayBindingPattern */:
	                result = reduceNodes(node.elements, cbNodes, result);
	                break;
	            case 180 /* BindingElement */:
	                result = reduceNode(node.propertyName, cbNode, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            // Expression
	            case 181 /* ArrayLiteralExpression */:
	                result = reduceNodes(node.elements, cbNodes, result);
	                break;
	            case 182 /* ObjectLiteralExpression */:
	                result = reduceNodes(node.properties, cbNodes, result);
	                break;
	            case 183 /* PropertyAccessExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.name, cbNode, result);
	                break;
	            case 184 /* ElementAccessExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.argumentExpression, cbNode, result);
	                break;
	            case 185 /* CallExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNodes(node.typeArguments, cbNodes, result);
	                result = reduceNodes(node.arguments, cbNodes, result);
	                break;
	            case 186 /* NewExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNodes(node.typeArguments, cbNodes, result);
	                result = reduceNodes(node.arguments, cbNodes, result);
	                break;
	            case 187 /* TaggedTemplateExpression */:
	                result = reduceNode(node.tag, cbNode, result);
	                result = reduceNode(node.template, cbNode, result);
	                break;
	            case 188 /* TypeAssertionExpression */:
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 190 /* FunctionExpression */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 191 /* ArrowFunction */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 189 /* ParenthesizedExpression */:
	            case 192 /* DeleteExpression */:
	            case 193 /* TypeOfExpression */:
	            case 194 /* VoidExpression */:
	            case 195 /* AwaitExpression */:
	            case 201 /* YieldExpression */:
	            case 202 /* SpreadElement */:
	            case 207 /* NonNullExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 196 /* PrefixUnaryExpression */:
	            case 197 /* PostfixUnaryExpression */:
	                result = reduceNode(node.operand, cbNode, result);
	                break;
	            case 198 /* BinaryExpression */:
	                result = reduceNode(node.left, cbNode, result);
	                result = reduceNode(node.right, cbNode, result);
	                break;
	            case 199 /* ConditionalExpression */:
	                result = reduceNode(node.condition, cbNode, result);
	                result = reduceNode(node.whenTrue, cbNode, result);
	                result = reduceNode(node.whenFalse, cbNode, result);
	                break;
	            case 200 /* TemplateExpression */:
	                result = reduceNode(node.head, cbNode, result);
	                result = reduceNodes(node.templateSpans, cbNodes, result);
	                break;
	            case 203 /* ClassExpression */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.heritageClauses, cbNodes, result);
	                result = reduceNodes(node.members, cbNodes, result);
	                break;
	            case 205 /* ExpressionWithTypeArguments */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNodes(node.typeArguments, cbNodes, result);
	                break;
	            case 206 /* AsExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                break;
	            // Misc
	            case 209 /* TemplateSpan */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.literal, cbNode, result);
	                break;
	            // Element
	            case 211 /* Block */:
	                result = reduceNodes(node.statements, cbNodes, result);
	                break;
	            case 212 /* VariableStatement */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.declarationList, cbNode, result);
	                break;
	            case 214 /* ExpressionStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 215 /* IfStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.thenStatement, cbNode, result);
	                result = reduceNode(node.elseStatement, cbNode, result);
	                break;
	            case 216 /* DoStatement */:
	                result = reduceNode(node.statement, cbNode, result);
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 217 /* WhileStatement */:
	            case 224 /* WithStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.statement, cbNode, result);
	                break;
	            case 218 /* ForStatement */:
	                result = reduceNode(node.initializer, cbNode, result);
	                result = reduceNode(node.condition, cbNode, result);
	                result = reduceNode(node.incrementor, cbNode, result);
	                result = reduceNode(node.statement, cbNode, result);
	                break;
	            case 219 /* ForInStatement */:
	            case 220 /* ForOfStatement */:
	                result = reduceNode(node.initializer, cbNode, result);
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.statement, cbNode, result);
	                break;
	            case 223 /* ReturnStatement */:
	            case 227 /* ThrowStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 225 /* SwitchStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.caseBlock, cbNode, result);
	                break;
	            case 226 /* LabeledStatement */:
	                result = reduceNode(node.label, cbNode, result);
	                result = reduceNode(node.statement, cbNode, result);
	                break;
	            case 228 /* TryStatement */:
	                result = reduceNode(node.tryBlock, cbNode, result);
	                result = reduceNode(node.catchClause, cbNode, result);
	                result = reduceNode(node.finallyBlock, cbNode, result);
	                break;
	            case 230 /* VariableDeclaration */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 231 /* VariableDeclarationList */:
	                result = reduceNodes(node.declarations, cbNodes, result);
	                break;
	            case 232 /* FunctionDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 233 /* ClassDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.heritageClauses, cbNodes, result);
	                result = reduceNodes(node.members, cbNodes, result);
	                break;
	            case 236 /* EnumDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.members, cbNodes, result);
	                break;
	            case 237 /* ModuleDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 238 /* ModuleBlock */:
	                result = reduceNodes(node.statements, cbNodes, result);
	                break;
	            case 239 /* CaseBlock */:
	                result = reduceNodes(node.clauses, cbNodes, result);
	                break;
	            case 241 /* ImportEqualsDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.moduleReference, cbNode, result);
	                break;
	            case 242 /* ImportDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.importClause, cbNode, result);
	                result = reduceNode(node.moduleSpecifier, cbNode, result);
	                break;
	            case 243 /* ImportClause */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.namedBindings, cbNode, result);
	                break;
	            case 244 /* NamespaceImport */:
	                result = reduceNode(node.name, cbNode, result);
	                break;
	            case 245 /* NamedImports */:
	            case 249 /* NamedExports */:
	                result = reduceNodes(node.elements, cbNodes, result);
	                break;
	            case 246 /* ImportSpecifier */:
	            case 250 /* ExportSpecifier */:
	                result = reduceNode(node.propertyName, cbNode, result);
	                result = reduceNode(node.name, cbNode, result);
	                break;
	            case 247 /* ExportAssignment */:
	                result = ts.reduceLeft(node.decorators, cbNode, result);
	                result = ts.reduceLeft(node.modifiers, cbNode, result);
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 248 /* ExportDeclaration */:
	                result = ts.reduceLeft(node.decorators, cbNode, result);
	                result = ts.reduceLeft(node.modifiers, cbNode, result);
	                result = reduceNode(node.exportClause, cbNode, result);
	                result = reduceNode(node.moduleSpecifier, cbNode, result);
	                break;
	            // Module references
	            case 252 /* ExternalModuleReference */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // JSX
	            case 253 /* JsxElement */:
	                result = reduceNode(node.openingElement, cbNode, result);
	                result = ts.reduceLeft(node.children, cbNode, result);
	                result = reduceNode(node.closingElement, cbNode, result);
	                break;
	            case 257 /* JsxFragment */:
	                result = reduceNode(node.openingFragment, cbNode, result);
	                result = ts.reduceLeft(node.children, cbNode, result);
	                result = reduceNode(node.closingFragment, cbNode, result);
	                break;
	            case 254 /* JsxSelfClosingElement */:
	            case 255 /* JsxOpeningElement */:
	                result = reduceNode(node.tagName, cbNode, result);
	                result = reduceNode(node.attributes, cbNode, result);
	                break;
	            case 261 /* JsxAttributes */:
	                result = reduceNodes(node.properties, cbNodes, result);
	                break;
	            case 256 /* JsxClosingElement */:
	                result = reduceNode(node.tagName, cbNode, result);
	                break;
	            case 260 /* JsxAttribute */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 262 /* JsxSpreadAttribute */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 263 /* JsxExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // Clauses
	            case 264 /* CaseClause */:
	                result = reduceNode(node.expression, cbNode, result);
	            // falls through
	            case 265 /* DefaultClause */:
	                result = reduceNodes(node.statements, cbNodes, result);
	                break;
	            case 266 /* HeritageClause */:
	                result = reduceNodes(node.types, cbNodes, result);
	                break;
	            case 267 /* CatchClause */:
	                result = reduceNode(node.variableDeclaration, cbNode, result);
	                result = reduceNode(node.block, cbNode, result);
	                break;
	            // Property assignments
	            case 268 /* PropertyAssignment */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 269 /* ShorthandPropertyAssignment */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.objectAssignmentInitializer, cbNode, result);
	                break;
	            case 270 /* SpreadAssignment */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // Enum
	            case 271 /* EnumMember */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            // Top-level nodes
	            case 272 /* SourceFile */:
	                result = reduceNodes(node.statements, cbNodes, result);
	                break;
	            // Transformation nodes
	            case 295 /* PartiallyEmittedExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 296 /* CommaListExpression */:
	                result = reduceNodes(node.elements, cbNodes, result);
	                break;
	            default:
	                break;
	        }
	        return result;
	    }
	    ts.reduceEachChild = reduceEachChild;
	    function mergeLexicalEnvironment(statements, declarations) {
	        if (!ts.some(declarations)) {
	            return statements;
	        }
	        return ts.isNodeArray(statements)
	            ? ts.setTextRange(ts.createNodeArray(ts.concatenate(statements, declarations)), statements)
	            : ts.addRange(statements, declarations);
	    }
	    ts.mergeLexicalEnvironment = mergeLexicalEnvironment;
	    /**
	     * Lifts a NodeArray containing only Statement nodes to a block.
	     *
	     * @param nodes The NodeArray.
	     */
	    function liftToBlock(nodes) {
	        Debug.assert(ts.every(nodes, ts.isStatement), "Cannot lift nodes to a Block.");
	        return ts.singleOrUndefined(nodes) || ts.createBlock(nodes);
	    }
	    ts.liftToBlock = liftToBlock;
	    /**
	     * Aggregates the TransformFlags for a Node and its subtree.
	     */
	    function aggregateTransformFlags(node) {
	        aggregateTransformFlagsForNode(node);
	        return node;
	    }
	    ts.aggregateTransformFlags = aggregateTransformFlags;
	    /**
	     * Aggregates the TransformFlags for a Node and its subtree. The flags for the subtree are
	     * computed first, then the transform flags for the current node are computed from the subtree
	     * flags and the state of the current node. Finally, the transform flags of the node are
	     * returned, excluding any flags that should not be included in its parent node's subtree
	     * flags.
	     */
	    function aggregateTransformFlagsForNode(node) {
	        if (node === undefined) {
	            return 0 /* None */;
	        }
	        if (node.transformFlags & 536870912 /* HasComputedFlags */) {
	            return node.transformFlags & ~ts.getTransformFlagsSubtreeExclusions(node.kind);
	        }
	        var subtreeFlags = aggregateTransformFlagsForSubtree(node);
	        return ts.computeTransformFlagsForNode(node, subtreeFlags);
	    }
	    function aggregateTransformFlagsForNodeArray(nodes) {
	        if (nodes === undefined) {
	            return 0 /* None */;
	        }
	        var subtreeFlags = 0 /* None */;
	        var nodeArrayFlags = 0 /* None */;
	        for (var _i = 0, nodes_3 = nodes; _i < nodes_3.length; _i++) {
	            var node = nodes_3[_i];
	            subtreeFlags |= aggregateTransformFlagsForNode(node);
	            nodeArrayFlags |= node.transformFlags & ~536870912 /* HasComputedFlags */;
	        }
	        nodes.transformFlags = nodeArrayFlags | 536870912 /* HasComputedFlags */;
	        return subtreeFlags;
	    }
	    /**
	     * Aggregates the transform flags for the subtree of a node.
	     */
	    function aggregateTransformFlagsForSubtree(node) {
	        // We do not transform ambient declarations or types, so there is no need to
	        // recursively aggregate transform flags.
	        if (ts.hasModifier(node, 2 /* Ambient */) || (ts.isTypeNode(node) && node.kind !== 205 /* ExpressionWithTypeArguments */)) {
	            return 0 /* None */;
	        }
	        // Aggregate the transform flags of each child.
	        return reduceEachChild(node, 0 /* None */, aggregateTransformFlagsForChildNode, aggregateTransformFlagsForChildNodes);
	    }
	    /**
	     * Aggregates the TransformFlags of a child node with the TransformFlags of its
	     * siblings.
	     */
	    function aggregateTransformFlagsForChildNode(transformFlags, node) {
	        return transformFlags | aggregateTransformFlagsForNode(node);
	    }
	    function aggregateTransformFlagsForChildNodes(transformFlags, nodes) {
	        return transformFlags | aggregateTransformFlagsForNodeArray(nodes);
	    }
	    var Debug;
	    (function (Debug) {
	        var isDebugInfoEnabled = false;
	        Debug.failBadSyntaxKind = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, message) { return Debug.fail((message || "Unexpected node.") + "\r\nNode " + ts.formatSyntaxKind(node.kind) + " was unexpected.", Debug.failBadSyntaxKind); }
	            : ts.noop;
	        Debug.assertEachNode = Debug.shouldAssert(1 /* Normal */)
	            ? function (nodes, test, message) { return Debug.assert(test === undefined || ts.every(nodes, test), message || "Unexpected node.", function () { return "Node array did not pass test '" + Debug.getFunctionName(test) + "'."; }, Debug.assertEachNode); }
	            : ts.noop;
	        Debug.assertNode = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, test, message) { return Debug.assert(test === undefined || test(node), message || "Unexpected node.", function () { return "Node " + ts.formatSyntaxKind(node.kind) + " did not pass test '" + Debug.getFunctionName(test) + "'."; }, Debug.assertNode); }
	            : ts.noop;
	        Debug.assertOptionalNode = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, test, message) { return Debug.assert(test === undefined || node === undefined || test(node), message || "Unexpected node.", function () { return "Node " + ts.formatSyntaxKind(node.kind) + " did not pass test '" + Debug.getFunctionName(test) + "'."; }, Debug.assertOptionalNode); }
	            : ts.noop;
	        Debug.assertOptionalToken = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, kind, message) { return Debug.assert(kind === undefined || node === undefined || node.kind === kind, message || "Unexpected node.", function () { return "Node " + ts.formatSyntaxKind(node.kind) + " was not a '" + ts.formatSyntaxKind(kind) + "' token."; }, Debug.assertOptionalToken); }
	            : ts.noop;
	        Debug.assertMissingNode = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, message) { return Debug.assert(node === undefined, message || "Unexpected node.", function () { return "Node " + ts.formatSyntaxKind(node.kind) + " was unexpected'."; }, Debug.assertMissingNode); }
	            : ts.noop;
	        /**
	         * Injects debug information into frequently used types.
	         */
	        function enableDebugInfo() {
	            if (isDebugInfoEnabled)
	                return;
	            // Add additional properties in debug mode to assist with debugging.
	            Object.defineProperties(ts.objectAllocator.getSymbolConstructor().prototype, {
	                __debugFlags: { get: function () { return ts.formatSymbolFlags(this.flags); } }
	            });
	            Object.defineProperties(ts.objectAllocator.getTypeConstructor().prototype, {
	                __debugFlags: { get: function () { return ts.formatTypeFlags(this.flags); } },
	                __debugObjectFlags: { get: function () { return this.flags & 65536 /* Object */ ? ts.formatObjectFlags(this.objectFlags) : ""; } },
	                __debugTypeToString: { value: function () { return this.checker.typeToString(this); } },
	            });
	            var nodeConstructors = [
	                ts.objectAllocator.getNodeConstructor(),
	                ts.objectAllocator.getIdentifierConstructor(),
	                ts.objectAllocator.getTokenConstructor(),
	                ts.objectAllocator.getSourceFileConstructor()
	            ];
	            for (var _i = 0, nodeConstructors_1 = nodeConstructors; _i < nodeConstructors_1.length; _i++) {
	                var ctor = nodeConstructors_1[_i];
	                if (!ctor.prototype.hasOwnProperty("__debugKind")) {
	                    Object.defineProperties(ctor.prototype, {
	                        __debugKind: { get: function () { return ts.formatSyntaxKind(this.kind); } },
	                        __debugModifierFlags: { get: function () { return ts.formatModifierFlags(ts.getModifierFlagsNoCache(this)); } },
	                        __debugTransformFlags: { get: function () { return ts.formatTransformFlags(this.transformFlags); } },
	                        __debugEmitFlags: { get: function () { return ts.formatEmitFlags(ts.getEmitFlags(this)); } },
	                        __debugGetText: {
	                            value: function (includeTrivia) {
	                                if (ts.nodeIsSynthesized(this))
	                                    return "";
	                                var parseNode = ts.getParseTreeNode(this);
	                                var sourceFile = parseNode && ts.getSourceFileOfNode(parseNode);
	                                return sourceFile ? ts.getSourceTextOfNodeFromSourceFile(sourceFile, parseNode, includeTrivia) : "";
	                            }
	                        }
	                    });
	                }
	            }
	            isDebugInfoEnabled = true;
	        }
	        Debug.enableDebugInfo = enableDebugInfo;
	    })(Debug = ts.Debug || (ts.Debug = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function getOriginalNodeId(node) {
	        node = ts.getOriginalNode(node);
	        return node ? ts.getNodeId(node) : 0;
	    }
	    ts.getOriginalNodeId = getOriginalNodeId;
	    function getNamedImportCount(node) {
	        if (!(node.importClause && node.importClause.namedBindings))
	            return 0;
	        var names = node.importClause.namedBindings;
	        if (!names)
	            return 0;
	        if (!ts.isNamedImports(names))
	            return 0;
	        return names.elements.length;
	    }
	    function containsDefaultReference(node) {
	        if (!node)
	            return false;
	        if (!ts.isNamedImports(node))
	            return false;
	        return ts.some(node.elements, isNamedDefaultReference);
	    }
	    function isNamedDefaultReference(e) {
	        return e.propertyName && e.propertyName.escapedText === "default" /* Default */;
	    }
	    function getImportNeedsImportStarHelper(node) {
	        return !!ts.getNamespaceDeclarationNode(node) || (getNamedImportCount(node) > 1 && containsDefaultReference(node.importClause.namedBindings));
	    }
	    ts.getImportNeedsImportStarHelper = getImportNeedsImportStarHelper;
	    function getImportNeedsImportDefaultHelper(node) {
	        return ts.isDefaultImport(node) || (getNamedImportCount(node) === 1 && containsDefaultReference(node.importClause.namedBindings));
	    }
	    ts.getImportNeedsImportDefaultHelper = getImportNeedsImportDefaultHelper;
	    function collectExternalModuleInfo(sourceFile, resolver, compilerOptions) {
	        var externalImports = [];
	        var exportSpecifiers = ts.createMultiMap();
	        var exportedBindings = [];
	        var uniqueExports = ts.createMap();
	        var exportedNames;
	        var hasExportDefault = false;
	        var exportEquals = undefined;
	        var hasExportStarsToExportValues = false;
	        var hasImportStarOrImportDefault = false;
	        for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	            var node = _a[_i];
	            switch (node.kind) {
	                case 242 /* ImportDeclaration */:
	                    // import "mod"
	                    // import x from "mod"
	                    // import * as x from "mod"
	                    // import { x, y } from "mod"
	                    externalImports.push(node);
	                    hasImportStarOrImportDefault = getImportNeedsImportStarHelper(node) || getImportNeedsImportDefaultHelper(node);
	                    break;
	                case 241 /* ImportEqualsDeclaration */:
	                    if (node.moduleReference.kind === 252 /* ExternalModuleReference */) {
	                        // import x = require("mod")
	                        externalImports.push(node);
	                    }
	                    break;
	                case 248 /* ExportDeclaration */:
	                    if (node.moduleSpecifier) {
	                        if (!node.exportClause) {
	                            // export * from "mod"
	                            externalImports.push(node);
	                            hasExportStarsToExportValues = true;
	                        }
	                        else {
	                            // export { x, y } from "mod"
	                            externalImports.push(node);
	                        }
	                    }
	                    else {
	                        // export { x, y }
	                        for (var _b = 0, _c = node.exportClause.elements; _b < _c.length; _b++) {
	                            var specifier = _c[_b];
	                            if (!uniqueExports.get(ts.idText(specifier.name))) {
	                                var name = specifier.propertyName || specifier.name;
	                                exportSpecifiers.add(ts.idText(name), specifier);
	                                var decl = resolver.getReferencedImportDeclaration(name)
	                                    || resolver.getReferencedValueDeclaration(name);
	                                if (decl) {
	                                    multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(decl), specifier.name);
	                                }
	                                uniqueExports.set(ts.idText(specifier.name), true);
	                                exportedNames = ts.append(exportedNames, specifier.name);
	                            }
	                        }
	                    }
	                    break;
	                case 247 /* ExportAssignment */:
	                    if (node.isExportEquals && !exportEquals) {
	                        // export = x
	                        exportEquals = node;
	                    }
	                    break;
	                case 212 /* VariableStatement */:
	                    if (ts.hasModifier(node, 1 /* Export */)) {
	                        for (var _d = 0, _e = node.declarationList.declarations; _d < _e.length; _d++) {
	                            var decl = _e[_d];
	                            exportedNames = collectExportedVariableInfo(decl, uniqueExports, exportedNames);
	                        }
	                    }
	                    break;
	                case 232 /* FunctionDeclaration */:
	                    if (ts.hasModifier(node, 1 /* Export */)) {
	                        if (ts.hasModifier(node, 512 /* Default */)) {
	                            // export default function() { }
	                            if (!hasExportDefault) {
	                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), ts.getDeclarationName(node));
	                                hasExportDefault = true;
	                            }
	                        }
	                        else {
	                            // export function x() { }
	                            var name = node.name;
	                            if (!uniqueExports.get(ts.idText(name))) {
	                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
	                                uniqueExports.set(ts.idText(name), true);
	                                exportedNames = ts.append(exportedNames, name);
	                            }
	                        }
	                    }
	                    break;
	                case 233 /* ClassDeclaration */:
	                    if (ts.hasModifier(node, 1 /* Export */)) {
	                        if (ts.hasModifier(node, 512 /* Default */)) {
	                            // export default class { }
	                            if (!hasExportDefault) {
	                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), ts.getDeclarationName(node));
	                                hasExportDefault = true;
	                            }
	                        }
	                        else {
	                            // export class x { }
	                            var name = node.name;
	                            if (name && !uniqueExports.get(ts.idText(name))) {
	                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
	                                uniqueExports.set(ts.idText(name), true);
	                                exportedNames = ts.append(exportedNames, name);
	                            }
	                        }
	                    }
	                    break;
	            }
	        }
	        var externalHelpersModuleName = ts.getOrCreateExternalHelpersModuleNameIfNeeded(sourceFile, compilerOptions, hasExportStarsToExportValues, hasImportStarOrImportDefault);
	        var externalHelpersImportDeclaration = externalHelpersModuleName && ts.createImportDeclaration(
	        /*decorators*/ undefined, 
	        /*modifiers*/ undefined, ts.createImportClause(/*name*/ undefined, ts.createNamespaceImport(externalHelpersModuleName)), ts.createLiteral(ts.externalHelpersModuleNameText));
	        if (externalHelpersImportDeclaration) {
	            ts.addEmitFlags(externalHelpersImportDeclaration, 67108864 /* NeverApplyImportHelper */);
	            externalImports.unshift(externalHelpersImportDeclaration);
	        }
	        return { externalImports: externalImports, exportSpecifiers: exportSpecifiers, exportEquals: exportEquals, hasExportStarsToExportValues: hasExportStarsToExportValues, exportedBindings: exportedBindings, exportedNames: exportedNames, externalHelpersImportDeclaration: externalHelpersImportDeclaration };
	    }
	    ts.collectExternalModuleInfo = collectExternalModuleInfo;
	    function collectExportedVariableInfo(decl, uniqueExports, exportedNames) {
	        if (ts.isBindingPattern(decl.name)) {
	            for (var _i = 0, _a = decl.name.elements; _i < _a.length; _i++) {
	                var element = _a[_i];
	                if (!ts.isOmittedExpression(element)) {
	                    exportedNames = collectExportedVariableInfo(element, uniqueExports, exportedNames);
	                }
	            }
	        }
	        else if (!ts.isGeneratedIdentifier(decl.name)) {
	            var text = ts.idText(decl.name);
	            if (!uniqueExports.get(text)) {
	                uniqueExports.set(text, true);
	                exportedNames = ts.append(exportedNames, decl.name);
	            }
	        }
	        return exportedNames;
	    }
	    /** Use a sparse array as a multi-map. */
	    function multiMapSparseArrayAdd(map, key, value) {
	        var values = map[key];
	        if (values) {
	            values.push(value);
	        }
	        else {
	            map[key] = values = [value];
	        }
	        return values;
	    }
	    /**
	     * Used in the module transformer to check if an expression is reasonably without sideeffect,
	     *  and thus better to copy into multiple places rather than to cache in a temporary variable
	     *  - this is mostly subjective beyond the requirement that the expression not be sideeffecting
	     */
	    function isSimpleCopiableExpression(expression) {
	        return ts.isStringLiteralLike(expression) ||
	            expression.kind === 8 /* NumericLiteral */ ||
	            ts.isKeyword(expression.kind) ||
	            ts.isIdentifier(expression);
	    }
	    ts.isSimpleCopiableExpression = isSimpleCopiableExpression;
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    var FlattenLevel;
	    (function (FlattenLevel) {
	        FlattenLevel[FlattenLevel["All"] = 0] = "All";
	        FlattenLevel[FlattenLevel["ObjectRest"] = 1] = "ObjectRest";
	    })(FlattenLevel = ts.FlattenLevel || (ts.FlattenLevel = {}));
	    /**
	     * Flattens a DestructuringAssignment or a VariableDeclaration to an expression.
	     *
	     * @param node The node to flatten.
	     * @param visitor An optional visitor used to visit initializers.
	     * @param context The transformation context.
	     * @param level Indicates the extent to which flattening should occur.
	     * @param needsValue An optional value indicating whether the value from the right-hand-side of
	     * the destructuring assignment is needed as part of a larger expression.
	     * @param createAssignmentCallback An optional callback used to create the assignment expression.
	     */
	    function flattenDestructuringAssignment(node, visitor, context, level, needsValue, createAssignmentCallback) {
	        var location = node;
	        var value;
	        if (ts.isDestructuringAssignment(node)) {
	            value = node.right;
	            while (ts.isEmptyArrayLiteral(node.left) || ts.isEmptyObjectLiteral(node.left)) {
	                if (ts.isDestructuringAssignment(value)) {
	                    location = node = value;
	                    value = node.right;
	                }
	                else {
	                    return value;
	                }
	            }
	        }
	        var expressions;
	        var flattenContext = {
	            context: context,
	            level: level,
	            downlevelIteration: context.getCompilerOptions().downlevelIteration,
	            hoistTempVariables: true,
	            emitExpression: emitExpression,
	            emitBindingOrAssignment: emitBindingOrAssignment,
	            createArrayBindingOrAssignmentPattern: makeArrayAssignmentPattern,
	            createObjectBindingOrAssignmentPattern: makeObjectAssignmentPattern,
	            createArrayBindingOrAssignmentElement: makeAssignmentElement,
	            visitor: visitor
	        };
	        if (value) {
	            value = ts.visitNode(value, visitor, ts.isExpression);
	            if (ts.isIdentifier(value) && bindingOrAssignmentElementAssignsToName(node, value.escapedText)) {
	                // If the right-hand value of the assignment is also an assignment target then
	                // we need to cache the right-hand value.
	                value = ensureIdentifier(flattenContext, value, /*reuseIdentifierExpressions*/ false, location);
	            }
	            else if (needsValue) {
	                // If the right-hand value of the destructuring assignment needs to be preserved (as
	                // is the case when the destructuring assignment is part of a larger expression),
	                // then we need to cache the right-hand value.
	                //
	                // The source map location for the assignment should point to the entire binary
	                // expression.
	                value = ensureIdentifier(flattenContext, value, /*reuseIdentifierExpressions*/ true, location);
	            }
	            else if (ts.nodeIsSynthesized(node)) {
	                // Generally, the source map location for a destructuring assignment is the root
	                // expression.
	                //
	                // However, if the root expression is synthesized (as in the case
	                // of the initializer when transforming a ForOfStatement), then the source map
	                // location should point to the right-hand value of the expression.
	                location = value;
	            }
	        }
	        flattenBindingOrAssignmentElement(flattenContext, node, value, location, /*skipInitializer*/ ts.isDestructuringAssignment(node));
	        if (value && needsValue) {
	            if (!ts.some(expressions)) {
	                return value;
	            }
	            expressions.push(value);
	        }
	        return ts.aggregateTransformFlags(ts.inlineExpressions(expressions)) || ts.createOmittedExpression();
	        function emitExpression(expression) {
	            // NOTE: this completely disables source maps, but aligns with the behavior of
	            //       `emitAssignment` in the old emitter.
	            ts.setEmitFlags(expression, 64 /* NoNestedSourceMaps */);
	            ts.aggregateTransformFlags(expression);
	            expressions = ts.append(expressions, expression);
	        }
	        function emitBindingOrAssignment(target, value, location, original) {
	            ts.Debug.assertNode(target, createAssignmentCallback ? ts.isIdentifier : ts.isExpression);
	            var expression = createAssignmentCallback
	                ? createAssignmentCallback(target, value, location)
	                : ts.setTextRange(ts.createAssignment(ts.visitNode(target, visitor, ts.isExpression), value), location);
	            expression.original = original;
	            emitExpression(expression);
	        }
	    }
	    ts.flattenDestructuringAssignment = flattenDestructuringAssignment;
	    function bindingOrAssignmentElementAssignsToName(element, escapedName) {
	        var target = ts.getTargetOfBindingOrAssignmentElement(element);
	        if (ts.isBindingOrAssignmentPattern(target)) {
	            return bindingOrAssignmentPatternAssignsToName(target, escapedName);
	        }
	        else if (ts.isIdentifier(target)) {
	            return target.escapedText === escapedName;
	        }
	        return false;
	    }
	    function bindingOrAssignmentPatternAssignsToName(pattern, escapedName) {
	        var elements = ts.getElementsOfBindingOrAssignmentPattern(pattern);
	        for (var _i = 0, elements_3 = elements; _i < elements_3.length; _i++) {
	            var element = elements_3[_i];
	            if (bindingOrAssignmentElementAssignsToName(element, escapedName)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    /**
	     * Flattens a VariableDeclaration or ParameterDeclaration to one or more variable declarations.
	     *
	     * @param node The node to flatten.
	     * @param visitor An optional visitor used to visit initializers.
	     * @param context The transformation context.
	     * @param boundValue The value bound to the declaration.
	     * @param skipInitializer A value indicating whether to ignore the initializer of `node`.
	     * @param hoistTempVariables Indicates whether temporary variables should not be recorded in-line.
	     * @param level Indicates the extent to which flattening should occur.
	     */
	    function flattenDestructuringBinding(node, visitor, context, level, rval, hoistTempVariables, skipInitializer) {
	        var pendingExpressions;
	        var pendingDeclarations = [];
	        var declarations = [];
	        var flattenContext = {
	            context: context,
	            level: level,
	            downlevelIteration: context.getCompilerOptions().downlevelIteration,
	            hoistTempVariables: hoistTempVariables,
	            emitExpression: emitExpression,
	            emitBindingOrAssignment: emitBindingOrAssignment,
	            createArrayBindingOrAssignmentPattern: makeArrayBindingPattern,
	            createObjectBindingOrAssignmentPattern: makeObjectBindingPattern,
	            createArrayBindingOrAssignmentElement: makeBindingElement,
	            visitor: visitor
	        };
	        if (ts.isVariableDeclaration(node)) {
	            var initializer = ts.getInitializerOfBindingOrAssignmentElement(node);
	            if (initializer && ts.isIdentifier(initializer) && bindingOrAssignmentElementAssignsToName(node, initializer.escapedText)) {
	                // If the right-hand value of the assignment is also an assignment target then
	                // we need to cache the right-hand value.
	                initializer = ensureIdentifier(flattenContext, initializer, /*reuseIdentifierExpressions*/ false, initializer);
	                node = ts.updateVariableDeclaration(node, node.name, node.type, initializer);
	            }
	        }
	        flattenBindingOrAssignmentElement(flattenContext, node, rval, node, skipInitializer);
	        if (pendingExpressions) {
	            var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            if (hoistTempVariables) {
	                var value = ts.inlineExpressions(pendingExpressions);
	                pendingExpressions = undefined;
	                emitBindingOrAssignment(temp, value, /*location*/ undefined, /*original*/ undefined);
	            }
	            else {
	                context.hoistVariableDeclaration(temp);
	                var pendingDeclaration = ts.lastOrUndefined(pendingDeclarations);
	                pendingDeclaration.pendingExpressions = ts.append(pendingDeclaration.pendingExpressions, ts.createAssignment(temp, pendingDeclaration.value));
	                ts.addRange(pendingDeclaration.pendingExpressions, pendingExpressions);
	                pendingDeclaration.value = temp;
	            }
	        }
	        for (var _i = 0, pendingDeclarations_1 = pendingDeclarations; _i < pendingDeclarations_1.length; _i++) {
	            var _a = pendingDeclarations_1[_i], pendingExpressions_1 = _a.pendingExpressions, name = _a.name, value = _a.value, location = _a.location, original = _a.original;
	            var variable = ts.createVariableDeclaration(name, 
	            /*type*/ undefined, pendingExpressions_1 ? ts.inlineExpressions(ts.append(pendingExpressions_1, value)) : value);
	            variable.original = original;
	            ts.setTextRange(variable, location);
	            if (ts.isIdentifier(name)) {
	                ts.setEmitFlags(variable, 64 /* NoNestedSourceMaps */);
	            }
	            ts.aggregateTransformFlags(variable);
	            declarations.push(variable);
	        }
	        return declarations;
	        function emitExpression(value) {
	            pendingExpressions = ts.append(pendingExpressions, value);
	        }
	        function emitBindingOrAssignment(target, value, location, original) {
	            ts.Debug.assertNode(target, ts.isBindingName);
	            if (pendingExpressions) {
	                value = ts.inlineExpressions(ts.append(pendingExpressions, value));
	                pendingExpressions = undefined;
	            }
	            pendingDeclarations.push({ pendingExpressions: pendingExpressions, name: target, value: value, location: location, original: original });
	        }
	    }
	    ts.flattenDestructuringBinding = flattenDestructuringBinding;
	    /**
	     * Flattens a BindingOrAssignmentElement into zero or more bindings or assignments.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param element The element to flatten.
	     * @param value The current RHS value to assign to the element.
	     * @param location The location to use for source maps and comments.
	     * @param skipInitializer An optional value indicating whether to include the initializer
	     * for the element.
	     */
	    function flattenBindingOrAssignmentElement(flattenContext, element, value, location, skipInitializer) {
	        if (!skipInitializer) {
	            var initializer = ts.visitNode(ts.getInitializerOfBindingOrAssignmentElement(element), flattenContext.visitor, ts.isExpression);
	            if (initializer) {
	                // Combine value and initializer
	                value = value ? createDefaultValueCheck(flattenContext, value, initializer, location) : initializer;
	            }
	            else if (!value) {
	                // Use 'void 0' in absence of value and initializer
	                value = ts.createVoidZero();
	            }
	        }
	        var bindingTarget = ts.getTargetOfBindingOrAssignmentElement(element);
	        if (ts.isObjectBindingOrAssignmentPattern(bindingTarget)) {
	            flattenObjectBindingOrAssignmentPattern(flattenContext, element, bindingTarget, value, location);
	        }
	        else if (ts.isArrayBindingOrAssignmentPattern(bindingTarget)) {
	            flattenArrayBindingOrAssignmentPattern(flattenContext, element, bindingTarget, value, location);
	        }
	        else {
	            flattenContext.emitBindingOrAssignment(bindingTarget, value, location, /*original*/ element);
	        }
	    }
	    /**
	     * Flattens an ObjectBindingOrAssignmentPattern into zero or more bindings or assignments.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param parent The parent element of the pattern.
	     * @param pattern The ObjectBindingOrAssignmentPattern to flatten.
	     * @param value The current RHS value to assign to the element.
	     * @param location The location to use for source maps and comments.
	     */
	    function flattenObjectBindingOrAssignmentPattern(flattenContext, parent, pattern, value, location) {
	        var elements = ts.getElementsOfBindingOrAssignmentPattern(pattern);
	        var numElements = elements.length;
	        if (numElements !== 1) {
	            // For anything other than a single-element destructuring we need to generate a temporary
	            // to ensure value is evaluated exactly once. Additionally, if we have zero elements
	            // we need to emit *something* to ensure that in case a 'var' keyword was already emitted,
	            // so in that case, we'll intentionally create that temporary.
	            var reuseIdentifierExpressions = !ts.isDeclarationBindingElement(parent) || numElements !== 0;
	            value = ensureIdentifier(flattenContext, value, reuseIdentifierExpressions, location);
	        }
	        var bindingElements;
	        var computedTempVariables;
	        for (var i = 0; i < numElements; i++) {
	            var element = elements[i];
	            if (!ts.getRestIndicatorOfBindingOrAssignmentElement(element)) {
	                var propertyName = ts.getPropertyNameOfBindingOrAssignmentElement(element);
	                if (flattenContext.level >= 1 /* ObjectRest */
	                    && !(element.transformFlags & (524288 /* ContainsRest */ | 1048576 /* ContainsObjectRest */))
	                    && !(ts.getTargetOfBindingOrAssignmentElement(element).transformFlags & (524288 /* ContainsRest */ | 1048576 /* ContainsObjectRest */))
	                    && !ts.isComputedPropertyName(propertyName)) {
	                    bindingElements = ts.append(bindingElements, element);
	                }
	                else {
	                    if (bindingElements) {
	                        flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value, location, pattern);
	                        bindingElements = undefined;
	                    }
	                    var rhsValue = createDestructuringPropertyAccess(flattenContext, value, propertyName);
	                    if (ts.isComputedPropertyName(propertyName)) {
	                        computedTempVariables = ts.append(computedTempVariables, rhsValue.argumentExpression);
	                    }
	                    flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
	                }
	            }
	            else if (i === numElements - 1) {
	                if (bindingElements) {
	                    flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value, location, pattern);
	                    bindingElements = undefined;
	                }
	                var rhsValue = createRestCall(flattenContext.context, value, elements, computedTempVariables, pattern);
	                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, element);
	            }
	        }
	        if (bindingElements) {
	            flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value, location, pattern);
	        }
	    }
	    /**
	     * Flattens an ArrayBindingOrAssignmentPattern into zero or more bindings or assignments.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param parent The parent element of the pattern.
	     * @param pattern The ArrayBindingOrAssignmentPattern to flatten.
	     * @param value The current RHS value to assign to the element.
	     * @param location The location to use for source maps and comments.
	     */
	    function flattenArrayBindingOrAssignmentPattern(flattenContext, parent, pattern, value, location) {
	        var elements = ts.getElementsOfBindingOrAssignmentPattern(pattern);
	        var numElements = elements.length;
	        if (flattenContext.level < 1 /* ObjectRest */ && flattenContext.downlevelIteration) {
	            // Read the elements of the iterable into an array
	            value = ensureIdentifier(flattenContext, ts.createReadHelper(flattenContext.context, value, numElements > 0 && ts.getRestIndicatorOfBindingOrAssignmentElement(elements[numElements - 1])
	                ? undefined
	                : numElements, location), 
	            /*reuseIdentifierExpressions*/ false, location);
	        }
	        else if (numElements !== 1 && (flattenContext.level < 1 /* ObjectRest */ || numElements === 0)
	            || ts.every(elements, ts.isOmittedExpression)) {
	            // For anything other than a single-element destructuring we need to generate a temporary
	            // to ensure value is evaluated exactly once. Additionally, if we have zero elements
	            // we need to emit *something* to ensure that in case a 'var' keyword was already emitted,
	            // so in that case, we'll intentionally create that temporary.
	            // Or all the elements of the binding pattern are omitted expression such as "var [,] = [1,2]",
	            // then we will create temporary variable.
	            var reuseIdentifierExpressions = !ts.isDeclarationBindingElement(parent) || numElements !== 0;
	            value = ensureIdentifier(flattenContext, value, reuseIdentifierExpressions, location);
	        }
	        var bindingElements;
	        var restContainingElements;
	        for (var i = 0; i < numElements; i++) {
	            var element = elements[i];
	            if (flattenContext.level >= 1 /* ObjectRest */) {
	                // If an array pattern contains an ObjectRest, we must cache the result so that we
	                // can perform the ObjectRest destructuring in a different declaration
	                if (element.transformFlags & 1048576 /* ContainsObjectRest */) {
	                    var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	                    if (flattenContext.hoistTempVariables) {
	                        flattenContext.context.hoistVariableDeclaration(temp);
	                    }
	                    restContainingElements = ts.append(restContainingElements, [temp, element]);
	                    bindingElements = ts.append(bindingElements, flattenContext.createArrayBindingOrAssignmentElement(temp));
	                }
	                else {
	                    bindingElements = ts.append(bindingElements, element);
	                }
	            }
	            else if (ts.isOmittedExpression(element)) {
	                continue;
	            }
	            else if (!ts.getRestIndicatorOfBindingOrAssignmentElement(element)) {
	                var rhsValue = ts.createElementAccess(value, i);
	                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
	            }
	            else if (i === numElements - 1) {
	                var rhsValue = ts.createArraySlice(value, i);
	                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
	            }
	        }
	        if (bindingElements) {
	            flattenContext.emitBindingOrAssignment(flattenContext.createArrayBindingOrAssignmentPattern(bindingElements), value, location, pattern);
	        }
	        if (restContainingElements) {
	            for (var _i = 0, restContainingElements_1 = restContainingElements; _i < restContainingElements_1.length; _i++) {
	                var _a = restContainingElements_1[_i], id = _a[0], element = _a[1];
	                flattenBindingOrAssignmentElement(flattenContext, element, id, element);
	            }
	        }
	    }
	    /**
	     * Creates an expression used to provide a default value if a value is `undefined` at runtime.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param value The RHS value to test.
	     * @param defaultValue The default value to use if `value` is `undefined` at runtime.
	     * @param location The location to use for source maps and comments.
	     */
	    function createDefaultValueCheck(flattenContext, value, defaultValue, location) {
	        value = ensureIdentifier(flattenContext, value, /*reuseIdentifierExpressions*/ true, location);
	        return ts.createConditional(ts.createTypeCheck(value, "undefined"), defaultValue, value);
	    }
	    /**
	     * Creates either a PropertyAccessExpression or an ElementAccessExpression for the
	     * right-hand side of a transformed destructuring assignment.
	     *
	     * @link https://tc39.github.io/ecma262/#sec-runtime-semantics-keyeddestructuringassignmentevaluation
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param value The RHS value that is the source of the property.
	     * @param propertyName The destructuring property name.
	     */
	    function createDestructuringPropertyAccess(flattenContext, value, propertyName) {
	        if (ts.isComputedPropertyName(propertyName)) {
	            var argumentExpression = ensureIdentifier(flattenContext, ts.visitNode(propertyName.expression, flattenContext.visitor), /*reuseIdentifierExpressions*/ false, /*location*/ propertyName);
	            return ts.createElementAccess(value, argumentExpression);
	        }
	        else if (ts.isStringOrNumericLiteral(propertyName)) {
	            var argumentExpression = ts.getSynthesizedClone(propertyName);
	            argumentExpression.text = argumentExpression.text;
	            return ts.createElementAccess(value, argumentExpression);
	        }
	        else {
	            var name = ts.createIdentifier(ts.idText(propertyName));
	            return ts.createPropertyAccess(value, name);
	        }
	    }
	    /**
	     * Ensures that there exists a declared identifier whose value holds the given expression.
	     * This function is useful to ensure that the expression's value can be read from in subsequent expressions.
	     * Unless 'reuseIdentifierExpressions' is false, 'value' will be returned if it is just an identifier.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param value the expression whose value needs to be bound.
	     * @param reuseIdentifierExpressions true if identifier expressions can simply be returned;
	     * false if it is necessary to always emit an identifier.
	     * @param location The location to use for source maps and comments.
	     */
	    function ensureIdentifier(flattenContext, value, reuseIdentifierExpressions, location) {
	        if (ts.isIdentifier(value) && reuseIdentifierExpressions) {
	            return value;
	        }
	        else {
	            var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            if (flattenContext.hoistTempVariables) {
	                flattenContext.context.hoistVariableDeclaration(temp);
	                flattenContext.emitExpression(ts.setTextRange(ts.createAssignment(temp, value), location));
	            }
	            else {
	                flattenContext.emitBindingOrAssignment(temp, value, location, /*original*/ undefined);
	            }
	            return temp;
	        }
	    }
	    function makeArrayBindingPattern(elements) {
	        ts.Debug.assertEachNode(elements, ts.isArrayBindingElement);
	        return ts.createArrayBindingPattern(elements);
	    }
	    function makeArrayAssignmentPattern(elements) {
	        return ts.createArrayLiteral(ts.map(elements, ts.convertToArrayAssignmentElement));
	    }
	    function makeObjectBindingPattern(elements) {
	        ts.Debug.assertEachNode(elements, ts.isBindingElement);
	        return ts.createObjectBindingPattern(elements);
	    }
	    function makeObjectAssignmentPattern(elements) {
	        return ts.createObjectLiteral(ts.map(elements, ts.convertToObjectAssignmentElement));
	    }
	    function makeBindingElement(name) {
	        return ts.createBindingElement(/*dotDotDotToken*/ undefined, /*propertyName*/ undefined, name);
	    }
	    function makeAssignmentElement(name) {
	        return name;
	    }
	    var restHelper = {
	        name: "typescript:rest",
	        scoped: false,
	        text: "\n            var __rest = (this && this.__rest) || function (s, e) {\n                var t = {};\n                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)\n                    t[p] = s[p];\n                if (s != null && typeof Object.getOwnPropertySymbols === \"function\")\n                    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)\n                        t[p[i]] = s[p[i]];\n                return t;\n            };"
	    };
	    /** Given value: o, propName: p, pattern: { a, b, ...p } from the original statement
	     * `{ a, b, ...p } = o`, create `p = __rest(o, ["a", "b"]);`
	     */
	    function createRestCall(context, value, elements, computedTempVariables, location) {
	        context.requestEmitHelper(restHelper);
	        var propertyNames = [];
	        var computedTempVariableOffset = 0;
	        for (var i = 0; i < elements.length - 1; i++) {
	            var propertyName = ts.getPropertyNameOfBindingOrAssignmentElement(elements[i]);
	            if (propertyName) {
	                if (ts.isComputedPropertyName(propertyName)) {
	                    var temp = computedTempVariables[computedTempVariableOffset];
	                    computedTempVariableOffset++;
	                    // typeof _tmp === "symbol" ? _tmp : _tmp + ""
	                    propertyNames.push(ts.createConditional(ts.createTypeCheck(temp, "symbol"), temp, ts.createAdd(temp, ts.createLiteral(""))));
	                }
	                else {
	                    propertyNames.push(ts.createLiteral(propertyName));
	                }
	            }
	        }
	        return ts.createCall(ts.getHelperName("__rest"), 
	        /*typeArguments*/ undefined, [
	            value,
	            ts.setTextRange(ts.createArrayLiteral(propertyNames), location)
	        ]);
	    }
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	/// <reference path="./destructuring.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    /**
	     * Indicates whether to emit type metadata in the new format.
	     */
	    var USE_NEW_TYPE_METADATA_FORMAT = false;
	    var TypeScriptSubstitutionFlags;
	    (function (TypeScriptSubstitutionFlags) {
	        /** Enables substitutions for decorated classes. */
	        TypeScriptSubstitutionFlags[TypeScriptSubstitutionFlags["ClassAliases"] = 1] = "ClassAliases";
	        /** Enables substitutions for namespace exports. */
	        TypeScriptSubstitutionFlags[TypeScriptSubstitutionFlags["NamespaceExports"] = 2] = "NamespaceExports";
	        /* Enables substitutions for unqualified enum members */
	        TypeScriptSubstitutionFlags[TypeScriptSubstitutionFlags["NonQualifiedEnumMembers"] = 8] = "NonQualifiedEnumMembers";
	    })(TypeScriptSubstitutionFlags || (TypeScriptSubstitutionFlags = {}));
	    var ClassFacts;
	    (function (ClassFacts) {
	        ClassFacts[ClassFacts["None"] = 0] = "None";
	        ClassFacts[ClassFacts["HasStaticInitializedProperties"] = 1] = "HasStaticInitializedProperties";
	        ClassFacts[ClassFacts["HasConstructorDecorators"] = 2] = "HasConstructorDecorators";
	        ClassFacts[ClassFacts["HasMemberDecorators"] = 4] = "HasMemberDecorators";
	        ClassFacts[ClassFacts["IsExportOfNamespace"] = 8] = "IsExportOfNamespace";
	        ClassFacts[ClassFacts["IsNamedExternalExport"] = 16] = "IsNamedExternalExport";
	        ClassFacts[ClassFacts["IsDefaultExternalExport"] = 32] = "IsDefaultExternalExport";
	        ClassFacts[ClassFacts["IsDerivedClass"] = 64] = "IsDerivedClass";
	        ClassFacts[ClassFacts["UseImmediatelyInvokedFunctionExpression"] = 128] = "UseImmediatelyInvokedFunctionExpression";
	        ClassFacts[ClassFacts["HasAnyDecorators"] = 6] = "HasAnyDecorators";
	        ClassFacts[ClassFacts["NeedsName"] = 5] = "NeedsName";
	        ClassFacts[ClassFacts["MayNeedImmediatelyInvokedFunctionExpression"] = 7] = "MayNeedImmediatelyInvokedFunctionExpression";
	        ClassFacts[ClassFacts["IsExported"] = 56] = "IsExported";
	    })(ClassFacts || (ClassFacts = {}));
	    function transformTypeScript(context) {
	        var startLexicalEnvironment = context.startLexicalEnvironment, resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var resolver = context.getEmitResolver();
	        var compilerOptions = context.getCompilerOptions();
	        var strictNullChecks = ts.getStrictOptionValue(compilerOptions, "strictNullChecks");
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var moduleKind = ts.getEmitModuleKind(compilerOptions);
	        // Save the previous transformation hooks.
	        var previousOnEmitNode = context.onEmitNode;
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        // Set new transformation hooks.
	        context.onEmitNode = onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        // Enable substitution for property/element access to emit const enum values.
	        context.enableSubstitution(183 /* PropertyAccessExpression */);
	        context.enableSubstitution(184 /* ElementAccessExpression */);
	        // These variables contain state that changes as we descend into the tree.
	        var currentSourceFile;
	        var currentNamespace;
	        var currentNamespaceContainerName;
	        var currentScope;
	        var currentScopeFirstDeclarationsOfName;
	        /**
	         * Keeps track of whether expression substitution has been enabled for specific edge cases.
	         * They are persisted between each SourceFile transformation and should not be reset.
	         */
	        var enabledSubstitutions;
	        /**
	         * A map that keeps track of aliases created for classes with decorators to avoid issues
	         * with the double-binding behavior of classes.
	         */
	        var classAliases;
	        /**
	         * Keeps track of whether we are within any containing namespaces when performing
	         * just-in-time substitution while printing an expression identifier.
	         */
	        var applicableSubstitutions;
	        /**
	         * Tracks what computed name expressions originating from elided names must be inlined
	         * at the next execution site, in document order
	         */
	        var pendingExpressions;
	        return transformSourceFile;
	        /**
	         * Transform TypeScript-specific syntax in a SourceFile.
	         *
	         * @param node A SourceFile node.
	         */
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            currentSourceFile = node;
	            var visited = saveStateAndInvoke(node, visitSourceFile);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            currentSourceFile = undefined;
	            return visited;
	        }
	        /**
	         * Visits a node, saving and restoring state variables on the stack.
	         *
	         * @param node The node to visit.
	         */
	        function saveStateAndInvoke(node, f) {
	            // Save state
	            var savedCurrentScope = currentScope;
	            var savedCurrentScopeFirstDeclarationsOfName = currentScopeFirstDeclarationsOfName;
	            // Handle state changes before visiting a node.
	            onBeforeVisitNode(node);
	            var visited = f(node);
	            // Restore state
	            if (currentScope !== savedCurrentScope) {
	                currentScopeFirstDeclarationsOfName = savedCurrentScopeFirstDeclarationsOfName;
	            }
	            currentScope = savedCurrentScope;
	            return visited;
	        }
	        /**
	         * Performs actions that should always occur immediately before visiting a node.
	         *
	         * @param node The node to visit.
	         */
	        function onBeforeVisitNode(node) {
	            switch (node.kind) {
	                case 272 /* SourceFile */:
	                case 239 /* CaseBlock */:
	                case 238 /* ModuleBlock */:
	                case 211 /* Block */:
	                    currentScope = node;
	                    currentScopeFirstDeclarationsOfName = undefined;
	                    break;
	                case 233 /* ClassDeclaration */:
	                case 232 /* FunctionDeclaration */:
	                    if (ts.hasModifier(node, 2 /* Ambient */)) {
	                        break;
	                    }
	                    // Record these declarations provided that they have a name.
	                    if (node.name) {
	                        recordEmittedDeclarationInScope(node);
	                    }
	                    else {
	                        // These nodes should always have names unless they are default-exports;
	                        // however, class declaration parsing allows for undefined names, so syntactically invalid
	                        // programs may also have an undefined name.
	                        ts.Debug.assert(node.kind === 233 /* ClassDeclaration */ || ts.hasModifier(node, 512 /* Default */));
	                    }
	                    break;
	            }
	        }
	        /**
	         * General-purpose node visitor.
	         *
	         * @param node The node to visit.
	         */
	        function visitor(node) {
	            return saveStateAndInvoke(node, visitorWorker);
	        }
	        /**
	         * Visits and possibly transforms any node.
	         *
	         * @param node The node to visit.
	         */
	        function visitorWorker(node) {
	            if (node.transformFlags & 1 /* TypeScript */) {
	                // This node is explicitly marked as TypeScript, so we should transform the node.
	                return visitTypeScript(node);
	            }
	            else if (node.transformFlags & 2 /* ContainsTypeScript */) {
	                // This node contains TypeScript, so we should visit its children.
	                return ts.visitEachChild(node, visitor, context);
	            }
	            return node;
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a SourceFile.
	         *
	         * @param node The node to visit.
	         */
	        function sourceElementVisitor(node) {
	            return saveStateAndInvoke(node, sourceElementVisitorWorker);
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a SourceFile.
	         *
	         * @param node The node to visit.
	         */
	        function sourceElementVisitorWorker(node) {
	            switch (node.kind) {
	                case 242 /* ImportDeclaration */:
	                case 241 /* ImportEqualsDeclaration */:
	                case 247 /* ExportAssignment */:
	                case 248 /* ExportDeclaration */:
	                    return visitEllidableStatement(node);
	                default:
	                    return visitorWorker(node);
	            }
	        }
	        function visitEllidableStatement(node) {
	            var parsed = ts.getParseTreeNode(node);
	            if (parsed !== node) {
	                // If the node has been transformed by a `before` transformer, perform no ellision on it
	                // As the type information we would attempt to lookup to perform ellision is potentially unavailable for the synthesized nodes
	                // We do not reuse `visitorWorker`, as the ellidable statement syntax kinds are technically unrecognized by the switch-case in `visitTypeScript`,
	                // and will trigger debug failures when debug verbosity is turned up
	                if (node.transformFlags & 2 /* ContainsTypeScript */) {
	                    // This node contains TypeScript, so we should visit its children.
	                    return ts.visitEachChild(node, visitor, context);
	                }
	                // Otherwise, we can just return the node
	                return node;
	            }
	            switch (node.kind) {
	                case 242 /* ImportDeclaration */:
	                    return visitImportDeclaration(node);
	                case 241 /* ImportEqualsDeclaration */:
	                    return visitImportEqualsDeclaration(node);
	                case 247 /* ExportAssignment */:
	                    return visitExportAssignment(node);
	                case 248 /* ExportDeclaration */:
	                    return visitExportDeclaration(node);
	                default:
	                    ts.Debug.fail("Unhandled ellided statement");
	            }
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a namespace.
	         *
	         * @param node The node to visit.
	         */
	        function namespaceElementVisitor(node) {
	            return saveStateAndInvoke(node, namespaceElementVisitorWorker);
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a namespace.
	         *
	         * @param node The node to visit.
	         */
	        function namespaceElementVisitorWorker(node) {
	            if (node.kind === 248 /* ExportDeclaration */ ||
	                node.kind === 242 /* ImportDeclaration */ ||
	                node.kind === 243 /* ImportClause */ ||
	                (node.kind === 241 /* ImportEqualsDeclaration */ &&
	                    node.moduleReference.kind === 252 /* ExternalModuleReference */)) {
	                // do not emit ES6 imports and exports since they are illegal inside a namespace
	                return undefined;
	            }
	            else if (node.transformFlags & 1 /* TypeScript */ || ts.hasModifier(node, 1 /* Export */)) {
	                // This node is explicitly marked as TypeScript, or is exported at the namespace
	                // level, so we should transform the node.
	                return visitTypeScript(node);
	            }
	            else if (node.transformFlags & 2 /* ContainsTypeScript */) {
	                // This node contains TypeScript, so we should visit its children.
	                return ts.visitEachChild(node, visitor, context);
	            }
	            return node;
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a class with TypeScript syntax.
	         *
	         * @param node The node to visit.
	         */
	        function classElementVisitor(node) {
	            return saveStateAndInvoke(node, classElementVisitorWorker);
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a class with TypeScript syntax.
	         *
	         * @param node The node to visit.
	         */
	        function classElementVisitorWorker(node) {
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                    // TypeScript constructors are transformed in `visitClassDeclaration`.
	                    // We elide them here as `visitorWorker` checks transform flags, which could
	                    // erronously include an ES6 constructor without TypeScript syntax.
	                    return undefined;
	                case 151 /* PropertyDeclaration */:
	                case 159 /* IndexSignature */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 153 /* MethodDeclaration */:
	                    // Fallback to the default visit behavior.
	                    return visitorWorker(node);
	                case 210 /* SemicolonClassElement */:
	                    return node;
	                default:
	                    ts.Debug.failBadSyntaxKind(node);
	                    return undefined;
	            }
	        }
	        function modifierVisitor(node) {
	            if (ts.modifierToFlag(node.kind) & 2270 /* TypeScriptModifier */) {
	                return undefined;
	            }
	            else if (currentNamespace && node.kind === 84 /* ExportKeyword */) {
	                return undefined;
	            }
	            return node;
	        }
	        /**
	         * Branching visitor, visits a TypeScript syntax node.
	         *
	         * @param node The node to visit.
	         */
	        function visitTypeScript(node) {
	            if (ts.hasModifier(node, 2 /* Ambient */) && ts.isStatement(node)) {
	                // TypeScript ambient declarations are elided, but some comments may be preserved.
	                // See the implementation of `getLeadingComments` in comments.ts for more details.
	                return ts.createNotEmittedStatement(node);
	            }
	            switch (node.kind) {
	                case 84 /* ExportKeyword */:
	                case 79 /* DefaultKeyword */:
	                    // ES6 export and default modifiers are elided when inside a namespace.
	                    return currentNamespace ? undefined : node;
	                case 114 /* PublicKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 117 /* AbstractKeyword */:
	                case 76 /* ConstKeyword */:
	                case 124 /* DeclareKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                // TypeScript accessibility and readonly modifiers are elided.
	                case 166 /* ArrayType */:
	                case 167 /* TupleType */:
	                case 165 /* TypeLiteral */:
	                case 160 /* TypePredicate */:
	                case 147 /* TypeParameter */:
	                case 119 /* AnyKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 131 /* NeverKeyword */:
	                case 105 /* VoidKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 163 /* ConstructorType */:
	                case 162 /* FunctionType */:
	                case 164 /* TypeQuery */:
	                case 161 /* TypeReference */:
	                case 168 /* UnionType */:
	                case 169 /* IntersectionType */:
	                case 170 /* ConditionalType */:
	                case 172 /* ParenthesizedType */:
	                case 173 /* ThisType */:
	                case 174 /* TypeOperator */:
	                case 175 /* IndexedAccessType */:
	                case 176 /* MappedType */:
	                case 177 /* LiteralType */:
	                // TypeScript type nodes are elided.
	                case 159 /* IndexSignature */:
	                // TypeScript index signatures are elided.
	                case 149 /* Decorator */:
	                // TypeScript decorators are elided. They will be emitted as part of visitClassDeclaration.
	                case 235 /* TypeAliasDeclaration */:
	                    // TypeScript type-only declarations are elided.
	                    return undefined;
	                case 151 /* PropertyDeclaration */:
	                    // TypeScript property declarations are elided. However their names are still visited, and can potentially be retained if they could have sideeffects
	                    return visitPropertyDeclaration(node);
	                case 240 /* NamespaceExportDeclaration */:
	                    // TypeScript namespace export declarations are elided.
	                    return undefined;
	                case 154 /* Constructor */:
	                    return visitConstructor(node);
	                case 234 /* InterfaceDeclaration */:
	                    // TypeScript interfaces are elided, but some comments may be preserved.
	                    // See the implementation of `getLeadingComments` in comments.ts for more details.
	                    return ts.createNotEmittedStatement(node);
	                case 233 /* ClassDeclaration */:
	                    // This is a class declaration with TypeScript syntax extensions.
	                    //
	                    // TypeScript class syntax extensions include:
	                    // - decorators
	                    // - optional `implements` heritage clause
	                    // - parameter property assignments in the constructor
	                    // - property declarations
	                    // - index signatures
	                    // - method overload signatures
	                    return visitClassDeclaration(node);
	                case 203 /* ClassExpression */:
	                    // This is a class expression with TypeScript syntax extensions.
	                    //
	                    // TypeScript class syntax extensions include:
	                    // - decorators
	                    // - optional `implements` heritage clause
	                    // - parameter property assignments in the constructor
	                    // - property declarations
	                    // - index signatures
	                    // - method overload signatures
	                    return visitClassExpression(node);
	                case 266 /* HeritageClause */:
	                    // This is a heritage clause with TypeScript syntax extensions.
	                    //
	                    // TypeScript heritage clause extensions include:
	                    // - `implements` clause
	                    return visitHeritageClause(node);
	                case 205 /* ExpressionWithTypeArguments */:
	                    // TypeScript supports type arguments on an expression in an `extends` heritage clause.
	                    return visitExpressionWithTypeArguments(node);
	                case 153 /* MethodDeclaration */:
	                    // TypeScript method declarations may have decorators, modifiers
	                    // or type annotations.
	                    return visitMethodDeclaration(node);
	                case 155 /* GetAccessor */:
	                    // Get Accessors can have TypeScript modifiers, decorators, and type annotations.
	                    return visitGetAccessor(node);
	                case 156 /* SetAccessor */:
	                    // Set Accessors can have TypeScript modifiers and type annotations.
	                    return visitSetAccessor(node);
	                case 232 /* FunctionDeclaration */:
	                    // Typescript function declarations can have modifiers, decorators, and type annotations.
	                    return visitFunctionDeclaration(node);
	                case 190 /* FunctionExpression */:
	                    // TypeScript function expressions can have modifiers and type annotations.
	                    return visitFunctionExpression(node);
	                case 191 /* ArrowFunction */:
	                    // TypeScript arrow functions can have modifiers and type annotations.
	                    return visitArrowFunction(node);
	                case 148 /* Parameter */:
	                    // This is a parameter declaration with TypeScript syntax extensions.
	                    //
	                    // TypeScript parameter declaration syntax extensions include:
	                    // - decorators
	                    // - accessibility modifiers
	                    // - the question mark (?) token for optional parameters
	                    // - type annotations
	                    // - this parameters
	                    return visitParameter(node);
	                case 189 /* ParenthesizedExpression */:
	                    // ParenthesizedExpressions are TypeScript if their expression is a
	                    // TypeAssertion or AsExpression
	                    return visitParenthesizedExpression(node);
	                case 188 /* TypeAssertionExpression */:
	                case 206 /* AsExpression */:
	                    // TypeScript type assertions are removed, but their subtrees are preserved.
	                    return visitAssertionExpression(node);
	                case 185 /* CallExpression */:
	                    return visitCallExpression(node);
	                case 186 /* NewExpression */:
	                    return visitNewExpression(node);
	                case 207 /* NonNullExpression */:
	                    // TypeScript non-null expressions are removed, but their subtrees are preserved.
	                    return visitNonNullExpression(node);
	                case 236 /* EnumDeclaration */:
	                    // TypeScript enum declarations do not exist in ES6 and must be rewritten.
	                    return visitEnumDeclaration(node);
	                case 212 /* VariableStatement */:
	                    // TypeScript namespace exports for variable statements must be transformed.
	                    return visitVariableStatement(node);
	                case 230 /* VariableDeclaration */:
	                    return visitVariableDeclaration(node);
	                case 237 /* ModuleDeclaration */:
	                    // TypeScript namespace declarations must be transformed.
	                    return visitModuleDeclaration(node);
	                case 241 /* ImportEqualsDeclaration */:
	                    // TypeScript namespace or external module import.
	                    return visitImportEqualsDeclaration(node);
	                default:
	                    ts.Debug.failBadSyntaxKind(node);
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitSourceFile(node) {
	            var alwaysStrict = ts.getStrictOptionValue(compilerOptions, "alwaysStrict") &&
	                !(ts.isExternalModule(node) && moduleKind >= ts.ModuleKind.ES2015);
	            return ts.updateSourceFileNode(node, ts.visitLexicalEnvironment(node.statements, sourceElementVisitor, context, /*start*/ 0, alwaysStrict));
	        }
	        /**
	         * Tests whether we should emit a __decorate call for a class declaration.
	         */
	        function shouldEmitDecorateCallForClass(node) {
	            if (node.decorators && node.decorators.length > 0) {
	                return true;
	            }
	            var constructor = ts.getFirstConstructorWithBody(node);
	            if (constructor) {
	                return ts.forEach(constructor.parameters, shouldEmitDecorateCallForParameter);
	            }
	            return false;
	        }
	        /**
	         * Tests whether we should emit a __decorate call for a parameter declaration.
	         */
	        function shouldEmitDecorateCallForParameter(parameter) {
	            return parameter.decorators !== undefined && parameter.decorators.length > 0;
	        }
	        function getClassFacts(node, staticProperties) {
	            var facts = 0 /* None */;
	            if (ts.some(staticProperties))
	                facts |= 1 /* HasStaticInitializedProperties */;
	            var extendsClauseElement = ts.getClassExtendsHeritageClauseElement(node);
	            if (extendsClauseElement && ts.skipOuterExpressions(extendsClauseElement.expression).kind !== 95 /* NullKeyword */)
	                facts |= 64 /* IsDerivedClass */;
	            if (shouldEmitDecorateCallForClass(node))
	                facts |= 2 /* HasConstructorDecorators */;
	            if (ts.childIsDecorated(node))
	                facts |= 4 /* HasMemberDecorators */;
	            if (isExportOfNamespace(node))
	                facts |= 8 /* IsExportOfNamespace */;
	            else if (isDefaultExternalModuleExport(node))
	                facts |= 32 /* IsDefaultExternalExport */;
	            else if (isNamedExternalModuleExport(node))
	                facts |= 16 /* IsNamedExternalExport */;
	            if (languageVersion <= 1 /* ES5 */ && (facts & 7 /* MayNeedImmediatelyInvokedFunctionExpression */))
	                facts |= 128 /* UseImmediatelyInvokedFunctionExpression */;
	            return facts;
	        }
	        /**
	         * Transforms a class declaration with TypeScript syntax into compatible ES6.
	         *
	         * This function will only be called when one of the following conditions are met:
	         * - The class has decorators.
	         * - The class has property declarations with initializers.
	         * - The class contains a constructor that contains parameters with accessibility modifiers.
	         * - The class is an export in a TypeScript namespace.
	         *
	         * @param node The node to transform.
	         */
	        function visitClassDeclaration(node) {
	            var savedPendingExpressions = pendingExpressions;
	            pendingExpressions = undefined;
	            var staticProperties = getInitializedProperties(node, /*isStatic*/ true);
	            var facts = getClassFacts(node, staticProperties);
	            if (facts & 128 /* UseImmediatelyInvokedFunctionExpression */) {
	                context.startLexicalEnvironment();
	            }
	            var name = node.name || (facts & 5 /* NeedsName */ ? ts.getGeneratedNameForNode(node) : undefined);
	            var classStatement = facts & 2 /* HasConstructorDecorators */
	                ? createClassDeclarationHeadWithDecorators(node, name, facts)
	                : createClassDeclarationHeadWithoutDecorators(node, name, facts);
	            var statements = [classStatement];
	            // Write any pending expressions from elided or moved computed property names
	            if (ts.some(pendingExpressions)) {
	                statements.push(ts.createStatement(ts.inlineExpressions(pendingExpressions)));
	            }
	            pendingExpressions = savedPendingExpressions;
	            // Emit static property assignment. Because classDeclaration is lexically evaluated,
	            // it is safe to emit static property assignment after classDeclaration
	            // From ES6 specification:
	            //      HasLexicalDeclaration (N) : Determines if the argument identifier has a binding in this environment record that was created using
	            //                                  a lexical declaration such as a LexicalDeclaration or a ClassDeclaration.
	            if (facts & 1 /* HasStaticInitializedProperties */) {
	                addInitializedPropertyStatements(statements, staticProperties, facts & 128 /* UseImmediatelyInvokedFunctionExpression */ ? ts.getInternalName(node) : ts.getLocalName(node));
	            }
	            // Write any decorators of the node.
	            addClassElementDecorationStatements(statements, node, /*isStatic*/ false);
	            addClassElementDecorationStatements(statements, node, /*isStatic*/ true);
	            addConstructorDecorationStatement(statements, node);
	            if (facts & 128 /* UseImmediatelyInvokedFunctionExpression */) {
	                // When we emit a TypeScript class down to ES5, we must wrap it in an IIFE so that the
	                // 'es2015' transformer can properly nest static initializers and decorators. The result
	                // looks something like:
	                //
	                //  var C = function () {
	                //      class C {
	                //      }
	                //      C.static_prop = 1;
	                //      return C;
	                //  }();
	                //
	                var closingBraceLocation = ts.createTokenRange(ts.skipTrivia(currentSourceFile.text, node.members.end), 18 /* CloseBraceToken */);
	                var localName = ts.getInternalName(node);
	                // The following partially-emitted expression exists purely to align our sourcemap
	                // emit with the original emitter.
	                var outer = ts.createPartiallyEmittedExpression(localName);
	                outer.end = closingBraceLocation.end;
	                ts.setEmitFlags(outer, 1536 /* NoComments */);
	                var statement = ts.createReturn(outer);
	                statement.pos = closingBraceLocation.pos;
	                ts.setEmitFlags(statement, 1536 /* NoComments */ | 384 /* NoTokenSourceMaps */);
	                statements.push(statement);
	                ts.addRange(statements, context.endLexicalEnvironment());
	                var iife = ts.createImmediatelyInvokedArrowFunction(statements);
	                ts.setEmitFlags(iife, 33554432 /* TypeScriptClassWrapper */);
	                var varStatement = ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                    ts.createVariableDeclaration(ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ false), 
	                    /*type*/ undefined, iife)
	                ]));
	                ts.setOriginalNode(varStatement, node);
	                ts.setCommentRange(varStatement, node);
	                ts.setSourceMapRange(varStatement, ts.moveRangePastDecorators(node));
	                ts.startOnNewLine(varStatement);
	                statements = [varStatement];
	            }
	            // If the class is exported as part of a TypeScript namespace, emit the namespace export.
	            // Otherwise, if the class was exported at the top level and was decorated, emit an export
	            // declaration or export default for the class.
	            if (facts & 8 /* IsExportOfNamespace */) {
	                addExportMemberAssignment(statements, node);
	            }
	            else if (facts & 128 /* UseImmediatelyInvokedFunctionExpression */ || facts & 2 /* HasConstructorDecorators */) {
	                if (facts & 32 /* IsDefaultExternalExport */) {
	                    statements.push(ts.createExportDefault(ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true)));
	                }
	                else if (facts & 16 /* IsNamedExternalExport */) {
	                    statements.push(ts.createExternalModuleExport(ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true)));
	                }
	            }
	            if (statements.length > 1) {
	                // Add a DeclarationMarker as a marker for the end of the declaration
	                statements.push(ts.createEndOfDeclarationMarker(node));
	                ts.setEmitFlags(classStatement, ts.getEmitFlags(classStatement) | 4194304 /* HasEndOfDeclarationMarker */);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Transforms a non-decorated class declaration and appends the resulting statements.
	         *
	         * @param node A ClassDeclaration node.
	         * @param name The name of the class.
	         * @param facts Precomputed facts about the class.
	         */
	        function createClassDeclarationHeadWithoutDecorators(node, name, facts) {
	            //  ${modifiers} class ${name} ${heritageClauses} {
	            //      ${members}
	            //  }
	            // we do not emit modifiers on the declaration if we are emitting an IIFE
	            var modifiers = !(facts & 128 /* UseImmediatelyInvokedFunctionExpression */)
	                ? ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier)
	                : undefined;
	            var classDeclaration = ts.createClassDeclaration(
	            /*decorators*/ undefined, modifiers, name, 
	            /*typeParameters*/ undefined, ts.visitNodes(node.heritageClauses, visitor, ts.isHeritageClause), transformClassMembers(node, (facts & 64 /* IsDerivedClass */) !== 0));
	            // To better align with the old emitter, we should not emit a trailing source map
	            // entry if the class has static properties.
	            var emitFlags = ts.getEmitFlags(node);
	            if (facts & 1 /* HasStaticInitializedProperties */) {
	                emitFlags |= 32 /* NoTrailingSourceMap */;
	            }
	            ts.setTextRange(classDeclaration, node);
	            ts.setOriginalNode(classDeclaration, node);
	            ts.setEmitFlags(classDeclaration, emitFlags);
	            return classDeclaration;
	        }
	        /**
	         * Transforms a decorated class declaration and appends the resulting statements. If
	         * the class requires an alias to avoid issues with double-binding, the alias is returned.
	         */
	        function createClassDeclarationHeadWithDecorators(node, name, facts) {
	            // When we emit an ES6 class that has a class decorator, we must tailor the
	            // emit to certain specific cases.
	            //
	            // In the simplest case, we emit the class declaration as a let declaration, and
	            // evaluate decorators after the close of the class body:
	            //
	            //  [Example 1]
	            //  ---------------------------------------------------------------------
	            //  TypeScript                      | Javascript
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  class C {                       | }
	            //  }                               | C = __decorate([dec], C);
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  export class C {                | }
	            //  }                               | C = __decorate([dec], C);
	            //                                  | export { C };
	            //  ---------------------------------------------------------------------
	            //
	            // If a class declaration contains a reference to itself *inside* of the class body,
	            // this introduces two bindings to the class: One outside of the class body, and one
	            // inside of the class body. If we apply decorators as in [Example 1] above, there
	            // is the possibility that the decorator `dec` will return a new value for the
	            // constructor, which would result in the binding inside of the class no longer
	            // pointing to the same reference as the binding outside of the class.
	            //
	            // As a result, we must instead rewrite all references to the class *inside* of the
	            // class body to instead point to a local temporary alias for the class:
	            //
	            //  [Example 2]
	            //  ---------------------------------------------------------------------
	            //  TypeScript                      | Javascript
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = C_1 = class C {
	            //  class C {                       |   static x() { return C_1.y; }
	            //    static x() { return C.y; }    | }
	            //    static y = 1;                 | C.y = 1;
	            //  }                               | C = C_1 = __decorate([dec], C);
	            //                                  | var C_1;
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  export class C {                |   static x() { return C_1.y; }
	            //    static x() { return C.y; }    | }
	            //    static y = 1;                 | C.y = 1;
	            //  }                               | C = C_1 = __decorate([dec], C);
	            //                                  | export { C };
	            //                                  | var C_1;
	            //  ---------------------------------------------------------------------
	            //
	            // If a class declaration is the default export of a module, we instead emit
	            // the export after the decorated declaration:
	            //
	            //  [Example 3]
	            //  ---------------------------------------------------------------------
	            //  TypeScript                      | Javascript
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let default_1 = class {
	            //  export default class {          | }
	            //  }                               | default_1 = __decorate([dec], default_1);
	            //                                  | export default default_1;
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  export default class C {        | }
	            //  }                               | C = __decorate([dec], C);
	            //                                  | export default C;
	            //  ---------------------------------------------------------------------
	            //
	            // If the class declaration is the default export and a reference to itself
	            // inside of the class body, we must emit both an alias for the class *and*
	            // move the export after the declaration:
	            //
	            //  [Example 4]
	            //  ---------------------------------------------------------------------
	            //  TypeScript                      | Javascript
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  export default class C {        |   static x() { return C_1.y; }
	            //    static x() { return C.y; }    | }
	            //    static y = 1;                 | C.y = 1;
	            //  }                               | C = C_1 = __decorate([dec], C);
	            //                                  | export default C;
	            //                                  | var C_1;
	            //  ---------------------------------------------------------------------
	            //
	            var location = ts.moveRangePastDecorators(node);
	            var classAlias = getClassAliasIfNeeded(node);
	            var declName = ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	            //  ... = class ${name} ${heritageClauses} {
	            //      ${members}
	            //  }
	            var heritageClauses = ts.visitNodes(node.heritageClauses, visitor, ts.isHeritageClause);
	            var members = transformClassMembers(node, (facts & 64 /* IsDerivedClass */) !== 0);
	            var classExpression = ts.createClassExpression(/*modifiers*/ undefined, name, /*typeParameters*/ undefined, heritageClauses, members);
	            ts.setOriginalNode(classExpression, node);
	            ts.setTextRange(classExpression, location);
	            //  let ${name} = ${classExpression} where name is either declaredName if the class doesn't contain self-reference
	            //                                         or decoratedClassAlias if the class contain self-reference.
	            var statement = ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(declName, 
	                /*type*/ undefined, classAlias ? ts.createAssignment(classAlias, classExpression) : classExpression)
	            ], 1 /* Let */));
	            ts.setOriginalNode(statement, node);
	            ts.setTextRange(statement, location);
	            ts.setCommentRange(statement, node);
	            return statement;
	        }
	        /**
	         * Transforms a class expression with TypeScript syntax into compatible ES6.
	         *
	         * This function will only be called when one of the following conditions are met:
	         * - The class has property declarations with initializers.
	         * - The class contains a constructor that contains parameters with accessibility modifiers.
	         *
	         * @param node The node to transform.
	         */
	        function visitClassExpression(node) {
	            var savedPendingExpressions = pendingExpressions;
	            pendingExpressions = undefined;
	            var staticProperties = getInitializedProperties(node, /*isStatic*/ true);
	            var heritageClauses = ts.visitNodes(node.heritageClauses, visitor, ts.isHeritageClause);
	            var members = transformClassMembers(node, ts.some(heritageClauses, function (c) { return c.token === 85 /* ExtendsKeyword */; }));
	            var classExpression = ts.createClassExpression(
	            /*modifiers*/ undefined, node.name, 
	            /*typeParameters*/ undefined, heritageClauses, members);
	            ts.setOriginalNode(classExpression, node);
	            ts.setTextRange(classExpression, node);
	            if (ts.some(staticProperties) || ts.some(pendingExpressions)) {
	                var expressions = [];
	                var isClassWithConstructorReference = resolver.getNodeCheckFlags(node) & 8388608 /* ClassWithConstructorReference */;
	                var temp = ts.createTempVariable(hoistVariableDeclaration, !!isClassWithConstructorReference);
	                if (isClassWithConstructorReference) {
	                    // record an alias as the class name is not in scope for statics.
	                    enableSubstitutionForClassAliases();
	                    var alias = ts.getSynthesizedClone(temp);
	                    alias.autoGenerateFlags &= ~16 /* ReservedInNestedScopes */;
	                    classAliases[ts.getOriginalNodeId(node)] = alias;
	                }
	                // To preserve the behavior of the old emitter, we explicitly indent
	                // the body of a class with static initializers.
	                ts.setEmitFlags(classExpression, 65536 /* Indented */ | ts.getEmitFlags(classExpression));
	                expressions.push(ts.startOnNewLine(ts.createAssignment(temp, classExpression)));
	                // Add any pending expressions leftover from elided or relocated computed property names
	                ts.addRange(expressions, ts.map(pendingExpressions, ts.startOnNewLine));
	                pendingExpressions = savedPendingExpressions;
	                ts.addRange(expressions, generateInitializedPropertyExpressions(staticProperties, temp));
	                expressions.push(ts.startOnNewLine(temp));
	                return ts.inlineExpressions(expressions);
	            }
	            pendingExpressions = savedPendingExpressions;
	            return classExpression;
	        }
	        /**
	         * Transforms the members of a class.
	         *
	         * @param node The current class.
	         * @param isDerivedClass A value indicating whether the class has an extends clause that does not extend 'null'.
	         */
	        function transformClassMembers(node, isDerivedClass) {
	            var members = [];
	            var constructor = transformConstructor(node, isDerivedClass);
	            if (constructor) {
	                members.push(constructor);
	            }
	            ts.addRange(members, ts.visitNodes(node.members, classElementVisitor, ts.isClassElement));
	            return ts.setTextRange(ts.createNodeArray(members), /*location*/ node.members);
	        }
	        /**
	         * Transforms (or creates) a constructor for a class.
	         *
	         * @param node The current class.
	         * @param isDerivedClass A value indicating whether the class has an extends clause that does not extend 'null'.
	         */
	        function transformConstructor(node, isDerivedClass) {
	            // Check if we have property assignment inside class declaration.
	            // If there is a property assignment, we need to emit constructor whether users define it or not
	            // If there is no property assignment, we can omit constructor if users do not define it
	            var hasInstancePropertyWithInitializer = ts.forEach(node.members, isInstanceInitializedProperty);
	            var hasParameterPropertyAssignments = node.transformFlags & 262144 /* ContainsParameterPropertyAssignments */;
	            var constructor = ts.getFirstConstructorWithBody(node);
	            // If the class does not contain nodes that require a synthesized constructor,
	            // accept the current constructor if it exists.
	            if (!hasInstancePropertyWithInitializer && !hasParameterPropertyAssignments) {
	                return ts.visitEachChild(constructor, visitor, context);
	            }
	            var parameters = transformConstructorParameters(constructor);
	            var body = transformConstructorBody(node, constructor, isDerivedClass);
	            //  constructor(${parameters}) {
	            //      ${body}
	            //  }
	            return ts.startOnNewLine(ts.setOriginalNode(ts.setTextRange(ts.createConstructor(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, parameters, body), constructor || node), constructor));
	        }
	        /**
	         * Transforms (or creates) the parameters for the constructor of a class with
	         * parameter property assignments or instance property initializers.
	         *
	         * @param constructor The constructor declaration.
	         */
	        function transformConstructorParameters(constructor) {
	            // The ES2015 spec specifies in 14.5.14. Runtime Semantics: ClassDefinitionEvaluation:
	            // If constructor is empty, then
	            //     If ClassHeritag_eopt is present and protoParent is not null, then
	            //          Let constructor be the result of parsing the source text
	            //              constructor(...args) { super (...args);}
	            //          using the syntactic grammar with the goal symbol MethodDefinition[~Yield].
	            //      Else,
	            //           Let constructor be the result of parsing the source text
	            //               constructor( ){ }
	            //           using the syntactic grammar with the goal symbol MethodDefinition[~Yield].
	            //
	            // While we could emit the '...args' rest parameter, certain later tools in the pipeline might
	            // downlevel the '...args' portion less efficiently by naively copying the contents of 'arguments' to an array.
	            // Instead, we'll avoid using a rest parameter and spread into the super call as
	            // 'super(...arguments)' instead of 'super(...args)', as you can see in "transformConstructorBody".
	            return ts.visitParameterList(constructor && constructor.parameters, visitor, context)
	                || [];
	        }
	        /**
	         * Transforms (or creates) a constructor body for a class with parameter property
	         * assignments or instance property initializers.
	         *
	         * @param node The current class.
	         * @param constructor The current class constructor.
	         * @param isDerivedClass A value indicating whether the class has an extends clause that does not extend 'null'.
	         */
	        function transformConstructorBody(node, constructor, isDerivedClass) {
	            var statements = [];
	            var indexOfFirstStatement = 0;
	            resumeLexicalEnvironment();
	            if (constructor) {
	                indexOfFirstStatement = addPrologueDirectivesAndInitialSuperCall(constructor, statements);
	                // Add parameters with property assignments. Transforms this:
	                //
	                //  constructor (public x, public y) {
	                //  }
	                //
	                // Into this:
	                //
	                //  constructor (x, y) {
	                //      this.x = x;
	                //      this.y = y;
	                //  }
	                //
	                var propertyAssignments = getParametersWithPropertyAssignments(constructor);
	                ts.addRange(statements, ts.map(propertyAssignments, transformParameterWithPropertyAssignment));
	            }
	            else if (isDerivedClass) {
	                // Add a synthetic `super` call:
	                //
	                //  super(...arguments);
	                //
	                statements.push(ts.createStatement(ts.createCall(ts.createSuper(), 
	                /*typeArguments*/ undefined, [ts.createSpread(ts.createIdentifier("arguments"))])));
	            }
	            // Add the property initializers. Transforms this:
	            //
	            //  public x = 1;
	            //
	            // Into this:
	            //
	            //  constructor() {
	            //      this.x = 1;
	            //  }
	            //
	            var properties = getInitializedProperties(node, /*isStatic*/ false);
	            addInitializedPropertyStatements(statements, properties, ts.createThis());
	            if (constructor) {
	                // The class already had a constructor, so we should add the existing statements, skipping the initial super call.
	                ts.addRange(statements, ts.visitNodes(constructor.body.statements, visitor, ts.isStatement, indexOfFirstStatement));
	            }
	            // End the lexical environment.
	            statements = ts.mergeLexicalEnvironment(statements, endLexicalEnvironment());
	            return ts.setTextRange(ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), 
	            /*location*/ constructor ? constructor.body.statements : node.members), 
	            /*multiLine*/ true), 
	            /*location*/ constructor ? constructor.body : undefined);
	        }
	        /**
	         * Adds super call and preceding prologue directives into the list of statements.
	         *
	         * @param ctor The constructor node.
	         * @returns index of the statement that follows super call
	         */
	        function addPrologueDirectivesAndInitialSuperCall(ctor, result) {
	            if (ctor.body) {
	                var statements = ctor.body.statements;
	                // add prologue directives to the list (if any)
	                var index = ts.addPrologue(result, statements, /*ensureUseStrict*/ false, visitor);
	                if (index === statements.length) {
	                    // list contains nothing but prologue directives (or empty) - exit
	                    return index;
	                }
	                var statement = statements[index];
	                if (statement.kind === 214 /* ExpressionStatement */ && ts.isSuperCall(statement.expression)) {
	                    result.push(ts.visitNode(statement, visitor, ts.isStatement));
	                    return index + 1;
	                }
	                return index;
	            }
	            return 0;
	        }
	        /**
	         * Gets all parameters of a constructor that should be transformed into property assignments.
	         *
	         * @param node The constructor node.
	         */
	        function getParametersWithPropertyAssignments(node) {
	            return ts.filter(node.parameters, isParameterWithPropertyAssignment);
	        }
	        /**
	         * Determines whether a parameter should be transformed into a property assignment.
	         *
	         * @param parameter The parameter node.
	         */
	        function isParameterWithPropertyAssignment(parameter) {
	            return ts.hasModifier(parameter, 92 /* ParameterPropertyModifier */)
	                && ts.isIdentifier(parameter.name);
	        }
	        /**
	         * Transforms a parameter into a property assignment statement.
	         *
	         * @param node The parameter declaration.
	         */
	        function transformParameterWithPropertyAssignment(node) {
	            ts.Debug.assert(ts.isIdentifier(node.name));
	            var name = node.name;
	            var propertyName = ts.getMutableClone(name);
	            ts.setEmitFlags(propertyName, 1536 /* NoComments */ | 48 /* NoSourceMap */);
	            var localName = ts.getMutableClone(name);
	            ts.setEmitFlags(localName, 1536 /* NoComments */);
	            return ts.startOnNewLine(ts.setTextRange(ts.createStatement(ts.createAssignment(ts.setTextRange(ts.createPropertyAccess(ts.createThis(), propertyName), node.name), localName)), ts.moveRangePos(node, -1)));
	        }
	        /**
	         * Gets all property declarations with initializers on either the static or instance side of a class.
	         *
	         * @param node The class node.
	         * @param isStatic A value indicating whether to get properties from the static or instance side of the class.
	         */
	        function getInitializedProperties(node, isStatic) {
	            return ts.filter(node.members, isStatic ? isStaticInitializedProperty : isInstanceInitializedProperty);
	        }
	        /**
	         * Gets a value indicating whether a class element is a static property declaration with an initializer.
	         *
	         * @param member The class element node.
	         */
	        function isStaticInitializedProperty(member) {
	            return isInitializedProperty(member, /*isStatic*/ true);
	        }
	        /**
	         * Gets a value indicating whether a class element is an instance property declaration with an initializer.
	         *
	         * @param member The class element node.
	         */
	        function isInstanceInitializedProperty(member) {
	            return isInitializedProperty(member, /*isStatic*/ false);
	        }
	        /**
	         * Gets a value indicating whether a class element is either a static or an instance property declaration with an initializer.
	         *
	         * @param member The class element node.
	         * @param isStatic A value indicating whether the member should be a static or instance member.
	         */
	        function isInitializedProperty(member, isStatic) {
	            return member.kind === 151 /* PropertyDeclaration */
	                && isStatic === ts.hasModifier(member, 32 /* Static */)
	                && member.initializer !== undefined;
	        }
	        /**
	         * Generates assignment statements for property initializers.
	         *
	         * @param properties An array of property declarations to transform.
	         * @param receiver The receiver on which each property should be assigned.
	         */
	        function addInitializedPropertyStatements(statements, properties, receiver) {
	            for (var _i = 0, properties_10 = properties; _i < properties_10.length; _i++) {
	                var property = properties_10[_i];
	                var statement = ts.createStatement(transformInitializedProperty(property, receiver));
	                ts.setSourceMapRange(statement, ts.moveRangePastModifiers(property));
	                ts.setCommentRange(statement, property);
	                statements.push(statement);
	            }
	        }
	        /**
	         * Generates assignment expressions for property initializers.
	         *
	         * @param properties An array of property declarations to transform.
	         * @param receiver The receiver on which each property should be assigned.
	         */
	        function generateInitializedPropertyExpressions(properties, receiver) {
	            var expressions = [];
	            for (var _i = 0, properties_11 = properties; _i < properties_11.length; _i++) {
	                var property = properties_11[_i];
	                var expression = transformInitializedProperty(property, receiver);
	                ts.startOnNewLine(expression);
	                ts.setSourceMapRange(expression, ts.moveRangePastModifiers(property));
	                ts.setCommentRange(expression, property);
	                expressions.push(expression);
	            }
	            return expressions;
	        }
	        /**
	         * Transforms a property initializer into an assignment statement.
	         *
	         * @param property The property declaration.
	         * @param receiver The object receiving the property assignment.
	         */
	        function transformInitializedProperty(property, receiver) {
	            // We generate a name here in order to reuse the value cached by the relocated computed name expression (which uses the same generated name)
	            var propertyName = ts.isComputedPropertyName(property.name) && !isSimpleInlineableExpression(property.name.expression)
	                ? ts.updateComputedPropertyName(property.name, ts.getGeneratedNameForNode(property.name, !ts.hasModifier(property, 32 /* Static */)))
	                : property.name;
	            var initializer = ts.visitNode(property.initializer, visitor, ts.isExpression);
	            var memberAccess = ts.createMemberAccessForPropertyName(receiver, propertyName, /*location*/ propertyName);
	            return ts.createAssignment(memberAccess, initializer);
	        }
	        /**
	         * Gets either the static or instance members of a class that are decorated, or have
	         * parameters that are decorated.
	         *
	         * @param node The class containing the member.
	         * @param isStatic A value indicating whether to retrieve static or instance members of
	         *                 the class.
	         */
	        function getDecoratedClassElements(node, isStatic) {
	            return ts.filter(node.members, isStatic ? function (m) { return isStaticDecoratedClassElement(m, node); } : function (m) { return isInstanceDecoratedClassElement(m, node); });
	        }
	        /**
	         * Determines whether a class member is a static member of a class that is decorated, or
	         * has parameters that are decorated.
	         *
	         * @param member The class member.
	         */
	        function isStaticDecoratedClassElement(member, parent) {
	            return isDecoratedClassElement(member, /*isStatic*/ true, parent);
	        }
	        /**
	         * Determines whether a class member is an instance member of a class that is decorated,
	         * or has parameters that are decorated.
	         *
	         * @param member The class member.
	         */
	        function isInstanceDecoratedClassElement(member, parent) {
	            return isDecoratedClassElement(member, /*isStatic*/ false, parent);
	        }
	        /**
	         * Determines whether a class member is either a static or an instance member of a class
	         * that is decorated, or has parameters that are decorated.
	         *
	         * @param member The class member.
	         */
	        function isDecoratedClassElement(member, isStatic, parent) {
	            return ts.nodeOrChildIsDecorated(member, parent)
	                && isStatic === ts.hasModifier(member, 32 /* Static */);
	        }
	        /**
	         * Gets an array of arrays of decorators for the parameters of a function-like node.
	         * The offset into the result array should correspond to the offset of the parameter.
	         *
	         * @param node The function-like node.
	         */
	        function getDecoratorsOfParameters(node) {
	            var decorators;
	            if (node) {
	                var parameters = node.parameters;
	                for (var i = 0; i < parameters.length; i++) {
	                    var parameter = parameters[i];
	                    if (decorators || parameter.decorators) {
	                        if (!decorators) {
	                            decorators = new Array(parameters.length);
	                        }
	                        decorators[i] = parameter.decorators;
	                    }
	                }
	            }
	            return decorators;
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the class and the decorators for the
	         * parameters of the constructor of the class.
	         *
	         * @param node The class node.
	         */
	        function getAllDecoratorsOfConstructor(node) {
	            var decorators = node.decorators;
	            var parameters = getDecoratorsOfParameters(ts.getFirstConstructorWithBody(node));
	            if (!decorators && !parameters) {
	                return undefined;
	            }
	            return {
	                decorators: decorators,
	                parameters: parameters
	            };
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the member and its parameters.
	         *
	         * @param node The class node that contains the member.
	         * @param member The class member.
	         */
	        function getAllDecoratorsOfClassElement(node, member) {
	            switch (member.kind) {
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return getAllDecoratorsOfAccessors(node, member);
	                case 153 /* MethodDeclaration */:
	                    return getAllDecoratorsOfMethod(member);
	                case 151 /* PropertyDeclaration */:
	                    return getAllDecoratorsOfProperty(member);
	                default:
	                    return undefined;
	            }
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the accessor and its parameters.
	         *
	         * @param node The class node that contains the accessor.
	         * @param accessor The class accessor member.
	         */
	        function getAllDecoratorsOfAccessors(node, accessor) {
	            if (!accessor.body) {
	                return undefined;
	            }
	            var _a = ts.getAllAccessorDeclarations(node.members, accessor), firstAccessor = _a.firstAccessor, secondAccessor = _a.secondAccessor, setAccessor = _a.setAccessor;
	            var firstAccessorWithDecorators = firstAccessor.decorators ? firstAccessor : secondAccessor && secondAccessor.decorators ? secondAccessor : undefined;
	            if (!firstAccessorWithDecorators || accessor !== firstAccessorWithDecorators) {
	                return undefined;
	            }
	            var decorators = firstAccessorWithDecorators.decorators;
	            var parameters = getDecoratorsOfParameters(setAccessor);
	            if (!decorators && !parameters) {
	                return undefined;
	            }
	            return { decorators: decorators, parameters: parameters };
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the method and its parameters.
	         *
	         * @param method The class method member.
	         */
	        function getAllDecoratorsOfMethod(method) {
	            if (!method.body) {
	                return undefined;
	            }
	            var decorators = method.decorators;
	            var parameters = getDecoratorsOfParameters(method);
	            if (!decorators && !parameters) {
	                return undefined;
	            }
	            return { decorators: decorators, parameters: parameters };
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the property.
	         *
	         * @param property The class property member.
	         */
	        function getAllDecoratorsOfProperty(property) {
	            var decorators = property.decorators;
	            if (!decorators) {
	                return undefined;
	            }
	            return { decorators: decorators };
	        }
	        /**
	         * Transforms all of the decorators for a declaration into an array of expressions.
	         *
	         * @param node The declaration node.
	         * @param allDecorators An object containing all of the decorators for the declaration.
	         */
	        function transformAllDecoratorsOfDeclaration(node, container, allDecorators) {
	            if (!allDecorators) {
	                return undefined;
	            }
	            var decoratorExpressions = [];
	            ts.addRange(decoratorExpressions, ts.map(allDecorators.decorators, transformDecorator));
	            ts.addRange(decoratorExpressions, ts.flatMap(allDecorators.parameters, transformDecoratorsOfParameter));
	            addTypeMetadata(node, container, decoratorExpressions);
	            return decoratorExpressions;
	        }
	        /**
	         * Generates statements used to apply decorators to either the static or instance members
	         * of a class.
	         *
	         * @param node The class node.
	         * @param isStatic A value indicating whether to generate statements for static or
	         *                 instance members.
	         */
	        function addClassElementDecorationStatements(statements, node, isStatic) {
	            ts.addRange(statements, ts.map(generateClassElementDecorationExpressions(node, isStatic), expressionToStatement));
	        }
	        /**
	         * Generates expressions used to apply decorators to either the static or instance members
	         * of a class.
	         *
	         * @param node The class node.
	         * @param isStatic A value indicating whether to generate expressions for static or
	         *                 instance members.
	         */
	        function generateClassElementDecorationExpressions(node, isStatic) {
	            var members = getDecoratedClassElements(node, isStatic);
	            var expressions;
	            for (var _i = 0, members_4 = members; _i < members_4.length; _i++) {
	                var member = members_4[_i];
	                var expression = generateClassElementDecorationExpression(node, member);
	                if (expression) {
	                    if (!expressions) {
	                        expressions = [expression];
	                    }
	                    else {
	                        expressions.push(expression);
	                    }
	                }
	            }
	            return expressions;
	        }
	        /**
	         * Generates an expression used to evaluate class element decorators at runtime.
	         *
	         * @param node The class node that contains the member.
	         * @param member The class member.
	         */
	        function generateClassElementDecorationExpression(node, member) {
	            var allDecorators = getAllDecoratorsOfClassElement(node, member);
	            var decoratorExpressions = transformAllDecoratorsOfDeclaration(member, node, allDecorators);
	            if (!decoratorExpressions) {
	                return undefined;
	            }
	            // Emit the call to __decorate. Given the following:
	            //
	            //   class C {
	            //     @dec method(@dec2 x) {}
	            //     @dec get accessor() {}
	            //     @dec prop;
	            //   }
	            //
	            // The emit for a method is:
	            //
	            //   __decorate([
	            //       dec,
	            //       __param(0, dec2),
	            //       __metadata("design:type", Function),
	            //       __metadata("design:paramtypes", [Object]),
	            //       __metadata("design:returntype", void 0)
	            //   ], C.prototype, "method", null);
	            //
	            // The emit for an accessor is:
	            //
	            //   __decorate([
	            //       dec
	            //   ], C.prototype, "accessor", null);
	            //
	            // The emit for a property is:
	            //
	            //   __decorate([
	            //       dec
	            //   ], C.prototype, "prop");
	            //
	            var prefix = getClassMemberPrefix(node, member);
	            var memberName = getExpressionForPropertyName(member, /*generateNameForComputedPropertyName*/ true);
	            var descriptor = languageVersion > 0 /* ES3 */
	                ? member.kind === 151 /* PropertyDeclaration */
	                    // We emit `void 0` here to indicate to `__decorate` that it can invoke `Object.defineProperty` directly, but that it
	                    // should not invoke `Object.getOwnPropertyDescriptor`.
	                    ? ts.createVoidZero()
	                    // We emit `null` here to indicate to `__decorate` that it can invoke `Object.getOwnPropertyDescriptor` directly.
	                    // We have this extra argument here so that we can inject an explicit property descriptor at a later date.
	                    : ts.createNull()
	                : undefined;
	            var helper = createDecorateHelper(context, decoratorExpressions, prefix, memberName, descriptor, ts.moveRangePastDecorators(member));
	            ts.setEmitFlags(helper, 1536 /* NoComments */);
	            return helper;
	        }
	        /**
	         * Generates a __decorate helper call for a class constructor.
	         *
	         * @param node The class node.
	         */
	        function addConstructorDecorationStatement(statements, node) {
	            var expression = generateConstructorDecorationExpression(node);
	            if (expression) {
	                statements.push(ts.setOriginalNode(ts.createStatement(expression), node));
	            }
	        }
	        /**
	         * Generates a __decorate helper call for a class constructor.
	         *
	         * @param node The class node.
	         */
	        function generateConstructorDecorationExpression(node) {
	            var allDecorators = getAllDecoratorsOfConstructor(node);
	            var decoratorExpressions = transformAllDecoratorsOfDeclaration(node, node, allDecorators);
	            if (!decoratorExpressions) {
	                return undefined;
	            }
	            var classAlias = classAliases && classAliases[ts.getOriginalNodeId(node)];
	            var localName = ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	            var decorate = createDecorateHelper(context, decoratorExpressions, localName);
	            var expression = ts.createAssignment(localName, classAlias ? ts.createAssignment(classAlias, decorate) : decorate);
	            ts.setEmitFlags(expression, 1536 /* NoComments */);
	            ts.setSourceMapRange(expression, ts.moveRangePastDecorators(node));
	            return expression;
	        }
	        /**
	         * Transforms a decorator into an expression.
	         *
	         * @param decorator The decorator node.
	         */
	        function transformDecorator(decorator) {
	            return ts.visitNode(decorator.expression, visitor, ts.isExpression);
	        }
	        /**
	         * Transforms the decorators of a parameter.
	         *
	         * @param decorators The decorators for the parameter at the provided offset.
	         * @param parameterOffset The offset of the parameter.
	         */
	        function transformDecoratorsOfParameter(decorators, parameterOffset) {
	            var expressions;
	            if (decorators) {
	                expressions = [];
	                for (var _i = 0, decorators_1 = decorators; _i < decorators_1.length; _i++) {
	                    var decorator = decorators_1[_i];
	                    var helper = createParamHelper(context, transformDecorator(decorator), parameterOffset, 
	                    /*location*/ decorator.expression);
	                    ts.setEmitFlags(helper, 1536 /* NoComments */);
	                    expressions.push(helper);
	                }
	            }
	            return expressions;
	        }
	        /**
	         * Adds optional type metadata for a declaration.
	         *
	         * @param node The declaration node.
	         * @param decoratorExpressions The destination array to which to add new decorator expressions.
	         */
	        function addTypeMetadata(node, container, decoratorExpressions) {
	            if (USE_NEW_TYPE_METADATA_FORMAT) {
	                addNewTypeMetadata(node, container, decoratorExpressions);
	            }
	            else {
	                addOldTypeMetadata(node, container, decoratorExpressions);
	            }
	        }
	        function addOldTypeMetadata(node, container, decoratorExpressions) {
	            if (compilerOptions.emitDecoratorMetadata) {
	                if (shouldAddTypeMetadata(node)) {
	                    decoratorExpressions.push(createMetadataHelper(context, "design:type", serializeTypeOfNode(node)));
	                }
	                if (shouldAddParamTypesMetadata(node)) {
	                    decoratorExpressions.push(createMetadataHelper(context, "design:paramtypes", serializeParameterTypesOfNode(node, container)));
	                }
	                if (shouldAddReturnTypeMetadata(node)) {
	                    decoratorExpressions.push(createMetadataHelper(context, "design:returntype", serializeReturnTypeOfNode(node)));
	                }
	            }
	        }
	        function addNewTypeMetadata(node, container, decoratorExpressions) {
	            if (compilerOptions.emitDecoratorMetadata) {
	                var properties = void 0;
	                if (shouldAddTypeMetadata(node)) {
	                    (properties || (properties = [])).push(ts.createPropertyAssignment("type", ts.createArrowFunction(/*modifiers*/ undefined, /*typeParameters*/ undefined, [], /*type*/ undefined, ts.createToken(36 /* EqualsGreaterThanToken */), serializeTypeOfNode(node))));
	                }
	                if (shouldAddParamTypesMetadata(node)) {
	                    (properties || (properties = [])).push(ts.createPropertyAssignment("paramTypes", ts.createArrowFunction(/*modifiers*/ undefined, /*typeParameters*/ undefined, [], /*type*/ undefined, ts.createToken(36 /* EqualsGreaterThanToken */), serializeParameterTypesOfNode(node, container))));
	                }
	                if (shouldAddReturnTypeMetadata(node)) {
	                    (properties || (properties = [])).push(ts.createPropertyAssignment("returnType", ts.createArrowFunction(/*modifiers*/ undefined, /*typeParameters*/ undefined, [], /*type*/ undefined, ts.createToken(36 /* EqualsGreaterThanToken */), serializeReturnTypeOfNode(node))));
	                }
	                if (properties) {
	                    decoratorExpressions.push(createMetadataHelper(context, "design:typeinfo", ts.createObjectLiteral(properties, /*multiLine*/ true)));
	                }
	            }
	        }
	        /**
	         * Determines whether to emit the "design:type" metadata based on the node's kind.
	         * The caller should have already tested whether the node has decorators and whether the
	         * emitDecoratorMetadata compiler option is set.
	         *
	         * @param node The node to test.
	         */
	        function shouldAddTypeMetadata(node) {
	            var kind = node.kind;
	            return kind === 153 /* MethodDeclaration */
	                || kind === 155 /* GetAccessor */
	                || kind === 156 /* SetAccessor */
	                || kind === 151 /* PropertyDeclaration */;
	        }
	        /**
	         * Determines whether to emit the "design:returntype" metadata based on the node's kind.
	         * The caller should have already tested whether the node has decorators and whether the
	         * emitDecoratorMetadata compiler option is set.
	         *
	         * @param node The node to test.
	         */
	        function shouldAddReturnTypeMetadata(node) {
	            return node.kind === 153 /* MethodDeclaration */;
	        }
	        /**
	         * Determines whether to emit the "design:paramtypes" metadata based on the node's kind.
	         * The caller should have already tested whether the node has decorators and whether the
	         * emitDecoratorMetadata compiler option is set.
	         *
	         * @param node The node to test.
	         */
	        function shouldAddParamTypesMetadata(node) {
	            switch (node.kind) {
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                    return ts.getFirstConstructorWithBody(node) !== undefined;
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return true;
	            }
	            return false;
	        }
	        /**
	         * Serializes the type of a node for use with decorator type metadata.
	         *
	         * @param node The node that should have its type serialized.
	         */
	        function serializeTypeOfNode(node) {
	            switch (node.kind) {
	                case 151 /* PropertyDeclaration */:
	                case 148 /* Parameter */:
	                case 155 /* GetAccessor */:
	                    return serializeTypeNode(node.type);
	                case 156 /* SetAccessor */:
	                    return serializeTypeNode(ts.getSetAccessorTypeAnnotationNode(node));
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                case 153 /* MethodDeclaration */:
	                    return ts.createIdentifier("Function");
	                default:
	                    return ts.createVoidZero();
	            }
	        }
	        /**
	         * Serializes the types of the parameters of a node for use with decorator type metadata.
	         *
	         * @param node The node that should have its parameter types serialized.
	         */
	        function serializeParameterTypesOfNode(node, container) {
	            var valueDeclaration = ts.isClassLike(node)
	                ? ts.getFirstConstructorWithBody(node)
	                : ts.isFunctionLike(node) && ts.nodeIsPresent(node.body)
	                    ? node
	                    : undefined;
	            var expressions = [];
	            if (valueDeclaration) {
	                var parameters = getParametersOfDecoratedDeclaration(valueDeclaration, container);
	                var numParameters = parameters.length;
	                for (var i = 0; i < numParameters; i++) {
	                    var parameter = parameters[i];
	                    if (i === 0 && ts.isIdentifier(parameter.name) && parameter.name.escapedText === "this") {
	                        continue;
	                    }
	                    if (parameter.dotDotDotToken) {
	                        expressions.push(serializeTypeNode(ts.getRestParameterElementType(parameter.type)));
	                    }
	                    else {
	                        expressions.push(serializeTypeOfNode(parameter));
	                    }
	                }
	            }
	            return ts.createArrayLiteral(expressions);
	        }
	        function getParametersOfDecoratedDeclaration(node, container) {
	            if (container && node.kind === 155 /* GetAccessor */) {
	                var setAccessor = ts.getAllAccessorDeclarations(container.members, node).setAccessor;
	                if (setAccessor) {
	                    return setAccessor.parameters;
	                }
	            }
	            return node.parameters;
	        }
	        /**
	         * Serializes the return type of a node for use with decorator type metadata.
	         *
	         * @param node The node that should have its return type serialized.
	         */
	        function serializeReturnTypeOfNode(node) {
	            if (ts.isFunctionLike(node) && node.type) {
	                return serializeTypeNode(node.type);
	            }
	            else if (ts.isAsyncFunction(node)) {
	                return ts.createIdentifier("Promise");
	            }
	            return ts.createVoidZero();
	        }
	        /**
	         * Serializes a type node for use with decorator type metadata.
	         *
	         * Types are serialized in the following fashion:
	         * - Void types point to "undefined" (e.g. "void 0")
	         * - Function and Constructor types point to the global "Function" constructor.
	         * - Interface types with a call or construct signature types point to the global
	         *   "Function" constructor.
	         * - Array and Tuple types point to the global "Array" constructor.
	         * - Type predicates and booleans point to the global "Boolean" constructor.
	         * - String literal types and strings point to the global "String" constructor.
	         * - Enum and number types point to the global "Number" constructor.
	         * - Symbol types point to the global "Symbol" constructor.
	         * - Type references to classes (or class-like variables) point to the constructor for the class.
	         * - Anything else points to the global "Object" constructor.
	         *
	         * @param node The type node to serialize.
	         */
	        function serializeTypeNode(node) {
	            if (node === undefined) {
	                return ts.createIdentifier("Object");
	            }
	            switch (node.kind) {
	                case 105 /* VoidKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 95 /* NullKeyword */:
	                case 131 /* NeverKeyword */:
	                    return ts.createVoidZero();
	                case 172 /* ParenthesizedType */:
	                    return serializeTypeNode(node.type);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                    return ts.createIdentifier("Function");
	                case 166 /* ArrayType */:
	                case 167 /* TupleType */:
	                    return ts.createIdentifier("Array");
	                case 160 /* TypePredicate */:
	                case 122 /* BooleanKeyword */:
	                    return ts.createIdentifier("Boolean");
	                case 137 /* StringKeyword */:
	                    return ts.createIdentifier("String");
	                case 135 /* ObjectKeyword */:
	                    return ts.createIdentifier("Object");
	                case 177 /* LiteralType */:
	                    switch (node.literal.kind) {
	                        case 9 /* StringLiteral */:
	                            return ts.createIdentifier("String");
	                        case 8 /* NumericLiteral */:
	                            return ts.createIdentifier("Number");
	                        case 101 /* TrueKeyword */:
	                        case 86 /* FalseKeyword */:
	                            return ts.createIdentifier("Boolean");
	                        default:
	                            ts.Debug.failBadSyntaxKind(node.literal);
	                            break;
	                    }
	                    break;
	                case 134 /* NumberKeyword */:
	                    return ts.createIdentifier("Number");
	                case 138 /* SymbolKeyword */:
	                    return languageVersion < 2 /* ES2015 */
	                        ? getGlobalSymbolNameWithFallback()
	                        : ts.createIdentifier("Symbol");
	                case 161 /* TypeReference */:
	                    return serializeTypeReferenceNode(node);
	                case 169 /* IntersectionType */:
	                case 168 /* UnionType */:
	                    return serializeUnionOrIntersectionType(node);
	                case 164 /* TypeQuery */:
	                case 174 /* TypeOperator */:
	                case 175 /* IndexedAccessType */:
	                case 176 /* MappedType */:
	                case 165 /* TypeLiteral */:
	                case 119 /* AnyKeyword */:
	                case 173 /* ThisType */:
	                    break;
	                default:
	                    ts.Debug.failBadSyntaxKind(node);
	                    break;
	            }
	            return ts.createIdentifier("Object");
	        }
	        function serializeUnionOrIntersectionType(node) {
	            // Note when updating logic here also update getEntityNameForDecoratorMetadata
	            // so that aliases can be marked as referenced
	            var serializedUnion;
	            for (var _i = 0, _a = node.types; _i < _a.length; _i++) {
	                var typeNode = _a[_i];
	                while (typeNode.kind === 172 /* ParenthesizedType */) {
	                    typeNode = typeNode.type; // Skip parens if need be
	                }
	                if (typeNode.kind === 131 /* NeverKeyword */) {
	                    continue; // Always elide `never` from the union/intersection if possible
	                }
	                if (!strictNullChecks && (typeNode.kind === 95 /* NullKeyword */ || typeNode.kind === 140 /* UndefinedKeyword */)) {
	                    continue; // Elide null and undefined from unions for metadata, just like what we did prior to the implementation of strict null checks
	                }
	                var serializedIndividual = serializeTypeNode(typeNode);
	                if (ts.isIdentifier(serializedIndividual) && serializedIndividual.escapedText === "Object") {
	                    // One of the individual is global object, return immediately
	                    return serializedIndividual;
	                }
	                else if (serializedUnion) {
	                    // Different types
	                    if (!ts.isIdentifier(serializedUnion) ||
	                        !ts.isIdentifier(serializedIndividual) ||
	                        serializedUnion.escapedText !== serializedIndividual.escapedText) {
	                        return ts.createIdentifier("Object");
	                    }
	                }
	                else {
	                    // Initialize the union type
	                    serializedUnion = serializedIndividual;
	                }
	            }
	            // If we were able to find common type, use it
	            return serializedUnion || ts.createVoidZero(); // Fallback is only hit if all union constituients are null/undefined/never
	        }
	        /**
	         * Serializes a TypeReferenceNode to an appropriate JS constructor value for use with
	         * decorator type metadata.
	         *
	         * @param node The type reference node.
	         */
	        function serializeTypeReferenceNode(node) {
	            switch (resolver.getTypeReferenceSerializationKind(node.typeName, currentScope)) {
	                case ts.TypeReferenceSerializationKind.Unknown:
	                    var serialized = serializeEntityNameAsExpression(node.typeName, /*useFallback*/ true);
	                    var temp = ts.createTempVariable(hoistVariableDeclaration);
	                    return ts.createLogicalOr(ts.createLogicalAnd(ts.createTypeCheck(ts.createAssignment(temp, serialized), "function"), temp), ts.createIdentifier("Object"));
	                case ts.TypeReferenceSerializationKind.TypeWithConstructSignatureAndValue:
	                    return serializeEntityNameAsExpression(node.typeName, /*useFallback*/ false);
	                case ts.TypeReferenceSerializationKind.VoidNullableOrNeverType:
	                    return ts.createVoidZero();
	                case ts.TypeReferenceSerializationKind.BooleanType:
	                    return ts.createIdentifier("Boolean");
	                case ts.TypeReferenceSerializationKind.NumberLikeType:
	                    return ts.createIdentifier("Number");
	                case ts.TypeReferenceSerializationKind.StringLikeType:
	                    return ts.createIdentifier("String");
	                case ts.TypeReferenceSerializationKind.ArrayLikeType:
	                    return ts.createIdentifier("Array");
	                case ts.TypeReferenceSerializationKind.ESSymbolType:
	                    return languageVersion < 2 /* ES2015 */
	                        ? getGlobalSymbolNameWithFallback()
	                        : ts.createIdentifier("Symbol");
	                case ts.TypeReferenceSerializationKind.TypeWithCallSignature:
	                    return ts.createIdentifier("Function");
	                case ts.TypeReferenceSerializationKind.Promise:
	                    return ts.createIdentifier("Promise");
	                case ts.TypeReferenceSerializationKind.ObjectType:
	                default:
	                    return ts.createIdentifier("Object");
	            }
	        }
	        /**
	         * Serializes an entity name as an expression for decorator type metadata.
	         *
	         * @param node The entity name to serialize.
	         * @param useFallback A value indicating whether to use logical operators to test for the
	         *                    entity name at runtime.
	         */
	        function serializeEntityNameAsExpression(node, useFallback) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    // Create a clone of the name with a new parent, and treat it as if it were
	                    // a source tree node for the purposes of the checker.
	                    var name = ts.getMutableClone(node);
	                    name.flags &= ~8 /* Synthesized */;
	                    name.original = undefined;
	                    name.parent = ts.getParseTreeNode(currentScope); // ensure the parent is set to a parse tree node.
	                    if (useFallback) {
	                        return ts.createLogicalAnd(ts.createStrictInequality(ts.createTypeOf(name), ts.createLiteral("undefined")), name);
	                    }
	                    return name;
	                case 145 /* QualifiedName */:
	                    return serializeQualifiedNameAsExpression(node, useFallback);
	            }
	        }
	        /**
	         * Serializes an qualified name as an expression for decorator type metadata.
	         *
	         * @param node The qualified name to serialize.
	         * @param useFallback A value indicating whether to use logical operators to test for the
	         *                    qualified name at runtime.
	         */
	        function serializeQualifiedNameAsExpression(node, useFallback) {
	            var left;
	            if (node.left.kind === 71 /* Identifier */) {
	                left = serializeEntityNameAsExpression(node.left, useFallback);
	            }
	            else if (useFallback) {
	                var temp = ts.createTempVariable(hoistVariableDeclaration);
	                left = ts.createLogicalAnd(ts.createAssignment(temp, serializeEntityNameAsExpression(node.left, /*useFallback*/ true)), temp);
	            }
	            else {
	                left = serializeEntityNameAsExpression(node.left, /*useFallback*/ false);
	            }
	            return ts.createPropertyAccess(left, node.right);
	        }
	        /**
	         * Gets an expression that points to the global "Symbol" constructor at runtime if it is
	         * available.
	         */
	        function getGlobalSymbolNameWithFallback() {
	            return ts.createConditional(ts.createTypeCheck(ts.createIdentifier("Symbol"), "function"), ts.createIdentifier("Symbol"), ts.createIdentifier("Object"));
	        }
	        /**
	         * A simple inlinable expression is an expression which can be copied into multiple locations
	         * without risk of repeating any sideeffects and whose value could not possibly change between
	         * any such locations
	         */
	        function isSimpleInlineableExpression(expression) {
	            return !ts.isIdentifier(expression) && ts.isSimpleCopiableExpression(expression) ||
	                ts.isWellKnownSymbolSyntactically(expression);
	        }
	        /**
	         * Gets an expression that represents a property name. For a computed property, a
	         * name is generated for the node.
	         *
	         * @param member The member whose name should be converted into an expression.
	         */
	        function getExpressionForPropertyName(member, generateNameForComputedPropertyName) {
	            var name = member.name;
	            if (ts.isComputedPropertyName(name)) {
	                return generateNameForComputedPropertyName && !isSimpleInlineableExpression(name.expression)
	                    ? ts.getGeneratedNameForNode(name)
	                    : name.expression;
	            }
	            else if (ts.isIdentifier(name)) {
	                return ts.createLiteral(ts.idText(name));
	            }
	            else {
	                return ts.getSynthesizedClone(name);
	            }
	        }
	        /**
	         * If the name is a computed property, this function transforms it, then either returns an expression which caches the
	         * value of the result or the expression itself if the value is either unused or safe to inline into multiple locations
	         * @param shouldHoist Does the expression need to be reused? (ie, for an initializer or a decorator)
	         * @param omitSimple Should expressions with no observable side-effects be elided? (ie, the expression is not hoisted for a decorator or initializer and is a literal)
	         */
	        function getPropertyNameExpressionIfNeeded(name, shouldHoist, omitSimple) {
	            if (ts.isComputedPropertyName(name)) {
	                var expression = ts.visitNode(name.expression, visitor, ts.isExpression);
	                var innerExpression = ts.skipPartiallyEmittedExpressions(expression);
	                var inlinable = isSimpleInlineableExpression(innerExpression);
	                if (!inlinable && shouldHoist) {
	                    var generatedName = ts.getGeneratedNameForNode(name);
	                    hoistVariableDeclaration(generatedName);
	                    return ts.createAssignment(generatedName, expression);
	                }
	                return (omitSimple && (inlinable || ts.isIdentifier(innerExpression))) ? undefined : expression;
	            }
	        }
	        /**
	         * Visits the property name of a class element, for use when emitting property
	         * initializers. For a computed property on a node with decorators, a temporary
	         * value is stored for later use.
	         *
	         * @param member The member whose name should be visited.
	         */
	        function visitPropertyNameOfClassElement(member) {
	            var name = member.name;
	            var expr = getPropertyNameExpressionIfNeeded(name, ts.some(member.decorators), /*omitSimple*/ false);
	            if (expr) {
	                // Inline any pending expressions from previous elided or relocated computed property name expressions in order to preserve execution order
	                if (ts.some(pendingExpressions)) {
	                    expr = ts.inlineExpressions(pendingExpressions.concat([expr]));
	                    pendingExpressions.length = 0;
	                }
	                return ts.updateComputedPropertyName(name, expr);
	            }
	            else {
	                return name;
	            }
	        }
	        /**
	         * Transforms a HeritageClause with TypeScript syntax.
	         *
	         * This function will only be called when one of the following conditions are met:
	         * - The node is a non-`extends` heritage clause that should be elided.
	         * - The node is an `extends` heritage clause that should be visited, but only allow a single type.
	         *
	         * @param node The HeritageClause to transform.
	         */
	        function visitHeritageClause(node) {
	            if (node.token === 85 /* ExtendsKeyword */) {
	                var types = ts.visitNodes(node.types, visitor, ts.isExpressionWithTypeArguments, 0, 1);
	                return ts.setTextRange(ts.createHeritageClause(85 /* ExtendsKeyword */, types), node);
	            }
	            return undefined;
	        }
	        /**
	         * Transforms an ExpressionWithTypeArguments with TypeScript syntax.
	         *
	         * This function will only be called when one of the following conditions are met:
	         * - The node contains type arguments that should be elided.
	         *
	         * @param node The ExpressionWithTypeArguments to transform.
	         */
	        function visitExpressionWithTypeArguments(node) {
	            return ts.updateExpressionWithTypeArguments(node, 
	            /*typeArguments*/ undefined, ts.visitNode(node.expression, visitor, ts.isLeftHandSideExpression));
	        }
	        /**
	         * Determines whether to emit a function-like declaration. We should not emit the
	         * declaration if it does not have a body.
	         *
	         * @param node The declaration node.
	         */
	        function shouldEmitFunctionLikeDeclaration(node) {
	            return !ts.nodeIsMissing(node.body);
	        }
	        function visitPropertyDeclaration(node) {
	            var expr = getPropertyNameExpressionIfNeeded(node.name, ts.some(node.decorators) || !!node.initializer, /*omitSimple*/ true);
	            if (expr && !isSimpleInlineableExpression(expr)) {
	                (pendingExpressions || (pendingExpressions = [])).push(expr);
	            }
	            return undefined;
	        }
	        function visitConstructor(node) {
	            if (!shouldEmitFunctionLikeDeclaration(node)) {
	                return undefined;
	            }
	            return ts.updateConstructor(node, ts.visitNodes(node.decorators, visitor, ts.isDecorator), ts.visitNodes(node.modifiers, visitor, ts.isModifier), ts.visitParameterList(node.parameters, visitor, context), ts.visitFunctionBody(node.body, visitor, context));
	        }
	        /**
	         * Visits a method declaration of a class.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is an overload
	         * - The node is marked as abstract, public, private, protected, or readonly
	         * - The node has a computed property name
	         *
	         * @param node The method node.
	         */
	        function visitMethodDeclaration(node) {
	            if (!shouldEmitFunctionLikeDeclaration(node)) {
	                return undefined;
	            }
	            var updated = ts.updateMethod(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, visitPropertyNameOfClassElement(node), 
	            /*questionToken*/ undefined, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.visitFunctionBody(node.body, visitor, context));
	            if (updated !== node) {
	                // While we emit the source map for the node after skipping decorators and modifiers,
	                // we need to emit the comments for the original range.
	                ts.setCommentRange(updated, node);
	                ts.setSourceMapRange(updated, ts.moveRangePastDecorators(node));
	            }
	            return updated;
	        }
	        /**
	         * Determines whether to emit an accessor declaration. We should not emit the
	         * declaration if it does not have a body and is abstract.
	         *
	         * @param node The declaration node.
	         */
	        function shouldEmitAccessorDeclaration(node) {
	            return !(ts.nodeIsMissing(node.body) && ts.hasModifier(node, 128 /* Abstract */));
	        }
	        /**
	         * Visits a get accessor declaration of a class.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked as abstract, public, private, or protected
	         * - The node has a computed property name
	         *
	         * @param node The get accessor node.
	         */
	        function visitGetAccessor(node) {
	            if (!shouldEmitAccessorDeclaration(node)) {
	                return undefined;
	            }
	            var updated = ts.updateGetAccessor(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), visitPropertyNameOfClassElement(node), ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.visitFunctionBody(node.body, visitor, context) || ts.createBlock([]));
	            if (updated !== node) {
	                // While we emit the source map for the node after skipping decorators and modifiers,
	                // we need to emit the comments for the original range.
	                ts.setCommentRange(updated, node);
	                ts.setSourceMapRange(updated, ts.moveRangePastDecorators(node));
	            }
	            return updated;
	        }
	        /**
	         * Visits a set accessor declaration of a class.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked as abstract, public, private, or protected
	         * - The node has a computed property name
	         *
	         * @param node The set accessor node.
	         */
	        function visitSetAccessor(node) {
	            if (!shouldEmitAccessorDeclaration(node)) {
	                return undefined;
	            }
	            var updated = ts.updateSetAccessor(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), visitPropertyNameOfClassElement(node), ts.visitParameterList(node.parameters, visitor, context), ts.visitFunctionBody(node.body, visitor, context) || ts.createBlock([]));
	            if (updated !== node) {
	                // While we emit the source map for the node after skipping decorators and modifiers,
	                // we need to emit the comments for the original range.
	                ts.setCommentRange(updated, node);
	                ts.setSourceMapRange(updated, ts.moveRangePastDecorators(node));
	            }
	            return updated;
	        }
	        /**
	         * Visits a function declaration.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is an overload
	         * - The node is exported from a TypeScript namespace
	         * - The node has decorators
	         *
	         * @param node The function node.
	         */
	        function visitFunctionDeclaration(node) {
	            if (!shouldEmitFunctionLikeDeclaration(node)) {
	                return ts.createNotEmittedStatement(node);
	            }
	            var updated = ts.updateFunctionDeclaration(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.visitFunctionBody(node.body, visitor, context) || ts.createBlock([]));
	            if (isExportOfNamespace(node)) {
	                var statements = [updated];
	                addExportMemberAssignment(statements, node);
	                return statements;
	            }
	            return updated;
	        }
	        /**
	         * Visits a function expression node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node has type annotations
	         *
	         * @param node The function expression node.
	         */
	        function visitFunctionExpression(node) {
	            if (!shouldEmitFunctionLikeDeclaration(node)) {
	                return ts.createOmittedExpression();
	            }
	            var updated = ts.updateFunctionExpression(node, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.visitFunctionBody(node.body, visitor, context) || ts.createBlock([]));
	            return updated;
	        }
	        /**
	         * @remarks
	         * This function will be called when one of the following conditions are met:
	         * - The node has type annotations
	         */
	        function visitArrowFunction(node) {
	            var updated = ts.updateArrowFunction(node, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, node.equalsGreaterThanToken, ts.visitFunctionBody(node.body, visitor, context));
	            return updated;
	        }
	        /**
	         * Visits a parameter declaration node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node has an accessibility modifier.
	         * - The node has a questionToken.
	         * - The node's kind is ThisKeyword.
	         *
	         * @param node The parameter declaration node.
	         */
	        function visitParameter(node) {
	            if (ts.parameterIsThisKeyword(node)) {
	                return undefined;
	            }
	            var parameter = ts.createParameter(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, node.dotDotDotToken, ts.visitNode(node.name, visitor, ts.isBindingName), 
	            /*questionToken*/ undefined, 
	            /*type*/ undefined, ts.visitNode(node.initializer, visitor, ts.isExpression));
	            // While we emit the source map for the node after skipping decorators and modifiers,
	            // we need to emit the comments for the original range.
	            ts.setOriginalNode(parameter, node);
	            ts.setTextRange(parameter, ts.moveRangePastModifiers(node));
	            ts.setCommentRange(parameter, node);
	            ts.setSourceMapRange(parameter, ts.moveRangePastModifiers(node));
	            ts.setEmitFlags(parameter.name, 32 /* NoTrailingSourceMap */);
	            return parameter;
	        }
	        /**
	         * Visits a variable statement in a namespace.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is exported from a TypeScript namespace.
	         */
	        function visitVariableStatement(node) {
	            if (isExportOfNamespace(node)) {
	                var variables = ts.getInitializedVariables(node.declarationList);
	                if (variables.length === 0) {
	                    // elide statement if there are no initialized variables.
	                    return undefined;
	                }
	                return ts.setTextRange(ts.createStatement(ts.inlineExpressions(ts.map(variables, transformInitializedVariable))), node);
	            }
	            else {
	                return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function transformInitializedVariable(node) {
	            var name = node.name;
	            if (ts.isBindingPattern(name)) {
	                return ts.flattenDestructuringAssignment(node, visitor, context, 0 /* All */, 
	                /*needsValue*/ false, createNamespaceExportExpression);
	            }
	            else {
	                return ts.setTextRange(ts.createAssignment(getNamespaceMemberNameWithSourceMapsAndWithoutComments(name), ts.visitNode(node.initializer, visitor, ts.isExpression)), 
	                /*location*/ node);
	            }
	        }
	        function visitVariableDeclaration(node) {
	            return ts.updateVariableDeclaration(node, ts.visitNode(node.name, visitor, ts.isBindingName), 
	            /*type*/ undefined, ts.visitNode(node.initializer, visitor, ts.isExpression));
	        }
	        /**
	         * Visits a parenthesized expression that contains either a type assertion or an `as`
	         * expression.
	         *
	         * @param node The parenthesized expression node.
	         */
	        function visitParenthesizedExpression(node) {
	            var innerExpression = ts.skipOuterExpressions(node.expression, ~2 /* Assertions */);
	            if (ts.isAssertionExpression(innerExpression)) {
	                // Make sure we consider all nested cast expressions, e.g.:
	                // (<any><number><any>-A).x;
	                var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	                // We have an expression of the form: (<Type>SubExpr). Emitting this as (SubExpr)
	                // is really not desirable. We would like to emit the subexpression as-is. Omitting
	                // the parentheses, however, could cause change in the semantics of the generated
	                // code if the casted expression has a lower precedence than the rest of the
	                // expression.
	                //
	                // To preserve comments, we return a "PartiallyEmittedExpression" here which will
	                // preserve the position information of the original expression.
	                //
	                // Due to the auto-parenthesization rules used by the visitor and factory functions
	                // we can safely elide the parentheses here, as a new synthetic
	                // ParenthesizedExpression will be inserted if we remove parentheses too
	                // aggressively.
	                return ts.createPartiallyEmittedExpression(expression, node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitAssertionExpression(node) {
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            return ts.createPartiallyEmittedExpression(expression, node);
	        }
	        function visitNonNullExpression(node) {
	            var expression = ts.visitNode(node.expression, visitor, ts.isLeftHandSideExpression);
	            return ts.createPartiallyEmittedExpression(expression, node);
	        }
	        function visitCallExpression(node) {
	            return ts.updateCall(node, ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*typeArguments*/ undefined, ts.visitNodes(node.arguments, visitor, ts.isExpression));
	        }
	        function visitNewExpression(node) {
	            return ts.updateNew(node, ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*typeArguments*/ undefined, ts.visitNodes(node.arguments, visitor, ts.isExpression));
	        }
	        /**
	         * Determines whether to emit an enum declaration.
	         *
	         * @param node The enum declaration node.
	         */
	        function shouldEmitEnumDeclaration(node) {
	            return !ts.isConst(node)
	                || compilerOptions.preserveConstEnums
	                || compilerOptions.isolatedModules;
	        }
	        /**
	         * Visits an enum declaration.
	         *
	         * This function will be called any time a TypeScript enum is encountered.
	         *
	         * @param node The enum declaration node.
	         */
	        function visitEnumDeclaration(node) {
	            if (!shouldEmitEnumDeclaration(node)) {
	                return undefined;
	            }
	            var statements = [];
	            // We request to be advised when the printer is about to print this node. This allows
	            // us to set up the correct state for later substitutions.
	            var emitFlags = 2 /* AdviseOnEmitNode */;
	            // If needed, we should emit a variable declaration for the enum. If we emit
	            // a leading variable declaration, we should not emit leading comments for the
	            // enum body.
	            if (addVarForEnumOrModuleDeclaration(statements, node)) {
	                // We should still emit the comments if we are emitting a system module.
	                if (moduleKind !== ts.ModuleKind.System || currentScope !== currentSourceFile) {
	                    emitFlags |= 512 /* NoLeadingComments */;
	                }
	            }
	            // `parameterName` is the declaration name used inside of the enum.
	            var parameterName = getNamespaceParameterName(node);
	            // `containerName` is the expression used inside of the enum for assignments.
	            var containerName = getNamespaceContainerName(node);
	            // `exportName` is the expression used within this node's container for any exported references.
	            var exportName = ts.hasModifier(node, 1 /* Export */)
	                ? ts.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true)
	                : ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	            //  x || (x = {})
	            //  exports.x || (exports.x = {})
	            var moduleArg = ts.createLogicalOr(exportName, ts.createAssignment(exportName, ts.createObjectLiteral()));
	            if (hasNamespaceQualifiedExportName(node)) {
	                // `localName` is the expression used within this node's containing scope for any local references.
	                var localName = ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	                //  x = (exports.x || (exports.x = {}))
	                moduleArg = ts.createAssignment(localName, moduleArg);
	            }
	            //  (function (x) {
	            //      x[x["y"] = 0] = "y";
	            //      ...
	            //  })(x || (x = {}));
	            var enumStatement = ts.createStatement(ts.createCall(ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, parameterName)], 
	            /*type*/ undefined, transformEnumBody(node, containerName)), 
	            /*typeArguments*/ undefined, [moduleArg]));
	            ts.setOriginalNode(enumStatement, node);
	            ts.setTextRange(enumStatement, node);
	            ts.setEmitFlags(enumStatement, emitFlags);
	            statements.push(enumStatement);
	            // Add a DeclarationMarker for the enum to preserve trailing comments and mark
	            // the end of the declaration.
	            statements.push(ts.createEndOfDeclarationMarker(node));
	            return statements;
	        }
	        /**
	         * Transforms the body of an enum declaration.
	         *
	         * @param node The enum declaration node.
	         */
	        function transformEnumBody(node, localName) {
	            var savedCurrentNamespaceLocalName = currentNamespaceContainerName;
	            currentNamespaceContainerName = localName;
	            var statements = [];
	            startLexicalEnvironment();
	            ts.addRange(statements, ts.map(node.members, transformEnumMember));
	            ts.addRange(statements, endLexicalEnvironment());
	            currentNamespaceContainerName = savedCurrentNamespaceLocalName;
	            return ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), /*location*/ node.members), 
	            /*multiLine*/ true);
	        }
	        /**
	         * Transforms an enum member into a statement.
	         *
	         * @param member The enum member node.
	         */
	        function transformEnumMember(member) {
	            // enums don't support computed properties
	            // we pass false as 'generateNameForComputedPropertyName' for a backward compatibility purposes
	            // old emitter always generate 'expression' part of the name as-is.
	            var name = getExpressionForPropertyName(member, /*generateNameForComputedPropertyName*/ false);
	            var valueExpression = transformEnumMemberDeclarationValue(member);
	            var innerAssignment = ts.createAssignment(ts.createElementAccess(currentNamespaceContainerName, name), valueExpression);
	            var outerAssignment = valueExpression.kind === 9 /* StringLiteral */ ?
	                innerAssignment :
	                ts.createAssignment(ts.createElementAccess(currentNamespaceContainerName, innerAssignment), name);
	            return ts.setTextRange(ts.createStatement(ts.setTextRange(outerAssignment, member)), member);
	        }
	        /**
	         * Transforms the value of an enum member.
	         *
	         * @param member The enum member node.
	         */
	        function transformEnumMemberDeclarationValue(member) {
	            var value = resolver.getConstantValue(member);
	            if (value !== undefined) {
	                return ts.createLiteral(value);
	            }
	            else {
	                enableSubstitutionForNonQualifiedEnumMembers();
	                if (member.initializer) {
	                    return ts.visitNode(member.initializer, visitor, ts.isExpression);
	                }
	                else {
	                    return ts.createVoidZero();
	                }
	            }
	        }
	        /**
	         * Determines whether to elide a module declaration.
	         *
	         * @param node The module declaration node.
	         */
	        function shouldEmitModuleDeclaration(node) {
	            return ts.isInstantiatedModule(node, compilerOptions.preserveConstEnums || compilerOptions.isolatedModules);
	        }
	        /**
	         * Determines whether an exported declaration will have a qualified export name (e.g. `f.x`
	         * or `exports.x`).
	         */
	        function hasNamespaceQualifiedExportName(node) {
	            return isExportOfNamespace(node)
	                || (isExternalModuleExport(node)
	                    && moduleKind !== ts.ModuleKind.ES2015
	                    && moduleKind !== ts.ModuleKind.ESNext
	                    && moduleKind !== ts.ModuleKind.System);
	        }
	        /**
	         * Records that a declaration was emitted in the current scope, if it was the first
	         * declaration for the provided symbol.
	         */
	        function recordEmittedDeclarationInScope(node) {
	            if (!currentScopeFirstDeclarationsOfName) {
	                currentScopeFirstDeclarationsOfName = ts.createUnderscoreEscapedMap();
	            }
	            var name = declaredNameInScope(node);
	            if (!currentScopeFirstDeclarationsOfName.has(name)) {
	                currentScopeFirstDeclarationsOfName.set(name, node);
	            }
	        }
	        /**
	         * Determines whether a declaration is the first declaration with
	         * the same name emitted in the current scope.
	         */
	        function isFirstEmittedDeclarationInScope(node) {
	            if (currentScopeFirstDeclarationsOfName) {
	                var name = declaredNameInScope(node);
	                return currentScopeFirstDeclarationsOfName.get(name) === node;
	            }
	            return true;
	        }
	        function declaredNameInScope(node) {
	            ts.Debug.assertNode(node.name, ts.isIdentifier);
	            return node.name.escapedText;
	        }
	        /**
	         * Adds a leading VariableStatement for a enum or module declaration.
	         */
	        function addVarForEnumOrModuleDeclaration(statements, node) {
	            // Emit a variable statement for the module. We emit top-level enums as a `var`
	            // declaration to avoid static errors in global scripts scripts due to redeclaration.
	            // enums in any other scope are emitted as a `let` declaration.
	            var statement = ts.createVariableStatement(ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true))
	            ], currentScope.kind === 272 /* SourceFile */ ? 0 /* None */ : 1 /* Let */));
	            ts.setOriginalNode(statement, node);
	            recordEmittedDeclarationInScope(node);
	            if (isFirstEmittedDeclarationInScope(node)) {
	                // Adjust the source map emit to match the old emitter.
	                if (node.kind === 236 /* EnumDeclaration */) {
	                    ts.setSourceMapRange(statement.declarationList, node);
	                }
	                else {
	                    ts.setSourceMapRange(statement, node);
	                }
	                // Trailing comments for module declaration should be emitted after the function closure
	                // instead of the variable statement:
	                //
	                //     /** Module comment*/
	                //     module m1 {
	                //         function foo4Export() {
	                //         }
	                //     } // trailing comment module
	                //
	                // Should emit:
	                //
	                //     /** Module comment*/
	                //     var m1;
	                //     (function (m1) {
	                //         function foo4Export() {
	                //         }
	                //     })(m1 || (m1 = {})); // trailing comment module
	                //
	                ts.setCommentRange(statement, node);
	                ts.setEmitFlags(statement, 1024 /* NoTrailingComments */ | 4194304 /* HasEndOfDeclarationMarker */);
	                statements.push(statement);
	                return true;
	            }
	            else {
	                // For an EnumDeclaration or ModuleDeclaration that merges with a preceeding
	                // declaration we do not emit a leading variable declaration. To preserve the
	                // begin/end semantics of the declararation and to properly handle exports
	                // we wrap the leading variable declaration in a `MergeDeclarationMarker`.
	                var mergeMarker = ts.createMergeDeclarationMarker(statement);
	                ts.setEmitFlags(mergeMarker, 1536 /* NoComments */ | 4194304 /* HasEndOfDeclarationMarker */);
	                statements.push(mergeMarker);
	                return false;
	            }
	        }
	        /**
	         * Visits a module declaration node.
	         *
	         * This function will be called any time a TypeScript namespace (ModuleDeclaration) is encountered.
	         *
	         * @param node The module declaration node.
	         */
	        function visitModuleDeclaration(node) {
	            if (!shouldEmitModuleDeclaration(node)) {
	                return ts.createNotEmittedStatement(node);
	            }
	            ts.Debug.assertNode(node.name, ts.isIdentifier, "A TypeScript namespace should have an Identifier name.");
	            enableSubstitutionForNamespaceExports();
	            var statements = [];
	            // We request to be advised when the printer is about to print this node. This allows
	            // us to set up the correct state for later substitutions.
	            var emitFlags = 2 /* AdviseOnEmitNode */;
	            // If needed, we should emit a variable declaration for the module. If we emit
	            // a leading variable declaration, we should not emit leading comments for the
	            // module body.
	            if (addVarForEnumOrModuleDeclaration(statements, node)) {
	                // We should still emit the comments if we are emitting a system module.
	                if (moduleKind !== ts.ModuleKind.System || currentScope !== currentSourceFile) {
	                    emitFlags |= 512 /* NoLeadingComments */;
	                }
	            }
	            // `parameterName` is the declaration name used inside of the namespace.
	            var parameterName = getNamespaceParameterName(node);
	            // `containerName` is the expression used inside of the namespace for exports.
	            var containerName = getNamespaceContainerName(node);
	            // `exportName` is the expression used within this node's container for any exported references.
	            var exportName = ts.hasModifier(node, 1 /* Export */)
	                ? ts.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true)
	                : ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	            //  x || (x = {})
	            //  exports.x || (exports.x = {})
	            var moduleArg = ts.createLogicalOr(exportName, ts.createAssignment(exportName, ts.createObjectLiteral()));
	            if (hasNamespaceQualifiedExportName(node)) {
	                // `localName` is the expression used within this node's containing scope for any local references.
	                var localName = ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	                //  x = (exports.x || (exports.x = {}))
	                moduleArg = ts.createAssignment(localName, moduleArg);
	            }
	            //  (function (x_1) {
	            //      x_1.y = ...;
	            //  })(x || (x = {}));
	            var moduleStatement = ts.createStatement(ts.createCall(ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, parameterName)], 
	            /*type*/ undefined, transformModuleBody(node, containerName)), 
	            /*typeArguments*/ undefined, [moduleArg]));
	            ts.setOriginalNode(moduleStatement, node);
	            ts.setTextRange(moduleStatement, node);
	            ts.setEmitFlags(moduleStatement, emitFlags);
	            statements.push(moduleStatement);
	            // Add a DeclarationMarker for the namespace to preserve trailing comments and mark
	            // the end of the declaration.
	            statements.push(ts.createEndOfDeclarationMarker(node));
	            return statements;
	        }
	        /**
	         * Transforms the body of a module declaration.
	         *
	         * @param node The module declaration node.
	         */
	        function transformModuleBody(node, namespaceLocalName) {
	            var savedCurrentNamespaceContainerName = currentNamespaceContainerName;
	            var savedCurrentNamespace = currentNamespace;
	            var savedCurrentScopeFirstDeclarationsOfName = currentScopeFirstDeclarationsOfName;
	            currentNamespaceContainerName = namespaceLocalName;
	            currentNamespace = node;
	            currentScopeFirstDeclarationsOfName = undefined;
	            var statements = [];
	            startLexicalEnvironment();
	            var statementsLocation;
	            var blockLocation;
	            var body = node.body;
	            if (body.kind === 238 /* ModuleBlock */) {
	                saveStateAndInvoke(body, function (body) { return ts.addRange(statements, ts.visitNodes(body.statements, namespaceElementVisitor, ts.isStatement)); });
	                statementsLocation = body.statements;
	                blockLocation = body;
	            }
	            else {
	                var result = visitModuleDeclaration(body);
	                if (result) {
	                    if (ts.isArray(result)) {
	                        ts.addRange(statements, result);
	                    }
	                    else {
	                        statements.push(result);
	                    }
	                }
	                var moduleBlock = getInnerMostModuleDeclarationFromDottedModule(node).body;
	                statementsLocation = ts.moveRangePos(moduleBlock.statements, -1);
	            }
	            ts.addRange(statements, endLexicalEnvironment());
	            currentNamespaceContainerName = savedCurrentNamespaceContainerName;
	            currentNamespace = savedCurrentNamespace;
	            currentScopeFirstDeclarationsOfName = savedCurrentScopeFirstDeclarationsOfName;
	            var block = ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), 
	            /*location*/ statementsLocation), 
	            /*multiLine*/ true);
	            ts.setTextRange(block, blockLocation);
	            // namespace hello.hi.world {
	            //      function foo() {}
	            //
	            //      // TODO, blah
	            // }
	            //
	            // should be emitted as
	            //
	            // var hello;
	            // (function (hello) {
	            //     var hi;
	            //     (function (hi) {
	            //         var world;
	            //         (function (world) {
	            //             function foo() { }
	            //             // TODO, blah
	            //         })(world = hi.world || (hi.world = {}));
	            //     })(hi = hello.hi || (hello.hi = {}));
	            // })(hello || (hello = {}));
	            // We only want to emit comment on the namespace which contains block body itself, not the containing namespaces.
	            if (body.kind !== 238 /* ModuleBlock */) {
	                ts.setEmitFlags(block, ts.getEmitFlags(block) | 1536 /* NoComments */);
	            }
	            return block;
	        }
	        function getInnerMostModuleDeclarationFromDottedModule(moduleDeclaration) {
	            if (moduleDeclaration.body.kind === 237 /* ModuleDeclaration */) {
	                var recursiveInnerModule = getInnerMostModuleDeclarationFromDottedModule(moduleDeclaration.body);
	                return recursiveInnerModule || moduleDeclaration.body;
	            }
	        }
	        /**
	         * Visits an import declaration, eliding it if it is not referenced.
	         *
	         * @param node The import declaration node.
	         */
	        function visitImportDeclaration(node) {
	            if (!node.importClause) {
	                // Do not elide a side-effect only import declaration.
	                //  import "foo";
	                return node;
	            }
	            // Elide the declaration if the import clause was elided.
	            var importClause = ts.visitNode(node.importClause, visitImportClause, ts.isImportClause);
	            return importClause
	                ? ts.updateImportDeclaration(node, 
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, importClause, node.moduleSpecifier)
	                : undefined;
	        }
	        /**
	         * Visits an import clause, eliding it if it is not referenced.
	         *
	         * @param node The import clause node.
	         */
	        function visitImportClause(node) {
	            // Elide the import clause if we elide both its name and its named bindings.
	            var name = resolver.isReferencedAliasDeclaration(node) ? node.name : undefined;
	            var namedBindings = ts.visitNode(node.namedBindings, visitNamedImportBindings, ts.isNamedImportBindings);
	            return (name || namedBindings) ? ts.updateImportClause(node, name, namedBindings) : undefined;
	        }
	        /**
	         * Visits named import bindings, eliding it if it is not referenced.
	         *
	         * @param node The named import bindings node.
	         */
	        function visitNamedImportBindings(node) {
	            if (node.kind === 244 /* NamespaceImport */) {
	                // Elide a namespace import if it is not referenced.
	                return resolver.isReferencedAliasDeclaration(node) ? node : undefined;
	            }
	            else {
	                // Elide named imports if all of its import specifiers are elided.
	                var elements = ts.visitNodes(node.elements, visitImportSpecifier, ts.isImportSpecifier);
	                return ts.some(elements) ? ts.updateNamedImports(node, elements) : undefined;
	            }
	        }
	        /**
	         * Visits an import specifier, eliding it if it is not referenced.
	         *
	         * @param node The import specifier node.
	         */
	        function visitImportSpecifier(node) {
	            // Elide an import specifier if it is not referenced.
	            return resolver.isReferencedAliasDeclaration(node) ? node : undefined;
	        }
	        /**
	         * Visits an export assignment, eliding it if it does not contain a clause that resolves
	         * to a value.
	         *
	         * @param node The export assignment node.
	         */
	        function visitExportAssignment(node) {
	            // Elide the export assignment if it does not reference a value.
	            return resolver.isValueAliasDeclaration(node)
	                ? ts.visitEachChild(node, visitor, context)
	                : undefined;
	        }
	        /**
	         * Visits an export declaration, eliding it if it does not contain a clause that resolves
	         * to a value.
	         *
	         * @param node The export declaration node.
	         */
	        function visitExportDeclaration(node) {
	            if (!node.exportClause) {
	                // Elide a star export if the module it references does not export a value.
	                return compilerOptions.isolatedModules || resolver.moduleExportsSomeValue(node.moduleSpecifier) ? node : undefined;
	            }
	            if (!resolver.isValueAliasDeclaration(node)) {
	                // Elide the export declaration if it does not export a value.
	                return undefined;
	            }
	            // Elide the export declaration if all of its named exports are elided.
	            var exportClause = ts.visitNode(node.exportClause, visitNamedExports, ts.isNamedExports);
	            return exportClause
	                ? ts.updateExportDeclaration(node, 
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, exportClause, node.moduleSpecifier)
	                : undefined;
	        }
	        /**
	         * Visits named exports, eliding it if it does not contain an export specifier that
	         * resolves to a value.
	         *
	         * @param node The named exports node.
	         */
	        function visitNamedExports(node) {
	            // Elide the named exports if all of its export specifiers were elided.
	            var elements = ts.visitNodes(node.elements, visitExportSpecifier, ts.isExportSpecifier);
	            return ts.some(elements) ? ts.updateNamedExports(node, elements) : undefined;
	        }
	        /**
	         * Visits an export specifier, eliding it if it does not resolve to a value.
	         *
	         * @param node The export specifier node.
	         */
	        function visitExportSpecifier(node) {
	            // Elide an export specifier if it does not reference a value.
	            return resolver.isValueAliasDeclaration(node) ? node : undefined;
	        }
	        /**
	         * Determines whether to emit an import equals declaration.
	         *
	         * @param node The import equals declaration node.
	         */
	        function shouldEmitImportEqualsDeclaration(node) {
	            // preserve old compiler's behavior: emit 'var' for import declaration (even if we do not consider them referenced) when
	            // - current file is not external module
	            // - import declaration is top level and target is value imported by entity name
	            return resolver.isReferencedAliasDeclaration(node)
	                || (!ts.isExternalModule(currentSourceFile)
	                    && resolver.isTopLevelValueImportEqualsWithEntityName(node));
	        }
	        /**
	         * Visits an import equals declaration.
	         *
	         * @param node The import equals declaration node.
	         */
	        function visitImportEqualsDeclaration(node) {
	            if (ts.isExternalModuleImportEqualsDeclaration(node)) {
	                // Elide external module `import=` if it is not referenced.
	                return resolver.isReferencedAliasDeclaration(node)
	                    ? ts.visitEachChild(node, visitor, context)
	                    : undefined;
	            }
	            if (!shouldEmitImportEqualsDeclaration(node)) {
	                return undefined;
	            }
	            var moduleReference = ts.createExpressionFromEntityName(node.moduleReference);
	            ts.setEmitFlags(moduleReference, 1536 /* NoComments */ | 2048 /* NoNestedComments */);
	            if (isNamedExternalModuleExport(node) || !isExportOfNamespace(node)) {
	                //  export var ${name} = ${moduleReference};
	                //  var ${name} = ${moduleReference};
	                return ts.setOriginalNode(ts.setTextRange(ts.createVariableStatement(ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), ts.createVariableDeclarationList([
	                    ts.setOriginalNode(ts.createVariableDeclaration(node.name, 
	                    /*type*/ undefined, moduleReference), node)
	                ])), node), node);
	            }
	            else {
	                // exports.${name} = ${moduleReference};
	                return ts.setOriginalNode(createNamespaceExport(node.name, moduleReference, node), node);
	            }
	        }
	        /**
	         * Gets a value indicating whether the node is exported from a namespace.
	         *
	         * @param node The node to test.
	         */
	        function isExportOfNamespace(node) {
	            return currentNamespace !== undefined && ts.hasModifier(node, 1 /* Export */);
	        }
	        /**
	         * Gets a value indicating whether the node is exported from an external module.
	         *
	         * @param node The node to test.
	         */
	        function isExternalModuleExport(node) {
	            return currentNamespace === undefined && ts.hasModifier(node, 1 /* Export */);
	        }
	        /**
	         * Gets a value indicating whether the node is a named export from an external module.
	         *
	         * @param node The node to test.
	         */
	        function isNamedExternalModuleExport(node) {
	            return isExternalModuleExport(node)
	                && !ts.hasModifier(node, 512 /* Default */);
	        }
	        /**
	         * Gets a value indicating whether the node is the default export of an external module.
	         *
	         * @param node The node to test.
	         */
	        function isDefaultExternalModuleExport(node) {
	            return isExternalModuleExport(node)
	                && ts.hasModifier(node, 512 /* Default */);
	        }
	        /**
	         * Creates a statement for the provided expression. This is used in calls to `map`.
	         */
	        function expressionToStatement(expression) {
	            return ts.createStatement(expression);
	        }
	        function addExportMemberAssignment(statements, node) {
	            var expression = ts.createAssignment(ts.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true), ts.getLocalName(node));
	            ts.setSourceMapRange(expression, ts.createRange(node.name ? node.name.pos : node.pos, node.end));
	            var statement = ts.createStatement(expression);
	            ts.setSourceMapRange(statement, ts.createRange(-1, node.end));
	            statements.push(statement);
	        }
	        function createNamespaceExport(exportName, exportValue, location) {
	            return ts.setTextRange(ts.createStatement(ts.createAssignment(ts.getNamespaceMemberName(currentNamespaceContainerName, exportName, /*allowComments*/ false, /*allowSourceMaps*/ true), exportValue)), location);
	        }
	        function createNamespaceExportExpression(exportName, exportValue, location) {
	            return ts.setTextRange(ts.createAssignment(getNamespaceMemberNameWithSourceMapsAndWithoutComments(exportName), exportValue), location);
	        }
	        function getNamespaceMemberNameWithSourceMapsAndWithoutComments(name) {
	            return ts.getNamespaceMemberName(currentNamespaceContainerName, name, /*allowComments*/ false, /*allowSourceMaps*/ true);
	        }
	        /**
	         * Gets the declaration name used inside of a namespace or enum.
	         */
	        function getNamespaceParameterName(node) {
	            var name = ts.getGeneratedNameForNode(node);
	            ts.setSourceMapRange(name, node.name);
	            return name;
	        }
	        /**
	         * Gets the expression used to refer to a namespace or enum within the body
	         * of its declaration.
	         */
	        function getNamespaceContainerName(node) {
	            return ts.getGeneratedNameForNode(node);
	        }
	        /**
	         * Gets a local alias for a class declaration if it is a decorated class with an internal
	         * reference to the static side of the class. This is necessary to avoid issues with
	         * double-binding semantics for the class name.
	         */
	        function getClassAliasIfNeeded(node) {
	            if (resolver.getNodeCheckFlags(node) & 8388608 /* ClassWithConstructorReference */) {
	                enableSubstitutionForClassAliases();
	                var classAlias = ts.createUniqueName(node.name && !ts.isGeneratedIdentifier(node.name) ? ts.idText(node.name) : "default");
	                classAliases[ts.getOriginalNodeId(node)] = classAlias;
	                hoistVariableDeclaration(classAlias);
	                return classAlias;
	            }
	        }
	        function getClassPrototype(node) {
	            return ts.createPropertyAccess(ts.getDeclarationName(node), "prototype");
	        }
	        function getClassMemberPrefix(node, member) {
	            return ts.hasModifier(member, 32 /* Static */)
	                ? ts.getDeclarationName(node)
	                : getClassPrototype(node);
	        }
	        function enableSubstitutionForNonQualifiedEnumMembers() {
	            if ((enabledSubstitutions & 8 /* NonQualifiedEnumMembers */) === 0) {
	                enabledSubstitutions |= 8 /* NonQualifiedEnumMembers */;
	                context.enableSubstitution(71 /* Identifier */);
	            }
	        }
	        function enableSubstitutionForClassAliases() {
	            if ((enabledSubstitutions & 1 /* ClassAliases */) === 0) {
	                enabledSubstitutions |= 1 /* ClassAliases */;
	                // We need to enable substitutions for identifiers. This allows us to
	                // substitute class names inside of a class declaration.
	                context.enableSubstitution(71 /* Identifier */);
	                // Keep track of class aliases.
	                classAliases = [];
	            }
	        }
	        function enableSubstitutionForNamespaceExports() {
	            if ((enabledSubstitutions & 2 /* NamespaceExports */) === 0) {
	                enabledSubstitutions |= 2 /* NamespaceExports */;
	                // We need to enable substitutions for identifiers and shorthand property assignments. This allows us to
	                // substitute the names of exported members of a namespace.
	                context.enableSubstitution(71 /* Identifier */);
	                context.enableSubstitution(269 /* ShorthandPropertyAssignment */);
	                // We need to be notified when entering and exiting namespaces.
	                context.enableEmitNotification(237 /* ModuleDeclaration */);
	            }
	        }
	        function isTransformedModuleDeclaration(node) {
	            return ts.getOriginalNode(node).kind === 237 /* ModuleDeclaration */;
	        }
	        function isTransformedEnumDeclaration(node) {
	            return ts.getOriginalNode(node).kind === 236 /* EnumDeclaration */;
	        }
	        /**
	         * Hook for node emit.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emit A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            var savedApplicableSubstitutions = applicableSubstitutions;
	            var savedCurrentSourceFile = currentSourceFile;
	            if (ts.isSourceFile(node)) {
	                currentSourceFile = node;
	            }
	            if (enabledSubstitutions & 2 /* NamespaceExports */ && isTransformedModuleDeclaration(node)) {
	                applicableSubstitutions |= 2 /* NamespaceExports */;
	            }
	            if (enabledSubstitutions & 8 /* NonQualifiedEnumMembers */ && isTransformedEnumDeclaration(node)) {
	                applicableSubstitutions |= 8 /* NonQualifiedEnumMembers */;
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	            applicableSubstitutions = savedApplicableSubstitutions;
	            currentSourceFile = savedCurrentSourceFile;
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            else if (ts.isShorthandPropertyAssignment(node)) {
	                return substituteShorthandPropertyAssignment(node);
	            }
	            return node;
	        }
	        function substituteShorthandPropertyAssignment(node) {
	            if (enabledSubstitutions & 2 /* NamespaceExports */) {
	                var name = node.name;
	                var exportedName = trySubstituteNamespaceExportedName(name);
	                if (exportedName) {
	                    // A shorthand property with an assignment initializer is probably part of a
	                    // destructuring assignment
	                    if (node.objectAssignmentInitializer) {
	                        var initializer = ts.createAssignment(exportedName, node.objectAssignmentInitializer);
	                        return ts.setTextRange(ts.createPropertyAssignment(name, initializer), node);
	                    }
	                    return ts.setTextRange(ts.createPropertyAssignment(name, exportedName), node);
	                }
	            }
	            return node;
	        }
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return substituteExpressionIdentifier(node);
	                case 183 /* PropertyAccessExpression */:
	                    return substitutePropertyAccessExpression(node);
	                case 184 /* ElementAccessExpression */:
	                    return substituteElementAccessExpression(node);
	            }
	            return node;
	        }
	        function substituteExpressionIdentifier(node) {
	            return trySubstituteClassAlias(node)
	                || trySubstituteNamespaceExportedName(node)
	                || node;
	        }
	        function trySubstituteClassAlias(node) {
	            if (enabledSubstitutions & 1 /* ClassAliases */) {
	                if (resolver.getNodeCheckFlags(node) & 16777216 /* ConstructorReferenceInClass */) {
	                    // Due to the emit for class decorators, any reference to the class from inside of the class body
	                    // must instead be rewritten to point to a temporary variable to avoid issues with the double-bind
	                    // behavior of class names in ES6.
	                    // Also, when emitting statics for class expressions, we must substitute a class alias for
	                    // constructor references in static property initializers.
	                    var declaration = resolver.getReferencedValueDeclaration(node);
	                    if (declaration) {
	                        var classAlias = classAliases[declaration.id];
	                        if (classAlias) {
	                            var clone_1 = ts.getSynthesizedClone(classAlias);
	                            ts.setSourceMapRange(clone_1, node);
	                            ts.setCommentRange(clone_1, node);
	                            return clone_1;
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function trySubstituteNamespaceExportedName(node) {
	            // If this is explicitly a local name, do not substitute.
	            if (enabledSubstitutions & applicableSubstitutions && !ts.isGeneratedIdentifier(node) && !ts.isLocalName(node)) {
	                // If we are nested within a namespace declaration, we may need to qualifiy
	                // an identifier that is exported from a merged namespace.
	                var container = resolver.getReferencedExportContainer(node, /*prefixLocals*/ false);
	                if (container && container.kind !== 272 /* SourceFile */) {
	                    var substitute = (applicableSubstitutions & 2 /* NamespaceExports */ && container.kind === 237 /* ModuleDeclaration */) ||
	                        (applicableSubstitutions & 8 /* NonQualifiedEnumMembers */ && container.kind === 236 /* EnumDeclaration */);
	                    if (substitute) {
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(container), node), 
	                        /*location*/ node);
	                    }
	                }
	            }
	            return undefined;
	        }
	        function substitutePropertyAccessExpression(node) {
	            return substituteConstantValue(node);
	        }
	        function substituteElementAccessExpression(node) {
	            return substituteConstantValue(node);
	        }
	        function substituteConstantValue(node) {
	            var constantValue = tryGetConstEnumValue(node);
	            if (constantValue !== undefined) {
	                // track the constant value on the node for the printer in needsDotDotForPropertyAccess
	                ts.setConstantValue(node, constantValue);
	                var substitute = ts.createLiteral(constantValue);
	                if (!compilerOptions.removeComments) {
	                    var propertyName = ts.isPropertyAccessExpression(node)
	                        ? ts.declarationNameToString(node.name)
	                        : ts.getTextOfNode(node.argumentExpression);
	                    ts.addSyntheticTrailingComment(substitute, 3 /* MultiLineCommentTrivia */, " " + propertyName + " ");
	                }
	                return substitute;
	            }
	            return node;
	        }
	        function tryGetConstEnumValue(node) {
	            if (compilerOptions.isolatedModules) {
	                return undefined;
	            }
	            return ts.isPropertyAccessExpression(node) || ts.isElementAccessExpression(node) ? resolver.getConstantValue(node) : undefined;
	        }
	    }
	    ts.transformTypeScript = transformTypeScript;
	    function createDecorateHelper(context, decoratorExpressions, target, memberName, descriptor, location) {
	        var argumentsArray = [];
	        argumentsArray.push(ts.createArrayLiteral(decoratorExpressions, /*multiLine*/ true));
	        argumentsArray.push(target);
	        if (memberName) {
	            argumentsArray.push(memberName);
	            if (descriptor) {
	                argumentsArray.push(descriptor);
	            }
	        }
	        context.requestEmitHelper(decorateHelper);
	        return ts.setTextRange(ts.createCall(ts.getHelperName("__decorate"), 
	        /*typeArguments*/ undefined, argumentsArray), location);
	    }
	    var decorateHelper = {
	        name: "typescript:decorate",
	        scoped: false,
	        priority: 2,
	        text: "\n            var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {\n                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;\n                if (typeof Reflect === \"object\" && typeof Reflect.decorate === \"function\") r = Reflect.decorate(decorators, target, key, desc);\n                else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;\n                return c > 3 && r && Object.defineProperty(target, key, r), r;\n            };"
	    };
	    function createMetadataHelper(context, metadataKey, metadataValue) {
	        context.requestEmitHelper(metadataHelper);
	        return ts.createCall(ts.getHelperName("__metadata"), 
	        /*typeArguments*/ undefined, [
	            ts.createLiteral(metadataKey),
	            metadataValue
	        ]);
	    }
	    var metadataHelper = {
	        name: "typescript:metadata",
	        scoped: false,
	        priority: 3,
	        text: "\n            var __metadata = (this && this.__metadata) || function (k, v) {\n                if (typeof Reflect === \"object\" && typeof Reflect.metadata === \"function\") return Reflect.metadata(k, v);\n            };"
	    };
	    function createParamHelper(context, expression, parameterOffset, location) {
	        context.requestEmitHelper(paramHelper);
	        return ts.setTextRange(ts.createCall(ts.getHelperName("__param"), 
	        /*typeArguments*/ undefined, [
	            ts.createLiteral(parameterOffset),
	            expression
	        ]), location);
	    }
	    var paramHelper = {
	        name: "typescript:param",
	        scoped: false,
	        priority: 4,
	        text: "\n            var __param = (this && this.__param) || function (paramIndex, decorator) {\n                return function (target, key) { decorator(target, key, paramIndex); }\n            };"
	    };
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    var ES2017SubstitutionFlags;
	    (function (ES2017SubstitutionFlags) {
	        /** Enables substitutions for async methods with `super` calls. */
	        ES2017SubstitutionFlags[ES2017SubstitutionFlags["AsyncMethodsWithSuper"] = 1] = "AsyncMethodsWithSuper";
	    })(ES2017SubstitutionFlags || (ES2017SubstitutionFlags = {}));
	    function transformES2017(context) {
	        var resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var resolver = context.getEmitResolver();
	        var compilerOptions = context.getCompilerOptions();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        /**
	         * Keeps track of whether expression substitution has been enabled for specific edge cases.
	         * They are persisted between each SourceFile transformation and should not be reset.
	         */
	        var enabledSubstitutions;
	        /**
	         * This keeps track of containers where `super` is valid, for use with
	         * just-in-time substitution for `super` expressions inside of async methods.
	         */
	        var enclosingSuperContainerFlags = 0;
	        var enclosingFunctionParameterNames;
	        // Save the previous transformation hooks.
	        var previousOnEmitNode = context.onEmitNode;
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        // Set new transformation hooks.
	        context.onEmitNode = onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        return transformSourceFile;
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            var visited = ts.visitEachChild(node, visitor, context);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            return visited;
	        }
	        function visitor(node) {
	            if ((node.transformFlags & 16 /* ContainsES2017 */) === 0) {
	                return node;
	            }
	            switch (node.kind) {
	                case 120 /* AsyncKeyword */:
	                    // ES2017 async modifier should be elided for targets < ES2017
	                    return undefined;
	                case 195 /* AwaitExpression */:
	                    return visitAwaitExpression(node);
	                case 153 /* MethodDeclaration */:
	                    return visitMethodDeclaration(node);
	                case 232 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 190 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                case 191 /* ArrowFunction */:
	                    return visitArrowFunction(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function asyncBodyVisitor(node) {
	            if (ts.isNodeWithPossibleHoistedDeclaration(node)) {
	                switch (node.kind) {
	                    case 212 /* VariableStatement */:
	                        return visitVariableStatementInAsyncBody(node);
	                    case 218 /* ForStatement */:
	                        return visitForStatementInAsyncBody(node);
	                    case 219 /* ForInStatement */:
	                        return visitForInStatementInAsyncBody(node);
	                    case 220 /* ForOfStatement */:
	                        return visitForOfStatementInAsyncBody(node);
	                    case 267 /* CatchClause */:
	                        return visitCatchClauseInAsyncBody(node);
	                    case 211 /* Block */:
	                    case 225 /* SwitchStatement */:
	                    case 239 /* CaseBlock */:
	                    case 264 /* CaseClause */:
	                    case 265 /* DefaultClause */:
	                    case 228 /* TryStatement */:
	                    case 216 /* DoStatement */:
	                    case 217 /* WhileStatement */:
	                    case 215 /* IfStatement */:
	                    case 224 /* WithStatement */:
	                    case 226 /* LabeledStatement */:
	                        return ts.visitEachChild(node, asyncBodyVisitor, context);
	                    default:
	                        return ts.Debug.assertNever(node, "Unhandled node.");
	                }
	            }
	            return visitor(node);
	        }
	        function visitCatchClauseInAsyncBody(node) {
	            var catchClauseNames = ts.createUnderscoreEscapedMap();
	            recordDeclarationName(node.variableDeclaration, catchClauseNames);
	            // names declared in a catch variable are block scoped
	            var catchClauseUnshadowedNames;
	            catchClauseNames.forEach(function (_, escapedName) {
	                if (enclosingFunctionParameterNames.has(escapedName)) {
	                    if (!catchClauseUnshadowedNames) {
	                        catchClauseUnshadowedNames = ts.cloneMap(enclosingFunctionParameterNames);
	                    }
	                    catchClauseUnshadowedNames.delete(escapedName);
	                }
	            });
	            if (catchClauseUnshadowedNames) {
	                var savedEnclosingFunctionParameterNames = enclosingFunctionParameterNames;
	                enclosingFunctionParameterNames = catchClauseUnshadowedNames;
	                var result = ts.visitEachChild(node, asyncBodyVisitor, context);
	                enclosingFunctionParameterNames = savedEnclosingFunctionParameterNames;
	                return result;
	            }
	            else {
	                return ts.visitEachChild(node, asyncBodyVisitor, context);
	            }
	        }
	        function visitVariableStatementInAsyncBody(node) {
	            if (isVariableDeclarationListWithCollidingName(node.declarationList)) {
	                var expression = visitVariableDeclarationListWithCollidingNames(node.declarationList, /*hasReceiver*/ false);
	                return expression ? ts.createStatement(expression) : undefined;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitForInStatementInAsyncBody(node) {
	            return ts.updateForIn(node, isVariableDeclarationListWithCollidingName(node.initializer)
	                ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ true)
	                : ts.visitNode(node.initializer, visitor, ts.isForInitializer), ts.visitNode(node.expression, visitor, ts.isExpression), ts.visitNode(node.statement, asyncBodyVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        function visitForOfStatementInAsyncBody(node) {
	            return ts.updateForOf(node, ts.visitNode(node.awaitModifier, visitor, ts.isToken), isVariableDeclarationListWithCollidingName(node.initializer)
	                ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ true)
	                : ts.visitNode(node.initializer, visitor, ts.isForInitializer), ts.visitNode(node.expression, visitor, ts.isExpression), ts.visitNode(node.statement, asyncBodyVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        function visitForStatementInAsyncBody(node) {
	            return ts.updateFor(node, isVariableDeclarationListWithCollidingName(node.initializer)
	                ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ false)
	                : ts.visitNode(node.initializer, visitor, ts.isForInitializer), ts.visitNode(node.condition, visitor, ts.isExpression), ts.visitNode(node.incrementor, visitor, ts.isExpression), ts.visitNode(node.statement, asyncBodyVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        /**
	         * Visits an AwaitExpression node.
	         *
	         * This function will be called any time a ES2017 await expression is encountered.
	         *
	         * @param node The node to visit.
	         */
	        function visitAwaitExpression(node) {
	            return ts.setOriginalNode(ts.setTextRange(ts.createYield(
	            /*asteriskToken*/ undefined, ts.visitNode(node.expression, visitor, ts.isExpression)), node), node);
	        }
	        /**
	         * Visits a MethodDeclaration node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked as async
	         *
	         * @param node The node to visit.
	         */
	        function visitMethodDeclaration(node) {
	            return ts.updateMethod(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, visitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*questionToken*/ undefined, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.getFunctionFlags(node) & 2 /* Async */
	                ? transformAsyncFunctionBody(node)
	                : ts.visitFunctionBody(node.body, visitor, context));
	        }
	        /**
	         * Visits a FunctionDeclaration node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked async
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionDeclaration(node) {
	            return ts.updateFunctionDeclaration(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, visitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.getFunctionFlags(node) & 2 /* Async */
	                ? transformAsyncFunctionBody(node)
	                : ts.visitFunctionBody(node.body, visitor, context));
	        }
	        /**
	         * Visits a FunctionExpression node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked async
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionExpression(node) {
	            return ts.updateFunctionExpression(node, ts.visitNodes(node.modifiers, visitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.getFunctionFlags(node) & 2 /* Async */
	                ? transformAsyncFunctionBody(node)
	                : ts.visitFunctionBody(node.body, visitor, context));
	        }
	        /**
	         * Visits an ArrowFunction.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked async
	         *
	         * @param node The node to visit.
	         */
	        function visitArrowFunction(node) {
	            return ts.updateArrowFunction(node, ts.visitNodes(node.modifiers, visitor, ts.isModifier), 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, node.equalsGreaterThanToken, ts.getFunctionFlags(node) & 2 /* Async */
	                ? transformAsyncFunctionBody(node)
	                : ts.visitFunctionBody(node.body, visitor, context));
	        }
	        function recordDeclarationName(_a, names) {
	            var name = _a.name;
	            if (ts.isIdentifier(name)) {
	                names.set(name.escapedText, true);
	            }
	            else {
	                for (var _i = 0, _b = name.elements; _i < _b.length; _i++) {
	                    var element = _b[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        recordDeclarationName(element, names);
	                    }
	                }
	            }
	        }
	        function isVariableDeclarationListWithCollidingName(node) {
	            return node
	                && ts.isVariableDeclarationList(node)
	                && !(node.flags & 3 /* BlockScoped */)
	                && ts.forEach(node.declarations, collidesWithParameterName);
	        }
	        function visitVariableDeclarationListWithCollidingNames(node, hasReceiver) {
	            hoistVariableDeclarationList(node);
	            var variables = ts.getInitializedVariables(node);
	            if (variables.length === 0) {
	                if (hasReceiver) {
	                    return ts.visitNode(ts.convertToAssignmentElementTarget(node.declarations[0].name), visitor, ts.isExpression);
	                }
	                return undefined;
	            }
	            return ts.inlineExpressions(ts.map(variables, transformInitializedVariable));
	        }
	        function hoistVariableDeclarationList(node) {
	            ts.forEach(node.declarations, hoistVariable);
	        }
	        function hoistVariable(_a) {
	            var name = _a.name;
	            if (ts.isIdentifier(name)) {
	                hoistVariableDeclaration(name);
	            }
	            else {
	                for (var _i = 0, _b = name.elements; _i < _b.length; _i++) {
	                    var element = _b[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        hoistVariable(element);
	                    }
	                }
	            }
	        }
	        function transformInitializedVariable(node) {
	            var converted = ts.setSourceMapRange(ts.createAssignment(ts.convertToAssignmentElementTarget(node.name), node.initializer), node);
	            return ts.visitNode(converted, visitor, ts.isExpression);
	        }
	        function collidesWithParameterName(_a) {
	            var name = _a.name;
	            if (ts.isIdentifier(name)) {
	                return enclosingFunctionParameterNames.has(name.escapedText);
	            }
	            else {
	                for (var _i = 0, _b = name.elements; _i < _b.length; _i++) {
	                    var element = _b[_i];
	                    if (!ts.isOmittedExpression(element) && collidesWithParameterName(element)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function transformAsyncFunctionBody(node) {
	            resumeLexicalEnvironment();
	            var original = ts.getOriginalNode(node, ts.isFunctionLike);
	            var nodeType = original.type;
	            var promiseConstructor = languageVersion < 2 /* ES2015 */ ? getPromiseConstructor(nodeType) : undefined;
	            var isArrowFunction = node.kind === 191 /* ArrowFunction */;
	            var hasLexicalArguments = (resolver.getNodeCheckFlags(node) & 8192 /* CaptureArguments */) !== 0;
	            // An async function is emit as an outer function that calls an inner
	            // generator function. To preserve lexical bindings, we pass the current
	            // `this` and `arguments` objects to `__awaiter`. The generator function
	            // passed to `__awaiter` is executed inside of the callback to the
	            // promise constructor.
	            var savedEnclosingFunctionParameterNames = enclosingFunctionParameterNames;
	            enclosingFunctionParameterNames = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, _a = node.parameters; _i < _a.length; _i++) {
	                var parameter = _a[_i];
	                recordDeclarationName(parameter, enclosingFunctionParameterNames);
	            }
	            var result;
	            if (!isArrowFunction) {
	                var statements = [];
	                var statementOffset = ts.addPrologue(statements, node.body.statements, /*ensureUseStrict*/ false, visitor);
	                statements.push(ts.createReturn(createAwaiterHelper(context, hasLexicalArguments, promiseConstructor, transformAsyncFunctionBodyWorker(node.body, statementOffset))));
	                ts.addRange(statements, endLexicalEnvironment());
	                var block = ts.createBlock(statements, /*multiLine*/ true);
	                ts.setTextRange(block, node.body);
	                // Minor optimization, emit `_super` helper to capture `super` access in an arrow.
	                // This step isn't needed if we eventually transform this to ES5.
	                if (languageVersion >= 2 /* ES2015 */) {
	                    if (resolver.getNodeCheckFlags(node) & 4096 /* AsyncMethodWithSuperBinding */) {
	                        enableSubstitutionForAsyncMethodsWithSuper();
	                        ts.addEmitHelper(block, ts.advancedAsyncSuperHelper);
	                    }
	                    else if (resolver.getNodeCheckFlags(node) & 2048 /* AsyncMethodWithSuper */) {
	                        enableSubstitutionForAsyncMethodsWithSuper();
	                        ts.addEmitHelper(block, ts.asyncSuperHelper);
	                    }
	                }
	                result = block;
	            }
	            else {
	                var expression = createAwaiterHelper(context, hasLexicalArguments, promiseConstructor, transformAsyncFunctionBodyWorker(node.body));
	                var declarations = endLexicalEnvironment();
	                if (ts.some(declarations)) {
	                    var block = ts.convertToFunctionBody(expression);
	                    result = ts.updateBlock(block, ts.setTextRange(ts.createNodeArray(ts.concatenate(block.statements, declarations)), block.statements));
	                }
	                else {
	                    result = expression;
	                }
	            }
	            enclosingFunctionParameterNames = savedEnclosingFunctionParameterNames;
	            return result;
	        }
	        function transformAsyncFunctionBodyWorker(body, start) {
	            if (ts.isBlock(body)) {
	                return ts.updateBlock(body, ts.visitNodes(body.statements, asyncBodyVisitor, ts.isStatement, start));
	            }
	            else {
	                return ts.convertToFunctionBody(ts.visitNode(body, asyncBodyVisitor, ts.isConciseBody));
	            }
	        }
	        function getPromiseConstructor(type) {
	            var typeName = type && ts.getEntityNameFromTypeNode(type);
	            if (typeName && ts.isEntityName(typeName)) {
	                var serializationKind = resolver.getTypeReferenceSerializationKind(typeName);
	                if (serializationKind === ts.TypeReferenceSerializationKind.TypeWithConstructSignatureAndValue
	                    || serializationKind === ts.TypeReferenceSerializationKind.Unknown) {
	                    return typeName;
	                }
	            }
	            return undefined;
	        }
	        function enableSubstitutionForAsyncMethodsWithSuper() {
	            if ((enabledSubstitutions & 1 /* AsyncMethodsWithSuper */) === 0) {
	                enabledSubstitutions |= 1 /* AsyncMethodsWithSuper */;
	                // We need to enable substitutions for call, property access, and element access
	                // if we need to rewrite super calls.
	                context.enableSubstitution(185 /* CallExpression */);
	                context.enableSubstitution(183 /* PropertyAccessExpression */);
	                context.enableSubstitution(184 /* ElementAccessExpression */);
	                // We need to be notified when entering and exiting declarations that bind super.
	                context.enableEmitNotification(233 /* ClassDeclaration */);
	                context.enableEmitNotification(153 /* MethodDeclaration */);
	                context.enableEmitNotification(155 /* GetAccessor */);
	                context.enableEmitNotification(156 /* SetAccessor */);
	                context.enableEmitNotification(154 /* Constructor */);
	            }
	        }
	        /**
	         * Hook for node emit.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emit A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            // If we need to support substitutions for `super` in an async method,
	            // we should track it here.
	            if (enabledSubstitutions & 1 /* AsyncMethodsWithSuper */ && isSuperContainer(node)) {
	                var superContainerFlags = resolver.getNodeCheckFlags(node) & (2048 /* AsyncMethodWithSuper */ | 4096 /* AsyncMethodWithSuperBinding */);
	                if (superContainerFlags !== enclosingSuperContainerFlags) {
	                    var savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
	                    enclosingSuperContainerFlags = superContainerFlags;
	                    previousOnEmitNode(hint, node, emitCallback);
	                    enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
	                    return;
	                }
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */ && enclosingSuperContainerFlags) {
	                return substituteExpression(node);
	            }
	            return node;
	        }
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 183 /* PropertyAccessExpression */:
	                    return substitutePropertyAccessExpression(node);
	                case 184 /* ElementAccessExpression */:
	                    return substituteElementAccessExpression(node);
	                case 185 /* CallExpression */:
	                    return substituteCallExpression(node);
	            }
	            return node;
	        }
	        function substitutePropertyAccessExpression(node) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return createSuperAccessInAsyncMethod(ts.createLiteral(ts.idText(node.name)), node);
	            }
	            return node;
	        }
	        function substituteElementAccessExpression(node) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return createSuperAccessInAsyncMethod(node.argumentExpression, node);
	            }
	            return node;
	        }
	        function substituteCallExpression(node) {
	            var expression = node.expression;
	            if (ts.isSuperProperty(expression)) {
	                var argumentExpression = ts.isPropertyAccessExpression(expression)
	                    ? substitutePropertyAccessExpression(expression)
	                    : substituteElementAccessExpression(expression);
	                return ts.createCall(ts.createPropertyAccess(argumentExpression, "call"), 
	                /*typeArguments*/ undefined, [
	                    ts.createThis()
	                ].concat(node.arguments));
	            }
	            return node;
	        }
	        function isSuperContainer(node) {
	            var kind = node.kind;
	            return kind === 233 /* ClassDeclaration */
	                || kind === 154 /* Constructor */
	                || kind === 153 /* MethodDeclaration */
	                || kind === 155 /* GetAccessor */
	                || kind === 156 /* SetAccessor */;
	        }
	        function createSuperAccessInAsyncMethod(argumentExpression, location) {
	            if (enclosingSuperContainerFlags & 4096 /* AsyncMethodWithSuperBinding */) {
	                return ts.setTextRange(ts.createPropertyAccess(ts.createCall(ts.createIdentifier("_super"), 
	                /*typeArguments*/ undefined, [argumentExpression]), "value"), location);
	            }
	            else {
	                return ts.setTextRange(ts.createCall(ts.createIdentifier("_super"), 
	                /*typeArguments*/ undefined, [argumentExpression]), location);
	            }
	        }
	    }
	    ts.transformES2017 = transformES2017;
	    var awaiterHelper = {
	        name: "typescript:awaiter",
	        scoped: false,
	        priority: 5,
	        text: "\n            var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {\n                return new (P || (P = Promise))(function (resolve, reject) {\n                    function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }\n                    function rejected(value) { try { step(generator[\"throw\"](value)); } catch (e) { reject(e); } }\n                    function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }\n                    step((generator = generator.apply(thisArg, _arguments || [])).next());\n                });\n            };"
	    };
	    function createAwaiterHelper(context, hasLexicalArguments, promiseConstructor, body) {
	        context.requestEmitHelper(awaiterHelper);
	        var generatorFunc = ts.createFunctionExpression(
	        /*modifiers*/ undefined, ts.createToken(39 /* AsteriskToken */), 
	        /*name*/ undefined, 
	        /*typeParameters*/ undefined, 
	        /*parameters*/ [], 
	        /*type*/ undefined, body);
	        // Mark this node as originally an async function
	        (generatorFunc.emitNode || (generatorFunc.emitNode = {})).flags |= 262144 /* AsyncFunctionBody */ | 524288 /* ReuseTempVariableScope */;
	        return ts.createCall(ts.getHelperName("__awaiter"), 
	        /*typeArguments*/ undefined, [
	            ts.createThis(),
	            hasLexicalArguments ? ts.createIdentifier("arguments") : ts.createVoidZero(),
	            promiseConstructor ? ts.createExpressionFromEntityName(promiseConstructor) : ts.createVoidZero(),
	            generatorFunc
	        ]);
	    }
	    ts.asyncSuperHelper = {
	        name: "typescript:async-super",
	        scoped: true,
	        text: "\n            const _super = name => super[name];\n        "
	    };
	    ts.advancedAsyncSuperHelper = {
	        name: "typescript:advanced-async-super",
	        scoped: true,
	        text: "\n            const _super = (function (geti, seti) {\n                const cache = Object.create(null);\n                return name => cache[name] || (cache[name] = { get value() { return geti(name); }, set value(v) { seti(name, v); } });\n            })(name => super[name], (name, value) => super[name] = value);\n        "
	    };
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	/// <reference path="es2017.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    var ESNextSubstitutionFlags;
	    (function (ESNextSubstitutionFlags) {
	        /** Enables substitutions for async methods with `super` calls. */
	        ESNextSubstitutionFlags[ESNextSubstitutionFlags["AsyncMethodsWithSuper"] = 1] = "AsyncMethodsWithSuper";
	    })(ESNextSubstitutionFlags || (ESNextSubstitutionFlags = {}));
	    function transformESNext(context) {
	        var resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var resolver = context.getEmitResolver();
	        var compilerOptions = context.getCompilerOptions();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var previousOnEmitNode = context.onEmitNode;
	        context.onEmitNode = onEmitNode;
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        context.onSubstituteNode = onSubstituteNode;
	        var enabledSubstitutions;
	        var enclosingFunctionFlags;
	        var enclosingSuperContainerFlags = 0;
	        return transformSourceFile;
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            var visited = ts.visitEachChild(node, visitor, context);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            return visited;
	        }
	        function visitor(node) {
	            return visitorWorker(node, /*noDestructuringValue*/ false);
	        }
	        function visitorNoDestructuringValue(node) {
	            return visitorWorker(node, /*noDestructuringValue*/ true);
	        }
	        function visitorNoAsyncModifier(node) {
	            if (node.kind === 120 /* AsyncKeyword */) {
	                return undefined;
	            }
	            return node;
	        }
	        function visitorWorker(node, noDestructuringValue) {
	            if ((node.transformFlags & 8 /* ContainsESNext */) === 0) {
	                return node;
	            }
	            switch (node.kind) {
	                case 195 /* AwaitExpression */:
	                    return visitAwaitExpression(node);
	                case 201 /* YieldExpression */:
	                    return visitYieldExpression(node);
	                case 226 /* LabeledStatement */:
	                    return visitLabeledStatement(node);
	                case 182 /* ObjectLiteralExpression */:
	                    return visitObjectLiteralExpression(node);
	                case 198 /* BinaryExpression */:
	                    return visitBinaryExpression(node, noDestructuringValue);
	                case 230 /* VariableDeclaration */:
	                    return visitVariableDeclaration(node);
	                case 220 /* ForOfStatement */:
	                    return visitForOfStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 218 /* ForStatement */:
	                    return visitForStatement(node);
	                case 194 /* VoidExpression */:
	                    return visitVoidExpression(node);
	                case 154 /* Constructor */:
	                    return visitConstructorDeclaration(node);
	                case 153 /* MethodDeclaration */:
	                    return visitMethodDeclaration(node);
	                case 155 /* GetAccessor */:
	                    return visitGetAccessorDeclaration(node);
	                case 156 /* SetAccessor */:
	                    return visitSetAccessorDeclaration(node);
	                case 232 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 190 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                case 191 /* ArrowFunction */:
	                    return visitArrowFunction(node);
	                case 148 /* Parameter */:
	                    return visitParameter(node);
	                case 214 /* ExpressionStatement */:
	                    return visitExpressionStatement(node);
	                case 189 /* ParenthesizedExpression */:
	                    return visitParenthesizedExpression(node, noDestructuringValue);
	                case 267 /* CatchClause */:
	                    return visitCatchClause(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitAwaitExpression(node) {
	            if (enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */) {
	                return ts.setOriginalNode(ts.setTextRange(ts.createYield(createAwaitHelper(context, ts.visitNode(node.expression, visitor, ts.isExpression))), 
	                /*location*/ node), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitYieldExpression(node) {
	            if (enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */ && node.asteriskToken) {
	                var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	                return ts.setOriginalNode(ts.setTextRange(ts.createYield(createAwaitHelper(context, ts.updateYield(node, node.asteriskToken, createAsyncDelegatorHelper(context, createAsyncValuesHelper(context, expression, expression), expression)))), node), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitLabeledStatement(node) {
	            if (enclosingFunctionFlags & 2 /* Async */) {
	                var statement = ts.unwrapInnermostStatementOfLabel(node);
	                if (statement.kind === 220 /* ForOfStatement */ && statement.awaitModifier) {
	                    return visitForOfStatement(statement, node);
	                }
	                return ts.restoreEnclosingLabel(ts.visitEachChild(statement, visitor, context), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function chunkObjectLiteralElements(elements) {
	            var chunkObject;
	            var objects = [];
	            for (var _i = 0, elements_4 = elements; _i < elements_4.length; _i++) {
	                var e = elements_4[_i];
	                if (e.kind === 270 /* SpreadAssignment */) {
	                    if (chunkObject) {
	                        objects.push(ts.createObjectLiteral(chunkObject));
	                        chunkObject = undefined;
	                    }
	                    var target = e.expression;
	                    objects.push(ts.visitNode(target, visitor, ts.isExpression));
	                }
	                else {
	                    chunkObject = ts.append(chunkObject, e.kind === 268 /* PropertyAssignment */
	                        ? ts.createPropertyAssignment(e.name, ts.visitNode(e.initializer, visitor, ts.isExpression))
	                        : ts.visitNode(e, visitor, ts.isObjectLiteralElementLike));
	                }
	            }
	            if (chunkObject) {
	                objects.push(ts.createObjectLiteral(chunkObject));
	            }
	            return objects;
	        }
	        function visitObjectLiteralExpression(node) {
	            if (node.transformFlags & 1048576 /* ContainsObjectSpread */) {
	                // spread elements emit like so:
	                // non-spread elements are chunked together into object literals, and then all are passed to __assign:
	                //     { a, ...o, b } => __assign({a}, o, {b});
	                // If the first element is a spread element, then the first argument to __assign is {}:
	                //     { ...o, a, b, ...o2 } => __assign({}, o, {a, b}, o2)
	                var objects = chunkObjectLiteralElements(node.properties);
	                if (objects.length && objects[0].kind !== 182 /* ObjectLiteralExpression */) {
	                    objects.unshift(ts.createObjectLiteral());
	                }
	                return createAssignHelper(context, objects);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitExpressionStatement(node) {
	            return ts.visitEachChild(node, visitorNoDestructuringValue, context);
	        }
	        function visitParenthesizedExpression(node, noDestructuringValue) {
	            return ts.visitEachChild(node, noDestructuringValue ? visitorNoDestructuringValue : visitor, context);
	        }
	        function visitCatchClause(node) {
	            if (!node.variableDeclaration) {
	                return ts.updateCatchClause(node, ts.createVariableDeclaration(ts.createTempVariable(/*recordTempVariable*/ undefined)), ts.visitNode(node.block, visitor, ts.isBlock));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a BinaryExpression that contains a destructuring assignment.
	         *
	         * @param node A BinaryExpression node.
	         */
	        function visitBinaryExpression(node, noDestructuringValue) {
	            if (ts.isDestructuringAssignment(node) && node.left.transformFlags & 1048576 /* ContainsObjectRest */) {
	                return ts.flattenDestructuringAssignment(node, visitor, context, 1 /* ObjectRest */, !noDestructuringValue);
	            }
	            else if (node.operatorToken.kind === 26 /* CommaToken */) {
	                return ts.updateBinary(node, ts.visitNode(node.left, visitorNoDestructuringValue, ts.isExpression), ts.visitNode(node.right, noDestructuringValue ? visitorNoDestructuringValue : visitor, ts.isExpression));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a VariableDeclaration node with a binding pattern.
	         *
	         * @param node A VariableDeclaration node.
	         */
	        function visitVariableDeclaration(node) {
	            // If we are here it is because the name contains a binding pattern with a rest somewhere in it.
	            if (ts.isBindingPattern(node.name) && node.name.transformFlags & 1048576 /* ContainsObjectRest */) {
	                return ts.flattenDestructuringBinding(node, visitor, context, 1 /* ObjectRest */);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitForStatement(node) {
	            return ts.updateFor(node, ts.visitNode(node.initializer, visitorNoDestructuringValue, ts.isForInitializer), ts.visitNode(node.condition, visitor, ts.isExpression), ts.visitNode(node.incrementor, visitor, ts.isExpression), ts.visitNode(node.statement, visitor, ts.isStatement));
	        }
	        function visitVoidExpression(node) {
	            return ts.visitEachChild(node, visitorNoDestructuringValue, context);
	        }
	        /**
	         * Visits a ForOfStatement and converts it into a ES2015-compatible ForOfStatement.
	         *
	         * @param node A ForOfStatement.
	         */
	        function visitForOfStatement(node, outermostLabeledStatement) {
	            if (node.initializer.transformFlags & 1048576 /* ContainsObjectRest */) {
	                node = transformForOfStatementWithObjectRest(node);
	            }
	            if (node.awaitModifier) {
	                return transformForAwaitOfStatement(node, outermostLabeledStatement);
	            }
	            else {
	                return ts.restoreEnclosingLabel(ts.visitEachChild(node, visitor, context), outermostLabeledStatement);
	            }
	        }
	        function transformForOfStatementWithObjectRest(node) {
	            var initializerWithoutParens = ts.skipParentheses(node.initializer);
	            if (ts.isVariableDeclarationList(initializerWithoutParens) || ts.isAssignmentPattern(initializerWithoutParens)) {
	                var bodyLocation = void 0;
	                var statementsLocation = void 0;
	                var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	                var statements = [ts.createForOfBindingStatement(initializerWithoutParens, temp)];
	                if (ts.isBlock(node.statement)) {
	                    ts.addRange(statements, node.statement.statements);
	                    bodyLocation = node.statement;
	                    statementsLocation = node.statement.statements;
	                }
	                return ts.updateForOf(node, node.awaitModifier, ts.setTextRange(ts.createVariableDeclarationList([
	                    ts.setTextRange(ts.createVariableDeclaration(temp), node.initializer)
	                ], 1 /* Let */), node.initializer), node.expression, ts.setTextRange(ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), statementsLocation), 
	                /*multiLine*/ true), bodyLocation));
	            }
	            return node;
	        }
	        function convertForOfStatementHead(node, boundValue) {
	            var binding = ts.createForOfBindingStatement(node.initializer, boundValue);
	            var bodyLocation;
	            var statementsLocation;
	            var statements = [ts.visitNode(binding, visitor, ts.isStatement)];
	            var statement = ts.visitNode(node.statement, visitor, ts.isStatement);
	            if (ts.isBlock(statement)) {
	                ts.addRange(statements, statement.statements);
	                bodyLocation = statement;
	                statementsLocation = statement.statements;
	            }
	            else {
	                statements.push(statement);
	            }
	            return ts.setEmitFlags(ts.setTextRange(ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), statementsLocation), 
	            /*multiLine*/ true), bodyLocation), 48 /* NoSourceMap */ | 384 /* NoTokenSourceMaps */);
	        }
	        function createDownlevelAwait(expression) {
	            return enclosingFunctionFlags & 1 /* Generator */
	                ? ts.createYield(/*asteriskToken*/ undefined, createAwaitHelper(context, expression))
	                : ts.createAwait(expression);
	        }
	        function transformForAwaitOfStatement(node, outermostLabeledStatement) {
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            var iterator = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(expression) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var result = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(iterator) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var errorRecord = ts.createUniqueName("e");
	            var catchVariable = ts.getGeneratedNameForNode(errorRecord);
	            var returnMethod = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var callValues = createAsyncValuesHelper(context, expression, /*location*/ node.expression);
	            var callNext = ts.createCall(ts.createPropertyAccess(iterator, "next"), /*typeArguments*/ undefined, []);
	            var getDone = ts.createPropertyAccess(result, "done");
	            var getValue = ts.createPropertyAccess(result, "value");
	            var callReturn = ts.createFunctionCall(returnMethod, iterator, []);
	            hoistVariableDeclaration(errorRecord);
	            hoistVariableDeclaration(returnMethod);
	            var forStatement = ts.setEmitFlags(ts.setTextRange(ts.createFor(
	            /*initializer*/ ts.setEmitFlags(ts.setTextRange(ts.createVariableDeclarationList([
	                ts.setTextRange(ts.createVariableDeclaration(iterator, /*type*/ undefined, callValues), node.expression),
	                ts.createVariableDeclaration(result)
	            ]), node.expression), 2097152 /* NoHoisting */), 
	            /*condition*/ ts.createComma(ts.createAssignment(result, createDownlevelAwait(callNext)), ts.createLogicalNot(getDone)), 
	            /*incrementor*/ undefined, 
	            /*statement*/ convertForOfStatementHead(node, createDownlevelAwait(getValue))), 
	            /*location*/ node), 256 /* NoTokenTrailingSourceMaps */);
	            return ts.createTry(ts.createBlock([
	                ts.restoreEnclosingLabel(forStatement, outermostLabeledStatement)
	            ]), ts.createCatchClause(ts.createVariableDeclaration(catchVariable), ts.setEmitFlags(ts.createBlock([
	                ts.createStatement(ts.createAssignment(errorRecord, ts.createObjectLiteral([
	                    ts.createPropertyAssignment("error", catchVariable)
	                ])))
	            ]), 1 /* SingleLine */)), ts.createBlock([
	                ts.createTry(
	                /*tryBlock*/ ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(ts.createLogicalAnd(ts.createLogicalAnd(result, ts.createLogicalNot(getDone)), ts.createAssignment(returnMethod, ts.createPropertyAccess(iterator, "return"))), ts.createStatement(createDownlevelAwait(callReturn))), 1 /* SingleLine */)
	                ]), 
	                /*catchClause*/ undefined, 
	                /*finallyBlock*/ ts.setEmitFlags(ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(errorRecord, ts.createThrow(ts.createPropertyAccess(errorRecord, "error"))), 1 /* SingleLine */)
	                ]), 1 /* SingleLine */))
	            ]));
	        }
	        function visitParameter(node) {
	            if (node.transformFlags & 1048576 /* ContainsObjectRest */) {
	                // Binding patterns are converted into a generated name and are
	                // evaluated inside the function body.
	                return ts.updateParameter(node, 
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, node.dotDotDotToken, ts.getGeneratedNameForNode(node), 
	                /*questionToken*/ undefined, 
	                /*type*/ undefined, ts.visitNode(node.initializer, visitor, ts.isExpression));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitConstructorDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = 0 /* Normal */;
	            var updated = ts.updateConstructor(node, 
	            /*decorators*/ undefined, node.modifiers, ts.visitParameterList(node.parameters, visitor, context), transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitGetAccessorDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = 0 /* Normal */;
	            var updated = ts.updateGetAccessor(node, 
	            /*decorators*/ undefined, node.modifiers, ts.visitNode(node.name, visitor, ts.isPropertyName), ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitSetAccessorDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = 0 /* Normal */;
	            var updated = ts.updateSetAccessor(node, 
	            /*decorators*/ undefined, node.modifiers, ts.visitNode(node.name, visitor, ts.isPropertyName), ts.visitParameterList(node.parameters, visitor, context), transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitMethodDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = ts.getFunctionFlags(node);
	            var updated = ts.updateMethod(node, 
	            /*decorators*/ undefined, enclosingFunctionFlags & 1 /* Generator */
	                ? ts.visitNodes(node.modifiers, visitorNoAsyncModifier, ts.isModifier)
	                : node.modifiers, enclosingFunctionFlags & 2 /* Async */
	                ? undefined
	                : node.asteriskToken, ts.visitNode(node.name, visitor, ts.isPropertyName), ts.visitNode(/*questionToken*/ undefined, visitor, ts.isToken), 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */
	                ? transformAsyncGeneratorFunctionBody(node)
	                : transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitFunctionDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = ts.getFunctionFlags(node);
	            var updated = ts.updateFunctionDeclaration(node, 
	            /*decorators*/ undefined, enclosingFunctionFlags & 1 /* Generator */
	                ? ts.visitNodes(node.modifiers, visitorNoAsyncModifier, ts.isModifier)
	                : node.modifiers, enclosingFunctionFlags & 2 /* Async */
	                ? undefined
	                : node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */
	                ? transformAsyncGeneratorFunctionBody(node)
	                : transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitArrowFunction(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = ts.getFunctionFlags(node);
	            var updated = ts.updateArrowFunction(node, node.modifiers, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, node.equalsGreaterThanToken, transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitFunctionExpression(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = ts.getFunctionFlags(node);
	            var updated = ts.updateFunctionExpression(node, enclosingFunctionFlags & 1 /* Generator */
	                ? ts.visitNodes(node.modifiers, visitorNoAsyncModifier, ts.isModifier)
	                : node.modifiers, enclosingFunctionFlags & 2 /* Async */
	                ? undefined
	                : node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */
	                ? transformAsyncGeneratorFunctionBody(node)
	                : transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function transformAsyncGeneratorFunctionBody(node) {
	            resumeLexicalEnvironment();
	            var statements = [];
	            var statementOffset = ts.addPrologue(statements, node.body.statements, /*ensureUseStrict*/ false, visitor);
	            appendObjectRestAssignmentsIfNeeded(statements, node);
	            statements.push(ts.createReturn(createAsyncGeneratorHelper(context, ts.createFunctionExpression(
	            /*modifiers*/ undefined, ts.createToken(39 /* AsteriskToken */), node.name && ts.getGeneratedNameForNode(node.name), 
	            /*typeParameters*/ undefined, 
	            /*parameters*/ [], 
	            /*type*/ undefined, ts.updateBlock(node.body, ts.visitLexicalEnvironment(node.body.statements, visitor, context, statementOffset))))));
	            ts.addRange(statements, endLexicalEnvironment());
	            var block = ts.updateBlock(node.body, statements);
	            // Minor optimization, emit `_super` helper to capture `super` access in an arrow.
	            // This step isn't needed if we eventually transform this to ES5.
	            if (languageVersion >= 2 /* ES2015 */) {
	                if (resolver.getNodeCheckFlags(node) & 4096 /* AsyncMethodWithSuperBinding */) {
	                    enableSubstitutionForAsyncMethodsWithSuper();
	                    ts.addEmitHelper(block, ts.advancedAsyncSuperHelper);
	                }
	                else if (resolver.getNodeCheckFlags(node) & 2048 /* AsyncMethodWithSuper */) {
	                    enableSubstitutionForAsyncMethodsWithSuper();
	                    ts.addEmitHelper(block, ts.asyncSuperHelper);
	                }
	            }
	            return block;
	        }
	        function transformFunctionBody(node) {
	            resumeLexicalEnvironment();
	            var statementOffset = 0;
	            var statements = [];
	            var body = ts.visitNode(node.body, visitor, ts.isConciseBody);
	            if (ts.isBlock(body)) {
	                statementOffset = ts.addPrologue(statements, body.statements, /*ensureUseStrict*/ false, visitor);
	            }
	            ts.addRange(statements, appendObjectRestAssignmentsIfNeeded(/*statements*/ undefined, node));
	            var trailingStatements = endLexicalEnvironment();
	            if (statementOffset > 0 || ts.some(statements) || ts.some(trailingStatements)) {
	                var block = ts.convertToFunctionBody(body, /*multiLine*/ true);
	                ts.addRange(statements, block.statements.slice(statementOffset));
	                ts.addRange(statements, trailingStatements);
	                return ts.updateBlock(block, ts.setTextRange(ts.createNodeArray(statements), block.statements));
	            }
	            return body;
	        }
	        function appendObjectRestAssignmentsIfNeeded(statements, node) {
	            for (var _i = 0, _a = node.parameters; _i < _a.length; _i++) {
	                var parameter = _a[_i];
	                if (parameter.transformFlags & 1048576 /* ContainsObjectRest */) {
	                    var temp = ts.getGeneratedNameForNode(parameter);
	                    var declarations = ts.flattenDestructuringBinding(parameter, visitor, context, 1 /* ObjectRest */, temp, 
	                    /*doNotRecordTempVariablesInLine*/ false, 
	                    /*skipInitializer*/ true);
	                    if (ts.some(declarations)) {
	                        var statement = ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList(declarations));
	                        ts.setEmitFlags(statement, 1048576 /* CustomPrologue */);
	                        statements = ts.append(statements, statement);
	                    }
	                }
	            }
	            return statements;
	        }
	        function enableSubstitutionForAsyncMethodsWithSuper() {
	            if ((enabledSubstitutions & 1 /* AsyncMethodsWithSuper */) === 0) {
	                enabledSubstitutions |= 1 /* AsyncMethodsWithSuper */;
	                // We need to enable substitutions for call, property access, and element access
	                // if we need to rewrite super calls.
	                context.enableSubstitution(185 /* CallExpression */);
	                context.enableSubstitution(183 /* PropertyAccessExpression */);
	                context.enableSubstitution(184 /* ElementAccessExpression */);
	                // We need to be notified when entering and exiting declarations that bind super.
	                context.enableEmitNotification(233 /* ClassDeclaration */);
	                context.enableEmitNotification(153 /* MethodDeclaration */);
	                context.enableEmitNotification(155 /* GetAccessor */);
	                context.enableEmitNotification(156 /* SetAccessor */);
	                context.enableEmitNotification(154 /* Constructor */);
	            }
	        }
	        /**
	         * Called by the printer just before a node is printed.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to be printed.
	         * @param emitCallback The callback used to emit the node.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            // If we need to support substitutions for `super` in an async method,
	            // we should track it here.
	            if (enabledSubstitutions & 1 /* AsyncMethodsWithSuper */ && isSuperContainer(node)) {
	                var superContainerFlags = resolver.getNodeCheckFlags(node) & (2048 /* AsyncMethodWithSuper */ | 4096 /* AsyncMethodWithSuperBinding */);
	                if (superContainerFlags !== enclosingSuperContainerFlags) {
	                    var savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
	                    enclosingSuperContainerFlags = superContainerFlags;
	                    previousOnEmitNode(hint, node, emitCallback);
	                    enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
	                    return;
	                }
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint The context for the emitter.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */ && enclosingSuperContainerFlags) {
	                return substituteExpression(node);
	            }
	            return node;
	        }
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 183 /* PropertyAccessExpression */:
	                    return substitutePropertyAccessExpression(node);
	                case 184 /* ElementAccessExpression */:
	                    return substituteElementAccessExpression(node);
	                case 185 /* CallExpression */:
	                    return substituteCallExpression(node);
	            }
	            return node;
	        }
	        function substitutePropertyAccessExpression(node) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return createSuperAccessInAsyncMethod(ts.createLiteral(ts.idText(node.name)), node);
	            }
	            return node;
	        }
	        function substituteElementAccessExpression(node) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return createSuperAccessInAsyncMethod(node.argumentExpression, node);
	            }
	            return node;
	        }
	        function substituteCallExpression(node) {
	            var expression = node.expression;
	            if (ts.isSuperProperty(expression)) {
	                var argumentExpression = ts.isPropertyAccessExpression(expression)
	                    ? substitutePropertyAccessExpression(expression)
	                    : substituteElementAccessExpression(expression);
	                return ts.createCall(ts.createPropertyAccess(argumentExpression, "call"), 
	                /*typeArguments*/ undefined, [
	                    ts.createThis()
	                ].concat(node.arguments));
	            }
	            return node;
	        }
	        function isSuperContainer(node) {
	            var kind = node.kind;
	            return kind === 233 /* ClassDeclaration */
	                || kind === 154 /* Constructor */
	                || kind === 153 /* MethodDeclaration */
	                || kind === 155 /* GetAccessor */
	                || kind === 156 /* SetAccessor */;
	        }
	        function createSuperAccessInAsyncMethod(argumentExpression, location) {
	            if (enclosingSuperContainerFlags & 4096 /* AsyncMethodWithSuperBinding */) {
	                return ts.setTextRange(ts.createPropertyAccess(ts.createCall(ts.createIdentifier("_super"), 
	                /*typeArguments*/ undefined, [argumentExpression]), "value"), location);
	            }
	            else {
	                return ts.setTextRange(ts.createCall(ts.createIdentifier("_super"), 
	                /*typeArguments*/ undefined, [argumentExpression]), location);
	            }
	        }
	    }
	    ts.transformESNext = transformESNext;
	    var assignHelper = {
	        name: "typescript:assign",
	        scoped: false,
	        priority: 1,
	        text: "\n            var __assign = (this && this.__assign) || Object.assign || function(t) {\n                for (var s, i = 1, n = arguments.length; i < n; i++) {\n                    s = arguments[i];\n                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))\n                        t[p] = s[p];\n                }\n                return t;\n            };"
	    };
	    function createAssignHelper(context, attributesSegments) {
	        if (context.getCompilerOptions().target >= 2 /* ES2015 */) {
	            return ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Object"), "assign"), 
	            /*typeArguments*/ undefined, attributesSegments);
	        }
	        context.requestEmitHelper(assignHelper);
	        return ts.createCall(ts.getHelperName("__assign"), 
	        /*typeArguments*/ undefined, attributesSegments);
	    }
	    ts.createAssignHelper = createAssignHelper;
	    var awaitHelper = {
	        name: "typescript:await",
	        scoped: false,
	        text: "\n            var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }\n        "
	    };
	    function createAwaitHelper(context, expression) {
	        context.requestEmitHelper(awaitHelper);
	        return ts.createCall(ts.getHelperName("__await"), /*typeArguments*/ undefined, [expression]);
	    }
	    var asyncGeneratorHelper = {
	        name: "typescript:asyncGenerator",
	        scoped: false,
	        text: "\n            var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {\n                if (!Symbol.asyncIterator) throw new TypeError(\"Symbol.asyncIterator is not defined.\");\n                var g = generator.apply(thisArg, _arguments || []), i, q = [];\n                return i = {}, verb(\"next\"), verb(\"throw\"), verb(\"return\"), i[Symbol.asyncIterator] = function () { return this; }, i;\n                function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }\n                function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }\n                function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }\n                function fulfill(value) { resume(\"next\", value); }\n                function reject(value) { resume(\"throw\", value); }\n                function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }\n            };\n        "
	    };
	    function createAsyncGeneratorHelper(context, generatorFunc) {
	        context.requestEmitHelper(awaitHelper);
	        context.requestEmitHelper(asyncGeneratorHelper);
	        // Mark this node as originally an async function
	        (generatorFunc.emitNode || (generatorFunc.emitNode = {})).flags |= 262144 /* AsyncFunctionBody */;
	        return ts.createCall(ts.getHelperName("__asyncGenerator"), 
	        /*typeArguments*/ undefined, [
	            ts.createThis(),
	            ts.createIdentifier("arguments"),
	            generatorFunc
	        ]);
	    }
	    var asyncDelegator = {
	        name: "typescript:asyncDelegator",
	        scoped: false,
	        text: "\n            var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {\n                var i, p;\n                return i = {}, verb(\"next\"), verb(\"throw\", function (e) { throw e; }), verb(\"return\"), i[Symbol.iterator] = function () { return this; }, i;\n                function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === \"return\" } : f ? f(v) : v; }; }\n            };\n        "
	    };
	    function createAsyncDelegatorHelper(context, expression, location) {
	        context.requestEmitHelper(awaitHelper);
	        context.requestEmitHelper(asyncDelegator);
	        return ts.setTextRange(ts.createCall(ts.getHelperName("__asyncDelegator"), 
	        /*typeArguments*/ undefined, [expression]), location);
	    }
	    var asyncValues = {
	        name: "typescript:asyncValues",
	        scoped: false,
	        text: "\n            var __asyncValues = (this && this.__asyncValues) || function (o) {\n                if (!Symbol.asyncIterator) throw new TypeError(\"Symbol.asyncIterator is not defined.\");\n                var m = o[Symbol.asyncIterator];\n                return m ? m.call(o) : typeof __values === \"function\" ? __values(o) : o[Symbol.iterator]();\n            };\n        "
	    };
	    function createAsyncValuesHelper(context, expression, location) {
	        context.requestEmitHelper(asyncValues);
	        return ts.setTextRange(ts.createCall(ts.getHelperName("__asyncValues"), 
	        /*typeArguments*/ undefined, [expression]), location);
	    }
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	/// <reference path="./esnext.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformJsx(context) {
	        var compilerOptions = context.getCompilerOptions();
	        var currentSourceFile;
	        return transformSourceFile;
	        /**
	         * Transform JSX-specific syntax in a SourceFile.
	         *
	         * @param node A SourceFile node.
	         */
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            currentSourceFile = node;
	            var visited = ts.visitEachChild(node, visitor, context);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            return visited;
	        }
	        function visitor(node) {
	            if (node.transformFlags & 4 /* ContainsJsx */) {
	                return visitorWorker(node);
	            }
	            else {
	                return node;
	            }
	        }
	        function visitorWorker(node) {
	            switch (node.kind) {
	                case 253 /* JsxElement */:
	                    return visitJsxElement(node, /*isChild*/ false);
	                case 254 /* JsxSelfClosingElement */:
	                    return visitJsxSelfClosingElement(node, /*isChild*/ false);
	                case 257 /* JsxFragment */:
	                    return visitJsxFragment(node, /*isChild*/ false);
	                case 263 /* JsxExpression */:
	                    return visitJsxExpression(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function transformJsxChildToExpression(node) {
	            switch (node.kind) {
	                case 10 /* JsxText */:
	                    return visitJsxText(node);
	                case 263 /* JsxExpression */:
	                    return visitJsxExpression(node);
	                case 253 /* JsxElement */:
	                    return visitJsxElement(node, /*isChild*/ true);
	                case 254 /* JsxSelfClosingElement */:
	                    return visitJsxSelfClosingElement(node, /*isChild*/ true);
	                case 257 /* JsxFragment */:
	                    return visitJsxFragment(node, /*isChild*/ true);
	                default:
	                    ts.Debug.failBadSyntaxKind(node);
	                    return undefined;
	            }
	        }
	        function visitJsxElement(node, isChild) {
	            return visitJsxOpeningLikeElement(node.openingElement, node.children, isChild, /*location*/ node);
	        }
	        function visitJsxSelfClosingElement(node, isChild) {
	            return visitJsxOpeningLikeElement(node, /*children*/ undefined, isChild, /*location*/ node);
	        }
	        function visitJsxFragment(node, isChild) {
	            return visitJsxOpeningFragment(node.openingFragment, node.children, isChild, /*location*/ node);
	        }
	        function visitJsxOpeningLikeElement(node, children, isChild, location) {
	            var tagName = getTagName(node);
	            var objectProperties;
	            var attrs = node.attributes.properties;
	            if (attrs.length === 0) {
	                // When there are no attributes, React wants "null"
	                objectProperties = ts.createNull();
	            }
	            else {
	                // Map spans of JsxAttribute nodes into object literals and spans
	                // of JsxSpreadAttribute nodes into expressions.
	                var segments = ts.flatten(ts.spanMap(attrs, ts.isJsxSpreadAttribute, function (attrs, isSpread) { return isSpread
	                    ? ts.map(attrs, transformJsxSpreadAttributeToExpression)
	                    : ts.createObjectLiteral(ts.map(attrs, transformJsxAttributeToObjectLiteralElement)); }));
	                if (ts.isJsxSpreadAttribute(attrs[0])) {
	                    // We must always emit at least one object literal before a spread
	                    // argument.
	                    segments.unshift(ts.createObjectLiteral());
	                }
	                // Either emit one big object literal (no spread attribs), or
	                // a call to the __assign helper.
	                objectProperties = ts.singleOrUndefined(segments);
	                if (!objectProperties) {
	                    objectProperties = ts.createAssignHelper(context, segments);
	                }
	            }
	            var element = ts.createExpressionForJsxElement(context.getEmitResolver().getJsxFactoryEntity(), compilerOptions.reactNamespace, tagName, objectProperties, ts.mapDefined(children, transformJsxChildToExpression), node, location);
	            if (isChild) {
	                ts.startOnNewLine(element);
	            }
	            return element;
	        }
	        function visitJsxOpeningFragment(node, children, isChild, location) {
	            var element = ts.createExpressionForJsxFragment(context.getEmitResolver().getJsxFactoryEntity(), compilerOptions.reactNamespace, ts.mapDefined(children, transformJsxChildToExpression), node, location);
	            if (isChild) {
	                ts.startOnNewLine(element);
	            }
	            return element;
	        }
	        function transformJsxSpreadAttributeToExpression(node) {
	            return ts.visitNode(node.expression, visitor, ts.isExpression);
	        }
	        function transformJsxAttributeToObjectLiteralElement(node) {
	            var name = getAttributeName(node);
	            var expression = transformJsxAttributeInitializer(node.initializer);
	            return ts.createPropertyAssignment(name, expression);
	        }
	        function transformJsxAttributeInitializer(node) {
	            if (node === undefined) {
	                return ts.createTrue();
	            }
	            else if (node.kind === 9 /* StringLiteral */) {
	                // Always recreate the literal to escape any escape sequences or newlines which may be in the original jsx string and which
	                // Need to be escaped to be handled correctly in a normal string
	                var literal = ts.createLiteral(tryDecodeEntities(node.text) || node.text);
	                literal.singleQuote = node.singleQuote !== undefined ? node.singleQuote : !ts.isStringDoubleQuoted(node, currentSourceFile);
	                return ts.setTextRange(literal, node);
	            }
	            else if (node.kind === 263 /* JsxExpression */) {
	                if (node.expression === undefined) {
	                    return ts.createTrue();
	                }
	                return visitJsxExpression(node);
	            }
	            else {
	                ts.Debug.failBadSyntaxKind(node);
	            }
	        }
	        function visitJsxText(node) {
	            var fixed = fixupWhitespaceAndDecodeEntities(ts.getTextOfNode(node, /*includeTrivia*/ true));
	            return fixed === undefined ? undefined : ts.createLiteral(fixed);
	        }
	        /**
	         * JSX trims whitespace at the end and beginning of lines, except that the
	         * start/end of a tag is considered a start/end of a line only if that line is
	         * on the same line as the closing tag. See examples in
	         * tests/cases/conformance/jsx/tsxReactEmitWhitespace.tsx
	         * See also https://www.w3.org/TR/html4/struct/text.html#h-9.1 and https://www.w3.org/TR/CSS2/text.html#white-space-model
	         *
	         * An equivalent algorithm would be:
	         * - If there is only one line, return it.
	         * - If there is only whitespace (but multiple lines), return `undefined`.
	         * - Split the text into lines.
	         * - 'trimRight' the first line, 'trimLeft' the last line, 'trim' middle lines.
	         * - Decode entities on each line (individually).
	         * - Remove empty lines and join the rest with " ".
	         */
	        function fixupWhitespaceAndDecodeEntities(text) {
	            var acc;
	            // First non-whitespace character on this line.
	            var firstNonWhitespace = 0;
	            // Last non-whitespace character on this line.
	            var lastNonWhitespace = -1;
	            // These initial values are special because the first line is:
	            // firstNonWhitespace = 0 to indicate that we want leading whitsepace,
	            // but lastNonWhitespace = -1 as a special flag to indicate that we *don't* include the line if it's all whitespace.
	            for (var i = 0; i < text.length; i++) {
	                var c = text.charCodeAt(i);
	                if (ts.isLineBreak(c)) {
	                    // If we've seen any non-whitespace characters on this line, add the 'trim' of the line.
	                    // (lastNonWhitespace === -1 is a special flag to detect whether the first line is all whitespace.)
	                    if (firstNonWhitespace !== -1 && lastNonWhitespace !== -1) {
	                        acc = addLineOfJsxText(acc, text.substr(firstNonWhitespace, lastNonWhitespace - firstNonWhitespace + 1));
	                    }
	                    // Reset firstNonWhitespace for the next line.
	                    // Don't bother to reset lastNonWhitespace because we ignore it if firstNonWhitespace = -1.
	                    firstNonWhitespace = -1;
	                }
	                else if (!ts.isWhiteSpaceSingleLine(c)) {
	                    lastNonWhitespace = i;
	                    if (firstNonWhitespace === -1) {
	                        firstNonWhitespace = i;
	                    }
	                }
	            }
	            return firstNonWhitespace !== -1
	                // Last line had a non-whitespace character. Emit the 'trimLeft', meaning keep trailing whitespace.
	                ? addLineOfJsxText(acc, text.substr(firstNonWhitespace))
	                // Last line was all whitespace, so ignore it
	                : acc;
	        }
	        function addLineOfJsxText(acc, trimmedLine) {
	            // We do not escape the string here as that is handled by the printer
	            // when it emits the literal. We do, however, need to decode JSX entities.
	            var decoded = decodeEntities(trimmedLine);
	            return acc === undefined ? decoded : acc + " " + decoded;
	        }
	        /**
	         * Replace entities like "&nbsp;", "&#123;", and "&#xDEADBEEF;" with the characters they encode.
	         * See https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references
	         */
	        function decodeEntities(text) {
	            return text.replace(/&((#((\d+)|x([\da-fA-F]+)))|(\w+));/g, function (match, _all, _number, _digits, decimal, hex, word) {
	                if (decimal) {
	                    return String.fromCharCode(parseInt(decimal, 10));
	                }
	                else if (hex) {
	                    return String.fromCharCode(parseInt(hex, 16));
	                }
	                else {
	                    var ch = entities.get(word);
	                    // If this is not a valid entity, then just use `match` (replace it with itself, i.e. don't replace)
	                    return ch ? String.fromCharCode(ch) : match;
	                }
	            });
	        }
	        /** Like `decodeEntities` but returns `undefined` if there were no entities to decode. */
	        function tryDecodeEntities(text) {
	            var decoded = decodeEntities(text);
	            return decoded === text ? undefined : decoded;
	        }
	        function getTagName(node) {
	            if (node.kind === 253 /* JsxElement */) {
	                return getTagName(node.openingElement);
	            }
	            else {
	                var name = node.tagName;
	                if (ts.isIdentifier(name) && ts.isIntrinsicJsxName(name.escapedText)) {
	                    return ts.createLiteral(ts.idText(name));
	                }
	                else {
	                    return ts.createExpressionFromEntityName(name);
	                }
	            }
	        }
	        /**
	         * Emit an attribute name, which is quoted if it needs to be quoted. Because
	         * these emit into an object literal property name, we don't need to be worried
	         * about keywords, just non-identifier characters
	         */
	        function getAttributeName(node) {
	            var name = node.name;
	            var text = ts.idText(name);
	            if (/^[A-Za-z_]\w*$/.test(text)) {
	                return name;
	            }
	            else {
	                return ts.createLiteral(text);
	            }
	        }
	        function visitJsxExpression(node) {
	            return ts.visitNode(node.expression, visitor, ts.isExpression);
	        }
	    }
	    ts.transformJsx = transformJsx;
	    var entities = ts.createMapFromTemplate({
	        quot: 0x0022,
	        amp: 0x0026,
	        apos: 0x0027,
	        lt: 0x003C,
	        gt: 0x003E,
	        nbsp: 0x00A0,
	        iexcl: 0x00A1,
	        cent: 0x00A2,
	        pound: 0x00A3,
	        curren: 0x00A4,
	        yen: 0x00A5,
	        brvbar: 0x00A6,
	        sect: 0x00A7,
	        uml: 0x00A8,
	        copy: 0x00A9,
	        ordf: 0x00AA,
	        laquo: 0x00AB,
	        not: 0x00AC,
	        shy: 0x00AD,
	        reg: 0x00AE,
	        macr: 0x00AF,
	        deg: 0x00B0,
	        plusmn: 0x00B1,
	        sup2: 0x00B2,
	        sup3: 0x00B3,
	        acute: 0x00B4,
	        micro: 0x00B5,
	        para: 0x00B6,
	        middot: 0x00B7,
	        cedil: 0x00B8,
	        sup1: 0x00B9,
	        ordm: 0x00BA,
	        raquo: 0x00BB,
	        frac14: 0x00BC,
	        frac12: 0x00BD,
	        frac34: 0x00BE,
	        iquest: 0x00BF,
	        Agrave: 0x00C0,
	        Aacute: 0x00C1,
	        Acirc: 0x00C2,
	        Atilde: 0x00C3,
	        Auml: 0x00C4,
	        Aring: 0x00C5,
	        AElig: 0x00C6,
	        Ccedil: 0x00C7,
	        Egrave: 0x00C8,
	        Eacute: 0x00C9,
	        Ecirc: 0x00CA,
	        Euml: 0x00CB,
	        Igrave: 0x00CC,
	        Iacute: 0x00CD,
	        Icirc: 0x00CE,
	        Iuml: 0x00CF,
	        ETH: 0x00D0,
	        Ntilde: 0x00D1,
	        Ograve: 0x00D2,
	        Oacute: 0x00D3,
	        Ocirc: 0x00D4,
	        Otilde: 0x00D5,
	        Ouml: 0x00D6,
	        times: 0x00D7,
	        Oslash: 0x00D8,
	        Ugrave: 0x00D9,
	        Uacute: 0x00DA,
	        Ucirc: 0x00DB,
	        Uuml: 0x00DC,
	        Yacute: 0x00DD,
	        THORN: 0x00DE,
	        szlig: 0x00DF,
	        agrave: 0x00E0,
	        aacute: 0x00E1,
	        acirc: 0x00E2,
	        atilde: 0x00E3,
	        auml: 0x00E4,
	        aring: 0x00E5,
	        aelig: 0x00E6,
	        ccedil: 0x00E7,
	        egrave: 0x00E8,
	        eacute: 0x00E9,
	        ecirc: 0x00EA,
	        euml: 0x00EB,
	        igrave: 0x00EC,
	        iacute: 0x00ED,
	        icirc: 0x00EE,
	        iuml: 0x00EF,
	        eth: 0x00F0,
	        ntilde: 0x00F1,
	        ograve: 0x00F2,
	        oacute: 0x00F3,
	        ocirc: 0x00F4,
	        otilde: 0x00F5,
	        ouml: 0x00F6,
	        divide: 0x00F7,
	        oslash: 0x00F8,
	        ugrave: 0x00F9,
	        uacute: 0x00FA,
	        ucirc: 0x00FB,
	        uuml: 0x00FC,
	        yacute: 0x00FD,
	        thorn: 0x00FE,
	        yuml: 0x00FF,
	        OElig: 0x0152,
	        oelig: 0x0153,
	        Scaron: 0x0160,
	        scaron: 0x0161,
	        Yuml: 0x0178,
	        fnof: 0x0192,
	        circ: 0x02C6,
	        tilde: 0x02DC,
	        Alpha: 0x0391,
	        Beta: 0x0392,
	        Gamma: 0x0393,
	        Delta: 0x0394,
	        Epsilon: 0x0395,
	        Zeta: 0x0396,
	        Eta: 0x0397,
	        Theta: 0x0398,
	        Iota: 0x0399,
	        Kappa: 0x039A,
	        Lambda: 0x039B,
	        Mu: 0x039C,
	        Nu: 0x039D,
	        Xi: 0x039E,
	        Omicron: 0x039F,
	        Pi: 0x03A0,
	        Rho: 0x03A1,
	        Sigma: 0x03A3,
	        Tau: 0x03A4,
	        Upsilon: 0x03A5,
	        Phi: 0x03A6,
	        Chi: 0x03A7,
	        Psi: 0x03A8,
	        Omega: 0x03A9,
	        alpha: 0x03B1,
	        beta: 0x03B2,
	        gamma: 0x03B3,
	        delta: 0x03B4,
	        epsilon: 0x03B5,
	        zeta: 0x03B6,
	        eta: 0x03B7,
	        theta: 0x03B8,
	        iota: 0x03B9,
	        kappa: 0x03BA,
	        lambda: 0x03BB,
	        mu: 0x03BC,
	        nu: 0x03BD,
	        xi: 0x03BE,
	        omicron: 0x03BF,
	        pi: 0x03C0,
	        rho: 0x03C1,
	        sigmaf: 0x03C2,
	        sigma: 0x03C3,
	        tau: 0x03C4,
	        upsilon: 0x03C5,
	        phi: 0x03C6,
	        chi: 0x03C7,
	        psi: 0x03C8,
	        omega: 0x03C9,
	        thetasym: 0x03D1,
	        upsih: 0x03D2,
	        piv: 0x03D6,
	        ensp: 0x2002,
	        emsp: 0x2003,
	        thinsp: 0x2009,
	        zwnj: 0x200C,
	        zwj: 0x200D,
	        lrm: 0x200E,
	        rlm: 0x200F,
	        ndash: 0x2013,
	        mdash: 0x2014,
	        lsquo: 0x2018,
	        rsquo: 0x2019,
	        sbquo: 0x201A,
	        ldquo: 0x201C,
	        rdquo: 0x201D,
	        bdquo: 0x201E,
	        dagger: 0x2020,
	        Dagger: 0x2021,
	        bull: 0x2022,
	        hellip: 0x2026,
	        permil: 0x2030,
	        prime: 0x2032,
	        Prime: 0x2033,
	        lsaquo: 0x2039,
	        rsaquo: 0x203A,
	        oline: 0x203E,
	        frasl: 0x2044,
	        euro: 0x20AC,
	        image: 0x2111,
	        weierp: 0x2118,
	        real: 0x211C,
	        trade: 0x2122,
	        alefsym: 0x2135,
	        larr: 0x2190,
	        uarr: 0x2191,
	        rarr: 0x2192,
	        darr: 0x2193,
	        harr: 0x2194,
	        crarr: 0x21B5,
	        lArr: 0x21D0,
	        uArr: 0x21D1,
	        rArr: 0x21D2,
	        dArr: 0x21D3,
	        hArr: 0x21D4,
	        forall: 0x2200,
	        part: 0x2202,
	        exist: 0x2203,
	        empty: 0x2205,
	        nabla: 0x2207,
	        isin: 0x2208,
	        notin: 0x2209,
	        ni: 0x220B,
	        prod: 0x220F,
	        sum: 0x2211,
	        minus: 0x2212,
	        lowast: 0x2217,
	        radic: 0x221A,
	        prop: 0x221D,
	        infin: 0x221E,
	        ang: 0x2220,
	        and: 0x2227,
	        or: 0x2228,
	        cap: 0x2229,
	        cup: 0x222A,
	        int: 0x222B,
	        there4: 0x2234,
	        sim: 0x223C,
	        cong: 0x2245,
	        asymp: 0x2248,
	        ne: 0x2260,
	        equiv: 0x2261,
	        le: 0x2264,
	        ge: 0x2265,
	        sub: 0x2282,
	        sup: 0x2283,
	        nsub: 0x2284,
	        sube: 0x2286,
	        supe: 0x2287,
	        oplus: 0x2295,
	        otimes: 0x2297,
	        perp: 0x22A5,
	        sdot: 0x22C5,
	        lceil: 0x2308,
	        rceil: 0x2309,
	        lfloor: 0x230A,
	        rfloor: 0x230B,
	        lang: 0x2329,
	        rang: 0x232A,
	        loz: 0x25CA,
	        spades: 0x2660,
	        clubs: 0x2663,
	        hearts: 0x2665,
	        diams: 0x2666
	    });
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformES2016(context) {
	        var hoistVariableDeclaration = context.hoistVariableDeclaration;
	        return transformSourceFile;
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitor(node) {
	            if ((node.transformFlags & 32 /* ContainsES2016 */) === 0) {
	                return node;
	            }
	            switch (node.kind) {
	                case 198 /* BinaryExpression */:
	                    return visitBinaryExpression(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitBinaryExpression(node) {
	            switch (node.operatorToken.kind) {
	                case 62 /* AsteriskAsteriskEqualsToken */:
	                    return visitExponentiationAssignmentExpression(node);
	                case 40 /* AsteriskAsteriskToken */:
	                    return visitExponentiationExpression(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitExponentiationAssignmentExpression(node) {
	            var target;
	            var value;
	            var left = ts.visitNode(node.left, visitor, ts.isExpression);
	            var right = ts.visitNode(node.right, visitor, ts.isExpression);
	            if (ts.isElementAccessExpression(left)) {
	                // Transforms `a[x] **= b` into `(_a = a)[_x = x] = Math.pow(_a[_x], b)`
	                var expressionTemp = ts.createTempVariable(hoistVariableDeclaration);
	                var argumentExpressionTemp = ts.createTempVariable(hoistVariableDeclaration);
	                target = ts.setTextRange(ts.createElementAccess(ts.setTextRange(ts.createAssignment(expressionTemp, left.expression), left.expression), ts.setTextRange(ts.createAssignment(argumentExpressionTemp, left.argumentExpression), left.argumentExpression)), left);
	                value = ts.setTextRange(ts.createElementAccess(expressionTemp, argumentExpressionTemp), left);
	            }
	            else if (ts.isPropertyAccessExpression(left)) {
	                // Transforms `a.x **= b` into `(_a = a).x = Math.pow(_a.x, b)`
	                var expressionTemp = ts.createTempVariable(hoistVariableDeclaration);
	                target = ts.setTextRange(ts.createPropertyAccess(ts.setTextRange(ts.createAssignment(expressionTemp, left.expression), left.expression), left.name), left);
	                value = ts.setTextRange(ts.createPropertyAccess(expressionTemp, left.name), left);
	            }
	            else {
	                // Transforms `a **= b` into `a = Math.pow(a, b)`
	                target = left;
	                value = left;
	            }
	            return ts.setTextRange(ts.createAssignment(target, ts.createMathPow(value, right, /*location*/ node)), node);
	        }
	        function visitExponentiationExpression(node) {
	            // Transforms `a ** b` into `Math.pow(a, b)`
	            var left = ts.visitNode(node.left, visitor, ts.isExpression);
	            var right = ts.visitNode(node.right, visitor, ts.isExpression);
	            return ts.createMathPow(left, right, /*location*/ node);
	        }
	    }
	    ts.transformES2016 = transformES2016;
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	/// <reference path="./destructuring.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    var ES2015SubstitutionFlags;
	    (function (ES2015SubstitutionFlags) {
	        /** Enables substitutions for captured `this` */
	        ES2015SubstitutionFlags[ES2015SubstitutionFlags["CapturedThis"] = 1] = "CapturedThis";
	        /** Enables substitutions for block-scoped bindings. */
	        ES2015SubstitutionFlags[ES2015SubstitutionFlags["BlockScopedBindings"] = 2] = "BlockScopedBindings";
	    })(ES2015SubstitutionFlags || (ES2015SubstitutionFlags = {}));
	    var CopyDirection;
	    (function (CopyDirection) {
	        CopyDirection[CopyDirection["ToOriginal"] = 0] = "ToOriginal";
	        CopyDirection[CopyDirection["ToOutParameter"] = 1] = "ToOutParameter";
	    })(CopyDirection || (CopyDirection = {}));
	    var Jump;
	    (function (Jump) {
	        Jump[Jump["Break"] = 2] = "Break";
	        Jump[Jump["Continue"] = 4] = "Continue";
	        Jump[Jump["Return"] = 8] = "Return";
	    })(Jump || (Jump = {}));
	    var SuperCaptureResult;
	    (function (SuperCaptureResult) {
	        /**
	         * A capture may have been added for calls to 'super', but
	         * the caller should emit subsequent statements normally.
	         */
	        SuperCaptureResult[SuperCaptureResult["NoReplacement"] = 0] = "NoReplacement";
	        /**
	         * A call to 'super()' got replaced with a capturing statement like:
	         *
	         *  var _this = _super.call(...) || this;
	         *
	         * Callers should skip the current statement.
	         */
	        SuperCaptureResult[SuperCaptureResult["ReplaceSuperCapture"] = 1] = "ReplaceSuperCapture";
	        /**
	         * A call to 'super()' got replaced with a capturing statement like:
	         *
	         *  return _super.call(...) || this;
	         *
	         * Callers should skip the current statement and avoid any returns of '_this'.
	         */
	        SuperCaptureResult[SuperCaptureResult["ReplaceWithReturn"] = 2] = "ReplaceWithReturn";
	    })(SuperCaptureResult || (SuperCaptureResult = {}));
	    // Facts we track as we traverse the tree
	    var HierarchyFacts;
	    (function (HierarchyFacts) {
	        HierarchyFacts[HierarchyFacts["None"] = 0] = "None";
	        //
	        // Ancestor facts
	        //
	        HierarchyFacts[HierarchyFacts["Function"] = 1] = "Function";
	        HierarchyFacts[HierarchyFacts["ArrowFunction"] = 2] = "ArrowFunction";
	        HierarchyFacts[HierarchyFacts["AsyncFunctionBody"] = 4] = "AsyncFunctionBody";
	        HierarchyFacts[HierarchyFacts["NonStaticClassElement"] = 8] = "NonStaticClassElement";
	        HierarchyFacts[HierarchyFacts["CapturesThis"] = 16] = "CapturesThis";
	        HierarchyFacts[HierarchyFacts["ExportedVariableStatement"] = 32] = "ExportedVariableStatement";
	        HierarchyFacts[HierarchyFacts["TopLevel"] = 64] = "TopLevel";
	        HierarchyFacts[HierarchyFacts["Block"] = 128] = "Block";
	        HierarchyFacts[HierarchyFacts["IterationStatement"] = 256] = "IterationStatement";
	        HierarchyFacts[HierarchyFacts["IterationStatementBlock"] = 512] = "IterationStatementBlock";
	        HierarchyFacts[HierarchyFacts["ForStatement"] = 1024] = "ForStatement";
	        HierarchyFacts[HierarchyFacts["ForInOrForOfStatement"] = 2048] = "ForInOrForOfStatement";
	        HierarchyFacts[HierarchyFacts["ConstructorWithCapturedSuper"] = 4096] = "ConstructorWithCapturedSuper";
	        HierarchyFacts[HierarchyFacts["ComputedPropertyName"] = 8192] = "ComputedPropertyName";
	        // NOTE: do not add more ancestor flags without also updating AncestorFactsMask below.
	        //
	        // Ancestor masks
	        //
	        HierarchyFacts[HierarchyFacts["AncestorFactsMask"] = 16383] = "AncestorFactsMask";
	        // We are always in *some* kind of block scope, but only specific block-scope containers are
	        // top-level or Blocks.
	        HierarchyFacts[HierarchyFacts["BlockScopeIncludes"] = 0] = "BlockScopeIncludes";
	        HierarchyFacts[HierarchyFacts["BlockScopeExcludes"] = 4032] = "BlockScopeExcludes";
	        // A source file is a top-level block scope.
	        HierarchyFacts[HierarchyFacts["SourceFileIncludes"] = 64] = "SourceFileIncludes";
	        HierarchyFacts[HierarchyFacts["SourceFileExcludes"] = 3968] = "SourceFileExcludes";
	        // Functions, methods, and accessors are both new lexical scopes and new block scopes.
	        HierarchyFacts[HierarchyFacts["FunctionIncludes"] = 65] = "FunctionIncludes";
	        HierarchyFacts[HierarchyFacts["FunctionExcludes"] = 16286] = "FunctionExcludes";
	        HierarchyFacts[HierarchyFacts["AsyncFunctionBodyIncludes"] = 69] = "AsyncFunctionBodyIncludes";
	        HierarchyFacts[HierarchyFacts["AsyncFunctionBodyExcludes"] = 16278] = "AsyncFunctionBodyExcludes";
	        // Arrow functions are lexically scoped to their container, but are new block scopes.
	        HierarchyFacts[HierarchyFacts["ArrowFunctionIncludes"] = 66] = "ArrowFunctionIncludes";
	        HierarchyFacts[HierarchyFacts["ArrowFunctionExcludes"] = 16256] = "ArrowFunctionExcludes";
	        // Constructors are both new lexical scopes and new block scopes. Constructors are also
	        // always considered non-static members of a class.
	        HierarchyFacts[HierarchyFacts["ConstructorIncludes"] = 73] = "ConstructorIncludes";
	        HierarchyFacts[HierarchyFacts["ConstructorExcludes"] = 16278] = "ConstructorExcludes";
	        // 'do' and 'while' statements are not block scopes. We track that the subtree is contained
	        // within an IterationStatement to indicate whether the embedded statement is an
	        // IterationStatementBlock.
	        HierarchyFacts[HierarchyFacts["DoOrWhileStatementIncludes"] = 256] = "DoOrWhileStatementIncludes";
	        HierarchyFacts[HierarchyFacts["DoOrWhileStatementExcludes"] = 0] = "DoOrWhileStatementExcludes";
	        // 'for' statements are new block scopes and have special handling for 'let' declarations.
	        HierarchyFacts[HierarchyFacts["ForStatementIncludes"] = 1280] = "ForStatementIncludes";
	        HierarchyFacts[HierarchyFacts["ForStatementExcludes"] = 3008] = "ForStatementExcludes";
	        // 'for-in' and 'for-of' statements are new block scopes and have special handling for
	        // 'let' declarations.
	        HierarchyFacts[HierarchyFacts["ForInOrForOfStatementIncludes"] = 2304] = "ForInOrForOfStatementIncludes";
	        HierarchyFacts[HierarchyFacts["ForInOrForOfStatementExcludes"] = 1984] = "ForInOrForOfStatementExcludes";
	        // Blocks (other than function bodies) are new block scopes.
	        HierarchyFacts[HierarchyFacts["BlockIncludes"] = 128] = "BlockIncludes";
	        HierarchyFacts[HierarchyFacts["BlockExcludes"] = 3904] = "BlockExcludes";
	        HierarchyFacts[HierarchyFacts["IterationStatementBlockIncludes"] = 512] = "IterationStatementBlockIncludes";
	        HierarchyFacts[HierarchyFacts["IterationStatementBlockExcludes"] = 4032] = "IterationStatementBlockExcludes";
	        // Computed property names track subtree flags differently than their containing members.
	        HierarchyFacts[HierarchyFacts["ComputedPropertyNameIncludes"] = 8192] = "ComputedPropertyNameIncludes";
	        HierarchyFacts[HierarchyFacts["ComputedPropertyNameExcludes"] = 0] = "ComputedPropertyNameExcludes";
	        //
	        // Subtree facts
	        //
	        HierarchyFacts[HierarchyFacts["NewTarget"] = 16384] = "NewTarget";
	        HierarchyFacts[HierarchyFacts["NewTargetInComputedPropertyName"] = 32768] = "NewTargetInComputedPropertyName";
	        //
	        // Subtree masks
	        //
	        HierarchyFacts[HierarchyFacts["SubtreeFactsMask"] = -16384] = "SubtreeFactsMask";
	        HierarchyFacts[HierarchyFacts["PropagateNewTargetMask"] = 49152] = "PropagateNewTargetMask";
	    })(HierarchyFacts || (HierarchyFacts = {}));
	    function transformES2015(context) {
	        var startLexicalEnvironment = context.startLexicalEnvironment, resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var compilerOptions = context.getCompilerOptions();
	        var resolver = context.getEmitResolver();
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        var previousOnEmitNode = context.onEmitNode;
	        context.onEmitNode = onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        var currentSourceFile;
	        var currentText;
	        var hierarchyFacts;
	        var taggedTemplateStringDeclarations;
	        function recordTaggedTemplateString(temp) {
	            taggedTemplateStringDeclarations = ts.append(taggedTemplateStringDeclarations, ts.createVariableDeclaration(temp));
	        }
	        /**
	         * Used to track if we are emitting body of the converted loop
	         */
	        var convertedLoopState;
	        /**
	         * Keeps track of whether substitutions have been enabled for specific cases.
	         * They are persisted between each SourceFile transformation and should not
	         * be reset.
	         */
	        var enabledSubstitutions;
	        return transformSourceFile;
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            currentSourceFile = node;
	            currentText = node.text;
	            var visited = visitSourceFile(node);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            currentSourceFile = undefined;
	            currentText = undefined;
	            taggedTemplateStringDeclarations = undefined;
	            hierarchyFacts = 0 /* None */;
	            return visited;
	        }
	        /**
	         * Sets the `HierarchyFacts` for this node prior to visiting this node's subtree, returning the facts set prior to modification.
	         * @param excludeFacts The existing `HierarchyFacts` to reset before visiting the subtree.
	         * @param includeFacts The new `HierarchyFacts` to set before visiting the subtree.
	         */
	        function enterSubtree(excludeFacts, includeFacts) {
	            var ancestorFacts = hierarchyFacts;
	            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & 16383 /* AncestorFactsMask */;
	            return ancestorFacts;
	        }
	        /**
	         * Restores the `HierarchyFacts` for this node's ancestor after visiting this node's
	         * subtree, propagating specific facts from the subtree.
	         * @param ancestorFacts The `HierarchyFacts` of the ancestor to restore after visiting the subtree.
	         * @param excludeFacts The existing `HierarchyFacts` of the subtree that should not be propagated.
	         * @param includeFacts The new `HierarchyFacts` of the subtree that should be propagated.
	         */
	        function exitSubtree(ancestorFacts, excludeFacts, includeFacts) {
	            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & -16384 /* SubtreeFactsMask */ | ancestorFacts;
	        }
	        function isReturnVoidStatementInConstructorWithCapturedSuper(node) {
	            return hierarchyFacts & 4096 /* ConstructorWithCapturedSuper */
	                && node.kind === 223 /* ReturnStatement */
	                && !node.expression;
	        }
	        function shouldVisitNode(node) {
	            return (node.transformFlags & 128 /* ContainsES2015 */) !== 0
	                || convertedLoopState !== undefined
	                || (hierarchyFacts & 4096 /* ConstructorWithCapturedSuper */ && (ts.isStatement(node) || (node.kind === 211 /* Block */)))
	                || (ts.isIterationStatement(node, /*lookInLabeledStatements*/ false) && shouldConvertIterationStatementBody(node))
	                || (ts.getEmitFlags(node) & 33554432 /* TypeScriptClassWrapper */) !== 0;
	        }
	        function visitor(node) {
	            if (shouldVisitNode(node)) {
	                return visitJavaScript(node);
	            }
	            else {
	                return node;
	            }
	        }
	        function functionBodyVisitor(node) {
	            if (shouldVisitNode(node)) {
	                return visitBlock(node, /*isFunctionBody*/ true);
	            }
	            return node;
	        }
	        function callExpressionVisitor(node) {
	            if (node.kind === 97 /* SuperKeyword */) {
	                return visitSuperKeyword(/*isExpressionOfCall*/ true);
	            }
	            return visitor(node);
	        }
	        function visitJavaScript(node) {
	            switch (node.kind) {
	                case 115 /* StaticKeyword */:
	                    return undefined; // elide static keyword
	                case 233 /* ClassDeclaration */:
	                    return visitClassDeclaration(node);
	                case 203 /* ClassExpression */:
	                    return visitClassExpression(node);
	                case 148 /* Parameter */:
	                    return visitParameter(node);
	                case 232 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 191 /* ArrowFunction */:
	                    return visitArrowFunction(node);
	                case 190 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                case 230 /* VariableDeclaration */:
	                    return visitVariableDeclaration(node);
	                case 71 /* Identifier */:
	                    return visitIdentifier(node);
	                case 231 /* VariableDeclarationList */:
	                    return visitVariableDeclarationList(node);
	                case 225 /* SwitchStatement */:
	                    return visitSwitchStatement(node);
	                case 239 /* CaseBlock */:
	                    return visitCaseBlock(node);
	                case 211 /* Block */:
	                    return visitBlock(node, /*isFunctionBody*/ false);
	                case 222 /* BreakStatement */:
	                case 221 /* ContinueStatement */:
	                    return visitBreakOrContinueStatement(node);
	                case 226 /* LabeledStatement */:
	                    return visitLabeledStatement(node);
	                case 216 /* DoStatement */:
	                case 217 /* WhileStatement */:
	                    return visitDoOrWhileStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 218 /* ForStatement */:
	                    return visitForStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 219 /* ForInStatement */:
	                    return visitForInStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 220 /* ForOfStatement */:
	                    return visitForOfStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 214 /* ExpressionStatement */:
	                    return visitExpressionStatement(node);
	                case 182 /* ObjectLiteralExpression */:
	                    return visitObjectLiteralExpression(node);
	                case 267 /* CatchClause */:
	                    return visitCatchClause(node);
	                case 269 /* ShorthandPropertyAssignment */:
	                    return visitShorthandPropertyAssignment(node);
	                case 146 /* ComputedPropertyName */:
	                    return visitComputedPropertyName(node);
	                case 181 /* ArrayLiteralExpression */:
	                    return visitArrayLiteralExpression(node);
	                case 185 /* CallExpression */:
	                    return visitCallExpression(node);
	                case 186 /* NewExpression */:
	                    return visitNewExpression(node);
	                case 189 /* ParenthesizedExpression */:
	                    return visitParenthesizedExpression(node, /*needsDestructuringValue*/ true);
	                case 198 /* BinaryExpression */:
	                    return visitBinaryExpression(node, /*needsDestructuringValue*/ true);
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 14 /* TemplateHead */:
	                case 15 /* TemplateMiddle */:
	                case 16 /* TemplateTail */:
	                    return visitTemplateLiteral(node);
	                case 9 /* StringLiteral */:
	                    return visitStringLiteral(node);
	                case 8 /* NumericLiteral */:
	                    return visitNumericLiteral(node);
	                case 187 /* TaggedTemplateExpression */:
	                    return visitTaggedTemplateExpression(node);
	                case 200 /* TemplateExpression */:
	                    return visitTemplateExpression(node);
	                case 201 /* YieldExpression */:
	                    return visitYieldExpression(node);
	                case 202 /* SpreadElement */:
	                    return visitSpreadElement(node);
	                case 97 /* SuperKeyword */:
	                    return visitSuperKeyword(/*isExpressionOfCall*/ false);
	                case 99 /* ThisKeyword */:
	                    return visitThisKeyword(node);
	                case 208 /* MetaProperty */:
	                    return visitMetaProperty(node);
	                case 153 /* MethodDeclaration */:
	                    return visitMethodDeclaration(node);
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return visitAccessorDeclaration(node);
	                case 212 /* VariableStatement */:
	                    return visitVariableStatement(node);
	                case 223 /* ReturnStatement */:
	                    return visitReturnStatement(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitSourceFile(node) {
	            var ancestorFacts = enterSubtree(3968 /* SourceFileExcludes */, 64 /* SourceFileIncludes */);
	            var statements = [];
	            startLexicalEnvironment();
	            var statementOffset = ts.addStandardPrologue(statements, node.statements, /*ensureUseStrict*/ false);
	            addCaptureThisForNodeIfNeeded(statements, node);
	            statementOffset = ts.addCustomPrologue(statements, node.statements, statementOffset, visitor);
	            ts.addRange(statements, ts.visitNodes(node.statements, visitor, ts.isStatement, statementOffset));
	            if (taggedTemplateStringDeclarations) {
	                statements.push(ts.createVariableStatement(/*modifiers*/ undefined, ts.createVariableDeclarationList(taggedTemplateStringDeclarations)));
	            }
	            ts.addRange(statements, endLexicalEnvironment());
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray(statements), node.statements));
	        }
	        function visitSwitchStatement(node) {
	            if (convertedLoopState !== undefined) {
	                var savedAllowedNonLabeledJumps = convertedLoopState.allowedNonLabeledJumps;
	                // for switch statement allow only non-labeled break
	                convertedLoopState.allowedNonLabeledJumps |= 2 /* Break */;
	                var result = ts.visitEachChild(node, visitor, context);
	                convertedLoopState.allowedNonLabeledJumps = savedAllowedNonLabeledJumps;
	                return result;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitCaseBlock(node) {
	            var ancestorFacts = enterSubtree(4032 /* BlockScopeExcludes */, 0 /* BlockScopeIncludes */);
	            var updated = ts.visitEachChild(node, visitor, context);
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        function returnCapturedThis(node) {
	            return ts.setOriginalNode(ts.createReturn(ts.createIdentifier("_this")), node);
	        }
	        function visitReturnStatement(node) {
	            if (convertedLoopState) {
	                convertedLoopState.nonLocalJumps |= 8 /* Return */;
	                if (isReturnVoidStatementInConstructorWithCapturedSuper(node)) {
	                    node = returnCapturedThis(node);
	                }
	                return ts.createReturn(ts.createObjectLiteral([
	                    ts.createPropertyAssignment(ts.createIdentifier("value"), node.expression
	                        ? ts.visitNode(node.expression, visitor, ts.isExpression)
	                        : ts.createVoidZero())
	                ]));
	            }
	            else if (isReturnVoidStatementInConstructorWithCapturedSuper(node)) {
	                return returnCapturedThis(node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitThisKeyword(node) {
	            if (convertedLoopState) {
	                if (hierarchyFacts & 2 /* ArrowFunction */) {
	                    // if the enclosing function is an ArrowFunction then we use the captured 'this' keyword.
	                    convertedLoopState.containsLexicalThis = true;
	                    return node;
	                }
	                return convertedLoopState.thisName || (convertedLoopState.thisName = ts.createUniqueName("this"));
	            }
	            return node;
	        }
	        function visitIdentifier(node) {
	            if (!convertedLoopState) {
	                return node;
	            }
	            if (ts.isGeneratedIdentifier(node)) {
	                return node;
	            }
	            if (node.escapedText !== "arguments" || !resolver.isArgumentsLocalBinding(node)) {
	                return node;
	            }
	            return convertedLoopState.argumentsName || (convertedLoopState.argumentsName = ts.createUniqueName("arguments"));
	        }
	        function visitBreakOrContinueStatement(node) {
	            if (convertedLoopState) {
	                // check if we can emit break/continue as is
	                // it is possible if either
	                //   - break/continue is labeled and label is located inside the converted loop
	                //   - break/continue is non-labeled and located in non-converted loop/switch statement
	                var jump = node.kind === 222 /* BreakStatement */ ? 2 /* Break */ : 4 /* Continue */;
	                var canUseBreakOrContinue = (node.label && convertedLoopState.labels && convertedLoopState.labels.get(ts.idText(node.label))) ||
	                    (!node.label && (convertedLoopState.allowedNonLabeledJumps & jump));
	                if (!canUseBreakOrContinue) {
	                    var labelMarker = void 0;
	                    if (!node.label) {
	                        if (node.kind === 222 /* BreakStatement */) {
	                            convertedLoopState.nonLocalJumps |= 2 /* Break */;
	                            labelMarker = "break";
	                        }
	                        else {
	                            convertedLoopState.nonLocalJumps |= 4 /* Continue */;
	                            // note: return value is emitted only to simplify debugging, call to converted loop body does not do any dispatching on it.
	                            labelMarker = "continue";
	                        }
	                    }
	                    else {
	                        if (node.kind === 222 /* BreakStatement */) {
	                            labelMarker = "break-" + node.label.escapedText;
	                            setLabeledJump(convertedLoopState, /*isBreak*/ true, ts.idText(node.label), labelMarker);
	                        }
	                        else {
	                            labelMarker = "continue-" + node.label.escapedText;
	                            setLabeledJump(convertedLoopState, /*isBreak*/ false, ts.idText(node.label), labelMarker);
	                        }
	                    }
	                    var returnExpression = ts.createLiteral(labelMarker);
	                    if (convertedLoopState.loopOutParameters.length) {
	                        var outParams = convertedLoopState.loopOutParameters;
	                        var expr = void 0;
	                        for (var i = 0; i < outParams.length; i++) {
	                            var copyExpr = copyOutParameter(outParams[i], 1 /* ToOutParameter */);
	                            if (i === 0) {
	                                expr = copyExpr;
	                            }
	                            else {
	                                expr = ts.createBinary(expr, 26 /* CommaToken */, copyExpr);
	                            }
	                        }
	                        returnExpression = ts.createBinary(expr, 26 /* CommaToken */, returnExpression);
	                    }
	                    return ts.createReturn(returnExpression);
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a ClassDeclaration and transforms it into a variable statement.
	         *
	         * @param node A ClassDeclaration node.
	         */
	        function visitClassDeclaration(node) {
	            // [source]
	            //      class C { }
	            //
	            // [output]
	            //      var C = (function () {
	            //          function C() {
	            //          }
	            //          return C;
	            //      }());
	            var variable = ts.createVariableDeclaration(ts.getLocalName(node, /*allowComments*/ true), 
	            /*type*/ undefined, transformClassLikeDeclarationToExpression(node));
	            ts.setOriginalNode(variable, node);
	            var statements = [];
	            var statement = ts.createVariableStatement(/*modifiers*/ undefined, ts.createVariableDeclarationList([variable]));
	            ts.setOriginalNode(statement, node);
	            ts.setTextRange(statement, node);
	            ts.startOnNewLine(statement);
	            statements.push(statement);
	            // Add an `export default` statement for default exports (for `--target es5 --module es6`)
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                var exportStatement = ts.hasModifier(node, 512 /* Default */)
	                    ? ts.createExportDefault(ts.getLocalName(node))
	                    : ts.createExternalModuleExport(ts.getLocalName(node));
	                ts.setOriginalNode(exportStatement, statement);
	                statements.push(exportStatement);
	            }
	            var emitFlags = ts.getEmitFlags(node);
	            if ((emitFlags & 4194304 /* HasEndOfDeclarationMarker */) === 0) {
	                // Add a DeclarationMarker as a marker for the end of the declaration
	                statements.push(ts.createEndOfDeclarationMarker(node));
	                ts.setEmitFlags(statement, emitFlags | 4194304 /* HasEndOfDeclarationMarker */);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a ClassExpression and transforms it into an expression.
	         *
	         * @param node A ClassExpression node.
	         */
	        function visitClassExpression(node) {
	            // [source]
	            //      C = class { }
	            //
	            // [output]
	            //      C = (function () {
	            //          function class_1() {
	            //          }
	            //          return class_1;
	            //      }())
	            return transformClassLikeDeclarationToExpression(node);
	        }
	        /**
	         * Transforms a ClassExpression or ClassDeclaration into an expression.
	         *
	         * @param node A ClassExpression or ClassDeclaration node.
	         */
	        function transformClassLikeDeclarationToExpression(node) {
	            // [source]
	            //      class C extends D {
	            //          constructor() {}
	            //          method() {}
	            //          get prop() {}
	            //          set prop(v) {}
	            //      }
	            //
	            // [output]
	            //      (function (_super) {
	            //          __extends(C, _super);
	            //          function C() {
	            //          }
	            //          C.prototype.method = function () {}
	            //          Object.defineProperty(C.prototype, "prop", {
	            //              get: function() {},
	            //              set: function() {},
	            //              enumerable: true,
	            //              configurable: true
	            //          });
	            //          return C;
	            //      }(D))
	            if (node.name) {
	                enableSubstitutionsForBlockScopedBindings();
	            }
	            var extendsClauseElement = ts.getClassExtendsHeritageClauseElement(node);
	            var classFunction = ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, extendsClauseElement ? [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "_super")] : [], 
	            /*type*/ undefined, transformClassBody(node, extendsClauseElement));
	            // To preserve the behavior of the old emitter, we explicitly indent
	            // the body of the function here if it was requested in an earlier
	            // transformation.
	            ts.setEmitFlags(classFunction, (ts.getEmitFlags(node) & 65536 /* Indented */) | 524288 /* ReuseTempVariableScope */);
	            // "inner" and "outer" below are added purely to preserve source map locations from
	            // the old emitter
	            var inner = ts.createPartiallyEmittedExpression(classFunction);
	            inner.end = node.end;
	            ts.setEmitFlags(inner, 1536 /* NoComments */);
	            var outer = ts.createPartiallyEmittedExpression(inner);
	            outer.end = ts.skipTrivia(currentText, node.pos);
	            ts.setEmitFlags(outer, 1536 /* NoComments */);
	            var result = ts.createParen(ts.createCall(outer, 
	            /*typeArguments*/ undefined, extendsClauseElement
	                ? [ts.visitNode(extendsClauseElement.expression, visitor, ts.isExpression)]
	                : []));
	            ts.addSyntheticLeadingComment(result, 3 /* MultiLineCommentTrivia */, "* @class ");
	            return result;
	        }
	        /**
	         * Transforms a ClassExpression or ClassDeclaration into a function body.
	         *
	         * @param node A ClassExpression or ClassDeclaration node.
	         * @param extendsClauseElement The expression for the class `extends` clause.
	         */
	        function transformClassBody(node, extendsClauseElement) {
	            var statements = [];
	            startLexicalEnvironment();
	            addExtendsHelperIfNeeded(statements, node, extendsClauseElement);
	            addConstructor(statements, node, extendsClauseElement);
	            addClassMembers(statements, node);
	            // Create a synthetic text range for the return statement.
	            var closingBraceLocation = ts.createTokenRange(ts.skipTrivia(currentText, node.members.end), 18 /* CloseBraceToken */);
	            var localName = ts.getInternalName(node);
	            // The following partially-emitted expression exists purely to align our sourcemap
	            // emit with the original emitter.
	            var outer = ts.createPartiallyEmittedExpression(localName);
	            outer.end = closingBraceLocation.end;
	            ts.setEmitFlags(outer, 1536 /* NoComments */);
	            var statement = ts.createReturn(outer);
	            statement.pos = closingBraceLocation.pos;
	            ts.setEmitFlags(statement, 1536 /* NoComments */ | 384 /* NoTokenSourceMaps */);
	            statements.push(statement);
	            ts.addRange(statements, endLexicalEnvironment());
	            var block = ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), /*location*/ node.members), /*multiLine*/ true);
	            ts.setEmitFlags(block, 1536 /* NoComments */);
	            return block;
	        }
	        /**
	         * Adds a call to the `__extends` helper if needed for a class.
	         *
	         * @param statements The statements of the class body function.
	         * @param node The ClassExpression or ClassDeclaration node.
	         * @param extendsClauseElement The expression for the class `extends` clause.
	         */
	        function addExtendsHelperIfNeeded(statements, node, extendsClauseElement) {
	            if (extendsClauseElement) {
	                statements.push(ts.setTextRange(ts.createStatement(createExtendsHelper(context, ts.getInternalName(node))), 
	                /*location*/ extendsClauseElement));
	            }
	        }
	        /**
	         * Adds the constructor of the class to a class body function.
	         *
	         * @param statements The statements of the class body function.
	         * @param node The ClassExpression or ClassDeclaration node.
	         * @param extendsClauseElement The expression for the class `extends` clause.
	         */
	        function addConstructor(statements, node, extendsClauseElement) {
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = enterSubtree(16278 /* ConstructorExcludes */, 73 /* ConstructorIncludes */);
	            var constructor = ts.getFirstConstructorWithBody(node);
	            var hasSynthesizedSuper = hasSynthesizedDefaultSuperCall(constructor, extendsClauseElement !== undefined);
	            var constructorFunction = ts.createFunctionDeclaration(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, ts.getInternalName(node), 
	            /*typeParameters*/ undefined, transformConstructorParameters(constructor, hasSynthesizedSuper), 
	            /*type*/ undefined, transformConstructorBody(constructor, node, extendsClauseElement, hasSynthesizedSuper));
	            ts.setTextRange(constructorFunction, constructor || node);
	            if (extendsClauseElement) {
	                ts.setEmitFlags(constructorFunction, 8 /* CapturesThis */);
	            }
	            statements.push(constructorFunction);
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	        }
	        /**
	         * Transforms the parameters of the constructor declaration of a class.
	         *
	         * @param constructor The constructor for the class.
	         * @param hasSynthesizedSuper A value indicating whether the constructor starts with a
	         *                            synthesized `super` call.
	         */
	        function transformConstructorParameters(constructor, hasSynthesizedSuper) {
	            // If the TypeScript transformer needed to synthesize a constructor for property
	            // initializers, it would have also added a synthetic `...args` parameter and
	            // `super` call.
	            // If this is the case, we do not include the synthetic `...args` parameter and
	            // will instead use the `arguments` object in ES5/3.
	            return ts.visitParameterList(constructor && !hasSynthesizedSuper && constructor.parameters, visitor, context)
	                || [];
	        }
	        /**
	         * Transforms the body of a constructor declaration of a class.
	         *
	         * @param constructor The constructor for the class.
	         * @param node The node which contains the constructor.
	         * @param extendsClauseElement The expression for the class `extends` clause.
	         * @param hasSynthesizedSuper A value indicating whether the constructor starts with a
	         *                            synthesized `super` call.
	         */
	        function transformConstructorBody(constructor, node, extendsClauseElement, hasSynthesizedSuper) {
	            var statements = [];
	            resumeLexicalEnvironment();
	            var statementOffset = -1;
	            if (hasSynthesizedSuper) {
	                // If a super call has already been synthesized,
	                // we're going to assume that we should just transform everything after that.
	                // The assumption is that no prior step in the pipeline has added any prologue directives.
	                statementOffset = 0;
	            }
	            else if (constructor) {
	                statementOffset = ts.addStandardPrologue(statements, constructor.body.statements, /*ensureUseStrict*/ false);
	            }
	            if (constructor) {
	                addDefaultValueAssignmentsIfNeeded(statements, constructor);
	                addRestParameterIfNeeded(statements, constructor, hasSynthesizedSuper);
	                if (!hasSynthesizedSuper) {
	                    // If no super call has been synthesized, emit custom prologue directives.
	                    statementOffset = ts.addCustomPrologue(statements, constructor.body.statements, statementOffset, visitor);
	                }
	                ts.Debug.assert(statementOffset >= 0, "statementOffset not initialized correctly!");
	            }
	            // determine whether the class is known syntactically to be a derived class (e.g. a
	            // class that extends a value that is not syntactically known to be `null`).
	            var isDerivedClass = extendsClauseElement && ts.skipOuterExpressions(extendsClauseElement.expression).kind !== 95 /* NullKeyword */;
	            var superCaptureStatus = declareOrCaptureOrReturnThisForConstructorIfNeeded(statements, constructor, isDerivedClass, hasSynthesizedSuper, statementOffset);
	            // The last statement expression was replaced. Skip it.
	            if (superCaptureStatus === 1 /* ReplaceSuperCapture */ || superCaptureStatus === 2 /* ReplaceWithReturn */) {
	                statementOffset++;
	            }
	            if (constructor) {
	                if (superCaptureStatus === 1 /* ReplaceSuperCapture */) {
	                    hierarchyFacts |= 4096 /* ConstructorWithCapturedSuper */;
	                }
	                ts.addRange(statements, ts.visitNodes(constructor.body.statements, visitor, ts.isStatement, /*start*/ statementOffset));
	            }
	            // Return `_this` unless we're sure enough that it would be pointless to add a return statement.
	            // If there's a constructor that we can tell returns in enough places, then we *do not* want to add a return.
	            if (isDerivedClass
	                && superCaptureStatus !== 2 /* ReplaceWithReturn */
	                && !(constructor && isSufficientlyCoveredByReturnStatements(constructor.body))) {
	                statements.push(ts.createReturn(ts.createIdentifier("_this")));
	            }
	            ts.addRange(statements, endLexicalEnvironment());
	            if (constructor) {
	                prependCaptureNewTargetIfNeeded(statements, constructor, /*copyOnWrite*/ false);
	            }
	            var block = ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), 
	            /*location*/ constructor ? constructor.body.statements : node.members), 
	            /*multiLine*/ true);
	            ts.setTextRange(block, constructor ? constructor.body : node);
	            if (!constructor) {
	                ts.setEmitFlags(block, 1536 /* NoComments */);
	            }
	            return block;
	        }
	        /**
	         * We want to try to avoid emitting a return statement in certain cases if a user already returned something.
	         * It would generate obviously dead code, so we'll try to make things a little bit prettier
	         * by doing a minimal check on whether some common patterns always explicitly return.
	         */
	        function isSufficientlyCoveredByReturnStatements(statement) {
	            // A return statement is considered covered.
	            if (statement.kind === 223 /* ReturnStatement */) {
	                return true;
	            }
	            else if (statement.kind === 215 /* IfStatement */) {
	                var ifStatement = statement;
	                if (ifStatement.elseStatement) {
	                    return isSufficientlyCoveredByReturnStatements(ifStatement.thenStatement) &&
	                        isSufficientlyCoveredByReturnStatements(ifStatement.elseStatement);
	                }
	            }
	            else if (statement.kind === 211 /* Block */) {
	                var lastStatement = ts.lastOrUndefined(statement.statements);
	                if (lastStatement && isSufficientlyCoveredByReturnStatements(lastStatement)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        /**
	         * Declares a `_this` variable for derived classes and for when arrow functions capture `this`.
	         *
	         * @returns The new statement offset into the `statements` array.
	         */
	        function declareOrCaptureOrReturnThisForConstructorIfNeeded(statements, ctor, isDerivedClass, hasSynthesizedSuper, statementOffset) {
	            // If this isn't a derived class, just capture 'this' for arrow functions if necessary.
	            if (!isDerivedClass) {
	                if (ctor) {
	                    addCaptureThisForNodeIfNeeded(statements, ctor);
	                }
	                return 0 /* NoReplacement */;
	            }
	            // We must be here because the user didn't write a constructor
	            // but we needed to call 'super(...args)' anyway as per 14.5.14 of the ES2016 spec.
	            // If that's the case we can just immediately return the result of a 'super()' call.
	            if (!ctor) {
	                statements.push(ts.createReturn(createDefaultSuperCallOrThis()));
	                return 2 /* ReplaceWithReturn */;
	            }
	            // The constructor exists, but it and the 'super()' call it contains were generated
	            // for something like property initializers.
	            // Create a captured '_this' variable and assume it will subsequently be used.
	            if (hasSynthesizedSuper) {
	                captureThisForNode(statements, ctor, createDefaultSuperCallOrThis());
	                enableSubstitutionsForCapturedThis();
	                return 1 /* ReplaceSuperCapture */;
	            }
	            // Most of the time, a 'super' call will be the first real statement in a constructor body.
	            // In these cases, we'd like to transform these into a *single* statement instead of a declaration
	            // followed by an assignment statement for '_this'. For instance, if we emitted without an initializer,
	            // we'd get:
	            //
	            //      var _this;
	            //      _this = _super.call(...) || this;
	            //
	            // instead of
	            //
	            //      var _this = _super.call(...) || this;
	            //
	            // Additionally, if the 'super()' call is the last statement, we should just avoid capturing
	            // entirely and immediately return the result like so:
	            //
	            //      return _super.call(...) || this;
	            //
	            var firstStatement;
	            var superCallExpression;
	            var ctorStatements = ctor.body.statements;
	            if (statementOffset < ctorStatements.length) {
	                firstStatement = ctorStatements[statementOffset];
	                if (firstStatement.kind === 214 /* ExpressionStatement */ && ts.isSuperCall(firstStatement.expression)) {
	                    superCallExpression = visitImmediateSuperCallInBody(firstStatement.expression);
	                }
	            }
	            // Return the result if we have an immediate super() call on the last statement,
	            // but only if the constructor itself doesn't use 'this' elsewhere.
	            if (superCallExpression
	                && statementOffset === ctorStatements.length - 1
	                && !(ctor.transformFlags & (16384 /* ContainsLexicalThis */ | 32768 /* ContainsCapturedLexicalThis */))) {
	                var returnStatement = ts.createReturn(superCallExpression);
	                if (superCallExpression.kind !== 198 /* BinaryExpression */
	                    || superCallExpression.left.kind !== 185 /* CallExpression */) {
	                    ts.Debug.fail("Assumed generated super call would have form 'super.call(...) || this'.");
	                }
	                // Shift comments from the original super call to the return statement.
	                ts.setCommentRange(returnStatement, ts.getCommentRange(ts.setEmitFlags(superCallExpression.left, 1536 /* NoComments */)));
	                statements.push(returnStatement);
	                return 2 /* ReplaceWithReturn */;
	            }
	            // Perform the capture.
	            captureThisForNode(statements, ctor, superCallExpression || createActualThis(), firstStatement);
	            // If we're actually replacing the original statement, we need to signal this to the caller.
	            if (superCallExpression) {
	                return 1 /* ReplaceSuperCapture */;
	            }
	            return 0 /* NoReplacement */;
	        }
	        function createActualThis() {
	            return ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */);
	        }
	        function createDefaultSuperCallOrThis() {
	            return ts.createLogicalOr(ts.createLogicalAnd(ts.createStrictInequality(ts.createIdentifier("_super"), ts.createNull()), ts.createFunctionApply(ts.createIdentifier("_super"), createActualThis(), ts.createIdentifier("arguments"))), createActualThis());
	        }
	        /**
	         * Visits a parameter declaration.
	         *
	         * @param node A ParameterDeclaration node.
	         */
	        function visitParameter(node) {
	            if (node.dotDotDotToken) {
	                // rest parameters are elided
	                return undefined;
	            }
	            else if (ts.isBindingPattern(node.name)) {
	                // Binding patterns are converted into a generated name and are
	                // evaluated inside the function body.
	                return ts.setOriginalNode(ts.setTextRange(ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, ts.getGeneratedNameForNode(node), 
	                /*questionToken*/ undefined, 
	                /*type*/ undefined, 
	                /*initializer*/ undefined), 
	                /*location*/ node), 
	                /*original*/ node);
	            }
	            else if (node.initializer) {
	                // Initializers are elided
	                return ts.setOriginalNode(ts.setTextRange(ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, node.name, 
	                /*questionToken*/ undefined, 
	                /*type*/ undefined, 
	                /*initializer*/ undefined), 
	                /*location*/ node), 
	                /*original*/ node);
	            }
	            else {
	                return node;
	            }
	        }
	        /**
	         * Gets a value indicating whether we need to add default value assignments for a
	         * function-like node.
	         *
	         * @param node A function-like node.
	         */
	        function shouldAddDefaultValueAssignments(node) {
	            return (node.transformFlags & 131072 /* ContainsDefaultValueAssignments */) !== 0;
	        }
	        /**
	         * Adds statements to the body of a function-like node if it contains parameters with
	         * binding patterns or initializers.
	         *
	         * @param statements The statements for the new function body.
	         * @param node A function-like node.
	         */
	        function addDefaultValueAssignmentsIfNeeded(statements, node) {
	            if (!shouldAddDefaultValueAssignments(node)) {
	                return;
	            }
	            for (var _i = 0, _a = node.parameters; _i < _a.length; _i++) {
	                var parameter = _a[_i];
	                var name = parameter.name, initializer = parameter.initializer, dotDotDotToken = parameter.dotDotDotToken;
	                // A rest parameter cannot have a binding pattern or an initializer,
	                // so let's just ignore it.
	                if (dotDotDotToken) {
	                    continue;
	                }
	                if (ts.isBindingPattern(name)) {
	                    addDefaultValueAssignmentForBindingPattern(statements, parameter, name, initializer);
	                }
	                else if (initializer) {
	                    addDefaultValueAssignmentForInitializer(statements, parameter, name, initializer);
	                }
	            }
	        }
	        /**
	         * Adds statements to the body of a function-like node for parameters with binding patterns
	         *
	         * @param statements The statements for the new function body.
	         * @param parameter The parameter for the function.
	         * @param name The name of the parameter.
	         * @param initializer The initializer for the parameter.
	         */
	        function addDefaultValueAssignmentForBindingPattern(statements, parameter, name, initializer) {
	            var temp = ts.getGeneratedNameForNode(parameter);
	            // In cases where a binding pattern is simply '[]' or '{}',
	            // we usually don't want to emit a var declaration; however, in the presence
	            // of an initializer, we must emit that expression to preserve side effects.
	            if (name.elements.length > 0) {
	                statements.push(ts.setEmitFlags(ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList(ts.flattenDestructuringBinding(parameter, visitor, context, 0 /* All */, temp))), 1048576 /* CustomPrologue */));
	            }
	            else if (initializer) {
	                statements.push(ts.setEmitFlags(ts.createStatement(ts.createAssignment(temp, ts.visitNode(initializer, visitor, ts.isExpression))), 1048576 /* CustomPrologue */));
	            }
	        }
	        /**
	         * Adds statements to the body of a function-like node for parameters with initializers.
	         *
	         * @param statements The statements for the new function body.
	         * @param parameter The parameter for the function.
	         * @param name The name of the parameter.
	         * @param initializer The initializer for the parameter.
	         */
	        function addDefaultValueAssignmentForInitializer(statements, parameter, name, initializer) {
	            initializer = ts.visitNode(initializer, visitor, ts.isExpression);
	            var statement = ts.createIf(ts.createTypeCheck(ts.getSynthesizedClone(name), "undefined"), ts.setEmitFlags(ts.setTextRange(ts.createBlock([
	                ts.createStatement(ts.setTextRange(ts.createAssignment(ts.setEmitFlags(ts.getMutableClone(name), 48 /* NoSourceMap */), ts.setEmitFlags(initializer, 48 /* NoSourceMap */ | ts.getEmitFlags(initializer))), parameter))
	            ]), parameter), 1 /* SingleLine */ | 32 /* NoTrailingSourceMap */ | 384 /* NoTokenSourceMaps */));
	            ts.startOnNewLine(statement);
	            ts.setTextRange(statement, parameter);
	            ts.setEmitFlags(statement, 384 /* NoTokenSourceMaps */ | 32 /* NoTrailingSourceMap */ | 1048576 /* CustomPrologue */);
	            statements.push(statement);
	        }
	        /**
	         * Gets a value indicating whether we need to add statements to handle a rest parameter.
	         *
	         * @param node A ParameterDeclaration node.
	         * @param inConstructorWithSynthesizedSuper A value indicating whether the parameter is
	         *                                          part of a constructor declaration with a
	         *                                          synthesized call to `super`
	         */
	        function shouldAddRestParameter(node, inConstructorWithSynthesizedSuper) {
	            return node && node.dotDotDotToken && node.name.kind === 71 /* Identifier */ && !inConstructorWithSynthesizedSuper;
	        }
	        /**
	         * Adds statements to the body of a function-like node if it contains a rest parameter.
	         *
	         * @param statements The statements for the new function body.
	         * @param node A function-like node.
	         * @param inConstructorWithSynthesizedSuper A value indicating whether the parameter is
	         *                                          part of a constructor declaration with a
	         *                                          synthesized call to `super`
	         */
	        function addRestParameterIfNeeded(statements, node, inConstructorWithSynthesizedSuper) {
	            var parameter = ts.lastOrUndefined(node.parameters);
	            if (!shouldAddRestParameter(parameter, inConstructorWithSynthesizedSuper)) {
	                return;
	            }
	            // `declarationName` is the name of the local declaration for the parameter.
	            var declarationName = ts.getMutableClone(parameter.name);
	            ts.setEmitFlags(declarationName, 48 /* NoSourceMap */);
	            // `expressionName` is the name of the parameter used in expressions.
	            var expressionName = ts.getSynthesizedClone(parameter.name);
	            var restIndex = node.parameters.length - 1;
	            var temp = ts.createLoopVariable();
	            // var param = [];
	            statements.push(ts.setEmitFlags(ts.setTextRange(ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(declarationName, 
	                /*type*/ undefined, ts.createArrayLiteral([]))
	            ])), 
	            /*location*/ parameter), 1048576 /* CustomPrologue */));
	            // for (var _i = restIndex; _i < arguments.length; _i++) {
	            //   param[_i - restIndex] = arguments[_i];
	            // }
	            var forStatement = ts.createFor(ts.setTextRange(ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(temp, /*type*/ undefined, ts.createLiteral(restIndex))
	            ]), parameter), ts.setTextRange(ts.createLessThan(temp, ts.createPropertyAccess(ts.createIdentifier("arguments"), "length")), parameter), ts.setTextRange(ts.createPostfixIncrement(temp), parameter), ts.createBlock([
	                ts.startOnNewLine(ts.setTextRange(ts.createStatement(ts.createAssignment(ts.createElementAccess(expressionName, restIndex === 0
	                    ? temp
	                    : ts.createSubtract(temp, ts.createLiteral(restIndex))), ts.createElementAccess(ts.createIdentifier("arguments"), temp))), 
	                /*location*/ parameter))
	            ]));
	            ts.setEmitFlags(forStatement, 1048576 /* CustomPrologue */);
	            ts.startOnNewLine(forStatement);
	            statements.push(forStatement);
	        }
	        /**
	         * Adds a statement to capture the `this` of a function declaration if it is needed.
	         *
	         * @param statements The statements for the new function body.
	         * @param node A node.
	         */
	        function addCaptureThisForNodeIfNeeded(statements, node) {
	            if (node.transformFlags & 32768 /* ContainsCapturedLexicalThis */ && node.kind !== 191 /* ArrowFunction */) {
	                captureThisForNode(statements, node, ts.createThis());
	            }
	        }
	        function captureThisForNode(statements, node, initializer, originalStatement) {
	            enableSubstitutionsForCapturedThis();
	            var captureThisStatement = ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration("_this", 
	                /*type*/ undefined, initializer)
	            ]));
	            ts.setEmitFlags(captureThisStatement, 1536 /* NoComments */ | 1048576 /* CustomPrologue */);
	            ts.setTextRange(captureThisStatement, originalStatement);
	            ts.setSourceMapRange(captureThisStatement, node);
	            statements.push(captureThisStatement);
	        }
	        function prependCaptureNewTargetIfNeeded(statements, node, copyOnWrite) {
	            if (hierarchyFacts & 16384 /* NewTarget */) {
	                var newTarget = void 0;
	                switch (node.kind) {
	                    case 191 /* ArrowFunction */:
	                        return statements;
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        // Methods and accessors cannot be constructors, so 'new.target' will
	                        // always return 'undefined'.
	                        newTarget = ts.createVoidZero();
	                        break;
	                    case 154 /* Constructor */:
	                        // Class constructors can only be called with `new`, so `this.constructor`
	                        // should be relatively safe to use.
	                        newTarget = ts.createPropertyAccess(ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */), "constructor");
	                        break;
	                    case 232 /* FunctionDeclaration */:
	                    case 190 /* FunctionExpression */:
	                        // Functions can be called or constructed, and may have a `this` due to
	                        // being a member or when calling an imported function via `other_1.f()`.
	                        newTarget = ts.createConditional(ts.createLogicalAnd(ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */), ts.createBinary(ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */), 93 /* InstanceOfKeyword */, ts.getLocalName(node))), ts.createPropertyAccess(ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */), "constructor"), ts.createVoidZero());
	                        break;
	                    default:
	                        ts.Debug.failBadSyntaxKind(node);
	                        break;
	                }
	                var captureNewTargetStatement = ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                    ts.createVariableDeclaration("_newTarget", 
	                    /*type*/ undefined, newTarget)
	                ]));
	                if (copyOnWrite) {
	                    return [captureNewTargetStatement].concat(statements);
	                }
	                statements.unshift(captureNewTargetStatement);
	            }
	            return statements;
	        }
	        /**
	         * Adds statements to the class body function for a class to define the members of the
	         * class.
	         *
	         * @param statements The statements for the class body function.
	         * @param node The ClassExpression or ClassDeclaration node.
	         */
	        function addClassMembers(statements, node) {
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                switch (member.kind) {
	                    case 210 /* SemicolonClassElement */:
	                        statements.push(transformSemicolonClassElementToStatement(member));
	                        break;
	                    case 153 /* MethodDeclaration */:
	                        statements.push(transformClassMethodDeclarationToStatement(getClassMemberPrefix(node, member), member, node));
	                        break;
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        var accessors = ts.getAllAccessorDeclarations(node.members, member);
	                        if (member === accessors.firstAccessor) {
	                            statements.push(transformAccessorsToStatement(getClassMemberPrefix(node, member), accessors, node));
	                        }
	                        break;
	                    case 154 /* Constructor */:
	                        // Constructors are handled in visitClassExpression/visitClassDeclaration
	                        break;
	                    default:
	                        ts.Debug.failBadSyntaxKind(node);
	                        break;
	                }
	            }
	        }
	        /**
	         * Transforms a SemicolonClassElement into a statement for a class body function.
	         *
	         * @param member The SemicolonClassElement node.
	         */
	        function transformSemicolonClassElementToStatement(member) {
	            return ts.setTextRange(ts.createEmptyStatement(), member);
	        }
	        /**
	         * Transforms a MethodDeclaration into a statement for a class body function.
	         *
	         * @param receiver The receiver for the member.
	         * @param member The MethodDeclaration node.
	         */
	        function transformClassMethodDeclarationToStatement(receiver, member, container) {
	            var ancestorFacts = enterSubtree(0 /* None */, 0 /* None */);
	            var commentRange = ts.getCommentRange(member);
	            var sourceMapRange = ts.getSourceMapRange(member);
	            var memberName = ts.createMemberAccessForPropertyName(receiver, ts.visitNode(member.name, visitor, ts.isPropertyName), /*location*/ member.name);
	            var memberFunction = transformFunctionLikeToExpression(member, /*location*/ member, /*name*/ undefined, container);
	            ts.setEmitFlags(memberFunction, 1536 /* NoComments */);
	            ts.setSourceMapRange(memberFunction, sourceMapRange);
	            var statement = ts.setTextRange(ts.createStatement(ts.createAssignment(memberName, memberFunction)), 
	            /*location*/ member);
	            ts.setOriginalNode(statement, member);
	            ts.setCommentRange(statement, commentRange);
	            // The location for the statement is used to emit comments only.
	            // No source map should be emitted for this statement to align with the
	            // old emitter.
	            ts.setEmitFlags(statement, 48 /* NoSourceMap */);
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, hierarchyFacts & 49152 /* PropagateNewTargetMask */ ? 16384 /* NewTarget */ : 0 /* None */);
	            return statement;
	        }
	        /**
	         * Transforms a set of related of get/set accessors into a statement for a class body function.
	         *
	         * @param receiver The receiver for the member.
	         * @param accessors The set of related get/set accessors.
	         */
	        function transformAccessorsToStatement(receiver, accessors, container) {
	            var statement = ts.createStatement(transformAccessorsToExpression(receiver, accessors, container, /*startsOnNewLine*/ false));
	            // The location for the statement is used to emit source maps only.
	            // No comments should be emitted for this statement to align with the
	            // old emitter.
	            ts.setEmitFlags(statement, 1536 /* NoComments */);
	            ts.setSourceMapRange(statement, ts.getSourceMapRange(accessors.firstAccessor));
	            return statement;
	        }
	        /**
	         * Transforms a set of related get/set accessors into an expression for either a class
	         * body function or an ObjectLiteralExpression with computed properties.
	         *
	         * @param receiver The receiver for the member.
	         */
	        function transformAccessorsToExpression(receiver, _a, container, startsOnNewLine) {
	            var firstAccessor = _a.firstAccessor, getAccessor = _a.getAccessor, setAccessor = _a.setAccessor;
	            var ancestorFacts = enterSubtree(0 /* None */, 0 /* None */);
	            // To align with source maps in the old emitter, the receiver and property name
	            // arguments are both mapped contiguously to the accessor name.
	            var target = ts.getMutableClone(receiver);
	            ts.setEmitFlags(target, 1536 /* NoComments */ | 32 /* NoTrailingSourceMap */);
	            ts.setSourceMapRange(target, firstAccessor.name);
	            var propertyName = ts.createExpressionForPropertyName(ts.visitNode(firstAccessor.name, visitor, ts.isPropertyName));
	            ts.setEmitFlags(propertyName, 1536 /* NoComments */ | 16 /* NoLeadingSourceMap */);
	            ts.setSourceMapRange(propertyName, firstAccessor.name);
	            var properties = [];
	            if (getAccessor) {
	                var getterFunction = transformFunctionLikeToExpression(getAccessor, /*location*/ undefined, /*name*/ undefined, container);
	                ts.setSourceMapRange(getterFunction, ts.getSourceMapRange(getAccessor));
	                ts.setEmitFlags(getterFunction, 512 /* NoLeadingComments */);
	                var getter = ts.createPropertyAssignment("get", getterFunction);
	                ts.setCommentRange(getter, ts.getCommentRange(getAccessor));
	                properties.push(getter);
	            }
	            if (setAccessor) {
	                var setterFunction = transformFunctionLikeToExpression(setAccessor, /*location*/ undefined, /*name*/ undefined, container);
	                ts.setSourceMapRange(setterFunction, ts.getSourceMapRange(setAccessor));
	                ts.setEmitFlags(setterFunction, 512 /* NoLeadingComments */);
	                var setter = ts.createPropertyAssignment("set", setterFunction);
	                ts.setCommentRange(setter, ts.getCommentRange(setAccessor));
	                properties.push(setter);
	            }
	            properties.push(ts.createPropertyAssignment("enumerable", ts.createTrue()), ts.createPropertyAssignment("configurable", ts.createTrue()));
	            var call = ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Object"), "defineProperty"), 
	            /*typeArguments*/ undefined, [
	                target,
	                propertyName,
	                ts.createObjectLiteral(properties, /*multiLine*/ true)
	            ]);
	            if (startsOnNewLine) {
	                ts.startOnNewLine(call);
	            }
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, hierarchyFacts & 49152 /* PropagateNewTargetMask */ ? 16384 /* NewTarget */ : 0 /* None */);
	            return call;
	        }
	        /**
	         * Visits an ArrowFunction and transforms it into a FunctionExpression.
	         *
	         * @param node An ArrowFunction node.
	         */
	        function visitArrowFunction(node) {
	            if (node.transformFlags & 16384 /* ContainsLexicalThis */) {
	                enableSubstitutionsForCapturedThis();
	            }
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = enterSubtree(16256 /* ArrowFunctionExcludes */, 66 /* ArrowFunctionIncludes */);
	            var func = ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, transformFunctionBody(node));
	            ts.setTextRange(func, node);
	            ts.setOriginalNode(func, node);
	            ts.setEmitFlags(func, 8 /* CapturesThis */);
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return func;
	        }
	        /**
	         * Visits a FunctionExpression node.
	         *
	         * @param node a FunctionExpression node.
	         */
	        function visitFunctionExpression(node) {
	            var ancestorFacts = ts.getEmitFlags(node) & 262144 /* AsyncFunctionBody */
	                ? enterSubtree(16278 /* AsyncFunctionBodyExcludes */, 69 /* AsyncFunctionBodyIncludes */)
	                : enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */);
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var parameters = ts.visitParameterList(node.parameters, visitor, context);
	            var body = node.transformFlags & 64 /* ES2015 */
	                ? transformFunctionBody(node)
	                : visitFunctionBodyDownLevel(node);
	            var name = hierarchyFacts & 16384 /* NewTarget */
	                ? ts.getLocalName(node)
	                : node.name;
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return ts.updateFunctionExpression(node, 
	            /*modifiers*/ undefined, node.asteriskToken, name, 
	            /*typeParameters*/ undefined, parameters, 
	            /*type*/ undefined, body);
	        }
	        /**
	         * Visits a FunctionDeclaration node.
	         *
	         * @param node a FunctionDeclaration node.
	         */
	        function visitFunctionDeclaration(node) {
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */);
	            var parameters = ts.visitParameterList(node.parameters, visitor, context);
	            var body = node.transformFlags & 64 /* ES2015 */
	                ? transformFunctionBody(node)
	                : visitFunctionBodyDownLevel(node);
	            var name = hierarchyFacts & 16384 /* NewTarget */
	                ? ts.getLocalName(node)
	                : node.name;
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return ts.updateFunctionDeclaration(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, visitor, ts.isModifier), node.asteriskToken, name, 
	            /*typeParameters*/ undefined, parameters, 
	            /*type*/ undefined, body);
	        }
	        /**
	         * Transforms a function-like node into a FunctionExpression.
	         *
	         * @param node The function-like node to transform.
	         * @param location The source-map location for the new FunctionExpression.
	         * @param name The name of the new FunctionExpression.
	         */
	        function transformFunctionLikeToExpression(node, location, name, container) {
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = container && ts.isClassLike(container) && !ts.hasModifier(node, 32 /* Static */)
	                ? enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */ | 8 /* NonStaticClassElement */)
	                : enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */);
	            var parameters = ts.visitParameterList(node.parameters, visitor, context);
	            var body = transformFunctionBody(node);
	            if (hierarchyFacts & 16384 /* NewTarget */ && !name && (node.kind === 232 /* FunctionDeclaration */ || node.kind === 190 /* FunctionExpression */)) {
	                name = ts.getGeneratedNameForNode(node);
	            }
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return ts.setOriginalNode(ts.setTextRange(ts.createFunctionExpression(
	            /*modifiers*/ undefined, node.asteriskToken, name, 
	            /*typeParameters*/ undefined, parameters, 
	            /*type*/ undefined, body), location), 
	            /*original*/ node);
	        }
	        /**
	         * Transforms the body of a function-like node.
	         *
	         * @param node A function-like node.
	         */
	        function transformFunctionBody(node) {
	            var multiLine = false; // indicates whether the block *must* be emitted as multiple lines
	            var singleLine = false; // indicates whether the block *may* be emitted as a single line
	            var statementsLocation;
	            var closeBraceLocation;
	            var statements = [];
	            var body = node.body;
	            var statementOffset;
	            resumeLexicalEnvironment();
	            if (ts.isBlock(body)) {
	                // ensureUseStrict is false because no new prologue-directive should be added.
	                // addStandardPrologue will put already-existing directives at the beginning of the target statement-array
	                statementOffset = ts.addStandardPrologue(statements, body.statements, /*ensureUseStrict*/ false);
	            }
	            addCaptureThisForNodeIfNeeded(statements, node);
	            addDefaultValueAssignmentsIfNeeded(statements, node);
	            addRestParameterIfNeeded(statements, node, /*inConstructorWithSynthesizedSuper*/ false);
	            // If we added any generated statements, this must be a multi-line block.
	            if (!multiLine && statements.length > 0) {
	                multiLine = true;
	            }
	            if (ts.isBlock(body)) {
	                // addCustomPrologue puts already-existing directives at the beginning of the target statement-array
	                statementOffset = ts.addCustomPrologue(statements, body.statements, statementOffset, visitor);
	                statementsLocation = body.statements;
	                ts.addRange(statements, ts.visitNodes(body.statements, visitor, ts.isStatement, statementOffset));
	                // If the original body was a multi-line block, this must be a multi-line block.
	                if (!multiLine && body.multiLine) {
	                    multiLine = true;
	                }
	            }
	            else {
	                ts.Debug.assert(node.kind === 191 /* ArrowFunction */);
	                // To align with the old emitter, we use a synthetic end position on the location
	                // for the statement list we synthesize when we down-level an arrow function with
	                // an expression function body. This prevents both comments and source maps from
	                // being emitted for the end position only.
	                statementsLocation = ts.moveRangeEnd(body, -1);
	                var equalsGreaterThanToken = node.equalsGreaterThanToken;
	                if (!ts.nodeIsSynthesized(equalsGreaterThanToken) && !ts.nodeIsSynthesized(body)) {
	                    if (ts.rangeEndIsOnSameLineAsRangeStart(equalsGreaterThanToken, body, currentSourceFile)) {
	                        singleLine = true;
	                    }
	                    else {
	                        multiLine = true;
	                    }
	                }
	                var expression = ts.visitNode(body, visitor, ts.isExpression);
	                var returnStatement = ts.createReturn(expression);
	                ts.setTextRange(returnStatement, body);
	                ts.setEmitFlags(returnStatement, 384 /* NoTokenSourceMaps */ | 32 /* NoTrailingSourceMap */ | 1024 /* NoTrailingComments */);
	                statements.push(returnStatement);
	                // To align with the source map emit for the old emitter, we set a custom
	                // source map location for the close brace.
	                closeBraceLocation = body;
	            }
	            var lexicalEnvironment = context.endLexicalEnvironment();
	            ts.addRange(statements, lexicalEnvironment);
	            prependCaptureNewTargetIfNeeded(statements, node, /*copyOnWrite*/ false);
	            // If we added any final generated statements, this must be a multi-line block
	            if (!multiLine && lexicalEnvironment && lexicalEnvironment.length) {
	                multiLine = true;
	            }
	            var block = ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), statementsLocation), multiLine);
	            ts.setTextRange(block, node.body);
	            if (!multiLine && singleLine) {
	                ts.setEmitFlags(block, 1 /* SingleLine */);
	            }
	            if (closeBraceLocation) {
	                ts.setTokenSourceMapRange(block, 18 /* CloseBraceToken */, closeBraceLocation);
	            }
	            ts.setOriginalNode(block, node.body);
	            return block;
	        }
	        function visitFunctionBodyDownLevel(node) {
	            var updated = ts.visitFunctionBody(node.body, functionBodyVisitor, context);
	            return ts.updateBlock(updated, ts.setTextRange(ts.createNodeArray(prependCaptureNewTargetIfNeeded(updated.statements, node, /*copyOnWrite*/ true)), 
	            /*location*/ updated.statements));
	        }
	        function visitBlock(node, isFunctionBody) {
	            if (isFunctionBody) {
	                // A function body is not a block scope.
	                return ts.visitEachChild(node, visitor, context);
	            }
	            var ancestorFacts = hierarchyFacts & 256 /* IterationStatement */
	                ? enterSubtree(4032 /* IterationStatementBlockExcludes */, 512 /* IterationStatementBlockIncludes */)
	                : enterSubtree(3904 /* BlockExcludes */, 128 /* BlockIncludes */);
	            var updated = ts.visitEachChild(node, visitor, context);
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        /**
	         * Visits an ExpressionStatement that contains a destructuring assignment.
	         *
	         * @param node An ExpressionStatement node.
	         */
	        function visitExpressionStatement(node) {
	            // If we are here it is most likely because our expression is a destructuring assignment.
	            switch (node.expression.kind) {
	                case 189 /* ParenthesizedExpression */:
	                    return ts.updateStatement(node, visitParenthesizedExpression(node.expression, /*needsDestructuringValue*/ false));
	                case 198 /* BinaryExpression */:
	                    return ts.updateStatement(node, visitBinaryExpression(node.expression, /*needsDestructuringValue*/ false));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a ParenthesizedExpression that may contain a destructuring assignment.
	         *
	         * @param node A ParenthesizedExpression node.
	         * @param needsDestructuringValue A value indicating whether we need to hold onto the rhs
	         *                                of a destructuring assignment.
	         */
	        function visitParenthesizedExpression(node, needsDestructuringValue) {
	            // If we are here it is most likely because our expression is a destructuring assignment.
	            if (!needsDestructuringValue) {
	                // By default we always emit the RHS at the end of a flattened destructuring
	                // expression. If we are in a state where we do not need the destructuring value,
	                // we pass that information along to the children that care about it.
	                switch (node.expression.kind) {
	                    case 189 /* ParenthesizedExpression */:
	                        return ts.updateParen(node, visitParenthesizedExpression(node.expression, /*needsDestructuringValue*/ false));
	                    case 198 /* BinaryExpression */:
	                        return ts.updateParen(node, visitBinaryExpression(node.expression, /*needsDestructuringValue*/ false));
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a BinaryExpression that contains a destructuring assignment.
	         *
	         * @param node A BinaryExpression node.
	         * @param needsDestructuringValue A value indicating whether we need to hold onto the rhs
	         *                                of a destructuring assignment.
	         */
	        function visitBinaryExpression(node, needsDestructuringValue) {
	            // If we are here it is because this is a destructuring assignment.
	            if (ts.isDestructuringAssignment(node)) {
	                return ts.flattenDestructuringAssignment(node, visitor, context, 0 /* All */, needsDestructuringValue);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitVariableStatement(node) {
	            var ancestorFacts = enterSubtree(0 /* None */, ts.hasModifier(node, 1 /* Export */) ? 32 /* ExportedVariableStatement */ : 0 /* None */);
	            var updated;
	            if (convertedLoopState && (node.declarationList.flags & 3 /* BlockScoped */) === 0) {
	                // we are inside a converted loop - hoist variable declarations
	                var assignments = void 0;
	                for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    hoistVariableDeclarationDeclaredInConvertedLoop(convertedLoopState, decl);
	                    if (decl.initializer) {
	                        var assignment = void 0;
	                        if (ts.isBindingPattern(decl.name)) {
	                            assignment = ts.flattenDestructuringAssignment(decl, visitor, context, 0 /* All */);
	                        }
	                        else {
	                            assignment = ts.createBinary(decl.name, 58 /* EqualsToken */, ts.visitNode(decl.initializer, visitor, ts.isExpression));
	                            ts.setTextRange(assignment, decl);
	                        }
	                        assignments = ts.append(assignments, assignment);
	                    }
	                }
	                if (assignments) {
	                    updated = ts.setTextRange(ts.createStatement(ts.inlineExpressions(assignments)), node);
	                }
	                else {
	                    // none of declarations has initializer - the entire variable statement can be deleted
	                    updated = undefined;
	                }
	            }
	            else {
	                updated = ts.visitEachChild(node, visitor, context);
	            }
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        /**
	         * Visits a VariableDeclarationList that is block scoped (e.g. `let` or `const`).
	         *
	         * @param node A VariableDeclarationList node.
	         */
	        function visitVariableDeclarationList(node) {
	            if (node.transformFlags & 64 /* ES2015 */) {
	                if (node.flags & 3 /* BlockScoped */) {
	                    enableSubstitutionsForBlockScopedBindings();
	                }
	                var declarations = ts.flatMap(node.declarations, node.flags & 1 /* Let */
	                    ? visitVariableDeclarationInLetDeclarationList
	                    : visitVariableDeclaration);
	                var declarationList = ts.createVariableDeclarationList(declarations);
	                ts.setOriginalNode(declarationList, node);
	                ts.setTextRange(declarationList, node);
	                ts.setCommentRange(declarationList, node);
	                if (node.transformFlags & 8388608 /* ContainsBindingPattern */
	                    && (ts.isBindingPattern(node.declarations[0].name) || ts.isBindingPattern(ts.lastOrUndefined(node.declarations).name))) {
	                    // If the first or last declaration is a binding pattern, we need to modify
	                    // the source map range for the declaration list.
	                    var firstDeclaration = ts.firstOrUndefined(declarations);
	                    if (firstDeclaration) {
	                        var lastDeclaration = ts.lastOrUndefined(declarations);
	                        ts.setSourceMapRange(declarationList, ts.createRange(firstDeclaration.pos, lastDeclaration.end));
	                    }
	                }
	                return declarationList;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Gets a value indicating whether we should emit an explicit initializer for a variable
	         * declaration in a `let` declaration list.
	         *
	         * @param node A VariableDeclaration node.
	         */
	        function shouldEmitExplicitInitializerForLetDeclaration(node) {
	            // Nested let bindings might need to be initialized explicitly to preserve
	            // ES6 semantic:
	            //
	            //  { let x = 1; }
	            //  { let x; } // x here should be undefined. not 1
	            //
	            // Top level bindings never collide with anything and thus don't require
	            // explicit initialization. As for nested let bindings there are two cases:
	            //
	            // - Nested let bindings that were not renamed definitely should be
	            //   initialized explicitly:
	            //
	            //    { let x = 1; }
	            //    { let x; if (some-condition) { x = 1}; if (x) { /*1*/ } }
	            //
	            //   Without explicit initialization code in /*1*/ can be executed even if
	            //   some-condition is evaluated to false.
	            //
	            // - Renaming introduces fresh name that should not collide with any
	            //   existing names, however renamed bindings sometimes also should be
	            //   explicitly initialized. One particular case: non-captured binding
	            //   declared inside loop body (but not in loop initializer):
	            //
	            //    let x;
	            //    for (;;) {
	            //        let x;
	            //    }
	            //
	            //   In downlevel codegen inner 'x' will be renamed so it won't collide
	            //   with outer 'x' however it will should be reset on every iteration as
	            //   if it was declared anew.
	            //
	            //   * Why non-captured binding?
	            //     - Because if loop contains block scoped binding captured in some
	            //       function then loop body will be rewritten to have a fresh scope
	            //       on every iteration so everything will just work.
	            //
	            //   * Why loop initializer is excluded?
	            //     - Since we've introduced a fresh name it already will be undefined.
	            var flags = resolver.getNodeCheckFlags(node);
	            var isCapturedInFunction = flags & 131072 /* CapturedBlockScopedBinding */;
	            var isDeclaredInLoop = flags & 262144 /* BlockScopedBindingInLoop */;
	            var emittedAsTopLevel = (hierarchyFacts & 64 /* TopLevel */) !== 0
	                || (isCapturedInFunction
	                    && isDeclaredInLoop
	                    && (hierarchyFacts & 512 /* IterationStatementBlock */) !== 0);
	            var emitExplicitInitializer = !emittedAsTopLevel
	                && (hierarchyFacts & 2048 /* ForInOrForOfStatement */) === 0
	                && (!resolver.isDeclarationWithCollidingName(node)
	                    || (isDeclaredInLoop
	                        && !isCapturedInFunction
	                        && (hierarchyFacts & (1024 /* ForStatement */ | 2048 /* ForInOrForOfStatement */)) === 0));
	            return emitExplicitInitializer;
	        }
	        /**
	         * Visits a VariableDeclaration in a `let` declaration list.
	         *
	         * @param node A VariableDeclaration node.
	         */
	        function visitVariableDeclarationInLetDeclarationList(node) {
	            // For binding pattern names that lack initializers there is no point to emit
	            // explicit initializer since downlevel codegen for destructuring will fail
	            // in the absence of initializer so all binding elements will say uninitialized
	            var name = node.name;
	            if (ts.isBindingPattern(name)) {
	                return visitVariableDeclaration(node);
	            }
	            if (!node.initializer && shouldEmitExplicitInitializerForLetDeclaration(node)) {
	                var clone_2 = ts.getMutableClone(node);
	                clone_2.initializer = ts.createVoidZero();
	                return clone_2;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a VariableDeclaration node with a binding pattern.
	         *
	         * @param node A VariableDeclaration node.
	         */
	        function visitVariableDeclaration(node) {
	            var ancestorFacts = enterSubtree(32 /* ExportedVariableStatement */, 0 /* None */);
	            var updated;
	            if (ts.isBindingPattern(node.name)) {
	                updated = ts.flattenDestructuringBinding(node, visitor, context, 0 /* All */, 
	                /*value*/ undefined, (ancestorFacts & 32 /* ExportedVariableStatement */) !== 0);
	            }
	            else {
	                updated = ts.visitEachChild(node, visitor, context);
	            }
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        function recordLabel(node) {
	            convertedLoopState.labels.set(ts.idText(node.label), true);
	        }
	        function resetLabel(node) {
	            convertedLoopState.labels.set(ts.idText(node.label), false);
	        }
	        function visitLabeledStatement(node) {
	            if (convertedLoopState && !convertedLoopState.labels) {
	                convertedLoopState.labels = ts.createMap();
	            }
	            var statement = ts.unwrapInnermostStatementOfLabel(node, convertedLoopState && recordLabel);
	            return ts.isIterationStatement(statement, /*lookInLabeledStatements*/ false)
	                ? visitIterationStatement(statement, /*outermostLabeledStatement*/ node)
	                : ts.restoreEnclosingLabel(ts.visitNode(statement, visitor, ts.isStatement), node, convertedLoopState && resetLabel);
	        }
	        function visitIterationStatement(node, outermostLabeledStatement) {
	            switch (node.kind) {
	                case 216 /* DoStatement */:
	                case 217 /* WhileStatement */:
	                    return visitDoOrWhileStatement(node, outermostLabeledStatement);
	                case 218 /* ForStatement */:
	                    return visitForStatement(node, outermostLabeledStatement);
	                case 219 /* ForInStatement */:
	                    return visitForInStatement(node, outermostLabeledStatement);
	                case 220 /* ForOfStatement */:
	                    return visitForOfStatement(node, outermostLabeledStatement);
	            }
	        }
	        function visitIterationStatementWithFacts(excludeFacts, includeFacts, node, outermostLabeledStatement, convert) {
	            var ancestorFacts = enterSubtree(excludeFacts, includeFacts);
	            var updated = convertIterationStatementBodyIfNecessary(node, outermostLabeledStatement, convert);
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        function visitDoOrWhileStatement(node, outermostLabeledStatement) {
	            return visitIterationStatementWithFacts(0 /* DoOrWhileStatementExcludes */, 256 /* DoOrWhileStatementIncludes */, node, outermostLabeledStatement);
	        }
	        function visitForStatement(node, outermostLabeledStatement) {
	            return visitIterationStatementWithFacts(3008 /* ForStatementExcludes */, 1280 /* ForStatementIncludes */, node, outermostLabeledStatement);
	        }
	        function visitForInStatement(node, outermostLabeledStatement) {
	            return visitIterationStatementWithFacts(1984 /* ForInOrForOfStatementExcludes */, 2304 /* ForInOrForOfStatementIncludes */, node, outermostLabeledStatement);
	        }
	        function visitForOfStatement(node, outermostLabeledStatement) {
	            return visitIterationStatementWithFacts(1984 /* ForInOrForOfStatementExcludes */, 2304 /* ForInOrForOfStatementIncludes */, node, outermostLabeledStatement, compilerOptions.downlevelIteration ? convertForOfStatementForIterable : convertForOfStatementForArray);
	        }
	        function convertForOfStatementHead(node, boundValue, convertedLoopBodyStatements) {
	            var statements = [];
	            if (ts.isVariableDeclarationList(node.initializer)) {
	                if (node.initializer.flags & 3 /* BlockScoped */) {
	                    enableSubstitutionsForBlockScopedBindings();
	                }
	                var firstOriginalDeclaration = ts.firstOrUndefined(node.initializer.declarations);
	                if (firstOriginalDeclaration && ts.isBindingPattern(firstOriginalDeclaration.name)) {
	                    // This works whether the declaration is a var, let, or const.
	                    // It will use rhsIterationValue _a[_i] as the initializer.
	                    var declarations = ts.flattenDestructuringBinding(firstOriginalDeclaration, visitor, context, 0 /* All */, boundValue);
	                    var declarationList = ts.setTextRange(ts.createVariableDeclarationList(declarations), node.initializer);
	                    ts.setOriginalNode(declarationList, node.initializer);
	                    // Adjust the source map range for the first declaration to align with the old
	                    // emitter.
	                    var firstDeclaration = declarations[0];
	                    var lastDeclaration = ts.lastOrUndefined(declarations);
	                    ts.setSourceMapRange(declarationList, ts.createRange(firstDeclaration.pos, lastDeclaration.end));
	                    statements.push(ts.createVariableStatement(
	                    /*modifiers*/ undefined, declarationList));
	                }
	                else {
	                    // The following call does not include the initializer, so we have
	                    // to emit it separately.
	                    statements.push(ts.setTextRange(ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.setOriginalNode(ts.setTextRange(ts.createVariableDeclarationList([
	                        ts.createVariableDeclaration(firstOriginalDeclaration ? firstOriginalDeclaration.name : ts.createTempVariable(/*recordTempVariable*/ undefined), 
	                        /*type*/ undefined, boundValue)
	                    ]), ts.moveRangePos(node.initializer, -1)), node.initializer)), ts.moveRangeEnd(node.initializer, -1)));
	                }
	            }
	            else {
	                // Initializer is an expression. Emit the expression in the body, so that it's
	                // evaluated on every iteration.
	                var assignment = ts.createAssignment(node.initializer, boundValue);
	                if (ts.isDestructuringAssignment(assignment)) {
	                    ts.aggregateTransformFlags(assignment);
	                    statements.push(ts.createStatement(visitBinaryExpression(assignment, /*needsDestructuringValue*/ false)));
	                }
	                else {
	                    assignment.end = node.initializer.end;
	                    statements.push(ts.setTextRange(ts.createStatement(ts.visitNode(assignment, visitor, ts.isExpression)), ts.moveRangeEnd(node.initializer, -1)));
	                }
	            }
	            var bodyLocation;
	            var statementsLocation;
	            if (convertedLoopBodyStatements) {
	                ts.addRange(statements, convertedLoopBodyStatements);
	            }
	            else {
	                var statement = ts.visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock);
	                if (ts.isBlock(statement)) {
	                    ts.addRange(statements, statement.statements);
	                    bodyLocation = statement;
	                    statementsLocation = statement.statements;
	                }
	                else {
	                    statements.push(statement);
	                }
	            }
	            // The old emitter does not emit source maps for the block.
	            // We add the location to preserve comments.
	            return ts.setEmitFlags(ts.setTextRange(ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), statementsLocation), 
	            /*multiLine*/ true), bodyLocation), 48 /* NoSourceMap */ | 384 /* NoTokenSourceMaps */);
	        }
	        function convertForOfStatementForArray(node, outermostLabeledStatement, convertedLoopBodyStatements) {
	            // The following ES6 code:
	            //
	            //    for (let v of expr) { }
	            //
	            // should be emitted as
	            //
	            //    for (var _i = 0, _a = expr; _i < _a.length; _i++) {
	            //        var v = _a[_i];
	            //    }
	            //
	            // where _a and _i are temps emitted to capture the RHS and the counter,
	            // respectively.
	            // When the left hand side is an expression instead of a let declaration,
	            // the "let v" is not emitted.
	            // When the left hand side is a let/const, the v is renamed if there is
	            // another v in scope.
	            // Note that all assignments to the LHS are emitted in the body, including
	            // all destructuring.
	            // Note also that because an extra statement is needed to assign to the LHS,
	            // for-of bodies are always emitted as blocks.
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            // In the case where the user wrote an identifier as the RHS, like this:
	            //
	            //     for (let v of arr) { }
	            //
	            // we don't want to emit a temporary variable for the RHS, just use it directly.
	            var counter = ts.createLoopVariable();
	            var rhsReference = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(expression) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            // The old emitter does not emit source maps for the expression
	            ts.setEmitFlags(expression, 48 /* NoSourceMap */ | ts.getEmitFlags(expression));
	            var forStatement = ts.setTextRange(ts.createFor(
	            /*initializer*/ ts.setEmitFlags(ts.setTextRange(ts.createVariableDeclarationList([
	                ts.setTextRange(ts.createVariableDeclaration(counter, /*type*/ undefined, ts.createLiteral(0)), ts.moveRangePos(node.expression, -1)),
	                ts.setTextRange(ts.createVariableDeclaration(rhsReference, /*type*/ undefined, expression), node.expression)
	            ]), node.expression), 2097152 /* NoHoisting */), 
	            /*condition*/ ts.setTextRange(ts.createLessThan(counter, ts.createPropertyAccess(rhsReference, "length")), node.expression), 
	            /*incrementor*/ ts.setTextRange(ts.createPostfixIncrement(counter), node.expression), 
	            /*statement*/ convertForOfStatementHead(node, ts.createElementAccess(rhsReference, counter), convertedLoopBodyStatements)), 
	            /*location*/ node);
	            // Disable trailing source maps for the OpenParenToken to align source map emit with the old emitter.
	            ts.setEmitFlags(forStatement, 256 /* NoTokenTrailingSourceMaps */);
	            ts.setTextRange(forStatement, node);
	            return ts.restoreEnclosingLabel(forStatement, outermostLabeledStatement, convertedLoopState && resetLabel);
	        }
	        function convertForOfStatementForIterable(node, outermostLabeledStatement, convertedLoopBodyStatements) {
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            var iterator = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(expression) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var result = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(iterator) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var errorRecord = ts.createUniqueName("e");
	            var catchVariable = ts.getGeneratedNameForNode(errorRecord);
	            var returnMethod = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var values = ts.createValuesHelper(context, expression, node.expression);
	            var next = ts.createCall(ts.createPropertyAccess(iterator, "next"), /*typeArguments*/ undefined, []);
	            hoistVariableDeclaration(errorRecord);
	            hoistVariableDeclaration(returnMethod);
	            var forStatement = ts.setEmitFlags(ts.setTextRange(ts.createFor(
	            /*initializer*/ ts.setEmitFlags(ts.setTextRange(ts.createVariableDeclarationList([
	                ts.setTextRange(ts.createVariableDeclaration(iterator, /*type*/ undefined, values), node.expression),
	                ts.createVariableDeclaration(result, /*type*/ undefined, next)
	            ]), node.expression), 2097152 /* NoHoisting */), 
	            /*condition*/ ts.createLogicalNot(ts.createPropertyAccess(result, "done")), 
	            /*incrementor*/ ts.createAssignment(result, next), 
	            /*statement*/ convertForOfStatementHead(node, ts.createPropertyAccess(result, "value"), convertedLoopBodyStatements)), 
	            /*location*/ node), 256 /* NoTokenTrailingSourceMaps */);
	            return ts.createTry(ts.createBlock([
	                ts.restoreEnclosingLabel(forStatement, outermostLabeledStatement, convertedLoopState && resetLabel)
	            ]), ts.createCatchClause(ts.createVariableDeclaration(catchVariable), ts.setEmitFlags(ts.createBlock([
	                ts.createStatement(ts.createAssignment(errorRecord, ts.createObjectLiteral([
	                    ts.createPropertyAssignment("error", catchVariable)
	                ])))
	            ]), 1 /* SingleLine */)), ts.createBlock([
	                ts.createTry(
	                /*tryBlock*/ ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(ts.createLogicalAnd(ts.createLogicalAnd(result, ts.createLogicalNot(ts.createPropertyAccess(result, "done"))), ts.createAssignment(returnMethod, ts.createPropertyAccess(iterator, "return"))), ts.createStatement(ts.createFunctionCall(returnMethod, iterator, []))), 1 /* SingleLine */),
	                ]), 
	                /*catchClause*/ undefined, 
	                /*finallyBlock*/ ts.setEmitFlags(ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(errorRecord, ts.createThrow(ts.createPropertyAccess(errorRecord, "error"))), 1 /* SingleLine */)
	                ]), 1 /* SingleLine */))
	            ]));
	        }
	        /**
	         * Visits an ObjectLiteralExpression with computed property names.
	         *
	         * @param node An ObjectLiteralExpression node.
	         */
	        function visitObjectLiteralExpression(node) {
	            // We are here because a ComputedPropertyName was used somewhere in the expression.
	            var properties = node.properties;
	            var numProperties = properties.length;
	            // Find the first computed property.
	            // Everything until that point can be emitted as part of the initial object literal.
	            var numInitialProperties = numProperties;
	            var numInitialPropertiesWithoutYield = numProperties;
	            for (var i = 0; i < numProperties; i++) {
	                var property = properties[i];
	                if ((property.transformFlags & 16777216 /* ContainsYield */ && hierarchyFacts & 4 /* AsyncFunctionBody */)
	                    && i < numInitialPropertiesWithoutYield) {
	                    numInitialPropertiesWithoutYield = i;
	                }
	                if (property.name.kind === 146 /* ComputedPropertyName */) {
	                    numInitialProperties = i;
	                    break;
	                }
	            }
	            if (numInitialProperties !== numProperties) {
	                if (numInitialPropertiesWithoutYield < numInitialProperties) {
	                    numInitialProperties = numInitialPropertiesWithoutYield;
	                }
	                // For computed properties, we need to create a unique handle to the object
	                // literal so we can modify it without risking internal assignments tainting the object.
	                var temp = ts.createTempVariable(hoistVariableDeclaration);
	                // Write out the first non-computed properties, then emit the rest through indexing on the temp variable.
	                var expressions = [];
	                var assignment = ts.createAssignment(temp, ts.setEmitFlags(ts.createObjectLiteral(ts.visitNodes(properties, visitor, ts.isObjectLiteralElementLike, 0, numInitialProperties), node.multiLine), 65536 /* Indented */));
	                if (node.multiLine) {
	                    ts.startOnNewLine(assignment);
	                }
	                expressions.push(assignment);
	                addObjectLiteralMembers(expressions, node, temp, numInitialProperties);
	                // We need to clone the temporary identifier so that we can write it on a
	                // new line
	                expressions.push(node.multiLine ? ts.startOnNewLine(ts.getMutableClone(temp)) : temp);
	                return ts.inlineExpressions(expressions);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function shouldConvertIterationStatementBody(node) {
	            return (resolver.getNodeCheckFlags(node) & 65536 /* LoopWithCapturedBlockScopedBinding */) !== 0;
	        }
	        /**
	         * Records constituents of name for the given variable to be hoisted in the outer scope.
	         */
	        function hoistVariableDeclarationDeclaredInConvertedLoop(state, node) {
	            if (!state.hoistedLocalVariables) {
	                state.hoistedLocalVariables = [];
	            }
	            visit(node.name);
	            function visit(node) {
	                if (node.kind === 71 /* Identifier */) {
	                    state.hoistedLocalVariables.push(node);
	                }
	                else {
	                    for (var _i = 0, _a = node.elements; _i < _a.length; _i++) {
	                        var element = _a[_i];
	                        if (!ts.isOmittedExpression(element)) {
	                            visit(element.name);
	                        }
	                    }
	                }
	            }
	        }
	        function convertIterationStatementBodyIfNecessary(node, outermostLabeledStatement, convert) {
	            if (!shouldConvertIterationStatementBody(node)) {
	                var saveAllowedNonLabeledJumps = void 0;
	                if (convertedLoopState) {
	                    // we get here if we are trying to emit normal loop loop inside converted loop
	                    // set allowedNonLabeledJumps to Break | Continue to mark that break\continue inside the loop should be emitted as is
	                    saveAllowedNonLabeledJumps = convertedLoopState.allowedNonLabeledJumps;
	                    convertedLoopState.allowedNonLabeledJumps = 2 /* Break */ | 4 /* Continue */;
	                }
	                var result = convert
	                    ? convert(node, outermostLabeledStatement, /*convertedLoopBodyStatements*/ undefined)
	                    : ts.restoreEnclosingLabel(ts.visitEachChild(node, visitor, context), outermostLabeledStatement, convertedLoopState && resetLabel);
	                if (convertedLoopState) {
	                    convertedLoopState.allowedNonLabeledJumps = saveAllowedNonLabeledJumps;
	                }
	                return result;
	            }
	            var functionName = ts.createUniqueName("_loop");
	            var loopInitializer;
	            switch (node.kind) {
	                case 218 /* ForStatement */:
	                case 219 /* ForInStatement */:
	                case 220 /* ForOfStatement */:
	                    var initializer = node.initializer;
	                    if (initializer && initializer.kind === 231 /* VariableDeclarationList */) {
	                        loopInitializer = initializer;
	                    }
	                    break;
	            }
	            // variables that will be passed to the loop as parameters
	            var loopParameters = [];
	            // variables declared in the loop initializer that will be changed inside the loop
	            var loopOutParameters = [];
	            if (loopInitializer && (ts.getCombinedNodeFlags(loopInitializer) & 3 /* BlockScoped */)) {
	                for (var _i = 0, _a = loopInitializer.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    processLoopVariableDeclaration(decl, loopParameters, loopOutParameters);
	                }
	            }
	            var outerConvertedLoopState = convertedLoopState;
	            convertedLoopState = { loopOutParameters: loopOutParameters };
	            if (outerConvertedLoopState) {
	                // convertedOuterLoopState !== undefined means that this converted loop is nested in another converted loop.
	                // if outer converted loop has already accumulated some state - pass it through
	                if (outerConvertedLoopState.argumentsName) {
	                    // outer loop has already used 'arguments' so we've already have some name to alias it
	                    // use the same name in all nested loops
	                    convertedLoopState.argumentsName = outerConvertedLoopState.argumentsName;
	                }
	                if (outerConvertedLoopState.thisName) {
	                    // outer loop has already used 'this' so we've already have some name to alias it
	                    // use the same name in all nested loops
	                    convertedLoopState.thisName = outerConvertedLoopState.thisName;
	                }
	                if (outerConvertedLoopState.hoistedLocalVariables) {
	                    // we've already collected some non-block scoped variable declarations in enclosing loop
	                    // use the same storage in nested loop
	                    convertedLoopState.hoistedLocalVariables = outerConvertedLoopState.hoistedLocalVariables;
	                }
	            }
	            startLexicalEnvironment();
	            var loopBody = ts.visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock);
	            var lexicalEnvironment = endLexicalEnvironment();
	            var currentState = convertedLoopState;
	            convertedLoopState = outerConvertedLoopState;
	            if (loopOutParameters.length || lexicalEnvironment) {
	                var statements_4 = ts.isBlock(loopBody) ? loopBody.statements.slice() : [loopBody];
	                if (loopOutParameters.length) {
	                    copyOutParameters(loopOutParameters, 1 /* ToOutParameter */, statements_4);
	                }
	                ts.addRange(statements_4, lexicalEnvironment);
	                loopBody = ts.createBlock(statements_4, /*multiline*/ true);
	            }
	            if (ts.isBlock(loopBody)) {
	                loopBody.multiLine = true;
	            }
	            else {
	                loopBody = ts.createBlock([loopBody], /*multiline*/ true);
	            }
	            var containsYield = (node.statement.transformFlags & 16777216 /* ContainsYield */) !== 0;
	            var isAsyncBlockContainingAwait = containsYield && (hierarchyFacts & 4 /* AsyncFunctionBody */) !== 0;
	            var loopBodyFlags = 0;
	            if (currentState.containsLexicalThis) {
	                loopBodyFlags |= 8 /* CapturesThis */;
	            }
	            if (isAsyncBlockContainingAwait) {
	                loopBodyFlags |= 262144 /* AsyncFunctionBody */;
	            }
	            var convertedLoopVariable = ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.setEmitFlags(ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(functionName, 
	                /*type*/ undefined, ts.setEmitFlags(ts.createFunctionExpression(
	                /*modifiers*/ undefined, containsYield ? ts.createToken(39 /* AsteriskToken */) : undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, loopParameters, 
	                /*type*/ undefined, loopBody), loopBodyFlags))
	            ]), 2097152 /* NoHoisting */));
	            var statements = [convertedLoopVariable];
	            var extraVariableDeclarations;
	            // propagate state from the inner loop to the outer loop if necessary
	            if (currentState.argumentsName) {
	                // if alias for arguments is set
	                if (outerConvertedLoopState) {
	                    // pass it to outer converted loop
	                    outerConvertedLoopState.argumentsName = currentState.argumentsName;
	                }
	                else {
	                    // this is top level converted loop and we need to create an alias for 'arguments' object
	                    (extraVariableDeclarations || (extraVariableDeclarations = [])).push(ts.createVariableDeclaration(currentState.argumentsName, 
	                    /*type*/ undefined, ts.createIdentifier("arguments")));
	                }
	            }
	            if (currentState.thisName) {
	                // if alias for this is set
	                if (outerConvertedLoopState) {
	                    // pass it to outer converted loop
	                    outerConvertedLoopState.thisName = currentState.thisName;
	                }
	                else {
	                    // this is top level converted loop so we need to create an alias for 'this' here
	                    // NOTE:
	                    // if converted loops were all nested in arrow function then we'll always emit '_this' so convertedLoopState.thisName will not be set.
	                    // If it is set this means that all nested loops are not nested in arrow function and it is safe to capture 'this'.
	                    (extraVariableDeclarations || (extraVariableDeclarations = [])).push(ts.createVariableDeclaration(currentState.thisName, 
	                    /*type*/ undefined, ts.createIdentifier("this")));
	                }
	            }
	            if (currentState.hoistedLocalVariables) {
	                // if hoistedLocalVariables !== undefined this means that we've possibly collected some variable declarations to be hoisted later
	                if (outerConvertedLoopState) {
	                    // pass them to outer converted loop
	                    outerConvertedLoopState.hoistedLocalVariables = currentState.hoistedLocalVariables;
	                }
	                else {
	                    if (!extraVariableDeclarations) {
	                        extraVariableDeclarations = [];
	                    }
	                    // hoist collected variable declarations
	                    for (var _b = 0, _c = currentState.hoistedLocalVariables; _b < _c.length; _b++) {
	                        var identifier = _c[_b];
	                        extraVariableDeclarations.push(ts.createVariableDeclaration(identifier));
	                    }
	                }
	            }
	            // add extra variables to hold out parameters if necessary
	            if (loopOutParameters.length) {
	                if (!extraVariableDeclarations) {
	                    extraVariableDeclarations = [];
	                }
	                for (var _d = 0, loopOutParameters_1 = loopOutParameters; _d < loopOutParameters_1.length; _d++) {
	                    var outParam = loopOutParameters_1[_d];
	                    extraVariableDeclarations.push(ts.createVariableDeclaration(outParam.outParamName));
	                }
	            }
	            // create variable statement to hold all introduced variable declarations
	            if (extraVariableDeclarations) {
	                statements.push(ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList(extraVariableDeclarations)));
	            }
	            var convertedLoopBodyStatements = generateCallToConvertedLoop(functionName, loopParameters, currentState, containsYield);
	            var loop;
	            if (convert) {
	                loop = convert(node, outermostLabeledStatement, convertedLoopBodyStatements);
	            }
	            else {
	                var clone_3 = ts.getMutableClone(node);
	                // clean statement part
	                clone_3.statement = undefined;
	                // visit childnodes to transform initializer/condition/incrementor parts
	                clone_3 = ts.visitEachChild(clone_3, visitor, context);
	                // set loop statement
	                clone_3.statement = ts.createBlock(convertedLoopBodyStatements, /*multiline*/ true);
	                // reset and re-aggregate the transform flags
	                clone_3.transformFlags = 0;
	                ts.aggregateTransformFlags(clone_3);
	                loop = ts.restoreEnclosingLabel(clone_3, outermostLabeledStatement, convertedLoopState && resetLabel);
	            }
	            statements.push(loop);
	            return statements;
	        }
	        function copyOutParameter(outParam, copyDirection) {
	            var source = copyDirection === 0 /* ToOriginal */ ? outParam.outParamName : outParam.originalName;
	            var target = copyDirection === 0 /* ToOriginal */ ? outParam.originalName : outParam.outParamName;
	            return ts.createBinary(target, 58 /* EqualsToken */, source);
	        }
	        function copyOutParameters(outParams, copyDirection, statements) {
	            for (var _i = 0, outParams_1 = outParams; _i < outParams_1.length; _i++) {
	                var outParam = outParams_1[_i];
	                statements.push(ts.createStatement(copyOutParameter(outParam, copyDirection)));
	            }
	        }
	        function generateCallToConvertedLoop(loopFunctionExpressionName, parameters, state, isAsyncBlockContainingAwait) {
	            var outerConvertedLoopState = convertedLoopState;
	            var statements = [];
	            // loop is considered simple if it does not have any return statements or break\continue that transfer control outside of the loop
	            // simple loops are emitted as just 'loop()';
	            // NOTE: if loop uses only 'continue' it still will be emitted as simple loop
	            var isSimpleLoop = !(state.nonLocalJumps & ~4 /* Continue */) &&
	                !state.labeledNonLocalBreaks &&
	                !state.labeledNonLocalContinues;
	            var call = ts.createCall(loopFunctionExpressionName, /*typeArguments*/ undefined, ts.map(parameters, function (p) { return p.name; }));
	            var callResult = isAsyncBlockContainingAwait
	                ? ts.createYield(ts.createToken(39 /* AsteriskToken */), ts.setEmitFlags(call, 8388608 /* Iterator */))
	                : call;
	            if (isSimpleLoop) {
	                statements.push(ts.createStatement(callResult));
	                copyOutParameters(state.loopOutParameters, 0 /* ToOriginal */, statements);
	            }
	            else {
	                var loopResultName = ts.createUniqueName("state");
	                var stateVariable = ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(loopResultName, /*type*/ undefined, callResult)]));
	                statements.push(stateVariable);
	                copyOutParameters(state.loopOutParameters, 0 /* ToOriginal */, statements);
	                if (state.nonLocalJumps & 8 /* Return */) {
	                    var returnStatement = void 0;
	                    if (outerConvertedLoopState) {
	                        outerConvertedLoopState.nonLocalJumps |= 8 /* Return */;
	                        returnStatement = ts.createReturn(loopResultName);
	                    }
	                    else {
	                        returnStatement = ts.createReturn(ts.createPropertyAccess(loopResultName, "value"));
	                    }
	                    statements.push(ts.createIf(ts.createBinary(ts.createTypeOf(loopResultName), 34 /* EqualsEqualsEqualsToken */, ts.createLiteral("object")), returnStatement));
	                }
	                if (state.nonLocalJumps & 2 /* Break */) {
	                    statements.push(ts.createIf(ts.createBinary(loopResultName, 34 /* EqualsEqualsEqualsToken */, ts.createLiteral("break")), ts.createBreak()));
	                }
	                if (state.labeledNonLocalBreaks || state.labeledNonLocalContinues) {
	                    var caseClauses = [];
	                    processLabeledJumps(state.labeledNonLocalBreaks, /*isBreak*/ true, loopResultName, outerConvertedLoopState, caseClauses);
	                    processLabeledJumps(state.labeledNonLocalContinues, /*isBreak*/ false, loopResultName, outerConvertedLoopState, caseClauses);
	                    statements.push(ts.createSwitch(loopResultName, ts.createCaseBlock(caseClauses)));
	                }
	            }
	            return statements;
	        }
	        function setLabeledJump(state, isBreak, labelText, labelMarker) {
	            if (isBreak) {
	                if (!state.labeledNonLocalBreaks) {
	                    state.labeledNonLocalBreaks = ts.createMap();
	                }
	                state.labeledNonLocalBreaks.set(labelText, labelMarker);
	            }
	            else {
	                if (!state.labeledNonLocalContinues) {
	                    state.labeledNonLocalContinues = ts.createMap();
	                }
	                state.labeledNonLocalContinues.set(labelText, labelMarker);
	            }
	        }
	        function processLabeledJumps(table, isBreak, loopResultName, outerLoop, caseClauses) {
	            if (!table) {
	                return;
	            }
	            table.forEach(function (labelMarker, labelText) {
	                var statements = [];
	                // if there are no outer converted loop or outer label in question is located inside outer converted loop
	                // then emit labeled break\continue
	                // otherwise propagate pair 'label -> marker' to outer converted loop and emit 'return labelMarker' so outer loop can later decide what to do
	                if (!outerLoop || (outerLoop.labels && outerLoop.labels.get(labelText))) {
	                    var label = ts.createIdentifier(labelText);
	                    statements.push(isBreak ? ts.createBreak(label) : ts.createContinue(label));
	                }
	                else {
	                    setLabeledJump(outerLoop, isBreak, labelText, labelMarker);
	                    statements.push(ts.createReturn(loopResultName));
	                }
	                caseClauses.push(ts.createCaseClause(ts.createLiteral(labelMarker), statements));
	            });
	        }
	        function processLoopVariableDeclaration(decl, loopParameters, loopOutParameters) {
	            var name = decl.name;
	            if (ts.isBindingPattern(name)) {
	                for (var _i = 0, _a = name.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        processLoopVariableDeclaration(element, loopParameters, loopOutParameters);
	                    }
	                }
	            }
	            else {
	                loopParameters.push(ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, name));
	                if (resolver.getNodeCheckFlags(decl) & 2097152 /* NeedsLoopOutParameter */) {
	                    var outParamName = ts.createUniqueName("out_" + ts.idText(name));
	                    loopOutParameters.push({ originalName: name, outParamName: outParamName });
	                }
	            }
	        }
	        /**
	         * Adds the members of an object literal to an array of expressions.
	         *
	         * @param expressions An array of expressions.
	         * @param node An ObjectLiteralExpression node.
	         * @param receiver The receiver for members of the ObjectLiteralExpression.
	         * @param numInitialNonComputedProperties The number of initial properties without
	         *                                        computed property names.
	         */
	        function addObjectLiteralMembers(expressions, node, receiver, start) {
	            var properties = node.properties;
	            var numProperties = properties.length;
	            for (var i = start; i < numProperties; i++) {
	                var property = properties[i];
	                switch (property.kind) {
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        var accessors = ts.getAllAccessorDeclarations(node.properties, property);
	                        if (property === accessors.firstAccessor) {
	                            expressions.push(transformAccessorsToExpression(receiver, accessors, node, node.multiLine));
	                        }
	                        break;
	                    case 153 /* MethodDeclaration */:
	                        expressions.push(transformObjectLiteralMethodDeclarationToExpression(property, receiver, node, node.multiLine));
	                        break;
	                    case 268 /* PropertyAssignment */:
	                        expressions.push(transformPropertyAssignmentToExpression(property, receiver, node.multiLine));
	                        break;
	                    case 269 /* ShorthandPropertyAssignment */:
	                        expressions.push(transformShorthandPropertyAssignmentToExpression(property, receiver, node.multiLine));
	                        break;
	                    default:
	                        ts.Debug.failBadSyntaxKind(node);
	                        break;
	                }
	            }
	        }
	        /**
	         * Transforms a PropertyAssignment node into an expression.
	         *
	         * @param node The ObjectLiteralExpression that contains the PropertyAssignment.
	         * @param property The PropertyAssignment node.
	         * @param receiver The receiver for the assignment.
	         */
	        function transformPropertyAssignmentToExpression(property, receiver, startsOnNewLine) {
	            var expression = ts.createAssignment(ts.createMemberAccessForPropertyName(receiver, ts.visitNode(property.name, visitor, ts.isPropertyName)), ts.visitNode(property.initializer, visitor, ts.isExpression));
	            ts.setTextRange(expression, property);
	            if (startsOnNewLine) {
	                ts.startOnNewLine(expression);
	            }
	            return expression;
	        }
	        /**
	         * Transforms a ShorthandPropertyAssignment node into an expression.
	         *
	         * @param node The ObjectLiteralExpression that contains the ShorthandPropertyAssignment.
	         * @param property The ShorthandPropertyAssignment node.
	         * @param receiver The receiver for the assignment.
	         */
	        function transformShorthandPropertyAssignmentToExpression(property, receiver, startsOnNewLine) {
	            var expression = ts.createAssignment(ts.createMemberAccessForPropertyName(receiver, ts.visitNode(property.name, visitor, ts.isPropertyName)), ts.getSynthesizedClone(property.name));
	            ts.setTextRange(expression, property);
	            if (startsOnNewLine) {
	                ts.startOnNewLine(expression);
	            }
	            return expression;
	        }
	        /**
	         * Transforms a MethodDeclaration of an ObjectLiteralExpression into an expression.
	         *
	         * @param node The ObjectLiteralExpression that contains the MethodDeclaration.
	         * @param method The MethodDeclaration node.
	         * @param receiver The receiver for the assignment.
	         */
	        function transformObjectLiteralMethodDeclarationToExpression(method, receiver, container, startsOnNewLine) {
	            var ancestorFacts = enterSubtree(0 /* None */, 0 /* None */);
	            var expression = ts.createAssignment(ts.createMemberAccessForPropertyName(receiver, ts.visitNode(method.name, visitor, ts.isPropertyName)), transformFunctionLikeToExpression(method, /*location*/ method, /*name*/ undefined, container));
	            ts.setTextRange(expression, method);
	            if (startsOnNewLine) {
	                ts.startOnNewLine(expression);
	            }
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, hierarchyFacts & 49152 /* PropagateNewTargetMask */ ? 16384 /* NewTarget */ : 0 /* None */);
	            return expression;
	        }
	        function visitCatchClause(node) {
	            var ancestorFacts = enterSubtree(4032 /* BlockScopeExcludes */, 0 /* BlockScopeIncludes */);
	            var updated;
	            ts.Debug.assert(!!node.variableDeclaration, "Catch clause variable should always be present when downleveling ES2015.");
	            if (ts.isBindingPattern(node.variableDeclaration.name)) {
	                var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	                var newVariableDeclaration = ts.createVariableDeclaration(temp);
	                ts.setTextRange(newVariableDeclaration, node.variableDeclaration);
	                var vars = ts.flattenDestructuringBinding(node.variableDeclaration, visitor, context, 0 /* All */, temp);
	                var list = ts.createVariableDeclarationList(vars);
	                ts.setTextRange(list, node.variableDeclaration);
	                var destructure = ts.createVariableStatement(/*modifiers*/ undefined, list);
	                updated = ts.updateCatchClause(node, newVariableDeclaration, addStatementToStartOfBlock(node.block, destructure));
	            }
	            else {
	                updated = ts.visitEachChild(node, visitor, context);
	            }
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        function addStatementToStartOfBlock(block, statement) {
	            var transformedStatements = ts.visitNodes(block.statements, visitor, ts.isStatement);
	            return ts.updateBlock(block, [statement].concat(transformedStatements));
	        }
	        /**
	         * Visits a MethodDeclaration of an ObjectLiteralExpression and transforms it into a
	         * PropertyAssignment.
	         *
	         * @param node A MethodDeclaration node.
	         */
	        function visitMethodDeclaration(node) {
	            // We should only get here for methods on an object literal with regular identifier names.
	            // Methods on classes are handled in visitClassDeclaration/visitClassExpression.
	            // Methods with computed property names are handled in visitObjectLiteralExpression.
	            ts.Debug.assert(!ts.isComputedPropertyName(node.name));
	            var functionExpression = transformFunctionLikeToExpression(node, /*location*/ ts.moveRangePos(node, -1), /*name*/ undefined, /*container*/ undefined);
	            ts.setEmitFlags(functionExpression, 512 /* NoLeadingComments */ | ts.getEmitFlags(functionExpression));
	            return ts.setTextRange(ts.createPropertyAssignment(node.name, functionExpression), 
	            /*location*/ node);
	        }
	        /**
	         * Visits an AccessorDeclaration of an ObjectLiteralExpression.
	         *
	         * @param node An AccessorDeclaration node.
	         */
	        function visitAccessorDeclaration(node) {
	            ts.Debug.assert(!ts.isComputedPropertyName(node.name));
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */);
	            var updated;
	            if (node.transformFlags & 32768 /* ContainsCapturedLexicalThis */) {
	                var parameters = ts.visitParameterList(node.parameters, visitor, context);
	                var body = transformFunctionBody(node);
	                if (node.kind === 155 /* GetAccessor */) {
	                    updated = ts.updateGetAccessor(node, node.decorators, node.modifiers, node.name, parameters, node.type, body);
	                }
	                else {
	                    updated = ts.updateSetAccessor(node, node.decorators, node.modifiers, node.name, parameters, body);
	                }
	            }
	            else {
	                updated = ts.visitEachChild(node, visitor, context);
	            }
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return updated;
	        }
	        /**
	         * Visits a ShorthandPropertyAssignment and transforms it into a PropertyAssignment.
	         *
	         * @param node A ShorthandPropertyAssignment node.
	         */
	        function visitShorthandPropertyAssignment(node) {
	            return ts.setTextRange(ts.createPropertyAssignment(node.name, ts.getSynthesizedClone(node.name)), 
	            /*location*/ node);
	        }
	        function visitComputedPropertyName(node) {
	            var ancestorFacts = enterSubtree(0 /* ComputedPropertyNameExcludes */, 8192 /* ComputedPropertyNameIncludes */);
	            var updated = ts.visitEachChild(node, visitor, context);
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, hierarchyFacts & 49152 /* PropagateNewTargetMask */ ? 32768 /* NewTargetInComputedPropertyName */ : 0 /* None */);
	            return updated;
	        }
	        /**
	         * Visits a YieldExpression node.
	         *
	         * @param node A YieldExpression node.
	         */
	        function visitYieldExpression(node) {
	            // `yield` expressions are transformed using the generators transformer.
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits an ArrayLiteralExpression that contains a spread element.
	         *
	         * @param node An ArrayLiteralExpression node.
	         */
	        function visitArrayLiteralExpression(node) {
	            if (node.transformFlags & 64 /* ES2015 */) {
	                // We are here because we contain a SpreadElementExpression.
	                return transformAndSpreadElements(node.elements, /*needsUniqueCopy*/ true, node.multiLine, /*hasTrailingComma*/ node.elements.hasTrailingComma);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a CallExpression that contains either a spread element or `super`.
	         *
	         * @param node a CallExpression.
	         */
	        function visitCallExpression(node) {
	            if (ts.getEmitFlags(node) & 33554432 /* TypeScriptClassWrapper */) {
	                return visitTypeScriptClassWrapper(node);
	            }
	            if (node.transformFlags & 64 /* ES2015 */) {
	                return visitCallExpressionWithPotentialCapturedThisAssignment(node, /*assignToCapturedThis*/ true);
	            }
	            return ts.updateCall(node, ts.visitNode(node.expression, callExpressionVisitor, ts.isExpression), 
	            /*typeArguments*/ undefined, ts.visitNodes(node.arguments, visitor, ts.isExpression));
	        }
	        function visitTypeScriptClassWrapper(node) {
	            // This is a call to a class wrapper function (an IIFE) created by the 'ts' transformer.
	            // The wrapper has a form similar to:
	            //
	            //  (function() {
	            //      class C { // 1
	            //      }
	            //      C.x = 1; // 2
	            //      return C;
	            //  }())
	            //
	            // When we transform the class, we end up with something like this:
	            //
	            //  (function () {
	            //      var C = (function () { // 3
	            //          function C() {
	            //          }
	            //          return C; // 4
	            //      }());
	            //      C.x = 1;
	            //      return C;
	            //  }())
	            //
	            // We want to simplify the two nested IIFEs to end up with something like this:
	            //
	            //  (function () {
	            //      function C() {
	            //      }
	            //      C.x = 1;
	            //      return C;
	            //  }())
	            // We skip any outer expressions in a number of places to get to the innermost
	            // expression, but we will restore them later to preserve comments and source maps.
	            var body = ts.cast(ts.cast(ts.skipOuterExpressions(node.expression), ts.isArrowFunction).body, ts.isBlock);
	            // The class statements are the statements generated by visiting the first statement of the
	            // body (1), while all other statements are added to remainingStatements (2)
	            var classStatements = ts.visitNodes(body.statements, visitor, ts.isStatement, 0, 1);
	            var remainingStatements = ts.visitNodes(body.statements, visitor, ts.isStatement, 1, body.statements.length - 1);
	            var varStatement = ts.cast(ts.firstOrUndefined(classStatements), ts.isVariableStatement);
	            // We know there is only one variable declaration here as we verified this in an
	            // earlier call to isTypeScriptClassWrapper
	            var variable = varStatement.declarationList.declarations[0];
	            var initializer = ts.skipOuterExpressions(variable.initializer);
	            // Under certain conditions, the 'ts' transformer may introduce a class alias, which
	            // we see as an assignment, for example:
	            //
	            //  (function () {
	            //      var C = C_1 = (function () {
	            //          function C() {
	            //          }
	            //          C.x = function () { return C_1; }
	            //          return C;
	            //      }());
	            //      C = C_1 = __decorate([dec], C);
	            //      return C;
	            //      var C_1;
	            //  }())
	            //
	            var aliasAssignment = ts.tryCast(initializer, ts.isAssignmentExpression);
	            // The underlying call (3) is another IIFE that may contain a '_super' argument.
	            var call = ts.cast(aliasAssignment ? ts.skipOuterExpressions(aliasAssignment.right) : initializer, ts.isCallExpression);
	            var func = ts.cast(ts.skipOuterExpressions(call.expression), ts.isFunctionExpression);
	            var funcStatements = func.body.statements;
	            var classBodyStart = 0;
	            var classBodyEnd = -1;
	            var statements = [];
	            if (aliasAssignment) {
	                // If we have a class alias assignment, we need to move it to the down-level constructor
	                // function we generated for the class.
	                var extendsCall = ts.tryCast(funcStatements[classBodyStart], ts.isExpressionStatement);
	                if (extendsCall) {
	                    statements.push(extendsCall);
	                    classBodyStart++;
	                }
	                // The next statement is the function declaration.
	                statements.push(funcStatements[classBodyStart]);
	                classBodyStart++;
	                // Add the class alias following the declaration.
	                statements.push(ts.createStatement(ts.createAssignment(aliasAssignment.left, ts.cast(variable.name, ts.isIdentifier))));
	            }
	            // Find the trailing 'return' statement (4)
	            while (!ts.isReturnStatement(ts.elementAt(funcStatements, classBodyEnd))) {
	                classBodyEnd--;
	            }
	            // When we extract the statements of the inner IIFE, we exclude the 'return' statement (4)
	            // as we already have one that has been introduced by the 'ts' transformer.
	            ts.addRange(statements, funcStatements, classBodyStart, classBodyEnd);
	            if (classBodyEnd < -1) {
	                // If there were any hoisted declarations following the return statement, we should
	                // append them.
	                ts.addRange(statements, funcStatements, classBodyEnd + 1);
	            }
	            // Add the remaining statements of the outer wrapper.
	            ts.addRange(statements, remainingStatements);
	            // The 'es2015' class transform may add an end-of-declaration marker. If so we will add it
	            // after the remaining statements from the 'ts' transformer.
	            ts.addRange(statements, classStatements, /*start*/ 1);
	            // Recreate any outer parentheses or partially-emitted expressions to preserve source map
	            // and comment locations.
	            return ts.recreateOuterExpressions(node.expression, ts.recreateOuterExpressions(variable.initializer, ts.recreateOuterExpressions(aliasAssignment && aliasAssignment.right, ts.updateCall(call, ts.recreateOuterExpressions(call.expression, ts.updateFunctionExpression(func, 
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, func.parameters, 
	            /*type*/ undefined, ts.updateBlock(func.body, statements))), 
	            /*typeArguments*/ undefined, call.arguments))));
	        }
	        function visitImmediateSuperCallInBody(node) {
	            return visitCallExpressionWithPotentialCapturedThisAssignment(node, /*assignToCapturedThis*/ false);
	        }
	        function visitCallExpressionWithPotentialCapturedThisAssignment(node, assignToCapturedThis) {
	            // We are here either because SuperKeyword was used somewhere in the expression, or
	            // because we contain a SpreadElementExpression.
	            if (node.transformFlags & 524288 /* ContainsSpread */ ||
	                node.expression.kind === 97 /* SuperKeyword */ ||
	                ts.isSuperProperty(ts.skipOuterExpressions(node.expression))) {
	                var _a = ts.createCallBinding(node.expression, hoistVariableDeclaration), target = _a.target, thisArg = _a.thisArg;
	                if (node.expression.kind === 97 /* SuperKeyword */) {
	                    ts.setEmitFlags(thisArg, 4 /* NoSubstitution */);
	                }
	                var resultingCall = void 0;
	                if (node.transformFlags & 524288 /* ContainsSpread */) {
	                    // [source]
	                    //      f(...a, b)
	                    //      x.m(...a, b)
	                    //      super(...a, b)
	                    //      super.m(...a, b) // in static
	                    //      super.m(...a, b) // in instance
	                    //
	                    // [output]
	                    //      f.apply(void 0, a.concat([b]))
	                    //      (_a = x).m.apply(_a, a.concat([b]))
	                    //      _super.apply(this, a.concat([b]))
	                    //      _super.m.apply(this, a.concat([b]))
	                    //      _super.prototype.m.apply(this, a.concat([b]))
	                    resultingCall = ts.createFunctionApply(ts.visitNode(target, callExpressionVisitor, ts.isExpression), ts.visitNode(thisArg, visitor, ts.isExpression), transformAndSpreadElements(node.arguments, /*needsUniqueCopy*/ false, /*multiLine*/ false, /*hasTrailingComma*/ false));
	                }
	                else {
	                    // [source]
	                    //      super(a)
	                    //      super.m(a) // in static
	                    //      super.m(a) // in instance
	                    //
	                    // [output]
	                    //      _super.call(this, a)
	                    //      _super.m.call(this, a)
	                    //      _super.prototype.m.call(this, a)
	                    resultingCall = ts.createFunctionCall(ts.visitNode(target, callExpressionVisitor, ts.isExpression), ts.visitNode(thisArg, visitor, ts.isExpression), ts.visitNodes(node.arguments, visitor, ts.isExpression), 
	                    /*location*/ node);
	                }
	                if (node.expression.kind === 97 /* SuperKeyword */) {
	                    var actualThis = ts.createThis();
	                    ts.setEmitFlags(actualThis, 4 /* NoSubstitution */);
	                    var initializer = ts.createLogicalOr(resultingCall, actualThis);
	                    resultingCall = assignToCapturedThis
	                        ? ts.createAssignment(ts.createIdentifier("_this"), initializer)
	                        : initializer;
	                }
	                return ts.setOriginalNode(resultingCall, node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a NewExpression that contains a spread element.
	         *
	         * @param node A NewExpression node.
	         */
	        function visitNewExpression(node) {
	            if (node.transformFlags & 524288 /* ContainsSpread */) {
	                // We are here because we contain a SpreadElementExpression.
	                // [source]
	                //      new C(...a)
	                //
	                // [output]
	                //      new ((_a = C).bind.apply(_a, [void 0].concat(a)))()
	                var _a = ts.createCallBinding(ts.createPropertyAccess(node.expression, "bind"), hoistVariableDeclaration), target = _a.target, thisArg = _a.thisArg;
	                return ts.createNew(ts.createFunctionApply(ts.visitNode(target, visitor, ts.isExpression), thisArg, transformAndSpreadElements(ts.createNodeArray([ts.createVoidZero()].concat(node.arguments)), /*needsUniqueCopy*/ false, /*multiLine*/ false, /*hasTrailingComma*/ false)), 
	                /*typeArguments*/ undefined, []);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Transforms an array of Expression nodes that contains a SpreadExpression.
	         *
	         * @param elements The array of Expression nodes.
	         * @param needsUniqueCopy A value indicating whether to ensure that the result is a fresh array.
	         * @param multiLine A value indicating whether the result should be emitted on multiple lines.
	         */
	        function transformAndSpreadElements(elements, needsUniqueCopy, multiLine, hasTrailingComma) {
	            // [source]
	            //      [a, ...b, c]
	            //
	            // [output]
	            //      [a].concat(b, [c])
	            // Map spans of spread expressions into their expressions and spans of other
	            // expressions into an array literal.
	            var numElements = elements.length;
	            var segments = ts.flatten(ts.spanMap(elements, partitionSpread, function (partition, visitPartition, _start, end) {
	                return visitPartition(partition, multiLine, hasTrailingComma && end === numElements);
	            }));
	            if (compilerOptions.downlevelIteration) {
	                if (segments.length === 1) {
	                    var firstSegment = segments[0];
	                    if (ts.isCallExpression(firstSegment)
	                        && ts.isIdentifier(firstSegment.expression)
	                        && (ts.getEmitFlags(firstSegment.expression) & 4096 /* HelperName */)
	                        && firstSegment.expression.escapedText === "___spread") {
	                        return segments[0];
	                    }
	                }
	                return ts.createSpreadHelper(context, segments);
	            }
	            else {
	                if (segments.length === 1) {
	                    var firstElement = elements[0];
	                    return needsUniqueCopy && ts.isSpreadElement(firstElement) && firstElement.expression.kind !== 181 /* ArrayLiteralExpression */
	                        ? ts.createArraySlice(segments[0])
	                        : segments[0];
	                }
	                // Rewrite using the pattern <segment0>.concat(<segment1>, <segment2>, ...)
	                return ts.createArrayConcat(segments.shift(), segments);
	            }
	        }
	        function partitionSpread(node) {
	            return ts.isSpreadElement(node)
	                ? visitSpanOfSpreads
	                : visitSpanOfNonSpreads;
	        }
	        function visitSpanOfSpreads(chunk) {
	            return ts.map(chunk, visitExpressionOfSpread);
	        }
	        function visitSpanOfNonSpreads(chunk, multiLine, hasTrailingComma) {
	            return ts.createArrayLiteral(ts.visitNodes(ts.createNodeArray(chunk, hasTrailingComma), visitor, ts.isExpression), multiLine);
	        }
	        function visitSpreadElement(node) {
	            return ts.visitNode(node.expression, visitor, ts.isExpression);
	        }
	        /**
	         * Transforms the expression of a SpreadExpression node.
	         *
	         * @param node A SpreadExpression node.
	         */
	        function visitExpressionOfSpread(node) {
	            return ts.visitNode(node.expression, visitor, ts.isExpression);
	        }
	        /**
	         * Visits a template literal.
	         *
	         * @param node A template literal.
	         */
	        function visitTemplateLiteral(node) {
	            return ts.setTextRange(ts.createLiteral(node.text), node);
	        }
	        /**
	         * Visits a string literal with an extended unicode escape.
	         *
	         * @param node A string literal.
	         */
	        function visitStringLiteral(node) {
	            if (node.hasExtendedUnicodeEscape) {
	                return ts.setTextRange(ts.createLiteral(node.text), node);
	            }
	            return node;
	        }
	        /**
	         * Visits a binary or octal (ES6) numeric literal.
	         *
	         * @param node A string literal.
	         */
	        function visitNumericLiteral(node) {
	            if (node.numericLiteralFlags & 384 /* BinaryOrOctalSpecifier */) {
	                return ts.setTextRange(ts.createNumericLiteral(node.text), node);
	            }
	            return node;
	        }
	        /**
	         * Visits a TaggedTemplateExpression node.
	         *
	         * @param node A TaggedTemplateExpression node.
	         */
	        function visitTaggedTemplateExpression(node) {
	            // Visit the tag expression
	            var tag = ts.visitNode(node.tag, visitor, ts.isExpression);
	            // Build up the template arguments and the raw and cooked strings for the template.
	            // We start out with 'undefined' for the first argument and revisit later
	            // to avoid walking over the template string twice and shifting all our arguments over after the fact.
	            var templateArguments = [undefined];
	            var cookedStrings = [];
	            var rawStrings = [];
	            var template = node.template;
	            if (ts.isNoSubstitutionTemplateLiteral(template)) {
	                cookedStrings.push(ts.createLiteral(template.text));
	                rawStrings.push(getRawLiteral(template));
	            }
	            else {
	                cookedStrings.push(ts.createLiteral(template.head.text));
	                rawStrings.push(getRawLiteral(template.head));
	                for (var _i = 0, _a = template.templateSpans; _i < _a.length; _i++) {
	                    var templateSpan = _a[_i];
	                    cookedStrings.push(ts.createLiteral(templateSpan.literal.text));
	                    rawStrings.push(getRawLiteral(templateSpan.literal));
	                    templateArguments.push(ts.visitNode(templateSpan.expression, visitor, ts.isExpression));
	                }
	            }
	            var helperCall = createTemplateObjectHelper(context, ts.createArrayLiteral(cookedStrings), ts.createArrayLiteral(rawStrings));
	            // Create a variable to cache the template object if we're in a module.
	            // Do not do this in the global scope, as any variable we currently generate could conflict with
	            // variables from outside of the current compilation. In the future, we can revisit this behavior.
	            if (ts.isExternalModule(currentSourceFile)) {
	                var tempVar = ts.createUniqueName("templateObject");
	                recordTaggedTemplateString(tempVar);
	                templateArguments[0] = ts.createLogicalOr(tempVar, ts.createAssignment(tempVar, helperCall));
	            }
	            else {
	                templateArguments[0] = helperCall;
	            }
	            return ts.createCall(tag, /*typeArguments*/ undefined, templateArguments);
	        }
	        /**
	         * Creates an ES5 compatible literal from an ES6 template literal.
	         *
	         * @param node The ES6 template literal.
	         */
	        function getRawLiteral(node) {
	            // Find original source text, since we need to emit the raw strings of the tagged template.
	            // The raw strings contain the (escaped) strings of what the user wrote.
	            // Examples: `\n` is converted to "\\n", a template string with a newline to "\n".
	            var text = ts.getSourceTextOfNodeFromSourceFile(currentSourceFile, node);
	            // text contains the original source, it will also contain quotes ("`"), dolar signs and braces ("${" and "}"),
	            // thus we need to remove those characters.
	            // First template piece starts with "`", others with "}"
	            // Last template piece ends with "`", others with "${"
	            var isLast = node.kind === 13 /* NoSubstitutionTemplateLiteral */ || node.kind === 16 /* TemplateTail */;
	            text = text.substring(1, text.length - (isLast ? 1 : 2));
	            // Newline normalization:
	            // ES6 Spec 11.8.6.1 - Static Semantics of TV's and TRV's
	            // <CR><LF> and <CR> LineTerminatorSequences are normalized to <LF> for both TV and TRV.
	            text = text.replace(/\r\n?/g, "\n");
	            return ts.setTextRange(ts.createLiteral(text), node);
	        }
	        /**
	         * Visits a TemplateExpression node.
	         *
	         * @param node A TemplateExpression node.
	         */
	        function visitTemplateExpression(node) {
	            var expressions = [];
	            addTemplateHead(expressions, node);
	            addTemplateSpans(expressions, node);
	            // createAdd will check if each expression binds less closely than binary '+'.
	            // If it does, it wraps the expression in parentheses. Otherwise, something like
	            //    `abc${ 1 << 2 }`
	            // becomes
	            //    "abc" + 1 << 2 + ""
	            // which is really
	            //    ("abc" + 1) << (2 + "")
	            // rather than
	            //    "abc" + (1 << 2) + ""
	            var expression = ts.reduceLeft(expressions, ts.createAdd);
	            if (ts.nodeIsSynthesized(expression)) {
	                expression.pos = node.pos;
	                expression.end = node.end;
	            }
	            return expression;
	        }
	        /**
	         * Gets a value indicating whether we need to include the head of a TemplateExpression.
	         *
	         * @param node A TemplateExpression node.
	         */
	        function shouldAddTemplateHead(node) {
	            // If this expression has an empty head literal and the first template span has a non-empty
	            // literal, then emitting the empty head literal is not necessary.
	            //     `${ foo } and ${ bar }`
	            // can be emitted as
	            //     foo + " and " + bar
	            // This is because it is only required that one of the first two operands in the emit
	            // output must be a string literal, so that the other operand and all following operands
	            // are forced into strings.
	            //
	            // If the first template span has an empty literal, then the head must still be emitted.
	            //     `${ foo }${ bar }`
	            // must still be emitted as
	            //     "" + foo + bar
	            // There is always atleast one templateSpan in this code path, since
	            // NoSubstitutionTemplateLiterals are directly emitted via emitLiteral()
	            ts.Debug.assert(node.templateSpans.length !== 0);
	            return node.head.text.length !== 0 || node.templateSpans[0].literal.text.length === 0;
	        }
	        /**
	         * Adds the head of a TemplateExpression to an array of expressions.
	         *
	         * @param expressions An array of expressions.
	         * @param node A TemplateExpression node.
	         */
	        function addTemplateHead(expressions, node) {
	            if (!shouldAddTemplateHead(node)) {
	                return;
	            }
	            expressions.push(ts.createLiteral(node.head.text));
	        }
	        /**
	         * Visits and adds the template spans of a TemplateExpression to an array of expressions.
	         *
	         * @param expressions An array of expressions.
	         * @param node A TemplateExpression node.
	         */
	        function addTemplateSpans(expressions, node) {
	            for (var _i = 0, _a = node.templateSpans; _i < _a.length; _i++) {
	                var span_6 = _a[_i];
	                expressions.push(ts.visitNode(span_6.expression, visitor, ts.isExpression));
	                // Only emit if the literal is non-empty.
	                // The binary '+' operator is left-associative, so the first string concatenation
	                // with the head will force the result up to this point to be a string.
	                // Emitting a '+ ""' has no semantic effect for middles and tails.
	                if (span_6.literal.text.length !== 0) {
	                    expressions.push(ts.createLiteral(span_6.literal.text));
	                }
	            }
	        }
	        /**
	         * Visits the `super` keyword
	         */
	        function visitSuperKeyword(isExpressionOfCall) {
	            return hierarchyFacts & 8 /* NonStaticClassElement */
	                && !isExpressionOfCall
	                ? ts.createPropertyAccess(ts.createIdentifier("_super"), "prototype")
	                : ts.createIdentifier("_super");
	        }
	        function visitMetaProperty(node) {
	            if (node.keywordToken === 94 /* NewKeyword */ && node.name.escapedText === "target") {
	                if (hierarchyFacts & 8192 /* ComputedPropertyName */) {
	                    hierarchyFacts |= 32768 /* NewTargetInComputedPropertyName */;
	                }
	                else {
	                    hierarchyFacts |= 16384 /* NewTarget */;
	                }
	                return ts.createIdentifier("_newTarget");
	            }
	            return node;
	        }
	        /**
	         * Called by the printer just before a node is printed.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to be printed.
	         * @param emitCallback The callback used to emit the node.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            if (enabledSubstitutions & 1 /* CapturedThis */ && ts.isFunctionLike(node)) {
	                // If we are tracking a captured `this`, keep track of the enclosing function.
	                var ancestorFacts = enterSubtree(16286 /* FunctionExcludes */, ts.getEmitFlags(node) & 8 /* CapturesThis */
	                    ? 65 /* FunctionIncludes */ | 16 /* CapturesThis */
	                    : 65 /* FunctionIncludes */);
	                previousOnEmitNode(hint, node, emitCallback);
	                exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	                return;
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	        }
	        /**
	         * Enables a more costly code path for substitutions when we determine a source file
	         * contains block-scoped bindings (e.g. `let` or `const`).
	         */
	        function enableSubstitutionsForBlockScopedBindings() {
	            if ((enabledSubstitutions & 2 /* BlockScopedBindings */) === 0) {
	                enabledSubstitutions |= 2 /* BlockScopedBindings */;
	                context.enableSubstitution(71 /* Identifier */);
	            }
	        }
	        /**
	         * Enables a more costly code path for substitutions when we determine a source file
	         * contains a captured `this`.
	         */
	        function enableSubstitutionsForCapturedThis() {
	            if ((enabledSubstitutions & 1 /* CapturedThis */) === 0) {
	                enabledSubstitutions |= 1 /* CapturedThis */;
	                context.enableSubstitution(99 /* ThisKeyword */);
	                context.enableEmitNotification(154 /* Constructor */);
	                context.enableEmitNotification(153 /* MethodDeclaration */);
	                context.enableEmitNotification(155 /* GetAccessor */);
	                context.enableEmitNotification(156 /* SetAccessor */);
	                context.enableEmitNotification(191 /* ArrowFunction */);
	                context.enableEmitNotification(190 /* FunctionExpression */);
	                context.enableEmitNotification(232 /* FunctionDeclaration */);
	            }
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint The context for the emitter.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            if (ts.isIdentifier(node)) {
	                return substituteIdentifier(node);
	            }
	            return node;
	        }
	        /**
	         * Hooks substitutions for non-expression identifiers.
	         */
	        function substituteIdentifier(node) {
	            // Only substitute the identifier if we have enabled substitutions for block-scoped
	            // bindings.
	            if (enabledSubstitutions & 2 /* BlockScopedBindings */ && !ts.isInternalName(node)) {
	                var original = ts.getParseTreeNode(node, ts.isIdentifier);
	                if (original && isNameOfDeclarationWithCollidingName(original)) {
	                    return ts.setTextRange(ts.getGeneratedNameForNode(original), node);
	                }
	            }
	            return node;
	        }
	        /**
	         * Determines whether a name is the name of a declaration with a colliding name.
	         * NOTE: This function expects to be called with an original source tree node.
	         *
	         * @param node An original source tree node.
	         */
	        function isNameOfDeclarationWithCollidingName(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 180 /* BindingElement */:
	                case 233 /* ClassDeclaration */:
	                case 236 /* EnumDeclaration */:
	                case 230 /* VariableDeclaration */:
	                    return parent.name === node
	                        && resolver.isDeclarationWithCollidingName(parent);
	            }
	            return false;
	        }
	        /**
	         * Substitutes an expression.
	         *
	         * @param node An Expression node.
	         */
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return substituteExpressionIdentifier(node);
	                case 99 /* ThisKeyword */:
	                    return substituteThisKeyword(node);
	            }
	            return node;
	        }
	        /**
	         * Substitutes an expression identifier.
	         *
	         * @param node An Identifier node.
	         */
	        function substituteExpressionIdentifier(node) {
	            if (enabledSubstitutions & 2 /* BlockScopedBindings */ && !ts.isInternalName(node)) {
	                var declaration = resolver.getReferencedDeclarationWithCollidingName(node);
	                if (declaration && !(ts.isClassLike(declaration) && isPartOfClassBody(declaration, node))) {
	                    return ts.setTextRange(ts.getGeneratedNameForNode(ts.getNameOfDeclaration(declaration)), node);
	                }
	            }
	            return node;
	        }
	        function isPartOfClassBody(declaration, node) {
	            var currentNode = ts.getParseTreeNode(node);
	            if (!currentNode || currentNode === declaration || currentNode.end <= declaration.pos || currentNode.pos >= declaration.end) {
	                // if the node has no correlation to a parse tree node, its definitely not
	                // part of the body.
	                // if the node is outside of the document range of the declaration, its
	                // definitely not part of the body.
	                return false;
	            }
	            var blockScope = ts.getEnclosingBlockScopeContainer(declaration);
	            while (currentNode) {
	                if (currentNode === blockScope || currentNode === declaration) {
	                    // if we are in the enclosing block scope of the declaration, we are definitely
	                    // not inside the class body.
	                    return false;
	                }
	                if (ts.isClassElement(currentNode) && currentNode.parent === declaration) {
	                    return true;
	                }
	                currentNode = currentNode.parent;
	            }
	            return false;
	        }
	        /**
	         * Substitutes `this` when contained within an arrow function.
	         *
	         * @param node The ThisKeyword node.
	         */
	        function substituteThisKeyword(node) {
	            if (enabledSubstitutions & 1 /* CapturedThis */
	                && hierarchyFacts & 16 /* CapturesThis */) {
	                return ts.setTextRange(ts.createIdentifier("_this"), node);
	            }
	            return node;
	        }
	        function getClassMemberPrefix(node, member) {
	            return ts.hasModifier(member, 32 /* Static */)
	                ? ts.getInternalName(node)
	                : ts.createPropertyAccess(ts.getInternalName(node), "prototype");
	        }
	        function hasSynthesizedDefaultSuperCall(constructor, hasExtendsClause) {
	            if (!constructor || !hasExtendsClause) {
	                return false;
	            }
	            if (ts.some(constructor.parameters)) {
	                return false;
	            }
	            var statement = ts.firstOrUndefined(constructor.body.statements);
	            if (!statement || !ts.nodeIsSynthesized(statement) || statement.kind !== 214 /* ExpressionStatement */) {
	                return false;
	            }
	            var statementExpression = statement.expression;
	            if (!ts.nodeIsSynthesized(statementExpression) || statementExpression.kind !== 185 /* CallExpression */) {
	                return false;
	            }
	            var callTarget = statementExpression.expression;
	            if (!ts.nodeIsSynthesized(callTarget) || callTarget.kind !== 97 /* SuperKeyword */) {
	                return false;
	            }
	            var callArgument = ts.singleOrUndefined(statementExpression.arguments);
	            if (!callArgument || !ts.nodeIsSynthesized(callArgument) || callArgument.kind !== 202 /* SpreadElement */) {
	                return false;
	            }
	            var expression = callArgument.expression;
	            return ts.isIdentifier(expression) && expression.escapedText === "arguments";
	        }
	    }
	    ts.transformES2015 = transformES2015;
	    function createExtendsHelper(context, name) {
	        context.requestEmitHelper(extendsHelper);
	        return ts.createCall(ts.getHelperName("__extends"), 
	        /*typeArguments*/ undefined, [
	            name,
	            ts.createIdentifier("_super")
	        ]);
	    }
	    function createTemplateObjectHelper(context, cooked, raw) {
	        context.requestEmitHelper(templateObjectHelper);
	        return ts.createCall(ts.getHelperName("__makeTemplateObject"), 
	        /*typeArguments*/ undefined, [
	            cooked,
	            raw
	        ]);
	    }
	    var extendsHelper = {
	        name: "typescript:extends",
	        scoped: false,
	        priority: 0,
	        text: "\n            var __extends = (this && this.__extends) || (function () {\n                var extendStatics = Object.setPrototypeOf ||\n                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\n                    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\n                return function (d, b) {\n                    extendStatics(d, b);\n                    function __() { this.constructor = d; }\n                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\n                };\n            })();"
	    };
	    var templateObjectHelper = {
	        name: "typescript:makeTemplateObject",
	        scoped: false,
	        priority: 0,
	        text: "\n            var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {\n                if (Object.defineProperty) { Object.defineProperty(cooked, \"raw\", { value: raw }); } else { cooked.raw = raw; }\n                return cooked;\n            };"
	    };
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    /**
	     * Transforms ES5 syntax into ES3 syntax.
	     *
	     * @param context Context and state information for the transformation.
	     */
	    function transformES5(context) {
	        var compilerOptions = context.getCompilerOptions();
	        // enable emit notification only if using --jsx preserve or react-native
	        var previousOnEmitNode;
	        var noSubstitution;
	        if (compilerOptions.jsx === 1 /* Preserve */ || compilerOptions.jsx === 3 /* ReactNative */) {
	            previousOnEmitNode = context.onEmitNode;
	            context.onEmitNode = onEmitNode;
	            context.enableEmitNotification(255 /* JsxOpeningElement */);
	            context.enableEmitNotification(256 /* JsxClosingElement */);
	            context.enableEmitNotification(254 /* JsxSelfClosingElement */);
	            noSubstitution = [];
	        }
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        context.onSubstituteNode = onSubstituteNode;
	        context.enableSubstitution(183 /* PropertyAccessExpression */);
	        context.enableSubstitution(268 /* PropertyAssignment */);
	        return transformSourceFile;
	        /**
	         * Transforms an ES5 source file to ES3.
	         *
	         * @param node A SourceFile
	         */
	        function transformSourceFile(node) {
	            return node;
	        }
	        /**
	         * Called by the printer just before a node is printed.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback A callback used to emit the node.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            switch (node.kind) {
	                case 255 /* JsxOpeningElement */:
	                case 256 /* JsxClosingElement */:
	                case 254 /* JsxSelfClosingElement */:
	                    var tagName = node.tagName;
	                    noSubstitution[ts.getOriginalNodeId(tagName)] = true;
	                    break;
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            if (node.id && noSubstitution && noSubstitution[node.id]) {
	                return previousOnSubstituteNode(hint, node);
	            }
	            node = previousOnSubstituteNode(hint, node);
	            if (ts.isPropertyAccessExpression(node)) {
	                return substitutePropertyAccessExpression(node);
	            }
	            else if (ts.isPropertyAssignment(node)) {
	                return substitutePropertyAssignment(node);
	            }
	            return node;
	        }
	        /**
	         * Substitutes a PropertyAccessExpression whose name is a reserved word.
	         *
	         * @param node A PropertyAccessExpression
	         */
	        function substitutePropertyAccessExpression(node) {
	            var literalName = trySubstituteReservedName(node.name);
	            if (literalName) {
	                return ts.setTextRange(ts.createElementAccess(node.expression, literalName), node);
	            }
	            return node;
	        }
	        /**
	         * Substitutes a PropertyAssignment whose name is a reserved word.
	         *
	         * @param node A PropertyAssignment
	         */
	        function substitutePropertyAssignment(node) {
	            var literalName = ts.isIdentifier(node.name) && trySubstituteReservedName(node.name);
	            if (literalName) {
	                return ts.updatePropertyAssignment(node, literalName, node.initializer);
	            }
	            return node;
	        }
	        /**
	         * If an identifier name is a reserved word, returns a string literal for the name.
	         *
	         * @param name An Identifier
	         */
	        function trySubstituteReservedName(name) {
	            var token = name.originalKeywordKind || (ts.nodeIsSynthesized(name) ? ts.stringToToken(ts.idText(name)) : undefined);
	            if (token >= 72 /* FirstReservedWord */ && token <= 107 /* LastReservedWord */) {
	                return ts.setTextRange(ts.createLiteral(name), name);
	            }
	            return undefined;
	        }
	    }
	    ts.transformES5 = transformES5;
	})(ts || (ts = {}));
	/// <reference path="../factory.ts" />
	/// <reference path="../visitor.ts" />
	// Transforms generator functions into a compatible ES5 representation with similar runtime
	// semantics. This is accomplished by first transforming the body of each generator
	// function into an intermediate representation that is the compiled into a JavaScript
	// switch statement.
	//
	// Many functions in this transformer will contain comments indicating the expected
	// intermediate representation. For illustrative purposes, the following intermediate
	// language is used to define this intermediate representation:
	//
	//  .nop                            - Performs no operation.
	//  .local NAME, ...                - Define local variable declarations.
	//  .mark LABEL                     - Mark the location of a label.
	//  .br LABEL                       - Jump to a label. If jumping out of a protected
	//                                    region, all .finally blocks are executed.
	//  .brtrue LABEL, (x)              - Jump to a label IIF the expression `x` is truthy.
	//                                    If jumping out of a protected region, all .finally
	//                                    blocks are executed.
	//  .brfalse LABEL, (x)             - Jump to a label IIF the expression `x` is falsey.
	//                                    If jumping out of a protected region, all .finally
	//                                    blocks are executed.
	//  .yield (x)                      - Yield the value of the optional expression `x`.
	//                                    Resume at the next label.
	//  .yieldstar (x)                  - Delegate yield to the value of the optional
	//                                    expression `x`. Resume at the next label.
	//                                    NOTE: `x` must be an Iterator, not an Iterable.
	//  .loop CONTINUE, BREAK           - Marks the beginning of a loop. Any "continue" or
	//                                    "break" abrupt completions jump to the CONTINUE or
	//                                    BREAK labels, respectively.
	//  .endloop                        - Marks the end of a loop.
	//  .with (x)                       - Marks the beginning of a WithStatement block, using
	//                                    the supplied expression.
	//  .endwith                        - Marks the end of a WithStatement.
	//  .switch                         - Marks the beginning of a SwitchStatement.
	//  .endswitch                      - Marks the end of a SwitchStatement.
	//  .labeled NAME                   - Marks the beginning of a LabeledStatement with the
	//                                    supplied name.
	//  .endlabeled                     - Marks the end of a LabeledStatement.
	//  .try TRY, CATCH, FINALLY, END   - Marks the beginning of a protected region, and the
	//                                    labels for each block.
	//  .catch (x)                      - Marks the beginning of a catch block.
	//  .finally                        - Marks the beginning of a finally block.
	//  .endfinally                     - Marks the end of a finally block.
	//  .endtry                         - Marks the end of a protected region.
	//  .throw (x)                      - Throws the value of the expression `x`.
	//  .return (x)                     - Returns the value of the expression `x`.
	//
	// In addition, the illustrative intermediate representation introduces some special
	// variables:
	//
	//  %sent%                          - Either returns the next value sent to the generator,
	//                                    returns the result of a delegated yield, or throws
	//                                    the exception sent to the generator.
	//  %error%                         - Returns the value of the current exception in a
	//                                    catch block.
	//
	// This intermediate representation is then compiled into JavaScript syntax. The resulting
	// compilation output looks something like the following:
	//
	//  function f() {
	//      var /*locals*/;
	//      /*functions*/
	//      return __generator(function (state) {
	//          switch (state.label) {
	//              /*cases per label*/
	//          }
	//      });
	//  }
	//
	// Each of the above instructions corresponds to JavaScript emit similar to the following:
	//
	//  .local NAME                   | var NAME;
	// -------------------------------|----------------------------------------------
	//  .mark LABEL                   | case LABEL:
	// -------------------------------|----------------------------------------------
	//  .br LABEL                     |     return [3 /*break*/, LABEL];
	// -------------------------------|----------------------------------------------
	//  .brtrue LABEL, (x)            |     if (x) return [3 /*break*/, LABEL];
	// -------------------------------|----------------------------------------------
	//  .brfalse LABEL, (x)           |     if (!(x)) return [3, /*break*/, LABEL];
	// -------------------------------|----------------------------------------------
	//  .yield (x)                    |     return [4 /*yield*/, x];
	//  .mark RESUME                  | case RESUME:
	//      a = %sent%;               |     a = state.sent();
	// -------------------------------|----------------------------------------------
	//  .yieldstar (x)                |     return [5 /*yield**/, x];
	//  .mark RESUME                  | case RESUME:
	//      a = %sent%;               |     a = state.sent();
	// -------------------------------|----------------------------------------------
	//  .with (_a)                    |     with (_a) {
	//      a();                      |         a();
	//                                |     }
	//                                |     state.label = LABEL;
	//  .mark LABEL                   | case LABEL:
	//                                |     with (_a) {
	//      b();                      |         b();
	//                                |     }
	//  .endwith                      |
	// -------------------------------|----------------------------------------------
	//                                | case 0:
	//                                |     state.trys = [];
	//                                | ...
	//  .try TRY, CATCH, FINALLY, END |
	//  .mark TRY                     | case TRY:
	//                                |     state.trys.push([TRY, CATCH, FINALLY, END]);
	//  .nop                          |
	//      a();                      |     a();
	//  .br END                       |     return [3 /*break*/, END];
	//  .catch (e)                    |
	//  .mark CATCH                   | case CATCH:
	//                                |     e = state.sent();
	//      b();                      |     b();
	//  .br END                       |     return [3 /*break*/, END];
	//  .finally                      |
	//  .mark FINALLY                 | case FINALLY:
	//      c();                      |     c();
	//  .endfinally                   |     return [7 /*endfinally*/];
	//  .endtry                       |
	//  .mark END                     | case END:
	/*@internal*/
	var ts;
	(function (ts) {
	    var OpCode;
	    (function (OpCode) {
	        OpCode[OpCode["Nop"] = 0] = "Nop";
	        OpCode[OpCode["Statement"] = 1] = "Statement";
	        OpCode[OpCode["Assign"] = 2] = "Assign";
	        OpCode[OpCode["Break"] = 3] = "Break";
	        OpCode[OpCode["BreakWhenTrue"] = 4] = "BreakWhenTrue";
	        OpCode[OpCode["BreakWhenFalse"] = 5] = "BreakWhenFalse";
	        OpCode[OpCode["Yield"] = 6] = "Yield";
	        OpCode[OpCode["YieldStar"] = 7] = "YieldStar";
	        OpCode[OpCode["Return"] = 8] = "Return";
	        OpCode[OpCode["Throw"] = 9] = "Throw";
	        OpCode[OpCode["Endfinally"] = 10] = "Endfinally"; // Marks the end of a `finally` block
	    })(OpCode || (OpCode = {}));
	    // whether a generated code block is opening or closing at the current operation for a FunctionBuilder
	    var BlockAction;
	    (function (BlockAction) {
	        BlockAction[BlockAction["Open"] = 0] = "Open";
	        BlockAction[BlockAction["Close"] = 1] = "Close";
	    })(BlockAction || (BlockAction = {}));
	    // the kind for a generated code block in a FunctionBuilder
	    var CodeBlockKind;
	    (function (CodeBlockKind) {
	        CodeBlockKind[CodeBlockKind["Exception"] = 0] = "Exception";
	        CodeBlockKind[CodeBlockKind["With"] = 1] = "With";
	        CodeBlockKind[CodeBlockKind["Switch"] = 2] = "Switch";
	        CodeBlockKind[CodeBlockKind["Loop"] = 3] = "Loop";
	        CodeBlockKind[CodeBlockKind["Labeled"] = 4] = "Labeled";
	    })(CodeBlockKind || (CodeBlockKind = {}));
	    // the state for a generated code exception block
	    var ExceptionBlockState;
	    (function (ExceptionBlockState) {
	        ExceptionBlockState[ExceptionBlockState["Try"] = 0] = "Try";
	        ExceptionBlockState[ExceptionBlockState["Catch"] = 1] = "Catch";
	        ExceptionBlockState[ExceptionBlockState["Finally"] = 2] = "Finally";
	        ExceptionBlockState[ExceptionBlockState["Done"] = 3] = "Done";
	    })(ExceptionBlockState || (ExceptionBlockState = {}));
	    // NOTE: changes to this enum should be reflected in the __generator helper.
	    var Instruction;
	    (function (Instruction) {
	        Instruction[Instruction["Next"] = 0] = "Next";
	        Instruction[Instruction["Throw"] = 1] = "Throw";
	        Instruction[Instruction["Return"] = 2] = "Return";
	        Instruction[Instruction["Break"] = 3] = "Break";
	        Instruction[Instruction["Yield"] = 4] = "Yield";
	        Instruction[Instruction["YieldStar"] = 5] = "YieldStar";
	        Instruction[Instruction["Catch"] = 6] = "Catch";
	        Instruction[Instruction["Endfinally"] = 7] = "Endfinally";
	    })(Instruction || (Instruction = {}));
	    function getInstructionName(instruction) {
	        switch (instruction) {
	            case 2 /* Return */: return "return";
	            case 3 /* Break */: return "break";
	            case 4 /* Yield */: return "yield";
	            case 5 /* YieldStar */: return "yield*";
	            case 7 /* Endfinally */: return "endfinally";
	        }
	    }
	    function transformGenerators(context) {
	        var resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistFunctionDeclaration = context.hoistFunctionDeclaration, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var compilerOptions = context.getCompilerOptions();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var resolver = context.getEmitResolver();
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        context.onSubstituteNode = onSubstituteNode;
	        var renamedCatchVariables;
	        var renamedCatchVariableDeclarations;
	        var inGeneratorFunctionBody;
	        var inStatementContainingYield;
	        // The following three arrays store information about generated code blocks.
	        // All three arrays are correlated by their index. This approach is used over allocating
	        // objects to store the same information to avoid GC overhead.
	        //
	        var blocks; // Information about the code block
	        var blockOffsets; // The operation offset at which a code block begins or ends
	        var blockActions; // Whether the code block is opened or closed
	        var blockStack; // A stack of currently open code blocks
	        // Labels are used to mark locations in the code that can be the target of a Break (jump)
	        // operation. These are translated into case clauses in a switch statement.
	        // The following two arrays are correlated by their index. This approach is used over
	        // allocating objects to store the same information to avoid GC overhead.
	        //
	        var labelOffsets; // The operation offset at which the label is defined.
	        var labelExpressions; // The NumericLiteral nodes bound to each label.
	        var nextLabelId = 1; // The next label id to use.
	        // Operations store information about generated code for the function body. This
	        // Includes things like statements, assignments, breaks (jumps), and yields.
	        // The following three arrays are correlated by their index. This approach is used over
	        // allocating objects to store the same information to avoid GC overhead.
	        //
	        var operations; // The operation to perform.
	        var operationArguments; // The arguments to the operation.
	        var operationLocations; // The source map location for the operation.
	        var state; // The name of the state object used by the generator at runtime.
	        // The following variables store information used by the `build` function:
	        //
	        var blockIndex = 0; // The index of the current block.
	        var labelNumber = 0; // The current label number.
	        var labelNumbers;
	        var lastOperationWasAbrupt; // Indicates whether the last operation was abrupt (break/continue).
	        var lastOperationWasCompletion; // Indicates whether the last operation was a completion (return/throw).
	        var clauses; // The case clauses generated for labels.
	        var statements; // The statements for the current label.
	        var exceptionBlockStack; // A stack of containing exception blocks.
	        var currentExceptionBlock; // The current exception block.
	        var withBlockStack; // A stack containing `with` blocks.
	        return transformSourceFile;
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile || (node.transformFlags & 512 /* ContainsGenerator */) === 0) {
	                return node;
	            }
	            var visited = ts.visitEachChild(node, visitor, context);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            return visited;
	        }
	        /**
	         * Visits a node.
	         *
	         * @param node The node to visit.
	         */
	        function visitor(node) {
	            var transformFlags = node.transformFlags;
	            if (inStatementContainingYield) {
	                return visitJavaScriptInStatementContainingYield(node);
	            }
	            else if (inGeneratorFunctionBody) {
	                return visitJavaScriptInGeneratorFunctionBody(node);
	            }
	            else if (transformFlags & 256 /* Generator */) {
	                return visitGenerator(node);
	            }
	            else if (transformFlags & 512 /* ContainsGenerator */) {
	                return ts.visitEachChild(node, visitor, context);
	            }
	            else {
	                return node;
	            }
	        }
	        /**
	         * Visits a node that is contained within a statement that contains yield.
	         *
	         * @param node The node to visit.
	         */
	        function visitJavaScriptInStatementContainingYield(node) {
	            switch (node.kind) {
	                case 216 /* DoStatement */:
	                    return visitDoStatement(node);
	                case 217 /* WhileStatement */:
	                    return visitWhileStatement(node);
	                case 225 /* SwitchStatement */:
	                    return visitSwitchStatement(node);
	                case 226 /* LabeledStatement */:
	                    return visitLabeledStatement(node);
	                default:
	                    return visitJavaScriptInGeneratorFunctionBody(node);
	            }
	        }
	        /**
	         * Visits a node that is contained within a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitJavaScriptInGeneratorFunctionBody(node) {
	            switch (node.kind) {
	                case 232 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 190 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return visitAccessorDeclaration(node);
	                case 212 /* VariableStatement */:
	                    return visitVariableStatement(node);
	                case 218 /* ForStatement */:
	                    return visitForStatement(node);
	                case 219 /* ForInStatement */:
	                    return visitForInStatement(node);
	                case 222 /* BreakStatement */:
	                    return visitBreakStatement(node);
	                case 221 /* ContinueStatement */:
	                    return visitContinueStatement(node);
	                case 223 /* ReturnStatement */:
	                    return visitReturnStatement(node);
	                default:
	                    if (node.transformFlags & 16777216 /* ContainsYield */) {
	                        return visitJavaScriptContainingYield(node);
	                    }
	                    else if (node.transformFlags & (512 /* ContainsGenerator */ | 33554432 /* ContainsHoistedDeclarationOrCompletion */)) {
	                        return ts.visitEachChild(node, visitor, context);
	                    }
	                    else {
	                        return node;
	                    }
	            }
	        }
	        /**
	         * Visits a node that contains a YieldExpression.
	         *
	         * @param node The node to visit.
	         */
	        function visitJavaScriptContainingYield(node) {
	            switch (node.kind) {
	                case 198 /* BinaryExpression */:
	                    return visitBinaryExpression(node);
	                case 199 /* ConditionalExpression */:
	                    return visitConditionalExpression(node);
	                case 201 /* YieldExpression */:
	                    return visitYieldExpression(node);
	                case 181 /* ArrayLiteralExpression */:
	                    return visitArrayLiteralExpression(node);
	                case 182 /* ObjectLiteralExpression */:
	                    return visitObjectLiteralExpression(node);
	                case 184 /* ElementAccessExpression */:
	                    return visitElementAccessExpression(node);
	                case 185 /* CallExpression */:
	                    return visitCallExpression(node);
	                case 186 /* NewExpression */:
	                    return visitNewExpression(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        /**
	         * Visits a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitGenerator(node) {
	            switch (node.kind) {
	                case 232 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 190 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                default:
	                    ts.Debug.failBadSyntaxKind(node);
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        /**
	         * Visits a function declaration.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The function declaration is a generator function.
	         * - The function declaration is contained within the body of a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionDeclaration(node) {
	            // Currently, we only support generators that were originally async functions.
	            if (node.asteriskToken) {
	                node = ts.setOriginalNode(ts.setTextRange(ts.createFunctionDeclaration(
	                /*decorators*/ undefined, node.modifiers, 
	                /*asteriskToken*/ undefined, node.name, 
	                /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	                /*type*/ undefined, transformGeneratorFunctionBody(node.body)), 
	                /*location*/ node), node);
	            }
	            else {
	                var savedInGeneratorFunctionBody = inGeneratorFunctionBody;
	                var savedInStatementContainingYield = inStatementContainingYield;
	                inGeneratorFunctionBody = false;
	                inStatementContainingYield = false;
	                node = ts.visitEachChild(node, visitor, context);
	                inGeneratorFunctionBody = savedInGeneratorFunctionBody;
	                inStatementContainingYield = savedInStatementContainingYield;
	            }
	            if (inGeneratorFunctionBody) {
	                // Function declarations in a generator function body are hoisted
	                // to the top of the lexical scope and elided from the current statement.
	                hoistFunctionDeclaration(node);
	                return undefined;
	            }
	            else {
	                return node;
	            }
	        }
	        /**
	         * Visits a function expression.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The function expression is a generator function.
	         * - The function expression is contained within the body of a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionExpression(node) {
	            // Currently, we only support generators that were originally async functions.
	            if (node.asteriskToken) {
	                node = ts.setOriginalNode(ts.setTextRange(ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, node.name, 
	                /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	                /*type*/ undefined, transformGeneratorFunctionBody(node.body)), 
	                /*location*/ node), node);
	            }
	            else {
	                var savedInGeneratorFunctionBody = inGeneratorFunctionBody;
	                var savedInStatementContainingYield = inStatementContainingYield;
	                inGeneratorFunctionBody = false;
	                inStatementContainingYield = false;
	                node = ts.visitEachChild(node, visitor, context);
	                inGeneratorFunctionBody = savedInGeneratorFunctionBody;
	                inStatementContainingYield = savedInStatementContainingYield;
	            }
	            return node;
	        }
	        /**
	         * Visits a get or set accessor declaration.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The accessor is contained within the body of a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitAccessorDeclaration(node) {
	            var savedInGeneratorFunctionBody = inGeneratorFunctionBody;
	            var savedInStatementContainingYield = inStatementContainingYield;
	            inGeneratorFunctionBody = false;
	            inStatementContainingYield = false;
	            node = ts.visitEachChild(node, visitor, context);
	            inGeneratorFunctionBody = savedInGeneratorFunctionBody;
	            inStatementContainingYield = savedInStatementContainingYield;
	            return node;
	        }
	        /**
	         * Transforms the body of a generator function declaration.
	         *
	         * @param node The function body to transform.
	         */
	        function transformGeneratorFunctionBody(body) {
	            // Save existing generator state
	            var statements = [];
	            var savedInGeneratorFunctionBody = inGeneratorFunctionBody;
	            var savedInStatementContainingYield = inStatementContainingYield;
	            var savedBlocks = blocks;
	            var savedBlockOffsets = blockOffsets;
	            var savedBlockActions = blockActions;
	            var savedBlockStack = blockStack;
	            var savedLabelOffsets = labelOffsets;
	            var savedLabelExpressions = labelExpressions;
	            var savedNextLabelId = nextLabelId;
	            var savedOperations = operations;
	            var savedOperationArguments = operationArguments;
	            var savedOperationLocations = operationLocations;
	            var savedState = state;
	            // Initialize generator state
	            inGeneratorFunctionBody = true;
	            inStatementContainingYield = false;
	            blocks = undefined;
	            blockOffsets = undefined;
	            blockActions = undefined;
	            blockStack = undefined;
	            labelOffsets = undefined;
	            labelExpressions = undefined;
	            nextLabelId = 1;
	            operations = undefined;
	            operationArguments = undefined;
	            operationLocations = undefined;
	            state = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            // Build the generator
	            resumeLexicalEnvironment();
	            var statementOffset = ts.addPrologue(statements, body.statements, /*ensureUseStrict*/ false, visitor);
	            transformAndEmitStatements(body.statements, statementOffset);
	            var buildResult = build();
	            ts.addRange(statements, endLexicalEnvironment());
	            statements.push(ts.createReturn(buildResult));
	            // Restore previous generator state
	            inGeneratorFunctionBody = savedInGeneratorFunctionBody;
	            inStatementContainingYield = savedInStatementContainingYield;
	            blocks = savedBlocks;
	            blockOffsets = savedBlockOffsets;
	            blockActions = savedBlockActions;
	            blockStack = savedBlockStack;
	            labelOffsets = savedLabelOffsets;
	            labelExpressions = savedLabelExpressions;
	            nextLabelId = savedNextLabelId;
	            operations = savedOperations;
	            operationArguments = savedOperationArguments;
	            operationLocations = savedOperationLocations;
	            state = savedState;
	            return ts.setTextRange(ts.createBlock(statements, body.multiLine), body);
	        }
	        /**
	         * Visits a variable statement.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The variable statement is contained within the body of a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitVariableStatement(node) {
	            if (node.transformFlags & 16777216 /* ContainsYield */) {
	                transformAndEmitVariableDeclarationList(node.declarationList);
	                return undefined;
	            }
	            else {
	                // Do not hoist custom prologues.
	                if (ts.getEmitFlags(node) & 1048576 /* CustomPrologue */) {
	                    return node;
	                }
	                for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    hoistVariableDeclaration(variable.name);
	                }
	                var variables = ts.getInitializedVariables(node.declarationList);
	                if (variables.length === 0) {
	                    return undefined;
	                }
	                return ts.setSourceMapRange(ts.createStatement(ts.inlineExpressions(ts.map(variables, transformInitializedVariable))), node);
	            }
	        }
	        /**
	         * Visits a binary expression.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The node contains a YieldExpression.
	         *
	         * @param node The node to visit.
	         */
	        function visitBinaryExpression(node) {
	            switch (ts.getExpressionAssociativity(node)) {
	                case 0 /* Left */:
	                    return visitLeftAssociativeBinaryExpression(node);
	                case 1 /* Right */:
	                    return visitRightAssociativeBinaryExpression(node);
	                default:
	                    ts.Debug.fail("Unknown associativity.");
	            }
	        }
	        function isCompoundAssignment(kind) {
	            return kind >= 59 /* FirstCompoundAssignment */
	                && kind <= 70 /* LastCompoundAssignment */;
	        }
	        function getOperatorForCompoundAssignment(kind) {
	            switch (kind) {
	                case 59 /* PlusEqualsToken */: return 37 /* PlusToken */;
	                case 60 /* MinusEqualsToken */: return 38 /* MinusToken */;
	                case 61 /* AsteriskEqualsToken */: return 39 /* AsteriskToken */;
	                case 62 /* AsteriskAsteriskEqualsToken */: return 40 /* AsteriskAsteriskToken */;
	                case 63 /* SlashEqualsToken */: return 41 /* SlashToken */;
	                case 64 /* PercentEqualsToken */: return 42 /* PercentToken */;
	                case 65 /* LessThanLessThanEqualsToken */: return 45 /* LessThanLessThanToken */;
	                case 66 /* GreaterThanGreaterThanEqualsToken */: return 46 /* GreaterThanGreaterThanToken */;
	                case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */: return 47 /* GreaterThanGreaterThanGreaterThanToken */;
	                case 68 /* AmpersandEqualsToken */: return 48 /* AmpersandToken */;
	                case 69 /* BarEqualsToken */: return 49 /* BarToken */;
	                case 70 /* CaretEqualsToken */: return 50 /* CaretToken */;
	            }
	        }
	        /**
	         * Visits a right-associative binary expression containing `yield`.
	         *
	         * @param node The node to visit.
	         */
	        function visitRightAssociativeBinaryExpression(node) {
	            var left = node.left, right = node.right;
	            if (containsYield(right)) {
	                var target = void 0;
	                switch (left.kind) {
	                    case 183 /* PropertyAccessExpression */:
	                        // [source]
	                        //      a.b = yield;
	                        //
	                        // [intermediate]
	                        //  .local _a
	                        //      _a = a;
	                        //  .yield resumeLabel
	                        //  .mark resumeLabel
	                        //      _a.b = %sent%;
	                        target = ts.updatePropertyAccess(left, cacheExpression(ts.visitNode(left.expression, visitor, ts.isLeftHandSideExpression)), left.name);
	                        break;
	                    case 184 /* ElementAccessExpression */:
	                        // [source]
	                        //      a[b] = yield;
	                        //
	                        // [intermediate]
	                        //  .local _a, _b
	                        //      _a = a;
	                        //      _b = b;
	                        //  .yield resumeLabel
	                        //  .mark resumeLabel
	                        //      _a[_b] = %sent%;
	                        target = ts.updateElementAccess(left, cacheExpression(ts.visitNode(left.expression, visitor, ts.isLeftHandSideExpression)), cacheExpression(ts.visitNode(left.argumentExpression, visitor, ts.isExpression)));
	                        break;
	                    default:
	                        target = ts.visitNode(left, visitor, ts.isExpression);
	                        break;
	                }
	                var operator = node.operatorToken.kind;
	                if (isCompoundAssignment(operator)) {
	                    return ts.setTextRange(ts.createAssignment(target, ts.setTextRange(ts.createBinary(cacheExpression(target), getOperatorForCompoundAssignment(operator), ts.visitNode(right, visitor, ts.isExpression)), node)), node);
	                }
	                else {
	                    return ts.updateBinary(node, target, ts.visitNode(right, visitor, ts.isExpression));
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitLeftAssociativeBinaryExpression(node) {
	            if (containsYield(node.right)) {
	                if (ts.isLogicalOperator(node.operatorToken.kind)) {
	                    return visitLogicalBinaryExpression(node);
	                }
	                else if (node.operatorToken.kind === 26 /* CommaToken */) {
	                    return visitCommaExpression(node);
	                }
	                // [source]
	                //      a() + (yield) + c()
	                //
	                // [intermediate]
	                //  .local _a
	                //      _a = a();
	                //  .yield resumeLabel
	                //      _a + %sent% + c()
	                var clone_4 = ts.getMutableClone(node);
	                clone_4.left = cacheExpression(ts.visitNode(node.left, visitor, ts.isExpression));
	                clone_4.right = ts.visitNode(node.right, visitor, ts.isExpression);
	                return clone_4;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a logical binary expression containing `yield`.
	         *
	         * @param node A node to visit.
	         */
	        function visitLogicalBinaryExpression(node) {
	            // Logical binary expressions (`&&` and `||`) are shortcutting expressions and need
	            // to be transformed as such:
	            //
	            // [source]
	            //      x = a() && yield;
	            //
	            // [intermediate]
	            //  .local _a
	            //      _a = a();
	            //  .brfalse resultLabel, (_a)
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      _a = %sent%;
	            //  .mark resultLabel
	            //      x = _a;
	            //
	            // [source]
	            //      x = a() || yield;
	            //
	            // [intermediate]
	            //  .local _a
	            //      _a = a();
	            //  .brtrue resultLabel, (_a)
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      _a = %sent%;
	            //  .mark resultLabel
	            //      x = _a;
	            var resultLabel = defineLabel();
	            var resultLocal = declareLocal();
	            emitAssignment(resultLocal, ts.visitNode(node.left, visitor, ts.isExpression), /*location*/ node.left);
	            if (node.operatorToken.kind === 53 /* AmpersandAmpersandToken */) {
	                // Logical `&&` shortcuts when the left-hand operand is falsey.
	                emitBreakWhenFalse(resultLabel, resultLocal, /*location*/ node.left);
	            }
	            else {
	                // Logical `||` shortcuts when the left-hand operand is truthy.
	                emitBreakWhenTrue(resultLabel, resultLocal, /*location*/ node.left);
	            }
	            emitAssignment(resultLocal, ts.visitNode(node.right, visitor, ts.isExpression), /*location*/ node.right);
	            markLabel(resultLabel);
	            return resultLocal;
	        }
	        /**
	         * Visits a comma expression containing `yield`.
	         *
	         * @param node The node to visit.
	         */
	        function visitCommaExpression(node) {
	            // [source]
	            //      x = a(), yield, b();
	            //
	            // [intermediate]
	            //      a();
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      x = %sent%, b();
	            var pendingExpressions = [];
	            visit(node.left);
	            visit(node.right);
	            return ts.inlineExpressions(pendingExpressions);
	            function visit(node) {
	                if (ts.isBinaryExpression(node) && node.operatorToken.kind === 26 /* CommaToken */) {
	                    visit(node.left);
	                    visit(node.right);
	                }
	                else {
	                    if (containsYield(node) && pendingExpressions.length > 0) {
	                        emitWorker(1 /* Statement */, [ts.createStatement(ts.inlineExpressions(pendingExpressions))]);
	                        pendingExpressions = [];
	                    }
	                    pendingExpressions.push(ts.visitNode(node, visitor, ts.isExpression));
	                }
	            }
	        }
	        /**
	         * Visits a conditional expression containing `yield`.
	         *
	         * @param node The node to visit.
	         */
	        function visitConditionalExpression(node) {
	            // [source]
	            //      x = a() ? yield : b();
	            //
	            // [intermediate]
	            //  .local _a
	            //  .brfalse whenFalseLabel, (a())
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      _a = %sent%;
	            //  .br resultLabel
	            //  .mark whenFalseLabel
	            //      _a = b();
	            //  .mark resultLabel
	            //      x = _a;
	            // We only need to perform a specific transformation if a `yield` expression exists
	            // in either the `whenTrue` or `whenFalse` branches.
	            // A `yield` in the condition will be handled by the normal visitor.
	            if (containsYield(node.whenTrue) || containsYield(node.whenFalse)) {
	                var whenFalseLabel = defineLabel();
	                var resultLabel = defineLabel();
	                var resultLocal = declareLocal();
	                emitBreakWhenFalse(whenFalseLabel, ts.visitNode(node.condition, visitor, ts.isExpression), /*location*/ node.condition);
	                emitAssignment(resultLocal, ts.visitNode(node.whenTrue, visitor, ts.isExpression), /*location*/ node.whenTrue);
	                emitBreak(resultLabel);
	                markLabel(whenFalseLabel);
	                emitAssignment(resultLocal, ts.visitNode(node.whenFalse, visitor, ts.isExpression), /*location*/ node.whenFalse);
	                markLabel(resultLabel);
	                return resultLocal;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a `yield` expression.
	         *
	         * @param node The node to visit.
	         */
	        function visitYieldExpression(node) {
	            // [source]
	            //      x = yield a();
	            //
	            // [intermediate]
	            //  .yield resumeLabel, (a())
	            //  .mark resumeLabel
	            //      x = %sent%;
	            var resumeLabel = defineLabel();
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            if (node.asteriskToken) {
	                var iterator = (ts.getEmitFlags(node.expression) & 8388608 /* Iterator */) === 0
	                    ? ts.createValuesHelper(context, expression, /*location*/ node)
	                    : expression;
	                emitYieldStar(iterator, /*location*/ node);
	            }
	            else {
	                emitYield(expression, /*location*/ node);
	            }
	            markLabel(resumeLabel);
	            return createGeneratorResume(/*location*/ node);
	        }
	        /**
	         * Visits an ArrayLiteralExpression that contains a YieldExpression.
	         *
	         * @param node The node to visit.
	         */
	        function visitArrayLiteralExpression(node) {
	            return visitElements(node.elements, /*leadingElement*/ undefined, /*location*/ undefined, node.multiLine);
	        }
	        /**
	         * Visits an array of expressions containing one or more YieldExpression nodes
	         * and returns an expression for the resulting value.
	         *
	         * @param elements The elements to visit.
	         * @param multiLine Whether array literals created should be emitted on multiple lines.
	         */
	        function visitElements(elements, leadingElement, location, multiLine) {
	            // [source]
	            //      ar = [1, yield, 2];
	            //
	            // [intermediate]
	            //  .local _a
	            //      _a = [1];
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      ar = _a.concat([%sent%, 2]);
	            var numInitialElements = countInitialNodesWithoutYield(elements);
	            var temp;
	            if (numInitialElements > 0) {
	                temp = declareLocal();
	                var initialElements = ts.visitNodes(elements, visitor, ts.isExpression, 0, numInitialElements);
	                emitAssignment(temp, ts.createArrayLiteral(leadingElement
	                    ? [leadingElement].concat(initialElements) : initialElements));
	                leadingElement = undefined;
	            }
	            var expressions = ts.reduceLeft(elements, reduceElement, [], numInitialElements);
	            return temp
	                ? ts.createArrayConcat(temp, [ts.createArrayLiteral(expressions, multiLine)])
	                : ts.setTextRange(ts.createArrayLiteral(leadingElement ? [leadingElement].concat(expressions) : expressions, multiLine), location);
	            function reduceElement(expressions, element) {
	                if (containsYield(element) && expressions.length > 0) {
	                    var hasAssignedTemp = temp !== undefined;
	                    if (!temp) {
	                        temp = declareLocal();
	                    }
	                    emitAssignment(temp, hasAssignedTemp
	                        ? ts.createArrayConcat(temp, [ts.createArrayLiteral(expressions, multiLine)])
	                        : ts.createArrayLiteral(leadingElement ? [leadingElement].concat(expressions) : expressions, multiLine));
	                    leadingElement = undefined;
	                    expressions = [];
	                }
	                expressions.push(ts.visitNode(element, visitor, ts.isExpression));
	                return expressions;
	            }
	        }
	        function visitObjectLiteralExpression(node) {
	            // [source]
	            //      o = {
	            //          a: 1,
	            //          b: yield,
	            //          c: 2
	            //      };
	            //
	            // [intermediate]
	            //  .local _a
	            //      _a = {
	            //          a: 1
	            //      };
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      o = (_a.b = %sent%,
	            //          _a.c = 2,
	            //          _a);
	            var properties = node.properties;
	            var multiLine = node.multiLine;
	            var numInitialProperties = countInitialNodesWithoutYield(properties);
	            var temp = declareLocal();
	            emitAssignment(temp, ts.createObjectLiteral(ts.visitNodes(properties, visitor, ts.isObjectLiteralElementLike, 0, numInitialProperties), multiLine));
	            var expressions = ts.reduceLeft(properties, reduceProperty, [], numInitialProperties);
	            expressions.push(multiLine ? ts.startOnNewLine(ts.getMutableClone(temp)) : temp);
	            return ts.inlineExpressions(expressions);
	            function reduceProperty(expressions, property) {
	                if (containsYield(property) && expressions.length > 0) {
	                    emitStatement(ts.createStatement(ts.inlineExpressions(expressions)));
	                    expressions = [];
	                }
	                var expression = ts.createExpressionForObjectLiteralElementLike(node, property, temp);
	                var visited = ts.visitNode(expression, visitor, ts.isExpression);
	                if (visited) {
	                    if (multiLine) {
	                        ts.startOnNewLine(visited);
	                    }
	                    expressions.push(visited);
	                }
	                return expressions;
	            }
	        }
	        /**
	         * Visits an ElementAccessExpression that contains a YieldExpression.
	         *
	         * @param node The node to visit.
	         */
	        function visitElementAccessExpression(node) {
	            if (containsYield(node.argumentExpression)) {
	                // [source]
	                //      a = x[yield];
	                //
	                // [intermediate]
	                //  .local _a
	                //      _a = x;
	                //  .yield resumeLabel
	                //  .mark resumeLabel
	                //      a = _a[%sent%]
	                var clone_5 = ts.getMutableClone(node);
	                clone_5.expression = cacheExpression(ts.visitNode(node.expression, visitor, ts.isLeftHandSideExpression));
	                clone_5.argumentExpression = ts.visitNode(node.argumentExpression, visitor, ts.isExpression);
	                return clone_5;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitCallExpression(node) {
	            if (!ts.isImportCall(node) && ts.forEach(node.arguments, containsYield)) {
	                // [source]
	                //      a.b(1, yield, 2);
	                //
	                // [intermediate]
	                //  .local _a, _b, _c
	                //      _b = (_a = a).b;
	                //      _c = [1];
	                //  .yield resumeLabel
	                //  .mark resumeLabel
	                //      _b.apply(_a, _c.concat([%sent%, 2]));
	                var _a = ts.createCallBinding(node.expression, hoistVariableDeclaration, languageVersion, /*cacheIdentifiers*/ true), target = _a.target, thisArg = _a.thisArg;
	                return ts.setOriginalNode(ts.createFunctionApply(cacheExpression(ts.visitNode(target, visitor, ts.isLeftHandSideExpression)), thisArg, visitElements(node.arguments), 
	                /*location*/ node), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitNewExpression(node) {
	            if (ts.forEach(node.arguments, containsYield)) {
	                // [source]
	                //      new a.b(1, yield, 2);
	                //
	                // [intermediate]
	                //  .local _a, _b, _c
	                //      _b = (_a = a.b).bind;
	                //      _c = [1];
	                //  .yield resumeLabel
	                //  .mark resumeLabel
	                //      new (_b.apply(_a, _c.concat([%sent%, 2])));
	                var _a = ts.createCallBinding(ts.createPropertyAccess(node.expression, "bind"), hoistVariableDeclaration), target = _a.target, thisArg = _a.thisArg;
	                return ts.setOriginalNode(ts.setTextRange(ts.createNew(ts.createFunctionApply(cacheExpression(ts.visitNode(target, visitor, ts.isExpression)), thisArg, visitElements(node.arguments, 
	                /*leadingElement*/ ts.createVoidZero())), 
	                /*typeArguments*/ undefined, []), node), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function transformAndEmitStatements(statements, start) {
	            if (start === void 0) { start = 0; }
	            var numStatements = statements.length;
	            for (var i = start; i < numStatements; i++) {
	                transformAndEmitStatement(statements[i]);
	            }
	        }
	        function transformAndEmitEmbeddedStatement(node) {
	            if (ts.isBlock(node)) {
	                transformAndEmitStatements(node.statements);
	            }
	            else {
	                transformAndEmitStatement(node);
	            }
	        }
	        function transformAndEmitStatement(node) {
	            var savedInStatementContainingYield = inStatementContainingYield;
	            if (!inStatementContainingYield) {
	                inStatementContainingYield = containsYield(node);
	            }
	            transformAndEmitStatementWorker(node);
	            inStatementContainingYield = savedInStatementContainingYield;
	        }
	        function transformAndEmitStatementWorker(node) {
	            switch (node.kind) {
	                case 211 /* Block */:
	                    return transformAndEmitBlock(node);
	                case 214 /* ExpressionStatement */:
	                    return transformAndEmitExpressionStatement(node);
	                case 215 /* IfStatement */:
	                    return transformAndEmitIfStatement(node);
	                case 216 /* DoStatement */:
	                    return transformAndEmitDoStatement(node);
	                case 217 /* WhileStatement */:
	                    return transformAndEmitWhileStatement(node);
	                case 218 /* ForStatement */:
	                    return transformAndEmitForStatement(node);
	                case 219 /* ForInStatement */:
	                    return transformAndEmitForInStatement(node);
	                case 221 /* ContinueStatement */:
	                    return transformAndEmitContinueStatement(node);
	                case 222 /* BreakStatement */:
	                    return transformAndEmitBreakStatement(node);
	                case 223 /* ReturnStatement */:
	                    return transformAndEmitReturnStatement(node);
	                case 224 /* WithStatement */:
	                    return transformAndEmitWithStatement(node);
	                case 225 /* SwitchStatement */:
	                    return transformAndEmitSwitchStatement(node);
	                case 226 /* LabeledStatement */:
	                    return transformAndEmitLabeledStatement(node);
	                case 227 /* ThrowStatement */:
	                    return transformAndEmitThrowStatement(node);
	                case 228 /* TryStatement */:
	                    return transformAndEmitTryStatement(node);
	                default:
	                    return emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function transformAndEmitBlock(node) {
	            if (containsYield(node)) {
	                transformAndEmitStatements(node.statements);
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function transformAndEmitExpressionStatement(node) {
	            emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	        }
	        function transformAndEmitVariableDeclarationList(node) {
	            for (var _i = 0, _a = node.declarations; _i < _a.length; _i++) {
	                var variable = _a[_i];
	                var name = ts.getSynthesizedClone(variable.name);
	                ts.setCommentRange(name, variable.name);
	                hoistVariableDeclaration(name);
	            }
	            var variables = ts.getInitializedVariables(node);
	            var numVariables = variables.length;
	            var variablesWritten = 0;
	            var pendingExpressions = [];
	            while (variablesWritten < numVariables) {
	                for (var i = variablesWritten; i < numVariables; i++) {
	                    var variable = variables[i];
	                    if (containsYield(variable.initializer) && pendingExpressions.length > 0) {
	                        break;
	                    }
	                    pendingExpressions.push(transformInitializedVariable(variable));
	                }
	                if (pendingExpressions.length) {
	                    emitStatement(ts.createStatement(ts.inlineExpressions(pendingExpressions)));
	                    variablesWritten += pendingExpressions.length;
	                    pendingExpressions = [];
	                }
	            }
	            return undefined;
	        }
	        function transformInitializedVariable(node) {
	            return ts.setSourceMapRange(ts.createAssignment(ts.setSourceMapRange(ts.getSynthesizedClone(node.name), node.name), ts.visitNode(node.initializer, visitor, ts.isExpression)), node);
	        }
	        function transformAndEmitIfStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      if (x)
	                //          /*thenStatement*/
	                //      else
	                //          /*elseStatement*/
	                //
	                // [intermediate]
	                //  .brfalse elseLabel, (x)
	                //      /*thenStatement*/
	                //  .br endLabel
	                //  .mark elseLabel
	                //      /*elseStatement*/
	                //  .mark endLabel
	                if (containsYield(node.thenStatement) || containsYield(node.elseStatement)) {
	                    var endLabel = defineLabel();
	                    var elseLabel = node.elseStatement ? defineLabel() : undefined;
	                    emitBreakWhenFalse(node.elseStatement ? elseLabel : endLabel, ts.visitNode(node.expression, visitor, ts.isExpression), /*location*/ node.expression);
	                    transformAndEmitEmbeddedStatement(node.thenStatement);
	                    if (node.elseStatement) {
	                        emitBreak(endLabel);
	                        markLabel(elseLabel);
	                        transformAndEmitEmbeddedStatement(node.elseStatement);
	                    }
	                    markLabel(endLabel);
	                }
	                else {
	                    emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	                }
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function transformAndEmitDoStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      do {
	                //          /*body*/
	                //      }
	                //      while (i < 10);
	                //
	                // [intermediate]
	                //  .loop conditionLabel, endLabel
	                //  .mark loopLabel
	                //      /*body*/
	                //  .mark conditionLabel
	                //  .brtrue loopLabel, (i < 10)
	                //  .endloop
	                //  .mark endLabel
	                var conditionLabel = defineLabel();
	                var loopLabel = defineLabel();
	                beginLoopBlock(/*continueLabel*/ conditionLabel);
	                markLabel(loopLabel);
	                transformAndEmitEmbeddedStatement(node.statement);
	                markLabel(conditionLabel);
	                emitBreakWhenTrue(loopLabel, ts.visitNode(node.expression, visitor, ts.isExpression));
	                endLoopBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitDoStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptLoopBlock();
	                node = ts.visitEachChild(node, visitor, context);
	                endLoopBlock();
	                return node;
	            }
	            else {
	                return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function transformAndEmitWhileStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      while (i < 10) {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .loop loopLabel, endLabel
	                //  .mark loopLabel
	                //  .brfalse endLabel, (i < 10)
	                //      /*body*/
	                //  .br loopLabel
	                //  .endloop
	                //  .mark endLabel
	                var loopLabel = defineLabel();
	                var endLabel = beginLoopBlock(loopLabel);
	                markLabel(loopLabel);
	                emitBreakWhenFalse(endLabel, ts.visitNode(node.expression, visitor, ts.isExpression));
	                transformAndEmitEmbeddedStatement(node.statement);
	                emitBreak(loopLabel);
	                endLoopBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitWhileStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptLoopBlock();
	                node = ts.visitEachChild(node, visitor, context);
	                endLoopBlock();
	                return node;
	            }
	            else {
	                return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function transformAndEmitForStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      for (var i = 0; i < 10; i++) {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .local i
	                //      i = 0;
	                //  .loop incrementLabel, endLoopLabel
	                //  .mark conditionLabel
	                //  .brfalse endLoopLabel, (i < 10)
	                //      /*body*/
	                //  .mark incrementLabel
	                //      i++;
	                //  .br conditionLabel
	                //  .endloop
	                //  .mark endLoopLabel
	                var conditionLabel = defineLabel();
	                var incrementLabel = defineLabel();
	                var endLabel = beginLoopBlock(incrementLabel);
	                if (node.initializer) {
	                    var initializer = node.initializer;
	                    if (ts.isVariableDeclarationList(initializer)) {
	                        transformAndEmitVariableDeclarationList(initializer);
	                    }
	                    else {
	                        emitStatement(ts.setTextRange(ts.createStatement(ts.visitNode(initializer, visitor, ts.isExpression)), initializer));
	                    }
	                }
	                markLabel(conditionLabel);
	                if (node.condition) {
	                    emitBreakWhenFalse(endLabel, ts.visitNode(node.condition, visitor, ts.isExpression));
	                }
	                transformAndEmitEmbeddedStatement(node.statement);
	                markLabel(incrementLabel);
	                if (node.incrementor) {
	                    emitStatement(ts.setTextRange(ts.createStatement(ts.visitNode(node.incrementor, visitor, ts.isExpression)), node.incrementor));
	                }
	                emitBreak(conditionLabel);
	                endLoopBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitForStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptLoopBlock();
	            }
	            var initializer = node.initializer;
	            if (initializer && ts.isVariableDeclarationList(initializer)) {
	                for (var _i = 0, _a = initializer.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    hoistVariableDeclaration(variable.name);
	                }
	                var variables = ts.getInitializedVariables(initializer);
	                node = ts.updateFor(node, variables.length > 0
	                    ? ts.inlineExpressions(ts.map(variables, transformInitializedVariable))
	                    : undefined, ts.visitNode(node.condition, visitor, ts.isExpression), ts.visitNode(node.incrementor, visitor, ts.isExpression), ts.visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            }
	            else {
	                node = ts.visitEachChild(node, visitor, context);
	            }
	            if (inStatementContainingYield) {
	                endLoopBlock();
	            }
	            return node;
	        }
	        function transformAndEmitForInStatement(node) {
	            // TODO(rbuckton): Source map locations
	            if (containsYield(node)) {
	                // [source]
	                //      for (var p in o) {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .local _a, _b, _i
	                //      _a = [];
	                //      for (_b in o) _a.push(_b);
	                //      _i = 0;
	                //  .loop incrementLabel, endLoopLabel
	                //  .mark conditionLabel
	                //  .brfalse endLoopLabel, (_i < _a.length)
	                //      p = _a[_i];
	                //      /*body*/
	                //  .mark incrementLabel
	                //      _b++;
	                //  .br conditionLabel
	                //  .endloop
	                //  .mark endLoopLabel
	                var keysArray = declareLocal(); // _a
	                var key = declareLocal(); // _b
	                var keysIndex = ts.createLoopVariable(); // _i
	                var initializer = node.initializer;
	                hoistVariableDeclaration(keysIndex);
	                emitAssignment(keysArray, ts.createArrayLiteral());
	                emitStatement(ts.createForIn(key, ts.visitNode(node.expression, visitor, ts.isExpression), ts.createStatement(ts.createCall(ts.createPropertyAccess(keysArray, "push"), 
	                /*typeArguments*/ undefined, [key]))));
	                emitAssignment(keysIndex, ts.createLiteral(0));
	                var conditionLabel = defineLabel();
	                var incrementLabel = defineLabel();
	                var endLabel = beginLoopBlock(incrementLabel);
	                markLabel(conditionLabel);
	                emitBreakWhenFalse(endLabel, ts.createLessThan(keysIndex, ts.createPropertyAccess(keysArray, "length")));
	                var variable = void 0;
	                if (ts.isVariableDeclarationList(initializer)) {
	                    for (var _i = 0, _a = initializer.declarations; _i < _a.length; _i++) {
	                        var variable_1 = _a[_i];
	                        hoistVariableDeclaration(variable_1.name);
	                    }
	                    variable = ts.getSynthesizedClone(initializer.declarations[0].name);
	                }
	                else {
	                    variable = ts.visitNode(initializer, visitor, ts.isExpression);
	                    ts.Debug.assert(ts.isLeftHandSideExpression(variable));
	                }
	                emitAssignment(variable, ts.createElementAccess(keysArray, keysIndex));
	                transformAndEmitEmbeddedStatement(node.statement);
	                markLabel(incrementLabel);
	                emitStatement(ts.createStatement(ts.createPostfixIncrement(keysIndex)));
	                emitBreak(conditionLabel);
	                endLoopBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitForInStatement(node) {
	            // [source]
	            //      for (var x in a) {
	            //          /*body*/
	            //      }
	            //
	            // [intermediate]
	            //  .local x
	            //  .loop
	            //      for (x in a) {
	            //          /*body*/
	            //      }
	            //  .endloop
	            if (inStatementContainingYield) {
	                beginScriptLoopBlock();
	            }
	            var initializer = node.initializer;
	            if (ts.isVariableDeclarationList(initializer)) {
	                for (var _i = 0, _a = initializer.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    hoistVariableDeclaration(variable.name);
	                }
	                node = ts.updateForIn(node, initializer.declarations[0].name, ts.visitNode(node.expression, visitor, ts.isExpression), ts.visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            }
	            else {
	                node = ts.visitEachChild(node, visitor, context);
	            }
	            if (inStatementContainingYield) {
	                endLoopBlock();
	            }
	            return node;
	        }
	        function transformAndEmitContinueStatement(node) {
	            var label = findContinueTarget(node.label ? ts.idText(node.label) : undefined);
	            if (label > 0) {
	                emitBreak(label, /*location*/ node);
	            }
	            else {
	                // invalid continue without a containing loop. Leave the node as is, per #17875.
	                emitStatement(node);
	            }
	        }
	        function visitContinueStatement(node) {
	            if (inStatementContainingYield) {
	                var label = findContinueTarget(node.label && ts.idText(node.label));
	                if (label > 0) {
	                    return createInlineBreak(label, /*location*/ node);
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function transformAndEmitBreakStatement(node) {
	            var label = findBreakTarget(node.label ? ts.idText(node.label) : undefined);
	            if (label > 0) {
	                emitBreak(label, /*location*/ node);
	            }
	            else {
	                // invalid break without a containing loop, switch, or labeled statement. Leave the node as is, per #17875.
	                emitStatement(node);
	            }
	        }
	        function visitBreakStatement(node) {
	            if (inStatementContainingYield) {
	                var label = findBreakTarget(node.label && ts.idText(node.label));
	                if (label > 0) {
	                    return createInlineBreak(label, /*location*/ node);
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function transformAndEmitReturnStatement(node) {
	            emitReturn(ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*location*/ node);
	        }
	        function visitReturnStatement(node) {
	            return createInlineReturn(ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*location*/ node);
	        }
	        function transformAndEmitWithStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      with (x) {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .with (x)
	                //      /*body*/
	                //  .endwith
	                beginWithBlock(cacheExpression(ts.visitNode(node.expression, visitor, ts.isExpression)));
	                transformAndEmitEmbeddedStatement(node.statement);
	                endWithBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function transformAndEmitSwitchStatement(node) {
	            if (containsYield(node.caseBlock)) {
	                // [source]
	                //      switch (x) {
	                //          case a:
	                //              /*caseStatements*/
	                //          case b:
	                //              /*caseStatements*/
	                //          default:
	                //              /*defaultStatements*/
	                //      }
	                //
	                // [intermediate]
	                //  .local _a
	                //  .switch endLabel
	                //      _a = x;
	                //      switch (_a) {
	                //          case a:
	                //  .br clauseLabels[0]
	                //      }
	                //      switch (_a) {
	                //          case b:
	                //  .br clauseLabels[1]
	                //      }
	                //  .br clauseLabels[2]
	                //  .mark clauseLabels[0]
	                //      /*caseStatements*/
	                //  .mark clauseLabels[1]
	                //      /*caseStatements*/
	                //  .mark clauseLabels[2]
	                //      /*caseStatements*/
	                //  .endswitch
	                //  .mark endLabel
	                var caseBlock = node.caseBlock;
	                var numClauses = caseBlock.clauses.length;
	                var endLabel = beginSwitchBlock();
	                var expression = cacheExpression(ts.visitNode(node.expression, visitor, ts.isExpression));
	                // Create labels for each clause and find the index of the first default clause.
	                var clauseLabels = [];
	                var defaultClauseIndex = -1;
	                for (var i = 0; i < numClauses; i++) {
	                    var clause = caseBlock.clauses[i];
	                    clauseLabels.push(defineLabel());
	                    if (clause.kind === 265 /* DefaultClause */ && defaultClauseIndex === -1) {
	                        defaultClauseIndex = i;
	                    }
	                }
	                // Emit switch statements for each run of case clauses either from the first case
	                // clause or the next case clause with a `yield` in its expression, up to the next
	                // case clause with a `yield` in its expression.
	                var clausesWritten = 0;
	                var pendingClauses = [];
	                while (clausesWritten < numClauses) {
	                    var defaultClausesSkipped = 0;
	                    for (var i = clausesWritten; i < numClauses; i++) {
	                        var clause = caseBlock.clauses[i];
	                        if (clause.kind === 264 /* CaseClause */) {
	                            if (containsYield(clause.expression) && pendingClauses.length > 0) {
	                                break;
	                            }
	                            pendingClauses.push(ts.createCaseClause(ts.visitNode(clause.expression, visitor, ts.isExpression), [
	                                createInlineBreak(clauseLabels[i], /*location*/ clause.expression)
	                            ]));
	                        }
	                        else {
	                            defaultClausesSkipped++;
	                        }
	                    }
	                    if (pendingClauses.length) {
	                        emitStatement(ts.createSwitch(expression, ts.createCaseBlock(pendingClauses)));
	                        clausesWritten += pendingClauses.length;
	                        pendingClauses = [];
	                    }
	                    if (defaultClausesSkipped > 0) {
	                        clausesWritten += defaultClausesSkipped;
	                        defaultClausesSkipped = 0;
	                    }
	                }
	                if (defaultClauseIndex >= 0) {
	                    emitBreak(clauseLabels[defaultClauseIndex]);
	                }
	                else {
	                    emitBreak(endLabel);
	                }
	                for (var i = 0; i < numClauses; i++) {
	                    markLabel(clauseLabels[i]);
	                    transformAndEmitStatements(caseBlock.clauses[i].statements);
	                }
	                endSwitchBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitSwitchStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptSwitchBlock();
	            }
	            node = ts.visitEachChild(node, visitor, context);
	            if (inStatementContainingYield) {
	                endSwitchBlock();
	            }
	            return node;
	        }
	        function transformAndEmitLabeledStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      x: {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .labeled "x", endLabel
	                //      /*body*/
	                //  .endlabeled
	                //  .mark endLabel
	                beginLabeledBlock(ts.idText(node.label));
	                transformAndEmitEmbeddedStatement(node.statement);
	                endLabeledBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitLabeledStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptLabeledBlock(ts.idText(node.label));
	            }
	            node = ts.visitEachChild(node, visitor, context);
	            if (inStatementContainingYield) {
	                endLabeledBlock();
	            }
	            return node;
	        }
	        function transformAndEmitThrowStatement(node) {
	            emitThrow(ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*location*/ node);
	        }
	        function transformAndEmitTryStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      try {
	                //          /*tryBlock*/
	                //      }
	                //      catch (e) {
	                //          /*catchBlock*/
	                //      }
	                //      finally {
	                //          /*finallyBlock*/
	                //      }
	                //
	                // [intermediate]
	                //  .local _a
	                //  .try tryLabel, catchLabel, finallyLabel, endLabel
	                //  .mark tryLabel
	                //  .nop
	                //      /*tryBlock*/
	                //  .br endLabel
	                //  .catch
	                //  .mark catchLabel
	                //      _a = %error%;
	                //      /*catchBlock*/
	                //  .br endLabel
	                //  .finally
	                //  .mark finallyLabel
	                //      /*finallyBlock*/
	                //  .endfinally
	                //  .endtry
	                //  .mark endLabel
	                beginExceptionBlock();
	                transformAndEmitEmbeddedStatement(node.tryBlock);
	                if (node.catchClause) {
	                    beginCatchBlock(node.catchClause.variableDeclaration);
	                    transformAndEmitEmbeddedStatement(node.catchClause.block);
	                }
	                if (node.finallyBlock) {
	                    beginFinallyBlock();
	                    transformAndEmitEmbeddedStatement(node.finallyBlock);
	                }
	                endExceptionBlock();
	            }
	            else {
	                emitStatement(ts.visitEachChild(node, visitor, context));
	            }
	        }
	        function containsYield(node) {
	            return node && (node.transformFlags & 16777216 /* ContainsYield */) !== 0;
	        }
	        function countInitialNodesWithoutYield(nodes) {
	            var numNodes = nodes.length;
	            for (var i = 0; i < numNodes; i++) {
	                if (containsYield(nodes[i])) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            return node;
	        }
	        function substituteExpression(node) {
	            if (ts.isIdentifier(node)) {
	                return substituteExpressionIdentifier(node);
	            }
	            return node;
	        }
	        function substituteExpressionIdentifier(node) {
	            if (!ts.isGeneratedIdentifier(node) && renamedCatchVariables && renamedCatchVariables.has(ts.idText(node))) {
	                var original = ts.getOriginalNode(node);
	                if (ts.isIdentifier(original) && original.parent) {
	                    var declaration = resolver.getReferencedValueDeclaration(original);
	                    if (declaration) {
	                        var name = renamedCatchVariableDeclarations[ts.getOriginalNodeId(declaration)];
	                        if (name) {
	                            var clone_6 = ts.getMutableClone(name);
	                            ts.setSourceMapRange(clone_6, node);
	                            ts.setCommentRange(clone_6, node);
	                            return clone_6;
	                        }
	                    }
	                }
	            }
	            return node;
	        }
	        function cacheExpression(node) {
	            var temp;
	            if (ts.isGeneratedIdentifier(node) || ts.getEmitFlags(node) & 4096 /* HelperName */) {
	                return node;
	            }
	            temp = ts.createTempVariable(hoistVariableDeclaration);
	            emitAssignment(temp, node, /*location*/ node);
	            return temp;
	        }
	        function declareLocal(name) {
	            var temp = name
	                ? ts.createUniqueName(name)
	                : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            hoistVariableDeclaration(temp);
	            return temp;
	        }
	        /**
	         * Defines a label, uses as the target of a Break operation.
	         */
	        function defineLabel() {
	            if (!labelOffsets) {
	                labelOffsets = [];
	            }
	            var label = nextLabelId;
	            nextLabelId++;
	            labelOffsets[label] = -1;
	            return label;
	        }
	        /**
	         * Marks the current operation with the specified label.
	         */
	        function markLabel(label) {
	            ts.Debug.assert(labelOffsets !== undefined, "No labels were defined.");
	            labelOffsets[label] = operations ? operations.length : 0;
	        }
	        /**
	         * Begins a block operation (With, Break/Continue, Try/Catch/Finally)
	         *
	         * @param block Information about the block.
	         */
	        function beginBlock(block) {
	            if (!blocks) {
	                blocks = [];
	                blockActions = [];
	                blockOffsets = [];
	                blockStack = [];
	            }
	            var index = blockActions.length;
	            blockActions[index] = 0 /* Open */;
	            blockOffsets[index] = operations ? operations.length : 0;
	            blocks[index] = block;
	            blockStack.push(block);
	            return index;
	        }
	        /**
	         * Ends the current block operation.
	         */
	        function endBlock() {
	            var block = peekBlock();
	            ts.Debug.assert(block !== undefined, "beginBlock was never called.");
	            var index = blockActions.length;
	            blockActions[index] = 1 /* Close */;
	            blockOffsets[index] = operations ? operations.length : 0;
	            blocks[index] = block;
	            blockStack.pop();
	            return block;
	        }
	        /**
	         * Gets the current open block.
	         */
	        function peekBlock() {
	            return ts.lastOrUndefined(blockStack);
	        }
	        /**
	         * Gets the kind of the current open block.
	         */
	        function peekBlockKind() {
	            var block = peekBlock();
	            return block && block.kind;
	        }
	        /**
	         * Begins a code block for a generated `with` statement.
	         *
	         * @param expression An identifier representing expression for the `with` block.
	         */
	        function beginWithBlock(expression) {
	            var startLabel = defineLabel();
	            var endLabel = defineLabel();
	            markLabel(startLabel);
	            beginBlock({
	                kind: 1 /* With */,
	                expression: expression,
	                startLabel: startLabel,
	                endLabel: endLabel
	            });
	        }
	        /**
	         * Ends a code block for a generated `with` statement.
	         */
	        function endWithBlock() {
	            ts.Debug.assert(peekBlockKind() === 1 /* With */);
	            var block = endBlock();
	            markLabel(block.endLabel);
	        }
	        /**
	         * Begins a code block for a generated `try` statement.
	         */
	        function beginExceptionBlock() {
	            var startLabel = defineLabel();
	            var endLabel = defineLabel();
	            markLabel(startLabel);
	            beginBlock({
	                kind: 0 /* Exception */,
	                state: 0 /* Try */,
	                startLabel: startLabel,
	                endLabel: endLabel
	            });
	            emitNop();
	            return endLabel;
	        }
	        /**
	         * Enters the `catch` clause of a generated `try` statement.
	         *
	         * @param variable The catch variable.
	         */
	        function beginCatchBlock(variable) {
	            ts.Debug.assert(peekBlockKind() === 0 /* Exception */);
	            // generated identifiers should already be unique within a file
	            var name;
	            if (ts.isGeneratedIdentifier(variable.name)) {
	                name = variable.name;
	                hoistVariableDeclaration(variable.name);
	            }
	            else {
	                var text = ts.idText(variable.name);
	                name = declareLocal(text);
	                if (!renamedCatchVariables) {
	                    renamedCatchVariables = ts.createMap();
	                    renamedCatchVariableDeclarations = [];
	                    context.enableSubstitution(71 /* Identifier */);
	                }
	                renamedCatchVariables.set(text, true);
	                renamedCatchVariableDeclarations[ts.getOriginalNodeId(variable)] = name;
	            }
	            var exception = peekBlock();
	            ts.Debug.assert(exception.state < 1 /* Catch */);
	            var endLabel = exception.endLabel;
	            emitBreak(endLabel);
	            var catchLabel = defineLabel();
	            markLabel(catchLabel);
	            exception.state = 1 /* Catch */;
	            exception.catchVariable = name;
	            exception.catchLabel = catchLabel;
	            emitAssignment(name, ts.createCall(ts.createPropertyAccess(state, "sent"), /*typeArguments*/ undefined, []));
	            emitNop();
	        }
	        /**
	         * Enters the `finally` block of a generated `try` statement.
	         */
	        function beginFinallyBlock() {
	            ts.Debug.assert(peekBlockKind() === 0 /* Exception */);
	            var exception = peekBlock();
	            ts.Debug.assert(exception.state < 2 /* Finally */);
	            var endLabel = exception.endLabel;
	            emitBreak(endLabel);
	            var finallyLabel = defineLabel();
	            markLabel(finallyLabel);
	            exception.state = 2 /* Finally */;
	            exception.finallyLabel = finallyLabel;
	        }
	        /**
	         * Ends the code block for a generated `try` statement.
	         */
	        function endExceptionBlock() {
	            ts.Debug.assert(peekBlockKind() === 0 /* Exception */);
	            var exception = endBlock();
	            var state = exception.state;
	            if (state < 2 /* Finally */) {
	                emitBreak(exception.endLabel);
	            }
	            else {
	                emitEndfinally();
	            }
	            markLabel(exception.endLabel);
	            emitNop();
	            exception.state = 3 /* Done */;
	        }
	        /**
	         * Begins a code block that supports `break` or `continue` statements that are defined in
	         * the source tree and not from generated code.
	         *
	         * @param labelText Names from containing labeled statements.
	         */
	        function beginScriptLoopBlock() {
	            beginBlock({
	                kind: 3 /* Loop */,
	                isScript: true,
	                breakLabel: -1,
	                continueLabel: -1
	            });
	        }
	        /**
	         * Begins a code block that supports `break` or `continue` statements that are defined in
	         * generated code. Returns a label used to mark the operation to which to jump when a
	         * `break` statement targets this block.
	         *
	         * @param continueLabel A Label used to mark the operation to which to jump when a
	         *                      `continue` statement targets this block.
	         */
	        function beginLoopBlock(continueLabel) {
	            var breakLabel = defineLabel();
	            beginBlock({
	                kind: 3 /* Loop */,
	                isScript: false,
	                breakLabel: breakLabel,
	                continueLabel: continueLabel,
	            });
	            return breakLabel;
	        }
	        /**
	         * Ends a code block that supports `break` or `continue` statements that are defined in
	         * generated code or in the source tree.
	         */
	        function endLoopBlock() {
	            ts.Debug.assert(peekBlockKind() === 3 /* Loop */);
	            var block = endBlock();
	            var breakLabel = block.breakLabel;
	            if (!block.isScript) {
	                markLabel(breakLabel);
	            }
	        }
	        /**
	         * Begins a code block that supports `break` statements that are defined in the source
	         * tree and not from generated code.
	         *
	         */
	        function beginScriptSwitchBlock() {
	            beginBlock({
	                kind: 2 /* Switch */,
	                isScript: true,
	                breakLabel: -1
	            });
	        }
	        /**
	         * Begins a code block that supports `break` statements that are defined in generated code.
	         * Returns a label used to mark the operation to which to jump when a `break` statement
	         * targets this block.
	         */
	        function beginSwitchBlock() {
	            var breakLabel = defineLabel();
	            beginBlock({
	                kind: 2 /* Switch */,
	                isScript: false,
	                breakLabel: breakLabel,
	            });
	            return breakLabel;
	        }
	        /**
	         * Ends a code block that supports `break` statements that are defined in generated code.
	         */
	        function endSwitchBlock() {
	            ts.Debug.assert(peekBlockKind() === 2 /* Switch */);
	            var block = endBlock();
	            var breakLabel = block.breakLabel;
	            if (!block.isScript) {
	                markLabel(breakLabel);
	            }
	        }
	        function beginScriptLabeledBlock(labelText) {
	            beginBlock({
	                kind: 4 /* Labeled */,
	                isScript: true,
	                labelText: labelText,
	                breakLabel: -1
	            });
	        }
	        function beginLabeledBlock(labelText) {
	            var breakLabel = defineLabel();
	            beginBlock({
	                kind: 4 /* Labeled */,
	                isScript: false,
	                labelText: labelText,
	                breakLabel: breakLabel
	            });
	        }
	        function endLabeledBlock() {
	            ts.Debug.assert(peekBlockKind() === 4 /* Labeled */);
	            var block = endBlock();
	            if (!block.isScript) {
	                markLabel(block.breakLabel);
	            }
	        }
	        /**
	         * Indicates whether the provided block supports `break` statements.
	         *
	         * @param block A code block.
	         */
	        function supportsUnlabeledBreak(block) {
	            return block.kind === 2 /* Switch */
	                || block.kind === 3 /* Loop */;
	        }
	        /**
	         * Indicates whether the provided block supports `break` statements with labels.
	         *
	         * @param block A code block.
	         */
	        function supportsLabeledBreakOrContinue(block) {
	            return block.kind === 4 /* Labeled */;
	        }
	        /**
	         * Indicates whether the provided block supports `continue` statements.
	         *
	         * @param block A code block.
	         */
	        function supportsUnlabeledContinue(block) {
	            return block.kind === 3 /* Loop */;
	        }
	        function hasImmediateContainingLabeledBlock(labelText, start) {
	            for (var j = start; j >= 0; j--) {
	                var containingBlock = blockStack[j];
	                if (supportsLabeledBreakOrContinue(containingBlock)) {
	                    if (containingBlock.labelText === labelText) {
	                        return true;
	                    }
	                }
	                else {
	                    break;
	                }
	            }
	            return false;
	        }
	        /**
	         * Finds the label that is the target for a `break` statement.
	         *
	         * @param labelText An optional name of a containing labeled statement.
	         */
	        function findBreakTarget(labelText) {
	            if (blockStack) {
	                if (labelText) {
	                    for (var i = blockStack.length - 1; i >= 0; i--) {
	                        var block = blockStack[i];
	                        if (supportsLabeledBreakOrContinue(block) && block.labelText === labelText) {
	                            return block.breakLabel;
	                        }
	                        else if (supportsUnlabeledBreak(block) && hasImmediateContainingLabeledBlock(labelText, i - 1)) {
	                            return block.breakLabel;
	                        }
	                    }
	                }
	                else {
	                    for (var i = blockStack.length - 1; i >= 0; i--) {
	                        var block = blockStack[i];
	                        if (supportsUnlabeledBreak(block)) {
	                            return block.breakLabel;
	                        }
	                    }
	                }
	            }
	            return 0;
	        }
	        /**
	         * Finds the label that is the target for a `continue` statement.
	         *
	         * @param labelText An optional name of a containing labeled statement.
	         */
	        function findContinueTarget(labelText) {
	            if (blockStack) {
	                if (labelText) {
	                    for (var i = blockStack.length - 1; i >= 0; i--) {
	                        var block = blockStack[i];
	                        if (supportsUnlabeledContinue(block) && hasImmediateContainingLabeledBlock(labelText, i - 1)) {
	                            return block.continueLabel;
	                        }
	                    }
	                }
	                else {
	                    for (var i = blockStack.length - 1; i >= 0; i--) {
	                        var block = blockStack[i];
	                        if (supportsUnlabeledContinue(block)) {
	                            return block.continueLabel;
	                        }
	                    }
	                }
	            }
	            return 0;
	        }
	        /**
	         * Creates an expression that can be used to indicate the value for a label.
	         *
	         * @param label A label.
	         */
	        function createLabel(label) {
	            if (label > 0) {
	                if (labelExpressions === undefined) {
	                    labelExpressions = [];
	                }
	                var expression = ts.createLiteral(-1);
	                if (labelExpressions[label] === undefined) {
	                    labelExpressions[label] = [expression];
	                }
	                else {
	                    labelExpressions[label].push(expression);
	                }
	                return expression;
	            }
	            return ts.createOmittedExpression();
	        }
	        /**
	         * Creates a numeric literal for the provided instruction.
	         */
	        function createInstruction(instruction) {
	            var literal = ts.createLiteral(instruction);
	            ts.addSyntheticTrailingComment(literal, 3 /* MultiLineCommentTrivia */, getInstructionName(instruction));
	            return literal;
	        }
	        /**
	         * Creates a statement that can be used indicate a Break operation to the provided label.
	         *
	         * @param label A label.
	         * @param location An optional source map location for the statement.
	         */
	        function createInlineBreak(label, location) {
	            ts.Debug.assertLessThan(0, label, "Invalid label");
	            return ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(3 /* Break */),
	                createLabel(label)
	            ])), location);
	        }
	        /**
	         * Creates a statement that can be used indicate a Return operation.
	         *
	         * @param expression The expression for the return statement.
	         * @param location An optional source map location for the statement.
	         */
	        function createInlineReturn(expression, location) {
	            return ts.setTextRange(ts.createReturn(ts.createArrayLiteral(expression
	                ? [createInstruction(2 /* Return */), expression]
	                : [createInstruction(2 /* Return */)])), location);
	        }
	        /**
	         * Creates an expression that can be used to resume from a Yield operation.
	         */
	        function createGeneratorResume(location) {
	            return ts.setTextRange(ts.createCall(ts.createPropertyAccess(state, "sent"), 
	            /*typeArguments*/ undefined, []), location);
	        }
	        /**
	         * Emits an empty instruction.
	         */
	        function emitNop() {
	            emitWorker(0 /* Nop */);
	        }
	        /**
	         * Emits a Statement.
	         *
	         * @param node A statement.
	         */
	        function emitStatement(node) {
	            if (node) {
	                emitWorker(1 /* Statement */, [node]);
	            }
	            else {
	                emitNop();
	            }
	        }
	        /**
	         * Emits an Assignment operation.
	         *
	         * @param left The left-hand side of the assignment.
	         * @param right The right-hand side of the assignment.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitAssignment(left, right, location) {
	            emitWorker(2 /* Assign */, [left, right], location);
	        }
	        /**
	         * Emits a Break operation to the specified label.
	         *
	         * @param label A label.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitBreak(label, location) {
	            emitWorker(3 /* Break */, [label], location);
	        }
	        /**
	         * Emits a Break operation to the specified label when a condition evaluates to a truthy
	         * value at runtime.
	         *
	         * @param label A label.
	         * @param condition The condition.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitBreakWhenTrue(label, condition, location) {
	            emitWorker(4 /* BreakWhenTrue */, [label, condition], location);
	        }
	        /**
	         * Emits a Break to the specified label when a condition evaluates to a falsey value at
	         * runtime.
	         *
	         * @param label A label.
	         * @param condition The condition.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitBreakWhenFalse(label, condition, location) {
	            emitWorker(5 /* BreakWhenFalse */, [label, condition], location);
	        }
	        /**
	         * Emits a YieldStar operation for the provided expression.
	         *
	         * @param expression An optional value for the yield operation.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitYieldStar(expression, location) {
	            emitWorker(7 /* YieldStar */, [expression], location);
	        }
	        /**
	         * Emits a Yield operation for the provided expression.
	         *
	         * @param expression An optional value for the yield operation.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitYield(expression, location) {
	            emitWorker(6 /* Yield */, [expression], location);
	        }
	        /**
	         * Emits a Return operation for the provided expression.
	         *
	         * @param expression An optional value for the operation.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitReturn(expression, location) {
	            emitWorker(8 /* Return */, [expression], location);
	        }
	        /**
	         * Emits a Throw operation for the provided expression.
	         *
	         * @param expression A value for the operation.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitThrow(expression, location) {
	            emitWorker(9 /* Throw */, [expression], location);
	        }
	        /**
	         * Emits an Endfinally operation. This is used to handle `finally` block semantics.
	         */
	        function emitEndfinally() {
	            emitWorker(10 /* Endfinally */);
	        }
	        /**
	         * Emits an operation.
	         *
	         * @param code The OpCode for the operation.
	         * @param args The optional arguments for the operation.
	         */
	        function emitWorker(code, args, location) {
	            if (operations === undefined) {
	                operations = [];
	                operationArguments = [];
	                operationLocations = [];
	            }
	            if (labelOffsets === undefined) {
	                // mark entry point
	                markLabel(defineLabel());
	            }
	            var operationIndex = operations.length;
	            operations[operationIndex] = code;
	            operationArguments[operationIndex] = args;
	            operationLocations[operationIndex] = location;
	        }
	        /**
	         * Builds the generator function body.
	         */
	        function build() {
	            blockIndex = 0;
	            labelNumber = 0;
	            labelNumbers = undefined;
	            lastOperationWasAbrupt = false;
	            lastOperationWasCompletion = false;
	            clauses = undefined;
	            statements = undefined;
	            exceptionBlockStack = undefined;
	            currentExceptionBlock = undefined;
	            withBlockStack = undefined;
	            var buildResult = buildStatements();
	            return createGeneratorHelper(context, ts.setEmitFlags(ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, state)], 
	            /*type*/ undefined, ts.createBlock(buildResult, 
	            /*multiLine*/ buildResult.length > 0)), 524288 /* ReuseTempVariableScope */));
	        }
	        /**
	         * Builds the statements for the generator function body.
	         */
	        function buildStatements() {
	            if (operations) {
	                for (var operationIndex = 0; operationIndex < operations.length; operationIndex++) {
	                    writeOperation(operationIndex);
	                }
	                flushFinalLabel(operations.length);
	            }
	            else {
	                flushFinalLabel(0);
	            }
	            if (clauses) {
	                var labelExpression = ts.createPropertyAccess(state, "label");
	                var switchStatement = ts.createSwitch(labelExpression, ts.createCaseBlock(clauses));
	                return [ts.startOnNewLine(switchStatement)];
	            }
	            if (statements) {
	                return statements;
	            }
	            return [];
	        }
	        /**
	         * Flush the current label and advance to a new label.
	         */
	        function flushLabel() {
	            if (!statements) {
	                return;
	            }
	            appendLabel(/*markLabelEnd*/ !lastOperationWasAbrupt);
	            lastOperationWasAbrupt = false;
	            lastOperationWasCompletion = false;
	            labelNumber++;
	        }
	        /**
	         * Flush the final label of the generator function body.
	         */
	        function flushFinalLabel(operationIndex) {
	            if (isFinalLabelReachable(operationIndex)) {
	                tryEnterLabel(operationIndex);
	                withBlockStack = undefined;
	                writeReturn(/*expression*/ undefined, /*operationLocation*/ undefined);
	            }
	            if (statements && clauses) {
	                appendLabel(/*markLabelEnd*/ false);
	            }
	            updateLabelExpressions();
	        }
	        /**
	         * Tests whether the final label of the generator function body
	         * is reachable by user code.
	         */
	        function isFinalLabelReachable(operationIndex) {
	            // if the last operation was *not* a completion (return/throw) then
	            // the final label is reachable.
	            if (!lastOperationWasCompletion) {
	                return true;
	            }
	            // if there are no labels defined or referenced, then the final label is
	            // not reachable.
	            if (!labelOffsets || !labelExpressions) {
	                return false;
	            }
	            // if the label for this offset is referenced, then the final label
	            // is reachable.
	            for (var label = 0; label < labelOffsets.length; label++) {
	                if (labelOffsets[label] === operationIndex && labelExpressions[label]) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        /**
	         * Appends a case clause for the last label and sets the new label.
	         *
	         * @param markLabelEnd Indicates that the transition between labels was a fall-through
	         *                     from a previous case clause and the change in labels should be
	         *                     reflected on the `state` object.
	         */
	        function appendLabel(markLabelEnd) {
	            if (!clauses) {
	                clauses = [];
	            }
	            if (statements) {
	                if (withBlockStack) {
	                    // The previous label was nested inside one or more `with` blocks, so we
	                    // surround the statements in generated `with` blocks to create the same environment.
	                    for (var i = withBlockStack.length - 1; i >= 0; i--) {
	                        var withBlock = withBlockStack[i];
	                        statements = [ts.createWith(withBlock.expression, ts.createBlock(statements))];
	                    }
	                }
	                if (currentExceptionBlock) {
	                    // The previous label was nested inside of an exception block, so we must
	                    // indicate entry into a protected region by pushing the label numbers
	                    // for each block in the protected region.
	                    var startLabel = currentExceptionBlock.startLabel, catchLabel = currentExceptionBlock.catchLabel, finallyLabel = currentExceptionBlock.finallyLabel, endLabel = currentExceptionBlock.endLabel;
	                    statements.unshift(ts.createStatement(ts.createCall(ts.createPropertyAccess(ts.createPropertyAccess(state, "trys"), "push"), 
	                    /*typeArguments*/ undefined, [
	                        ts.createArrayLiteral([
	                            createLabel(startLabel),
	                            createLabel(catchLabel),
	                            createLabel(finallyLabel),
	                            createLabel(endLabel)
	                        ])
	                    ])));
	                    currentExceptionBlock = undefined;
	                }
	                if (markLabelEnd) {
	                    // The case clause for the last label falls through to this label, so we
	                    // add an assignment statement to reflect the change in labels.
	                    statements.push(ts.createStatement(ts.createAssignment(ts.createPropertyAccess(state, "label"), ts.createLiteral(labelNumber + 1))));
	                }
	            }
	            clauses.push(ts.createCaseClause(ts.createLiteral(labelNumber), statements || []));
	            statements = undefined;
	        }
	        /**
	         * Tries to enter into a new label at the current operation index.
	         */
	        function tryEnterLabel(operationIndex) {
	            if (!labelOffsets) {
	                return;
	            }
	            for (var label = 0; label < labelOffsets.length; label++) {
	                if (labelOffsets[label] === operationIndex) {
	                    flushLabel();
	                    if (labelNumbers === undefined) {
	                        labelNumbers = [];
	                    }
	                    if (labelNumbers[labelNumber] === undefined) {
	                        labelNumbers[labelNumber] = [label];
	                    }
	                    else {
	                        labelNumbers[labelNumber].push(label);
	                    }
	                }
	            }
	        }
	        /**
	         * Updates literal expressions for labels with actual label numbers.
	         */
	        function updateLabelExpressions() {
	            if (labelExpressions !== undefined && labelNumbers !== undefined) {
	                for (var labelNumber_1 = 0; labelNumber_1 < labelNumbers.length; labelNumber_1++) {
	                    var labels = labelNumbers[labelNumber_1];
	                    if (labels !== undefined) {
	                        for (var _i = 0, labels_1 = labels; _i < labels_1.length; _i++) {
	                            var label = labels_1[_i];
	                            var expressions = labelExpressions[label];
	                            if (expressions !== undefined) {
	                                for (var _a = 0, expressions_1 = expressions; _a < expressions_1.length; _a++) {
	                                    var expression = expressions_1[_a];
	                                    expression.text = String(labelNumber_1);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        /**
	         * Tries to enter or leave a code block.
	         */
	        function tryEnterOrLeaveBlock(operationIndex) {
	            if (blocks) {
	                for (; blockIndex < blockActions.length && blockOffsets[blockIndex] <= operationIndex; blockIndex++) {
	                    var block = blocks[blockIndex];
	                    var blockAction = blockActions[blockIndex];
	                    switch (block.kind) {
	                        case 0 /* Exception */:
	                            if (blockAction === 0 /* Open */) {
	                                if (!exceptionBlockStack) {
	                                    exceptionBlockStack = [];
	                                }
	                                if (!statements) {
	                                    statements = [];
	                                }
	                                exceptionBlockStack.push(currentExceptionBlock);
	                                currentExceptionBlock = block;
	                            }
	                            else if (blockAction === 1 /* Close */) {
	                                currentExceptionBlock = exceptionBlockStack.pop();
	                            }
	                            break;
	                        case 1 /* With */:
	                            if (blockAction === 0 /* Open */) {
	                                if (!withBlockStack) {
	                                    withBlockStack = [];
	                                }
	                                withBlockStack.push(block);
	                            }
	                            else if (blockAction === 1 /* Close */) {
	                                withBlockStack.pop();
	                            }
	                            break;
	                    }
	                }
	            }
	        }
	        /**
	         * Writes an operation as a statement to the current label's statement list.
	         *
	         * @param operation The OpCode of the operation
	         */
	        function writeOperation(operationIndex) {
	            tryEnterLabel(operationIndex);
	            tryEnterOrLeaveBlock(operationIndex);
	            // early termination, nothing else to process in this label
	            if (lastOperationWasAbrupt) {
	                return;
	            }
	            lastOperationWasAbrupt = false;
	            lastOperationWasCompletion = false;
	            var opcode = operations[operationIndex];
	            if (opcode === 0 /* Nop */) {
	                return;
	            }
	            else if (opcode === 10 /* Endfinally */) {
	                return writeEndfinally();
	            }
	            var args = operationArguments[operationIndex];
	            if (opcode === 1 /* Statement */) {
	                return writeStatement(args[0]);
	            }
	            var location = operationLocations[operationIndex];
	            switch (opcode) {
	                case 2 /* Assign */:
	                    return writeAssign(args[0], args[1], location);
	                case 3 /* Break */:
	                    return writeBreak(args[0], location);
	                case 4 /* BreakWhenTrue */:
	                    return writeBreakWhenTrue(args[0], args[1], location);
	                case 5 /* BreakWhenFalse */:
	                    return writeBreakWhenFalse(args[0], args[1], location);
	                case 6 /* Yield */:
	                    return writeYield(args[0], location);
	                case 7 /* YieldStar */:
	                    return writeYieldStar(args[0], location);
	                case 8 /* Return */:
	                    return writeReturn(args[0], location);
	                case 9 /* Throw */:
	                    return writeThrow(args[0], location);
	            }
	        }
	        /**
	         * Writes a statement to the current label's statement list.
	         *
	         * @param statement A statement to write.
	         */
	        function writeStatement(statement) {
	            if (statement) {
	                if (!statements) {
	                    statements = [statement];
	                }
	                else {
	                    statements.push(statement);
	                }
	            }
	        }
	        /**
	         * Writes an Assign operation to the current label's statement list.
	         *
	         * @param left The left-hand side of the assignment.
	         * @param right The right-hand side of the assignment.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeAssign(left, right, operationLocation) {
	            writeStatement(ts.setTextRange(ts.createStatement(ts.createAssignment(left, right)), operationLocation));
	        }
	        /**
	         * Writes a Throw operation to the current label's statement list.
	         *
	         * @param expression The value to throw.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeThrow(expression, operationLocation) {
	            lastOperationWasAbrupt = true;
	            lastOperationWasCompletion = true;
	            writeStatement(ts.setTextRange(ts.createThrow(expression), operationLocation));
	        }
	        /**
	         * Writes a Return operation to the current label's statement list.
	         *
	         * @param expression The value to return.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeReturn(expression, operationLocation) {
	            lastOperationWasAbrupt = true;
	            lastOperationWasCompletion = true;
	            writeStatement(ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral(expression
	                ? [createInstruction(2 /* Return */), expression]
	                : [createInstruction(2 /* Return */)])), operationLocation), 384 /* NoTokenSourceMaps */));
	        }
	        /**
	         * Writes a Break operation to the current label's statement list.
	         *
	         * @param label The label for the Break.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeBreak(label, operationLocation) {
	            lastOperationWasAbrupt = true;
	            writeStatement(ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(3 /* Break */),
	                createLabel(label)
	            ])), operationLocation), 384 /* NoTokenSourceMaps */));
	        }
	        /**
	         * Writes a BreakWhenTrue operation to the current label's statement list.
	         *
	         * @param label The label for the Break.
	         * @param condition The condition for the Break.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeBreakWhenTrue(label, condition, operationLocation) {
	            writeStatement(ts.setEmitFlags(ts.createIf(condition, ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(3 /* Break */),
	                createLabel(label)
	            ])), operationLocation), 384 /* NoTokenSourceMaps */)), 1 /* SingleLine */));
	        }
	        /**
	         * Writes a BreakWhenFalse operation to the current label's statement list.
	         *
	         * @param label The label for the Break.
	         * @param condition The condition for the Break.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeBreakWhenFalse(label, condition, operationLocation) {
	            writeStatement(ts.setEmitFlags(ts.createIf(ts.createLogicalNot(condition), ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(3 /* Break */),
	                createLabel(label)
	            ])), operationLocation), 384 /* NoTokenSourceMaps */)), 1 /* SingleLine */));
	        }
	        /**
	         * Writes a Yield operation to the current label's statement list.
	         *
	         * @param expression The expression to yield.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeYield(expression, operationLocation) {
	            lastOperationWasAbrupt = true;
	            writeStatement(ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral(expression
	                ? [createInstruction(4 /* Yield */), expression]
	                : [createInstruction(4 /* Yield */)])), operationLocation), 384 /* NoTokenSourceMaps */));
	        }
	        /**
	         * Writes a YieldStar instruction to the current label's statement list.
	         *
	         * @param expression The expression to yield.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeYieldStar(expression, operationLocation) {
	            lastOperationWasAbrupt = true;
	            writeStatement(ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(5 /* YieldStar */),
	                expression
	            ])), operationLocation), 384 /* NoTokenSourceMaps */));
	        }
	        /**
	         * Writes an Endfinally instruction to the current label's statement list.
	         */
	        function writeEndfinally() {
	            lastOperationWasAbrupt = true;
	            writeStatement(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(7 /* Endfinally */)
	            ])));
	        }
	    }
	    ts.transformGenerators = transformGenerators;
	    function createGeneratorHelper(context, body) {
	        context.requestEmitHelper(generatorHelper);
	        return ts.createCall(ts.getHelperName("__generator"), 
	        /*typeArguments*/ undefined, [ts.createThis(), body]);
	    }
	    // The __generator helper is used by down-level transformations to emulate the runtime
	    // semantics of an ES2015 generator function. When called, this helper returns an
	    // object that implements the Iterator protocol, in that it has `next`, `return`, and
	    // `throw` methods that step through the generator when invoked.
	    //
	    // parameters:
	    //  @param thisArg  The value to use as the `this` binding for the transformed generator body.
	    //  @param body     A function that acts as the transformed generator body.
	    //
	    // variables:
	    //  _       Persistent state for the generator that is shared between the helper and the
	    //          generator body. The state object has the following members:
	    //            sent() - A method that returns or throws the current completion value.
	    //            label  - The next point at which to resume evaluation of the generator body.
	    //            trys   - A stack of protected regions (try/catch/finally blocks).
	    //            ops    - A stack of pending instructions when inside of a finally block.
	    //  f       A value indicating whether the generator is executing.
	    //  y       An iterator to delegate for a yield*.
	    //  t       A temporary variable that holds one of the following values (note that these
	    //          cases do not overlap):
	    //          - The completion value when resuming from a `yield` or `yield*`.
	    //          - The error value for a catch block.
	    //          - The current protected region (array of try/catch/finally/end labels).
	    //          - The verb (`next`, `throw`, or `return` method) to delegate to the expression
	    //            of a `yield*`.
	    //          - The result of evaluating the verb delegated to the expression of a `yield*`.
	    //
	    // functions:
	    //  verb(n)     Creates a bound callback to the `step` function for opcode `n`.
	    //  step(op)    Evaluates opcodes in a generator body until execution is suspended or
	    //              completed.
	    //
	    // The __generator helper understands a limited set of instructions:
	    //  0: next(value?)     - Start or resume the generator with the specified value.
	    //  1: throw(error)     - Resume the generator with an exception. If the generator is
	    //                        suspended inside of one or more protected regions, evaluates
	    //                        any intervening finally blocks between the current label and
	    //                        the nearest catch block or function boundary. If uncaught, the
	    //                        exception is thrown to the caller.
	    //  2: return(value?)   - Resume the generator as if with a return. If the generator is
	    //                        suspended inside of one or more protected regions, evaluates any
	    //                        intervening finally blocks.
	    //  3: break(label)     - Jump to the specified label. If the label is outside of the
	    //                        current protected region, evaluates any intervening finally
	    //                        blocks.
	    //  4: yield(value?)    - Yield execution to the caller with an optional value. When
	    //                        resumed, the generator will continue at the next label.
	    //  5: yield*(value)    - Delegates evaluation to the supplied iterator. When
	    //                        delegation completes, the generator will continue at the next
	    //                        label.
	    //  6: catch(error)     - Handles an exception thrown from within the generator body. If
	    //                        the current label is inside of one or more protected regions,
	    //                        evaluates any intervening finally blocks between the current
	    //                        label and the nearest catch block or function boundary. If
	    //                        uncaught, the exception is thrown to the caller.
	    //  7: endfinally       - Ends a finally block, resuming the last instruction prior to
	    //                        entering a finally block.
	    //
	    // For examples of how these are used, see the comments in ./transformers/generators.ts
	    var generatorHelper = {
	        name: "typescript:generator",
	        scoped: false,
	        priority: 6,
	        text: "\n            var __generator = (this && this.__generator) || function (thisArg, body) {\n                var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;\n                return g = { next: verb(0), \"throw\": verb(1), \"return\": verb(2) }, typeof Symbol === \"function\" && (g[Symbol.iterator] = function() { return this; }), g;\n                function verb(n) { return function (v) { return step([n, v]); }; }\n                function step(op) {\n                    if (f) throw new TypeError(\"Generator is already executing.\");\n                    while (_) try {\n                        if (f = 1, y && (t = y[op[0] & 2 ? \"return\" : op[0] ? \"throw\" : \"next\"]) && !(t = t.call(y, op[1])).done) return t;\n                        if (y = 0, t) op = [0, t.value];\n                        switch (op[0]) {\n                            case 0: case 1: t = op; break;\n                            case 4: _.label++; return { value: op[1], done: false };\n                            case 5: _.label++; y = op[1]; op = [0]; continue;\n                            case 7: op = _.ops.pop(); _.trys.pop(); continue;\n                            default:\n                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }\n                                if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }\n                                if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }\n                                if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }\n                                if (t[2]) _.ops.pop();\n                                _.trys.pop(); continue;\n                        }\n                        op = body.call(thisArg, _);\n                    } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }\n                    if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };\n                }\n            };"
	    };
	})(ts || (ts = {}));
	/// <reference path="../../factory.ts" />
	/// <reference path="../../visitor.ts" />
	/// <reference path="../destructuring.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformModule(context) {
	        function getTransformModuleDelegate(moduleKind) {
	            switch (moduleKind) {
	                case ts.ModuleKind.AMD: return transformAMDModule;
	                case ts.ModuleKind.UMD: return transformUMDModule;
	                default: return transformCommonJSModule;
	            }
	        }
	        var startLexicalEnvironment = context.startLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var compilerOptions = context.getCompilerOptions();
	        var resolver = context.getEmitResolver();
	        var host = context.getEmitHost();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var moduleKind = ts.getEmitModuleKind(compilerOptions);
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        var previousOnEmitNode = context.onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        context.onEmitNode = onEmitNode;
	        context.enableSubstitution(71 /* Identifier */); // Substitutes expression identifiers with imported/exported symbols.
	        context.enableSubstitution(198 /* BinaryExpression */); // Substitutes assignments to exported symbols.
	        context.enableSubstitution(196 /* PrefixUnaryExpression */); // Substitutes updates to exported symbols.
	        context.enableSubstitution(197 /* PostfixUnaryExpression */); // Substitutes updates to exported symbols.
	        context.enableSubstitution(269 /* ShorthandPropertyAssignment */); // Substitutes shorthand property assignments for imported/exported symbols.
	        context.enableEmitNotification(272 /* SourceFile */); // Restore state when substituting nodes in a file.
	        var moduleInfoMap = []; // The ExternalModuleInfo for each file.
	        var deferredExports = []; // Exports to defer until an EndOfDeclarationMarker is found.
	        var currentSourceFile; // The current file.
	        var currentModuleInfo; // The ExternalModuleInfo for the current file.
	        var noSubstitution; // Set of nodes for which substitution rules should be ignored.
	        var needUMDDynamicImportHelper;
	        return transformSourceFile;
	        /**
	         * Transforms the module aspects of a SourceFile.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile || !(ts.isEffectiveExternalModule(node, compilerOptions) || node.transformFlags & 67108864 /* ContainsDynamicImport */)) {
	                return node;
	            }
	            currentSourceFile = node;
	            currentModuleInfo = ts.collectExternalModuleInfo(node, resolver, compilerOptions);
	            moduleInfoMap[ts.getOriginalNodeId(node)] = currentModuleInfo;
	            // Perform the transformation.
	            var transformModule = getTransformModuleDelegate(moduleKind);
	            var updated = transformModule(node);
	            currentSourceFile = undefined;
	            currentModuleInfo = undefined;
	            needUMDDynamicImportHelper = false;
	            return ts.aggregateTransformFlags(updated);
	        }
	        function shouldEmitUnderscoreUnderscoreESModule() {
	            if (!currentModuleInfo.exportEquals && ts.isExternalModule(currentSourceFile)) {
	                return true;
	            }
	            return false;
	        }
	        /**
	         * Transforms a SourceFile into a CommonJS module.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformCommonJSModule(node) {
	            startLexicalEnvironment();
	            var statements = [];
	            var ensureUseStrict = ts.getStrictOptionValue(compilerOptions, "alwaysStrict") || (!compilerOptions.noImplicitUseStrict && ts.isExternalModule(currentSourceFile));
	            var statementOffset = ts.addPrologue(statements, node.statements, ensureUseStrict, sourceElementVisitor);
	            if (shouldEmitUnderscoreUnderscoreESModule()) {
	                ts.append(statements, createUnderscoreUnderscoreESModule());
	            }
	            ts.append(statements, ts.visitNode(currentModuleInfo.externalHelpersImportDeclaration, sourceElementVisitor, ts.isStatement));
	            ts.addRange(statements, ts.visitNodes(node.statements, sourceElementVisitor, ts.isStatement, statementOffset));
	            addExportEqualsIfNeeded(statements, /*emitAsReturn*/ false);
	            ts.addRange(statements, endLexicalEnvironment());
	            var updated = ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray(statements), node.statements));
	            if (currentModuleInfo.hasExportStarsToExportValues && !compilerOptions.importHelpers) {
	                // If we have any `export * from ...` declarations
	                // we need to inform the emitter to add the __export helper.
	                ts.addEmitHelper(updated, exportStarHelper);
	            }
	            ts.addEmitHelpers(updated, context.readEmitHelpers());
	            return updated;
	        }
	        /**
	         * Transforms a SourceFile into an AMD module.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformAMDModule(node) {
	            var define = ts.createIdentifier("define");
	            var moduleName = ts.tryGetModuleNameFromFile(node, host, compilerOptions);
	            // An AMD define function has the following shape:
	            //
	            //     define(id?, dependencies?, factory);
	            //
	            // This has the shape of the following:
	            //
	            //     define(name, ["module1", "module2"], function (module1Alias) { ... }
	            //
	            // The location of the alias in the parameter list in the factory function needs to
	            // match the position of the module name in the dependency list.
	            //
	            // To ensure this is true in cases of modules with no aliases, e.g.:
	            //
	            //     import "module"
	            //
	            // or
	            //
	            //     /// <amd-dependency path= "a.css" />
	            //
	            // we need to add modules without alias names to the end of the dependencies list
	            var _a = collectAsynchronousDependencies(node, /*includeNonAmdDependencies*/ true), aliasedModuleNames = _a.aliasedModuleNames, unaliasedModuleNames = _a.unaliasedModuleNames, importAliasNames = _a.importAliasNames;
	            // Create an updated SourceFile:
	            //
	            //     define(moduleName?, ["module1", "module2"], function ...
	            var updated = ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray([
	                ts.createStatement(ts.createCall(define, 
	                /*typeArguments*/ undefined, (moduleName ? [moduleName] : []).concat([
	                    // Add the dependency array argument:
	                    //
	                    //     ["require", "exports", module1", "module2", ...]
	                    ts.createArrayLiteral([
	                        ts.createLiteral("require"),
	                        ts.createLiteral("exports")
	                    ].concat(aliasedModuleNames, unaliasedModuleNames)),
	                    // Add the module body function argument:
	                    //
	                    //     function (require, exports, module1, module2) ...
	                    ts.createFunctionExpression(
	                    /*modifiers*/ undefined, 
	                    /*asteriskToken*/ undefined, 
	                    /*name*/ undefined, 
	                    /*typeParameters*/ undefined, [
	                        ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "require"),
	                        ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "exports")
	                    ].concat(importAliasNames), 
	                    /*type*/ undefined, transformAsynchronousModuleBody(node))
	                ])))
	            ]), 
	            /*location*/ node.statements));
	            ts.addEmitHelpers(updated, context.readEmitHelpers());
	            return updated;
	        }
	        /**
	         * Transforms a SourceFile into a UMD module.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformUMDModule(node) {
	            var _a = collectAsynchronousDependencies(node, /*includeNonAmdDependencies*/ false), aliasedModuleNames = _a.aliasedModuleNames, unaliasedModuleNames = _a.unaliasedModuleNames, importAliasNames = _a.importAliasNames;
	            var moduleName = ts.tryGetModuleNameFromFile(node, host, compilerOptions);
	            var umdHeader = ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "factory")], 
	            /*type*/ undefined, ts.setTextRange(ts.createBlock([
	                ts.createIf(ts.createLogicalAnd(ts.createTypeCheck(ts.createIdentifier("module"), "object"), ts.createTypeCheck(ts.createPropertyAccess(ts.createIdentifier("module"), "exports"), "object")), ts.createBlock([
	                    ts.createVariableStatement(
	                    /*modifiers*/ undefined, [
	                        ts.createVariableDeclaration("v", 
	                        /*type*/ undefined, ts.createCall(ts.createIdentifier("factory"), 
	                        /*typeArguments*/ undefined, [
	                            ts.createIdentifier("require"),
	                            ts.createIdentifier("exports")
	                        ]))
	                    ]),
	                    ts.setEmitFlags(ts.createIf(ts.createStrictInequality(ts.createIdentifier("v"), ts.createIdentifier("undefined")), ts.createStatement(ts.createAssignment(ts.createPropertyAccess(ts.createIdentifier("module"), "exports"), ts.createIdentifier("v")))), 1 /* SingleLine */)
	                ]), ts.createIf(ts.createLogicalAnd(ts.createTypeCheck(ts.createIdentifier("define"), "function"), ts.createPropertyAccess(ts.createIdentifier("define"), "amd")), ts.createBlock([
	                    ts.createStatement(ts.createCall(ts.createIdentifier("define"), 
	                    /*typeArguments*/ undefined, (moduleName ? [moduleName] : []).concat([
	                        ts.createArrayLiteral([
	                            ts.createLiteral("require"),
	                            ts.createLiteral("exports")
	                        ].concat(aliasedModuleNames, unaliasedModuleNames)),
	                        ts.createIdentifier("factory")
	                    ])))
	                ])))
	            ], 
	            /*multiLine*/ true), 
	            /*location*/ undefined));
	            // Create an updated SourceFile:
	            //
	            //  (function (factory) {
	            //      if (typeof module === "object" && typeof module.exports === "object") {
	            //          var v = factory(require, exports);
	            //          if (v !== undefined) module.exports = v;
	            //      }
	            //      else if (typeof define === 'function' && define.amd) {
	            //          define(["require", "exports"], factory);
	            //      }
	            //  })(function ...)
	            var updated = ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray([
	                ts.createStatement(ts.createCall(umdHeader, 
	                /*typeArguments*/ undefined, [
	                    // Add the module body function argument:
	                    //
	                    //     function (require, exports) ...
	                    ts.createFunctionExpression(
	                    /*modifiers*/ undefined, 
	                    /*asteriskToken*/ undefined, 
	                    /*name*/ undefined, 
	                    /*typeParameters*/ undefined, [
	                        ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "require"),
	                        ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "exports")
	                    ].concat(importAliasNames), 
	                    /*type*/ undefined, transformAsynchronousModuleBody(node))
	                ]))
	            ]), 
	            /*location*/ node.statements));
	            ts.addEmitHelpers(updated, context.readEmitHelpers());
	            return updated;
	        }
	        /**
	         * Collect the additional asynchronous dependencies for the module.
	         *
	         * @param node The source file.
	         * @param includeNonAmdDependencies A value indicating whether to include non-AMD dependencies.
	         */
	        function collectAsynchronousDependencies(node, includeNonAmdDependencies) {
	            // names of modules with corresponding parameter in the factory function
	            var aliasedModuleNames = [];
	            // names of modules with no corresponding parameters in factory function
	            var unaliasedModuleNames = [];
	            // names of the parameters in the factory function; these
	            // parameters need to match the indexes of the corresponding
	            // module names in aliasedModuleNames.
	            var importAliasNames = [];
	            // Fill in amd-dependency tags
	            for (var _i = 0, _a = node.amdDependencies; _i < _a.length; _i++) {
	                var amdDependency = _a[_i];
	                if (amdDependency.name) {
	                    aliasedModuleNames.push(ts.createLiteral(amdDependency.path));
	                    importAliasNames.push(ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, amdDependency.name));
	                }
	                else {
	                    unaliasedModuleNames.push(ts.createLiteral(amdDependency.path));
	                }
	            }
	            for (var _b = 0, _c = currentModuleInfo.externalImports; _b < _c.length; _b++) {
	                var importNode = _c[_b];
	                // Find the name of the external module
	                var externalModuleName = ts.getExternalModuleNameLiteral(importNode, currentSourceFile, host, resolver, compilerOptions);
	                // Find the name of the module alias, if there is one
	                var importAliasName = ts.getLocalNameForExternalImport(importNode, currentSourceFile);
	                // It is possible that externalModuleName is undefined if it is not string literal.
	                // This can happen in the invalid import syntax.
	                // E.g : "import * from alias from 'someLib';"
	                if (externalModuleName) {
	                    if (includeNonAmdDependencies && importAliasName) {
	                        // Set emitFlags on the name of the classDeclaration
	                        // This is so that when printer will not substitute the identifier
	                        ts.setEmitFlags(importAliasName, 4 /* NoSubstitution */);
	                        aliasedModuleNames.push(externalModuleName);
	                        importAliasNames.push(ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, importAliasName));
	                    }
	                    else {
	                        unaliasedModuleNames.push(externalModuleName);
	                    }
	                }
	            }
	            return { aliasedModuleNames: aliasedModuleNames, unaliasedModuleNames: unaliasedModuleNames, importAliasNames: importAliasNames };
	        }
	        function getAMDImportExpressionForImport(node) {
	            if (ts.isImportEqualsDeclaration(node) || ts.isExportDeclaration(node) || !ts.getExternalModuleNameLiteral(node, currentSourceFile, host, resolver, compilerOptions)) {
	                return undefined;
	            }
	            var name = ts.getLocalNameForExternalImport(node, currentSourceFile);
	            var expr = getHelperExpressionForImport(node, name);
	            if (expr === name) {
	                return undefined;
	            }
	            return ts.createStatement(ts.createAssignment(name, expr));
	        }
	        /**
	         * Transforms a SourceFile into an AMD or UMD module body.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformAsynchronousModuleBody(node) {
	            startLexicalEnvironment();
	            var statements = [];
	            var statementOffset = ts.addPrologue(statements, node.statements, /*ensureUseStrict*/ !compilerOptions.noImplicitUseStrict, sourceElementVisitor);
	            if (shouldEmitUnderscoreUnderscoreESModule()) {
	                ts.append(statements, createUnderscoreUnderscoreESModule());
	            }
	            // Visit each statement of the module body.
	            ts.append(statements, ts.visitNode(currentModuleInfo.externalHelpersImportDeclaration, sourceElementVisitor, ts.isStatement));
	            if (moduleKind === ts.ModuleKind.AMD) {
	                ts.addRange(statements, ts.mapDefined(currentModuleInfo.externalImports, getAMDImportExpressionForImport));
	            }
	            ts.addRange(statements, ts.visitNodes(node.statements, sourceElementVisitor, ts.isStatement, statementOffset));
	            // Append the 'export =' statement if provided.
	            addExportEqualsIfNeeded(statements, /*emitAsReturn*/ true);
	            // End the lexical environment for the module body
	            // and merge any new lexical declarations.
	            ts.addRange(statements, endLexicalEnvironment());
	            var body = ts.createBlock(statements, /*multiLine*/ true);
	            if (currentModuleInfo.hasExportStarsToExportValues && !compilerOptions.importHelpers) {
	                // If we have any `export * from ...` declarations
	                // we need to inform the emitter to add the __export helper.
	                ts.addEmitHelper(body, exportStarHelper);
	            }
	            if (needUMDDynamicImportHelper) {
	                ts.addEmitHelper(body, dynamicImportUMDHelper);
	            }
	            return body;
	        }
	        /**
	         * Adds the down-level representation of `export=` to the statement list if one exists
	         * in the source file.
	         *
	         * @param statements The Statement list to modify.
	         * @param emitAsReturn A value indicating whether to emit the `export=` statement as a
	         * return statement.
	         */
	        function addExportEqualsIfNeeded(statements, emitAsReturn) {
	            if (currentModuleInfo.exportEquals) {
	                var expressionResult = ts.visitNode(currentModuleInfo.exportEquals.expression, importCallExpressionVisitor);
	                if (expressionResult) {
	                    if (emitAsReturn) {
	                        var statement = ts.createReturn(expressionResult);
	                        ts.setTextRange(statement, currentModuleInfo.exportEquals);
	                        ts.setEmitFlags(statement, 384 /* NoTokenSourceMaps */ | 1536 /* NoComments */);
	                        statements.push(statement);
	                    }
	                    else {
	                        var statement = ts.createStatement(ts.createAssignment(ts.createPropertyAccess(ts.createIdentifier("module"), "exports"), expressionResult));
	                        ts.setTextRange(statement, currentModuleInfo.exportEquals);
	                        ts.setEmitFlags(statement, 1536 /* NoComments */);
	                        statements.push(statement);
	                    }
	                }
	            }
	        }
	        //
	        // Top-Level Source Element Visitors
	        //
	        /**
	         * Visits a node at the top level of the source file.
	         *
	         * @param node The node to visit.
	         */
	        function sourceElementVisitor(node) {
	            switch (node.kind) {
	                case 242 /* ImportDeclaration */:
	                    return visitImportDeclaration(node);
	                case 241 /* ImportEqualsDeclaration */:
	                    return visitImportEqualsDeclaration(node);
	                case 248 /* ExportDeclaration */:
	                    return visitExportDeclaration(node);
	                case 247 /* ExportAssignment */:
	                    return visitExportAssignment(node);
	                case 212 /* VariableStatement */:
	                    return visitVariableStatement(node);
	                case 232 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 233 /* ClassDeclaration */:
	                    return visitClassDeclaration(node);
	                case 297 /* MergeDeclarationMarker */:
	                    return visitMergeDeclarationMarker(node);
	                case 298 /* EndOfDeclarationMarker */:
	                    return visitEndOfDeclarationMarker(node);
	                default:
	                    return ts.visitEachChild(node, importCallExpressionVisitor, context);
	            }
	        }
	        function importCallExpressionVisitor(node) {
	            // This visitor does not need to descend into the tree if there is no dynamic import,
	            // as export/import statements are only transformed at the top level of a file.
	            if (!(node.transformFlags & 67108864 /* ContainsDynamicImport */)) {
	                return node;
	            }
	            if (ts.isImportCall(node)) {
	                return visitImportCallExpression(node);
	            }
	            else {
	                return ts.visitEachChild(node, importCallExpressionVisitor, context);
	            }
	        }
	        function visitImportCallExpression(node) {
	            var argument = ts.visitNode(ts.firstOrUndefined(node.arguments), importCallExpressionVisitor);
	            var containsLexicalThis = !!(node.transformFlags & 16384 /* ContainsLexicalThis */);
	            switch (compilerOptions.module) {
	                case ts.ModuleKind.AMD:
	                    return createImportCallExpressionAMD(argument, containsLexicalThis);
	                case ts.ModuleKind.UMD:
	                    return createImportCallExpressionUMD(argument, containsLexicalThis);
	                case ts.ModuleKind.CommonJS:
	                default:
	                    return createImportCallExpressionCommonJS(argument, containsLexicalThis);
	            }
	        }
	        function createImportCallExpressionUMD(arg, containsLexicalThis) {
	            // (function (factory) {
	            //      ... (regular UMD)
	            // }
	            // })(function (require, exports, useSyncRequire) {
	            //      "use strict";
	            //      Object.defineProperty(exports, "__esModule", { value: true });
	            //      var __syncRequire = typeof module === "object" && typeof module.exports === "object";
	            //      var __resolved = new Promise(function (resolve) { resolve(); });
	            //      .....
	            //      __syncRequire
	            //          ? __resolved.then(function () { return require(x); }) /*CommonJs Require*/
	            //          : new Promise(function (_a, _b) { require([x], _a, _b); }); /*Amd Require*/
	            // });
	            needUMDDynamicImportHelper = true;
	            if (ts.isSimpleCopiableExpression(arg)) {
	                var argClone = ts.isGeneratedIdentifier(arg) ? arg : ts.isStringLiteral(arg) ? ts.createLiteral(arg) : ts.setEmitFlags(ts.setTextRange(ts.getSynthesizedClone(arg), arg), 1536 /* NoComments */);
	                return ts.createConditional(
	                /*condition*/ ts.createIdentifier("__syncRequire"), 
	                /*whenTrue*/ createImportCallExpressionCommonJS(arg, containsLexicalThis), 
	                /*whenFalse*/ createImportCallExpressionAMD(argClone, containsLexicalThis));
	            }
	            else {
	                var temp = ts.createTempVariable(hoistVariableDeclaration);
	                return ts.createComma(ts.createAssignment(temp, arg), ts.createConditional(
	                /*condition*/ ts.createIdentifier("__syncRequire"), 
	                /*whenTrue*/ createImportCallExpressionCommonJS(temp, containsLexicalThis), 
	                /*whenFalse*/ createImportCallExpressionAMD(temp, containsLexicalThis)));
	            }
	        }
	        function createImportCallExpressionAMD(arg, containsLexicalThis) {
	            // improt("./blah")
	            // emit as
	            // define(["require", "exports", "blah"], function (require, exports) {
	            //     ...
	            //     new Promise(function (_a, _b) { require([x], _a, _b); }); /*Amd Require*/
	            // });
	            var resolve = ts.createUniqueName("resolve");
	            var reject = ts.createUniqueName("reject");
	            var parameters = [
	                ts.createParameter(/*decorator*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, /*name*/ resolve),
	                ts.createParameter(/*decorator*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, /*name*/ reject)
	            ];
	            var body = ts.createBlock([
	                ts.createStatement(ts.createCall(ts.createIdentifier("require"), 
	                /*typeArguments*/ undefined, [ts.createArrayLiteral([arg || ts.createOmittedExpression()]), resolve, reject]))
	            ]);
	            var func;
	            if (languageVersion >= 2 /* ES2015 */) {
	                func = ts.createArrowFunction(
	                /*modifiers*/ undefined, 
	                /*typeParameters*/ undefined, parameters, 
	                /*type*/ undefined, 
	                /*equalsGreaterThanToken*/ undefined, body);
	            }
	            else {
	                func = ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, parameters, 
	                /*type*/ undefined, body);
	                // if there is a lexical 'this' in the import call arguments, ensure we indicate
	                // that this new function expression indicates it captures 'this' so that the
	                // es2015 transformer will properly substitute 'this' with '_this'.
	                if (containsLexicalThis) {
	                    ts.setEmitFlags(func, 8 /* CapturesThis */);
	                }
	            }
	            var promise = ts.createNew(ts.createIdentifier("Promise"), /*typeArguments*/ undefined, [func]);
	            if (compilerOptions.esModuleInterop) {
	                context.requestEmitHelper(importStarHelper);
	                return ts.createCall(ts.createPropertyAccess(promise, ts.createIdentifier("then")), /*typeArguments*/ undefined, [ts.getHelperName("__importStar")]);
	            }
	            return promise;
	        }
	        function createImportCallExpressionCommonJS(arg, containsLexicalThis) {
	            // import("./blah")
	            // emit as
	            // Promise.resolve().then(function () { return require(x); }) /*CommonJs Require*/
	            // We have to wrap require in then callback so that require is done in asynchronously
	            // if we simply do require in resolve callback in Promise constructor. We will execute the loading immediately
	            var promiseResolveCall = ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Promise"), "resolve"), /*typeArguments*/ undefined, /*argumentsArray*/ []);
	            var requireCall = ts.createCall(ts.createIdentifier("require"), /*typeArguments*/ undefined, arg ? [arg] : []);
	            if (compilerOptions.esModuleInterop) {
	                context.requestEmitHelper(importStarHelper);
	                requireCall = ts.createCall(ts.getHelperName("__importStar"), /*typeArguments*/ undefined, [requireCall]);
	            }
	            var func;
	            if (languageVersion >= 2 /* ES2015 */) {
	                func = ts.createArrowFunction(
	                /*modifiers*/ undefined, 
	                /*typeParameters*/ undefined, 
	                /*parameters*/ [], 
	                /*type*/ undefined, 
	                /*equalsGreaterThanToken*/ undefined, requireCall);
	            }
	            else {
	                func = ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, 
	                /*parameters*/ [], 
	                /*type*/ undefined, ts.createBlock([ts.createReturn(requireCall)]));
	                // if there is a lexical 'this' in the import call arguments, ensure we indicate
	                // that this new function expression indicates it captures 'this' so that the
	                // es2015 transformer will properly substitute 'this' with '_this'.
	                if (containsLexicalThis) {
	                    ts.setEmitFlags(func, 8 /* CapturesThis */);
	                }
	            }
	            return ts.createCall(ts.createPropertyAccess(promiseResolveCall, "then"), /*typeArguments*/ undefined, [func]);
	        }
	        function getHelperExpressionForImport(node, innerExpr) {
	            if (!compilerOptions.esModuleInterop || ts.getEmitFlags(node) & 67108864 /* NeverApplyImportHelper */) {
	                return innerExpr;
	            }
	            if (ts.getImportNeedsImportStarHelper(node)) {
	                context.requestEmitHelper(importStarHelper);
	                return ts.createCall(ts.getHelperName("__importStar"), /*typeArguments*/ undefined, [innerExpr]);
	            }
	            if (ts.getImportNeedsImportDefaultHelper(node)) {
	                context.requestEmitHelper(importDefaultHelper);
	                return ts.createCall(ts.getHelperName("__importDefault"), /*typeArguments*/ undefined, [innerExpr]);
	            }
	            return innerExpr;
	        }
	        /**
	         * Visits an ImportDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitImportDeclaration(node) {
	            var statements;
	            var namespaceDeclaration = ts.getNamespaceDeclarationNode(node);
	            if (moduleKind !== ts.ModuleKind.AMD) {
	                if (!node.importClause) {
	                    // import "mod";
	                    return ts.setTextRange(ts.createStatement(createRequireCall(node)), node);
	                }
	                else {
	                    var variables = [];
	                    if (namespaceDeclaration && !ts.isDefaultImport(node)) {
	                        // import * as n from "mod";
	                        variables.push(ts.createVariableDeclaration(ts.getSynthesizedClone(namespaceDeclaration.name), 
	                        /*type*/ undefined, getHelperExpressionForImport(node, createRequireCall(node))));
	                    }
	                    else {
	                        // import d from "mod";
	                        // import { x, y } from "mod";
	                        // import d, { x, y } from "mod";
	                        // import d, * as n from "mod";
	                        variables.push(ts.createVariableDeclaration(ts.getGeneratedNameForNode(node), 
	                        /*type*/ undefined, getHelperExpressionForImport(node, createRequireCall(node))));
	                        if (namespaceDeclaration && ts.isDefaultImport(node)) {
	                            variables.push(ts.createVariableDeclaration(ts.getSynthesizedClone(namespaceDeclaration.name), 
	                            /*type*/ undefined, ts.getGeneratedNameForNode(node)));
	                        }
	                    }
	                    statements = ts.append(statements, ts.setTextRange(ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.createVariableDeclarationList(variables, languageVersion >= 2 /* ES2015 */ ? 2 /* Const */ : 0 /* None */)), 
	                    /*location*/ node));
	                }
	            }
	            else if (namespaceDeclaration && ts.isDefaultImport(node)) {
	                // import d, * as n from "mod";
	                statements = ts.append(statements, ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                    ts.setTextRange(ts.createVariableDeclaration(ts.getSynthesizedClone(namespaceDeclaration.name), 
	                    /*type*/ undefined, ts.getGeneratedNameForNode(node)), 
	                    /*location*/ node)
	                ], languageVersion >= 2 /* ES2015 */ ? 2 /* Const */ : 0 /* None */)));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfImportDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfImportDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Creates a `require()` call to import an external module.
	         *
	         * @param importNode The declararation to import.
	         */
	        function createRequireCall(importNode) {
	            var moduleName = ts.getExternalModuleNameLiteral(importNode, currentSourceFile, host, resolver, compilerOptions);
	            var args = [];
	            if (moduleName) {
	                args.push(moduleName);
	            }
	            return ts.createCall(ts.createIdentifier("require"), /*typeArguments*/ undefined, args);
	        }
	        /**
	         * Visits an ImportEqualsDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitImportEqualsDeclaration(node) {
	            ts.Debug.assert(ts.isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
	            var statements;
	            if (moduleKind !== ts.ModuleKind.AMD) {
	                if (ts.hasModifier(node, 1 /* Export */)) {
	                    statements = ts.append(statements, ts.setTextRange(ts.createStatement(createExportExpression(node.name, createRequireCall(node))), node));
	                }
	                else {
	                    statements = ts.append(statements, ts.setTextRange(ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                        ts.createVariableDeclaration(ts.getSynthesizedClone(node.name), 
	                        /*type*/ undefined, createRequireCall(node))
	                    ], 
	                    /*flags*/ languageVersion >= 2 /* ES2015 */ ? 2 /* Const */ : 0 /* None */)), node));
	                }
	            }
	            else {
	                if (ts.hasModifier(node, 1 /* Export */)) {
	                    statements = ts.append(statements, ts.setTextRange(ts.createStatement(createExportExpression(ts.getExportName(node), ts.getLocalName(node))), node));
	                }
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfImportEqualsDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfImportEqualsDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits an ExportDeclaration node.
	         *
	         * @param The node to visit.
	         */
	        function visitExportDeclaration(node) {
	            if (!node.moduleSpecifier) {
	                // Elide export declarations with no module specifier as they are handled
	                // elsewhere.
	                return undefined;
	            }
	            var generatedName = ts.getGeneratedNameForNode(node);
	            if (node.exportClause) {
	                var statements = [];
	                // export { x, y } from "mod";
	                if (moduleKind !== ts.ModuleKind.AMD) {
	                    statements.push(ts.setTextRange(ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                        ts.createVariableDeclaration(generatedName, 
	                        /*type*/ undefined, createRequireCall(node))
	                    ])), 
	                    /*location*/ node));
	                }
	                for (var _i = 0, _a = node.exportClause.elements; _i < _a.length; _i++) {
	                    var specifier = _a[_i];
	                    var exportedValue = ts.createPropertyAccess(generatedName, specifier.propertyName || specifier.name);
	                    statements.push(ts.setTextRange(ts.createStatement(createExportExpression(ts.getExportName(specifier), exportedValue)), specifier));
	                }
	                return ts.singleOrMany(statements);
	            }
	            else {
	                // export * from "mod";
	                return ts.setTextRange(ts.createStatement(createExportStarHelper(context, moduleKind !== ts.ModuleKind.AMD ? createRequireCall(node) : generatedName)), node);
	            }
	        }
	        /**
	         * Visits an ExportAssignment node.
	         *
	         * @param node The node to visit.
	         */
	        function visitExportAssignment(node) {
	            if (node.isExportEquals) {
	                return undefined;
	            }
	            var statements;
	            var original = node.original;
	            if (original && hasAssociatedEndOfDeclarationMarker(original)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportStatement(deferredExports[id], ts.createIdentifier("default"), ts.visitNode(node.expression, importCallExpressionVisitor), /*location*/ node, /*allowComments*/ true);
	            }
	            else {
	                statements = appendExportStatement(statements, ts.createIdentifier("default"), ts.visitNode(node.expression, importCallExpressionVisitor), /*location*/ node, /*allowComments*/ true);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a FunctionDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionDeclaration(node) {
	            var statements;
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                statements = ts.append(statements, ts.setOriginalNode(ts.setTextRange(ts.createFunctionDeclaration(
	                /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, ts.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), 
	                /*typeParameters*/ undefined, ts.visitNodes(node.parameters, importCallExpressionVisitor), 
	                /*type*/ undefined, ts.visitEachChild(node.body, importCallExpressionVisitor, context)), 
	                /*location*/ node), 
	                /*original*/ node));
	            }
	            else {
	                statements = ts.append(statements, ts.visitEachChild(node, importCallExpressionVisitor, context));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfHoistedDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfHoistedDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a ClassDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitClassDeclaration(node) {
	            var statements;
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                statements = ts.append(statements, ts.setOriginalNode(ts.setTextRange(ts.createClassDeclaration(
	                /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), ts.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), 
	                /*typeParameters*/ undefined, ts.visitNodes(node.heritageClauses, importCallExpressionVisitor), ts.visitNodes(node.members, importCallExpressionVisitor)), node), node));
	            }
	            else {
	                statements = ts.append(statements, ts.visitEachChild(node, importCallExpressionVisitor, context));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfHoistedDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfHoistedDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a VariableStatement node.
	         *
	         * @param node The node to visit.
	         */
	        function visitVariableStatement(node) {
	            var statements;
	            var variables;
	            var expressions;
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                var modifiers = void 0;
	                // If we're exporting these variables, then these just become assignments to 'exports.x'.
	                // We only want to emit assignments for variables with initializers.
	                for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    if (ts.isIdentifier(variable.name) && ts.isLocalName(variable.name)) {
	                        if (!modifiers) {
	                            modifiers = ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier);
	                        }
	                        variables = ts.append(variables, variable);
	                    }
	                    else if (variable.initializer) {
	                        expressions = ts.append(expressions, transformInitializedVariable(variable));
	                    }
	                }
	                if (variables) {
	                    statements = ts.append(statements, ts.updateVariableStatement(node, modifiers, ts.updateVariableDeclarationList(node.declarationList, variables)));
	                }
	                if (expressions) {
	                    statements = ts.append(statements, ts.setTextRange(ts.createStatement(ts.inlineExpressions(expressions)), node));
	                }
	            }
	            else {
	                statements = ts.append(statements, ts.visitEachChild(node, importCallExpressionVisitor, context));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfVariableStatement(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfVariableStatement(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Transforms an exported variable with an initializer into an expression.
	         *
	         * @param node The node to transform.
	         */
	        function transformInitializedVariable(node) {
	            if (ts.isBindingPattern(node.name)) {
	                return ts.flattenDestructuringAssignment(ts.visitNode(node, importCallExpressionVisitor), 
	                /*visitor*/ undefined, context, 0 /* All */, 
	                /*needsValue*/ false, createExportExpression);
	            }
	            else {
	                return ts.createAssignment(ts.setTextRange(ts.createPropertyAccess(ts.createIdentifier("exports"), node.name), 
	                /*location*/ node.name), ts.visitNode(node.initializer, importCallExpressionVisitor));
	            }
	        }
	        /**
	         * Visits a MergeDeclarationMarker used as a placeholder for the beginning of a merged
	         * and transformed declaration.
	         *
	         * @param node The node to visit.
	         */
	        function visitMergeDeclarationMarker(node) {
	            // For an EnumDeclaration or ModuleDeclaration that merges with a preceeding
	            // declaration we do not emit a leading variable declaration. To preserve the
	            // begin/end semantics of the declararation and to properly handle exports
	            // we wrapped the leading variable declaration in a `MergeDeclarationMarker`.
	            //
	            // To balance the declaration, add the exports of the elided variable
	            // statement.
	            if (hasAssociatedEndOfDeclarationMarker(node) && node.original.kind === 212 /* VariableStatement */) {
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfVariableStatement(deferredExports[id], node.original);
	            }
	            return node;
	        }
	        /**
	         * Determines whether a node has an associated EndOfDeclarationMarker.
	         *
	         * @param node The node to test.
	         */
	        function hasAssociatedEndOfDeclarationMarker(node) {
	            return (ts.getEmitFlags(node) & 4194304 /* HasEndOfDeclarationMarker */) !== 0;
	        }
	        /**
	         * Visits a DeclarationMarker used as a placeholder for the end of a transformed
	         * declaration.
	         *
	         * @param node The node to visit.
	         */
	        function visitEndOfDeclarationMarker(node) {
	            // For some transformations we emit an `EndOfDeclarationMarker` to mark the actual
	            // end of the transformed declaration. We use this marker to emit any deferred exports
	            // of the declaration.
	            var id = ts.getOriginalNodeId(node);
	            var statements = deferredExports[id];
	            if (statements) {
	                delete deferredExports[id];
	                return ts.append(statements, node);
	            }
	            return node;
	        }
	        /**
	         * Appends the exports of an ImportDeclaration to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfImportDeclaration(statements, decl) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            var importClause = decl.importClause;
	            if (!importClause) {
	                return statements;
	            }
	            if (importClause.name) {
	                statements = appendExportsOfDeclaration(statements, importClause);
	            }
	            var namedBindings = importClause.namedBindings;
	            if (namedBindings) {
	                switch (namedBindings.kind) {
	                    case 244 /* NamespaceImport */:
	                        statements = appendExportsOfDeclaration(statements, namedBindings);
	                        break;
	                    case 245 /* NamedImports */:
	                        for (var _i = 0, _a = namedBindings.elements; _i < _a.length; _i++) {
	                            var importBinding = _a[_i];
	                            statements = appendExportsOfDeclaration(statements, importBinding);
	                        }
	                        break;
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of an ImportEqualsDeclaration to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfImportEqualsDeclaration(statements, decl) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            return appendExportsOfDeclaration(statements, decl);
	        }
	        /**
	         * Appends the exports of a VariableStatement to a statement list, returning the statement
	         * list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param node The VariableStatement whose exports are to be recorded.
	         */
	        function appendExportsOfVariableStatement(statements, node) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                var decl = _a[_i];
	                statements = appendExportsOfBindingElement(statements, decl);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a VariableDeclaration or BindingElement to a statement list,
	         * returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfBindingElement(statements, decl) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            if (ts.isBindingPattern(decl.name)) {
	                for (var _i = 0, _a = decl.name.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        statements = appendExportsOfBindingElement(statements, element);
	                    }
	                }
	            }
	            else if (!ts.isGeneratedIdentifier(decl.name)) {
	                statements = appendExportsOfDeclaration(statements, decl);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a ClassDeclaration or FunctionDeclaration to a statement list,
	         * returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfHoistedDeclaration(statements, decl) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            if (ts.hasModifier(decl, 1 /* Export */)) {
	                var exportName = ts.hasModifier(decl, 512 /* Default */) ? ts.createIdentifier("default") : ts.getDeclarationName(decl);
	                statements = appendExportStatement(statements, exportName, ts.getLocalName(decl), /*location*/ decl);
	            }
	            if (decl.name) {
	                statements = appendExportsOfDeclaration(statements, decl);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a declaration to a statement list, returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration to export.
	         */
	        function appendExportsOfDeclaration(statements, decl) {
	            var name = ts.getDeclarationName(decl);
	            var exportSpecifiers = currentModuleInfo.exportSpecifiers.get(ts.idText(name));
	            if (exportSpecifiers) {
	                for (var _i = 0, exportSpecifiers_1 = exportSpecifiers; _i < exportSpecifiers_1.length; _i++) {
	                    var exportSpecifier = exportSpecifiers_1[_i];
	                    statements = appendExportStatement(statements, exportSpecifier.name, name, /*location*/ exportSpecifier.name);
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the down-level representation of an export to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param exportName The name of the export.
	         * @param expression The expression to export.
	         * @param location The location to use for source maps and comments for the export.
	         * @param allowComments Whether to allow comments on the export.
	         */
	        function appendExportStatement(statements, exportName, expression, location, allowComments) {
	            statements = ts.append(statements, createExportStatement(exportName, expression, location, allowComments));
	            return statements;
	        }
	        function createUnderscoreUnderscoreESModule() {
	            var statement;
	            if (languageVersion === 0 /* ES3 */) {
	                statement = ts.createStatement(createExportExpression(ts.createIdentifier("__esModule"), ts.createLiteral(/*value*/ true)));
	            }
	            else {
	                statement = ts.createStatement(ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Object"), "defineProperty"), 
	                /*typeArguments*/ undefined, [
	                    ts.createIdentifier("exports"),
	                    ts.createLiteral("__esModule"),
	                    ts.createObjectLiteral([
	                        ts.createPropertyAssignment("value", ts.createLiteral(/*value*/ true))
	                    ])
	                ]));
	            }
	            ts.setEmitFlags(statement, 1048576 /* CustomPrologue */);
	            return statement;
	        }
	        /**
	         * Creates a call to the current file's export function to export a value.
	         *
	         * @param name The bound name of the export.
	         * @param value The exported value.
	         * @param location The location to use for source maps and comments for the export.
	         * @param allowComments An optional value indicating whether to emit comments for the statement.
	         */
	        function createExportStatement(name, value, location, allowComments) {
	            var statement = ts.setTextRange(ts.createStatement(createExportExpression(name, value)), location);
	            ts.startOnNewLine(statement);
	            if (!allowComments) {
	                ts.setEmitFlags(statement, 1536 /* NoComments */);
	            }
	            return statement;
	        }
	        /**
	         * Creates a call to the current file's export function to export a value.
	         *
	         * @param name The bound name of the export.
	         * @param value The exported value.
	         * @param location The location to use for source maps and comments for the export.
	         */
	        function createExportExpression(name, value, location) {
	            return ts.setTextRange(ts.createAssignment(ts.createPropertyAccess(ts.createIdentifier("exports"), ts.getSynthesizedClone(name)), value), location);
	        }
	        //
	        // Modifier Visitors
	        //
	        /**
	         * Visit nodes to elide module-specific modifiers.
	         *
	         * @param node The node to visit.
	         */
	        function modifierVisitor(node) {
	            // Elide module-specific modifiers.
	            switch (node.kind) {
	                case 84 /* ExportKeyword */:
	                case 79 /* DefaultKeyword */:
	                    return undefined;
	            }
	            return node;
	        }
	        //
	        // Emit Notification
	        //
	        /**
	         * Hook for node emit notifications.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emit A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            if (node.kind === 272 /* SourceFile */) {
	                currentSourceFile = node;
	                currentModuleInfo = moduleInfoMap[ts.getOriginalNodeId(currentSourceFile)];
	                noSubstitution = [];
	                previousOnEmitNode(hint, node, emitCallback);
	                currentSourceFile = undefined;
	                currentModuleInfo = undefined;
	                noSubstitution = undefined;
	            }
	            else {
	                previousOnEmitNode(hint, node, emitCallback);
	            }
	        }
	        //
	        // Substitutions
	        //
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (node.id && noSubstitution[node.id]) {
	                return node;
	            }
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            else if (ts.isShorthandPropertyAssignment(node)) {
	                return substituteShorthandPropertyAssignment(node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for a ShorthandPropertyAssignment whose declaration name is an imported
	         * or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteShorthandPropertyAssignment(node) {
	            var name = node.name;
	            var exportedOrImportedName = substituteExpressionIdentifier(name);
	            if (exportedOrImportedName !== name) {
	                // A shorthand property with an assignment initializer is probably part of a
	                // destructuring assignment
	                if (node.objectAssignmentInitializer) {
	                    var initializer = ts.createAssignment(exportedOrImportedName, node.objectAssignmentInitializer);
	                    return ts.setTextRange(ts.createPropertyAssignment(name, initializer), node);
	                }
	                return ts.setTextRange(ts.createPropertyAssignment(name, exportedOrImportedName), node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for an Expression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return substituteExpressionIdentifier(node);
	                case 198 /* BinaryExpression */:
	                    return substituteBinaryExpression(node);
	                case 197 /* PostfixUnaryExpression */:
	                case 196 /* PrefixUnaryExpression */:
	                    return substituteUnaryExpression(node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for an Identifier expression that may contain an imported or exported
	         * symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteExpressionIdentifier(node) {
	            if (ts.getEmitFlags(node) & 4096 /* HelperName */) {
	                var externalHelpersModuleName = ts.getExternalHelpersModuleName(currentSourceFile);
	                if (externalHelpersModuleName) {
	                    return ts.createPropertyAccess(externalHelpersModuleName, node);
	                }
	                return node;
	            }
	            if (!ts.isGeneratedIdentifier(node) && !ts.isLocalName(node)) {
	                var exportContainer = resolver.getReferencedExportContainer(node, ts.isExportName(node));
	                if (exportContainer && exportContainer.kind === 272 /* SourceFile */) {
	                    return ts.setTextRange(ts.createPropertyAccess(ts.createIdentifier("exports"), ts.getSynthesizedClone(node)), 
	                    /*location*/ node);
	                }
	                var importDeclaration = resolver.getReferencedImportDeclaration(node);
	                if (importDeclaration) {
	                    if (ts.isImportClause(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent), ts.createIdentifier("default")), 
	                        /*location*/ node);
	                    }
	                    else if (ts.isImportSpecifier(importDeclaration)) {
	                        var name = importDeclaration.propertyName || importDeclaration.name;
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent.parent.parent), ts.getSynthesizedClone(name)), 
	                        /*location*/ node);
	                    }
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitution for a BinaryExpression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteBinaryExpression(node) {
	            // When we see an assignment expression whose left-hand side is an exported symbol,
	            // we should ensure all exports of that symbol are updated with the correct value.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            // - We do not substitute identifiers that were originally the name of an enum or
	            //   namespace due to how they are transformed in TypeScript.
	            // - We only substitute identifiers that are exported at the top level.
	            if (ts.isAssignmentOperator(node.operatorToken.kind)
	                && ts.isIdentifier(node.left)
	                && !ts.isGeneratedIdentifier(node.left)
	                && !ts.isLocalName(node.left)
	                && !ts.isDeclarationNameOfEnumOrNamespace(node.left)) {
	                var exportedNames = getExports(node.left);
	                if (exportedNames) {
	                    // For each additional export of the declaration, apply an export assignment.
	                    var expression = node;
	                    for (var _i = 0, exportedNames_1 = exportedNames; _i < exportedNames_1.length; _i++) {
	                        var exportName = exportedNames_1[_i];
	                        // Mark the node to prevent triggering this rule again.
	                        noSubstitution[ts.getNodeId(expression)] = true;
	                        expression = createExportExpression(exportName, expression, /*location*/ node);
	                    }
	                    return expression;
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitution for a UnaryExpression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteUnaryExpression(node) {
	            // When we see a prefix or postfix increment expression whose operand is an exported
	            // symbol, we should ensure all exports of that symbol are updated with the correct
	            // value.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            // - We do not substitute identifiers that were originally the name of an enum or
	            //   namespace due to how they are transformed in TypeScript.
	            // - We only substitute identifiers that are exported at the top level.
	            if ((node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */)
	                && ts.isIdentifier(node.operand)
	                && !ts.isGeneratedIdentifier(node.operand)
	                && !ts.isLocalName(node.operand)
	                && !ts.isDeclarationNameOfEnumOrNamespace(node.operand)) {
	                var exportedNames = getExports(node.operand);
	                if (exportedNames) {
	                    var expression = node.kind === 197 /* PostfixUnaryExpression */
	                        ? ts.setTextRange(ts.createBinary(node.operand, ts.createToken(node.operator === 43 /* PlusPlusToken */ ? 59 /* PlusEqualsToken */ : 60 /* MinusEqualsToken */), ts.createLiteral(1)), 
	                        /*location*/ node)
	                        : node;
	                    for (var _i = 0, exportedNames_2 = exportedNames; _i < exportedNames_2.length; _i++) {
	                        var exportName = exportedNames_2[_i];
	                        // Mark the node to prevent triggering this rule again.
	                        noSubstitution[ts.getNodeId(expression)] = true;
	                        expression = createExportExpression(exportName, expression);
	                    }
	                    return expression;
	                }
	            }
	            return node;
	        }
	        /**
	         * Gets the additional exports of a name.
	         *
	         * @param name The name.
	         */
	        function getExports(name) {
	            if (!ts.isGeneratedIdentifier(name)) {
	                var valueDeclaration = resolver.getReferencedImportDeclaration(name)
	                    || resolver.getReferencedValueDeclaration(name);
	                if (valueDeclaration) {
	                    return currentModuleInfo
	                        && currentModuleInfo.exportedBindings[ts.getOriginalNodeId(valueDeclaration)];
	                }
	            }
	        }
	    }
	    ts.transformModule = transformModule;
	    // emit output for the __export helper function
	    var exportStarHelper = {
	        name: "typescript:export-star",
	        scoped: true,
	        text: "\n            function __export(m) {\n                for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];\n            }\n        "
	    };
	    function createExportStarHelper(context, module) {
	        var compilerOptions = context.getCompilerOptions();
	        return compilerOptions.importHelpers
	            ? ts.createCall(ts.getHelperName("__exportStar"), /*typeArguments*/ undefined, [module, ts.createIdentifier("exports")])
	            : ts.createCall(ts.createIdentifier("__export"), /*typeArguments*/ undefined, [module]);
	    }
	    // emit helper for dynamic import
	    var dynamicImportUMDHelper = {
	        name: "typescript:dynamicimport-sync-require",
	        scoped: true,
	        text: "\n            var __syncRequire = typeof module === \"object\" && typeof module.exports === \"object\";"
	    };
	    // emit helper for `import * as Name from "foo"`
	    var importStarHelper = {
	        name: "typescript:commonjsimportstar",
	        scoped: false,
	        text: "\nvar __importStar = (this && this.__importStar) || function (mod) {\n    if (mod && mod.__esModule) return mod;\n    var result = {};\n    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];\n    result[\"default\"] = mod;\n    return result;\n}"
	    };
	    // emit helper for `import Name from "foo"`
	    var importDefaultHelper = {
	        name: "typescript:commonjsimportdefault",
	        scoped: false,
	        text: "\nvar __importDefault = (this && this.__importDefault) || function (mod) {\n    return (mod && mod.__esModule) ? mod : { \"default\": mod };\n}"
	    };
	})(ts || (ts = {}));
	/// <reference path="../../factory.ts" />
	/// <reference path="../../visitor.ts" />
	/// <reference path="../destructuring.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformSystemModule(context) {
	        var startLexicalEnvironment = context.startLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var compilerOptions = context.getCompilerOptions();
	        var resolver = context.getEmitResolver();
	        var host = context.getEmitHost();
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        var previousOnEmitNode = context.onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        context.onEmitNode = onEmitNode;
	        context.enableSubstitution(71 /* Identifier */); // Substitutes expression identifiers for imported symbols.
	        context.enableSubstitution(269 /* ShorthandPropertyAssignment */); // Substitutes expression identifiers for imported symbols
	        context.enableSubstitution(198 /* BinaryExpression */); // Substitutes assignments to exported symbols.
	        context.enableSubstitution(196 /* PrefixUnaryExpression */); // Substitutes updates to exported symbols.
	        context.enableSubstitution(197 /* PostfixUnaryExpression */); // Substitutes updates to exported symbols.
	        context.enableEmitNotification(272 /* SourceFile */); // Restore state when substituting nodes in a file.
	        var moduleInfoMap = []; // The ExternalModuleInfo for each file.
	        var deferredExports = []; // Exports to defer until an EndOfDeclarationMarker is found.
	        var exportFunctionsMap = []; // The export function associated with a source file.
	        var noSubstitutionMap = []; // Set of nodes for which substitution rules should be ignored for each file.
	        var currentSourceFile; // The current file.
	        var moduleInfo; // ExternalModuleInfo for the current file.
	        var exportFunction; // The export function for the current file.
	        var contextObject; // The context object for the current file.
	        var hoistedStatements;
	        var enclosingBlockScopedContainer;
	        var noSubstitution; // Set of nodes for which substitution rules should be ignored.
	        return transformSourceFile;
	        /**
	         * Transforms the module aspects of a SourceFile.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile || !(ts.isEffectiveExternalModule(node, compilerOptions) || node.transformFlags & 67108864 /* ContainsDynamicImport */)) {
	                return node;
	            }
	            var id = ts.getOriginalNodeId(node);
	            currentSourceFile = node;
	            enclosingBlockScopedContainer = node;
	            // System modules have the following shape:
	            //
	            //     System.register(['dep-1', ... 'dep-n'], function(exports) {/* module body function */})
	            //
	            // The parameter 'exports' here is a callback '<T>(name: string, value: T) => T' that
	            // is used to publish exported values. 'exports' returns its 'value' argument so in
	            // most cases expressions that mutate exported values can be rewritten as:
	            //
	            //     expr -> exports('name', expr)
	            //
	            // The only exception in this rule is postfix unary operators,
	            // see comment to 'substitutePostfixUnaryExpression' for more details
	            // Collect information about the external module and dependency groups.
	            moduleInfo = moduleInfoMap[id] = ts.collectExternalModuleInfo(node, resolver, compilerOptions);
	            // Make sure that the name of the 'exports' function does not conflict with
	            // existing identifiers.
	            exportFunction = ts.createUniqueName("exports");
	            exportFunctionsMap[id] = exportFunction;
	            contextObject = ts.createUniqueName("context");
	            // Add the body of the module.
	            var dependencyGroups = collectDependencyGroups(moduleInfo.externalImports);
	            var moduleBodyBlock = createSystemModuleBody(node, dependencyGroups);
	            var moduleBodyFunction = ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [
	                ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, exportFunction),
	                ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, contextObject)
	            ], 
	            /*type*/ undefined, moduleBodyBlock);
	            // Write the call to `System.register`
	            // Clear the emit-helpers flag for later passes since we'll have already used it in the module body
	            // So the helper will be emit at the correct position instead of at the top of the source-file
	            var moduleName = ts.tryGetModuleNameFromFile(node, host, compilerOptions);
	            var dependencies = ts.createArrayLiteral(ts.map(dependencyGroups, function (dependencyGroup) { return dependencyGroup.name; }));
	            var updated = ts.setEmitFlags(ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray([
	                ts.createStatement(ts.createCall(ts.createPropertyAccess(ts.createIdentifier("System"), "register"), 
	                /*typeArguments*/ undefined, moduleName
	                    ? [moduleName, dependencies, moduleBodyFunction]
	                    : [dependencies, moduleBodyFunction]))
	            ]), node.statements)), 1024 /* NoTrailingComments */);
	            if (!(compilerOptions.outFile || compilerOptions.out)) {
	                ts.moveEmitHelpers(updated, moduleBodyBlock, function (helper) { return !helper.scoped; });
	            }
	            if (noSubstitution) {
	                noSubstitutionMap[id] = noSubstitution;
	                noSubstitution = undefined;
	            }
	            currentSourceFile = undefined;
	            moduleInfo = undefined;
	            exportFunction = undefined;
	            contextObject = undefined;
	            hoistedStatements = undefined;
	            enclosingBlockScopedContainer = undefined;
	            return ts.aggregateTransformFlags(updated);
	        }
	        /**
	         * Collects the dependency groups for this files imports.
	         *
	         * @param externalImports The imports for the file.
	         */
	        function collectDependencyGroups(externalImports) {
	            var groupIndices = ts.createMap();
	            var dependencyGroups = [];
	            for (var _i = 0, externalImports_1 = externalImports; _i < externalImports_1.length; _i++) {
	                var externalImport = externalImports_1[_i];
	                var externalModuleName = ts.getExternalModuleNameLiteral(externalImport, currentSourceFile, host, resolver, compilerOptions);
	                if (externalModuleName) {
	                    var text = externalModuleName.text;
	                    var groupIndex = groupIndices.get(text);
	                    if (groupIndex !== undefined) {
	                        // deduplicate/group entries in dependency list by the dependency name
	                        dependencyGroups[groupIndex].externalImports.push(externalImport);
	                    }
	                    else {
	                        groupIndices.set(text, dependencyGroups.length);
	                        dependencyGroups.push({
	                            name: externalModuleName,
	                            externalImports: [externalImport]
	                        });
	                    }
	                }
	            }
	            return dependencyGroups;
	        }
	        /**
	         * Adds the statements for the module body function for the source file.
	         *
	         * @param node The source file for the module.
	         * @param dependencyGroups The grouped dependencies of the module.
	         */
	        function createSystemModuleBody(node, dependencyGroups) {
	            // Shape of the body in system modules:
	            //
	            //  function (exports) {
	            //      <list of local aliases for imports>
	            //      <hoisted variable declarations>
	            //      <hoisted function declarations>
	            //      return {
	            //          setters: [
	            //              <list of setter function for imports>
	            //          ],
	            //          execute: function() {
	            //              <module statements>
	            //          }
	            //      }
	            //      <temp declarations>
	            //  }
	            //
	            // i.e:
	            //
	            //   import {x} from 'file1'
	            //   var y = 1;
	            //   export function foo() { return y + x(); }
	            //   console.log(y);
	            //
	            // Will be transformed to:
	            //
	            //  function(exports) {
	            //      function foo() { return y + file_1.x(); }
	            //      exports("foo", foo);
	            //      var file_1, y;
	            //      return {
	            //          setters: [
	            //              function(v) { file_1 = v }
	            //          ],
	            //          execute(): function() {
	            //              y = 1;
	            //              console.log(y);
	            //          }
	            //      };
	            //  }
	            var statements = [];
	            // We start a new lexical environment in this function body, but *not* in the
	            // body of the execute function. This allows us to emit temporary declarations
	            // only in the outer module body and not in the inner one.
	            startLexicalEnvironment();
	            // Add any prologue directives.
	            var ensureUseStrict = ts.getStrictOptionValue(compilerOptions, "alwaysStrict") || (!compilerOptions.noImplicitUseStrict && ts.isExternalModule(currentSourceFile));
	            var statementOffset = ts.addPrologue(statements, node.statements, ensureUseStrict, sourceElementVisitor);
	            // var __moduleName = context_1 && context_1.id;
	            statements.push(ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration("__moduleName", 
	                /*type*/ undefined, ts.createLogicalAnd(contextObject, ts.createPropertyAccess(contextObject, "id")))
	            ])));
	            // Visit the synthetic external helpers import declaration if present
	            ts.visitNode(moduleInfo.externalHelpersImportDeclaration, sourceElementVisitor, ts.isStatement);
	            // Visit the statements of the source file, emitting any transformations into
	            // the `executeStatements` array. We do this *before* we fill the `setters` array
	            // as we both emit transformations as well as aggregate some data used when creating
	            // setters. This allows us to reduce the number of times we need to loop through the
	            // statements of the source file.
	            var executeStatements = ts.visitNodes(node.statements, sourceElementVisitor, ts.isStatement, statementOffset);
	            // Emit early exports for function declarations.
	            ts.addRange(statements, hoistedStatements);
	            // We emit hoisted variables early to align roughly with our previous emit output.
	            // Two key differences in this approach are:
	            // - Temporary variables will appear at the top rather than at the bottom of the file
	            ts.addRange(statements, endLexicalEnvironment());
	            var exportStarFunction = addExportStarIfNeeded(statements);
	            var moduleObject = ts.createObjectLiteral([
	                ts.createPropertyAssignment("setters", createSettersArray(exportStarFunction, dependencyGroups)),
	                ts.createPropertyAssignment("execute", ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, 
	                /*parameters*/ [], 
	                /*type*/ undefined, ts.createBlock(executeStatements, /*multiLine*/ true)))
	            ]);
	            moduleObject.multiLine = true;
	            statements.push(ts.createReturn(moduleObject));
	            return ts.createBlock(statements, /*multiLine*/ true);
	        }
	        /**
	         * Adds an exportStar function to a statement list if it is needed for the file.
	         *
	         * @param statements A statement list.
	         */
	        function addExportStarIfNeeded(statements) {
	            if (!moduleInfo.hasExportStarsToExportValues) {
	                return;
	            }
	            // when resolving exports local exported entries/indirect exported entries in the module
	            // should always win over entries with similar names that were added via star exports
	            // to support this we store names of local/indirect exported entries in a set.
	            // this set is used to filter names brought by star expors.
	            // local names set should only be added if we have anything exported
	            if (!moduleInfo.exportedNames && moduleInfo.exportSpecifiers.size === 0) {
	                // no exported declarations (export var ...) or export specifiers (export {x})
	                // check if we have any non star export declarations.
	                var hasExportDeclarationWithExportClause = false;
	                for (var _i = 0, _a = moduleInfo.externalImports; _i < _a.length; _i++) {
	                    var externalImport = _a[_i];
	                    if (externalImport.kind === 248 /* ExportDeclaration */ && externalImport.exportClause) {
	                        hasExportDeclarationWithExportClause = true;
	                        break;
	                    }
	                }
	                if (!hasExportDeclarationWithExportClause) {
	                    // we still need to emit exportStar helper
	                    var exportStarFunction_1 = createExportStarFunction(/*localNames*/ undefined);
	                    statements.push(exportStarFunction_1);
	                    return exportStarFunction_1.name;
	                }
	            }
	            var exportedNames = [];
	            if (moduleInfo.exportedNames) {
	                for (var _b = 0, _c = moduleInfo.exportedNames; _b < _c.length; _b++) {
	                    var exportedLocalName = _c[_b];
	                    if (exportedLocalName.escapedText === "default") {
	                        continue;
	                    }
	                    // write name of exported declaration, i.e 'export var x...'
	                    exportedNames.push(ts.createPropertyAssignment(ts.createLiteral(exportedLocalName), ts.createTrue()));
	                }
	            }
	            for (var _d = 0, _e = moduleInfo.externalImports; _d < _e.length; _d++) {
	                var externalImport = _e[_d];
	                if (externalImport.kind !== 248 /* ExportDeclaration */) {
	                    continue;
	                }
	                if (!externalImport.exportClause) {
	                    // export * from ...
	                    continue;
	                }
	                for (var _f = 0, _g = externalImport.exportClause.elements; _f < _g.length; _f++) {
	                    var element = _g[_f];
	                    // write name of indirectly exported entry, i.e. 'export {x} from ...'
	                    exportedNames.push(ts.createPropertyAssignment(ts.createLiteral(ts.idText(element.name || element.propertyName)), ts.createTrue()));
	                }
	            }
	            var exportedNamesStorageRef = ts.createUniqueName("exportedNames");
	            statements.push(ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(exportedNamesStorageRef, 
	                /*type*/ undefined, ts.createObjectLiteral(exportedNames, /*multiline*/ true))
	            ])));
	            var exportStarFunction = createExportStarFunction(exportedNamesStorageRef);
	            statements.push(exportStarFunction);
	            return exportStarFunction.name;
	        }
	        /**
	         * Creates an exportStar function for the file, with an optional set of excluded local
	         * names.
	         *
	         * @param localNames An optional reference to an object containing a set of excluded local
	         * names.
	         */
	        function createExportStarFunction(localNames) {
	            var exportStarFunction = ts.createUniqueName("exportStar");
	            var m = ts.createIdentifier("m");
	            var n = ts.createIdentifier("n");
	            var exports = ts.createIdentifier("exports");
	            var condition = ts.createStrictInequality(n, ts.createLiteral("default"));
	            if (localNames) {
	                condition = ts.createLogicalAnd(condition, ts.createLogicalNot(ts.createCall(ts.createPropertyAccess(localNames, "hasOwnProperty"), 
	                /*typeArguments*/ undefined, [n])));
	            }
	            return ts.createFunctionDeclaration(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, exportStarFunction, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, m)], 
	            /*type*/ undefined, ts.createBlock([
	                ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                    ts.createVariableDeclaration(exports, 
	                    /*type*/ undefined, ts.createObjectLiteral([]))
	                ])),
	                ts.createForIn(ts.createVariableDeclarationList([
	                    ts.createVariableDeclaration(n, /*type*/ undefined)
	                ]), m, ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(condition, ts.createStatement(ts.createAssignment(ts.createElementAccess(exports, n), ts.createElementAccess(m, n)))), 1 /* SingleLine */)
	                ])),
	                ts.createStatement(ts.createCall(exportFunction, 
	                /*typeArguments*/ undefined, [exports]))
	            ], /*multiline*/ true));
	        }
	        /**
	         * Creates an array setter callbacks for each dependency group.
	         *
	         * @param exportStarFunction A reference to an exportStarFunction for the file.
	         * @param dependencyGroups An array of grouped dependencies.
	         */
	        function createSettersArray(exportStarFunction, dependencyGroups) {
	            var setters = [];
	            for (var _i = 0, dependencyGroups_1 = dependencyGroups; _i < dependencyGroups_1.length; _i++) {
	                var group_1 = dependencyGroups_1[_i];
	                // derive a unique name for parameter from the first named entry in the group
	                var localName = ts.forEach(group_1.externalImports, function (i) { return ts.getLocalNameForExternalImport(i, currentSourceFile); });
	                var parameterName = localName ? ts.getGeneratedNameForNode(localName) : ts.createUniqueName("");
	                var statements = [];
	                for (var _a = 0, _b = group_1.externalImports; _a < _b.length; _a++) {
	                    var entry = _b[_a];
	                    var importVariableName = ts.getLocalNameForExternalImport(entry, currentSourceFile);
	                    switch (entry.kind) {
	                        case 242 /* ImportDeclaration */:
	                            if (!entry.importClause) {
	                                // 'import "..."' case
	                                // module is imported only for side-effects, no emit required
	                                break;
	                            }
	                        // falls through
	                        case 241 /* ImportEqualsDeclaration */:
	                            ts.Debug.assert(importVariableName !== undefined);
	                            // save import into the local
	                            statements.push(ts.createStatement(ts.createAssignment(importVariableName, parameterName)));
	                            break;
	                        case 248 /* ExportDeclaration */:
	                            ts.Debug.assert(importVariableName !== undefined);
	                            if (entry.exportClause) {
	                                //  export {a, b as c} from 'foo'
	                                //
	                                // emit as:
	                                //
	                                //  exports_({
	                                //     "a": _["a"],
	                                //     "c": _["b"]
	                                //  });
	                                var properties = [];
	                                for (var _c = 0, _d = entry.exportClause.elements; _c < _d.length; _c++) {
	                                    var e = _d[_c];
	                                    properties.push(ts.createPropertyAssignment(ts.createLiteral(ts.idText(e.name)), ts.createElementAccess(parameterName, ts.createLiteral(ts.idText(e.propertyName || e.name)))));
	                                }
	                                statements.push(ts.createStatement(ts.createCall(exportFunction, 
	                                /*typeArguments*/ undefined, [ts.createObjectLiteral(properties, /*multiline*/ true)])));
	                            }
	                            else {
	                                //  export * from 'foo'
	                                //
	                                // emit as:
	                                //
	                                //  exportStar(foo_1_1);
	                                statements.push(ts.createStatement(ts.createCall(exportStarFunction, 
	                                /*typeArguments*/ undefined, [parameterName])));
	                            }
	                            break;
	                    }
	                }
	                setters.push(ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, parameterName)], 
	                /*type*/ undefined, ts.createBlock(statements, /*multiLine*/ true)));
	            }
	            return ts.createArrayLiteral(setters, /*multiLine*/ true);
	        }
	        //
	        // Top-level Source Element Visitors
	        //
	        /**
	         * Visit source elements at the top-level of a module.
	         *
	         * @param node The node to visit.
	         */
	        function sourceElementVisitor(node) {
	            switch (node.kind) {
	                case 242 /* ImportDeclaration */:
	                    return visitImportDeclaration(node);
	                case 241 /* ImportEqualsDeclaration */:
	                    return visitImportEqualsDeclaration(node);
	                case 248 /* ExportDeclaration */:
	                    // ExportDeclarations are elided as they are handled via
	                    // `appendExportsOfDeclaration`.
	                    return undefined;
	                case 247 /* ExportAssignment */:
	                    return visitExportAssignment(node);
	                default:
	                    return nestedElementVisitor(node);
	            }
	        }
	        /**
	         * Visits an ImportDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitImportDeclaration(node) {
	            var statements;
	            if (node.importClause) {
	                hoistVariableDeclaration(ts.getLocalNameForExternalImport(node, currentSourceFile));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfImportDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfImportDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits an ImportEqualsDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitImportEqualsDeclaration(node) {
	            ts.Debug.assert(ts.isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
	            var statements;
	            hoistVariableDeclaration(ts.getLocalNameForExternalImport(node, currentSourceFile));
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfImportEqualsDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfImportEqualsDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits an ExportAssignment node.
	         *
	         * @param node The node to visit.
	         */
	        function visitExportAssignment(node) {
	            if (node.isExportEquals) {
	                // Elide `export=` as it is illegal in a SystemJS module.
	                return undefined;
	            }
	            var expression = ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression);
	            var original = node.original;
	            if (original && hasAssociatedEndOfDeclarationMarker(original)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportStatement(deferredExports[id], ts.createIdentifier("default"), expression, /*allowComments*/ true);
	            }
	            else {
	                return createExportStatement(ts.createIdentifier("default"), expression, /*allowComments*/ true);
	            }
	        }
	        /**
	         * Visits a FunctionDeclaration, hoisting it to the outer module body function.
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionDeclaration(node) {
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                hoistedStatements = ts.append(hoistedStatements, ts.updateFunctionDeclaration(node, node.decorators, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, ts.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), 
	                /*typeParameters*/ undefined, ts.visitNodes(node.parameters, destructuringAndImportCallVisitor, ts.isParameterDeclaration), 
	                /*type*/ undefined, ts.visitNode(node.body, destructuringAndImportCallVisitor, ts.isBlock)));
	            }
	            else {
	                hoistedStatements = ts.append(hoistedStatements, ts.visitEachChild(node, destructuringAndImportCallVisitor, context));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfHoistedDeclaration(deferredExports[id], node);
	            }
	            else {
	                hoistedStatements = appendExportsOfHoistedDeclaration(hoistedStatements, node);
	            }
	            return undefined;
	        }
	        /**
	         * Visits a ClassDeclaration, hoisting its name to the outer module body function.
	         *
	         * @param node The node to visit.
	         */
	        function visitClassDeclaration(node) {
	            var statements;
	            // Hoist the name of the class declaration to the outer module body function.
	            var name = ts.getLocalName(node);
	            hoistVariableDeclaration(name);
	            // Rewrite the class declaration into an assignment of a class expression.
	            statements = ts.append(statements, ts.setTextRange(ts.createStatement(ts.createAssignment(name, ts.setTextRange(ts.createClassExpression(
	            /*modifiers*/ undefined, node.name, 
	            /*typeParameters*/ undefined, ts.visitNodes(node.heritageClauses, destructuringAndImportCallVisitor, ts.isHeritageClause), ts.visitNodes(node.members, destructuringAndImportCallVisitor, ts.isClassElement)), node))), node));
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfHoistedDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfHoistedDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a variable statement, hoisting declared names to the top-level module body.
	         * Each declaration is rewritten into an assignment expression.
	         *
	         * @param node The node to visit.
	         */
	        function visitVariableStatement(node) {
	            if (!shouldHoistVariableDeclarationList(node.declarationList)) {
	                return ts.visitNode(node, destructuringAndImportCallVisitor, ts.isStatement);
	            }
	            var expressions;
	            var isExportedDeclaration = ts.hasModifier(node, 1 /* Export */);
	            var isMarkedDeclaration = hasAssociatedEndOfDeclarationMarker(node);
	            for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                var variable = _a[_i];
	                if (variable.initializer) {
	                    expressions = ts.append(expressions, transformInitializedVariable(variable, isExportedDeclaration && !isMarkedDeclaration));
	                }
	                else {
	                    hoistBindingElement(variable);
	                }
	            }
	            var statements;
	            if (expressions) {
	                statements = ts.append(statements, ts.setTextRange(ts.createStatement(ts.inlineExpressions(expressions)), node));
	            }
	            if (isMarkedDeclaration) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfVariableStatement(deferredExports[id], node, isExportedDeclaration);
	            }
	            else {
	                statements = appendExportsOfVariableStatement(statements, node, /*exportSelf*/ false);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Hoists the declared names of a VariableDeclaration or BindingElement.
	         *
	         * @param node The declaration to hoist.
	         */
	        function hoistBindingElement(node) {
	            if (ts.isBindingPattern(node.name)) {
	                for (var _i = 0, _a = node.name.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        hoistBindingElement(element);
	                    }
	                }
	            }
	            else {
	                hoistVariableDeclaration(ts.getSynthesizedClone(node.name));
	            }
	        }
	        /**
	         * Determines whether a VariableDeclarationList should be hoisted.
	         *
	         * @param node The node to test.
	         */
	        function shouldHoistVariableDeclarationList(node) {
	            // hoist only non-block scoped declarations or block scoped declarations parented by source file
	            return (ts.getEmitFlags(node) & 2097152 /* NoHoisting */) === 0
	                && (enclosingBlockScopedContainer.kind === 272 /* SourceFile */
	                    || (ts.getOriginalNode(node).flags & 3 /* BlockScoped */) === 0);
	        }
	        /**
	         * Transform an initialized variable declaration into an expression.
	         *
	         * @param node The node to transform.
	         * @param isExportedDeclaration A value indicating whether the variable is exported.
	         */
	        function transformInitializedVariable(node, isExportedDeclaration) {
	            var createAssignment = isExportedDeclaration ? createExportedVariableAssignment : createNonExportedVariableAssignment;
	            return ts.isBindingPattern(node.name)
	                ? ts.flattenDestructuringAssignment(node, destructuringAndImportCallVisitor, context, 0 /* All */, 
	                /*needsValue*/ false, createAssignment)
	                : node.initializer ? createAssignment(node.name, ts.visitNode(node.initializer, destructuringAndImportCallVisitor, ts.isExpression)) : node.name;
	        }
	        /**
	         * Creates an assignment expression for an exported variable declaration.
	         *
	         * @param name The name of the variable.
	         * @param value The value of the variable's initializer.
	         * @param location The source map location for the assignment.
	         */
	        function createExportedVariableAssignment(name, value, location) {
	            return createVariableAssignment(name, value, location, /*isExportedDeclaration*/ true);
	        }
	        /**
	         * Creates an assignment expression for a non-exported variable declaration.
	         *
	         * @param name The name of the variable.
	         * @param value The value of the variable's initializer.
	         * @param location The source map location for the assignment.
	         */
	        function createNonExportedVariableAssignment(name, value, location) {
	            return createVariableAssignment(name, value, location, /*isExportedDeclaration*/ false);
	        }
	        /**
	         * Creates an assignment expression for a variable declaration.
	         *
	         * @param name The name of the variable.
	         * @param value The value of the variable's initializer.
	         * @param location The source map location for the assignment.
	         * @param isExportedDeclaration A value indicating whether the variable is exported.
	         */
	        function createVariableAssignment(name, value, location, isExportedDeclaration) {
	            hoistVariableDeclaration(ts.getSynthesizedClone(name));
	            return isExportedDeclaration
	                ? createExportExpression(name, preventSubstitution(ts.setTextRange(ts.createAssignment(name, value), location)))
	                : preventSubstitution(ts.setTextRange(ts.createAssignment(name, value), location));
	        }
	        /**
	         * Visits a MergeDeclarationMarker used as a placeholder for the beginning of a merged
	         * and transformed declaration.
	         *
	         * @param node The node to visit.
	         */
	        function visitMergeDeclarationMarker(node) {
	            // For an EnumDeclaration or ModuleDeclaration that merges with a preceeding
	            // declaration we do not emit a leading variable declaration. To preserve the
	            // begin/end semantics of the declararation and to properly handle exports
	            // we wrapped the leading variable declaration in a `MergeDeclarationMarker`.
	            //
	            // To balance the declaration, we defer the exports of the elided variable
	            // statement until we visit this declaration's `EndOfDeclarationMarker`.
	            if (hasAssociatedEndOfDeclarationMarker(node) && node.original.kind === 212 /* VariableStatement */) {
	                var id = ts.getOriginalNodeId(node);
	                var isExportedDeclaration = ts.hasModifier(node.original, 1 /* Export */);
	                deferredExports[id] = appendExportsOfVariableStatement(deferredExports[id], node.original, isExportedDeclaration);
	            }
	            return node;
	        }
	        /**
	         * Determines whether a node has an associated EndOfDeclarationMarker.
	         *
	         * @param node The node to test.
	         */
	        function hasAssociatedEndOfDeclarationMarker(node) {
	            return (ts.getEmitFlags(node) & 4194304 /* HasEndOfDeclarationMarker */) !== 0;
	        }
	        /**
	         * Visits a DeclarationMarker used as a placeholder for the end of a transformed
	         * declaration.
	         *
	         * @param node The node to visit.
	         */
	        function visitEndOfDeclarationMarker(node) {
	            // For some transformations we emit an `EndOfDeclarationMarker` to mark the actual
	            // end of the transformed declaration. We use this marker to emit any deferred exports
	            // of the declaration.
	            var id = ts.getOriginalNodeId(node);
	            var statements = deferredExports[id];
	            if (statements) {
	                delete deferredExports[id];
	                return ts.append(statements, node);
	            }
	            return node;
	        }
	        /**
	         * Appends the exports of an ImportDeclaration to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfImportDeclaration(statements, decl) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            var importClause = decl.importClause;
	            if (!importClause) {
	                return statements;
	            }
	            if (importClause.name) {
	                statements = appendExportsOfDeclaration(statements, importClause);
	            }
	            var namedBindings = importClause.namedBindings;
	            if (namedBindings) {
	                switch (namedBindings.kind) {
	                    case 244 /* NamespaceImport */:
	                        statements = appendExportsOfDeclaration(statements, namedBindings);
	                        break;
	                    case 245 /* NamedImports */:
	                        for (var _i = 0, _a = namedBindings.elements; _i < _a.length; _i++) {
	                            var importBinding = _a[_i];
	                            statements = appendExportsOfDeclaration(statements, importBinding);
	                        }
	                        break;
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the export of an ImportEqualsDeclaration to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfImportEqualsDeclaration(statements, decl) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            return appendExportsOfDeclaration(statements, decl);
	        }
	        /**
	         * Appends the exports of a VariableStatement to a statement list, returning the statement
	         * list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param node The VariableStatement whose exports are to be recorded.
	         * @param exportSelf A value indicating whether to also export each VariableDeclaration of
	         * `nodes` declaration list.
	         */
	        function appendExportsOfVariableStatement(statements, node, exportSelf) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                var decl = _a[_i];
	                if (decl.initializer || exportSelf) {
	                    statements = appendExportsOfBindingElement(statements, decl, exportSelf);
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a VariableDeclaration or BindingElement to a statement list,
	         * returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         * @param exportSelf A value indicating whether to also export the declaration itself.
	         */
	        function appendExportsOfBindingElement(statements, decl, exportSelf) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            if (ts.isBindingPattern(decl.name)) {
	                for (var _i = 0, _a = decl.name.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        statements = appendExportsOfBindingElement(statements, element, exportSelf);
	                    }
	                }
	            }
	            else if (!ts.isGeneratedIdentifier(decl.name)) {
	                var excludeName = void 0;
	                if (exportSelf) {
	                    statements = appendExportStatement(statements, decl.name, ts.getLocalName(decl));
	                    excludeName = ts.idText(decl.name);
	                }
	                statements = appendExportsOfDeclaration(statements, decl, excludeName);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a ClassDeclaration or FunctionDeclaration to a statement list,
	         * returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfHoistedDeclaration(statements, decl) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            var excludeName;
	            if (ts.hasModifier(decl, 1 /* Export */)) {
	                var exportName = ts.hasModifier(decl, 512 /* Default */) ? ts.createLiteral("default") : decl.name;
	                statements = appendExportStatement(statements, exportName, ts.getLocalName(decl));
	                excludeName = ts.getTextOfIdentifierOrLiteral(exportName);
	            }
	            if (decl.name) {
	                statements = appendExportsOfDeclaration(statements, decl, excludeName);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a declaration to a statement list, returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration to export.
	         * @param excludeName An optional name to exclude from exports.
	         */
	        function appendExportsOfDeclaration(statements, decl, excludeName) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            var name = ts.getDeclarationName(decl);
	            var exportSpecifiers = moduleInfo.exportSpecifiers.get(ts.idText(name));
	            if (exportSpecifiers) {
	                for (var _i = 0, exportSpecifiers_2 = exportSpecifiers; _i < exportSpecifiers_2.length; _i++) {
	                    var exportSpecifier = exportSpecifiers_2[_i];
	                    if (exportSpecifier.name.escapedText !== excludeName) {
	                        statements = appendExportStatement(statements, exportSpecifier.name, name);
	                    }
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the down-level representation of an export to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param exportName The name of the export.
	         * @param expression The expression to export.
	         * @param allowComments Whether to allow comments on the export.
	         */
	        function appendExportStatement(statements, exportName, expression, allowComments) {
	            statements = ts.append(statements, createExportStatement(exportName, expression, allowComments));
	            return statements;
	        }
	        /**
	         * Creates a call to the current file's export function to export a value.
	         *
	         * @param name The bound name of the export.
	         * @param value The exported value.
	         * @param allowComments An optional value indicating whether to emit comments for the statement.
	         */
	        function createExportStatement(name, value, allowComments) {
	            var statement = ts.createStatement(createExportExpression(name, value));
	            ts.startOnNewLine(statement);
	            if (!allowComments) {
	                ts.setEmitFlags(statement, 1536 /* NoComments */);
	            }
	            return statement;
	        }
	        /**
	         * Creates a call to the current file's export function to export a value.
	         *
	         * @param name The bound name of the export.
	         * @param value The exported value.
	         */
	        function createExportExpression(name, value) {
	            var exportName = ts.isIdentifier(name) ? ts.createLiteral(name) : name;
	            ts.setEmitFlags(value, ts.getEmitFlags(value) | 1536 /* NoComments */);
	            return ts.setCommentRange(ts.createCall(exportFunction, /*typeArguments*/ undefined, [exportName, value]), value);
	        }
	        //
	        // Top-Level or Nested Source Element Visitors
	        //
	        /**
	         * Visit nested elements at the top-level of a module.
	         *
	         * @param node The node to visit.
	         */
	        function nestedElementVisitor(node) {
	            switch (node.kind) {
	                case 212 /* VariableStatement */:
	                    return visitVariableStatement(node);
	                case 232 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 233 /* ClassDeclaration */:
	                    return visitClassDeclaration(node);
	                case 218 /* ForStatement */:
	                    return visitForStatement(node);
	                case 219 /* ForInStatement */:
	                    return visitForInStatement(node);
	                case 220 /* ForOfStatement */:
	                    return visitForOfStatement(node);
	                case 216 /* DoStatement */:
	                    return visitDoStatement(node);
	                case 217 /* WhileStatement */:
	                    return visitWhileStatement(node);
	                case 226 /* LabeledStatement */:
	                    return visitLabeledStatement(node);
	                case 224 /* WithStatement */:
	                    return visitWithStatement(node);
	                case 225 /* SwitchStatement */:
	                    return visitSwitchStatement(node);
	                case 239 /* CaseBlock */:
	                    return visitCaseBlock(node);
	                case 264 /* CaseClause */:
	                    return visitCaseClause(node);
	                case 265 /* DefaultClause */:
	                    return visitDefaultClause(node);
	                case 228 /* TryStatement */:
	                    return visitTryStatement(node);
	                case 267 /* CatchClause */:
	                    return visitCatchClause(node);
	                case 211 /* Block */:
	                    return visitBlock(node);
	                case 297 /* MergeDeclarationMarker */:
	                    return visitMergeDeclarationMarker(node);
	                case 298 /* EndOfDeclarationMarker */:
	                    return visitEndOfDeclarationMarker(node);
	                default:
	                    return destructuringAndImportCallVisitor(node);
	            }
	        }
	        /**
	         * Visits the body of a ForStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitForStatement(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateFor(node, visitForInitializer(node.initializer), ts.visitNode(node.condition, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.incrementor, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Visits the body of a ForInStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitForInStatement(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateForIn(node, visitForInitializer(node.initializer), ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Visits the body of a ForOfStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitForOfStatement(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateForOf(node, node.awaitModifier, visitForInitializer(node.initializer), ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Determines whether to hoist the initializer of a ForStatement, ForInStatement, or
	         * ForOfStatement.
	         *
	         * @param node The node to test.
	         */
	        function shouldHoistForInitializer(node) {
	            return ts.isVariableDeclarationList(node)
	                && shouldHoistVariableDeclarationList(node);
	        }
	        /**
	         * Visits the initializer of a ForStatement, ForInStatement, or ForOfStatement
	         *
	         * @param node The node to visit.
	         */
	        function visitForInitializer(node) {
	            if (!node) {
	                return node;
	            }
	            if (shouldHoistForInitializer(node)) {
	                var expressions = void 0;
	                for (var _i = 0, _a = node.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    expressions = ts.append(expressions, transformInitializedVariable(variable, /*isExportedDeclaration*/ false));
	                    if (!variable.initializer) {
	                        hoistBindingElement(variable);
	                    }
	                }
	                return expressions ? ts.inlineExpressions(expressions) : ts.createOmittedExpression();
	            }
	            else {
	                return ts.visitEachChild(node, nestedElementVisitor, context);
	            }
	        }
	        /**
	         * Visits the body of a DoStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitDoStatement(node) {
	            return ts.updateDo(node, ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock), ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression));
	        }
	        /**
	         * Visits the body of a WhileStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitWhileStatement(node) {
	            return ts.updateWhile(node, ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        /**
	         * Visits the body of a LabeledStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitLabeledStatement(node) {
	            return ts.updateLabel(node, node.label, ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        /**
	         * Visits the body of a WithStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitWithStatement(node) {
	            return ts.updateWith(node, ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        /**
	         * Visits the body of a SwitchStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitSwitchStatement(node) {
	            return ts.updateSwitch(node, ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.caseBlock, nestedElementVisitor, ts.isCaseBlock));
	        }
	        /**
	         * Visits the body of a CaseBlock to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitCaseBlock(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateCaseBlock(node, ts.visitNodes(node.clauses, nestedElementVisitor, ts.isCaseOrDefaultClause));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Visits the body of a CaseClause to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitCaseClause(node) {
	            return ts.updateCaseClause(node, ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNodes(node.statements, nestedElementVisitor, ts.isStatement));
	        }
	        /**
	         * Visits the body of a DefaultClause to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitDefaultClause(node) {
	            return ts.visitEachChild(node, nestedElementVisitor, context);
	        }
	        /**
	         * Visits the body of a TryStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitTryStatement(node) {
	            return ts.visitEachChild(node, nestedElementVisitor, context);
	        }
	        /**
	         * Visits the body of a CatchClause to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitCatchClause(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateCatchClause(node, node.variableDeclaration, ts.visitNode(node.block, nestedElementVisitor, ts.isBlock));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Visits the body of a Block to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitBlock(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.visitEachChild(node, nestedElementVisitor, context);
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        //
	        // Destructuring Assignment Visitors
	        //
	        /**
	         * Visit nodes to flatten destructuring assignments to exported symbols.
	         *
	         * @param node The node to visit.
	         */
	        function destructuringAndImportCallVisitor(node) {
	            if (node.transformFlags & 1024 /* DestructuringAssignment */
	                && node.kind === 198 /* BinaryExpression */) {
	                return visitDestructuringAssignment(node);
	            }
	            else if (ts.isImportCall(node)) {
	                return visitImportCallExpression(node);
	            }
	            else if ((node.transformFlags & 2048 /* ContainsDestructuringAssignment */) || (node.transformFlags & 67108864 /* ContainsDynamicImport */)) {
	                return ts.visitEachChild(node, destructuringAndImportCallVisitor, context);
	            }
	            else {
	                return node;
	            }
	        }
	        function visitImportCallExpression(node) {
	            // import("./blah")
	            // emit as
	            // System.register([], function (_export, _context) {
	            //     return {
	            //         setters: [],
	            //         execute: () => {
	            //             _context.import('./blah');
	            //         }
	            //     };
	            // });
	            return ts.createCall(ts.createPropertyAccess(contextObject, ts.createIdentifier("import")), 
	            /*typeArguments*/ undefined, ts.some(node.arguments) ? [ts.visitNode(node.arguments[0], destructuringAndImportCallVisitor)] : []);
	        }
	        /**
	         * Visits a DestructuringAssignment to flatten destructuring to exported symbols.
	         *
	         * @param node The node to visit.
	         */
	        function visitDestructuringAssignment(node) {
	            if (hasExportedReferenceInDestructuringTarget(node.left)) {
	                return ts.flattenDestructuringAssignment(node, destructuringAndImportCallVisitor, context, 0 /* All */, 
	                /*needsValue*/ true);
	            }
	            return ts.visitEachChild(node, destructuringAndImportCallVisitor, context);
	        }
	        /**
	         * Determines whether the target of a destructuring assigment refers to an exported symbol.
	         *
	         * @param node The destructuring target.
	         */
	        function hasExportedReferenceInDestructuringTarget(node) {
	            if (ts.isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
	                return hasExportedReferenceInDestructuringTarget(node.left);
	            }
	            else if (ts.isSpreadElement(node)) {
	                return hasExportedReferenceInDestructuringTarget(node.expression);
	            }
	            else if (ts.isObjectLiteralExpression(node)) {
	                return ts.some(node.properties, hasExportedReferenceInDestructuringTarget);
	            }
	            else if (ts.isArrayLiteralExpression(node)) {
	                return ts.some(node.elements, hasExportedReferenceInDestructuringTarget);
	            }
	            else if (ts.isShorthandPropertyAssignment(node)) {
	                return hasExportedReferenceInDestructuringTarget(node.name);
	            }
	            else if (ts.isPropertyAssignment(node)) {
	                return hasExportedReferenceInDestructuringTarget(node.initializer);
	            }
	            else if (ts.isIdentifier(node)) {
	                var container = resolver.getReferencedExportContainer(node);
	                return container !== undefined && container.kind === 272 /* SourceFile */;
	            }
	            else {
	                return false;
	            }
	        }
	        //
	        // Modifier Visitors
	        //
	        /**
	         * Visit nodes to elide module-specific modifiers.
	         *
	         * @param node The node to visit.
	         */
	        function modifierVisitor(node) {
	            switch (node.kind) {
	                case 84 /* ExportKeyword */:
	                case 79 /* DefaultKeyword */:
	                    return undefined;
	            }
	            return node;
	        }
	        //
	        // Emit Notification
	        //
	        /**
	         * Hook for node emit notifications.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            if (node.kind === 272 /* SourceFile */) {
	                var id = ts.getOriginalNodeId(node);
	                currentSourceFile = node;
	                moduleInfo = moduleInfoMap[id];
	                exportFunction = exportFunctionsMap[id];
	                noSubstitution = noSubstitutionMap[id];
	                if (noSubstitution) {
	                    delete noSubstitutionMap[id];
	                }
	                previousOnEmitNode(hint, node, emitCallback);
	                currentSourceFile = undefined;
	                moduleInfo = undefined;
	                exportFunction = undefined;
	                noSubstitution = undefined;
	            }
	            else {
	                previousOnEmitNode(hint, node, emitCallback);
	            }
	        }
	        //
	        // Substitutions
	        //
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (isSubstitutionPrevented(node)) {
	                return node;
	            }
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            else if (hint === 4 /* Unspecified */) {
	                return substituteUnspecified(node);
	            }
	            return node;
	        }
	        /**
	         * Substitute the node, if necessary.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteUnspecified(node) {
	            switch (node.kind) {
	                case 269 /* ShorthandPropertyAssignment */:
	                    return substituteShorthandPropertyAssignment(node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for a ShorthandPropertyAssignment whose name that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteShorthandPropertyAssignment(node) {
	            var name = node.name;
	            if (!ts.isGeneratedIdentifier(name) && !ts.isLocalName(name)) {
	                var importDeclaration = resolver.getReferencedImportDeclaration(name);
	                if (importDeclaration) {
	                    if (ts.isImportClause(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAssignment(ts.getSynthesizedClone(name), ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent), ts.createIdentifier("default"))), 
	                        /*location*/ node);
	                    }
	                    else if (ts.isImportSpecifier(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAssignment(ts.getSynthesizedClone(name), ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent.parent.parent), ts.getSynthesizedClone(importDeclaration.propertyName || importDeclaration.name))), 
	                        /*location*/ node);
	                    }
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitute the expression, if necessary.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return substituteExpressionIdentifier(node);
	                case 198 /* BinaryExpression */:
	                    return substituteBinaryExpression(node);
	                case 196 /* PrefixUnaryExpression */:
	                case 197 /* PostfixUnaryExpression */:
	                    return substituteUnaryExpression(node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for an Identifier expression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteExpressionIdentifier(node) {
	            if (ts.getEmitFlags(node) & 4096 /* HelperName */) {
	                var externalHelpersModuleName = ts.getExternalHelpersModuleName(currentSourceFile);
	                if (externalHelpersModuleName) {
	                    return ts.createPropertyAccess(externalHelpersModuleName, node);
	                }
	                return node;
	            }
	            // When we see an identifier in an expression position that
	            // points to an imported symbol, we should substitute a qualified
	            // reference to the imported symbol if one is needed.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            if (!ts.isGeneratedIdentifier(node) && !ts.isLocalName(node)) {
	                var importDeclaration = resolver.getReferencedImportDeclaration(node);
	                if (importDeclaration) {
	                    if (ts.isImportClause(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent), ts.createIdentifier("default")), 
	                        /*location*/ node);
	                    }
	                    else if (ts.isImportSpecifier(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent.parent.parent), ts.getSynthesizedClone(importDeclaration.propertyName || importDeclaration.name)), 
	                        /*location*/ node);
	                    }
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitution for a BinaryExpression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteBinaryExpression(node) {
	            // When we see an assignment expression whose left-hand side is an exported symbol,
	            // we should ensure all exports of that symbol are updated with the correct value.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            // - We do not substitute identifiers that were originally the name of an enum or
	            //   namespace due to how they are transformed in TypeScript.
	            // - We only substitute identifiers that are exported at the top level.
	            if (ts.isAssignmentOperator(node.operatorToken.kind)
	                && ts.isIdentifier(node.left)
	                && !ts.isGeneratedIdentifier(node.left)
	                && !ts.isLocalName(node.left)
	                && !ts.isDeclarationNameOfEnumOrNamespace(node.left)) {
	                var exportedNames = getExports(node.left);
	                if (exportedNames) {
	                    // For each additional export of the declaration, apply an export assignment.
	                    var expression = node;
	                    for (var _i = 0, exportedNames_3 = exportedNames; _i < exportedNames_3.length; _i++) {
	                        var exportName = exportedNames_3[_i];
	                        expression = createExportExpression(exportName, preventSubstitution(expression));
	                    }
	                    return expression;
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitution for a UnaryExpression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteUnaryExpression(node) {
	            // When we see a prefix or postfix increment expression whose operand is an exported
	            // symbol, we should ensure all exports of that symbol are updated with the correct
	            // value.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            // - We do not substitute identifiers that were originally the name of an enum or
	            //   namespace due to how they are transformed in TypeScript.
	            // - We only substitute identifiers that are exported at the top level.
	            if ((node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */)
	                && ts.isIdentifier(node.operand)
	                && !ts.isGeneratedIdentifier(node.operand)
	                && !ts.isLocalName(node.operand)
	                && !ts.isDeclarationNameOfEnumOrNamespace(node.operand)) {
	                var exportedNames = getExports(node.operand);
	                if (exportedNames) {
	                    var expression = node.kind === 197 /* PostfixUnaryExpression */
	                        ? ts.setTextRange(ts.createPrefix(node.operator, node.operand), node)
	                        : node;
	                    for (var _i = 0, exportedNames_4 = exportedNames; _i < exportedNames_4.length; _i++) {
	                        var exportName = exportedNames_4[_i];
	                        expression = createExportExpression(exportName, preventSubstitution(expression));
	                    }
	                    if (node.kind === 197 /* PostfixUnaryExpression */) {
	                        expression = node.operator === 43 /* PlusPlusToken */
	                            ? ts.createSubtract(preventSubstitution(expression), ts.createLiteral(1))
	                            : ts.createAdd(preventSubstitution(expression), ts.createLiteral(1));
	                    }
	                    return expression;
	                }
	            }
	            return node;
	        }
	        /**
	         * Gets the exports of a name.
	         *
	         * @param name The name.
	         */
	        function getExports(name) {
	            var exportedNames;
	            if (!ts.isGeneratedIdentifier(name)) {
	                var valueDeclaration = resolver.getReferencedImportDeclaration(name)
	                    || resolver.getReferencedValueDeclaration(name);
	                if (valueDeclaration) {
	                    var exportContainer = resolver.getReferencedExportContainer(name, /*prefixLocals*/ false);
	                    if (exportContainer && exportContainer.kind === 272 /* SourceFile */) {
	                        exportedNames = ts.append(exportedNames, ts.getDeclarationName(valueDeclaration));
	                    }
	                    exportedNames = ts.addRange(exportedNames, moduleInfo && moduleInfo.exportedBindings[ts.getOriginalNodeId(valueDeclaration)]);
	                }
	            }
	            return exportedNames;
	        }
	        /**
	         * Prevent substitution of a node for this transformer.
	         *
	         * @param node The node which should not be substituted.
	         */
	        function preventSubstitution(node) {
	            if (noSubstitution === undefined)
	                noSubstitution = [];
	            noSubstitution[ts.getNodeId(node)] = true;
	            return node;
	        }
	        /**
	         * Determines whether a node should not be substituted.
	         *
	         * @param node The node to test.
	         */
	        function isSubstitutionPrevented(node) {
	            return noSubstitution && node.id && noSubstitution[node.id];
	        }
	    }
	    ts.transformSystemModule = transformSystemModule;
	})(ts || (ts = {}));
	/// <reference path="../../factory.ts" />
	/// <reference path="../../visitor.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformES2015Module(context) {
	        var compilerOptions = context.getCompilerOptions();
	        var previousOnEmitNode = context.onEmitNode;
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        context.onEmitNode = onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        context.enableEmitNotification(272 /* SourceFile */);
	        context.enableSubstitution(71 /* Identifier */);
	        var currentSourceFile;
	        return transformSourceFile;
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            if (ts.isExternalModule(node) || compilerOptions.isolatedModules) {
	                var externalHelpersModuleName = ts.getOrCreateExternalHelpersModuleNameIfNeeded(node, compilerOptions);
	                if (externalHelpersModuleName) {
	                    var statements = [];
	                    var statementOffset = ts.addPrologue(statements, node.statements);
	                    var tslibImport = ts.createImportDeclaration(
	                    /*decorators*/ undefined, 
	                    /*modifiers*/ undefined, ts.createImportClause(/*name*/ undefined, ts.createNamespaceImport(externalHelpersModuleName)), ts.createLiteral(ts.externalHelpersModuleNameText));
	                    ts.addEmitFlags(tslibImport, 67108864 /* NeverApplyImportHelper */);
	                    ts.append(statements, tslibImport);
	                    ts.addRange(statements, ts.visitNodes(node.statements, visitor, ts.isStatement, statementOffset));
	                    return ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray(statements), node.statements));
	                }
	                else {
	                    return ts.visitEachChild(node, visitor, context);
	                }
	            }
	            return node;
	        }
	        function visitor(node) {
	            switch (node.kind) {
	                case 241 /* ImportEqualsDeclaration */:
	                    // Elide `import=` as it is not legal with --module ES6
	                    return undefined;
	                case 247 /* ExportAssignment */:
	                    return visitExportAssignment(node);
	            }
	            return node;
	        }
	        function visitExportAssignment(node) {
	            // Elide `export=` as it is not legal with --module ES6
	            return node.isExportEquals ? undefined : node;
	        }
	        //
	        // Emit Notification
	        //
	        /**
	         * Hook for node emit.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emit A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            if (ts.isSourceFile(node)) {
	                currentSourceFile = node;
	                previousOnEmitNode(hint, node, emitCallback);
	                currentSourceFile = undefined;
	            }
	            else {
	                previousOnEmitNode(hint, node, emitCallback);
	            }
	        }
	        //
	        // Substitutions
	        //
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (ts.isIdentifier(node) && hint === 1 /* Expression */) {
	                return substituteExpressionIdentifier(node);
	            }
	            return node;
	        }
	        function substituteExpressionIdentifier(node) {
	            if (ts.getEmitFlags(node) & 4096 /* HelperName */) {
	                var externalHelpersModuleName = ts.getExternalHelpersModuleName(currentSourceFile);
	                if (externalHelpersModuleName) {
	                    return ts.createPropertyAccess(externalHelpersModuleName, node);
	                }
	            }
	            return node;
	        }
	    }
	    ts.transformES2015Module = transformES2015Module;
	})(ts || (ts = {}));
	/// <reference path="visitor.ts" />
	/// <reference path="transformers/utilities.ts" />
	/// <reference path="transformers/ts.ts" />
	/// <reference path="transformers/jsx.ts" />
	/// <reference path="transformers/esnext.ts" />
	/// <reference path="transformers/es2017.ts" />
	/// <reference path="transformers/es2016.ts" />
	/// <reference path="transformers/es2015.ts" />
	/// <reference path="transformers/generators.ts" />
	/// <reference path="transformers/es5.ts" />
	/// <reference path="transformers/module/module.ts" />
	/// <reference path="transformers/module/system.ts" />
	/// <reference path="transformers/module/es2015.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    function getModuleTransformer(moduleKind) {
	        switch (moduleKind) {
	            case ts.ModuleKind.ESNext:
	            case ts.ModuleKind.ES2015:
	                return ts.transformES2015Module;
	            case ts.ModuleKind.System:
	                return ts.transformSystemModule;
	            default:
	                return ts.transformModule;
	        }
	    }
	    var TransformationState;
	    (function (TransformationState) {
	        TransformationState[TransformationState["Uninitialized"] = 0] = "Uninitialized";
	        TransformationState[TransformationState["Initialized"] = 1] = "Initialized";
	        TransformationState[TransformationState["Completed"] = 2] = "Completed";
	        TransformationState[TransformationState["Disposed"] = 3] = "Disposed";
	    })(TransformationState || (TransformationState = {}));
	    var SyntaxKindFeatureFlags;
	    (function (SyntaxKindFeatureFlags) {
	        SyntaxKindFeatureFlags[SyntaxKindFeatureFlags["Substitution"] = 1] = "Substitution";
	        SyntaxKindFeatureFlags[SyntaxKindFeatureFlags["EmitNotifications"] = 2] = "EmitNotifications";
	    })(SyntaxKindFeatureFlags || (SyntaxKindFeatureFlags = {}));
	    function getTransformers(compilerOptions, customTransformers) {
	        var jsx = compilerOptions.jsx;
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var moduleKind = ts.getEmitModuleKind(compilerOptions);
	        var transformers = [];
	        ts.addRange(transformers, customTransformers && customTransformers.before);
	        transformers.push(ts.transformTypeScript);
	        if (jsx === 2 /* React */) {
	            transformers.push(ts.transformJsx);
	        }
	        if (languageVersion < 6 /* ESNext */) {
	            transformers.push(ts.transformESNext);
	        }
	        if (languageVersion < 4 /* ES2017 */) {
	            transformers.push(ts.transformES2017);
	        }
	        if (languageVersion < 3 /* ES2016 */) {
	            transformers.push(ts.transformES2016);
	        }
	        if (languageVersion < 2 /* ES2015 */) {
	            transformers.push(ts.transformES2015);
	            transformers.push(ts.transformGenerators);
	        }
	        transformers.push(getModuleTransformer(moduleKind));
	        // The ES5 transformer is last so that it can substitute expressions like `exports.default`
	        // for ES3.
	        if (languageVersion < 1 /* ES5 */) {
	            transformers.push(ts.transformES5);
	        }
	        ts.addRange(transformers, customTransformers && customTransformers.after);
	        return transformers;
	    }
	    ts.getTransformers = getTransformers;
	    /**
	     * Transforms an array of SourceFiles by passing them through each transformer.
	     *
	     * @param resolver The emit resolver provided by the checker.
	     * @param host The emit host object used to interact with the file system.
	     * @param options Compiler options to surface in the `TransformationContext`.
	     * @param nodes An array of nodes to transform.
	     * @param transforms An array of `TransformerFactory` callbacks.
	     * @param allowDtsFiles A value indicating whether to allow the transformation of .d.ts files.
	     */
	    function transformNodes(resolver, host, options, nodes, transformers, allowDtsFiles) {
	        var enabledSyntaxKindFeatures = new Array(299 /* Count */);
	        var lexicalEnvironmentVariableDeclarations;
	        var lexicalEnvironmentFunctionDeclarations;
	        var lexicalEnvironmentVariableDeclarationsStack = [];
	        var lexicalEnvironmentFunctionDeclarationsStack = [];
	        var lexicalEnvironmentStackOffset = 0;
	        var lexicalEnvironmentSuspended = false;
	        var emitHelpers;
	        var onSubstituteNode = function (_, node) { return node; };
	        var onEmitNode = function (hint, node, callback) { return callback(hint, node); };
	        var state = 0 /* Uninitialized */;
	        // The transformation context is provided to each transformer as part of transformer
	        // initialization.
	        var context = {
	            getCompilerOptions: function () { return options; },
	            getEmitResolver: function () { return resolver; },
	            getEmitHost: function () { return host; },
	            startLexicalEnvironment: startLexicalEnvironment,
	            suspendLexicalEnvironment: suspendLexicalEnvironment,
	            resumeLexicalEnvironment: resumeLexicalEnvironment,
	            endLexicalEnvironment: endLexicalEnvironment,
	            hoistVariableDeclaration: hoistVariableDeclaration,
	            hoistFunctionDeclaration: hoistFunctionDeclaration,
	            requestEmitHelper: requestEmitHelper,
	            readEmitHelpers: readEmitHelpers,
	            enableSubstitution: enableSubstitution,
	            enableEmitNotification: enableEmitNotification,
	            isSubstitutionEnabled: isSubstitutionEnabled,
	            isEmitNotificationEnabled: isEmitNotificationEnabled,
	            get onSubstituteNode() { return onSubstituteNode; },
	            set onSubstituteNode(value) {
	                ts.Debug.assert(state < 1 /* Initialized */, "Cannot modify transformation hooks after initialization has completed.");
	                ts.Debug.assert(value !== undefined, "Value must not be 'undefined'");
	                onSubstituteNode = value;
	            },
	            get onEmitNode() { return onEmitNode; },
	            set onEmitNode(value) {
	                ts.Debug.assert(state < 1 /* Initialized */, "Cannot modify transformation hooks after initialization has completed.");
	                ts.Debug.assert(value !== undefined, "Value must not be 'undefined'");
	                onEmitNode = value;
	            }
	        };
	        // Ensure the parse tree is clean before applying transformations
	        for (var _i = 0, nodes_4 = nodes; _i < nodes_4.length; _i++) {
	            var node = nodes_4[_i];
	            ts.disposeEmitNodes(ts.getSourceFileOfNode(ts.getParseTreeNode(node)));
	        }
	        ts.performance.mark("beforeTransform");
	        // Chain together and initialize each transformer.
	        var transformation = ts.chain.apply(void 0, transformers)(context);
	        // prevent modification of transformation hooks.
	        state = 1 /* Initialized */;
	        // Transform each node.
	        var transformed = ts.map(nodes, allowDtsFiles ? transformation : transformRoot);
	        // prevent modification of the lexical environment.
	        state = 2 /* Completed */;
	        ts.performance.mark("afterTransform");
	        ts.performance.measure("transformTime", "beforeTransform", "afterTransform");
	        return {
	            transformed: transformed,
	            substituteNode: substituteNode,
	            emitNodeWithNotification: emitNodeWithNotification,
	            dispose: dispose
	        };
	        function transformRoot(node) {
	            return node && (!ts.isSourceFile(node) || !node.isDeclarationFile) ? transformation(node) : node;
	        }
	        /**
	         * Enables expression substitutions in the pretty printer for the provided SyntaxKind.
	         */
	        function enableSubstitution(kind) {
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the transformation context after transformation has completed.");
	            enabledSyntaxKindFeatures[kind] |= 1 /* Substitution */;
	        }
	        /**
	         * Determines whether expression substitutions are enabled for the provided node.
	         */
	        function isSubstitutionEnabled(node) {
	            return (enabledSyntaxKindFeatures[node.kind] & 1 /* Substitution */) !== 0
	                && (ts.getEmitFlags(node) & 4 /* NoSubstitution */) === 0;
	        }
	        /**
	         * Emits a node with possible substitution.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback The callback used to emit the node or its substitute.
	         */
	        function substituteNode(hint, node) {
	            ts.Debug.assert(state < 3 /* Disposed */, "Cannot substitute a node after the result is disposed.");
	            return node && isSubstitutionEnabled(node) && onSubstituteNode(hint, node) || node;
	        }
	        /**
	         * Enables before/after emit notifications in the pretty printer for the provided SyntaxKind.
	         */
	        function enableEmitNotification(kind) {
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the transformation context after transformation has completed.");
	            enabledSyntaxKindFeatures[kind] |= 2 /* EmitNotifications */;
	        }
	        /**
	         * Determines whether before/after emit notifications should be raised in the pretty
	         * printer when it emits a node.
	         */
	        function isEmitNotificationEnabled(node) {
	            return (enabledSyntaxKindFeatures[node.kind] & 2 /* EmitNotifications */) !== 0
	                || (ts.getEmitFlags(node) & 2 /* AdviseOnEmitNode */) !== 0;
	        }
	        /**
	         * Emits a node with possible emit notification.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback The callback used to emit the node.
	         */
	        function emitNodeWithNotification(hint, node, emitCallback) {
	            ts.Debug.assert(state < 3 /* Disposed */, "Cannot invoke TransformationResult callbacks after the result is disposed.");
	            if (node) {
	                if (isEmitNotificationEnabled(node)) {
	                    onEmitNode(hint, node, emitCallback);
	                }
	                else {
	                    emitCallback(hint, node);
	                }
	            }
	        }
	        /**
	         * Records a hoisted variable declaration for the provided name within a lexical environment.
	         */
	        function hoistVariableDeclaration(name) {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            var decl = ts.setEmitFlags(ts.createVariableDeclaration(name), 64 /* NoNestedSourceMaps */);
	            if (!lexicalEnvironmentVariableDeclarations) {
	                lexicalEnvironmentVariableDeclarations = [decl];
	            }
	            else {
	                lexicalEnvironmentVariableDeclarations.push(decl);
	            }
	        }
	        /**
	         * Records a hoisted function declaration within a lexical environment.
	         */
	        function hoistFunctionDeclaration(func) {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            if (!lexicalEnvironmentFunctionDeclarations) {
	                lexicalEnvironmentFunctionDeclarations = [func];
	            }
	            else {
	                lexicalEnvironmentFunctionDeclarations.push(func);
	            }
	        }
	        /**
	         * Starts a new lexical environment. Any existing hoisted variable or function declarations
	         * are pushed onto a stack, and the related storage variables are reset.
	         */
	        function startLexicalEnvironment() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            ts.Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is suspended.");
	            // Save the current lexical environment. Rather than resizing the array we adjust the
	            // stack size variable. This allows us to reuse existing array slots we've
	            // already allocated between transformations to avoid allocation and GC overhead during
	            // transformation.
	            lexicalEnvironmentVariableDeclarationsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentVariableDeclarations;
	            lexicalEnvironmentFunctionDeclarationsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentFunctionDeclarations;
	            lexicalEnvironmentStackOffset++;
	            lexicalEnvironmentVariableDeclarations = undefined;
	            lexicalEnvironmentFunctionDeclarations = undefined;
	        }
	        /** Suspends the current lexical environment, usually after visiting a parameter list. */
	        function suspendLexicalEnvironment() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            ts.Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is already suspended.");
	            lexicalEnvironmentSuspended = true;
	        }
	        /** Resumes a suspended lexical environment, usually before visiting a function body. */
	        function resumeLexicalEnvironment() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            ts.Debug.assert(lexicalEnvironmentSuspended, "Lexical environment is not suspended.");
	            lexicalEnvironmentSuspended = false;
	        }
	        /**
	         * Ends a lexical environment. The previous set of hoisted declarations are restored and
	         * any hoisted declarations added in this environment are returned.
	         */
	        function endLexicalEnvironment() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            ts.Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is suspended.");
	            var statements;
	            if (lexicalEnvironmentVariableDeclarations || lexicalEnvironmentFunctionDeclarations) {
	                if (lexicalEnvironmentFunctionDeclarations) {
	                    statements = lexicalEnvironmentFunctionDeclarations.slice();
	                }
	                if (lexicalEnvironmentVariableDeclarations) {
	                    var statement = ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.createVariableDeclarationList(lexicalEnvironmentVariableDeclarations));
	                    if (!statements) {
	                        statements = [statement];
	                    }
	                    else {
	                        statements.push(statement);
	                    }
	                }
	            }
	            // Restore the previous lexical environment.
	            lexicalEnvironmentStackOffset--;
	            lexicalEnvironmentVariableDeclarations = lexicalEnvironmentVariableDeclarationsStack[lexicalEnvironmentStackOffset];
	            lexicalEnvironmentFunctionDeclarations = lexicalEnvironmentFunctionDeclarationsStack[lexicalEnvironmentStackOffset];
	            if (lexicalEnvironmentStackOffset === 0) {
	                lexicalEnvironmentVariableDeclarationsStack = [];
	                lexicalEnvironmentFunctionDeclarationsStack = [];
	            }
	            return statements;
	        }
	        function requestEmitHelper(helper) {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the transformation context during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the transformation context after transformation has completed.");
	            ts.Debug.assert(!helper.scoped, "Cannot request a scoped emit helper.");
	            emitHelpers = ts.append(emitHelpers, helper);
	        }
	        function readEmitHelpers() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the transformation context during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the transformation context after transformation has completed.");
	            var helpers = emitHelpers;
	            emitHelpers = undefined;
	            return helpers;
	        }
	        function dispose() {
	            if (state < 3 /* Disposed */) {
	                // Clean up emit nodes on parse tree
	                for (var _i = 0, nodes_5 = nodes; _i < nodes_5.length; _i++) {
	                    var node = nodes_5[_i];
	                    ts.disposeEmitNodes(ts.getSourceFileOfNode(ts.getParseTreeNode(node)));
	                }
	                // Release references to external entries for GC purposes.
	                lexicalEnvironmentVariableDeclarations = undefined;
	                lexicalEnvironmentVariableDeclarationsStack = undefined;
	                lexicalEnvironmentFunctionDeclarations = undefined;
	                lexicalEnvironmentFunctionDeclarationsStack = undefined;
	                onSubstituteNode = undefined;
	                onEmitNode = undefined;
	                emitHelpers = undefined;
	                // Prevent further use of the transformation result.
	                state = 3 /* Disposed */;
	            }
	        }
	    }
	    ts.transformNodes = transformNodes;
	})(ts || (ts = {}));
	/// <reference path="checker.ts"/>
	/* @internal */
	var ts;
	(function (ts) {
	    // Used for initialize lastEncodedSourceMapSpan and reset lastEncodedSourceMapSpan when updateLastEncodedAndRecordedSpans
	    var defaultLastEncodedSourceMapSpan = {
	        emittedLine: 1,
	        emittedColumn: 1,
	        sourceLine: 1,
	        sourceColumn: 1,
	        sourceIndex: 0
	    };
	    function createSourceMapWriter(host, writer) {
	        var compilerOptions = host.getCompilerOptions();
	        var extendedDiagnostics = compilerOptions.extendedDiagnostics;
	        var currentSource;
	        var currentSourceText;
	        var sourceMapDir; // The directory in which sourcemap will be
	        // Current source map file and its index in the sources list
	        var sourceMapSourceIndex;
	        // Last recorded and encoded spans
	        var lastRecordedSourceMapSpan;
	        var lastEncodedSourceMapSpan;
	        var lastEncodedNameIndex;
	        // Source map data
	        var sourceMapData;
	        var disabled = !(compilerOptions.sourceMap || compilerOptions.inlineSourceMap);
	        return {
	            initialize: initialize,
	            reset: reset,
	            getSourceMapData: function () { return sourceMapData; },
	            setSourceFile: setSourceFile,
	            emitPos: emitPos,
	            emitNodeWithSourceMap: emitNodeWithSourceMap,
	            emitTokenWithSourceMap: emitTokenWithSourceMap,
	            getText: getText,
	            getSourceMappingURL: getSourceMappingURL,
	        };
	        /**
	         * Skips trivia such as comments and white-space that can optionally overriden by the source map source
	         */
	        function skipSourceTrivia(pos) {
	            return currentSource.skipTrivia ? currentSource.skipTrivia(pos) : ts.skipTrivia(currentSourceText, pos);
	        }
	        /**
	         * Initialize the SourceMapWriter for a new output file.
	         *
	         * @param filePath The path to the generated output file.
	         * @param sourceMapFilePath The path to the output source map file.
	         * @param sourceFileOrBundle The input source file or bundle for the program.
	         */
	        function initialize(filePath, sourceMapFilePath, sourceFileOrBundle) {
	            if (disabled) {
	                return;
	            }
	            if (sourceMapData) {
	                reset();
	            }
	            currentSource = undefined;
	            currentSourceText = undefined;
	            // Current source map file and its index in the sources list
	            sourceMapSourceIndex = -1;
	            // Last recorded and encoded spans
	            lastRecordedSourceMapSpan = undefined;
	            lastEncodedSourceMapSpan = defaultLastEncodedSourceMapSpan;
	            lastEncodedNameIndex = 0;
	            // Initialize source map data
	            sourceMapData = {
	                sourceMapFilePath: sourceMapFilePath,
	                jsSourceMappingURL: !compilerOptions.inlineSourceMap ? ts.getBaseFileName(ts.normalizeSlashes(sourceMapFilePath)) : undefined,
	                sourceMapFile: ts.getBaseFileName(ts.normalizeSlashes(filePath)),
	                sourceMapSourceRoot: compilerOptions.sourceRoot || "",
	                sourceMapSources: [],
	                inputSourceFileNames: [],
	                sourceMapNames: [],
	                sourceMapMappings: "",
	                sourceMapSourcesContent: compilerOptions.inlineSources ? [] : undefined,
	                sourceMapDecodedMappings: []
	            };
	            // Normalize source root and make sure it has trailing "/" so that it can be used to combine paths with the
	            // relative paths of the sources list in the sourcemap
	            sourceMapData.sourceMapSourceRoot = ts.normalizeSlashes(sourceMapData.sourceMapSourceRoot);
	            if (sourceMapData.sourceMapSourceRoot.length && sourceMapData.sourceMapSourceRoot.charCodeAt(sourceMapData.sourceMapSourceRoot.length - 1) !== 47 /* slash */) {
	                sourceMapData.sourceMapSourceRoot += ts.directorySeparator;
	            }
	            if (compilerOptions.mapRoot) {
	                sourceMapDir = ts.normalizeSlashes(compilerOptions.mapRoot);
	                if (sourceFileOrBundle.kind === 272 /* SourceFile */) {
	                    // For modules or multiple emit files the mapRoot will have directory structure like the sources
	                    // So if src\a.ts and src\lib\b.ts are compiled together user would be moving the maps into mapRoot\a.js.map and mapRoot\lib\b.js.map
	                    sourceMapDir = ts.getDirectoryPath(ts.getSourceFilePathInNewDir(sourceFileOrBundle, host, sourceMapDir));
	                }
	                if (!ts.isRootedDiskPath(sourceMapDir) && !ts.isUrl(sourceMapDir)) {
	                    // The relative paths are relative to the common directory
	                    sourceMapDir = ts.combinePaths(host.getCommonSourceDirectory(), sourceMapDir);
	                    sourceMapData.jsSourceMappingURL = ts.getRelativePathToDirectoryOrUrl(ts.getDirectoryPath(ts.normalizePath(filePath)), // get the relative sourceMapDir path based on jsFilePath
	                    ts.combinePaths(sourceMapDir, sourceMapData.jsSourceMappingURL), // this is where user expects to see sourceMap
	                    host.getCurrentDirectory(), host.getCanonicalFileName, 
	                    /*isAbsolutePathAnUrl*/ true);
	                }
	                else {
	                    sourceMapData.jsSourceMappingURL = ts.combinePaths(sourceMapDir, sourceMapData.jsSourceMappingURL);
	                }
	            }
	            else {
	                sourceMapDir = ts.getDirectoryPath(ts.normalizePath(filePath));
	            }
	        }
	        /**
	         * Reset the SourceMapWriter to an empty state.
	         */
	        function reset() {
	            if (disabled) {
	                return;
	            }
	            currentSource = undefined;
	            sourceMapDir = undefined;
	            sourceMapSourceIndex = undefined;
	            lastRecordedSourceMapSpan = undefined;
	            lastEncodedSourceMapSpan = undefined;
	            lastEncodedNameIndex = undefined;
	            sourceMapData = undefined;
	        }
	        // Encoding for sourcemap span
	        function encodeLastRecordedSourceMapSpan() {
	            if (!lastRecordedSourceMapSpan || lastRecordedSourceMapSpan === lastEncodedSourceMapSpan) {
	                return;
	            }
	            var prevEncodedEmittedColumn = lastEncodedSourceMapSpan.emittedColumn;
	            // Line/Comma delimiters
	            if (lastEncodedSourceMapSpan.emittedLine === lastRecordedSourceMapSpan.emittedLine) {
	                // Emit comma to separate the entry
	                if (sourceMapData.sourceMapMappings) {
	                    sourceMapData.sourceMapMappings += ",";
	                }
	            }
	            else {
	                // Emit line delimiters
	                for (var encodedLine = lastEncodedSourceMapSpan.emittedLine; encodedLine < lastRecordedSourceMapSpan.emittedLine; encodedLine++) {
	                    sourceMapData.sourceMapMappings += ";";
	                }
	                prevEncodedEmittedColumn = 1;
	            }
	            // 1. Relative Column 0 based
	            sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.emittedColumn - prevEncodedEmittedColumn);
	            // 2. Relative sourceIndex
	            sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.sourceIndex - lastEncodedSourceMapSpan.sourceIndex);
	            // 3. Relative sourceLine 0 based
	            sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.sourceLine - lastEncodedSourceMapSpan.sourceLine);
	            // 4. Relative sourceColumn 0 based
	            sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.sourceColumn - lastEncodedSourceMapSpan.sourceColumn);
	            // 5. Relative namePosition 0 based
	            if (lastRecordedSourceMapSpan.nameIndex >= 0) {
	                ts.Debug.assert(false, "We do not support name index right now, Make sure to update updateLastEncodedAndRecordedSpans when we start using this");
	                sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.nameIndex - lastEncodedNameIndex);
	                lastEncodedNameIndex = lastRecordedSourceMapSpan.nameIndex;
	            }
	            lastEncodedSourceMapSpan = lastRecordedSourceMapSpan;
	            sourceMapData.sourceMapDecodedMappings.push(lastEncodedSourceMapSpan);
	        }
	        /**
	         * Emits a mapping.
	         *
	         * If the position is synthetic (undefined or a negative value), no mapping will be
	         * created.
	         *
	         * @param pos The position.
	         */
	        function emitPos(pos) {
	            if (disabled || ts.positionIsSynthesized(pos)) {
	                return;
	            }
	            if (extendedDiagnostics) {
	                ts.performance.mark("beforeSourcemap");
	            }
	            var sourceLinePos = ts.getLineAndCharacterOfPosition(currentSource, pos);
	            // Convert the location to be one-based.
	            sourceLinePos.line++;
	            sourceLinePos.character++;
	            var emittedLine = writer.getLine();
	            var emittedColumn = writer.getColumn();
	            // If this location wasn't recorded or the location in source is going backwards, record the span
	            if (!lastRecordedSourceMapSpan ||
	                lastRecordedSourceMapSpan.emittedLine !== emittedLine ||
	                lastRecordedSourceMapSpan.emittedColumn !== emittedColumn ||
	                (lastRecordedSourceMapSpan.sourceIndex === sourceMapSourceIndex &&
	                    (lastRecordedSourceMapSpan.sourceLine > sourceLinePos.line ||
	                        (lastRecordedSourceMapSpan.sourceLine === sourceLinePos.line && lastRecordedSourceMapSpan.sourceColumn > sourceLinePos.character)))) {
	                // Encode the last recordedSpan before assigning new
	                encodeLastRecordedSourceMapSpan();
	                // New span
	                lastRecordedSourceMapSpan = {
	                    emittedLine: emittedLine,
	                    emittedColumn: emittedColumn,
	                    sourceLine: sourceLinePos.line,
	                    sourceColumn: sourceLinePos.character,
	                    sourceIndex: sourceMapSourceIndex
	                };
	            }
	            else {
	                // Take the new pos instead since there is no change in emittedLine and column since last location
	                lastRecordedSourceMapSpan.sourceLine = sourceLinePos.line;
	                lastRecordedSourceMapSpan.sourceColumn = sourceLinePos.character;
	                lastRecordedSourceMapSpan.sourceIndex = sourceMapSourceIndex;
	            }
	            if (extendedDiagnostics) {
	                ts.performance.mark("afterSourcemap");
	                ts.performance.measure("Source Map", "beforeSourcemap", "afterSourcemap");
	            }
	        }
	        /**
	         * Emits a node with possible leading and trailing source maps.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback The callback used to emit the node.
	         */
	        function emitNodeWithSourceMap(hint, node, emitCallback) {
	            if (disabled) {
	                return emitCallback(hint, node);
	            }
	            if (node) {
	                var emitNode = node.emitNode;
	                var emitFlags = emitNode && emitNode.flags;
	                var range = emitNode && emitNode.sourceMapRange;
	                var _a = range || node, pos = _a.pos, end = _a.end;
	                var source = range && range.source;
	                var oldSource = currentSource;
	                if (source === oldSource)
	                    source = undefined;
	                if (source)
	                    setSourceFile(source);
	                if (node.kind !== 294 /* NotEmittedStatement */
	                    && (emitFlags & 16 /* NoLeadingSourceMap */) === 0
	                    && pos >= 0) {
	                    emitPos(skipSourceTrivia(pos));
	                }
	                if (source)
	                    setSourceFile(oldSource);
	                if (emitFlags & 64 /* NoNestedSourceMaps */) {
	                    disabled = true;
	                    emitCallback(hint, node);
	                    disabled = false;
	                }
	                else {
	                    emitCallback(hint, node);
	                }
	                if (source)
	                    setSourceFile(source);
	                if (node.kind !== 294 /* NotEmittedStatement */
	                    && (emitFlags & 32 /* NoTrailingSourceMap */) === 0
	                    && end >= 0) {
	                    emitPos(end);
	                }
	                if (source)
	                    setSourceFile(oldSource);
	            }
	        }
	        /**
	         * Emits a token of a node with possible leading and trailing source maps.
	         *
	         * @param node The node containing the token.
	         * @param token The token to emit.
	         * @param tokenStartPos The start pos of the token.
	         * @param emitCallback The callback used to emit the token.
	         */
	        function emitTokenWithSourceMap(node, token, writer, tokenPos, emitCallback) {
	            if (disabled) {
	                return emitCallback(token, writer, tokenPos);
	            }
	            var emitNode = node && node.emitNode;
	            var emitFlags = emitNode && emitNode.flags;
	            var range = emitNode && emitNode.tokenSourceMapRanges && emitNode.tokenSourceMapRanges[token];
	            tokenPos = skipSourceTrivia(range ? range.pos : tokenPos);
	            if ((emitFlags & 128 /* NoTokenLeadingSourceMaps */) === 0 && tokenPos >= 0) {
	                emitPos(tokenPos);
	            }
	            tokenPos = emitCallback(token, writer, tokenPos);
	            if (range)
	                tokenPos = range.end;
	            if ((emitFlags & 256 /* NoTokenTrailingSourceMaps */) === 0 && tokenPos >= 0) {
	                emitPos(tokenPos);
	            }
	            return tokenPos;
	        }
	        /**
	         * Set the current source file.
	         *
	         * @param sourceFile The source file.
	         */
	        function setSourceFile(sourceFile) {
	            if (disabled) {
	                return;
	            }
	            currentSource = sourceFile;
	            currentSourceText = currentSource.text;
	            // Add the file to tsFilePaths
	            // If sourceroot option: Use the relative path corresponding to the common directory path
	            // otherwise source locations relative to map file location
	            var sourcesDirectoryPath = compilerOptions.sourceRoot ? host.getCommonSourceDirectory() : sourceMapDir;
	            var source = ts.getRelativePathToDirectoryOrUrl(sourcesDirectoryPath, currentSource.fileName, host.getCurrentDirectory(), host.getCanonicalFileName, 
	            /*isAbsolutePathAnUrl*/ true);
	            sourceMapSourceIndex = sourceMapData.sourceMapSources.indexOf(source);
	            if (sourceMapSourceIndex === -1) {
	                sourceMapSourceIndex = sourceMapData.sourceMapSources.length;
	                sourceMapData.sourceMapSources.push(source);
	                // The one that can be used from program to get the actual source file
	                sourceMapData.inputSourceFileNames.push(currentSource.fileName);
	                if (compilerOptions.inlineSources) {
	                    sourceMapData.sourceMapSourcesContent.push(currentSource.text);
	                }
	            }
	        }
	        /**
	         * Gets the text for the source map.
	         */
	        function getText() {
	            if (disabled) {
	                return;
	            }
	            encodeLastRecordedSourceMapSpan();
	            return JSON.stringify({
	                version: 3,
	                file: sourceMapData.sourceMapFile,
	                sourceRoot: sourceMapData.sourceMapSourceRoot,
	                sources: sourceMapData.sourceMapSources,
	                names: sourceMapData.sourceMapNames,
	                mappings: sourceMapData.sourceMapMappings,
	                sourcesContent: sourceMapData.sourceMapSourcesContent,
	            });
	        }
	        /**
	         * Gets the SourceMappingURL for the source map.
	         */
	        function getSourceMappingURL() {
	            if (disabled) {
	                return;
	            }
	            if (compilerOptions.inlineSourceMap) {
	                // Encode the sourceMap into the sourceMap url
	                var base64SourceMapText = ts.convertToBase64(getText());
	                return sourceMapData.jsSourceMappingURL = "data:application/json;base64," + base64SourceMapText;
	            }
	            else {
	                return sourceMapData.jsSourceMappingURL;
	            }
	        }
	    }
	    ts.createSourceMapWriter = createSourceMapWriter;
	    var base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	    function base64FormatEncode(inValue) {
	        if (inValue < 64) {
	            return base64Chars.charAt(inValue);
	        }
	        throw TypeError(inValue + ": not a 64 based value");
	    }
	    function base64VLQFormatEncode(inValue) {
	        // Add a new least significant bit that has the sign of the value.
	        // if negative number the least significant bit that gets added to the number has value 1
	        // else least significant bit value that gets added is 0
	        // eg. -1 changes to binary : 01 [1] => 3
	        //     +1 changes to binary : 01 [0] => 2
	        if (inValue < 0) {
	            inValue = ((-inValue) << 1) + 1;
	        }
	        else {
	            inValue = inValue << 1;
	        }
	        // Encode 5 bits at a time starting from least significant bits
	        var encodedStr = "";
	        do {
	            var currentDigit = inValue & 31; // 11111
	            inValue = inValue >> 5;
	            if (inValue > 0) {
	                // There are still more digits to decode, set the msb (6th bit)
	                currentDigit = currentDigit | 32;
	            }
	            encodedStr = encodedStr + base64FormatEncode(currentDigit);
	        } while (inValue > 0);
	        return encodedStr;
	    }
	})(ts || (ts = {}));
	/// <reference path="sourcemap.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    function createCommentWriter(printerOptions, emitPos) {
	        var extendedDiagnostics = printerOptions.extendedDiagnostics;
	        var newLine = ts.getNewLineCharacter(printerOptions);
	        var writer;
	        var containerPos = -1;
	        var containerEnd = -1;
	        var declarationListContainerEnd = -1;
	        var currentSourceFile;
	        var currentText;
	        var currentLineMap;
	        var detachedCommentsInfo;
	        var hasWrittenComment = false;
	        var disabled = printerOptions.removeComments;
	        return {
	            reset: reset,
	            setWriter: setWriter,
	            setSourceFile: setSourceFile,
	            emitNodeWithComments: emitNodeWithComments,
	            emitBodyWithDetachedComments: emitBodyWithDetachedComments,
	            emitTrailingCommentsOfPosition: emitTrailingCommentsOfPosition,
	            emitLeadingCommentsOfPosition: emitLeadingCommentsOfPosition,
	        };
	        function emitNodeWithComments(hint, node, emitCallback) {
	            if (disabled) {
	                emitCallback(hint, node);
	                return;
	            }
	            if (node) {
	                hasWrittenComment = false;
	                var emitNode = node.emitNode;
	                var emitFlags = emitNode && emitNode.flags;
	                var _a = emitNode && emitNode.commentRange || node, pos = _a.pos, end = _a.end;
	                if ((pos < 0 && end < 0) || (pos === end)) {
	                    // Both pos and end are synthesized, so just emit the node without comments.
	                    emitNodeWithSynthesizedComments(hint, node, emitNode, emitFlags, emitCallback);
	                }
	                else {
	                    if (extendedDiagnostics) {
	                        ts.performance.mark("preEmitNodeWithComment");
	                    }
	                    var isEmittedNode = node.kind !== 294 /* NotEmittedStatement */;
	                    // We have to explicitly check that the node is JsxText because if the compilerOptions.jsx is "preserve" we will not do any transformation.
	                    // It is expensive to walk entire tree just to set one kind of node to have no comments.
	                    var skipLeadingComments = pos < 0 || (emitFlags & 512 /* NoLeadingComments */) !== 0 || node.kind === 10 /* JsxText */;
	                    var skipTrailingComments = end < 0 || (emitFlags & 1024 /* NoTrailingComments */) !== 0 || node.kind === 10 /* JsxText */;
	                    // Emit leading comments if the position is not synthesized and the node
	                    // has not opted out from emitting leading comments.
	                    if (!skipLeadingComments) {
	                        emitLeadingComments(pos, isEmittedNode);
	                    }
	                    // Save current container state on the stack.
	                    var savedContainerPos = containerPos;
	                    var savedContainerEnd = containerEnd;
	                    var savedDeclarationListContainerEnd = declarationListContainerEnd;
	                    if (!skipLeadingComments) {
	                        containerPos = pos;
	                    }
	                    if (!skipTrailingComments) {
	                        containerEnd = end;
	                        // To avoid invalid comment emit in a down-level binding pattern, we
	                        // keep track of the last declaration list container's end
	                        if (node.kind === 231 /* VariableDeclarationList */) {
	                            declarationListContainerEnd = end;
	                        }
	                    }
	                    if (extendedDiagnostics) {
	                        ts.performance.measure("commentTime", "preEmitNodeWithComment");
	                    }
	                    emitNodeWithSynthesizedComments(hint, node, emitNode, emitFlags, emitCallback);
	                    if (extendedDiagnostics) {
	                        ts.performance.mark("postEmitNodeWithComment");
	                    }
	                    // Restore previous container state.
	                    containerPos = savedContainerPos;
	                    containerEnd = savedContainerEnd;
	                    declarationListContainerEnd = savedDeclarationListContainerEnd;
	                    // Emit trailing comments if the position is not synthesized and the node
	                    // has not opted out from emitting leading comments and is an emitted node.
	                    if (!skipTrailingComments && isEmittedNode) {
	                        emitTrailingComments(end);
	                    }
	                    if (extendedDiagnostics) {
	                        ts.performance.measure("commentTime", "postEmitNodeWithComment");
	                    }
	                }
	            }
	        }
	        function emitNodeWithSynthesizedComments(hint, node, emitNode, emitFlags, emitCallback) {
	            var leadingComments = emitNode && emitNode.leadingComments;
	            if (ts.some(leadingComments)) {
	                if (extendedDiagnostics) {
	                    ts.performance.mark("preEmitNodeWithSynthesizedComments");
	                }
	                ts.forEach(leadingComments, emitLeadingSynthesizedComment);
	                if (extendedDiagnostics) {
	                    ts.performance.measure("commentTime", "preEmitNodeWithSynthesizedComments");
	                }
	            }
	            emitNodeWithNestedComments(hint, node, emitFlags, emitCallback);
	            var trailingComments = emitNode && emitNode.trailingComments;
	            if (ts.some(trailingComments)) {
	                if (extendedDiagnostics) {
	                    ts.performance.mark("postEmitNodeWithSynthesizedComments");
	                }
	                ts.forEach(trailingComments, emitTrailingSynthesizedComment);
	                if (extendedDiagnostics) {
	                    ts.performance.measure("commentTime", "postEmitNodeWithSynthesizedComments");
	                }
	            }
	        }
	        function emitLeadingSynthesizedComment(comment) {
	            if (comment.kind === 2 /* SingleLineCommentTrivia */) {
	                writer.writeLine();
	            }
	            writeSynthesizedComment(comment);
	            if (comment.hasTrailingNewLine || comment.kind === 2 /* SingleLineCommentTrivia */) {
	                writer.writeLine();
	            }
	            else {
	                writer.write(" ");
	            }
	        }
	        function emitTrailingSynthesizedComment(comment) {
	            if (!writer.isAtStartOfLine()) {
	                writer.write(" ");
	            }
	            writeSynthesizedComment(comment);
	            if (comment.hasTrailingNewLine) {
	                writer.writeLine();
	            }
	        }
	        function writeSynthesizedComment(comment) {
	            var text = formatSynthesizedComment(comment);
	            var lineMap = comment.kind === 3 /* MultiLineCommentTrivia */ ? ts.computeLineStarts(text) : undefined;
	            ts.writeCommentRange(text, lineMap, writer, 0, text.length, newLine);
	        }
	        function formatSynthesizedComment(comment) {
	            return comment.kind === 3 /* MultiLineCommentTrivia */
	                ? "/*" + comment.text + "*/"
	                : "//" + comment.text;
	        }
	        function emitNodeWithNestedComments(hint, node, emitFlags, emitCallback) {
	            if (emitFlags & 2048 /* NoNestedComments */) {
	                disabled = true;
	                emitCallback(hint, node);
	                disabled = false;
	            }
	            else {
	                emitCallback(hint, node);
	            }
	        }
	        function emitBodyWithDetachedComments(node, detachedRange, emitCallback) {
	            if (extendedDiagnostics) {
	                ts.performance.mark("preEmitBodyWithDetachedComments");
	            }
	            var pos = detachedRange.pos, end = detachedRange.end;
	            var emitFlags = ts.getEmitFlags(node);
	            var skipLeadingComments = pos < 0 || (emitFlags & 512 /* NoLeadingComments */) !== 0;
	            var skipTrailingComments = disabled || end < 0 || (emitFlags & 1024 /* NoTrailingComments */) !== 0;
	            if (!skipLeadingComments) {
	                emitDetachedCommentsAndUpdateCommentsInfo(detachedRange);
	            }
	            if (extendedDiagnostics) {
	                ts.performance.measure("commentTime", "preEmitBodyWithDetachedComments");
	            }
	            if (emitFlags & 2048 /* NoNestedComments */ && !disabled) {
	                disabled = true;
	                emitCallback(node);
	                disabled = false;
	            }
	            else {
	                emitCallback(node);
	            }
	            if (extendedDiagnostics) {
	                ts.performance.mark("beginEmitBodyWithDetachedCommetns");
	            }
	            if (!skipTrailingComments) {
	                emitLeadingComments(detachedRange.end, /*isEmittedNode*/ true);
	                if (hasWrittenComment && !writer.isAtStartOfLine()) {
	                    writer.writeLine();
	                }
	            }
	            if (extendedDiagnostics) {
	                ts.performance.measure("commentTime", "beginEmitBodyWithDetachedCommetns");
	            }
	        }
	        function emitLeadingComments(pos, isEmittedNode) {
	            hasWrittenComment = false;
	            if (isEmittedNode) {
	                forEachLeadingCommentToEmit(pos, emitLeadingComment);
	            }
	            else if (pos === 0) {
	                // If the node will not be emitted in JS, remove all the comments(normal, pinned and ///) associated with the node,
	                // unless it is a triple slash comment at the top of the file.
	                // For Example:
	                //      /// <reference-path ...>
	                //      declare var x;
	                //      /// <reference-path ...>
	                //      interface F {}
	                //  The first /// will NOT be removed while the second one will be removed even though both node will not be emitted
	                forEachLeadingCommentToEmit(pos, emitTripleSlashLeadingComment);
	            }
	        }
	        function emitTripleSlashLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
	            if (isTripleSlashComment(commentPos, commentEnd)) {
	                emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos);
	            }
	        }
	        function emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
	            if (!hasWrittenComment) {
	                ts.emitNewLineBeforeLeadingCommentOfPosition(currentLineMap, writer, rangePos, commentPos);
	                hasWrittenComment = true;
	            }
	            // Leading comments are emitted at /*leading comment1 */space/*leading comment*/space
	            if (emitPos)
	                emitPos(commentPos);
	            ts.writeCommentRange(currentText, currentLineMap, writer, commentPos, commentEnd, newLine);
	            if (emitPos)
	                emitPos(commentEnd);
	            if (hasTrailingNewLine) {
	                writer.writeLine();
	            }
	            else if (kind === 3 /* MultiLineCommentTrivia */) {
	                writer.write(" ");
	            }
	        }
	        function emitLeadingCommentsOfPosition(pos) {
	            if (disabled || pos === -1) {
	                return;
	            }
	            emitLeadingComments(pos, /*isEmittedNode*/ true);
	        }
	        function emitTrailingComments(pos) {
	            forEachTrailingCommentToEmit(pos, emitTrailingComment);
	        }
	        function emitTrailingComment(commentPos, commentEnd, _kind, hasTrailingNewLine) {
	            // trailing comments are emitted at space/*trailing comment1 */space/*trailing comment2*/
	            if (!writer.isAtStartOfLine()) {
	                writer.write(" ");
	            }
	            if (emitPos)
	                emitPos(commentPos);
	            ts.writeCommentRange(currentText, currentLineMap, writer, commentPos, commentEnd, newLine);
	            if (emitPos)
	                emitPos(commentEnd);
	            if (hasTrailingNewLine) {
	                writer.writeLine();
	            }
	        }
	        function emitTrailingCommentsOfPosition(pos, prefixSpace) {
	            if (disabled) {
	                return;
	            }
	            if (extendedDiagnostics) {
	                ts.performance.mark("beforeEmitTrailingCommentsOfPosition");
	            }
	            forEachTrailingCommentToEmit(pos, prefixSpace ? emitTrailingComment : emitTrailingCommentOfPosition);
	            if (extendedDiagnostics) {
	                ts.performance.measure("commentTime", "beforeEmitTrailingCommentsOfPosition");
	            }
	        }
	        function emitTrailingCommentOfPosition(commentPos, commentEnd, _kind, hasTrailingNewLine) {
	            // trailing comments of a position are emitted at /*trailing comment1 */space/*trailing comment*/space
	            if (emitPos)
	                emitPos(commentPos);
	            ts.writeCommentRange(currentText, currentLineMap, writer, commentPos, commentEnd, newLine);
	            if (emitPos)
	                emitPos(commentEnd);
	            if (hasTrailingNewLine) {
	                writer.writeLine();
	            }
	            else {
	                writer.write(" ");
	            }
	        }
	        function forEachLeadingCommentToEmit(pos, cb) {
	            // Emit the leading comments only if the container's pos doesn't match because the container should take care of emitting these comments
	            if (containerPos === -1 || pos !== containerPos) {
	                if (hasDetachedComments(pos)) {
	                    forEachLeadingCommentWithoutDetachedComments(cb);
	                }
	                else {
	                    ts.forEachLeadingCommentRange(currentText, pos, cb, /*state*/ pos);
	                }
	            }
	        }
	        function forEachTrailingCommentToEmit(end, cb) {
	            // Emit the trailing comments only if the container's end doesn't match because the container should take care of emitting these comments
	            if (containerEnd === -1 || (end !== containerEnd && end !== declarationListContainerEnd)) {
	                ts.forEachTrailingCommentRange(currentText, end, cb);
	            }
	        }
	        function reset() {
	            currentSourceFile = undefined;
	            currentText = undefined;
	            currentLineMap = undefined;
	            detachedCommentsInfo = undefined;
	        }
	        function setWriter(output) {
	            writer = output;
	        }
	        function setSourceFile(sourceFile) {
	            currentSourceFile = sourceFile;
	            currentText = currentSourceFile.text;
	            currentLineMap = ts.getLineStarts(currentSourceFile);
	            detachedCommentsInfo = undefined;
	        }
	        function hasDetachedComments(pos) {
	            return detachedCommentsInfo !== undefined && ts.lastOrUndefined(detachedCommentsInfo).nodePos === pos;
	        }
	        function forEachLeadingCommentWithoutDetachedComments(cb) {
	            // get the leading comments from detachedPos
	            var pos = ts.lastOrUndefined(detachedCommentsInfo).detachedCommentEndPos;
	            if (detachedCommentsInfo.length - 1) {
	                detachedCommentsInfo.pop();
	            }
	            else {
	                detachedCommentsInfo = undefined;
	            }
	            ts.forEachLeadingCommentRange(currentText, pos, cb, /*state*/ pos);
	        }
	        function emitDetachedCommentsAndUpdateCommentsInfo(range) {
	            var currentDetachedCommentInfo = ts.emitDetachedComments(currentText, currentLineMap, writer, writeComment, range, newLine, disabled);
	            if (currentDetachedCommentInfo) {
	                if (detachedCommentsInfo) {
	                    detachedCommentsInfo.push(currentDetachedCommentInfo);
	                }
	                else {
	                    detachedCommentsInfo = [currentDetachedCommentInfo];
	                }
	            }
	        }
	        function writeComment(text, lineMap, writer, commentPos, commentEnd, newLine) {
	            if (emitPos)
	                emitPos(commentPos);
	            ts.writeCommentRange(text, lineMap, writer, commentPos, commentEnd, newLine);
	            if (emitPos)
	                emitPos(commentEnd);
	        }
	        /**
	         * Determine if the given comment is a triple-slash
	         *
	         * @return true if the comment is a triple-slash comment else false
	         */
	        function isTripleSlashComment(commentPos, commentEnd) {
	            return ts.isRecognizedTripleSlashComment(currentText, commentPos, commentEnd);
	        }
	    }
	    ts.createCommentWriter = createCommentWriter;
	})(ts || (ts = {}));
	/// <reference path="checker.ts"/>
	/* @internal */
	var ts;
	(function (ts) {
	    function getDeclarationDiagnostics(host, resolver, targetSourceFile) {
	        var declarationDiagnostics = ts.createDiagnosticCollection();
	        ts.forEachEmittedFile(host, getDeclarationDiagnosticsFromFile, targetSourceFile);
	        return declarationDiagnostics.getDiagnostics(targetSourceFile ? targetSourceFile.fileName : undefined);
	        function getDeclarationDiagnosticsFromFile(_a, sourceFileOrBundle) {
	            var declarationFilePath = _a.declarationFilePath;
	            emitDeclarations(host, resolver, declarationDiagnostics, declarationFilePath, sourceFileOrBundle, /*emitOnlyDtsFiles*/ false);
	        }
	    }
	    ts.getDeclarationDiagnostics = getDeclarationDiagnostics;
	    function emitDeclarations(host, resolver, emitterDiagnostics, declarationFilePath, sourceFileOrBundle, emitOnlyDtsFiles) {
	        var sourceFiles = sourceFileOrBundle.kind === 273 /* Bundle */ ? sourceFileOrBundle.sourceFiles : [sourceFileOrBundle];
	        var isBundledEmit = sourceFileOrBundle.kind === 273 /* Bundle */;
	        var newLine = host.getNewLine();
	        var compilerOptions = host.getCompilerOptions();
	        var write;
	        var writeLine;
	        var increaseIndent;
	        var decreaseIndent;
	        var writeTextOfNode;
	        var writer;
	        createAndSetNewTextWriterWithSymbolWriter();
	        var enclosingDeclaration;
	        var resultHasExternalModuleIndicator;
	        var currentText;
	        var currentLineMap;
	        var currentIdentifiers;
	        var isCurrentFileExternalModule;
	        var reportedDeclarationError = false;
	        var errorNameNode;
	        var emitJsDocComments = compilerOptions.removeComments ? ts.noop : writeJsDocComments;
	        var emit = compilerOptions.stripInternal ? stripInternal : emitNode;
	        var needsDeclare = true;
	        var moduleElementDeclarationEmitInfo = [];
	        var asynchronousSubModuleDeclarationEmitInfo;
	        // Contains the reference paths that needs to go in the declaration file.
	        // Collecting this separately because reference paths need to be first thing in the declaration file
	        // and we could be collecting these paths from multiple files into single one with --out option
	        var referencesOutput = "";
	        var usedTypeDirectiveReferences;
	        // Emit references corresponding to each file
	        var emittedReferencedFiles = [];
	        var addedGlobalFileReference = false;
	        var allSourcesModuleElementDeclarationEmitInfo = [];
	        ts.forEach(sourceFiles, function (sourceFile) {
	            // Dont emit for javascript file
	            if (ts.isSourceFileJavaScript(sourceFile)) {
	                return;
	            }
	            // Check what references need to be added
	            if (!compilerOptions.noResolve) {
	                ts.forEach(sourceFile.referencedFiles, function (fileReference) {
	                    var referencedFile = ts.tryResolveScriptReference(host, sourceFile, fileReference);
	                    // Emit reference in dts, if the file reference was not already emitted
	                    if (referencedFile && !ts.contains(emittedReferencedFiles, referencedFile)) {
	                        // Add a reference to generated dts file,
	                        // global file reference is added only
	                        //  - if it is not bundled emit (because otherwise it would be self reference)
	                        //  - and it is not already added
	                        if (writeReferencePath(referencedFile, !isBundledEmit && !addedGlobalFileReference, emitOnlyDtsFiles)) {
	                            addedGlobalFileReference = true;
	                        }
	                        emittedReferencedFiles.push(referencedFile);
	                    }
	                });
	            }
	            resultHasExternalModuleIndicator = false;
	            if (!isBundledEmit || !ts.isExternalModule(sourceFile)) {
	                needsDeclare = true;
	                emitSourceFile(sourceFile);
	            }
	            else if (ts.isExternalModule(sourceFile)) {
	                needsDeclare = false;
	                write("declare module \"" + ts.getResolvedExternalModuleName(host, sourceFile) + "\" {");
	                writeLine();
	                increaseIndent();
	                emitSourceFile(sourceFile);
	                decreaseIndent();
	                write("}");
	                writeLine();
	            }
	            // create asynchronous output for the importDeclarations
	            if (moduleElementDeclarationEmitInfo.length) {
	                var oldWriter = writer;
	                ts.forEach(moduleElementDeclarationEmitInfo, function (aliasEmitInfo) {
	                    if (aliasEmitInfo.isVisible && !aliasEmitInfo.asynchronousOutput) {
	                        ts.Debug.assert(aliasEmitInfo.node.kind === 242 /* ImportDeclaration */);
	                        createAndSetNewTextWriterWithSymbolWriter();
	                        ts.Debug.assert(aliasEmitInfo.indent === 0 || (aliasEmitInfo.indent === 1 && isBundledEmit));
	                        for (var i = 0; i < aliasEmitInfo.indent; i++) {
	                            increaseIndent();
	                        }
	                        writeImportDeclaration(aliasEmitInfo.node);
	                        aliasEmitInfo.asynchronousOutput = writer.getText();
	                        for (var i = 0; i < aliasEmitInfo.indent; i++) {
	                            decreaseIndent();
	                        }
	                    }
	                });
	                setWriter(oldWriter);
	                allSourcesModuleElementDeclarationEmitInfo = allSourcesModuleElementDeclarationEmitInfo.concat(moduleElementDeclarationEmitInfo);
	                moduleElementDeclarationEmitInfo = [];
	            }
	            if (!isBundledEmit && ts.isExternalModule(sourceFile) && !resultHasExternalModuleIndicator) {
	                // if file was external module this fact should be preserved in .d.ts as well.
	                // in case if we didn't write any external module specifiers in .d.ts we need to emit something
	                // that will force compiler to think that this file is an external module - 'export {}' is a reasonable choice here.
	                write("export {};");
	                writeLine();
	            }
	        });
	        if (usedTypeDirectiveReferences) {
	            ts.forEachKey(usedTypeDirectiveReferences, function (directive) {
	                referencesOutput += "/// <reference types=\"" + directive + "\" />" + newLine;
	            });
	        }
	        return {
	            reportedDeclarationError: reportedDeclarationError,
	            moduleElementDeclarationEmitInfo: allSourcesModuleElementDeclarationEmitInfo,
	            synchronousDeclarationOutput: writer.getText(),
	            referencesOutput: referencesOutput,
	        };
	        function hasInternalAnnotation(range) {
	            var comment = currentText.substring(range.pos, range.end);
	            return ts.stringContains(comment, "@internal");
	        }
	        function stripInternal(node) {
	            if (node) {
	                var leadingCommentRanges = ts.getLeadingCommentRanges(currentText, node.pos);
	                if (ts.forEach(leadingCommentRanges, hasInternalAnnotation)) {
	                    return;
	                }
	                emitNode(node);
	            }
	        }
	        function createAndSetNewTextWriterWithSymbolWriter() {
	            var writer = ts.createTextWriter(newLine);
	            writer.trackSymbol = trackSymbol;
	            writer.reportInaccessibleThisError = reportInaccessibleThisError;
	            writer.reportInaccessibleUniqueSymbolError = reportInaccessibleUniqueSymbolError;
	            writer.reportPrivateInBaseOfClassExpression = reportPrivateInBaseOfClassExpression;
	            writer.writeKeyword = writer.write;
	            writer.writeOperator = writer.write;
	            writer.writePunctuation = writer.write;
	            writer.writeSpace = writer.write;
	            writer.writeStringLiteral = writer.writeLiteral;
	            writer.writeParameter = writer.write;
	            writer.writeProperty = writer.write;
	            writer.writeSymbol = writer.write;
	            setWriter(writer);
	        }
	        function setWriter(newWriter) {
	            writer = newWriter;
	            write = newWriter.write;
	            writeTextOfNode = newWriter.writeTextOfNode;
	            writeLine = newWriter.writeLine;
	            increaseIndent = newWriter.increaseIndent;
	            decreaseIndent = newWriter.decreaseIndent;
	        }
	        function writeAsynchronousModuleElements(nodes) {
	            var oldWriter = writer;
	            ts.forEach(nodes, function (declaration) {
	                var nodeToCheck;
	                if (declaration.kind === 230 /* VariableDeclaration */) {
	                    nodeToCheck = declaration.parent.parent;
	                }
	                else if (declaration.kind === 245 /* NamedImports */ || declaration.kind === 246 /* ImportSpecifier */ || declaration.kind === 243 /* ImportClause */) {
	                    ts.Debug.fail("We should be getting ImportDeclaration instead to write");
	                }
	                else {
	                    nodeToCheck = declaration;
	                }
	                var moduleElementEmitInfo = ts.forEach(moduleElementDeclarationEmitInfo, function (declEmitInfo) { return declEmitInfo.node === nodeToCheck ? declEmitInfo : undefined; });
	                if (!moduleElementEmitInfo && asynchronousSubModuleDeclarationEmitInfo) {
	                    moduleElementEmitInfo = ts.forEach(asynchronousSubModuleDeclarationEmitInfo, function (declEmitInfo) { return declEmitInfo.node === nodeToCheck ? declEmitInfo : undefined; });
	                }
	                // If the alias was marked as not visible when we saw its declaration, we would have saved the aliasEmitInfo, but if we haven't yet visited the alias declaration
	                // then we don't need to write it at this point. We will write it when we actually see its declaration
	                // Eg.
	                // export function bar(a: foo.Foo) { }
	                // import foo = require("foo");
	                // Writing of function bar would mark alias declaration foo as visible but we haven't yet visited that declaration so do nothing,
	                // we would write alias foo declaration when we visit it since it would now be marked as visible
	                if (moduleElementEmitInfo) {
	                    if (moduleElementEmitInfo.node.kind === 242 /* ImportDeclaration */) {
	                        // we have to create asynchronous output only after we have collected complete information
	                        // because it is possible to enable multiple bindings as asynchronously visible
	                        moduleElementEmitInfo.isVisible = true;
	                    }
	                    else {
	                        createAndSetNewTextWriterWithSymbolWriter();
	                        for (var declarationIndent = moduleElementEmitInfo.indent; declarationIndent; declarationIndent--) {
	                            increaseIndent();
	                        }
	                        if (nodeToCheck.kind === 237 /* ModuleDeclaration */) {
	                            ts.Debug.assert(asynchronousSubModuleDeclarationEmitInfo === undefined);
	                            asynchronousSubModuleDeclarationEmitInfo = [];
	                        }
	                        writeModuleElement(nodeToCheck);
	                        if (nodeToCheck.kind === 237 /* ModuleDeclaration */) {
	                            moduleElementEmitInfo.subModuleElementDeclarationEmitInfo = asynchronousSubModuleDeclarationEmitInfo;
	                            asynchronousSubModuleDeclarationEmitInfo = undefined;
	                        }
	                        moduleElementEmitInfo.asynchronousOutput = writer.getText();
	                    }
	                }
	            });
	            setWriter(oldWriter);
	        }
	        function recordTypeReferenceDirectivesIfNecessary(typeReferenceDirectives) {
	            if (!typeReferenceDirectives) {
	                return;
	            }
	            if (!usedTypeDirectiveReferences) {
	                usedTypeDirectiveReferences = ts.createMap();
	            }
	            for (var _i = 0, typeReferenceDirectives_1 = typeReferenceDirectives; _i < typeReferenceDirectives_1.length; _i++) {
	                var directive = typeReferenceDirectives_1[_i];
	                if (!usedTypeDirectiveReferences.has(directive)) {
	                    usedTypeDirectiveReferences.set(directive, directive);
	                }
	            }
	        }
	        function handleSymbolAccessibilityError(symbolAccessibilityResult) {
	            if (symbolAccessibilityResult.accessibility === 0 /* Accessible */) {
	                // write the aliases
	                if (symbolAccessibilityResult && symbolAccessibilityResult.aliasesToMakeVisible) {
	                    writeAsynchronousModuleElements(symbolAccessibilityResult.aliasesToMakeVisible);
	                }
	            }
	            else {
	                // Report error
	                reportedDeclarationError = true;
	                var errorInfo = writer.getSymbolAccessibilityDiagnostic(symbolAccessibilityResult);
	                if (errorInfo) {
	                    if (errorInfo.typeName) {
	                        emitterDiagnostics.add(ts.createDiagnosticForNode(symbolAccessibilityResult.errorNode || errorInfo.errorNode, errorInfo.diagnosticMessage, ts.getTextOfNodeFromSourceText(currentText, errorInfo.typeName), symbolAccessibilityResult.errorSymbolName, symbolAccessibilityResult.errorModuleName));
	                    }
	                    else {
	                        emitterDiagnostics.add(ts.createDiagnosticForNode(symbolAccessibilityResult.errorNode || errorInfo.errorNode, errorInfo.diagnosticMessage, symbolAccessibilityResult.errorSymbolName, symbolAccessibilityResult.errorModuleName));
	                    }
	                }
	            }
	        }
	        function trackSymbol(symbol, enclosingDeclaration, meaning) {
	            handleSymbolAccessibilityError(resolver.isSymbolAccessible(symbol, enclosingDeclaration, meaning, /*shouldComputeAliasesToMakeVisible*/ true));
	            recordTypeReferenceDirectivesIfNecessary(resolver.getTypeReferenceDirectivesForSymbol(symbol, meaning));
	        }
	        function reportPrivateInBaseOfClassExpression(propertyName) {
	            if (errorNameNode) {
	                reportedDeclarationError = true;
	                emitterDiagnostics.add(ts.createDiagnosticForNode(errorNameNode, ts.Diagnostics.Property_0_of_exported_class_expression_may_not_be_private_or_protected, propertyName));
	            }
	        }
	        function reportInaccessibleUniqueSymbolError() {
	            if (errorNameNode) {
	                reportedDeclarationError = true;
	                emitterDiagnostics.add(ts.createDiagnosticForNode(errorNameNode, ts.Diagnostics.The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary, ts.declarationNameToString(errorNameNode), "unique symbol"));
	            }
	        }
	        function reportInaccessibleThisError() {
	            if (errorNameNode) {
	                reportedDeclarationError = true;
	                emitterDiagnostics.add(ts.createDiagnosticForNode(errorNameNode, ts.Diagnostics.The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary, ts.declarationNameToString(errorNameNode), "this"));
	            }
	        }
	        function writeTypeOfDeclaration(declaration, type, getSymbolAccessibilityDiagnostic) {
	            writer.getSymbolAccessibilityDiagnostic = getSymbolAccessibilityDiagnostic;
	            write(": ");
	            // use the checker's type, not the declared type,
	            // for optional parameter properties
	            // and also for non-optional initialized parameters that aren't a parameter property
	            // these types may need to add `undefined`.
	            var shouldUseResolverType = declaration.kind === 148 /* Parameter */ &&
	                (resolver.isRequiredInitializedParameter(declaration) ||
	                    resolver.isOptionalUninitializedParameterProperty(declaration));
	            if (type && !shouldUseResolverType) {
	                // Write the type
	                emitType(type);
	            }
	            else {
	                errorNameNode = declaration.name;
	                var format = 4096 /* UseTypeOfFunction */ | 8 /* UseStructuralFallback */ |
	                    2048 /* WriteClassExpressionAsTypeLiteral */ |
	                    (shouldUseResolverType ? 131072 /* AddUndefined */ : 0);
	                resolver.writeTypeOfDeclaration(declaration, enclosingDeclaration, format, writer);
	                errorNameNode = undefined;
	            }
	        }
	        function writeReturnTypeAtSignature(signature, getSymbolAccessibilityDiagnostic) {
	            writer.getSymbolAccessibilityDiagnostic = getSymbolAccessibilityDiagnostic;
	            write(": ");
	            if (signature.type) {
	                // Write the type
	                emitType(signature.type);
	            }
	            else {
	                errorNameNode = signature.name;
	                resolver.writeReturnTypeOfSignatureDeclaration(signature, enclosingDeclaration, 4096 /* UseTypeOfFunction */ | 8 /* UseStructuralFallback */ | 2048 /* WriteClassExpressionAsTypeLiteral */, writer);
	                errorNameNode = undefined;
	            }
	        }
	        function emitLines(nodes) {
	            for (var _i = 0, nodes_6 = nodes; _i < nodes_6.length; _i++) {
	                var node = nodes_6[_i];
	                emit(node);
	            }
	        }
	        function emitSeparatedList(nodes, separator, eachNodeEmitFn, canEmitFn) {
	            var currentWriterPos = writer.getTextPos();
	            for (var _i = 0, nodes_7 = nodes; _i < nodes_7.length; _i++) {
	                var node = nodes_7[_i];
	                if (!canEmitFn || canEmitFn(node)) {
	                    if (currentWriterPos !== writer.getTextPos()) {
	                        write(separator);
	                    }
	                    currentWriterPos = writer.getTextPos();
	                    eachNodeEmitFn(node);
	                }
	            }
	        }
	        function emitCommaList(nodes, eachNodeEmitFn, canEmitFn) {
	            emitSeparatedList(nodes, ", ", eachNodeEmitFn, canEmitFn);
	        }
	        function writeJsDocComments(declaration) {
	            if (declaration) {
	                var jsDocComments = ts.getJSDocCommentRanges(declaration, currentText);
	                ts.emitNewLineBeforeLeadingComments(currentLineMap, writer, declaration, jsDocComments);
	                // jsDoc comments are emitted at /*leading comment1 */space/*leading comment*/space
	                ts.emitComments(currentText, currentLineMap, writer, jsDocComments, /*leadingSeparator*/ false, /*trailingSeparator*/ true, newLine, ts.writeCommentRange);
	            }
	        }
	        function emitTypeWithNewGetSymbolAccessibilityDiagnostic(type, getSymbolAccessibilityDiagnostic) {
	            writer.getSymbolAccessibilityDiagnostic = getSymbolAccessibilityDiagnostic;
	            emitType(type);
	        }
	        function emitType(type) {
	            switch (type.kind) {
	                case 119 /* AnyKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 135 /* ObjectKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 105 /* VoidKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 95 /* NullKeyword */:
	                case 131 /* NeverKeyword */:
	                case 173 /* ThisType */:
	                case 177 /* LiteralType */:
	                    return writeTextOfNode(currentText, type);
	                case 205 /* ExpressionWithTypeArguments */:
	                    return emitExpressionWithTypeArguments(type);
	                case 161 /* TypeReference */:
	                    return emitTypeReference(type);
	                case 164 /* TypeQuery */:
	                    return emitTypeQuery(type);
	                case 166 /* ArrayType */:
	                    return emitArrayType(type);
	                case 167 /* TupleType */:
	                    return emitTupleType(type);
	                case 168 /* UnionType */:
	                    return emitUnionType(type);
	                case 169 /* IntersectionType */:
	                    return emitIntersectionType(type);
	                case 170 /* ConditionalType */:
	                    return emitConditionalType(type);
	                case 171 /* InferType */:
	                    return emitInferType(type);
	                case 172 /* ParenthesizedType */:
	                    return emitParenType(type);
	                case 174 /* TypeOperator */:
	                    return emitTypeOperator(type);
	                case 175 /* IndexedAccessType */:
	                    return emitIndexedAccessType(type);
	                case 176 /* MappedType */:
	                    return emitMappedType(type);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                    return emitSignatureDeclarationWithJsDocComments(type);
	                case 165 /* TypeLiteral */:
	                    return emitTypeLiteral(type);
	                case 71 /* Identifier */:
	                    return emitEntityName(type);
	                case 145 /* QualifiedName */:
	                    return emitEntityName(type);
	                case 160 /* TypePredicate */:
	                    return emitTypePredicate(type);
	            }
	            function writeEntityName(entityName) {
	                if (entityName.kind === 71 /* Identifier */) {
	                    writeTextOfNode(currentText, entityName);
	                }
	                else {
	                    var left = entityName.kind === 145 /* QualifiedName */ ? entityName.left : entityName.expression;
	                    var right = entityName.kind === 145 /* QualifiedName */ ? entityName.right : entityName.name;
	                    writeEntityName(left);
	                    write(".");
	                    writeTextOfNode(currentText, right);
	                }
	            }
	            function emitEntityName(entityName) {
	                var visibilityResult = resolver.isEntityNameVisible(entityName, 
	                // Aliases can be written asynchronously so use correct enclosing declaration
	                entityName.parent.kind === 241 /* ImportEqualsDeclaration */ ? entityName.parent : enclosingDeclaration);
	                handleSymbolAccessibilityError(visibilityResult);
	                recordTypeReferenceDirectivesIfNecessary(resolver.getTypeReferenceDirectivesForEntityName(entityName));
	                writeEntityName(entityName);
	            }
	            function emitExpressionWithTypeArguments(node) {
	                if (ts.isEntityNameExpression(node.expression)) {
	                    ts.Debug.assert(node.expression.kind === 71 /* Identifier */ || node.expression.kind === 183 /* PropertyAccessExpression */);
	                    emitEntityName(node.expression);
	                    if (node.typeArguments) {
	                        write("<");
	                        emitCommaList(node.typeArguments, emitType);
	                        write(">");
	                    }
	                }
	            }
	            function emitTypeReference(type) {
	                emitEntityName(type.typeName);
	                if (type.typeArguments) {
	                    write("<");
	                    emitCommaList(type.typeArguments, emitType);
	                    write(">");
	                }
	            }
	            function emitTypePredicate(type) {
	                writeTextOfNode(currentText, type.parameterName);
	                write(" is ");
	                emitType(type.type);
	            }
	            function emitTypeQuery(type) {
	                write("typeof ");
	                emitEntityName(type.exprName);
	            }
	            function emitArrayType(type) {
	                emitType(type.elementType);
	                write("[]");
	            }
	            function emitTupleType(type) {
	                write("[");
	                emitCommaList(type.elementTypes, emitType);
	                write("]");
	            }
	            function emitUnionType(type) {
	                emitSeparatedList(type.types, " | ", emitType);
	            }
	            function emitIntersectionType(type) {
	                emitSeparatedList(type.types, " & ", emitType);
	            }
	            function emitConditionalType(node) {
	                emitType(node.checkType);
	                write(" extends ");
	                emitType(node.extendsType);
	                write(" ? ");
	                var prevEnclosingDeclaration = enclosingDeclaration;
	                enclosingDeclaration = node.trueType;
	                emitType(node.trueType);
	                enclosingDeclaration = prevEnclosingDeclaration;
	                write(" : ");
	                emitType(node.falseType);
	            }
	            function emitInferType(node) {
	                write("infer ");
	                writeTextOfNode(currentText, node.typeParameter.name);
	            }
	            function emitParenType(type) {
	                write("(");
	                emitType(type.type);
	                write(")");
	            }
	            function emitTypeOperator(type) {
	                write(ts.tokenToString(type.operator));
	                write(" ");
	                emitType(type.type);
	            }
	            function emitIndexedAccessType(node) {
	                emitType(node.objectType);
	                write("[");
	                emitType(node.indexType);
	                write("]");
	            }
	            function emitMappedType(node) {
	                var prevEnclosingDeclaration = enclosingDeclaration;
	                enclosingDeclaration = node;
	                write("{");
	                writeLine();
	                increaseIndent();
	                if (node.readonlyToken) {
	                    write(node.readonlyToken.kind === 37 /* PlusToken */ ? "+readonly " :
	                        node.readonlyToken.kind === 38 /* MinusToken */ ? "-readonly " :
	                            "readonly ");
	                }
	                write("[");
	                writeEntityName(node.typeParameter.name);
	                write(" in ");
	                emitType(node.typeParameter.constraint);
	                write("]");
	                if (node.questionToken) {
	                    write(node.questionToken.kind === 37 /* PlusToken */ ? "+?" :
	                        node.questionToken.kind === 38 /* MinusToken */ ? "-?" :
	                            "?");
	                }
	                write(": ");
	                emitType(node.type);
	                write(";");
	                writeLine();
	                decreaseIndent();
	                write("}");
	                enclosingDeclaration = prevEnclosingDeclaration;
	            }
	            function emitTypeLiteral(type) {
	                write("{");
	                if (type.members.length) {
	                    writeLine();
	                    increaseIndent();
	                    // write members
	                    emitLines(type.members);
	                    decreaseIndent();
	                }
	                write("}");
	            }
	        }
	        function emitSourceFile(node) {
	            currentText = node.text;
	            currentLineMap = ts.getLineStarts(node);
	            currentIdentifiers = node.identifiers;
	            isCurrentFileExternalModule = ts.isExternalModule(node);
	            enclosingDeclaration = node;
	            ts.emitDetachedComments(currentText, currentLineMap, writer, ts.writeCommentRange, node, newLine, /*removeComments*/ true);
	            emitLines(node.statements);
	        }
	        // Return a temp variable name to be used in `export default`/`export class ... extends` statements.
	        // The temp name will be of the form _default_counter.
	        // Note that export default is only allowed at most once in a module, so we
	        // do not need to keep track of created temp names.
	        function getExportTempVariableName(baseName) {
	            if (!currentIdentifiers.has(baseName)) {
	                return baseName;
	            }
	            var count = 0;
	            while (true) {
	                count++;
	                var name = baseName + "_" + count;
	                if (!currentIdentifiers.has(name)) {
	                    return name;
	                }
	            }
	        }
	        function emitTempVariableDeclaration(expr, baseName, diagnostic, needsDeclare) {
	            var tempVarName = getExportTempVariableName(baseName);
	            if (needsDeclare) {
	                write("declare ");
	            }
	            write("const ");
	            write(tempVarName);
	            write(": ");
	            writer.getSymbolAccessibilityDiagnostic = function () { return diagnostic; };
	            resolver.writeTypeOfExpression(expr, enclosingDeclaration, 4096 /* UseTypeOfFunction */ | 8 /* UseStructuralFallback */ | 2048 /* WriteClassExpressionAsTypeLiteral */, writer);
	            write(";");
	            writeLine();
	            return tempVarName;
	        }
	        function emitExportAssignment(node) {
	            if (ts.isSourceFile(node.parent)) {
	                resultHasExternalModuleIndicator = true; // Top-level exports are external module indicators
	            }
	            if (node.expression.kind === 71 /* Identifier */) {
	                write(node.isExportEquals ? "export = " : "export default ");
	                writeTextOfNode(currentText, node.expression);
	            }
	            else {
	                var tempVarName = emitTempVariableDeclaration(node.expression, "_default", {
	                    diagnosticMessage: ts.Diagnostics.Default_export_of_the_module_has_or_is_using_private_name_0,
	                    errorNode: node
	                }, needsDeclare);
	                write(node.isExportEquals ? "export = " : "export default ");
	                write(tempVarName);
	            }
	            write(";");
	            writeLine();
	            // Make all the declarations visible for the export name
	            if (node.expression.kind === 71 /* Identifier */) {
	                var nodes = resolver.collectLinkedAliases(node.expression);
	                // write each of these declarations asynchronously
	                writeAsynchronousModuleElements(nodes);
	            }
	        }
	        function isModuleElementVisible(node) {
	            return resolver.isDeclarationVisible(node);
	        }
	        function emitModuleElement(node, isModuleElementVisible) {
	            if (isModuleElementVisible) {
	                writeModuleElement(node);
	            }
	            else if (node.kind === 241 /* ImportEqualsDeclaration */ ||
	                (node.parent.kind === 272 /* SourceFile */ && isCurrentFileExternalModule)) {
	                var isVisible = void 0;
	                if (asynchronousSubModuleDeclarationEmitInfo && node.parent.kind !== 272 /* SourceFile */) {
	                    // Import declaration of another module that is visited async so lets put it in right spot
	                    asynchronousSubModuleDeclarationEmitInfo.push({
	                        node: node,
	                        outputPos: writer.getTextPos(),
	                        indent: writer.getIndent(),
	                        isVisible: isVisible
	                    });
	                }
	                else {
	                    if (node.kind === 242 /* ImportDeclaration */) {
	                        var importDeclaration = node;
	                        if (importDeclaration.importClause) {
	                            isVisible = (importDeclaration.importClause.name && resolver.isDeclarationVisible(importDeclaration.importClause)) ||
	                                isVisibleNamedBinding(importDeclaration.importClause.namedBindings);
	                        }
	                    }
	                    moduleElementDeclarationEmitInfo.push({
	                        node: node,
	                        outputPos: writer.getTextPos(),
	                        indent: writer.getIndent(),
	                        isVisible: isVisible
	                    });
	                }
	            }
	        }
	        function writeModuleElement(node) {
	            switch (node.kind) {
	                case 232 /* FunctionDeclaration */:
	                    return writeFunctionDeclaration(node);
	                case 212 /* VariableStatement */:
	                    return writeVariableStatement(node);
	                case 234 /* InterfaceDeclaration */:
	                    return writeInterfaceDeclaration(node);
	                case 233 /* ClassDeclaration */:
	                    return writeClassDeclaration(node);
	                case 235 /* TypeAliasDeclaration */:
	                    return writeTypeAliasDeclaration(node);
	                case 236 /* EnumDeclaration */:
	                    return writeEnumDeclaration(node);
	                case 237 /* ModuleDeclaration */:
	                    return writeModuleDeclaration(node);
	                case 241 /* ImportEqualsDeclaration */:
	                    return writeImportEqualsDeclaration(node);
	                case 242 /* ImportDeclaration */:
	                    return writeImportDeclaration(node);
	                default:
	                    ts.Debug.fail("Unknown symbol kind");
	            }
	        }
	        function emitModuleElementDeclarationFlags(node) {
	            // If the node is parented in the current source file we need to emit export declare or just export
	            if (node.parent.kind === 272 /* SourceFile */) {
	                var modifiers = ts.getModifierFlags(node);
	                // If the node is exported
	                if (modifiers & 1 /* Export */) {
	                    resultHasExternalModuleIndicator = true; // Top-level exports are external module indicators
	                    write("export ");
	                }
	                if (modifiers & 512 /* Default */) {
	                    write("default ");
	                }
	                else if (node.kind !== 234 /* InterfaceDeclaration */ && needsDeclare) {
	                    write("declare ");
	                }
	            }
	        }
	        function emitClassMemberDeclarationFlags(flags) {
	            if (flags & 8 /* Private */) {
	                write("private ");
	            }
	            else if (flags & 16 /* Protected */) {
	                write("protected ");
	            }
	            if (flags & 32 /* Static */) {
	                write("static ");
	            }
	            if (flags & 64 /* Readonly */) {
	                write("readonly ");
	            }
	            if (flags & 128 /* Abstract */) {
	                write("abstract ");
	            }
	        }
	        function writeImportEqualsDeclaration(node) {
	            // note usage of writer. methods instead of aliases created, just to make sure we are using
	            // correct writer especially to handle asynchronous alias writing
	            emitJsDocComments(node);
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                write("export ");
	            }
	            write("import ");
	            writeTextOfNode(currentText, node.name);
	            write(" = ");
	            if (ts.isInternalModuleImportEqualsDeclaration(node)) {
	                emitTypeWithNewGetSymbolAccessibilityDiagnostic(node.moduleReference, getImportEntityNameVisibilityError);
	                write(";");
	            }
	            else {
	                write("require(");
	                emitExternalModuleSpecifier(node);
	                write(");");
	            }
	            writer.writeLine();
	            function getImportEntityNameVisibilityError() {
	                return {
	                    diagnosticMessage: ts.Diagnostics.Import_declaration_0_is_using_private_name_1,
	                    errorNode: node,
	                    typeName: node.name
	                };
	            }
	        }
	        function isVisibleNamedBinding(namedBindings) {
	            if (namedBindings) {
	                if (namedBindings.kind === 244 /* NamespaceImport */) {
	                    return resolver.isDeclarationVisible(namedBindings);
	                }
	                else {
	                    return namedBindings.elements.some(function (namedImport) { return resolver.isDeclarationVisible(namedImport); });
	                }
	            }
	        }
	        function writeImportDeclaration(node) {
	            emitJsDocComments(node);
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                write("export ");
	            }
	            write("import ");
	            if (node.importClause) {
	                var currentWriterPos = writer.getTextPos();
	                if (node.importClause.name && resolver.isDeclarationVisible(node.importClause)) {
	                    writeTextOfNode(currentText, node.importClause.name);
	                }
	                if (node.importClause.namedBindings && isVisibleNamedBinding(node.importClause.namedBindings)) {
	                    if (currentWriterPos !== writer.getTextPos()) {
	                        // If the default binding was emitted, write the separated
	                        write(", ");
	                    }
	                    if (node.importClause.namedBindings.kind === 244 /* NamespaceImport */) {
	                        write("* as ");
	                        writeTextOfNode(currentText, node.importClause.namedBindings.name);
	                    }
	                    else {
	                        write("{ ");
	                        emitCommaList(node.importClause.namedBindings.elements, emitImportOrExportSpecifier, resolver.isDeclarationVisible);
	                        write(" }");
	                    }
	                }
	                write(" from ");
	            }
	            emitExternalModuleSpecifier(node);
	            write(";");
	            writer.writeLine();
	        }
	        function emitExternalModuleSpecifier(parent) {
	            // emitExternalModuleSpecifier is usually called when we emit something in the.d.ts file that will make it an external module (i.e. import/export declarations).
	            // the only case when it is not true is when we call it to emit correct name for module augmentation - d.ts files with just module augmentations are not considered
	            // external modules since they are indistinguishable from script files with ambient modules. To fix this in such d.ts files we'll emit top level 'export {}'
	            // so compiler will treat them as external modules.
	            resultHasExternalModuleIndicator = resultHasExternalModuleIndicator || parent.kind !== 237 /* ModuleDeclaration */;
	            var moduleSpecifier = parent.kind === 241 /* ImportEqualsDeclaration */ ? ts.getExternalModuleImportEqualsDeclarationExpression(parent) :
	                parent.kind === 237 /* ModuleDeclaration */ ? parent.name : parent.moduleSpecifier;
	            if (moduleSpecifier.kind === 9 /* StringLiteral */ && isBundledEmit && (compilerOptions.out || compilerOptions.outFile)) {
	                var moduleName = ts.getExternalModuleNameFromDeclaration(host, resolver, parent);
	                if (moduleName) {
	                    write('"');
	                    write(moduleName);
	                    write('"');
	                    return;
	                }
	            }
	            writeTextOfNode(currentText, moduleSpecifier);
	        }
	        function emitImportOrExportSpecifier(node) {
	            if (node.propertyName) {
	                writeTextOfNode(currentText, node.propertyName);
	                write(" as ");
	            }
	            writeTextOfNode(currentText, node.name);
	        }
	        function emitExportSpecifier(node) {
	            emitImportOrExportSpecifier(node);
	            // Make all the declarations visible for the export name
	            var nodes = resolver.collectLinkedAliases(node.propertyName || node.name);
	            // write each of these declarations asynchronously
	            writeAsynchronousModuleElements(nodes);
	        }
	        function emitExportDeclaration(node) {
	            resultHasExternalModuleIndicator = true; // Top-level exports are external module indicators
	            emitJsDocComments(node);
	            write("export ");
	            if (node.exportClause) {
	                write("{ ");
	                emitCommaList(node.exportClause.elements, emitExportSpecifier);
	                write(" }");
	            }
	            else {
	                write("*");
	            }
	            if (node.moduleSpecifier) {
	                write(" from ");
	                emitExternalModuleSpecifier(node);
	            }
	            write(";");
	            writer.writeLine();
	        }
	        function writeModuleDeclaration(node) {
	            emitJsDocComments(node);
	            emitModuleElementDeclarationFlags(node);
	            if (ts.isGlobalScopeAugmentation(node)) {
	                write("global ");
	            }
	            else {
	                if (node.flags & 16 /* Namespace */) {
	                    write("namespace ");
	                }
	                else {
	                    write("module ");
	                }
	                if (ts.isExternalModuleAugmentation(node)) {
	                    emitExternalModuleSpecifier(node);
	                }
	                else {
	                    writeTextOfNode(currentText, node.name);
	                }
	            }
	            while (node.body && node.body.kind !== 238 /* ModuleBlock */) {
	                node = node.body;
	                write(".");
	                writeTextOfNode(currentText, node.name);
	            }
	            var prevEnclosingDeclaration = enclosingDeclaration;
	            if (node.body) {
	                enclosingDeclaration = node;
	                write(" {");
	                writeLine();
	                increaseIndent();
	                emitLines(node.body.statements);
	                decreaseIndent();
	                write("}");
	                writeLine();
	                enclosingDeclaration = prevEnclosingDeclaration;
	            }
	            else {
	                write(";");
	            }
	        }
	        function writeTypeAliasDeclaration(node) {
	            var prevEnclosingDeclaration = enclosingDeclaration;
	            enclosingDeclaration = node;
	            emitJsDocComments(node);
	            emitModuleElementDeclarationFlags(node);
	            write("type ");
	            writeTextOfNode(currentText, node.name);
	            emitTypeParameters(node.typeParameters);
	            write(" = ");
	            emitTypeWithNewGetSymbolAccessibilityDiagnostic(node.type, getTypeAliasDeclarationVisibilityError);
	            write(";");
	            writeLine();
	            enclosingDeclaration = prevEnclosingDeclaration;
	            function getTypeAliasDeclarationVisibilityError() {
	                return {
	                    diagnosticMessage: ts.Diagnostics.Exported_type_alias_0_has_or_is_using_private_name_1,
	                    errorNode: node.type,
	                    typeName: node.name
	                };
	            }
	        }
	        function writeEnumDeclaration(node) {
	            emitJsDocComments(node);
	            emitModuleElementDeclarationFlags(node);
	            if (ts.isConst(node)) {
	                write("const ");
	            }
	            write("enum ");
	            writeTextOfNode(currentText, node.name);
	            write(" {");
	            writeLine();
	            increaseIndent();
	            emitLines(node.members);
	            decreaseIndent();
	            write("}");
	            writeLine();
	        }
	        function emitEnumMemberDeclaration(node) {
	            emitJsDocComments(node);
	            writeTextOfNode(currentText, node.name);
	            var enumMemberValue = resolver.getConstantValue(node);
	            if (enumMemberValue !== undefined) {
	                write(" = ");
	                write(ts.getTextOfConstantValue(enumMemberValue));
	            }
	            write(",");
	            writeLine();
	        }
	        function isPrivateMethodTypeParameter(node) {
	            return node.parent.kind === 153 /* MethodDeclaration */ && ts.hasModifier(node.parent, 8 /* Private */);
	        }
	        function emitTypeParameters(typeParameters) {
	            function emitTypeParameter(node) {
	                increaseIndent();
	                emitJsDocComments(node);
	                decreaseIndent();
	                writeTextOfNode(currentText, node.name);
	                // If there is constraint present and this is not a type parameter of the private method emit the constraint
	                if (node.constraint && !isPrivateMethodTypeParameter(node)) {
	                    write(" extends ");
	                    if (node.parent.kind === 162 /* FunctionType */ ||
	                        node.parent.kind === 163 /* ConstructorType */ ||
	                        (node.parent.parent && node.parent.parent.kind === 165 /* TypeLiteral */)) {
	                        ts.Debug.assert(node.parent.kind === 153 /* MethodDeclaration */ ||
	                            node.parent.kind === 152 /* MethodSignature */ ||
	                            node.parent.kind === 162 /* FunctionType */ ||
	                            node.parent.kind === 163 /* ConstructorType */ ||
	                            node.parent.kind === 157 /* CallSignature */ ||
	                            node.parent.kind === 158 /* ConstructSignature */);
	                        emitType(node.constraint);
	                    }
	                    else {
	                        emitTypeWithNewGetSymbolAccessibilityDiagnostic(node.constraint, getTypeParameterConstraintVisibilityError);
	                    }
	                }
	                if (node.default && !isPrivateMethodTypeParameter(node)) {
	                    write(" = ");
	                    if (node.parent.kind === 162 /* FunctionType */ ||
	                        node.parent.kind === 163 /* ConstructorType */ ||
	                        (node.parent.parent && node.parent.parent.kind === 165 /* TypeLiteral */)) {
	                        ts.Debug.assert(node.parent.kind === 153 /* MethodDeclaration */ ||
	                            node.parent.kind === 152 /* MethodSignature */ ||
	                            node.parent.kind === 162 /* FunctionType */ ||
	                            node.parent.kind === 163 /* ConstructorType */ ||
	                            node.parent.kind === 157 /* CallSignature */ ||
	                            node.parent.kind === 158 /* ConstructSignature */);
	                        emitType(node.default);
	                    }
	                    else {
	                        emitTypeWithNewGetSymbolAccessibilityDiagnostic(node.default, getTypeParameterConstraintVisibilityError);
	                    }
	                }
	                function getTypeParameterConstraintVisibilityError() {
	                    // Type parameter constraints are named by user so we should always be able to name it
	                    var diagnosticMessage;
	                    switch (node.parent.kind) {
	                        case 233 /* ClassDeclaration */:
	                            diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_exported_class_has_or_is_using_private_name_1;
	                            break;
	                        case 234 /* InterfaceDeclaration */:
	                            diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1;
	                            break;
	                        case 158 /* ConstructSignature */:
	                            diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1;
	                            break;
	                        case 157 /* CallSignature */:
	                            diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1;
	                            break;
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                            if (ts.hasModifier(node.parent, 32 /* Static */)) {
	                                diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1;
	                            }
	                            else if (node.parent.parent.kind === 233 /* ClassDeclaration */) {
	                                diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1;
	                            }
	                            else {
	                                diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1;
	                            }
	                            break;
	                        case 232 /* FunctionDeclaration */:
	                            diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_exported_function_has_or_is_using_private_name_1;
	                            break;
	                        case 235 /* TypeAliasDeclaration */:
	                            diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1;
	                            break;
	                        default:
	                            ts.Debug.fail("This is unknown parent for type parameter: " + node.parent.kind);
	                    }
	                    return {
	                        diagnosticMessage: diagnosticMessage,
	                        errorNode: node,
	                        typeName: node.name
	                    };
	                }
	            }
	            if (typeParameters) {
	                write("<");
	                emitCommaList(typeParameters, emitTypeParameter);
	                write(">");
	            }
	        }
	        function emitHeritageClause(typeReferences, isImplementsList) {
	            if (typeReferences) {
	                write(isImplementsList ? " implements " : " extends ");
	                emitCommaList(typeReferences, emitTypeOfTypeReference);
	            }
	            function emitTypeOfTypeReference(node) {
	                if (ts.isEntityNameExpression(node.expression)) {
	                    emitTypeWithNewGetSymbolAccessibilityDiagnostic(node, getHeritageClauseVisibilityError);
	                }
	                else if (!isImplementsList && node.expression.kind === 95 /* NullKeyword */) {
	                    write("null");
	                }
	                function getHeritageClauseVisibilityError() {
	                    var diagnosticMessage;
	                    // Heritage clause is written by user so it can always be named
	                    if (node.parent.parent.kind === 233 /* ClassDeclaration */) {
	                        // Class or Interface implemented/extended is inaccessible
	                        diagnosticMessage = isImplementsList ?
	                            ts.Diagnostics.Implements_clause_of_exported_class_0_has_or_is_using_private_name_1 :
	                            ts.Diagnostics.extends_clause_of_exported_class_0_has_or_is_using_private_name_1;
	                    }
	                    else {
	                        // interface is inaccessible
	                        diagnosticMessage = ts.Diagnostics.extends_clause_of_exported_interface_0_has_or_is_using_private_name_1;
	                    }
	                    return {
	                        diagnosticMessage: diagnosticMessage,
	                        errorNode: node,
	                        typeName: ts.getNameOfDeclaration(node.parent.parent)
	                    };
	                }
	            }
	        }
	        function writeClassDeclaration(node) {
	            function emitParameterProperties(constructorDeclaration) {
	                if (constructorDeclaration) {
	                    ts.forEach(constructorDeclaration.parameters, function (param) {
	                        if (ts.hasModifier(param, 92 /* ParameterPropertyModifier */)) {
	                            emitPropertyDeclaration(param);
	                        }
	                    });
	                }
	            }
	            var prevEnclosingDeclaration = enclosingDeclaration;
	            enclosingDeclaration = node;
	            var baseTypeNode = ts.getClassExtendsHeritageClauseElement(node);
	            var tempVarName;
	            if (baseTypeNode && !ts.isEntityNameExpression(baseTypeNode.expression)) {
	                tempVarName = baseTypeNode.expression.kind === 95 /* NullKeyword */ ?
	                    "null" :
	                    emitTempVariableDeclaration(baseTypeNode.expression, node.name.escapedText + "_base", {
	                        diagnosticMessage: ts.Diagnostics.extends_clause_of_exported_class_0_has_or_is_using_private_name_1,
	                        errorNode: baseTypeNode,
	                        typeName: node.name
	                    }, !ts.findAncestor(node, function (n) { return n.kind === 237 /* ModuleDeclaration */; }));
	            }
	            emitJsDocComments(node);
	            emitModuleElementDeclarationFlags(node);
	            if (ts.hasModifier(node, 128 /* Abstract */)) {
	                write("abstract ");
	            }
	            write("class ");
	            writeTextOfNode(currentText, node.name);
	            emitTypeParameters(node.typeParameters);
	            if (baseTypeNode) {
	                if (!ts.isEntityNameExpression(baseTypeNode.expression)) {
	                    write(" extends ");
	                    write(tempVarName);
	                    if (baseTypeNode.typeArguments) {
	                        write("<");
	                        emitCommaList(baseTypeNode.typeArguments, emitType);
	                        write(">");
	                    }
	                }
	                else {
	                    emitHeritageClause([baseTypeNode], /*isImplementsList*/ false);
	                }
	            }
	            emitHeritageClause(ts.getClassImplementsHeritageClauseElements(node), /*isImplementsList*/ true);
	            write(" {");
	            writeLine();
	            increaseIndent();
	            emitParameterProperties(ts.getFirstConstructorWithBody(node));
	            emitLines(node.members);
	            decreaseIndent();
	            write("}");
	            writeLine();
	            enclosingDeclaration = prevEnclosingDeclaration;
	        }
	        function writeInterfaceDeclaration(node) {
	            emitJsDocComments(node);
	            emitModuleElementDeclarationFlags(node);
	            write("interface ");
	            writeTextOfNode(currentText, node.name);
	            var prevEnclosingDeclaration = enclosingDeclaration;
	            enclosingDeclaration = node;
	            emitTypeParameters(node.typeParameters);
	            var interfaceExtendsTypes = ts.filter(ts.getInterfaceBaseTypeNodes(node), function (base) { return ts.isEntityNameExpression(base.expression); });
	            if (interfaceExtendsTypes && interfaceExtendsTypes.length) {
	                emitHeritageClause(interfaceExtendsTypes, /*isImplementsList*/ false);
	            }
	            write(" {");
	            writeLine();
	            increaseIndent();
	            emitLines(node.members);
	            decreaseIndent();
	            write("}");
	            writeLine();
	            enclosingDeclaration = prevEnclosingDeclaration;
	        }
	        function emitPropertyDeclaration(node) {
	            if (ts.hasDynamicName(node) && !resolver.isLateBound(node)) {
	                return;
	            }
	            emitJsDocComments(node);
	            emitClassMemberDeclarationFlags(ts.getModifierFlags(node));
	            emitVariableDeclaration(node);
	            write(";");
	            writeLine();
	        }
	        function bindingNameContainsVisibleBindingElement(node) {
	            return !!node && ts.isBindingPattern(node) && ts.some(node.elements, function (elem) { return !ts.isOmittedExpression(elem) && isVariableDeclarationVisible(elem); });
	        }
	        function isVariableDeclarationVisible(node) {
	            return resolver.isDeclarationVisible(node) || bindingNameContainsVisibleBindingElement(node.name);
	        }
	        function emitVariableDeclaration(node) {
	            // If we are emitting property it isn't moduleElement and hence we already know it needs to be emitted
	            // so there is no check needed to see if declaration is visible
	            if (node.kind !== 230 /* VariableDeclaration */ || isVariableDeclarationVisible(node)) {
	                if (ts.isBindingPattern(node.name)) {
	                    emitBindingPattern(node.name);
	                }
	                else {
	                    writeNameOfDeclaration(node, getVariableDeclarationTypeVisibilityError);
	                    // If optional property emit ? but in the case of parameterProperty declaration with "?" indicating optional parameter for the constructor
	                    // we don't want to emit property declaration with "?"
	                    if ((node.kind === 151 /* PropertyDeclaration */ || node.kind === 150 /* PropertySignature */ ||
	                        (node.kind === 148 /* Parameter */ && !ts.isParameterPropertyDeclaration(node))) && ts.hasQuestionToken(node)) {
	                        write("?");
	                    }
	                    if ((node.kind === 151 /* PropertyDeclaration */ || node.kind === 150 /* PropertySignature */) && node.parent.kind === 165 /* TypeLiteral */) {
	                        emitTypeOfVariableDeclarationFromTypeLiteral(node);
	                    }
	                    else if (resolver.isLiteralConstDeclaration(node)) {
	                        write(" = ");
	                        resolver.writeLiteralConstValue(node, writer);
	                    }
	                    else if (!ts.hasModifier(node, 8 /* Private */)) {
	                        writeTypeOfDeclaration(node, node.type, getVariableDeclarationTypeVisibilityError);
	                    }
	                }
	            }
	            function getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult) {
	                if (node.kind === 230 /* VariableDeclaration */) {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Exported_variable_0_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Exported_variable_0_has_or_is_using_private_name_1;
	                }
	                else if (node.kind === 151 /* PropertyDeclaration */ || node.kind === 150 /* PropertySignature */ ||
	                    (node.kind === 148 /* Parameter */ && ts.hasModifier(node.parent, 8 /* Private */))) {
	                    // TODO(jfreeman): Deal with computed properties in error reporting.
	                    if (ts.hasModifier(node, 32 /* Static */)) {
	                        return symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_private_name_1;
	                    }
	                    else if (node.parent.kind === 233 /* ClassDeclaration */ || node.kind === 148 /* Parameter */) {
	                        return symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_private_name_1;
	                    }
	                    else {
	                        // Interfaces cannot have types that cannot be named
	                        return symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Property_0_of_exported_interface_has_or_is_using_private_name_1;
	                    }
	                }
	            }
	            function getVariableDeclarationTypeVisibilityError(symbolAccessibilityResult) {
	                var diagnosticMessage = getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
	                return diagnosticMessage !== undefined ? {
	                    diagnosticMessage: diagnosticMessage,
	                    errorNode: node,
	                    typeName: node.name
	                } : undefined;
	            }
	            function emitBindingPattern(bindingPattern) {
	                // Only select visible, non-omitted expression from the bindingPattern's elements.
	                // We have to do this to avoid emitting trailing commas.
	                // For example:
	                //      original: var [, c,,] = [ 2,3,4]
	                //      emitted: declare var c: number; // instead of declare var c:number, ;
	                var elements = [];
	                for (var _i = 0, _a = bindingPattern.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (element.kind !== 204 /* OmittedExpression */ && isVariableDeclarationVisible(element)) {
	                        elements.push(element);
	                    }
	                }
	                emitCommaList(elements, emitBindingElement);
	            }
	            function emitBindingElement(bindingElement) {
	                function getBindingElementTypeVisibilityError(symbolAccessibilityResult) {
	                    var diagnosticMessage = getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
	                    return diagnosticMessage !== undefined ? {
	                        diagnosticMessage: diagnosticMessage,
	                        errorNode: bindingElement,
	                        typeName: bindingElement.name
	                    } : undefined;
	                }
	                if (bindingElement.name) {
	                    if (ts.isBindingPattern(bindingElement.name)) {
	                        emitBindingPattern(bindingElement.name);
	                    }
	                    else {
	                        writeTextOfNode(currentText, bindingElement.name);
	                        writeTypeOfDeclaration(bindingElement, /*type*/ undefined, getBindingElementTypeVisibilityError);
	                    }
	                }
	            }
	        }
	        function emitTypeOfVariableDeclarationFromTypeLiteral(node) {
	            // if this is property of type literal,
	            // or is parameter of method/call/construct/index signature of type literal
	            // emit only if type is specified
	            if (ts.hasType(node)) {
	                write(": ");
	                emitType(node.type);
	            }
	        }
	        function isVariableStatementVisible(node) {
	            return ts.forEach(node.declarationList.declarations, function (varDeclaration) { return isVariableDeclarationVisible(varDeclaration); });
	        }
	        function writeVariableStatement(node) {
	            // If binding pattern doesn't have name, then there is nothing to be emitted for declaration file i.e. const [,] = [1,2].
	            if (ts.every(node.declarationList && node.declarationList.declarations, function (decl) { return decl.name && ts.isEmptyBindingPattern(decl.name); })) {
	                return;
	            }
	            emitJsDocComments(node);
	            emitModuleElementDeclarationFlags(node);
	            if (ts.isLet(node.declarationList)) {
	                write("let ");
	            }
	            else if (ts.isConst(node.declarationList)) {
	                write("const ");
	            }
	            else {
	                write("var ");
	            }
	            emitCommaList(node.declarationList.declarations, emitVariableDeclaration, isVariableDeclarationVisible);
	            write(";");
	            writeLine();
	        }
	        function emitAccessorDeclaration(node) {
	            if (ts.hasDynamicName(node) && !resolver.isLateBound(node)) {
	                return;
	            }
	            var accessors = ts.getAllAccessorDeclarations(node.parent.members, node);
	            var accessorWithTypeAnnotation;
	            if (node === accessors.firstAccessor) {
	                emitJsDocComments(accessors.getAccessor);
	                emitJsDocComments(accessors.setAccessor);
	                emitClassMemberDeclarationFlags(ts.getModifierFlags(node) | (accessors.setAccessor ? 0 : 64 /* Readonly */));
	                writeNameOfDeclaration(node, getAccessorNameVisibilityError);
	                if (!ts.hasModifier(node, 8 /* Private */)) {
	                    accessorWithTypeAnnotation = node;
	                    var type = getTypeAnnotationFromAccessor(node);
	                    if (!type) {
	                        // couldn't get type for the first accessor, try the another one
	                        var anotherAccessor = node.kind === 155 /* GetAccessor */ ? accessors.setAccessor : accessors.getAccessor;
	                        type = getTypeAnnotationFromAccessor(anotherAccessor);
	                        if (type) {
	                            accessorWithTypeAnnotation = anotherAccessor;
	                        }
	                    }
	                    writeTypeOfDeclaration(node, type, getAccessorDeclarationTypeVisibilityError);
	                }
	                write(";");
	                writeLine();
	            }
	            function getTypeAnnotationFromAccessor(accessor) {
	                if (accessor) {
	                    return accessor.kind === 155 /* GetAccessor */
	                        ? accessor.type // Getter - return type
	                        : accessor.parameters.length > 0
	                            ? accessor.parameters[0].type // Setter parameter type
	                            : undefined;
	                }
	            }
	            function getAccessorNameVisibilityError(symbolAccessibilityResult) {
	                var diagnosticMessage = getAccessorNameVisibilityDiagnosticMessage(symbolAccessibilityResult);
	                return diagnosticMessage !== undefined ? {
	                    diagnosticMessage: diagnosticMessage,
	                    errorNode: node,
	                    typeName: node.name
	                } : undefined;
	            }
	            function getAccessorNameVisibilityDiagnosticMessage(symbolAccessibilityResult) {
	                if (ts.hasModifier(node, 32 /* Static */)) {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_private_name_1;
	                }
	                else if (node.parent.kind === 233 /* ClassDeclaration */) {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_private_name_1;
	                }
	                else {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Property_0_of_exported_interface_has_or_is_using_private_name_1;
	                }
	            }
	            function getAccessorDeclarationTypeVisibilityError(symbolAccessibilityResult) {
	                var diagnosticMessage;
	                if (accessorWithTypeAnnotation.kind === 156 /* SetAccessor */) {
	                    // Getters can infer the return type from the returned expression, but setters cannot, so the
	                    // "_from_external_module_1_but_cannot_be_named" case cannot occur.
	                    if (ts.hasModifier(accessorWithTypeAnnotation, 32 /* Static */)) {
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1;
	                    }
	                    else {
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1;
	                    }
	                }
	                else {
	                    if (ts.hasModifier(accessorWithTypeAnnotation, 32 /* Static */)) {
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                ts.Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1;
	                    }
	                    else {
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                ts.Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1;
	                    }
	                }
	                return {
	                    diagnosticMessage: diagnosticMessage,
	                    errorNode: accessorWithTypeAnnotation.name,
	                    typeName: accessorWithTypeAnnotation.name
	                };
	            }
	        }
	        function writeFunctionDeclaration(node) {
	            if (ts.hasDynamicName(node) && !resolver.isLateBound(node)) {
	                return;
	            }
	            // If we are emitting Method/Constructor it isn't moduleElement and hence already determined to be emitting
	            // so no need to verify if the declaration is visible
	            if (!resolver.isImplementationOfOverload(node)) {
	                emitJsDocComments(node);
	                if (node.kind === 232 /* FunctionDeclaration */) {
	                    emitModuleElementDeclarationFlags(node);
	                }
	                else if (node.kind === 153 /* MethodDeclaration */ || node.kind === 154 /* Constructor */) {
	                    emitClassMemberDeclarationFlags(ts.getModifierFlags(node));
	                }
	                if (node.kind === 232 /* FunctionDeclaration */) {
	                    write("function ");
	                    writeTextOfNode(currentText, node.name);
	                }
	                else if (node.kind === 154 /* Constructor */) {
	                    write("constructor");
	                }
	                else {
	                    writeNameOfDeclaration(node, getMethodNameVisibilityError);
	                    if (ts.hasQuestionToken(node)) {
	                        write("?");
	                    }
	                }
	                emitSignatureDeclaration(node);
	            }
	            function getMethodNameVisibilityError(symbolAccessibilityResult) {
	                var diagnosticMessage = getMethodNameVisibilityDiagnosticMessage(symbolAccessibilityResult);
	                return diagnosticMessage !== undefined ? {
	                    diagnosticMessage: diagnosticMessage,
	                    errorNode: node,
	                    typeName: node.name
	                } : undefined;
	            }
	            function getMethodNameVisibilityDiagnosticMessage(symbolAccessibilityResult) {
	                if (ts.hasModifier(node, 32 /* Static */)) {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_private_name_1;
	                }
	                else if (node.parent.kind === 233 /* ClassDeclaration */) {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Public_method_0_of_exported_class_has_or_is_using_private_name_1;
	                }
	                else {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Method_0_of_exported_interface_has_or_is_using_private_name_1;
	                }
	            }
	        }
	        function writeNameOfDeclaration(node, getSymbolAccessibilityDiagnostic) {
	            if (ts.hasDynamicName(node)) {
	                // If this node has a dynamic name, it can only be an identifier or property access because
	                // we've already skipped it otherwise.
	                ts.Debug.assert(resolver.isLateBound(node));
	                writeLateBoundNameOfDeclaration(node, getSymbolAccessibilityDiagnostic);
	            }
	            else {
	                // If this node is a computed name, it can only be a symbol, because we've already skipped
	                // it if it's not a well known symbol. In that case, the text of the name will be exactly
	                // what we want, namely the name expression enclosed in brackets.
	                writeTextOfNode(currentText, node.name);
	            }
	        }
	        function writeLateBoundNameOfDeclaration(node, getSymbolAccessibilityDiagnostic) {
	            writer.getSymbolAccessibilityDiagnostic = getSymbolAccessibilityDiagnostic;
	            var entityName = node.name.expression;
	            var visibilityResult = resolver.isEntityNameVisible(entityName, enclosingDeclaration);
	            handleSymbolAccessibilityError(visibilityResult);
	            recordTypeReferenceDirectivesIfNecessary(resolver.getTypeReferenceDirectivesForEntityName(entityName));
	            writeTextOfNode(currentText, node.name);
	        }
	        function emitSignatureDeclarationWithJsDocComments(node) {
	            emitJsDocComments(node);
	            emitSignatureDeclaration(node);
	        }
	        function emitSignatureDeclaration(node) {
	            var prevEnclosingDeclaration = enclosingDeclaration;
	            enclosingDeclaration = node;
	            var closeParenthesizedFunctionType = false;
	            if (node.kind === 159 /* IndexSignature */) {
	                // Index signature can have readonly modifier
	                emitClassMemberDeclarationFlags(ts.getModifierFlags(node));
	                write("[");
	            }
	            else {
	                if (node.kind === 154 /* Constructor */ && ts.hasModifier(node, 8 /* Private */)) {
	                    write("();");
	                    writeLine();
	                    return;
	                }
	                // Construct signature or constructor type write new Signature
	                if (node.kind === 158 /* ConstructSignature */ || node.kind === 163 /* ConstructorType */) {
	                    write("new ");
	                }
	                else if (node.kind === 162 /* FunctionType */) {
	                    var currentOutput = writer.getText();
	                    // Do not generate incorrect type when function type with type parameters is type argument
	                    // This could happen if user used space between two '<' making it error free
	                    // e.g var x: A< <Tany>(a: Tany)=>Tany>;
	                    if (node.typeParameters && currentOutput.charAt(currentOutput.length - 1) === "<") {
	                        closeParenthesizedFunctionType = true;
	                        write("(");
	                    }
	                }
	                emitTypeParameters(node.typeParameters);
	                write("(");
	            }
	            // Parameters
	            emitCommaList(node.parameters, emitParameterDeclaration);
	            if (node.kind === 159 /* IndexSignature */) {
	                write("]");
	            }
	            else {
	                write(")");
	            }
	            // If this is not a constructor and is not private, emit the return type
	            var isFunctionTypeOrConstructorType = node.kind === 162 /* FunctionType */ || node.kind === 163 /* ConstructorType */;
	            if (isFunctionTypeOrConstructorType || node.parent.kind === 165 /* TypeLiteral */) {
	                // Emit type literal signature return type only if specified
	                if (node.type) {
	                    write(isFunctionTypeOrConstructorType ? " => " : ": ");
	                    emitType(node.type);
	                }
	            }
	            else if (node.kind !== 154 /* Constructor */ && !ts.hasModifier(node, 8 /* Private */)) {
	                writeReturnTypeAtSignature(node, getReturnTypeVisibilityError);
	            }
	            enclosingDeclaration = prevEnclosingDeclaration;
	            if (!isFunctionTypeOrConstructorType) {
	                write(";");
	                writeLine();
	            }
	            else if (closeParenthesizedFunctionType) {
	                write(")");
	            }
	            function getReturnTypeVisibilityError(symbolAccessibilityResult) {
	                var diagnosticMessage;
	                switch (node.kind) {
	                    case 158 /* ConstructSignature */:
	                        // Interfaces cannot have return types that cannot be named
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 :
	                            ts.Diagnostics.Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0;
	                        break;
	                    case 157 /* CallSignature */:
	                        // Interfaces cannot have return types that cannot be named
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 :
	                            ts.Diagnostics.Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0;
	                        break;
	                    case 159 /* IndexSignature */:
	                        // Interfaces cannot have return types that cannot be named
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 :
	                            ts.Diagnostics.Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0;
	                        break;
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        if (ts.hasModifier(node, 32 /* Static */)) {
	                            diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                                symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                    ts.Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named :
	                                    ts.Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1 :
	                                ts.Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0;
	                        }
	                        else if (node.parent.kind === 233 /* ClassDeclaration */) {
	                            diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                                symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                    ts.Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named :
	                                    ts.Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1 :
	                                ts.Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0;
	                        }
	                        else {
	                            // Interfaces cannot have return types that cannot be named
	                            diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                                ts.Diagnostics.Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1 :
	                                ts.Diagnostics.Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0;
	                        }
	                        break;
	                    case 232 /* FunctionDeclaration */:
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named :
	                                ts.Diagnostics.Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1 :
	                            ts.Diagnostics.Return_type_of_exported_function_has_or_is_using_private_name_0;
	                        break;
	                    default:
	                        ts.Debug.fail("This is unknown kind for signature: " + node.kind);
	                }
	                return {
	                    diagnosticMessage: diagnosticMessage,
	                    errorNode: node.name || node
	                };
	            }
	        }
	        function emitParameterDeclaration(node) {
	            increaseIndent();
	            emitJsDocComments(node);
	            if (node.dotDotDotToken) {
	                write("...");
	            }
	            if (ts.isBindingPattern(node.name)) {
	                // For bindingPattern, we can't simply writeTextOfNode from the source file
	                // because we want to omit the initializer and using writeTextOfNode will result in initializer get emitted.
	                // Therefore, we will have to recursively emit each element in the bindingPattern.
	                emitBindingPattern(node.name);
	            }
	            else {
	                writeTextOfNode(currentText, node.name);
	            }
	            if (resolver.isOptionalParameter(node)) {
	                write("?");
	            }
	            decreaseIndent();
	            if (node.parent.kind === 162 /* FunctionType */ ||
	                node.parent.kind === 163 /* ConstructorType */ ||
	                node.parent.parent.kind === 165 /* TypeLiteral */) {
	                emitTypeOfVariableDeclarationFromTypeLiteral(node);
	            }
	            else if (!ts.hasModifier(node.parent, 8 /* Private */)) {
	                writeTypeOfDeclaration(node, node.type, getParameterDeclarationTypeVisibilityError);
	            }
	            function getParameterDeclarationTypeVisibilityError(symbolAccessibilityResult) {
	                var diagnosticMessage = getParameterDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
	                return diagnosticMessage !== undefined ? {
	                    diagnosticMessage: diagnosticMessage,
	                    errorNode: node,
	                    typeName: node.name
	                } : undefined;
	            }
	            function getParameterDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult) {
	                switch (node.parent.kind) {
	                    case 154 /* Constructor */:
	                        return symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                ts.Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1;
	                    case 158 /* ConstructSignature */:
	                        // Interfaces cannot have parameter types that cannot be named
	                        return symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1;
	                    case 157 /* CallSignature */:
	                        // Interfaces cannot have parameter types that cannot be named
	                        return symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1;
	                    case 159 /* IndexSignature */:
	                        // Interfaces cannot have parameter types that cannot be named
	                        return symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1;
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        if (ts.hasModifier(node.parent, 32 /* Static */)) {
	                            return symbolAccessibilityResult.errorModuleName ?
	                                symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                    ts.Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                    ts.Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                                ts.Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1;
	                        }
	                        else if (node.parent.parent.kind === 233 /* ClassDeclaration */) {
	                            return symbolAccessibilityResult.errorModuleName ?
	                                symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                    ts.Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                    ts.Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                                ts.Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1;
	                        }
	                        else {
	                            // Interfaces cannot have parameter types that cannot be named
	                            return symbolAccessibilityResult.errorModuleName ?
	                                ts.Diagnostics.Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                                ts.Diagnostics.Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1;
	                        }
	                    case 232 /* FunctionDeclaration */:
	                        return symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                ts.Diagnostics.Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_0_of_exported_function_has_or_is_using_private_name_1;
	                    default:
	                        ts.Debug.fail("This is unknown parent for parameter: " + node.parent.kind);
	                }
	            }
	            function emitBindingPattern(bindingPattern) {
	                // We have to explicitly emit square bracket and bracket because these tokens are not store inside the node.
	                if (bindingPattern.kind === 178 /* ObjectBindingPattern */) {
	                    write("{");
	                    emitCommaList(bindingPattern.elements, emitBindingElement);
	                    write("}");
	                }
	                else if (bindingPattern.kind === 179 /* ArrayBindingPattern */) {
	                    write("[");
	                    var elements = bindingPattern.elements;
	                    emitCommaList(elements, emitBindingElement);
	                    if (elements && elements.hasTrailingComma) {
	                        write(", ");
	                    }
	                    write("]");
	                }
	            }
	            function emitBindingElement(bindingElement) {
	                if (bindingElement.kind === 204 /* OmittedExpression */) {
	                    // If bindingElement is an omittedExpression (i.e. containing elision),
	                    // we will emit blank space (although this may differ from users' original code,
	                    // it allows emitSeparatedList to write separator appropriately)
	                    // Example:
	                    //      original: function foo([, x, ,]) {}
	                    //      tslint:disable-next-line no-double-space
	                    //      emit    : function foo([ , x,  , ]) {}
	                    write(" ");
	                }
	                else if (bindingElement.kind === 180 /* BindingElement */) {
	                    if (bindingElement.propertyName) {
	                        // bindingElement has propertyName property in the following case:
	                        //      { y: [a,b,c] ...} -> bindingPattern will have a property called propertyName for "y"
	                        // We have to explicitly emit the propertyName before descending into its binding elements.
	                        // Example:
	                        //      original: function foo({y: [a,b,c]}) {}
	                        //      emit    : declare function foo({y: [a, b, c]}: { y: [any, any, any] }) void;
	                        writeTextOfNode(currentText, bindingElement.propertyName);
	                        write(": ");
	                    }
	                    if (bindingElement.name) {
	                        if (ts.isBindingPattern(bindingElement.name)) {
	                            // If it is a nested binding pattern, we will recursively descend into each element and emit each one separately.
	                            // In the case of rest element, we will omit rest element.
	                            // Example:
	                            //      original: function foo([a, [[b]], c] = [1,[["string"]], 3]) {}
	                            //      emit    : declare function foo([a, [[b]], c]: [number, [[string]], number]): void;
	                            //      original with rest: function foo([a, ...c]) {}
	                            //      emit              : declare function foo([a, ...c]): void;
	                            emitBindingPattern(bindingElement.name);
	                        }
	                        else {
	                            ts.Debug.assert(bindingElement.name.kind === 71 /* Identifier */);
	                            // If the node is just an identifier, we will simply emit the text associated with the node's name
	                            // Example:
	                            //      original: function foo({y = 10, x}) {}
	                            //      emit    : declare function foo({y, x}: {number, any}): void;
	                            if (bindingElement.dotDotDotToken) {
	                                write("...");
	                            }
	                            writeTextOfNode(currentText, bindingElement.name);
	                        }
	                    }
	                }
	            }
	        }
	        function emitNode(node) {
	            switch (node.kind) {
	                case 232 /* FunctionDeclaration */:
	                case 237 /* ModuleDeclaration */:
	                case 241 /* ImportEqualsDeclaration */:
	                case 234 /* InterfaceDeclaration */:
	                case 233 /* ClassDeclaration */:
	                case 235 /* TypeAliasDeclaration */:
	                case 236 /* EnumDeclaration */:
	                    return emitModuleElement(node, isModuleElementVisible(node));
	                case 212 /* VariableStatement */:
	                    return emitModuleElement(node, isVariableStatementVisible(node));
	                case 242 /* ImportDeclaration */:
	                    // Import declaration without import clause is visible, otherwise it is not visible
	                    return emitModuleElement(node, /*isModuleElementVisible*/ !node.importClause);
	                case 248 /* ExportDeclaration */:
	                    return emitExportDeclaration(node);
	                case 154 /* Constructor */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    return writeFunctionDeclaration(node);
	                case 158 /* ConstructSignature */:
	                case 157 /* CallSignature */:
	                case 159 /* IndexSignature */:
	                    return emitSignatureDeclarationWithJsDocComments(node);
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return emitAccessorDeclaration(node);
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return emitPropertyDeclaration(node);
	                case 271 /* EnumMember */:
	                    return emitEnumMemberDeclaration(node);
	                case 247 /* ExportAssignment */:
	                    return emitExportAssignment(node);
	                case 272 /* SourceFile */:
	                    return emitSourceFile(node);
	            }
	        }
	        /**
	         * Adds the reference to referenced file, returns true if global file reference was emitted
	         * @param referencedFile
	         * @param addBundledFileReference Determines if global file reference corresponding to bundled file should be emitted or not
	         */
	        function writeReferencePath(referencedFile, addBundledFileReference, emitOnlyDtsFiles) {
	            var declFileName;
	            var addedBundledEmitReference = false;
	            if (referencedFile.isDeclarationFile) {
	                // Declaration file, use declaration file name
	                declFileName = referencedFile.fileName;
	            }
	            else {
	                // Get the declaration file path
	                ts.forEachEmittedFile(host, getDeclFileName, referencedFile, emitOnlyDtsFiles);
	            }
	            if (declFileName) {
	                declFileName = ts.getRelativePathToDirectoryOrUrl(ts.getDirectoryPath(ts.normalizeSlashes(declarationFilePath)), declFileName, host.getCurrentDirectory(), host.getCanonicalFileName, 
	                /*isAbsolutePathAnUrl*/ false);
	                referencesOutput += "/// <reference path=\"" + declFileName + "\" />" + newLine;
	            }
	            return addedBundledEmitReference;
	            function getDeclFileName(emitFileNames, sourceFileOrBundle) {
	                // Dont add reference path to this file if it is a bundled emit and caller asked not emit bundled file path
	                var isBundledEmit = sourceFileOrBundle.kind === 273 /* Bundle */;
	                if (isBundledEmit && !addBundledFileReference) {
	                    return;
	                }
	                ts.Debug.assert(!!emitFileNames.declarationFilePath || ts.isSourceFileJavaScript(referencedFile), "Declaration file is not present only for javascript files");
	                declFileName = emitFileNames.declarationFilePath || emitFileNames.jsFilePath;
	                addedBundledEmitReference = isBundledEmit;
	            }
	        }
	    }
	    /* @internal */
	    function writeDeclarationFile(declarationFilePath, sourceFileOrBundle, host, resolver, emitterDiagnostics, emitOnlyDtsFiles) {
	        var emitDeclarationResult = emitDeclarations(host, resolver, emitterDiagnostics, declarationFilePath, sourceFileOrBundle, emitOnlyDtsFiles);
	        var emitSkipped = emitDeclarationResult.reportedDeclarationError || host.isEmitBlocked(declarationFilePath) || host.getCompilerOptions().noEmit;
	        if (!emitSkipped || emitOnlyDtsFiles) {
	            var sourceFiles = sourceFileOrBundle.kind === 273 /* Bundle */ ? sourceFileOrBundle.sourceFiles : [sourceFileOrBundle];
	            var declarationOutput = emitDeclarationResult.referencesOutput
	                + getDeclarationOutput(emitDeclarationResult.synchronousDeclarationOutput, emitDeclarationResult.moduleElementDeclarationEmitInfo);
	            ts.writeFile(host, emitterDiagnostics, declarationFilePath, declarationOutput, host.getCompilerOptions().emitBOM, sourceFiles);
	        }
	        return emitSkipped;
	        function getDeclarationOutput(synchronousDeclarationOutput, moduleElementDeclarationEmitInfo) {
	            var appliedSyncOutputPos = 0;
	            var declarationOutput = "";
	            // apply asynchronous additions to the synchronous output
	            ts.forEach(moduleElementDeclarationEmitInfo, function (aliasEmitInfo) {
	                if (aliasEmitInfo.asynchronousOutput) {
	                    declarationOutput += synchronousDeclarationOutput.substring(appliedSyncOutputPos, aliasEmitInfo.outputPos);
	                    declarationOutput += getDeclarationOutput(aliasEmitInfo.asynchronousOutput, aliasEmitInfo.subModuleElementDeclarationEmitInfo);
	                    appliedSyncOutputPos = aliasEmitInfo.outputPos;
	                }
	            });
	            declarationOutput += synchronousDeclarationOutput.substring(appliedSyncOutputPos);
	            return declarationOutput;
	        }
	    }
	    ts.writeDeclarationFile = writeDeclarationFile;
	})(ts || (ts = {}));
	/// <reference path="checker.ts" />
	/// <reference path="transformer.ts" />
	/// <reference path="declarationEmitter.ts" />
	/// <reference path="sourcemap.ts" />
	/// <reference path="comments.ts" />
	var ts;
	(function (ts) {
	    var brackets = createBracketsMap();
	    /*@internal*/
	    /**
	     * Iterates over the source files that are expected to have an emit output.
	     *
	     * @param host An EmitHost.
	     * @param action The action to execute.
	     * @param sourceFilesOrTargetSourceFile
	     *   If an array, the full list of source files to emit.
	     *   Else, calls `getSourceFilesToEmit` with the (optional) target source file to determine the list of source files to emit.
	     */
	    function forEachEmittedFile(host, action, sourceFilesOrTargetSourceFile, emitOnlyDtsFiles) {
	        var sourceFiles = ts.isArray(sourceFilesOrTargetSourceFile) ? sourceFilesOrTargetSourceFile : ts.getSourceFilesToEmit(host, sourceFilesOrTargetSourceFile);
	        var options = host.getCompilerOptions();
	        if (options.outFile || options.out) {
	            if (sourceFiles.length) {
	                var jsFilePath = options.outFile || options.out;
	                var sourceMapFilePath = getSourceMapFilePath(jsFilePath, options);
	                var declarationFilePath = options.declaration ? ts.removeFileExtension(jsFilePath) + ".d.ts" /* Dts */ : "";
	                var result = action({ jsFilePath: jsFilePath, sourceMapFilePath: sourceMapFilePath, declarationFilePath: declarationFilePath }, ts.createBundle(sourceFiles), emitOnlyDtsFiles);
	                if (result) {
	                    return result;
	                }
	            }
	        }
	        else {
	            for (var _a = 0, sourceFiles_1 = sourceFiles; _a < sourceFiles_1.length; _a++) {
	                var sourceFile = sourceFiles_1[_a];
	                var jsFilePath = ts.getOwnEmitOutputFilePath(sourceFile, host, getOutputExtension(sourceFile, options));
	                var sourceMapFilePath = getSourceMapFilePath(jsFilePath, options);
	                var declarationFilePath = !ts.isSourceFileJavaScript(sourceFile) && (emitOnlyDtsFiles || options.declaration) ? ts.getDeclarationEmitOutputFilePath(sourceFile, host) : undefined;
	                var result = action({ jsFilePath: jsFilePath, sourceMapFilePath: sourceMapFilePath, declarationFilePath: declarationFilePath }, sourceFile, emitOnlyDtsFiles);
	                if (result) {
	                    return result;
	                }
	            }
	        }
	    }
	    ts.forEachEmittedFile = forEachEmittedFile;
	    function getSourceMapFilePath(jsFilePath, options) {
	        return options.sourceMap ? jsFilePath + ".map" : undefined;
	    }
	    // JavaScript files are always LanguageVariant.JSX, as JSX syntax is allowed in .js files also.
	    // So for JavaScript files, '.jsx' is only emitted if the input was '.jsx', and JsxEmit.Preserve.
	    // For TypeScript, the only time to emit with a '.jsx' extension, is on JSX input, and JsxEmit.Preserve
	    function getOutputExtension(sourceFile, options) {
	        if (options.jsx === 1 /* Preserve */) {
	            if (ts.isSourceFileJavaScript(sourceFile)) {
	                if (ts.fileExtensionIs(sourceFile.fileName, ".jsx" /* Jsx */)) {
	                    return ".jsx" /* Jsx */;
	                }
	            }
	            else if (sourceFile.languageVariant === 1 /* JSX */) {
	                // TypeScript source file preserving JSX syntax
	                return ".jsx" /* Jsx */;
	            }
	        }
	        return ".js" /* Js */;
	    }
	    function getOriginalSourceFileOrBundle(sourceFileOrBundle) {
	        if (sourceFileOrBundle.kind === 273 /* Bundle */) {
	            return ts.updateBundle(sourceFileOrBundle, ts.sameMap(sourceFileOrBundle.sourceFiles, ts.getOriginalSourceFile));
	        }
	        return ts.getOriginalSourceFile(sourceFileOrBundle);
	    }
	    /*@internal*/
	    // targetSourceFile is when users only want one file in entire project to be emitted. This is used in compileOnSave feature
	    function emitFiles(resolver, host, targetSourceFile, emitOnlyDtsFiles, transformers) {
	        var compilerOptions = host.getCompilerOptions();
	        var moduleKind = ts.getEmitModuleKind(compilerOptions);
	        var sourceMapDataList = compilerOptions.sourceMap || compilerOptions.inlineSourceMap ? [] : undefined;
	        var emittedFilesList = compilerOptions.listEmittedFiles ? [] : undefined;
	        var emitterDiagnostics = ts.createDiagnosticCollection();
	        var newLine = host.getNewLine();
	        var writer = ts.createTextWriter(newLine);
	        var sourceMap = ts.createSourceMapWriter(host, writer);
	        var currentSourceFile;
	        var bundledHelpers;
	        var isOwnFileEmit;
	        var emitSkipped = false;
	        var sourceFiles = ts.getSourceFilesToEmit(host, targetSourceFile);
	        // Transform the source files
	        var transform = ts.transformNodes(resolver, host, compilerOptions, sourceFiles, transformers, /*allowDtsFiles*/ false);
	        // Create a printer to print the nodes
	        var printer = createPrinter(compilerOptions, {
	            // resolver hooks
	            hasGlobalName: resolver.hasGlobalName,
	            // transform hooks
	            onEmitNode: transform.emitNodeWithNotification,
	            substituteNode: transform.substituteNode,
	            // sourcemap hooks
	            onEmitSourceMapOfNode: sourceMap.emitNodeWithSourceMap,
	            onEmitSourceMapOfToken: sourceMap.emitTokenWithSourceMap,
	            onEmitSourceMapOfPosition: sourceMap.emitPos,
	            // emitter hooks
	            onEmitHelpers: emitHelpers,
	            onSetSourceFile: setSourceFile,
	        });
	        // Emit each output file
	        ts.performance.mark("beforePrint");
	        forEachEmittedFile(host, emitSourceFileOrBundle, transform.transformed, emitOnlyDtsFiles);
	        ts.performance.measure("printTime", "beforePrint");
	        // Clean up emit nodes on parse tree
	        transform.dispose();
	        return {
	            emitSkipped: emitSkipped,
	            diagnostics: emitterDiagnostics.getDiagnostics(),
	            emittedFiles: emittedFilesList,
	            sourceMaps: sourceMapDataList
	        };
	        function emitSourceFileOrBundle(_a, sourceFileOrBundle) {
	            var jsFilePath = _a.jsFilePath, sourceMapFilePath = _a.sourceMapFilePath, declarationFilePath = _a.declarationFilePath;
	            // Make sure not to write js file and source map file if any of them cannot be written
	            if (!host.isEmitBlocked(jsFilePath) && !compilerOptions.noEmit && !compilerOptions.emitDeclarationOnly) {
	                if (!emitOnlyDtsFiles) {
	                    printSourceFileOrBundle(jsFilePath, sourceMapFilePath, sourceFileOrBundle);
	                }
	            }
	            else {
	                emitSkipped = true;
	            }
	            if (declarationFilePath) {
	                emitSkipped = ts.writeDeclarationFile(declarationFilePath, getOriginalSourceFileOrBundle(sourceFileOrBundle), host, resolver, emitterDiagnostics, emitOnlyDtsFiles) || emitSkipped;
	            }
	            if (!emitSkipped && emittedFilesList) {
	                if (!emitOnlyDtsFiles) {
	                    emittedFilesList.push(jsFilePath);
	                }
	                if (sourceMapFilePath) {
	                    emittedFilesList.push(sourceMapFilePath);
	                }
	                if (declarationFilePath) {
	                    emittedFilesList.push(declarationFilePath);
	                }
	            }
	        }
	        function printSourceFileOrBundle(jsFilePath, sourceMapFilePath, sourceFileOrBundle) {
	            var bundle = sourceFileOrBundle.kind === 273 /* Bundle */ ? sourceFileOrBundle : undefined;
	            var sourceFile = sourceFileOrBundle.kind === 272 /* SourceFile */ ? sourceFileOrBundle : undefined;
	            var sourceFiles = bundle ? bundle.sourceFiles : [sourceFile];
	            sourceMap.initialize(jsFilePath, sourceMapFilePath, sourceFileOrBundle);
	            if (bundle) {
	                bundledHelpers = ts.createMap();
	                isOwnFileEmit = false;
	                printer.writeBundle(bundle, writer);
	            }
	            else {
	                isOwnFileEmit = true;
	                printer.writeFile(sourceFile, writer);
	            }
	            writer.writeLine();
	            var sourceMappingURL = sourceMap.getSourceMappingURL();
	            if (sourceMappingURL) {
	                writer.write("//# " + "sourceMappingURL" + "=" + sourceMappingURL); // Sometimes tools can sometimes see this line as a source mapping url comment
	            }
	            // Write the source map
	            if (compilerOptions.sourceMap && !compilerOptions.inlineSourceMap) {
	                ts.writeFile(host, emitterDiagnostics, sourceMapFilePath, sourceMap.getText(), /*writeByteOrderMark*/ false, sourceFiles);
	            }
	            // Record source map data for the test harness.
	            if (sourceMapDataList) {
	                sourceMapDataList.push(sourceMap.getSourceMapData());
	            }
	            // Write the output file
	            ts.writeFile(host, emitterDiagnostics, jsFilePath, writer.getText(), compilerOptions.emitBOM, sourceFiles);
	            // Reset state
	            sourceMap.reset();
	            writer.clear();
	            currentSourceFile = undefined;
	            bundledHelpers = undefined;
	            isOwnFileEmit = false;
	        }
	        function setSourceFile(node) {
	            currentSourceFile = node;
	            sourceMap.setSourceFile(node);
	        }
	        function emitHelpers(node, writeLines) {
	            var helpersEmitted = false;
	            var bundle = node.kind === 273 /* Bundle */ ? node : undefined;
	            if (bundle && moduleKind === ts.ModuleKind.None) {
	                return;
	            }
	            var numNodes = bundle ? bundle.sourceFiles.length : 1;
	            for (var i = 0; i < numNodes; i++) {
	                var currentNode = bundle ? bundle.sourceFiles[i] : node;
	                var sourceFile = ts.isSourceFile(currentNode) ? currentNode : currentSourceFile;
	                var shouldSkip = compilerOptions.noEmitHelpers || ts.getExternalHelpersModuleName(sourceFile) !== undefined;
	                var shouldBundle = ts.isSourceFile(currentNode) && !isOwnFileEmit;
	                var helpers = ts.getEmitHelpers(currentNode);
	                if (helpers) {
	                    for (var _a = 0, _b = ts.stableSort(helpers, ts.compareEmitHelpers); _a < _b.length; _a++) {
	                        var helper = _b[_a];
	                        if (!helper.scoped) {
	                            // Skip the helper if it can be skipped and the noEmitHelpers compiler
	                            // option is set, or if it can be imported and the importHelpers compiler
	                            // option is set.
	                            if (shouldSkip)
	                                continue;
	                            // Skip the helper if it can be bundled but hasn't already been emitted and we
	                            // are emitting a bundled module.
	                            if (shouldBundle) {
	                                if (bundledHelpers.get(helper.name)) {
	                                    continue;
	                                }
	                                bundledHelpers.set(helper.name, true);
	                            }
	                        }
	                        else if (bundle) {
	                            // Skip the helper if it is scoped and we are emitting bundled helpers
	                            continue;
	                        }
	                        writeLines(helper.text);
	                        helpersEmitted = true;
	                    }
	                }
	            }
	            return helpersEmitted;
	        }
	    }
	    ts.emitFiles = emitFiles;
	    function createPrinter(printerOptions, handlers) {
	        if (printerOptions === void 0) { printerOptions = {}; }
	        if (handlers === void 0) { handlers = {}; }
	        var hasGlobalName = handlers.hasGlobalName, onEmitSourceMapOfNode = handlers.onEmitSourceMapOfNode, onEmitSourceMapOfToken = handlers.onEmitSourceMapOfToken, onEmitSourceMapOfPosition = handlers.onEmitSourceMapOfPosition, onEmitNode = handlers.onEmitNode, onEmitHelpers = handlers.onEmitHelpers, onSetSourceFile = handlers.onSetSourceFile, substituteNode = handlers.substituteNode, onBeforeEmitNodeArray = handlers.onBeforeEmitNodeArray, onAfterEmitNodeArray = handlers.onAfterEmitNodeArray, onBeforeEmitToken = handlers.onBeforeEmitToken, onAfterEmitToken = handlers.onAfterEmitToken;
	        var newLine = ts.getNewLineCharacter(printerOptions);
	        var comments = ts.createCommentWriter(printerOptions, onEmitSourceMapOfPosition);
	        var emitNodeWithComments = comments.emitNodeWithComments, emitBodyWithDetachedComments = comments.emitBodyWithDetachedComments, emitTrailingCommentsOfPosition = comments.emitTrailingCommentsOfPosition, emitLeadingCommentsOfPosition = comments.emitLeadingCommentsOfPosition;
	        var currentSourceFile;
	        var nodeIdToGeneratedName; // Map of generated names for specific nodes.
	        var autoGeneratedIdToGeneratedName; // Map of generated names for temp and loop variables.
	        var generatedNames; // Set of names generated by the NameGenerator.
	        var tempFlagsStack; // Stack of enclosing name generation scopes.
	        var tempFlags; // TempFlags for the current name generation scope.
	        var reservedNamesStack; // Stack of TempFlags reserved in enclosing name generation scopes.
	        var reservedNames; // TempFlags to reserve in nested name generation scopes.
	        var writer;
	        var ownWriter;
	        var write = writeBase;
	        var commitPendingSemicolon = ts.noop;
	        var writeSemicolon = writeSemicolonInternal;
	        var pendingSemicolon = false;
	        if (printerOptions.omitTrailingSemicolon) {
	            commitPendingSemicolon = commitPendingSemicolonInternal;
	            writeSemicolon = deferWriteSemicolon;
	        }
	        var syntheticParent = { pos: -1, end: -1 };
	        reset();
	        return {
	            // public API
	            printNode: printNode,
	            printList: printList,
	            printFile: printFile,
	            printBundle: printBundle,
	            // internal API
	            writeNode: writeNode,
	            writeList: writeList,
	            writeFile: writeFile,
	            writeBundle: writeBundle
	        };
	        function printNode(hint, node, sourceFile) {
	            switch (hint) {
	                case 0 /* SourceFile */:
	                    ts.Debug.assert(ts.isSourceFile(node), "Expected a SourceFile node.");
	                    break;
	                case 2 /* IdentifierName */:
	                    ts.Debug.assert(ts.isIdentifier(node), "Expected an Identifier node.");
	                    break;
	                case 1 /* Expression */:
	                    ts.Debug.assert(ts.isExpression(node), "Expected an Expression node.");
	                    break;
	            }
	            switch (node.kind) {
	                case 272 /* SourceFile */: return printFile(node);
	                case 273 /* Bundle */: return printBundle(node);
	            }
	            writeNode(hint, node, sourceFile, beginPrint());
	            return endPrint();
	        }
	        function printList(format, nodes, sourceFile) {
	            writeList(format, nodes, sourceFile, beginPrint());
	            return endPrint();
	        }
	        function printBundle(bundle) {
	            writeBundle(bundle, beginPrint());
	            return endPrint();
	        }
	        function printFile(sourceFile) {
	            writeFile(sourceFile, beginPrint());
	            return endPrint();
	        }
	        function writeNode(hint, node, sourceFile, output) {
	            var previousWriter = writer;
	            setWriter(output);
	            print(hint, node, sourceFile);
	            reset();
	            writer = previousWriter;
	        }
	        function writeList(format, nodes, sourceFile, output) {
	            var previousWriter = writer;
	            setWriter(output);
	            if (sourceFile) {
	                setSourceFile(sourceFile);
	            }
	            emitList(syntheticParent, nodes, format);
	            reset();
	            writer = previousWriter;
	        }
	        function writeBundle(bundle, output) {
	            var previousWriter = writer;
	            setWriter(output);
	            emitShebangIfNeeded(bundle);
	            emitPrologueDirectivesIfNeeded(bundle);
	            emitHelpersIndirect(bundle);
	            for (var _a = 0, _b = bundle.sourceFiles; _a < _b.length; _a++) {
	                var sourceFile = _b[_a];
	                print(0 /* SourceFile */, sourceFile, sourceFile);
	            }
	            reset();
	            writer = previousWriter;
	        }
	        function writeFile(sourceFile, output) {
	            var previousWriter = writer;
	            setWriter(output);
	            emitShebangIfNeeded(sourceFile);
	            emitPrologueDirectivesIfNeeded(sourceFile);
	            print(0 /* SourceFile */, sourceFile, sourceFile);
	            reset();
	            writer = previousWriter;
	        }
	        function beginPrint() {
	            return ownWriter || (ownWriter = ts.createTextWriter(newLine));
	        }
	        function endPrint() {
	            var text = ownWriter.getText();
	            ownWriter.clear();
	            return text;
	        }
	        function print(hint, node, sourceFile) {
	            if (sourceFile) {
	                setSourceFile(sourceFile);
	            }
	            pipelineEmitWithNotification(hint, node);
	        }
	        function setSourceFile(sourceFile) {
	            currentSourceFile = sourceFile;
	            comments.setSourceFile(sourceFile);
	            if (onSetSourceFile) {
	                onSetSourceFile(sourceFile);
	            }
	        }
	        function setWriter(output) {
	            writer = output;
	            comments.setWriter(output);
	        }
	        function reset() {
	            nodeIdToGeneratedName = [];
	            autoGeneratedIdToGeneratedName = [];
	            generatedNames = ts.createMap();
	            tempFlagsStack = [];
	            tempFlags = 0 /* Auto */;
	            reservedNamesStack = [];
	            comments.reset();
	            setWriter(/*output*/ undefined);
	        }
	        // TODO: Should this just be `emit`?
	        // See https://github.com/Microsoft/TypeScript/pull/18284#discussion_r137611034
	        function emitIfPresent(node) {
	            if (node) {
	                emit(node);
	            }
	        }
	        function emit(node) {
	            pipelineEmitWithNotification(4 /* Unspecified */, node);
	        }
	        function emitIdentifierName(node) {
	            pipelineEmitWithNotification(2 /* IdentifierName */, node);
	        }
	        function emitExpression(node) {
	            pipelineEmitWithNotification(1 /* Expression */, node);
	        }
	        function pipelineEmitWithNotification(hint, node) {
	            if (onEmitNode) {
	                onEmitNode(hint, node, pipelineEmitWithComments);
	            }
	            else {
	                pipelineEmitWithComments(hint, node);
	            }
	        }
	        function pipelineEmitWithComments(hint, node) {
	            node = trySubstituteNode(hint, node);
	            if (emitNodeWithComments && hint !== 0 /* SourceFile */) {
	                emitNodeWithComments(hint, node, pipelineEmitWithSourceMap);
	            }
	            else {
	                pipelineEmitWithSourceMap(hint, node);
	            }
	        }
	        function pipelineEmitWithSourceMap(hint, node) {
	            if (onEmitSourceMapOfNode && hint !== 0 /* SourceFile */ && hint !== 2 /* IdentifierName */) {
	                onEmitSourceMapOfNode(hint, node, pipelineEmitWithHint);
	            }
	            else {
	                pipelineEmitWithHint(hint, node);
	            }
	        }
	        function pipelineEmitWithHint(hint, node) {
	            switch (hint) {
	                case 0 /* SourceFile */: return pipelineEmitSourceFile(node);
	                case 2 /* IdentifierName */: return pipelineEmitIdentifierName(node);
	                case 1 /* Expression */: return pipelineEmitExpression(node);
	                case 3 /* MappedTypeParameter */: return emitMappedTypeParameter(ts.cast(node, ts.isTypeParameterDeclaration));
	                case 4 /* Unspecified */: return pipelineEmitUnspecified(node);
	            }
	        }
	        function pipelineEmitSourceFile(node) {
	            ts.Debug.assertNode(node, ts.isSourceFile);
	            emitSourceFile(node);
	        }
	        function pipelineEmitIdentifierName(node) {
	            ts.Debug.assertNode(node, ts.isIdentifier);
	            emitIdentifier(node);
	        }
	        function emitMappedTypeParameter(node) {
	            emit(node.name);
	            writeSpace();
	            writeKeyword("in");
	            writeSpace();
	            emit(node.constraint);
	        }
	        function pipelineEmitUnspecified(node) {
	            var kind = node.kind;
	            // Reserved words
	            // Strict mode reserved words
	            // Contextual keywords
	            if (ts.isKeyword(kind)) {
	                writeTokenNode(node, writeKeyword);
	                return;
	            }
	            switch (kind) {
	                // Pseudo-literals
	                case 14 /* TemplateHead */:
	                case 15 /* TemplateMiddle */:
	                case 16 /* TemplateTail */:
	                    return emitLiteral(node);
	                // Identifiers
	                case 71 /* Identifier */:
	                    return emitIdentifier(node);
	                // Parse tree nodes
	                // Names
	                case 145 /* QualifiedName */:
	                    return emitQualifiedName(node);
	                case 146 /* ComputedPropertyName */:
	                    return emitComputedPropertyName(node);
	                // Signature elements
	                case 147 /* TypeParameter */:
	                    return emitTypeParameter(node);
	                case 148 /* Parameter */:
	                    return emitParameter(node);
	                case 149 /* Decorator */:
	                    return emitDecorator(node);
	                // Type members
	                case 150 /* PropertySignature */:
	                    return emitPropertySignature(node);
	                case 151 /* PropertyDeclaration */:
	                    return emitPropertyDeclaration(node);
	                case 152 /* MethodSignature */:
	                    return emitMethodSignature(node);
	                case 153 /* MethodDeclaration */:
	                    return emitMethodDeclaration(node);
	                case 154 /* Constructor */:
	                    return emitConstructor(node);
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return emitAccessorDeclaration(node);
	                case 157 /* CallSignature */:
	                    return emitCallSignature(node);
	                case 158 /* ConstructSignature */:
	                    return emitConstructSignature(node);
	                case 159 /* IndexSignature */:
	                    return emitIndexSignature(node);
	                // Types
	                case 160 /* TypePredicate */:
	                    return emitTypePredicate(node);
	                case 161 /* TypeReference */:
	                    return emitTypeReference(node);
	                case 162 /* FunctionType */:
	                    return emitFunctionType(node);
	                case 280 /* JSDocFunctionType */:
	                    return emitJSDocFunctionType(node);
	                case 163 /* ConstructorType */:
	                    return emitConstructorType(node);
	                case 164 /* TypeQuery */:
	                    return emitTypeQuery(node);
	                case 165 /* TypeLiteral */:
	                    return emitTypeLiteral(node);
	                case 166 /* ArrayType */:
	                    return emitArrayType(node);
	                case 167 /* TupleType */:
	                    return emitTupleType(node);
	                case 168 /* UnionType */:
	                    return emitUnionType(node);
	                case 169 /* IntersectionType */:
	                    return emitIntersectionType(node);
	                case 170 /* ConditionalType */:
	                    return emitConditionalType(node);
	                case 171 /* InferType */:
	                    return emitInferType(node);
	                case 172 /* ParenthesizedType */:
	                    return emitParenthesizedType(node);
	                case 205 /* ExpressionWithTypeArguments */:
	                    return emitExpressionWithTypeArguments(node);
	                case 173 /* ThisType */:
	                    return emitThisType();
	                case 174 /* TypeOperator */:
	                    return emitTypeOperator(node);
	                case 175 /* IndexedAccessType */:
	                    return emitIndexedAccessType(node);
	                case 176 /* MappedType */:
	                    return emitMappedType(node);
	                case 177 /* LiteralType */:
	                    return emitLiteralType(node);
	                case 275 /* JSDocAllType */:
	                    write("*");
	                    return;
	                case 276 /* JSDocUnknownType */:
	                    write("?");
	                    return;
	                case 277 /* JSDocNullableType */:
	                    return emitJSDocNullableType(node);
	                case 278 /* JSDocNonNullableType */:
	                    return emitJSDocNonNullableType(node);
	                case 279 /* JSDocOptionalType */:
	                    return emitJSDocOptionalType(node);
	                case 281 /* JSDocVariadicType */:
	                    return emitJSDocVariadicType(node);
	                // Binding patterns
	                case 178 /* ObjectBindingPattern */:
	                    return emitObjectBindingPattern(node);
	                case 179 /* ArrayBindingPattern */:
	                    return emitArrayBindingPattern(node);
	                case 180 /* BindingElement */:
	                    return emitBindingElement(node);
	                // Misc
	                case 209 /* TemplateSpan */:
	                    return emitTemplateSpan(node);
	                case 210 /* SemicolonClassElement */:
	                    return emitSemicolonClassElement();
	                // Statements
	                case 211 /* Block */:
	                    return emitBlock(node);
	                case 212 /* VariableStatement */:
	                    return emitVariableStatement(node);
	                case 213 /* EmptyStatement */:
	                    return emitEmptyStatement();
	                case 214 /* ExpressionStatement */:
	                    return emitExpressionStatement(node);
	                case 215 /* IfStatement */:
	                    return emitIfStatement(node);
	                case 216 /* DoStatement */:
	                    return emitDoStatement(node);
	                case 217 /* WhileStatement */:
	                    return emitWhileStatement(node);
	                case 218 /* ForStatement */:
	                    return emitForStatement(node);
	                case 219 /* ForInStatement */:
	                    return emitForInStatement(node);
	                case 220 /* ForOfStatement */:
	                    return emitForOfStatement(node);
	                case 221 /* ContinueStatement */:
	                    return emitContinueStatement(node);
	                case 222 /* BreakStatement */:
	                    return emitBreakStatement(node);
	                case 223 /* ReturnStatement */:
	                    return emitReturnStatement(node);
	                case 224 /* WithStatement */:
	                    return emitWithStatement(node);
	                case 225 /* SwitchStatement */:
	                    return emitSwitchStatement(node);
	                case 226 /* LabeledStatement */:
	                    return emitLabeledStatement(node);
	                case 227 /* ThrowStatement */:
	                    return emitThrowStatement(node);
	                case 228 /* TryStatement */:
	                    return emitTryStatement(node);
	                case 229 /* DebuggerStatement */:
	                    return emitDebuggerStatement(node);
	                // Declarations
	                case 230 /* VariableDeclaration */:
	                    return emitVariableDeclaration(node);
	                case 231 /* VariableDeclarationList */:
	                    return emitVariableDeclarationList(node);
	                case 232 /* FunctionDeclaration */:
	                    return emitFunctionDeclaration(node);
	                case 233 /* ClassDeclaration */:
	                    return emitClassDeclaration(node);
	                case 234 /* InterfaceDeclaration */:
	                    return emitInterfaceDeclaration(node);
	                case 235 /* TypeAliasDeclaration */:
	                    return emitTypeAliasDeclaration(node);
	                case 236 /* EnumDeclaration */:
	                    return emitEnumDeclaration(node);
	                case 237 /* ModuleDeclaration */:
	                    return emitModuleDeclaration(node);
	                case 238 /* ModuleBlock */:
	                    return emitModuleBlock(node);
	                case 239 /* CaseBlock */:
	                    return emitCaseBlock(node);
	                case 240 /* NamespaceExportDeclaration */:
	                    return emitNamespaceExportDeclaration(node);
	                case 241 /* ImportEqualsDeclaration */:
	                    return emitImportEqualsDeclaration(node);
	                case 242 /* ImportDeclaration */:
	                    return emitImportDeclaration(node);
	                case 243 /* ImportClause */:
	                    return emitImportClause(node);
	                case 244 /* NamespaceImport */:
	                    return emitNamespaceImport(node);
	                case 245 /* NamedImports */:
	                    return emitNamedImports(node);
	                case 246 /* ImportSpecifier */:
	                    return emitImportSpecifier(node);
	                case 247 /* ExportAssignment */:
	                    return emitExportAssignment(node);
	                case 248 /* ExportDeclaration */:
	                    return emitExportDeclaration(node);
	                case 249 /* NamedExports */:
	                    return emitNamedExports(node);
	                case 250 /* ExportSpecifier */:
	                    return emitExportSpecifier(node);
	                case 251 /* MissingDeclaration */:
	                    return;
	                // Module references
	                case 252 /* ExternalModuleReference */:
	                    return emitExternalModuleReference(node);
	                // JSX (non-expression)
	                case 10 /* JsxText */:
	                    return emitJsxText(node);
	                case 255 /* JsxOpeningElement */:
	                case 258 /* JsxOpeningFragment */:
	                    return emitJsxOpeningElementOrFragment(node);
	                case 256 /* JsxClosingElement */:
	                case 259 /* JsxClosingFragment */:
	                    return emitJsxClosingElementOrFragment(node);
	                case 260 /* JsxAttribute */:
	                    return emitJsxAttribute(node);
	                case 261 /* JsxAttributes */:
	                    return emitJsxAttributes(node);
	                case 262 /* JsxSpreadAttribute */:
	                    return emitJsxSpreadAttribute(node);
	                case 263 /* JsxExpression */:
	                    return emitJsxExpression(node);
	                // Clauses
	                case 264 /* CaseClause */:
	                    return emitCaseClause(node);
	                case 265 /* DefaultClause */:
	                    return emitDefaultClause(node);
	                case 266 /* HeritageClause */:
	                    return emitHeritageClause(node);
	                case 267 /* CatchClause */:
	                    return emitCatchClause(node);
	                // Property assignments
	                case 268 /* PropertyAssignment */:
	                    return emitPropertyAssignment(node);
	                case 269 /* ShorthandPropertyAssignment */:
	                    return emitShorthandPropertyAssignment(node);
	                case 270 /* SpreadAssignment */:
	                    return emitSpreadAssignment(node);
	                // Enum
	                case 271 /* EnumMember */:
	                    return emitEnumMember(node);
	            }
	            // If the node is an expression, try to emit it as an expression with
	            // substitution.
	            if (ts.isExpression(node)) {
	                return pipelineEmitExpression(trySubstituteNode(1 /* Expression */, node));
	            }
	            if (ts.isToken(node)) {
	                writeTokenNode(node, writePunctuation);
	                return;
	            }
	        }
	        function pipelineEmitExpression(node) {
	            var kind = node.kind;
	            switch (kind) {
	                // Literals
	                case 8 /* NumericLiteral */:
	                    return emitNumericLiteral(node);
	                case 9 /* StringLiteral */:
	                case 12 /* RegularExpressionLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                    return emitLiteral(node);
	                // Identifiers
	                case 71 /* Identifier */:
	                    return emitIdentifier(node);
	                // Reserved words
	                case 86 /* FalseKeyword */:
	                case 95 /* NullKeyword */:
	                case 97 /* SuperKeyword */:
	                case 101 /* TrueKeyword */:
	                case 99 /* ThisKeyword */:
	                case 91 /* ImportKeyword */:
	                    writeTokenNode(node, writeKeyword);
	                    return;
	                // Expressions
	                case 181 /* ArrayLiteralExpression */:
	                    return emitArrayLiteralExpression(node);
	                case 182 /* ObjectLiteralExpression */:
	                    return emitObjectLiteralExpression(node);
	                case 183 /* PropertyAccessExpression */:
	                    return emitPropertyAccessExpression(node);
	                case 184 /* ElementAccessExpression */:
	                    return emitElementAccessExpression(node);
	                case 185 /* CallExpression */:
	                    return emitCallExpression(node);
	                case 186 /* NewExpression */:
	                    return emitNewExpression(node);
	                case 187 /* TaggedTemplateExpression */:
	                    return emitTaggedTemplateExpression(node);
	                case 188 /* TypeAssertionExpression */:
	                    return emitTypeAssertionExpression(node);
	                case 189 /* ParenthesizedExpression */:
	                    return emitParenthesizedExpression(node);
	                case 190 /* FunctionExpression */:
	                    return emitFunctionExpression(node);
	                case 191 /* ArrowFunction */:
	                    return emitArrowFunction(node);
	                case 192 /* DeleteExpression */:
	                    return emitDeleteExpression(node);
	                case 193 /* TypeOfExpression */:
	                    return emitTypeOfExpression(node);
	                case 194 /* VoidExpression */:
	                    return emitVoidExpression(node);
	                case 195 /* AwaitExpression */:
	                    return emitAwaitExpression(node);
	                case 196 /* PrefixUnaryExpression */:
	                    return emitPrefixUnaryExpression(node);
	                case 197 /* PostfixUnaryExpression */:
	                    return emitPostfixUnaryExpression(node);
	                case 198 /* BinaryExpression */:
	                    return emitBinaryExpression(node);
	                case 199 /* ConditionalExpression */:
	                    return emitConditionalExpression(node);
	                case 200 /* TemplateExpression */:
	                    return emitTemplateExpression(node);
	                case 201 /* YieldExpression */:
	                    return emitYieldExpression(node);
	                case 202 /* SpreadElement */:
	                    return emitSpreadExpression(node);
	                case 203 /* ClassExpression */:
	                    return emitClassExpression(node);
	                case 204 /* OmittedExpression */:
	                    return;
	                case 206 /* AsExpression */:
	                    return emitAsExpression(node);
	                case 207 /* NonNullExpression */:
	                    return emitNonNullExpression(node);
	                case 208 /* MetaProperty */:
	                    return emitMetaProperty(node);
	                // JSX
	                case 253 /* JsxElement */:
	                    return emitJsxElement(node);
	                case 254 /* JsxSelfClosingElement */:
	                    return emitJsxSelfClosingElement(node);
	                case 257 /* JsxFragment */:
	                    return emitJsxFragment(node);
	                // Transformation nodes
	                case 295 /* PartiallyEmittedExpression */:
	                    return emitPartiallyEmittedExpression(node);
	                case 296 /* CommaListExpression */:
	                    return emitCommaList(node);
	            }
	        }
	        function trySubstituteNode(hint, node) {
	            return node && substituteNode && substituteNode(hint, node) || node;
	        }
	        function emitHelpersIndirect(node) {
	            if (onEmitHelpers) {
	                onEmitHelpers(node, writeLines);
	            }
	        }
	        //
	        // Literals/Pseudo-literals
	        //
	        // SyntaxKind.NumericLiteral
	        function emitNumericLiteral(node) {
	            emitLiteral(node);
	        }
	        // SyntaxKind.StringLiteral
	        // SyntaxKind.RegularExpressionLiteral
	        // SyntaxKind.NoSubstitutionTemplateLiteral
	        // SyntaxKind.TemplateHead
	        // SyntaxKind.TemplateMiddle
	        // SyntaxKind.TemplateTail
	        function emitLiteral(node) {
	            var text = getLiteralTextOfNode(node);
	            if ((printerOptions.sourceMap || printerOptions.inlineSourceMap)
	                && (node.kind === 9 /* StringLiteral */ || ts.isTemplateLiteralKind(node.kind))) {
	                writeLiteral(text);
	            }
	            else {
	                // Quick info expects all literals to be called with writeStringLiteral, as there's no specific type for numberLiterals
	                writeStringLiteral(text);
	            }
	        }
	        //
	        // Identifiers
	        //
	        function emitIdentifier(node) {
	            var writeText = node.symbol ? writeSymbol : write;
	            writeText(getTextOfNode(node, /*includeTrivia*/ false), node.symbol);
	            emitList(node, node.typeArguments, 26896 /* TypeParameters */); // Call emitList directly since it could be an array of TypeParameterDeclarations _or_ type arguments
	        }
	        //
	        // Names
	        //
	        function emitQualifiedName(node) {
	            emitEntityName(node.left);
	            writePunctuation(".");
	            emit(node.right);
	        }
	        function emitEntityName(node) {
	            if (node.kind === 71 /* Identifier */) {
	                emitExpression(node);
	            }
	            else {
	                emit(node);
	            }
	        }
	        function emitComputedPropertyName(node) {
	            writePunctuation("[");
	            emitExpression(node.expression);
	            writePunctuation("]");
	        }
	        //
	        // Signature elements
	        //
	        function emitTypeParameter(node) {
	            emit(node.name);
	            if (node.constraint) {
	                writeSpace();
	                writeKeyword("extends");
	                writeSpace();
	                emit(node.constraint);
	            }
	            if (node.default) {
	                writeSpace();
	                writeOperator("=");
	                writeSpace();
	                emit(node.default);
	            }
	        }
	        function emitParameter(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitIfPresent(node.dotDotDotToken);
	            if (node.name) {
	                emitNodeWithWriter(node.name, writeParameter);
	            }
	            emitIfPresent(node.questionToken);
	            if (node.parent && node.parent.kind === 280 /* JSDocFunctionType */ && !node.name) {
	                emit(node.type);
	            }
	            else {
	                emitTypeAnnotation(node.type);
	            }
	            emitInitializer(node.initializer);
	        }
	        function emitDecorator(decorator) {
	            writePunctuation("@");
	            emitExpression(decorator.expression);
	        }
	        //
	        // Type members
	        //
	        function emitPropertySignature(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitNodeWithWriter(node.name, writeProperty);
	            emitIfPresent(node.questionToken);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	        }
	        function emitPropertyDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emit(node.name);
	            emitIfPresent(node.questionToken);
	            emitIfPresent(node.exclamationToken);
	            emitTypeAnnotation(node.type);
	            emitInitializer(node.initializer);
	            writeSemicolon();
	        }
	        function emitMethodSignature(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emit(node.name);
	            emitIfPresent(node.questionToken);
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	        }
	        function emitMethodDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitIfPresent(node.asteriskToken);
	            emit(node.name);
	            emitIfPresent(node.questionToken);
	            emitSignatureAndBody(node, emitSignatureHead);
	        }
	        function emitConstructor(node) {
	            emitModifiers(node, node.modifiers);
	            writeKeyword("constructor");
	            emitSignatureAndBody(node, emitSignatureHead);
	        }
	        function emitAccessorDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword(node.kind === 155 /* GetAccessor */ ? "get" : "set");
	            writeSpace();
	            emit(node.name);
	            emitSignatureAndBody(node, emitSignatureHead);
	        }
	        function emitCallSignature(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	        }
	        function emitConstructSignature(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("new");
	            writeSpace();
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	        }
	        function emitIndexSignature(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitParametersForIndexSignature(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	        }
	        function emitSemicolonClassElement() {
	            writeSemicolon();
	        }
	        //
	        // Types
	        //
	        function emitTypePredicate(node) {
	            emit(node.parameterName);
	            writeSpace();
	            writeKeyword("is");
	            writeSpace();
	            emit(node.type);
	        }
	        function emitTypeReference(node) {
	            emit(node.typeName);
	            emitTypeArguments(node, node.typeArguments);
	        }
	        function emitFunctionType(node) {
	            emitTypeParameters(node, node.typeParameters);
	            emitParametersForArrow(node, node.parameters);
	            writeSpace();
	            writePunctuation("=>");
	            writeSpace();
	            emit(node.type);
	        }
	        function emitJSDocFunctionType(node) {
	            write("function");
	            emitParameters(node, node.parameters);
	            write(":");
	            emit(node.type);
	        }
	        function emitJSDocNullableType(node) {
	            write("?");
	            emit(node.type);
	        }
	        function emitJSDocNonNullableType(node) {
	            write("!");
	            emit(node.type);
	        }
	        function emitJSDocOptionalType(node) {
	            emit(node.type);
	            write("=");
	        }
	        function emitConstructorType(node) {
	            writeKeyword("new");
	            writeSpace();
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            writeSpace();
	            writePunctuation("=>");
	            writeSpace();
	            emit(node.type);
	        }
	        function emitTypeQuery(node) {
	            writeKeyword("typeof");
	            writeSpace();
	            emit(node.exprName);
	        }
	        function emitTypeLiteral(node) {
	            writePunctuation("{");
	            var flags = ts.getEmitFlags(node) & 1 /* SingleLine */ ? 448 /* SingleLineTypeLiteralMembers */ : 65 /* MultiLineTypeLiteralMembers */;
	            emitList(node, node.members, flags | 262144 /* NoSpaceIfEmpty */);
	            writePunctuation("}");
	        }
	        function emitArrayType(node) {
	            emit(node.elementType);
	            writePunctuation("[");
	            writePunctuation("]");
	        }
	        function emitJSDocVariadicType(node) {
	            write("...");
	            emit(node.type);
	        }
	        function emitTupleType(node) {
	            writePunctuation("[");
	            emitList(node, node.elementTypes, 336 /* TupleTypeElements */);
	            writePunctuation("]");
	        }
	        function emitUnionType(node) {
	            emitList(node, node.types, 260 /* UnionTypeConstituents */);
	        }
	        function emitIntersectionType(node) {
	            emitList(node, node.types, 264 /* IntersectionTypeConstituents */);
	        }
	        function emitConditionalType(node) {
	            emit(node.checkType);
	            writeSpace();
	            writeKeyword("extends");
	            writeSpace();
	            emit(node.extendsType);
	            writeSpace();
	            writePunctuation("?");
	            writeSpace();
	            emit(node.trueType);
	            writeSpace();
	            writePunctuation(":");
	            writeSpace();
	            emit(node.falseType);
	        }
	        function emitInferType(node) {
	            writeKeyword("infer");
	            writeSpace();
	            emit(node.typeParameter);
	        }
	        function emitParenthesizedType(node) {
	            writePunctuation("(");
	            emit(node.type);
	            writePunctuation(")");
	        }
	        function emitThisType() {
	            writeKeyword("this");
	        }
	        function emitTypeOperator(node) {
	            writeTokenText(node.operator, writeKeyword);
	            writeSpace();
	            emit(node.type);
	        }
	        function emitIndexedAccessType(node) {
	            emit(node.objectType);
	            writePunctuation("[");
	            emit(node.indexType);
	            writePunctuation("]");
	        }
	        function emitMappedType(node) {
	            var emitFlags = ts.getEmitFlags(node);
	            writePunctuation("{");
	            if (emitFlags & 1 /* SingleLine */) {
	                writeSpace();
	            }
	            else {
	                writeLine();
	                increaseIndent();
	            }
	            if (node.readonlyToken) {
	                emit(node.readonlyToken);
	                if (node.readonlyToken.kind !== 132 /* ReadonlyKeyword */) {
	                    writeKeyword("readonly");
	                }
	                writeSpace();
	            }
	            writePunctuation("[");
	            pipelineEmitWithNotification(3 /* MappedTypeParameter */, node.typeParameter);
	            writePunctuation("]");
	            if (node.questionToken) {
	                emit(node.questionToken);
	                if (node.questionToken.kind !== 55 /* QuestionToken */) {
	                    writePunctuation("?");
	                }
	            }
	            writePunctuation(":");
	            writeSpace();
	            emit(node.type);
	            writeSemicolon();
	            if (emitFlags & 1 /* SingleLine */) {
	                writeSpace();
	            }
	            else {
	                writeLine();
	                decreaseIndent();
	            }
	            writePunctuation("}");
	        }
	        function emitLiteralType(node) {
	            emitExpression(node.literal);
	        }
	        //
	        // Binding patterns
	        //
	        function emitObjectBindingPattern(node) {
	            writePunctuation("{");
	            emitList(node, node.elements, 262576 /* ObjectBindingPatternElements */);
	            writePunctuation("}");
	        }
	        function emitArrayBindingPattern(node) {
	            writePunctuation("[");
	            emitList(node, node.elements, 262448 /* ArrayBindingPatternElements */);
	            writePunctuation("]");
	        }
	        function emitBindingElement(node) {
	            emitIfPresent(node.dotDotDotToken);
	            if (node.propertyName) {
	                emit(node.propertyName);
	                writePunctuation(":");
	                writeSpace();
	            }
	            emit(node.name);
	            emitInitializer(node.initializer);
	        }
	        //
	        // Expressions
	        //
	        function emitArrayLiteralExpression(node) {
	            var elements = node.elements;
	            var preferNewLine = node.multiLine ? 32768 /* PreferNewLine */ : 0 /* None */;
	            emitExpressionList(node, elements, 4466 /* ArrayLiteralExpressionElements */ | preferNewLine);
	        }
	        function emitObjectLiteralExpression(node) {
	            var indentedFlag = ts.getEmitFlags(node) & 65536 /* Indented */;
	            if (indentedFlag) {
	                increaseIndent();
	            }
	            var preferNewLine = node.multiLine ? 32768 /* PreferNewLine */ : 0 /* None */;
	            var allowTrailingComma = currentSourceFile.languageVersion >= 1 /* ES5 */ ? 32 /* AllowTrailingComma */ : 0 /* None */;
	            emitList(node, node.properties, 263122 /* ObjectLiteralExpressionProperties */ | allowTrailingComma | preferNewLine);
	            if (indentedFlag) {
	                decreaseIndent();
	            }
	        }
	        function emitPropertyAccessExpression(node) {
	            var indentBeforeDot = false;
	            var indentAfterDot = false;
	            if (!(ts.getEmitFlags(node) & 131072 /* NoIndentation */)) {
	                var dotRangeStart = node.expression.end;
	                var dotRangeEnd = ts.skipTrivia(currentSourceFile.text, node.expression.end) + 1;
	                var dotToken = ts.createToken(23 /* DotToken */);
	                dotToken.pos = dotRangeStart;
	                dotToken.end = dotRangeEnd;
	                indentBeforeDot = needsIndentation(node, node.expression, dotToken);
	                indentAfterDot = needsIndentation(node, dotToken, node.name);
	            }
	            emitExpression(node.expression);
	            increaseIndentIf(indentBeforeDot);
	            var shouldEmitDotDot = !indentBeforeDot && needsDotDotForPropertyAccess(node.expression);
	            writePunctuation(shouldEmitDotDot ? ".." : ".");
	            increaseIndentIf(indentAfterDot);
	            emit(node.name);
	            decreaseIndentIf(indentBeforeDot, indentAfterDot);
	        }
	        // 1..toString is a valid property access, emit a dot after the literal
	        // Also emit a dot if expression is a integer const enum value - it will appear in generated code as numeric literal
	        function needsDotDotForPropertyAccess(expression) {
	            expression = ts.skipPartiallyEmittedExpressions(expression);
	            if (ts.isNumericLiteral(expression)) {
	                // check if numeric literal is a decimal literal that was originally written with a dot
	                var text = getLiteralTextOfNode(expression);
	                return !expression.numericLiteralFlags
	                    && !ts.stringContains(text, ts.tokenToString(23 /* DotToken */));
	            }
	            else if (ts.isPropertyAccessExpression(expression) || ts.isElementAccessExpression(expression)) {
	                // check if constant enum value is integer
	                var constantValue = ts.getConstantValue(expression);
	                // isFinite handles cases when constantValue is undefined
	                return typeof constantValue === "number" && isFinite(constantValue)
	                    && Math.floor(constantValue) === constantValue
	                    && printerOptions.removeComments;
	            }
	        }
	        function emitElementAccessExpression(node) {
	            emitExpression(node.expression);
	            writePunctuation("[");
	            emitExpression(node.argumentExpression);
	            writePunctuation("]");
	        }
	        function emitCallExpression(node) {
	            emitExpression(node.expression);
	            emitTypeArguments(node, node.typeArguments);
	            emitExpressionList(node, node.arguments, 1296 /* CallExpressionArguments */);
	        }
	        function emitNewExpression(node) {
	            writeKeyword("new");
	            writeSpace();
	            emitExpression(node.expression);
	            emitTypeArguments(node, node.typeArguments);
	            emitExpressionList(node, node.arguments, 9488 /* NewExpressionArguments */);
	        }
	        function emitTaggedTemplateExpression(node) {
	            emitExpression(node.tag);
	            writeSpace();
	            emitExpression(node.template);
	        }
	        function emitTypeAssertionExpression(node) {
	            writePunctuation("<");
	            emit(node.type);
	            writePunctuation(">");
	            emitExpression(node.expression);
	        }
	        function emitParenthesizedExpression(node) {
	            writePunctuation("(");
	            emitExpression(node.expression);
	            writePunctuation(")");
	        }
	        function emitFunctionExpression(node) {
	            emitFunctionDeclarationOrExpression(node);
	        }
	        function emitArrowFunction(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitSignatureAndBody(node, emitArrowFunctionHead);
	        }
	        function emitArrowFunctionHead(node) {
	            emitTypeParameters(node, node.typeParameters);
	            emitParametersForArrow(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSpace();
	            emit(node.equalsGreaterThanToken);
	        }
	        function emitDeleteExpression(node) {
	            writeKeyword("delete");
	            writeSpace();
	            emitExpression(node.expression);
	        }
	        function emitTypeOfExpression(node) {
	            writeKeyword("typeof");
	            writeSpace();
	            emitExpression(node.expression);
	        }
	        function emitVoidExpression(node) {
	            writeKeyword("void");
	            writeSpace();
	            emitExpression(node.expression);
	        }
	        function emitAwaitExpression(node) {
	            writeKeyword("await");
	            writeSpace();
	            emitExpression(node.expression);
	        }
	        function emitPrefixUnaryExpression(node) {
	            writeTokenText(node.operator, writeOperator);
	            if (shouldEmitWhitespaceBeforeOperand(node)) {
	                writeSpace();
	            }
	            emitExpression(node.operand);
	        }
	        function shouldEmitWhitespaceBeforeOperand(node) {
	            // In some cases, we need to emit a space between the operator and the operand. One obvious case
	            // is when the operator is an identifier, like delete or typeof. We also need to do this for plus
	            // and minus expressions in certain cases. Specifically, consider the following two cases (parens
	            // are just for clarity of exposition, and not part of the source code):
	            //
	            //  (+(+1))
	            //  (+(++1))
	            //
	            // We need to emit a space in both cases. In the first case, the absence of a space will make
	            // the resulting expression a prefix increment operation. And in the second, it will make the resulting
	            // expression a prefix increment whose operand is a plus expression - (++(+x))
	            // The same is true of minus of course.
	            var operand = node.operand;
	            return operand.kind === 196 /* PrefixUnaryExpression */
	                && ((node.operator === 37 /* PlusToken */ && (operand.operator === 37 /* PlusToken */ || operand.operator === 43 /* PlusPlusToken */))
	                    || (node.operator === 38 /* MinusToken */ && (operand.operator === 38 /* MinusToken */ || operand.operator === 44 /* MinusMinusToken */)));
	        }
	        function emitPostfixUnaryExpression(node) {
	            emitExpression(node.operand);
	            writeTokenText(node.operator, writeOperator);
	        }
	        function emitBinaryExpression(node) {
	            var isCommaOperator = node.operatorToken.kind !== 26 /* CommaToken */;
	            var indentBeforeOperator = needsIndentation(node, node.left, node.operatorToken);
	            var indentAfterOperator = needsIndentation(node, node.operatorToken, node.right);
	            emitExpression(node.left);
	            increaseIndentIf(indentBeforeOperator, isCommaOperator ? " " : undefined);
	            emitLeadingCommentsOfPosition(node.operatorToken.pos);
	            writeTokenNode(node.operatorToken, writeOperator);
	            emitTrailingCommentsOfPosition(node.operatorToken.end, /*prefixSpace*/ true); // Binary operators should have a space before the comment starts
	            increaseIndentIf(indentAfterOperator, " ");
	            emitExpression(node.right);
	            decreaseIndentIf(indentBeforeOperator, indentAfterOperator);
	        }
	        function emitConditionalExpression(node) {
	            var indentBeforeQuestion = needsIndentation(node, node.condition, node.questionToken);
	            var indentAfterQuestion = needsIndentation(node, node.questionToken, node.whenTrue);
	            var indentBeforeColon = needsIndentation(node, node.whenTrue, node.colonToken);
	            var indentAfterColon = needsIndentation(node, node.colonToken, node.whenFalse);
	            emitExpression(node.condition);
	            increaseIndentIf(indentBeforeQuestion, " ");
	            emit(node.questionToken);
	            increaseIndentIf(indentAfterQuestion, " ");
	            emitExpression(node.whenTrue);
	            decreaseIndentIf(indentBeforeQuestion, indentAfterQuestion);
	            increaseIndentIf(indentBeforeColon, " ");
	            emit(node.colonToken);
	            increaseIndentIf(indentAfterColon, " ");
	            emitExpression(node.whenFalse);
	            decreaseIndentIf(indentBeforeColon, indentAfterColon);
	        }
	        function emitTemplateExpression(node) {
	            emit(node.head);
	            emitList(node, node.templateSpans, 131072 /* TemplateExpressionSpans */);
	        }
	        function emitYieldExpression(node) {
	            writeKeyword("yield");
	            emit(node.asteriskToken);
	            emitExpressionWithLeadingSpace(node.expression);
	        }
	        function emitSpreadExpression(node) {
	            writePunctuation("...");
	            emitExpression(node.expression);
	        }
	        function emitClassExpression(node) {
	            emitClassDeclarationOrExpression(node);
	        }
	        function emitExpressionWithTypeArguments(node) {
	            emitExpression(node.expression);
	            emitTypeArguments(node, node.typeArguments);
	        }
	        function emitAsExpression(node) {
	            emitExpression(node.expression);
	            if (node.type) {
	                writeSpace();
	                writeKeyword("as");
	                writeSpace();
	                emit(node.type);
	            }
	        }
	        function emitNonNullExpression(node) {
	            emitExpression(node.expression);
	            writeOperator("!");
	        }
	        function emitMetaProperty(node) {
	            writeToken(node.keywordToken, node.pos, writePunctuation);
	            writePunctuation(".");
	            emit(node.name);
	        }
	        //
	        // Misc
	        //
	        function emitTemplateSpan(node) {
	            emitExpression(node.expression);
	            emit(node.literal);
	        }
	        //
	        // Statements
	        //
	        function emitBlock(node) {
	            writeToken(17 /* OpenBraceToken */, node.pos, writePunctuation, /*contextNode*/ node);
	            emitBlockStatements(node, /*forceSingleLine*/ !node.multiLine && isEmptyBlock(node));
	            // We have to call emitLeadingComments explicitly here because otherwise leading comments of the close brace token will not be emitted
	            increaseIndent();
	            emitLeadingCommentsOfPosition(node.statements.end);
	            decreaseIndent();
	            writeToken(18 /* CloseBraceToken */, node.statements.end, writePunctuation, /*contextNode*/ node);
	        }
	        function emitBlockStatements(node, forceSingleLine) {
	            var format = forceSingleLine || ts.getEmitFlags(node) & 1 /* SingleLine */ ? 384 /* SingleLineBlockStatements */ : 65 /* MultiLineBlockStatements */;
	            emitList(node, node.statements, format);
	        }
	        function emitVariableStatement(node) {
	            emitModifiers(node, node.modifiers);
	            emit(node.declarationList);
	            writeSemicolon();
	        }
	        function emitEmptyStatement() {
	            writeSemicolon();
	        }
	        function emitExpressionStatement(node) {
	            emitExpression(node.expression);
	            writeSemicolon();
	        }
	        function emitIfStatement(node) {
	            var openParenPos = writeToken(90 /* IfKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            writeToken(19 /* OpenParenToken */, openParenPos, writePunctuation, node);
	            emitExpression(node.expression);
	            writeToken(20 /* CloseParenToken */, node.expression.end, writePunctuation, node);
	            emitEmbeddedStatement(node, node.thenStatement);
	            if (node.elseStatement) {
	                writeLineOrSpace(node);
	                writeToken(82 /* ElseKeyword */, node.thenStatement.end, writeKeyword, node);
	                if (node.elseStatement.kind === 215 /* IfStatement */) {
	                    writeSpace();
	                    emit(node.elseStatement);
	                }
	                else {
	                    emitEmbeddedStatement(node, node.elseStatement);
	                }
	            }
	        }
	        function emitDoStatement(node) {
	            writeKeyword("do");
	            emitEmbeddedStatement(node, node.statement);
	            if (ts.isBlock(node.statement)) {
	                writeSpace();
	            }
	            else {
	                writeLineOrSpace(node);
	            }
	            writeKeyword("while");
	            writeSpace();
	            writePunctuation("(");
	            emitExpression(node.expression);
	            writePunctuation(");");
	        }
	        function emitWhileStatement(node) {
	            writeKeyword("while");
	            writeSpace();
	            writePunctuation("(");
	            emitExpression(node.expression);
	            writePunctuation(")");
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitForStatement(node) {
	            var openParenPos = writeToken(88 /* ForKeyword */, node.pos, writeKeyword);
	            writeSpace();
	            writeToken(19 /* OpenParenToken */, openParenPos, writePunctuation, /*contextNode*/ node);
	            emitForBinding(node.initializer);
	            writeSemicolon();
	            emitExpressionWithLeadingSpace(node.condition);
	            writeSemicolon();
	            emitExpressionWithLeadingSpace(node.incrementor);
	            writePunctuation(")");
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitForInStatement(node) {
	            var openParenPos = writeToken(88 /* ForKeyword */, node.pos, writeKeyword);
	            writeSpace();
	            writeToken(19 /* OpenParenToken */, openParenPos, writePunctuation);
	            emitForBinding(node.initializer);
	            writeSpace();
	            writeKeyword("in");
	            writeSpace();
	            emitExpression(node.expression);
	            writeToken(20 /* CloseParenToken */, node.expression.end, writePunctuation);
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitForOfStatement(node) {
	            var openParenPos = writeToken(88 /* ForKeyword */, node.pos, writeKeyword);
	            writeSpace();
	            emitWithTrailingSpace(node.awaitModifier);
	            writeToken(19 /* OpenParenToken */, openParenPos, writePunctuation);
	            emitForBinding(node.initializer);
	            writeSpace();
	            writeKeyword("of");
	            writeSpace();
	            emitExpression(node.expression);
	            writeToken(20 /* CloseParenToken */, node.expression.end, writePunctuation);
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitForBinding(node) {
	            if (node !== undefined) {
	                if (node.kind === 231 /* VariableDeclarationList */) {
	                    emit(node);
	                }
	                else {
	                    emitExpression(node);
	                }
	            }
	        }
	        function emitContinueStatement(node) {
	            writeToken(77 /* ContinueKeyword */, node.pos, writeKeyword);
	            emitWithLeadingSpace(node.label);
	            writeSemicolon();
	        }
	        function emitBreakStatement(node) {
	            writeToken(72 /* BreakKeyword */, node.pos, writeKeyword);
	            emitWithLeadingSpace(node.label);
	            writeSemicolon();
	        }
	        function emitTokenWithComment(token, pos, writer, contextNode) {
	            var node = contextNode && ts.getParseTreeNode(contextNode);
	            if (node && node.kind === contextNode.kind) {
	                pos = ts.skipTrivia(currentSourceFile.text, pos);
	            }
	            pos = writeToken(token, pos, writer, /*contextNode*/ contextNode);
	            if (node && node.kind === contextNode.kind) {
	                emitTrailingCommentsOfPosition(pos, /*prefixSpace*/ true);
	            }
	            return pos;
	        }
	        function emitReturnStatement(node) {
	            emitTokenWithComment(96 /* ReturnKeyword */, node.pos, writeKeyword, /*contextNode*/ node);
	            emitExpressionWithLeadingSpace(node.expression);
	            writeSemicolon();
	        }
	        function emitWithStatement(node) {
	            writeKeyword("with");
	            writeSpace();
	            writePunctuation("(");
	            emitExpression(node.expression);
	            writePunctuation(")");
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitSwitchStatement(node) {
	            var openParenPos = writeToken(98 /* SwitchKeyword */, node.pos, writeKeyword);
	            writeSpace();
	            writeToken(19 /* OpenParenToken */, openParenPos, writePunctuation);
	            emitExpression(node.expression);
	            writeToken(20 /* CloseParenToken */, node.expression.end, writePunctuation);
	            writeSpace();
	            emit(node.caseBlock);
	        }
	        function emitLabeledStatement(node) {
	            emit(node.label);
	            writePunctuation(":");
	            writeSpace();
	            emit(node.statement);
	        }
	        function emitThrowStatement(node) {
	            writeKeyword("throw");
	            emitExpressionWithLeadingSpace(node.expression);
	            writeSemicolon();
	        }
	        function emitTryStatement(node) {
	            writeKeyword("try");
	            writeSpace();
	            emit(node.tryBlock);
	            if (node.catchClause) {
	                writeLineOrSpace(node);
	                emit(node.catchClause);
	            }
	            if (node.finallyBlock) {
	                writeLineOrSpace(node);
	                writeKeyword("finally");
	                writeSpace();
	                emit(node.finallyBlock);
	            }
	        }
	        function emitDebuggerStatement(node) {
	            writeToken(78 /* DebuggerKeyword */, node.pos, writeKeyword);
	            writeSemicolon();
	        }
	        //
	        // Declarations
	        //
	        function emitVariableDeclaration(node) {
	            emit(node.name);
	            emitTypeAnnotation(node.type);
	            emitInitializer(node.initializer);
	        }
	        function emitVariableDeclarationList(node) {
	            writeKeyword(ts.isLet(node) ? "let" : ts.isConst(node) ? "const" : "var");
	            writeSpace();
	            emitList(node, node.declarations, 272 /* VariableDeclarationList */);
	        }
	        function emitFunctionDeclaration(node) {
	            emitFunctionDeclarationOrExpression(node);
	        }
	        function emitFunctionDeclarationOrExpression(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("function");
	            emitIfPresent(node.asteriskToken);
	            writeSpace();
	            emitIdentifierName(node.name);
	            emitSignatureAndBody(node, emitSignatureHead);
	        }
	        function emitBlockCallback(_hint, body) {
	            emitBlockFunctionBody(body);
	        }
	        function emitSignatureAndBody(node, emitSignatureHead) {
	            var body = node.body;
	            if (body) {
	                if (ts.isBlock(body)) {
	                    var indentedFlag = ts.getEmitFlags(node) & 65536 /* Indented */;
	                    if (indentedFlag) {
	                        increaseIndent();
	                    }
	                    pushNameGenerationScope(node);
	                    emitSignatureHead(node);
	                    if (onEmitNode) {
	                        onEmitNode(4 /* Unspecified */, body, emitBlockCallback);
	                    }
	                    else {
	                        emitBlockFunctionBody(body);
	                    }
	                    popNameGenerationScope(node);
	                    if (indentedFlag) {
	                        decreaseIndent();
	                    }
	                }
	                else {
	                    emitSignatureHead(node);
	                    writeSpace();
	                    emitExpression(body);
	                }
	            }
	            else {
	                emitSignatureHead(node);
	                writeSemicolon();
	            }
	        }
	        function emitSignatureHead(node) {
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            emitTypeAnnotation(node.type);
	        }
	        function shouldEmitBlockFunctionBodyOnSingleLine(body) {
	            // We must emit a function body as a single-line body in the following case:
	            // * The body has NodeEmitFlags.SingleLine specified.
	            // We must emit a function body as a multi-line body in the following cases:
	            // * The body is explicitly marked as multi-line.
	            // * A non-synthesized body's start and end position are on different lines.
	            // * Any statement in the body starts on a new line.
	            if (ts.getEmitFlags(body) & 1 /* SingleLine */) {
	                return true;
	            }
	            if (body.multiLine) {
	                return false;
	            }
	            if (!ts.nodeIsSynthesized(body) && !ts.rangeIsOnSingleLine(body, currentSourceFile)) {
	                return false;
	            }
	            if (shouldWriteLeadingLineTerminator(body, body.statements, 2 /* PreserveLines */)
	                || shouldWriteClosingLineTerminator(body, body.statements, 2 /* PreserveLines */)) {
	                return false;
	            }
	            var previousStatement;
	            for (var _a = 0, _b = body.statements; _a < _b.length; _a++) {
	                var statement = _b[_a];
	                if (shouldWriteSeparatingLineTerminator(previousStatement, statement, 2 /* PreserveLines */)) {
	                    return false;
	                }
	                previousStatement = statement;
	            }
	            return true;
	        }
	        function emitBlockFunctionBody(body) {
	            writeSpace();
	            writePunctuation("{");
	            increaseIndent();
	            var emitBlockFunctionBody = shouldEmitBlockFunctionBodyOnSingleLine(body)
	                ? emitBlockFunctionBodyOnSingleLine
	                : emitBlockFunctionBodyWorker;
	            if (emitBodyWithDetachedComments) {
	                emitBodyWithDetachedComments(body, body.statements, emitBlockFunctionBody);
	            }
	            else {
	                emitBlockFunctionBody(body);
	            }
	            decreaseIndent();
	            writeToken(18 /* CloseBraceToken */, body.statements.end, writePunctuation, body);
	        }
	        function emitBlockFunctionBodyOnSingleLine(body) {
	            emitBlockFunctionBodyWorker(body, /*emitBlockFunctionBodyOnSingleLine*/ true);
	        }
	        function emitBlockFunctionBodyWorker(body, emitBlockFunctionBodyOnSingleLine) {
	            // Emit all the prologue directives (like "use strict").
	            var statementOffset = emitPrologueDirectives(body.statements, /*startWithNewLine*/ true);
	            var pos = writer.getTextPos();
	            emitHelpersIndirect(body);
	            if (statementOffset === 0 && pos === writer.getTextPos() && emitBlockFunctionBodyOnSingleLine) {
	                decreaseIndent();
	                emitList(body, body.statements, 384 /* SingleLineFunctionBodyStatements */);
	                increaseIndent();
	            }
	            else {
	                emitList(body, body.statements, 1 /* MultiLineFunctionBodyStatements */, statementOffset);
	            }
	        }
	        function emitClassDeclaration(node) {
	            emitClassDeclarationOrExpression(node);
	        }
	        function emitClassDeclarationOrExpression(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("class");
	            if (node.name) {
	                writeSpace();
	                emitIdentifierName(node.name);
	            }
	            var indentedFlag = ts.getEmitFlags(node) & 65536 /* Indented */;
	            if (indentedFlag) {
	                increaseIndent();
	            }
	            emitTypeParameters(node, node.typeParameters);
	            emitList(node, node.heritageClauses, 256 /* ClassHeritageClauses */);
	            writeSpace();
	            writePunctuation("{");
	            emitList(node, node.members, 65 /* ClassMembers */);
	            writePunctuation("}");
	            if (indentedFlag) {
	                decreaseIndent();
	            }
	        }
	        function emitInterfaceDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("interface");
	            writeSpace();
	            emit(node.name);
	            emitTypeParameters(node, node.typeParameters);
	            emitList(node, node.heritageClauses, 256 /* HeritageClauses */);
	            writeSpace();
	            writePunctuation("{");
	            emitList(node, node.members, 65 /* InterfaceMembers */);
	            writePunctuation("}");
	        }
	        function emitTypeAliasDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("type");
	            writeSpace();
	            emit(node.name);
	            emitTypeParameters(node, node.typeParameters);
	            writeSpace();
	            writePunctuation("=");
	            writeSpace();
	            emit(node.type);
	            writeSemicolon();
	        }
	        function emitEnumDeclaration(node) {
	            emitModifiers(node, node.modifiers);
	            writeKeyword("enum");
	            writeSpace();
	            emit(node.name);
	            writeSpace();
	            writePunctuation("{");
	            emitList(node, node.members, 81 /* EnumMembers */);
	            writePunctuation("}");
	        }
	        function emitModuleDeclaration(node) {
	            emitModifiers(node, node.modifiers);
	            if (~node.flags & 512 /* GlobalAugmentation */) {
	                writeKeyword(node.flags & 16 /* Namespace */ ? "namespace" : "module");
	                writeSpace();
	            }
	            emit(node.name);
	            var body = node.body;
	            while (body.kind === 237 /* ModuleDeclaration */) {
	                writePunctuation(".");
	                emit(body.name);
	                body = body.body;
	            }
	            writeSpace();
	            emit(body);
	        }
	        function emitModuleBlock(node) {
	            pushNameGenerationScope(node);
	            writePunctuation("{");
	            emitBlockStatements(node, /*forceSingleLine*/ isEmptyBlock(node));
	            writePunctuation("}");
	            popNameGenerationScope(node);
	        }
	        function emitCaseBlock(node) {
	            writeToken(17 /* OpenBraceToken */, node.pos, writePunctuation);
	            emitList(node, node.clauses, 65 /* CaseBlockClauses */);
	            writeToken(18 /* CloseBraceToken */, node.clauses.end, writePunctuation);
	        }
	        function emitImportEqualsDeclaration(node) {
	            emitModifiers(node, node.modifiers);
	            writeKeyword("import");
	            writeSpace();
	            emit(node.name);
	            writeSpace();
	            writePunctuation("=");
	            writeSpace();
	            emitModuleReference(node.moduleReference);
	            writeSemicolon();
	        }
	        function emitModuleReference(node) {
	            if (node.kind === 71 /* Identifier */) {
	                emitExpression(node);
	            }
	            else {
	                emit(node);
	            }
	        }
	        function emitImportDeclaration(node) {
	            emitModifiers(node, node.modifiers);
	            writeKeyword("import");
	            writeSpace();
	            if (node.importClause) {
	                emit(node.importClause);
	                writeSpace();
	                writeKeyword("from");
	                writeSpace();
	            }
	            emitExpression(node.moduleSpecifier);
	            writeSemicolon();
	        }
	        function emitImportClause(node) {
	            emit(node.name);
	            if (node.name && node.namedBindings) {
	                writePunctuation(",");
	                writeSpace();
	            }
	            emit(node.namedBindings);
	        }
	        function emitNamespaceImport(node) {
	            writePunctuation("*");
	            writeSpace();
	            writeKeyword("as");
	            writeSpace();
	            emit(node.name);
	        }
	        function emitNamedImports(node) {
	            emitNamedImportsOrExports(node);
	        }
	        function emitImportSpecifier(node) {
	            emitImportOrExportSpecifier(node);
	        }
	        function emitExportAssignment(node) {
	            writeKeyword("export");
	            writeSpace();
	            if (node.isExportEquals) {
	                writeOperator("=");
	            }
	            else {
	                writeKeyword("default");
	            }
	            writeSpace();
	            emitExpression(node.expression);
	            writeSemicolon();
	        }
	        function emitExportDeclaration(node) {
	            writeKeyword("export");
	            writeSpace();
	            if (node.exportClause) {
	                emit(node.exportClause);
	            }
	            else {
	                writePunctuation("*");
	            }
	            if (node.moduleSpecifier) {
	                writeSpace();
	                writeKeyword("from");
	                writeSpace();
	                emitExpression(node.moduleSpecifier);
	            }
	            writeSemicolon();
	        }
	        function emitNamespaceExportDeclaration(node) {
	            writeKeyword("export");
	            writeSpace();
	            writeKeyword("as");
	            writeSpace();
	            writeKeyword("namespace");
	            writeSpace();
	            emit(node.name);
	            writeSemicolon();
	        }
	        function emitNamedExports(node) {
	            emitNamedImportsOrExports(node);
	        }
	        function emitExportSpecifier(node) {
	            emitImportOrExportSpecifier(node);
	        }
	        function emitNamedImportsOrExports(node) {
	            writePunctuation("{");
	            emitList(node, node.elements, 432 /* NamedImportsOrExportsElements */);
	            writePunctuation("}");
	        }
	        function emitImportOrExportSpecifier(node) {
	            if (node.propertyName) {
	                emit(node.propertyName);
	                writeSpace();
	                writeKeyword("as");
	                writeSpace();
	            }
	            emit(node.name);
	        }
	        //
	        // Module references
	        //
	        function emitExternalModuleReference(node) {
	            writeKeyword("require");
	            writePunctuation("(");
	            emitExpression(node.expression);
	            writePunctuation(")");
	        }
	        //
	        // JSX
	        //
	        function emitJsxElement(node) {
	            emit(node.openingElement);
	            emitList(node, node.children, 131072 /* JsxElementOrFragmentChildren */);
	            emit(node.closingElement);
	        }
	        function emitJsxSelfClosingElement(node) {
	            writePunctuation("<");
	            emitJsxTagName(node.tagName);
	            writeSpace();
	            // We are checking here so we won't re-enter the emiting pipeline and emit extra sourcemap
	            if (node.attributes.properties && node.attributes.properties.length > 0) {
	                emit(node.attributes);
	            }
	            writePunctuation("/>");
	        }
	        function emitJsxFragment(node) {
	            emit(node.openingFragment);
	            emitList(node, node.children, 131072 /* JsxElementOrFragmentChildren */);
	            emit(node.closingFragment);
	        }
	        function emitJsxOpeningElementOrFragment(node) {
	            writePunctuation("<");
	            if (ts.isJsxOpeningElement(node)) {
	                emitJsxTagName(node.tagName);
	                // We are checking here so we won't re-enter the emitting pipeline and emit extra sourcemap
	                if (node.attributes.properties && node.attributes.properties.length > 0) {
	                    writeSpace();
	                    emit(node.attributes);
	                }
	            }
	            writePunctuation(">");
	        }
	        function emitJsxText(node) {
	            commitPendingSemicolon();
	            writer.writeLiteral(getTextOfNode(node, /*includeTrivia*/ true));
	        }
	        function emitJsxClosingElementOrFragment(node) {
	            writePunctuation("</");
	            if (ts.isJsxClosingElement(node)) {
	                emitJsxTagName(node.tagName);
	            }
	            writePunctuation(">");
	        }
	        function emitJsxAttributes(node) {
	            emitList(node, node.properties, 131328 /* JsxElementAttributes */);
	        }
	        function emitJsxAttribute(node) {
	            emit(node.name);
	            emitNodeWithPrefix("=", writePunctuation, node.initializer, emit);
	        }
	        function emitJsxSpreadAttribute(node) {
	            writePunctuation("{...");
	            emitExpression(node.expression);
	            writePunctuation("}");
	        }
	        function emitJsxExpression(node) {
	            if (node.expression) {
	                writePunctuation("{");
	                emitIfPresent(node.dotDotDotToken);
	                emitExpression(node.expression);
	                writePunctuation("}");
	            }
	        }
	        function emitJsxTagName(node) {
	            if (node.kind === 71 /* Identifier */) {
	                emitExpression(node);
	            }
	            else {
	                emit(node);
	            }
	        }
	        //
	        // Clauses
	        //
	        function emitCaseClause(node) {
	            writeKeyword("case");
	            writeSpace();
	            emitExpression(node.expression);
	            writePunctuation(":");
	            emitCaseOrDefaultClauseStatements(node, node.statements);
	        }
	        function emitDefaultClause(node) {
	            writeKeyword("default");
	            writePunctuation(":");
	            emitCaseOrDefaultClauseStatements(node, node.statements);
	        }
	        function emitCaseOrDefaultClauseStatements(parentNode, statements) {
	            var emitAsSingleStatement = statements.length === 1 &&
	                (
	                // treat synthesized nodes as located on the same line for emit purposes
	                ts.nodeIsSynthesized(parentNode) ||
	                    ts.nodeIsSynthesized(statements[0]) ||
	                    ts.rangeStartPositionsAreOnSameLine(parentNode, statements[0], currentSourceFile));
	            // e.g:
	            //      case 0: // Zero
	            //      case 1: // One
	            //      case 2: // two
	            //          return "hi";
	            // If there is no statements, emitNodeWithComments of the parentNode which is caseClause will take care of trailing comment.
	            // So in example above, comment "// Zero" and "// One" will be emit in emitTrailingComments in emitNodeWithComments.
	            // However, for "case 2", because parentNode which is caseClause has an "end" property to be end of the statements (in this case return statement)
	            // comment "// two" will not be emitted in emitNodeWithComments.
	            // Therefore, we have to do the check here to emit such comment.
	            if (statements.length > 0) {
	                // We use emitTrailingCommentsOfPosition instead of emitLeadingCommentsOfPosition because leading comments is defined as comments before the node after newline character separating it from previous line
	                // Note: we can't use parentNode.end as such position includes statements.
	                emitTrailingCommentsOfPosition(statements.pos);
	            }
	            var format = 81985 /* CaseOrDefaultClauseStatements */;
	            if (emitAsSingleStatement) {
	                writeSpace();
	                format &= ~(1 /* MultiLine */ | 64 /* Indented */);
	            }
	            emitList(parentNode, statements, format);
	        }
	        function emitHeritageClause(node) {
	            writeSpace();
	            writeTokenText(node.token, writeKeyword);
	            writeSpace();
	            emitList(node, node.types, 272 /* HeritageClauseTypes */);
	        }
	        function emitCatchClause(node) {
	            var openParenPos = writeToken(74 /* CatchKeyword */, node.pos, writeKeyword);
	            writeSpace();
	            if (node.variableDeclaration) {
	                writeToken(19 /* OpenParenToken */, openParenPos, writePunctuation);
	                emit(node.variableDeclaration);
	                writeToken(20 /* CloseParenToken */, node.variableDeclaration.end, writePunctuation);
	                writeSpace();
	            }
	            emit(node.block);
	        }
	        //
	        // Property assignments
	        //
	        function emitPropertyAssignment(node) {
	            emit(node.name);
	            writePunctuation(":");
	            writeSpace();
	            // This is to ensure that we emit comment in the following case:
	            //      For example:
	            //          obj = {
	            //              id: /*comment1*/ ()=>void
	            //          }
	            // "comment1" is not considered to be leading comment for node.initializer
	            // but rather a trailing comment on the previous node.
	            var initializer = node.initializer;
	            if (emitTrailingCommentsOfPosition && (ts.getEmitFlags(initializer) & 512 /* NoLeadingComments */) === 0) {
	                var commentRange = ts.getCommentRange(initializer);
	                emitTrailingCommentsOfPosition(commentRange.pos);
	            }
	            emitExpression(initializer);
	        }
	        function emitShorthandPropertyAssignment(node) {
	            emit(node.name);
	            if (node.objectAssignmentInitializer) {
	                writeSpace();
	                writePunctuation("=");
	                writeSpace();
	                emitExpression(node.objectAssignmentInitializer);
	            }
	        }
	        function emitSpreadAssignment(node) {
	            if (node.expression) {
	                writePunctuation("...");
	                emitExpression(node.expression);
	            }
	        }
	        //
	        // Enum
	        //
	        function emitEnumMember(node) {
	            emit(node.name);
	            emitInitializer(node.initializer);
	        }
	        //
	        // Top-level nodes
	        //
	        function emitSourceFile(node) {
	            writeLine();
	            var statements = node.statements;
	            if (emitBodyWithDetachedComments) {
	                // Emit detached comment if there are no prologue directives or if the first node is synthesized.
	                // The synthesized node will have no leading comment so some comments may be missed.
	                var shouldEmitDetachedComment = statements.length === 0 ||
	                    !ts.isPrologueDirective(statements[0]) ||
	                    ts.nodeIsSynthesized(statements[0]);
	                if (shouldEmitDetachedComment) {
	                    emitBodyWithDetachedComments(node, statements, emitSourceFileWorker);
	                    return;
	                }
	            }
	            emitSourceFileWorker(node);
	        }
	        function emitSourceFileWorker(node) {
	            var statements = node.statements;
	            pushNameGenerationScope(node);
	            emitHelpersIndirect(node);
	            var index = ts.findIndex(statements, function (statement) { return !ts.isPrologueDirective(statement); });
	            emitList(node, statements, 1 /* MultiLine */, index === -1 ? statements.length : index);
	            popNameGenerationScope(node);
	        }
	        // Transformation nodes
	        function emitPartiallyEmittedExpression(node) {
	            emitExpression(node.expression);
	        }
	        function emitCommaList(node) {
	            emitExpressionList(node, node.elements, 272 /* CommaListElements */);
	        }
	        /**
	         * Emits any prologue directives at the start of a Statement list, returning the
	         * number of prologue directives written to the output.
	         */
	        function emitPrologueDirectives(statements, startWithNewLine, seenPrologueDirectives) {
	            for (var i = 0; i < statements.length; i++) {
	                var statement = statements[i];
	                if (ts.isPrologueDirective(statement)) {
	                    var shouldEmitPrologueDirective = seenPrologueDirectives ? !seenPrologueDirectives.has(statement.expression.text) : true;
	                    if (shouldEmitPrologueDirective) {
	                        if (startWithNewLine || i > 0) {
	                            writeLine();
	                        }
	                        emit(statement);
	                        if (seenPrologueDirectives) {
	                            seenPrologueDirectives.set(statement.expression.text, true);
	                        }
	                    }
	                }
	                else {
	                    // return index of the first non prologue directive
	                    return i;
	                }
	            }
	            return statements.length;
	        }
	        function emitPrologueDirectivesIfNeeded(sourceFileOrBundle) {
	            if (ts.isSourceFile(sourceFileOrBundle)) {
	                setSourceFile(sourceFileOrBundle);
	                emitPrologueDirectives(sourceFileOrBundle.statements);
	            }
	            else {
	                var seenPrologueDirectives = ts.createMap();
	                for (var _a = 0, _b = sourceFileOrBundle.sourceFiles; _a < _b.length; _a++) {
	                    var sourceFile = _b[_a];
	                    setSourceFile(sourceFile);
	                    emitPrologueDirectives(sourceFile.statements, /*startWithNewLine*/ true, seenPrologueDirectives);
	                }
	            }
	        }
	        function emitShebangIfNeeded(sourceFileOrBundle) {
	            if (ts.isSourceFile(sourceFileOrBundle)) {
	                var shebang = ts.getShebang(sourceFileOrBundle.text);
	                if (shebang) {
	                    write(shebang);
	                    writeLine();
	                    return true;
	                }
	            }
	            else {
	                for (var _a = 0, _b = sourceFileOrBundle.sourceFiles; _a < _b.length; _a++) {
	                    var sourceFile = _b[_a];
	                    // Emit only the first encountered shebang
	                    if (emitShebangIfNeeded(sourceFile)) {
	                        break;
	                    }
	                }
	            }
	        }
	        //
	        // Helpers
	        //
	        function emitNodeWithWriter(node, writer) {
	            var savedWrite = write;
	            write = writer;
	            emit(node);
	            write = savedWrite;
	        }
	        function emitModifiers(node, modifiers) {
	            if (modifiers && modifiers.length) {
	                emitList(node, modifiers, 131328 /* Modifiers */);
	                writeSpace();
	            }
	        }
	        function emitTypeAnnotation(node) {
	            if (node) {
	                writePunctuation(":");
	                writeSpace();
	                emit(node);
	            }
	        }
	        function emitInitializer(node) {
	            if (node) {
	                writeSpace();
	                writeOperator("=");
	                writeSpace();
	                emitExpression(node);
	            }
	        }
	        function emitNodeWithPrefix(prefix, prefixWriter, node, emit) {
	            if (node) {
	                prefixWriter(prefix);
	                emit(node);
	            }
	        }
	        function emitWithLeadingSpace(node) {
	            if (node) {
	                writeSpace();
	                emit(node);
	            }
	        }
	        function emitExpressionWithLeadingSpace(node) {
	            if (node) {
	                writeSpace();
	                emitExpression(node);
	            }
	        }
	        function emitWithTrailingSpace(node) {
	            if (node) {
	                emit(node);
	                writeSpace();
	            }
	        }
	        function emitEmbeddedStatement(parent, node) {
	            if (ts.isBlock(node) || ts.getEmitFlags(parent) & 1 /* SingleLine */) {
	                writeSpace();
	                emit(node);
	            }
	            else {
	                writeLine();
	                increaseIndent();
	                emit(node);
	                decreaseIndent();
	            }
	        }
	        function emitDecorators(parentNode, decorators) {
	            emitList(parentNode, decorators, 24577 /* Decorators */);
	        }
	        function emitTypeArguments(parentNode, typeArguments) {
	            emitList(parentNode, typeArguments, 26896 /* TypeArguments */);
	        }
	        function emitTypeParameters(parentNode, typeParameters) {
	            if (ts.isFunctionLike(parentNode) && parentNode.typeArguments) {
	                return emitTypeArguments(parentNode, parentNode.typeArguments);
	            }
	            emitList(parentNode, typeParameters, 26896 /* TypeParameters */);
	        }
	        function emitParameters(parentNode, parameters) {
	            emitList(parentNode, parameters, 1296 /* Parameters */);
	        }
	        function canEmitSimpleArrowHead(parentNode, parameters) {
	            var parameter = ts.singleOrUndefined(parameters);
	            return parameter
	                && parameter.pos === parentNode.pos // may not have parsed tokens between parent and parameter
	                && !(ts.isArrowFunction(parentNode) && parentNode.type) // arrow function may not have return type annotation
	                && !ts.some(parentNode.decorators) // parent may not have decorators
	                && !ts.some(parentNode.modifiers) // parent may not have modifiers
	                && !ts.some(parentNode.typeParameters) // parent may not have type parameters
	                && !ts.some(parameter.decorators) // parameter may not have decorators
	                && !ts.some(parameter.modifiers) // parameter may not have modifiers
	                && !parameter.dotDotDotToken // parameter may not be rest
	                && !parameter.questionToken // parameter may not be optional
	                && !parameter.type // parameter may not have a type annotation
	                && !parameter.initializer // parameter may not have an initializer
	                && ts.isIdentifier(parameter.name); // parameter name must be identifier
	        }
	        function emitParametersForArrow(parentNode, parameters) {
	            if (canEmitSimpleArrowHead(parentNode, parameters)) {
	                emitList(parentNode, parameters, 1296 /* Parameters */ & ~1024 /* Parenthesis */);
	            }
	            else {
	                emitParameters(parentNode, parameters);
	            }
	        }
	        function emitParametersForIndexSignature(parentNode, parameters) {
	            emitList(parentNode, parameters, 4432 /* IndexSignatureParameters */);
	        }
	        function emitList(parentNode, children, format, start, count) {
	            emitNodeList(emit, parentNode, children, format, start, count);
	        }
	        function emitExpressionList(parentNode, children, format, start, count) {
	            emitNodeList(emitExpression, parentNode, children, format, start, count);
	        }
	        function writeDelimiter(format) {
	            switch (format & 28 /* DelimitersMask */) {
	                case 0 /* None */:
	                    break;
	                case 16 /* CommaDelimited */:
	                    writePunctuation(",");
	                    break;
	                case 4 /* BarDelimited */:
	                    writeSpace();
	                    writePunctuation("|");
	                    break;
	                case 8 /* AmpersandDelimited */:
	                    writeSpace();
	                    writePunctuation("&");
	                    break;
	            }
	        }
	        function emitNodeList(emit, parentNode, children, format, start, count) {
	            if (start === void 0) { start = 0; }
	            if (count === void 0) { count = children ? children.length - start : 0; }
	            var isUndefined = children === undefined;
	            if (isUndefined && format & 8192 /* OptionalIfUndefined */) {
	                return;
	            }
	            var isEmpty = isUndefined || start >= children.length || count === 0;
	            if (isEmpty && format & 16384 /* OptionalIfEmpty */) {
	                if (onBeforeEmitNodeArray) {
	                    onBeforeEmitNodeArray(children);
	                }
	                if (onAfterEmitNodeArray) {
	                    onAfterEmitNodeArray(children);
	                }
	                return;
	            }
	            if (format & 7680 /* BracketsMask */) {
	                writePunctuation(getOpeningBracket(format));
	            }
	            if (onBeforeEmitNodeArray) {
	                onBeforeEmitNodeArray(children);
	            }
	            if (isEmpty) {
	                // Write a line terminator if the parent node was multi-line
	                if (format & 1 /* MultiLine */) {
	                    writeLine();
	                }
	                else if (format & 128 /* SpaceBetweenBraces */ && !(format & 262144 /* NoSpaceIfEmpty */)) {
	                    writeSpace();
	                }
	            }
	            else {
	                // Write the opening line terminator or leading whitespace.
	                var mayEmitInterveningComments = (format & 131072 /* NoInterveningComments */) === 0;
	                var shouldEmitInterveningComments = mayEmitInterveningComments;
	                if (shouldWriteLeadingLineTerminator(parentNode, children, format)) {
	                    writeLine();
	                    shouldEmitInterveningComments = false;
	                }
	                else if (format & 128 /* SpaceBetweenBraces */) {
	                    writeSpace();
	                }
	                // Increase the indent, if requested.
	                if (format & 64 /* Indented */) {
	                    increaseIndent();
	                }
	                // Emit each child.
	                var previousSibling = void 0;
	                var shouldDecreaseIndentAfterEmit = void 0;
	                for (var i = 0; i < count; i++) {
	                    var child = children[start + i];
	                    // Write the delimiter if this is not the first node.
	                    if (previousSibling) {
	                        // i.e
	                        //      function commentedParameters(
	                        //          /* Parameter a */
	                        //          a
	                        //          /* End of parameter a */ -> this comment isn't considered to be trailing comment of parameter "a" due to newline
	                        //          ,
	                        if (format & 28 /* DelimitersMask */ && previousSibling.end !== parentNode.end) {
	                            emitLeadingCommentsOfPosition(previousSibling.end);
	                        }
	                        writeDelimiter(format);
	                        // Write either a line terminator or whitespace to separate the elements.
	                        if (shouldWriteSeparatingLineTerminator(previousSibling, child, format)) {
	                            // If a synthesized node in a single-line list starts on a new
	                            // line, we should increase the indent.
	                            if ((format & (3 /* LinesMask */ | 64 /* Indented */)) === 0 /* SingleLine */) {
	                                increaseIndent();
	                                shouldDecreaseIndentAfterEmit = true;
	                            }
	                            writeLine();
	                            shouldEmitInterveningComments = false;
	                        }
	                        else if (previousSibling && format & 256 /* SpaceBetweenSiblings */) {
	                            writeSpace();
	                        }
	                    }
	                    // Emit this child.
	                    if (shouldEmitInterveningComments) {
	                        if (emitTrailingCommentsOfPosition) {
	                            var commentRange = ts.getCommentRange(child);
	                            emitTrailingCommentsOfPosition(commentRange.pos);
	                        }
	                    }
	                    else {
	                        shouldEmitInterveningComments = mayEmitInterveningComments;
	                    }
	                    emit(child);
	                    if (shouldDecreaseIndentAfterEmit) {
	                        decreaseIndent();
	                        shouldDecreaseIndentAfterEmit = false;
	                    }
	                    previousSibling = child;
	                }
	                // Write a trailing comma, if requested.
	                var hasTrailingComma = (format & 32 /* AllowTrailingComma */) && children.hasTrailingComma;
	                if (format & 16 /* CommaDelimited */ && hasTrailingComma) {
	                    writePunctuation(",");
	                }
	                // Emit any trailing comment of the last element in the list
	                // i.e
	                //       var array = [...
	                //          2
	                //          /* end of element 2 */
	                //       ];
	                if (previousSibling && format & 28 /* DelimitersMask */ && previousSibling.end !== parentNode.end && !(ts.getEmitFlags(previousSibling) & 1024 /* NoTrailingComments */)) {
	                    emitLeadingCommentsOfPosition(previousSibling.end);
	                }
	                // Decrease the indent, if requested.
	                if (format & 64 /* Indented */) {
	                    decreaseIndent();
	                }
	                // Write the closing line terminator or closing whitespace.
	                if (shouldWriteClosingLineTerminator(parentNode, children, format)) {
	                    writeLine();
	                }
	                else if (format & 128 /* SpaceBetweenBraces */) {
	                    writeSpace();
	                }
	            }
	            if (onAfterEmitNodeArray) {
	                onAfterEmitNodeArray(children);
	            }
	            if (format & 7680 /* BracketsMask */) {
	                writePunctuation(getClosingBracket(format));
	            }
	        }
	        function commitPendingSemicolonInternal() {
	            if (pendingSemicolon) {
	                writeSemicolonInternal();
	                pendingSemicolon = false;
	            }
	        }
	        function writeLiteral(s) {
	            commitPendingSemicolon();
	            writer.writeLiteral(s);
	        }
	        function writeStringLiteral(s) {
	            commitPendingSemicolon();
	            writer.writeStringLiteral(s);
	        }
	        function writeBase(s) {
	            commitPendingSemicolon();
	            writer.write(s);
	        }
	        function writeSymbol(s, sym) {
	            commitPendingSemicolon();
	            writer.writeSymbol(s, sym);
	        }
	        function writePunctuation(s) {
	            commitPendingSemicolon();
	            writer.writePunctuation(s);
	        }
	        function deferWriteSemicolon() {
	            pendingSemicolon = true;
	        }
	        function writeSemicolonInternal() {
	            writer.writePunctuation(";");
	        }
	        function writeKeyword(s) {
	            commitPendingSemicolon();
	            writer.writeKeyword(s);
	        }
	        function writeOperator(s) {
	            commitPendingSemicolon();
	            writer.writeOperator(s);
	        }
	        function writeParameter(s) {
	            commitPendingSemicolon();
	            writer.writeParameter(s);
	        }
	        function writeSpace() {
	            commitPendingSemicolon();
	            writer.writeSpace(" ");
	        }
	        function writeProperty(s) {
	            commitPendingSemicolon();
	            writer.writeProperty(s);
	        }
	        function writeLine() {
	            commitPendingSemicolon();
	            writer.writeLine();
	        }
	        function increaseIndent() {
	            commitPendingSemicolon();
	            writer.increaseIndent();
	        }
	        function decreaseIndent() {
	            commitPendingSemicolon();
	            writer.decreaseIndent();
	        }
	        function writeToken(token, pos, writer, contextNode) {
	            return onEmitSourceMapOfToken
	                ? onEmitSourceMapOfToken(contextNode, token, writer, pos, writeTokenText)
	                : writeTokenText(token, writer, pos);
	        }
	        function writeTokenNode(node, writer) {
	            if (onBeforeEmitToken) {
	                onBeforeEmitToken(node);
	            }
	            writer(ts.tokenToString(node.kind));
	            if (onAfterEmitToken) {
	                onAfterEmitToken(node);
	            }
	        }
	        function writeTokenText(token, writer, pos) {
	            var tokenString = ts.tokenToString(token);
	            writer(tokenString);
	            return pos < 0 ? pos : pos + tokenString.length;
	        }
	        function writeLineOrSpace(node) {
	            if (ts.getEmitFlags(node) & 1 /* SingleLine */) {
	                writeSpace();
	            }
	            else {
	                writeLine();
	            }
	        }
	        function writeLines(text) {
	            var lines = text.split(/\r\n?|\n/g);
	            var indentation = guessIndentation(lines);
	            for (var _a = 0, lines_1 = lines; _a < lines_1.length; _a++) {
	                var lineText = lines_1[_a];
	                var line = indentation ? lineText.slice(indentation) : lineText;
	                if (line.length) {
	                    writeLine();
	                    write(line);
	                    writeLine();
	                }
	            }
	        }
	        function guessIndentation(lines) {
	            var indentation;
	            for (var _a = 0, lines_2 = lines; _a < lines_2.length; _a++) {
	                var line = lines_2[_a];
	                for (var i = 0; i < line.length && (indentation === undefined || i < indentation); i++) {
	                    if (!ts.isWhiteSpaceLike(line.charCodeAt(i))) {
	                        if (indentation === undefined || i < indentation) {
	                            indentation = i;
	                            break;
	                        }
	                    }
	                }
	            }
	            return indentation;
	        }
	        function increaseIndentIf(value, valueToWriteWhenNotIndenting) {
	            if (value) {
	                increaseIndent();
	                writeLine();
	            }
	            else if (valueToWriteWhenNotIndenting) {
	                write(valueToWriteWhenNotIndenting);
	            }
	        }
	        // Helper function to decrease the indent if we previously indented.  Allows multiple
	        // previous indent values to be considered at a time.  This also allows caller to just
	        // call this once, passing in all their appropriate indent values, instead of needing
	        // to call this helper function multiple times.
	        function decreaseIndentIf(value1, value2) {
	            if (value1) {
	                decreaseIndent();
	            }
	            if (value2) {
	                decreaseIndent();
	            }
	        }
	        function shouldWriteLeadingLineTerminator(parentNode, children, format) {
	            if (format & 1 /* MultiLine */) {
	                return true;
	            }
	            if (format & 2 /* PreserveLines */) {
	                if (format & 32768 /* PreferNewLine */) {
	                    return true;
	                }
	                var firstChild = children[0];
	                if (firstChild === undefined) {
	                    return !ts.rangeIsOnSingleLine(parentNode, currentSourceFile);
	                }
	                else if (ts.positionIsSynthesized(parentNode.pos) || ts.nodeIsSynthesized(firstChild)) {
	                    return synthesizedNodeStartsOnNewLine(firstChild, format);
	                }
	                else {
	                    return !ts.rangeStartPositionsAreOnSameLine(parentNode, firstChild, currentSourceFile);
	                }
	            }
	            else {
	                return false;
	            }
	        }
	        function shouldWriteSeparatingLineTerminator(previousNode, nextNode, format) {
	            if (format & 1 /* MultiLine */) {
	                return true;
	            }
	            else if (format & 2 /* PreserveLines */) {
	                if (previousNode === undefined || nextNode === undefined) {
	                    return false;
	                }
	                else if (ts.nodeIsSynthesized(previousNode) || ts.nodeIsSynthesized(nextNode)) {
	                    return synthesizedNodeStartsOnNewLine(previousNode, format) || synthesizedNodeStartsOnNewLine(nextNode, format);
	                }
	                else {
	                    return !ts.rangeEndIsOnSameLineAsRangeStart(previousNode, nextNode, currentSourceFile);
	                }
	            }
	            else {
	                return ts.getStartsOnNewLine(nextNode);
	            }
	        }
	        function shouldWriteClosingLineTerminator(parentNode, children, format) {
	            if (format & 1 /* MultiLine */) {
	                return (format & 65536 /* NoTrailingNewLine */) === 0;
	            }
	            else if (format & 2 /* PreserveLines */) {
	                if (format & 32768 /* PreferNewLine */) {
	                    return true;
	                }
	                var lastChild = ts.lastOrUndefined(children);
	                if (lastChild === undefined) {
	                    return !ts.rangeIsOnSingleLine(parentNode, currentSourceFile);
	                }
	                else if (ts.positionIsSynthesized(parentNode.pos) || ts.nodeIsSynthesized(lastChild)) {
	                    return synthesizedNodeStartsOnNewLine(lastChild, format);
	                }
	                else {
	                    return !ts.rangeEndPositionsAreOnSameLine(parentNode, lastChild, currentSourceFile);
	                }
	            }
	            else {
	                return false;
	            }
	        }
	        function synthesizedNodeStartsOnNewLine(node, format) {
	            if (ts.nodeIsSynthesized(node)) {
	                var startsOnNewLine = ts.getStartsOnNewLine(node);
	                if (startsOnNewLine === undefined) {
	                    return (format & 32768 /* PreferNewLine */) !== 0;
	                }
	                return startsOnNewLine;
	            }
	            return (format & 32768 /* PreferNewLine */) !== 0;
	        }
	        function needsIndentation(parent, node1, node2) {
	            parent = skipSynthesizedParentheses(parent);
	            node1 = skipSynthesizedParentheses(node1);
	            node2 = skipSynthesizedParentheses(node2);
	            // Always use a newline for synthesized code if the synthesizer desires it.
	            if (ts.getStartsOnNewLine(node2)) {
	                return true;
	            }
	            return !ts.nodeIsSynthesized(parent)
	                && !ts.nodeIsSynthesized(node1)
	                && !ts.nodeIsSynthesized(node2)
	                && !ts.rangeEndIsOnSameLineAsRangeStart(node1, node2, currentSourceFile);
	        }
	        function isEmptyBlock(block) {
	            return block.statements.length === 0
	                && ts.rangeEndIsOnSameLineAsRangeStart(block, block, currentSourceFile);
	        }
	        function skipSynthesizedParentheses(node) {
	            while (node.kind === 189 /* ParenthesizedExpression */ && ts.nodeIsSynthesized(node)) {
	                node = node.expression;
	            }
	            return node;
	        }
	        function getTextOfNode(node, includeTrivia) {
	            if (ts.isGeneratedIdentifier(node)) {
	                return generateName(node);
	            }
	            else if (ts.isIdentifier(node) && (ts.nodeIsSynthesized(node) || !node.parent)) {
	                return ts.idText(node);
	            }
	            else if (node.kind === 9 /* StringLiteral */ && node.textSourceNode) {
	                return getTextOfNode(node.textSourceNode, includeTrivia);
	            }
	            else if (ts.isLiteralExpression(node) && (ts.nodeIsSynthesized(node) || !node.parent)) {
	                return node.text;
	            }
	            return ts.getSourceTextOfNodeFromSourceFile(currentSourceFile, node, includeTrivia);
	        }
	        function getLiteralTextOfNode(node) {
	            if (node.kind === 9 /* StringLiteral */ && node.textSourceNode) {
	                var textSourceNode = node.textSourceNode;
	                if (ts.isIdentifier(textSourceNode)) {
	                    return ts.getEmitFlags(node) & 16777216 /* NoAsciiEscaping */ ?
	                        "\"" + ts.escapeString(getTextOfNode(textSourceNode)) + "\"" :
	                        "\"" + ts.escapeNonAsciiString(getTextOfNode(textSourceNode)) + "\"";
	                }
	                else {
	                    return getLiteralTextOfNode(textSourceNode);
	                }
	            }
	            return ts.getLiteralText(node, currentSourceFile);
	        }
	        /**
	         * Push a new name generation scope.
	         */
	        function pushNameGenerationScope(node) {
	            if (node && ts.getEmitFlags(node) & 524288 /* ReuseTempVariableScope */) {
	                return;
	            }
	            tempFlagsStack.push(tempFlags);
	            tempFlags = 0;
	            reservedNamesStack.push(reservedNames);
	        }
	        /**
	         * Pop the current name generation scope.
	         */
	        function popNameGenerationScope(node) {
	            if (node && ts.getEmitFlags(node) & 524288 /* ReuseTempVariableScope */) {
	                return;
	            }
	            tempFlags = tempFlagsStack.pop();
	            reservedNames = reservedNamesStack.pop();
	        }
	        function reserveNameInNestedScopes(name) {
	            if (!reservedNames || reservedNames === ts.lastOrUndefined(reservedNamesStack)) {
	                reservedNames = ts.createMap();
	            }
	            reservedNames.set(name, true);
	        }
	        /**
	         * Generate the text for a generated identifier.
	         */
	        function generateName(name) {
	            if ((name.autoGenerateFlags & 7 /* KindMask */) === 4 /* Node */) {
	                // Node names generate unique names based on their original node
	                // and are cached based on that node's id.
	                if (name.autoGenerateFlags & 8 /* SkipNameGenerationScope */) {
	                    var savedTempFlags = tempFlags;
	                    popNameGenerationScope(/*node*/ undefined);
	                    var result = generateNameCached(getNodeForGeneratedName(name));
	                    pushNameGenerationScope(/*node*/ undefined);
	                    tempFlags = savedTempFlags;
	                    return result;
	                }
	                else {
	                    return generateNameCached(getNodeForGeneratedName(name));
	                }
	            }
	            else {
	                // Auto, Loop, and Unique names are cached based on their unique
	                // autoGenerateId.
	                var autoGenerateId = name.autoGenerateId;
	                return autoGeneratedIdToGeneratedName[autoGenerateId] || (autoGeneratedIdToGeneratedName[autoGenerateId] = makeName(name));
	            }
	        }
	        function generateNameCached(node) {
	            var nodeId = ts.getNodeId(node);
	            return nodeIdToGeneratedName[nodeId] || (nodeIdToGeneratedName[nodeId] = generateNameForNode(node));
	        }
	        /**
	         * Returns a value indicating whether a name is unique globally, within the current file,
	         * or within the NameGenerator.
	         */
	        function isUniqueName(name) {
	            return !(hasGlobalName && hasGlobalName(name))
	                && !currentSourceFile.identifiers.has(name)
	                && !generatedNames.has(name)
	                && !(reservedNames && reservedNames.has(name));
	        }
	        /**
	         * Returns a value indicating whether a name is unique within a container.
	         */
	        function isUniqueLocalName(name, container) {
	            for (var node = container; ts.isNodeDescendantOf(node, container); node = node.nextContainer) {
	                if (node.locals) {
	                    var local = node.locals.get(ts.escapeLeadingUnderscores(name));
	                    // We conservatively include alias symbols to cover cases where they're emitted as locals
	                    if (local && local.flags & (107455 /* Value */ | 1048576 /* ExportValue */ | 2097152 /* Alias */)) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }
	        /**
	         * Return the next available name in the pattern _a ... _z, _0, _1, ...
	         * TempFlags._i or TempFlags._n may be used to express a preference for that dedicated name.
	         * Note that names generated by makeTempVariableName and makeUniqueName will never conflict.
	         */
	        function makeTempVariableName(flags, reservedInNestedScopes) {
	            if (flags && !(tempFlags & flags)) {
	                var name = flags === 268435456 /* _i */ ? "_i" : "_n";
	                if (isUniqueName(name)) {
	                    tempFlags |= flags;
	                    if (reservedInNestedScopes) {
	                        reserveNameInNestedScopes(name);
	                    }
	                    return name;
	                }
	            }
	            while (true) {
	                var count = tempFlags & 268435455 /* CountMask */;
	                tempFlags++;
	                // Skip over 'i' and 'n'
	                if (count !== 8 && count !== 13) {
	                    var name = count < 26
	                        ? "_" + String.fromCharCode(97 /* a */ + count)
	                        : "_" + (count - 26);
	                    if (isUniqueName(name)) {
	                        if (reservedInNestedScopes) {
	                            reserveNameInNestedScopes(name);
	                        }
	                        return name;
	                    }
	                }
	            }
	        }
	        /**
	         * Generate a name that is unique within the current file and doesn't conflict with any names
	         * in global scope. The name is formed by adding an '_n' suffix to the specified base name,
	         * where n is a positive integer. Note that names generated by makeTempVariableName and
	         * makeUniqueName are guaranteed to never conflict.
	         */
	        function makeUniqueName(baseName) {
	            // Find the first unique 'name_n', where n is a positive number
	            if (baseName.charCodeAt(baseName.length - 1) !== 95 /* _ */) {
	                baseName += "_";
	            }
	            var i = 1;
	            while (true) {
	                var generatedName = baseName + i;
	                if (isUniqueName(generatedName)) {
	                    generatedNames.set(generatedName, true);
	                    return generatedName;
	                }
	                i++;
	            }
	        }
	        /**
	         * Generates a unique name for a ModuleDeclaration or EnumDeclaration.
	         */
	        function generateNameForModuleOrEnum(node) {
	            var name = getTextOfNode(node.name);
	            // Use module/enum name itself if it is unique, otherwise make a unique variation
	            return isUniqueLocalName(name, node) ? name : makeUniqueName(name);
	        }
	        /**
	         * Generates a unique name for an ImportDeclaration or ExportDeclaration.
	         */
	        function generateNameForImportOrExportDeclaration(node) {
	            var expr = ts.getExternalModuleName(node);
	            var baseName = ts.isStringLiteral(expr) ?
	                ts.makeIdentifierFromModuleName(expr.text) : "module";
	            return makeUniqueName(baseName);
	        }
	        /**
	         * Generates a unique name for a default export.
	         */
	        function generateNameForExportDefault() {
	            return makeUniqueName("default");
	        }
	        /**
	         * Generates a unique name for a class expression.
	         */
	        function generateNameForClassExpression() {
	            return makeUniqueName("class");
	        }
	        function generateNameForMethodOrAccessor(node) {
	            if (ts.isIdentifier(node.name)) {
	                return generateNameCached(node.name);
	            }
	            return makeTempVariableName(0 /* Auto */);
	        }
	        /**
	         * Generates a unique name from a node.
	         */
	        function generateNameForNode(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return makeUniqueName(getTextOfNode(node));
	                case 237 /* ModuleDeclaration */:
	                case 236 /* EnumDeclaration */:
	                    return generateNameForModuleOrEnum(node);
	                case 242 /* ImportDeclaration */:
	                case 248 /* ExportDeclaration */:
	                    return generateNameForImportOrExportDeclaration(node);
	                case 232 /* FunctionDeclaration */:
	                case 233 /* ClassDeclaration */:
	                case 247 /* ExportAssignment */:
	                    return generateNameForExportDefault();
	                case 203 /* ClassExpression */:
	                    return generateNameForClassExpression();
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return generateNameForMethodOrAccessor(node);
	                default:
	                    return makeTempVariableName(0 /* Auto */);
	            }
	        }
	        /**
	         * Generates a unique identifier for a node.
	         */
	        function makeName(name) {
	            switch (name.autoGenerateFlags & 7 /* KindMask */) {
	                case 1 /* Auto */:
	                    return makeTempVariableName(0 /* Auto */, !!(name.autoGenerateFlags & 16 /* ReservedInNestedScopes */));
	                case 2 /* Loop */:
	                    return makeTempVariableName(268435456 /* _i */, !!(name.autoGenerateFlags & 16 /* ReservedInNestedScopes */));
	                case 3 /* Unique */:
	                    return makeUniqueName(ts.idText(name));
	            }
	            ts.Debug.fail("Unsupported GeneratedIdentifierKind.");
	        }
	        /**
	         * Gets the node from which a name should be generated.
	         */
	        function getNodeForGeneratedName(name) {
	            var autoGenerateId = name.autoGenerateId;
	            var node = name;
	            var original = node.original;
	            while (original) {
	                node = original;
	                // if "node" is a different generated name (having a different
	                // "autoGenerateId"), use it and stop traversing.
	                if (ts.isIdentifier(node)
	                    && node.autoGenerateFlags === 4 /* Node */
	                    && node.autoGenerateId !== autoGenerateId) {
	                    break;
	                }
	                original = node.original;
	            }
	            // otherwise, return the original node for the source;
	            return node;
	        }
	    }
	    ts.createPrinter = createPrinter;
	    function createBracketsMap() {
	        var brackets = [];
	        brackets[512 /* Braces */] = ["{", "}"];
	        brackets[1024 /* Parenthesis */] = ["(", ")"];
	        brackets[2048 /* AngleBrackets */] = ["<", ">"];
	        brackets[4096 /* SquareBrackets */] = ["[", "]"];
	        return brackets;
	    }
	    function getOpeningBracket(format) {
	        return brackets[format & 7680 /* BracketsMask */][0];
	    }
	    function getClosingBracket(format) {
	        return brackets[format & 7680 /* BracketsMask */][1];
	    }
	    // Flags enum to track count of temp variables and a few dedicated names
	    var TempFlags;
	    (function (TempFlags) {
	        TempFlags[TempFlags["Auto"] = 0] = "Auto";
	        TempFlags[TempFlags["CountMask"] = 268435455] = "CountMask";
	        TempFlags[TempFlags["_i"] = 268435456] = "_i";
	    })(TempFlags || (TempFlags = {}));
	})(ts || (ts = {}));
	/// <reference path="sys.ts" />
	/// <reference path="emitter.ts" />
	/// <reference path="core.ts" />
	var ts;
	(function (ts) {
	    var ignoreDiagnosticCommentRegEx = /(^\s*$)|(^\s*\/\/\/?\s*(@ts-ignore)?)/;
	    function findConfigFile(searchPath, fileExists, configName) {
	        if (configName === void 0) { configName = "tsconfig.json"; }
	        return ts.forEachAncestorDirectory(searchPath, function (ancestor) {
	            var fileName = ts.combinePaths(ancestor, configName);
	            return fileExists(fileName) ? fileName : undefined;
	        });
	    }
	    ts.findConfigFile = findConfigFile;
	    function resolveTripleslashReference(moduleName, containingFile) {
	        var basePath = ts.getDirectoryPath(containingFile);
	        var referencedFileName = ts.isRootedDiskPath(moduleName) ? moduleName : ts.combinePaths(basePath, moduleName);
	        return ts.normalizePath(referencedFileName);
	    }
	    ts.resolveTripleslashReference = resolveTripleslashReference;
	    /* @internal */
	    function computeCommonSourceDirectoryOfFilenames(fileNames, currentDirectory, getCanonicalFileName) {
	        var commonPathComponents;
	        var failed = ts.forEach(fileNames, function (sourceFile) {
	            // Each file contributes into common source file path
	            var sourcePathComponents = ts.getNormalizedPathComponents(sourceFile, currentDirectory);
	            sourcePathComponents.pop(); // The base file name is not part of the common directory path
	            if (!commonPathComponents) {
	                // first file
	                commonPathComponents = sourcePathComponents;
	                return;
	            }
	            var n = Math.min(commonPathComponents.length, sourcePathComponents.length);
	            for (var i = 0; i < n; i++) {
	                if (getCanonicalFileName(commonPathComponents[i]) !== getCanonicalFileName(sourcePathComponents[i])) {
	                    if (i === 0) {
	                        // Failed to find any common path component
	                        return true;
	                    }
	                    // New common path found that is 0 -> i-1
	                    commonPathComponents.length = i;
	                    break;
	                }
	            }
	            // If the sourcePathComponents was shorter than the commonPathComponents, truncate to the sourcePathComponents
	            if (sourcePathComponents.length < commonPathComponents.length) {
	                commonPathComponents.length = sourcePathComponents.length;
	            }
	        });
	        // A common path can not be found when paths span multiple drives on windows, for example
	        if (failed) {
	            return "";
	        }
	        if (!commonPathComponents) {
	            return currentDirectory;
	        }
	        return ts.getNormalizedPathFromPathComponents(commonPathComponents);
	    }
	    ts.computeCommonSourceDirectoryOfFilenames = computeCommonSourceDirectoryOfFilenames;
	    function createCompilerHost(options, setParentNodes) {
	        var existingDirectories = ts.createMap();
	        function getCanonicalFileName(fileName) {
	            // if underlying system can distinguish between two files whose names differs only in cases then file name already in canonical form.
	            // otherwise use toLowerCase as a canonical form.
	            return ts.sys.useCaseSensitiveFileNames ? fileName : fileName.toLowerCase();
	        }
	        function getSourceFile(fileName, languageVersion, onError) {
	            var text;
	            try {
	                ts.performance.mark("beforeIORead");
	                text = ts.sys.readFile(fileName, options.charset);
	                ts.performance.mark("afterIORead");
	                ts.performance.measure("I/O Read", "beforeIORead", "afterIORead");
	            }
	            catch (e) {
	                if (onError) {
	                    onError(e.message);
	                }
	                text = "";
	            }
	            return text !== undefined ? ts.createSourceFile(fileName, text, languageVersion, setParentNodes) : undefined;
	        }
	        function directoryExists(directoryPath) {
	            if (existingDirectories.has(directoryPath)) {
	                return true;
	            }
	            if (ts.sys.directoryExists(directoryPath)) {
	                existingDirectories.set(directoryPath, true);
	                return true;
	            }
	            return false;
	        }
	        function ensureDirectoriesExist(directoryPath) {
	            if (directoryPath.length > ts.getRootLength(directoryPath) && !directoryExists(directoryPath)) {
	                var parentDirectory = ts.getDirectoryPath(directoryPath);
	                ensureDirectoriesExist(parentDirectory);
	                ts.sys.createDirectory(directoryPath);
	            }
	        }
	        var outputFingerprints;
	        function writeFileIfUpdated(fileName, data, writeByteOrderMark) {
	            if (!outputFingerprints) {
	                outputFingerprints = ts.createMap();
	            }
	            var hash = ts.sys.createHash(data);
	            var mtimeBefore = ts.sys.getModifiedTime(fileName);
	            if (mtimeBefore) {
	                var fingerprint = outputFingerprints.get(fileName);
	                // If output has not been changed, and the file has no external modification
	                if (fingerprint &&
	                    fingerprint.byteOrderMark === writeByteOrderMark &&
	                    fingerprint.hash === hash &&
	                    fingerprint.mtime.getTime() === mtimeBefore.getTime()) {
	                    return;
	                }
	            }
	            ts.sys.writeFile(fileName, data, writeByteOrderMark);
	            var mtimeAfter = ts.sys.getModifiedTime(fileName);
	            outputFingerprints.set(fileName, {
	                hash: hash,
	                byteOrderMark: writeByteOrderMark,
	                mtime: mtimeAfter
	            });
	        }
	        function writeFile(fileName, data, writeByteOrderMark, onError) {
	            try {
	                ts.performance.mark("beforeIOWrite");
	                ensureDirectoriesExist(ts.getDirectoryPath(ts.normalizePath(fileName)));
	                if (ts.isWatchSet(options) && ts.sys.createHash && ts.sys.getModifiedTime) {
	                    writeFileIfUpdated(fileName, data, writeByteOrderMark);
	                }
	                else {
	                    ts.sys.writeFile(fileName, data, writeByteOrderMark);
	                }
	                ts.performance.mark("afterIOWrite");
	                ts.performance.measure("I/O Write", "beforeIOWrite", "afterIOWrite");
	            }
	            catch (e) {
	                if (onError) {
	                    onError(e.message);
	                }
	            }
	        }
	        function getDefaultLibLocation() {
	            return ts.getDirectoryPath(ts.normalizePath(ts.sys.getExecutingFilePath()));
	        }
	        var newLine = ts.getNewLineCharacter(options);
	        var realpath = ts.sys.realpath && (function (path) { return ts.sys.realpath(path); });
	        return {
	            getSourceFile: getSourceFile,
	            getDefaultLibLocation: getDefaultLibLocation,
	            getDefaultLibFileName: function (options) { return ts.combinePaths(getDefaultLibLocation(), ts.getDefaultLibFileName(options)); },
	            writeFile: writeFile,
	            getCurrentDirectory: ts.memoize(function () { return ts.sys.getCurrentDirectory(); }),
	            useCaseSensitiveFileNames: function () { return ts.sys.useCaseSensitiveFileNames; },
	            getCanonicalFileName: getCanonicalFileName,
	            getNewLine: function () { return newLine; },
	            fileExists: function (fileName) { return ts.sys.fileExists(fileName); },
	            readFile: function (fileName) { return ts.sys.readFile(fileName); },
	            trace: function (s) { return ts.sys.write(s + newLine); },
	            directoryExists: function (directoryName) { return ts.sys.directoryExists(directoryName); },
	            getEnvironmentVariable: function (name) { return ts.sys.getEnvironmentVariable ? ts.sys.getEnvironmentVariable(name) : ""; },
	            getDirectories: function (path) { return ts.sys.getDirectories(path); },
	            realpath: realpath
	        };
	    }
	    ts.createCompilerHost = createCompilerHost;
	    function getPreEmitDiagnostics(program, sourceFile, cancellationToken) {
	        var diagnostics = program.getOptionsDiagnostics(cancellationToken).concat(program.getSyntacticDiagnostics(sourceFile, cancellationToken), program.getGlobalDiagnostics(cancellationToken), program.getSemanticDiagnostics(sourceFile, cancellationToken));
	        if (program.getCompilerOptions().declaration) {
	            ts.addRange(diagnostics, program.getDeclarationDiagnostics(sourceFile, cancellationToken));
	        }
	        return ts.sortAndDeduplicateDiagnostics(diagnostics);
	    }
	    ts.getPreEmitDiagnostics = getPreEmitDiagnostics;
	    function formatDiagnostics(diagnostics, host) {
	        var output = "";
	        for (var _i = 0, diagnostics_1 = diagnostics; _i < diagnostics_1.length; _i++) {
	            var diagnostic = diagnostics_1[_i];
	            output += formatDiagnostic(diagnostic, host);
	        }
	        return output;
	    }
	    ts.formatDiagnostics = formatDiagnostics;
	    function formatDiagnostic(diagnostic, host) {
	        var category = ts.DiagnosticCategory[diagnostic.category].toLowerCase();
	        var errorMessage = category + " TS" + diagnostic.code + ": " + flattenDiagnosticMessageText(diagnostic.messageText, host.getNewLine()) + host.getNewLine();
	        if (diagnostic.file) {
	            var _a = ts.getLineAndCharacterOfPosition(diagnostic.file, diagnostic.start), line = _a.line, character = _a.character;
	            var fileName = diagnostic.file.fileName;
	            var relativeFileName = ts.convertToRelativePath(fileName, host.getCurrentDirectory(), function (fileName) { return host.getCanonicalFileName(fileName); });
	            return relativeFileName + "(" + (line + 1) + "," + (character + 1) + "): " + errorMessage;
	        }
	        return errorMessage;
	    }
	    ts.formatDiagnostic = formatDiagnostic;
	    /** @internal */
	    var ForegroundColorEscapeSequences;
	    (function (ForegroundColorEscapeSequences) {
	        ForegroundColorEscapeSequences["Grey"] = "\u001B[90m";
	        ForegroundColorEscapeSequences["Red"] = "\u001B[91m";
	        ForegroundColorEscapeSequences["Yellow"] = "\u001B[93m";
	        ForegroundColorEscapeSequences["Blue"] = "\u001B[94m";
	        ForegroundColorEscapeSequences["Cyan"] = "\u001B[96m";
	    })(ForegroundColorEscapeSequences = ts.ForegroundColorEscapeSequences || (ts.ForegroundColorEscapeSequences = {}));
	    var gutterStyleSequence = "\u001b[30;47m";
	    var gutterSeparator = " ";
	    var resetEscapeSequence = "\u001b[0m";
	    var ellipsis = "...";
	    function getCategoryFormat(category) {
	        switch (category) {
	            case ts.DiagnosticCategory.Warning: return ForegroundColorEscapeSequences.Yellow;
	            case ts.DiagnosticCategory.Error: return ForegroundColorEscapeSequences.Red;
	            case ts.DiagnosticCategory.Message: return ForegroundColorEscapeSequences.Blue;
	        }
	    }
	    /** @internal */
	    function formatColorAndReset(text, formatStyle) {
	        return formatStyle + text + resetEscapeSequence;
	    }
	    ts.formatColorAndReset = formatColorAndReset;
	    function padLeft(s, length) {
	        while (s.length < length) {
	            s = " " + s;
	        }
	        return s;
	    }
	    function formatDiagnosticsWithColorAndContext(diagnostics, host) {
	        var output = "";
	        for (var _i = 0, diagnostics_2 = diagnostics; _i < diagnostics_2.length; _i++) {
	            var diagnostic = diagnostics_2[_i];
	            var context = "";
	            if (diagnostic.file) {
	                var start = diagnostic.start, length_4 = diagnostic.length, file = diagnostic.file;
	                var _a = ts.getLineAndCharacterOfPosition(file, start), firstLine = _a.line, firstLineChar = _a.character;
	                var _b = ts.getLineAndCharacterOfPosition(file, start + length_4), lastLine = _b.line, lastLineChar = _b.character;
	                var lastLineInFile = ts.getLineAndCharacterOfPosition(file, file.text.length).line;
	                var relativeFileName = host ? ts.convertToRelativePath(file.fileName, host.getCurrentDirectory(), function (fileName) { return host.getCanonicalFileName(fileName); }) : file.fileName;
	                var hasMoreThanFiveLines = (lastLine - firstLine) >= 4;
	                var gutterWidth = (lastLine + 1 + "").length;
	                if (hasMoreThanFiveLines) {
	                    gutterWidth = Math.max(ellipsis.length, gutterWidth);
	                }
	                for (var i = firstLine; i <= lastLine; i++) {
	                    context += host.getNewLine();
	                    // If the error spans over 5 lines, we'll only show the first 2 and last 2 lines,
	                    // so we'll skip ahead to the second-to-last line.
	                    if (hasMoreThanFiveLines && firstLine + 1 < i && i < lastLine - 1) {
	                        context += formatColorAndReset(padLeft(ellipsis, gutterWidth), gutterStyleSequence) + gutterSeparator + host.getNewLine();
	                        i = lastLine - 1;
	                    }
	                    var lineStart = ts.getPositionOfLineAndCharacter(file, i, 0);
	                    var lineEnd = i < lastLineInFile ? ts.getPositionOfLineAndCharacter(file, i + 1, 0) : file.text.length;
	                    var lineContent = file.text.slice(lineStart, lineEnd);
	                    lineContent = lineContent.replace(/\s+$/g, ""); // trim from end
	                    lineContent = lineContent.replace("\t", " "); // convert tabs to single spaces
	                    // Output the gutter and the actual contents of the line.
	                    context += formatColorAndReset(padLeft(i + 1 + "", gutterWidth), gutterStyleSequence) + gutterSeparator;
	                    context += lineContent + host.getNewLine();
	                    // Output the gutter and the error span for the line using tildes.
	                    context += formatColorAndReset(padLeft("", gutterWidth), gutterStyleSequence) + gutterSeparator;
	                    context += ForegroundColorEscapeSequences.Red;
	                    if (i === firstLine) {
	                        // If we're on the last line, then limit it to the last character of the last line.
	                        // Otherwise, we'll just squiggle the rest of the line, giving 'slice' no end position.
	                        var lastCharForLine = i === lastLine ? lastLineChar : undefined;
	                        context += lineContent.slice(0, firstLineChar).replace(/\S/g, " ");
	                        context += lineContent.slice(firstLineChar, lastCharForLine).replace(/./g, "~");
	                    }
	                    else if (i === lastLine) {
	                        context += lineContent.slice(0, lastLineChar).replace(/./g, "~");
	                    }
	                    else {
	                        // Squiggle the entire line.
	                        context += lineContent.replace(/./g, "~");
	                    }
	                    context += resetEscapeSequence;
	                }
	                output += formatColorAndReset(relativeFileName, ForegroundColorEscapeSequences.Cyan);
	                output += ":";
	                output += formatColorAndReset("" + (firstLine + 1), ForegroundColorEscapeSequences.Yellow);
	                output += ":";
	                output += formatColorAndReset("" + (firstLineChar + 1), ForegroundColorEscapeSequences.Yellow);
	                output += " - ";
	            }
	            var categoryColor = getCategoryFormat(diagnostic.category);
	            var category = ts.DiagnosticCategory[diagnostic.category].toLowerCase();
	            output += formatColorAndReset(category, categoryColor);
	            output += formatColorAndReset(" TS" + diagnostic.code + ": ", ForegroundColorEscapeSequences.Grey);
	            output += flattenDiagnosticMessageText(diagnostic.messageText, host.getNewLine());
	            if (diagnostic.file) {
	                output += host.getNewLine();
	                output += context;
	            }
	            output += host.getNewLine();
	        }
	        return output + host.getNewLine();
	    }
	    ts.formatDiagnosticsWithColorAndContext = formatDiagnosticsWithColorAndContext;
	    function flattenDiagnosticMessageText(messageText, newLine) {
	        if (ts.isString(messageText)) {
	            return messageText;
	        }
	        else {
	            var diagnosticChain = messageText;
	            var result = "";
	            var indent = 0;
	            while (diagnosticChain) {
	                if (indent) {
	                    result += newLine;
	                    for (var i = 0; i < indent; i++) {
	                        result += "  ";
	                    }
	                }
	                result += diagnosticChain.messageText;
	                indent++;
	                diagnosticChain = diagnosticChain.next;
	            }
	            return result;
	        }
	    }
	    ts.flattenDiagnosticMessageText = flattenDiagnosticMessageText;
	    function loadWithLocalCache(names, containingFile, loader) {
	        if (names.length === 0) {
	            return [];
	        }
	        var resolutions = [];
	        var cache = ts.createMap();
	        for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
	            var name = names_1[_i];
	            var result = void 0;
	            if (cache.has(name)) {
	                result = cache.get(name);
	            }
	            else {
	                cache.set(name, result = loader(name, containingFile));
	            }
	            resolutions.push(result);
	        }
	        return resolutions;
	    }
	    /**
	     * Determines if program structure is upto date or needs to be recreated
	     */
	    /* @internal */
	    function isProgramUptoDate(program, rootFileNames, newOptions, getSourceVersion, fileExists, hasInvalidatedResolution, hasChangedAutomaticTypeDirectiveNames) {
	        // If we haven't created a program yet or have changed automatic type directives, then it is not up-to-date
	        if (!program || hasChangedAutomaticTypeDirectiveNames) {
	            return false;
	        }
	        // If number of files in the program do not match, it is not up-to-date
	        if (program.getRootFileNames().length !== rootFileNames.length) {
	            return false;
	        }
	        // If any file is not up-to-date, then the whole program is not up-to-date
	        if (program.getSourceFiles().some(sourceFileNotUptoDate)) {
	            return false;
	        }
	        // If any of the missing file paths are now created
	        if (program.getMissingFilePaths().some(fileExists)) {
	            return false;
	        }
	        var currentOptions = program.getCompilerOptions();
	        // If the compilation settings do no match, then the program is not up-to-date
	        if (!ts.compareDataObjects(currentOptions, newOptions)) {
	            return false;
	        }
	        // If everything matches but the text of config file is changed,
	        // error locations can change for program options, so update the program
	        if (currentOptions.configFile && newOptions.configFile) {
	            return currentOptions.configFile.text === newOptions.configFile.text;
	        }
	        return true;
	        function sourceFileNotUptoDate(sourceFile) {
	            return sourceFile.version !== getSourceVersion(sourceFile.path) ||
	                hasInvalidatedResolution(sourceFile.path);
	        }
	    }
	    ts.isProgramUptoDate = isProgramUptoDate;
	    /**
	     * Determined if source file needs to be re-created even if its text hasn't changed
	     */
	    function shouldProgramCreateNewSourceFiles(program, newOptions) {
	        // If any of these options change, we can't reuse old source file even if version match
	        // The change in options like these could result in change in syntax tree change
	        var oldOptions = program && program.getCompilerOptions();
	        return oldOptions && (oldOptions.target !== newOptions.target ||
	            oldOptions.module !== newOptions.module ||
	            oldOptions.moduleResolution !== newOptions.moduleResolution ||
	            oldOptions.noResolve !== newOptions.noResolve ||
	            oldOptions.jsx !== newOptions.jsx ||
	            oldOptions.allowJs !== newOptions.allowJs ||
	            oldOptions.disableSizeLimit !== newOptions.disableSizeLimit ||
	            oldOptions.baseUrl !== newOptions.baseUrl ||
	            !ts.equalOwnProperties(oldOptions.paths, newOptions.paths));
	    }
	    /**
	     * Create a new 'Program' instance. A Program is an immutable collection of 'SourceFile's and a 'CompilerOptions'
	     * that represent a compilation unit.
	     *
	     * Creating a program proceeds from a set of root files, expanding the set of inputs by following imports and
	     * triple-slash-reference-path directives transitively. '@types' and triple-slash-reference-types are also pulled in.
	     *
	     * @param rootNames - A set of root files.
	     * @param options - The compiler options which should be used.
	     * @param host - The host interacts with the underlying file system.
	     * @param oldProgram - Reuses an old program structure.
	     * @returns A 'Program' object.
	     */
	    function createProgram(rootNames, options, host, oldProgram) {
	        var program;
	        var files = [];
	        var commonSourceDirectory;
	        var diagnosticsProducingTypeChecker;
	        var noDiagnosticsTypeChecker;
	        var classifiableNames;
	        var modifiedFilePaths;
	        var cachedSemanticDiagnosticsForFile = {};
	        var cachedDeclarationDiagnosticsForFile = {};
	        var resolvedTypeReferenceDirectives = ts.createMap();
	        var fileProcessingDiagnostics = ts.createDiagnosticCollection();
	        // The below settings are to track if a .js file should be add to the program if loaded via searching under node_modules.
	        // This works as imported modules are discovered recursively in a depth first manner, specifically:
	        // - For each root file, findSourceFile is called.
	        // - This calls processImportedModules for each module imported in the source file.
	        // - This calls resolveModuleNames, and then calls findSourceFile for each resolved module.
	        // As all these operations happen - and are nested - within the createProgram call, they close over the below variables.
	        // The current resolution depth is tracked by incrementing/decrementing as the depth first search progresses.
	        var maxNodeModuleJsDepth = typeof options.maxNodeModuleJsDepth === "number" ? options.maxNodeModuleJsDepth : 0;
	        var currentNodeModulesDepth = 0;
	        // If a module has some of its imports skipped due to being at the depth limit under node_modules, then track
	        // this, as it may be imported at a shallower depth later, and then it will need its skipped imports processed.
	        var modulesWithElidedImports = ts.createMap();
	        // Track source files that are source files found by searching under node_modules, as these shouldn't be compiled.
	        var sourceFilesFoundSearchingNodeModules = ts.createMap();
	        ts.performance.mark("beforeProgram");
	        host = host || createCompilerHost(options);
	        var skipDefaultLib = options.noLib;
	        var getDefaultLibraryFileName = ts.memoize(function () { return host.getDefaultLibFileName(options); });
	        var defaultLibraryPath = host.getDefaultLibLocation ? host.getDefaultLibLocation() : ts.getDirectoryPath(getDefaultLibraryFileName());
	        var programDiagnostics = ts.createDiagnosticCollection();
	        var currentDirectory = host.getCurrentDirectory();
	        var supportedExtensions = ts.getSupportedExtensions(options);
	        // Map storing if there is emit blocking diagnostics for given input
	        var hasEmitBlockingDiagnostics = ts.createMap();
	        var _compilerOptionsObjectLiteralSyntax;
	        var moduleResolutionCache;
	        var resolveModuleNamesWorker;
	        var hasInvalidatedResolution = host.hasInvalidatedResolution || ts.returnFalse;
	        if (host.resolveModuleNames) {
	            resolveModuleNamesWorker = function (moduleNames, containingFile, reusedNames) { return host.resolveModuleNames(checkAllDefined(moduleNames), containingFile, reusedNames).map(function (resolved) {
	                // An older host may have omitted extension, in which case we should infer it from the file extension of resolvedFileName.
	                if (!resolved || resolved.extension !== undefined) {
	                    return resolved;
	                }
	                var withExtension = ts.clone(resolved);
	                withExtension.extension = ts.extensionFromPath(resolved.resolvedFileName);
	                return withExtension;
	            }); };
	        }
	        else {
	            moduleResolutionCache = ts.createModuleResolutionCache(currentDirectory, function (x) { return host.getCanonicalFileName(x); });
	            var loader_1 = function (moduleName, containingFile) { return ts.resolveModuleName(moduleName, containingFile, options, host, moduleResolutionCache).resolvedModule; };
	            resolveModuleNamesWorker = function (moduleNames, containingFile) { return loadWithLocalCache(checkAllDefined(moduleNames), containingFile, loader_1); };
	        }
	        var resolveTypeReferenceDirectiveNamesWorker;
	        if (host.resolveTypeReferenceDirectives) {
	            resolveTypeReferenceDirectiveNamesWorker = function (typeDirectiveNames, containingFile) { return host.resolveTypeReferenceDirectives(checkAllDefined(typeDirectiveNames), containingFile); };
	        }
	        else {
	            var loader_2 = function (typesRef, containingFile) { return ts.resolveTypeReferenceDirective(typesRef, containingFile, options, host).resolvedTypeReferenceDirective; };
	            resolveTypeReferenceDirectiveNamesWorker = function (typeReferenceDirectiveNames, containingFile) { return loadWithLocalCache(checkAllDefined(typeReferenceDirectiveNames), containingFile, loader_2); };
	        }
	        // Map from a stringified PackageId to the source file with that id.
	        // Only one source file may have a given packageId. Others become redirects (see createRedirectSourceFile).
	        // `packageIdToSourceFile` is only used while building the program, while `sourceFileToPackageName` and `isSourceFileTargetOfRedirect` are kept around.
	        var packageIdToSourceFile = ts.createMap();
	        // Maps from a SourceFile's `.path` to the name of the package it was imported with.
	        var sourceFileToPackageName = ts.createMap();
	        // See `sourceFileIsRedirectedTo`.
	        var redirectTargetsSet = ts.createMap();
	        var filesByName = ts.createMap();
	        var missingFilePaths;
	        // stores 'filename -> file association' ignoring case
	        // used to track cases when two file names differ only in casing
	        var filesByNameIgnoreCase = host.useCaseSensitiveFileNames() ? ts.createMap() : undefined;
	        var shouldCreateNewSourceFile = shouldProgramCreateNewSourceFiles(oldProgram, options);
	        var structuralIsReused = tryReuseStructureFromOldProgram();
	        if (structuralIsReused !== 2 /* Completely */) {
	            ts.forEach(rootNames, function (name) { return processRootFile(name, /*isDefaultLib*/ false); });
	            // load type declarations specified via 'types' argument or implicitly from types/ and node_modules/@types folders
	            var typeReferences = ts.getAutomaticTypeDirectiveNames(options, host);
	            if (typeReferences.length) {
	                // This containingFilename needs to match with the one used in managed-side
	                var containingDirectory = options.configFilePath ? ts.getDirectoryPath(options.configFilePath) : host.getCurrentDirectory();
	                var containingFilename = ts.combinePaths(containingDirectory, "__inferred type names__.ts");
	                var resolutions = resolveTypeReferenceDirectiveNamesWorker(typeReferences, containingFilename);
	                for (var i = 0; i < typeReferences.length; i++) {
	                    processTypeReferenceDirective(typeReferences[i], resolutions[i]);
	                }
	            }
	            // Do not process the default library if:
	            //  - The '--noLib' flag is used.
	            //  - A 'no-default-lib' reference comment is encountered in
	            //      processing the root files.
	            if (!skipDefaultLib) {
	                // If '--lib' is not specified, include default library file according to '--target'
	                // otherwise, using options specified in '--lib' instead of '--target' default library file
	                if (!options.lib) {
	                    processRootFile(getDefaultLibraryFileName(), /*isDefaultLib*/ true);
	                }
	                else {
	                    ts.forEach(options.lib, function (libFileName) {
	                        processRootFile(ts.combinePaths(defaultLibraryPath, libFileName), /*isDefaultLib*/ true);
	                    });
	                }
	            }
	            missingFilePaths = ts.arrayFrom(filesByName.keys(), function (p) { return p; }).filter(function (p) { return !filesByName.get(p); });
	        }
	        ts.Debug.assert(!!missingFilePaths);
	        // unconditionally set moduleResolutionCache to undefined to avoid unnecessary leaks
	        moduleResolutionCache = undefined;
	        // Release any files we have acquired in the old program but are
	        // not part of the new program.
	        if (oldProgram && host.onReleaseOldSourceFile) {
	            var oldSourceFiles = oldProgram.getSourceFiles();
	            for (var _i = 0, oldSourceFiles_1 = oldSourceFiles; _i < oldSourceFiles_1.length; _i++) {
	                var oldSourceFile = oldSourceFiles_1[_i];
	                if (!getSourceFile(oldSourceFile.path) || shouldCreateNewSourceFile) {
	                    host.onReleaseOldSourceFile(oldSourceFile, oldProgram.getCompilerOptions());
	                }
	            }
	        }
	        // unconditionally set oldProgram to undefined to prevent it from being captured in closure
	        oldProgram = undefined;
	        program = {
	            getRootFileNames: function () { return rootNames; },
	            getSourceFile: getSourceFile,
	            getSourceFileByPath: getSourceFileByPath,
	            getSourceFiles: function () { return files; },
	            getMissingFilePaths: function () { return missingFilePaths; },
	            getCompilerOptions: function () { return options; },
	            getSyntacticDiagnostics: getSyntacticDiagnostics,
	            getOptionsDiagnostics: getOptionsDiagnostics,
	            getGlobalDiagnostics: getGlobalDiagnostics,
	            getSemanticDiagnostics: getSemanticDiagnostics,
	            getDeclarationDiagnostics: getDeclarationDiagnostics,
	            getTypeChecker: getTypeChecker,
	            getClassifiableNames: getClassifiableNames,
	            getDiagnosticsProducingTypeChecker: getDiagnosticsProducingTypeChecker,
	            getCommonSourceDirectory: getCommonSourceDirectory,
	            emit: emit,
	            getCurrentDirectory: function () { return currentDirectory; },
	            getNodeCount: function () { return getDiagnosticsProducingTypeChecker().getNodeCount(); },
	            getIdentifierCount: function () { return getDiagnosticsProducingTypeChecker().getIdentifierCount(); },
	            getSymbolCount: function () { return getDiagnosticsProducingTypeChecker().getSymbolCount(); },
	            getTypeCount: function () { return getDiagnosticsProducingTypeChecker().getTypeCount(); },
	            getFileProcessingDiagnostics: function () { return fileProcessingDiagnostics; },
	            getResolvedTypeReferenceDirectives: function () { return resolvedTypeReferenceDirectives; },
	            isSourceFileFromExternalLibrary: isSourceFileFromExternalLibrary,
	            isSourceFileDefaultLibrary: isSourceFileDefaultLibrary,
	            dropDiagnosticsProducingTypeChecker: dropDiagnosticsProducingTypeChecker,
	            getSourceFileFromReference: getSourceFileFromReference,
	            sourceFileToPackageName: sourceFileToPackageName,
	            redirectTargetsSet: redirectTargetsSet,
	            isEmittedFile: isEmittedFile
	        };
	        verifyCompilerOptions();
	        ts.performance.mark("afterProgram");
	        ts.performance.measure("Program", "beforeProgram", "afterProgram");
	        return program;
	        function toPath(fileName) {
	            return ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	        }
	        function getCommonSourceDirectory() {
	            if (commonSourceDirectory === undefined) {
	                var emittedFiles = ts.filter(files, function (file) { return ts.sourceFileMayBeEmitted(file, options, isSourceFileFromExternalLibrary); });
	                if (options.rootDir && checkSourceFilesBelongToPath(emittedFiles, options.rootDir)) {
	                    // If a rootDir is specified and is valid use it as the commonSourceDirectory
	                    commonSourceDirectory = ts.getNormalizedAbsolutePath(options.rootDir, currentDirectory);
	                }
	                else {
	                    commonSourceDirectory = computeCommonSourceDirectory(emittedFiles);
	                }
	                if (commonSourceDirectory && commonSourceDirectory[commonSourceDirectory.length - 1] !== ts.directorySeparator) {
	                    // Make sure directory path ends with directory separator so this string can directly
	                    // used to replace with "" to get the relative path of the source file and the relative path doesn't
	                    // start with / making it rooted path
	                    commonSourceDirectory += ts.directorySeparator;
	                }
	            }
	            return commonSourceDirectory;
	        }
	        function getClassifiableNames() {
	            if (!classifiableNames) {
	                // Initialize a checker so that all our files are bound.
	                getTypeChecker();
	                classifiableNames = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
	                    var sourceFile = files_1[_i];
	                    ts.copyEntries(sourceFile.classifiableNames, classifiableNames);
	                }
	            }
	            return classifiableNames;
	        }
	        function resolveModuleNamesReusingOldState(moduleNames, containingFile, file, oldProgramState) {
	            if (structuralIsReused === 0 /* Not */ && !file.ambientModuleNames.length) {
	                // If the old program state does not permit reusing resolutions and `file` does not contain locally defined ambient modules,
	                // the best we can do is fallback to the default logic.
	                return resolveModuleNamesWorker(moduleNames, containingFile);
	            }
	            var oldSourceFile = oldProgramState.program && oldProgramState.program.getSourceFile(containingFile);
	            if (oldSourceFile !== file && file.resolvedModules) {
	                // `file` was created for the new program.
	                //
	                // We only set `file.resolvedModules` via work from the current function,
	                // so it is defined iff we already called the current function on `file`.
	                // That call happened no later than the creation of the `file` object,
	                // which per above occured during the current program creation.
	                // Since we assume the filesystem does not change during program creation,
	                // it is safe to reuse resolutions from the earlier call.
	                var result_3 = [];
	                for (var _i = 0, moduleNames_1 = moduleNames; _i < moduleNames_1.length; _i++) {
	                    var moduleName = moduleNames_1[_i];
	                    var resolvedModule = file.resolvedModules.get(moduleName);
	                    result_3.push(resolvedModule);
	                }
	                return result_3;
	            }
	            // At this point, we know at least one of the following hold:
	            // - file has local declarations for ambient modules
	            // - old program state is available
	            // With this information, we can infer some module resolutions without performing resolution.
	            /** An ordered list of module names for which we cannot recover the resolution. */
	            var unknownModuleNames;
	            /**
	             * The indexing of elements in this list matches that of `moduleNames`.
	             *
	             * Before combining results, result[i] is in one of the following states:
	             * * undefined: needs to be recomputed,
	             * * predictedToResolveToAmbientModuleMarker: known to be an ambient module.
	             * Needs to be reset to undefined before returning,
	             * * ResolvedModuleFull instance: can be reused.
	             */
	            var result;
	            var reusedNames;
	            /** A transient placeholder used to mark predicted resolution in the result list. */
	            var predictedToResolveToAmbientModuleMarker = {};
	            for (var i = 0; i < moduleNames.length; i++) {
	                var moduleName = moduleNames[i];
	                // If the source file is unchanged and doesnt have invalidated resolution, reuse the module resolutions
	                if (file === oldSourceFile && !hasInvalidatedResolution(oldSourceFile.path)) {
	                    var oldResolvedModule = oldSourceFile && oldSourceFile.resolvedModules.get(moduleName);
	                    if (oldResolvedModule) {
	                        if (ts.isTraceEnabled(options, host)) {
	                            ts.trace(host, ts.Diagnostics.Reusing_resolution_of_module_0_to_file_1_from_old_program, moduleName, containingFile);
	                        }
	                        (result || (result = new Array(moduleNames.length)))[i] = oldResolvedModule;
	                        (reusedNames || (reusedNames = [])).push(moduleName);
	                        continue;
	                    }
	                }
	                // We know moduleName resolves to an ambient module provided that moduleName:
	                // - is in the list of ambient modules locally declared in the current source file.
	                // - resolved to an ambient module in the old program whose declaration is in an unmodified file
	                //   (so the same module declaration will land in the new program)
	                var resolvesToAmbientModuleInNonModifiedFile = false;
	                if (ts.contains(file.ambientModuleNames, moduleName)) {
	                    resolvesToAmbientModuleInNonModifiedFile = true;
	                    if (ts.isTraceEnabled(options, host)) {
	                        ts.trace(host, ts.Diagnostics.Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1, moduleName, containingFile);
	                    }
	                }
	                else {
	                    resolvesToAmbientModuleInNonModifiedFile = moduleNameResolvesToAmbientModuleInNonModifiedFile(moduleName, oldProgramState);
	                }
	                if (resolvesToAmbientModuleInNonModifiedFile) {
	                    (result || (result = new Array(moduleNames.length)))[i] = predictedToResolveToAmbientModuleMarker;
	                }
	                else {
	                    // Resolution failed in the old program, or resolved to an ambient module for which we can't reuse the result.
	                    (unknownModuleNames || (unknownModuleNames = [])).push(moduleName);
	                }
	            }
	            var resolutions = unknownModuleNames && unknownModuleNames.length
	                ? resolveModuleNamesWorker(unknownModuleNames, containingFile, reusedNames)
	                : ts.emptyArray;
	            // Combine results of resolutions and predicted results
	            if (!result) {
	                // There were no unresolved/ambient resolutions.
	                ts.Debug.assert(resolutions.length === moduleNames.length);
	                return resolutions;
	            }
	            var j = 0;
	            for (var i = 0; i < result.length; i++) {
	                if (result[i]) {
	                    // `result[i]` is either a `ResolvedModuleFull` or a marker.
	                    // If it is the former, we can leave it as is.
	                    if (result[i] === predictedToResolveToAmbientModuleMarker) {
	                        result[i] = undefined;
	                    }
	                }
	                else {
	                    result[i] = resolutions[j];
	                    j++;
	                }
	            }
	            ts.Debug.assert(j === resolutions.length);
	            return result;
	            // If we change our policy of rechecking failed lookups on each program create,
	            // we should adjust the value returned here.
	            function moduleNameResolvesToAmbientModuleInNonModifiedFile(moduleName, oldProgramState) {
	                var resolutionToFile = ts.getResolvedModule(oldProgramState.oldSourceFile, moduleName);
	                var resolvedFile = resolutionToFile && oldProgramState.program && oldProgramState.program.getSourceFile(resolutionToFile.resolvedFileName);
	                if (resolutionToFile && resolvedFile && !resolvedFile.externalModuleIndicator) {
	                    // In the old program, we resolved to an ambient module that was in the same
	                    //   place as we expected to find an actual module file.
	                    // We actually need to return 'false' here even though this seems like a 'true' case
	                    //   because the normal module resolution algorithm will find this anyway.
	                    return false;
	                }
	                var ambientModule = oldProgramState.program && oldProgramState.program.getTypeChecker().tryFindAmbientModuleWithoutAugmentations(moduleName);
	                if (!(ambientModule && ambientModule.declarations)) {
	                    return false;
	                }
	                // at least one of declarations should come from non-modified source file
	                var firstUnmodifiedFile = ts.forEach(ambientModule.declarations, function (d) {
	                    var f = ts.getSourceFileOfNode(d);
	                    return !ts.contains(oldProgramState.modifiedFilePaths, f.path) && f;
	                });
	                if (!firstUnmodifiedFile) {
	                    return false;
	                }
	                if (ts.isTraceEnabled(options, host)) {
	                    ts.trace(host, ts.Diagnostics.Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified, moduleName, firstUnmodifiedFile.fileName);
	                }
	                return true;
	            }
	        }
	        function tryReuseStructureFromOldProgram() {
	            if (!oldProgram) {
	                return 0 /* Not */;
	            }
	            // check properties that can affect structure of the program or module resolution strategy
	            // if any of these properties has changed - structure cannot be reused
	            var oldOptions = oldProgram.getCompilerOptions();
	            if (ts.changesAffectModuleResolution(oldOptions, options)) {
	                return oldProgram.structureIsReused = 0 /* Not */;
	            }
	            ts.Debug.assert(!(oldProgram.structureIsReused & (2 /* Completely */ | 1 /* SafeModules */)));
	            // there is an old program, check if we can reuse its structure
	            var oldRootNames = oldProgram.getRootFileNames();
	            if (!ts.arrayIsEqualTo(oldRootNames, rootNames)) {
	                return oldProgram.structureIsReused = 0 /* Not */;
	            }
	            if (!ts.arrayIsEqualTo(options.types, oldOptions.types)) {
	                return oldProgram.structureIsReused = 0 /* Not */;
	            }
	            // check if program source files has changed in the way that can affect structure of the program
	            var newSourceFiles = [];
	            var filePaths = [];
	            var modifiedSourceFiles = [];
	            oldProgram.structureIsReused = 2 /* Completely */;
	            // If the missing file paths are now present, it can change the progam structure,
	            // and hence cant reuse the structure.
	            // This is same as how we dont reuse the structure if one of the file from old program is now missing
	            if (oldProgram.getMissingFilePaths().some(function (missingFilePath) { return host.fileExists(missingFilePath); })) {
	                return oldProgram.structureIsReused = 0 /* Not */;
	            }
	            var oldSourceFiles = oldProgram.getSourceFiles();
	            var SeenPackageName;
	            (function (SeenPackageName) {
	                SeenPackageName[SeenPackageName["Exists"] = 0] = "Exists";
	                SeenPackageName[SeenPackageName["Modified"] = 1] = "Modified";
	            })(SeenPackageName || (SeenPackageName = {}));
	            var seenPackageNames = ts.createMap();
	            for (var _i = 0, oldSourceFiles_2 = oldSourceFiles; _i < oldSourceFiles_2.length; _i++) {
	                var oldSourceFile = oldSourceFiles_2[_i];
	                var newSourceFile = host.getSourceFileByPath
	                    ? host.getSourceFileByPath(oldSourceFile.fileName, oldSourceFile.path, options.target, /*onError*/ undefined, shouldCreateNewSourceFile)
	                    : host.getSourceFile(oldSourceFile.fileName, options.target, /*onError*/ undefined, shouldCreateNewSourceFile);
	                if (!newSourceFile) {
	                    return oldProgram.structureIsReused = 0 /* Not */;
	                }
	                ts.Debug.assert(!newSourceFile.redirectInfo, "Host should not return a redirect source file from `getSourceFile`");
	                var fileChanged = void 0;
	                if (oldSourceFile.redirectInfo) {
	                    // We got `newSourceFile` by path, so it is actually for the unredirected file.
	                    // This lets us know if the unredirected file has changed. If it has we should break the redirect.
	                    if (newSourceFile !== oldSourceFile.redirectInfo.unredirected) {
	                        // Underlying file has changed. Might not redirect anymore. Must rebuild program.
	                        return oldProgram.structureIsReused = 0 /* Not */;
	                    }
	                    fileChanged = false;
	                    newSourceFile = oldSourceFile; // Use the redirect.
	                }
	                else if (oldProgram.redirectTargetsSet.has(oldSourceFile.path)) {
	                    // If a redirected-to source file changes, the redirect may be broken.
	                    if (newSourceFile !== oldSourceFile) {
	                        return oldProgram.structureIsReused = 0 /* Not */;
	                    }
	                    fileChanged = false;
	                }
	                else {
	                    fileChanged = newSourceFile !== oldSourceFile;
	                }
	                newSourceFile.path = oldSourceFile.path;
	                filePaths.push(newSourceFile.path);
	                var packageName = oldProgram.sourceFileToPackageName.get(oldSourceFile.path);
	                if (packageName !== undefined) {
	                    // If there are 2 different source files for the same package name and at least one of them changes,
	                    // they might become redirects. So we must rebuild the program.
	                    var prevKind = seenPackageNames.get(packageName);
	                    var newKind = fileChanged ? 1 /* Modified */ : 0 /* Exists */;
	                    if ((prevKind !== undefined && newKind === 1 /* Modified */) || prevKind === 1 /* Modified */) {
	                        return oldProgram.structureIsReused = 0 /* Not */;
	                    }
	                    seenPackageNames.set(packageName, newKind);
	                }
	                if (fileChanged) {
	                    // The `newSourceFile` object was created for the new program.
	                    if (oldSourceFile.hasNoDefaultLib !== newSourceFile.hasNoDefaultLib) {
	                        // value of no-default-lib has changed
	                        // this will affect if default library is injected into the list of files
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    // check tripleslash references
	                    if (!ts.arrayIsEqualTo(oldSourceFile.referencedFiles, newSourceFile.referencedFiles, fileReferenceIsEqualTo)) {
	                        // tripleslash references has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    // check imports and module augmentations
	                    collectExternalModuleReferences(newSourceFile);
	                    if (!ts.arrayIsEqualTo(oldSourceFile.imports, newSourceFile.imports, moduleNameIsEqualTo)) {
	                        // imports has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    if (!ts.arrayIsEqualTo(oldSourceFile.moduleAugmentations, newSourceFile.moduleAugmentations, moduleNameIsEqualTo)) {
	                        // moduleAugmentations has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    if ((oldSourceFile.flags & 524288 /* PossiblyContainsDynamicImport */) !== (newSourceFile.flags & 524288 /* PossiblyContainsDynamicImport */)) {
	                        // dynamicImport has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    if (!ts.arrayIsEqualTo(oldSourceFile.typeReferenceDirectives, newSourceFile.typeReferenceDirectives, fileReferenceIsEqualTo)) {
	                        // 'types' references has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    // tentatively approve the file
	                    modifiedSourceFiles.push({ oldFile: oldSourceFile, newFile: newSourceFile });
	                }
	                else if (hasInvalidatedResolution(oldSourceFile.path)) {
	                    // 'module/types' references could have changed
	                    oldProgram.structureIsReused = 1 /* SafeModules */;
	                    // add file to the modified list so that we will resolve it later
	                    modifiedSourceFiles.push({ oldFile: oldSourceFile, newFile: newSourceFile });
	                }
	                // if file has passed all checks it should be safe to reuse it
	                newSourceFiles.push(newSourceFile);
	            }
	            if (oldProgram.structureIsReused !== 2 /* Completely */) {
	                return oldProgram.structureIsReused;
	            }
	            modifiedFilePaths = modifiedSourceFiles.map(function (f) { return f.newFile.path; });
	            // try to verify results of module resolution
	            for (var _a = 0, modifiedSourceFiles_1 = modifiedSourceFiles; _a < modifiedSourceFiles_1.length; _a++) {
	                var _b = modifiedSourceFiles_1[_a], oldSourceFile = _b.oldFile, newSourceFile = _b.newFile;
	                var newSourceFilePath = ts.getNormalizedAbsolutePath(newSourceFile.fileName, currentDirectory);
	                if (resolveModuleNamesWorker) {
	                    var moduleNames = getModuleNames(newSourceFile);
	                    var oldProgramState = { program: oldProgram, oldSourceFile: oldSourceFile, modifiedFilePaths: modifiedFilePaths };
	                    var resolutions = resolveModuleNamesReusingOldState(moduleNames, newSourceFilePath, newSourceFile, oldProgramState);
	                    // ensure that module resolution results are still correct
	                    var resolutionsChanged = ts.hasChangesInResolutions(moduleNames, resolutions, oldSourceFile.resolvedModules, ts.moduleResolutionIsEqualTo);
	                    if (resolutionsChanged) {
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                        newSourceFile.resolvedModules = ts.zipToMap(moduleNames, resolutions);
	                    }
	                    else {
	                        newSourceFile.resolvedModules = oldSourceFile.resolvedModules;
	                    }
	                }
	                if (resolveTypeReferenceDirectiveNamesWorker) {
	                    var typesReferenceDirectives = ts.map(newSourceFile.typeReferenceDirectives, function (x) { return x.fileName; });
	                    var resolutions = resolveTypeReferenceDirectiveNamesWorker(typesReferenceDirectives, newSourceFilePath);
	                    // ensure that types resolutions are still correct
	                    var resolutionsChanged = ts.hasChangesInResolutions(typesReferenceDirectives, resolutions, oldSourceFile.resolvedTypeReferenceDirectiveNames, ts.typeDirectiveIsEqualTo);
	                    if (resolutionsChanged) {
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                        newSourceFile.resolvedTypeReferenceDirectiveNames = ts.zipToMap(typesReferenceDirectives, resolutions);
	                    }
	                    else {
	                        newSourceFile.resolvedTypeReferenceDirectiveNames = oldSourceFile.resolvedTypeReferenceDirectiveNames;
	                    }
	                }
	            }
	            if (oldProgram.structureIsReused !== 2 /* Completely */) {
	                return oldProgram.structureIsReused;
	            }
	            if (host.hasChangedAutomaticTypeDirectiveNames) {
	                return oldProgram.structureIsReused = 1 /* SafeModules */;
	            }
	            missingFilePaths = oldProgram.getMissingFilePaths();
	            // update fileName -> file mapping
	            for (var i = 0; i < newSourceFiles.length; i++) {
	                filesByName.set(filePaths[i], newSourceFiles[i]);
	                // Set the file as found during node modules search if it was found that way in old progra,
	                if (oldProgram.isSourceFileFromExternalLibrary(oldProgram.getSourceFileByPath(filePaths[i]))) {
	                    sourceFilesFoundSearchingNodeModules.set(filePaths[i], true);
	                }
	            }
	            files = newSourceFiles;
	            fileProcessingDiagnostics = oldProgram.getFileProcessingDiagnostics();
	            for (var _c = 0, modifiedSourceFiles_2 = modifiedSourceFiles; _c < modifiedSourceFiles_2.length; _c++) {
	                var modifiedFile = modifiedSourceFiles_2[_c];
	                fileProcessingDiagnostics.reattachFileDiagnostics(modifiedFile.newFile);
	            }
	            resolvedTypeReferenceDirectives = oldProgram.getResolvedTypeReferenceDirectives();
	            sourceFileToPackageName = oldProgram.sourceFileToPackageName;
	            redirectTargetsSet = oldProgram.redirectTargetsSet;
	            return oldProgram.structureIsReused = 2 /* Completely */;
	        }
	        function getEmitHost(writeFileCallback) {
	            return {
	                getCanonicalFileName: getCanonicalFileName,
	                getCommonSourceDirectory: program.getCommonSourceDirectory,
	                getCompilerOptions: program.getCompilerOptions,
	                getCurrentDirectory: function () { return currentDirectory; },
	                getNewLine: function () { return host.getNewLine(); },
	                getSourceFile: program.getSourceFile,
	                getSourceFileByPath: program.getSourceFileByPath,
	                getSourceFiles: program.getSourceFiles,
	                isSourceFileFromExternalLibrary: isSourceFileFromExternalLibrary,
	                writeFile: writeFileCallback || (function (fileName, data, writeByteOrderMark, onError, sourceFiles) { return host.writeFile(fileName, data, writeByteOrderMark, onError, sourceFiles); }),
	                isEmitBlocked: isEmitBlocked,
	            };
	        }
	        function isSourceFileFromExternalLibrary(file) {
	            return sourceFilesFoundSearchingNodeModules.get(file.path);
	        }
	        function isSourceFileDefaultLibrary(file) {
	            if (file.hasNoDefaultLib) {
	                return true;
	            }
	            if (!options.noLib) {
	                return false;
	            }
	            // If '--lib' is not specified, include default library file according to '--target'
	            // otherwise, using options specified in '--lib' instead of '--target' default library file
	            var equalityComparer = host.useCaseSensitiveFileNames() ? ts.equateStringsCaseSensitive : ts.equateStringsCaseInsensitive;
	            if (!options.lib) {
	                return equalityComparer(file.fileName, getDefaultLibraryFileName());
	            }
	            else {
	                return ts.forEach(options.lib, function (libFileName) { return equalityComparer(file.fileName, ts.combinePaths(defaultLibraryPath, libFileName)); });
	            }
	        }
	        function getDiagnosticsProducingTypeChecker() {
	            return diagnosticsProducingTypeChecker || (diagnosticsProducingTypeChecker = ts.createTypeChecker(program, /*produceDiagnostics:*/ true));
	        }
	        function dropDiagnosticsProducingTypeChecker() {
	            diagnosticsProducingTypeChecker = undefined;
	        }
	        function getTypeChecker() {
	            return noDiagnosticsTypeChecker || (noDiagnosticsTypeChecker = ts.createTypeChecker(program, /*produceDiagnostics:*/ false));
	        }
	        function emit(sourceFile, writeFileCallback, cancellationToken, emitOnlyDtsFiles, transformers) {
	            return runWithCancellationToken(function () { return emitWorker(program, sourceFile, writeFileCallback, cancellationToken, emitOnlyDtsFiles, transformers); });
	        }
	        function isEmitBlocked(emitFileName) {
	            return hasEmitBlockingDiagnostics.has(toPath(emitFileName));
	        }
	        function emitWorker(program, sourceFile, writeFileCallback, cancellationToken, emitOnlyDtsFiles, customTransformers) {
	            var declarationDiagnostics = [];
	            if (!emitOnlyDtsFiles) {
	                if (options.noEmit) {
	                    return { diagnostics: declarationDiagnostics, sourceMaps: undefined, emittedFiles: undefined, emitSkipped: true };
	                }
	                // If the noEmitOnError flag is set, then check if we have any errors so far.  If so,
	                // immediately bail out.  Note that we pass 'undefined' for 'sourceFile' so that we
	                // get any preEmit diagnostics, not just the ones
	                if (options.noEmitOnError) {
	                    var diagnostics = program.getOptionsDiagnostics(cancellationToken).concat(program.getSyntacticDiagnostics(sourceFile, cancellationToken), program.getGlobalDiagnostics(cancellationToken), program.getSemanticDiagnostics(sourceFile, cancellationToken));
	                    if (diagnostics.length === 0 && program.getCompilerOptions().declaration) {
	                        declarationDiagnostics = program.getDeclarationDiagnostics(/*sourceFile*/ undefined, cancellationToken);
	                    }
	                    if (diagnostics.length > 0 || declarationDiagnostics.length > 0) {
	                        return {
	                            diagnostics: ts.concatenate(diagnostics, declarationDiagnostics),
	                            sourceMaps: undefined,
	                            emittedFiles: undefined,
	                            emitSkipped: true
	                        };
	                    }
	                }
	            }
	            // Create the emit resolver outside of the "emitTime" tracking code below.  That way
	            // any cost associated with it (like type checking) are appropriate associated with
	            // the type-checking counter.
	            //
	            // If the -out option is specified, we should not pass the source file to getEmitResolver.
	            // This is because in the -out scenario all files need to be emitted, and therefore all
	            // files need to be type checked. And the way to specify that all files need to be type
	            // checked is to not pass the file to getEmitResolver.
	            var emitResolver = getDiagnosticsProducingTypeChecker().getEmitResolver((options.outFile || options.out) ? undefined : sourceFile, cancellationToken);
	            ts.performance.mark("beforeEmit");
	            var transformers = emitOnlyDtsFiles ? [] : ts.getTransformers(options, customTransformers);
	            var emitResult = ts.emitFiles(emitResolver, getEmitHost(writeFileCallback), sourceFile, emitOnlyDtsFiles, transformers);
	            ts.performance.mark("afterEmit");
	            ts.performance.measure("Emit", "beforeEmit", "afterEmit");
	            return emitResult;
	        }
	        function getSourceFile(fileName) {
	            return getSourceFileByPath(toPath(fileName));
	        }
	        function getSourceFileByPath(path) {
	            return filesByName.get(path);
	        }
	        function getDiagnosticsHelper(sourceFile, getDiagnostics, cancellationToken) {
	            if (sourceFile) {
	                return getDiagnostics(sourceFile, cancellationToken);
	            }
	            return ts.sortAndDeduplicateDiagnostics(ts.flatMap(program.getSourceFiles(), function (sourceFile) {
	                if (cancellationToken) {
	                    cancellationToken.throwIfCancellationRequested();
	                }
	                return getDiagnostics(sourceFile, cancellationToken);
	            }));
	        }
	        function getSyntacticDiagnostics(sourceFile, cancellationToken) {
	            return getDiagnosticsHelper(sourceFile, getSyntacticDiagnosticsForFile, cancellationToken);
	        }
	        function getSemanticDiagnostics(sourceFile, cancellationToken) {
	            return getDiagnosticsHelper(sourceFile, getSemanticDiagnosticsForFile, cancellationToken);
	        }
	        function getDeclarationDiagnostics(sourceFile, cancellationToken) {
	            var options = program.getCompilerOptions();
	            // collect diagnostics from the program only once if either no source file was specified or out/outFile is set (bundled emit)
	            if (!sourceFile || options.out || options.outFile) {
	                return getDeclarationDiagnosticsWorker(sourceFile, cancellationToken);
	            }
	            else {
	                return getDiagnosticsHelper(sourceFile, getDeclarationDiagnosticsForFile, cancellationToken);
	            }
	        }
	        function getSyntacticDiagnosticsForFile(sourceFile) {
	            // For JavaScript files, we report semantic errors for using TypeScript-only
	            // constructs from within a JavaScript file as syntactic errors.
	            if (ts.isSourceFileJavaScript(sourceFile)) {
	                if (!sourceFile.additionalSyntacticDiagnostics) {
	                    sourceFile.additionalSyntacticDiagnostics = getJavaScriptSyntacticDiagnosticsForFile(sourceFile);
	                }
	                return ts.concatenate(sourceFile.additionalSyntacticDiagnostics, sourceFile.parseDiagnostics);
	            }
	            return sourceFile.parseDiagnostics;
	        }
	        function runWithCancellationToken(func) {
	            try {
	                return func();
	            }
	            catch (e) {
	                if (e instanceof ts.OperationCanceledException) {
	                    // We were canceled while performing the operation.  Because our type checker
	                    // might be a bad state, we need to throw it away.
	                    //
	                    // Note: we are overly aggressive here.  We do not actually *have* to throw away
	                    // the "noDiagnosticsTypeChecker".  However, for simplicity, i'd like to keep
	                    // the lifetimes of these two TypeCheckers the same.  Also, we generally only
	                    // cancel when the user has made a change anyways.  And, in that case, we (the
	                    // program instance) will get thrown away anyways.  So trying to keep one of
	                    // these type checkers alive doesn't serve much purpose.
	                    noDiagnosticsTypeChecker = undefined;
	                    diagnosticsProducingTypeChecker = undefined;
	                }
	                throw e;
	            }
	        }
	        function getSemanticDiagnosticsForFile(sourceFile, cancellationToken) {
	            return getAndCacheDiagnostics(sourceFile, cancellationToken, cachedSemanticDiagnosticsForFile, getSemanticDiagnosticsForFileNoCache);
	        }
	        function getSemanticDiagnosticsForFileNoCache(sourceFile, cancellationToken) {
	            return runWithCancellationToken(function () {
	                // If skipLibCheck is enabled, skip reporting errors if file is a declaration file.
	                // If skipDefaultLibCheck is enabled, skip reporting errors if file contains a
	                // '/// <reference no-default-lib="true"/>' directive.
	                if (options.skipLibCheck && sourceFile.isDeclarationFile || options.skipDefaultLibCheck && sourceFile.hasNoDefaultLib) {
	                    return ts.emptyArray;
	                }
	                var typeChecker = getDiagnosticsProducingTypeChecker();
	                ts.Debug.assert(!!sourceFile.bindDiagnostics);
	                var isCheckJs = ts.isCheckJsEnabledForFile(sourceFile, options);
	                // By default, only type-check .ts, .tsx, and 'External' files (external files are added by plugins)
	                var includeBindAndCheckDiagnostics = sourceFile.scriptKind === 3 /* TS */ || sourceFile.scriptKind === 4 /* TSX */ ||
	                    sourceFile.scriptKind === 5 /* External */ || isCheckJs;
	                var bindDiagnostics = includeBindAndCheckDiagnostics ? sourceFile.bindDiagnostics : ts.emptyArray;
	                var checkDiagnostics = includeBindAndCheckDiagnostics ? typeChecker.getDiagnostics(sourceFile, cancellationToken) : ts.emptyArray;
	                var fileProcessingDiagnosticsInFile = fileProcessingDiagnostics.getDiagnostics(sourceFile.fileName);
	                var programDiagnosticsInFile = programDiagnostics.getDiagnostics(sourceFile.fileName);
	                var diagnostics = bindDiagnostics.concat(checkDiagnostics, fileProcessingDiagnosticsInFile, programDiagnosticsInFile);
	                if (isCheckJs) {
	                    diagnostics = ts.concatenate(diagnostics, sourceFile.jsDocDiagnostics);
	                }
	                return ts.filter(diagnostics, shouldReportDiagnostic);
	            });
	        }
	        /**
	         * Skip errors if previous line start with '// @ts-ignore' comment, not counting non-empty non-comment lines
	         */
	        function shouldReportDiagnostic(diagnostic) {
	            var file = diagnostic.file, start = diagnostic.start;
	            if (file) {
	                var lineStarts = ts.getLineStarts(file);
	                var line = ts.computeLineAndCharacterOfPosition(lineStarts, start).line;
	                while (line > 0) {
	                    var previousLineText = file.text.slice(lineStarts[line - 1], lineStarts[line]);
	                    var result = ignoreDiagnosticCommentRegEx.exec(previousLineText);
	                    if (!result) {
	                        // non-empty line
	                        return true;
	                    }
	                    if (result[3]) {
	                        // @ts-ignore
	                        return false;
	                    }
	                    line--;
	                }
	            }
	            return true;
	        }
	        function getJavaScriptSyntacticDiagnosticsForFile(sourceFile) {
	            return runWithCancellationToken(function () {
	                var diagnostics = [];
	                var parent = sourceFile;
	                walk(sourceFile);
	                return diagnostics;
	                function walk(node) {
	                    // Return directly from the case if the given node doesnt want to visit each child
	                    // Otherwise break to visit each child
	                    switch (parent.kind) {
	                        case 148 /* Parameter */:
	                        case 151 /* PropertyDeclaration */:
	                            if (parent.questionToken === node) {
	                                diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics._0_can_only_be_used_in_a_ts_file, "?"));
	                                return;
	                            }
	                        // falls through
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 154 /* Constructor */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                        case 190 /* FunctionExpression */:
	                        case 232 /* FunctionDeclaration */:
	                        case 191 /* ArrowFunction */:
	                        case 230 /* VariableDeclaration */:
	                            // type annotation
	                            if (parent.type === node) {
	                                diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.types_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                    }
	                    switch (node.kind) {
	                        case 241 /* ImportEqualsDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.import_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 247 /* ExportAssignment */:
	                            if (node.isExportEquals) {
	                                diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.export_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                            break;
	                        case 266 /* HeritageClause */:
	                            var heritageClause = node;
	                            if (heritageClause.token === 108 /* ImplementsKeyword */) {
	                                diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.implements_clauses_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                            break;
	                        case 234 /* InterfaceDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.interface_declarations_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 237 /* ModuleDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.module_declarations_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 235 /* TypeAliasDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.type_aliases_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 236 /* EnumDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.enum_declarations_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 207 /* NonNullExpression */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.non_null_assertions_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 206 /* AsExpression */:
	                            diagnostics.push(createDiagnosticForNode(node.type, ts.Diagnostics.type_assertion_expressions_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 188 /* TypeAssertionExpression */:
	                            ts.Debug.fail(); // Won't parse these in a JS file anyway, as they are interpreted as JSX.
	                    }
	                    var prevParent = parent;
	                    parent = node;
	                    ts.forEachChild(node, walk, walkArray);
	                    parent = prevParent;
	                }
	                function walkArray(nodes) {
	                    if (parent.decorators === nodes && !options.experimentalDecorators) {
	                        diagnostics.push(createDiagnosticForNode(parent, ts.Diagnostics.Experimental_support_for_decorators_is_a_feature_that_is_subject_to_change_in_a_future_release_Set_the_experimentalDecorators_option_to_remove_this_warning));
	                    }
	                    switch (parent.kind) {
	                        case 233 /* ClassDeclaration */:
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 154 /* Constructor */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                        case 190 /* FunctionExpression */:
	                        case 232 /* FunctionDeclaration */:
	                        case 191 /* ArrowFunction */:
	                            // Check type parameters
	                            if (nodes === parent.typeParameters) {
	                                diagnostics.push(createDiagnosticForNodeArray(nodes, ts.Diagnostics.type_parameter_declarations_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                        // falls through
	                        case 212 /* VariableStatement */:
	                            // Check modifiers
	                            if (nodes === parent.modifiers) {
	                                return checkModifiers(nodes, parent.kind === 212 /* VariableStatement */);
	                            }
	                            break;
	                        case 151 /* PropertyDeclaration */:
	                            // Check modifiers of property declaration
	                            if (nodes === parent.modifiers) {
	                                for (var _i = 0, _a = nodes; _i < _a.length; _i++) {
	                                    var modifier = _a[_i];
	                                    if (modifier.kind !== 115 /* StaticKeyword */) {
	                                        diagnostics.push(createDiagnosticForNode(modifier, ts.Diagnostics._0_can_only_be_used_in_a_ts_file, ts.tokenToString(modifier.kind)));
	                                    }
	                                }
	                                return;
	                            }
	                            break;
	                        case 148 /* Parameter */:
	                            // Check modifiers of parameter declaration
	                            if (nodes === parent.modifiers) {
	                                diagnostics.push(createDiagnosticForNodeArray(nodes, ts.Diagnostics.parameter_modifiers_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                            break;
	                        case 185 /* CallExpression */:
	                        case 186 /* NewExpression */:
	                        case 205 /* ExpressionWithTypeArguments */:
	                            // Check type arguments
	                            if (nodes === parent.typeArguments) {
	                                diagnostics.push(createDiagnosticForNodeArray(nodes, ts.Diagnostics.type_arguments_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                            break;
	                    }
	                    for (var _b = 0, nodes_8 = nodes; _b < nodes_8.length; _b++) {
	                        var node = nodes_8[_b];
	                        walk(node);
	                    }
	                }
	                function checkModifiers(modifiers, isConstValid) {
	                    for (var _i = 0, modifiers_1 = modifiers; _i < modifiers_1.length; _i++) {
	                        var modifier = modifiers_1[_i];
	                        switch (modifier.kind) {
	                            case 76 /* ConstKeyword */:
	                                if (isConstValid) {
	                                    continue;
	                                }
	                            // to report error,
	                            // falls through
	                            case 114 /* PublicKeyword */:
	                            case 112 /* PrivateKeyword */:
	                            case 113 /* ProtectedKeyword */:
	                            case 132 /* ReadonlyKeyword */:
	                            case 124 /* DeclareKeyword */:
	                            case 117 /* AbstractKeyword */:
	                                diagnostics.push(createDiagnosticForNode(modifier, ts.Diagnostics._0_can_only_be_used_in_a_ts_file, ts.tokenToString(modifier.kind)));
	                                break;
	                            // These are all legal modifiers.
	                            case 115 /* StaticKeyword */:
	                            case 84 /* ExportKeyword */:
	                            case 79 /* DefaultKeyword */:
	                        }
	                    }
	                }
	                function createDiagnosticForNodeArray(nodes, message, arg0, arg1, arg2) {
	                    var start = nodes.pos;
	                    return ts.createFileDiagnostic(sourceFile, start, nodes.end - start, message, arg0, arg1, arg2);
	                }
	                // Since these are syntactic diagnostics, parent might not have been set
	                // this means the sourceFile cannot be infered from the node
	                function createDiagnosticForNode(node, message, arg0, arg1, arg2) {
	                    return ts.createDiagnosticForNodeInSourceFile(sourceFile, node, message, arg0, arg1, arg2);
	                }
	            });
	        }
	        function getDeclarationDiagnosticsWorker(sourceFile, cancellationToken) {
	            return getAndCacheDiagnostics(sourceFile, cancellationToken, cachedDeclarationDiagnosticsForFile, getDeclarationDiagnosticsForFileNoCache);
	        }
	        function getDeclarationDiagnosticsForFileNoCache(sourceFile, cancellationToken) {
	            return runWithCancellationToken(function () {
	                var resolver = getDiagnosticsProducingTypeChecker().getEmitResolver(sourceFile, cancellationToken);
	                // Don't actually write any files since we're just getting diagnostics.
	                return ts.getDeclarationDiagnostics(getEmitHost(ts.noop), resolver, sourceFile);
	            });
	        }
	        function getAndCacheDiagnostics(sourceFile, cancellationToken, cache, getDiagnostics) {
	            var cachedResult = sourceFile
	                ? cache.perFile && cache.perFile.get(sourceFile.path)
	                : cache.allDiagnostics;
	            if (cachedResult) {
	                return cachedResult;
	            }
	            var result = getDiagnostics(sourceFile, cancellationToken) || ts.emptyArray;
	            if (sourceFile) {
	                if (!cache.perFile) {
	                    cache.perFile = ts.createMap();
	                }
	                cache.perFile.set(sourceFile.path, result);
	            }
	            else {
	                cache.allDiagnostics = result;
	            }
	            return result;
	        }
	        function getDeclarationDiagnosticsForFile(sourceFile, cancellationToken) {
	            return sourceFile.isDeclarationFile ? [] : getDeclarationDiagnosticsWorker(sourceFile, cancellationToken);
	        }
	        function getOptionsDiagnostics() {
	            return ts.sortAndDeduplicateDiagnostics(ts.concatenate(fileProcessingDiagnostics.getGlobalDiagnostics(), ts.concatenate(programDiagnostics.getGlobalDiagnostics(), options.configFile ? programDiagnostics.getDiagnostics(options.configFile.fileName) : [])));
	        }
	        function getGlobalDiagnostics() {
	            return ts.sortAndDeduplicateDiagnostics(getDiagnosticsProducingTypeChecker().getGlobalDiagnostics().slice());
	        }
	        function processRootFile(fileName, isDefaultLib) {
	            processSourceFile(ts.normalizePath(fileName), isDefaultLib, /*packageId*/ undefined);
	        }
	        function fileReferenceIsEqualTo(a, b) {
	            return a.fileName === b.fileName;
	        }
	        function moduleNameIsEqualTo(a, b) {
	            return a.kind === 9 /* StringLiteral */
	                ? b.kind === 9 /* StringLiteral */ && a.text === b.text
	                : b.kind === 71 /* Identifier */ && a.escapedText === b.escapedText;
	        }
	        function collectExternalModuleReferences(file) {
	            if (file.imports) {
	                return;
	            }
	            var isJavaScriptFile = ts.isSourceFileJavaScript(file);
	            var isExternalModuleFile = ts.isExternalModule(file);
	            // file.imports may not be undefined if there exists dynamic import
	            var imports;
	            var moduleAugmentations;
	            var ambientModules;
	            // If we are importing helpers, we need to add a synthetic reference to resolve the
	            // helpers library.
	            if (options.importHelpers
	                && (options.isolatedModules || isExternalModuleFile)
	                && !file.isDeclarationFile) {
	                // synthesize 'import "tslib"' declaration
	                var externalHelpersModuleReference = ts.createLiteral(ts.externalHelpersModuleNameText);
	                var importDecl = ts.createImportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, /*importClause*/ undefined);
	                ts.addEmitFlags(importDecl, 67108864 /* NeverApplyImportHelper */);
	                externalHelpersModuleReference.parent = importDecl;
	                importDecl.parent = file;
	                imports = [externalHelpersModuleReference];
	            }
	            for (var _i = 0, _a = file.statements; _i < _a.length; _i++) {
	                var node = _a[_i];
	                collectModuleReferences(node, /*inAmbientModule*/ false);
	                if ((file.flags & 524288 /* PossiblyContainsDynamicImport */) || isJavaScriptFile) {
	                    collectDynamicImportOrRequireCalls(node);
	                }
	            }
	            file.imports = imports || ts.emptyArray;
	            file.moduleAugmentations = moduleAugmentations || ts.emptyArray;
	            file.ambientModuleNames = ambientModules || ts.emptyArray;
	            return;
	            function collectModuleReferences(node, inAmbientModule) {
	                switch (node.kind) {
	                    case 242 /* ImportDeclaration */:
	                    case 241 /* ImportEqualsDeclaration */:
	                    case 248 /* ExportDeclaration */:
	                        var moduleNameExpr = ts.getExternalModuleName(node);
	                        if (!moduleNameExpr || !ts.isStringLiteral(moduleNameExpr)) {
	                            break;
	                        }
	                        if (!moduleNameExpr.text) {
	                            break;
	                        }
	                        // TypeScript 1.0 spec (April 2014): 12.1.6
	                        // An ExternalImportDeclaration in an AmbientExternalModuleDeclaration may reference other external modules
	                        // only through top - level external module names. Relative external module names are not permitted.
	                        if (!inAmbientModule || !ts.isExternalModuleNameRelative(moduleNameExpr.text)) {
	                            (imports || (imports = [])).push(moduleNameExpr);
	                        }
	                        break;
	                    case 237 /* ModuleDeclaration */:
	                        if (ts.isAmbientModule(node) && (inAmbientModule || ts.hasModifier(node, 2 /* Ambient */) || file.isDeclarationFile)) {
	                            var moduleName = node.name;
	                            var nameText = ts.getTextOfIdentifierOrLiteral(moduleName);
	                            // Ambient module declarations can be interpreted as augmentations for some existing external modules.
	                            // This will happen in two cases:
	                            // - if current file is external module then module augmentation is a ambient module declaration defined in the top level scope
	                            // - if current file is not external module then module augmentation is an ambient module declaration with non-relative module name
	                            //   immediately nested in top level ambient module declaration .
	                            if (isExternalModuleFile || (inAmbientModule && !ts.isExternalModuleNameRelative(nameText))) {
	                                (moduleAugmentations || (moduleAugmentations = [])).push(moduleName);
	                            }
	                            else if (!inAmbientModule) {
	                                if (file.isDeclarationFile) {
	                                    // for global .d.ts files record name of ambient module
	                                    (ambientModules || (ambientModules = [])).push(nameText);
	                                }
	                                // An AmbientExternalModuleDeclaration declares an external module.
	                                // This type of declaration is permitted only in the global module.
	                                // The StringLiteral must specify a top - level external module name.
	                                // Relative external module names are not permitted
	                                // NOTE: body of ambient module is always a module block, if it exists
	                                var body = node.body;
	                                if (body) {
	                                    for (var _i = 0, _a = body.statements; _i < _a.length; _i++) {
	                                        var statement = _a[_i];
	                                        collectModuleReferences(statement, /*inAmbientModule*/ true);
	                                    }
	                                }
	                            }
	                        }
	                }
	            }
	            function collectDynamicImportOrRequireCalls(node) {
	                if (ts.isRequireCall(node, /*checkArgumentIsStringLiteral*/ true)) {
	                    (imports || (imports = [])).push(node.arguments[0]);
	                }
	                else if (ts.isImportCall(node) && node.arguments.length === 1 && node.arguments[0].kind === 9 /* StringLiteral */) {
	                    (imports || (imports = [])).push(node.arguments[0]);
	                }
	                else {
	                    ts.forEachChild(node, collectDynamicImportOrRequireCalls);
	                }
	            }
	        }
	        /** This should have similar behavior to 'processSourceFile' without diagnostics or mutation. */
	        function getSourceFileFromReference(referencingFile, ref) {
	            return getSourceFileFromReferenceWorker(resolveTripleslashReference(ref.fileName, referencingFile.fileName), function (fileName) { return filesByName.get(toPath(fileName)); });
	        }
	        function getSourceFileFromReferenceWorker(fileName, getSourceFile, fail, refFile) {
	            if (ts.hasExtension(fileName)) {
	                if (!options.allowNonTsExtensions && !ts.forEach(supportedExtensions, function (extension) { return ts.fileExtensionIs(host.getCanonicalFileName(fileName), extension); })) {
	                    if (fail)
	                        fail(ts.Diagnostics.File_0_has_unsupported_extension_The_only_supported_extensions_are_1, fileName, "'" + supportedExtensions.join("', '") + "'");
	                    return undefined;
	                }
	                var sourceFile = getSourceFile(fileName);
	                if (fail) {
	                    if (!sourceFile) {
	                        fail(ts.Diagnostics.File_0_not_found, fileName);
	                    }
	                    else if (refFile && host.getCanonicalFileName(fileName) === host.getCanonicalFileName(refFile.fileName)) {
	                        fail(ts.Diagnostics.A_file_cannot_have_a_reference_to_itself);
	                    }
	                }
	                return sourceFile;
	            }
	            else {
	                var sourceFileNoExtension = options.allowNonTsExtensions && getSourceFile(fileName);
	                if (sourceFileNoExtension)
	                    return sourceFileNoExtension;
	                if (fail && options.allowNonTsExtensions) {
	                    fail(ts.Diagnostics.File_0_not_found, fileName);
	                    return undefined;
	                }
	                var sourceFileWithAddedExtension = ts.forEach(supportedExtensions, function (extension) { return getSourceFile(fileName + extension); });
	                if (fail && !sourceFileWithAddedExtension)
	                    fail(ts.Diagnostics.File_0_not_found, fileName + ".ts" /* Ts */);
	                return sourceFileWithAddedExtension;
	            }
	        }
	        /** This has side effects through `findSourceFile`. */
	        function processSourceFile(fileName, isDefaultLib, packageId, refFile, refPos, refEnd) {
	            getSourceFileFromReferenceWorker(fileName, function (fileName) { return findSourceFile(fileName, toPath(fileName), isDefaultLib, refFile, refPos, refEnd, packageId); }, function (diagnostic) {
	                var args = [];
	                for (var _i = 1; _i < arguments.length; _i++) {
	                    args[_i - 1] = arguments[_i];
	                }
	                fileProcessingDiagnostics.add(refFile !== undefined && refEnd !== undefined && refPos !== undefined
	                    ? ts.createFileDiagnostic.apply(void 0, [refFile, refPos, refEnd - refPos, diagnostic].concat(args)) : ts.createCompilerDiagnostic.apply(void 0, [diagnostic].concat(args)));
	            }, refFile);
	        }
	        function reportFileNamesDifferOnlyInCasingError(fileName, existingFileName, refFile, refPos, refEnd) {
	            if (refFile !== undefined && refPos !== undefined && refEnd !== undefined) {
	                fileProcessingDiagnostics.add(ts.createFileDiagnostic(refFile, refPos, refEnd - refPos, ts.Diagnostics.File_name_0_differs_from_already_included_file_name_1_only_in_casing, fileName, existingFileName));
	            }
	            else {
	                fileProcessingDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.File_name_0_differs_from_already_included_file_name_1_only_in_casing, fileName, existingFileName));
	            }
	        }
	        function createRedirectSourceFile(redirectTarget, unredirected, fileName, path) {
	            var redirect = Object.create(redirectTarget);
	            redirect.fileName = fileName;
	            redirect.path = path;
	            redirect.redirectInfo = { redirectTarget: redirectTarget, unredirected: unredirected };
	            Object.defineProperties(redirect, {
	                id: {
	                    get: function () { return this.redirectInfo.redirectTarget.id; },
	                    set: function (value) { this.redirectInfo.redirectTarget.id = value; },
	                },
	                symbol: {
	                    get: function () { return this.redirectInfo.redirectTarget.symbol; },
	                    set: function (value) { this.redirectInfo.redirectTarget.symbol = value; },
	                },
	            });
	            return redirect;
	        }
	        // Get source file from normalized fileName
	        function findSourceFile(fileName, path, isDefaultLib, refFile, refPos, refEnd, packageId) {
	            if (filesByName.has(path)) {
	                var file_1 = filesByName.get(path);
	                // try to check if we've already seen this file but with a different casing in path
	                // NOTE: this only makes sense for case-insensitive file systems
	                if (file_1 && options.forceConsistentCasingInFileNames && ts.getNormalizedAbsolutePath(file_1.fileName, currentDirectory) !== ts.getNormalizedAbsolutePath(fileName, currentDirectory)) {
	                    reportFileNamesDifferOnlyInCasingError(fileName, file_1.fileName, refFile, refPos, refEnd);
	                }
	                // If the file was previously found via a node_modules search, but is now being processed as a root file,
	                // then everything it sucks in may also be marked incorrectly, and needs to be checked again.
	                if (file_1 && sourceFilesFoundSearchingNodeModules.get(file_1.path) && currentNodeModulesDepth === 0) {
	                    sourceFilesFoundSearchingNodeModules.set(file_1.path, false);
	                    if (!options.noResolve) {
	                        processReferencedFiles(file_1, isDefaultLib);
	                        processTypeReferenceDirectives(file_1);
	                    }
	                    modulesWithElidedImports.set(file_1.path, false);
	                    processImportedModules(file_1);
	                }
	                else if (file_1 && modulesWithElidedImports.get(file_1.path)) {
	                    if (currentNodeModulesDepth < maxNodeModuleJsDepth) {
	                        modulesWithElidedImports.set(file_1.path, false);
	                        processImportedModules(file_1);
	                    }
	                }
	                return file_1;
	            }
	            // We haven't looked for this file, do so now and cache result
	            var file = host.getSourceFile(fileName, options.target, function (hostErrorMessage) {
	                if (refFile !== undefined && refPos !== undefined && refEnd !== undefined) {
	                    fileProcessingDiagnostics.add(ts.createFileDiagnostic(refFile, refPos, refEnd - refPos, ts.Diagnostics.Cannot_read_file_0_Colon_1, fileName, hostErrorMessage));
	                }
	                else {
	                    fileProcessingDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.Cannot_read_file_0_Colon_1, fileName, hostErrorMessage));
	                }
	            }, shouldCreateNewSourceFile);
	            if (packageId) {
	                var packageIdKey = ts.packageIdToString(packageId);
	                var fileFromPackageId = packageIdToSourceFile.get(packageIdKey);
	                if (fileFromPackageId) {
	                    // Some other SourceFile already exists with this package name and version.
	                    // Instead of creating a duplicate, just redirect to the existing one.
	                    var dupFile = createRedirectSourceFile(fileFromPackageId, file, fileName, path);
	                    redirectTargetsSet.set(fileFromPackageId.path, true);
	                    filesByName.set(path, dupFile);
	                    sourceFileToPackageName.set(path, packageId.name);
	                    files.push(dupFile);
	                    return dupFile;
	                }
	                else if (file) {
	                    // This is the first source file to have this packageId.
	                    packageIdToSourceFile.set(packageIdKey, file);
	                    sourceFileToPackageName.set(path, packageId.name);
	                }
	            }
	            filesByName.set(path, file);
	            if (file) {
	                sourceFilesFoundSearchingNodeModules.set(path, currentNodeModulesDepth > 0);
	                file.path = path;
	                if (host.useCaseSensitiveFileNames()) {
	                    var pathLowerCase = path.toLowerCase();
	                    // for case-sensitive file systems check if we've already seen some file with similar filename ignoring case
	                    var existingFile = filesByNameIgnoreCase.get(pathLowerCase);
	                    if (existingFile) {
	                        reportFileNamesDifferOnlyInCasingError(fileName, existingFile.fileName, refFile, refPos, refEnd);
	                    }
	                    else {
	                        filesByNameIgnoreCase.set(pathLowerCase, file);
	                    }
	                }
	                skipDefaultLib = skipDefaultLib || file.hasNoDefaultLib;
	                if (!options.noResolve) {
	                    processReferencedFiles(file, isDefaultLib);
	                    processTypeReferenceDirectives(file);
	                }
	                // always process imported modules to record module name resolutions
	                processImportedModules(file);
	                if (isDefaultLib) {
	                    files.unshift(file);
	                }
	                else {
	                    files.push(file);
	                }
	            }
	            return file;
	        }
	        function processReferencedFiles(file, isDefaultLib) {
	            ts.forEach(file.referencedFiles, function (ref) {
	                var referencedFileName = resolveTripleslashReference(ref.fileName, file.fileName);
	                processSourceFile(referencedFileName, isDefaultLib, /*packageId*/ undefined, file, ref.pos, ref.end);
	            });
	        }
	        function processTypeReferenceDirectives(file) {
	            // We lower-case all type references because npm automatically lowercases all packages. See GH#9824.
	            var typeDirectives = ts.map(file.typeReferenceDirectives, function (ref) { return ref.fileName.toLocaleLowerCase(); });
	            var resolutions = resolveTypeReferenceDirectiveNamesWorker(typeDirectives, file.fileName);
	            for (var i = 0; i < typeDirectives.length; i++) {
	                var ref = file.typeReferenceDirectives[i];
	                var resolvedTypeReferenceDirective = resolutions[i];
	                // store resolved type directive on the file
	                var fileName = ref.fileName.toLocaleLowerCase();
	                ts.setResolvedTypeReferenceDirective(file, fileName, resolvedTypeReferenceDirective);
	                processTypeReferenceDirective(fileName, resolvedTypeReferenceDirective, file, ref.pos, ref.end);
	            }
	        }
	        function processTypeReferenceDirective(typeReferenceDirective, resolvedTypeReferenceDirective, refFile, refPos, refEnd) {
	            // If we already found this library as a primary reference - nothing to do
	            var previousResolution = resolvedTypeReferenceDirectives.get(typeReferenceDirective);
	            if (previousResolution && previousResolution.primary) {
	                return;
	            }
	            var saveResolution = true;
	            if (resolvedTypeReferenceDirective) {
	                if (resolvedTypeReferenceDirective.primary) {
	                    // resolved from the primary path
	                    processSourceFile(resolvedTypeReferenceDirective.resolvedFileName, /*isDefaultLib*/ false, resolvedTypeReferenceDirective.packageId, refFile, refPos, refEnd);
	                }
	                else {
	                    // If we already resolved to this file, it must have been a secondary reference. Check file contents
	                    // for sameness and possibly issue an error
	                    if (previousResolution) {
	                        // Don't bother reading the file again if it's the same file.
	                        if (resolvedTypeReferenceDirective.resolvedFileName !== previousResolution.resolvedFileName) {
	                            var otherFileText = host.readFile(resolvedTypeReferenceDirective.resolvedFileName);
	                            if (otherFileText !== getSourceFile(previousResolution.resolvedFileName).text) {
	                                fileProcessingDiagnostics.add(createDiagnostic(refFile, refPos, refEnd, ts.Diagnostics.Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_library_to_resolve_the_conflict, typeReferenceDirective, resolvedTypeReferenceDirective.resolvedFileName, previousResolution.resolvedFileName));
	                            }
	                        }
	                        // don't overwrite previous resolution result
	                        saveResolution = false;
	                    }
	                    else {
	                        // First resolution of this library
	                        processSourceFile(resolvedTypeReferenceDirective.resolvedFileName, /*isDefaultLib*/ false, resolvedTypeReferenceDirective.packageId, refFile, refPos, refEnd);
	                    }
	                }
	            }
	            else {
	                fileProcessingDiagnostics.add(createDiagnostic(refFile, refPos, refEnd, ts.Diagnostics.Cannot_find_type_definition_file_for_0, typeReferenceDirective));
	            }
	            if (saveResolution) {
	                resolvedTypeReferenceDirectives.set(typeReferenceDirective, resolvedTypeReferenceDirective);
	            }
	        }
	        function createDiagnostic(refFile, refPos, refEnd, message) {
	            var args = [];
	            for (var _i = 4; _i < arguments.length; _i++) {
	                args[_i - 4] = arguments[_i];
	            }
	            if (refFile === undefined || refPos === undefined || refEnd === undefined) {
	                return ts.createCompilerDiagnostic.apply(void 0, [message].concat(args));
	            }
	            else {
	                return ts.createFileDiagnostic.apply(void 0, [refFile, refPos, refEnd - refPos, message].concat(args));
	            }
	        }
	        function getCanonicalFileName(fileName) {
	            return host.getCanonicalFileName(fileName);
	        }
	        function processImportedModules(file) {
	            collectExternalModuleReferences(file);
	            if (file.imports.length || file.moduleAugmentations.length) {
	                // Because global augmentation doesn't have string literal name, we can check for global augmentation as such.
	                var moduleNames = getModuleNames(file);
	                var oldProgramState = { program: oldProgram, oldSourceFile: oldProgram && oldProgram.getSourceFile(file.fileName), modifiedFilePaths: modifiedFilePaths };
	                var resolutions = resolveModuleNamesReusingOldState(moduleNames, ts.getNormalizedAbsolutePath(file.fileName, currentDirectory), file, oldProgramState);
	                ts.Debug.assert(resolutions.length === moduleNames.length);
	                for (var i = 0; i < moduleNames.length; i++) {
	                    var resolution = resolutions[i];
	                    ts.setResolvedModule(file, moduleNames[i], resolution);
	                    if (!resolution) {
	                        continue;
	                    }
	                    var isFromNodeModulesSearch = resolution.isExternalLibraryImport;
	                    var isJsFile = !ts.extensionIsTypeScript(resolution.extension);
	                    var isJsFileFromNodeModules = isFromNodeModulesSearch && isJsFile;
	                    var resolvedFileName = resolution.resolvedFileName;
	                    if (isFromNodeModulesSearch) {
	                        currentNodeModulesDepth++;
	                    }
	                    // add file to program only if:
	                    // - resolution was successful
	                    // - noResolve is falsy
	                    // - module name comes from the list of imports
	                    // - it's not a top level JavaScript module that exceeded the search max
	                    var elideImport = isJsFileFromNodeModules && currentNodeModulesDepth > maxNodeModuleJsDepth;
	                    // Don't add the file if it has a bad extension (e.g. 'tsx' if we don't have '--allowJs')
	                    // This may still end up being an untyped module -- the file won't be included but imports will be allowed.
	                    var shouldAddFile = resolvedFileName
	                        && !getResolutionDiagnostic(options, resolution)
	                        && !options.noResolve
	                        && i < file.imports.length
	                        && !elideImport
	                        && !(isJsFile && !options.allowJs);
	                    if (elideImport) {
	                        modulesWithElidedImports.set(file.path, true);
	                    }
	                    else if (shouldAddFile) {
	                        var path = toPath(resolvedFileName);
	                        var pos = ts.skipTrivia(file.text, file.imports[i].pos);
	                        findSourceFile(resolvedFileName, path, /*isDefaultLib*/ false, file, pos, file.imports[i].end, resolution.packageId);
	                    }
	                    if (isFromNodeModulesSearch) {
	                        currentNodeModulesDepth--;
	                    }
	                }
	            }
	            else {
	                // no imports - drop cached module resolutions
	                file.resolvedModules = undefined;
	            }
	        }
	        function computeCommonSourceDirectory(sourceFiles) {
	            var fileNames = [];
	            for (var _i = 0, sourceFiles_2 = sourceFiles; _i < sourceFiles_2.length; _i++) {
	                var file = sourceFiles_2[_i];
	                if (!file.isDeclarationFile) {
	                    fileNames.push(file.fileName);
	                }
	            }
	            return computeCommonSourceDirectoryOfFilenames(fileNames, currentDirectory, getCanonicalFileName);
	        }
	        function checkSourceFilesBelongToPath(sourceFiles, rootDirectory) {
	            var allFilesBelongToPath = true;
	            if (sourceFiles) {
	                var absoluteRootDirectoryPath = host.getCanonicalFileName(ts.getNormalizedAbsolutePath(rootDirectory, currentDirectory));
	                for (var _i = 0, sourceFiles_3 = sourceFiles; _i < sourceFiles_3.length; _i++) {
	                    var sourceFile = sourceFiles_3[_i];
	                    if (!sourceFile.isDeclarationFile) {
	                        var absoluteSourceFilePath = host.getCanonicalFileName(ts.getNormalizedAbsolutePath(sourceFile.fileName, currentDirectory));
	                        if (absoluteSourceFilePath.indexOf(absoluteRootDirectoryPath) !== 0) {
	                            programDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files, sourceFile.fileName, options.rootDir));
	                            allFilesBelongToPath = false;
	                        }
	                    }
	                }
	            }
	            return allFilesBelongToPath;
	        }
	        function verifyCompilerOptions() {
	            if (options.isolatedModules) {
	                if (options.declaration) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "declaration", "isolatedModules");
	                }
	                if (options.noEmitOnError) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "noEmitOnError", "isolatedModules");
	                }
	                if (options.out) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "out", "isolatedModules");
	                }
	                if (options.outFile) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "outFile", "isolatedModules");
	                }
	            }
	            if (options.inlineSourceMap) {
	                if (options.sourceMap) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "sourceMap", "inlineSourceMap");
	                }
	                if (options.mapRoot) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "mapRoot", "inlineSourceMap");
	                }
	            }
	            if (options.paths && options.baseUrl === undefined) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_paths_cannot_be_used_without_specifying_baseUrl_option, "paths");
	            }
	            if (options.paths) {
	                for (var key in options.paths) {
	                    if (!ts.hasProperty(options.paths, key)) {
	                        continue;
	                    }
	                    if (!ts.hasZeroOrOneAsteriskCharacter(key)) {
	                        createDiagnosticForOptionPaths(/*onKey*/ true, key, ts.Diagnostics.Pattern_0_can_have_at_most_one_Asterisk_character, key);
	                    }
	                    if (ts.isArray(options.paths[key])) {
	                        var len = options.paths[key].length;
	                        if (len === 0) {
	                            createDiagnosticForOptionPaths(/*onKey*/ false, key, ts.Diagnostics.Substitutions_for_pattern_0_shouldn_t_be_an_empty_array, key);
	                        }
	                        for (var i = 0; i < len; i++) {
	                            var subst = options.paths[key][i];
	                            var typeOfSubst = typeof subst;
	                            if (typeOfSubst === "string") {
	                                if (!ts.hasZeroOrOneAsteriskCharacter(subst)) {
	                                    createDiagnosticForOptionPathKeyValue(key, i, ts.Diagnostics.Substitution_0_in_pattern_1_in_can_have_at_most_one_Asterisk_character, subst, key);
	                                }
	                            }
	                            else {
	                                createDiagnosticForOptionPathKeyValue(key, i, ts.Diagnostics.Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2, subst, key, typeOfSubst);
	                            }
	                        }
	                    }
	                    else {
	                        createDiagnosticForOptionPaths(/*onKey*/ false, key, ts.Diagnostics.Substitutions_for_pattern_0_should_be_an_array, key);
	                    }
	                }
	            }
	            if (!options.sourceMap && !options.inlineSourceMap) {
	                if (options.inlineSources) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided, "inlineSources");
	                }
	                if (options.sourceRoot) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided, "sourceRoot");
	                }
	            }
	            if (options.out && options.outFile) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "out", "outFile");
	            }
	            if (options.mapRoot && !options.sourceMap) {
	                // Error to specify --mapRoot without --sourcemap
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "mapRoot", "sourceMap");
	            }
	            if (options.declarationDir) {
	                if (!options.declaration) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "declarationDir", "declaration");
	                }
	                if (options.out || options.outFile) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "declarationDir", options.out ? "out" : "outFile");
	                }
	            }
	            if (options.lib && options.noLib) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "lib", "noLib");
	            }
	            if (options.noImplicitUseStrict && ts.getStrictOptionValue(options, "alwaysStrict")) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "noImplicitUseStrict", "alwaysStrict");
	            }
	            var languageVersion = options.target || 0 /* ES3 */;
	            var outFile = options.outFile || options.out;
	            var firstNonAmbientExternalModuleSourceFile = ts.forEach(files, function (f) { return ts.isExternalModule(f) && !f.isDeclarationFile ? f : undefined; });
	            if (options.isolatedModules) {
	                if (options.module === ts.ModuleKind.None && languageVersion < 2 /* ES2015 */) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES2015_or_higher, "isolatedModules", "target");
	                }
	                var firstNonExternalModuleSourceFile = ts.forEach(files, function (f) { return !ts.isExternalModule(f) && !f.isDeclarationFile ? f : undefined; });
	                if (firstNonExternalModuleSourceFile) {
	                    var span_7 = ts.getErrorSpanForNode(firstNonExternalModuleSourceFile, firstNonExternalModuleSourceFile);
	                    programDiagnostics.add(ts.createFileDiagnostic(firstNonExternalModuleSourceFile, span_7.start, span_7.length, ts.Diagnostics.Cannot_compile_namespaces_when_the_isolatedModules_flag_is_provided));
	                }
	            }
	            else if (firstNonAmbientExternalModuleSourceFile && languageVersion < 2 /* ES2015 */ && options.module === ts.ModuleKind.None) {
	                // We cannot use createDiagnosticFromNode because nodes do not have parents yet
	                var span_8 = ts.getErrorSpanForNode(firstNonAmbientExternalModuleSourceFile, firstNonAmbientExternalModuleSourceFile.externalModuleIndicator);
	                programDiagnostics.add(ts.createFileDiagnostic(firstNonAmbientExternalModuleSourceFile, span_8.start, span_8.length, ts.Diagnostics.Cannot_use_imports_exports_or_module_augmentations_when_module_is_none));
	            }
	            // Cannot specify module gen that isn't amd or system with --out
	            if (outFile) {
	                if (options.module && !(options.module === ts.ModuleKind.AMD || options.module === ts.ModuleKind.System)) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Only_amd_and_system_modules_are_supported_alongside_0, options.out ? "out" : "outFile", "module");
	                }
	                else if (options.module === undefined && firstNonAmbientExternalModuleSourceFile) {
	                    var span_9 = ts.getErrorSpanForNode(firstNonAmbientExternalModuleSourceFile, firstNonAmbientExternalModuleSourceFile.externalModuleIndicator);
	                    programDiagnostics.add(ts.createFileDiagnostic(firstNonAmbientExternalModuleSourceFile, span_9.start, span_9.length, ts.Diagnostics.Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system, options.out ? "out" : "outFile"));
	                }
	            }
	            // there has to be common source directory if user specified --outdir || --sourceRoot
	            // if user specified --mapRoot, there needs to be common source directory if there would be multiple files being emitted
	            if (options.outDir || // there is --outDir specified
	                options.sourceRoot || // there is --sourceRoot specified
	                options.mapRoot) {
	                // Precalculate and cache the common source directory
	                var dir = getCommonSourceDirectory();
	                // If we failed to find a good common directory, but outDir is specified and at least one of our files is on a windows drive/URL/other resource, add a failure
	                if (options.outDir && dir === "" && ts.forEach(files, function (file) { return ts.getRootLength(file.fileName) > 1; })) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Cannot_find_the_common_subdirectory_path_for_the_input_files, "outDir");
	                }
	            }
	            if (!options.noEmit && options.allowJs && options.declaration) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "allowJs", "declaration");
	            }
	            if (options.checkJs && !options.allowJs) {
	                programDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "checkJs", "allowJs"));
	            }
	            if (options.emitDeclarationOnly) {
	                if (!options.declaration) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "emitDeclarationOnly", "declarations");
	                }
	                if (options.noEmit) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "emitDeclarationOnly", "noEmit");
	                }
	            }
	            if (options.emitDecoratorMetadata &&
	                !options.experimentalDecorators) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "emitDecoratorMetadata", "experimentalDecorators");
	            }
	            if (options.jsxFactory) {
	                if (options.reactNamespace) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "reactNamespace", "jsxFactory");
	                }
	                if (!ts.parseIsolatedEntityName(options.jsxFactory, languageVersion)) {
	                    createOptionValueDiagnostic("jsxFactory", ts.Diagnostics.Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name, options.jsxFactory);
	                }
	            }
	            else if (options.reactNamespace && !ts.isIdentifierText(options.reactNamespace, languageVersion)) {
	                createOptionValueDiagnostic("reactNamespace", ts.Diagnostics.Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier, options.reactNamespace);
	            }
	            // If the emit is enabled make sure that every output file is unique and not overwriting any of the input files
	            if (!options.noEmit && !options.suppressOutputPathCheck) {
	                var emitHost = getEmitHost();
	                var emitFilesSeen_1 = ts.createMap();
	                ts.forEachEmittedFile(emitHost, function (emitFileNames) {
	                    if (!options.emitDeclarationOnly) {
	                        verifyEmitFilePath(emitFileNames.jsFilePath, emitFilesSeen_1);
	                    }
	                    verifyEmitFilePath(emitFileNames.declarationFilePath, emitFilesSeen_1);
	                });
	            }
	            // Verify that all the emit files are unique and don't overwrite input files
	            function verifyEmitFilePath(emitFileName, emitFilesSeen) {
	                if (emitFileName) {
	                    var emitFilePath = toPath(emitFileName);
	                    // Report error if the output overwrites input file
	                    if (filesByName.has(emitFilePath)) {
	                        var chain_2;
	                        if (!options.configFilePath) {
	                            // The program is from either an inferred project or an external project
	                            chain_2 = ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript_files_Learn_more_at_https_Colon_Slash_Slashaka_ms_Slashtsconfig);
	                        }
	                        chain_2 = ts.chainDiagnosticMessages(chain_2, ts.Diagnostics.Cannot_write_file_0_because_it_would_overwrite_input_file, emitFileName);
	                        blockEmittingOfFile(emitFileName, ts.createCompilerDiagnosticFromMessageChain(chain_2));
	                    }
	                    var emitFileKey = !host.useCaseSensitiveFileNames() ? emitFilePath.toLocaleLowerCase() : emitFilePath;
	                    // Report error if multiple files write into same file
	                    if (emitFilesSeen.has(emitFileKey)) {
	                        // Already seen the same emit file - report error
	                        blockEmittingOfFile(emitFileName, ts.createCompilerDiagnostic(ts.Diagnostics.Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files, emitFileName));
	                    }
	                    else {
	                        emitFilesSeen.set(emitFileKey, true);
	                    }
	                }
	            }
	        }
	        function createDiagnosticForOptionPathKeyValue(key, valueIndex, message, arg0, arg1, arg2) {
	            var needCompilerDiagnostic = true;
	            var pathsSyntax = getOptionPathsSyntax();
	            for (var _i = 0, pathsSyntax_1 = pathsSyntax; _i < pathsSyntax_1.length; _i++) {
	                var pathProp = pathsSyntax_1[_i];
	                if (ts.isObjectLiteralExpression(pathProp.initializer)) {
	                    for (var _a = 0, _b = ts.getPropertyAssignment(pathProp.initializer, key); _a < _b.length; _a++) {
	                        var keyProps = _b[_a];
	                        if (ts.isArrayLiteralExpression(keyProps.initializer) &&
	                            keyProps.initializer.elements.length > valueIndex) {
	                            programDiagnostics.add(ts.createDiagnosticForNodeInSourceFile(options.configFile, keyProps.initializer.elements[valueIndex], message, arg0, arg1, arg2));
	                            needCompilerDiagnostic = false;
	                        }
	                    }
	                }
	            }
	            if (needCompilerDiagnostic) {
	                programDiagnostics.add(ts.createCompilerDiagnostic(message, arg0, arg1, arg2));
	            }
	        }
	        function createDiagnosticForOptionPaths(onKey, key, message, arg0) {
	            var needCompilerDiagnostic = true;
	            var pathsSyntax = getOptionPathsSyntax();
	            for (var _i = 0, pathsSyntax_2 = pathsSyntax; _i < pathsSyntax_2.length; _i++) {
	                var pathProp = pathsSyntax_2[_i];
	                if (ts.isObjectLiteralExpression(pathProp.initializer) &&
	                    createOptionDiagnosticInObjectLiteralSyntax(pathProp.initializer, onKey, key, /*key2*/ undefined, message, arg0)) {
	                    needCompilerDiagnostic = false;
	                }
	            }
	            if (needCompilerDiagnostic) {
	                programDiagnostics.add(ts.createCompilerDiagnostic(message, arg0));
	            }
	        }
	        function getOptionPathsSyntax() {
	            var compilerOptionsObjectLiteralSyntax = getCompilerOptionsObjectLiteralSyntax();
	            if (compilerOptionsObjectLiteralSyntax) {
	                return ts.getPropertyAssignment(compilerOptionsObjectLiteralSyntax, "paths");
	            }
	            return ts.emptyArray;
	        }
	        function createDiagnosticForOptionName(message, option1, option2) {
	            createDiagnosticForOption(/*onKey*/ true, option1, option2, message, option1, option2);
	        }
	        function createOptionValueDiagnostic(option1, message, arg0) {
	            createDiagnosticForOption(/*onKey*/ false, option1, /*option2*/ undefined, message, arg0);
	        }
	        function createDiagnosticForOption(onKey, option1, option2, message, arg0, arg1) {
	            var compilerOptionsObjectLiteralSyntax = getCompilerOptionsObjectLiteralSyntax();
	            var needCompilerDiagnostic = !compilerOptionsObjectLiteralSyntax ||
	                !createOptionDiagnosticInObjectLiteralSyntax(compilerOptionsObjectLiteralSyntax, onKey, option1, option2, message, arg0, arg1);
	            if (needCompilerDiagnostic) {
	                programDiagnostics.add(ts.createCompilerDiagnostic(message, arg0, arg1));
	            }
	        }
	        function getCompilerOptionsObjectLiteralSyntax() {
	            if (_compilerOptionsObjectLiteralSyntax === undefined) {
	                _compilerOptionsObjectLiteralSyntax = null; // tslint:disable-line:no-null-keyword
	                if (options.configFile && options.configFile.jsonObject) {
	                    for (var _i = 0, _a = ts.getPropertyAssignment(options.configFile.jsonObject, "compilerOptions"); _i < _a.length; _i++) {
	                        var prop = _a[_i];
	                        if (ts.isObjectLiteralExpression(prop.initializer)) {
	                            _compilerOptionsObjectLiteralSyntax = prop.initializer;
	                            break;
	                        }
	                    }
	                }
	            }
	            return _compilerOptionsObjectLiteralSyntax;
	        }
	        function createOptionDiagnosticInObjectLiteralSyntax(objectLiteral, onKey, key1, key2, message, arg0, arg1) {
	            var props = ts.getPropertyAssignment(objectLiteral, key1, key2);
	            for (var _i = 0, props_2 = props; _i < props_2.length; _i++) {
	                var prop = props_2[_i];
	                programDiagnostics.add(ts.createDiagnosticForNodeInSourceFile(options.configFile, onKey ? prop.name : prop.initializer, message, arg0, arg1));
	            }
	            return !!props.length;
	        }
	        function blockEmittingOfFile(emitFileName, diag) {
	            hasEmitBlockingDiagnostics.set(toPath(emitFileName), true);
	            programDiagnostics.add(diag);
	        }
	        function isEmittedFile(file) {
	            if (options.noEmit) {
	                return false;
	            }
	            // If this is source file, its not emitted file
	            var filePath = toPath(file);
	            if (getSourceFileByPath(filePath)) {
	                return false;
	            }
	            // If options have --outFile or --out just check that
	            var out = options.outFile || options.out;
	            if (out) {
	                return isSameFile(filePath, out) || isSameFile(filePath, ts.removeFileExtension(out) + ".d.ts" /* Dts */);
	            }
	            // If --outDir, check if file is in that directory
	            if (options.outDir) {
	                return ts.containsPath(options.outDir, filePath, currentDirectory, !host.useCaseSensitiveFileNames());
	            }
	            if (ts.fileExtensionIsOneOf(filePath, ts.supportedJavascriptExtensions) || ts.fileExtensionIs(filePath, ".d.ts" /* Dts */)) {
	                // Otherwise just check if sourceFile with the name exists
	                var filePathWithoutExtension = ts.removeFileExtension(filePath);
	                return !!getSourceFileByPath(ts.combinePaths(filePathWithoutExtension, ".ts" /* Ts */)) ||
	                    !!getSourceFileByPath(ts.combinePaths(filePathWithoutExtension, ".tsx" /* Tsx */));
	            }
	            return false;
	        }
	        function isSameFile(file1, file2) {
	            return ts.comparePaths(file1, file2, currentDirectory, !host.useCaseSensitiveFileNames()) === 0 /* EqualTo */;
	        }
	    }
	    ts.createProgram = createProgram;
	    /* @internal */
	    /**
	     * Returns a DiagnosticMessage if we won't include a resolved module due to its extension.
	     * The DiagnosticMessage's parameters are the imported module name, and the filename it resolved to.
	     * This returns a diagnostic even if the module will be an untyped module.
	     */
	    function getResolutionDiagnostic(options, _a) {
	        var extension = _a.extension;
	        switch (extension) {
	            case ".ts" /* Ts */:
	            case ".d.ts" /* Dts */:
	                // These are always allowed.
	                return undefined;
	            case ".tsx" /* Tsx */:
	                return needJsx();
	            case ".jsx" /* Jsx */:
	                return needJsx() || needAllowJs();
	            case ".js" /* Js */:
	                return needAllowJs();
	        }
	        function needJsx() {
	            return options.jsx ? undefined : ts.Diagnostics.Module_0_was_resolved_to_1_but_jsx_is_not_set;
	        }
	        function needAllowJs() {
	            return options.allowJs || !ts.getStrictOptionValue(options, "noImplicitAny") ? undefined : ts.Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type;
	        }
	    }
	    ts.getResolutionDiagnostic = getResolutionDiagnostic;
	    function checkAllDefined(names) {
	        ts.Debug.assert(names.every(function (name) { return name !== undefined; }), "A name is undefined.", function () { return JSON.stringify(names); });
	        return names;
	    }
	    function getModuleNames(_a) {
	        var imports = _a.imports, moduleAugmentations = _a.moduleAugmentations;
	        var res = imports.map(function (i) { return i.text; });
	        for (var _i = 0, moduleAugmentations_1 = moduleAugmentations; _i < moduleAugmentations_1.length; _i++) {
	            var aug = moduleAugmentations_1[_i];
	            if (aug.kind === 9 /* StringLiteral */) {
	                res.push(aug.text);
	            }
	            // Do nothing if it's an Identifier; we don't need to do module resolution for `declare global`.
	        }
	        return res;
	    }
	})(ts || (ts = {}));
	/// <reference path="program.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    function getFileEmitOutput(program, sourceFile, emitOnlyDtsFiles, cancellationToken, customTransformers) {
	        var outputFiles = [];
	        var emitResult = program.emit(sourceFile, writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers);
	        return { outputFiles: outputFiles, emitSkipped: emitResult.emitSkipped };
	        function writeFile(fileName, text, writeByteOrderMark) {
	            outputFiles.push({ name: fileName, writeByteOrderMark: writeByteOrderMark, text: text });
	        }
	    }
	    ts.getFileEmitOutput = getFileEmitOutput;
	})(ts || (ts = {}));
	/*@internal*/
	(function (ts) {
	    var BuilderState;
	    (function (BuilderState) {
	        /**
	         * Gets the referenced files for a file from the program with values for the keys as referenced file's path to be true
	         */
	        function getReferencedFiles(program, sourceFile, getCanonicalFileName) {
	            var referencedFiles;
	            // We need to use a set here since the code can contain the same import twice,
	            // but that will only be one dependency.
	            // To avoid invernal conversion, the key of the referencedFiles map must be of type Path
	            if (sourceFile.imports && sourceFile.imports.length > 0) {
	                var checker = program.getTypeChecker();
	                for (var _i = 0, _a = sourceFile.imports; _i < _a.length; _i++) {
	                    var importName = _a[_i];
	                    var symbol = checker.getSymbolAtLocation(importName);
	                    if (symbol && symbol.declarations && symbol.declarations[0]) {
	                        var declarationSourceFile = ts.getSourceFileOfNode(symbol.declarations[0]);
	                        if (declarationSourceFile) {
	                            addReferencedFile(declarationSourceFile.path);
	                        }
	                    }
	                }
	            }
	            var sourceFileDirectory = ts.getDirectoryPath(sourceFile.path);
	            // Handle triple slash references
	            if (sourceFile.referencedFiles && sourceFile.referencedFiles.length > 0) {
	                for (var _b = 0, _c = sourceFile.referencedFiles; _b < _c.length; _b++) {
	                    var referencedFile = _c[_b];
	                    var referencedPath = ts.toPath(referencedFile.fileName, sourceFileDirectory, getCanonicalFileName);
	                    addReferencedFile(referencedPath);
	                }
	            }
	            // Handle type reference directives
	            if (sourceFile.resolvedTypeReferenceDirectiveNames) {
	                sourceFile.resolvedTypeReferenceDirectiveNames.forEach(function (resolvedTypeReferenceDirective) {
	                    if (!resolvedTypeReferenceDirective) {
	                        return;
	                    }
	                    var fileName = resolvedTypeReferenceDirective.resolvedFileName;
	                    var typeFilePath = ts.toPath(fileName, sourceFileDirectory, getCanonicalFileName);
	                    addReferencedFile(typeFilePath);
	                });
	            }
	            return referencedFiles;
	            function addReferencedFile(referencedPath) {
	                if (!referencedFiles) {
	                    referencedFiles = ts.createMap();
	                }
	                referencedFiles.set(referencedPath, true);
	            }
	        }
	        /**
	         * Returns true if oldState is reusable, that is the emitKind = module/non module has not changed
	         */
	        function canReuseOldState(newReferencedMap, oldState) {
	            return oldState && !oldState.referencedMap === !newReferencedMap;
	        }
	        BuilderState.canReuseOldState = canReuseOldState;
	        /**
	         * Creates the state of file references and signature for the new program from oldState if it is safe
	         */
	        function create(newProgram, getCanonicalFileName, oldState) {
	            var fileInfos = ts.createMap();
	            var referencedMap = newProgram.getCompilerOptions().module !== ts.ModuleKind.None ? ts.createMap() : undefined;
	            var hasCalledUpdateShapeSignature = ts.createMap();
	            var useOldState = canReuseOldState(referencedMap, oldState);
	            // Create the reference map, and set the file infos
	            for (var _i = 0, _a = newProgram.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile = _a[_i];
	                var version_1 = sourceFile.version;
	                var oldInfo = useOldState && oldState.fileInfos.get(sourceFile.path);
	                if (referencedMap) {
	                    var newReferences = getReferencedFiles(newProgram, sourceFile, getCanonicalFileName);
	                    if (newReferences) {
	                        referencedMap.set(sourceFile.path, newReferences);
	                    }
	                }
	                fileInfos.set(sourceFile.path, { version: version_1, signature: oldInfo && oldInfo.signature });
	            }
	            return {
	                fileInfos: fileInfos,
	                referencedMap: referencedMap,
	                hasCalledUpdateShapeSignature: hasCalledUpdateShapeSignature,
	                allFilesExcludingDefaultLibraryFile: undefined,
	                allFileNames: undefined
	            };
	        }
	        BuilderState.create = create;
	        /**
	         * Gets the files affected by the path from the program
	         */
	        function getFilesAffectedBy(state, programOfThisState, path, cancellationToken, computeHash, cacheToUpdateSignature) {
	            // Since the operation could be cancelled, the signatures are always stored in the cache
	            // They will be commited once it is safe to use them
	            // eg when calling this api from tsserver, if there is no cancellation of the operation
	            // In the other cases the affected files signatures are commited only after the iteration through the result is complete
	            var signatureCache = cacheToUpdateSignature || ts.createMap();
	            var sourceFile = programOfThisState.getSourceFileByPath(path);
	            if (!sourceFile) {
	                return ts.emptyArray;
	            }
	            if (!updateShapeSignature(state, programOfThisState, sourceFile, signatureCache, cancellationToken, computeHash)) {
	                return [sourceFile];
	            }
	            var result = (state.referencedMap ? getFilesAffectedByUpdatedShapeWhenModuleEmit : getFilesAffectedByUpdatedShapeWhenNonModuleEmit)(state, programOfThisState, sourceFile, signatureCache, cancellationToken, computeHash);
	            if (!cacheToUpdateSignature) {
	                // Commit all the signatures in the signature cache
	                updateSignaturesFromCache(state, signatureCache);
	            }
	            return result;
	        }
	        BuilderState.getFilesAffectedBy = getFilesAffectedBy;
	        /**
	         * Updates the signatures from the cache into state's fileinfo signatures
	         * This should be called whenever it is safe to commit the state of the builder
	         */
	        function updateSignaturesFromCache(state, signatureCache) {
	            signatureCache.forEach(function (signature, path) {
	                state.fileInfos.get(path).signature = signature;
	                state.hasCalledUpdateShapeSignature.set(path, true);
	            });
	        }
	        BuilderState.updateSignaturesFromCache = updateSignaturesFromCache;
	        /**
	         * Returns if the shape of the signature has changed since last emit
	         */
	        function updateShapeSignature(state, programOfThisState, sourceFile, cacheToUpdateSignature, cancellationToken, computeHash) {
	            ts.Debug.assert(!!sourceFile);
	            // If we have cached the result for this file, that means hence forth we should assume file shape is uptodate
	            if (state.hasCalledUpdateShapeSignature.has(sourceFile.path) || cacheToUpdateSignature.has(sourceFile.path)) {
	                return false;
	            }
	            var info = state.fileInfos.get(sourceFile.path);
	            ts.Debug.assert(!!info);
	            var prevSignature = info.signature;
	            var latestSignature;
	            if (sourceFile.isDeclarationFile) {
	                latestSignature = sourceFile.version;
	            }
	            else {
	                var emitOutput = ts.getFileEmitOutput(programOfThisState, sourceFile, /*emitOnlyDtsFiles*/ true, cancellationToken);
	                if (emitOutput.outputFiles && emitOutput.outputFiles.length > 0) {
	                    latestSignature = computeHash(emitOutput.outputFiles[0].text);
	                }
	                else {
	                    latestSignature = prevSignature;
	                }
	            }
	            cacheToUpdateSignature.set(sourceFile.path, latestSignature);
	            return !prevSignature || latestSignature !== prevSignature;
	        }
	        /**
	         * Get all the dependencies of the sourceFile
	         */
	        function getAllDependencies(state, programOfThisState, sourceFile) {
	            var compilerOptions = programOfThisState.getCompilerOptions();
	            // With --out or --outFile all outputs go into single file, all files depend on each other
	            if (compilerOptions.outFile || compilerOptions.out) {
	                return getAllFileNames(state, programOfThisState);
	            }
	            // If this is non module emit, or its a global file, it depends on all the source files
	            if (!state.referencedMap || (!ts.isExternalModule(sourceFile) && !containsOnlyAmbientModules(sourceFile))) {
	                return getAllFileNames(state, programOfThisState);
	            }
	            // Get the references, traversing deep from the referenceMap
	            var seenMap = ts.createMap();
	            var queue = [sourceFile.path];
	            while (queue.length) {
	                var path = queue.pop();
	                if (!seenMap.has(path)) {
	                    seenMap.set(path, true);
	                    var references = state.referencedMap.get(path);
	                    if (references) {
	                        var iterator = references.keys();
	                        for (var _a = iterator.next(), value = _a.value, done = _a.done; !done; _b = iterator.next(), value = _b.value, done = _b.done, _b) {
	                            queue.push(value);
	                        }
	                    }
	                }
	            }
	            return ts.arrayFrom(ts.mapDefinedIterator(seenMap.keys(), function (path) {
	                var file = programOfThisState.getSourceFileByPath(path);
	                return file ? file.fileName : path;
	            }));
	            var _b;
	        }
	        BuilderState.getAllDependencies = getAllDependencies;
	        /**
	         * Gets the names of all files from the program
	         */
	        function getAllFileNames(state, programOfThisState) {
	            if (!state.allFileNames) {
	                var sourceFiles = programOfThisState.getSourceFiles();
	                state.allFileNames = sourceFiles === ts.emptyArray ? ts.emptyArray : sourceFiles.map(function (file) { return file.fileName; });
	            }
	            return state.allFileNames;
	        }
	        /**
	         * Gets the files referenced by the the file path
	         */
	        function getReferencedByPaths(state, referencedFilePath) {
	            return ts.arrayFrom(ts.mapDefinedIterator(state.referencedMap.entries(), function (_a) {
	                var filePath = _a[0], referencesInFile = _a[1];
	                return referencesInFile.has(referencedFilePath) ? filePath : undefined;
	            }));
	        }
	        /**
	         * For script files that contains only ambient external modules, although they are not actually external module files,
	         * they can only be consumed via importing elements from them. Regular script files cannot consume them. Therefore,
	         * there are no point to rebuild all script files if these special files have changed. However, if any statement
	         * in the file is not ambient external module, we treat it as a regular script file.
	         */
	        function containsOnlyAmbientModules(sourceFile) {
	            for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	                var statement = _a[_i];
	                if (!ts.isModuleWithStringLiteralName(statement)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        /**
	         * Gets all files of the program excluding the default library file
	         */
	        function getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, firstSourceFile) {
	            // Use cached result
	            if (state.allFilesExcludingDefaultLibraryFile) {
	                return state.allFilesExcludingDefaultLibraryFile;
	            }
	            var result;
	            addSourceFile(firstSourceFile);
	            for (var _i = 0, _a = programOfThisState.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile = _a[_i];
	                if (sourceFile !== firstSourceFile) {
	                    addSourceFile(sourceFile);
	                }
	            }
	            state.allFilesExcludingDefaultLibraryFile = result || ts.emptyArray;
	            return state.allFilesExcludingDefaultLibraryFile;
	            function addSourceFile(sourceFile) {
	                if (!programOfThisState.isSourceFileDefaultLibrary(sourceFile)) {
	                    (result || (result = [])).push(sourceFile);
	                }
	            }
	        }
	        /**
	         * When program emits non modular code, gets the files affected by the sourceFile whose shape has changed
	         */
	        function getFilesAffectedByUpdatedShapeWhenNonModuleEmit(state, programOfThisState, sourceFileWithUpdatedShape) {
	            var compilerOptions = programOfThisState.getCompilerOptions();
	            // If `--out` or `--outFile` is specified, any new emit will result in re-emitting the entire project,
	            // so returning the file itself is good enough.
	            if (compilerOptions && (compilerOptions.out || compilerOptions.outFile)) {
	                return [sourceFileWithUpdatedShape];
	            }
	            return getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, sourceFileWithUpdatedShape);
	        }
	        /**
	         * When program emits modular code, gets the files affected by the sourceFile whose shape has changed
	         */
	        function getFilesAffectedByUpdatedShapeWhenModuleEmit(state, programOfThisState, sourceFileWithUpdatedShape, cacheToUpdateSignature, cancellationToken, computeHash) {
	            if (!ts.isExternalModule(sourceFileWithUpdatedShape) && !containsOnlyAmbientModules(sourceFileWithUpdatedShape)) {
	                return getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, sourceFileWithUpdatedShape);
	            }
	            var compilerOptions = programOfThisState.getCompilerOptions();
	            if (compilerOptions && (compilerOptions.isolatedModules || compilerOptions.out || compilerOptions.outFile)) {
	                return [sourceFileWithUpdatedShape];
	            }
	            // Now we need to if each file in the referencedBy list has a shape change as well.
	            // Because if so, its own referencedBy files need to be saved as well to make the
	            // emitting result consistent with files on disk.
	            var seenFileNamesMap = ts.createMap();
	            // Start with the paths this file was referenced by
	            seenFileNamesMap.set(sourceFileWithUpdatedShape.path, sourceFileWithUpdatedShape);
	            var queue = getReferencedByPaths(state, sourceFileWithUpdatedShape.path);
	            while (queue.length > 0) {
	                var currentPath = queue.pop();
	                if (!seenFileNamesMap.has(currentPath)) {
	                    var currentSourceFile = programOfThisState.getSourceFileByPath(currentPath);
	                    seenFileNamesMap.set(currentPath, currentSourceFile);
	                    if (currentSourceFile && updateShapeSignature(state, programOfThisState, currentSourceFile, cacheToUpdateSignature, cancellationToken, computeHash)) {
	                        queue.push.apply(queue, getReferencedByPaths(state, currentPath));
	                    }
	                }
	            }
	            // Return array of values that needs emit
	            // Return array of values that needs emit
	            return ts.arrayFrom(ts.mapDefinedIterator(seenFileNamesMap.values(), function (value) { return value; }));
	        }
	    })(BuilderState = ts.BuilderState || (ts.BuilderState = {}));
	})(ts || (ts = {}));
	/// <reference path="builderState.ts" />
	/*@internal*/
	var ts;
	(function (ts) {
	    function hasSameKeys(map1, map2) {
	        // Has same size and every key is present in both maps
	        return map1 === map2 || map1 && map2 && map1.size === map2.size && !ts.forEachKey(map1, function (key) { return !map2.has(key); });
	    }
	    /**
	     * Create the state so that we can iterate on changedFiles/affected files
	     */
	    function createBuilderProgramState(newProgram, getCanonicalFileName, oldState) {
	        var state = ts.BuilderState.create(newProgram, getCanonicalFileName, oldState);
	        state.program = newProgram;
	        var compilerOptions = newProgram.getCompilerOptions();
	        if (!compilerOptions.outFile && !compilerOptions.out) {
	            state.semanticDiagnosticsPerFile = ts.createMap();
	        }
	        state.changedFilesSet = ts.createMap();
	        var useOldState = ts.BuilderState.canReuseOldState(state.referencedMap, oldState);
	        var canCopySemanticDiagnostics = useOldState && oldState.semanticDiagnosticsPerFile && !!state.semanticDiagnosticsPerFile;
	        if (useOldState) {
	            // Verify the sanity of old state
	            if (!oldState.currentChangedFilePath) {
	                ts.Debug.assert(!oldState.affectedFiles && (!oldState.currentAffectedFilesSignatures || !oldState.currentAffectedFilesSignatures.size), "Cannot reuse if only few affected files of currentChangedFile were iterated");
	            }
	            if (canCopySemanticDiagnostics) {
	                ts.Debug.assert(!ts.forEachKey(oldState.changedFilesSet, function (path) { return oldState.semanticDiagnosticsPerFile.has(path); }), "Semantic diagnostics shouldnt be available for changed files");
	            }
	            // Copy old state's changed files set
	            ts.copyEntries(oldState.changedFilesSet, state.changedFilesSet);
	        }
	        // Update changed files and copy semantic diagnostics if we can
	        var referencedMap = state.referencedMap;
	        var oldReferencedMap = useOldState && oldState.referencedMap;
	        state.fileInfos.forEach(function (info, sourceFilePath) {
	            var oldInfo;
	            var newReferences;
	            // if not using old state, every file is changed
	            if (!useOldState ||
	                // File wasnt present in old state
	                !(oldInfo = oldState.fileInfos.get(sourceFilePath)) ||
	                // versions dont match
	                oldInfo.version !== info.version ||
	                // Referenced files changed
	                !hasSameKeys(newReferences = referencedMap && referencedMap.get(sourceFilePath), oldReferencedMap && oldReferencedMap.get(sourceFilePath)) ||
	                // Referenced file was deleted in the new program
	                newReferences && ts.forEachKey(newReferences, function (path) { return !state.fileInfos.has(path) && oldState.fileInfos.has(path); })) {
	                // Register file as changed file and do not copy semantic diagnostics, since all changed files need to be re-evaluated
	                state.changedFilesSet.set(sourceFilePath, true);
	            }
	            else if (canCopySemanticDiagnostics) {
	                // Unchanged file copy diagnostics
	                var diagnostics = oldState.semanticDiagnosticsPerFile.get(sourceFilePath);
	                if (diagnostics) {
	                    state.semanticDiagnosticsPerFile.set(sourceFilePath, diagnostics);
	                }
	            }
	        });
	        return state;
	    }
	    /**
	     * Verifies that source file is ok to be used in calls that arent handled by next
	     */
	    function assertSourceFileOkWithoutNextAffectedCall(state, sourceFile) {
	        ts.Debug.assert(!sourceFile || !state.affectedFiles || state.affectedFiles[state.affectedFilesIndex - 1] !== sourceFile || !state.semanticDiagnosticsPerFile.has(sourceFile.path));
	    }
	    /**
	     * This function returns the next affected file to be processed.
	     * Note that until doneAffected is called it would keep reporting same result
	     * This is to allow the callers to be able to actually remove affected file only when the operation is complete
	     * eg. if during diagnostics check cancellation token ends up cancelling the request, the affected file should be retained
	     */
	    function getNextAffectedFile(state, cancellationToken, computeHash) {
	        while (true) {
	            var affectedFiles = state.affectedFiles;
	            if (affectedFiles) {
	                var seenAffectedFiles = state.seenAffectedFiles, semanticDiagnosticsPerFile = state.semanticDiagnosticsPerFile;
	                var affectedFilesIndex = state.affectedFilesIndex;
	                while (affectedFilesIndex < affectedFiles.length) {
	                    var affectedFile = affectedFiles[affectedFilesIndex];
	                    if (!seenAffectedFiles.has(affectedFile.path)) {
	                        // Set the next affected file as seen and remove the cached semantic diagnostics
	                        state.affectedFilesIndex = affectedFilesIndex;
	                        semanticDiagnosticsPerFile.delete(affectedFile.path);
	                        return affectedFile;
	                    }
	                    seenAffectedFiles.set(affectedFile.path, true);
	                    affectedFilesIndex++;
	                }
	                // Remove the changed file from the change set
	                state.changedFilesSet.delete(state.currentChangedFilePath);
	                state.currentChangedFilePath = undefined;
	                // Commit the changes in file signature
	                ts.BuilderState.updateSignaturesFromCache(state, state.currentAffectedFilesSignatures);
	                state.currentAffectedFilesSignatures.clear();
	                state.affectedFiles = undefined;
	            }
	            // Get next changed file
	            var nextKey = state.changedFilesSet.keys().next();
	            if (nextKey.done) {
	                // Done
	                return undefined;
	            }
	            // With --out or --outFile all outputs go into single file
	            // so operations are performed directly on program, return program
	            var compilerOptions = state.program.getCompilerOptions();
	            if (compilerOptions.outFile || compilerOptions.out) {
	                ts.Debug.assert(!state.semanticDiagnosticsPerFile);
	                return state.program;
	            }
	            // Get next batch of affected files
	            state.currentAffectedFilesSignatures = state.currentAffectedFilesSignatures || ts.createMap();
	            state.affectedFiles = ts.BuilderState.getFilesAffectedBy(state, state.program, nextKey.value, cancellationToken, computeHash, state.currentAffectedFilesSignatures);
	            state.currentChangedFilePath = nextKey.value;
	            state.semanticDiagnosticsPerFile.delete(nextKey.value);
	            state.affectedFilesIndex = 0;
	            state.seenAffectedFiles = state.seenAffectedFiles || ts.createMap();
	        }
	    }
	    /**
	     * This is called after completing operation on the next affected file.
	     * The operations here are postponed to ensure that cancellation during the iteration is handled correctly
	     */
	    function doneWithAffectedFile(state, affected) {
	        if (affected === state.program) {
	            state.changedFilesSet.clear();
	        }
	        else {
	            state.seenAffectedFiles.set(affected.path, true);
	            state.affectedFilesIndex++;
	        }
	    }
	    /**
	     * Returns the result with affected file
	     */
	    function toAffectedFileResult(state, result, affected) {
	        doneWithAffectedFile(state, affected);
	        return { result: result, affected: affected };
	    }
	    /**
	     * Gets the semantic diagnostics either from cache if present, or otherwise from program and caches it
	     * Note that it is assumed that the when asked about semantic diagnostics, the file has been taken out of affected files/changed file set
	     */
	    function getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken) {
	        var path = sourceFile.path;
	        var cachedDiagnostics = state.semanticDiagnosticsPerFile.get(path);
	        // Report the semantic diagnostics from the cache if we already have those diagnostics present
	        if (cachedDiagnostics) {
	            return cachedDiagnostics;
	        }
	        // Diagnostics werent cached, get them from program, and cache the result
	        var diagnostics = state.program.getSemanticDiagnostics(sourceFile, cancellationToken);
	        state.semanticDiagnosticsPerFile.set(path, diagnostics);
	        return diagnostics;
	    }
	    var BuilderProgramKind;
	    (function (BuilderProgramKind) {
	        BuilderProgramKind[BuilderProgramKind["SemanticDiagnosticsBuilderProgram"] = 0] = "SemanticDiagnosticsBuilderProgram";
	        BuilderProgramKind[BuilderProgramKind["EmitAndSemanticDiagnosticsBuilderProgram"] = 1] = "EmitAndSemanticDiagnosticsBuilderProgram";
	    })(BuilderProgramKind = ts.BuilderProgramKind || (ts.BuilderProgramKind = {}));
	    function getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram) {
	        var host;
	        var newProgram;
	        if (ts.isArray(newProgramOrRootNames)) {
	            newProgram = ts.createProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram && oldProgram.getProgram());
	            host = oldProgramOrHost;
	        }
	        else {
	            newProgram = newProgramOrRootNames;
	            host = hostOrOptions;
	            oldProgram = oldProgramOrHost;
	        }
	        return { host: host, newProgram: newProgram, oldProgram: oldProgram };
	    }
	    ts.getBuilderCreationParameters = getBuilderCreationParameters;
	    function createBuilderProgram(kind, _a) {
	        var newProgram = _a.newProgram, host = _a.host, oldProgram = _a.oldProgram;
	        // Return same program if underlying program doesnt change
	        var oldState = oldProgram && oldProgram.getState();
	        if (oldState && newProgram === oldState.program) {
	            newProgram = undefined;
	            oldState = undefined;
	            return oldProgram;
	        }
	        /**
	         * Create the canonical file name for identity
	         */
	        var getCanonicalFileName = ts.createGetCanonicalFileName(host.useCaseSensitiveFileNames());
	        /**
	         * Computing hash to for signature verification
	         */
	        var computeHash = host.createHash || ts.identity;
	        var state = createBuilderProgramState(newProgram, getCanonicalFileName, oldState);
	        // To ensure that we arent storing any references to old program or new program without state
	        newProgram = undefined;
	        oldProgram = undefined;
	        oldState = undefined;
	        var result = {
	            getState: function () { return state; },
	            getProgram: function () { return state.program; },
	            getCompilerOptions: function () { return state.program.getCompilerOptions(); },
	            getSourceFile: function (fileName) { return state.program.getSourceFile(fileName); },
	            getSourceFiles: function () { return state.program.getSourceFiles(); },
	            getOptionsDiagnostics: function (cancellationToken) { return state.program.getOptionsDiagnostics(cancellationToken); },
	            getGlobalDiagnostics: function (cancellationToken) { return state.program.getGlobalDiagnostics(cancellationToken); },
	            getSyntacticDiagnostics: function (sourceFile, cancellationToken) { return state.program.getSyntacticDiagnostics(sourceFile, cancellationToken); },
	            getSemanticDiagnostics: getSemanticDiagnostics,
	            emit: emit,
	            getAllDependencies: function (sourceFile) { return ts.BuilderState.getAllDependencies(state, state.program, sourceFile); },
	            getCurrentDirectory: function () { return state.program.getCurrentDirectory(); }
	        };
	        if (kind === BuilderProgramKind.SemanticDiagnosticsBuilderProgram) {
	            result.getSemanticDiagnosticsOfNextAffectedFile = getSemanticDiagnosticsOfNextAffectedFile;
	        }
	        else if (kind === BuilderProgramKind.EmitAndSemanticDiagnosticsBuilderProgram) {
	            result.emitNextAffectedFile = emitNextAffectedFile;
	        }
	        else {
	            ts.notImplemented();
	        }
	        return result;
	        /**
	         * Emits the next affected file's emit result (EmitResult and sourceFiles emitted) or returns undefined if iteration is complete
	         * The first of writeFile if provided, writeFile of BuilderProgramHost if provided, writeFile of compiler host
	         * in that order would be used to write the files
	         */
	        function emitNextAffectedFile(writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers) {
	            var affected = getNextAffectedFile(state, cancellationToken, computeHash);
	            if (!affected) {
	                // Done
	                return undefined;
	            }
	            return toAffectedFileResult(state, 
	            // When whole program is affected, do emit only once (eg when --out or --outFile is specified)
	            // Otherwise just affected file
	            state.program.emit(affected === state.program ? undefined : affected, writeFile || host.writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers), affected);
	        }
	        /**
	         * Emits the JavaScript and declaration files.
	         * When targetSource file is specified, emits the files corresponding to that source file,
	         * otherwise for the whole program.
	         * In case of EmitAndSemanticDiagnosticsBuilderProgram, when targetSourceFile is specified,
	         * it is assumed that that file is handled from affected file list. If targetSourceFile is not specified,
	         * it will only emit all the affected files instead of whole program
	         *
	         * The first of writeFile if provided, writeFile of BuilderProgramHost if provided, writeFile of compiler host
	         * in that order would be used to write the files
	         */
	        function emit(targetSourceFile, writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers) {
	            if (kind === BuilderProgramKind.EmitAndSemanticDiagnosticsBuilderProgram) {
	                assertSourceFileOkWithoutNextAffectedCall(state, targetSourceFile);
	                if (!targetSourceFile) {
	                    // Emit and report any errors we ran into.
	                    var sourceMaps = [];
	                    var emitSkipped = void 0;
	                    var diagnostics = void 0;
	                    var emittedFiles = [];
	                    var affectedEmitResult = void 0;
	                    while (affectedEmitResult = emitNextAffectedFile(writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers)) {
	                        emitSkipped = emitSkipped || affectedEmitResult.result.emitSkipped;
	                        diagnostics = ts.addRange(diagnostics, affectedEmitResult.result.diagnostics);
	                        emittedFiles = ts.addRange(emittedFiles, affectedEmitResult.result.emittedFiles);
	                        sourceMaps = ts.addRange(sourceMaps, affectedEmitResult.result.sourceMaps);
	                    }
	                    return {
	                        emitSkipped: emitSkipped,
	                        diagnostics: diagnostics || ts.emptyArray,
	                        emittedFiles: emittedFiles,
	                        sourceMaps: sourceMaps
	                    };
	                }
	            }
	            return state.program.emit(targetSourceFile, writeFile || host.writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers);
	        }
	        /**
	         * Return the semantic diagnostics for the next affected file or undefined if iteration is complete
	         * If provided ignoreSourceFile would be called before getting the diagnostics and would ignore the sourceFile if the returned value was true
	         */
	        function getSemanticDiagnosticsOfNextAffectedFile(cancellationToken, ignoreSourceFile) {
	            while (true) {
	                var affected = getNextAffectedFile(state, cancellationToken, computeHash);
	                if (!affected) {
	                    // Done
	                    return undefined;
	                }
	                else if (affected === state.program) {
	                    // When whole program is affected, get all semantic diagnostics (eg when --out or --outFile is specified)
	                    return toAffectedFileResult(state, state.program.getSemanticDiagnostics(/*targetSourceFile*/ undefined, cancellationToken), affected);
	                }
	                // Get diagnostics for the affected file if its not ignored
	                if (ignoreSourceFile && ignoreSourceFile(affected)) {
	                    // Get next affected file
	                    doneWithAffectedFile(state, affected);
	                    continue;
	                }
	                return toAffectedFileResult(state, getSemanticDiagnosticsOfFile(state, affected, cancellationToken), affected);
	            }
	        }
	        /**
	         * Gets the semantic diagnostics from the program corresponding to this state of file (if provided) or whole program
	         * The semantic diagnostics are cached and managed here
	         * Note that it is assumed that when asked about semantic diagnostics through this API,
	         * the file has been taken out of affected files so it is safe to use cache or get from program and cache the diagnostics
	         * In case of SemanticDiagnosticsBuilderProgram if the source file is not provided,
	         * it will iterate through all the affected files, to ensure that cache stays valid and yet provide a way to get all semantic diagnostics
	         */
	        function getSemanticDiagnostics(sourceFile, cancellationToken) {
	            assertSourceFileOkWithoutNextAffectedCall(state, sourceFile);
	            var compilerOptions = state.program.getCompilerOptions();
	            if (compilerOptions.outFile || compilerOptions.out) {
	                ts.Debug.assert(!state.semanticDiagnosticsPerFile);
	                // We dont need to cache the diagnostics just return them from program
	                return state.program.getSemanticDiagnostics(sourceFile, cancellationToken);
	            }
	            if (sourceFile) {
	                return getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken);
	            }
	            if (kind === BuilderProgramKind.SemanticDiagnosticsBuilderProgram) {
	                // When semantic builder asks for diagnostics of the whole program,
	                // ensure that all the affected files are handled
	                var affected = void 0;
	                while (affected = getNextAffectedFile(state, cancellationToken, computeHash)) {
	                    doneWithAffectedFile(state, affected);
	                }
	            }
	            var diagnostics;
	            for (var _i = 0, _a = state.program.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile_1 = _a[_i];
	                diagnostics = ts.addRange(diagnostics, getSemanticDiagnosticsOfFile(state, sourceFile_1, cancellationToken));
	            }
	            return diagnostics || ts.emptyArray;
	        }
	    }
	    ts.createBuilderProgram = createBuilderProgram;
	})(ts || (ts = {}));
	(function (ts) {
	    function createSemanticDiagnosticsBuilderProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram) {
	        return ts.createBuilderProgram(ts.BuilderProgramKind.SemanticDiagnosticsBuilderProgram, ts.getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram));
	    }
	    ts.createSemanticDiagnosticsBuilderProgram = createSemanticDiagnosticsBuilderProgram;
	    function createEmitAndSemanticDiagnosticsBuilderProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram) {
	        return ts.createBuilderProgram(ts.BuilderProgramKind.EmitAndSemanticDiagnosticsBuilderProgram, ts.getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram));
	    }
	    ts.createEmitAndSemanticDiagnosticsBuilderProgram = createEmitAndSemanticDiagnosticsBuilderProgram;
	    function createAbstractBuilder(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram) {
	        var program = ts.getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram).newProgram;
	        return {
	            // Only return program, all other methods are not implemented
	            getProgram: function () { return program; },
	            getState: ts.notImplemented,
	            getCompilerOptions: ts.notImplemented,
	            getSourceFile: ts.notImplemented,
	            getSourceFiles: ts.notImplemented,
	            getOptionsDiagnostics: ts.notImplemented,
	            getGlobalDiagnostics: ts.notImplemented,
	            getSyntacticDiagnostics: ts.notImplemented,
	            getSemanticDiagnostics: ts.notImplemented,
	            emit: ts.notImplemented,
	            getAllDependencies: ts.notImplemented,
	            getCurrentDirectory: ts.notImplemented
	        };
	    }
	    ts.createAbstractBuilder = createAbstractBuilder;
	})(ts || (ts = {}));
	/// <reference path="core.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    function createCachedDirectoryStructureHost(host, currentDirectory, useCaseSensitiveFileNames) {
	        if (!host.getDirectories || !host.readDirectory) {
	            return undefined;
	        }
	        var cachedReadDirectoryResult = ts.createMap();
	        var getCanonicalFileName = ts.createGetCanonicalFileName(useCaseSensitiveFileNames);
	        return {
	            useCaseSensitiveFileNames: useCaseSensitiveFileNames,
	            fileExists: fileExists,
	            readFile: function (path, encoding) { return host.readFile(path, encoding); },
	            directoryExists: host.directoryExists && directoryExists,
	            getDirectories: getDirectories,
	            readDirectory: readDirectory,
	            createDirectory: host.createDirectory && createDirectory,
	            writeFile: host.writeFile && writeFile,
	            addOrDeleteFileOrDirectory: addOrDeleteFileOrDirectory,
	            addOrDeleteFile: addOrDeleteFile,
	            clearCache: clearCache
	        };
	        function toPath(fileName) {
	            return ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	        }
	        function getCachedFileSystemEntries(rootDirPath) {
	            return cachedReadDirectoryResult.get(rootDirPath);
	        }
	        function getCachedFileSystemEntriesForBaseDir(path) {
	            return getCachedFileSystemEntries(ts.getDirectoryPath(path));
	        }
	        function getBaseNameOfFileName(fileName) {
	            return ts.getBaseFileName(ts.normalizePath(fileName));
	        }
	        function createCachedFileSystemEntries(rootDir, rootDirPath) {
	            var resultFromHost = {
	                files: ts.map(host.readDirectory(rootDir, /*extensions*/ undefined, /*exclude*/ undefined, /*include*/ ["*.*"]), getBaseNameOfFileName) || [],
	                directories: host.getDirectories(rootDir) || []
	            };
	            cachedReadDirectoryResult.set(rootDirPath, resultFromHost);
	            return resultFromHost;
	        }
	        /**
	         * If the readDirectory result was already cached, it returns that
	         * Otherwise gets result from host and caches it.
	         * The host request is done under try catch block to avoid caching incorrect result
	         */
	        function tryReadDirectory(rootDir, rootDirPath) {
	            var cachedResult = getCachedFileSystemEntries(rootDirPath);
	            if (cachedResult) {
	                return cachedResult;
	            }
	            try {
	                return createCachedFileSystemEntries(rootDir, rootDirPath);
	            }
	            catch (_e) {
	                // If there is exception to read directories, dont cache the result and direct the calls to host
	                ts.Debug.assert(!cachedReadDirectoryResult.has(rootDirPath));
	                return undefined;
	            }
	        }
	        function fileNameEqual(name1, name2) {
	            return getCanonicalFileName(name1) === getCanonicalFileName(name2);
	        }
	        function hasEntry(entries, name) {
	            return ts.some(entries, function (file) { return fileNameEqual(file, name); });
	        }
	        function updateFileSystemEntry(entries, baseName, isValid) {
	            if (hasEntry(entries, baseName)) {
	                if (!isValid) {
	                    return ts.filterMutate(entries, function (entry) { return !fileNameEqual(entry, baseName); });
	                }
	            }
	            else if (isValid) {
	                return entries.push(baseName);
	            }
	        }
	        function writeFile(fileName, data, writeByteOrderMark) {
	            var path = toPath(fileName);
	            var result = getCachedFileSystemEntriesForBaseDir(path);
	            if (result) {
	                updateFilesOfFileSystemEntry(result, getBaseNameOfFileName(fileName), /*fileExists*/ true);
	            }
	            return host.writeFile(fileName, data, writeByteOrderMark);
	        }
	        function fileExists(fileName) {
	            var path = toPath(fileName);
	            var result = getCachedFileSystemEntriesForBaseDir(path);
	            return result && hasEntry(result.files, getBaseNameOfFileName(fileName)) ||
	                host.fileExists(fileName);
	        }
	        function directoryExists(dirPath) {
	            var path = toPath(dirPath);
	            return cachedReadDirectoryResult.has(path) || host.directoryExists(dirPath);
	        }
	        function createDirectory(dirPath) {
	            var path = toPath(dirPath);
	            var result = getCachedFileSystemEntriesForBaseDir(path);
	            var baseFileName = getBaseNameOfFileName(dirPath);
	            if (result) {
	                updateFileSystemEntry(result.directories, baseFileName, /*isValid*/ true);
	            }
	            host.createDirectory(dirPath);
	        }
	        function getDirectories(rootDir) {
	            var rootDirPath = toPath(rootDir);
	            var result = tryReadDirectory(rootDir, rootDirPath);
	            if (result) {
	                return result.directories.slice();
	            }
	            return host.getDirectories(rootDir);
	        }
	        function readDirectory(rootDir, extensions, excludes, includes, depth) {
	            var rootDirPath = toPath(rootDir);
	            var result = tryReadDirectory(rootDir, rootDirPath);
	            if (result) {
	                return ts.matchFiles(rootDir, extensions, excludes, includes, useCaseSensitiveFileNames, currentDirectory, depth, getFileSystemEntries);
	            }
	            return host.readDirectory(rootDir, extensions, excludes, includes, depth);
	            function getFileSystemEntries(dir) {
	                var path = toPath(dir);
	                if (path === rootDirPath) {
	                    return result;
	                }
	                return tryReadDirectory(dir, path) || ts.emptyFileSystemEntries;
	            }
	        }
	        function addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath) {
	            var existingResult = getCachedFileSystemEntries(fileOrDirectoryPath);
	            if (existingResult) {
	                // Just clear the cache for now
	                // For now just clear the cache, since this could mean that multiple level entries might need to be re-evaluated
	                clearCache();
	                return undefined;
	            }
	            var parentResult = getCachedFileSystemEntriesForBaseDir(fileOrDirectoryPath);
	            if (!parentResult) {
	                return undefined;
	            }
	            // This was earlier a file (hence not in cached directory contents)
	            // or we never cached the directory containing it
	            if (!host.directoryExists) {
	                // Since host doesnt support directory exists, clear the cache as otherwise it might not be same
	                clearCache();
	                return undefined;
	            }
	            var baseName = getBaseNameOfFileName(fileOrDirectory);
	            var fsQueryResult = {
	                fileExists: host.fileExists(fileOrDirectoryPath),
	                directoryExists: host.directoryExists(fileOrDirectoryPath)
	            };
	            if (fsQueryResult.directoryExists || hasEntry(parentResult.directories, baseName)) {
	                // Folder added or removed, clear the cache instead of updating the folder and its structure
	                clearCache();
	            }
	            else {
	                // No need to update the directory structure, just files
	                updateFilesOfFileSystemEntry(parentResult, baseName, fsQueryResult.fileExists);
	            }
	            return fsQueryResult;
	        }
	        function addOrDeleteFile(fileName, filePath, eventKind) {
	            if (eventKind === ts.FileWatcherEventKind.Changed) {
	                return;
	            }
	            var parentResult = getCachedFileSystemEntriesForBaseDir(filePath);
	            if (parentResult) {
	                updateFilesOfFileSystemEntry(parentResult, getBaseNameOfFileName(fileName), eventKind === ts.FileWatcherEventKind.Created);
	            }
	        }
	        function updateFilesOfFileSystemEntry(parentResult, baseName, fileExists) {
	            updateFileSystemEntry(parentResult.files, baseName, fileExists);
	        }
	        function clearCache() {
	            cachedReadDirectoryResult.clear();
	        }
	    }
	    ts.createCachedDirectoryStructureHost = createCachedDirectoryStructureHost;
	    var ConfigFileProgramReloadLevel;
	    (function (ConfigFileProgramReloadLevel) {
	        ConfigFileProgramReloadLevel[ConfigFileProgramReloadLevel["None"] = 0] = "None";
	        /** Update the file name list from the disk */
	        ConfigFileProgramReloadLevel[ConfigFileProgramReloadLevel["Partial"] = 1] = "Partial";
	        /** Reload completely by re-reading contents of config file from disk and updating program */
	        ConfigFileProgramReloadLevel[ConfigFileProgramReloadLevel["Full"] = 2] = "Full";
	    })(ConfigFileProgramReloadLevel = ts.ConfigFileProgramReloadLevel || (ts.ConfigFileProgramReloadLevel = {}));
	    /**
	     * Updates the existing missing file watches with the new set of missing files after new program is created
	     */
	    function updateMissingFilePathsWatch(program, missingFileWatches, createMissingFileWatch) {
	        var missingFilePaths = program.getMissingFilePaths();
	        var newMissingFilePathMap = ts.arrayToSet(missingFilePaths);
	        // Update the missing file paths watcher
	        ts.mutateMap(missingFileWatches, newMissingFilePathMap, {
	            // Watch the missing files
	            createNewValue: createMissingFileWatch,
	            // Files that are no longer missing (e.g. because they are no longer required)
	            // should no longer be watched.
	            onDeleteValue: closeFileWatcher
	        });
	    }
	    ts.updateMissingFilePathsWatch = updateMissingFilePathsWatch;
	    /**
	     * Updates the existing wild card directory watches with the new set of wild card directories from the config file
	     * after new program is created because the config file was reloaded or program was created first time from the config file
	     * Note that there is no need to call this function when the program is updated with additional files without reloading config files,
	     * as wildcard directories wont change unless reloading config file
	     */
	    function updateWatchingWildcardDirectories(existingWatchedForWildcards, wildcardDirectories, watchDirectory) {
	        ts.mutateMap(existingWatchedForWildcards, wildcardDirectories, {
	            // Create new watch and recursive info
	            createNewValue: createWildcardDirectoryWatcher,
	            // Close existing watch thats not needed any more
	            onDeleteValue: closeFileWatcherOf,
	            // Close existing watch that doesnt match in the flags
	            onExistingValue: updateWildcardDirectoryWatcher
	        });
	        function createWildcardDirectoryWatcher(directory, flags) {
	            // Create new watch and recursive info
	            return {
	                watcher: watchDirectory(directory, flags),
	                flags: flags
	            };
	        }
	        function updateWildcardDirectoryWatcher(existingWatcher, flags, directory) {
	            // Watcher needs to be updated if the recursive flags dont match
	            if (existingWatcher.flags === flags) {
	                return;
	            }
	            existingWatcher.watcher.close();
	            existingWatchedForWildcards.set(directory, createWildcardDirectoryWatcher(directory, flags));
	        }
	    }
	    ts.updateWatchingWildcardDirectories = updateWatchingWildcardDirectories;
	    function isEmittedFileOfProgram(program, file) {
	        if (!program) {
	            return false;
	        }
	        return program.isEmittedFile(file);
	    }
	    ts.isEmittedFileOfProgram = isEmittedFileOfProgram;
	    function addFileWatcher(host, file, cb) {
	        return host.watchFile(file, cb);
	    }
	    ts.addFileWatcher = addFileWatcher;
	    function addFileWatcherWithLogging(host, file, cb, log) {
	        var watcherCaption = "FileWatcher:: ";
	        return createWatcherWithLogging(addFileWatcher, watcherCaption, log, /*logOnlyTrigger*/ false, host, file, cb);
	    }
	    ts.addFileWatcherWithLogging = addFileWatcherWithLogging;
	    function addFileWatcherWithOnlyTriggerLogging(host, file, cb, log) {
	        var watcherCaption = "FileWatcher:: ";
	        return createWatcherWithLogging(addFileWatcher, watcherCaption, log, /*logOnlyTrigger*/ true, host, file, cb);
	    }
	    ts.addFileWatcherWithOnlyTriggerLogging = addFileWatcherWithOnlyTriggerLogging;
	    function addFilePathWatcher(host, file, cb, path) {
	        return host.watchFile(file, function (fileName, eventKind) { return cb(fileName, eventKind, path); });
	    }
	    ts.addFilePathWatcher = addFilePathWatcher;
	    function addFilePathWatcherWithLogging(host, file, cb, path, log) {
	        var watcherCaption = "FileWatcher:: ";
	        return createWatcherWithLogging(addFileWatcher, watcherCaption, log, /*logOnlyTrigger*/ false, host, file, cb, path);
	    }
	    ts.addFilePathWatcherWithLogging = addFilePathWatcherWithLogging;
	    function addFilePathWatcherWithOnlyTriggerLogging(host, file, cb, path, log) {
	        var watcherCaption = "FileWatcher:: ";
	        return createWatcherWithLogging(addFileWatcher, watcherCaption, log, /*logOnlyTrigger*/ true, host, file, cb, path);
	    }
	    ts.addFilePathWatcherWithOnlyTriggerLogging = addFilePathWatcherWithOnlyTriggerLogging;
	    function addDirectoryWatcher(host, directory, cb, flags) {
	        var recursive = (flags & 1 /* Recursive */) !== 0;
	        return host.watchDirectory(directory, cb, recursive);
	    }
	    ts.addDirectoryWatcher = addDirectoryWatcher;
	    function addDirectoryWatcherWithLogging(host, directory, cb, flags, log) {
	        var watcherCaption = "DirectoryWatcher " + ((flags & 1 /* Recursive */) !== 0 ? "recursive" : "") + ":: ";
	        return createWatcherWithLogging(addDirectoryWatcher, watcherCaption, log, /*logOnlyTrigger*/ false, host, directory, cb, flags);
	    }
	    ts.addDirectoryWatcherWithLogging = addDirectoryWatcherWithLogging;
	    function addDirectoryWatcherWithOnlyTriggerLogging(host, directory, cb, flags, log) {
	        var watcherCaption = "DirectoryWatcher " + ((flags & 1 /* Recursive */) !== 0 ? "recursive" : "") + ":: ";
	        return createWatcherWithLogging(addDirectoryWatcher, watcherCaption, log, /*logOnlyTrigger*/ true, host, directory, cb, flags);
	    }
	    ts.addDirectoryWatcherWithOnlyTriggerLogging = addDirectoryWatcherWithOnlyTriggerLogging;
	    function createWatcherWithLogging(addWatch, watcherCaption, log, logOnlyTrigger, host, file, cb, optional) {
	        var info = "PathInfo: " + file;
	        if (!logOnlyTrigger) {
	            log(watcherCaption + "Added: " + info);
	        }
	        var watcher = addWatch(host, file, function (fileName, cbOptional1) {
	            var optionalInfo = cbOptional1 !== undefined ? " " + cbOptional1 : "";
	            log(watcherCaption + "Trigger: " + fileName + optionalInfo + " " + info);
	            var start = ts.timestamp();
	            cb(fileName, cbOptional1, optional);
	            var elapsed = ts.timestamp() - start;
	            log(watcherCaption + "Elapsed: " + elapsed + "ms Trigger: " + fileName + optionalInfo + " " + info);
	        }, optional);
	        return {
	            close: function () {
	                if (!logOnlyTrigger) {
	                    log(watcherCaption + "Close: " + info);
	                }
	                watcher.close();
	            }
	        };
	    }
	    function closeFileWatcher(watcher) {
	        watcher.close();
	    }
	    ts.closeFileWatcher = closeFileWatcher;
	    function closeFileWatcherOf(objWithWatcher) {
	        objWithWatcher.watcher.close();
	    }
	    ts.closeFileWatcherOf = closeFileWatcherOf;
	})(ts || (ts = {}));
	/// <reference path="types.ts"/>
	/// <reference path="core.ts"/>
	/// <reference path="watchUtilities.ts"/>
	/*@internal*/
	var ts;
	(function (ts) {
	    ts.maxNumberOfFilesToIterateForInvalidation = 256;
	    function createResolutionCache(resolutionHost, rootDirForResolution, logChangesWhenResolvingModule) {
	        var filesWithChangedSetOfUnresolvedImports;
	        var filesWithInvalidatedResolutions;
	        var allFilesHaveInvalidatedResolution = false;
	        // The resolvedModuleNames and resolvedTypeReferenceDirectives are the cache of resolutions per file.
	        // The key in the map is source file's path.
	        // The values are Map of resolutions with key being name lookedup.
	        var resolvedModuleNames = ts.createMap();
	        var perDirectoryResolvedModuleNames = ts.createMap();
	        var resolvedTypeReferenceDirectives = ts.createMap();
	        var perDirectoryResolvedTypeReferenceDirectives = ts.createMap();
	        var getCurrentDirectory = ts.memoize(function () { return resolutionHost.getCurrentDirectory(); });
	        var cachedDirectoryStructureHost = resolutionHost.getCachedDirectoryStructureHost();
	        /**
	         * These are the extensions that failed lookup files will have by default,
	         * any other extension of failed lookup will be store that path in custom failed lookup path
	         * This helps in not having to comb through all resolutions when files are added/removed
	         * Note that .d.ts file also has .d.ts extension hence will be part of default extensions
	         */
	        var failedLookupDefaultExtensions = [".ts" /* Ts */, ".tsx" /* Tsx */, ".js" /* Js */, ".jsx" /* Jsx */, ".json" /* Json */];
	        var customFailedLookupPaths = ts.createMap();
	        var directoryWatchesOfFailedLookups = ts.createMap();
	        var rootDir = rootDirForResolution && ts.removeTrailingDirectorySeparator(ts.getNormalizedAbsolutePath(rootDirForResolution, getCurrentDirectory()));
	        var rootPath = rootDir && resolutionHost.toPath(rootDir);
	        // TypeRoot watches for the types that get added as part of getAutomaticTypeDirectiveNames
	        var typeRootsWatches = ts.createMap();
	        return {
	            startRecordingFilesWithChangedResolutions: startRecordingFilesWithChangedResolutions,
	            finishRecordingFilesWithChangedResolutions: finishRecordingFilesWithChangedResolutions,
	            // perDirectoryResolvedModuleNames and perDirectoryResolvedTypeReferenceDirectives could be non empty if there was exception during program update
	            // (between startCachingPerDirectoryResolution and finishCachingPerDirectoryResolution)
	            startCachingPerDirectoryResolution: clearPerDirectoryResolutions,
	            finishCachingPerDirectoryResolution: finishCachingPerDirectoryResolution,
	            resolveModuleNames: resolveModuleNames,
	            resolveTypeReferenceDirectives: resolveTypeReferenceDirectives,
	            removeResolutionsOfFile: removeResolutionsOfFile,
	            invalidateResolutionOfFile: invalidateResolutionOfFile,
	            createHasInvalidatedResolution: createHasInvalidatedResolution,
	            updateTypeRootsWatch: updateTypeRootsWatch,
	            closeTypeRootsWatch: closeTypeRootsWatch,
	            clear: clear
	        };
	        function getResolvedModule(resolution) {
	            return resolution.resolvedModule;
	        }
	        function getResolvedTypeReferenceDirective(resolution) {
	            return resolution.resolvedTypeReferenceDirective;
	        }
	        function isInDirectoryPath(dir, file) {
	            if (dir === undefined || file.length <= dir.length) {
	                return false;
	            }
	            return ts.startsWith(file, dir) && file[dir.length] === ts.directorySeparator;
	        }
	        function clear() {
	            ts.clearMap(directoryWatchesOfFailedLookups, ts.closeFileWatcherOf);
	            customFailedLookupPaths.clear();
	            closeTypeRootsWatch();
	            resolvedModuleNames.clear();
	            resolvedTypeReferenceDirectives.clear();
	            allFilesHaveInvalidatedResolution = false;
	            // perDirectoryResolvedModuleNames and perDirectoryResolvedTypeReferenceDirectives could be non empty if there was exception during program update
	            // (between startCachingPerDirectoryResolution and finishCachingPerDirectoryResolution)
	            clearPerDirectoryResolutions();
	        }
	        function startRecordingFilesWithChangedResolutions() {
	            filesWithChangedSetOfUnresolvedImports = [];
	        }
	        function finishRecordingFilesWithChangedResolutions() {
	            var collected = filesWithChangedSetOfUnresolvedImports;
	            filesWithChangedSetOfUnresolvedImports = undefined;
	            return collected;
	        }
	        function createHasInvalidatedResolution(forceAllFilesAsInvalidated) {
	            if (allFilesHaveInvalidatedResolution || forceAllFilesAsInvalidated) {
	                // Any file asked would have invalidated resolution
	                filesWithInvalidatedResolutions = undefined;
	                return ts.returnTrue;
	            }
	            var collected = filesWithInvalidatedResolutions;
	            filesWithInvalidatedResolutions = undefined;
	            return function (path) { return collected && collected.has(path); };
	        }
	        function clearPerDirectoryResolutions() {
	            perDirectoryResolvedModuleNames.clear();
	            perDirectoryResolvedTypeReferenceDirectives.clear();
	        }
	        function finishCachingPerDirectoryResolution() {
	            allFilesHaveInvalidatedResolution = false;
	            directoryWatchesOfFailedLookups.forEach(function (watcher, path) {
	                if (watcher.refCount === 0) {
	                    directoryWatchesOfFailedLookups.delete(path);
	                    watcher.watcher.close();
	                }
	            });
	            clearPerDirectoryResolutions();
	        }
	        function resolveModuleName(moduleName, containingFile, compilerOptions, host) {
	            var primaryResult = ts.resolveModuleName(moduleName, containingFile, compilerOptions, host);
	            // return result immediately only if global cache support is not enabled or if it is .ts, .tsx or .d.ts
	            if (!resolutionHost.getGlobalCache) {
	                return primaryResult;
	            }
	            // otherwise try to load typings from @types
	            var globalCache = resolutionHost.getGlobalCache();
	            if (globalCache !== undefined && !ts.isExternalModuleNameRelative(moduleName) && !(primaryResult.resolvedModule && ts.extensionIsTypeScript(primaryResult.resolvedModule.extension))) {
	                // create different collection of failed lookup locations for second pass
	                // if it will fail and we've already found something during the first pass - we don't want to pollute its results
	                var _a = ts.loadModuleFromGlobalCache(moduleName, resolutionHost.projectName, compilerOptions, host, globalCache), resolvedModule = _a.resolvedModule, failedLookupLocations = _a.failedLookupLocations;
	                if (resolvedModule) {
	                    return { resolvedModule: resolvedModule, failedLookupLocations: ts.addRange(primaryResult.failedLookupLocations, failedLookupLocations) };
	                }
	            }
	            // Default return the result from the first pass
	            return primaryResult;
	        }
	        function resolveNamesWithLocalCache(names, containingFile, cache, perDirectoryCache, loader, getResolutionWithResolvedFileName, reusedNames, logChanges) {
	            var path = resolutionHost.toPath(containingFile);
	            var resolutionsInFile = cache.get(path) || cache.set(path, ts.createMap()).get(path);
	            var dirPath = ts.getDirectoryPath(path);
	            var perDirectoryResolution = perDirectoryCache.get(dirPath);
	            if (!perDirectoryResolution) {
	                perDirectoryResolution = ts.createMap();
	                perDirectoryCache.set(dirPath, perDirectoryResolution);
	            }
	            var resolvedModules = [];
	            var compilerOptions = resolutionHost.getCompilationSettings();
	            var seenNamesInFile = ts.createMap();
	            for (var _i = 0, names_2 = names; _i < names_2.length; _i++) {
	                var name = names_2[_i];
	                var resolution = resolutionsInFile.get(name);
	                // Resolution is valid if it is present and not invalidated
	                if (!seenNamesInFile.has(name) &&
	                    allFilesHaveInvalidatedResolution || !resolution || resolution.isInvalidated) {
	                    var existingResolution = resolution;
	                    var resolutionInDirectory = perDirectoryResolution.get(name);
	                    if (resolutionInDirectory) {
	                        resolution = resolutionInDirectory;
	                    }
	                    else {
	                        resolution = loader(name, containingFile, compilerOptions, resolutionHost);
	                        perDirectoryResolution.set(name, resolution);
	                    }
	                    resolutionsInFile.set(name, resolution);
	                    if (resolution.failedLookupLocations) {
	                        if (existingResolution && existingResolution.failedLookupLocations) {
	                            watchAndStopWatchDiffFailedLookupLocations(resolution, existingResolution);
	                        }
	                        else {
	                            watchFailedLookupLocationOfResolution(resolution, 0);
	                        }
	                    }
	                    else if (existingResolution) {
	                        stopWatchFailedLookupLocationOfResolution(existingResolution);
	                    }
	                    if (logChanges && filesWithChangedSetOfUnresolvedImports && !resolutionIsEqualTo(existingResolution, resolution)) {
	                        filesWithChangedSetOfUnresolvedImports.push(path);
	                        // reset log changes to avoid recording the same file multiple times
	                        logChanges = false;
	                    }
	                }
	                ts.Debug.assert(resolution !== undefined && !resolution.isInvalidated);
	                seenNamesInFile.set(name, true);
	                resolvedModules.push(getResolutionWithResolvedFileName(resolution));
	            }
	            // Stop watching and remove the unused name
	            resolutionsInFile.forEach(function (resolution, name) {
	                if (!seenNamesInFile.has(name) && !ts.contains(reusedNames, name)) {
	                    stopWatchFailedLookupLocationOfResolution(resolution);
	                    resolutionsInFile.delete(name);
	                }
	            });
	            return resolvedModules;
	            function resolutionIsEqualTo(oldResolution, newResolution) {
	                if (oldResolution === newResolution) {
	                    return true;
	                }
	                if (!oldResolution || !newResolution || oldResolution.isInvalidated) {
	                    return false;
	                }
	                var oldResult = getResolutionWithResolvedFileName(oldResolution);
	                var newResult = getResolutionWithResolvedFileName(newResolution);
	                if (oldResult === newResult) {
	                    return true;
	                }
	                if (!oldResult || !newResult) {
	                    return false;
	                }
	                return oldResult.resolvedFileName === newResult.resolvedFileName;
	            }
	        }
	        function resolveTypeReferenceDirectives(typeDirectiveNames, containingFile) {
	            return resolveNamesWithLocalCache(typeDirectiveNames, containingFile, resolvedTypeReferenceDirectives, perDirectoryResolvedTypeReferenceDirectives, ts.resolveTypeReferenceDirective, getResolvedTypeReferenceDirective, 
	            /*reusedNames*/ undefined, /*logChanges*/ false);
	        }
	        function resolveModuleNames(moduleNames, containingFile, reusedNames) {
	            return resolveNamesWithLocalCache(moduleNames, containingFile, resolvedModuleNames, perDirectoryResolvedModuleNames, resolveModuleName, getResolvedModule, reusedNames, logChangesWhenResolvingModule);
	        }
	        function isNodeModulesDirectory(dirPath) {
	            return ts.endsWith(dirPath, "/node_modules");
	        }
	        function isNodeModulesAtTypesDirectory(dirPath) {
	            return ts.endsWith(dirPath, "/node_modules/@types");
	        }
	        function isDirectoryAtleastAtLevelFromFSRoot(dirPath, minLevels) {
	            for (var searchIndex = ts.getRootLength(dirPath); minLevels > 0; minLevels--) {
	                searchIndex = dirPath.indexOf(ts.directorySeparator, searchIndex) + 1;
	                if (searchIndex === 0) {
	                    // Folder isnt at expected minimun levels
	                    return false;
	                }
	            }
	            return true;
	        }
	        function canWatchDirectory(dirPath) {
	            return isDirectoryAtleastAtLevelFromFSRoot(dirPath, 
	            // When root is "/" do not watch directories like:
	            // "/", "/user", "/user/username", "/user/username/folderAtRoot"
	            // When root is "c:/" do not watch directories like:
	            // "c:/", "c:/folderAtRoot"
	            dirPath.charCodeAt(0) === 47 /* slash */ ? 3 : 1);
	        }
	        function filterFSRootDirectoriesToWatch(watchPath, dirPath) {
	            if (!canWatchDirectory(dirPath)) {
	                watchPath.ignore = true;
	            }
	            return watchPath;
	        }
	        function getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath) {
	            if (isInDirectoryPath(rootPath, failedLookupLocationPath)) {
	                return { dir: rootDir, dirPath: rootPath };
	            }
	            var dir = ts.getDirectoryPath(ts.getNormalizedAbsolutePath(failedLookupLocation, getCurrentDirectory()));
	            var dirPath = ts.getDirectoryPath(failedLookupLocationPath);
	            // If directory path contains node module, get the most parent node_modules directory for watching
	            while (ts.stringContains(dirPath, "/node_modules/")) {
	                dir = ts.getDirectoryPath(dir);
	                dirPath = ts.getDirectoryPath(dirPath);
	            }
	            // If the directory is node_modules use it to watch
	            if (isNodeModulesDirectory(dirPath)) {
	                return filterFSRootDirectoriesToWatch({ dir: dir, dirPath: dirPath }, ts.getDirectoryPath(dirPath));
	            }
	            // Use some ancestor of the root directory
	            if (rootPath !== undefined) {
	                while (!isInDirectoryPath(dirPath, rootPath)) {
	                    var parentPath = ts.getDirectoryPath(dirPath);
	                    if (parentPath === dirPath) {
	                        break;
	                    }
	                    dirPath = parentPath;
	                    dir = ts.getDirectoryPath(dir);
	                }
	            }
	            return filterFSRootDirectoriesToWatch({ dir: dir, dirPath: dirPath }, dirPath);
	        }
	        function isPathWithDefaultFailedLookupExtension(path) {
	            return ts.fileExtensionIsOneOf(path, failedLookupDefaultExtensions);
	        }
	        function watchAndStopWatchDiffFailedLookupLocations(resolution, existingResolution) {
	            var failedLookupLocations = resolution.failedLookupLocations;
	            var existingFailedLookupLocations = existingResolution.failedLookupLocations;
	            for (var index = 0; index < failedLookupLocations.length; index++) {
	                if (index === existingFailedLookupLocations.length) {
	                    // Additional failed lookup locations, watch from this index
	                    watchFailedLookupLocationOfResolution(resolution, index);
	                    return;
	                }
	                else if (failedLookupLocations[index] !== existingFailedLookupLocations[index]) {
	                    // Different failed lookup locations,
	                    // Watch new resolution failed lookup locations from this index and
	                    // stop watching existing resolutions from this index
	                    watchFailedLookupLocationOfResolution(resolution, index);
	                    stopWatchFailedLookupLocationOfResolutionFrom(existingResolution, index);
	                    return;
	                }
	            }
	            // All new failed lookup locations are already watched (and are same),
	            // Stop watching failed lookup locations of existing resolution after failed lookup locations length
	            stopWatchFailedLookupLocationOfResolutionFrom(existingResolution, failedLookupLocations.length);
	        }
	        function watchFailedLookupLocationOfResolution(_a, startIndex) {
	            var failedLookupLocations = _a.failedLookupLocations;
	            for (var i = startIndex; i < failedLookupLocations.length; i++) {
	                var failedLookupLocation = failedLookupLocations[i];
	                var failedLookupLocationPath = resolutionHost.toPath(failedLookupLocation);
	                // If the failed lookup location path is not one of the supported extensions,
	                // store it in the custom path
	                if (!isPathWithDefaultFailedLookupExtension(failedLookupLocationPath)) {
	                    var refCount = customFailedLookupPaths.get(failedLookupLocationPath) || 0;
	                    customFailedLookupPaths.set(failedLookupLocationPath, refCount + 1);
	                }
	                var _b = getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath), dir = _b.dir, dirPath = _b.dirPath, ignore = _b.ignore;
	                if (!ignore) {
	                    var dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
	                    if (dirWatcher) {
	                        dirWatcher.refCount++;
	                    }
	                    else {
	                        directoryWatchesOfFailedLookups.set(dirPath, { watcher: createDirectoryWatcher(dir, dirPath), refCount: 1 });
	                    }
	                }
	            }
	        }
	        function stopWatchFailedLookupLocationOfResolution(resolution) {
	            if (resolution.failedLookupLocations) {
	                stopWatchFailedLookupLocationOfResolutionFrom(resolution, 0);
	            }
	        }
	        function stopWatchFailedLookupLocationOfResolutionFrom(_a, startIndex) {
	            var failedLookupLocations = _a.failedLookupLocations;
	            for (var i = startIndex; i < failedLookupLocations.length; i++) {
	                var failedLookupLocation = failedLookupLocations[i];
	                var failedLookupLocationPath = resolutionHost.toPath(failedLookupLocation);
	                var refCount = customFailedLookupPaths.get(failedLookupLocationPath);
	                if (refCount) {
	                    if (refCount === 1) {
	                        customFailedLookupPaths.delete(failedLookupLocationPath);
	                    }
	                    else {
	                        ts.Debug.assert(refCount > 1);
	                        customFailedLookupPaths.set(failedLookupLocationPath, refCount - 1);
	                    }
	                }
	                var _b = getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath), dirPath = _b.dirPath, ignore = _b.ignore;
	                if (!ignore) {
	                    var dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
	                    // Do not close the watcher yet since it might be needed by other failed lookup locations.
	                    dirWatcher.refCount--;
	                }
	            }
	        }
	        function createDirectoryWatcher(directory, dirPath) {
	            return resolutionHost.watchDirectoryOfFailedLookupLocation(directory, function (fileOrDirectory) {
	                var fileOrDirectoryPath = resolutionHost.toPath(fileOrDirectory);
	                if (cachedDirectoryStructureHost) {
	                    // Since the file existance changed, update the sourceFiles cache
	                    cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
	                }
	                // If the files are added to project root or node_modules directory, always run through the invalidation process
	                // Otherwise run through invalidation only if adding to the immediate directory
	                if (!allFilesHaveInvalidatedResolution &&
	                    dirPath === rootPath || isNodeModulesDirectory(dirPath) || ts.getDirectoryPath(fileOrDirectoryPath) === dirPath) {
	                    if (invalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, dirPath === fileOrDirectoryPath)) {
	                        resolutionHost.onInvalidatedResolution();
	                    }
	                }
	            }, 1 /* Recursive */);
	        }
	        function removeResolutionsOfFileFromCache(cache, filePath) {
	            // Deleted file, stop watching failed lookups for all the resolutions in the file
	            var resolutions = cache.get(filePath);
	            if (resolutions) {
	                resolutions.forEach(stopWatchFailedLookupLocationOfResolution);
	                cache.delete(filePath);
	            }
	        }
	        function removeResolutionsOfFile(filePath) {
	            removeResolutionsOfFileFromCache(resolvedModuleNames, filePath);
	            removeResolutionsOfFileFromCache(resolvedTypeReferenceDirectives, filePath);
	        }
	        function invalidateResolutionCache(cache, isInvalidatedResolution, getResolutionWithResolvedFileName) {
	            var seen = ts.createMap();
	            cache.forEach(function (resolutions, containingFilePath) {
	                var dirPath = ts.getDirectoryPath(containingFilePath);
	                var seenInDir = seen.get(dirPath);
	                if (!seenInDir) {
	                    seenInDir = ts.createMap();
	                    seen.set(dirPath, seenInDir);
	                }
	                resolutions.forEach(function (resolution, name) {
	                    if (seenInDir.has(name)) {
	                        return;
	                    }
	                    seenInDir.set(name, true);
	                    if (!resolution.isInvalidated && isInvalidatedResolution(resolution, getResolutionWithResolvedFileName)) {
	                        // Mark the file as needing re-evaluation of module resolution instead of using it blindly.
	                        resolution.isInvalidated = true;
	                        (filesWithInvalidatedResolutions || (filesWithInvalidatedResolutions = ts.createMap())).set(containingFilePath, true);
	                    }
	                });
	            });
	        }
	        function hasReachedResolutionIterationLimit() {
	            var maxSize = resolutionHost.maxNumberOfFilesToIterateForInvalidation || ts.maxNumberOfFilesToIterateForInvalidation;
	            return resolvedModuleNames.size > maxSize || resolvedTypeReferenceDirectives.size > maxSize;
	        }
	        function invalidateResolutions(isInvalidatedResolution) {
	            // If more than maxNumberOfFilesToIterateForInvalidation present,
	            // just invalidated all files and recalculate the resolutions for files instead
	            if (hasReachedResolutionIterationLimit()) {
	                allFilesHaveInvalidatedResolution = true;
	                return;
	            }
	            invalidateResolutionCache(resolvedModuleNames, isInvalidatedResolution, getResolvedModule);
	            invalidateResolutionCache(resolvedTypeReferenceDirectives, isInvalidatedResolution, getResolvedTypeReferenceDirective);
	        }
	        function invalidateResolutionOfFile(filePath) {
	            removeResolutionsOfFile(filePath);
	            invalidateResolutions(
	            // Resolution is invalidated if the resulting file name is same as the deleted file path
	            function (resolution, getResolutionWithResolvedFileName) {
	                var result = getResolutionWithResolvedFileName(resolution);
	                return result && resolutionHost.toPath(result.resolvedFileName) === filePath;
	            });
	        }
	        function invalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, isCreatingWatchedDirectory) {
	            var isChangedFailedLookupLocation;
	            if (isCreatingWatchedDirectory) {
	                // Watching directory is created
	                // Invalidate any resolution has failed lookup in this directory
	                isChangedFailedLookupLocation = function (location) { return isInDirectoryPath(fileOrDirectoryPath, resolutionHost.toPath(location)); };
	            }
	            else {
	                // Some file or directory in the watching directory is created
	                // Return early if it does not have any of the watching extension or not the custom failed lookup path
	                var dirOfFileOrDirectory = ts.getDirectoryPath(fileOrDirectoryPath);
	                if (isNodeModulesAtTypesDirectory(dirOfFileOrDirectory) || isNodeModulesDirectory(dirOfFileOrDirectory)) {
	                    // Invalidate any resolution from this directory
	                    isChangedFailedLookupLocation = function (location) {
	                        var locationPath = resolutionHost.toPath(location);
	                        return locationPath === fileOrDirectoryPath || ts.startsWith(resolutionHost.toPath(location), fileOrDirectoryPath);
	                    };
	                }
	                else {
	                    if (!isPathWithDefaultFailedLookupExtension(fileOrDirectoryPath) && !customFailedLookupPaths.has(fileOrDirectoryPath)) {
	                        return false;
	                    }
	                    // Ignore emits from the program
	                    if (ts.isEmittedFileOfProgram(resolutionHost.getCurrentProgram(), fileOrDirectoryPath)) {
	                        return false;
	                    }
	                    // Resolution need to be invalidated if failed lookup location is same as the file or directory getting created
	                    isChangedFailedLookupLocation = function (location) { return resolutionHost.toPath(location) === fileOrDirectoryPath; };
	                }
	            }
	            var hasChangedFailedLookupLocation = function (resolution) { return ts.some(resolution.failedLookupLocations, isChangedFailedLookupLocation); };
	            var invalidatedFilesCount = filesWithInvalidatedResolutions && filesWithInvalidatedResolutions.size;
	            invalidateResolutions(
	            // Resolution is invalidated if the resulting file name is same as the deleted file path
	            hasChangedFailedLookupLocation);
	            return allFilesHaveInvalidatedResolution || filesWithInvalidatedResolutions && filesWithInvalidatedResolutions.size !== invalidatedFilesCount;
	        }
	        function closeTypeRootsWatch() {
	            ts.clearMap(typeRootsWatches, ts.closeFileWatcher);
	        }
	        function createTypeRootsWatch(_typeRootPath, typeRoot) {
	            // Create new watch and recursive info
	            return resolutionHost.watchTypeRootsDirectory(typeRoot, function (fileOrDirectory) {
	                var fileOrDirectoryPath = resolutionHost.toPath(fileOrDirectory);
	                if (cachedDirectoryStructureHost) {
	                    // Since the file existance changed, update the sourceFiles cache
	                    cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
	                }
	                // For now just recompile
	                // We could potentially store more data here about whether it was/would be really be used or not
	                // and with that determine to trigger compilation but for now this is enough
	                resolutionHost.onChangedAutomaticTypeDirectiveNames();
	            }, 1 /* Recursive */);
	        }
	        /**
	         * Watches the types that would get added as part of getAutomaticTypeDirectiveNames
	         * To be called when compiler options change
	         */
	        function updateTypeRootsWatch() {
	            var options = resolutionHost.getCompilationSettings();
	            if (options.types) {
	                // No need to do any watch since resolution cache is going to handle the failed lookups
	                // for the types added by this
	                closeTypeRootsWatch();
	                return;
	            }
	            // we need to assume the directories exist to ensure that we can get all the type root directories that get included
	            // But filter directories that are at root level to say directory doesnt exist, so that we arent watching them
	            var typeRoots = ts.getEffectiveTypeRoots(options, { directoryExists: directoryExistsForTypeRootWatch, getCurrentDirectory: getCurrentDirectory });
	            if (typeRoots) {
	                ts.mutateMap(typeRootsWatches, ts.arrayToMap(typeRoots, function (tr) { return resolutionHost.toPath(tr); }), {
	                    createNewValue: createTypeRootsWatch,
	                    onDeleteValue: ts.closeFileWatcher
	                });
	            }
	            else {
	                closeTypeRootsWatch();
	            }
	        }
	        /**
	         * Use this function to return if directory exists to get type roots to watch
	         * If we return directory exists then only the paths will be added to type roots
	         * Hence return true for all directories except root directories which are filtered from watching
	         */
	        function directoryExistsForTypeRootWatch(nodeTypesDirectory) {
	            var dir = ts.getDirectoryPath(ts.getDirectoryPath(nodeTypesDirectory));
	            var dirPath = resolutionHost.toPath(dir);
	            return dirPath === rootPath || canWatchDirectory(dirPath);
	        }
	    }
	    ts.createResolutionCache = createResolutionCache;
	})(ts || (ts = {}));
	/// <reference path="program.ts" />
	/// <reference path="builder.ts" />
	/// <reference path="resolutionCache.ts"/>
	/*@internal*/
	var ts;
	(function (ts) {
	    var sysFormatDiagnosticsHost = ts.sys ? {
	        getCurrentDirectory: function () { return ts.sys.getCurrentDirectory(); },
	        getNewLine: function () { return ts.sys.newLine; },
	        getCanonicalFileName: ts.createGetCanonicalFileName(ts.sys.useCaseSensitiveFileNames)
	    } : undefined;
	    /**
	     * Create a function that reports error by writing to the system and handles the formating of the diagnostic
	     */
	    function createDiagnosticReporter(system, pretty) {
	        var host = system === ts.sys ? sysFormatDiagnosticsHost : {
	            getCurrentDirectory: function () { return system.getCurrentDirectory(); },
	            getNewLine: function () { return system.newLine; },
	            getCanonicalFileName: ts.createGetCanonicalFileName(system.useCaseSensitiveFileNames),
	        };
	        if (!pretty) {
	            return function (diagnostic) { return system.write(ts.formatDiagnostic(diagnostic, host)); };
	        }
	        var diagnostics = new Array(1);
	        return function (diagnostic) {
	            diagnostics[0] = diagnostic;
	            system.write(ts.formatDiagnosticsWithColorAndContext(diagnostics, host) + host.getNewLine());
	            diagnostics[0] = undefined;
	        };
	    }
	    ts.createDiagnosticReporter = createDiagnosticReporter;
	    function clearScreenIfNotWatchingForFileChanges(system, diagnostic, options) {
	        if (system.clearScreen &&
	            diagnostic.code !== ts.Diagnostics.Compilation_complete_Watching_for_file_changes.code &&
	            !options.extendedDiagnostics &&
	            !options.diagnostics) {
	            system.clearScreen();
	        }
	    }
	    /**
	     * Create a function that reports watch status by writing to the system and handles the formating of the diagnostic
	     */
	    function createWatchStatusReporter(system, pretty) {
	        return pretty ?
	            function (diagnostic, newLine, options) {
	                clearScreenIfNotWatchingForFileChanges(system, diagnostic, options);
	                var output = "[" + ts.formatColorAndReset(new Date().toLocaleTimeString(), ts.ForegroundColorEscapeSequences.Grey) + "] ";
	                output += "" + ts.flattenDiagnosticMessageText(diagnostic.messageText, system.newLine) + (newLine + newLine + newLine);
	                system.write(output);
	            } :
	            function (diagnostic, newLine, options) {
	                clearScreenIfNotWatchingForFileChanges(system, diagnostic, options);
	                var output = new Date().toLocaleTimeString() + " - ";
	                output += "" + ts.flattenDiagnosticMessageText(diagnostic.messageText, system.newLine) + (newLine + newLine + newLine);
	                system.write(output);
	            };
	    }
	    ts.createWatchStatusReporter = createWatchStatusReporter;
	    /** Parses config file using System interface */
	    function parseConfigFileWithSystem(configFileName, optionsToExtend, system, reportDiagnostic) {
	        var host = system;
	        host.onConfigFileDiagnostic = reportDiagnostic;
	        host.onUnRecoverableConfigFileDiagnostic = function (diagnostic) { return reportUnrecoverableDiagnostic(ts.sys, reportDiagnostic, diagnostic); };
	        var result = getParsedCommandLineOfConfigFile(configFileName, optionsToExtend, host);
	        host.onConfigFileDiagnostic = undefined;
	        host.onUnRecoverableConfigFileDiagnostic = undefined;
	        return result;
	    }
	    ts.parseConfigFileWithSystem = parseConfigFileWithSystem;
	    /**
	     * Reads the config file, reports errors if any and exits if the config file cannot be found
	     */
	    function getParsedCommandLineOfConfigFile(configFileName, optionsToExtend, host) {
	        var configFileText;
	        try {
	            configFileText = host.readFile(configFileName);
	        }
	        catch (e) {
	            var error = ts.createCompilerDiagnostic(ts.Diagnostics.Cannot_read_file_0_Colon_1, configFileName, e.message);
	            host.onUnRecoverableConfigFileDiagnostic(error);
	            return undefined;
	        }
	        if (!configFileText) {
	            var error = ts.createCompilerDiagnostic(ts.Diagnostics.File_0_not_found, configFileName);
	            host.onUnRecoverableConfigFileDiagnostic(error);
	            return undefined;
	        }
	        var result = ts.parseJsonText(configFileName, configFileText);
	        result.parseDiagnostics.forEach(function (diagnostic) { return host.onConfigFileDiagnostic(diagnostic); });
	        var cwd = host.getCurrentDirectory();
	        var configParseResult = ts.parseJsonSourceFileConfigFileContent(result, host, ts.getNormalizedAbsolutePath(ts.getDirectoryPath(configFileName), cwd), optionsToExtend, ts.getNormalizedAbsolutePath(configFileName, cwd));
	        configParseResult.errors.forEach(function (diagnostic) { return host.onConfigFileDiagnostic(diagnostic); });
	        return configParseResult;
	    }
	    ts.getParsedCommandLineOfConfigFile = getParsedCommandLineOfConfigFile;
	    /**
	     * Helper that emit files, report diagnostics and lists emitted and/or source files depending on compiler options
	     */
	    function emitFilesAndReportErrors(program, reportDiagnostic, writeFileName) {
	        // First get and report any syntactic errors.
	        var diagnostics = program.getSyntacticDiagnostics().slice();
	        var reportSemanticDiagnostics = false;
	        // If we didn't have any syntactic errors, then also try getting the global and
	        // semantic errors.
	        if (diagnostics.length === 0) {
	            ts.addRange(diagnostics, program.getOptionsDiagnostics());
	            ts.addRange(diagnostics, program.getGlobalDiagnostics());
	            if (diagnostics.length === 0) {
	                reportSemanticDiagnostics = true;
	            }
	        }
	        // Emit and report any errors we ran into.
	        var _a = program.emit(), emittedFiles = _a.emittedFiles, emitSkipped = _a.emitSkipped, emitDiagnostics = _a.diagnostics;
	        ts.addRange(diagnostics, emitDiagnostics);
	        if (reportSemanticDiagnostics) {
	            ts.addRange(diagnostics, program.getSemanticDiagnostics());
	        }
	        ts.sortAndDeduplicateDiagnostics(diagnostics).forEach(reportDiagnostic);
	        if (writeFileName) {
	            var currentDir_1 = program.getCurrentDirectory();
	            ts.forEach(emittedFiles, function (file) {
	                var filepath = ts.getNormalizedAbsolutePath(file, currentDir_1);
	                writeFileName("TSFILE: " + filepath);
	            });
	            if (program.getCompilerOptions().listFiles) {
	                ts.forEach(program.getSourceFiles(), function (file) {
	                    writeFileName(file.fileName);
	                });
	            }
	        }
	        if (emitSkipped && diagnostics.length > 0) {
	            // If the emitter didn't emit anything, then pass that value along.
	            return ts.ExitStatus.DiagnosticsPresent_OutputsSkipped;
	        }
	        else if (diagnostics.length > 0) {
	            // The emitter emitted something, inform the caller if that happened in the presence
	            // of diagnostics or not.
	            return ts.ExitStatus.DiagnosticsPresent_OutputsGenerated;
	        }
	        return ts.ExitStatus.Success;
	    }
	    ts.emitFilesAndReportErrors = emitFilesAndReportErrors;
	    var noopFileWatcher = { close: ts.noop };
	    /**
	     * Creates the watch compiler host that can be extended with config file or root file names and options host
	     */
	    function createWatchCompilerHost(system, createProgram, reportDiagnostic, reportWatchStatus) {
	        if (system === void 0) { system = ts.sys; }
	        if (!createProgram) {
	            createProgram = ts.createEmitAndSemanticDiagnosticsBuilderProgram;
	        }
	        var host = system;
	        var useCaseSensitiveFileNames = function () { return system.useCaseSensitiveFileNames; };
	        var writeFileName = function (s) { return system.write(s + system.newLine); };
	        return {
	            useCaseSensitiveFileNames: useCaseSensitiveFileNames,
	            getNewLine: function () { return system.newLine; },
	            getCurrentDirectory: function () { return system.getCurrentDirectory(); },
	            getDefaultLibLocation: getDefaultLibLocation,
	            getDefaultLibFileName: function (options) { return ts.combinePaths(getDefaultLibLocation(), ts.getDefaultLibFileName(options)); },
	            fileExists: function (path) { return system.fileExists(path); },
	            readFile: function (path, encoding) { return system.readFile(path, encoding); },
	            directoryExists: function (path) { return system.directoryExists(path); },
	            getDirectories: function (path) { return system.getDirectories(path); },
	            readDirectory: function (path, extensions, exclude, include, depth) { return system.readDirectory(path, extensions, exclude, include, depth); },
	            realpath: system.realpath && (function (path) { return system.realpath(path); }),
	            getEnvironmentVariable: system.getEnvironmentVariable && (function (name) { return system.getEnvironmentVariable(name); }),
	            watchFile: system.watchFile ? (function (path, callback, pollingInterval) { return system.watchFile(path, callback, pollingInterval); }) : function () { return noopFileWatcher; },
	            watchDirectory: system.watchDirectory ? (function (path, callback, recursive) { return system.watchDirectory(path, callback, recursive); }) : function () { return noopFileWatcher; },
	            setTimeout: system.setTimeout ? (function (callback, ms) {
	                var args = [];
	                for (var _i = 2; _i < arguments.length; _i++) {
	                    args[_i - 2] = arguments[_i];
	                }
	                return (_a = system.setTimeout).call.apply(_a, [system, callback, ms].concat(args));
	                var _a;
	            }) : ts.noop,
	            clearTimeout: system.clearTimeout ? (function (timeoutId) { return system.clearTimeout(timeoutId); }) : ts.noop,
	            trace: function (s) { return system.write(s); },
	            onWatchStatusChange: reportWatchStatus || createWatchStatusReporter(system),
	            createDirectory: function (path) { return system.createDirectory(path); },
	            writeFile: function (path, data, writeByteOrderMark) { return system.writeFile(path, data, writeByteOrderMark); },
	            onCachedDirectoryStructureHostCreate: function (cacheHost) { return host = cacheHost || system; },
	            createHash: system.createHash && (function (s) { return system.createHash(s); }),
	            createProgram: createProgram,
	            afterProgramCreate: emitFilesAndReportErrorUsingBuilder
	        };
	        function getDefaultLibLocation() {
	            return ts.getDirectoryPath(ts.normalizePath(system.getExecutingFilePath()));
	        }
	        function emitFilesAndReportErrorUsingBuilder(builderProgram) {
	            emitFilesAndReportErrors(builderProgram, reportDiagnostic, writeFileName);
	        }
	    }
	    /**
	     * Report error and exit
	     */
	    function reportUnrecoverableDiagnostic(system, reportDiagnostic, diagnostic) {
	        reportDiagnostic(diagnostic);
	        system.exit(ts.ExitStatus.DiagnosticsPresent_OutputsSkipped);
	    }
	    /**
	     * Creates the watch compiler host from system for config file in watch mode
	     */
	    function createWatchCompilerHostOfConfigFile(configFileName, optionsToExtend, system, createProgram, reportDiagnostic, reportWatchStatus) {
	        reportDiagnostic = reportDiagnostic || createDiagnosticReporter(system);
	        var host = createWatchCompilerHost(system, createProgram, reportDiagnostic, reportWatchStatus);
	        host.onConfigFileDiagnostic = reportDiagnostic;
	        host.onUnRecoverableConfigFileDiagnostic = function (diagnostic) { return reportUnrecoverableDiagnostic(system, reportDiagnostic, diagnostic); };
	        host.configFileName = configFileName;
	        host.optionsToExtend = optionsToExtend;
	        return host;
	    }
	    ts.createWatchCompilerHostOfConfigFile = createWatchCompilerHostOfConfigFile;
	    /**
	     * Creates the watch compiler host from system for compiling root files and options in watch mode
	     */
	    function createWatchCompilerHostOfFilesAndCompilerOptions(rootFiles, options, system, createProgram, reportDiagnostic, reportWatchStatus) {
	        var host = createWatchCompilerHost(system, createProgram, reportDiagnostic || createDiagnosticReporter(system), reportWatchStatus);
	        host.rootFiles = rootFiles;
	        host.options = options;
	        return host;
	    }
	    ts.createWatchCompilerHostOfFilesAndCompilerOptions = createWatchCompilerHostOfFilesAndCompilerOptions;
	})(ts || (ts = {}));
	(function (ts) {
	    function createWatchCompilerHost(rootFilesOrConfigFileName, options, system, createProgram, reportDiagnostic, reportWatchStatus) {
	        if (ts.isArray(rootFilesOrConfigFileName)) {
	            return ts.createWatchCompilerHostOfFilesAndCompilerOptions(rootFilesOrConfigFileName, options, system, createProgram, reportDiagnostic, reportWatchStatus);
	        }
	        else {
	            return ts.createWatchCompilerHostOfConfigFile(rootFilesOrConfigFileName, options, system, createProgram, reportDiagnostic, reportWatchStatus);
	        }
	    }
	    ts.createWatchCompilerHost = createWatchCompilerHost;
	    var initialVersion = 1;
	    function createWatchProgram(host) {
	        var builderProgram;
	        var reloadLevel; // level to indicate if the program needs to be reloaded from config file/just filenames etc
	        var missingFilesMap; // Map of file watchers for the missing files
	        var watchedWildcardDirectories; // map of watchers for the wild card directories in the config file
	        var timerToUpdateProgram; // timer callback to recompile the program
	        var sourceFilesCache = ts.createMap(); // Cache that stores the source file and version info
	        var missingFilePathsRequestedForRelease; // These paths are held temparirly so that we can remove the entry from source file cache if the file is not tracked by missing files
	        var hasChangedCompilerOptions = false; // True if the compiler options have changed between compilations
	        var hasChangedAutomaticTypeDirectiveNames = false; // True if the automatic type directives have changed
	        var useCaseSensitiveFileNames = host.useCaseSensitiveFileNames();
	        var currentDirectory = host.getCurrentDirectory();
	        var getCurrentDirectory = function () { return currentDirectory; };
	        var readFile = function (path, encoding) { return host.readFile(path, encoding); };
	        var configFileName = host.configFileName, _a = host.optionsToExtend, optionsToExtendForConfigFile = _a === void 0 ? {} : _a, createProgram = host.createProgram;
	        var rootFileNames = host.rootFiles, compilerOptions = host.options, configFileSpecs = host.configFileSpecs, configFileWildCardDirectories = host.configFileWildCardDirectories;
	        var cachedDirectoryStructureHost = configFileName && ts.createCachedDirectoryStructureHost(host, currentDirectory, useCaseSensitiveFileNames);
	        if (cachedDirectoryStructureHost && host.onCachedDirectoryStructureHostCreate) {
	            host.onCachedDirectoryStructureHostCreate(cachedDirectoryStructureHost);
	        }
	        var directoryStructureHost = cachedDirectoryStructureHost || host;
	        var parseConfigFileHost = {
	            useCaseSensitiveFileNames: useCaseSensitiveFileNames,
	            readDirectory: function (path, extensions, exclude, include, depth) { return directoryStructureHost.readDirectory(path, extensions, exclude, include, depth); },
	            fileExists: function (path) { return host.fileExists(path); },
	            readFile: readFile,
	            getCurrentDirectory: getCurrentDirectory,
	            onConfigFileDiagnostic: host.onConfigFileDiagnostic,
	            onUnRecoverableConfigFileDiagnostic: host.onUnRecoverableConfigFileDiagnostic
	        };
	        // From tsc we want to get already parsed result and hence check for rootFileNames
	        if (configFileName && !rootFileNames) {
	            parseConfigFile();
	        }
	        var trace = host.trace && (function (s) { host.trace(s + newLine); });
	        var loggingEnabled = trace && (compilerOptions.diagnostics || compilerOptions.extendedDiagnostics);
	        var writeLog = loggingEnabled ? trace : ts.noop;
	        var watchFile = compilerOptions.extendedDiagnostics ? ts.addFileWatcherWithLogging : loggingEnabled ? ts.addFileWatcherWithOnlyTriggerLogging : ts.addFileWatcher;
	        var watchFilePath = compilerOptions.extendedDiagnostics ? ts.addFilePathWatcherWithLogging : ts.addFilePathWatcher;
	        var watchDirectoryWorker = compilerOptions.extendedDiagnostics ? ts.addDirectoryWatcherWithLogging : ts.addDirectoryWatcher;
	        var getCanonicalFileName = ts.createGetCanonicalFileName(useCaseSensitiveFileNames);
	        var newLine = updateNewLine();
	        writeLog("Current directory: " + currentDirectory + " CaseSensitiveFileNames: " + useCaseSensitiveFileNames);
	        if (configFileName) {
	            watchFile(host, configFileName, scheduleProgramReload, writeLog);
	        }
	        var compilerHost = {
	            // Members for CompilerHost
	            getSourceFile: function (fileName, languageVersion, onError, shouldCreateNewSourceFile) { return getVersionedSourceFileByPath(fileName, toPath(fileName), languageVersion, onError, shouldCreateNewSourceFile); },
	            getSourceFileByPath: getVersionedSourceFileByPath,
	            getDefaultLibLocation: host.getDefaultLibLocation && (function () { return host.getDefaultLibLocation(); }),
	            getDefaultLibFileName: function (options) { return host.getDefaultLibFileName(options); },
	            writeFile: writeFile,
	            getCurrentDirectory: getCurrentDirectory,
	            useCaseSensitiveFileNames: function () { return useCaseSensitiveFileNames; },
	            getCanonicalFileName: getCanonicalFileName,
	            getNewLine: function () { return newLine; },
	            fileExists: fileExists,
	            readFile: readFile,
	            trace: trace,
	            directoryExists: directoryStructureHost.directoryExists && (function (path) { return directoryStructureHost.directoryExists(path); }),
	            getDirectories: directoryStructureHost.getDirectories && (function (path) { return directoryStructureHost.getDirectories(path); }),
	            realpath: host.realpath && (function (s) { return host.realpath(s); }),
	            getEnvironmentVariable: host.getEnvironmentVariable ? (function (name) { return host.getEnvironmentVariable(name); }) : (function () { return ""; }),
	            onReleaseOldSourceFile: onReleaseOldSourceFile,
	            createHash: host.createHash && (function (data) { return host.createHash(data); }),
	            // Members for ResolutionCacheHost
	            toPath: toPath,
	            getCompilationSettings: function () { return compilerOptions; },
	            watchDirectoryOfFailedLookupLocation: watchDirectory,
	            watchTypeRootsDirectory: watchDirectory,
	            getCachedDirectoryStructureHost: function () { return cachedDirectoryStructureHost; },
	            onInvalidatedResolution: scheduleProgramUpdate,
	            onChangedAutomaticTypeDirectiveNames: function () {
	                hasChangedAutomaticTypeDirectiveNames = true;
	                scheduleProgramUpdate();
	            },
	            maxNumberOfFilesToIterateForInvalidation: host.maxNumberOfFilesToIterateForInvalidation,
	            getCurrentProgram: getCurrentProgram,
	            writeLog: writeLog
	        };
	        // Cache for the module resolution
	        var resolutionCache = ts.createResolutionCache(compilerHost, configFileName ?
	            ts.getDirectoryPath(ts.getNormalizedAbsolutePath(configFileName, currentDirectory)) :
	            currentDirectory, 
	        /*logChangesWhenResolvingModule*/ false);
	        // Resolve module using host module resolution strategy if provided otherwise use resolution cache to resolve module names
	        compilerHost.resolveModuleNames = host.resolveModuleNames ?
	            (function (moduleNames, containingFile, reusedNames) { return host.resolveModuleNames(moduleNames, containingFile, reusedNames); }) :
	            (function (moduleNames, containingFile, reusedNames) { return resolutionCache.resolveModuleNames(moduleNames, containingFile, reusedNames); });
	        compilerHost.resolveTypeReferenceDirectives = host.resolveTypeReferenceDirectives ?
	            (function (typeDirectiveNames, containingFile) { return host.resolveTypeReferenceDirectives(typeDirectiveNames, containingFile); }) :
	            (function (typeDirectiveNames, containingFile) { return resolutionCache.resolveTypeReferenceDirectives(typeDirectiveNames, containingFile); });
	        var userProvidedResolution = !!host.resolveModuleNames || !!host.resolveTypeReferenceDirectives;
	        reportWatchDiagnostic(ts.Diagnostics.Starting_compilation_in_watch_mode);
	        synchronizeProgram();
	        // Update the wild card directory watch
	        watchConfigFileWildCardDirectories();
	        return configFileName ?
	            { getCurrentProgram: getCurrentBuilderProgram, getProgram: synchronizeProgram } :
	            { getCurrentProgram: getCurrentBuilderProgram, getProgram: synchronizeProgram, updateRootFileNames: updateRootFileNames };
	        function getCurrentBuilderProgram() {
	            return builderProgram;
	        }
	        function getCurrentProgram() {
	            return builderProgram && builderProgram.getProgram();
	        }
	        function synchronizeProgram() {
	            writeLog("Synchronizing program");
	            var program = getCurrentProgram();
	            if (hasChangedCompilerOptions) {
	                newLine = updateNewLine();
	                if (program && ts.changesAffectModuleResolution(program.getCompilerOptions(), compilerOptions)) {
	                    resolutionCache.clear();
	                }
	            }
	            // All resolutions are invalid if user provided resolutions
	            var hasInvalidatedResolution = resolutionCache.createHasInvalidatedResolution(userProvidedResolution);
	            if (ts.isProgramUptoDate(getCurrentProgram(), rootFileNames, compilerOptions, getSourceVersion, fileExists, hasInvalidatedResolution, hasChangedAutomaticTypeDirectiveNames)) {
	                return builderProgram;
	            }
	            // Compile the program
	            if (loggingEnabled) {
	                writeLog("CreatingProgramWith::");
	                writeLog("  roots: " + JSON.stringify(rootFileNames));
	                writeLog("  options: " + JSON.stringify(compilerOptions));
	            }
	            var needsUpdateInTypeRootWatch = hasChangedCompilerOptions || !program;
	            hasChangedCompilerOptions = false;
	            resolutionCache.startCachingPerDirectoryResolution();
	            compilerHost.hasInvalidatedResolution = hasInvalidatedResolution;
	            compilerHost.hasChangedAutomaticTypeDirectiveNames = hasChangedAutomaticTypeDirectiveNames;
	            builderProgram = createProgram(rootFileNames, compilerOptions, compilerHost, builderProgram);
	            resolutionCache.finishCachingPerDirectoryResolution();
	            // Update watches
	            ts.updateMissingFilePathsWatch(builderProgram.getProgram(), missingFilesMap || (missingFilesMap = ts.createMap()), watchMissingFilePath);
	            if (needsUpdateInTypeRootWatch) {
	                resolutionCache.updateTypeRootsWatch();
	            }
	            if (missingFilePathsRequestedForRelease) {
	                // These are the paths that program creater told us as not in use any more but were missing on the disk.
	                // We didnt remove the entry for them from sourceFiles cache so that we dont have to do File IO,
	                // if there is already watcher for it (for missing files)
	                // At this point our watches were updated, hence now we know that these paths are not tracked and need to be removed
	                // so that at later time we have correct result of their presence
	                for (var _i = 0, missingFilePathsRequestedForRelease_1 = missingFilePathsRequestedForRelease; _i < missingFilePathsRequestedForRelease_1.length; _i++) {
	                    var missingFilePath = missingFilePathsRequestedForRelease_1[_i];
	                    if (!missingFilesMap.has(missingFilePath)) {
	                        sourceFilesCache.delete(missingFilePath);
	                    }
	                }
	                missingFilePathsRequestedForRelease = undefined;
	            }
	            if (host.afterProgramCreate) {
	                host.afterProgramCreate(builderProgram);
	            }
	            reportWatchDiagnostic(ts.Diagnostics.Compilation_complete_Watching_for_file_changes);
	            return builderProgram;
	        }
	        function updateRootFileNames(files) {
	            ts.Debug.assert(!configFileName, "Cannot update root file names with config file watch mode");
	            rootFileNames = files;
	            scheduleProgramUpdate();
	        }
	        function updateNewLine() {
	            return ts.getNewLineCharacter(compilerOptions, function () { return host.getNewLine(); });
	        }
	        function toPath(fileName) {
	            return ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	        }
	        function isFileMissingOnHost(hostSourceFile) {
	            return typeof hostSourceFile === "number";
	        }
	        function isFilePresentOnHost(hostSourceFile) {
	            return !!hostSourceFile.sourceFile;
	        }
	        function fileExists(fileName) {
	            var path = toPath(fileName);
	            // If file is missing on host from cache, we can definitely say file doesnt exist
	            // otherwise we need to ensure from the disk
	            if (isFileMissingOnHost(sourceFilesCache.get(path))) {
	                return true;
	            }
	            return directoryStructureHost.fileExists(fileName);
	        }
	        function getVersionedSourceFileByPath(fileName, path, languageVersion, onError, shouldCreateNewSourceFile) {
	            var hostSourceFile = sourceFilesCache.get(path);
	            // No source file on the host
	            if (isFileMissingOnHost(hostSourceFile)) {
	                return undefined;
	            }
	            // Create new source file if requested or the versions dont match
	            if (!hostSourceFile || shouldCreateNewSourceFile || !isFilePresentOnHost(hostSourceFile) || hostSourceFile.version.toString() !== hostSourceFile.sourceFile.version) {
	                var sourceFile = getNewSourceFile();
	                if (hostSourceFile) {
	                    if (shouldCreateNewSourceFile) {
	                        hostSourceFile.version++;
	                    }
	                    if (sourceFile) {
	                        // Set the source file and create file watcher now that file was present on the disk
	                        hostSourceFile.sourceFile = sourceFile;
	                        sourceFile.version = hostSourceFile.version.toString();
	                        if (!hostSourceFile.fileWatcher) {
	                            hostSourceFile.fileWatcher = watchFilePath(host, fileName, onSourceFileChange, path, writeLog);
	                        }
	                    }
	                    else {
	                        // There is no source file on host any more, close the watch, missing file paths will track it
	                        if (isFilePresentOnHost(hostSourceFile)) {
	                            hostSourceFile.fileWatcher.close();
	                        }
	                        sourceFilesCache.set(path, hostSourceFile.version);
	                    }
	                }
	                else {
	                    if (sourceFile) {
	                        sourceFile.version = initialVersion.toString();
	                        var fileWatcher = watchFilePath(host, fileName, onSourceFileChange, path, writeLog);
	                        sourceFilesCache.set(path, { sourceFile: sourceFile, version: initialVersion, fileWatcher: fileWatcher });
	                    }
	                    else {
	                        sourceFilesCache.set(path, initialVersion);
	                    }
	                }
	                return sourceFile;
	            }
	            return hostSourceFile.sourceFile;
	            function getNewSourceFile() {
	                var text;
	                try {
	                    ts.performance.mark("beforeIORead");
	                    text = host.readFile(fileName, compilerOptions.charset);
	                    ts.performance.mark("afterIORead");
	                    ts.performance.measure("I/O Read", "beforeIORead", "afterIORead");
	                }
	                catch (e) {
	                    if (onError) {
	                        onError(e.message);
	                    }
	                }
	                return text !== undefined ? ts.createSourceFile(fileName, text, languageVersion) : undefined;
	            }
	        }
	        function nextSourceFileVersion(path) {
	            var hostSourceFile = sourceFilesCache.get(path);
	            if (hostSourceFile !== undefined) {
	                if (isFileMissingOnHost(hostSourceFile)) {
	                    // The next version, lets set it as presence unknown file
	                    sourceFilesCache.set(path, { version: Number(hostSourceFile) + 1 });
	                }
	                else {
	                    hostSourceFile.version++;
	                }
	            }
	        }
	        function getSourceVersion(path) {
	            var hostSourceFile = sourceFilesCache.get(path);
	            return !hostSourceFile || isFileMissingOnHost(hostSourceFile) ? undefined : hostSourceFile.version.toString();
	        }
	        function onReleaseOldSourceFile(oldSourceFile, _oldOptions) {
	            var hostSourceFileInfo = sourceFilesCache.get(oldSourceFile.path);
	            // If this is the source file thats in the cache and new program doesnt need it,
	            // remove the cached entry.
	            // Note we arent deleting entry if file became missing in new program or
	            // there was version update and new source file was created.
	            if (hostSourceFileInfo) {
	                // record the missing file paths so they can be removed later if watchers arent tracking them
	                if (isFileMissingOnHost(hostSourceFileInfo)) {
	                    (missingFilePathsRequestedForRelease || (missingFilePathsRequestedForRelease = [])).push(oldSourceFile.path);
	                }
	                else if (hostSourceFileInfo.sourceFile === oldSourceFile) {
	                    if (hostSourceFileInfo.fileWatcher) {
	                        hostSourceFileInfo.fileWatcher.close();
	                    }
	                    sourceFilesCache.delete(oldSourceFile.path);
	                    resolutionCache.removeResolutionsOfFile(oldSourceFile.path);
	                }
	            }
	        }
	        function reportWatchDiagnostic(message) {
	            if (host.onWatchStatusChange) {
	                host.onWatchStatusChange(ts.createCompilerDiagnostic(message), newLine, compilerOptions);
	            }
	        }
	        // Upon detecting a file change, wait for 250ms and then perform a recompilation. This gives batch
	        // operations (such as saving all modified files in an editor) a chance to complete before we kick
	        // off a new compilation.
	        function scheduleProgramUpdate() {
	            if (!host.setTimeout || !host.clearTimeout) {
	                return;
	            }
	            if (timerToUpdateProgram) {
	                host.clearTimeout(timerToUpdateProgram);
	            }
	            timerToUpdateProgram = host.setTimeout(updateProgram, 250);
	        }
	        function scheduleProgramReload() {
	            ts.Debug.assert(!!configFileName);
	            reloadLevel = ts.ConfigFileProgramReloadLevel.Full;
	            scheduleProgramUpdate();
	        }
	        function updateProgram() {
	            timerToUpdateProgram = undefined;
	            reportWatchDiagnostic(ts.Diagnostics.File_change_detected_Starting_incremental_compilation);
	            switch (reloadLevel) {
	                case ts.ConfigFileProgramReloadLevel.Partial:
	                    return reloadFileNamesFromConfigFile();
	                case ts.ConfigFileProgramReloadLevel.Full:
	                    return reloadConfigFile();
	                default:
	                    synchronizeProgram();
	                    return;
	            }
	        }
	        function reloadFileNamesFromConfigFile() {
	            var result = ts.getFileNamesFromConfigSpecs(configFileSpecs, ts.getDirectoryPath(configFileName), compilerOptions, parseConfigFileHost);
	            if (!configFileSpecs.filesSpecs && result.fileNames.length === 0) {
	                host.onConfigFileDiagnostic(ts.getErrorForNoInputFiles(configFileSpecs, configFileName));
	            }
	            rootFileNames = result.fileNames;
	            // Update the program
	            synchronizeProgram();
	        }
	        function reloadConfigFile() {
	            writeLog("Reloading config file: " + configFileName);
	            reloadLevel = ts.ConfigFileProgramReloadLevel.None;
	            if (cachedDirectoryStructureHost) {
	                cachedDirectoryStructureHost.clearCache();
	            }
	            parseConfigFile();
	            hasChangedCompilerOptions = true;
	            synchronizeProgram();
	            // Update the wild card directory watch
	            watchConfigFileWildCardDirectories();
	        }
	        function parseConfigFile() {
	            var configParseResult = ts.getParsedCommandLineOfConfigFile(configFileName, optionsToExtendForConfigFile, parseConfigFileHost);
	            rootFileNames = configParseResult.fileNames;
	            compilerOptions = configParseResult.options;
	            configFileSpecs = configParseResult.configFileSpecs;
	            configFileWildCardDirectories = configParseResult.wildcardDirectories;
	        }
	        function onSourceFileChange(fileName, eventKind, path) {
	            updateCachedSystemWithFile(fileName, path, eventKind);
	            // Update the source file cache
	            if (eventKind === ts.FileWatcherEventKind.Deleted && sourceFilesCache.get(path)) {
	                resolutionCache.invalidateResolutionOfFile(path);
	            }
	            nextSourceFileVersion(path);
	            // Update the program
	            scheduleProgramUpdate();
	        }
	        function updateCachedSystemWithFile(fileName, path, eventKind) {
	            if (cachedDirectoryStructureHost) {
	                cachedDirectoryStructureHost.addOrDeleteFile(fileName, path, eventKind);
	            }
	        }
	        function watchDirectory(directory, cb, flags) {
	            return watchDirectoryWorker(host, directory, cb, flags, writeLog);
	        }
	        function watchMissingFilePath(missingFilePath) {
	            return watchFilePath(host, missingFilePath, onMissingFileChange, missingFilePath, writeLog);
	        }
	        function onMissingFileChange(fileName, eventKind, missingFilePath) {
	            updateCachedSystemWithFile(fileName, missingFilePath, eventKind);
	            if (eventKind === ts.FileWatcherEventKind.Created && missingFilesMap.has(missingFilePath)) {
	                missingFilesMap.get(missingFilePath).close();
	                missingFilesMap.delete(missingFilePath);
	                // Delete the entry in the source files cache so that new source file is created
	                nextSourceFileVersion(missingFilePath);
	                // When a missing file is created, we should update the graph.
	                scheduleProgramUpdate();
	            }
	        }
	        function watchConfigFileWildCardDirectories() {
	            if (configFileWildCardDirectories) {
	                ts.updateWatchingWildcardDirectories(watchedWildcardDirectories || (watchedWildcardDirectories = ts.createMap()), ts.createMapFromTemplate(configFileWildCardDirectories), watchWildcardDirectory);
	            }
	            else if (watchedWildcardDirectories) {
	                ts.clearMap(watchedWildcardDirectories, ts.closeFileWatcherOf);
	            }
	        }
	        function watchWildcardDirectory(directory, flags) {
	            return watchDirectory(directory, function (fileOrDirectory) {
	                ts.Debug.assert(!!configFileName);
	                var fileOrDirectoryPath = toPath(fileOrDirectory);
	                // Since the file existance changed, update the sourceFiles cache
	                if (cachedDirectoryStructureHost) {
	                    cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
	                }
	                nextSourceFileVersion(fileOrDirectoryPath);
	                // If the the added or created file or directory is not supported file name, ignore the file
	                // But when watched directory is added/removed, we need to reload the file list
	                if (fileOrDirectoryPath !== directory && ts.hasExtension(fileOrDirectoryPath) && !ts.isSupportedSourceFileName(fileOrDirectory, compilerOptions)) {
	                    writeLog("Project: " + configFileName + " Detected file add/remove of non supported extension: " + fileOrDirectory);
	                    return;
	                }
	                // Reload is pending, do the reload
	                if (reloadLevel !== ts.ConfigFileProgramReloadLevel.Full) {
	                    reloadLevel = ts.ConfigFileProgramReloadLevel.Partial;
	                    // Schedule Update the program
	                    scheduleProgramUpdate();
	                }
	            }, flags);
	        }
	        function ensureDirectoriesExist(directoryPath) {
	            if (directoryPath.length > ts.getRootLength(directoryPath) && !host.directoryExists(directoryPath)) {
	                var parentDirectory = ts.getDirectoryPath(directoryPath);
	                ensureDirectoriesExist(parentDirectory);
	                host.createDirectory(directoryPath);
	            }
	        }
	        function writeFile(fileName, text, writeByteOrderMark, onError) {
	            try {
	                ts.performance.mark("beforeIOWrite");
	                ensureDirectoriesExist(ts.getDirectoryPath(ts.normalizePath(fileName)));
	                host.writeFile(fileName, text, writeByteOrderMark);
	                ts.performance.mark("afterIOWrite");
	                ts.performance.measure("I/O Write", "beforeIOWrite", "afterIOWrite");
	            }
	            catch (e) {
	                if (onError) {
	                    onError(e.message);
	                }
	            }
	        }
	    }
	    ts.createWatchProgram = createWatchProgram;
	})(ts || (ts = {}));
	/// <reference path="sys.ts"/>
	/// <reference path="types.ts"/>
	/// <reference path="core.ts"/>
	/// <reference path="diagnosticInformationMap.generated.ts"/>
	/// <reference path="parser.ts"/>
	var ts;
	(function (ts) {
	    /* @internal */
	    ts.compileOnSaveCommandLineOption = { name: "compileOnSave", type: "boolean" };
	    /* @internal */
	    ts.optionDeclarations = [
	        // CommandLine only options
	        {
	            name: "help",
	            shortName: "h",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Print_this_message,
	        },
	        {
	            name: "help",
	            shortName: "?",
	            type: "boolean"
	        },
	        {
	            name: "all",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Show_all_compiler_options,
	        },
	        {
	            name: "version",
	            shortName: "v",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Print_the_compiler_s_version,
	        },
	        {
	            name: "init",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file,
	        },
	        {
	            name: "project",
	            shortName: "p",
	            type: "string",
	            isFilePath: true,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            paramType: ts.Diagnostics.FILE_OR_DIRECTORY,
	            description: ts.Diagnostics.Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json,
	        },
	        {
	            name: "pretty",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Stylize_errors_and_messages_using_color_and_context_experimental
	        },
	        {
	            name: "watch",
	            shortName: "w",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Watch_input_files,
	        },
	        // Basic
	        {
	            name: "target",
	            shortName: "t",
	            type: ts.createMapFromTemplate({
	                es3: 0 /* ES3 */,
	                es5: 1 /* ES5 */,
	                es6: 2 /* ES2015 */,
	                es2015: 2 /* ES2015 */,
	                es2016: 3 /* ES2016 */,
	                es2017: 4 /* ES2017 */,
	                es2018: 5 /* ES2018 */,
	                esnext: 6 /* ESNext */,
	            }),
	            paramType: ts.Diagnostics.VERSION,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_ECMAScript_target_version_Colon_ES3_default_ES5_ES2015_ES2016_ES2017_ES2018_or_ESNEXT,
	        },
	        {
	            name: "module",
	            shortName: "m",
	            type: ts.createMapFromTemplate({
	                none: ts.ModuleKind.None,
	                commonjs: ts.ModuleKind.CommonJS,
	                amd: ts.ModuleKind.AMD,
	                system: ts.ModuleKind.System,
	                umd: ts.ModuleKind.UMD,
	                es6: ts.ModuleKind.ES2015,
	                es2015: ts.ModuleKind.ES2015,
	                esnext: ts.ModuleKind.ESNext
	            }),
	            paramType: ts.Diagnostics.KIND,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_module_code_generation_Colon_none_commonjs_amd_system_umd_es2015_or_ESNext,
	        },
	        {
	            name: "lib",
	            type: "list",
	            element: {
	                name: "lib",
	                type: ts.createMapFromTemplate({
	                    // JavaScript only
	                    "es5": "lib.es5.d.ts",
	                    "es6": "lib.es2015.d.ts",
	                    "es2015": "lib.es2015.d.ts",
	                    "es7": "lib.es2016.d.ts",
	                    "es2016": "lib.es2016.d.ts",
	                    "es2017": "lib.es2017.d.ts",
	                    "es2018": "lib.es2018.d.ts",
	                    "esnext": "lib.esnext.d.ts",
	                    // Host only
	                    "dom": "lib.dom.d.ts",
	                    "dom.iterable": "lib.dom.iterable.d.ts",
	                    "webworker": "lib.webworker.d.ts",
	                    "scripthost": "lib.scripthost.d.ts",
	                    // ES2015 Or ESNext By-feature options
	                    "es2015.core": "lib.es2015.core.d.ts",
	                    "es2015.collection": "lib.es2015.collection.d.ts",
	                    "es2015.generator": "lib.es2015.generator.d.ts",
	                    "es2015.iterable": "lib.es2015.iterable.d.ts",
	                    "es2015.promise": "lib.es2015.promise.d.ts",
	                    "es2015.proxy": "lib.es2015.proxy.d.ts",
	                    "es2015.reflect": "lib.es2015.reflect.d.ts",
	                    "es2015.symbol": "lib.es2015.symbol.d.ts",
	                    "es2015.symbol.wellknown": "lib.es2015.symbol.wellknown.d.ts",
	                    "es2016.array.include": "lib.es2016.array.include.d.ts",
	                    "es2017.object": "lib.es2017.object.d.ts",
	                    "es2017.sharedmemory": "lib.es2017.sharedmemory.d.ts",
	                    "es2017.string": "lib.es2017.string.d.ts",
	                    "es2017.intl": "lib.es2017.intl.d.ts",
	                    "es2017.typedarrays": "lib.es2017.typedarrays.d.ts",
	                    "esnext.array": "lib.esnext.array.d.ts",
	                    "esnext.asynciterable": "lib.esnext.asynciterable.d.ts",
	                    "esnext.promise": "lib.esnext.promise.d.ts",
	                }),
	            },
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_library_files_to_be_included_in_the_compilation
	        },
	        {
	            name: "allowJs",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Allow_javascript_files_to_be_compiled
	        },
	        {
	            name: "checkJs",
	            type: "boolean",
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Report_errors_in_js_files
	        },
	        {
	            name: "jsx",
	            type: ts.createMapFromTemplate({
	                "preserve": 1 /* Preserve */,
	                "react-native": 3 /* ReactNative */,
	                "react": 2 /* React */
	            }),
	            paramType: ts.Diagnostics.KIND,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_JSX_code_generation_Colon_preserve_react_native_or_react,
	        },
	        {
	            name: "declaration",
	            shortName: "d",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Generates_corresponding_d_ts_file,
	        },
	        {
	            name: "emitDeclarationOnly",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Only_emit_d_ts_declaration_files,
	        },
	        {
	            name: "sourceMap",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Generates_corresponding_map_file,
	        },
	        {
	            name: "outFile",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.FILE,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Concatenate_and_emit_output_to_single_file,
	        },
	        {
	            name: "outDir",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.DIRECTORY,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Redirect_output_structure_to_the_directory,
	        },
	        {
	            name: "rootDir",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.LOCATION,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir,
	        },
	        {
	            name: "removeComments",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Do_not_emit_comments_to_output,
	        },
	        {
	            name: "noEmit",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Do_not_emit_outputs,
	        },
	        {
	            name: "importHelpers",
	            type: "boolean",
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Import_emit_helpers_from_tslib
	        },
	        {
	            name: "downlevelIteration",
	            type: "boolean",
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_or_ES3
	        },
	        {
	            name: "isolatedModules",
	            type: "boolean",
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule
	        },
	        // Strict Type Checks
	        {
	            name: "strict",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Enable_all_strict_type_checking_options
	        },
	        {
	            name: "noImplicitAny",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Raise_error_on_expressions_and_declarations_with_an_implied_any_type,
	        },
	        {
	            name: "strictNullChecks",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Enable_strict_null_checks
	        },
	        {
	            name: "strictFunctionTypes",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Enable_strict_checking_of_function_types
	        },
	        {
	            name: "strictPropertyInitialization",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Enable_strict_checking_of_property_initialization_in_classes
	        },
	        {
	            name: "noImplicitThis",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Raise_error_on_this_expressions_with_an_implied_any_type,
	        },
	        {
	            name: "alwaysStrict",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Parse_in_strict_mode_and_emit_use_strict_for_each_source_file
	        },
	        // Additional Checks
	        {
	            name: "noUnusedLocals",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Additional_Checks,
	            description: ts.Diagnostics.Report_errors_on_unused_locals,
	        },
	        {
	            name: "noUnusedParameters",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Additional_Checks,
	            description: ts.Diagnostics.Report_errors_on_unused_parameters,
	        },
	        {
	            name: "noImplicitReturns",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Additional_Checks,
	            description: ts.Diagnostics.Report_error_when_not_all_code_paths_in_function_return_a_value
	        },
	        {
	            name: "noFallthroughCasesInSwitch",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Additional_Checks,
	            description: ts.Diagnostics.Report_errors_for_fallthrough_cases_in_switch_statement
	        },
	        // Module Resolution
	        {
	            name: "moduleResolution",
	            type: ts.createMapFromTemplate({
	                node: ts.ModuleResolutionKind.NodeJs,
	                classic: ts.ModuleResolutionKind.Classic,
	            }),
	            paramType: ts.Diagnostics.STRATEGY,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Specify_module_resolution_strategy_Colon_node_Node_js_or_classic_TypeScript_pre_1_6,
	        },
	        {
	            name: "baseUrl",
	            type: "string",
	            isFilePath: true,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Base_directory_to_resolve_non_absolute_module_names
	        },
	        {
	            // this option can only be specified in tsconfig.json
	            // use type = object to copy the value as-is
	            name: "paths",
	            type: "object",
	            isTSConfigOnly: true,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl
	        },
	        {
	            // this option can only be specified in tsconfig.json
	            // use type = object to copy the value as-is
	            name: "rootDirs",
	            type: "list",
	            isTSConfigOnly: true,
	            element: {
	                name: "rootDirs",
	                type: "string",
	                isFilePath: true
	            },
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime
	        },
	        {
	            name: "typeRoots",
	            type: "list",
	            element: {
	                name: "typeRoots",
	                type: "string",
	                isFilePath: true
	            },
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.List_of_folders_to_include_type_definitions_from
	        },
	        {
	            name: "types",
	            type: "list",
	            element: {
	                name: "types",
	                type: "string"
	            },
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Type_declaration_files_to_be_included_in_compilation
	        },
	        {
	            name: "allowSyntheticDefaultImports",
	            type: "boolean",
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typechecking
	        },
	        {
	            name: "esModuleInterop",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for_all_imports_Implies_allowSyntheticDefaultImports
	        },
	        {
	            name: "preserveSymlinks",
	            type: "boolean",
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Do_not_resolve_the_real_path_of_symlinks,
	        },
	        // Source Maps
	        {
	            name: "sourceRoot",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.LOCATION,
	            category: ts.Diagnostics.Source_Map_Options,
	            description: ts.Diagnostics.Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations,
	        },
	        {
	            name: "mapRoot",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.LOCATION,
	            category: ts.Diagnostics.Source_Map_Options,
	            description: ts.Diagnostics.Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations,
	        },
	        {
	            name: "inlineSourceMap",
	            type: "boolean",
	            category: ts.Diagnostics.Source_Map_Options,
	            description: ts.Diagnostics.Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file
	        },
	        {
	            name: "inlineSources",
	            type: "boolean",
	            category: ts.Diagnostics.Source_Map_Options,
	            description: ts.Diagnostics.Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap_to_be_set
	        },
	        // Experimental
	        {
	            name: "experimentalDecorators",
	            type: "boolean",
	            category: ts.Diagnostics.Experimental_Options,
	            description: ts.Diagnostics.Enables_experimental_support_for_ES7_decorators
	        },
	        {
	            name: "emitDecoratorMetadata",
	            type: "boolean",
	            category: ts.Diagnostics.Experimental_Options,
	            description: ts.Diagnostics.Enables_experimental_support_for_emitting_type_metadata_for_decorators
	        },
	        // Advanced
	        {
	            name: "jsxFactory",
	            type: "string",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h
	        },
	        {
	            name: "diagnostics",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Show_diagnostic_information
	        },
	        {
	            name: "extendedDiagnostics",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Show_verbose_diagnostic_information
	        },
	        {
	            name: "traceResolution",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Enable_tracing_of_the_name_resolution_process
	        },
	        {
	            name: "listFiles",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Print_names_of_files_part_of_the_compilation
	        },
	        {
	            name: "listEmittedFiles",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Print_names_of_generated_files_part_of_the_compilation
	        },
	        {
	            name: "out",
	            type: "string",
	            isFilePath: false,
	            // for correct behaviour, please use outFile
	            category: ts.Diagnostics.Advanced_Options,
	            paramType: ts.Diagnostics.FILE,
	            description: ts.Diagnostics.Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file,
	        },
	        {
	            name: "reactNamespace",
	            type: "string",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react_JSX_emit
	        },
	        {
	            name: "skipDefaultLibCheck",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files
	        },
	        {
	            name: "charset",
	            type: "string",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.The_character_set_of_the_input_files
	        },
	        {
	            name: "emitBOM",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files
	        },
	        {
	            name: "locale",
	            type: "string",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.The_locale_used_when_displaying_messages_to_the_user_e_g_en_us
	        },
	        {
	            name: "newLine",
	            type: ts.createMapFromTemplate({
	                crlf: 0 /* CarriageReturnLineFeed */,
	                lf: 1 /* LineFeed */
	            }),
	            paramType: ts.Diagnostics.NEWLINE,
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix,
	        },
	        {
	            name: "noErrorTruncation",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_truncate_error_messages
	        },
	        {
	            name: "noLib",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_include_the_default_library_file_lib_d_ts
	        },
	        {
	            name: "noResolve",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files
	        },
	        {
	            name: "stripInternal",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_emit_declarations_for_code_that_has_an_internal_annotation,
	        },
	        {
	            name: "disableSizeLimit",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Disable_size_limitations_on_JavaScript_projects
	        },
	        {
	            name: "noImplicitUseStrict",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_emit_use_strict_directives_in_module_output
	        },
	        {
	            name: "noEmitHelpers",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_generate_custom_helper_functions_like_extends_in_compiled_output
	        },
	        {
	            name: "noEmitOnError",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_emit_outputs_if_any_errors_were_reported,
	        },
	        {
	            name: "preserveConstEnums",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_erase_const_enum_declarations_in_generated_code
	        },
	        {
	            name: "declarationDir",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.DIRECTORY,
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Output_directory_for_generated_declaration_files
	        },
	        {
	            name: "skipLibCheck",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Skip_type_checking_of_declaration_files,
	        },
	        {
	            name: "allowUnusedLabels",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_report_errors_on_unused_labels
	        },
	        {
	            name: "allowUnreachableCode",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_report_errors_on_unreachable_code
	        },
	        {
	            name: "suppressExcessPropertyErrors",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Suppress_excess_property_checks_for_object_literals,
	        },
	        {
	            name: "suppressImplicitAnyIndexErrors",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures,
	        },
	        {
	            name: "forceConsistentCasingInFileNames",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Disallow_inconsistently_cased_references_to_the_same_file
	        },
	        {
	            name: "maxNodeModuleJsDepth",
	            type: "number",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files
	        },
	        {
	            name: "noStrictGenericChecks",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Disable_strict_checking_of_generic_signatures_in_function_types,
	        },
	        {
	            // A list of plugins to load in the language service
	            name: "plugins",
	            type: "list",
	            isTSConfigOnly: true,
	            element: {
	                name: "plugin",
	                type: "object"
	            },
	            description: ts.Diagnostics.List_of_language_service_plugins
	        }
	    ];
	    /* @internal */
	    ts.typeAcquisitionDeclarations = [
	        {
	            /* @deprecated typingOptions.enableAutoDiscovery
	             * Use typeAcquisition.enable instead.
	             */
	            name: "enableAutoDiscovery",
	            type: "boolean",
	        },
	        {
	            name: "enable",
	            type: "boolean",
	        },
	        {
	            name: "include",
	            type: "list",
	            element: {
	                name: "include",
	                type: "string"
	            }
	        },
	        {
	            name: "exclude",
	            type: "list",
	            element: {
	                name: "exclude",
	                type: "string"
	            }
	        }
	    ];
	    /* @internal */
	    ts.defaultInitCompilerOptions = {
	        module: ts.ModuleKind.CommonJS,
	        target: 1 /* ES5 */,
	        strict: true,
	        esModuleInterop: true
	    };
	    var optionNameMapCache;
	    /* @internal */
	    function convertEnableAutoDiscoveryToEnable(typeAcquisition) {
	        // Convert deprecated typingOptions.enableAutoDiscovery to typeAcquisition.enable
	        if (typeAcquisition && typeAcquisition.enableAutoDiscovery !== undefined && typeAcquisition.enable === undefined) {
	            return {
	                enable: typeAcquisition.enableAutoDiscovery,
	                include: typeAcquisition.include || [],
	                exclude: typeAcquisition.exclude || []
	            };
	        }
	        return typeAcquisition;
	    }
	    ts.convertEnableAutoDiscoveryToEnable = convertEnableAutoDiscoveryToEnable;
	    function getOptionNameMap() {
	        if (optionNameMapCache) {
	            return optionNameMapCache;
	        }
	        var optionNameMap = ts.createMap();
	        var shortOptionNames = ts.createMap();
	        ts.forEach(ts.optionDeclarations, function (option) {
	            optionNameMap.set(option.name.toLowerCase(), option);
	            if (option.shortName) {
	                shortOptionNames.set(option.shortName, option.name);
	            }
	        });
	        optionNameMapCache = { optionNameMap: optionNameMap, shortOptionNames: shortOptionNames };
	        return optionNameMapCache;
	    }
	    /* @internal */
	    function createCompilerDiagnosticForInvalidCustomType(opt) {
	        return createDiagnosticForInvalidCustomType(opt, ts.createCompilerDiagnostic);
	    }
	    ts.createCompilerDiagnosticForInvalidCustomType = createCompilerDiagnosticForInvalidCustomType;
	    function createDiagnosticForInvalidCustomType(opt, createDiagnostic) {
	        var namesOfType = ts.arrayFrom(opt.type.keys()).map(function (key) { return "'" + key + "'"; }).join(", ");
	        return createDiagnostic(ts.Diagnostics.Argument_for_0_option_must_be_Colon_1, "--" + opt.name, namesOfType);
	    }
	    /* @internal */
	    function parseCustomTypeOption(opt, value, errors) {
	        return convertJsonOptionOfCustomType(opt, trimString(value || ""), errors);
	    }
	    ts.parseCustomTypeOption = parseCustomTypeOption;
	    /* @internal */
	    function parseListTypeOption(opt, value, errors) {
	        if (value === void 0) { value = ""; }
	        value = trimString(value);
	        if (ts.startsWith(value, "-")) {
	            return undefined;
	        }
	        if (value === "") {
	            return [];
	        }
	        var values = value.split(",");
	        switch (opt.element.type) {
	            case "number":
	                return ts.map(values, parseInt);
	            case "string":
	                return ts.map(values, function (v) { return v || ""; });
	            default:
	                return ts.filter(ts.map(values, function (v) { return parseCustomTypeOption(opt.element, v, errors); }), function (v) { return !!v; });
	        }
	    }
	    ts.parseListTypeOption = parseListTypeOption;
	    function parseCommandLine(commandLine, readFile) {
	        var options = {};
	        var fileNames = [];
	        var errors = [];
	        parseStrings(commandLine);
	        return {
	            options: options,
	            fileNames: fileNames,
	            errors: errors
	        };
	        function parseStrings(args) {
	            var i = 0;
	            while (i < args.length) {
	                var s = args[i];
	                i++;
	                if (s.charCodeAt(0) === 64 /* at */) {
	                    parseResponseFile(s.slice(1));
	                }
	                else if (s.charCodeAt(0) === 45 /* minus */) {
	                    var opt = getOptionFromName(s.slice(s.charCodeAt(1) === 45 /* minus */ ? 2 : 1), /*allowShort*/ true);
	                    if (opt) {
	                        if (opt.isTSConfigOnly) {
	                            errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Option_0_can_only_be_specified_in_tsconfig_json_file, opt.name));
	                        }
	                        else {
	                            // Check to see if no argument was provided (e.g. "--locale" is the last command-line argument).
	                            if (!args[i] && opt.type !== "boolean") {
	                                errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Compiler_option_0_expects_an_argument, opt.name));
	                            }
	                            switch (opt.type) {
	                                case "number":
	                                    options[opt.name] = parseInt(args[i]);
	                                    i++;
	                                    break;
	                                case "boolean":
	                                    // boolean flag has optional value true, false, others
	                                    var optValue = args[i];
	                                    options[opt.name] = optValue !== "false";
	                                    // consume next argument as boolean flag value
	                                    if (optValue === "false" || optValue === "true") {
	                                        i++;
	                                    }
	                                    break;
	                                case "string":
	                                    options[opt.name] = args[i] || "";
	                                    i++;
	                                    break;
	                                case "list":
	                                    var result = parseListTypeOption(opt, args[i], errors);
	                                    options[opt.name] = result || [];
	                                    if (result) {
	                                        i++;
	                                    }
	                                    break;
	                                // If not a primitive, the possible types are specified in what is effectively a map of options.
	                                default:
	                                    options[opt.name] = parseCustomTypeOption(opt, args[i], errors);
	                                    i++;
	                                    break;
	                            }
	                        }
	                    }
	                    else {
	                        errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Unknown_compiler_option_0, s));
	                    }
	                }
	                else {
	                    fileNames.push(s);
	                }
	            }
	        }
	        function parseResponseFile(fileName) {
	            var text = readFile ? readFile(fileName) : ts.sys.readFile(fileName);
	            if (!text) {
	                errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.File_0_not_found, fileName));
	                return;
	            }
	            var args = [];
	            var pos = 0;
	            while (true) {
	                while (pos < text.length && text.charCodeAt(pos) <= 32 /* space */)
	                    pos++;
	                if (pos >= text.length)
	                    break;
	                var start = pos;
	                if (text.charCodeAt(start) === 34 /* doubleQuote */) {
	                    pos++;
	                    while (pos < text.length && text.charCodeAt(pos) !== 34 /* doubleQuote */)
	                        pos++;
	                    if (pos < text.length) {
	                        args.push(text.substring(start + 1, pos));
	                        pos++;
	                    }
	                    else {
	                        errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Unterminated_quoted_string_in_response_file_0, fileName));
	                    }
	                }
	                else {
	                    while (text.charCodeAt(pos) > 32 /* space */)
	                        pos++;
	                    args.push(text.substring(start, pos));
	                }
	            }
	            parseStrings(args);
	        }
	    }
	    ts.parseCommandLine = parseCommandLine;
	    function getOptionFromName(optionName, allowShort) {
	        if (allowShort === void 0) { allowShort = false; }
	        optionName = optionName.toLowerCase();
	        var _a = getOptionNameMap(), optionNameMap = _a.optionNameMap, shortOptionNames = _a.shortOptionNames;
	        // Try to translate short option names to their full equivalents.
	        if (allowShort) {
	            var short = shortOptionNames.get(optionName);
	            if (short !== undefined) {
	                optionName = short;
	            }
	        }
	        return optionNameMap.get(optionName);
	    }
	    /**
	     * Read tsconfig.json file
	     * @param fileName The path to the config file
	     */
	    function readConfigFile(fileName, readFile) {
	        var textOrDiagnostic = tryReadFile(fileName, readFile);
	        return ts.isString(textOrDiagnostic) ? parseConfigFileTextToJson(fileName, textOrDiagnostic) : { config: {}, error: textOrDiagnostic };
	    }
	    ts.readConfigFile = readConfigFile;
	    /**
	     * Parse the text of the tsconfig.json file
	     * @param fileName The path to the config file
	     * @param jsonText The text of the config file
	     */
	    function parseConfigFileTextToJson(fileName, jsonText) {
	        var jsonSourceFile = ts.parseJsonText(fileName, jsonText);
	        return {
	            config: convertToObject(jsonSourceFile, jsonSourceFile.parseDiagnostics),
	            error: jsonSourceFile.parseDiagnostics.length ? jsonSourceFile.parseDiagnostics[0] : undefined
	        };
	    }
	    ts.parseConfigFileTextToJson = parseConfigFileTextToJson;
	    /**
	     * Read tsconfig.json file
	     * @param fileName The path to the config file
	     */
	    function readJsonConfigFile(fileName, readFile) {
	        var textOrDiagnostic = tryReadFile(fileName, readFile);
	        return ts.isString(textOrDiagnostic) ? ts.parseJsonText(fileName, textOrDiagnostic) : { parseDiagnostics: [textOrDiagnostic] };
	    }
	    ts.readJsonConfigFile = readJsonConfigFile;
	    function tryReadFile(fileName, readFile) {
	        var text;
	        try {
	            text = readFile(fileName);
	        }
	        catch (e) {
	            return ts.createCompilerDiagnostic(ts.Diagnostics.Cannot_read_file_0_Colon_1, fileName, e.message);
	        }
	        return text === undefined ? ts.createCompilerDiagnostic(ts.Diagnostics.The_specified_path_does_not_exist_Colon_0, fileName) : text;
	    }
	    function commandLineOptionsToMap(options) {
	        return ts.arrayToMap(options, function (option) { return option.name; });
	    }
	    var _tsconfigRootOptions;
	    function getTsconfigRootOptionsMap() {
	        if (_tsconfigRootOptions === undefined) {
	            _tsconfigRootOptions = commandLineOptionsToMap([
	                {
	                    name: "compilerOptions",
	                    type: "object",
	                    elementOptions: commandLineOptionsToMap(ts.optionDeclarations),
	                    extraKeyDiagnosticMessage: ts.Diagnostics.Unknown_compiler_option_0
	                },
	                {
	                    name: "typingOptions",
	                    type: "object",
	                    elementOptions: commandLineOptionsToMap(ts.typeAcquisitionDeclarations),
	                    extraKeyDiagnosticMessage: ts.Diagnostics.Unknown_type_acquisition_option_0
	                },
	                {
	                    name: "typeAcquisition",
	                    type: "object",
	                    elementOptions: commandLineOptionsToMap(ts.typeAcquisitionDeclarations),
	                    extraKeyDiagnosticMessage: ts.Diagnostics.Unknown_type_acquisition_option_0
	                },
	                {
	                    name: "extends",
	                    type: "string"
	                },
	                {
	                    name: "files",
	                    type: "list",
	                    element: {
	                        name: "files",
	                        type: "string"
	                    }
	                },
	                {
	                    name: "include",
	                    type: "list",
	                    element: {
	                        name: "include",
	                        type: "string"
	                    }
	                },
	                {
	                    name: "exclude",
	                    type: "list",
	                    element: {
	                        name: "exclude",
	                        type: "string"
	                    }
	                },
	                ts.compileOnSaveCommandLineOption
	            ]);
	        }
	        return _tsconfigRootOptions;
	    }
	    /**
	     * Convert the json syntax tree into the json value
	     */
	    function convertToObject(sourceFile, errors) {
	        return convertToObjectWorker(sourceFile, errors, /*knownRootOptions*/ undefined, /*jsonConversionNotifier*/ undefined);
	    }
	    ts.convertToObject = convertToObject;
	    /**
	     * Convert the json syntax tree into the json value
	     */
	    function convertToObjectWorker(sourceFile, errors, knownRootOptions, jsonConversionNotifier) {
	        if (!sourceFile.jsonObject) {
	            return {};
	        }
	        return convertObjectLiteralExpressionToJson(sourceFile.jsonObject, knownRootOptions, 
	        /*extraKeyDiagnosticMessage*/ undefined, /*parentOption*/ undefined);
	        function convertObjectLiteralExpressionToJson(node, knownOptions, extraKeyDiagnosticMessage, parentOption) {
	            var result = {};
	            for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                var element = _a[_i];
	                if (element.kind !== 268 /* PropertyAssignment */) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, element, ts.Diagnostics.Property_assignment_expected));
	                    continue;
	                }
	                if (element.questionToken) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, element.questionToken, ts.Diagnostics._0_can_only_be_used_in_a_ts_file, "?"));
	                }
	                if (!isDoubleQuotedString(element.name)) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, element.name, ts.Diagnostics.String_literal_with_double_quotes_expected));
	                }
	                var keyText = ts.unescapeLeadingUnderscores(ts.getTextOfPropertyName(element.name));
	                var option = knownOptions ? knownOptions.get(keyText) : undefined;
	                if (extraKeyDiagnosticMessage && !option) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, element.name, extraKeyDiagnosticMessage, keyText));
	                }
	                var value = convertPropertyValueToJson(element.initializer, option);
	                if (typeof keyText !== "undefined") {
	                    result[keyText] = value;
	                    // Notify key value set, if user asked for it
	                    if (jsonConversionNotifier &&
	                        // Current callbacks are only on known parent option or if we are setting values in the root
	                        (parentOption || knownOptions === knownRootOptions)) {
	                        var isValidOptionValue = isCompilerOptionsValue(option, value);
	                        if (parentOption) {
	                            if (isValidOptionValue) {
	                                // Notify option set in the parent if its a valid option value
	                                jsonConversionNotifier.onSetValidOptionKeyValueInParent(parentOption, option, value);
	                            }
	                        }
	                        else if (knownOptions === knownRootOptions) {
	                            if (isValidOptionValue) {
	                                // Notify about the valid root key value being set
	                                jsonConversionNotifier.onSetValidOptionKeyValueInRoot(keyText, element.name, value, element.initializer);
	                            }
	                            else if (!option) {
	                                // Notify about the unknown root key value being set
	                                jsonConversionNotifier.onSetUnknownOptionKeyValueInRoot(keyText, element.name, value, element.initializer);
	                            }
	                        }
	                    }
	                }
	            }
	            return result;
	        }
	        function convertArrayLiteralExpressionToJson(elements, elementOption) {
	            return elements.map(function (element) { return convertPropertyValueToJson(element, elementOption); });
	        }
	        function convertPropertyValueToJson(valueExpression, option) {
	            switch (valueExpression.kind) {
	                case 101 /* TrueKeyword */:
	                    reportInvalidOptionValue(option && option.type !== "boolean");
	                    return true;
	                case 86 /* FalseKeyword */:
	                    reportInvalidOptionValue(option && option.type !== "boolean");
	                    return false;
	                case 95 /* NullKeyword */:
	                    reportInvalidOptionValue(option && option.name === "extends"); // "extends" is the only option we don't allow null/undefined for
	                    return null; // tslint:disable-line:no-null-keyword
	                case 9 /* StringLiteral */:
	                    if (!isDoubleQuotedString(valueExpression)) {
	                        errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, ts.Diagnostics.String_literal_with_double_quotes_expected));
	                    }
	                    reportInvalidOptionValue(option && (ts.isString(option.type) && option.type !== "string"));
	                    var text = valueExpression.text;
	                    if (option && !ts.isString(option.type)) {
	                        var customOption = option;
	                        // Validate custom option type
	                        if (!customOption.type.has(text.toLowerCase())) {
	                            errors.push(createDiagnosticForInvalidCustomType(customOption, function (message, arg0, arg1) { return ts.createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, message, arg0, arg1); }));
	                        }
	                    }
	                    return text;
	                case 8 /* NumericLiteral */:
	                    reportInvalidOptionValue(option && option.type !== "number");
	                    return Number(valueExpression.text);
	                case 196 /* PrefixUnaryExpression */:
	                    if (valueExpression.operator !== 38 /* MinusToken */ || valueExpression.operand.kind !== 8 /* NumericLiteral */) {
	                        break; // not valid JSON syntax
	                    }
	                    reportInvalidOptionValue(option && option.type !== "number");
	                    return -Number(valueExpression.operand.text);
	                case 182 /* ObjectLiteralExpression */:
	                    reportInvalidOptionValue(option && option.type !== "object");
	                    var objectLiteralExpression = valueExpression;
	                    // Currently having element option declaration in the tsconfig with type "object"
	                    // determines if it needs onSetValidOptionKeyValueInParent callback or not
	                    // At moment there are only "compilerOptions", "typeAcquisition" and "typingOptions"
	                    // that satifies it and need it to modify options set in them (for normalizing file paths)
	                    // vs what we set in the json
	                    // If need arises, we can modify this interface and callbacks as needed
	                    if (option) {
	                        var _a = option, elementOptions = _a.elementOptions, extraKeyDiagnosticMessage = _a.extraKeyDiagnosticMessage, optionName = _a.name;
	                        return convertObjectLiteralExpressionToJson(objectLiteralExpression, elementOptions, extraKeyDiagnosticMessage, optionName);
	                    }
	                    else {
	                        return convertObjectLiteralExpressionToJson(objectLiteralExpression, /* knownOptions*/ undefined, 
	                        /*extraKeyDiagnosticMessage */ undefined, /*parentOption*/ undefined);
	                    }
	                case 181 /* ArrayLiteralExpression */:
	                    reportInvalidOptionValue(option && option.type !== "list");
	                    return convertArrayLiteralExpressionToJson(valueExpression.elements, option && option.element);
	            }
	            // Not in expected format
	            if (option) {
	                reportInvalidOptionValue(/*isError*/ true);
	            }
	            else {
	                errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, ts.Diagnostics.Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_literal));
	            }
	            return undefined;
	            function reportInvalidOptionValue(isError) {
	                if (isError) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, option.name, getCompilerOptionValueTypeString(option)));
	                }
	            }
	        }
	        function isDoubleQuotedString(node) {
	            return ts.isStringLiteral(node) && ts.isStringDoubleQuoted(node, sourceFile);
	        }
	    }
	    function getCompilerOptionValueTypeString(option) {
	        return option.type === "list" ?
	            "Array" :
	            ts.isString(option.type) ? option.type : "string";
	    }
	    function isCompilerOptionsValue(option, value) {
	        if (option) {
	            if (isNullOrUndefined(value))
	                return true; // All options are undefinable/nullable
	            if (option.type === "list") {
	                return ts.isArray(value);
	            }
	            var expectedType = ts.isString(option.type) ? option.type : "string";
	            return typeof value === expectedType;
	        }
	    }
	    /**
	     * Generate tsconfig configuration when running command line "--init"
	     * @param options commandlineOptions to be generated into tsconfig.json
	     * @param fileNames array of filenames to be generated into tsconfig.json
	     */
	    /* @internal */
	    function generateTSConfig(options, fileNames, newLine) {
	        var compilerOptions = ts.extend(options, ts.defaultInitCompilerOptions);
	        var compilerOptionsMap = serializeCompilerOptions(compilerOptions);
	        return writeConfigurations();
	        function getCustomTypeMapOfCommandLineOption(optionDefinition) {
	            if (optionDefinition.type === "string" || optionDefinition.type === "number" || optionDefinition.type === "boolean") {
	                // this is of a type CommandLineOptionOfPrimitiveType
	                return undefined;
	            }
	            else if (optionDefinition.type === "list") {
	                return getCustomTypeMapOfCommandLineOption(optionDefinition.element);
	            }
	            else {
	                return optionDefinition.type;
	            }
	        }
	        function getNameOfCompilerOptionValue(value, customTypeMap) {
	            // There is a typeMap associated with this command-line option so use it to map value back to its name
	            return ts.forEachEntry(customTypeMap, function (mapValue, key) {
	                if (mapValue === value) {
	                    return key;
	                }
	            });
	        }
	        function serializeCompilerOptions(options) {
	            var result = ts.createMap();
	            var optionsNameMap = getOptionNameMap().optionNameMap;
	            var _loop_6 = function (name) {
	                if (ts.hasProperty(options, name)) {
	                    // tsconfig only options cannot be specified via command line,
	                    // so we can assume that only types that can appear here string | number | boolean
	                    if (optionsNameMap.has(name) && optionsNameMap.get(name).category === ts.Diagnostics.Command_line_Options) {
	                        return "continue";
	                    }
	                    var value = options[name];
	                    var optionDefinition = optionsNameMap.get(name.toLowerCase());
	                    if (optionDefinition) {
	                        var customTypeMap_1 = getCustomTypeMapOfCommandLineOption(optionDefinition);
	                        if (!customTypeMap_1) {
	                            // There is no map associated with this compiler option then use the value as-is
	                            // This is the case if the value is expect to be string, number, boolean or list of string
	                            result.set(name, value);
	                        }
	                        else {
	                            if (optionDefinition.type === "list") {
	                                result.set(name, value.map(function (element) { return getNameOfCompilerOptionValue(element, customTypeMap_1); }));
	                            }
	                            else {
	                                // There is a typeMap associated with this command-line option so use it to map value back to its name
	                                result.set(name, getNameOfCompilerOptionValue(value, customTypeMap_1));
	                            }
	                        }
	                    }
	                }
	            };
	            for (var name in options) {
	                _loop_6(name);
	            }
	            return result;
	        }
	        function getDefaultValueForOption(option) {
	            switch (option.type) {
	                case "number":
	                    return 1;
	                case "boolean":
	                    return true;
	                case "string":
	                    return option.isFilePath ? "./" : "";
	                case "list":
	                    return [];
	                case "object":
	                    return {};
	                default:
	                    return option.type.keys().next().value;
	            }
	        }
	        function makePadding(paddingLength) {
	            return Array(paddingLength + 1).join(" ");
	        }
	        function writeConfigurations() {
	            // Filter applicable options to place in the file
	            var categorizedOptions = ts.createMultiMap();
	            for (var _i = 0, optionDeclarations_1 = ts.optionDeclarations; _i < optionDeclarations_1.length; _i++) {
	                var option = optionDeclarations_1[_i];
	                var category = option.category;
	                if (category !== undefined && category !== ts.Diagnostics.Command_line_Options && category !== ts.Diagnostics.Advanced_Options) {
	                    categorizedOptions.add(ts.getLocaleSpecificMessage(category), option);
	                }
	            }
	            // Serialize all options and their descriptions
	            var marginLength = 0;
	            var seenKnownKeys = 0;
	            var nameColumn = [];
	            var descriptionColumn = [];
	            categorizedOptions.forEach(function (options, category) {
	                if (nameColumn.length !== 0) {
	                    nameColumn.push("");
	                    descriptionColumn.push("");
	                }
	                nameColumn.push("/* " + category + " */");
	                descriptionColumn.push("");
	                for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
	                    var option = options_1[_i];
	                    var optionName = void 0;
	                    if (compilerOptionsMap.has(option.name)) {
	                        optionName = "\"" + option.name + "\": " + JSON.stringify(compilerOptionsMap.get(option.name)) + ((seenKnownKeys += 1) === compilerOptionsMap.size ? "" : ",");
	                    }
	                    else {
	                        optionName = "// \"" + option.name + "\": " + JSON.stringify(getDefaultValueForOption(option)) + ",";
	                    }
	                    nameColumn.push(optionName);
	                    descriptionColumn.push("/* " + (option.description && ts.getLocaleSpecificMessage(option.description) || option.name) + " */");
	                    marginLength = Math.max(optionName.length, marginLength);
	                }
	            });
	            // Write the output
	            var tab = makePadding(2);
	            var result = [];
	            result.push("{");
	            result.push(tab + "\"compilerOptions\": {");
	            // Print out each row, aligning all the descriptions on the same column.
	            for (var i = 0; i < nameColumn.length; i++) {
	                var optionName = nameColumn[i];
	                var description = descriptionColumn[i];
	                result.push(optionName && "" + tab + tab + optionName + (description && (makePadding(marginLength - optionName.length + 2) + description)));
	            }
	            if (fileNames.length) {
	                result.push(tab + "},");
	                result.push(tab + "\"files\": [");
	                for (var i = 0; i < fileNames.length; i++) {
	                    result.push("" + tab + tab + JSON.stringify(fileNames[i]) + (i === fileNames.length - 1 ? "" : ","));
	                }
	                result.push(tab + "]");
	            }
	            else {
	                result.push(tab + "}");
	            }
	            result.push("}");
	            return result.join(newLine);
	        }
	    }
	    ts.generateTSConfig = generateTSConfig;
	    /**
	     * Parse the contents of a config file (tsconfig.json).
	     * @param json The contents of the config file to parse
	     * @param host Instance of ParseConfigHost used to enumerate files in folder.
	     * @param basePath A root directory to resolve relative path entries in the config
	     *    file to. e.g. outDir
	     */
	    function parseJsonConfigFileContent(json, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions) {
	        return parseJsonConfigFileContentWorker(json, /*sourceFile*/ undefined, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions);
	    }
	    ts.parseJsonConfigFileContent = parseJsonConfigFileContent;
	    /**
	     * Parse the contents of a config file (tsconfig.json).
	     * @param jsonNode The contents of the config file to parse
	     * @param host Instance of ParseConfigHost used to enumerate files in folder.
	     * @param basePath A root directory to resolve relative path entries in the config
	     *    file to. e.g. outDir
	     */
	    function parseJsonSourceFileConfigFileContent(sourceFile, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions) {
	        return parseJsonConfigFileContentWorker(/*json*/ undefined, sourceFile, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions);
	    }
	    ts.parseJsonSourceFileConfigFileContent = parseJsonSourceFileConfigFileContent;
	    /*@internal*/
	    function setConfigFileInOptions(options, configFile) {
	        if (configFile) {
	            Object.defineProperty(options, "configFile", { enumerable: false, writable: false, value: configFile });
	        }
	    }
	    ts.setConfigFileInOptions = setConfigFileInOptions;
	    function isNullOrUndefined(x) {
	        // tslint:disable-next-line:no-null-keyword
	        return x === undefined || x === null;
	    }
	    function directoryOfCombinedPath(fileName, basePath) {
	        // Use the `getNormalizedAbsolutePath` function to avoid canonicalizing the path, as it must remain noncanonical
	        // until consistient casing errors are reported
	        return ts.getDirectoryPath(ts.getNormalizedAbsolutePath(fileName, basePath));
	    }
	    /**
	     * Parse the contents of a config file from json or json source file (tsconfig.json).
	     * @param json The contents of the config file to parse
	     * @param sourceFile sourceFile corresponding to the Json
	     * @param host Instance of ParseConfigHost used to enumerate files in folder.
	     * @param basePath A root directory to resolve relative path entries in the config
	     *    file to. e.g. outDir
	     * @param resolutionStack Only present for backwards-compatibility. Should be empty.
	     */
	    function parseJsonConfigFileContentWorker(json, sourceFile, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions) {
	        if (existingOptions === void 0) { existingOptions = {}; }
	        if (resolutionStack === void 0) { resolutionStack = []; }
	        if (extraFileExtensions === void 0) { extraFileExtensions = []; }
	        ts.Debug.assert((json === undefined && sourceFile !== undefined) || (json !== undefined && sourceFile === undefined));
	        var errors = [];
	        var parsedConfig = parseConfig(json, sourceFile, host, basePath, configFileName, resolutionStack, errors);
	        var raw = parsedConfig.raw;
	        var options = ts.extend(existingOptions, parsedConfig.options || {});
	        options.configFilePath = configFileName;
	        setConfigFileInOptions(options, sourceFile);
	        var _a = getFileNames(), fileNames = _a.fileNames, wildcardDirectories = _a.wildcardDirectories, spec = _a.spec;
	        return {
	            options: options,
	            fileNames: fileNames,
	            typeAcquisition: parsedConfig.typeAcquisition || getDefaultTypeAcquisition(),
	            raw: raw,
	            errors: errors,
	            wildcardDirectories: wildcardDirectories,
	            compileOnSave: !!raw.compileOnSave,
	            configFileSpecs: spec
	        };
	        function getFileNames() {
	            var filesSpecs;
	            if (ts.hasProperty(raw, "files") && !isNullOrUndefined(raw.files)) {
	                if (ts.isArray(raw.files)) {
	                    filesSpecs = raw.files;
	                    if (filesSpecs.length === 0) {
	                        createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.The_files_list_in_config_file_0_is_empty, configFileName || "tsconfig.json");
	                    }
	                }
	                else {
	                    createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "files", "Array");
	                }
	            }
	            var includeSpecs;
	            if (ts.hasProperty(raw, "include") && !isNullOrUndefined(raw.include)) {
	                if (ts.isArray(raw.include)) {
	                    includeSpecs = raw.include;
	                }
	                else {
	                    createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "include", "Array");
	                }
	            }
	            var excludeSpecs;
	            if (ts.hasProperty(raw, "exclude") && !isNullOrUndefined(raw.exclude)) {
	                if (ts.isArray(raw.exclude)) {
	                    excludeSpecs = raw.exclude;
	                }
	                else {
	                    createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "exclude", "Array");
	                }
	            }
	            else {
	                var outDir = raw.compilerOptions && raw.compilerOptions.outDir;
	                if (outDir) {
	                    excludeSpecs = [outDir];
	                }
	            }
	            if (filesSpecs === undefined && includeSpecs === undefined) {
	                includeSpecs = ["**/*"];
	            }
	            var result = matchFileNames(filesSpecs, includeSpecs, excludeSpecs, configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath, options, host, errors, extraFileExtensions, sourceFile);
	            if (result.fileNames.length === 0 && !ts.hasProperty(raw, "files") && resolutionStack.length === 0) {
	                errors.push(getErrorForNoInputFiles(result.spec, configFileName));
	            }
	            return result;
	        }
	        function createCompilerDiagnosticOnlyIfJson(message, arg0, arg1) {
	            if (!sourceFile) {
	                errors.push(ts.createCompilerDiagnostic(message, arg0, arg1));
	            }
	        }
	    }
	    /*@internal*/
	    function isErrorNoInputFiles(error) {
	        return error.code === ts.Diagnostics.No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2.code;
	    }
	    ts.isErrorNoInputFiles = isErrorNoInputFiles;
	    /*@internal*/
	    function getErrorForNoInputFiles(_a, configFileName) {
	        var includeSpecs = _a.includeSpecs, excludeSpecs = _a.excludeSpecs;
	        return ts.createCompilerDiagnostic(ts.Diagnostics.No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2, configFileName || "tsconfig.json", JSON.stringify(includeSpecs || []), JSON.stringify(excludeSpecs || []));
	    }
	    ts.getErrorForNoInputFiles = getErrorForNoInputFiles;
	    function isSuccessfulParsedTsconfig(value) {
	        return !!value.options;
	    }
	    /**
	     * This *just* extracts options/include/exclude/files out of a config file.
	     * It does *not* resolve the included files.
	     */
	    function parseConfig(json, sourceFile, host, basePath, configFileName, resolutionStack, errors) {
	        basePath = ts.normalizeSlashes(basePath);
	        var resolvedPath = ts.getNormalizedAbsolutePath(configFileName || "", basePath);
	        if (resolutionStack.indexOf(resolvedPath) >= 0) {
	            errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Circularity_detected_while_resolving_configuration_Colon_0, resolutionStack.concat([resolvedPath]).join(" -> ")));
	            return { raw: json || convertToObject(sourceFile, errors) };
	        }
	        var ownConfig = json ?
	            parseOwnConfigOfJson(json, host, basePath, configFileName, errors) :
	            parseOwnConfigOfJsonSourceFile(sourceFile, host, basePath, configFileName, errors);
	        if (ownConfig.extendedConfigPath) {
	            // copy the resolution stack so it is never reused between branches in potential diamond-problem scenarios.
	            resolutionStack = resolutionStack.concat([resolvedPath]);
	            var extendedConfig = getExtendedConfig(sourceFile, ownConfig.extendedConfigPath, host, basePath, resolutionStack, errors);
	            if (extendedConfig && isSuccessfulParsedTsconfig(extendedConfig)) {
	                var baseRaw_1 = extendedConfig.raw;
	                var raw_1 = ownConfig.raw;
	                var setPropertyInRawIfNotUndefined = function (propertyName) {
	                    var value = raw_1[propertyName] || baseRaw_1[propertyName];
	                    if (value) {
	                        raw_1[propertyName] = value;
	                    }
	                };
	                setPropertyInRawIfNotUndefined("include");
	                setPropertyInRawIfNotUndefined("exclude");
	                setPropertyInRawIfNotUndefined("files");
	                if (raw_1.compileOnSave === undefined) {
	                    raw_1.compileOnSave = baseRaw_1.compileOnSave;
	                }
	                ownConfig.options = ts.assign({}, extendedConfig.options, ownConfig.options);
	                // TODO extend type typeAcquisition
	            }
	        }
	        return ownConfig;
	    }
	    function parseOwnConfigOfJson(json, host, basePath, configFileName, errors) {
	        if (ts.hasProperty(json, "excludes")) {
	            errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Unknown_option_excludes_Did_you_mean_exclude));
	        }
	        var options = convertCompilerOptionsFromJsonWorker(json.compilerOptions, basePath, errors, configFileName);
	        // typingOptions has been deprecated and is only supported for backward compatibility purposes.
	        // It should be removed in future releases - use typeAcquisition instead.
	        var typeAcquisition = convertTypeAcquisitionFromJsonWorker(json.typeAcquisition || json.typingOptions, basePath, errors, configFileName);
	        json.compileOnSave = convertCompileOnSaveOptionFromJson(json, basePath, errors);
	        var extendedConfigPath;
	        if (json.extends) {
	            if (!ts.isString(json.extends)) {
	                errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "extends", "string"));
	            }
	            else {
	                var newBase = configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath;
	                extendedConfigPath = getExtendsConfigPath(json.extends, host, newBase, errors, ts.createCompilerDiagnostic);
	            }
	        }
	        return { raw: json, options: options, typeAcquisition: typeAcquisition, extendedConfigPath: extendedConfigPath };
	    }
	    function parseOwnConfigOfJsonSourceFile(sourceFile, host, basePath, configFileName, errors) {
	        var options = getDefaultCompilerOptions(configFileName);
	        var typeAcquisition, typingOptionstypeAcquisition;
	        var extendedConfigPath;
	        var optionsIterator = {
	            onSetValidOptionKeyValueInParent: function (parentOption, option, value) {
	                ts.Debug.assert(parentOption === "compilerOptions" || parentOption === "typeAcquisition" || parentOption === "typingOptions");
	                var currentOption = parentOption === "compilerOptions" ?
	                    options :
	                    parentOption === "typeAcquisition" ?
	                        (typeAcquisition || (typeAcquisition = getDefaultTypeAcquisition(configFileName))) :
	                        (typingOptionstypeAcquisition || (typingOptionstypeAcquisition = getDefaultTypeAcquisition(configFileName)));
	                currentOption[option.name] = normalizeOptionValue(option, basePath, value);
	            },
	            onSetValidOptionKeyValueInRoot: function (key, _keyNode, value, valueNode) {
	                switch (key) {
	                    case "extends":
	                        var newBase = configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath;
	                        extendedConfigPath = getExtendsConfigPath(value, host, newBase, errors, function (message, arg0) {
	                            return ts.createDiagnosticForNodeInSourceFile(sourceFile, valueNode, message, arg0);
	                        });
	                        return;
	                    case "files":
	                        if (value.length === 0) {
	                            errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, valueNode, ts.Diagnostics.The_files_list_in_config_file_0_is_empty, configFileName || "tsconfig.json"));
	                        }
	                        return;
	                }
	            },
	            onSetUnknownOptionKeyValueInRoot: function (key, keyNode, _value, _valueNode) {
	                if (key === "excludes") {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, keyNode, ts.Diagnostics.Unknown_option_excludes_Did_you_mean_exclude));
	                }
	            }
	        };
	        var json = convertToObjectWorker(sourceFile, errors, getTsconfigRootOptionsMap(), optionsIterator);
	        if (!typeAcquisition) {
	            if (typingOptionstypeAcquisition) {
	                typeAcquisition = (typingOptionstypeAcquisition.enableAutoDiscovery !== undefined) ?
	                    {
	                        enable: typingOptionstypeAcquisition.enableAutoDiscovery,
	                        include: typingOptionstypeAcquisition.include,
	                        exclude: typingOptionstypeAcquisition.exclude
	                    } :
	                    typingOptionstypeAcquisition;
	            }
	            else {
	                typeAcquisition = getDefaultTypeAcquisition(configFileName);
	            }
	        }
	        return { raw: json, options: options, typeAcquisition: typeAcquisition, extendedConfigPath: extendedConfigPath };
	    }
	    function getExtendsConfigPath(extendedConfig, host, basePath, errors, createDiagnostic) {
	        extendedConfig = ts.normalizeSlashes(extendedConfig);
	        // If the path isn't a rooted or relative path, don't try to resolve it (we reserve the right to special case module-id like paths in the future)
	        if (!(ts.isRootedDiskPath(extendedConfig) || ts.startsWith(extendedConfig, "./") || ts.startsWith(extendedConfig, "../"))) {
	            errors.push(createDiagnostic(ts.Diagnostics.A_path_in_an_extends_option_must_be_relative_or_rooted_but_0_is_not, extendedConfig));
	            return undefined;
	        }
	        var extendedConfigPath = ts.getNormalizedAbsolutePath(extendedConfig, basePath);
	        if (!host.fileExists(extendedConfigPath) && !ts.endsWith(extendedConfigPath, ".json" /* Json */)) {
	            extendedConfigPath = extendedConfigPath + ".json";
	            if (!host.fileExists(extendedConfigPath)) {
	                errors.push(createDiagnostic(ts.Diagnostics.File_0_does_not_exist, extendedConfig));
	                return undefined;
	            }
	        }
	        return extendedConfigPath;
	    }
	    function getExtendedConfig(sourceFile, extendedConfigPath, host, basePath, resolutionStack, errors) {
	        var extendedResult = readJsonConfigFile(extendedConfigPath, function (path) { return host.readFile(path); });
	        if (sourceFile) {
	            (sourceFile.extendedSourceFiles || (sourceFile.extendedSourceFiles = [])).push(extendedResult.fileName);
	        }
	        if (extendedResult.parseDiagnostics.length) {
	            errors.push.apply(errors, extendedResult.parseDiagnostics);
	            return undefined;
	        }
	        var extendedDirname = ts.getDirectoryPath(extendedConfigPath);
	        var extendedConfig = parseConfig(/*json*/ undefined, extendedResult, host, extendedDirname, ts.getBaseFileName(extendedConfigPath), resolutionStack, errors);
	        if (sourceFile) {
	            (_a = sourceFile.extendedSourceFiles).push.apply(_a, extendedResult.extendedSourceFiles);
	        }
	        if (isSuccessfulParsedTsconfig(extendedConfig)) {
	            // Update the paths to reflect base path
	            var relativeDifference_1 = ts.convertToRelativePath(extendedDirname, basePath, ts.identity);
	            var updatePath_1 = function (path) { return ts.isRootedDiskPath(path) ? path : ts.combinePaths(relativeDifference_1, path); };
	            var mapPropertiesInRawIfNotUndefined = function (propertyName) {
	                if (raw_2[propertyName]) {
	                    raw_2[propertyName] = ts.map(raw_2[propertyName], updatePath_1);
	                }
	            };
	            var raw_2 = extendedConfig.raw;
	            mapPropertiesInRawIfNotUndefined("include");
	            mapPropertiesInRawIfNotUndefined("exclude");
	            mapPropertiesInRawIfNotUndefined("files");
	        }
	        return extendedConfig;
	        var _a;
	    }
	    function convertCompileOnSaveOptionFromJson(jsonOption, basePath, errors) {
	        if (!ts.hasProperty(jsonOption, ts.compileOnSaveCommandLineOption.name)) {
	            return undefined;
	        }
	        var result = convertJsonOption(ts.compileOnSaveCommandLineOption, jsonOption.compileOnSave, basePath, errors);
	        if (typeof result === "boolean" && result) {
	            return result;
	        }
	        return false;
	    }
	    function convertCompilerOptionsFromJson(jsonOptions, basePath, configFileName) {
	        var errors = [];
	        var options = convertCompilerOptionsFromJsonWorker(jsonOptions, basePath, errors, configFileName);
	        return { options: options, errors: errors };
	    }
	    ts.convertCompilerOptionsFromJson = convertCompilerOptionsFromJson;
	    function convertTypeAcquisitionFromJson(jsonOptions, basePath, configFileName) {
	        var errors = [];
	        var options = convertTypeAcquisitionFromJsonWorker(jsonOptions, basePath, errors, configFileName);
	        return { options: options, errors: errors };
	    }
	    ts.convertTypeAcquisitionFromJson = convertTypeAcquisitionFromJson;
	    function getDefaultCompilerOptions(configFileName) {
	        var options = ts.getBaseFileName(configFileName) === "jsconfig.json"
	            ? { allowJs: true, maxNodeModuleJsDepth: 2, allowSyntheticDefaultImports: true, skipLibCheck: true, noEmit: true }
	            : {};
	        return options;
	    }
	    function convertCompilerOptionsFromJsonWorker(jsonOptions, basePath, errors, configFileName) {
	        var options = getDefaultCompilerOptions(configFileName);
	        convertOptionsFromJson(ts.optionDeclarations, jsonOptions, basePath, options, ts.Diagnostics.Unknown_compiler_option_0, errors);
	        return options;
	    }
	    function getDefaultTypeAcquisition(configFileName) {
	        return { enable: ts.getBaseFileName(configFileName) === "jsconfig.json", include: [], exclude: [] };
	    }
	    function convertTypeAcquisitionFromJsonWorker(jsonOptions, basePath, errors, configFileName) {
	        var options = getDefaultTypeAcquisition(configFileName);
	        var typeAcquisition = convertEnableAutoDiscoveryToEnable(jsonOptions);
	        convertOptionsFromJson(ts.typeAcquisitionDeclarations, typeAcquisition, basePath, options, ts.Diagnostics.Unknown_type_acquisition_option_0, errors);
	        return options;
	    }
	    function convertOptionsFromJson(optionDeclarations, jsonOptions, basePath, defaultOptions, diagnosticMessage, errors) {
	        if (!jsonOptions) {
	            return;
	        }
	        var optionNameMap = commandLineOptionsToMap(optionDeclarations);
	        for (var id in jsonOptions) {
	            var opt = optionNameMap.get(id);
	            if (opt) {
	                defaultOptions[opt.name] = convertJsonOption(opt, jsonOptions[id], basePath, errors);
	            }
	            else {
	                errors.push(ts.createCompilerDiagnostic(diagnosticMessage, id));
	            }
	        }
	    }
	    function convertJsonOption(opt, value, basePath, errors) {
	        if (isCompilerOptionsValue(opt, value)) {
	            var optType = opt.type;
	            if (optType === "list" && ts.isArray(value)) {
	                return convertJsonOptionOfListType(opt, value, basePath, errors);
	            }
	            else if (!ts.isString(optType)) {
	                return convertJsonOptionOfCustomType(opt, value, errors);
	            }
	            return normalizeNonListOptionValue(opt, basePath, value);
	        }
	        else {
	            errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, opt.name, getCompilerOptionValueTypeString(opt)));
	        }
	    }
	    function normalizeOptionValue(option, basePath, value) {
	        if (isNullOrUndefined(value))
	            return undefined;
	        if (option.type === "list") {
	            var listOption_1 = option;
	            if (listOption_1.element.isFilePath || !ts.isString(listOption_1.element.type)) {
	                return ts.filter(ts.map(value, function (v) { return normalizeOptionValue(listOption_1.element, basePath, v); }), function (v) { return !!v; });
	            }
	            return value;
	        }
	        else if (!ts.isString(option.type)) {
	            return option.type.get(ts.isString(value) ? value.toLowerCase() : value);
	        }
	        return normalizeNonListOptionValue(option, basePath, value);
	    }
	    function normalizeNonListOptionValue(option, basePath, value) {
	        if (option.isFilePath) {
	            value = ts.normalizePath(ts.combinePaths(basePath, value));
	            if (value === "") {
	                value = ".";
	            }
	        }
	        return value;
	    }
	    function convertJsonOptionOfCustomType(opt, value, errors) {
	        if (isNullOrUndefined(value))
	            return undefined;
	        var key = value.toLowerCase();
	        var val = opt.type.get(key);
	        if (val !== undefined) {
	            return val;
	        }
	        else {
	            errors.push(createCompilerDiagnosticForInvalidCustomType(opt));
	        }
	    }
	    function convertJsonOptionOfListType(option, values, basePath, errors) {
	        return ts.filter(ts.map(values, function (v) { return convertJsonOption(option.element, v, basePath, errors); }), function (v) { return !!v; });
	    }
	    function trimString(s) {
	        return typeof s.trim === "function" ? s.trim() : s.replace(/^[\s]+|[\s]+$/g, "");
	    }
	    /**
	     * Tests for a path that ends in a recursive directory wildcard.
	     * Matches **, \**, **\, and \**\, but not a**b.
	     *
	     * NOTE: used \ in place of / above to avoid issues with multiline comments.
	     *
	     * Breakdown:
	     *  (^|\/)      # matches either the beginning of the string or a directory separator.
	     *  \*\*        # matches the recursive directory wildcard "**".
	     *  \/?$        # matches an optional trailing directory separator at the end of the string.
	     */
	    var invalidTrailingRecursionPattern = /(^|\/)\*\*\/?$/;
	    /**
	     * Tests for a path where .. appears after a recursive directory wildcard.
	     * Matches **\..\*, **\a\..\*, and **\.., but not ..\**\*
	     *
	     * NOTE: used \ in place of / above to avoid issues with multiline comments.
	     *
	     * Breakdown:
	     *  (^|\/)      # matches either the beginning of the string or a directory separator.
	     *  \*\*\/      # matches a recursive directory wildcard "**" followed by a directory separator.
	     *  (.*\/)?     # optionally matches any number of characters followed by a directory separator.
	     *  \.\.        # matches a parent directory path component ".."
	     *  ($|\/)      # matches either the end of the string or a directory separator.
	     */
	    var invalidDotDotAfterRecursiveWildcardPattern = /(^|\/)\*\*\/(.*\/)?\.\.($|\/)/;
	    /**
	     * Tests for a path containing a wildcard character in a directory component of the path.
	     * Matches \*\, \?\, and \a*b\, but not \a\ or \a\*.
	     *
	     * NOTE: used \ in place of / above to avoid issues with multiline comments.
	     *
	     * Breakdown:
	     *  \/          # matches a directory separator.
	     *  [^/]*?      # matches any number of characters excluding directory separators (non-greedy).
	     *  [*?]        # matches either a wildcard character (* or ?)
	     *  [^/]*       # matches any number of characters excluding directory separators (greedy).
	     *  \/          # matches a directory separator.
	     */
	    var watchRecursivePattern = /\/[^/]*?[*?][^/]*\//;
	    /**
	     * Matches the portion of a wildcard path that does not contain wildcards.
	     * Matches \a of \a\*, or \a\b\c of \a\b\c\?\d.
	     *
	     * NOTE: used \ in place of / above to avoid issues with multiline comments.
	     *
	     * Breakdown:
	     *  ^                   # matches the beginning of the string
	     *  [^*?]*              # matches any number of non-wildcard characters
	     *  (?=\/[^/]*[*?])     # lookahead that matches a directory separator followed by
	     *                      # a path component that contains at least one wildcard character (* or ?).
	     */
	    var wildcardDirectoryPattern = /^[^*?]*(?=\/[^/]*[*?])/;
	    /**
	     * Expands an array of file specifications.
	     *
	     * @param filesSpecs The literal file names to include.
	     * @param includeSpecs The wildcard file specifications to include.
	     * @param excludeSpecs The wildcard file specifications to exclude.
	     * @param basePath The base path for any relative file specifications.
	     * @param options Compiler options.
	     * @param host The host used to resolve files and directories.
	     * @param errors An array for diagnostic reporting.
	     */
	    function matchFileNames(filesSpecs, includeSpecs, excludeSpecs, basePath, options, host, errors, extraFileExtensions, jsonSourceFile) {
	        basePath = ts.normalizePath(basePath);
	        var validatedIncludeSpecs, validatedExcludeSpecs;
	        // The exclude spec list is converted into a regular expression, which allows us to quickly
	        // test whether a file or directory should be excluded before recursively traversing the
	        // file system.
	        if (includeSpecs) {
	            validatedIncludeSpecs = validateSpecs(includeSpecs, errors, /*allowTrailingRecursion*/ false, jsonSourceFile, "include");
	        }
	        if (excludeSpecs) {
	            validatedExcludeSpecs = validateSpecs(excludeSpecs, errors, /*allowTrailingRecursion*/ true, jsonSourceFile, "exclude");
	        }
	        // Wildcard directories (provided as part of a wildcard path) are stored in a
	        // file map that marks whether it was a regular wildcard match (with a `*` or `?` token),
	        // or a recursive directory. This information is used by filesystem watchers to monitor for
	        // new entries in these paths.
	        var wildcardDirectories = getWildcardDirectories(validatedIncludeSpecs, validatedExcludeSpecs, basePath, host.useCaseSensitiveFileNames);
	        var spec = { filesSpecs: filesSpecs, includeSpecs: includeSpecs, excludeSpecs: excludeSpecs, validatedIncludeSpecs: validatedIncludeSpecs, validatedExcludeSpecs: validatedExcludeSpecs, wildcardDirectories: wildcardDirectories };
	        return getFileNamesFromConfigSpecs(spec, basePath, options, host, extraFileExtensions);
	    }
	    /**
	     * Gets the file names from the provided config file specs that contain, files, include, exclude and
	     * other properties needed to resolve the file names
	     * @param spec The config file specs extracted with file names to include, wildcards to include/exclude and other details
	     * @param basePath The base path for any relative file specifications.
	     * @param options Compiler options.
	     * @param host The host used to resolve files and directories.
	     * @param extraFileExtensions optionaly file extra file extension information from host
	     */
	    /* @internal */
	    function getFileNamesFromConfigSpecs(spec, basePath, options, host, extraFileExtensions) {
	        if (extraFileExtensions === void 0) { extraFileExtensions = []; }
	        basePath = ts.normalizePath(basePath);
	        var keyMapper = host.useCaseSensitiveFileNames ? caseSensitiveKeyMapper : caseInsensitiveKeyMapper;
	        // Literal file names (provided via the "files" array in tsconfig.json) are stored in a
	        // file map with a possibly case insensitive key. We use this map later when when including
	        // wildcard paths.
	        var literalFileMap = ts.createMap();
	        // Wildcard paths (provided via the "includes" array in tsconfig.json) are stored in a
	        // file map with a possibly case insensitive key. We use this map to store paths matched
	        // via wildcard, and to handle extension priority.
	        var wildcardFileMap = ts.createMap();
	        var filesSpecs = spec.filesSpecs, validatedIncludeSpecs = spec.validatedIncludeSpecs, validatedExcludeSpecs = spec.validatedExcludeSpecs, wildcardDirectories = spec.wildcardDirectories;
	        // Rather than requery this for each file and filespec, we query the supported extensions
	        // once and store it on the expansion context.
	        var supportedExtensions = ts.getSupportedExtensions(options, extraFileExtensions);
	        // Literal files are always included verbatim. An "include" or "exclude" specification cannot
	        // remove a literal file.
	        if (filesSpecs) {
	            for (var _i = 0, filesSpecs_1 = filesSpecs; _i < filesSpecs_1.length; _i++) {
	                var fileName = filesSpecs_1[_i];
	                var file = ts.getNormalizedAbsolutePath(fileName, basePath);
	                literalFileMap.set(keyMapper(file), file);
	            }
	        }
	        if (validatedIncludeSpecs && validatedIncludeSpecs.length > 0) {
	            for (var _a = 0, _b = host.readDirectory(basePath, supportedExtensions, validatedExcludeSpecs, validatedIncludeSpecs, /*depth*/ undefined); _a < _b.length; _a++) {
	                var file = _b[_a];
	                // If we have already included a literal or wildcard path with a
	                // higher priority extension, we should skip this file.
	                //
	                // This handles cases where we may encounter both <file>.ts and
	                // <file>.d.ts (or <file>.js if "allowJs" is enabled) in the same
	                // directory when they are compilation outputs.
	                if (hasFileWithHigherPriorityExtension(file, literalFileMap, wildcardFileMap, supportedExtensions, keyMapper)) {
	                    continue;
	                }
	                // We may have included a wildcard path with a lower priority
	                // extension due to the user-defined order of entries in the
	                // "include" array. If there is a lower priority extension in the
	                // same directory, we should remove it.
	                removeWildcardFilesWithLowerPriorityExtension(file, wildcardFileMap, supportedExtensions, keyMapper);
	                var key = keyMapper(file);
	                if (!literalFileMap.has(key) && !wildcardFileMap.has(key)) {
	                    wildcardFileMap.set(key, file);
	                }
	            }
	        }
	        var literalFiles = ts.arrayFrom(literalFileMap.values());
	        var wildcardFiles = ts.arrayFrom(wildcardFileMap.values());
	        return {
	            fileNames: literalFiles.concat(wildcardFiles),
	            wildcardDirectories: wildcardDirectories,
	            spec: spec
	        };
	    }
	    ts.getFileNamesFromConfigSpecs = getFileNamesFromConfigSpecs;
	    function validateSpecs(specs, errors, allowTrailingRecursion, jsonSourceFile, specKey) {
	        return specs.filter(function (spec) {
	            var diag = specToDiagnostic(spec, allowTrailingRecursion);
	            if (diag !== undefined) {
	                errors.push(createDiagnostic(diag, spec));
	            }
	            return diag === undefined;
	        });
	        function createDiagnostic(message, spec) {
	            if (jsonSourceFile && jsonSourceFile.jsonObject) {
	                for (var _i = 0, _a = ts.getPropertyAssignment(jsonSourceFile.jsonObject, specKey); _i < _a.length; _i++) {
	                    var property = _a[_i];
	                    if (ts.isArrayLiteralExpression(property.initializer)) {
	                        for (var _b = 0, _c = property.initializer.elements; _b < _c.length; _b++) {
	                            var element = _c[_b];
	                            if (ts.isStringLiteral(element) && element.text === spec) {
	                                return ts.createDiagnosticForNodeInSourceFile(jsonSourceFile, element, message, spec);
	                            }
	                        }
	                    }
	                }
	            }
	            return ts.createCompilerDiagnostic(message, spec);
	        }
	    }
	    function specToDiagnostic(spec, allowTrailingRecursion) {
	        if (!allowTrailingRecursion && invalidTrailingRecursionPattern.test(spec)) {
	            return ts.Diagnostics.File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0;
	        }
	        else if (invalidDotDotAfterRecursiveWildcardPattern.test(spec)) {
	            return ts.Diagnostics.File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0;
	        }
	    }
	    /**
	     * Gets directories in a set of include patterns that should be watched for changes.
	     */
	    function getWildcardDirectories(include, exclude, path, useCaseSensitiveFileNames) {
	        // We watch a directory recursively if it contains a wildcard anywhere in a directory segment
	        // of the pattern:
	        //
	        //  /a/b/**/d   - Watch /a/b recursively to catch changes to any d in any subfolder recursively
	        //  /a/b/*/d    - Watch /a/b recursively to catch any d in any immediate subfolder, even if a new subfolder is added
	        //  /a/b        - Watch /a/b recursively to catch changes to anything in any recursive subfoler
	        //
	        // We watch a directory without recursion if it contains a wildcard in the file segment of
	        // the pattern:
	        //
	        //  /a/b/*      - Watch /a/b directly to catch any new file
	        //  /a/b/a?z    - Watch /a/b directly to catch any new file matching a?z
	        var rawExcludeRegex = ts.getRegularExpressionForWildcard(exclude, path, "exclude");
	        var excludeRegex = rawExcludeRegex && new RegExp(rawExcludeRegex, useCaseSensitiveFileNames ? "" : "i");
	        var wildcardDirectories = {};
	        if (include !== undefined) {
	            var recursiveKeys = [];
	            for (var _i = 0, include_1 = include; _i < include_1.length; _i++) {
	                var file = include_1[_i];
	                var spec = ts.normalizePath(ts.combinePaths(path, file));
	                if (excludeRegex && excludeRegex.test(spec)) {
	                    continue;
	                }
	                var match = getWildcardDirectoryFromSpec(spec, useCaseSensitiveFileNames);
	                if (match) {
	                    var key = match.key, flags = match.flags;
	                    var existingFlags = wildcardDirectories[key];
	                    if (existingFlags === undefined || existingFlags < flags) {
	                        wildcardDirectories[key] = flags;
	                        if (flags === 1 /* Recursive */) {
	                            recursiveKeys.push(key);
	                        }
	                    }
	                }
	            }
	            // Remove any subpaths under an existing recursively watched directory.
	            for (var key in wildcardDirectories) {
	                if (ts.hasProperty(wildcardDirectories, key)) {
	                    for (var _a = 0, recursiveKeys_1 = recursiveKeys; _a < recursiveKeys_1.length; _a++) {
	                        var recursiveKey = recursiveKeys_1[_a];
	                        if (key !== recursiveKey && ts.containsPath(recursiveKey, key, path, !useCaseSensitiveFileNames)) {
	                            delete wildcardDirectories[key];
	                        }
	                    }
	                }
	            }
	        }
	        return wildcardDirectories;
	    }
	    function getWildcardDirectoryFromSpec(spec, useCaseSensitiveFileNames) {
	        var match = wildcardDirectoryPattern.exec(spec);
	        if (match) {
	            return {
	                key: useCaseSensitiveFileNames ? match[0] : match[0].toLowerCase(),
	                flags: watchRecursivePattern.test(spec) ? 1 /* Recursive */ : 0 /* None */
	            };
	        }
	        if (ts.isImplicitGlob(spec)) {
	            return { key: spec, flags: 1 /* Recursive */ };
	        }
	        return undefined;
	    }
	    /**
	     * Determines whether a literal or wildcard file has already been included that has a higher
	     * extension priority.
	     *
	     * @param file The path to the file.
	     * @param extensionPriority The priority of the extension.
	     * @param context The expansion context.
	     */
	    function hasFileWithHigherPriorityExtension(file, literalFiles, wildcardFiles, extensions, keyMapper) {
	        var extensionPriority = ts.getExtensionPriority(file, extensions);
	        var adjustedExtensionPriority = ts.adjustExtensionPriority(extensionPriority, extensions);
	        for (var i = 0 /* Highest */; i < adjustedExtensionPriority; i++) {
	            var higherPriorityExtension = extensions[i];
	            var higherPriorityPath = keyMapper(ts.changeExtension(file, higherPriorityExtension));
	            if (literalFiles.has(higherPriorityPath) || wildcardFiles.has(higherPriorityPath)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    /**
	     * Removes files included via wildcard expansion with a lower extension priority that have
	     * already been included.
	     *
	     * @param file The path to the file.
	     * @param extensionPriority The priority of the extension.
	     * @param context The expansion context.
	     */
	    function removeWildcardFilesWithLowerPriorityExtension(file, wildcardFiles, extensions, keyMapper) {
	        var extensionPriority = ts.getExtensionPriority(file, extensions);
	        var nextExtensionPriority = ts.getNextLowestExtensionPriority(extensionPriority, extensions);
	        for (var i = nextExtensionPriority; i < extensions.length; i++) {
	            var lowerPriorityExtension = extensions[i];
	            var lowerPriorityPath = keyMapper(ts.changeExtension(file, lowerPriorityExtension));
	            wildcardFiles.delete(lowerPriorityPath);
	        }
	    }
	    /**
	     * Gets a case sensitive key.
	     *
	     * @param key The original key.
	     */
	    function caseSensitiveKeyMapper(key) {
	        return key;
	    }
	    /**
	     * Gets a case insensitive key.
	     *
	     * @param key The original key.
	     */
	    function caseInsensitiveKeyMapper(key) {
	        return key.toLowerCase();
	    }
	    /**
	     * Produces a cleaned version of compiler options with personally identifiying info (aka, paths) removed.
	     * Also converts enum values back to strings.
	     */
	    /* @internal */
	    function convertCompilerOptionsForTelemetry(opts) {
	        var out = {};
	        for (var key in opts) {
	            if (opts.hasOwnProperty(key)) {
	                var type = getOptionFromName(key);
	                if (type !== undefined) {
	                    out[key] = getOptionValueWithEmptyStrings(opts[key], type);
	                }
	            }
	        }
	        return out;
	    }
	    ts.convertCompilerOptionsForTelemetry = convertCompilerOptionsForTelemetry;
	    function getOptionValueWithEmptyStrings(value, option) {
	        switch (option.type) {
	            case "object":// "paths". Can't get any useful information from the value since we blank out strings, so just return "".
	                return "";
	            case "string":// Could be any arbitrary string -- use empty string instead.
	                return "";
	            case "number":// Allow numbers, but be sure to check it's actually a number.
	                return typeof value === "number" ? value : "";
	            case "boolean":
	                return typeof value === "boolean" ? value : "";
	            case "list":
	                var elementType_1 = option.element;
	                return ts.isArray(value) ? value.map(function (v) { return getOptionValueWithEmptyStrings(v, elementType_1); }) : "";
	            default:
	                return ts.forEachEntry(option.type, function (optionEnumValue, optionStringValue) {
	                    if (optionEnumValue === value) {
	                        return optionStringValue;
	                    }
	                });
	        }
	    }
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    var ScriptSnapshot;
	    (function (ScriptSnapshot) {
	        var StringScriptSnapshot = /** @class */ (function () {
	            function StringScriptSnapshot(text) {
	                this.text = text;
	            }
	            StringScriptSnapshot.prototype.getText = function (start, end) {
	                return start === 0 && end === this.text.length
	                    ? this.text
	                    : this.text.substring(start, end);
	            };
	            StringScriptSnapshot.prototype.getLength = function () {
	                return this.text.length;
	            };
	            StringScriptSnapshot.prototype.getChangeRange = function () {
	                // Text-based snapshots do not support incremental parsing. Return undefined
	                // to signal that to the caller.
	                return undefined;
	            };
	            return StringScriptSnapshot;
	        }());
	        function fromString(text) {
	            return new StringScriptSnapshot(text);
	        }
	        ScriptSnapshot.fromString = fromString;
	    })(ScriptSnapshot = ts.ScriptSnapshot || (ts.ScriptSnapshot = {}));
	    var TextChange = /** @class */ (function () {
	        function TextChange() {
	        }
	        return TextChange;
	    }());
	    ts.TextChange = TextChange;
	    var HighlightSpanKind;
	    (function (HighlightSpanKind) {
	        HighlightSpanKind["none"] = "none";
	        HighlightSpanKind["definition"] = "definition";
	        HighlightSpanKind["reference"] = "reference";
	        HighlightSpanKind["writtenReference"] = "writtenReference";
	    })(HighlightSpanKind = ts.HighlightSpanKind || (ts.HighlightSpanKind = {}));
	    var IndentStyle;
	    (function (IndentStyle) {
	        IndentStyle[IndentStyle["None"] = 0] = "None";
	        IndentStyle[IndentStyle["Block"] = 1] = "Block";
	        IndentStyle[IndentStyle["Smart"] = 2] = "Smart";
	    })(IndentStyle = ts.IndentStyle || (ts.IndentStyle = {}));
	    var SymbolDisplayPartKind;
	    (function (SymbolDisplayPartKind) {
	        SymbolDisplayPartKind[SymbolDisplayPartKind["aliasName"] = 0] = "aliasName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["className"] = 1] = "className";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["enumName"] = 2] = "enumName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["fieldName"] = 3] = "fieldName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["interfaceName"] = 4] = "interfaceName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["keyword"] = 5] = "keyword";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["lineBreak"] = 6] = "lineBreak";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["numericLiteral"] = 7] = "numericLiteral";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["stringLiteral"] = 8] = "stringLiteral";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["localName"] = 9] = "localName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["methodName"] = 10] = "methodName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["moduleName"] = 11] = "moduleName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["operator"] = 12] = "operator";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["parameterName"] = 13] = "parameterName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["propertyName"] = 14] = "propertyName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["punctuation"] = 15] = "punctuation";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["space"] = 16] = "space";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["text"] = 17] = "text";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["typeParameterName"] = 18] = "typeParameterName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["enumMemberName"] = 19] = "enumMemberName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["functionName"] = 20] = "functionName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["regularExpressionLiteral"] = 21] = "regularExpressionLiteral";
	    })(SymbolDisplayPartKind = ts.SymbolDisplayPartKind || (ts.SymbolDisplayPartKind = {}));
	    var OutputFileType;
	    (function (OutputFileType) {
	        OutputFileType[OutputFileType["JavaScript"] = 0] = "JavaScript";
	        OutputFileType[OutputFileType["SourceMap"] = 1] = "SourceMap";
	        OutputFileType[OutputFileType["Declaration"] = 2] = "Declaration";
	    })(OutputFileType = ts.OutputFileType || (ts.OutputFileType = {}));
	    var EndOfLineState;
	    (function (EndOfLineState) {
	        EndOfLineState[EndOfLineState["None"] = 0] = "None";
	        EndOfLineState[EndOfLineState["InMultiLineCommentTrivia"] = 1] = "InMultiLineCommentTrivia";
	        EndOfLineState[EndOfLineState["InSingleQuoteStringLiteral"] = 2] = "InSingleQuoteStringLiteral";
	        EndOfLineState[EndOfLineState["InDoubleQuoteStringLiteral"] = 3] = "InDoubleQuoteStringLiteral";
	        EndOfLineState[EndOfLineState["InTemplateHeadOrNoSubstitutionTemplate"] = 4] = "InTemplateHeadOrNoSubstitutionTemplate";
	        EndOfLineState[EndOfLineState["InTemplateMiddleOrTail"] = 5] = "InTemplateMiddleOrTail";
	        EndOfLineState[EndOfLineState["InTemplateSubstitutionPosition"] = 6] = "InTemplateSubstitutionPosition";
	    })(EndOfLineState = ts.EndOfLineState || (ts.EndOfLineState = {}));
	    var TokenClass;
	    (function (TokenClass) {
	        TokenClass[TokenClass["Punctuation"] = 0] = "Punctuation";
	        TokenClass[TokenClass["Keyword"] = 1] = "Keyword";
	        TokenClass[TokenClass["Operator"] = 2] = "Operator";
	        TokenClass[TokenClass["Comment"] = 3] = "Comment";
	        TokenClass[TokenClass["Whitespace"] = 4] = "Whitespace";
	        TokenClass[TokenClass["Identifier"] = 5] = "Identifier";
	        TokenClass[TokenClass["NumberLiteral"] = 6] = "NumberLiteral";
	        TokenClass[TokenClass["StringLiteral"] = 7] = "StringLiteral";
	        TokenClass[TokenClass["RegExpLiteral"] = 8] = "RegExpLiteral";
	    })(TokenClass = ts.TokenClass || (ts.TokenClass = {}));
	    var ScriptElementKind;
	    (function (ScriptElementKind) {
	        ScriptElementKind["unknown"] = "";
	        ScriptElementKind["warning"] = "warning";
	        /** predefined type (void) or keyword (class) */
	        ScriptElementKind["keyword"] = "keyword";
	        /** top level script node */
	        ScriptElementKind["scriptElement"] = "script";
	        /** module foo {} */
	        ScriptElementKind["moduleElement"] = "module";
	        /** class X {} */
	        ScriptElementKind["classElement"] = "class";
	        /** var x = class X {} */
	        ScriptElementKind["localClassElement"] = "local class";
	        /** interface Y {} */
	        ScriptElementKind["interfaceElement"] = "interface";
	        /** type T = ... */
	        ScriptElementKind["typeElement"] = "type";
	        /** enum E */
	        ScriptElementKind["enumElement"] = "enum";
	        ScriptElementKind["enumMemberElement"] = "enum member";
	        /**
	         * Inside module and script only
	         * const v = ..
	         */
	        ScriptElementKind["variableElement"] = "var";
	        /** Inside function */
	        ScriptElementKind["localVariableElement"] = "local var";
	        /**
	         * Inside module and script only
	         * function f() { }
	         */
	        ScriptElementKind["functionElement"] = "function";
	        /** Inside function */
	        ScriptElementKind["localFunctionElement"] = "local function";
	        /** class X { [public|private]* foo() {} } */
	        ScriptElementKind["memberFunctionElement"] = "method";
	        /** class X { [public|private]* [get|set] foo:number; } */
	        ScriptElementKind["memberGetAccessorElement"] = "getter";
	        ScriptElementKind["memberSetAccessorElement"] = "setter";
	        /**
	         * class X { [public|private]* foo:number; }
	         * interface Y { foo:number; }
	         */
	        ScriptElementKind["memberVariableElement"] = "property";
	        /** class X { constructor() { } } */
	        ScriptElementKind["constructorImplementationElement"] = "constructor";
	        /** interface Y { ():number; } */
	        ScriptElementKind["callSignatureElement"] = "call";
	        /** interface Y { []:number; } */
	        ScriptElementKind["indexSignatureElement"] = "index";
	        /** interface Y { new():Y; } */
	        ScriptElementKind["constructSignatureElement"] = "construct";
	        /** function foo(*Y*: string) */
	        ScriptElementKind["parameterElement"] = "parameter";
	        ScriptElementKind["typeParameterElement"] = "type parameter";
	        ScriptElementKind["primitiveType"] = "primitive type";
	        ScriptElementKind["label"] = "label";
	        ScriptElementKind["alias"] = "alias";
	        ScriptElementKind["constElement"] = "const";
	        ScriptElementKind["letElement"] = "let";
	        ScriptElementKind["directory"] = "directory";
	        ScriptElementKind["externalModuleName"] = "external module name";
	        /**
	         * <JsxTagName attribute1 attribute2={0} />
	         */
	        ScriptElementKind["jsxAttribute"] = "JSX attribute";
	    })(ScriptElementKind = ts.ScriptElementKind || (ts.ScriptElementKind = {}));
	    var ScriptElementKindModifier;
	    (function (ScriptElementKindModifier) {
	        ScriptElementKindModifier["none"] = "";
	        ScriptElementKindModifier["publicMemberModifier"] = "public";
	        ScriptElementKindModifier["privateMemberModifier"] = "private";
	        ScriptElementKindModifier["protectedMemberModifier"] = "protected";
	        ScriptElementKindModifier["exportedModifier"] = "export";
	        ScriptElementKindModifier["ambientModifier"] = "declare";
	        ScriptElementKindModifier["staticModifier"] = "static";
	        ScriptElementKindModifier["abstractModifier"] = "abstract";
	        ScriptElementKindModifier["optionalModifier"] = "optional";
	    })(ScriptElementKindModifier = ts.ScriptElementKindModifier || (ts.ScriptElementKindModifier = {}));
	    var ClassificationTypeNames;
	    (function (ClassificationTypeNames) {
	        ClassificationTypeNames["comment"] = "comment";
	        ClassificationTypeNames["identifier"] = "identifier";
	        ClassificationTypeNames["keyword"] = "keyword";
	        ClassificationTypeNames["numericLiteral"] = "number";
	        ClassificationTypeNames["operator"] = "operator";
	        ClassificationTypeNames["stringLiteral"] = "string";
	        ClassificationTypeNames["whiteSpace"] = "whitespace";
	        ClassificationTypeNames["text"] = "text";
	        ClassificationTypeNames["punctuation"] = "punctuation";
	        ClassificationTypeNames["className"] = "class name";
	        ClassificationTypeNames["enumName"] = "enum name";
	        ClassificationTypeNames["interfaceName"] = "interface name";
	        ClassificationTypeNames["moduleName"] = "module name";
	        ClassificationTypeNames["typeParameterName"] = "type parameter name";
	        ClassificationTypeNames["typeAliasName"] = "type alias name";
	        ClassificationTypeNames["parameterName"] = "parameter name";
	        ClassificationTypeNames["docCommentTagName"] = "doc comment tag name";
	        ClassificationTypeNames["jsxOpenTagName"] = "jsx open tag name";
	        ClassificationTypeNames["jsxCloseTagName"] = "jsx close tag name";
	        ClassificationTypeNames["jsxSelfClosingTagName"] = "jsx self closing tag name";
	        ClassificationTypeNames["jsxAttribute"] = "jsx attribute";
	        ClassificationTypeNames["jsxText"] = "jsx text";
	        ClassificationTypeNames["jsxAttributeStringLiteralValue"] = "jsx attribute string literal value";
	    })(ClassificationTypeNames = ts.ClassificationTypeNames || (ts.ClassificationTypeNames = {}));
	    var ClassificationType;
	    (function (ClassificationType) {
	        ClassificationType[ClassificationType["comment"] = 1] = "comment";
	        ClassificationType[ClassificationType["identifier"] = 2] = "identifier";
	        ClassificationType[ClassificationType["keyword"] = 3] = "keyword";
	        ClassificationType[ClassificationType["numericLiteral"] = 4] = "numericLiteral";
	        ClassificationType[ClassificationType["operator"] = 5] = "operator";
	        ClassificationType[ClassificationType["stringLiteral"] = 6] = "stringLiteral";
	        ClassificationType[ClassificationType["regularExpressionLiteral"] = 7] = "regularExpressionLiteral";
	        ClassificationType[ClassificationType["whiteSpace"] = 8] = "whiteSpace";
	        ClassificationType[ClassificationType["text"] = 9] = "text";
	        ClassificationType[ClassificationType["punctuation"] = 10] = "punctuation";
	        ClassificationType[ClassificationType["className"] = 11] = "className";
	        ClassificationType[ClassificationType["enumName"] = 12] = "enumName";
	        ClassificationType[ClassificationType["interfaceName"] = 13] = "interfaceName";
	        ClassificationType[ClassificationType["moduleName"] = 14] = "moduleName";
	        ClassificationType[ClassificationType["typeParameterName"] = 15] = "typeParameterName";
	        ClassificationType[ClassificationType["typeAliasName"] = 16] = "typeAliasName";
	        ClassificationType[ClassificationType["parameterName"] = 17] = "parameterName";
	        ClassificationType[ClassificationType["docCommentTagName"] = 18] = "docCommentTagName";
	        ClassificationType[ClassificationType["jsxOpenTagName"] = 19] = "jsxOpenTagName";
	        ClassificationType[ClassificationType["jsxCloseTagName"] = 20] = "jsxCloseTagName";
	        ClassificationType[ClassificationType["jsxSelfClosingTagName"] = 21] = "jsxSelfClosingTagName";
	        ClassificationType[ClassificationType["jsxAttribute"] = 22] = "jsxAttribute";
	        ClassificationType[ClassificationType["jsxText"] = 23] = "jsxText";
	        ClassificationType[ClassificationType["jsxAttributeStringLiteralValue"] = 24] = "jsxAttributeStringLiteralValue";
	    })(ClassificationType = ts.ClassificationType || (ts.ClassificationType = {}));
	})(ts || (ts = {}));
	// These utilities are common to multiple language service features.
	/* @internal */
	var ts;
	(function (ts) {
	    ts.scanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ true);
	    var SemanticMeaning;
	    (function (SemanticMeaning) {
	        SemanticMeaning[SemanticMeaning["None"] = 0] = "None";
	        SemanticMeaning[SemanticMeaning["Value"] = 1] = "Value";
	        SemanticMeaning[SemanticMeaning["Type"] = 2] = "Type";
	        SemanticMeaning[SemanticMeaning["Namespace"] = 4] = "Namespace";
	        SemanticMeaning[SemanticMeaning["All"] = 7] = "All";
	    })(SemanticMeaning = ts.SemanticMeaning || (ts.SemanticMeaning = {}));
	    function getMeaningFromDeclaration(node) {
	        switch (node.kind) {
	            case 148 /* Parameter */:
	            case 230 /* VariableDeclaration */:
	            case 180 /* BindingElement */:
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 268 /* PropertyAssignment */:
	            case 269 /* ShorthandPropertyAssignment */:
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 232 /* FunctionDeclaration */:
	            case 190 /* FunctionExpression */:
	            case 191 /* ArrowFunction */:
	            case 267 /* CatchClause */:
	            case 260 /* JsxAttribute */:
	                return 1 /* Value */;
	            case 147 /* TypeParameter */:
	            case 234 /* InterfaceDeclaration */:
	            case 235 /* TypeAliasDeclaration */:
	            case 165 /* TypeLiteral */:
	                return 2 /* Type */;
	            case 291 /* JSDocTypedefTag */:
	                // If it has no name node, it shares the name with the value declaration below it.
	                return node.name === undefined ? 1 /* Value */ | 2 /* Type */ : 2 /* Type */;
	            case 271 /* EnumMember */:
	            case 233 /* ClassDeclaration */:
	                return 1 /* Value */ | 2 /* Type */;
	            case 237 /* ModuleDeclaration */:
	                if (ts.isAmbientModule(node)) {
	                    return 4 /* Namespace */ | 1 /* Value */;
	                }
	                else if (ts.getModuleInstanceState(node) === 1 /* Instantiated */) {
	                    return 4 /* Namespace */ | 1 /* Value */;
	                }
	                else {
	                    return 4 /* Namespace */;
	                }
	            case 236 /* EnumDeclaration */:
	            case 245 /* NamedImports */:
	            case 246 /* ImportSpecifier */:
	            case 241 /* ImportEqualsDeclaration */:
	            case 242 /* ImportDeclaration */:
	            case 247 /* ExportAssignment */:
	            case 248 /* ExportDeclaration */:
	                return 7 /* All */;
	            // An external module can be a Value
	            case 272 /* SourceFile */:
	                return 4 /* Namespace */ | 1 /* Value */;
	        }
	        return 7 /* All */;
	    }
	    ts.getMeaningFromDeclaration = getMeaningFromDeclaration;
	    function getMeaningFromLocation(node) {
	        if (node.kind === 272 /* SourceFile */) {
	            return 1 /* Value */;
	        }
	        else if (node.parent.kind === 247 /* ExportAssignment */) {
	            return 7 /* All */;
	        }
	        else if (isInRightSideOfInternalImportEqualsDeclaration(node)) {
	            return getMeaningFromRightHandSideOfImportEquals(node);
	        }
	        else if (ts.isDeclarationName(node)) {
	            return getMeaningFromDeclaration(node.parent);
	        }
	        else if (isTypeReference(node)) {
	            return 2 /* Type */;
	        }
	        else if (isNamespaceReference(node)) {
	            return 4 /* Namespace */;
	        }
	        else if (ts.isTypeParameterDeclaration(node.parent)) {
	            ts.Debug.assert(ts.isJSDocTemplateTag(node.parent.parent)); // Else would be handled by isDeclarationName
	            return 2 /* Type */;
	        }
	        else {
	            return 1 /* Value */;
	        }
	    }
	    ts.getMeaningFromLocation = getMeaningFromLocation;
	    function getMeaningFromRightHandSideOfImportEquals(node) {
	        //     import a = |b|; // Namespace
	        //     import a = |b.c|; // Value, type, namespace
	        //     import a = |b.c|.d; // Namespace
	        var name = node.kind === 145 /* QualifiedName */ ? node : ts.isQualifiedName(node.parent) && node.parent.right === node ? node.parent : undefined;
	        return name && name.parent.kind === 241 /* ImportEqualsDeclaration */ ? 7 /* All */ : 4 /* Namespace */;
	    }
	    function isInRightSideOfInternalImportEqualsDeclaration(node) {
	        while (node.parent.kind === 145 /* QualifiedName */) {
	            node = node.parent;
	        }
	        return ts.isInternalModuleImportEqualsDeclaration(node.parent) && node.parent.moduleReference === node;
	    }
	    ts.isInRightSideOfInternalImportEqualsDeclaration = isInRightSideOfInternalImportEqualsDeclaration;
	    function isNamespaceReference(node) {
	        return isQualifiedNameNamespaceReference(node) || isPropertyAccessNamespaceReference(node);
	    }
	    function isQualifiedNameNamespaceReference(node) {
	        var root = node;
	        var isLastClause = true;
	        if (root.parent.kind === 145 /* QualifiedName */) {
	            while (root.parent && root.parent.kind === 145 /* QualifiedName */) {
	                root = root.parent;
	            }
	            isLastClause = root.right === node;
	        }
	        return root.parent.kind === 161 /* TypeReference */ && !isLastClause;
	    }
	    function isPropertyAccessNamespaceReference(node) {
	        var root = node;
	        var isLastClause = true;
	        if (root.parent.kind === 183 /* PropertyAccessExpression */) {
	            while (root.parent && root.parent.kind === 183 /* PropertyAccessExpression */) {
	                root = root.parent;
	            }
	            isLastClause = root.name === node;
	        }
	        if (!isLastClause && root.parent.kind === 205 /* ExpressionWithTypeArguments */ && root.parent.parent.kind === 266 /* HeritageClause */) {
	            var decl = root.parent.parent.parent;
	            return (decl.kind === 233 /* ClassDeclaration */ && root.parent.parent.token === 108 /* ImplementsKeyword */) ||
	                (decl.kind === 234 /* InterfaceDeclaration */ && root.parent.parent.token === 85 /* ExtendsKeyword */);
	        }
	        return false;
	    }
	    function isTypeReference(node) {
	        if (ts.isRightSideOfQualifiedNameOrPropertyAccess(node)) {
	            node = node.parent;
	        }
	        switch (node.kind) {
	            case 99 /* ThisKeyword */:
	                return !ts.isExpressionNode(node);
	            case 173 /* ThisType */:
	                return true;
	        }
	        switch (node.parent.kind) {
	            case 161 /* TypeReference */:
	                return true;
	            case 205 /* ExpressionWithTypeArguments */:
	                return !ts.isExpressionWithTypeArgumentsInClassExtendsClause(node.parent);
	        }
	        return false;
	    }
	    function isCallExpressionTarget(node) {
	        return isCallOrNewExpressionTarget(node, 185 /* CallExpression */);
	    }
	    ts.isCallExpressionTarget = isCallExpressionTarget;
	    function isNewExpressionTarget(node) {
	        return isCallOrNewExpressionTarget(node, 186 /* NewExpression */);
	    }
	    ts.isNewExpressionTarget = isNewExpressionTarget;
	    function isCallOrNewExpressionTarget(node, kind) {
	        var target = climbPastPropertyAccess(node);
	        return target && target.parent && target.parent.kind === kind && target.parent.expression === target;
	    }
	    function climbPastPropertyAccess(node) {
	        return isRightSideOfPropertyAccess(node) ? node.parent : node;
	    }
	    ts.climbPastPropertyAccess = climbPastPropertyAccess;
	    function getTargetLabel(referenceNode, labelName) {
	        while (referenceNode) {
	            if (referenceNode.kind === 226 /* LabeledStatement */ && referenceNode.label.escapedText === labelName) {
	                return referenceNode.label;
	            }
	            referenceNode = referenceNode.parent;
	        }
	        return undefined;
	    }
	    ts.getTargetLabel = getTargetLabel;
	    function isJumpStatementTarget(node) {
	        return node.kind === 71 /* Identifier */ && ts.isBreakOrContinueStatement(node.parent) && node.parent.label === node;
	    }
	    ts.isJumpStatementTarget = isJumpStatementTarget;
	    function isLabelOfLabeledStatement(node) {
	        return node.kind === 71 /* Identifier */ && ts.isLabeledStatement(node.parent) && node.parent.label === node;
	    }
	    ts.isLabelOfLabeledStatement = isLabelOfLabeledStatement;
	    function isLabelName(node) {
	        return isLabelOfLabeledStatement(node) || isJumpStatementTarget(node);
	    }
	    ts.isLabelName = isLabelName;
	    function isRightSideOfQualifiedName(node) {
	        return node.parent.kind === 145 /* QualifiedName */ && node.parent.right === node;
	    }
	    ts.isRightSideOfQualifiedName = isRightSideOfQualifiedName;
	    function isRightSideOfPropertyAccess(node) {
	        return node && node.parent && node.parent.kind === 183 /* PropertyAccessExpression */ && node.parent.name === node;
	    }
	    ts.isRightSideOfPropertyAccess = isRightSideOfPropertyAccess;
	    function isNameOfModuleDeclaration(node) {
	        return node.parent.kind === 237 /* ModuleDeclaration */ && node.parent.name === node;
	    }
	    ts.isNameOfModuleDeclaration = isNameOfModuleDeclaration;
	    function isNameOfFunctionDeclaration(node) {
	        return node.kind === 71 /* Identifier */ &&
	            ts.isFunctionLike(node.parent) && node.parent.name === node;
	    }
	    ts.isNameOfFunctionDeclaration = isNameOfFunctionDeclaration;
	    function isLiteralNameOfPropertyDeclarationOrIndexAccess(node) {
	        switch (node.parent.kind) {
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 268 /* PropertyAssignment */:
	            case 271 /* EnumMember */:
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 237 /* ModuleDeclaration */:
	                return ts.getNameOfDeclaration(node.parent) === node;
	            case 184 /* ElementAccessExpression */:
	                return node.parent.argumentExpression === node;
	            case 146 /* ComputedPropertyName */:
	                return true;
	            case 177 /* LiteralType */:
	                return node.parent.parent.kind === 175 /* IndexedAccessType */;
	        }
	    }
	    ts.isLiteralNameOfPropertyDeclarationOrIndexAccess = isLiteralNameOfPropertyDeclarationOrIndexAccess;
	    function isExpressionOfExternalModuleImportEqualsDeclaration(node) {
	        return ts.isExternalModuleImportEqualsDeclaration(node.parent.parent) &&
	            ts.getExternalModuleImportEqualsDeclarationExpression(node.parent.parent) === node;
	    }
	    ts.isExpressionOfExternalModuleImportEqualsDeclaration = isExpressionOfExternalModuleImportEqualsDeclaration;
	    function getContainerNode(node) {
	        if (node.kind === 291 /* JSDocTypedefTag */) {
	            // This doesn't just apply to the node immediately under the comment, but to everything in its parent's scope.
	            // node.parent = the JSDoc comment, node.parent.parent = the node having the comment.
	            // Then we get parent again in the loop.
	            node = node.parent.parent;
	        }
	        while (true) {
	            node = node.parent;
	            if (!node) {
	                return undefined;
	            }
	            switch (node.kind) {
	                case 272 /* SourceFile */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 233 /* ClassDeclaration */:
	                case 234 /* InterfaceDeclaration */:
	                case 236 /* EnumDeclaration */:
	                case 237 /* ModuleDeclaration */:
	                    return node;
	            }
	        }
	    }
	    ts.getContainerNode = getContainerNode;
	    function getNodeKind(node) {
	        switch (node.kind) {
	            case 272 /* SourceFile */:
	                return ts.isExternalModule(node) ? "module" /* moduleElement */ : "script" /* scriptElement */;
	            case 237 /* ModuleDeclaration */:
	                return "module" /* moduleElement */;
	            case 233 /* ClassDeclaration */:
	            case 203 /* ClassExpression */:
	                return "class" /* classElement */;
	            case 234 /* InterfaceDeclaration */: return "interface" /* interfaceElement */;
	            case 235 /* TypeAliasDeclaration */: return "type" /* typeElement */;
	            case 236 /* EnumDeclaration */: return "enum" /* enumElement */;
	            case 230 /* VariableDeclaration */:
	                return getKindOfVariableDeclaration(node);
	            case 180 /* BindingElement */:
	                return getKindOfVariableDeclaration(ts.getRootDeclaration(node));
	            case 191 /* ArrowFunction */:
	            case 232 /* FunctionDeclaration */:
	            case 190 /* FunctionExpression */:
	                return "function" /* functionElement */;
	            case 155 /* GetAccessor */: return "getter" /* memberGetAccessorElement */;
	            case 156 /* SetAccessor */: return "setter" /* memberSetAccessorElement */;
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	                return "method" /* memberFunctionElement */;
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	                return "property" /* memberVariableElement */;
	            case 159 /* IndexSignature */: return "index" /* indexSignatureElement */;
	            case 158 /* ConstructSignature */: return "construct" /* constructSignatureElement */;
	            case 157 /* CallSignature */: return "call" /* callSignatureElement */;
	            case 154 /* Constructor */: return "constructor" /* constructorImplementationElement */;
	            case 147 /* TypeParameter */: return "type parameter" /* typeParameterElement */;
	            case 271 /* EnumMember */: return "enum member" /* enumMemberElement */;
	            case 148 /* Parameter */: return ts.hasModifier(node, 92 /* ParameterPropertyModifier */) ? "property" /* memberVariableElement */ : "parameter" /* parameterElement */;
	            case 241 /* ImportEqualsDeclaration */:
	            case 246 /* ImportSpecifier */:
	            case 243 /* ImportClause */:
	            case 250 /* ExportSpecifier */:
	            case 244 /* NamespaceImport */:
	                return "alias" /* alias */;
	            case 291 /* JSDocTypedefTag */:
	                return "type" /* typeElement */;
	            case 198 /* BinaryExpression */:
	                var kind = ts.getSpecialPropertyAssignmentKind(node);
	                var right = node.right;
	                switch (kind) {
	                    case 0 /* None */:
	                        return "" /* unknown */;
	                    case 1 /* ExportsProperty */:
	                    case 2 /* ModuleExports */:
	                        var rightKind = getNodeKind(right);
	                        return rightKind === "" /* unknown */ ? "const" /* constElement */ : rightKind;
	                    case 3 /* PrototypeProperty */:
	                        return ts.isFunctionExpression(right) ? "method" /* memberFunctionElement */ : "property" /* memberVariableElement */;
	                    case 4 /* ThisProperty */:
	                        return "property" /* memberVariableElement */; // property
	                    case 5 /* Property */:
	                        // static method / property
	                        return ts.isFunctionExpression(right) ? "method" /* memberFunctionElement */ : "property" /* memberVariableElement */;
	                    default: {
	                        ts.assertTypeIsNever(kind);
	                        return "" /* unknown */;
	                    }
	                }
	            default:
	                return "" /* unknown */;
	        }
	        function getKindOfVariableDeclaration(v) {
	            return ts.isConst(v)
	                ? "const" /* constElement */
	                : ts.isLet(v)
	                    ? "let" /* letElement */
	                    : "var" /* variableElement */;
	        }
	    }
	    ts.getNodeKind = getNodeKind;
	    function isThis(node) {
	        switch (node.kind) {
	            case 99 /* ThisKeyword */:
	                // case SyntaxKind.ThisType: TODO: GH#9267
	                return true;
	            case 71 /* Identifier */:
	                // 'this' as a parameter
	                return ts.identifierIsThisKeyword(node) && node.parent.kind === 148 /* Parameter */;
	            default:
	                return false;
	        }
	    }
	    ts.isThis = isThis;
	    // Matches the beginning of a triple slash directive
	    var tripleSlashDirectivePrefixRegex = /^\/\/\/\s*</;
	    function getLineStartPositionForPosition(position, sourceFile) {
	        var lineStarts = ts.getLineStarts(sourceFile);
	        var line = sourceFile.getLineAndCharacterOfPosition(position).line;
	        return lineStarts[line];
	    }
	    ts.getLineStartPositionForPosition = getLineStartPositionForPosition;
	    function rangeContainsRange(r1, r2) {
	        return startEndContainsRange(r1.pos, r1.end, r2);
	    }
	    ts.rangeContainsRange = rangeContainsRange;
	    function startEndContainsRange(start, end, range) {
	        return start <= range.pos && end >= range.end;
	    }
	    ts.startEndContainsRange = startEndContainsRange;
	    function rangeContainsStartEnd(range, start, end) {
	        return range.pos <= start && range.end >= end;
	    }
	    ts.rangeContainsStartEnd = rangeContainsStartEnd;
	    function rangeOverlapsWithStartEnd(r1, start, end) {
	        return startEndOverlapsWithStartEnd(r1.pos, r1.end, start, end);
	    }
	    ts.rangeOverlapsWithStartEnd = rangeOverlapsWithStartEnd;
	    function startEndOverlapsWithStartEnd(start1, end1, start2, end2) {
	        var start = Math.max(start1, start2);
	        var end = Math.min(end1, end2);
	        return start < end;
	    }
	    ts.startEndOverlapsWithStartEnd = startEndOverlapsWithStartEnd;
	    /**
	     * Assumes `candidate.start <= position` holds.
	     */
	    function positionBelongsToNode(candidate, position, sourceFile) {
	        ts.Debug.assert(candidate.pos <= position);
	        return position < candidate.end || !isCompletedNode(candidate, sourceFile);
	    }
	    ts.positionBelongsToNode = positionBelongsToNode;
	    function isCompletedNode(n, sourceFile) {
	        if (ts.nodeIsMissing(n)) {
	            return false;
	        }
	        switch (n.kind) {
	            case 233 /* ClassDeclaration */:
	            case 234 /* InterfaceDeclaration */:
	            case 236 /* EnumDeclaration */:
	            case 182 /* ObjectLiteralExpression */:
	            case 178 /* ObjectBindingPattern */:
	            case 165 /* TypeLiteral */:
	            case 211 /* Block */:
	            case 238 /* ModuleBlock */:
	            case 239 /* CaseBlock */:
	            case 245 /* NamedImports */:
	            case 249 /* NamedExports */:
	                return nodeEndsWith(n, 18 /* CloseBraceToken */, sourceFile);
	            case 267 /* CatchClause */:
	                return isCompletedNode(n.block, sourceFile);
	            case 186 /* NewExpression */:
	                if (!n.arguments) {
	                    return true;
	                }
	            // falls through
	            case 185 /* CallExpression */:
	            case 189 /* ParenthesizedExpression */:
	            case 172 /* ParenthesizedType */:
	                return nodeEndsWith(n, 20 /* CloseParenToken */, sourceFile);
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	                return isCompletedNode(n.type, sourceFile);
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 232 /* FunctionDeclaration */:
	            case 190 /* FunctionExpression */:
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 158 /* ConstructSignature */:
	            case 157 /* CallSignature */:
	            case 191 /* ArrowFunction */:
	                if (n.body) {
	                    return isCompletedNode(n.body, sourceFile);
	                }
	                if (n.type) {
	                    return isCompletedNode(n.type, sourceFile);
	                }
	                // Even though type parameters can be unclosed, we can get away with
	                // having at least a closing paren.
	                return hasChildOfKind(n, 20 /* CloseParenToken */, sourceFile);
	            case 237 /* ModuleDeclaration */:
	                return n.body && isCompletedNode(n.body, sourceFile);
	            case 215 /* IfStatement */:
	                if (n.elseStatement) {
	                    return isCompletedNode(n.elseStatement, sourceFile);
	                }
	                return isCompletedNode(n.thenStatement, sourceFile);
	            case 214 /* ExpressionStatement */:
	                return isCompletedNode(n.expression, sourceFile) ||
	                    hasChildOfKind(n, 25 /* SemicolonToken */, sourceFile);
	            case 181 /* ArrayLiteralExpression */:
	            case 179 /* ArrayBindingPattern */:
	            case 184 /* ElementAccessExpression */:
	            case 146 /* ComputedPropertyName */:
	            case 167 /* TupleType */:
	                return nodeEndsWith(n, 22 /* CloseBracketToken */, sourceFile);
	            case 159 /* IndexSignature */:
	                if (n.type) {
	                    return isCompletedNode(n.type, sourceFile);
	                }
	                return hasChildOfKind(n, 22 /* CloseBracketToken */, sourceFile);
	            case 264 /* CaseClause */:
	            case 265 /* DefaultClause */:
	                // there is no such thing as terminator token for CaseClause/DefaultClause so for simplicity always consider them non-completed
	                return false;
	            case 218 /* ForStatement */:
	            case 219 /* ForInStatement */:
	            case 220 /* ForOfStatement */:
	            case 217 /* WhileStatement */:
	                return isCompletedNode(n.statement, sourceFile);
	            case 216 /* DoStatement */:
	                // rough approximation: if DoStatement has While keyword - then if node is completed is checking the presence of ')';
	                return hasChildOfKind(n, 106 /* WhileKeyword */, sourceFile)
	                    ? nodeEndsWith(n, 20 /* CloseParenToken */, sourceFile)
	                    : isCompletedNode(n.statement, sourceFile);
	            case 164 /* TypeQuery */:
	                return isCompletedNode(n.exprName, sourceFile);
	            case 193 /* TypeOfExpression */:
	            case 192 /* DeleteExpression */:
	            case 194 /* VoidExpression */:
	            case 201 /* YieldExpression */:
	            case 202 /* SpreadElement */:
	                var unaryWordExpression = n;
	                return isCompletedNode(unaryWordExpression.expression, sourceFile);
	            case 187 /* TaggedTemplateExpression */:
	                return isCompletedNode(n.template, sourceFile);
	            case 200 /* TemplateExpression */:
	                var lastSpan = ts.lastOrUndefined(n.templateSpans);
	                return isCompletedNode(lastSpan, sourceFile);
	            case 209 /* TemplateSpan */:
	                return ts.nodeIsPresent(n.literal);
	            case 248 /* ExportDeclaration */:
	            case 242 /* ImportDeclaration */:
	                return ts.nodeIsPresent(n.moduleSpecifier);
	            case 196 /* PrefixUnaryExpression */:
	                return isCompletedNode(n.operand, sourceFile);
	            case 198 /* BinaryExpression */:
	                return isCompletedNode(n.right, sourceFile);
	            case 199 /* ConditionalExpression */:
	                return isCompletedNode(n.whenFalse, sourceFile);
	            default:
	                return true;
	        }
	    }
	    /*
	     * Checks if node ends with 'expectedLastToken'.
	     * If child at position 'length - 1' is 'SemicolonToken' it is skipped and 'expectedLastToken' is compared with child at position 'length - 2'.
	     */
	    function nodeEndsWith(n, expectedLastToken, sourceFile) {
	        var children = n.getChildren(sourceFile);
	        if (children.length) {
	            var last_2 = ts.lastOrUndefined(children);
	            if (last_2.kind === expectedLastToken) {
	                return true;
	            }
	            else if (last_2.kind === 25 /* SemicolonToken */ && children.length !== 1) {
	                return children[children.length - 2].kind === expectedLastToken;
	            }
	        }
	        return false;
	    }
	    function findListItemInfo(node) {
	        var list = findContainingList(node);
	        // It is possible at this point for syntaxList to be undefined, either if
	        // node.parent had no list child, or if none of its list children contained
	        // the span of node. If this happens, return undefined. The caller should
	        // handle this case.
	        if (!list) {
	            return undefined;
	        }
	        var children = list.getChildren();
	        var listItemIndex = ts.indexOfNode(children, node);
	        return {
	            listItemIndex: listItemIndex,
	            list: list
	        };
	    }
	    ts.findListItemInfo = findListItemInfo;
	    function hasChildOfKind(n, kind, sourceFile) {
	        return !!findChildOfKind(n, kind, sourceFile);
	    }
	    ts.hasChildOfKind = hasChildOfKind;
	    function findChildOfKind(n, kind, sourceFile) {
	        return ts.find(n.getChildren(sourceFile), function (c) { return c.kind === kind; });
	    }
	    ts.findChildOfKind = findChildOfKind;
	    function findContainingList(node) {
	        // The node might be a list element (nonsynthetic) or a comma (synthetic). Either way, it will
	        // be parented by the container of the SyntaxList, not the SyntaxList itself.
	        // In order to find the list item index, we first need to locate SyntaxList itself and then search
	        // for the position of the relevant node (or comma).
	        var syntaxList = ts.find(node.parent.getChildren(), function (c) { return ts.isSyntaxList(c) && rangeContainsRange(c, node); });
	        // Either we didn't find an appropriate list, or the list must contain us.
	        ts.Debug.assert(!syntaxList || ts.contains(syntaxList.getChildren(), node));
	        return syntaxList;
	    }
	    ts.findContainingList = findContainingList;
	    /* Gets the token whose text has range [start, end) and
	     * position >= start and (position < end or (position === end && token is keyword or identifier))
	     */
	    function getTouchingWord(sourceFile, position, includeJsDocComment) {
	        return getTouchingToken(sourceFile, position, includeJsDocComment, function (n) { return isWord(n.kind); });
	    }
	    ts.getTouchingWord = getTouchingWord;
	    /* Gets the token whose text has range [start, end) and position >= start
	     * and (position < end or (position === end && token is keyword or identifier or numeric/string literal))
	     */
	    function getTouchingPropertyName(sourceFile, position, includeJsDocComment) {
	        return getTouchingToken(sourceFile, position, includeJsDocComment, function (n) { return isPropertyName(n.kind); });
	    }
	    ts.getTouchingPropertyName = getTouchingPropertyName;
	    /**
	     * Returns the token if position is in [start, end).
	     * If position === end, returns the preceding token if includeItemAtEndPosition(previousToken) === true
	     */
	    function getTouchingToken(sourceFile, position, includeJsDocComment, includePrecedingTokenAtEndPosition) {
	        return getTokenAtPositionWorker(sourceFile, position, /*allowPositionInLeadingTrivia*/ false, includePrecedingTokenAtEndPosition, /*includeEndPosition*/ false, includeJsDocComment);
	    }
	    ts.getTouchingToken = getTouchingToken;
	    /** Returns a token if position is in [start-of-leading-trivia, end) */
	    function getTokenAtPosition(sourceFile, position, includeJsDocComment, includeEndPosition) {
	        return getTokenAtPositionWorker(sourceFile, position, /*allowPositionInLeadingTrivia*/ true, /*includePrecedingTokenAtEndPosition*/ undefined, includeEndPosition, includeJsDocComment);
	    }
	    ts.getTokenAtPosition = getTokenAtPosition;
	    /** Get the token whose text contains the position */
	    function getTokenAtPositionWorker(sourceFile, position, allowPositionInLeadingTrivia, includePrecedingTokenAtEndPosition, includeEndPosition, includeJsDocComment) {
	        var current = sourceFile;
	        outer: while (true) {
	            if (ts.isToken(current)) {
	                // exit early
	                return current;
	            }
	            // find the child that contains 'position'
	            for (var _i = 0, _a = current.getChildren(); _i < _a.length; _i++) {
	                var child = _a[_i];
	                if (!includeJsDocComment && ts.isJSDocNode(child)) {
	                    continue;
	                }
	                var start = allowPositionInLeadingTrivia ? child.getFullStart() : child.getStart(sourceFile, includeJsDocComment);
	                if (start > position) {
	                    // If this child begins after position, then all subsequent children will as well.
	                    break;
	                }
	                var end = child.getEnd();
	                if (position < end || (position === end && (child.kind === 1 /* EndOfFileToken */ || includeEndPosition))) {
	                    current = child;
	                    continue outer;
	                }
	                else if (includePrecedingTokenAtEndPosition && end === position) {
	                    var previousToken = findPrecedingToken(position, sourceFile, child);
	                    if (previousToken && includePrecedingTokenAtEndPosition(previousToken)) {
	                        return previousToken;
	                    }
	                }
	            }
	            return current;
	        }
	    }
	    /**
	     * The token on the left of the position is the token that strictly includes the position
	     * or sits to the left of the cursor if it is on a boundary. For example
	     *
	     *   fo|o               -> will return foo
	     *   foo <comment> |bar -> will return foo
	     *
	     */
	    function findTokenOnLeftOfPosition(file, position) {
	        // Ideally, getTokenAtPosition should return a token. However, it is currently
	        // broken, so we do a check to make sure the result was indeed a token.
	        var tokenAtPosition = getTokenAtPosition(file, position, /*includeJsDocComment*/ false);
	        if (ts.isToken(tokenAtPosition) && position > tokenAtPosition.getStart(file) && position < tokenAtPosition.getEnd()) {
	            return tokenAtPosition;
	        }
	        return findPrecedingToken(position, file);
	    }
	    ts.findTokenOnLeftOfPosition = findTokenOnLeftOfPosition;
	    function findNextToken(previousToken, parent) {
	        return find(parent);
	        function find(n) {
	            if (ts.isToken(n) && n.pos === previousToken.end) {
	                // this is token that starts at the end of previous token - return it
	                return n;
	            }
	            var children = n.getChildren();
	            for (var _i = 0, children_3 = children; _i < children_3.length; _i++) {
	                var child = children_3[_i];
	                var shouldDiveInChildNode = 
	                // previous token is enclosed somewhere in the child
	                (child.pos <= previousToken.pos && child.end > previousToken.end) ||
	                    // previous token ends exactly at the beginning of child
	                    (child.pos === previousToken.end);
	                if (shouldDiveInChildNode && nodeHasTokens(child)) {
	                    return find(child);
	                }
	            }
	            return undefined;
	        }
	    }
	    ts.findNextToken = findNextToken;
	    /**
	     * Finds the rightmost token satisfying `token.end <= position`,
	     * excluding `JsxText` tokens containing only whitespace.
	     */
	    function findPrecedingToken(position, sourceFile, startNode, includeJsDoc) {
	        var result = find(startNode || sourceFile);
	        ts.Debug.assert(!(result && isWhiteSpaceOnlyJsxText(result)));
	        return result;
	        function find(n) {
	            if (isNonWhitespaceToken(n)) {
	                return n;
	            }
	            var children = n.getChildren(sourceFile);
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i];
	                // Note that the span of a node's tokens is [node.getStart(...), node.end).
	                // Given that `position < child.end` and child has constituent tokens, we distinguish these cases:
	                // 1) `position` precedes `child`'s tokens or `child` has no tokens (ie: in a comment or whitespace preceding `child`):
	                // we need to find the last token in a previous child.
	                // 2) `position` is within the same span: we recurse on `child`.
	                if (position < child.end) {
	                    var start = child.getStart(sourceFile, includeJsDoc);
	                    var lookInPreviousChild = (start >= position) || // cursor in the leading trivia
	                        !nodeHasTokens(child) ||
	                        isWhiteSpaceOnlyJsxText(child);
	                    if (lookInPreviousChild) {
	                        // actual start of the node is past the position - previous token should be at the end of previous child
	                        var candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ i);
	                        return candidate && findRightmostToken(candidate, sourceFile);
	                    }
	                    else {
	                        // candidate should be in this node
	                        return find(child);
	                    }
	                }
	            }
	            ts.Debug.assert(startNode !== undefined || n.kind === 272 /* SourceFile */ || ts.isJSDocCommentContainingNode(n));
	            // Here we know that none of child token nodes embrace the position,
	            // the only known case is when position is at the end of the file.
	            // Try to find the rightmost token in the file without filtering.
	            // Namely we are skipping the check: 'position < node.end'
	            if (children.length) {
	                var candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ children.length);
	                return candidate && findRightmostToken(candidate, sourceFile);
	            }
	        }
	    }
	    ts.findPrecedingToken = findPrecedingToken;
	    function isNonWhitespaceToken(n) {
	        return ts.isToken(n) && !isWhiteSpaceOnlyJsxText(n);
	    }
	    function findRightmostToken(n, sourceFile) {
	        if (isNonWhitespaceToken(n)) {
	            return n;
	        }
	        var children = n.getChildren(sourceFile);
	        var candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ children.length);
	        return candidate && findRightmostToken(candidate, sourceFile);
	    }
	    /**
	     * Finds the rightmost child to the left of `children[exclusiveStartPosition]` which is a non-all-whitespace token or has constituent tokens.
	     */
	    function findRightmostChildNodeWithTokens(children, exclusiveStartPosition) {
	        for (var i = exclusiveStartPosition - 1; i >= 0; i--) {
	            var child = children[i];
	            if (isWhiteSpaceOnlyJsxText(child)) {
	                ts.Debug.assert(i > 0, "`JsxText` tokens should not be the first child of `JsxElement | JsxSelfClosingElement`");
	            }
	            else if (nodeHasTokens(children[i])) {
	                return children[i];
	            }
	        }
	    }
	    function isInString(sourceFile, position, previousToken) {
	        if (previousToken === void 0) { previousToken = findPrecedingToken(position, sourceFile); }
	        if (previousToken && ts.isStringTextContainingNode(previousToken)) {
	            var start = previousToken.getStart();
	            var end = previousToken.getEnd();
	            // To be "in" one of these literals, the position has to be:
	            //   1. entirely within the token text.
	            //   2. at the end position of an unterminated token.
	            //   3. at the end of a regular expression (due to trailing flags like '/foo/g').
	            if (start < position && position < end) {
	                return true;
	            }
	            if (position === end) {
	                return !!previousToken.isUnterminated;
	            }
	        }
	        return false;
	    }
	    ts.isInString = isInString;
	    /**
	     * returns true if the position is in between the open and close elements of an JSX expression.
	     */
	    function isInsideJsxElementOrAttribute(sourceFile, position) {
	        var token = getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	        if (!token) {
	            return false;
	        }
	        if (token.kind === 10 /* JsxText */) {
	            return true;
	        }
	        // <div>Hello |</div>
	        if (token.kind === 27 /* LessThanToken */ && token.parent.kind === 10 /* JsxText */) {
	            return true;
	        }
	        // <div> { | </div> or <div a={| </div>
	        if (token.kind === 27 /* LessThanToken */ && token.parent.kind === 263 /* JsxExpression */) {
	            return true;
	        }
	        // <div> {
	        // |
	        // } < /div>
	        if (token && token.kind === 18 /* CloseBraceToken */ && token.parent.kind === 263 /* JsxExpression */) {
	            return true;
	        }
	        // <div>|</div>
	        if (token.kind === 27 /* LessThanToken */ && token.parent.kind === 256 /* JsxClosingElement */) {
	            return true;
	        }
	        return false;
	    }
	    ts.isInsideJsxElementOrAttribute = isInsideJsxElementOrAttribute;
	    function isWhiteSpaceOnlyJsxText(node) {
	        return ts.isJsxText(node) && node.containsOnlyWhiteSpaces;
	    }
	    function isInTemplateString(sourceFile, position) {
	        var token = getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	        return ts.isTemplateLiteralKind(token.kind) && position > token.getStart(sourceFile);
	    }
	    ts.isInTemplateString = isInTemplateString;
	    /**
	     * Returns true if the cursor at position in sourceFile is within a comment.
	     *
	     * @param tokenAtPosition Must equal `getTokenAtPosition(sourceFile, position)
	     * @param predicate Additional predicate to test on the comment range.
	     */
	    function isInComment(sourceFile, position, tokenAtPosition, predicate) {
	        return !!ts.formatting.getRangeOfEnclosingComment(sourceFile, position, /*onlyMultiLine*/ false, /*precedingToken*/ undefined, tokenAtPosition, predicate);
	    }
	    ts.isInComment = isInComment;
	    function hasDocComment(sourceFile, position) {
	        var token = getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	        // First, we have to see if this position actually landed in a comment.
	        var commentRanges = ts.getLeadingCommentRanges(sourceFile.text, token.pos);
	        return ts.forEach(commentRanges, jsDocPrefix);
	        function jsDocPrefix(c) {
	            var text = sourceFile.text;
	            return text.length >= c.pos + 3 && text[c.pos] === "/" && text[c.pos + 1] === "*" && text[c.pos + 2] === "*";
	        }
	    }
	    ts.hasDocComment = hasDocComment;
	    function nodeHasTokens(n) {
	        // If we have a token or node that has a non-zero width, it must have tokens.
	        // Note: getWidth() does not take trivia into account.
	        return n.getWidth() !== 0;
	    }
	    function getNodeModifiers(node) {
	        var flags = ts.getCombinedModifierFlags(node);
	        var result = [];
	        if (flags & 8 /* Private */)
	            result.push("private" /* privateMemberModifier */);
	        if (flags & 16 /* Protected */)
	            result.push("protected" /* protectedMemberModifier */);
	        if (flags & 4 /* Public */)
	            result.push("public" /* publicMemberModifier */);
	        if (flags & 32 /* Static */)
	            result.push("static" /* staticModifier */);
	        if (flags & 128 /* Abstract */)
	            result.push("abstract" /* abstractModifier */);
	        if (flags & 1 /* Export */)
	            result.push("export" /* exportedModifier */);
	        if (node.flags & 2097152 /* Ambient */)
	            result.push("declare" /* ambientModifier */);
	        return result.length > 0 ? result.join(",") : "" /* none */;
	    }
	    ts.getNodeModifiers = getNodeModifiers;
	    function getTypeArgumentOrTypeParameterList(node) {
	        if (node.kind === 161 /* TypeReference */ || node.kind === 185 /* CallExpression */) {
	            return node.typeArguments;
	        }
	        if (ts.isFunctionLike(node) || node.kind === 233 /* ClassDeclaration */ || node.kind === 234 /* InterfaceDeclaration */) {
	            return node.typeParameters;
	        }
	        return undefined;
	    }
	    ts.getTypeArgumentOrTypeParameterList = getTypeArgumentOrTypeParameterList;
	    function isWord(kind) {
	        return kind === 71 /* Identifier */ || ts.isKeyword(kind);
	    }
	    ts.isWord = isWord;
	    function isPropertyName(kind) {
	        return kind === 9 /* StringLiteral */ || kind === 8 /* NumericLiteral */ || isWord(kind);
	    }
	    function isComment(kind) {
	        return kind === 2 /* SingleLineCommentTrivia */ || kind === 3 /* MultiLineCommentTrivia */;
	    }
	    ts.isComment = isComment;
	    function isStringOrRegularExpressionOrTemplateLiteral(kind) {
	        if (kind === 9 /* StringLiteral */
	            || kind === 12 /* RegularExpressionLiteral */
	            || ts.isTemplateLiteralKind(kind)) {
	            return true;
	        }
	        return false;
	    }
	    ts.isStringOrRegularExpressionOrTemplateLiteral = isStringOrRegularExpressionOrTemplateLiteral;
	    function isPunctuation(kind) {
	        return 17 /* FirstPunctuation */ <= kind && kind <= 70 /* LastPunctuation */;
	    }
	    ts.isPunctuation = isPunctuation;
	    function isInsideTemplateLiteral(node, position) {
	        return ts.isTemplateLiteralKind(node.kind)
	            && (node.getStart() < position && position < node.getEnd()) || (!!node.isUnterminated && position === node.getEnd());
	    }
	    ts.isInsideTemplateLiteral = isInsideTemplateLiteral;
	    function isAccessibilityModifier(kind) {
	        switch (kind) {
	            case 114 /* PublicKeyword */:
	            case 112 /* PrivateKeyword */:
	            case 113 /* ProtectedKeyword */:
	                return true;
	        }
	        return false;
	    }
	    ts.isAccessibilityModifier = isAccessibilityModifier;
	    function cloneCompilerOptions(options) {
	        var result = ts.clone(options);
	        ts.setConfigFileInOptions(result, options && options.configFile);
	        return result;
	    }
	    ts.cloneCompilerOptions = cloneCompilerOptions;
	    function isArrayLiteralOrObjectLiteralDestructuringPattern(node) {
	        if (node.kind === 181 /* ArrayLiteralExpression */ ||
	            node.kind === 182 /* ObjectLiteralExpression */) {
	            // [a,b,c] from:
	            // [a, b, c] = someExpression;
	            if (node.parent.kind === 198 /* BinaryExpression */ &&
	                node.parent.left === node &&
	                node.parent.operatorToken.kind === 58 /* EqualsToken */) {
	                return true;
	            }
	            // [a, b, c] from:
	            // for([a, b, c] of expression)
	            if (node.parent.kind === 220 /* ForOfStatement */ &&
	                node.parent.initializer === node) {
	                return true;
	            }
	            // [a, b, c] of
	            // [x, [a, b, c] ] = someExpression
	            // or
	            // {x, a: {a, b, c} } = someExpression
	            if (isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent.kind === 268 /* PropertyAssignment */ ? node.parent.parent : node.parent)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.isArrayLiteralOrObjectLiteralDestructuringPattern = isArrayLiteralOrObjectLiteralDestructuringPattern;
	    function hasTrailingDirectorySeparator(path) {
	        var lastCharacter = path.charAt(path.length - 1);
	        return lastCharacter === "/" || lastCharacter === "\\";
	    }
	    ts.hasTrailingDirectorySeparator = hasTrailingDirectorySeparator;
	    function isInReferenceComment(sourceFile, position) {
	        return isInComment(sourceFile, position, /*tokenAtPosition*/ undefined, function (c) {
	            var commentText = sourceFile.text.substring(c.pos, c.end);
	            return tripleSlashDirectivePrefixRegex.test(commentText);
	        });
	    }
	    ts.isInReferenceComment = isInReferenceComment;
	    function isInNonReferenceComment(sourceFile, position) {
	        return isInComment(sourceFile, position, /*tokenAtPosition*/ undefined, function (c) {
	            var commentText = sourceFile.text.substring(c.pos, c.end);
	            return !tripleSlashDirectivePrefixRegex.test(commentText);
	        });
	    }
	    ts.isInNonReferenceComment = isInNonReferenceComment;
	    function createTextSpanFromNode(node, sourceFile) {
	        return ts.createTextSpanFromBounds(node.getStart(sourceFile), node.getEnd());
	    }
	    ts.createTextSpanFromNode = createTextSpanFromNode;
	    function createTextSpanFromRange(range) {
	        return ts.createTextSpanFromBounds(range.pos, range.end);
	    }
	    ts.createTextSpanFromRange = createTextSpanFromRange;
	    function createTextChangeFromStartLength(start, length, newText) {
	        return createTextChange(ts.createTextSpan(start, length), newText);
	    }
	    ts.createTextChangeFromStartLength = createTextChangeFromStartLength;
	    function createTextChange(span, newText) {
	        return { span: span, newText: newText };
	    }
	    ts.createTextChange = createTextChange;
	    ts.typeKeywords = [
	        119 /* AnyKeyword */,
	        122 /* BooleanKeyword */,
	        128 /* KeyOfKeyword */,
	        131 /* NeverKeyword */,
	        95 /* NullKeyword */,
	        134 /* NumberKeyword */,
	        135 /* ObjectKeyword */,
	        137 /* StringKeyword */,
	        138 /* SymbolKeyword */,
	        105 /* VoidKeyword */,
	        140 /* UndefinedKeyword */,
	        141 /* UniqueKeyword */,
	    ];
	    function isTypeKeyword(kind) {
	        return ts.contains(ts.typeKeywords, kind);
	    }
	    ts.isTypeKeyword = isTypeKeyword;
	    /** True if the symbol is for an external module, as opposed to a namespace. */
	    function isExternalModuleSymbol(moduleSymbol) {
	        ts.Debug.assert(!!(moduleSymbol.flags & 1536 /* Module */));
	        return moduleSymbol.name.charCodeAt(0) === 34 /* doubleQuote */;
	    }
	    ts.isExternalModuleSymbol = isExternalModuleSymbol;
	    /** Returns `true` the first time it encounters a node and `false` afterwards. */
	    function nodeSeenTracker() {
	        var seen = [];
	        return function (node) {
	            var id = ts.getNodeId(node);
	            return !seen[id] && (seen[id] = true);
	        };
	    }
	    ts.nodeSeenTracker = nodeSeenTracker;
	    /** Add a value to a set, and return true if it wasn't already present. */
	    function addToSeen(seen, key) {
	        key = String(key);
	        if (seen.has(key)) {
	            return false;
	        }
	        seen.set(key, true);
	        return true;
	    }
	    ts.addToSeen = addToSeen;
	    function getSnapshotText(snap) {
	        return snap.getText(0, snap.getLength());
	    }
	    ts.getSnapshotText = getSnapshotText;
	    function repeatString(str, count) {
	        var result = "";
	        for (var i = 0; i < count; i++) {
	            result += str;
	        }
	        return result;
	    }
	    ts.repeatString = repeatString;
	})(ts || (ts = {}));
	// Display-part writer helpers
	/* @internal */
	(function (ts) {
	    function isFirstDeclarationOfSymbolParameter(symbol) {
	        return symbol.declarations && symbol.declarations.length > 0 && symbol.declarations[0].kind === 148 /* Parameter */;
	    }
	    ts.isFirstDeclarationOfSymbolParameter = isFirstDeclarationOfSymbolParameter;
	    var displayPartWriter = getDisplayPartWriter();
	    function getDisplayPartWriter() {
	        var displayParts;
	        var lineStart;
	        var indent;
	        resetWriter();
	        var unknownWrite = function (text) { return writeKind(text, ts.SymbolDisplayPartKind.text); };
	        return {
	            displayParts: function () { return displayParts; },
	            writeKeyword: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.keyword); },
	            writeOperator: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.operator); },
	            writePunctuation: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.punctuation); },
	            writeSpace: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.space); },
	            writeStringLiteral: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.stringLiteral); },
	            writeParameter: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.parameterName); },
	            writeProperty: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.propertyName); },
	            writeLiteral: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.stringLiteral); },
	            writeSymbol: writeSymbol,
	            writeLine: writeLine,
	            write: unknownWrite,
	            writeTextOfNode: unknownWrite,
	            getText: function () { return ""; },
	            getTextPos: function () { return 0; },
	            getColumn: function () { return 0; },
	            getLine: function () { return 0; },
	            isAtStartOfLine: function () { return false; },
	            rawWrite: ts.notImplemented,
	            getIndent: function () { return indent; },
	            increaseIndent: function () { indent++; },
	            decreaseIndent: function () { indent--; },
	            clear: resetWriter,
	            trackSymbol: ts.noop,
	            reportInaccessibleThisError: ts.noop,
	            reportInaccessibleUniqueSymbolError: ts.noop,
	            reportPrivateInBaseOfClassExpression: ts.noop,
	        };
	        function writeIndent() {
	            if (lineStart) {
	                var indentString = ts.getIndentString(indent);
	                if (indentString) {
	                    displayParts.push(displayPart(indentString, ts.SymbolDisplayPartKind.space));
	                }
	                lineStart = false;
	            }
	        }
	        function writeKind(text, kind) {
	            writeIndent();
	            displayParts.push(displayPart(text, kind));
	        }
	        function writeSymbol(text, symbol) {
	            writeIndent();
	            displayParts.push(symbolPart(text, symbol));
	        }
	        function writeLine() {
	            displayParts.push(lineBreakPart());
	            lineStart = true;
	        }
	        function resetWriter() {
	            displayParts = [];
	            lineStart = true;
	            indent = 0;
	        }
	    }
	    function symbolPart(text, symbol) {
	        return displayPart(text, displayPartKind(symbol));
	        function displayPartKind(symbol) {
	            var flags = symbol.flags;
	            if (flags & 3 /* Variable */) {
	                return isFirstDeclarationOfSymbolParameter(symbol) ? ts.SymbolDisplayPartKind.parameterName : ts.SymbolDisplayPartKind.localName;
	            }
	            else if (flags & 4 /* Property */) {
	                return ts.SymbolDisplayPartKind.propertyName;
	            }
	            else if (flags & 32768 /* GetAccessor */) {
	                return ts.SymbolDisplayPartKind.propertyName;
	            }
	            else if (flags & 65536 /* SetAccessor */) {
	                return ts.SymbolDisplayPartKind.propertyName;
	            }
	            else if (flags & 8 /* EnumMember */) {
	                return ts.SymbolDisplayPartKind.enumMemberName;
	            }
	            else if (flags & 16 /* Function */) {
	                return ts.SymbolDisplayPartKind.functionName;
	            }
	            else if (flags & 32 /* Class */) {
	                return ts.SymbolDisplayPartKind.className;
	            }
	            else if (flags & 64 /* Interface */) {
	                return ts.SymbolDisplayPartKind.interfaceName;
	            }
	            else if (flags & 384 /* Enum */) {
	                return ts.SymbolDisplayPartKind.enumName;
	            }
	            else if (flags & 1536 /* Module */) {
	                return ts.SymbolDisplayPartKind.moduleName;
	            }
	            else if (flags & 8192 /* Method */) {
	                return ts.SymbolDisplayPartKind.methodName;
	            }
	            else if (flags & 262144 /* TypeParameter */) {
	                return ts.SymbolDisplayPartKind.typeParameterName;
	            }
	            else if (flags & 524288 /* TypeAlias */) {
	                return ts.SymbolDisplayPartKind.aliasName;
	            }
	            else if (flags & 2097152 /* Alias */) {
	                return ts.SymbolDisplayPartKind.aliasName;
	            }
	            return ts.SymbolDisplayPartKind.text;
	        }
	    }
	    ts.symbolPart = symbolPart;
	    function displayPart(text, kind) {
	        return { text: text, kind: ts.SymbolDisplayPartKind[kind] };
	    }
	    ts.displayPart = displayPart;
	    function spacePart() {
	        return displayPart(" ", ts.SymbolDisplayPartKind.space);
	    }
	    ts.spacePart = spacePart;
	    function keywordPart(kind) {
	        return displayPart(ts.tokenToString(kind), ts.SymbolDisplayPartKind.keyword);
	    }
	    ts.keywordPart = keywordPart;
	    function punctuationPart(kind) {
	        return displayPart(ts.tokenToString(kind), ts.SymbolDisplayPartKind.punctuation);
	    }
	    ts.punctuationPart = punctuationPart;
	    function operatorPart(kind) {
	        return displayPart(ts.tokenToString(kind), ts.SymbolDisplayPartKind.operator);
	    }
	    ts.operatorPart = operatorPart;
	    function textOrKeywordPart(text) {
	        var kind = ts.stringToToken(text);
	        return kind === undefined
	            ? textPart(text)
	            : keywordPart(kind);
	    }
	    ts.textOrKeywordPart = textOrKeywordPart;
	    function textPart(text) {
	        return displayPart(text, ts.SymbolDisplayPartKind.text);
	    }
	    ts.textPart = textPart;
	    var carriageReturnLineFeed = "\r\n";
	    /**
	     * The default is CRLF.
	     */
	    function getNewLineOrDefaultFromHost(host, formatSettings) {
	        return (formatSettings && formatSettings.newLineCharacter) ||
	            (host.getNewLine && host.getNewLine()) ||
	            carriageReturnLineFeed;
	    }
	    ts.getNewLineOrDefaultFromHost = getNewLineOrDefaultFromHost;
	    function lineBreakPart() {
	        return displayPart("\n", ts.SymbolDisplayPartKind.lineBreak);
	    }
	    ts.lineBreakPart = lineBreakPart;
	    /* @internal */
	    function mapToDisplayParts(writeDisplayParts) {
	        try {
	            writeDisplayParts(displayPartWriter);
	            return displayPartWriter.displayParts();
	        }
	        finally {
	            displayPartWriter.clear();
	        }
	    }
	    ts.mapToDisplayParts = mapToDisplayParts;
	    function typeToDisplayParts(typechecker, type, enclosingDeclaration, flags) {
	        return mapToDisplayParts(function (writer) {
	            typechecker.writeType(type, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */, writer);
	        });
	    }
	    ts.typeToDisplayParts = typeToDisplayParts;
	    function symbolToDisplayParts(typeChecker, symbol, enclosingDeclaration, meaning, flags) {
	        return mapToDisplayParts(function (writer) {
	            typeChecker.writeSymbol(symbol, enclosingDeclaration, meaning, flags | 8 /* UseAliasDefinedOutsideCurrentScope */, writer);
	        });
	    }
	    ts.symbolToDisplayParts = symbolToDisplayParts;
	    function signatureToDisplayParts(typechecker, signature, enclosingDeclaration, flags) {
	        flags |= 16384 /* UseAliasDefinedOutsideCurrentScope */ | 1024 /* MultilineObjectLiterals */ | 32 /* WriteTypeArgumentsOfSignature */ | 8192 /* OmitParameterModifiers */;
	        return mapToDisplayParts(function (writer) {
	            typechecker.writeSignature(signature, enclosingDeclaration, flags, /*signatureKind*/ undefined, writer);
	        });
	    }
	    ts.signatureToDisplayParts = signatureToDisplayParts;
	    function isImportOrExportSpecifierName(location) {
	        return location.parent &&
	            (location.parent.kind === 246 /* ImportSpecifier */ || location.parent.kind === 250 /* ExportSpecifier */) &&
	            location.parent.propertyName === location;
	    }
	    ts.isImportOrExportSpecifierName = isImportOrExportSpecifierName;
	    /**
	     * Strip off existed single quotes or double quotes from a given string
	     *
	     * @return non-quoted string
	     */
	    function stripQuotes(name) {
	        var length = name.length;
	        if (length >= 2 && name.charCodeAt(0) === name.charCodeAt(length - 1) && startsWithQuote(name)) {
	            return name.substring(1, length - 1);
	        }
	        return name;
	    }
	    ts.stripQuotes = stripQuotes;
	    function startsWithQuote(name) {
	        return ts.isSingleOrDoubleQuote(name.charCodeAt(0));
	    }
	    ts.startsWithQuote = startsWithQuote;
	    function scriptKindIs(fileName, host) {
	        var scriptKinds = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            scriptKinds[_i - 2] = arguments[_i];
	        }
	        var scriptKind = getScriptKind(fileName, host);
	        return ts.forEach(scriptKinds, function (k) { return k === scriptKind; });
	    }
	    ts.scriptKindIs = scriptKindIs;
	    function getScriptKind(fileName, host) {
	        // First check to see if the script kind was specified by the host. Chances are the host
	        // may override the default script kind for the file extension.
	        return ts.ensureScriptKind(fileName, host && host.getScriptKind && host.getScriptKind(fileName));
	    }
	    ts.getScriptKind = getScriptKind;
	    function getUniqueSymbolId(symbol, checker) {
	        return ts.getSymbolId(ts.skipAlias(symbol, checker));
	    }
	    ts.getUniqueSymbolId = getUniqueSymbolId;
	    function getFirstNonSpaceCharacterPosition(text, position) {
	        while (ts.isWhiteSpaceLike(text.charCodeAt(position))) {
	            position += 1;
	        }
	        return position;
	    }
	    ts.getFirstNonSpaceCharacterPosition = getFirstNonSpaceCharacterPosition;
	    /**
	     * Creates a deep, memberwise clone of a node with no source map location.
	     *
	     * WARNING: This is an expensive operation and is only intended to be used in refactorings
	     * and code fixes (because those are triggered by explicit user actions).
	     */
	    function getSynthesizedDeepClone(node) {
	        if (node === undefined) {
	            return undefined;
	        }
	        var visited = ts.visitEachChild(node, getSynthesizedDeepClone, ts.nullTransformationContext);
	        if (visited === node) {
	            // This only happens for leaf nodes - internal nodes always see their children change.
	            var clone_7 = ts.getSynthesizedClone(node);
	            if (ts.isStringLiteral(clone_7)) {
	                clone_7.textSourceNode = node;
	            }
	            else if (ts.isNumericLiteral(clone_7)) {
	                clone_7.numericLiteralFlags = node.numericLiteralFlags;
	            }
	            clone_7.pos = node.pos;
	            clone_7.end = node.end;
	            return clone_7;
	        }
	        // PERF: As an optimization, rather than calling getSynthesizedClone, we'll update
	        // the new node created by visitEachChild with the extra changes getSynthesizedClone
	        // would have made.
	        visited.parent = undefined;
	        return visited;
	    }
	    ts.getSynthesizedDeepClone = getSynthesizedDeepClone;
	    function getSynthesizedDeepClones(nodes) {
	        return nodes && ts.createNodeArray(nodes.map(getSynthesizedDeepClone), nodes.hasTrailingComma);
	    }
	    ts.getSynthesizedDeepClones = getSynthesizedDeepClones;
	    /**
	     * Sets EmitFlags to suppress leading and trailing trivia on the node.
	     */
	    /* @internal */
	    function suppressLeadingAndTrailingTrivia(node) {
	        ts.Debug.assert(node !== undefined);
	        suppressLeading(node);
	        suppressTrailing(node);
	        function suppressLeading(node) {
	            ts.addEmitFlags(node, 512 /* NoLeadingComments */);
	            var firstChild = ts.forEachChild(node, function (child) { return child; });
	            if (firstChild) {
	                suppressLeading(firstChild);
	            }
	        }
	        function suppressTrailing(node) {
	            ts.addEmitFlags(node, 1024 /* NoTrailingComments */);
	            var lastChild = undefined;
	            ts.forEachChild(node, function (child) { return (lastChild = child, undefined); }, function (children) {
	                // As an optimization, jump straight to the end of the list.
	                if (children.length) {
	                    lastChild = ts.last(children);
	                }
	                return undefined;
	            });
	            if (lastChild) {
	                suppressTrailing(lastChild);
	            }
	        }
	    }
	    ts.suppressLeadingAndTrailingTrivia = suppressLeadingAndTrailingTrivia;
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    function createClassifier() {
	        var scanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false);
	        function getClassificationsForLine(text, lexState, syntacticClassifierAbsent) {
	            return convertClassificationsToResult(getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent), text);
	        }
	        // If there is a syntactic classifier ('syntacticClassifierAbsent' is false),
	        // we will be more conservative in order to avoid conflicting with the syntactic classifier.
	        function getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent) {
	            var token = 0 /* Unknown */;
	            var lastNonTriviaToken = 0 /* Unknown */;
	            // Just a stack of TemplateHeads and OpenCurlyBraces, used to perform rudimentary (inexact)
	            // classification on template strings. Because of the context free nature of templates,
	            // the only precise way to classify a template portion would be by propagating the stack across
	            // lines, just as we do with the end-of-line state. However, this is a burden for implementers,
	            // and the behavior is entirely subsumed by the syntactic classifier anyway, so we instead
	            // flatten any nesting when the template stack is non-empty and encode it in the end-of-line state.
	            // Situations in which this fails are
	            //  1) When template strings are nested across different lines:
	            //          `hello ${ `world
	            //          ` }`
	            //
	            //     Where on the second line, you will get the closing of a template,
	            //     a closing curly, and a new template.
	            //
	            //  2) When substitution expressions have curly braces and the curly brace falls on the next line:
	            //          `hello ${ () => {
	            //          return "world" } } `
	            //
	            //     Where on the second line, you will get the 'return' keyword,
	            //     a string literal, and a template end consisting of '} } `'.
	            var templateStack = [];
	            var _a = getPrefixFromLexState(lexState), prefix = _a.prefix, pushTemplate = _a.pushTemplate;
	            text = prefix + text;
	            var offset = prefix.length;
	            if (pushTemplate) {
	                templateStack.push(14 /* TemplateHead */);
	            }
	            scanner.setText(text);
	            var endOfLineState = 0 /* None */;
	            var spans = [];
	            // We can run into an unfortunate interaction between the lexical and syntactic classifier
	            // when the user is typing something generic.  Consider the case where the user types:
	            //
	            //      Foo<number
	            //
	            // From the lexical classifier's perspective, 'number' is a keyword, and so the word will
	            // be classified as such.  However, from the syntactic classifier's tree-based perspective
	            // this is simply an expression with the identifier 'number' on the RHS of the less than
	            // token.  So the classification will go back to being an identifier.  The moment the user
	            // types again, number will become a keyword, then an identifier, etc. etc.
	            //
	            // To try to avoid this problem, we avoid classifying contextual keywords as keywords
	            // when the user is potentially typing something generic.  We just can't do a good enough
	            // job at the lexical level, and so well leave it up to the syntactic classifier to make
	            // the determination.
	            //
	            // In order to determine if the user is potentially typing something generic, we use a
	            // weak heuristic where we track < and > tokens.  It's a weak heuristic, but should
	            // work well enough in practice.
	            var angleBracketStack = 0;
	            do {
	                token = scanner.scan();
	                if (!ts.isTrivia(token)) {
	                    handleToken();
	                    lastNonTriviaToken = token;
	                }
	                var end = scanner.getTextPos();
	                pushEncodedClassification(scanner.getTokenPos(), end, offset, classFromKind(token), spans);
	                if (end >= text.length) {
	                    var end_1 = getNewEndOfLineState(scanner, token, ts.lastOrUndefined(templateStack));
	                    if (end_1 !== undefined) {
	                        endOfLineState = end_1;
	                    }
	                }
	            } while (token !== 1 /* EndOfFileToken */);
	            function handleToken() {
	                switch (token) {
	                    case 41 /* SlashToken */:
	                    case 63 /* SlashEqualsToken */:
	                        if (!noRegexTable[lastNonTriviaToken] && scanner.reScanSlashToken() === 12 /* RegularExpressionLiteral */) {
	                            token = 12 /* RegularExpressionLiteral */;
	                        }
	                        break;
	                    case 27 /* LessThanToken */:
	                        if (lastNonTriviaToken === 71 /* Identifier */) {
	                            // Could be the start of something generic.  Keep track of that by bumping
	                            // up the current count of generic contexts we may be in.
	                            angleBracketStack++;
	                        }
	                        break;
	                    case 29 /* GreaterThanToken */:
	                        if (angleBracketStack > 0) {
	                            // If we think we're currently in something generic, then mark that that
	                            // generic entity is complete.
	                            angleBracketStack--;
	                        }
	                        break;
	                    case 119 /* AnyKeyword */:
	                    case 137 /* StringKeyword */:
	                    case 134 /* NumberKeyword */:
	                    case 122 /* BooleanKeyword */:
	                    case 138 /* SymbolKeyword */:
	                        if (angleBracketStack > 0 && !syntacticClassifierAbsent) {
	                            // If it looks like we're could be in something generic, don't classify this
	                            // as a keyword.  We may just get overwritten by the syntactic classifier,
	                            // causing a noisy experience for the user.
	                            token = 71 /* Identifier */;
	                        }
	                        break;
	                    case 14 /* TemplateHead */:
	                        templateStack.push(token);
	                        break;
	                    case 17 /* OpenBraceToken */:
	                        // If we don't have anything on the template stack,
	                        // then we aren't trying to keep track of a previously scanned template head.
	                        if (templateStack.length > 0) {
	                            templateStack.push(token);
	                        }
	                        break;
	                    case 18 /* CloseBraceToken */:
	                        // If we don't have anything on the template stack,
	                        // then we aren't trying to keep track of a previously scanned template head.
	                        if (templateStack.length > 0) {
	                            var lastTemplateStackToken = ts.lastOrUndefined(templateStack);
	                            if (lastTemplateStackToken === 14 /* TemplateHead */) {
	                                token = scanner.reScanTemplateToken();
	                                // Only pop on a TemplateTail; a TemplateMiddle indicates there is more for us.
	                                if (token === 16 /* TemplateTail */) {
	                                    templateStack.pop();
	                                }
	                                else {
	                                    ts.Debug.assertEqual(token, 15 /* TemplateMiddle */, "Should have been a template middle.");
	                                }
	                            }
	                            else {
	                                ts.Debug.assertEqual(lastTemplateStackToken, 17 /* OpenBraceToken */, "Should have been an open brace");
	                                templateStack.pop();
	                            }
	                        }
	                        break;
	                    default:
	                        if (!ts.isKeyword(token)) {
	                            break;
	                        }
	                        if (lastNonTriviaToken === 23 /* DotToken */) {
	                            token = 71 /* Identifier */;
	                        }
	                        else if (ts.isKeyword(lastNonTriviaToken) && ts.isKeyword(token) && !canFollow(lastNonTriviaToken, token)) {
	                            // We have two keywords in a row.  Only treat the second as a keyword if
	                            // it's a sequence that could legally occur in the language.  Otherwise
	                            // treat it as an identifier.  This way, if someone writes "private var"
	                            // we recognize that 'var' is actually an identifier here.
	                            token = 71 /* Identifier */;
	                        }
	                }
	            }
	            return { endOfLineState: endOfLineState, spans: spans };
	        }
	        return { getClassificationsForLine: getClassificationsForLine, getEncodedLexicalClassifications: getEncodedLexicalClassifications };
	    }
	    ts.createClassifier = createClassifier;
	    /// We do not have a full parser support to know when we should parse a regex or not
	    /// If we consider every slash token to be a regex, we could be missing cases like "1/2/3", where
	    /// we have a series of divide operator. this list allows us to be more accurate by ruling out
	    /// locations where a regexp cannot exist.
	    var noRegexTable = ts.arrayToNumericMap([
	        71 /* Identifier */,
	        9 /* StringLiteral */,
	        8 /* NumericLiteral */,
	        12 /* RegularExpressionLiteral */,
	        99 /* ThisKeyword */,
	        43 /* PlusPlusToken */,
	        44 /* MinusMinusToken */,
	        20 /* CloseParenToken */,
	        22 /* CloseBracketToken */,
	        18 /* CloseBraceToken */,
	        101 /* TrueKeyword */,
	        86 /* FalseKeyword */,
	    ], function (token) { return token; }, function () { return true; });
	    function getNewEndOfLineState(scanner, token, lastOnTemplateStack) {
	        switch (token) {
	            case 9 /* StringLiteral */: {
	                // Check to see if we finished up on a multiline string literal.
	                if (!scanner.isUnterminated())
	                    return undefined;
	                var tokenText = scanner.getTokenText();
	                var lastCharIndex = tokenText.length - 1;
	                var numBackslashes = 0;
	                while (tokenText.charCodeAt(lastCharIndex - numBackslashes) === 92 /* backslash */) {
	                    numBackslashes++;
	                }
	                // If we have an odd number of backslashes, then the multiline string is unclosed
	                if ((numBackslashes & 1) === 0)
	                    return undefined;
	                return tokenText.charCodeAt(0) === 34 /* doubleQuote */ ? 3 /* InDoubleQuoteStringLiteral */ : 2 /* InSingleQuoteStringLiteral */;
	            }
	            case 3 /* MultiLineCommentTrivia */:
	                // Check to see if the multiline comment was unclosed.
	                return scanner.isUnterminated() ? 1 /* InMultiLineCommentTrivia */ : undefined;
	            default:
	                if (ts.isTemplateLiteralKind(token)) {
	                    if (!scanner.isUnterminated()) {
	                        return undefined;
	                    }
	                    switch (token) {
	                        case 16 /* TemplateTail */:
	                            return 5 /* InTemplateMiddleOrTail */;
	                        case 13 /* NoSubstitutionTemplateLiteral */:
	                            return 4 /* InTemplateHeadOrNoSubstitutionTemplate */;
	                        default:
	                            throw ts.Debug.fail("Only 'NoSubstitutionTemplateLiteral's and 'TemplateTail's can be unterminated; got SyntaxKind #" + token);
	                    }
	                }
	                return lastOnTemplateStack === 14 /* TemplateHead */ ? 6 /* InTemplateSubstitutionPosition */ : undefined;
	        }
	    }
	    function pushEncodedClassification(start, end, offset, classification, result) {
	        if (classification === 8 /* whiteSpace */) {
	            // Don't bother with whitespace classifications.  They're not needed.
	            return;
	        }
	        if (start === 0 && offset > 0) {
	            // We're classifying the first token, and this was a case where we prepended text.
	            // We should consider the start of this token to be at the start of the original text.
	            start += offset;
	        }
	        var length = end - start;
	        if (length > 0) {
	            // All our tokens are in relation to the augmented text.  Move them back to be
	            // relative to the original text.
	            result.push(start - offset, length, classification);
	        }
	    }
	    function convertClassificationsToResult(classifications, text) {
	        var entries = [];
	        var dense = classifications.spans;
	        var lastEnd = 0;
	        for (var i = 0; i < dense.length; i += 3) {
	            var start = dense[i];
	            var length_5 = dense[i + 1];
	            var type = dense[i + 2];
	            // Make a whitespace entry between the last item and this one.
	            if (lastEnd >= 0) {
	                var whitespaceLength_1 = start - lastEnd;
	                if (whitespaceLength_1 > 0) {
	                    entries.push({ length: whitespaceLength_1, classification: ts.TokenClass.Whitespace });
	                }
	            }
	            entries.push({ length: length_5, classification: convertClassification(type) });
	            lastEnd = start + length_5;
	        }
	        var whitespaceLength = text.length - lastEnd;
	        if (whitespaceLength > 0) {
	            entries.push({ length: whitespaceLength, classification: ts.TokenClass.Whitespace });
	        }
	        return { entries: entries, finalLexState: classifications.endOfLineState };
	    }
	    function convertClassification(type) {
	        switch (type) {
	            case 1 /* comment */: return ts.TokenClass.Comment;
	            case 3 /* keyword */: return ts.TokenClass.Keyword;
	            case 4 /* numericLiteral */: return ts.TokenClass.NumberLiteral;
	            case 5 /* operator */: return ts.TokenClass.Operator;
	            case 6 /* stringLiteral */: return ts.TokenClass.StringLiteral;
	            case 8 /* whiteSpace */: return ts.TokenClass.Whitespace;
	            case 10 /* punctuation */: return ts.TokenClass.Punctuation;
	            case 2 /* identifier */:
	            case 11 /* className */:
	            case 12 /* enumName */:
	            case 13 /* interfaceName */:
	            case 14 /* moduleName */:
	            case 15 /* typeParameterName */:
	            case 16 /* typeAliasName */:
	            case 9 /* text */:
	            case 17 /* parameterName */:
	                return ts.TokenClass.Identifier;
	        }
	    }
	    /** Returns true if 'keyword2' can legally follow 'keyword1' in any language construct. */
	    function canFollow(keyword1, keyword2) {
	        if (!ts.isAccessibilityModifier(keyword1)) {
	            // Assume any other keyword combination is legal.
	            // This can be refined in the future if there are more cases we want the classifier to be better at.
	            return true;
	        }
	        switch (keyword2) {
	            case 125 /* GetKeyword */:
	            case 136 /* SetKeyword */:
	            case 123 /* ConstructorKeyword */:
	            case 115 /* StaticKeyword */:
	                return true; // Allow things like "public get", "public constructor" and "public static".
	            default:
	                return false; // Any other keyword following "public" is actually an identifier, not a real keyword.
	        }
	    }
	    function getPrefixFromLexState(lexState) {
	        // If we're in a string literal, then prepend: "\
	        // (and a newline).  That way when we lex we'll think we're still in a string literal.
	        //
	        // If we're in a multiline comment, then prepend: /*
	        // (and a newline).  That way when we lex we'll think we're still in a multiline comment.
	        switch (lexState) {
	            case 3 /* InDoubleQuoteStringLiteral */:
	                return { prefix: "\"\\\n" };
	            case 2 /* InSingleQuoteStringLiteral */:
	                return { prefix: "'\\\n" };
	            case 1 /* InMultiLineCommentTrivia */:
	                return { prefix: "/*\n" };
	            case 4 /* InTemplateHeadOrNoSubstitutionTemplate */:
	                return { prefix: "`\n" };
	            case 5 /* InTemplateMiddleOrTail */:
	                return { prefix: "}\n", pushTemplate: true };
	            case 6 /* InTemplateSubstitutionPosition */:
	                return { prefix: "", pushTemplate: true };
	            case 0 /* None */:
	                return { prefix: "" };
	            default:
	                throw ts.Debug.assertNever(lexState);
	        }
	    }
	    function isBinaryExpressionOperatorToken(token) {
	        switch (token) {
	            case 39 /* AsteriskToken */:
	            case 41 /* SlashToken */:
	            case 42 /* PercentToken */:
	            case 37 /* PlusToken */:
	            case 38 /* MinusToken */:
	            case 45 /* LessThanLessThanToken */:
	            case 46 /* GreaterThanGreaterThanToken */:
	            case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	            case 27 /* LessThanToken */:
	            case 29 /* GreaterThanToken */:
	            case 30 /* LessThanEqualsToken */:
	            case 31 /* GreaterThanEqualsToken */:
	            case 93 /* InstanceOfKeyword */:
	            case 92 /* InKeyword */:
	            case 118 /* AsKeyword */:
	            case 32 /* EqualsEqualsToken */:
	            case 33 /* ExclamationEqualsToken */:
	            case 34 /* EqualsEqualsEqualsToken */:
	            case 35 /* ExclamationEqualsEqualsToken */:
	            case 48 /* AmpersandToken */:
	            case 50 /* CaretToken */:
	            case 49 /* BarToken */:
	            case 53 /* AmpersandAmpersandToken */:
	            case 54 /* BarBarToken */:
	            case 69 /* BarEqualsToken */:
	            case 68 /* AmpersandEqualsToken */:
	            case 70 /* CaretEqualsToken */:
	            case 65 /* LessThanLessThanEqualsToken */:
	            case 66 /* GreaterThanGreaterThanEqualsToken */:
	            case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	            case 59 /* PlusEqualsToken */:
	            case 60 /* MinusEqualsToken */:
	            case 61 /* AsteriskEqualsToken */:
	            case 63 /* SlashEqualsToken */:
	            case 64 /* PercentEqualsToken */:
	            case 58 /* EqualsToken */:
	            case 26 /* CommaToken */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    function isPrefixUnaryExpressionOperatorToken(token) {
	        switch (token) {
	            case 37 /* PlusToken */:
	            case 38 /* MinusToken */:
	            case 52 /* TildeToken */:
	            case 51 /* ExclamationToken */:
	            case 43 /* PlusPlusToken */:
	            case 44 /* MinusMinusToken */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    function classFromKind(token) {
	        if (ts.isKeyword(token)) {
	            return 3 /* keyword */;
	        }
	        else if (isBinaryExpressionOperatorToken(token) || isPrefixUnaryExpressionOperatorToken(token)) {
	            return 5 /* operator */;
	        }
	        else if (token >= 17 /* FirstPunctuation */ && token <= 70 /* LastPunctuation */) {
	            return 10 /* punctuation */;
	        }
	        switch (token) {
	            case 8 /* NumericLiteral */:
	                return 4 /* numericLiteral */;
	            case 9 /* StringLiteral */:
	                return 6 /* stringLiteral */;
	            case 12 /* RegularExpressionLiteral */:
	                return 7 /* regularExpressionLiteral */;
	            case 7 /* ConflictMarkerTrivia */:
	            case 3 /* MultiLineCommentTrivia */:
	            case 2 /* SingleLineCommentTrivia */:
	                return 1 /* comment */;
	            case 5 /* WhitespaceTrivia */:
	            case 4 /* NewLineTrivia */:
	                return 8 /* whiteSpace */;
	            case 71 /* Identifier */:
	            default:
	                if (ts.isTemplateLiteralKind(token)) {
	                    return 6 /* stringLiteral */;
	                }
	                return 2 /* identifier */;
	        }
	    }
	    /* @internal */
	    function getSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span) {
	        return convertClassificationsToSpans(getEncodedSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span));
	    }
	    ts.getSemanticClassifications = getSemanticClassifications;
	    function checkForClassificationCancellation(cancellationToken, kind) {
	        // We don't want to actually call back into our host on every node to find out if we've
	        // been canceled.  That would be an enormous amount of chattyness, along with the all
	        // the overhead of marshalling the data to/from the host.  So instead we pick a few
	        // reasonable node kinds to bother checking on.  These node kinds represent high level
	        // constructs that we would expect to see commonly, but just at a far less frequent
	        // interval.
	        //
	        // For example, in checker.ts (around 750k) we only have around 600 of these constructs.
	        // That means we're calling back into the host around every 1.2k of the file we process.
	        // Lib.d.ts has similar numbers.
	        switch (kind) {
	            case 237 /* ModuleDeclaration */:
	            case 233 /* ClassDeclaration */:
	            case 234 /* InterfaceDeclaration */:
	            case 232 /* FunctionDeclaration */:
	                cancellationToken.throwIfCancellationRequested();
	        }
	    }
	    /* @internal */
	    function getEncodedSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span) {
	        var spans = [];
	        sourceFile.forEachChild(function cb(node) {
	            // Only walk into nodes that intersect the requested span.
	            if (!node || !ts.textSpanIntersectsWith(span, node.pos, node.getFullWidth())) {
	                return;
	            }
	            checkForClassificationCancellation(cancellationToken, node.kind);
	            // Only bother calling into the typechecker if this is an identifier that
	            // could possibly resolve to a type name.  This makes classification run
	            // in a third of the time it would normally take.
	            if (ts.isIdentifier(node) && !ts.nodeIsMissing(node) && classifiableNames.has(node.escapedText)) {
	                var symbol = typeChecker.getSymbolAtLocation(node);
	                var type = symbol && classifySymbol(symbol, ts.getMeaningFromLocation(node), typeChecker);
	                if (type) {
	                    pushClassification(node.getStart(sourceFile), node.getEnd(), type);
	                }
	            }
	            node.forEachChild(cb);
	        });
	        return { spans: spans, endOfLineState: 0 /* None */ };
	        function pushClassification(start, end, type) {
	            spans.push(start);
	            spans.push(end - start);
	            spans.push(type);
	        }
	    }
	    ts.getEncodedSemanticClassifications = getEncodedSemanticClassifications;
	    function classifySymbol(symbol, meaningAtPosition, checker) {
	        var flags = symbol.getFlags();
	        if ((flags & 2885600 /* Classifiable */) === 0 /* None */) {
	            return undefined;
	        }
	        else if (flags & 32 /* Class */) {
	            return 11 /* className */;
	        }
	        else if (flags & 384 /* Enum */) {
	            return 12 /* enumName */;
	        }
	        else if (flags & 524288 /* TypeAlias */) {
	            return 16 /* typeAliasName */;
	        }
	        else if (flags & 1536 /* Module */) {
	            // Only classify a module as such if
	            //  - It appears in a namespace context.
	            //  - There exists a module declaration which actually impacts the value side.
	            return meaningAtPosition & 4 /* Namespace */ || meaningAtPosition & 1 /* Value */ && hasValueSideModule(symbol) ? 14 /* moduleName */ : undefined;
	        }
	        else if (flags & 2097152 /* Alias */) {
	            return classifySymbol(checker.getAliasedSymbol(symbol), meaningAtPosition, checker);
	        }
	        else if (meaningAtPosition & 2 /* Type */) {
	            return flags & 64 /* Interface */ ? 13 /* interfaceName */ : flags & 262144 /* TypeParameter */ ? 15 /* typeParameterName */ : undefined;
	        }
	        else {
	            return undefined;
	        }
	    }
	    /** Returns true if there exists a module that introduces entities on the value side. */
	    function hasValueSideModule(symbol) {
	        return ts.some(symbol.declarations, function (declaration) {
	            return ts.isModuleDeclaration(declaration) && ts.getModuleInstanceState(declaration) === 1 /* Instantiated */;
	        });
	    }
	    function getClassificationTypeName(type) {
	        switch (type) {
	            case 1 /* comment */: return "comment" /* comment */;
	            case 2 /* identifier */: return "identifier" /* identifier */;
	            case 3 /* keyword */: return "keyword" /* keyword */;
	            case 4 /* numericLiteral */: return "number" /* numericLiteral */;
	            case 5 /* operator */: return "operator" /* operator */;
	            case 6 /* stringLiteral */: return "string" /* stringLiteral */;
	            case 8 /* whiteSpace */: return "whitespace" /* whiteSpace */;
	            case 9 /* text */: return "text" /* text */;
	            case 10 /* punctuation */: return "punctuation" /* punctuation */;
	            case 11 /* className */: return "class name" /* className */;
	            case 12 /* enumName */: return "enum name" /* enumName */;
	            case 13 /* interfaceName */: return "interface name" /* interfaceName */;
	            case 14 /* moduleName */: return "module name" /* moduleName */;
	            case 15 /* typeParameterName */: return "type parameter name" /* typeParameterName */;
	            case 16 /* typeAliasName */: return "type alias name" /* typeAliasName */;
	            case 17 /* parameterName */: return "parameter name" /* parameterName */;
	            case 18 /* docCommentTagName */: return "doc comment tag name" /* docCommentTagName */;
	            case 19 /* jsxOpenTagName */: return "jsx open tag name" /* jsxOpenTagName */;
	            case 20 /* jsxCloseTagName */: return "jsx close tag name" /* jsxCloseTagName */;
	            case 21 /* jsxSelfClosingTagName */: return "jsx self closing tag name" /* jsxSelfClosingTagName */;
	            case 22 /* jsxAttribute */: return "jsx attribute" /* jsxAttribute */;
	            case 23 /* jsxText */: return "jsx text" /* jsxText */;
	            case 24 /* jsxAttributeStringLiteralValue */: return "jsx attribute string literal value" /* jsxAttributeStringLiteralValue */;
	        }
	    }
	    function convertClassificationsToSpans(classifications) {
	        ts.Debug.assert(classifications.spans.length % 3 === 0);
	        var dense = classifications.spans;
	        var result = [];
	        for (var i = 0; i < dense.length; i += 3) {
	            result.push({
	                textSpan: ts.createTextSpan(dense[i], dense[i + 1]),
	                classificationType: getClassificationTypeName(dense[i + 2])
	            });
	        }
	        return result;
	    }
	    /* @internal */
	    function getSyntacticClassifications(cancellationToken, sourceFile, span) {
	        return convertClassificationsToSpans(getEncodedSyntacticClassifications(cancellationToken, sourceFile, span));
	    }
	    ts.getSyntacticClassifications = getSyntacticClassifications;
	    /* @internal */
	    function getEncodedSyntacticClassifications(cancellationToken, sourceFile, span) {
	        var spanStart = span.start;
	        var spanLength = span.length;
	        // Make a scanner we can get trivia from.
	        var triviaScanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false, sourceFile.languageVariant, sourceFile.text);
	        var mergeConflictScanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false, sourceFile.languageVariant, sourceFile.text);
	        var result = [];
	        processElement(sourceFile);
	        return { spans: result, endOfLineState: 0 /* None */ };
	        function pushClassification(start, length, type) {
	            result.push(start);
	            result.push(length);
	            result.push(type);
	        }
	        function classifyLeadingTriviaAndGetTokenStart(token) {
	            triviaScanner.setTextPos(token.pos);
	            while (true) {
	                var start = triviaScanner.getTextPos();
	                // only bother scanning if we have something that could be trivia.
	                if (!ts.couldStartTrivia(sourceFile.text, start)) {
	                    return start;
	                }
	                var kind = triviaScanner.scan();
	                var end = triviaScanner.getTextPos();
	                var width = end - start;
	                // The moment we get something that isn't trivia, then stop processing.
	                if (!ts.isTrivia(kind)) {
	                    return start;
	                }
	                switch (kind) {
	                    case 4 /* NewLineTrivia */:
	                    case 5 /* WhitespaceTrivia */:
	                        // Don't bother with newlines/whitespace.
	                        continue;
	                    case 2 /* SingleLineCommentTrivia */:
	                    case 3 /* MultiLineCommentTrivia */:
	                        // Only bother with the trivia if it at least intersects the span of interest.
	                        classifyComment(token, kind, start, width);
	                        // Classifying a comment might cause us to reuse the trivia scanner
	                        // (because of jsdoc comments).  So after we classify the comment make
	                        // sure we set the scanner position back to where it needs to be.
	                        triviaScanner.setTextPos(end);
	                        continue;
	                    case 7 /* ConflictMarkerTrivia */:
	                        var text = sourceFile.text;
	                        var ch = text.charCodeAt(start);
	                        // for the <<<<<<< and >>>>>>> markers, we just add them in as comments
	                        // in the classification stream.
	                        if (ch === 60 /* lessThan */ || ch === 62 /* greaterThan */) {
	                            pushClassification(start, width, 1 /* comment */);
	                            continue;
	                        }
	                        // for the ||||||| and ======== markers, add a comment for the first line,
	                        // and then lex all subsequent lines up until the end of the conflict marker.
	                        ts.Debug.assert(ch === 124 /* bar */ || ch === 61 /* equals */);
	                        classifyDisabledMergeCode(text, start, end);
	                        break;
	                    case 6 /* ShebangTrivia */:
	                        // TODO: Maybe we should classify these.
	                        break;
	                    default:
	                        ts.Debug.assertNever(kind);
	                }
	            }
	        }
	        function classifyComment(token, kind, start, width) {
	            if (kind === 3 /* MultiLineCommentTrivia */) {
	                // See if this is a doc comment.  If so, we'll classify certain portions of it
	                // specially.
	                var docCommentAndDiagnostics = ts.parseIsolatedJSDocComment(sourceFile.text, start, width);
	                if (docCommentAndDiagnostics && docCommentAndDiagnostics.jsDoc) {
	                    // TODO: This should be predicated on `token["kind"]` being compatible with `HasJSDoc["kind"]`
	                    docCommentAndDiagnostics.jsDoc.parent = token;
	                    classifyJSDocComment(docCommentAndDiagnostics.jsDoc);
	                    return;
	                }
	            }
	            // Simple comment.  Just add as is.
	            pushCommentRange(start, width);
	        }
	        function pushCommentRange(start, width) {
	            pushClassification(start, width, 1 /* comment */);
	        }
	        function classifyJSDocComment(docComment) {
	            var pos = docComment.pos;
	            if (docComment.tags) {
	                for (var _i = 0, _a = docComment.tags; _i < _a.length; _i++) {
	                    var tag = _a[_i];
	                    // As we walk through each tag, classify the portion of text from the end of
	                    // the last tag (or the start of the entire doc comment) as 'comment'.
	                    if (tag.pos !== pos) {
	                        pushCommentRange(pos, tag.pos - pos);
	                    }
	                    pushClassification(tag.atToken.pos, tag.atToken.end - tag.atToken.pos, 10 /* punctuation */); // "@"
	                    pushClassification(tag.tagName.pos, tag.tagName.end - tag.tagName.pos, 18 /* docCommentTagName */); // e.g. "param"
	                    pos = tag.tagName.end;
	                    switch (tag.kind) {
	                        case 287 /* JSDocParameterTag */:
	                            processJSDocParameterTag(tag);
	                            break;
	                        case 290 /* JSDocTemplateTag */:
	                            processJSDocTemplateTag(tag);
	                            break;
	                        case 289 /* JSDocTypeTag */:
	                            processElement(tag.typeExpression);
	                            break;
	                        case 288 /* JSDocReturnTag */:
	                            processElement(tag.typeExpression);
	                            break;
	                    }
	                    pos = tag.end;
	                }
	            }
	            if (pos !== docComment.end) {
	                pushCommentRange(pos, docComment.end - pos);
	            }
	            return;
	            function processJSDocParameterTag(tag) {
	                if (tag.isNameFirst) {
	                    pushCommentRange(pos, tag.name.pos - pos);
	                    pushClassification(tag.name.pos, tag.name.end - tag.name.pos, 17 /* parameterName */);
	                    pos = tag.name.end;
	                }
	                if (tag.typeExpression) {
	                    pushCommentRange(pos, tag.typeExpression.pos - pos);
	                    processElement(tag.typeExpression);
	                    pos = tag.typeExpression.end;
	                }
	                if (!tag.isNameFirst) {
	                    pushCommentRange(pos, tag.name.pos - pos);
	                    pushClassification(tag.name.pos, tag.name.end - tag.name.pos, 17 /* parameterName */);
	                    pos = tag.name.end;
	                }
	            }
	        }
	        function processJSDocTemplateTag(tag) {
	            for (var _i = 0, _a = tag.getChildren(); _i < _a.length; _i++) {
	                var child = _a[_i];
	                processElement(child);
	            }
	        }
	        function classifyDisabledMergeCode(text, start, end) {
	            // Classify the line that the ||||||| or ======= marker is on as a comment.
	            // Then just lex all further tokens and add them to the result.
	            var i;
	            for (i = start; i < end; i++) {
	                if (ts.isLineBreak(text.charCodeAt(i))) {
	                    break;
	                }
	            }
	            pushClassification(start, i - start, 1 /* comment */);
	            mergeConflictScanner.setTextPos(i);
	            while (mergeConflictScanner.getTextPos() < end) {
	                classifyDisabledCodeToken();
	            }
	        }
	        function classifyDisabledCodeToken() {
	            var start = mergeConflictScanner.getTextPos();
	            var tokenKind = mergeConflictScanner.scan();
	            var end = mergeConflictScanner.getTextPos();
	            var type = classifyTokenType(tokenKind);
	            if (type) {
	                pushClassification(start, end - start, type);
	            }
	        }
	        /**
	         * Returns true if node should be treated as classified and no further processing is required.
	         * False will mean that node is not classified and traverse routine should recurse into node contents.
	         */
	        function tryClassifyNode(node) {
	            if (ts.isJSDoc(node)) {
	                return true;
	            }
	            if (ts.nodeIsMissing(node)) {
	                return true;
	            }
	            var classifiedElementName = tryClassifyJsxElementName(node);
	            if (!ts.isToken(node) && node.kind !== 10 /* JsxText */ && classifiedElementName === undefined) {
	                return false;
	            }
	            var tokenStart = node.kind === 10 /* JsxText */ ? node.pos : classifyLeadingTriviaAndGetTokenStart(node);
	            var tokenWidth = node.end - tokenStart;
	            ts.Debug.assert(tokenWidth >= 0);
	            if (tokenWidth > 0) {
	                var type = classifiedElementName || classifyTokenType(node.kind, node);
	                if (type) {
	                    pushClassification(tokenStart, tokenWidth, type);
	                }
	            }
	            return true;
	        }
	        function tryClassifyJsxElementName(token) {
	            switch (token.parent && token.parent.kind) {
	                case 255 /* JsxOpeningElement */:
	                    if (token.parent.tagName === token) {
	                        return 19 /* jsxOpenTagName */;
	                    }
	                    break;
	                case 256 /* JsxClosingElement */:
	                    if (token.parent.tagName === token) {
	                        return 20 /* jsxCloseTagName */;
	                    }
	                    break;
	                case 254 /* JsxSelfClosingElement */:
	                    if (token.parent.tagName === token) {
	                        return 21 /* jsxSelfClosingTagName */;
	                    }
	                    break;
	                case 260 /* JsxAttribute */:
	                    if (token.parent.name === token) {
	                        return 22 /* jsxAttribute */;
	                    }
	                    break;
	            }
	            return undefined;
	        }
	        // for accurate classification, the actual token should be passed in.  however, for
	        // cases like 'disabled merge code' classification, we just get the token kind and
	        // classify based on that instead.
	        function classifyTokenType(tokenKind, token) {
	            if (ts.isKeyword(tokenKind)) {
	                return 3 /* keyword */;
	            }
	            // Special case `<` and `>`: If they appear in a generic context they are punctuation,
	            // not operators.
	            if (tokenKind === 27 /* LessThanToken */ || tokenKind === 29 /* GreaterThanToken */) {
	                // If the node owning the token has a type argument list or type parameter list, then
	                // we can effectively assume that a '<' and '>' belong to those lists.
	                if (token && ts.getTypeArgumentOrTypeParameterList(token.parent)) {
	                    return 10 /* punctuation */;
	                }
	            }
	            if (ts.isPunctuation(tokenKind)) {
	                if (token) {
	                    if (tokenKind === 58 /* EqualsToken */) {
	                        // the '=' in a variable declaration is special cased here.
	                        if (token.parent.kind === 230 /* VariableDeclaration */ ||
	                            token.parent.kind === 151 /* PropertyDeclaration */ ||
	                            token.parent.kind === 148 /* Parameter */ ||
	                            token.parent.kind === 260 /* JsxAttribute */) {
	                            return 5 /* operator */;
	                        }
	                    }
	                    if (token.parent.kind === 198 /* BinaryExpression */ ||
	                        token.parent.kind === 196 /* PrefixUnaryExpression */ ||
	                        token.parent.kind === 197 /* PostfixUnaryExpression */ ||
	                        token.parent.kind === 199 /* ConditionalExpression */) {
	                        return 5 /* operator */;
	                    }
	                }
	                return 10 /* punctuation */;
	            }
	            else if (tokenKind === 8 /* NumericLiteral */) {
	                return 4 /* numericLiteral */;
	            }
	            else if (tokenKind === 9 /* StringLiteral */) {
	                return token.parent.kind === 260 /* JsxAttribute */ ? 24 /* jsxAttributeStringLiteralValue */ : 6 /* stringLiteral */;
	            }
	            else if (tokenKind === 12 /* RegularExpressionLiteral */) {
	                // TODO: we should get another classification type for these literals.
	                return 6 /* stringLiteral */;
	            }
	            else if (ts.isTemplateLiteralKind(tokenKind)) {
	                // TODO (drosen): we should *also* get another classification type for these literals.
	                return 6 /* stringLiteral */;
	            }
	            else if (tokenKind === 10 /* JsxText */) {
	                return 23 /* jsxText */;
	            }
	            else if (tokenKind === 71 /* Identifier */) {
	                if (token) {
	                    switch (token.parent.kind) {
	                        case 233 /* ClassDeclaration */:
	                            if (token.parent.name === token) {
	                                return 11 /* className */;
	                            }
	                            return;
	                        case 147 /* TypeParameter */:
	                            if (token.parent.name === token) {
	                                return 15 /* typeParameterName */;
	                            }
	                            return;
	                        case 234 /* InterfaceDeclaration */:
	                            if (token.parent.name === token) {
	                                return 13 /* interfaceName */;
	                            }
	                            return;
	                        case 236 /* EnumDeclaration */:
	                            if (token.parent.name === token) {
	                                return 12 /* enumName */;
	                            }
	                            return;
	                        case 237 /* ModuleDeclaration */:
	                            if (token.parent.name === token) {
	                                return 14 /* moduleName */;
	                            }
	                            return;
	                        case 148 /* Parameter */:
	                            if (token.parent.name === token) {
	                                return ts.isThisIdentifier(token) ? 3 /* keyword */ : 17 /* parameterName */;
	                            }
	                            return;
	                    }
	                }
	                return 2 /* identifier */;
	            }
	        }
	        function processElement(element) {
	            if (!element) {
	                return;
	            }
	            // Ignore nodes that don't intersect the original span to classify.
	            if (ts.decodedTextSpanIntersectsWith(spanStart, spanLength, element.pos, element.getFullWidth())) {
	                checkForClassificationCancellation(cancellationToken, element.kind);
	                for (var _i = 0, _a = element.getChildren(sourceFile); _i < _a.length; _i++) {
	                    var child = _a[_i];
	                    if (!tryClassifyNode(child)) {
	                        // Recurse into our child nodes.
	                        processElement(child);
	                    }
	                }
	            }
	        }
	    }
	    ts.getEncodedSyntacticClassifications = getEncodedSyntacticClassifications;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var Completions;
	    (function (Completions) {
	        var PathCompletions;
	        (function (PathCompletions) {
	            function createPathCompletion(name, kind, span) {
	                return { name: name, kind: kind, span: span };
	            }
	            function getStringLiteralCompletionsFromModuleNames(sourceFile, node, compilerOptions, host, typeChecker) {
	                var literalValue = ts.normalizeSlashes(node.text);
	                var scriptPath = node.getSourceFile().path;
	                var scriptDirectory = ts.getDirectoryPath(scriptPath);
	                var span = getDirectoryFragmentTextSpan(node.text, node.getStart(sourceFile) + 1);
	                if (isPathRelativeToScript(literalValue) || ts.isRootedDiskPath(literalValue)) {
	                    var extensions = ts.getSupportedExtensions(compilerOptions);
	                    if (compilerOptions.rootDirs) {
	                        return getCompletionEntriesForDirectoryFragmentWithRootDirs(compilerOptions.rootDirs, literalValue, scriptDirectory, extensions, /*includeExtensions*/ false, span, compilerOptions, host, scriptPath);
	                    }
	                    else {
	                        return getCompletionEntriesForDirectoryFragment(literalValue, scriptDirectory, extensions, /*includeExtensions*/ false, span, host, scriptPath);
	                    }
	                }
	                else {
	                    // Check for node modules
	                    return getCompletionEntriesForNonRelativeModules(literalValue, scriptDirectory, span, compilerOptions, host, typeChecker);
	                }
	            }
	            PathCompletions.getStringLiteralCompletionsFromModuleNames = getStringLiteralCompletionsFromModuleNames;
	            /**
	             * Takes a script path and returns paths for all potential folders that could be merged with its
	             * containing folder via the "rootDirs" compiler option
	             */
	            function getBaseDirectoriesFromRootDirs(rootDirs, basePath, scriptPath, ignoreCase) {
	                // Make all paths absolute/normalized if they are not already
	                rootDirs = rootDirs.map(function (rootDirectory) { return ts.normalizePath(ts.isRootedDiskPath(rootDirectory) ? rootDirectory : ts.combinePaths(basePath, rootDirectory)); });
	                // Determine the path to the directory containing the script relative to the root directory it is contained within
	                var relativeDirectory = ts.firstDefined(rootDirs, function (rootDirectory) {
	                    return ts.containsPath(rootDirectory, scriptPath, basePath, ignoreCase) ? scriptPath.substr(rootDirectory.length) : undefined;
	                });
	                // Now find a path for each potential directory that is to be merged with the one containing the script
	                return ts.deduplicate(rootDirs.map(function (rootDirectory) { return ts.combinePaths(rootDirectory, relativeDirectory); }), ts.equateStringsCaseSensitive, ts.compareStringsCaseSensitive);
	            }
	            function getCompletionEntriesForDirectoryFragmentWithRootDirs(rootDirs, fragment, scriptPath, extensions, includeExtensions, span, compilerOptions, host, exclude) {
	                var basePath = compilerOptions.project || host.getCurrentDirectory();
	                var ignoreCase = !(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames());
	                var baseDirectories = getBaseDirectoriesFromRootDirs(rootDirs, basePath, scriptPath, ignoreCase);
	                var result = [];
	                for (var _i = 0, baseDirectories_1 = baseDirectories; _i < baseDirectories_1.length; _i++) {
	                    var baseDirectory = baseDirectories_1[_i];
	                    getCompletionEntriesForDirectoryFragment(fragment, baseDirectory, extensions, includeExtensions, span, host, exclude, result);
	                }
	                return result;
	            }
	            /**
	             * Given a path ending at a directory, gets the completions for the path, and filters for those entries containing the basename.
	             */
	            function getCompletionEntriesForDirectoryFragment(fragment, scriptPath, extensions, includeExtensions, span, host, exclude, result) {
	                if (result === void 0) { result = []; }
	                if (fragment === undefined) {
	                    fragment = "";
	                }
	                fragment = ts.normalizeSlashes(fragment);
	                /**
	                 * Remove the basename from the path. Note that we don't use the basename to filter completions;
	                 * the client is responsible for refining completions.
	                 */
	                fragment = ts.getDirectoryPath(fragment);
	                if (fragment === "") {
	                    fragment = "." + ts.directorySeparator;
	                }
	                fragment = ts.ensureTrailingDirectorySeparator(fragment);
	                var absolutePath = normalizeAndPreserveTrailingSlash(ts.isRootedDiskPath(fragment) ? fragment : ts.combinePaths(scriptPath, fragment));
	                var baseDirectory = ts.getDirectoryPath(absolutePath);
	                var ignoreCase = !(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames());
	                if (tryDirectoryExists(host, baseDirectory)) {
	                    // Enumerate the available files if possible
	                    var files = tryReadDirectory(host, baseDirectory, extensions, /*exclude*/ undefined, /*include*/ ["./*"]);
	                    if (files) {
	                        /**
	                         * Multiple file entries might map to the same truncated name once we remove extensions
	                         * (happens iff includeExtensions === false)so we use a set-like data structure. Eg:
	                         *
	                         * both foo.ts and foo.tsx become foo
	                         */
	                        var foundFiles = ts.createMap();
	                        for (var _i = 0, files_2 = files; _i < files_2.length; _i++) {
	                            var filePath = files_2[_i];
	                            filePath = ts.normalizePath(filePath);
	                            if (exclude && ts.comparePaths(filePath, exclude, scriptPath, ignoreCase) === 0 /* EqualTo */) {
	                                continue;
	                            }
	                            var foundFileName = includeExtensions ? ts.getBaseFileName(filePath) : ts.removeFileExtension(ts.getBaseFileName(filePath));
	                            if (!foundFiles.has(foundFileName)) {
	                                foundFiles.set(foundFileName, true);
	                            }
	                        }
	                        ts.forEachKey(foundFiles, function (foundFile) {
	                            result.push(createPathCompletion(foundFile, "script" /* scriptElement */, span));
	                        });
	                    }
	                    // If possible, get folder completion as well
	                    var directories = tryGetDirectories(host, baseDirectory);
	                    if (directories) {
	                        for (var _a = 0, directories_1 = directories; _a < directories_1.length; _a++) {
	                            var directory = directories_1[_a];
	                            var directoryName = ts.getBaseFileName(ts.normalizePath(directory));
	                            result.push(createPathCompletion(directoryName, "directory" /* directory */, span));
	                        }
	                    }
	                }
	                return result;
	            }
	            /**
	             * Check all of the declared modules and those in node modules. Possible sources of modules:
	             *      Modules that are found by the type checker
	             *      Modules found relative to "baseUrl" compliler options (including patterns from "paths" compiler option)
	             *      Modules from node_modules (i.e. those listed in package.json)
	             *          This includes all files that are found in node_modules/moduleName/ with acceptable file extensions
	             */
	            function getCompletionEntriesForNonRelativeModules(fragment, scriptPath, span, compilerOptions, host, typeChecker) {
	                var baseUrl = compilerOptions.baseUrl, paths = compilerOptions.paths;
	                var result = [];
	                var fileExtensions = ts.getSupportedExtensions(compilerOptions);
	                if (baseUrl) {
	                    var projectDir = compilerOptions.project || host.getCurrentDirectory();
	                    var absolute = ts.isRootedDiskPath(baseUrl) ? baseUrl : ts.combinePaths(projectDir, baseUrl);
	                    getCompletionEntriesForDirectoryFragment(fragment, ts.normalizePath(absolute), fileExtensions, /*includeExtensions*/ false, span, host, /*exclude*/ undefined, result);
	                    for (var path in paths) {
	                        var patterns = paths[path];
	                        if (paths.hasOwnProperty(path) && patterns) {
	                            var _loop_7 = function (name, kind) {
	                                // Path mappings may provide a duplicate way to get to something we've already added, so don't add again.
	                                if (!result.some(function (entry) { return entry.name === name; })) {
	                                    result.push(createPathCompletion(name, kind, span));
	                                }
	                            };
	                            for (var _i = 0, _a = getCompletionsForPathMapping(path, patterns, fragment, baseUrl, fileExtensions, host); _i < _a.length; _i++) {
	                                var _b = _a[_i], name = _b.name, kind = _b.kind;
	                                _loop_7(name, kind);
	                            }
	                        }
	                    }
	                }
	                if (compilerOptions.moduleResolution === ts.ModuleResolutionKind.NodeJs) {
	                    ts.forEachAncestorDirectory(scriptPath, function (ancestor) {
	                        var nodeModules = ts.combinePaths(ancestor, "node_modules");
	                        if (host.directoryExists(nodeModules)) {
	                            getCompletionEntriesForDirectoryFragment(fragment, nodeModules, fileExtensions, /*includeExtensions*/ false, span, host, /*exclude*/ undefined, result);
	                        }
	                    });
	                }
	                getCompletionEntriesFromTypings(host, compilerOptions, scriptPath, span, result);
	                for (var _c = 0, _d = enumeratePotentialNonRelativeModules(fragment, scriptPath, compilerOptions, typeChecker, host); _c < _d.length; _c++) {
	                    var moduleName = _d[_c];
	                    result.push(createPathCompletion(moduleName, "external module name" /* externalModuleName */, span));
	                }
	                return result;
	            }
	            function getCompletionsForPathMapping(path, patterns, fragment, baseUrl, fileExtensions, host) {
	                if (!ts.endsWith(path, "*")) {
	                    // For a path mapping "foo": ["/x/y/z.ts"], add "foo" itself as a completion.
	                    return !ts.stringContains(path, "*") && ts.startsWith(path, fragment) ? [{ name: path, kind: "directory" /* directory */ }] : ts.emptyArray;
	                }
	                var pathPrefix = path.slice(0, path.length - 1);
	                if (!ts.startsWith(fragment, pathPrefix)) {
	                    return [{ name: pathPrefix, kind: "directory" /* directory */ }];
	                }
	                var remainingFragment = fragment.slice(pathPrefix.length);
	                return ts.flatMap(patterns, function (pattern) { return getModulesForPathsPattern(remainingFragment, baseUrl, pattern, fileExtensions, host); });
	            }
	            function getModulesForPathsPattern(fragment, baseUrl, pattern, fileExtensions, host) {
	                if (!host.readDirectory) {
	                    return undefined;
	                }
	                var parsed = ts.hasZeroOrOneAsteriskCharacter(pattern) ? ts.tryParsePattern(pattern) : undefined;
	                if (!parsed) {
	                    return undefined;
	                }
	                // The prefix has two effective parts: the directory path and the base component after the filepath that is not a
	                // full directory component. For example: directory/path/of/prefix/base*
	                var normalizedPrefix = normalizeAndPreserveTrailingSlash(parsed.prefix);
	                var normalizedPrefixDirectory = ts.getDirectoryPath(normalizedPrefix);
	                var normalizedPrefixBase = ts.getBaseFileName(normalizedPrefix);
	                var fragmentHasPath = ts.stringContains(fragment, ts.directorySeparator);
	                // Try and expand the prefix to include any path from the fragment so that we can limit the readDirectory call
	                var expandedPrefixDirectory = fragmentHasPath ? ts.combinePaths(normalizedPrefixDirectory, normalizedPrefixBase + ts.getDirectoryPath(fragment)) : normalizedPrefixDirectory;
	                var normalizedSuffix = ts.normalizePath(parsed.suffix);
	                // Need to normalize after combining: If we combinePaths("a", "../b"), we want "b" and not "a/../b".
	                var baseDirectory = ts.normalizePath(ts.combinePaths(baseUrl, expandedPrefixDirectory));
	                var completePrefix = fragmentHasPath ? baseDirectory : ts.ensureTrailingDirectorySeparator(baseDirectory) + normalizedPrefixBase;
	                // If we have a suffix, then we need to read the directory all the way down. We could create a glob
	                // that encodes the suffix, but we would have to escape the character "?" which readDirectory
	                // doesn't support. For now, this is safer but slower
	                var includeGlob = normalizedSuffix ? "**/*" : "./*";
	                var matches = tryReadDirectory(host, baseDirectory, fileExtensions, /*exclude*/ undefined, [includeGlob]).map(function (name) { return ({ name: name, kind: "script" /* scriptElement */ }); });
	                var directories = tryGetDirectories(host, baseDirectory).map(function (d) { return ts.combinePaths(baseDirectory, d); }).map(function (name) { return ({ name: name, kind: "directory" /* directory */ }); });
	                // Trim away prefix and suffix
	                return ts.mapDefined(ts.concatenate(matches, directories), function (_a) {
	                    var name = _a.name, kind = _a.kind;
	                    var normalizedMatch = ts.normalizePath(name);
	                    var inner = withoutStartAndEnd(normalizedMatch, completePrefix, normalizedSuffix);
	                    return inner !== undefined ? { name: removeLeadingDirectorySeparator(ts.removeFileExtension(inner)), kind: kind } : undefined;
	                });
	            }
	            function withoutStartAndEnd(s, start, end) {
	                return ts.startsWith(s, start) && ts.endsWith(s, end) ? s.slice(start.length, s.length - end.length) : undefined;
	            }
	            function removeLeadingDirectorySeparator(path) {
	                return path[0] === ts.directorySeparator ? path.slice(1) : path;
	            }
	            function enumeratePotentialNonRelativeModules(fragment, scriptPath, options, typeChecker, host) {
	                // Check If this is a nested module
	                var isNestedModule = ts.stringContains(fragment, ts.directorySeparator);
	                var moduleNameFragment = isNestedModule ? fragment.substr(0, fragment.lastIndexOf(ts.directorySeparator)) : undefined;
	                // Get modules that the type checker picked up
	                var ambientModules = ts.map(typeChecker.getAmbientModules(), function (sym) { return ts.stripQuotes(sym.name); });
	                var nonRelativeModuleNames = ts.filter(ambientModules, function (moduleName) { return ts.startsWith(moduleName, fragment); });
	                // Nested modules of the form "module-name/sub" need to be adjusted to only return the string
	                // after the last '/' that appears in the fragment because that's where the replacement span
	                // starts
	                if (isNestedModule) {
	                    var moduleNameWithSeperator_1 = ts.ensureTrailingDirectorySeparator(moduleNameFragment);
	                    nonRelativeModuleNames = ts.map(nonRelativeModuleNames, function (nonRelativeModuleName) {
	                        return ts.removePrefix(nonRelativeModuleName, moduleNameWithSeperator_1);
	                    });
	                }
	                if (!options.moduleResolution || options.moduleResolution === ts.ModuleResolutionKind.NodeJs) {
	                    for (var _i = 0, _a = enumerateNodeModulesVisibleToScript(host, scriptPath); _i < _a.length; _i++) {
	                        var visibleModule = _a[_i];
	                        if (!isNestedModule) {
	                            nonRelativeModuleNames.push(visibleModule.moduleName);
	                        }
	                        else if (ts.startsWith(visibleModule.moduleName, moduleNameFragment)) {
	                            var nestedFiles = tryReadDirectory(host, visibleModule.moduleDir, ts.supportedTypeScriptExtensions, /*exclude*/ undefined, /*include*/ ["./*"]);
	                            if (nestedFiles) {
	                                for (var _b = 0, nestedFiles_1 = nestedFiles; _b < nestedFiles_1.length; _b++) {
	                                    var f = nestedFiles_1[_b];
	                                    f = ts.normalizePath(f);
	                                    var nestedModule = ts.removeFileExtension(ts.getBaseFileName(f));
	                                    nonRelativeModuleNames.push(nestedModule);
	                                }
	                            }
	                        }
	                    }
	                }
	                return ts.deduplicate(nonRelativeModuleNames, ts.equateStringsCaseSensitive, ts.compareStringsCaseSensitive);
	            }
	            function getTripleSlashReferenceCompletion(sourceFile, position, compilerOptions, host) {
	                var token = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	                var commentRanges = ts.getLeadingCommentRanges(sourceFile.text, token.pos);
	                var range = commentRanges && ts.find(commentRanges, function (commentRange) { return position >= commentRange.pos && position <= commentRange.end; });
	                if (!range) {
	                    return undefined;
	                }
	                var text = sourceFile.text.slice(range.pos, position);
	                var match = tripleSlashDirectiveFragmentRegex.exec(text);
	                if (!match) {
	                    return undefined;
	                }
	                var prefix = match[1], kind = match[2], toComplete = match[3];
	                var scriptPath = ts.getDirectoryPath(sourceFile.path);
	                switch (kind) {
	                    case "path": {
	                        // Give completions for a relative path
	                        var span_10 = getDirectoryFragmentTextSpan(toComplete, range.pos + prefix.length);
	                        return getCompletionEntriesForDirectoryFragment(toComplete, scriptPath, ts.getSupportedExtensions(compilerOptions), /*includeExtensions*/ true, span_10, host, sourceFile.path);
	                    }
	                    case "types": {
	                        // Give completions based on the typings available
	                        var span_11 = ts.createTextSpan(range.pos + prefix.length, match[0].length - prefix.length);
	                        return getCompletionEntriesFromTypings(host, compilerOptions, scriptPath, span_11);
	                    }
	                    default:
	                        return undefined;
	                }
	            }
	            PathCompletions.getTripleSlashReferenceCompletion = getTripleSlashReferenceCompletion;
	            function getCompletionEntriesFromTypings(host, options, scriptPath, span, result) {
	                if (result === void 0) { result = []; }
	                // Check for typings specified in compiler options
	                var seen = ts.createMap();
	                if (options.types) {
	                    for (var _i = 0, _a = options.types; _i < _a.length; _i++) {
	                        var typesName = _a[_i];
	                        var moduleName = ts.getUnmangledNameForScopedPackage(typesName);
	                        pushResult(moduleName);
	                    }
	                }
	                else if (host.getDirectories) {
	                    var typeRoots = void 0;
	                    try {
	                        typeRoots = ts.getEffectiveTypeRoots(options, host);
	                    }
	                    catch (_b) { }
	                    if (typeRoots) {
	                        for (var _c = 0, typeRoots_2 = typeRoots; _c < typeRoots_2.length; _c++) {
	                            var root = typeRoots_2[_c];
	                            getCompletionEntriesFromDirectories(root);
	                        }
	                    }
	                    // Also get all @types typings installed in visible node_modules directories
	                    for (var _d = 0, _e = findPackageJsons(scriptPath, host); _d < _e.length; _d++) {
	                        var packageJson = _e[_d];
	                        var typesDir = ts.combinePaths(ts.getDirectoryPath(packageJson), "node_modules/@types");
	                        getCompletionEntriesFromDirectories(typesDir);
	                    }
	                }
	                return result;
	                function getCompletionEntriesFromDirectories(directory) {
	                    ts.Debug.assert(!!host.getDirectories);
	                    if (tryDirectoryExists(host, directory)) {
	                        var directories = tryGetDirectories(host, directory);
	                        if (directories) {
	                            for (var _i = 0, directories_2 = directories; _i < directories_2.length; _i++) {
	                                var typeDirectory = directories_2[_i];
	                                typeDirectory = ts.normalizePath(typeDirectory);
	                                var directoryName = ts.getBaseFileName(typeDirectory);
	                                var moduleName = ts.getUnmangledNameForScopedPackage(directoryName);
	                                pushResult(moduleName);
	                            }
	                        }
	                    }
	                }
	                function pushResult(moduleName) {
	                    if (!seen.has(moduleName)) {
	                        result.push(createPathCompletion(moduleName, "external module name" /* externalModuleName */, span));
	                        seen.set(moduleName, true);
	                    }
	                }
	            }
	            function findPackageJsons(directory, host) {
	                var paths = [];
	                ts.forEachAncestorDirectory(directory, function (ancestor) {
	                    var currentConfigPath = ts.findConfigFile(ancestor, function (f) { return tryFileExists(host, f); }, "package.json");
	                    if (!currentConfigPath) {
	                        return true; // break out
	                    }
	                    paths.push(currentConfigPath);
	                });
	                return paths;
	            }
	            function enumerateNodeModulesVisibleToScript(host, scriptPath) {
	                var result = [];
	                if (host.readFile && host.fileExists) {
	                    for (var _i = 0, _a = findPackageJsons(scriptPath, host); _i < _a.length; _i++) {
	                        var packageJson = _a[_i];
	                        var contents = tryReadingPackageJson(packageJson);
	                        if (!contents) {
	                            return;
	                        }
	                        var nodeModulesDir = ts.combinePaths(ts.getDirectoryPath(packageJson), "node_modules");
	                        var foundModuleNames = [];
	                        // Provide completions for all non @types dependencies
	                        for (var _b = 0, nodeModulesDependencyKeys_1 = nodeModulesDependencyKeys; _b < nodeModulesDependencyKeys_1.length; _b++) {
	                            var key = nodeModulesDependencyKeys_1[_b];
	                            addPotentialPackageNames(contents[key], foundModuleNames);
	                        }
	                        for (var _c = 0, foundModuleNames_1 = foundModuleNames; _c < foundModuleNames_1.length; _c++) {
	                            var moduleName = foundModuleNames_1[_c];
	                            var moduleDir = ts.combinePaths(nodeModulesDir, moduleName);
	                            result.push({
	                                moduleName: moduleName,
	                                moduleDir: moduleDir
	                            });
	                        }
	                    }
	                }
	                return result;
	                function tryReadingPackageJson(filePath) {
	                    try {
	                        var fileText = tryReadFile(host, filePath);
	                        return fileText ? JSON.parse(fileText) : undefined;
	                    }
	                    catch (e) {
	                        return undefined;
	                    }
	                }
	                function addPotentialPackageNames(dependencies, result) {
	                    if (dependencies) {
	                        for (var dep in dependencies) {
	                            if (dependencies.hasOwnProperty(dep) && !ts.startsWith(dep, "@types/")) {
	                                result.push(dep);
	                            }
	                        }
	                    }
	                }
	            }
	            // Replace everything after the last directory seperator that appears
	            function getDirectoryFragmentTextSpan(text, textStart) {
	                var index = text.lastIndexOf(ts.directorySeparator);
	                var offset = index !== -1 ? index + 1 : 0;
	                return { start: textStart + offset, length: text.length - offset };
	            }
	            // Returns true if the path is explicitly relative to the script (i.e. relative to . or ..)
	            function isPathRelativeToScript(path) {
	                if (path && path.length >= 2 && path.charCodeAt(0) === 46 /* dot */) {
	                    var slashIndex = path.length >= 3 && path.charCodeAt(1) === 46 /* dot */ ? 2 : 1;
	                    var slashCharCode = path.charCodeAt(slashIndex);
	                    return slashCharCode === 47 /* slash */ || slashCharCode === 92 /* backslash */;
	                }
	                return false;
	            }
	            function normalizeAndPreserveTrailingSlash(path) {
	                if (ts.normalizeSlashes(path) === "./") {
	                    // normalizePath turns "./" into "". "" + "/" would then be a rooted path instead of a relative one, so avoid this particular case.
	                    // There is no problem for adding "/" to a non-empty string -- it's only a problem at the beginning.
	                    return "";
	                }
	                var norm = ts.normalizePath(path);
	                return ts.hasTrailingDirectorySeparator(path) ? ts.ensureTrailingDirectorySeparator(norm) : norm;
	            }
	            /**
	             * Matches a triple slash reference directive with an incomplete string literal for its path. Used
	             * to determine if the caret is currently within the string literal and capture the literal fragment
	             * for completions.
	             * For example, this matches
	             *
	             * /// <reference path="fragment
	             *
	             * but not
	             *
	             * /// <reference path="fragment"
	             */
	            var tripleSlashDirectiveFragmentRegex = /^(\/\/\/\s*<reference\s+(path|types)\s*=\s*(?:'|"))([^\3"]*)$/;
	            var nodeModulesDependencyKeys = ["dependencies", "devDependencies", "peerDependencies", "optionalDependencies"];
	            function tryGetDirectories(host, directoryName) {
	                return tryIOAndConsumeErrors(host, host.getDirectories, directoryName) || [];
	            }
	            function tryReadDirectory(host, path, extensions, exclude, include) {
	                return tryIOAndConsumeErrors(host, host.readDirectory, path, extensions, exclude, include) || ts.emptyArray;
	            }
	            function tryReadFile(host, path) {
	                return tryIOAndConsumeErrors(host, host.readFile, path);
	            }
	            function tryFileExists(host, path) {
	                return tryIOAndConsumeErrors(host, host.fileExists, path);
	            }
	            function tryDirectoryExists(host, path) {
	                try {
	                    return ts.directoryProbablyExists(path, host);
	                }
	                catch (_a) { }
	                return undefined;
	            }
	            function tryIOAndConsumeErrors(host, toApply) {
	                var args = [];
	                for (var _i = 2; _i < arguments.length; _i++) {
	                    args[_i - 2] = arguments[_i];
	                }
	                try {
	                    return toApply && toApply.apply(host, args);
	                }
	                catch (_a) { }
	                return undefined;
	            }
	        })(PathCompletions = Completions.PathCompletions || (Completions.PathCompletions = {}));
	    })(Completions = ts.Completions || (ts.Completions = {}));
	})(ts || (ts = {}));
	/// <reference path="./pathCompletions.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    var Completions;
	    (function (Completions) {
	        var KeywordCompletionFilters;
	        (function (KeywordCompletionFilters) {
	            KeywordCompletionFilters[KeywordCompletionFilters["None"] = 0] = "None";
	            KeywordCompletionFilters[KeywordCompletionFilters["ClassElementKeywords"] = 1] = "ClassElementKeywords";
	            KeywordCompletionFilters[KeywordCompletionFilters["ConstructorParameterKeywords"] = 2] = "ConstructorParameterKeywords";
	            KeywordCompletionFilters[KeywordCompletionFilters["FunctionLikeBodyKeywords"] = 3] = "FunctionLikeBodyKeywords";
	            KeywordCompletionFilters[KeywordCompletionFilters["TypeKeywords"] = 4] = "TypeKeywords";
	        })(KeywordCompletionFilters || (KeywordCompletionFilters = {}));
	        function getCompletionsAtPosition(host, typeChecker, log, compilerOptions, sourceFile, position, allSourceFiles, options) {
	            if (ts.isInReferenceComment(sourceFile, position)) {
	                var entries = Completions.PathCompletions.getTripleSlashReferenceCompletion(sourceFile, position, compilerOptions, host);
	                return entries && convertPathCompletions(entries);
	            }
	            var contextToken = ts.findPrecedingToken(position, sourceFile);
	            if (ts.isInString(sourceFile, position, contextToken)) {
	                return !contextToken || !ts.isStringLiteralLike(contextToken)
	                    ? undefined
	                    : convertStringLiteralCompletions(getStringLiteralCompletionEntries(sourceFile, contextToken, position, typeChecker, compilerOptions, host), sourceFile, typeChecker, log);
	            }
	            if (contextToken && ts.isBreakOrContinueStatement(contextToken.parent)
	                && (contextToken.kind === 72 /* BreakKeyword */ || contextToken.kind === 77 /* ContinueKeyword */ || contextToken.kind === 71 /* Identifier */)) {
	                return getLabelCompletionAtPosition(contextToken.parent);
	            }
	            var completionData = getCompletionData(typeChecker, log, sourceFile, position, allSourceFiles, options, compilerOptions.target);
	            if (!completionData) {
	                return undefined;
	            }
	            switch (completionData.kind) {
	                case 0 /* Data */:
	                    return completionInfoFromData(sourceFile, typeChecker, compilerOptions, log, completionData, options.includeInsertTextCompletions);
	                case 1 /* JsDocTagName */:
	                    // If the current position is a jsDoc tag name, only tag names should be provided for completion
	                    return jsdocCompletionInfo(ts.JsDoc.getJSDocTagNameCompletions());
	                case 2 /* JsDocTag */:
	                    // If the current position is a jsDoc tag, only tags should be provided for completion
	                    return jsdocCompletionInfo(ts.JsDoc.getJSDocTagCompletions());
	                case 3 /* JsDocParameterName */:
	                    return jsdocCompletionInfo(ts.JsDoc.getJSDocParameterNameCompletions(completionData.tag));
	                default:
	                    throw ts.Debug.assertNever(completionData);
	            }
	        }
	        Completions.getCompletionsAtPosition = getCompletionsAtPosition;
	        function convertStringLiteralCompletions(completion, sourceFile, checker, log) {
	            if (completion === undefined) {
	                return undefined;
	            }
	            switch (completion.kind) {
	                case 0 /* Paths */:
	                    return convertPathCompletions(completion.paths);
	                case 1 /* Properties */: {
	                    var entries = [];
	                    getCompletionEntriesFromSymbols(completion.symbols, entries, sourceFile, sourceFile, checker, 6 /* ESNext */, log, 4 /* String */); // Target will not be used, so arbitrary
	                    return { isGlobalCompletion: false, isMemberCompletion: true, isNewIdentifierLocation: true, entries: entries };
	                }
	                case 2 /* Types */: {
	                    var entries = completion.types.map(function (type) { return ({ name: type.value, kindModifiers: "" /* none */, kind: "var" /* variableElement */, sortText: "0" }); });
	                    return { isGlobalCompletion: false, isMemberCompletion: false, isNewIdentifierLocation: true, entries: entries };
	                }
	                default:
	                    return ts.Debug.assertNever(completion);
	            }
	        }
	        function convertPathCompletions(pathCompletions) {
	            var isGlobalCompletion = false; // We don't want the editor to offer any other completions, such as snippets, inside a comment.
	            var isNewIdentifierLocation = true; // The user may type in a path that doesn't yet exist, creating a "new identifier" with respect to the collection of identifiers the server is aware of.
	            var entries = pathCompletions.map(function (_a) {
	                var name = _a.name, kind = _a.kind, span = _a.span;
	                return ({ name: name, kind: kind, kindModifiers: "" /* none */, sortText: "0", replacementSpan: span });
	            });
	            return { isGlobalCompletion: isGlobalCompletion, isMemberCompletion: false, isNewIdentifierLocation: isNewIdentifierLocation, entries: entries };
	        }
	        function jsdocCompletionInfo(entries) {
	            return { isGlobalCompletion: false, isMemberCompletion: false, isNewIdentifierLocation: false, entries: entries };
	        }
	        function completionInfoFromData(sourceFile, typeChecker, compilerOptions, log, completionData, includeInsertTextCompletions) {
	            var symbols = completionData.symbols, completionKind = completionData.completionKind, isInSnippetScope = completionData.isInSnippetScope, isNewIdentifierLocation = completionData.isNewIdentifierLocation, location = completionData.location, propertyAccessToConvert = completionData.propertyAccessToConvert, keywordFilters = completionData.keywordFilters, symbolToOriginInfoMap = completionData.symbolToOriginInfoMap, recommendedCompletion = completionData.recommendedCompletion, isJsxInitializer = completionData.isJsxInitializer;
	            if (sourceFile.languageVariant === 1 /* JSX */ && location && location.parent && ts.isJsxClosingElement(location.parent)) {
	                // In the TypeScript JSX element, if such element is not defined. When users query for completion at closing tag,
	                // instead of simply giving unknown value, the completion will return the tag-name of an associated opening-element.
	                // For example:
	                //     var x = <div> </ /*1*/>
	                // The completion list at "1" will contain "div" with type any
	                var tagName = location.parent.parent.openingElement.tagName;
	                return { isGlobalCompletion: false, isMemberCompletion: true, isNewIdentifierLocation: false,
	                    entries: [{
	                            name: tagName.getFullText(),
	                            kind: "class" /* classElement */,
	                            kindModifiers: undefined,
	                            sortText: "0",
	                        }] };
	            }
	            var entries = [];
	            if (ts.isSourceFileJavaScript(sourceFile)) {
	                var uniqueNames = getCompletionEntriesFromSymbols(symbols, entries, location, sourceFile, typeChecker, compilerOptions.target, log, completionKind, includeInsertTextCompletions, propertyAccessToConvert, isJsxInitializer, recommendedCompletion, symbolToOriginInfoMap);
	                getJavaScriptCompletionEntries(sourceFile, location.pos, uniqueNames, compilerOptions.target, entries);
	            }
	            else {
	                if ((!symbols || symbols.length === 0) && keywordFilters === 0 /* None */) {
	                    return undefined;
	                }
	                getCompletionEntriesFromSymbols(symbols, entries, location, sourceFile, typeChecker, compilerOptions.target, log, completionKind, includeInsertTextCompletions, propertyAccessToConvert, isJsxInitializer, recommendedCompletion, symbolToOriginInfoMap);
	            }
	            // TODO add filter for keyword based on type/value/namespace and also location
	            // Add all keywords if
	            // - this is not a member completion list (all the keywords)
	            // - other filters are enabled in required scenario so add those keywords
	            var isMemberCompletion = isMemberCompletionKind(completionKind);
	            if (keywordFilters !== 0 /* None */ || !isMemberCompletion) {
	                ts.addRange(entries, getKeywordCompletions(keywordFilters));
	            }
	            return { isGlobalCompletion: isInSnippetScope, isMemberCompletion: isMemberCompletion, isNewIdentifierLocation: isNewIdentifierLocation, entries: entries };
	        }
	        function isMemberCompletionKind(kind) {
	            switch (kind) {
	                case 0 /* ObjectPropertyDeclaration */:
	                case 3 /* MemberLike */:
	                case 2 /* PropertyAccess */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function getJavaScriptCompletionEntries(sourceFile, position, uniqueNames, target, entries) {
	            ts.getNameTable(sourceFile).forEach(function (pos, name) {
	                // Skip identifiers produced only from the current location
	                if (pos === position) {
	                    return;
	                }
	                var realName = ts.unescapeLeadingUnderscores(name);
	                if (ts.addToSeen(uniqueNames, realName) && ts.isIdentifierText(realName, target) && !ts.isStringANonContextualKeyword(realName)) {
	                    entries.push({
	                        name: realName,
	                        kind: "warning" /* warning */,
	                        kindModifiers: "",
	                        sortText: "1"
	                    });
	                }
	            });
	        }
	        function createCompletionEntry(symbol, location, sourceFile, typeChecker, target, kind, origin, recommendedCompletion, propertyAccessToConvert, isJsxInitializer, includeInsertTextCompletions) {
	            var info = getCompletionEntryDisplayNameForSymbol(symbol, target, origin, kind);
	            if (!info) {
	                return undefined;
	            }
	            var name = info.name, needsConvertPropertyAccess = info.needsConvertPropertyAccess;
	            var insertText;
	            var replacementSpan;
	            if (includeInsertTextCompletions) {
	                if (origin && origin.type === "this-type") {
	                    insertText = needsConvertPropertyAccess ? "this[" + quote(name) + "]" : "this." + name;
	                }
	                else if (needsConvertPropertyAccess) {
	                    insertText = "[" + quote(name) + "]";
	                    var dot = ts.findChildOfKind(propertyAccessToConvert, 23 /* DotToken */, sourceFile);
	                    // If the text after the '.' starts with this name, write over it. Else, add new text.
	                    var end = ts.startsWith(name, propertyAccessToConvert.name.text) ? propertyAccessToConvert.name.end : dot.end;
	                    replacementSpan = ts.createTextSpanFromBounds(dot.getStart(sourceFile), end);
	                }
	                if (isJsxInitializer) {
	                    if (insertText === undefined)
	                        insertText = name;
	                    insertText = "{" + insertText + "}";
	                    if (typeof isJsxInitializer !== "boolean") {
	                        replacementSpan = ts.createTextSpanFromNode(isJsxInitializer, sourceFile);
	                    }
	                }
	            }
	            if (insertText !== undefined && !includeInsertTextCompletions) {
	                return undefined;
	            }
	            // TODO(drosen): Right now we just permit *all* semantic meanings when calling
	            // 'getSymbolKind' which is permissible given that it is backwards compatible; but
	            // really we should consider passing the meaning for the node so that we don't report
	            // that a suggestion for a value is an interface.  We COULD also just do what
	            // 'getSymbolModifiers' does, which is to use the first declaration.
	            // Use a 'sortText' of 0' so that all symbol completion entries come before any other
	            // entries (like JavaScript identifier entries).
	            return {
	                name: name,
	                kind: ts.SymbolDisplay.getSymbolKind(typeChecker, symbol, location),
	                kindModifiers: ts.SymbolDisplay.getSymbolModifiers(symbol),
	                sortText: "0",
	                source: getSourceFromOrigin(origin),
	                hasAction: trueOrUndefined(!!origin && origin.type === "export"),
	                isRecommended: trueOrUndefined(isRecommendedCompletionMatch(symbol, recommendedCompletion, typeChecker)),
	                insertText: insertText,
	                replacementSpan: replacementSpan,
	            };
	        }
	        function quote(text) {
	            // TODO: GH#20619 Use configured quote style
	            return JSON.stringify(text);
	        }
	        function isRecommendedCompletionMatch(localSymbol, recommendedCompletion, checker) {
	            return localSymbol === recommendedCompletion ||
	                !!(localSymbol.flags & 1048576 /* ExportValue */) && checker.getExportSymbolOfSymbol(localSymbol) === recommendedCompletion;
	        }
	        function trueOrUndefined(b) {
	            return b ? true : undefined;
	        }
	        function getSourceFromOrigin(origin) {
	            return origin && origin.type === "export" ? ts.stripQuotes(origin.moduleSymbol.name) : undefined;
	        }
	        function getCompletionEntriesFromSymbols(symbols, entries, location, sourceFile, typeChecker, target, log, kind, includeInsertTextCompletions, propertyAccessToConvert, isJsxInitializer, recommendedCompletion, symbolToOriginInfoMap) {
	            var start = ts.timestamp();
	            // Tracks unique names.
	            // We don't set this for global variables or completions from external module exports, because we can have multiple of those.
	            // Based on the order we add things we will always see locals first, then globals, then module exports.
	            // So adding a completion for a local will prevent us from adding completions for external module exports sharing the same name.
	            var uniques = ts.createMap();
	            for (var _i = 0, symbols_4 = symbols; _i < symbols_4.length; _i++) {
	                var symbol = symbols_4[_i];
	                var origin = symbolToOriginInfoMap ? symbolToOriginInfoMap[ts.getSymbolId(symbol)] : undefined;
	                var entry = createCompletionEntry(symbol, location, sourceFile, typeChecker, target, kind, origin, recommendedCompletion, propertyAccessToConvert, isJsxInitializer, includeInsertTextCompletions);
	                if (!entry) {
	                    continue;
	                }
	                var name = entry.name;
	                if (uniques.has(name)) {
	                    continue;
	                }
	                // Latter case tests whether this is a global variable.
	                if (!origin && !(symbol.parent === undefined && !ts.some(symbol.declarations, function (d) { return d.getSourceFile() === location.getSourceFile(); }))) {
	                    uniques.set(name, true);
	                }
	                entries.push(entry);
	            }
	            log("getCompletionsAtPosition: getCompletionEntriesFromSymbols: " + (ts.timestamp() - start));
	            return uniques;
	        }
	        function getLabelCompletionAtPosition(node) {
	            var entries = getLabelStatementCompletions(node);
	            if (entries.length) {
	                return { isGlobalCompletion: false, isMemberCompletion: false, isNewIdentifierLocation: false, entries: entries };
	            }
	        }
	        function getLabelStatementCompletions(node) {
	            var entries = [];
	            var uniques = ts.createMap();
	            var current = node;
	            while (current) {
	                if (ts.isFunctionLike(current)) {
	                    break;
	                }
	                if (ts.isLabeledStatement(current)) {
	                    var name = current.label.text;
	                    if (!uniques.has(name)) {
	                        uniques.set(name, true);
	                        entries.push({
	                            name: name,
	                            kindModifiers: "" /* none */,
	                            kind: "label" /* label */,
	                            sortText: "0"
	                        });
	                    }
	                }
	                current = current.parent;
	            }
	            return entries;
	        }
	        var StringLiteralCompletionKind;
	        (function (StringLiteralCompletionKind) {
	            StringLiteralCompletionKind[StringLiteralCompletionKind["Paths"] = 0] = "Paths";
	            StringLiteralCompletionKind[StringLiteralCompletionKind["Properties"] = 1] = "Properties";
	            StringLiteralCompletionKind[StringLiteralCompletionKind["Types"] = 2] = "Types";
	        })(StringLiteralCompletionKind || (StringLiteralCompletionKind = {}));
	        function getStringLiteralCompletionEntries(sourceFile, node, position, typeChecker, compilerOptions, host) {
	            switch (node.parent.kind) {
	                case 177 /* LiteralType */:
	                    switch (node.parent.parent.kind) {
	                        case 161 /* TypeReference */:
	                            return { kind: 2 /* Types */, types: getStringLiteralTypes(typeChecker.getTypeArgumentConstraint(node.parent), typeChecker) };
	                        case 175 /* IndexedAccessType */:
	                            // Get all apparent property names
	                            // i.e. interface Foo {
	                            //          foo: string;
	                            //          bar: string;
	                            //      }
	                            //      let x: Foo["/*completion position*/"]
	                            return { kind: 1 /* Properties */, symbols: typeChecker.getTypeFromTypeNode(node.parent.parent.objectType).getApparentProperties() };
	                        default:
	                            return undefined;
	                    }
	                case 268 /* PropertyAssignment */:
	                    if (ts.isObjectLiteralExpression(node.parent.parent) && node.parent.name === node) {
	                        // Get quoted name of properties of the object literal expression
	                        // i.e. interface ConfigFiles {
	                        //          'jspm:dev': string
	                        //      }
	                        //      let files: ConfigFiles = {
	                        //          '/*completion position*/'
	                        //      }
	                        //
	                        //      function foo(c: ConfigFiles) {}
	                        //      foo({
	                        //          '/*completion position*/'
	                        //      });
	                        var type = typeChecker.getContextualType(node.parent.parent);
	                        return { kind: 1 /* Properties */, symbols: type && type.getApparentProperties() };
	                    }
	                    return fromContextualType();
	                case 184 /* ElementAccessExpression */: {
	                    var _a = node.parent, expression = _a.expression, argumentExpression = _a.argumentExpression;
	                    if (node === argumentExpression) {
	                        // Get all names of properties on the expression
	                        // i.e. interface A {
	                        //      'prop1': string
	                        // }
	                        // let a: A;
	                        // a['/*completion position*/']
	                        return { kind: 1 /* Properties */, symbols: typeChecker.getTypeAtLocation(expression).getApparentProperties() };
	                    }
	                    return undefined;
	                }
	                case 185 /* CallExpression */:
	                case 186 /* NewExpression */:
	                    if (!ts.isRequireCall(node.parent, /*checkArgumentIsStringLiteral*/ false) && !ts.isImportCall(node.parent)) {
	                        var argumentInfo_1 = ts.SignatureHelp.getImmediatelyContainingArgumentInfo(node, position, sourceFile);
	                        // Get string literal completions from specialized signatures of the target
	                        // i.e. declare function f(a: 'A');
	                        // f("/*completion position*/")
	                        if (argumentInfo_1) {
	                            var candidates = [];
	                            typeChecker.getResolvedSignature(argumentInfo_1.invocation, candidates, argumentInfo_1.argumentCount);
	                            var uniques_1 = ts.createMap();
	                            return { kind: 2 /* Types */, types: ts.flatMap(candidates, function (candidate) { return getStringLiteralTypes(typeChecker.getParameterType(candidate, argumentInfo_1.argumentIndex), typeChecker, uniques_1); }) };
	                        }
	                        return fromContextualType();
	                    }
	                // falls through (is `require("")` or `import("")`)
	                case 242 /* ImportDeclaration */:
	                case 248 /* ExportDeclaration */:
	                case 252 /* ExternalModuleReference */:
	                    // Get all known external module names or complete a path to a module
	                    // i.e. import * as ns from "/*completion position*/";
	                    //      var y = import("/*completion position*/");
	                    //      import x = require("/*completion position*/");
	                    //      var y = require("/*completion position*/");
	                    //      export * from "/*completion position*/";
	                    return { kind: 0 /* Paths */, paths: Completions.PathCompletions.getStringLiteralCompletionsFromModuleNames(sourceFile, node, compilerOptions, host, typeChecker) };
	                default:
	                    return fromContextualType();
	            }
	            function fromContextualType() {
	                // Get completion for string literal from string literal type
	                // i.e. var x: "hi" | "hello" = "/*completion position*/"
	                return { kind: 2 /* Types */, types: getStringLiteralTypes(getContextualTypeFromParent(node, typeChecker), typeChecker) };
	            }
	        }
	        function getStringLiteralTypes(type, typeChecker, uniques) {
	            if (uniques === void 0) { uniques = ts.createMap(); }
	            if (type && type.flags & 32768 /* TypeParameter */) {
	                type = type.getConstraint();
	            }
	            return type && type.flags & 131072 /* Union */
	                ? ts.flatMap(type.types, function (t) { return getStringLiteralTypes(t, typeChecker, uniques); })
	                : type && type.flags & 32 /* StringLiteral */ && !(type.flags & 256 /* EnumLiteral */) && ts.addToSeen(uniques, type.value)
	                    ? [type]
	                    : ts.emptyArray;
	        }
	        function getSymbolCompletionFromEntryId(typeChecker, log, compilerOptions, sourceFile, position, _a, allSourceFiles) {
	            var name = _a.name, source = _a.source;
	            var completionData = getCompletionData(typeChecker, log, sourceFile, position, allSourceFiles, { includeExternalModuleExports: true, includeInsertTextCompletions: true }, compilerOptions.target);
	            if (!completionData) {
	                return { type: "none" };
	            }
	            if (completionData.kind !== 0 /* Data */) {
	                return { type: "request", request: completionData };
	            }
	            var symbols = completionData.symbols, location = completionData.location, completionKind = completionData.completionKind, symbolToOriginInfoMap = completionData.symbolToOriginInfoMap, previousToken = completionData.previousToken, isJsxInitializer = completionData.isJsxInitializer;
	            // Find the symbol with the matching entry name.
	            // We don't need to perform character checks here because we're only comparing the
	            // name against 'entryName' (which is known to be good), not building a new
	            // completion entry.
	            return ts.firstDefined(symbols, function (symbol) {
	                var origin = symbolToOriginInfoMap[ts.getSymbolId(symbol)];
	                var info = getCompletionEntryDisplayNameForSymbol(symbol, compilerOptions.target, origin, completionKind);
	                return info && info.name === name && getSourceFromOrigin(origin) === source ? { type: "symbol", symbol: symbol, location: location, symbolToOriginInfoMap: symbolToOriginInfoMap, previousToken: previousToken, isJsxInitializer: isJsxInitializer } : undefined;
	            }) || { type: "none" };
	        }
	        function getSymbolName(symbol, origin, target) {
	            return origin && origin.type === "export" && origin.isDefaultExport && symbol.escapedName === "default" /* Default */
	                // Name of "export default foo;" is "foo". Name of "export default 0" is the filename converted to camelCase.
	                ? ts.firstDefined(symbol.declarations, function (d) { return ts.isExportAssignment(d) && ts.isIdentifier(d.expression) ? d.expression.text : undefined; })
	                    || ts.codefix.moduleSymbolToValidIdentifier(origin.moduleSymbol, target)
	                : symbol.name;
	        }
	        function getCompletionEntryDetails(program, log, compilerOptions, sourceFile, position, entryId, allSourceFiles, host, formatContext, getCanonicalFileName) {
	            var typeChecker = program.getTypeChecker();
	            var name = entryId.name;
	            // Compute all the completion symbols again.
	            var symbolCompletion = getSymbolCompletionFromEntryId(typeChecker, log, compilerOptions, sourceFile, position, entryId, allSourceFiles);
	            switch (symbolCompletion.type) {
	                case "request": {
	                    var request = symbolCompletion.request;
	                    switch (request.kind) {
	                        case 1 /* JsDocTagName */:
	                            return ts.JsDoc.getJSDocTagNameCompletionDetails(name);
	                        case 2 /* JsDocTag */:
	                            return ts.JsDoc.getJSDocTagCompletionDetails(name);
	                        case 3 /* JsDocParameterName */:
	                            return ts.JsDoc.getJSDocParameterNameCompletionDetails(name);
	                        default:
	                            return ts.Debug.assertNever(request);
	                    }
	                }
	                case "symbol": {
	                    var symbol = symbolCompletion.symbol, location = symbolCompletion.location, symbolToOriginInfoMap = symbolCompletion.symbolToOriginInfoMap, previousToken = symbolCompletion.previousToken;
	                    var _a = getCompletionEntryCodeActionsAndSourceDisplay(symbolToOriginInfoMap, symbol, program, typeChecker, host, compilerOptions, sourceFile, previousToken, formatContext, getCanonicalFileName, allSourceFiles), codeActions = _a.codeActions, sourceDisplay = _a.sourceDisplay;
	                    var kindModifiers = ts.SymbolDisplay.getSymbolModifiers(symbol);
	                    var _b = ts.SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, symbol, sourceFile, location, location, 7 /* All */), displayParts = _b.displayParts, documentation = _b.documentation, symbolKind = _b.symbolKind, tags = _b.tags;
	                    return { name: name, kindModifiers: kindModifiers, kind: symbolKind, displayParts: displayParts, documentation: documentation, tags: tags, codeActions: codeActions, source: sourceDisplay };
	                }
	                case "none": {
	                    // Didn't find a symbol with this name.  See if we can find a keyword instead.
	                    if (allKeywordsCompletions().some(function (c) { return c.name === name; })) {
	                        return {
	                            name: name,
	                            kind: "keyword" /* keyword */,
	                            kindModifiers: "" /* none */,
	                            displayParts: [ts.displayPart(name, ts.SymbolDisplayPartKind.keyword)],
	                            documentation: undefined,
	                            tags: undefined,
	                            codeActions: undefined,
	                            source: undefined,
	                        };
	                    }
	                    return undefined;
	                }
	            }
	        }
	        Completions.getCompletionEntryDetails = getCompletionEntryDetails;
	        function getCompletionEntryCodeActionsAndSourceDisplay(symbolToOriginInfoMap, symbol, program, checker, host, compilerOptions, sourceFile, previousToken, formatContext, getCanonicalFileName, allSourceFiles) {
	            var symbolOriginInfo = symbolToOriginInfoMap[ts.getSymbolId(symbol)];
	            return symbolOriginInfo && symbolOriginInfo.type === "export"
	                ? getCodeActionsAndSourceDisplayForImport(symbolOriginInfo, symbol, program, checker, host, compilerOptions, sourceFile, previousToken, formatContext, getCanonicalFileName, allSourceFiles)
	                : { codeActions: undefined, sourceDisplay: undefined };
	        }
	        function getCodeActionsAndSourceDisplayForImport(symbolOriginInfo, symbol, program, checker, host, compilerOptions, sourceFile, previousToken, formatContext, getCanonicalFileName, allSourceFiles) {
	            var moduleSymbol = symbolOriginInfo.moduleSymbol;
	            var exportedSymbol = ts.skipAlias(symbol.exportSymbol || symbol, checker);
	            var _a = ts.codefix.getImportCompletionAction(exportedSymbol, moduleSymbol, sourceFile, getSymbolName(symbol, symbolOriginInfo, compilerOptions.target), host, program, checker, compilerOptions, allSourceFiles, formatContext, getCanonicalFileName, previousToken), moduleSpecifier = _a.moduleSpecifier, codeAction = _a.codeAction;
	            return { sourceDisplay: [ts.textPart(moduleSpecifier)], codeActions: [codeAction] };
	        }
	        function getCompletionEntrySymbol(typeChecker, log, compilerOptions, sourceFile, position, entryId, allSourceFiles) {
	            var completion = getSymbolCompletionFromEntryId(typeChecker, log, compilerOptions, sourceFile, position, entryId, allSourceFiles);
	            return completion.type === "symbol" ? completion.symbol : undefined;
	        }
	        Completions.getCompletionEntrySymbol = getCompletionEntrySymbol;
	        var CompletionDataKind;
	        (function (CompletionDataKind) {
	            CompletionDataKind[CompletionDataKind["Data"] = 0] = "Data";
	            CompletionDataKind[CompletionDataKind["JsDocTagName"] = 1] = "JsDocTagName";
	            CompletionDataKind[CompletionDataKind["JsDocTag"] = 2] = "JsDocTag";
	            CompletionDataKind[CompletionDataKind["JsDocParameterName"] = 3] = "JsDocParameterName";
	        })(CompletionDataKind || (CompletionDataKind = {}));
	        var CompletionKind;
	        (function (CompletionKind) {
	            CompletionKind[CompletionKind["ObjectPropertyDeclaration"] = 0] = "ObjectPropertyDeclaration";
	            CompletionKind[CompletionKind["Global"] = 1] = "Global";
	            CompletionKind[CompletionKind["PropertyAccess"] = 2] = "PropertyAccess";
	            CompletionKind[CompletionKind["MemberLike"] = 3] = "MemberLike";
	            CompletionKind[CompletionKind["String"] = 4] = "String";
	            CompletionKind[CompletionKind["None"] = 5] = "None";
	        })(CompletionKind || (CompletionKind = {}));
	        function getRecommendedCompletion(currentToken, position, sourceFile, checker) {
	            var ty = getContextualType(currentToken, position, sourceFile, checker);
	            var symbol = ty && ty.symbol;
	            // Don't include make a recommended completion for an abstract class
	            return symbol && (symbol.flags & 384 /* Enum */ || symbol.flags & 32 /* Class */ && !ts.isAbstractConstructorSymbol(symbol))
	                ? getFirstSymbolInChain(symbol, currentToken, checker)
	                : undefined;
	        }
	        function getContextualType(currentToken, position, sourceFile, checker) {
	            var parent = currentToken.parent;
	            switch (currentToken.kind) {
	                case 71 /* Identifier */:
	                    return getContextualTypeFromParent(currentToken, checker);
	                case 58 /* EqualsToken */:
	                    switch (parent.kind) {
	                        case 230 /* VariableDeclaration */:
	                            return checker.getContextualType(parent.initializer);
	                        case 198 /* BinaryExpression */:
	                            return checker.getTypeAtLocation(parent.left);
	                        case 260 /* JsxAttribute */:
	                            return checker.getContextualTypeForJsxAttribute(parent);
	                        default:
	                            return undefined;
	                    }
	                case 94 /* NewKeyword */:
	                    return checker.getContextualType(parent);
	                case 73 /* CaseKeyword */:
	                    return getSwitchedType(ts.cast(parent, ts.isCaseClause), checker);
	                case 17 /* OpenBraceToken */:
	                    return ts.isJsxExpression(parent) && parent.parent.kind !== 253 /* JsxElement */ ? checker.getContextualTypeForJsxAttribute(parent.parent) : undefined;
	                default:
	                    var argInfo = ts.SignatureHelp.getImmediatelyContainingArgumentInfo(currentToken, position, sourceFile);
	                    return argInfo
	                        // At `,`, treat this as the next argument after the comma.
	                        ? checker.getContextualTypeForArgumentAtIndex(argInfo.invocation, argInfo.argumentIndex + (currentToken.kind === 26 /* CommaToken */ ? 1 : 0))
	                        : isEqualityOperatorKind(currentToken.kind) && ts.isBinaryExpression(parent) && isEqualityOperatorKind(parent.operatorToken.kind)
	                            // completion at `x ===/**/` should be for the right side
	                            ? checker.getTypeAtLocation(parent.left)
	                            : checker.getContextualType(currentToken);
	            }
	        }
	        function getContextualTypeFromParent(node, checker) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 186 /* NewExpression */:
	                    return checker.getContextualType(parent);
	                case 198 /* BinaryExpression */: {
	                    var _a = parent, left = _a.left, operatorToken = _a.operatorToken, right = _a.right;
	                    return isEqualityOperatorKind(operatorToken.kind)
	                        ? checker.getTypeAtLocation(node === right ? left : right)
	                        : checker.getContextualType(node);
	                }
	                case 264 /* CaseClause */:
	                    return parent.expression === node ? getSwitchedType(parent, checker) : undefined;
	                default:
	                    return checker.getContextualType(node);
	            }
	        }
	        function getSwitchedType(caseClause, checker) {
	            return checker.getTypeAtLocation(caseClause.parent.parent.expression);
	        }
	        function getFirstSymbolInChain(symbol, enclosingDeclaration, checker) {
	            var chain = checker.getAccessibleSymbolChain(symbol, enclosingDeclaration, /*meaning*/ 67108863 /* All */, /*useOnlyExternalAliasing*/ false);
	            if (chain)
	                return ts.first(chain);
	            return symbol.parent && (isModuleSymbol(symbol.parent) ? symbol : getFirstSymbolInChain(symbol.parent, enclosingDeclaration, checker));
	        }
	        function isModuleSymbol(symbol) {
	            return symbol.declarations.some(function (d) { return d.kind === 272 /* SourceFile */; });
	        }
	        function getCompletionData(typeChecker, log, sourceFile, position, allSourceFiles, options, target) {
	            var start = ts.timestamp();
	            var currentToken = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false); // TODO: GH#15853
	            // We will check for jsdoc comments with insideComment and getJsDocTagAtPosition. (TODO: that seems rather inefficient to check the same thing so many times.)
	            log("getCompletionData: Get current token: " + (ts.timestamp() - start));
	            start = ts.timestamp();
	            // Completion not allowed inside comments, bail out if this is the case
	            var insideComment = ts.isInComment(sourceFile, position, currentToken);
	            log("getCompletionData: Is inside comment: " + (ts.timestamp() - start));
	            var insideJsDocTagTypeExpression = false;
	            var isInSnippetScope = false;
	            if (insideComment) {
	                if (ts.hasDocComment(sourceFile, position)) {
	                    if (sourceFile.text.charCodeAt(position - 1) === 64 /* at */) {
	                        // The current position is next to the '@' sign, when no tag name being provided yet.
	                        // Provide a full list of tag names
	                        return { kind: 1 /* JsDocTagName */ };
	                    }
	                    else {
	                        // When completion is requested without "@", we will have check to make sure that
	                        // there are no comments prefix the request position. We will only allow "*" and space.
	                        // e.g
	                        //   /** |c| /*
	                        //
	                        //   /**
	                        //     |c|
	                        //    */
	                        //
	                        //   /**
	                        //    * |c|
	                        //    */
	                        //
	                        //   /**
	                        //    *         |c|
	                        //    */
	                        var lineStart = ts.getLineStartPositionForPosition(position, sourceFile);
	                        if (!(sourceFile.text.substring(lineStart, position).match(/[^\*|\s|(/\*\*)]/))) {
	                            return { kind: 2 /* JsDocTag */ };
	                        }
	                    }
	                }
	                // Completion should work inside certain JsDoc tags. For example:
	                //     /** @type {number | string} */
	                // Completion should work in the brackets
	                var tag = getJsDocTagAtPosition(currentToken, position);
	                if (tag) {
	                    if (tag.tagName.pos <= position && position <= tag.tagName.end) {
	                        return { kind: 1 /* JsDocTagName */ };
	                    }
	                    if (isTagWithTypeExpression(tag) && tag.typeExpression && tag.typeExpression.kind === 274 /* JSDocTypeExpression */) {
	                        currentToken = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ true);
	                        if (!currentToken ||
	                            (!ts.isDeclarationName(currentToken) &&
	                                (currentToken.parent.kind !== 292 /* JSDocPropertyTag */ ||
	                                    currentToken.parent.name !== currentToken))) {
	                            // Use as type location if inside tag's type expression
	                            insideJsDocTagTypeExpression = isCurrentlyEditingNode(tag.typeExpression);
	                        }
	                    }
	                    if (ts.isJSDocParameterTag(tag) && (ts.nodeIsMissing(tag.name) || tag.name.pos <= position && position <= tag.name.end)) {
	                        return { kind: 3 /* JsDocParameterName */, tag: tag };
	                    }
	                }
	                if (!insideJsDocTagTypeExpression) {
	                    // Proceed if the current position is in jsDoc tag expression; otherwise it is a normal
	                    // comment or the plain text part of a jsDoc comment, so no completion should be available
	                    log("Returning an empty list because completion was inside a regular comment or plain text part of a JsDoc comment.");
	                    return undefined;
	                }
	            }
	            start = ts.timestamp();
	            var previousToken = ts.findPrecedingToken(position, sourceFile, /*startNode*/ undefined, insideJsDocTagTypeExpression);
	            log("getCompletionData: Get previous token 1: " + (ts.timestamp() - start));
	            // The decision to provide completion depends on the contextToken, which is determined through the previousToken.
	            // Note: 'previousToken' (and thus 'contextToken') can be undefined if we are the beginning of the file
	            var contextToken = previousToken;
	            // Check if the caret is at the end of an identifier; this is a partial identifier that we want to complete: e.g. a.toS|
	            // Skip this partial identifier and adjust the contextToken to the token that precedes it.
	            if (contextToken && position <= contextToken.end && ts.isWord(contextToken.kind)) {
	                var start_4 = ts.timestamp();
	                contextToken = ts.findPrecedingToken(contextToken.getFullStart(), sourceFile, /*startNode*/ undefined, insideJsDocTagTypeExpression);
	                log("getCompletionData: Get previous token 2: " + (ts.timestamp() - start_4));
	            }
	            // Find the node where completion is requested on.
	            // Also determine whether we are trying to complete with members of that node
	            // or attributes of a JSX tag.
	            var node = currentToken;
	            var propertyAccessToConvert;
	            var isRightOfDot = false;
	            var isRightOfOpenTag = false;
	            var isStartingCloseTag = false;
	            var isJsxInitializer = false;
	            var location = ts.getTouchingPropertyName(sourceFile, position, insideJsDocTagTypeExpression); // TODO: GH#15853
	            if (contextToken) {
	                // Bail out if this is a known invalid completion location
	                if (isCompletionListBlocker(contextToken)) {
	                    log("Returning an empty list because completion was requested in an invalid position.");
	                    return undefined;
	                }
	                var parent = contextToken.parent;
	                if (contextToken.kind === 23 /* DotToken */) {
	                    isRightOfDot = true;
	                    switch (parent.kind) {
	                        case 183 /* PropertyAccessExpression */:
	                            propertyAccessToConvert = parent;
	                            node = propertyAccessToConvert.expression;
	                            break;
	                        case 145 /* QualifiedName */:
	                            node = parent.left;
	                            break;
	                        default:
	                            // There is nothing that precedes the dot, so this likely just a stray character
	                            // or leading into a '...' token. Just bail out instead.
	                            return undefined;
	                    }
	                }
	                else if (sourceFile.languageVariant === 1 /* JSX */) {
	                    // <UI.Test /* completion position */ />
	                    // If the tagname is a property access expression, we will then walk up to the top most of property access expression.
	                    // Then, try to get a JSX container and its associated attributes type.
	                    if (parent && parent.kind === 183 /* PropertyAccessExpression */) {
	                        contextToken = parent;
	                        parent = parent.parent;
	                    }
	                    // Fix location
	                    if (currentToken.parent === location) {
	                        switch (currentToken.kind) {
	                            case 29 /* GreaterThanToken */:
	                                if (currentToken.parent.kind === 253 /* JsxElement */ || currentToken.parent.kind === 255 /* JsxOpeningElement */) {
	                                    location = currentToken;
	                                }
	                                break;
	                            case 41 /* SlashToken */:
	                                if (currentToken.parent.kind === 254 /* JsxSelfClosingElement */) {
	                                    location = currentToken;
	                                }
	                                break;
	                        }
	                    }
	                    switch (parent.kind) {
	                        case 256 /* JsxClosingElement */:
	                            if (contextToken.kind === 41 /* SlashToken */) {
	                                isStartingCloseTag = true;
	                                location = contextToken;
	                            }
	                            break;
	                        case 198 /* BinaryExpression */:
	                            if (!(parent.left.flags & 32768 /* ThisNodeHasError */)) {
	                                // It has a left-hand side, so we're not in an opening JSX tag.
	                                break;
	                            }
	                        // falls through
	                        case 254 /* JsxSelfClosingElement */:
	                        case 253 /* JsxElement */:
	                        case 255 /* JsxOpeningElement */:
	                            if (contextToken.kind === 27 /* LessThanToken */) {
	                                isRightOfOpenTag = true;
	                                location = contextToken;
	                            }
	                            break;
	                        case 260 /* JsxAttribute */:
	                            switch (previousToken.kind) {
	                                case 58 /* EqualsToken */:
	                                    isJsxInitializer = true;
	                                    break;
	                                case 71 /* Identifier */:
	                                    if (previousToken !== parent.name) {
	                                        isJsxInitializer = previousToken;
	                                    }
	                            }
	                            break;
	                    }
	                }
	            }
	            var semanticStart = ts.timestamp();
	            var completionKind = 5 /* None */;
	            var isNewIdentifierLocation = false;
	            var keywordFilters = 0 /* None */;
	            var symbols = [];
	            var symbolToOriginInfoMap = [];
	            if (isRightOfDot) {
	                getTypeScriptMemberSymbols();
	            }
	            else if (isRightOfOpenTag) {
	                var tagSymbols = ts.Debug.assertEachDefined(typeChecker.getJsxIntrinsicTagNames(), "getJsxIntrinsicTagNames() should all be defined");
	                if (tryGetGlobalSymbols()) {
	                    symbols = tagSymbols.concat(symbols.filter(function (s) { return !!(s.flags & (107455 /* Value */ | 2097152 /* Alias */)); }));
	                }
	                else {
	                    symbols = tagSymbols;
	                }
	                completionKind = 3 /* MemberLike */;
	            }
	            else if (isStartingCloseTag) {
	                var tagName = contextToken.parent.parent.openingElement.tagName;
	                var tagSymbol = typeChecker.getSymbolAtLocation(tagName);
	                if (tagSymbol) {
	                    symbols = [tagSymbol];
	                }
	                completionKind = 3 /* MemberLike */;
	            }
	            else {
	                // For JavaScript or TypeScript, if we're not after a dot, then just try to get the
	                // global symbols in scope.  These results should be valid for either language as
	                // the set of symbols that can be referenced from this location.
	                if (!tryGetGlobalSymbols()) {
	                    return undefined;
	                }
	            }
	            log("getCompletionData: Semantic work: " + (ts.timestamp() - semanticStart));
	            var recommendedCompletion = previousToken && getRecommendedCompletion(previousToken, position, sourceFile, typeChecker);
	            return { kind: 0 /* Data */, symbols: symbols, completionKind: completionKind, isInSnippetScope: isInSnippetScope, propertyAccessToConvert: propertyAccessToConvert, isNewIdentifierLocation: isNewIdentifierLocation, location: location, keywordFilters: keywordFilters, symbolToOriginInfoMap: symbolToOriginInfoMap, recommendedCompletion: recommendedCompletion, previousToken: previousToken, isJsxInitializer: isJsxInitializer };
	            function isTagWithTypeExpression(tag) {
	                switch (tag.kind) {
	                    case 287 /* JSDocParameterTag */:
	                    case 292 /* JSDocPropertyTag */:
	                    case 288 /* JSDocReturnTag */:
	                    case 289 /* JSDocTypeTag */:
	                    case 291 /* JSDocTypedefTag */:
	                        return true;
	                }
	            }
	            function getTypeScriptMemberSymbols() {
	                // Right of dot member completion list
	                completionKind = 2 /* PropertyAccess */;
	                // Since this is qualified name check its a type node location
	                var isTypeLocation = insideJsDocTagTypeExpression || ts.isPartOfTypeNode(node.parent);
	                var isRhsOfImportDeclaration = ts.isInRightSideOfInternalImportEqualsDeclaration(node);
	                if (ts.isEntityName(node)) {
	                    var symbol = typeChecker.getSymbolAtLocation(node);
	                    if (symbol) {
	                        symbol = ts.skipAlias(symbol, typeChecker);
	                        if (symbol.flags & (1536 /* Module */ | 384 /* Enum */)) {
	                            // Extract module or enum members
	                            var exportedSymbols = ts.Debug.assertEachDefined(typeChecker.getExportsOfModule(symbol), "getExportsOfModule() should all be defined");
	                            var isValidValueAccess_1 = function (symbol) { return typeChecker.isValidPropertyAccess((node.parent), symbol.name); };
	                            var isValidTypeAccess_1 = function (symbol) { return symbolCanBeReferencedAtTypeLocation(symbol); };
	                            var isValidAccess = isRhsOfImportDeclaration ?
	                                // Any kind is allowed when dotting off namespace in internal import equals declaration
	                                function (symbol) { return isValidTypeAccess_1(symbol) || isValidValueAccess_1(symbol); } :
	                                isTypeLocation ? isValidTypeAccess_1 : isValidValueAccess_1;
	                            for (var _i = 0, exportedSymbols_1 = exportedSymbols; _i < exportedSymbols_1.length; _i++) {
	                                var symbol_2 = exportedSymbols_1[_i];
	                                if (isValidAccess(symbol_2)) {
	                                    symbols.push(symbol_2);
	                                }
	                            }
	                            // If the module is merged with a value, we must get the type of the class and add its propertes (for inherited static methods).
	                            if (!isTypeLocation && symbol.declarations.some(function (d) { return d.kind !== 272 /* SourceFile */ && d.kind !== 237 /* ModuleDeclaration */ && d.kind !== 236 /* EnumDeclaration */; })) {
	                                addTypeProperties(typeChecker.getTypeOfSymbolAtLocation(symbol, node));
	                            }
	                            return;
	                        }
	                    }
	                }
	                if (!isTypeLocation) {
	                    addTypeProperties(typeChecker.getTypeAtLocation(node));
	                }
	            }
	            function addTypeProperties(type) {
	                if (ts.isSourceFileJavaScript(sourceFile)) {
	                    // In javascript files, for union types, we don't just get the members that
	                    // the individual types have in common, we also include all the members that
	                    // each individual type has. This is because we're going to add all identifiers
	                    // anyways. So we might as well elevate the members that were at least part
	                    // of the individual types to a higher status since we know what they are.
	                    symbols.push.apply(symbols, getPropertiesForCompletion(type, typeChecker, /*isForAccess*/ true));
	                }
	                else {
	                    for (var _i = 0, _a = type.getApparentProperties(); _i < _a.length; _i++) {
	                        var symbol = _a[_i];
	                        if (typeChecker.isValidPropertyAccessForCompletions((node.parent), type, symbol)) {
	                            symbols.push(symbol);
	                        }
	                    }
	                }
	            }
	            function tryGetGlobalSymbols() {
	                var objectLikeContainer;
	                var namedImportsOrExports;
	                var classLikeContainer;
	                var jsxContainer;
	                if (objectLikeContainer = tryGetObjectLikeCompletionContainer(contextToken)) {
	                    return tryGetObjectLikeCompletionSymbols(objectLikeContainer);
	                }
	                if (namedImportsOrExports = tryGetNamedImportsOrExportsForCompletion(contextToken)) {
	                    // cursor is in an import clause
	                    // try to show exported member for imported module
	                    return tryGetImportOrExportClauseCompletionSymbols(namedImportsOrExports);
	                }
	                if (tryGetConstructorLikeCompletionContainer(contextToken)) {
	                    // no members, only keywords
	                    completionKind = 5 /* None */;
	                    // Declaring new property/method/accessor
	                    isNewIdentifierLocation = true;
	                    // Has keywords for constructor parameter
	                    keywordFilters = 2 /* ConstructorParameterKeywords */;
	                    return true;
	                }
	                if (classLikeContainer = tryGetClassLikeCompletionContainer(contextToken)) {
	                    // cursor inside class declaration
	                    getGetClassLikeCompletionSymbols(classLikeContainer);
	                    return true;
	                }
	                if (jsxContainer = tryGetContainingJsxElement(contextToken)) {
	                    var attrsType = void 0;
	                    if ((jsxContainer.kind === 254 /* JsxSelfClosingElement */) || (jsxContainer.kind === 255 /* JsxOpeningElement */)) {
	                        // Cursor is inside a JSX self-closing element or opening element
	                        attrsType = typeChecker.getAllAttributesTypeFromJsxOpeningLikeElement(jsxContainer);
	                        if (attrsType) {
	                            symbols = filterJsxAttributes(typeChecker.getPropertiesOfType(attrsType), jsxContainer.attributes.properties);
	                            completionKind = 3 /* MemberLike */;
	                            isNewIdentifierLocation = false;
	                            return true;
	                        }
	                    }
	                }
	                if (tryGetFunctionLikeBodyCompletionContainer(contextToken)) {
	                    keywordFilters = 3 /* FunctionLikeBodyKeywords */;
	                }
	                // Get all entities in the current scope.
	                completionKind = 1 /* Global */;
	                isNewIdentifierLocation = isNewIdentifierDefinitionLocation(contextToken);
	                if (previousToken !== contextToken) {
	                    ts.Debug.assert(!!previousToken, "Expected 'contextToken' to be defined when different from 'previousToken'.");
	                }
	                // We need to find the node that will give us an appropriate scope to begin
	                // aggregating completion candidates. This is achieved in 'getScopeNode'
	                // by finding the first node that encompasses a position, accounting for whether a node
	                // is "complete" to decide whether a position belongs to the node.
	                //
	                // However, at the end of an identifier, we are interested in the scope of the identifier
	                // itself, but fall outside of the identifier. For instance:
	                //
	                //      xyz => x$
	                //
	                // the cursor is outside of both the 'x' and the arrow function 'xyz => x',
	                // so 'xyz' is not returned in our results.
	                //
	                // We define 'adjustedPosition' so that we may appropriately account for
	                // being at the end of an identifier. The intention is that if requesting completion
	                // at the end of an identifier, it should be effectively equivalent to requesting completion
	                // anywhere inside/at the beginning of the identifier. So in the previous case, the
	                // 'adjustedPosition' will work as if requesting completion in the following:
	                //
	                //      xyz => $x
	                //
	                // If previousToken !== contextToken, then
	                //   - 'contextToken' was adjusted to the token prior to 'previousToken'
	                //      because we were at the end of an identifier.
	                //   - 'previousToken' is defined.
	                var adjustedPosition = previousToken !== contextToken ?
	                    previousToken.getStart() :
	                    position;
	                var scopeNode = getScopeNode(contextToken, adjustedPosition, sourceFile) || sourceFile;
	                isInSnippetScope = isSnippetScope(scopeNode);
	                var symbolMeanings = 793064 /* Type */ | 107455 /* Value */ | 1920 /* Namespace */ | 2097152 /* Alias */;
	                symbols = ts.Debug.assertEachDefined(typeChecker.getSymbolsInScope(scopeNode, symbolMeanings), "getSymbolsInScope() should all be defined");
	                // Need to insert 'this.' before properties of `this` type, so only do that if `includeInsertTextCompletions`
	                if (options.includeInsertTextCompletions && scopeNode.kind !== 272 /* SourceFile */) {
	                    var thisType = typeChecker.tryGetThisTypeAt(scopeNode);
	                    if (thisType) {
	                        for (var _i = 0, _a = getPropertiesForCompletion(thisType, typeChecker, /*isForAccess*/ true); _i < _a.length; _i++) {
	                            var symbol = _a[_i];
	                            symbolToOriginInfoMap[ts.getSymbolId(symbol)] = { type: "this-type" };
	                            symbols.push(symbol);
	                        }
	                    }
	                }
	                if (options.includeExternalModuleExports) {
	                    getSymbolsFromOtherSourceFileExports(symbols, previousToken && ts.isIdentifier(previousToken) ? previousToken.text : "", target);
	                }
	                filterGlobalCompletion(symbols);
	                return true;
	            }
	            function isSnippetScope(scopeNode) {
	                switch (scopeNode.kind) {
	                    case 272 /* SourceFile */:
	                    case 200 /* TemplateExpression */:
	                    case 263 /* JsxExpression */:
	                    case 211 /* Block */:
	                        return true;
	                    default:
	                        return ts.isStatement(scopeNode);
	                }
	            }
	            function filterGlobalCompletion(symbols) {
	                var isTypeCompletion = insideJsDocTagTypeExpression || !isContextTokenValueLocation(contextToken) && (ts.isPartOfTypeNode(location) || isContextTokenTypeLocation(contextToken));
	                if (isTypeCompletion)
	                    keywordFilters = 4 /* TypeKeywords */;
	                ts.filterMutate(symbols, function (symbol) {
	                    if (!ts.isSourceFile(location)) {
	                        // export = /**/ here we want to get all meanings, so any symbol is ok
	                        if (ts.isExportAssignment(location.parent)) {
	                            return true;
	                        }
	                        symbol = ts.skipAlias(symbol, typeChecker);
	                        // import m = /**/ <-- It can only access namespace (if typing import = x. this would get member symbols and not namespace)
	                        if (ts.isInRightSideOfInternalImportEqualsDeclaration(location)) {
	                            return !!(symbol.flags & 1920 /* Namespace */);
	                        }
	                        if (isTypeCompletion) {
	                            // Its a type, but you can reach it by namespace.type as well
	                            return symbolCanBeReferencedAtTypeLocation(symbol);
	                        }
	                    }
	                    // expressions are value space (which includes the value namespaces)
	                    return !!(ts.getCombinedLocalAndExportSymbolFlags(symbol) & 107455 /* Value */);
	                });
	            }
	            function isContextTokenValueLocation(contextToken) {
	                return contextToken &&
	                    contextToken.kind === 103 /* TypeOfKeyword */ &&
	                    contextToken.parent.kind === 164 /* TypeQuery */;
	            }
	            function isContextTokenTypeLocation(contextToken) {
	                if (contextToken) {
	                    var parentKind = contextToken.parent.kind;
	                    switch (contextToken.kind) {
	                        case 56 /* ColonToken */:
	                            return parentKind === 151 /* PropertyDeclaration */ ||
	                                parentKind === 150 /* PropertySignature */ ||
	                                parentKind === 148 /* Parameter */ ||
	                                parentKind === 230 /* VariableDeclaration */ ||
	                                ts.isFunctionLikeKind(parentKind);
	                        case 58 /* EqualsToken */:
	                            return parentKind === 235 /* TypeAliasDeclaration */;
	                        case 118 /* AsKeyword */:
	                            return parentKind === 206 /* AsExpression */;
	                    }
	                }
	                return false;
	            }
	            function symbolCanBeReferencedAtTypeLocation(symbol) {
	                symbol = symbol.exportSymbol || symbol;
	                // This is an alias, follow what it aliases
	                symbol = ts.skipAlias(symbol, typeChecker);
	                if (symbol.flags & 793064 /* Type */) {
	                    return true;
	                }
	                if (symbol.flags & 1536 /* Module */) {
	                    var exportedSymbols = typeChecker.getExportsOfModule(symbol);
	                    // If the exported symbols contains type,
	                    // symbol can be referenced at locations where type is allowed
	                    return ts.forEach(exportedSymbols, symbolCanBeReferencedAtTypeLocation);
	                }
	            }
	            function getSymbolsFromOtherSourceFileExports(symbols, tokenText, target) {
	                var tokenTextLowerCase = tokenText.toLowerCase();
	                ts.codefix.forEachExternalModuleToImportFrom(typeChecker, sourceFile, allSourceFiles, function (moduleSymbol) {
	                    for (var _i = 0, _a = typeChecker.getExportsOfModule(moduleSymbol); _i < _a.length; _i++) {
	                        var symbol = _a[_i];
	                        // Don't add a completion for a re-export, only for the original.
	                        // The actual import fix might end up coming from a re-export -- we don't compute that until getting completion details.
	                        // This is just to avoid adding duplicate completion entries.
	                        //
	                        // If `symbol.parent !== ...`, this comes from an `export * from "foo"` re-export. Those don't create new symbols.
	                        // If `some(...)`, this comes from an `export { foo } from "foo"` re-export, which creates a new symbol (thus isn't caught by the first check).
	                        if (typeChecker.getMergedSymbol(symbol.parent) !== typeChecker.resolveExternalModuleSymbol(moduleSymbol)
	                            || ts.some(symbol.declarations, function (d) { return ts.isExportSpecifier(d) && !!d.parent.parent.moduleSpecifier; })) {
	                            continue;
	                        }
	                        var isDefaultExport = symbol.name === "default" /* Default */;
	                        if (isDefaultExport) {
	                            symbol = ts.getLocalSymbolForExportDefault(symbol) || symbol;
	                        }
	                        var origin = { type: "export", moduleSymbol: moduleSymbol, isDefaultExport: isDefaultExport };
	                        if (stringContainsCharactersInOrder(getSymbolName(symbol, origin, target).toLowerCase(), tokenTextLowerCase)) {
	                            symbols.push(symbol);
	                            symbolToOriginInfoMap[ts.getSymbolId(symbol)] = origin;
	                        }
	                    }
	                });
	            }
	            /**
	             * True if you could remove some characters in `a` to get `b`.
	             * E.g., true for "abcdef" and "bdf".
	             * But not true for "abcdef" and "dbf".
	             */
	            function stringContainsCharactersInOrder(str, characters) {
	                if (characters.length === 0) {
	                    return true;
	                }
	                var characterIndex = 0;
	                for (var strIndex = 0; strIndex < str.length; strIndex++) {
	                    if (str.charCodeAt(strIndex) === characters.charCodeAt(characterIndex)) {
	                        characterIndex++;
	                        if (characterIndex === characters.length) {
	                            return true;
	                        }
	                    }
	                }
	                // Did not find all characters
	                return false;
	            }
	            /**
	             * Finds the first node that "embraces" the position, so that one may
	             * accurately aggregate locals from the closest containing scope.
	             */
	            function getScopeNode(initialToken, position, sourceFile) {
	                var scope = initialToken;
	                while (scope && !ts.positionBelongsToNode(scope, position, sourceFile)) {
	                    scope = scope.parent;
	                }
	                return scope;
	            }
	            function isCompletionListBlocker(contextToken) {
	                var start = ts.timestamp();
	                var result = isInStringOrRegularExpressionOrTemplateLiteral(contextToken) ||
	                    isSolelyIdentifierDefinitionLocation(contextToken) ||
	                    isDotOfNumericLiteral(contextToken) ||
	                    isInJsxText(contextToken);
	                log("getCompletionsAtPosition: isCompletionListBlocker: " + (ts.timestamp() - start));
	                return result;
	            }
	            function isInJsxText(contextToken) {
	                if (contextToken.kind === 10 /* JsxText */) {
	                    return true;
	                }
	                if (contextToken.kind === 29 /* GreaterThanToken */ && contextToken.parent) {
	                    if (contextToken.parent.kind === 255 /* JsxOpeningElement */) {
	                        return true;
	                    }
	                    if (contextToken.parent.kind === 256 /* JsxClosingElement */ || contextToken.parent.kind === 254 /* JsxSelfClosingElement */) {
	                        return contextToken.parent.parent && contextToken.parent.parent.kind === 253 /* JsxElement */;
	                    }
	                }
	                return false;
	            }
	            function isNewIdentifierDefinitionLocation(previousToken) {
	                if (previousToken) {
	                    var containingNodeKind = previousToken.parent.kind;
	                    switch (previousToken.kind) {
	                        case 26 /* CommaToken */:
	                            return containingNodeKind === 185 /* CallExpression */ // func( a, |
	                                || containingNodeKind === 154 /* Constructor */ // constructor( a, |   /* public, protected, private keywords are allowed here, so show completion */
	                                || containingNodeKind === 186 /* NewExpression */ // new C(a, |
	                                || containingNodeKind === 181 /* ArrayLiteralExpression */ // [a, |
	                                || containingNodeKind === 198 /* BinaryExpression */ // const x = (a, |
	                                || containingNodeKind === 162 /* FunctionType */; // var x: (s: string, list|
	                        case 19 /* OpenParenToken */:
	                            return containingNodeKind === 185 /* CallExpression */ // func( |
	                                || containingNodeKind === 154 /* Constructor */ // constructor( |
	                                || containingNodeKind === 186 /* NewExpression */ // new C(a|
	                                || containingNodeKind === 189 /* ParenthesizedExpression */ // const x = (a|
	                                || containingNodeKind === 172 /* ParenthesizedType */; // function F(pred: (a| /* this can become an arrow function, where 'a' is the argument */
	                        case 21 /* OpenBracketToken */:
	                            return containingNodeKind === 181 /* ArrayLiteralExpression */ // [ |
	                                || containingNodeKind === 159 /* IndexSignature */ // [ | : string ]
	                                || containingNodeKind === 146 /* ComputedPropertyName */; // [ |    /* this can become an index signature */
	                        case 129 /* ModuleKeyword */: // module |
	                        case 130 /* NamespaceKeyword */:// namespace |
	                            return true;
	                        case 23 /* DotToken */:
	                            return containingNodeKind === 237 /* ModuleDeclaration */; // module A.|
	                        case 17 /* OpenBraceToken */:
	                            return containingNodeKind === 233 /* ClassDeclaration */; // class A{ |
	                        case 58 /* EqualsToken */:
	                            return containingNodeKind === 230 /* VariableDeclaration */ // const x = a|
	                                || containingNodeKind === 198 /* BinaryExpression */; // x = a|
	                        case 14 /* TemplateHead */:
	                            return containingNodeKind === 200 /* TemplateExpression */; // `aa ${|
	                        case 15 /* TemplateMiddle */:
	                            return containingNodeKind === 209 /* TemplateSpan */; // `aa ${10} dd ${|
	                        case 114 /* PublicKeyword */:
	                        case 112 /* PrivateKeyword */:
	                        case 113 /* ProtectedKeyword */:
	                            return containingNodeKind === 151 /* PropertyDeclaration */; // class A{ public |
	                    }
	                    // Previous token may have been a keyword that was converted to an identifier.
	                    switch (previousToken.getText()) {
	                        case "public":
	                        case "protected":
	                        case "private":
	                            return true;
	                    }
	                }
	                return false;
	            }
	            function isInStringOrRegularExpressionOrTemplateLiteral(contextToken) {
	                if (contextToken.kind === 9 /* StringLiteral */
	                    || contextToken.kind === 12 /* RegularExpressionLiteral */
	                    || ts.isTemplateLiteralKind(contextToken.kind)) {
	                    var start_5 = contextToken.getStart();
	                    var end = contextToken.getEnd();
	                    // To be "in" one of these literals, the position has to be:
	                    //   1. entirely within the token text.
	                    //   2. at the end position of an unterminated token.
	                    //   3. at the end of a regular expression (due to trailing flags like '/foo/g').
	                    if (start_5 < position && position < end) {
	                        return true;
	                    }
	                    if (position === end) {
	                        return !!contextToken.isUnterminated
	                            || contextToken.kind === 12 /* RegularExpressionLiteral */;
	                    }
	                }
	                return false;
	            }
	            /**
	             * Aggregates relevant symbols for completion in object literals and object binding patterns.
	             * Relevant symbols are stored in the captured 'symbols' variable.
	             *
	             * @returns true if 'symbols' was successfully populated; false otherwise.
	             */
	            function tryGetObjectLikeCompletionSymbols(objectLikeContainer) {
	                // We're looking up possible property names from contextual/inferred/declared type.
	                completionKind = 0 /* ObjectPropertyDeclaration */;
	                var typeMembers;
	                var existingMembers;
	                if (objectLikeContainer.kind === 182 /* ObjectLiteralExpression */) {
	                    // We are completing on contextual types, but may also include properties
	                    // other than those within the declared type.
	                    isNewIdentifierLocation = true;
	                    var typeForObject = typeChecker.getContextualType(objectLikeContainer);
	                    if (!typeForObject)
	                        return false;
	                    typeMembers = getPropertiesForCompletion(typeForObject, typeChecker, /*isForAccess*/ false);
	                    existingMembers = objectLikeContainer.properties;
	                }
	                else {
	                    ts.Debug.assert(objectLikeContainer.kind === 178 /* ObjectBindingPattern */);
	                    // We are *only* completing on properties from the type being destructured.
	                    isNewIdentifierLocation = false;
	                    var rootDeclaration = ts.getRootDeclaration(objectLikeContainer.parent);
	                    if (!ts.isVariableLike(rootDeclaration))
	                        throw ts.Debug.fail("Root declaration is not variable-like.");
	                    // We don't want to complete using the type acquired by the shape
	                    // of the binding pattern; we are only interested in types acquired
	                    // through type declaration or inference.
	                    // Also proceed if rootDeclaration is a parameter and if its containing function expression/arrow function is contextually typed -
	                    // type of parameter will flow in from the contextual type of the function
	                    var canGetType = ts.hasInitializer(rootDeclaration) || ts.hasType(rootDeclaration) || rootDeclaration.parent.parent.kind === 220 /* ForOfStatement */;
	                    if (!canGetType && rootDeclaration.kind === 148 /* Parameter */) {
	                        if (ts.isExpression(rootDeclaration.parent)) {
	                            canGetType = !!typeChecker.getContextualType(rootDeclaration.parent);
	                        }
	                        else if (rootDeclaration.parent.kind === 153 /* MethodDeclaration */ || rootDeclaration.parent.kind === 156 /* SetAccessor */) {
	                            canGetType = ts.isExpression(rootDeclaration.parent.parent) && !!typeChecker.getContextualType(rootDeclaration.parent.parent);
	                        }
	                    }
	                    if (canGetType) {
	                        var typeForObject = typeChecker.getTypeAtLocation(objectLikeContainer);
	                        if (!typeForObject)
	                            return false;
	                        // In a binding pattern, get only known properties. Everywhere else we will get all possible properties.
	                        typeMembers = typeChecker.getPropertiesOfType(typeForObject).filter(function (symbol) { return !(ts.getDeclarationModifierFlagsFromSymbol(symbol) & 24 /* NonPublicAccessibilityModifier */); });
	                        existingMembers = objectLikeContainer.elements;
	                    }
	                }
	                if (typeMembers && typeMembers.length > 0) {
	                    // Add filtered items to the completion list
	                    symbols = filterObjectMembersList(typeMembers, ts.Debug.assertDefined(existingMembers));
	                }
	                return true;
	            }
	            /**
	             * Aggregates relevant symbols for completion in import clauses and export clauses
	             * whose declarations have a module specifier; for instance, symbols will be aggregated for
	             *
	             *      import { | } from "moduleName";
	             *      export { a as foo, | } from "moduleName";
	             *
	             * but not for
	             *
	             *      export { | };
	             *
	             * Relevant symbols are stored in the captured 'symbols' variable.
	             *
	             * @returns true if 'symbols' was successfully populated; false otherwise.
	             */
	            function tryGetImportOrExportClauseCompletionSymbols(namedImportsOrExports) {
	                var declarationKind = namedImportsOrExports.kind === 245 /* NamedImports */ ?
	                    242 /* ImportDeclaration */ :
	                    248 /* ExportDeclaration */;
	                var importOrExportDeclaration = ts.getAncestor(namedImportsOrExports, declarationKind);
	                var moduleSpecifier = importOrExportDeclaration.moduleSpecifier;
	                if (!moduleSpecifier) {
	                    return false;
	                }
	                completionKind = 3 /* MemberLike */;
	                isNewIdentifierLocation = false;
	                var moduleSpecifierSymbol = typeChecker.getSymbolAtLocation(moduleSpecifier);
	                if (!moduleSpecifierSymbol) {
	                    symbols = ts.emptyArray;
	                    return true;
	                }
	                var exports = typeChecker.getExportsAndPropertiesOfModule(moduleSpecifierSymbol);
	                symbols = filterNamedImportOrExportCompletionItems(exports, namedImportsOrExports.elements);
	                return true;
	            }
	            /**
	             * Aggregates relevant symbols for completion in class declaration
	             * Relevant symbols are stored in the captured 'symbols' variable.
	             */
	            function getGetClassLikeCompletionSymbols(classLikeDeclaration) {
	                // We're looking up possible property names from parent type.
	                completionKind = 3 /* MemberLike */;
	                // Declaring new property/method/accessor
	                isNewIdentifierLocation = true;
	                // Has keywords for class elements
	                keywordFilters = 1 /* ClassElementKeywords */;
	                var baseTypeNode = ts.getClassExtendsHeritageClauseElement(classLikeDeclaration);
	                var implementsTypeNodes = ts.getClassImplementsHeritageClauseElements(classLikeDeclaration);
	                if (baseTypeNode || implementsTypeNodes) {
	                    var classElement = contextToken.parent;
	                    var classElementModifierFlags = ts.isClassElement(classElement) && ts.getModifierFlags(classElement);
	                    // If this is context token is not something we are editing now, consider if this would lead to be modifier
	                    if (contextToken.kind === 71 /* Identifier */ && !isCurrentlyEditingNode(contextToken)) {
	                        switch (contextToken.getText()) {
	                            case "private":
	                                classElementModifierFlags = classElementModifierFlags | 8 /* Private */;
	                                break;
	                            case "static":
	                                classElementModifierFlags = classElementModifierFlags | 32 /* Static */;
	                                break;
	                        }
	                    }
	                    // No member list for private methods
	                    if (!(classElementModifierFlags & 8 /* Private */)) {
	                        var baseClassTypeToGetPropertiesFrom = void 0;
	                        if (baseTypeNode) {
	                            baseClassTypeToGetPropertiesFrom = typeChecker.getTypeAtLocation(baseTypeNode);
	                            if (classElementModifierFlags & 32 /* Static */) {
	                                // Use static class to get property symbols from
	                                baseClassTypeToGetPropertiesFrom = typeChecker.getTypeOfSymbolAtLocation(baseClassTypeToGetPropertiesFrom.symbol, classLikeDeclaration);
	                            }
	                        }
	                        var implementedInterfaceTypePropertySymbols = (classElementModifierFlags & 32 /* Static */) ?
	                            ts.emptyArray :
	                            ts.flatMap(implementsTypeNodes || ts.emptyArray, function (typeNode) { return typeChecker.getPropertiesOfType(typeChecker.getTypeAtLocation(typeNode)); });
	                        // List of property symbols of base type that are not private and already implemented
	                        symbols = filterClassMembersList(baseClassTypeToGetPropertiesFrom ?
	                            typeChecker.getPropertiesOfType(baseClassTypeToGetPropertiesFrom) :
	                            ts.emptyArray, implementedInterfaceTypePropertySymbols, classLikeDeclaration.members, classElementModifierFlags);
	                    }
	                }
	            }
	            /**
	             * Returns the immediate owning object literal or binding pattern of a context token,
	             * on the condition that one exists and that the context implies completion should be given.
	             */
	            function tryGetObjectLikeCompletionContainer(contextToken) {
	                if (contextToken) {
	                    switch (contextToken.kind) {
	                        case 17 /* OpenBraceToken */: // const x = { |
	                        case 26 /* CommaToken */:// const x = { a: 0, |
	                            var parent = contextToken.parent;
	                            if (ts.isObjectLiteralExpression(parent) || ts.isObjectBindingPattern(parent)) {
	                                return parent;
	                            }
	                            break;
	                    }
	                }
	                return undefined;
	            }
	            /**
	             * Returns the containing list of named imports or exports of a context token,
	             * on the condition that one exists and that the context implies completion should be given.
	             */
	            function tryGetNamedImportsOrExportsForCompletion(contextToken) {
	                if (contextToken) {
	                    switch (contextToken.kind) {
	                        case 17 /* OpenBraceToken */: // import { |
	                        case 26 /* CommaToken */:// import { a as 0, |
	                            switch (contextToken.parent.kind) {
	                                case 245 /* NamedImports */:
	                                case 249 /* NamedExports */:
	                                    return contextToken.parent;
	                            }
	                    }
	                }
	                return undefined;
	            }
	            function isFromClassElementDeclaration(node) {
	                return ts.isClassElement(node.parent) && ts.isClassLike(node.parent.parent);
	            }
	            function isParameterOfConstructorDeclaration(node) {
	                return ts.isParameter(node) && ts.isConstructorDeclaration(node.parent);
	            }
	            function isConstructorParameterCompletion(node) {
	                return node.parent &&
	                    isParameterOfConstructorDeclaration(node.parent) &&
	                    (isConstructorParameterCompletionKeyword(node.kind) || ts.isDeclarationName(node));
	            }
	            /**
	             * Returns the immediate owning class declaration of a context token,
	             * on the condition that one exists and that the context implies completion should be given.
	             */
	            function tryGetClassLikeCompletionContainer(contextToken) {
	                if (contextToken) {
	                    switch (contextToken.kind) {
	                        case 17 /* OpenBraceToken */:// class c { |
	                            if (ts.isClassLike(contextToken.parent)) {
	                                return contextToken.parent;
	                            }
	                            break;
	                        // class c {getValue(): number, | }
	                        case 26 /* CommaToken */:
	                            if (ts.isClassLike(contextToken.parent)) {
	                                return contextToken.parent;
	                            }
	                            break;
	                        // class c {getValue(): number; | }
	                        case 25 /* SemicolonToken */:
	                        // class c { method() { } | }
	                        case 18 /* CloseBraceToken */:
	                            if (ts.isClassLike(location)) {
	                                return location;
	                            }
	                            // class c { method() { } b| }
	                            if (isFromClassElementDeclaration(location) &&
	                                location.parent.name === location) {
	                                return location.parent.parent;
	                            }
	                            break;
	                        default:
	                            if (isFromClassElementDeclaration(contextToken) &&
	                                (isClassMemberCompletionKeyword(contextToken.kind) ||
	                                    isClassMemberCompletionKeywordText(contextToken.getText()))) {
	                                return contextToken.parent.parent;
	                            }
	                    }
	                }
	                // class c { method() { } | method2() { } }
	                if (location && location.kind === 293 /* SyntaxList */ && ts.isClassLike(location.parent)) {
	                    return location.parent;
	                }
	                return undefined;
	            }
	            /**
	             * Returns the immediate owning class declaration of a context token,
	             * on the condition that one exists and that the context implies completion should be given.
	             */
	            function tryGetConstructorLikeCompletionContainer(contextToken) {
	                if (contextToken) {
	                    switch (contextToken.kind) {
	                        case 19 /* OpenParenToken */:
	                        case 26 /* CommaToken */:
	                            return ts.isConstructorDeclaration(contextToken.parent) && contextToken.parent;
	                        default:
	                            if (isConstructorParameterCompletion(contextToken)) {
	                                return contextToken.parent.parent;
	                            }
	                    }
	                }
	                return undefined;
	            }
	            function tryGetFunctionLikeBodyCompletionContainer(contextToken) {
	                if (contextToken) {
	                    var prev_1;
	                    var container = ts.findAncestor(contextToken.parent, function (node) {
	                        if (ts.isClassLike(node)) {
	                            return "quit";
	                        }
	                        if (ts.isFunctionLikeDeclaration(node) && prev_1 === node.body) {
	                            return true;
	                        }
	                        prev_1 = node;
	                    });
	                    return container && container;
	                }
	            }
	            function tryGetContainingJsxElement(contextToken) {
	                if (contextToken) {
	                    var parent = contextToken.parent;
	                    switch (contextToken.kind) {
	                        case 28 /* LessThanSlashToken */:
	                        case 41 /* SlashToken */:
	                        case 71 /* Identifier */:
	                        case 183 /* PropertyAccessExpression */:
	                        case 261 /* JsxAttributes */:
	                        case 260 /* JsxAttribute */:
	                        case 262 /* JsxSpreadAttribute */:
	                            if (parent && (parent.kind === 254 /* JsxSelfClosingElement */ || parent.kind === 255 /* JsxOpeningElement */)) {
	                                return parent;
	                            }
	                            else if (parent.kind === 260 /* JsxAttribute */) {
	                                // Currently we parse JsxOpeningLikeElement as:
	                                //      JsxOpeningLikeElement
	                                //          attributes: JsxAttributes
	                                //             properties: NodeArray<JsxAttributeLike>
	                                return parent.parent.parent;
	                            }
	                            break;
	                        // The context token is the closing } or " of an attribute, which means
	                        // its parent is a JsxExpression, whose parent is a JsxAttribute,
	                        // whose parent is a JsxOpeningLikeElement
	                        case 9 /* StringLiteral */:
	                            if (parent && ((parent.kind === 260 /* JsxAttribute */) || (parent.kind === 262 /* JsxSpreadAttribute */))) {
	                                // Currently we parse JsxOpeningLikeElement as:
	                                //      JsxOpeningLikeElement
	                                //          attributes: JsxAttributes
	                                //             properties: NodeArray<JsxAttributeLike>
	                                return parent.parent.parent;
	                            }
	                            break;
	                        case 18 /* CloseBraceToken */:
	                            if (parent &&
	                                parent.kind === 263 /* JsxExpression */ &&
	                                parent.parent && parent.parent.kind === 260 /* JsxAttribute */) {
	                                // Currently we parse JsxOpeningLikeElement as:
	                                //      JsxOpeningLikeElement
	                                //          attributes: JsxAttributes
	                                //             properties: NodeArray<JsxAttributeLike>
	                                //                  each JsxAttribute can have initializer as JsxExpression
	                                return parent.parent.parent.parent;
	                            }
	                            if (parent && parent.kind === 262 /* JsxSpreadAttribute */) {
	                                // Currently we parse JsxOpeningLikeElement as:
	                                //      JsxOpeningLikeElement
	                                //          attributes: JsxAttributes
	                                //             properties: NodeArray<JsxAttributeLike>
	                                return parent.parent.parent;
	                            }
	                            break;
	                    }
	                }
	                return undefined;
	            }
	            /**
	             * @returns true if we are certain that the currently edited location must define a new location; false otherwise.
	             */
	            function isSolelyIdentifierDefinitionLocation(contextToken) {
	                var containingNodeKind = contextToken.parent.kind;
	                switch (contextToken.kind) {
	                    case 26 /* CommaToken */:
	                        return containingNodeKind === 230 /* VariableDeclaration */ ||
	                            containingNodeKind === 231 /* VariableDeclarationList */ ||
	                            containingNodeKind === 212 /* VariableStatement */ ||
	                            containingNodeKind === 236 /* EnumDeclaration */ || // enum a { foo, |
	                            isFunctionLikeButNotConstructor(containingNodeKind) ||
	                            containingNodeKind === 234 /* InterfaceDeclaration */ || // interface A<T, |
	                            containingNodeKind === 179 /* ArrayBindingPattern */ || // var [x, y|
	                            containingNodeKind === 235 /* TypeAliasDeclaration */ || // type Map, K, |
	                            // class A<T, |
	                            // var C = class D<T, |
	                            (ts.isClassLike(contextToken.parent) &&
	                                contextToken.parent.typeParameters &&
	                                contextToken.parent.typeParameters.end >= contextToken.pos);
	                    case 23 /* DotToken */:
	                        return containingNodeKind === 179 /* ArrayBindingPattern */; // var [.|
	                    case 56 /* ColonToken */:
	                        return containingNodeKind === 180 /* BindingElement */; // var {x :html|
	                    case 21 /* OpenBracketToken */:
	                        return containingNodeKind === 179 /* ArrayBindingPattern */; // var [x|
	                    case 19 /* OpenParenToken */:
	                        return containingNodeKind === 267 /* CatchClause */ ||
	                            isFunctionLikeButNotConstructor(containingNodeKind);
	                    case 17 /* OpenBraceToken */:
	                        return containingNodeKind === 236 /* EnumDeclaration */ || // enum a { |
	                            containingNodeKind === 234 /* InterfaceDeclaration */ || // interface a { |
	                            containingNodeKind === 165 /* TypeLiteral */; // const x : { |
	                    case 25 /* SemicolonToken */:
	                        return containingNodeKind === 150 /* PropertySignature */ &&
	                            contextToken.parent && contextToken.parent.parent &&
	                            (contextToken.parent.parent.kind === 234 /* InterfaceDeclaration */ || // interface a { f; |
	                                contextToken.parent.parent.kind === 165 /* TypeLiteral */); // const x : { a; |
	                    case 27 /* LessThanToken */:
	                        return containingNodeKind === 233 /* ClassDeclaration */ || // class A< |
	                            containingNodeKind === 203 /* ClassExpression */ || // var C = class D< |
	                            containingNodeKind === 234 /* InterfaceDeclaration */ || // interface A< |
	                            containingNodeKind === 235 /* TypeAliasDeclaration */ || // type List< |
	                            ts.isFunctionLikeKind(containingNodeKind);
	                    case 115 /* StaticKeyword */:
	                        return containingNodeKind === 151 /* PropertyDeclaration */ && !ts.isClassLike(contextToken.parent.parent);
	                    case 24 /* DotDotDotToken */:
	                        return containingNodeKind === 148 /* Parameter */ ||
	                            (contextToken.parent && contextToken.parent.parent &&
	                                contextToken.parent.parent.kind === 179 /* ArrayBindingPattern */); // var [...z|
	                    case 114 /* PublicKeyword */:
	                    case 112 /* PrivateKeyword */:
	                    case 113 /* ProtectedKeyword */:
	                        return containingNodeKind === 148 /* Parameter */ && !ts.isConstructorDeclaration(contextToken.parent.parent);
	                    case 118 /* AsKeyword */:
	                        return containingNodeKind === 246 /* ImportSpecifier */ ||
	                            containingNodeKind === 250 /* ExportSpecifier */ ||
	                            containingNodeKind === 244 /* NamespaceImport */;
	                    case 125 /* GetKeyword */:
	                    case 136 /* SetKeyword */:
	                        if (isFromClassElementDeclaration(contextToken)) {
	                            return false;
	                        }
	                    // falls through
	                    case 75 /* ClassKeyword */:
	                    case 83 /* EnumKeyword */:
	                    case 109 /* InterfaceKeyword */:
	                    case 89 /* FunctionKeyword */:
	                    case 104 /* VarKeyword */:
	                    case 91 /* ImportKeyword */:
	                    case 110 /* LetKeyword */:
	                    case 76 /* ConstKeyword */:
	                    case 116 /* YieldKeyword */:
	                    case 139 /* TypeKeyword */:// type htm|
	                        return true;
	                }
	                // If the previous token is keyword correspoding to class member completion keyword
	                // there will be completion available here
	                if (isClassMemberCompletionKeywordText(contextToken.getText()) &&
	                    isFromClassElementDeclaration(contextToken)) {
	                    return false;
	                }
	                if (isConstructorParameterCompletion(contextToken)) {
	                    // constructor parameter completion is available only if
	                    // - its modifier of the constructor parameter or
	                    // - its name of the parameter and not being edited
	                    // eg. constructor(a |<- this shouldnt show completion
	                    if (!ts.isIdentifier(contextToken) ||
	                        isConstructorParameterCompletionKeywordText(contextToken.getText()) ||
	                        isCurrentlyEditingNode(contextToken)) {
	                        return false;
	                    }
	                }
	                // Previous token may have been a keyword that was converted to an identifier.
	                switch (contextToken.getText()) {
	                    case "abstract":
	                    case "async":
	                    case "class":
	                    case "const":
	                    case "declare":
	                    case "enum":
	                    case "function":
	                    case "interface":
	                    case "let":
	                    case "private":
	                    case "protected":
	                    case "public":
	                    case "static":
	                    case "var":
	                    case "yield":
	                        return true;
	                }
	                return ts.isDeclarationName(contextToken)
	                    && !ts.isJsxAttribute(contextToken.parent)
	                    // Don't block completions if we're in `class C /**/`, because we're *past* the end of the identifier and might want to complete `extends`.
	                    // If `contextToken !== previousToken`, this is `class C ex/**/`.
	                    && !(ts.isClassLike(contextToken.parent) && (contextToken !== previousToken || position > previousToken.end));
	            }
	            function isFunctionLikeButNotConstructor(kind) {
	                return ts.isFunctionLikeKind(kind) && kind !== 154 /* Constructor */;
	            }
	            function isDotOfNumericLiteral(contextToken) {
	                if (contextToken.kind === 8 /* NumericLiteral */) {
	                    var text = contextToken.getFullText();
	                    return text.charAt(text.length - 1) === ".";
	                }
	                return false;
	            }
	            /**
	             * Filters out completion suggestions for named imports or exports.
	             *
	             * @param exportsOfModule          The list of symbols which a module exposes.
	             * @param namedImportsOrExports    The list of existing import/export specifiers in the import/export clause.
	             *
	             * @returns Symbols to be suggested at an import/export clause, barring those whose named imports/exports
	             *          do not occur at the current position and have not otherwise been typed.
	             */
	            function filterNamedImportOrExportCompletionItems(exportsOfModule, namedImportsOrExports) {
	                var existingImportsOrExports = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, namedImportsOrExports_1 = namedImportsOrExports; _i < namedImportsOrExports_1.length; _i++) {
	                    var element = namedImportsOrExports_1[_i];
	                    // If this is the current item we are editing right now, do not filter it out
	                    if (isCurrentlyEditingNode(element)) {
	                        continue;
	                    }
	                    var name = element.propertyName || element.name;
	                    existingImportsOrExports.set(name.escapedText, true);
	                }
	                return exportsOfModule.filter(function (e) { return e.escapedName !== "default" /* Default */ && !existingImportsOrExports.get(e.escapedName); });
	            }
	            /**
	             * Filters out completion suggestions for named imports or exports.
	             *
	             * @returns Symbols to be suggested in an object binding pattern or object literal expression, barring those whose declarations
	             *          do not occur at the current position and have not otherwise been typed.
	             */
	            function filterObjectMembersList(contextualMemberSymbols, existingMembers) {
	                if (existingMembers.length === 0) {
	                    return contextualMemberSymbols;
	                }
	                var existingMemberNames = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, existingMembers_1 = existingMembers; _i < existingMembers_1.length; _i++) {
	                    var m = existingMembers_1[_i];
	                    // Ignore omitted expressions for missing members
	                    if (m.kind !== 268 /* PropertyAssignment */ &&
	                        m.kind !== 269 /* ShorthandPropertyAssignment */ &&
	                        m.kind !== 180 /* BindingElement */ &&
	                        m.kind !== 153 /* MethodDeclaration */ &&
	                        m.kind !== 155 /* GetAccessor */ &&
	                        m.kind !== 156 /* SetAccessor */) {
	                        continue;
	                    }
	                    // If this is the current item we are editing right now, do not filter it out
	                    if (isCurrentlyEditingNode(m)) {
	                        continue;
	                    }
	                    var existingName = void 0;
	                    if (m.kind === 180 /* BindingElement */ && m.propertyName) {
	                        // include only identifiers in completion list
	                        if (m.propertyName.kind === 71 /* Identifier */) {
	                            existingName = m.propertyName.escapedText;
	                        }
	                    }
	                    else {
	                        // TODO: Account for computed property name
	                        // NOTE: if one only performs this step when m.name is an identifier,
	                        // things like '__proto__' are not filtered out.
	                        var name = ts.getNameOfDeclaration(m);
	                        existingName = ts.isPropertyNameLiteral(name) ? ts.getEscapedTextOfIdentifierOrLiteral(name) : undefined;
	                    }
	                    existingMemberNames.set(existingName, true);
	                }
	                return contextualMemberSymbols.filter(function (m) { return !existingMemberNames.get(m.escapedName); });
	            }
	            /**
	             * Filters out completion suggestions for class elements.
	             *
	             * @returns Symbols to be suggested in an class element depending on existing memebers and symbol flags
	             */
	            function filterClassMembersList(baseSymbols, implementingTypeSymbols, existingMembers, currentClassElementModifierFlags) {
	                var existingMemberNames = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, existingMembers_2 = existingMembers; _i < existingMembers_2.length; _i++) {
	                    var m = existingMembers_2[_i];
	                    // Ignore omitted expressions for missing members
	                    if (m.kind !== 151 /* PropertyDeclaration */ &&
	                        m.kind !== 153 /* MethodDeclaration */ &&
	                        m.kind !== 155 /* GetAccessor */ &&
	                        m.kind !== 156 /* SetAccessor */) {
	                        continue;
	                    }
	                    // If this is the current item we are editing right now, do not filter it out
	                    if (isCurrentlyEditingNode(m)) {
	                        continue;
	                    }
	                    // Dont filter member even if the name matches if it is declared private in the list
	                    if (ts.hasModifier(m, 8 /* Private */)) {
	                        continue;
	                    }
	                    // do not filter it out if the static presence doesnt match
	                    var mIsStatic = ts.hasModifier(m, 32 /* Static */);
	                    var currentElementIsStatic = !!(currentClassElementModifierFlags & 32 /* Static */);
	                    if ((mIsStatic && !currentElementIsStatic) ||
	                        (!mIsStatic && currentElementIsStatic)) {
	                        continue;
	                    }
	                    var existingName = ts.getPropertyNameForPropertyNameNode(m.name);
	                    if (existingName) {
	                        existingMemberNames.set(existingName, true);
	                    }
	                }
	                var result = [];
	                addPropertySymbols(baseSymbols, 8 /* Private */);
	                addPropertySymbols(implementingTypeSymbols, 24 /* NonPublicAccessibilityModifier */);
	                return result;
	                function addPropertySymbols(properties, inValidModifierFlags) {
	                    for (var _i = 0, properties_12 = properties; _i < properties_12.length; _i++) {
	                        var property = properties_12[_i];
	                        if (isValidProperty(property, inValidModifierFlags)) {
	                            result.push(property);
	                        }
	                    }
	                }
	                function isValidProperty(propertySymbol, inValidModifierFlags) {
	                    return !existingMemberNames.get(propertySymbol.escapedName) &&
	                        propertySymbol.getDeclarations() &&
	                        !(ts.getDeclarationModifierFlagsFromSymbol(propertySymbol) & inValidModifierFlags);
	                }
	            }
	            /**
	             * Filters out completion suggestions from 'symbols' according to existing JSX attributes.
	             *
	             * @returns Symbols to be suggested in a JSX element, barring those whose attributes
	             *          do not occur at the current position and have not otherwise been typed.
	             */
	            function filterJsxAttributes(symbols, attributes) {
	                var seenNames = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
	                    var attr = attributes_1[_i];
	                    // If this is the current item we are editing right now, do not filter it out
	                    if (isCurrentlyEditingNode(attr)) {
	                        continue;
	                    }
	                    if (attr.kind === 260 /* JsxAttribute */) {
	                        seenNames.set(attr.name.escapedText, true);
	                    }
	                }
	                return symbols.filter(function (a) { return !seenNames.get(a.escapedName); });
	            }
	            function isCurrentlyEditingNode(node) {
	                return node.getStart() <= position && position <= node.getEnd();
	            }
	        }
	        function getCompletionEntryDisplayNameForSymbol(symbol, target, origin, kind) {
	            var name = getSymbolName(symbol, origin, target);
	            if (name === undefined
	                // If the symbol is external module, don't show it in the completion list
	                // (i.e declare module "http" { const x; } | // <= request completion here, "http" should not be there)
	                || symbol.flags & 1536 /* Module */ && ts.startsWithQuote(name)
	                // If the symbol is the internal name of an ES symbol, it is not a valid entry. Internal names for ES symbols start with "__@"
	                || ts.isKnownSymbol(symbol)) {
	                return undefined;
	            }
	            var validIdentiferResult = { name: name, needsConvertPropertyAccess: false };
	            if (ts.isIdentifierText(name, target))
	                return validIdentiferResult;
	            switch (kind) {
	                case 3 /* MemberLike */:
	                    return undefined;
	                case 0 /* ObjectPropertyDeclaration */:
	                    // TODO: GH#18169
	                    return { name: JSON.stringify(name), needsConvertPropertyAccess: false };
	                case 2 /* PropertyAccess */:
	                case 1 /* Global */:
	                    // Don't add a completion for a name starting with a space. See https://github.com/Microsoft/TypeScript/pull/20547
	                    return name.charCodeAt(0) === 32 /* space */ ? undefined : { name: name, needsConvertPropertyAccess: true };
	                case 5 /* None */:
	                case 4 /* String */:
	                    return validIdentiferResult;
	                default:
	                    ts.Debug.assertNever(kind);
	            }
	        }
	        // A cache of completion entries for keywords, these do not change between sessions
	        var _keywordCompletions = [];
	        var allKeywordsCompletions = ts.memoize(function () {
	            var res = [];
	            for (var i = 72 /* FirstKeyword */; i <= 144 /* LastKeyword */; i++) {
	                res.push({
	                    name: ts.tokenToString(i),
	                    kind: "keyword" /* keyword */,
	                    kindModifiers: "" /* none */,
	                    sortText: "0"
	                });
	            }
	            return res;
	        });
	        function getKeywordCompletions(keywordFilter) {
	            return _keywordCompletions[keywordFilter] || (_keywordCompletions[keywordFilter] = allKeywordsCompletions().filter(function (entry) {
	                var kind = ts.stringToToken(entry.name);
	                switch (keywordFilter) {
	                    case 0 /* None */:
	                        // "undefined" is a global variable, so don't need a keyword completion for it.
	                        return kind !== 140 /* UndefinedKeyword */;
	                    case 1 /* ClassElementKeywords */:
	                        return isClassMemberCompletionKeyword(kind);
	                    case 2 /* ConstructorParameterKeywords */:
	                        return isConstructorParameterCompletionKeyword(kind);
	                    case 3 /* FunctionLikeBodyKeywords */:
	                        return isFunctionLikeBodyCompletionKeyword(kind);
	                    case 4 /* TypeKeywords */:
	                        return ts.isTypeKeyword(kind);
	                    default:
	                        return ts.Debug.assertNever(keywordFilter);
	                }
	            }));
	        }
	        function isClassMemberCompletionKeyword(kind) {
	            switch (kind) {
	                case 114 /* PublicKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 117 /* AbstractKeyword */:
	                case 115 /* StaticKeyword */:
	                case 123 /* ConstructorKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                case 125 /* GetKeyword */:
	                case 136 /* SetKeyword */:
	                case 120 /* AsyncKeyword */:
	                    return true;
	            }
	        }
	        function isClassMemberCompletionKeywordText(text) {
	            return isClassMemberCompletionKeyword(ts.stringToToken(text));
	        }
	        function isConstructorParameterCompletionKeyword(kind) {
	            switch (kind) {
	                case 114 /* PublicKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                    return true;
	            }
	        }
	        function isConstructorParameterCompletionKeywordText(text) {
	            return isConstructorParameterCompletionKeyword(ts.stringToToken(text));
	        }
	        function isFunctionLikeBodyCompletionKeyword(kind) {
	            switch (kind) {
	                case 114 /* PublicKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                case 123 /* ConstructorKeyword */:
	                case 115 /* StaticKeyword */:
	                case 117 /* AbstractKeyword */:
	                case 125 /* GetKeyword */:
	                case 136 /* SetKeyword */:
	                case 140 /* UndefinedKeyword */:
	                    return false;
	            }
	            return true;
	        }
	        function isEqualityOperatorKind(kind) {
	            switch (kind) {
	                case 34 /* EqualsEqualsEqualsToken */:
	                case 32 /* EqualsEqualsToken */:
	                case 35 /* ExclamationEqualsEqualsToken */:
	                case 33 /* ExclamationEqualsToken */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        /** Get the corresponding JSDocTag node if the position is in a jsDoc comment */
	        function getJsDocTagAtPosition(node, position) {
	            var jsDoc = getJsDocHavingNode(node).jsDoc;
	            if (!jsDoc)
	                return undefined;
	            for (var _i = 0, jsDoc_1 = jsDoc; _i < jsDoc_1.length; _i++) {
	                var _a = jsDoc_1[_i], pos = _a.pos, end = _a.end, tags = _a.tags;
	                if (!tags || position < pos || position > end)
	                    continue;
	                for (var i = tags.length - 1; i >= 0; i--) {
	                    var tag = tags[i];
	                    if (position >= tag.pos) {
	                        return tag;
	                    }
	                }
	            }
	        }
	        function getJsDocHavingNode(node) {
	            if (!ts.isToken(node))
	                return node;
	            switch (node.kind) {
	                case 104 /* VarKeyword */:
	                case 110 /* LetKeyword */:
	                case 76 /* ConstKeyword */:
	                    // if the current token is var, let or const, skip the VariableDeclarationList
	                    return node.parent.parent;
	                default:
	                    return node.parent;
	            }
	        }
	        /**
	         * Gets all properties on a type, but if that type is a union of several types,
	         * excludes array-like types or callable/constructable types.
	         */
	        function getPropertiesForCompletion(type, checker, isForAccess) {
	            if (!(type.flags & 131072 /* Union */)) {
	                return ts.Debug.assertEachDefined(type.getApparentProperties(), "getApparentProperties() should all be defined");
	            }
	            var types = type.types;
	            // If we're providing completions for an object literal, skip primitive, array-like, or callable types since those shouldn't be implemented by object literals.
	            var filteredTypes = isForAccess ? types : types.filter(function (memberType) {
	                return !(memberType.flags & 16382 /* Primitive */ || checker.isArrayLikeType(memberType) || ts.typeHasCallOrConstructSignatures(memberType, checker));
	            });
	            return ts.Debug.assertEachDefined(checker.getAllPossiblePropertiesOfTypes(filteredTypes), "getAllPossiblePropertiesOfTypes() should all be defined");
	        }
	    })(Completions = ts.Completions || (ts.Completions = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var DocumentHighlights;
	    (function (DocumentHighlights) {
	        function getDocumentHighlights(program, cancellationToken, sourceFile, position, sourceFilesToSearch) {
	            var node = ts.getTouchingWord(sourceFile, position, /*includeJsDocComment*/ true);
	            if (node.parent && (ts.isJsxOpeningElement(node.parent) && node.parent.tagName === node || ts.isJsxClosingElement(node.parent))) {
	                // For a JSX element, just highlight the matching tag, not all references.
	                var _a = node.parent.parent, openingElement = _a.openingElement, closingElement = _a.closingElement;
	                var highlightSpans = [openingElement, closingElement].map(function (_a) {
	                    var tagName = _a.tagName;
	                    return getHighlightSpanForNode(tagName, sourceFile);
	                });
	                return [{ fileName: sourceFile.fileName, highlightSpans: highlightSpans }];
	            }
	            return getSemanticDocumentHighlights(position, node, program, cancellationToken, sourceFilesToSearch) || getSyntacticDocumentHighlights(node, sourceFile);
	        }
	        DocumentHighlights.getDocumentHighlights = getDocumentHighlights;
	        function getHighlightSpanForNode(node, sourceFile) {
	            return {
	                fileName: sourceFile.fileName,
	                textSpan: ts.createTextSpanFromNode(node, sourceFile),
	                kind: "none" /* none */
	            };
	        }
	        function getSemanticDocumentHighlights(position, node, program, cancellationToken, sourceFilesToSearch) {
	            var referenceEntries = ts.FindAllReferences.getReferenceEntriesForNode(position, node, program, sourceFilesToSearch, cancellationToken);
	            if (!referenceEntries)
	                return undefined;
	            var map = ts.arrayToMultiMap(referenceEntries.map(ts.FindAllReferences.toHighlightSpan), function (e) { return e.fileName; }, function (e) { return e.span; });
	            return ts.arrayFrom(map.entries(), function (_a) {
	                var fileName = _a[0], highlightSpans = _a[1];
	                return ({ fileName: fileName, highlightSpans: highlightSpans });
	            });
	        }
	        function getSyntacticDocumentHighlights(node, sourceFile) {
	            var highlightSpans = getHighlightSpans(node, sourceFile);
	            if (!highlightSpans || highlightSpans.length === 0) {
	                return undefined;
	            }
	            return [{ fileName: sourceFile.fileName, highlightSpans: highlightSpans }];
	        }
	        function getHighlightSpans(node, sourceFile) {
	            switch (node.kind) {
	                case 90 /* IfKeyword */:
	                case 82 /* ElseKeyword */:
	                    return ts.isIfStatement(node.parent) ? getIfElseOccurrences(node.parent, sourceFile) : undefined;
	                case 96 /* ReturnKeyword */:
	                    return useParent(node.parent, ts.isReturnStatement, getReturnOccurrences);
	                case 100 /* ThrowKeyword */:
	                    return useParent(node.parent, ts.isThrowStatement, getThrowOccurrences);
	                case 102 /* TryKeyword */:
	                case 74 /* CatchKeyword */:
	                case 87 /* FinallyKeyword */:
	                    var tryStatement = node.kind === 74 /* CatchKeyword */ ? node.parent.parent : node.parent;
	                    return useParent(tryStatement, ts.isTryStatement, getTryCatchFinallyOccurrences);
	                case 98 /* SwitchKeyword */:
	                    return useParent(node.parent, ts.isSwitchStatement, getSwitchCaseDefaultOccurrences);
	                case 73 /* CaseKeyword */:
	                case 79 /* DefaultKeyword */:
	                    return useParent(node.parent.parent.parent, ts.isSwitchStatement, getSwitchCaseDefaultOccurrences);
	                case 72 /* BreakKeyword */:
	                case 77 /* ContinueKeyword */:
	                    return useParent(node.parent, ts.isBreakOrContinueStatement, getBreakOrContinueStatementOccurrences);
	                case 88 /* ForKeyword */:
	                case 106 /* WhileKeyword */:
	                case 81 /* DoKeyword */:
	                    return useParent(node.parent, function (n) { return ts.isIterationStatement(n, /*lookInLabeledStatements*/ true); }, getLoopBreakContinueOccurrences);
	                case 123 /* ConstructorKeyword */:
	                    return getFromAllDeclarations(ts.isConstructorDeclaration, [123 /* ConstructorKeyword */]);
	                case 125 /* GetKeyword */:
	                case 136 /* SetKeyword */:
	                    return getFromAllDeclarations(ts.isAccessor, [125 /* GetKeyword */, 136 /* SetKeyword */]);
	                default:
	                    return ts.isModifierKind(node.kind) && (ts.isDeclaration(node.parent) || ts.isVariableStatement(node.parent))
	                        ? highlightSpans(getModifierOccurrences(node.kind, node.parent))
	                        : undefined;
	            }
	            function getFromAllDeclarations(nodeTest, keywords) {
	                return useParent(node.parent, nodeTest, function (decl) { return ts.mapDefined(decl.symbol.declarations, function (d) {
	                    return nodeTest(d) ? ts.find(d.getChildren(sourceFile), function (c) { return ts.contains(keywords, c.kind); }) : undefined;
	                }); });
	            }
	            function useParent(node, nodeTest, getNodes) {
	                return nodeTest(node) ? highlightSpans(getNodes(node, sourceFile)) : undefined;
	            }
	            function highlightSpans(nodes) {
	                return nodes && nodes.map(function (node) { return getHighlightSpanForNode(node, sourceFile); });
	            }
	        }
	        /**
	         * Aggregates all throw-statements within this node *without* crossing
	         * into function boundaries and try-blocks with catch-clauses.
	         */
	        function aggregateOwnedThrowStatements(node) {
	            if (ts.isThrowStatement(node)) {
	                return [node];
	            }
	            else if (ts.isTryStatement(node)) {
	                // Exceptions thrown within a try block lacking a catch clause are "owned" in the current context.
	                return ts.concatenate(node.catchClause ? aggregateOwnedThrowStatements(node.catchClause) : node.tryBlock && aggregateOwnedThrowStatements(node.tryBlock), aggregateOwnedThrowStatements(node.finallyBlock));
	            }
	            // Do not cross function boundaries.
	            return ts.isFunctionLike(node) ? undefined : flatMapChildren(node, aggregateOwnedThrowStatements);
	        }
	        /**
	         * For lack of a better name, this function takes a throw statement and returns the
	         * nearest ancestor that is a try-block (whose try statement has a catch clause),
	         * function-block, or source file.
	         */
	        function getThrowStatementOwner(throwStatement) {
	            var child = throwStatement;
	            while (child.parent) {
	                var parent = child.parent;
	                if (ts.isFunctionBlock(parent) || parent.kind === 272 /* SourceFile */) {
	                    return parent;
	                }
	                // A throw-statement is only owned by a try-statement if the try-statement has
	                // a catch clause, and if the throw-statement occurs within the try block.
	                if (ts.isTryStatement(parent) && parent.tryBlock === child && parent.catchClause) {
	                    return child;
	                }
	                child = parent;
	            }
	            return undefined;
	        }
	        function aggregateAllBreakAndContinueStatements(node) {
	            return ts.isBreakOrContinueStatement(node) ? [node] : ts.isFunctionLike(node) ? undefined : flatMapChildren(node, aggregateAllBreakAndContinueStatements);
	        }
	        function flatMapChildren(node, cb) {
	            var result = [];
	            node.forEachChild(function (child) {
	                var value = cb(child);
	                if (value !== undefined) {
	                    result.push.apply(result, ts.toArray(value));
	                }
	            });
	            return result;
	        }
	        function ownsBreakOrContinueStatement(owner, statement) {
	            var actualOwner = getBreakOrContinueOwner(statement);
	            return actualOwner && actualOwner === owner;
	        }
	        function getBreakOrContinueOwner(statement) {
	            return ts.findAncestor(statement, function (node) {
	                switch (node.kind) {
	                    case 225 /* SwitchStatement */:
	                        if (statement.kind === 221 /* ContinueStatement */) {
	                            return false;
	                        }
	                    // falls through
	                    case 218 /* ForStatement */:
	                    case 219 /* ForInStatement */:
	                    case 220 /* ForOfStatement */:
	                    case 217 /* WhileStatement */:
	                    case 216 /* DoStatement */:
	                        return !statement.label || isLabeledBy(node, statement.label.escapedText);
	                    default:
	                        // Don't cross function boundaries.
	                        // TODO: GH#20090
	                        return (ts.isFunctionLike(node) && "quit");
	                }
	            });
	        }
	        function getModifierOccurrences(modifier, declaration) {
	            var modifierFlag = ts.modifierToFlag(modifier);
	            return ts.mapDefined(getNodesToSearchForModifier(declaration, modifierFlag), function (node) {
	                if (ts.getModifierFlags(node) & modifierFlag) {
	                    var mod = ts.find(node.modifiers, function (m) { return m.kind === modifier; });
	                    ts.Debug.assert(!!mod);
	                    return mod;
	                }
	            });
	        }
	        function getNodesToSearchForModifier(declaration, modifierFlag) {
	            // Types of node whose children might have modifiers.
	            var container = declaration.parent;
	            switch (container.kind) {
	                case 238 /* ModuleBlock */:
	                case 272 /* SourceFile */:
	                case 211 /* Block */:
	                case 264 /* CaseClause */:
	                case 265 /* DefaultClause */:
	                    // Container is either a class declaration or the declaration is a classDeclaration
	                    if (modifierFlag & 128 /* Abstract */ && ts.isClassDeclaration(declaration)) {
	                        return declaration.members.concat([declaration]);
	                    }
	                    else {
	                        return container.statements;
	                    }
	                case 154 /* Constructor */:
	                case 153 /* MethodDeclaration */:
	                case 232 /* FunctionDeclaration */: {
	                    return container.parameters.concat((ts.isClassLike(container.parent) ? container.parent.members : []));
	                }
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                    var nodes = container.members;
	                    // If we're an accessibility modifier, we're in an instance member and should search
	                    // the constructor's parameter list for instance members as well.
	                    if (modifierFlag & 28 /* AccessibilityModifier */) {
	                        var constructor = ts.find(container.members, ts.isConstructorDeclaration);
	                        if (constructor) {
	                            return nodes.concat(constructor.parameters);
	                        }
	                    }
	                    else if (modifierFlag & 128 /* Abstract */) {
	                        return nodes.concat([container]);
	                    }
	                    return nodes;
	                default:
	                    ts.Debug.assertNever(container, "Invalid container kind.");
	            }
	        }
	        function pushKeywordIf(keywordList, token) {
	            var expected = [];
	            for (var _i = 2; _i < arguments.length; _i++) {
	                expected[_i - 2] = arguments[_i];
	            }
	            if (token && ts.contains(expected, token.kind)) {
	                keywordList.push(token);
	                return true;
	            }
	            return false;
	        }
	        function getLoopBreakContinueOccurrences(loopNode) {
	            var keywords = [];
	            if (pushKeywordIf(keywords, loopNode.getFirstToken(), 88 /* ForKeyword */, 106 /* WhileKeyword */, 81 /* DoKeyword */)) {
	                // If we succeeded and got a do-while loop, then start looking for a 'while' keyword.
	                if (loopNode.kind === 216 /* DoStatement */) {
	                    var loopTokens = loopNode.getChildren();
	                    for (var i = loopTokens.length - 1; i >= 0; i--) {
	                        if (pushKeywordIf(keywords, loopTokens[i], 106 /* WhileKeyword */)) {
	                            break;
	                        }
	                    }
	                }
	            }
	            ts.forEach(aggregateAllBreakAndContinueStatements(loopNode.statement), function (statement) {
	                if (ownsBreakOrContinueStatement(loopNode, statement)) {
	                    pushKeywordIf(keywords, statement.getFirstToken(), 72 /* BreakKeyword */, 77 /* ContinueKeyword */);
	                }
	            });
	            return keywords;
	        }
	        function getBreakOrContinueStatementOccurrences(breakOrContinueStatement) {
	            var owner = getBreakOrContinueOwner(breakOrContinueStatement);
	            if (owner) {
	                switch (owner.kind) {
	                    case 218 /* ForStatement */:
	                    case 219 /* ForInStatement */:
	                    case 220 /* ForOfStatement */:
	                    case 216 /* DoStatement */:
	                    case 217 /* WhileStatement */:
	                        return getLoopBreakContinueOccurrences(owner);
	                    case 225 /* SwitchStatement */:
	                        return getSwitchCaseDefaultOccurrences(owner);
	                }
	            }
	            return undefined;
	        }
	        function getSwitchCaseDefaultOccurrences(switchStatement) {
	            var keywords = [];
	            pushKeywordIf(keywords, switchStatement.getFirstToken(), 98 /* SwitchKeyword */);
	            // Go through each clause in the switch statement, collecting the 'case'/'default' keywords.
	            ts.forEach(switchStatement.caseBlock.clauses, function (clause) {
	                pushKeywordIf(keywords, clause.getFirstToken(), 73 /* CaseKeyword */, 79 /* DefaultKeyword */);
	                ts.forEach(aggregateAllBreakAndContinueStatements(clause), function (statement) {
	                    if (ownsBreakOrContinueStatement(switchStatement, statement)) {
	                        pushKeywordIf(keywords, statement.getFirstToken(), 72 /* BreakKeyword */);
	                    }
	                });
	            });
	            return keywords;
	        }
	        function getTryCatchFinallyOccurrences(tryStatement, sourceFile) {
	            var keywords = [];
	            pushKeywordIf(keywords, tryStatement.getFirstToken(), 102 /* TryKeyword */);
	            if (tryStatement.catchClause) {
	                pushKeywordIf(keywords, tryStatement.catchClause.getFirstToken(), 74 /* CatchKeyword */);
	            }
	            if (tryStatement.finallyBlock) {
	                var finallyKeyword = ts.findChildOfKind(tryStatement, 87 /* FinallyKeyword */, sourceFile);
	                pushKeywordIf(keywords, finallyKeyword, 87 /* FinallyKeyword */);
	            }
	            return keywords;
	        }
	        function getThrowOccurrences(throwStatement, sourceFile) {
	            var owner = getThrowStatementOwner(throwStatement);
	            if (!owner) {
	                return undefined;
	            }
	            var keywords = [];
	            ts.forEach(aggregateOwnedThrowStatements(owner), function (throwStatement) {
	                keywords.push(ts.findChildOfKind(throwStatement, 100 /* ThrowKeyword */, sourceFile));
	            });
	            // If the "owner" is a function, then we equate 'return' and 'throw' statements in their
	            // ability to "jump out" of the function, and include occurrences for both.
	            if (ts.isFunctionBlock(owner)) {
	                ts.forEachReturnStatement(owner, function (returnStatement) {
	                    keywords.push(ts.findChildOfKind(returnStatement, 96 /* ReturnKeyword */, sourceFile));
	                });
	            }
	            return keywords;
	        }
	        function getReturnOccurrences(returnStatement, sourceFile) {
	            var func = ts.getContainingFunction(returnStatement);
	            if (!func) {
	                return undefined;
	            }
	            var keywords = [];
	            ts.forEachReturnStatement(ts.cast(func.body, ts.isBlock), function (returnStatement) {
	                keywords.push(ts.findChildOfKind(returnStatement, 96 /* ReturnKeyword */, sourceFile));
	            });
	            // Include 'throw' statements that do not occur within a try block.
	            ts.forEach(aggregateOwnedThrowStatements(func.body), function (throwStatement) {
	                keywords.push(ts.findChildOfKind(throwStatement, 100 /* ThrowKeyword */, sourceFile));
	            });
	            return keywords;
	        }
	        function getIfElseOccurrences(ifStatement, sourceFile) {
	            var keywords = getIfElseKeywords(ifStatement, sourceFile);
	            var result = [];
	            // We'd like to highlight else/ifs together if they are only separated by whitespace
	            // (i.e. the keywords are separated by no comments, no newlines).
	            for (var i = 0; i < keywords.length; i++) {
	                if (keywords[i].kind === 82 /* ElseKeyword */ && i < keywords.length - 1) {
	                    var elseKeyword = keywords[i];
	                    var ifKeyword = keywords[i + 1]; // this *should* always be an 'if' keyword.
	                    var shouldCombineElseAndIf = true;
	                    // Avoid recalculating getStart() by iterating backwards.
	                    for (var j = ifKeyword.getStart(sourceFile) - 1; j >= elseKeyword.end; j--) {
	                        if (!ts.isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(j))) {
	                            shouldCombineElseAndIf = false;
	                            break;
	                        }
	                    }
	                    if (shouldCombineElseAndIf) {
	                        result.push({
	                            fileName: sourceFile.fileName,
	                            textSpan: ts.createTextSpanFromBounds(elseKeyword.getStart(), ifKeyword.end),
	                            kind: "reference" /* reference */
	                        });
	                        i++; // skip the next keyword
	                        continue;
	                    }
	                }
	                // Ordinary case: just highlight the keyword.
	                result.push(getHighlightSpanForNode(keywords[i], sourceFile));
	            }
	            return result;
	        }
	        function getIfElseKeywords(ifStatement, sourceFile) {
	            var keywords = [];
	            // Traverse upwards through all parent if-statements linked by their else-branches.
	            while (ts.isIfStatement(ifStatement.parent) && ifStatement.parent.elseStatement === ifStatement) {
	                ifStatement = ifStatement.parent;
	            }
	            // Now traverse back down through the else branches, aggregating if/else keywords of if-statements.
	            while (true) {
	                var children = ifStatement.getChildren(sourceFile);
	                pushKeywordIf(keywords, children[0], 90 /* IfKeyword */);
	                // Generally the 'else' keyword is second-to-last, so we traverse backwards.
	                for (var i = children.length - 1; i >= 0; i--) {
	                    if (pushKeywordIf(keywords, children[i], 82 /* ElseKeyword */)) {
	                        break;
	                    }
	                }
	                if (!ifStatement.elseStatement || !ts.isIfStatement(ifStatement.elseStatement)) {
	                    break;
	                }
	                ifStatement = ifStatement.elseStatement;
	            }
	            return keywords;
	        }
	        /**
	         * Whether or not a 'node' is preceded by a label of the given string.
	         * Note: 'node' cannot be a SourceFile.
	         */
	        function isLabeledBy(node, labelName) {
	            return !!ts.findAncestor(node.parent, function (owner) { return !ts.isLabeledStatement(owner) ? "quit" : owner.label.escapedText === labelName; });
	        }
	    })(DocumentHighlights = ts.DocumentHighlights || (ts.DocumentHighlights = {}));
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    function createDocumentRegistry(useCaseSensitiveFileNames, currentDirectory) {
	        if (currentDirectory === void 0) { currentDirectory = ""; }
	        // Maps from compiler setting target (ES3, ES5, etc.) to all the cached documents we have
	        // for those settings.
	        var buckets = ts.createMap();
	        var getCanonicalFileName = ts.createGetCanonicalFileName(!!useCaseSensitiveFileNames);
	        function getKeyForCompilationSettings(settings) {
	            return "_" + settings.target + "|" + settings.module + "|" + settings.noResolve + "|" + settings.jsx + "|" + settings.allowJs + "|" + settings.baseUrl + "|" + JSON.stringify(settings.typeRoots) + "|" + JSON.stringify(settings.rootDirs) + "|" + JSON.stringify(settings.paths);
	        }
	        function getBucketForCompilationSettings(key, createIfMissing) {
	            var bucket = buckets.get(key);
	            if (!bucket && createIfMissing) {
	                buckets.set(key, bucket = ts.createMap());
	            }
	            return bucket;
	        }
	        function reportStats() {
	            var bucketInfoArray = ts.arrayFrom(buckets.keys()).filter(function (name) { return name && name.charAt(0) === "_"; }).map(function (name) {
	                var entries = buckets.get(name);
	                var sourceFiles = [];
	                entries.forEach(function (entry, name) {
	                    sourceFiles.push({
	                        name: name,
	                        refCount: entry.languageServiceRefCount,
	                        references: entry.owners.slice(0)
	                    });
	                });
	                sourceFiles.sort(function (x, y) { return y.refCount - x.refCount; });
	                return {
	                    bucket: name,
	                    sourceFiles: sourceFiles
	                };
	            });
	            return JSON.stringify(bucketInfoArray, undefined, 2);
	        }
	        function acquireDocument(fileName, compilationSettings, scriptSnapshot, version, scriptKind) {
	            var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	            var key = getKeyForCompilationSettings(compilationSettings);
	            return acquireDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version, scriptKind);
	        }
	        function acquireDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version, scriptKind) {
	            return acquireOrUpdateDocument(fileName, path, compilationSettings, key, scriptSnapshot, version, /*acquiring*/ true, scriptKind);
	        }
	        function updateDocument(fileName, compilationSettings, scriptSnapshot, version, scriptKind) {
	            var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	            var key = getKeyForCompilationSettings(compilationSettings);
	            return updateDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version, scriptKind);
	        }
	        function updateDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version, scriptKind) {
	            return acquireOrUpdateDocument(fileName, path, compilationSettings, key, scriptSnapshot, version, /*acquiring*/ false, scriptKind);
	        }
	        function acquireOrUpdateDocument(fileName, path, compilationSettings, key, scriptSnapshot, version, acquiring, scriptKind) {
	            var bucket = getBucketForCompilationSettings(key, /*createIfMissing*/ true);
	            var entry = bucket.get(path);
	            if (!entry) {
	                // Have never seen this file with these settings.  Create a new source file for it.
	                var sourceFile = ts.createLanguageServiceSourceFile(fileName, scriptSnapshot, compilationSettings.target, version, /*setNodeParents*/ false, scriptKind);
	                entry = {
	                    sourceFile: sourceFile,
	                    languageServiceRefCount: 1,
	                    owners: []
	                };
	                bucket.set(path, entry);
	            }
	            else {
	                // We have an entry for this file.  However, it may be for a different version of
	                // the script snapshot.  If so, update it appropriately.  Otherwise, we can just
	                // return it as is.
	                if (entry.sourceFile.version !== version) {
	                    entry.sourceFile = ts.updateLanguageServiceSourceFile(entry.sourceFile, scriptSnapshot, version, scriptSnapshot.getChangeRange(entry.sourceFile.scriptSnapshot));
	                }
	                // If we're acquiring, then this is the first time this LS is asking for this document.
	                // Increase our ref count so we know there's another LS using the document.  If we're
	                // not acquiring, then that means the LS is 'updating' the file instead, and that means
	                // it has already acquired the document previously.  As such, we do not need to increase
	                // the ref count.
	                if (acquiring) {
	                    entry.languageServiceRefCount++;
	                }
	            }
	            return entry.sourceFile;
	        }
	        function releaseDocument(fileName, compilationSettings) {
	            var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	            var key = getKeyForCompilationSettings(compilationSettings);
	            return releaseDocumentWithKey(path, key);
	        }
	        function releaseDocumentWithKey(path, key) {
	            var bucket = getBucketForCompilationSettings(key, /*createIfMissing*/ false);
	            ts.Debug.assert(bucket !== undefined);
	            var entry = bucket.get(path);
	            entry.languageServiceRefCount--;
	            ts.Debug.assert(entry.languageServiceRefCount >= 0);
	            if (entry.languageServiceRefCount === 0) {
	                bucket.delete(path);
	            }
	        }
	        return {
	            acquireDocument: acquireDocument,
	            acquireDocumentWithKey: acquireDocumentWithKey,
	            updateDocument: updateDocument,
	            updateDocumentWithKey: updateDocumentWithKey,
	            releaseDocument: releaseDocument,
	            releaseDocumentWithKey: releaseDocumentWithKey,
	            reportStats: reportStats,
	            getKeyForCompilationSettings: getKeyForCompilationSettings
	        };
	    }
	    ts.createDocumentRegistry = createDocumentRegistry;
	})(ts || (ts = {}));
	/* Code for finding imports of an exported symbol. Used only by FindAllReferences. */
	/* @internal */
	var ts;
	(function (ts) {
	    var FindAllReferences;
	    (function (FindAllReferences) {
	        /** Creates the imports map and returns an ImportTracker that uses it. Call this lazily to avoid calling `getDirectImportsMap` unnecessarily.  */
	        function createImportTracker(sourceFiles, checker, cancellationToken) {
	            var allDirectImports = getDirectImportsMap(sourceFiles, checker, cancellationToken);
	            return function (exportSymbol, exportInfo, isForRename) {
	                var _a = getImportersForExport(sourceFiles, allDirectImports, exportInfo, checker, cancellationToken), directImports = _a.directImports, indirectUsers = _a.indirectUsers;
	                return __assign({ indirectUsers: indirectUsers }, getSearchesFromDirectImports(directImports, exportSymbol, exportInfo.exportKind, checker, isForRename));
	            };
	        }
	        FindAllReferences.createImportTracker = createImportTracker;
	        var ExportKind;
	        (function (ExportKind) {
	            ExportKind[ExportKind["Named"] = 0] = "Named";
	            ExportKind[ExportKind["Default"] = 1] = "Default";
	            ExportKind[ExportKind["ExportEquals"] = 2] = "ExportEquals";
	        })(ExportKind = FindAllReferences.ExportKind || (FindAllReferences.ExportKind = {}));
	        var ImportExport;
	        (function (ImportExport) {
	            ImportExport[ImportExport["Import"] = 0] = "Import";
	            ImportExport[ImportExport["Export"] = 1] = "Export";
	        })(ImportExport = FindAllReferences.ImportExport || (FindAllReferences.ImportExport = {}));
	        /** Returns import statements that directly reference the exporting module, and a list of files that may access the module through a namespace. */
	        function getImportersForExport(sourceFiles, allDirectImports, _a, checker, cancellationToken) {
	            var exportingModuleSymbol = _a.exportingModuleSymbol, exportKind = _a.exportKind;
	            var markSeenDirectImport = ts.nodeSeenTracker();
	            var markSeenIndirectUser = ts.nodeSeenTracker();
	            var directImports = [];
	            var isAvailableThroughGlobal = !!exportingModuleSymbol.globalExports;
	            var indirectUserDeclarations = isAvailableThroughGlobal ? undefined : [];
	            handleDirectImports(exportingModuleSymbol);
	            return { directImports: directImports, indirectUsers: getIndirectUsers() };
	            function getIndirectUsers() {
	                if (isAvailableThroughGlobal) {
	                    // It has `export as namespace`, so anything could potentially use it.
	                    return sourceFiles;
	                }
	                // Module augmentations may use this module's exports without importing it.
	                for (var _i = 0, _a = exportingModuleSymbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    if (ts.isExternalModuleAugmentation(decl)) {
	                        addIndirectUser(decl);
	                    }
	                }
	                // This may return duplicates (if there are multiple module declarations in a single source file, all importing the same thing as a namespace), but `State.markSearchedSymbol` will handle that.
	                return indirectUserDeclarations.map(ts.getSourceFileOfNode);
	            }
	            function handleDirectImports(exportingModuleSymbol) {
	                var theseDirectImports = getDirectImports(exportingModuleSymbol);
	                if (theseDirectImports) {
	                    for (var _i = 0, theseDirectImports_1 = theseDirectImports; _i < theseDirectImports_1.length; _i++) {
	                        var direct = theseDirectImports_1[_i];
	                        if (!markSeenDirectImport(direct)) {
	                            continue;
	                        }
	                        cancellationToken.throwIfCancellationRequested();
	                        switch (direct.kind) {
	                            case 185 /* CallExpression */:
	                                if (!isAvailableThroughGlobal) {
	                                    var parent = direct.parent;
	                                    if (exportKind === 2 /* ExportEquals */ && parent.kind === 230 /* VariableDeclaration */) {
	                                        var name = parent.name;
	                                        if (name.kind === 71 /* Identifier */) {
	                                            directImports.push(name);
	                                            break;
	                                        }
	                                    }
	                                    // Don't support re-exporting 'require()' calls, so just add a single indirect user.
	                                    addIndirectUser(direct.getSourceFile());
	                                }
	                                break;
	                            case 241 /* ImportEqualsDeclaration */:
	                                handleNamespaceImport(direct, direct.name, ts.hasModifier(direct, 1 /* Export */));
	                                break;
	                            case 242 /* ImportDeclaration */:
	                                var namedBindings = direct.importClause && direct.importClause.namedBindings;
	                                if (namedBindings && namedBindings.kind === 244 /* NamespaceImport */) {
	                                    handleNamespaceImport(direct, namedBindings.name);
	                                }
	                                else if (ts.isDefaultImport(direct)) {
	                                    var sourceFileLike = getSourceFileLikeForImportDeclaration(direct);
	                                    if (!isAvailableThroughGlobal) {
	                                        addIndirectUser(sourceFileLike); // Add a check for indirect uses to handle synthetic default imports
	                                    }
	                                    directImports.push(direct);
	                                }
	                                else {
	                                    directImports.push(direct);
	                                }
	                                break;
	                            case 248 /* ExportDeclaration */:
	                                if (!direct.exportClause) {
	                                    // This is `export * from "foo"`, so imports of this module may import the export too.
	                                    handleDirectImports(getContainingModuleSymbol(direct, checker));
	                                }
	                                else {
	                                    // This is `export { foo } from "foo"` and creates an alias symbol, so recursive search will get handle re-exports.
	                                    directImports.push(direct);
	                                }
	                                break;
	                        }
	                    }
	                }
	            }
	            function handleNamespaceImport(importDeclaration, name, isReExport) {
	                if (exportKind === 2 /* ExportEquals */) {
	                    // This is a direct import, not import-as-namespace.
	                    directImports.push(importDeclaration);
	                }
	                else if (!isAvailableThroughGlobal) {
	                    var sourceFileLike = getSourceFileLikeForImportDeclaration(importDeclaration);
	                    ts.Debug.assert(sourceFileLike.kind === 272 /* SourceFile */ || sourceFileLike.kind === 237 /* ModuleDeclaration */);
	                    if (isReExport || findNamespaceReExports(sourceFileLike, name, checker)) {
	                        addIndirectUsers(sourceFileLike);
	                    }
	                    else {
	                        addIndirectUser(sourceFileLike);
	                    }
	                }
	            }
	            function addIndirectUser(sourceFileLike) {
	                ts.Debug.assert(!isAvailableThroughGlobal);
	                var isNew = markSeenIndirectUser(sourceFileLike);
	                if (isNew) {
	                    indirectUserDeclarations.push(sourceFileLike);
	                }
	                return isNew;
	            }
	            /** Adds a module and all of its transitive dependencies as possible indirect users. */
	            function addIndirectUsers(sourceFileLike) {
	                if (!addIndirectUser(sourceFileLike)) {
	                    return;
	                }
	                var moduleSymbol = checker.getMergedSymbol(sourceFileLike.symbol);
	                ts.Debug.assert(!!(moduleSymbol.flags & 1536 /* Module */));
	                var directImports = getDirectImports(moduleSymbol);
	                if (directImports) {
	                    for (var _i = 0, directImports_1 = directImports; _i < directImports_1.length; _i++) {
	                        var directImport = directImports_1[_i];
	                        addIndirectUsers(getSourceFileLikeForImportDeclaration(directImport));
	                    }
	                }
	            }
	            function getDirectImports(moduleSymbol) {
	                return allDirectImports.get(ts.getSymbolId(moduleSymbol).toString());
	            }
	        }
	        /**
	         * Given the set of direct imports of a module, we need to find which ones import the particular exported symbol.
	         * The returned `importSearches` will result in the entire source file being searched.
	         * But re-exports will be placed in 'singleReferences' since they cannot be locally referenced.
	         */
	        function getSearchesFromDirectImports(directImports, exportSymbol, exportKind, checker, isForRename) {
	            var importSearches = [];
	            var singleReferences = [];
	            function addSearch(location, symbol) {
	                importSearches.push([location, symbol]);
	            }
	            if (directImports) {
	                for (var _i = 0, directImports_2 = directImports; _i < directImports_2.length; _i++) {
	                    var decl = directImports_2[_i];
	                    handleImport(decl);
	                }
	            }
	            return { importSearches: importSearches, singleReferences: singleReferences };
	            function handleImport(decl) {
	                if (decl.kind === 241 /* ImportEqualsDeclaration */) {
	                    if (isExternalModuleImportEquals(decl)) {
	                        handleNamespaceImportLike(decl.name);
	                    }
	                    return;
	                }
	                if (decl.kind === 71 /* Identifier */) {
	                    handleNamespaceImportLike(decl);
	                    return;
	                }
	                // Ignore if there's a grammar error
	                if (decl.moduleSpecifier.kind !== 9 /* StringLiteral */) {
	                    return;
	                }
	                if (decl.kind === 248 /* ExportDeclaration */) {
	                    searchForNamedImport(decl.exportClause);
	                    return;
	                }
	                var importClause = decl.importClause;
	                if (!importClause) {
	                    return;
	                }
	                var namedBindings = importClause.namedBindings;
	                if (namedBindings && namedBindings.kind === 244 /* NamespaceImport */) {
	                    handleNamespaceImportLike(namedBindings.name);
	                    return;
	                }
	                if (exportKind === 0 /* Named */) {
	                    searchForNamedImport(namedBindings);
	                }
	                else {
	                    // `export =` might be imported by a default import if `--allowSyntheticDefaultImports` is on, so this handles both ExportKind.Default and ExportKind.ExportEquals
	                    var name = importClause.name;
	                    // If a default import has the same name as the default export, allow to rename it.
	                    // Given `import f` and `export default function f`, we will rename both, but for `import g` we will rename just that.
	                    if (name && (!isForRename || name.escapedText === symbolName(exportSymbol))) {
	                        var defaultImportAlias = checker.getSymbolAtLocation(name);
	                        addSearch(name, defaultImportAlias);
	                    }
	                    // 'default' might be accessed as a named import `{ default as foo }`.
	                    if (!isForRename && exportKind === 1 /* Default */) {
	                        searchForNamedImport(namedBindings);
	                    }
	                }
	            }
	            /**
	             * `import x = require("./x") or `import * as x from "./x"`.
	             * An `export =` may be imported by this syntax, so it may be a direct import.
	             * If it's not a direct import, it will be in `indirectUsers`, so we don't have to do anything here.
	             */
	            function handleNamespaceImportLike(importName) {
	                // Don't rename an import that already has a different name than the export.
	                if (exportKind === 2 /* ExportEquals */ && (!isForRename || isNameMatch(importName.escapedText))) {
	                    addSearch(importName, checker.getSymbolAtLocation(importName));
	                }
	            }
	            function searchForNamedImport(namedBindings) {
	                if (!namedBindings) {
	                    return;
	                }
	                for (var _i = 0, _a = namedBindings.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    var name = element.name, propertyName = element.propertyName;
	                    if (!isNameMatch((propertyName || name).escapedText)) {
	                        continue;
	                    }
	                    if (propertyName) {
	                        // This is `import { foo as bar } from "./a"` or `export { foo as bar } from "./a"`. `foo` isn't a local in the file, so just add it as a single reference.
	                        singleReferences.push(propertyName);
	                        if (!isForRename) {
	                            // Search locally for `bar`.
	                            addSearch(name, checker.getSymbolAtLocation(name));
	                        }
	                    }
	                    else {
	                        var localSymbol = element.kind === 250 /* ExportSpecifier */ && element.propertyName
	                            ? checker.getExportSpecifierLocalTargetSymbol(element) // For re-exporting under a different name, we want to get the re-exported symbol.
	                            : checker.getSymbolAtLocation(name);
	                        addSearch(name, localSymbol);
	                    }
	                }
	            }
	            function isNameMatch(name) {
	                // Use name of "default" even in `export =` case because we may have allowSyntheticDefaultImports
	                return name === exportSymbol.escapedName || exportKind !== 0 /* Named */ && name === "default" /* Default */;
	            }
	        }
	        /** Returns 'true' is the namespace 'name' is re-exported from this module, and 'false' if it is only used locally. */
	        function findNamespaceReExports(sourceFileLike, name, checker) {
	            var namespaceImportSymbol = checker.getSymbolAtLocation(name);
	            return forEachPossibleImportOrExportStatement(sourceFileLike, function (statement) {
	                if (statement.kind !== 248 /* ExportDeclaration */)
	                    return;
	                var _a = statement, exportClause = _a.exportClause, moduleSpecifier = _a.moduleSpecifier;
	                if (moduleSpecifier || !exportClause)
	                    return;
	                for (var _i = 0, _b = exportClause.elements; _i < _b.length; _i++) {
	                    var element = _b[_i];
	                    if (checker.getExportSpecifierLocalTargetSymbol(element) === namespaceImportSymbol) {
	                        return true;
	                    }
	                }
	            });
	        }
	        function findModuleReferences(program, sourceFiles, searchModuleSymbol) {
	            var refs = [];
	            var checker = program.getTypeChecker();
	            for (var _i = 0, sourceFiles_4 = sourceFiles; _i < sourceFiles_4.length; _i++) {
	                var referencingFile = sourceFiles_4[_i];
	                var searchSourceFile = searchModuleSymbol.valueDeclaration;
	                if (searchSourceFile.kind === 272 /* SourceFile */) {
	                    for (var _a = 0, _b = referencingFile.referencedFiles; _a < _b.length; _a++) {
	                        var ref = _b[_a];
	                        if (program.getSourceFileFromReference(referencingFile, ref) === searchSourceFile) {
	                            refs.push({ kind: "reference", referencingFile: referencingFile, ref: ref });
	                        }
	                    }
	                    for (var _c = 0, _d = referencingFile.typeReferenceDirectives; _c < _d.length; _c++) {
	                        var ref = _d[_c];
	                        var referenced = program.getResolvedTypeReferenceDirectives().get(ref.fileName);
	                        if (referenced !== undefined && referenced.resolvedFileName === searchSourceFile.fileName) {
	                            refs.push({ kind: "reference", referencingFile: referencingFile, ref: ref });
	                        }
	                    }
	                }
	                forEachImport(referencingFile, function (_importDecl, moduleSpecifier) {
	                    var moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
	                    if (moduleSymbol === searchModuleSymbol) {
	                        refs.push({ kind: "import", literal: moduleSpecifier });
	                    }
	                });
	            }
	            return refs;
	        }
	        FindAllReferences.findModuleReferences = findModuleReferences;
	        /** Returns a map from a module symbol Id to all import statements that directly reference the module. */
	        function getDirectImportsMap(sourceFiles, checker, cancellationToken) {
	            var map = ts.createMap();
	            for (var _i = 0, sourceFiles_5 = sourceFiles; _i < sourceFiles_5.length; _i++) {
	                var sourceFile = sourceFiles_5[_i];
	                cancellationToken.throwIfCancellationRequested();
	                forEachImport(sourceFile, function (importDecl, moduleSpecifier) {
	                    var moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
	                    if (moduleSymbol) {
	                        var id = ts.getSymbolId(moduleSymbol).toString();
	                        var imports = map.get(id);
	                        if (!imports) {
	                            map.set(id, imports = []);
	                        }
	                        imports.push(importDecl);
	                    }
	                });
	            }
	            return map;
	        }
	        /** Iterates over all statements at the top level or in module declarations. Returns the first truthy result. */
	        function forEachPossibleImportOrExportStatement(sourceFileLike, action) {
	            return ts.forEach(sourceFileLike.kind === 272 /* SourceFile */ ? sourceFileLike.statements : sourceFileLike.body.statements, function (statement) {
	                return action(statement) || (isAmbientModuleDeclaration(statement) && ts.forEach(statement.body && statement.body.statements, action));
	            });
	        }
	        /** Calls `action` for each import, re-export, or require() in a file. */
	        function forEachImport(sourceFile, action) {
	            if (sourceFile.externalModuleIndicator || sourceFile.imports !== undefined) {
	                for (var _i = 0, _a = sourceFile.imports; _i < _a.length; _i++) {
	                    var moduleSpecifier = _a[_i];
	                    action(importerFromModuleSpecifier(moduleSpecifier), moduleSpecifier);
	                }
	            }
	            else {
	                forEachPossibleImportOrExportStatement(sourceFile, function (statement) {
	                    switch (statement.kind) {
	                        case 248 /* ExportDeclaration */:
	                        case 242 /* ImportDeclaration */: {
	                            var decl = statement;
	                            if (decl.moduleSpecifier && decl.moduleSpecifier.kind === 9 /* StringLiteral */) {
	                                action(decl, decl.moduleSpecifier);
	                            }
	                            break;
	                        }
	                        case 241 /* ImportEqualsDeclaration */: {
	                            var decl = statement;
	                            var moduleReference = decl.moduleReference;
	                            if (moduleReference.kind === 252 /* ExternalModuleReference */ &&
	                                moduleReference.expression.kind === 9 /* StringLiteral */) {
	                                action(decl, moduleReference.expression);
	                            }
	                            break;
	                        }
	                    }
	                });
	            }
	        }
	        function importerFromModuleSpecifier(moduleSpecifier) {
	            var decl = moduleSpecifier.parent;
	            switch (decl.kind) {
	                case 185 /* CallExpression */:
	                case 242 /* ImportDeclaration */:
	                case 248 /* ExportDeclaration */:
	                    return decl;
	                case 252 /* ExternalModuleReference */:
	                    return decl.parent;
	                default:
	                    ts.Debug.fail("Unexpected module specifier parent: " + decl.kind);
	            }
	        }
	        /**
	         * Given a local reference, we might notice that it's an import/export and recursively search for references of that.
	         * If at an import, look locally for the symbol it imports.
	         * If an an export, look for all imports of it.
	         * This doesn't handle export specifiers; that is done in `getReferencesAtExportSpecifier`.
	         * @param comingFromExport If we are doing a search for all exports, don't bother looking backwards for the imported symbol, since that's the reason we're here.
	         */
	        function getImportOrExportSymbol(node, symbol, checker, comingFromExport) {
	            return comingFromExport ? getExport() : getExport() || getImport();
	            function getExport() {
	                var parent = node.parent;
	                if (symbol.exportSymbol) {
	                    if (parent.kind === 183 /* PropertyAccessExpression */) {
	                        // When accessing an export of a JS module, there's no alias. The symbol will still be flagged as an export even though we're at the use.
	                        // So check that we are at the declaration.
	                        return symbol.declarations.some(function (d) { return d === parent; }) && ts.isBinaryExpression(parent.parent)
	                            ? getSpecialPropertyExport(parent.parent, /*useLhsSymbol*/ false)
	                            : undefined;
	                    }
	                    else {
	                        return exportInfo(symbol.exportSymbol, getExportKindForDeclaration(parent));
	                    }
	                }
	                else {
	                    var exportNode = getExportNode(parent, node);
	                    if (exportNode && ts.hasModifier(exportNode, 1 /* Export */)) {
	                        if (ts.isImportEqualsDeclaration(exportNode) && exportNode.moduleReference === node) {
	                            // We're at `Y` in `export import X = Y`. This is not the exported symbol, the left-hand-side is. So treat this as an import statement.
	                            if (comingFromExport) {
	                                return undefined;
	                            }
	                            var lhsSymbol = checker.getSymbolAtLocation(exportNode.name);
	                            return { kind: 0 /* Import */, symbol: lhsSymbol, isNamedImport: false };
	                        }
	                        else {
	                            return exportInfo(symbol, getExportKindForDeclaration(exportNode));
	                        }
	                    }
	                    else if (ts.isExportAssignment(parent)) {
	                        return getExportAssignmentExport(parent);
	                    }
	                    else if (ts.isExportAssignment(parent.parent)) {
	                        return getExportAssignmentExport(parent.parent);
	                    }
	                    else if (ts.isBinaryExpression(parent)) {
	                        return getSpecialPropertyExport(parent, /*useLhsSymbol*/ true);
	                    }
	                    else if (ts.isBinaryExpression(parent.parent)) {
	                        return getSpecialPropertyExport(parent.parent, /*useLhsSymbol*/ true);
	                    }
	                }
	                function getExportAssignmentExport(ex) {
	                    // Get the symbol for the `export =` node; its parent is the module it's the export of.
	                    var exportingModuleSymbol = ts.Debug.assertDefined(ex.symbol.parent, "Expected export symbol to have a parent");
	                    var exportKind = ex.isExportEquals ? 2 /* ExportEquals */ : 1 /* Default */;
	                    return { kind: 1 /* Export */, symbol: symbol, exportInfo: { exportingModuleSymbol: exportingModuleSymbol, exportKind: exportKind } };
	                }
	                function getSpecialPropertyExport(node, useLhsSymbol) {
	                    var kind;
	                    switch (ts.getSpecialPropertyAssignmentKind(node)) {
	                        case 1 /* ExportsProperty */:
	                            kind = 0 /* Named */;
	                            break;
	                        case 2 /* ModuleExports */:
	                            kind = 2 /* ExportEquals */;
	                            break;
	                        default:
	                            return undefined;
	                    }
	                    var sym = useLhsSymbol ? checker.getSymbolAtLocation(ts.cast(node.left, ts.isPropertyAccessExpression).name) : symbol;
	                    // Better detection for GH#20803
	                    if (sym && !(checker.getMergedSymbol(sym.parent).flags & 1536 /* Module */)) {
	                        ts.Debug.fail("Special property assignment kind does not have a module as its parent. Assignment is " + ts.Debug.showSymbol(sym) + ", parent is " + ts.Debug.showSymbol(sym.parent));
	                    }
	                    return sym && exportInfo(sym, kind);
	                }
	            }
	            function getImport() {
	                var isImport = isNodeImport(node);
	                if (!isImport)
	                    return undefined;
	                // A symbol being imported is always an alias. So get what that aliases to find the local symbol.
	                var importedSymbol = checker.getImmediateAliasedSymbol(symbol);
	                if (!importedSymbol)
	                    return undefined;
	                // Search on the local symbol in the exporting module, not the exported symbol.
	                importedSymbol = skipExportSpecifierSymbol(importedSymbol, checker);
	                // Similarly, skip past the symbol for 'export ='
	                if (importedSymbol.escapedName === "export=") {
	                    importedSymbol = getExportEqualsLocalSymbol(importedSymbol, checker);
	                }
	                // If the import has a different name than the export, do not continue searching.
	                // If `importedName` is undefined, do continue searching as the export is anonymous.
	                // (All imports returned from this function will be ignored anyway if we are in rename and this is a not a named export.)
	                var importedName = symbolName(importedSymbol);
	                if (importedName === undefined || importedName === "default" /* Default */ || importedName === symbol.escapedName) {
	                    return __assign({ kind: 0 /* Import */, symbol: importedSymbol }, isImport);
	                }
	            }
	            function exportInfo(symbol, kind) {
	                var exportInfo = getExportInfo(symbol, kind, checker);
	                return exportInfo && { kind: 1 /* Export */, symbol: symbol, exportInfo: exportInfo };
	            }
	            // Not meant for use with export specifiers or export assignment.
	            function getExportKindForDeclaration(node) {
	                return ts.hasModifier(node, 512 /* Default */) ? 1 /* Default */ : 0 /* Named */;
	            }
	        }
	        FindAllReferences.getImportOrExportSymbol = getImportOrExportSymbol;
	        function getExportEqualsLocalSymbol(importedSymbol, checker) {
	            if (importedSymbol.flags & 2097152 /* Alias */) {
	                return ts.Debug.assertDefined(checker.getImmediateAliasedSymbol(importedSymbol));
	            }
	            var decl = importedSymbol.valueDeclaration;
	            if (ts.isExportAssignment(decl)) {
	                return ts.Debug.assertDefined(decl.expression.symbol);
	            }
	            else if (ts.isBinaryExpression(decl)) {
	                return ts.Debug.assertDefined(decl.right.symbol);
	            }
	            return ts.Debug.fail();
	        }
	        // If a reference is a class expression, the exported node would be its parent.
	        // If a reference is a variable declaration, the exported node would be the variable statement.
	        function getExportNode(parent, node) {
	            if (parent.kind === 230 /* VariableDeclaration */) {
	                var p = parent;
	                return p.name !== node ? undefined :
	                    p.parent.kind === 267 /* CatchClause */ ? undefined : p.parent.parent.kind === 212 /* VariableStatement */ ? p.parent.parent : undefined;
	            }
	            else {
	                return parent;
	            }
	        }
	        function isNodeImport(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 241 /* ImportEqualsDeclaration */:
	                    return parent.name === node && isExternalModuleImportEquals(parent)
	                        ? { isNamedImport: false }
	                        : undefined;
	                case 246 /* ImportSpecifier */:
	                    // For a rename import `{ foo as bar }`, don't search for the imported symbol. Just find local uses of `bar`.
	                    return parent.propertyName ? undefined : { isNamedImport: true };
	                case 243 /* ImportClause */:
	                case 244 /* NamespaceImport */:
	                    ts.Debug.assert(parent.name === node);
	                    return { isNamedImport: false };
	                default:
	                    return undefined;
	            }
	        }
	        function getExportInfo(exportSymbol, exportKind, checker) {
	            var moduleSymbol = exportSymbol.parent;
	            if (!moduleSymbol)
	                return undefined; // This can happen if an `export` is not at the top-level (which is a compile error).
	            var exportingModuleSymbol = checker.getMergedSymbol(moduleSymbol); // Need to get merged symbol in case there's an augmentation.
	            // `export` may appear in a namespace. In that case, just rely on global search.
	            return ts.isExternalModuleSymbol(exportingModuleSymbol) ? { exportingModuleSymbol: exportingModuleSymbol, exportKind: exportKind } : undefined;
	        }
	        FindAllReferences.getExportInfo = getExportInfo;
	        function symbolName(symbol) {
	            if (symbol.escapedName !== "default" /* Default */) {
	                return symbol.escapedName;
	            }
	            return ts.forEach(symbol.declarations, function (decl) {
	                var name = ts.getNameOfDeclaration(decl);
	                return name && name.kind === 71 /* Identifier */ && name.escapedText;
	            });
	        }
	        /** If at an export specifier, go to the symbol it refers to. */
	        function skipExportSpecifierSymbol(symbol, checker) {
	            // For `export { foo } from './bar", there's nothing to skip, because it does not create a new alias. But `export { foo } does.
	            if (symbol.declarations) {
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    if (ts.isExportSpecifier(declaration) && !declaration.propertyName && !declaration.parent.parent.moduleSpecifier) {
	                        return checker.getExportSpecifierLocalTargetSymbol(declaration);
	                    }
	                }
	            }
	            return symbol;
	        }
	        function getContainingModuleSymbol(importer, checker) {
	            return checker.getMergedSymbol(getSourceFileLikeForImportDeclaration(importer).symbol);
	        }
	        function getSourceFileLikeForImportDeclaration(node) {
	            if (node.kind === 185 /* CallExpression */) {
	                return node.getSourceFile();
	            }
	            var parent = node.parent;
	            if (parent.kind === 272 /* SourceFile */) {
	                return parent;
	            }
	            ts.Debug.assert(parent.kind === 238 /* ModuleBlock */);
	            return ts.cast(parent.parent, isAmbientModuleDeclaration);
	        }
	        function isAmbientModuleDeclaration(node) {
	            return node.kind === 237 /* ModuleDeclaration */ && node.name.kind === 9 /* StringLiteral */;
	        }
	        function isExternalModuleImportEquals(_a) {
	            var moduleReference = _a.moduleReference;
	            return moduleReference.kind === 252 /* ExternalModuleReference */ && moduleReference.expression.kind === 9 /* StringLiteral */;
	        }
	    })(FindAllReferences = ts.FindAllReferences || (ts.FindAllReferences = {}));
	})(ts || (ts = {}));
	/// <reference path="./importTracker.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    var FindAllReferences;
	    (function (FindAllReferences) {
	        function nodeEntry(node, isInString) {
	            return { type: "node", node: node, isInString: isInString };
	        }
	        FindAllReferences.nodeEntry = nodeEntry;
	        function findReferencedSymbols(program, cancellationToken, sourceFiles, sourceFile, position) {
	            var referencedSymbols = findAllReferencedSymbols(program, cancellationToken, sourceFiles, sourceFile, position);
	            var checker = program.getTypeChecker();
	            return !referencedSymbols || !referencedSymbols.length ? undefined : ts.mapDefined(referencedSymbols, function (_a) {
	                var definition = _a.definition, references = _a.references;
	                // Only include referenced symbols that have a valid definition.
	                return definition && { definition: definitionToReferencedSymbolDefinitionInfo(definition, checker), references: references.map(toReferenceEntry) };
	            });
	        }
	        FindAllReferences.findReferencedSymbols = findReferencedSymbols;
	        function getImplementationsAtPosition(program, cancellationToken, sourceFiles, sourceFile, position) {
	            // A node in a JSDoc comment can't have an implementation anyway.
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ false);
	            var referenceEntries = getImplementationReferenceEntries(program, cancellationToken, sourceFiles, node, position);
	            var checker = program.getTypeChecker();
	            return ts.map(referenceEntries, function (entry) { return toImplementationLocation(entry, checker); });
	        }
	        FindAllReferences.getImplementationsAtPosition = getImplementationsAtPosition;
	        function getImplementationReferenceEntries(program, cancellationToken, sourceFiles, node, position) {
	            if (node.kind === 272 /* SourceFile */) {
	                return undefined;
	            }
	            var checker = program.getTypeChecker();
	            // If invoked directly on a shorthand property assignment, then return
	            // the declaration of the symbol being assigned (not the symbol being assigned to).
	            if (node.parent.kind === 269 /* ShorthandPropertyAssignment */) {
	                var result_4 = [];
	                FindAllReferences.Core.getReferenceEntriesForShorthandPropertyAssignment(node, checker, function (node) { return result_4.push(nodeEntry(node)); });
	                return result_4;
	            }
	            else if (node.kind === 97 /* SuperKeyword */ || ts.isSuperProperty(node.parent)) {
	                // References to and accesses on the super keyword only have one possible implementation, so no
	                // need to "Find all References"
	                var symbol = checker.getSymbolAtLocation(node);
	                return symbol.valueDeclaration && [nodeEntry(symbol.valueDeclaration)];
	            }
	            else {
	                // Perform "Find all References" and retrieve only those that are implementations
	                return getReferenceEntriesForNode(position, node, program, sourceFiles, cancellationToken, { implementations: true });
	            }
	        }
	        function findReferencedEntries(program, cancellationToken, sourceFiles, sourceFile, position, options) {
	            var x = flattenEntries(findAllReferencedSymbols(program, cancellationToken, sourceFiles, sourceFile, position, options));
	            return ts.map(x, toReferenceEntry);
	        }
	        FindAllReferences.findReferencedEntries = findReferencedEntries;
	        function getReferenceEntriesForNode(position, node, program, sourceFiles, cancellationToken, options) {
	            if (options === void 0) { options = {}; }
	            return flattenEntries(FindAllReferences.Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options));
	        }
	        FindAllReferences.getReferenceEntriesForNode = getReferenceEntriesForNode;
	        function findAllReferencedSymbols(program, cancellationToken, sourceFiles, sourceFile, position, options) {
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            return FindAllReferences.Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options);
	        }
	        function flattenEntries(referenceSymbols) {
	            return referenceSymbols && ts.flatMap(referenceSymbols, function (r) { return r.references; });
	        }
	        function definitionToReferencedSymbolDefinitionInfo(def, checker) {
	            var info = (function () {
	                switch (def.type) {
	                    case "symbol": {
	                        var symbol = def.symbol, node_3 = def.node;
	                        var _a = getDefinitionKindAndDisplayParts(symbol, node_3, checker), displayParts_1 = _a.displayParts, kind_1 = _a.kind;
	                        var name_4 = displayParts_1.map(function (p) { return p.text; }).join("");
	                        return { node: node_3, name: name_4, kind: kind_1, displayParts: displayParts_1 };
	                    }
	                    case "label": {
	                        var node_4 = def.node;
	                        return { node: node_4, name: node_4.text, kind: "label" /* label */, displayParts: [ts.displayPart(node_4.text, ts.SymbolDisplayPartKind.text)] };
	                    }
	                    case "keyword": {
	                        var node_5 = def.node;
	                        var name_5 = ts.tokenToString(node_5.kind);
	                        return { node: node_5, name: name_5, kind: "keyword" /* keyword */, displayParts: [{ text: name_5, kind: "keyword" /* keyword */ }] };
	                    }
	                    case "this": {
	                        var node_6 = def.node;
	                        var symbol = checker.getSymbolAtLocation(node_6);
	                        var displayParts_2 = symbol && ts.SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, node_6.getSourceFile(), ts.getContainerNode(node_6), node_6).displayParts;
	                        return { node: node_6, name: "this", kind: "var" /* variableElement */, displayParts: displayParts_2 };
	                    }
	                    case "string": {
	                        var node_7 = def.node;
	                        return { node: node_7, name: node_7.text, kind: "var" /* variableElement */, displayParts: [ts.displayPart(ts.getTextOfNode(node_7), ts.SymbolDisplayPartKind.stringLiteral)] };
	                    }
	                }
	            })();
	            if (!info) {
	                return undefined;
	            }
	            var node = info.node, name = info.name, kind = info.kind, displayParts = info.displayParts;
	            var sourceFile = node.getSourceFile();
	            return {
	                containerKind: "" /* unknown */,
	                containerName: "",
	                fileName: sourceFile.fileName,
	                kind: kind,
	                name: name,
	                textSpan: ts.createTextSpanFromNode(node, sourceFile),
	                displayParts: displayParts
	            };
	        }
	        function getDefinitionKindAndDisplayParts(symbol, node, checker) {
	            var _a = ts.SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, node.getSourceFile(), ts.getContainerNode(node), node), displayParts = _a.displayParts, symbolKind = _a.symbolKind;
	            return { displayParts: displayParts, kind: symbolKind };
	        }
	        function toReferenceEntry(entry) {
	            if (entry.type === "span") {
	                return { textSpan: entry.textSpan, fileName: entry.fileName, isWriteAccess: false, isDefinition: false };
	            }
	            var node = entry.node, isInString = entry.isInString;
	            return {
	                fileName: node.getSourceFile().fileName,
	                textSpan: getTextSpan(node),
	                isWriteAccess: isWriteAccessForReference(node),
	                isDefinition: node.kind === 79 /* DefaultKeyword */
	                    || ts.isAnyDeclarationName(node)
	                    || ts.isLiteralComputedPropertyDeclarationName(node),
	                isInString: isInString
	            };
	        }
	        function toImplementationLocation(entry, checker) {
	            if (entry.type === "node") {
	                var node = entry.node;
	                return __assign({ textSpan: getTextSpan(node), fileName: node.getSourceFile().fileName }, implementationKindDisplayParts(node, checker));
	            }
	            else {
	                var textSpan = entry.textSpan, fileName = entry.fileName;
	                return { textSpan: textSpan, fileName: fileName, kind: "" /* unknown */, displayParts: [] };
	            }
	        }
	        function implementationKindDisplayParts(node, checker) {
	            var symbol = checker.getSymbolAtLocation(ts.isDeclaration(node) && node.name ? node.name : node);
	            if (symbol) {
	                return getDefinitionKindAndDisplayParts(symbol, node, checker);
	            }
	            else if (node.kind === 182 /* ObjectLiteralExpression */) {
	                return {
	                    kind: "interface" /* interfaceElement */,
	                    displayParts: [ts.punctuationPart(19 /* OpenParenToken */), ts.textPart("object literal"), ts.punctuationPart(20 /* CloseParenToken */)]
	                };
	            }
	            else if (node.kind === 203 /* ClassExpression */) {
	                return {
	                    kind: "local class" /* localClassElement */,
	                    displayParts: [ts.punctuationPart(19 /* OpenParenToken */), ts.textPart("anonymous local class"), ts.punctuationPart(20 /* CloseParenToken */)]
	                };
	            }
	            else {
	                return { kind: ts.getNodeKind(node), displayParts: [] };
	            }
	        }
	        function toHighlightSpan(entry) {
	            if (entry.type === "span") {
	                var fileName_1 = entry.fileName, textSpan = entry.textSpan;
	                return { fileName: fileName_1, span: { textSpan: textSpan, kind: "reference" /* reference */ } };
	            }
	            var node = entry.node, isInString = entry.isInString;
	            var fileName = entry.node.getSourceFile().fileName;
	            var writeAccess = isWriteAccessForReference(node);
	            var span = {
	                textSpan: getTextSpan(node),
	                kind: writeAccess ? "writtenReference" /* writtenReference */ : "reference" /* reference */,
	                isInString: isInString
	            };
	            return { fileName: fileName, span: span };
	        }
	        FindAllReferences.toHighlightSpan = toHighlightSpan;
	        function getTextSpan(node) {
	            var start = node.getStart();
	            var end = node.getEnd();
	            if (node.kind === 9 /* StringLiteral */) {
	                start += 1;
	                end -= 1;
	            }
	            return ts.createTextSpanFromBounds(start, end);
	        }
	        /** A node is considered a writeAccess iff it is a name of a declaration or a target of an assignment */
	        function isWriteAccessForReference(node) {
	            return node.kind === 79 /* DefaultKeyword */ || ts.isAnyDeclarationName(node) || ts.isWriteAccess(node);
	        }
	    })(FindAllReferences = ts.FindAllReferences || (ts.FindAllReferences = {}));
	})(ts || (ts = {}));
	/** Encapsulates the core find-all-references algorithm. */
	/* @internal */
	(function (ts) {
	    var FindAllReferences;
	    (function (FindAllReferences) {
	        var Core;
	        (function (Core) {
	            /** Core find-all-references algorithm. Handles special cases before delegating to `getReferencedSymbolsForSymbol`. */
	            function getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options) {
	                if (options === void 0) { options = {}; }
	                if (ts.isSourceFile(node)) {
	                    var reference = ts.GoToDefinition.getReferenceAtPosition(node, position, program);
	                    return reference && getReferencedSymbolsForModule(program, program.getTypeChecker().getMergedSymbol(reference.file.symbol), sourceFiles);
	                }
	                if (!options.implementations) {
	                    var special = getReferencedSymbolsSpecial(node, sourceFiles, cancellationToken);
	                    if (special) {
	                        return special;
	                    }
	                }
	                var checker = program.getTypeChecker();
	                var symbol = checker.getSymbolAtLocation(node);
	                // Could not find a symbol e.g. unknown identifier
	                if (!symbol) {
	                    // String literal might be a property (and thus have a symbol), so do this here rather than in getReferencedSymbolsSpecial.
	                    return !options.implementations && ts.isStringLiteral(node) ? getReferencesForStringLiteral(node, sourceFiles, cancellationToken) : undefined;
	                }
	                if (symbol.flags & 1536 /* Module */ && isModuleReferenceLocation(node)) {
	                    return getReferencedSymbolsForModule(program, symbol, sourceFiles);
	                }
	                return getReferencedSymbolsForSymbol(symbol, node, sourceFiles, checker, cancellationToken, options);
	            }
	            Core.getReferencedSymbolsForNode = getReferencedSymbolsForNode;
	            function isModuleReferenceLocation(node) {
	                if (!ts.isStringLiteralLike(node)) {
	                    return false;
	                }
	                switch (node.parent.kind) {
	                    case 237 /* ModuleDeclaration */:
	                    case 252 /* ExternalModuleReference */:
	                    case 242 /* ImportDeclaration */:
	                    case 248 /* ExportDeclaration */:
	                        return true;
	                    case 185 /* CallExpression */:
	                        return ts.isRequireCall(node.parent, /*checkArgumentIsStringLiteral*/ false) || ts.isImportCall(node.parent);
	                    default:
	                        return false;
	                }
	            }
	            function getReferencedSymbolsForModule(program, symbol, sourceFiles) {
	                ts.Debug.assert(!!symbol.valueDeclaration);
	                var references = FindAllReferences.findModuleReferences(program, sourceFiles, symbol).map(function (reference) {
	                    if (reference.kind === "import") {
	                        return { type: "node", node: reference.literal };
	                    }
	                    else {
	                        return {
	                            type: "span",
	                            fileName: reference.referencingFile.fileName,
	                            textSpan: ts.createTextSpanFromRange(reference.ref),
	                        };
	                    }
	                });
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    switch (decl.kind) {
	                        case 272 /* SourceFile */:
	                            // Don't include the source file itself. (This may not be ideal behavior, but awkward to include an entire file as a reference.)
	                            break;
	                        case 237 /* ModuleDeclaration */:
	                            references.push({ type: "node", node: decl.name });
	                            break;
	                        default:
	                            ts.Debug.fail("Expected a module symbol to be declared by a SourceFile or ModuleDeclaration.");
	                    }
	                }
	                return [{
	                        definition: { type: "symbol", symbol: symbol, node: symbol.valueDeclaration },
	                        references: references
	                    }];
	            }
	            /** getReferencedSymbols for special node kinds. */
	            function getReferencedSymbolsSpecial(node, sourceFiles, cancellationToken) {
	                if (ts.isTypeKeyword(node.kind)) {
	                    return getAllReferencesForKeyword(sourceFiles, node.kind, cancellationToken);
	                }
	                // Labels
	                if (ts.isJumpStatementTarget(node)) {
	                    var labelDefinition = ts.getTargetLabel(node.parent, node.text);
	                    // if we have a label definition, look within its statement for references, if not, then
	                    // the label is undefined and we have no results..
	                    return labelDefinition && getLabelReferencesInNode(labelDefinition.parent, labelDefinition);
	                }
	                else if (ts.isLabelOfLabeledStatement(node)) {
	                    // it is a label definition and not a target, search within the parent labeledStatement
	                    return getLabelReferencesInNode(node.parent, node);
	                }
	                if (ts.isThis(node)) {
	                    return getReferencesForThisKeyword(node, sourceFiles, cancellationToken);
	                }
	                if (node.kind === 97 /* SuperKeyword */) {
	                    return getReferencesForSuperKeyword(node);
	                }
	                return undefined;
	            }
	            /** Core find-all-references algorithm for a normal symbol. */
	            function getReferencedSymbolsForSymbol(symbol, node, sourceFiles, checker, cancellationToken, options) {
	                symbol = skipPastExportOrImportSpecifierOrUnion(symbol, node, checker) || symbol;
	                // Compute the meaning from the location and the symbol it references
	                var searchMeaning = getIntersectingMeaningFromDeclarations(ts.getMeaningFromLocation(node), symbol.declarations);
	                var result = [];
	                var state = new State(sourceFiles, getSpecialSearchKind(node), checker, cancellationToken, searchMeaning, options, result);
	                if (node.kind === 79 /* DefaultKeyword */) {
	                    addReference(node, symbol, node, state);
	                    searchForImportsOfExport(node, symbol, { exportingModuleSymbol: ts.Debug.assertDefined(symbol.parent, "Expected export symbol to have a parent"), exportKind: 1 /* Default */ }, state);
	                }
	                else {
	                    var search = state.createSearch(node, symbol, /*comingFrom*/ undefined, { allSearchSymbols: populateSearchSymbolSet(symbol, node, checker, options.implementations) });
	                    // Try to get the smallest valid scope that we can limit our search to;
	                    // otherwise we'll need to search globally (i.e. include each file).
	                    var scope = getSymbolScope(symbol);
	                    if (scope) {
	                        getReferencesInContainer(scope, scope.getSourceFile(), search, state);
	                    }
	                    else {
	                        // Global search
	                        for (var _i = 0, _a = state.sourceFiles; _i < _a.length; _i++) {
	                            var sourceFile = _a[_i];
	                            state.cancellationToken.throwIfCancellationRequested();
	                            searchForName(sourceFile, search, state);
	                        }
	                    }
	                }
	                return result;
	            }
	            function getSpecialSearchKind(node) {
	                switch (node.kind) {
	                    case 123 /* ConstructorKeyword */:
	                        return 1 /* Constructor */;
	                    case 71 /* Identifier */:
	                        if (ts.isClassLike(node.parent)) {
	                            ts.Debug.assert(node.parent.name === node);
	                            return 2 /* Class */;
	                        }
	                    // falls through
	                    default:
	                        return 0 /* None */;
	                }
	            }
	            /** Handle a few special cases relating to export/import specifiers. */
	            function skipPastExportOrImportSpecifierOrUnion(symbol, node, checker) {
	                var parent = node.parent;
	                if (ts.isExportSpecifier(parent)) {
	                    return getLocalSymbolForExportSpecifier(node, symbol, parent, checker);
	                }
	                if (ts.isImportSpecifier(parent) && parent.propertyName === node) {
	                    // We're at `foo` in `import { foo as bar }`. Probably intended to find all refs on the original, not just on the import.
	                    return checker.getImmediateAliasedSymbol(symbol);
	                }
	                // If the symbol is declared as part of a declaration like `{ type: "a" } | { type: "b" }`, use the property on the union type to get more references.
	                return ts.firstDefined(symbol.declarations, function (decl) {
	                    if (!decl.parent) {
	                        // Assertions for GH#21814. We should be handling SourceFile symbols in `getReferencedSymbolsForModule` instead of getting here.
	                        ts.Debug.assert(decl.kind === 272 /* SourceFile */);
	                        ts.Debug.fail("Unexpected symbol at " + ts.Debug.showSyntaxKind(node) + ": " + ts.Debug.showSymbol(symbol));
	                    }
	                    return ts.isTypeLiteralNode(decl.parent) && ts.isUnionTypeNode(decl.parent.parent)
	                        ? checker.getPropertyOfType(checker.getTypeFromTypeNode(decl.parent.parent), symbol.name)
	                        : undefined;
	                });
	            }
	            var SpecialSearchKind;
	            (function (SpecialSearchKind) {
	                SpecialSearchKind[SpecialSearchKind["None"] = 0] = "None";
	                SpecialSearchKind[SpecialSearchKind["Constructor"] = 1] = "Constructor";
	                SpecialSearchKind[SpecialSearchKind["Class"] = 2] = "Class";
	            })(SpecialSearchKind || (SpecialSearchKind = {}));
	            /**
	             * Holds all state needed for the finding references.
	             * Unlike `Search`, there is only one `State`.
	             */
	            var State = /** @class */ (function () {
	                function State(sourceFiles, 
	                /** True if we're searching for constructor references. */
	                specialSearchKind, checker, cancellationToken, searchMeaning, options, result) {
	                    this.sourceFiles = sourceFiles;
	                    this.specialSearchKind = specialSearchKind;
	                    this.checker = checker;
	                    this.cancellationToken = cancellationToken;
	                    this.searchMeaning = searchMeaning;
	                    this.options = options;
	                    this.result = result;
	                    /** Cache for `explicitlyinheritsFrom`. */
	                    this.inheritsFromCache = ts.createMap();
	                    /**
	                     * Type nodes can contain multiple references to the same type. For example:
	                     *      let x: Foo & (Foo & Bar) = ...
	                     * Because we are returning the implementation locations and not the identifier locations,
	                     * duplicate entries would be returned here as each of the type references is part of
	                     * the same implementation. For that reason, check before we add a new entry.
	                     */
	                    this.markSeenContainingTypeReference = ts.nodeSeenTracker();
	                    /**
	                     * It's possible that we will encounter the right side of `export { foo as bar } from "x";` more than once.
	                     * For example:
	                     *     // b.ts
	                     *     export { foo as bar } from "./a";
	                     *     import { bar } from "./b";
	                     *
	                     * Normally at `foo as bar` we directly add `foo` and do not locally search for it (since it doesn't declare a local).
	                     * But another reference to it may appear in the same source file.
	                     * See `tests/cases/fourslash/transitiveExportImports3.ts`.
	                     */
	                    this.markSeenReExportRHS = ts.nodeSeenTracker();
	                    this.symbolIdToReferences = [];
	                    // Source file ID → symbol ID → Whether the symbol has been searched for in the source file.
	                    this.sourceFileToSeenSymbols = [];
	                }
	                /** Gets every place to look for references of an exported symbols. See `ImportsResult` in `importTracker.ts` for more documentation. */
	                State.prototype.getImportSearches = function (exportSymbol, exportInfo) {
	                    if (!this.importTracker)
	                        this.importTracker = FindAllReferences.createImportTracker(this.sourceFiles, this.checker, this.cancellationToken);
	                    return this.importTracker(exportSymbol, exportInfo, this.options.isForRename);
	                };
	                /** @param allSearchSymbols set of additinal symbols for use by `includes`. */
	                State.prototype.createSearch = function (location, symbol, comingFrom, searchOptions) {
	                    if (searchOptions === void 0) { searchOptions = {}; }
	                    // Note: if this is an external module symbol, the name doesn't include quotes.
	                    // Note: getLocalSymbolForExportDefault handles `export default class C {}`, but not `export default C` or `export { C as default }`.
	                    // The other two forms seem to be handled downstream (e.g. in `skipPastExportOrImportSpecifier`), so special-casing the first form
	                    // here appears to be intentional).
	                    var _a = searchOptions.text, text = _a === void 0 ? ts.stripQuotes(ts.unescapeLeadingUnderscores((ts.getLocalSymbolForExportDefault(symbol) || symbol).escapedName)) : _a, _b = searchOptions.allSearchSymbols, allSearchSymbols = _b === void 0 ? undefined : _b;
	                    var escapedText = ts.escapeLeadingUnderscores(text);
	                    var parents = this.options.implementations && getParentSymbolsOfPropertyAccess(location, symbol, this.checker);
	                    return {
	                        location: location, symbol: symbol, comingFrom: comingFrom, text: text, escapedText: escapedText, parents: parents,
	                        includes: function (referenceSymbol) { return allSearchSymbols ? ts.contains(allSearchSymbols, referenceSymbol) : referenceSymbol === symbol; },
	                    };
	                };
	                /**
	                 * Callback to add references for a particular searched symbol.
	                 * This initializes a reference group, so only call this if you will add at least one reference.
	                 */
	                State.prototype.referenceAdder = function (searchSymbol, searchLocation) {
	                    var symbolId = ts.getSymbolId(searchSymbol);
	                    var references = this.symbolIdToReferences[symbolId];
	                    if (!references) {
	                        references = this.symbolIdToReferences[symbolId] = [];
	                        this.result.push({ definition: { type: "symbol", symbol: searchSymbol, node: searchLocation }, references: references });
	                    }
	                    return function (node) { return references.push(FindAllReferences.nodeEntry(node)); };
	                };
	                /** Add a reference with no associated definition. */
	                State.prototype.addStringOrCommentReference = function (fileName, textSpan) {
	                    this.result.push({
	                        definition: undefined,
	                        references: [{ type: "span", fileName: fileName, textSpan: textSpan }]
	                    });
	                };
	                /** Returns `true` the first time we search for a symbol in a file and `false` afterwards. */
	                State.prototype.markSearchedSymbol = function (sourceFile, symbol) {
	                    var sourceId = ts.getNodeId(sourceFile);
	                    var symbolId = ts.getSymbolId(symbol);
	                    var seenSymbols = this.sourceFileToSeenSymbols[sourceId] || (this.sourceFileToSeenSymbols[sourceId] = []);
	                    return !seenSymbols[symbolId] && (seenSymbols[symbolId] = true);
	                };
	                return State;
	            }());
	            /** Search for all imports of a given exported symbol using `State.getImportSearches`. */
	            function searchForImportsOfExport(exportLocation, exportSymbol, exportInfo, state) {
	                var _a = state.getImportSearches(exportSymbol, exportInfo), importSearches = _a.importSearches, singleReferences = _a.singleReferences, indirectUsers = _a.indirectUsers;
	                // For `import { foo as bar }` just add the reference to `foo`, and don't otherwise search in the file.
	                if (singleReferences.length) {
	                    var addRef = state.referenceAdder(exportSymbol, exportLocation);
	                    for (var _i = 0, singleReferences_1 = singleReferences; _i < singleReferences_1.length; _i++) {
	                        var singleRef = singleReferences_1[_i];
	                        addRef(singleRef);
	                    }
	                }
	                // For each import, find all references to that import in its source file.
	                for (var _b = 0, importSearches_1 = importSearches; _b < importSearches_1.length; _b++) {
	                    var _c = importSearches_1[_b], importLocation = _c[0], importSymbol = _c[1];
	                    getReferencesInSourceFile(importLocation.getSourceFile(), state.createSearch(importLocation, importSymbol, 1 /* Export */), state);
	                }
	                if (indirectUsers.length) {
	                    var indirectSearch = void 0;
	                    switch (exportInfo.exportKind) {
	                        case 0 /* Named */:
	                            indirectSearch = state.createSearch(exportLocation, exportSymbol, 1 /* Export */);
	                            break;
	                        case 1 /* Default */:
	                            // Search for a property access to '.default'. This can't be renamed.
	                            indirectSearch = state.options.isForRename ? undefined : state.createSearch(exportLocation, exportSymbol, 1 /* Export */, { text: "default" });
	                            break;
	                        case 2 /* ExportEquals */:
	                            break;
	                    }
	                    if (indirectSearch) {
	                        for (var _d = 0, indirectUsers_1 = indirectUsers; _d < indirectUsers_1.length; _d++) {
	                            var indirectUser = indirectUsers_1[_d];
	                            searchForName(indirectUser, indirectSearch, state);
	                        }
	                    }
	                }
	            }
	            // Go to the symbol we imported from and find references for it.
	            function searchForImportedSymbol(symbol, state) {
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    getReferencesInSourceFile(declaration.getSourceFile(), state.createSearch(declaration, symbol, 0 /* Import */), state);
	                }
	            }
	            /** Search for all occurences of an identifier in a source file (and filter out the ones that match). */
	            function searchForName(sourceFile, search, state) {
	                if (ts.getNameTable(sourceFile).get(search.escapedText) !== undefined) {
	                    getReferencesInSourceFile(sourceFile, search, state);
	                }
	            }
	            function getPropertySymbolOfDestructuringAssignment(location, checker) {
	                return ts.isArrayLiteralOrObjectLiteralDestructuringPattern(location.parent.parent) &&
	                    checker.getPropertySymbolOfDestructuringAssignment(location);
	            }
	            function getObjectBindingElementWithoutPropertyName(symbol) {
	                var bindingElement = ts.getDeclarationOfKind(symbol, 180 /* BindingElement */);
	                if (bindingElement &&
	                    bindingElement.parent.kind === 178 /* ObjectBindingPattern */ &&
	                    !bindingElement.propertyName) {
	                    return bindingElement;
	                }
	            }
	            function getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol, checker) {
	                var bindingElement = getObjectBindingElementWithoutPropertyName(symbol);
	                if (!bindingElement)
	                    return undefined;
	                var typeOfPattern = checker.getTypeAtLocation(bindingElement.parent);
	                var propSymbol = typeOfPattern && checker.getPropertyOfType(typeOfPattern, bindingElement.name.text);
	                if (propSymbol && propSymbol.flags & 98304 /* Accessor */) {
	                    // See GH#16922
	                    ts.Debug.assert(!!(propSymbol.flags & 33554432 /* Transient */));
	                    return propSymbol.target;
	                }
	                return propSymbol;
	            }
	            /**
	             * Determines the smallest scope in which a symbol may have named references.
	             * Note that not every construct has been accounted for. This function can
	             * probably be improved.
	             *
	             * @returns undefined if the scope cannot be determined, implying that
	             * a reference to a symbol can occur anywhere.
	             */
	            function getSymbolScope(symbol) {
	                // If this is the symbol of a named function expression or named class expression,
	                // then named references are limited to its own scope.
	                var declarations = symbol.declarations, flags = symbol.flags, parent = symbol.parent, valueDeclaration = symbol.valueDeclaration;
	                if (valueDeclaration && (valueDeclaration.kind === 190 /* FunctionExpression */ || valueDeclaration.kind === 203 /* ClassExpression */)) {
	                    return valueDeclaration;
	                }
	                if (!declarations) {
	                    return undefined;
	                }
	                // If this is private property or method, the scope is the containing class
	                if (flags & (4 /* Property */ | 8192 /* Method */)) {
	                    var privateDeclaration = ts.find(declarations, function (d) { return ts.hasModifier(d, 8 /* Private */); });
	                    if (privateDeclaration) {
	                        return ts.getAncestor(privateDeclaration, 233 /* ClassDeclaration */);
	                    }
	                    // Else this is a public property and could be accessed from anywhere.
	                    return undefined;
	                }
	                // If symbol is of object binding pattern element without property name we would want to
	                // look for property too and that could be anywhere
	                if (getObjectBindingElementWithoutPropertyName(symbol)) {
	                    return undefined;
	                }
	                /*
	                If the symbol has a parent, it's globally visible unless:
	                - It's a private property (handled above).
	                - It's a type parameter.
	                - The parent is an external module: then we should only search in the module (and recurse on the export later).
	                  - But if the parent has `export as namespace`, the symbol is globally visible through that namespace.
	                */
	                var exposedByParent = parent && !(symbol.flags & 262144 /* TypeParameter */);
	                if (exposedByParent && !((parent.flags & 1536 /* Module */) && ts.isExternalModuleSymbol(parent) && !parent.globalExports)) {
	                    return undefined;
	                }
	                var scope;
	                for (var _i = 0, declarations_9 = declarations; _i < declarations_9.length; _i++) {
	                    var declaration = declarations_9[_i];
	                    var container = ts.getContainerNode(declaration);
	                    if (scope && scope !== container) {
	                        // Different declarations have different containers, bail out
	                        return undefined;
	                    }
	                    if (!container || container.kind === 272 /* SourceFile */ && !ts.isExternalOrCommonJsModule(container)) {
	                        // This is a global variable and not an external module, any declaration defined
	                        // within this scope is visible outside the file
	                        return undefined;
	                    }
	                    // The search scope is the container node
	                    scope = container;
	                }
	                // If symbol.parent, this means we are in an export of an external module. (Otherwise we would have returned `undefined` above.)
	                // For an export of a module, we may be in a declaration file, and it may be accessed elsewhere. E.g.:
	                //     declare module "a" { export type T = number; }
	                //     declare module "b" { import { T } from "a"; export const x: T; }
	                // So we must search the whole source file. (Because we will mark the source file as seen, we we won't return to it when searching for imports.)
	                return exposedByParent ? scope.getSourceFile() : scope;
	            }
	            /** Used as a quick check for whether a symbol is used at all in a file (besides its definition). */
	            function isSymbolReferencedInFile(definition, checker, sourceFile) {
	                var symbol = checker.getSymbolAtLocation(definition);
	                if (!symbol)
	                    return true; // Be lenient with invalid code.
	                return getPossibleSymbolReferencePositions(sourceFile, symbol.name).some(function (position) {
	                    var token = ts.tryCast(ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true), ts.isIdentifier);
	                    return token && token !== definition && token.escapedText === definition.escapedText && checker.getSymbolAtLocation(token) === symbol;
	                });
	            }
	            Core.isSymbolReferencedInFile = isSymbolReferencedInFile;
	            function getPossibleSymbolReferencePositions(sourceFile, symbolName, container) {
	                if (container === void 0) { container = sourceFile; }
	                var positions = [];
	                /// TODO: Cache symbol existence for files to save text search
	                // Also, need to make this work for unicode escapes.
	                // Be resilient in the face of a symbol with no name or zero length name
	                if (!symbolName || !symbolName.length) {
	                    return positions;
	                }
	                var text = sourceFile.text;
	                var sourceLength = text.length;
	                var symbolNameLength = symbolName.length;
	                var position = text.indexOf(symbolName, container.pos);
	                while (position >= 0) {
	                    // If we are past the end, stop looking
	                    if (position > container.end)
	                        break;
	                    // We found a match.  Make sure it's not part of a larger word (i.e. the char
	                    // before and after it have to be a non-identifier char).
	                    var endPosition = position + symbolNameLength;
	                    if ((position === 0 || !ts.isIdentifierPart(text.charCodeAt(position - 1), 6 /* Latest */)) &&
	                        (endPosition === sourceLength || !ts.isIdentifierPart(text.charCodeAt(endPosition), 6 /* Latest */))) {
	                        // Found a real match.  Keep searching.
	                        positions.push(position);
	                    }
	                    position = text.indexOf(symbolName, position + symbolNameLength + 1);
	                }
	                return positions;
	            }
	            function getLabelReferencesInNode(container, targetLabel) {
	                var sourceFile = container.getSourceFile();
	                var labelName = targetLabel.text;
	                var references = ts.mapDefined(getPossibleSymbolReferencePositions(sourceFile, labelName, container), function (position) {
	                    var node = ts.getTouchingWord(sourceFile, position, /*includeJsDocComment*/ false);
	                    // Only pick labels that are either the target label, or have a target that is the target label
	                    return node && (node === targetLabel || (ts.isJumpStatementTarget(node) && ts.getTargetLabel(node, labelName) === targetLabel)) ? FindAllReferences.nodeEntry(node) : undefined;
	                });
	                return [{ definition: { type: "label", node: targetLabel }, references: references }];
	            }
	            function isValidReferencePosition(node, searchSymbolName) {
	                // Compare the length so we filter out strict superstrings of the symbol we are looking for
	                switch (node.kind) {
	                    case 71 /* Identifier */:
	                        return node.text.length === searchSymbolName.length;
	                    case 9 /* StringLiteral */:
	                        return (ts.isLiteralNameOfPropertyDeclarationOrIndexAccess(node) || isNameOfExternalModuleImportOrDeclaration(node)) &&
	                            node.text.length === searchSymbolName.length;
	                    case 8 /* NumericLiteral */:
	                        return ts.isLiteralNameOfPropertyDeclarationOrIndexAccess(node) && node.text.length === searchSymbolName.length;
	                    case 79 /* DefaultKeyword */:
	                        return "default".length === searchSymbolName.length;
	                    default:
	                        return false;
	                }
	            }
	            function getAllReferencesForKeyword(sourceFiles, keywordKind, cancellationToken) {
	                var references = ts.flatMap(sourceFiles, function (sourceFile) {
	                    cancellationToken.throwIfCancellationRequested();
	                    return ts.mapDefined(getPossibleSymbolReferencePositions(sourceFile, ts.tokenToString(keywordKind), sourceFile), function (position) {
	                        var referenceLocation = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	                        return referenceLocation.kind === keywordKind ? FindAllReferences.nodeEntry(referenceLocation) : undefined;
	                    });
	                });
	                return references.length ? [{ definition: { type: "keyword", node: references[0].node }, references: references }] : undefined;
	            }
	            function getReferencesInSourceFile(sourceFile, search, state) {
	                state.cancellationToken.throwIfCancellationRequested();
	                return getReferencesInContainer(sourceFile, sourceFile, search, state);
	            }
	            /**
	             * Search within node "container" for references for a search value, where the search value is defined as a
	             * tuple of(searchSymbol, searchText, searchLocation, and searchMeaning).
	             * searchLocation: a node where the search value
	             */
	            function getReferencesInContainer(container, sourceFile, search, state) {
	                if (!state.markSearchedSymbol(sourceFile, search.symbol)) {
	                    return;
	                }
	                for (var _i = 0, _a = getPossibleSymbolReferencePositions(sourceFile, search.text, container); _i < _a.length; _i++) {
	                    var position = _a[_i];
	                    getReferencesAtLocation(sourceFile, position, search, state);
	                }
	            }
	            function getReferencesAtLocation(sourceFile, position, search, state) {
	                var referenceLocation = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	                if (!isValidReferencePosition(referenceLocation, search.text)) {
	                    // This wasn't the start of a token.  Check to see if it might be a
	                    // match in a comment or string if that's what the caller is asking
	                    // for.
	                    if (!state.options.implementations && (state.options.findInStrings && ts.isInString(sourceFile, position) || state.options.findInComments && ts.isInNonReferenceComment(sourceFile, position))) {
	                        // In the case where we're looking inside comments/strings, we don't have
	                        // an actual definition.  So just use 'undefined' here.  Features like
	                        // 'Rename' won't care (as they ignore the definitions), and features like
	                        // 'FindReferences' will just filter out these results.
	                        state.addStringOrCommentReference(sourceFile.fileName, ts.createTextSpan(position, search.text.length));
	                    }
	                    return;
	                }
	                if (!(ts.getMeaningFromLocation(referenceLocation) & state.searchMeaning)) {
	                    return;
	                }
	                var referenceSymbol = state.checker.getSymbolAtLocation(referenceLocation);
	                if (!referenceSymbol) {
	                    return;
	                }
	                var parent = referenceLocation.parent;
	                if (ts.isImportSpecifier(parent) && parent.propertyName === referenceLocation) {
	                    // This is added through `singleReferences` in ImportsResult. If we happen to see it again, don't add it again.
	                    return;
	                }
	                if (ts.isExportSpecifier(parent)) {
	                    ts.Debug.assert(referenceLocation.kind === 71 /* Identifier */);
	                    getReferencesAtExportSpecifier(referenceLocation, referenceSymbol, parent, search, state);
	                    return;
	                }
	                var relatedSymbol = getRelatedSymbol(search, referenceSymbol, referenceLocation, state);
	                if (!relatedSymbol) {
	                    getReferenceForShorthandProperty(referenceSymbol, search, state);
	                    return;
	                }
	                switch (state.specialSearchKind) {
	                    case 0 /* None */:
	                        addReference(referenceLocation, relatedSymbol, search.location, state);
	                        break;
	                    case 1 /* Constructor */:
	                        addConstructorReferences(referenceLocation, sourceFile, search, state);
	                        break;
	                    case 2 /* Class */:
	                        addClassStaticThisReferences(referenceLocation, search, state);
	                        break;
	                    default:
	                        ts.Debug.assertNever(state.specialSearchKind);
	                }
	                getImportOrExportReferences(referenceLocation, referenceSymbol, search, state);
	            }
	            function getReferencesAtExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, search, state) {
	                var parent = exportSpecifier.parent, propertyName = exportSpecifier.propertyName, name = exportSpecifier.name;
	                var exportDeclaration = parent.parent;
	                var localSymbol = getLocalSymbolForExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, state.checker);
	                if (!search.includes(localSymbol)) {
	                    return;
	                }
	                if (!propertyName) {
	                    addRef();
	                }
	                else if (referenceLocation === propertyName) {
	                    // For `export { foo as bar } from "baz"`, "`foo`" will be added from the singleReferences for import searches of the original export.
	                    // For `export { foo as bar };`, where `foo` is a local, so add it now.
	                    if (!exportDeclaration.moduleSpecifier) {
	                        addRef();
	                    }
	                    if (!state.options.isForRename && state.markSeenReExportRHS(name)) {
	                        addReference(name, referenceSymbol, name, state);
	                    }
	                }
	                else {
	                    if (state.markSeenReExportRHS(referenceLocation)) {
	                        addRef();
	                    }
	                }
	                // For `export { foo as bar }`, rename `foo`, but not `bar`.
	                if (!(referenceLocation === propertyName && state.options.isForRename)) {
	                    var exportKind = referenceLocation.originalKeywordKind === 79 /* DefaultKeyword */ ? 1 /* Default */ : 0 /* Named */;
	                    var exportInfo = FindAllReferences.getExportInfo(referenceSymbol, exportKind, state.checker);
	                    ts.Debug.assert(!!exportInfo);
	                    searchForImportsOfExport(referenceLocation, referenceSymbol, exportInfo, state);
	                }
	                // At `export { x } from "foo"`, also search for the imported symbol `"foo".x`.
	                if (search.comingFrom !== 1 /* Export */ && exportDeclaration.moduleSpecifier && !propertyName) {
	                    var imported = state.checker.getExportSpecifierLocalTargetSymbol(exportSpecifier);
	                    if (imported)
	                        searchForImportedSymbol(imported, state);
	                }
	                function addRef() {
	                    addReference(referenceLocation, localSymbol, search.location, state);
	                }
	            }
	            function getLocalSymbolForExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, checker) {
	                return isExportSpecifierAlias(referenceLocation, exportSpecifier) && checker.getExportSpecifierLocalTargetSymbol(exportSpecifier) || referenceSymbol;
	            }
	            function isExportSpecifierAlias(referenceLocation, exportSpecifier) {
	                var parent = exportSpecifier.parent, propertyName = exportSpecifier.propertyName, name = exportSpecifier.name;
	                ts.Debug.assert(propertyName === referenceLocation || name === referenceLocation);
	                if (propertyName) {
	                    // Given `export { foo as bar } [from "someModule"]`: It's an alias at `foo`, but at `bar` it's a new symbol.
	                    return propertyName === referenceLocation;
	                }
	                else {
	                    // `export { foo } from "foo"` is a re-export.
	                    // `export { foo };` is not a re-export, it creates an alias for the local variable `foo`.
	                    return !parent.parent.moduleSpecifier;
	                }
	            }
	            function getImportOrExportReferences(referenceLocation, referenceSymbol, search, state) {
	                var importOrExport = FindAllReferences.getImportOrExportSymbol(referenceLocation, referenceSymbol, state.checker, search.comingFrom === 1 /* Export */);
	                if (!importOrExport)
	                    return;
	                var symbol = importOrExport.symbol;
	                if (importOrExport.kind === 0 /* Import */) {
	                    if (!state.options.isForRename || importOrExport.isNamedImport) {
	                        searchForImportedSymbol(symbol, state);
	                    }
	                }
	                else {
	                    // We don't check for `state.isForRename`, even for default exports, because importers that previously matched the export name should be updated to continue matching.
	                    searchForImportsOfExport(referenceLocation, symbol, importOrExport.exportInfo, state);
	                }
	            }
	            function getReferenceForShorthandProperty(_a, search, state) {
	                var flags = _a.flags, valueDeclaration = _a.valueDeclaration;
	                var shorthandValueSymbol = state.checker.getShorthandAssignmentValueSymbol(valueDeclaration);
	                /*
	                 * Because in short-hand property assignment, an identifier which stored as name of the short-hand property assignment
	                 * has two meanings: property name and property value. Therefore when we do findAllReference at the position where
	                 * an identifier is declared, the language service should return the position of the variable declaration as well as
	                 * the position in short-hand property assignment excluding property accessing. However, if we do findAllReference at the
	                 * position of property accessing, the referenceEntry of such position will be handled in the first case.
	                 */
	                if (!(flags & 33554432 /* Transient */) && search.includes(shorthandValueSymbol)) {
	                    addReference(ts.getNameOfDeclaration(valueDeclaration), shorthandValueSymbol, search.location, state);
	                }
	            }
	            function addReference(referenceLocation, relatedSymbol, searchLocation, state) {
	                var addRef = state.referenceAdder(relatedSymbol, searchLocation);
	                if (state.options.implementations) {
	                    addImplementationReferences(referenceLocation, addRef, state);
	                }
	                else {
	                    addRef(referenceLocation);
	                }
	            }
	            /** Adds references when a constructor is used with `new this()` in its own class and `super()` calls in subclasses.  */
	            function addConstructorReferences(referenceLocation, sourceFile, search, state) {
	                if (ts.isNewExpressionTarget(referenceLocation)) {
	                    addReference(referenceLocation, search.symbol, search.location, state);
	                }
	                var pusher = function () { return state.referenceAdder(search.symbol, search.location); };
	                if (ts.isClassLike(referenceLocation.parent)) {
	                    ts.Debug.assert(referenceLocation.kind === 79 /* DefaultKeyword */ || referenceLocation.parent.name === referenceLocation);
	                    // This is the class declaration containing the constructor.
	                    findOwnConstructorReferences(search.symbol, sourceFile, pusher());
	                }
	                else {
	                    // If this class appears in `extends C`, then the extending class' "super" calls are references.
	                    var classExtending = tryGetClassByExtendingIdentifier(referenceLocation);
	                    if (classExtending) {
	                        findSuperConstructorAccesses(classExtending, pusher());
	                    }
	                }
	            }
	            function addClassStaticThisReferences(referenceLocation, search, state) {
	                addReference(referenceLocation, search.symbol, search.location, state);
	                if (ts.isClassLike(referenceLocation.parent)) {
	                    ts.Debug.assert(referenceLocation.parent.name === referenceLocation);
	                    // This is the class declaration.
	                    addStaticThisReferences(referenceLocation.parent, state.referenceAdder(search.symbol, search.location));
	                }
	            }
	            function addStaticThisReferences(classLike, pusher) {
	                for (var _i = 0, _a = classLike.members; _i < _a.length; _i++) {
	                    var member = _a[_i];
	                    if (!(ts.isMethodOrAccessor(member) && ts.hasModifier(member, 32 /* Static */))) {
	                        continue;
	                    }
	                    member.body.forEachChild(function cb(node) {
	                        if (node.kind === 99 /* ThisKeyword */) {
	                            pusher(node);
	                        }
	                        else if (!ts.isFunctionLike(node)) {
	                            node.forEachChild(cb);
	                        }
	                    });
	                }
	            }
	            function getPropertyAccessExpressionFromRightHandSide(node) {
	                return ts.isRightSideOfPropertyAccess(node) && node.parent;
	            }
	            /**
	             * `classSymbol` is the class where the constructor was defined.
	             * Reference the constructor and all calls to `new this()`.
	             */
	            function findOwnConstructorReferences(classSymbol, sourceFile, addNode) {
	                for (var _i = 0, _a = classSymbol.members.get("__constructor" /* Constructor */).declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var ctrKeyword = ts.findChildOfKind(decl, 123 /* ConstructorKeyword */, sourceFile);
	                    ts.Debug.assert(decl.kind === 154 /* Constructor */ && !!ctrKeyword);
	                    addNode(ctrKeyword);
	                }
	                classSymbol.exports.forEach(function (member) {
	                    var decl = member.valueDeclaration;
	                    if (decl && decl.kind === 153 /* MethodDeclaration */) {
	                        var body = decl.body;
	                        if (body) {
	                            forEachDescendantOfKind(body, 99 /* ThisKeyword */, function (thisKeyword) {
	                                if (ts.isNewExpressionTarget(thisKeyword)) {
	                                    addNode(thisKeyword);
	                                }
	                            });
	                        }
	                    }
	                });
	            }
	            /** Find references to `super` in the constructor of an extending class.  */
	            function findSuperConstructorAccesses(cls, addNode) {
	                var symbol = cls.symbol;
	                var ctr = symbol.members.get("__constructor" /* Constructor */);
	                if (!ctr) {
	                    return;
	                }
	                for (var _i = 0, _a = ctr.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    ts.Debug.assert(decl.kind === 154 /* Constructor */);
	                    var body = decl.body;
	                    if (body) {
	                        forEachDescendantOfKind(body, 97 /* SuperKeyword */, function (node) {
	                            if (ts.isCallExpressionTarget(node)) {
	                                addNode(node);
	                            }
	                        });
	                    }
	                }
	            }
	            function addImplementationReferences(refNode, addReference, state) {
	                // Check if we found a function/propertyAssignment/method with an implementation or initializer
	                if (ts.isDeclarationName(refNode) && isImplementation(refNode.parent)) {
	                    addReference(refNode.parent);
	                    return;
	                }
	                if (refNode.kind !== 71 /* Identifier */) {
	                    return;
	                }
	                if (refNode.parent.kind === 269 /* ShorthandPropertyAssignment */) {
	                    // Go ahead and dereference the shorthand assignment by going to its definition
	                    getReferenceEntriesForShorthandPropertyAssignment(refNode, state.checker, addReference);
	                }
	                // Check if the node is within an extends or implements clause
	                var containingClass = getContainingClassIfInHeritageClause(refNode);
	                if (containingClass) {
	                    addReference(containingClass);
	                    return;
	                }
	                // If we got a type reference, try and see if the reference applies to any expressions that can implement an interface
	                var containingTypeReference = getContainingTypeReference(refNode);
	                if (containingTypeReference && state.markSeenContainingTypeReference(containingTypeReference)) {
	                    var parent = containingTypeReference.parent;
	                    if (ts.hasType(parent) && parent.type === containingTypeReference && ts.hasInitializer(parent) && isImplementationExpression(parent.initializer)) {
	                        addReference(parent.initializer);
	                    }
	                    else if (ts.isFunctionLike(parent) && parent.type === containingTypeReference && parent.body) {
	                        var body = parent.body;
	                        if (body.kind === 211 /* Block */) {
	                            ts.forEachReturnStatement(body, function (returnStatement) {
	                                if (returnStatement.expression && isImplementationExpression(returnStatement.expression)) {
	                                    addReference(returnStatement.expression);
	                                }
	                            });
	                        }
	                        else if (isImplementationExpression(body)) {
	                            addReference(body);
	                        }
	                    }
	                    else if (ts.isAssertionExpression(parent) && isImplementationExpression(parent.expression)) {
	                        addReference(parent.expression);
	                    }
	                }
	            }
	            function getSymbolsForClassAndInterfaceComponents(type, result) {
	                if (result === void 0) { result = []; }
	                for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                    var componentType = _a[_i];
	                    if (componentType.symbol && componentType.symbol.getFlags() & (32 /* Class */ | 64 /* Interface */)) {
	                        result.push(componentType.symbol);
	                    }
	                    if (componentType.getFlags() & 393216 /* UnionOrIntersection */) {
	                        getSymbolsForClassAndInterfaceComponents(componentType, result);
	                    }
	                }
	                return result;
	            }
	            function getContainingTypeReference(node) {
	                var topLevelTypeReference = undefined;
	                while (node) {
	                    if (ts.isTypeNode(node)) {
	                        topLevelTypeReference = node;
	                    }
	                    node = node.parent;
	                }
	                return topLevelTypeReference;
	            }
	            function getContainingClassIfInHeritageClause(node) {
	                if (node && node.parent) {
	                    if (node.kind === 205 /* ExpressionWithTypeArguments */
	                        && node.parent.kind === 266 /* HeritageClause */
	                        && ts.isClassLike(node.parent.parent)) {
	                        return node.parent.parent;
	                    }
	                    else if (node.kind === 71 /* Identifier */ || node.kind === 183 /* PropertyAccessExpression */) {
	                        return getContainingClassIfInHeritageClause(node.parent);
	                    }
	                }
	                return undefined;
	            }
	            /**
	             * Returns true if this is an expression that can be considered an implementation
	             */
	            function isImplementationExpression(node) {
	                switch (node.kind) {
	                    case 189 /* ParenthesizedExpression */:
	                        return isImplementationExpression(node.expression);
	                    case 191 /* ArrowFunction */:
	                    case 190 /* FunctionExpression */:
	                    case 182 /* ObjectLiteralExpression */:
	                    case 203 /* ClassExpression */:
	                    case 181 /* ArrayLiteralExpression */:
	                        return true;
	                    default:
	                        return false;
	                }
	            }
	            /**
	             * Determines if the parent symbol occurs somewhere in the child's ancestry. If the parent symbol
	             * is an interface, determines if some ancestor of the child symbol extends or inherits from it.
	             * Also takes in a cache of previous results which makes this slightly more efficient and is
	             * necessary to avoid potential loops like so:
	             *     class A extends B { }
	             *     class B extends A { }
	             *
	             * We traverse the AST rather than using the type checker because users are typically only interested
	             * in explicit implementations of an interface/class when calling "Go to Implementation". Sibling
	             * implementations of types that share a common ancestor with the type whose implementation we are
	             * searching for need to be filtered out of the results. The type checker doesn't let us make the
	             * distinction between structurally compatible implementations and explicit implementations, so we
	             * must use the AST.
	             *
	             * @param child         A class or interface Symbol
	             * @param parent        Another class or interface Symbol
	             * @param cachedResults A map of symbol id pairs (i.e. "child,parent") to booleans indicating previous results
	             */
	            function explicitlyInheritsFrom(child, parent, cachedResults, checker) {
	                var parentIsInterface = parent.getFlags() & 64 /* Interface */;
	                return searchHierarchy(child);
	                function searchHierarchy(symbol) {
	                    if (symbol === parent) {
	                        return true;
	                    }
	                    var key = ts.getSymbolId(symbol) + "," + ts.getSymbolId(parent);
	                    var cached = cachedResults.get(key);
	                    if (cached !== undefined) {
	                        return cached;
	                    }
	                    // Set the key so that we don't infinitely recurse
	                    cachedResults.set(key, false);
	                    var inherits = ts.forEach(symbol.getDeclarations(), function (declaration) {
	                        if (ts.isClassLike(declaration)) {
	                            if (parentIsInterface) {
	                                var interfaceReferences = ts.getClassImplementsHeritageClauseElements(declaration);
	                                if (interfaceReferences) {
	                                    for (var _i = 0, interfaceReferences_1 = interfaceReferences; _i < interfaceReferences_1.length; _i++) {
	                                        var typeReference = interfaceReferences_1[_i];
	                                        if (searchTypeReference(typeReference)) {
	                                            return true;
	                                        }
	                                    }
	                                }
	                            }
	                            return searchTypeReference(ts.getClassExtendsHeritageClauseElement(declaration));
	                        }
	                        else if (declaration.kind === 234 /* InterfaceDeclaration */) {
	                            if (parentIsInterface) {
	                                return ts.forEach(ts.getInterfaceBaseTypeNodes(declaration), searchTypeReference);
	                            }
	                        }
	                        return false;
	                    });
	                    cachedResults.set(key, inherits);
	                    return inherits;
	                }
	                function searchTypeReference(typeReference) {
	                    if (typeReference) {
	                        var type = checker.getTypeAtLocation(typeReference);
	                        if (type && type.symbol) {
	                            return searchHierarchy(type.symbol);
	                        }
	                    }
	                    return false;
	                }
	            }
	            function getReferencesForSuperKeyword(superKeyword) {
	                var searchSpaceNode = ts.getSuperContainer(superKeyword, /*stopOnFunctions*/ false);
	                if (!searchSpaceNode) {
	                    return undefined;
	                }
	                // Whether 'super' occurs in a static context within a class.
	                var staticFlag = 32 /* Static */;
	                switch (searchSpaceNode.kind) {
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                    case 154 /* Constructor */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        staticFlag &= ts.getModifierFlags(searchSpaceNode);
	                        searchSpaceNode = searchSpaceNode.parent; // re-assign to be the owning class
	                        break;
	                    default:
	                        return undefined;
	                }
	                var sourceFile = searchSpaceNode.getSourceFile();
	                var references = ts.mapDefined(getPossibleSymbolReferencePositions(sourceFile, "super", searchSpaceNode), function (position) {
	                    var node = ts.getTouchingWord(sourceFile, position, /*includeJsDocComment*/ false);
	                    if (!node || node.kind !== 97 /* SuperKeyword */) {
	                        return;
	                    }
	                    var container = ts.getSuperContainer(node, /*stopOnFunctions*/ false);
	                    // If we have a 'super' container, we must have an enclosing class.
	                    // Now make sure the owning class is the same as the search-space
	                    // and has the same static qualifier as the original 'super's owner.
	                    return container && (32 /* Static */ & ts.getModifierFlags(container)) === staticFlag && container.parent.symbol === searchSpaceNode.symbol ? FindAllReferences.nodeEntry(node) : undefined;
	                });
	                return [{ definition: { type: "symbol", symbol: searchSpaceNode.symbol, node: superKeyword }, references: references }];
	            }
	            function getReferencesForThisKeyword(thisOrSuperKeyword, sourceFiles, cancellationToken) {
	                var searchSpaceNode = ts.getThisContainer(thisOrSuperKeyword, /* includeArrowFunctions */ false);
	                // Whether 'this' occurs in a static context within a class.
	                var staticFlag = 32 /* Static */;
	                switch (searchSpaceNode.kind) {
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        if (ts.isObjectLiteralMethod(searchSpaceNode)) {
	                            break;
	                        }
	                    // falls through
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 154 /* Constructor */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        staticFlag &= ts.getModifierFlags(searchSpaceNode);
	                        searchSpaceNode = searchSpaceNode.parent; // re-assign to be the owning class
	                        break;
	                    case 272 /* SourceFile */:
	                        if (ts.isExternalModule(searchSpaceNode)) {
	                            return undefined;
	                        }
	                    // falls through
	                    case 232 /* FunctionDeclaration */:
	                    case 190 /* FunctionExpression */:
	                        break;
	                    // Computed properties in classes are not handled here because references to this are illegal,
	                    // so there is no point finding references to them.
	                    default:
	                        return undefined;
	                }
	                var references = [];
	                for (var _i = 0, _a = searchSpaceNode.kind === 272 /* SourceFile */ ? sourceFiles : [searchSpaceNode.getSourceFile()]; _i < _a.length; _i++) {
	                    var sourceFile = _a[_i];
	                    cancellationToken.throwIfCancellationRequested();
	                    var positions = getPossibleSymbolReferencePositions(sourceFile, "this", ts.isSourceFile(searchSpaceNode) ? sourceFile : searchSpaceNode);
	                    getThisReferencesInFile(sourceFile, searchSpaceNode.kind === 272 /* SourceFile */ ? sourceFile : searchSpaceNode, positions, staticFlag, references);
	                }
	                return [{
	                        definition: { type: "this", node: thisOrSuperKeyword },
	                        references: references
	                    }];
	            }
	            function getThisReferencesInFile(sourceFile, searchSpaceNode, possiblePositions, staticFlag, result) {
	                ts.forEach(possiblePositions, function (position) {
	                    var node = ts.getTouchingWord(sourceFile, position, /*includeJsDocComment*/ false);
	                    if (!node || !ts.isThis(node)) {
	                        return;
	                    }
	                    var container = ts.getThisContainer(node, /* includeArrowFunctions */ false);
	                    switch (searchSpaceNode.kind) {
	                        case 190 /* FunctionExpression */:
	                        case 232 /* FunctionDeclaration */:
	                            if (searchSpaceNode.symbol === container.symbol) {
	                                result.push(FindAllReferences.nodeEntry(node));
	                            }
	                            break;
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                            if (ts.isObjectLiteralMethod(searchSpaceNode) && searchSpaceNode.symbol === container.symbol) {
	                                result.push(FindAllReferences.nodeEntry(node));
	                            }
	                            break;
	                        case 203 /* ClassExpression */:
	                        case 233 /* ClassDeclaration */:
	                            // Make sure the container belongs to the same class
	                            // and has the appropriate static modifier from the original container.
	                            if (container.parent && searchSpaceNode.symbol === container.parent.symbol && (ts.getModifierFlags(container) & 32 /* Static */) === staticFlag) {
	                                result.push(FindAllReferences.nodeEntry(node));
	                            }
	                            break;
	                        case 272 /* SourceFile */:
	                            if (container.kind === 272 /* SourceFile */ && !ts.isExternalModule(container)) {
	                                result.push(FindAllReferences.nodeEntry(node));
	                            }
	                            break;
	                    }
	                });
	            }
	            function getReferencesForStringLiteral(node, sourceFiles, cancellationToken) {
	                var references = ts.flatMap(sourceFiles, function (sourceFile) {
	                    cancellationToken.throwIfCancellationRequested();
	                    return ts.mapDefined(getPossibleSymbolReferencePositions(sourceFile, node.text), function (position) {
	                        var ref = ts.tryCast(ts.getTouchingWord(sourceFile, position, /*includeJsDocComment*/ false), ts.isStringLiteral);
	                        return ref && ref.text === node.text ? FindAllReferences.nodeEntry(ref, /*isInString*/ true) : undefined;
	                    });
	                });
	                return [{
	                        definition: { type: "string", node: node },
	                        references: references
	                    }];
	            }
	            // For certain symbol kinds, we need to include other symbols in the search set.
	            // This is not needed when searching for re-exports.
	            function populateSearchSymbolSet(symbol, location, checker, implementations) {
	                // The search set contains at least the current symbol
	                var result = [];
	                var containingObjectLiteralElement = ts.getContainingObjectLiteralElement(location);
	                if (containingObjectLiteralElement) {
	                    // If the location is name of property symbol from object literal destructuring pattern
	                    // Search the property symbol
	                    //      for ( { property: p2 } of elems) { }
	                    if (containingObjectLiteralElement.kind !== 269 /* ShorthandPropertyAssignment */) {
	                        var propertySymbol = getPropertySymbolOfDestructuringAssignment(location, checker);
	                        if (propertySymbol) {
	                            result.push(propertySymbol);
	                        }
	                    }
	                    // If the location is in a context sensitive location (i.e. in an object literal) try
	                    // to get a contextual type for it, and add the property symbol from the contextual
	                    // type to the search set
	                    for (var _i = 0, _a = getPropertySymbolsFromContextualType(containingObjectLiteralElement, checker); _i < _a.length; _i++) {
	                        var contextualSymbol = _a[_i];
	                        addRootSymbols(contextualSymbol);
	                    }
	                    /* Because in short-hand property assignment, location has two meaning : property name and as value of the property
	                     * When we do findAllReference at the position of the short-hand property assignment, we would want to have references to position of
	                     * property name and variable declaration of the identifier.
	                     * Like in below example, when querying for all references for an identifier 'name', of the property assignment, the language service
	                     * should show both 'name' in 'obj' and 'name' in variable declaration
	                     *      const name = "Foo";
	                     *      const obj = { name };
	                     * In order to do that, we will populate the search set with the value symbol of the identifier as a value of the property assignment
	                     * so that when matching with potential reference symbol, both symbols from property declaration and variable declaration
	                     * will be included correctly.
	                     */
	                    var shorthandValueSymbol = checker.getShorthandAssignmentValueSymbol(location.parent);
	                    if (shorthandValueSymbol) {
	                        result.push(shorthandValueSymbol);
	                    }
	                }
	                // If the symbol.valueDeclaration is a property parameter declaration,
	                // we should include both parameter declaration symbol and property declaration symbol
	                // Parameter Declaration symbol is only visible within function scope, so the symbol is stored in constructor.locals.
	                // Property Declaration symbol is a member of the class, so the symbol is stored in its class Declaration.symbol.members
	                ts.addRange(result, getParameterPropertySymbols(symbol, checker));
	                // If this is symbol of binding element without propertyName declaration in Object binding pattern
	                // Include the property in the search
	                var bindingElementPropertySymbol = getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol, checker);
	                if (bindingElementPropertySymbol) {
	                    result.push(bindingElementPropertySymbol);
	                    addRootSymbols(bindingElementPropertySymbol);
	                }
	                addRootSymbols(symbol);
	                return result;
	                function addRootSymbols(sym) {
	                    // If this is a union property, add all the symbols from all its source symbols in all unioned types.
	                    // If the symbol is an instantiation from a another symbol (e.g. widened symbol) , add the root the list
	                    for (var _i = 0, _a = checker.getRootSymbols(sym); _i < _a.length; _i++) {
	                        var rootSymbol = _a[_i];
	                        result.push(rootSymbol);
	                        // Add symbol of properties/methods of the same name in base classes and implemented interfaces definitions
	                        if (!implementations && rootSymbol.parent && rootSymbol.parent.flags & (32 /* Class */ | 64 /* Interface */)) {
	                            getPropertySymbolsFromBaseTypes(rootSymbol.parent, rootSymbol.name, result, /*previousIterationSymbolsCache*/ ts.createSymbolTable(), checker);
	                        }
	                    }
	                }
	            }
	            function getParameterPropertySymbols(symbol, checker) {
	                return symbol.valueDeclaration && ts.isParameter(symbol.valueDeclaration) && ts.isParameterPropertyDeclaration(symbol.valueDeclaration)
	                    ? checker.getSymbolsOfParameterPropertyDeclaration(symbol.valueDeclaration, symbol.name)
	                    : undefined;
	            }
	            /**
	             * Find symbol of the given property-name and add the symbol to the given result array
	             * @param symbol a symbol to start searching for the given propertyName
	             * @param propertyName a name of property to search for
	             * @param result an array of symbol of found property symbols
	             * @param previousIterationSymbolsCache a cache of symbol from previous iterations of calling this function to prevent infinite revisiting of the same symbol.
	             *                                The value of previousIterationSymbol is undefined when the function is first called.
	             */
	            function getPropertySymbolsFromBaseTypes(symbol, propertyName, result, previousIterationSymbolsCache, checker) {
	                if (!symbol) {
	                    return;
	                }
	                // If the current symbol is the same as the previous-iteration symbol, we can just return the symbol that has already been visited
	                // This is particularly important for the following cases, so that we do not infinitely visit the same symbol.
	                // For example:
	                //      interface C extends C {
	                //          /*findRef*/propName: string;
	                //      }
	                // The first time getPropertySymbolsFromBaseTypes is called when finding-all-references at propName,
	                // the symbol argument will be the symbol of an interface "C" and previousIterationSymbol is undefined,
	                // the function will add any found symbol of the property-name, then its sub-routine will call
	                // getPropertySymbolsFromBaseTypes again to walk up any base types to prevent revisiting already
	                // visited symbol, interface "C", the sub-routine will pass the current symbol as previousIterationSymbol.
	                if (previousIterationSymbolsCache.has(symbol.escapedName)) {
	                    return;
	                }
	                if (symbol.flags & (32 /* Class */ | 64 /* Interface */)) {
	                    ts.forEach(symbol.getDeclarations(), function (declaration) {
	                        if (ts.isClassLike(declaration)) {
	                            getPropertySymbolFromTypeReference(ts.getClassExtendsHeritageClauseElement(declaration));
	                            ts.forEach(ts.getClassImplementsHeritageClauseElements(declaration), getPropertySymbolFromTypeReference);
	                        }
	                        else if (declaration.kind === 234 /* InterfaceDeclaration */) {
	                            ts.forEach(ts.getInterfaceBaseTypeNodes(declaration), getPropertySymbolFromTypeReference);
	                        }
	                    });
	                }
	                return;
	                function getPropertySymbolFromTypeReference(typeReference) {
	                    if (typeReference) {
	                        var type = checker.getTypeAtLocation(typeReference);
	                        if (type) {
	                            var propertySymbol = checker.getPropertyOfType(type, propertyName);
	                            if (propertySymbol) {
	                                result.push.apply(result, checker.getRootSymbols(propertySymbol));
	                            }
	                            // Visit the typeReference as well to see if it directly or indirectly use that property
	                            previousIterationSymbolsCache.set(symbol.escapedName, symbol);
	                            getPropertySymbolsFromBaseTypes(type.symbol, propertyName, result, previousIterationSymbolsCache, checker);
	                        }
	                    }
	                }
	            }
	            function getRelatedSymbol(search, referenceSymbol, referenceLocation, state) {
	                var checker = state.checker;
	                if (search.includes(referenceSymbol)) {
	                    return referenceSymbol;
	                }
	                if (referenceSymbol.flags & 1 /* FunctionScopedVariable */) {
	                    ts.Debug.assert(!(referenceSymbol.flags & 4 /* Property */));
	                    var paramProps = getParameterPropertySymbols(referenceSymbol, checker);
	                    if (paramProps) {
	                        return getRelatedSymbol(search, ts.find(paramProps, function (x) { return !!(x.flags & 4 /* Property */); }), referenceLocation, state);
	                    }
	                }
	                // If the reference location is in an object literal, try to get the contextual type for the
	                // object literal, lookup the property symbol in the contextual type, and use this symbol to
	                // compare to our searchSymbol
	                var containingObjectLiteralElement = ts.getContainingObjectLiteralElement(referenceLocation);
	                if (containingObjectLiteralElement) {
	                    var contextualSymbol = ts.firstDefined(getPropertySymbolsFromContextualType(containingObjectLiteralElement, checker), findRootSymbol);
	                    if (contextualSymbol) {
	                        return contextualSymbol;
	                    }
	                    // If the reference location is the name of property from object literal destructuring pattern
	                    // Get the property symbol from the object literal's type and look if thats the search symbol
	                    // In below eg. get 'property' from type of elems iterating type
	                    //      for ( { property: p2 } of elems) { }
	                    var propertySymbol = getPropertySymbolOfDestructuringAssignment(referenceLocation, checker);
	                    if (propertySymbol && search.includes(propertySymbol)) {
	                        return propertySymbol;
	                    }
	                }
	                // If the reference location is the binding element and doesn't have property name
	                // then include the binding element in the related symbols
	                //      let { a } : { a };
	                var bindingElementPropertySymbol = getPropertySymbolOfObjectBindingPatternWithoutPropertyName(referenceSymbol, checker);
	                if (bindingElementPropertySymbol) {
	                    var fromBindingElement = findRootSymbol(bindingElementPropertySymbol);
	                    if (fromBindingElement)
	                        return fromBindingElement;
	                }
	                return findRootSymbol(referenceSymbol);
	                function findRootSymbol(sym) {
	                    // Unwrap symbols to get to the root (e.g. transient symbols as a result of widening)
	                    // Or a union property, use its underlying unioned symbols
	                    return ts.firstDefined(checker.getRootSymbols(sym), function (rootSymbol) {
	                        // if it is in the list, then we are done
	                        if (search.includes(rootSymbol)) {
	                            return rootSymbol;
	                        }
	                        // Finally, try all properties with the same name in any type the containing type extended or implemented, and
	                        // see if any is in the list. If we were passed a parent symbol, only include types that are subtypes of the
	                        // parent symbol
	                        if (rootSymbol.parent && rootSymbol.parent.flags & (32 /* Class */ | 64 /* Interface */)) {
	                            // Parents will only be defined if implementations is true
	                            if (search.parents && !ts.some(search.parents, function (parent) { return explicitlyInheritsFrom(rootSymbol.parent, parent, state.inheritsFromCache, checker); })) {
	                                return undefined;
	                            }
	                            var result = [];
	                            getPropertySymbolsFromBaseTypes(rootSymbol.parent, rootSymbol.name, result, /*previousIterationSymbolsCache*/ ts.createSymbolTable(), checker);
	                            return ts.find(result, search.includes);
	                        }
	                        return undefined;
	                    });
	                }
	            }
	            function getNameFromObjectLiteralElement(node) {
	                if (node.name.kind === 146 /* ComputedPropertyName */) {
	                    var nameExpression = node.name.expression;
	                    // treat computed property names where expression is string/numeric literal as just string/numeric literal
	                    if (ts.isStringOrNumericLiteral(nameExpression)) {
	                        return nameExpression.text;
	                    }
	                    return undefined;
	                }
	                return ts.getTextOfIdentifierOrLiteral(node.name);
	            }
	            /** Gets all symbols for one property. Does not get symbols for every property. */
	            function getPropertySymbolsFromContextualType(node, checker) {
	                var contextualType = checker.getContextualType(node.parent);
	                var name = getNameFromObjectLiteralElement(node);
	                var symbol = contextualType && name && contextualType.getProperty(name);
	                return symbol ? [symbol] :
	                    contextualType && contextualType.flags & 131072 /* Union */ ? ts.mapDefined(contextualType.types, function (t) { return t.getProperty(name); }) : ts.emptyArray;
	            }
	            /**
	             * Given an initial searchMeaning, extracted from a location, widen the search scope based on the declarations
	             * of the corresponding symbol. e.g. if we are searching for "Foo" in value position, but "Foo" references a class
	             * then we need to widen the search to include type positions as well.
	             * On the contrary, if we are searching for "Bar" in type position and we trace bar to an interface, and an uninstantiated
	             * module, we want to keep the search limited to only types, as the two declarations (interface and uninstantiated module)
	             * do not intersect in any of the three spaces.
	             */
	            function getIntersectingMeaningFromDeclarations(meaning, declarations) {
	                if (declarations) {
	                    var lastIterationMeaning = void 0;
	                    do {
	                        // The result is order-sensitive, for instance if initialMeaning === Namespace, and declarations = [class, instantiated module]
	                        // we need to consider both as they initialMeaning intersects with the module in the namespace space, and the module
	                        // intersects with the class in the value space.
	                        // To achieve that we will keep iterating until the result stabilizes.
	                        // Remember the last meaning
	                        lastIterationMeaning = meaning;
	                        for (var _i = 0, declarations_10 = declarations; _i < declarations_10.length; _i++) {
	                            var declaration = declarations_10[_i];
	                            var declarationMeaning = ts.getMeaningFromDeclaration(declaration);
	                            if (declarationMeaning & meaning) {
	                                meaning |= declarationMeaning;
	                            }
	                        }
	                    } while (meaning !== lastIterationMeaning);
	                }
	                return meaning;
	            }
	            function isImplementation(node) {
	                if (!node) {
	                    return false;
	                }
	                else if (ts.isVariableLike(node) && ts.hasInitializer(node)) {
	                    return true;
	                }
	                else if (node.kind === 230 /* VariableDeclaration */) {
	                    var parentStatement = getParentStatementOfVariableDeclaration(node);
	                    return parentStatement && ts.hasModifier(parentStatement, 2 /* Ambient */);
	                }
	                else if (ts.isFunctionLike(node)) {
	                    return !!node.body || ts.hasModifier(node, 2 /* Ambient */);
	                }
	                else {
	                    switch (node.kind) {
	                        case 233 /* ClassDeclaration */:
	                        case 203 /* ClassExpression */:
	                        case 236 /* EnumDeclaration */:
	                        case 237 /* ModuleDeclaration */:
	                            return true;
	                    }
	                }
	                return false;
	            }
	            function getParentStatementOfVariableDeclaration(node) {
	                if (node.parent && node.parent.parent && node.parent.parent.kind === 212 /* VariableStatement */) {
	                    ts.Debug.assert(node.parent.kind === 231 /* VariableDeclarationList */);
	                    return node.parent.parent;
	                }
	            }
	            function getReferenceEntriesForShorthandPropertyAssignment(node, checker, addReference) {
	                var refSymbol = checker.getSymbolAtLocation(node);
	                var shorthandSymbol = checker.getShorthandAssignmentValueSymbol(refSymbol.valueDeclaration);
	                if (shorthandSymbol) {
	                    for (var _i = 0, _a = shorthandSymbol.getDeclarations(); _i < _a.length; _i++) {
	                        var declaration = _a[_i];
	                        if (ts.getMeaningFromDeclaration(declaration) & 1 /* Value */) {
	                            addReference(declaration);
	                        }
	                    }
	                }
	            }
	            Core.getReferenceEntriesForShorthandPropertyAssignment = getReferenceEntriesForShorthandPropertyAssignment;
	            function forEachDescendantOfKind(node, kind, action) {
	                ts.forEachChild(node, function (child) {
	                    if (child.kind === kind) {
	                        action(child);
	                    }
	                    forEachDescendantOfKind(child, kind, action);
	                });
	            }
	            /** Get `C` given `N` if `N` is in the position `class C extends N` or `class C extends foo.N` where `N` is an identifier. */
	            function tryGetClassByExtendingIdentifier(node) {
	                return ts.tryGetClassExtendingExpressionWithTypeArguments(ts.climbPastPropertyAccess(node).parent);
	            }
	            function isNameOfExternalModuleImportOrDeclaration(node) {
	                if (node.kind === 9 /* StringLiteral */) {
	                    return ts.isNameOfModuleDeclaration(node) || ts.isExpressionOfExternalModuleImportEqualsDeclaration(node);
	                }
	                return false;
	            }
	            /**
	             * If we are just looking for implementations and this is a property access expression, we need to get the
	             * symbol of the local type of the symbol the property is being accessed on. This is because our search
	             * symbol may have a different parent symbol if the local type's symbol does not declare the property
	             * being accessed (i.e. it is declared in some parent class or interface)
	             */
	            function getParentSymbolsOfPropertyAccess(location, symbol, checker) {
	                var propertyAccessExpression = getPropertyAccessExpressionFromRightHandSide(location);
	                if (!propertyAccessExpression) {
	                    return undefined;
	                }
	                var localParentType = checker.getTypeAtLocation(propertyAccessExpression.expression);
	                if (!localParentType) {
	                    return undefined;
	                }
	                if (localParentType.symbol && localParentType.symbol.flags & (32 /* Class */ | 64 /* Interface */) && localParentType.symbol !== symbol.parent) {
	                    return [localParentType.symbol];
	                }
	                else if (localParentType.flags & 393216 /* UnionOrIntersection */) {
	                    return getSymbolsForClassAndInterfaceComponents(localParentType);
	                }
	            }
	        })(Core = FindAllReferences.Core || (FindAllReferences.Core = {}));
	    })(FindAllReferences = ts.FindAllReferences || (ts.FindAllReferences = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var GoToDefinition;
	    (function (GoToDefinition) {
	        function getDefinitionAtPosition(program, sourceFile, position) {
	            var reference = getReferenceAtPosition(sourceFile, position, program);
	            if (reference) {
	                return [getDefinitionInfoForFileReference(reference.fileName, reference.file.fileName)];
	            }
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            if (node === sourceFile) {
	                return undefined;
	            }
	            // Labels
	            if (ts.isJumpStatementTarget(node)) {
	                var label = ts.getTargetLabel(node.parent, node.text);
	                return label ? [createDefinitionInfoFromName(label, "label" /* label */, node.text, /*containerName*/ undefined)] : undefined;
	            }
	            var typeChecker = program.getTypeChecker();
	            var calledDeclaration = tryGetSignatureDeclaration(typeChecker, node);
	            if (calledDeclaration) {
	                return [createDefinitionFromSignatureDeclaration(typeChecker, calledDeclaration)];
	            }
	            var symbol = typeChecker.getSymbolAtLocation(node);
	            // Could not find a symbol e.g. node is string or number keyword,
	            // or the symbol was an internal symbol and does not have a declaration e.g. undefined symbol
	            if (!symbol) {
	                return undefined;
	            }
	            // If this is an alias, and the request came at the declaration location
	            // get the aliased symbol instead. This allows for goto def on an import e.g.
	            //   import {A, B} from "mod";
	            // to jump to the implementation directly.
	            if (symbol.flags & 2097152 /* Alias */ && shouldSkipAlias(node, symbol.declarations[0])) {
	                var aliased = typeChecker.getAliasedSymbol(symbol);
	                if (aliased.declarations) {
	                    symbol = aliased;
	                }
	            }
	            // Because name in short-hand property assignment has two different meanings: property name and property value,
	            // using go-to-definition at such position should go to the variable declaration of the property value rather than
	            // go to the declaration of the property name (in this case stay at the same position). However, if go-to-definition
	            // is performed at the location of property access, we would like to go to definition of the property in the short-hand
	            // assignment. This case and others are handled by the following code.
	            if (node.parent.kind === 269 /* ShorthandPropertyAssignment */) {
	                var shorthandSymbol = typeChecker.getShorthandAssignmentValueSymbol(symbol.valueDeclaration);
	                if (!shorthandSymbol) {
	                    return [];
	                }
	                var shorthandDeclarations = shorthandSymbol.getDeclarations();
	                var shorthandSymbolKind_1 = ts.SymbolDisplay.getSymbolKind(typeChecker, shorthandSymbol, node);
	                var shorthandSymbolName_1 = typeChecker.symbolToString(shorthandSymbol);
	                var shorthandContainerName_1 = typeChecker.symbolToString(symbol.parent, node);
	                return ts.map(shorthandDeclarations, function (declaration) { return createDefinitionInfo(declaration, shorthandSymbolKind_1, shorthandSymbolName_1, shorthandContainerName_1); });
	            }
	            // If the node is the name of a BindingElement within an ObjectBindingPattern instead of just returning the
	            // declaration the symbol (which is itself), we should try to get to the original type of the ObjectBindingPattern
	            // and return the property declaration for the referenced property.
	            // For example:
	            //      import('./foo').then(({ b/*goto*/ar }) => undefined); => should get use to the declaration in file "./foo"
	            //
	            //      function bar<T>(onfulfilled: (value: T) => void) { //....}
	            //      interface Test {
	            //          pr/*destination*/op1: number
	            //      }
	            //      bar<Test>(({pr/*goto*/op1})=>{});
	            if (ts.isPropertyName(node) && ts.isBindingElement(node.parent) && ts.isObjectBindingPattern(node.parent.parent) &&
	                (node === (node.parent.propertyName || node.parent.name))) {
	                var type = typeChecker.getTypeAtLocation(node.parent.parent);
	                if (type) {
	                    var propSymbols = ts.getPropertySymbolsFromType(type, node);
	                    if (propSymbols) {
	                        return ts.flatMap(propSymbols, function (propSymbol) { return getDefinitionFromSymbol(typeChecker, propSymbol, node); });
	                    }
	                }
	            }
	            // If the current location we want to find its definition is in an object literal, try to get the contextual type for the
	            // object literal, lookup the property symbol in the contextual type, and use this for goto-definition.
	            // For example
	            //      interface Props{
	            //          /*first*/prop1: number
	            //          prop2: boolean
	            //      }
	            //      function Foo(arg: Props) {}
	            //      Foo( { pr/*1*/op1: 10, prop2: true })
	            var element = ts.getContainingObjectLiteralElement(node);
	            if (element && typeChecker.getContextualType(element.parent)) {
	                return ts.flatMap(ts.getPropertySymbolsFromContextualType(typeChecker, element), function (propertySymbol) {
	                    return getDefinitionFromSymbol(typeChecker, propertySymbol, node);
	                });
	            }
	            return getDefinitionFromSymbol(typeChecker, symbol, node);
	        }
	        GoToDefinition.getDefinitionAtPosition = getDefinitionAtPosition;
	        function getReferenceAtPosition(sourceFile, position, program) {
	            var referencePath = findReferenceInPosition(sourceFile.referencedFiles, position);
	            if (referencePath) {
	                var file = ts.tryResolveScriptReference(program, sourceFile, referencePath);
	                return file && { fileName: referencePath.fileName, file: file };
	            }
	            var typeReferenceDirective = findReferenceInPosition(sourceFile.typeReferenceDirectives, position);
	            if (typeReferenceDirective) {
	                var reference = program.getResolvedTypeReferenceDirectives().get(typeReferenceDirective.fileName);
	                var file = reference && program.getSourceFile(reference.resolvedFileName);
	                return file && { fileName: typeReferenceDirective.fileName, file: file };
	            }
	            return undefined;
	        }
	        GoToDefinition.getReferenceAtPosition = getReferenceAtPosition;
	        /// Goto type
	        function getTypeDefinitionAtPosition(typeChecker, sourceFile, position) {
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            if (node === sourceFile) {
	                return undefined;
	            }
	            var symbol = typeChecker.getSymbolAtLocation(node);
	            var type = symbol && typeChecker.getTypeOfSymbolAtLocation(symbol, node);
	            if (!type) {
	                return undefined;
	            }
	            if (type.flags & 131072 /* Union */ && !(type.flags & 16 /* Enum */)) {
	                return ts.flatMap(type.types, function (t) { return t.symbol && getDefinitionFromSymbol(typeChecker, t.symbol, node); });
	            }
	            return type.symbol && getDefinitionFromSymbol(typeChecker, type.symbol, node);
	        }
	        GoToDefinition.getTypeDefinitionAtPosition = getTypeDefinitionAtPosition;
	        function getDefinitionAndBoundSpan(program, sourceFile, position) {
	            var definitions = getDefinitionAtPosition(program, sourceFile, position);
	            if (!definitions || definitions.length === 0) {
	                return undefined;
	            }
	            // Check if position is on triple slash reference.
	            var comment = findReferenceInPosition(sourceFile.referencedFiles, position) || findReferenceInPosition(sourceFile.typeReferenceDirectives, position);
	            if (comment) {
	                return { definitions: definitions, textSpan: ts.createTextSpanFromRange(comment) };
	            }
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            var textSpan = ts.createTextSpan(node.getStart(), node.getWidth());
	            return { definitions: definitions, textSpan: textSpan };
	        }
	        GoToDefinition.getDefinitionAndBoundSpan = getDefinitionAndBoundSpan;
	        // Go to the original declaration for cases:
	        //
	        //   (1) when the aliased symbol was declared in the location(parent).
	        //   (2) when the aliased symbol is originating from an import.
	        //
	        function shouldSkipAlias(node, declaration) {
	            if (node.kind !== 71 /* Identifier */) {
	                return false;
	            }
	            if (node.parent === declaration) {
	                return true;
	            }
	            switch (declaration.kind) {
	                case 243 /* ImportClause */:
	                case 241 /* ImportEqualsDeclaration */:
	                    return true;
	                case 246 /* ImportSpecifier */:
	                    return declaration.parent.kind === 245 /* NamedImports */;
	                default:
	                    return false;
	            }
	        }
	        function getDefinitionFromSymbol(typeChecker, symbol, node) {
	            var _a = getSymbolInfo(typeChecker, symbol, node), symbolName = _a.symbolName, symbolKind = _a.symbolKind, containerName = _a.containerName;
	            return getConstructSignatureDefinition() || getCallSignatureDefinition() || ts.map(symbol.declarations, function (declaration) { return createDefinitionInfo(declaration, symbolKind, symbolName, containerName); });
	            function getConstructSignatureDefinition() {
	                // Applicable only if we are in a new expression, or we are on a constructor declaration
	                // and in either case the symbol has a construct signature definition, i.e. class
	                if (symbol.flags & 32 /* Class */ && (ts.isNewExpressionTarget(node) || node.kind === 123 /* ConstructorKeyword */)) {
	                    var cls = ts.find(symbol.declarations, ts.isClassLike) || ts.Debug.fail("Expected declaration to have at least one class-like declaration");
	                    return getSignatureDefinition(cls.members, /*selectConstructors*/ true);
	                }
	            }
	            function getCallSignatureDefinition() {
	                return ts.isCallExpressionTarget(node) || ts.isNewExpressionTarget(node) || ts.isNameOfFunctionDeclaration(node)
	                    ? getSignatureDefinition(symbol.declarations, /*selectConstructors*/ false)
	                    : undefined;
	            }
	            function getSignatureDefinition(signatureDeclarations, selectConstructors) {
	                if (!signatureDeclarations) {
	                    return undefined;
	                }
	                var declarations = signatureDeclarations.filter(selectConstructors ? ts.isConstructorDeclaration : isSignatureDeclaration);
	                return declarations.length
	                    ? [createDefinitionInfo(ts.find(declarations, function (d) { return !!d.body; }) || ts.last(declarations), symbolKind, symbolName, containerName)]
	                    : undefined;
	            }
	        }
	        function isSignatureDeclaration(node) {
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                case 158 /* ConstructSignature */:
	                case 232 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        /** Creates a DefinitionInfo from a Declaration, using the declaration's name if possible. */
	        function createDefinitionInfo(node, symbolKind, symbolName, containerName) {
	            return createDefinitionInfoFromName(ts.getNameOfDeclaration(node) || node, symbolKind, symbolName, containerName);
	        }
	        /** Creates a DefinitionInfo directly from the name of a declaration. */
	        function createDefinitionInfoFromName(name, symbolKind, symbolName, containerName) {
	            var sourceFile = name.getSourceFile();
	            return {
	                fileName: sourceFile.fileName,
	                textSpan: ts.createTextSpanFromNode(name, sourceFile),
	                kind: symbolKind,
	                name: symbolName,
	                containerKind: undefined,
	                containerName: containerName
	            };
	        }
	        function getSymbolInfo(typeChecker, symbol, node) {
	            return {
	                symbolName: typeChecker.symbolToString(symbol),
	                symbolKind: ts.SymbolDisplay.getSymbolKind(typeChecker, symbol, node),
	                containerName: symbol.parent ? typeChecker.symbolToString(symbol.parent, node) : ""
	            };
	        }
	        function createDefinitionFromSignatureDeclaration(typeChecker, decl) {
	            var _a = getSymbolInfo(typeChecker, decl.symbol, decl), symbolName = _a.symbolName, symbolKind = _a.symbolKind, containerName = _a.containerName;
	            return createDefinitionInfo(decl, symbolKind, symbolName, containerName);
	        }
	        function findReferenceInPosition(refs, pos) {
	            for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
	                var ref = refs_1[_i];
	                if (ref.pos <= pos && pos <= ref.end) {
	                    return ref;
	                }
	            }
	            return undefined;
	        }
	        GoToDefinition.findReferenceInPosition = findReferenceInPosition;
	        function getDefinitionInfoForFileReference(name, targetFileName) {
	            return {
	                fileName: targetFileName,
	                textSpan: ts.createTextSpanFromBounds(0, 0),
	                kind: "script" /* scriptElement */,
	                name: name,
	                containerName: undefined,
	                containerKind: undefined
	            };
	        }
	        /** Returns a CallLikeExpression where `node` is the target being invoked. */
	        function getAncestorCallLikeExpression(node) {
	            var target = climbPastManyPropertyAccesses(node);
	            var callLike = target.parent;
	            return callLike && ts.isCallLikeExpression(callLike) && ts.getInvokedExpression(callLike) === target && callLike;
	        }
	        function climbPastManyPropertyAccesses(node) {
	            return ts.isRightSideOfPropertyAccess(node) ? climbPastManyPropertyAccesses(node.parent) : node;
	        }
	        function tryGetSignatureDeclaration(typeChecker, node) {
	            var callLike = getAncestorCallLikeExpression(node);
	            var signature = callLike && typeChecker.getResolvedSignature(callLike);
	            if (signature) {
	                var decl = signature.declaration;
	                if (decl && isSignatureDeclaration(decl)) {
	                    return decl;
	                }
	            }
	            // Don't go to a function type, go to the value having that type.
	            return undefined;
	        }
	    })(GoToDefinition = ts.GoToDefinition || (ts.GoToDefinition = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var JsDoc;
	    (function (JsDoc) {
	        var jsDocTagNames = [
	            "augments",
	            "author",
	            "argument",
	            "borrows",
	            "class",
	            "constant",
	            "constructor",
	            "constructs",
	            "default",
	            "deprecated",
	            "description",
	            "event",
	            "example",
	            "extends",
	            "field",
	            "fileOverview",
	            "function",
	            "ignore",
	            "inheritDoc",
	            "inner",
	            "lends",
	            "link",
	            "memberOf",
	            "method",
	            "name",
	            "namespace",
	            "param",
	            "private",
	            "prop",
	            "property",
	            "public",
	            "requires",
	            "returns",
	            "see",
	            "since",
	            "static",
	            "template",
	            "throws",
	            "type",
	            "typedef",
	            "version"
	        ];
	        var jsDocTagNameCompletionEntries;
	        var jsDocTagCompletionEntries;
	        function getJsDocCommentsFromDeclarations(declarations) {
	            // Only collect doc comments from duplicate declarations once:
	            // In case of a union property there might be same declaration multiple times
	            // which only varies in type parameter
	            // Eg. const a: Array<string> | Array<number>; a.length
	            // The property length will have two declarations of property length coming
	            // from Array<T> - Array<string> and Array<number>
	            var documentationComment = [];
	            forEachUnique(declarations, function (declaration) {
	                for (var _i = 0, _a = getCommentHavingNodes(declaration); _i < _a.length; _i++) {
	                    var comment = _a[_i].comment;
	                    if (comment === undefined)
	                        continue;
	                    if (documentationComment.length) {
	                        documentationComment.push(ts.lineBreakPart());
	                    }
	                    documentationComment.push(ts.textPart(comment));
	                }
	            });
	            return documentationComment;
	        }
	        JsDoc.getJsDocCommentsFromDeclarations = getJsDocCommentsFromDeclarations;
	        function getCommentHavingNodes(declaration) {
	            switch (declaration.kind) {
	                case 292 /* JSDocPropertyTag */:
	                    return [declaration];
	                case 291 /* JSDocTypedefTag */:
	                    return [declaration.parent];
	                default:
	                    return ts.getJSDocCommentsAndTags(declaration);
	            }
	        }
	        function getJsDocTagsFromDeclarations(declarations) {
	            // Only collect doc comments from duplicate declarations once.
	            var tags = [];
	            forEachUnique(declarations, function (declaration) {
	                for (var _i = 0, _a = ts.getJSDocTags(declaration); _i < _a.length; _i++) {
	                    var tag = _a[_i];
	                    tags.push({ name: tag.tagName.text, text: getCommentText(tag) });
	                }
	            });
	            return tags;
	        }
	        JsDoc.getJsDocTagsFromDeclarations = getJsDocTagsFromDeclarations;
	        function getCommentText(tag) {
	            var comment = tag.comment;
	            switch (tag.kind) {
	                case 285 /* JSDocAugmentsTag */:
	                    return withNode(tag.class);
	                case 290 /* JSDocTemplateTag */:
	                    return withList(tag.typeParameters);
	                case 289 /* JSDocTypeTag */:
	                    return withNode(tag.typeExpression);
	                case 291 /* JSDocTypedefTag */:
	                case 292 /* JSDocPropertyTag */:
	                case 287 /* JSDocParameterTag */:
	                    var name = tag.name;
	                    return name ? withNode(name) : comment;
	                default:
	                    return comment;
	            }
	            function withNode(node) {
	                return addComment(node.getText());
	            }
	            function withList(list) {
	                return addComment(list.map(function (x) { return x.getText(); }).join(", "));
	            }
	            function addComment(s) {
	                return comment === undefined ? s : s + " " + comment;
	            }
	        }
	        /**
	         * Iterates through 'array' by index and performs the callback on each element of array until the callback
	         * returns a truthy value, then returns that value.
	         * If no such value is found, the callback is applied to each element of array and undefined is returned.
	         */
	        function forEachUnique(array, callback) {
	            if (array) {
	                for (var i = 0; i < array.length; i++) {
	                    if (array.indexOf(array[i]) === i) {
	                        var result = callback(array[i], i);
	                        if (result) {
	                            return result;
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function getJSDocTagNameCompletions() {
	            return jsDocTagNameCompletionEntries || (jsDocTagNameCompletionEntries = ts.map(jsDocTagNames, function (tagName) {
	                return {
	                    name: tagName,
	                    kind: "keyword" /* keyword */,
	                    kindModifiers: "",
	                    sortText: "0",
	                };
	            }));
	        }
	        JsDoc.getJSDocTagNameCompletions = getJSDocTagNameCompletions;
	        JsDoc.getJSDocTagNameCompletionDetails = getJSDocTagCompletionDetails;
	        function getJSDocTagCompletions() {
	            return jsDocTagCompletionEntries || (jsDocTagCompletionEntries = ts.map(jsDocTagNames, function (tagName) {
	                return {
	                    name: "@" + tagName,
	                    kind: "keyword" /* keyword */,
	                    kindModifiers: "",
	                    sortText: "0"
	                };
	            }));
	        }
	        JsDoc.getJSDocTagCompletions = getJSDocTagCompletions;
	        function getJSDocTagCompletionDetails(name) {
	            return {
	                name: name,
	                kind: "" /* unknown */,
	                kindModifiers: "",
	                displayParts: [ts.textPart(name)],
	                documentation: ts.emptyArray,
	                tags: ts.emptyArray,
	                codeActions: undefined,
	            };
	        }
	        JsDoc.getJSDocTagCompletionDetails = getJSDocTagCompletionDetails;
	        function getJSDocParameterNameCompletions(tag) {
	            if (!ts.isIdentifier(tag.name)) {
	                return ts.emptyArray;
	            }
	            var nameThusFar = tag.name.text;
	            var jsdoc = tag.parent;
	            var fn = jsdoc.parent;
	            if (!ts.isFunctionLike(fn))
	                return [];
	            return ts.mapDefined(fn.parameters, function (param) {
	                if (!ts.isIdentifier(param.name))
	                    return undefined;
	                var name = param.name.text;
	                if (jsdoc.tags.some(function (t) { return t !== tag && ts.isJSDocParameterTag(t) && ts.isIdentifier(t.name) && t.name.escapedText === name; })
	                    || nameThusFar !== undefined && !ts.startsWith(name, nameThusFar)) {
	                    return undefined;
	                }
	                return { name: name, kind: "parameter" /* parameterElement */, kindModifiers: "", sortText: "0" };
	            });
	        }
	        JsDoc.getJSDocParameterNameCompletions = getJSDocParameterNameCompletions;
	        function getJSDocParameterNameCompletionDetails(name) {
	            return {
	                name: name,
	                kind: "parameter" /* parameterElement */,
	                kindModifiers: "",
	                displayParts: [ts.textPart(name)],
	                documentation: ts.emptyArray,
	                tags: ts.emptyArray,
	                codeActions: undefined,
	            };
	        }
	        JsDoc.getJSDocParameterNameCompletionDetails = getJSDocParameterNameCompletionDetails;
	        /**
	         * Checks if position points to a valid position to add JSDoc comments, and if so,
	         * returns the appropriate template. Otherwise returns an empty string.
	         * Valid positions are
	         *      - outside of comments, statements, and expressions, and
	         *      - preceding a:
	         *          - function/constructor/method declaration
	         *          - class declarations
	         *          - variable statements
	         *          - namespace declarations
	         *          - interface declarations
	         *          - method signatures
	         *          - type alias declarations
	         *
	         * Hosts should ideally check that:
	         * - The line is all whitespace up to 'position' before performing the insertion.
	         * - If the keystroke sequence "/\*\*" induced the call, we also check that the next
	         * non-whitespace character is '*', which (approximately) indicates whether we added
	         * the second '*' to complete an existing (JSDoc) comment.
	         * @param fileName The file in which to perform the check.
	         * @param position The (character-indexed) position in the file where the check should
	         * be performed.
	         */
	        function getDocCommentTemplateAtPosition(newLine, sourceFile, position) {
	            // Check if in a context where we don't want to perform any insertion
	            if (ts.isInString(sourceFile, position) || ts.isInComment(sourceFile, position) || ts.hasDocComment(sourceFile, position)) {
	                return undefined;
	            }
	            var tokenAtPos = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	            var tokenStart = tokenAtPos.getStart();
	            if (!tokenAtPos || tokenStart < position) {
	                return undefined;
	            }
	            var commentOwnerInfo = getCommentOwnerInfo(tokenAtPos);
	            if (!commentOwnerInfo) {
	                return undefined;
	            }
	            var commentOwner = commentOwnerInfo.commentOwner, parameters = commentOwnerInfo.parameters;
	            if (commentOwner.getStart() < position) {
	                return undefined;
	            }
	            if (!parameters || parameters.length === 0) {
	                // if there are no parameters, just complete to a single line JSDoc comment
	                var singleLineResult = "/** */";
	                return { newText: singleLineResult, caretOffset: 3 };
	            }
	            var posLineAndChar = sourceFile.getLineAndCharacterOfPosition(position);
	            var lineStart = sourceFile.getLineStarts()[posLineAndChar.line];
	            // replace non-whitespace characters in prefix with spaces.
	            var indentationStr = sourceFile.text.substr(lineStart, posLineAndChar.character).replace(/\S/i, function () { return " "; });
	            var isJavaScriptFile = ts.hasJavaScriptFileExtension(sourceFile.fileName);
	            var docParams = "";
	            for (var i = 0; i < parameters.length; i++) {
	                var currentName = parameters[i].name;
	                var paramName = currentName.kind === 71 /* Identifier */ ? currentName.escapedText : "param" + i;
	                if (isJavaScriptFile) {
	                    docParams += indentationStr + " * @param {any} " + paramName + newLine;
	                }
	                else {
	                    docParams += indentationStr + " * @param " + paramName + newLine;
	                }
	            }
	            // A doc comment consists of the following
	            // * The opening comment line
	            // * the first line (without a param) for the object's untagged info (this is also where the caret ends up)
	            // * the '@param'-tagged lines
	            // * TODO: other tags.
	            // * the closing comment line
	            // * if the caret was directly in front of the object, then we add an extra line and indentation.
	            var preamble = "/**" + newLine +
	                indentationStr + " * ";
	            var result = preamble + newLine +
	                docParams +
	                indentationStr + " */" +
	                (tokenStart === position ? newLine + indentationStr : "");
	            return { newText: result, caretOffset: preamble.length };
	        }
	        JsDoc.getDocCommentTemplateAtPosition = getDocCommentTemplateAtPosition;
	        function getCommentOwnerInfo(tokenAtPos) {
	            for (var commentOwner = tokenAtPos; commentOwner; commentOwner = commentOwner.parent) {
	                switch (commentOwner.kind) {
	                    case 232 /* FunctionDeclaration */:
	                    case 153 /* MethodDeclaration */:
	                    case 154 /* Constructor */:
	                    case 152 /* MethodSignature */:
	                        var parameters = commentOwner.parameters;
	                        return { commentOwner: commentOwner, parameters: parameters };
	                    case 233 /* ClassDeclaration */:
	                    case 234 /* InterfaceDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 236 /* EnumDeclaration */:
	                    case 271 /* EnumMember */:
	                    case 235 /* TypeAliasDeclaration */:
	                        return { commentOwner: commentOwner };
	                    case 212 /* VariableStatement */: {
	                        var varStatement = commentOwner;
	                        var varDeclarations = varStatement.declarationList.declarations;
	                        var parameters_1 = varDeclarations.length === 1 && varDeclarations[0].initializer
	                            ? getParametersFromRightHandSideOfAssignment(varDeclarations[0].initializer)
	                            : undefined;
	                        return { commentOwner: commentOwner, parameters: parameters_1 };
	                    }
	                    case 272 /* SourceFile */:
	                        return undefined;
	                    case 237 /* ModuleDeclaration */:
	                        // If in walking up the tree, we hit a a nested namespace declaration,
	                        // then we must be somewhere within a dotted namespace name; however we don't
	                        // want to give back a JSDoc template for the 'b' or 'c' in 'namespace a.b.c { }'.
	                        return commentOwner.parent.kind === 237 /* ModuleDeclaration */ ? undefined : { commentOwner: commentOwner };
	                    case 198 /* BinaryExpression */: {
	                        var be = commentOwner;
	                        if (ts.getSpecialPropertyAssignmentKind(be) === 0 /* None */) {
	                            return undefined;
	                        }
	                        var parameters_2 = ts.isFunctionLike(be.right) ? be.right.parameters : ts.emptyArray;
	                        return { commentOwner: commentOwner, parameters: parameters_2 };
	                    }
	                }
	            }
	        }
	        /**
	         * Digs into an an initializer or RHS operand of an assignment operation
	         * to get the parameters of an apt signature corresponding to a
	         * function expression or a class expression.
	         *
	         * @param rightHandSide the expression which may contain an appropriate set of parameters
	         * @returns the parameters of a signature found on the RHS if one exists; otherwise 'emptyArray'.
	         */
	        function getParametersFromRightHandSideOfAssignment(rightHandSide) {
	            while (rightHandSide.kind === 189 /* ParenthesizedExpression */) {
	                rightHandSide = rightHandSide.expression;
	            }
	            switch (rightHandSide.kind) {
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                    return rightHandSide.parameters;
	                case 203 /* ClassExpression */:
	                    for (var _i = 0, _a = rightHandSide.members; _i < _a.length; _i++) {
	                        var member = _a[_i];
	                        if (member.kind === 154 /* Constructor */) {
	                            return member.parameters;
	                        }
	                    }
	                    break;
	            }
	            return ts.emptyArray;
	        }
	    })(JsDoc = ts.JsDoc || (ts.JsDoc = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function stringToInt(str) {
	        var n = parseInt(str, 10);
	        if (isNaN(n)) {
	            throw new Error("Error in parseInt(" + JSON.stringify(str) + ")");
	        }
	        return n;
	    }
	    var isPrereleaseRegex = /^(.*)-next.\d+/;
	    var prereleaseSemverRegex = /^(\d+)\.(\d+)\.0-next.(\d+)$/;
	    var semverRegex = /^(\d+)\.(\d+)\.(\d+)$/;
	    var Semver = /** @class */ (function () {
	        function Semver(major, minor, patch, 
	        /**
	         * If true, this is `major.minor.0-next.patch`.
	         * If false, this is `major.minor.patch`.
	         */
	        isPrerelease) {
	            this.major = major;
	            this.minor = minor;
	            this.patch = patch;
	            this.isPrerelease = isPrerelease;
	        }
	        Semver.parse = function (semver) {
	            var isPrerelease = isPrereleaseRegex.test(semver);
	            var result = Semver.tryParse(semver, isPrerelease);
	            if (!result) {
	                throw new Error("Unexpected semver: " + semver + " (isPrerelease: " + isPrerelease + ")");
	            }
	            return result;
	        };
	        Semver.fromRaw = function (_a) {
	            var major = _a.major, minor = _a.minor, patch = _a.patch, isPrerelease = _a.isPrerelease;
	            return new Semver(major, minor, patch, isPrerelease);
	        };
	        // This must parse the output of `versionString`.
	        Semver.tryParse = function (semver, isPrerelease) {
	            // Per the semver spec <http://semver.org/#spec-item-2>:
	            // "A normal version number MUST take the form X.Y.Z where X, Y, and Z are non-negative integers, and MUST NOT contain leading zeroes."
	            var rgx = isPrerelease ? prereleaseSemverRegex : semverRegex;
	            var match = rgx.exec(semver);
	            return match ? new Semver(stringToInt(match[1]), stringToInt(match[2]), stringToInt(match[3]), isPrerelease) : undefined;
	        };
	        Object.defineProperty(Semver.prototype, "versionString", {
	            get: function () {
	                return this.isPrerelease ? this.major + "." + this.minor + ".0-next." + this.patch : this.major + "." + this.minor + "." + this.patch;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Semver.prototype.equals = function (sem) {
	            return this.major === sem.major && this.minor === sem.minor && this.patch === sem.patch && this.isPrerelease === sem.isPrerelease;
	        };
	        Semver.prototype.greaterThan = function (sem) {
	            return this.major > sem.major || this.major === sem.major
	                && (this.minor > sem.minor || this.minor === sem.minor
	                    && (!this.isPrerelease && sem.isPrerelease || this.isPrerelease === sem.isPrerelease
	                        && this.patch > sem.patch));
	        };
	        return Semver;
	    }());
	    ts.Semver = Semver;
	})(ts || (ts = {}));
	// Copyright (c) Microsoft. All rights reserved. Licensed under the Apache License, Version 2.0.
	// See LICENSE.txt in the project root for complete license information.
	/// <reference path='../compiler/types.ts' />
	/// <reference path='../compiler/core.ts' />
	/// <reference path='../compiler/commandLineParser.ts' />
	/// <reference path='../services/semver.ts' />
	/* @internal */
	var ts;
	(function (ts) {
	    var JsTyping;
	    (function (JsTyping) {
	        /* @internal */
	        function isTypingUpToDate(cachedTyping, availableTypingVersions) {
	            var availableVersion = ts.Semver.parse(ts.getProperty(availableTypingVersions, "ts" + ts.versionMajorMinor) || ts.getProperty(availableTypingVersions, "latest"));
	            return !availableVersion.greaterThan(cachedTyping.version);
	        }
	        JsTyping.isTypingUpToDate = isTypingUpToDate;
	        /* @internal */
	        JsTyping.nodeCoreModuleList = [
	            "buffer", "querystring", "events", "http", "cluster",
	            "zlib", "os", "https", "punycode", "repl", "readline",
	            "vm", "child_process", "url", "dns", "net",
	            "dgram", "fs", "path", "string_decoder", "tls",
	            "crypto", "stream", "util", "assert", "tty", "domain",
	            "constants", "process", "v8", "timers", "console"
	        ];
	        var nodeCoreModules = ts.arrayToSet(JsTyping.nodeCoreModuleList);
	        function loadSafeList(host, safeListPath) {
	            var result = ts.readConfigFile(safeListPath, function (path) { return host.readFile(path); });
	            return ts.createMapFromTemplate(result.config);
	        }
	        JsTyping.loadSafeList = loadSafeList;
	        function loadTypesMap(host, typesMapPath) {
	            var result = ts.readConfigFile(typesMapPath, function (path) { return host.readFile(path); });
	            if (result.config) {
	                return ts.createMapFromTemplate(result.config.simpleMap);
	            }
	            return undefined;
	        }
	        JsTyping.loadTypesMap = loadTypesMap;
	        /**
	         * @param host is the object providing I/O related operations.
	         * @param fileNames are the file names that belong to the same project
	         * @param projectRootPath is the path to the project root directory
	         * @param safeListPath is the path used to retrieve the safe list
	         * @param packageNameToTypingLocation is the map of package names to their cached typing locations and installed versions
	         * @param typeAcquisition is used to customize the typing acquisition process
	         * @param compilerOptions are used as a source for typing inference
	         */
	        function discoverTypings(host, log, fileNames, projectRootPath, safeList, packageNameToTypingLocation, typeAcquisition, unresolvedImports, typesRegistry) {
	            if (!typeAcquisition || !typeAcquisition.enable) {
	                return { cachedTypingPaths: [], newTypingNames: [], filesToWatch: [] };
	            }
	            // A typing name to typing file path mapping
	            var inferredTypings = ts.createMap();
	            // Only infer typings for .js and .jsx files
	            fileNames = ts.mapDefined(fileNames, function (fileName) {
	                var path = ts.normalizePath(fileName);
	                if (ts.hasJavaScriptFileExtension(path)) {
	                    return path;
	                }
	            });
	            var filesToWatch = [];
	            if (typeAcquisition.include)
	                addInferredTypings(typeAcquisition.include, "Explicitly included types");
	            var exclude = typeAcquisition.exclude || [];
	            // Directories to search for package.json, bower.json and other typing information
	            var possibleSearchDirs = ts.arrayToSet(fileNames, ts.getDirectoryPath);
	            possibleSearchDirs.set(projectRootPath, true);
	            possibleSearchDirs.forEach(function (_true, searchDir) {
	                var packageJsonPath = ts.combinePaths(searchDir, "package.json");
	                getTypingNamesFromJson(packageJsonPath, filesToWatch);
	                var bowerJsonPath = ts.combinePaths(searchDir, "bower.json");
	                getTypingNamesFromJson(bowerJsonPath, filesToWatch);
	                var bowerComponentsPath = ts.combinePaths(searchDir, "bower_components");
	                getTypingNamesFromPackagesFolder(bowerComponentsPath, filesToWatch);
	                var nodeModulesPath = ts.combinePaths(searchDir, "node_modules");
	                getTypingNamesFromPackagesFolder(nodeModulesPath, filesToWatch);
	            });
	            getTypingNamesFromSourceFileNames(fileNames);
	            // add typings for unresolved imports
	            if (unresolvedImports) {
	                var module = ts.deduplicate(unresolvedImports.map(function (moduleId) { return nodeCoreModules.has(moduleId) ? "node" : moduleId; }), ts.equateStringsCaseSensitive, ts.compareStringsCaseSensitive);
	                addInferredTypings(module, "Inferred typings from unresolved imports");
	            }
	            // Add the cached typing locations for inferred typings that are already installed
	            packageNameToTypingLocation.forEach(function (typing, name) {
	                if (inferredTypings.has(name) && inferredTypings.get(name) === undefined && isTypingUpToDate(typing, typesRegistry.get(name))) {
	                    inferredTypings.set(name, typing.typingLocation);
	                }
	            });
	            // Remove typings that the user has added to the exclude list
	            for (var _i = 0, exclude_1 = exclude; _i < exclude_1.length; _i++) {
	                var excludeTypingName = exclude_1[_i];
	                var didDelete = inferredTypings.delete(excludeTypingName);
	                if (didDelete && log)
	                    log("Typing for " + excludeTypingName + " is in exclude list, will be ignored.");
	            }
	            var newTypingNames = [];
	            var cachedTypingPaths = [];
	            inferredTypings.forEach(function (inferred, typing) {
	                if (inferred !== undefined) {
	                    cachedTypingPaths.push(inferred);
	                }
	                else {
	                    newTypingNames.push(typing);
	                }
	            });
	            var result = { cachedTypingPaths: cachedTypingPaths, newTypingNames: newTypingNames, filesToWatch: filesToWatch };
	            if (log)
	                log("Result: " + JSON.stringify(result));
	            return result;
	            function addInferredTyping(typingName) {
	                if (!inferredTypings.has(typingName)) {
	                    inferredTypings.set(typingName, undefined);
	                }
	            }
	            function addInferredTypings(typingNames, message) {
	                if (log)
	                    log(message + ": " + JSON.stringify(typingNames));
	                ts.forEach(typingNames, addInferredTyping);
	            }
	            /**
	             * Get the typing info from common package manager json files like package.json or bower.json
	             */
	            function getTypingNamesFromJson(jsonPath, filesToWatch) {
	                if (!host.fileExists(jsonPath)) {
	                    return;
	                }
	                filesToWatch.push(jsonPath);
	                var jsonConfig = ts.readConfigFile(jsonPath, function (path) { return host.readFile(path); }).config;
	                var jsonTypingNames = ts.flatMap([jsonConfig.dependencies, jsonConfig.devDependencies, jsonConfig.optionalDependencies, jsonConfig.peerDependencies], ts.getOwnKeys);
	                addInferredTypings(jsonTypingNames, "Typing names in '" + jsonPath + "' dependencies");
	            }
	            /**
	             * Infer typing names from given file names. For example, the file name "jquery-min.2.3.4.js"
	             * should be inferred to the 'jquery' typing name; and "angular-route.1.2.3.js" should be inferred
	             * to the 'angular-route' typing name.
	             * @param fileNames are the names for source files in the project
	             */
	            function getTypingNamesFromSourceFileNames(fileNames) {
	                var fromFileNames = ts.mapDefined(fileNames, function (j) {
	                    if (!ts.hasJavaScriptFileExtension(j))
	                        return undefined;
	                    var inferredTypingName = ts.removeFileExtension(ts.getBaseFileName(j.toLowerCase()));
	                    var cleanedTypingName = ts.removeMinAndVersionNumbers(inferredTypingName);
	                    return safeList.get(cleanedTypingName);
	                });
	                if (fromFileNames.length) {
	                    addInferredTypings(fromFileNames, "Inferred typings from file names");
	                }
	                var hasJsxFile = ts.some(fileNames, function (f) { return ts.fileExtensionIs(f, ".jsx" /* Jsx */); });
	                if (hasJsxFile) {
	                    if (log)
	                        log("Inferred 'react' typings due to presence of '.jsx' extension");
	                    addInferredTyping("react");
	                }
	            }
	            /**
	             * Infer typing names from packages folder (ex: node_module, bower_components)
	             * @param packagesFolderPath is the path to the packages folder
	             */
	            function getTypingNamesFromPackagesFolder(packagesFolderPath, filesToWatch) {
	                filesToWatch.push(packagesFolderPath);
	                // Todo: add support for ModuleResolutionHost too
	                if (!host.directoryExists(packagesFolderPath)) {
	                    return;
	                }
	                // depth of 2, so we access `node_modules/foo` but not `node_modules/foo/bar`
	                var fileNames = host.readDirectory(packagesFolderPath, [".json" /* Json */], /*excludes*/ undefined, /*includes*/ undefined, /*depth*/ 2);
	                if (log)
	                    log("Searching for typing names in " + packagesFolderPath + "; all files: " + JSON.stringify(fileNames));
	                var packageNames = [];
	                for (var _i = 0, fileNames_1 = fileNames; _i < fileNames_1.length; _i++) {
	                    var fileName = fileNames_1[_i];
	                    var normalizedFileName = ts.normalizePath(fileName);
	                    var baseFileName = ts.getBaseFileName(normalizedFileName);
	                    if (baseFileName !== "package.json" && baseFileName !== "bower.json") {
	                        continue;
	                    }
	                    var result_5 = ts.readConfigFile(normalizedFileName, function (path) { return host.readFile(path); });
	                    var packageJson = result_5.config;
	                    // npm 3's package.json contains a "_requiredBy" field
	                    // we should include all the top level module names for npm 2, and only module names whose
	                    // "_requiredBy" field starts with "#" or equals "/" for npm 3.
	                    if (baseFileName === "package.json" && packageJson._requiredBy &&
	                        ts.filter(packageJson._requiredBy, function (r) { return r[0] === "#" || r === "/"; }).length === 0) {
	                        continue;
	                    }
	                    // If the package has its own d.ts typings, those will take precedence. Otherwise the package name will be used
	                    // to download d.ts files from DefinitelyTyped
	                    if (!packageJson.name) {
	                        continue;
	                    }
	                    var ownTypes = packageJson.types || packageJson.typings;
	                    if (ownTypes) {
	                        var absolutePath = ts.getNormalizedAbsolutePath(ownTypes, ts.getDirectoryPath(normalizedFileName));
	                        if (log)
	                            log("    Package '" + packageJson.name + "' provides its own types.");
	                        inferredTypings.set(packageJson.name, absolutePath);
	                    }
	                    else {
	                        packageNames.push(packageJson.name);
	                    }
	                }
	                addInferredTypings(packageNames, "    Found package names");
	            }
	        }
	        JsTyping.discoverTypings = discoverTypings;
	        var PackageNameValidationResult;
	        (function (PackageNameValidationResult) {
	            PackageNameValidationResult[PackageNameValidationResult["Ok"] = 0] = "Ok";
	            PackageNameValidationResult[PackageNameValidationResult["ScopedPackagesNotSupported"] = 1] = "ScopedPackagesNotSupported";
	            PackageNameValidationResult[PackageNameValidationResult["EmptyName"] = 2] = "EmptyName";
	            PackageNameValidationResult[PackageNameValidationResult["NameTooLong"] = 3] = "NameTooLong";
	            PackageNameValidationResult[PackageNameValidationResult["NameStartsWithDot"] = 4] = "NameStartsWithDot";
	            PackageNameValidationResult[PackageNameValidationResult["NameStartsWithUnderscore"] = 5] = "NameStartsWithUnderscore";
	            PackageNameValidationResult[PackageNameValidationResult["NameContainsNonURISafeCharacters"] = 6] = "NameContainsNonURISafeCharacters";
	        })(PackageNameValidationResult = JsTyping.PackageNameValidationResult || (JsTyping.PackageNameValidationResult = {}));
	        var maxPackageNameLength = 214;
	        /**
	         * Validates package name using rules defined at https://docs.npmjs.com/files/package.json
	         */
	        function validatePackageName(packageName) {
	            if (!packageName) {
	                return 2 /* EmptyName */;
	            }
	            if (packageName.length > maxPackageNameLength) {
	                return 3 /* NameTooLong */;
	            }
	            if (packageName.charCodeAt(0) === 46 /* dot */) {
	                return 4 /* NameStartsWithDot */;
	            }
	            if (packageName.charCodeAt(0) === 95 /* _ */) {
	                return 5 /* NameStartsWithUnderscore */;
	            }
	            // check if name is scope package like: starts with @ and has one '/' in the middle
	            // scoped packages are not currently supported
	            // TODO: when support will be added we'll need to split and check both scope and package name
	            if (/^@[^/]+\/[^/]+$/.test(packageName)) {
	                return 1 /* ScopedPackagesNotSupported */;
	            }
	            if (encodeURIComponent(packageName) !== packageName) {
	                return 6 /* NameContainsNonURISafeCharacters */;
	            }
	            return 0 /* Ok */;
	        }
	        JsTyping.validatePackageName = validatePackageName;
	        function renderPackageNameValidationFailure(result, typing) {
	            switch (result) {
	                case 2 /* EmptyName */:
	                    return "Package name '" + typing + "' cannot be empty";
	                case 3 /* NameTooLong */:
	                    return "Package name '" + typing + "' should be less than " + maxPackageNameLength + " characters";
	                case 4 /* NameStartsWithDot */:
	                    return "Package name '" + typing + "' cannot start with '.'";
	                case 5 /* NameStartsWithUnderscore */:
	                    return "Package name '" + typing + "' cannot start with '_'";
	                case 1 /* ScopedPackagesNotSupported */:
	                    return "Package '" + typing + "' is scoped and currently is not supported";
	                case 6 /* NameContainsNonURISafeCharacters */:
	                    return "Package name '" + typing + "' contains non URI safe characters";
	                case 0 /* Ok */:
	                    throw ts.Debug.fail(); // Shouldn't have called this.
	                default:
	                    ts.Debug.assertNever(result);
	            }
	        }
	        JsTyping.renderPackageNameValidationFailure = renderPackageNameValidationFailure;
	    })(JsTyping = ts.JsTyping || (ts.JsTyping = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var NavigateTo;
	    (function (NavigateTo) {
	        function getNavigateToItems(sourceFiles, checker, cancellationToken, searchValue, maxResultCount, excludeDtsFiles) {
	            var patternMatcher = ts.createPatternMatcher(searchValue);
	            var rawItems = [];
	            var _loop_8 = function (sourceFile) {
	                cancellationToken.throwIfCancellationRequested();
	                if (excludeDtsFiles && ts.fileExtensionIs(sourceFile.fileName, ".d.ts" /* Dts */)) {
	                    return "continue";
	                }
	                ts.forEachEntry(sourceFile.getNamedDeclarations(), function (declarations, name) {
	                    getItemsFromNamedDeclaration(patternMatcher, name, declarations, checker, sourceFile.fileName, rawItems);
	                });
	            };
	            // Search the declarations in all files and output matched NavigateToItem into array of NavigateToItem[]
	            for (var _i = 0, sourceFiles_6 = sourceFiles; _i < sourceFiles_6.length; _i++) {
	                var sourceFile = sourceFiles_6[_i];
	                _loop_8(sourceFile);
	            }
	            rawItems.sort(compareNavigateToItems);
	            if (maxResultCount !== undefined) {
	                rawItems = rawItems.slice(0, maxResultCount);
	            }
	            return rawItems.map(createNavigateToItem);
	        }
	        NavigateTo.getNavigateToItems = getNavigateToItems;
	        function getItemsFromNamedDeclaration(patternMatcher, name, declarations, checker, fileName, rawItems) {
	            // First do a quick check to see if the name of the declaration matches the
	            // last portion of the (possibly) dotted name they're searching for.
	            var matches = patternMatcher.getMatchesForLastSegmentOfPattern(name);
	            if (!matches) {
	                return; // continue to next named declarations
	            }
	            for (var _i = 0, declarations_11 = declarations; _i < declarations_11.length; _i++) {
	                var declaration = declarations_11[_i];
	                if (!shouldKeepItem(declaration, checker)) {
	                    continue;
	                }
	                // It was a match! If the pattern has dots in it, then also see if the
	                // declaration container matches as well.
	                var containerMatches = matches;
	                if (patternMatcher.patternContainsDots) {
	                    containerMatches = patternMatcher.getMatches(getContainers(declaration), name);
	                    if (!containerMatches) {
	                        continue;
	                    }
	                }
	                var matchKind = bestMatchKind(containerMatches);
	                var isCaseSensitive = allMatchesAreCaseSensitive(containerMatches);
	                rawItems.push({ name: name, fileName: fileName, matchKind: matchKind, isCaseSensitive: isCaseSensitive, declaration: declaration });
	            }
	        }
	        function shouldKeepItem(declaration, checker) {
	            switch (declaration.kind) {
	                case 243 /* ImportClause */:
	                case 246 /* ImportSpecifier */:
	                case 241 /* ImportEqualsDeclaration */:
	                    var importer = checker.getSymbolAtLocation(declaration.name);
	                    var imported = checker.getAliasedSymbol(importer);
	                    return importer.escapedName !== imported.escapedName;
	                default:
	                    return true;
	            }
	        }
	        function allMatchesAreCaseSensitive(matches) {
	            ts.Debug.assert(matches.length > 0);
	            // This is a case sensitive match, only if all the submatches were case sensitive.
	            for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
	                var match = matches_1[_i];
	                if (!match.isCaseSensitive) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        function tryAddSingleDeclarationName(declaration, containers) {
	            var name = ts.getNameOfDeclaration(declaration);
	            if (name && ts.isPropertyNameLiteral(name)) {
	                containers.unshift(ts.getTextOfIdentifierOrLiteral(name));
	                return true;
	            }
	            else if (name && name.kind === 146 /* ComputedPropertyName */) {
	                return tryAddComputedPropertyName(name.expression, containers, /*includeLastPortion*/ true);
	            }
	            else {
	                // Don't know how to add this.
	                return false;
	            }
	        }
	        // Only added the names of computed properties if they're simple dotted expressions, like:
	        //
	        //      [X.Y.Z]() { }
	        function tryAddComputedPropertyName(expression, containers, includeLastPortion) {
	            if (ts.isPropertyNameLiteral(expression)) {
	                var text = ts.getTextOfIdentifierOrLiteral(expression);
	                if (includeLastPortion) {
	                    containers.unshift(text);
	                }
	                return true;
	            }
	            if (ts.isPropertyAccessExpression(expression)) {
	                if (includeLastPortion) {
	                    containers.unshift(expression.name.text);
	                }
	                return tryAddComputedPropertyName(expression.expression, containers, /*includeLastPortion*/ true);
	            }
	            return false;
	        }
	        function getContainers(declaration) {
	            var containers = [];
	            // First, if we started with a computed property name, then add all but the last
	            // portion into the container array.
	            var name = ts.getNameOfDeclaration(declaration);
	            if (name.kind === 146 /* ComputedPropertyName */) {
	                if (!tryAddComputedPropertyName(name.expression, containers, /*includeLastPortion*/ false)) {
	                    return undefined;
	                }
	            }
	            // Now, walk up our containers, adding all their names to the container array.
	            declaration = ts.getContainerNode(declaration);
	            while (declaration) {
	                if (!tryAddSingleDeclarationName(declaration, containers)) {
	                    return undefined;
	                }
	                declaration = ts.getContainerNode(declaration);
	            }
	            return containers;
	        }
	        function bestMatchKind(matches) {
	            ts.Debug.assert(matches.length > 0);
	            var bestMatchKind = ts.PatternMatchKind.camelCase;
	            for (var _i = 0, matches_2 = matches; _i < matches_2.length; _i++) {
	                var match = matches_2[_i];
	                var kind = match.kind;
	                if (kind < bestMatchKind) {
	                    bestMatchKind = kind;
	                }
	            }
	            return bestMatchKind;
	        }
	        function compareNavigateToItems(i1, i2) {
	            // TODO(cyrusn): get the gamut of comparisons that VS already uses here.
	            return ts.compareValues(i1.matchKind, i2.matchKind)
	                || ts.compareStringsCaseSensitiveUI(i1.name, i2.name);
	        }
	        function createNavigateToItem(rawItem) {
	            var declaration = rawItem.declaration;
	            var container = ts.getContainerNode(declaration);
	            var containerName = container && ts.getNameOfDeclaration(container);
	            return {
	                name: rawItem.name,
	                kind: ts.getNodeKind(declaration),
	                kindModifiers: ts.getNodeModifiers(declaration),
	                matchKind: ts.PatternMatchKind[rawItem.matchKind],
	                isCaseSensitive: rawItem.isCaseSensitive,
	                fileName: rawItem.fileName,
	                textSpan: ts.createTextSpanFromNode(declaration),
	                // TODO(jfreeman): What should be the containerName when the container has a computed name?
	                containerName: containerName ? containerName.text : "",
	                containerKind: containerName ? ts.getNodeKind(container) : "" /* unknown */
	            };
	        }
	    })(NavigateTo = ts.NavigateTo || (ts.NavigateTo = {}));
	})(ts || (ts = {}));
	/// <reference path='services.ts' />
	/* @internal */
	var ts;
	(function (ts) {
	    var NavigationBar;
	    (function (NavigationBar) {
	        /**
	         * Matches all whitespace characters in a string. Eg:
	         *
	         * "app.
	         *
	         * onactivated"
	         *
	         * matches because of the newline, whereas
	         *
	         * "app.onactivated"
	         *
	         * does not match.
	         */
	        var whiteSpaceRegex = /\s+/g;
	        // Keep sourceFile handy so we don't have to search for it every time we need to call `getText`.
	        var curCancellationToken;
	        var curSourceFile;
	        /**
	         * For performance, we keep navigation bar parents on a stack rather than passing them through each recursion.
	         * `parent` is the current parent and is *not* stored in parentsStack.
	         * `startNode` sets a new parent and `endNode` returns to the previous parent.
	         */
	        var parentsStack = [];
	        var parent;
	        // NavigationBarItem requires an array, but will not mutate it, so just give it this for performance.
	        var emptyChildItemArray = [];
	        function getNavigationBarItems(sourceFile, cancellationToken) {
	            curCancellationToken = cancellationToken;
	            curSourceFile = sourceFile;
	            try {
	                return ts.map(topLevelItems(rootNavigationBarNode(sourceFile)), convertToTopLevelItem);
	            }
	            finally {
	                reset();
	            }
	        }
	        NavigationBar.getNavigationBarItems = getNavigationBarItems;
	        function getNavigationTree(sourceFile, cancellationToken) {
	            curCancellationToken = cancellationToken;
	            curSourceFile = sourceFile;
	            try {
	                return convertToTree(rootNavigationBarNode(sourceFile));
	            }
	            finally {
	                reset();
	            }
	        }
	        NavigationBar.getNavigationTree = getNavigationTree;
	        function reset() {
	            curSourceFile = undefined;
	            curCancellationToken = undefined;
	            parentsStack = [];
	            parent = undefined;
	            emptyChildItemArray = [];
	        }
	        function nodeText(node) {
	            return node.getText(curSourceFile);
	        }
	        function navigationBarNodeKind(n) {
	            return n.node.kind;
	        }
	        function pushChild(parent, child) {
	            if (parent.children) {
	                parent.children.push(child);
	            }
	            else {
	                parent.children = [child];
	            }
	        }
	        function rootNavigationBarNode(sourceFile) {
	            ts.Debug.assert(!parentsStack.length);
	            var root = { node: sourceFile, additionalNodes: undefined, parent: undefined, children: undefined, indent: 0 };
	            parent = root;
	            for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	                var statement = _a[_i];
	                addChildrenRecursively(statement);
	            }
	            endNode();
	            ts.Debug.assert(!parent && !parentsStack.length);
	            return root;
	        }
	        function addLeafNode(node) {
	            pushChild(parent, emptyNavigationBarNode(node));
	        }
	        function emptyNavigationBarNode(node) {
	            return {
	                node: node,
	                additionalNodes: undefined,
	                parent: parent,
	                children: undefined,
	                indent: parent.indent + 1
	            };
	        }
	        /**
	         * Add a new level of NavigationBarNodes.
	         * This pushes to the stack, so you must call `endNode` when you are done adding to this node.
	         */
	        function startNode(node) {
	            var navNode = emptyNavigationBarNode(node);
	            pushChild(parent, navNode);
	            // Save the old parent
	            parentsStack.push(parent);
	            parent = navNode;
	        }
	        /** Call after calling `startNode` and adding children to it. */
	        function endNode() {
	            if (parent.children) {
	                mergeChildren(parent.children);
	                sortChildren(parent.children);
	            }
	            parent = parentsStack.pop();
	        }
	        function addNodeWithRecursiveChild(node, child) {
	            startNode(node);
	            addChildrenRecursively(child);
	            endNode();
	        }
	        /** Look for navigation bar items in node's subtree, adding them to the current `parent`. */
	        function addChildrenRecursively(node) {
	            curCancellationToken.throwIfCancellationRequested();
	            if (!node || ts.isToken(node)) {
	                return;
	            }
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                    // Get parameter properties, and treat them as being on the *same* level as the constructor, not under it.
	                    var ctr = node;
	                    addNodeWithRecursiveChild(ctr, ctr.body);
	                    // Parameter properties are children of the class, not the constructor.
	                    for (var _i = 0, _a = ctr.parameters; _i < _a.length; _i++) {
	                        var param = _a[_i];
	                        if (ts.isParameterPropertyDeclaration(param)) {
	                            addLeafNode(param);
	                        }
	                    }
	                    break;
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 152 /* MethodSignature */:
	                    if (!ts.hasDynamicName(node)) {
	                        addNodeWithRecursiveChild(node, node.body);
	                    }
	                    break;
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    if (!ts.hasDynamicName(node)) {
	                        addLeafNode(node);
	                    }
	                    break;
	                case 243 /* ImportClause */:
	                    var importClause = node;
	                    // Handle default import case e.g.:
	                    //    import d from "mod";
	                    if (importClause.name) {
	                        addLeafNode(importClause);
	                    }
	                    // Handle named bindings in imports e.g.:
	                    //    import * as NS from "mod";
	                    //    import {a, b as B} from "mod";
	                    var namedBindings = importClause.namedBindings;
	                    if (namedBindings) {
	                        if (namedBindings.kind === 244 /* NamespaceImport */) {
	                            addLeafNode(namedBindings);
	                        }
	                        else {
	                            for (var _b = 0, _c = namedBindings.elements; _b < _c.length; _b++) {
	                                var element = _c[_b];
	                                addLeafNode(element);
	                            }
	                        }
	                    }
	                    break;
	                case 180 /* BindingElement */:
	                case 230 /* VariableDeclaration */:
	                    var _d = node, name = _d.name, initializer = _d.initializer;
	                    if (ts.isBindingPattern(name)) {
	                        addChildrenRecursively(name);
	                    }
	                    else if (initializer && isFunctionOrClassExpression(initializer)) {
	                        if (initializer.name) {
	                            // Don't add a node for the VariableDeclaration, just for the initializer.
	                            addChildrenRecursively(initializer);
	                        }
	                        else {
	                            // Add a node for the VariableDeclaration, but not for the initializer.
	                            startNode(node);
	                            ts.forEachChild(initializer, addChildrenRecursively);
	                            endNode();
	                        }
	                    }
	                    else {
	                        addNodeWithRecursiveChild(node, initializer);
	                    }
	                    break;
	                case 191 /* ArrowFunction */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                    addNodeWithRecursiveChild(node, node.body);
	                    break;
	                case 236 /* EnumDeclaration */:
	                    startNode(node);
	                    for (var _e = 0, _f = node.members; _e < _f.length; _e++) {
	                        var member = _f[_e];
	                        if (!isComputedProperty(member)) {
	                            addLeafNode(member);
	                        }
	                    }
	                    endNode();
	                    break;
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                case 234 /* InterfaceDeclaration */:
	                    startNode(node);
	                    for (var _g = 0, _h = node.members; _g < _h.length; _g++) {
	                        var member = _h[_g];
	                        addChildrenRecursively(member);
	                    }
	                    endNode();
	                    break;
	                case 237 /* ModuleDeclaration */:
	                    addNodeWithRecursiveChild(node, getInteriorModule(node).body);
	                    break;
	                case 250 /* ExportSpecifier */:
	                case 241 /* ImportEqualsDeclaration */:
	                case 159 /* IndexSignature */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 235 /* TypeAliasDeclaration */:
	                    addLeafNode(node);
	                    break;
	                case 198 /* BinaryExpression */: {
	                    var special = ts.getSpecialPropertyAssignmentKind(node);
	                    switch (special) {
	                        case 1 /* ExportsProperty */:
	                        case 2 /* ModuleExports */:
	                        case 3 /* PrototypeProperty */:
	                            addNodeWithRecursiveChild(node, node.right);
	                            break;
	                        case 4 /* ThisProperty */:
	                        case 5 /* Property */:
	                        case 0 /* None */:
	                            break;
	                        default:
	                            ts.Debug.assertNever(special);
	                    }
	                }
	                // falls through
	                default:
	                    if (ts.hasJSDocNodes(node)) {
	                        ts.forEach(node.jsDoc, function (jsDoc) {
	                            ts.forEach(jsDoc.tags, function (tag) {
	                                if (tag.kind === 291 /* JSDocTypedefTag */) {
	                                    addLeafNode(tag);
	                                }
	                            });
	                        });
	                    }
	                    ts.forEachChild(node, addChildrenRecursively);
	            }
	        }
	        /** Merge declarations of the same kind. */
	        function mergeChildren(children) {
	            var nameToItems = ts.createMap();
	            ts.filterMutate(children, function (child) {
	                var declName = ts.getNameOfDeclaration(child.node);
	                var name = declName && nodeText(declName);
	                if (!name) {
	                    // Anonymous items are never merged.
	                    return true;
	                }
	                var itemsWithSameName = nameToItems.get(name);
	                if (!itemsWithSameName) {
	                    nameToItems.set(name, child);
	                    return true;
	                }
	                if (itemsWithSameName instanceof Array) {
	                    for (var _i = 0, itemsWithSameName_1 = itemsWithSameName; _i < itemsWithSameName_1.length; _i++) {
	                        var itemWithSameName = itemsWithSameName_1[_i];
	                        if (tryMerge(itemWithSameName, child)) {
	                            return false;
	                        }
	                    }
	                    itemsWithSameName.push(child);
	                    return true;
	                }
	                else {
	                    var itemWithSameName = itemsWithSameName;
	                    if (tryMerge(itemWithSameName, child)) {
	                        return false;
	                    }
	                    nameToItems.set(name, [itemWithSameName, child]);
	                    return true;
	                }
	            });
	        }
	        function tryMerge(a, b) {
	            if (shouldReallyMerge(a.node, b.node)) {
	                merge(a, b);
	                return true;
	            }
	            return false;
	        }
	        /** a and b have the same name, but they may not be mergeable. */
	        function shouldReallyMerge(a, b) {
	            if (a.kind !== b.kind) {
	                return false;
	            }
	            switch (a.kind) {
	                case 151 /* PropertyDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return ts.hasModifier(a, 32 /* Static */) === ts.hasModifier(b, 32 /* Static */);
	                case 237 /* ModuleDeclaration */:
	                    return areSameModule(a, b);
	                default:
	                    return true;
	            }
	        }
	        // We use 1 NavNode to represent 'A.B.C', but there are multiple source nodes.
	        // Only merge module nodes that have the same chain. Don't merge 'A.B.C' with 'A'!
	        function areSameModule(a, b) {
	            return a.body.kind === b.body.kind && (a.body.kind !== 237 /* ModuleDeclaration */ || areSameModule(a.body, b.body));
	        }
	        /** Merge source into target. Source should be thrown away after this is called. */
	        function merge(target, source) {
	            target.additionalNodes = target.additionalNodes || [];
	            target.additionalNodes.push(source.node);
	            if (source.additionalNodes) {
	                (_a = target.additionalNodes).push.apply(_a, source.additionalNodes);
	            }
	            target.children = ts.concatenate(target.children, source.children);
	            if (target.children) {
	                mergeChildren(target.children);
	                sortChildren(target.children);
	            }
	            var _a;
	        }
	        /** Recursively ensure that each NavNode's children are in sorted order. */
	        function sortChildren(children) {
	            children.sort(compareChildren);
	        }
	        function compareChildren(child1, child2) {
	            return ts.compareStringsCaseSensitiveUI(tryGetName(child1.node), tryGetName(child2.node))
	                || ts.compareValues(navigationBarNodeKind(child1), navigationBarNodeKind(child2));
	        }
	        /**
	         * This differs from getItemName because this is just used for sorting.
	         * We only sort nodes by name that have a more-or-less "direct" name, as opposed to `new()` and the like.
	         * So `new()` can still come before an `aardvark` method.
	         */
	        function tryGetName(node) {
	            if (node.kind === 237 /* ModuleDeclaration */) {
	                return getModuleName(node);
	            }
	            var declName = ts.getNameOfDeclaration(node);
	            if (declName) {
	                return ts.unescapeLeadingUnderscores(ts.getPropertyNameForPropertyNameNode(declName));
	            }
	            switch (node.kind) {
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                case 203 /* ClassExpression */:
	                    return getFunctionOrClassName(node);
	                case 291 /* JSDocTypedefTag */:
	                    return getJSDocTypedefTagName(node);
	                default:
	                    return undefined;
	            }
	        }
	        function getItemName(node) {
	            if (node.kind === 237 /* ModuleDeclaration */) {
	                return getModuleName(node);
	            }
	            var name = ts.getNameOfDeclaration(node);
	            if (name) {
	                var text = nodeText(name);
	                if (text.length > 0) {
	                    return text;
	                }
	            }
	            switch (node.kind) {
	                case 272 /* SourceFile */:
	                    var sourceFile = node;
	                    return ts.isExternalModule(sourceFile)
	                        ? "\"" + ts.escapeString(ts.getBaseFileName(ts.removeFileExtension(ts.normalizePath(sourceFile.fileName)))) + "\""
	                        : "<global>";
	                case 191 /* ArrowFunction */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                    if (ts.getModifierFlags(node) & 512 /* Default */) {
	                        return "default";
	                    }
	                    // We may get a string with newlines or other whitespace in the case of an object dereference
	                    // (eg: "app\n.onactivated"), so we should remove the whitespace for readabiltiy in the
	                    // navigation bar.
	                    return getFunctionOrClassName(node);
	                case 154 /* Constructor */:
	                    return "constructor";
	                case 158 /* ConstructSignature */:
	                    return "new()";
	                case 157 /* CallSignature */:
	                    return "()";
	                case 159 /* IndexSignature */:
	                    return "[]";
	                case 291 /* JSDocTypedefTag */:
	                    return getJSDocTypedefTagName(node);
	                default:
	                    return "<unknown>";
	            }
	        }
	        function getJSDocTypedefTagName(node) {
	            if (node.name) {
	                return node.name.text;
	            }
	            else {
	                var parentNode = node.parent && node.parent.parent;
	                if (parentNode && parentNode.kind === 212 /* VariableStatement */) {
	                    if (parentNode.declarationList.declarations.length > 0) {
	                        var nameIdentifier = parentNode.declarationList.declarations[0].name;
	                        if (nameIdentifier.kind === 71 /* Identifier */) {
	                            return nameIdentifier.text;
	                        }
	                    }
	                }
	                return "<typedef>";
	            }
	        }
	        /** Flattens the NavNode tree to a list, keeping only the top-level items. */
	        function topLevelItems(root) {
	            var topLevel = [];
	            function recur(item) {
	                if (isTopLevel(item)) {
	                    topLevel.push(item);
	                    if (item.children) {
	                        for (var _i = 0, _a = item.children; _i < _a.length; _i++) {
	                            var child = _a[_i];
	                            recur(child);
	                        }
	                    }
	                }
	            }
	            recur(root);
	            return topLevel;
	            function isTopLevel(item) {
	                switch (navigationBarNodeKind(item)) {
	                    case 233 /* ClassDeclaration */:
	                    case 203 /* ClassExpression */:
	                    case 236 /* EnumDeclaration */:
	                    case 234 /* InterfaceDeclaration */:
	                    case 237 /* ModuleDeclaration */:
	                    case 272 /* SourceFile */:
	                    case 235 /* TypeAliasDeclaration */:
	                    case 291 /* JSDocTypedefTag */:
	                        return true;
	                    case 154 /* Constructor */:
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 230 /* VariableDeclaration */:
	                        return hasSomeImportantChild(item);
	                    case 191 /* ArrowFunction */:
	                    case 232 /* FunctionDeclaration */:
	                    case 190 /* FunctionExpression */:
	                        return isTopLevelFunctionDeclaration(item);
	                    default:
	                        return false;
	                }
	                function isTopLevelFunctionDeclaration(item) {
	                    if (!item.node.body) {
	                        return false;
	                    }
	                    switch (navigationBarNodeKind(item.parent)) {
	                        case 238 /* ModuleBlock */:
	                        case 272 /* SourceFile */:
	                        case 153 /* MethodDeclaration */:
	                        case 154 /* Constructor */:
	                            return true;
	                        default:
	                            return hasSomeImportantChild(item);
	                    }
	                }
	                function hasSomeImportantChild(item) {
	                    return ts.forEach(item.children, function (child) {
	                        var childKind = navigationBarNodeKind(child);
	                        return childKind !== 230 /* VariableDeclaration */ && childKind !== 180 /* BindingElement */;
	                    });
	                }
	            }
	        }
	        function convertToTree(n) {
	            return {
	                text: getItemName(n.node),
	                kind: ts.getNodeKind(n.node),
	                kindModifiers: getModifiers(n.node),
	                spans: getSpans(n),
	                childItems: ts.map(n.children, convertToTree)
	            };
	        }
	        function convertToTopLevelItem(n) {
	            return {
	                text: getItemName(n.node),
	                kind: ts.getNodeKind(n.node),
	                kindModifiers: getModifiers(n.node),
	                spans: getSpans(n),
	                childItems: ts.map(n.children, convertToChildItem) || emptyChildItemArray,
	                indent: n.indent,
	                bolded: false,
	                grayed: false
	            };
	            function convertToChildItem(n) {
	                return {
	                    text: getItemName(n.node),
	                    kind: ts.getNodeKind(n.node),
	                    kindModifiers: ts.getNodeModifiers(n.node),
	                    spans: getSpans(n),
	                    childItems: emptyChildItemArray,
	                    indent: 0,
	                    bolded: false,
	                    grayed: false
	                };
	            }
	        }
	        function getSpans(n) {
	            var spans = [getNodeSpan(n.node)];
	            if (n.additionalNodes) {
	                for (var _i = 0, _a = n.additionalNodes; _i < _a.length; _i++) {
	                    var node = _a[_i];
	                    spans.push(getNodeSpan(node));
	                }
	            }
	            return spans;
	        }
	        function getModuleName(moduleDeclaration) {
	            // We want to maintain quotation marks.
	            if (ts.isAmbientModule(moduleDeclaration)) {
	                return ts.getTextOfNode(moduleDeclaration.name);
	            }
	            // Otherwise, we need to aggregate each identifier to build up the qualified name.
	            var result = [];
	            result.push(ts.getTextOfIdentifierOrLiteral(moduleDeclaration.name));
	            while (moduleDeclaration.body && moduleDeclaration.body.kind === 237 /* ModuleDeclaration */) {
	                moduleDeclaration = moduleDeclaration.body;
	                result.push(ts.getTextOfIdentifierOrLiteral(moduleDeclaration.name));
	            }
	            return result.join(".");
	        }
	        /**
	         * For 'module A.B.C', we want to get the node for 'C'.
	         * We store 'A' as associated with a NavNode, and use getModuleName to traverse down again.
	         */
	        function getInteriorModule(decl) {
	            return decl.body.kind === 237 /* ModuleDeclaration */ ? getInteriorModule(decl.body) : decl;
	        }
	        function isComputedProperty(member) {
	            return !member.name || member.name.kind === 146 /* ComputedPropertyName */;
	        }
	        function getNodeSpan(node) {
	            return node.kind === 272 /* SourceFile */ ? ts.createTextSpanFromRange(node) : ts.createTextSpanFromNode(node, curSourceFile);
	        }
	        function getModifiers(node) {
	            if (node.parent && node.parent.kind === 230 /* VariableDeclaration */) {
	                node = node.parent;
	            }
	            return ts.getNodeModifiers(node);
	        }
	        function getFunctionOrClassName(node) {
	            if (node.name && ts.getFullWidth(node.name) > 0) {
	                return ts.declarationNameToString(node.name);
	            }
	            else if (node.parent.kind === 230 /* VariableDeclaration */) {
	                return ts.declarationNameToString(node.parent.name);
	            }
	            else if (node.parent.kind === 198 /* BinaryExpression */ &&
	                node.parent.operatorToken.kind === 58 /* EqualsToken */) {
	                return nodeText(node.parent.left).replace(whiteSpaceRegex, "");
	            }
	            else if (node.parent.kind === 268 /* PropertyAssignment */ && node.parent.name) {
	                return nodeText(node.parent.name);
	            }
	            else if (ts.getModifierFlags(node) & 512 /* Default */) {
	                return "default";
	            }
	            else {
	                return ts.isClassLike(node) ? "<class>" : "<function>";
	            }
	        }
	        function isFunctionOrClassExpression(node) {
	            switch (node.kind) {
	                case 191 /* ArrowFunction */:
	                case 190 /* FunctionExpression */:
	                case 203 /* ClassExpression */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	    })(NavigationBar = ts.NavigationBar || (ts.NavigationBar = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var OrganizeImports;
	    (function (OrganizeImports) {
	        /**
	         * Organize imports by:
	         *   1) Removing unused imports
	         *   2) Coalescing imports from the same module
	         *   3) Sorting imports
	         */
	        function organizeImports(sourceFile, formatContext, host, program) {
	            var changeTracker = ts.textChanges.ChangeTracker.fromContext({ host: host, formatContext: formatContext });
	            // All of the old ImportDeclarations in the file, in syntactic order.
	            var topLevelImportDecls = sourceFile.statements.filter(ts.isImportDeclaration);
	            organizeImportsWorker(topLevelImportDecls);
	            for (var _i = 0, _a = sourceFile.statements.filter(ts.isAmbientModule); _i < _a.length; _i++) {
	                var ambientModule = _a[_i];
	                var ambientModuleBody = getModuleBlock(ambientModule);
	                var ambientModuleImportDecls = ambientModuleBody.statements.filter(ts.isImportDeclaration);
	                organizeImportsWorker(ambientModuleImportDecls);
	            }
	            return changeTracker.getChanges();
	            function organizeImportsWorker(oldImportDecls) {
	                if (ts.length(oldImportDecls) === 0) {
	                    return;
	                }
	                var oldImportGroups = ts.group(oldImportDecls, function (importDecl) { return getExternalModuleName(importDecl.moduleSpecifier); });
	                var sortedImportGroups = ts.stableSort(oldImportGroups, function (group1, group2) { return compareModuleSpecifiers(group1[0].moduleSpecifier, group2[0].moduleSpecifier); });
	                var newImportDecls = ts.flatMap(sortedImportGroups, function (importGroup) {
	                    return getExternalModuleName(importGroup[0].moduleSpecifier)
	                        ? coalesceImports(removeUnusedImports(importGroup, sourceFile, program))
	                        : importGroup;
	                });
	                // Delete or replace the first import.
	                if (newImportDecls.length === 0) {
	                    changeTracker.deleteNode(sourceFile, oldImportDecls[0]);
	                }
	                else {
	                    // Note: Delete the surrounding trivia because it will have been retained in newImportDecls.
	                    changeTracker.replaceNodeWithNodes(sourceFile, oldImportDecls[0], newImportDecls, {
	                        useNonAdjustedStartPosition: false,
	                        useNonAdjustedEndPosition: false,
	                        suffix: ts.getNewLineOrDefaultFromHost(host, formatContext.options),
	                    });
	                }
	                // Delete any subsequent imports.
	                for (var i = 1; i < oldImportDecls.length; i++) {
	                    changeTracker.deleteNode(sourceFile, oldImportDecls[i]);
	                }
	            }
	        }
	        OrganizeImports.organizeImports = organizeImports;
	        function getModuleBlock(moduleDecl) {
	            var body = moduleDecl.body;
	            return body && !ts.isIdentifier(body) && (ts.isModuleBlock(body) ? body : getModuleBlock(body));
	        }
	        function removeUnusedImports(oldImports, sourceFile, program) {
	            var typeChecker = program.getTypeChecker();
	            var jsxNamespace = typeChecker.getJsxNamespace();
	            var jsxContext = sourceFile.languageVariant === 1 /* JSX */ && program.getCompilerOptions().jsx;
	            var usedImports = [];
	            for (var _i = 0, oldImports_1 = oldImports; _i < oldImports_1.length; _i++) {
	                var importDecl = oldImports_1[_i];
	                var importClause = importDecl.importClause;
	                if (!importClause) {
	                    // Imports without import clauses are assumed to be included for their side effects and are not removed.
	                    usedImports.push(importDecl);
	                    continue;
	                }
	                var name = importClause.name, namedBindings = importClause.namedBindings;
	                // Default import
	                if (name && !isDeclarationUsed(name)) {
	                    name = undefined;
	                }
	                if (namedBindings) {
	                    if (ts.isNamespaceImport(namedBindings)) {
	                        // Namespace import
	                        if (!isDeclarationUsed(namedBindings.name)) {
	                            namedBindings = undefined;
	                        }
	                    }
	                    else {
	                        // List of named imports
	                        var newElements = namedBindings.elements.filter(function (e) { return isDeclarationUsed(e.propertyName || e.name); });
	                        if (newElements.length < namedBindings.elements.length) {
	                            namedBindings = newElements.length
	                                ? ts.updateNamedImports(namedBindings, newElements)
	                                : undefined;
	                        }
	                    }
	                }
	                if (name || namedBindings) {
	                    usedImports.push(updateImportDeclarationAndClause(importDecl, name, namedBindings));
	                }
	            }
	            return usedImports;
	            function isDeclarationUsed(identifier) {
	                // The JSX factory symbol is always used.
	                return jsxContext && (identifier.text === jsxNamespace) || ts.FindAllReferences.Core.isSymbolReferencedInFile(identifier, typeChecker, sourceFile);
	            }
	        }
	        function getExternalModuleName(specifier) {
	            return ts.isStringLiteral(specifier) || ts.isNoSubstitutionTemplateLiteral(specifier)
	                ? specifier.text
	                : undefined;
	        }
	        /* @internal */ // Internal for testing
	        /**
	         * @param importGroup a list of ImportDeclarations, all with the same module name.
	         */
	        function coalesceImports(importGroup) {
	            if (importGroup.length === 0) {
	                return importGroup;
	            }
	            var _a = getCategorizedImports(importGroup), importWithoutClause = _a.importWithoutClause, defaultImports = _a.defaultImports, namespaceImports = _a.namespaceImports, namedImports = _a.namedImports;
	            var coalescedImports = [];
	            if (importWithoutClause) {
	                coalescedImports.push(importWithoutClause);
	            }
	            // Normally, we don't combine default and namespace imports, but it would be silly to
	            // produce two import declarations in this special case.
	            if (defaultImports.length === 1 && namespaceImports.length === 1 && namedImports.length === 0) {
	                // Add the namespace import to the existing default ImportDeclaration.
	                var defaultImport = defaultImports[0];
	                coalescedImports.push(updateImportDeclarationAndClause(defaultImport, defaultImport.importClause.name, namespaceImports[0].importClause.namedBindings));
	                return coalescedImports;
	            }
	            var sortedNamespaceImports = ts.stableSort(namespaceImports, function (i1, i2) {
	                return compareIdentifiers(i1.importClause.namedBindings.name, i2.importClause.namedBindings.name);
	            });
	            for (var _i = 0, sortedNamespaceImports_1 = sortedNamespaceImports; _i < sortedNamespaceImports_1.length; _i++) {
	                var namespaceImport = sortedNamespaceImports_1[_i];
	                // Drop the name, if any
	                coalescedImports.push(updateImportDeclarationAndClause(namespaceImport, /*name*/ undefined, namespaceImport.importClause.namedBindings));
	            }
	            if (defaultImports.length === 0 && namedImports.length === 0) {
	                return coalescedImports;
	            }
	            var newDefaultImport;
	            var newImportSpecifiers = [];
	            if (defaultImports.length === 1) {
	                newDefaultImport = defaultImports[0].importClause.name;
	            }
	            else {
	                for (var _b = 0, defaultImports_1 = defaultImports; _b < defaultImports_1.length; _b++) {
	                    var defaultImport = defaultImports_1[_b];
	                    newImportSpecifiers.push(ts.createImportSpecifier(ts.createIdentifier("default"), defaultImport.importClause.name));
	                }
	            }
	            newImportSpecifiers.push.apply(newImportSpecifiers, ts.flatMap(namedImports, function (i) { return i.importClause.namedBindings.elements; }));
	            var sortedImportSpecifiers = ts.stableSort(newImportSpecifiers, function (s1, s2) {
	                return compareIdentifiers(s1.propertyName || s1.name, s2.propertyName || s2.name) ||
	                    compareIdentifiers(s1.name, s2.name);
	            });
	            var importDecl = defaultImports.length > 0
	                ? defaultImports[0]
	                : namedImports[0];
	            var newNamedImports = sortedImportSpecifiers.length === 0
	                ? undefined
	                : namedImports.length === 0
	                    ? ts.createNamedImports(sortedImportSpecifiers)
	                    : ts.updateNamedImports(namedImports[0].importClause.namedBindings, sortedImportSpecifiers);
	            coalescedImports.push(updateImportDeclarationAndClause(importDecl, newDefaultImport, newNamedImports));
	            return coalescedImports;
	            /*
	             * Returns entire import declarations because they may already have been rewritten and
	             * may lack parent pointers.  The desired parts can easily be recovered based on the
	             * categorization.
	             *
	             * NB: There may be overlap between `defaultImports` and `namespaceImports`/`namedImports`.
	             */
	            function getCategorizedImports(importGroup) {
	                var importWithoutClause;
	                var defaultImports = [];
	                var namespaceImports = [];
	                var namedImports = [];
	                for (var _i = 0, importGroup_1 = importGroup; _i < importGroup_1.length; _i++) {
	                    var importDeclaration = importGroup_1[_i];
	                    if (importDeclaration.importClause === undefined) {
	                        // Only the first such import is interesting - the others are redundant.
	                        // Note: Unfortunately, we will lose trivia that was on this node.
	                        importWithoutClause = importWithoutClause || importDeclaration;
	                        continue;
	                    }
	                    var _a = importDeclaration.importClause, name = _a.name, namedBindings = _a.namedBindings;
	                    if (name) {
	                        defaultImports.push(importDeclaration);
	                    }
	                    if (namedBindings) {
	                        if (ts.isNamespaceImport(namedBindings)) {
	                            namespaceImports.push(importDeclaration);
	                        }
	                        else {
	                            namedImports.push(importDeclaration);
	                        }
	                    }
	                }
	                return {
	                    importWithoutClause: importWithoutClause,
	                    defaultImports: defaultImports,
	                    namespaceImports: namespaceImports,
	                    namedImports: namedImports,
	                };
	            }
	            function compareIdentifiers(s1, s2) {
	                return ts.compareStringsCaseSensitive(s1.text, s2.text);
	            }
	        }
	        OrganizeImports.coalesceImports = coalesceImports;
	        function updateImportDeclarationAndClause(importDeclaration, name, namedBindings) {
	            return ts.updateImportDeclaration(importDeclaration, importDeclaration.decorators, importDeclaration.modifiers, ts.updateImportClause(importDeclaration.importClause, name, namedBindings), importDeclaration.moduleSpecifier);
	        }
	        /* internal */ // Exported for testing
	        function compareModuleSpecifiers(m1, m2) {
	            var name1 = getExternalModuleName(m1);
	            var name2 = getExternalModuleName(m2);
	            return ts.compareBooleans(name1 === undefined, name2 === undefined) ||
	                ts.compareBooleans(ts.isExternalModuleNameRelative(name1), ts.isExternalModuleNameRelative(name2)) ||
	                ts.compareStringsCaseSensitive(name1, name2);
	        }
	        OrganizeImports.compareModuleSpecifiers = compareModuleSpecifiers;
	    })(OrganizeImports = ts.OrganizeImports || (ts.OrganizeImports = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var OutliningElementsCollector;
	    (function (OutliningElementsCollector) {
	        function collectElements(sourceFile, cancellationToken) {
	            var res = [];
	            addNodeOutliningSpans(sourceFile, cancellationToken, res);
	            addRegionOutliningSpans(sourceFile, res);
	            return res.sort(function (span1, span2) { return span1.textSpan.start - span2.textSpan.start; });
	        }
	        OutliningElementsCollector.collectElements = collectElements;
	        function addNodeOutliningSpans(sourceFile, cancellationToken, out) {
	            var depthRemaining = 40;
	            sourceFile.forEachChild(function walk(n) {
	                if (depthRemaining === 0)
	                    return;
	                cancellationToken.throwIfCancellationRequested();
	                if (ts.isDeclaration(n)) {
	                    addOutliningForLeadingCommentsForNode(n, sourceFile, cancellationToken, out);
	                }
	                var span = getOutliningSpanForNode(n, sourceFile);
	                if (span)
	                    out.push(span);
	                depthRemaining--;
	                n.forEachChild(walk);
	                depthRemaining++;
	            });
	        }
	        function addRegionOutliningSpans(sourceFile, out) {
	            var regions = [];
	            var lineStarts = sourceFile.getLineStarts();
	            for (var i = 0; i < lineStarts.length; i++) {
	                var currentLineStart = lineStarts[i];
	                var lineEnd = i + 1 === lineStarts.length ? sourceFile.getEnd() : lineStarts[i + 1] - 1;
	                var lineText = sourceFile.text.substring(currentLineStart, lineEnd);
	                var result = lineText.match(/^\s*\/\/\s*#(end)?region(?:\s+(.*))?$/);
	                if (!result || ts.isInComment(sourceFile, currentLineStart)) {
	                    continue;
	                }
	                if (!result[1]) {
	                    var span_12 = ts.createTextSpanFromBounds(sourceFile.text.indexOf("//", currentLineStart), lineEnd);
	                    regions.push(createOutliningSpan(span_12, span_12, /*autoCollapse*/ false, result[2] || "#region"));
	                }
	                else {
	                    var region = regions.pop();
	                    if (region) {
	                        region.textSpan.length = lineEnd - region.textSpan.start;
	                        region.hintSpan.length = lineEnd - region.textSpan.start;
	                        out.push(region);
	                    }
	                }
	            }
	        }
	        function addOutliningForLeadingCommentsForNode(n, sourceFile, cancellationToken, out) {
	            var comments = ts.getLeadingCommentRangesOfNode(n, sourceFile);
	            if (!comments)
	                return;
	            var firstSingleLineCommentStart = -1;
	            var lastSingleLineCommentEnd = -1;
	            var singleLineCommentCount = 0;
	            for (var _i = 0, comments_3 = comments; _i < comments_3.length; _i++) {
	                var _a = comments_3[_i], kind = _a.kind, pos = _a.pos, end = _a.end;
	                cancellationToken.throwIfCancellationRequested();
	                switch (kind) {
	                    case 2 /* SingleLineCommentTrivia */:
	                        // For single line comments, combine consecutive ones (2 or more) into
	                        // a single span from the start of the first till the end of the last
	                        if (singleLineCommentCount === 0) {
	                            firstSingleLineCommentStart = pos;
	                        }
	                        lastSingleLineCommentEnd = end;
	                        singleLineCommentCount++;
	                        break;
	                    case 3 /* MultiLineCommentTrivia */:
	                        combineAndAddMultipleSingleLineComments();
	                        out.push(createOutliningSpanFromBounds(pos, end));
	                        singleLineCommentCount = 0;
	                        break;
	                    default:
	                        ts.Debug.assertNever(kind);
	                }
	            }
	            combineAndAddMultipleSingleLineComments();
	            function combineAndAddMultipleSingleLineComments() {
	                // Only outline spans of two or more consecutive single line comments
	                if (singleLineCommentCount > 1) {
	                    out.push(createOutliningSpanFromBounds(firstSingleLineCommentStart, lastSingleLineCommentEnd));
	                }
	            }
	        }
	        function createOutliningSpanFromBounds(pos, end) {
	            return createOutliningSpan(ts.createTextSpanFromBounds(pos, end));
	        }
	        function getOutliningSpanForNode(n, sourceFile) {
	            switch (n.kind) {
	                case 211 /* Block */:
	                    if (ts.isFunctionBlock(n)) {
	                        return spanForNode(n.parent, /*autoCollapse*/ n.parent.kind !== 191 /* ArrowFunction */);
	                    }
	                    // Check if the block is standalone, or 'attached' to some parent statement.
	                    // If the latter, we want to collapse the block, but consider its hint span
	                    // to be the entire span of the parent.
	                    switch (n.parent.kind) {
	                        case 216 /* DoStatement */:
	                        case 219 /* ForInStatement */:
	                        case 220 /* ForOfStatement */:
	                        case 218 /* ForStatement */:
	                        case 215 /* IfStatement */:
	                        case 217 /* WhileStatement */:
	                        case 224 /* WithStatement */:
	                        case 267 /* CatchClause */:
	                            return spanForNode(n.parent);
	                        case 228 /* TryStatement */:
	                            // Could be the try-block, or the finally-block.
	                            var tryStatement = n.parent;
	                            if (tryStatement.tryBlock === n) {
	                                return spanForNode(n.parent);
	                            }
	                            else if (tryStatement.finallyBlock === n) {
	                                return spanForNode(ts.findChildOfKind(tryStatement, 87 /* FinallyKeyword */, sourceFile));
	                            }
	                        // falls through
	                        default:
	                            // Block was a standalone block.  In this case we want to only collapse
	                            // the span of the block, independent of any parent span.
	                            return createOutliningSpan(ts.createTextSpanFromNode(n, sourceFile));
	                    }
	                case 238 /* ModuleBlock */:
	                    return spanForNode(n.parent);
	                case 233 /* ClassDeclaration */:
	                case 234 /* InterfaceDeclaration */:
	                case 236 /* EnumDeclaration */:
	                case 239 /* CaseBlock */:
	                    return spanForNode(n);
	                case 182 /* ObjectLiteralExpression */:
	                    return spanForObjectOrArrayLiteral(n);
	                case 181 /* ArrayLiteralExpression */:
	                    return spanForObjectOrArrayLiteral(n, 21 /* OpenBracketToken */);
	            }
	            function spanForObjectOrArrayLiteral(node, open) {
	                if (open === void 0) { open = 17 /* OpenBraceToken */; }
	                // If the block has no leading keywords and is inside an array literal,
	                // we only want to collapse the span of the block.
	                // Otherwise, the collapsed section will include the end of the previous line.
	                return spanForNode(node, /*autoCollapse*/ false, /*useFullStart*/ !ts.isArrayLiteralExpression(node.parent), open);
	            }
	            function spanForNode(hintSpanNode, autoCollapse, useFullStart, open) {
	                if (autoCollapse === void 0) { autoCollapse = false; }
	                if (useFullStart === void 0) { useFullStart = true; }
	                if (open === void 0) { open = 17 /* OpenBraceToken */; }
	                var openToken = ts.findChildOfKind(n, open, sourceFile);
	                var close = open === 17 /* OpenBraceToken */ ? 18 /* CloseBraceToken */ : 22 /* CloseBracketToken */;
	                var closeToken = ts.findChildOfKind(n, close, sourceFile);
	                if (!openToken || !closeToken) {
	                    return undefined;
	                }
	                var textSpan = ts.createTextSpanFromBounds(useFullStart ? openToken.getFullStart() : openToken.getStart(sourceFile), closeToken.getEnd());
	                return createOutliningSpan(textSpan, ts.createTextSpanFromNode(hintSpanNode, sourceFile), autoCollapse);
	            }
	        }
	        function createOutliningSpan(textSpan, hintSpan, autoCollapse, bannerText) {
	            if (hintSpan === void 0) { hintSpan = textSpan; }
	            if (autoCollapse === void 0) { autoCollapse = false; }
	            if (bannerText === void 0) { bannerText = "..."; }
	            return { textSpan: textSpan, hintSpan: hintSpan, bannerText: bannerText, autoCollapse: autoCollapse };
	        }
	    })(OutliningElementsCollector = ts.OutliningElementsCollector || (ts.OutliningElementsCollector = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    // Note(cyrusn): this enum is ordered from strongest match type to weakest match type.
	    var PatternMatchKind;
	    (function (PatternMatchKind) {
	        PatternMatchKind[PatternMatchKind["exact"] = 0] = "exact";
	        PatternMatchKind[PatternMatchKind["prefix"] = 1] = "prefix";
	        PatternMatchKind[PatternMatchKind["substring"] = 2] = "substring";
	        PatternMatchKind[PatternMatchKind["camelCase"] = 3] = "camelCase";
	    })(PatternMatchKind = ts.PatternMatchKind || (ts.PatternMatchKind = {}));
	    function createPatternMatch(kind, punctuationStripped, isCaseSensitive, camelCaseWeight) {
	        return {
	            kind: kind,
	            punctuationStripped: punctuationStripped,
	            isCaseSensitive: isCaseSensitive,
	            camelCaseWeight: camelCaseWeight
	        };
	    }
	    function createPatternMatcher(pattern) {
	        // We'll often see the same candidate string many times when searching (For example, when
	        // we see the name of a module that is used everywhere, or the name of an overload).  As
	        // such, we cache the information we compute about the candidate for the life of this
	        // pattern matcher so we don't have to compute it multiple times.
	        var stringToWordSpans = ts.createMap();
	        pattern = pattern.trim();
	        var dotSeparatedSegments = pattern.split(".").map(function (p) { return createSegment(p.trim()); });
	        var invalidPattern = dotSeparatedSegments.length === 0 || ts.forEach(dotSeparatedSegments, segmentIsInvalid);
	        return {
	            getMatches: getMatches,
	            getMatchesForLastSegmentOfPattern: getMatchesForLastSegmentOfPattern,
	            patternContainsDots: dotSeparatedSegments.length > 1
	        };
	        // Quick checks so we can bail out when asked to match a candidate.
	        function skipMatch(candidate) {
	            return invalidPattern || !candidate;
	        }
	        function getMatchesForLastSegmentOfPattern(candidate) {
	            if (skipMatch(candidate)) {
	                return undefined;
	            }
	            return matchSegment(candidate, ts.lastOrUndefined(dotSeparatedSegments));
	        }
	        function getMatches(candidateContainers, candidate) {
	            if (skipMatch(candidate)) {
	                return undefined;
	            }
	            // First, check that the last part of the dot separated pattern matches the name of the
	            // candidate.  If not, then there's no point in proceeding and doing the more
	            // expensive work.
	            var candidateMatch = matchSegment(candidate, ts.lastOrUndefined(dotSeparatedSegments));
	            if (!candidateMatch) {
	                return undefined;
	            }
	            candidateContainers = candidateContainers || [];
	            // -1 because the last part was checked against the name, and only the rest
	            // of the parts are checked against the container.
	            if (dotSeparatedSegments.length - 1 > candidateContainers.length) {
	                // There weren't enough container parts to match against the pattern parts.
	                // So this definitely doesn't match.
	                return undefined;
	            }
	            // So far so good.  Now break up the container for the candidate and check if all
	            // the dotted parts match up correctly.
	            var totalMatch = candidateMatch;
	            for (var i = dotSeparatedSegments.length - 2, j = candidateContainers.length - 1; i >= 0; i -= 1, j -= 1) {
	                var segment = dotSeparatedSegments[i];
	                var containerName = candidateContainers[j];
	                var containerMatch = matchSegment(containerName, segment);
	                if (!containerMatch) {
	                    // This container didn't match the pattern piece.  So there's no match at all.
	                    return undefined;
	                }
	                ts.addRange(totalMatch, containerMatch);
	            }
	            // Success, this symbol's full name matched against the dotted name the user was asking
	            // about.
	            return totalMatch;
	        }
	        function getWordSpans(word) {
	            var spans = stringToWordSpans.get(word);
	            if (!spans) {
	                stringToWordSpans.set(word, spans = breakIntoWordSpans(word));
	            }
	            return spans;
	        }
	        function matchTextChunk(candidate, chunk, punctuationStripped) {
	            var index = indexOfIgnoringCase(candidate, chunk.textLowerCase);
	            if (index === 0) {
	                if (chunk.text.length === candidate.length) {
	                    // a) Check if the part matches the candidate entirely, in an case insensitive or
	                    //    sensitive manner.  If it does, return that there was an exact match.
	                    return createPatternMatch(PatternMatchKind.exact, punctuationStripped, /*isCaseSensitive:*/ candidate === chunk.text);
	                }
	                else {
	                    // b) Check if the part is a prefix of the candidate, in a case insensitive or sensitive
	                    //    manner.  If it does, return that there was a prefix match.
	                    return createPatternMatch(PatternMatchKind.prefix, punctuationStripped, /*isCaseSensitive:*/ ts.startsWith(candidate, chunk.text));
	                }
	            }
	            var isLowercase = chunk.isLowerCase;
	            if (isLowercase) {
	                if (index > 0) {
	                    // c) If the part is entirely lowercase, then check if it is contained anywhere in the
	                    //    candidate in a case insensitive manner.  If so, return that there was a substring
	                    //    match.
	                    //
	                    //    Note: We only have a substring match if the lowercase part is prefix match of some
	                    //    word part. That way we don't match something like 'Class' when the user types 'a'.
	                    //    But we would match 'FooAttribute' (since 'Attribute' starts with 'a').
	                    var wordSpans = getWordSpans(candidate);
	                    for (var _i = 0, wordSpans_1 = wordSpans; _i < wordSpans_1.length; _i++) {
	                        var span_13 = wordSpans_1[_i];
	                        if (partStartsWith(candidate, span_13, chunk.text, /*ignoreCase:*/ true)) {
	                            return createPatternMatch(PatternMatchKind.substring, punctuationStripped, 
	                            /*isCaseSensitive:*/ partStartsWith(candidate, span_13, chunk.text, /*ignoreCase:*/ false));
	                        }
	                    }
	                }
	            }
	            else {
	                // d) If the part was not entirely lowercase, then check if it is contained in the
	                //    candidate in a case *sensitive* manner. If so, return that there was a substring
	                //    match.
	                if (candidate.indexOf(chunk.text) > 0) {
	                    return createPatternMatch(PatternMatchKind.substring, punctuationStripped, /*isCaseSensitive:*/ true);
	                }
	            }
	            if (!isLowercase) {
	                // e) If the part was not entirely lowercase, then attempt a camel cased match as well.
	                if (chunk.characterSpans.length > 0) {
	                    var candidateParts = getWordSpans(candidate);
	                    var camelCaseWeight = tryCamelCaseMatch(candidate, candidateParts, chunk, /*ignoreCase:*/ false);
	                    if (camelCaseWeight !== undefined) {
	                        return createPatternMatch(PatternMatchKind.camelCase, punctuationStripped, /*isCaseSensitive:*/ true, /*camelCaseWeight:*/ camelCaseWeight);
	                    }
	                    camelCaseWeight = tryCamelCaseMatch(candidate, candidateParts, chunk, /*ignoreCase:*/ true);
	                    if (camelCaseWeight !== undefined) {
	                        return createPatternMatch(PatternMatchKind.camelCase, punctuationStripped, /*isCaseSensitive:*/ false, /*camelCaseWeight:*/ camelCaseWeight);
	                    }
	                }
	            }
	            if (isLowercase) {
	                // f) Is the pattern a substring of the candidate starting on one of the candidate's word boundaries?
	                // We could check every character boundary start of the candidate for the pattern. However, that's
	                // an m * n operation in the wost case. Instead, find the first instance of the pattern
	                // substring, and see if it starts on a capital letter. It seems unlikely that the user will try to
	                // filter the list based on a substring that starts on a capital letter and also with a lowercase one.
	                // (Pattern: fogbar, Candidate: quuxfogbarFogBar).
	                if (chunk.text.length < candidate.length) {
	                    if (index > 0 && isUpperCaseLetter(candidate.charCodeAt(index))) {
	                        return createPatternMatch(PatternMatchKind.substring, punctuationStripped, /*isCaseSensitive:*/ false);
	                    }
	                }
	            }
	            return undefined;
	        }
	        function containsSpaceOrAsterisk(text) {
	            for (var i = 0; i < text.length; i++) {
	                var ch = text.charCodeAt(i);
	                if (ch === 32 /* space */ || ch === 42 /* asterisk */) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function matchSegment(candidate, segment) {
	            // First check if the segment matches as is.  This is also useful if the segment contains
	            // characters we would normally strip when splitting into parts that we also may want to
	            // match in the candidate.  For example if the segment is "@int" and the candidate is
	            // "@int", then that will show up as an exact match here.
	            //
	            // Note: if the segment contains a space or an asterisk then we must assume that it's a
	            // multi-word segment.
	            if (!containsSpaceOrAsterisk(segment.totalTextChunk.text)) {
	                var match = matchTextChunk(candidate, segment.totalTextChunk, /*punctuationStripped:*/ false);
	                if (match) {
	                    return [match];
	                }
	            }
	            // The logic for pattern matching is now as follows:
	            //
	            // 1) Break the segment passed in into words.  Breaking is rather simple and a
	            //    good way to think about it that if gives you all the individual alphanumeric words
	            //    of the pattern.
	            //
	            // 2) For each word try to match the word against the candidate value.
	            //
	            // 3) Matching is as follows:
	            //
	            //   a) Check if the word matches the candidate entirely, in an case insensitive or
	            //    sensitive manner.  If it does, return that there was an exact match.
	            //
	            //   b) Check if the word is a prefix of the candidate, in a case insensitive or
	            //      sensitive manner.  If it does, return that there was a prefix match.
	            //
	            //   c) If the word is entirely lowercase, then check if it is contained anywhere in the
	            //      candidate in a case insensitive manner.  If so, return that there was a substring
	            //      match.
	            //
	            //      Note: We only have a substring match if the lowercase part is prefix match of
	            //      some word part. That way we don't match something like 'Class' when the user
	            //      types 'a'. But we would match 'FooAttribute' (since 'Attribute' starts with
	            //      'a').
	            //
	            //   d) If the word was not entirely lowercase, then check if it is contained in the
	            //      candidate in a case *sensitive* manner. If so, return that there was a substring
	            //      match.
	            //
	            //   e) If the word was not entirely lowercase, then attempt a camel cased match as
	            //      well.
	            //
	            //   f) The word is all lower case. Is it a case insensitive substring of the candidate starting
	            //      on a part boundary of the candidate?
	            //
	            // Only if all words have some sort of match is the pattern considered matched.
	            var subWordTextChunks = segment.subWordTextChunks;
	            var matches = undefined;
	            for (var _i = 0, subWordTextChunks_1 = subWordTextChunks; _i < subWordTextChunks_1.length; _i++) {
	                var subWordTextChunk = subWordTextChunks_1[_i];
	                // Try to match the candidate with this word
	                var result = matchTextChunk(candidate, subWordTextChunk, /*punctuationStripped:*/ true);
	                if (!result) {
	                    return undefined;
	                }
	                matches = matches || [];
	                matches.push(result);
	            }
	            return matches;
	        }
	        function partStartsWith(candidate, candidateSpan, pattern, ignoreCase, patternSpan) {
	            var patternPartStart = patternSpan ? patternSpan.start : 0;
	            var patternPartLength = patternSpan ? patternSpan.length : pattern.length;
	            if (patternPartLength > candidateSpan.length) {
	                // Pattern part is longer than the candidate part. There can never be a match.
	                return false;
	            }
	            if (ignoreCase) {
	                for (var i = 0; i < patternPartLength; i++) {
	                    var ch1 = pattern.charCodeAt(patternPartStart + i);
	                    var ch2 = candidate.charCodeAt(candidateSpan.start + i);
	                    if (toLowerCase(ch1) !== toLowerCase(ch2)) {
	                        return false;
	                    }
	                }
	            }
	            else {
	                for (var i = 0; i < patternPartLength; i++) {
	                    var ch1 = pattern.charCodeAt(patternPartStart + i);
	                    var ch2 = candidate.charCodeAt(candidateSpan.start + i);
	                    if (ch1 !== ch2) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }
	        function tryCamelCaseMatch(candidate, candidateParts, chunk, ignoreCase) {
	            var chunkCharacterSpans = chunk.characterSpans;
	            // Note: we may have more pattern parts than candidate parts.  This is because multiple
	            // pattern parts may match a candidate part.  For example "SiUI" against "SimpleUI".
	            // We'll have 3 pattern parts Si/U/I against two candidate parts Simple/UI.  However, U
	            // and I will both match in UI.
	            var currentCandidate = 0;
	            var currentChunkSpan = 0;
	            var firstMatch = undefined;
	            var contiguous = undefined;
	            while (true) {
	                // Let's consider our termination cases
	                if (currentChunkSpan === chunkCharacterSpans.length) {
	                    // We did match! We shall assign a weight to this
	                    var weight = 0;
	                    // Was this contiguous?
	                    if (contiguous) {
	                        weight += 1;
	                    }
	                    // Did we start at the beginning of the candidate?
	                    if (firstMatch === 0) {
	                        weight += 2;
	                    }
	                    return weight;
	                }
	                else if (currentCandidate === candidateParts.length) {
	                    // No match, since we still have more of the pattern to hit
	                    return undefined;
	                }
	                var candidatePart = candidateParts[currentCandidate];
	                var gotOneMatchThisCandidate = false;
	                // Consider the case of matching SiUI against SimpleUIElement. The candidate parts
	                // will be Simple/UI/Element, and the pattern parts will be Si/U/I.  We'll match 'Si'
	                // against 'Simple' first.  Then we'll match 'U' against 'UI'. However, we want to
	                // still keep matching pattern parts against that candidate part.
	                for (; currentChunkSpan < chunkCharacterSpans.length; currentChunkSpan++) {
	                    var chunkCharacterSpan = chunkCharacterSpans[currentChunkSpan];
	                    if (gotOneMatchThisCandidate) {
	                        // We've already gotten one pattern part match in this candidate.  We will
	                        // only continue trying to consumer pattern parts if the last part and this
	                        // part are both upper case.
	                        if (!isUpperCaseLetter(chunk.text.charCodeAt(chunkCharacterSpans[currentChunkSpan - 1].start)) ||
	                            !isUpperCaseLetter(chunk.text.charCodeAt(chunkCharacterSpans[currentChunkSpan].start))) {
	                            break;
	                        }
	                    }
	                    if (!partStartsWith(candidate, candidatePart, chunk.text, ignoreCase, chunkCharacterSpan)) {
	                        break;
	                    }
	                    gotOneMatchThisCandidate = true;
	                    firstMatch = firstMatch === undefined ? currentCandidate : firstMatch;
	                    // If we were contiguous, then keep that value.  If we weren't, then keep that
	                    // value.  If we don't know, then set the value to 'true' as an initial match is
	                    // obviously contiguous.
	                    contiguous = contiguous === undefined ? true : contiguous;
	                    candidatePart = ts.createTextSpan(candidatePart.start + chunkCharacterSpan.length, candidatePart.length - chunkCharacterSpan.length);
	                }
	                // Check if we matched anything at all.  If we didn't, then we need to unset the
	                // contiguous bit if we currently had it set.
	                // If we haven't set the bit yet, then that means we haven't matched anything so
	                // far, and we don't want to change that.
	                if (!gotOneMatchThisCandidate && contiguous !== undefined) {
	                    contiguous = false;
	                }
	                // Move onto the next candidate.
	                currentCandidate++;
	            }
	        }
	    }
	    ts.createPatternMatcher = createPatternMatcher;
	    function createSegment(text) {
	        return {
	            totalTextChunk: createTextChunk(text),
	            subWordTextChunks: breakPatternIntoTextChunks(text)
	        };
	    }
	    // A segment is considered invalid if we couldn't find any words in it.
	    function segmentIsInvalid(segment) {
	        return segment.subWordTextChunks.length === 0;
	    }
	    function isUpperCaseLetter(ch) {
	        // Fast check for the ascii range.
	        if (ch >= 65 /* A */ && ch <= 90 /* Z */) {
	            return true;
	        }
	        if (ch < 127 /* maxAsciiCharacter */ || !ts.isUnicodeIdentifierStart(ch, 6 /* Latest */)) {
	            return false;
	        }
	        // TODO: find a way to determine this for any unicode characters in a
	        // non-allocating manner.
	        var str = String.fromCharCode(ch);
	        return str === str.toUpperCase();
	    }
	    function isLowerCaseLetter(ch) {
	        // Fast check for the ascii range.
	        if (ch >= 97 /* a */ && ch <= 122 /* z */) {
	            return true;
	        }
	        if (ch < 127 /* maxAsciiCharacter */ || !ts.isUnicodeIdentifierStart(ch, 6 /* Latest */)) {
	            return false;
	        }
	        // TODO: find a way to determine this for any unicode characters in a
	        // non-allocating manner.
	        var str = String.fromCharCode(ch);
	        return str === str.toLowerCase();
	    }
	    // Assumes 'value' is already lowercase.
	    function indexOfIgnoringCase(str, value) {
	        var n = str.length - value.length;
	        for (var i = 0; i <= n; i++) {
	            if (startsWithIgnoringCase(str, value, i)) {
	                return i;
	            }
	        }
	        return -1;
	    }
	    // Assumes 'value' is already lowercase.
	    function startsWithIgnoringCase(str, value, start) {
	        for (var i = 0; i < value.length; i++) {
	            var ch1 = toLowerCase(str.charCodeAt(i + start));
	            var ch2 = value.charCodeAt(i);
	            if (ch1 !== ch2) {
	                return false;
	            }
	        }
	        return true;
	    }
	    function toLowerCase(ch) {
	        // Fast convert for the ascii range.
	        if (ch >= 65 /* A */ && ch <= 90 /* Z */) {
	            return 97 /* a */ + (ch - 65 /* A */);
	        }
	        if (ch < 127 /* maxAsciiCharacter */) {
	            return ch;
	        }
	        // TODO: find a way to compute this for any unicode characters in a
	        // non-allocating manner.
	        return String.fromCharCode(ch).toLowerCase().charCodeAt(0);
	    }
	    function isDigit(ch) {
	        // TODO(cyrusn): Find a way to support this for unicode digits.
	        return ch >= 48 /* _0 */ && ch <= 57 /* _9 */;
	    }
	    function isWordChar(ch) {
	        return isUpperCaseLetter(ch) || isLowerCaseLetter(ch) || isDigit(ch) || ch === 95 /* _ */ || ch === 36 /* $ */;
	    }
	    function breakPatternIntoTextChunks(pattern) {
	        var result = [];
	        var wordStart = 0;
	        var wordLength = 0;
	        for (var i = 0; i < pattern.length; i++) {
	            var ch = pattern.charCodeAt(i);
	            if (isWordChar(ch)) {
	                if (wordLength === 0) {
	                    wordStart = i;
	                }
	                wordLength++;
	            }
	            else {
	                if (wordLength > 0) {
	                    result.push(createTextChunk(pattern.substr(wordStart, wordLength)));
	                    wordLength = 0;
	                }
	            }
	        }
	        if (wordLength > 0) {
	            result.push(createTextChunk(pattern.substr(wordStart, wordLength)));
	        }
	        return result;
	    }
	    function createTextChunk(text) {
	        var textLowerCase = text.toLowerCase();
	        return {
	            text: text,
	            textLowerCase: textLowerCase,
	            isLowerCase: text === textLowerCase,
	            characterSpans: breakIntoCharacterSpans(text)
	        };
	    }
	    /* @internal */ function breakIntoCharacterSpans(identifier) {
	        return breakIntoSpans(identifier, /*word:*/ false);
	    }
	    ts.breakIntoCharacterSpans = breakIntoCharacterSpans;
	    /* @internal */ function breakIntoWordSpans(identifier) {
	        return breakIntoSpans(identifier, /*word:*/ true);
	    }
	    ts.breakIntoWordSpans = breakIntoWordSpans;
	    function breakIntoSpans(identifier, word) {
	        var result = [];
	        var wordStart = 0;
	        for (var i = 1; i < identifier.length; i++) {
	            var lastIsDigit = isDigit(identifier.charCodeAt(i - 1));
	            var currentIsDigit = isDigit(identifier.charCodeAt(i));
	            var hasTransitionFromLowerToUpper = transitionFromLowerToUpper(identifier, word, i);
	            var hasTransitionFromUpperToLower = transitionFromUpperToLower(identifier, word, i, wordStart);
	            if (charIsPunctuation(identifier.charCodeAt(i - 1)) ||
	                charIsPunctuation(identifier.charCodeAt(i)) ||
	                lastIsDigit !== currentIsDigit ||
	                hasTransitionFromLowerToUpper ||
	                hasTransitionFromUpperToLower) {
	                if (!isAllPunctuation(identifier, wordStart, i)) {
	                    result.push(ts.createTextSpan(wordStart, i - wordStart));
	                }
	                wordStart = i;
	            }
	        }
	        if (!isAllPunctuation(identifier, wordStart, identifier.length)) {
	            result.push(ts.createTextSpan(wordStart, identifier.length - wordStart));
	        }
	        return result;
	    }
	    function charIsPunctuation(ch) {
	        switch (ch) {
	            case 33 /* exclamation */:
	            case 34 /* doubleQuote */:
	            case 35 /* hash */:
	            case 37 /* percent */:
	            case 38 /* ampersand */:
	            case 39 /* singleQuote */:
	            case 40 /* openParen */:
	            case 41 /* closeParen */:
	            case 42 /* asterisk */:
	            case 44 /* comma */:
	            case 45 /* minus */:
	            case 46 /* dot */:
	            case 47 /* slash */:
	            case 58 /* colon */:
	            case 59 /* semicolon */:
	            case 63 /* question */:
	            case 64 /* at */:
	            case 91 /* openBracket */:
	            case 92 /* backslash */:
	            case 93 /* closeBracket */:
	            case 95 /* _ */:
	            case 123 /* openBrace */:
	            case 125 /* closeBrace */:
	                return true;
	        }
	        return false;
	    }
	    function isAllPunctuation(identifier, start, end) {
	        for (var i = start; i < end; i++) {
	            var ch = identifier.charCodeAt(i);
	            // We don't consider _ or $ as punctuation as there may be things with that name.
	            if (!charIsPunctuation(ch) || ch === 95 /* _ */ || ch === 36 /* $ */) {
	                return false;
	            }
	        }
	        return true;
	    }
	    function transitionFromUpperToLower(identifier, word, index, wordStart) {
	        if (word) {
	            // Cases this supports:
	            // 1) IDisposable -> I, Disposable
	            // 2) UIElement -> UI, Element
	            // 3) HTMLDocument -> HTML, Document
	            //
	            // etc.
	            if (index !== wordStart &&
	                index + 1 < identifier.length) {
	                var currentIsUpper = isUpperCaseLetter(identifier.charCodeAt(index));
	                var nextIsLower = isLowerCaseLetter(identifier.charCodeAt(index + 1));
	                if (currentIsUpper && nextIsLower) {
	                    // We have a transition from an upper to a lower letter here.  But we only
	                    // want to break if all the letters that preceded are uppercase.  i.e. if we
	                    // have "Foo" we don't want to break that into "F, oo".  But if we have
	                    // "IFoo" or "UIFoo", then we want to break that into "I, Foo" and "UI,
	                    // Foo".  i.e. the last uppercase letter belongs to the lowercase letters
	                    // that follows.  Note: this will make the following not split properly:
	                    // "HELLOthere".  However, these sorts of names do not show up in .Net
	                    // programs.
	                    for (var i = wordStart; i < index; i++) {
	                        if (!isUpperCaseLetter(identifier.charCodeAt(i))) {
	                            return false;
	                        }
	                    }
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	    function transitionFromLowerToUpper(identifier, word, index) {
	        var lastIsUpper = isUpperCaseLetter(identifier.charCodeAt(index - 1));
	        var currentIsUpper = isUpperCaseLetter(identifier.charCodeAt(index));
	        // See if the casing indicates we're starting a new word. Note: if we're breaking on
	        // words, then just seeing an upper case character isn't enough.  Instead, it has to
	        // be uppercase and the previous character can't be uppercase.
	        //
	        // For example, breaking "AddMetadata" on words would make: Add Metadata
	        //
	        // on characters would be: A dd M etadata
	        //
	        // Break "AM" on words would be: AM
	        //
	        // on characters would be: A M
	        //
	        // We break the search string on characters.  But we break the symbol name on words.
	        var transition = word
	            ? (currentIsUpper && !lastIsUpper)
	            : currentIsUpper;
	        return transition;
	    }
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    function preProcessFile(sourceText, readImportFiles, detectJavaScriptImports) {
	        if (readImportFiles === void 0) { readImportFiles = true; }
	        if (detectJavaScriptImports === void 0) { detectJavaScriptImports = false; }
	        var referencedFiles = [];
	        var typeReferenceDirectives = [];
	        var importedFiles = [];
	        var ambientExternalModules;
	        var isNoDefaultLib = false;
	        var braceNesting = 0;
	        // assume that text represent an external module if it contains at least one top level import/export
	        // ambient modules that are found inside external modules are interpreted as module augmentations
	        var externalModule = false;
	        function nextToken() {
	            var token = ts.scanner.scan();
	            if (token === 17 /* OpenBraceToken */) {
	                braceNesting++;
	            }
	            else if (token === 18 /* CloseBraceToken */) {
	                braceNesting--;
	            }
	            return token;
	        }
	        function processTripleSlashDirectives() {
	            var commentRanges = ts.getLeadingCommentRanges(sourceText, 0);
	            ts.forEach(commentRanges, function (commentRange) {
	                var comment = sourceText.substring(commentRange.pos, commentRange.end);
	                var referencePathMatchResult = ts.getFileReferenceFromReferencePath(comment, commentRange);
	                if (referencePathMatchResult) {
	                    isNoDefaultLib = referencePathMatchResult.isNoDefaultLib;
	                    var fileReference = referencePathMatchResult.fileReference;
	                    if (fileReference) {
	                        var collection = referencePathMatchResult.isTypeReferenceDirective
	                            ? typeReferenceDirectives
	                            : referencedFiles;
	                        collection.push(fileReference);
	                    }
	                }
	            });
	        }
	        function getFileReference() {
	            var fileName = ts.scanner.getTokenValue();
	            var pos = ts.scanner.getTokenPos();
	            return { fileName: fileName, pos: pos, end: pos + fileName.length };
	        }
	        function recordAmbientExternalModule() {
	            if (!ambientExternalModules) {
	                ambientExternalModules = [];
	            }
	            ambientExternalModules.push({ ref: getFileReference(), depth: braceNesting });
	        }
	        function recordModuleName() {
	            importedFiles.push(getFileReference());
	            markAsExternalModuleIfTopLevel();
	        }
	        function markAsExternalModuleIfTopLevel() {
	            if (braceNesting === 0) {
	                externalModule = true;
	            }
	        }
	        /**
	         * Returns true if at least one token was consumed from the stream
	         */
	        function tryConsumeDeclare() {
	            var token = ts.scanner.getToken();
	            if (token === 124 /* DeclareKeyword */) {
	                // declare module "mod"
	                token = nextToken();
	                if (token === 129 /* ModuleKeyword */) {
	                    token = nextToken();
	                    if (token === 9 /* StringLiteral */) {
	                        recordAmbientExternalModule();
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        /**
	         * Returns true if at least one token was consumed from the stream
	         */
	        function tryConsumeImport() {
	            var token = ts.scanner.getToken();
	            if (token === 91 /* ImportKeyword */) {
	                token = nextToken();
	                if (token === 19 /* OpenParenToken */) {
	                    token = nextToken();
	                    if (token === 9 /* StringLiteral */) {
	                        // import("mod");
	                        recordModuleName();
	                        return true;
	                    }
	                }
	                else if (token === 9 /* StringLiteral */) {
	                    // import "mod";
	                    recordModuleName();
	                    return true;
	                }
	                else {
	                    if (token === 71 /* Identifier */ || ts.isKeyword(token)) {
	                        token = nextToken();
	                        if (token === 142 /* FromKeyword */) {
	                            token = nextToken();
	                            if (token === 9 /* StringLiteral */) {
	                                // import d from "mod";
	                                recordModuleName();
	                                return true;
	                            }
	                        }
	                        else if (token === 58 /* EqualsToken */) {
	                            if (tryConsumeRequireCall(/*skipCurrentToken*/ true)) {
	                                return true;
	                            }
	                        }
	                        else if (token === 26 /* CommaToken */) {
	                            // consume comma and keep going
	                            token = nextToken();
	                        }
	                        else {
	                            // unknown syntax
	                            return true;
	                        }
	                    }
	                    if (token === 17 /* OpenBraceToken */) {
	                        token = nextToken();
	                        // consume "{ a as B, c, d as D}" clauses
	                        // make sure that it stops on EOF
	                        while (token !== 18 /* CloseBraceToken */ && token !== 1 /* EndOfFileToken */) {
	                            token = nextToken();
	                        }
	                        if (token === 18 /* CloseBraceToken */) {
	                            token = nextToken();
	                            if (token === 142 /* FromKeyword */) {
	                                token = nextToken();
	                                if (token === 9 /* StringLiteral */) {
	                                    // import {a as A} from "mod";
	                                    // import d, {a, b as B} from "mod"
	                                    recordModuleName();
	                                }
	                            }
	                        }
	                    }
	                    else if (token === 39 /* AsteriskToken */) {
	                        token = nextToken();
	                        if (token === 118 /* AsKeyword */) {
	                            token = nextToken();
	                            if (token === 71 /* Identifier */ || ts.isKeyword(token)) {
	                                token = nextToken();
	                                if (token === 142 /* FromKeyword */) {
	                                    token = nextToken();
	                                    if (token === 9 /* StringLiteral */) {
	                                        // import * as NS from "mod"
	                                        // import d, * as NS from "mod"
	                                        recordModuleName();
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function tryConsumeExport() {
	            var token = ts.scanner.getToken();
	            if (token === 84 /* ExportKeyword */) {
	                markAsExternalModuleIfTopLevel();
	                token = nextToken();
	                if (token === 17 /* OpenBraceToken */) {
	                    token = nextToken();
	                    // consume "{ a as B, c, d as D}" clauses
	                    // make sure it stops on EOF
	                    while (token !== 18 /* CloseBraceToken */ && token !== 1 /* EndOfFileToken */) {
	                        token = nextToken();
	                    }
	                    if (token === 18 /* CloseBraceToken */) {
	                        token = nextToken();
	                        if (token === 142 /* FromKeyword */) {
	                            token = nextToken();
	                            if (token === 9 /* StringLiteral */) {
	                                // export {a as A} from "mod";
	                                // export {a, b as B} from "mod"
	                                recordModuleName();
	                            }
	                        }
	                    }
	                }
	                else if (token === 39 /* AsteriskToken */) {
	                    token = nextToken();
	                    if (token === 142 /* FromKeyword */) {
	                        token = nextToken();
	                        if (token === 9 /* StringLiteral */) {
	                            // export * from "mod"
	                            recordModuleName();
	                        }
	                    }
	                }
	                else if (token === 91 /* ImportKeyword */) {
	                    token = nextToken();
	                    if (token === 71 /* Identifier */ || ts.isKeyword(token)) {
	                        token = nextToken();
	                        if (token === 58 /* EqualsToken */) {
	                            if (tryConsumeRequireCall(/*skipCurrentToken*/ true)) {
	                                return true;
	                            }
	                        }
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function tryConsumeRequireCall(skipCurrentToken) {
	            var token = skipCurrentToken ? nextToken() : ts.scanner.getToken();
	            if (token === 133 /* RequireKeyword */) {
	                token = nextToken();
	                if (token === 19 /* OpenParenToken */) {
	                    token = nextToken();
	                    if (token === 9 /* StringLiteral */) {
	                        //  require("mod");
	                        recordModuleName();
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function tryConsumeDefine() {
	            var token = ts.scanner.getToken();
	            if (token === 71 /* Identifier */ && ts.scanner.getTokenValue() === "define") {
	                token = nextToken();
	                if (token !== 19 /* OpenParenToken */) {
	                    return true;
	                }
	                token = nextToken();
	                if (token === 9 /* StringLiteral */) {
	                    // looks like define ("modname", ... - skip string literal and comma
	                    token = nextToken();
	                    if (token === 26 /* CommaToken */) {
	                        token = nextToken();
	                    }
	                    else {
	                        // unexpected token
	                        return true;
	                    }
	                }
	                // should be start of dependency list
	                if (token !== 21 /* OpenBracketToken */) {
	                    return true;
	                }
	                // skip open bracket
	                token = nextToken();
	                // scan until ']' or EOF
	                while (token !== 22 /* CloseBracketToken */ && token !== 1 /* EndOfFileToken */) {
	                    // record string literals as module names
	                    if (token === 9 /* StringLiteral */) {
	                        recordModuleName();
	                    }
	                    token = nextToken();
	                }
	                return true;
	            }
	            return false;
	        }
	        function processImports() {
	            ts.scanner.setText(sourceText);
	            nextToken();
	            // Look for:
	            //    import "mod";
	            //    import d from "mod"
	            //    import {a as A } from "mod";
	            //    import * as NS from "mod"
	            //    import d, {a, b as B} from "mod"
	            //    import i = require("mod");
	            //    import("mod");
	            //    export * from "mod"
	            //    export {a as b} from "mod"
	            //    export import i = require("mod")
	            //    (for JavaScript files) require("mod")
	            while (true) {
	                if (ts.scanner.getToken() === 1 /* EndOfFileToken */) {
	                    break;
	                }
	                // check if at least one of alternative have moved scanner forward
	                if (tryConsumeDeclare() ||
	                    tryConsumeImport() ||
	                    tryConsumeExport() ||
	                    (detectJavaScriptImports && (tryConsumeRequireCall(/*skipCurrentToken*/ false) || tryConsumeDefine()))) {
	                    continue;
	                }
	                else {
	                    nextToken();
	                }
	            }
	            ts.scanner.setText(undefined);
	        }
	        if (readImportFiles) {
	            processImports();
	        }
	        processTripleSlashDirectives();
	        if (externalModule) {
	            // for external modules module all nested ambient modules are augmentations
	            if (ambientExternalModules) {
	                // move all detected ambient modules to imported files since they need to be resolved
	                for (var _i = 0, ambientExternalModules_1 = ambientExternalModules; _i < ambientExternalModules_1.length; _i++) {
	                    var decl = ambientExternalModules_1[_i];
	                    importedFiles.push(decl.ref);
	                }
	            }
	            return { referencedFiles: referencedFiles, typeReferenceDirectives: typeReferenceDirectives, importedFiles: importedFiles, isLibFile: isNoDefaultLib, ambientExternalModules: undefined };
	        }
	        else {
	            // for global scripts ambient modules still can have augmentations - look for ambient modules with depth > 0
	            var ambientModuleNames = void 0;
	            if (ambientExternalModules) {
	                for (var _a = 0, ambientExternalModules_2 = ambientExternalModules; _a < ambientExternalModules_2.length; _a++) {
	                    var decl = ambientExternalModules_2[_a];
	                    if (decl.depth === 0) {
	                        if (!ambientModuleNames) {
	                            ambientModuleNames = [];
	                        }
	                        ambientModuleNames.push(decl.ref.fileName);
	                    }
	                    else {
	                        importedFiles.push(decl.ref);
	                    }
	                }
	            }
	            return { referencedFiles: referencedFiles, typeReferenceDirectives: typeReferenceDirectives, importedFiles: importedFiles, isLibFile: isNoDefaultLib, ambientExternalModules: ambientModuleNames };
	        }
	    }
	    ts.preProcessFile = preProcessFile;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var Rename;
	    (function (Rename) {
	        function getRenameInfo(typeChecker, defaultLibFileName, getCanonicalFileName, sourceFile, position) {
	            var getCanonicalDefaultLibName = ts.memoize(function () { return getCanonicalFileName(ts.normalizePath(defaultLibFileName)); });
	            var node = ts.getTouchingWord(sourceFile, position, /*includeJsDocComment*/ true);
	            var renameInfo = node && nodeIsEligibleForRename(node)
	                ? getRenameInfoForNode(node, typeChecker, sourceFile, isDefinedInLibraryFile)
	                : undefined;
	            return renameInfo || getRenameInfoError(ts.Diagnostics.You_cannot_rename_this_element);
	            function isDefinedInLibraryFile(declaration) {
	                if (!defaultLibFileName) {
	                    return false;
	                }
	                var sourceFile = declaration.getSourceFile();
	                var canonicalName = getCanonicalFileName(ts.normalizePath(sourceFile.fileName));
	                return canonicalName === getCanonicalDefaultLibName();
	            }
	        }
	        Rename.getRenameInfo = getRenameInfo;
	        function getRenameInfoForNode(node, typeChecker, sourceFile, isDefinedInLibraryFile) {
	            var symbol = typeChecker.getSymbolAtLocation(node);
	            // Only allow a symbol to be renamed if it actually has at least one declaration.
	            if (symbol) {
	                var declarations = symbol.declarations;
	                if (declarations && declarations.length > 0) {
	                    // Disallow rename for elements that are defined in the standard TypeScript library.
	                    if (declarations.some(isDefinedInLibraryFile)) {
	                        return getRenameInfoError(ts.Diagnostics.You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library);
	                    }
	                    // Cannot rename `default` as in `import { default as foo } from "./someModule";
	                    if (ts.isIdentifier(node) && node.originalKeywordKind === 79 /* DefaultKeyword */ && symbol.parent.flags & 1536 /* Module */) {
	                        return undefined;
	                    }
	                    var kind = ts.SymbolDisplay.getSymbolKind(typeChecker, symbol, node);
	                    var specifierName = (ts.isImportOrExportSpecifierName(node) || ts.isStringOrNumericLiteral(node) && node.parent.kind === 146 /* ComputedPropertyName */)
	                        ? ts.stripQuotes(ts.getTextOfIdentifierOrLiteral(node))
	                        : undefined;
	                    var displayName = specifierName || typeChecker.symbolToString(symbol);
	                    var fullDisplayName = specifierName || typeChecker.getFullyQualifiedName(symbol);
	                    return getRenameInfoSuccess(displayName, fullDisplayName, kind, ts.SymbolDisplay.getSymbolModifiers(symbol), node, sourceFile);
	                }
	            }
	            else if (ts.isStringLiteral(node)) {
	                if (isDefinedInLibraryFile(node)) {
	                    return getRenameInfoError(ts.Diagnostics.You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library);
	                }
	                return getRenameInfoSuccess(node.text, node.text, "var" /* variableElement */, "" /* none */, node, sourceFile);
	            }
	        }
	        function getRenameInfoSuccess(displayName, fullDisplayName, kind, kindModifiers, node, sourceFile) {
	            return {
	                canRename: true,
	                kind: kind,
	                displayName: displayName,
	                localizedErrorMessage: undefined,
	                fullDisplayName: fullDisplayName,
	                kindModifiers: kindModifiers,
	                triggerSpan: createTriggerSpanForNode(node, sourceFile)
	            };
	        }
	        function getRenameInfoError(diagnostic) {
	            return {
	                canRename: false,
	                localizedErrorMessage: ts.getLocaleSpecificMessage(diagnostic),
	                displayName: undefined,
	                fullDisplayName: undefined,
	                kind: undefined,
	                kindModifiers: undefined,
	                triggerSpan: undefined
	            };
	        }
	        function createTriggerSpanForNode(node, sourceFile) {
	            var start = node.getStart(sourceFile);
	            var width = node.getWidth(sourceFile);
	            if (node.kind === 9 /* StringLiteral */) {
	                // Exclude the quotes
	                start += 1;
	                width -= 2;
	            }
	            return ts.createTextSpan(start, width);
	        }
	        function nodeIsEligibleForRename(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                case 9 /* StringLiteral */:
	                case 99 /* ThisKeyword */:
	                    return true;
	                case 8 /* NumericLiteral */:
	                    return ts.isLiteralNameOfPropertyDeclarationOrIndexAccess(node);
	                default:
	                    return false;
	            }
	        }
	    })(Rename = ts.Rename || (ts.Rename = {}));
	})(ts || (ts = {}));
	///<reference path='services.ts' />
	/* @internal */
	var ts;
	(function (ts) {
	    var SignatureHelp;
	    (function (SignatureHelp) {
	        var ArgumentListKind;
	        (function (ArgumentListKind) {
	            ArgumentListKind[ArgumentListKind["TypeArguments"] = 0] = "TypeArguments";
	            ArgumentListKind[ArgumentListKind["CallArguments"] = 1] = "CallArguments";
	            ArgumentListKind[ArgumentListKind["TaggedTemplateArguments"] = 2] = "TaggedTemplateArguments";
	            ArgumentListKind[ArgumentListKind["JSXAttributesArguments"] = 3] = "JSXAttributesArguments";
	        })(ArgumentListKind = SignatureHelp.ArgumentListKind || (SignatureHelp.ArgumentListKind = {}));
	        function getSignatureHelpItems(program, sourceFile, position, cancellationToken) {
	            var typeChecker = program.getTypeChecker();
	            // Decide whether to show signature help
	            var startingToken = ts.findTokenOnLeftOfPosition(sourceFile, position);
	            if (!startingToken) {
	                // We are at the beginning of the file
	                return undefined;
	            }
	            var argumentInfo = getContainingArgumentInfo(startingToken, position, sourceFile);
	            if (!argumentInfo)
	                return undefined;
	            cancellationToken.throwIfCancellationRequested();
	            // Semantic filtering of signature help
	            var call = argumentInfo.invocation;
	            var candidates = [];
	            var resolvedSignature = typeChecker.getResolvedSignature(call, candidates, argumentInfo.argumentCount);
	            cancellationToken.throwIfCancellationRequested();
	            if (!candidates.length) {
	                // We didn't have any sig help items produced by the TS compiler.  If this is a JS
	                // file, then see if we can figure out anything better.
	                if (ts.isSourceFileJavaScript(sourceFile)) {
	                    return createJavaScriptSignatureHelpItems(argumentInfo, program);
	                }
	                return undefined;
	            }
	            return createSignatureHelpItems(candidates, resolvedSignature, argumentInfo, typeChecker);
	        }
	        SignatureHelp.getSignatureHelpItems = getSignatureHelpItems;
	        function createJavaScriptSignatureHelpItems(argumentInfo, program) {
	            if (argumentInfo.invocation.kind !== 185 /* CallExpression */) {
	                return undefined;
	            }
	            // See if we can find some symbol with the call expression name that has call signatures.
	            var callExpression = argumentInfo.invocation;
	            var expression = callExpression.expression;
	            var name = ts.isIdentifier(expression) ? expression : ts.isPropertyAccessExpression(expression) ? expression.name : undefined;
	            if (!name || !name.escapedText) {
	                return undefined;
	            }
	            var typeChecker = program.getTypeChecker();
	            for (var _i = 0, _a = program.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile = _a[_i];
	                var nameToDeclarations = sourceFile.getNamedDeclarations();
	                var declarations = nameToDeclarations.get(name.text);
	                if (declarations) {
	                    for (var _b = 0, declarations_12 = declarations; _b < declarations_12.length; _b++) {
	                        var declaration = declarations_12[_b];
	                        var symbol = declaration.symbol;
	                        if (symbol) {
	                            var type = typeChecker.getTypeOfSymbolAtLocation(symbol, declaration);
	                            if (type) {
	                                var callSignatures = type.getCallSignatures();
	                                if (callSignatures && callSignatures.length) {
	                                    return createSignatureHelpItems(callSignatures, callSignatures[0], argumentInfo, typeChecker);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        /**
	         * Returns relevant information for the argument list and the current argument if we are
	         * in the argument of an invocation; returns undefined otherwise.
	         */
	        function getImmediatelyContainingArgumentInfo(node, position, sourceFile) {
	            if (ts.isCallOrNewExpression(node.parent)) {
	                var invocation = node.parent;
	                var list = void 0;
	                var argumentIndex = void 0;
	                // There are 3 cases to handle:
	                //   1. The token introduces a list, and should begin a signature help session
	                //   2. The token is either not associated with a list, or ends a list, so the session should end
	                //   3. The token is buried inside a list, and should give signature help
	                //
	                // The following are examples of each:
	                //
	                //    Case 1:
	                //          foo<#T, U>(#a, b)    -> The token introduces a list, and should begin a signature help session
	                //    Case 2:
	                //          fo#o<T, U>#(a, b)#   -> The token is either not associated with a list, or ends a list, so the session should end
	                //    Case 3:
	                //          foo<T#, U#>(a#, #b#) -> The token is buried inside a list, and should give signature help
	                // Find out if 'node' is an argument, a type argument, or neither
	                if (node.kind === 27 /* LessThanToken */ || node.kind === 19 /* OpenParenToken */) {
	                    // Find the list that starts right *after* the < or ( token.
	                    // If the user has just opened a list, consider this item 0.
	                    list = getChildListThatStartsWithOpenerToken(invocation, node, sourceFile);
	                    ts.Debug.assert(list !== undefined);
	                    argumentIndex = 0;
	                }
	                else {
	                    // findListItemInfo can return undefined if we are not in parent's argument list
	                    // or type argument list. This includes cases where the cursor is:
	                    //   - To the right of the closing parenthesis, non-substitution template, or template tail.
	                    //   - Between the type arguments and the arguments (greater than token)
	                    //   - On the target of the call (parent.func)
	                    //   - On the 'new' keyword in a 'new' expression
	                    list = ts.findContainingList(node);
	                    if (!list)
	                        return undefined;
	                    argumentIndex = getArgumentIndex(list, node);
	                }
	                var kind = invocation.typeArguments && invocation.typeArguments.pos === list.pos ? 0 /* TypeArguments */ : 1 /* CallArguments */;
	                var argumentCount = getArgumentCount(list);
	                if (argumentIndex !== 0) {
	                    ts.Debug.assertLessThan(argumentIndex, argumentCount);
	                }
	                var argumentsSpan = getApplicableSpanForArguments(list, sourceFile);
	                return { kind: kind, invocation: invocation, argumentsSpan: argumentsSpan, argumentIndex: argumentIndex, argumentCount: argumentCount };
	            }
	            else if (node.kind === 13 /* NoSubstitutionTemplateLiteral */ && node.parent.kind === 187 /* TaggedTemplateExpression */) {
	                // Check if we're actually inside the template;
	                // otherwise we'll fall out and return undefined.
	                if (ts.isInsideTemplateLiteral(node, position)) {
	                    return getArgumentListInfoForTemplate(node.parent, /*argumentIndex*/ 0, sourceFile);
	                }
	            }
	            else if (node.kind === 14 /* TemplateHead */ && node.parent.parent.kind === 187 /* TaggedTemplateExpression */) {
	                var templateExpression = node.parent;
	                var tagExpression = templateExpression.parent;
	                ts.Debug.assert(templateExpression.kind === 200 /* TemplateExpression */);
	                var argumentIndex = ts.isInsideTemplateLiteral(node, position) ? 0 : 1;
	                return getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile);
	            }
	            else if (node.parent.kind === 209 /* TemplateSpan */ && node.parent.parent.parent.kind === 187 /* TaggedTemplateExpression */) {
	                var templateSpan = node.parent;
	                var templateExpression = templateSpan.parent;
	                var tagExpression = templateExpression.parent;
	                ts.Debug.assert(templateExpression.kind === 200 /* TemplateExpression */);
	                // If we're just after a template tail, don't show signature help.
	                if (node.kind === 16 /* TemplateTail */ && !ts.isInsideTemplateLiteral(node, position)) {
	                    return undefined;
	                }
	                var spanIndex = templateExpression.templateSpans.indexOf(templateSpan);
	                var argumentIndex = getArgumentIndexForTemplatePiece(spanIndex, node, position);
	                return getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile);
	            }
	            else if (node.parent && ts.isJsxOpeningLikeElement(node.parent)) {
	                // Provide a signature help for JSX opening element or JSX self-closing element.
	                // This is not guarantee that JSX tag-name is resolved into stateless function component. (that is done in "getSignatureHelpItems")
	                // i.e
	                //      export function MainButton(props: ButtonProps, context: any): JSX.Element { ... }
	                //      <MainButton /*signatureHelp*/
	                var attributeSpanStart = node.parent.attributes.getFullStart();
	                var attributeSpanEnd = ts.skipTrivia(sourceFile.text, node.parent.attributes.getEnd(), /*stopAfterLineBreak*/ false);
	                return {
	                    kind: 3 /* JSXAttributesArguments */,
	                    invocation: node.parent,
	                    argumentsSpan: ts.createTextSpan(attributeSpanStart, attributeSpanEnd - attributeSpanStart),
	                    argumentIndex: 0,
	                    argumentCount: 1
	                };
	            }
	            return undefined;
	        }
	        SignatureHelp.getImmediatelyContainingArgumentInfo = getImmediatelyContainingArgumentInfo;
	        function getArgumentIndex(argumentsList, node) {
	            // The list we got back can include commas.  In the presence of errors it may
	            // also just have nodes without commas.  For example "Foo(a b c)" will have 3
	            // args without commas. We want to find what index we're at.  So we count
	            // forward until we hit ourselves, only incrementing the index if it isn't a
	            // comma.
	            //
	            // Note: the subtlety around trailing commas (in getArgumentCount) does not apply
	            // here.  That's because we're only walking forward until we hit the node we're
	            // on.  In that case, even if we're after the trailing comma, we'll still see
	            // that trailing comma in the list, and we'll have generated the appropriate
	            // arg index.
	            var argumentIndex = 0;
	            for (var _i = 0, _a = argumentsList.getChildren(); _i < _a.length; _i++) {
	                var child = _a[_i];
	                if (child === node) {
	                    break;
	                }
	                if (child.kind !== 26 /* CommaToken */) {
	                    argumentIndex++;
	                }
	            }
	            return argumentIndex;
	        }
	        function getArgumentCount(argumentsList) {
	            // The argument count for a list is normally the number of non-comma children it has.
	            // For example, if you have "Foo(a,b)" then there will be three children of the arg
	            // list 'a' '<comma>' 'b'.  So, in this case the arg count will be 2.  However, there
	            // is a small subtlety.  If you have "Foo(a,)", then the child list will just have
	            // 'a' '<comma>'.  So, in the case where the last child is a comma, we increase the
	            // arg count by one to compensate.
	            //
	            // Note: this subtlety only applies to the last comma.  If you had "Foo(a,," then
	            // we'll have: 'a' '<comma>' '<missing>'
	            // That will give us 2 non-commas.  We then add one for the last comma, giving us an
	            // arg count of 3.
	            var listChildren = argumentsList.getChildren();
	            var argumentCount = ts.countWhere(listChildren, function (arg) { return arg.kind !== 26 /* CommaToken */; });
	            if (listChildren.length > 0 && ts.lastOrUndefined(listChildren).kind === 26 /* CommaToken */) {
	                argumentCount++;
	            }
	            return argumentCount;
	        }
	        // spanIndex is either the index for a given template span.
	        // This does not give appropriate results for a NoSubstitutionTemplateLiteral
	        function getArgumentIndexForTemplatePiece(spanIndex, node, position) {
	            // Because the TemplateStringsArray is the first argument, we have to offset each substitution expression by 1.
	            // There are three cases we can encounter:
	            //      1. We are precisely in the template literal (argIndex = 0).
	            //      2. We are in or to the right of the substitution expression (argIndex = spanIndex + 1).
	            //      3. We are directly to the right of the template literal, but because we look for the token on the left,
	            //          not enough to put us in the substitution expression; we should consider ourselves part of
	            //          the *next* span's expression by offsetting the index (argIndex = (spanIndex + 1) + 1).
	            //
	            // tslint:disable no-double-space
	            // Example: f  `# abcd $#{#  1 + 1#  }# efghi ${ #"#hello"#  }  #  `
	            //              ^       ^ ^       ^   ^          ^ ^      ^     ^
	            // Case:        1       1 3       2   1          3 2      2     1
	            // tslint:enable no-double-space
	            ts.Debug.assert(position >= node.getStart(), "Assumed 'position' could not occur before node.");
	            if (ts.isTemplateLiteralKind(node.kind)) {
	                if (ts.isInsideTemplateLiteral(node, position)) {
	                    return 0;
	                }
	                return spanIndex + 2;
	            }
	            return spanIndex + 1;
	        }
	        function getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile) {
	            // argumentCount is either 1 or (numSpans + 1) to account for the template strings array argument.
	            var argumentCount = ts.isNoSubstitutionTemplateLiteral(tagExpression.template) ? 1 : tagExpression.template.templateSpans.length + 1;
	            if (argumentIndex !== 0) {
	                ts.Debug.assertLessThan(argumentIndex, argumentCount);
	            }
	            return {
	                kind: 2 /* TaggedTemplateArguments */,
	                invocation: tagExpression,
	                argumentsSpan: getApplicableSpanForTaggedTemplate(tagExpression, sourceFile),
	                argumentIndex: argumentIndex,
	                argumentCount: argumentCount
	            };
	        }
	        function getApplicableSpanForArguments(argumentsList, sourceFile) {
	            // We use full start and skip trivia on the end because we want to include trivia on
	            // both sides. For example,
	            //
	            //    foo(   /*comment */     a, b, c      /*comment*/     )
	            //        |                                               |
	            //
	            // The applicable span is from the first bar to the second bar (inclusive,
	            // but not including parentheses)
	            var applicableSpanStart = argumentsList.getFullStart();
	            var applicableSpanEnd = ts.skipTrivia(sourceFile.text, argumentsList.getEnd(), /*stopAfterLineBreak*/ false);
	            return ts.createTextSpan(applicableSpanStart, applicableSpanEnd - applicableSpanStart);
	        }
	        function getApplicableSpanForTaggedTemplate(taggedTemplate, sourceFile) {
	            var template = taggedTemplate.template;
	            var applicableSpanStart = template.getStart();
	            var applicableSpanEnd = template.getEnd();
	            // We need to adjust the end position for the case where the template does not have a tail.
	            // Otherwise, we will not show signature help past the expression.
	            // For example,
	            //
	            //      ` ${ 1 + 1 foo(10)
	            //       |       |
	            // This is because a Missing node has no width. However, what we actually want is to include trivia
	            // leading up to the next token in case the user is about to type in a TemplateMiddle or TemplateTail.
	            if (template.kind === 200 /* TemplateExpression */) {
	                var lastSpan = ts.lastOrUndefined(template.templateSpans);
	                if (lastSpan.literal.getFullWidth() === 0) {
	                    applicableSpanEnd = ts.skipTrivia(sourceFile.text, applicableSpanEnd, /*stopAfterLineBreak*/ false);
	                }
	            }
	            return ts.createTextSpan(applicableSpanStart, applicableSpanEnd - applicableSpanStart);
	        }
	        function getContainingArgumentInfo(node, position, sourceFile) {
	            for (var n = node; n.kind !== 272 /* SourceFile */; n = n.parent) {
	                if (ts.isFunctionBlock(n)) {
	                    return undefined;
	                }
	                // If the node is not a subspan of its parent, this is a big problem.
	                // There have been crashes that might be caused by this violation.
	                if (n.pos < n.parent.pos || n.end > n.parent.end) {
	                    ts.Debug.fail("Node of kind " + n.kind + " is not a subspan of its parent of kind " + n.parent.kind);
	                }
	                var argumentInfo = getImmediatelyContainingArgumentInfo(n, position, sourceFile);
	                if (argumentInfo) {
	                    return argumentInfo;
	                }
	                // TODO: Handle generic call with incomplete syntax
	            }
	            return undefined;
	        }
	        SignatureHelp.getContainingArgumentInfo = getContainingArgumentInfo;
	        function getChildListThatStartsWithOpenerToken(parent, openerToken, sourceFile) {
	            var children = parent.getChildren(sourceFile);
	            var indexOfOpenerToken = children.indexOf(openerToken);
	            ts.Debug.assert(indexOfOpenerToken >= 0 && children.length > indexOfOpenerToken + 1);
	            return children[indexOfOpenerToken + 1];
	        }
	        var signatureHelpNodeBuilderFlags = 8192 /* OmitParameterModifiers */ | 3112960 /* IgnoreErrors */;
	        function createSignatureHelpItems(candidates, resolvedSignature, argumentListInfo, typeChecker) {
	            var argumentCount = argumentListInfo.argumentCount, applicableSpan = argumentListInfo.argumentsSpan, invocation = argumentListInfo.invocation, argumentIndex = argumentListInfo.argumentIndex;
	            var isTypeParameterList = argumentListInfo.kind === 0 /* TypeArguments */;
	            var callTarget = ts.getInvokedExpression(invocation);
	            var callTargetSymbol = typeChecker.getSymbolAtLocation(callTarget);
	            var callTargetDisplayParts = callTargetSymbol && ts.symbolToDisplayParts(typeChecker, callTargetSymbol, /*enclosingDeclaration*/ undefined, /*meaning*/ undefined);
	            var printer = ts.createPrinter({ removeComments: true });
	            var items = ts.map(candidates, function (candidateSignature) {
	                var signatureHelpParameters;
	                var prefixDisplayParts = [];
	                var suffixDisplayParts = [];
	                if (callTargetDisplayParts) {
	                    ts.addRange(prefixDisplayParts, callTargetDisplayParts);
	                }
	                var isVariadic;
	                if (isTypeParameterList) {
	                    isVariadic = false; // type parameter lists are not variadic
	                    prefixDisplayParts.push(ts.punctuationPart(27 /* LessThanToken */));
	                    var typeParameters = (candidateSignature.target || candidateSignature).typeParameters;
	                    signatureHelpParameters = typeParameters && typeParameters.length > 0 ? ts.map(typeParameters, createSignatureHelpParameterForTypeParameter) : ts.emptyArray;
	                    suffixDisplayParts.push(ts.punctuationPart(29 /* GreaterThanToken */));
	                    var parameterParts = ts.mapToDisplayParts(function (writer) {
	                        var thisParameter = candidateSignature.thisParameter ? [typeChecker.symbolToParameterDeclaration(candidateSignature.thisParameter, invocation, signatureHelpNodeBuilderFlags)] : [];
	                        var params = ts.createNodeArray(thisParameter.concat(ts.map(candidateSignature.parameters, function (param) { return typeChecker.symbolToParameterDeclaration(param, invocation, signatureHelpNodeBuilderFlags); })));
	                        printer.writeList(1296 /* CallExpressionArguments */, params, ts.getSourceFileOfNode(ts.getParseTreeNode(invocation)), writer);
	                    });
	                    ts.addRange(suffixDisplayParts, parameterParts);
	                }
	                else {
	                    isVariadic = candidateSignature.hasRestParameter;
	                    var typeParameterParts = ts.mapToDisplayParts(function (writer) {
	                        if (candidateSignature.typeParameters && candidateSignature.typeParameters.length) {
	                            var args = ts.createNodeArray(ts.map(candidateSignature.typeParameters, function (p) { return typeChecker.typeParameterToDeclaration(p, invocation); }));
	                            printer.writeList(26896 /* TypeParameters */, args, ts.getSourceFileOfNode(ts.getParseTreeNode(invocation)), writer);
	                        }
	                    });
	                    ts.addRange(prefixDisplayParts, typeParameterParts);
	                    prefixDisplayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                    signatureHelpParameters = ts.map(candidateSignature.parameters, createSignatureHelpParameterForParameter);
	                    suffixDisplayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                }
	                var returnTypeParts = ts.mapToDisplayParts(function (writer) {
	                    writer.writePunctuation(":");
	                    writer.writeSpace(" ");
	                    var predicate = typeChecker.getTypePredicateOfSignature(candidateSignature);
	                    if (predicate) {
	                        typeChecker.writeTypePredicate(predicate, invocation, /*flags*/ undefined, writer);
	                    }
	                    else {
	                        typeChecker.writeType(typeChecker.getReturnTypeOfSignature(candidateSignature), invocation, /*flags*/ undefined, writer);
	                    }
	                });
	                ts.addRange(suffixDisplayParts, returnTypeParts);
	                return {
	                    isVariadic: isVariadic,
	                    prefixDisplayParts: prefixDisplayParts,
	                    suffixDisplayParts: suffixDisplayParts,
	                    separatorDisplayParts: [ts.punctuationPart(26 /* CommaToken */), ts.spacePart()],
	                    parameters: signatureHelpParameters,
	                    documentation: candidateSignature.getDocumentationComment(typeChecker),
	                    tags: candidateSignature.getJsDocTags()
	                };
	            });
	            if (argumentIndex !== 0) {
	                ts.Debug.assertLessThan(argumentIndex, argumentCount);
	            }
	            var selectedItemIndex = candidates.indexOf(resolvedSignature);
	            ts.Debug.assert(selectedItemIndex !== -1); // If candidates is non-empty it should always include bestSignature. We check for an empty candidates before calling this function.
	            return { items: items, applicableSpan: applicableSpan, selectedItemIndex: selectedItemIndex, argumentIndex: argumentIndex, argumentCount: argumentCount };
	            function createSignatureHelpParameterForParameter(parameter) {
	                var displayParts = ts.mapToDisplayParts(function (writer) {
	                    var param = typeChecker.symbolToParameterDeclaration(parameter, invocation, signatureHelpNodeBuilderFlags);
	                    printer.writeNode(4 /* Unspecified */, param, ts.getSourceFileOfNode(ts.getParseTreeNode(invocation)), writer);
	                });
	                return {
	                    name: parameter.name,
	                    documentation: parameter.getDocumentationComment(typeChecker),
	                    displayParts: displayParts,
	                    isOptional: typeChecker.isOptionalParameter(parameter.valueDeclaration)
	                };
	            }
	            function createSignatureHelpParameterForTypeParameter(typeParameter) {
	                var displayParts = ts.mapToDisplayParts(function (writer) {
	                    var param = typeChecker.typeParameterToDeclaration(typeParameter, invocation);
	                    printer.writeNode(4 /* Unspecified */, param, ts.getSourceFileOfNode(ts.getParseTreeNode(invocation)), writer);
	                });
	                return {
	                    name: typeParameter.symbol.name,
	                    documentation: ts.emptyArray,
	                    displayParts: displayParts,
	                    isOptional: false
	                };
	            }
	        }
	    })(SignatureHelp = ts.SignatureHelp || (ts.SignatureHelp = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var SymbolDisplay;
	    (function (SymbolDisplay) {
	        // TODO(drosen): use contextual SemanticMeaning.
	        function getSymbolKind(typeChecker, symbol, location) {
	            var flags = ts.getCombinedLocalAndExportSymbolFlags(symbol);
	            if (flags & 32 /* Class */) {
	                return ts.getDeclarationOfKind(symbol, 203 /* ClassExpression */) ?
	                    "local class" /* localClassElement */ : "class" /* classElement */;
	            }
	            if (flags & 384 /* Enum */)
	                return "enum" /* enumElement */;
	            if (flags & 524288 /* TypeAlias */)
	                return "type" /* typeElement */;
	            if (flags & 64 /* Interface */)
	                return "interface" /* interfaceElement */;
	            if (flags & 262144 /* TypeParameter */)
	                return "type parameter" /* typeParameterElement */;
	            var result = getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location);
	            if (result === "" /* unknown */) {
	                if (flags & 262144 /* TypeParameter */)
	                    return "type parameter" /* typeParameterElement */;
	                if (flags & 8 /* EnumMember */)
	                    return "enum member" /* enumMemberElement */;
	                if (flags & 2097152 /* Alias */)
	                    return "alias" /* alias */;
	                if (flags & 1536 /* Module */)
	                    return "module" /* moduleElement */;
	            }
	            return result;
	        }
	        SymbolDisplay.getSymbolKind = getSymbolKind;
	        function getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location) {
	            if (typeChecker.isUndefinedSymbol(symbol)) {
	                return "var" /* variableElement */;
	            }
	            if (typeChecker.isArgumentsSymbol(symbol)) {
	                return "local var" /* localVariableElement */;
	            }
	            if (location.kind === 99 /* ThisKeyword */ && ts.isExpression(location)) {
	                return "parameter" /* parameterElement */;
	            }
	            var flags = ts.getCombinedLocalAndExportSymbolFlags(symbol);
	            if (flags & 3 /* Variable */) {
	                if (ts.isFirstDeclarationOfSymbolParameter(symbol)) {
	                    return "parameter" /* parameterElement */;
	                }
	                else if (symbol.valueDeclaration && ts.isConst(symbol.valueDeclaration)) {
	                    return "const" /* constElement */;
	                }
	                else if (ts.forEach(symbol.declarations, ts.isLet)) {
	                    return "let" /* letElement */;
	                }
	                return isLocalVariableOrFunction(symbol) ? "local var" /* localVariableElement */ : "var" /* variableElement */;
	            }
	            if (flags & 16 /* Function */)
	                return isLocalVariableOrFunction(symbol) ? "local function" /* localFunctionElement */ : "function" /* functionElement */;
	            if (flags & 32768 /* GetAccessor */)
	                return "getter" /* memberGetAccessorElement */;
	            if (flags & 65536 /* SetAccessor */)
	                return "setter" /* memberSetAccessorElement */;
	            if (flags & 8192 /* Method */)
	                return "method" /* memberFunctionElement */;
	            if (flags & 16384 /* Constructor */)
	                return "constructor" /* constructorImplementationElement */;
	            if (flags & 4 /* Property */) {
	                if (flags & 33554432 /* Transient */ && symbol.checkFlags & 6 /* Synthetic */) {
	                    // If union property is result of union of non method (property/accessors/variables), it is labeled as property
	                    var unionPropertyKind = ts.forEach(typeChecker.getRootSymbols(symbol), function (rootSymbol) {
	                        var rootSymbolFlags = rootSymbol.getFlags();
	                        if (rootSymbolFlags & (98308 /* PropertyOrAccessor */ | 3 /* Variable */)) {
	                            return "property" /* memberVariableElement */;
	                        }
	                        // May be a Function if this was from `typeof N` with `namespace N { function f();. }`.
	                        ts.Debug.assert(!!(rootSymbolFlags & (8192 /* Method */ | 16 /* Function */)));
	                    });
	                    if (!unionPropertyKind) {
	                        // If this was union of all methods,
	                        // make sure it has call signatures before we can label it as method
	                        var typeOfUnionProperty = typeChecker.getTypeOfSymbolAtLocation(symbol, location);
	                        if (typeOfUnionProperty.getCallSignatures().length) {
	                            return "method" /* memberFunctionElement */;
	                        }
	                        return "property" /* memberVariableElement */;
	                    }
	                    return unionPropertyKind;
	                }
	                // If we requested completions after `x.` at the top-level, we may be at a source file location.
	                switch (location.parent && location.parent.kind) {
	                    // If we've typed a character of the attribute name, will be 'JsxAttribute', else will be 'JsxOpeningElement'.
	                    case 255 /* JsxOpeningElement */:
	                    case 253 /* JsxElement */:
	                    case 254 /* JsxSelfClosingElement */:
	                        return location.kind === 71 /* Identifier */ ? "property" /* memberVariableElement */ : "JSX attribute" /* jsxAttribute */;
	                    case 260 /* JsxAttribute */:
	                        return "JSX attribute" /* jsxAttribute */;
	                    default:
	                        return "property" /* memberVariableElement */;
	                }
	            }
	            return "" /* unknown */;
	        }
	        function getSymbolModifiers(symbol) {
	            var nodeModifiers = symbol && symbol.declarations && symbol.declarations.length > 0
	                ? ts.getNodeModifiers(symbol.declarations[0])
	                : "" /* none */;
	            var symbolModifiers = symbol && symbol.flags & 16777216 /* Optional */ ?
	                "optional" /* optionalModifier */
	                : "" /* none */;
	            return nodeModifiers && symbolModifiers ? nodeModifiers + "," + symbolModifiers : nodeModifiers || symbolModifiers;
	        }
	        SymbolDisplay.getSymbolModifiers = getSymbolModifiers;
	        // TODO(drosen): Currently completion entry details passes the SemanticMeaning.All instead of using semanticMeaning of location
	        function getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, symbol, sourceFile, enclosingDeclaration, location, semanticMeaning, alias) {
	            if (semanticMeaning === void 0) { semanticMeaning = ts.getMeaningFromLocation(location); }
	            var displayParts = [];
	            var documentation;
	            var tags;
	            var symbolFlags = ts.getCombinedLocalAndExportSymbolFlags(symbol);
	            var symbolKind = getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location);
	            var hasAddedSymbolInfo;
	            var isThisExpression = location.kind === 99 /* ThisKeyword */ && ts.isExpression(location);
	            var type;
	            var printer;
	            var documentationFromAlias;
	            // Class at constructor site need to be shown as constructor apart from property,method, vars
	            if (symbolKind !== "" /* unknown */ || symbolFlags & 32 /* Class */ || symbolFlags & 2097152 /* Alias */) {
	                // If it is accessor they are allowed only if location is at name of the accessor
	                if (symbolKind === "getter" /* memberGetAccessorElement */ || symbolKind === "setter" /* memberSetAccessorElement */) {
	                    symbolKind = "property" /* memberVariableElement */;
	                }
	                var signature = void 0;
	                type = isThisExpression ? typeChecker.getTypeAtLocation(location) : typeChecker.getTypeOfSymbolAtLocation(symbol.exportSymbol || symbol, location);
	                if (location.parent && location.parent.kind === 183 /* PropertyAccessExpression */) {
	                    var right = location.parent.name;
	                    // Either the location is on the right of a property access, or on the left and the right is missing
	                    if (right === location || (right && right.getFullWidth() === 0)) {
	                        location = location.parent;
	                    }
	                }
	                // try get the call/construct signature from the type if it matches
	                var callExpressionLike = void 0;
	                if (ts.isCallOrNewExpression(location)) {
	                    callExpressionLike = location;
	                }
	                else if (ts.isCallExpressionTarget(location) || ts.isNewExpressionTarget(location)) {
	                    callExpressionLike = location.parent;
	                }
	                else if (location.parent && ts.isJsxOpeningLikeElement(location.parent) && ts.isFunctionLike(symbol.valueDeclaration)) {
	                    callExpressionLike = location.parent;
	                }
	                if (callExpressionLike) {
	                    var candidateSignatures = [];
	                    signature = typeChecker.getResolvedSignature(callExpressionLike, candidateSignatures);
	                    var useConstructSignatures = callExpressionLike.kind === 186 /* NewExpression */ || (ts.isCallExpression(callExpressionLike) && callExpressionLike.expression.kind === 97 /* SuperKeyword */);
	                    var allSignatures = useConstructSignatures ? type.getConstructSignatures() : type.getCallSignatures();
	                    if (!ts.contains(allSignatures, signature.target) && !ts.contains(allSignatures, signature)) {
	                        // Get the first signature if there is one -- allSignatures may contain
	                        // either the original signature or its target, so check for either
	                        signature = allSignatures.length ? allSignatures[0] : undefined;
	                    }
	                    if (signature) {
	                        if (useConstructSignatures && (symbolFlags & 32 /* Class */)) {
	                            // Constructor
	                            symbolKind = "constructor" /* constructorImplementationElement */;
	                            addPrefixForAnyFunctionOrVar(type.symbol, symbolKind);
	                        }
	                        else if (symbolFlags & 2097152 /* Alias */) {
	                            symbolKind = "alias" /* alias */;
	                            pushTypePart(symbolKind);
	                            displayParts.push(ts.spacePart());
	                            if (useConstructSignatures) {
	                                displayParts.push(ts.keywordPart(94 /* NewKeyword */));
	                                displayParts.push(ts.spacePart());
	                            }
	                            addFullSymbolName(symbol);
	                        }
	                        else {
	                            addPrefixForAnyFunctionOrVar(symbol, symbolKind);
	                        }
	                        switch (symbolKind) {
	                            case "JSX attribute" /* jsxAttribute */:
	                            case "property" /* memberVariableElement */:
	                            case "var" /* variableElement */:
	                            case "const" /* constElement */:
	                            case "let" /* letElement */:
	                            case "parameter" /* parameterElement */:
	                            case "local var" /* localVariableElement */:
	                                // If it is call or construct signature of lambda's write type name
	                                displayParts.push(ts.punctuationPart(56 /* ColonToken */));
	                                displayParts.push(ts.spacePart());
	                                if (!(type.flags & 65536 /* Object */ && type.objectFlags & 16 /* Anonymous */) && type.symbol) {
	                                    ts.addRange(displayParts, ts.symbolToDisplayParts(typeChecker, type.symbol, enclosingDeclaration, /*meaning*/ undefined, 4 /* AllowAnyNodeKind */ | 1 /* WriteTypeParametersOrArguments */));
	                                    displayParts.push(ts.lineBreakPart());
	                                }
	                                if (useConstructSignatures) {
	                                    displayParts.push(ts.keywordPart(94 /* NewKeyword */));
	                                    displayParts.push(ts.spacePart());
	                                }
	                                addSignatureDisplayParts(signature, allSignatures, 262144 /* WriteArrowStyleSignature */);
	                                break;
	                            default:
	                                // Just signature
	                                addSignatureDisplayParts(signature, allSignatures);
	                        }
	                        hasAddedSymbolInfo = true;
	                    }
	                }
	                else if ((ts.isNameOfFunctionDeclaration(location) && !(symbolFlags & 98304 /* Accessor */)) || // name of function declaration
	                    (location.kind === 123 /* ConstructorKeyword */ && location.parent.kind === 154 /* Constructor */)) {
	                    // get the signature from the declaration and write it
	                    var functionDeclaration_1 = location.parent;
	                    // Use function declaration to write the signatures only if the symbol corresponding to this declaration
	                    var locationIsSymbolDeclaration = ts.find(symbol.declarations, function (declaration) {
	                        return declaration === (location.kind === 123 /* ConstructorKeyword */ ? functionDeclaration_1.parent : functionDeclaration_1);
	                    });
	                    if (locationIsSymbolDeclaration) {
	                        var allSignatures = functionDeclaration_1.kind === 154 /* Constructor */ ? type.getNonNullableType().getConstructSignatures() : type.getNonNullableType().getCallSignatures();
	                        if (!typeChecker.isImplementationOfOverload(functionDeclaration_1)) {
	                            signature = typeChecker.getSignatureFromDeclaration(functionDeclaration_1);
	                        }
	                        else {
	                            signature = allSignatures[0];
	                        }
	                        if (functionDeclaration_1.kind === 154 /* Constructor */) {
	                            // show (constructor) Type(...) signature
	                            symbolKind = "constructor" /* constructorImplementationElement */;
	                            addPrefixForAnyFunctionOrVar(type.symbol, symbolKind);
	                        }
	                        else {
	                            // (function/method) symbol(..signature)
	                            addPrefixForAnyFunctionOrVar(functionDeclaration_1.kind === 157 /* CallSignature */ &&
	                                !(type.symbol.flags & 2048 /* TypeLiteral */ || type.symbol.flags & 4096 /* ObjectLiteral */) ? type.symbol : symbol, symbolKind);
	                        }
	                        addSignatureDisplayParts(signature, allSignatures);
	                        hasAddedSymbolInfo = true;
	                    }
	                }
	            }
	            if (symbolFlags & 32 /* Class */ && !hasAddedSymbolInfo && !isThisExpression) {
	                addAliasPrefixIfNecessary();
	                if (ts.getDeclarationOfKind(symbol, 203 /* ClassExpression */)) {
	                    // Special case for class expressions because we would like to indicate that
	                    // the class name is local to the class body (similar to function expression)
	                    //      (local class) class <className>
	                    pushTypePart("local class" /* localClassElement */);
	                }
	                else {
	                    // Class declaration has name which is not local.
	                    displayParts.push(ts.keywordPart(75 /* ClassKeyword */));
	                }
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                writeTypeParametersOfSymbol(symbol, sourceFile);
	            }
	            if ((symbolFlags & 64 /* Interface */) && (semanticMeaning & 2 /* Type */)) {
	                prefixNextMeaning();
	                displayParts.push(ts.keywordPart(109 /* InterfaceKeyword */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                writeTypeParametersOfSymbol(symbol, sourceFile);
	            }
	            if (symbolFlags & 524288 /* TypeAlias */) {
	                prefixNextMeaning();
	                displayParts.push(ts.keywordPart(139 /* TypeKeyword */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                writeTypeParametersOfSymbol(symbol, sourceFile);
	                displayParts.push(ts.spacePart());
	                displayParts.push(ts.operatorPart(58 /* EqualsToken */));
	                displayParts.push(ts.spacePart());
	                ts.addRange(displayParts, ts.typeToDisplayParts(typeChecker, typeChecker.getDeclaredTypeOfSymbol(symbol), enclosingDeclaration, 8388608 /* InTypeAlias */));
	            }
	            if (symbolFlags & 384 /* Enum */) {
	                prefixNextMeaning();
	                if (ts.forEach(symbol.declarations, ts.isConstEnumDeclaration)) {
	                    displayParts.push(ts.keywordPart(76 /* ConstKeyword */));
	                    displayParts.push(ts.spacePart());
	                }
	                displayParts.push(ts.keywordPart(83 /* EnumKeyword */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	            }
	            if (symbolFlags & 1536 /* Module */) {
	                prefixNextMeaning();
	                var declaration = ts.getDeclarationOfKind(symbol, 237 /* ModuleDeclaration */);
	                var isNamespace = declaration && declaration.name && declaration.name.kind === 71 /* Identifier */;
	                displayParts.push(ts.keywordPart(isNamespace ? 130 /* NamespaceKeyword */ : 129 /* ModuleKeyword */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	            }
	            if ((symbolFlags & 262144 /* TypeParameter */) && (semanticMeaning & 2 /* Type */)) {
	                prefixNextMeaning();
	                displayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                displayParts.push(ts.textPart("type parameter"));
	                displayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                if (symbol.parent) {
	                    // Class/Interface type parameter
	                    addInPrefix();
	                    addFullSymbolName(symbol.parent, enclosingDeclaration);
	                    writeTypeParametersOfSymbol(symbol.parent, enclosingDeclaration);
	                }
	                else {
	                    // Method/function type parameter
	                    var decl = ts.getDeclarationOfKind(symbol, 147 /* TypeParameter */);
	                    ts.Debug.assert(decl !== undefined);
	                    var declaration = decl.parent;
	                    if (declaration) {
	                        if (ts.isFunctionLikeKind(declaration.kind)) {
	                            addInPrefix();
	                            var signature = typeChecker.getSignatureFromDeclaration(declaration);
	                            if (declaration.kind === 158 /* ConstructSignature */) {
	                                displayParts.push(ts.keywordPart(94 /* NewKeyword */));
	                                displayParts.push(ts.spacePart());
	                            }
	                            else if (declaration.kind !== 157 /* CallSignature */ && declaration.name) {
	                                addFullSymbolName(declaration.symbol);
	                            }
	                            ts.addRange(displayParts, ts.signatureToDisplayParts(typeChecker, signature, sourceFile, 32 /* WriteTypeArgumentsOfSignature */));
	                        }
	                        else if (declaration.kind === 235 /* TypeAliasDeclaration */) {
	                            // Type alias type parameter
	                            // For example
	                            //      type list<T> = T[]; // Both T will go through same code path
	                            addInPrefix();
	                            displayParts.push(ts.keywordPart(139 /* TypeKeyword */));
	                            displayParts.push(ts.spacePart());
	                            addFullSymbolName(declaration.symbol);
	                            writeTypeParametersOfSymbol(declaration.symbol, sourceFile);
	                        }
	                    }
	                }
	            }
	            if (symbolFlags & 8 /* EnumMember */) {
	                symbolKind = "enum member" /* enumMemberElement */;
	                addPrefixForAnyFunctionOrVar(symbol, "enum member");
	                var declaration = symbol.declarations[0];
	                if (declaration.kind === 271 /* EnumMember */) {
	                    var constantValue = typeChecker.getConstantValue(declaration);
	                    if (constantValue !== undefined) {
	                        displayParts.push(ts.spacePart());
	                        displayParts.push(ts.operatorPart(58 /* EqualsToken */));
	                        displayParts.push(ts.spacePart());
	                        displayParts.push(ts.displayPart(ts.getTextOfConstantValue(constantValue), typeof constantValue === "number" ? ts.SymbolDisplayPartKind.numericLiteral : ts.SymbolDisplayPartKind.stringLiteral));
	                    }
	                }
	            }
	            if (symbolFlags & 2097152 /* Alias */) {
	                prefixNextMeaning();
	                if (!hasAddedSymbolInfo) {
	                    var resolvedSymbol = typeChecker.getAliasedSymbol(symbol);
	                    if (resolvedSymbol !== symbol && resolvedSymbol.declarations && resolvedSymbol.declarations.length > 0) {
	                        var resolvedNode = resolvedSymbol.declarations[0];
	                        var declarationName = ts.getNameOfDeclaration(resolvedNode);
	                        if (declarationName) {
	                            var isExternalModuleDeclaration = ts.isModuleWithStringLiteralName(resolvedNode) &&
	                                ts.hasModifier(resolvedNode, 2 /* Ambient */);
	                            var shouldUseAliasName = symbol.name !== "default" && !isExternalModuleDeclaration;
	                            var resolvedInfo = getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, resolvedSymbol, ts.getSourceFileOfNode(resolvedNode), resolvedNode, declarationName, semanticMeaning, shouldUseAliasName ? symbol : resolvedSymbol);
	                            displayParts.push.apply(displayParts, resolvedInfo.displayParts);
	                            displayParts.push(ts.lineBreakPart());
	                            documentationFromAlias = resolvedInfo.documentation;
	                        }
	                    }
	                }
	                switch (symbol.declarations[0].kind) {
	                    case 240 /* NamespaceExportDeclaration */:
	                        displayParts.push(ts.keywordPart(84 /* ExportKeyword */));
	                        displayParts.push(ts.spacePart());
	                        displayParts.push(ts.keywordPart(130 /* NamespaceKeyword */));
	                        break;
	                    case 247 /* ExportAssignment */:
	                        displayParts.push(ts.keywordPart(84 /* ExportKeyword */));
	                        displayParts.push(ts.spacePart());
	                        displayParts.push(ts.keywordPart(symbol.declarations[0].isExportEquals ? 58 /* EqualsToken */ : 79 /* DefaultKeyword */));
	                        break;
	                    default:
	                        displayParts.push(ts.keywordPart(91 /* ImportKeyword */));
	                }
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                ts.forEach(symbol.declarations, function (declaration) {
	                    if (declaration.kind === 241 /* ImportEqualsDeclaration */) {
	                        var importEqualsDeclaration = declaration;
	                        if (ts.isExternalModuleImportEqualsDeclaration(importEqualsDeclaration)) {
	                            displayParts.push(ts.spacePart());
	                            displayParts.push(ts.operatorPart(58 /* EqualsToken */));
	                            displayParts.push(ts.spacePart());
	                            displayParts.push(ts.keywordPart(133 /* RequireKeyword */));
	                            displayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                            displayParts.push(ts.displayPart(ts.getTextOfNode(ts.getExternalModuleImportEqualsDeclarationExpression(importEqualsDeclaration)), ts.SymbolDisplayPartKind.stringLiteral));
	                            displayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                        }
	                        else {
	                            var internalAliasSymbol = typeChecker.getSymbolAtLocation(importEqualsDeclaration.moduleReference);
	                            if (internalAliasSymbol) {
	                                displayParts.push(ts.spacePart());
	                                displayParts.push(ts.operatorPart(58 /* EqualsToken */));
	                                displayParts.push(ts.spacePart());
	                                addFullSymbolName(internalAliasSymbol, enclosingDeclaration);
	                            }
	                        }
	                        return true;
	                    }
	                });
	            }
	            if (!hasAddedSymbolInfo) {
	                if (symbolKind !== "" /* unknown */) {
	                    if (type) {
	                        if (isThisExpression) {
	                            prefixNextMeaning();
	                            displayParts.push(ts.keywordPart(99 /* ThisKeyword */));
	                        }
	                        else {
	                            addPrefixForAnyFunctionOrVar(symbol, symbolKind);
	                        }
	                        // For properties, variables and local vars: show the type
	                        if (symbolKind === "property" /* memberVariableElement */ ||
	                            symbolKind === "JSX attribute" /* jsxAttribute */ ||
	                            symbolFlags & 3 /* Variable */ ||
	                            symbolKind === "local var" /* localVariableElement */ ||
	                            isThisExpression) {
	                            displayParts.push(ts.punctuationPart(56 /* ColonToken */));
	                            displayParts.push(ts.spacePart());
	                            // If the type is type parameter, format it specially
	                            if (type.symbol && type.symbol.flags & 262144 /* TypeParameter */) {
	                                var typeParameterParts = ts.mapToDisplayParts(function (writer) {
	                                    var param = typeChecker.typeParameterToDeclaration(type, enclosingDeclaration);
	                                    getPrinter().writeNode(4 /* Unspecified */, param, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosingDeclaration)), writer);
	                                });
	                                ts.addRange(displayParts, typeParameterParts);
	                            }
	                            else {
	                                ts.addRange(displayParts, ts.typeToDisplayParts(typeChecker, type, enclosingDeclaration));
	                            }
	                        }
	                        else if (symbolFlags & 16 /* Function */ ||
	                            symbolFlags & 8192 /* Method */ ||
	                            symbolFlags & 16384 /* Constructor */ ||
	                            symbolFlags & 131072 /* Signature */ ||
	                            symbolFlags & 98304 /* Accessor */ ||
	                            symbolKind === "method" /* memberFunctionElement */) {
	                            var allSignatures = type.getNonNullableType().getCallSignatures();
	                            if (allSignatures.length) {
	                                addSignatureDisplayParts(allSignatures[0], allSignatures);
	                            }
	                        }
	                    }
	                }
	                else {
	                    symbolKind = getSymbolKind(typeChecker, symbol, location);
	                }
	            }
	            if (!documentation) {
	                documentation = symbol.getDocumentationComment(typeChecker);
	                tags = symbol.getJsDocTags();
	                if (documentation.length === 0 && symbolFlags & 4 /* Property */) {
	                    // For some special property access expressions like `exports.foo = foo` or `module.exports.foo = foo`
	                    // there documentation comments might be attached to the right hand side symbol of their declarations.
	                    // The pattern of such special property access is that the parent symbol is the symbol of the file.
	                    if (symbol.parent && ts.forEach(symbol.parent.declarations, function (declaration) { return declaration.kind === 272 /* SourceFile */; })) {
	                        for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                            var declaration = _a[_i];
	                            if (!declaration.parent || declaration.parent.kind !== 198 /* BinaryExpression */) {
	                                continue;
	                            }
	                            var rhsSymbol = typeChecker.getSymbolAtLocation(declaration.parent.right);
	                            if (!rhsSymbol) {
	                                continue;
	                            }
	                            documentation = rhsSymbol.getDocumentationComment(typeChecker);
	                            tags = rhsSymbol.getJsDocTags();
	                            if (documentation.length > 0) {
	                                break;
	                            }
	                        }
	                    }
	                }
	            }
	            if (documentation.length === 0 && documentationFromAlias) {
	                documentation = documentationFromAlias;
	            }
	            return { displayParts: displayParts, documentation: documentation, symbolKind: symbolKind, tags: tags };
	            function getPrinter() {
	                if (!printer) {
	                    printer = ts.createPrinter({ removeComments: true });
	                }
	                return printer;
	            }
	            function prefixNextMeaning() {
	                if (displayParts.length) {
	                    displayParts.push(ts.lineBreakPart());
	                }
	                addAliasPrefixIfNecessary();
	            }
	            function addAliasPrefixIfNecessary() {
	                if (alias) {
	                    pushTypePart("alias" /* alias */);
	                    displayParts.push(ts.spacePart());
	                }
	            }
	            function addInPrefix() {
	                displayParts.push(ts.spacePart());
	                displayParts.push(ts.keywordPart(92 /* InKeyword */));
	                displayParts.push(ts.spacePart());
	            }
	            function addFullSymbolName(symbolToDisplay, enclosingDeclaration) {
	                if (alias && symbolToDisplay === symbol) {
	                    symbolToDisplay = alias;
	                }
	                var fullSymbolDisplayParts = ts.symbolToDisplayParts(typeChecker, symbolToDisplay, enclosingDeclaration || sourceFile, /*meaning*/ undefined, 1 /* WriteTypeParametersOrArguments */ | 2 /* UseOnlyExternalAliasing */ | 4 /* AllowAnyNodeKind */);
	                ts.addRange(displayParts, fullSymbolDisplayParts);
	            }
	            function addPrefixForAnyFunctionOrVar(symbol, symbolKind) {
	                prefixNextMeaning();
	                if (symbolKind) {
	                    pushTypePart(symbolKind);
	                    if (symbol && !ts.some(symbol.declarations, function (d) { return ts.isArrowFunction(d) || (ts.isFunctionExpression(d) || ts.isClassExpression(d)) && !d.name; })) {
	                        displayParts.push(ts.spacePart());
	                        addFullSymbolName(symbol);
	                    }
	                }
	            }
	            function pushTypePart(symbolKind) {
	                switch (symbolKind) {
	                    case "var" /* variableElement */:
	                    case "function" /* functionElement */:
	                    case "let" /* letElement */:
	                    case "const" /* constElement */:
	                    case "constructor" /* constructorImplementationElement */:
	                        displayParts.push(ts.textOrKeywordPart(symbolKind));
	                        return;
	                    default:
	                        displayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                        displayParts.push(ts.textOrKeywordPart(symbolKind));
	                        displayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                        return;
	                }
	            }
	            function addSignatureDisplayParts(signature, allSignatures, flags) {
	                ts.addRange(displayParts, ts.signatureToDisplayParts(typeChecker, signature, enclosingDeclaration, flags | 32 /* WriteTypeArgumentsOfSignature */));
	                if (allSignatures.length > 1) {
	                    displayParts.push(ts.spacePart());
	                    displayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                    displayParts.push(ts.operatorPart(37 /* PlusToken */));
	                    displayParts.push(ts.displayPart((allSignatures.length - 1).toString(), ts.SymbolDisplayPartKind.numericLiteral));
	                    displayParts.push(ts.spacePart());
	                    displayParts.push(ts.textPart(allSignatures.length === 2 ? "overload" : "overloads"));
	                    displayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                }
	                documentation = signature.getDocumentationComment(typeChecker);
	                tags = signature.getJsDocTags();
	            }
	            function writeTypeParametersOfSymbol(symbol, enclosingDeclaration) {
	                var typeParameterParts = ts.mapToDisplayParts(function (writer) {
	                    var params = typeChecker.symbolToTypeParameterDeclarations(symbol, enclosingDeclaration);
	                    getPrinter().writeList(26896 /* TypeParameters */, params, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosingDeclaration)), writer);
	                });
	                ts.addRange(displayParts, typeParameterParts);
	            }
	        }
	        SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind = getSymbolDisplayPartsDocumentationAndSymbolKind;
	        function isLocalVariableOrFunction(symbol) {
	            if (symbol.parent) {
	                return false; // This is exported symbol
	            }
	            return ts.forEach(symbol.declarations, function (declaration) {
	                // Function expressions are local
	                if (declaration.kind === 190 /* FunctionExpression */) {
	                    return true;
	                }
	                if (declaration.kind !== 230 /* VariableDeclaration */ && declaration.kind !== 232 /* FunctionDeclaration */) {
	                    return false;
	                }
	                // If the parent is not sourceFile or module block it is local variable
	                for (var parent = declaration.parent; !ts.isFunctionBlock(parent); parent = parent.parent) {
	                    // Reached source file or module block
	                    if (parent.kind === 272 /* SourceFile */ || parent.kind === 238 /* ModuleBlock */) {
	                        return false;
	                    }
	                }
	                // parent is in function block
	                return true;
	            });
	        }
	    })(SymbolDisplay = ts.SymbolDisplay || (ts.SymbolDisplay = {}));
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    /*
	     * This function will compile source text from 'input' argument using specified compiler options.
	     * If not options are provided - it will use a set of default compiler options.
	     * Extra compiler options that will unconditionally be used by this function are:
	     * - isolatedModules = true
	     * - allowNonTsExtensions = true
	     * - noLib = true
	     * - noResolve = true
	     */
	    function transpileModule(input, transpileOptions) {
	        var diagnostics = [];
	        var options = transpileOptions.compilerOptions ? fixupCompilerOptions(transpileOptions.compilerOptions, diagnostics) : ts.getDefaultCompilerOptions();
	        options.isolatedModules = true;
	        // transpileModule does not write anything to disk so there is no need to verify that there are no conflicts between input and output paths.
	        options.suppressOutputPathCheck = true;
	        // Filename can be non-ts file.
	        options.allowNonTsExtensions = true;
	        // We are not returning a sourceFile for lib file when asked by the program,
	        // so pass --noLib to avoid reporting a file not found error.
	        options.noLib = true;
	        // Clear out other settings that would not be used in transpiling this module
	        options.lib = undefined;
	        options.types = undefined;
	        options.noEmit = undefined;
	        options.noEmitOnError = undefined;
	        options.paths = undefined;
	        options.rootDirs = undefined;
	        options.declaration = undefined;
	        options.declarationDir = undefined;
	        options.out = undefined;
	        options.outFile = undefined;
	        // We are not doing a full typecheck, we are not resolving the whole context,
	        // so pass --noResolve to avoid reporting missing file errors.
	        options.noResolve = true;
	        // if jsx is specified then treat file as .tsx
	        var inputFileName = transpileOptions.fileName || (options.jsx ? "module.tsx" : "module.ts");
	        var sourceFile = ts.createSourceFile(inputFileName, input, options.target);
	        if (transpileOptions.moduleName) {
	            sourceFile.moduleName = transpileOptions.moduleName;
	        }
	        if (transpileOptions.renamedDependencies) {
	            sourceFile.renamedDependencies = ts.createMapFromTemplate(transpileOptions.renamedDependencies);
	        }
	        var newLine = ts.getNewLineCharacter(options);
	        // Output
	        var outputText;
	        var sourceMapText;
	        // Create a compilerHost object to allow the compiler to read and write files
	        var compilerHost = {
	            getSourceFile: function (fileName) { return fileName === ts.normalizePath(inputFileName) ? sourceFile : undefined; },
	            writeFile: function (name, text) {
	                if (ts.fileExtensionIs(name, ".map")) {
	                    ts.Debug.assertEqual(sourceMapText, undefined, "Unexpected multiple source map outputs, file:", name);
	                    sourceMapText = text;
	                }
	                else {
	                    ts.Debug.assertEqual(outputText, undefined, "Unexpected multiple outputs, file:", name);
	                    outputText = text;
	                }
	            },
	            getDefaultLibFileName: function () { return "lib.d.ts"; },
	            useCaseSensitiveFileNames: function () { return false; },
	            getCanonicalFileName: function (fileName) { return fileName; },
	            getCurrentDirectory: function () { return ""; },
	            getNewLine: function () { return newLine; },
	            fileExists: function (fileName) { return fileName === inputFileName; },
	            readFile: function () { return ""; },
	            directoryExists: function () { return true; },
	            getDirectories: function () { return []; }
	        };
	        var program = ts.createProgram([inputFileName], options, compilerHost);
	        if (transpileOptions.reportDiagnostics) {
	            ts.addRange(/*to*/ diagnostics, /*from*/ program.getSyntacticDiagnostics(sourceFile));
	            ts.addRange(/*to*/ diagnostics, /*from*/ program.getOptionsDiagnostics());
	        }
	        // Emit
	        program.emit(/*targetSourceFile*/ undefined, /*writeFile*/ undefined, /*cancellationToken*/ undefined, /*emitOnlyDtsFiles*/ undefined, transpileOptions.transformers);
	        ts.Debug.assert(outputText !== undefined, "Output generation failed");
	        return { outputText: outputText, diagnostics: diagnostics, sourceMapText: sourceMapText };
	    }
	    ts.transpileModule = transpileModule;
	    /*
	     * This is a shortcut function for transpileModule - it accepts transpileOptions as parameters and returns only outputText part of the result.
	     */
	    function transpile(input, compilerOptions, fileName, diagnostics, moduleName) {
	        var output = transpileModule(input, { compilerOptions: compilerOptions, fileName: fileName, reportDiagnostics: !!diagnostics, moduleName: moduleName });
	        // addRange correctly handles cases when wither 'from' or 'to' argument is missing
	        ts.addRange(diagnostics, output.diagnostics);
	        return output.outputText;
	    }
	    ts.transpile = transpile;
	    var commandLineOptionsStringToEnum;
	    /** JS users may pass in string values for enum compiler options (such as ModuleKind), so convert. */
	    /*@internal*/
	    function fixupCompilerOptions(options, diagnostics) {
	        // Lazily create this value to fix module loading errors.
	        commandLineOptionsStringToEnum = commandLineOptionsStringToEnum || ts.filter(ts.optionDeclarations, function (o) {
	            return typeof o.type === "object" && !ts.forEachEntry(o.type, function (v) { return typeof v !== "number"; });
	        });
	        options = ts.cloneCompilerOptions(options);
	        var _loop_9 = function (opt) {
	            if (!ts.hasProperty(options, opt.name)) {
	                return "continue";
	            }
	            var value = options[opt.name];
	            // Value should be a key of opt.type
	            if (ts.isString(value)) {
	                // If value is not a string, this will fail
	                options[opt.name] = ts.parseCustomTypeOption(opt, value, diagnostics);
	            }
	            else {
	                if (!ts.forEachEntry(opt.type, function (v) { return v === value; })) {
	                    // Supplied value isn't a valid enum value.
	                    diagnostics.push(ts.createCompilerDiagnosticForInvalidCustomType(opt));
	                }
	            }
	        };
	        for (var _i = 0, commandLineOptionsStringToEnum_1 = commandLineOptionsStringToEnum; _i < commandLineOptionsStringToEnum_1.length; _i++) {
	            var opt = commandLineOptionsStringToEnum_1[_i];
	            _loop_9(opt);
	        }
	        return options;
	    }
	    ts.fixupCompilerOptions = fixupCompilerOptions;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        var FormattingRequestKind;
	        (function (FormattingRequestKind) {
	            FormattingRequestKind[FormattingRequestKind["FormatDocument"] = 0] = "FormatDocument";
	            FormattingRequestKind[FormattingRequestKind["FormatSelection"] = 1] = "FormatSelection";
	            FormattingRequestKind[FormattingRequestKind["FormatOnEnter"] = 2] = "FormatOnEnter";
	            FormattingRequestKind[FormattingRequestKind["FormatOnSemicolon"] = 3] = "FormatOnSemicolon";
	            FormattingRequestKind[FormattingRequestKind["FormatOnOpeningCurlyBrace"] = 4] = "FormatOnOpeningCurlyBrace";
	            FormattingRequestKind[FormattingRequestKind["FormatOnClosingCurlyBrace"] = 5] = "FormatOnClosingCurlyBrace";
	        })(FormattingRequestKind = formatting.FormattingRequestKind || (formatting.FormattingRequestKind = {}));
	        var FormattingContext = /** @class */ (function () {
	            function FormattingContext(sourceFile, formattingRequestKind, options) {
	                this.sourceFile = sourceFile;
	                this.formattingRequestKind = formattingRequestKind;
	                this.options = options;
	            }
	            FormattingContext.prototype.updateContext = function (currentRange, currentTokenParent, nextRange, nextTokenParent, commonParent) {
	                ts.Debug.assert(currentRange !== undefined, "currentTokenSpan is null");
	                ts.Debug.assert(currentTokenParent !== undefined, "currentTokenParent is null");
	                ts.Debug.assert(nextRange !== undefined, "nextTokenSpan is null");
	                ts.Debug.assert(nextTokenParent !== undefined, "nextTokenParent is null");
	                ts.Debug.assert(commonParent !== undefined, "commonParent is null");
	                this.currentTokenSpan = currentRange;
	                this.currentTokenParent = currentTokenParent;
	                this.nextTokenSpan = nextRange;
	                this.nextTokenParent = nextTokenParent;
	                this.contextNode = commonParent;
	                // drop cached results
	                this.contextNodeAllOnSameLine = undefined;
	                this.nextNodeAllOnSameLine = undefined;
	                this.tokensAreOnSameLine = undefined;
	                this.contextNodeBlockIsOnOneLine = undefined;
	                this.nextNodeBlockIsOnOneLine = undefined;
	            };
	            FormattingContext.prototype.ContextNodeAllOnSameLine = function () {
	                if (this.contextNodeAllOnSameLine === undefined) {
	                    this.contextNodeAllOnSameLine = this.NodeIsOnOneLine(this.contextNode);
	                }
	                return this.contextNodeAllOnSameLine;
	            };
	            FormattingContext.prototype.NextNodeAllOnSameLine = function () {
	                if (this.nextNodeAllOnSameLine === undefined) {
	                    this.nextNodeAllOnSameLine = this.NodeIsOnOneLine(this.nextTokenParent);
	                }
	                return this.nextNodeAllOnSameLine;
	            };
	            FormattingContext.prototype.TokensAreOnSameLine = function () {
	                if (this.tokensAreOnSameLine === undefined) {
	                    var startLine = this.sourceFile.getLineAndCharacterOfPosition(this.currentTokenSpan.pos).line;
	                    var endLine = this.sourceFile.getLineAndCharacterOfPosition(this.nextTokenSpan.pos).line;
	                    this.tokensAreOnSameLine = (startLine === endLine);
	                }
	                return this.tokensAreOnSameLine;
	            };
	            FormattingContext.prototype.ContextNodeBlockIsOnOneLine = function () {
	                if (this.contextNodeBlockIsOnOneLine === undefined) {
	                    this.contextNodeBlockIsOnOneLine = this.BlockIsOnOneLine(this.contextNode);
	                }
	                return this.contextNodeBlockIsOnOneLine;
	            };
	            FormattingContext.prototype.NextNodeBlockIsOnOneLine = function () {
	                if (this.nextNodeBlockIsOnOneLine === undefined) {
	                    this.nextNodeBlockIsOnOneLine = this.BlockIsOnOneLine(this.nextTokenParent);
	                }
	                return this.nextNodeBlockIsOnOneLine;
	            };
	            FormattingContext.prototype.NodeIsOnOneLine = function (node) {
	                var startLine = this.sourceFile.getLineAndCharacterOfPosition(node.getStart(this.sourceFile)).line;
	                var endLine = this.sourceFile.getLineAndCharacterOfPosition(node.getEnd()).line;
	                return startLine === endLine;
	            };
	            FormattingContext.prototype.BlockIsOnOneLine = function (node) {
	                var openBrace = ts.findChildOfKind(node, 17 /* OpenBraceToken */, this.sourceFile);
	                var closeBrace = ts.findChildOfKind(node, 18 /* CloseBraceToken */, this.sourceFile);
	                if (openBrace && closeBrace) {
	                    var startLine = this.sourceFile.getLineAndCharacterOfPosition(openBrace.getEnd()).line;
	                    var endLine = this.sourceFile.getLineAndCharacterOfPosition(closeBrace.getStart(this.sourceFile)).line;
	                    return startLine === endLine;
	                }
	                return false;
	            };
	            return FormattingContext;
	        }());
	        formatting.FormattingContext = FormattingContext;
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/// <reference path="formatting.ts"/>
	/// <reference path="..\..\compiler\scanner.ts"/>
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        var standardScanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false, 0 /* Standard */);
	        var jsxScanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false, 1 /* JSX */);
	        var ScanAction;
	        (function (ScanAction) {
	            ScanAction[ScanAction["Scan"] = 0] = "Scan";
	            ScanAction[ScanAction["RescanGreaterThanToken"] = 1] = "RescanGreaterThanToken";
	            ScanAction[ScanAction["RescanSlashToken"] = 2] = "RescanSlashToken";
	            ScanAction[ScanAction["RescanTemplateToken"] = 3] = "RescanTemplateToken";
	            ScanAction[ScanAction["RescanJsxIdentifier"] = 4] = "RescanJsxIdentifier";
	            ScanAction[ScanAction["RescanJsxText"] = 5] = "RescanJsxText";
	        })(ScanAction || (ScanAction = {}));
	        function getFormattingScanner(text, languageVariant, startPos, endPos, cb) {
	            var scanner = languageVariant === 1 /* JSX */ ? jsxScanner : standardScanner;
	            scanner.setText(text);
	            scanner.setTextPos(startPos);
	            var wasNewLine = true;
	            var leadingTrivia;
	            var trailingTrivia;
	            var savedPos;
	            var lastScanAction;
	            var lastTokenInfo;
	            var res = cb({
	                advance: advance,
	                readTokenInfo: readTokenInfo,
	                isOnToken: isOnToken,
	                getCurrentLeadingTrivia: function () { return leadingTrivia; },
	                lastTrailingTriviaWasNewLine: function () { return wasNewLine; },
	                skipToEndOf: skipToEndOf,
	            });
	            lastTokenInfo = undefined;
	            scanner.setText(undefined);
	            return res;
	            function advance() {
	                lastTokenInfo = undefined;
	                var isStarted = scanner.getStartPos() !== startPos;
	                if (isStarted) {
	                    wasNewLine = trailingTrivia && ts.lastOrUndefined(trailingTrivia).kind === 4 /* NewLineTrivia */;
	                }
	                else {
	                    scanner.scan();
	                }
	                leadingTrivia = undefined;
	                trailingTrivia = undefined;
	                var pos = scanner.getStartPos();
	                // Read leading trivia and token
	                while (pos < endPos) {
	                    var t = scanner.getToken();
	                    if (!ts.isTrivia(t)) {
	                        break;
	                    }
	                    // consume leading trivia
	                    scanner.scan();
	                    var item = {
	                        pos: pos,
	                        end: scanner.getStartPos(),
	                        kind: t
	                    };
	                    pos = scanner.getStartPos();
	                    leadingTrivia = ts.append(leadingTrivia, item);
	                }
	                savedPos = scanner.getStartPos();
	            }
	            function shouldRescanGreaterThanToken(node) {
	                switch (node.kind) {
	                    case 31 /* GreaterThanEqualsToken */:
	                    case 66 /* GreaterThanGreaterThanEqualsToken */:
	                    case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                    case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                    case 46 /* GreaterThanGreaterThanToken */:
	                        return true;
	                }
	                return false;
	            }
	            function shouldRescanJsxIdentifier(node) {
	                if (node.parent) {
	                    switch (node.parent.kind) {
	                        case 260 /* JsxAttribute */:
	                        case 255 /* JsxOpeningElement */:
	                        case 256 /* JsxClosingElement */:
	                        case 254 /* JsxSelfClosingElement */:
	                            // May parse an identifier like `module-layout`; that will be scanned as a keyword at first, but we should parse the whole thing to get an identifier.
	                            return ts.isKeyword(node.kind) || node.kind === 71 /* Identifier */;
	                    }
	                }
	                return false;
	            }
	            function shouldRescanJsxText(node) {
	                return node.kind === 10 /* JsxText */;
	            }
	            function shouldRescanSlashToken(container) {
	                return container.kind === 12 /* RegularExpressionLiteral */;
	            }
	            function shouldRescanTemplateToken(container) {
	                return container.kind === 15 /* TemplateMiddle */ ||
	                    container.kind === 16 /* TemplateTail */;
	            }
	            function startsWithSlashToken(t) {
	                return t === 41 /* SlashToken */ || t === 63 /* SlashEqualsToken */;
	            }
	            function readTokenInfo(n) {
	                ts.Debug.assert(isOnToken());
	                // normally scanner returns the smallest available token
	                // check the kind of context node to determine if scanner should have more greedy behavior and consume more text.
	                var expectedScanAction = shouldRescanGreaterThanToken(n)
	                    ? 1 /* RescanGreaterThanToken */
	                    : shouldRescanSlashToken(n)
	                        ? 2 /* RescanSlashToken */
	                        : shouldRescanTemplateToken(n)
	                            ? 3 /* RescanTemplateToken */
	                            : shouldRescanJsxIdentifier(n)
	                                ? 4 /* RescanJsxIdentifier */
	                                : shouldRescanJsxText(n)
	                                    ? 5 /* RescanJsxText */
	                                    : 0 /* Scan */;
	                if (lastTokenInfo && expectedScanAction === lastScanAction) {
	                    // readTokenInfo was called before with the same expected scan action.
	                    // No need to re-scan text, return existing 'lastTokenInfo'
	                    // it is ok to call fixTokenKind here since it does not affect
	                    // what portion of text is consumed. In contrast rescanning can change it,
	                    // i.e. for '>=' when originally scanner eats just one character
	                    // and rescanning forces it to consume more.
	                    return fixTokenKind(lastTokenInfo, n);
	                }
	                if (scanner.getStartPos() !== savedPos) {
	                    ts.Debug.assert(lastTokenInfo !== undefined);
	                    // readTokenInfo was called before but scan action differs - rescan text
	                    scanner.setTextPos(savedPos);
	                    scanner.scan();
	                }
	                var currentToken = getNextToken(n, expectedScanAction);
	                var token = {
	                    pos: scanner.getStartPos(),
	                    end: scanner.getTextPos(),
	                    kind: currentToken
	                };
	                // consume trailing trivia
	                if (trailingTrivia) {
	                    trailingTrivia = undefined;
	                }
	                while (scanner.getStartPos() < endPos) {
	                    currentToken = scanner.scan();
	                    if (!ts.isTrivia(currentToken)) {
	                        break;
	                    }
	                    var trivia = {
	                        pos: scanner.getStartPos(),
	                        end: scanner.getTextPos(),
	                        kind: currentToken
	                    };
	                    if (!trailingTrivia) {
	                        trailingTrivia = [];
	                    }
	                    trailingTrivia.push(trivia);
	                    if (currentToken === 4 /* NewLineTrivia */) {
	                        // move past new line
	                        scanner.scan();
	                        break;
	                    }
	                }
	                lastTokenInfo = { leadingTrivia: leadingTrivia, trailingTrivia: trailingTrivia, token: token };
	                return fixTokenKind(lastTokenInfo, n);
	            }
	            function getNextToken(n, expectedScanAction) {
	                var token = scanner.getToken();
	                lastScanAction = 0 /* Scan */;
	                switch (expectedScanAction) {
	                    case 1 /* RescanGreaterThanToken */:
	                        if (token === 29 /* GreaterThanToken */) {
	                            lastScanAction = 1 /* RescanGreaterThanToken */;
	                            var newToken = scanner.reScanGreaterToken();
	                            ts.Debug.assert(n.kind === newToken);
	                            return newToken;
	                        }
	                        break;
	                    case 2 /* RescanSlashToken */:
	                        if (startsWithSlashToken(token)) {
	                            lastScanAction = 2 /* RescanSlashToken */;
	                            var newToken = scanner.reScanSlashToken();
	                            ts.Debug.assert(n.kind === newToken);
	                            return newToken;
	                        }
	                        break;
	                    case 3 /* RescanTemplateToken */:
	                        if (token === 18 /* CloseBraceToken */) {
	                            lastScanAction = 3 /* RescanTemplateToken */;
	                            return scanner.reScanTemplateToken();
	                        }
	                        break;
	                    case 4 /* RescanJsxIdentifier */:
	                        lastScanAction = 4 /* RescanJsxIdentifier */;
	                        return scanner.scanJsxIdentifier();
	                    case 5 /* RescanJsxText */:
	                        lastScanAction = 5 /* RescanJsxText */;
	                        return scanner.reScanJsxToken();
	                    case 0 /* Scan */:
	                        break;
	                    default:
	                        ts.Debug.assertNever(expectedScanAction);
	                }
	                return token;
	            }
	            function isOnToken() {
	                var current = lastTokenInfo ? lastTokenInfo.token.kind : scanner.getToken();
	                var startPos = lastTokenInfo ? lastTokenInfo.token.pos : scanner.getStartPos();
	                return startPos < endPos && current !== 1 /* EndOfFileToken */ && !ts.isTrivia(current);
	            }
	            // when containing node in the tree is token
	            // but its kind differs from the kind that was returned by the scanner,
	            // then kind needs to be fixed. This might happen in cases
	            // when parser interprets token differently, i.e keyword treated as identifier
	            function fixTokenKind(tokenInfo, container) {
	                if (ts.isToken(container) && tokenInfo.token.kind !== container.kind) {
	                    tokenInfo.token.kind = container.kind;
	                }
	                return tokenInfo;
	            }
	            function skipToEndOf(node) {
	                scanner.setTextPos(node.end);
	                savedPos = scanner.getStartPos();
	                lastScanAction = undefined;
	                lastTokenInfo = undefined;
	                wasNewLine = false;
	                leadingTrivia = undefined;
	                trailingTrivia = undefined;
	            }
	        }
	        formatting.getFormattingScanner = getFormattingScanner;
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        formatting.anyContext = ts.emptyArray;
	        var RuleAction;
	        (function (RuleAction) {
	            RuleAction[RuleAction["Ignore"] = 1] = "Ignore";
	            RuleAction[RuleAction["Space"] = 2] = "Space";
	            RuleAction[RuleAction["NewLine"] = 4] = "NewLine";
	            RuleAction[RuleAction["Delete"] = 8] = "Delete";
	        })(RuleAction = formatting.RuleAction || (formatting.RuleAction = {}));
	        var RuleFlags;
	        (function (RuleFlags) {
	            RuleFlags[RuleFlags["None"] = 0] = "None";
	            RuleFlags[RuleFlags["CanDeleteNewLines"] = 1] = "CanDeleteNewLines";
	        })(RuleFlags = formatting.RuleFlags || (formatting.RuleFlags = {}));
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        function getAllRules() {
	            var allTokens = [];
	            for (var token = 0 /* FirstToken */; token <= 144 /* LastToken */; token++) {
	                allTokens.push(token);
	            }
	            function anyTokenExcept() {
	                var tokens = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    tokens[_i] = arguments[_i];
	                }
	                return { tokens: allTokens.filter(function (t) { return !tokens.some(function (t2) { return t2 === t; }); }), isSpecific: false };
	            }
	            var anyToken = { tokens: allTokens, isSpecific: false };
	            var anyTokenIncludingMultilineComments = tokenRangeFrom(allTokens.concat([3 /* MultiLineCommentTrivia */]));
	            var keywords = tokenRangeFromRange(72 /* FirstKeyword */, 144 /* LastKeyword */);
	            var binaryOperators = tokenRangeFromRange(27 /* FirstBinaryOperator */, 70 /* LastBinaryOperator */);
	            var binaryKeywordOperators = [92 /* InKeyword */, 93 /* InstanceOfKeyword */, 144 /* OfKeyword */, 118 /* AsKeyword */, 127 /* IsKeyword */];
	            var unaryPrefixOperators = [43 /* PlusPlusToken */, 44 /* MinusMinusToken */, 52 /* TildeToken */, 51 /* ExclamationToken */];
	            var unaryPrefixExpressions = [
	                8 /* NumericLiteral */, 71 /* Identifier */, 19 /* OpenParenToken */, 21 /* OpenBracketToken */,
	                17 /* OpenBraceToken */, 99 /* ThisKeyword */, 94 /* NewKeyword */
	            ];
	            var unaryPreincrementExpressions = [71 /* Identifier */, 19 /* OpenParenToken */, 99 /* ThisKeyword */, 94 /* NewKeyword */];
	            var unaryPostincrementExpressions = [71 /* Identifier */, 20 /* CloseParenToken */, 22 /* CloseBracketToken */, 94 /* NewKeyword */];
	            var unaryPredecrementExpressions = [71 /* Identifier */, 19 /* OpenParenToken */, 99 /* ThisKeyword */, 94 /* NewKeyword */];
	            var unaryPostdecrementExpressions = [71 /* Identifier */, 20 /* CloseParenToken */, 22 /* CloseBracketToken */, 94 /* NewKeyword */];
	            var comments = [2 /* SingleLineCommentTrivia */, 3 /* MultiLineCommentTrivia */];
	            var typeNames = [71 /* Identifier */].concat(ts.typeKeywords);
	            // Place a space before open brace in a function declaration
	            // TypeScript: Function can have return types, which can be made of tons of different token kinds
	            var functionOpenBraceLeftTokenRange = anyTokenIncludingMultilineComments;
	            // Place a space before open brace in a TypeScript declaration that has braces as children (class, module, enum, etc)
	            var typeScriptOpenBraceLeftTokenRange = tokenRangeFrom([71 /* Identifier */, 3 /* MultiLineCommentTrivia */, 75 /* ClassKeyword */, 84 /* ExportKeyword */, 91 /* ImportKeyword */]);
	            // Place a space before open brace in a control flow construct
	            var controlOpenBraceLeftTokenRange = tokenRangeFrom([20 /* CloseParenToken */, 3 /* MultiLineCommentTrivia */, 81 /* DoKeyword */, 102 /* TryKeyword */, 87 /* FinallyKeyword */, 82 /* ElseKeyword */]);
	            // These rules are higher in priority than user-configurable
	            var highPriorityCommonRules = [
	                // Leave comments alone
	                rule("IgnoreBeforeComment", anyToken, comments, formatting.anyContext, 1 /* Ignore */),
	                rule("IgnoreAfterLineComment", 2 /* SingleLineCommentTrivia */, anyToken, formatting.anyContext, 1 /* Ignore */),
	                rule("NotSpaceBeforeColon", anyToken, 56 /* ColonToken */, [isNonJsxSameLineTokenContext, isNotBinaryOpContext, isNotTypeAnnotationContext], 8 /* Delete */),
	                rule("SpaceAfterColon", 56 /* ColonToken */, anyToken, [isNonJsxSameLineTokenContext, isNotBinaryOpContext], 2 /* Space */),
	                rule("NoSpaceBeforeQuestionMark", anyToken, 55 /* QuestionToken */, [isNonJsxSameLineTokenContext, isNotBinaryOpContext], 8 /* Delete */),
	                // insert space after '?' only when it is used in conditional operator
	                rule("SpaceAfterQuestionMarkInConditionalOperator", 55 /* QuestionToken */, anyToken, [isNonJsxSameLineTokenContext, isConditionalOperatorContext], 2 /* Space */),
	                // in other cases there should be no space between '?' and next token
	                rule("NoSpaceAfterQuestionMark", 55 /* QuestionToken */, anyToken, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeDot", anyToken, 23 /* DotToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterDot", 23 /* DotToken */, anyToken, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Special handling of unary operators.
	                // Prefix operators generally shouldn't have a space between
	                // them and their target unary expression.
	                rule("NoSpaceAfterUnaryPrefixOperator", unaryPrefixOperators, unaryPrefixExpressions, [isNonJsxSameLineTokenContext, isNotBinaryOpContext], 8 /* Delete */),
	                rule("NoSpaceAfterUnaryPreincrementOperator", 43 /* PlusPlusToken */, unaryPreincrementExpressions, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterUnaryPredecrementOperator", 44 /* MinusMinusToken */, unaryPredecrementExpressions, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeUnaryPostincrementOperator", unaryPostincrementExpressions, 43 /* PlusPlusToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeUnaryPostdecrementOperator", unaryPostdecrementExpressions, 44 /* MinusMinusToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // More unary operator special-casing.
	                // DevDiv 181814: Be careful when removing leading whitespace
	                // around unary operators.  Examples:
	                //      1 - -2  --X--> 1--2
	                //      a + ++b --X--> a+++b
	                rule("SpaceAfterPostincrementWhenFollowedByAdd", 43 /* PlusPlusToken */, 37 /* PlusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterAddWhenFollowedByUnaryPlus", 37 /* PlusToken */, 37 /* PlusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterAddWhenFollowedByPreincrement", 37 /* PlusToken */, 43 /* PlusPlusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterPostdecrementWhenFollowedBySubtract", 44 /* MinusMinusToken */, 38 /* MinusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterSubtractWhenFollowedByUnaryMinus", 38 /* MinusToken */, 38 /* MinusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterSubtractWhenFollowedByPredecrement", 38 /* MinusToken */, 44 /* MinusMinusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("NoSpaceAfterCloseBrace", 18 /* CloseBraceToken */, [26 /* CommaToken */, 25 /* SemicolonToken */], [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // For functions and control block place } on a new line [multi-line rule]
	                rule("NewLineBeforeCloseBraceInBlockContext", anyTokenIncludingMultilineComments, 18 /* CloseBraceToken */, [isMultilineBlockContext], 4 /* NewLine */),
	                // Space/new line after }.
	                rule("SpaceAfterCloseBrace", 18 /* CloseBraceToken */, anyTokenExcept(20 /* CloseParenToken */), [isNonJsxSameLineTokenContext, isAfterCodeBlockContext], 2 /* Space */),
	                // Special case for (}, else) and (}, while) since else & while tokens are not part of the tree which makes SpaceAfterCloseBrace rule not applied
	                // Also should not apply to })
	                rule("SpaceBetweenCloseBraceAndElse", 18 /* CloseBraceToken */, 82 /* ElseKeyword */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBetweenCloseBraceAndWhile", 18 /* CloseBraceToken */, 106 /* WhileKeyword */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceBetweenEmptyBraceBrackets", 17 /* OpenBraceToken */, 18 /* CloseBraceToken */, [isNonJsxSameLineTokenContext, isObjectContext], 8 /* Delete */),
	                // Add a space after control dec context if the next character is an open bracket ex: 'if (false)[a, b] = [1, 2];' -> 'if (false) [a, b] = [1, 2];'
	                rule("SpaceAfterConditionalClosingParen", 20 /* CloseParenToken */, 21 /* OpenBracketToken */, [isControlDeclContext], 2 /* Space */),
	                rule("NoSpaceBetweenFunctionKeywordAndStar", 89 /* FunctionKeyword */, 39 /* AsteriskToken */, [isFunctionDeclarationOrFunctionExpressionContext], 8 /* Delete */),
	                rule("SpaceAfterStarInGeneratorDeclaration", 39 /* AsteriskToken */, [71 /* Identifier */, 19 /* OpenParenToken */], [isFunctionDeclarationOrFunctionExpressionContext], 2 /* Space */),
	                rule("SpaceAfterFunctionInFuncDecl", 89 /* FunctionKeyword */, anyToken, [isFunctionDeclContext], 2 /* Space */),
	                // Insert new line after { and before } in multi-line contexts.
	                rule("NewLineAfterOpenBraceInBlockContext", 17 /* OpenBraceToken */, anyToken, [isMultilineBlockContext], 4 /* NewLine */),
	                // For get/set members, we check for (identifier,identifier) since get/set don't have tokens and they are represented as just an identifier token.
	                // Though, we do extra check on the context to make sure we are dealing with get/set node. Example:
	                //      get x() {}
	                //      set x(val) {}
	                rule("SpaceAfterGetSetInMember", [125 /* GetKeyword */, 136 /* SetKeyword */], 71 /* Identifier */, [isFunctionDeclContext], 2 /* Space */),
	                rule("NoSpaceBetweenYieldKeywordAndStar", 116 /* YieldKeyword */, 39 /* AsteriskToken */, [isNonJsxSameLineTokenContext, isYieldOrYieldStarWithOperand], 8 /* Delete */),
	                rule("SpaceBetweenYieldOrYieldStarAndOperand", [116 /* YieldKeyword */, 39 /* AsteriskToken */], anyToken, [isNonJsxSameLineTokenContext, isYieldOrYieldStarWithOperand], 2 /* Space */),
	                rule("NoSpaceBetweenReturnAndSemicolon", 96 /* ReturnKeyword */, 25 /* SemicolonToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("SpaceAfterCertainKeywords", [104 /* VarKeyword */, 100 /* ThrowKeyword */, 94 /* NewKeyword */, 80 /* DeleteKeyword */, 96 /* ReturnKeyword */, 103 /* TypeOfKeyword */, 121 /* AwaitKeyword */], anyToken, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceAfterLetConstInVariableDeclaration", [110 /* LetKeyword */, 76 /* ConstKeyword */], anyToken, [isNonJsxSameLineTokenContext, isStartOfVariableDeclarationList], 2 /* Space */),
	                rule("NoSpaceBeforeOpenParenInFuncCall", anyToken, 19 /* OpenParenToken */, [isNonJsxSameLineTokenContext, isFunctionCallOrNewContext, isPreviousTokenNotComma], 8 /* Delete */),
	                // Special case for binary operators (that are keywords). For these we have to add a space and shouldn't follow any user options.
	                rule("SpaceBeforeBinaryKeywordOperator", anyToken, binaryKeywordOperators, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterBinaryKeywordOperator", binaryKeywordOperators, anyToken, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterVoidOperator", 105 /* VoidKeyword */, anyToken, [isNonJsxSameLineTokenContext, isVoidOpContext], 2 /* Space */),
	                // Async-await
	                rule("SpaceBetweenAsyncAndOpenParen", 120 /* AsyncKeyword */, 19 /* OpenParenToken */, [isArrowFunctionContext, isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBetweenAsyncAndFunctionKeyword", 120 /* AsyncKeyword */, 89 /* FunctionKeyword */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // template string
	                rule("NoSpaceBetweenTagAndTemplateString", 71 /* Identifier */, [13 /* NoSubstitutionTemplateLiteral */, 14 /* TemplateHead */], [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // JSX opening elements
	                rule("SpaceBeforeJsxAttribute", anyToken, 71 /* Identifier */, [isNextTokenParentJsxAttribute, isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeSlashInJsxOpeningElement", anyToken, 41 /* SlashToken */, [isJsxSelfClosingElementContext, isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceBeforeGreaterThanTokenInJsxOpeningElement", 41 /* SlashToken */, 29 /* GreaterThanToken */, [isJsxSelfClosingElementContext, isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeEqualInJsxAttribute", anyToken, 58 /* EqualsToken */, [isJsxAttributeContext, isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterEqualInJsxAttribute", 58 /* EqualsToken */, anyToken, [isJsxAttributeContext, isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // TypeScript-specific rules
	                // Use of module as a function call. e.g.: import m2 = module("m2");
	                rule("NoSpaceAfterModuleImport", [129 /* ModuleKeyword */, 133 /* RequireKeyword */], 19 /* OpenParenToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Add a space around certain TypeScript keywords
	                rule("SpaceAfterCertainTypeScriptKeywords", [
	                    117 /* AbstractKeyword */,
	                    75 /* ClassKeyword */,
	                    124 /* DeclareKeyword */,
	                    79 /* DefaultKeyword */,
	                    83 /* EnumKeyword */,
	                    84 /* ExportKeyword */,
	                    85 /* ExtendsKeyword */,
	                    125 /* GetKeyword */,
	                    108 /* ImplementsKeyword */,
	                    91 /* ImportKeyword */,
	                    109 /* InterfaceKeyword */,
	                    129 /* ModuleKeyword */,
	                    130 /* NamespaceKeyword */,
	                    112 /* PrivateKeyword */,
	                    114 /* PublicKeyword */,
	                    113 /* ProtectedKeyword */,
	                    132 /* ReadonlyKeyword */,
	                    136 /* SetKeyword */,
	                    115 /* StaticKeyword */,
	                    139 /* TypeKeyword */,
	                    142 /* FromKeyword */,
	                    128 /* KeyOfKeyword */,
	                    126 /* InferKeyword */,
	                ], anyToken, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeCertainTypeScriptKeywords", anyToken, [85 /* ExtendsKeyword */, 108 /* ImplementsKeyword */, 142 /* FromKeyword */], [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Treat string literals in module names as identifiers, and add a space between the literal and the opening Brace braces, e.g.: module "m2" {
	                rule("SpaceAfterModuleName", 9 /* StringLiteral */, 17 /* OpenBraceToken */, [isModuleDeclContext], 2 /* Space */),
	                // Lambda expressions
	                rule("SpaceBeforeArrow", anyToken, 36 /* EqualsGreaterThanToken */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceAfterArrow", 36 /* EqualsGreaterThanToken */, anyToken, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Optional parameters and let args
	                rule("NoSpaceAfterEllipsis", 24 /* DotDotDotToken */, 71 /* Identifier */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterOptionalParameters", 55 /* QuestionToken */, [20 /* CloseParenToken */, 26 /* CommaToken */], [isNonJsxSameLineTokenContext, isNotBinaryOpContext], 8 /* Delete */),
	                // Remove spaces in empty interface literals. e.g.: x: {}
	                rule("NoSpaceBetweenEmptyInterfaceBraceBrackets", 17 /* OpenBraceToken */, 18 /* CloseBraceToken */, [isNonJsxSameLineTokenContext, isObjectTypeContext], 8 /* Delete */),
	                // generics and type assertions
	                rule("NoSpaceBeforeOpenAngularBracket", typeNames, 27 /* LessThanToken */, [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                rule("NoSpaceBetweenCloseParenAndAngularBracket", 20 /* CloseParenToken */, 27 /* LessThanToken */, [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                rule("NoSpaceAfterOpenAngularBracket", 27 /* LessThanToken */, anyToken, [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseAngularBracket", anyToken, 29 /* GreaterThanToken */, [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                rule("NoSpaceAfterCloseAngularBracket", 29 /* GreaterThanToken */, [19 /* OpenParenToken */, 21 /* OpenBracketToken */, 29 /* GreaterThanToken */, 26 /* CommaToken */], [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                // decorators
	                rule("SpaceBeforeAt", [20 /* CloseParenToken */, 71 /* Identifier */], 57 /* AtToken */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceAfterAt", 57 /* AtToken */, anyToken, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Insert space after @ in decorator
	                rule("SpaceAfterDecorator", anyToken, [
	                    117 /* AbstractKeyword */,
	                    71 /* Identifier */,
	                    84 /* ExportKeyword */,
	                    79 /* DefaultKeyword */,
	                    75 /* ClassKeyword */,
	                    115 /* StaticKeyword */,
	                    114 /* PublicKeyword */,
	                    112 /* PrivateKeyword */,
	                    113 /* ProtectedKeyword */,
	                    125 /* GetKeyword */,
	                    136 /* SetKeyword */,
	                    21 /* OpenBracketToken */,
	                    39 /* AsteriskToken */,
	                ], [isEndOfDecoratorContextOnSameLine], 2 /* Space */),
	                rule("NoSpaceBeforeNonNullAssertionOperator", anyToken, 51 /* ExclamationToken */, [isNonJsxSameLineTokenContext, isNonNullAssertionContext], 8 /* Delete */),
	                rule("NoSpaceAfterNewKeywordOnConstructorSignature", 94 /* NewKeyword */, 19 /* OpenParenToken */, [isNonJsxSameLineTokenContext, isConstructorSignatureContext], 8 /* Delete */),
	            ];
	            // These rules are applied after high priority
	            var userConfigurableRules = [
	                // Treat constructor as an identifier in a function declaration, and remove spaces between constructor and following left parentheses
	                rule("SpaceAfterConstructor", 123 /* ConstructorKeyword */, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceAfterConstructor"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceAfterConstructor", 123 /* ConstructorKeyword */, 19 /* OpenParenToken */, [isOptionDisabledOrUndefined("insertSpaceAfterConstructor"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("SpaceAfterComma", 26 /* CommaToken */, anyToken, [isOptionEnabled("insertSpaceAfterCommaDelimiter"), isNonJsxSameLineTokenContext, isNonJsxElementOrFragmentContext, isNextTokenNotCloseBracket], 2 /* Space */),
	                rule("NoSpaceAfterComma", 26 /* CommaToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterCommaDelimiter"), isNonJsxSameLineTokenContext, isNonJsxElementOrFragmentContext], 8 /* Delete */),
	                // Insert space after function keyword for anonymous functions
	                rule("SpaceAfterAnonymousFunctionKeyword", 89 /* FunctionKeyword */, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceAfterFunctionKeywordForAnonymousFunctions"), isFunctionDeclContext], 2 /* Space */),
	                rule("NoSpaceAfterAnonymousFunctionKeyword", 89 /* FunctionKeyword */, 19 /* OpenParenToken */, [isOptionDisabledOrUndefined("insertSpaceAfterFunctionKeywordForAnonymousFunctions"), isFunctionDeclContext], 8 /* Delete */),
	                // Insert space after keywords in control flow statements
	                rule("SpaceAfterKeywordInControl", keywords, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceAfterKeywordsInControlFlowStatements"), isControlDeclContext], 2 /* Space */),
	                rule("NoSpaceAfterKeywordInControl", keywords, 19 /* OpenParenToken */, [isOptionDisabledOrUndefined("insertSpaceAfterKeywordsInControlFlowStatements"), isControlDeclContext], 8 /* Delete */),
	                // Insert space after opening and before closing nonempty parenthesis
	                rule("SpaceAfterOpenParen", 19 /* OpenParenToken */, anyToken, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeCloseParen", anyToken, 20 /* CloseParenToken */, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBetweenOpenParens", 19 /* OpenParenToken */, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceBetweenParens", 19 /* OpenParenToken */, 20 /* CloseParenToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterOpenParen", 19 /* OpenParenToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseParen", anyToken, 20 /* CloseParenToken */, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Insert space after opening and before closing nonempty brackets
	                rule("SpaceAfterOpenBracket", 21 /* OpenBracketToken */, anyToken, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeCloseBracket", anyToken, 22 /* CloseBracketToken */, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceBetweenBrackets", 21 /* OpenBracketToken */, 22 /* CloseBracketToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterOpenBracket", 21 /* OpenBracketToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseBracket", anyToken, 22 /* CloseBracketToken */, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Insert a space after { and before } in single-line contexts, but remove space from empty object literals {}.
	                rule("SpaceAfterOpenBrace", 17 /* OpenBraceToken */, anyToken, [isOptionEnabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"), isBraceWrappedContext], 2 /* Space */),
	                rule("SpaceBeforeCloseBrace", anyToken, 18 /* CloseBraceToken */, [isOptionEnabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"), isBraceWrappedContext], 2 /* Space */),
	                rule("NoSpaceBetweenEmptyBraceBrackets", 17 /* OpenBraceToken */, 18 /* CloseBraceToken */, [isNonJsxSameLineTokenContext, isObjectContext], 8 /* Delete */),
	                rule("NoSpaceAfterOpenBrace", 17 /* OpenBraceToken */, anyToken, [isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseBrace", anyToken, 18 /* CloseBraceToken */, [isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Insert space after opening and before closing template string braces
	                rule("SpaceAfterTemplateHeadAndMiddle", [14 /* TemplateHead */, 15 /* TemplateMiddle */], anyToken, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeTemplateMiddleAndTail", anyToken, [15 /* TemplateMiddle */, 16 /* TemplateTail */], [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceAfterTemplateHeadAndMiddle", [14 /* TemplateHead */, 15 /* TemplateMiddle */], anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeTemplateMiddleAndTail", anyToken, [15 /* TemplateMiddle */, 16 /* TemplateTail */], [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // No space after { and before } in JSX expression
	                rule("SpaceAfterOpenBraceInJsxExpression", 17 /* OpenBraceToken */, anyToken, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"), isNonJsxSameLineTokenContext, isJsxExpressionContext], 2 /* Space */),
	                rule("SpaceBeforeCloseBraceInJsxExpression", anyToken, 18 /* CloseBraceToken */, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"), isNonJsxSameLineTokenContext, isJsxExpressionContext], 2 /* Space */),
	                rule("NoSpaceAfterOpenBraceInJsxExpression", 17 /* OpenBraceToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"), isNonJsxSameLineTokenContext, isJsxExpressionContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseBraceInJsxExpression", anyToken, 18 /* CloseBraceToken */, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"), isNonJsxSameLineTokenContext, isJsxExpressionContext], 8 /* Delete */),
	                // Insert space after semicolon in for statement
	                rule("SpaceAfterSemicolonInFor", 25 /* SemicolonToken */, anyToken, [isOptionEnabled("insertSpaceAfterSemicolonInForStatements"), isNonJsxSameLineTokenContext, isForContext], 2 /* Space */),
	                rule("NoSpaceAfterSemicolonInFor", 25 /* SemicolonToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterSemicolonInForStatements"), isNonJsxSameLineTokenContext, isForContext], 8 /* Delete */),
	                // Insert space before and after binary operators
	                rule("SpaceBeforeBinaryOperator", anyToken, binaryOperators, [isOptionEnabled("insertSpaceBeforeAndAfterBinaryOperators"), isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterBinaryOperator", binaryOperators, anyToken, [isOptionEnabled("insertSpaceBeforeAndAfterBinaryOperators"), isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("NoSpaceBeforeBinaryOperator", anyToken, binaryOperators, [isOptionDisabledOrUndefined("insertSpaceBeforeAndAfterBinaryOperators"), isNonJsxSameLineTokenContext, isBinaryOpContext], 8 /* Delete */),
	                rule("NoSpaceAfterBinaryOperator", binaryOperators, anyToken, [isOptionDisabledOrUndefined("insertSpaceBeforeAndAfterBinaryOperators"), isNonJsxSameLineTokenContext, isBinaryOpContext], 8 /* Delete */),
	                rule("SpaceBeforeOpenParenInFuncDecl", anyToken, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceBeforeFunctionParenthesis"), isNonJsxSameLineTokenContext, isFunctionDeclContext], 2 /* Space */),
	                rule("NoSpaceBeforeOpenParenInFuncDecl", anyToken, 19 /* OpenParenToken */, [isOptionDisabledOrUndefined("insertSpaceBeforeFunctionParenthesis"), isNonJsxSameLineTokenContext, isFunctionDeclContext], 8 /* Delete */),
	                // Open Brace braces after control block
	                rule("NewLineBeforeOpenBraceInControl", controlOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionEnabled("placeOpenBraceOnNewLineForControlBlocks"), isControlDeclContext, isBeforeMultilineBlockContext], 4 /* NewLine */, 1 /* CanDeleteNewLines */),
	                // Open Brace braces after function
	                // TypeScript: Function can have return types, which can be made of tons of different token kinds
	                rule("NewLineBeforeOpenBraceInFunction", functionOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionEnabled("placeOpenBraceOnNewLineForFunctions"), isFunctionDeclContext, isBeforeMultilineBlockContext], 4 /* NewLine */, 1 /* CanDeleteNewLines */),
	                // Open Brace braces after TypeScript module/class/interface
	                rule("NewLineBeforeOpenBraceInTypeScriptDeclWithBlock", typeScriptOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionEnabled("placeOpenBraceOnNewLineForFunctions"), isTypeScriptDeclWithBlockContext, isBeforeMultilineBlockContext], 4 /* NewLine */, 1 /* CanDeleteNewLines */),
	                rule("SpaceAfterTypeAssertion", 29 /* GreaterThanToken */, anyToken, [isOptionEnabled("insertSpaceAfterTypeAssertion"), isNonJsxSameLineTokenContext, isTypeAssertionContext], 2 /* Space */),
	                rule("NoSpaceAfterTypeAssertion", 29 /* GreaterThanToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterTypeAssertion"), isNonJsxSameLineTokenContext, isTypeAssertionContext], 8 /* Delete */),
	                rule("SpaceBeforeTypeAnnotation", anyToken, 56 /* ColonToken */, [isOptionEnabled("insertSpaceBeforeTypeAnnotation"), isNonJsxSameLineTokenContext, isTypeAnnotationContext], 2 /* Space */),
	                rule("NoSpaceBeforeTypeAnnotation", anyToken, 56 /* ColonToken */, [isOptionDisabledOrUndefined("insertSpaceBeforeTypeAnnotation"), isNonJsxSameLineTokenContext, isTypeAnnotationContext], 8 /* Delete */),
	            ];
	            // These rules are lower in priority than user-configurable. Rules earlier in this list have priority over rules later in the list.
	            var lowPriorityCommonRules = [
	                // Space after keyword but not before ; or : or ?
	                rule("NoSpaceBeforeSemicolon", anyToken, 25 /* SemicolonToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("SpaceBeforeOpenBraceInControl", controlOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForControlBlocks"), isControlDeclContext, isNotFormatOnEnter, isSameLineTokenOrBeforeBlockContext], 2 /* Space */, 1 /* CanDeleteNewLines */),
	                rule("SpaceBeforeOpenBraceInFunction", functionOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForFunctions"), isFunctionDeclContext, isBeforeBlockContext, isNotFormatOnEnter, isSameLineTokenOrBeforeBlockContext], 2 /* Space */, 1 /* CanDeleteNewLines */),
	                rule("SpaceBeforeOpenBraceInTypeScriptDeclWithBlock", typeScriptOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForFunctions"), isTypeScriptDeclWithBlockContext, isNotFormatOnEnter, isSameLineTokenOrBeforeBlockContext], 2 /* Space */, 1 /* CanDeleteNewLines */),
	                rule("NoSpaceBeforeComma", anyToken, 26 /* CommaToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // No space before and after indexer `x[]`
	                rule("NoSpaceBeforeOpenBracket", anyTokenExcept(120 /* AsyncKeyword */, 73 /* CaseKeyword */), 21 /* OpenBracketToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterCloseBracket", 22 /* CloseBracketToken */, anyToken, [isNonJsxSameLineTokenContext, isNotBeforeBlockInFunctionDeclarationContext], 8 /* Delete */),
	                rule("SpaceAfterSemicolon", 25 /* SemicolonToken */, anyToken, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Remove extra space between for and await
	                rule("SpaceBetweenForAndAwaitKeyword", 88 /* ForKeyword */, 121 /* AwaitKeyword */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Add a space between statements. All keywords except (do,else,case) has open/close parens after them.
	                // So, we have a rule to add a space for [),Any], [do,Any], [else,Any], and [case,Any]
	                rule("SpaceBetweenStatements", [20 /* CloseParenToken */, 81 /* DoKeyword */, 82 /* ElseKeyword */, 73 /* CaseKeyword */], anyToken, [isNonJsxSameLineTokenContext, isNonJsxElementOrFragmentContext, isNotForContext], 2 /* Space */),
	                // This low-pri rule takes care of "try {" and "finally {" in case the rule SpaceBeforeOpenBraceInControl didn't execute on FormatOnEnter.
	                rule("SpaceAfterTryFinally", [102 /* TryKeyword */, 87 /* FinallyKeyword */], 17 /* OpenBraceToken */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	            ];
	            return highPriorityCommonRules.concat(userConfigurableRules, lowPriorityCommonRules);
	        }
	        formatting.getAllRules = getAllRules;
	        function rule(debugName, left, right, context, action, flags) {
	            if (flags === void 0) { flags = 0 /* None */; }
	            return { leftTokenRange: toTokenRange(left), rightTokenRange: toTokenRange(right), rule: { debugName: debugName, context: context, action: action, flags: flags } };
	        }
	        function tokenRangeFrom(tokens) {
	            return { tokens: tokens, isSpecific: true };
	        }
	        function toTokenRange(arg) {
	            return typeof arg === "number" ? tokenRangeFrom([arg]) : ts.isArray(arg) ? tokenRangeFrom(arg) : arg;
	        }
	        function tokenRangeFromRange(from, to, except) {
	            if (except === void 0) { except = []; }
	            var tokens = [];
	            for (var token = from; token <= to; token++) {
	                if (!ts.contains(except, token)) {
	                    tokens.push(token);
	                }
	            }
	            return tokenRangeFrom(tokens);
	        }
	        ///
	        /// Contexts
	        ///
	        function isOptionEnabled(optionName) {
	            return function (context) { return context.options && context.options.hasOwnProperty(optionName) && !!context.options[optionName]; };
	        }
	        function isOptionDisabled(optionName) {
	            return function (context) { return context.options && context.options.hasOwnProperty(optionName) && !context.options[optionName]; };
	        }
	        function isOptionDisabledOrUndefined(optionName) {
	            return function (context) { return !context.options || !context.options.hasOwnProperty(optionName) || !context.options[optionName]; };
	        }
	        function isOptionDisabledOrUndefinedOrTokensOnSameLine(optionName) {
	            return function (context) { return !context.options || !context.options.hasOwnProperty(optionName) || !context.options[optionName] || context.TokensAreOnSameLine(); };
	        }
	        function isOptionEnabledOrUndefined(optionName) {
	            return function (context) { return !context.options || !context.options.hasOwnProperty(optionName) || !!context.options[optionName]; };
	        }
	        function isForContext(context) {
	            return context.contextNode.kind === 218 /* ForStatement */;
	        }
	        function isNotForContext(context) {
	            return !isForContext(context);
	        }
	        function isBinaryOpContext(context) {
	            switch (context.contextNode.kind) {
	                case 198 /* BinaryExpression */:
	                case 199 /* ConditionalExpression */:
	                case 170 /* ConditionalType */:
	                case 206 /* AsExpression */:
	                case 250 /* ExportSpecifier */:
	                case 246 /* ImportSpecifier */:
	                case 160 /* TypePredicate */:
	                case 168 /* UnionType */:
	                case 169 /* IntersectionType */:
	                    return true;
	                // equals in binding elements: function foo([[x, y] = [1, 2]])
	                case 180 /* BindingElement */:
	                // equals in type X = ...
	                case 235 /* TypeAliasDeclaration */:
	                // equal in import a = module('a');
	                case 241 /* ImportEqualsDeclaration */:
	                // equal in let a = 0;
	                case 230 /* VariableDeclaration */:
	                // equal in p = 0;
	                case 148 /* Parameter */:
	                case 271 /* EnumMember */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return context.currentTokenSpan.kind === 58 /* EqualsToken */ || context.nextTokenSpan.kind === 58 /* EqualsToken */;
	                // "in" keyword in for (let x in []) { }
	                case 219 /* ForInStatement */:
	                // "in" keyword in [P in keyof T]: T[P]
	                case 147 /* TypeParameter */:
	                    return context.currentTokenSpan.kind === 92 /* InKeyword */ || context.nextTokenSpan.kind === 92 /* InKeyword */;
	                // Technically, "of" is not a binary operator, but format it the same way as "in"
	                case 220 /* ForOfStatement */:
	                    return context.currentTokenSpan.kind === 144 /* OfKeyword */ || context.nextTokenSpan.kind === 144 /* OfKeyword */;
	            }
	            return false;
	        }
	        function isNotBinaryOpContext(context) {
	            return !isBinaryOpContext(context);
	        }
	        function isNotTypeAnnotationContext(context) {
	            return !isTypeAnnotationContext(context);
	        }
	        function isTypeAnnotationContext(context) {
	            var contextKind = context.contextNode.kind;
	            return contextKind === 151 /* PropertyDeclaration */ ||
	                contextKind === 150 /* PropertySignature */ ||
	                contextKind === 148 /* Parameter */ ||
	                contextKind === 230 /* VariableDeclaration */ ||
	                ts.isFunctionLikeKind(contextKind);
	        }
	        function isConditionalOperatorContext(context) {
	            return context.contextNode.kind === 199 /* ConditionalExpression */ ||
	                context.contextNode.kind === 170 /* ConditionalType */;
	        }
	        function isSameLineTokenOrBeforeBlockContext(context) {
	            return context.TokensAreOnSameLine() || isBeforeBlockContext(context);
	        }
	        function isBraceWrappedContext(context) {
	            return context.contextNode.kind === 178 /* ObjectBindingPattern */ ||
	                context.contextNode.kind === 176 /* MappedType */ ||
	                isSingleLineBlockContext(context);
	        }
	        // This check is done before an open brace in a control construct, a function, or a typescript block declaration
	        function isBeforeMultilineBlockContext(context) {
	            return isBeforeBlockContext(context) && !(context.NextNodeAllOnSameLine() || context.NextNodeBlockIsOnOneLine());
	        }
	        function isMultilineBlockContext(context) {
	            return isBlockContext(context) && !(context.ContextNodeAllOnSameLine() || context.ContextNodeBlockIsOnOneLine());
	        }
	        function isSingleLineBlockContext(context) {
	            return isBlockContext(context) && (context.ContextNodeAllOnSameLine() || context.ContextNodeBlockIsOnOneLine());
	        }
	        function isBlockContext(context) {
	            return nodeIsBlockContext(context.contextNode);
	        }
	        function isBeforeBlockContext(context) {
	            return nodeIsBlockContext(context.nextTokenParent);
	        }
	        // IMPORTANT!!! This method must return true ONLY for nodes with open and close braces as immediate children
	        function nodeIsBlockContext(node) {
	            if (nodeIsTypeScriptDeclWithBlockContext(node)) {
	                // This means we are in a context that looks like a block to the user, but in the grammar is actually not a node (it's a class, module, enum, object type literal, etc).
	                return true;
	            }
	            switch (node.kind) {
	                case 211 /* Block */:
	                case 239 /* CaseBlock */:
	                case 182 /* ObjectLiteralExpression */:
	                case 238 /* ModuleBlock */:
	                    return true;
	            }
	            return false;
	        }
	        function isFunctionDeclContext(context) {
	            switch (context.contextNode.kind) {
	                case 232 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                // case SyntaxKind.MemberFunctionDeclaration:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                // case SyntaxKind.MethodSignature:
	                case 157 /* CallSignature */:
	                case 190 /* FunctionExpression */:
	                case 154 /* Constructor */:
	                case 191 /* ArrowFunction */:
	                // case SyntaxKind.ConstructorDeclaration:
	                // case SyntaxKind.SimpleArrowFunctionExpression:
	                // case SyntaxKind.ParenthesizedArrowFunctionExpression:
	                case 234 /* InterfaceDeclaration */:// This one is not truly a function, but for formatting purposes, it acts just like one
	                    return true;
	            }
	            return false;
	        }
	        function isFunctionDeclarationOrFunctionExpressionContext(context) {
	            return context.contextNode.kind === 232 /* FunctionDeclaration */ || context.contextNode.kind === 190 /* FunctionExpression */;
	        }
	        function isTypeScriptDeclWithBlockContext(context) {
	            return nodeIsTypeScriptDeclWithBlockContext(context.contextNode);
	        }
	        function nodeIsTypeScriptDeclWithBlockContext(node) {
	            switch (node.kind) {
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                case 234 /* InterfaceDeclaration */:
	                case 236 /* EnumDeclaration */:
	                case 165 /* TypeLiteral */:
	                case 237 /* ModuleDeclaration */:
	                case 248 /* ExportDeclaration */:
	                case 249 /* NamedExports */:
	                case 242 /* ImportDeclaration */:
	                case 245 /* NamedImports */:
	                    return true;
	            }
	            return false;
	        }
	        function isAfterCodeBlockContext(context) {
	            switch (context.currentTokenParent.kind) {
	                case 233 /* ClassDeclaration */:
	                case 237 /* ModuleDeclaration */:
	                case 236 /* EnumDeclaration */:
	                case 267 /* CatchClause */:
	                case 238 /* ModuleBlock */:
	                case 225 /* SwitchStatement */:
	                    return true;
	                case 211 /* Block */: {
	                    var blockParent = context.currentTokenParent.parent;
	                    // In a codefix scenario, we can't rely on parents being set. So just always return true.
	                    if (!blockParent || blockParent.kind !== 191 /* ArrowFunction */ && blockParent.kind !== 190 /* FunctionExpression */) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function isControlDeclContext(context) {
	            switch (context.contextNode.kind) {
	                case 215 /* IfStatement */:
	                case 225 /* SwitchStatement */:
	                case 218 /* ForStatement */:
	                case 219 /* ForInStatement */:
	                case 220 /* ForOfStatement */:
	                case 217 /* WhileStatement */:
	                case 228 /* TryStatement */:
	                case 216 /* DoStatement */:
	                case 224 /* WithStatement */:
	                // TODO
	                // case SyntaxKind.ElseClause:
	                case 267 /* CatchClause */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function isObjectContext(context) {
	            return context.contextNode.kind === 182 /* ObjectLiteralExpression */;
	        }
	        function isFunctionCallContext(context) {
	            return context.contextNode.kind === 185 /* CallExpression */;
	        }
	        function isNewContext(context) {
	            return context.contextNode.kind === 186 /* NewExpression */;
	        }
	        function isFunctionCallOrNewContext(context) {
	            return isFunctionCallContext(context) || isNewContext(context);
	        }
	        function isPreviousTokenNotComma(context) {
	            return context.currentTokenSpan.kind !== 26 /* CommaToken */;
	        }
	        function isNextTokenNotCloseBracket(context) {
	            return context.nextTokenSpan.kind !== 22 /* CloseBracketToken */;
	        }
	        function isArrowFunctionContext(context) {
	            return context.contextNode.kind === 191 /* ArrowFunction */;
	        }
	        function isNonJsxSameLineTokenContext(context) {
	            return context.TokensAreOnSameLine() && context.contextNode.kind !== 10 /* JsxText */;
	        }
	        function isNonJsxElementOrFragmentContext(context) {
	            return context.contextNode.kind !== 253 /* JsxElement */ && context.contextNode.kind !== 257 /* JsxFragment */;
	        }
	        function isJsxExpressionContext(context) {
	            return context.contextNode.kind === 263 /* JsxExpression */ || context.contextNode.kind === 262 /* JsxSpreadAttribute */;
	        }
	        function isNextTokenParentJsxAttribute(context) {
	            return context.nextTokenParent.kind === 260 /* JsxAttribute */;
	        }
	        function isJsxAttributeContext(context) {
	            return context.contextNode.kind === 260 /* JsxAttribute */;
	        }
	        function isJsxSelfClosingElementContext(context) {
	            return context.contextNode.kind === 254 /* JsxSelfClosingElement */;
	        }
	        function isNotBeforeBlockInFunctionDeclarationContext(context) {
	            return !isFunctionDeclContext(context) && !isBeforeBlockContext(context);
	        }
	        function isEndOfDecoratorContextOnSameLine(context) {
	            return context.TokensAreOnSameLine() &&
	                context.contextNode.decorators &&
	                nodeIsInDecoratorContext(context.currentTokenParent) &&
	                !nodeIsInDecoratorContext(context.nextTokenParent);
	        }
	        function nodeIsInDecoratorContext(node) {
	            while (ts.isExpressionNode(node)) {
	                node = node.parent;
	            }
	            return node.kind === 149 /* Decorator */;
	        }
	        function isStartOfVariableDeclarationList(context) {
	            return context.currentTokenParent.kind === 231 /* VariableDeclarationList */ &&
	                context.currentTokenParent.getStart(context.sourceFile) === context.currentTokenSpan.pos;
	        }
	        function isNotFormatOnEnter(context) {
	            return context.formattingRequestKind !== 2 /* FormatOnEnter */;
	        }
	        function isModuleDeclContext(context) {
	            return context.contextNode.kind === 237 /* ModuleDeclaration */;
	        }
	        function isObjectTypeContext(context) {
	            return context.contextNode.kind === 165 /* TypeLiteral */; // && context.contextNode.parent.kind !== SyntaxKind.InterfaceDeclaration;
	        }
	        function isConstructorSignatureContext(context) {
	            return context.contextNode.kind === 158 /* ConstructSignature */;
	        }
	        function isTypeArgumentOrParameterOrAssertion(token, parent) {
	            if (token.kind !== 27 /* LessThanToken */ && token.kind !== 29 /* GreaterThanToken */) {
	                return false;
	            }
	            switch (parent.kind) {
	                case 161 /* TypeReference */:
	                case 188 /* TypeAssertionExpression */:
	                case 235 /* TypeAliasDeclaration */:
	                case 233 /* ClassDeclaration */:
	                case 203 /* ClassExpression */:
	                case 234 /* InterfaceDeclaration */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 185 /* CallExpression */:
	                case 186 /* NewExpression */:
	                case 205 /* ExpressionWithTypeArguments */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function isTypeArgumentOrParameterOrAssertionContext(context) {
	            return isTypeArgumentOrParameterOrAssertion(context.currentTokenSpan, context.currentTokenParent) ||
	                isTypeArgumentOrParameterOrAssertion(context.nextTokenSpan, context.nextTokenParent);
	        }
	        function isTypeAssertionContext(context) {
	            return context.contextNode.kind === 188 /* TypeAssertionExpression */;
	        }
	        function isVoidOpContext(context) {
	            return context.currentTokenSpan.kind === 105 /* VoidKeyword */ && context.currentTokenParent.kind === 194 /* VoidExpression */;
	        }
	        function isYieldOrYieldStarWithOperand(context) {
	            return context.contextNode.kind === 201 /* YieldExpression */ && context.contextNode.expression !== undefined;
	        }
	        function isNonNullAssertionContext(context) {
	            return context.contextNode.kind === 207 /* NonNullExpression */;
	        }
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/// <reference path="rules.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        function getFormatContext(options) {
	            return { options: options, getRule: getRulesMap() };
	        }
	        formatting.getFormatContext = getFormatContext;
	        var rulesMapCache;
	        function getRulesMap() {
	            if (rulesMapCache === undefined) {
	                rulesMapCache = createRulesMap(formatting.getAllRules());
	            }
	            return rulesMapCache;
	        }
	        function createRulesMap(rules) {
	            var map = buildMap(rules);
	            return function (context) {
	                var bucket = map[getRuleBucketIndex(context.currentTokenSpan.kind, context.nextTokenSpan.kind)];
	                return bucket && ts.find(bucket, function (rule) { return ts.every(rule.context, function (c) { return c(context); }); });
	            };
	        }
	        function buildMap(rules) {
	            // Map from bucket index to array of rules
	            var map = new Array(mapRowLength * mapRowLength);
	            // This array is used only during construction of the rulesbucket in the map
	            var rulesBucketConstructionStateList = new Array(map.length);
	            for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
	                var rule = rules_1[_i];
	                var specificRule = rule.leftTokenRange.isSpecific && rule.rightTokenRange.isSpecific;
	                for (var _a = 0, _b = rule.leftTokenRange.tokens; _a < _b.length; _a++) {
	                    var left = _b[_a];
	                    for (var _c = 0, _d = rule.rightTokenRange.tokens; _c < _d.length; _c++) {
	                        var right = _d[_c];
	                        var index = getRuleBucketIndex(left, right);
	                        var rulesBucket = map[index];
	                        if (rulesBucket === undefined) {
	                            rulesBucket = map[index] = [];
	                        }
	                        addRule(rulesBucket, rule.rule, specificRule, rulesBucketConstructionStateList, index);
	                    }
	                }
	            }
	            return map;
	        }
	        function getRuleBucketIndex(row, column) {
	            ts.Debug.assert(row <= 144 /* LastKeyword */ && column <= 144 /* LastKeyword */, "Must compute formatting context from tokens");
	            return (row * mapRowLength) + column;
	        }
	        var maskBitSize = 5;
	        var mask = 31; // MaskBitSize bits
	        var mapRowLength = 144 /* LastToken */ + 1;
	        var RulesPosition;
	        (function (RulesPosition) {
	            RulesPosition[RulesPosition["IgnoreRulesSpecific"] = 0] = "IgnoreRulesSpecific";
	            RulesPosition[RulesPosition["IgnoreRulesAny"] = maskBitSize * 1] = "IgnoreRulesAny";
	            RulesPosition[RulesPosition["ContextRulesSpecific"] = maskBitSize * 2] = "ContextRulesSpecific";
	            RulesPosition[RulesPosition["ContextRulesAny"] = maskBitSize * 3] = "ContextRulesAny";
	            RulesPosition[RulesPosition["NoContextRulesSpecific"] = maskBitSize * 4] = "NoContextRulesSpecific";
	            RulesPosition[RulesPosition["NoContextRulesAny"] = maskBitSize * 5] = "NoContextRulesAny";
	        })(RulesPosition || (RulesPosition = {}));
	        // The Rules list contains all the inserted rules into a rulebucket in the following order:
	        //    1- Ignore rules with specific token combination
	        //    2- Ignore rules with any token combination
	        //    3- Context rules with specific token combination
	        //    4- Context rules with any token combination
	        //    5- Non-context rules with specific token combination
	        //    6- Non-context rules with any token combination
	        //
	        // The member rulesInsertionIndexBitmap is used to describe the number of rules
	        // in each sub-bucket (above) hence can be used to know the index of where to insert
	        // the next rule. It's a bitmap which contains 6 different sections each is given 5 bits.
	        //
	        // Example:
	        // In order to insert a rule to the end of sub-bucket (3), we get the index by adding
	        // the values in the bitmap segments 3rd, 2nd, and 1st.
	        function addRule(rules, rule, specificTokens, constructionState, rulesBucketIndex) {
	            var position = rule.action === 1 /* Ignore */
	                ? specificTokens ? RulesPosition.IgnoreRulesSpecific : RulesPosition.IgnoreRulesAny
	                : rule.context !== formatting.anyContext
	                    ? specificTokens ? RulesPosition.ContextRulesSpecific : RulesPosition.ContextRulesAny
	                    : specificTokens ? RulesPosition.NoContextRulesSpecific : RulesPosition.NoContextRulesAny;
	            var state = constructionState[rulesBucketIndex] || 0;
	            rules.splice(getInsertionIndex(state, position), 0, rule);
	            constructionState[rulesBucketIndex] = increaseInsertionIndex(state, position);
	        }
	        function getInsertionIndex(indexBitmap, maskPosition) {
	            var index = 0;
	            for (var pos = 0; pos <= maskPosition; pos += maskBitSize) {
	                index += indexBitmap & mask;
	                indexBitmap >>= maskBitSize;
	            }
	            return index;
	        }
	        function increaseInsertionIndex(indexBitmap, maskPosition) {
	            var value = ((indexBitmap >> maskPosition) & mask) + 1;
	            ts.Debug.assert((value & mask) === value, "Adding more rules into the sub-bucket than allowed. Maximum allowed is 32 rules.");
	            return (indexBitmap & ~(mask << maskPosition)) | (value << maskPosition);
	        }
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/// <reference path="formattingContext.ts" />
	/// <reference path="formattingScanner.ts" />
	/// <reference path="rule.ts" />
	/// <reference path="rulesMap.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        var Constants;
	        (function (Constants) {
	            Constants[Constants["Unknown"] = -1] = "Unknown";
	        })(Constants || (Constants = {}));
	        function formatOnEnter(position, sourceFile, formatContext) {
	            var line = sourceFile.getLineAndCharacterOfPosition(position).line;
	            if (line === 0) {
	                return [];
	            }
	            // After the enter key, the cursor is now at a new line. The new line may or may not contain non-whitespace characters.
	            // If the new line has only whitespaces, we won't want to format this line, because that would remove the indentation as
	            // trailing whitespaces. So the end of the formatting span should be the later one between:
	            //  1. the end of the previous line
	            //  2. the last non-whitespace character in the current line
	            var endOfFormatSpan = ts.getEndLinePosition(line, sourceFile);
	            while (ts.isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(endOfFormatSpan))) {
	                endOfFormatSpan--;
	            }
	            // if the character at the end of the span is a line break, we shouldn't include it, because it indicates we don't want to
	            // touch the current line at all. Also, on some OSes the line break consists of two characters (\r\n), we should test if the
	            // previous character before the end of format span is line break character as well.
	            if (ts.isLineBreak(sourceFile.text.charCodeAt(endOfFormatSpan))) {
	                endOfFormatSpan--;
	            }
	            var span = {
	                // get start position for the previous line
	                pos: ts.getStartPositionOfLine(line - 1, sourceFile),
	                // end value is exclusive so add 1 to the result
	                end: endOfFormatSpan + 1
	            };
	            return formatSpan(span, sourceFile, formatContext, 2 /* FormatOnEnter */);
	        }
	        formatting.formatOnEnter = formatOnEnter;
	        function formatOnSemicolon(position, sourceFile, formatContext) {
	            var semicolon = findImmediatelyPrecedingTokenOfKind(position, 25 /* SemicolonToken */, sourceFile);
	            return formatNodeLines(findOutermostNodeWithinListLevel(semicolon), sourceFile, formatContext, 3 /* FormatOnSemicolon */);
	        }
	        formatting.formatOnSemicolon = formatOnSemicolon;
	        function formatOnOpeningCurly(position, sourceFile, formatContext) {
	            var openingCurly = findImmediatelyPrecedingTokenOfKind(position, 17 /* OpenBraceToken */, sourceFile);
	            if (!openingCurly) {
	                return [];
	            }
	            var curlyBraceRange = openingCurly.parent;
	            var outermostNode = findOutermostNodeWithinListLevel(curlyBraceRange);
	            /**
	             * We limit the span to end at the opening curly to handle the case where
	             * the brace matched to that just typed will be incorrect after further edits.
	             * For example, we could type the opening curly for the following method
	             * body without brace-matching activated:
	             * ```
	             * class C {
	             *     foo()
	             * }
	             * ```
	             * and we wouldn't want to move the closing brace.
	             */
	            var textRange = {
	                pos: ts.getLineStartPositionForPosition(outermostNode.getStart(sourceFile), sourceFile),
	                end: position
	            };
	            return formatSpan(textRange, sourceFile, formatContext, 4 /* FormatOnOpeningCurlyBrace */);
	        }
	        formatting.formatOnOpeningCurly = formatOnOpeningCurly;
	        function formatOnClosingCurly(position, sourceFile, formatContext) {
	            var precedingToken = findImmediatelyPrecedingTokenOfKind(position, 18 /* CloseBraceToken */, sourceFile);
	            return formatNodeLines(findOutermostNodeWithinListLevel(precedingToken), sourceFile, formatContext, 5 /* FormatOnClosingCurlyBrace */);
	        }
	        formatting.formatOnClosingCurly = formatOnClosingCurly;
	        function formatDocument(sourceFile, formatContext) {
	            var span = {
	                pos: 0,
	                end: sourceFile.text.length
	            };
	            return formatSpan(span, sourceFile, formatContext, 0 /* FormatDocument */);
	        }
	        formatting.formatDocument = formatDocument;
	        function formatSelection(start, end, sourceFile, formatContext) {
	            // format from the beginning of the line
	            var span = {
	                pos: ts.getLineStartPositionForPosition(start, sourceFile),
	                end: end,
	            };
	            return formatSpan(span, sourceFile, formatContext, 1 /* FormatSelection */);
	        }
	        formatting.formatSelection = formatSelection;
	        /**
	         * Validating `expectedTokenKind` ensures the token was typed in the context we expect (eg: not a comment).
	         * @param expectedTokenKind The kind of the last token constituting the desired parent node.
	         */
	        function findImmediatelyPrecedingTokenOfKind(end, expectedTokenKind, sourceFile) {
	            var precedingToken = ts.findPrecedingToken(end, sourceFile);
	            return precedingToken && precedingToken.kind === expectedTokenKind && end === precedingToken.getEnd() ?
	                precedingToken :
	                undefined;
	        }
	        /**
	         * Finds the highest node enclosing `node` at the same list level as `node`
	         * and whose end does not exceed `node.end`.
	         *
	         * Consider typing the following
	         * ```
	         * let x = 1;
	         * while (true) {
	         * }
	         * ```
	         * Upon typing the closing curly, we want to format the entire `while`-statement, but not the preceding
	         * variable declaration.
	         */
	        function findOutermostNodeWithinListLevel(node) {
	            var current = node;
	            while (current &&
	                current.parent &&
	                current.parent.end === node.end &&
	                !isListElement(current.parent, current)) {
	                current = current.parent;
	            }
	            return current;
	        }
	        // Returns true if node is a element in some list in parent
	        // i.e. parent is class declaration with the list of members and node is one of members.
	        function isListElement(parent, node) {
	            switch (parent.kind) {
	                case 233 /* ClassDeclaration */:
	                case 234 /* InterfaceDeclaration */:
	                    return ts.rangeContainsRange(parent.members, node);
	                case 237 /* ModuleDeclaration */:
	                    var body = parent.body;
	                    return body && body.kind === 238 /* ModuleBlock */ && ts.rangeContainsRange(body.statements, node);
	                case 272 /* SourceFile */:
	                case 211 /* Block */:
	                case 238 /* ModuleBlock */:
	                    return ts.rangeContainsRange(parent.statements, node);
	                case 267 /* CatchClause */:
	                    return ts.rangeContainsRange(parent.block.statements, node);
	            }
	            return false;
	        }
	        /** find node that fully contains given text range */
	        function findEnclosingNode(range, sourceFile) {
	            return find(sourceFile);
	            function find(n) {
	                var candidate = ts.forEachChild(n, function (c) { return ts.startEndContainsRange(c.getStart(sourceFile), c.end, range) && c; });
	                if (candidate) {
	                    var result = find(candidate);
	                    if (result) {
	                        return result;
	                    }
	                }
	                return n;
	            }
	        }
	        /** formatting is not applied to ranges that contain parse errors.
	         * This function will return a predicate that for a given text range will tell
	         * if there are any parse errors that overlap with the range.
	         */
	        function prepareRangeContainsErrorFunction(errors, originalRange) {
	            if (!errors.length) {
	                return rangeHasNoErrors;
	            }
	            // pick only errors that fall in range
	            var sorted = errors
	                .filter(function (d) { return ts.rangeOverlapsWithStartEnd(originalRange, d.start, d.start + d.length); })
	                .sort(function (e1, e2) { return e1.start - e2.start; });
	            if (!sorted.length) {
	                return rangeHasNoErrors;
	            }
	            var index = 0;
	            return function (r) {
	                // in current implementation sequence of arguments [r1, r2...] is monotonically increasing.
	                // 'index' tracks the index of the most recent error that was checked.
	                while (true) {
	                    if (index >= sorted.length) {
	                        // all errors in the range were already checked -> no error in specified range
	                        return false;
	                    }
	                    var error = sorted[index];
	                    if (r.end <= error.start) {
	                        // specified range ends before the error refered by 'index' - no error in range
	                        return false;
	                    }
	                    if (ts.startEndOverlapsWithStartEnd(r.pos, r.end, error.start, error.start + error.length)) {
	                        // specified range overlaps with error range
	                        return true;
	                    }
	                    index++;
	                }
	            };
	            function rangeHasNoErrors() {
	                return false;
	            }
	        }
	        /**
	         * Start of the original range might fall inside the comment - scanner will not yield appropriate results
	         * This function will look for token that is located before the start of target range
	         * and return its end as start position for the scanner.
	         */
	        function getScanStartPosition(enclosingNode, originalRange, sourceFile) {
	            var start = enclosingNode.getStart(sourceFile);
	            if (start === originalRange.pos && enclosingNode.end === originalRange.end) {
	                return start;
	            }
	            var precedingToken = ts.findPrecedingToken(originalRange.pos, sourceFile);
	            if (!precedingToken) {
	                // no preceding token found - start from the beginning of enclosing node
	                return enclosingNode.pos;
	            }
	            // preceding token ends after the start of original range (i.e when originalRange.pos falls in the middle of literal)
	            // start from the beginning of enclosingNode to handle the entire 'originalRange'
	            if (precedingToken.end >= originalRange.pos) {
	                return enclosingNode.pos;
	            }
	            return precedingToken.end;
	        }
	        /*
	         * For cases like
	         * if (a ||
	         *     b ||$
	         *     c) {...}
	         * If we hit Enter at $ we want line '    b ||' to be indented.
	         * Formatting will be applied to the last two lines.
	         * Node that fully encloses these lines is binary expression 'a ||...'.
	         * Initial indentation for this node will be 0.
	         * Binary expressions don't introduce new indentation scopes, however it is possible
	         * that some parent node on the same line does - like if statement in this case.
	         * Note that we are considering parents only from the same line with initial node -
	         * if parent is on the different line - its delta was already contributed
	         * to the initial indentation.
	         */
	        function getOwnOrInheritedDelta(n, options, sourceFile) {
	            var previousLine = -1 /* Unknown */;
	            var child;
	            while (n) {
	                var line = sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile)).line;
	                if (previousLine !== -1 /* Unknown */ && line !== previousLine) {
	                    break;
	                }
	                if (formatting.SmartIndenter.shouldIndentChildNode(n, child)) {
	                    return options.indentSize;
	                }
	                previousLine = line;
	                child = n;
	                n = n.parent;
	            }
	            return 0;
	        }
	        /* @internal */
	        function formatNodeGivenIndentation(node, sourceFileLike, languageVariant, initialIndentation, delta, formatContext) {
	            var range = { pos: 0, end: sourceFileLike.text.length };
	            return formatting.getFormattingScanner(sourceFileLike.text, languageVariant, range.pos, range.end, function (scanner) { return formatSpanWorker(range, node, initialIndentation, delta, scanner, formatContext, 1 /* FormatSelection */, function (_) { return false; }, // assume that node does not have any errors
	            sourceFileLike); });
	        }
	        formatting.formatNodeGivenIndentation = formatNodeGivenIndentation;
	        function formatNodeLines(node, sourceFile, formatContext, requestKind) {
	            if (!node) {
	                return [];
	            }
	            var span = {
	                pos: ts.getLineStartPositionForPosition(node.getStart(sourceFile), sourceFile),
	                end: node.end
	            };
	            return formatSpan(span, sourceFile, formatContext, requestKind);
	        }
	        function formatSpan(originalRange, sourceFile, formatContext, requestKind) {
	            // find the smallest node that fully wraps the range and compute the initial indentation for the node
	            var enclosingNode = findEnclosingNode(originalRange, sourceFile);
	            return formatting.getFormattingScanner(sourceFile.text, sourceFile.languageVariant, getScanStartPosition(enclosingNode, originalRange, sourceFile), originalRange.end, function (scanner) { return formatSpanWorker(originalRange, enclosingNode, formatting.SmartIndenter.getIndentationForNode(enclosingNode, originalRange, sourceFile, formatContext.options), getOwnOrInheritedDelta(enclosingNode, formatContext.options, sourceFile), scanner, formatContext, requestKind, prepareRangeContainsErrorFunction(sourceFile.parseDiagnostics, originalRange), sourceFile); });
	        }
	        function formatSpanWorker(originalRange, enclosingNode, initialIndentation, delta, formattingScanner, _a, requestKind, rangeContainsError, sourceFile) {
	            var options = _a.options, getRule = _a.getRule;
	            // formatting context is used by rules provider
	            var formattingContext = new formatting.FormattingContext(sourceFile, requestKind, options);
	            var previousRange;
	            var previousParent;
	            var previousRangeStartLine;
	            var lastIndentedLine;
	            var indentationOnLastIndentedLine;
	            var edits = [];
	            formattingScanner.advance();
	            if (formattingScanner.isOnToken()) {
	                var startLine = sourceFile.getLineAndCharacterOfPosition(enclosingNode.getStart(sourceFile)).line;
	                var undecoratedStartLine = startLine;
	                if (enclosingNode.decorators) {
	                    undecoratedStartLine = sourceFile.getLineAndCharacterOfPosition(ts.getNonDecoratorTokenPosOfNode(enclosingNode, sourceFile)).line;
	                }
	                processNode(enclosingNode, enclosingNode, startLine, undecoratedStartLine, initialIndentation, delta);
	            }
	            if (!formattingScanner.isOnToken()) {
	                var leadingTrivia = formattingScanner.getCurrentLeadingTrivia();
	                if (leadingTrivia) {
	                    processTrivia(leadingTrivia, enclosingNode, enclosingNode, /*dynamicIndentation*/ undefined);
	                    trimTrailingWhitespacesForRemainingRange();
	                }
	            }
	            return edits;
	            // local functions
	            /** Tries to compute the indentation for a list element.
	             * If list element is not in range then
	             * function will pick its actual indentation
	             * so it can be pushed downstream as inherited indentation.
	             * If list element is in the range - its indentation will be equal
	             * to inherited indentation from its predecessors.
	             */
	            function tryComputeIndentationForListItem(startPos, endPos, parentStartLine, range, inheritedIndentation) {
	                if (ts.rangeOverlapsWithStartEnd(range, startPos, endPos) ||
	                    ts.rangeContainsStartEnd(range, startPos, endPos) /* Not to miss zero-range nodes e.g. JsxText */) {
	                    if (inheritedIndentation !== -1 /* Unknown */) {
	                        return inheritedIndentation;
	                    }
	                }
	                else {
	                    var startLine = sourceFile.getLineAndCharacterOfPosition(startPos).line;
	                    var startLinePosition = ts.getLineStartPositionForPosition(startPos, sourceFile);
	                    var column = formatting.SmartIndenter.findFirstNonWhitespaceColumn(startLinePosition, startPos, sourceFile, options);
	                    if (startLine !== parentStartLine || startPos === column) {
	                        // Use the base indent size if it is greater than
	                        // the indentation of the inherited predecessor.
	                        var baseIndentSize = formatting.SmartIndenter.getBaseIndentation(options);
	                        return baseIndentSize > column ? baseIndentSize : column;
	                    }
	                }
	                return -1 /* Unknown */;
	            }
	            function computeIndentation(node, startLine, inheritedIndentation, parent, parentDynamicIndentation, effectiveParentStartLine) {
	                var delta = formatting.SmartIndenter.shouldIndentChildNode(node) ? options.indentSize : 0;
	                if (effectiveParentStartLine === startLine) {
	                    // if node is located on the same line with the parent
	                    // - inherit indentation from the parent
	                    // - push children if either parent of node itself has non-zero delta
	                    return {
	                        indentation: startLine === lastIndentedLine ? indentationOnLastIndentedLine : parentDynamicIndentation.getIndentation(),
	                        delta: Math.min(options.indentSize, parentDynamicIndentation.getDelta(node) + delta)
	                    };
	                }
	                else if (inheritedIndentation === -1 /* Unknown */) {
	                    if (node.kind === 19 /* OpenParenToken */ && startLine === lastIndentedLine) {
	                        // the is used for chaining methods formatting
	                        // - we need to get the indentation on last line and the delta of parent
	                        return { indentation: indentationOnLastIndentedLine, delta: parentDynamicIndentation.getDelta(node) };
	                    }
	                    else if (formatting.SmartIndenter.childStartsOnTheSameLineWithElseInIfStatement(parent, node, startLine, sourceFile)) {
	                        return { indentation: parentDynamicIndentation.getIndentation(), delta: delta };
	                    }
	                    else {
	                        return { indentation: parentDynamicIndentation.getIndentation() + parentDynamicIndentation.getDelta(node), delta: delta };
	                    }
	                }
	                else {
	                    return { indentation: inheritedIndentation, delta: delta };
	                }
	            }
	            function getFirstNonDecoratorTokenOfNode(node) {
	                if (node.modifiers && node.modifiers.length) {
	                    return node.modifiers[0].kind;
	                }
	                switch (node.kind) {
	                    case 233 /* ClassDeclaration */: return 75 /* ClassKeyword */;
	                    case 234 /* InterfaceDeclaration */: return 109 /* InterfaceKeyword */;
	                    case 232 /* FunctionDeclaration */: return 89 /* FunctionKeyword */;
	                    case 236 /* EnumDeclaration */: return 236 /* EnumDeclaration */;
	                    case 155 /* GetAccessor */: return 125 /* GetKeyword */;
	                    case 156 /* SetAccessor */: return 136 /* SetKeyword */;
	                    case 153 /* MethodDeclaration */:
	                        if (node.asteriskToken) {
	                            return 39 /* AsteriskToken */;
	                        }
	                    // falls through
	                    case 151 /* PropertyDeclaration */:
	                    case 148 /* Parameter */:
	                        return ts.getNameOfDeclaration(node).kind;
	                }
	            }
	            function getDynamicIndentation(node, nodeStartLine, indentation, delta) {
	                return {
	                    getIndentationForComment: function (kind, tokenIndentation, container) {
	                        switch (kind) {
	                            // preceding comment to the token that closes the indentation scope inherits the indentation from the scope
	                            // ..  {
	                            //     // comment
	                            // }
	                            case 18 /* CloseBraceToken */:
	                            case 22 /* CloseBracketToken */:
	                            case 20 /* CloseParenToken */:
	                                return indentation + getDelta(container);
	                        }
	                        return tokenIndentation !== -1 /* Unknown */ ? tokenIndentation : indentation;
	                    },
	                    getIndentationForToken: function (line, kind, container) {
	                        return shouldAddDelta(line, kind, container) ? indentation + getDelta(container) : indentation;
	                    },
	                    getIndentation: function () { return indentation; },
	                    getDelta: getDelta,
	                    recomputeIndentation: function (lineAdded) {
	                        if (node.parent && formatting.SmartIndenter.shouldIndentChildNode(node.parent, node)) {
	                            indentation += lineAdded ? options.indentSize : -options.indentSize;
	                            delta = formatting.SmartIndenter.shouldIndentChildNode(node) ? options.indentSize : 0;
	                        }
	                    }
	                };
	                function shouldAddDelta(line, kind, container) {
	                    switch (kind) {
	                        // open and close brace, 'else' and 'while' (in do statement) tokens has indentation of the parent
	                        case 17 /* OpenBraceToken */:
	                        case 18 /* CloseBraceToken */:
	                        case 19 /* OpenParenToken */:
	                        case 20 /* CloseParenToken */:
	                        case 82 /* ElseKeyword */:
	                        case 106 /* WhileKeyword */:
	                        case 57 /* AtToken */:
	                            return false;
	                        case 41 /* SlashToken */:
	                        case 29 /* GreaterThanToken */:
	                            switch (container.kind) {
	                                case 255 /* JsxOpeningElement */:
	                                case 256 /* JsxClosingElement */:
	                                case 254 /* JsxSelfClosingElement */:
	                                    return false;
	                            }
	                            break;
	                        case 21 /* OpenBracketToken */:
	                        case 22 /* CloseBracketToken */:
	                            if (container.kind !== 176 /* MappedType */) {
	                                return false;
	                            }
	                            break;
	                    }
	                    // if token line equals to the line of containing node (this is a first token in the node) - use node indentation
	                    return nodeStartLine !== line
	                        // if this token is the first token following the list of decorators, we do not need to indent
	                        && !(node.decorators && kind === getFirstNonDecoratorTokenOfNode(node));
	                }
	                function getDelta(child) {
	                    // Delta value should be zero when the node explicitly prevents indentation of the child node
	                    return formatting.SmartIndenter.nodeWillIndentChild(node, child, /*indentByDefault*/ true) ? delta : 0;
	                }
	            }
	            function processNode(node, contextNode, nodeStartLine, undecoratedNodeStartLine, indentation, delta) {
	                if (!ts.rangeOverlapsWithStartEnd(originalRange, node.getStart(sourceFile), node.getEnd())) {
	                    return;
	                }
	                var nodeDynamicIndentation = getDynamicIndentation(node, nodeStartLine, indentation, delta);
	                // a useful observations when tracking context node
	                //        /
	                //      [a]
	                //   /   |   \
	                //  [b] [c] [d]
	                // node 'a' is a context node for nodes 'b', 'c', 'd'
	                // except for the leftmost leaf token in [b] - in this case context node ('e') is located somewhere above 'a'
	                // this rule can be applied recursively to child nodes of 'a'.
	                //
	                // context node is set to parent node value after processing every child node
	                // context node is set to parent of the token after processing every token
	                var childContextNode = contextNode;
	                // if there are any tokens that logically belong to node and interleave child nodes
	                // such tokens will be consumed in processChildNode for the child that follows them
	                ts.forEachChild(node, function (child) {
	                    processChildNode(child, /*inheritedIndentation*/ -1 /* Unknown */, node, nodeDynamicIndentation, nodeStartLine, undecoratedNodeStartLine, /*isListItem*/ false);
	                }, function (nodes) {
	                    processChildNodes(nodes, node, nodeStartLine, nodeDynamicIndentation);
	                });
	                // proceed any tokens in the node that are located after child nodes
	                while (formattingScanner.isOnToken()) {
	                    var tokenInfo = formattingScanner.readTokenInfo(node);
	                    if (tokenInfo.token.end > node.end) {
	                        break;
	                    }
	                    consumeTokenAndAdvanceScanner(tokenInfo, node, nodeDynamicIndentation, node);
	                }
	                function processChildNode(child, inheritedIndentation, parent, parentDynamicIndentation, parentStartLine, undecoratedParentStartLine, isListItem, isFirstListItem) {
	                    var childStartPos = child.getStart(sourceFile);
	                    var childStartLine = sourceFile.getLineAndCharacterOfPosition(childStartPos).line;
	                    var undecoratedChildStartLine = childStartLine;
	                    if (child.decorators) {
	                        undecoratedChildStartLine = sourceFile.getLineAndCharacterOfPosition(ts.getNonDecoratorTokenPosOfNode(child, sourceFile)).line;
	                    }
	                    // if child is a list item - try to get its indentation, only if parent is within the original range.
	                    var childIndentationAmount = -1 /* Unknown */;
	                    if (isListItem && ts.rangeContainsRange(originalRange, parent)) {
	                        childIndentationAmount = tryComputeIndentationForListItem(childStartPos, child.end, parentStartLine, originalRange, inheritedIndentation);
	                        if (childIndentationAmount !== -1 /* Unknown */) {
	                            inheritedIndentation = childIndentationAmount;
	                        }
	                    }
	                    // child node is outside the target range - do not dive inside
	                    if (!ts.rangeOverlapsWithStartEnd(originalRange, child.pos, child.end)) {
	                        if (child.end < originalRange.pos) {
	                            formattingScanner.skipToEndOf(child);
	                        }
	                        return inheritedIndentation;
	                    }
	                    if (child.getFullWidth() === 0) {
	                        return inheritedIndentation;
	                    }
	                    while (formattingScanner.isOnToken()) {
	                        // proceed any parent tokens that are located prior to child.getStart()
	                        var tokenInfo = formattingScanner.readTokenInfo(node);
	                        if (tokenInfo.token.end > childStartPos) {
	                            // stop when formatting scanner advances past the beginning of the child
	                            break;
	                        }
	                        consumeTokenAndAdvanceScanner(tokenInfo, node, parentDynamicIndentation, node);
	                    }
	                    if (!formattingScanner.isOnToken()) {
	                        return inheritedIndentation;
	                    }
	                    // JSX text shouldn't affect indenting
	                    if (ts.isToken(child) && child.kind !== 10 /* JsxText */) {
	                        // if child node is a token, it does not impact indentation, proceed it using parent indentation scope rules
	                        var tokenInfo = formattingScanner.readTokenInfo(child);
	                        ts.Debug.assert(tokenInfo.token.end === child.end, "Token end is child end");
	                        consumeTokenAndAdvanceScanner(tokenInfo, node, parentDynamicIndentation, child);
	                        return inheritedIndentation;
	                    }
	                    var effectiveParentStartLine = child.kind === 149 /* Decorator */ ? childStartLine : undecoratedParentStartLine;
	                    var childIndentation = computeIndentation(child, childStartLine, childIndentationAmount, node, parentDynamicIndentation, effectiveParentStartLine);
	                    processNode(child, childContextNode, childStartLine, undecoratedChildStartLine, childIndentation.indentation, childIndentation.delta);
	                    if (child.kind === 10 /* JsxText */) {
	                        var range = { pos: child.getStart(), end: child.getEnd() };
	                        indentMultilineCommentOrJsxText(range, childIndentation.indentation, /*firstLineIsIndented*/ true, /*indentFinalLine*/ false);
	                    }
	                    childContextNode = node;
	                    if (isFirstListItem && parent.kind === 181 /* ArrayLiteralExpression */ && inheritedIndentation === -1 /* Unknown */) {
	                        inheritedIndentation = childIndentation.indentation;
	                    }
	                    return inheritedIndentation;
	                }
	                function processChildNodes(nodes, parent, parentStartLine, parentDynamicIndentation) {
	                    ts.Debug.assert(ts.isNodeArray(nodes));
	                    var listStartToken = getOpenTokenForList(parent, nodes);
	                    var listEndToken = getCloseTokenForOpenToken(listStartToken);
	                    var listDynamicIndentation = parentDynamicIndentation;
	                    var startLine = parentStartLine;
	                    if (listStartToken !== 0 /* Unknown */) {
	                        // introduce a new indentation scope for lists (including list start and end tokens)
	                        while (formattingScanner.isOnToken()) {
	                            var tokenInfo = formattingScanner.readTokenInfo(parent);
	                            if (tokenInfo.token.end > nodes.pos) {
	                                // stop when formatting scanner moves past the beginning of node list
	                                break;
	                            }
	                            else if (tokenInfo.token.kind === listStartToken) {
	                                // consume list start token
	                                startLine = sourceFile.getLineAndCharacterOfPosition(tokenInfo.token.pos).line;
	                                var indentation_1 = computeIndentation(tokenInfo.token, startLine, -1 /* Unknown */, parent, parentDynamicIndentation, parentStartLine);
	                                listDynamicIndentation = getDynamicIndentation(parent, parentStartLine, indentation_1.indentation, indentation_1.delta);
	                                consumeTokenAndAdvanceScanner(tokenInfo, parent, listDynamicIndentation, parent);
	                            }
	                            else {
	                                // consume any tokens that precede the list as child elements of 'node' using its indentation scope
	                                consumeTokenAndAdvanceScanner(tokenInfo, parent, parentDynamicIndentation, parent);
	                            }
	                        }
	                    }
	                    var inheritedIndentation = -1 /* Unknown */;
	                    for (var i = 0; i < nodes.length; i++) {
	                        var child = nodes[i];
	                        inheritedIndentation = processChildNode(child, inheritedIndentation, node, listDynamicIndentation, startLine, startLine, /*isListItem*/ true, /*isFirstListItem*/ i === 0);
	                    }
	                    if (listEndToken !== 0 /* Unknown */) {
	                        if (formattingScanner.isOnToken()) {
	                            var tokenInfo = formattingScanner.readTokenInfo(parent);
	                            // consume the list end token only if it is still belong to the parent
	                            // there might be the case when current token matches end token but does not considered as one
	                            // function (x: function) <--
	                            // without this check close paren will be interpreted as list end token for function expression which is wrong
	                            if (tokenInfo.token.kind === listEndToken && ts.rangeContainsRange(parent, tokenInfo.token)) {
	                                // consume list end token
	                                consumeTokenAndAdvanceScanner(tokenInfo, parent, listDynamicIndentation, parent);
	                            }
	                        }
	                    }
	                }
	                function consumeTokenAndAdvanceScanner(currentTokenInfo, parent, dynamicIndentation, container) {
	                    ts.Debug.assert(ts.rangeContainsRange(parent, currentTokenInfo.token));
	                    var lastTriviaWasNewLine = formattingScanner.lastTrailingTriviaWasNewLine();
	                    var indentToken = false;
	                    if (currentTokenInfo.leadingTrivia) {
	                        processTrivia(currentTokenInfo.leadingTrivia, parent, childContextNode, dynamicIndentation);
	                    }
	                    var lineAction = 0 /* None */;
	                    var isTokenInRange = ts.rangeContainsRange(originalRange, currentTokenInfo.token);
	                    var tokenStart = sourceFile.getLineAndCharacterOfPosition(currentTokenInfo.token.pos);
	                    if (isTokenInRange) {
	                        var rangeHasError = rangeContainsError(currentTokenInfo.token);
	                        // save previousRange since processRange will overwrite this value with current one
	                        var savePreviousRange = previousRange;
	                        lineAction = processRange(currentTokenInfo.token, tokenStart, parent, childContextNode, dynamicIndentation);
	                        // do not indent comments\token if token range overlaps with some error
	                        if (!rangeHasError) {
	                            if (lineAction === 0 /* None */) {
	                                // indent token only if end line of previous range does not match start line of the token
	                                var prevEndLine = savePreviousRange && sourceFile.getLineAndCharacterOfPosition(savePreviousRange.end).line;
	                                indentToken = lastTriviaWasNewLine && tokenStart.line !== prevEndLine;
	                            }
	                            else {
	                                indentToken = lineAction === 1 /* LineAdded */;
	                            }
	                        }
	                    }
	                    if (currentTokenInfo.trailingTrivia) {
	                        processTrivia(currentTokenInfo.trailingTrivia, parent, childContextNode, dynamicIndentation);
	                    }
	                    if (indentToken) {
	                        var tokenIndentation = (isTokenInRange && !rangeContainsError(currentTokenInfo.token)) ?
	                            dynamicIndentation.getIndentationForToken(tokenStart.line, currentTokenInfo.token.kind, container) :
	                            -1 /* Unknown */;
	                        var indentNextTokenOrTrivia = true;
	                        if (currentTokenInfo.leadingTrivia) {
	                            var commentIndentation = dynamicIndentation.getIndentationForComment(currentTokenInfo.token.kind, tokenIndentation, container);
	                            for (var _i = 0, _a = currentTokenInfo.leadingTrivia; _i < _a.length; _i++) {
	                                var triviaItem = _a[_i];
	                                var triviaInRange = ts.rangeContainsRange(originalRange, triviaItem);
	                                switch (triviaItem.kind) {
	                                    case 3 /* MultiLineCommentTrivia */:
	                                        if (triviaInRange) {
	                                            indentMultilineCommentOrJsxText(triviaItem, commentIndentation, /*firstLineIsIndented*/ !indentNextTokenOrTrivia);
	                                        }
	                                        indentNextTokenOrTrivia = false;
	                                        break;
	                                    case 2 /* SingleLineCommentTrivia */:
	                                        if (indentNextTokenOrTrivia && triviaInRange) {
	                                            insertIndentation(triviaItem.pos, commentIndentation, /*lineAdded*/ false);
	                                        }
	                                        indentNextTokenOrTrivia = false;
	                                        break;
	                                    case 4 /* NewLineTrivia */:
	                                        indentNextTokenOrTrivia = true;
	                                        break;
	                                }
	                            }
	                        }
	                        // indent token only if is it is in target range and does not overlap with any error ranges
	                        if (tokenIndentation !== -1 /* Unknown */ && indentNextTokenOrTrivia) {
	                            insertIndentation(currentTokenInfo.token.pos, tokenIndentation, lineAction === 1 /* LineAdded */);
	                            lastIndentedLine = tokenStart.line;
	                            indentationOnLastIndentedLine = tokenIndentation;
	                        }
	                    }
	                    formattingScanner.advance();
	                    childContextNode = parent;
	                }
	            }
	            function processTrivia(trivia, parent, contextNode, dynamicIndentation) {
	                for (var _i = 0, trivia_1 = trivia; _i < trivia_1.length; _i++) {
	                    var triviaItem = trivia_1[_i];
	                    if (ts.isComment(triviaItem.kind) && ts.rangeContainsRange(originalRange, triviaItem)) {
	                        var triviaItemStart = sourceFile.getLineAndCharacterOfPosition(triviaItem.pos);
	                        processRange(triviaItem, triviaItemStart, parent, contextNode, dynamicIndentation);
	                    }
	                }
	            }
	            function processRange(range, rangeStart, parent, contextNode, dynamicIndentation) {
	                var rangeHasError = rangeContainsError(range);
	                var lineAction = 0 /* None */;
	                if (!rangeHasError) {
	                    if (!previousRange) {
	                        // trim whitespaces starting from the beginning of the span up to the current line
	                        var originalStart = sourceFile.getLineAndCharacterOfPosition(originalRange.pos);
	                        trimTrailingWhitespacesForLines(originalStart.line, rangeStart.line);
	                    }
	                    else {
	                        lineAction =
	                            processPair(range, rangeStart.line, parent, previousRange, previousRangeStartLine, previousParent, contextNode, dynamicIndentation);
	                    }
	                }
	                previousRange = range;
	                previousParent = parent;
	                previousRangeStartLine = rangeStart.line;
	                return lineAction;
	            }
	            function processPair(currentItem, currentStartLine, currentParent, previousItem, previousStartLine, previousParent, contextNode, dynamicIndentation) {
	                formattingContext.updateContext(previousItem, previousParent, currentItem, currentParent, contextNode);
	                var rule = getRule(formattingContext);
	                var trimTrailingWhitespaces;
	                var lineAction = 0 /* None */;
	                if (rule) {
	                    lineAction = applyRuleEdits(rule, previousItem, previousStartLine, currentItem, currentStartLine);
	                    switch (lineAction) {
	                        case 2 /* LineRemoved */:
	                            // Handle the case where the next line is moved to be the end of this line.
	                            // In this case we don't indent the next line in the next pass.
	                            if (currentParent.getStart(sourceFile) === currentItem.pos) {
	                                dynamicIndentation.recomputeIndentation(/*lineAddedByFormatting*/ false);
	                            }
	                            break;
	                        case 1 /* LineAdded */:
	                            // Handle the case where token2 is moved to the new line.
	                            // In this case we indent token2 in the next pass but we set
	                            // sameLineIndent flag to notify the indenter that the indentation is within the line.
	                            if (currentParent.getStart(sourceFile) === currentItem.pos) {
	                                dynamicIndentation.recomputeIndentation(/*lineAddedByFormatting*/ true);
	                            }
	                            break;
	                        default:
	                            ts.Debug.assert(lineAction === 0 /* None */);
	                    }
	                    // We need to trim trailing whitespace between the tokens if they were on different lines, and no rule was applied to put them on the same line
	                    trimTrailingWhitespaces = !(rule.action & 8 /* Delete */) && rule.flags !== 1 /* CanDeleteNewLines */;
	                }
	                else {
	                    trimTrailingWhitespaces = true;
	                }
	                if (currentStartLine !== previousStartLine && trimTrailingWhitespaces) {
	                    // We need to trim trailing whitespace between the tokens if they were on different lines, and no rule was applied to put them on the same line
	                    trimTrailingWhitespacesForLines(previousStartLine, currentStartLine, previousItem);
	                }
	                return lineAction;
	            }
	            function insertIndentation(pos, indentation, lineAdded) {
	                var indentationString = getIndentationString(indentation, options);
	                if (lineAdded) {
	                    // new line is added before the token by the formatting rules
	                    // insert indentation string at the very beginning of the token
	                    recordReplace(pos, 0, indentationString);
	                }
	                else {
	                    var tokenStart = sourceFile.getLineAndCharacterOfPosition(pos);
	                    var startLinePosition = ts.getStartPositionOfLine(tokenStart.line, sourceFile);
	                    if (indentation !== characterToColumn(startLinePosition, tokenStart.character) || indentationIsDifferent(indentationString, startLinePosition)) {
	                        recordReplace(startLinePosition, tokenStart.character, indentationString);
	                    }
	                }
	            }
	            function characterToColumn(startLinePosition, characterInLine) {
	                var column = 0;
	                for (var i = 0; i < characterInLine; i++) {
	                    if (sourceFile.text.charCodeAt(startLinePosition + i) === 9 /* tab */) {
	                        column += options.tabSize - column % options.tabSize;
	                    }
	                    else {
	                        column++;
	                    }
	                }
	                return column;
	            }
	            function indentationIsDifferent(indentationString, startLinePosition) {
	                return indentationString !== sourceFile.text.substr(startLinePosition, indentationString.length);
	            }
	            function indentMultilineCommentOrJsxText(commentRange, indentation, firstLineIsIndented, indentFinalLine) {
	                if (indentFinalLine === void 0) { indentFinalLine = true; }
	                // split comment in lines
	                var startLine = sourceFile.getLineAndCharacterOfPosition(commentRange.pos).line;
	                var endLine = sourceFile.getLineAndCharacterOfPosition(commentRange.end).line;
	                var parts;
	                if (startLine === endLine) {
	                    if (!firstLineIsIndented) {
	                        // treat as single line comment
	                        insertIndentation(commentRange.pos, indentation, /*lineAdded*/ false);
	                    }
	                    return;
	                }
	                else {
	                    parts = [];
	                    var startPos = commentRange.pos;
	                    for (var line = startLine; line < endLine; line++) {
	                        var endOfLine = ts.getEndLinePosition(line, sourceFile);
	                        parts.push({ pos: startPos, end: endOfLine });
	                        startPos = ts.getStartPositionOfLine(line + 1, sourceFile);
	                    }
	                    if (indentFinalLine) {
	                        parts.push({ pos: startPos, end: commentRange.end });
	                    }
	                }
	                var startLinePos = ts.getStartPositionOfLine(startLine, sourceFile);
	                var nonWhitespaceColumnInFirstPart = formatting.SmartIndenter.findFirstNonWhitespaceCharacterAndColumn(startLinePos, parts[0].pos, sourceFile, options);
	                if (indentation === nonWhitespaceColumnInFirstPart.column) {
	                    return;
	                }
	                var startIndex = 0;
	                if (firstLineIsIndented) {
	                    startIndex = 1;
	                    startLine++;
	                }
	                // shift all parts on the delta size
	                var delta = indentation - nonWhitespaceColumnInFirstPart.column;
	                for (var i = startIndex; i < parts.length; i++, startLine++) {
	                    var startLinePos_1 = ts.getStartPositionOfLine(startLine, sourceFile);
	                    var nonWhitespaceCharacterAndColumn = i === 0
	                        ? nonWhitespaceColumnInFirstPart
	                        : formatting.SmartIndenter.findFirstNonWhitespaceCharacterAndColumn(parts[i].pos, parts[i].end, sourceFile, options);
	                    var newIndentation = nonWhitespaceCharacterAndColumn.column + delta;
	                    if (newIndentation > 0) {
	                        var indentationString = getIndentationString(newIndentation, options);
	                        recordReplace(startLinePos_1, nonWhitespaceCharacterAndColumn.character, indentationString);
	                    }
	                    else {
	                        recordDelete(startLinePos_1, nonWhitespaceCharacterAndColumn.character);
	                    }
	                }
	            }
	            function trimTrailingWhitespacesForLines(line1, line2, range) {
	                for (var line = line1; line < line2; line++) {
	                    var lineStartPosition = ts.getStartPositionOfLine(line, sourceFile);
	                    var lineEndPosition = ts.getEndLinePosition(line, sourceFile);
	                    // do not trim whitespaces in comments or template expression
	                    if (range && (ts.isComment(range.kind) || ts.isStringOrRegularExpressionOrTemplateLiteral(range.kind)) && range.pos <= lineEndPosition && range.end > lineEndPosition) {
	                        continue;
	                    }
	                    var whitespaceStart = getTrailingWhitespaceStartPosition(lineStartPosition, lineEndPosition);
	                    if (whitespaceStart !== -1) {
	                        ts.Debug.assert(whitespaceStart === lineStartPosition || !ts.isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(whitespaceStart - 1)));
	                        recordDelete(whitespaceStart, lineEndPosition + 1 - whitespaceStart);
	                    }
	                }
	            }
	            /**
	             * @param start The position of the first character in range
	             * @param end The position of the last character in range
	             */
	            function getTrailingWhitespaceStartPosition(start, end) {
	                var pos = end;
	                while (pos >= start && ts.isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(pos))) {
	                    pos--;
	                }
	                if (pos !== end) {
	                    return pos + 1;
	                }
	                return -1;
	            }
	            /**
	             * Trimming will be done for lines after the previous range
	             */
	            function trimTrailingWhitespacesForRemainingRange() {
	                var startPosition = previousRange ? previousRange.end : originalRange.pos;
	                var startLine = sourceFile.getLineAndCharacterOfPosition(startPosition).line;
	                var endLine = sourceFile.getLineAndCharacterOfPosition(originalRange.end).line;
	                trimTrailingWhitespacesForLines(startLine, endLine + 1, previousRange);
	            }
	            function recordDelete(start, len) {
	                if (len) {
	                    edits.push(ts.createTextChangeFromStartLength(start, len, ""));
	                }
	            }
	            function recordReplace(start, len, newText) {
	                if (len || newText) {
	                    edits.push(ts.createTextChangeFromStartLength(start, len, newText));
	                }
	            }
	            function applyRuleEdits(rule, previousRange, previousStartLine, currentRange, currentStartLine) {
	                var onLaterLine = currentStartLine !== previousStartLine;
	                switch (rule.action) {
	                    case 1 /* Ignore */:
	                        // no action required
	                        return 0 /* None */;
	                    case 8 /* Delete */:
	                        if (previousRange.end !== currentRange.pos) {
	                            // delete characters starting from t1.end up to t2.pos exclusive
	                            recordDelete(previousRange.end, currentRange.pos - previousRange.end);
	                            return onLaterLine ? 2 /* LineRemoved */ : 0 /* None */;
	                        }
	                        break;
	                    case 4 /* NewLine */:
	                        // exit early if we on different lines and rule cannot change number of newlines
	                        // if line1 and line2 are on subsequent lines then no edits are required - ok to exit
	                        // if line1 and line2 are separated with more than one newline - ok to exit since we cannot delete extra new lines
	                        if (rule.flags !== 1 /* CanDeleteNewLines */ && previousStartLine !== currentStartLine) {
	                            return 0 /* None */;
	                        }
	                        // edit should not be applied if we have one line feed between elements
	                        var lineDelta = currentStartLine - previousStartLine;
	                        if (lineDelta !== 1) {
	                            recordReplace(previousRange.end, currentRange.pos - previousRange.end, options.newLineCharacter);
	                            return onLaterLine ? 0 /* None */ : 1 /* LineAdded */;
	                        }
	                        break;
	                    case 2 /* Space */:
	                        // exit early if we on different lines and rule cannot change number of newlines
	                        if (rule.flags !== 1 /* CanDeleteNewLines */ && previousStartLine !== currentStartLine) {
	                            return 0 /* None */;
	                        }
	                        var posDelta = currentRange.pos - previousRange.end;
	                        if (posDelta !== 1 || sourceFile.text.charCodeAt(previousRange.end) !== 32 /* space */) {
	                            recordReplace(previousRange.end, currentRange.pos - previousRange.end, " ");
	                            return onLaterLine ? 2 /* LineRemoved */ : 0 /* None */;
	                        }
	                }
	                return 0 /* None */;
	            }
	        }
	        var LineAction;
	        (function (LineAction) {
	            LineAction[LineAction["None"] = 0] = "None";
	            LineAction[LineAction["LineAdded"] = 1] = "LineAdded";
	            LineAction[LineAction["LineRemoved"] = 2] = "LineRemoved";
	        })(LineAction || (LineAction = {}));
	        /**
	         * @param precedingToken pass `null` if preceding token was already computed and result was `undefined`.
	         */
	        function getRangeOfEnclosingComment(sourceFile, position, onlyMultiLine, precedingToken, // tslint:disable-line:no-null-keyword
	        tokenAtPosition, predicate) {
	            if (tokenAtPosition === void 0) { tokenAtPosition = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false); }
	            var tokenStart = tokenAtPosition.getStart(sourceFile);
	            if (tokenStart <= position && position < tokenAtPosition.getEnd()) {
	                return undefined;
	            }
	            if (precedingToken === undefined) {
	                precedingToken = ts.findPrecedingToken(position, sourceFile);
	            }
	            // Between two consecutive tokens, all comments are either trailing on the former
	            // or leading on the latter (and none are in both lists).
	            var trailingRangesOfPreviousToken = precedingToken && ts.getTrailingCommentRanges(sourceFile.text, precedingToken.end);
	            var leadingCommentRangesOfNextToken = ts.getLeadingCommentRangesOfNode(tokenAtPosition, sourceFile);
	            var commentRanges = trailingRangesOfPreviousToken && leadingCommentRangesOfNextToken ?
	                trailingRangesOfPreviousToken.concat(leadingCommentRangesOfNextToken) :
	                trailingRangesOfPreviousToken || leadingCommentRangesOfNextToken;
	            if (commentRanges) {
	                for (var _i = 0, commentRanges_1 = commentRanges; _i < commentRanges_1.length; _i++) {
	                    var range = commentRanges_1[_i];
	                    // The end marker of a single-line comment does not include the newline character.
	                    // With caret at `^`, in the following case, we are inside a comment (^ denotes the cursor position):
	                    //
	                    //    // asdf   ^\n
	                    //
	                    // But for closed multi-line comments, we don't want to be inside the comment in the following case:
	                    //
	                    //    /* asdf */^
	                    //
	                    // However, unterminated multi-line comments *do* contain their end.
	                    //
	                    // Internally, we represent the end of the comment at the newline and closing '/', respectively.
	                    //
	                    if ((range.pos < position && position < range.end ||
	                        position === range.end && (range.kind === 2 /* SingleLineCommentTrivia */ || position === sourceFile.getFullWidth()))) {
	                        return (range.kind === 3 /* MultiLineCommentTrivia */ || !onlyMultiLine) && (!predicate || predicate(range)) ? range : undefined;
	                    }
	                }
	            }
	            return undefined;
	        }
	        formatting.getRangeOfEnclosingComment = getRangeOfEnclosingComment;
	        function getOpenTokenForList(node, list) {
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 191 /* ArrowFunction */:
	                    if (node.typeParameters === list) {
	                        return 27 /* LessThanToken */;
	                    }
	                    else if (node.parameters === list) {
	                        return 19 /* OpenParenToken */;
	                    }
	                    break;
	                case 185 /* CallExpression */:
	                case 186 /* NewExpression */:
	                    if (node.typeArguments === list) {
	                        return 27 /* LessThanToken */;
	                    }
	                    else if (node.arguments === list) {
	                        return 19 /* OpenParenToken */;
	                    }
	                    break;
	                case 161 /* TypeReference */:
	                    if (node.typeArguments === list) {
	                        return 27 /* LessThanToken */;
	                    }
	            }
	            return 0 /* Unknown */;
	        }
	        function getCloseTokenForOpenToken(kind) {
	            switch (kind) {
	                case 19 /* OpenParenToken */:
	                    return 20 /* CloseParenToken */;
	                case 27 /* LessThanToken */:
	                    return 29 /* GreaterThanToken */;
	            }
	            return 0 /* Unknown */;
	        }
	        var internedSizes;
	        var internedTabsIndentation;
	        var internedSpacesIndentation;
	        function getIndentationString(indentation, options) {
	            // reset interned strings if FormatCodeOptions were changed
	            var resetInternedStrings = !internedSizes || (internedSizes.tabSize !== options.tabSize || internedSizes.indentSize !== options.indentSize);
	            if (resetInternedStrings) {
	                internedSizes = { tabSize: options.tabSize, indentSize: options.indentSize };
	                internedTabsIndentation = internedSpacesIndentation = undefined;
	            }
	            if (!options.convertTabsToSpaces) {
	                var tabs = Math.floor(indentation / options.tabSize);
	                var spaces = indentation - tabs * options.tabSize;
	                var tabString = void 0;
	                if (!internedTabsIndentation) {
	                    internedTabsIndentation = [];
	                }
	                if (internedTabsIndentation[tabs] === undefined) {
	                    internedTabsIndentation[tabs] = tabString = ts.repeatString("\t", tabs);
	                }
	                else {
	                    tabString = internedTabsIndentation[tabs];
	                }
	                return spaces ? tabString + ts.repeatString(" ", spaces) : tabString;
	            }
	            else {
	                var spacesString = void 0;
	                var quotient = Math.floor(indentation / options.indentSize);
	                var remainder = indentation % options.indentSize;
	                if (!internedSpacesIndentation) {
	                    internedSpacesIndentation = [];
	                }
	                if (internedSpacesIndentation[quotient] === undefined) {
	                    spacesString = ts.repeatString(" ", options.indentSize * quotient);
	                    internedSpacesIndentation[quotient] = spacesString;
	                }
	                else {
	                    spacesString = internedSpacesIndentation[quotient];
	                }
	                return remainder ? spacesString + ts.repeatString(" ", remainder) : spacesString;
	            }
	        }
	        formatting.getIndentationString = getIndentationString;
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        var SmartIndenter;
	        (function (SmartIndenter) {
	            var Value;
	            (function (Value) {
	                Value[Value["Unknown"] = -1] = "Unknown";
	            })(Value || (Value = {}));
	            /**
	             * @param assumeNewLineBeforeCloseBrace
	             * `false` when called on text from a real source file.
	             * `true` when we need to assume `position` is on a newline.
	             *
	             * This is useful for codefixes. Consider
	             * ```
	             * function f() {
	             * |}
	             * ```
	             * with `position` at `|`.
	             *
	             * When inserting some text after an open brace, we would like to get indentation as if a newline was already there.
	             * By default indentation at `position` will be 0 so 'assumeNewLineBeforeCloseBrace' overrides this behavior.
	             */
	            function getIndentation(position, sourceFile, options, assumeNewLineBeforeCloseBrace) {
	                if (assumeNewLineBeforeCloseBrace === void 0) { assumeNewLineBeforeCloseBrace = false; }
	                if (position > sourceFile.text.length) {
	                    return getBaseIndentation(options); // past EOF
	                }
	                // no indentation when the indent style is set to none,
	                // so we can return fast
	                if (options.indentStyle === ts.IndentStyle.None) {
	                    return 0;
	                }
	                var precedingToken = ts.findPrecedingToken(position, sourceFile);
	                var enclosingCommentRange = formatting.getRangeOfEnclosingComment(sourceFile, position, /*onlyMultiLine*/ true, precedingToken || null); // tslint:disable-line:no-null-keyword
	                if (enclosingCommentRange) {
	                    return getCommentIndent(sourceFile, position, options, enclosingCommentRange);
	                }
	                if (!precedingToken) {
	                    return getBaseIndentation(options);
	                }
	                // no indentation in string \regex\template literals
	                var precedingTokenIsLiteral = ts.isStringOrRegularExpressionOrTemplateLiteral(precedingToken.kind);
	                if (precedingTokenIsLiteral && precedingToken.getStart(sourceFile) <= position && position < precedingToken.end) {
	                    return 0;
	                }
	                var lineAtPosition = sourceFile.getLineAndCharacterOfPosition(position).line;
	                // indentation is first non-whitespace character in a previous line
	                // for block indentation, we should look for a line which contains something that's not
	                // whitespace.
	                if (options.indentStyle === ts.IndentStyle.Block) {
	                    return getBlockIndent(sourceFile, position, options);
	                }
	                if (precedingToken.kind === 26 /* CommaToken */ && precedingToken.parent.kind !== 198 /* BinaryExpression */) {
	                    // previous token is comma that separates items in list - find the previous item and try to derive indentation from it
	                    var actualIndentation = getActualIndentationForListItemBeforeComma(precedingToken, sourceFile, options);
	                    if (actualIndentation !== -1 /* Unknown */) {
	                        return actualIndentation;
	                    }
	                }
	                return getSmartIndent(sourceFile, position, precedingToken, lineAtPosition, assumeNewLineBeforeCloseBrace, options);
	            }
	            SmartIndenter.getIndentation = getIndentation;
	            function getCommentIndent(sourceFile, position, options, enclosingCommentRange) {
	                var previousLine = ts.getLineAndCharacterOfPosition(sourceFile, position).line - 1;
	                var commentStartLine = ts.getLineAndCharacterOfPosition(sourceFile, enclosingCommentRange.pos).line;
	                ts.Debug.assert(commentStartLine >= 0);
	                if (previousLine <= commentStartLine) {
	                    return findFirstNonWhitespaceColumn(ts.getStartPositionOfLine(commentStartLine, sourceFile), position, sourceFile, options);
	                }
	                var startPostionOfLine = ts.getStartPositionOfLine(previousLine, sourceFile);
	                var _a = findFirstNonWhitespaceCharacterAndColumn(startPostionOfLine, position, sourceFile, options), column = _a.column, character = _a.character;
	                if (column === 0) {
	                    return column;
	                }
	                var firstNonWhitespaceCharacterCode = sourceFile.text.charCodeAt(startPostionOfLine + character);
	                return firstNonWhitespaceCharacterCode === 42 /* asterisk */ ? column - 1 : column;
	            }
	            function getBlockIndent(sourceFile, position, options) {
	                // move backwards until we find a line with a non-whitespace character,
	                // then find the first non-whitespace character for that line.
	                var current = position;
	                while (current > 0) {
	                    var char = sourceFile.text.charCodeAt(current);
	                    if (!ts.isWhiteSpaceLike(char)) {
	                        break;
	                    }
	                    current--;
	                }
	                var lineStart = ts.getLineStartPositionForPosition(current, sourceFile);
	                return findFirstNonWhitespaceColumn(lineStart, current, sourceFile, options);
	            }
	            function getSmartIndent(sourceFile, position, precedingToken, lineAtPosition, assumeNewLineBeforeCloseBrace, options) {
	                // try to find node that can contribute to indentation and includes 'position' starting from 'precedingToken'
	                // if such node is found - compute initial indentation for 'position' inside this node
	                var previous;
	                var current = precedingToken;
	                while (current) {
	                    if (ts.positionBelongsToNode(current, position, sourceFile) && shouldIndentChildNode(current, previous, /*isNextChild*/ true)) {
	                        var currentStart = getStartLineAndCharacterForNode(current, sourceFile);
	                        var nextTokenKind = nextTokenIsCurlyBraceOnSameLineAsCursor(precedingToken, current, lineAtPosition, sourceFile);
	                        var indentationDelta = nextTokenKind !== 0 /* Unknown */
	                            // handle cases when codefix is about to be inserted before the close brace
	                            ? assumeNewLineBeforeCloseBrace && nextTokenKind === 2 /* CloseBrace */ ? options.indentSize : 0
	                            : lineAtPosition !== currentStart.line ? options.indentSize : 0;
	                        return getIndentationForNodeWorker(current, currentStart, /*ignoreActualIndentationRange*/ undefined, indentationDelta, sourceFile, /*isNextChild*/ true, options);
	                    }
	                    // check if current node is a list item - if yes, take indentation from it
	                    var actualIndentation = getActualIndentationForListItem(current, sourceFile, options);
	                    if (actualIndentation !== -1 /* Unknown */) {
	                        return actualIndentation;
	                    }
	                    actualIndentation = getLineIndentationWhenExpressionIsInMultiLine(current, sourceFile, options);
	                    if (actualIndentation !== -1 /* Unknown */) {
	                        return actualIndentation + options.indentSize;
	                    }
	                    previous = current;
	                    current = current.parent;
	                }
	                // no parent was found - return the base indentation of the SourceFile
	                return getBaseIndentation(options);
	            }
	            function getIndentationForNode(n, ignoreActualIndentationRange, sourceFile, options) {
	                var start = sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile));
	                return getIndentationForNodeWorker(n, start, ignoreActualIndentationRange, /*indentationDelta*/ 0, sourceFile, /*isNextChild*/ false, options);
	            }
	            SmartIndenter.getIndentationForNode = getIndentationForNode;
	            function getBaseIndentation(options) {
	                return options.baseIndentSize || 0;
	            }
	            SmartIndenter.getBaseIndentation = getBaseIndentation;
	            function getIndentationForNodeWorker(current, currentStart, ignoreActualIndentationRange, indentationDelta, sourceFile, isNextChild, options) {
	                var parent = current.parent;
	                // Walk up the tree and collect indentation for parent-child node pairs. Indentation is not added if
	                // * parent and child nodes start on the same line, or
	                // * parent is an IfStatement and child starts on the same line as an 'else clause'.
	                while (parent) {
	                    var useActualIndentation = true;
	                    if (ignoreActualIndentationRange) {
	                        var start = current.getStart(sourceFile);
	                        useActualIndentation = start < ignoreActualIndentationRange.pos || start > ignoreActualIndentationRange.end;
	                    }
	                    if (useActualIndentation) {
	                        // check if current node is a list item - if yes, take indentation from it
	                        var actualIndentation = getActualIndentationForListItem(current, sourceFile, options);
	                        if (actualIndentation !== -1 /* Unknown */) {
	                            return actualIndentation + indentationDelta;
	                        }
	                    }
	                    var containingListOrParentStart = getContainingListOrParentStart(parent, current, sourceFile);
	                    var parentAndChildShareLine = containingListOrParentStart.line === currentStart.line ||
	                        childStartsOnTheSameLineWithElseInIfStatement(parent, current, currentStart.line, sourceFile);
	                    if (useActualIndentation) {
	                        // try to fetch actual indentation for current node from source text
	                        var actualIndentation = getActualIndentationForNode(current, parent, currentStart, parentAndChildShareLine, sourceFile, options);
	                        if (actualIndentation !== -1 /* Unknown */) {
	                            return actualIndentation + indentationDelta;
	                        }
	                        actualIndentation = getLineIndentationWhenExpressionIsInMultiLine(current, sourceFile, options);
	                        if (actualIndentation !== -1 /* Unknown */) {
	                            return actualIndentation + indentationDelta;
	                        }
	                    }
	                    // increase indentation if parent node wants its content to be indented and parent and child nodes don't start on the same line
	                    if (shouldIndentChildNode(parent, current, isNextChild) && !parentAndChildShareLine) {
	                        indentationDelta += options.indentSize;
	                    }
	                    // In our AST, a call argument's `parent` is the call-expression, not the argument list.
	                    // We would like to increase indentation based on the relationship between an argument and its argument-list,
	                    // so we spoof the starting position of the (parent) call-expression to match the (non-parent) argument-list.
	                    // But, the spoofed start-value could then cause a problem when comparing the start position of the call-expression
	                    // to *its* parent (in the case of an iife, an expression statement), adding an extra level of indentation.
	                    //
	                    // Instead, when at an argument, we unspoof the starting position of the enclosing call expression
	                    // *after* applying indentation for the argument.
	                    var useTrueStart = isArgumentAndStartLineOverlapsExpressionBeingCalled(parent, current, currentStart.line, sourceFile);
	                    current = parent;
	                    parent = current.parent;
	                    currentStart = useTrueStart ? sourceFile.getLineAndCharacterOfPosition(current.getStart(sourceFile)) : containingListOrParentStart;
	                }
	                return indentationDelta + getBaseIndentation(options);
	            }
	            function getContainingListOrParentStart(parent, child, sourceFile) {
	                var containingList = getContainingList(child, sourceFile);
	                var startPos = containingList ? containingList.pos : parent.getStart(sourceFile);
	                return sourceFile.getLineAndCharacterOfPosition(startPos);
	            }
	            /*
	             * Function returns Value.Unknown if indentation cannot be determined
	             */
	            function getActualIndentationForListItemBeforeComma(commaToken, sourceFile, options) {
	                // previous token is comma that separates items in list - find the previous item and try to derive indentation from it
	                var commaItemInfo = ts.findListItemInfo(commaToken);
	                if (commaItemInfo && commaItemInfo.listItemIndex > 0) {
	                    return deriveActualIndentationFromList(commaItemInfo.list.getChildren(), commaItemInfo.listItemIndex - 1, sourceFile, options);
	                }
	                else {
	                    // handle broken code gracefully
	                    return -1 /* Unknown */;
	                }
	            }
	            /*
	             * Function returns Value.Unknown if actual indentation for node should not be used (i.e because node is nested expression)
	             */
	            function getActualIndentationForNode(current, parent, currentLineAndChar, parentAndChildShareLine, sourceFile, options) {
	                // actual indentation is used for statements\declarations if one of cases below is true:
	                // - parent is SourceFile - by default immediate children of SourceFile are not indented except when user indents them manually
	                // - parent and child are not on the same line
	                var useActualIndentation = (ts.isDeclaration(current) || ts.isStatementButNotDeclaration(current)) &&
	                    (parent.kind === 272 /* SourceFile */ || !parentAndChildShareLine);
	                if (!useActualIndentation) {
	                    return -1 /* Unknown */;
	                }
	                return findColumnForFirstNonWhitespaceCharacterInLine(currentLineAndChar, sourceFile, options);
	            }
	            var NextTokenKind;
	            (function (NextTokenKind) {
	                NextTokenKind[NextTokenKind["Unknown"] = 0] = "Unknown";
	                NextTokenKind[NextTokenKind["OpenBrace"] = 1] = "OpenBrace";
	                NextTokenKind[NextTokenKind["CloseBrace"] = 2] = "CloseBrace";
	            })(NextTokenKind || (NextTokenKind = {}));
	            function nextTokenIsCurlyBraceOnSameLineAsCursor(precedingToken, current, lineAtPosition, sourceFile) {
	                var nextToken = ts.findNextToken(precedingToken, current);
	                if (!nextToken) {
	                    return 0 /* Unknown */;
	                }
	                if (nextToken.kind === 17 /* OpenBraceToken */) {
	                    // open braces are always indented at the parent level
	                    return 1 /* OpenBrace */;
	                }
	                else if (nextToken.kind === 18 /* CloseBraceToken */) {
	                    // close braces are indented at the parent level if they are located on the same line with cursor
	                    // this means that if new line will be added at $ position, this case will be indented
	                    // class A {
	                    //    $
	                    // }
	                    /// and this one - not
	                    // class A {
	                    // $}
	                    var nextTokenStartLine = getStartLineAndCharacterForNode(nextToken, sourceFile).line;
	                    return lineAtPosition === nextTokenStartLine ? 2 /* CloseBrace */ : 0 /* Unknown */;
	                }
	                return 0 /* Unknown */;
	            }
	            function getStartLineAndCharacterForNode(n, sourceFile) {
	                return sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile));
	            }
	            function isArgumentAndStartLineOverlapsExpressionBeingCalled(parent, child, childStartLine, sourceFile) {
	                if (!(ts.isCallExpression(parent) && ts.contains(parent.arguments, child))) {
	                    return false;
	                }
	                var expressionOfCallExpressionEnd = parent.expression.getEnd();
	                var expressionOfCallExpressionEndLine = ts.getLineAndCharacterOfPosition(sourceFile, expressionOfCallExpressionEnd).line;
	                return expressionOfCallExpressionEndLine === childStartLine;
	            }
	            SmartIndenter.isArgumentAndStartLineOverlapsExpressionBeingCalled = isArgumentAndStartLineOverlapsExpressionBeingCalled;
	            function childStartsOnTheSameLineWithElseInIfStatement(parent, child, childStartLine, sourceFile) {
	                if (parent.kind === 215 /* IfStatement */ && parent.elseStatement === child) {
	                    var elseKeyword = ts.findChildOfKind(parent, 82 /* ElseKeyword */, sourceFile);
	                    ts.Debug.assert(elseKeyword !== undefined);
	                    var elseKeywordStartLine = getStartLineAndCharacterForNode(elseKeyword, sourceFile).line;
	                    return elseKeywordStartLine === childStartLine;
	                }
	                return false;
	            }
	            SmartIndenter.childStartsOnTheSameLineWithElseInIfStatement = childStartsOnTheSameLineWithElseInIfStatement;
	            function getListIfStartEndIsInListRange(list, start, end) {
	                return list && ts.rangeContainsStartEnd(list, start, end) ? list : undefined;
	            }
	            function getContainingList(node, sourceFile) {
	                if (node.parent) {
	                    switch (node.parent.kind) {
	                        case 161 /* TypeReference */:
	                            return getListIfStartEndIsInListRange(node.parent.typeArguments, node.getStart(sourceFile), node.getEnd());
	                        case 182 /* ObjectLiteralExpression */:
	                            return node.parent.properties;
	                        case 181 /* ArrayLiteralExpression */:
	                            return node.parent.elements;
	                        case 232 /* FunctionDeclaration */:
	                        case 190 /* FunctionExpression */:
	                        case 191 /* ArrowFunction */:
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 157 /* CallSignature */:
	                        case 154 /* Constructor */:
	                        case 163 /* ConstructorType */:
	                        case 158 /* ConstructSignature */: {
	                            var start = node.getStart(sourceFile);
	                            return getListIfStartEndIsInListRange(node.parent.typeParameters, start, node.getEnd()) ||
	                                getListIfStartEndIsInListRange(node.parent.parameters, start, node.getEnd());
	                        }
	                        case 233 /* ClassDeclaration */:
	                            return getListIfStartEndIsInListRange(node.parent.typeParameters, node.getStart(sourceFile), node.getEnd());
	                        case 186 /* NewExpression */:
	                        case 185 /* CallExpression */: {
	                            var start = node.getStart(sourceFile);
	                            return getListIfStartEndIsInListRange(node.parent.typeArguments, start, node.getEnd()) ||
	                                getListIfStartEndIsInListRange(node.parent.arguments, start, node.getEnd());
	                        }
	                        case 231 /* VariableDeclarationList */:
	                            return getListIfStartEndIsInListRange(node.parent.declarations, node.getStart(sourceFile), node.getEnd());
	                        case 245 /* NamedImports */:
	                        case 249 /* NamedExports */:
	                            return getListIfStartEndIsInListRange(node.parent.elements, node.getStart(sourceFile), node.getEnd());
	                    }
	                }
	                return undefined;
	            }
	            SmartIndenter.getContainingList = getContainingList;
	            function getActualIndentationForListItem(node, sourceFile, options) {
	                var containingList = getContainingList(node, sourceFile);
	                if (containingList) {
	                    var index = containingList.indexOf(node);
	                    if (index !== -1) {
	                        return deriveActualIndentationFromList(containingList, index, sourceFile, options);
	                    }
	                }
	                return -1 /* Unknown */;
	            }
	            function getLineIndentationWhenExpressionIsInMultiLine(node, sourceFile, options) {
	                // actual indentation should not be used when:
	                // - node is close parenthesis - this is the end of the expression
	                if (node.kind === 20 /* CloseParenToken */) {
	                    return -1 /* Unknown */;
	                }
	                if (node.parent && ts.isCallOrNewExpression(node.parent) && node.parent.expression !== node) {
	                    var fullCallOrNewExpression = node.parent.expression;
	                    var startingExpression = getStartingExpression(fullCallOrNewExpression);
	                    if (fullCallOrNewExpression === startingExpression) {
	                        return -1 /* Unknown */;
	                    }
	                    var fullCallOrNewExpressionEnd = sourceFile.getLineAndCharacterOfPosition(fullCallOrNewExpression.end);
	                    var startingExpressionEnd = sourceFile.getLineAndCharacterOfPosition(startingExpression.end);
	                    if (fullCallOrNewExpressionEnd.line === startingExpressionEnd.line) {
	                        return -1 /* Unknown */;
	                    }
	                    return findColumnForFirstNonWhitespaceCharacterInLine(fullCallOrNewExpressionEnd, sourceFile, options);
	                }
	                return -1 /* Unknown */;
	                function getStartingExpression(node) {
	                    while (true) {
	                        switch (node.kind) {
	                            case 185 /* CallExpression */:
	                            case 186 /* NewExpression */:
	                            case 183 /* PropertyAccessExpression */:
	                            case 184 /* ElementAccessExpression */:
	                                node = node.expression;
	                                break;
	                            default:
	                                return node;
	                        }
	                    }
	                }
	            }
	            function deriveActualIndentationFromList(list, index, sourceFile, options) {
	                ts.Debug.assert(index >= 0 && index < list.length);
	                var node = list[index];
	                // walk toward the start of the list starting from current node and check if the line is the same for all items.
	                // if end line for item [i - 1] differs from the start line for item [i] - find column of the first non-whitespace character on the line of item [i]
	                var lineAndCharacter = getStartLineAndCharacterForNode(node, sourceFile);
	                for (var i = index - 1; i >= 0; i--) {
	                    if (list[i].kind === 26 /* CommaToken */) {
	                        continue;
	                    }
	                    // skip list items that ends on the same line with the current list element
	                    var prevEndLine = sourceFile.getLineAndCharacterOfPosition(list[i].end).line;
	                    if (prevEndLine !== lineAndCharacter.line) {
	                        return findColumnForFirstNonWhitespaceCharacterInLine(lineAndCharacter, sourceFile, options);
	                    }
	                    lineAndCharacter = getStartLineAndCharacterForNode(list[i], sourceFile);
	                }
	                return -1 /* Unknown */;
	            }
	            function findColumnForFirstNonWhitespaceCharacterInLine(lineAndCharacter, sourceFile, options) {
	                var lineStart = sourceFile.getPositionOfLineAndCharacter(lineAndCharacter.line, 0);
	                return findFirstNonWhitespaceColumn(lineStart, lineStart + lineAndCharacter.character, sourceFile, options);
	            }
	            /**
	             * Character is the actual index of the character since the beginning of the line.
	             * Column - position of the character after expanding tabs to spaces.
	             * "0\t2$"
	             * value of 'character' for '$' is 3
	             * value of 'column' for '$' is 6 (assuming that tab size is 4)
	             */
	            function findFirstNonWhitespaceCharacterAndColumn(startPos, endPos, sourceFile, options) {
	                var character = 0;
	                var column = 0;
	                for (var pos = startPos; pos < endPos; pos++) {
	                    var ch = sourceFile.text.charCodeAt(pos);
	                    if (!ts.isWhiteSpaceSingleLine(ch)) {
	                        break;
	                    }
	                    if (ch === 9 /* tab */) {
	                        column += options.tabSize + (column % options.tabSize);
	                    }
	                    else {
	                        column++;
	                    }
	                    character++;
	                }
	                return { column: column, character: character };
	            }
	            SmartIndenter.findFirstNonWhitespaceCharacterAndColumn = findFirstNonWhitespaceCharacterAndColumn;
	            function findFirstNonWhitespaceColumn(startPos, endPos, sourceFile, options) {
	                return findFirstNonWhitespaceCharacterAndColumn(startPos, endPos, sourceFile, options).column;
	            }
	            SmartIndenter.findFirstNonWhitespaceColumn = findFirstNonWhitespaceColumn;
	            function nodeContentIsAlwaysIndented(kind) {
	                switch (kind) {
	                    case 214 /* ExpressionStatement */:
	                    case 233 /* ClassDeclaration */:
	                    case 203 /* ClassExpression */:
	                    case 234 /* InterfaceDeclaration */:
	                    case 236 /* EnumDeclaration */:
	                    case 235 /* TypeAliasDeclaration */:
	                    case 181 /* ArrayLiteralExpression */:
	                    case 211 /* Block */:
	                    case 238 /* ModuleBlock */:
	                    case 182 /* ObjectLiteralExpression */:
	                    case 165 /* TypeLiteral */:
	                    case 176 /* MappedType */:
	                    case 167 /* TupleType */:
	                    case 239 /* CaseBlock */:
	                    case 265 /* DefaultClause */:
	                    case 264 /* CaseClause */:
	                    case 189 /* ParenthesizedExpression */:
	                    case 183 /* PropertyAccessExpression */:
	                    case 185 /* CallExpression */:
	                    case 186 /* NewExpression */:
	                    case 212 /* VariableStatement */:
	                    case 230 /* VariableDeclaration */:
	                    case 247 /* ExportAssignment */:
	                    case 223 /* ReturnStatement */:
	                    case 199 /* ConditionalExpression */:
	                    case 179 /* ArrayBindingPattern */:
	                    case 178 /* ObjectBindingPattern */:
	                    case 255 /* JsxOpeningElement */:
	                    case 258 /* JsxOpeningFragment */:
	                    case 254 /* JsxSelfClosingElement */:
	                    case 263 /* JsxExpression */:
	                    case 152 /* MethodSignature */:
	                    case 157 /* CallSignature */:
	                    case 158 /* ConstructSignature */:
	                    case 148 /* Parameter */:
	                    case 162 /* FunctionType */:
	                    case 163 /* ConstructorType */:
	                    case 172 /* ParenthesizedType */:
	                    case 187 /* TaggedTemplateExpression */:
	                    case 195 /* AwaitExpression */:
	                    case 249 /* NamedExports */:
	                    case 245 /* NamedImports */:
	                    case 250 /* ExportSpecifier */:
	                    case 246 /* ImportSpecifier */:
	                    case 268 /* PropertyAssignment */:
	                    case 151 /* PropertyDeclaration */:
	                        return true;
	                }
	                return false;
	            }
	            function nodeWillIndentChild(parent, child, indentByDefault) {
	                var childKind = child ? child.kind : 0 /* Unknown */;
	                switch (parent.kind) {
	                    case 216 /* DoStatement */:
	                    case 217 /* WhileStatement */:
	                    case 219 /* ForInStatement */:
	                    case 220 /* ForOfStatement */:
	                    case 218 /* ForStatement */:
	                    case 215 /* IfStatement */:
	                    case 232 /* FunctionDeclaration */:
	                    case 190 /* FunctionExpression */:
	                    case 153 /* MethodDeclaration */:
	                    case 191 /* ArrowFunction */:
	                    case 154 /* Constructor */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        return childKind !== 211 /* Block */;
	                    case 248 /* ExportDeclaration */:
	                        return childKind !== 249 /* NamedExports */;
	                    case 242 /* ImportDeclaration */:
	                        return childKind !== 243 /* ImportClause */ ||
	                            (!!child.namedBindings && child.namedBindings.kind !== 245 /* NamedImports */);
	                    case 253 /* JsxElement */:
	                        return childKind !== 256 /* JsxClosingElement */;
	                    case 257 /* JsxFragment */:
	                        return childKind !== 259 /* JsxClosingFragment */;
	                }
	                // No explicit rule for given nodes so the result will follow the default value argument
	                return indentByDefault;
	            }
	            SmartIndenter.nodeWillIndentChild = nodeWillIndentChild;
	            function isControlFlowEndingStatement(kind, parent) {
	                switch (kind) {
	                    case 223 /* ReturnStatement */:
	                    case 227 /* ThrowStatement */:
	                        switch (parent.kind) {
	                            case 211 /* Block */:
	                                var grandParent = parent.parent;
	                                switch (grandParent && grandParent.kind) {
	                                    case 232 /* FunctionDeclaration */:
	                                    case 190 /* FunctionExpression */:
	                                        // We may want to write inner functions after this.
	                                        return false;
	                                    default:
	                                        return true;
	                                }
	                            case 264 /* CaseClause */:
	                            case 265 /* DefaultClause */:
	                            case 272 /* SourceFile */:
	                            case 238 /* ModuleBlock */:
	                                return true;
	                            default:
	                                throw ts.Debug.fail();
	                        }
	                    case 221 /* ContinueStatement */:
	                    case 222 /* BreakStatement */:
	                        return true;
	                    default:
	                        return false;
	                }
	            }
	            /**
	             * True when the parent node should indent the given child by an explicit rule.
	             * @param isNextChild If true, we are judging indent of a hypothetical child *after* this one, not the current child.
	             */
	            function shouldIndentChildNode(parent, child, isNextChild) {
	                if (isNextChild === void 0) { isNextChild = false; }
	                return (nodeContentIsAlwaysIndented(parent.kind) || nodeWillIndentChild(parent, child, /*indentByDefault*/ false))
	                    && !(isNextChild && child && isControlFlowEndingStatement(child.kind, parent));
	            }
	            SmartIndenter.shouldIndentChildNode = shouldIndentChildNode;
	        })(SmartIndenter = formatting.SmartIndenter || (formatting.SmartIndenter = {}));
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var textChanges;
	    (function (textChanges_1) {
	        /**
	         * Currently for simplicity we store recovered positions on the node itself.
	         * It can be changed to side-table later if we decide that current design is too invasive.
	         */
	        function getPos(n) {
	            var result = n.__pos;
	            ts.Debug.assert(typeof result === "number");
	            return result;
	        }
	        function setPos(n, pos) {
	            ts.Debug.assert(typeof pos === "number");
	            n.__pos = pos;
	        }
	        function getEnd(n) {
	            var result = n.__end;
	            ts.Debug.assert(typeof result === "number");
	            return result;
	        }
	        function setEnd(n, end) {
	            ts.Debug.assert(typeof end === "number");
	            n.__end = end;
	        }
	        var Position;
	        (function (Position) {
	            Position[Position["FullStart"] = 0] = "FullStart";
	            Position[Position["Start"] = 1] = "Start";
	        })(Position = textChanges_1.Position || (textChanges_1.Position = {}));
	        function skipWhitespacesAndLineBreaks(text, start) {
	            return ts.skipTrivia(text, start, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
	        }
	        function hasCommentsBeforeLineBreak(text, start) {
	            var i = start;
	            while (i < text.length) {
	                var ch = text.charCodeAt(i);
	                if (ts.isWhiteSpaceSingleLine(ch)) {
	                    i++;
	                    continue;
	                }
	                return ch === 47 /* slash */;
	            }
	            return false;
	        }
	        textChanges_1.useNonAdjustedPositions = {
	            useNonAdjustedStartPosition: true,
	            useNonAdjustedEndPosition: true,
	        };
	        var ChangeKind;
	        (function (ChangeKind) {
	            ChangeKind[ChangeKind["Remove"] = 0] = "Remove";
	            ChangeKind[ChangeKind["ReplaceWithSingleNode"] = 1] = "ReplaceWithSingleNode";
	            ChangeKind[ChangeKind["ReplaceWithMultipleNodes"] = 2] = "ReplaceWithMultipleNodes";
	        })(ChangeKind || (ChangeKind = {}));
	        function getSeparatorCharacter(separator) {
	            return ts.tokenToString(separator.kind);
	        }
	        textChanges_1.getSeparatorCharacter = getSeparatorCharacter;
	        function getAdjustedStartPosition(sourceFile, node, options, position) {
	            if (options.useNonAdjustedStartPosition) {
	                return node.getStart();
	            }
	            var fullStart = node.getFullStart();
	            var start = node.getStart(sourceFile);
	            if (fullStart === start) {
	                return start;
	            }
	            var fullStartLine = ts.getLineStartPositionForPosition(fullStart, sourceFile);
	            var startLine = ts.getLineStartPositionForPosition(start, sourceFile);
	            if (startLine === fullStartLine) {
	                // full start and start of the node are on the same line
	                //   a,     b;
	                //    ^     ^
	                //    |   start
	                // fullstart
	                // when b is replaced - we usually want to keep the leading trvia
	                // when b is deleted - we delete it
	                return position === Position.Start ? start : fullStart;
	            }
	            // get start position of the line following the line that contains fullstart position
	            // (but only if the fullstart isn't the very beginning of the file)
	            var nextLineStart = fullStart > 0 ? 1 : 0;
	            var adjustedStartPosition = ts.getStartPositionOfLine(ts.getLineOfLocalPosition(sourceFile, fullStartLine) + nextLineStart, sourceFile);
	            // skip whitespaces/newlines
	            adjustedStartPosition = skipWhitespacesAndLineBreaks(sourceFile.text, adjustedStartPosition);
	            return ts.getStartPositionOfLine(ts.getLineOfLocalPosition(sourceFile, adjustedStartPosition), sourceFile);
	        }
	        textChanges_1.getAdjustedStartPosition = getAdjustedStartPosition;
	        function getAdjustedEndPosition(sourceFile, node, options) {
	            if (options.useNonAdjustedEndPosition || ts.isExpression(node)) {
	                return node.getEnd();
	            }
	            var end = node.getEnd();
	            var newEnd = ts.skipTrivia(sourceFile.text, end, /*stopAfterLineBreak*/ true);
	            return newEnd !== end && ts.isLineBreak(sourceFile.text.charCodeAt(newEnd - 1))
	                ? newEnd
	                : end;
	        }
	        textChanges_1.getAdjustedEndPosition = getAdjustedEndPosition;
	        /**
	         * Checks if 'candidate' argument is a legal separator in the list that contains 'node' as an element
	         */
	        function isSeparator(node, candidate) {
	            return candidate && node.parent && (candidate.kind === 26 /* CommaToken */ || (candidate.kind === 25 /* SemicolonToken */ && node.parent.kind === 182 /* ObjectLiteralExpression */));
	        }
	        function spaces(count) {
	            var s = "";
	            for (var i = 0; i < count; i++) {
	                s += " ";
	            }
	            return s;
	        }
	        var ChangeTracker = /** @class */ (function () {
	            /** Public for tests only. Other callers should use `ChangeTracker.with`. */
	            function ChangeTracker(newLineCharacter, formatContext, validator) {
	                this.newLineCharacter = newLineCharacter;
	                this.formatContext = formatContext;
	                this.validator = validator;
	                this.changes = [];
	                this.deletedNodesInLists = []; // Stores ids of nodes in lists that we already deleted. Used to avoid deleting `, ` twice in `a, b`.
	                // Map from class id to nodes to insert at the start
	                this.nodesInsertedAtClassStarts = ts.createMap();
	            }
	            ChangeTracker.fromContext = function (context) {
	                return new ChangeTracker(ts.getNewLineOrDefaultFromHost(context.host, context.formatContext.options), context.formatContext);
	            };
	            ChangeTracker.with = function (context, cb) {
	                var tracker = ChangeTracker.fromContext(context);
	                cb(tracker);
	                return tracker.getChanges();
	            };
	            ChangeTracker.prototype.deleteRange = function (sourceFile, range) {
	                this.changes.push({ kind: ChangeKind.Remove, sourceFile: sourceFile, range: range });
	                return this;
	            };
	            ChangeTracker.prototype.deleteNode = function (sourceFile, node, options) {
	                if (options === void 0) { options = {}; }
	                var startPosition = getAdjustedStartPosition(sourceFile, node, options, Position.FullStart);
	                var endPosition = getAdjustedEndPosition(sourceFile, node, options);
	                this.deleteRange(sourceFile, { pos: startPosition, end: endPosition });
	                return this;
	            };
	            ChangeTracker.prototype.deleteNodeRange = function (sourceFile, startNode, endNode, options) {
	                if (options === void 0) { options = {}; }
	                var startPosition = getAdjustedStartPosition(sourceFile, startNode, options, Position.FullStart);
	                var endPosition = getAdjustedEndPosition(sourceFile, endNode, options);
	                this.deleteRange(sourceFile, { pos: startPosition, end: endPosition });
	                return this;
	            };
	            ChangeTracker.prototype.deleteNodeInList = function (sourceFile, node) {
	                var containingList = ts.formatting.SmartIndenter.getContainingList(node, sourceFile);
	                if (!containingList) {
	                    ts.Debug.fail("node is not a list element");
	                    return this;
	                }
	                var index = ts.indexOfNode(containingList, node);
	                if (index < 0) {
	                    return this;
	                }
	                if (containingList.length === 1) {
	                    this.deleteNode(sourceFile, node);
	                    return this;
	                }
	                var id = ts.getNodeId(node);
	                ts.Debug.assert(!this.deletedNodesInLists[id], "Deleting a node twice");
	                this.deletedNodesInLists[id] = true;
	                if (index !== containingList.length - 1) {
	                    var nextToken = ts.getTokenAtPosition(sourceFile, node.end, /*includeJsDocComment*/ false);
	                    if (nextToken && isSeparator(node, nextToken)) {
	                        // find first non-whitespace position in the leading trivia of the node
	                        var startPosition = ts.skipTrivia(sourceFile.text, getAdjustedStartPosition(sourceFile, node, {}, Position.FullStart), /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
	                        var nextElement = containingList[index + 1];
	                        /// find first non-whitespace position in the leading trivia of the next node
	                        var endPosition = ts.skipTrivia(sourceFile.text, getAdjustedStartPosition(sourceFile, nextElement, {}, Position.FullStart), /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
	                        // shift next node so its first non-whitespace position will be moved to the first non-whitespace position of the deleted node
	                        this.deleteRange(sourceFile, { pos: startPosition, end: endPosition });
	                    }
	                }
	                else {
	                    var prev = containingList[index - 1];
	                    if (this.deletedNodesInLists[ts.getNodeId(prev)]) {
	                        var pos = ts.skipTrivia(sourceFile.text, getAdjustedStartPosition(sourceFile, node, {}, Position.FullStart), /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
	                        var end = getAdjustedEndPosition(sourceFile, node, {});
	                        this.deleteRange(sourceFile, { pos: pos, end: end });
	                    }
	                    else {
	                        var previousToken = ts.getTokenAtPosition(sourceFile, containingList[index - 1].end, /*includeJsDocComment*/ false);
	                        if (previousToken && isSeparator(node, previousToken)) {
	                            this.deleteNodeRange(sourceFile, previousToken, node);
	                        }
	                    }
	                }
	                return this;
	            };
	            // TODO (https://github.com/Microsoft/TypeScript/issues/21246): default should probably be useNonAdjustedPositions
	            ChangeTracker.prototype.replaceRange = function (sourceFile, range, newNode, options) {
	                if (options === void 0) { options = {}; }
	                this.changes.push({ kind: ChangeKind.ReplaceWithSingleNode, sourceFile: sourceFile, range: range, options: options, node: newNode });
	                return this;
	            };
	            // TODO (https://github.com/Microsoft/TypeScript/issues/21246): default should probably be useNonAdjustedPositions
	            ChangeTracker.prototype.replaceNode = function (sourceFile, oldNode, newNode, options) {
	                if (options === void 0) { options = {}; }
	                var pos = getAdjustedStartPosition(sourceFile, oldNode, options, Position.Start);
	                var end = getAdjustedEndPosition(sourceFile, oldNode, options);
	                return this.replaceRange(sourceFile, { pos: pos, end: end }, newNode, options);
	            };
	            // TODO (https://github.com/Microsoft/TypeScript/issues/21246): default should probably be useNonAdjustedPositions
	            ChangeTracker.prototype.replaceNodeRange = function (sourceFile, startNode, endNode, newNode, options) {
	                if (options === void 0) { options = {}; }
	                var pos = getAdjustedStartPosition(sourceFile, startNode, options, Position.Start);
	                var end = getAdjustedEndPosition(sourceFile, endNode, options);
	                return this.replaceRange(sourceFile, { pos: pos, end: end }, newNode, options);
	            };
	            ChangeTracker.prototype.replaceRangeWithNodes = function (sourceFile, range, newNodes, options) {
	                if (options === void 0) { options = textChanges_1.useNonAdjustedPositions; }
	                this.changes.push({ kind: ChangeKind.ReplaceWithMultipleNodes, sourceFile: sourceFile, range: range, options: options, nodes: newNodes });
	                return this;
	            };
	            ChangeTracker.prototype.replaceNodeWithNodes = function (sourceFile, oldNode, newNodes, options) {
	                if (options === void 0) { options = textChanges_1.useNonAdjustedPositions; }
	                var pos = getAdjustedStartPosition(sourceFile, oldNode, options, Position.Start);
	                var end = getAdjustedEndPosition(sourceFile, oldNode, options);
	                return this.replaceRangeWithNodes(sourceFile, { pos: pos, end: end }, newNodes, options);
	            };
	            ChangeTracker.prototype.replaceNodeRangeWithNodes = function (sourceFile, startNode, endNode, newNodes, options) {
	                if (options === void 0) { options = textChanges_1.useNonAdjustedPositions; }
	                var pos = getAdjustedStartPosition(sourceFile, startNode, options, Position.Start);
	                var end = getAdjustedEndPosition(sourceFile, endNode, options);
	                return this.replaceRangeWithNodes(sourceFile, { pos: pos, end: end }, newNodes, options);
	            };
	            ChangeTracker.prototype.insertNodeAt = function (sourceFile, pos, newNode, options) {
	                if (options === void 0) { options = {}; }
	                this.changes.push({ kind: ChangeKind.ReplaceWithSingleNode, sourceFile: sourceFile, options: options, node: newNode, range: { pos: pos, end: pos } });
	                return this;
	            };
	            ChangeTracker.prototype.insertNodeAtTopOfFile = function (sourceFile, newNode, blankLineBetween) {
	                var pos = getInsertionPositionAtSourceFileTop(sourceFile);
	                this.insertNodeAt(sourceFile, pos, newNode, {
	                    prefix: pos === 0 ? undefined : this.newLineCharacter,
	                    suffix: (ts.isLineBreak(sourceFile.text.charCodeAt(pos)) ? "" : this.newLineCharacter) + (blankLineBetween ? this.newLineCharacter : ""),
	                });
	            };
	            ChangeTracker.prototype.insertNodeBefore = function (sourceFile, before, newNode, blankLineBetween) {
	                if (blankLineBetween === void 0) { blankLineBetween = false; }
	                var pos = getAdjustedStartPosition(sourceFile, before, {}, Position.Start);
	                return this.replaceRange(sourceFile, { pos: pos, end: pos }, newNode, this.getOptionsForInsertNodeBefore(before, blankLineBetween));
	            };
	            ChangeTracker.prototype.insertModifierBefore = function (sourceFile, modifier, before) {
	                var pos = before.getStart(sourceFile);
	                this.replaceRange(sourceFile, { pos: pos, end: pos }, ts.createToken(modifier), { suffix: " " });
	            };
	            ChangeTracker.prototype.getOptionsForInsertNodeBefore = function (before, doubleNewlines) {
	                if (ts.isStatement(before) || ts.isClassElement(before)) {
	                    return { suffix: doubleNewlines ? this.newLineCharacter + this.newLineCharacter : this.newLineCharacter };
	                }
	                else if (ts.isVariableDeclaration(before)) {
	                    return { suffix: ", " };
	                }
	                throw ts.Debug.failBadSyntaxKind(before); // We haven't handled this kind of node yet -- add it
	            };
	            ChangeTracker.prototype.insertNodeAtConstructorStart = function (sourceFile, ctr, newStatement) {
	                var firstStatement = ts.firstOrUndefined(ctr.body.statements);
	                if (!firstStatement || !ctr.body.multiLine) {
	                    this.replaceConstructorBody(sourceFile, ctr, [newStatement].concat(ctr.body.statements));
	                }
	                else {
	                    this.insertNodeBefore(sourceFile, firstStatement, newStatement);
	                }
	            };
	            ChangeTracker.prototype.insertNodeAtConstructorEnd = function (sourceFile, ctr, newStatement) {
	                var lastStatement = ts.lastOrUndefined(ctr.body.statements);
	                if (!lastStatement || !ctr.body.multiLine) {
	                    this.replaceConstructorBody(sourceFile, ctr, ctr.body.statements.concat([newStatement]));
	                }
	                else {
	                    this.insertNodeAfter(sourceFile, lastStatement, newStatement);
	                }
	            };
	            ChangeTracker.prototype.replaceConstructorBody = function (sourceFile, ctr, statements) {
	                this.replaceNode(sourceFile, ctr.body, ts.createBlock(statements, /*multiLine*/ true), { useNonAdjustedEndPosition: true });
	            };
	            ChangeTracker.prototype.insertNodeAtEndOfScope = function (sourceFile, scope, newNode) {
	                var pos = getAdjustedStartPosition(sourceFile, scope.getLastToken(), {}, Position.Start);
	                this.replaceRange(sourceFile, { pos: pos, end: pos }, newNode, {
	                    prefix: ts.isLineBreak(sourceFile.text.charCodeAt(scope.getLastToken().pos)) ? this.newLineCharacter : this.newLineCharacter + this.newLineCharacter,
	                    suffix: this.newLineCharacter
	                });
	            };
	            ChangeTracker.prototype.insertNodeAtClassStart = function (sourceFile, cls, newElement) {
	                var firstMember = ts.firstOrUndefined(cls.members);
	                if (!firstMember) {
	                    var id = ts.getNodeId(cls).toString();
	                    var newMembers = this.nodesInsertedAtClassStarts.get(id);
	                    if (newMembers) {
	                        ts.Debug.assert(newMembers.sourceFile === sourceFile && newMembers.cls === cls);
	                        newMembers.members.push(newElement);
	                    }
	                    else {
	                        this.nodesInsertedAtClassStarts.set(id, { sourceFile: sourceFile, cls: cls, members: [newElement] });
	                    }
	                }
	                else {
	                    this.insertNodeBefore(sourceFile, firstMember, newElement);
	                }
	            };
	            ChangeTracker.prototype.insertNodeAfter = function (sourceFile, after, newNode) {
	                if (ts.isStatementButNotDeclaration(after) ||
	                    after.kind === 151 /* PropertyDeclaration */ ||
	                    after.kind === 150 /* PropertySignature */ ||
	                    after.kind === 152 /* MethodSignature */) {
	                    // check if previous statement ends with semicolon
	                    // if not - insert semicolon to preserve the code from changing the meaning due to ASI
	                    if (sourceFile.text.charCodeAt(after.end - 1) !== 59 /* semicolon */) {
	                        this.changes.push({
	                            kind: ChangeKind.ReplaceWithSingleNode,
	                            sourceFile: sourceFile,
	                            options: {},
	                            range: { pos: after.end, end: after.end },
	                            node: ts.createToken(25 /* SemicolonToken */)
	                        });
	                    }
	                }
	                var endPosition = getAdjustedEndPosition(sourceFile, after, {});
	                return this.replaceRange(sourceFile, { pos: endPosition, end: endPosition }, newNode, this.getInsertNodeAfterOptions(after));
	            };
	            ChangeTracker.prototype.getInsertNodeAfterOptions = function (node) {
	                if (ts.isClassDeclaration(node) || ts.isModuleDeclaration(node)) {
	                    return { prefix: this.newLineCharacter, suffix: this.newLineCharacter };
	                }
	                else if (ts.isStatement(node) || ts.isClassElement(node) || ts.isTypeElement(node)) {
	                    return { suffix: this.newLineCharacter };
	                }
	                else if (ts.isVariableDeclaration(node)) {
	                    return { prefix: ", " };
	                }
	                throw ts.Debug.failBadSyntaxKind(node); // We haven't handled this kind of node yet -- add it
	            };
	            /**
	             * This function should be used to insert nodes in lists when nodes don't carry separators as the part of the node range,
	             * i.e. arguments in arguments lists, parameters in parameter lists etc.
	             * Note that separators are part of the node in statements and class elements.
	             */
	            ChangeTracker.prototype.insertNodeInListAfter = function (sourceFile, after, newNode) {
	                var containingList = ts.formatting.SmartIndenter.getContainingList(after, sourceFile);
	                if (!containingList) {
	                    ts.Debug.fail("node is not a list element");
	                    return this;
	                }
	                var index = ts.indexOfNode(containingList, after);
	                if (index < 0) {
	                    return this;
	                }
	                var end = after.getEnd();
	                if (index !== containingList.length - 1) {
	                    // any element except the last one
	                    // use next sibling as an anchor
	                    var nextToken = ts.getTokenAtPosition(sourceFile, after.end, /*includeJsDocComment*/ false);
	                    if (nextToken && isSeparator(after, nextToken)) {
	                        // for list
	                        // a, b, c
	                        // create change for adding 'e' after 'a' as
	                        // - find start of next element after a (it is b)
	                        // - use this start as start and end position in final change
	                        // - build text of change by formatting the text of node + separator + whitespace trivia of b
	                        // in multiline case it will work as
	                        //   a,
	                        //   b,
	                        //   c,
	                        // result - '*' denotes leading trivia that will be inserted after new text (displayed as '#')
	                        //   a,*
	                        // ***insertedtext<separator>#
	                        // ###b,
	                        //   c,
	                        // find line and character of the next element
	                        var lineAndCharOfNextElement = ts.getLineAndCharacterOfPosition(sourceFile, skipWhitespacesAndLineBreaks(sourceFile.text, containingList[index + 1].getFullStart()));
	                        // find line and character of the token that precedes next element (usually it is separator)
	                        var lineAndCharOfNextToken = ts.getLineAndCharacterOfPosition(sourceFile, nextToken.end);
	                        var prefix = void 0;
	                        var startPos = void 0;
	                        if (lineAndCharOfNextToken.line === lineAndCharOfNextElement.line) {
	                            // next element is located on the same line with separator:
	                            // a,$$$$b
	                            //  ^    ^
	                            //  |    |-next element
	                            //  |-separator
	                            // where $$$ is some leading trivia
	                            // for a newly inserted node we'll maintain the same relative position comparing to separator and replace leading trivia with spaces
	                            // a,    x,$$$$b
	                            //  ^    ^     ^
	                            //  |    |     |-next element
	                            //  |    |-new inserted node padded with spaces
	                            //  |-separator
	                            startPos = nextToken.end;
	                            prefix = spaces(lineAndCharOfNextElement.character - lineAndCharOfNextToken.character);
	                        }
	                        else {
	                            // next element is located on different line that separator
	                            // let insert position be the beginning of the line that contains next element
	                            startPos = ts.getStartPositionOfLine(lineAndCharOfNextElement.line, sourceFile);
	                        }
	                        this.changes.push({
	                            kind: ChangeKind.ReplaceWithSingleNode,
	                            sourceFile: sourceFile,
	                            range: { pos: startPos, end: containingList[index + 1].getStart(sourceFile) },
	                            node: newNode,
	                            options: {
	                                prefix: prefix,
	                                // write separator and leading trivia of the next element as suffix
	                                suffix: "" + ts.tokenToString(nextToken.kind) + sourceFile.text.substring(nextToken.end, containingList[index + 1].getStart(sourceFile))
	                            }
	                        });
	                    }
	                }
	                else {
	                    var afterStart = after.getStart(sourceFile);
	                    var afterStartLinePosition = ts.getLineStartPositionForPosition(afterStart, sourceFile);
	                    var separator = void 0;
	                    var multilineList = false;
	                    // insert element after the last element in the list that has more than one item
	                    // pick the element preceding the after element to:
	                    // - pick the separator
	                    // - determine if list is a multiline
	                    if (containingList.length === 1) {
	                        // if list has only one element then we'll format is as multiline if node has comment in trailing trivia, or as singleline otherwise
	                        // i.e. var x = 1 // this is x
	                        //     | new element will be inserted at this position
	                        separator = 26 /* CommaToken */;
	                    }
	                    else {
	                        // element has more than one element, pick separator from the list
	                        var tokenBeforeInsertPosition = ts.findPrecedingToken(after.pos, sourceFile);
	                        separator = isSeparator(after, tokenBeforeInsertPosition) ? tokenBeforeInsertPosition.kind : 26 /* CommaToken */;
	                        // determine if list is multiline by checking lines of after element and element that precedes it.
	                        var afterMinusOneStartLinePosition = ts.getLineStartPositionForPosition(containingList[index - 1].getStart(sourceFile), sourceFile);
	                        multilineList = afterMinusOneStartLinePosition !== afterStartLinePosition;
	                    }
	                    if (hasCommentsBeforeLineBreak(sourceFile.text, after.end)) {
	                        // in this case we'll always treat containing list as multiline
	                        multilineList = true;
	                    }
	                    if (multilineList) {
	                        // insert separator immediately following the 'after' node to preserve comments in trailing trivia
	                        this.changes.push({
	                            kind: ChangeKind.ReplaceWithSingleNode,
	                            sourceFile: sourceFile,
	                            range: { pos: end, end: end },
	                            node: ts.createToken(separator),
	                            options: {}
	                        });
	                        // use the same indentation as 'after' item
	                        var indentation = ts.formatting.SmartIndenter.findFirstNonWhitespaceColumn(afterStartLinePosition, afterStart, sourceFile, this.formatContext.options);
	                        // insert element before the line break on the line that contains 'after' element
	                        var insertPos = ts.skipTrivia(sourceFile.text, end, /*stopAfterLineBreak*/ true, /*stopAtComments*/ false);
	                        if (insertPos !== end && ts.isLineBreak(sourceFile.text.charCodeAt(insertPos - 1))) {
	                            insertPos--;
	                        }
	                        this.changes.push({
	                            kind: ChangeKind.ReplaceWithSingleNode,
	                            sourceFile: sourceFile,
	                            range: { pos: insertPos, end: insertPos },
	                            node: newNode,
	                            options: { indentation: indentation, prefix: this.newLineCharacter }
	                        });
	                    }
	                    else {
	                        this.changes.push({
	                            kind: ChangeKind.ReplaceWithSingleNode,
	                            sourceFile: sourceFile,
	                            range: { pos: end, end: end },
	                            node: newNode,
	                            options: { prefix: ts.tokenToString(separator) + " " }
	                        });
	                    }
	                }
	                return this;
	            };
	            ChangeTracker.prototype.finishInsertNodeAtClassStart = function () {
	                var _this = this;
	                this.nodesInsertedAtClassStarts.forEach(function (_a) {
	                    var sourceFile = _a.sourceFile, cls = _a.cls, members = _a.members;
	                    var newCls = cls.kind === 233 /* ClassDeclaration */
	                        ? ts.updateClassDeclaration(cls, cls.decorators, cls.modifiers, cls.name, cls.typeParameters, cls.heritageClauses, members)
	                        : ts.updateClassExpression(cls, cls.modifiers, cls.name, cls.typeParameters, cls.heritageClauses, members);
	                    _this.replaceNode(sourceFile, cls, newCls, { useNonAdjustedEndPosition: true });
	                });
	            };
	            ChangeTracker.prototype.getChanges = function () {
	                var _this = this;
	                this.finishInsertNodeAtClassStart();
	                return ts.group(this.changes, function (c) { return c.sourceFile.path; }).map(function (changesInFile) {
	                    var sourceFile = changesInFile[0].sourceFile;
	                    var textChanges = ChangeTracker.normalize(changesInFile).map(function (c) {
	                        return ts.createTextChange(ts.createTextSpanFromRange(c.range), _this.computeNewText(c, sourceFile));
	                    });
	                    return { fileName: sourceFile.fileName, textChanges: textChanges };
	                });
	            };
	            ChangeTracker.prototype.computeNewText = function (change, sourceFile) {
	                var _this = this;
	                if (change.kind === ChangeKind.Remove) {
	                    // deletion case
	                    return "";
	                }
	                var options = change.options || {};
	                var text;
	                var pos = change.range.pos;
	                var posStartsLine = ts.getLineStartPositionForPosition(pos, sourceFile) === pos;
	                if (change.kind === ChangeKind.ReplaceWithMultipleNodes) {
	                    var lastIndex_1 = change.nodes.length - 1;
	                    var parts = change.nodes.map(function (n, index) {
	                        var formatted = _this.getFormattedTextOfNode(n, sourceFile, pos, options);
	                        return index === lastIndex_1 || ts.endsWith(formatted, _this.newLineCharacter)
	                            ? formatted
	                            : (formatted + _this.newLineCharacter);
	                    });
	                    text = parts.join("");
	                }
	                else {
	                    ts.Debug.assert(change.kind === ChangeKind.ReplaceWithSingleNode, "change.kind === ReplaceWithSingleNode");
	                    text = this.getFormattedTextOfNode(change.node, sourceFile, pos, options);
	                }
	                // strip initial indentation (spaces or tabs) if text will be inserted in the middle of the line
	                text = (posStartsLine || options.indentation !== undefined) ? text : text.replace(/^\s+/, "");
	                return (options.prefix || "") + text + (options.suffix || "");
	            };
	            ChangeTracker.prototype.getFormattedTextOfNode = function (node, sourceFile, pos, options) {
	                var nonformattedText = getNonformattedText(node, sourceFile, this.newLineCharacter);
	                if (this.validator) {
	                    this.validator(nonformattedText);
	                }
	                var formatOptions = this.formatContext.options;
	                var posStartsLine = ts.getLineStartPositionForPosition(pos, sourceFile) === pos;
	                var initialIndentation = options.indentation !== undefined
	                    ? options.indentation
	                    : (options.useIndentationFromFile !== false)
	                        ? ts.formatting.SmartIndenter.getIndentation(pos, sourceFile, formatOptions, posStartsLine || (options.prefix === this.newLineCharacter))
	                        : 0;
	                var delta = options.delta !== undefined
	                    ? options.delta
	                    : ts.formatting.SmartIndenter.shouldIndentChildNode(node)
	                        ? (formatOptions.indentSize || 0)
	                        : 0;
	                return applyFormatting(nonformattedText, sourceFile, initialIndentation, delta, this.formatContext);
	            };
	            ChangeTracker.normalize = function (changes) {
	                // order changes by start position
	                var normalized = ts.stableSort(changes, function (a, b) { return a.range.pos - b.range.pos; });
	                // verify that change intervals do not overlap, except possibly at end points.
	                for (var i = 0; i < normalized.length - 2; i++) {
	                    ts.Debug.assert(normalized[i].range.end <= normalized[i + 1].range.pos);
	                }
	                return normalized;
	            };
	            return ChangeTracker;
	        }());
	        textChanges_1.ChangeTracker = ChangeTracker;
	        function getNonformattedText(node, sourceFile, newLine) {
	            var writer = new Writer(newLine);
	            var printer = ts.createPrinter({ newLine: newLine === "\n" ? 1 /* LineFeed */ : 0 /* CarriageReturnLineFeed */ }, writer);
	            printer.writeNode(4 /* Unspecified */, node, sourceFile, writer);
	            return { text: writer.getText(), node: assignPositionsToNode(node) };
	        }
	        function applyFormatting(nonFormattedText, sourceFile, initialIndentation, delta, formatContext) {
	            var lineMap = ts.computeLineStarts(nonFormattedText.text);
	            var file = {
	                text: nonFormattedText.text,
	                lineMap: lineMap,
	                getLineAndCharacterOfPosition: function (pos) { return ts.computeLineAndCharacterOfPosition(lineMap, pos); }
	            };
	            var changes = ts.formatting.formatNodeGivenIndentation(nonFormattedText.node, file, sourceFile.languageVariant, initialIndentation, delta, formatContext);
	            return applyChanges(nonFormattedText.text, changes);
	        }
	        function applyChanges(text, changes) {
	            for (var i = changes.length - 1; i >= 0; i--) {
	                var change = changes[i];
	                text = "" + text.substring(0, change.span.start) + change.newText + text.substring(ts.textSpanEnd(change.span));
	            }
	            return text;
	        }
	        textChanges_1.applyChanges = applyChanges;
	        function isTrivia(s) {
	            return ts.skipTrivia(s, 0) === s.length;
	        }
	        function assignPositionsToNode(node) {
	            var visited = ts.visitEachChild(node, assignPositionsToNode, ts.nullTransformationContext, assignPositionsToNodeArray, assignPositionsToNode);
	            // create proxy node for non synthesized nodes
	            var newNode = ts.nodeIsSynthesized(visited) ? visited : Object.create(visited);
	            newNode.pos = getPos(node);
	            newNode.end = getEnd(node);
	            return newNode;
	        }
	        function assignPositionsToNodeArray(nodes, visitor, test, start, count) {
	            var visited = ts.visitNodes(nodes, visitor, test, start, count);
	            if (!visited) {
	                return visited;
	            }
	            // clone nodearray if necessary
	            var nodeArray = visited === nodes ? ts.createNodeArray(visited.slice(0)) : visited;
	            nodeArray.pos = getPos(nodes);
	            nodeArray.end = getEnd(nodes);
	            return nodeArray;
	        }
	        var Writer = /** @class */ (function () {
	            function Writer(newLine) {
	                var _this = this;
	                this.lastNonTriviaPosition = 0;
	                this.writer = ts.createTextWriter(newLine);
	                this.onEmitNode = function (hint, node, printCallback) {
	                    if (node) {
	                        setPos(node, _this.lastNonTriviaPosition);
	                    }
	                    printCallback(hint, node);
	                    if (node) {
	                        setEnd(node, _this.lastNonTriviaPosition);
	                    }
	                };
	                this.onBeforeEmitNodeArray = function (nodes) {
	                    if (nodes) {
	                        setPos(nodes, _this.lastNonTriviaPosition);
	                    }
	                };
	                this.onAfterEmitNodeArray = function (nodes) {
	                    if (nodes) {
	                        setEnd(nodes, _this.lastNonTriviaPosition);
	                    }
	                };
	                this.onBeforeEmitToken = function (node) {
	                    if (node) {
	                        setPos(node, _this.lastNonTriviaPosition);
	                    }
	                };
	                this.onAfterEmitToken = function (node) {
	                    if (node) {
	                        setEnd(node, _this.lastNonTriviaPosition);
	                    }
	                };
	            }
	            Writer.prototype.setLastNonTriviaPosition = function (s, force) {
	                if (force || !isTrivia(s)) {
	                    this.lastNonTriviaPosition = this.writer.getTextPos();
	                    var i = 0;
	                    while (ts.isWhiteSpaceLike(s.charCodeAt(s.length - i - 1))) {
	                        i++;
	                    }
	                    // trim trailing whitespaces
	                    this.lastNonTriviaPosition -= i;
	                }
	            };
	            Writer.prototype.write = function (s) {
	                this.writer.write(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeKeyword = function (s) {
	                this.writer.writeKeyword(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeOperator = function (s) {
	                this.writer.writeOperator(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writePunctuation = function (s) {
	                this.writer.writePunctuation(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeParameter = function (s) {
	                this.writer.writeParameter(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeProperty = function (s) {
	                this.writer.writeProperty(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeSpace = function (s) {
	                this.writer.writeSpace(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeStringLiteral = function (s) {
	                this.writer.writeStringLiteral(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeSymbol = function (s, sym) {
	                this.writer.writeSymbol(s, sym);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeTextOfNode = function (text, node) {
	                this.writer.writeTextOfNode(text, node);
	            };
	            Writer.prototype.writeLine = function () {
	                this.writer.writeLine();
	            };
	            Writer.prototype.increaseIndent = function () {
	                this.writer.increaseIndent();
	            };
	            Writer.prototype.decreaseIndent = function () {
	                this.writer.decreaseIndent();
	            };
	            Writer.prototype.getText = function () {
	                return this.writer.getText();
	            };
	            Writer.prototype.rawWrite = function (s) {
	                this.writer.rawWrite(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeLiteral = function (s) {
	                this.writer.writeLiteral(s);
	                this.setLastNonTriviaPosition(s, /*force*/ true);
	            };
	            Writer.prototype.getTextPos = function () {
	                return this.writer.getTextPos();
	            };
	            Writer.prototype.getLine = function () {
	                return this.writer.getLine();
	            };
	            Writer.prototype.getColumn = function () {
	                return this.writer.getColumn();
	            };
	            Writer.prototype.getIndent = function () {
	                return this.writer.getIndent();
	            };
	            Writer.prototype.isAtStartOfLine = function () {
	                return this.writer.isAtStartOfLine();
	            };
	            Writer.prototype.clear = function () {
	                this.writer.clear();
	                this.lastNonTriviaPosition = 0;
	            };
	            return Writer;
	        }());
	        function getInsertionPositionAtSourceFileTop(_a) {
	            var text = _a.text;
	            var shebang = ts.getShebang(text);
	            var position = 0;
	            if (shebang !== undefined) {
	                position = shebang.length;
	                advancePastLineBreak();
	            }
	            // For a source file, it is possible there are detached comments we should not skip
	            var ranges = ts.getLeadingCommentRanges(text, position);
	            if (!ranges)
	                return position;
	            // However we should still skip a pinned comment at the top
	            if (ranges.length && ranges[0].kind === 3 /* MultiLineCommentTrivia */ && ts.isPinnedComment(text, ranges[0])) {
	                position = ranges[0].end;
	                advancePastLineBreak();
	                ranges = ranges.slice(1);
	            }
	            // As well as any triple slash references
	            for (var _i = 0, ranges_1 = ranges; _i < ranges_1.length; _i++) {
	                var range = ranges_1[_i];
	                if (range.kind === 2 /* SingleLineCommentTrivia */ && ts.isRecognizedTripleSlashComment(text, range.pos, range.end)) {
	                    position = range.end;
	                    advancePastLineBreak();
	                    continue;
	                }
	                break;
	            }
	            return position;
	            function advancePastLineBreak() {
	                if (position < text.length) {
	                    var charCode = text.charCodeAt(position);
	                    if (ts.isLineBreak(charCode)) {
	                        position++;
	                        if (position < text.length && charCode === 13 /* carriageReturn */ && text.charCodeAt(position) === 10 /* lineFeed */) {
	                            position++;
	                        }
	                    }
	                }
	            }
	        }
	    })(textChanges = ts.textChanges || (ts.textChanges = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var codeFixRegistrations = [];
	        var fixIdToRegistration = ts.createMap();
	        function registerCodeFix(reg) {
	            for (var _i = 0, _a = reg.errorCodes; _i < _a.length; _i++) {
	                var error = _a[_i];
	                var registrations = codeFixRegistrations[error];
	                if (!registrations) {
	                    registrations = [];
	                    codeFixRegistrations[error] = registrations;
	                }
	                registrations.push(reg);
	            }
	            if (reg.fixIds) {
	                for (var _b = 0, _c = reg.fixIds; _b < _c.length; _b++) {
	                    var fixId = _c[_b];
	                    ts.Debug.assert(!fixIdToRegistration.has(fixId));
	                    fixIdToRegistration.set(fixId, reg);
	                }
	            }
	        }
	        codefix.registerCodeFix = registerCodeFix;
	        function getSupportedErrorCodes() {
	            return Object.keys(codeFixRegistrations);
	        }
	        codefix.getSupportedErrorCodes = getSupportedErrorCodes;
	        function getFixes(context) {
	            var fixes = codeFixRegistrations[context.errorCode];
	            var allActions = [];
	            ts.forEach(fixes, function (f) {
	                var actions = f.getCodeActions(context);
	                if (actions && actions.length > 0) {
	                    for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
	                        var action = actions_1[_i];
	                        if (action === undefined) {
	                            context.host.log("Action for error code " + context.errorCode + " added an invalid action entry; please log a bug");
	                        }
	                        else {
	                            allActions.push(action);
	                        }
	                    }
	                }
	            });
	            return allActions;
	        }
	        codefix.getFixes = getFixes;
	        function getAllFixes(context) {
	            // Currently fixId is always a string.
	            return fixIdToRegistration.get(ts.cast(context.fixId, ts.isString)).getAllCodeActions(context);
	        }
	        codefix.getAllFixes = getAllFixes;
	        function createCombinedCodeActions(changes, commands) {
	            return { changes: changes, commands: commands };
	        }
	        function createFileTextChanges(fileName, textChanges) {
	            return { fileName: fileName, textChanges: textChanges };
	        }
	        codefix.createFileTextChanges = createFileTextChanges;
	        function codeFixAll(context, errorCodes, use) {
	            var commands = [];
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) {
	                return eachDiagnostic(context, errorCodes, function (diag) { return use(t, diag, commands); });
	            });
	            return createCombinedCodeActions(changes, commands.length === 0 ? undefined : commands);
	        }
	        codefix.codeFixAll = codeFixAll;
	        function codeFixAllWithTextChanges(context, errorCodes, use) {
	            var changes = [];
	            eachDiagnostic(context, errorCodes, function (diag) { return use(changes, diag); });
	            changes.sort(function (a, b) { return b.span.start - a.span.start; });
	            return createCombinedCodeActions([createFileTextChanges(context.sourceFile.fileName, changes)]);
	        }
	        codefix.codeFixAllWithTextChanges = codeFixAllWithTextChanges;
	        function eachDiagnostic(_a, errorCodes, cb) {
	            var program = _a.program, sourceFile = _a.sourceFile;
	            for (var _i = 0, _b = program.getSemanticDiagnostics(sourceFile); _i < _b.length; _i++) {
	                var diag = _b[_i];
	                if (ts.contains(errorCodes, diag.code)) {
	                    cb(diag);
	                }
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor_1) {
	        // A map with the refactor code as key, the refactor itself as value
	        // e.g.  nonSuggestableRefactors[refactorCode] -> the refactor you want
	        var refactors = ts.createMap();
	        /** @param name An unique code associated with each refactor. Does not have to be human-readable. */
	        function registerRefactor(name, refactor) {
	            refactors.set(name, refactor);
	        }
	        refactor_1.registerRefactor = registerRefactor;
	        function getApplicableRefactors(context) {
	            return ts.arrayFrom(ts.flatMapIterator(refactors.values(), function (refactor) {
	                return context.cancellationToken && context.cancellationToken.isCancellationRequested() ? undefined : refactor.getAvailableActions(context);
	            }));
	        }
	        refactor_1.getApplicableRefactors = getApplicableRefactors;
	        function getEditsForRefactor(context, refactorName, actionName) {
	            var refactor = refactors.get(refactorName);
	            return refactor && refactor.getEditsForAction(context, actionName);
	        }
	        refactor_1.getEditsForRefactor = getEditsForRefactor;
	    })(refactor = ts.refactor || (ts.refactor = {}));
	    function getRefactorContextLength(context) {
	        return context.endPosition === undefined ? 0 : context.endPosition - context.startPosition;
	    }
	    ts.getRefactorContextLength = getRefactorContextLength;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "addMissingInvocationForDecorator";
	        var errorCodes = [ts.Diagnostics._0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return makeChange(t, context.sourceFile, context.span.start); });
	                return [{ description: ts.getLocaleSpecificMessage(ts.Diagnostics.Call_decorator_expression), changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) { return makeChange(changes, diag.file, diag.start); }); },
	        });
	        function makeChange(changeTracker, sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            var decorator = ts.findAncestor(token, ts.isDecorator);
	            ts.Debug.assert(!!decorator, "Expected position to be owned by a decorator.");
	            var replacement = ts.createCall(decorator.expression, /*typeArguments*/ undefined, /*argumentsArray*/ undefined);
	            changeTracker.replaceNode(sourceFile, decorator.expression, replacement);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "correctQualifiedNameToIndexedAccessType";
	        var errorCodes = [ts.Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var qualifiedName = getQualifiedName(context.sourceFile, context.span.start);
	                if (!qualifiedName)
	                    return undefined;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, context.sourceFile, qualifiedName); });
	                var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Rewrite_as_the_indexed_access_type_0), [qualifiedName.left.text + "[\"" + qualifiedName.right.text + "\"]"]);
	                return [{ description: description, changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var q = getQualifiedName(diag.file, diag.start);
	                if (q) {
	                    doChange(changes, diag.file, q);
	                }
	            }); },
	        });
	        function getQualifiedName(sourceFile, pos) {
	            var qualifiedName = ts.findAncestor(ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ true), ts.isQualifiedName);
	            ts.Debug.assert(!!qualifiedName, "Expected position to be owned by a qualified name.");
	            return ts.isIdentifier(qualifiedName.left) ? qualifiedName : undefined;
	        }
	        function doChange(changeTracker, sourceFile, qualifiedName) {
	            var rightText = qualifiedName.right.text;
	            var replacement = ts.createIndexedAccessTypeNode(ts.createTypeReferenceNode(qualifiedName.left, /*typeArguments*/ undefined), ts.createLiteralTypeNode(ts.createLiteral(rightText)));
	            changeTracker.replaceNode(sourceFile, qualifiedName, replacement);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var errorCodes = [ts.Diagnostics.Class_0_incorrectly_implements_interface_1.code,
	            ts.Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass.code];
	        var fixId = "fixClassIncorrectlyImplementsInterface"; // TODO: share a group with fixClassDoesntImplementInheritedAbstractMember?
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var program = context.program, sourceFile = context.sourceFile, span = context.span;
	                var classDeclaration = getClass(sourceFile, span.start);
	                var checker = program.getTypeChecker();
	                return ts.mapDefined(ts.getClassImplementsHeritageClauseElements(classDeclaration), function (implementedTypeNode) {
	                    var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addMissingDeclarations(checker, implementedTypeNode, sourceFile, classDeclaration, t); });
	                    if (changes.length === 0)
	                        return undefined;
	                    var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Implement_interface_0), [implementedTypeNode.getText()]);
	                    return { description: description, changes: changes, fixId: fixId };
	                });
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var seenClassDeclarations = ts.createMap();
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var classDeclaration = getClass(diag.file, diag.start);
	                    if (ts.addToSeen(seenClassDeclarations, ts.getNodeId(classDeclaration))) {
	                        for (var _i = 0, _a = ts.getClassImplementsHeritageClauseElements(classDeclaration); _i < _a.length; _i++) {
	                            var implementedTypeNode = _a[_i];
	                            addMissingDeclarations(context.program.getTypeChecker(), implementedTypeNode, diag.file, classDeclaration, changes);
	                        }
	                    }
	                });
	            },
	        });
	        function getClass(sourceFile, pos) {
	            return ts.Debug.assertDefined(ts.getContainingClass(ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false)));
	        }
	        function addMissingDeclarations(checker, implementedTypeNode, sourceFile, classDeclaration, changeTracker) {
	            // Note that this is ultimately derived from a map indexed by symbol names,
	            // so duplicates cannot occur.
	            var implementedType = checker.getTypeAtLocation(implementedTypeNode);
	            var implementedTypeSymbols = checker.getPropertiesOfType(implementedType);
	            var nonPrivateMembers = implementedTypeSymbols.filter(function (symbol) { return !(ts.getModifierFlags(symbol.valueDeclaration) & 8 /* Private */); });
	            var classType = checker.getTypeAtLocation(classDeclaration);
	            if (!checker.getIndexTypeOfType(classType, 1 /* Number */)) {
	                createMissingIndexSignatureDeclaration(implementedType, 1 /* Number */);
	            }
	            if (!checker.getIndexTypeOfType(classType, 0 /* String */)) {
	                createMissingIndexSignatureDeclaration(implementedType, 0 /* String */);
	            }
	            codefix.createMissingMemberNodes(classDeclaration, nonPrivateMembers, checker, function (member) { return changeTracker.insertNodeAtClassStart(sourceFile, classDeclaration, member); });
	            function createMissingIndexSignatureDeclaration(type, kind) {
	                var indexInfoOfKind = checker.getIndexInfoOfType(type, kind);
	                if (indexInfoOfKind) {
	                    changeTracker.insertNodeAtClassStart(sourceFile, classDeclaration, checker.indexInfoToIndexSignatureDeclaration(indexInfoOfKind, kind, classDeclaration));
	                }
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var errorCodes = [
	            ts.Diagnostics.Property_0_does_not_exist_on_type_1.code,
	            ts.Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2.code,
	        ];
	        var fixId = "addMissingMember";
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var info = getInfo(context.sourceFile, context.span.start, context.program.getTypeChecker());
	                if (!info)
	                    return undefined;
	                var classDeclaration = info.classDeclaration, classDeclarationSourceFile = info.classDeclarationSourceFile, inJs = info.inJs, makeStatic = info.makeStatic, token = info.token, call = info.call;
	                var methodCodeAction = call && getActionForMethodDeclaration(context, classDeclarationSourceFile, classDeclaration, token, call, makeStatic, inJs);
	                var addMember = inJs ?
	                    ts.singleElementArray(getActionsForAddMissingMemberInJavaScriptFile(context, classDeclarationSourceFile, classDeclaration, token.text, makeStatic)) :
	                    getActionsForAddMissingMemberInTypeScriptFile(context, classDeclarationSourceFile, classDeclaration, token, makeStatic);
	                return ts.concatenate(ts.singleElementArray(methodCodeAction), addMember);
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var seenNames = ts.createMap();
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var program = context.program;
	                    var info = getInfo(diag.file, diag.start, program.getTypeChecker());
	                    if (!info)
	                        return;
	                    var classDeclaration = info.classDeclaration, classDeclarationSourceFile = info.classDeclarationSourceFile, inJs = info.inJs, makeStatic = info.makeStatic, token = info.token, call = info.call;
	                    if (!ts.addToSeen(seenNames, token.text)) {
	                        return;
	                    }
	                    // Always prefer to add a method declaration if possible.
	                    if (call) {
	                        addMethodDeclaration(changes, classDeclarationSourceFile, classDeclaration, token, call, makeStatic, inJs);
	                    }
	                    else {
	                        if (inJs) {
	                            addMissingMemberInJs(changes, classDeclarationSourceFile, classDeclaration, token.text, makeStatic);
	                        }
	                        else {
	                            var typeNode = getTypeNode(program.getTypeChecker(), classDeclaration, token);
	                            addPropertyDeclaration(changes, classDeclarationSourceFile, classDeclaration, token.text, typeNode, makeStatic);
	                        }
	                    }
	                });
	            },
	        });
	        function getInfo(tokenSourceFile, tokenPos, checker) {
	            // The identifier of the missing property. eg:
	            // this.missing = 1;
	            //      ^^^^^^^
	            var token = ts.getTokenAtPosition(tokenSourceFile, tokenPos, /*includeJsDocComment*/ false);
	            if (!ts.isIdentifier(token)) {
	                return undefined;
	            }
	            var classAndMakeStatic = getClassAndMakeStatic(token, checker);
	            if (!classAndMakeStatic) {
	                return undefined;
	            }
	            var classDeclaration = classAndMakeStatic.classDeclaration, makeStatic = classAndMakeStatic.makeStatic;
	            var classDeclarationSourceFile = classDeclaration.getSourceFile();
	            var inJs = ts.isInJavaScriptFile(classDeclarationSourceFile);
	            var call = ts.tryCast(token.parent.parent, ts.isCallExpression);
	            return { token: token, classDeclaration: classDeclaration, makeStatic: makeStatic, classDeclarationSourceFile: classDeclarationSourceFile, inJs: inJs, call: call };
	        }
	        function getClassAndMakeStatic(token, checker) {
	            var parent = token.parent;
	            if (!ts.isPropertyAccessExpression(parent)) {
	                return undefined;
	            }
	            if (parent.expression.kind === 99 /* ThisKeyword */) {
	                var containingClassMemberDeclaration = ts.getThisContainer(token, /*includeArrowFunctions*/ false);
	                if (!ts.isClassElement(containingClassMemberDeclaration)) {
	                    return undefined;
	                }
	                var classDeclaration = containingClassMemberDeclaration.parent;
	                // Property accesses on `this` in a static method are accesses of a static member.
	                return ts.isClassLike(classDeclaration) ? { classDeclaration: classDeclaration, makeStatic: ts.hasModifier(containingClassMemberDeclaration, 32 /* Static */) } : undefined;
	            }
	            else {
	                var leftExpressionType = checker.getTypeAtLocation(parent.expression);
	                var symbol = leftExpressionType.symbol;
	                if (!(symbol && leftExpressionType.flags & 65536 /* Object */ && symbol.flags & 32 /* Class */)) {
	                    return undefined;
	                }
	                var classDeclaration = ts.cast(ts.first(symbol.declarations), ts.isClassLike);
	                // The expression is a class symbol but the type is not the instance-side.
	                return { classDeclaration: classDeclaration, makeStatic: leftExpressionType !== checker.getDeclaredTypeOfSymbol(symbol) };
	            }
	        }
	        function getActionsForAddMissingMemberInJavaScriptFile(context, classDeclarationSourceFile, classDeclaration, tokenName, makeStatic) {
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addMissingMemberInJs(t, classDeclarationSourceFile, classDeclaration, tokenName, makeStatic); });
	            if (changes.length === 0)
	                return undefined;
	            var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(makeStatic ? ts.Diagnostics.Initialize_static_property_0 : ts.Diagnostics.Initialize_property_0_in_the_constructor), [tokenName]);
	            return { description: description, changes: changes, fixId: fixId };
	        }
	        function addMissingMemberInJs(changeTracker, classDeclarationSourceFile, classDeclaration, tokenName, makeStatic) {
	            if (makeStatic) {
	                if (classDeclaration.kind === 203 /* ClassExpression */) {
	                    return;
	                }
	                var className = classDeclaration.name.getText();
	                var staticInitialization = initializePropertyToUndefined(ts.createIdentifier(className), tokenName);
	                changeTracker.insertNodeAfter(classDeclarationSourceFile, classDeclaration, staticInitialization);
	            }
	            else {
	                var classConstructor = ts.getFirstConstructorWithBody(classDeclaration);
	                if (!classConstructor) {
	                    return;
	                }
	                var propertyInitialization = initializePropertyToUndefined(ts.createThis(), tokenName);
	                changeTracker.insertNodeAtConstructorEnd(classDeclarationSourceFile, classConstructor, propertyInitialization);
	            }
	        }
	        function initializePropertyToUndefined(obj, propertyName) {
	            return ts.createStatement(ts.createAssignment(ts.createPropertyAccess(obj, propertyName), ts.createIdentifier("undefined")));
	        }
	        function getActionsForAddMissingMemberInTypeScriptFile(context, classDeclarationSourceFile, classDeclaration, token, makeStatic) {
	            var typeNode = getTypeNode(context.program.getTypeChecker(), classDeclaration, token);
	            var addProp = createAddPropertyDeclarationAction(context, classDeclarationSourceFile, classDeclaration, makeStatic, token.text, typeNode);
	            return makeStatic ? [addProp] : [addProp, createAddIndexSignatureAction(context, classDeclarationSourceFile, classDeclaration, token.text, typeNode)];
	        }
	        function getTypeNode(checker, classDeclaration, token) {
	            var typeNode;
	            if (token.parent.parent.kind === 198 /* BinaryExpression */) {
	                var binaryExpression = token.parent.parent;
	                var otherExpression = token.parent === binaryExpression.left ? binaryExpression.right : binaryExpression.left;
	                var widenedType = checker.getWidenedType(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(otherExpression)));
	                typeNode = checker.typeToTypeNode(widenedType, classDeclaration);
	            }
	            return typeNode || ts.createKeywordTypeNode(119 /* AnyKeyword */);
	        }
	        function createAddPropertyDeclarationAction(context, classDeclarationSourceFile, classDeclaration, makeStatic, tokenName, typeNode) {
	            var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(makeStatic ? ts.Diagnostics.Declare_static_property_0 : ts.Diagnostics.Declare_property_0), [tokenName]);
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addPropertyDeclaration(t, classDeclarationSourceFile, classDeclaration, tokenName, typeNode, makeStatic); });
	            return { description: description, changes: changes, fixId: fixId };
	        }
	        function addPropertyDeclaration(changeTracker, classDeclarationSourceFile, classDeclaration, tokenName, typeNode, makeStatic) {
	            var property = ts.createProperty(
	            /*decorators*/ undefined, 
	            /*modifiers*/ makeStatic ? [ts.createToken(115 /* StaticKeyword */)] : undefined, tokenName, 
	            /*questionToken*/ undefined, typeNode, 
	            /*initializer*/ undefined);
	            changeTracker.insertNodeAtClassStart(classDeclarationSourceFile, classDeclaration, property);
	        }
	        function createAddIndexSignatureAction(context, classDeclarationSourceFile, classDeclaration, tokenName, typeNode) {
	            // Index signatures cannot have the static modifier.
	            var stringTypeNode = ts.createKeywordTypeNode(137 /* StringKeyword */);
	            var indexingParameter = ts.createParameter(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, 
	            /*dotDotDotToken*/ undefined, "x", 
	            /*questionToken*/ undefined, stringTypeNode, 
	            /*initializer*/ undefined);
	            var indexSignature = ts.createIndexSignature(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, [indexingParameter], typeNode);
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return t.insertNodeAtClassStart(classDeclarationSourceFile, classDeclaration, indexSignature); });
	            // No fixId here because code-fix-all currently only works on adding individual named properties.
	            return { description: ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Add_index_signature_for_property_0), [tokenName]), changes: changes, fixId: undefined };
	        }
	        function getActionForMethodDeclaration(context, classDeclarationSourceFile, classDeclaration, token, callExpression, makeStatic, inJs) {
	            var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(makeStatic ? ts.Diagnostics.Declare_static_method_0 : ts.Diagnostics.Declare_method_0), [token.text]);
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addMethodDeclaration(t, classDeclarationSourceFile, classDeclaration, token, callExpression, makeStatic, inJs); });
	            return { description: description, changes: changes, fixId: fixId };
	        }
	        function addMethodDeclaration(changeTracker, classDeclarationSourceFile, classDeclaration, token, callExpression, makeStatic, inJs) {
	            var methodDeclaration = codefix.createMethodFromCallExpression(callExpression, token.text, inJs, makeStatic);
	            changeTracker.insertNodeAtClassStart(classDeclarationSourceFile, classDeclaration, methodDeclaration);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "fixSpelling";
	        var errorCodes = [
	            ts.Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2.code,
	            ts.Diagnostics.Cannot_find_name_0_Did_you_mean_1.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var info = getInfo(sourceFile, context.span.start, context.program.getTypeChecker());
	                if (!info)
	                    return undefined;
	                var node = info.node, suggestion = info.suggestion;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, node, suggestion); });
	                var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Change_spelling_to_0), [suggestion]);
	                return [{ description: description, changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var info = getInfo(diag.file, diag.start, context.program.getTypeChecker());
	                if (info)
	                    doChange(changes, context.sourceFile, info.node, info.suggestion);
	            }); },
	        });
	        function getInfo(sourceFile, pos, checker) {
	            // This is the identifier of the misspelled word. eg:
	            // this.speling = 1;
	            //      ^^^^^^^
	            var node = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false); // TODO: GH#15852
	            var suggestion;
	            if (ts.isPropertyAccessExpression(node.parent) && node.parent.name === node) {
	                ts.Debug.assert(node.kind === 71 /* Identifier */);
	                var containingType = checker.getTypeAtLocation(node.parent.expression);
	                suggestion = checker.getSuggestionForNonexistentProperty(node, containingType);
	            }
	            else {
	                var meaning = ts.getMeaningFromLocation(node);
	                var name = ts.getTextOfNode(node);
	                ts.Debug.assert(name !== undefined, "name should be defined");
	                suggestion = checker.getSuggestionForNonexistentSymbol(node, name, convertSemanticMeaningToSymbolFlags(meaning));
	            }
	            return suggestion === undefined ? undefined : { node: node, suggestion: suggestion };
	        }
	        function doChange(changes, sourceFile, node, suggestion) {
	            changes.replaceNode(sourceFile, node, ts.createIdentifier(suggestion));
	        }
	        function convertSemanticMeaningToSymbolFlags(meaning) {
	            var flags = 0;
	            if (meaning & 4 /* Namespace */) {
	                flags |= 1920 /* Namespace */;
	            }
	            if (meaning & 2 /* Type */) {
	                flags |= 793064 /* Type */;
	            }
	            if (meaning & 1 /* Value */) {
	                flags |= 107455 /* Value */;
	            }
	            return flags;
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "fixCannotFindModule";
	        var errorCodes = [ts.Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var codeAction = tryGetCodeActionForInstallPackageTypes(context.host, context.sourceFile.fileName, getModuleName(context.sourceFile, context.span.start));
	                return codeAction && [__assign({ fixId: fixId }, codeAction)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (_, diag, commands) {
	                var pkg = getTypesPackageNameToInstall(context.host, getModuleName(diag.file, diag.start));
	                if (pkg) {
	                    commands.push(getCommand(diag.file.fileName, pkg));
	                }
	            }); },
	        });
	        function getModuleName(sourceFile, pos) {
	            return ts.cast(ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false), ts.isStringLiteral).text;
	        }
	        function getCommand(fileName, packageName) {
	            return { type: "install package", file: fileName, packageName: packageName };
	        }
	        function getTypesPackageNameToInstall(host, moduleName) {
	            var packageName = ts.getPackageName(moduleName).packageName;
	            // If !registry, registry not available yet, can't do anything.
	            return host.isKnownTypesPackageName(packageName) ? ts.getTypesPackageName(packageName) : undefined;
	        }
	        function tryGetCodeActionForInstallPackageTypes(host, fileName, moduleName) {
	            var packageName = getTypesPackageNameToInstall(host, moduleName);
	            return packageName === undefined ? undefined : {
	                description: ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Install_0), [packageName]),
	                changes: [],
	                commands: [getCommand(fileName, packageName)],
	            };
	        }
	        codefix.tryGetCodeActionForInstallPackageTypes = tryGetCodeActionForInstallPackageTypes;
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var errorCodes = [
	            ts.Diagnostics.Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2.code,
	            ts.Diagnostics.Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1.code,
	        ];
	        var fixId = "fixClassDoesntImplementInheritedAbstractMember";
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var program = context.program, sourceFile = context.sourceFile, span = context.span;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) {
	                    return addMissingMembers(getClass(sourceFile, span.start), sourceFile, program.getTypeChecker(), t);
	                });
	                return changes.length === 0 ? undefined : [{ description: ts.getLocaleSpecificMessage(ts.Diagnostics.Implement_inherited_abstract_class), changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var seenClassDeclarations = ts.createMap();
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var classDeclaration = getClass(diag.file, diag.start);
	                    if (ts.addToSeen(seenClassDeclarations, ts.getNodeId(classDeclaration))) {
	                        addMissingMembers(classDeclaration, context.sourceFile, context.program.getTypeChecker(), changes);
	                    }
	                });
	            },
	        });
	        function getClass(sourceFile, pos) {
	            // Token is the identifier in the case of a class declaration
	            // or the class keyword token in the case of a class expression.
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            return ts.cast(token.parent, ts.isClassLike);
	        }
	        function addMissingMembers(classDeclaration, sourceFile, checker, changeTracker) {
	            var extendsNode = ts.getClassExtendsHeritageClauseElement(classDeclaration);
	            var instantiatedExtendsType = checker.getTypeAtLocation(extendsNode);
	            // Note that this is ultimately derived from a map indexed by symbol names,
	            // so duplicates cannot occur.
	            var abstractAndNonPrivateExtendsSymbols = checker.getPropertiesOfType(instantiatedExtendsType).filter(symbolPointsToNonPrivateAndAbstractMember);
	            codefix.createMissingMemberNodes(classDeclaration, abstractAndNonPrivateExtendsSymbols, checker, function (member) { return changeTracker.insertNodeAtClassStart(sourceFile, classDeclaration, member); });
	        }
	        function symbolPointsToNonPrivateAndAbstractMember(symbol) {
	            // See `codeFixClassExtendAbstractProtectedProperty.ts` in https://github.com/Microsoft/TypeScript/pull/11547/files
	            // (now named `codeFixClassExtendAbstractPrivateProperty.ts`)
	            var flags = ts.getModifierFlags(ts.first(symbol.getDeclarations()));
	            return !(flags & 8 /* Private */) && !!(flags & 128 /* Abstract */);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "classSuperMustPrecedeThisAccess";
	        var errorCodes = [ts.Diagnostics.super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, span = context.span;
	                var nodes = getNodes(sourceFile, span.start);
	                if (!nodes)
	                    return undefined;
	                var constructor = nodes.constructor, superCall = nodes.superCall;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, constructor, superCall); });
	                return [{ description: ts.getLocaleSpecificMessage(ts.Diagnostics.Make_super_call_the_first_statement_in_the_constructor), changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var seenClasses = ts.createMap(); // Ensure we only do this once per class.
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var nodes = getNodes(diag.file, diag.start);
	                    if (!nodes)
	                        return;
	                    var constructor = nodes.constructor, superCall = nodes.superCall;
	                    if (ts.addToSeen(seenClasses, ts.getNodeId(constructor.parent))) {
	                        doChange(changes, sourceFile, constructor, superCall);
	                    }
	                });
	            },
	        });
	        function doChange(changes, sourceFile, constructor, superCall) {
	            changes.insertNodeAtConstructorStart(sourceFile, constructor, superCall);
	            changes.deleteNode(sourceFile, superCall);
	        }
	        function getNodes(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            if (token.kind !== 99 /* ThisKeyword */)
	                return undefined;
	            var constructor = ts.getContainingFunction(token);
	            var superCall = findSuperCall(constructor.body);
	            // figure out if the `this` access is actually inside the supercall
	            // i.e. super(this.a), since in that case we won't suggest a fix
	            return superCall && !superCall.expression.arguments.some(function (arg) { return ts.isPropertyAccessExpression(arg) && arg.expression === token; }) ? { constructor: constructor, superCall: superCall } : undefined;
	        }
	        function findSuperCall(n) {
	            return ts.isExpressionStatement(n) && ts.isSuperCall(n.expression)
	                ? n
	                : ts.isFunctionLike(n)
	                    ? undefined
	                    : ts.forEachChild(n, findSuperCall);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "constructorForDerivedNeedSuperCall";
	        var errorCodes = [ts.Diagnostics.Constructors_for_derived_classes_must_contain_a_super_call.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, span = context.span;
	                var ctr = getNode(sourceFile, span.start);
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, ctr); });
	                return [{ description: ts.getLocaleSpecificMessage(ts.Diagnostics.Add_missing_super_call), changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                return doChange(changes, context.sourceFile, getNode(diag.file, diag.start));
	            }); },
	        });
	        function getNode(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            ts.Debug.assert(token.kind === 123 /* ConstructorKeyword */);
	            return token.parent;
	        }
	        function doChange(changes, sourceFile, ctr) {
	            var superCall = ts.createStatement(ts.createCall(ts.createSuper(), /*typeArguments*/ undefined, /*argumentsArray*/ ts.emptyArray));
	            changes.insertNodeAtConstructorStart(sourceFile, ctr, superCall);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "extendsInterfaceBecomesImplements";
	        var errorCodes = [ts.Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var nodes = getNodes(sourceFile, context.span.start);
	                if (!nodes)
	                    return undefined;
	                var extendsToken = nodes.extendsToken, heritageClauses = nodes.heritageClauses;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChanges(t, sourceFile, extendsToken, heritageClauses); });
	                return [{ description: ts.getLocaleSpecificMessage(ts.Diagnostics.Change_extends_to_implements), changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var nodes = getNodes(diag.file, diag.start);
	                if (nodes)
	                    doChanges(changes, diag.file, nodes.extendsToken, nodes.heritageClauses);
	            }); },
	        });
	        function getNodes(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            var heritageClauses = ts.getContainingClass(token).heritageClauses;
	            var extendsToken = heritageClauses[0].getFirstToken();
	            return extendsToken.kind === 85 /* ExtendsKeyword */ ? { extendsToken: extendsToken, heritageClauses: heritageClauses } : undefined;
	        }
	        function doChanges(changes, sourceFile, extendsToken, heritageClauses) {
	            changes.replaceNode(sourceFile, extendsToken, ts.createToken(108 /* ImplementsKeyword */), ts.textChanges.useNonAdjustedPositions);
	            // If there is already an implements clause, replace the implements keyword with a comma.
	            if (heritageClauses.length === 2 &&
	                heritageClauses[0].token === 85 /* ExtendsKeyword */ &&
	                heritageClauses[1].token === 108 /* ImplementsKeyword */) {
	                var implementsToken = heritageClauses[1].getFirstToken();
	                var implementsFullStart = implementsToken.getFullStart();
	                changes.replaceRange(sourceFile, { pos: implementsFullStart, end: implementsFullStart }, ts.createToken(26 /* CommaToken */));
	                // Rough heuristic: delete trailing whitespace after keyword so that it's not excessive.
	                // (Trailing because leading might be indentation, which is more sensitive.)
	                var text = sourceFile.text;
	                var end = implementsToken.end;
	                while (end < text.length && ts.isWhiteSpaceSingleLine(text.charCodeAt(end))) {
	                    end++;
	                }
	                changes.deleteRange(sourceFile, { pos: implementsToken.getStart(), end: end });
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "forgottenThisPropertyAccess";
	        var errorCodes = [ts.Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var token = getNode(sourceFile, context.span.start);
	                if (!token) {
	                    return undefined;
	                }
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, token); });
	                return [{ description: ts.getLocaleSpecificMessage(ts.Diagnostics.Add_this_to_unresolved_variable), changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                doChange(changes, context.sourceFile, getNode(diag.file, diag.start));
	            }); },
	        });
	        function getNode(sourceFile, pos) {
	            var node = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            return ts.isIdentifier(node) ? node : undefined;
	        }
	        function doChange(changes, sourceFile, token) {
	            if (!token) {
	                return;
	            }
	            // TODO (https://github.com/Microsoft/TypeScript/issues/21246): use shared helper
	            ts.suppressLeadingAndTrailingTrivia(token);
	            changes.replaceNode(sourceFile, token, ts.createPropertyAccess(ts.createThis(), token), ts.textChanges.useNonAdjustedPositions);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixIdPrefix = "unusedIdentifier_prefix";
	        var fixIdDelete = "unusedIdentifier_delete";
	        var errorCodes = [
	            ts.Diagnostics._0_is_declared_but_its_value_is_never_read.code,
	            ts.Diagnostics.Property_0_is_declared_but_its_value_is_never_read.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var token = getToken(sourceFile, context.span.start);
	                var result = [];
	                var deletion = ts.textChanges.ChangeTracker.with(context, function (t) { return tryDeleteDeclaration(t, sourceFile, token); });
	                if (deletion.length) {
	                    var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Remove_declaration_for_Colon_0), [token.getText()]);
	                    result.push({ description: description, changes: deletion, fixId: fixIdDelete });
	                }
	                var prefix = ts.textChanges.ChangeTracker.with(context, function (t) { return tryPrefixDeclaration(t, context.errorCode, sourceFile, token); });
	                if (prefix.length) {
	                    var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Prefix_0_with_an_underscore), [token.getText()]);
	                    result.push({ description: description, changes: prefix, fixId: fixIdPrefix });
	                }
	                return result;
	            },
	            fixIds: [fixIdPrefix, fixIdDelete],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var sourceFile = context.sourceFile;
	                var token = getToken(diag.file, diag.start);
	                switch (context.fixId) {
	                    case fixIdPrefix:
	                        if (ts.isIdentifier(token) && canPrefix(token)) {
	                            tryPrefixDeclaration(changes, diag.code, sourceFile, token);
	                        }
	                        break;
	                    case fixIdDelete:
	                        tryDeleteDeclaration(changes, sourceFile, token);
	                        break;
	                    default:
	                        ts.Debug.fail(JSON.stringify(context.fixId));
	                }
	            }); },
	        });
	        function getToken(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            // this handles var ["computed"] = 12;
	            return token.kind === 21 /* OpenBracketToken */ ? ts.getTokenAtPosition(sourceFile, pos + 1, /*includeJsDocComment*/ false) : token;
	        }
	        function tryPrefixDeclaration(changes, errorCode, sourceFile, token) {
	            // Don't offer to prefix a property.
	            if (errorCode !== ts.Diagnostics.Property_0_is_declared_but_its_value_is_never_read.code && ts.isIdentifier(token) && canPrefix(token)) {
	                changes.replaceNode(sourceFile, token, ts.createIdentifier("_" + token.text));
	            }
	        }
	        function canPrefix(token) {
	            switch (token.parent.kind) {
	                case 148 /* Parameter */:
	                    return true;
	                case 230 /* VariableDeclaration */: {
	                    var varDecl = token.parent;
	                    switch (varDecl.parent.parent.kind) {
	                        case 220 /* ForOfStatement */:
	                        case 219 /* ForInStatement */:
	                            return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function tryDeleteDeclaration(changes, sourceFile, token) {
	            switch (token.kind) {
	                case 71 /* Identifier */:
	                    tryDeleteIdentifier(changes, sourceFile, token);
	                    break;
	                case 151 /* PropertyDeclaration */:
	                case 244 /* NamespaceImport */:
	                    changes.deleteNode(sourceFile, token.parent);
	                    break;
	                default:
	                    tryDeleteDefault(changes, sourceFile, token);
	            }
	        }
	        function tryDeleteDefault(changes, sourceFile, token) {
	            if (ts.isDeclarationName(token)) {
	                changes.deleteNode(sourceFile, token.parent);
	            }
	            else if (ts.isLiteralComputedPropertyDeclarationName(token)) {
	                changes.deleteNode(sourceFile, token.parent.parent);
	            }
	        }
	        function tryDeleteIdentifier(changes, sourceFile, identifier) {
	            var parent = identifier.parent;
	            switch (parent.kind) {
	                case 230 /* VariableDeclaration */:
	                    tryDeleteVariableDeclaration(changes, sourceFile, parent);
	                    break;
	                case 147 /* TypeParameter */:
	                    var typeParameters = parent.parent.typeParameters;
	                    if (typeParameters.length === 1) {
	                        var previousToken = ts.getTokenAtPosition(sourceFile, typeParameters.pos - 1, /*includeJsDocComment*/ false);
	                        var nextToken = ts.getTokenAtPosition(sourceFile, typeParameters.end, /*includeJsDocComment*/ false);
	                        ts.Debug.assert(previousToken.kind === 27 /* LessThanToken */);
	                        ts.Debug.assert(nextToken.kind === 29 /* GreaterThanToken */);
	                        changes.deleteNodeRange(sourceFile, previousToken, nextToken);
	                    }
	                    else {
	                        changes.deleteNodeInList(sourceFile, parent);
	                    }
	                    break;
	                case 148 /* Parameter */:
	                    var oldFunction = parent.parent;
	                    if (ts.isArrowFunction(oldFunction) && oldFunction.parameters.length === 1) {
	                        // Lambdas with exactly one parameter are special because, after removal, there
	                        // must be an empty parameter list (i.e. `()`) and this won't necessarily be the
	                        // case if the parameter is simply removed (e.g. in `x => 1`).
	                        var newFunction = ts.updateArrowFunction(oldFunction, oldFunction.modifiers, oldFunction.typeParameters, 
	                        /*parameters*/ undefined, oldFunction.type, oldFunction.equalsGreaterThanToken, oldFunction.body);
	                        // Drop leading and trailing trivia of the new function because we're only going
	                        // to replace the span (vs the full span) of the old function - the old leading
	                        // and trailing trivia will remain.
	                        ts.suppressLeadingAndTrailingTrivia(newFunction);
	                        changes.replaceNode(sourceFile, oldFunction, newFunction, ts.textChanges.useNonAdjustedPositions);
	                    }
	                    else {
	                        changes.deleteNodeInList(sourceFile, parent);
	                    }
	                    break;
	                // handle case where 'import a = A;'
	                case 241 /* ImportEqualsDeclaration */:
	                    var importEquals = ts.getAncestor(identifier, 241 /* ImportEqualsDeclaration */);
	                    changes.deleteNode(sourceFile, importEquals);
	                    break;
	                case 246 /* ImportSpecifier */:
	                    var namedImports = parent.parent;
	                    if (namedImports.elements.length === 1) {
	                        tryDeleteNamedImportBinding(changes, sourceFile, namedImports);
	                    }
	                    else {
	                        // delete import specifier
	                        changes.deleteNodeInList(sourceFile, parent);
	                    }
	                    break;
	                case 243 /* ImportClause */:// this covers both 'import |d|' and 'import |d,| *'
	                    var importClause = parent;
	                    if (!importClause.namedBindings) {
	                        changes.deleteNode(sourceFile, ts.getAncestor(importClause, 242 /* ImportDeclaration */));
	                    }
	                    else {
	                        // import |d,| * as ns from './file'
	                        var start = importClause.name.getStart(sourceFile);
	                        var nextToken = ts.getTokenAtPosition(sourceFile, importClause.name.end, /*includeJsDocComment*/ false);
	                        if (nextToken && nextToken.kind === 26 /* CommaToken */) {
	                            // shift first non-whitespace position after comma to the start position of the node
	                            var end = ts.skipTrivia(sourceFile.text, nextToken.end, /*stopAfterLineBreaks*/ false, /*stopAtComments*/ true);
	                            changes.deleteRange(sourceFile, { pos: start, end: end });
	                        }
	                        else {
	                            changes.deleteNode(sourceFile, importClause.name);
	                        }
	                    }
	                    break;
	                case 244 /* NamespaceImport */:
	                    tryDeleteNamedImportBinding(changes, sourceFile, parent);
	                    break;
	                default:
	                    tryDeleteDefault(changes, sourceFile, identifier);
	                    break;
	            }
	        }
	        function tryDeleteNamedImportBinding(changes, sourceFile, namedBindings) {
	            if (namedBindings.parent.name) {
	                // Delete named imports while preserving the default import
	                // import d|, * as ns| from './file'
	                // import d|, { a }| from './file'
	                var previousToken = ts.getTokenAtPosition(sourceFile, namedBindings.pos - 1, /*includeJsDocComment*/ false);
	                if (previousToken && previousToken.kind === 26 /* CommaToken */) {
	                    changes.deleteRange(sourceFile, { pos: previousToken.getStart(), end: namedBindings.end });
	                }
	            }
	            else {
	                // Delete the entire import declaration
	                // |import * as ns from './file'|
	                // |import { a } from './file'|
	                var importDecl = ts.getAncestor(namedBindings, 242 /* ImportDeclaration */);
	                changes.deleteNode(sourceFile, importDecl);
	            }
	        }
	        // token.parent is a variableDeclaration
	        function tryDeleteVariableDeclaration(changes, sourceFile, varDecl) {
	            switch (varDecl.parent.parent.kind) {
	                case 218 /* ForStatement */: {
	                    var forStatement = varDecl.parent.parent;
	                    var forInitializer = forStatement.initializer;
	                    if (forInitializer.declarations.length === 1) {
	                        changes.deleteNode(sourceFile, forInitializer);
	                    }
	                    else {
	                        changes.deleteNodeInList(sourceFile, varDecl);
	                    }
	                    break;
	                }
	                case 220 /* ForOfStatement */:
	                    var forOfStatement = varDecl.parent.parent;
	                    ts.Debug.assert(forOfStatement.initializer.kind === 231 /* VariableDeclarationList */);
	                    var forOfInitializer = forOfStatement.initializer;
	                    changes.replaceNode(sourceFile, forOfInitializer.declarations[0], ts.createObjectLiteral());
	                    break;
	                case 219 /* ForInStatement */:
	                case 228 /* TryStatement */:
	                    break;
	                default:
	                    var variableStatement = varDecl.parent.parent;
	                    if (variableStatement.declarationList.declarations.length === 1) {
	                        changes.deleteNode(sourceFile, variableStatement);
	                    }
	                    else {
	                        changes.deleteNodeInList(sourceFile, varDecl);
	                    }
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixIdPlain = "fixJSDocTypes_plain";
	        var fixIdNullable = "fixJSDocTypes_nullable";
	        var errorCodes = [ts.Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var checker = context.program.getTypeChecker();
	                var info = getInfo(sourceFile, context.span.start, checker);
	                if (!info)
	                    return undefined;
	                var typeNode = info.typeNode, type = info.type;
	                var original = typeNode.getText(sourceFile);
	                var actions = [fix(type, fixIdPlain)];
	                if (typeNode.kind === 277 /* JSDocNullableType */) {
	                    // for nullable types, suggest the flow-compatible `T | null | undefined`
	                    // in addition to the jsdoc/closure-compatible `T | null`
	                    actions.push(fix(checker.getNullableType(type, 4096 /* Undefined */), fixIdNullable));
	                }
	                return actions;
	                function fix(type, fixId) {
	                    var newText = typeString(type, checker);
	                    return {
	                        description: ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Change_0_to_1), [original, newText]),
	                        changes: [codefix.createFileTextChanges(sourceFile.fileName, [createChange(typeNode, sourceFile, newText)])],
	                        fixId: fixId,
	                    };
	                }
	            },
	            fixIds: [fixIdPlain, fixIdNullable],
	            getAllCodeActions: function (context) {
	                var fixId = context.fixId, program = context.program, sourceFile = context.sourceFile;
	                var checker = program.getTypeChecker();
	                return codefix.codeFixAllWithTextChanges(context, errorCodes, function (changes, err) {
	                    var info = getInfo(err.file, err.start, checker);
	                    if (!info)
	                        return;
	                    var typeNode = info.typeNode, type = info.type;
	                    var fixedType = typeNode.kind === 277 /* JSDocNullableType */ && fixId === fixIdNullable ? checker.getNullableType(type, 4096 /* Undefined */) : type;
	                    changes.push(createChange(typeNode, sourceFile, typeString(fixedType, checker)));
	                });
	            }
	        });
	        function getInfo(sourceFile, pos, checker) {
	            var decl = ts.findAncestor(ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false), isTypeContainer);
	            var typeNode = decl && decl.type;
	            return typeNode && { typeNode: typeNode, type: checker.getTypeFromTypeNode(typeNode) };
	        }
	        function createChange(declaration, sourceFile, newText) {
	            return ts.createTextChange(ts.createTextSpanFromNode(declaration, sourceFile), newText);
	        }
	        function typeString(type, checker) {
	            return checker.typeToString(type, /*enclosingDeclaration*/ undefined, 1 /* NoTruncation */);
	        }
	        function isTypeContainer(node) {
	            // NOTE: Some locations are not handled yet:
	            // MappedTypeNode.typeParameters and SignatureDeclaration.typeParameters, as well as CallExpression.typeArguments
	            switch (node.kind) {
	                case 206 /* AsExpression */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 232 /* FunctionDeclaration */:
	                case 155 /* GetAccessor */:
	                case 159 /* IndexSignature */:
	                case 176 /* MappedType */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 148 /* Parameter */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 156 /* SetAccessor */:
	                case 235 /* TypeAliasDeclaration */:
	                case 188 /* TypeAssertionExpression */:
	                case 230 /* VariableDeclaration */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "fixAwaitInSyncFunction";
	        var errorCodes = [
	            ts.Diagnostics.await_expression_is_only_allowed_within_an_async_function.code,
	            ts.Diagnostics.A_for_await_of_statement_is_only_allowed_within_an_async_function_or_async_generator.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, span = context.span;
	                var nodes = getNodes(sourceFile, span.start);
	                if (!nodes)
	                    return undefined;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, nodes); });
	                return [{ description: ts.getLocaleSpecificMessage(ts.Diagnostics.Add_async_modifier_to_containing_function), changes: changes, fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var nodes = getNodes(diag.file, diag.start);
	                if (!nodes)
	                    return;
	                doChange(changes, context.sourceFile, nodes);
	            }); },
	        });
	        function getReturnType(expr) {
	            if (expr.type) {
	                return expr.type;
	            }
	            if (ts.isVariableDeclaration(expr.parent) &&
	                expr.parent.type &&
	                ts.isFunctionTypeNode(expr.parent.type)) {
	                return expr.parent.type.type;
	            }
	        }
	        function getNodes(sourceFile, start) {
	            var token = ts.getTokenAtPosition(sourceFile, start, /*includeJsDocComment*/ false);
	            var containingFunction = ts.getContainingFunction(token);
	            var insertBefore;
	            switch (containingFunction.kind) {
	                case 153 /* MethodDeclaration */:
	                    insertBefore = containingFunction.name;
	                    break;
	                case 232 /* FunctionDeclaration */:
	                case 190 /* FunctionExpression */:
	                    insertBefore = ts.findChildOfKind(containingFunction, 89 /* FunctionKeyword */, sourceFile);
	                    break;
	                case 191 /* ArrowFunction */:
	                    insertBefore = ts.findChildOfKind(containingFunction, 19 /* OpenParenToken */, sourceFile) || ts.first(containingFunction.parameters);
	                    break;
	                default:
	                    return;
	            }
	            return {
	                insertBefore: insertBefore,
	                returnType: getReturnType(containingFunction)
	            };
	        }
	        function doChange(changes, sourceFile, _a) {
	            var insertBefore = _a.insertBefore, returnType = _a.returnType;
	            if (returnType) {
	                var entityName = ts.getEntityNameFromTypeNode(returnType);
	                if (!entityName || entityName.kind !== 71 /* Identifier */ || entityName.text !== "Promise") {
	                    changes.replaceNode(sourceFile, returnType, ts.createTypeReferenceNode("Promise", ts.createNodeArray([returnType])));
	                }
	            }
	            changes.insertModifierBefore(sourceFile, 120 /* AsyncKeyword */, insertBefore);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var ChangeTracker = ts.textChanges.ChangeTracker;
	        codefix.registerCodeFix({
	            errorCodes: [
	                ts.Diagnostics.Cannot_find_name_0.code,
	                ts.Diagnostics.Cannot_find_name_0_Did_you_mean_1.code,
	                ts.Diagnostics.Cannot_find_namespace_0.code,
	                ts.Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead.code
	            ],
	            getCodeActions: getImportCodeActions,
	            // TODO: GH#20315
	            fixIds: [],
	            getAllCodeActions: ts.notImplemented,
	        });
	        function createCodeAction(descriptionDiagnostic, diagnosticArgs, changes) {
	            var description = ts.formatMessage.apply(undefined, [undefined, descriptionDiagnostic].concat(diagnosticArgs));
	            // TODO: GH#20315
	            return { description: description, changes: changes, fixId: undefined };
	        }
	        function convertToImportCodeFixContext(context, symbolToken, symbolName) {
	            var useCaseSensitiveFileNames = context.host.useCaseSensitiveFileNames ? context.host.useCaseSensitiveFileNames() : false;
	            var program = context.program;
	            var checker = program.getTypeChecker();
	            return {
	                host: context.host,
	                formatContext: context.formatContext,
	                sourceFile: context.sourceFile,
	                program: program,
	                checker: checker,
	                compilerOptions: program.getCompilerOptions(),
	                cachedImportDeclarations: [],
	                getCanonicalFileName: ts.createGetCanonicalFileName(useCaseSensitiveFileNames),
	                symbolName: symbolName,
	                symbolToken: symbolToken
	            };
	        }
	        var ImportKind;
	        (function (ImportKind) {
	            ImportKind[ImportKind["Named"] = 0] = "Named";
	            ImportKind[ImportKind["Default"] = 1] = "Default";
	            ImportKind[ImportKind["Namespace"] = 2] = "Namespace";
	            ImportKind[ImportKind["Equals"] = 3] = "Equals";
	        })(ImportKind || (ImportKind = {}));
	        function getImportCompletionAction(exportedSymbol, moduleSymbol, sourceFile, symbolName, host, program, checker, compilerOptions, allSourceFiles, formatContext, getCanonicalFileName, symbolToken) {
	            var exportInfos = getAllReExportingModules(exportedSymbol, checker, allSourceFiles);
	            ts.Debug.assert(exportInfos.some(function (info) { return info.moduleSymbol === moduleSymbol; }));
	            // We sort the best codefixes first, so taking `first` is best for completions.
	            var moduleSpecifier = ts.first(getNewImportInfos(program, sourceFile, exportInfos, compilerOptions, getCanonicalFileName, host)).moduleSpecifier;
	            var ctx = { host: host, program: program, checker: checker, compilerOptions: compilerOptions, sourceFile: sourceFile, formatContext: formatContext, symbolName: symbolName, getCanonicalFileName: getCanonicalFileName, symbolToken: symbolToken };
	            return { moduleSpecifier: moduleSpecifier, codeAction: ts.first(getCodeActionsForImport(exportInfos, ctx)) };
	        }
	        codefix.getImportCompletionAction = getImportCompletionAction;
	        function getAllReExportingModules(exportedSymbol, checker, allSourceFiles) {
	            var result = [];
	            forEachExternalModule(checker, allSourceFiles, function (moduleSymbol) {
	                for (var _i = 0, _a = checker.getExportsOfModule(moduleSymbol); _i < _a.length; _i++) {
	                    var exported = _a[_i];
	                    if (ts.skipAlias(exported, checker) === exportedSymbol) {
	                        var isDefaultExport = checker.tryGetMemberInModuleExports("default" /* Default */, moduleSymbol) === exported;
	                        result.push({ moduleSymbol: moduleSymbol, importKind: isDefaultExport ? 1 /* Default */ : 0 /* Named */ });
	                    }
	                }
	            });
	            return result;
	        }
	        function getCodeActionsForImport(exportInfos, context) {
	            var existingImports = ts.flatMap(exportInfos, function (info) {
	                return getImportDeclarations(info, context.checker, context.sourceFile, context.cachedImportDeclarations);
	            });
	            // It is possible that multiple import statements with the same specifier exist in the file.
	            // e.g.
	            //
	            //     import * as ns from "foo";
	            //     import { member1, member2 } from "foo";
	            //
	            //     member3/**/ <-- cusor here
	            //
	            // in this case we should provie 2 actions:
	            //     1. change "member3" to "ns.member3"
	            //     2. add "member3" to the second import statement's import list
	            // and it is up to the user to decide which one fits best.
	            var useExistingImportActions = !context.symbolToken || !ts.isIdentifier(context.symbolToken) ? ts.emptyArray : ts.mapDefined(existingImports, function (_a) {
	                var declaration = _a.declaration;
	                var namespace = getNamespaceImportName(declaration);
	                if (namespace) {
	                    var moduleSymbol = context.checker.getAliasedSymbol(context.checker.getSymbolAtLocation(namespace));
	                    if (moduleSymbol && moduleSymbol.exports.has(ts.escapeLeadingUnderscores(context.symbolName))) {
	                        return getCodeActionForUseExistingNamespaceImport(namespace.text, context, context.symbolToken);
	                    }
	                }
	            });
	            return useExistingImportActions.concat(getCodeActionsForAddImport(exportInfos, context, existingImports));
	        }
	        function getNamespaceImportName(declaration) {
	            if (declaration.kind === 242 /* ImportDeclaration */) {
	                var namedBindings = declaration.importClause && ts.isImportClause(declaration.importClause) && declaration.importClause.namedBindings;
	                return namedBindings && namedBindings.kind === 244 /* NamespaceImport */ ? namedBindings.name : undefined;
	            }
	            else {
	                return declaration.name;
	            }
	        }
	        // TODO(anhans): This doesn't seem important to cache... just use an iterator instead of creating a new array?
	        function getImportDeclarations(_a, checker, _b, cachedImportDeclarations) {
	            var moduleSymbol = _a.moduleSymbol, importKind = _a.importKind;
	            var imports = _b.imports;
	            if (cachedImportDeclarations === void 0) { cachedImportDeclarations = []; }
	            var moduleSymbolId = ts.getUniqueSymbolId(moduleSymbol, checker);
	            var cached = cachedImportDeclarations[moduleSymbolId];
	            if (!cached) {
	                cached = cachedImportDeclarations[moduleSymbolId] = ts.mapDefined(imports, function (importModuleSpecifier) {
	                    var declaration = checker.getSymbolAtLocation(importModuleSpecifier) === moduleSymbol ? getImportDeclaration(importModuleSpecifier) : undefined;
	                    return declaration && { declaration: declaration, importKind: importKind };
	                });
	            }
	            return cached;
	        }
	        function getImportDeclaration(_a) {
	            var parent = _a.parent;
	            switch (parent.kind) {
	                case 242 /* ImportDeclaration */:
	                    return parent;
	                case 252 /* ExternalModuleReference */:
	                    return parent.parent;
	                case 248 /* ExportDeclaration */:
	                case 185 /* CallExpression */:// For "require()" calls
	                    // Ignore these, can't add imports to them.
	                    return undefined;
	                default:
	                    ts.Debug.fail();
	            }
	        }
	        function getCodeActionForNewImport(context, _a) {
	            var moduleSpecifier = _a.moduleSpecifier, importKind = _a.importKind;
	            var sourceFile = context.sourceFile, symbolName = context.symbolName;
	            var lastImportDeclaration = ts.findLast(sourceFile.statements, ts.isAnyImportSyntax);
	            var moduleSpecifierWithoutQuotes = ts.stripQuotes(moduleSpecifier);
	            var quotedModuleSpecifier = createStringLiteralWithQuoteStyle(sourceFile, moduleSpecifierWithoutQuotes);
	            var importDecl = importKind !== 3 /* Equals */
	                ? ts.createImportDeclaration(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, createImportClauseOfKind(importKind, symbolName), quotedModuleSpecifier)
	                : ts.createImportEqualsDeclaration(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, ts.createIdentifier(symbolName), ts.createExternalModuleReference(quotedModuleSpecifier));
	            var changes = ChangeTracker.with(context, function (changeTracker) {
	                if (lastImportDeclaration) {
	                    changeTracker.insertNodeAfter(sourceFile, lastImportDeclaration, importDecl);
	                }
	                else {
	                    changeTracker.insertNodeAtTopOfFile(sourceFile, importDecl, /*blankLineBetween*/ true);
	                }
	            });
	            // if this file doesn't have any import statements, insert an import statement and then insert a new line
	            // between the only import statement and user code. Otherwise just insert the statement because chances
	            // are there are already a new line seperating code and import statements.
	            return createCodeAction(ts.Diagnostics.Import_0_from_module_1, [symbolName, moduleSpecifierWithoutQuotes], changes);
	        }
	        function createStringLiteralWithQuoteStyle(sourceFile, text) {
	            var literal = ts.createLiteral(text);
	            var firstModuleSpecifier = ts.firstOrUndefined(sourceFile.imports);
	            literal.singleQuote = !!firstModuleSpecifier && !ts.isStringDoubleQuoted(firstModuleSpecifier, sourceFile);
	            return literal;
	        }
	        function usesJsExtensionOnImports(sourceFile) {
	            return ts.firstDefined(sourceFile.imports, function (_a) {
	                var text = _a.text;
	                return ts.pathIsRelative(text) ? ts.fileExtensionIs(text, ".js" /* Js */) : undefined;
	            }) || false;
	        }
	        function createImportClauseOfKind(kind, symbolName) {
	            var id = ts.createIdentifier(symbolName);
	            switch (kind) {
	                case 1 /* Default */:
	                    return ts.createImportClause(id, /*namedBindings*/ undefined);
	                case 2 /* Namespace */:
	                    return ts.createImportClause(/*name*/ undefined, ts.createNamespaceImport(id));
	                case 0 /* Named */:
	                    return ts.createImportClause(/*name*/ undefined, ts.createNamedImports([ts.createImportSpecifier(/*propertyName*/ undefined, id)]));
	                default:
	                    ts.Debug.assertNever(kind);
	            }
	        }
	        function getNewImportInfos(program, sourceFile, moduleSymbols, options, getCanonicalFileName, host) {
	            var baseUrl = options.baseUrl, paths = options.paths, rootDirs = options.rootDirs;
	            var addJsExtension = usesJsExtensionOnImports(sourceFile);
	            var choicesForEachExportingModule = ts.flatMap(moduleSymbols, function (_a) {
	                var moduleSymbol = _a.moduleSymbol, importKind = _a.importKind;
	                var modulePathsGroups = getAllModulePaths(program, moduleSymbol.valueDeclaration.getSourceFile()).map(function (moduleFileName) {
	                    var sourceDirectory = ts.getDirectoryPath(sourceFile.fileName);
	                    var global = tryGetModuleNameFromAmbientModule(moduleSymbol)
	                        || tryGetModuleNameFromTypeRoots(options, host, getCanonicalFileName, moduleFileName, addJsExtension)
	                        || tryGetModuleNameAsNodeModule(options, moduleFileName, host, getCanonicalFileName, sourceDirectory)
	                        || rootDirs && tryGetModuleNameFromRootDirs(rootDirs, moduleFileName, sourceDirectory, getCanonicalFileName);
	                    if (global) {
	                        return [global];
	                    }
	                    var relativePath = removeExtensionAndIndexPostFix(getRelativePath(moduleFileName, sourceDirectory, getCanonicalFileName), options, addJsExtension);
	                    if (!baseUrl) {
	                        return [relativePath];
	                    }
	                    var relativeToBaseUrl = getRelativePathIfInDirectory(moduleFileName, baseUrl, getCanonicalFileName);
	                    if (!relativeToBaseUrl) {
	                        return [relativePath];
	                    }
	                    var importRelativeToBaseUrl = removeExtensionAndIndexPostFix(relativeToBaseUrl, options, addJsExtension);
	                    if (paths) {
	                        var fromPaths = tryGetModuleNameFromPaths(ts.removeFileExtension(relativeToBaseUrl), importRelativeToBaseUrl, paths);
	                        if (fromPaths) {
	                            return [fromPaths];
	                        }
	                    }
	                    if (isPathRelativeToParent(relativeToBaseUrl)) {
	                        return [relativePath];
	                    }
	                    /*
	                    Prefer a relative import over a baseUrl import if it doesn't traverse up to baseUrl.
	    
	                    Suppose we have:
	                        baseUrl = /base
	                        sourceDirectory = /base/a/b
	                        moduleFileName = /base/foo/bar
	                    Then:
	                        relativePath = ../../foo/bar
	                        getRelativePathNParents(relativePath) = 2
	                        pathFromSourceToBaseUrl = ../../
	                        getRelativePathNParents(pathFromSourceToBaseUrl) = 2
	                        2 < 2 = false
	                    In this case we should prefer using the baseUrl path "/a/b" instead of the relative path "../../foo/bar".
	    
	                    Suppose we have:
	                        baseUrl = /base
	                        sourceDirectory = /base/foo/a
	                        moduleFileName = /base/foo/bar
	                    Then:
	                        relativePath = ../a
	                        getRelativePathNParents(relativePath) = 1
	                        pathFromSourceToBaseUrl = ../../
	                        getRelativePathNParents(pathFromSourceToBaseUrl) = 2
	                        1 < 2 = true
	                    In this case we should prefer using the relative path "../a" instead of the baseUrl path "foo/a".
	                    */
	                    var pathFromSourceToBaseUrl = getRelativePath(baseUrl, sourceDirectory, getCanonicalFileName);
	                    var relativeFirst = getRelativePathNParents(relativePath) < getRelativePathNParents(pathFromSourceToBaseUrl);
	                    return relativeFirst ? [relativePath, importRelativeToBaseUrl] : [importRelativeToBaseUrl, relativePath];
	                });
	                return modulePathsGroups.map(function (group) { return group.map(function (moduleSpecifier) { return ({ moduleSpecifier: moduleSpecifier, importKind: importKind }); }); });
	            });
	            // Sort to keep the shortest paths first, but keep [relativePath, importRelativeToBaseUrl] groups together
	            return ts.flatten(choicesForEachExportingModule.sort(function (a, b) { return ts.first(a).moduleSpecifier.length - ts.first(b).moduleSpecifier.length; }));
	        }
	        /**
	         * Looks for a existing imports that use symlinks to this module.
	         * Only if no symlink is available, the real path will be used.
	         */
	        function getAllModulePaths(program, _a) {
	            var fileName = _a.fileName;
	            var symlinks = ts.mapDefined(program.getSourceFiles(), function (sf) {
	                return sf.resolvedModules && ts.firstDefinedIterator(sf.resolvedModules.values(), function (res) {
	                    return res && res.resolvedFileName === fileName ? res.originalPath : undefined;
	                });
	            });
	            return symlinks.length === 0 ? [fileName] : symlinks;
	        }
	        function getRelativePathNParents(relativePath) {
	            var count = 0;
	            for (var i = 0; i + 3 <= relativePath.length && relativePath.slice(i, i + 3) === "../"; i += 3) {
	                count++;
	            }
	            return count;
	        }
	        function tryGetModuleNameFromAmbientModule(moduleSymbol) {
	            var decl = moduleSymbol.valueDeclaration;
	            if (ts.isModuleDeclaration(decl) && ts.isStringLiteral(decl.name)) {
	                return decl.name.text;
	            }
	        }
	        function tryGetModuleNameFromPaths(relativeToBaseUrlWithIndex, relativeToBaseUrl, paths) {
	            for (var key in paths) {
	                for (var _i = 0, _a = paths[key]; _i < _a.length; _i++) {
	                    var patternText_1 = _a[_i];
	                    var pattern = ts.removeFileExtension(ts.normalizePath(patternText_1));
	                    var indexOfStar = pattern.indexOf("*");
	                    if (indexOfStar === 0 && pattern.length === 1) {
	                        continue;
	                    }
	                    else if (indexOfStar !== -1) {
	                        var prefix = pattern.substr(0, indexOfStar);
	                        var suffix = pattern.substr(indexOfStar + 1);
	                        if (relativeToBaseUrl.length >= prefix.length + suffix.length &&
	                            ts.startsWith(relativeToBaseUrl, prefix) &&
	                            ts.endsWith(relativeToBaseUrl, suffix)) {
	                            var matchedStar = relativeToBaseUrl.substr(prefix.length, relativeToBaseUrl.length - suffix.length);
	                            return key.replace("*", matchedStar);
	                        }
	                    }
	                    else if (pattern === relativeToBaseUrl || pattern === relativeToBaseUrlWithIndex) {
	                        return key;
	                    }
	                }
	            }
	        }
	        function tryGetModuleNameFromRootDirs(rootDirs, moduleFileName, sourceDirectory, getCanonicalFileName) {
	            var normalizedTargetPath = getPathRelativeToRootDirs(moduleFileName, rootDirs, getCanonicalFileName);
	            if (normalizedTargetPath === undefined) {
	                return undefined;
	            }
	            var normalizedSourcePath = getPathRelativeToRootDirs(sourceDirectory, rootDirs, getCanonicalFileName);
	            var relativePath = normalizedSourcePath !== undefined ? getRelativePath(normalizedTargetPath, normalizedSourcePath, getCanonicalFileName) : normalizedTargetPath;
	            return ts.removeFileExtension(relativePath);
	        }
	        function tryGetModuleNameFromTypeRoots(options, host, getCanonicalFileName, moduleFileName, addJsExtension) {
	            var roots = ts.getEffectiveTypeRoots(options, host);
	            return ts.firstDefined(roots, function (unNormalizedTypeRoot) {
	                var typeRoot = ts.toPath(unNormalizedTypeRoot, /*basePath*/ undefined, getCanonicalFileName);
	                if (ts.startsWith(moduleFileName, typeRoot)) {
	                    return removeExtensionAndIndexPostFix(moduleFileName.substring(typeRoot.length + 1), options, addJsExtension);
	                }
	            });
	        }
	        function tryGetModuleNameAsNodeModule(options, moduleFileName, host, getCanonicalFileName, sourceDirectory) {
	            if (ts.getEmitModuleResolutionKind(options) !== ts.ModuleResolutionKind.NodeJs) {
	                // nothing to do here
	                return undefined;
	            }
	            var parts = getNodeModulePathParts(moduleFileName);
	            if (!parts) {
	                return undefined;
	            }
	            // Simplify the full file path to something that can be resolved by Node.
	            // If the module could be imported by a directory name, use that directory's name
	            var moduleSpecifier = getDirectoryOrExtensionlessFileName(moduleFileName);
	            // Get a path that's relative to node_modules or the importing file's path
	            moduleSpecifier = getNodeResolvablePath(moduleSpecifier);
	            // If the module was found in @types, get the actual Node package name
	            return ts.getPackageNameFromAtTypesDirectory(moduleSpecifier);
	            function getDirectoryOrExtensionlessFileName(path) {
	                // If the file is the main module, it can be imported by the package name
	                var packageRootPath = path.substring(0, parts.packageRootIndex);
	                var packageJsonPath = ts.combinePaths(packageRootPath, "package.json");
	                if (host.fileExists(packageJsonPath)) {
	                    var packageJsonContent = JSON.parse(host.readFile(packageJsonPath));
	                    if (packageJsonContent) {
	                        var mainFileRelative = packageJsonContent.typings || packageJsonContent.types || packageJsonContent.main;
	                        if (mainFileRelative) {
	                            var mainExportFile = ts.toPath(mainFileRelative, packageRootPath, getCanonicalFileName);
	                            if (mainExportFile === getCanonicalFileName(path)) {
	                                return packageRootPath;
	                            }
	                        }
	                    }
	                }
	                // We still have a file name - remove the extension
	                var fullModulePathWithoutExtension = ts.removeFileExtension(path);
	                // If the file is /index, it can be imported by its directory name
	                if (getCanonicalFileName(fullModulePathWithoutExtension.substring(parts.fileNameIndex)) === "/index") {
	                    return fullModulePathWithoutExtension.substring(0, parts.fileNameIndex);
	                }
	                return fullModulePathWithoutExtension;
	            }
	            function getNodeResolvablePath(path) {
	                var basePath = path.substring(0, parts.topLevelNodeModulesIndex);
	                if (sourceDirectory.indexOf(basePath) === 0) {
	                    // if node_modules folder is in this folder or any of its parent folders, no need to keep it.
	                    return path.substring(parts.topLevelPackageNameIndex + 1);
	                }
	                else {
	                    return getRelativePath(path, sourceDirectory, getCanonicalFileName);
	                }
	            }
	        }
	        function getNodeModulePathParts(fullPath) {
	            // If fullPath can't be valid module file within node_modules, returns undefined.
	            // Example of expected pattern: /base/path/node_modules/[@scope/otherpackage/@otherscope/node_modules/]package/[subdirectory/]file.js
	            // Returns indices:                       ^            ^                                                      ^             ^
	            var topLevelNodeModulesIndex = 0;
	            var topLevelPackageNameIndex = 0;
	            var packageRootIndex = 0;
	            var fileNameIndex = 0;
	            var States;
	            (function (States) {
	                States[States["BeforeNodeModules"] = 0] = "BeforeNodeModules";
	                States[States["NodeModules"] = 1] = "NodeModules";
	                States[States["Scope"] = 2] = "Scope";
	                States[States["PackageContent"] = 3] = "PackageContent";
	            })(States || (States = {}));
	            var partStart = 0;
	            var partEnd = 0;
	            var state = 0 /* BeforeNodeModules */;
	            while (partEnd >= 0) {
	                partStart = partEnd;
	                partEnd = fullPath.indexOf("/", partStart + 1);
	                switch (state) {
	                    case 0 /* BeforeNodeModules */:
	                        if (fullPath.indexOf("/node_modules/", partStart) === partStart) {
	                            topLevelNodeModulesIndex = partStart;
	                            topLevelPackageNameIndex = partEnd;
	                            state = 1 /* NodeModules */;
	                        }
	                        break;
	                    case 1 /* NodeModules */:
	                    case 2 /* Scope */:
	                        if (state === 1 /* NodeModules */ && fullPath.charAt(partStart + 1) === "@") {
	                            state = 2 /* Scope */;
	                        }
	                        else {
	                            packageRootIndex = partEnd;
	                            state = 3 /* PackageContent */;
	                        }
	                        break;
	                    case 3 /* PackageContent */:
	                        if (fullPath.indexOf("/node_modules/", partStart) === partStart) {
	                            state = 1 /* NodeModules */;
	                        }
	                        else {
	                            state = 3 /* PackageContent */;
	                        }
	                        break;
	                }
	            }
	            fileNameIndex = partStart;
	            return state > 1 /* NodeModules */ ? { topLevelNodeModulesIndex: topLevelNodeModulesIndex, topLevelPackageNameIndex: topLevelPackageNameIndex, packageRootIndex: packageRootIndex, fileNameIndex: fileNameIndex } : undefined;
	        }
	        function getPathRelativeToRootDirs(path, rootDirs, getCanonicalFileName) {
	            return ts.firstDefined(rootDirs, function (rootDir) {
	                var relativePath = getRelativePathIfInDirectory(path, rootDir, getCanonicalFileName);
	                return isPathRelativeToParent(relativePath) ? undefined : relativePath;
	            });
	        }
	        function removeExtensionAndIndexPostFix(fileName, options, addJsExtension) {
	            var noExtension = ts.removeFileExtension(fileName);
	            return addJsExtension
	                ? noExtension + ".js"
	                : ts.getEmitModuleResolutionKind(options) === ts.ModuleResolutionKind.NodeJs
	                    ? ts.removeSuffix(noExtension, "/index")
	                    : noExtension;
	        }
	        function getRelativePathIfInDirectory(path, directoryPath, getCanonicalFileName) {
	            var relativePath = ts.getRelativePathToDirectoryOrUrl(directoryPath, path, directoryPath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
	            return ts.isRootedDiskPath(relativePath) ? undefined : relativePath;
	        }
	        function isPathRelativeToParent(path) {
	            return ts.startsWith(path, "..");
	        }
	        function getRelativePath(path, directoryPath, getCanonicalFileName) {
	            var relativePath = ts.getRelativePathToDirectoryOrUrl(directoryPath, path, directoryPath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
	            return !ts.pathIsRelative(relativePath) ? "./" + relativePath : relativePath;
	        }
	        function getCodeActionsForAddImport(exportInfos, ctx, existingImports) {
	            var fromExistingImport = ts.firstDefined(existingImports, function (_a) {
	                var declaration = _a.declaration, importKind = _a.importKind;
	                if (declaration.kind === 242 /* ImportDeclaration */ && declaration.importClause) {
	                    var changes = tryUpdateExistingImport(ctx, ts.isImportClause(declaration.importClause) && declaration.importClause || undefined, importKind);
	                    if (changes) {
	                        var moduleSpecifierWithoutQuotes = ts.stripQuotes(declaration.moduleSpecifier.getText());
	                        return createCodeAction(ts.Diagnostics.Add_0_to_existing_import_declaration_from_1, [ctx.symbolName, moduleSpecifierWithoutQuotes], changes);
	                    }
	                }
	            });
	            if (fromExistingImport) {
	                return [fromExistingImport];
	            }
	            var existingDeclaration = ts.firstDefined(existingImports, newImportInfoFromExistingSpecifier);
	            var newImportInfos = existingDeclaration
	                ? [existingDeclaration]
	                : getNewImportInfos(ctx.program, ctx.sourceFile, exportInfos, ctx.compilerOptions, ctx.getCanonicalFileName, ctx.host);
	            return newImportInfos.map(function (info) { return getCodeActionForNewImport(ctx, info); });
	        }
	        function newImportInfoFromExistingSpecifier(_a) {
	            var declaration = _a.declaration, importKind = _a.importKind;
	            var expression = declaration.kind === 242 /* ImportDeclaration */
	                ? declaration.moduleSpecifier
	                : declaration.moduleReference.kind === 252 /* ExternalModuleReference */
	                    ? declaration.moduleReference.expression
	                    : undefined;
	            return expression && ts.isStringLiteral(expression) ? { moduleSpecifier: expression.text, importKind: importKind } : undefined;
	        }
	        function tryUpdateExistingImport(context, importClause, importKind) {
	            var symbolName = context.symbolName, sourceFile = context.sourceFile;
	            var name = importClause.name;
	            var namedBindings = (importClause.kind !== 241 /* ImportEqualsDeclaration */ && importClause).namedBindings;
	            switch (importKind) {
	                case 1 /* Default */:
	                    return name ? undefined : ChangeTracker.with(context, function (t) {
	                        return t.replaceNode(sourceFile, importClause, ts.createImportClause(ts.createIdentifier(symbolName), namedBindings));
	                    });
	                case 0 /* Named */: {
	                    var newImportSpecifier_1 = ts.createImportSpecifier(/*propertyName*/ undefined, ts.createIdentifier(symbolName));
	                    if (namedBindings && namedBindings.kind === 245 /* NamedImports */ && namedBindings.elements.length !== 0) {
	                        // There are already named imports; add another.
	                        return ChangeTracker.with(context, function (t) { return t.insertNodeInListAfter(sourceFile, namedBindings.elements[namedBindings.elements.length - 1], newImportSpecifier_1); });
	                    }
	                    if (!namedBindings || namedBindings.kind === 245 /* NamedImports */ && namedBindings.elements.length === 0) {
	                        return ChangeTracker.with(context, function (t) {
	                            return t.replaceNode(sourceFile, importClause, ts.createImportClause(name, ts.createNamedImports([newImportSpecifier_1])));
	                        });
	                    }
	                    return undefined;
	                }
	                case 2 /* Namespace */:
	                    return namedBindings ? undefined : ChangeTracker.with(context, function (t) {
	                        return t.replaceNode(sourceFile, importClause, ts.createImportClause(name, ts.createNamespaceImport(ts.createIdentifier(symbolName))));
	                    });
	                case 3 /* Equals */:
	                    return undefined;
	                default:
	                    ts.Debug.assertNever(importKind);
	            }
	        }
	        function getCodeActionForUseExistingNamespaceImport(namespacePrefix, context, symbolToken) {
	            var symbolName = context.symbolName, sourceFile = context.sourceFile;
	            /**
	             * Cases:
	             *     import * as ns from "mod"
	             *     import default, * as ns from "mod"
	             *     import ns = require("mod")
	             *
	             * Because there is no import list, we alter the reference to include the
	             * namespace instead of altering the import declaration. For example, "foo" would
	             * become "ns.foo"
	             */
	            var changes = ChangeTracker.with(context, function (tracker) {
	                return tracker.replaceNode(sourceFile, symbolToken, ts.createPropertyAccess(ts.createIdentifier(namespacePrefix), symbolToken));
	            });
	            return createCodeAction(ts.Diagnostics.Change_0_to_1, [symbolName, namespacePrefix + "." + symbolName], changes);
	        }
	        function getImportCodeActions(context) {
	            return context.errorCode === ts.Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead.code
	                ? getActionsForUMDImport(context)
	                : getActionsForNonUMDImport(context);
	        }
	        function getActionsForUMDImport(context) {
	            var token = ts.getTokenAtPosition(context.sourceFile, context.span.start, /*includeJsDocComment*/ false);
	            var checker = context.program.getTypeChecker();
	            var umdSymbol;
	            if (ts.isIdentifier(token)) {
	                // try the identifier to see if it is the umd symbol
	                umdSymbol = checker.getSymbolAtLocation(token);
	            }
	            if (!ts.isUMDExportSymbol(umdSymbol)) {
	                // The error wasn't for the symbolAtLocation, it was for the JSX tag itself, which needs access to e.g. `React`.
	                var parent = token.parent;
	                var isNodeOpeningLikeElement = ts.isJsxOpeningLikeElement(parent);
	                if ((ts.isJsxOpeningLikeElement && parent.tagName === token) || parent.kind === 258 /* JsxOpeningFragment */) {
	                    umdSymbol = checker.resolveName(checker.getJsxNamespace(), isNodeOpeningLikeElement ? parent.tagName : parent, 107455 /* Value */, /*excludeGlobals*/ false);
	                }
	            }
	            if (ts.isUMDExportSymbol(umdSymbol)) {
	                var symbol = checker.getAliasedSymbol(umdSymbol);
	                if (symbol) {
	                    return getCodeActionsForImport([{ moduleSymbol: symbol, importKind: getUmdImportKind(context.program.getCompilerOptions()) }], convertToImportCodeFixContext(context, token, umdSymbol.name));
	                }
	            }
	            return undefined;
	        }
	        function getUmdImportKind(compilerOptions) {
	            // Import a synthetic `default` if enabled.
	            if (ts.getAllowSyntheticDefaultImports(compilerOptions)) {
	                return 1 /* Default */;
	            }
	            // When a synthetic `default` is unavailable, use `import..require` if the module kind supports it.
	            var moduleKind = ts.getEmitModuleKind(compilerOptions);
	            switch (moduleKind) {
	                case ts.ModuleKind.AMD:
	                case ts.ModuleKind.CommonJS:
	                case ts.ModuleKind.UMD:
	                    return 3 /* Equals */;
	                case ts.ModuleKind.System:
	                case ts.ModuleKind.ES2015:
	                case ts.ModuleKind.ESNext:
	                case ts.ModuleKind.None:
	                    // Fall back to the `import * as ns` style import.
	                    return 2 /* Namespace */;
	                default:
	                    throw ts.Debug.assertNever(moduleKind);
	            }
	        }
	        function getActionsForNonUMDImport(context) {
	            // This will always be an Identifier, since the diagnostics we fix only fail on identifiers.
	            var sourceFile = context.sourceFile, span = context.span, program = context.program, cancellationToken = context.cancellationToken;
	            var checker = program.getTypeChecker();
	            var symbolToken = ts.getTokenAtPosition(sourceFile, span.start, /*includeJsDocComment*/ false);
	            var isJsxNamespace = ts.isJsxOpeningLikeElement(symbolToken.parent) && symbolToken.parent.tagName === symbolToken;
	            if (!isJsxNamespace && !ts.isIdentifier(symbolToken)) {
	                return undefined;
	            }
	            var symbolName = isJsxNamespace ? checker.getJsxNamespace() : symbolToken.text;
	            var allSourceFiles = program.getSourceFiles();
	            var compilerOptions = program.getCompilerOptions();
	            // "default" is a keyword and not a legal identifier for the import, so we don't expect it here
	            ts.Debug.assert(symbolName !== "default");
	            var currentTokenMeaning = ts.getMeaningFromLocation(symbolToken);
	            // For each original symbol, keep all re-exports of that symbol together so we can call `getCodeActionsForImport` on the whole group at once.
	            // Maps symbol id to info for modules providing that symbol (original export + re-exports).
	            var originalSymbolToExportInfos = ts.createMultiMap();
	            function addSymbol(moduleSymbol, exportedSymbol, importKind) {
	                originalSymbolToExportInfos.add(ts.getUniqueSymbolId(exportedSymbol, checker).toString(), { moduleSymbol: moduleSymbol, importKind: importKind });
	            }
	            forEachExternalModuleToImportFrom(checker, sourceFile, allSourceFiles, function (moduleSymbol) {
	                cancellationToken.throwIfCancellationRequested();
	                // check the default export
	                var defaultExport = checker.tryGetMemberInModuleExports("default" /* Default */, moduleSymbol);
	                if (defaultExport) {
	                    var localSymbol = ts.getLocalSymbolForExportDefault(defaultExport);
	                    if ((localSymbol && localSymbol.escapedName === symbolName ||
	                        getEscapedNameForExportDefault(defaultExport) === symbolName ||
	                        moduleSymbolToValidIdentifier(moduleSymbol, compilerOptions.target) === symbolName) && checkSymbolHasMeaning(localSymbol || defaultExport, currentTokenMeaning)) {
	                        addSymbol(moduleSymbol, localSymbol || defaultExport, 1 /* Default */);
	                    }
	                }
	                // check exports with the same name
	                var exportSymbolWithIdenticalName = checker.tryGetMemberInModuleExportsAndProperties(symbolName, moduleSymbol);
	                if (exportSymbolWithIdenticalName && checkSymbolHasMeaning(exportSymbolWithIdenticalName, currentTokenMeaning)) {
	                    addSymbol(moduleSymbol, exportSymbolWithIdenticalName, 0 /* Named */);
	                }
	                function getEscapedNameForExportDefault(symbol) {
	                    return ts.firstDefined(symbol.declarations, function (declaration) {
	                        if (ts.isExportAssignment(declaration)) {
	                            if (ts.isIdentifier(declaration.expression)) {
	                                return declaration.expression.escapedText;
	                            }
	                        }
	                        else if (ts.isExportSpecifier(declaration)) {
	                            ts.Debug.assert(declaration.name.escapedText === "default" /* Default */);
	                            if (declaration.propertyName) {
	                                return declaration.propertyName.escapedText;
	                            }
	                        }
	                    });
	                }
	            });
	            return ts.arrayFrom(ts.flatMapIterator(originalSymbolToExportInfos.values(), function (exportInfos) { return getCodeActionsForImport(exportInfos, convertToImportCodeFixContext(context, symbolToken, symbolName)); }));
	        }
	        function checkSymbolHasMeaning(_a, meaning) {
	            var declarations = _a.declarations;
	            return ts.some(declarations, function (decl) { return !!(ts.getMeaningFromDeclaration(decl) & meaning); });
	        }
	        function forEachExternalModuleToImportFrom(checker, from, allSourceFiles, cb) {
	            forEachExternalModule(checker, allSourceFiles, function (module, sourceFile) {
	                if (sourceFile === undefined || sourceFile !== from && isImportablePath(from.fileName, sourceFile.fileName)) {
	                    cb(module);
	                }
	            });
	        }
	        codefix.forEachExternalModuleToImportFrom = forEachExternalModuleToImportFrom;
	        function forEachExternalModule(checker, allSourceFiles, cb) {
	            for (var _i = 0, _a = checker.getAmbientModules(); _i < _a.length; _i++) {
	                var ambient = _a[_i];
	                cb(ambient, /*sourceFile*/ undefined);
	            }
	            for (var _b = 0, allSourceFiles_1 = allSourceFiles; _b < allSourceFiles_1.length; _b++) {
	                var sourceFile = allSourceFiles_1[_b];
	                if (ts.isExternalOrCommonJsModule(sourceFile)) {
	                    cb(sourceFile.symbol, sourceFile);
	                }
	            }
	        }
	        /**
	         * Don't include something from a `node_modules` that isn't actually reachable by a global import.
	         * A relative import to node_modules is usually a bad idea.
	         */
	        function isImportablePath(fromPath, toPath) {
	            // If it's in a `node_modules` but is not reachable from here via a global import, don't bother.
	            var toNodeModules = ts.forEachAncestorDirectory(toPath, function (ancestor) { return ts.getBaseFileName(ancestor) === "node_modules" ? ancestor : undefined; });
	            return toNodeModules === undefined || ts.startsWith(fromPath, ts.getDirectoryPath(toNodeModules));
	        }
	        function moduleSymbolToValidIdentifier(moduleSymbol, target) {
	            return moduleSpecifierToValidIdentifier(ts.removeFileExtension(ts.getBaseFileName(moduleSymbol.name)), target);
	        }
	        codefix.moduleSymbolToValidIdentifier = moduleSymbolToValidIdentifier;
	        function moduleSpecifierToValidIdentifier(moduleSpecifier, target) {
	            var res = "";
	            var lastCharWasValid = true;
	            var firstCharCode = moduleSpecifier.charCodeAt(0);
	            if (ts.isIdentifierStart(firstCharCode, target)) {
	                res += String.fromCharCode(firstCharCode);
	            }
	            else {
	                lastCharWasValid = false;
	            }
	            for (var i = 1; i < moduleSpecifier.length; i++) {
	                var ch = moduleSpecifier.charCodeAt(i);
	                var isValid = ts.isIdentifierPart(ch, target);
	                if (isValid) {
	                    var char = String.fromCharCode(ch);
	                    if (!lastCharWasValid) {
	                        char = char.toUpperCase();
	                    }
	                    res += char;
	                }
	                lastCharWasValid = isValid;
	            }
	            // Need `|| "_"` to ensure result isn't empty.
	            return !ts.isStringANonContextualKeyword(res) ? res || "_" : "_" + res;
	        }
	        codefix.moduleSpecifierToValidIdentifier = moduleSpecifierToValidIdentifier;
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "disableJsDiagnostics";
	        var errorCodes = ts.mapDefined(Object.keys(ts.Diagnostics), function (key) {
	            var diag = ts.Diagnostics[key];
	            return diag.category === ts.DiagnosticCategory.Error ? diag.code : undefined;
	        });
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, program = context.program, span = context.span;
	                if (!ts.isInJavaScriptFile(sourceFile) || !ts.isCheckJsEnabledForFile(sourceFile, program.getCompilerOptions())) {
	                    return undefined;
	                }
	                var newLineCharacter = ts.getNewLineOrDefaultFromHost(context.host, context.formatContext.options);
	                return [{
	                        description: ts.getLocaleSpecificMessage(ts.Diagnostics.Ignore_this_error_message),
	                        changes: [codefix.createFileTextChanges(sourceFile.fileName, [getIgnoreCommentLocationForLocation(sourceFile, span.start, newLineCharacter).change])],
	                        fixId: fixId,
	                    },
	                    {
	                        description: ts.getLocaleSpecificMessage(ts.Diagnostics.Disable_checking_for_this_file),
	                        changes: [codefix.createFileTextChanges(sourceFile.fileName, [
	                                ts.createTextChange(sourceFile.checkJsDirective ? ts.createTextSpanFromBounds(sourceFile.checkJsDirective.pos, sourceFile.checkJsDirective.end) : ts.createTextSpan(0, 0), "// @ts-nocheck" + newLineCharacter),
	                            ])],
	                        // fixId unnecessary because adding `// @ts-nocheck` even once will ignore every error in the file.
	                        fixId: undefined,
	                    }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var seenLines = ts.createMap(); // Only need to add `// @ts-ignore` for a line once.
	                return codefix.codeFixAllWithTextChanges(context, errorCodes, function (changes, err) {
	                    if (err.start !== undefined) {
	                        var _a = getIgnoreCommentLocationForLocation(err.file, err.start, ts.getNewLineOrDefaultFromHost(context.host, context.formatContext.options)), lineNumber = _a.lineNumber, change = _a.change;
	                        if (ts.addToSeen(seenLines, lineNumber)) {
	                            changes.push(change);
	                        }
	                    }
	                });
	            },
	        });
	        function getIgnoreCommentLocationForLocation(sourceFile, position, newLineCharacter) {
	            var lineNumber = ts.getLineAndCharacterOfPosition(sourceFile, position).line;
	            var lineStartPosition = ts.getStartPositionOfLine(lineNumber, sourceFile);
	            var startPosition = ts.getFirstNonSpaceCharacterPosition(sourceFile.text, lineStartPosition);
	            // First try to see if we can put the '// @ts-ignore' on the previous line.
	            // We need to make sure that we are not in the middle of a string literal or a comment.
	            // We also want to check if the previous line holds a comment for a node on the next line
	            // if so, we do not want to separate the node from its comment if we can.
	            if (!ts.isInComment(sourceFile, startPosition) && !ts.isInString(sourceFile, startPosition) && !ts.isInTemplateString(sourceFile, startPosition)) {
	                var token = ts.getTouchingToken(sourceFile, startPosition, /*includeJsDocComment*/ false);
	                var tokenLeadingComments = ts.getLeadingCommentRangesOfNode(token, sourceFile);
	                if (!tokenLeadingComments || !tokenLeadingComments.length || tokenLeadingComments[0].pos >= startPosition) {
	                    return { lineNumber: lineNumber, change: ts.createTextChangeFromStartLength(startPosition, 0, "// @ts-ignore" + newLineCharacter) };
	                }
	            }
	            // If all fails, add an extra new line immediately before the error span.
	            return { lineNumber: lineNumber, change: ts.createTextChangeFromStartLength(position, 0, (position === startPosition ? "" : newLineCharacter) + "// @ts-ignore" + newLineCharacter) };
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        /**
	         * Finds members of the resolved type that are missing in the class pointed to by class decl
	         * and generates source code for the missing members.
	         * @param possiblyMissingSymbols The collection of symbols to filter and then get insertions for.
	         * @returns Empty string iff there are no member insertions.
	         */
	        function createMissingMemberNodes(classDeclaration, possiblyMissingSymbols, checker, out) {
	            var classMembers = classDeclaration.symbol.members;
	            for (var _i = 0, possiblyMissingSymbols_1 = possiblyMissingSymbols; _i < possiblyMissingSymbols_1.length; _i++) {
	                var symbol = possiblyMissingSymbols_1[_i];
	                if (!classMembers.has(symbol.escapedName)) {
	                    addNewNodeForMemberSymbol(symbol, classDeclaration, checker, out);
	                }
	            }
	        }
	        codefix.createMissingMemberNodes = createMissingMemberNodes;
	        /**
	         * @returns Empty string iff there we can't figure out a representation for `symbol` in `enclosingDeclaration`.
	         */
	        function addNewNodeForMemberSymbol(symbol, enclosingDeclaration, checker, out) {
	            var declarations = symbol.getDeclarations();
	            if (!(declarations && declarations.length)) {
	                return undefined;
	            }
	            var declaration = declarations[0];
	            // Clone name to remove leading trivia.
	            var name = ts.getSynthesizedDeepClone(ts.getNameOfDeclaration(declaration));
	            var visibilityModifier = createVisibilityModifier(ts.getModifierFlags(declaration));
	            var modifiers = visibilityModifier ? ts.createNodeArray([visibilityModifier]) : undefined;
	            var type = checker.getWidenedType(checker.getTypeOfSymbolAtLocation(symbol, enclosingDeclaration));
	            var optional = !!(symbol.flags & 16777216 /* Optional */);
	            switch (declaration.kind) {
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 150 /* PropertySignature */:
	                case 151 /* PropertyDeclaration */:
	                    var typeNode = checker.typeToTypeNode(type, enclosingDeclaration);
	                    out(ts.createProperty(
	                    /*decorators*/ undefined, modifiers, name, optional ? ts.createToken(55 /* QuestionToken */) : undefined, typeNode, 
	                    /*initializer*/ undefined));
	                    break;
	                case 152 /* MethodSignature */:
	                case 153 /* MethodDeclaration */:
	                    // The signature for the implementation appears as an entry in `signatures` iff
	                    // there is only one signature.
	                    // If there are overloads and an implementation signature, it appears as an
	                    // extra declaration that isn't a signature for `type`.
	                    // If there is more than one overload but no implementation signature
	                    // (eg: an abstract method or interface declaration), there is a 1-1
	                    // correspondence of declarations and signatures.
	                    var signatures = checker.getSignaturesOfType(type, 0 /* Call */);
	                    if (!ts.some(signatures)) {
	                        break;
	                    }
	                    if (declarations.length === 1) {
	                        ts.Debug.assert(signatures.length === 1);
	                        var signature = signatures[0];
	                        outputMethod(signature, modifiers, name, createStubbedMethodBody());
	                        break;
	                    }
	                    for (var _i = 0, signatures_8 = signatures; _i < signatures_8.length; _i++) {
	                        var signature = signatures_8[_i];
	                        // Need to ensure nodes are fresh each time so they can have different positions.
	                        outputMethod(signature, getSynthesizedDeepClones(modifiers), ts.getSynthesizedDeepClone(name));
	                    }
	                    if (declarations.length > signatures.length) {
	                        var signature = checker.getSignatureFromDeclaration(declarations[declarations.length - 1]);
	                        outputMethod(signature, modifiers, name, createStubbedMethodBody());
	                    }
	                    else {
	                        ts.Debug.assert(declarations.length === signatures.length);
	                        out(createMethodImplementingSignatures(signatures, name, optional, modifiers));
	                    }
	                    break;
	            }
	            function outputMethod(signature, modifiers, name, body) {
	                var method = signatureToMethodDeclaration(checker, signature, enclosingDeclaration, modifiers, name, optional, body);
	                if (method)
	                    out(method);
	            }
	        }
	        function signatureToMethodDeclaration(checker, signature, enclosingDeclaration, modifiers, name, optional, body) {
	            var signatureDeclaration = checker.signatureToSignatureDeclaration(signature, 153 /* MethodDeclaration */, enclosingDeclaration, 256 /* SuppressAnyReturnType */);
	            if (!signatureDeclaration) {
	                return undefined;
	            }
	            signatureDeclaration.decorators = undefined;
	            signatureDeclaration.modifiers = modifiers;
	            signatureDeclaration.name = name;
	            signatureDeclaration.questionToken = optional ? ts.createToken(55 /* QuestionToken */) : undefined;
	            signatureDeclaration.body = body;
	            return signatureDeclaration;
	        }
	        function getSynthesizedDeepClones(nodes) {
	            return nodes && ts.createNodeArray(nodes.map(ts.getSynthesizedDeepClone));
	        }
	        function createMethodFromCallExpression(_a, methodName, inJs, makeStatic) {
	            var typeArguments = _a.typeArguments, args = _a.arguments;
	            return ts.createMethod(
	            /*decorators*/ undefined, 
	            /*modifiers*/ makeStatic ? [ts.createToken(115 /* StaticKeyword */)] : undefined, 
	            /*asteriskToken*/ undefined, methodName, 
	            /*questionToken*/ undefined, 
	            /*typeParameters*/ inJs ? undefined : ts.map(typeArguments, function (_, i) {
	                return ts.createTypeParameterDeclaration(84 /* T */ + typeArguments.length - 1 <= 90 /* Z */ ? String.fromCharCode(84 /* T */ + i) : "T" + i);
	            }), 
	            /*parameters*/ createDummyParameters(args.length, /*names*/ undefined, /*minArgumentCount*/ undefined, inJs), 
	            /*type*/ inJs ? undefined : ts.createKeywordTypeNode(119 /* AnyKeyword */), createStubbedMethodBody());
	        }
	        codefix.createMethodFromCallExpression = createMethodFromCallExpression;
	        function createDummyParameters(argCount, names, minArgumentCount, inJs) {
	            var parameters = [];
	            for (var i = 0; i < argCount; i++) {
	                var newParameter = ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, 
	                /*name*/ names && names[i] || "arg" + i, 
	                /*questionToken*/ minArgumentCount !== undefined && i >= minArgumentCount ? ts.createToken(55 /* QuestionToken */) : undefined, 
	                /*type*/ inJs ? undefined : ts.createKeywordTypeNode(119 /* AnyKeyword */), 
	                /*initializer*/ undefined);
	                parameters.push(newParameter);
	            }
	            return parameters;
	        }
	        function createMethodImplementingSignatures(signatures, name, optional, modifiers) {
	            /** This is *a* signature with the maximal number of arguments,
	             * such that if there is a "maximal" signature without rest arguments,
	             * this is one of them.
	             */
	            var maxArgsSignature = signatures[0];
	            var minArgumentCount = signatures[0].minArgumentCount;
	            var someSigHasRestParameter = false;
	            for (var _i = 0, signatures_9 = signatures; _i < signatures_9.length; _i++) {
	                var sig = signatures_9[_i];
	                minArgumentCount = Math.min(sig.minArgumentCount, minArgumentCount);
	                if (sig.hasRestParameter) {
	                    someSigHasRestParameter = true;
	                }
	                if (sig.parameters.length >= maxArgsSignature.parameters.length && (!sig.hasRestParameter || maxArgsSignature.hasRestParameter)) {
	                    maxArgsSignature = sig;
	                }
	            }
	            var maxNonRestArgs = maxArgsSignature.parameters.length - (maxArgsSignature.hasRestParameter ? 1 : 0);
	            var maxArgsParameterSymbolNames = maxArgsSignature.parameters.map(function (symbol) { return symbol.name; });
	            var parameters = createDummyParameters(maxNonRestArgs, maxArgsParameterSymbolNames, minArgumentCount, /*inJs*/ false);
	            if (someSigHasRestParameter) {
	                var anyArrayType = ts.createArrayTypeNode(ts.createKeywordTypeNode(119 /* AnyKeyword */));
	                var restParameter = ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, ts.createToken(24 /* DotDotDotToken */), maxArgsParameterSymbolNames[maxNonRestArgs] || "rest", 
	                /*questionToken*/ maxNonRestArgs >= minArgumentCount ? ts.createToken(55 /* QuestionToken */) : undefined, anyArrayType, 
	                /*initializer*/ undefined);
	                parameters.push(restParameter);
	            }
	            return createStubbedMethod(modifiers, name, optional, 
	            /*typeParameters*/ undefined, parameters, 
	            /*returnType*/ undefined);
	        }
	        function createStubbedMethod(modifiers, name, optional, typeParameters, parameters, returnType) {
	            return ts.createMethod(
	            /*decorators*/ undefined, modifiers, 
	            /*asteriskToken*/ undefined, name, optional ? ts.createToken(55 /* QuestionToken */) : undefined, typeParameters, parameters, returnType, createStubbedMethodBody());
	        }
	        function createStubbedMethodBody() {
	            return ts.createBlock([ts.createThrow(ts.createNew(ts.createIdentifier("Error"), 
	                /*typeArguments*/ undefined, [ts.createLiteral("Method not implemented.")]))], 
	            /*multiline*/ true);
	        }
	        function createVisibilityModifier(flags) {
	            if (flags & 4 /* Public */) {
	                return ts.createToken(114 /* PublicKeyword */);
	            }
	            else if (flags & 16 /* Protected */) {
	                return ts.createToken(113 /* ProtectedKeyword */);
	            }
	            return undefined;
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "inferFromUsage";
	        var errorCodes = [
	            // Variable declarations
	            ts.Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code,
	            // Variable uses
	            ts.Diagnostics.Variable_0_implicitly_has_an_1_type.code,
	            // Parameter declarations
	            ts.Diagnostics.Parameter_0_implicitly_has_an_1_type.code,
	            ts.Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code,
	            // Get Accessor declarations
	            ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code,
	            ts.Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code,
	            // Set Accessor declarations
	            ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code,
	            // Property declarations
	            ts.Diagnostics.Member_0_implicitly_has_an_1_type.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (_a) {
	                var sourceFile = _a.sourceFile, program = _a.program, start = _a.span.start, errorCode = _a.errorCode, cancellationToken = _a.cancellationToken;
	                if (ts.isSourceFileJavaScript(sourceFile)) {
	                    return undefined; // TODO: GH#20113
	                }
	                var token = ts.getTokenAtPosition(sourceFile, start, /*includeJsDocComment*/ false);
	                var fix = getFix(sourceFile, token, errorCode, program, cancellationToken);
	                if (!fix)
	                    return undefined;
	                var declaration = fix.declaration, textChanges = fix.textChanges;
	                var name = ts.getNameOfDeclaration(declaration);
	                var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(getDiagnostic(errorCode, token)), [name.getText()]);
	                return [{ description: description, changes: [{ fileName: sourceFile.fileName, textChanges: textChanges }], fixId: fixId }];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var sourceFile = context.sourceFile, program = context.program, cancellationToken = context.cancellationToken;
	                var seenFunctions = ts.createMap();
	                return codefix.codeFixAllWithTextChanges(context, errorCodes, function (changes, err) {
	                    var fix = getFix(sourceFile, ts.getTokenAtPosition(err.file, err.start, /*includeJsDocComment*/ false), err.code, program, cancellationToken, seenFunctions);
	                    if (fix)
	                        changes.push.apply(changes, fix.textChanges);
	                });
	            },
	        });
	        function getDiagnostic(errorCode, token) {
	            switch (errorCode) {
	                case ts.Diagnostics.Parameter_0_implicitly_has_an_1_type.code:
	                    return ts.isSetAccessor(ts.getContainingFunction(token)) ? ts.Diagnostics.Infer_type_of_0_from_usage : ts.Diagnostics.Infer_parameter_types_from_usage;
	                case ts.Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code:
	                    return ts.Diagnostics.Infer_parameter_types_from_usage;
	                default:
	                    return ts.Diagnostics.Infer_type_of_0_from_usage;
	            }
	        }
	        function getFix(sourceFile, token, errorCode, program, cancellationToken, seenFunctions) {
	            if (!isAllowedTokenKind(token.kind)) {
	                return undefined;
	            }
	            switch (errorCode) {
	                // Variable and Property declarations
	                case ts.Diagnostics.Member_0_implicitly_has_an_1_type.code:
	                case ts.Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code:
	                    return getCodeActionForVariableDeclaration(token.parent, program, cancellationToken);
	                case ts.Diagnostics.Variable_0_implicitly_has_an_1_type.code: {
	                    var symbol = program.getTypeChecker().getSymbolAtLocation(token);
	                    return symbol && symbol.valueDeclaration && getCodeActionForVariableDeclaration(symbol.valueDeclaration, program, cancellationToken);
	                }
	            }
	            var containingFunction = ts.getContainingFunction(token);
	            if (containingFunction === undefined) {
	                return undefined;
	            }
	            switch (errorCode) {
	                // Parameter declarations
	                case ts.Diagnostics.Parameter_0_implicitly_has_an_1_type.code:
	                    if (ts.isSetAccessor(containingFunction)) {
	                        return getCodeActionForSetAccessor(containingFunction, program, cancellationToken);
	                    }
	                // falls through
	                case ts.Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code:
	                    return !seenFunctions || ts.addToSeen(seenFunctions, ts.getNodeId(containingFunction))
	                        ? getCodeActionForParameters(ts.cast(token.parent, ts.isParameter), containingFunction, sourceFile, program, cancellationToken)
	                        : undefined;
	                // Get Accessor declarations
	                case ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code:
	                case ts.Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code:
	                    return ts.isGetAccessor(containingFunction) ? getCodeActionForGetAccessor(containingFunction, sourceFile, program, cancellationToken) : undefined;
	                // Set Accessor declarations
	                case ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code:
	                    return ts.isSetAccessor(containingFunction) ? getCodeActionForSetAccessor(containingFunction, program, cancellationToken) : undefined;
	                default:
	                    throw ts.Debug.fail(String(errorCode));
	            }
	        }
	        function isAllowedTokenKind(kind) {
	            switch (kind) {
	                case 71 /* Identifier */:
	                case 24 /* DotDotDotToken */:
	                case 114 /* PublicKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function getCodeActionForVariableDeclaration(declaration, program, cancellationToken) {
	            if (!ts.isIdentifier(declaration.name))
	                return undefined;
	            var type = inferTypeForVariableFromUsage(declaration.name, program, cancellationToken);
	            return makeFix(declaration, declaration.name.getEnd(), type, program);
	        }
	        function isApplicableFunctionForInference(declaration) {
	            switch (declaration.kind) {
	                case 232 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 154 /* Constructor */:
	                    return true;
	                case 190 /* FunctionExpression */:
	                    return !!declaration.name;
	            }
	            return false;
	        }
	        function getCodeActionForParameters(parameterDeclaration, containingFunction, sourceFile, program, cancellationToken) {
	            if (!ts.isIdentifier(parameterDeclaration.name) || !isApplicableFunctionForInference(containingFunction)) {
	                return undefined;
	            }
	            var types = inferTypeForParametersFromUsage(containingFunction, sourceFile, program, cancellationToken) ||
	                containingFunction.parameters.map(function (p) { return ts.isIdentifier(p.name) ? inferTypeForVariableFromUsage(p.name, program, cancellationToken) : undefined; });
	            if (!types)
	                return undefined;
	            // We didn't actually find a set of type inference positions matching each parameter position
	            if (containingFunction.parameters.length !== types.length) {
	                return undefined;
	            }
	            var textChanges = ts.arrayFrom(ts.mapDefinedIterator(ts.zipToIterator(containingFunction.parameters, types), function (_a) {
	                var parameter = _a[0], type = _a[1];
	                return type && !parameter.type && !parameter.initializer ? makeChange(containingFunction, parameter.end, type, program) : undefined;
	            }));
	            return textChanges.length ? { declaration: parameterDeclaration, textChanges: textChanges } : undefined;
	        }
	        function getCodeActionForSetAccessor(setAccessorDeclaration, program, cancellationToken) {
	            var setAccessorParameter = setAccessorDeclaration.parameters[0];
	            if (!setAccessorParameter || !ts.isIdentifier(setAccessorDeclaration.name) || !ts.isIdentifier(setAccessorParameter.name)) {
	                return undefined;
	            }
	            var type = inferTypeForVariableFromUsage(setAccessorDeclaration.name, program, cancellationToken) ||
	                inferTypeForVariableFromUsage(setAccessorParameter.name, program, cancellationToken);
	            return makeFix(setAccessorParameter, setAccessorParameter.name.getEnd(), type, program);
	        }
	        function getCodeActionForGetAccessor(getAccessorDeclaration, sourceFile, program, cancellationToken) {
	            if (!ts.isIdentifier(getAccessorDeclaration.name)) {
	                return undefined;
	            }
	            var type = inferTypeForVariableFromUsage(getAccessorDeclaration.name, program, cancellationToken);
	            var closeParenToken = ts.findChildOfKind(getAccessorDeclaration, 20 /* CloseParenToken */, sourceFile);
	            return makeFix(getAccessorDeclaration, closeParenToken.getEnd(), type, program);
	        }
	        function makeFix(declaration, start, type, program) {
	            return type && { declaration: declaration, textChanges: [makeChange(declaration, start, type, program)] };
	        }
	        function makeChange(declaration, start, type, program) {
	            var typeString = type && typeToString(type, declaration, program.getTypeChecker());
	            return typeString === undefined ? undefined : ts.createTextChangeFromStartLength(start, 0, ": " + typeString);
	        }
	        function getReferences(token, program, cancellationToken) {
	            // Position shouldn't matter since token is not a SourceFile.
	            return ts.mapDefined(ts.FindAllReferences.getReferenceEntriesForNode(-1, token, program, program.getSourceFiles(), cancellationToken), function (entry) {
	                return entry.type === "node" ? ts.tryCast(entry.node, ts.isIdentifier) : undefined;
	            });
	        }
	        function inferTypeForVariableFromUsage(token, program, cancellationToken) {
	            return InferFromReference.inferTypeFromReferences(getReferences(token, program, cancellationToken), program.getTypeChecker(), cancellationToken);
	        }
	        function inferTypeForParametersFromUsage(containingFunction, sourceFile, program, cancellationToken) {
	            switch (containingFunction.kind) {
	                case 154 /* Constructor */:
	                case 190 /* FunctionExpression */:
	                case 232 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                    var isConstructor = containingFunction.kind === 154 /* Constructor */;
	                    var searchToken = isConstructor ?
	                        ts.findChildOfKind(containingFunction, 123 /* ConstructorKeyword */, sourceFile) :
	                        containingFunction.name;
	                    if (searchToken) {
	                        return InferFromReference.inferTypeForParametersFromReferences(getReferences(searchToken, program, cancellationToken), containingFunction, program.getTypeChecker(), cancellationToken);
	                    }
	            }
	        }
	        function getTypeAccessiblityWriter(checker) {
	            var str = "";
	            var typeIsAccessible = true;
	            var writeText = function (text) { return str += text; };
	            return {
	                getText: function () { return typeIsAccessible ? str : undefined; },
	                writeKeyword: writeText,
	                writeOperator: writeText,
	                writePunctuation: writeText,
	                writeSpace: writeText,
	                writeStringLiteral: writeText,
	                writeParameter: writeText,
	                writeProperty: writeText,
	                writeSymbol: writeText,
	                write: writeText,
	                writeTextOfNode: writeText,
	                rawWrite: writeText,
	                writeLiteral: writeText,
	                getTextPos: function () { return 0; },
	                getLine: function () { return 0; },
	                getColumn: function () { return 0; },
	                getIndent: function () { return 0; },
	                isAtStartOfLine: function () { return false; },
	                writeLine: function () { return writeText(" "); },
	                increaseIndent: ts.noop,
	                decreaseIndent: ts.noop,
	                clear: function () { str = ""; typeIsAccessible = true; },
	                trackSymbol: function (symbol, declaration, meaning) {
	                    if (checker.isSymbolAccessible(symbol, declaration, meaning, /*shouldComputeAliasToMarkVisible*/ false).accessibility !== 0 /* Accessible */) {
	                        typeIsAccessible = false;
	                    }
	                },
	                reportInaccessibleThisError: function () { typeIsAccessible = false; },
	                reportPrivateInBaseOfClassExpression: function () { typeIsAccessible = false; },
	                reportInaccessibleUniqueSymbolError: function () { typeIsAccessible = false; }
	            };
	        }
	        function typeToString(type, enclosingDeclaration, checker) {
	            var writer = getTypeAccessiblityWriter(checker);
	            checker.writeType(type, enclosingDeclaration, /*flags*/ undefined, writer);
	            return writer.getText();
	        }
	        var InferFromReference;
	        (function (InferFromReference) {
	            function inferTypeFromReferences(references, checker, cancellationToken) {
	                var usageContext = {};
	                for (var _i = 0, references_1 = references; _i < references_1.length; _i++) {
	                    var reference = references_1[_i];
	                    cancellationToken.throwIfCancellationRequested();
	                    inferTypeFromContext(reference, checker, usageContext);
	                }
	                return getTypeFromUsageContext(usageContext, checker);
	            }
	            InferFromReference.inferTypeFromReferences = inferTypeFromReferences;
	            function inferTypeForParametersFromReferences(references, declaration, checker, cancellationToken) {
	                if (references.length === 0) {
	                    return undefined;
	                }
	                if (!declaration.parameters) {
	                    return undefined;
	                }
	                var usageContext = {};
	                for (var _i = 0, references_2 = references; _i < references_2.length; _i++) {
	                    var reference = references_2[_i];
	                    cancellationToken.throwIfCancellationRequested();
	                    inferTypeFromContext(reference, checker, usageContext);
	                }
	                var isConstructor = declaration.kind === 154 /* Constructor */;
	                var callContexts = isConstructor ? usageContext.constructContexts : usageContext.callContexts;
	                return callContexts && declaration.parameters.map(function (parameter, parameterIndex) {
	                    var types = [];
	                    var isRestParameter = ts.isRestParameter(parameter);
	                    for (var _i = 0, callContexts_1 = callContexts; _i < callContexts_1.length; _i++) {
	                        var callContext = callContexts_1[_i];
	                        if (callContext.argumentTypes.length <= parameterIndex) {
	                            continue;
	                        }
	                        if (isRestParameter) {
	                            for (var i = parameterIndex; i < callContext.argumentTypes.length; i++) {
	                                types.push(checker.getBaseTypeOfLiteralType(callContext.argumentTypes[i]));
	                            }
	                        }
	                        else {
	                            types.push(checker.getBaseTypeOfLiteralType(callContext.argumentTypes[parameterIndex]));
	                        }
	                    }
	                    if (!types.length) {
	                        return undefined;
	                    }
	                    var type = checker.getWidenedType(checker.getUnionType(types, 2 /* Subtype */));
	                    return isRestParameter ? checker.createArrayType(type) : type;
	                });
	            }
	            InferFromReference.inferTypeForParametersFromReferences = inferTypeForParametersFromReferences;
	            function inferTypeFromContext(node, checker, usageContext) {
	                while (ts.isRightSideOfQualifiedNameOrPropertyAccess(node)) {
	                    node = node.parent;
	                }
	                switch (node.parent.kind) {
	                    case 197 /* PostfixUnaryExpression */:
	                        usageContext.isNumber = true;
	                        break;
	                    case 196 /* PrefixUnaryExpression */:
	                        inferTypeFromPrefixUnaryExpressionContext(node.parent, usageContext);
	                        break;
	                    case 198 /* BinaryExpression */:
	                        inferTypeFromBinaryExpressionContext(node, node.parent, checker, usageContext);
	                        break;
	                    case 264 /* CaseClause */:
	                    case 265 /* DefaultClause */:
	                        inferTypeFromSwitchStatementLabelContext(node.parent, checker, usageContext);
	                        break;
	                    case 185 /* CallExpression */:
	                    case 186 /* NewExpression */:
	                        if (node.parent.expression === node) {
	                            inferTypeFromCallExpressionContext(node.parent, checker, usageContext);
	                        }
	                        else {
	                            inferTypeFromContextualType(node, checker, usageContext);
	                        }
	                        break;
	                    case 183 /* PropertyAccessExpression */:
	                        inferTypeFromPropertyAccessExpressionContext(node.parent, checker, usageContext);
	                        break;
	                    case 184 /* ElementAccessExpression */:
	                        inferTypeFromPropertyElementExpressionContext(node.parent, node, checker, usageContext);
	                        break;
	                    default:
	                        return inferTypeFromContextualType(node, checker, usageContext);
	                }
	            }
	            function inferTypeFromContextualType(node, checker, usageContext) {
	                if (ts.isExpressionNode(node)) {
	                    addCandidateType(usageContext, checker.getContextualType(node));
	                }
	            }
	            function inferTypeFromPrefixUnaryExpressionContext(node, usageContext) {
	                switch (node.operator) {
	                    case 43 /* PlusPlusToken */:
	                    case 44 /* MinusMinusToken */:
	                    case 38 /* MinusToken */:
	                    case 52 /* TildeToken */:
	                        usageContext.isNumber = true;
	                        break;
	                    case 37 /* PlusToken */:
	                        usageContext.isNumberOrString = true;
	                        break;
	                }
	            }
	            function inferTypeFromBinaryExpressionContext(node, parent, checker, usageContext) {
	                switch (parent.operatorToken.kind) {
	                    // ExponentiationOperator
	                    case 40 /* AsteriskAsteriskToken */:
	                    // MultiplicativeOperator
	                    case 39 /* AsteriskToken */:
	                    case 41 /* SlashToken */:
	                    case 42 /* PercentToken */:
	                    // ShiftOperator
	                    case 45 /* LessThanLessThanToken */:
	                    case 46 /* GreaterThanGreaterThanToken */:
	                    case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                    // BitwiseOperator
	                    case 48 /* AmpersandToken */:
	                    case 49 /* BarToken */:
	                    case 50 /* CaretToken */:
	                    // CompoundAssignmentOperator
	                    case 60 /* MinusEqualsToken */:
	                    case 62 /* AsteriskAsteriskEqualsToken */:
	                    case 61 /* AsteriskEqualsToken */:
	                    case 63 /* SlashEqualsToken */:
	                    case 64 /* PercentEqualsToken */:
	                    case 68 /* AmpersandEqualsToken */:
	                    case 69 /* BarEqualsToken */:
	                    case 70 /* CaretEqualsToken */:
	                    case 65 /* LessThanLessThanEqualsToken */:
	                    case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                    case 66 /* GreaterThanGreaterThanEqualsToken */:
	                    // AdditiveOperator
	                    case 38 /* MinusToken */:
	                    // RelationalOperator
	                    case 27 /* LessThanToken */:
	                    case 30 /* LessThanEqualsToken */:
	                    case 29 /* GreaterThanToken */:
	                    case 31 /* GreaterThanEqualsToken */:
	                        var operandType = checker.getTypeAtLocation(parent.left === node ? parent.right : parent.left);
	                        if (operandType.flags & 272 /* EnumLike */) {
	                            addCandidateType(usageContext, operandType);
	                        }
	                        else {
	                            usageContext.isNumber = true;
	                        }
	                        break;
	                    case 59 /* PlusEqualsToken */:
	                    case 37 /* PlusToken */:
	                        var otherOperandType = checker.getTypeAtLocation(parent.left === node ? parent.right : parent.left);
	                        if (otherOperandType.flags & 272 /* EnumLike */) {
	                            addCandidateType(usageContext, otherOperandType);
	                        }
	                        else if (otherOperandType.flags & 84 /* NumberLike */) {
	                            usageContext.isNumber = true;
	                        }
	                        else if (otherOperandType.flags & 524322 /* StringLike */) {
	                            usageContext.isString = true;
	                        }
	                        else {
	                            usageContext.isNumberOrString = true;
	                        }
	                        break;
	                    //  AssignmentOperators
	                    case 58 /* EqualsToken */:
	                    case 32 /* EqualsEqualsToken */:
	                    case 34 /* EqualsEqualsEqualsToken */:
	                    case 35 /* ExclamationEqualsEqualsToken */:
	                    case 33 /* ExclamationEqualsToken */:
	                        addCandidateType(usageContext, checker.getTypeAtLocation(parent.left === node ? parent.right : parent.left));
	                        break;
	                    case 92 /* InKeyword */:
	                        if (node === parent.left) {
	                            usageContext.isString = true;
	                        }
	                        break;
	                    // LogicalOperator
	                    case 54 /* BarBarToken */:
	                        if (node === parent.left &&
	                            (node.parent.parent.kind === 230 /* VariableDeclaration */ || ts.isAssignmentExpression(node.parent.parent, /*excludeCompoundAssignment*/ true))) {
	                            // var x = x || {};
	                            // TODO: use getFalsyflagsOfType
	                            addCandidateType(usageContext, checker.getTypeAtLocation(parent.right));
	                        }
	                        break;
	                    case 53 /* AmpersandAmpersandToken */:
	                    case 26 /* CommaToken */:
	                    case 93 /* InstanceOfKeyword */:
	                        // nothing to infer here
	                        break;
	                }
	            }
	            function inferTypeFromSwitchStatementLabelContext(parent, checker, usageContext) {
	                addCandidateType(usageContext, checker.getTypeAtLocation(parent.parent.parent.expression));
	            }
	            function inferTypeFromCallExpressionContext(parent, checker, usageContext) {
	                var callContext = {
	                    argumentTypes: [],
	                    returnType: {}
	                };
	                if (parent.arguments) {
	                    for (var _i = 0, _a = parent.arguments; _i < _a.length; _i++) {
	                        var argument = _a[_i];
	                        callContext.argumentTypes.push(checker.getTypeAtLocation(argument));
	                    }
	                }
	                inferTypeFromContext(parent, checker, callContext.returnType);
	                if (parent.kind === 185 /* CallExpression */) {
	                    (usageContext.callContexts || (usageContext.callContexts = [])).push(callContext);
	                }
	                else {
	                    (usageContext.constructContexts || (usageContext.constructContexts = [])).push(callContext);
	                }
	            }
	            function inferTypeFromPropertyAccessExpressionContext(parent, checker, usageContext) {
	                var name = ts.escapeLeadingUnderscores(parent.name.text);
	                if (!usageContext.properties) {
	                    usageContext.properties = ts.createUnderscoreEscapedMap();
	                }
	                var propertyUsageContext = usageContext.properties.get(name) || {};
	                inferTypeFromContext(parent, checker, propertyUsageContext);
	                usageContext.properties.set(name, propertyUsageContext);
	            }
	            function inferTypeFromPropertyElementExpressionContext(parent, node, checker, usageContext) {
	                if (node === parent.argumentExpression) {
	                    usageContext.isNumberOrString = true;
	                    return;
	                }
	                else {
	                    var indexType = checker.getTypeAtLocation(parent);
	                    var indexUsageContext = {};
	                    inferTypeFromContext(parent, checker, indexUsageContext);
	                    if (indexType.flags & 84 /* NumberLike */) {
	                        usageContext.numberIndexContext = indexUsageContext;
	                    }
	                    else {
	                        usageContext.stringIndexContext = indexUsageContext;
	                    }
	                }
	            }
	            function getTypeFromUsageContext(usageContext, checker) {
	                if (usageContext.isNumberOrString && !usageContext.isNumber && !usageContext.isString) {
	                    return checker.getUnionType([checker.getNumberType(), checker.getStringType()]);
	                }
	                else if (usageContext.isNumber) {
	                    return checker.getNumberType();
	                }
	                else if (usageContext.isString) {
	                    return checker.getStringType();
	                }
	                else if (usageContext.candidateTypes) {
	                    return checker.getWidenedType(checker.getUnionType(ts.map(usageContext.candidateTypes, function (t) { return checker.getBaseTypeOfLiteralType(t); }), 2 /* Subtype */));
	                }
	                else if (usageContext.properties && hasCallContext(usageContext.properties.get("then"))) {
	                    var paramType = getParameterTypeFromCallContexts(0, usageContext.properties.get("then").callContexts, /*isRestParameter*/ false, checker);
	                    var types = paramType.getCallSignatures().map(function (c) { return c.getReturnType(); });
	                    return checker.createPromiseType(types.length ? checker.getUnionType(types, 2 /* Subtype */) : checker.getAnyType());
	                }
	                else if (usageContext.properties && hasCallContext(usageContext.properties.get("push"))) {
	                    return checker.createArrayType(getParameterTypeFromCallContexts(0, usageContext.properties.get("push").callContexts, /*isRestParameter*/ false, checker));
	                }
	                else if (usageContext.properties || usageContext.callContexts || usageContext.constructContexts || usageContext.numberIndexContext || usageContext.stringIndexContext) {
	                    var members_5 = ts.createUnderscoreEscapedMap();
	                    var callSignatures = [];
	                    var constructSignatures = [];
	                    var stringIndexInfo = void 0;
	                    var numberIndexInfo = void 0;
	                    if (usageContext.properties) {
	                        usageContext.properties.forEach(function (context, name) {
	                            var symbol = checker.createSymbol(4 /* Property */, name);
	                            symbol.type = getTypeFromUsageContext(context, checker) || checker.getAnyType();
	                            members_5.set(name, symbol);
	                        });
	                    }
	                    if (usageContext.callContexts) {
	                        for (var _i = 0, _a = usageContext.callContexts; _i < _a.length; _i++) {
	                            var callContext = _a[_i];
	                            callSignatures.push(getSignatureFromCallContext(callContext, checker));
	                        }
	                    }
	                    if (usageContext.constructContexts) {
	                        for (var _b = 0, _c = usageContext.constructContexts; _b < _c.length; _b++) {
	                            var constructContext = _c[_b];
	                            constructSignatures.push(getSignatureFromCallContext(constructContext, checker));
	                        }
	                    }
	                    if (usageContext.numberIndexContext) {
	                        numberIndexInfo = checker.createIndexInfo(getTypeFromUsageContext(usageContext.numberIndexContext, checker), /*isReadonly*/ false);
	                    }
	                    if (usageContext.stringIndexContext) {
	                        stringIndexInfo = checker.createIndexInfo(getTypeFromUsageContext(usageContext.stringIndexContext, checker), /*isReadonly*/ false);
	                    }
	                    return checker.createAnonymousType(/*symbol*/ undefined, members_5, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	                }
	                else {
	                    return undefined;
	                }
	            }
	            function getParameterTypeFromCallContexts(parameterIndex, callContexts, isRestParameter, checker) {
	                var types = [];
	                if (callContexts) {
	                    for (var _i = 0, callContexts_2 = callContexts; _i < callContexts_2.length; _i++) {
	                        var callContext = callContexts_2[_i];
	                        if (callContext.argumentTypes.length > parameterIndex) {
	                            if (isRestParameter) {
	                                types = ts.concatenate(types, ts.map(callContext.argumentTypes.slice(parameterIndex), function (a) { return checker.getBaseTypeOfLiteralType(a); }));
	                            }
	                            else {
	                                types.push(checker.getBaseTypeOfLiteralType(callContext.argumentTypes[parameterIndex]));
	                            }
	                        }
	                    }
	                }
	                if (types.length) {
	                    var type = checker.getWidenedType(checker.getUnionType(types, 2 /* Subtype */));
	                    return isRestParameter ? checker.createArrayType(type) : type;
	                }
	                return undefined;
	            }
	            function getSignatureFromCallContext(callContext, checker) {
	                var parameters = [];
	                for (var i = 0; i < callContext.argumentTypes.length; i++) {
	                    var symbol = checker.createSymbol(1 /* FunctionScopedVariable */, ts.escapeLeadingUnderscores("arg" + i));
	                    symbol.type = checker.getWidenedType(checker.getBaseTypeOfLiteralType(callContext.argumentTypes[i]));
	                    parameters.push(symbol);
	                }
	                var returnType = getTypeFromUsageContext(callContext.returnType, checker) || checker.getVoidType();
	                return checker.createSignature(/*declaration*/ undefined, /*typeParameters*/ undefined, /*thisParameter*/ undefined, parameters, returnType, /*typePredicate*/ undefined, callContext.argumentTypes.length, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	            }
	            function addCandidateType(context, type) {
	                if (type && !(type.flags & 1 /* Any */) && !(type.flags & 16384 /* Never */)) {
	                    (context.candidateTypes || (context.candidateTypes = [])).push(type);
	                }
	            }
	            function hasCallContext(usageContext) {
	                return usageContext && usageContext.callContexts;
	            }
	        })(InferFromReference || (InferFromReference = {}));
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        codefix.registerCodeFix({
	            errorCodes: [ts.Diagnostics.A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime.code],
	            getCodeActions: getActionsForInvalidImport
	        });
	        function getActionsForInvalidImport(context) {
	            var sourceFile = context.sourceFile;
	            // This is the whole import statement, eg:
	            // import * as Bluebird from 'bluebird';
	            // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	            var node = ts.getTokenAtPosition(sourceFile, context.span.start, /*includeJsDocComment*/ false).parent;
	            if (!ts.isImportDeclaration(node)) {
	                // No import quick fix for import calls
	                return [];
	            }
	            return getCodeFixesForImportDeclaration(context, node);
	        }
	        function getCodeFixesForImportDeclaration(context, node) {
	            var sourceFile = ts.getSourceFileOfNode(node);
	            var namespace = ts.getNamespaceDeclarationNode(node);
	            var opts = context.program.getCompilerOptions();
	            var variations = [];
	            // import Bluebird from "bluebird";
	            variations.push(createAction(context, sourceFile, node, ts.createImportDeclaration(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, ts.createImportClause(namespace.name, /*namedBindings*/ undefined), node.moduleSpecifier)));
	            if (ts.getEmitModuleKind(opts) === ts.ModuleKind.CommonJS) {
	                // import Bluebird = require("bluebird");
	                variations.push(createAction(context, sourceFile, node, ts.createImportEqualsDeclaration(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, namespace.name, ts.createExternalModuleReference(node.moduleSpecifier))));
	            }
	            return variations;
	        }
	        function createAction(context, sourceFile, node, replacement) {
	            // TODO: GH#21246 Should be able to use `replaceNode`, but be sure to preserve comments (see `codeFixCalledES2015Import11.ts`)
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return t.replaceRange(sourceFile, { pos: node.getStart(), end: node.end }, replacement); });
	            return {
	                description: ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Replace_import_with_0), [changes[0].textChanges[0].newText]),
	                changes: changes,
	            };
	        }
	        codefix.registerCodeFix({
	            errorCodes: [
	                ts.Diagnostics.Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures.code,
	                ts.Diagnostics.Cannot_use_new_with_an_expression_whose_type_lacks_a_call_or_construct_signature.code,
	            ],
	            getCodeActions: getActionsForUsageOfInvalidImport
	        });
	        function getActionsForUsageOfInvalidImport(context) {
	            var sourceFile = context.sourceFile;
	            var targetKind = ts.Diagnostics.Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures.code === context.errorCode ? 185 /* CallExpression */ : 186 /* NewExpression */;
	            var node = ts.findAncestor(ts.getTokenAtPosition(sourceFile, context.span.start, /*includeJsDocComment*/ false), function (a) { return a.kind === targetKind && a.getStart() === context.span.start && a.getEnd() === (context.span.start + context.span.length); });
	            if (!node) {
	                return [];
	            }
	            var expr = node.expression;
	            var type = context.program.getTypeChecker().getTypeAtLocation(expr);
	            if (!(type.symbol && type.symbol.originatingImport)) {
	                return [];
	            }
	            var fixes = [];
	            var relatedImport = type.symbol.originatingImport;
	            if (!ts.isImportCall(relatedImport)) {
	                ts.addRange(fixes, getCodeFixesForImportDeclaration(context, relatedImport));
	            }
	            fixes.push({
	                description: ts.getLocaleSpecificMessage(ts.Diagnostics.Use_synthetic_default_member),
	                changes: ts.textChanges.ChangeTracker.with(context, function (t) { return t.replaceNode(sourceFile, expr, ts.createPropertyAccess(expr, "default"), {}); }),
	            });
	            return fixes;
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixIdAddDefiniteAssignmentAssertions = "addMissingPropertyDefiniteAssignmentAssertions";
	        var fixIdAddUndefinedType = "addMissingPropertyUndefinedType";
	        var fixIdAddInitializer = "addMissingPropertyInitializer";
	        var errorCodes = [ts.Diagnostics.Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var propertyDeclaration = getPropertyDeclaration(context.sourceFile, context.span.start);
	                if (!propertyDeclaration)
	                    return;
	                var newLineCharacter = ts.getNewLineOrDefaultFromHost(context.host, context.formatContext.options);
	                var result = [
	                    getActionForAddMissingUndefinedType(context, propertyDeclaration),
	                    getActionForAddMissingDefiniteAssignmentAssertion(context, propertyDeclaration, newLineCharacter)
	                ];
	                ts.append(result, getActionForAddMissingInitializer(context, propertyDeclaration, newLineCharacter));
	                return result;
	            },
	            fixIds: [fixIdAddDefiniteAssignmentAssertions, fixIdAddUndefinedType, fixIdAddInitializer],
	            getAllCodeActions: function (context) {
	                var newLineCharacter = ts.getNewLineOrDefaultFromHost(context.host, context.formatContext.options);
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var propertyDeclaration = getPropertyDeclaration(diag.file, diag.start);
	                    if (!propertyDeclaration)
	                        return;
	                    switch (context.fixId) {
	                        case fixIdAddDefiniteAssignmentAssertions:
	                            addDefiniteAssignmentAssertion(changes, diag.file, propertyDeclaration, newLineCharacter);
	                            break;
	                        case fixIdAddUndefinedType:
	                            addUndefinedType(changes, diag.file, propertyDeclaration);
	                            break;
	                        case fixIdAddInitializer:
	                            var checker = context.program.getTypeChecker();
	                            var initializer = getInitializer(checker, propertyDeclaration);
	                            if (!initializer)
	                                return;
	                            addInitializer(changes, diag.file, propertyDeclaration, initializer, newLineCharacter);
	                            break;
	                        default:
	                            ts.Debug.fail(JSON.stringify(context.fixId));
	                    }
	                });
	            },
	        });
	        function getPropertyDeclaration(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            return ts.isIdentifier(token) ? ts.cast(token.parent, ts.isPropertyDeclaration) : undefined;
	        }
	        function getActionForAddMissingDefiniteAssignmentAssertion(context, propertyDeclaration, newLineCharacter) {
	            var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Add_definite_assignment_assertion_to_property_0), [propertyDeclaration.getText()]);
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addDefiniteAssignmentAssertion(t, context.sourceFile, propertyDeclaration, newLineCharacter); });
	            return { description: description, changes: changes, fixId: fixIdAddDefiniteAssignmentAssertions };
	        }
	        function addDefiniteAssignmentAssertion(changeTracker, propertyDeclarationSourceFile, propertyDeclaration, newLineCharacter) {
	            var property = ts.updateProperty(propertyDeclaration, propertyDeclaration.decorators, propertyDeclaration.modifiers, propertyDeclaration.name, ts.createToken(51 /* ExclamationToken */), propertyDeclaration.type, propertyDeclaration.initializer);
	            changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration, property, { suffix: newLineCharacter });
	        }
	        function getActionForAddMissingUndefinedType(context, propertyDeclaration) {
	            var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Add_undefined_type_to_property_0), [propertyDeclaration.name.getText()]);
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addUndefinedType(t, context.sourceFile, propertyDeclaration); });
	            return { description: description, changes: changes, fixId: fixIdAddUndefinedType };
	        }
	        function addUndefinedType(changeTracker, propertyDeclarationSourceFile, propertyDeclaration) {
	            var undefinedTypeNode = ts.createKeywordTypeNode(140 /* UndefinedKeyword */);
	            var types = ts.isUnionTypeNode(propertyDeclaration.type) ? propertyDeclaration.type.types.concat(undefinedTypeNode) : [propertyDeclaration.type, undefinedTypeNode];
	            changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration.type, ts.createUnionTypeNode(types));
	        }
	        function getActionForAddMissingInitializer(context, propertyDeclaration, newLineCharacter) {
	            var checker = context.program.getTypeChecker();
	            var initializer = getInitializer(checker, propertyDeclaration);
	            if (!initializer)
	                return undefined;
	            var description = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Add_initializer_to_property_0), [propertyDeclaration.name.getText()]);
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addInitializer(t, context.sourceFile, propertyDeclaration, initializer, newLineCharacter); });
	            return { description: description, changes: changes, fixId: fixIdAddInitializer };
	        }
	        function addInitializer(changeTracker, propertyDeclarationSourceFile, propertyDeclaration, initializer, newLineCharacter) {
	            var property = ts.updateProperty(propertyDeclaration, propertyDeclaration.decorators, propertyDeclaration.modifiers, propertyDeclaration.name, propertyDeclaration.questionToken, propertyDeclaration.type, initializer);
	            changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration, property, { suffix: newLineCharacter });
	        }
	        function getInitializer(checker, propertyDeclaration) {
	            return getDefaultValueFromType(checker, checker.getTypeFromTypeNode(propertyDeclaration.type));
	        }
	        function getDefaultValueFromType(checker, type) {
	            if (type.flags & 2 /* String */) {
	                return ts.createLiteral("");
	            }
	            else if (type.flags & 4 /* Number */) {
	                return ts.createNumericLiteral("0");
	            }
	            else if (type.flags & 8 /* Boolean */) {
	                return ts.createFalse();
	            }
	            else if (type.flags & 224 /* Literal */) {
	                return ts.createLiteral(type.value);
	            }
	            else if (type.flags & 131072 /* Union */) {
	                return ts.firstDefined(type.types, function (t) { return getDefaultValueFromType(checker, t); });
	            }
	            else if (ts.getObjectFlags(type) & 1 /* Class */) {
	                var classDeclaration = ts.getClassLikeDeclarationOfSymbol(type.symbol);
	                if (!classDeclaration || ts.hasModifier(classDeclaration, 128 /* Abstract */))
	                    return undefined;
	                var constructorDeclaration = ts.find(classDeclaration.members, function (m) { return ts.isConstructorDeclaration(m) && !!m.body; });
	                if (constructorDeclaration && constructorDeclaration.parameters.length)
	                    return undefined;
	                return ts.createNew(ts.createIdentifier(type.symbol.name), /*typeArguments*/ undefined, /*argumentsArray*/ undefined);
	            }
	            return undefined;
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/// <reference path="addMissingInvocationForDecorator.ts" />
	/// <reference path="correctQualifiedNameToIndexedAccessType.ts" />
	/// <reference path="fixClassIncorrectlyImplementsInterface.ts" />
	/// <reference path="fixAddMissingMember.ts" />
	/// <reference path="fixSpelling.ts" />
	/// <reference path="fixCannotFindModule.ts" />
	/// <reference path="fixClassDoesntImplementInheritedAbstractMember.ts" />
	/// <reference path="fixClassSuperMustPrecedeThisAccess.ts" />
	/// <reference path="fixConstructorForDerivedNeedSuperCall.ts" />
	/// <reference path="fixExtendsInterfaceBecomesImplements.ts" />
	/// <reference path="fixForgottenThisPropertyAccess.ts" />
	/// <reference path='fixUnusedIdentifier.ts' />
	/// <reference path='fixJSDocTypes.ts' />
	/// <reference path='fixAwaitInSyncFunction.ts' />
	/// <reference path='importFixes.ts' />
	/// <reference path='disableJsDiagnostics.ts' />
	/// <reference path='helpers.ts' />
	/// <reference path='inferFromUsage.ts' />
	/// <reference path="fixInvalidImportSyntax.ts" />
	/// <reference path="fixStrictClassInitialization.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var annotateWithTypeFromJSDoc;
	        (function (annotateWithTypeFromJSDoc) {
	            var refactorName = "Annotate with type from JSDoc";
	            var actionName = "annotate";
	            var description = ts.Diagnostics.Annotate_with_type_from_JSDoc.message;
	            refactor.registerRefactor(refactorName, { getEditsForAction: getEditsForAction, getAvailableActions: getAvailableActions });
	            function getAvailableActions(context) {
	                if (ts.isInJavaScriptFile(context.file)) {
	                    return undefined;
	                }
	                var node = ts.getTokenAtPosition(context.file, context.startPosition, /*includeJsDocComment*/ false);
	                if (hasUsableJSDoc(ts.findAncestor(node, isDeclarationWithType))) {
	                    return [{
	                            name: refactorName,
	                            description: description,
	                            actions: [
	                                {
	                                    description: description,
	                                    name: actionName
	                                }
	                            ]
	                        }];
	                }
	            }
	            function hasUsableJSDoc(decl) {
	                if (!decl) {
	                    return false;
	                }
	                if (ts.isFunctionLikeDeclaration(decl)) {
	                    return decl.parameters.some(hasUsableJSDoc) || (!decl.type && !!ts.getJSDocReturnType(decl));
	                }
	                return !decl.type && !!ts.getJSDocType(decl);
	            }
	            function getEditsForAction(context, action) {
	                if (actionName !== action) {
	                    return ts.Debug.fail("actionName !== action: " + actionName + " !== " + action);
	                }
	                var node = ts.getTokenAtPosition(context.file, context.startPosition, /*includeJsDocComment*/ false);
	                var decl = ts.findAncestor(node, isDeclarationWithType);
	                if (!decl || decl.type) {
	                    return undefined;
	                }
	                var jsdocType = ts.getJSDocType(decl);
	                var isFunctionWithJSDoc = ts.isFunctionLikeDeclaration(decl) && (ts.getJSDocReturnType(decl) || decl.parameters.some(function (p) { return !!ts.getJSDocType(p); }));
	                if (isFunctionWithJSDoc || jsdocType && decl.kind === 148 /* Parameter */) {
	                    return getEditsForFunctionAnnotation(context);
	                }
	                else if (jsdocType) {
	                    return getEditsForAnnotation(context);
	                }
	                else {
	                    ts.Debug.assert(!!refactor, "No applicable refactor found.");
	                }
	            }
	            function getEditsForAnnotation(context) {
	                var sourceFile = context.file;
	                var token = ts.getTokenAtPosition(sourceFile, context.startPosition, /*includeJsDocComment*/ false);
	                var decl = ts.findAncestor(token, isDeclarationWithType);
	                var jsdocType = ts.getJSDocType(decl);
	                if (!decl || !jsdocType || decl.type) {
	                    return ts.Debug.fail("!decl || !jsdocType || decl.type: !" + decl + " || !" + jsdocType + " || " + decl.type);
	                }
	                var changeTracker = ts.textChanges.ChangeTracker.fromContext(context);
	                var declarationWithType = addType(decl, transformJSDocType(jsdocType));
	                ts.suppressLeadingAndTrailingTrivia(declarationWithType);
	                changeTracker.replaceNode(sourceFile, decl, declarationWithType, ts.textChanges.useNonAdjustedPositions);
	                return {
	                    edits: changeTracker.getChanges(),
	                    renameFilename: undefined,
	                    renameLocation: undefined
	                };
	            }
	            function getEditsForFunctionAnnotation(context) {
	                var sourceFile = context.file;
	                var token = ts.getTokenAtPosition(sourceFile, context.startPosition, /*includeJsDocComment*/ false);
	                var decl = ts.findAncestor(token, ts.isFunctionLikeDeclaration);
	                var changeTracker = ts.textChanges.ChangeTracker.fromContext(context);
	                var functionWithType = addTypesToFunctionLike(decl);
	                ts.suppressLeadingAndTrailingTrivia(functionWithType);
	                changeTracker.replaceNode(sourceFile, decl, functionWithType, ts.textChanges.useNonAdjustedPositions);
	                return {
	                    edits: changeTracker.getChanges(),
	                    renameFilename: undefined,
	                    renameLocation: undefined
	                };
	            }
	            function isDeclarationWithType(node) {
	                return ts.isFunctionLikeDeclaration(node) ||
	                    node.kind === 230 /* VariableDeclaration */ ||
	                    node.kind === 148 /* Parameter */ ||
	                    node.kind === 150 /* PropertySignature */ ||
	                    node.kind === 151 /* PropertyDeclaration */;
	            }
	            function addTypesToFunctionLike(decl) {
	                var typeParameters = ts.getEffectiveTypeParameterDeclarations(decl, /*checkJSDoc*/ true);
	                var parameters = decl.parameters.map(function (p) { return ts.createParameter(p.decorators, p.modifiers, p.dotDotDotToken, p.name, p.questionToken, transformJSDocType(ts.getEffectiveTypeAnnotationNode(p, /*checkJSDoc*/ true)), p.initializer); });
	                var returnType = transformJSDocType(ts.getEffectiveReturnTypeNode(decl, /*checkJSDoc*/ true));
	                switch (decl.kind) {
	                    case 232 /* FunctionDeclaration */:
	                        return ts.createFunctionDeclaration(decl.decorators, decl.modifiers, decl.asteriskToken, decl.name, typeParameters, parameters, returnType, decl.body);
	                    case 154 /* Constructor */:
	                        return ts.createConstructor(decl.decorators, decl.modifiers, parameters, decl.body);
	                    case 190 /* FunctionExpression */:
	                        return ts.createFunctionExpression(decl.modifiers, decl.asteriskToken, decl.name, typeParameters, parameters, returnType, decl.body);
	                    case 191 /* ArrowFunction */:
	                        return ts.createArrowFunction(decl.modifiers, typeParameters, parameters, returnType, decl.equalsGreaterThanToken, decl.body);
	                    case 153 /* MethodDeclaration */:
	                        return ts.createMethod(decl.decorators, decl.modifiers, decl.asteriskToken, decl.name, decl.questionToken, typeParameters, parameters, returnType, decl.body);
	                    case 155 /* GetAccessor */:
	                        return ts.createGetAccessor(decl.decorators, decl.modifiers, decl.name, decl.parameters, returnType, decl.body);
	                    case 156 /* SetAccessor */:
	                        return ts.createSetAccessor(decl.decorators, decl.modifiers, decl.name, parameters, decl.body);
	                    default:
	                        return ts.Debug.assertNever(decl, "Unexpected SyntaxKind: " + decl.kind);
	                }
	            }
	            function addType(decl, jsdocType) {
	                switch (decl.kind) {
	                    case 230 /* VariableDeclaration */:
	                        return ts.createVariableDeclaration(decl.name, jsdocType, decl.initializer);
	                    case 150 /* PropertySignature */:
	                        return ts.createPropertySignature(decl.modifiers, decl.name, decl.questionToken, jsdocType, decl.initializer);
	                    case 151 /* PropertyDeclaration */:
	                        return ts.createProperty(decl.decorators, decl.modifiers, decl.name, decl.questionToken, jsdocType, decl.initializer);
	                    default:
	                        return ts.Debug.fail("Unexpected SyntaxKind: " + decl.kind);
	                }
	            }
	            function transformJSDocType(node) {
	                if (node === undefined) {
	                    return undefined;
	                }
	                switch (node.kind) {
	                    case 275 /* JSDocAllType */:
	                    case 276 /* JSDocUnknownType */:
	                        return ts.createTypeReferenceNode("any", ts.emptyArray);
	                    case 279 /* JSDocOptionalType */:
	                        return transformJSDocOptionalType(node);
	                    case 278 /* JSDocNonNullableType */:
	                        return transformJSDocType(node.type);
	                    case 277 /* JSDocNullableType */:
	                        return transformJSDocNullableType(node);
	                    case 281 /* JSDocVariadicType */:
	                        return transformJSDocVariadicType(node);
	                    case 280 /* JSDocFunctionType */:
	                        return transformJSDocFunctionType(node);
	                    case 148 /* Parameter */:
	                        return transformJSDocParameter(node);
	                    case 161 /* TypeReference */:
	                        return transformJSDocTypeReference(node);
	                    default:
	                        var visited = ts.visitEachChild(node, transformJSDocType, /*context*/ undefined);
	                        ts.setEmitFlags(visited, 1 /* SingleLine */);
	                        return visited;
	                }
	            }
	            function transformJSDocOptionalType(node) {
	                return ts.createUnionTypeNode([ts.visitNode(node.type, transformJSDocType), ts.createTypeReferenceNode("undefined", ts.emptyArray)]);
	            }
	            function transformJSDocNullableType(node) {
	                return ts.createUnionTypeNode([ts.visitNode(node.type, transformJSDocType), ts.createTypeReferenceNode("null", ts.emptyArray)]);
	            }
	            function transformJSDocVariadicType(node) {
	                return ts.createArrayTypeNode(ts.visitNode(node.type, transformJSDocType));
	            }
	            function transformJSDocFunctionType(node) {
	                var parameters = node.parameters && node.parameters.map(transformJSDocType);
	                return ts.createFunctionTypeNode(ts.emptyArray, parameters, node.type);
	            }
	            function transformJSDocParameter(node) {
	                var index = node.parent.parameters.indexOf(node);
	                var isRest = node.type.kind === 281 /* JSDocVariadicType */ && index === node.parent.parameters.length - 1;
	                var name = node.name || (isRest ? "rest" : "arg" + index);
	                var dotdotdot = isRest ? ts.createToken(24 /* DotDotDotToken */) : node.dotDotDotToken;
	                return ts.createParameter(node.decorators, node.modifiers, dotdotdot, name, node.questionToken, ts.visitNode(node.type, transformJSDocType), node.initializer);
	            }
	            function transformJSDocTypeReference(node) {
	                var name = node.typeName;
	                var args = node.typeArguments;
	                if (ts.isIdentifier(node.typeName)) {
	                    if (ts.isJSDocIndexSignature(node)) {
	                        return transformJSDocIndexSignature(node);
	                    }
	                    var text = node.typeName.text;
	                    switch (node.typeName.text) {
	                        case "String":
	                        case "Boolean":
	                        case "Object":
	                        case "Number":
	                            text = text.toLowerCase();
	                            break;
	                        case "array":
	                        case "date":
	                        case "promise":
	                            text = text[0].toUpperCase() + text.slice(1);
	                            break;
	                    }
	                    name = ts.createIdentifier(text);
	                    if ((text === "Array" || text === "Promise") && !node.typeArguments) {
	                        args = ts.createNodeArray([ts.createTypeReferenceNode("any", ts.emptyArray)]);
	                    }
	                    else {
	                        args = ts.visitNodes(node.typeArguments, transformJSDocType);
	                    }
	                }
	                return ts.createTypeReferenceNode(name, args);
	            }
	            function transformJSDocIndexSignature(node) {
	                var index = ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, node.typeArguments[0].kind === 134 /* NumberKeyword */ ? "n" : "s", 
	                /*questionToken*/ undefined, ts.createTypeReferenceNode(node.typeArguments[0].kind === 134 /* NumberKeyword */ ? "number" : "string", []), 
	                /*initializer*/ undefined);
	                var indexSignature = ts.createTypeLiteralNode([ts.createIndexSignature(/*decorators*/ undefined, /*modifiers*/ undefined, [index], node.typeArguments[1])]);
	                ts.setEmitFlags(indexSignature, 1 /* SingleLine */);
	                return indexSignature;
	            }
	        })(annotateWithTypeFromJSDoc = refactor.annotateWithTypeFromJSDoc || (refactor.annotateWithTypeFromJSDoc = {}));
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var convertFunctionToES6Class;
	        (function (convertFunctionToES6Class) {
	            var refactorName = "Convert to ES2015 class";
	            var actionName = "convert";
	            var description = ts.Diagnostics.Convert_function_to_an_ES2015_class.message;
	            refactor.registerRefactor(refactorName, { getEditsForAction: getEditsForAction, getAvailableActions: getAvailableActions });
	            function getAvailableActions(context) {
	                if (!ts.isInJavaScriptFile(context.file)) {
	                    return undefined;
	                }
	                var symbol = getConstructorSymbol(context);
	                if (!symbol) {
	                    return undefined;
	                }
	                if (ts.isDeclarationOfFunctionOrClassExpression(symbol)) {
	                    symbol = symbol.valueDeclaration.initializer.symbol;
	                }
	                if ((symbol.flags & 16 /* Function */) && symbol.members && (symbol.members.size > 0)) {
	                    return [
	                        {
	                            name: refactorName,
	                            description: description,
	                            actions: [
	                                {
	                                    description: description,
	                                    name: actionName
	                                }
	                            ]
	                        }
	                    ];
	                }
	            }
	            function getEditsForAction(context, action) {
	                // Somehow wrong action got invoked?
	                if (actionName !== action) {
	                    return undefined;
	                }
	                var sourceFile = context.file;
	                var ctorSymbol = getConstructorSymbol(context);
	                var deletedNodes = [];
	                var deletes = [];
	                if (!(ctorSymbol.flags & (16 /* Function */ | 3 /* Variable */))) {
	                    return undefined;
	                }
	                var ctorDeclaration = ctorSymbol.valueDeclaration;
	                var changeTracker = ts.textChanges.ChangeTracker.fromContext(context);
	                var precedingNode;
	                var newClassDeclaration;
	                switch (ctorDeclaration.kind) {
	                    case 232 /* FunctionDeclaration */:
	                        precedingNode = ctorDeclaration;
	                        deleteNode(ctorDeclaration);
	                        newClassDeclaration = createClassFromFunctionDeclaration(ctorDeclaration);
	                        break;
	                    case 230 /* VariableDeclaration */:
	                        precedingNode = ctorDeclaration.parent.parent;
	                        if (ctorDeclaration.parent.declarations.length === 1) {
	                            deleteNode(precedingNode);
	                        }
	                        else {
	                            deleteNode(ctorDeclaration, /*inList*/ true);
	                        }
	                        newClassDeclaration = createClassFromVariableDeclaration(ctorDeclaration);
	                        break;
	                }
	                if (!newClassDeclaration) {
	                    return undefined;
	                }
	                // Because the preceding node could be touched, we need to insert nodes before delete nodes.
	                changeTracker.insertNodeAfter(sourceFile, precedingNode, newClassDeclaration);
	                for (var _i = 0, deletes_1 = deletes; _i < deletes_1.length; _i++) {
	                    var deleteCallback = deletes_1[_i];
	                    deleteCallback();
	                }
	                return {
	                    edits: changeTracker.getChanges(),
	                    renameFilename: undefined,
	                    renameLocation: undefined,
	                };
	                function deleteNode(node, inList) {
	                    if (inList === void 0) { inList = false; }
	                    if (deletedNodes.some(function (n) { return ts.isNodeDescendantOf(node, n); })) {
	                        // Parent node has already been deleted; do nothing
	                        return;
	                    }
	                    deletedNodes.push(node);
	                    if (inList) {
	                        deletes.push(function () { return changeTracker.deleteNodeInList(sourceFile, node); });
	                    }
	                    else {
	                        deletes.push(function () { return changeTracker.deleteNode(sourceFile, node); });
	                    }
	                }
	                function createClassElementsFromSymbol(symbol) {
	                    var memberElements = [];
	                    // all instance members are stored in the "member" array of symbol
	                    if (symbol.members) {
	                        symbol.members.forEach(function (member) {
	                            var memberElement = createClassElement(member, /*modifiers*/ undefined);
	                            if (memberElement) {
	                                memberElements.push(memberElement);
	                            }
	                        });
	                    }
	                    // all static members are stored in the "exports" array of symbol
	                    if (symbol.exports) {
	                        symbol.exports.forEach(function (member) {
	                            var memberElement = createClassElement(member, [ts.createToken(115 /* StaticKeyword */)]);
	                            if (memberElement) {
	                                memberElements.push(memberElement);
	                            }
	                        });
	                    }
	                    return memberElements;
	                    function shouldConvertDeclaration(_target, source) {
	                        // Right now the only thing we can convert are function expressions - other values shouldn't get
	                        // transformed. We can update this once ES public class properties are available.
	                        return ts.isFunctionLike(source);
	                    }
	                    function createClassElement(symbol, modifiers) {
	                        // both properties and methods are bound as property symbols
	                        if (!(symbol.flags & 4 /* Property */)) {
	                            return;
	                        }
	                        var memberDeclaration = symbol.valueDeclaration;
	                        var assignmentBinaryExpression = memberDeclaration.parent;
	                        if (!shouldConvertDeclaration(memberDeclaration, assignmentBinaryExpression.right)) {
	                            return;
	                        }
	                        // delete the entire statement if this expression is the sole expression to take care of the semicolon at the end
	                        var nodeToDelete = assignmentBinaryExpression.parent && assignmentBinaryExpression.parent.kind === 214 /* ExpressionStatement */
	                            ? assignmentBinaryExpression.parent : assignmentBinaryExpression;
	                        deleteNode(nodeToDelete);
	                        if (!assignmentBinaryExpression.right) {
	                            return ts.createProperty([], modifiers, symbol.name, /*questionToken*/ undefined, 
	                            /*type*/ undefined, /*initializer*/ undefined);
	                        }
	                        switch (assignmentBinaryExpression.right.kind) {
	                            case 190 /* FunctionExpression */: {
	                                var functionExpression = assignmentBinaryExpression.right;
	                                var fullModifiers = ts.concatenate(modifiers, getModifierKindFromSource(functionExpression, 120 /* AsyncKeyword */));
	                                var method = ts.createMethod(/*decorators*/ undefined, fullModifiers, /*asteriskToken*/ undefined, memberDeclaration.name, /*questionToken*/ undefined, 
	                                /*typeParameters*/ undefined, functionExpression.parameters, /*type*/ undefined, functionExpression.body);
	                                copyComments(assignmentBinaryExpression, method);
	                                return method;
	                            }
	                            case 191 /* ArrowFunction */: {
	                                var arrowFunction = assignmentBinaryExpression.right;
	                                var arrowFunctionBody = arrowFunction.body;
	                                var bodyBlock = void 0;
	                                // case 1: () => { return [1,2,3] }
	                                if (arrowFunctionBody.kind === 211 /* Block */) {
	                                    bodyBlock = arrowFunctionBody;
	                                }
	                                else {
	                                    bodyBlock = ts.createBlock([ts.createReturn(arrowFunctionBody)]);
	                                }
	                                var fullModifiers = ts.concatenate(modifiers, getModifierKindFromSource(arrowFunction, 120 /* AsyncKeyword */));
	                                var method = ts.createMethod(/*decorators*/ undefined, fullModifiers, /*asteriskToken*/ undefined, memberDeclaration.name, /*questionToken*/ undefined, 
	                                /*typeParameters*/ undefined, arrowFunction.parameters, /*type*/ undefined, bodyBlock);
	                                copyComments(assignmentBinaryExpression, method);
	                                return method;
	                            }
	                            default: {
	                                // Don't try to declare members in JavaScript files
	                                if (ts.isSourceFileJavaScript(sourceFile)) {
	                                    return;
	                                }
	                                var prop = ts.createProperty(/*decorators*/ undefined, modifiers, memberDeclaration.name, /*questionToken*/ undefined, 
	                                /*type*/ undefined, assignmentBinaryExpression.right);
	                                copyComments(assignmentBinaryExpression.parent, prop);
	                                return prop;
	                            }
	                        }
	                    }
	                }
	                function copyComments(sourceNode, targetNode) {
	                    ts.forEachLeadingCommentRange(sourceFile.text, sourceNode.pos, function (pos, end, kind, htnl) {
	                        if (kind === 3 /* MultiLineCommentTrivia */) {
	                            // Remove leading /*
	                            pos += 2;
	                            // Remove trailing */
	                            end -= 2;
	                        }
	                        else {
	                            // Remove leading //
	                            pos += 2;
	                        }
	                        ts.addSyntheticLeadingComment(targetNode, kind, sourceFile.text.slice(pos, end), htnl);
	                    });
	                }
	                function createClassFromVariableDeclaration(node) {
	                    var initializer = node.initializer;
	                    if (!initializer || initializer.kind !== 190 /* FunctionExpression */) {
	                        return undefined;
	                    }
	                    if (node.name.kind !== 71 /* Identifier */) {
	                        return undefined;
	                    }
	                    var memberElements = createClassElementsFromSymbol(initializer.symbol);
	                    if (initializer.body) {
	                        memberElements.unshift(ts.createConstructor(/*decorators*/ undefined, /*modifiers*/ undefined, initializer.parameters, initializer.body));
	                    }
	                    var modifiers = getModifierKindFromSource(precedingNode, 84 /* ExportKeyword */);
	                    var cls = ts.createClassDeclaration(/*decorators*/ undefined, modifiers, node.name, 
	                    /*typeParameters*/ undefined, /*heritageClauses*/ undefined, memberElements);
	                    // Don't call copyComments here because we'll already leave them in place
	                    return cls;
	                }
	                function createClassFromFunctionDeclaration(node) {
	                    var memberElements = createClassElementsFromSymbol(ctorSymbol);
	                    if (node.body) {
	                        memberElements.unshift(ts.createConstructor(/*decorators*/ undefined, /*modifiers*/ undefined, node.parameters, node.body));
	                    }
	                    var modifiers = getModifierKindFromSource(node, 84 /* ExportKeyword */);
	                    var cls = ts.createClassDeclaration(/*decorators*/ undefined, modifiers, node.name, 
	                    /*typeParameters*/ undefined, /*heritageClauses*/ undefined, memberElements);
	                    // Don't call copyComments here because we'll already leave them in place
	                    return cls;
	                }
	                function getModifierKindFromSource(source, kind) {
	                    return ts.filter(source.modifiers, function (modifier) { return modifier.kind === kind; });
	                }
	            }
	            function getConstructorSymbol(_a) {
	                var startPosition = _a.startPosition, file = _a.file, program = _a.program;
	                var checker = program.getTypeChecker();
	                var token = ts.getTokenAtPosition(file, startPosition, /*includeJsDocComment*/ false);
	                return checker.getSymbolAtLocation(token);
	            }
	        })(convertFunctionToES6Class = refactor.convertFunctionToES6Class || (refactor.convertFunctionToES6Class = {}));
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var actionName = "Convert to ES6 module";
	        var description = ts.getLocaleSpecificMessage(ts.Diagnostics.Convert_to_ES6_module);
	        refactor.registerRefactor(actionName, { getEditsForAction: getEditsForAction, getAvailableActions: getAvailableActions });
	        function getAvailableActions(context) {
	            var file = context.file, startPosition = context.startPosition;
	            if (!ts.isSourceFileJavaScript(file) || !file.commonJsModuleIndicator) {
	                return undefined;
	            }
	            var node = ts.getTokenAtPosition(file, startPosition, /*includeJsDocComment*/ false);
	            return !isAtTriggerLocation(file, node) ? undefined : [
	                {
	                    name: actionName,
	                    description: description,
	                    actions: [
	                        {
	                            description: description,
	                            name: actionName,
	                        },
	                    ],
	                },
	            ];
	        }
	        function isAtTriggerLocation(sourceFile, node, onSecondTry) {
	            if (onSecondTry === void 0) { onSecondTry = false; }
	            switch (node.kind) {
	                case 185 /* CallExpression */:
	                    return isAtTopLevelRequire(node);
	                case 183 /* PropertyAccessExpression */:
	                    return ts.isExportsOrModuleExportsOrAlias(sourceFile, node)
	                        || ts.isExportsOrModuleExportsOrAlias(sourceFile, node.expression);
	                case 231 /* VariableDeclarationList */:
	                    return isVariableDeclarationTriggerLocation(ts.firstOrUndefined(node.declarations));
	                case 230 /* VariableDeclaration */:
	                    return isVariableDeclarationTriggerLocation(node);
	                default:
	                    return ts.isExpression(node) && ts.isExportsOrModuleExportsOrAlias(sourceFile, node)
	                        || !onSecondTry && isAtTriggerLocation(sourceFile, node.parent, /*onSecondTry*/ true);
	            }
	            function isVariableDeclarationTriggerLocation(decl) {
	                return !!decl && !!decl.initializer && ts.isExportsOrModuleExportsOrAlias(sourceFile, decl.initializer);
	            }
	        }
	        function isAtTopLevelRequire(call) {
	            if (!ts.isRequireCall(call, /*checkArgumentIsStringLiteral*/ true)) {
	                return false;
	            }
	            var propAccess = call.parent;
	            var varDecl = ts.isPropertyAccessExpression(propAccess) ? propAccess.parent : propAccess;
	            if (ts.isExpressionStatement(varDecl) && ts.isSourceFile(varDecl.parent)) {
	                return true;
	            }
	            if (!ts.isVariableDeclaration(varDecl)) {
	                return false;
	            }
	            var varDeclList = varDecl.parent;
	            if (varDeclList.kind !== 231 /* VariableDeclarationList */) {
	                return false;
	            }
	            var varStatement = varDeclList.parent;
	            return varStatement.kind === 212 /* VariableStatement */ && varStatement.parent.kind === 272 /* SourceFile */;
	        }
	        function getEditsForAction(context, _actionName) {
	            ts.Debug.assertEqual(actionName, _actionName);
	            var file = context.file, program = context.program;
	            ts.Debug.assert(ts.isSourceFileJavaScript(file));
	            var edits = ts.textChanges.ChangeTracker.with(context, function (changes) {
	                var moduleExportsChangedToDefault = convertFileToEs6Module(file, program.getTypeChecker(), changes, program.getCompilerOptions().target);
	                if (moduleExportsChangedToDefault) {
	                    for (var _i = 0, _a = program.getSourceFiles(); _i < _a.length; _i++) {
	                        var importingFile = _a[_i];
	                        fixImportOfModuleExports(importingFile, file, changes);
	                    }
	                }
	            });
	            return { edits: edits, renameFilename: undefined, renameLocation: undefined };
	        }
	        function fixImportOfModuleExports(importingFile, exportingFile, changes) {
	            for (var _i = 0, _a = importingFile.imports; _i < _a.length; _i++) {
	                var moduleSpecifier = _a[_i];
	                var imported = ts.getResolvedModule(importingFile, moduleSpecifier.text);
	                if (!imported || imported.resolvedFileName !== exportingFile.fileName) {
	                    continue;
	                }
	                var parent = moduleSpecifier.parent;
	                switch (parent.kind) {
	                    case 252 /* ExternalModuleReference */: {
	                        var importEq = parent.parent;
	                        changes.replaceNode(importingFile, importEq, makeImport(importEq.name, /*namedImports*/ undefined, moduleSpecifier.text));
	                        break;
	                    }
	                    case 185 /* CallExpression */: {
	                        var call = parent;
	                        if (ts.isRequireCall(call, /*checkArgumentIsStringLiteral*/ false)) {
	                            changes.replaceNode(importingFile, parent, ts.createPropertyAccess(ts.getSynthesizedDeepClone(call), "default"));
	                        }
	                        break;
	                    }
	                }
	            }
	        }
	        /** @returns Whether we converted a `module.exports =` to a default export. */
	        function convertFileToEs6Module(sourceFile, checker, changes, target) {
	            var identifiers = { original: collectFreeIdentifiers(sourceFile), additional: ts.createMap() };
	            var exports = collectExportRenames(sourceFile, checker, identifiers);
	            convertExportsAccesses(sourceFile, exports, changes);
	            var moduleExportsChangedToDefault = false;
	            for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	                var statement = _a[_i];
	                var moduleExportsChanged = convertStatement(sourceFile, statement, checker, changes, identifiers, target, exports);
	                moduleExportsChangedToDefault = moduleExportsChangedToDefault || moduleExportsChanged;
	            }
	            return moduleExportsChangedToDefault;
	        }
	        function collectExportRenames(sourceFile, checker, identifiers) {
	            var res = ts.createMap();
	            forEachExportReference(sourceFile, function (node) {
	                var _a = node.name, text = _a.text, originalKeywordKind = _a.originalKeywordKind;
	                if (!res.has(text) && (originalKeywordKind !== undefined && ts.isNonContextualKeyword(originalKeywordKind)
	                    || checker.resolveName(node.name.text, node, 107455 /* Value */, /*excludeGlobals*/ true))) {
	                    // Unconditionally add an underscore in case `text` is a keyword.
	                    res.set(text, makeUniqueName("_" + text, identifiers));
	                }
	            });
	            return res;
	        }
	        function convertExportsAccesses(sourceFile, exports, changes) {
	            forEachExportReference(sourceFile, function (node, isAssignmentLhs) {
	                if (isAssignmentLhs) {
	                    return;
	                }
	                var text = node.name.text;
	                changes.replaceNode(sourceFile, node, ts.createIdentifier(exports.get(text) || text));
	            });
	        }
	        function forEachExportReference(sourceFile, cb) {
	            sourceFile.forEachChild(function recur(node) {
	                if (ts.isPropertyAccessExpression(node) && ts.isExportsOrModuleExportsOrAlias(sourceFile, node.expression)) {
	                    var parent = node.parent;
	                    cb(node, ts.isBinaryExpression(parent) && parent.left === node && parent.operatorToken.kind === 58 /* EqualsToken */);
	                }
	                node.forEachChild(recur);
	            });
	        }
	        function convertStatement(sourceFile, statement, checker, changes, identifiers, target, exports) {
	            switch (statement.kind) {
	                case 212 /* VariableStatement */:
	                    convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target);
	                    return false;
	                case 214 /* ExpressionStatement */: {
	                    var expression = statement.expression;
	                    switch (expression.kind) {
	                        case 185 /* CallExpression */: {
	                            if (ts.isRequireCall(expression, /*checkArgumentIsStringLiteral*/ true)) {
	                                // For side-effecting require() call, just make a side-effecting import.
	                                changes.replaceNode(sourceFile, statement, makeImport(/*name*/ undefined, /*namedImports*/ undefined, expression.arguments[0].text));
	                            }
	                            return false;
	                        }
	                        case 198 /* BinaryExpression */: {
	                            var _a = expression, left = _a.left, operatorToken = _a.operatorToken, right = _a.right;
	                            return operatorToken.kind === 58 /* EqualsToken */ && convertAssignment(sourceFile, checker, statement, left, right, changes, exports);
	                        }
	                    }
	                }
	                // falls through
	                default:
	                    return false;
	            }
	        }
	        function convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target) {
	            var declarationList = statement.declarationList;
	            var foundImport = false;
	            var newNodes = ts.flatMap(declarationList.declarations, function (decl) {
	                var name = decl.name, initializer = decl.initializer;
	                if (ts.isExportsOrModuleExportsOrAlias(sourceFile, initializer)) {
	                    // `const alias = module.exports;` can be removed.
	                    foundImport = true;
	                    return [];
	                }
	                if (ts.isRequireCall(initializer, /*checkArgumentIsStringLiteral*/ true)) {
	                    foundImport = true;
	                    return convertSingleImport(sourceFile, name, initializer.arguments[0].text, changes, checker, identifiers, target);
	                }
	                else if (ts.isPropertyAccessExpression(initializer) && ts.isRequireCall(initializer.expression, /*checkArgumentIsStringLiteral*/ true)) {
	                    foundImport = true;
	                    return convertPropertyAccessImport(name, initializer.name.text, initializer.expression.arguments[0].text, identifiers);
	                }
	                else {
	                    // Move it out to its own variable statement.
	                    return ts.createVariableStatement(/*modifiers*/ undefined, ts.createVariableDeclarationList([decl], declarationList.flags));
	                }
	            });
	            if (foundImport) {
	                // useNonAdjustedEndPosition to ensure we don't eat the newline after the statement.
	                changes.replaceNodeWithNodes(sourceFile, statement, newNodes);
	            }
	        }
	        /** Converts `const name = require("moduleSpecifier").propertyName` */
	        function convertPropertyAccessImport(name, propertyName, moduleSpecifier, identifiers) {
	            switch (name.kind) {
	                case 178 /* ObjectBindingPattern */:
	                case 179 /* ArrayBindingPattern */: {
	                    // `const [a, b] = require("c").d` --> `import { d } from "c"; const [a, b] = d;`
	                    var tmp = makeUniqueName(propertyName, identifiers);
	                    return [
	                        makeSingleImport(tmp, propertyName, moduleSpecifier),
	                        makeConst(/*modifiers*/ undefined, name, ts.createIdentifier(tmp)),
	                    ];
	                }
	                case 71 /* Identifier */:
	                    // `const a = require("b").c` --> `import { c as a } from "./b";
	                    return [makeSingleImport(name.text, propertyName, moduleSpecifier)];
	                default:
	                    ts.Debug.assertNever(name);
	            }
	        }
	        function convertAssignment(sourceFile, checker, statement, left, right, changes, exports) {
	            if (!ts.isPropertyAccessExpression(left)) {
	                return false;
	            }
	            if (ts.isExportsOrModuleExportsOrAlias(sourceFile, left)) {
	                if (ts.isExportsOrModuleExportsOrAlias(sourceFile, right)) {
	                    // `const alias = module.exports;` or `module.exports = alias;` can be removed.
	                    changes.deleteNode(sourceFile, statement);
	                }
	                else {
	                    var newNodes = ts.isObjectLiteralExpression(right) ? tryChangeModuleExportsObject(right) : undefined;
	                    var changedToDefaultExport = false;
	                    if (!newNodes) {
	                        (_a = convertModuleExportsToExportDefault(right, checker), newNodes = _a[0], changedToDefaultExport = _a[1]);
	                    }
	                    changes.replaceNodeWithNodes(sourceFile, statement, newNodes);
	                    return changedToDefaultExport;
	                }
	            }
	            else if (ts.isExportsOrModuleExportsOrAlias(sourceFile, left.expression)) {
	                convertNamedExport(sourceFile, statement, left.name, right, changes, exports);
	            }
	            return false;
	            var _a;
	        }
	        /**
	         * Convert `module.exports = { ... }` to individual exports..
	         * We can't always do this if the module has interesting members -- then it will be a default export instead.
	         */
	        function tryChangeModuleExportsObject(object) {
	            return ts.mapAllOrFail(object.properties, function (prop) {
	                switch (prop.kind) {
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    // TODO: Maybe we should handle this? See fourslash test `refactorConvertToEs6Module_export_object_shorthand.ts`.
	                    case 269 /* ShorthandPropertyAssignment */:
	                    case 270 /* SpreadAssignment */:
	                        return undefined;
	                    case 268 /* PropertyAssignment */:
	                        return !ts.isIdentifier(prop.name) ? undefined : convertExportsDotXEquals(prop.name.text, prop.initializer);
	                    case 153 /* MethodDeclaration */:
	                        return !ts.isIdentifier(prop.name) ? undefined : functionExpressionToDeclaration(prop.name.text, [ts.createToken(84 /* ExportKeyword */)], prop);
	                    default:
	                        ts.Debug.assertNever(prop);
	                }
	            });
	        }
	        function convertNamedExport(sourceFile, statement, propertyName, right, changes, exports) {
	            // If "originalKeywordKind" was set, this is e.g. `exports.
	            var text = propertyName.text;
	            var rename = exports.get(text);
	            if (rename !== undefined) {
	                /*
	                const _class = 0;
	                export { _class as class };
	                */
	                var newNodes = [
	                    makeConst(/*modifiers*/ undefined, rename, right),
	                    makeExportDeclaration([ts.createExportSpecifier(rename, text)]),
	                ];
	                changes.replaceNodeWithNodes(sourceFile, statement, newNodes);
	            }
	            else {
	                changes.replaceNode(sourceFile, statement, convertExportsDotXEquals(text, right), { useNonAdjustedEndPosition: true });
	            }
	        }
	        function convertModuleExportsToExportDefault(exported, checker) {
	            var modifiers = [ts.createToken(84 /* ExportKeyword */), ts.createToken(79 /* DefaultKeyword */)];
	            switch (exported.kind) {
	                case 190 /* FunctionExpression */:
	                case 191 /* ArrowFunction */: {
	                    // `module.exports = function f() {}` --> `export default function f() {}`
	                    var fn = exported;
	                    return [[functionExpressionToDeclaration(fn.name && fn.name.text, modifiers, fn)], true];
	                }
	                case 203 /* ClassExpression */: {
	                    // `module.exports = class C {}` --> `export default class C {}`
	                    var cls = exported;
	                    return [[classExpressionToDeclaration(cls.name && cls.name.text, modifiers, cls)], true];
	                }
	                case 185 /* CallExpression */:
	                    if (ts.isRequireCall(exported, /*checkArgumentIsStringLiteral*/ true)) {
	                        return convertReExportAll(exported.arguments[0], checker);
	                    }
	                // falls through
	                default:
	                    // `module.exports = 0;` --> `export default 0;`
	                    return [[ts.createExportAssignment(/*decorators*/ undefined, /*modifiers*/ undefined, /*isExportEquals*/ false, exported)], true];
	            }
	        }
	        function convertReExportAll(reExported, checker) {
	            // `module.exports = require("x");` ==> `export * from "x"; export { default } from "x";`
	            var moduleSpecifier = reExported.text;
	            var moduleSymbol = checker.getSymbolAtLocation(reExported);
	            var exports = moduleSymbol ? moduleSymbol.exports : ts.emptyUnderscoreEscapedMap;
	            return exports.has("export=")
	                ? [[reExportDefault(moduleSpecifier)], true]
	                : !exports.has("default")
	                    ? [[reExportStar(moduleSpecifier)], false]
	                    // If there's some non-default export, must include both `export *` and `export default`.
	                    : exports.size > 1 ? [[reExportStar(moduleSpecifier), reExportDefault(moduleSpecifier)], true] : [[reExportDefault(moduleSpecifier)], true];
	        }
	        function reExportStar(moduleSpecifier) {
	            return makeExportDeclaration(/*exportClause*/ undefined, moduleSpecifier);
	        }
	        function reExportDefault(moduleSpecifier) {
	            return makeExportDeclaration([ts.createExportSpecifier(/*propertyName*/ undefined, "default")], moduleSpecifier);
	        }
	        function convertExportsDotXEquals(name, exported) {
	            var modifiers = [ts.createToken(84 /* ExportKeyword */)];
	            switch (exported.kind) {
	                case 190 /* FunctionExpression */: {
	                    var expressionName = exported.name;
	                    if (expressionName && expressionName.text !== name) {
	                        // `exports.f = function g() {}` -> `export const f = function g() {}`
	                        return exportConst();
	                    }
	                }
	                // falls through
	                case 191 /* ArrowFunction */:
	                    // `exports.f = function() {}` --> `export function f() {}`
	                    return functionExpressionToDeclaration(name, modifiers, exported);
	                case 203 /* ClassExpression */:
	                    // `exports.C = class {}` --> `export class C {}`
	                    return classExpressionToDeclaration(name, modifiers, exported);
	                default:
	                    return exportConst();
	            }
	            function exportConst() {
	                // `exports.x = 0;` --> `export const x = 0;`
	                return makeConst(modifiers, ts.createIdentifier(name), exported);
	            }
	        }
	        /**
	         * Converts `const <<name>> = require("x");`.
	         * Returns nodes that will replace the variable declaration for the commonjs import.
	         * May also make use `changes` to remove qualifiers at the use sites of imports, to change `mod.x` to `x`.
	         */
	        function convertSingleImport(file, name, moduleSpecifier, changes, checker, identifiers, target) {
	            switch (name.kind) {
	                case 178 /* ObjectBindingPattern */: {
	                    var importSpecifiers = ts.mapAllOrFail(name.elements, function (e) {
	                        return e.dotDotDotToken || e.initializer || e.propertyName && !ts.isIdentifier(e.propertyName) || !ts.isIdentifier(e.name)
	                            ? undefined
	                            : makeImportSpecifier(e.propertyName && e.propertyName.text, e.name.text);
	                    });
	                    if (importSpecifiers) {
	                        return [makeImport(/*name*/ undefined, importSpecifiers, moduleSpecifier)];
	                    }
	                }
	                // falls through -- object destructuring has an interesting pattern and must be a variable declaration
	                case 179 /* ArrayBindingPattern */: {
	                    /*
	                    import x from "x";
	                    const [a, b, c] = x;
	                    */
	                    var tmp = makeUniqueName(ts.codefix.moduleSpecifierToValidIdentifier(moduleSpecifier, target), identifiers);
	                    return [
	                        makeImport(ts.createIdentifier(tmp), /*namedImports*/ undefined, moduleSpecifier),
	                        makeConst(/*modifiers*/ undefined, ts.getSynthesizedDeepClone(name), ts.createIdentifier(tmp)),
	                    ];
	                }
	                case 71 /* Identifier */:
	                    return convertSingleIdentifierImport(file, name, moduleSpecifier, changes, checker, identifiers);
	                default:
	                    ts.Debug.assertNever(name);
	            }
	        }
	        /**
	         * Convert `import x = require("x").`
	         * Also converts uses like `x.y()` to `y()` and uses a named import.
	         */
	        function convertSingleIdentifierImport(file, name, moduleSpecifier, changes, checker, identifiers) {
	            var nameSymbol = checker.getSymbolAtLocation(name);
	            // Maps from module property name to name actually used. (The same if there isn't shadowing.)
	            var namedBindingsNames = ts.createMap();
	            // True if there is some non-property use like `x()` or `f(x)`.
	            var needDefaultImport = false;
	            for (var _i = 0, _a = identifiers.original.get(name.text); _i < _a.length; _i++) {
	                var use = _a[_i];
	                if (checker.getSymbolAtLocation(use) !== nameSymbol || use === name) {
	                    // This was a use of a different symbol with the same name, due to shadowing. Ignore.
	                    continue;
	                }
	                var parent = use.parent;
	                if (ts.isPropertyAccessExpression(parent)) {
	                    var expression = parent.expression, propertyName = parent.name.text;
	                    ts.Debug.assert(expression === use); // Else shouldn't have been in `collectIdentifiers`
	                    var idName = namedBindingsNames.get(propertyName);
	                    if (idName === undefined) {
	                        idName = makeUniqueName(propertyName, identifiers);
	                        namedBindingsNames.set(propertyName, idName);
	                    }
	                    changes.replaceNode(file, parent, ts.createIdentifier(idName));
	                }
	                else {
	                    needDefaultImport = true;
	                }
	            }
	            var namedBindings = namedBindingsNames.size === 0 ? undefined : ts.arrayFrom(ts.mapIterator(namedBindingsNames.entries(), function (_a) {
	                var propertyName = _a[0], idName = _a[1];
	                return ts.createImportSpecifier(propertyName === idName ? undefined : ts.createIdentifier(propertyName), ts.createIdentifier(idName));
	            }));
	            if (!namedBindings) {
	                // If it was unused, ensure that we at least import *something*.
	                needDefaultImport = true;
	            }
	            return [makeImport(needDefaultImport ? ts.getSynthesizedDeepClone(name) : undefined, namedBindings, moduleSpecifier)];
	        }
	        // Identifiers helpers
	        function makeUniqueName(name, identifiers) {
	            while (identifiers.original.has(name) || identifiers.additional.has(name)) {
	                name = "_" + name;
	            }
	            identifiers.additional.set(name, true);
	            return name;
	        }
	        function collectFreeIdentifiers(file) {
	            var map = ts.createMultiMap();
	            file.forEachChild(function recur(node) {
	                if (ts.isIdentifier(node) && isFreeIdentifier(node)) {
	                    map.add(node.text, node);
	                }
	                node.forEachChild(recur);
	            });
	            return map;
	        }
	        function isFreeIdentifier(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 183 /* PropertyAccessExpression */:
	                    return parent.name !== node;
	                case 180 /* BindingElement */:
	                    return parent.propertyName !== node;
	                default:
	                    return true;
	            }
	        }
	        // Node helpers
	        function functionExpressionToDeclaration(name, additionalModifiers, fn) {
	            return ts.createFunctionDeclaration(ts.getSynthesizedDeepClones(fn.decorators), // TODO: GH#19915 Don't think this is even legal.
	            ts.concatenate(additionalModifiers, ts.getSynthesizedDeepClones(fn.modifiers)), ts.getSynthesizedDeepClone(fn.asteriskToken), name, ts.getSynthesizedDeepClones(fn.typeParameters), ts.getSynthesizedDeepClones(fn.parameters), ts.getSynthesizedDeepClone(fn.type), ts.convertToFunctionBody(ts.getSynthesizedDeepClone(fn.body)));
	        }
	        function classExpressionToDeclaration(name, additionalModifiers, cls) {
	            return ts.createClassDeclaration(ts.getSynthesizedDeepClones(cls.decorators), // TODO: GH#19915 Don't think this is even legal.
	            ts.concatenate(additionalModifiers, ts.getSynthesizedDeepClones(cls.modifiers)), name, ts.getSynthesizedDeepClones(cls.typeParameters), ts.getSynthesizedDeepClones(cls.heritageClauses), ts.getSynthesizedDeepClones(cls.members));
	        }
	        function makeSingleImport(localName, propertyName, moduleSpecifier) {
	            return propertyName === "default"
	                ? makeImport(ts.createIdentifier(localName), /*namedImports*/ undefined, moduleSpecifier)
	                : makeImport(/*name*/ undefined, [makeImportSpecifier(propertyName, localName)], moduleSpecifier);
	        }
	        function makeImport(name, namedImports, moduleSpecifier) {
	            var importClause = (name || namedImports) && ts.createImportClause(name, namedImports && ts.createNamedImports(namedImports));
	            return ts.createImportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, importClause, ts.createLiteral(moduleSpecifier));
	        }
	        function makeImportSpecifier(propertyName, name) {
	            return ts.createImportSpecifier(propertyName !== undefined && propertyName !== name ? ts.createIdentifier(propertyName) : undefined, ts.createIdentifier(name));
	        }
	        function makeConst(modifiers, name, init) {
	            return ts.createVariableStatement(modifiers, ts.createVariableDeclarationList([ts.createVariableDeclaration(name, /*type*/ undefined, init)], 2 /* Const */));
	        }
	        function makeExportDeclaration(exportSpecifiers, moduleSpecifier) {
	            return ts.createExportDeclaration(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, exportSpecifiers && ts.createNamedExports(exportSpecifiers), moduleSpecifier === undefined ? undefined : ts.createLiteral(moduleSpecifier));
	        }
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/// <reference path="../refactorProvider.ts" />
	/// <reference path="../../compiler/checker.ts" />
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var extractSymbol;
	        (function (extractSymbol) {
	            var refactorName = "Extract Symbol";
	            refactor.registerRefactor(refactorName, { getAvailableActions: getAvailableActions, getEditsForAction: getEditsForAction });
	            /**
	             * Compute the associated code actions
	             * Exported for tests.
	             */
	            function getAvailableActions(context) {
	                var rangeToExtract = getRangeToExtract(context.file, { start: context.startPosition, length: ts.getRefactorContextLength(context) });
	                var targetRange = rangeToExtract.targetRange;
	                if (targetRange === undefined) {
	                    return undefined;
	                }
	                var extractions = getPossibleExtractions(targetRange, context);
	                if (extractions === undefined) {
	                    // No extractions possible
	                    return undefined;
	                }
	                var functionActions = [];
	                var usedFunctionNames = ts.createMap();
	                var constantActions = [];
	                var usedConstantNames = ts.createMap();
	                var i = 0;
	                for (var _i = 0, extractions_1 = extractions; _i < extractions_1.length; _i++) {
	                    var _a = extractions_1[_i], functionExtraction = _a.functionExtraction, constantExtraction = _a.constantExtraction;
	                    // Skip these since we don't have a way to report errors yet
	                    if (functionExtraction.errors.length === 0) {
	                        // Don't issue refactorings with duplicated names.
	                        // Scopes come back in "innermost first" order, so extractions will
	                        // preferentially go into nearer scopes
	                        var description = functionExtraction.description;
	                        if (!usedFunctionNames.has(description)) {
	                            usedFunctionNames.set(description, true);
	                            functionActions.push({
	                                description: description,
	                                name: "function_scope_" + i
	                            });
	                        }
	                    }
	                    // Skip these since we don't have a way to report errors yet
	                    if (constantExtraction.errors.length === 0) {
	                        // Don't issue refactorings with duplicated names.
	                        // Scopes come back in "innermost first" order, so extractions will
	                        // preferentially go into nearer scopes
	                        var description = constantExtraction.description;
	                        if (!usedConstantNames.has(description)) {
	                            usedConstantNames.set(description, true);
	                            constantActions.push({
	                                description: description,
	                                name: "constant_scope_" + i
	                            });
	                        }
	                    }
	                    // *do* increment i anyway because we'll look for the i-th scope
	                    // later when actually doing the refactoring if the user requests it
	                    i++;
	                }
	                var infos = [];
	                if (functionActions.length) {
	                    infos.push({
	                        name: refactorName,
	                        description: ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_function),
	                        actions: functionActions
	                    });
	                }
	                if (constantActions.length) {
	                    infos.push({
	                        name: refactorName,
	                        description: ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_constant),
	                        actions: constantActions
	                    });
	                }
	                return infos.length ? infos : undefined;
	            }
	            extractSymbol.getAvailableActions = getAvailableActions;
	            /* Exported for tests */
	            function getEditsForAction(context, actionName) {
	                var rangeToExtract = getRangeToExtract(context.file, { start: context.startPosition, length: ts.getRefactorContextLength(context) });
	                var targetRange = rangeToExtract.targetRange;
	                var parsedFunctionIndexMatch = /^function_scope_(\d+)$/.exec(actionName);
	                if (parsedFunctionIndexMatch) {
	                    var index = +parsedFunctionIndexMatch[1];
	                    ts.Debug.assert(isFinite(index), "Expected to parse a finite number from the function scope index");
	                    return getFunctionExtractionAtIndex(targetRange, context, index);
	                }
	                var parsedConstantIndexMatch = /^constant_scope_(\d+)$/.exec(actionName);
	                if (parsedConstantIndexMatch) {
	                    var index = +parsedConstantIndexMatch[1];
	                    ts.Debug.assert(isFinite(index), "Expected to parse a finite number from the constant scope index");
	                    return getConstantExtractionAtIndex(targetRange, context, index);
	                }
	                ts.Debug.fail("Unrecognized action name");
	            }
	            extractSymbol.getEditsForAction = getEditsForAction;
	            // Move these into diagnostic messages if they become user-facing
	            var Messages;
	            (function (Messages) {
	                function createMessage(message) {
	                    return { message: message, code: 0, category: ts.DiagnosticCategory.Message, key: message };
	                }
	                Messages.cannotExtractRange = createMessage("Cannot extract range.");
	                Messages.cannotExtractImport = createMessage("Cannot extract import statement.");
	                Messages.cannotExtractSuper = createMessage("Cannot extract super call.");
	                Messages.cannotExtractEmpty = createMessage("Cannot extract empty range.");
	                Messages.expressionExpected = createMessage("expression expected.");
	                Messages.uselessConstantType = createMessage("No reason to extract constant of type.");
	                Messages.statementOrExpressionExpected = createMessage("Statement or expression expected.");
	                Messages.cannotExtractRangeContainingConditionalBreakOrContinueStatements = createMessage("Cannot extract range containing conditional break or continue statements.");
	                Messages.cannotExtractRangeContainingConditionalReturnStatement = createMessage("Cannot extract range containing conditional return statement.");
	                Messages.cannotExtractRangeContainingLabeledBreakOrContinueStatementWithTargetOutsideOfTheRange = createMessage("Cannot extract range containing labeled break or continue with target outside of the range.");
	                Messages.cannotExtractRangeThatContainsWritesToReferencesLocatedOutsideOfTheTargetRangeInGenerators = createMessage("Cannot extract range containing writes to references located outside of the target range in generators.");
	                Messages.typeWillNotBeVisibleInTheNewScope = createMessage("Type will not visible in the new scope.");
	                Messages.functionWillNotBeVisibleInTheNewScope = createMessage("Function will not visible in the new scope.");
	                Messages.cannotExtractIdentifier = createMessage("Select more than a single identifier.");
	                Messages.cannotExtractExportedEntity = createMessage("Cannot extract exported declaration");
	                Messages.cannotWriteInExpression = createMessage("Cannot write back side-effects when extracting an expression");
	                Messages.cannotExtractReadonlyPropertyInitializerOutsideConstructor = createMessage("Cannot move initialization of read-only class property outside of the constructor");
	                Messages.cannotExtractAmbientBlock = createMessage("Cannot extract code from ambient contexts");
	                Messages.cannotAccessVariablesFromNestedScopes = createMessage("Cannot access variables from nested scopes");
	                Messages.cannotExtractToOtherFunctionLike = createMessage("Cannot extract method to a function-like scope that is not a function");
	                Messages.cannotExtractToJSClass = createMessage("Cannot extract constant to a class scope in JS");
	                Messages.cannotExtractToExpressionArrowFunction = createMessage("Cannot extract constant to an arrow function without a block");
	            })(Messages = extractSymbol.Messages || (extractSymbol.Messages = {}));
	            var RangeFacts;
	            (function (RangeFacts) {
	                RangeFacts[RangeFacts["None"] = 0] = "None";
	                RangeFacts[RangeFacts["HasReturn"] = 1] = "HasReturn";
	                RangeFacts[RangeFacts["IsGenerator"] = 2] = "IsGenerator";
	                RangeFacts[RangeFacts["IsAsyncFunction"] = 4] = "IsAsyncFunction";
	                RangeFacts[RangeFacts["UsesThis"] = 8] = "UsesThis";
	                /**
	                 * The range is in a function which needs the 'static' modifier in a class
	                 */
	                RangeFacts[RangeFacts["InStaticRegion"] = 16] = "InStaticRegion";
	            })(RangeFacts || (RangeFacts = {}));
	            /**
	             * getRangeToExtract takes a span inside a text file and returns either an expression or an array
	             * of statements representing the minimum set of nodes needed to extract the entire span. This
	             * process may fail, in which case a set of errors is returned instead (these are currently
	             * not shown to the user, but can be used by us diagnostically)
	             */
	            // exported only for tests
	            function getRangeToExtract(sourceFile, span) {
	                var length = span.length;
	                if (length === 0) {
	                    return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractEmpty)] };
	                }
	                // Walk up starting from the the start position until we find a non-SourceFile node that subsumes the selected span.
	                // This may fail (e.g. you select two statements in the root of a source file)
	                var start = getParentNodeInSpan(ts.getTokenAtPosition(sourceFile, span.start, /*includeJsDocComment*/ false), sourceFile, span);
	                // Do the same for the ending position
	                var end = getParentNodeInSpan(ts.findTokenOnLeftOfPosition(sourceFile, ts.textSpanEnd(span)), sourceFile, span);
	                var declarations = [];
	                // We'll modify these flags as we walk the tree to collect data
	                // about what things need to be done as part of the extraction.
	                var rangeFacts = RangeFacts.None;
	                if (!start || !end) {
	                    // cannot find either start or end node
	                    return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                }
	                if (start.parent !== end.parent) {
	                    // start and end nodes belong to different subtrees
	                    return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                }
	                if (start !== end) {
	                    // start and end should be statements and parent should be either block or a source file
	                    if (!isBlockLike(start.parent)) {
	                        return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                    }
	                    var statements = [];
	                    for (var _i = 0, _a = start.parent.statements; _i < _a.length; _i++) {
	                        var statement = _a[_i];
	                        if (statement === start || statements.length) {
	                            var errors_1 = checkNode(statement);
	                            if (errors_1) {
	                                return { errors: errors_1 };
	                            }
	                            statements.push(statement);
	                        }
	                        if (statement === end) {
	                            break;
	                        }
	                    }
	                    if (!statements.length) {
	                        // https://github.com/Microsoft/TypeScript/issues/20559
	                        // Ranges like [|case 1: break;|] will fail to populate `statements` because
	                        // they will never find `start` in `start.parent.statements`.
	                        // Consider: We could support ranges like [|case 1:|] by refining them to just
	                        // the expression.
	                        return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                    }
	                    return { targetRange: { range: statements, facts: rangeFacts, declarations: declarations } };
	                }
	                if (ts.isReturnStatement(start) && !start.expression) {
	                    // Makes no sense to extract an expression-less return statement.
	                    return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                }
	                // We have a single node (start)
	                var node = refineNode(start);
	                var errors = checkRootNode(node) || checkNode(node);
	                if (errors) {
	                    return { errors: errors };
	                }
	                return { targetRange: { range: getStatementOrExpressionRange(node), facts: rangeFacts, declarations: declarations } };
	                /**
	                 * Attempt to refine the extraction node (generally, by shrinking it) to produce better results.
	                 * @param node The unrefined extraction node.
	                 */
	                function refineNode(node) {
	                    if (ts.isReturnStatement(node)) {
	                        if (node.expression) {
	                            return node.expression;
	                        }
	                    }
	                    else if (ts.isVariableStatement(node)) {
	                        var numInitializers = 0;
	                        var lastInitializer = undefined;
	                        for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                            var declaration = _a[_i];
	                            if (declaration.initializer) {
	                                numInitializers++;
	                                lastInitializer = declaration.initializer;
	                            }
	                        }
	                        if (numInitializers === 1) {
	                            return lastInitializer;
	                        }
	                        // No special handling if there are multiple initializers.
	                    }
	                    else if (ts.isVariableDeclaration(node)) {
	                        if (node.initializer) {
	                            return node.initializer;
	                        }
	                    }
	                    return node;
	                }
	                function checkRootNode(node) {
	                    if (ts.isIdentifier(ts.isExpressionStatement(node) ? node.expression : node)) {
	                        return [ts.createDiagnosticForNode(node, Messages.cannotExtractIdentifier)];
	                    }
	                    return undefined;
	                }
	                function checkForStaticContext(nodeToCheck, containingClass) {
	                    var current = nodeToCheck;
	                    while (current !== containingClass) {
	                        if (current.kind === 151 /* PropertyDeclaration */) {
	                            if (ts.hasModifier(current, 32 /* Static */)) {
	                                rangeFacts |= RangeFacts.InStaticRegion;
	                            }
	                            break;
	                        }
	                        else if (current.kind === 148 /* Parameter */) {
	                            var ctorOrMethod = ts.getContainingFunction(current);
	                            if (ctorOrMethod.kind === 154 /* Constructor */) {
	                                rangeFacts |= RangeFacts.InStaticRegion;
	                            }
	                            break;
	                        }
	                        else if (current.kind === 153 /* MethodDeclaration */) {
	                            if (ts.hasModifier(current, 32 /* Static */)) {
	                                rangeFacts |= RangeFacts.InStaticRegion;
	                            }
	                        }
	                        current = current.parent;
	                    }
	                }
	                // Verifies whether we can actually extract this node or not.
	                function checkNode(nodeToCheck) {
	                    var PermittedJumps;
	                    (function (PermittedJumps) {
	                        PermittedJumps[PermittedJumps["None"] = 0] = "None";
	                        PermittedJumps[PermittedJumps["Break"] = 1] = "Break";
	                        PermittedJumps[PermittedJumps["Continue"] = 2] = "Continue";
	                        PermittedJumps[PermittedJumps["Return"] = 4] = "Return";
	                    })(PermittedJumps || (PermittedJumps = {}));
	                    // We believe it's true because the node is from the (unmodified) tree.
	                    ts.Debug.assert(nodeToCheck.pos <= nodeToCheck.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	                    // For understanding how skipTrivia functioned:
	                    ts.Debug.assert(!ts.positionIsSynthesized(nodeToCheck.pos), "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	                    if (!ts.isStatement(nodeToCheck) && !(ts.isExpressionNode(nodeToCheck) && isExtractableExpression(nodeToCheck))) {
	                        return [ts.createDiagnosticForNode(nodeToCheck, Messages.statementOrExpressionExpected)];
	                    }
	                    if (nodeToCheck.flags & 2097152 /* Ambient */) {
	                        return [ts.createDiagnosticForNode(nodeToCheck, Messages.cannotExtractAmbientBlock)];
	                    }
	                    // If we're in a class, see whether we're in a static region (static property initializer, static method, class constructor parameter default)
	                    var containingClass = ts.getContainingClass(nodeToCheck);
	                    if (containingClass) {
	                        checkForStaticContext(nodeToCheck, containingClass);
	                    }
	                    var errors;
	                    var permittedJumps = 4 /* Return */;
	                    var seenLabels;
	                    visit(nodeToCheck);
	                    return errors;
	                    function visit(node) {
	                        if (errors) {
	                            // already found an error - can stop now
	                            return true;
	                        }
	                        if (ts.isDeclaration(node)) {
	                            var declaringNode = (node.kind === 230 /* VariableDeclaration */) ? node.parent.parent : node;
	                            if (ts.hasModifier(declaringNode, 1 /* Export */)) {
	                                (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractExportedEntity));
	                                return true;
	                            }
	                            declarations.push(node.symbol);
	                        }
	                        // Some things can't be extracted in certain situations
	                        switch (node.kind) {
	                            case 242 /* ImportDeclaration */:
	                                (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractImport));
	                                return true;
	                            case 97 /* SuperKeyword */:
	                                // For a super *constructor call*, we have to be extracting the entire class,
	                                // but a super *method call* simply implies a 'this' reference
	                                if (node.parent.kind === 185 /* CallExpression */) {
	                                    // Super constructor call
	                                    var containingClass_1 = ts.getContainingClass(node);
	                                    if (containingClass_1.pos < span.start || containingClass_1.end >= (span.start + span.length)) {
	                                        (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractSuper));
	                                        return true;
	                                    }
	                                }
	                                else {
	                                    rangeFacts |= RangeFacts.UsesThis;
	                                }
	                                break;
	                        }
	                        if (!node || ts.isFunctionLikeDeclaration(node) || ts.isClassLike(node)) {
	                            switch (node.kind) {
	                                case 232 /* FunctionDeclaration */:
	                                case 233 /* ClassDeclaration */:
	                                    if (node.parent.kind === 272 /* SourceFile */ && node.parent.externalModuleIndicator === undefined) {
	                                        // You cannot extract global declarations
	                                        (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.functionWillNotBeVisibleInTheNewScope));
	                                    }
	                                    break;
	                            }
	                            // do not dive into functions or classes
	                            return false;
	                        }
	                        var savedPermittedJumps = permittedJumps;
	                        switch (node.kind) {
	                            case 215 /* IfStatement */:
	                                permittedJumps = 0 /* None */;
	                                break;
	                            case 228 /* TryStatement */:
	                                // forbid all jumps inside try blocks
	                                permittedJumps = 0 /* None */;
	                                break;
	                            case 211 /* Block */:
	                                if (node.parent && node.parent.kind === 228 /* TryStatement */ && node.parent.finallyBlock === node) {
	                                    // allow unconditional returns from finally blocks
	                                    permittedJumps = 4 /* Return */;
	                                }
	                                break;
	                            case 264 /* CaseClause */:
	                                // allow unlabeled break inside case clauses
	                                permittedJumps |= 1 /* Break */;
	                                break;
	                            default:
	                                if (ts.isIterationStatement(node, /*lookInLabeledStatements*/ false)) {
	                                    // allow unlabeled break/continue inside loops
	                                    permittedJumps |= 1 /* Break */ | 2 /* Continue */;
	                                }
	                                break;
	                        }
	                        switch (node.kind) {
	                            case 173 /* ThisType */:
	                            case 99 /* ThisKeyword */:
	                                rangeFacts |= RangeFacts.UsesThis;
	                                break;
	                            case 226 /* LabeledStatement */:
	                                {
	                                    var label = node.label;
	                                    (seenLabels || (seenLabels = [])).push(label.escapedText);
	                                    ts.forEachChild(node, visit);
	                                    seenLabels.pop();
	                                    break;
	                                }
	                            case 222 /* BreakStatement */:
	                            case 221 /* ContinueStatement */:
	                                {
	                                    var label = node.label;
	                                    if (label) {
	                                        if (!ts.contains(seenLabels, label.escapedText)) {
	                                            // attempts to jump to label that is not in range to be extracted
	                                            (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractRangeContainingLabeledBreakOrContinueStatementWithTargetOutsideOfTheRange));
	                                        }
	                                    }
	                                    else {
	                                        if (!(permittedJumps & (node.kind === 222 /* BreakStatement */ ? 1 /* Break */ : 2 /* Continue */))) {
	                                            // attempt to break or continue in a forbidden context
	                                            (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractRangeContainingConditionalBreakOrContinueStatements));
	                                        }
	                                    }
	                                    break;
	                                }
	                            case 195 /* AwaitExpression */:
	                                rangeFacts |= RangeFacts.IsAsyncFunction;
	                                break;
	                            case 201 /* YieldExpression */:
	                                rangeFacts |= RangeFacts.IsGenerator;
	                                break;
	                            case 223 /* ReturnStatement */:
	                                if (permittedJumps & 4 /* Return */) {
	                                    rangeFacts |= RangeFacts.HasReturn;
	                                }
	                                else {
	                                    (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractRangeContainingConditionalReturnStatement));
	                                }
	                                break;
	                            default:
	                                ts.forEachChild(node, visit);
	                                break;
	                        }
	                        permittedJumps = savedPermittedJumps;
	                    }
	                }
	            }
	            extractSymbol.getRangeToExtract = getRangeToExtract;
	            function getStatementOrExpressionRange(node) {
	                if (ts.isStatement(node)) {
	                    return [node];
	                }
	                else if (ts.isExpressionNode(node)) {
	                    // If our selection is the expression in an ExpressionStatement, expand
	                    // the selection to include the enclosing Statement (this stops us
	                    // from trying to care about the return value of the extracted function
	                    // and eliminates double semicolon insertion in certain scenarios)
	                    return ts.isExpressionStatement(node.parent) ? [node.parent] : node;
	                }
	                return undefined;
	            }
	            function isScope(node) {
	                return ts.isFunctionLikeDeclaration(node) || ts.isSourceFile(node) || ts.isModuleBlock(node) || ts.isClassLike(node);
	            }
	            /**
	             * Computes possible places we could extract the function into. For example,
	             * you may be able to extract into a class method *or* local closure *or* namespace function,
	             * depending on what's in the extracted body.
	             */
	            function collectEnclosingScopes(range) {
	                var current = isReadonlyArray(range.range) ? ts.first(range.range) : range.range;
	                if (range.facts & RangeFacts.UsesThis) {
	                    // if range uses this as keyword or as type inside the class then it can only be extracted to a method of the containing class
	                    var containingClass = ts.getContainingClass(current);
	                    if (containingClass) {
	                        var containingFunction = ts.findAncestor(current, ts.isFunctionLikeDeclaration);
	                        return containingFunction
	                            ? [containingFunction, containingClass]
	                            : [containingClass];
	                    }
	                }
	                var scopes = [];
	                while (true) {
	                    current = current.parent;
	                    // A function parameter's initializer is actually in the outer scope, not the function declaration
	                    if (current.kind === 148 /* Parameter */) {
	                        // Skip all the way to the outer scope of the function that declared this parameter
	                        current = ts.findAncestor(current, function (parent) { return ts.isFunctionLikeDeclaration(parent); }).parent;
	                    }
	                    // We want to find the nearest parent where we can place an "equivalent" sibling to the node we're extracting out of.
	                    // Walk up to the closest parent of a place where we can logically put a sibling:
	                    //  * Function declaration
	                    //  * Class declaration or expression
	                    //  * Module/namespace or source file
	                    if (isScope(current)) {
	                        scopes.push(current);
	                        if (current.kind === 272 /* SourceFile */) {
	                            return scopes;
	                        }
	                    }
	                }
	            }
	            function getFunctionExtractionAtIndex(targetRange, context, requestedChangesIndex) {
	                var _a = getPossibleExtractionsWorker(targetRange, context), scopes = _a.scopes, _b = _a.readsAndWrites, target = _b.target, usagesPerScope = _b.usagesPerScope, functionErrorsPerScope = _b.functionErrorsPerScope, exposedVariableDeclarations = _b.exposedVariableDeclarations;
	                ts.Debug.assert(!functionErrorsPerScope[requestedChangesIndex].length, "The extraction went missing? How?");
	                context.cancellationToken.throwIfCancellationRequested();
	                return extractFunctionInScope(target, scopes[requestedChangesIndex], usagesPerScope[requestedChangesIndex], exposedVariableDeclarations, targetRange, context);
	            }
	            function getConstantExtractionAtIndex(targetRange, context, requestedChangesIndex) {
	                var _a = getPossibleExtractionsWorker(targetRange, context), scopes = _a.scopes, _b = _a.readsAndWrites, target = _b.target, usagesPerScope = _b.usagesPerScope, constantErrorsPerScope = _b.constantErrorsPerScope, exposedVariableDeclarations = _b.exposedVariableDeclarations;
	                ts.Debug.assert(!constantErrorsPerScope[requestedChangesIndex].length, "The extraction went missing? How?");
	                ts.Debug.assert(exposedVariableDeclarations.length === 0, "Extract constant accepted a range containing a variable declaration?");
	                context.cancellationToken.throwIfCancellationRequested();
	                var expression = ts.isExpression(target)
	                    ? target
	                    : target.statements[0].expression;
	                return extractConstantInScope(expression, scopes[requestedChangesIndex], usagesPerScope[requestedChangesIndex], targetRange.facts, context);
	            }
	            /**
	             * Given a piece of text to extract ('targetRange'), computes a list of possible extractions.
	             * Each returned ExtractResultForScope corresponds to a possible target scope and is either a set of changes
	             * or an error explaining why we can't extract into that scope.
	             */
	            function getPossibleExtractions(targetRange, context) {
	                var _a = getPossibleExtractionsWorker(targetRange, context), scopes = _a.scopes, _b = _a.readsAndWrites, functionErrorsPerScope = _b.functionErrorsPerScope, constantErrorsPerScope = _b.constantErrorsPerScope;
	                // Need the inner type annotation to avoid https://github.com/Microsoft/TypeScript/issues/7547
	                var extractions = scopes.map(function (scope, i) {
	                    var functionDescriptionPart = getDescriptionForFunctionInScope(scope);
	                    var constantDescriptionPart = getDescriptionForConstantInScope(scope);
	                    var scopeDescription = ts.isFunctionLikeDeclaration(scope)
	                        ? getDescriptionForFunctionLikeDeclaration(scope)
	                        : ts.isClassLike(scope)
	                            ? getDescriptionForClassLikeDeclaration(scope)
	                            : getDescriptionForModuleLikeDeclaration(scope);
	                    var functionDescription;
	                    var constantDescription;
	                    if (scopeDescription === 1 /* Global */) {
	                        functionDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1_scope), [functionDescriptionPart, "global"]);
	                        constantDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1_scope), [constantDescriptionPart, "global"]);
	                    }
	                    else if (scopeDescription === 0 /* Module */) {
	                        functionDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1_scope), [functionDescriptionPart, "module"]);
	                        constantDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1_scope), [constantDescriptionPart, "module"]);
	                    }
	                    else {
	                        functionDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1), [functionDescriptionPart, scopeDescription]);
	                        constantDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1), [constantDescriptionPart, scopeDescription]);
	                    }
	                    // Customize the phrasing for the innermost scope to increase clarity.
	                    if (i === 0 && !ts.isClassLike(scope)) {
	                        constantDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_enclosing_scope), [constantDescriptionPart]);
	                    }
	                    return {
	                        functionExtraction: {
	                            description: functionDescription,
	                            errors: functionErrorsPerScope[i],
	                        },
	                        constantExtraction: {
	                            description: constantDescription,
	                            errors: constantErrorsPerScope[i],
	                        },
	                    };
	                });
	                return extractions;
	            }
	            function getPossibleExtractionsWorker(targetRange, context) {
	                var sourceFile = context.file;
	                var scopes = collectEnclosingScopes(targetRange);
	                var enclosingTextRange = getEnclosingTextRange(targetRange, sourceFile);
	                var readsAndWrites = collectReadsAndWrites(targetRange, scopes, enclosingTextRange, sourceFile, context.program.getTypeChecker(), context.cancellationToken);
	                return { scopes: scopes, readsAndWrites: readsAndWrites };
	            }
	            function getDescriptionForFunctionInScope(scope) {
	                return ts.isFunctionLikeDeclaration(scope)
	                    ? "inner function"
	                    : ts.isClassLike(scope)
	                        ? "method"
	                        : "function";
	            }
	            function getDescriptionForConstantInScope(scope) {
	                return ts.isClassLike(scope)
	                    ? "readonly field"
	                    : "constant";
	            }
	            function getDescriptionForFunctionLikeDeclaration(scope) {
	                switch (scope.kind) {
	                    case 154 /* Constructor */:
	                        return "constructor";
	                    case 190 /* FunctionExpression */:
	                    case 232 /* FunctionDeclaration */:
	                        return scope.name
	                            ? "function '" + scope.name.text + "'"
	                            : "anonymous function";
	                    case 191 /* ArrowFunction */:
	                        return "arrow function";
	                    case 153 /* MethodDeclaration */:
	                        return "method '" + scope.name.getText();
	                    case 155 /* GetAccessor */:
	                        return "'get " + scope.name.getText() + "'";
	                    case 156 /* SetAccessor */:
	                        return "'set " + scope.name.getText() + "'";
	                    default:
	                        ts.Debug.assertNever(scope);
	                }
	            }
	            function getDescriptionForClassLikeDeclaration(scope) {
	                return scope.kind === 233 /* ClassDeclaration */
	                    ? scope.name ? "class '" + scope.name.text + "'" : "anonymous class declaration"
	                    : scope.name ? "class expression '" + scope.name.text + "'" : "anonymous class expression";
	            }
	            function getDescriptionForModuleLikeDeclaration(scope) {
	                return scope.kind === 238 /* ModuleBlock */
	                    ? "namespace '" + scope.parent.name.getText() + "'"
	                    : scope.externalModuleIndicator ? 0 /* Module */ : 1 /* Global */;
	            }
	            var SpecialScope;
	            (function (SpecialScope) {
	                SpecialScope[SpecialScope["Module"] = 0] = "Module";
	                SpecialScope[SpecialScope["Global"] = 1] = "Global";
	            })(SpecialScope || (SpecialScope = {}));
	            function getUniqueName(baseName, fileText) {
	                var nameText = baseName;
	                for (var i = 1; ts.stringContains(fileText, nameText); i++) {
	                    nameText = baseName + "_" + i;
	                }
	                return nameText;
	            }
	            /**
	             * Result of 'extractRange' operation for a specific scope.
	             * Stores either a list of changes that should be applied to extract a range or a list of errors
	             */
	            function extractFunctionInScope(node, scope, _a, exposedVariableDeclarations, range, context) {
	                var usagesInScope = _a.usages, typeParameterUsages = _a.typeParameterUsages, substitutions = _a.substitutions;
	                var checker = context.program.getTypeChecker();
	                // Make a unique name for the extracted function
	                var file = scope.getSourceFile();
	                var functionNameText = getUniqueName(ts.isClassLike(scope) ? "newMethod" : "newFunction", file.text);
	                var isJS = ts.isInJavaScriptFile(scope);
	                var functionName = ts.createIdentifier(functionNameText);
	                var returnType = undefined;
	                var parameters = [];
	                var callArguments = [];
	                var writes;
	                usagesInScope.forEach(function (usage, name) {
	                    var typeNode = undefined;
	                    if (!isJS) {
	                        var type = checker.getTypeOfSymbolAtLocation(usage.symbol, usage.node);
	                        // Widen the type so we don't emit nonsense annotations like "function fn(x: 3) {"
	                        type = checker.getBaseTypeOfLiteralType(type);
	                        typeNode = checker.typeToTypeNode(type, scope, 1 /* NoTruncation */);
	                    }
	                    var paramDecl = ts.createParameter(
	                    /*decorators*/ undefined, 
	                    /*modifiers*/ undefined, 
	                    /*dotDotDotToken*/ undefined, 
	                    /*name*/ name, 
	                    /*questionToken*/ undefined, typeNode);
	                    parameters.push(paramDecl);
	                    if (usage.usage === 2 /* Write */) {
	                        (writes || (writes = [])).push(usage);
	                    }
	                    callArguments.push(ts.createIdentifier(name));
	                });
	                var typeParametersAndDeclarations = ts.arrayFrom(typeParameterUsages.values()).map(function (type) { return ({ type: type, declaration: getFirstDeclaration(type) }); });
	                var sortedTypeParametersAndDeclarations = typeParametersAndDeclarations.sort(compareTypesByDeclarationOrder);
	                var typeParameters = sortedTypeParametersAndDeclarations.length === 0
	                    ? undefined
	                    : sortedTypeParametersAndDeclarations.map(function (t) { return t.declaration; });
	                // Strictly speaking, we should check whether each name actually binds to the appropriate type
	                // parameter.  In cases of shadowing, they may not.
	                var callTypeArguments = typeParameters !== undefined
	                    ? typeParameters.map(function (decl) { return ts.createTypeReferenceNode(decl.name, /*typeArguments*/ undefined); })
	                    : undefined;
	                // Provide explicit return types for contextually-typed functions
	                // to avoid problems when there are literal types present
	                if (ts.isExpression(node) && !isJS) {
	                    var contextualType = checker.getContextualType(node);
	                    returnType = checker.typeToTypeNode(contextualType, scope, 1 /* NoTruncation */);
	                }
	                var _b = transformFunctionBody(node, exposedVariableDeclarations, writes, substitutions, !!(range.facts & RangeFacts.HasReturn)), body = _b.body, returnValueProperty = _b.returnValueProperty;
	                ts.suppressLeadingAndTrailingTrivia(body);
	                var newFunction;
	                if (ts.isClassLike(scope)) {
	                    // always create private method in TypeScript files
	                    var modifiers = isJS ? [] : [ts.createToken(112 /* PrivateKeyword */)];
	                    if (range.facts & RangeFacts.InStaticRegion) {
	                        modifiers.push(ts.createToken(115 /* StaticKeyword */));
	                    }
	                    if (range.facts & RangeFacts.IsAsyncFunction) {
	                        modifiers.push(ts.createToken(120 /* AsyncKeyword */));
	                    }
	                    newFunction = ts.createMethod(
	                    /*decorators*/ undefined, modifiers.length ? modifiers : undefined, range.facts & RangeFacts.IsGenerator ? ts.createToken(39 /* AsteriskToken */) : undefined, functionName, 
	                    /*questionToken*/ undefined, typeParameters, parameters, returnType, body);
	                }
	                else {
	                    newFunction = ts.createFunctionDeclaration(
	                    /*decorators*/ undefined, range.facts & RangeFacts.IsAsyncFunction ? [ts.createToken(120 /* AsyncKeyword */)] : undefined, range.facts & RangeFacts.IsGenerator ? ts.createToken(39 /* AsteriskToken */) : undefined, functionName, typeParameters, parameters, returnType, body);
	                }
	                var changeTracker = ts.textChanges.ChangeTracker.fromContext(context);
	                var minInsertionPos = (isReadonlyArray(range.range) ? ts.last(range.range) : range.range).end;
	                var nodeToInsertBefore = getNodeToInsertFunctionBefore(minInsertionPos, scope);
	                if (nodeToInsertBefore) {
	                    changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newFunction, /*blankLineBetween*/ true);
	                }
	                else {
	                    changeTracker.insertNodeAtEndOfScope(context.file, scope, newFunction);
	                }
	                var newNodes = [];
	                // replace range with function call
	                var called = getCalledExpression(scope, range, functionNameText);
	                var call = ts.createCall(called, callTypeArguments, // Note that no attempt is made to take advantage of type argument inference
	                callArguments);
	                if (range.facts & RangeFacts.IsGenerator) {
	                    call = ts.createYield(ts.createToken(39 /* AsteriskToken */), call);
	                }
	                if (range.facts & RangeFacts.IsAsyncFunction) {
	                    call = ts.createAwait(call);
	                }
	                if (exposedVariableDeclarations.length && !writes) {
	                    // No need to mix declarations and writes.
	                    // How could any variables be exposed if there's a return statement?
	                    ts.Debug.assert(!returnValueProperty);
	                    ts.Debug.assert(!(range.facts & RangeFacts.HasReturn));
	                    if (exposedVariableDeclarations.length === 1) {
	                        // Declaring exactly one variable: let x = newFunction();
	                        var variableDeclaration = exposedVariableDeclarations[0];
	                        newNodes.push(ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(ts.getSynthesizedDeepClone(variableDeclaration.name), /*type*/ ts.getSynthesizedDeepClone(variableDeclaration.type), /*initializer*/ call)], // TODO (acasey): test binding patterns
	                        variableDeclaration.parent.flags)));
	                    }
	                    else {
	                        // Declaring multiple variables / return properties:
	                        //   let {x, y} = newFunction();
	                        var bindingElements = [];
	                        var typeElements = [];
	                        var commonNodeFlags = exposedVariableDeclarations[0].parent.flags;
	                        var sawExplicitType = false;
	                        for (var _i = 0, exposedVariableDeclarations_1 = exposedVariableDeclarations; _i < exposedVariableDeclarations_1.length; _i++) {
	                            var variableDeclaration = exposedVariableDeclarations_1[_i];
	                            bindingElements.push(ts.createBindingElement(
	                            /*dotDotDotToken*/ undefined, 
	                            /*propertyName*/ undefined, 
	                            /*name*/ ts.getSynthesizedDeepClone(variableDeclaration.name)));
	                            // Being returned through an object literal will have widened the type.
	                            var variableType = checker.typeToTypeNode(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(variableDeclaration)), scope, 1 /* NoTruncation */);
	                            typeElements.push(ts.createPropertySignature(
	                            /*modifiers*/ undefined, 
	                            /*name*/ variableDeclaration.symbol.name, 
	                            /*questionToken*/ undefined, 
	                            /*type*/ variableType, 
	                            /*initializer*/ undefined));
	                            sawExplicitType = sawExplicitType || variableDeclaration.type !== undefined;
	                            commonNodeFlags = commonNodeFlags & variableDeclaration.parent.flags;
	                        }
	                        var typeLiteral = sawExplicitType ? ts.createTypeLiteralNode(typeElements) : undefined;
	                        if (typeLiteral) {
	                            ts.setEmitFlags(typeLiteral, 1 /* SingleLine */);
	                        }
	                        newNodes.push(ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(ts.createObjectBindingPattern(bindingElements), 
	                            /*type*/ typeLiteral, 
	                            /*initializer*/ call)], commonNodeFlags)));
	                    }
	                }
	                else if (exposedVariableDeclarations.length || writes) {
	                    if (exposedVariableDeclarations.length) {
	                        // CONSIDER: we're going to create one statement per variable, but we could actually preserve their original grouping.
	                        for (var _c = 0, exposedVariableDeclarations_2 = exposedVariableDeclarations; _c < exposedVariableDeclarations_2.length; _c++) {
	                            var variableDeclaration = exposedVariableDeclarations_2[_c];
	                            var flags = variableDeclaration.parent.flags;
	                            if (flags & 2 /* Const */) {
	                                flags = (flags & ~2 /* Const */) | 1 /* Let */;
	                            }
	                            newNodes.push(ts.createVariableStatement(
	                            /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(variableDeclaration.symbol.name, getTypeDeepCloneUnionUndefined(variableDeclaration.type))], flags)));
	                        }
	                    }
	                    if (returnValueProperty) {
	                        // has both writes and return, need to create variable declaration to hold return value;
	                        newNodes.push(ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(returnValueProperty, getTypeDeepCloneUnionUndefined(returnType))], 1 /* Let */)));
	                    }
	                    var assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
	                    if (returnValueProperty) {
	                        assignments.unshift(ts.createShorthandPropertyAssignment(returnValueProperty));
	                    }
	                    // propagate writes back
	                    if (assignments.length === 1) {
	                        // We would only have introduced a return value property if there had been
	                        // other assignments to make.
	                        ts.Debug.assert(!returnValueProperty);
	                        newNodes.push(ts.createStatement(ts.createAssignment(assignments[0].name, call)));
	                        if (range.facts & RangeFacts.HasReturn) {
	                            newNodes.push(ts.createReturn());
	                        }
	                    }
	                    else {
	                        // emit e.g.
	                        //   { a, b, __return } = newFunction(a, b);
	                        //   return __return;
	                        newNodes.push(ts.createStatement(ts.createAssignment(ts.createObjectLiteral(assignments), call)));
	                        if (returnValueProperty) {
	                            newNodes.push(ts.createReturn(ts.createIdentifier(returnValueProperty)));
	                        }
	                    }
	                }
	                else {
	                    if (range.facts & RangeFacts.HasReturn) {
	                        newNodes.push(ts.createReturn(call));
	                    }
	                    else if (isReadonlyArray(range.range)) {
	                        newNodes.push(ts.createStatement(call));
	                    }
	                    else {
	                        newNodes.push(call);
	                    }
	                }
	                if (isReadonlyArray(range.range)) {
	                    changeTracker.replaceNodeRangeWithNodes(context.file, ts.first(range.range), ts.last(range.range), newNodes);
	                }
	                else {
	                    changeTracker.replaceNodeWithNodes(context.file, range.range, newNodes);
	                }
	                var edits = changeTracker.getChanges();
	                var renameRange = isReadonlyArray(range.range) ? ts.first(range.range) : range.range;
	                var renameFilename = renameRange.getSourceFile().fileName;
	                var renameLocation = getRenameLocation(edits, renameFilename, functionNameText, /*isDeclaredBeforeUse*/ false);
	                return { renameFilename: renameFilename, renameLocation: renameLocation, edits: edits };
	                function getTypeDeepCloneUnionUndefined(typeNode) {
	                    if (typeNode === undefined) {
	                        return undefined;
	                    }
	                    var clone = ts.getSynthesizedDeepClone(typeNode);
	                    var withoutParens = clone;
	                    while (ts.isParenthesizedTypeNode(withoutParens)) {
	                        withoutParens = withoutParens.type;
	                    }
	                    return ts.isUnionTypeNode(withoutParens) && ts.find(withoutParens.types, function (t) { return t.kind === 140 /* UndefinedKeyword */; })
	                        ? clone
	                        : ts.createUnionTypeNode([clone, ts.createKeywordTypeNode(140 /* UndefinedKeyword */)]);
	                }
	            }
	            /**
	             * Result of 'extractRange' operation for a specific scope.
	             * Stores either a list of changes that should be applied to extract a range or a list of errors
	             */
	            function extractConstantInScope(node, scope, _a, rangeFacts, context) {
	                var substitutions = _a.substitutions;
	                var checker = context.program.getTypeChecker();
	                // Make a unique name for the extracted variable
	                var file = scope.getSourceFile();
	                var localNameText = getUniqueName(ts.isClassLike(scope) ? "newProperty" : "newLocal", file.text);
	                var isJS = ts.isInJavaScriptFile(scope);
	                var variableType = isJS || !checker.isContextSensitive(node)
	                    ? undefined
	                    : checker.typeToTypeNode(checker.getContextualType(node), scope, 1 /* NoTruncation */);
	                var initializer = transformConstantInitializer(node, substitutions);
	                ts.suppressLeadingAndTrailingTrivia(initializer);
	                var changeTracker = ts.textChanges.ChangeTracker.fromContext(context);
	                if (ts.isClassLike(scope)) {
	                    ts.Debug.assert(!isJS); // See CannotExtractToJSClass
	                    var modifiers = [];
	                    modifiers.push(ts.createToken(112 /* PrivateKeyword */));
	                    if (rangeFacts & RangeFacts.InStaticRegion) {
	                        modifiers.push(ts.createToken(115 /* StaticKeyword */));
	                    }
	                    modifiers.push(ts.createToken(132 /* ReadonlyKeyword */));
	                    var newVariable = ts.createProperty(
	                    /*decorators*/ undefined, modifiers, localNameText, 
	                    /*questionToken*/ undefined, variableType, initializer);
	                    var localReference = ts.createPropertyAccess(rangeFacts & RangeFacts.InStaticRegion
	                        ? ts.createIdentifier(scope.name.getText())
	                        : ts.createThis(), ts.createIdentifier(localNameText));
	                    // Declare
	                    var maxInsertionPos = node.pos;
	                    var nodeToInsertBefore = getNodeToInsertPropertyBefore(maxInsertionPos, scope);
	                    changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newVariable, /*blankLineBetween*/ true);
	                    // Consume
	                    changeTracker.replaceNode(context.file, node, localReference, ts.textChanges.useNonAdjustedPositions);
	                }
	                else {
	                    var newVariableDeclaration = ts.createVariableDeclaration(localNameText, variableType, initializer);
	                    // If the node is part of an initializer in a list of variable declarations, insert a new
	                    // variable declaration into the list (in case it depends on earlier ones).
	                    // CONSIDER: If the declaration list isn't const, we might want to split it into multiple
	                    // lists so that the newly extracted one can be const.
	                    var oldVariableDeclaration = getContainingVariableDeclarationIfInList(node, scope);
	                    if (oldVariableDeclaration) {
	                        // Declare
	                        // CONSIDER: could detect that each is on a separate line (See `extractConstant_VariableList_MultipleLines` in `extractConstants.ts`)
	                        changeTracker.insertNodeBefore(context.file, oldVariableDeclaration, newVariableDeclaration);
	                        // Consume
	                        var localReference = ts.createIdentifier(localNameText);
	                        changeTracker.replaceNode(context.file, node, localReference, ts.textChanges.useNonAdjustedPositions);
	                    }
	                    else if (node.parent.kind === 214 /* ExpressionStatement */ && scope === ts.findAncestor(node, isScope)) {
	                        // If the parent is an expression statement and the target scope is the immediately enclosing one,
	                        // replace the statement with the declaration.
	                        var newVariableStatement = ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([newVariableDeclaration], 2 /* Const */));
	                        changeTracker.replaceNode(context.file, node.parent, newVariableStatement, ts.textChanges.useNonAdjustedPositions);
	                    }
	                    else {
	                        var newVariableStatement = ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([newVariableDeclaration], 2 /* Const */));
	                        // Declare
	                        var nodeToInsertBefore = getNodeToInsertConstantBefore(node, scope);
	                        if (nodeToInsertBefore.pos === 0) {
	                            changeTracker.insertNodeAtTopOfFile(context.file, newVariableStatement, /*blankLineBetween*/ false);
	                        }
	                        else {
	                            changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newVariableStatement, /*blankLineBetween*/ false);
	                        }
	                        // Consume
	                        if (node.parent.kind === 214 /* ExpressionStatement */) {
	                            // If the parent is an expression statement, delete it.
	                            changeTracker.deleteNode(context.file, node.parent, ts.textChanges.useNonAdjustedPositions);
	                        }
	                        else {
	                            var localReference = ts.createIdentifier(localNameText);
	                            changeTracker.replaceNode(context.file, node, localReference, ts.textChanges.useNonAdjustedPositions);
	                        }
	                    }
	                }
	                var edits = changeTracker.getChanges();
	                var renameFilename = node.getSourceFile().fileName;
	                var renameLocation = getRenameLocation(edits, renameFilename, localNameText, /*isDeclaredBeforeUse*/ true);
	                return { renameFilename: renameFilename, renameLocation: renameLocation, edits: edits };
	            }
	            function getContainingVariableDeclarationIfInList(node, scope) {
	                var prevNode = undefined;
	                while (node !== undefined && node !== scope) {
	                    if (ts.isVariableDeclaration(node) &&
	                        node.initializer === prevNode &&
	                        ts.isVariableDeclarationList(node.parent) &&
	                        node.parent.declarations.length > 1) {
	                        return node;
	                    }
	                    prevNode = node;
	                    node = node.parent;
	                }
	            }
	            /**
	             * @return The index of the (only) reference to the extracted symbol.  We want the cursor
	             * to be on the reference, rather than the declaration, because it's closer to where the
	             * user was before extracting it.
	             */
	            function getRenameLocation(edits, renameFilename, functionNameText, isDeclaredBeforeUse) {
	                var delta = 0;
	                var lastPos = -1;
	                for (var _i = 0, edits_1 = edits; _i < edits_1.length; _i++) {
	                    var _a = edits_1[_i], fileName = _a.fileName, textChanges_2 = _a.textChanges;
	                    ts.Debug.assert(fileName === renameFilename);
	                    for (var _b = 0, textChanges_3 = textChanges_2; _b < textChanges_3.length; _b++) {
	                        var change = textChanges_3[_b];
	                        var span_14 = change.span, newText = change.newText;
	                        var index = newText.indexOf(functionNameText);
	                        if (index !== -1) {
	                            lastPos = span_14.start + delta + index;
	                            // If the reference comes first, return immediately.
	                            if (!isDeclaredBeforeUse) {
	                                return lastPos;
	                            }
	                        }
	                        delta += newText.length - span_14.length;
	                    }
	                }
	                // If the declaration comes first, return the position of the last occurrence.
	                ts.Debug.assert(isDeclaredBeforeUse);
	                ts.Debug.assert(lastPos >= 0);
	                return lastPos;
	            }
	            function getFirstDeclaration(type) {
	                var firstDeclaration = undefined;
	                var symbol = type.symbol;
	                if (symbol && symbol.declarations) {
	                    for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                        var declaration = _a[_i];
	                        if (firstDeclaration === undefined || declaration.pos < firstDeclaration.pos) {
	                            firstDeclaration = declaration;
	                        }
	                    }
	                }
	                return firstDeclaration;
	            }
	            function compareTypesByDeclarationOrder(_a, _b) {
	                var type1 = _a.type, declaration1 = _a.declaration;
	                var type2 = _b.type, declaration2 = _b.declaration;
	                return ts.compareProperties(declaration1, declaration2, "pos", ts.compareValues)
	                    || ts.compareStringsCaseSensitive(type1.symbol ? type1.symbol.getName() : "", type2.symbol ? type2.symbol.getName() : "")
	                    || ts.compareValues(type1.id, type2.id);
	            }
	            function getCalledExpression(scope, range, functionNameText) {
	                var functionReference = ts.createIdentifier(functionNameText);
	                if (ts.isClassLike(scope)) {
	                    var lhs = range.facts & RangeFacts.InStaticRegion ? ts.createIdentifier(scope.name.text) : ts.createThis();
	                    return ts.createPropertyAccess(lhs, functionReference);
	                }
	                else {
	                    return functionReference;
	                }
	            }
	            function transformFunctionBody(body, exposedVariableDeclarations, writes, substitutions, hasReturn) {
	                var hasWritesOrVariableDeclarations = writes !== undefined || exposedVariableDeclarations.length > 0;
	                if (ts.isBlock(body) && !hasWritesOrVariableDeclarations && substitutions.size === 0) {
	                    // already block, no declarations or writes to propagate back, no substitutions - can use node as is
	                    return { body: ts.createBlock(body.statements, /*multLine*/ true), returnValueProperty: undefined };
	                }
	                var returnValueProperty;
	                var ignoreReturns = false;
	                var statements = ts.createNodeArray(ts.isBlock(body) ? body.statements.slice(0) : [ts.isStatement(body) ? body : ts.createReturn(body)]);
	                // rewrite body if either there are writes that should be propagated back via return statements or there are substitutions
	                if (hasWritesOrVariableDeclarations || substitutions.size) {
	                    var rewrittenStatements = ts.visitNodes(statements, visitor).slice();
	                    if (hasWritesOrVariableDeclarations && !hasReturn && ts.isStatement(body)) {
	                        // add return at the end to propagate writes back in case if control flow falls out of the function body
	                        // it is ok to know that range has at least one return since it we only allow unconditional returns
	                        var assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
	                        if (assignments.length === 1) {
	                            rewrittenStatements.push(ts.createReturn(assignments[0].name));
	                        }
	                        else {
	                            rewrittenStatements.push(ts.createReturn(ts.createObjectLiteral(assignments)));
	                        }
	                    }
	                    return { body: ts.createBlock(rewrittenStatements, /*multiLine*/ true), returnValueProperty: returnValueProperty };
	                }
	                else {
	                    return { body: ts.createBlock(statements, /*multiLine*/ true), returnValueProperty: undefined };
	                }
	                function visitor(node) {
	                    if (!ignoreReturns && node.kind === 223 /* ReturnStatement */ && hasWritesOrVariableDeclarations) {
	                        var assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
	                        if (node.expression) {
	                            if (!returnValueProperty) {
	                                returnValueProperty = "__return";
	                            }
	                            assignments.unshift(ts.createPropertyAssignment(returnValueProperty, ts.visitNode(node.expression, visitor)));
	                        }
	                        if (assignments.length === 1) {
	                            return ts.createReturn(assignments[0].name);
	                        }
	                        else {
	                            return ts.createReturn(ts.createObjectLiteral(assignments));
	                        }
	                    }
	                    else {
	                        var oldIgnoreReturns = ignoreReturns;
	                        ignoreReturns = ignoreReturns || ts.isFunctionLikeDeclaration(node) || ts.isClassLike(node);
	                        var substitution = substitutions.get(ts.getNodeId(node).toString());
	                        var result = substitution ? ts.getSynthesizedDeepClone(substitution) : ts.visitEachChild(node, visitor, ts.nullTransformationContext);
	                        ignoreReturns = oldIgnoreReturns;
	                        return result;
	                    }
	                }
	            }
	            function transformConstantInitializer(initializer, substitutions) {
	                return substitutions.size
	                    ? visitor(initializer)
	                    : initializer;
	                function visitor(node) {
	                    var substitution = substitutions.get(ts.getNodeId(node).toString());
	                    return substitution ? ts.getSynthesizedDeepClone(substitution) : ts.visitEachChild(node, visitor, ts.nullTransformationContext);
	                }
	            }
	            function getStatementsOrClassElements(scope) {
	                if (ts.isFunctionLikeDeclaration(scope)) {
	                    var body = scope.body;
	                    if (ts.isBlock(body)) {
	                        return body.statements;
	                    }
	                }
	                else if (ts.isModuleBlock(scope) || ts.isSourceFile(scope)) {
	                    return scope.statements;
	                }
	                else if (ts.isClassLike(scope)) {
	                    return scope.members;
	                }
	                else {
	                    ts.assertTypeIsNever(scope);
	                }
	                return ts.emptyArray;
	            }
	            /**
	             * If `scope` contains a function after `minPos`, then return the first such function.
	             * Otherwise, return `undefined`.
	             */
	            function getNodeToInsertFunctionBefore(minPos, scope) {
	                return ts.find(getStatementsOrClassElements(scope), function (child) {
	                    return child.pos >= minPos && ts.isFunctionLikeDeclaration(child) && !ts.isConstructorDeclaration(child);
	                });
	            }
	            function getNodeToInsertPropertyBefore(maxPos, scope) {
	                var members = scope.members;
	                ts.Debug.assert(members.length > 0); // There must be at least one child, since we extracted from one.
	                var prevMember = undefined;
	                var allProperties = true;
	                for (var _i = 0, members_6 = members; _i < members_6.length; _i++) {
	                    var member = members_6[_i];
	                    if (member.pos > maxPos) {
	                        return prevMember || members[0];
	                    }
	                    if (allProperties && !ts.isPropertyDeclaration(member)) {
	                        // If it is non-vacuously true that all preceding members are properties,
	                        // insert before the current member (i.e. at the end of the list of properties).
	                        if (prevMember !== undefined) {
	                            return member;
	                        }
	                        allProperties = false;
	                    }
	                    prevMember = member;
	                }
	                ts.Debug.assert(prevMember !== undefined); // If the loop didn't return, then it did set prevMember.
	                return prevMember;
	            }
	            function getNodeToInsertConstantBefore(node, scope) {
	                ts.Debug.assert(!ts.isClassLike(scope));
	                var prevScope = undefined;
	                for (var curr = node; curr !== scope; curr = curr.parent) {
	                    if (isScope(curr)) {
	                        prevScope = curr;
	                    }
	                }
	                for (var curr = (prevScope || node).parent;; curr = curr.parent) {
	                    if (isBlockLike(curr)) {
	                        var prevStatement = undefined;
	                        for (var _i = 0, _a = curr.statements; _i < _a.length; _i++) {
	                            var statement = _a[_i];
	                            if (statement.pos > node.pos) {
	                                break;
	                            }
	                            prevStatement = statement;
	                        }
	                        if (!prevStatement && ts.isCaseClause(curr)) {
	                            // We must have been in the expression of the case clause.
	                            ts.Debug.assert(ts.isSwitchStatement(curr.parent.parent));
	                            return curr.parent.parent;
	                        }
	                        // There must be at least one statement since we started in one.
	                        ts.Debug.assert(prevStatement !== undefined);
	                        return prevStatement;
	                    }
	                    if (curr === scope) {
	                        ts.Debug.fail("Didn't encounter a block-like before encountering scope");
	                        break;
	                    }
	                }
	            }
	            function getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes) {
	                var variableAssignments = ts.map(exposedVariableDeclarations, function (v) { return ts.createShorthandPropertyAssignment(v.symbol.name); });
	                var writeAssignments = ts.map(writes, function (w) { return ts.createShorthandPropertyAssignment(w.symbol.name); });
	                return variableAssignments === undefined
	                    ? writeAssignments
	                    : writeAssignments === undefined
	                        ? variableAssignments
	                        : variableAssignments.concat(writeAssignments);
	            }
	            function isReadonlyArray(v) {
	                return ts.isArray(v);
	            }
	            /**
	             * Produces a range that spans the entirety of nodes, given a selection
	             * that might start/end in the middle of nodes.
	             *
	             * For example, when the user makes a selection like this
	             *                     v---v
	             *   var someThing = foo + bar;
	             *  this returns     ^-------^
	             */
	            function getEnclosingTextRange(targetRange, sourceFile) {
	                return isReadonlyArray(targetRange.range)
	                    ? { pos: ts.first(targetRange.range).getStart(sourceFile), end: ts.last(targetRange.range).getEnd() }
	                    : targetRange.range;
	            }
	            var Usage;
	            (function (Usage) {
	                // value should be passed to extracted method
	                Usage[Usage["Read"] = 1] = "Read";
	                // value should be passed to extracted method and propagated back
	                Usage[Usage["Write"] = 2] = "Write";
	            })(Usage || (Usage = {}));
	            function collectReadsAndWrites(targetRange, scopes, enclosingTextRange, sourceFile, checker, cancellationToken) {
	                var allTypeParameterUsages = ts.createMap(); // Key is type ID
	                var usagesPerScope = [];
	                var substitutionsPerScope = [];
	                var functionErrorsPerScope = [];
	                var constantErrorsPerScope = [];
	                var visibleDeclarationsInExtractedRange = [];
	                var exposedVariableSymbolSet = ts.createMap(); // Key is symbol ID
	                var exposedVariableDeclarations = [];
	                var firstExposedNonVariableDeclaration = undefined;
	                var expression = !isReadonlyArray(targetRange.range)
	                    ? targetRange.range
	                    : targetRange.range.length === 1 && ts.isExpressionStatement(targetRange.range[0])
	                        ? targetRange.range[0].expression
	                        : undefined;
	                var expressionDiagnostic = undefined;
	                if (expression === undefined) {
	                    var statements = targetRange.range;
	                    var start = ts.first(statements).getStart();
	                    var end = ts.last(statements).end;
	                    expressionDiagnostic = ts.createFileDiagnostic(sourceFile, start, end - start, Messages.expressionExpected);
	                }
	                else if (checker.getTypeAtLocation(expression).flags & (2048 /* Void */ | 16384 /* Never */)) {
	                    expressionDiagnostic = ts.createDiagnosticForNode(expression, Messages.uselessConstantType);
	                }
	                // initialize results
	                for (var _i = 0, scopes_1 = scopes; _i < scopes_1.length; _i++) {
	                    var scope = scopes_1[_i];
	                    usagesPerScope.push({ usages: ts.createMap(), typeParameterUsages: ts.createMap(), substitutions: ts.createMap() });
	                    substitutionsPerScope.push(ts.createMap());
	                    functionErrorsPerScope.push(ts.isFunctionLikeDeclaration(scope) && scope.kind !== 232 /* FunctionDeclaration */
	                        ? [ts.createDiagnosticForNode(scope, Messages.cannotExtractToOtherFunctionLike)]
	                        : []);
	                    var constantErrors = [];
	                    if (expressionDiagnostic) {
	                        constantErrors.push(expressionDiagnostic);
	                    }
	                    if (ts.isClassLike(scope) && ts.isInJavaScriptFile(scope)) {
	                        constantErrors.push(ts.createDiagnosticForNode(scope, Messages.cannotExtractToJSClass));
	                    }
	                    if (ts.isArrowFunction(scope) && !ts.isBlock(scope.body)) {
	                        // TODO (https://github.com/Microsoft/TypeScript/issues/18924): allow this
	                        constantErrors.push(ts.createDiagnosticForNode(scope, Messages.cannotExtractToExpressionArrowFunction));
	                    }
	                    constantErrorsPerScope.push(constantErrors);
	                }
	                var seenUsages = ts.createMap();
	                var target = isReadonlyArray(targetRange.range) ? ts.createBlock(targetRange.range) : targetRange.range;
	                var unmodifiedNode = isReadonlyArray(targetRange.range) ? ts.first(targetRange.range) : targetRange.range;
	                var inGenericContext = isInGenericContext(unmodifiedNode);
	                collectUsages(target);
	                // Unfortunately, this code takes advantage of the knowledge that the generated method
	                // will use the contextual type of an expression as the return type of the extracted
	                // method (and will therefore "use" all the types involved).
	                if (inGenericContext && !isReadonlyArray(targetRange.range)) {
	                    var contextualType = checker.getContextualType(targetRange.range);
	                    recordTypeParameterUsages(contextualType);
	                }
	                if (allTypeParameterUsages.size > 0) {
	                    var seenTypeParameterUsages = ts.createMap(); // Key is type ID
	                    var i_1 = 0;
	                    for (var curr = unmodifiedNode; curr !== undefined && i_1 < scopes.length; curr = curr.parent) {
	                        if (curr === scopes[i_1]) {
	                            // Copy current contents of seenTypeParameterUsages into scope.
	                            seenTypeParameterUsages.forEach(function (typeParameter, id) {
	                                usagesPerScope[i_1].typeParameterUsages.set(id, typeParameter);
	                            });
	                            i_1++;
	                        }
	                        // Note that we add the current node's type parameters *after* updating the corresponding scope.
	                        if (ts.isDeclarationWithTypeParameters(curr) && curr.typeParameters) {
	                            for (var _a = 0, _b = curr.typeParameters; _a < _b.length; _a++) {
	                                var typeParameterDecl = _b[_a];
	                                var typeParameter = checker.getTypeAtLocation(typeParameterDecl);
	                                if (allTypeParameterUsages.has(typeParameter.id.toString())) {
	                                    seenTypeParameterUsages.set(typeParameter.id.toString(), typeParameter);
	                                }
	                            }
	                        }
	                    }
	                    // If we didn't get through all the scopes, then there were some that weren't in our
	                    // parent chain (impossible at time of writing).  A conservative solution would be to
	                    // copy allTypeParameterUsages into all remaining scopes.
	                    ts.Debug.assert(i_1 === scopes.length);
	                }
	                // If there are any declarations in the extracted block that are used in the same enclosing
	                // lexical scope, we can't move the extraction "up" as those declarations will become unreachable
	                if (visibleDeclarationsInExtractedRange.length) {
	                    var containingLexicalScopeOfExtraction = ts.isBlockScope(scopes[0], scopes[0].parent)
	                        ? scopes[0]
	                        : ts.getEnclosingBlockScopeContainer(scopes[0]);
	                    ts.forEachChild(containingLexicalScopeOfExtraction, checkForUsedDeclarations);
	                }
	                var _loop_10 = function (i) {
	                    var scopeUsages = usagesPerScope[i];
	                    // Special case: in the innermost scope, all usages are available.
	                    // (The computed value reflects the value at the top-level of the scope, but the
	                    // local will actually be declared at the same level as the extracted expression).
	                    if (i > 0 && (scopeUsages.usages.size > 0 || scopeUsages.typeParameterUsages.size > 0)) {
	                        var errorNode = isReadonlyArray(targetRange.range) ? targetRange.range[0] : targetRange.range;
	                        constantErrorsPerScope[i].push(ts.createDiagnosticForNode(errorNode, Messages.cannotAccessVariablesFromNestedScopes));
	                    }
	                    var hasWrite = false;
	                    var readonlyClassPropertyWrite = undefined;
	                    usagesPerScope[i].usages.forEach(function (value) {
	                        if (value.usage === 2 /* Write */) {
	                            hasWrite = true;
	                            if (value.symbol.flags & 106500 /* ClassMember */ &&
	                                value.symbol.valueDeclaration &&
	                                ts.hasModifier(value.symbol.valueDeclaration, 64 /* Readonly */)) {
	                                readonlyClassPropertyWrite = value.symbol.valueDeclaration;
	                            }
	                        }
	                    });
	                    // If an expression was extracted, then there shouldn't have been any variable declarations.
	                    ts.Debug.assert(isReadonlyArray(targetRange.range) || exposedVariableDeclarations.length === 0);
	                    if (hasWrite && !isReadonlyArray(targetRange.range)) {
	                        var diag = ts.createDiagnosticForNode(targetRange.range, Messages.cannotWriteInExpression);
	                        functionErrorsPerScope[i].push(diag);
	                        constantErrorsPerScope[i].push(diag);
	                    }
	                    else if (readonlyClassPropertyWrite && i > 0) {
	                        var diag = ts.createDiagnosticForNode(readonlyClassPropertyWrite, Messages.cannotExtractReadonlyPropertyInitializerOutsideConstructor);
	                        functionErrorsPerScope[i].push(diag);
	                        constantErrorsPerScope[i].push(diag);
	                    }
	                    else if (firstExposedNonVariableDeclaration) {
	                        var diag = ts.createDiagnosticForNode(firstExposedNonVariableDeclaration, Messages.cannotExtractExportedEntity);
	                        functionErrorsPerScope[i].push(diag);
	                        constantErrorsPerScope[i].push(diag);
	                    }
	                };
	                for (var i = 0; i < scopes.length; i++) {
	                    _loop_10(i);
	                }
	                return { target: target, usagesPerScope: usagesPerScope, functionErrorsPerScope: functionErrorsPerScope, constantErrorsPerScope: constantErrorsPerScope, exposedVariableDeclarations: exposedVariableDeclarations };
	                function hasTypeParameters(node) {
	                    return ts.isDeclarationWithTypeParameters(node) &&
	                        node.typeParameters !== undefined &&
	                        node.typeParameters.length > 0;
	                }
	                function isInGenericContext(node) {
	                    for (; node; node = node.parent) {
	                        if (hasTypeParameters(node)) {
	                            return true;
	                        }
	                    }
	                    return false;
	                }
	                function recordTypeParameterUsages(type) {
	                    // PERF: This is potentially very expensive.  `type` could be a library type with
	                    // a lot of properties, each of which the walker will visit.  Unfortunately, the
	                    // solution isn't as trivial as filtering to user types because of (e.g.) Array.
	                    var symbolWalker = checker.getSymbolWalker(function () { return (cancellationToken.throwIfCancellationRequested(), true); });
	                    var visitedTypes = symbolWalker.walkType(type).visitedTypes;
	                    for (var _i = 0, visitedTypes_1 = visitedTypes; _i < visitedTypes_1.length; _i++) {
	                        var visitedType = visitedTypes_1[_i];
	                        if (visitedType.flags & 32768 /* TypeParameter */) {
	                            allTypeParameterUsages.set(visitedType.id.toString(), visitedType);
	                        }
	                    }
	                }
	                function collectUsages(node, valueUsage) {
	                    if (valueUsage === void 0) { valueUsage = 1 /* Read */; }
	                    if (inGenericContext) {
	                        var type = checker.getTypeAtLocation(node);
	                        recordTypeParameterUsages(type);
	                    }
	                    if (ts.isDeclaration(node) && node.symbol) {
	                        visibleDeclarationsInExtractedRange.push(node);
	                    }
	                    if (ts.isAssignmentExpression(node)) {
	                        // use 'write' as default usage for values
	                        collectUsages(node.left, 2 /* Write */);
	                        collectUsages(node.right);
	                    }
	                    else if (ts.isUnaryExpressionWithWrite(node)) {
	                        collectUsages(node.operand, 2 /* Write */);
	                    }
	                    else if (ts.isPropertyAccessExpression(node) || ts.isElementAccessExpression(node)) {
	                        // use 'write' as default usage for values
	                        ts.forEachChild(node, collectUsages);
	                    }
	                    else if (ts.isIdentifier(node)) {
	                        if (!node.parent) {
	                            return;
	                        }
	                        if (ts.isQualifiedName(node.parent) && node !== node.parent.left) {
	                            return;
	                        }
	                        if (ts.isPropertyAccessExpression(node.parent) && node !== node.parent.expression) {
	                            return;
	                        }
	                        recordUsage(node, valueUsage, /*isTypeNode*/ ts.isPartOfTypeNode(node));
	                    }
	                    else {
	                        ts.forEachChild(node, collectUsages);
	                    }
	                }
	                function recordUsage(n, usage, isTypeNode) {
	                    var symbolId = recordUsagebySymbol(n, usage, isTypeNode);
	                    if (symbolId) {
	                        for (var i = 0; i < scopes.length; i++) {
	                            // push substitution from map<symbolId, subst> to map<nodeId, subst> to simplify rewriting
	                            var substitution = substitutionsPerScope[i].get(symbolId);
	                            if (substitution) {
	                                usagesPerScope[i].substitutions.set(ts.getNodeId(n).toString(), substitution);
	                            }
	                        }
	                    }
	                }
	                function recordUsagebySymbol(identifier, usage, isTypeName) {
	                    var symbol = getSymbolReferencedByIdentifier(identifier);
	                    if (!symbol) {
	                        // cannot find symbol - do nothing
	                        return undefined;
	                    }
	                    var symbolId = ts.getSymbolId(symbol).toString();
	                    var lastUsage = seenUsages.get(symbolId);
	                    // there are two kinds of value usages
	                    // - reads - if range contains a read from the value located outside of the range then value should be passed as a parameter
	                    // - writes - if range contains a write to a value located outside the range the value should be passed as a parameter and
	                    //   returned as a return value
	                    // 'write' case is a superset of 'read' so if we already have processed 'write' of some symbol there is not need to handle 'read'
	                    // since all information is already recorded
	                    if (lastUsage && lastUsage >= usage) {
	                        return symbolId;
	                    }
	                    seenUsages.set(symbolId, usage);
	                    if (lastUsage) {
	                        // if we get here this means that we are trying to handle 'write' and 'read' was already processed
	                        // walk scopes and update existing records.
	                        for (var _i = 0, usagesPerScope_1 = usagesPerScope; _i < usagesPerScope_1.length; _i++) {
	                            var perScope = usagesPerScope_1[_i];
	                            var prevEntry = perScope.usages.get(identifier.text);
	                            if (prevEntry) {
	                                perScope.usages.set(identifier.text, { usage: usage, symbol: symbol, node: identifier });
	                            }
	                        }
	                        return symbolId;
	                    }
	                    // find first declaration in this file
	                    var decls = symbol.getDeclarations();
	                    var declInFile = decls && ts.find(decls, function (d) { return d.getSourceFile() === sourceFile; });
	                    if (!declInFile) {
	                        return undefined;
	                    }
	                    if (ts.rangeContainsStartEnd(enclosingTextRange, declInFile.getStart(), declInFile.end)) {
	                        // declaration is located in range to be extracted - do nothing
	                        return undefined;
	                    }
	                    if (targetRange.facts & RangeFacts.IsGenerator && usage === 2 /* Write */) {
	                        // this is write to a reference located outside of the target scope and range is extracted into generator
	                        // currently this is unsupported scenario
	                        var diag = ts.createDiagnosticForNode(identifier, Messages.cannotExtractRangeThatContainsWritesToReferencesLocatedOutsideOfTheTargetRangeInGenerators);
	                        for (var _a = 0, functionErrorsPerScope_1 = functionErrorsPerScope; _a < functionErrorsPerScope_1.length; _a++) {
	                            var errors = functionErrorsPerScope_1[_a];
	                            errors.push(diag);
	                        }
	                        for (var _b = 0, constantErrorsPerScope_1 = constantErrorsPerScope; _b < constantErrorsPerScope_1.length; _b++) {
	                            var errors = constantErrorsPerScope_1[_b];
	                            errors.push(diag);
	                        }
	                    }
	                    for (var i = 0; i < scopes.length; i++) {
	                        var scope = scopes[i];
	                        var resolvedSymbol = checker.resolveName(symbol.name, scope, symbol.flags, /*excludeGlobals*/ false);
	                        if (resolvedSymbol === symbol) {
	                            continue;
	                        }
	                        if (!substitutionsPerScope[i].has(symbolId)) {
	                            var substitution = tryReplaceWithQualifiedNameOrPropertyAccess(symbol.exportSymbol || symbol, scope, isTypeName);
	                            if (substitution) {
	                                substitutionsPerScope[i].set(symbolId, substitution);
	                            }
	                            else if (isTypeName) {
	                                // If the symbol is a type parameter that won't be in scope, we'll pass it as a type argument
	                                // so there's no problem.
	                                if (!(symbol.flags & 262144 /* TypeParameter */)) {
	                                    var diag = ts.createDiagnosticForNode(identifier, Messages.typeWillNotBeVisibleInTheNewScope);
	                                    functionErrorsPerScope[i].push(diag);
	                                    constantErrorsPerScope[i].push(diag);
	                                }
	                            }
	                            else {
	                                usagesPerScope[i].usages.set(identifier.text, { usage: usage, symbol: symbol, node: identifier });
	                            }
	                        }
	                    }
	                    return symbolId;
	                }
	                function checkForUsedDeclarations(node) {
	                    // If this node is entirely within the original extraction range, we don't need to do anything.
	                    if (node === targetRange.range || (isReadonlyArray(targetRange.range) && targetRange.range.indexOf(node) >= 0)) {
	                        return;
	                    }
	                    // Otherwise check and recurse.
	                    var sym = ts.isIdentifier(node)
	                        ? getSymbolReferencedByIdentifier(node)
	                        : checker.getSymbolAtLocation(node);
	                    if (sym) {
	                        var decl = ts.find(visibleDeclarationsInExtractedRange, function (d) { return d.symbol === sym; });
	                        if (decl) {
	                            if (ts.isVariableDeclaration(decl)) {
	                                var idString = decl.symbol.id.toString();
	                                if (!exposedVariableSymbolSet.has(idString)) {
	                                    exposedVariableDeclarations.push(decl);
	                                    exposedVariableSymbolSet.set(idString, true);
	                                }
	                            }
	                            else {
	                                // CONSIDER: this includes binding elements, which we could
	                                // expose in the same way as variables.
	                                firstExposedNonVariableDeclaration = firstExposedNonVariableDeclaration || decl;
	                            }
	                        }
	                    }
	                    ts.forEachChild(node, checkForUsedDeclarations);
	                }
	                /**
	                 * Return the symbol referenced by an identifier (even if it declares a different symbol).
	                 */
	                function getSymbolReferencedByIdentifier(identifier) {
	                    // If the identifier is both a property name and its value, we're only interested in its value
	                    // (since the name is a declaration and will be included in the extracted range).
	                    return identifier.parent && ts.isShorthandPropertyAssignment(identifier.parent) && identifier.parent.name === identifier
	                        ? checker.getShorthandAssignmentValueSymbol(identifier.parent)
	                        : checker.getSymbolAtLocation(identifier);
	                }
	                function tryReplaceWithQualifiedNameOrPropertyAccess(symbol, scopeDecl, isTypeNode) {
	                    if (!symbol) {
	                        return undefined;
	                    }
	                    var decls = symbol.getDeclarations();
	                    if (decls && decls.some(function (d) { return d.parent === scopeDecl; })) {
	                        return ts.createIdentifier(symbol.name);
	                    }
	                    var prefix = tryReplaceWithQualifiedNameOrPropertyAccess(symbol.parent, scopeDecl, isTypeNode);
	                    if (prefix === undefined) {
	                        return undefined;
	                    }
	                    return isTypeNode
	                        ? ts.createQualifiedName(prefix, ts.createIdentifier(symbol.name))
	                        : ts.createPropertyAccess(prefix, symbol.name);
	                }
	            }
	            function getParentNodeInSpan(node, file, span) {
	                if (!node)
	                    return undefined;
	                while (node.parent) {
	                    if (ts.isSourceFile(node.parent) || !spanContainsNode(span, node.parent, file)) {
	                        return node;
	                    }
	                    node = node.parent;
	                }
	            }
	            function spanContainsNode(span, node, file) {
	                return ts.textSpanContainsPosition(span, node.getStart(file)) &&
	                    node.getEnd() <= ts.textSpanEnd(span);
	            }
	            /**
	             * Computes whether or not a node represents an expression in a position where it could
	             * be extracted.
	             * The isExpression() in utilities.ts returns some false positives we need to handle,
	             * such as `import x from 'y'` -- the 'y' is a StringLiteral but is *not* an expression
	             * in the sense of something that you could extract on
	             */
	            function isExtractableExpression(node) {
	                switch (node.parent.kind) {
	                    case 271 /* EnumMember */:
	                        return false;
	                }
	                switch (node.kind) {
	                    case 9 /* StringLiteral */:
	                        return node.parent.kind !== 242 /* ImportDeclaration */ &&
	                            node.parent.kind !== 246 /* ImportSpecifier */;
	                    case 202 /* SpreadElement */:
	                    case 178 /* ObjectBindingPattern */:
	                    case 180 /* BindingElement */:
	                        return false;
	                    case 71 /* Identifier */:
	                        return node.parent.kind !== 180 /* BindingElement */ &&
	                            node.parent.kind !== 246 /* ImportSpecifier */ &&
	                            node.parent.kind !== 250 /* ExportSpecifier */;
	                }
	                return true;
	            }
	            function isBlockLike(node) {
	                switch (node.kind) {
	                    case 211 /* Block */:
	                    case 272 /* SourceFile */:
	                    case 238 /* ModuleBlock */:
	                    case 264 /* CaseClause */:
	                        return true;
	                    default:
	                        return false;
	                }
	            }
	        })(extractSymbol = refactor.extractSymbol || (refactor.extractSymbol = {}));
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var installTypesForPackage;
	        (function (installTypesForPackage) {
	            var refactorName = "Install missing types package";
	            var actionName = "install";
	            var description = "Install missing types package";
	            refactor.registerRefactor(refactorName, { getEditsForAction: getEditsForAction, getAvailableActions: getAvailableActions });
	            function getAvailableActions(context) {
	                if (ts.getStrictOptionValue(context.program.getCompilerOptions(), "noImplicitAny")) {
	                    // Then it will be available via `fixCannotFindModule`.
	                    return undefined;
	                }
	                var action = getAction(context);
	                return action && [
	                    {
	                        name: refactorName,
	                        description: description,
	                        actions: [
	                            {
	                                description: action.description,
	                                name: actionName,
	                            },
	                        ],
	                    },
	                ];
	            }
	            function getEditsForAction(context, _actionName) {
	                ts.Debug.assertEqual(actionName, _actionName);
	                var action = getAction(context); // Should be defined if we said there was an action available.
	                return {
	                    edits: [],
	                    renameFilename: undefined,
	                    renameLocation: undefined,
	                    commands: action.commands,
	                };
	            }
	            function getAction(context) {
	                var file = context.file, startPosition = context.startPosition;
	                var node = ts.getTokenAtPosition(file, startPosition, /*includeJsDocComment*/ false);
	                if (!ts.isStringLiteral(node) || !isModuleIdentifier(node)) {
	                    return undefined;
	                }
	                var resolvedTo = ts.getResolvedModule(file, node.text);
	                // Still offer to install types if it resolved to e.g. a ".js" file.
	                // `tryGetCodeActionForInstallPackageTypes` will verify that we're looking for a valid package name,
	                // so the fix won't trigger for imports of ".js" files that couldn't be better replaced by typings.
	                if (resolvedTo && ts.extensionIsTypeScript(resolvedTo.extension)) {
	                    return undefined;
	                }
	                return ts.codefix.tryGetCodeActionForInstallPackageTypes(context.host, file.fileName, node.text);
	            }
	            function isModuleIdentifier(node) {
	                switch (node.parent.kind) {
	                    case 242 /* ImportDeclaration */:
	                    case 252 /* ExternalModuleReference */:
	                        return true;
	                    default:
	                        return false;
	                }
	            }
	        })(installTypesForPackage = refactor.installTypesForPackage || (refactor.installTypesForPackage = {}));
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var installTypesForPackage;
	        (function (installTypesForPackage) {
	            var actionName = "Convert to default import";
	            var description = ts.getLocaleSpecificMessage(ts.Diagnostics.Convert_to_default_import);
	            refactor.registerRefactor(actionName, { getEditsForAction: getEditsForAction, getAvailableActions: getAvailableActions });
	            function getAvailableActions(context) {
	                var file = context.file, startPosition = context.startPosition, program = context.program;
	                if (!ts.getAllowSyntheticDefaultImports(program.getCompilerOptions())) {
	                    return undefined;
	                }
	                var importInfo = getConvertibleImportAtPosition(file, startPosition);
	                if (!importInfo) {
	                    return undefined;
	                }
	                var module = ts.getResolvedModule(file, importInfo.moduleSpecifier.text);
	                var resolvedFile = module && program.getSourceFile(module.resolvedFileName);
	                if (!(resolvedFile && resolvedFile.externalModuleIndicator && ts.isExportAssignment(resolvedFile.externalModuleIndicator) && resolvedFile.externalModuleIndicator.isExportEquals)) {
	                    return undefined;
	                }
	                return [
	                    {
	                        name: actionName,
	                        description: description,
	                        actions: [
	                            {
	                                description: description,
	                                name: actionName,
	                            },
	                        ],
	                    },
	                ];
	            }
	            function getEditsForAction(context, _actionName) {
	                var file = context.file, startPosition = context.startPosition;
	                ts.Debug.assertEqual(actionName, _actionName);
	                var importInfo = getConvertibleImportAtPosition(file, startPosition);
	                if (!importInfo) {
	                    return undefined;
	                }
	                var importStatement = importInfo.importStatement, name = importInfo.name, moduleSpecifier = importInfo.moduleSpecifier;
	                var newImportClause = ts.createImportClause(name, /*namedBindings*/ undefined);
	                var newImportStatement = ts.createImportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, newImportClause, moduleSpecifier);
	                return {
	                    edits: ts.textChanges.ChangeTracker.with(context, function (t) { return t.replaceNode(file, importStatement, newImportStatement); }),
	                    renameFilename: undefined,
	                    renameLocation: undefined,
	                };
	            }
	            function getConvertibleImportAtPosition(file, startPosition) {
	                var node = ts.getTokenAtPosition(file, startPosition, /*includeJsDocComment*/ false);
	                while (true) {
	                    switch (node.kind) {
	                        case 241 /* ImportEqualsDeclaration */:
	                            var eq = node;
	                            var moduleReference = eq.moduleReference;
	                            return moduleReference.kind === 252 /* ExternalModuleReference */ && ts.isStringLiteral(moduleReference.expression)
	                                ? { importStatement: eq, name: eq.name, moduleSpecifier: moduleReference.expression }
	                                : undefined;
	                        case 242 /* ImportDeclaration */:
	                            var d = node;
	                            var importClause = d.importClause;
	                            return importClause && !importClause.name && importClause.namedBindings.kind === 244 /* NamespaceImport */ && ts.isStringLiteral(d.moduleSpecifier)
	                                ? { importStatement: d, name: importClause.namedBindings.name, moduleSpecifier: d.moduleSpecifier }
	                                : undefined;
	                        // For known child node kinds of convertible imports, try again with parent node.
	                        case 244 /* NamespaceImport */:
	                        case 252 /* ExternalModuleReference */:
	                        case 91 /* ImportKeyword */:
	                        case 71 /* Identifier */:
	                        case 9 /* StringLiteral */:
	                        case 39 /* AsteriskToken */:
	                            break;
	                        default:
	                            return undefined;
	                    }
	                    node = node.parent;
	                }
	            }
	        })(installTypesForPackage = refactor.installTypesForPackage || (refactor.installTypesForPackage = {}));
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/// <reference path="annotateWithTypeFromJSDoc.ts" />
	/// <reference path="convertFunctionToEs6Class.ts" />
	/// <reference path="convertToEs6Module.ts" />
	/// <reference path="extractSymbol.ts" />
	/// <reference path="installTypesForPackage.ts" />
	/// <reference path="useDefaultImport.ts" />
	/// <reference path="..\compiler\program.ts"/>
	/// <reference path="..\compiler\commandLineParser.ts"/>
	/// <reference path='types.ts' />
	/// <reference path='utilities.ts' />
	/// <reference path='breakpoints.ts' />
	/// <reference path='classifier.ts' />
	/// <reference path='completions.ts' />
	/// <reference path='documentHighlights.ts' />
	/// <reference path='documentRegistry.ts' />
	/// <reference path='findAllReferences.ts' />
	/// <reference path='goToDefinition.ts' />
	/// <reference path='jsDoc.ts' />
	/// <reference path='jsTyping.ts' />
	/// <reference path='navigateTo.ts' />
	/// <reference path='navigationBar.ts' />
	/// <reference path='organizeImports.ts' />
	/// <reference path='outliningElementsCollector.ts' />
	/// <reference path='patternMatcher.ts' />
	/// <reference path='preProcess.ts' />
	/// <reference path='rename.ts' />
	/// <reference path='signatureHelp.ts' />
	/// <reference path='symbolDisplay.ts' />
	/// <reference path='transpile.ts' />
	/// <reference path='formatting\formatting.ts' />
	/// <reference path='formatting\smartIndenter.ts' />
	/// <reference path='textChanges.ts' />
	/// <reference path='codeFixProvider.ts' />
	/// <reference path='refactorProvider.ts' />
	/// <reference path='codefixes\fixes.ts' />
	/// <reference path='refactors\refactors.ts' />
	var ts;
	(function (ts) {
	    /** The version of the language service API */
	    ts.servicesVersion = "0.7";
	    function createNode(kind, pos, end, parent) {
	        var node = ts.isNodeKind(kind) ? new NodeObject(kind, pos, end) :
	            kind === 71 /* Identifier */ ? new IdentifierObject(71 /* Identifier */, pos, end) :
	                new TokenObject(kind, pos, end);
	        node.parent = parent;
	        node.flags = parent.flags & 6387712 /* ContextFlags */;
	        return node;
	    }
	    var NodeObject = /** @class */ (function () {
	        function NodeObject(kind, pos, end) {
	            this.pos = pos;
	            this.end = end;
	            this.flags = 0 /* None */;
	            this.transformFlags = undefined;
	            this.parent = undefined;
	            this.kind = kind;
	        }
	        NodeObject.prototype.assertHasRealPosition = function (message) {
	            // tslint:disable-next-line:debug-assert
	            ts.Debug.assert(!ts.positionIsSynthesized(this.pos) && !ts.positionIsSynthesized(this.end), message || "Node must have a real position for this operation");
	        };
	        NodeObject.prototype.getSourceFile = function () {
	            return ts.getSourceFileOfNode(this);
	        };
	        NodeObject.prototype.getStart = function (sourceFile, includeJsDocComment) {
	            this.assertHasRealPosition();
	            return ts.getTokenPosOfNode(this, sourceFile, includeJsDocComment);
	        };
	        NodeObject.prototype.getFullStart = function () {
	            this.assertHasRealPosition();
	            return this.pos;
	        };
	        NodeObject.prototype.getEnd = function () {
	            this.assertHasRealPosition();
	            return this.end;
	        };
	        NodeObject.prototype.getWidth = function (sourceFile) {
	            this.assertHasRealPosition();
	            return this.getEnd() - this.getStart(sourceFile);
	        };
	        NodeObject.prototype.getFullWidth = function () {
	            this.assertHasRealPosition();
	            return this.end - this.pos;
	        };
	        NodeObject.prototype.getLeadingTriviaWidth = function (sourceFile) {
	            this.assertHasRealPosition();
	            return this.getStart(sourceFile) - this.pos;
	        };
	        NodeObject.prototype.getFullText = function (sourceFile) {
	            this.assertHasRealPosition();
	            return (sourceFile || this.getSourceFile()).text.substring(this.pos, this.end);
	        };
	        NodeObject.prototype.getText = function (sourceFile) {
	            this.assertHasRealPosition();
	            if (!sourceFile) {
	                sourceFile = this.getSourceFile();
	            }
	            return sourceFile.text.substring(this.getStart(sourceFile), this.getEnd());
	        };
	        NodeObject.prototype.addSyntheticNodes = function (nodes, pos, end) {
	            ts.scanner.setTextPos(pos);
	            while (pos < end) {
	                var token = ts.scanner.scan();
	                var textPos = ts.scanner.getTextPos();
	                if (textPos <= end) {
	                    if (token === 71 /* Identifier */) {
	                        ts.Debug.fail("Did not expect " + ts.Debug.showSyntaxKind(this) + " to have an Identifier in its trivia");
	                    }
	                    nodes.push(createNode(token, pos, textPos, this));
	                }
	                pos = textPos;
	                if (token === 1 /* EndOfFileToken */) {
	                    break;
	                }
	            }
	            return pos;
	        };
	        NodeObject.prototype.createSyntaxList = function (nodes) {
	            var list = createNode(293 /* SyntaxList */, nodes.pos, nodes.end, this);
	            list._children = [];
	            var pos = nodes.pos;
	            for (var _i = 0, nodes_9 = nodes; _i < nodes_9.length; _i++) {
	                var node = nodes_9[_i];
	                if (pos < node.pos) {
	                    pos = this.addSyntheticNodes(list._children, pos, node.pos);
	                }
	                list._children.push(node);
	                pos = node.end;
	            }
	            if (pos < nodes.end) {
	                this.addSyntheticNodes(list._children, pos, nodes.end);
	            }
	            return list;
	        };
	        NodeObject.prototype.createChildren = function (sourceFile) {
	            var _this = this;
	            if (!ts.isNodeKind(this.kind)) {
	                this._children = ts.emptyArray;
	                return;
	            }
	            if (ts.isJSDocCommentContainingNode(this)) {
	                /** Don't add trivia for "tokens" since this is in a comment. */
	                var children_4 = [];
	                this.forEachChild(function (child) { children_4.push(child); });
	                this._children = children_4;
	                return;
	            }
	            var children = [];
	            ts.scanner.setText((sourceFile || this.getSourceFile()).text);
	            var pos = this.pos;
	            var processNode = function (node) {
	                pos = _this.addSyntheticNodes(children, pos, node.pos);
	                children.push(node);
	                pos = node.end;
	            };
	            var processNodes = function (nodes) {
	                if (pos < nodes.pos) {
	                    pos = _this.addSyntheticNodes(children, pos, nodes.pos);
	                }
	                children.push(_this.createSyntaxList(nodes));
	                pos = nodes.end;
	            };
	            // jsDocComments need to be the first children
	            if (this.jsDoc) {
	                for (var _i = 0, _a = this.jsDoc; _i < _a.length; _i++) {
	                    var jsDocComment = _a[_i];
	                    processNode(jsDocComment);
	                }
	            }
	            // For syntactic classifications, all trivia are classcified together, including jsdoc comments.
	            // For that to work, the jsdoc comments should still be the leading trivia of the first child.
	            // Restoring the scanner position ensures that.
	            pos = this.pos;
	            ts.forEachChild(this, processNode, processNodes);
	            if (pos < this.end) {
	                this.addSyntheticNodes(children, pos, this.end);
	            }
	            ts.scanner.setText(undefined);
	            this._children = children;
	        };
	        NodeObject.prototype.getChildCount = function (sourceFile) {
	            this.assertHasRealPosition();
	            if (!this._children)
	                this.createChildren(sourceFile);
	            return this._children.length;
	        };
	        NodeObject.prototype.getChildAt = function (index, sourceFile) {
	            this.assertHasRealPosition();
	            if (!this._children)
	                this.createChildren(sourceFile);
	            return this._children[index];
	        };
	        NodeObject.prototype.getChildren = function (sourceFile) {
	            this.assertHasRealPosition("Node without a real position cannot be scanned and thus has no token nodes - use forEachChild and collect the result if that's fine");
	            if (!this._children)
	                this.createChildren(sourceFile);
	            return this._children;
	        };
	        NodeObject.prototype.getFirstToken = function (sourceFile) {
	            this.assertHasRealPosition();
	            var children = this.getChildren(sourceFile);
	            if (!children.length) {
	                return undefined;
	            }
	            var child = ts.find(children, function (kid) { return kid.kind < 274 /* FirstJSDocNode */ || kid.kind > 292 /* LastJSDocNode */; });
	            return child.kind < 145 /* FirstNode */ ?
	                child :
	                child.getFirstToken(sourceFile);
	        };
	        NodeObject.prototype.getLastToken = function (sourceFile) {
	            this.assertHasRealPosition();
	            var children = this.getChildren(sourceFile);
	            var child = ts.lastOrUndefined(children);
	            if (!child) {
	                return undefined;
	            }
	            return child.kind < 145 /* FirstNode */ ? child : child.getLastToken(sourceFile);
	        };
	        NodeObject.prototype.forEachChild = function (cbNode, cbNodeArray) {
	            return ts.forEachChild(this, cbNode, cbNodeArray);
	        };
	        return NodeObject;
	    }());
	    var TokenOrIdentifierObject = /** @class */ (function () {
	        function TokenOrIdentifierObject(pos, end) {
	            // Set properties in same order as NodeObject
	            this.pos = pos;
	            this.end = end;
	            this.flags = 0 /* None */;
	            this.parent = undefined;
	        }
	        TokenOrIdentifierObject.prototype.getSourceFile = function () {
	            return ts.getSourceFileOfNode(this);
	        };
	        TokenOrIdentifierObject.prototype.getStart = function (sourceFile, includeJsDocComment) {
	            return ts.getTokenPosOfNode(this, sourceFile, includeJsDocComment);
	        };
	        TokenOrIdentifierObject.prototype.getFullStart = function () {
	            return this.pos;
	        };
	        TokenOrIdentifierObject.prototype.getEnd = function () {
	            return this.end;
	        };
	        TokenOrIdentifierObject.prototype.getWidth = function (sourceFile) {
	            return this.getEnd() - this.getStart(sourceFile);
	        };
	        TokenOrIdentifierObject.prototype.getFullWidth = function () {
	            return this.end - this.pos;
	        };
	        TokenOrIdentifierObject.prototype.getLeadingTriviaWidth = function (sourceFile) {
	            return this.getStart(sourceFile) - this.pos;
	        };
	        TokenOrIdentifierObject.prototype.getFullText = function (sourceFile) {
	            return (sourceFile || this.getSourceFile()).text.substring(this.pos, this.end);
	        };
	        TokenOrIdentifierObject.prototype.getText = function (sourceFile) {
	            if (!sourceFile) {
	                sourceFile = this.getSourceFile();
	            }
	            return sourceFile.text.substring(this.getStart(sourceFile), this.getEnd());
	        };
	        TokenOrIdentifierObject.prototype.getChildCount = function () {
	            return 0;
	        };
	        TokenOrIdentifierObject.prototype.getChildAt = function () {
	            return undefined;
	        };
	        TokenOrIdentifierObject.prototype.getChildren = function () {
	            return ts.emptyArray;
	        };
	        TokenOrIdentifierObject.prototype.getFirstToken = function () {
	            return undefined;
	        };
	        TokenOrIdentifierObject.prototype.getLastToken = function () {
	            return undefined;
	        };
	        TokenOrIdentifierObject.prototype.forEachChild = function () {
	            return undefined;
	        };
	        return TokenOrIdentifierObject;
	    }());
	    var SymbolObject = /** @class */ (function () {
	        function SymbolObject(flags, name) {
	            this.flags = flags;
	            this.escapedName = name;
	        }
	        SymbolObject.prototype.getFlags = function () {
	            return this.flags;
	        };
	        Object.defineProperty(SymbolObject.prototype, "name", {
	            get: function () {
	                return ts.symbolName(this);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        SymbolObject.prototype.getEscapedName = function () {
	            return this.escapedName;
	        };
	        SymbolObject.prototype.getName = function () {
	            return this.name;
	        };
	        SymbolObject.prototype.getDeclarations = function () {
	            return this.declarations;
	        };
	        SymbolObject.prototype.getDocumentationComment = function (checker) {
	            if (this.documentationComment === undefined) {
	                if (this.declarations) {
	                    this.documentationComment = ts.JsDoc.getJsDocCommentsFromDeclarations(this.declarations);
	                    if (this.documentationComment.length === 0 || this.declarations.some(hasJSDocInheritDocTag)) {
	                        if (checker) {
	                            for (var _i = 0, _a = this.declarations; _i < _a.length; _i++) {
	                                var declaration = _a[_i];
	                                var inheritedDocs = findInheritedJSDocComments(declaration, this.getName(), checker);
	                                if (inheritedDocs.length > 0) {
	                                    if (this.documentationComment.length > 0) {
	                                        inheritedDocs.push(ts.lineBreakPart());
	                                    }
	                                    this.documentationComment = ts.concatenate(inheritedDocs, this.documentationComment);
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                }
	                else {
	                    this.documentationComment = [];
	                }
	            }
	            return this.documentationComment;
	        };
	        SymbolObject.prototype.getJsDocTags = function () {
	            if (this.tags === undefined) {
	                this.tags = ts.JsDoc.getJsDocTagsFromDeclarations(this.declarations);
	            }
	            return this.tags;
	        };
	        return SymbolObject;
	    }());
	    var TokenObject = /** @class */ (function (_super) {
	        __extends(TokenObject, _super);
	        function TokenObject(kind, pos, end) {
	            var _this = _super.call(this, pos, end) || this;
	            _this.kind = kind;
	            return _this;
	        }
	        return TokenObject;
	    }(TokenOrIdentifierObject));
	    var IdentifierObject = /** @class */ (function (_super) {
	        __extends(IdentifierObject, _super);
	        function IdentifierObject(_kind, pos, end) {
	            return _super.call(this, pos, end) || this;
	        }
	        Object.defineProperty(IdentifierObject.prototype, "text", {
	            get: function () {
	                return ts.idText(this);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return IdentifierObject;
	    }(TokenOrIdentifierObject));
	    IdentifierObject.prototype.kind = 71 /* Identifier */;
	    var TypeObject = /** @class */ (function () {
	        function TypeObject(checker, flags) {
	            this.checker = checker;
	            this.flags = flags;
	        }
	        TypeObject.prototype.getFlags = function () {
	            return this.flags;
	        };
	        TypeObject.prototype.getSymbol = function () {
	            return this.symbol;
	        };
	        TypeObject.prototype.getProperties = function () {
	            return this.checker.getPropertiesOfType(this);
	        };
	        TypeObject.prototype.getProperty = function (propertyName) {
	            return this.checker.getPropertyOfType(this, propertyName);
	        };
	        TypeObject.prototype.getApparentProperties = function () {
	            return this.checker.getAugmentedPropertiesOfType(this);
	        };
	        TypeObject.prototype.getCallSignatures = function () {
	            return this.checker.getSignaturesOfType(this, 0 /* Call */);
	        };
	        TypeObject.prototype.getConstructSignatures = function () {
	            return this.checker.getSignaturesOfType(this, 1 /* Construct */);
	        };
	        TypeObject.prototype.getStringIndexType = function () {
	            return this.checker.getIndexTypeOfType(this, 0 /* String */);
	        };
	        TypeObject.prototype.getNumberIndexType = function () {
	            return this.checker.getIndexTypeOfType(this, 1 /* Number */);
	        };
	        TypeObject.prototype.getBaseTypes = function () {
	            return this.flags & 65536 /* Object */ && this.objectFlags & (1 /* Class */ | 2 /* Interface */)
	                ? this.checker.getBaseTypes(this)
	                : undefined;
	        };
	        TypeObject.prototype.getNonNullableType = function () {
	            return this.checker.getNonNullableType(this);
	        };
	        TypeObject.prototype.getConstraint = function () {
	            return this.checker.getBaseConstraintOfType(this);
	        };
	        TypeObject.prototype.getDefault = function () {
	            return this.checker.getDefaultFromTypeParameter(this);
	        };
	        return TypeObject;
	    }());
	    var SignatureObject = /** @class */ (function () {
	        function SignatureObject(checker) {
	            this.checker = checker;
	        }
	        SignatureObject.prototype.getDeclaration = function () {
	            return this.declaration;
	        };
	        SignatureObject.prototype.getTypeParameters = function () {
	            return this.typeParameters;
	        };
	        SignatureObject.prototype.getParameters = function () {
	            return this.parameters;
	        };
	        SignatureObject.prototype.getReturnType = function () {
	            return this.checker.getReturnTypeOfSignature(this);
	        };
	        SignatureObject.prototype.getDocumentationComment = function () {
	            if (this.documentationComment === undefined) {
	                if (this.declaration) {
	                    this.documentationComment = ts.JsDoc.getJsDocCommentsFromDeclarations([this.declaration]);
	                    if (this.documentationComment.length === 0 || hasJSDocInheritDocTag(this.declaration)) {
	                        var inheritedDocs = findInheritedJSDocComments(this.declaration, this.declaration.symbol.getName(), this.checker);
	                        if (this.documentationComment.length > 0) {
	                            inheritedDocs.push(ts.lineBreakPart());
	                        }
	                        this.documentationComment = ts.concatenate(inheritedDocs, this.documentationComment);
	                    }
	                }
	                else {
	                    this.documentationComment = [];
	                }
	            }
	            return this.documentationComment;
	        };
	        SignatureObject.prototype.getJsDocTags = function () {
	            if (this.jsDocTags === undefined) {
	                this.jsDocTags = this.declaration ? ts.JsDoc.getJsDocTagsFromDeclarations([this.declaration]) : [];
	            }
	            return this.jsDocTags;
	        };
	        return SignatureObject;
	    }());
	    /**
	     * Returns whether or not the given node has a JSDoc "inheritDoc" tag on it.
	     * @param node the Node in question.
	     * @returns `true` if `node` has a JSDoc "inheritDoc" tag on it, otherwise `false`.
	     */
	    function hasJSDocInheritDocTag(node) {
	        return ts.getJSDocTags(node).some(function (tag) { return tag.tagName.text === "inheritDoc"; });
	    }
	    /**
	     * Attempts to find JSDoc comments for possibly-inherited properties.  Checks superclasses then traverses
	     * implemented interfaces until a symbol is found with the same name and with documentation.
	     * @param declaration The possibly-inherited declaration to find comments for.
	     * @param propertyName The name of the possibly-inherited property.
	     * @param typeChecker A TypeChecker, used to find inherited properties.
	     * @returns A filled array of documentation comments if any were found, otherwise an empty array.
	     */
	    function findInheritedJSDocComments(declaration, propertyName, typeChecker) {
	        var foundDocs = false;
	        return ts.flatMap(getAllSuperTypeNodes(declaration), function (superTypeNode) {
	            if (foundDocs) {
	                return ts.emptyArray;
	            }
	            var superType = typeChecker.getTypeAtLocation(superTypeNode);
	            if (!superType) {
	                return ts.emptyArray;
	            }
	            var baseProperty = typeChecker.getPropertyOfType(superType, propertyName);
	            if (!baseProperty) {
	                return ts.emptyArray;
	            }
	            var inheritedDocs = baseProperty.getDocumentationComment(typeChecker);
	            foundDocs = inheritedDocs.length > 0;
	            return inheritedDocs;
	        });
	    }
	    /**
	     * Finds and returns the `TypeNode` for all super classes and implemented interfaces given a declaration.
	     * @param declaration The possibly-inherited declaration.
	     * @returns A filled array of `TypeNode`s containing all super classes and implemented interfaces if any exist, otherwise an empty array.
	     */
	    function getAllSuperTypeNodes(declaration) {
	        var container = declaration.parent;
	        if (!container || (!ts.isClassDeclaration(container) && !ts.isInterfaceDeclaration(container))) {
	            return ts.emptyArray;
	        }
	        var extended = ts.getClassExtendsHeritageClauseElement(container);
	        var types = extended ? [extended] : ts.emptyArray;
	        return ts.isClassLike(container) ? ts.concatenate(types, ts.getClassImplementsHeritageClauseElements(container)) : types;
	    }
	    var SourceFileObject = /** @class */ (function (_super) {
	        __extends(SourceFileObject, _super);
	        function SourceFileObject(kind, pos, end) {
	            return _super.call(this, kind, pos, end) || this;
	        }
	        SourceFileObject.prototype.update = function (newText, textChangeRange) {
	            return ts.updateSourceFile(this, newText, textChangeRange);
	        };
	        SourceFileObject.prototype.getLineAndCharacterOfPosition = function (position) {
	            return ts.getLineAndCharacterOfPosition(this, position);
	        };
	        SourceFileObject.prototype.getLineStarts = function () {
	            return ts.getLineStarts(this);
	        };
	        SourceFileObject.prototype.getPositionOfLineAndCharacter = function (line, character) {
	            return ts.getPositionOfLineAndCharacter(this, line, character);
	        };
	        SourceFileObject.prototype.getLineEndOfPosition = function (pos) {
	            var line = this.getLineAndCharacterOfPosition(pos).line;
	            var lineStarts = this.getLineStarts();
	            var lastCharPos;
	            if (line + 1 >= lineStarts.length) {
	                lastCharPos = this.getEnd();
	            }
	            if (!lastCharPos) {
	                lastCharPos = lineStarts[line + 1] - 1;
	            }
	            var fullText = this.getFullText();
	            // if the new line is "\r\n", we should return the last non-new-line-character position
	            return fullText[lastCharPos] === "\n" && fullText[lastCharPos - 1] === "\r" ? lastCharPos - 1 : lastCharPos;
	        };
	        SourceFileObject.prototype.getNamedDeclarations = function () {
	            if (!this.namedDeclarations) {
	                this.namedDeclarations = this.computeNamedDeclarations();
	            }
	            return this.namedDeclarations;
	        };
	        SourceFileObject.prototype.computeNamedDeclarations = function () {
	            var result = ts.createMultiMap();
	            ts.forEachChild(this, visit);
	            return result;
	            function addDeclaration(declaration) {
	                var name = getDeclarationName(declaration);
	                if (name) {
	                    result.add(name, declaration);
	                }
	            }
	            function getDeclarations(name) {
	                var declarations = result.get(name);
	                if (!declarations) {
	                    result.set(name, declarations = []);
	                }
	                return declarations;
	            }
	            function getDeclarationName(declaration) {
	                var name = ts.getNameOfDeclaration(declaration);
	                return name && (ts.isPropertyNameLiteral(name) ? ts.getTextOfIdentifierOrLiteral(name) :
	                    name.kind === 146 /* ComputedPropertyName */ && ts.isPropertyAccessExpression(name.expression) ? name.expression.name.text : undefined);
	            }
	            function visit(node) {
	                switch (node.kind) {
	                    case 232 /* FunctionDeclaration */:
	                    case 190 /* FunctionExpression */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        var functionDeclaration = node;
	                        var declarationName = getDeclarationName(functionDeclaration);
	                        if (declarationName) {
	                            var declarations = getDeclarations(declarationName);
	                            var lastDeclaration = ts.lastOrUndefined(declarations);
	                            // Check whether this declaration belongs to an "overload group".
	                            if (lastDeclaration && functionDeclaration.parent === lastDeclaration.parent && functionDeclaration.symbol === lastDeclaration.symbol) {
	                                // Overwrite the last declaration if it was an overload
	                                // and this one is an implementation.
	                                if (functionDeclaration.body && !lastDeclaration.body) {
	                                    declarations[declarations.length - 1] = functionDeclaration;
	                                }
	                            }
	                            else {
	                                declarations.push(functionDeclaration);
	                            }
	                        }
	                        ts.forEachChild(node, visit);
	                        break;
	                    case 233 /* ClassDeclaration */:
	                    case 203 /* ClassExpression */:
	                    case 234 /* InterfaceDeclaration */:
	                    case 235 /* TypeAliasDeclaration */:
	                    case 236 /* EnumDeclaration */:
	                    case 237 /* ModuleDeclaration */:
	                    case 241 /* ImportEqualsDeclaration */:
	                    case 250 /* ExportSpecifier */:
	                    case 246 /* ImportSpecifier */:
	                    case 243 /* ImportClause */:
	                    case 244 /* NamespaceImport */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 165 /* TypeLiteral */:
	                        addDeclaration(node);
	                        ts.forEachChild(node, visit);
	                        break;
	                    case 148 /* Parameter */:
	                        // Only consider parameter properties
	                        if (!ts.hasModifier(node, 92 /* ParameterPropertyModifier */)) {
	                            break;
	                        }
	                    // falls through
	                    case 230 /* VariableDeclaration */:
	                    case 180 /* BindingElement */: {
	                        var decl = node;
	                        if (ts.isBindingPattern(decl.name)) {
	                            ts.forEachChild(decl.name, visit);
	                            break;
	                        }
	                        if (decl.initializer) {
	                            visit(decl.initializer);
	                        }
	                    }
	                    // falls through
	                    case 271 /* EnumMember */:
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                        addDeclaration(node);
	                        break;
	                    case 248 /* ExportDeclaration */:
	                        // Handle named exports case e.g.:
	                        //    export {a, b as B} from "mod";
	                        if (node.exportClause) {
	                            ts.forEach(node.exportClause.elements, visit);
	                        }
	                        break;
	                    case 242 /* ImportDeclaration */:
	                        var importClause = node.importClause;
	                        if (importClause) {
	                            // Handle default import case e.g.:
	                            //    import d from "mod";
	                            if (importClause.name) {
	                                addDeclaration(importClause);
	                            }
	                            // Handle named bindings in imports e.g.:
	                            //    import * as NS from "mod";
	                            //    import {a, b as B} from "mod";
	                            if (importClause.namedBindings) {
	                                if (importClause.namedBindings.kind === 244 /* NamespaceImport */) {
	                                    addDeclaration(importClause.namedBindings);
	                                }
	                                else {
	                                    ts.forEach(importClause.namedBindings.elements, visit);
	                                }
	                            }
	                        }
	                        break;
	                    case 198 /* BinaryExpression */:
	                        if (ts.getSpecialPropertyAssignmentKind(node) !== 0 /* None */) {
	                            addDeclaration(node);
	                        }
	                    // falls through
	                    default:
	                        ts.forEachChild(node, visit);
	                }
	            }
	        };
	        return SourceFileObject;
	    }(NodeObject));
	    var SourceMapSourceObject = /** @class */ (function () {
	        function SourceMapSourceObject(fileName, text, skipTrivia) {
	            this.fileName = fileName;
	            this.text = text;
	            this.skipTrivia = skipTrivia;
	        }
	        SourceMapSourceObject.prototype.getLineAndCharacterOfPosition = function (pos) {
	            return ts.getLineAndCharacterOfPosition(this, pos);
	        };
	        return SourceMapSourceObject;
	    }());
	    function getServicesObjectAllocator() {
	        return {
	            getNodeConstructor: function () { return NodeObject; },
	            getTokenConstructor: function () { return TokenObject; },
	            getIdentifierConstructor: function () { return IdentifierObject; },
	            getSourceFileConstructor: function () { return SourceFileObject; },
	            getSymbolConstructor: function () { return SymbolObject; },
	            getTypeConstructor: function () { return TypeObject; },
	            getSignatureConstructor: function () { return SignatureObject; },
	            getSourceMapSourceConstructor: function () { return SourceMapSourceObject; },
	        };
	    }
	    function toEditorSettings(optionsAsMap) {
	        var allPropertiesAreCamelCased = true;
	        for (var key in optionsAsMap) {
	            if (ts.hasProperty(optionsAsMap, key) && !isCamelCase(key)) {
	                allPropertiesAreCamelCased = false;
	                break;
	            }
	        }
	        if (allPropertiesAreCamelCased) {
	            return optionsAsMap;
	        }
	        var settings = {};
	        for (var key in optionsAsMap) {
	            if (ts.hasProperty(optionsAsMap, key)) {
	                var newKey = isCamelCase(key) ? key : key.charAt(0).toLowerCase() + key.substr(1);
	                settings[newKey] = optionsAsMap[key];
	            }
	        }
	        return settings;
	    }
	    ts.toEditorSettings = toEditorSettings;
	    function isCamelCase(s) {
	        return !s.length || s.charAt(0) === s.charAt(0).toLowerCase();
	    }
	    function displayPartsToString(displayParts) {
	        if (displayParts) {
	            return ts.map(displayParts, function (displayPart) { return displayPart.text; }).join("");
	        }
	        return "";
	    }
	    ts.displayPartsToString = displayPartsToString;
	    function getDefaultCompilerOptions() {
	        // Always default to "ScriptTarget.ES5" for the language service
	        return {
	            target: 1 /* ES5 */,
	            jsx: 1 /* Preserve */
	        };
	    }
	    ts.getDefaultCompilerOptions = getDefaultCompilerOptions;
	    function getSupportedCodeFixes() {
	        return ts.codefix.getSupportedErrorCodes();
	    }
	    ts.getSupportedCodeFixes = getSupportedCodeFixes;
	    // Cache host information about script Should be refreshed
	    // at each language service public entry point, since we don't know when
	    // the set of scripts handled by the host changes.
	    var HostCache = /** @class */ (function () {
	        function HostCache(host, getCanonicalFileName) {
	            this.host = host;
	            // script id => script index
	            this.currentDirectory = host.getCurrentDirectory();
	            this.fileNameToEntry = ts.createMap();
	            // Initialize the list with the root file names
	            var rootFileNames = host.getScriptFileNames();
	            for (var _i = 0, rootFileNames_1 = rootFileNames; _i < rootFileNames_1.length; _i++) {
	                var fileName = rootFileNames_1[_i];
	                this.createEntry(fileName, ts.toPath(fileName, this.currentDirectory, getCanonicalFileName));
	            }
	            // store the compilation settings
	            this._compilationSettings = host.getCompilationSettings() || getDefaultCompilerOptions();
	        }
	        HostCache.prototype.compilationSettings = function () {
	            return this._compilationSettings;
	        };
	        HostCache.prototype.createEntry = function (fileName, path) {
	            var entry;
	            var scriptSnapshot = this.host.getScriptSnapshot(fileName);
	            if (scriptSnapshot) {
	                entry = {
	                    hostFileName: fileName,
	                    version: this.host.getScriptVersion(fileName),
	                    scriptSnapshot: scriptSnapshot,
	                    scriptKind: ts.getScriptKind(fileName, this.host)
	                };
	            }
	            else {
	                entry = fileName;
	            }
	            this.fileNameToEntry.set(path, entry);
	            return entry;
	        };
	        HostCache.prototype.getEntryByPath = function (path) {
	            return this.fileNameToEntry.get(path);
	        };
	        HostCache.prototype.getHostFileInformation = function (path) {
	            var entry = this.fileNameToEntry.get(path);
	            return !ts.isString(entry) ? entry : undefined;
	        };
	        HostCache.prototype.getOrCreateEntryByPath = function (fileName, path) {
	            var info = this.getEntryByPath(path) || this.createEntry(fileName, path);
	            return ts.isString(info) ? undefined : info;
	        };
	        HostCache.prototype.getRootFileNames = function () {
	            return ts.arrayFrom(this.fileNameToEntry.values(), function (entry) {
	                return ts.isString(entry) ? entry : entry.hostFileName;
	            });
	        };
	        HostCache.prototype.getVersion = function (path) {
	            var file = this.getHostFileInformation(path);
	            return file && file.version;
	        };
	        HostCache.prototype.getScriptSnapshot = function (path) {
	            var file = this.getHostFileInformation(path);
	            return file && file.scriptSnapshot;
	        };
	        return HostCache;
	    }());
	    var SyntaxTreeCache = /** @class */ (function () {
	        function SyntaxTreeCache(host) {
	            this.host = host;
	        }
	        SyntaxTreeCache.prototype.getCurrentSourceFile = function (fileName) {
	            var scriptSnapshot = this.host.getScriptSnapshot(fileName);
	            if (!scriptSnapshot) {
	                // The host does not know about this file.
	                throw new Error("Could not find file: '" + fileName + "'.");
	            }
	            var scriptKind = ts.getScriptKind(fileName, this.host);
	            var version = this.host.getScriptVersion(fileName);
	            var sourceFile;
	            if (this.currentFileName !== fileName) {
	                // This is a new file, just parse it
	                sourceFile = createLanguageServiceSourceFile(fileName, scriptSnapshot, 6 /* Latest */, version, /*setNodeParents*/ true, scriptKind);
	            }
	            else if (this.currentFileVersion !== version) {
	                // This is the same file, just a newer version. Incrementally parse the file.
	                var editRange = scriptSnapshot.getChangeRange(this.currentFileScriptSnapshot);
	                sourceFile = updateLanguageServiceSourceFile(this.currentSourceFile, scriptSnapshot, version, editRange);
	            }
	            if (sourceFile) {
	                // All done, ensure state is up to date
	                this.currentFileVersion = version;
	                this.currentFileName = fileName;
	                this.currentFileScriptSnapshot = scriptSnapshot;
	                this.currentSourceFile = sourceFile;
	            }
	            return this.currentSourceFile;
	        };
	        return SyntaxTreeCache;
	    }());
	    function setSourceFileFields(sourceFile, scriptSnapshot, version) {
	        sourceFile.version = version;
	        sourceFile.scriptSnapshot = scriptSnapshot;
	    }
	    function createLanguageServiceSourceFile(fileName, scriptSnapshot, scriptTarget, version, setNodeParents, scriptKind) {
	        var sourceFile = ts.createSourceFile(fileName, ts.getSnapshotText(scriptSnapshot), scriptTarget, setNodeParents, scriptKind);
	        setSourceFileFields(sourceFile, scriptSnapshot, version);
	        return sourceFile;
	    }
	    ts.createLanguageServiceSourceFile = createLanguageServiceSourceFile;
	    ts.disableIncrementalParsing = false;
	    function updateLanguageServiceSourceFile(sourceFile, scriptSnapshot, version, textChangeRange, aggressiveChecks) {
	        // If we were given a text change range, and our version or open-ness changed, then
	        // incrementally parse this file.
	        if (textChangeRange) {
	            if (version !== sourceFile.version) {
	                // Once incremental parsing is ready, then just call into this function.
	                if (!ts.disableIncrementalParsing) {
	                    var newText = void 0;
	                    // grab the fragment from the beginning of the original text to the beginning of the span
	                    var prefix = textChangeRange.span.start !== 0
	                        ? sourceFile.text.substr(0, textChangeRange.span.start)
	                        : "";
	                    // grab the fragment from the end of the span till the end of the original text
	                    var suffix = ts.textSpanEnd(textChangeRange.span) !== sourceFile.text.length
	                        ? sourceFile.text.substr(ts.textSpanEnd(textChangeRange.span))
	                        : "";
	                    if (textChangeRange.newLength === 0) {
	                        // edit was a deletion - just combine prefix and suffix
	                        newText = prefix && suffix ? prefix + suffix : prefix || suffix;
	                    }
	                    else {
	                        // it was actual edit, fetch the fragment of new text that correspond to new span
	                        var changedText = scriptSnapshot.getText(textChangeRange.span.start, textChangeRange.span.start + textChangeRange.newLength);
	                        // combine prefix, changed text and suffix
	                        newText = prefix && suffix
	                            ? prefix + changedText + suffix
	                            : prefix
	                                ? (prefix + changedText)
	                                : (changedText + suffix);
	                    }
	                    var newSourceFile = ts.updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks);
	                    setSourceFileFields(newSourceFile, scriptSnapshot, version);
	                    // after incremental parsing nameTable might not be up-to-date
	                    // drop it so it can be lazily recreated later
	                    newSourceFile.nameTable = undefined;
	                    // dispose all resources held by old script snapshot
	                    if (sourceFile !== newSourceFile && sourceFile.scriptSnapshot) {
	                        if (sourceFile.scriptSnapshot.dispose) {
	                            sourceFile.scriptSnapshot.dispose();
	                        }
	                        sourceFile.scriptSnapshot = undefined;
	                    }
	                    return newSourceFile;
	                }
	            }
	        }
	        // Otherwise, just create a new source file.
	        return createLanguageServiceSourceFile(sourceFile.fileName, scriptSnapshot, sourceFile.languageVersion, version, /*setNodeParents*/ true, sourceFile.scriptKind);
	    }
	    ts.updateLanguageServiceSourceFile = updateLanguageServiceSourceFile;
	    var CancellationTokenObject = /** @class */ (function () {
	        function CancellationTokenObject(cancellationToken) {
	            this.cancellationToken = cancellationToken;
	        }
	        CancellationTokenObject.prototype.isCancellationRequested = function () {
	            return this.cancellationToken && this.cancellationToken.isCancellationRequested();
	        };
	        CancellationTokenObject.prototype.throwIfCancellationRequested = function () {
	            if (this.isCancellationRequested()) {
	                throw new ts.OperationCanceledException();
	            }
	        };
	        return CancellationTokenObject;
	    }());
	    /* @internal */
	    /** A cancellation that throttles calls to the host */
	    var ThrottledCancellationToken = /** @class */ (function () {
	        function ThrottledCancellationToken(hostCancellationToken, throttleWaitMilliseconds) {
	            if (throttleWaitMilliseconds === void 0) { throttleWaitMilliseconds = 20; }
	            this.hostCancellationToken = hostCancellationToken;
	            this.throttleWaitMilliseconds = throttleWaitMilliseconds;
	            // Store when we last tried to cancel.  Checking cancellation can be expensive (as we have
	            // to marshall over to the host layer).  So we only bother actually checking once enough
	            // time has passed.
	            this.lastCancellationCheckTime = 0;
	        }
	        ThrottledCancellationToken.prototype.isCancellationRequested = function () {
	            var time = ts.timestamp();
	            var duration = Math.abs(time - this.lastCancellationCheckTime);
	            if (duration >= this.throttleWaitMilliseconds) {
	                // Check no more than once every throttle wait milliseconds
	                this.lastCancellationCheckTime = time;
	                return this.hostCancellationToken.isCancellationRequested();
	            }
	            return false;
	        };
	        ThrottledCancellationToken.prototype.throwIfCancellationRequested = function () {
	            if (this.isCancellationRequested()) {
	                throw new ts.OperationCanceledException();
	            }
	        };
	        return ThrottledCancellationToken;
	    }());
	    ts.ThrottledCancellationToken = ThrottledCancellationToken;
	    function createLanguageService(host, documentRegistry) {
	        if (documentRegistry === void 0) { documentRegistry = ts.createDocumentRegistry(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames(), host.getCurrentDirectory()); }
	        var syntaxTreeCache = new SyntaxTreeCache(host);
	        var program;
	        var lastProjectVersion;
	        var lastTypesRootVersion = 0;
	        var useCaseSensitivefileNames = host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames();
	        var cancellationToken = new CancellationTokenObject(host.getCancellationToken && host.getCancellationToken());
	        var currentDirectory = host.getCurrentDirectory();
	        // Check if the localized messages json is set, otherwise query the host for it
	        if (!ts.localizedDiagnosticMessages && host.getLocalizedDiagnosticMessages) {
	            ts.localizedDiagnosticMessages = host.getLocalizedDiagnosticMessages();
	        }
	        function log(message) {
	            if (host.log) {
	                host.log(message);
	            }
	        }
	        var getCanonicalFileName = ts.createGetCanonicalFileName(useCaseSensitivefileNames);
	        function getValidSourceFile(fileName) {
	            var sourceFile = program.getSourceFile(fileName);
	            if (!sourceFile) {
	                throw new Error("Could not find file: '" + fileName + "'.");
	            }
	            return sourceFile;
	        }
	        function synchronizeHostData() {
	            // perform fast check if host supports it
	            if (host.getProjectVersion) {
	                var hostProjectVersion = host.getProjectVersion();
	                if (hostProjectVersion) {
	                    if (lastProjectVersion === hostProjectVersion && !host.hasChangedAutomaticTypeDirectiveNames) {
	                        return;
	                    }
	                    lastProjectVersion = hostProjectVersion;
	                }
	            }
	            var typeRootsVersion = host.getTypeRootsVersion ? host.getTypeRootsVersion() : 0;
	            if (lastTypesRootVersion !== typeRootsVersion) {
	                log("TypeRoots version has changed; provide new program");
	                program = undefined;
	                lastTypesRootVersion = typeRootsVersion;
	            }
	            // Get a fresh cache of the host information
	            var hostCache = new HostCache(host, getCanonicalFileName);
	            var rootFileNames = hostCache.getRootFileNames();
	            var hasInvalidatedResolution = host.hasInvalidatedResolution || ts.returnFalse;
	            // If the program is already up-to-date, we can reuse it
	            if (ts.isProgramUptoDate(program, rootFileNames, hostCache.compilationSettings(), function (path) { return hostCache.getVersion(path); }, fileExists, hasInvalidatedResolution, host.hasChangedAutomaticTypeDirectiveNames)) {
	                return;
	            }
	            // IMPORTANT - It is critical from this moment onward that we do not check
	            // cancellation tokens.  We are about to mutate source files from a previous program
	            // instance.  If we cancel midway through, we may end up in an inconsistent state where
	            // the program points to old source files that have been invalidated because of
	            // incremental parsing.
	            var newSettings = hostCache.compilationSettings();
	            // Now create a new compiler
	            var compilerHost = {
	                getSourceFile: getOrCreateSourceFile,
	                getSourceFileByPath: getOrCreateSourceFileByPath,
	                getCancellationToken: function () { return cancellationToken; },
	                getCanonicalFileName: getCanonicalFileName,
	                useCaseSensitiveFileNames: function () { return useCaseSensitivefileNames; },
	                getNewLine: function () { return ts.getNewLineCharacter(newSettings, function () { return ts.getNewLineOrDefaultFromHost(host); }); },
	                getDefaultLibFileName: function (options) { return host.getDefaultLibFileName(options); },
	                writeFile: ts.noop,
	                getCurrentDirectory: function () { return currentDirectory; },
	                fileExists: fileExists,
	                readFile: function (fileName) {
	                    // stub missing host functionality
	                    var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	                    var entry = hostCache.getEntryByPath(path);
	                    if (entry) {
	                        return ts.isString(entry) ? undefined : ts.getSnapshotText(entry.scriptSnapshot);
	                    }
	                    return host.readFile && host.readFile(fileName);
	                },
	                realpath: host.realpath && (function (path) { return host.realpath(path); }),
	                directoryExists: function (directoryName) {
	                    return ts.directoryProbablyExists(directoryName, host);
	                },
	                getDirectories: function (path) {
	                    return host.getDirectories ? host.getDirectories(path) : [];
	                },
	                onReleaseOldSourceFile: onReleaseOldSourceFile,
	                hasInvalidatedResolution: hasInvalidatedResolution,
	                hasChangedAutomaticTypeDirectiveNames: host.hasChangedAutomaticTypeDirectiveNames
	            };
	            if (host.trace) {
	                compilerHost.trace = function (message) { return host.trace(message); };
	            }
	            if (host.resolveModuleNames) {
	                compilerHost.resolveModuleNames = function (moduleNames, containingFile, reusedNames) { return host.resolveModuleNames(moduleNames, containingFile, reusedNames); };
	            }
	            if (host.resolveTypeReferenceDirectives) {
	                compilerHost.resolveTypeReferenceDirectives = function (typeReferenceDirectiveNames, containingFile) {
	                    return host.resolveTypeReferenceDirectives(typeReferenceDirectiveNames, containingFile);
	                };
	            }
	            var documentRegistryBucketKey = documentRegistry.getKeyForCompilationSettings(newSettings);
	            program = ts.createProgram(rootFileNames, newSettings, compilerHost, program);
	            // hostCache is captured in the closure for 'getOrCreateSourceFile' but it should not be used past this point.
	            // It needs to be cleared to allow all collected snapshots to be released
	            hostCache = undefined;
	            // Make sure all the nodes in the program are both bound, and have their parent
	            // pointers set property.
	            program.getTypeChecker();
	            return;
	            function fileExists(fileName) {
	                var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	                var entry = hostCache.getEntryByPath(path);
	                return entry ?
	                    !ts.isString(entry) :
	                    (host.fileExists && host.fileExists(fileName));
	            }
	            // Release any files we have acquired in the old program but are
	            // not part of the new program.
	            function onReleaseOldSourceFile(oldSourceFile, oldOptions) {
	                var oldSettingsKey = documentRegistry.getKeyForCompilationSettings(oldOptions);
	                documentRegistry.releaseDocumentWithKey(oldSourceFile.path, oldSettingsKey);
	            }
	            function getOrCreateSourceFile(fileName, languageVersion, onError, shouldCreateNewSourceFile) {
	                return getOrCreateSourceFileByPath(fileName, ts.toPath(fileName, currentDirectory, getCanonicalFileName), languageVersion, onError, shouldCreateNewSourceFile);
	            }
	            function getOrCreateSourceFileByPath(fileName, path, _languageVersion, _onError, shouldCreateNewSourceFile) {
	                ts.Debug.assert(hostCache !== undefined);
	                // The program is asking for this file, check first if the host can locate it.
	                // If the host can not locate the file, then it does not exist. return undefined
	                // to the program to allow reporting of errors for missing files.
	                var hostFileInformation = hostCache.getOrCreateEntryByPath(fileName, path);
	                if (!hostFileInformation) {
	                    return undefined;
	                }
	                // Check if the language version has changed since we last created a program; if they are the same,
	                // it is safe to reuse the sourceFiles; if not, then the shape of the AST can change, and the oldSourceFile
	                // can not be reused. we have to dump all syntax trees and create new ones.
	                if (!shouldCreateNewSourceFile) {
	                    // Check if the old program had this file already
	                    var oldSourceFile = program && program.getSourceFileByPath(path);
	                    if (oldSourceFile) {
	                        // We already had a source file for this file name.  Go to the registry to
	                        // ensure that we get the right up to date version of it.  We need this to
	                        // address the following race-condition.  Specifically, say we have the following:
	                        //
	                        //      LS1
	                        //          \
	                        //           DocumentRegistry
	                        //          /
	                        //      LS2
	                        //
	                        // Each LS has a reference to file 'foo.ts' at version 1.  LS2 then updates
	                        // it's version of 'foo.ts' to version 2.  This will cause LS2 and the
	                        // DocumentRegistry to have version 2 of the document.  HOwever, LS1 will
	                        // have version 1.  And *importantly* this source file will be *corrupt*.
	                        // The act of creating version 2 of the file irrevocably damages the version
	                        // 1 file.
	                        //
	                        // So, later when we call into LS1, we need to make sure that it doesn't use
	                        // it's source file any more, and instead defers to DocumentRegistry to get
	                        // either version 1, version 2 (or some other version) depending on what the
	                        // host says should be used.
	                        // We do not support the scenario where a host can modify a registered
	                        // file's script kind, i.e. in one project some file is treated as ".ts"
	                        // and in another as ".js"
	                        ts.Debug.assertEqual(hostFileInformation.scriptKind, oldSourceFile.scriptKind, "Registered script kind should match new script kind.", path);
	                        return documentRegistry.updateDocumentWithKey(fileName, path, newSettings, documentRegistryBucketKey, hostFileInformation.scriptSnapshot, hostFileInformation.version, hostFileInformation.scriptKind);
	                    }
	                    // We didn't already have the file.  Fall through and acquire it from the registry.
	                }
	                // Could not find this file in the old program, create a new SourceFile for it.
	                return documentRegistry.acquireDocumentWithKey(fileName, path, newSettings, documentRegistryBucketKey, hostFileInformation.scriptSnapshot, hostFileInformation.version, hostFileInformation.scriptKind);
	            }
	        }
	        function getProgram() {
	            synchronizeHostData();
	            return program;
	        }
	        function cleanupSemanticCache() {
	            program = undefined;
	        }
	        function dispose() {
	            if (program) {
	                ts.forEach(program.getSourceFiles(), function (f) {
	                    return documentRegistry.releaseDocument(f.fileName, program.getCompilerOptions());
	                });
	                program = undefined;
	            }
	            host = undefined;
	        }
	        /// Diagnostics
	        function getSyntacticDiagnostics(fileName) {
	            synchronizeHostData();
	            return program.getSyntacticDiagnostics(getValidSourceFile(fileName), cancellationToken).slice();
	        }
	        /**
	         * getSemanticDiagnostics return array of Diagnostics. If '-d' is not enabled, only report semantic errors
	         * If '-d' enabled, report both semantic and emitter errors
	         */
	        function getSemanticDiagnostics(fileName) {
	            synchronizeHostData();
	            var targetSourceFile = getValidSourceFile(fileName);
	            // Only perform the action per file regardless of '-out' flag as LanguageServiceHost is expected to call this function per file.
	            // Therefore only get diagnostics for given file.
	            var semanticDiagnostics = program.getSemanticDiagnostics(targetSourceFile, cancellationToken);
	            if (!program.getCompilerOptions().declaration) {
	                return semanticDiagnostics.slice();
	            }
	            // If '-d' is enabled, check for emitter error. One example of emitter error is export class implements non-export interface
	            var declarationDiagnostics = program.getDeclarationDiagnostics(targetSourceFile, cancellationToken);
	            return semanticDiagnostics.concat(declarationDiagnostics);
	        }
	        function getCompilerOptionsDiagnostics() {
	            synchronizeHostData();
	            return program.getOptionsDiagnostics(cancellationToken).concat(program.getGlobalDiagnostics(cancellationToken));
	        }
	        function getCompletionsAtPosition(fileName, position, options) {
	            if (options === void 0) { options = { includeExternalModuleExports: false, includeInsertTextCompletions: false }; }
	            synchronizeHostData();
	            return ts.Completions.getCompletionsAtPosition(host, program.getTypeChecker(), log, program.getCompilerOptions(), getValidSourceFile(fileName), position, program.getSourceFiles(), options);
	        }
	        function getCompletionEntryDetails(fileName, position, name, formattingOptions, source) {
	            synchronizeHostData();
	            return ts.Completions.getCompletionEntryDetails(program, log, program.getCompilerOptions(), getValidSourceFile(fileName), position, { name: name, source: source }, program.getSourceFiles(), host, formattingOptions && ts.formatting.getFormatContext(formattingOptions), getCanonicalFileName);
	        }
	        function getCompletionEntrySymbol(fileName, position, name, source) {
	            synchronizeHostData();
	            return ts.Completions.getCompletionEntrySymbol(program.getTypeChecker(), log, program.getCompilerOptions(), getValidSourceFile(fileName), position, { name: name, source: source }, program.getSourceFiles());
	        }
	        function getQuickInfoAtPosition(fileName, position) {
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            if (node === sourceFile) {
	                // Avoid giving quickInfo for the sourceFile as a whole.
	                return undefined;
	            }
	            var typeChecker = program.getTypeChecker();
	            var symbol = getSymbolAtLocationForQuickInfo(node, typeChecker);
	            if (!symbol || typeChecker.isUnknownSymbol(symbol)) {
	                // Try getting just type at this position and show
	                switch (node.kind) {
	                    case 71 /* Identifier */:
	                        if (ts.isLabelName(node)) {
	                            // Type here will be 'any', avoid displaying this.
	                            return undefined;
	                        }
	                    // falls through
	                    case 183 /* PropertyAccessExpression */:
	                    case 145 /* QualifiedName */:
	                    case 99 /* ThisKeyword */:
	                    case 173 /* ThisType */:
	                    case 97 /* SuperKeyword */:
	                        // For the identifiers/this/super etc get the type at position
	                        var type = typeChecker.getTypeAtLocation(node);
	                        return type && {
	                            kind: "" /* unknown */,
	                            kindModifiers: "" /* none */,
	                            textSpan: ts.createTextSpanFromNode(node, sourceFile),
	                            displayParts: ts.typeToDisplayParts(typeChecker, type, ts.getContainerNode(node)),
	                            documentation: type.symbol ? type.symbol.getDocumentationComment(typeChecker) : undefined,
	                            tags: type.symbol ? type.symbol.getJsDocTags() : undefined
	                        };
	                }
	                return undefined;
	            }
	            var _a = ts.SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, symbol, sourceFile, ts.getContainerNode(node), node), symbolKind = _a.symbolKind, displayParts = _a.displayParts, documentation = _a.documentation, tags = _a.tags;
	            return {
	                kind: symbolKind,
	                kindModifiers: ts.SymbolDisplay.getSymbolModifiers(symbol),
	                textSpan: ts.createTextSpanFromNode(node, sourceFile),
	                displayParts: displayParts,
	                documentation: documentation,
	                tags: tags,
	            };
	        }
	        function getSymbolAtLocationForQuickInfo(node, checker) {
	            if ((ts.isIdentifier(node) || ts.isStringLiteral(node))
	                && ts.isPropertyAssignment(node.parent)
	                && node.parent.name === node) {
	                var type = checker.getContextualType(node.parent.parent);
	                var property = type && checker.getPropertyOfType(type, ts.getTextOfIdentifierOrLiteral(node));
	                if (property) {
	                    return property;
	                }
	            }
	            return checker.getSymbolAtLocation(node);
	        }
	        /// Goto definition
	        function getDefinitionAtPosition(fileName, position) {
	            synchronizeHostData();
	            return ts.GoToDefinition.getDefinitionAtPosition(program, getValidSourceFile(fileName), position);
	        }
	        function getDefinitionAndBoundSpan(fileName, position) {
	            synchronizeHostData();
	            return ts.GoToDefinition.getDefinitionAndBoundSpan(program, getValidSourceFile(fileName), position);
	        }
	        function getTypeDefinitionAtPosition(fileName, position) {
	            synchronizeHostData();
	            return ts.GoToDefinition.getTypeDefinitionAtPosition(program.getTypeChecker(), getValidSourceFile(fileName), position);
	        }
	        /// Goto implementation
	        function getImplementationAtPosition(fileName, position) {
	            synchronizeHostData();
	            return ts.FindAllReferences.getImplementationsAtPosition(program, cancellationToken, program.getSourceFiles(), getValidSourceFile(fileName), position);
	        }
	        /// References and Occurrences
	        function getOccurrencesAtPosition(fileName, position) {
	            var canonicalFileName = getCanonicalFileName(ts.normalizeSlashes(fileName));
	            return ts.flatMap(getDocumentHighlights(fileName, position, [fileName]), function (entry) { return entry.highlightSpans.map(function (highlightSpan) {
	                ts.Debug.assert(getCanonicalFileName(ts.normalizeSlashes(entry.fileName)) === canonicalFileName); // Get occurrences only supports reporting occurrences for the file queried.
	                return {
	                    fileName: entry.fileName,
	                    textSpan: highlightSpan.textSpan,
	                    isWriteAccess: highlightSpan.kind === "writtenReference" /* writtenReference */,
	                    isDefinition: false,
	                    isInString: highlightSpan.isInString,
	                };
	            }); });
	        }
	        function getDocumentHighlights(fileName, position, filesToSearch) {
	            synchronizeHostData();
	            var sourceFilesToSearch = ts.map(filesToSearch, function (f) { return ts.Debug.assertDefined(program.getSourceFile(f)); });
	            var sourceFile = getValidSourceFile(fileName);
	            return ts.DocumentHighlights.getDocumentHighlights(program, cancellationToken, sourceFile, position, sourceFilesToSearch);
	        }
	        function findRenameLocations(fileName, position, findInStrings, findInComments) {
	            return getReferences(fileName, position, { findInStrings: findInStrings, findInComments: findInComments, isForRename: true });
	        }
	        function getReferencesAtPosition(fileName, position) {
	            return getReferences(fileName, position);
	        }
	        function getReferences(fileName, position, options) {
	            synchronizeHostData();
	            // Exclude default library when renaming as commonly user don't want to change that file.
	            var sourceFiles = [];
	            if (options && options.isForRename) {
	                for (var _i = 0, _a = program.getSourceFiles(); _i < _a.length; _i++) {
	                    var sourceFile = _a[_i];
	                    if (!program.isSourceFileDefaultLibrary(sourceFile)) {
	                        sourceFiles.push(sourceFile);
	                    }
	                }
	            }
	            else {
	                sourceFiles = program.getSourceFiles().slice();
	            }
	            return ts.FindAllReferences.findReferencedEntries(program, cancellationToken, sourceFiles, getValidSourceFile(fileName), position, options);
	        }
	        function findReferences(fileName, position) {
	            synchronizeHostData();
	            return ts.FindAllReferences.findReferencedSymbols(program, cancellationToken, program.getSourceFiles(), getValidSourceFile(fileName), position);
	        }
	        /// NavigateTo
	        function getNavigateToItems(searchValue, maxResultCount, fileName, excludeDtsFiles) {
	            synchronizeHostData();
	            var sourceFiles = fileName ? [getValidSourceFile(fileName)] : program.getSourceFiles();
	            return ts.NavigateTo.getNavigateToItems(sourceFiles, program.getTypeChecker(), cancellationToken, searchValue, maxResultCount, excludeDtsFiles);
	        }
	        function getEmitOutput(fileName, emitOnlyDtsFiles) {
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            var customTransformers = host.getCustomTransformers && host.getCustomTransformers();
	            return ts.getFileEmitOutput(program, sourceFile, emitOnlyDtsFiles, cancellationToken, customTransformers);
	        }
	        // Signature help
	        /**
	         * This is a semantic operation.
	         */
	        function getSignatureHelpItems(fileName, position) {
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            return ts.SignatureHelp.getSignatureHelpItems(program, sourceFile, position, cancellationToken);
	        }
	        /// Syntactic features
	        function getNonBoundSourceFile(fileName) {
	            return syntaxTreeCache.getCurrentSourceFile(fileName);
	        }
	        function getSourceFile(fileName) {
	            return getNonBoundSourceFile(fileName);
	        }
	        function getNameOrDottedNameSpan(fileName, startPos, _endPos) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            // Get node at the location
	            var node = ts.getTouchingPropertyName(sourceFile, startPos, /*includeJsDocComment*/ false);
	            if (node === sourceFile) {
	                return;
	            }
	            switch (node.kind) {
	                case 183 /* PropertyAccessExpression */:
	                case 145 /* QualifiedName */:
	                case 9 /* StringLiteral */:
	                case 86 /* FalseKeyword */:
	                case 101 /* TrueKeyword */:
	                case 95 /* NullKeyword */:
	                case 97 /* SuperKeyword */:
	                case 99 /* ThisKeyword */:
	                case 173 /* ThisType */:
	                case 71 /* Identifier */:
	                    break;
	                // Cant create the text span
	                default:
	                    return;
	            }
	            var nodeForStartPos = node;
	            while (true) {
	                if (ts.isRightSideOfPropertyAccess(nodeForStartPos) || ts.isRightSideOfQualifiedName(nodeForStartPos)) {
	                    // If on the span is in right side of the the property or qualified name, return the span from the qualified name pos to end of this node
	                    nodeForStartPos = nodeForStartPos.parent;
	                }
	                else if (ts.isNameOfModuleDeclaration(nodeForStartPos)) {
	                    // If this is name of a module declarations, check if this is right side of dotted module name
	                    // If parent of the module declaration which is parent of this node is module declaration and its body is the module declaration that this node is name of
	                    // Then this name is name from dotted module
	                    if (nodeForStartPos.parent.parent.kind === 237 /* ModuleDeclaration */ &&
	                        nodeForStartPos.parent.parent.body === nodeForStartPos.parent) {
	                        // Use parent module declarations name for start pos
	                        nodeForStartPos = nodeForStartPos.parent.parent.name;
	                    }
	                    else {
	                        // We have to use this name for start pos
	                        break;
	                    }
	                }
	                else {
	                    // Is not a member expression so we have found the node for start pos
	                    break;
	                }
	            }
	            return ts.createTextSpanFromBounds(nodeForStartPos.getStart(), node.getEnd());
	        }
	        function getBreakpointStatementAtPosition(fileName, position) {
	            // doesn't use compiler - no need to synchronize with host
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            return ts.BreakpointResolver.spanInSourceFileAtLocation(sourceFile, position);
	        }
	        function getNavigationBarItems(fileName) {
	            return ts.NavigationBar.getNavigationBarItems(syntaxTreeCache.getCurrentSourceFile(fileName), cancellationToken);
	        }
	        function getNavigationTree(fileName) {
	            return ts.NavigationBar.getNavigationTree(syntaxTreeCache.getCurrentSourceFile(fileName), cancellationToken);
	        }
	        function isTsOrTsxFile(fileName) {
	            var kind = ts.getScriptKind(fileName, host);
	            return kind === 3 /* TS */ || kind === 4 /* TSX */;
	        }
	        function getSemanticClassifications(fileName, span) {
	            if (!isTsOrTsxFile(fileName)) {
	                // do not run semantic classification on non-ts-or-tsx files
	                return [];
	            }
	            synchronizeHostData();
	            return ts.getSemanticClassifications(program.getTypeChecker(), cancellationToken, getValidSourceFile(fileName), program.getClassifiableNames(), span);
	        }
	        function getEncodedSemanticClassifications(fileName, span) {
	            if (!isTsOrTsxFile(fileName)) {
	                // do not run semantic classification on non-ts-or-tsx files
	                return { spans: [], endOfLineState: 0 /* None */ };
	            }
	            synchronizeHostData();
	            return ts.getEncodedSemanticClassifications(program.getTypeChecker(), cancellationToken, getValidSourceFile(fileName), program.getClassifiableNames(), span);
	        }
	        function getSyntacticClassifications(fileName, span) {
	            // doesn't use compiler - no need to synchronize with host
	            return ts.getSyntacticClassifications(cancellationToken, syntaxTreeCache.getCurrentSourceFile(fileName), span);
	        }
	        function getEncodedSyntacticClassifications(fileName, span) {
	            // doesn't use compiler - no need to synchronize with host
	            return ts.getEncodedSyntacticClassifications(cancellationToken, syntaxTreeCache.getCurrentSourceFile(fileName), span);
	        }
	        function getOutliningSpans(fileName) {
	            // doesn't use compiler - no need to synchronize with host
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            return ts.OutliningElementsCollector.collectElements(sourceFile, cancellationToken);
	        }
	        var braceMatching = ts.createMapFromTemplate((_a = {},
	            _a[17 /* OpenBraceToken */] = 18 /* CloseBraceToken */,
	            _a[19 /* OpenParenToken */] = 20 /* CloseParenToken */,
	            _a[21 /* OpenBracketToken */] = 22 /* CloseBracketToken */,
	            _a[29 /* GreaterThanToken */] = 27 /* LessThanToken */,
	            _a));
	        braceMatching.forEach(function (value, key) { return braceMatching.set(value.toString(), Number(key)); });
	        function getBraceMatchingAtPosition(fileName, position) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            var token = ts.getTouchingToken(sourceFile, position, /*includeJsDocComment*/ false);
	            var matchKind = token.getStart(sourceFile) === position ? braceMatching.get(token.kind.toString()) : undefined;
	            var match = matchKind && ts.findChildOfKind(token.parent, matchKind, sourceFile);
	            // We want to order the braces when we return the result.
	            return match ? [ts.createTextSpanFromNode(token, sourceFile), ts.createTextSpanFromNode(match, sourceFile)].sort(function (a, b) { return a.start - b.start; }) : ts.emptyArray;
	        }
	        function getIndentationAtPosition(fileName, position, editorOptions) {
	            var start = ts.timestamp();
	            var settings = toEditorSettings(editorOptions);
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            log("getIndentationAtPosition: getCurrentSourceFile: " + (ts.timestamp() - start));
	            start = ts.timestamp();
	            var result = ts.formatting.SmartIndenter.getIndentation(position, sourceFile, settings);
	            log("getIndentationAtPosition: computeIndentation  : " + (ts.timestamp() - start));
	            return result;
	        }
	        function getFormattingEditsForRange(fileName, start, end, options) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            return ts.formatting.formatSelection(start, end, sourceFile, ts.formatting.getFormatContext(toEditorSettings(options)));
	        }
	        function getFormattingEditsForDocument(fileName, options) {
	            return ts.formatting.formatDocument(syntaxTreeCache.getCurrentSourceFile(fileName), ts.formatting.getFormatContext(toEditorSettings(options)));
	        }
	        function getFormattingEditsAfterKeystroke(fileName, position, key, options) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            var formatContext = ts.formatting.getFormatContext(toEditorSettings(options));
	            if (!ts.isInComment(sourceFile, position)) {
	                switch (key) {
	                    case "{":
	                        return ts.formatting.formatOnOpeningCurly(position, sourceFile, formatContext);
	                    case "}":
	                        return ts.formatting.formatOnClosingCurly(position, sourceFile, formatContext);
	                    case ";":
	                        return ts.formatting.formatOnSemicolon(position, sourceFile, formatContext);
	                    case "\n":
	                        return ts.formatting.formatOnEnter(position, sourceFile, formatContext);
	                }
	            }
	            return [];
	        }
	        function getCodeFixesAtPosition(fileName, start, end, errorCodes, formatOptions) {
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            var span = ts.createTextSpanFromBounds(start, end);
	            var formatContext = ts.formatting.getFormatContext(formatOptions);
	            return ts.flatMap(ts.deduplicate(errorCodes, ts.equateValues, ts.compareValues), function (errorCode) {
	                cancellationToken.throwIfCancellationRequested();
	                return ts.codefix.getFixes({ errorCode: errorCode, sourceFile: sourceFile, span: span, program: program, host: host, cancellationToken: cancellationToken, formatContext: formatContext });
	            });
	        }
	        function getCombinedCodeFix(scope, fixId, formatOptions) {
	            synchronizeHostData();
	            ts.Debug.assert(scope.type === "file");
	            var sourceFile = getValidSourceFile(scope.fileName);
	            var formatContext = ts.formatting.getFormatContext(formatOptions);
	            return ts.codefix.getAllFixes({ fixId: fixId, sourceFile: sourceFile, program: program, host: host, cancellationToken: cancellationToken, formatContext: formatContext });
	        }
	        function organizeImports(scope, formatOptions) {
	            synchronizeHostData();
	            ts.Debug.assert(scope.type === "file");
	            var sourceFile = getValidSourceFile(scope.fileName);
	            var formatContext = ts.formatting.getFormatContext(formatOptions);
	            return ts.OrganizeImports.organizeImports(sourceFile, formatContext, host, program);
	        }
	        function applyCodeActionCommand(fileName, actionOrUndefined) {
	            var action = typeof fileName === "string" ? actionOrUndefined : fileName;
	            return ts.isArray(action) ? Promise.all(action.map(applySingleCodeActionCommand)) : applySingleCodeActionCommand(action);
	        }
	        function applySingleCodeActionCommand(action) {
	            switch (action.type) {
	                case "install package":
	                    return host.installPackage
	                        ? host.installPackage({ fileName: ts.toPath(action.file, currentDirectory, getCanonicalFileName), packageName: action.packageName })
	                        : Promise.reject("Host does not implement `installPackage`");
	                default:
	                    ts.Debug.fail();
	            }
	        }
	        function getDocCommentTemplateAtPosition(fileName, position) {
	            return ts.JsDoc.getDocCommentTemplateAtPosition(ts.getNewLineOrDefaultFromHost(host), syntaxTreeCache.getCurrentSourceFile(fileName), position);
	        }
	        function isValidBraceCompletionAtPosition(fileName, position, openingBrace) {
	            // '<' is currently not supported, figuring out if we're in a Generic Type vs. a comparison is too
	            // expensive to do during typing scenarios
	            // i.e. whether we're dealing with:
	            //      var x = new foo<| ( with class foo<T>{} )
	            // or
	            //      var y = 3 <|
	            if (openingBrace === 60 /* lessThan */) {
	                return false;
	            }
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            // Check if in a context where we don't want to perform any insertion
	            if (ts.isInString(sourceFile, position)) {
	                return false;
	            }
	            if (ts.isInsideJsxElementOrAttribute(sourceFile, position)) {
	                return openingBrace === 123 /* openBrace */;
	            }
	            if (ts.isInTemplateString(sourceFile, position)) {
	                return false;
	            }
	            switch (openingBrace) {
	                case 39 /* singleQuote */:
	                case 34 /* doubleQuote */:
	                case 96 /* backtick */:
	                    return !ts.isInComment(sourceFile, position);
	            }
	            return true;
	        }
	        function getSpanOfEnclosingComment(fileName, position, onlyMultiLine) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            var range = ts.formatting.getRangeOfEnclosingComment(sourceFile, position, onlyMultiLine);
	            return range && ts.createTextSpanFromRange(range);
	        }
	        function getTodoComments(fileName, descriptors) {
	            // Note: while getting todo comments seems like a syntactic operation, we actually
	            // treat it as a semantic operation here.  This is because we expect our host to call
	            // this on every single file.  If we treat this syntactically, then that will cause
	            // us to populate and throw away the tree in our syntax tree cache for each file.  By
	            // treating this as a semantic operation, we can access any tree without throwing
	            // anything away.
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            cancellationToken.throwIfCancellationRequested();
	            var fileContents = sourceFile.text;
	            var result = [];
	            // Exclude node_modules files as we don't want to show the todos of external libraries.
	            if (descriptors.length > 0 && !isNodeModulesFile(sourceFile.fileName)) {
	                var regExp = getTodoCommentsRegExp();
	                var matchArray = void 0;
	                while (matchArray = regExp.exec(fileContents)) {
	                    cancellationToken.throwIfCancellationRequested();
	                    // If we got a match, here is what the match array will look like.  Say the source text is:
	                    //
	                    //      "    // hack   1"
	                    //
	                    // The result array with the regexp:    will be:
	                    //
	                    //      ["// hack   1", "// ", "hack   1", undefined, "hack"]
	                    //
	                    // Here are the relevant capture groups:
	                    //  0) The full match for the entire regexp.
	                    //  1) The preamble to the message portion.
	                    //  2) The message portion.
	                    //  3...N) The descriptor that was matched - by index.  'undefined' for each
	                    //         descriptor that didn't match.  an actual value if it did match.
	                    //
	                    //  i.e. 'undefined' in position 3 above means TODO(jason) didn't match.
	                    //       "hack"      in position 4 means HACK did match.
	                    var firstDescriptorCaptureIndex = 3;
	                    ts.Debug.assert(matchArray.length === descriptors.length + firstDescriptorCaptureIndex);
	                    var preamble = matchArray[1];
	                    var matchPosition = matchArray.index + preamble.length;
	                    // OK, we have found a match in the file.  This is only an acceptable match if
	                    // it is contained within a comment.
	                    if (!ts.isInComment(sourceFile, matchPosition)) {
	                        continue;
	                    }
	                    var descriptor = undefined;
	                    for (var i = 0; i < descriptors.length; i++) {
	                        if (matchArray[i + firstDescriptorCaptureIndex]) {
	                            descriptor = descriptors[i];
	                        }
	                    }
	                    ts.Debug.assert(descriptor !== undefined);
	                    // We don't want to match something like 'TODOBY', so we make sure a non
	                    // letter/digit follows the match.
	                    if (isLetterOrDigit(fileContents.charCodeAt(matchPosition + descriptor.text.length))) {
	                        continue;
	                    }
	                    var message = matchArray[2];
	                    result.push({ descriptor: descriptor, message: message, position: matchPosition });
	                }
	            }
	            return result;
	            function escapeRegExp(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            }
	            function getTodoCommentsRegExp() {
	                // NOTE: `?:` means 'non-capture group'.  It allows us to have groups without having to
	                // filter them out later in the final result array.
	                // TODO comments can appear in one of the following forms:
	                //
	                //  1)      // TODO     or  /////////// TODO
	                //
	                //  2)      /* TODO     or  /********** TODO
	                //
	                //  3)      /*
	                //           *   TODO
	                //           */
	                //
	                // The following three regexps are used to match the start of the text up to the TODO
	                // comment portion.
	                var singleLineCommentStart = /(?:\/\/+\s*)/.source;
	                var multiLineCommentStart = /(?:\/\*+\s*)/.source;
	                var anyNumberOfSpacesAndAsterisksAtStartOfLine = /(?:^(?:\s|\*)*)/.source;
	                // Match any of the above three TODO comment start regexps.
	                // Note that the outermost group *is* a capture group.  We want to capture the preamble
	                // so that we can determine the starting position of the TODO comment match.
	                var preamble = "(" + anyNumberOfSpacesAndAsterisksAtStartOfLine + "|" + singleLineCommentStart + "|" + multiLineCommentStart + ")";
	                // Takes the descriptors and forms a regexp that matches them as if they were literals.
	                // For example, if the descriptors are "TODO(jason)" and "HACK", then this will be:
	                //
	                //      (?:(TODO\(jason\))|(HACK))
	                //
	                // Note that the outermost group is *not* a capture group, but the innermost groups
	                // *are* capture groups.  By capturing the inner literals we can determine after
	                // matching which descriptor we are dealing with.
	                var literals = "(?:" + ts.map(descriptors, function (d) { return "(" + escapeRegExp(d.text) + ")"; }).join("|") + ")";
	                // After matching a descriptor literal, the following regexp matches the rest of the
	                // text up to the end of the line (or */).
	                var endOfLineOrEndOfComment = /(?:$|\*\/)/.source;
	                var messageRemainder = /(?:.*?)/.source;
	                // This is the portion of the match we'll return as part of the TODO comment result. We
	                // match the literal portion up to the end of the line or end of comment.
	                var messagePortion = "(" + literals + messageRemainder + ")";
	                var regExpString = preamble + messagePortion + endOfLineOrEndOfComment;
	                // The final regexp will look like this:
	                // /((?:\/\/+\s*)|(?:\/\*+\s*)|(?:^(?:\s|\*)*))((?:(TODO\(jason\))|(HACK))(?:.*?))(?:$|\*\/)/gim
	                // The flags of the regexp are important here.
	                //  'g' is so that we are doing a global search and can find matches several times
	                //  in the input.
	                //
	                //  'i' is for case insensitivity (We do this to match C# TODO comment code).
	                //
	                //  'm' is so we can find matches in a multi-line input.
	                return new RegExp(regExpString, "gim");
	            }
	            function isLetterOrDigit(char) {
	                return (char >= 97 /* a */ && char <= 122 /* z */) ||
	                    (char >= 65 /* A */ && char <= 90 /* Z */) ||
	                    (char >= 48 /* _0 */ && char <= 57 /* _9 */);
	            }
	            function isNodeModulesFile(path) {
	                return ts.stringContains(path, "/node_modules/");
	            }
	        }
	        function getRenameInfo(fileName, position) {
	            synchronizeHostData();
	            var defaultLibFileName = host.getDefaultLibFileName(host.getCompilationSettings());
	            return ts.Rename.getRenameInfo(program.getTypeChecker(), defaultLibFileName, getCanonicalFileName, getValidSourceFile(fileName), position);
	        }
	        function getRefactorContext(file, positionOrRange, formatOptions) {
	            var _a = typeof positionOrRange === "number" ? [positionOrRange, undefined] : [positionOrRange.pos, positionOrRange.end], startPosition = _a[0], endPosition = _a[1];
	            return {
	                file: file,
	                startPosition: startPosition,
	                endPosition: endPosition,
	                program: getProgram(),
	                host: host,
	                formatContext: ts.formatting.getFormatContext(formatOptions),
	                cancellationToken: cancellationToken,
	            };
	        }
	        function getApplicableRefactors(fileName, positionOrRange) {
	            synchronizeHostData();
	            var file = getValidSourceFile(fileName);
	            return ts.refactor.getApplicableRefactors(getRefactorContext(file, positionOrRange));
	        }
	        function getEditsForRefactor(fileName, formatOptions, positionOrRange, refactorName, actionName) {
	            synchronizeHostData();
	            var file = getValidSourceFile(fileName);
	            return ts.refactor.getEditsForRefactor(getRefactorContext(file, positionOrRange, formatOptions), refactorName, actionName);
	        }
	        return {
	            dispose: dispose,
	            cleanupSemanticCache: cleanupSemanticCache,
	            getSyntacticDiagnostics: getSyntacticDiagnostics,
	            getSemanticDiagnostics: getSemanticDiagnostics,
	            getCompilerOptionsDiagnostics: getCompilerOptionsDiagnostics,
	            getSyntacticClassifications: getSyntacticClassifications,
	            getSemanticClassifications: getSemanticClassifications,
	            getEncodedSyntacticClassifications: getEncodedSyntacticClassifications,
	            getEncodedSemanticClassifications: getEncodedSemanticClassifications,
	            getCompletionsAtPosition: getCompletionsAtPosition,
	            getCompletionEntryDetails: getCompletionEntryDetails,
	            getCompletionEntrySymbol: getCompletionEntrySymbol,
	            getSignatureHelpItems: getSignatureHelpItems,
	            getQuickInfoAtPosition: getQuickInfoAtPosition,
	            getDefinitionAtPosition: getDefinitionAtPosition,
	            getDefinitionAndBoundSpan: getDefinitionAndBoundSpan,
	            getImplementationAtPosition: getImplementationAtPosition,
	            getTypeDefinitionAtPosition: getTypeDefinitionAtPosition,
	            getReferencesAtPosition: getReferencesAtPosition,
	            findReferences: findReferences,
	            getOccurrencesAtPosition: getOccurrencesAtPosition,
	            getDocumentHighlights: getDocumentHighlights,
	            getNameOrDottedNameSpan: getNameOrDottedNameSpan,
	            getBreakpointStatementAtPosition: getBreakpointStatementAtPosition,
	            getNavigateToItems: getNavigateToItems,
	            getRenameInfo: getRenameInfo,
	            findRenameLocations: findRenameLocations,
	            getNavigationBarItems: getNavigationBarItems,
	            getNavigationTree: getNavigationTree,
	            getOutliningSpans: getOutliningSpans,
	            getTodoComments: getTodoComments,
	            getBraceMatchingAtPosition: getBraceMatchingAtPosition,
	            getIndentationAtPosition: getIndentationAtPosition,
	            getFormattingEditsForRange: getFormattingEditsForRange,
	            getFormattingEditsForDocument: getFormattingEditsForDocument,
	            getFormattingEditsAfterKeystroke: getFormattingEditsAfterKeystroke,
	            getDocCommentTemplateAtPosition: getDocCommentTemplateAtPosition,
	            isValidBraceCompletionAtPosition: isValidBraceCompletionAtPosition,
	            getSpanOfEnclosingComment: getSpanOfEnclosingComment,
	            getCodeFixesAtPosition: getCodeFixesAtPosition,
	            getCombinedCodeFix: getCombinedCodeFix,
	            applyCodeActionCommand: applyCodeActionCommand,
	            organizeImports: organizeImports,
	            getEmitOutput: getEmitOutput,
	            getNonBoundSourceFile: getNonBoundSourceFile,
	            getSourceFile: getSourceFile,
	            getProgram: getProgram,
	            getApplicableRefactors: getApplicableRefactors,
	            getEditsForRefactor: getEditsForRefactor,
	        };
	        var _a;
	    }
	    ts.createLanguageService = createLanguageService;
	    /* @internal */
	    /** Names in the name table are escaped, so an identifier `__foo` will have a name table entry `___foo`. */
	    function getNameTable(sourceFile) {
	        if (!sourceFile.nameTable) {
	            initializeNameTable(sourceFile);
	        }
	        return sourceFile.nameTable;
	    }
	    ts.getNameTable = getNameTable;
	    function initializeNameTable(sourceFile) {
	        var nameTable = sourceFile.nameTable = ts.createUnderscoreEscapedMap();
	        sourceFile.forEachChild(function walk(node) {
	            if (ts.isIdentifier(node) && node.escapedText || ts.isStringOrNumericLiteral(node) && literalIsName(node)) {
	                var text = ts.getEscapedTextOfIdentifierOrLiteral(node);
	                nameTable.set(text, nameTable.get(text) === undefined ? node.pos : -1);
	            }
	            ts.forEachChild(node, walk);
	            if (ts.hasJSDocNodes(node)) {
	                for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                    var jsDoc = _a[_i];
	                    ts.forEachChild(jsDoc, walk);
	                }
	            }
	        });
	    }
	    /**
	     * We want to store any numbers/strings if they were a name that could be
	     * related to a declaration.  So, if we have 'import x = require("something")'
	     * then we want 'something' to be in the name table.  Similarly, if we have
	     * "a['propname']" then we want to store "propname" in the name table.
	     */
	    function literalIsName(node) {
	        return ts.isDeclarationName(node) ||
	            node.parent.kind === 252 /* ExternalModuleReference */ ||
	            isArgumentOfElementAccessExpression(node) ||
	            ts.isLiteralComputedPropertyDeclarationName(node);
	    }
	    /**
	     * Returns the containing object literal property declaration given a possible name node, e.g. "a" in x = { "a": 1 }
	     */
	    /* @internal */
	    function getContainingObjectLiteralElement(node) {
	        switch (node.kind) {
	            case 9 /* StringLiteral */:
	            case 8 /* NumericLiteral */:
	                if (node.parent.kind === 146 /* ComputedPropertyName */) {
	                    return ts.isObjectLiteralElement(node.parent.parent) ? node.parent.parent : undefined;
	                }
	            // falls through
	            case 71 /* Identifier */:
	                return ts.isObjectLiteralElement(node.parent) &&
	                    (node.parent.parent.kind === 182 /* ObjectLiteralExpression */ || node.parent.parent.kind === 261 /* JsxAttributes */) &&
	                    node.parent.name === node ? node.parent : undefined;
	        }
	        return undefined;
	    }
	    ts.getContainingObjectLiteralElement = getContainingObjectLiteralElement;
	    /* @internal */
	    function getPropertySymbolsFromContextualType(typeChecker, node) {
	        var objectLiteral = node.parent;
	        var contextualType = typeChecker.getContextualType(objectLiteral);
	        return getPropertySymbolsFromType(contextualType, node.name);
	    }
	    ts.getPropertySymbolsFromContextualType = getPropertySymbolsFromContextualType;
	    /* @internal */
	    function getPropertySymbolsFromType(type, propName) {
	        var name = ts.unescapeLeadingUnderscores(ts.getTextOfPropertyName(propName));
	        if (name && type) {
	            var result_6 = [];
	            var symbol = type.getProperty(name);
	            if (type.flags & 131072 /* Union */) {
	                ts.forEach(type.types, function (t) {
	                    var symbol = t.getProperty(name);
	                    if (symbol) {
	                        result_6.push(symbol);
	                    }
	                });
	                return result_6;
	            }
	            if (symbol) {
	                result_6.push(symbol);
	                return result_6;
	            }
	        }
	        return undefined;
	    }
	    ts.getPropertySymbolsFromType = getPropertySymbolsFromType;
	    function isArgumentOfElementAccessExpression(node) {
	        return node &&
	            node.parent &&
	            node.parent.kind === 184 /* ElementAccessExpression */ &&
	            node.parent.argumentExpression === node;
	    }
	    /**
	     * Get the path of the default library files (lib.d.ts) as distributed with the typescript
	     * node package.
	     * The functionality is not supported if the ts module is consumed outside of a node module.
	     */
	    function getDefaultLibFilePath(options) {
	        // Check __dirname is defined and that we are on a node.js system.
	        if (true) {
	            return __dirname + ts.directorySeparator + ts.getDefaultLibFileName(options);
	        }
	        throw new Error("getDefaultLibFilePath is only supported when consumed as a node module. ");
	    }
	    ts.getDefaultLibFilePath = getDefaultLibFilePath;
	    ts.objectAllocator = getServicesObjectAllocator();
	})(ts || (ts = {}));
	// Copyright (c) Microsoft. All rights reserved. Licensed under the Apache License, Version 2.0.
	// See LICENSE.txt in the project root for complete license information.
	/// <reference path='services.ts' />
	/* @internal */
	var ts;
	(function (ts) {
	    var BreakpointResolver;
	    (function (BreakpointResolver) {
	        /**
	         * Get the breakpoint span in given sourceFile
	         */
	        function spanInSourceFileAtLocation(sourceFile, position) {
	            // Cannot set breakpoint in dts file
	            if (sourceFile.isDeclarationFile) {
	                return undefined;
	            }
	            var tokenAtLocation = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	            var lineOfPosition = sourceFile.getLineAndCharacterOfPosition(position).line;
	            if (sourceFile.getLineAndCharacterOfPosition(tokenAtLocation.getStart(sourceFile)).line > lineOfPosition) {
	                // Get previous token if the token is returned starts on new line
	                // eg: let x =10; |--- cursor is here
	                //     let y = 10;
	                // token at position will return let keyword on second line as the token but we would like to use
	                // token on same line if trailing trivia (comments or white spaces on same line) part of the last token on that line
	                tokenAtLocation = ts.findPrecedingToken(tokenAtLocation.pos, sourceFile);
	                // It's a blank line
	                if (!tokenAtLocation || sourceFile.getLineAndCharacterOfPosition(tokenAtLocation.getEnd()).line !== lineOfPosition) {
	                    return undefined;
	                }
	            }
	            // Cannot set breakpoint in ambient declarations
	            if (tokenAtLocation.flags & 2097152 /* Ambient */) {
	                return undefined;
	            }
	            // Get the span in the node based on its syntax
	            return spanInNode(tokenAtLocation);
	            function textSpan(startNode, endNode) {
	                var start = startNode.decorators ?
	                    ts.skipTrivia(sourceFile.text, startNode.decorators.end) :
	                    startNode.getStart(sourceFile);
	                return ts.createTextSpanFromBounds(start, (endNode || startNode).getEnd());
	            }
	            function textSpanEndingAtNextToken(startNode, previousTokenToFindNextEndToken) {
	                return textSpan(startNode, ts.findNextToken(previousTokenToFindNextEndToken, previousTokenToFindNextEndToken.parent));
	            }
	            function spanInNodeIfStartsOnSameLine(node, otherwiseOnNode) {
	                if (node && lineOfPosition === sourceFile.getLineAndCharacterOfPosition(node.getStart(sourceFile)).line) {
	                    return spanInNode(node);
	                }
	                return spanInNode(otherwiseOnNode);
	            }
	            function spanInNodeArray(nodeArray) {
	                return ts.createTextSpanFromBounds(ts.skipTrivia(sourceFile.text, nodeArray.pos), nodeArray.end);
	            }
	            function spanInPreviousNode(node) {
	                return spanInNode(ts.findPrecedingToken(node.pos, sourceFile));
	            }
	            function spanInNextNode(node) {
	                return spanInNode(ts.findNextToken(node, node.parent));
	            }
	            function spanInNode(node) {
	                if (node) {
	                    switch (node.kind) {
	                        case 212 /* VariableStatement */:
	                            // Span on first variable declaration
	                            return spanInVariableDeclaration(node.declarationList.declarations[0]);
	                        case 230 /* VariableDeclaration */:
	                        case 151 /* PropertyDeclaration */:
	                        case 150 /* PropertySignature */:
	                            return spanInVariableDeclaration(node);
	                        case 148 /* Parameter */:
	                            return spanInParameterDeclaration(node);
	                        case 232 /* FunctionDeclaration */:
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                        case 154 /* Constructor */:
	                        case 190 /* FunctionExpression */:
	                        case 191 /* ArrowFunction */:
	                            return spanInFunctionDeclaration(node);
	                        case 211 /* Block */:
	                            if (ts.isFunctionBlock(node)) {
	                                return spanInFunctionBlock(node);
	                            }
	                        // falls through
	                        case 238 /* ModuleBlock */:
	                            return spanInBlock(node);
	                        case 267 /* CatchClause */:
	                            return spanInBlock(node.block);
	                        case 214 /* ExpressionStatement */:
	                            // span on the expression
	                            return textSpan(node.expression);
	                        case 223 /* ReturnStatement */:
	                            // span on return keyword and expression if present
	                            return textSpan(node.getChildAt(0), node.expression);
	                        case 217 /* WhileStatement */:
	                            // Span on while(...)
	                            return textSpanEndingAtNextToken(node, node.expression);
	                        case 216 /* DoStatement */:
	                            // span in statement of the do statement
	                            return spanInNode(node.statement);
	                        case 229 /* DebuggerStatement */:
	                            // span on debugger keyword
	                            return textSpan(node.getChildAt(0));
	                        case 215 /* IfStatement */:
	                            // set on if(..) span
	                            return textSpanEndingAtNextToken(node, node.expression);
	                        case 226 /* LabeledStatement */:
	                            // span in statement
	                            return spanInNode(node.statement);
	                        case 222 /* BreakStatement */:
	                        case 221 /* ContinueStatement */:
	                            // On break or continue keyword and label if present
	                            return textSpan(node.getChildAt(0), node.label);
	                        case 218 /* ForStatement */:
	                            return spanInForStatement(node);
	                        case 219 /* ForInStatement */:
	                            // span of for (a in ...)
	                            return textSpanEndingAtNextToken(node, node.expression);
	                        case 220 /* ForOfStatement */:
	                            // span in initializer
	                            return spanInInitializerOfForLike(node);
	                        case 225 /* SwitchStatement */:
	                            // span on switch(...)
	                            return textSpanEndingAtNextToken(node, node.expression);
	                        case 264 /* CaseClause */:
	                        case 265 /* DefaultClause */:
	                            // span in first statement of the clause
	                            return spanInNode(node.statements[0]);
	                        case 228 /* TryStatement */:
	                            // span in try block
	                            return spanInBlock(node.tryBlock);
	                        case 227 /* ThrowStatement */:
	                            // span in throw ...
	                            return textSpan(node, node.expression);
	                        case 247 /* ExportAssignment */:
	                            // span on export = id
	                            return textSpan(node, node.expression);
	                        case 241 /* ImportEqualsDeclaration */:
	                            // import statement without including semicolon
	                            return textSpan(node, node.moduleReference);
	                        case 242 /* ImportDeclaration */:
	                            // import statement without including semicolon
	                            return textSpan(node, node.moduleSpecifier);
	                        case 248 /* ExportDeclaration */:
	                            // import statement without including semicolon
	                            return textSpan(node, node.moduleSpecifier);
	                        case 237 /* ModuleDeclaration */:
	                            // span on complete module if it is instantiated
	                            if (ts.getModuleInstanceState(node) !== 1 /* Instantiated */) {
	                                return undefined;
	                            }
	                        // falls through
	                        case 233 /* ClassDeclaration */:
	                        case 236 /* EnumDeclaration */:
	                        case 271 /* EnumMember */:
	                        case 180 /* BindingElement */:
	                            // span on complete node
	                            return textSpan(node);
	                        case 224 /* WithStatement */:
	                            // span in statement
	                            return spanInNode(node.statement);
	                        case 149 /* Decorator */:
	                            return spanInNodeArray(node.parent.decorators);
	                        case 178 /* ObjectBindingPattern */:
	                        case 179 /* ArrayBindingPattern */:
	                            return spanInBindingPattern(node);
	                        // No breakpoint in interface, type alias
	                        case 234 /* InterfaceDeclaration */:
	                        case 235 /* TypeAliasDeclaration */:
	                            return undefined;
	                        // Tokens:
	                        case 25 /* SemicolonToken */:
	                        case 1 /* EndOfFileToken */:
	                            return spanInNodeIfStartsOnSameLine(ts.findPrecedingToken(node.pos, sourceFile));
	                        case 26 /* CommaToken */:
	                            return spanInPreviousNode(node);
	                        case 17 /* OpenBraceToken */:
	                            return spanInOpenBraceToken(node);
	                        case 18 /* CloseBraceToken */:
	                            return spanInCloseBraceToken(node);
	                        case 22 /* CloseBracketToken */:
	                            return spanInCloseBracketToken(node);
	                        case 19 /* OpenParenToken */:
	                            return spanInOpenParenToken(node);
	                        case 20 /* CloseParenToken */:
	                            return spanInCloseParenToken(node);
	                        case 56 /* ColonToken */:
	                            return spanInColonToken(node);
	                        case 29 /* GreaterThanToken */:
	                        case 27 /* LessThanToken */:
	                            return spanInGreaterThanOrLessThanToken(node);
	                        // Keywords:
	                        case 106 /* WhileKeyword */:
	                            return spanInWhileKeyword(node);
	                        case 82 /* ElseKeyword */:
	                        case 74 /* CatchKeyword */:
	                        case 87 /* FinallyKeyword */:
	                            return spanInNextNode(node);
	                        case 144 /* OfKeyword */:
	                            return spanInOfKeyword(node);
	                        default:
	                            // Destructuring pattern in destructuring assignment
	                            // [a, b, c] of
	                            // [a, b, c] = expression
	                            if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node)) {
	                                return spanInArrayLiteralOrObjectLiteralDestructuringPattern(node);
	                            }
	                            // Set breakpoint on identifier element of destructuring pattern
	                            // `a` or `...c` or `d: x` from
	                            // `[a, b, ...c]` or `{ a, b }` or `{ d: x }` from destructuring pattern
	                            if ((node.kind === 71 /* Identifier */ ||
	                                node.kind === 202 /* SpreadElement */ ||
	                                node.kind === 268 /* PropertyAssignment */ ||
	                                node.kind === 269 /* ShorthandPropertyAssignment */) &&
	                                ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) {
	                                return textSpan(node);
	                            }
	                            if (node.kind === 198 /* BinaryExpression */) {
	                                var binaryExpression = node;
	                                // Set breakpoint in destructuring pattern if its destructuring assignment
	                                // [a, b, c] or {a, b, c} of
	                                // [a, b, c] = expression or
	                                // {a, b, c} = expression
	                                if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(binaryExpression.left)) {
	                                    return spanInArrayLiteralOrObjectLiteralDestructuringPattern(binaryExpression.left);
	                                }
	                                if (binaryExpression.operatorToken.kind === 58 /* EqualsToken */ &&
	                                    ts.isArrayLiteralOrObjectLiteralDestructuringPattern(binaryExpression.parent)) {
	                                    // Set breakpoint on assignment expression element of destructuring pattern
	                                    // a = expression of
	                                    // [a = expression, b, c] = someExpression or
	                                    // { a = expression, b, c } = someExpression
	                                    return textSpan(node);
	                                }
	                                if (binaryExpression.operatorToken.kind === 26 /* CommaToken */) {
	                                    return spanInNode(binaryExpression.left);
	                                }
	                            }
	                            if (ts.isExpressionNode(node)) {
	                                switch (node.parent.kind) {
	                                    case 216 /* DoStatement */:
	                                        // Set span as if on while keyword
	                                        return spanInPreviousNode(node);
	                                    case 149 /* Decorator */:
	                                        // Set breakpoint on the decorator emit
	                                        return spanInNode(node.parent);
	                                    case 218 /* ForStatement */:
	                                    case 220 /* ForOfStatement */:
	                                        return textSpan(node);
	                                    case 198 /* BinaryExpression */:
	                                        if (node.parent.operatorToken.kind === 26 /* CommaToken */) {
	                                            // If this is a comma expression, the breakpoint is possible in this expression
	                                            return textSpan(node);
	                                        }
	                                        break;
	                                    case 191 /* ArrowFunction */:
	                                        if (node.parent.body === node) {
	                                            // If this is body of arrow function, it is allowed to have the breakpoint
	                                            return textSpan(node);
	                                        }
	                                        break;
	                                }
	                            }
	                            // If this is name of property assignment, set breakpoint in the initializer
	                            if (node.parent.kind === 268 /* PropertyAssignment */ &&
	                                node.parent.name === node &&
	                                !ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent.parent)) {
	                                return spanInNode(node.parent.initializer);
	                            }
	                            // Breakpoint in type assertion goes to its operand
	                            if (node.parent.kind === 188 /* TypeAssertionExpression */ && node.parent.type === node) {
	                                return spanInNextNode(node.parent.type);
	                            }
	                            // return type of function go to previous token
	                            if (ts.isFunctionLike(node.parent) && node.parent.type === node) {
	                                return spanInPreviousNode(node);
	                            }
	                            // initializer of variable/parameter declaration go to previous node
	                            if ((node.parent.kind === 230 /* VariableDeclaration */ ||
	                                node.parent.kind === 148 /* Parameter */)) {
	                                var paramOrVarDecl = node.parent;
	                                if (paramOrVarDecl.initializer === node ||
	                                    paramOrVarDecl.type === node ||
	                                    ts.isAssignmentOperator(node.kind)) {
	                                    return spanInPreviousNode(node);
	                                }
	                            }
	                            if (node.parent.kind === 198 /* BinaryExpression */) {
	                                var binaryExpression = node.parent;
	                                if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(binaryExpression.left) &&
	                                    (binaryExpression.right === node ||
	                                        binaryExpression.operatorToken === node)) {
	                                    // If initializer of destructuring assignment move to previous token
	                                    return spanInPreviousNode(node);
	                                }
	                            }
	                            // Default go to parent to set the breakpoint
	                            return spanInNode(node.parent);
	                    }
	                }
	                function textSpanFromVariableDeclaration(variableDeclaration) {
	                    if (variableDeclaration.parent.kind === 231 /* VariableDeclarationList */ &&
	                        variableDeclaration.parent.declarations[0] === variableDeclaration) {
	                        // First declaration - include let keyword
	                        return textSpan(ts.findPrecedingToken(variableDeclaration.pos, sourceFile, variableDeclaration.parent), variableDeclaration);
	                    }
	                    else {
	                        // Span only on this declaration
	                        return textSpan(variableDeclaration);
	                    }
	                }
	                function spanInVariableDeclaration(variableDeclaration) {
	                    // If declaration of for in statement, just set the span in parent
	                    if (variableDeclaration.parent.parent.kind === 219 /* ForInStatement */) {
	                        return spanInNode(variableDeclaration.parent.parent);
	                    }
	                    // If this is a destructuring pattern, set breakpoint in binding pattern
	                    if (ts.isBindingPattern(variableDeclaration.name)) {
	                        return spanInBindingPattern(variableDeclaration.name);
	                    }
	                    // Breakpoint is possible in variableDeclaration only if there is initialization
	                    // or its declaration from 'for of'
	                    if (variableDeclaration.initializer ||
	                        ts.hasModifier(variableDeclaration, 1 /* Export */) ||
	                        variableDeclaration.parent.parent.kind === 220 /* ForOfStatement */) {
	                        return textSpanFromVariableDeclaration(variableDeclaration);
	                    }
	                    if (variableDeclaration.parent.kind === 231 /* VariableDeclarationList */ &&
	                        variableDeclaration.parent.declarations[0] !== variableDeclaration) {
	                        // If we cannot set breakpoint on this declaration, set it on previous one
	                        // Because the variable declaration may be binding pattern and
	                        // we would like to set breakpoint in last binding element if that's the case,
	                        // use preceding token instead
	                        return spanInNode(ts.findPrecedingToken(variableDeclaration.pos, sourceFile, variableDeclaration.parent));
	                    }
	                }
	                function canHaveSpanInParameterDeclaration(parameter) {
	                    // Breakpoint is possible on parameter only if it has initializer, is a rest parameter, or has public or private modifier
	                    return !!parameter.initializer || parameter.dotDotDotToken !== undefined ||
	                        ts.hasModifier(parameter, 4 /* Public */ | 8 /* Private */);
	                }
	                function spanInParameterDeclaration(parameter) {
	                    if (ts.isBindingPattern(parameter.name)) {
	                        // Set breakpoint in binding pattern
	                        return spanInBindingPattern(parameter.name);
	                    }
	                    else if (canHaveSpanInParameterDeclaration(parameter)) {
	                        return textSpan(parameter);
	                    }
	                    else {
	                        var functionDeclaration = parameter.parent;
	                        var indexOfParameter = functionDeclaration.parameters.indexOf(parameter);
	                        ts.Debug.assert(indexOfParameter !== -1);
	                        if (indexOfParameter !== 0) {
	                            // Not a first parameter, go to previous parameter
	                            return spanInParameterDeclaration(functionDeclaration.parameters[indexOfParameter - 1]);
	                        }
	                        else {
	                            // Set breakpoint in the function declaration body
	                            return spanInNode(functionDeclaration.body);
	                        }
	                    }
	                }
	                function canFunctionHaveSpanInWholeDeclaration(functionDeclaration) {
	                    return ts.hasModifier(functionDeclaration, 1 /* Export */) ||
	                        (functionDeclaration.parent.kind === 233 /* ClassDeclaration */ && functionDeclaration.kind !== 154 /* Constructor */);
	                }
	                function spanInFunctionDeclaration(functionDeclaration) {
	                    // No breakpoints in the function signature
	                    if (!functionDeclaration.body) {
	                        return undefined;
	                    }
	                    if (canFunctionHaveSpanInWholeDeclaration(functionDeclaration)) {
	                        // Set the span on whole function declaration
	                        return textSpan(functionDeclaration);
	                    }
	                    // Set span in function body
	                    return spanInNode(functionDeclaration.body);
	                }
	                function spanInFunctionBlock(block) {
	                    var nodeForSpanInBlock = block.statements.length ? block.statements[0] : block.getLastToken();
	                    if (canFunctionHaveSpanInWholeDeclaration(block.parent)) {
	                        return spanInNodeIfStartsOnSameLine(block.parent, nodeForSpanInBlock);
	                    }
	                    return spanInNode(nodeForSpanInBlock);
	                }
	                function spanInBlock(block) {
	                    switch (block.parent.kind) {
	                        case 237 /* ModuleDeclaration */:
	                            if (ts.getModuleInstanceState(block.parent) !== 1 /* Instantiated */) {
	                                return undefined;
	                            }
	                        // falls through
	                        // Set on parent if on same line otherwise on first statement
	                        case 217 /* WhileStatement */:
	                        case 215 /* IfStatement */:
	                        case 219 /* ForInStatement */:
	                            return spanInNodeIfStartsOnSameLine(block.parent, block.statements[0]);
	                        // Set span on previous token if it starts on same line otherwise on the first statement of the block
	                        case 218 /* ForStatement */:
	                        case 220 /* ForOfStatement */:
	                            return spanInNodeIfStartsOnSameLine(ts.findPrecedingToken(block.pos, sourceFile, block.parent), block.statements[0]);
	                    }
	                    // Default action is to set on first statement
	                    return spanInNode(block.statements[0]);
	                }
	                function spanInInitializerOfForLike(forLikeStatement) {
	                    if (forLikeStatement.initializer.kind === 231 /* VariableDeclarationList */) {
	                        // Declaration list - set breakpoint in first declaration
	                        var variableDeclarationList = forLikeStatement.initializer;
	                        if (variableDeclarationList.declarations.length > 0) {
	                            return spanInNode(variableDeclarationList.declarations[0]);
	                        }
	                    }
	                    else {
	                        // Expression - set breakpoint in it
	                        return spanInNode(forLikeStatement.initializer);
	                    }
	                }
	                function spanInForStatement(forStatement) {
	                    if (forStatement.initializer) {
	                        return spanInInitializerOfForLike(forStatement);
	                    }
	                    if (forStatement.condition) {
	                        return textSpan(forStatement.condition);
	                    }
	                    if (forStatement.incrementor) {
	                        return textSpan(forStatement.incrementor);
	                    }
	                }
	                function spanInBindingPattern(bindingPattern) {
	                    // Set breakpoint in first binding element
	                    var firstBindingElement = ts.forEach(bindingPattern.elements, function (element) { return element.kind !== 204 /* OmittedExpression */ ? element : undefined; });
	                    if (firstBindingElement) {
	                        return spanInNode(firstBindingElement);
	                    }
	                    // Empty binding pattern of binding element, set breakpoint on binding element
	                    if (bindingPattern.parent.kind === 180 /* BindingElement */) {
	                        return textSpan(bindingPattern.parent);
	                    }
	                    // Variable declaration is used as the span
	                    return textSpanFromVariableDeclaration(bindingPattern.parent);
	                }
	                function spanInArrayLiteralOrObjectLiteralDestructuringPattern(node) {
	                    ts.Debug.assert(node.kind !== 179 /* ArrayBindingPattern */ && node.kind !== 178 /* ObjectBindingPattern */);
	                    var elements = node.kind === 181 /* ArrayLiteralExpression */ ? node.elements : node.properties;
	                    var firstBindingElement = ts.forEach(elements, function (element) { return element.kind !== 204 /* OmittedExpression */ ? element : undefined; });
	                    if (firstBindingElement) {
	                        return spanInNode(firstBindingElement);
	                    }
	                    // Could be ArrayLiteral from destructuring assignment or
	                    // just nested element in another destructuring assignment
	                    // set breakpoint on assignment when parent is destructuring assignment
	                    // Otherwise set breakpoint for this element
	                    return textSpan(node.parent.kind === 198 /* BinaryExpression */ ? node.parent : node);
	                }
	                // Tokens:
	                function spanInOpenBraceToken(node) {
	                    switch (node.parent.kind) {
	                        case 236 /* EnumDeclaration */:
	                            var enumDeclaration = node.parent;
	                            return spanInNodeIfStartsOnSameLine(ts.findPrecedingToken(node.pos, sourceFile, node.parent), enumDeclaration.members.length ? enumDeclaration.members[0] : enumDeclaration.getLastToken(sourceFile));
	                        case 233 /* ClassDeclaration */:
	                            var classDeclaration = node.parent;
	                            return spanInNodeIfStartsOnSameLine(ts.findPrecedingToken(node.pos, sourceFile, node.parent), classDeclaration.members.length ? classDeclaration.members[0] : classDeclaration.getLastToken(sourceFile));
	                        case 239 /* CaseBlock */:
	                            return spanInNodeIfStartsOnSameLine(node.parent.parent, node.parent.clauses[0]);
	                    }
	                    // Default to parent node
	                    return spanInNode(node.parent);
	                }
	                function spanInCloseBraceToken(node) {
	                    switch (node.parent.kind) {
	                        case 238 /* ModuleBlock */:
	                            // If this is not an instantiated module block, no bp span
	                            if (ts.getModuleInstanceState(node.parent.parent) !== 1 /* Instantiated */) {
	                                return undefined;
	                            }
	                        // falls through
	                        case 236 /* EnumDeclaration */:
	                        case 233 /* ClassDeclaration */:
	                            // Span on close brace token
	                            return textSpan(node);
	                        case 211 /* Block */:
	                            if (ts.isFunctionBlock(node.parent)) {
	                                // Span on close brace token
	                                return textSpan(node);
	                            }
	                        // falls through
	                        case 267 /* CatchClause */:
	                            return spanInNode(ts.lastOrUndefined(node.parent.statements));
	                        case 239 /* CaseBlock */:
	                            // breakpoint in last statement of the last clause
	                            var caseBlock = node.parent;
	                            var lastClause = ts.lastOrUndefined(caseBlock.clauses);
	                            if (lastClause) {
	                                return spanInNode(ts.lastOrUndefined(lastClause.statements));
	                            }
	                            return undefined;
	                        case 178 /* ObjectBindingPattern */:
	                            // Breakpoint in last binding element or binding pattern if it contains no elements
	                            var bindingPattern = node.parent;
	                            return spanInNode(ts.lastOrUndefined(bindingPattern.elements) || bindingPattern);
	                        // Default to parent node
	                        default:
	                            if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) {
	                                // Breakpoint in last binding element or binding pattern if it contains no elements
	                                var objectLiteral = node.parent;
	                                return textSpan(ts.lastOrUndefined(objectLiteral.properties) || objectLiteral);
	                            }
	                            return spanInNode(node.parent);
	                    }
	                }
	                function spanInCloseBracketToken(node) {
	                    switch (node.parent.kind) {
	                        case 179 /* ArrayBindingPattern */:
	                            // Breakpoint in last binding element or binding pattern if it contains no elements
	                            var bindingPattern = node.parent;
	                            return textSpan(ts.lastOrUndefined(bindingPattern.elements) || bindingPattern);
	                        default:
	                            if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) {
	                                // Breakpoint in last binding element or binding pattern if it contains no elements
	                                var arrayLiteral = node.parent;
	                                return textSpan(ts.lastOrUndefined(arrayLiteral.elements) || arrayLiteral);
	                            }
	                            // Default to parent node
	                            return spanInNode(node.parent);
	                    }
	                }
	                function spanInOpenParenToken(node) {
	                    if (node.parent.kind === 216 /* DoStatement */ || // Go to while keyword and do action instead
	                        node.parent.kind === 185 /* CallExpression */ ||
	                        node.parent.kind === 186 /* NewExpression */) {
	                        return spanInPreviousNode(node);
	                    }
	                    if (node.parent.kind === 189 /* ParenthesizedExpression */) {
	                        return spanInNextNode(node);
	                    }
	                    // Default to parent node
	                    return spanInNode(node.parent);
	                }
	                function spanInCloseParenToken(node) {
	                    // Is this close paren token of parameter list, set span in previous token
	                    switch (node.parent.kind) {
	                        case 190 /* FunctionExpression */:
	                        case 232 /* FunctionDeclaration */:
	                        case 191 /* ArrowFunction */:
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                        case 154 /* Constructor */:
	                        case 217 /* WhileStatement */:
	                        case 216 /* DoStatement */:
	                        case 218 /* ForStatement */:
	                        case 220 /* ForOfStatement */:
	                        case 185 /* CallExpression */:
	                        case 186 /* NewExpression */:
	                        case 189 /* ParenthesizedExpression */:
	                            return spanInPreviousNode(node);
	                        // Default to parent node
	                        default:
	                            return spanInNode(node.parent);
	                    }
	                }
	                function spanInColonToken(node) {
	                    // Is this : specifying return annotation of the function declaration
	                    if (ts.isFunctionLike(node.parent) ||
	                        node.parent.kind === 268 /* PropertyAssignment */ ||
	                        node.parent.kind === 148 /* Parameter */) {
	                        return spanInPreviousNode(node);
	                    }
	                    return spanInNode(node.parent);
	                }
	                function spanInGreaterThanOrLessThanToken(node) {
	                    if (node.parent.kind === 188 /* TypeAssertionExpression */) {
	                        return spanInNextNode(node);
	                    }
	                    return spanInNode(node.parent);
	                }
	                function spanInWhileKeyword(node) {
	                    if (node.parent.kind === 216 /* DoStatement */) {
	                        // Set span on while expression
	                        return textSpanEndingAtNextToken(node, node.parent.expression);
	                    }
	                    // Default to parent node
	                    return spanInNode(node.parent);
	                }
	                function spanInOfKeyword(node) {
	                    if (node.parent.kind === 220 /* ForOfStatement */) {
	                        // Set using next token
	                        return spanInNextNode(node);
	                    }
	                    // Default to parent node
	                    return spanInNode(node.parent);
	                }
	            }
	        }
	        BreakpointResolver.spanInSourceFileAtLocation = spanInSourceFileAtLocation;
	    })(BreakpointResolver = ts.BreakpointResolver || (ts.BreakpointResolver = {}));
	})(ts || (ts = {}));
	/// <reference path="..\compiler\transformer.ts"/>
	/// <reference path="transpile.ts"/>
	var ts;
	(function (ts) {
	    /**
	     * Transform one or more nodes using the supplied transformers.
	     * @param source A single `Node` or an array of `Node` objects.
	     * @param transformers An array of `TransformerFactory` callbacks used to process the transformation.
	     * @param compilerOptions Optional compiler options.
	     */
	    function transform(source, transformers, compilerOptions) {
	        var diagnostics = [];
	        compilerOptions = ts.fixupCompilerOptions(compilerOptions, diagnostics);
	        var nodes = ts.isArray(source) ? source : [source];
	        var result = ts.transformNodes(/*resolver*/ undefined, /*emitHost*/ undefined, compilerOptions, nodes, transformers, /*allowDtsFiles*/ true);
	        result.diagnostics = ts.concatenate(result.diagnostics, diagnostics);
	        return result;
	    }
	    ts.transform = transform;
	})(ts || (ts = {}));
	//
	// Copyright (c) Microsoft Corporation.  All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	//
	/// <reference path='services.ts' />
	/* @internal */
	var debugObjectHost = (function () { return this; })();
	// We need to use 'null' to interface with the managed side.
	/* tslint:disable:no-null-keyword */
	/* tslint:disable:no-in-operator */
	/* @internal */
	var ts;
	(function (ts) {
	    function logInternalError(logger, err) {
	        if (logger) {
	            logger.log("*INTERNAL ERROR* - Exception in typescript services: " + err.message);
	        }
	    }
	    var ScriptSnapshotShimAdapter = /** @class */ (function () {
	        function ScriptSnapshotShimAdapter(scriptSnapshotShim) {
	            this.scriptSnapshotShim = scriptSnapshotShim;
	        }
	        ScriptSnapshotShimAdapter.prototype.getText = function (start, end) {
	            return this.scriptSnapshotShim.getText(start, end);
	        };
	        ScriptSnapshotShimAdapter.prototype.getLength = function () {
	            return this.scriptSnapshotShim.getLength();
	        };
	        ScriptSnapshotShimAdapter.prototype.getChangeRange = function (oldSnapshot) {
	            var oldSnapshotShim = oldSnapshot;
	            var encoded = this.scriptSnapshotShim.getChangeRange(oldSnapshotShim.scriptSnapshotShim);
	            if (encoded === null) {
	                return null;
	            }
	            var decoded = JSON.parse(encoded);
	            return ts.createTextChangeRange(ts.createTextSpan(decoded.span.start, decoded.span.length), decoded.newLength);
	        };
	        ScriptSnapshotShimAdapter.prototype.dispose = function () {
	            // if scriptSnapshotShim is a COM object then property check becomes method call with no arguments
	            // 'in' does not have this effect
	            if ("dispose" in this.scriptSnapshotShim) {
	                this.scriptSnapshotShim.dispose();
	            }
	        };
	        return ScriptSnapshotShimAdapter;
	    }());
	    var LanguageServiceShimHostAdapter = /** @class */ (function () {
	        function LanguageServiceShimHostAdapter(shimHost) {
	            var _this = this;
	            this.shimHost = shimHost;
	            this.loggingEnabled = false;
	            this.tracingEnabled = false;
	            // if shimHost is a COM object then property check will become method call with no arguments.
	            // 'in' does not have this effect.
	            if ("getModuleResolutionsForFile" in this.shimHost) {
	                this.resolveModuleNames = function (moduleNames, containingFile) {
	                    var resolutionsInFile = JSON.parse(_this.shimHost.getModuleResolutionsForFile(containingFile));
	                    return ts.map(moduleNames, function (name) {
	                        var result = ts.getProperty(resolutionsInFile, name);
	                        return result ? { resolvedFileName: result, extension: ts.extensionFromPath(result), isExternalLibraryImport: false } : undefined;
	                    });
	                };
	            }
	            if ("directoryExists" in this.shimHost) {
	                this.directoryExists = function (directoryName) { return _this.shimHost.directoryExists(directoryName); };
	            }
	            if ("getTypeReferenceDirectiveResolutionsForFile" in this.shimHost) {
	                this.resolveTypeReferenceDirectives = function (typeDirectiveNames, containingFile) {
	                    var typeDirectivesForFile = JSON.parse(_this.shimHost.getTypeReferenceDirectiveResolutionsForFile(containingFile));
	                    return ts.map(typeDirectiveNames, function (name) { return ts.getProperty(typeDirectivesForFile, name); });
	                };
	            }
	        }
	        LanguageServiceShimHostAdapter.prototype.log = function (s) {
	            if (this.loggingEnabled) {
	                this.shimHost.log(s);
	            }
	        };
	        LanguageServiceShimHostAdapter.prototype.trace = function (s) {
	            if (this.tracingEnabled) {
	                this.shimHost.trace(s);
	            }
	        };
	        LanguageServiceShimHostAdapter.prototype.error = function (s) {
	            this.shimHost.error(s);
	        };
	        LanguageServiceShimHostAdapter.prototype.getProjectVersion = function () {
	            if (!this.shimHost.getProjectVersion) {
	                // shimmed host does not support getProjectVersion
	                return undefined;
	            }
	            return this.shimHost.getProjectVersion();
	        };
	        LanguageServiceShimHostAdapter.prototype.getTypeRootsVersion = function () {
	            if (!this.shimHost.getTypeRootsVersion) {
	                return 0;
	            }
	            return this.shimHost.getTypeRootsVersion();
	        };
	        LanguageServiceShimHostAdapter.prototype.useCaseSensitiveFileNames = function () {
	            return this.shimHost.useCaseSensitiveFileNames ? this.shimHost.useCaseSensitiveFileNames() : false;
	        };
	        LanguageServiceShimHostAdapter.prototype.getCompilationSettings = function () {
	            var settingsJson = this.shimHost.getCompilationSettings();
	            if (settingsJson === null || settingsJson === "") {
	                throw Error("LanguageServiceShimHostAdapter.getCompilationSettings: empty compilationSettings");
	            }
	            var compilerOptions = JSON.parse(settingsJson);
	            // permit language service to handle all files (filtering should be performed on the host side)
	            compilerOptions.allowNonTsExtensions = true;
	            return compilerOptions;
	        };
	        LanguageServiceShimHostAdapter.prototype.getScriptFileNames = function () {
	            var encoded = this.shimHost.getScriptFileNames();
	            return this.files = JSON.parse(encoded);
	        };
	        LanguageServiceShimHostAdapter.prototype.getScriptSnapshot = function (fileName) {
	            var scriptSnapshot = this.shimHost.getScriptSnapshot(fileName);
	            return scriptSnapshot && new ScriptSnapshotShimAdapter(scriptSnapshot);
	        };
	        LanguageServiceShimHostAdapter.prototype.getScriptKind = function (fileName) {
	            if ("getScriptKind" in this.shimHost) {
	                return this.shimHost.getScriptKind(fileName);
	            }
	            else {
	                return 0 /* Unknown */;
	            }
	        };
	        LanguageServiceShimHostAdapter.prototype.getScriptVersion = function (fileName) {
	            return this.shimHost.getScriptVersion(fileName);
	        };
	        LanguageServiceShimHostAdapter.prototype.getLocalizedDiagnosticMessages = function () {
	            var diagnosticMessagesJson = this.shimHost.getLocalizedDiagnosticMessages();
	            if (diagnosticMessagesJson === null || diagnosticMessagesJson === "") {
	                return null;
	            }
	            try {
	                return JSON.parse(diagnosticMessagesJson);
	            }
	            catch (e) {
	                this.log(e.description || "diagnosticMessages.generated.json has invalid JSON format");
	                return null;
	            }
	        };
	        LanguageServiceShimHostAdapter.prototype.getCancellationToken = function () {
	            var hostCancellationToken = this.shimHost.getCancellationToken();
	            return new ts.ThrottledCancellationToken(hostCancellationToken);
	        };
	        LanguageServiceShimHostAdapter.prototype.getCurrentDirectory = function () {
	            return this.shimHost.getCurrentDirectory();
	        };
	        LanguageServiceShimHostAdapter.prototype.getDirectories = function (path) {
	            return JSON.parse(this.shimHost.getDirectories(path));
	        };
	        LanguageServiceShimHostAdapter.prototype.getDefaultLibFileName = function (options) {
	            return this.shimHost.getDefaultLibFileName(JSON.stringify(options));
	        };
	        LanguageServiceShimHostAdapter.prototype.readDirectory = function (path, extensions, exclude, include, depth) {
	            var pattern = ts.getFileMatcherPatterns(path, exclude, include, this.shimHost.useCaseSensitiveFileNames(), this.shimHost.getCurrentDirectory());
	            return JSON.parse(this.shimHost.readDirectory(path, JSON.stringify(extensions), JSON.stringify(pattern.basePaths), pattern.excludePattern, pattern.includeFilePattern, pattern.includeDirectoryPattern, depth));
	        };
	        LanguageServiceShimHostAdapter.prototype.readFile = function (path, encoding) {
	            return this.shimHost.readFile(path, encoding);
	        };
	        LanguageServiceShimHostAdapter.prototype.fileExists = function (path) {
	            return this.shimHost.fileExists(path);
	        };
	        return LanguageServiceShimHostAdapter;
	    }());
	    ts.LanguageServiceShimHostAdapter = LanguageServiceShimHostAdapter;
	    var CoreServicesShimHostAdapter = /** @class */ (function () {
	        function CoreServicesShimHostAdapter(shimHost) {
	            var _this = this;
	            this.shimHost = shimHost;
	            this.useCaseSensitiveFileNames = this.shimHost.useCaseSensitiveFileNames ? this.shimHost.useCaseSensitiveFileNames() : false;
	            if ("directoryExists" in this.shimHost) {
	                this.directoryExists = function (directoryName) { return _this.shimHost.directoryExists(directoryName); };
	            }
	            if ("realpath" in this.shimHost) {
	                this.realpath = function (path) { return _this.shimHost.realpath(path); };
	            }
	        }
	        CoreServicesShimHostAdapter.prototype.readDirectory = function (rootDir, extensions, exclude, include, depth) {
	            var pattern = ts.getFileMatcherPatterns(rootDir, exclude, include, this.shimHost.useCaseSensitiveFileNames(), this.shimHost.getCurrentDirectory());
	            return JSON.parse(this.shimHost.readDirectory(rootDir, JSON.stringify(extensions), JSON.stringify(pattern.basePaths), pattern.excludePattern, pattern.includeFilePattern, pattern.includeDirectoryPattern, depth));
	        };
	        CoreServicesShimHostAdapter.prototype.fileExists = function (fileName) {
	            return this.shimHost.fileExists(fileName);
	        };
	        CoreServicesShimHostAdapter.prototype.readFile = function (fileName) {
	            return this.shimHost.readFile(fileName);
	        };
	        CoreServicesShimHostAdapter.prototype.getDirectories = function (path) {
	            return JSON.parse(this.shimHost.getDirectories(path));
	        };
	        return CoreServicesShimHostAdapter;
	    }());
	    ts.CoreServicesShimHostAdapter = CoreServicesShimHostAdapter;
	    function simpleForwardCall(logger, actionDescription, action, logPerformance) {
	        var start;
	        if (logPerformance) {
	            logger.log(actionDescription);
	            start = ts.timestamp();
	        }
	        var result = action();
	        if (logPerformance) {
	            var end = ts.timestamp();
	            logger.log(actionDescription + " completed in " + (end - start) + " msec");
	            if (ts.isString(result)) {
	                var str = result;
	                if (str.length > 128) {
	                    str = str.substring(0, 128) + "...";
	                }
	                logger.log("  result.length=" + str.length + ", result='" + JSON.stringify(str) + "'");
	            }
	        }
	        return result;
	    }
	    function forwardJSONCall(logger, actionDescription, action, logPerformance) {
	        return forwardCall(logger, actionDescription, /*returnJson*/ true, action, logPerformance);
	    }
	    function forwardCall(logger, actionDescription, returnJson, action, logPerformance) {
	        try {
	            var result = simpleForwardCall(logger, actionDescription, action, logPerformance);
	            return returnJson ? JSON.stringify({ result: result }) : result;
	        }
	        catch (err) {
	            if (err instanceof ts.OperationCanceledException) {
	                return JSON.stringify({ canceled: true });
	            }
	            logInternalError(logger, err);
	            err.description = actionDescription;
	            return JSON.stringify({ error: err });
	        }
	    }
	    var ShimBase = /** @class */ (function () {
	        function ShimBase(factory) {
	            this.factory = factory;
	            factory.registerShim(this);
	        }
	        ShimBase.prototype.dispose = function (_dummy) {
	            this.factory.unregisterShim(this);
	        };
	        return ShimBase;
	    }());
	    function realizeDiagnostics(diagnostics, newLine) {
	        return diagnostics.map(function (d) { return realizeDiagnostic(d, newLine); });
	    }
	    ts.realizeDiagnostics = realizeDiagnostics;
	    function realizeDiagnostic(diagnostic, newLine) {
	        return {
	            message: ts.flattenDiagnosticMessageText(diagnostic.messageText, newLine),
	            start: diagnostic.start,
	            length: diagnostic.length,
	            /// TODO: no need for the tolowerCase call
	            category: ts.DiagnosticCategory[diagnostic.category].toLowerCase(),
	            code: diagnostic.code
	        };
	    }
	    var LanguageServiceShimObject = /** @class */ (function (_super) {
	        __extends(LanguageServiceShimObject, _super);
	        function LanguageServiceShimObject(factory, host, languageService) {
	            var _this = _super.call(this, factory) || this;
	            _this.host = host;
	            _this.languageService = languageService;
	            _this.logPerformance = false;
	            _this.logger = _this.host;
	            return _this;
	        }
	        LanguageServiceShimObject.prototype.forwardJSONCall = function (actionDescription, action) {
	            return forwardJSONCall(this.logger, actionDescription, action, this.logPerformance);
	        };
	        /// DISPOSE
	        /**
	         * Ensure (almost) deterministic release of internal Javascript resources when
	         * some external native objects holds onto us (e.g. Com/Interop).
	         */
	        LanguageServiceShimObject.prototype.dispose = function (dummy) {
	            this.logger.log("dispose()");
	            this.languageService.dispose();
	            this.languageService = null;
	            // force a GC
	            if (debugObjectHost && debugObjectHost.CollectGarbage) {
	                debugObjectHost.CollectGarbage();
	                this.logger.log("CollectGarbage()");
	            }
	            this.logger = null;
	            _super.prototype.dispose.call(this, dummy);
	        };
	        /// REFRESH
	        /**
	         * Update the list of scripts known to the compiler
	         */
	        LanguageServiceShimObject.prototype.refresh = function (throwOnError) {
	            this.forwardJSONCall("refresh(" + throwOnError + ")", function () { return null; });
	        };
	        LanguageServiceShimObject.prototype.cleanupSemanticCache = function () {
	            var _this = this;
	            this.forwardJSONCall("cleanupSemanticCache()", function () {
	                _this.languageService.cleanupSemanticCache();
	                return null;
	            });
	        };
	        LanguageServiceShimObject.prototype.realizeDiagnostics = function (diagnostics) {
	            var newLine = ts.getNewLineOrDefaultFromHost(this.host);
	            return ts.realizeDiagnostics(diagnostics, newLine);
	        };
	        LanguageServiceShimObject.prototype.getSyntacticClassifications = function (fileName, start, length) {
	            var _this = this;
	            return this.forwardJSONCall("getSyntacticClassifications('" + fileName + "', " + start + ", " + length + ")", function () { return _this.languageService.getSyntacticClassifications(fileName, ts.createTextSpan(start, length)); });
	        };
	        LanguageServiceShimObject.prototype.getSemanticClassifications = function (fileName, start, length) {
	            var _this = this;
	            return this.forwardJSONCall("getSemanticClassifications('" + fileName + "', " + start + ", " + length + ")", function () { return _this.languageService.getSemanticClassifications(fileName, ts.createTextSpan(start, length)); });
	        };
	        LanguageServiceShimObject.prototype.getEncodedSyntacticClassifications = function (fileName, start, length) {
	            var _this = this;
	            return this.forwardJSONCall("getEncodedSyntacticClassifications('" + fileName + "', " + start + ", " + length + ")", 
	            // directly serialize the spans out to a string.  This is much faster to decode
	            // on the managed side versus a full JSON array.
	            function () { return convertClassifications(_this.languageService.getEncodedSyntacticClassifications(fileName, ts.createTextSpan(start, length))); });
	        };
	        LanguageServiceShimObject.prototype.getEncodedSemanticClassifications = function (fileName, start, length) {
	            var _this = this;
	            return this.forwardJSONCall("getEncodedSemanticClassifications('" + fileName + "', " + start + ", " + length + ")", 
	            // directly serialize the spans out to a string.  This is much faster to decode
	            // on the managed side versus a full JSON array.
	            function () { return convertClassifications(_this.languageService.getEncodedSemanticClassifications(fileName, ts.createTextSpan(start, length))); });
	        };
	        LanguageServiceShimObject.prototype.getSyntacticDiagnostics = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getSyntacticDiagnostics('" + fileName + "')", function () {
	                var diagnostics = _this.languageService.getSyntacticDiagnostics(fileName);
	                return _this.realizeDiagnostics(diagnostics);
	            });
	        };
	        LanguageServiceShimObject.prototype.getSemanticDiagnostics = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getSemanticDiagnostics('" + fileName + "')", function () {
	                var diagnostics = _this.languageService.getSemanticDiagnostics(fileName);
	                return _this.realizeDiagnostics(diagnostics);
	            });
	        };
	        LanguageServiceShimObject.prototype.getCompilerOptionsDiagnostics = function () {
	            var _this = this;
	            return this.forwardJSONCall("getCompilerOptionsDiagnostics()", function () {
	                var diagnostics = _this.languageService.getCompilerOptionsDiagnostics();
	                return _this.realizeDiagnostics(diagnostics);
	            });
	        };
	        /// QUICKINFO
	        /**
	         * Computes a string representation of the type at the requested position
	         * in the active file.
	         */
	        LanguageServiceShimObject.prototype.getQuickInfoAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getQuickInfoAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getQuickInfoAtPosition(fileName, position); });
	        };
	        /// NAMEORDOTTEDNAMESPAN
	        /**
	         * Computes span information of the name or dotted name at the requested position
	         * in the active file.
	         */
	        LanguageServiceShimObject.prototype.getNameOrDottedNameSpan = function (fileName, startPos, endPos) {
	            var _this = this;
	            return this.forwardJSONCall("getNameOrDottedNameSpan('" + fileName + "', " + startPos + ", " + endPos + ")", function () { return _this.languageService.getNameOrDottedNameSpan(fileName, startPos, endPos); });
	        };
	        /**
	         * STATEMENTSPAN
	         * Computes span information of statement at the requested position in the active file.
	         */
	        LanguageServiceShimObject.prototype.getBreakpointStatementAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getBreakpointStatementAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getBreakpointStatementAtPosition(fileName, position); });
	        };
	        /// SIGNATUREHELP
	        LanguageServiceShimObject.prototype.getSignatureHelpItems = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getSignatureHelpItems('" + fileName + "', " + position + ")", function () { return _this.languageService.getSignatureHelpItems(fileName, position); });
	        };
	        /// GOTO DEFINITION
	        /**
	         * Computes the definition location and file for the symbol
	         * at the requested position.
	         */
	        LanguageServiceShimObject.prototype.getDefinitionAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getDefinitionAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getDefinitionAtPosition(fileName, position); });
	        };
	        /**
	         * Computes the definition location and file for the symbol
	         * at the requested position.
	         */
	        LanguageServiceShimObject.prototype.getDefinitionAndBoundSpan = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getDefinitionAndBoundSpan('" + fileName + "', " + position + ")", function () { return _this.languageService.getDefinitionAndBoundSpan(fileName, position); });
	        };
	        /// GOTO Type
	        /**
	         * Computes the definition location of the type of the symbol
	         * at the requested position.
	         */
	        LanguageServiceShimObject.prototype.getTypeDefinitionAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getTypeDefinitionAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getTypeDefinitionAtPosition(fileName, position); });
	        };
	        /// GOTO Implementation
	        /**
	         * Computes the implementation location of the symbol
	         * at the requested position.
	         */
	        LanguageServiceShimObject.prototype.getImplementationAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getImplementationAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getImplementationAtPosition(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.getRenameInfo = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getRenameInfo('" + fileName + "', " + position + ")", function () { return _this.languageService.getRenameInfo(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.findRenameLocations = function (fileName, position, findInStrings, findInComments) {
	            var _this = this;
	            return this.forwardJSONCall("findRenameLocations('" + fileName + "', " + position + ", " + findInStrings + ", " + findInComments + ")", function () { return _this.languageService.findRenameLocations(fileName, position, findInStrings, findInComments); });
	        };
	        /// GET BRACE MATCHING
	        LanguageServiceShimObject.prototype.getBraceMatchingAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getBraceMatchingAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getBraceMatchingAtPosition(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.isValidBraceCompletionAtPosition = function (fileName, position, openingBrace) {
	            var _this = this;
	            return this.forwardJSONCall("isValidBraceCompletionAtPosition('" + fileName + "', " + position + ", " + openingBrace + ")", function () { return _this.languageService.isValidBraceCompletionAtPosition(fileName, position, openingBrace); });
	        };
	        LanguageServiceShimObject.prototype.getSpanOfEnclosingComment = function (fileName, position, onlyMultiLine) {
	            var _this = this;
	            return this.forwardJSONCall("getSpanOfEnclosingComment('" + fileName + "', " + position + ")", function () { return _this.languageService.getSpanOfEnclosingComment(fileName, position, onlyMultiLine); });
	        };
	        /// GET SMART INDENT
	        LanguageServiceShimObject.prototype.getIndentationAtPosition = function (fileName, position, options /*Services.EditorOptions*/) {
	            var _this = this;
	            return this.forwardJSONCall("getIndentationAtPosition('" + fileName + "', " + position + ")", function () {
	                var localOptions = JSON.parse(options);
	                return _this.languageService.getIndentationAtPosition(fileName, position, localOptions);
	            });
	        };
	        /// GET REFERENCES
	        LanguageServiceShimObject.prototype.getReferencesAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getReferencesAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getReferencesAtPosition(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.findReferences = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("findReferences('" + fileName + "', " + position + ")", function () { return _this.languageService.findReferences(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.getOccurrencesAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getOccurrencesAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getOccurrencesAtPosition(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.getDocumentHighlights = function (fileName, position, filesToSearch) {
	            var _this = this;
	            return this.forwardJSONCall("getDocumentHighlights('" + fileName + "', " + position + ")", function () {
	                var results = _this.languageService.getDocumentHighlights(fileName, position, JSON.parse(filesToSearch));
	                // workaround for VS document highlighting issue - keep only items from the initial file
	                var normalizedName = ts.normalizeSlashes(fileName).toLowerCase();
	                return ts.filter(results, function (r) { return ts.normalizeSlashes(r.fileName).toLowerCase() === normalizedName; });
	            });
	        };
	        /// COMPLETION LISTS
	        /**
	         * Get a string based representation of the completions
	         * to provide at the given source position and providing a member completion
	         * list if requested.
	         */
	        LanguageServiceShimObject.prototype.getCompletionsAtPosition = function (fileName, position, options) {
	            var _this = this;
	            return this.forwardJSONCall("getCompletionsAtPosition('" + fileName + "', " + position + ", " + options + ")", function () { return _this.languageService.getCompletionsAtPosition(fileName, position, options); });
	        };
	        /** Get a string based representation of a completion list entry details */
	        LanguageServiceShimObject.prototype.getCompletionEntryDetails = function (fileName, position, entryName, options, source) {
	            var _this = this;
	            return this.forwardJSONCall("getCompletionEntryDetails('" + fileName + "', " + position + ", '" + entryName + "')", function () {
	                var localOptions = options === undefined ? undefined : JSON.parse(options);
	                return _this.languageService.getCompletionEntryDetails(fileName, position, entryName, localOptions, source);
	            });
	        };
	        LanguageServiceShimObject.prototype.getFormattingEditsForRange = function (fileName, start, end, options /*Services.FormatCodeOptions*/) {
	            var _this = this;
	            return this.forwardJSONCall("getFormattingEditsForRange('" + fileName + "', " + start + ", " + end + ")", function () {
	                var localOptions = JSON.parse(options);
	                return _this.languageService.getFormattingEditsForRange(fileName, start, end, localOptions);
	            });
	        };
	        LanguageServiceShimObject.prototype.getFormattingEditsForDocument = function (fileName, options /*Services.FormatCodeOptions*/) {
	            var _this = this;
	            return this.forwardJSONCall("getFormattingEditsForDocument('" + fileName + "')", function () {
	                var localOptions = JSON.parse(options);
	                return _this.languageService.getFormattingEditsForDocument(fileName, localOptions);
	            });
	        };
	        LanguageServiceShimObject.prototype.getFormattingEditsAfterKeystroke = function (fileName, position, key, options /*Services.FormatCodeOptions*/) {
	            var _this = this;
	            return this.forwardJSONCall("getFormattingEditsAfterKeystroke('" + fileName + "', " + position + ", '" + key + "')", function () {
	                var localOptions = JSON.parse(options);
	                return _this.languageService.getFormattingEditsAfterKeystroke(fileName, position, key, localOptions);
	            });
	        };
	        LanguageServiceShimObject.prototype.getDocCommentTemplateAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getDocCommentTemplateAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getDocCommentTemplateAtPosition(fileName, position); });
	        };
	        /// NAVIGATE TO
	        /** Return a list of symbols that are interesting to navigate to */
	        LanguageServiceShimObject.prototype.getNavigateToItems = function (searchValue, maxResultCount, fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getNavigateToItems('" + searchValue + "', " + maxResultCount + ", " + fileName + ")", function () { return _this.languageService.getNavigateToItems(searchValue, maxResultCount, fileName); });
	        };
	        LanguageServiceShimObject.prototype.getNavigationBarItems = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getNavigationBarItems('" + fileName + "')", function () { return _this.languageService.getNavigationBarItems(fileName); });
	        };
	        LanguageServiceShimObject.prototype.getNavigationTree = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getNavigationTree('" + fileName + "')", function () { return _this.languageService.getNavigationTree(fileName); });
	        };
	        LanguageServiceShimObject.prototype.getOutliningSpans = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getOutliningSpans('" + fileName + "')", function () { return _this.languageService.getOutliningSpans(fileName); });
	        };
	        LanguageServiceShimObject.prototype.getTodoComments = function (fileName, descriptors) {
	            var _this = this;
	            return this.forwardJSONCall("getTodoComments('" + fileName + "')", function () { return _this.languageService.getTodoComments(fileName, JSON.parse(descriptors)); });
	        };
	        /// Emit
	        LanguageServiceShimObject.prototype.getEmitOutput = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getEmitOutput('" + fileName + "')", function () { return _this.languageService.getEmitOutput(fileName); });
	        };
	        LanguageServiceShimObject.prototype.getEmitOutputObject = function (fileName) {
	            var _this = this;
	            return forwardCall(this.logger, "getEmitOutput('" + fileName + "')", 
	            /*returnJson*/ false, function () { return _this.languageService.getEmitOutput(fileName); }, this.logPerformance);
	        };
	        return LanguageServiceShimObject;
	    }(ShimBase));
	    function convertClassifications(classifications) {
	        return { spans: classifications.spans.join(","), endOfLineState: classifications.endOfLineState };
	    }
	    var ClassifierShimObject = /** @class */ (function (_super) {
	        __extends(ClassifierShimObject, _super);
	        function ClassifierShimObject(factory, logger) {
	            var _this = _super.call(this, factory) || this;
	            _this.logger = logger;
	            _this.logPerformance = false;
	            _this.classifier = ts.createClassifier();
	            return _this;
	        }
	        ClassifierShimObject.prototype.getEncodedLexicalClassifications = function (text, lexState, syntacticClassifierAbsent) {
	            var _this = this;
	            return forwardJSONCall(this.logger, "getEncodedLexicalClassifications", function () { return convertClassifications(_this.classifier.getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent)); }, this.logPerformance);
	        };
	        /// COLORIZATION
	        ClassifierShimObject.prototype.getClassificationsForLine = function (text, lexState, classifyKeywordsInGenerics) {
	            var classification = this.classifier.getClassificationsForLine(text, lexState, classifyKeywordsInGenerics);
	            var result = "";
	            for (var _i = 0, _a = classification.entries; _i < _a.length; _i++) {
	                var item = _a[_i];
	                result += item.length + "\n";
	                result += item.classification + "\n";
	            }
	            result += classification.finalLexState;
	            return result;
	        };
	        return ClassifierShimObject;
	    }(ShimBase));
	    var CoreServicesShimObject = /** @class */ (function (_super) {
	        __extends(CoreServicesShimObject, _super);
	        function CoreServicesShimObject(factory, logger, host) {
	            var _this = _super.call(this, factory) || this;
	            _this.logger = logger;
	            _this.host = host;
	            _this.logPerformance = false;
	            return _this;
	        }
	        CoreServicesShimObject.prototype.forwardJSONCall = function (actionDescription, action) {
	            return forwardJSONCall(this.logger, actionDescription, action, this.logPerformance);
	        };
	        CoreServicesShimObject.prototype.resolveModuleName = function (fileName, moduleName, compilerOptionsJson) {
	            var _this = this;
	            return this.forwardJSONCall("resolveModuleName('" + fileName + "')", function () {
	                var compilerOptions = JSON.parse(compilerOptionsJson);
	                var result = ts.resolveModuleName(moduleName, ts.normalizeSlashes(fileName), compilerOptions, _this.host);
	                var resolvedFileName = result.resolvedModule ? result.resolvedModule.resolvedFileName : undefined;
	                if (result.resolvedModule && result.resolvedModule.extension !== ".ts" /* Ts */ && result.resolvedModule.extension !== ".tsx" /* Tsx */ && result.resolvedModule.extension !== ".d.ts" /* Dts */) {
	                    resolvedFileName = undefined;
	                }
	                return {
	                    resolvedFileName: resolvedFileName,
	                    failedLookupLocations: result.failedLookupLocations
	                };
	            });
	        };
	        CoreServicesShimObject.prototype.resolveTypeReferenceDirective = function (fileName, typeReferenceDirective, compilerOptionsJson) {
	            var _this = this;
	            return this.forwardJSONCall("resolveTypeReferenceDirective(" + fileName + ")", function () {
	                var compilerOptions = JSON.parse(compilerOptionsJson);
	                var result = ts.resolveTypeReferenceDirective(typeReferenceDirective, ts.normalizeSlashes(fileName), compilerOptions, _this.host);
	                return {
	                    resolvedFileName: result.resolvedTypeReferenceDirective ? result.resolvedTypeReferenceDirective.resolvedFileName : undefined,
	                    primary: result.resolvedTypeReferenceDirective ? result.resolvedTypeReferenceDirective.primary : true,
	                    failedLookupLocations: result.failedLookupLocations
	                };
	            });
	        };
	        CoreServicesShimObject.prototype.getPreProcessedFileInfo = function (fileName, sourceTextSnapshot) {
	            var _this = this;
	            return this.forwardJSONCall("getPreProcessedFileInfo('" + fileName + "')", function () {
	                // for now treat files as JavaScript
	                var result = ts.preProcessFile(ts.getSnapshotText(sourceTextSnapshot), /* readImportFiles */ true, /* detectJavaScriptImports */ true);
	                return {
	                    referencedFiles: _this.convertFileReferences(result.referencedFiles),
	                    importedFiles: _this.convertFileReferences(result.importedFiles),
	                    ambientExternalModules: result.ambientExternalModules,
	                    isLibFile: result.isLibFile,
	                    typeReferenceDirectives: _this.convertFileReferences(result.typeReferenceDirectives)
	                };
	            });
	        };
	        CoreServicesShimObject.prototype.getAutomaticTypeDirectiveNames = function (compilerOptionsJson) {
	            var _this = this;
	            return this.forwardJSONCall("getAutomaticTypeDirectiveNames('" + compilerOptionsJson + "')", function () {
	                var compilerOptions = JSON.parse(compilerOptionsJson);
	                return ts.getAutomaticTypeDirectiveNames(compilerOptions, _this.host);
	            });
	        };
	        CoreServicesShimObject.prototype.convertFileReferences = function (refs) {
	            if (!refs) {
	                return undefined;
	            }
	            var result = [];
	            for (var _i = 0, refs_2 = refs; _i < refs_2.length; _i++) {
	                var ref = refs_2[_i];
	                result.push({
	                    path: ts.normalizeSlashes(ref.fileName),
	                    position: ref.pos,
	                    length: ref.end - ref.pos
	                });
	            }
	            return result;
	        };
	        CoreServicesShimObject.prototype.getTSConfigFileInfo = function (fileName, sourceTextSnapshot) {
	            var _this = this;
	            return this.forwardJSONCall("getTSConfigFileInfo('" + fileName + "')", function () {
	                var result = ts.parseJsonText(fileName, ts.getSnapshotText(sourceTextSnapshot));
	                var normalizedFileName = ts.normalizeSlashes(fileName);
	                var configFile = ts.parseJsonSourceFileConfigFileContent(result, _this.host, ts.getDirectoryPath(normalizedFileName), /*existingOptions*/ {}, normalizedFileName);
	                return {
	                    options: configFile.options,
	                    typeAcquisition: configFile.typeAcquisition,
	                    files: configFile.fileNames,
	                    raw: configFile.raw,
	                    errors: realizeDiagnostics(result.parseDiagnostics.concat(configFile.errors), "\r\n")
	                };
	            });
	        };
	        CoreServicesShimObject.prototype.getDefaultCompilationSettings = function () {
	            return this.forwardJSONCall("getDefaultCompilationSettings()", function () { return ts.getDefaultCompilerOptions(); });
	        };
	        CoreServicesShimObject.prototype.discoverTypings = function (discoverTypingsJson) {
	            var _this = this;
	            var getCanonicalFileName = ts.createGetCanonicalFileName(/*useCaseSensitivefileNames:*/ false);
	            return this.forwardJSONCall("discoverTypings()", function () {
	                var info = JSON.parse(discoverTypingsJson);
	                if (_this.safeList === undefined) {
	                    _this.safeList = ts.JsTyping.loadSafeList(_this.host, ts.toPath(info.safeListPath, info.safeListPath, getCanonicalFileName));
	                }
	                return ts.JsTyping.discoverTypings(_this.host, function (msg) { return _this.logger.log(msg); }, info.fileNames, ts.toPath(info.projectRootPath, info.projectRootPath, getCanonicalFileName), _this.safeList, info.packageNameToTypingLocation, info.typeAcquisition, info.unresolvedImports, info.typesRegistry);
	            });
	        };
	        return CoreServicesShimObject;
	    }(ShimBase));
	    var TypeScriptServicesFactory = /** @class */ (function () {
	        function TypeScriptServicesFactory() {
	            this._shims = [];
	        }
	        /*
	         * Returns script API version.
	         */
	        TypeScriptServicesFactory.prototype.getServicesVersion = function () {
	            return ts.servicesVersion;
	        };
	        TypeScriptServicesFactory.prototype.createLanguageServiceShim = function (host) {
	            try {
	                if (this.documentRegistry === undefined) {
	                    this.documentRegistry = ts.createDocumentRegistry(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames(), host.getCurrentDirectory());
	                }
	                var hostAdapter = new LanguageServiceShimHostAdapter(host);
	                var languageService = ts.createLanguageService(hostAdapter, this.documentRegistry);
	                return new LanguageServiceShimObject(this, host, languageService);
	            }
	            catch (err) {
	                logInternalError(host, err);
	                throw err;
	            }
	        };
	        TypeScriptServicesFactory.prototype.createClassifierShim = function (logger) {
	            try {
	                return new ClassifierShimObject(this, logger);
	            }
	            catch (err) {
	                logInternalError(logger, err);
	                throw err;
	            }
	        };
	        TypeScriptServicesFactory.prototype.createCoreServicesShim = function (host) {
	            try {
	                var adapter = new CoreServicesShimHostAdapter(host);
	                return new CoreServicesShimObject(this, host, adapter);
	            }
	            catch (err) {
	                logInternalError(host, err);
	                throw err;
	            }
	        };
	        TypeScriptServicesFactory.prototype.close = function () {
	            // Forget all the registered shims
	            ts.clear(this._shims);
	            this.documentRegistry = undefined;
	        };
	        TypeScriptServicesFactory.prototype.registerShim = function (shim) {
	            this._shims.push(shim);
	        };
	        TypeScriptServicesFactory.prototype.unregisterShim = function (shim) {
	            for (var i = 0; i < this._shims.length; i++) {
	                if (this._shims[i] === shim) {
	                    delete this._shims[i];
	                    return;
	                }
	            }
	            throw new Error("Invalid operation");
	        };
	        return TypeScriptServicesFactory;
	    }());
	    ts.TypeScriptServicesFactory = TypeScriptServicesFactory;
	    if (typeof module !== "undefined" && module.exports) {
	        module.exports = ts;
	    }
	})(ts || (ts = {}));
	/* tslint:enable:no-in-operator */
	/* tslint:enable:no-null */
	/// TODO: this is used by VS, clean this up on both sides of the interface
	/* @internal */
	var TypeScript;
	(function (TypeScript) {
	    var Services;
	    (function (Services) {
	        Services.TypeScriptServicesFactory = ts.TypeScriptServicesFactory;
	    })(Services = TypeScript.Services || (TypeScript.Services = {}));
	})(TypeScript || (TypeScript = {}));
	// 'toolsVersion' gets consumed by the managed side, so it's not unused.
	// TODO: it should be moved into a namespace though.
	/* @internal */
	var toolsVersion = ts.versionMajorMinor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), "/index.js", (function() { return this; }()), "/"))

/***/ },
/* 151 */
/***/ function(module, exports) {

	"use strict";
	/** Raf for node + browser */
	exports.raf = typeof requestAnimationFrame === 'undefined' ? setTimeout : requestAnimationFrame.bind(window);
	/**
	 * Utility to join classes conditionally
	 */
	function classes() {
	    var classes = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        classes[_i] = arguments[_i];
	    }
	    return classes.filter(function (c) { return !!c; }).join(' ');
	}
	exports.classes = classes;
	/**
	 * Merges various styles into a single style object.
	 * Note: if two objects have the same property the last one wins
	 */
	function extend() {
	    var objects = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        objects[_i] = arguments[_i];
	    }
	    /** The final result we will return */
	    var result = {};
	    for (var _a = 0, objects_1 = objects; _a < objects_1.length; _a++) {
	        var object = objects_1[_a];
	        if (object == null || object === false) {
	            continue;
	        }
	        for (var key in object) {
	            /** Falsy values except a explicit 0 is ignored */
	            var val = object[key];
	            if (!val && val !== 0) {
	                continue;
	            }
	            /** if nested media or pseudo selector */
	            if (key === '$nest' && val) {
	                result[key] = result['$nest'] ? extend(result['$nest'], val) : val;
	            }
	            else if ((key.indexOf('&') !== -1 || key.indexOf('@media') === 0)) {
	                result[key] = result[key] ? extend(result[key], val) : val;
	            }
	            else {
	                result[key] = val;
	            }
	        }
	    }
	    return result;
	}
	exports.extend = extend;
	/**
	 * Utility to help customize styles with media queries. e.g.
	 * ```
	 * style(
	 *  media({maxWidth:500}, {color:'red'})
	 * )
	 * ```
	 */
	exports.media = function (mediaQuery) {
	    var objects = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        objects[_i - 1] = arguments[_i];
	    }
	    var mediaQuerySections = [];
	    if (mediaQuery.type)
	        mediaQuerySections.push(mediaQuery.type);
	    if (mediaQuery.orientation)
	        mediaQuerySections.push(mediaQuery.orientation);
	    if (mediaQuery.minWidth)
	        mediaQuerySections.push("(min-width: " + mediaQuery.minWidth + "px)");
	    if (mediaQuery.maxWidth)
	        mediaQuerySections.push("(max-width: " + mediaQuery.maxWidth + "px)");
	    var stringMediaQuery = "@media " + mediaQuerySections.join(' and ');
	    var object = {
	        $nest: (_a = {},
	            _a[stringMediaQuery] = extend.apply(void 0, objects),
	            _a)
	    };
	    return object;
	    var _a;
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	exports.Indicator = function (_a) {
	    var color = _a.color;
	    return (React.createElement("svg", { height: "10px", width: "10px", viewBox: "0 0 10 10", style: {
	            boxShadow: "0px 0px 28px 0px " + color
	        } },
	        React.createElement("circle", { fill: color, r: 5, cx: 5, cy: 5 })));
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(364);
	var React = __webpack_require__(2);
	var ui_1 = __webpack_require__(1);
	var Robocop = /** @class */ (function (_super) {
	    __extends(Robocop, _super);
	    function Robocop() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Robocop.prototype.render = function () {
	        return (React.createElement("div", { className: "progress" },
	            React.createElement("div", { className: "indeterminate" })));
	    };
	    return Robocop;
	}(ui_1.BaseComponent));
	exports.Robocop = Robocop;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(23);
	var icon_1 = __webpack_require__(31);
	/**
	 * This maps into the iconTypes.svg [x,y]
	 *
	 * (0,0)-------x
	 * |
	 * |
	 * y
	 *
	 */
	var iconLocations = (_a = {},
	    _a[types_1.IconType.Global] = { x: 10, y: 0 },
	    _a[types_1.IconType.Namespace] = { x: 0, y: 6 },
	    _a[types_1.IconType.Variable] = { x: 0, y: 1 },
	    _a[types_1.IconType.Function] = { x: 8, y: 4 },
	    _a[types_1.IconType.FunctionGeneric] = { x: 8, y: 5 },
	    _a[types_1.IconType.Enum] = { x: 0, y: 7 },
	    _a[types_1.IconType.EnumMember] = { x: 0, y: 8 },
	    _a[types_1.IconType.Interface] = { x: 0, y: 4 },
	    _a[types_1.IconType.InterfaceGeneric] = { x: 0, y: 5 },
	    _a[types_1.IconType.InterfaceConstructor] = { x: 12, y: 6 },
	    _a[types_1.IconType.InterfaceProperty] = { x: 12, y: 0 },
	    _a[types_1.IconType.InterfaceMethod] = { x: 12, y: 4 },
	    _a[types_1.IconType.InterfaceMethodGeneric] = { x: 12, y: 5 },
	    _a[types_1.IconType.InterfaceIndexSignature] = { x: 12, y: 7 },
	    _a[types_1.IconType.Class] = { x: 0, y: 2 },
	    _a[types_1.IconType.ClassGeneric] = { x: 0, y: 3 },
	    _a[types_1.IconType.ClassConstructor] = { x: 3, y: 6 },
	    _a[types_1.IconType.ClassProperty] = { x: 3, y: 0 },
	    _a[types_1.IconType.ClassMethod] = { x: 3, y: 4 },
	    _a[types_1.IconType.ClassMethodGeneric] = { x: 3, y: 5 },
	    _a[types_1.IconType.ClassIndexSignature] = { x: 3, y: 7 },
	    _a);
	var _typeIconLocations = iconLocations;
	var ui = __webpack_require__(1);
	var React = __webpack_require__(2);
	var pure = __webpack_require__(61);
	var csx = __webpack_require__(6);
	var styles = __webpack_require__(10);
	var TypeIconStyles;
	(function (TypeIconStyles) {
	    TypeIconStyles.spriteSize = 17; // px
	    /** We want to eat a bit of the icon otherwise we get neighbours at certain scales */
	    TypeIconStyles.iconClipWidth = 1;
	    TypeIconStyles.root = {
	        width: TypeIconStyles.spriteSize - TypeIconStyles.iconClipWidth + "px",
	        height: TypeIconStyles.spriteSize + "px",
	        display: 'inline-block',
	    };
	})(TypeIconStyles || (TypeIconStyles = {}));
	/**
	 * Draws the icon for a type
	 */
	var TypeIcon = /** @class */ (function (_super) {
	    __extends(TypeIcon, _super);
	    function TypeIcon() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TypeIcon.prototype.shouldComponentUpdate = function () {
	        return pure.shouldComponentUpdate.apply(this, arguments);
	    };
	    TypeIcon.prototype.render = function () {
	        var imageLocation = iconLocations[this.props.iconType];
	        var left = imageLocation.x * -TypeIconStyles.spriteSize - TypeIconStyles.iconClipWidth;
	        var top = imageLocation.y * -TypeIconStyles.spriteSize;
	        var backgroundImage = 'url(assets/typeIcons.svg)';
	        var backgroundPosition = left + "px " + top + "px";
	        var style = csx.extend(TypeIconStyles.root, { backgroundImage: backgroundImage, backgroundPosition: backgroundPosition });
	        return React.createElement("div", { style: style });
	    };
	    return TypeIcon;
	}(ui.BaseComponent));
	exports.TypeIcon = TypeIcon;
	/**
	 * Draws an icon for `private` visibility indication
	 */
	var VisibilityIndicator = /** @class */ (function (_super) {
	    __extends(VisibilityIndicator, _super);
	    function VisibilityIndicator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VisibilityIndicator.prototype.shouldComponentUpdate = function () {
	        return pure.shouldComponentUpdate.apply(this, arguments);
	    };
	    VisibilityIndicator.prototype.render = function () {
	        // Maybe add others if needed. I doubt it though.
	        var classIconColorTheme = "#4DA6FF";
	        if (this.props.visibility === types_1.UMLClassMemberVisibility.Public)
	            return React.createElement("span", null);
	        if (this.props.visibility === types_1.UMLClassMemberVisibility.Private)
	            return React.createElement(icon_1.Icon, { name: "lock", style: { color: classIconColorTheme } });
	        else
	            return React.createElement(icon_1.Icon, { name: "shield", style: { color: classIconColorTheme } });
	    };
	    return VisibilityIndicator;
	}(ui.BaseComponent));
	/**
	 * Draws an icon for `override` visibility indication
	 */
	var OverrideIndicator = /** @class */ (function (_super) {
	    __extends(OverrideIndicator, _super);
	    function OverrideIndicator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    OverrideIndicator.prototype.shouldComponentUpdate = function () {
	        return pure.shouldComponentUpdate.apply(this, arguments);
	    };
	    OverrideIndicator.prototype.render = function () {
	        // Maybe add others if needed. I doubt it though.
	        var classIconColorTheme = "#4DA6FF";
	        return React.createElement(icon_1.Icon, { name: "arrow-circle-up", style: { color: classIconColorTheme } });
	    };
	    return OverrideIndicator;
	}(ui.BaseComponent));
	/**
	 * Draws an icon for `static` indication
	 */
	var LifetimeIndicator = /** @class */ (function (_super) {
	    __extends(LifetimeIndicator, _super);
	    function LifetimeIndicator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LifetimeIndicator.prototype.render = function () {
	        // Maybe add others if needed. I doubt it though.
	        var classIconColorTheme = "#4DA6FF";
	        if (this.props.lifetime === types_1.UMLClassMemberLifetime.Instance)
	            return React.createElement("span", null);
	        else
	            return React.createElement(icon_1.Icon, { name: "bullhorn", style: { color: classIconColorTheme } });
	    };
	    return LifetimeIndicator;
	}(React.PureComponent));
	/**
	 * Draws the icon followed by name
	 */
	var DocumentedTypeHeaderStyles;
	(function (DocumentedTypeHeaderStyles) {
	    DocumentedTypeHeaderStyles.root = csx.extend({
	        fontWeight: 'bold',
	        fontSize: '.6rem',
	        color: styles.textColor,
	        // Center
	        display: 'flex',
	        alignItems: 'center',
	        whiteSpace: 'pre'
	    });
	})(DocumentedTypeHeaderStyles || (DocumentedTypeHeaderStyles = {}));
	var DocumentedTypeHeader = /** @class */ (function (_super) {
	    __extends(DocumentedTypeHeader, _super);
	    function DocumentedTypeHeader() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DocumentedTypeHeader.prototype.render = function () {
	        var hasLifetime = (this.props.lifetime != null) && this.props.lifetime !== types_1.UMLClassMemberLifetime.Instance;
	        var hasVisibility = (this.props.visibility != null) && this.props.visibility !== types_1.UMLClassMemberVisibility.Public;
	        return React.createElement("div", { style: DocumentedTypeHeaderStyles.root },
	            React.createElement(TypeIcon, { iconType: this.props.icon }),
	            hasLifetime && React.createElement(LifetimeIndicator, { lifetime: this.props.lifetime }),
	            hasLifetime && "\u00a0",
	            hasVisibility && React.createElement(VisibilityIndicator, { visibility: this.props.visibility }),
	            hasVisibility && "\u00a0",
	            " " + this.props.name,
	            this.props.override && "\u00a0",
	            this.props.override && React.createElement(OverrideIndicator, null));
	    };
	    return DocumentedTypeHeader;
	}(React.PureComponent));
	exports.DocumentedTypeHeader = DocumentedTypeHeader;
	exports.SectionHeader = function (props) {
	    return React.createElement("div", { style: { fontSize: '1rem', fontWeight: 'bold' } }, props.text);
	};
	/**
	 * Draws the legend
	 */
	var TypeIconLegendStyles;
	(function (TypeIconLegendStyles) {
	    TypeIconLegendStyles.root = csx.extend({
	        fontWeight: 'bold',
	        fontSize: '.6rem',
	        color: styles.textColor,
	    });
	    TypeIconLegendStyles.legendColumnContainer = csx.horizontal;
	    TypeIconLegendStyles.legendColumn = csx.extend(csx.vertical, {
	        padding: '10px'
	    });
	})(TypeIconLegendStyles || (TypeIconLegendStyles = {}));
	var TypeIconLegend = /** @class */ (function (_super) {
	    __extends(TypeIconLegend, _super);
	    function TypeIconLegend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TypeIconLegend.prototype.render = function () {
	        return (React.createElement("div", { style: TypeIconLegendStyles.root },
	            React.createElement("div", { style: { paddingLeft: '10px' } },
	                React.createElement(exports.SectionHeader, { text: "Legend" })),
	            React.createElement("div", { style: TypeIconLegendStyles.legendColumnContainer },
	                React.createElement("div", { style: TypeIconLegendStyles.legendColumn },
	                    React.createElement(DocumentedTypeHeader, { name: "Global", icon: types_1.IconType.Global }),
	                    React.createElement(DocumentedTypeHeader, { name: "Namespace", icon: types_1.IconType.Namespace }),
	                    React.createElement(DocumentedTypeHeader, { name: "Variable", icon: types_1.IconType.Variable }),
	                    React.createElement(DocumentedTypeHeader, { name: "Function", icon: types_1.IconType.Function }),
	                    React.createElement(DocumentedTypeHeader, { name: "Function Generic", icon: types_1.IconType.FunctionGeneric }),
	                    React.createElement("div", { style: { height: TypeIconStyles.spriteSize + 'px' } }),
	                    React.createElement(DocumentedTypeHeader, { name: "Enum", icon: types_1.IconType.Enum }),
	                    React.createElement(DocumentedTypeHeader, { name: "Enum Member", icon: types_1.IconType.EnumMember })),
	                React.createElement("div", { style: TypeIconLegendStyles.legendColumn },
	                    React.createElement(DocumentedTypeHeader, { name: "Interface", icon: types_1.IconType.Interface }),
	                    React.createElement(DocumentedTypeHeader, { name: "Interface Generic", icon: types_1.IconType.InterfaceGeneric }),
	                    React.createElement(DocumentedTypeHeader, { name: "Interface Constructor", icon: types_1.IconType.InterfaceConstructor }),
	                    React.createElement(DocumentedTypeHeader, { name: "Interface Property", icon: types_1.IconType.InterfaceProperty }),
	                    React.createElement(DocumentedTypeHeader, { name: "Interface Method", icon: types_1.IconType.InterfaceMethod }),
	                    React.createElement(DocumentedTypeHeader, { name: "Interface Method Generic", icon: types_1.IconType.InterfaceMethodGeneric }),
	                    React.createElement(DocumentedTypeHeader, { name: "Interface Index Signature", icon: types_1.IconType.InterfaceIndexSignature })),
	                React.createElement("div", { style: TypeIconLegendStyles.legendColumn },
	                    React.createElement(DocumentedTypeHeader, { name: "Class", icon: types_1.IconType.Class }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Generic", icon: types_1.IconType.ClassGeneric }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Constructor", icon: types_1.IconType.ClassConstructor }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Property", icon: types_1.IconType.ClassProperty }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Method", icon: types_1.IconType.ClassMethod }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Method Generic", icon: types_1.IconType.ClassMethodGeneric }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Index Signature", icon: types_1.IconType.ClassIndexSignature })))));
	    };
	    return TypeIconLegend;
	}(React.PureComponent));
	exports.TypeIconLegend = TypeIconLegend;
	var TypeIconClassDiagramLegend = /** @class */ (function (_super) {
	    __extends(TypeIconClassDiagramLegend, _super);
	    function TypeIconClassDiagramLegend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TypeIconClassDiagramLegend.prototype.render = function () {
	        return (React.createElement("div", { style: TypeIconLegendStyles.root },
	            React.createElement("div", { style: { paddingLeft: '10px' } },
	                React.createElement(exports.SectionHeader, { text: "Class Diagram Legend" })),
	            React.createElement("div", { style: TypeIconLegendStyles.legendColumnContainer },
	                React.createElement("div", { style: TypeIconLegendStyles.legendColumn },
	                    React.createElement(DocumentedTypeHeader, { name: "Class", icon: types_1.IconType.Class }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Generic", icon: types_1.IconType.ClassGeneric }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Constructor", icon: types_1.IconType.ClassConstructor }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Property", icon: types_1.IconType.ClassProperty }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Method", icon: types_1.IconType.ClassMethod }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Method Generic", icon: types_1.IconType.ClassMethodGeneric }),
	                    React.createElement(DocumentedTypeHeader, { name: "Class Index Signature", icon: types_1.IconType.ClassIndexSignature })),
	                React.createElement("div", { style: TypeIconLegendStyles.legendColumn },
	                    React.createElement("div", null,
	                        React.createElement(VisibilityIndicator, { visibility: types_1.UMLClassMemberVisibility.Private }),
	                        " \u00A0 Private"),
	                    React.createElement("div", { style: { marginTop: '5px' } },
	                        React.createElement(VisibilityIndicator, { visibility: types_1.UMLClassMemberVisibility.Protected }),
	                        " \u00A0 Protected"),
	                    React.createElement("div", { style: { marginTop: '5px' } },
	                        React.createElement(LifetimeIndicator, { lifetime: types_1.UMLClassMemberLifetime.Static }),
	                        " \u00A0 Static"),
	                    React.createElement("div", { style: { marginTop: '5px' } },
	                        React.createElement(OverrideIndicator, null),
	                        " \u00A0 Override")))));
	    };
	    return TypeIconClassDiagramLegend;
	}(React.PureComponent));
	exports.TypeIconClassDiagramLegend = TypeIconClassDiagramLegend;
	var _a;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var ui = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var state = __webpack_require__(11);
	var commands = __webpack_require__(7);
	var react_redux_1 = __webpack_require__(29);
	var icon_1 = __webpack_require__(31);
	var tabRegistry = __webpack_require__(163);
	var appTabsContainer_1 = __webpack_require__(26);
	var typestyle = __webpack_require__(13);
	var csx_1 = __webpack_require__(6);
	var inputBlackStyleBase = styles.Input.inputBlackStyleBase;
	var inputBlackClassName = typestyle.style(inputBlackStyleBase);
	exports.inputCodeStyle = {
	    fontFamily: 'monospace',
	};
	exports.searchOptionsLabelStyle = {
	    color: 'grey',
	    fontSize: '1.5rem',
	    fontWeight: 'bold',
	    cursor: 'pointer',
	    paddingLeft: '5px',
	    paddingRight: '5px',
	};
	var labelStyle = {
	    color: 'grey',
	    padding: '4px'
	};
	var FindAndReplace = /** @class */ (function (_super) {
	    __extends(FindAndReplace, _super);
	    function FindAndReplace() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.findInput = function () { return ReactDOM.findDOMNode(_this.refs.find); };
	        _this.replaceInput = function () { return ReactDOM.findDOMNode(_this.refs.replace); };
	        _this.regexInput = function () { return ReactDOM.findDOMNode(_this.refs.regex.refs.input); };
	        _this.caseInsensitiveInput = function () { return ReactDOM.findDOMNode(_this.refs.caseInsensitive.refs.input); };
	        _this.fullWordInput = function () { return ReactDOM.findDOMNode(_this.refs.fullWord.refs.input); };
	        _this.replaceWith = function () { return _this.replaceInput().value; };
	        /** Tab key is only called on key down :) */
	        _this.findKeyDownHandler = function (e) {
	            var _a = ui.getKeyStates(e), tab = _a.tab, shift = _a.shift, enter = _a.enter, mod = _a.mod;
	            if (shift && tab) {
	                _this.fullWordInput() && _this.fullWordInput().focus();
	                e.preventDefault();
	                return;
	            }
	            if (!state.getState().findOptions.query) {
	                return;
	            }
	            if (mod && enter && !shift) {
	                commands.replaceAll.emit({ newText: _this.replaceWith() });
	                return;
	            }
	            if (shift && enter) {
	                commands.findPrevious.emit({});
	                return;
	            }
	            if (enter) {
	                commands.findNext.emit({});
	                return;
	            }
	        };
	        _this.replaceKeyDownHandler = function (e) {
	            var _a = ui.getKeyStates(e), tab = _a.tab, shift = _a.shift, enter = _a.enter, mod = _a.mod;
	            if (!state.getState().findOptions.query) {
	                return;
	            }
	            if (mod && enter) {
	                commands.replaceAll.emit({ newText: _this.replaceWith() });
	                return;
	            }
	            // The cursor.replace function in code mirror focuses the editor *with a delay* :-/
	            var focusBackOnReplaceInput = function () { return setTimeout(function () { return _this.replaceInput().focus(); }, 50); };
	            if (shift && enter) {
	                commands.replacePrevious.emit({ newText: _this.replaceWith() });
	                focusBackOnReplaceInput();
	                return;
	            }
	            if (enter) {
	                commands.replaceNext.emit({ newText: _this.replaceWith() });
	                focusBackOnReplaceInput();
	                return;
	            }
	        };
	        _this.fullWordKeyDownHandler = function (e) {
	            var _a = ui.getKeyStates(e), tab = _a.tab, shift = _a.shift, enter = _a.enter;
	            if (tab && !shift) {
	                _this.findInput().focus();
	                e.preventDefault();
	                return;
	            }
	        };
	        _this.findChanged = utils.debounce(function () {
	            var val = _this.findInput().value;
	            state.setFindOptionsQuery(val);
	        }, 200);
	        _this.handleRegexChange = function (e) {
	            var val = e.target.checked;
	            state.setFindOptionsIsRegex(val);
	        };
	        _this.handleCaseSensitiveChange = function (e) {
	            var val = e.target.checked;
	            state.setFindOptionsIsCaseSensitive(val);
	        };
	        _this.handleFullWordChange = function (e) {
	            var val = e.target.checked;
	            state.setFindOptionsIsFullWord(val);
	        };
	        return _this;
	    }
	    FindAndReplace.prototype.componentDidMount = function () {
	        var _this = this;
	        this.disposible.add(commands.findAndReplace.on(function () {
	            /** Find input might not be there if current tab doesn't support search */
	            if (!_this.findInput()) {
	                return;
	            }
	            // if not shown and the current tab is an editor we should load the selected text from the editor (if any)
	            if (!state.getState().findOptions.isShown) {
	                var codeEditor = appTabsContainer_1.tabState.getFocusedCodeEditorIfAny();
	                if (codeEditor) {
	                    var selectedString = codeEditor.getSelectionSearchString();
	                    if (selectedString) {
	                        state.setFindOptionsQuery(selectedString);
	                        _this.findInput().value = selectedString;
	                    }
	                }
	            }
	            state.setFindOptionsIsShown(true);
	            _this.findInput().select();
	            _this.replaceInput() && _this.replaceInput().select();
	            _this.findInput().focus();
	        }));
	        this.disposible.add(commands.esc.on(function () {
	            state.setFindOptionsIsShown(false);
	            _this.findInput() && _this.findInput().focus();
	        }));
	        this.disposible.add(appTabsContainer_1.tabStateChanged.on(function () {
	            _this.forceUpdate();
	        }));
	    };
	    // searchLocation = (): HTMLInputElement=> ReactDOM.findDOMNode(this.refs.find);
	    FindAndReplace.prototype.render = function () {
	        var shownStyle = this.props.findQuery.isShown ? {} : { display: 'none' };
	        /** Detect advanced find needed or not */
	        var tab = appTabsContainer_1.tabState.getSelectedTab();
	        var searchSupport = tab && tabRegistry.getTabConfigByUrl(tab.url).searchSupport;
	        var advancedFind = searchSupport && searchSupport == tabRegistry.TabSearchSupport.Advanced;
	        /** For Find and Replace Multi ... completely bail out */
	        if (!tab || !searchSupport) {
	            return React.createElement("noscript", null);
	        }
	        if (!advancedFind) {
	            return (React.createElement("div", { style: csx.extend(csx.horizontal, shownStyle) },
	                React.createElement("div", { style: csx_1.extend(csx.flex, csx.vertical) },
	                    React.createElement("div", { style: csx_1.extend(csx.horizontal, csx.center, styles.padded1) },
	                        React.createElement("input", { tabIndex: 1, ref: "find", placeholder: "Find", className: inputBlackClassName, style: csx_1.extend(exports.inputCodeStyle, csx.flex), onKeyDown: this.findKeyDownHandler, onChange: this.findChanged, defaultValue: this.props.findQuery.query })))));
	        }
	        return (React.createElement("div", { style: csx_1.extend(csx.vertical, shownStyle) },
	            React.createElement("div", { style: csx_1.extend(csx.horizontal, shownStyle) },
	                React.createElement("div", { style: csx_1.extend(csx.flex, csx.vertical) },
	                    React.createElement("div", { style: csx_1.extend(csx.horizontal, csx.center, styles.padded1) },
	                        React.createElement("input", { tabIndex: 1, ref: "find", placeholder: "Find", className: inputBlackClassName, style: csx.extend(exports.inputCodeStyle, csx.flex), onKeyDown: this.findKeyDownHandler, onChange: this.findChanged, defaultValue: this.props.findQuery.query })),
	                    React.createElement("div", { style: csx_1.extend(csx.horizontal, csx.center, styles.padded1) },
	                        React.createElement("input", { tabIndex: 2, ref: "replace", placeholder: "Replace", className: inputBlackClassName, style: csx.extend(exports.inputCodeStyle, csx.flex), onKeyDown: this.replaceKeyDownHandler }))),
	                React.createElement("div", { style: csx.centerCenter },
	                    React.createElement("div", { style: csx.extend(csx.horizontal, csx.aroundJustified, styles.padded1) },
	                        React.createElement("label", { style: csx_1.extend(csx.horizontal, csx.center) },
	                            React.createElement(ui.Toggle, { tabIndex: 3, ref: "regex", onChange: this.handleRegexChange }),
	                            React.createElement("span", { style: exports.searchOptionsLabelStyle }, ".*")),
	                        React.createElement("label", { style: csx_1.extend(csx.horizontal, csx.center) },
	                            React.createElement(ui.Toggle, { tabIndex: 4, ref: "caseInsensitive", onChange: this.handleCaseSensitiveChange }),
	                            React.createElement("span", { style: exports.searchOptionsLabelStyle }, "Aa")),
	                        React.createElement("label", { style: csx_1.extend(csx.horizontal, csx.center) },
	                            React.createElement(ui.Toggle, { tabIndex: 5, ref: "fullWord", onKeyDown: this.fullWordKeyDownHandler, onChange: this.handleFullWordChange }),
	                            React.createElement("span", { style: exports.searchOptionsLabelStyle },
	                                React.createElement(icon_1.Icon, { name: "text-width" })))))),
	            React.createElement("div", { style: styles.Tip.root },
	                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Esc"),
	                " to exit",
	                ' ',
	                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Enter"),
	                " to find/replace next",
	                ' ',
	                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Shift + Enter"),
	                " to find/replace previous",
	                ' ',
	                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle },
	                    commands.modName,
	                    " + Enter"),
	                " to replace all")));
	    };
	    FindAndReplace.prototype.handleSearchKeys = function (e) {
	    };
	    FindAndReplace.prototype.componentWillUpdate = function (nextProps, nextState) {
	        if (nextProps.findQuery.isShown !== this.props.findQuery.isShown) {
	            appTabsContainer_1.tabState.debouncedResize();
	        }
	    };
	    FindAndReplace = __decorate([
	        react_redux_1.connect(function (state) {
	            return {
	                findQuery: state.findOptions,
	            };
	        })
	    ], FindAndReplace);
	    return FindAndReplace;
	}(ui_1.BaseComponent));
	exports.FindAndReplace = FindAndReplace;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var state = __webpack_require__(11);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var appTabsContainer_1 = __webpack_require__(26);
	var globalErrorCacheClient_1 = __webpack_require__(35);
	commands.gotoNext.on(function () {
	    gotoNext();
	});
	commands.gotoPrevious.on(function () {
	    gotoPrevious();
	});
	var errorsInOpenFiles = { members: [] };
	var buildOutput = { members: [] };
	var referencesOutput = { members: [] };
	var reloadErrorsInOpenFiles = utils.debounce(function () {
	    var errorsFlattened = appTabsContainer_1.tabState.errorsByFilePathFiltered().errorsFlattened;
	    errorsInOpenFiles.members = errorsFlattened.map(function (x) {
	        return { filePath: x.filePath, line: x.from.line, col: x.from.ch };
	    });
	}, 500);
	globalErrorCacheClient_1.errorsCache.errorsDelta.on(reloadErrorsInOpenFiles);
	state.subscribeSub(function (state) { return state.errorsDisplayMode; }, reloadErrorsInOpenFiles);
	state.subscribeSub(function (state) { return state.errorsFilter; }, reloadErrorsInOpenFiles);
	appTabsContainer_1.tabStateChanged.on(reloadErrorsInOpenFiles);
	/**
	 * Use this to keep the *lastPosition* in error list in sync
	 * A bit fugly because there might be multiple errors in the same location but works good enough
	 */
	function gotoError(error) {
	    commands.doOpenOrFocusFile.emit({ filePath: error.filePath, position: error.from });
	    errorsInOpenFiles.lastIndex = indexOf(errorsInOpenFiles.members, function (member) {
	        return member.filePath == error.filePath && member.line == error.from.line && member.col == error.from.ch;
	    });
	}
	exports.gotoError = gotoError;
	/** This *must* always be set */
	var activeList = errorsInOpenFiles;
	function gotoItemInActiveList(index) {
	    var member = activeList.members[index];
	    activeList.lastIndex = index;
	    commands.doOpenOrFocusFile.emit({ filePath: member.filePath, position: { line: member.line, ch: member.col } });
	}
	/**
	 * Uses `activeList` to go to the next error or loop back
	 * Storing `lastIndex` with the list allows us to be lazy elsewhere and actively find the element here
	 */
	function findCurrentIndexInList() {
	    // Early exit if no members
	    if (!activeList.members.length) {
	        ui.notifyInfoNormalDisappear('No members in active go-to list');
	        return -1;
	    }
	    // If we don't have a lastPosition then first is the last position
	    if (!activeList.lastIndex || activeList.lastIndex == -1)
	        return 0;
	    // If we have gone too far, then goto last
	    if (activeList.lastIndex >= activeList.members.length)
	        return activeList.members.length - 1;
	    // Index is good. Return that :)
	    return activeList.lastIndex;
	}
	/** Uses `activeList` to go to the next position or loop back */
	function gotoNext() {
	    var currentIndex = findCurrentIndexInList();
	    if (currentIndex == -1)
	        return;
	    var nextIndex = currentIndex + 1;
	    // If next is == length then loop to zero
	    if (nextIndex == activeList.members.length) {
	        nextIndex = 0;
	    }
	    gotoItemInActiveList(nextIndex);
	}
	exports.gotoNext = gotoNext;
	/** Uses `activeList` to go to the previous position or loop back */
	function gotoPrevious() {
	    var currentIndex = findCurrentIndexInList();
	    if (currentIndex == -1)
	        return;
	    var previousIndex = currentIndex - 1;
	    // If next is == -1 then loop to length
	    if (previousIndex == -1) {
	        previousIndex = activeList.members.length - 1;
	    }
	    gotoItemInActiveList(previousIndex);
	}
	exports.gotoPrevious = gotoPrevious;
	/**
	 * Utility Return index of element in an array based on a filter
	 */
	function indexOf(items, filter) {
	    for (var i = 0; i < items.length; i++) {
	        if (filter(items[i])) {
	            return i;
	        }
	    }
	    return -1;
	}


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This is a copy paste of `htmltojsx/src/htmltojsx.js`
	 * That lib tries to support both node / cli / browser
	 * So I just removed the `node` stuff from this file instead of taking too many depdencies
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This is a very simple HTML to JSX converter. It turns out that browsers
	 * have good HTML parsers (who would have thought?) so we utilise this by
	 * inserting the HTML into a temporary DOM node, and then do a breadth-first
	 * traversal of the resulting DOM tree.
	 */
	// https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType
	var NODE_TYPE = {
	    ELEMENT: 1,
	    TEXT: 3,
	    COMMENT: 8
	};
	var ATTRIBUTE_MAPPING = {
	    'for': 'htmlFor',
	    'class': 'className'
	};
	var ELEMENT_ATTRIBUTE_MAPPING = {
	    'input': {
	        'checked': 'defaultChecked',
	        'value': 'defaultValue'
	    }
	};
	var HTMLDOMPropertyConfig = __webpack_require__(109);
	// Populate property map with ReactJS's attribute and property mappings
	// TODO handle/use .Properties value eg: MUST_USE_PROPERTY is not HTML attr
	for (var propname in HTMLDOMPropertyConfig.Properties) {
	    if (!HTMLDOMPropertyConfig.Properties.hasOwnProperty(propname)) {
	        continue;
	    }
	    var mapFrom = HTMLDOMPropertyConfig.DOMAttributeNames[propname] || propname.toLowerCase();
	    if (!ATTRIBUTE_MAPPING[mapFrom])
	        ATTRIBUTE_MAPPING[mapFrom] = propname;
	}
	/**
	 * Repeats a string a certain number of times.
	 * Also: the future is bright and consists of native string repetition:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
	 *
	 * @param {string} string  String to repeat
	 * @param {number} times   Number of times to repeat string. Integer.
	 * @see http://jsperf.com/string-repeater/2
	 */
	function repeatString(string, times) {
	    if (times === 1) {
	        return string;
	    }
	    if (times < 0) {
	        throw new Error();
	    }
	    var repeated = '';
	    while (times) {
	        if (times & 1) {
	            repeated += string;
	        }
	        if (times >>= 1) {
	            string += string;
	        }
	    }
	    return repeated;
	}
	/**
	 * Determine if the string ends with the specified substring.
	 *
	 * @param {string} haystack String to search in
	 * @param {string} needle   String to search for
	 * @return {boolean}
	 */
	function endsWith(haystack, needle) {
	    return haystack.slice(-needle.length) === needle;
	}
	/**
	 * Trim the specified substring off the string. If the string does not end
	 * with the specified substring, this is a no-op.
	 *
	 * @param {string} haystack String to search in
	 * @param {string} needle   String to search for
	 * @return {string}
	 */
	function trimEnd(haystack, needle) {
	    return endsWith(haystack, needle)
	        ? haystack.slice(0, -needle.length)
	        : haystack;
	}
	/**
	 * Convert a hyphenated string to camelCase.
	 */
	function hyphenToCamelCase(string) {
	    return string.replace(/-(.)/g, function (match, chr) {
	        return chr.toUpperCase();
	    });
	}
	/**
	 * Determines if the specified string consists entirely of whitespace.
	 */
	function isEmpty(string) {
	    return !/[^\s]/.test(string);
	}
	/**
	 * Determines if the CSS value can be converted from a
	 * 'px' suffixed string to a numeric value
	 *
	 * @param {string} value CSS property value
	 * @return {boolean}
	 */
	function isConvertiblePixelValue(value) {
	    return /^\d+px$/.test(value);
	}
	/**
	 * Determines if the specified string consists entirely of numeric characters.
	 */
	function isNumeric(input) {
	    return input !== undefined
	        && input !== null
	        && (typeof input === 'number' || parseInt(input, 10) == input);
	}
	var createElement = function (tag) {
	    return document.createElement(tag);
	};
	var tempEl = createElement('div');
	/**
	 * Escapes special characters by converting them to their escaped equivalent
	 * (eg. "<" to "&lt;"). Only escapes characters that absolutely must be escaped.
	 *
	 * @param {string} value
	 * @return {string}
	 */
	function escapeSpecialChars(value) {
	    // Uses this One Weird Trick to escape text - Raw text inserted as textContent
	    // will have its escaped version in innerHTML.
	    tempEl.textContent = value;
	    return tempEl.innerHTML;
	}
	var HTMLtoJSX = /** @class */ (function () {
	    function HTMLtoJSX(config) {
	        var _this = this;
	        /**
	         * Reset the internal state of the converter
	         */
	        this.reset = function () {
	            _this.output = '';
	            _this.level = 0;
	            _this._inPreTag = false;
	        };
	        /**
	         * Main entry point to the converter. Given the specified HTML, returns a
	         * JSX object representing it.
	         * @param {string} html HTML to convert
	         * @return {string} JSX
	         */
	        this.convert = function (html) {
	            _this.reset();
	            var containerEl = createElement('div');
	            containerEl.innerHTML = '\n' + _this._cleanInput(html) + '\n';
	            if (_this.config.createClass) {
	                if (_this.config.outputClassName) {
	                    _this.output = 'var ' + _this.config.outputClassName + ' = React.createClass({\n';
	                }
	                else {
	                    _this.output = 'React.createClass({\n';
	                }
	                _this.output += _this.config.indent + 'render: function() {' + "\n";
	                _this.output += _this.config.indent + _this.config.indent + 'return (\n';
	            }
	            if (_this._onlyOneTopLevel(containerEl)) {
	                // Only one top-level element, the component can return it directly
	                // No need to actually visit the container element
	                _this._traverse(containerEl);
	            }
	            else {
	                // More than one top-level element, need to wrap the whole thing in a
	                // container.
	                _this.output += _this.config.indent + _this.config.indent + _this.config.indent;
	                _this.level++;
	                _this._visit(containerEl);
	            }
	            _this.output = _this.output.trim() + '\n';
	            if (_this.config.createClass) {
	                _this.output += _this.config.indent + _this.config.indent + ');\n';
	                _this.output += _this.config.indent + '}\n';
	                _this.output += '});';
	            }
	            return _this.output;
	        };
	        /**
	         * Cleans up the specified HTML so it's in a format acceptable for
	         * converting.
	         *
	         * @param {string} html HTML to clean
	         * @return {string} Cleaned HTML
	         */
	        this._cleanInput = function (html) {
	            // Remove unnecessary whitespace
	            html = html.trim();
	            // Ugly method to strip script tags. They can wreak havoc on the DOM nodes
	            // so let's not even put them in the DOM.
	            html = html.replace(/<script([\s\S]*?)<\/script>/g, '');
	            return html;
	        };
	        /**
	         * Determines if there's only one top-level node in the DOM tree. That is,
	         * all the HTML is wrapped by a single HTML tag.
	         *
	         * @param {DOMElement} containerEl Container element
	         * @return {boolean}
	         */
	        this._onlyOneTopLevel = function (containerEl) {
	            // Only a single child element
	            if (containerEl.childNodes.length === 1
	                && containerEl.childNodes[0].nodeType === NODE_TYPE.ELEMENT) {
	                return true;
	            }
	            // Only one element, and all other children are whitespace
	            var foundElement = false;
	            for (var i = 0, count = containerEl.childNodes.length; i < count; i++) {
	                var child = containerEl.childNodes[i];
	                if (child.nodeType === NODE_TYPE.ELEMENT) {
	                    if (foundElement) {
	                        // Encountered an element after already encountering another one
	                        // Therefore, more than one element at root level
	                        return false;
	                    }
	                    else {
	                        foundElement = true;
	                    }
	                }
	                else if (child.nodeType === NODE_TYPE.TEXT && !isEmpty(child.textContent)) {
	                    // Contains text content
	                    return false;
	                }
	            }
	            return true;
	        };
	        /**
	         * Gets a newline followed by the correct indentation for the current
	         * nesting level
	         *
	         * @return {string}
	         */
	        this._getIndentedNewline = function () {
	            return '\n' + repeatString(_this.config.indent, _this.level + 2);
	        };
	        /**
	         * Handles processing the specified node
	         *
	         * @param {Node} node
	         */
	        this._visit = function (node) {
	            _this._beginVisit(node);
	            _this._traverse(node);
	            _this._endVisit(node);
	        };
	        /**
	         * Traverses all the children of the specified node
	         *
	         * @param {Node} node
	         */
	        this._traverse = function (node) {
	            _this.level++;
	            for (var i = 0, count = node.childNodes.length; i < count; i++) {
	                _this._visit(node.childNodes[i]);
	            }
	            _this.level--;
	        };
	        /**
	         * Handle pre-visit behaviour for the specified node.
	         *
	         * @param {Node} node
	         */
	        this._beginVisit = function (node) {
	            switch (node.nodeType) {
	                case NODE_TYPE.ELEMENT:
	                    _this._beginVisitElement(node);
	                    break;
	                case NODE_TYPE.TEXT:
	                    _this._visitText(node);
	                    break;
	                case NODE_TYPE.COMMENT:
	                    _this._visitComment(node);
	                    break;
	                default:
	                    console.warn('Unrecognised node type: ' + node.nodeType);
	            }
	        };
	        /**
	         * Handles post-visit behaviour for the specified node.
	         *
	         * @param {Node} node
	         */
	        this._endVisit = function (node) {
	            switch (node.nodeType) {
	                case NODE_TYPE.ELEMENT:
	                    _this._endVisitElement(node);
	                    break;
	                // No ending tags required for these types
	                case NODE_TYPE.TEXT:
	                case NODE_TYPE.COMMENT:
	                    break;
	            }
	        };
	        /**
	         * Handles pre-visit behaviour for the specified element node
	         *
	         * @param {DOMElement} node
	         */
	        this._beginVisitElement = function (node) {
	            var tagName = node.tagName.toLowerCase();
	            var attributes = [];
	            for (var i = 0, count = node.attributes.length; i < count; i++) {
	                attributes.push(_this._getElementAttribute(node, node.attributes[i]));
	            }
	            if (tagName === 'textarea') {
	                // Hax: textareas need their inner text moved to a "defaultValue" attribute.
	                attributes.push('defaultValue={' + JSON.stringify(node.value) + '}');
	            }
	            if (tagName === 'style') {
	                // Hax: style tag contents need to be dangerously set due to liberal curly brace usage
	                attributes.push('dangerouslySetInnerHTML={{__html: ' + JSON.stringify(node.textContent) + ' }}');
	            }
	            if (tagName === 'pre') {
	                _this._inPreTag = true;
	            }
	            _this.output += '<' + tagName;
	            if (attributes.length > 0) {
	                _this.output += ' ' + attributes.join(' ');
	            }
	            if (!_this._isSelfClosing(node)) {
	                _this.output += '>';
	            }
	        };
	        /**
	         * Handles post-visit behaviour for the specified element node
	         *
	         * @param {Node} node
	         */
	        this._endVisitElement = function (node) {
	            var tagName = node.tagName.toLowerCase();
	            // De-indent a bit
	            // TODO: It's inefficient to do it this way :/
	            _this.output = trimEnd(_this.output, _this.config.indent);
	            if (_this._isSelfClosing(node)) {
	                _this.output += ' />';
	            }
	            else {
	                _this.output += '</' + node.tagName.toLowerCase() + '>';
	            }
	            if (tagName === 'pre') {
	                _this._inPreTag = false;
	            }
	        };
	        /**
	         * Determines if this element node should be rendered as a self-closing
	         * tag.
	         *
	         * @param {Node} node
	         * @return {boolean}
	         */
	        this._isSelfClosing = function (node) {
	            // If it has children, it's not self-closing
	            // Exception: All children of a textarea are moved to a "defaultValue" attribute, style attributes are dangerously set.
	            return !node.firstChild || node.tagName.toLowerCase() === 'textarea' || node.tagName.toLowerCase() === 'style';
	        };
	        /**
	         * Handles processing of the specified text node
	         *
	         * @param {TextNode} node
	         */
	        this._visitText = function (node) {
	            var parentTag = node.parentNode && node.parentNode.tagName.toLowerCase();
	            if (parentTag === 'textarea' || parentTag === 'style') {
	                // Ignore text content of textareas and styles, as it will have already been moved
	                // to a "defaultValue" attribute and "dangerouslySetInnerHTML" attribute respectively.
	                return;
	            }
	            var text = escapeSpecialChars(node.textContent);
	            if (_this._inPreTag) {
	                // If this text is contained within a <pre>, we need to ensure the JSX
	                // whitespace coalescing rules don't eat the whitespace. This means
	                // wrapping newlines and sequences of two or more spaces in variables.
	                text = text
	                    .replace(/\r/g, '')
	                    .replace(/( {2,}|\n|\t|\{|\})/g, function (whitespace) {
	                    return '{' + JSON.stringify(whitespace) + '}';
	                });
	            }
	            else {
	                // If there's a newline in the text, adjust the indent level
	                if (text.indexOf('\n') > -1) {
	                    text = text.replace(/\n\s*/g, _this._getIndentedNewline());
	                }
	            }
	            _this.output += text;
	        };
	        /**
	         * Handles processing of the specified text node
	         *
	         * @param {Text} node
	         */
	        this._visitComment = function (node) {
	            _this.output += '{/*' + node.textContent.replace('*/', '* /') + '*/}';
	        };
	        /**
	         * Gets a JSX formatted version of the specified attribute from the node
	         *
	         * @param {DOMElement} node
	         * @param {object}     attribute
	         * @return {string}
	         */
	        this._getElementAttribute = function (node, attribute) {
	            switch (attribute.name) {
	                case 'style':
	                    return _this._getStyleAttribute(attribute.value);
	                default:
	                    var tagName = node.tagName.toLowerCase();
	                    var name = (ELEMENT_ATTRIBUTE_MAPPING[tagName] &&
	                        ELEMENT_ATTRIBUTE_MAPPING[tagName][attribute.name]) ||
	                        ATTRIBUTE_MAPPING[attribute.name] ||
	                        attribute.name;
	                    var result = name;
	                    // Numeric values should be output as {123} not "123"
	                    if (isNumeric(attribute.value)) {
	                        result += '={' + attribute.value + '}';
	                    }
	                    else if (attribute.value.length > 0) {
	                        result += '="' + attribute.value.replace('"', '&quot;') + '"';
	                    }
	                    return result;
	            }
	        };
	        /**
	         * Gets a JSX formatted version of the specified element styles
	         *
	         * @param {string} styles
	         * @return {string}
	         */
	        this._getStyleAttribute = function (styles) {
	            var jsxStyles = new StyleParser(styles).toJSXString();
	            return 'style={{' + jsxStyles + '}}';
	        };
	        this.config = config || {};
	        if (this.config.createClass === undefined) {
	            this.config.createClass = true;
	        }
	        if (!this.config.indent) {
	            this.config.indent = '  ';
	        }
	    }
	    return HTMLtoJSX;
	}());
	exports.HTMLtoJSX = HTMLtoJSX;
	;
	/**
	 * Handles parsing of inline styles
	 */
	var StyleParser = /** @class */ (function () {
	    /** @param {string} rawStyle Raw style attribute */
	    function StyleParser(rawStyle) {
	        var _this = this;
	        this.styles = {};
	        /**
	         * Parse the specified inline style attribute value
	         * @param {string} rawStyle Raw style attribute
	         */
	        this.parse = function (rawStyle) {
	            rawStyle.split(';').forEach(function (style) {
	                style = style.trim();
	                var firstColon = style.indexOf(':');
	                var key = style.substr(0, firstColon);
	                var value = style.substr(firstColon + 1).trim();
	                if (key !== '') {
	                    // Style key should be case insensitive
	                    key = key.toLowerCase();
	                    this.styles[key] = value;
	                }
	            }, _this);
	        };
	        /**
	         * Convert the style information represented by this parser into a JSX
	         * string
	         *
	         * @return {string}
	         */
	        this.toJSXString = function () {
	            var output = [];
	            for (var key in _this.styles) {
	                if (!_this.styles.hasOwnProperty(key)) {
	                    continue;
	                }
	                output.push(_this.toJSXKey(key) + ': ' + _this.toJSXValue(_this.styles[key]));
	            }
	            return output.join(', ');
	        };
	        /**
	         * Convert the CSS style key to a JSX style key
	         *
	         * @param {string} key CSS style key
	         * @return {string} JSX style key
	         */
	        this.toJSXKey = function (key) {
	            // Don't capitalize -ms- prefix
	            if (/^-ms-/.test(key)) {
	                key = key.substr(1);
	            }
	            return hyphenToCamelCase(key);
	        };
	        /**
	         * Convert the CSS style value to a JSX style value
	         *
	         * @param {string} value CSS style value
	         * @return {string} JSX style value
	         */
	        this.toJSXValue = function (value) {
	            if (isNumeric(value)) {
	                // If numeric, no quotes
	                return value;
	            }
	            else if (isConvertiblePixelValue(value)) {
	                // "500px" -> 500
	                return trimEnd(value, 'px');
	            }
	            else {
	                // Probably a string, wrap it in quotes
	                return '\'' + value.replace(/'/g, '"') + '\'';
	            }
	        };
	        this.parse(rawStyle);
	    }
	    ;
	    return StyleParser;
	}());
	exports.StyleParser = StyleParser;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * inspiration:
	 * https://github.com/formulahendry/vscode-auto-close-tag/blob/5921f24ffc6fc9350e1ce7c2a74ea99fab0c5b11/src/extension.ts
	 * Modified to:
	 * - remove options. We are in sublime mode, no excluded tags etc
	 * - work with monaco instead of a vscode workspace
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(19);
	var monacoUtils = __webpack_require__(18);
	/**
	 * We want to disable it e.g. when auto writing code
	 */
	var enabled = true;
	exports.disableAutoClose = function () { return enabled = false; };
	exports.enableAutoClose = function () { return enabled = true; };
	function setup(cm) {
	    var disposible = new events_1.CompositeDisposible();
	    disposible.add(cm.onDidChangeModelContent(function (e) {
	        if (!enabled)
	            return;
	        /** Close tag */
	        insertAutoCloseTag(e, cm);
	    }));
	    return disposible;
	}
	exports.setup = setup;
	function insertAutoCloseTag(event, editor) {
	    var originalRange = event.range;
	    /** User just did `<foo>` */
	    if (event.text === ">") {
	        var text = editor.getModel().getValueInRange({
	            startLineNumber: 1,
	            startColumn: 1,
	            endLineNumber: originalRange.endLineNumber,
	            endColumn: originalRange.endColumn,
	        });
	        /**
	         * Check that its not
	         * `/>` (self closing)
	         * `=>` (arrow)
	         * `}>` (generic) ... hard cause `<foo bar={someting}>` is valid :-/
	         * By just checking is a char
	         **/
	        var lastChar = "";
	        if (text.length > 2) {
	            lastChar = text.substr(text.length - 1);
	        }
	        if (lastChar === "/" || lastChar === '=') {
	            return;
	        }
	        var closeTag = getCloseTagIfAtAnOpenOne(editor.filePath, editor.getModel().getOffsetAt({
	            lineNumber: originalRange.endLineNumber,
	            column: originalRange.endColumn
	        }));
	        if (!closeTag)
	            return;
	        closeTag = "</" + closeTag + ">";
	        /** Make edits */
	        var startAt = editor.getModel().modifyPosition({
	            lineNumber: originalRange.endLineNumber,
	            column: originalRange.endColumn
	        }, 1);
	        monacoUtils.replaceRange({
	            model: editor.getModel(),
	            range: {
	                startLineNumber: startAt.lineNumber,
	                startColumn: startAt.column,
	                endLineNumber: startAt.lineNumber,
	                endColumn: startAt.column
	            },
	            newText: closeTag
	        });
	        return;
	    }
	    /** User just did `<foo>something</` */
	    if (event.text === "/") {
	        var text = editor.getModel().getValueInRange({
	            startLineNumber: 1,
	            startColumn: 1,
	            endLineNumber: originalRange.endLineNumber,
	            endColumn: originalRange.endColumn,
	        });
	        var lastChar = "";
	        if (text.length > 2) {
	            lastChar = text.substr(text.length - 1);
	        }
	        if (lastChar !== "<") {
	            return;
	        }
	        /** Yay, we have </ See if we have a close tag ? */
	        var closeTag = getCloseTagForAnAlreadyOpenOne(editor.filePath, editor.getModel().getOffsetAt({
	            lineNumber: originalRange.endLineNumber,
	            column: originalRange.endColumn
	        }));
	        if (!closeTag) {
	            return;
	        }
	        /** Yay we have candidate closeTag like `div` */
	        /**
	         * If the user already has a trailing `>` e.g.
	         * before: <div><(pos)>
	         * after: <div><(pos)/>
	         * Next chars will be `/>`
	         */
	        var nextChars = getNext2Chars(editor, { lineNumber: originalRange.endLineNumber, column: originalRange.endColumn });
	        /** If the next chars are not `/>` then we want to complete `>` for the user as well */
	        if (nextChars !== "/>") {
	            closeTag = closeTag + '>';
	        }
	        /** Make edits */
	        var startAt = editor.getModel().modifyPosition({
	            lineNumber: originalRange.endLineNumber,
	            column: originalRange.endColumn
	        }, 1);
	        monacoUtils.replaceRange({
	            model: editor.getModel(),
	            range: {
	                startLineNumber: startAt.lineNumber,
	                startColumn: startAt.column,
	                endLineNumber: startAt.lineNumber,
	                endColumn: startAt.column
	            },
	            newText: closeTag
	        });
	        /** And advance the cursor */
	        var endAt_1 = editor.getModel().modifyPosition({
	            lineNumber: startAt.lineNumber,
	            column: startAt.column
	        }, closeTag.length);
	        if (nextChars === "/>") {
	            /** Advance one char more */
	            endAt_1 = editor.getModel().modifyPosition(endAt_1, 1);
	        }
	        /** Set timeout. Because it doesn't work otherwise */
	        setTimeout(function () {
	            editor.setSelection({
	                startLineNumber: endAt_1.lineNumber,
	                startColumn: endAt_1.column,
	                endLineNumber: endAt_1.lineNumber,
	                endColumn: endAt_1.column,
	            });
	        });
	    }
	}
	function getNext2Chars(editor, position) {
	    var nextPos = editor.getModel().modifyPosition(position, 2);
	    var text = editor.getModel().getValueInRange({
	        startLineNumber: position.lineNumber,
	        startColumn: position.column,
	        endLineNumber: nextPos.lineNumber,
	        endColumn: nextPos.column,
	    });
	    return text;
	}
	var classifierCache_1 = __webpack_require__(86);
	function getCloseTagForAnAlreadyOpenOne(filePath, position) {
	    var sourceFile = classifierCache_1.getSourceFile(filePath);
	    var opens = [];
	    var collectTags = function (node) {
	        if (ts.isJsxOpeningElement(node)) {
	            if (node.getStart() >= position)
	                return;
	            if (node.getStart() === (position - 1)) {
	                /**
	                 * This is actually just
	                 * <div><>
	                 *       ^ parsed as an opening
	                 */
	                return;
	            }
	            opens.push(node);
	        }
	        if (ts.isJsxClosingElement(node)) {
	            if (node.getStart() >= position)
	                return;
	            opens.pop();
	        }
	        ts.forEachChild(node, collectTags);
	    };
	    ts.forEachChild(sourceFile, collectTags);
	    // console.log(opens.map(o => o.getFullText())); // DEBUG
	    if (opens.length) {
	        var tabToClose = opens[opens.length - 1]; // close the last one first
	        var tagName = tabToClose.tagName.getText(); // something like `foo.Someting`
	        return tagName;
	    }
	    return null;
	}
	function getCloseTagIfAtAnOpenOne(filePath, position) {
	    var sourceFile = classifierCache_1.getSourceFile(filePath);
	    var found = null;
	    var collectTags = function (node) {
	        /**
	         * <div
	         * Is actually parsed as a JSX self closing tag
	         **/
	        if (node.kind === ts.SyntaxKind.JsxSelfClosingElement) {
	            /**
	             * With
	             * <foo>
	             *   <another(cursor)
	             * </foo>
	             *
	             * the `<another </` is what the jsx self closing tag contains
	             * So if its a *self closing* tag with a start before and end after ... its a candidate
	             */
	            if (!(node.getStart() <= position) || !(node.getEnd() >= position))
	                return;
	            var fullText = node.getFullText().trim();
	            // is actually closed
	            if (fullText.endsWith('/')
	                /**
	                 * Is getting the next `</` e.g.
	                 * <foo>
	                 *   <another(cursor)
	                 * </foo>
	                 * is parsed as
	                 * `<another </`
	                 */
	                && !fullText.endsWith('</'))
	                return;
	            if (found) {
	                var previous = found;
	                /** If it surrounds the position more tightly */
	                var delta = (position - node.getStart()) + (node.getEnd() - position);
	                var previousDelta = (position - previous.getStart()) + (previous.getEnd() - position);
	                if (delta < previousDelta) {
	                    found = node;
	                    ;
	                }
	            }
	            else {
	                found = node;
	            }
	        }
	        ts.forEachChild(node, collectTags);
	    };
	    ts.forEachChild(sourceFile, collectTags);
	    if (found) {
	        /**
	         * For
	         * <div|Hello
	         * We want <div only. But tag name full text gives us `<divHello`.
	         * So fix it by simply only giving `<div` text before position
	         */
	        var tagName = found.tagName;
	        var start = found.tagName.getStart();
	        var end = position;
	        return sourceFile.getFullText().substring(start, end);
	    }
	    return null;
	}


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var typestyle = __webpack_require__(13);
	var commands = __webpack_require__(7);
	/**
	 * Some styles
	 */
	/**
	 * We have a unified color in overview as
	 * having three colors there is mentally overloading
	 **/
	var colorInOverView = 'rgba(0, 122, 204, 0.6)';
	var addedColor = '#008A00';
	var addedClassName = typestyle.style({
	    borderLeft: "3px solid " + addedColor,
	    marginLeft: "5px"
	});
	var addedDecorationOptions = {
	    linesDecorationsClassName: addedClassName,
	    isWholeLine: true,
	    overviewRuler: {
	        color: colorInOverView,
	        darkColor: colorInOverView,
	        position: monaco.editor.OverviewRulerLane.Left
	    }
	};
	var modifiedColor = 'yellow';
	var modifiedClassName = typestyle.style({
	    borderLeft: "3px solid " + modifiedColor,
	    marginLeft: "5px"
	});
	var modifiedDecorationOptions = {
	    linesDecorationsClassName: modifiedClassName,
	    isWholeLine: true,
	    overviewRuler: {
	        color: colorInOverView,
	        darkColor: colorInOverView,
	        position: monaco.editor.OverviewRulerLane.Left
	    }
	};
	var removedColor = '#00ccff';
	var removedClassName = typestyle.style({
	    borderLeft: "3px solid " + removedColor,
	    marginLeft: "5px"
	});
	var removedDecorationOptions = {
	    linesDecorationsClassName: removedClassName,
	    isWholeLine: true,
	    overviewRuler: {
	        color: colorInOverView,
	        darkColor: colorInOverView,
	        position: monaco.editor.OverviewRulerLane.Left
	    }
	};
	var events_1 = __webpack_require__(19);
	var utils = __webpack_require__(3);
	var socketClient_1 = __webpack_require__(5);
	function setup(editor) {
	    // if (editor) return { dispose: () => null }; // DEBUG : while the feature isn't complete used to disable it
	    var filePath = editor.filePath;
	    var lastDecorations = [];
	    var refreshGitStatus = function () {
	        socketClient_1.server.gitDiff({ filePath: filePath }).then(function (res) {
	            // Add to new
	            var addedDecorations = res.added.map(function (added) {
	                var result = {
	                    range: {
	                        startLineNumber: added.from + 1,
	                        endLineNumber: added.to + 1,
	                    },
	                    options: addedDecorationOptions
	                };
	                return result;
	            });
	            var modifiedDecorations = res.modified.map(function (modified) {
	                var result = {
	                    range: {
	                        startLineNumber: modified.from + 1,
	                        endLineNumber: modified.to + 1,
	                    },
	                    options: modifiedDecorationOptions
	                };
	                return result;
	            });
	            var removedDecorations = res.removed.map(function (removed) {
	                var result = {
	                    range: {
	                        startLineNumber: removed + 1,
	                        endLineNumber: removed + 1,
	                    },
	                    options: removedDecorationOptions
	                };
	                return result;
	            });
	            // Collect all the decorations and apply them
	            var deltaDecorations = addedDecorations.concat(modifiedDecorations).concat(removedDecorations);
	            lastDecorations = editor.deltaDecorations(lastDecorations, deltaDecorations);
	        });
	    };
	    var refreshGitStatusDebounced = utils.debounce(refreshGitStatus, 2000);
	    var disposible = new events_1.CompositeDisposible();
	    disposible.add(editor.onDidFocusEditor(refreshGitStatusDebounced));
	    disposible.add(editor.onDidChangeModelContent(refreshGitStatusDebounced));
	    disposible.add(commands.gitStatusNeedsRefresh.on(refreshGitStatusDebounced));
	    return disposible;
	}
	exports.setup = setup;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(19);
	var socketClient_1 = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var state = __webpack_require__(11);
	__webpack_require__(371);
	var quickFixClassName = 'monaco-quickfix';
	var quickFixDecorationOptions = {
	    glyphMarginClassName: quickFixClassName,
	    isWholeLine: true,
	    hoverMessage: 'QuickFixes available. Click to select.'
	};
	function setup(editor) {
	    // if (cm) return { dispose: () => null }; // DEBUG : while the feature isn't complete used to disable it
	    var disposed = false;
	    var lastWidget = null;
	    // The key quick fix get logic
	    var refreshQuickFixes = function () {
	        if (disposed)
	            return;
	        // Clear any previous attempt
	        editor._lastQuickFixInformation = null;
	        if (lastWidget) {
	            editor.removeContentWidget(lastWidget);
	            lastWidget = null;
	        }
	        // If not active project return
	        if (!state.inActiveProjectFilePath(editor.filePath)) {
	            return;
	        }
	        var indentSize = editor.getModel().getOptions().tabSize;
	        var pos = editor.getPosition();
	        var position = editor.getModel().getOffsetAt(pos);
	        // query the server with live analysis
	        socketClient_1.server.getQuickFixes({
	            indentSize: indentSize,
	            filePath: editor.filePath,
	            position: position
	        }).then(function (res) {
	            // If no longer relevant abort and wait for a new call.
	            var newPos = editor.getPosition();
	            if (!newPos.equals(pos))
	                return;
	            /** Only add the decoration if there are some fixes available */
	            if (res.fixes.length) {
	                editor._lastQuickFixInformation = { res: res, position: position };
	                // Setup the marker. Note: Must be done outside `getDomNode` to make it idempotent
	                var marker = document.createElement("div");
	                marker.className = quickFixClassName;
	                marker.title = "Quick fixes available";
	                marker.innerHTML = "💡";
	                marker.onclick = function () {
	                    runQuickFixSelector(editor);
	                };
	                lastWidget = {
	                    allowEditorOverflow: false,
	                    getId: function () { return 'quickfix'; },
	                    getDomNode: function () { return marker; },
	                    getPosition: function () {
	                        return {
	                            position: { lineNumber: pos.lineNumber, column: editor.getModel().getLineContent(pos.lineNumber).length + 1 },
	                            preference: [
	                                monaco.editor.ContentWidgetPositionPreference.EXACT,
	                            ]
	                        };
	                    }
	                };
	                editor.addContentWidget(lastWidget);
	            }
	        });
	    };
	    var refreshQuickFixesDebounced = utils.debounce(refreshQuickFixes, 1000);
	    var disposible = new events_1.CompositeDisposible();
	    disposible.add(editor.onDidFocusEditor(refreshQuickFixesDebounced));
	    disposible.add(editor.onDidChangeModelContent(refreshQuickFixesDebounced));
	    disposible.add(editor.onDidChangeCursorPosition(refreshQuickFixesDebounced));
	    disposible.add(socketClient_1.cast.activeProjectConfigDetailsUpdated.on(function () {
	        refreshQuickFixesDebounced();
	    }));
	    disposible.add({
	        dispose: function () {
	            disposed = true;
	        }
	    });
	    return disposible;
	}
	exports.setup = setup;
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var selectListView = __webpack_require__(51);
	var ui = __webpack_require__(1);
	var uix = __webpack_require__(41);
	var React = __webpack_require__(2);
	var QuickFixAction = /** @class */ (function (_super) {
	    __extends(QuickFixAction, _super);
	    function QuickFixAction() {
	        return _super.call(this, {
	            id: QuickFixAction.ID,
	            label: 'TypeScript Quick Fix',
	            alias: 'TypeScript Quick Fix',
	            precondition: EditorContextKeys.Focus,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.Alt | KeyCode.Enter
	            }
	        }) || this;
	    }
	    QuickFixAction.prototype.run = function (accessor, editor) {
	        runQuickFixSelector(editor);
	    };
	    QuickFixAction.ID = 'editor.action.quickfix';
	    return QuickFixAction;
	}(EditorAction));
	function runQuickFixSelector(editor) {
	    var cm = editor;
	    if (!cm._lastQuickFixInformation) {
	        ui.notifyInfoNormalDisappear('No active quick fixes for last editor position');
	        return;
	    }
	    var fixes = cm._lastQuickFixInformation.res.fixes;
	    selectListView.selectListView.show({
	        header: '💡 Quick Fixes',
	        data: fixes,
	        render: function (fix, highlighted) {
	            return React.createElement("div", { style: { fontFamily: 'monospace' } }, highlighted);
	        },
	        textify: function (fix) { return fix.display; },
	        onSelect: function (fix) {
	            /**
	             * For each ts code fix its expected to request formatting as well
	             * https://github.com/Microsoft/TypeScript/issues/12249
	             * So add them to the refactorings
	             * The backend can't do it as the file hasn't been edited yet. Have to request from frontend :-/
	             *
	             * But its probably not worth too much trouble for now so ignoring.
	             **/
	            // tsCodeFix.changes.forEach(change => {
	            //     change.textChanges.forEach(tc => {
	            //         /** The end depends on the old text vs. the new text. But always greater than start (good enough) */
	            //         let end = tc.span.start + tc.newText.length - tc.span.length;
	            //         if (end < tc.span.start) end = tc.span.start;
	            //         let start = tc.span.start;
	            //         let tsresult = formatting.formatDocumentRangeUsingPos(project, change.fileName, start, end,
	            //             /**
	            //              * This is not 100% correct as the changed file can be different.
	            //              * But the likelyhood of the *other* project file having different formatting requirements is very low
	            //              **/
	            //             query.editorOptions
	            //         );
	            //         console.log(tsresult, change.fileName, tc.span, end);
	            //         tsresult.forEach(formatting => {
	            //             refactorings.push({
	            //                 filePath: change.fileName,
	            //                 newText: formatting.newText,
	            //                 span: formatting.span
	            //             });
	            //         })
	            //     });
	            // });
	            socketClient_1.server.applyQuickFix({
	                key: fix.key,
	                indentSize: cm.getModel().getOptions().tabSize,
	                additionalData: null,
	                filePath: cm.filePath,
	                position: cm._lastQuickFixInformation.position,
	            }).then(function (res) {
	                // apply refactorings
	                // console.log('Apply refactorings:', res.refactorings); // DEBUG
	                uix.API.applyRefactorings(res.refactorings);
	            });
	            return '';
	        }
	    });
	}
	CommonEditorRegistry.registerEditorAction(new QuickFixAction());


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * From : https://github.com/Microsoft/vscode-json-languageservice/blob/master/src/parser/jsonParser.ts
	 *
	 * Modifications:
	 * - removed `localize` dependency
	 * - redirected `jsonc-parser` dependency
	 */
	/*---------------------------------------------------------------------------------------------
	 *  Copyright (c) Microsoft Corporation. All rights reserved.
	 *  Licensed under the MIT License. See License.txt in the project root for license information.
	 *--------------------------------------------------------------------------------------------*/
	'use strict';
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Json = __webpack_require__(84);
	var jsonLocation_1 = __webpack_require__(427);
	/** BAS the function that was provided by vscode-nls */
	var localize_1 = __webpack_require__(85);
	var ASTNode = /** @class */ (function () {
	    function ASTNode(parent, type, name, start, end) {
	        this.type = type;
	        this.name = name;
	        this.start = start;
	        this.end = end;
	        this.parent = parent;
	    }
	    ASTNode.prototype.getNodeLocation = function () {
	        var path = this.parent ? this.parent.getNodeLocation() : new jsonLocation_1.JSONLocation([]);
	        if (this.name) {
	            path = path.append(this.name);
	        }
	        return path;
	    };
	    ASTNode.prototype.getChildNodes = function () {
	        return [];
	    };
	    ASTNode.prototype.getValue = function () {
	        // override in children
	        return;
	    };
	    ASTNode.prototype.contains = function (offset, includeRightBound) {
	        if (includeRightBound === void 0) { includeRightBound = false; }
	        return offset >= this.start && offset < this.end || includeRightBound && offset === this.end;
	    };
	    ASTNode.prototype.visit = function (visitor) {
	        return visitor(this);
	    };
	    ASTNode.prototype.getNodeFromOffset = function (offset) {
	        var findNode = function (node) {
	            if (offset >= node.start && offset < node.end) {
	                var children = node.getChildNodes();
	                for (var i = 0; i < children.length && children[i].start <= offset; i++) {
	                    var item = findNode(children[i]);
	                    if (item) {
	                        return item;
	                    }
	                }
	                return node;
	            }
	            return null;
	        };
	        return findNode(this);
	    };
	    ASTNode.prototype.getNodeFromOffsetEndInclusive = function (offset) {
	        var findNode = function (node) {
	            if (offset >= node.start && offset <= node.end) {
	                var children = node.getChildNodes();
	                for (var i = 0; i < children.length && children[i].start <= offset; i++) {
	                    var item = findNode(children[i]);
	                    if (item) {
	                        return item;
	                    }
	                }
	                return node;
	            }
	            return null;
	        };
	        return findNode(this);
	    };
	    ASTNode.prototype.validate = function (schema, validationResult, matchingSchemas, offset) {
	        var _this = this;
	        if (offset === void 0) { offset = -1; }
	        if (offset !== -1 && !this.contains(offset)) {
	            return;
	        }
	        if (Array.isArray(schema.type)) {
	            if (schema.type.indexOf(this.type) === -1) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: schema.errorMessage || localize_1.localize('typeArrayMismatchWarning', 'Incorrect type. Expected one of {0}', schema.type.join(', '))
	                });
	            }
	        }
	        else if (schema.type) {
	            if (this.type !== schema.type) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: schema.errorMessage || localize_1.localize('typeMismatchWarning', 'Incorrect type. Expected "{0}"', schema.type)
	                });
	            }
	        }
	        if (Array.isArray(schema.allOf)) {
	            schema.allOf.forEach(function (subSchema) {
	                _this.validate(subSchema, validationResult, matchingSchemas, offset);
	            });
	        }
	        if (schema.not) {
	            var subValidationResult = new ValidationResult();
	            var subMatchingSchemas = [];
	            this.validate(schema.not, subValidationResult, subMatchingSchemas, offset);
	            if (!subValidationResult.hasErrors()) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('notSchemaWarning', "Matches a schema that is not allowed.")
	                });
	            }
	            if (matchingSchemas) {
	                subMatchingSchemas.forEach(function (ms) {
	                    ms.inverted = !ms.inverted;
	                    matchingSchemas.push(ms);
	                });
	            }
	        }
	        var testAlternatives = function (alternatives, maxOneMatch) {
	            var matches = [];
	            // remember the best match that is used for error messages
	            var bestMatch = null;
	            alternatives.forEach(function (subSchema) {
	                var subValidationResult = new ValidationResult();
	                var subMatchingSchemas = [];
	                _this.validate(subSchema, subValidationResult, subMatchingSchemas);
	                if (!subValidationResult.hasErrors()) {
	                    matches.push(subSchema);
	                }
	                if (!bestMatch) {
	                    bestMatch = { schema: subSchema, validationResult: subValidationResult, matchingSchemas: subMatchingSchemas };
	                }
	                else {
	                    if (!maxOneMatch && !subValidationResult.hasErrors() && !bestMatch.validationResult.hasErrors()) {
	                        // no errors, both are equally good matches
	                        bestMatch.matchingSchemas.push.apply(bestMatch.matchingSchemas, subMatchingSchemas);
	                        bestMatch.validationResult.propertiesMatches += subValidationResult.propertiesMatches;
	                        bestMatch.validationResult.propertiesValueMatches += subValidationResult.propertiesValueMatches;
	                    }
	                    else {
	                        var compareResult = subValidationResult.compare(bestMatch.validationResult);
	                        if (compareResult > 0) {
	                            // our node is the best matching so far
	                            bestMatch = { schema: subSchema, validationResult: subValidationResult, matchingSchemas: subMatchingSchemas };
	                        }
	                        else if (compareResult === 0) {
	                            // there's already a best matching but we are as good
	                            bestMatch.matchingSchemas.push.apply(bestMatch.matchingSchemas, subMatchingSchemas);
	                        }
	                    }
	                }
	            });
	            if (matches.length > 1 && maxOneMatch) {
	                validationResult.warnings.push({
	                    location: { start: _this.start, end: _this.start + 1 },
	                    message: localize_1.localize('oneOfWarning', "Matches multiple schemas when only one must validate.")
	                });
	            }
	            if (bestMatch !== null) {
	                validationResult.merge(bestMatch.validationResult);
	                validationResult.propertiesMatches += bestMatch.validationResult.propertiesMatches;
	                validationResult.propertiesValueMatches += bestMatch.validationResult.propertiesValueMatches;
	                if (matchingSchemas) {
	                    matchingSchemas.push.apply(matchingSchemas, bestMatch.matchingSchemas);
	                }
	            }
	            return matches.length;
	        };
	        if (Array.isArray(schema.anyOf)) {
	            testAlternatives(schema.anyOf, false);
	        }
	        if (Array.isArray(schema.oneOf)) {
	            testAlternatives(schema.oneOf, true);
	        }
	        if (Array.isArray(schema.enum)) {
	            if (schema.enum.indexOf(this.getValue()) === -1) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('enumWarning', 'Value is not an accepted value. Valid values: {0}', JSON.stringify(schema.enum))
	                });
	            }
	            else {
	                validationResult.enumValueMatch = true;
	            }
	        }
	        if (matchingSchemas !== null) {
	            matchingSchemas.push({ node: this, schema: schema });
	        }
	    };
	    return ASTNode;
	}());
	exports.ASTNode = ASTNode;
	var NullASTNode = /** @class */ (function (_super) {
	    __extends(NullASTNode, _super);
	    function NullASTNode(parent, name, start, end) {
	        return _super.call(this, parent, 'null', name, start, end) || this;
	    }
	    NullASTNode.prototype.getValue = function () {
	        return null;
	    };
	    return NullASTNode;
	}(ASTNode));
	exports.NullASTNode = NullASTNode;
	var BooleanASTNode = /** @class */ (function (_super) {
	    __extends(BooleanASTNode, _super);
	    function BooleanASTNode(parent, name, value, start, end) {
	        var _this = _super.call(this, parent, 'boolean', name, start, end) || this;
	        _this.value = value;
	        return _this;
	    }
	    BooleanASTNode.prototype.getValue = function () {
	        return this.value;
	    };
	    return BooleanASTNode;
	}(ASTNode));
	exports.BooleanASTNode = BooleanASTNode;
	var ArrayASTNode = /** @class */ (function (_super) {
	    __extends(ArrayASTNode, _super);
	    function ArrayASTNode(parent, name, start, end) {
	        var _this = _super.call(this, parent, 'array', name, start, end) || this;
	        _this.items = [];
	        return _this;
	    }
	    ArrayASTNode.prototype.getChildNodes = function () {
	        return this.items;
	    };
	    ArrayASTNode.prototype.getValue = function () {
	        return this.items.map(function (v) { return v.getValue(); });
	    };
	    ArrayASTNode.prototype.addItem = function (item) {
	        if (item) {
	            this.items.push(item);
	            return true;
	        }
	        return false;
	    };
	    ArrayASTNode.prototype.visit = function (visitor) {
	        var ctn = visitor(this);
	        for (var i = 0; i < this.items.length && ctn; i++) {
	            ctn = this.items[i].visit(visitor);
	        }
	        return ctn;
	    };
	    ArrayASTNode.prototype.validate = function (schema, validationResult, matchingSchemas, offset) {
	        var _this = this;
	        if (offset === void 0) { offset = -1; }
	        if (offset !== -1 && !this.contains(offset)) {
	            return;
	        }
	        _super.prototype.validate.call(this, schema, validationResult, matchingSchemas, offset);
	        if (Array.isArray(schema.items)) {
	            var subSchemas_1 = schema.items;
	            subSchemas_1.forEach(function (subSchema, index) {
	                var itemValidationResult = new ValidationResult();
	                var item = _this.items[index];
	                if (item) {
	                    item.validate(subSchema, itemValidationResult, matchingSchemas, offset);
	                    validationResult.mergePropertyMatch(itemValidationResult);
	                }
	                else if (_this.items.length >= subSchemas_1.length) {
	                    validationResult.propertiesValueMatches++;
	                }
	            });
	            if (schema.additionalItems === false && this.items.length > subSchemas_1.length) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('additionalItemsWarning', 'Array has too many items according to schema. Expected {0} or fewer', subSchemas_1.length)
	                });
	            }
	            else if (this.items.length >= subSchemas_1.length) {
	                validationResult.propertiesValueMatches += (this.items.length - subSchemas_1.length);
	            }
	        }
	        else if (schema.items) {
	            this.items.forEach(function (item) {
	                var itemValidationResult = new ValidationResult();
	                item.validate(schema.items, itemValidationResult, matchingSchemas, offset);
	                validationResult.mergePropertyMatch(itemValidationResult);
	            });
	        }
	        if (schema.minItems && this.items.length < schema.minItems) {
	            validationResult.warnings.push({
	                location: { start: this.start, end: this.end },
	                message: localize_1.localize('minItemsWarning', 'Array has too few items. Expected {0} or more', schema.minItems)
	            });
	        }
	        if (schema.maxItems && this.items.length > schema.maxItems) {
	            validationResult.warnings.push({
	                location: { start: this.start, end: this.end },
	                message: localize_1.localize('maxItemsWarning', 'Array has too many items. Expected {0} or fewer', schema.minItems)
	            });
	        }
	        if (schema.uniqueItems === true) {
	            var values_1 = this.items.map(function (node) {
	                return node.getValue();
	            });
	            var duplicates = values_1.some(function (value, index) {
	                return index !== values_1.lastIndexOf(value);
	            });
	            if (duplicates) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('uniqueItemsWarning', 'Array has duplicate items')
	                });
	            }
	        }
	    };
	    return ArrayASTNode;
	}(ASTNode));
	exports.ArrayASTNode = ArrayASTNode;
	var NumberASTNode = /** @class */ (function (_super) {
	    __extends(NumberASTNode, _super);
	    function NumberASTNode(parent, name, start, end) {
	        var _this = _super.call(this, parent, 'number', name, start, end) || this;
	        _this.isInteger = true;
	        _this.value = Number.NaN;
	        return _this;
	    }
	    NumberASTNode.prototype.getValue = function () {
	        return this.value;
	    };
	    NumberASTNode.prototype.validate = function (schema, validationResult, matchingSchemas, offset) {
	        if (offset === void 0) { offset = -1; }
	        if (offset !== -1 && !this.contains(offset)) {
	            return;
	        }
	        // work around type validation in the base class
	        var typeIsInteger = false;
	        if (schema.type === 'integer' || (Array.isArray(schema.type) && schema.type.indexOf('integer') !== -1)) {
	            typeIsInteger = true;
	        }
	        if (typeIsInteger && this.isInteger === true) {
	            this.type = 'integer';
	        }
	        _super.prototype.validate.call(this, schema, validationResult, matchingSchemas, offset);
	        this.type = 'number';
	        var val = this.getValue();
	        if (typeof schema.multipleOf === 'number') {
	            if (val % schema.multipleOf !== 0) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('multipleOfWarning', 'Value is not divisible by {0}', schema.multipleOf)
	                });
	            }
	        }
	        if (typeof schema.minimum === 'number') {
	            if (schema.exclusiveMinimum && val <= schema.minimum) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('exclusiveMinimumWarning', 'Value is below the exclusive minimum of {0}', schema.minimum)
	                });
	            }
	            if (!schema.exclusiveMinimum && val < schema.minimum) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('minimumWarning', 'Value is below the minimum of {0}', schema.minimum)
	                });
	            }
	        }
	        if (typeof schema.maximum === 'number') {
	            if (schema.exclusiveMaximum && val >= schema.maximum) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('exclusiveMaximumWarning', 'Value is above the exclusive maximum of {0}', schema.maximum)
	                });
	            }
	            if (!schema.exclusiveMaximum && val > schema.maximum) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('maximumWarning', 'Value is above the maximum of {0}', schema.maximum)
	                });
	            }
	        }
	    };
	    return NumberASTNode;
	}(ASTNode));
	exports.NumberASTNode = NumberASTNode;
	var StringASTNode = /** @class */ (function (_super) {
	    __extends(StringASTNode, _super);
	    function StringASTNode(parent, name, isKey, start, end) {
	        var _this = _super.call(this, parent, 'string', name, start, end) || this;
	        _this.isKey = isKey;
	        _this.value = '';
	        return _this;
	    }
	    StringASTNode.prototype.getValue = function () {
	        return this.value;
	    };
	    StringASTNode.prototype.validate = function (schema, validationResult, matchingSchemas, offset) {
	        if (offset === void 0) { offset = -1; }
	        if (offset !== -1 && !this.contains(offset)) {
	            return;
	        }
	        _super.prototype.validate.call(this, schema, validationResult, matchingSchemas, offset);
	        if (schema.minLength && this.value.length < schema.minLength) {
	            validationResult.warnings.push({
	                location: { start: this.start, end: this.end },
	                message: localize_1.localize('minLengthWarning', 'String is shorter than the minimum length of ', schema.minLength)
	            });
	        }
	        if (schema.maxLength && this.value.length > schema.maxLength) {
	            validationResult.warnings.push({
	                location: { start: this.start, end: this.end },
	                message: localize_1.localize('maxLengthWarning', 'String is shorter than the maximum length of ', schema.maxLength)
	            });
	        }
	        if (schema.pattern) {
	            var regex = new RegExp(schema.pattern);
	            if (!regex.test(this.value)) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: schema.errorMessage || localize_1.localize('patternWarning', 'String does not match the pattern of "{0}"', schema.pattern)
	                });
	            }
	        }
	    };
	    return StringASTNode;
	}(ASTNode));
	exports.StringASTNode = StringASTNode;
	var PropertyASTNode = /** @class */ (function (_super) {
	    __extends(PropertyASTNode, _super);
	    function PropertyASTNode(parent, key) {
	        var _this = _super.call(this, parent, 'property', null, key.start) || this;
	        _this.key = key;
	        key.parent = _this;
	        key.name = key.value;
	        _this.colonOffset = -1;
	        return _this;
	    }
	    PropertyASTNode.prototype.getChildNodes = function () {
	        return this.value ? [this.key, this.value] : [this.key];
	    };
	    PropertyASTNode.prototype.setValue = function (value) {
	        this.value = value;
	        return value !== null;
	    };
	    PropertyASTNode.prototype.visit = function (visitor) {
	        return visitor(this) && this.key.visit(visitor) && this.value && this.value.visit(visitor);
	    };
	    PropertyASTNode.prototype.validate = function (schema, validationResult, matchingSchemas, offset) {
	        if (offset === void 0) { offset = -1; }
	        if (offset !== -1 && !this.contains(offset)) {
	            return;
	        }
	        if (this.value) {
	            this.value.validate(schema, validationResult, matchingSchemas, offset);
	        }
	    };
	    return PropertyASTNode;
	}(ASTNode));
	exports.PropertyASTNode = PropertyASTNode;
	var ObjectASTNode = /** @class */ (function (_super) {
	    __extends(ObjectASTNode, _super);
	    function ObjectASTNode(parent, name, start, end) {
	        var _this = _super.call(this, parent, 'object', name, start, end) || this;
	        _this.properties = [];
	        return _this;
	    }
	    ObjectASTNode.prototype.getChildNodes = function () {
	        return this.properties;
	    };
	    ObjectASTNode.prototype.addProperty = function (node) {
	        if (!node) {
	            return false;
	        }
	        this.properties.push(node);
	        return true;
	    };
	    ObjectASTNode.prototype.getFirstProperty = function (key) {
	        for (var i = 0; i < this.properties.length; i++) {
	            if (this.properties[i].key.value === key) {
	                return this.properties[i];
	            }
	        }
	        return null;
	    };
	    ObjectASTNode.prototype.getKeyList = function () {
	        return this.properties.map(function (p) { return p.key.getValue(); });
	    };
	    ObjectASTNode.prototype.getValue = function () {
	        var value = {};
	        this.properties.forEach(function (p) {
	            var v = p.value && p.value.getValue();
	            if (v) {
	                value[p.key.getValue()] = v;
	            }
	        });
	        return value;
	    };
	    ObjectASTNode.prototype.visit = function (visitor) {
	        var ctn = visitor(this);
	        for (var i = 0; i < this.properties.length && ctn; i++) {
	            ctn = this.properties[i].visit(visitor);
	        }
	        return ctn;
	    };
	    ObjectASTNode.prototype.validate = function (schema, validationResult, matchingSchemas, offset) {
	        var _this = this;
	        if (offset === void 0) { offset = -1; }
	        if (offset !== -1 && !this.contains(offset)) {
	            return;
	        }
	        _super.prototype.validate.call(this, schema, validationResult, matchingSchemas, offset);
	        var seenKeys = {};
	        var unprocessedProperties = [];
	        this.properties.forEach(function (node) {
	            var key = node.key.value;
	            seenKeys[key] = node.value;
	            unprocessedProperties.push(key);
	        });
	        if (Array.isArray(schema.required)) {
	            schema.required.forEach(function (propertyName) {
	                if (!seenKeys[propertyName]) {
	                    var key = _this.parent && _this.parent && _this.parent.key;
	                    var location_1 = key ? { start: key.start, end: key.end } : { start: _this.start, end: _this.start + 1 };
	                    validationResult.warnings.push({
	                        location: location_1,
	                        message: localize_1.localize('MissingRequiredPropWarning', 'Missing property "{0}"', propertyName)
	                    });
	                }
	            });
	        }
	        var propertyProcessed = function (prop) {
	            var index = unprocessedProperties.indexOf(prop);
	            while (index >= 0) {
	                unprocessedProperties.splice(index, 1);
	                index = unprocessedProperties.indexOf(prop);
	            }
	        };
	        if (schema.properties) {
	            Object.keys(schema.properties).forEach(function (propertyName) {
	                propertyProcessed(propertyName);
	                var prop = schema.properties[propertyName];
	                var child = seenKeys[propertyName];
	                if (child) {
	                    var propertyvalidationResult = new ValidationResult();
	                    child.validate(prop, propertyvalidationResult, matchingSchemas, offset);
	                    validationResult.mergePropertyMatch(propertyvalidationResult);
	                }
	            });
	        }
	        if (schema.patternProperties) {
	            Object.keys(schema.patternProperties).forEach(function (propertyPattern) {
	                var regex = new RegExp(propertyPattern);
	                unprocessedProperties.slice(0).forEach(function (propertyName) {
	                    if (regex.test(propertyName)) {
	                        propertyProcessed(propertyName);
	                        var child = seenKeys[propertyName];
	                        if (child) {
	                            var propertyvalidationResult = new ValidationResult();
	                            child.validate(schema.patternProperties[propertyPattern], propertyvalidationResult, matchingSchemas, offset);
	                            validationResult.mergePropertyMatch(propertyvalidationResult);
	                        }
	                    }
	                });
	            });
	        }
	        if (schema.additionalProperties) {
	            unprocessedProperties.forEach(function (propertyName) {
	                var child = seenKeys[propertyName];
	                if (child) {
	                    var propertyvalidationResult = new ValidationResult();
	                    child.validate(schema.additionalProperties, propertyvalidationResult, matchingSchemas, offset);
	                    validationResult.mergePropertyMatch(propertyvalidationResult);
	                }
	            });
	        }
	        else if (schema.additionalProperties === false) {
	            if (unprocessedProperties.length > 0) {
	                unprocessedProperties.forEach(function (propertyName) {
	                    var child = seenKeys[propertyName];
	                    if (child) {
	                        var propertyNode = child.parent;
	                        validationResult.warnings.push({
	                            location: { start: propertyNode.key.start, end: propertyNode.key.end },
	                            message: localize_1.localize('DisallowedExtraPropWarning', 'Property {0} is not allowed', propertyName)
	                        });
	                    }
	                });
	            }
	        }
	        if (schema.maxProperties) {
	            if (this.properties.length > schema.maxProperties) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('MaxPropWarning', 'Object has more properties than limit of {0}', schema.maxProperties)
	                });
	            }
	        }
	        if (schema.minProperties) {
	            if (this.properties.length < schema.minProperties) {
	                validationResult.warnings.push({
	                    location: { start: this.start, end: this.end },
	                    message: localize_1.localize('MinPropWarning', 'Object has fewer properties than the required number of {0}', schema.minProperties)
	                });
	            }
	        }
	        if (schema.dependencies) {
	            Object.keys(schema.dependencies).forEach(function (key) {
	                var prop = seenKeys[key];
	                if (prop) {
	                    if (Array.isArray(schema.dependencies[key])) {
	                        var valueAsArray = schema.dependencies[key];
	                        valueAsArray.forEach(function (requiredProp) {
	                            if (!seenKeys[requiredProp]) {
	                                validationResult.warnings.push({
	                                    location: { start: _this.start, end: _this.end },
	                                    message: localize_1.localize('RequiredDependentPropWarning', 'Object is missing property {0} required by property {1}', requiredProp, key)
	                                });
	                            }
	                            else {
	                                validationResult.propertiesValueMatches++;
	                            }
	                        });
	                    }
	                    else if (schema.dependencies[key]) {
	                        var valueAsSchema = schema.dependencies[key];
	                        var propertyvalidationResult = new ValidationResult();
	                        _this.validate(valueAsSchema, propertyvalidationResult, matchingSchemas, offset);
	                        validationResult.mergePropertyMatch(propertyvalidationResult);
	                    }
	                }
	            });
	        }
	    };
	    return ObjectASTNode;
	}(ASTNode));
	exports.ObjectASTNode = ObjectASTNode;
	var JSONDocumentConfig = /** @class */ (function () {
	    function JSONDocumentConfig() {
	        this.ignoreDanglingComma = false;
	    }
	    return JSONDocumentConfig;
	}());
	exports.JSONDocumentConfig = JSONDocumentConfig;
	var ValidationResult = /** @class */ (function () {
	    function ValidationResult() {
	        this.errors = [];
	        this.warnings = [];
	        this.propertiesMatches = 0;
	        this.propertiesValueMatches = 0;
	        this.enumValueMatch = false;
	    }
	    ValidationResult.prototype.hasErrors = function () {
	        return !!this.errors.length || !!this.warnings.length;
	    };
	    ValidationResult.prototype.mergeAll = function (validationResults) {
	        var _this = this;
	        validationResults.forEach(function (validationResult) {
	            _this.merge(validationResult);
	        });
	    };
	    ValidationResult.prototype.merge = function (validationResult) {
	        this.errors = this.errors.concat(validationResult.errors);
	        this.warnings = this.warnings.concat(validationResult.warnings);
	    };
	    ValidationResult.prototype.mergePropertyMatch = function (propertyValidationResult) {
	        this.merge(propertyValidationResult);
	        this.propertiesMatches++;
	        if (propertyValidationResult.enumValueMatch || !propertyValidationResult.hasErrors() && propertyValidationResult.propertiesMatches) {
	            this.propertiesValueMatches++;
	        }
	    };
	    ValidationResult.prototype.compare = function (other) {
	        var hasErrors = this.hasErrors();
	        if (hasErrors !== other.hasErrors()) {
	            return hasErrors ? -1 : 1;
	        }
	        if (this.enumValueMatch !== other.enumValueMatch) {
	            return other.enumValueMatch ? -1 : 1;
	        }
	        if (this.propertiesValueMatches !== other.propertiesValueMatches) {
	            return this.propertiesValueMatches - other.propertiesValueMatches;
	        }
	        return this.propertiesMatches - other.propertiesMatches;
	    };
	    return ValidationResult;
	}());
	exports.ValidationResult = ValidationResult;
	var JSONDocument = /** @class */ (function () {
	    function JSONDocument(config) {
	        this.config = config;
	        this.validationResult = new ValidationResult();
	    }
	    Object.defineProperty(JSONDocument.prototype, "errors", {
	        get: function () {
	            return this.validationResult.errors;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(JSONDocument.prototype, "warnings", {
	        get: function () {
	            return this.validationResult.warnings;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    JSONDocument.prototype.getNodeFromOffset = function (offset) {
	        return this.root && this.root.getNodeFromOffset(offset);
	    };
	    JSONDocument.prototype.getNodeFromOffsetEndInclusive = function (offset) {
	        return this.root && this.root.getNodeFromOffsetEndInclusive(offset);
	    };
	    JSONDocument.prototype.visit = function (visitor) {
	        if (this.root) {
	            this.root.visit(visitor);
	        }
	    };
	    JSONDocument.prototype.validate = function (schema, matchingSchemas, offset) {
	        if (matchingSchemas === void 0) { matchingSchemas = null; }
	        if (offset === void 0) { offset = -1; }
	        if (this.root) {
	            this.root.validate(schema, this.validationResult, matchingSchemas, offset);
	        }
	    };
	    return JSONDocument;
	}());
	exports.JSONDocument = JSONDocument;
	function parse(text, config) {
	    if (config === void 0) { config = new JSONDocumentConfig(); }
	    var _doc = new JSONDocument(config);
	    var _scanner = Json.createScanner(text, true);
	    function _accept(token) {
	        if (_scanner.getToken() === token) {
	            _scanner.scan();
	            return true;
	        }
	        return false;
	    }
	    function _error(message, node, skipUntilAfter, skipUntil) {
	        if (node === void 0) { node = null; }
	        if (skipUntilAfter === void 0) { skipUntilAfter = []; }
	        if (skipUntil === void 0) { skipUntil = []; }
	        if (_doc.errors.length === 0 || _doc.errors[0].location.start !== _scanner.getTokenOffset()) {
	            // ignore multiple errors on the same offset
	            var error = { message: message, location: { start: _scanner.getTokenOffset(), end: _scanner.getTokenOffset() + _scanner.getTokenLength() } };
	            _doc.errors.push(error);
	        }
	        if (node) {
	            _finalize(node, false);
	        }
	        if (skipUntilAfter.length + skipUntil.length > 0) {
	            var token = _scanner.getToken();
	            while (token !== Json.SyntaxKind.EOF) {
	                if (skipUntilAfter.indexOf(token) !== -1) {
	                    _scanner.scan();
	                    break;
	                }
	                else if (skipUntil.indexOf(token) !== -1) {
	                    break;
	                }
	                token = _scanner.scan();
	            }
	        }
	        return node;
	    }
	    function _checkScanError() {
	        switch (_scanner.getTokenError()) {
	            case Json.ScanError.InvalidUnicode:
	                _error(localize_1.localize('InvalidUnicode', 'Invalid unicode sequence in string'));
	                return true;
	            case Json.ScanError.InvalidEscapeCharacter:
	                _error(localize_1.localize('InvalidEscapeCharacter', 'Invalid escape character in string'));
	                return true;
	            case Json.ScanError.UnexpectedEndOfNumber:
	                _error(localize_1.localize('UnexpectedEndOfNumber', 'Unexpected end of number'));
	                return true;
	            case Json.ScanError.UnexpectedEndOfComment:
	                _error(localize_1.localize('UnexpectedEndOfComment', 'Unexpected end of comment'));
	                return true;
	            case Json.ScanError.UnexpectedEndOfString:
	                _error(localize_1.localize('UnexpectedEndOfString', 'Unexpected end of string'));
	                return true;
	        }
	        return false;
	    }
	    function _finalize(node, scanNext) {
	        node.end = _scanner.getTokenOffset() + _scanner.getTokenLength();
	        if (scanNext) {
	            _scanner.scan();
	        }
	        return node;
	    }
	    function _parseArray(parent, name) {
	        if (_scanner.getToken() !== Json.SyntaxKind.OpenBracketToken) {
	            return null;
	        }
	        var node = new ArrayASTNode(parent, name, _scanner.getTokenOffset());
	        _scanner.scan(); // consume OpenBracketToken
	        var count = 0;
	        if (node.addItem(_parseValue(node, '' + count++))) {
	            while (_accept(Json.SyntaxKind.CommaToken)) {
	                if (!node.addItem(_parseValue(node, '' + count++)) && !_doc.config.ignoreDanglingComma) {
	                    _error(localize_1.localize('ValueExpected', 'Value expected'));
	                }
	            }
	        }
	        if (_scanner.getToken() !== Json.SyntaxKind.CloseBracketToken) {
	            return _error(localize_1.localize('ExpectedCloseBracket', 'Expected comma or closing bracket'), node);
	        }
	        return _finalize(node, true);
	    }
	    function _parseProperty(parent, keysSeen) {
	        var key = _parseString(null, null, true);
	        if (!key) {
	            if (_scanner.getToken() === Json.SyntaxKind.Unknown) {
	                // give a more helpful error message
	                var value = _scanner.getTokenValue();
	                if (value.match(/^['\w]/)) {
	                    _error(localize_1.localize('DoubleQuotesExpected', 'Property keys must be doublequoted'));
	                }
	            }
	            return null;
	        }
	        var node = new PropertyASTNode(parent, key);
	        if (keysSeen[key.value]) {
	            _doc.warnings.push({ location: { start: node.key.start, end: node.key.end }, message: localize_1.localize('DuplicateKeyWarning', "Duplicate object key") });
	        }
	        keysSeen[key.value] = true;
	        if (_scanner.getToken() === Json.SyntaxKind.ColonToken) {
	            node.colonOffset = _scanner.getTokenOffset();
	        }
	        else {
	            return _error(localize_1.localize('ColonExpected', 'Colon expected'), node, [], [Json.SyntaxKind.CloseBraceToken, Json.SyntaxKind.CommaToken]);
	        }
	        _scanner.scan(); // consume ColonToken
	        if (!node.setValue(_parseValue(node, key.value))) {
	            return _error(localize_1.localize('ValueExpected', 'Value expected'), node, [], [Json.SyntaxKind.CloseBraceToken, Json.SyntaxKind.CommaToken]);
	        }
	        node.end = node.value.end;
	        return node;
	    }
	    function _parseObject(parent, name) {
	        if (_scanner.getToken() !== Json.SyntaxKind.OpenBraceToken) {
	            return null;
	        }
	        var node = new ObjectASTNode(parent, name, _scanner.getTokenOffset());
	        _scanner.scan(); // consume OpenBraceToken
	        var keysSeen = {};
	        if (node.addProperty(_parseProperty(node, keysSeen))) {
	            while (_accept(Json.SyntaxKind.CommaToken)) {
	                if (!node.addProperty(_parseProperty(node, keysSeen)) && !_doc.config.ignoreDanglingComma) {
	                    _error(localize_1.localize('PropertyExpected', 'Property expected'));
	                }
	            }
	        }
	        if (_scanner.getToken() !== Json.SyntaxKind.CloseBraceToken) {
	            return _error(localize_1.localize('ExpectedCloseBrace', 'Expected comma or closing brace'), node);
	        }
	        return _finalize(node, true);
	    }
	    function _parseString(parent, name, isKey) {
	        if (_scanner.getToken() !== Json.SyntaxKind.StringLiteral) {
	            return null;
	        }
	        var node = new StringASTNode(parent, name, isKey, _scanner.getTokenOffset());
	        node.value = _scanner.getTokenValue();
	        _checkScanError();
	        return _finalize(node, true);
	    }
	    function _parseNumber(parent, name) {
	        if (_scanner.getToken() !== Json.SyntaxKind.NumericLiteral) {
	            return null;
	        }
	        var node = new NumberASTNode(parent, name, _scanner.getTokenOffset());
	        if (!_checkScanError()) {
	            var tokenValue = _scanner.getTokenValue();
	            try {
	                var numberValue = JSON.parse(tokenValue);
	                if (typeof numberValue !== 'number') {
	                    return _error(localize_1.localize('InvalidNumberFormat', 'Invalid number format'), node);
	                }
	                node.value = numberValue;
	            }
	            catch (e) {
	                return _error(localize_1.localize('InvalidNumberFormat', 'Invalid number format'), node);
	            }
	            node.isInteger = tokenValue.indexOf('.') === -1;
	        }
	        return _finalize(node, true);
	    }
	    function _parseLiteral(parent, name) {
	        var node;
	        switch (_scanner.getToken()) {
	            case Json.SyntaxKind.NullKeyword:
	                node = new NullASTNode(parent, name, _scanner.getTokenOffset());
	                break;
	            case Json.SyntaxKind.TrueKeyword:
	                node = new BooleanASTNode(parent, name, true, _scanner.getTokenOffset());
	                break;
	            case Json.SyntaxKind.FalseKeyword:
	                node = new BooleanASTNode(parent, name, false, _scanner.getTokenOffset());
	                break;
	            default:
	                return null;
	        }
	        return _finalize(node, true);
	    }
	    function _parseValue(parent, name) {
	        return _parseArray(parent, name) || _parseObject(parent, name) || _parseString(parent, name, false) || _parseNumber(parent, name) || _parseLiteral(parent, name);
	    }
	    _scanner.scan();
	    _doc.root = _parseValue(null, null);
	    if (!_doc.root) {
	        _error(localize_1.localize('Invalid symbol', 'Expected a JSON object, array or literal'));
	    }
	    else if (_scanner.getToken() !== Json.SyntaxKind.EOF) {
	        _error(localize_1.localize('End of file expected', 'End of file expected'));
	    }
	    return _doc;
	}
	exports.parse = parse;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var editBatcher = __webpack_require__(445);
	var utils = __webpack_require__(3);
	var classifierCache = __webpack_require__(86);
	var state = __webpack_require__(11);
	var monacoUtils = __webpack_require__(18);
	var events = __webpack_require__(19);
	/**
	 * Setup any additional languages
	 */
	var monacoTypeScript_1 = __webpack_require__(439);
	monacoTypeScript_1.setupMonacoTypecript();
	var monacoJson_1 = __webpack_require__(430);
	monacoJson_1.setupMonacoJson();
	/**
	 * Ext lookup
	 */
	var extLookup = {};
	monaco.languages.getLanguages().forEach(function (language) {
	    // console.log(language); // DEBUG
	    language.extensions.forEach(function (ext) {
	        // ext is like `.foo`. We really want `foo`
	        ext = ext.substr(1);
	        extLookup[ext] = language;
	    });
	});
	/**
	 * Gets the mode for a give filePath (based on its ext)
	 */
	var getLanguage = function (filePath) {
	    var mode = extLookup[utils.getExt(filePath)];
	    return mode ? mode.id : 'plaintext';
	};
	// to track the source of changes, local vs. network
	var localSourceId = utils.createId();
	function getLinkedDoc(filePath, editor) {
	    return getOrCreateDoc(filePath)
	        .then(function (_a) {
	        var doc = _a.doc, isJsOrTsFile = _a.isJsOrTsFile, editorOptions = _a.editorOptions;
	        // Everytime a typescript file is opened we ask for its output status (server pull)
	        // On editing this happens automatically (server push)
	        socketClient_1.server.getJSOutputStatus({ filePath: filePath }).then(function (res) {
	            if (res.inActiveProject) {
	                state.fileOuputStatusUpdated(res.outputStatus);
	            }
	        });
	        /** Wire up the doc */
	        editor.setModel(doc);
	        /** Add to list of editors */
	        doc._editors.push(editor);
	        return { doc: doc, editorOptions: editorOptions };
	    });
	}
	exports.getLinkedDoc = getLinkedDoc;
	function removeLinkedDoc(filePath, editor) {
	    editor.getModel()._editors = editor.getModel()._editors.filter(function (e) { return e != editor; });
	    // if this was the last editor using this model then we remove it from the cache as well
	    // otherwise we might get a file even if its deleted from the server
	    if (!editor.getModel()._editors.length) {
	        docByFilePathPromised[filePath].then(function (x) {
	            x.disposable.dispose();
	            delete docByFilePathPromised[filePath];
	        });
	    }
	}
	exports.removeLinkedDoc = removeLinkedDoc;
	var docByFilePathPromised = Object.create(null);
	function getOrCreateDoc(filePath) {
	    if (docByFilePathPromised[filePath]) {
	        return docByFilePathPromised[filePath];
	    }
	    else {
	        return docByFilePathPromised[filePath] = socketClient_1.server.openFile({ filePath: filePath }).then(function (res) {
	            var disposable = new events.CompositeDisposible();
	            var ext = utils.getExt(filePath);
	            var isJsOrTsFile = utils.isJsOrTs(filePath);
	            var language = getLanguage(filePath);
	            // console.log(res.editorOptions); // DEBUG
	            // console.log(mode,supportedModesMap[ext]); // Debug mode
	            // Add to classifier cache
	            if (isJsOrTsFile) {
	                classifierCache.addFile(filePath, res.contents);
	                disposable.add({ dispose: function () { return classifierCache.removeFile(filePath); } });
	            }
	            // create the doc
	            var doc = monaco.editor.createModel(res.contents, language);
	            doc.setEOL(monaco.editor.EndOfLineSequence.LF); // The true eol is only with the file model at the backend. The frontend doesn't care 🌹
	            doc.filePath = filePath;
	            doc._editors = [];
	            doc._editorOptions = res.editorOptions;
	            /** Susbcribe to editor options changing */
	            disposable.add(socketClient_1.cast.editorOptionsChanged.on(function (res) {
	                if (res.filePath === filePath) {
	                    doc._editorOptions = res.editorOptions;
	                }
	            }));
	            /**
	             * We ignore edit notifications from monaco if *we* did the edit e.g.
	             * - if the server sent the edit and we applied it.
	             */
	            var countOfEditNotificationsToIgnore = 0;
	            /** This is used for monaco edit operation version counting purposes */
	            var editorOperationCounter = 0;
	            // setup to push doc changes to server
	            disposable.add(doc.onDidChangeContent(function (evt) {
	                // Keep the ouput status cache informed
	                state.ifJSStatusWasCurrentThenMoveToOutOfDate({ inputFilePath: filePath });
	                // if this edit is happening
	                // because *we edited it due to a server request*
	                // we should exit
	                if (countOfEditNotificationsToIgnore) {
	                    countOfEditNotificationsToIgnore--;
	                    return;
	                }
	                var codeEdit = {
	                    from: { line: evt.range.startLineNumber - 1, ch: evt.range.startColumn - 1 },
	                    to: { line: evt.range.endLineNumber - 1, ch: evt.range.endColumn - 1 },
	                    newText: evt.text,
	                    sourceId: localSourceId
	                };
	                // Send the edit
	                editBatcher.addToQueue(filePath, codeEdit);
	                // Keep the classifier in sync
	                if (isJsOrTsFile) {
	                    classifierCache.editFile(filePath, codeEdit);
	                }
	            }));
	            // setup to get doc changes from server
	            disposable.add(socketClient_1.cast.didEdits.on(function (res) {
	                // console.log('got server edit', res.edit.sourceId,'our', sourceId)
	                var codeEdits = res.edits;
	                codeEdits.forEach(function (codeEdit) {
	                    // Easy exit for local edits getting echoed back
	                    if (res.filePath == filePath && codeEdit.sourceId !== localSourceId) {
	                        // Keep the classifier in sync
	                        if (isJsOrTsFile) {
	                            classifierCache.editFile(filePath, codeEdit);
	                        }
	                        // make the edits
	                        var editOperation = {
	                            identifier: {
	                                major: editorOperationCounter++,
	                                minor: 0
	                            },
	                            text: codeEdit.newText,
	                            range: new monaco.Range(codeEdit.from.line + 1, codeEdit.from.ch + 1, codeEdit.to.line + 1, codeEdit.to.ch + 1),
	                            forceMoveMarkers: false,
	                            isAutoWhitespaceEdit: false,
	                        };
	                        /** Mark as ignoring before applying the edit */
	                        countOfEditNotificationsToIgnore++;
	                        doc.pushEditOperations([], [editOperation], null);
	                    }
	                });
	            }));
	            // setup loading saved files changing on disk
	            disposable.add(socketClient_1.cast.savedFileChangedOnDisk.on(function (res) {
	                if (res.filePath == filePath
	                    && doc.getValue() !== res.contents) {
	                    // preserve cursor
	                    doc._editors.forEach(function (e) {
	                        var cursors = e.getSelections();
	                        setTimeout(function () {
	                            e.setSelections(cursors);
	                        });
	                    });
	                    // Keep the classifier in sync
	                    if (isJsOrTsFile) {
	                        classifierCache.setContents(filePath, res.contents);
	                    }
	                    // Note that we use *mark as coming from server* so we don't go into doc.change handler later on :)
	                    countOfEditNotificationsToIgnore++;
	                    // NOTE: we don't do `setValue` as
	                    // - that creates a new tokenizer (we would need to use `window.creatingModelFilePath`)
	                    // - looses all undo history.
	                    // Instead we *replace* all the text that is there 🌹
	                    var totalDocRange = doc.getFullModelRange();
	                    monacoUtils.replaceRange({
	                        range: totalDocRange,
	                        model: doc,
	                        newText: res.contents
	                    });
	                }
	            }));
	            // Finally return the doc
	            var result = {
	                doc: doc,
	                isJsOrTsFile: isJsOrTsFile,
	                editorOptions: res.editorOptions,
	                disposable: disposable,
	            };
	            return result;
	        });
	    }
	}
	/**
	 * Don't plan to export as giving others our true docs can have horrible consequences if they mess them up
	 */
	function getOrCreateDocs(filePaths) {
	    var promises = filePaths.map(function (fp) { return getOrCreateDoc(fp); });
	    return Promise.all(promises).then(function (docs) {
	        var res = {};
	        docs.forEach(function (_a) {
	            var doc = _a.doc;
	            return res[doc.filePath] = doc;
	        });
	        return res;
	    });
	}
	function applyRefactoringsToTsDocs(refactorings) {
	    var filePaths = Object.keys(refactorings);
	    getOrCreateDocs(filePaths).then(function (docsByFilePath) {
	        filePaths.forEach(function (fp) {
	            var doc = docsByFilePath[fp];
	            var changes = refactorings[fp];
	            for (var _i = 0, changes_1 = changes; _i < changes_1.length; _i++) {
	                var change = changes_1[_i];
	                var from = classifierCache.getLineAndCharacterOfPosition(fp, change.span.start);
	                var to = classifierCache.getLineAndCharacterOfPosition(fp, change.span.start + change.span.length);
	                monacoUtils.replaceRange({
	                    model: doc,
	                    range: {
	                        startLineNumber: from.line + 1,
	                        startColumn: from.ch + 1,
	                        endLineNumber: to.line + 1,
	                        endColumn: to.ch + 1
	                    },
	                    newText: change.newText
	                });
	            }
	        });
	    });
	}
	exports.applyRefactoringsToTsDocs = applyRefactoringsToTsDocs;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Does the mapping between urls to different tabs
	 * Anything about tabs that needs to change based on tab protocol should go here
	 */
	var utils = __webpack_require__(3);
	/** Various tabs  */
	var codeTab_1 = __webpack_require__(457);
	var astView_1 = __webpack_require__(456);
	var dependencyView_1 = __webpack_require__(458);
	var findAndReplaceMulti_1 = __webpack_require__(460);
	var documentationView_1 = __webpack_require__(459);
	var umlView_1 = __webpack_require__(465);
	var tsFlowView_1 = __webpack_require__(464);
	var testedView_1 = __webpack_require__(463);
	var liveDemoView_1 = __webpack_require__(462);
	var liveDemoReactView_1 = __webpack_require__(461);
	/**
	 * Tabs get to choose how much they want to integrate with search
	 */
	var TabSearchSupport;
	(function (TabSearchSupport) {
	    TabSearchSupport[TabSearchSupport["None"] = 0] = "None";
	    TabSearchSupport[TabSearchSupport["Basic"] = 1] = "Basic";
	    TabSearchSupport[TabSearchSupport["Advanced"] = 2] = "Advanced";
	})(TabSearchSupport = exports.TabSearchSupport || (exports.TabSearchSupport = {}));
	exports.tabs = {
	    file: {
	        protocol: 'file',
	        searchSupport: TabSearchSupport.Advanced,
	        getTitle: utils.getFileName,
	        component: codeTab_1.Code,
	    },
	    ast: {
	        protocol: 'ast',
	        searchSupport: TabSearchSupport.None,
	        getTitle: function (url) { return "AST " + utils.getFileName(url); },
	        component: astView_1.ASTView,
	    },
	    astfull: {
	        protocol: 'astfull',
	        searchSupport: TabSearchSupport.None,
	        getTitle: function (url) { return "AST Full " + utils.getFileName(url); },
	        component: astView_1.ASTView,
	    },
	    dependency: {
	        protocol: 'dependency',
	        searchSupport: TabSearchSupport.Basic,
	        getTitle: function () { return 'Dependency View'; },
	        component: dependencyView_1.DependencyView,
	    },
	    farm: {
	        protocol: 'farm',
	        searchSupport: TabSearchSupport.None,
	        getTitle: function (url) { return "Find In Project"; },
	        component: findAndReplaceMulti_1.FindAndReplaceView,
	    },
	    documentation: {
	        protocol: 'documentation',
	        searchSupport: TabSearchSupport.Basic,
	        getTitle: function (url) { return "Documentation"; },
	        component: documentationView_1.DocumentationView,
	    },
	    uml: {
	        protocol: 'uml',
	        searchSupport: TabSearchSupport.None,
	        getTitle: function (url) { return "UML " + utils.getFileName(url); },
	        component: umlView_1.UmlView,
	    },
	    tsflow: {
	        protocol: 'tsflow',
	        searchSupport: TabSearchSupport.None,
	        getTitle: function (url) { return "TSFlow " + utils.getFileName(url); },
	        component: tsFlowView_1.TsFlowView,
	    },
	    tested: {
	        protocol: 'tested',
	        searchSupport: TabSearchSupport.None,
	        getTitle: function (url) { return "Tests"; },
	        component: testedView_1.TestedView,
	    },
	    livedemo: {
	        protocol: 'livedemo',
	        searchSupport: TabSearchSupport.None,
	        getTitle: function () { return 'Live Demo'; },
	        component: liveDemoView_1.LiveDemoView
	    },
	    livedemoreact: {
	        protocol: 'livedemoreact',
	        searchSupport: TabSearchSupport.None,
	        getTitle: function () { return 'Live Demo React'; },
	        component: liveDemoReactView_1.LiveDemoReactView
	    }
	};
	var _ensuretabsType = exports.tabs;
	function getTabConfigs() {
	    return Object.keys(exports.tabs).map(function (protocol) { return ({ protocol: protocol, config: exports.tabs[protocol] }); });
	}
	exports.getTabConfigs = getTabConfigs;
	function getComponentByUrl(url) {
	    var protocol = utils.getFilePathAndProtocolFromUrl(url).protocol;
	    var tab = exports.tabs[protocol];
	    if (tab)
	        return tab.component;
	    var error = 'Unknown protocol: ' + protocol;
	    throw new Error(error);
	}
	exports.getComponentByUrl = getComponentByUrl;
	function getTabConfigByUrl(url) {
	    var protocol = utils.getFilePathAndProtocolFromUrl(url).protocol;
	    var tab = exports.tabs[protocol];
	    if (tab)
	        return tab;
	    var error = 'Unknown protocol: ' + protocol;
	    throw new Error(error);
	}
	exports.getTabConfigByUrl = getTabConfigByUrl;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketLib_1 = __webpack_require__(165);
	/**
	 * Consists of the following contracts
	 *
	 * a contract on how the client --calls--> server
	 * a contract on how the server --calls--> the client that is calling the server
	 * a contract on how the server --anycasts-> all clients
	 */
	exports.server = {
	    echo: {},
	    filePaths: {},
	    makeAbsolute: {},
	    /**
	     * File stuff
	     */
	    openFile: {},
	    closeFile: {},
	    editFile: {},
	    saveFile: {},
	    getFileStatus: {},
	    /** File Tree */
	    addFile: {},
	    addFolder: {},
	    deleteFromDisk: {},
	    duplicateFile: {},
	    duplicateDir: {},
	    movePath: {},
	    launchDirectory: {},
	    launchTerminal: {},
	    /**
	     * config stuff
	     */
	    availableProjects: {},
	    getActiveProjectConfigDetails: {},
	    setActiveProjectConfigDetails: {},
	    isFilePathInActiveProject: {},
	    setOpenUITabs: {},
	    getOpenUITabs: {},
	    activeProjectFilePaths: {},
	    sync: {},
	    setSetting: {},
	    getSetting: {},
	    getValidSessionId: {},
	    /**
	     * Error stuff
	     */
	    getErrors: {},
	    /**
	     * Tested
	     */
	    getTestResults: {},
	    /**
	     * Project Service
	     */
	    getCompletionsAtPosition: {},
	    getCompletionEntryDetails: {},
	    quickInfo: {},
	    getRenameInfo: {},
	    getDefinitionsAtPosition: {},
	    getReferences: {},
	    getDoctorInfo: {},
	    formatDocument: {},
	    formatDocumentRange: {},
	    getNavigateToItems: {},
	    getNavigateToItemsForFilePath: {},
	    getDependencies: {},
	    getAST: {},
	    getQuickFixes: {},
	    applyQuickFix: {},
	    getSemanticTree: {},
	    getOccurrencesAtPosition: {},
	    getFormattingEditsAfterKeystroke: {},
	    removeUnusedImports: {},
	    /**
	     * Documentation Browser
	     */
	    getTopLevelModuleNames: {},
	    getUpdatedModuleInformation: {},
	    /** UML Diagram */
	    getUmlDiagramForFile: {},
	    /** tsFlow */
	    getFlowRoots: {},
	    /** live analysis */
	    getLiveAnalysis: {},
	    /**
	     * Output Status
	     */
	    getCompleteOutputStatusCache: {},
	    getLiveBuildResults: {},
	    build: {},
	    getJSOutputStatus: {},
	    /**
	     * Live demo
	     */
	    enableLiveDemo: {},
	    disableLiveDemo: {},
	    enableLiveDemoReact: {},
	    disableLiveDemoReact: {},
	    /**
	     * Git service
	     */
	    gitStatus: {},
	    gitReset: {},
	    gitDiff: {},
	    gitAddAllCommitAndPush: {},
	    gitFetchLatestAndRebase: {},
	    /**
	     * NPM Service
	     */
	    npmLatest: {},
	    /**
	     * FARM
	     */
	    startFarming: {},
	    stopFarmingIfRunning: {},
	    farmResults: {},
	    /**
	     * Config creator
	     */
	    createEditorconfig: {},
	    /**
	     * Settings
	     */
	    getSettingsFilePath: {},
	    /**
	     * Server Disk Service
	     */
	    getDirItems: {},
	};
	exports.client = {
	    increment: {},
	};
	exports.cast = {
	    /** for testing */
	    hello: new socketLib_1.TypedEvent(),
	    /** If the file worker notices a change */
	    filePathsUpdated: new socketLib_1.TypedEvent(),
	    /** If an open and already saved file changes on disk  */
	    savedFileChangedOnDisk: new socketLib_1.TypedEvent(),
	    /** If a user does a code edit */
	    didEdits: new socketLib_1.TypedEvent(),
	    /** If any of the file status changes */
	    didStatusChange: new socketLib_1.TypedEvent(),
	    /** If file editor options change */
	    editorOptionsChanged: new socketLib_1.TypedEvent(),
	    /** Errors for a file path */
	    errorsDelta: new socketLib_1.TypedEvent(),
	    /** Tested */
	    testResultsDelta: new socketLib_1.TypedEvent(),
	    testedWorking: new socketLib_1.TypedEvent(),
	    /** TS analysis taking place */
	    tsWorking: new socketLib_1.TypedEvent(),
	    /** Available projects updated */
	    availableProjectsUpdated: new socketLib_1.TypedEvent(),
	    /** Active project name updated */
	    activeProjectConfigDetailsUpdated: new socketLib_1.TypedEvent(),
	    /** Active project files */
	    activeProjectFilePathsUpdated: new socketLib_1.TypedEvent(),
	    /** FARM */
	    farmResultsUpdated: new socketLib_1.TypedEvent(),
	    /** JS Ouput status  */
	    fileOutputStatusUpdated: new socketLib_1.TypedEvent(),
	    completeOutputStatusCacheUpdated: new socketLib_1.TypedEvent(),
	    liveBuildResults: new socketLib_1.TypedEvent(),
	    /** Live demo */
	    liveDemoData: new socketLib_1.TypedEvent(),
	    liveDemoBuildComplete: new socketLib_1.TypedEvent(),
	    /** Server quit */
	    serverExiting: new socketLib_1.TypedEvent(),
	};
	/**
	 * General utility interfaces
	 */
	var Types;
	(function (Types) {
	    /**
	     * AST View
	     */
	    var ASTMode;
	    (function (ASTMode) {
	        /** ts.forEachChild() */
	        ASTMode[ASTMode["visitor"] = 0] = "visitor";
	        /** node.getChildren() */
	        ASTMode[ASTMode["children"] = 1] = "children";
	    })(ASTMode = Types.ASTMode || (Types.ASTMode = {}));
	})(Types = exports.Types || (exports.Types = {}));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	// This code is designed to be used by both the server and the client
	// Very similar to workerlib but designed to work with socket.io
	// The client is the requestor (hence parent like) and the server is the responder (hence child like)
	// client == parent
	// server == child
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Allcast and Broadcast both come through as a message of the following type
	 */
	exports.anycastMessageName = 'anycast';
	__export(__webpack_require__(19));
	/** Creates a Guid (UUID v4) */
	function createId() {
	    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
	        return v.toString(16);
	    });
	}
	var RequesterResponder = /** @class */ (function () {
	    function RequesterResponder() {
	        var _this = this;
	        ///////////////////////////////// REQUESTOR /////////////////////////
	        this.currentListeners = {};
	        /** Only relevant when we only want the last of this type */
	        this.currentLastOfType = {};
	        this.pendingRequests = Object.create(null);
	        this.pendingRequestsChanged = function (pending) { return null; };
	        this.sendToServerHeart = function (data, message) {
	            // If we don't have a server exit
	            if (!_this.getSocket()) {
	                console.log('SEND ERR: no server when you tried to send :', message);
	                return Promise.reject(new Error("No socket active to recieve message: " + message));
	            }
	            // Initialize if this is the first call of this type
	            if (!_this.currentListeners[message])
	                _this.currentListeners[message] = {};
	            // Create an id unique to this call and store the defered against it
	            var id = createId();
	            var promise = new Promise(function (resolve, reject) {
	                _this.currentListeners[message][id] = { resolve: resolve, reject: reject, promise: promise };
	            });
	            // Send data to worker
	            _this.pendingRequests[id] = message;
	            _this.pendingRequestsChanged(Object.keys(_this.pendingRequests).map(function (k) { return _this.pendingRequests[k]; }));
	            _this.getSocket().emit('message', { message: message, id: id, data: data, isRequest: true });
	            return promise;
	        };
	        this.responders = {};
	        this.processRequest = function (m) {
	            var parsed = m;
	            if (!parsed.message || !_this.responders[parsed.message]) {
	                // TODO: handle this error scenario. Either the message is invalid or we do not have a registered responder
	                return;
	            }
	            var message = parsed.message;
	            var responsePromise;
	            try {
	                responsePromise = _this.responders[message](parsed.data, _this.client);
	            }
	            catch (err) {
	                responsePromise = Promise.reject({ method: message, message: err.message, stack: err.stack, details: err.details || {} });
	            }
	            responsePromise
	                .then(function (response) {
	                _this.getSocket().emit('message', {
	                    message: message,
	                    /** Note: to process a request we just pass the id as we recieve it */
	                    id: parsed.id,
	                    data: response,
	                    error: null,
	                    isRequest: false
	                });
	            })
	                .catch(function (error) {
	                _this.getSocket().emit('message', {
	                    message: message,
	                    /** Note: to process a request we just pass the id as we recieve it */
	                    id: parsed.id,
	                    data: null,
	                    error: error,
	                    isRequest: false
	                });
	            });
	        };
	    }
	    RequesterResponder.prototype.startListening = function () {
	        var _this = this;
	        try {
	            if (!this.getSocket()) {
	                console.log('You started listening without a socket!');
	                return;
	            }
	            var socket = this.getSocket();
	            socket.on('error', function (err) {
	            });
	            socket.on('message', function (message) {
	                if (message.isRequest) {
	                    _this.processRequest(message);
	                }
	                else {
	                    _this.processResponse(message);
	                }
	            });
	        }
	        catch (err) {
	            console.log('Socket : terminal error in listening', err);
	        }
	    };
	    /** process a message from the server */
	    RequesterResponder.prototype.processResponse = function (m) {
	        var _this = this;
	        var parsed = m;
	        if (!parsed.message || !parsed.id) {
	            console.log('SERVER ERR: Invalid JSON data from server:', m);
	        }
	        else if (!this.currentListeners[parsed.message] || !this.currentListeners[parsed.message][parsed.id]) {
	            console.log('SERVER ERR: No one was listening:', parsed.message, parsed.data);
	        }
	        else {
	            delete this.pendingRequests[parsed.id];
	            this.pendingRequestsChanged(Object.keys(this.pendingRequests).map(function (k) { return _this.pendingRequests[k]; }));
	            if (parsed.error) {
	                this.currentListeners[parsed.message][parsed.id].reject(parsed.error);
	                console.log(parsed.error);
	                console.log(parsed.error.stack);
	            }
	            else {
	                this.currentListeners[parsed.message][parsed.id].resolve(parsed.data);
	            }
	            delete this.currentListeners[parsed.message][parsed.id];
	            // If there is current last one queued then that needs to be resurrected
	            if (this.currentLastOfType[parsed.message]) {
	                var last_1 = this.currentLastOfType[parsed.message];
	                delete this.currentLastOfType[parsed.message];
	                var lastPromise = this.sendToServerHeart(last_1.data, parsed.message);
	                lastPromise.then(function (res) { return last_1.defer.resolve(res); }, function (rej) { return last_1.defer.reject(rej); });
	            }
	        }
	    };
	    /**
	     * Send all the member functions to IPC
	     */
	    RequesterResponder.prototype.sendAllToSocket = function (contract) {
	        var _this = this;
	        var toret = {};
	        Object.keys(contract).forEach(function (key) {
	            toret[key] = _this.sendToSocket(contract[key], key);
	        });
	        return toret;
	    };
	    /**
	     * Takes a sync named function
	     * and returns a function that will execute this function by name using IPC
	     * (will only work if the process on the other side has this function as a registered responder)
	     */
	    RequesterResponder.prototype.sendToSocket = function (func, name) {
	        var _this = this;
	        var message = name;
	        return function (data) { return _this.sendToServerHeart(data, message); };
	    };
	    /**
	     * If there are more than one pending then we only want the last one as they come in.
	     * All others will get the default value
	     */
	    RequesterResponder.prototype.sendToSocketOnlyLast = function (func, defaultResponse, name) {
	        var _this = this;
	        return function (data) {
	            var message = name;
	            // If we don't have a child exit
	            if (!_this.getSocket()) {
	                console.log('SEND ERR: no socket when you tried to send :', message);
	                return Promise.reject(new Error("No worker active to recieve message: " + message));
	            }
	            // Allow if this is the only call of this type
	            if (!Object.keys(_this.currentListeners[message] || {}).length) {
	                return _this.sendToServerHeart(data, message);
	            }
	            else {
	                // Note:
	                // The last needs to continue once the current one finishes
	                // That is done in our response handler
	                // If there is already something queued as last.
	                // Then it is no longer last and needs to be fed a default value
	                if (_this.currentLastOfType[message]) {
	                    _this.currentLastOfType[message].defer.resolve(defaultResponse);
	                }
	                // this needs to be the new last
	                var promise_1 = new Promise(function (resolve, reject) {
	                    _this.currentLastOfType[message] = {
	                        data: data,
	                        defer: { promise: promise_1, resolve: resolve, reject: reject }
	                    };
	                });
	                return promise_1;
	            }
	        };
	    };
	    RequesterResponder.prototype.addToResponders = function (func, name) {
	        this.responders[name] = func;
	    };
	    RequesterResponder.prototype.registerAllFunctionsExportedFromAsResponders = function (aModule) {
	        var _this = this;
	        Object.keys(aModule)
	            .filter(function (funcName) { return typeof aModule[funcName] == 'function'; })
	            .forEach(function (funcName) { return _this.addToResponders(aModule[funcName], funcName); });
	    };
	    return RequesterResponder;
	}());
	exports.RequesterResponder = RequesterResponder;


/***/ },
/* 166 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = ((uint8[i] << 16) & 0xFF0000) + ((uint8[i + 1] << 8) & 0xFF00) + (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var ts = __webpack_require__(150);
	module.exports = ts;
	if (typeof global !== 'undefined') {
	    global.ts = ts;
	}
	if (typeof window !== 'undefined') {
	    window.ts = ts;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 169 */
/***/ function(module, exports) {

	/*!
	 * clipboard.js v1.7.1
	 * https://zenorocha.github.io/clipboard.js
	 *
	 * Licensed MIT © Zeno Rocha
	 */
	!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.Clipboard=t()}}(function(){var t,e,n;return function t(e,n,o){function i(a,c){if(!n[a]){if(!e[a]){var l="function"==typeof require&&require;if(!c&&l)return l(a,!0);if(r)return r(a,!0);var s=new Error("Cannot find module '"+a+"'");throw s.code="MODULE_NOT_FOUND",s}var u=n[a]={exports:{}};e[a][0].call(u.exports,function(t){var n=e[a][1][t];return i(n||t)},u,u.exports,t,e,n,o)}return n[a].exports}for(var r="function"==typeof require&&require,a=0;a<o.length;a++)i(o[a]);return i}({1:[function(t,e,n){function o(t,e){for(;t&&t.nodeType!==i;){if("function"==typeof t.matches&&t.matches(e))return t;t=t.parentNode}}var i=9;if("undefined"!=typeof Element&&!Element.prototype.matches){var r=Element.prototype;r.matches=r.matchesSelector||r.mozMatchesSelector||r.msMatchesSelector||r.oMatchesSelector||r.webkitMatchesSelector}e.exports=o},{}],2:[function(t,e,n){function o(t,e,n,o,r){var a=i.apply(this,arguments);return t.addEventListener(n,a,r),{destroy:function(){t.removeEventListener(n,a,r)}}}function i(t,e,n,o){return function(n){n.delegateTarget=r(n.target,e),n.delegateTarget&&o.call(t,n)}}var r=t("./closest");e.exports=o},{"./closest":1}],3:[function(t,e,n){n.node=function(t){return void 0!==t&&t instanceof HTMLElement&&1===t.nodeType},n.nodeList=function(t){var e=Object.prototype.toString.call(t);return void 0!==t&&("[object NodeList]"===e||"[object HTMLCollection]"===e)&&"length"in t&&(0===t.length||n.node(t[0]))},n.string=function(t){return"string"==typeof t||t instanceof String},n.fn=function(t){return"[object Function]"===Object.prototype.toString.call(t)}},{}],4:[function(t,e,n){function o(t,e,n){if(!t&&!e&&!n)throw new Error("Missing required arguments");if(!c.string(e))throw new TypeError("Second argument must be a String");if(!c.fn(n))throw new TypeError("Third argument must be a Function");if(c.node(t))return i(t,e,n);if(c.nodeList(t))return r(t,e,n);if(c.string(t))return a(t,e,n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}function i(t,e,n){return t.addEventListener(e,n),{destroy:function(){t.removeEventListener(e,n)}}}function r(t,e,n){return Array.prototype.forEach.call(t,function(t){t.addEventListener(e,n)}),{destroy:function(){Array.prototype.forEach.call(t,function(t){t.removeEventListener(e,n)})}}}function a(t,e,n){return l(document.body,t,e,n)}var c=t("./is"),l=t("delegate");e.exports=o},{"./is":3,delegate:2}],5:[function(t,e,n){function o(t){var e;if("SELECT"===t.nodeName)t.focus(),e=t.value;else if("INPUT"===t.nodeName||"TEXTAREA"===t.nodeName){var n=t.hasAttribute("readonly");n||t.setAttribute("readonly",""),t.select(),t.setSelectionRange(0,t.value.length),n||t.removeAttribute("readonly"),e=t.value}else{t.hasAttribute("contenteditable")&&t.focus();var o=window.getSelection(),i=document.createRange();i.selectNodeContents(t),o.removeAllRanges(),o.addRange(i),e=o.toString()}return e}e.exports=o},{}],6:[function(t,e,n){function o(){}o.prototype={on:function(t,e,n){var o=this.e||(this.e={});return(o[t]||(o[t]=[])).push({fn:e,ctx:n}),this},once:function(t,e,n){function o(){i.off(t,o),e.apply(n,arguments)}var i=this;return o._=e,this.on(t,o,n)},emit:function(t){var e=[].slice.call(arguments,1),n=((this.e||(this.e={}))[t]||[]).slice(),o=0,i=n.length;for(o;o<i;o++)n[o].fn.apply(n[o].ctx,e);return this},off:function(t,e){var n=this.e||(this.e={}),o=n[t],i=[];if(o&&e)for(var r=0,a=o.length;r<a;r++)o[r].fn!==e&&o[r].fn._!==e&&i.push(o[r]);return i.length?n[t]=i:delete n[t],this}},e.exports=o},{}],7:[function(e,n,o){!function(i,r){if("function"==typeof t&&t.amd)t(["module","select"],r);else if(void 0!==o)r(n,e("select"));else{var a={exports:{}};r(a,i.select),i.clipboardAction=a.exports}}(this,function(t,e){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var i=n(e),r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),c=function(){function t(e){o(this,t),this.resolveOptions(e),this.initSelection()}return a(t,[{key:"resolveOptions",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action=e.action,this.container=e.container,this.emitter=e.emitter,this.target=e.target,this.text=e.text,this.trigger=e.trigger,this.selectedText=""}},{key:"initSelection",value:function t(){this.text?this.selectFake():this.target&&this.selectTarget()}},{key:"selectFake",value:function t(){var e=this,n="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return e.removeFake()},this.fakeHandler=this.container.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[n?"right":"left"]="-9999px";var o=window.pageYOffset||document.documentElement.scrollTop;this.fakeElem.style.top=o+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,this.container.appendChild(this.fakeElem),this.selectedText=(0,i.default)(this.fakeElem),this.copyText()}},{key:"removeFake",value:function t(){this.fakeHandler&&(this.container.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(this.container.removeChild(this.fakeElem),this.fakeElem=null)}},{key:"selectTarget",value:function t(){this.selectedText=(0,i.default)(this.target),this.copyText()}},{key:"copyText",value:function t(){var e=void 0;try{e=document.execCommand(this.action)}catch(t){e=!1}this.handleResult(e)}},{key:"handleResult",value:function t(e){this.emitter.emit(e?"success":"error",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})}},{key:"clearSelection",value:function t(){this.trigger&&this.trigger.focus(),window.getSelection().removeAllRanges()}},{key:"destroy",value:function t(){this.removeFake()}},{key:"action",set:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"copy";if(this._action=e,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function t(){return this._action}},{key:"target",set:function t(e){if(void 0!==e){if(!e||"object"!==(void 0===e?"undefined":r(e))||1!==e.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&e.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(e.hasAttribute("readonly")||e.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=e}},get:function t(){return this._target}}]),t}();t.exports=c})},{select:5}],8:[function(e,n,o){!function(i,r){if("function"==typeof t&&t.amd)t(["module","./clipboard-action","tiny-emitter","good-listener"],r);else if(void 0!==o)r(n,e("./clipboard-action"),e("tiny-emitter"),e("good-listener"));else{var a={exports:{}};r(a,i.clipboardAction,i.tinyEmitter,i.goodListener),i.clipboard=a.exports}}(this,function(t,e,n,o){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function l(t,e){var n="data-clipboard-"+t;if(e.hasAttribute(n))return e.getAttribute(n)}var s=i(e),u=i(n),f=i(o),d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},h=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),p=function(t){function e(t,n){r(this,e);var o=a(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return o.resolveOptions(n),o.listenClick(t),o}return c(e,t),h(e,[{key:"resolveOptions",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof e.action?e.action:this.defaultAction,this.target="function"==typeof e.target?e.target:this.defaultTarget,this.text="function"==typeof e.text?e.text:this.defaultText,this.container="object"===d(e.container)?e.container:document.body}},{key:"listenClick",value:function t(e){var n=this;this.listener=(0,f.default)(e,"click",function(t){return n.onClick(t)})}},{key:"onClick",value:function t(e){var n=e.delegateTarget||e.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new s.default({action:this.action(n),target:this.target(n),text:this.text(n),container:this.container,trigger:n,emitter:this})}},{key:"defaultAction",value:function t(e){return l("action",e)}},{key:"defaultTarget",value:function t(e){var n=l("target",e);if(n)return document.querySelector(n)}},{key:"defaultText",value:function t(e){return l("text",e)}},{key:"destroy",value:function t(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)}}],[{key:"isSupported",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["copy","cut"],n="string"==typeof e?[e]:e,o=!!document.queryCommandSupported;return n.forEach(function(t){o=o&&!!document.queryCommandSupported(t)}),o}}]),e}(u.default);t.exports=p})},{"./clipboard-action":7,"good-listener":4,"tiny-emitter":6}]},{},[8])(8)});

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var emptyObject = __webpack_require__(42);
	var _invariant = __webpack_require__(4);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(89)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(176)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(89)
	
	exports.createHmac = __webpack_require__(171)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(175)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createCipher'
	, 'createCipheriv'
	, 'createDecipher'
	, 'createDecipheriv'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(172);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(243)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(475)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(25).Buffer))

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(382) + ");src:url(" + __webpack_require__(381) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(385) + ") format(\"woff2\"),url(" + __webpack_require__(386) + ") format(\"woff\"),url(" + __webpack_require__(384) + ") format(\"truetype\"),url(" + __webpack_require__(383) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);
	
	// exports


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".lm_root{position:relative}.lm_row>.lm_item{float:left}.lm_content{overflow:hidden;position:relative}.lm_dragging,.lm_dragging *{cursor:move!important;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.lm_maximised{position:absolute;left:0;top:0;z-index:40}.lm_maximise_placeholder{display:none}.lm_splitter{position:relative;z-index:20}.lm_splitter.lm_dragging,.lm_splitter:hover{background:orange}.lm_splitter.lm_vertical .lm_drag_handle{position:absolute;height:25px;top:-10px;cursor:n-resize;width:100%}.lm_splitter.lm_horizontal{height:100%;float:left}.lm_splitter.lm_horizontal .lm_drag_handle{position:absolute;width:25px;left:-10px;cursor:e-resize;height:100%}.lm_header{position:relative;overflow:visible}.lm_header [class^=lm_]{box-sizing:content-box!important}.lm_header>ul{list-style-type:none;margin:0;padding:0}.lm_header .lm_controls{right:3px;position:absolute}.lm_header .lm_controls>li{width:18px;height:18px;float:left;text-align:center;cursor:pointer}.lm_header .lm_tabs{position:absolute}.lm_header .lm_tab{float:left;padding:0 10px 5px;height:14px;margin-top:1px;cursor:pointer;position:relative;padding-right:25px}.lm_header .lm_tab i{height:19px;width:2px;position:absolute}.lm_header .lm_tab i.lm_left{left:-2px;top:0}.lm_header .lm_tab i.lm_right{right:-2px;top:0}.lm_header .lm_tab .lm_title{text-overflow:ellipsis;display:inline-block;overflow:hidden}.lm_header .lm_tab .lm_close_tab{position:absolute;right:0;top:0;width:14px;height:14px;text-align:center}.lm_drop_tab_placeholder{width:100px;height:10px;float:left;visibility:hidden}.lm_dragProxy{position:absolute;z-index:30;top:0;left:0}.lm_dragProxy .lm_header{background:transparent}.lm_dragProxy .lm_content{border-top:none;overflow:hidden}.lm_dropTargetIndicator{position:absolute;z-index:20;display:none}.lm_dropTargetIndicator .lm_inner{position:relative;width:100%;height:100%;left:0;top:0}.lm_transition_indicator{top:0;left:0;display:none;z-index:20}.lm_popin,.lm_transition_indicator{position:absolute;width:20px;height:20px}.lm_popin{z-index:9999;bottom:0;right:0}.lm_popin>*{position:absolute;left:0;top:0;width:100%;height:100%}.lm_popin>.lm_bg{z-index:10}.lm_popin>.lm_icon{z-index:20}", ""]);
	
	// exports


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".lm_goldenlayout{background:#000}.lm_content{background:#222}.lm_dragProxy .lm_content{box-shadow:2px 2px 4px rgba(0,0,0,.9)}.lm_dropTargetIndicator{box-shadow:inset 0 0 30px #000;outline:1px dashed #ccc;transition:all .2s ease}.lm_dropTargetIndicator .lm_inner{background:#000;opacity:.2;filter:alpha(opacity=40)}.lm_splitter{background:#000;opacity:.001;transition:opacity .2s ease}.lm_splitter.lm_dragging,.lm_splitter:hover{opacity:1;background:#444}.lm_header{height:20px;-webkit-user-select:none;-moz-user-select:none;-o-user-select:none;-ms-user-select:none;user-select:none}.lm_header.lm_selectable{cursor:pointer}.lm_selected .lm_header{background-color:#452500}.lm_maximised .lm_header{background-color:#000}.lm_header .lm_tab{background:#111;color:#999;font-size:12px;padding-top:2px;padding-bottom:2px;font-family:Arial,sans-serif;margin-right:2px;box-shadow:2px -2px 2px rgba(0,0,0,.3)}.lm_tab.lm_active,.lm_tab:hover{color:#ddd;background:#222}.lm_header .lm_tab.lm_active{padding-bottom:3px;border-bottom:none;box-shadow:0 -2px 2px #000}.lm_header .lm_tab .lm_close_tab{background-position:50%;opacity:.4;filter:alpha(opacity=40);background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFQ0EwQjYyQ0YzOUExMUUzODEzRUM2RjIwMjQwNUVGMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFQ0EwQjYyREYzOUExMUUzODEzRUM2RjIwMjQwNUVGMyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkVDQTBCNjJBRjM5QTExRTM4MTNFQzZGMjAyNDA1RUYzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVDQTBCNjJCRjM5QTExRTM4MTNFQzZGMjAyNDA1RUYzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+71iVHAAAAE5JREFUeNpsTQkKwDAIS6Uf8P9/1CdkKtp1MCFqDgjMjAGQ/CB1AbACdHfMxM/Ud/MJ1G0OUVXcgTHKzNUBXoHSVpZPB94pLj/GqXgEGAC1mzL201rjRgAAAABJRU5ErkJggg==);width:11px;height:11px;right:6px;top:4px;background-repeat:no-repeat}.lm_header .lm_tab.lm_active .lm_close_tab,.lm_header .lm_tab .lm_close_tab:hover{opacity:1;filter:alpha(opacity=100)}.lm_controls>li{background-position:50%;background-repeat:no-repeat;position:relative;opacity:.4;filter:alpha(opacity=40);transition:opacity .3s ease}.lm_controls>li:hover{opacity:1;filter:alpha(opacity=100)}.lm_controls .lm_popout{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjOWFlODE3Zi0zMjcxLWJkNDItOTY0Mi03MDJiZjVkNGJmOWEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDlDNzcyMkJGQjYyMTFFM0IzQUE4RkIyQzNDRDI0MDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDlDNzcyMkFGQjYyMTFFM0IzQUE4RkIyQzNDRDI0MDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmM5YWU4MTdmLTMyNzEtYmQ0Mi05NjQyLTcwMmJmNWQ0YmY5YSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpjOWFlODE3Zi0zMjcxLWJkNDItOTY0Mi03MDJiZjVkNGJmOWEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5u9IgFAAAAPElEQVR42mL8//8/AxTAGeiABY3PiEXNfyYGIgALmjX/sZnMgs8aGIOQdf+xOZwBm3VEOxxvGIEAQIABAAoJChZkbRwFAAAAAElFTkSuQmCC)}.lm_controls .lm_maximise{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjOWFlODE3Zi0zMjcxLWJkNDItOTY0Mi03MDJiZjVkNGJmOWEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDlDQ0YxNUVGQjYyMTFFM0IzQUE4RkIyQzNDRDI0MDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDlDNzcyMzJGQjYyMTFFM0IzQUE4RkIyQzNDRDI0MDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmM5YWU4MTdmLTMyNzEtYmQ0Mi05NjQyLTcwMmJmNWQ0YmY5YSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpjOWFlODE3Zi0zMjcxLWJkNDItOTY0Mi03MDJiZjVkNGJmOWEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5DFX8LAAAAJklEQVR42mL8DwQMBAATAxGABUoz4lHznyiTBqMimO/whhVAgAEAMIEGEQk8OGQAAAAASUVORK5CYII=)}.lm_maximised .lm_controls .lm_maximise{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzdBOUM4MUQ0NzIyMTFFNDg0M0Q4OTQxQjVGRUFGQ0EiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzdBOUM4MUM0NzIyMTFFNDg0M0Q4OTQxQjVGRUFGQ0EiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkExRjEyNDM3RkI1RjExRTM4NkNCOTA5QTc5RjA3NEM3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkExRjEyNDM4RkI1RjExRTM4NkNCOTA5QTc5RjA3NEM3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+dG2ryAAAACdJREFUeNpi/P//PwMxgImBSDAyFbKAiFmzZuENzLS0NEaiTQQIMADdZQcTcyy94AAAAABJRU5ErkJggg==)}.lm_controls .lm_close{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjOWFlODE3Zi0zMjcxLWJkNDItOTY0Mi03MDJiZjVkNGJmOWEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDlDQ0YxNjZGQjYyMTFFM0IzQUE4RkIyQzNDRDI0MDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDlDQ0YxNjVGQjYyMTFFM0IzQUE4RkIyQzNDRDI0MDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmM5YWU4MTdmLTMyNzEtYmQ0Mi05NjQyLTcwMmJmNWQ0YmY5YSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpjOWFlODE3Zi0zMjcxLWJkNDItOTY0Mi03MDJiZjVkNGJmOWEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6rmsrNAAAAQ0lEQVR42nTOUQ4AMAQDUHr/O3dbIgtN+cMTTd6KiIy9iALcwNujGgf/B7RhhyMC5DoVOET3Gi6DQrgMCrGAAY8AAwDe6xQOLXhdxAAAAABJRU5ErkJggg==)}.lm_transition_indicator{background-color:#000;border:1px dashed #555}.lm_popin{cursor:pointer}.lm_popin .lm_bg{background:#fff;opacity:.3;filter:alpha(opacity=30)}.lm_popin .lm_icon{border-left:1px solid #eee;border-top:1px solid #eee;background-position:50%;background-repeat:no-repeat;opacity:.7;filter:alpha(opacity=70);background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAJCAYAAADpeqZqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxNTlCMjk5QzM3MUMxMUU0OTBFOUQ3QUI0Q0UzREQ0RSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxNTlCMjk5RDM3MUMxMUU0OTBFOUQ3QUI0Q0UzREQ0RSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjE1OUIyOTlBMzcxQzExRTQ5MEU5RDdBQjRDRTNERDRFIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjE1OUIyOTlCMzcxQzExRTQ5MEU5RDdBQjRDRTNERDRFIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+3fq+uQAAAFxJREFUeNqcjosJwCAMRBNxgey/YzLCacRADaJtH/jlnh6rKoiIRYQCMwMdqC70gR4c6zzzwUGZmxBewQBynaVqxrNDelwsgZ3sUvEph2/U28s7Cv0gfvpUsQkwAKQyLdc+L4T6AAAAAElFTkSuQmCC)}.lm_popin:hover .lm_icon{opacity:1;filter:alpha(opacity=100)}", ""]);
	
	// exports


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! Hint.css - v2.5.0 - 2017-04-23\n* http://kushagragour.in/lab/hint/\n* Copyright (c) 2017 Kushagra Gour */[class*=hint--]{position:relative;display:inline-block}[class*=hint--]:after,[class*=hint--]:before{position:absolute;transform:translateZ(0);visibility:hidden;opacity:0;z-index:1000000;pointer-events:none;transition:.3s ease;transition-delay:0ms}[class*=hint--]:hover:after,[class*=hint--]:hover:before{visibility:visible;opacity:1;transition-delay:.1s}[class*=hint--]:before{content:\"\";position:absolute;background:transparent;border:6px solid transparent;z-index:1000001}[class*=hint--]:after{background:#383838;color:#fff;padding:8px 10px;font-size:12px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;line-height:12px;white-space:nowrap}[class*=hint--][aria-label]:after{content:attr(aria-label)}[class*=hint--][data-hint]:after{content:attr(data-hint)}[aria-label=\"\"]:after,[aria-label=\"\"]:before,[data-hint=\"\"]:after,[data-hint=\"\"]:before{display:none!important}.hint--top-left:before,.hint--top-right:before,.hint--top:before{border-top-color:#383838}.hint--bottom-left:before,.hint--bottom-right:before,.hint--bottom:before{border-bottom-color:#383838}.hint--left:before{border-left-color:#383838}.hint--right:before{border-right-color:#383838}.hint--top:before{margin-bottom:-11px}.hint--top:after,.hint--top:before{bottom:100%;left:50%}.hint--top:before{left:calc(50% - 6px)}.hint--top:after{transform:translateX(-50%)}.hint--top:hover:before{transform:translateY(-8px)}.hint--top:hover:after{transform:translateX(-50%) translateY(-8px)}.hint--bottom:before{margin-top:-11px}.hint--bottom:after,.hint--bottom:before{top:100%;left:50%}.hint--bottom:before{left:calc(50% - 6px)}.hint--bottom:after{transform:translateX(-50%)}.hint--bottom:hover:before{transform:translateY(8px)}.hint--bottom:hover:after{transform:translateX(-50%) translateY(8px)}.hint--right:before{margin-left:-11px;margin-bottom:-6px}.hint--right:after{margin-bottom:-14px}.hint--right:after,.hint--right:before{left:100%;bottom:50%}.hint--right:hover:after,.hint--right:hover:before{transform:translateX(8px)}.hint--left:before{margin-right:-11px;margin-bottom:-6px}.hint--left:after{margin-bottom:-14px}.hint--left:after,.hint--left:before{right:100%;bottom:50%}.hint--left:hover:after,.hint--left:hover:before{transform:translateX(-8px)}.hint--top-left:before{margin-bottom:-11px}.hint--top-left:after,.hint--top-left:before{bottom:100%;left:50%}.hint--top-left:before{left:calc(50% - 6px)}.hint--top-left:after{transform:translateX(-100%);margin-left:12px}.hint--top-left:hover:before{transform:translateY(-8px)}.hint--top-left:hover:after{transform:translateX(-100%) translateY(-8px)}.hint--top-right:before{margin-bottom:-11px}.hint--top-right:after,.hint--top-right:before{bottom:100%;left:50%}.hint--top-right:before{left:calc(50% - 6px)}.hint--top-right:after{transform:translateX(0);margin-left:-12px}.hint--top-right:hover:after,.hint--top-right:hover:before{transform:translateY(-8px)}.hint--bottom-left:before{margin-top:-11px}.hint--bottom-left:after,.hint--bottom-left:before{top:100%;left:50%}.hint--bottom-left:before{left:calc(50% - 6px)}.hint--bottom-left:after{transform:translateX(-100%);margin-left:12px}.hint--bottom-left:hover:before{transform:translateY(8px)}.hint--bottom-left:hover:after{transform:translateX(-100%) translateY(8px)}.hint--bottom-right:before{margin-top:-11px}.hint--bottom-right:after,.hint--bottom-right:before{top:100%;left:50%}.hint--bottom-right:before{left:calc(50% - 6px)}.hint--bottom-right:after{transform:translateX(0);margin-left:-12px}.hint--bottom-right:hover:after,.hint--bottom-right:hover:before{transform:translateY(8px)}.hint--large:after,.hint--medium:after,.hint--small:after{white-space:normal;line-height:1.4em;word-wrap:break-word}.hint--small:after{width:80px}.hint--medium:after{width:150px}.hint--large:after{width:300px}[class*=hint--]:after{text-shadow:0 -1px 0 #000;box-shadow:4px 4px 8px rgba(0,0,0,.3)}.hint--error:after{background-color:#b34e4d;text-shadow:0 -1px 0 #592726}.hint--error.hint--top-left:before,.hint--error.hint--top-right:before,.hint--error.hint--top:before{border-top-color:#b34e4d}.hint--error.hint--bottom-left:before,.hint--error.hint--bottom-right:before,.hint--error.hint--bottom:before{border-bottom-color:#b34e4d}.hint--error.hint--left:before{border-left-color:#b34e4d}.hint--error.hint--right:before{border-right-color:#b34e4d}.hint--warning:after{background-color:#c09854;text-shadow:0 -1px 0 #6c5328}.hint--warning.hint--top-left:before,.hint--warning.hint--top-right:before,.hint--warning.hint--top:before{border-top-color:#c09854}.hint--warning.hint--bottom-left:before,.hint--warning.hint--bottom-right:before,.hint--warning.hint--bottom:before{border-bottom-color:#c09854}.hint--warning.hint--left:before{border-left-color:#c09854}.hint--warning.hint--right:before{border-right-color:#c09854}.hint--info:after{background-color:#3986ac;text-shadow:0 -1px 0 #1a3c4d}.hint--info.hint--top-left:before,.hint--info.hint--top-right:before,.hint--info.hint--top:before{border-top-color:#3986ac}.hint--info.hint--bottom-left:before,.hint--info.hint--bottom-right:before,.hint--info.hint--bottom:before{border-bottom-color:#3986ac}.hint--info.hint--left:before{border-left-color:#3986ac}.hint--info.hint--right:before{border-right-color:#3986ac}.hint--success:after{background-color:#458746;text-shadow:0 -1px 0 #1a321a}.hint--success.hint--top-left:before,.hint--success.hint--top-right:before,.hint--success.hint--top:before{border-top-color:#458746}.hint--success.hint--bottom-left:before,.hint--success.hint--bottom-right:before,.hint--success.hint--bottom:before{border-bottom-color:#458746}.hint--success.hint--left:before{border-left-color:#458746}.hint--success.hint--right:before{border-right-color:#458746}.hint--always:after,.hint--always:before{opacity:1;visibility:visible}.hint--always.hint--top:before{transform:translateY(-8px)}.hint--always.hint--top:after{transform:translateX(-50%) translateY(-8px)}.hint--always.hint--top-left:before{transform:translateY(-8px)}.hint--always.hint--top-left:after{transform:translateX(-100%) translateY(-8px)}.hint--always.hint--top-right:after,.hint--always.hint--top-right:before{transform:translateY(-8px)}.hint--always.hint--bottom:before{transform:translateY(8px)}.hint--always.hint--bottom:after{transform:translateX(-50%) translateY(8px)}.hint--always.hint--bottom-left:before{transform:translateY(8px)}.hint--always.hint--bottom-left:after{transform:translateX(-100%) translateY(8px)}.hint--always.hint--bottom-right:after,.hint--always.hint--bottom-right:before{transform:translateY(8px)}.hint--always.hint--left:after,.hint--always.hint--left:before{transform:translateX(-8px)}.hint--always.hint--right:after,.hint--always.hint--right:before{transform:translateX(8px)}.hint--rounded:after{border-radius:4px}.hint--no-animate:after,.hint--no-animate:before{transition-duration:0ms}.hint--bounce:after,.hint--bounce:before{transition:opacity .3s ease,visibility .3s ease,transform .3s cubic-bezier(.71,1.7,.77,1.24)}", ""]);
	
	// exports


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".ast-view{overflow-y:auto}.ast-view .node rect{cursor:pointer;fill:#fff;fill-opacity:.9;stroke:#000;stroke-width:1.5px}.ast-view .node text{font:11px sans-serif;font-weight:700;pointer-events:none;fill:#fff}.ast-view path.link{fill:none;stroke:#9ecae1;stroke-width:1.5px}", ""]);
	
	// exports


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".dependency-view{overflow-y:auto;background-color:#fff}.dependency-view .link{fill:none;stroke:#666;stroke-width:1.5px;opacity:.5;transition-property:opacity;transition-duration:.2s}.dependency-view .link.incomming{stroke:green;opacity:.9}.dependency-view .link.outgoing{stroke:red;opacity:.9}.dependency-view .link.dimmed{opacity:.05}.dependency-view .link.filtered-out{opacity:0}.dependency-view #licensing{fill:green}.dependency-view circle{fill:#ccc;stroke:#333;stroke-width:1.5px;transition-property:opacity,fill;transition-duration:.2s;opacity:1}.dependency-view circle.inonly{fill:green}.dependency-view circle.outonly{fill:blue}.dependency-view circle.circular{fill:red}.dependency-view circle.hovering{opacity:1;fill:#b94431}.dependency-view circle.not-hovering{opacity:.05}.dependency-view circle.filtered-out{opacity:0}.dependency-view text{font:10px sans-serif;pointer-events:none;text-shadow:0 1px 0 #fff,1px 0 0 #fff,0 -1px 0 #fff,-1px 0 0 #fff}.dependency-view text.dimmed{opacity:.05}.dependency-view text.filtered-out{opacity:0}.dependency-view g.dimmed{stroke-opacity:.05}.dependency-view .control-zoom{position:absolute;top:10px;left:10px;background:rgba(0,0,0,.25);padding:5px;border-radius:7px;z-index:100;display:inline-block}.dependency-view .control-zoom a{background:hsla(0,0%,100%,.75);background-position:50% 50%;background-repeat:no-repeat;display:block;width:19px;height:19px;border-radius:4px}.dependency-view .control-zoom a:last-child{margin:0}.dependency-view .control-zoom a:hover{background-color:#fff}.dependency-view .control-zoom>.control-zoom-in{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkUwRTZCRkI3NjQzNzExRTBBQUI3RTAwMUU2MTZDRkQ5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkUwRTZCRkI4NjQzNzExRTBBQUI3RTAwMUU2MTZDRkQ5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTBFNkJGQjU2NDM3MTFFMEFBQjdFMDAxRTYxNkNGRDkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTBFNkJGQjY2NDM3MTFFMEFBQjdFMDAxRTYxNkNGRDkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7cwPMXAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAARSURBVAhbY3jcwABBcAATAQBxlwhT4XiahwAAAABJRU5ErkJggg==);margin-bottom:5px}.dependency-view .control-zoom>.control-zoom-out{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU5MjRDMEQ5NjQzNzExRTBCM0JDQkU2MzVGQTBCNjRDIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU5MjRDMERBNjQzNzExRTBCM0JDQkU2MzVGQTBCNjRDIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTkyNEMwRDc2NDM3MTFFMEIzQkNCRTYzNUZBMEI2NEMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTkyNEMwRDg2NDM3MTFFMEIzQkNCRTYzNUZBMEI2NEMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7uh53jAAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlP/AOW3MEoAAAARSURBVAhbY/jfwABBcAATAQB6xwj7vHGbwAAAAABJRU5ErkJggg==);margin-bottom:5px}.dependency-view .control-zoom>.control-fit{text-decoration:none}.dependency-view .control-zoom>.control-fit:before{content:\"\\F0B2\";font:normal normal normal 10px/1 FontAwesome;font-size:inherit;color:rgba(0,0,0,.75);margin-left:3px}", ""]);
	
	// exports


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);
	
	// exports


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-toggle{display:inline-block;position:relative;cursor:pointer;background-color:transparent;border:0;padding:0;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent}.react-toggle-screenreader-only{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.react-toggle--disabled{opacity:.5;transition:opacity .25s}.react-toggle-track{width:50px;height:24px;padding:0;border-radius:30px;background-color:#4d4d4d;transition:all .2s ease}.react-toggle:hover .react-toggle-track{background-color:#000}.react-toggle--checked .react-toggle-track{background-color:#19ab27}.react-toggle.react-toggle--checked:hover .react-toggle-track{background-color:#128d15}.react-toggle-track-check{position:absolute;width:14px;height:10px;top:0;bottom:0;margin-top:auto;margin-bottom:auto;line-height:0;left:8px;opacity:0;transition:opacity .25s ease}.react-toggle--checked .react-toggle-track-check,.react-toggle-track-x{opacity:1;transition:opacity .25s ease}.react-toggle-track-x{position:absolute;width:10px;height:10px;top:0;bottom:0;margin-top:auto;margin-bottom:auto;line-height:0;right:10px}.react-toggle--checked .react-toggle-track-x{opacity:0}.react-toggle-thumb{transition:all .5s cubic-bezier(.23,1,.32,1) 0ms;position:absolute;top:1px;left:1px;width:22px;height:22px;border:1px solid #4d4d4d;border-radius:50%;background-color:#fafafa;box-sizing:border-box;transition:all .25s ease}.react-toggle--checked .react-toggle-thumb{left:27px;border-color:#19ab27}.react-toggle--focus .react-toggle-thumb{box-shadow:0 0 2px 3px #0099e0}.react-toggle:active .react-toggle-thumb{box-shadow:0 0 5px 5px #0099e0}", ""]);
	
	// exports


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80);line-height:1}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}.rtl .toast-close-button{left:-.3em;float:left;right:.3em}button.toast-close-button{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.toast-top-center{top:0;right:0;width:100%}.toast-bottom-center{bottom:0;right:0;width:100%}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{position:fixed;z-index:999999;pointer-events:none}#toast-container *{box-sizing:border-box}#toast-container>div{position:relative;pointer-events:auto;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;border-radius:3px 3px 3px 3px;background-position:15px;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>div.rtl{direction:rtl;padding:15px 50px 15px 15px;background-position:right 15px center}#toast-container>div:hover{box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=\")!important}#toast-container>.toast-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=\")!important}#toast-container>.toast-success{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==\")!important}#toast-container>.toast-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=\")!important}#toast-container.toast-bottom-center>div,#toast-container.toast-top-center>div{width:300px;margin-left:auto;margin-right:auto}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin-left:auto;margin-right:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info{background-color:#2f96b4}.toast-warning{background-color:#f89406}.toast-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}@media (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container>div.rtl{padding:8px 50px 8px 8px}#toast-container .toast-close-button{right:-.2em;top:-.2em}#toast-container .rtl .toast-close-button{left:-.2em;right:.2em}}@media (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container>div.rtl{padding:8px 50px 8px 8px}#toast-container .toast-close-button{right:-.2em;top:-.2em}#toast-container .rtl .toast-close-button{left:-.2em;right:.2em}}@media (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}#toast-container>div.rtl{padding:15px 50px 15px 15px}}", ""]);
	
	// exports


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Viewer.js v0.4.0\n * https://github.com/fengyuanchen/viewerjs\n *\n * Copyright (c) 2015-2016 Fengyuan Chen\n * Released under the MIT license\n *\n * Date: 2016-03-20T07:17:50.179Z\n */.viewer-close:before,.viewer-flip-horizontal:before,.viewer-flip-vertical:before,.viewer-fullscreen-exit:before,.viewer-fullscreen:before,.viewer-next:before,.viewer-one-to-one:before,.viewer-play:before,.viewer-prev:before,.viewer-reset:before,.viewer-rotate-left:before,.viewer-rotate-right:before,.viewer-zoom-in:before,.viewer-zoom-out:before{font-size:0;line-height:0;display:block;width:20px;height:20px;color:transparent;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAAAUCAYAAABWOyJDAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAQPSURBVHic7Zs/iFxVFMa/0U2UaJGksUgnIVhYxVhpjDbZCBmLdAYECxsRFBTUamcXUiSNncgKQbSxsxH8gzAP3FU2jY0kKKJNiiiIghFlccnP4p3nPCdv3p9778vsLOcHB2bfveeb7955c3jvvNkBIMdxnD64a94GHMfZu3iBcRynN7zAOI7TG15gHCeeNUkr8zaxG2lbYDYsdgMbktBsP03jdQwljSXdtBhLOmtjowC9Mg9L+knSlcD8TNKpSA9lBpK2JF2VdDSR5n5J64m0qli399hNFMUlpshQii5jbXTbHGviB0nLNeNDSd9VO4A2UdB2fp+x0eCnaXxWXGA2X0au/3HgN9P4LFCjIANOJdrLr0zzZ+BEpNYDwKbpnQMeAw4m8HjQtM6Z9qa917zPQwFr3M5KgA6J5rTJCdFZJj9/lyvGhsDvwFNVuV2MhhjrK6b9bFiE+j1r87eBl4HDwCF7/U/k+ofAX5b/EXBv5JoLMuILzf3Ap6Z3EzgdqHMCuF7hcQf4HDgeoHnccncqdK/TvSDWffFXI/exICY/xZyqc6XLWF1UFZna4gJ7q8BsRvgd2/xXpo6P+D9dfT7PpECtA3cnWPM0GXGFZh/wgWltA+cDNC7X+AP4GzjZQe+k5dRxuYPeiuXU7e1qwLpDz7dFjXKRaSwuMLvAlG8zZlG+YmiK1HoFqT7wP2z+4Q45TfEGcMt01xLoNZEBTwRqD4BLpnMLeC1A41UmVxsXgXeBayV/Wx20rpTyrpnWRft7p6O/FdqzGrDukPNtkaMoMo3FBdBSQMOnYBCReyf05s126fU9ytfX98+mY54Kxnp7S9K3kj6U9KYdG0h6UdLbkh7poFXMfUnSOyVvL0h6VtIXHbS6nOP+s/Zm9mvyXW1uuC9ohZ72E9uDmXWLJOB1GxsH+DxPftsB8B6wlGDN02TAkxG6+4D3TWsbeC5CS8CDFce+AW500LhhOW2020TRjK3b21HEmgti9m0RonxbdMZeVzV+/4tF3cBpP7E9mKHNL5q8h5g0eYsCMQz0epq8gQrwMXAgcs0FGXGFRcB9wCemF9PkbYqM/Bas7fxLwNeJPdTdpo4itQti8lPMqTpXuozVRVXPpbHI3KkNTB1NfkL81j2mvhDp91HgV9MKuRIqrykj3WPq4rHyL+axj8/qGPmTqi6F9YDlHOvJU6oYcTsh/TYSzWmTE6JT19CtLTJt32D6CmHe0eQn1O8z5AXgT4sx4Vcu0/EQecMydB8z0hUWkTd2t4CrwNEePqMBcAR4mrBbwyXLPWJa8zrXmmLEhNBmfpkuY2102xxrih+pb+ieAb6vGhuA97UcJ5KR8gZ77K+99xxeYBzH6Q3/Z0fHcXrDC4zjOL3hBcZxnN74F+zlvXFWXF9PAAAAAElFTkSuQmCC\");background-repeat:no-repeat}.viewer-zoom-in:before{content:\"Zoom In\";background-position:0 0}.viewer-zoom-out:before{content:\"Zoom Out\";background-position:-20px 0}.viewer-one-to-one:before{content:\"One to One\";background-position:-40px 0}.viewer-reset:before{content:\"Reset\";background-position:-60px 0}.viewer-prev:before{content:\"Previous\";background-position:-80px 0}.viewer-play:before{content:\"Play\";background-position:-100px 0}.viewer-next:before{content:\"Next\";background-position:-120px 0}.viewer-rotate-left:before{content:\"Rotate Left\";background-position:-140px 0}.viewer-rotate-right:before{content:\"Rotate Right\";background-position:-160px 0}.viewer-flip-horizontal:before{content:\"Flip Horizontal\";background-position:-180px 0}.viewer-flip-vertical:before{content:\"Flip Vertical\";background-position:-200px 0}.viewer-fullscreen:before{content:\"Enter Full Screen\";background-position:-220px 0}.viewer-fullscreen-exit:before{content:\"Exit Full Screen\";background-position:-240px 0}.viewer-close:before{content:\"Close\";background-position:-260px 0}.viewer-container{font-size:0;line-height:0;position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden;-ms-user-select:none;user-select:none;background-color:rgba(0,0,0,.5);direction:ltr!important;-ms-touch-action:none;touch-action:none;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none}.viewer-container::selection,.viewer-container ::selection{background-color:transparent}.viewer-container img{display:block;width:100%;min-width:0!important;max-width:none!important;height:auto;min-height:0!important;max-height:none!important}.viewer-canvas{position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden}.viewer-canvas>img{width:auto;max-width:90%!important;height:auto;margin:15px auto}.viewer-footer{position:absolute;right:0;bottom:0;left:0;overflow:hidden;text-align:center}.viewer-navbar{overflow:hidden;background-color:rgba(0,0,0,.5)}.viewer-list{overflow:hidden;box-sizing:content-box;height:50px;margin:0;padding:1px 0}.viewer-list>li{font-size:0;line-height:0;float:left;overflow:hidden;width:30px;height:50px;cursor:pointer;opacity:.5;color:transparent}.viewer-list>li+li{margin-left:1px}.viewer-list>.viewer-active{opacity:1}.viewer-player{right:0;bottom:0;display:none;cursor:none;background-color:#000}.viewer-player,.viewer-player>img{position:absolute;top:0;left:0}.viewer-toolbar{overflow:hidden;width:280px;margin:0 auto 5px;padding:3px 0}.viewer-toolbar>li{float:left;overflow:hidden;width:24px;height:24px;cursor:pointer;border-radius:50%;background-color:rgba(0,0,0,.5)}.viewer-toolbar>li:hover{background-color:rgba(0,0,0,.8)}.viewer-toolbar>li:before{margin:2px}.viewer-toolbar>li+li{margin-left:1px}.viewer-toolbar>.viewer-play{width:30px;height:30px;margin-top:-3px;margin-bottom:-3px}.viewer-toolbar>.viewer-play:before{margin:5px}.viewer-tooltip{font-size:12px;line-height:20px;position:absolute;top:50%;left:50%;display:none;width:50px;height:20px;margin-top:-10px;margin-left:-25px;text-align:center;color:#fff;border-radius:10px;background-color:rgba(0,0,0,.8)}.viewer-title{font-size:12px;line-height:1;display:inline-block;overflow:hidden;max-width:90%;margin:0 5% 5px;white-space:nowrap;text-overflow:ellipsis;opacity:.8;color:#ccc}.viewer-title:hover{opacity:1}.viewer-button{position:absolute;top:-40px;right:-40px;overflow:hidden;width:80px;height:80px;cursor:pointer;border-radius:50%;background-color:rgba(0,0,0,.5)}.viewer-button:before{position:absolute;bottom:15px;left:15px}.viewer-fixed{position:fixed}.viewer-open{overflow:hidden}.viewer-show{display:block}.viewer-hide{display:none}.viewer-invisible{visibility:hidden}.viewer-move{cursor:move;cursor:grab}.viewer-fade{opacity:0}.viewer-in{opacity:1}.viewer-transition{transition:all .3s ease-out}@media (max-width:767px){.viewer-hide-xs-down{display:none}}@media (max-width:991px){.viewer-hide-sm-down{display:none}}@media (max-width:1199px){.viewer-hide-md-down{display:none}}", ""]);
	
	// exports


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".progress{position:relative;height:4px;display:block;width:100%;background-color:#111;margin:.5rem 0 1rem;overflow:hidden}.progress .indeterminate{background-color:#00c4ff}.progress .indeterminate:before{animation:indeterminate 2.1s cubic-bezier(.65,.815,.735,.395) infinite}.progress .indeterminate:after,.progress .indeterminate:before{content:\"\";position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right}.progress .indeterminate:after{animation:indeterminate-short 2.1s cubic-bezier(.165,.84,.44,1) infinite;animation-delay:1.15s}@keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}", ""]);
	
	// exports


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".viewer-toolbar .viewer-next,.viewer-toolbar .viewer-play,.viewer-toolbar .viewer-prev{display:none}.viewer-toolbar{width:200px}.viewer-container{height:auto!important;width:auto!important}.viewer-canvas{display:flex;justify-content:center;align-items:center}.viewer-canvas img{margin:0!important}", ""]);
	
	// exports


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".alm-connection-status{-webkit-pointer-events:none;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.alm-connection-status .alm-connection-status-activity{display:block;position:fixed;z-index:2000;top:0;right:0;width:150px;height:150px;background:#29d;transition:transform .3s;transform:translateX(100%) translateY(-100%) rotate(45deg);pointer-events:none}.alm-connection-status.alm-connection-status-active .alm-connection-status-activity{transform:translateX(50%) translateY(-50%) rotate(45deg)}.alm-connection-status .alm-connection-status-activity:after,.alm-connection-status .alm-connection-status-activity:before{box-sizing:border-box;position:absolute;bottom:30px;left:50%;display:block;border:5px solid #fff;border-radius:50%;content:\"\"}.alm-connection-status .alm-connection-status-activity:before{margin-left:-12px;bottom:15px;width:40px;height:40px;border-right-color:rgba(0,0,0,.2);border-left-color:rgba(0,0,0,.2);animation:pace-theme-corner-indicator-spin 3s linear infinite}.alm-connection-status .alm-connection-status-activity:after{margin-left:-2px;bottom:25px;width:20px;height:20px;border-top-color:rgba(0,0,0,.2);border-bottom-color:rgba(0,0,0,.2);animation:pace-theme-corner-indicator-spin 1s linear infinite}@keyframes pace-theme-corner-indicator-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}", ""]);
	
	// exports


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".alm-markdown-root{font-size:.7em}.alm-markdown-root p{margin-top:.5em;margin-bottom:.5em}.alm-markdown-root a{color:grey}.alm-markdown-root a:hover{color:#fff}.alm-markdown-root ul{margin:0}", ""]);
	
	// exports


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".monaco-jumpy{position:absolute;font-size:.7em;font-family:consolas,menlo,monospace;font-weight:700;color:#333;background:#fff;opacity:.9;border-radius:25%;padding-left:2px;padding-right:2px;padding-top:1px;z-index:1000}", ""]);
	
	// exports


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".monaco-lint-marker-error:before,.monaco-lint-message-error:before{content:\"\\F057\";font:normal normal normal 10px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#f92672;font-size:.9em;cursor:pointer;margin-left:5px}", ""]);
	
	// exports


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".monaco-live-analysis-override{margin-left:5px;font-size:.7rem;transition:opacity .2s;opacity:.6;cursor:pointer}.monaco-live-analysis-override:before{content:\"\\F0AA\";font:normal normal normal 10px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#4da6ff}.monaco-live-analysis-override:hover{opacity:1!important}", ""]);
	
	// exports


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".monaco-quickfix{margin-left:0;font-size:.8rem;transition:opacity .2s;opacity:.6;cursor:pointer}.monaco-quickfix:hover{opacity:1!important}", ""]);
	
	// exports


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".monaco-editor.vs-dark .glyph-margin,.monaco-editor.vs-dark .monaco-editor-background{background-color:#272822}.monaco-editor.vs-dark .view-overlays .current-line{border:2px solid rgba(96,95,84,.5)}.monaco-editor.vs-dark .view-overlays.focused .selected-text{background-color:rgba(152,139,3,.4)}.monaco-editor-hover.monaco-editor-background div:first-child{margin-left:1px}.monaco-editor.vs-dark .monaco-editor-hover{border-color:#ccc}.monaco-editor.vs-dark .monaco-editor-hover [data-code]{margin:3px 0}.monaco-editor.vs-dark .monaco-editor-hover code{padding:0 3px;background-color:#555}.monaco-editor.vs-dark .bracket-match{background-color:hsla(0,0%,39%,.3)}.editor-widget.find-widget{display:none!important}.cdr.currentFindMatch{border:1px solid #fff;background-color:#6d4f3a}.monaco-editor.mac .margin-view-overlays .line-numbers,.monaco-editor .margin-view-overlays .line-numbers{cursor:pointer}.monaco-editor .zone-widget .zone-widget-container:focus{outline:none}.monaco-editor .zone-widget .zone-widget-container .block.title{font-family:monospace;padding-top:2px}", ""]);
	
	// exports


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".monaco-list .monaco-highlighted-label .highlight{color:#66d9ef!important}.vs-dark .monaco-list-row.focused{background-color:#00305a}", ""]);
	
	// exports


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".loader ul{width:10px;padding-left:0;display:inline-block}.loader ul li{display:inline-block;width:2px;height:10px;transform:translateY(0);box-shadow:0 0 3px rgba(0,0,0,.4);animation:colorbars 333ms alternate infinite cubic-bezier(.2,0,.5,1)}.loader .one{background:#2776b7;border-radius:3px 0 0 3px}.loader .two{background:#328fc5}.loader .three{background:#56b4d4}.loader .four{background:#61ca8c}.loader .five{background:#c5e9ae;border-radius:0 3px 3px 0}.loader li:first-of-type{animation-delay:111ms}.loader li:nth-of-type(2){animation-delay:222ms}.loader li:nth-of-type(3){animation-delay:333ms}.loader li:nth-of-type(4){animation-delay:444ms}.loader li:nth-of-type(5){animation-delay:555ms}@keyframes colorbars{to{transform:translateY(4px)}}", ""]);
	
	// exports


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(14)();
	// imports
	
	
	// module
	exports.push([module.id, ".lm_controls{display:none}.lm_splitter.lm_vertical .lm_drag_handle{top:0;height:5px}.lm_splitter.lm_horizontal .lm_drag_handle{left:0;width:5px}.lm_header .lm_tab .lm_close_tab{background-image:none;top:2px}.lm_close_tab:before{content:\"\\F00D\";font-family:FontAwesome}.alm_jumpIndex{position:absolute;right:-5px;top:-5px;background:#ad5000;color:#fff;font-weight:700;z-index:4;padding:2px 5px;border-radius:50px}.lm_active .alm_jumpIndex{background:#ee7813}.alm_tabMove{position:absolute;right:calc(50% - 200px);top:calc(50% - 5em);background:#333;color:#ddd;font-weight:700;z-index:1000;padding:15px 10px;border-radius:4px;border:3px solid #999;text-align:center;opacity:.8}.alm_tabMove div{padding:5px 0}.alm_tabMove .keyStrokeStyle{font-size:.9rem;background:#111;padding:1px 4px;border-radius:5px;border:2px solid}.lm_tab.alm_selected{color:#6edeef}.lm_tab{transition:color .2s;font-weight:700}.lm_content{display:flex;background-color:#272822}.lm_dropTargetIndicator,.lm_splitter{z-index:2}.lm_tab.unsaved .lm_close_tab:before{content:\"\\F1CD\";font-family:FontAwesome}.alm_tipRoot{position:absolute;top:0;bottom:0;right:0;left:0;display:flex;pointer-events:none;background-color:#272822}", ""]);
	
	// exports


/***/ },
/* 199 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 200 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 201 */
/***/ function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ },
/* 202 */
/***/ function(module, exports) {

	/*!
	 * escape-html
	 * Copyright(c) 2012-2013 TJ Holowaychuk
	 * Copyright(c) 2015 Andreas Lubbe
	 * Copyright(c) 2015 Tiancheng "Timothy" Gu
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Module exports.
	 * @public
	 */
	
	module.exports = escapeHtml;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34: // "
	        escape = '&quot;';
	        break;
	      case 38: // &
	        escape = '&amp;';
	        break;
	      case 39: // '
	        escape = '&#39;';
	        break;
	      case 60: // <
	        escape = '&lt;';
	        break;
	      case 62: // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index
	    ? html + str.substring(lastIndex, index)
	    : html;
	}


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 204 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(204);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(214);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var createArrayFromMixed = __webpack_require__(207);
	var getMarkupWrap = __webpack_require__(209);
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 210 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 211 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(211);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 213 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(213);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 215 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var pluckCandidates, scorer, sortCandidates;
	
	  scorer = __webpack_require__(97);
	
	  pluckCandidates = function(a) {
	    return a.candidate;
	  };
	
	  sortCandidates = function(a, b) {
	    return b.score - a.score;
	  };
	
	  module.exports = function(candidates, query, queryHasSlashes, _arg) {
	    var candidate, key, maxResults, score, scoredCandidates, string, _i, _len, _ref;
	    _ref = _arg != null ? _arg : {}, key = _ref.key, maxResults = _ref.maxResults;
	    if (query) {
	      scoredCandidates = [];
	      for (_i = 0, _len = candidates.length; _i < _len; _i++) {
	        candidate = candidates[_i];
	        string = key != null ? candidate[key] : candidate;
	        if (!string) {
	          continue;
	        }
	        score = scorer.score(string, query, queryHasSlashes);
	        if (!queryHasSlashes) {
	          score = scorer.basenameScore(string, query, score);
	        }
	        if (score > 0) {
	          scoredCandidates.push({
	            candidate: candidate,
	            score: score
	          });
	        }
	      }
	      scoredCandidates.sort(sortCandidates);
	      candidates = scoredCandidates.map(pluckCandidates);
	    }
	    if (maxResults != null) {
	      candidates = candidates.slice(0, maxResults);
	    }
	    return candidates;
	  };
	
	}).call(this);


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var PathSeparator;
	
	  PathSeparator = __webpack_require__(53).sep;
	
	  exports.basenameMatch = function(string, query) {
	    var base, index, lastCharacter, slashCount;
	    index = string.length - 1;
	    while (string[index] === PathSeparator) {
	      index--;
	    }
	    slashCount = 0;
	    lastCharacter = index;
	    base = null;
	    while (index >= 0) {
	      if (string[index] === PathSeparator) {
	        slashCount++;
	        if (base == null) {
	          base = string.substring(index + 1, lastCharacter + 1);
	        }
	      } else if (index === 0) {
	        if (lastCharacter < string.length - 1) {
	          if (base == null) {
	            base = string.substring(0, lastCharacter + 1);
	          }
	        } else {
	          if (base == null) {
	            base = string;
	          }
	        }
	      }
	      index--;
	    }
	    return exports.match(base, query, string.length - base.length);
	  };
	
	  exports.match = function(string, query, stringOffset) {
	    var character, indexInQuery, indexInString, lowerCaseIndex, matches, minIndex, queryLength, stringLength, upperCaseIndex, _i, _ref, _results;
	    if (stringOffset == null) {
	      stringOffset = 0;
	    }
	    if (string === query) {
	      return (function() {
	        _results = [];
	        for (var _i = stringOffset, _ref = stringOffset + string.length; stringOffset <= _ref ? _i < _ref : _i > _ref; stringOffset <= _ref ? _i++ : _i--){ _results.push(_i); }
	        return _results;
	      }).apply(this);
	    }
	    queryLength = query.length;
	    stringLength = string.length;
	    indexInQuery = 0;
	    indexInString = 0;
	    matches = [];
	    while (indexInQuery < queryLength) {
	      character = query[indexInQuery++];
	      lowerCaseIndex = string.indexOf(character.toLowerCase());
	      upperCaseIndex = string.indexOf(character.toUpperCase());
	      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
	      if (minIndex === -1) {
	        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
	      }
	      indexInString = minIndex;
	      if (indexInString === -1) {
	        return [];
	      }
	      matches.push(stringOffset + indexInString);
	      stringOffset += indexInString + 1;
	      string = string.substring(indexInString + 1, stringLength);
	    }
	    return matches;
	  };
	
	}).call(this);


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function($){var lm={"config":{},"container":{},"controls":{},"errors":{},"items":{},"utils":{}};
	
	lm.utils.F = function () {};
		
	lm.utils.extend = function( subClass, superClass ) {
		subClass.prototype = lm.utils.createObject( superClass.prototype );
		subClass.prototype.contructor = subClass;
	};
	
	lm.utils.createObject = function( prototype ) {
		if( typeof Object.create === 'function' ) {
			return Object.create( prototype );
		} else {
			lm.utils.F.prototype = prototype;
			return new lm.utils.F();
		}
	};
	
	lm.utils.objectKeys = function( object ) {
		var keys, key;
	
		if( typeof Object.keys === 'function' ) {
			return Object.keys( object );
		} else {
			keys = [];
			for( key in object ) {
				keys.push( key );
			}
			return keys;
		}
	};
	
	lm.utils.getHashValue = function( key ) {
		var matches = location.hash.match( new RegExp( key + '=([^&]*)' ) );
		return matches ? matches[ 1 ] : null;
	};
	
	lm.utils.getQueryStringParam = function( param ) {
		if( window.location.hash ) {
			return lm.utils.getHashValue( param );
		} else if( !window.location.search ) {
			return null;
		}
	
		var keyValuePairs = window.location.search.substr( 1 ).split( '&' ),
			params = {},
			pair,
			i;
	
		for( i = 0; i < keyValuePairs.length; i++ ) {
			pair = keyValuePairs[ i ].split( '=' );
			params[ pair[ 0 ] ] = pair[ 1 ];
		}
	
		return params[ param ] || null;
	};
	
	lm.utils.copy = function( target, source ) {
		for( var key in source ) {
			target[ key ] = source[ key ];
		}
		return target;
	};
	
	/**
	 * This is based on Paul Irish's shim, but looks quite odd in comparison. Why?
	 * Because 
	 * a) it shouldn't affect the global requestAnimationFrame function
	 * b) it shouldn't pass on the time that has passed
	 *
	 * @param   {Function} fn
	 *
	 * @returns {void}
	 */
	lm.utils.animFrame = function( fn ){
		return ( window.requestAnimationFrame     ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame    ||
		function( callback ){
			window.setTimeout(callback, 1000 / 60);
		})(function(){
			fn();
		});
	};
	
	lm.utils.indexOf = function( needle, haystack ) {
		if( !( haystack instanceof Array ) ) {
			throw new Error( 'Haystack is not an Array' );
		}
		
		if( haystack.indexOf ) {
			return haystack.indexOf( needle );
		} else {
			for( var i = 0; i < haystack.length; i++ ) {
				if( haystack[ i ] === needle ) {
					return i;
				}
			}
			return -1;
		}
	};
	
	if ( typeof /./ != 'function' && typeof Int8Array != 'object' ) {
	  lm.utils.isFunction = function ( obj ) {
	    return typeof obj == 'function' || false;
	  };
	} else {
		lm.utils.isFunction = function ( obj ) {
			return toString.call(obj) === '[object Function]';
		};
	}
	
	lm.utils.fnBind = function( fn, context, boundArgs ) {
	
		if( Function.prototype.bind !== undefined ) {
			return Function.prototype.bind.apply( fn, [ context ].concat( boundArgs || [] ) );
		}
	
		var bound = function () {
	
			// Join the already applied arguments to the now called ones (after converting to an array again).
			var args = ( boundArgs || [] ).concat(Array.prototype.slice.call(arguments, 0));
	
			// If not being called as a constructor
			if (!(this instanceof bound)){
				// return the result of the function called bound to target and partially applied.
				return fn.apply(context, args);
			}
			// If being called as a constructor, apply the function bound to self.
			fn.apply(this, args);
		};
		// Attach the prototype of the function to our newly created function.
		bound.prototype = fn.prototype;
		return bound;
	};
	
	lm.utils.removeFromArray = function( item, array ) {
		var index = lm.utils.indexOf( item, array );
	
		if( index === -1 ) {
			throw new Error( 'Can\'t remove item from array. Item is not in the array' );
		}
	
		array.splice( index, 1 );
	};
	
	lm.utils.now = function() {
		if( typeof Date.now === 'function' ) {
			return Date.now();
		} else {
			return ( new Date() ).getTime();
		}
	};
	
	lm.utils.getUniqueId = function() {
		return ( Math.random() * 1000000000000000 )
			.toString(36)
			.replace( '.', '' );
	};
	
	/**
	 * A basic XSS filter. It is ultimately up to the
	 * implementing developer to make sure their particular 
	 * applications and usecases are save from cross site scripting attacks
	 *
	 * @param   {String} input
	 * @param 	{Boolean} keepTags
	 *
	 * @returns {String} filtered input
	 */
	lm.utils.filterXss = function( input, keepTags ) {
		
		var output = input
			.replace( /javascript/gi, 'j&#97;vascript' )
			.replace( /expression/gi, 'expr&#101;ssion' )
			.replace( /onload/gi, 'onlo&#97;d' )
			.replace( /script/gi, '&#115;cript' )
			.replace( /onerror/gi, 'on&#101;rror' );
	
		if( keepTags === true ) {
			return output;
		} else {
			return output
				.replace( />/g, '&gt;' )
				.replace( /</g, '&lt;' );
		}
	};
	
	/**
	 * Removes html tags from a string
	 *
	 * @param   {String} input
	 *
	 * @returns {String} input without tags
	 */
	lm.utils.stripTags = function( input ) {
		return $.trim( input.replace( /(<([^>]+)>)/ig, '' ) );
	};
	/**
	 * A generic and very fast EventEmitter
	 * implementation. On top of emitting the
	 * actual event it emits an
	 *
	 * lm.utils.EventEmitter.ALL_EVENT
	 *
	 * event for every event triggered. This allows
	 * to hook into it and proxy events forwards
	 *
	 * @constructor
	 */
	lm.utils.EventEmitter = function()
	{
		this._mSubscriptions = { };
		this._mSubscriptions[ lm.utils.EventEmitter.ALL_EVENT ] = [];
	
		/**
		 * Listen for events
		 *
		 * @param   {String} sEvent    The name of the event to listen to
		 * @param   {Function} fCallback The callback to execute when the event occurs 
		 * @param   {[Object]} oContext The value of the this pointer within the callback function
		 *
		 * @returns {void}
		 */
		this.on = function( sEvent, fCallback, oContext )
		{
			if ( !lm.utils.isFunction(fCallback) ) {
				throw new Error( 'Tried to listen to event ' + sEvent + ' with non-function callback ' + fCallback );
			}
			
			if( !this._mSubscriptions[ sEvent ] )
			{
				this._mSubscriptions[ sEvent ] = [];
			}
	
			this._mSubscriptions[ sEvent ].push({ fn: fCallback, ctx: oContext });
		};
	
		/**
		 * Emit an event and notify listeners
		 *
		 * @param   {String} sEvent The name of the event
		 * @param 	{Mixed}  various additional arguments that will be passed to the listener
		 *
		 * @returns {void}
		 */
		this.emit = function( sEvent )
		{
			var i, ctx, args;
	
			args = Array.prototype.slice.call( arguments, 1 );
			
			if( this._mSubscriptions[ sEvent ] ) {
				for( i = 0; i < this._mSubscriptions[ sEvent ].length; i++ )
				{
					ctx = this._mSubscriptions[ sEvent ][ i ].ctx || {};
					this._mSubscriptions[ sEvent ][ i ].fn.apply( ctx, args );
				}
			}
			
			args.unshift( sEvent );
	
			for( i = 0; i < this._mSubscriptions[ lm.utils.EventEmitter.ALL_EVENT ].length; i++ )
			{
				ctx = this._mSubscriptions[ lm.utils.EventEmitter.ALL_EVENT ][ i ].ctx || {};
				this._mSubscriptions[ lm.utils.EventEmitter.ALL_EVENT ][ i ].fn.apply( ctx, args );
			}
		};
	
		/**
		 * Removes a listener for an event, or all listeners if no callback and context is provided.
		 *
		 * @param   {String} sEvent    The name of the event
		 * @param   {Function} fCallback The previously registered callback method (optional)
		 * @param   {Object} oContext  The previously registered context (optional)
		 *
		 * @returns {void}
		 */
		this.unbind = function( sEvent, fCallback, oContext )
		{
			if( !this._mSubscriptions[ sEvent ] ) {
				throw new Error( 'No subscribtions to unsubscribe for event ' + sEvent );
			}
	
			var i, bUnbound = false;
	
			for( i = 0; i < this._mSubscriptions[ sEvent ].length; i++ )
			{
				if
				(
					( !fCallback || this._mSubscriptions[ sEvent ][ i ].fn === fCallback ) &&
					( !oContext || oContext === this._mSubscriptions[ sEvent ][ i ].ctx )
				)
				{
					this._mSubscriptions[ sEvent ].splice( i, 1 );
					bUnbound = true;
				}
			}
	
			if( bUnbound === false )
			{
				throw new Error( 'Nothing to unbind for ' + sEvent );
			}
		};
	
		/**
		 * Alias for unbind
		 */
		this.off = this.unbind;
	
		/**
		 * Alias for emit
		 */
		this.trigger = this.emit;
	};
	
	/**
	 * The name of the event that's triggered for every other event
	 *
	 * usage
	 *
	 * myEmitter.on( lm.utils.EventEmitter.ALL_EVENT, function( eventName, argsArray ){
	 * 	//do stuff
	 * });
	 *
	 * @type {String}
	 */
	lm.utils.EventEmitter.ALL_EVENT = '__all';
	lm.utils.DragListener = function(eElement, nButtonCode)
	{
		lm.utils.EventEmitter.call(this);
	
		this._eElement = $(eElement);
		this._oDocument = $(document);
		this._eBody = $(document.body);
		this._nButtonCode = nButtonCode || 0;
	
		/**
		* The delay after which to start the drag in milliseconds
		*/
		this._nDelay = 200;
	
		/**
		* The distance the mouse needs to be moved to qualify as a drag
		*/
		this._nDistance = 10;//TODO - works better with delay only
	
		this._nX = 0;
		this._nY = 0;
	
		this._nOriginalX = 0;
		this._nOriginalY = 0;
	
		this._bDragging = false;
	
		this._fMove = lm.utils.fnBind( this.onMouseMove, this );
		this._fUp = lm.utils.fnBind( this.onMouseUp, this );
		this._fDown = lm.utils.fnBind( this.onMouseDown, this );
	
	
		this._eElement.on( 'mousedown touchstart', this._fDown );
	};
	
	lm.utils.DragListener.timeout = null;
	
	lm.utils.copy( lm.utils.DragListener.prototype, {
		destroy: function() {
			this._eElement.unbind( 'mousedown touchstart', this._fDown );
		},
	
		onMouseDown: function(oEvent)
		{
			oEvent.preventDefault();
	
			if (oEvent.button == 0) {
				var coordinates = this._getCoordinates( oEvent );
	
				this._nOriginalX = coordinates.x;
				this._nOriginalY = coordinates.y;
	
				this._oDocument.on( 'mousemove touchmove', this._fMove );
				this._oDocument.one( 'mouseup touchend', this._fUp );
	
				this._timeout = setTimeout( lm.utils.fnBind( this._startDrag, this ), this._nDelay );
			}
		},
	
		onMouseMove: function(oEvent)
		{
			if (this._timeout != null) {
				oEvent.preventDefault();
	
				var coordinates = this._getCoordinates(oEvent);
	
				this._nX = coordinates.x - this._nOriginalX;
				this._nY = coordinates.y - this._nOriginalY;
	
				if (this._bDragging === false) {
					if (
						Math.abs(this._nX) > this._nDistance ||
						Math.abs(this._nY) > this._nDistance
					) {
						clearTimeout(this._timeout);
						this._startDrag();
					}
				}
	
				if (this._bDragging) {
					this.emit('drag', this._nX, this._nY, oEvent);
				}
			}
		},
	
		onMouseUp: function(oEvent)
		{
			if(this._timeout != null) {
				clearTimeout( this._timeout );
				this._eBody.removeClass( 'lm_dragging' );
				this._eElement.removeClass( 'lm_dragging' );
				this._oDocument.find( 'iframe' ).css( 'pointer-events', '' );
				this._oDocument.unbind( 'mousemove touchmove', this._fMove );
	
				if( this._bDragging === true ) {
					this._bDragging = false;
					this.emit( 'dragStop', oEvent, this._nOriginalX + this._nX );
				}
			}
		},
	
		_startDrag: function()
		{
			this._bDragging = true;
			this._eBody.addClass( 'lm_dragging' );
			this._eElement.addClass( 'lm_dragging' );
			this._oDocument.find( 'iframe' ).css( 'pointer-events', 'none' );
			this.emit('dragStart', this._nOriginalX, this._nOriginalY);
		},
	
		_getCoordinates: function( event ) {
			var coordinates = {};
	
			if( event.type.substr( 0, 5 ) === 'touch' ) {
				coordinates.x = event.originalEvent.targetTouches[ 0 ].pageX;
				coordinates.y = event.originalEvent.targetTouches[ 0 ].pageY;
			} else {
				coordinates.x = event.pageX;
				coordinates.y = event.pageY;
			}
	
			return coordinates;
		}
	});
	/**
	 * The main class that will be exposed as GoldenLayout.
	 *
	 * @public
	 * @constructor
	 * @param {GoldenLayout config} config
	 * @param {[DOM element container]} container Can be a jQuery selector string or a Dom element. Defaults to body
	 *
	 * @returns {VOID}
	 */
	lm.LayoutManager = function( config, container ) {
	
		if( !$ || typeof $.noConflict !== 'function' ) {
			var errorMsg = 'jQuery is missing as dependency for GoldenLayout. ';
			errorMsg += 'Please either expose $ on GoldenLayout\'s scope (e.g. window) or add "jquery" to ';
			errorMsg += 'your paths when using RequireJS/AMD';
			throw new Error( errorMsg );
		}
		lm.utils.EventEmitter.call( this );
	
		this.isInitialised = false;
		this._isFullPage = false;
		this._resizeTimeoutId = null;
		this._components = { 'lm-react-component': lm.utils.ReactComponentHandler };
		this._itemAreas = [];
		this._resizeFunction = lm.utils.fnBind( this._onResize, this );
		this._unloadFunction = lm.utils.fnBind( this._onUnload, this );
		this._maximisedItem = null;
		this._maximisePlaceholder = $( '<div class="lm_maximise_place"></div>' );
		this._creationTimeoutPassed = false;
		this._subWindowsCreated = false;
		this._dragSources = [];
	
		this.width = null;
		this.height = null;
		this.root =  null;
		this.openPopouts = [];
		this.selectedItem = null;
		this.isSubWindow = false;
		this.eventHub = new lm.utils.EventHub( this );
		this.config = this._createConfig( config );
		this.container = container;
		this.dropTargetIndicator = null;
		this.transitionIndicator = null;
		this.tabDropPlaceholder = $( '<div class="lm_drop_tab_placeholder"></div>' );
	
		if( this.isSubWindow === true ) {
			$( 'body' ).css( 'visibility', 'hidden' );
		}
	
		this._typeToItem = {
			'column': lm.utils.fnBind( lm.items.RowOrColumn, this, [ true ] ),
			'row': lm.utils.fnBind( lm.items.RowOrColumn, this, [ false ] ),
			'stack': lm.items.Stack,
			'component': lm.items.Component
		};
	};
	
	/**
	 * Hook that allows to access private classes
	 */
	lm.LayoutManager.__lm = lm;
	
	/**
	 * Takes a GoldenLayout configuration object and
	 * replaces its keys and values recursively with
	 * one letter codes
	 *
	 * @static
	 * @public
	 * @param   {Object} config A GoldenLayout config object
	 *
	 * @returns {Object} minified config
	 */
	lm.LayoutManager.minifyConfig = function( config ) {
		return ( new lm.utils.ConfigMinifier() ).minifyConfig( config );
	};
	
	/**
	 * Takes a configuration Object that was previously minified
	 * using minifyConfig and returns its original version
	 *
	 * @static
	 * @public
	 * @param   {Object} minifiedConfig
	 *
	 * @returns {Object} the original configuration
	 */
	lm.LayoutManager.unminifyConfig = function( config ) {
		return ( new lm.utils.ConfigMinifier() ).unminifyConfig( config );
	};
	
	lm.utils.copy( lm.LayoutManager.prototype, {
	
		/**
		 * Register a component with the layout manager. If a configuration node
		 * of type component is reached it will look up componentName and create the
		 * associated component
		 *
		 *  {
		 *		type: "component",
		 *		componentName: "EquityNewsFeed",
		 *		componentState: { "feedTopic": "us-bluechips" }
		 *  }
		 *
		 * @public
		 * @param   {String} name
		 * @param   {Function} constructor
		 *
		 * @returns {void}
		 */
		registerComponent: function( name, constructor ) {
			if( typeof constructor !== 'function' ) {
				throw new Error( 'Please register a constructor function' );
			}
	
			if( this._components[ name ] !== undefined ) {
				throw new Error( 'Component ' + name + ' is already registered' );
			}
	
			this._components[ name ] = constructor;
		},
	
		/**
		 * Creates a layout configuration object based on the the current state
		 *
		 * @public
		 * @returns {Object} GoldenLayout configuration
		 */
		toConfig: function( root ) {
			var config, next, i;
	
			if( this.isInitialised === false ) {
				throw new Error( 'Can\'t create config, layout not yet initialised' );
			}
	
			if( root && !( root instanceof lm.items.AbstractContentItem ) ){
				throw new Error( 'Root must be a ContentItem' );
			}
	
			/*
			 * settings & labels
			 */
			config = {
				settings: lm.utils.copy( {}, this.config.settings ),
				dimensions: lm.utils.copy( {}, this.config.dimensions ),
				labels: lm.utils.copy( {}, this.config.labels )
			};
	
			/*
			 * Content
			 */
			config.content = [];
			next = function( configNode, item ) {
				var key, i;
	
				for( key in item.config ) {
					if( key !== 'content' ) {
						configNode[ key ] = item.config[ key ];
					}
				}
	
				if( item.contentItems.length ) {
					configNode.content = [];
	
					for( i = 0; i < item.contentItems.length; i++ ) {
						configNode.content[ i ] = {};
						next( configNode.content[ i ], item.contentItems[ i ] );
					}
				}
			};
	
			if( root ) {
				next( config, { contentItems: [ root ] } );
			} else {
				next( config, this.root );
			}
	
			/*
			 * Retrieve config for subwindows
			 */
			this._$reconcilePopoutWindows();
			config.openPopouts = [];
			for( i = 0; i < this.openPopouts.length; i++ ) {
				config.openPopouts.push( this.openPopouts[ i ].toConfig() );
			}
	
			/*
			 * Add maximised item
			 */
			config.maximisedItemId = this._maximisedItem ? '__glMaximised' : null;
			return config;
		},
	
		/**
		 * Returns a previously registered component
		 *
		 * @public
		 * @param   {String} name The name used
		 *
		 * @returns {Function}
		 */
		getComponent: function( name ) {
			if( this._components[ name ] === undefined ) {
				throw new lm.errors.ConfigurationError( 'Unknown component "' + name + '"' );
			}
	
			return this._components[ name ];
		},
	
		/**
		 * Creates the actual layout. Must be called after all initial components
		 * are registered. Recurses through the configuration and sets up
		 * the item tree.
		 *
		 * If called before the document is ready it adds itself as a listener
		 * to the document.ready event
		 *
		 * @public
		 *
		 * @returns {void}
		 */
		init: function() {
	
			/**
			 * Create the popout windows straight away. If popouts are blocked
			 * an error is thrown on the same 'thread' rather than a timeout and can
			 * be caught. This also prevents any further initilisation from taking place.
			 */
			if( this._subWindowsCreated === false ) {
				this._createSubWindows();
				this._subWindowsCreated = true;
			}
	
	
			/**
			 * If the document isn't ready yet, wait for it.
			 */
			if( document.readyState === 'loading' || document.body === null ) {
				$(document).ready( lm.utils.fnBind( this.init, this ));
				return;
			}
	
			/**
			 * If this is a subwindow, wait a few milliseconds for the original
			 * page's js calls to be executed, then replace the bodies content
			 * with GoldenLayout
			 */
			if( this.isSubWindow === true && this._creationTimeoutPassed === false ) {
				setTimeout( lm.utils.fnBind( this.init, this ), 7 );
				this._creationTimeoutPassed = true;
				return;
			}
	
			if( this.isSubWindow === true ) {
				this._adjustToWindowMode();
			}
	
			this._setContainer();
			this.dropTargetIndicator = new lm.controls.DropTargetIndicator( this.container );
			this.transitionIndicator = new lm.controls.TransitionIndicator();
			this.updateSize();
			this._create( this.config );
			this._bindEvents();
			this.isInitialised = true;
			this.emit( 'initialised' );
		},
	
		/**
		 * Updates the layout managers size
		 *
		 * @public
		 * @param   {[int]} width  height in pixels
		 * @param   {[int]} height width in pixels
		 *
		 * @returns {void}
		 */
		updateSize: function( width, height ) {
			if( arguments.length === 2 ) {
				this.width = width;
				this.height = height;
			} else {
				this.width = this.container.width();
				this.height = this.container.height();
			}
	
			if( this.isInitialised === true ) {
				this.root.callDownwards( 'setSize' );
	
				if( this._maximisedItem ) {
					this._maximisedItem.element.width( this.container.width() );
					this._maximisedItem.element.height( this.container.height() );
					this._maximisedItem.callDownwards( 'setSize' );
				}
			}
		},
	
		/**
		 * Destroys the LayoutManager instance itself as well as every ContentItem
		 * within it. After this is called nothing should be left of the LayoutManager.
		 *
		 * @public
		 * @returns {void}
		 */
		destroy: function() {
			if( this.isInitialised === false ) {
				return;
			}
			this._onUnload();
			$( window ).off( 'resize', this._resizeFunction );
			$( window ).off( 'unload beforeunload', this._unloadFunction );
			this.root.callDownwards( '_$destroy', [], true );
			this.root.contentItems = [];
			this.tabDropPlaceholder.remove();
			this.dropTargetIndicator.destroy();
			this.transitionIndicator.destroy();
			this.eventHub.destroy();
			
			this._dragSources.forEach(function (dragSource) {
				dragSource._dragListener.destroy();
				dragSource._element = null;
				dragSource._itemConfig = null;
				dragSource._dragListener = null;
			});
			this._dragSources = [];
		},
	
		/**
		 * Recursively creates new item tree structures based on a provided
		 * ItemConfiguration object
		 *
		 * @public
		 * @param   {Object} config ItemConfig
		 * @param   {[ContentItem]} parent The item the newly created item should be a child of
		 *
		 * @returns {lm.items.ContentItem}
		 */
		createContentItem: function( config, parent ) {
			var typeErrorMsg, contentItem;
	
			if( typeof config.type !== 'string' ) {
				throw new lm.errors.ConfigurationError( 'Missing parameter \'type\'', config );
			}
	
			if (config.type === 'react-component') {
				config.type = 'component';
				config.componentName = 'lm-react-component';
			}
	
			if( !this._typeToItem[ config.type ] ) {
				typeErrorMsg = 'Unknown type \'' + config.type + '\'. ' +
					'Valid types are ' + lm.utils.objectKeys( this._typeToItem ).join( ',' );
	
				throw new lm.errors.ConfigurationError( typeErrorMsg );
			}
	
	
			/**
			 * We add an additional stack around every component that's not within a stack anyways.
			 */
			if(
				// If this is a component
				config.type === 'component' &&
	
				// and it's not already within a stack
				!( parent instanceof lm.items.Stack ) &&
	
				// and we have a parent
				!!parent &&
	
				// and it's not the topmost item in a new window
				!( this.isSubWindow === true && parent instanceof lm.items.Root )
			) {
				config = {
					type: 'stack',
					width: config.width,
					height: config.height,
					content: [ config ]
				};
			}
	
			contentItem = new this._typeToItem[ config.type ]( this, config, parent );
			return contentItem;
		},
	
		/**
		 * Creates a popout window with the specified content and dimensions
		 *
		 * @param   {Object|lm.itemsAbstractContentItem} configOrContentItem
		 * @param   {[Object]} dimensions A map with width, height, left and top
		 * @param 	{[String]} parentId the id of the element this item will be appended to
		 *                             when popIn is called
		 * @param 	{[Number]} indexInParent The position of this item within its parent element
	
		 * @returns {lm.controls.BrowserPopout}
		 */
		createPopout: function( configOrContentItem, dimensions, parentId, indexInParent ) {
			var config = configOrContentItem,
				isItem = configOrContentItem instanceof lm.items.AbstractContentItem,
				self = this,
				windowLeft,
				windowTop,
				offset,
				parent,
				child,
				browserPopout;
	
			parentId = parentId || null;
	
			if( isItem ) {
				config = this.toConfig( configOrContentItem ).content;
				parentId = lm.utils.getUniqueId();
	
				/**
				 * If the item is the only component within a stack or for some
				 * other reason the only child of its parent the parent will be destroyed
				 * when the child is removed.
				 *
				 * In order to support this we move up the tree until we find something
				 * that will remain after the item is being popped out
				 */
				parent = configOrContentItem.parent;
				child = configOrContentItem;
				while( parent.contentItems.length === 1 && !parent.isRoot ) {
					parent = parent.parent;
					child = child.parent;
				}
	
				parent.addId( parentId );
				if( isNaN( indexInParent ) ) {
					indexInParent = lm.utils.indexOf( child, parent.contentItems );
				}
			} else {
				if( !( config instanceof Array ) ) {
					config = [ config ];
				}
			}
	
	
	
			if( !dimensions && isItem ) {
				windowLeft = window.screenX || window.screenLeft;
				windowTop = window.screenY || window.screenTop;
				offset = configOrContentItem.element.offset();
	
				dimensions = {
					left: windowLeft + offset.left,
					top: windowTop + offset.top,
					width: configOrContentItem.element.width(),
					height: configOrContentItem.element.height()
				};
			}
	
			if( !dimensions && !isItem ) {
				dimensions = {
					left: window.screenX || window.screenLeft + 20,
					top: window.screenY || window.screenTop + 20,
					width: 500,
					height: 309
				};
			}
	
			if( isItem ) {
				configOrContentItem.remove();
			}
	
			browserPopout = new lm.controls.BrowserPopout( config, dimensions, parentId, indexInParent, this );
	
			browserPopout.on( 'initialised', function(){
				self.emit( 'windowOpened', browserPopout );
			});
	
			browserPopout.on( 'closed', function(){
				self._$reconcilePopoutWindows();
			});
	
			this.openPopouts.push( browserPopout );
	
			return browserPopout;
		},
	
		/**
		 * Attaches DragListener to any given DOM element
		 * and turns it into a way of creating new ContentItems
		 * by 'dragging' the DOM element into the layout
		 *
		 * @param   {jQuery DOM element} element
		 * @param   {Object|Function} itemConfig for the new item to be created, or a function which will provide it
		 *
		 * @returns {void}
		 */
		createDragSource: function( element, itemConfig ) {
			this.config.settings.constrainDragToContainer = false;
			var dragSource = new lm.controls.DragSource( $( element ), itemConfig, this );
			this._dragSources.push(dragSource);
			
			return dragSource;
		},
	
		/**
		 * Programmatically selects an item. This deselects
		 * the currently selected item, selects the specified item
		 * and emits a selectionChanged event
		 *
		 * @param   {lm.item.AbstractContentItem} item#
		 * @param   {[Boolean]} _$silent Wheather to notify the item of its selection
		 * @event 	selectionChanged
		 *
		 * @returns {VOID}
		 */
		selectItem: function( item, _$silent ) {
	
			if( this.config.settings.selectionEnabled !== true ) {
				throw new Error( 'Please set selectionEnabled to true to use this feature' );
			}
	
			if( item === this.selectedItem ) {
				return;
			}
	
			if( this.selectedItem !== null ) {
				this.selectedItem.deselect();
			}
	
			if( item && _$silent !== true ) {
				item.select();
			}
	
			this.selectedItem = item;
	
			this.emit( 'selectionChanged', item );
		},
	
		/*************************
		* PACKAGE PRIVATE
		*************************/
		_$maximiseItem: function( contentItem ) {
			if( this._maximisedItem !== null ) {
				this._$minimiseItem( this._maximisedItem );
			}
			this._maximisedItem = contentItem;
			this._maximisedItem.addId( '__glMaximised' );
			contentItem.element.addClass( 'lm_maximised' );
			contentItem.element.after( this._maximisePlaceholder );
			this.root.element.prepend( contentItem.element );
			contentItem.element.width( this.container.width() );
			contentItem.element.height( this.container.height() );
			contentItem.callDownwards( 'setSize' );
			this._maximisedItem.emit( 'maximised' );
			this.emit( 'stateChanged' );
		},
	
		_$minimiseItem: function( contentItem ) {
			contentItem.element.removeClass( 'lm_maximised' );
			contentItem.removeId( '__glMaximised' );
			this._maximisePlaceholder.after( contentItem.element );
			this._maximisePlaceholder.remove();
			contentItem.parent.callDownwards( 'setSize' );
			this._maximisedItem = null;
			contentItem.emit( 'minimised' );
			this.emit( 'stateChanged' );
		},
	
		/**
		 * This method is used to get around sandboxed iframe restrictions.
		 * If 'allow-top-navigation' is not specified in the iframe's 'sandbox' attribute
		 * (as is the case with codepens) the parent window is forbidden from calling certain
		 * methods on the child, such as window.close() or setting document.location.href.
		 *
		 * This prevented GoldenLayout popouts from popping in in codepens. The fix is to call
		 * _$closeWindow on the child window's gl instance which (after a timeout to disconnect
		 * the invoking method from the close call) closes itself.
		 *
		 * @packagePrivate
		 *
		 * @returns {void}
		 */
		_$closeWindow: function() {
			window.setTimeout(function(){
				window.close();
			}, 1);
		},
	
		_$getArea: function( x, y ) {
			var i, area, smallestSurface = Infinity, mathingArea = null;
	
			for( i = 0; i < this._itemAreas.length; i++ ) {
				area = this._itemAreas[ i ];
	
				if(
					x > area.x1 &&
					x < area.x2 &&
					y > area.y1 &&
					y < area.y2 &&
					smallestSurface > area.surface
				){
					smallestSurface = area.surface;
					mathingArea = area;
				}
			}
	
			return mathingArea;
		},
	
		_$calculateItemAreas: function() {
			var i, area, allContentItems = this._getAllContentItems();
			this._itemAreas = [];
	
			/**
			 * If the last item is dragged out, highlight the entire container size to
			 * allow to re-drop it. allContentItems[ 0 ] === this.root at this point
			 *
			 * Don't include root into the possible drop areas though otherwise since it
			 * will used for every gap in the layout, e.g. splitters
			 */
			if( allContentItems.length === 1 ) {
				this._itemAreas.push( this.root._$getArea() );
				return;
			}
	
			for( i = 0; i < allContentItems.length; i++ ) {
	
				if( !( allContentItems[ i ].isStack ) ) {
					continue;
				}
	
				area = allContentItems[ i ]._$getArea();
	
				if( area === null ) {
					continue;
				} else if( area instanceof Array ) {
					this._itemAreas = this._itemAreas.concat( area );
				} else {
					this._itemAreas.push( area );
				}
			}
		},
	
		/**
		 * Takes a contentItem or a configuration and optionally a parent
		 * item and returns an initialised instance of the contentItem.
		 * If the contentItem is a function, it is first called
		 *
		 * @packagePrivate
		 *
		 * @param   {lm.items.AbtractContentItem|Object|Function} contentItemOrConfig
		 * @param   {lm.items.AbtractContentItem} parent Only necessary when passing in config
		 *
		 * @returns {lm.items.AbtractContentItem}
		 */
		_$normalizeContentItem: function( contentItemOrConfig, parent ) {
			if( !contentItemOrConfig ) {
				throw new Error( 'No content item defined' );
			}
	
			if( lm.utils.isFunction( contentItemOrConfig ) ) {
				contentItemOrConfig = contentItemOrConfig();
			}
	
			if( contentItemOrConfig instanceof lm.items.AbstractContentItem ) {
				return contentItemOrConfig;
			}
	
			if( $.isPlainObject( contentItemOrConfig ) && contentItemOrConfig.type ) {
				var newContentItem = this.createContentItem( contentItemOrConfig, parent );
				newContentItem.callDownwards( '_$init' );
				return newContentItem;
			} else {
				throw new Error( 'Invalid contentItem' );
			}
		},
	
		/**
		 * Iterates through the array of open popout windows and removes the ones
		 * that are effectively closed. This is necessary due to the lack of reliably
		 * listening for window.close / unload events in a cross browser compatible fashion.
		 *
		 * @packagePrivate
		 *
		 * @returns {void}
		 */
		_$reconcilePopoutWindows: function() {
			var openPopouts = [], i;
	
			for( i = 0; i < this.openPopouts.length; i++ ) {
				if( this.openPopouts[ i ].getWindow().closed === false ) {
					openPopouts.push( this.openPopouts[ i ] );
				} else {
					this.emit( 'windowClosed', this.openPopouts[ i ] );
				}
			}
	
			if( this.openPopouts.length !== openPopouts.length ) {
				this.emit( 'stateChanged' );
				this.openPopouts = openPopouts;
			}
	
		},
	
		/***************************
		* PRIVATE
		***************************/
		/**
		 * Returns a flattened array of all content items,
		 * regardles of level or type
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_getAllContentItems: function() {
			var allContentItems = [];
	
			var addChildren = function( contentItem ) {
				allContentItems.push( contentItem );
	
				if( contentItem.contentItems instanceof Array ) {
					for( var i = 0; i < contentItem.contentItems.length; i++ ) {
						addChildren( contentItem.contentItems[ i ] );
					}
				}
			};
	
			addChildren( this.root );
	
			return allContentItems;
		},
	
		/**
		 * Binds to DOM/BOM events on init
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_bindEvents: function() {
			if( this._isFullPage ) {
				$(window).resize( this._resizeFunction );
			}
			$(window).on( 'unload beforeunload', this._unloadFunction );
		},
	
		/**
		 * Debounces resize events
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_onResize: function() {
			clearTimeout( this._resizeTimeoutId );
			this._resizeTimeoutId = setTimeout(lm.utils.fnBind( this.updateSize, this ), 100 );
		},
	
		/**
		 * Extends the default config with the user specific settings and applies
		 * derivations. Please note that there's a seperate method (AbstractContentItem._extendItemNode)
		 * that deals with the extension of item configs
		 *
		 * @param   {Object} config
		 * @static
		 * @returns {Object} config
		 */
		_createConfig: function( config ) {
			var windowConfigKey = lm.utils.getQueryStringParam( 'gl-window' );
	
			if( windowConfigKey ) {
				this.isSubWindow = true;
				config = localStorage.getItem( windowConfigKey );
				config = JSON.parse( config );
				config = ( new lm.utils.ConfigMinifier() ).unminifyConfig( config );
				localStorage.removeItem( windowConfigKey );
			}
	
			config = $.extend( true, {}, lm.config.defaultConfig, config );
	
			var nextNode = function( node ) {
				for( var key in node ) {
					if( key !== 'props' && typeof node[ key ] === 'object' ) {
						nextNode( node[ key ] );
					}
					else if( key === 'type' && node[ key ] === 'react-component' ) {
						node.type = 'component';
						node.componentName = 'lm-react-component';
					}
				}
			}
	
			nextNode( config );
	
			if( config.settings.hasHeaders === false ) {
				config.dimensions.headerHeight = 0;
			}
	
			return config;
		},
	
		/**
		 * This is executed when GoldenLayout detects that it is run
		 * within a previously opened popout window.
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_adjustToWindowMode: function() {
			var popInButton = $( '<div class="lm_popin" title="' + this.config.labels.popin + '">' +
					'<div class="lm_icon"></div>' +
					'<div class="lm_bg"></div>' +
				'</div>');
	
			popInButton.click(lm.utils.fnBind(function(){
				this.emit( 'popIn' );
			}, this));
	
			document.title = lm.utils.stripTags( this.config.content[ 0 ].title );
	
			$( 'head' ).append( $( 'body link, body style, template, .gl_keep' ) );
	
			this.container = $( 'body' )
					.html( '' )
					.css( 'visibility', 'visible' )
					.append( popInButton );
	
			/*
			 * This seems a bit pointless, but actually causes a reflow/re-evaluation getting around
			 * slickgrid's "Cannot find stylesheet." bug in chrome
			 */
			var x = document.body.offsetHeight; // jshint ignore:line
	
			/*
			 * Expose this instance on the window object
			 * to allow the opening window to interact with
			 * it
			 */
			window.__glInstance = this;
		},
	
		/**
		 * Creates Subwindows (if there are any). Throws an error
		 * if popouts are blocked.
		 *
		 * @returns {void}
		 */
		_createSubWindows: function() {
			var i, popout;
	
			for( i = 0; i < this.config.openPopouts.length; i++ ) {
				popout = this.config.openPopouts[ i ];
	
				this.createPopout(
					popout.content,
					popout.dimensions,
					popout.parentId,
					popout.indexInParent
				);
			}
		},
	
		/**
		 * Determines what element the layout will be created in
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_setContainer: function() {
			var container = $( this.container || 'body' );
	
			if( container.length === 0 ) {
				throw new Error( 'GoldenLayout container not found' );
			}
	
			if( container.length > 1 ) {
				throw new Error( 'GoldenLayout more than one container element specified' );
			}
	
			if( container[ 0 ] === document.body ) {
				this._isFullPage = true;
	
				$( 'html, body' ).css({
					height: '100%',
					margin:0,
					padding: 0,
					overflow: 'hidden'
				});
			}
	
			this.container = container;
		},
	
		/**
		 * Kicks of the initial, recursive creation chain
		 *
		 * @param   {Object} config GoldenLayout Config
		 *
		 * @returns {void}
		 */
		_create: function( config ) {
			var errorMsg;
	
			if( !( config.content instanceof Array ) ) {
				if( config.content === undefined ) {
					errorMsg = 'Missing setting \'content\' on top level of configuration';
				} else {
					errorMsg = 'Configuration parameter \'content\' must be an array';
				}
	
				throw new lm.errors.ConfigurationError( errorMsg, config );
			}
	
			if( config.content.length > 1 ) {
				errorMsg = 'Top level content can\'t contain more then one element.';
				throw new lm.errors.ConfigurationError( errorMsg, config );
			}
	
			this.root = new lm.items.Root( this, { content: config.content }, this.container );
			this.root.callDownwards( '_$init' );
	
			if( config.maximisedItemId === '__glMaximised' ) {
				this.root.getItemsById( config.maximisedItemId )[ 0 ].toggleMaximise();
			}
		},
	
		/**
		 * Called when the window is closed or the user navigates away
		 * from the page
		 *
		 * @returns {void}
		 */
		_onUnload: function() {
			if( this.config.settings.closePopoutsOnUnload === true ) {
				for( var i = 0; i < this.openPopouts.length; i++ ) {
					this.openPopouts[ i ].close();
				}
			}
		}
	});
	
	/**
	 * Expose the Layoutmanager as the single entrypoint using UMD
	 */
	(function () {
		/* global define */
		if ( true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(36) ], __WEBPACK_AMD_DEFINE_RESULT__ = function( jquery ){ $ = jquery; return lm.LayoutManager; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // jshint ignore:line
		} else if (typeof exports === 'object') {
			module.exports = lm.LayoutManager;
		} else {
			window.GoldenLayout = lm.LayoutManager;
		}
	})();
	
	lm.config.itemDefaultConfig = {
		isClosable: true,
		reorderEnabled: true,
		title: ''
	};
	lm.config.defaultConfig = {
		openPopouts:[],
		settings:{
			hasHeaders: true,
			constrainDragToContainer: true,
			reorderEnabled: true,
			selectionEnabled: false,
			popoutWholeStack: false,
			blockedPopoutsThrowError: true,
			closePopoutsOnUnload: true,
			showPopoutIcon: true,
			showMaximiseIcon: true,
			showCloseIcon: true
		},
		dimensions: {
			borderWidth: 5,
			minItemHeight: 10,
			minItemWidth: 10,
			headerHeight: 20,
			dragProxyWidth: 300,
			dragProxyHeight: 200
		},
		labels: {
			close: 'close',
			maximise: 'maximise',
			minimise: 'minimise',
			popout: 'open in new window',
			popin: 'pop in'
		}
	};
	lm.container.ItemContainer = function( config, parent, layoutManager ) {
		lm.utils.EventEmitter.call( this );
	
		this.width = null;
		this.height = null;
		this.title = config.componentName;
		this.parent = parent;
		this.layoutManager = layoutManager;
		this.isHidden = false;
		
		this._config = config;
		this._element = $([
			'<div class="lm_item_container">',
				'<div class="lm_content"></div>',
			'</div>'
		].join( '' ));
		
		this._contentElement = this._element.find( '.lm_content' );
	};
	
	lm.utils.copy( lm.container.ItemContainer.prototype, {
	
		/**
		 * Get the inner DOM element the container's content
		 * is intended to live in
		 *
		 * @returns {DOM element}
		 */
		getElement: function() {
			return this._contentElement;
		},
		
		/**
		 * Hide the container. Notifies the containers content first
		 * and then hides the DOM node. If the container is already hidden
		 * this should have no effect
		 *
		 * @returns {void}
		 */
		hide: function() {
			this.emit( 'hide' );
			this.isHidden = true;
			this._element.hide();
		},
		
		/**
		 * Shows a previously hidden container. Notifies the
		 * containers content first and then shows the DOM element.
		 * If the container is already visible this has no effect.
		 *
		 * @returns {void}
		 */
		show: function() {
			this.emit( 'show' );
			this.isHidden = false;
			this._element.show();
			// call shown only if the container has a valid size
			if(this.height != 0 || this.width != 0) {
				this.emit( 'shown' );
			}
		},
	
		/**
		 * Set the size from within the container. Traverses up
		 * the item tree until it finds a row or column element
		 * and resizes its items accordingly.
		 *
		 * If this container isn't a descendant of a row or column
		 * it returns false
		 * @todo  Rework!!!
		 * @param {Number} width  The new width in pixel
		 * @param {Number} height The new height in pixel
		 * 
		 * @returns {Boolean} resizeSuccesful
		 */
		setSize: function( width, height ) {
			var rowOrColumn = this.parent,
				rowOrColumnChild = this,
				totalPixel,
				percentage,
				direction,
				newSize,
				delta,
				i;
	
			while( !rowOrColumn.isColumn && !rowOrColumn.isRow ) {
				rowOrColumnChild = rowOrColumn;
				rowOrColumn = rowOrColumn.parent;
				
	
				/**
				 * No row or column has been found
				 */
				if( rowOrColumn.isRoot ) {
					return false;
				}
			}
	
			direction = rowOrColumn.isColumn ? "height" : "width";
			newSize = direction === "height" ? height : width;
	
			totalPixel = this[direction] * ( 1 / ( rowOrColumnChild.config[direction] / 100 ) );
			percentage = ( newSize / totalPixel ) * 100;
			delta = ( rowOrColumnChild.config[direction] - percentage ) / rowOrColumn.contentItems.length;
	
			for( i = 0; i < rowOrColumn.contentItems.length; i++ ) {
				if( rowOrColumn.contentItems[ i ] === rowOrColumnChild ) {
					rowOrColumn.contentItems[ i ].config[direction] = percentage;
				} else {
					rowOrColumn.contentItems[ i ].config[direction] += delta;
				}
			}
	
			rowOrColumn.callDownwards( 'setSize' );
	
			return true;
		},
		
		/**
		 * Closes the container if it is closable. Can be called by
		 * both the component within at as well as the contentItem containing
		 * it. Emits a close event before the container itself is closed.
		 *
		 * @returns {void}
		 */
		close: function() {
			if( this._config.isClosable ) {
				this.emit( 'close' );
				this.parent.close();
			}
		},
	
		/**
		 * Returns the current state object
		 *
		 * @returns {Object} state
		 */
		getState: function() {
			return this._config.componentState;
		},
	
		/**
		 * Merges the provided state into the current one
		 *
		 * @param   {Object} state
		 *
		 * @returns {void}
		 */
		extendState: function( state ) {
			this.setState( $.extend( true, this.getState(), state ) );
		},
	
		/**
		 * Notifies the layout manager of a stateupdate
		 *
		 * @param {serialisable} state
		 */
		setState: function( state ) {
			this._config.componentState = state;
			this.parent.emitBubblingEvent( 'stateChanged' );
		},
	
		/**
		 * Set's the components title
		 *
		 * @param {String} title
		 */
		setTitle: function( title ) {
			this.parent.setTitle( title );
		},
	
		/**
		 * Set's the containers size. Called by the container's component.
		 * To set the size programmatically from within the container please
		 * use the public setSize method
		 *
		 * @param {[Int]} width  in px
		 * @param {[Int]} height in px
		 * 
		 * @returns {void}
		 */
		_$setSize: function( width, height ) {
			if( width !== this.width || height !== this.height ) {
				this.width = width;
				this.height = height;
				this._contentElement.width( this.width ).height( this.height );
				this.emit( 'resize' );
			}
		}
	});
	
	/**
	 * Pops a content item out into a new browser window.
	 * This is achieved by
	 *
	 * 	- Creating a new configuration with the content item as root element
	 * 	- Serializing and minifying the configuration
	 * 	- Opening the current window's URL with the configuration as a GET parameter
	 * 	- GoldenLayout when opened in the new window will look for the GET parameter
	 * 	  and use it instead of the provided configuration
	 *
	 * @param {Object} config GoldenLayout item config
	 * @param {Object} dimensions A map with width, height, top and left
	 * @param {String} parentId The id of the element the item will be appended to on popIn
	 * @param {Number} indexInParent The position of this element within its parent
	 * @param {lm.LayoutManager} layoutManager
	 */
	lm.controls.BrowserPopout = function( config, dimensions, parentId, indexInParent, layoutManager ) {
		lm.utils.EventEmitter.call( this );
		this.isInitialised = false;
	
		this._config = config;
		this._dimensions = dimensions;
		this._parentId = parentId;
		this._indexInParent = indexInParent;
		this._layoutManager = layoutManager;
		this._popoutWindow = null;
		this._id = null;
		this._createWindow();
	};
	
	lm.utils.copy( lm.controls.BrowserPopout.prototype, {
	
		toConfig: function() {
			return {
				dimensions:{
					width: this.getGlInstance().width,
					height: this.getGlInstance().height,
					left: this._popoutWindow.screenX || this._popoutWindow.screenLeft,
					top: this._popoutWindow.screenY || this._popoutWindow.screenTop
				},
				content: this.getGlInstance().toConfig().content,
				parentId: this._parentId,
				indexInParent: this._indexInParent
			};
		},
	
		getGlInstance: function() {
			return this._popoutWindow.__glInstance;
		},
	
		getWindow: function() {
			return this._popoutWindow;
		},
	
		close: function() {
			if( this.getGlInstance() ) {
				this.getGlInstance()._$closeWindow();
			} else {
				try{
					this.getWindow().close();
				} catch( e ){}
			}
		},
	
		/**
		 * Returns the popped out item to its original position. If the original 
		 * parent isn't available anymore it falls back to the layout's topmost element
		 */
		popIn: function() {
			var childConfig, 
				parentItem, 
				index = this._indexInParent;
	
			if( this._parentId ) {
				
				/*
				 * The $.extend call seems a bit pointless, but it's crucial to
				 * copy the config returned by this.getGlInstance().toConfig()
				 * onto a new object. Internet Explorer keeps the references
				 * to objects on the child window, resulting in the following error
				 * once the child window is closed:
				 *
				 * The callee (server [not server application]) is not available and disappeared
				 */
				childConfig = $.extend( true, {}, this.getGlInstance().toConfig() ).content[ 0 ];
				parentItem = this._layoutManager.root.getItemsById( this._parentId )[ 0 ];
				
				/*
				 * Fallback if parentItem is not available. Either add it to the topmost
				 * item or make it the topmost item if the layout is empty
				 */
				if( !parentItem ) {
					if( this._layoutManager.root.contentItems.length > 0 ) {
						parentItem = this._layoutManager.root.contentItems[ 0 ];
					} else {
						parentItem = this._layoutManager.root;
					}
					index = 0;
				}
			}
	
			parentItem.addChild( childConfig, this._indexInParent );
			this.close();
		},
	
		/**
		 * Creates the URL and window parameter
		 * and opens a new window
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_createWindow: function() {
			var checkReadyInterval,
				url = this._createUrl(),
				
				/**
				 * Bogus title to prevent re-usage of existing window with the
				 * same title. The actual title will be set by the new window's
				 * GoldenLayout instance if it detects that it is in subWindowMode
				 */
				title = Math.floor( Math.random() * 1000000 ).toString( 36 ),
	
				/**
				 * The options as used in the window.open string
				 */
				options = this._serializeWindowOptions({
					width: this._dimensions.width,
					height: this._dimensions.height,
					innerWidth: this._dimensions.width,
					innerHeight: this._dimensions.height,
					menubar: 'no',
					toolbar: 'no',
					location: 'no',
					personalbar: 'no',
					resizable: 'yes',
					scrollbars: 'no',
					status: 'no'
				});
	
			this._popoutWindow = window.open( url, title, options );
	
			if( !this._popoutWindow ) {
				if( this._layoutManager.config.settings.blockedPopoutsThrowError === true ) {
					var error = new Error( 'Popout blocked' );
					error.type = 'popoutBlocked';
					throw error;
				} else {
					return;
				}
			}
	
			$( this._popoutWindow )
				.on( 'load', lm.utils.fnBind( this._positionWindow, this ) )
				.on( 'unload beforeunload', lm.utils.fnBind( this._onClose, this ) );
	
			/**
			 * Polling the childwindow to find out if GoldenLayout has been initialised
			 * doesn't seem optimal, but the alternatives - adding a callback to the parent
			 * window or raising an event on the window object - both would introduce knowledge
			 * about the parent to the child window which we'd rather avoid
			 */
			checkReadyInterval = setInterval(lm.utils.fnBind(function(){
				if( this._popoutWindow.__glInstance && this._popoutWindow.__glInstance.isInitialised ) {
					this._onInitialised();
					clearInterval( checkReadyInterval );
				}
			}, this ), 10 );
		},
	
		/**
		 * Serialises a map of key:values to a window options string
		 *
		 * @param   {Object} windowOptions
		 *
		 * @returns {String} serialised window options
		 */
		_serializeWindowOptions: function( windowOptions ) {
			var windowOptionsString = [], key;
	
			for( key in windowOptions ) {
				windowOptionsString.push( key + '=' + windowOptions[ key ] );
			}
	
			return windowOptionsString.join( ',' );
		},
	
		/**
		 * Creates the URL for the new window, including the
		 * config GET parameter
		 *
		 * @returns {String} URL
		 */
		_createUrl: function() {
			var config = { content: this._config },
				storageKey = 'gl-window-config-' + lm.utils.getUniqueId(),
				urlParts;
	
			config = ( new lm.utils.ConfigMinifier() ).minifyConfig( config );
			
			try{
				localStorage.setItem( storageKey, JSON.stringify( config ) );
			} catch( e ) {
				throw new Error( 'Error while writing to localStorage ' + e.toString() );
			}
	
			urlParts = document.location.href.split( '?' );
	
			// URL doesn't contain GET-parameters
			if( urlParts.length === 1 ) {
				return urlParts[ 0 ] + '?gl-window=' + storageKey;
	
			// URL contains GET-parameters
			} else {
				return document.location.href + '&gl-window=' + storageKey;
			}
		},
	
		/**
		 * Move the newly created window roughly to
		 * where the component used to be. 
		 *
		 * @private
		 * 
		 * @returns {void}
		 */
		_positionWindow: function() {
			this._popoutWindow.moveTo( this._dimensions.left, this._dimensions.top );
			this._popoutWindow.focus();
		},
	
		/**
		 * Callback when the new window is opened and the GoldenLayout instance
		 * within it is initialised
		 *
		 * @returns {void}
		 */
		_onInitialised: function() {
			this.isInitialised = true;
			this.getGlInstance().on( 'popIn', this.popIn, this );
			this.emit( 'initialised' );
		},
	
		/**
		 * Invoked 50ms after the window unload event
		 *
		 * @private
		 * 
		 * @returns {void}
		 */
		_onClose: function() {
			setTimeout( lm.utils.fnBind( this.emit, this, [ 'closed' ] ), 50 );
		}
	});
	/**
	 * This class creates a temporary container
	 * for the component whilst it is being dragged
	 * and handles drag events
	 *
	 * @constructor
	 * @private
	 *
	 * @param {Number} x              The initial x position
	 * @param {Number} y              The initial y position
	 * @param {lm.utils.DragListener} dragListener   
	 * @param {lm.LayoutManager} layoutManager
	 * @param {lm.item.AbstractContentItem} contentItem
	 * @param {lm.item.AbstractContentItem} originalParent
	 */
	lm.controls.DragProxy = function( x, y, dragListener, layoutManager, contentItem, originalParent ) {
	
		lm.utils.EventEmitter.call( this );
	
		this._dragListener = dragListener;
		this._layoutManager = layoutManager;
		this._contentItem = contentItem;
		this._originalParent = originalParent;
	
		this._area = null;
		this._lastValidArea = null;
	
		this._dragListener.on( 'drag', this._onDrag, this );
		this._dragListener.on( 'dragStop', this._onDrop, this );
	
		this.element = $( lm.controls.DragProxy._template );
		this.element.css({ left: x, top: y });
		this.element.find( '.lm_tab' ).attr( 'title', lm.utils.stripTags( this._contentItem.config.title ) );
		this.element.find( '.lm_title' ).html( this._contentItem.config.title );
		this.childElementContainer = this.element.find( '.lm_content' );
		this.childElementContainer.append( contentItem.element );
	
		this._updateTree();
		this._layoutManager._$calculateItemAreas();
		this._setDimensions();
	
		$( document.body ).append( this.element );
	
		var offset = this._layoutManager.container.offset();
	
		this._minX = offset.left;
		this._minY = offset.top;
		this._maxX = this._layoutManager.container.width() + this._minX;
		this._maxY = this._layoutManager.container.height() + this._minY;
		this._width = this.element.width();
		this._height = this.element.height();
	
		this._setDropPosition( x, y );
	};
	
	lm.controls.DragProxy._template = '<div class="lm_dragProxy">' +
										'<div class="lm_header">' +
											'<ul class="lm_tabs">' +
												'<li class="lm_tab lm_active"><i class="lm_left"></i>' +
												'<span class="lm_title"></span>' +
												'<i class="lm_right"></i></li>' +
											'</ul>' +
										'</div>' +
										'<div class="lm_content"></div>' +
									'</div>';
	
	lm.utils.copy( lm.controls.DragProxy.prototype, {
	
		/**
		 * Callback on every mouseMove event during a drag. Determines if the drag is
		 * still within the valid drag area and calls the layoutManager to highlight the
		 * current drop area
		 *
		 * @param   {Number} offsetX The difference from the original x position in px
		 * @param   {Number} offsetY The difference from the original y position in px
		 * @param   {jQuery DOM event} event
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_onDrag: function( offsetX, offsetY, event ) {
			var x = event.pageX,
				y = event.pageY,
				isWithinContainer = x > this._minX && x < this._maxX && y > this._minY && y < this._maxY;
	
			if( !isWithinContainer && this._layoutManager.config.settings.constrainDragToContainer === true ) {
				return;
			}
	
			this._setDropPosition( x, y );
		},
	
		/**
		 * Sets the target position, highlighting the appropriate area
		 *
		 * @param   {Number} x The x position in px
		 * @param   {Number} y The y position in px
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_setDropPosition: function( x, y ) {
			this.element.css({ left: x, top: y });
			this._area = this._layoutManager._$getArea( x, y );
	
			if( this._area !== null ) {
				this._lastValidArea = this._area;
				this._area.contentItem._$highlightDropZone( x, y, this._area );
			}
		},
	
		/**
		 * Callback when the drag has finished. Determines the drop area
		 * and adds the child to it
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_onDrop: function() {
			this._layoutManager.dropTargetIndicator.hide();
	
			/*
			 * Valid drop area found
			 */
			if( this._area !== null ) {
				this._area.contentItem._$onDrop( this._contentItem );
	
			/**
			 * No valid drop area available at present, but one has been found before.
			 * Use it
			 */
			} else if( this._lastValidArea !== null ) {
				this._lastValidArea.contentItem._$onDrop( this._contentItem );
	
			/**
			 * No valid drop area found during the duration of the drag. Return
			 * content item to its original position if a original parent is provided.
			 * (Which is not the case if the drag had been initiated by createDragSource)
			 */
			} else if ( this._originalParent ){
				this._originalParent.addChild( this._contentItem );
	
			/**
			 * The drag didn't ultimately end up with adding the content item to
			 * any container. In order to ensure clean up happens, destroy the
			 * content item.
			 */
			} else {
				this._contentItem._$destroy();
			}
			
			this.element.remove();
	
			this._layoutManager.emit( 'itemDropped', this._contentItem );
		},
		
		/**
		 * Removes the item from its original position within the tree
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_updateTree: function() {
			
			/**
			 * parent is null if the drag had been initiated by a external drag source
			 */
			if( this._contentItem.parent ) {
				this._contentItem.parent.removeChild( this._contentItem, true );
			}
			
			this._contentItem._$setParent( this );
		},
		
		/**
		 * Updates the Drag Proxie's dimensions
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_setDimensions: function() {
			var dimensions = this._layoutManager.config.dimensions,
				width = dimensions.dragProxyWidth,
				height = dimensions.dragProxyHeight - dimensions.headerHeight;
		
			this.childElementContainer.width( width );
			this.childElementContainer.height( height );
			this._contentItem.element.width( width );
			this._contentItem.element.height( height );
			this._contentItem.callDownwards( '_$show' );
			this._contentItem.callDownwards( 'setSize' );
		}
	});
	
	/**
	 * Allows for any DOM item to create a component on drag
	 * start tobe dragged into the Layout
	 *
	 * @param {jQuery element} element
	 * @param {Object} itemConfig the configuration for the contentItem that will be created
	 * @param {LayoutManager} layoutManager
	 *
	 * @constructor
	 */
	lm.controls.DragSource = function( element, itemConfig, layoutManager ) {
		this._element = element;
		this._itemConfig = itemConfig;
		this._layoutManager = layoutManager;
		this._dragListener = null;
	
		this._createDragListener();
	};
	
	lm.utils.copy( lm.controls.DragSource.prototype, {
		
		/**
		 * Called initially and after every drag
		 *
		 * @returns {void}
		 */
		_createDragListener: function() {
			if( this._dragListener !== null ) {
				this._dragListener.destroy();
			}
			
			this._dragListener = new lm.utils.DragListener( this._element );
			this._dragListener.on( 'dragStart', this._onDragStart, this );
			this._dragListener.on( 'dragStop', this._createDragListener, this );
		},
	
		/**
		 * Callback for the DragListener's dragStart event
		 *
		 * @param   {int} x the x position of the mouse on dragStart
		 * @param   {int} y the x position of the mouse on dragStart
		 *
		 * @returns {void}
		 */
		_onDragStart: function( x, y ) {
			var itemConfig = this._itemConfig;
			if( lm.utils.isFunction( itemConfig ) ) {
				itemConfig = itemConfig();
			}
			var contentItem = this._layoutManager._$normalizeContentItem( $.extend( true, {}, itemConfig ) ),
				dragProxy = new lm.controls.DragProxy( x, y, this._dragListener, this._layoutManager, contentItem, null );
			
			this._layoutManager.transitionIndicator.transitionElements( this._element, dragProxy.element );
		}
	});
	
	lm.controls.DropTargetIndicator = function() {
		this.element = $( lm.controls.DropTargetIndicator._template );
		$(document.body).append( this.element );
	};
	
	lm.controls.DropTargetIndicator._template = '<div class="lm_dropTargetIndicator"><div class="lm_inner"></div></div>';
	
	lm.utils.copy( lm.controls.DropTargetIndicator.prototype, {
		destroy: function() {
			this.element.remove();
		},
	
		highlight: function( x1, y1, x2, y2 ) {
			this.highlightArea({ x1:x1, y1:y1, x2:x2, y2:y2 });
		},
	
		highlightArea: function( area ) {
			this.element.css({
				left: area.x1,
				top: area.y1,
				width: area.x2 - area.x1,
				height: area.y2 - area.y1
			}).show();
		},
	
		hide: function() {
			this.element.hide();
		}
	});
	/**
	 * This class represents a header above a Stack ContentItem.
	 *
	 * @param {lm.LayoutManager} layoutManager
	 * @param {lm.item.AbstractContentItem} parent
	 */
	lm.controls.Header = function( layoutManager, parent ) {
		lm.utils.EventEmitter.call( this );
	
		this.layoutManager = layoutManager;
		this.element = $( lm.controls.Header._template );
	
		if( this.layoutManager.config.settings.selectionEnabled === true ) {
			this.element.addClass( 'lm_selectable' );
			this.element.click( lm.utils.fnBind( this._onHeaderClick, this ) );
		}
		
		this.element.height( layoutManager.config.dimensions.headerHeight );
		this.tabsContainer = this.element.find( '.lm_tabs' );
		this.controlsContainer = this.element.find( '.lm_controls' );
		this.parent = parent;
		this.parent.on( 'resize', this._updateTabSizes, this );
		this.tabs = [];
		this.activeContentItem = null;
		this.closeButton = null;
	
		this._createControls();
	};
	
	lm.controls.Header._template = [
		'<div class="lm_header">',
			'<ul class="lm_tabs"></ul>',
			'<ul class="lm_controls"></ul>',
		'</div>'
	].join( '' );
	
	lm.utils.copy( lm.controls.Header.prototype, {
	
		/**
		 * Creates a new tab and associates it with a contentItem
		 *
		 * @param	{lm.item.AbstractContentItem} contentItem
		 * @param	{Integer} index The position of the tab
		 *
		 * @returns {void}
		 */
		createTab: function( contentItem, index ) {
			var tab, i;
	
			//If there's already a tab relating to the
			//content item, don't do anything
			for( i = 0; i < this.tabs.length; i++ ) {
				if( this.tabs[ i ].contentItem === contentItem ) {
					return;
				}
			}
	
			tab = new lm.controls.Tab( this, contentItem );
			
			if( this.tabs.length === 0 ) {
				this.tabs.push( tab );
				this.tabsContainer.append( tab.element );
				return;
			}
		
			if( index === undefined ) {
				index = this.tabs.length;
			}
		
			if( index > 0 ) {
				this.tabs[ index - 1 ].element.after( tab.element );
			} else {
				this.tabs[ 0 ].element.before( tab.element );
			}
		
			this.tabs.splice( index, 0, tab );
			this._updateTabSizes();
		},
	
		/**
		 * Finds a tab based on the contentItem its associated with and removes it.
		 *
		 * @param	{lm.item.AbstractContentItem} contentItem
		 *
		 * @returns {void}
		 */
		removeTab: function( contentItem ) {
			for( var i = 0; i < this.tabs.length; i++ ) {
				if( this.tabs[ i ].contentItem === contentItem ) {
					this.tabs[ i ]._$destroy();
					this.tabs.splice( i, 1 );
					return;
				}
			}
		
			throw new Error( 'contentItem is not controlled by this header' );
		},
		
		/**
		 * The programmatical equivalent of clicking a Tab.
		 *
		 * @param {lm.item.AbstractContentItem} contentItem
		 */
		setActiveContentItem: function( contentItem ) {
			var i, isActive;
	
			for( i = 0; i < this.tabs.length; i++ ) {
				isActive = this.tabs[ i ].contentItem === contentItem;
				this.tabs[ i ].setActive( isActive );
				if( isActive === true ) {
					this.activeContentItem = contentItem;
					this.parent.config.activeItemIndex = i;
				}
			}
	
			this._updateTabSizes();
			this.parent.emitBubblingEvent( 'stateChanged' );
		},
	
		/**
		 * Programmatically set closability.
		 *
		 * @package private
		 * @param {Boolean} isClosable Whether to enable/disable closability.
		 *
		 * @returns {Boolean} Whether the action was successful
		 */
		_$setClosable: function( isClosable ) {
			if ( this.closeButton && this._isClosable() ) {
				this.closeButton.element[ isClosable ? "show" : "hide" ]();
				return true;
			}
	
			return false;
		},
	
		/**
		 * Destroys the entire header
		 *
		 * @package private
		 * 
		 * @returns {void}
		 */
		_$destroy: function() {
			this.emit( 'destroy' );
		
			for( var i = 0; i < this.tabs.length; i++ ) {
				this.tabs[ i ]._$destroy();
			}
		
			this.element.remove();
		},
	
		/**
		 * Creates the popout, maximise and close buttons in the header's top right corner
		 *
		 * @returns {void}
		 */
		_createControls: function() {
			var closeStack,
				popout,
				label,
				maximiseLabel,
				minimiseLabel,
				maximise,
				maximiseButton;
	
			/**
			 * Popout control to launch component in new window.
			 */
			if( this.layoutManager.config.settings.showPopoutIcon ) {
				popout = lm.utils.fnBind( this._onPopoutClick, this );
				label = this.layoutManager.config.labels.popout;
				new lm.controls.HeaderButton( this, label, 'lm_popout', popout );
			}
	
			/**
			 * Maximise control - set the component to the full size of the layout
			 */
			if( this.layoutManager.config.settings.showMaximiseIcon ) {
				maximise = lm.utils.fnBind( this.parent.toggleMaximise, this.parent );
				maximiseLabel = this.layoutManager.config.labels.maximise;
				minimiseLabel = this.layoutManager.config.labels.minimise;
				maximiseButton = new lm.controls.HeaderButton( this, maximiseLabel, 'lm_maximise', maximise );
				
				this.parent.on( 'maximised', function(){
					maximiseButton.element.attr( 'title', minimiseLabel );
				});
	
				this.parent.on( 'minimised', function(){
					maximiseButton.element.attr( 'title', maximiseLabel );
				});
			}
	
			/**
			 * Close button
			 */
			if( this._isClosable() ) {
				closeStack = lm.utils.fnBind( this.parent.remove, this.parent );
				label = this.layoutManager.config.labels.close;
				this.closeButton = new lm.controls.HeaderButton( this, label, 'lm_close', closeStack );
			}
		},
	
		/**
		 * Checks whether the header is closable based on the parent config and 
		 * the global config.
		 *
		 * @returns {Boolean} Whether the header is closable.
		 */
		_isClosable: function() {
			return this.parent.config.isClosable && this.layoutManager.config.settings.showCloseIcon;
		},
	
		_onPopoutClick: function() {
			if( this.layoutManager.config.settings.popoutWholeStack === true ) {
				this.parent.popout();
			} else {
				this.activeContentItem.popout();
			}
		},
	
	
		/**
		 * Invoked when the header's background is clicked (not it's tabs or controls)
		 *
		 * @param	{jQuery DOM event} event
		 *
		 * @returns {void}
		 */
		_onHeaderClick: function( event ) {
			if( event.target === this.element[ 0 ] ) {
				this.parent.select();
			}
		},
	
		/**
		 * Shrinks the tabs if the available space is not sufficient
		 *
		 * @returns {void}
		 */
		_updateTabSizes: function() {
			if( this.tabs.length === 0 ) {
				return;
			}
			
			var availableWidth = this.element.outerWidth() - this.controlsContainer.outerWidth(),
				totalTabWidth = 0,
				tabElement,
				i,
				marginLeft,
				gap;
	
			for( i = 0; i < this.tabs.length; i++ ) {
				tabElement = this.tabs[ i ].element;
	
				/*
				 * In order to show every tab's close icon, decrement the z-index from left to right
				 */
				tabElement.css( 'z-index', this.tabs.length - i );
				totalTabWidth += tabElement.outerWidth() + parseInt( tabElement.css( 'margin-right' ), 10 );
			}
	
			gap = ( totalTabWidth - availableWidth ) / ( this.tabs.length - 1 );
	
			for( i = 0; i < this.tabs.length; i++ ) {
	
				/*
				 * The active tab keeps it's original width
				 */
				if( !this.tabs[ i ].isActive && gap > 0 ) {
					marginLeft = '-' + Math.floor( gap )+ 'px';
				} else {
					marginLeft = '';
				}
	
				this.tabs[ i ].element.css( 'margin-left', marginLeft );
			}
	
			if( availableWidth < totalTabWidth ) {
				this.element.css( 'overflow', 'hidden' );
			} else {
				this.element.css( 'overflow', 'visible' );
			}
		}
	});
	
	
	lm.controls.HeaderButton = function( header, label, cssClass, action ) {
		this._header = header;
		this.element = $( '<li class="' + cssClass + '" title="' + label + '"></li>' );
		this._header.on( 'destroy', this._$destroy, this );
		this._action = action;
		this.element.click( this._action );
		this._header.controlsContainer.append( this.element );
	};
	
	lm.utils.copy( lm.controls.HeaderButton.prototype, {
		_$destroy: function() {
			this.element.off();
			this.element.remove();
		}
	});
	lm.controls.Splitter = function( isVertical, size ) {
		this._isVertical = isVertical;
		this._size = size;
	
		this.element = this._createElement();
		this._dragListener = new lm.utils.DragListener( this.element );
	};
	
	lm.utils.copy( lm.controls.Splitter.prototype, {
		on: function( event, callback, context ) {
			this._dragListener.on( event, callback, context );
		},
	
		_$destroy: function() {
			this.element.remove();
		},
	
		_createElement: function() {
			var element = $( '<div class="lm_splitter"><div class="lm_drag_handle"></div></div>' );
			element.addClass( 'lm_' + ( this._isVertical ? 'vertical' : 'horizontal' ) );
			element[ this._isVertical ? 'height' : 'width' ]( this._size );
	
			return element;
		}
	});
	
	/**
	 * Represents an individual tab within a Stack's header
	 *
	 * @param {lm.controls.Header} header
	 * @param {lm.items.AbstractContentItem} contentItem
	 *
	 * @constructor
	 */
	lm.controls.Tab = function( header, contentItem ) {
		this.header = header;
		this.contentItem = contentItem;
		this.element = $( lm.controls.Tab._template );
		this.titleElement = this.element.find( '.lm_title' );
		this.closeElement = this.element.find( '.lm_close_tab' );
		this.closeElement[ contentItem.config.isClosable ? 'show' : 'hide' ]();
		this.isActive = false;
	
		this.setTitle( contentItem.config.title );
		this.contentItem.on( 'titleChanged', this.setTitle, this );
	
		this._layoutManager = this.contentItem.layoutManager;
	
		if(
			this._layoutManager.config.settings.reorderEnabled === true &&
			contentItem.config.reorderEnabled === true
		) {
			this._dragListener = new lm.utils.DragListener( this.element );
			this._dragListener.on( 'dragStart', this._onDragStart, this );
		}
	
		this._onTabClickFn = lm.utils.fnBind( this._onTabClick, this );
		this._onCloseClickFn = lm.utils.fnBind( this._onCloseClick, this );
	
		this.element.click( this._onTabClickFn );
	
		if( this.contentItem.config.isClosable ) {
			this.closeElement.click( this._onCloseClickFn );
		} else {
			this.closeElement.remove();
		}
	
		this.contentItem.tab = this;
		this.contentItem.emit( 'tab', this );
		this.contentItem.layoutManager.emit( 'tabCreated', this );
	
		if( this.contentItem.isComponent ) {
			this.contentItem.container.tab = this;
			this.contentItem.container.emit( 'tab', this );
		}
	};
	
	/**
	 * The tab's html template
	 *
	 * @type {String}
	 */
	lm.controls.Tab._template = '<li class="lm_tab"><i class="lm_left"></i>' +
								'<span class="lm_title"></span><div class="lm_close_tab"></div>' +
								'<i class="lm_right"></i></li>';
	
	lm.utils.copy( lm.controls.Tab.prototype,{
	
		/**
		 * Sets the tab's title to the provided string and sets
		 * its title attribute to a pure text representation (without
		 * html tags) of the same string.
		 *
		 * @public
		 * @param {String} title can contain html
		 */
		setTitle: function( title ) {
			this.element.attr( 'title', lm.utils.stripTags( title ) );
			this.titleElement.html( title );
		},
	
		/**
		 * Sets this tab's active state. To programmatically
		 * switch tabs, use header.setActiveContentItem( item ) instead.
		 *
		 * @public
		 * @param {Boolean} isActive
		 */
		setActive: function( isActive ) {
			if( isActive === this.isActive ) {
				return;
			}
			this.isActive = isActive;
	
			if( isActive ) {
				this.element.addClass( 'lm_active' );
			} else {
				this.element.removeClass( 'lm_active');
			}
		},
	
		/**
		 * Destroys the tab
		 *
		 * @private
		 * @returns {void}
		 */
		_$destroy: function() {
			this.element.off( 'click', this._onTabClickFn );
			this.closeElement.off( 'click', this._onCloseClickFn );
			if( this._dragListener ) {
				this._dragListener.off( 'dragStart', this._onDragStart );
				this._dragListener = null;
			}
			this.element.remove();
		},
	
		/**
		 * Callback for the DragListener
		 *
		 * @param   {Number} x The tabs absolute x position
		 * @param   {Number} y The tabs absolute y position
		 *
		 * @private
		 * @returns {void}
		 */
		_onDragStart: function( x, y ) {
			if( this.contentItem.parent.isMaximised === true ) {
				this.contentItem.parent.toggleMaximise();
			}
			new lm.controls.DragProxy(
				x,
				y,
				this._dragListener,
				this._layoutManager,
				this.contentItem,
				this.header.parent
			);
		},
	
		/**
		 * Callback when the tab is clicked
		 *
		 * @param {jQuery DOM event} event
		 *
		 * @private
		 * @returns {void}
		 */
		_onTabClick: function( event ) {
			// left mouse button
			if( event.button === 0 ) {
				var activeContentItem = this.header.parent.getActiveContentItem();
				if (this.contentItem !== activeContentItem) {
					this.header.parent.setActiveContentItem( this.contentItem );
				}
	
			// middle mouse button
			} else if( event.button === 1 && this.contentItem.config.isClosable ) {
				this._onCloseClick( event );
			}
		},
	
		/**
		 * Callback when the tab's close button is
		 * clicked
		 *
		 * @param   {jQuery DOM event} event
		 *
		 * @private
		 * @returns {void}
		 */
		_onCloseClick: function( event ) {
			event.stopPropagation();
			this.header.parent.removeChild( this.contentItem );
		}
	});
	
	lm.controls.TransitionIndicator = function() {
		this._element = $( '<div class="lm_transition_indicator"></div>' );
		$( document.body ).append( this._element );
	
		this._toElement = null;
		this._fromDimensions = null;
		this._totalAnimationDuration = 200;
		this._animationStartTime = null;
	};
	
	lm.utils.copy( lm.controls.TransitionIndicator.prototype, {
		destroy: function() {
			this._element.remove();
		},
	
		transitionElements: function( fromElement, toElement ) {
			/**
			 * TODO - This is not quite as cool as expected. Review.
			 */
			return;
			this._toElement = toElement;
			this._animationStartTime = lm.utils.now();
			this._fromDimensions = this._measure( fromElement );
			this._fromDimensions.opacity = 0.8;
			this._element.show().css( this._fromDimensions );
			lm.utils.animFrame( lm.utils.fnBind( this._nextAnimationFrame, this ) );
		},
	
		_nextAnimationFrame: function() {
			var toDimensions = this._measure( this._toElement ),
				animationProgress = ( lm.utils.now() - this._animationStartTime ) / this._totalAnimationDuration,
				currentFrameStyles = {},
				cssProperty;
	
			if( animationProgress >= 1 ) {
				this._element.hide();
				return;
			}
	
			toDimensions.opacity = 0;
	
			for( cssProperty in this._fromDimensions ) {
				currentFrameStyles[ cssProperty ] = this._fromDimensions[ cssProperty ] +
				( toDimensions[ cssProperty] - this._fromDimensions[ cssProperty ] ) *
				animationProgress;
			}
			
			this._element.css( currentFrameStyles );
			lm.utils.animFrame( lm.utils.fnBind( this._nextAnimationFrame, this ) );
		},
	
		_measure: function( element ) {
			var offset = element.offset();
	
			return {
				left: offset.left,
				top: offset.top,
				width: element.outerWidth(),
				height: element.outerHeight()
			};
		}
	});
	lm.errors.ConfigurationError = function( message, node ) {
		Error.call( this );
	
		this.name = 'Configuration Error';
		this.message = message;
		this.node = node;
	};
	
	lm.errors.ConfigurationError.prototype = new Error();
	
	
	/**
	 * This is the baseclass that all content items inherit from.
	 * Most methods provide a subset of what the sub-classes do.
	 *
	 * It also provides a number of functions for tree traversal
	 *
	 * @param {lm.LayoutManager} layoutManager
	 * @param {item node configuration} config
	 * @param {lm.item} parent
	 *
	 * @event stateChanged
	 * @event beforeItemDestroyed
	 * @event itemDestroyed
	 * @event itemCreated
	 * @event componentCreated
	 * @event rowCreated
	 * @event columnCreated
	 * @event stackCreated
	 *
	 * @constructor
	 */
	lm.items.AbstractContentItem = function( layoutManager, config, parent ) {
		lm.utils.EventEmitter.call( this );
	
		this.config = this._extendItemNode( config );
		this.type = config.type;
		this.contentItems = [];
		this.parent = parent;
	
		this.isInitialised = false;
		this.isMaximised = false;
		this.isRoot = false;
		this.isRow = false;
		this.isColumn = false;
		this.isStack = false;
		this.isComponent = false;
	
		this.layoutManager = layoutManager;
		this._pendingEventPropagations = {};
		this._throttledEvents = [ 'stateChanged' ];
	
		this.on( lm.utils.EventEmitter.ALL_EVENT, this._propagateEvent, this );
		
		if( config.content ) {
			this._createContentItems( config );
		}
	};
	
	lm.utils.copy( lm.items.AbstractContentItem.prototype, {
		
		/**
		 * Set the size of the component and its children, called recursively
		 *
		 * @abstract
		 * @returns void
		 */
		setSize: function() {
			throw new Error( 'Abstract Method' );
		},
	
		/**
		 * Calls a method recursively downwards on the tree
		 *
		 * @param   {String} functionName      the name of the function to be called
		 * @param   {[Array]}functionArguments optional arguments that are passed to every function
		 * @param   {[bool]} bottomUp          Call methods from bottom to top, defaults to false
		 * @param   {[bool]} skipSelf          Don't invoke the method on the class that calls it, defaults to false
		 *
		 * @returns {void}
		 */
		callDownwards: function( functionName, functionArguments, bottomUp, skipSelf ) {
			var i;
	
			if( bottomUp !== true && skipSelf !== true ) {
				this[ functionName ].apply( this, functionArguments || [] );
			}
			for( i = 0; i < this.contentItems.length; i++ ) {
				this.contentItems[ i ].callDownwards( functionName, functionArguments, bottomUp );
			}
			if( bottomUp === true && skipSelf !== true ) {
				this[ functionName ].apply( this, functionArguments || [] );
			}
		},
	
		/**
		 * Removes a child node (and its children) from the tree
		 *
		 * @param   {lm.items.ContentItem} contentItem
		 *
		 * @returns {void}
		 */
		removeChild: function( contentItem, keepChild ) {
			
			/*
			 * Get the position of the item that's to be removed within all content items this node contains
			 */
			var index = lm.utils.indexOf( contentItem, this.contentItems );
	
			/*
			 * Make sure the content item to be removed is actually a child of this item
			 */
			if( index === -1 ) {
				throw new Error( 'Can\'t remove child item. Unknown content item' );
			}
	
			/**
			 * Call ._$destroy on the content item. This also calls ._$destroy on all its children
			 */
			if( keepChild !== true ) {
				this.contentItems[ index ]._$destroy();
			}
			
			/**
			 * Remove the content item from this nodes array of children
			 */
			this.contentItems.splice( index, 1 );
	
			/**
			 * Remove the item from the configuration
			 */
			this.config.content.splice( index, 1 );
	
			/**
			 * If this node still contains other content items, adjust their size
			 */
			if( this.contentItems.length > 0 ) {
				this.callDownwards( 'setSize' );
	
			/**
			 * If this was the last content item, remove this node as well
			 */
			} else if( !(this instanceof lm.items.Root) && this.config.isClosable === true ) {
				this.parent.removeChild( this );
			}
		},
	
		/**
		 * Sets up the tree structure for the newly added child
		 * The responsibility for the actual DOM manipulations lies
		 * with the concrete item
		 *
		 * @param {lm.items.AbstractContentItem} contentItem
		 * @param {[Int]} index If omitted item will be appended
		 */
		addChild: function( contentItem, index ) {
			if ( index === undefined ) {
				index = this.contentItems.length;
			}
	
			this.contentItems.splice( index, 0, contentItem );
	
			if( this.config.content === undefined ) {
				this.config.content = [];
			}
	
			this.config.content.splice( index, 0, contentItem.config );
			contentItem.parent = this;
			
			if( contentItem.parent.isInitialised === true && contentItem.isInitialised === false ) {
				contentItem._$init();
			}
		},
	
		/**
		 * Replaces oldChild with newChild. This used to use jQuery.replaceWith... which for
		 * some reason removes all event listeners, so isn't really an option.
		 *
		 * @param   {lm.item.AbstractContentItem} oldChild
		 * @param   {lm.item.AbstractContentItem} newChild
		 *
		 * @returns {void}
		 */
		replaceChild: function( oldChild, newChild, _$destroyOldChild ) {
	
			newChild = this.layoutManager._$normalizeContentItem( newChild );
	
			var index = lm.utils.indexOf( oldChild, this.contentItems ),
				parentNode = oldChild.element[ 0 ].parentNode;
	
			if( index === -1 ) {
				throw new Error( 'Can\'t replace child. oldChild is not child of this' );
			}
	
			parentNode.replaceChild( newChild.element[ 0 ], oldChild.element[ 0 ] );
	
			/*
			 * Optionally destroy the old content item
			 */
			if( _$destroyOldChild === true ) {
				oldChild.parent = null;
				oldChild._$destroy();
			}
			
			/*
			 * Wire the new contentItem into the tree
			 */
			this.contentItems[ index ] = newChild;
			newChild.parent = this;
	
			/*
			 * Update tab reference
			 */
			if ( this.isStack ) {
				this.header.tabs[ index ].contentItem = newChild;
			}
	
			//TODO This doesn't update the config... refactor to leave item nodes untouched after creation
			if( newChild.parent.isInitialised === true && newChild.isInitialised === false ) {
				newChild._$init();
			}
	
			this.callDownwards( 'setSize' );
		},
	
		/**
		 * Convenience method. 
		 * Shorthand for this.parent.removeChild( this )
		 *
		 * @returns {void}
		 */
		remove: function() {
			this.parent.removeChild( this );
		},
	
		/**
		 * Removes the component from the layout and creates a new 
		 * browser window with the component and its children inside
		 *
		 * @returns {lm.controls.BrowserPopout}
		 */
		popout: function() {
			var browserPopout = this.layoutManager.createPopout( this );
			this.emitBubblingEvent( 'stateChanged' );
			return browserPopout;
		},
	
		/**
		 * Maximises the Item or minimises it if it is already maximised
		 *
		 * @returns {void}
		 */
		toggleMaximise: function() {
			if( this.isMaximised === true ) {
				this.layoutManager._$minimiseItem( this );
			} else {
				this.layoutManager._$maximiseItem( this );
			}
	
			this.isMaximised = !this.isMaximised;
			this.emitBubblingEvent( 'stateChanged' );
		},
	
		/**
		 * Selects the item if it is not already selected
		 *
		 * @returns {void}
		 */
		select: function() {
			if( this.layoutManager.selectedItem !== this ) {
				this.layoutManager.selectItem( this, true );
				this.element.addClass( 'lm_selected' );
			}
		},
	
		/**
		 * De-selects the item if it is selected
		 *
		 * @returns {void}
		 */
		deselect: function() {
			if( this.layoutManager.selectedItem === this ) {
				this.layoutManager.selectedItem = null;
				this.element.removeClass( 'lm_selected' );
			}
		},
	
		/**
		 * Set this component's title
		 * 
		 * @public
		 * @param {String} title
		 *
		 * @returns {void}
		 */
		setTitle: function( title ) {
			this.config.title = title;
			this.emit( 'titleChanged', title );
			this.emit( 'stateChanged' );
		},
	
		/**
		 * Checks whether a provided id is present
		 *
		 * @public
		 * @param   {String}  id
		 *
		 * @returns {Boolean} isPresent
		 */
		hasId: function( id ) {
			if( !this.config.id ) {
				return false;
			} else if( typeof this.config.id === 'string' ) {
				return this.config.id === id;
			} else if( this.config.id instanceof Array ) {
				return lm.utils.indexOf( id, this.config.id ) !== -1;
			}
		},
	
		/**
		 * Adds an id. Adds it as a string if the component doesn't
		 * have an id yet or creates/uses an array
		 *
		 * @public
		 * @param {String} id
		 *
		 * @returns {void}
		 */
		addId: function( id ) {
			if( this.hasId( id ) ) {
				return;
			}
	
			if( !this.config.id ) {
				this.config.id = id;
			} else if( typeof this.config.id === 'string' ) {
				this.config.id = [ this.config.id, id ];
			} else if( this.config.id instanceof Array ) {
				this.config.id.push( id );
			}
		},
	
		/**
		 * Removes an existing id. Throws an error
		 * if the id is not present
		 *
		 * @public
		 * @param   {String} id
		 *
		 * @returns {void}
		 */
		removeId: function( id ) {
			if( !this.hasId( id ) ) {
				throw new Error( 'Id not found' );
			}
			
			if( typeof this.config.id === 'string' ) {
				delete this.config.id;
			} else if( this.config.id instanceof Array ) {
				var index = lm.utils.indexOf( id, this.config.id );
				this.config.id.splice( index, 1 );
			}
		},
	
		/****************************************
		* SELECTOR
		****************************************/
		getItemsByFilter: function( filter ) {
			var result = [],
				next = function( contentItem ) {
					for( var i = 0; i < contentItem.contentItems.length; i++ ) {
						
						if( filter( contentItem.contentItems[ i ] ) === true ) {
							result.push( contentItem.contentItems[ i ] );
						}
	
						next( contentItem.contentItems[ i ] );
					}
				};
	
			next( this );
			return result;
		},
	
		getItemsById: function( id ) {
			return this.getItemsByFilter( function( item ){
				if( item.config.id instanceof Array ) {
					return lm.utils.indexOf( id, item.config.id ) !== -1;
				} else {
					return item.config.id === id;
				}
			});
		},
	
		getItemsByType: function( type ) {
			return this._$getItemsByProperty( 'type', type );
		},
	
		getComponentsByName: function( componentName ) {
			var components = this._$getItemsByProperty( 'componentName', componentName ),
				instances = [],
				i;
	
			for( i = 0; i < components.length; i++ ) {
				instances.push( components[ i ].instance );
			}
	
			return instances;
		},
	
		/****************************************
		* PACKAGE PRIVATE
		****************************************/
		_$getItemsByProperty: function( key, value ) {
			return this.getItemsByFilter( function( item ){
				return item[ key ] === value;
			});
		},
	
		_$setParent: function( parent ) {
			this.parent = parent;
		},
	
		_$highlightDropZone: function( x, y, area ) {
			this.layoutManager.dropTargetIndicator.highlightArea( area );
		},
	
		_$onDrop: function( contentItem ) {
			this.addChild( contentItem );
		},
	
		_$hide: function() {
			this._callOnActiveComponents( 'hide' );
			this.element.hide();
			this.layoutManager.updateSize();
		},
	
		_$show: function() {
			this._callOnActiveComponents( 'show' );
			this.element.show();
			this.layoutManager.updateSize();
			this._callOnActiveComponents( 'shown' );
		},
	
		_callOnActiveComponents: function( methodName ) {
			var stacks = this.getItemsByType( 'stack' ),
				activeContentItem,
				i;
	
			for( i = 0; i < stacks.length; i++ ) {
				activeContentItem = stacks[ i ].getActiveContentItem();
	
				if( activeContentItem && activeContentItem.isComponent ) {
					activeContentItem.container[ methodName ]();
				}
			}
		},
		
		/**
		 * Destroys this item ands its children
		 *
		 * @returns {void}
		 */
		_$destroy: function() {
			this.emitBubblingEvent( 'beforeItemDestroyed' );
			this.callDownwards( '_$destroy', [], true, true );
			this.element.remove();
			this.emitBubblingEvent( 'itemDestroyed' );
		},
	
		/**
		 * Returns the area the component currently occupies in the format
		 *
		 * {
		 *		x1: int
		 *		xy: int
		 *		y1: int
		 *		y2: int
		 *		contentItem: contentItem
		 * }
		 */
		_$getArea: function( element ) {
			element = element || this.element;
	
			var offset = element.offset(),
				width = element.width(),
				height = element.height();
	
			return {
				x1: offset.left,
				y1: offset.top,
				x2: offset.left + width,
				y2: offset.top + height,
				surface: width * height,
				contentItem: this
			};
		},
	
		/**
		 * The tree of content items is created in two steps: First all content items are instantiated,
		 * then init is called recursively from top to bottem. This is the basic init function,
		 * it can be used, extended or overwritten by the content items
		 * 
		 * Its behaviour depends on the content item
		 *
		 * @package private
		 * 
		 * @returns {void}
		 */
		_$init: function() {
			var i;
			this.setSize();
	
			for( i = 0; i < this.contentItems.length; i++ ) {
				this.childElementContainer.append( this.contentItems[ i ].element );
			}
	
			this.isInitialised = true;
			this.emitBubblingEvent( 'itemCreated' );
			this.emitBubblingEvent( this.type + 'Created' );
		},
	
		/**
		 * Emit an event that bubbles up the item tree.
		 *
		 * @param   {String} name The name of the event
		 *
		 * @returns {void}
		 */
		emitBubblingEvent: function( name ) {
			var event = new lm.utils.BubblingEvent( name, this );
			this.emit( name, event );
		},
	
		/**
		 * Private method, creates all content items for this node at initialisation time
		 * PLEASE NOTE, please see addChild for adding contentItems add runtime
		 * @private
		 * @param   {configuration item node} config
		 *
		 * @returns {void}
		 */
		_createContentItems: function( config ) {
			var oContentItem, i;
	
			if( !( config.content instanceof Array ) ) {
				throw new lm.errors.ConfigurationError( 'content must be an Array', config );
			}
	
			for( i = 0; i < config.content.length; i++ ) {
				oContentItem = this.layoutManager.createContentItem( config.content[ i ], this );
				this.contentItems.push( oContentItem );
			}
		},
	
		/**
		 * Extends an item configuration node with default settings
		 * @private
		 * @param   {configuration item node} config
		 *
		 * @returns {configuration item node} extended config
		 */
		_extendItemNode: function( config ) {
			
			for( var key in lm.config.itemDefaultConfig ) {
				if( config[ key ] === undefined ) {
					config[ key ] = lm.config.itemDefaultConfig[ key ];
				}
			}
			
			return config;
		},
	
		/**
		 * Called for every event on the item tree. Decides whether the event is a bubbling
		 * event and propagates it to its parent
		 *
		 * @param	{String} name the name of the event
		 * @param   {lm.utils.BubblingEvent} event 
		 *
		 * @returns {void}
		 */
		_propagateEvent: function( name, event ) {
			if( event instanceof lm.utils.BubblingEvent &&
				event.isPropagationStopped === false &&
				this.isInitialised === true ) {
				
				/**
				 * In some cases (e.g. if an element is created from a DragSource) it
				 * doesn't have a parent and is not below root. If that's the case
				 * propagate the bubbling event from the top level of the substree directly
				 * to the layoutManager
				 */
				if( this.isRoot === false && this.parent ) {
					this.parent.emit.apply( this.parent, Array.prototype.slice.call( arguments, 0 ) );
				} else {
					this._scheduleEventPropagationToLayoutManager( name, event );
				}
			}
		},
	
		/**
		 * All raw events bubble up to the root element. Some events that
		 * are propagated to - and emitted by - the layoutManager however are
		 * only string-based, batched and sanitized to make them more usable
		 *
		 * @param {String} name the name of the event
		 *
		 * @private
		 * @returns {void}
		 */
		_scheduleEventPropagationToLayoutManager: function( name, event ) {
			if( lm.utils.indexOf( name, this._throttledEvents ) === -1 ) {
				this.layoutManager.emit( name, event.origin );
			} else {
				if( this._pendingEventPropagations[ name ] !== true ) {
					this._pendingEventPropagations[ name ] = true;
					lm.utils.animFrame( lm.utils.fnBind( this._propagateEventToLayoutManager, this, [ name, event ] ) );
				}
			}
			
		},
	
		/**
		 * Callback for events scheduled by _scheduleEventPropagationToLayoutManager
		 *
		 * @param {String} name the name of the event
		 *
		 * @private
		 * @returns {void}
		 */
		_propagateEventToLayoutManager: function( name, event ) {
			this._pendingEventPropagations[ name ] = false;
			this.layoutManager.emit( name, event );
		}
	});
	
	/**
	 * @param {[type]} layoutManager [description]
	 * @param {[type]} config      [description]
	 * @param {[type]} parent        [description]
	 */
	lm.items.Component = function( layoutManager, config, parent ) {
		lm.items.AbstractContentItem.call( this, layoutManager, config, parent );
	
		var ComponentConstructor = layoutManager.getComponent( this.config.componentName ),
			componentConfig = $.extend( true, {}, this.config.componentState || {} );
	
		componentConfig.componentName = this.config.componentName;
		this.componentName = this.config.componentName;
	
		if( this.config.title === '' ) {
			this.config.title = this.config.componentName;
		}
	
		this.isComponent = true;
		this.container = new lm.container.ItemContainer( this.config, this, layoutManager );
		this.instance = new ComponentConstructor( this.container, componentConfig  );
		this.element = this.container._element;
	};
	
	lm.utils.extend( lm.items.Component, lm.items.AbstractContentItem );
	
	lm.utils.copy( lm.items.Component.prototype, {
	
		close: function() {
			this.parent.removeChild( this );
		},
	
		setSize: function() {
			this.container._$setSize( this.element.width(), this.element.height() );
		},
	
		_$init: function() {
			lm.items.AbstractContentItem.prototype._$init.call( this );
			this.container.emit( 'open' );
		},
	
		_$hide: function() {
			this.container.hide();
			lm.items.AbstractContentItem.prototype._$hide.call( this );
		},
	
		_$show: function() {
			this.container.show();
			lm.items.AbstractContentItem.prototype._$show.call( this );
		},
		
		_$shown: function() {
			this.container.shown();
			lm.items.AbstractContentItem.prototype._$shown.call( this );
		},
	
		_$destroy: function() {
			this.container.emit( 'destroy' );
			lm.items.AbstractContentItem.prototype._$destroy.call( this );
		},
	
		/**
		 * Dragging onto a component directly is not an option
		 *
		 * @returns null
		 */
		_$getArea: function() {
			return null;
		}
	});
	lm.items.Root = function( layoutManager, config, containerElement ) {
		lm.items.AbstractContentItem.call( this, layoutManager, config, null );
		this.isRoot = true;
		this.type = 'root';
		this.element = $( '<div class="lm_goldenlayout lm_item lm_root"></div>' );
		this.childElementContainer = this.element;
		this._containerElement = containerElement;
		this._containerElement.append( this.element );
	};
	
	lm.utils.extend( lm.items.Root, lm.items.AbstractContentItem );
	
	lm.utils.copy( lm.items.Root.prototype, {
		addChild: function( contentItem ) {
			if( this.contentItems.length > 0 ) {
				throw new Error( 'Root node can only have a single child' );
			}
	
			contentItem = this.layoutManager._$normalizeContentItem( contentItem, this );
			this.childElementContainer.append( contentItem.element );
			lm.items.AbstractContentItem.prototype.addChild.call( this, contentItem );
			
			this.callDownwards( 'setSize' );
			this.emitBubblingEvent( 'stateChanged' );
		},
	
		setSize: function() {
			var width = this._containerElement.width(),
				height = this._containerElement.height();
	
			this.element.width( width );
			this.element.height( height );
	
			/*
			 * Root can be empty
			 */
			if( this.contentItems[ 0 ] ) {
				this.contentItems[ 0 ].element.width( width );
				this.contentItems[ 0 ].element.height( height );
			}
		},
	
		_$onDrop: function( contentItem ) {
			var stack;
	
			if( contentItem.isComponent === true ) {
				stack = this.layoutManager.createContentItem( {type: 'stack' }, this );
				stack.addChild( contentItem );
				this.addChild( stack );
			} else {
				this.addChild( contentItem );
			}
		}
	});
	
	
	
	lm.items.RowOrColumn = function( isColumn, layoutManager, config, parent ) {
		lm.items.AbstractContentItem.call( this, layoutManager, config, parent );
	
		this.isRow = !isColumn;
		this.isColumn = isColumn;
		
		this.element = $( '<div class="lm_item lm_' + ( isColumn ? 'column' : 'row' ) + '"></div>' );
		this.childElementContainer = this.element;
		this._splitterSize = layoutManager.config.dimensions.borderWidth;
		this._isColumn = isColumn;
		this._dimension = isColumn ? 'height' : 'width';
		this._splitter = [];
		this._splitterPosition = null;
		this._splitterMinPosition = null;
		this._splitterMaxPosition = null;
	};
	
	lm.utils.extend( lm.items.RowOrColumn, lm.items.AbstractContentItem );
	
	lm.utils.copy( lm.items.RowOrColumn.prototype, {
		
		/**
		 * Add a new contentItem to the Row or Column
		 *
		 * @param {lm.item.AbstractContentItem} contentItem
		 * @param {[int]} index The position of the new item within the Row or Column.
		 *                      If no index is provided the item will be added to the end
		 * @param {[bool]} _$suspendResize If true the items won't be resized. This will leave the item in
		 *                                 an inconsistent state and is only intended to be used if multiple
		 *                                 children need to be added in one go and resize is called afterwards
		 *
		 * @returns {void}
		 */
		addChild: function( contentItem, index, _$suspendResize ) {
		
			var newItemSize, itemSize, i, splitterElement;
		
			contentItem = this.layoutManager._$normalizeContentItem( contentItem, this );
	
			if( index === undefined ) {
				index = this.contentItems.length;
			}
		
			if( this.contentItems.length > 0 ) {
				splitterElement = this._createSplitter( Math.max( 0, index - 1 ) ).element;
		
				if( index > 0 ) {
					this.contentItems[ index - 1 ].element.after( splitterElement );
					splitterElement.after( contentItem.element );
				} else {
					this.contentItems[ 0 ].element.before( splitterElement );
					splitterElement.before( contentItem.element );
				}
			} else {
				this.childElementContainer.append( contentItem.element );
			}
			
			lm.items.AbstractContentItem.prototype.addChild.call( this, contentItem, index );
		
			newItemSize = ( 1 / this.contentItems.length ) * 100;
			
			if( _$suspendResize === true ) {
				this.emitBubblingEvent( 'stateChanged' );
				return;
			}
			
			for( i = 0; i < this.contentItems.length; i++ ) {
				if( this.contentItems[ i ] === contentItem ) {
					contentItem.config[ this._dimension ] = newItemSize;
				} else {
					itemSize = this.contentItems[ i ].config[ this._dimension ] *= ( 100 - newItemSize ) / 100;
					this.contentItems[ i ].config[ this._dimension ] = itemSize;
				}
			}
			
			this.callDownwards( 'setSize' );
			this.emitBubblingEvent( 'stateChanged' );
		},
	
		/**
		 * Removes a child of this element
		 *
		 * @param   {lm.items.AbstractContentItem} contentItem
		 * @param   {boolean} keepChild   If true the child will be removed, but not destroyed
		 *
		 * @returns {void}
		 */
		removeChild: function( contentItem, keepChild ) {
			var removedItemSize = contentItem.config[ this._dimension ],
				index = lm.utils.indexOf( contentItem, this.contentItems ),
				splitterIndex = Math.max( index - 1, 0 ),
				i,
				childItem;
	
			if( index === -1 ) {
				throw new Error( 'Can\'t remove child. ContentItem is not child of this Row or Column' );
			}
			
			/**
			 * Remove the splitter before the item or after if the item happens
			 * to be the first in the row/column
			 */
			if( this._splitter[ splitterIndex ] ) {
				this._splitter[ splitterIndex ]._$destroy();
				this._splitter.splice( splitterIndex, 1 );
			}
			
			/**
			 * Allocate the space that the removed item occupied to the remaining items
			 */
			for( i = 0; i < this.contentItems.length; i++ ) {
				if( this.contentItems[ i ] !== contentItem ) {
					this.contentItems[ i ].config[ this._dimension ] += removedItemSize / ( this.contentItems.length - 1 );
				}
			}
		
			lm.items.AbstractContentItem.prototype.removeChild.call( this, contentItem, keepChild );
	
			if( this.contentItems.length === 1 && this.config.isClosable === true ) {
				childItem = this.contentItems[ 0 ];
				this.contentItems = [];
				this.parent.replaceChild( this, childItem, true );
			} else {
				this.callDownwards( 'setSize' );
				this.emitBubblingEvent( 'stateChanged' );
			}
		},
		
		/**
		 * Replaces a child of this Row or Column with another contentItem
		 *
		 * @param   {lm.items.AbstractContentItem} oldChild
		 * @param   {lm.items.AbstractContentItem} newChild
		 *
		 * @returns {void}
		 */
		replaceChild: function( oldChild, newChild ) {
			var size = oldChild.config[ this._dimension ];
			lm.items.AbstractContentItem.prototype.replaceChild.call( this, oldChild, newChild );
			newChild.config[ this._dimension ] = size;
			this.callDownwards( 'setSize' );
			this.emitBubblingEvent( 'stateChanged' );
		},
		
		/**
		 * Called whenever the dimensions of this item or one of its parents change
		 *
		 * @returns {void}
		 */
		setSize: function() {
			if( this.contentItems.length > 0 ) {
				this._calculateRelativeSizes();
				this._setAbsoluteSizes();
			}
			this.emitBubblingEvent( 'stateChanged' );
			this.emit( 'resize' );
		},
		
		/**
		 * Invoked recursively by the layout manager. AbstractContentItem.init appends
		 * the contentItem's DOM elements to the container, RowOrColumn init adds splitters
		 * in between them
		 *
		 * @package private
		 * @override AbstractContentItem._$init
		 * @returns {void}
		 */
		_$init: function() {
			if( this.isInitialised === true ) return;
	
			var i;
		
			lm.items.AbstractContentItem.prototype._$init.call( this );
			
			for( i = 0; i < this.contentItems.length - 1; i++ ) {
				this.contentItems[ i ].element.after( this._createSplitter( i ).element );
			}
		},
		
		/**
		 * Turns the relative sizes calculated by _calculateRelativeSizes into
		 * absolute pixel values and applies them to the children's DOM elements
		 *
		 * Assigns additional pixels to counteract Math.floor
		 * 
		 * @private
		 * @returns {void}
		 */
		_setAbsoluteSizes: function() {
			var i,
				totalSplitterSize = ( this.contentItems.length - 1 ) * this._splitterSize,
				totalWidth = this.element.width(),
				totalHeight = this.element.height(),
				totalAssigned = 0,
				additionalPixel,
				itemSize,
				itemSizes = [];
		
			if( this._isColumn ) {
				totalHeight -= totalSplitterSize;
			} else {
				totalWidth -= totalSplitterSize;
			}
		
			for( i = 0; i < this.contentItems.length; i++ ) {
				if( this._isColumn ) {
					itemSize = Math.floor( totalHeight * ( this.contentItems[ i ].config.height / 100 ) );
				} else {
					itemSize = Math.floor( totalWidth * ( this.contentItems[ i ].config.width / 100 ) );
				}
	
				totalAssigned += itemSize;
				itemSizes.push( itemSize );
			}
	
			additionalPixel = Math.floor( ( this._isColumn ? totalHeight : totalWidth ) - totalAssigned );
	
			for( i = 0; i < this.contentItems.length; i++ ) {
				if( additionalPixel - i > 0 ) {
					itemSizes[ i ]++;
				}
	
				if( this._isColumn ) {
					this.contentItems[ i ].element.width( totalWidth );
					this.contentItems[ i ].element.height( itemSizes[ i ] );
				} else {
					this.contentItems[ i ].element.width( itemSizes[ i ] );
					this.contentItems[ i ].element.height( totalHeight );
				}
			}
		},
		
		/**
		 * Calculates the relative sizes of all children of this Item. The logic
		 * is as follows:
		 * 
		 * - Add up the total size of all items that have a configured size
		 *
		 * - If the total == 100 (check for floating point errors)
		 *		Excellent, job done
		 * 
		 * - If the total is > 100, 
		 *		set the size of items without set dimensions to 1/3 and add this to the total
		 *		set the size off all items so that the total is hundred relative to their original size 
		 *
		 * - If the total is < 100
		 *		If there are items without set dimensions, distribute the remainder to 100 evenly between them
		 *		If there are no items without set dimensions, increase all items sizes relative to
		 *		their original size so that they add up to 100
		 *
		 * @private
		 * @returns {void}
		 */
		_calculateRelativeSizes: function() {
			
			var i,
				total = 0,
				itemsWithoutSetDimension = [],
				dimension = this._isColumn ? 'height' : 'width';
		
			for( i = 0; i < this.contentItems.length; i++ ) {
				if( this.contentItems[ i ].config[ dimension ] !== undefined ) {
					total += this.contentItems[ i ].config[ dimension ];
				} else {
					itemsWithoutSetDimension.push( this.contentItems[ i ] );
				}
			}
		
			/**
			 * Everything adds up to hundred, all good :-)
			 */
			if( Math.round( total ) === 100 ) {
				return;
			}
		
			/**
			 * Allocate the remaining size to the items without a set dimension
			 */
			if( Math.round( total ) < 100 && itemsWithoutSetDimension.length > 0 ) {
				for( i = 0; i < itemsWithoutSetDimension.length; i++ ) {
					itemsWithoutSetDimension[ i ].config[ dimension ] = ( 100 - total ) / itemsWithoutSetDimension.length;
				}
				return;
			}
		
			/**
			 * If the total is > 100, but there are also items without a set dimension left, assing 50
			 * as their dimension and add it to the total
			 *
			 * This will be reset in the next step
			 */
			if( Math.round( total ) > 100 ) {
				for( i = 0; i < itemsWithoutSetDimension.length; i++ ) {
					itemsWithoutSetDimension[ i ].config[ dimension ] = 50;
					total += 50;
				}
			}
		
			/**
			 * Set every items size relative to 100 relative to its size to total
			 */
			for( i = 0; i < this.contentItems.length; i++ ) {
				this.contentItems[ i ].config[ dimension ] = ( this.contentItems[ i ].config[ dimension ] / total ) * 100;
			}
		},
		
		/**
		 * Instantiates a new lm.controls.Splitter, binds events to it and adds
		 * it to the array of splitters at the position specified as the index argument
		 *
		 * What it doesn't do though is append the splitter to the DOM
		 *
		 * @param   {Int} index The position of the splitter
		 *
		 * @returns {lm.controls.Splitter}
		 */
		_createSplitter: function( index ) {
			var splitter;
			splitter = new lm.controls.Splitter( this._isColumn, this._splitterSize );
			splitter.on( 'drag', lm.utils.fnBind( this._onSplitterDrag, this, [ splitter ] ), this );
			splitter.on( 'dragStop', lm.utils.fnBind( this._onSplitterDragStop, this, [ splitter ] ), this );
			splitter.on( 'dragStart', lm.utils.fnBind( this._onSplitterDragStart, this, [ splitter ] ), this );
			this._splitter.splice( index, 0, splitter );
			return splitter;
		},
		
		/**
		 * Locates the instance of lm.controls.Splitter in the array of
		 * registered splitters and returns a map containing the contentItem
		 * before and after the splitters, both of which are affected if the
		 * splitter is moved
		 *
		 * @param   {lm.controls.Splitter} splitter
		 *
		 * @returns {Object} A map of contentItems that the splitter affects
		 */
		_getItemsForSplitter: function( splitter ) {
			var index = lm.utils.indexOf( splitter, this._splitter );
			
			return {
				before: this.contentItems[ index ],
				after: this.contentItems[ index + 1 ]
			};
		},
	
		/**
		 * Gets the minimum dimensions for the given item configuration array
		 * @param item
		 * @private
		 */
		_getMinimumDimensions: function (arr) {
			var minWidth = 0, minHeight = 0;
	
			for (var i = 0; i < arr.length; ++i) {
				minWidth = Math.max(arr[i].minWidth || 0, minWidth);
				minHeight = Math.max(arr[i].minHeight || 0, minHeight);
			}
	
			return { horizontal: minWidth, vertical: minHeight };
		},
		
		/**
		 * Invoked when a splitter's dragListener fires dragStart. Calculates the splitters
		 * movement area once (so that it doesn't need calculating on every mousemove event)
		 *
		 * @param   {lm.controls.Splitter} splitter
		 *
		 * @returns {void}
		 */
		_onSplitterDragStart: function( splitter ) {
			var items = this._getItemsForSplitter( splitter ),
				minSize = this.layoutManager.config.dimensions[ this._isColumn ? 'minItemHeight' : 'minItemWidth' ];
	
			var beforeMinDim = this._getMinimumDimensions(items.before.config.content);
			var beforeMinSize = this._isColumn ? beforeMinDim.vertical : beforeMinDim.horizontal;
	
			var afterMinDim = this._getMinimumDimensions(items.after.config.content);
			var afterMinSize = this._isColumn ? afterMinDim.vertical : afterMinDim.horizontal;
	
			this._splitterPosition = 0;
			this._splitterMinPosition = -1 * ( items.before.element[ this._dimension ]() - (beforeMinSize || minSize) );
			this._splitterMaxPosition = items.after.element[ this._dimension ]() - (afterMinSize || minSize);
		},
		
		/**
		 * Invoked when a splitter's DragListener fires drag. Updates the splitters DOM position,
		 * but not the sizes of the elements the splitter controls in order to minimize resize events
		 *
		 * @param   {lm.controls.Splitter} splitter
		 * @param   {Int} offsetX  Relative pixel values to the splitters original position. Can be negative
		 * @param   {Int} offsetY  Relative pixel values to the splitters original position. Can be negative
		 *
		 * @returns {void}
		 */
		_onSplitterDrag: function( splitter, offsetX, offsetY ) {
			var offset = this._isColumn ? offsetY : offsetX;
		
			if( offset > this._splitterMinPosition && offset < this._splitterMaxPosition ) {
				this._splitterPosition = offset;
				splitter.element.css( this._isColumn ? 'top' : 'left', offset );
			}
		},
		
		/**
		 * Invoked when a splitter's DragListener fires dragStop. Resets the splitters DOM position,
		 * and applies the new sizes to the elements before and after the splitter and their children
		 * on the next animation frame
		 *
		 * @param   {lm.controls.Splitter} splitter
		 *
		 * @returns {void}
		 */
		_onSplitterDragStop: function( splitter ) {
	
			var items = this._getItemsForSplitter( splitter ),
				sizeBefore = items.before.element[ this._dimension ](),
				sizeAfter = items.after.element[ this._dimension ](),
				splitterPositionInRange = ( this._splitterPosition + sizeBefore ) / ( sizeBefore + sizeAfter ),
				totalRelativeSize = items.before.config[ this._dimension ] + items.after.config[ this._dimension ];
		
			items.before.config[ this._dimension ] = splitterPositionInRange * totalRelativeSize;
			items.after.config[ this._dimension ] = ( 1 - splitterPositionInRange ) * totalRelativeSize;
		
			splitter.element.css({
				'top': 0,
				'left': 0
			});
			
			lm.utils.animFrame( lm.utils.fnBind( this.callDownwards, this, [ 'setSize' ] ) );
		}
	});
	lm.items.Stack = function( layoutManager, config, parent ) {
		lm.items.AbstractContentItem.call( this, layoutManager, config, parent );
	
		this.element = $( '<div class="lm_item lm_stack"></div>' );
		this._activeContentItem = null;
	
		this._dropZones = {};
		this._dropSegment = null;
		this._contentAreaDimensions = null;
		this._dropIndex = null;
	
		this.isStack = true;
	
		this.childElementContainer = $( '<div class="lm_items"></div>' );
		this.header = new lm.controls.Header( layoutManager, this );
	
		if( layoutManager.config.settings.hasHeaders === true ) {
			this.element.append( this.header.element );
		}
	
		this.element.append( this.childElementContainer );
		this._$validateClosability();
	};
	
	lm.utils.extend( lm.items.Stack, lm.items.AbstractContentItem );
	
	lm.utils.copy( lm.items.Stack.prototype, {
	
		setSize: function() {
			var i,
				contentWidth = this.element.width(),
				contentHeight = this.element.height() - this.layoutManager.config.dimensions.headerHeight;
	
			this.childElementContainer.width( contentWidth );
			this.childElementContainer.height( contentHeight );
	
			for( i = 0; i < this.contentItems.length; i++ ) {
				this.contentItems[ i ].element.width( contentWidth ).height( contentHeight );
			}
			this.emit( 'resize' );
			this.emitBubblingEvent( 'stateChanged' );
		},
	
		_$init: function() {
			var i, initialItem;
	
			if( this.isInitialised === true ) return;
	
			lm.items.AbstractContentItem.prototype._$init.call( this );
	
			for( i = 0; i < this.contentItems.length; i++ ) {
				this.header.createTab( this.contentItems[ i ] );
				this.contentItems[ i ]._$hide();
			}
	
			if( this.contentItems.length > 0 ) {
				initialItem = this.contentItems[ this.config.activeItemIndex || 0 ];
	
				if( !initialItem ) {
					throw new Error( 'Configured activeItemIndex out of bounds' );
				}
				
				this.setActiveContentItem( initialItem );
			}
		},
	
		setActiveContentItem: function( contentItem ) {
			if( lm.utils.indexOf( contentItem, this.contentItems ) === -1 ) {
				throw new Error( 'contentItem is not a child of this stack' );
			}
	
			if( this._activeContentItem !== null ) {
				this._activeContentItem._$hide();
			}
	
			this._activeContentItem = contentItem;
			this.header.setActiveContentItem( contentItem );
			contentItem._$show();
			this.emit( 'activeContentItemChanged', contentItem );
			this.emitBubblingEvent( 'stateChanged' );
		},
	
		getActiveContentItem: function() {
			return this.header.activeContentItem;
		},
	
		addChild: function( contentItem, index ) {
			contentItem = this.layoutManager._$normalizeContentItem( contentItem, this );
			lm.items.AbstractContentItem.prototype.addChild.call( this, contentItem, index );
			this.childElementContainer.append( contentItem.element );
			this.header.createTab( contentItem, index );
			this.setActiveContentItem( contentItem );
			this.callDownwards( 'setSize' );
			this._$validateClosability();
			this.emitBubblingEvent( 'stateChanged' );
		},
	
		removeChild: function( contentItem, keepChild ) {
			var index = lm.utils.indexOf( contentItem, this.contentItems );
			lm.items.AbstractContentItem.prototype.removeChild.call( this, contentItem, keepChild );
			this.header.removeTab( contentItem );
			
			if( this.contentItems.length > 0 ) {
				this.setActiveContentItem( this.contentItems[ Math.max( index -1 , 0 ) ] );
			} else {
				this._activeContentItem = null;
			}
			
			this._$validateClosability();
			this.emitBubblingEvent( 'stateChanged' );
		},
	
		/**
		 * Validates that the stack is still closable or not. If a stack is able
		 * to close, but has a non closable component added to it, the stack is no
		 * longer closable until all components are closable.
		 *
		 * @returns {void}
		 */
		_$validateClosability: function() {
			var contentItem,
				isClosable,
				len,
				i;
	
			isClosable = this.header._isClosable();
	
			for ( i = 0, len = this.contentItems.length; i < len; i++ ) {
				if (!isClosable) { 
					break; 
				}
	
				isClosable = this.contentItems[ i ].config.isClosable;
			}
	
			this.header._$setClosable( isClosable );
		},
	
		_$destroy: function() {
			lm.items.AbstractContentItem.prototype._$destroy.call( this );
			this.header._$destroy();
		},
	
	
		/**
		 * Ok, this one is going to be the tricky one: The user has dropped {contentItem} onto this stack.
		 *
		 * It was dropped on either the stacks header or the top, right, bottom or left bit of the content area
		 * (which one of those is stored in this._dropSegment). Now, if the user has dropped on the header the case
		 * is relatively clear: We add the item to the existing stack... job done (might be good to have 
		 * tab reordering at some point, but lets not sweat it right now)
		 *
		 * If the item was dropped on the content part things are a bit more complicated. If it was dropped on either the
		 * top or bottom region we need to create a new column and place the items accordingly. 
		 * Unless, of course if the stack is already within a column... in which case we want 
		 * to add the newly created item to the existing column... 
		 * either prepend or append it, depending on wether its top or bottom.
		 *
		 * Same thing for rows and left / right drop segments... so in total there are 9 things that can potentially happen
		 * (left, top, right, bottom) * is child of the right parent (row, column) + header drop
		 * 
		 * @param	{lm.item} contentItem
		 *
		 * @returns {void}
		 */
		_$onDrop: function( contentItem ) {
	
			/*
			 * The item was dropped on the header area. Just add it as a child of this stack and
			 * get the hell out of this logic
			 */
			if( this._dropSegment === 'header' ) {
				this._resetHeaderDropZone();
				this.addChild( contentItem, this._dropIndex );
				return;
			}
	
			/*
			 * The stack is empty. Let's just add the element.
			 */
			if( this._dropSegment === 'body' ) {
				this.addChild( contentItem );
				return;
			}
	
			/*
			 * The item was dropped on the top-, left-, bottom- or right- part of the content. Let's
			 * aggregate some conditions to make the if statements later on more readable
			 */
			var isVertical = this._dropSegment === 'top' || this._dropSegment === 'bottom',
				isHorizontal = this._dropSegment === 'left' || this._dropSegment === 'right',
				insertBefore = this._dropSegment === 'top' || this._dropSegment === 'left',
				hasCorrectParent = ( isVertical && this.parent.isColumn ) || ( isHorizontal && this.parent.isRow ),
				type = isVertical ? 'column' : 'row',
				dimension = isVertical ? 'height' : 'width',
				index,
				stack,
				rowOrColumn;
	
			/*
			 * The content item can be either a component or a stack. If it is a component, wrap it into a stack
			 */
			if( contentItem.isComponent ) {
				stack = this.layoutManager.createContentItem({ type: 'stack' }, this );
				stack._$init();
				stack.addChild( contentItem );
				contentItem = stack;
			}
	
			/*
			 * If the item is dropped on top or bottom of a column or left and right of a row, it's already
			 * layd out in the correct way. Just add it as a child
			 */
			if( hasCorrectParent ) {
				index = lm.utils.indexOf( this, this.parent.contentItems );
				this.parent.addChild( contentItem, insertBefore ? index : index + 1, true );
				this.config[ dimension ] *= 0.5;
				contentItem.config[ dimension ] = this.config[ dimension ];
				this.parent.callDownwards( 'setSize' );
			/*
			 * This handles items that are dropped on top or bottom of a row or left / right of a column. We need
			 * to create the appropriate contentItem for them to live in
			 */
			} else {
				type = isVertical ? 'column' : 'row';
				rowOrColumn = this.layoutManager.createContentItem({ type: type }, this );
				this.parent.replaceChild( this, rowOrColumn );
	
				rowOrColumn.addChild( contentItem, insertBefore ? 0 : undefined, true );
				rowOrColumn.addChild( this, insertBefore ? undefined : 0, true );
	
				this.config[ dimension ] = 50;
				contentItem.config[ dimension ] = 50;
				rowOrColumn.callDownwards( 'setSize' );
			}
		},
	
		/**
		 * If the user hovers above the header part of the stack, indicate drop positions for tabs.
		 * otherwise indicate which segment of the body the dragged item would be dropped on
		 *
		 * @param	{Int} x Absolute Screen X
		 * @param	{Int} y Absolute Screen Y
		 *
		 * @returns {void}
		 */
		_$highlightDropZone: function( x, y ) {
			var segment, area;
	
			for( segment in this._contentAreaDimensions ) {
				area = this._contentAreaDimensions[ segment ].hoverArea;
	
				if( area.x1 < x && area.x2 > x && area.y1 < y && area.y2 > y ) {
	
					if( segment === 'header' ) {
						this._dropSegment = 'header';
						this._highlightHeaderDropZone( x );
					} else {
						this._resetHeaderDropZone();
						this._highlightBodyDropZone( segment );
					}
					
					return;
				}
			}
		},
	
		_$getArea: function() {
			if( this.element.is( ':visible' ) === false ) {
				return null;
			}
			
			var getArea = lm.items.AbstractContentItem.prototype._$getArea,
				headerArea = getArea.call( this, this.header.element ),
				contentArea = getArea.call( this, this.childElementContainer ),
				contentWidth = contentArea.x2 - contentArea.x1,
				contentHeight = contentArea.y2 - contentArea.y1;
	
			this._contentAreaDimensions = {
				header: {
					hoverArea: {
						x1: headerArea.x1,
						y1: headerArea.y1,
						x2: headerArea.x2,
						y2: headerArea.y2
					},
					highlightArea: {
						x1: headerArea.x1,
						y1: headerArea.y1,
						x2: headerArea.x2,
						y2: headerArea.y2
					}
				}
			};
	
			/**
			 * If this Stack is a parent to rows, columns or other stacks only its
			 * header is a valid dropzone.
			 */
			if( this._activeContentItem && this._activeContentItem.isComponent === false ) {
				return headerArea;
			}
	
			/**
			 * Highlight the entire body if the stack is empty
			 */
			if( this.contentItems.length === 0 ) {
	
				this._contentAreaDimensions.body = {
					hoverArea: {
						x1: contentArea.x1,
						y1: contentArea.y1,
						x2: contentArea.x2,
						y2: contentArea.y2
					},
					highlightArea: {
						x1: contentArea.x1,
						y1: contentArea.y1,
						x2: contentArea.x2,
						y2: contentArea.y2
					}
				};
	
				return getArea.call( this, this.element );
			}
	
			this._contentAreaDimensions.left = {
				hoverArea: {
					x1: contentArea.x1,
					y1: contentArea.y1,
					x2: contentArea.x1 + contentWidth * 0.25,
					y2: contentArea.y2
				},
				highlightArea: {
					x1: contentArea.x1,
					y1: contentArea.y1,
					x2: contentArea.x1 + contentWidth * 0.5,
					y2: contentArea.y2
				}
			};
	
			this._contentAreaDimensions.top = {
				hoverArea: {
					x1: contentArea.x1 + contentWidth * 0.25,
					y1: contentArea.y1,
					x2: contentArea.x1 + contentWidth * 0.75,
					y2: contentArea.y1 + contentHeight * 0.5
				},
				highlightArea: {
					x1: contentArea.x1,
					y1: contentArea.y1,
					x2: contentArea.x2,
					y2: contentArea.y1 + contentHeight * 0.5
				}
			};
			
			this._contentAreaDimensions.right = {
				hoverArea: {
					x1: contentArea.x1 + contentWidth * 0.75,
					y1: contentArea.y1,
					x2: contentArea.x2,
					y2: contentArea.y2
				},
				highlightArea: {
					x1: contentArea.x1 + contentWidth * 0.5,
					y1: contentArea.y1,
					x2: contentArea.x2,
					y2: contentArea.y2
				}
			};
	
			this._contentAreaDimensions.bottom = {
				hoverArea: {
					x1: contentArea.x1 + contentWidth * 0.25,
					y1: contentArea.y1 + contentHeight * 0.5,
					x2: contentArea.x1 + contentWidth * 0.75,
					y2: contentArea.y2
				},
				highlightArea: {
					x1: contentArea.x1,
					y1: contentArea.y1 + contentHeight * 0.5,
					x2: contentArea.x2,
					y2: contentArea.y2
				}
			};
	
			return getArea.call( this, this.element );
		},
	
		_highlightHeaderDropZone: function( x ) {
			var i,
				tabElement,
				tabsLength = this.header.tabs.length,
				isAboveTab = false,
				tabTop,
				tabLeft,
				offset,
				placeHolderLeft,
				headerOffset,
				tabWidth,
				halfX;
	
			// Empty stack
			if( tabsLength === 0 ) {
				headerOffset = this.header.element.offset();
	
				this.layoutManager.dropTargetIndicator.highlightArea({
					x1: headerOffset.left,
					x2: headerOffset.left + 100,
					y1: headerOffset.top + this.header.element.height() - 20,
					y2: headerOffset.top + this.header.element.height()
				});
	
				return;
			}
	
			for( i = 0; i < tabsLength; i++ ) {
				tabElement = this.header.tabs[ i ].element;
				offset = tabElement.offset();
				tabLeft = offset.left;
				tabTop = offset.top;
				tabWidth = tabElement.width();
	
				if( x > tabLeft && x < tabLeft + tabWidth ) {
					isAboveTab = true;
					break;
				}
			}
	
			if( isAboveTab === false && x < tabLeft ) {
				return;
			}
	
			halfX = tabLeft + tabWidth / 2;
	
			if( x < halfX ) {
				this._dropIndex = i;
				tabElement.before( this.layoutManager.tabDropPlaceholder );
			} else {
				this._dropIndex = Math.min( i + 1, tabsLength );
				tabElement.after( this.layoutManager.tabDropPlaceholder );
			}
	
	
			placeHolderLeft = this.layoutManager.tabDropPlaceholder.offset().left;
	
			this.layoutManager.dropTargetIndicator.highlightArea({
				x1: placeHolderLeft,
				x2: placeHolderLeft + this.layoutManager.tabDropPlaceholder.width(),
				y1: tabTop,
				y2: tabTop + tabElement.innerHeight()
			});
		},
	
		_resetHeaderDropZone: function() {
			this.layoutManager.tabDropPlaceholder.remove();
		},
	
		_highlightBodyDropZone: function( segment ) {
			var highlightArea = this._contentAreaDimensions[ segment ].highlightArea;
			this.layoutManager.dropTargetIndicator.highlightArea( highlightArea );
			this._dropSegment = segment;
		}
	});
	
	lm.utils.BubblingEvent = function( name, origin ) {
		this.name = name;
		this.origin = origin;
		this.isPropagationStopped = false;
	};
	
	lm.utils.BubblingEvent.prototype.stopPropagation = function() {
		this.isPropagationStopped = true;
	};
	/**
	 * Minifies and unminifies configs by replacing frequent keys
	 * and values with one letter substitutes
	 *
	 * @constructor
	 */
	lm.utils.ConfigMinifier = function(){
		this._keys = [
			'settings',
			'hasHeaders',
			'constrainDragToContainer',
			'selectionEnabled',
			'dimensions',
			'borderWidth',
			'minItemHeight',
			'minItemWidth',
			'headerHeight',
			'dragProxyWidth',
			'dragProxyHeight',
			'labels',
			'close',
			'maximise',
			'minimise',
			'popout',
			'content',
			'componentName',
			'componentState',
			'id',
			'width',
			'type',
			'height',
			'isClosable',
			'title',
			'popoutWholeStack',
			'openPopouts',
			'parentId',
			'activeItemIndex',
			'reorderEnabled'
	
	
	
	
	
			//Maximum 36 entries, do not cross this line!
		];
	
		this._values = [
			true,
			false,
			'row',
			'column',
			'stack',
			'component',
			'close',
			'maximise',
			'minimise',
			'open in new window'
		];
	};
	
	lm.utils.copy( lm.utils.ConfigMinifier.prototype, {
	
		/**
		 * Takes a GoldenLayout configuration object and
		 * replaces its keys and values recursively with
		 * one letter counterparts
		 *
		 * @param   {Object} config A GoldenLayout config object
		 *
		 * @returns {Object} minified config
		 */
		minifyConfig: function( config ) {
			var min = {};
			this._nextLevel( config, min, '_min' );
			return min;
		},
	
		/**
		 * Takes a configuration Object that was previously minified
		 * using minifyConfig and returns its original version
		 *
		 * @param   {Object} minifiedConfig
		 *
		 * @returns {Object} the original configuration
		 */
		unminifyConfig: function( minifiedConfig ) { 
			var orig = {};
			this._nextLevel( minifiedConfig, orig, '_max' );
			return orig;
		},
	
		/**
		 * Recursive function, called for every level of the config structure
		 *
		 * @param   {Array|Object} orig
		 * @param   {Array|Object} min
		 * @param 	{String} translationFn
		 *
		 * @returns {void}
		 */
		_nextLevel: function( from, to, translationFn ) {
			var key, minKey;
	
			for( key in from ) {
	
				/**
				 * For in returns array indices as keys, so let's cast them to numbers
				 */
				if( from instanceof Array ) key = parseInt( key, 10 );
	
				/**
				 * In case something has extended Object prototypes
				 */
				if( !from.hasOwnProperty( key ) ) continue;
	
				/**
				 * Translate the key to a one letter substitute
				 */
				minKey = this[ translationFn ]( key, this._keys );
	
				/**
				 * For Arrays and Objects, create a new Array/Object
				 * on the minified object and recurse into it
				 */
				if( typeof from[ key ] === 'object' ) {
					to[ minKey ] = from[ key ] instanceof Array ? [] : {};
					this._nextLevel( from[ key ], to[ minKey ], translationFn );
	
				/**
				 * For primitive values (Strings, Numbers, Boolean etc.)
				 * minify the value
				 */
				} else {
					to[ minKey ] = this[ translationFn ]( from[ key ], this._values );
				}
			}
		},
	
		/**
		 * Minifies value based on a dictionary
		 *
		 * @param   {String|Boolean} value
		 * @param   {Array<String|Boolean>} dictionary
		 *
		 * @returns {String} The minified version
		 */
		_min: function( value, dictionary ) {
			/**
			 * If a value actually is a single character, prefix it
			 * with ___ to avoid mistaking it for a minification code
			 */
			if( typeof value === 'string' && value.length === 1 ) {
				return '___' + value;
			}
	
			var index = lm.utils.indexOf( value, dictionary );
			
			/**
			 * value not found in the dictionary, return it unmodified
			 */
			if( index === -1 ) {
				return value;
	
			/**
			 * value found in dictionary, return its base36 counterpart
			 */
			} else {
				return index.toString( 36 );
			}
		},
	
		_max: function( value, dictionary ) {
			/**
			 * value is a single character. Assume that it's a translation
			 * and return the original value from the dictionary
			 */
			if( typeof value === 'string' && value.length === 1 ) {
				return dictionary[ parseInt( value, 36 ) ];
			}
	
			/**
			 * value originally was a single character and was prefixed with ___
			 * to avoid mistaking it for a translation. Remove the prefix
			 * and return the original character
			 */
			if( typeof value === 'string' && value.substr( 0, 3 ) === '___' ) {
				return value[ 3 ];
			}
			/**
			 * value was not minified
			 */
			return value;
		}
	});
	
	/**
	 * An EventEmitter singleton that propagates events
	 * across multiple windows. This is a little bit trickier since
	 * windows are allowed to open childWindows in their own right
	 *
	 * This means that we deal with a tree of windows. Hence the rules for event propagation are:
	 *
	 * - Propagate events from this layout to both parents and children
	 * - Propagate events from parent to this and children
	 * - Propagate events from children to the other children (but not the emitting one) and the parent
	 *
	 * @constructor
	 * 
	 * @param {lm.LayoutManager} layoutManager
	 */
	lm.utils.EventHub = function( layoutManager ) {
		lm.utils.EventEmitter.call( this );
		this._layoutManager = layoutManager;
		this._dontPropagateToParent = null;
		this._childEventSource = null;
		this.on( lm.utils.EventEmitter.ALL_EVENT, lm.utils.fnBind( this._onEventFromThis, this ) );
		this._boundOnEventFromChild = lm.utils.fnBind( this._onEventFromChild, this );
		$(window).on( 'gl_child_event', this._boundOnEventFromChild );
	};
	
	/**
	 * Called on every event emitted on this eventHub, regardles of origin.
	 *
	 * @private
	 *
	 * @param {Mixed}
	 * 
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._onEventFromThis = function() {
		var args = Array.prototype.slice.call( arguments );
	
		if( this._layoutManager.isSubWindow && args[ 0 ] !== this._dontPropagateToParent ) {
			this._propagateToParent( args );
		}
		this._propagateToChildren( args );
	
		//Reset
		this._dontPropagateToParent = null;
		this._childEventSource = null;
	};
	
	/**
	 * Called by the parent layout.
	 *
	 * @param   {Array} args Event name + arguments
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._$onEventFromParent = function( args ) {
		this._dontPropagateToParent = args[ 0 ];
		this.emit.apply( this, args );
	};
	
	/**
	 * Callback for child events raised on the window
	 *
	 * @param   {DOMEvent} event
	 * @private
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._onEventFromChild = function( event ) {
		this._childEventSource = event.originalEvent.__gl;
		this.emit.apply( this, event.originalEvent.__glArgs );
	};
	
	/**
	 * Propagates the event to the parent by emitting
	 * it on the parent's DOM window
	 *
	 * @param   {Array} args Event name + arguments
	 * @private
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._propagateToParent = function( args ) {
		var event,
			eventName = 'gl_child_event'; 
	
		if (document.createEvent) {
			event = window.opener.document.createEvent( 'HTMLEvents' );
			event.initEvent( eventName, true, true);
		} else {
			event = window.opener.document.createEventObject();
			event.eventType = eventName;
		}
	
		event.eventName = eventName;
		event.__glArgs = args;
		event.__gl = this._layoutManager;
	
		if (document.createEvent) {
			window.opener.dispatchEvent(event);
		} else {
			window.opener.fireEvent( 'on' + event.eventType, event );
		}
	};
	
	/**
	 * Propagate events to children
	 *
	 * @param   {Array} args Event name + arguments
	 * @private
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._propagateToChildren = function( args ) {
		var childGl, i;
	
		for( i = 0; i < this._layoutManager.openPopouts.length; i++ ) {
			childGl = this._layoutManager.openPopouts[ i ].getGlInstance();
	
			if( childGl && childGl !== this._childEventSource ) {
				childGl.eventHub._$onEventFromParent( args );
			}
		}
	};
	
	
	/**
	 * Destroys the EventHub
	 *
	 * @public
	 * @returns {void}
	 */
	
	lm.utils.EventHub.prototype.destroy = function() {
		$(window).off( 'gl_child_event', this._boundOnEventFromChild );
	};
	/**
	 * A specialised GoldenLayout component that binds GoldenLayout container
	 * lifecycle events to react components
	 *
	 * @constructor
	 *
	 * @param {lm.container.ItemContainer} container
	 * @param {Object} state state is not required for react components
	 */
	lm.utils.ReactComponentHandler = function( container, state ) {
		this._reactComponent = null;
		this._originalComponentWillUpdate = null;
		this._container = container;
		this._initialState = state;
		this._reactClass = this._getReactClass();
		this._container.on( 'open', this._render, this );
		this._container.on( 'destroy', this._destroy, this );
	};
	
	lm.utils.copy( lm.utils.ReactComponentHandler.prototype, {
	
		/**
		 * Creates the react class and component and hydrates it with
		 * the initial state - if one is present
		 *
		 * By default, react's getInitialState will be used
		 *
		 * @private
		 * @returns {void}
		 */
		_render: function() {
			this._reactComponent = ReactDOM.render( this._getReactComponent(), this._container.getElement()[ 0 ]);
			this._originalComponentWillUpdate = this._reactComponent.componentWillUpdate || function(){};
			this._reactComponent.componentWillUpdate = this._onUpdate.bind( this );
			if( this._container.getState() ) {
				this._reactComponent.setState( this._container.getState() );
			}
		},
	
		/**
		 * Removes the component from the DOM and thus invokes React's unmount lifecycle
		 *
		 * @private
		 * @returns {void}
		 */
		_destroy: function() {
			ReactDOM.unmountComponentAtNode( this._container.getElement()[ 0 ]);
			this._container.off( 'open', this._render, this );
			this._container.off( 'destroy', this._destroy, this );
		},
	
		/**
		 * Hooks into React's state management and applies the componentstate
		 * to GoldenLayout
		 *
		 * @private
		 * @returns {void}
		 */
		_onUpdate: function( nextProps, nextState ) {
			this._container.setState( nextState );
			this._originalComponentWillUpdate.call( this._reactComponent, nextProps, nextState );
		},
	
		/**
		 * Retrieves the react class from GoldenLayout's registry
		 *
		 * @private
		 * @returns {React.Class}
		 */
		_getReactClass: function() {
			var componentName = this._container._config.component;
			var reactClass;
	
			if( !componentName ) {
				throw new Error( 'No react component name. type: react-component needs a field `component`' );
			}
	
			reactClass = this._container.layoutManager.getComponent( componentName );
	
			if( !reactClass ) {
				throw new Error( 'React component "' + componentName + '" not found. ' +
					'Please register all components with GoldenLayout using `registerComponent(name, component)`' );
			}
	
			return reactClass;
		},
	
		/**
		 * Copies and extends the properties array and returns the React element
		 *
		 * @private
		 * @returns {React.Element}
		 */
		_getReactComponent: function() {
			var defaultProps = {
				glEventHub: this._container.layoutManager.eventHub,
				glContainer: this._container,
			};
			var props = $.extend( defaultProps, this._container._config.props );
			return React.createElement( this._reactClass, props );
		}
	});})(window.$);

/***/ },
/* 219 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 220 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 222 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCopy = __webpack_require__(224),
	    keys = __webpack_require__(103);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 224 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var bindCallback = __webpack_require__(225),
	    isIterateeCall = __webpack_require__(228),
	    restParam = __webpack_require__(231);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 227 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 228 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 230 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(104),
	    getRawTag = __webpack_require__(235),
	    objectToString = __webpack_require__(236);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 233 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(237);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(104);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 236 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 237 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(233);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 239 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/markedjs/marked
	 */
	
	;(function(root) {
	'use strict';
	
	/**
	 * Block-Level Grammar
	 */
	
	var block = {
	  newline: /^\n+/,
	  code: /^( {4}[^\n]+\n*)+/,
	  fences: noop,
	  hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
	  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
	  nptable: noop,
	  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
	  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
	  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
	  def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
	  table: noop,
	  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
	  paragraph: /^([^\n]+(?:\n?(?!hr|heading|lheading| {0,3}>|tag)[^\n]+)+)/,
	  text: /^[^\n]+/
	};
	
	block._label = /(?:\\[\[\]]|[^\[\]])+/;
	block._title = /(?:"(?:\\"|[^"]|"[^"\n]*")*"|'\n?(?:[^'\n]+\n?)*'|\([^()]*\))/;
	block.def = edit(block.def)
	  .replace('label', block._label)
	  .replace('title', block._title)
	  .getRegex();
	
	block.bullet = /(?:[*+-]|\d+\.)/;
	block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
	block.item = edit(block.item, 'gm')
	  .replace(/bull/g, block.bullet)
	  .getRegex();
	
	block.list = edit(block.list)
	  .replace(/bull/g, block.bullet)
	  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
	  .replace('def', '\\n+(?=' + block.def.source + ')')
	  .getRegex();
	
	block._tag = '(?!(?:'
	  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
	  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
	  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b';
	
	block.html = edit(block.html)
	  .replace('comment', /<!--[\s\S]*?-->/)
	  .replace('closed', /<(tag)[\s\S]+?<\/\1>/)
	  .replace('closing', /<tag(?:"[^"]*"|'[^']*'|\s[^'"\/>\s]*)*?\/?>/)
	  .replace(/tag/g, block._tag)
	  .getRegex();
	
	block.paragraph = edit(block.paragraph)
	  .replace('hr', block.hr)
	  .replace('heading', block.heading)
	  .replace('lheading', block.lheading)
	  .replace('tag', '<' + block._tag)
	  .getRegex();
	
	block.blockquote = edit(block.blockquote)
	  .replace('paragraph', block.paragraph)
	  .getRegex();
	
	/**
	 * Normal Block Grammar
	 */
	
	block.normal = merge({}, block);
	
	/**
	 * GFM Block Grammar
	 */
	
	block.gfm = merge({}, block.normal, {
	  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\n? *\1 *(?:\n+|$)/,
	  paragraph: /^/,
	  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
	});
	
	block.gfm.paragraph = edit(block.paragraph)
	  .replace('(?!', '(?!'
	    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
	    + block.list.source.replace('\\1', '\\3') + '|')
	  .getRegex();
	
	/**
	 * GFM + Tables Block Grammar
	 */
	
	block.tables = merge({}, block.gfm, {
	  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
	  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
	});
	
	/**
	 * Block Lexer
	 */
	
	function Lexer(options) {
	  this.tokens = [];
	  this.tokens.links = {};
	  this.options = options || marked.defaults;
	  this.rules = block.normal;
	
	  if (this.options.gfm) {
	    if (this.options.tables) {
	      this.rules = block.tables;
	    } else {
	      this.rules = block.gfm;
	    }
	  }
	}
	
	/**
	 * Expose Block Rules
	 */
	
	Lexer.rules = block;
	
	/**
	 * Static Lex Method
	 */
	
	Lexer.lex = function(src, options) {
	  var lexer = new Lexer(options);
	  return lexer.lex(src);
	};
	
	/**
	 * Preprocessing
	 */
	
	Lexer.prototype.lex = function(src) {
	  src = src
	    .replace(/\r\n|\r/g, '\n')
	    .replace(/\t/g, '    ')
	    .replace(/\u00a0/g, ' ')
	    .replace(/\u2424/g, '\n');
	
	  return this.token(src, true);
	};
	
	/**
	 * Lexing
	 */
	
	Lexer.prototype.token = function(src, top) {
	  src = src.replace(/^ +$/gm, '');
	  var next,
	      loose,
	      cap,
	      bull,
	      b,
	      item,
	      space,
	      i,
	      tag,
	      l;
	
	  while (src) {
	    // newline
	    if (cap = this.rules.newline.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[0].length > 1) {
	        this.tokens.push({
	          type: 'space'
	        });
	      }
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      cap = cap[0].replace(/^ {4}/gm, '');
	      this.tokens.push({
	        type: 'code',
	        text: !this.options.pedantic
	          ? cap.replace(/\n+$/, '')
	          : cap
	      });
	      continue;
	    }
	
	    // fences (gfm)
	    if (cap = this.rules.fences.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'code',
	        lang: cap[2],
	        text: cap[3] || ''
	      });
	      continue;
	    }
	
	    // heading
	    if (cap = this.rules.heading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[1].length,
	        text: cap[2]
	      });
	      continue;
	    }
	
	    // table no leading pipe (gfm)
	    if (top && (cap = this.rules.nptable.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i].split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // hr
	    if (cap = this.rules.hr.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'hr'
	      });
	      continue;
	    }
	
	    // blockquote
	    if (cap = this.rules.blockquote.exec(src)) {
	      src = src.substring(cap[0].length);
	
	      this.tokens.push({
	        type: 'blockquote_start'
	      });
	
	      cap = cap[0].replace(/^ *> ?/gm, '');
	
	      // Pass `top` to keep the current
	      // "toplevel" state. This is exactly
	      // how markdown.pl works.
	      this.token(cap, top);
	
	      this.tokens.push({
	        type: 'blockquote_end'
	      });
	
	      continue;
	    }
	
	    // list
	    if (cap = this.rules.list.exec(src)) {
	      src = src.substring(cap[0].length);
	      bull = cap[2];
	
	      this.tokens.push({
	        type: 'list_start',
	        ordered: bull.length > 1
	      });
	
	      // Get each top-level item.
	      cap = cap[0].match(this.rules.item);
	
	      next = false;
	      l = cap.length;
	      i = 0;
	
	      for (; i < l; i++) {
	        item = cap[i];
	
	        // Remove the list item's bullet
	        // so it is seen as the next token.
	        space = item.length;
	        item = item.replace(/^ *([*+-]|\d+\.) +/, '');
	
	        // Outdent whatever the
	        // list item contains. Hacky.
	        if (~item.indexOf('\n ')) {
	          space -= item.length;
	          item = !this.options.pedantic
	            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
	            : item.replace(/^ {1,4}/gm, '');
	        }
	
	        // Determine whether the next list item belongs here.
	        // Backpedal if it does not belong in this list.
	        if (this.options.smartLists && i !== l - 1) {
	          b = block.bullet.exec(cap[i + 1])[0];
	          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
	            src = cap.slice(i + 1).join('\n') + src;
	            i = l - 1;
	          }
	        }
	
	        // Determine whether item is loose or not.
	        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
	        // for discount behavior.
	        loose = next || /\n\n(?!\s*$)/.test(item);
	        if (i !== l - 1) {
	          next = item.charAt(item.length - 1) === '\n';
	          if (!loose) loose = next;
	        }
	
	        this.tokens.push({
	          type: loose
	            ? 'loose_item_start'
	            : 'list_item_start'
	        });
	
	        // Recurse.
	        this.token(item, false);
	
	        this.tokens.push({
	          type: 'list_item_end'
	        });
	      }
	
	      this.tokens.push({
	        type: 'list_end'
	      });
	
	      continue;
	    }
	
	    // html
	    if (cap = this.rules.html.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: this.options.sanitize
	          ? 'paragraph'
	          : 'html',
	        pre: !this.options.sanitizer
	          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	        text: cap[0]
	      });
	      continue;
	    }
	
	    // def
	    if (top && (cap = this.rules.def.exec(src))) {
	      src = src.substring(cap[0].length);
	      if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
	      tag = cap[1].toLowerCase();
	      if (!this.tokens.links[tag]) {
	        this.tokens.links[tag] = {
	          href: cap[2],
	          title: cap[3]
	        };
	      }
	      continue;
	    }
	
	    // table (gfm)
	    if (top && (cap = this.rules.table.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i]
	          .replace(/^ *\| *| *\| *$/g, '')
	          .split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // lheading
	    if (cap = this.rules.lheading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[2] === '=' ? 1 : 2,
	        text: cap[1]
	      });
	      continue;
	    }
	
	    // top-level paragraph
	    if (top && (cap = this.rules.paragraph.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'paragraph',
	        text: cap[1].charAt(cap[1].length - 1) === '\n'
	          ? cap[1].slice(0, -1)
	          : cap[1]
	      });
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      // Top-level should never reach here.
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'text',
	        text: cap[0]
	      });
	      continue;
	    }
	
	    if (src) {
	      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return this.tokens;
	};
	
	/**
	 * Inline-Level Grammar
	 */
	
	var inline = {
	  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
	  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
	  url: noop,
	  tag: /^<!--[\s\S]*?-->|^<\/?[a-zA-Z0-9\-]+(?:"[^"]*"|'[^']*'|\s[^<'">\/\s]*)*?\/?>/,
	  link: /^!?\[(inside)\]\(href\)/,
	  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
	  nolink: /^!?\[((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\]/,
	  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
	  em: /^_([^\s_](?:[^_]|__)+?[^\s_])_\b|^\*((?:\*\*|[^*])+?)\*(?!\*)/,
	  code: /^(`+)\s*([\s\S]*?[^`]?)\s*\1(?!`)/,
	  br: /^ {2,}\n(?!\s*$)/,
	  del: noop,
	  text: /^[\s\S]+?(?=[\\<!\[`*]|\b_| {2,}\n|$)/
	};
	
	inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
	inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
	
	inline.autolink = edit(inline.autolink)
	  .replace('scheme', inline._scheme)
	  .replace('email', inline._email)
	  .getRegex()
	
	inline._inside = /(?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]]|\](?=[^\[]*\]))*/;
	inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
	
	inline.link = edit(inline.link)
	  .replace('inside', inline._inside)
	  .replace('href', inline._href)
	  .getRegex();
	
	inline.reflink = edit(inline.reflink)
	  .replace('inside', inline._inside)
	  .getRegex();
	
	/**
	 * Normal Inline Grammar
	 */
	
	inline.normal = merge({}, inline);
	
	/**
	 * Pedantic Inline Grammar
	 */
	
	inline.pedantic = merge({}, inline.normal, {
	  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
	});
	
	/**
	 * GFM Inline Grammar
	 */
	
	inline.gfm = merge({}, inline.normal, {
	  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
	  url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/)
	    .replace('email', inline._email)
	    .getRegex(),
	  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
	  del: /^~~(?=\S)([\s\S]*?\S)~~/,
	  text: edit(inline.text)
	    .replace(']|', '~]|')
	    .replace('|', '|https?://|ftp://|www\\.|[a-zA-Z0-9.!#$%&\'*+/=?^_`{\\|}~-]+@|')
	    .getRegex()
	});
	
	/**
	 * GFM + Line Breaks Inline Grammar
	 */
	
	inline.breaks = merge({}, inline.gfm, {
	  br: edit(inline.br).replace('{2,}', '*').getRegex(),
	  text: edit(inline.gfm.text).replace('{2,}', '*').getRegex()
	});
	
	/**
	 * Inline Lexer & Compiler
	 */
	
	function InlineLexer(links, options) {
	  this.options = options || marked.defaults;
	  this.links = links;
	  this.rules = inline.normal;
	  this.renderer = this.options.renderer || new Renderer();
	  this.renderer.options = this.options;
	
	  if (!this.links) {
	    throw new Error('Tokens array requires a `links` property.');
	  }
	
	  if (this.options.gfm) {
	    if (this.options.breaks) {
	      this.rules = inline.breaks;
	    } else {
	      this.rules = inline.gfm;
	    }
	  } else if (this.options.pedantic) {
	    this.rules = inline.pedantic;
	  }
	}
	
	/**
	 * Expose Inline Rules
	 */
	
	InlineLexer.rules = inline;
	
	/**
	 * Static Lexing/Compiling Method
	 */
	
	InlineLexer.output = function(src, links, options) {
	  var inline = new InlineLexer(links, options);
	  return inline.output(src);
	};
	
	/**
	 * Lexing/Compiling
	 */
	
	InlineLexer.prototype.output = function(src) {
	  var out = '',
	      link,
	      text,
	      href,
	      cap;
	
	  while (src) {
	    // escape
	    if (cap = this.rules.escape.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += cap[1];
	      continue;
	    }
	
	    // autolink
	    if (cap = this.rules.autolink.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = escape(this.mangle(cap[1]));
	        href = 'mailto:' + text;
	      } else {
	        text = escape(cap[1]);
	        href = text;
	      }
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // url (gfm)
	    if (!this.inLink && (cap = this.rules.url.exec(src))) {
	      cap[0] = this.rules._backpedal.exec(cap[0])[0];
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = escape(cap[0]);
	        href = 'mailto:' + text;
	      } else {
	        text = escape(cap[0]);
	        if (cap[1] === 'www.') {
	          href = 'http://' + text;
	        } else {
	          href = text;
	        }
	      }
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // tag
	    if (cap = this.rules.tag.exec(src)) {
	      if (!this.inLink && /^<a /i.test(cap[0])) {
	        this.inLink = true;
	      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
	        this.inLink = false;
	      }
	      src = src.substring(cap[0].length);
	      out += this.options.sanitize
	        ? this.options.sanitizer
	          ? this.options.sanitizer(cap[0])
	          : escape(cap[0])
	        : cap[0]
	      continue;
	    }
	
	    // link
	    if (cap = this.rules.link.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.inLink = true;
	      out += this.outputLink(cap, {
	        href: cap[2],
	        title: cap[3]
	      });
	      this.inLink = false;
	      continue;
	    }
	
	    // reflink, nolink
	    if ((cap = this.rules.reflink.exec(src))
	        || (cap = this.rules.nolink.exec(src))) {
	      src = src.substring(cap[0].length);
	      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
	      link = this.links[link.toLowerCase()];
	      if (!link || !link.href) {
	        out += cap[0].charAt(0);
	        src = cap[0].substring(1) + src;
	        continue;
	      }
	      this.inLink = true;
	      out += this.outputLink(cap, link);
	      this.inLink = false;
	      continue;
	    }
	
	    // strong
	    if (cap = this.rules.strong.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.strong(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // em
	    if (cap = this.rules.em.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.em(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.codespan(escape(cap[2].trim(), true));
	      continue;
	    }
	
	    // br
	    if (cap = this.rules.br.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.br();
	      continue;
	    }
	
	    // del (gfm)
	    if (cap = this.rules.del.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.del(this.output(cap[1]));
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.text(escape(this.smartypants(cap[0])));
	      continue;
	    }
	
	    if (src) {
	      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return out;
	};
	
	/**
	 * Compile Link
	 */
	
	InlineLexer.prototype.outputLink = function(cap, link) {
	  var href = escape(link.href),
	      title = link.title ? escape(link.title) : null;
	
	  return cap[0].charAt(0) !== '!'
	    ? this.renderer.link(href, title, this.output(cap[1]))
	    : this.renderer.image(href, title, escape(cap[1]));
	};
	
	/**
	 * Smartypants Transformations
	 */
	
	InlineLexer.prototype.smartypants = function(text) {
	  if (!this.options.smartypants) return text;
	  return text
	    // em-dashes
	    .replace(/---/g, '\u2014')
	    // en-dashes
	    .replace(/--/g, '\u2013')
	    // opening singles
	    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
	    // closing singles & apostrophes
	    .replace(/'/g, '\u2019')
	    // opening doubles
	    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
	    // closing doubles
	    .replace(/"/g, '\u201d')
	    // ellipses
	    .replace(/\.{3}/g, '\u2026');
	};
	
	/**
	 * Mangle Links
	 */
	
	InlineLexer.prototype.mangle = function(text) {
	  if (!this.options.mangle) return text;
	  var out = '',
	      l = text.length,
	      i = 0,
	      ch;
	
	  for (; i < l; i++) {
	    ch = text.charCodeAt(i);
	    if (Math.random() > 0.5) {
	      ch = 'x' + ch.toString(16);
	    }
	    out += '&#' + ch + ';';
	  }
	
	  return out;
	};
	
	/**
	 * Renderer
	 */
	
	function Renderer(options) {
	  this.options = options || {};
	}
	
	Renderer.prototype.code = function(code, lang, escaped) {
	  if (this.options.highlight) {
	    var out = this.options.highlight(code, lang);
	    if (out != null && out !== code) {
	      escaped = true;
	      code = out;
	    }
	  }
	
	  if (!lang) {
	    return '<pre><code>'
	      + (escaped ? code : escape(code, true))
	      + '\n</code></pre>';
	  }
	
	  return '<pre><code class="'
	    + this.options.langPrefix
	    + escape(lang, true)
	    + '">'
	    + (escaped ? code : escape(code, true))
	    + '\n</code></pre>\n';
	};
	
	Renderer.prototype.blockquote = function(quote) {
	  return '<blockquote>\n' + quote + '</blockquote>\n';
	};
	
	Renderer.prototype.html = function(html) {
	  return html;
	};
	
	Renderer.prototype.heading = function(text, level, raw) {
	  return '<h'
	    + level
	    + ' id="'
	    + this.options.headerPrefix
	    + raw.toLowerCase().replace(/[^\w]+/g, '-')
	    + '">'
	    + text
	    + '</h'
	    + level
	    + '>\n';
	};
	
	Renderer.prototype.hr = function() {
	  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
	};
	
	Renderer.prototype.list = function(body, ordered) {
	  var type = ordered ? 'ol' : 'ul';
	  return '<' + type + '>\n' + body + '</' + type + '>\n';
	};
	
	Renderer.prototype.listitem = function(text) {
	  return '<li>' + text + '</li>\n';
	};
	
	Renderer.prototype.paragraph = function(text) {
	  return '<p>' + text + '</p>\n';
	};
	
	Renderer.prototype.table = function(header, body) {
	  return '<table>\n'
	    + '<thead>\n'
	    + header
	    + '</thead>\n'
	    + '<tbody>\n'
	    + body
	    + '</tbody>\n'
	    + '</table>\n';
	};
	
	Renderer.prototype.tablerow = function(content) {
	  return '<tr>\n' + content + '</tr>\n';
	};
	
	Renderer.prototype.tablecell = function(content, flags) {
	  var type = flags.header ? 'th' : 'td';
	  var tag = flags.align
	    ? '<' + type + ' style="text-align:' + flags.align + '">'
	    : '<' + type + '>';
	  return tag + content + '</' + type + '>\n';
	};
	
	// span level renderer
	Renderer.prototype.strong = function(text) {
	  return '<strong>' + text + '</strong>';
	};
	
	Renderer.prototype.em = function(text) {
	  return '<em>' + text + '</em>';
	};
	
	Renderer.prototype.codespan = function(text) {
	  return '<code>' + text + '</code>';
	};
	
	Renderer.prototype.br = function() {
	  return this.options.xhtml ? '<br/>' : '<br>';
	};
	
	Renderer.prototype.del = function(text) {
	  return '<del>' + text + '</del>';
	};
	
	Renderer.prototype.link = function(href, title, text) {
	  if (this.options.sanitize) {
	    try {
	      var prot = decodeURIComponent(unescape(href))
	        .replace(/[^\w:]/g, '')
	        .toLowerCase();
	    } catch (e) {
	      return text;
	    }
	    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
	      return text;
	    }
	  }
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<a href="' + href + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += '>' + text + '</a>';
	  return out;
	};
	
	Renderer.prototype.image = function(href, title, text) {
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<img src="' + href + '" alt="' + text + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += this.options.xhtml ? '/>' : '>';
	  return out;
	};
	
	Renderer.prototype.text = function(text) {
	  return text;
	};
	
	/**
	 * TextRenderer
	 * returns only the textual part of the token
	 */
	
	function TextRenderer() {}
	
	// no need for block level renderers
	
	TextRenderer.prototype.strong =
	TextRenderer.prototype.em =
	TextRenderer.prototype.codespan =
	TextRenderer.prototype.del =
	TextRenderer.prototype.text = function (text) {
	  return text;
	}
	
	TextRenderer.prototype.link =
	TextRenderer.prototype.image = function(href, title, text) {
	  return '' + text;
	}
	
	TextRenderer.prototype.br = function() {
	  return '';
	}
	
	/**
	 * Parsing & Compiling
	 */
	
	function Parser(options) {
	  this.tokens = [];
	  this.token = null;
	  this.options = options || marked.defaults;
	  this.options.renderer = this.options.renderer || new Renderer();
	  this.renderer = this.options.renderer;
	  this.renderer.options = this.options;
	}
	
	/**
	 * Static Parse Method
	 */
	
	Parser.parse = function(src, options) {
	  var parser = new Parser(options);
	  return parser.parse(src);
	};
	
	/**
	 * Parse Loop
	 */
	
	Parser.prototype.parse = function(src) {
	  this.inline = new InlineLexer(src.links, this.options);
	  // use an InlineLexer with a TextRenderer to extract pure text
	  this.inlineText = new InlineLexer(
	    src.links,
	    merge({}, this.options, {renderer: new TextRenderer()})
	  );
	  this.tokens = src.reverse();
	
	  var out = '';
	  while (this.next()) {
	    out += this.tok();
	  }
	
	  return out;
	};
	
	/**
	 * Next Token
	 */
	
	Parser.prototype.next = function() {
	  return this.token = this.tokens.pop();
	};
	
	/**
	 * Preview Next Token
	 */
	
	Parser.prototype.peek = function() {
	  return this.tokens[this.tokens.length - 1] || 0;
	};
	
	/**
	 * Parse Text Tokens
	 */
	
	Parser.prototype.parseText = function() {
	  var body = this.token.text;
	
	  while (this.peek().type === 'text') {
	    body += '\n' + this.next().text;
	  }
	
	  return this.inline.output(body);
	};
	
	/**
	 * Parse Current Token
	 */
	
	Parser.prototype.tok = function() {
	  switch (this.token.type) {
	    case 'space': {
	      return '';
	    }
	    case 'hr': {
	      return this.renderer.hr();
	    }
	    case 'heading': {
	      return this.renderer.heading(
	        this.inline.output(this.token.text),
	        this.token.depth,
	        unescape(this.inlineText.output(this.token.text)));
	    }
	    case 'code': {
	      return this.renderer.code(this.token.text,
	        this.token.lang,
	        this.token.escaped);
	    }
	    case 'table': {
	      var header = '',
	          body = '',
	          i,
	          row,
	          cell,
	          j;
	
	      // header
	      cell = '';
	      for (i = 0; i < this.token.header.length; i++) {
	        cell += this.renderer.tablecell(
	          this.inline.output(this.token.header[i]),
	          { header: true, align: this.token.align[i] }
	        );
	      }
	      header += this.renderer.tablerow(cell);
	
	      for (i = 0; i < this.token.cells.length; i++) {
	        row = this.token.cells[i];
	
	        cell = '';
	        for (j = 0; j < row.length; j++) {
	          cell += this.renderer.tablecell(
	            this.inline.output(row[j]),
	            { header: false, align: this.token.align[j] }
	          );
	        }
	
	        body += this.renderer.tablerow(cell);
	      }
	      return this.renderer.table(header, body);
	    }
	    case 'blockquote_start': {
	      body = '';
	
	      while (this.next().type !== 'blockquote_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.blockquote(body);
	    }
	    case 'list_start': {
	      body = '';
	      var ordered = this.token.ordered;
	
	      while (this.next().type !== 'list_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.list(body, ordered);
	    }
	    case 'list_item_start': {
	      body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.token.type === 'text'
	          ? this.parseText()
	          : this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'loose_item_start': {
	      body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'html': {
	      var html = !this.token.pre && !this.options.pedantic
	        ? this.inline.output(this.token.text)
	        : this.token.text;
	      return this.renderer.html(html);
	    }
	    case 'paragraph': {
	      return this.renderer.paragraph(this.inline.output(this.token.text));
	    }
	    case 'text': {
	      return this.renderer.paragraph(this.parseText());
	    }
	  }
	};
	
	/**
	 * Helpers
	 */
	
	function escape(html, encode) {
	  return html
	    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;')
	    .replace(/"/g, '&quot;')
	    .replace(/'/g, '&#39;');
	}
	
	function unescape(html) {
	  // explicitly match decimal, hex, and named HTML entities
	  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
	    n = n.toLowerCase();
	    if (n === 'colon') return ':';
	    if (n.charAt(0) === '#') {
	      return n.charAt(1) === 'x'
	        ? String.fromCharCode(parseInt(n.substring(2), 16))
	        : String.fromCharCode(+n.substring(1));
	    }
	    return '';
	  });
	}
	
	function edit(regex, opt) {
	  regex = regex.source;
	  opt = opt || '';
	  return {
	    replace: function(name, val) {
	      val = val.source || val;
	      val = val.replace(/(^|[^\[])\^/g, '$1');
	      regex = regex.replace(name, val);
	      return this;
	    },
	    getRegex: function() {
	      return new RegExp(regex, opt);
	    }
	  };
	}
	
	function resolveUrl(base, href) {
	  if (!baseUrls[' ' + base]) {
	    // we can ignore everything in base after the last slash of its path component,
	    // but we might need to add _that_
	    // https://tools.ietf.org/html/rfc3986#section-3
	    if (/^[^:]+:\/*[^/]*$/.test(base)) {
	      baseUrls[' ' + base] = base + '/';
	    } else {
	      baseUrls[' ' + base] = base.replace(/[^/]*$/, '');
	    }
	  }
	  base = baseUrls[' ' + base];
	
	  if (href.slice(0, 2) === '//') {
	    return base.replace(/:[\s\S]*/, ':') + href;
	  } else if (href.charAt(0) === '/') {
	    return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
	  } else {
	    return base + href;
	  }
	}
	var baseUrls = {};
	var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
	
	function noop() {}
	noop.exec = noop;
	
	function merge(obj) {
	  var i = 1,
	      target,
	      key;
	
	  for (; i < arguments.length; i++) {
	    target = arguments[i];
	    for (key in target) {
	      if (Object.prototype.hasOwnProperty.call(target, key)) {
	        obj[key] = target[key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Marked
	 */
	
	function marked(src, opt, callback) {
	  // throw error in case of non string input
	  if (typeof src === 'undefined' || src === null) {
	    throw new Error('marked(): input parameter is undefined or null');
	  }
	  if (typeof src !== 'string') {
	    throw new Error('marked(): input parameter is of type '
	      + Object.prototype.toString.call(src) + ', string expected');
	  }
	
	  if (callback || typeof opt === 'function') {
	    if (!callback) {
	      callback = opt;
	      opt = null;
	    }
	
	    opt = merge({}, marked.defaults, opt || {});
	
	    var highlight = opt.highlight,
	        tokens,
	        pending,
	        i = 0;
	
	    try {
	      tokens = Lexer.lex(src, opt)
	    } catch (e) {
	      return callback(e);
	    }
	
	    pending = tokens.length;
	
	    var done = function(err) {
	      if (err) {
	        opt.highlight = highlight;
	        return callback(err);
	      }
	
	      var out;
	
	      try {
	        out = Parser.parse(tokens, opt);
	      } catch (e) {
	        err = e;
	      }
	
	      opt.highlight = highlight;
	
	      return err
	        ? callback(err)
	        : callback(null, out);
	    };
	
	    if (!highlight || highlight.length < 3) {
	      return done();
	    }
	
	    delete opt.highlight;
	
	    if (!pending) return done();
	
	    for (; i < tokens.length; i++) {
	      (function(token) {
	        if (token.type !== 'code') {
	          return --pending || done();
	        }
	        return highlight(token.text, token.lang, function(err, code) {
	          if (err) return done(err);
	          if (code == null || code === token.text) {
	            return --pending || done();
	          }
	          token.text = code;
	          token.escaped = true;
	          --pending || done();
	        });
	      })(tokens[i]);
	    }
	
	    return;
	  }
	  try {
	    if (opt) opt = merge({}, marked.defaults, opt);
	    return Parser.parse(Lexer.lex(src, opt), opt);
	  } catch (e) {
	    e.message += '\nPlease report this to https://github.com/markedjs/marked.';
	    if ((opt || marked.defaults).silent) {
	      return '<p>An error occurred:</p><pre>'
	        + escape(e.message + '', true)
	        + '</pre>';
	    }
	    throw e;
	  }
	}
	
	/**
	 * Options
	 */
	
	marked.options =
	marked.setOptions = function(opt) {
	  merge(marked.defaults, opt);
	  return marked;
	};
	
	marked.defaults = {
	  gfm: true,
	  tables: true,
	  breaks: false,
	  pedantic: false,
	  sanitize: false,
	  sanitizer: null,
	  mangle: true,
	  smartLists: false,
	  silent: false,
	  highlight: null,
	  langPrefix: 'lang-',
	  smartypants: false,
	  headerPrefix: '',
	  renderer: new Renderer(),
	  xhtml: false,
	  baseUrl: null
	};
	
	/**
	 * Expose
	 */
	
	marked.Parser = Parser;
	marked.parser = Parser.parse;
	
	marked.Renderer = Renderer;
	marked.TextRenderer = TextRenderer;
	
	marked.Lexer = Lexer;
	marked.lexer = Lexer.lex;
	
	marked.InlineLexer = InlineLexer;
	marked.inlineLexer = InlineLexer.output;
	
	marked.parse = marked;
	
	if (true) {
	  module.exports = marked;
	} else if (typeof define === 'function' && define.amd) {
	  define(function() { return marked; });
	} else {
	  root.marked = marked;
	}
	})(this || (typeof window !== 'undefined' ? window : global));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 241 */
/***/ function(module, exports) {

	/**
	 * adds a bindGlobal method to Mousetrap that allows you to
	 * bind specific keyboard shortcuts that will still work
	 * inside a text input field
	 *
	 * usage:
	 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
	 */
	/* global Mousetrap:true */
	(function(Mousetrap) {
	    var _globalCallbacks = {};
	    var _originalStopCallback = Mousetrap.prototype.stopCallback;
	
	    Mousetrap.prototype.stopCallback = function(e, element, combo, sequence) {
	        var self = this;
	
	        if (self.paused) {
	            return true;
	        }
	
	        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) {
	            return false;
	        }
	
	        return _originalStopCallback.call(self, e, element, combo);
	    };
	
	    Mousetrap.prototype.bindGlobal = function(keys, callback, action) {
	        var self = this;
	        self.bind(keys, callback, action);
	
	        if (keys instanceof Array) {
	            for (var i = 0; i < keys.length; i++) {
	                _globalCallbacks[keys[i]] = true;
	            }
	            return;
	        }
	
	        _globalCallbacks[keys] = true;
	    };
	
	    Mousetrap.init();
	}) (Mousetrap);


/***/ },
/* 242 */
/***/ function(module, exports) {



/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(246);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(21);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	var assign = __webpack_require__(12);
	
	var ReactPropTypesSecret = __webpack_require__(247);
	var checkPropTypes = __webpack_require__(244);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(52);
	
	module.exports = {
	  shouldComponentUpdate: function(nextProps, nextState) {
	    return (
	      !shallowEqual(this.props, nextProps) ||
	      !shallowEqual(this.state, nextState)
	    );
	  }
	};


/***/ },
/* 249 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(16);
	
	var focusNode = __webpack_require__(93);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(20);
	var FallbackCompositionState = __webpack_require__(257);
	var SyntheticCompositionEvent = __webpack_require__(290);
	var SyntheticInputEvent = __webpack_require__(293);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(106);
	var ExecutionEnvironment = __webpack_require__(20);
	var ReactInstrumentation = __webpack_require__(22);
	
	var camelizeStyleName = __webpack_require__(205);
	var dangerousStyleValue = __webpack_require__(299);
	var hyphenateStyleName = __webpack_require__(212);
	var memoizeStringOnly = __webpack_require__(215);
	var warning = __webpack_require__(8);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    // Don't warn for CSS variables
	    if (name.indexOf('--') === 0) {
	      return;
	    }
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleName.indexOf('--') === 0) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(43);
	var EventPropagators = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(24);
	var SyntheticEvent = __webpack_require__(27);
	
	var inputValueTracking = __webpack_require__(129);
	var getEventTarget = __webpack_require__(76);
	var isEventSupported = __webpack_require__(78);
	var isTextInputElement = __webpack_require__(130);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var DOMLazyTree = __webpack_require__(38);
	var ExecutionEnvironment = __webpack_require__(20);
	
	var createNodesFromMarkup = __webpack_require__(208);
	var emptyFunction = __webpack_require__(21);
	var invariant = __webpack_require__(4);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 255 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(16);
	var SyntheticMouseEvent = __webpack_require__(55);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var PooledClass = __webpack_require__(32);
	
	var getTextContentAccessor = __webpack_require__(128);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(33);
	
	var instantiateReactComponent = __webpack_require__(77);
	var KeyEscapeUtils = __webpack_require__(68);
	var shouldUpdateReactComponent = __webpack_require__(79);
	var traverseAllChildren = __webpack_require__(132);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(138);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(64);
	var ReactDOMIDOperations = __webpack_require__(265);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(12);
	
	var React = __webpack_require__(34);
	var ReactComponentEnvironment = __webpack_require__(70);
	var ReactCurrentOwner = __webpack_require__(30);
	var ReactErrorUtils = __webpack_require__(71);
	var ReactInstanceMap = __webpack_require__(45);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactNodeTypes = __webpack_require__(121);
	var ReactReconciler = __webpack_require__(33);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(42);
	var invariant = __webpack_require__(4);
	var shallowEqual = __webpack_require__(52);
	var shouldUpdateReactComponent = __webpack_require__(79);
	var warning = __webpack_require__(8);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDefaultInjection = __webpack_require__(114);
	var ReactMount = __webpack_require__(120);
	var ReactReconciler = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(24);
	var ReactVersion = __webpack_require__(123);
	
	var findDOMNode = __webpack_require__(300);
	var getHostComponentFromComposite = __webpack_require__(127);
	var renderSubtreeIntoContainer = __webpack_require__(307);
	var warning = __webpack_require__(8);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(12);
	
	var AutoFocusUtils = __webpack_require__(250);
	var CSSPropertyOperations = __webpack_require__(252);
	var DOMLazyTree = __webpack_require__(38);
	var DOMNamespaces = __webpack_require__(65);
	var DOMProperty = __webpack_require__(39);
	var DOMPropertyOperations = __webpack_require__(108);
	var EventPluginHub = __webpack_require__(43);
	var EventPluginRegistry = __webpack_require__(66);
	var ReactBrowserEventEmitter = __webpack_require__(54);
	var ReactDOMComponentFlags = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDOMInput = __webpack_require__(266);
	var ReactDOMOption = __webpack_require__(267);
	var ReactDOMSelect = __webpack_require__(112);
	var ReactDOMTextarea = __webpack_require__(271);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactMultiChild = __webpack_require__(277);
	var ReactServerRenderingTransaction = __webpack_require__(122);
	
	var emptyFunction = __webpack_require__(21);
	var escapeTextContentForBrowser = __webpack_require__(57);
	var invariant = __webpack_require__(4);
	var isEventSupported = __webpack_require__(78);
	var shallowEqual = __webpack_require__(52);
	var inputValueTracking = __webpack_require__(129);
	var validateDOMNesting = __webpack_require__(80);
	var warning = __webpack_require__(8);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var DOMLazyTree = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(16);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 264 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(16);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(12);
	
	var DOMPropertyOperations = __webpack_require__(108);
	var LinkedValueUtils = __webpack_require__(69);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var React = __webpack_require__(34);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDOMSelect = __webpack_require__(112);
	
	var warning = __webpack_require__(8);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var getNodeForCharacterOffset = __webpack_require__(304);
	var getTextContentAccessor = __webpack_require__(128);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(114);
	var ReactServerRendering = __webpack_require__(283);
	var ReactVersion = __webpack_require__(123);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(12);
	
	var DOMChildrenOperations = __webpack_require__(64);
	var DOMLazyTree = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(16);
	
	var escapeTextContentForBrowser = __webpack_require__(57);
	var invariant = __webpack_require__(4);
	var validateDOMNesting = __webpack_require__(80);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9),
	    _assign = __webpack_require__(12);
	
	var LinkedValueUtils = __webpack_require__(69);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 273 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(43);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var EventListener = __webpack_require__(92);
	var ExecutionEnvironment = __webpack_require__(20);
	var PooledClass = __webpack_require__(32);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(24);
	
	var getEventTarget = __webpack_require__(76);
	var getUnboundedScrollPosition = __webpack_require__(210);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(39);
	var EventPluginHub = __webpack_require__(43);
	var EventPluginUtils = __webpack_require__(67);
	var ReactComponentEnvironment = __webpack_require__(70);
	var ReactEmptyComponent = __webpack_require__(115);
	var ReactBrowserEventEmitter = __webpack_require__(54);
	var ReactHostComponent = __webpack_require__(117);
	var ReactUpdates = __webpack_require__(24);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactComponentEnvironment = __webpack_require__(70);
	var ReactInstanceMap = __webpack_require__(45);
	var ReactInstrumentation = __webpack_require__(22);
	
	var ReactCurrentOwner = __webpack_require__(30);
	var ReactReconciler = __webpack_require__(33);
	var ReactChildReconciler = __webpack_require__(258);
	
	var emptyFunction = __webpack_require__(21);
	var flattenChildren = __webpack_require__(301);
	var invariant = __webpack_require__(4);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 279 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(12);
	
	var CallbackQueue = __webpack_require__(107);
	var PooledClass = __webpack_require__(32);
	var ReactBrowserEventEmitter = __webpack_require__(54);
	var ReactInputSelection = __webpack_require__(118);
	var ReactInstrumentation = __webpack_require__(22);
	var Transaction = __webpack_require__(56);
	var ReactUpdateQueue = __webpack_require__(72);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(278);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 282 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var React = __webpack_require__(34);
	var ReactDOMContainerInfo = __webpack_require__(111);
	var ReactDefaultBatchingStrategy = __webpack_require__(113);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactMarkupChecksum = __webpack_require__(119);
	var ReactReconciler = __webpack_require__(33);
	var ReactServerBatchingStrategy = __webpack_require__(282);
	var ReactServerRenderingTransaction = __webpack_require__(122);
	var ReactUpdates = __webpack_require__(24);
	
	var emptyObject = __webpack_require__(42);
	var instantiateReactComponent = __webpack_require__(77);
	var invariant = __webpack_require__(4);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(72);
	
	var warning = __webpack_require__(8);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 285 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactInputSelection = __webpack_require__(118);
	var SyntheticEvent = __webpack_require__(27);
	
	var getActiveElement = __webpack_require__(94);
	var isTextInputElement = __webpack_require__(130);
	var shallowEqual = __webpack_require__(52);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var EventListener = __webpack_require__(92);
	var EventPropagators = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(16);
	var SyntheticAnimationEvent = __webpack_require__(288);
	var SyntheticClipboardEvent = __webpack_require__(289);
	var SyntheticEvent = __webpack_require__(27);
	var SyntheticFocusEvent = __webpack_require__(292);
	var SyntheticKeyboardEvent = __webpack_require__(294);
	var SyntheticMouseEvent = __webpack_require__(55);
	var SyntheticDragEvent = __webpack_require__(291);
	var SyntheticTouchEvent = __webpack_require__(295);
	var SyntheticTransitionEvent = __webpack_require__(296);
	var SyntheticUIEvent = __webpack_require__(46);
	var SyntheticWheelEvent = __webpack_require__(297);
	
	var emptyFunction = __webpack_require__(21);
	var getEventCharCode = __webpack_require__(74);
	var invariant = __webpack_require__(4);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(55);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(46);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(46);
	
	var getEventCharCode = __webpack_require__(74);
	var getEventKey = __webpack_require__(302);
	var getEventModifierState = __webpack_require__(75);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(46);
	
	var getEventModifierState = __webpack_require__(75);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(55);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 298 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(106);
	var warning = __webpack_require__(8);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(9);
	
	var ReactCurrentOwner = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactInstanceMap = __webpack_require__(45);
	
	var getHostComponentFromComposite = __webpack_require__(127);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(68);
	var traverseAllChildren = __webpack_require__(132);
	var warning = __webpack_require__(8);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(138);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(74);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 303 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 304 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(57);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(120);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(310);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(21);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(8);
	
	var ReactPropTypesSecret = __webpack_require__(311);
	var checkPropTypes = __webpack_require__(308);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 311 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2), __webpack_require__(17));
		else if(typeof define === 'function' && define.amd)
			define(["react", "react-dom"], factory);
		else if(typeof exports === 'object')
			exports["ReactDraggable"] = factory(require("react"), require("react-dom"));
		else
			root["ReactDraggable"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		module.exports = __webpack_require__(1).default;
		module.exports.DraggableCore = __webpack_require__(9).default;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _reactDom = __webpack_require__(3);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _classnames = __webpack_require__(4);
		
		var _classnames2 = _interopRequireDefault(_classnames);
		
		var _domFns = __webpack_require__(5);
		
		var _positionFns = __webpack_require__(8);
		
		var _shims = __webpack_require__(6);
		
		var _DraggableCore = __webpack_require__(9);
		
		var _DraggableCore2 = _interopRequireDefault(_DraggableCore);
		
		var _log = __webpack_require__(11);
		
		var _log2 = _interopRequireDefault(_log);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		// $FlowIgnore
		
		
		/*:: import type {DraggableEventHandler} from './utils/types';*/
		/*:: type DraggableState = {
		  dragging: boolean,
		  dragged: boolean,
		  x: number, y: number,
		  slackX: number, slackY: number,
		  isElementSVG: boolean
		};*/
		
		
		//
		// Define <Draggable>
		//
		
		/*:: type ConstructorProps = {
		  position: { x: number, y: number },
		  defaultPosition: { x: number, y: number }
		};*/
		
		var Draggable = function (_React$Component) {
		  _inherits(Draggable, _React$Component);
		
		  function Draggable(props /*: ConstructorProps*/) {
		    _classCallCheck(this, Draggable);
		
		    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Draggable).call(this, props));
		
		    _this.onDragStart = function (e, coreData) {
		      (0, _log2.default)('Draggable: onDragStart: %j', coreData);
		
		      // Short-circuit if user's callback killed it.
		      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
		      // Kills start event on core as well, so move handlers are never bound.
		      if (shouldStart === false) return false;
		
		      _this.setState({ dragging: true, dragged: true });
		    };
		
		    _this.onDrag = function (e, coreData) {
		      if (!_this.state.dragging) return false;
		      (0, _log2.default)('Draggable: onDrag: %j', coreData);
		
		      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);
		
		      var newState /*: $Shape<DraggableState>*/ = {
		        x: uiData.x,
		        y: uiData.y
		      };
		
		      // Keep within bounds.
		      if (_this.props.bounds) {
		        // Save original x and y.
		        var _x = newState.x;
		        var _y = newState.y;
		
		        // Add slack to the values used to calculate bound position. This will ensure that if
		        // we start removing slack, the element won't react to it right away until it's been
		        // completely removed.
		
		        newState.x += _this.state.slackX;
		        newState.y += _this.state.slackY;
		
		        // Get bound position. This will ceil/floor the x and y within the boundaries.
		        // $FlowBug
		
		
		        // Recalculate slack by noting how much was shaved by the boundPosition handler.
		
		        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y);
		
		        var _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2);
		
		        newState.x = _getBoundPosition2[0];
		        newState.y = _getBoundPosition2[1];
		        newState.slackX = _this.state.slackX + (_x - newState.x);
		        newState.slackY = _this.state.slackY + (_y - newState.y);
		
		        // Update the event we fire to reflect what really happened after bounds took effect.
		        uiData.x = _x;
		        uiData.y = _y;
		        uiData.deltaX = newState.x - _this.state.x;
		        uiData.deltaY = newState.y - _this.state.y;
		      }
		
		      // Short-circuit if user's callback killed it.
		      var shouldUpdate = _this.props.onDrag(e, uiData);
		      if (shouldUpdate === false) return false;
		
		      _this.setState(newState);
		    };
		
		    _this.onDragStop = function (e, coreData) {
		      if (!_this.state.dragging) return false;
		
		      // Short-circuit if user's callback killed it.
		      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
		      if (shouldStop === false) return false;
		
		      (0, _log2.default)('Draggable: onDragStop: %j', coreData);
		
		      var newState /*: $Shape<DraggableState>*/ = {
		        dragging: false,
		        slackX: 0,
		        slackY: 0
		      };
		
		      // If this is a controlled component, the result of this operation will be to
		      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
		      var controlled = Boolean(_this.props.position);
		      if (controlled) {
		        var _this$props$position = _this.props.position;
		        var _x2 = _this$props$position.x;
		        var _y2 = _this$props$position.y;
		
		        newState.x = _x2;
		        newState.y = _y2;
		      }
		
		      _this.setState(newState);
		    };
		
		    _this.state = {
		      // Whether or not we are currently dragging.
		      dragging: false,
		
		      // Whether or not we have been dragged before.
		      dragged: false,
		
		      // Current transform x and y.
		      x: props.position ? props.position.x : props.defaultPosition.x,
		      y: props.position ? props.position.y : props.defaultPosition.y,
		
		      // Used for compensating for out-of-bounds drags
		      slackX: 0, slackY: 0,
		
		      // Can only determine if SVG after mounting
		      isElementSVG: false
		    };
		    return _this;
		  }
		
		  _createClass(Draggable, [{
		    key: 'componentWillMount',
		    value: function componentWillMount() {
		      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
		        // eslint-disable-next-line
		        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
		      }
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      // Check to see if the element passed is an instanceof SVGElement
		      if (typeof SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof SVGElement) {
		        this.setState({ isElementSVG: true });
		      }
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps /*: Object*/) {
		      // Set x/y if position has changed
		      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
		        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
		      }
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _classNames;
		
		      var style = {},
		          svgTransform = null;
		
		      // If this is controlled, we don't want to move it - unless it's dragging.
		      var controlled = Boolean(this.props.position);
		      var draggable = !controlled || this.state.dragging;
		
		      var position = this.props.position || this.props.defaultPosition;
		      var transformOpts = {
		        // Set left if horizontal drag is enabled
		        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,
		
		        // Set top if vertical drag is enabled
		        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
		      };
		
		      // If this element was SVG, we use the `transform` attribute.
		      if (this.state.isElementSVG) {
		        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
		      } else {
		        // Add a CSS transform to move the element around. This allows us to move the element around
		        // without worrying about whether or not it is relatively or absolutely positioned.
		        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
		        // has a clean slate.
		        style = (0, _domFns.createCSSTransform)(transformOpts);
		      }
		
		      var _props = this.props;
		      var defaultClassName = _props.defaultClassName;
		      var defaultClassNameDragging = _props.defaultClassNameDragging;
		      var defaultClassNameDragged = _props.defaultClassNameDragged;
		
		      // Mark with class while dragging
		
		      var className = (0, _classnames2.default)(this.props.children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
		
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return _react2.default.createElement(
		        _DraggableCore2.default,
		        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
		        _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
		          className: className,
		          style: _extends({}, this.props.children.props.style, style),
		          transform: svgTransform
		        })
		      );
		    }
		  }]);
		
		  return Draggable;
		}(_react2.default.Component);
		
		Draggable.displayName = 'Draggable';
		Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {
		
		  /**
		   * `axis` determines which axis the draggable can move.
		   *
		   *  Note that all callbacks will still return data as normal. This only
		   *  controls flushing to the DOM.
		   *
		   * 'both' allows movement horizontally and vertically.
		   * 'x' limits movement to horizontal axis.
		   * 'y' limits movement to vertical axis.
		   * 'none' limits all movement.
		   *
		   * Defaults to 'both'.
		   */
		  axis: _react.PropTypes.oneOf(['both', 'x', 'y', 'none']),
		
		  /**
		   * `bounds` determines the range of movement available to the element.
		   * Available values are:
		   *
		   * 'parent' restricts movement within the Draggable's parent node.
		   *
		   * Alternatively, pass an object with the following properties, all of which are optional:
		   *
		   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
		   *
		   * All values are in px.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable bounds={{right: 300, bottom: 300}}>
		   *              <div>Content</div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  bounds: _react.PropTypes.oneOfType([_react.PropTypes.shape({
		    left: _react.PropTypes.number,
		    right: _react.PropTypes.number,
		    top: _react.PropTypes.number,
		    bottom: _react.PropTypes.number
		  }), _react.PropTypes.string, _react.PropTypes.oneOf([false])]),
		
		  defaultClassName: _react.PropTypes.string,
		  defaultClassNameDragging: _react.PropTypes.string,
		  defaultClassNameDragged: _react.PropTypes.string,
		
		  /**
		   * `defaultPosition` specifies the x and y that the dragged item should start at
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  defaultPosition: _react.PropTypes.shape({
		    x: _react.PropTypes.number,
		    y: _react.PropTypes.number
		  }),
		
		  /**
		   * `position`, if present, defines the current position of the element.
		   *
		   *  This is similar to how form elements in React work - if no `position` is supplied, the component
		   *  is uncontrolled.
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable position={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  position: _react.PropTypes.shape({
		    x: _react.PropTypes.number,
		    y: _react.PropTypes.number
		  }),
		
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: _shims.dontSetMe,
		  style: _shims.dontSetMe,
		  transform: _shims.dontSetMe
		});
		Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
		  axis: 'both',
		  bounds: false,
		  defaultClassName: 'react-draggable',
		  defaultClassNameDragging: 'react-draggable-dragging',
		  defaultClassNameDragged: 'react-draggable-dragged',
		  defaultPosition: { x: 0, y: 0 },
		  position: null
		});
		exports.default = Draggable;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
		/* global define */
		
		(function () {
			'use strict';
		
			var hasOwn = {}.hasOwnProperty;
		
			function classNames () {
				var classes = [];
		
				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (!arg) continue;
		
					var argType = typeof arg;
		
					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}
		
				return classes.join(' ');
			}
		
			if (typeof module !== 'undefined' && module.exports) {
				module.exports = classNames;
			} else if (true) {
				// register as 'classnames', consistent with npm package name
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return classNames;
				}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else {
				window.classNames = classNames;
			}
		}());
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		exports.matchesSelector = matchesSelector;
		exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
		exports.addEvent = addEvent;
		exports.removeEvent = removeEvent;
		exports.outerHeight = outerHeight;
		exports.outerWidth = outerWidth;
		exports.innerHeight = innerHeight;
		exports.innerWidth = innerWidth;
		exports.offsetXYFromParent = offsetXYFromParent;
		exports.createCSSTransform = createCSSTransform;
		exports.createSVGTransform = createSVGTransform;
		exports.getTouch = getTouch;
		exports.getTouchIdentifier = getTouchIdentifier;
		exports.addUserSelectStyles = addUserSelectStyles;
		exports.removeUserSelectStyles = removeUserSelectStyles;
		exports.styleHacks = styleHacks;
		
		var _shims = __webpack_require__(6);
		
		var _getPrefix = __webpack_require__(7);
		
		var _getPrefix2 = _interopRequireDefault(_getPrefix);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		/*:: import type {ControlPosition} from './types';*/
		
		
		var matchesSelectorFunc = '';
		function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
		  if (!matchesSelectorFunc) {
		    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
		      // $FlowIgnore: Doesn't think elements are indexable
		      return (0, _shims.isFunction)(el[method]);
		    });
		  }
		
		  // $FlowIgnore: Doesn't think elements are indexable
		  return el[matchesSelectorFunc].call(el, selector);
		}
		
		// Works up the tree to the draggable itself attempting to match selector.
		function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
		  var node = el;
		  do {
		    if (matchesSelector(node, selector)) return true;
		    if (node === baseNode) return false;
		    node = node.parentNode;
		  } while (node);
		
		  return false;
		}
		
		function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.attachEvent) {
		    el.attachEvent('on' + event, handler);
		  } else if (el.addEventListener) {
		    el.addEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = handler;
		  }
		}
		
		function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.detachEvent) {
		    el.detachEvent('on' + event, handler);
		  } else if (el.removeEventListener) {
		    el.removeEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = null;
		  }
		}
		
		function outerHeight(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetTop which is including margin. See getBoundPosition
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height += (0, _shims.int)(computedStyle.borderTopWidth);
		  height += (0, _shims.int)(computedStyle.borderBottomWidth);
		  return height;
		}
		
		function outerWidth(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetLeft which is including margin. See getBoundPosition
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width += (0, _shims.int)(computedStyle.borderLeftWidth);
		  width += (0, _shims.int)(computedStyle.borderRightWidth);
		  return width;
		}
		function innerHeight(node /*: HTMLElement*/) /*: number*/ {
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height -= (0, _shims.int)(computedStyle.paddingTop);
		  height -= (0, _shims.int)(computedStyle.paddingBottom);
		  return height;
		}
		
		function innerWidth(node /*: HTMLElement*/) /*: number*/ {
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width -= (0, _shims.int)(computedStyle.paddingLeft);
		  width -= (0, _shims.int)(computedStyle.paddingRight);
		  return width;
		}
		
		// Get from offsetParent
		function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
		  var isBody = offsetParent === offsetParent.ownerDocument.body;
		  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();
		
		  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
		  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
		
		  return { x: x, y: y };
		}
		
		function createCSSTransform(_ref) /*: Object*/ {
		  var x = _ref.x;
		  var y = _ref.y;
		
		  // Replace unitless items with px
		  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
		}
		
		function createSVGTransform(_ref3) /*: string*/ {
		  var x = _ref3.x;
		  var y = _ref3.y;
		
		  return 'translate(' + x + ',' + y + ')';
		}
		
		function getTouch(e /*: MouseEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
		  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
		    return identifier === t.identifier;
		  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
		    return identifier === t.identifier;
		  });
		}
		
		function getTouchIdentifier(e /*: MouseEvent*/) /*: ?number*/ {
		  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
		  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
		}
		
		// User-select Hacks:
		//
		// Useful for preventing blue highlights all over everything when dragging.
		var userSelectPrefix = (0, _getPrefix.getPrefix)('user-select');
		var userSelect = (0, _getPrefix.browserPrefixToStyle)('user-select', userSelectPrefix);
		var userSelectStyle = ';' + userSelect + ': none;';
		
		// Note we're passing `document` b/c we could be iframed
		function addUserSelectStyles(body /*: HTMLElement*/) {
		  var style = body.getAttribute('style') || '';
		  body.setAttribute('style', style + userSelectStyle);
		}
		
		function removeUserSelectStyles(body /*: HTMLElement*/) {
		  var style = body.getAttribute('style') || '';
		  body.setAttribute('style', style.replace(userSelectStyle, ''));
		}
		
		function styleHacks() /*: Object*/ {
		  var childStyle /*: Object*/ = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		
		  // Workaround IE pointer events; see #51
		  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
		  return _extends({
		    touchAction: 'none'
		  }, childStyle);
		}
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.findInArray = findInArray;
		exports.isFunction = isFunction;
		exports.isNum = isNum;
		exports.int = int;
		exports.dontSetMe = dontSetMe;
		
		// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
		function findInArray(array /*: Array<any>*/, callback /*: Function*/) /*: any*/ {
		  for (var i = 0, length = array.length; i < length; i++) {
		    if (callback.apply(callback, [array[i], i, array])) return array[i];
		  }
		}
		
		function isFunction(func /*: any*/) /*: boolean*/ {
		  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
		}
		
		function isNum(num /*: any*/) /*: boolean*/ {
		  return typeof num === 'number' && !isNaN(num);
		}
		
		function int(a /*: string*/) /*: number*/ {
		  return parseInt(a, 10);
		}
		
		function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
		  if (props[propName]) {
		    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
		  }
		}
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getPrefix = getPrefix;
		exports.browserPrefixToKey = browserPrefixToKey;
		exports.browserPrefixToStyle = browserPrefixToStyle;
		
		var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
		function getPrefix() /*: string*/ {
		  var prop /*: string*/ = arguments.length <= 0 || arguments[0] === undefined ? 'transform' : arguments[0];
		
		  // Checking specifically for 'window.document' is for pseudo-browser server-side
		  // environments that define 'window' as the global context.
		  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
		  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
		
		  var style = window.document.documentElement.style;
		
		  if (prop in style) return '';
		
		  for (var i = 0; i < prefixes.length; i++) {
		    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
		  }
		
		  return '';
		}
		
		function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
		}
		
		function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
		}
		
		function kebabToTitleCase(str /*: string*/) /*: string*/ {
		  var out = '';
		  var shouldCapitalize = true;
		  for (var i = 0; i < str.length; i++) {
		    if (shouldCapitalize) {
		      out += str[i].toUpperCase();
		      shouldCapitalize = false;
		    } else if (str[i] === '-') {
		      shouldCapitalize = true;
		    } else {
		      out += str[i];
		    }
		  }
		  return out;
		}
		
		// Default export is the prefix itself, like 'Moz', 'Webkit', etc
		// Note that you may have to re-test for certain things; for instance, Chrome 50
		// can handle unprefixed `transform`, but not unprefixed `user-select`
		exports.default = getPrefix();
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getBoundPosition = getBoundPosition;
		exports.snapToGrid = snapToGrid;
		exports.canDragX = canDragX;
		exports.canDragY = canDragY;
		exports.getControlPosition = getControlPosition;
		exports.createCoreData = createCoreData;
		exports.createDraggableData = createDraggableData;
		
		var _shims = __webpack_require__(6);
		
		var _reactDom = __webpack_require__(3);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _domFns = __webpack_require__(5);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/*:: import type Draggable from '../Draggable';*/
		/*:: import type {Bounds, ControlPosition, DraggableData} from './types';*/
		/*:: import type DraggableCore from '../DraggableCore';*/
		function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
		  // If no bounds, short-circuit and move on
		  if (!draggable.props.bounds) return [x, y];
		
		  // Clone new bounds
		  var bounds = draggable.props.bounds;
		
		  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
		  var node = _reactDom2.default.findDOMNode(draggable);
		
		  if (typeof bounds === 'string') {
		    var ownerDocument = node.ownerDocument;
		
		    var ownerWindow = ownerDocument.defaultView;
		    var boundNode = void 0;
		    if (bounds === 'parent') {
		      boundNode = node.parentNode;
		    } else {
		      boundNode = ownerDocument.querySelector(bounds);
		      if (!boundNode) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
		    }
		    var nodeStyle = ownerWindow.getComputedStyle(node);
		    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
		    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
		    bounds = {
		      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.borderLeftWidth) + (0, _shims.int)(nodeStyle.marginLeft),
		      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.borderTopWidth) + (0, _shims.int)(nodeStyle.marginTop),
		      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft,
		      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop
		    };
		  }
		
		  // Keep x and y below right and bottom limits...
		  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
		  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
		
		  // But above left and top limits.
		  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
		  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
		
		  return [x, y];
		}
		
		function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
		  var x = Math.round(pendingX / grid[0]) * grid[0];
		  var y = Math.round(pendingY / grid[1]) * grid[1];
		  return [x, y];
		}
		
		function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
		}
		
		function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
		}
		
		// Get {x, y} positions from event.
		function getControlPosition(e /*: MouseEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
		  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
		  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
		  var node = _reactDom2.default.findDOMNode(draggableCore);
		  // User can provide an offsetParent if desired.
		  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
		  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
		}
		
		// Create an data object exposed by <DraggableCore>'s events
		function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
		  // State changes are often (but not always!) async. We want the latest value.
		  var state = draggable._pendingState || draggable.state;
		  var isStart = !(0, _shims.isNum)(state.lastX);
		
		  if (isStart) {
		    // If this is our first move, use the x and y as last coords.
		    return {
		      node: _reactDom2.default.findDOMNode(draggable),
		      deltaX: 0, deltaY: 0,
		      lastX: x, lastY: y,
		      x: x, y: y
		    };
		  } else {
		    // Otherwise calculate proper values.
		    return {
		      node: _reactDom2.default.findDOMNode(draggable),
		      deltaX: x - state.lastX, deltaY: y - state.lastY,
		      lastX: state.lastX, lastY: state.lastY,
		      x: x, y: y
		    };
		  }
		}
		
		// Create an data exposed by <Draggable>'s events
		function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
		  return {
		    node: coreData.node,
		    x: draggable.state.x + coreData.deltaX,
		    y: draggable.state.y + coreData.deltaY,
		    deltaX: coreData.deltaX,
		    deltaY: coreData.deltaY,
		    lastX: draggable.state.x,
		    lastY: draggable.state.y
		  };
		}
		
		// A lot faster than stringify/parse
		function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
		  return {
		    left: bounds.left,
		    top: bounds.top,
		    right: bounds.right,
		    bottom: bounds.bottom
		  };
		}
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _reactDom = __webpack_require__(3);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _domFns = __webpack_require__(5);
		
		var _positionFns = __webpack_require__(8);
		
		var _shims = __webpack_require__(6);
		
		var _log = __webpack_require__(11);
		
		var _log2 = _interopRequireDefault(_log);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		// Simple abstraction for dragging events names.
		/*:: import type {EventHandler} from './utils/types';*/
		var eventsFor = {
		  touch: {
		    start: 'touchstart',
		    move: 'touchmove',
		    stop: 'touchend'
		  },
		  mouse: {
		    start: 'mousedown',
		    move: 'mousemove',
		    stop: 'mouseup'
		  }
		};
		
		// Default to mouse events.
		var dragEventFor = eventsFor.mouse;
		
		//
		// Define <DraggableCore>.
		//
		// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
		// work well with libraries that require more control over the element.
		//
		
		/*:: type CoreState = {
		  dragging: boolean,
		  lastX: number,
		  lastY: number,
		  touchIdentifier: ?number
		};*/
		
		var DraggableCore = function (_React$Component) {
		  _inherits(DraggableCore, _React$Component);
		
		  function DraggableCore() {
		    var _Object$getPrototypeO;
		
		    var _temp, _this, _ret;
		
		    _classCallCheck(this, DraggableCore);
		
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
		
		    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DraggableCore)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
		      dragging: false,
		      // Used while dragging to determine deltas.
		      lastX: NaN, lastY: NaN,
		      touchIdentifier: null
		    }, _this.handleDragStart = function (e) {
		      // Make it possible to attach event handlers on top of this one.
		      _this.props.onMouseDown(e);
		
		      // Only accept left-clicks.
		      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
		
		      // Get nodes. Be sure to grab relative document (could be iframed)
		      var domNode = _reactDom2.default.findDOMNode(_this);
		      var ownerDocument = domNode.ownerDocument;
		
		      // Short circuit if handle or cancel prop was provided and selector doesn't match.
		
		      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, domNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, domNode)) {
		        return;
		      }
		
		      // Set touch identifier in component state if this is a touch event. This allows us to
		      // distinguish between individual touches on multitouch screens by identifying which
		      // touchpoint was set to this element.
		      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
		      _this.setState({ touchIdentifier: touchIdentifier });
		
		      // Get the current drag point from the event. This is used as the offset.
		      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
		      if (position == null) return; // not possible but satisfies flow
		      var x = position.x;
		      var y = position.y;
		
		      // Create an event object with all the data parents need to make a decision here.
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);
		
		      // Call event handler. If it returns explicit false, cancel.
		      (0, _log2.default)('calling', _this.props.onStart);
		      var shouldUpdate = _this.props.onStart(e, coreEvent);
		      if (shouldUpdate === false) return;
		
		      // Add a style to the body to disable user-select. This prevents text from
		      // being selected all over the page.
		      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument.body);
		
		      // Initiate dragging. Set the current x and y as offsets
		      // so we know how much we've moved during the drag. This allows us
		      // to drag elements around even if they have been moved, without issue.
		      _this.setState({
		        dragging: true,
		
		        lastX: x,
		        lastY: y
		      });
		
		      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
		      // this element. We use different events depending on whether or not we have detected that this
		      // is a touch-capable device.
		      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
		      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.handleDrag = function (e) {
		
		      // Get the current drag point from the event. This is used as the offset.
		      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x;
		      var y = position.y;
		
		      // Snap to grid if prop has been provided
		
		      if (x !== x) debugger;
		
		      if (Array.isArray(_this.props.grid)) {
		        var deltaX = x - _this.state.lastX,
		            deltaY = y - _this.state.lastY;
		
		        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
		
		        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
		
		        deltaX = _snapToGrid2[0];
		        deltaY = _snapToGrid2[1];
		
		        if (!deltaX && !deltaY) return; // skip useless drag
		        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
		      }
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);
		
		      // Call event handler. If it returns explicit false, trigger end.
		      var shouldUpdate = _this.props.onDrag(e, coreEvent);
		      if (shouldUpdate === false) {
		        try {
		          _this.handleDragStop(new MouseEvent('mouseup'));
		        } catch (err) {
		          // Old browsers
		          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseEvent*/);
		          // I see why this insanity was deprecated
		          // $FlowIgnore
		          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		          _this.handleDragStop(event);
		        }
		        return;
		      }
		
		      _this.setState({
		        lastX: x,
		        lastY: y
		      });
		    }, _this.handleDragStop = function (e) {
		      if (!_this.state.dragging) return;
		
		      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x;
		      var y = position.y;
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(_this);
		
		      var ownerDocument = _ReactDOM$findDOMNode.ownerDocument;
		
		      // Remove user-select hack
		
		      if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument.body);
		
		      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);
		
		      // Reset the el.
		      _this.setState({
		        dragging: false,
		        lastX: NaN,
		        lastY: NaN
		      });
		
		      // Call event handler
		      _this.props.onStop(e, coreEvent);
		
		      // Remove event handlers
		      (0, _log2.default)('DraggableCore: Removing handlers');
		      (0, _domFns.removeEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.onMouseDown = function (e) {
		      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
		
		      return _this.handleDragStart(e);
		    }, _this.onMouseUp = function (e) {
		      dragEventFor = eventsFor.mouse;
		
		      return _this.handleDragStop(e);
		    }, _this.onTouchStart = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
		
		      return _this.handleDragStart(e);
		    }, _this.onTouchEnd = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
		
		      return _this.handleDragStop(e);
		    }, _temp), _possibleConstructorReturn(_this, _ret);
		  }
		
		  _createClass(DraggableCore, [{
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
		      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
		
		      var _ReactDOM$findDOMNode2 = _reactDom2.default.findDOMNode(this);
		
		      var ownerDocument = _ReactDOM$findDOMNode2.ownerDocument;
		
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
		      if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument.body);
		    }
		
		    // Same as onMouseDown (start drag), but now consider this a touch device.
		
		  }, {
		    key: 'render',
		    value: function render() {
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
		        style: (0, _domFns.styleHacks)(this.props.children.props.style),
		
		        // Note: mouseMove handler is attached to document so it will still function
		        // when the user drags quickly and leaves the bounds of the element.
		        onMouseDown: this.onMouseDown,
		        onTouchStart: this.onTouchStart,
		        onMouseUp: this.onMouseUp,
		        onTouchEnd: this.onTouchEnd
		      });
		    }
		  }]);
		
		  return DraggableCore;
		}(_react2.default.Component);
		
		DraggableCore.displayName = 'DraggableCore';
		DraggableCore.propTypes = {
		  /**
		   * `allowAnyClick` allows dragging using any mouse button.
		   * By default, we only accept the left button.
		   *
		   * Defaults to `false`.
		   */
		  allowAnyClick: _react.PropTypes.bool,
		
		  /**
		   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
		   * with the exception of `onMouseDown`, will not fire.
		   */
		  disabled: _react.PropTypes.bool,
		
		  /**
		   * By default, we add 'user-select:none' attributes to the document body
		   * to prevent ugly text selection during drag. If this is causing problems
		   * for your app, set this to `false`.
		   */
		  enableUserSelectHack: _react.PropTypes.bool,
		
		  /**
		   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
		   * instead of using the parent node.
		   */
		  offsetParent: function offsetParent(props, propName) {
		    if (process.browser && props[propName] && props[propName].nodeType !== 1) {
		      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
		    }
		  },
		
		  /**
		   * `grid` specifies the x and y that dragging should snap to.
		   */
		  grid: _react.PropTypes.arrayOf(_react.PropTypes.number),
		
		  /**
		   * `handle` specifies a selector to be used as the handle that initiates drag.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable handle=".handle">
		   *              <div>
		   *                  <div className="handle">Click me to drag</div>
		   *                  <div>This is some other content</div>
		   *              </div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  handle: _react.PropTypes.string,
		
		  /**
		   * `cancel` specifies a selector to be used to prevent drag initialization.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *           return(
		   *               <Draggable cancel=".cancel">
		   *                   <div>
		   *                     <div className="cancel">You can't drag from here</div>
		   *                     <div>Dragging here works fine</div>
		   *                   </div>
		   *               </Draggable>
		   *           );
		   *       }
		   *   });
		   * ```
		   */
		  cancel: _react.PropTypes.string,
		
		  /**
		   * Called when dragging starts.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onStart: _react.PropTypes.func,
		
		  /**
		   * Called while dragging.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onDrag: _react.PropTypes.func,
		
		  /**
		   * Called when dragging stops.
		   * If this function returns the boolean false, the drag will remain active.
		   */
		  onStop: _react.PropTypes.func,
		
		  /**
		   * A workaround option which can be passed if onMouseDown needs to be accessed,
		   * since it'll always be blocked (as there is internal use of onMouseDown)
		   */
		  onMouseDown: _react.PropTypes.func,
		
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: _shims.dontSetMe,
		  style: _shims.dontSetMe,
		  transform: _shims.dontSetMe
		};
		DraggableCore.defaultProps = {
		  allowAnyClick: false, // by default only accept left click
		  cancel: null,
		  disabled: false,
		  enableUserSelectHack: true,
		  offsetParent: null,
		  handle: null,
		  grid: null,
		  transform: null,
		  onStart: function onStart() {},
		  onDrag: function onDrag() {},
		  onStop: function onStop() {},
		  onMouseDown: function onMouseDown() {}
		};
		exports.default = DraggableCore;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		(function () {
		  try {
		    cachedSetTimeout = setTimeout;
		  } catch (e) {
		    cachedSetTimeout = function () {
		      throw new Error('setTimeout is not defined');
		    }
		  }
		  try {
		    cachedClearTimeout = clearTimeout;
		  } catch (e) {
		    cachedClearTimeout = function () {
		      throw new Error('clearTimeout is not defined');
		    }
		  }
		} ())
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = cachedSetTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    cachedClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        cachedSetTimeout(drainQueue, 0);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = log;
		
		/*eslint no-console:0*/
		function log() {
		  var _console;
		
		  if ((undefined)) (_console = console).log.apply(_console, arguments);
		}
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=react-draggable.js.map

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var ExecutionEnvironment = __webpack_require__(203);
	var ModalPortal = React.createFactory(__webpack_require__(314));
	var ariaAppHider = __webpack_require__(315);
	var elementClass = __webpack_require__(201);
	var renderSubtreeIntoContainer = __webpack_require__(17).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(102);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	var Modal = React.createClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: React.PropTypes.bool.isRequired,
	    style: React.PropTypes.shape({
	      content: React.PropTypes.object,
	      overlay: React.PropTypes.object
	    }),
	    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: React.PropTypes.func,
	    onRequestClose: React.PropTypes.func,
	    closeTimeoutMS: React.PropTypes.number,
	    ariaHideApp: React.PropTypes.bool,
	    shouldCloseOnOverlayClick: React.PropTypes.bool
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = 'ReactModalPortal';
	    AppElement.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    AppElement.removeChild(this.node);
	    elementClass(document.body).remove('ReactModal__Body--open');
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen) {
	      elementClass(document.body).add('ReactModal__Body--open');
	    } else {
	      elementClass(document.body).remove('ReactModal__Body--open');
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return React.DOM.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	var div = React.DOM.div;
	var focusManager = __webpack_require__(316);
	var scopeTab = __webpack_require__(317);
	var Assign = __webpack_require__(102);
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: {
	    base: 'ReactModal__Overlay',
	    afterOpen: 'ReactModal__Overlay--after-open',
	    beforeClose: 'ReactModal__Overlay--before-close'
	  },
	  content: {
	    base: 'ReactModal__Content',
	    afterOpen: 'ReactModal__Content--after-open',
	    beforeClose: 'ReactModal__Content--before-close'
	  }
	};
	
	var ModalPortal = module.exports = React.createClass({
	
	  displayName: 'ModalPortal',
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  open: function() {
	    focusManager.setupScopedFocus(this.node);
	    focusManager.markForFocusLater();
	    this.setState({isOpen: true}, function() {
	      this.setState({afterOpen: true});
	
	      if (this.props.isOpen && this.props.onAfterOpen) {
	        this.props.onAfterOpen();
	      }
	    }.bind(this));
	  },
	
	  close: function() {
	    if (!this.ownerHandlesClose())
	      return;
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    this.refs.content.focus();
	  },
	
	  closeWithTimeout: function() {
	    this.setState({beforeClose: true}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      afterOpen: false,
	      beforeClose: false
	    }, this.afterClose);
	  },
	
	  afterClose: function() {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayClick: function(event) {
	    var node = event.target
	
	    while (node) {
	      if (node === this.refs.content) return
	      node = node.parentNode
	    }
	
	    if (this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.props.isOpen && !this.state.beforeClose;
	  },
	
	  buildClassName: function(which, additional) {
	    var className = CLASS_NAMES[which].base;
	    if (this.state.afterOpen)
	      className += ' '+CLASS_NAMES[which].afterOpen;
	    if (this.state.beforeClose)
	      className += ' '+CLASS_NAMES[which].beforeClose;
	    return additional ? className + ' ' + additional : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onClick: this.handleOverlayClick
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ },
/* 315 */
/***/ function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(134);
	var modalElement = null;
	var focusLaterElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation 
	    // is that the document.body gets focus, and then we focus our element right 
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElement = document.activeElement;
	};
	
	exports.returnFocus = function() {
	  try {
	    focusLaterElement.focus();
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+focusLaterElement+' but it is not in the DOM anymore');
	  }
	  focusLaterElement = null;
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};
	
	


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(134);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(2);
	
	var _storeShape = __webpack_require__(135);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(136);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(2);
	
	var _storeShape = __webpack_require__(135);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(320);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(321);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(136);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(62);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(219);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(221);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 320 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(144);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var React = _interopRequire(__webpack_require__(2));
	
	module.exports = React.createClass({
	  displayName: "check.es6",
	
	  render: function render() {
	    return React.createElement(
	      "svg",
	      { width: "14", height: "11", viewBox: "0 0 14 11" },
	      React.createElement(
	        "title",
	        null,
	        "switch-check"
	      ),
	      React.createElement("path", { d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0", fill: "#fff", fillRule: "evenodd" })
	    );
	  }
	});


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = _interopRequire(__webpack_require__(2));
	
	var classNames = _interopRequire(__webpack_require__(168));
	
	var Check = _interopRequire(__webpack_require__(322));
	
	var X = _interopRequire(__webpack_require__(324));
	
	var PureRenderMixin = _interopRequire(__webpack_require__(248));
	
	module.exports = React.createClass({
	  mixins: [PureRenderMixin],
	
	  displayName: "Toggle",
	
	  propTypes: {
	    checked: React.PropTypes.bool,
	    defaultChecked: React.PropTypes.bool,
	    onChange: React.PropTypes.func,
	    name: React.PropTypes.string,
	    value: React.PropTypes.string,
	    id: React.PropTypes.string,
	    "aria-labelledby": React.PropTypes.string,
	    "aria-label": React.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    var checked = false;
	    if ("checked" in this.props) {
	      checked = this.props.checked;
	    } else if ("defaultChecked" in this.props) {
	      checked = this.props.defaultChecked;
	    }
	    return {
	      checked: !!checked,
	      hasFocus: false
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ("checked" in nextProps) {
	      this.setState({ checked: !!nextProps.checked });
	    }
	  },
	
	  handleClick: function handleClick(event) {
	    var checkbox = this.refs.input;
	    if (event.target !== checkbox) {
	      event.preventDefault();
	      checkbox.focus();
	      checkbox.click();
	      return;
	    }
	
	    if (!("checked" in this.props)) {
	      this.setState({ checked: checkbox.checked });
	    }
	  },
	
	  handleFocus: function handleFocus() {
	    this.setState({ hasFocus: true });
	  },
	
	  handleBlur: function handleBlur() {
	    this.setState({ hasFocus: false });
	  },
	
	  render: function render() {
	    var classes = classNames("react-toggle", {
	      "react-toggle--checked": this.state.checked,
	      "react-toggle--focus": this.state.hasFocus,
	      "react-toggle--disabled": this.props.disabled
	    });
	
	    return React.createElement(
	      "div",
	      { className: classes, onClick: this.handleClick },
	      React.createElement(
	        "div",
	        { className: "react-toggle-track" },
	        React.createElement(
	          "div",
	          { className: "react-toggle-track-check" },
	          React.createElement(Check, null)
	        ),
	        React.createElement(
	          "div",
	          { className: "react-toggle-track-x" },
	          React.createElement(X, null)
	        )
	      ),
	      React.createElement("div", { className: "react-toggle-thumb" }),
	      React.createElement("input", _extends({
	        ref: "input",
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        className: "react-toggle-screenreader-only",
	        type: "checkbox"
	      }, this.props))
	    );
	  }
	});


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var React = _interopRequire(__webpack_require__(2));
	
	module.exports = React.createClass({
	  displayName: "x.es6",
	
	  render: function render() {
	    return React.createElement(
	      "svg",
	      { width: "10", height: "10", viewBox: "0 0 10 10" },
	      React.createElement(
	        "title",
	        null,
	        "switch-x"
	      ),
	      React.createElement("path", { d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12", fill: "#fff", fillRule: "evenodd" })
	    );
	  }
	});


/***/ },
/* 325 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(326);
	var ReactElement = __webpack_require__(40);
	
	var emptyFunction = __webpack_require__(21);
	var traverseAllChildren = __webpack_require__(336);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(40);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(40),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(245);
	
	module.exports = factory(isValidElement);

/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.0';

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(137),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(40),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(140);
	var factory = __webpack_require__(170);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 332 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 333 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactElement = __webpack_require__(40);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactCurrentOwner = __webpack_require__(30);
	var REACT_ELEMENT_TYPE = __webpack_require__(139);
	
	var getIteratorFn = __webpack_require__(332);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(325);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(142);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 338 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(143);
	
	var _isPlainObject = __webpack_require__(62);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(145);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ },
/* 341 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(25).Buffer
	var Hash   = __webpack_require__(341)(Buffer)
	
	exports.sha1 = __webpack_require__(343)(Buffer, Hash)
	exports.sha256 = __webpack_require__(344)(Buffer, Hash)
	exports.sha512 = __webpack_require__(345)(Buffer, Hash)


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(81).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(81).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(81).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var SourceMapConsumer = __webpack_require__(353).SourceMapConsumer;
	var path = __webpack_require__(53);
	var fs = __webpack_require__(242);
	
	// Only install once if called multiple times
	var errorFormatterInstalled = false;
	var uncaughtShimInstalled = false;
	
	// If true, the caches are reset before a stack trace formatting operation
	var emptyCacheBetweenOperations = false;
	
	// Supports {browser, node, auto}
	var environment = "auto";
	
	// Maps a file path to a string containing the file contents
	var fileContentsCache = {};
	
	// Maps a file path to a source map for that file
	var sourceMapCache = {};
	
	// Regex for detecting source maps
	var reSourceMap = /^data:application\/json[^,]+base64,/;
	
	// Priority list of retrieve handlers
	var retrieveFileHandlers = [];
	var retrieveMapHandlers = [];
	
	function isInBrowser() {
	  if (environment === "browser")
	    return true;
	  if (environment === "node")
	    return false;
	  return ((typeof window !== 'undefined') && (typeof XMLHttpRequest === 'function') && !(window.require && window.module && window.process && window.process.type === "renderer"));
	}
	
	function hasGlobalProcessEventEmitter() {
	  return ((typeof process === 'object') && (process !== null) && (typeof process.on === 'function'));
	}
	
	function handlerExec(list) {
	  return function(arg) {
	    for (var i = 0; i < list.length; i++) {
	      var ret = list[i](arg);
	      if (ret) {
	        return ret;
	      }
	    }
	    return null;
	  };
	}
	
	var retrieveFile = handlerExec(retrieveFileHandlers);
	
	retrieveFileHandlers.push(function(path) {
	  // Trim the path to make sure there is no extra whitespace.
	  path = path.trim();
	  if (path in fileContentsCache) {
	    return fileContentsCache[path];
	  }
	
	  try {
	    // Use SJAX if we are in the browser
	    if (isInBrowser()) {
	      var xhr = new XMLHttpRequest();
	      xhr.open('GET', path, false);
	      xhr.send(null);
	      var contents = null
	      if (xhr.readyState === 4 && xhr.status === 200) {
	        contents = xhr.responseText
	      }
	    }
	
	    // Otherwise, use the filesystem
	    else {
	      var contents = fs.readFileSync(path, 'utf8');
	    }
	  } catch (e) {
	    var contents = null;
	  }
	
	  return fileContentsCache[path] = contents;
	});
	
	// Support URLs relative to a directory, but be careful about a protocol prefix
	// in case we are in the browser (i.e. directories may start with "http://")
	function supportRelativeURL(file, url) {
	  if (!file) return url;
	  var dir = path.dirname(file);
	  var match = /^\w+:\/\/[^\/]*/.exec(dir);
	  var protocol = match ? match[0] : '';
	  return protocol + path.resolve(dir.slice(protocol.length), url);
	}
	
	function retrieveSourceMapURL(source) {
	  var fileData;
	
	  if (isInBrowser()) {
	    var xhr = new XMLHttpRequest();
	    xhr.open('GET', source, false);
	    xhr.send(null);
	    fileData = xhr.readyState === 4 ? xhr.responseText : null;
	
	    // Support providing a sourceMappingURL via the SourceMap header
	    var sourceMapHeader = xhr.getResponseHeader("SourceMap") ||
	                          xhr.getResponseHeader("X-SourceMap");
	    if (sourceMapHeader) {
	      return sourceMapHeader;
	    }
	  }
	
	  // Get the URL of the source map
	  fileData = retrieveFile(source);
	  //        //# sourceMappingURL=foo.js.map                       /*# sourceMappingURL=foo.js.map */
	  var re = /(?:\/\/[@#][ \t]+sourceMappingURL=([^\s'"]+?)[ \t]*$)|(?:\/\*[@#][ \t]+sourceMappingURL=([^\*]+?)[ \t]*(?:\*\/)[ \t]*$)/mg;
	  // Keep executing the search to find the *last* sourceMappingURL to avoid
	  // picking up sourceMappingURLs from comments, strings, etc.
	  var lastMatch, match;
	  while (match = re.exec(fileData)) lastMatch = match;
	  if (!lastMatch) return null;
	  return lastMatch[1];
	};
	
	// Can be overridden by the retrieveSourceMap option to install. Takes a
	// generated source filename; returns a {map, optional url} object, or null if
	// there is no source map.  The map field may be either a string or the parsed
	// JSON object (ie, it must be a valid argument to the SourceMapConsumer
	// constructor).
	var retrieveSourceMap = handlerExec(retrieveMapHandlers);
	retrieveMapHandlers.push(function(source) {
	  var sourceMappingURL = retrieveSourceMapURL(source);
	  if (!sourceMappingURL) return null;
	
	  // Read the contents of the source map
	  var sourceMapData;
	  if (reSourceMap.test(sourceMappingURL)) {
	    // Support source map URL as a data url
	    var rawData = sourceMappingURL.slice(sourceMappingURL.indexOf(',') + 1);
	    sourceMapData = new Buffer(rawData, "base64").toString();
	    sourceMappingURL = null;
	  } else {
	    // Support source map URLs relative to the source URL
	    sourceMappingURL = supportRelativeURL(source, sourceMappingURL);
	    sourceMapData = retrieveFile(sourceMappingURL);
	  }
	
	  if (!sourceMapData) {
	    return null;
	  }
	
	  return {
	    url: sourceMappingURL,
	    map: sourceMapData
	  };
	});
	
	function mapSourcePosition(position) {
	  var sourceMap = sourceMapCache[position.source];
	  if (!sourceMap) {
	    // Call the (overrideable) retrieveSourceMap function to get the source map.
	    var urlAndMap = retrieveSourceMap(position.source);
	    if (urlAndMap) {
	      sourceMap = sourceMapCache[position.source] = {
	        url: urlAndMap.url,
	        map: new SourceMapConsumer(urlAndMap.map)
	      };
	
	      // Load all sources stored inline with the source map into the file cache
	      // to pretend like they are already loaded. They may not exist on disk.
	      if (sourceMap.map.sourcesContent) {
	        sourceMap.map.sources.forEach(function(source, i) {
	          var contents = sourceMap.map.sourcesContent[i];
	          if (contents) {
	            var url = supportRelativeURL(sourceMap.url, source);
	            fileContentsCache[url] = contents;
	          }
	        });
	      }
	    } else {
	      sourceMap = sourceMapCache[position.source] = {
	        url: null,
	        map: null
	      };
	    }
	  }
	
	  // Resolve the source URL relative to the URL of the source map
	  if (sourceMap && sourceMap.map) {
	    var originalPosition = sourceMap.map.originalPositionFor(position);
	
	    // Only return the original position if a matching line was found. If no
	    // matching line is found then we return position instead, which will cause
	    // the stack trace to print the path and line for the compiled file. It is
	    // better to give a precise location in the compiled file than a vague
	    // location in the original file.
	    if (originalPosition.source !== null) {
	      originalPosition.source = supportRelativeURL(
	        sourceMap.url, originalPosition.source);
	      return originalPosition;
	    }
	  }
	
	  return position;
	}
	
	// Parses code generated by FormatEvalOrigin(), a function inside V8:
	// https://code.google.com/p/v8/source/browse/trunk/src/messages.js
	function mapEvalOrigin(origin) {
	  // Most eval() calls are in this format
	  var match = /^eval at ([^(]+) \((.+):(\d+):(\d+)\)$/.exec(origin);
	  if (match) {
	    var position = mapSourcePosition({
	      source: match[2],
	      line: +match[3],
	      column: match[4] - 1
	    });
	    return 'eval at ' + match[1] + ' (' + position.source + ':' +
	      position.line + ':' + (position.column + 1) + ')';
	  }
	
	  // Parse nested eval() calls using recursion
	  match = /^eval at ([^(]+) \((.+)\)$/.exec(origin);
	  if (match) {
	    return 'eval at ' + match[1] + ' (' + mapEvalOrigin(match[2]) + ')';
	  }
	
	  // Make sure we still return useful information if we didn't find anything
	  return origin;
	}
	
	// This is copied almost verbatim from the V8 source code at
	// https://code.google.com/p/v8/source/browse/trunk/src/messages.js. The
	// implementation of wrapCallSite() used to just forward to the actual source
	// code of CallSite.prototype.toString but unfortunately a new release of V8
	// did something to the prototype chain and broke the shim. The only fix I
	// could find was copy/paste.
	function CallSiteToString() {
	  var fileName;
	  var fileLocation = "";
	  if (this.isNative()) {
	    fileLocation = "native";
	  } else {
	    fileName = this.getScriptNameOrSourceURL();
	    if (!fileName && this.isEval()) {
	      fileLocation = this.getEvalOrigin();
	      fileLocation += ", ";  // Expecting source position to follow.
	    }
	
	    if (fileName) {
	      fileLocation += fileName;
	    } else {
	      // Source code does not originate from a file and is not native, but we
	      // can still get the source position inside the source string, e.g. in
	      // an eval string.
	      fileLocation += "<anonymous>";
	    }
	    var lineNumber = this.getLineNumber();
	    if (lineNumber != null) {
	      fileLocation += ":" + lineNumber;
	      var columnNumber = this.getColumnNumber();
	      if (columnNumber) {
	        fileLocation += ":" + columnNumber;
	      }
	    }
	  }
	
	  var line = "";
	  var functionName = this.getFunctionName();
	  var addSuffix = true;
	  var isConstructor = this.isConstructor();
	  var isMethodCall = !(this.isToplevel() || isConstructor);
	  if (isMethodCall) {
	    var typeName = this.getTypeName();
	    var methodName = this.getMethodName();
	    if (functionName) {
	      if (typeName && functionName.indexOf(typeName) != 0) {
	        line += typeName + ".";
	      }
	      line += functionName;
	      if (methodName && functionName.indexOf("." + methodName) != functionName.length - methodName.length - 1) {
	        line += " [as " + methodName + "]";
	      }
	    } else {
	      line += typeName + "." + (methodName || "<anonymous>");
	    }
	  } else if (isConstructor) {
	    line += "new " + (functionName || "<anonymous>");
	  } else if (functionName) {
	    line += functionName;
	  } else {
	    line += fileLocation;
	    addSuffix = false;
	  }
	  if (addSuffix) {
	    line += " (" + fileLocation + ")";
	  }
	  return line;
	}
	
	function cloneCallSite(frame) {
	  var object = {};
	  Object.getOwnPropertyNames(Object.getPrototypeOf(frame)).forEach(function(name) {
	    object[name] = /^(?:is|get)/.test(name) ? function() { return frame[name].call(frame); } : frame[name];
	  });
	  object.toString = CallSiteToString;
	  return object;
	}
	
	function wrapCallSite(frame) {
	  if(frame.isNative()) {
	    return frame;
	  }
	
	  // Most call sites will return the source file from getFileName(), but code
	  // passed to eval() ending in "//# sourceURL=..." will return the source file
	  // from getScriptNameOrSourceURL() instead
	  var source = frame.getFileName() || frame.getScriptNameOrSourceURL();
	  if (source) {
	    var line = frame.getLineNumber();
	    var column = frame.getColumnNumber() - 1;
	
	    // Fix position in Node where some (internal) code is prepended.
	    // See https://github.com/evanw/node-source-map-support/issues/36
	    if (line === 1 && !isInBrowser() && !frame.isEval()) {
	      column -= 62;
	    }
	
	    var position = mapSourcePosition({
	      source: source,
	      line: line,
	      column: column
	    });
	    frame = cloneCallSite(frame);
	    frame.getFileName = function() { return position.source; };
	    frame.getLineNumber = function() { return position.line; };
	    frame.getColumnNumber = function() { return position.column + 1; };
	    frame.getScriptNameOrSourceURL = function() { return position.source; };
	    return frame;
	  }
	
	  // Code called using eval() needs special handling
	  var origin = frame.isEval() && frame.getEvalOrigin();
	  if (origin) {
	    origin = mapEvalOrigin(origin);
	    frame = cloneCallSite(frame);
	    frame.getEvalOrigin = function() { return origin; };
	    return frame;
	  }
	
	  // If we get here then we were unable to change the source position
	  return frame;
	}
	
	// This function is part of the V8 stack trace API, for more info see:
	// http://code.google.com/p/v8/wiki/JavaScriptStackTraceApi
	function prepareStackTrace(error, stack) {
	  if (emptyCacheBetweenOperations) {
	    fileContentsCache = {};
	    sourceMapCache = {};
	  }
	
	  return error + stack.map(function(frame) {
	    return '\n    at ' + wrapCallSite(frame);
	  }).join('');
	}
	
	// Generate position and snippet of original source with pointer
	function getErrorSource(error) {
	  var match = /\n    at [^(]+ \((.*):(\d+):(\d+)\)/.exec(error.stack);
	  if (match) {
	    var source = match[1];
	    var line = +match[2];
	    var column = +match[3];
	
	    // Support the inline sourceContents inside the source map
	    var contents = fileContentsCache[source];
	
	    // Support files on disk
	    if (!contents && fs.existsSync(source)) {
	      contents = fs.readFileSync(source, 'utf8');
	    }
	
	    // Format the line from the original source code like node does
	    if (contents) {
	      var code = contents.split(/(?:\r\n|\r|\n)/)[line - 1];
	      if (code) {
	        return source + ':' + line + '\n' + code + '\n' +
	          new Array(column).join(' ') + '^';
	      }
	    }
	  }
	  return null;
	}
	
	function printErrorAndExit (error) {
	  var source = getErrorSource(error);
	
	  if (source) {
	    console.error();
	    console.error(source);
	  }
	
	  console.error(error.stack);
	  process.exit(1);
	}
	
	function shimEmitUncaughtException () {
	  var origEmit = process.emit;
	
	  process.emit = function (type) {
	    if (type === 'uncaughtException') {
	      var hasStack = (arguments[1] && arguments[1].stack);
	      var hasListeners = (this.listeners(type).length > 0);
	
	      if (hasStack && !hasListeners) {
	        return printErrorAndExit(arguments[1]);
	      }
	    }
	
	    return origEmit.apply(this, arguments);
	  };
	}
	
	exports.wrapCallSite = wrapCallSite;
	exports.getErrorSource = getErrorSource;
	exports.mapSourcePosition = mapSourcePosition;
	exports.retrieveSourceMap = retrieveSourceMap;
	
	exports.install = function(options) {
	  options = options || {};
	
	  if (options.environment) {
	    environment = options.environment;
	    if (["node", "browser", "auto"].indexOf(environment) === -1) {
	      throw new Error("environment " + environment + " was unknown. Available options are {auto, browser, node}")
	    }
	  }
	
	  // Allow sources to be found by methods other than reading the files
	  // directly from disk.
	  if (options.retrieveFile) {
	    if (options.overrideRetrieveFile) {
	      retrieveFileHandlers.length = 0;
	    }
	
	    retrieveFileHandlers.unshift(options.retrieveFile);
	  }
	
	  // Allow source maps to be found by methods other than reading the files
	  // directly from disk.
	  if (options.retrieveSourceMap) {
	    if (options.overrideRetrieveSourceMap) {
	      retrieveMapHandlers.length = 0;
	    }
	
	    retrieveMapHandlers.unshift(options.retrieveSourceMap);
	  }
	
	  // Configure options
	  if (!emptyCacheBetweenOperations) {
	    emptyCacheBetweenOperations = 'emptyCacheBetweenOperations' in options ?
	      options.emptyCacheBetweenOperations : false;
	  }
	
	  // Install the error reformatter
	  if (!errorFormatterInstalled) {
	    errorFormatterInstalled = true;
	    Error.prepareStackTrace = prepareStackTrace;
	  }
	
	  if (!uncaughtShimInstalled) {
	    var installHandler = 'handleUncaughtExceptions' in options ?
	      options.handleUncaughtExceptions : true;
	
	    // Provide the option to not install the uncaught exception handler. This is
	    // to support other uncaught exception handlers (in test frameworks, for
	    // example). If this handler is not installed and there are no other uncaught
	    // exception handlers, uncaught exceptions will be caught by node's built-in
	    // exception handler and the process will still be terminated. However, the
	    // generated JavaScript code will be shown above the stack trace instead of
	    // the original source code.
	    if (installHandler && hasGlobalProcessEventEmitter()) {
	      uncaughtShimInstalled = true;
	      shimEmitUncaughtException();
	    }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), __webpack_require__(25).Buffer))

/***/ },
/* 347 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
	/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */
	exports.encode = function (number) {
	  if (0 <= number && number < intToCharMap.length) {
	    return intToCharMap[number];
	  }
	  throw new TypeError("Must be between 0 and 63: " + number);
	};
	
	/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */
	exports.decode = function (charCode) {
	  var bigA = 65;     // 'A'
	  var bigZ = 90;     // 'Z'
	
	  var littleA = 97;  // 'a'
	  var littleZ = 122; // 'z'
	
	  var zero = 48;     // '0'
	  var nine = 57;     // '9'
	
	  var plus = 43;     // '+'
	  var slash = 47;    // '/'
	
	  var littleOffset = 26;
	  var numberOffset = 52;
	
	  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	  if (bigA <= charCode && charCode <= bigZ) {
	    return (charCode - bigA);
	  }
	
	  // 26 - 51: abcdefghijklmnopqrstuvwxyz
	  if (littleA <= charCode && charCode <= littleZ) {
	    return (charCode - littleA + littleOffset);
	  }
	
	  // 52 - 61: 0123456789
	  if (zero <= charCode && charCode <= nine) {
	    return (charCode - zero + numberOffset);
	  }
	
	  // 62: +
	  if (charCode == plus) {
	    return 62;
	  }
	
	  // 63: /
	  if (charCode == slash) {
	    return 63;
	  }
	
	  // Invalid base64 digit.
	  return -1;
	};


/***/ },
/* 348 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	exports.GREATEST_LOWER_BOUND = 1;
	exports.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */
	function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
	  // This function terminates when one of the following is true:
	  //
	  //   1. We find the exact element we are looking for.
	  //
	  //   2. We did not find the exact element, but we can return the index of
	  //      the next-closest element.
	  //
	  //   3. We did not find the exact element, and there is no next-closest
	  //      element than the one we are searching for, so we return -1.
	  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
	  var cmp = aCompare(aNeedle, aHaystack[mid], true);
	  if (cmp === 0) {
	    // Found the element we are looking for.
	    return mid;
	  }
	  else if (cmp > 0) {
	    // Our needle is greater than aHaystack[mid].
	    if (aHigh - mid > 1) {
	      // The element is in the upper half.
	      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // The exact needle element was not found in this haystack. Determine if
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return aHigh < aHaystack.length ? aHigh : -1;
	    } else {
	      return mid;
	    }
	  }
	  else {
	    // Our needle is less than aHaystack[mid].
	    if (mid - aLow > 1) {
	      // The element is in the lower half.
	      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return mid;
	    } else {
	      return aLow < 0 ? -1 : aLow;
	    }
	  }
	}
	
	/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */
	exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
	  if (aHaystack.length === 0) {
	    return -1;
	  }
	
	  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
	                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
	  if (index < 0) {
	    return -1;
	  }
	
	  // We have found either the exact element, or the next-closest element than
	  // the one we are searching for. However, there may be more than one such
	  // element. Make sure we always return the smallest of these.
	  while (index - 1 >= 0) {
	    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
	      break;
	    }
	    --index;
	  }
	
	  return index;
	};


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2014 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(48);
	
	/**
	 * Determine whether mappingB is after mappingA with respect to generated
	 * position.
	 */
	function generatedPositionAfter(mappingA, mappingB) {
	  // Optimized for most common case
	  var lineA = mappingA.generatedLine;
	  var lineB = mappingB.generatedLine;
	  var columnA = mappingA.generatedColumn;
	  var columnB = mappingB.generatedColumn;
	  return lineB > lineA || lineB == lineA && columnB >= columnA ||
	         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
	}
	
	/**
	 * A data structure to provide a sorted view of accumulated mappings in a
	 * performance conscious manner. It trades a neglibable overhead in general
	 * case for a large speedup in case of mappings being added in order.
	 */
	function MappingList() {
	  this._array = [];
	  this._sorted = true;
	  // Serves as infimum
	  this._last = {generatedLine: -1, generatedColumn: 0};
	}
	
	/**
	 * Iterate through internal items. This method takes the same arguments that
	 * `Array.prototype.forEach` takes.
	 *
	 * NOTE: The order of the mappings is NOT guaranteed.
	 */
	MappingList.prototype.unsortedForEach =
	  function MappingList_forEach(aCallback, aThisArg) {
	    this._array.forEach(aCallback, aThisArg);
	  };
	
	/**
	 * Add the given source mapping.
	 *
	 * @param Object aMapping
	 */
	MappingList.prototype.add = function MappingList_add(aMapping) {
	  if (generatedPositionAfter(this._last, aMapping)) {
	    this._last = aMapping;
	    this._array.push(aMapping);
	  } else {
	    this._sorted = false;
	    this._array.push(aMapping);
	  }
	};
	
	/**
	 * Returns the flat, sorted array of mappings. The mappings are sorted by
	 * generated position.
	 *
	 * WARNING: This method returns internal data without copying, for
	 * performance. The return value must NOT be mutated, and should be treated as
	 * an immutable borrow. If you want to take ownership, you must make your own
	 * copy.
	 */
	MappingList.prototype.toArray = function MappingList_toArray() {
	  if (!this._sorted) {
	    this._array.sort(util.compareByGeneratedPositionsInflated);
	    this._sorted = true;
	  }
	  return this._array;
	};
	
	exports.MappingList = MappingList;


/***/ },
/* 350 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	// It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.
	
	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */
	function swap(ary, x, y) {
	  var temp = ary[x];
	  ary[x] = ary[y];
	  ary[y] = temp;
	}
	
	/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */
	function randomIntInRange(low, high) {
	  return Math.round(low + (Math.random() * (high - low)));
	}
	
	/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */
	function doQuickSort(ary, comparator, p, r) {
	  // If our lower bound is less than our upper bound, we (1) partition the
	  // array into two pieces and (2) recurse on each half. If it is not, this is
	  // the empty array and our base case.
	
	  if (p < r) {
	    // (1) Partitioning.
	    //
	    // The partitioning chooses a pivot between `p` and `r` and moves all
	    // elements that are less than or equal to the pivot to the before it, and
	    // all the elements that are greater than it after it. The effect is that
	    // once partition is done, the pivot is in the exact place it will be when
	    // the array is put in sorted order, and it will not need to be moved
	    // again. This runs in O(n) time.
	
	    // Always choose a random pivot so that an input array which is reverse
	    // sorted does not cause O(n^2) running time.
	    var pivotIndex = randomIntInRange(p, r);
	    var i = p - 1;
	
	    swap(ary, pivotIndex, r);
	    var pivot = ary[r];
	
	    // Immediately after `j` is incremented in this loop, the following hold
	    // true:
	    //
	    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	    //
	    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	    for (var j = p; j < r; j++) {
	      if (comparator(ary[j], pivot) <= 0) {
	        i += 1;
	        swap(ary, i, j);
	      }
	    }
	
	    swap(ary, i + 1, j);
	    var q = i + 1;
	
	    // (2) Recurse on each half.
	
	    doQuickSort(ary, comparator, p, q - 1);
	    doQuickSort(ary, comparator, q + 1, r);
	  }
	}
	
	/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */
	exports.quickSort = function (ary, comparator) {
	  doQuickSort(ary, comparator, 0, ary.length - 1);
	};


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(48);
	var binarySearch = __webpack_require__(348);
	var ArraySet = __webpack_require__(146).ArraySet;
	var base64VLQ = __webpack_require__(147);
	var quickSort = __webpack_require__(350).quickSort;
	
	function SourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  return sourceMap.sections != null
	    ? new IndexedSourceMapConsumer(sourceMap)
	    : new BasicSourceMapConsumer(sourceMap);
	}
	
	SourceMapConsumer.fromSourceMap = function(aSourceMap) {
	  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
	}
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	SourceMapConsumer.prototype._version = 3;
	
	// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.
	
	SourceMapConsumer.prototype.__generatedMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
	  get: function () {
	    if (!this.__generatedMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__generatedMappings;
	  }
	});
	
	SourceMapConsumer.prototype.__originalMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
	  get: function () {
	    if (!this.__originalMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__originalMappings;
	  }
	});
	
	SourceMapConsumer.prototype._charIsMappingSeparator =
	  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
	    var c = aStr.charAt(index);
	    return c === ";" || c === ",";
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	SourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    throw new Error("Subclasses must implement _parseMappings");
	  };
	
	SourceMapConsumer.GENERATED_ORDER = 1;
	SourceMapConsumer.ORIGINAL_ORDER = 2;
	
	SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
	SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */
	SourceMapConsumer.prototype.eachMapping =
	  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
	    var context = aContext || null;
	    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
	    var mappings;
	    switch (order) {
	    case SourceMapConsumer.GENERATED_ORDER:
	      mappings = this._generatedMappings;
	      break;
	    case SourceMapConsumer.ORIGINAL_ORDER:
	      mappings = this._originalMappings;
	      break;
	    default:
	      throw new Error("Unknown order of iteration.");
	    }
	
	    var sourceRoot = this.sourceRoot;
	    mappings.map(function (mapping) {
	      var source = mapping.source === null ? null : this._sources.at(mapping.source);
	      if (source != null && sourceRoot != null) {
	        source = util.join(sourceRoot, source);
	      }
	      return {
	        source: source,
	        generatedLine: mapping.generatedLine,
	        generatedColumn: mapping.generatedColumn,
	        originalLine: mapping.originalLine,
	        originalColumn: mapping.originalColumn,
	        name: mapping.name === null ? null : this._names.at(mapping.name)
	      };
	    }, this).forEach(aCallback, context);
	  };
	
	/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: Optional. the column number in the original source.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	SourceMapConsumer.prototype.allGeneratedPositionsFor =
	  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
	    var line = util.getArg(aArgs, 'line');
	
	    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	    // returns the index of the closest mapping less than the needle. By
	    // setting needle.originalColumn to 0, we thus find the last mapping for
	    // the given line, provided such a mapping exists.
	    var needle = {
	      source: util.getArg(aArgs, 'source'),
	      originalLine: line,
	      originalColumn: util.getArg(aArgs, 'column', 0)
	    };
	
	    if (this.sourceRoot != null) {
	      needle.source = util.relative(this.sourceRoot, needle.source);
	    }
	    if (!this._sources.has(needle.source)) {
	      return [];
	    }
	    needle.source = this._sources.indexOf(needle.source);
	
	    var mappings = [];
	
	    var index = this._findMapping(needle,
	                                  this._originalMappings,
	                                  "originalLine",
	                                  "originalColumn",
	                                  util.compareByOriginalPositions,
	                                  binarySearch.LEAST_UPPER_BOUND);
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (aArgs.column === undefined) {
	        var originalLine = mapping.originalLine;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we found. Since
	        // mappings are sorted, this is guaranteed to find all mappings for
	        // the line we found.
	        while (mapping && mapping.originalLine === originalLine) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      } else {
	        var originalColumn = mapping.originalColumn;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we were searching for.
	        // Since mappings are sorted, this is guaranteed to find all mappings for
	        // the line we are searching for.
	        while (mapping &&
	               mapping.originalLine === line &&
	               mapping.originalColumn == originalColumn) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      }
	    }
	
	    return mappings;
	  };
	
	exports.SourceMapConsumer = SourceMapConsumer;
	
	/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The only parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */
	function BasicSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sources = util.getArg(sourceMap, 'sources');
	  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	  // requires the array) to play nice here.
	  var names = util.getArg(sourceMap, 'names', []);
	  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
	  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
	  var mappings = util.getArg(sourceMap, 'mappings');
	  var file = util.getArg(sourceMap, 'file', null);
	
	  // Once again, Sass deviates from the spec and supplies the version as a
	  // string rather than a number, so we use loose equality checking here.
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  sources = sources
	    .map(String)
	    // Some source maps produce relative source paths like "./foo.js" instead of
	    // "foo.js".  Normalize these first so that future comparisons will succeed.
	    // See bugzil.la/1090768.
	    .map(util.normalize)
	    // Always ensure that absolute sources are internally stored relative to
	    // the source root, if the source root is absolute. Not doing this would
	    // be particularly problematic when the source root is a prefix of the
	    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	    .map(function (source) {
	      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
	        ? util.relative(sourceRoot, source)
	        : source;
	    });
	
	  // Pass `true` below to allow duplicate names and sources. While source maps
	  // are intended to be compressed and deduplicated, the TypeScript compiler
	  // sometimes generates source maps with duplicates in them. See Github issue
	  // #72 and bugzil.la/889492.
	  this._names = ArraySet.fromArray(names.map(String), true);
	  this._sources = ArraySet.fromArray(sources, true);
	
	  this.sourceRoot = sourceRoot;
	  this.sourcesContent = sourcesContent;
	  this._mappings = mappings;
	  this.file = file;
	}
	
	BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
	/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @returns BasicSourceMapConsumer
	 */
	BasicSourceMapConsumer.fromSourceMap =
	  function SourceMapConsumer_fromSourceMap(aSourceMap) {
	    var smc = Object.create(BasicSourceMapConsumer.prototype);
	
	    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
	    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
	    smc.sourceRoot = aSourceMap._sourceRoot;
	    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
	                                                            smc.sourceRoot);
	    smc.file = aSourceMap._file;
	
	    // Because we are modifying the entries (by converting string sources and
	    // names to indices into the sources and names ArraySets), we have to make
	    // a copy of the entry or else bad things happen. Shared mutable state
	    // strikes again! See github issue #191.
	
	    var generatedMappings = aSourceMap._mappings.toArray().slice();
	    var destGeneratedMappings = smc.__generatedMappings = [];
	    var destOriginalMappings = smc.__originalMappings = [];
	
	    for (var i = 0, length = generatedMappings.length; i < length; i++) {
	      var srcMapping = generatedMappings[i];
	      var destMapping = new Mapping;
	      destMapping.generatedLine = srcMapping.generatedLine;
	      destMapping.generatedColumn = srcMapping.generatedColumn;
	
	      if (srcMapping.source) {
	        destMapping.source = sources.indexOf(srcMapping.source);
	        destMapping.originalLine = srcMapping.originalLine;
	        destMapping.originalColumn = srcMapping.originalColumn;
	
	        if (srcMapping.name) {
	          destMapping.name = names.indexOf(srcMapping.name);
	        }
	
	        destOriginalMappings.push(destMapping);
	      }
	
	      destGeneratedMappings.push(destMapping);
	    }
	
	    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
	    return smc;
	  };
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	BasicSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    return this._sources.toArray().map(function (s) {
	      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
	    }, this);
	  }
	});
	
	/**
	 * Provide the JIT with a nice shape / hidden class.
	 */
	function Mapping() {
	  this.generatedLine = 0;
	  this.generatedColumn = 0;
	  this.source = null;
	  this.originalLine = null;
	  this.originalColumn = null;
	  this.name = null;
	}
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	BasicSourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    var generatedLine = 1;
	    var previousGeneratedColumn = 0;
	    var previousOriginalLine = 0;
	    var previousOriginalColumn = 0;
	    var previousSource = 0;
	    var previousName = 0;
	    var length = aStr.length;
	    var index = 0;
	    var cachedSegments = {};
	    var temp = {};
	    var originalMappings = [];
	    var generatedMappings = [];
	    var mapping, str, segment, end, value;
	
	    while (index < length) {
	      if (aStr.charAt(index) === ';') {
	        generatedLine++;
	        index++;
	        previousGeneratedColumn = 0;
	      }
	      else if (aStr.charAt(index) === ',') {
	        index++;
	      }
	      else {
	        mapping = new Mapping();
	        mapping.generatedLine = generatedLine;
	
	        // Because each offset is encoded relative to the previous one,
	        // many segments often have the same encoding. We can exploit this
	        // fact by caching the parsed variable length fields of each segment,
	        // allowing us to avoid a second parse if we encounter the same
	        // segment again.
	        for (end = index; end < length; end++) {
	          if (this._charIsMappingSeparator(aStr, end)) {
	            break;
	          }
	        }
	        str = aStr.slice(index, end);
	
	        segment = cachedSegments[str];
	        if (segment) {
	          index += str.length;
	        } else {
	          segment = [];
	          while (index < end) {
	            base64VLQ.decode(aStr, index, temp);
	            value = temp.value;
	            index = temp.rest;
	            segment.push(value);
	          }
	
	          if (segment.length === 2) {
	            throw new Error('Found a source, but no line and column');
	          }
	
	          if (segment.length === 3) {
	            throw new Error('Found a source and line, but no column');
	          }
	
	          cachedSegments[str] = segment;
	        }
	
	        // Generated column.
	        mapping.generatedColumn = previousGeneratedColumn + segment[0];
	        previousGeneratedColumn = mapping.generatedColumn;
	
	        if (segment.length > 1) {
	          // Original source.
	          mapping.source = previousSource + segment[1];
	          previousSource += segment[1];
	
	          // Original line.
	          mapping.originalLine = previousOriginalLine + segment[2];
	          previousOriginalLine = mapping.originalLine;
	          // Lines are stored 0-based
	          mapping.originalLine += 1;
	
	          // Original column.
	          mapping.originalColumn = previousOriginalColumn + segment[3];
	          previousOriginalColumn = mapping.originalColumn;
	
	          if (segment.length > 4) {
	            // Original name.
	            mapping.name = previousName + segment[4];
	            previousName += segment[4];
	          }
	        }
	
	        generatedMappings.push(mapping);
	        if (typeof mapping.originalLine === 'number') {
	          originalMappings.push(mapping);
	        }
	      }
	    }
	
	    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
	    this.__generatedMappings = generatedMappings;
	
	    quickSort(originalMappings, util.compareByOriginalPositions);
	    this.__originalMappings = originalMappings;
	  };
	
	/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */
	BasicSourceMapConsumer.prototype._findMapping =
	  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
	                                         aColumnName, aComparator, aBias) {
	    // To return the position we are searching for, we must first find the
	    // mapping for the given position and then return the opposite position it
	    // points to. Because the mappings are sorted, we can use binary search to
	    // find the best mapping.
	
	    if (aNeedle[aLineName] <= 0) {
	      throw new TypeError('Line must be greater than or equal to 1, got '
	                          + aNeedle[aLineName]);
	    }
	    if (aNeedle[aColumnName] < 0) {
	      throw new TypeError('Column must be greater than or equal to 0, got '
	                          + aNeedle[aColumnName]);
	    }
	
	    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
	  };
	
	/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */
	BasicSourceMapConsumer.prototype.computeColumnSpans =
	  function SourceMapConsumer_computeColumnSpans() {
	    for (var index = 0; index < this._generatedMappings.length; ++index) {
	      var mapping = this._generatedMappings[index];
	
	      // Mappings do not contain a field for the last generated columnt. We
	      // can come up with an optimistic estimate, however, by assuming that
	      // mappings are contiguous (i.e. given two consecutive mappings, the
	      // first mapping ends where the second one starts).
	      if (index + 1 < this._generatedMappings.length) {
	        var nextMapping = this._generatedMappings[index + 1];
	
	        if (mapping.generatedLine === nextMapping.generatedLine) {
	          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
	          continue;
	        }
	      }
	
	      // The last mapping for each line spans the entire line.
	      mapping.lastGeneratedColumn = Infinity;
	    }
	  };
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	BasicSourceMapConsumer.prototype.originalPositionFor =
	  function SourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._generatedMappings,
	      "generatedLine",
	      "generatedColumn",
	      util.compareByGeneratedPositionsDeflated,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._generatedMappings[index];
	
	      if (mapping.generatedLine === needle.generatedLine) {
	        var source = util.getArg(mapping, 'source', null);
	        if (source !== null) {
	          source = this._sources.at(source);
	          if (this.sourceRoot != null) {
	            source = util.join(this.sourceRoot, source);
	          }
	        }
	        var name = util.getArg(mapping, 'name', null);
	        if (name !== null) {
	          name = this._names.at(name);
	        }
	        return {
	          source: source,
	          line: util.getArg(mapping, 'originalLine', null),
	          column: util.getArg(mapping, 'originalColumn', null),
	          name: name
	        };
	      }
	    }
	
	    return {
	      source: null,
	      line: null,
	      column: null,
	      name: null
	    };
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function BasicSourceMapConsumer_hasContentsOfAllSources() {
	    if (!this.sourcesContent) {
	      return false;
	    }
	    return this.sourcesContent.length >= this._sources.size() &&
	      !this.sourcesContent.some(function (sc) { return sc == null; });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	BasicSourceMapConsumer.prototype.sourceContentFor =
	  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    if (!this.sourcesContent) {
	      return null;
	    }
	
	    if (this.sourceRoot != null) {
	      aSource = util.relative(this.sourceRoot, aSource);
	    }
	
	    if (this._sources.has(aSource)) {
	      return this.sourcesContent[this._sources.indexOf(aSource)];
	    }
	
	    var url;
	    if (this.sourceRoot != null
	        && (url = util.urlParse(this.sourceRoot))) {
	      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
	      // many users. We can help them out when they expect file:// URIs to
	      // behave like it would if they were running a local HTTP server. See
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
	      if (url.scheme == "file"
	          && this._sources.has(fileUriAbsPath)) {
	        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
	      }
	
	      if ((!url.path || url.path == "/")
	          && this._sources.has("/" + aSource)) {
	        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
	      }
	    }
	
	    // This function is used recursively from
	    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	    // don't want to throw if we can't find the source - we just want to
	    // return null, so we provide a flag to exit gracefully.
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	BasicSourceMapConsumer.prototype.generatedPositionFor =
	  function SourceMapConsumer_generatedPositionFor(aArgs) {
	    var source = util.getArg(aArgs, 'source');
	    if (this.sourceRoot != null) {
	      source = util.relative(this.sourceRoot, source);
	    }
	    if (!this._sources.has(source)) {
	      return {
	        line: null,
	        column: null,
	        lastColumn: null
	      };
	    }
	    source = this._sources.indexOf(source);
	
	    var needle = {
	      source: source,
	      originalLine: util.getArg(aArgs, 'line'),
	      originalColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._originalMappings,
	      "originalLine",
	      "originalColumn",
	      util.compareByOriginalPositions,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (mapping.source === needle.source) {
	        return {
	          line: util.getArg(mapping, 'generatedLine', null),
	          column: util.getArg(mapping, 'generatedColumn', null),
	          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	        };
	      }
	    }
	
	    return {
	      line: null,
	      column: null,
	      lastColumn: null
	    };
	  };
	
	exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
	/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The only parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */
	function IndexedSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sections = util.getArg(sourceMap, 'sections');
	
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	
	  var lastOffset = {
	    line: -1,
	    column: 0
	  };
	  this._sections = sections.map(function (s) {
	    if (s.url) {
	      // The url field will require support for asynchronicity.
	      // See https://github.com/mozilla/source-map/issues/16
	      throw new Error('Support for url field in sections not implemented.');
	    }
	    var offset = util.getArg(s, 'offset');
	    var offsetLine = util.getArg(offset, 'line');
	    var offsetColumn = util.getArg(offset, 'column');
	
	    if (offsetLine < lastOffset.line ||
	        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
	      throw new Error('Section offsets must be ordered and non-overlapping.');
	    }
	    lastOffset = offset;
	
	    return {
	      generatedOffset: {
	        // The offset fields are 0-based, but we use 1-based indices when
	        // encoding/decoding from VLQ.
	        generatedLine: offsetLine + 1,
	        generatedColumn: offsetColumn + 1
	      },
	      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
	    }
	  });
	}
	
	IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	IndexedSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    var sources = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
	        sources.push(this._sections[i].consumer.sources[j]);
	      }
	    }
	    return sources;
	  }
	});
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	IndexedSourceMapConsumer.prototype.originalPositionFor =
	  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    // Find the section containing the generated position we're trying to map
	    // to an original position.
	    var sectionIndex = binarySearch.search(needle, this._sections,
	      function(needle, section) {
	        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
	        if (cmp) {
	          return cmp;
	        }
	
	        return (needle.generatedColumn -
	                section.generatedOffset.generatedColumn);
	      });
	    var section = this._sections[sectionIndex];
	
	    if (!section) {
	      return {
	        source: null,
	        line: null,
	        column: null,
	        name: null
	      };
	    }
	
	    return section.consumer.originalPositionFor({
	      line: needle.generatedLine -
	        (section.generatedOffset.generatedLine - 1),
	      column: needle.generatedColumn -
	        (section.generatedOffset.generatedLine === needle.generatedLine
	         ? section.generatedOffset.generatedColumn - 1
	         : 0),
	      bias: aArgs.bias
	    });
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
	    return this._sections.every(function (s) {
	      return s.consumer.hasContentsOfAllSources();
	    });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	IndexedSourceMapConsumer.prototype.sourceContentFor =
	  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      var content = section.consumer.sourceContentFor(aSource, true);
	      if (content) {
	        return content;
	      }
	    }
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	IndexedSourceMapConsumer.prototype.generatedPositionFor =
	  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      // Only consider this section if the requested source is in the list of
	      // sources of the consumer.
	      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
	        continue;
	      }
	      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
	      if (generatedPosition) {
	        var ret = {
	          line: generatedPosition.line +
	            (section.generatedOffset.generatedLine - 1),
	          column: generatedPosition.column +
	            (section.generatedOffset.generatedLine === generatedPosition.line
	             ? section.generatedOffset.generatedColumn - 1
	             : 0)
	        };
	        return ret;
	      }
	    }
	
	    return {
	      line: null,
	      column: null
	    };
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	IndexedSourceMapConsumer.prototype._parseMappings =
	  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    this.__generatedMappings = [];
	    this.__originalMappings = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	      var sectionMappings = section.consumer._generatedMappings;
	      for (var j = 0; j < sectionMappings.length; j++) {
	        var mapping = sectionMappings[j];
	
	        var source = section.consumer._sources.at(mapping.source);
	        if (section.consumer.sourceRoot !== null) {
	          source = util.join(section.consumer.sourceRoot, source);
	        }
	        this._sources.add(source);
	        source = this._sources.indexOf(source);
	
	        var name = section.consumer._names.at(mapping.name);
	        this._names.add(name);
	        name = this._names.indexOf(name);
	
	        // The mappings coming from the consumer for the section have
	        // generated positions relative to the start of the section, so we
	        // need to offset them to be relative to the start of the concatenated
	        // generated file.
	        var adjustedMapping = {
	          source: source,
	          generatedLine: mapping.generatedLine +
	            (section.generatedOffset.generatedLine - 1),
	          generatedColumn: mapping.generatedColumn +
	            (section.generatedOffset.generatedLine === mapping.generatedLine
	            ? section.generatedOffset.generatedColumn - 1
	            : 0),
	          originalLine: mapping.originalLine,
	          originalColumn: mapping.originalColumn,
	          name: name
	        };
	
	        this.__generatedMappings.push(adjustedMapping);
	        if (typeof adjustedMapping.originalLine === 'number') {
	          this.__originalMappings.push(adjustedMapping);
	        }
	      }
	    }
	
	    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
	    quickSort(this.__originalMappings, util.compareByOriginalPositions);
	  };
	
	exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var SourceMapGenerator = __webpack_require__(148).SourceMapGenerator;
	var util = __webpack_require__(48);
	
	// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
	// operating systems these days (capturing the result).
	var REGEX_NEWLINE = /(\r?\n)/;
	
	// Newline character code for charCodeAt() comparisons
	var NEWLINE_CODE = 10;
	
	// Private symbol for identifying `SourceNode`s when multiple versions of
	// the source-map library are loaded. This MUST NOT CHANGE across
	// versions!
	var isSourceNode = "$$$isSourceNode$$$";
	
	/**
	 * SourceNodes provide a way to abstract over interpolating/concatenating
	 * snippets of generated JavaScript source code while maintaining the line and
	 * column information associated with the original source code.
	 *
	 * @param aLine The original line number.
	 * @param aColumn The original column number.
	 * @param aSource The original source's filename.
	 * @param aChunks Optional. An array of strings which are snippets of
	 *        generated JS, or other SourceNodes.
	 * @param aName The original identifier.
	 */
	function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
	  this.children = [];
	  this.sourceContents = {};
	  this.line = aLine == null ? null : aLine;
	  this.column = aColumn == null ? null : aColumn;
	  this.source = aSource == null ? null : aSource;
	  this.name = aName == null ? null : aName;
	  this[isSourceNode] = true;
	  if (aChunks != null) this.add(aChunks);
	}
	
	/**
	 * Creates a SourceNode from generated code and a SourceMapConsumer.
	 *
	 * @param aGeneratedCode The generated code
	 * @param aSourceMapConsumer The SourceMap for the generated code
	 * @param aRelativePath Optional. The path that relative sources in the
	 *        SourceMapConsumer should be relative to.
	 */
	SourceNode.fromStringWithSourceMap =
	  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
	    // The SourceNode we want to fill with the generated code
	    // and the SourceMap
	    var node = new SourceNode();
	
	    // All even indices of this array are one line of the generated code,
	    // while all odd indices are the newlines between two adjacent lines
	    // (since `REGEX_NEWLINE` captures its match).
	    // Processed fragments are accessed by calling `shiftNextLine`.
	    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
	    var remainingLinesIndex = 0;
	    var shiftNextLine = function() {
	      var lineContents = getNextLine();
	      // The last line of a file might not have a newline.
	      var newLine = getNextLine() || "";
	      return lineContents + newLine;
	
	      function getNextLine() {
	        return remainingLinesIndex < remainingLines.length ?
	            remainingLines[remainingLinesIndex++] : undefined;
	      }
	    };
	
	    // We need to remember the position of "remainingLines"
	    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
	
	    // The generate SourceNodes we need a code range.
	    // To extract it current and last mapping is used.
	    // Here we store the last mapping.
	    var lastMapping = null;
	
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      if (lastMapping !== null) {
	        // We add the code from "lastMapping" to "mapping":
	        // First check if there is a new line in between.
	        if (lastGeneratedLine < mapping.generatedLine) {
	          // Associate first line with "lastMapping"
	          addMappingWithCode(lastMapping, shiftNextLine());
	          lastGeneratedLine++;
	          lastGeneratedColumn = 0;
	          // The remaining code is added without mapping
	        } else {
	          // There is no new line in between.
	          // Associate the code between "lastGeneratedColumn" and
	          // "mapping.generatedColumn" with "lastMapping"
	          var nextLine = remainingLines[remainingLinesIndex];
	          var code = nextLine.substr(0, mapping.generatedColumn -
	                                        lastGeneratedColumn);
	          remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn -
	                                              lastGeneratedColumn);
	          lastGeneratedColumn = mapping.generatedColumn;
	          addMappingWithCode(lastMapping, code);
	          // No more remaining code, continue
	          lastMapping = mapping;
	          return;
	        }
	      }
	      // We add the generated code until the first mapping
	      // to the SourceNode without any mapping.
	      // Each line is added as separate string.
	      while (lastGeneratedLine < mapping.generatedLine) {
	        node.add(shiftNextLine());
	        lastGeneratedLine++;
	      }
	      if (lastGeneratedColumn < mapping.generatedColumn) {
	        var nextLine = remainingLines[remainingLinesIndex];
	        node.add(nextLine.substr(0, mapping.generatedColumn));
	        remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
	        lastGeneratedColumn = mapping.generatedColumn;
	      }
	      lastMapping = mapping;
	    }, this);
	    // We have processed all mappings.
	    if (remainingLinesIndex < remainingLines.length) {
	      if (lastMapping) {
	        // Associate the remaining code in the current line with "lastMapping"
	        addMappingWithCode(lastMapping, shiftNextLine());
	      }
	      // and add the remaining lines without any mapping
	      node.add(remainingLines.splice(remainingLinesIndex).join(""));
	    }
	
	    // Copy sourcesContent into SourceNode
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aRelativePath != null) {
	          sourceFile = util.join(aRelativePath, sourceFile);
	        }
	        node.setSourceContent(sourceFile, content);
	      }
	    });
	
	    return node;
	
	    function addMappingWithCode(mapping, code) {
	      if (mapping === null || mapping.source === undefined) {
	        node.add(code);
	      } else {
	        var source = aRelativePath
	          ? util.join(aRelativePath, mapping.source)
	          : mapping.source;
	        node.add(new SourceNode(mapping.originalLine,
	                                mapping.originalColumn,
	                                source,
	                                code,
	                                mapping.name));
	      }
	    }
	  };
	
	/**
	 * Add a chunk of generated JS to this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.add = function SourceNode_add(aChunk) {
	  if (Array.isArray(aChunk)) {
	    aChunk.forEach(function (chunk) {
	      this.add(chunk);
	    }, this);
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    if (aChunk) {
	      this.children.push(aChunk);
	    }
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Add a chunk of generated JS to the beginning of this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
	  if (Array.isArray(aChunk)) {
	    for (var i = aChunk.length-1; i >= 0; i--) {
	      this.prepend(aChunk[i]);
	    }
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    this.children.unshift(aChunk);
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Walk over the tree of JS snippets in this node and its children. The
	 * walking function is called once for each snippet of JS and is passed that
	 * snippet and the its original associated source's line/column location.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walk = function SourceNode_walk(aFn) {
	  var chunk;
	  for (var i = 0, len = this.children.length; i < len; i++) {
	    chunk = this.children[i];
	    if (chunk[isSourceNode]) {
	      chunk.walk(aFn);
	    }
	    else {
	      if (chunk !== '') {
	        aFn(chunk, { source: this.source,
	                     line: this.line,
	                     column: this.column,
	                     name: this.name });
	      }
	    }
	  }
	};
	
	/**
	 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	 * each of `this.children`.
	 *
	 * @param aSep The separator.
	 */
	SourceNode.prototype.join = function SourceNode_join(aSep) {
	  var newChildren;
	  var i;
	  var len = this.children.length;
	  if (len > 0) {
	    newChildren = [];
	    for (i = 0; i < len-1; i++) {
	      newChildren.push(this.children[i]);
	      newChildren.push(aSep);
	    }
	    newChildren.push(this.children[i]);
	    this.children = newChildren;
	  }
	  return this;
	};
	
	/**
	 * Call String.prototype.replace on the very right-most source snippet. Useful
	 * for trimming whitespace from the end of a source node, etc.
	 *
	 * @param aPattern The pattern to replace.
	 * @param aReplacement The thing to replace the pattern with.
	 */
	SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
	  var lastChild = this.children[this.children.length - 1];
	  if (lastChild[isSourceNode]) {
	    lastChild.replaceRight(aPattern, aReplacement);
	  }
	  else if (typeof lastChild === 'string') {
	    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
	  }
	  else {
	    this.children.push(''.replace(aPattern, aReplacement));
	  }
	  return this;
	};
	
	/**
	 * Set the source content for a source file. This will be added to the SourceMapGenerator
	 * in the sourcesContent field.
	 *
	 * @param aSourceFile The filename of the source file
	 * @param aSourceContent The content of the source file
	 */
	SourceNode.prototype.setSourceContent =
	  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
	    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
	  };
	
	/**
	 * Walk over the tree of SourceNodes. The walking function is called for each
	 * source file content and is passed the filename and source content.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walkSourceContents =
	  function SourceNode_walkSourceContents(aFn) {
	    for (var i = 0, len = this.children.length; i < len; i++) {
	      if (this.children[i][isSourceNode]) {
	        this.children[i].walkSourceContents(aFn);
	      }
	    }
	
	    var sources = Object.keys(this.sourceContents);
	    for (var i = 0, len = sources.length; i < len; i++) {
	      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
	    }
	  };
	
	/**
	 * Return the string representation of this source node. Walks over the tree
	 * and concatenates all the various snippets together to one string.
	 */
	SourceNode.prototype.toString = function SourceNode_toString() {
	  var str = "";
	  this.walk(function (chunk) {
	    str += chunk;
	  });
	  return str;
	};
	
	/**
	 * Returns the string representation of this source node along with a source
	 * map.
	 */
	SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
	  var generated = {
	    code: "",
	    line: 1,
	    column: 0
	  };
	  var map = new SourceMapGenerator(aArgs);
	  var sourceMappingActive = false;
	  var lastOriginalSource = null;
	  var lastOriginalLine = null;
	  var lastOriginalColumn = null;
	  var lastOriginalName = null;
	  this.walk(function (chunk, original) {
	    generated.code += chunk;
	    if (original.source !== null
	        && original.line !== null
	        && original.column !== null) {
	      if(lastOriginalSource !== original.source
	         || lastOriginalLine !== original.line
	         || lastOriginalColumn !== original.column
	         || lastOriginalName !== original.name) {
	        map.addMapping({
	          source: original.source,
	          original: {
	            line: original.line,
	            column: original.column
	          },
	          generated: {
	            line: generated.line,
	            column: generated.column
	          },
	          name: original.name
	        });
	      }
	      lastOriginalSource = original.source;
	      lastOriginalLine = original.line;
	      lastOriginalColumn = original.column;
	      lastOriginalName = original.name;
	      sourceMappingActive = true;
	    } else if (sourceMappingActive) {
	      map.addMapping({
	        generated: {
	          line: generated.line,
	          column: generated.column
	        }
	      });
	      lastOriginalSource = null;
	      sourceMappingActive = false;
	    }
	    for (var idx = 0, length = chunk.length; idx < length; idx++) {
	      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
	        generated.line++;
	        generated.column = 0;
	        // Mappings end at eol
	        if (idx + 1 === length) {
	          lastOriginalSource = null;
	          sourceMappingActive = false;
	        } else if (sourceMappingActive) {
	          map.addMapping({
	            source: original.source,
	            original: {
	              line: original.line,
	              column: original.column
	            },
	            generated: {
	              line: generated.line,
	              column: generated.column
	            },
	            name: original.name
	          });
	        }
	      } else {
	        generated.column++;
	      }
	    }
	  });
	  this.walkSourceContents(function (sourceFile, sourceContent) {
	    map.setSourceContent(sourceFile, sourceContent);
	  });
	
	  return { code: generated.code, map: map };
	};
	
	exports.SourceNode = SourceNode;


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2009-2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE.txt or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	exports.SourceMapGenerator = __webpack_require__(148).SourceMapGenerator;
	exports.SourceMapConsumer = __webpack_require__(351).SourceMapConsumer;
	exports.SourceNode = __webpack_require__(352).SourceNode;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(177);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./font-awesome.css", function() {
				var newContent = require("!!../../css-loader/index.js!./font-awesome.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(178);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./goldenlayout-base.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./goldenlayout-base.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(179);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./goldenlayout-dark-theme.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./goldenlayout-dark-theme.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(180);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./hint.css", function() {
				var newContent = require("!!../css-loader/index.js!./hint.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(181);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./astView.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./astView.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(182);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./dependencyView.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./dependencyView.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(183);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./normalize.css", function() {
				var newContent = require("!!../css-loader/index.js!./normalize.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(184);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./style.css", function() {
				var newContent = require("!!../css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(185);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./toastr.css", function() {
				var newContent = require("!!../../css-loader/index.js!./toastr.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(186);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./viewer.css", function() {
				var newContent = require("!!../../css-loader/index.js!./viewer.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(187);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./robocop.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./robocop.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(188);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./imageViewer.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./imageViewer.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(189);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./lostConnection.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./lostConnection.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(190);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./markdown.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./markdown.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(191);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./jumpy.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./jumpy.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(192);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./linter.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./linter.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(193);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./liveAnalysis.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./liveAnalysis.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(194);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./quickFix.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./quickFix.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(195);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./codeEditor.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./codeEditor.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(196);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./autocomplete.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./autocomplete.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(197);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./pendingRequestsIndicator.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./pendingRequestsIndicator.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(198);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(15)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./appTabsContainer.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./appTabsContainer.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(377)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 377 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var FreeStyle = __webpack_require__(95);
	/**
	 * We need to do the following to *our* objects before passing to freestyle:
	 * - For any `$nest` directive move up to FreeStyle style nesting
	 * - For any `$unique` directive map to FreeStyle Unique
	 * - For any `$debugName` directive return the debug name
	 */
	function ensureStringObj(object) {
	    /** The final result we will return */
	    var result = {};
	    var debugName = '';
	    for (var key in object) {
	        /** Grab the value upfront */
	        var val = object[key];
	        /** TypeStyle configuration options */
	        if (key === '$unique') {
	            result[FreeStyle.IS_UNIQUE] = val;
	        }
	        else if (key === '$nest') {
	            var nested = val;
	            for (var selector in nested) {
	                var subproperties = nested[selector];
	                result[selector] = ensureStringObj(subproperties).result;
	            }
	        }
	        else if (key === '$debugName') {
	            debugName = val;
	        }
	        else {
	            result[key] = val;
	        }
	    }
	    return { result: result, debugName: debugName };
	}
	exports.ensureStringObj = ensureStringObj;
	// todo: better name here
	function explodeKeyframes(frames) {
	    var result = { $debugName: undefined, keyframes: {} };
	    for (var offset in frames) {
	        var val = frames[offset];
	        if (offset === '$debugName') {
	            result.$debugName = val;
	        }
	        else {
	            result.keyframes[offset] = val;
	        }
	    }
	    return result;
	}
	exports.explodeKeyframes = explodeKeyframes;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var formatting_1 = __webpack_require__(378);
	var utilities_1 = __webpack_require__(151);
	var FreeStyle = __webpack_require__(95);
	/**
	 * Maintains a single stylesheet and keeps it in sync with requested styles
	 */
	var TypeStyle = (function () {
	    function TypeStyle(_a) {
	        var autoGenerateTag = _a.autoGenerateTag;
	        var _this = this;
	        /**
	         * Insert `raw` CSS as a string. This is useful for e.g.
	         * - third party CSS that you are customizing with template strings
	         * - generating raw CSS in JavaScript
	         * - reset libraries like normalize.css that you can use without loaders
	         */
	        this.cssRaw = function (mustBeValidCSS) {
	            if (!mustBeValidCSS) {
	                return;
	            }
	            _this._raw += mustBeValidCSS || '';
	            _this._pendingRawChange = true;
	            _this._styleUpdated();
	        };
	        /**
	         * Takes CSSProperties and registers it to a global selector (body, html, etc.)
	         */
	        this.cssRule = function (selector) {
	            var objects = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                objects[_i - 1] = arguments[_i];
	            }
	            var object = formatting_1.ensureStringObj(utilities_1.extend.apply(void 0, objects)).result;
	            _this._freeStyle.registerRule(selector, object);
	            _this._styleUpdated();
	            return;
	        };
	        /**
	         * Renders styles to the singleton tag imediately
	         * NOTE: You should only call it on initial render to prevent any non CSS flash.
	         * After that it is kept sync using `requestAnimationFrame` and we haven't noticed any bad flashes.
	         **/
	        this.forceRenderStyles = function () {
	            var target = _this._getTag();
	            if (!target) {
	                return;
	            }
	            target.textContent = _this.getStyles();
	        };
	        /**
	         * Utility function to register an @font-face
	         */
	        this.fontFace = function () {
	            var fontFace = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                fontFace[_i] = arguments[_i];
	            }
	            var freeStyle = _this._freeStyle;
	            for (var _a = 0, fontFace_1 = fontFace; _a < fontFace_1.length; _a++) {
	                var face = fontFace_1[_a];
	                freeStyle.registerRule('@font-face', face);
	            }
	            _this._styleUpdated();
	            return;
	        };
	        /**
	         * Allows use to use the stylesheet in a node.js environment
	         */
	        this.getStyles = function () {
	            return (_this._raw || '') + _this._freeStyle.getStyles();
	        };
	        /**
	         * Takes keyframes and returns a generated animationName
	         */
	        this.keyframes = function (frames) {
	            var _a = formatting_1.explodeKeyframes(frames), keyframes = _a.keyframes, $debugName = _a.$debugName;
	            // TODO: replace $debugName with display name
	            var animationName = _this._freeStyle.registerKeyframes(keyframes, $debugName);
	            _this._styleUpdated();
	            return animationName;
	        };
	        /**
	         * Helps with testing. Reinitializes FreeStyle + raw
	         */
	        this.reinit = function () {
	            /** reinit freestyle */
	            var freeStyle = FreeStyle.create();
	            _this._freeStyle = freeStyle;
	            _this._lastFreeStyleChangeId = freeStyle.changeId;
	            /** reinit raw */
	            _this._raw = '';
	            _this._pendingRawChange = false;
	            /** Clear any styles that were flushed */
	            var target = _this._getTag();
	            if (target) {
	                target.textContent = '';
	            }
	        };
	        /** Sets the target tag where we write the css on style updates */
	        this.setStylesTarget = function (tag) {
	            /** Clear any data in any previous tag */
	            if (_this._tag) {
	                _this._tag.textContent = '';
	            }
	            _this._tag = tag;
	            /** This special time buffer immediately */
	            _this.forceRenderStyles();
	        };
	        /**
	         * Takes CSSProperties and return a generated className you can use on your component
	         */
	        this.style = function () {
	            var objects = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                objects[_i] = arguments[_i];
	            }
	            var freeStyle = _this._freeStyle;
	            var _a = formatting_1.ensureStringObj(utilities_1.extend.apply(void 0, objects)), result = _a.result, debugName = _a.debugName;
	            var className = debugName ? freeStyle.registerStyle(result, debugName) : freeStyle.registerStyle(result);
	            _this._styleUpdated();
	            return className;
	        };
	        var freeStyle = FreeStyle.create();
	        this._autoGenerateTag = autoGenerateTag;
	        this._freeStyle = freeStyle;
	        this._lastFreeStyleChangeId = freeStyle.changeId;
	        this._pending = 0;
	        this._pendingRawChange = false;
	        this._raw = '';
	        this._tag = undefined;
	    }
	    /**
	     * Only calls cb all sync operations settle
	     */
	    TypeStyle.prototype._afterAllSync = function (cb) {
	        var _this = this;
	        this._pending++;
	        var pending = this._pending;
	        utilities_1.raf(function () {
	            if (pending !== _this._pending) {
	                return;
	            }
	            cb();
	        });
	    };
	    TypeStyle.prototype._getTag = function () {
	        if (this._tag) {
	            return this._tag;
	        }
	        if (this._autoGenerateTag) {
	            var tag = typeof window === 'undefined'
	                ? { textContent: '' }
	                : document.createElement('style');
	            if (typeof document !== 'undefined') {
	                document.head.appendChild(tag);
	            }
	            this._tag = tag;
	            return tag;
	        }
	        return undefined;
	    };
	    /** Checks if the style tag needs updating and if so queues up the change */
	    TypeStyle.prototype._styleUpdated = function () {
	        var _this = this;
	        var changeId = this._freeStyle.changeId;
	        var lastChangeId = this._lastFreeStyleChangeId;
	        if (!this._pendingRawChange && changeId === lastChangeId) {
	            return;
	        }
	        this._lastFreeStyleChangeId = changeId;
	        this._pendingRawChange = false;
	        this._afterAllSync(function () { return _this.forceRenderStyles(); });
	    };
	    return TypeStyle;
	}());
	exports.TypeStyle = TypeStyle;


/***/ },
/* 380 */
/***/ function(module, exports) {

	"use strict";


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "912ec66d7572ff821749319396470bde.svg";

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b06871f281fee6b241d60582ae9369b9.ttf";

/***/ },
/* 385 */
/***/ function(module, exports) {

	module.exports = "data:application/font-woff2;base64,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"

/***/ },
/* 386 */
/***/ function(module, exports) {

	module.exports = "data:application/font-woff;base64,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"

/***/ },
/* 387 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 388 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Viewer.js v0.4.0
	 * https://github.com/fengyuanchen/viewerjs
	 *
	 * Copyright (c) 2015-2016 Fengyuan Chen
	 * Released under the MIT license
	 *
	 * Date: 2016-03-20T07:17:50.179Z
	 */
	
	(function (global, factory) {
	  if (typeof module === 'object' && typeof module.exports === 'object') {
	    module.exports = global.document ? factory(global, true) : function (window) {
	      if (!window.document) {
	        throw new Error('Viewer requires a window with a document');
	      }
	
	      return factory(window);
	    };
	  } else {
	    factory(global);
	  }
	})(typeof window !== 'undefined' ? window : this, function (window, noGlobal) {
	
	  'use strict';
	
	  var document = window.document;
	  var Event = window.Event;
	
	  // Constants
	  var NAMESPACE = 'viewer';
	
	  // Classes
	  var CLASS_FIXED = NAMESPACE + '-fixed';
	  var CLASS_OPEN = NAMESPACE + '-open';
	  var CLASS_SHOW = NAMESPACE + '-show';
	  var CLASS_HIDE = NAMESPACE + '-hide';
	  var CLASS_HIDE_XS_DOWN = 'viewer-hide-xs-down';
	  var CLASS_HIDE_SM_DOWN = 'viewer-hide-sm-down';
	  var CLASS_HIDE_MD_DOWN = 'viewer-hide-md-down';
	  var CLASS_FADE = NAMESPACE + '-fade';
	  var CLASS_IN = NAMESPACE + '-in';
	  var CLASS_MOVE = NAMESPACE + '-move';
	  var CLASS_ACTIVE = NAMESPACE + '-active';
	  var CLASS_INVISIBLE = NAMESPACE + '-invisible';
	  var CLASS_TRANSITION = NAMESPACE + '-transition';
	  var CLASS_FULLSCREEN = NAMESPACE + '-fullscreen';
	  var CLASS_FULLSCREEN_EXIT = NAMESPACE + '-fullscreen-exit';
	  var CLASS_CLOSE = NAMESPACE + '-close';
	
	  // Events
	  var EVENT_MOUSEDOWN = 'mousedown touchstart pointerdown MSPointerDown';
	  var EVENT_MOUSEMOVE = 'mousemove touchmove pointermove MSPointerMove';
	  var EVENT_MOUSEUP = 'mouseup touchend touchcancel pointerup pointercancel MSPointerUp MSPointerCancel';
	  var EVENT_WHEEL = 'wheel mousewheel DOMMouseScroll';
	  var EVENT_TRANSITIONEND = 'transitionend';
	  var EVENT_LOAD = 'load';
	  var EVENT_KEYDOWN = 'keydown';
	  var EVENT_CLICK = 'click';
	  var EVENT_RESIZE = 'resize';
	  var EVENT_BUILD = 'build';
	  var EVENT_BUILT = 'built';
	  var EVENT_SHOW = 'show';
	  var EVENT_SHOWN = 'shown';
	  var EVENT_HIDE = 'hide';
	  var EVENT_HIDDEN = 'hidden';
	  var EVENT_VIEW = 'view';
	  var EVENT_VIEWED = 'viewed';
	
	  // RegExps
	  var REGEXP_SUFFIX = /width|height|left|top|marginLeft|marginTop/;
	  var REGEXP_TRIM = /^\s+(.*)\s+$/;
	  var REGEXP_SPACES = /\s+/;
	
	  // Supports
	  var SUPPORT_TRANSITION = typeof document.createElement(NAMESPACE).style.transition !== 'undefined';
	
	  // Maths
	  var min = Math.min;
	  var max = Math.max;
	  var abs = Math.abs;
	  var sqrt = Math.sqrt;
	  var round = Math.round;
	
	  // Utilities
	  var objectProto = Object.prototype;
	  var toString = objectProto.toString;
	  var hasOwnProperty = objectProto.hasOwnProperty;
	  var slice = Array.prototype.slice;
	
	  function typeOf(obj) {
	    return toString.call(obj).slice(8, -1).toLowerCase();
	  }
	
	  function isString(str) {
	    return typeof str === 'string';
	  }
	
	  function isNumber(num) {
	    return typeof num === 'number' && !isNaN(num);
	  }
	
	  function isUndefined(obj) {
	    return typeof obj === 'undefined';
	  }
	
	  function isObject(obj) {
	    return typeof obj === 'object' && obj !== null;
	  }
	
	  function isPlainObject(obj) {
	    var constructor;
	    var prototype;
	
	    if (!isObject(obj)) {
	      return false;
	    }
	
	    try {
	      constructor = obj.constructor;
	      prototype = constructor.prototype;
	
	      return constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
	    } catch (e) {
	      return false;
	    }
	  }
	
	  function isFunction(fn) {
	    return typeOf(fn) === 'function';
	  }
	
	  function isArray(arr) {
	    return Array.isArray ? Array.isArray(arr) : typeOf(arr) === 'array';
	  }
	
	  function toArray(obj, offset) {
	    offset = offset >= 0 ? offset : 0;
	
	    if (Array.from) {
	      return Array.from(obj).slice(offset);
	    }
	
	    return slice.call(obj, offset);
	  }
	
	  function inArray(value, arr) {
	    var index = -1;
	
	    if (arr.indexOf) {
	      return arr.indexOf(value);
	    } else {
	      each(arr, function (n, i) {
	        if (n === value) {
	          index = i;
	          return false;
	        }
	      });
	    }
	
	    return index;
	  }
	
	  function trim(str) {
	    if (isString(str)) {
	      str = str.trim ? str.trim() : str.replace(REGEXP_TRIM, '1');
	    }
	
	    return str;
	  }
	
	  function each(obj, callback) {
	    var length;
	    var i;
	
	    if (obj && isFunction(callback)) {
	      if (isArray(obj) || isNumber(obj.length)/* array-like */) {
	        for (i = 0, length = obj.length; i < length; i++) {
	          if (callback.call(obj, obj[i], i, obj) === false) {
	            break;
	          }
	        }
	      } else if (isObject(obj)) {
	        for (i in obj) {
	          if (obj.hasOwnProperty(i)) {
	            if (callback.call(obj, obj[i], i, obj) === false) {
	              break;
	            }
	          }
	        }
	      }
	    }
	
	    return obj;
	  }
	
	  function extend(obj) {
	    var args;
	
	    if (arguments.length > 1) {
	      args = toArray(arguments);
	
	      if (Object.assign) {
	        return Object.assign.apply(Object, args);
	      }
	
	      args.shift();
	
	      each(args, function (arg) {
	        each(arg, function (prop, i) {
	          obj[i] = prop;
	        });
	      });
	    }
	
	    return obj;
	  }
	
	  function proxy(fn, context) {
	    var args = toArray(arguments, 2);
	
	    return function () {
	      return fn.apply(context, args.concat(toArray(arguments)));
	    };
	  }
	
	  function setStyle(element, styles) {
	    var style = element.style;
	
	    each(styles, function (value, property) {
	      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
	        value += 'px';
	      }
	
	      style[property] = value;
	    });
	  }
	
	  function getStyle(element) {
	    return window.getComputedStyle ?
	      window.getComputedStyle(element, null) :
	      element.currentStyle;
	  }
	
	  function hasClass(element, value) {
	    return element.classList ?
	      element.classList.contains(value) :
	      element.className.indexOf(value) > -1;
	  }
	
	  function addClass(element, value) {
	    var className;
	
	    if (!value) {
	      return;
	    }
	
	    if (isNumber(element.length)) {
	      return each(element, function (elem) {
	        addClass(elem, value);
	      });
	    }
	
	    if (element.classList) {
	      return element.classList.add(value);
	    }
	
	    className = trim(element.className);
	
	    if (!className) {
	      element.className = value;
	    } else if (className.indexOf(value) < 0) {
	      element.className = className + ' ' + value;
	    }
	  }
	
	  function removeClass(element, value) {
	    if (!value) {
	      return;
	    }
	
	    if (isNumber(element.length)) {
	      return each(element, function (elem) {
	        removeClass(elem, value);
	      });
	    }
	
	    if (element.classList) {
	      return element.classList.remove(value);
	    }
	
	    if (element.className.indexOf(value) >= 0) {
	      element.className = element.className.replace(value, '');
	    }
	  }
	
	  function toggleClass(element, value, added) {
	    if (isNumber(element.length)) {
	      return each(element, function (elem) {
	        toggleClass(elem, value, added);
	      });
	    }
	
	    // IE10-11 doesn't support the second parameter of `classList.toggle`
	    if (added) {
	      addClass(element, value);
	    } else {
	      removeClass(element, value);
	    }
	  }
	
	  function getData(element, name) {
	    return isObject(element[name]) ?
	      element[name] :
	      element.dataset ?
	        element.dataset[name] :
	        element.getAttribute('data-' + name);
	  }
	
	  function setData(element, name, data) {
	    if (isObject(data) && isUndefined(element[name])) {
	      element[name] = data;
	    } else if (element.dataset) {
	      element.dataset[name] = data;
	    } else {
	      element.setAttribute('data-' + name, data);
	    }
	  }
	
	  function removeData(element, name) {
	    if (isObject(element[name])) {
	      delete element[name];
	    } else if (element.dataset) {
	      delete element.dataset[name];
	    } else {
	      element.removeAttribute('data-' + name);
	    }
	  }
	
	  function addListener(element, type, handler, once) {
	    var types = trim(type).split(REGEXP_SPACES);
	    var originalHandler = handler;
	
	    if (types.length > 1) {
	      return each(types, function (type) {
	        addListener(element, type, handler);
	      });
	    }
	
	    if (once) {
	      handler = function () {
	        removeListener(element, type, handler);
	
	        return originalHandler.apply(element, arguments);
	      };
	    }
	
	    if (element.addEventListener) {
	      element.addEventListener(type, handler, false);
	    } else if (element.attachEvent) {
	      element.attachEvent('on' + type, handler);
	    }
	  }
	
	  function removeListener(element, type, handler) {
	    var types = trim(type).split(REGEXP_SPACES);
	
	    if (types.length > 1) {
	      return each(types, function (type) {
	        removeListener(element, type, handler);
	      });
	    }
	
	    if (element.removeEventListener) {
	      element.removeEventListener(type, handler, false);
	    } else if (element.detachEvent) {
	      element.detachEvent('on' + type, handler);
	    }
	  }
	
	  function dispatchEvent(element, type, data) {
	    var event;
	
	    if (element.dispatchEvent) {
	
	      // Event and CustomEvent on IE9-11 are global objects, not constructors
	      if (isFunction(Event) && isFunction(CustomEvent)) {
	        if (isUndefined(data)) {
	          event = new Event(type, {
	            bubbles: true,
	            cancelable: true
	          });
	        } else {
	          event = new CustomEvent(type, {
	            detail: data,
	            bubbles: true,
	            cancelable: true
	          });
	        }
	      } else {
	        // IE9-11
	        if (isUndefined(data)) {
	          event = document.createEvent('Event');
	          event.initEvent(type, true, true);
	        } else {
	          event = document.createEvent('CustomEvent');
	          event.initCustomEvent(type, true, true, data);
	        }
	      }
	
	      // IE9+
	      return element.dispatchEvent(event);
	    } else if (element.fireEvent) {
	
	      // IE6-10 (native events only)
	      return element.fireEvent('on' + type);
	    }
	  }
	
	  function preventDefault(e) {
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      e.returnValue = false;
	    }
	  }
	
	  function getEvent(event) {
	    var e = event || window.event;
	    var doc;
	
	    // Fix target property (IE8)
	    if (!e.target) {
	      e.target = e.srcElement || document;
	    }
	
	    if (!isNumber(e.pageX)) {
	      doc = document.documentElement;
	      e.pageX = e.clientX + (window.scrollX || doc && doc.scrollLeft || 0) - (doc && doc.clientLeft || 0);
	      e.pageY = e.clientY + (window.scrollY || doc && doc.scrollTop || 0) - (doc && doc.clientTop || 0);
	    }
	
	    return e;
	  }
	
	  function getOffset(element) {
	    var doc = document.documentElement;
	    var box = element.getBoundingClientRect();
	
	    return {
	      left: box.left + (window.scrollX || doc && doc.scrollLeft || 0) - (doc && doc.clientLeft || 0),
	      top: box.top + (window.scrollY || doc && doc.scrollTop || 0) - (doc && doc.clientTop || 0)
	    };
	  }
	
	  function getTouchesCenter(touches) {
	    var length = touches.length;
	    var pageX = 0;
	    var pageY = 0;
	
	    if (length) {
	      each(touches, function (touch) {
	        pageX += touch.pageX;
	        pageY += touch.pageY;
	      });
	
	      pageX /= length;
	      pageY /= length;
	    }
	
	    return {
	      pageX: pageX,
	      pageY: pageY
	    };
	  }
	
	  function getByTag(element, tagName) {
	    return element.getElementsByTagName(tagName);
	  }
	
	  function getByClass(element, className) {
	    return element.getElementsByClassName ?
	      element.getElementsByClassName(className) :
	      element.querySelectorAll('.' + className);
	  }
	
	  function appendChild(element, elem) {
	    if (elem.length) {
	      return each(elem, function (el) {
	        appendChild(element, el);
	      });
	    }
	
	    element.appendChild(elem);
	  }
	
	  function removeChild(element) {
	    if (element.parentNode) {
	      element.parentNode.removeChild(element);
	    }
	  }
	
	  function empty(element) {
	    while (element.firstChild) {
	      element.removeChild(element.firstChild);
	    }
	  }
	
	  function setText(element, text) {
	    if (!isUndefined(element.textContent)) {
	      element.textContent = text;
	    } else {
	      element.innerText = text;
	    }
	  }
	
	  // Force reflow to enable CSS3 transition
	  function forceReflow(element) {
	    return element.offsetWidth;
	  }
	
	  // e.g.: http://domain.com/path/to/picture.jpg?size=1280×960 -> picture.jpg
	  function getImageName(url) {
	    return isString(url) ? url.replace(/^.*\//, '').replace(/[\?&#].*$/, '') : '';
	  }
	
	  function getImageSize(image, callback) {
	    var newImage;
	
	    // Modern browsers
	    if (image.naturalWidth) {
	      return callback(image.naturalWidth, image.naturalHeight);
	    }
	
	    // IE8: Don't use `new Image()` here
	    newImage = document.createElement('img');
	
	    newImage.onload = function () {
	      callback(this.width, this.height);
	    };
	
	    newImage.src = image.src;
	  }
	
	  function getTransform(data) {
	    var transforms = [];
	    var rotate = data.rotate;
	    var scaleX = data.scaleX;
	    var scaleY = data.scaleY;
	
	    if (isNumber(rotate)) {
	      transforms.push('rotate(' + rotate + 'deg)');
	    }
	
	    if (isNumber(scaleX) && isNumber(scaleY)) {
	      transforms.push('scale(' + scaleX + ',' + scaleY + ')');
	    }
	
	    return transforms.length ? transforms.join(' ') : 'none';
	  }
	
	  function getResponsiveClass(option) {
	    switch (option) {
	      case 2:
	        return CLASS_HIDE_XS_DOWN;
	
	      case 3:
	        return CLASS_HIDE_SM_DOWN;
	
	      case 4:
	        return CLASS_HIDE_MD_DOWN;
	    }
	  }
	
	  function Viewer(element, options) {
	    var _this = this;
	
	    _this.element = element;
	    _this.options = extend({}, Viewer.DEFAULTS, isPlainObject(options) && options);
	    _this.isImg = false;
	    _this.isBuilt = false;
	    _this.isShown = false;
	    _this.isViewed = false;
	    _this.isFulled = false;
	    _this.isPlayed = false;
	    _this.wheeling = false;
	    _this.playing = false;
	    _this.fading = false;
	    _this.tooltiping = false;
	    _this.transitioning = false;
	    _this.action = false;
	    _this.target = false;
	    _this.timeout = false;
	    _this.index = 0;
	    _this.length = 0;
	    _this.init();
	  }
	
	  Viewer.prototype = {
	    constructor: Viewer,
	
	    init: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	      var isImg = element.tagName.toLowerCase() === 'img';
	      var images = isImg ? [element] : getByTag(element, 'img');
	      var length = images.length;
	      var ready = proxy(_this.ready, _this);
	
	      if (getData(element, NAMESPACE)) {
	        return;
	      }
	
	      setData(element, NAMESPACE, _this);
	
	      if (!length) {
	        return;
	      }
	
	      if (isFunction(options.build)) {
	        addListener(element, EVENT_BUILD, options.build, true);
	      }
	
	      if (dispatchEvent(element, EVENT_BUILD) === false) {
	        return;
	      }
	
	      // Override `transition` option if it is not supported
	      if (!SUPPORT_TRANSITION) {
	        options.transition = false;
	      }
	
	      _this.isImg = isImg;
	      _this.length = length;
	      _this.count = 0;
	      _this.images = images;
	      _this.body = document.body;
	
	      if (options.inline) {
	        addListener(element, EVENT_BUILT, function () {
	          _this.view();
	        }, true);
	
	        each(images, function (image) {
	          if (image.complete) {
	            ready();
	          } else {
	            addListener(image, EVENT_LOAD, ready, true);
	          }
	        });
	      } else {
	        addListener(element, EVENT_CLICK, (_this._start = proxy(_this.start, _this)));
	      }
	    },
	
	    ready: function () {
	      var _this = this;
	
	      _this.count++;
	
	      if (_this.count === _this.length) {
	        _this.build();
	      }
	    },
	
	    build: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	      var template;
	      var parent;
	      var viewer;
	      var button;
	      var toolbar;
	      var navbar;
	      var title;
	      var rotate;
	
	      if (_this.isBuilt) {
	        return;
	      }
	
	      template = document.createElement('div');
	      template.innerHTML = Viewer.TEMPLATE;
	
	      _this.parent = parent = element.parentNode;
	      _this.viewer = viewer = getByClass(template, 'viewer-container')[0];
	      _this.canvas = getByClass(viewer, 'viewer-canvas')[0];
	      _this.footer = getByClass(viewer, 'viewer-footer')[0];
	      _this.title = title = getByClass(viewer, 'viewer-title')[0];
	      _this.toolbar = toolbar = getByClass(viewer, 'viewer-toolbar')[0];
	      _this.navbar = navbar = getByClass(viewer, 'viewer-navbar')[0];
	      _this.button = button = getByClass(viewer, 'viewer-button')[0];
	      _this.tooltipBox = getByClass(viewer, 'viewer-tooltip')[0];
	      _this.player = getByClass(viewer, 'viewer-player')[0];
	      _this.list = getByClass(viewer, 'viewer-list')[0];
	
	      addClass(title, !options.title ? CLASS_HIDE : getResponsiveClass(options.title));
	      addClass(toolbar, !options.toolbar ? CLASS_HIDE : getResponsiveClass(options.toolbar));
	      addClass(navbar, !options.navbar ? CLASS_HIDE : getResponsiveClass(options.navbar));
	      toggleClass(button, CLASS_HIDE, !options.button);
	
	      toggleClass(toolbar.querySelectorAll('li[class*=zoom]'), CLASS_INVISIBLE, !options.zoomable);
	      toggleClass(toolbar.querySelectorAll('li[class*=flip]'), CLASS_INVISIBLE, !options.scalable);
	
	      if (!options.rotatable) {
	        rotate = toolbar.querySelectorAll('li[class*=rotate]');
	        addClass(rotate, CLASS_INVISIBLE);
	        appendChild(toolbar, rotate);
	      }
	
	      if (options.inline) {
	        addClass(button, CLASS_FULLSCREEN);
	        setStyle(viewer, {
	          zIndex: options.zIndexInline
	        });
	
	        if (getStyle(parent).position === 'static') {
	          setStyle(parent, {
	            position: 'relative'
	          });
	        }
	      } else {
	        addClass(button, CLASS_CLOSE);
	        addClass(viewer, CLASS_FIXED);
	        addClass(viewer, CLASS_FADE);
	        addClass(viewer, CLASS_HIDE);
	
	        setStyle(viewer, {
	          zIndex: options.zIndex
	        });
	      }
	
	      // Inserts the viewer after to the current element
	      parent.insertBefore(viewer, element.nextSibling);
	
	      if (options.inline) {
	        _this.render();
	        _this.bind();
	        _this.isShown = true;
	      }
	
	      _this.isBuilt = true;
	
	      if (isFunction(options.built)) {
	        addListener(element, EVENT_BUILT, options.built, true);
	      }
	
	      dispatchEvent(element, EVENT_BUILT);
	    },
	
	    unbuild: function () {
	      var _this = this;
	
	      if (!_this.isBuilt) {
	        return;
	      }
	
	      _this.isBuilt = false;
	      removeChild(_this.viewer);
	    },
	
	    bind: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	      var viewer = _this.viewer;
	
	      if (isFunction(options.view)) {
	        addListener(element, EVENT_VIEW, options.view);
	      }
	
	      if (isFunction(options.viewed)) {
	        addListener(element, EVENT_VIEWED, options.viewed);
	      }
	
	      addListener(viewer, EVENT_CLICK, (_this._click = proxy(_this.click, _this)));
	      addListener(viewer, EVENT_WHEEL, (_this._wheel = proxy(_this.wheel, _this)));
	      addListener(_this.canvas, EVENT_MOUSEDOWN, (_this._mousedown = proxy(_this.mousedown, _this)));
	      addListener(document, EVENT_MOUSEMOVE, (_this._mousemove = proxy(_this.mousemove, _this)));
	      addListener(document, EVENT_MOUSEUP, (_this._mouseup = proxy(_this.mouseup, _this)));
	      addListener(document, EVENT_KEYDOWN, (_this._keydown = proxy(_this.keydown, _this)));
	      addListener(window, EVENT_RESIZE, (_this._resize = proxy(_this.resize, _this)));
	    },
	
	    unbind: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	      var viewer = _this.viewer;
	
	      if (isFunction(options.view)) {
	        removeListener(element, EVENT_VIEW, options.view);
	      }
	
	      if (isFunction(options.viewed)) {
	        removeListener(element, EVENT_VIEWED, options.viewed);
	      }
	
	      removeListener(viewer, EVENT_CLICK, _this._click);
	      removeListener(viewer, EVENT_WHEEL, _this._wheel);
	      removeListener(_this.canvas, EVENT_MOUSEDOWN, _this._mousedown);
	      removeListener(document, EVENT_MOUSEMOVE, _this._mousemove);
	      removeListener(document, EVENT_MOUSEUP, _this._mouseup);
	      removeListener(document, EVENT_KEYDOWN, _this._keydown);
	      removeListener(window, EVENT_RESIZE, _this._resize);
	    },
	
	    render: function () {
	      var _this = this;
	
	      _this.initContainer();
	      _this.initViewer();
	      _this.initList();
	      _this.renderViewer();
	    },
	
	    initContainer: function () {
	      var _this = this;
	
	      _this.containerData = {
	        width: window.innerWidth,
	        height: window.innerHeight
	      };
	    },
	
	    initViewer: function () {
	      var _this = this;
	      var options = _this.options;
	      var parent = _this.parent;
	      var viewerData;
	
	      if (options.inline) {
	        _this.parentData = viewerData = {
	          width: max(parent.offsetWidth, options.minWidth),
	          height: max(parent.offsetHeight, options.minHeight)
	        };
	      }
	
	      if (_this.isFulled || !viewerData) {
	        viewerData = _this.containerData;
	      }
	
	      _this.viewerData = extend({}, viewerData);
	    },
	
	    renderViewer: function () {
	      var _this = this;
	
	      if (_this.options.inline && !_this.isFulled) {
	        setStyle(_this.viewer, _this.viewerData);
	      }
	    },
	
	    initList: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	      var list = _this.list;
	      var items = [];
	
	      each(_this.images, function (image, i) {
	        var src = image.src;
	        var alt = image.alt || getImageName(src);
	        var url = options.url;
	
	        if (!src) {
	          return;
	        }
	
	        if (isString(url)) {
	          url = image.getAttribute(url);
	        } else if (isFunction(url)) {
	          url = url.call(image, image);
	        }
	
	        items.push(
	          '<li>' +
	            '<img' +
	              ' src="' + src + '"' +
	              ' data-action="view"' +
	              ' data-index="' +  i + '"' +
	              ' data-original-url="' +  (url || src) + '"' +
	              ' alt="' +  alt + '"' +
	            '>' +
	          '</li>'
	        );
	      });
	
	      list.innerHTML = items.join('');
	
	      each(getByTag(list, 'img'), function (image) {
	        setData(image, 'filled', true);
	        addListener(image, EVENT_LOAD, proxy(_this.loadImage, _this), true);
	      });
	
	      _this.items = getByTag(list, 'li');
	
	      if (options.transition) {
	        addListener(element, EVENT_VIEWED, function () {
	          addClass(list, CLASS_TRANSITION);
	        }, true);
	      }
	    },
	
	    renderList: function (index) {
	      var _this = this;
	      var i = index || _this.index;
	      var width = _this.items[i].offsetWidth || 30;
	      var outerWidth = width + 1; // 1 pixel of `margin-left` width
	
	      // Place the active item in the center of the screen
	      setStyle(_this.list, {
	        width: outerWidth * _this.length,
	        marginLeft: (_this.viewerData.width - width) / 2 - outerWidth * i
	      });
	    },
	
	    resetList: function () {
	      var _this = this;
	
	      empty(_this.list);
	      removeClass(_this.list, CLASS_TRANSITION);
	      setStyle({
	        marginLeft: 0
	      });
	    },
	
	    initImage: function (callback) {
	      var _this = this;
	      var options = _this.options;
	      var image = _this.image;
	      var viewerData = _this.viewerData;
	      var footerHeight = _this.footer.offsetHeight;
	      var viewerWidth = viewerData.width;
	      var viewerHeight = max(viewerData.height - footerHeight, footerHeight);
	      var oldImageData = _this.imageData || {};
	
	      getImageSize(image, function (naturalWidth, naturalHeight) {
	        var aspectRatio = naturalWidth / naturalHeight;
	        var width = viewerWidth;
	        var height = viewerHeight;
	        var initialImageData;
	        var imageData;
	
	        if (viewerHeight * aspectRatio > viewerWidth) {
	          height = viewerWidth / aspectRatio;
	        } else {
	          width = viewerHeight * aspectRatio;
	        }
	
	        width = min(width * 0.9, naturalWidth);
	        height = min(height * 0.9, naturalHeight);
	
	        imageData = {
	          naturalWidth: naturalWidth,
	          naturalHeight: naturalHeight,
	          aspectRatio: aspectRatio,
	          ratio: width / naturalWidth,
	          width: width,
	          height: height,
	          left: (viewerWidth - width) / 2,
	          top: (viewerHeight - height) / 2
	        };
	
	        initialImageData = extend({}, imageData);
	
	        if (options.rotatable) {
	          imageData.rotate = oldImageData.rotate || 0;
	          initialImageData.rotate = 0;
	        }
	
	        if (options.scalable) {
	          imageData.scaleX = oldImageData.scaleX || 1;
	          imageData.scaleY = oldImageData.scaleY || 1;
	          initialImageData.scaleX = 1;
	          initialImageData.scaleY = 1;
	        }
	
	        _this.imageData = imageData;
	        _this.initialImageData = initialImageData;
	
	        if (isFunction(callback)) {
	          callback();
	        }
	      });
	    },
	
	    renderImage: function (callback) {
	      var _this = this;
	      var image = _this.image;
	      var imageData = _this.imageData;
	      var transform = getTransform(imageData);
	
	      setStyle(image, {
	        width: imageData.width,
	        height: imageData.height,
	        marginLeft: imageData.left,
	        marginTop: imageData.top,
	        WebkitTransform: transform,
	        msTransform: transform,
	        transform: transform
	      });
	
	      if (isFunction(callback)) {
	        if (_this.transitioning) {
	          addListener(image, EVENT_TRANSITIONEND, callback, true);
	        } else {
	          callback();
	        }
	      }
	    },
	
	    resetImage: function () {
	      var _this = this;
	
	      // this.image only defined after viewed
	      if (_this.image) {
	        removeChild(_this.image);
	        _this.image = null;
	      }
	    },
	
	    start: function (event) {
	      var _this = this;
	      var e = getEvent(event);
	      var target = e.target;
	
	      if (target.tagName.toLowerCase() === 'img') {
	        _this.target = target;
	        _this.show();
	      }
	    },
	
	    click: function (event) {
	      var _this = this;
	      var e = getEvent(event);
	      var target = e.target;
	      var action = getData(target, 'action');
	      var imageData = _this.imageData;
	
	      switch (action) {
	        case 'mix':
	          if (_this.isPlayed) {
	            _this.stop();
	          } else {
	            if (_this.options.inline) {
	              if (_this.isFulled) {
	                _this.exit();
	              } else {
	                _this.full();
	              }
	            } else {
	              _this.hide();
	            }
	          }
	
	          break;
	
	        case 'view':
	          _this.view(getData(target, 'index'));
	          break;
	
	        case 'zoom-in':
	          _this.zoom(0.1, true);
	          break;
	
	        case 'zoom-out':
	          _this.zoom(-0.1, true);
	          break;
	
	        case 'one-to-one':
	          _this.toggle();
	          break;
	
	        case 'reset':
	          _this.reset();
	          break;
	
	        case 'prev':
	          _this.prev();
	          break;
	
	        case 'play':
	          _this.play();
	          break;
	
	        case 'next':
	          _this.next();
	          break;
	
	        case 'rotate-left':
	          _this.rotate(-90);
	          break;
	
	        case 'rotate-right':
	          _this.rotate(90);
	          break;
	
	        case 'flip-horizontal':
	          _this.scaleX(-imageData.scaleX || -1);
	          break;
	
	        case 'flip-vertical':
	          _this.scaleY(-imageData.scaleY || -1);
	          break;
	
	        default:
	          if (_this.isPlayed) {
	            _this.stop();
	          }
	      }
	    },
	
	    load: function () {
	      var _this = this;
	      var options = _this.options;
	      var image = _this.image;
	      var index = _this.index;
	      var viewerData = _this.viewerData;
	
	      if (_this.timeout) {
	        clearTimeout(_this.timeout);
	        _this.timeout = false;
	      }
	
	      removeClass(image, CLASS_INVISIBLE);
	
	      image.style.cssText = (
	        'width:0;' +
	        'height:0;' +
	        'margin-left:' + viewerData.width / 2 + 'px;' +
	        'margin-top:' + viewerData.height / 2 + 'px;' +
	        'max-width:none!important;' +
	        'visibility:visible;'
	      );
	
	      _this.initImage(function () {
	        toggleClass(image, CLASS_TRANSITION, options.transition);
	        toggleClass(image, CLASS_MOVE, options.movable);
	
	        _this.renderImage(function () {
	          _this.isViewed = true;
	          dispatchEvent(_this.element, EVENT_VIEWED, {
	            originalImage: _this.images[index],
	            index: index,
	            image: image
	          });
	        });
	      });
	    },
	
	    loadImage: function (event) {
	      var e = getEvent(event);
	      var image = e.target;
	      var parent = image.parentNode;
	      var parentWidth = parent.offsetWidth || 30;
	      var parentHeight = parent.offsetHeight || 50;
	      var filled = !!getData(image, 'filled');
	
	      getImageSize(image, function (naturalWidth, naturalHeight) {
	        var aspectRatio = naturalWidth / naturalHeight;
	        var width = parentWidth;
	        var height = parentHeight;
	
	        if (parentHeight * aspectRatio > parentWidth) {
	          if (filled) {
	            width = parentHeight * aspectRatio;
	          } else {
	            height = parentWidth / aspectRatio;
	          }
	        } else {
	          if (filled) {
	            height = parentWidth / aspectRatio;
	          } else {
	            width = parentHeight * aspectRatio;
	          }
	        }
	
	        setStyle(image, {
	          width: width,
	          height: height,
	          marginLeft: (parentWidth - width) / 2,
	          marginTop: (parentHeight - height) / 2
	        });
	      });
	    },
	
	    resize: function () {
	      var _this = this;
	
	      _this.initContainer();
	      _this.initViewer();
	      _this.renderViewer();
	      _this.renderList();
	
	      if (_this.isViewed) {
	        _this.initImage(function () {
	          _this.renderImage();
	        });
	      }
	
	      if (_this.isPlayed) {
	        each(getByTag(_this.player, 'img'), function (image) {
	          addListener(image, EVENT_LOAD, proxy(_this.loadImage, _this), true);
	          dispatchEvent(image, EVENT_LOAD);
	        });
	      }
	    },
	
	    wheel: function (event) {
	      var _this = this;
	      var e = getEvent(event);
	      var ratio = Number(_this.options.zoomRatio) || 0.1;
	      var delta = 1;
	
	      if (!_this.isViewed) {
	        return;
	      }
	
	      preventDefault(e);
	
	      // Limit wheel speed to prevent zoom too fast
	      if (_this.wheeling) {
	        return;
	      }
	
	      _this.wheeling = true;
	
	      setTimeout(function () {
	        _this.wheeling = false;
	      }, 50);
	
	      if (e.deltaY) {
	        delta = e.deltaY > 0 ? 1 : -1;
	      } else if (e.wheelDelta) {
	        delta = -e.wheelDelta / 120;
	      } else if (e.detail) {
	        delta = e.detail > 0 ? 1 : -1;
	      }
	
	      _this.zoom(-delta * ratio, true, e);
	    },
	
	    keydown: function (event) {
	      var _this = this;
	      var e = getEvent(event);
	      var options = _this.options;
	      var key = e.keyCode || e.which || e.charCode;
	
	      if (!_this.isFulled || !options.keyboard) {
	        return;
	      }
	
	      switch (key) {
	
	        // (Key: Esc)
	        case 27:
	          if (_this.isPlayed) {
	            _this.stop();
	          } else {
	            if (options.inline) {
	              if (_this.isFulled) {
	                _this.exit();
	              }
	            } else {
	              _this.hide();
	            }
	          }
	
	          break;
	
	        // (Key: Space)
	        case 32:
	          if (_this.isPlayed) {
	            _this.stop();
	          }
	
	          break;
	
	        // View previous (Key: ←)
	        case 37:
	          _this.prev();
	          break;
	
	        // Zoom in (Key: ↑)
	        case 38:
	
	          // Prevent scroll on Firefox
	          preventDefault(e);
	
	          _this.zoom(options.zoomRatio, true);
	          break;
	
	        // View next (Key: →)
	        case 39:
	          _this.next();
	          break;
	
	        // Zoom out (Key: ↓)
	        case 40:
	
	          // Prevent scroll on Firefox
	          preventDefault(e);
	
	          _this.zoom(-options.zoomRatio, true);
	          break;
	
	        // Zoom out to initial size (Key: Ctrl + 0)
	        case 48:
	          // Go to next
	
	        // Zoom in to natural size (Key: Ctrl + 1)
	        case 49:
	          if (e.ctrlKey || e.shiftKey) {
	            preventDefault(e);
	            _this.toggle();
	          }
	
	          break;
	
	        // No default
	      }
	    },
	
	    mousedown: function (event) {
	      var _this = this;
	      var options = _this.options;
	      var e = getEvent(event);
	      var action = options.movable ? 'move' : false;
	      var touches = e.touches;
	      var touchesLength;
	      var touch;
	
	      if (!_this.isViewed) {
	        return;
	      }
	
	      if (touches) {
	        touchesLength = touches.length;
	
	        if (touchesLength > 1) {
	          if (options.zoomable && touchesLength === 2) {
	            touch = touches[1];
	            _this.startX2 = touch.pageX;
	            _this.startY2 = touch.pageY;
	            action = 'zoom';
	          } else {
	            return;
	          }
	        } else {
	          if (_this.isSwitchable()) {
	            action = 'switch';
	          }
	        }
	
	        touch = touches[0];
	      }
	
	      if (action) {
	        preventDefault(e);
	        _this.action = action;
	        _this.startX = touch ? touch.pageX : e.pageX;
	        _this.startY = touch ? touch.pageY : e.pageY;
	      }
	    },
	
	    mousemove: function (event) {
	      var _this = this;
	      var options = _this.options;
	      var e = getEvent(event);
	      var action = _this.action;
	      var image = _this.image;
	      var touches = e.touches;
	      var touchesLength;
	      var touch;
	
	      if (!_this.isViewed) {
	        return;
	      }
	
	      if (touches) {
	        touchesLength = touches.length;
	
	        if (touchesLength > 1) {
	          if (options.zoomable && touchesLength === 2) {
	            touch = touches[1];
	            _this.endX2 = touch.pageX;
	            _this.endY2 = touch.pageY;
	          } else {
	            return;
	          }
	        }
	
	        touch = touches[0];
	      }
	
	      if (action) {
	        preventDefault(e);
	
	        if (action === 'move' && options.transition && hasClass(image, CLASS_TRANSITION)) {
	          removeClass(image, CLASS_TRANSITION);
	        }
	
	        _this.endX = touch ? touch.pageX : e.pageX;
	        _this.endY = touch ? touch.pageY : e.pageY;
	
	        _this.change(e);
	      }
	    },
	
	    mouseup: function (event) {
	      var _this = this;
	      var e = getEvent(event);
	      var action = _this.action;
	
	      if (action) {
	        preventDefault(e);
	
	        if (action === 'move' && _this.options.transition) {
	          addClass(_this.image, CLASS_TRANSITION);
	        }
	
	        _this.action = false;
	      }
	    },
	
	    // Show the viewer (only available in modal mode)
	    show: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	      var viewer;
	
	      if (options.inline || _this.transitioning) {
	        return _this;
	      }
	
	      if (!_this.isBuilt) {
	        _this.build();
	      }
	
	      viewer = _this.viewer;
	
	      if (isFunction(options.show)) {
	        addListener(element, EVENT_SHOW, options.show, true);
	      }
	
	      if (dispatchEvent(element, EVENT_SHOW) === false) {
	        return _this;
	      }
	
	      addClass(_this.body, CLASS_OPEN);
	      removeClass(viewer, CLASS_HIDE);
	
	      addListener(element, EVENT_SHOWN, function () {
	        _this.view(_this.target ? inArray(_this.target, toArray(_this.images)) : _this.index);
	        _this.target = false;
	      }, true);
	
	      if (options.transition) {
	        _this.transitioning = true;
	        addClass(viewer, CLASS_TRANSITION);
	        forceReflow(viewer);
	        addListener(viewer, EVENT_TRANSITIONEND, proxy(_this.shown, _this), true);
	        addClass(viewer, CLASS_IN);
	      } else {
	        addClass(viewer, CLASS_IN);
	        _this.shown();
	      }
	
	      return _this;
	    },
	
	    // Hide the viewer (only available in modal mode)
	    hide: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	      var viewer = _this.viewer;
	
	      if (options.inline || _this.transitioning || !_this.isShown) {
	        return _this;
	      }
	
	      if (isFunction(options.hide)) {
	        addListener(element, EVENT_HIDE, options.hide, true);
	      }
	
	      if (dispatchEvent(element, EVENT_HIDE) === false) {
	        return _this;
	      }
	
	      if (_this.isViewed && options.transition) {
	        _this.transitioning = true;
	        addListener(_this.image, EVENT_TRANSITIONEND, function () {
	          addListener(viewer, EVENT_TRANSITIONEND, proxy(_this.hidden, _this), true);
	          removeClass(viewer, CLASS_IN);
	        }, true);
	        _this.zoomTo(0, false, false, true);
	      } else {
	        removeClass(viewer, CLASS_IN);
	        _this.hidden();
	      }
	
	      return _this;
	    },
	
	    /**
	     * View one of the images with image's index
	     *
	     * @param {Number} index
	     */
	    view: function (index) {
	      var _this = this;
	      var element = _this.element;
	      var title = _this.title;
	      var canvas = _this.canvas;
	      var image;
	      var item;
	      var img;
	      var url;
	      var alt;
	
	      index = Number(index) || 0;
	
	      if (!_this.isShown || _this.isPlayed || index < 0 || index >= _this.length ||
	        _this.isViewed && index === _this.index) {
	        return _this;
	      }
	
	      item = _this.items[index];
	      img = getByTag(item, 'img')[0];
	      url = getData(img, 'originalUrl');
	      alt = img.getAttribute('alt');
	
	      image = document.createElement('img');
	      image.src = url;
	      image.alt = alt;
	
	      if (dispatchEvent(element, EVENT_VIEW, {
	        originalImage: _this.images[index],
	        index: index,
	        image: image
	      }) === false) {
	        return _this;
	      }
	
	      _this.image = image;
	
	      if (_this.isViewed) {
	        removeClass(_this.items[_this.index], CLASS_ACTIVE);
	      }
	
	      addClass(item, CLASS_ACTIVE);
	
	      _this.isViewed = false;
	      _this.index = index;
	      _this.imageData = null;
	
	      addClass(image, CLASS_INVISIBLE);
	      empty(canvas);
	      appendChild(canvas, image);
	
	      // Center current item
	      _this.renderList();
	
	      // Clear title
	      empty(title);
	
	      // Generate title after viewed
	      addListener(element, EVENT_VIEWED, function () {
	        var imageData = _this.imageData;
	        var width = imageData.naturalWidth;
	        var height = imageData.naturalHeight;
	
	        setText(title, alt + ' (' + width + ' × ' + height + ')');
	      }, true);
	
	      if (image.complete) {
	        _this.load();
	      } else {
	        addListener(image, EVENT_LOAD, proxy(_this.load, _this), true);
	
	        if (_this.timeout) {
	          clearTimeout(_this.timeout);
	        }
	
	        // Make the image visible if it fails to load within 1s
	        _this.timeout = setTimeout(function () {
	          removeClass(image, CLASS_INVISIBLE);
	          _this.timeout = false;
	        }, 1000);
	      }
	
	      return _this;
	    },
	
	    // View the previous image
	    prev: function () {
	      var _this = this;
	
	      _this.view(max(_this.index - 1, 0));
	
	      return _this;
	    },
	
	    // View the next image
	    next: function () {
	      var _this = this;
	
	      _this.view(min(_this.index + 1, _this.length - 1));
	
	      return _this;
	    },
	
	    /**
	     * Move the image with relative offsets
	     *
	     * @param {Number} offsetX
	     * @param {Number} offsetY (optional)
	     */
	    move: function (offsetX, offsetY) {
	      var _this = this;
	      var imageData = _this.imageData;
	
	      _this.moveTo(
	        isUndefined(offsetX) ? offsetX : imageData.left + Number(offsetX),
	        isUndefined(offsetY) ? offsetY : imageData.top + Number(offsetY)
	      );
	
	      return _this;
	    },
	
	    /**
	     * Move the image to an absolute point
	     *
	     * @param {Number} x
	     * @param {Number} y (optional)
	     */
	    moveTo: function (x, y) {
	      var _this = this;
	      var imageData = _this.imageData;
	      var changed = false;
	
	      // If "y" is not present, its default value is "x"
	      if (isUndefined(y)) {
	        y = x;
	      }
	
	      x = Number(x);
	      y = Number(y);
	
	      if (_this.isViewed && !_this.isPlayed && _this.options.movable) {
	        if (isNumber(x)) {
	          imageData.left = x;
	          changed = true;
	        }
	
	        if (isNumber(y)) {
	          imageData.top = y;
	          changed = true;
	        }
	
	        if (changed) {
	          _this.renderImage();
	        }
	      }
	
	      return _this;
	    },
	
	    /**
	     * Zoom the image with a relative ratio
	     *
	     * @param {Number} ratio
	     * @param {Boolean} hasTooltip (optional)
	     * @param {Event} _originalEvent (private)
	     */
	    zoom: function (ratio, hasTooltip, _originalEvent) {
	      var _this = this;
	      var imageData = _this.imageData;
	
	      ratio = Number(ratio);
	
	      if (ratio < 0) {
	        ratio =  1 / (1 - ratio);
	      } else {
	        ratio = 1 + ratio;
	      }
	
	      _this.zoomTo(imageData.width * ratio / imageData.naturalWidth, hasTooltip, _originalEvent);
	
	      return _this;
	    },
	
	    /**
	     * Zoom the image to an absolute ratio
	     *
	     * @param {Number} ratio
	     * @param {Boolean} hasTooltip (optional)
	     * @param {Event} _originalEvent (private)
	     * @param {Boolean} _zoomable (private)
	     */
	    zoomTo: function (ratio, hasTooltip, _originalEvent, _zoomable) {
	      var _this = this;
	      var options = _this.options;
	      var minZoomRatio = 0.01;
	      var maxZoomRatio = 100;
	      var imageData = _this.imageData;
	      var newWidth;
	      var newHeight;
	      var offset;
	      var center;
	
	      ratio = max(0, ratio);
	
	      if (isNumber(ratio) && _this.isViewed && !_this.isPlayed && (_zoomable || options.zoomable)) {
	        if (!_zoomable) {
	          minZoomRatio = max(minZoomRatio, options.minZoomRatio);
	          maxZoomRatio = min(maxZoomRatio, options.maxZoomRatio);
	          ratio = min(max(ratio, minZoomRatio), maxZoomRatio);
	        }
	
	        if (ratio > 0.95 && ratio < 1.05) {
	          ratio = 1;
	        }
	
	        newWidth = imageData.naturalWidth * ratio;
	        newHeight = imageData.naturalHeight * ratio;
	
	        if (_originalEvent) {
	          offset = getOffset(_this.viewer);
	          center = _originalEvent.touches ? getTouchesCenter(_originalEvent.touches) : {
	            pageX: _originalEvent.pageX,
	            pageY: _originalEvent.pageY
	          };
	
	          // Zoom from the triggering point of the event
	          imageData.left -= (newWidth - imageData.width) * (
	            ((center.pageX - offset.left) - imageData.left) / imageData.width
	          );
	          imageData.top -= (newHeight - imageData.height) * (
	            ((center.pageY - offset.top) - imageData.top) / imageData.height
	          );
	        } else {
	
	          // Zoom from the center of the image
	          imageData.left -= (newWidth - imageData.width) / 2;
	          imageData.top -= (newHeight - imageData.height) / 2;
	        }
	
	        imageData.width = newWidth;
	        imageData.height = newHeight;
	        imageData.ratio = ratio;
	        _this.renderImage();
	
	        if (hasTooltip) {
	          _this.tooltip();
	        }
	      }
	
	      return _this;
	    },
	
	    /**
	     * Rotate the image with a relative degree
	     *
	     * @param {Number} degree
	     */
	    rotate: function (degree) {
	      var _this = this;
	
	      _this.rotateTo((_this.imageData.rotate || 0) + Number(degree));
	
	      return _this;
	    },
	
	    /**
	     * Rotate the image to an absolute degree
	     * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function#rotate()
	     *
	     * @param {Number} degree
	     */
	    rotateTo: function (degree) {
	      var _this = this;
	      var imageData = _this.imageData;
	
	      degree = Number(degree);
	
	      if (isNumber(degree) && _this.isViewed && !_this.isPlayed && _this.options.rotatable) {
	        imageData.rotate = degree;
	        _this.renderImage();
	      }
	
	      return _this;
	    },
	
	    /**
	     * Scale the image
	     * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function#scale()
	     *
	     * @param {Number} scaleX
	     * @param {Number} scaleY (optional)
	     */
	    scale: function (scaleX, scaleY) {
	      var _this = this;
	      var imageData = _this.imageData;
	      var changed = false;
	
	      // If "scaleY" is not present, its default value is "scaleX"
	      if (isUndefined(scaleY)) {
	        scaleY = scaleX;
	      }
	
	      scaleX = Number(scaleX);
	      scaleY = Number(scaleY);
	
	      if (_this.isViewed && !_this.isPlayed && _this.options.scalable) {
	        if (isNumber(scaleX)) {
	          imageData.scaleX = scaleX;
	          changed = true;
	        }
	
	        if (isNumber(scaleY)) {
	          imageData.scaleY = scaleY;
	          changed = true;
	        }
	
	        if (changed) {
	          _this.renderImage();
	        }
	      }
	
	      return _this;
	    },
	
	    /**
	     * Scale the abscissa of the image
	     *
	     * @param {Number} scaleX
	     */
	    scaleX: function (scaleX) {
	      var _this = this;
	
	      _this.scale(scaleX, _this.imageData.scaleY);
	
	      return _this;
	    },
	
	    /**
	     * Scale the ordinate of the image
	     *
	     * @param {Number} scaleY
	     */
	    scaleY: function (scaleY) {
	      var _this = this;
	
	      _this.scale(_this.imageData.scaleX, scaleY);
	
	      return _this;
	    },
	
	    // Play the images
	    play: function () {
	      var _this = this;
	      var options = _this.options;
	      var player = _this.player;
	      var load = proxy(_this.loadImage, _this);
	      var list = [];
	      var total = 0;
	      var index = 0;
	      var playing;
	
	      if (!_this.isShown || _this.isPlayed) {
	        return _this;
	      }
	
	      if (options.fullscreen) {
	        _this.requestFullscreen();
	      }
	
	      _this.isPlayed = true;
	      addClass(player, CLASS_SHOW);
	
	      each(_this.items, function (item, i) {
	        var img = getByTag(item, 'img')[0];
	        var image = document.createElement('img');
	
	        image.src = getData(img, 'originalUrl');
	        image.alt = img.getAttribute('alt');
	        total++;
	
	        addClass(image, CLASS_FADE);
	        toggleClass(image, CLASS_TRANSITION, options.transition);
	
	        if (hasClass(item, CLASS_ACTIVE)) {
	          addClass(image, CLASS_IN);
	          index = i;
	        }
	
	        list.push(image);
	        addListener(image, EVENT_LOAD, load, true);
	        appendChild(player, image);
	      });
	
	      if (isNumber(options.interval) && options.interval > 0) {
	        playing = function () {
	          _this.playing = setTimeout(function () {
	            removeClass(list[index], CLASS_IN);
	            index++;
	            index = index < total ? index : 0;
	            addClass(list[index], CLASS_IN);
	
	            playing();
	          }, options.interval);
	        };
	
	        if (total > 1) {
	          playing();
	        }
	      }
	
	      return _this;
	    },
	
	    // Stop play
	    stop: function () {
	      var _this = this;
	      var player = _this.player;
	
	      if (!_this.isPlayed) {
	        return _this;
	      }
	
	      if (_this.options.fullscreen) {
	        _this.exitFullscreen();
	      }
	
	      _this.isPlayed = false;
	      clearTimeout(_this.playing);
	      removeClass(player, CLASS_SHOW);
	      empty(player);
	
	      return _this;
	    },
	
	    // Enter modal mode (only available in inline mode)
	    full: function () {
	      var _this = this;
	      var options = _this.options;
	      var viewer = _this.viewer;
	      var image = _this.image;
	      var list = _this.list;
	
	      if (!_this.isShown || _this.isPlayed || _this.isFulled || !options.inline) {
	        return _this;
	      }
	
	      _this.isFulled = true;
	      addClass(_this.body, CLASS_OPEN);
	      addClass(_this.button, CLASS_FULLSCREEN_EXIT);
	
	      if (options.transition) {
	        removeClass(image, CLASS_TRANSITION);
	        removeClass(list, CLASS_TRANSITION);
	      }
	
	      addClass(viewer, CLASS_FIXED);
	      viewer.setAttribute('style', '');
	      setStyle(viewer, {
	        zIndex: options.zIndex
	      });
	
	      _this.initContainer();
	      _this.viewerData = extend({}, _this.containerData);
	      _this.renderList();
	      _this.initImage(function () {
	        _this.renderImage(function () {
	          if (options.transition) {
	            setTimeout(function () {
	              addClass(image, CLASS_TRANSITION);
	              addClass(list, CLASS_TRANSITION);
	            }, 0);
	          }
	        });
	      });
	
	      return _this;
	    },
	
	    // Exit modal mode (only available in inline mode)
	    exit: function () {
	      var _this = this;
	      var options = _this.options;
	      var viewer = _this.viewer;
	      var image = _this.image;
	      var list = _this.list;
	
	      if (!_this.isFulled) {
	        return _this;
	      }
	
	      _this.isFulled = false;
	      removeClass(_this.body, CLASS_OPEN);
	      removeClass(_this.button, CLASS_FULLSCREEN_EXIT);
	
	      if (options.transition) {
	        removeClass(image, CLASS_TRANSITION);
	        removeClass(list, CLASS_TRANSITION);
	      }
	
	      removeClass(viewer, CLASS_FIXED);
	      setStyle(viewer, {
	        zIndex: options.zIndexInline
	      });
	
	      _this.viewerData = extend({}, _this.parentData);
	      _this.renderViewer();
	      _this.renderList();
	      _this.initImage(function () {
	        _this.renderImage(function () {
	          if (options.transition) {
	            setTimeout(function () {
	              addClass(image, CLASS_TRANSITION);
	              addClass(list, CLASS_TRANSITION);
	            }, 0);
	          }
	        });
	      });
	
	      return _this;
	    },
	
	    // Show the current ratio of the image with percentage
	    tooltip: function () {
	      var _this = this;
	      var options = _this.options;
	      var tooltipBox = _this.tooltipBox;
	      var imageData = _this.imageData;
	
	      if (!_this.isViewed || _this.isPlayed || !options.tooltip) {
	        return _this;
	      }
	
	      setText(tooltipBox, round(imageData.ratio * 100) + '%');
	
	      if (!_this.tooltiping) {
	        if (options.transition) {
	          if (_this.fading) {
	            dispatchEvent(tooltipBox, EVENT_TRANSITIONEND);
	          }
	
	          addClass(tooltipBox, CLASS_SHOW);
	          addClass(tooltipBox, CLASS_FADE);
	          addClass(tooltipBox, CLASS_TRANSITION);
	          forceReflow(tooltipBox);
	          addClass(tooltipBox, CLASS_IN);
	        } else {
	          addClass(tooltipBox, CLASS_SHOW);
	        }
	      } else {
	        clearTimeout(_this.tooltiping);
	      }
	
	      _this.tooltiping = setTimeout(function () {
	        if (options.transition) {
	          addListener(tooltipBox, EVENT_TRANSITIONEND, function () {
	            removeClass(tooltipBox, CLASS_SHOW);
	            removeClass(tooltipBox, CLASS_FADE);
	            removeClass(tooltipBox, CLASS_TRANSITION);
	            _this.fading = false;
	          }, true);
	
	          removeClass(tooltipBox, CLASS_IN);
	          _this.fading = true;
	        } else {
	          removeClass(tooltipBox, CLASS_SHOW);
	        }
	
	        _this.tooltiping = false;
	      }, 1000);
	
	      return _this;
	    },
	
	    // Toggle the image size between its natural size and initial size
	    toggle: function () {
	      var _this = this;
	
	      if (_this.imageData.ratio === 1) {
	        _this.zoomTo(_this.initialImageData.ratio, true);
	      } else {
	        _this.zoomTo(1, true);
	      }
	
	      return _this;
	    },
	
	    // Reset the image to its initial state
	    reset: function () {
	      var _this = this;
	
	      if (_this.isViewed && !_this.isPlayed) {
	        _this.imageData = extend({}, _this.initialImageData);
	        _this.renderImage();
	      }
	
	      return _this;
	    },
	
	    // Update viewer when images changed
	    update: function () {
	      var _this = this;
	      var indexes = [];
	      var index;
	
	      // Destroy viewer if the target image was deleted
	      if (_this.isImg && !_this.element.parentNode) {
	        return _this.destroy();
	      }
	
	      _this.length = _this.images.length;
	
	      if (_this.isBuilt) {
	        each(_this.items, function (item, i) {
	          var img = getByTag(item, 'img')[0];
	          var image = _this.images[i];
	
	          if (image) {
	            if (image.src !== img.src) {
	              indexes.push(i);
	            }
	          } else {
	            indexes.push(i);
	          }
	        });
	
	        setStyle(_this.list, {
	          width: 'auto'
	        });
	
	        _this.initList();
	
	        if (_this.isShown) {
	          if (_this.length) {
	            if (_this.isViewed) {
	              index = inArray(_this.index, indexes);
	
	              if (index >= 0) {
	                _this.isViewed = false;
	                _this.view(max(_this.index - (index + 1), 0));
	              } else {
	                addClass(_this.items[_this.index], CLASS_ACTIVE);
	              }
	            }
	          } else {
	            _this.image = null;
	            _this.isViewed = false;
	            _this.index = 0;
	            _this.imageData = null;
	            empty(_this.canvas);
	            empty(_this.title);
	          }
	        }
	      }
	
	      return _this;
	    },
	
	    // Destroy the viewer
	    destroy: function () {
	      var _this = this;
	      var element = _this.element;
	
	      if (_this.options.inline) {
	        _this.unbind();
	      } else {
	        if (_this.isShown) {
	          _this.unbind();
	        }
	
	        removeListener(element, EVENT_CLICK, _this._start);
	      }
	
	      _this.unbuild();
	      removeData(element, NAMESPACE);
	
	      return _this;
	    },
	
	    shown: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	
	      _this.transitioning = false;
	      _this.isFulled = true;
	      _this.isShown = true;
	      _this.isVisible = true;
	      _this.render();
	      _this.bind();
	
	      if (isFunction(options.shown)) {
	        addListener(element, EVENT_SHOWN, options.shown, true);
	      }
	
	      dispatchEvent(element, EVENT_SHOWN);
	    },
	
	    hidden: function () {
	      var _this = this;
	      var options = _this.options;
	      var element = _this.element;
	
	      _this.transitioning = false;
	      _this.isViewed = false;
	      _this.isFulled = false;
	      _this.isShown = false;
	      _this.isVisible = false;
	      _this.unbind();
	      removeClass(_this.body, CLASS_OPEN);
	      addClass(_this.viewer, CLASS_HIDE);
	      _this.resetList();
	      _this.resetImage();
	
	      if (isFunction(options.hidden)) {
	        addListener(element, EVENT_HIDDEN, options.hidden, true);
	      }
	
	      dispatchEvent(element, EVENT_HIDDEN);
	    },
	
	    requestFullscreen: function () {
	      var _this = this;
	      var documentElement = document.documentElement;
	
	      if (_this.isFulled && !document.fullscreenElement && !document.mozFullScreenElement &&
	        !document.webkitFullscreenElement && !document.msFullscreenElement) {
	
	        if (documentElement.requestFullscreen) {
	          documentElement.requestFullscreen();
	        } else if (documentElement.msRequestFullscreen) {
	          documentElement.msRequestFullscreen();
	        } else if (documentElement.mozRequestFullScreen) {
	          documentElement.mozRequestFullScreen();
	        } else if (documentElement.webkitRequestFullscreen) {
	          documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	        }
	      }
	    },
	
	    exitFullscreen: function () {
	      var _this = this;
	
	      if (_this.isFulled) {
	        if (document.exitFullscreen) {
	          document.exitFullscreen();
	        } else if (document.msExitFullscreen) {
	          document.msExitFullscreen();
	        } else if (document.mozCancelFullScreen) {
	          document.mozCancelFullScreen();
	        } else if (document.webkitExitFullscreen) {
	          document.webkitExitFullscreen();
	        }
	      }
	    },
	
	    change: function (originalEvent) {
	      var _this = this;
	      var offsetX = _this.endX - _this.startX;
	      var offsetY = _this.endY - _this.startY;
	
	      switch (_this.action) {
	
	        // Move the current image
	        case 'move':
	          _this.move(offsetX, offsetY);
	          break;
	
	        // Zoom the current image
	        case 'zoom':
	          _this.zoom(function (x1, y1, x2, y2) {
	            var z1 = sqrt(x1 * x1 + y1 * y1);
	            var z2 = sqrt(x2 * x2 + y2 * y2);
	
	            return (z2 - z1) / z1;
	          }(
	            abs(_this.startX - _this.startX2),
	            abs(_this.startY - _this.startY2),
	            abs(_this.endX - _this.endX2),
	            abs(_this.endY - _this.endY2)
	          ), false, originalEvent);
	
	          _this.startX2 = _this.endX2;
	          _this.startY2 = _this.endY2;
	          break;
	
	        case 'switch':
	          _this.action = 'switched';
	
	          if (abs(offsetX) > abs(offsetY)) {
	            if (offsetX > 1) {
	              _this.prev();
	            } else if (offsetX < -1) {
	              _this.next();
	            }
	          }
	
	          break;
	
	        // No default
	      }
	
	      // Override
	      _this.startX = _this.endX;
	      _this.startY = _this.endY;
	    },
	
	    isSwitchable: function () {
	      var _this = this;
	      var imageData = _this.imageData;
	      var viewerData = _this.viewerData;
	
	      return imageData.left >= 0 && imageData.top >= 0 &&
	        imageData.width <= viewerData.width &&
	        imageData.height <= viewerData.height;
	    }
	  };
	
	  Viewer.DEFAULTS = {
	
	    // Enable inline mode
	    inline: false,
	
	    // Show the button on the top-right of the viewer
	    button: true,
	
	    // Show the navbar
	    navbar: true,
	
	    // Show the title
	    title: true,
	
	    // Show the toolbar
	    toolbar: true,
	
	    // Show the tooltip with image ratio (percentage) when zoom in or zoom out
	    tooltip: true,
	
	    // Enable to move the image
	    movable: true,
	
	    // Enable to zoom the image
	    zoomable: true,
	
	    // Enable to rotate the image
	    rotatable: true,
	
	    // Enable to scale the image
	    scalable: true,
	
	    // Enable CSS3 Transition for some special elements
	    transition: true,
	
	    // Enable to request fullscreen when play
	    fullscreen: true,
	
	    // Enable keyboard support
	    keyboard: true,
	
	    // Define interval of each image when playing
	    interval: 5000,
	
	    // Min width of the viewer in inline mode
	    minWidth: 200,
	
	    // Min height of the viewer in inline mode
	    minHeight: 100,
	
	    // Define the ratio when zoom the image by wheeling mouse
	    zoomRatio: 0.1,
	
	    // Define the min ratio of the image when zoom out
	    minZoomRatio: 0.01,
	
	    // Define the max ratio of the image when zoom in
	    maxZoomRatio: 100,
	
	    // Define the CSS `z-index` value of viewer in modal mode.
	    zIndex: 2015,
	
	    // Define the CSS `z-index` value of viewer in inline mode.
	    zIndexInline: 0,
	
	    // Define where to get the original image URL for viewing
	    // Type: String (an image attribute) or Function (should return an image URL)
	    url: 'src',
	
	    // Event shortcuts
	    build: null,
	    built: null,
	    show: null,
	    shown: null,
	    hide: null,
	    hidden: null,
	    view: null,
	    viewed: null
	  };
	
	  Viewer.TEMPLATE = (
	    '<div class="viewer-container">' +
	      '<div class="viewer-canvas"></div>' +
	      '<div class="viewer-footer">' +
	        '<div class="viewer-title"></div>' +
	        '<ul class="viewer-toolbar">' +
	          '<li class="viewer-zoom-in" data-action="zoom-in"></li>' +
	          '<li class="viewer-zoom-out" data-action="zoom-out"></li>' +
	          '<li class="viewer-one-to-one" data-action="one-to-one"></li>' +
	          '<li class="viewer-reset" data-action="reset"></li>' +
	          '<li class="viewer-prev" data-action="prev"></li>' +
	          '<li class="viewer-play" data-action="play"></li>' +
	          '<li class="viewer-next" data-action="next"></li>' +
	          '<li class="viewer-rotate-left" data-action="rotate-left"></li>' +
	          '<li class="viewer-rotate-right" data-action="rotate-right"></li>' +
	          '<li class="viewer-flip-horizontal" data-action="flip-horizontal"></li>' +
	          '<li class="viewer-flip-vertical" data-action="flip-vertical"></li>' +
	        '</ul>' +
	        '<div class="viewer-navbar">' +
	          '<ul class="viewer-list"></ul>' +
	        '</div>' +
	      '</div>' +
	      '<div class="viewer-tooltip"></div>' +
	      '<div class="viewer-button" data-action="mix"></div>' +
	      '<div class="viewer-player"></div>' +
	    '</div>'
	  );
	
	  var _Viewer = window.Viewer;
	
	  Viewer.noConflict = function () {
	    window.Viewer = _Viewer;
	    return Viewer;
	  };
	
	  Viewer.setDefaults = function (options) {
	    extend(Viewer.DEFAULTS, options);
	  };
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Viewer;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  if (!noGlobal) {
	    window.Viewer = Viewer;
	  }
	
	  return Viewer;
	
	});


/***/ },
/* 390 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Maintains a ring of stuff that has been copy / cut so you can paste any of them 🌹
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Imports */
	var monacoUtils_1 = __webpack_require__(18);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var ui = __webpack_require__(1);
	var uix = __webpack_require__(41);
	var clipboardRing = []; // New items at the head of the ring
	var maxItems = 10;
	var index = 0;
	function addToClipboardRing() {
	    var codeEditor = uix.API.getFocusedCodeEditorIfAny();
	    if (!codeEditor)
	        return;
	    index = 0; // Reset seek index
	    var selected = monacoUtils_1.getSelectionOrCurrentLine(codeEditor.editor);
	    addSelected(selected);
	}
	exports.addToClipboardRing = addToClipboardRing;
	function addSelected(selected) {
	    // Just prevents the item being added right next to each other
	    var before = utils.rangeLimited({ num: index - 1, min: 0, max: clipboardRing.length - 1, loopAround: true });
	    var after = utils.rangeLimited({ num: index + 1, min: 0, max: clipboardRing.length - 1, loopAround: true });
	    if (clipboardRing[before] === selected
	        || clipboardRing[after] === selected
	        // Cause we will remove last if we get to max items, check second last too
	        || clipboardRing[maxItems - 2] === selected) {
	        return false;
	    }
	    clipboardRing.unshift(selected);
	    if (clipboardRing.length > maxItems) {
	        clipboardRing.pop();
	    }
	    // console.log(clipboardRing,index); // DEBUG
	    return true;
	}
	function pasteFromClipboardRing() {
	    var codeEditor = uix.API.getFocusedCodeEditorIfAny();
	    if (!codeEditor)
	        return;
	    var selection = codeEditor.editor.getSelection();
	    var hasSelection = !selection.isEmpty();
	    if (!clipboardRing.length) {
	        ui.notifyInfoQuickDisappear('Clipboard Ring Empty');
	        // TODO: hand over to os command + select if anything gets pasted
	        return;
	    }
	    var item = clipboardRing[index];
	    var lines = item.split('\n');
	    var lastLineLength = lines[lines.length - 1].length;
	    var doc = codeEditor.editor.getModel();
	    /** Find the start */
	    var from = {
	        line: selection.startLineNumber - 1,
	        ch: selection.startColumn - 1
	    };
	    /** Also add any current selection to the clipboard ring */
	    if (hasSelection) {
	        var added = addSelected(codeEditor.editor.getModel().getValueInRange(selection)); // Add current selection to the ring
	        if (added) {
	            index++;
	        }
	    }
	    // replace selection (if any) with a new one
	    // have the new item selected
	    var line = lines.length > 1 ? from.line + (lines.length - 1) : from.line;
	    var ch = lines.length > 1 ? lastLineLength : from.ch + item.length;
	    var to = { line: line, ch: ch };
	    monacoUtils_1.replaceSelection({ editor: codeEditor.editor, newText: item });
	    codeEditor.editor.setSelection({
	        startLineNumber: from.line + 1,
	        startColumn: from.ch + 1,
	        endLineNumber: to.line + 1,
	        endColumn: to.ch + 1
	    });
	    // update the index (and loop around)
	    index = utils.rangeLimited({ num: index + 1, min: 0, max: clipboardRing.length - 1, loopAround: true });
	}
	exports.pasteFromClipboardRing = pasteFromClipboardRing;
	commands.copy.on(function () {
	    addToClipboardRing();
	});
	commands.cut.on(function () {
	    addToClipboardRing();
	});
	commands.pasteFromRing.on(function () {
	    pasteFromClipboardRing();
	});


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands = __webpack_require__(7);
	var ui = __webpack_require__(1);
	var inputDialog_1 = __webpack_require__(83);
	var socketClient_1 = __webpack_require__(5);
	commands.gitAddAllCommitAndPush.on(function () {
	    inputDialog_1.inputDialog.open({
	        header: 'Git: Add all the files, commit with the following message, and push',
	        onOk: function (message) {
	            ui.notifyInfoNormalDisappear("Git: Sending commands. Will notify when complete.");
	            socketClient_1.server
	                .gitAddAllCommitAndPush({ message: message })
	                .then(function (res) {
	                if (res.type === 'error') {
	                    ui.notifyWarningNormalDisappear("Git Failed:" + res.error);
	                }
	                else {
	                    ui.notifySuccessNormalDisappear(res.log);
	                    ui.notifySuccessNormalDisappear("Git: Commands ran to completion successfully.");
	                }
	                commands.gitStatusNeedsRefresh.emit({});
	            });
	        },
	        onEsc: function () { return null; },
	    });
	});


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands = __webpack_require__(7);
	var ui = __webpack_require__(1);
	var socketClient_1 = __webpack_require__(5);
	commands.gitFetchLatestAndRebase.on(function () {
	    ui.notifyInfoNormalDisappear("Git: Sending commands. Will notify when complete.");
	    socketClient_1.server
	        .gitFetchLatestAndRebase({})
	        .then(function (res) {
	        if (res.type === 'error') {
	            ui.notifyWarningNormalDisappear("Git Failed:" + res.error);
	        }
	        else {
	            ui.notifySuccessNormalDisappear(res.log);
	            ui.notifySuccessNormalDisappear("Git: Commands ran to completion successfully.");
	        }
	        commands.gitStatusNeedsRefresh.emit({});
	    });
	});


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands = __webpack_require__(7);
	var ui = __webpack_require__(1);
	var selectListView = __webpack_require__(51);
	commands.openFileFromDisk.on(function () {
	    ui.comingSoon("Open a file from the server disk");
	    selectListView.selectListView.show({
	        header: 'Open a file from server disk',
	        data: [],
	        render: function (filePath, matched) { return matched; },
	        textify: function (filePath) { return filePath; },
	        onSelect: function (filePath) {
	            commands.doOpenOrFocusFile.emit({ filePath: filePath });
	            return '';
	        },
	        getNewData: function (filterValue) {
	            // TODO:
	            return Promise.resolve([]);
	        }
	    });
	});


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils = __webpack_require__(3);
	/** Addons. These must be loaded before the function below is ever called so loaded here 🌹 */
	var gitStatus = __webpack_require__(159);
	var jumpy = __webpack_require__(415);
	var writeCode = __webpack_require__(422);
	var gitReset = __webpack_require__(411);
	var htmlToTsx = __webpack_require__(413);
	var cssToTs = __webpack_require__(407);
	var jsonToDts = __webpack_require__(414);
	var gotoTypeScriptSymbol = __webpack_require__(412);
	var findReferences = __webpack_require__(423);
	var gotoDefinition = __webpack_require__(424);
	var renameVariable = __webpack_require__(425);
	var blaster = __webpack_require__(406);
	var quickFix = __webpack_require__(160);
	var removeUnusedImports = __webpack_require__(419);
	var liveDemo = __webpack_require__(418);
	var formatBetter = __webpack_require__(410);
	var ensureImport = gitStatus
	    || jumpy
	    || writeCode
	    || gitReset
	    || htmlToTsx
	    || cssToTs
	    || jsonToDts
	    || gotoTypeScriptSymbol
	    || findReferences
	    || gotoDefinition
	    || renameVariable
	    || blaster
	    || quickFix
	    || removeUnusedImports
	    || liveDemo
	    || formatBetter;
	/**
	 * These are actions for which we have our own commands
	 */
	var blackListedActions = utils.createMap([
	    // we have our own find experience
	    'actions.find',
	    'editor.action.nextMatchFindAction',
	    'editor.action.previousMatchFindAction',
	    // we have our own goto definition/references/rename experiences
	    'editor.action.goToDeclaration',
	    'editor.action.referenceSearch.trigger',
	    'editor.action.rename',
	    // we have our own quickfix implementation
	    'editor.action.quickFix',
	    // we have our own goto symbol for TypeScript
	    // Sadly disabiling this means we lose it for `css` files too.
	    // But its okay as far as I am concerned.
	    'editor.action.quickOutline'
	]);
	/**
	 * This creates a dummy monaco editor just to get its actions
	 */
	function getActions() {
	    var elt = document.createElement('div');
	    var editor = monaco.editor.create(elt, {}, []);
	    // WARNING: This isn't documented or well exposed
	    // but this is what `quickCommand.ts` (the built in command pallet) uses
	    // It uses its on (injected) version but fortunately its on the editor as well
	    var keybindingService = editor._standaloneKeybindingService;
	    // console.log(editor, keybindingService); // DEBUG
	    var actions = editor.getActions().filter(function (a) { return !blackListedActions[a.id]; });
	    var result = actions.map(function (a) {
	        // can have multiple (but in my experience they only had singles or 0)
	        var keyboards = keybindingService.lookupKeybindings(a.id).map(function (k) { return keybindingService.getLabelFor(k); });
	        var keyboard = keyboards[0];
	        // if there was any keyboard
	        // map to it look nice for us
	        // We don't actually need to use these bindings other than the display it (as trigger is done by `id`).
	        var kbd = null;
	        if (keyboard) {
	            kbd = keyboard
	                .replace('UpArrow', 'Up')
	                .replace('DownArrow', 'Down')
	                .replace('LeftArrow', 'Left')
	                .replace('RightArrow', 'Right');
	        }
	        return {
	            label: a.label,
	            id: a.id,
	            kbd: kbd
	        };
	    });
	    editor.dispose();
	    elt.remove();
	    return result;
	}
	exports.getActions = getActions;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var styles = __webpack_require__(10);
	var typestyle = __webpack_require__(13);
	var inputBlackClassName = typestyle.style(styles.modal.inputStyleBase, {
	    fontSize: '.7rem',
	    lineHeight: '.7rem',
	    fontFamily: 'sans-serif',
	    flex: '1',
	});
	exports.InputBlack = function (props) {
	    return (React.createElement("input", { className: inputBlackClassName, style: props.style, type: "text", placeholder: props.placeholder, value: props.value, onChange: function (e) { return props.onChange(e.target.value); }, onKeyDown: props.onKeyDown }));
	};


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var Progress = /** @class */ (function (_super) {
	    __extends(Progress, _super);
	    function Progress() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Progress.prototype.render = function () {
	        var _a = this.props, current = _a.current, total = _a.total;
	        var percent = total == 0 ? 100 : (current / total * 100);
	        if (percent < 0) {
	            percent = 0;
	        }
	        ;
	        var parentStyle = {
	            textAlign: 'center',
	            fontSize: '.6em',
	            fontWeight: 'bold',
	            color: 'white',
	            border: '1px solid white',
	        };
	        var childStyle = {
	            backgroundColor: '#0BD318',
	            width: percent + '%',
	            transition: "width 200ms",
	            padding: '5px 10px',
	        };
	        return (React.createElement("div", { className: "progressbar-container", style: parentStyle },
	            React.createElement("div", { className: "progressbar-progress", style: childStyle }, this.props.children)));
	    };
	    return Progress;
	}(React.Component));
	exports.Progress = Progress;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Commands to create common configuration files
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands = __webpack_require__(7);
	var ui = __webpack_require__(1);
	var socketClient_1 = __webpack_require__(5);
	commands.createEditorconfig.on(function () {
	    socketClient_1.server.createEditorconfig({}).then(function (res) {
	        if (res.alreadyPresent) {
	            ui.notifyWarningNormalDisappear('There is already an .editorconfig. Opened that for you instead.');
	            commands.doOpenOrFocusFile.emit({ filePath: res.alreadyPresent });
	        }
	        else {
	            ui.notifySuccessNormalDisappear('Created an .editorconfig');
	        }
	    });
	});


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Singleton that maintains the cursor history
	 */
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var appTabsContainer_1 = __webpack_require__(26);
	/** The current cursor location */
	var currentIndex = -1;
	var history = [];
	var tooMany = 200;
	/** Subscribe to user requests to move around */
	commands.previousCursorLocation.on(function () {
	    previous();
	});
	commands.nextCursorLocation.on(function () {
	    next();
	});
	function previous() {
	    currentIndex = utils.rangeLimited({ min: 0, max: history.length - 1, num: currentIndex - 1 });
	    var tab = history[currentIndex];
	    if (tab) {
	        commands.doOpenOrFocusTab.emit({ tabId: tab.tabId, tabUrl: tab.tabUrl, position: tab.position });
	    }
	    // debug();
	}
	exports.previous = previous;
	function next() {
	    currentIndex = utils.rangeLimited({ min: 0, max: history.length - 1, num: currentIndex + 1 });
	    var tab = history[currentIndex];
	    if (tab) {
	        commands.doOpenOrFocusTab.emit({ tabId: tab.tabId, tabUrl: tab.tabUrl, position: tab.position });
	    }
	    // debug();
	}
	exports.next = next;
	/**
	 * The current tab with id is fetched from state. So all you need is editorPosition
	 */
	exports.addEntry = utils.debounce(function (editorPosition) {
	    var selectedTab = appTabsContainer_1.tabState.getSelectedTab();
	    /**
	     * This can happen if we close the tabs too fast (because this function is debounced)
	     * Adding a cursor history should not have been called if there is no active tab
	     * Adding a cursor history should not have been called if active tab is not a filePath
	     */
	    if (!selectedTab || !selectedTab.url.startsWith('file://')) {
	        return;
	    }
	    var potentialNewEntry = {
	        tabId: selectedTab.id,
	        tabUrl: selectedTab.url,
	        position: editorPosition
	    };
	    var isSame = function (pos1, pos2) { return pos1.line == pos2.line && pos1.ch == pos2.ch; };
	    // This prevents us adding a new history for what we already know e.g. when we ask the UI to select a tab
	    var testEntry = history[currentIndex];
	    if (testEntry && testEntry.tabId == potentialNewEntry.tabId) {
	        if (isSame(editorPosition, testEntry.position)) {
	            return;
	        }
	    }
	    // if the users action is same as what there would be one before we just take them there in index
	    testEntry = history[currentIndex - 1];
	    if (testEntry && testEntry.tabId == potentialNewEntry.tabId) {
	        if (isSame(editorPosition, testEntry.position)) {
	            currentIndex--;
	            return;
	        }
	    }
	    // if the users action is same as what there would be one after we just take them there in index
	    testEntry = history[currentIndex + 1];
	    if (testEntry && testEntry.tabId == potentialNewEntry.tabId) {
	        if (isSame(editorPosition, testEntry.position)) {
	            currentIndex++;
	            return;
	        }
	    }
	    currentIndex++;
	    history.splice(currentIndex, 0, potentialNewEntry);
	    // If too many:
	    if (history.length >= tooMany) {
	        // if at end we remove items from the start
	        if (currentIndex == history.length - 1) {
	            history.shift();
	            currentIndex--;
	        }
	        else {
	            history.pop();
	        }
	    }
	    // console.log(`Added tab: ${potentialNewEntry.tabUrl}:${potentialNewEntry.position.line}:${potentialNewEntry.position.ch}`); debug(); // Debug
	}, 800);
	var debug = function () {
	    console.log(history.map(function (h) { return h.tabUrl + ':' + h.position.line + ':' + h.position.ch; }));
	    console.log(currentIndex);
	};
	// window.debug = debug;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var types = __webpack_require__(23);
	var React = __webpack_require__(2);
	var csx = __webpack_require__(6);
	var ReactDOM = __webpack_require__(17);
	var ui_1 = __webpack_require__(1);
	var ui = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var state = __webpack_require__(11);
	var react_redux_1 = __webpack_require__(29);
	var icon_1 = __webpack_require__(31);
	var commands = __webpack_require__(7);
	var DraggableCore = ui.DraggableCore;
	var utils_1 = __webpack_require__(3);
	var robocop_1 = __webpack_require__(153);
	var inputDialog_1 = __webpack_require__(83);
	var Mousetrap = __webpack_require__(63);
	var clipboard = __webpack_require__(50);
	var appTabsContainer_1 = __webpack_require__(26);
	var settings = __webpack_require__(88);
	var typestyle = __webpack_require__(13);
	var utils_2 = __webpack_require__(3);
	var dirSelected = { isDir: true };
	var fileSelected = { isDir: false };
	var resizerWidth = 5;
	var resizerStyle = {
	    background: 'radial-gradient(#444,transparent)',
	    width: resizerWidth + 'px',
	    cursor: 'ew-resize',
	    color: '#666',
	};
	var treeListStyle = {
	    color: '#eee',
	    fontSize: '.7rem',
	    padding: '3px',
	};
	var treeScrollClassName = typestyle.style({
	    border: '1px solid grey',
	    $nest: {
	        '&:focus': {
	            outline: 'none',
	            border: '1px solid ' + styles.highlightColor
	        }
	    }
	});
	var treeItemClassName = typestyle.style({
	    whiteSpace: 'nowrap',
	    cursor: 'pointer',
	    padding: '3px',
	    userSelect: 'none',
	    fontSize: '.9em',
	    opacity: .8,
	    $nest: {
	        '&:focus': {
	            outline: 'none',
	        }
	    }
	});
	var treeItemSelectedStyle = {
	    backgroundColor: styles.selectedBackgroundColor,
	};
	var treeItemInProjectStyle = {
	    color: 'rgb(0, 255, 183)',
	    opacity: 1,
	};
	var treeItemIsGeneratedStyle = {
	    fontSize: '.6em'
	};
	var currentSelectedItemCopyStyle = {
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'pre',
	    cursor: 'pointer',
	    marginLeft: '2px',
	    fontSize: '.6rem',
	    fontWeight: 'bold',
	    color: '#CCC',
	    textShadow: '0 0 3px rgba(255, 255, 255, 0.5)',
	};
	var helpRowStyle = {
	    margin: '5px',
	    lineHeight: '18px'
	};
	var FileTree = /** @class */ (function (_super) {
	    __extends(FileTree, _super);
	    function FileTree(props) {
	        var _this = _super.call(this, props) || this;
	        /** can't be pure right now because of how we've written `selectedState` */
	        // shouldComponentUpdate = pure.shouldComponentUpdate;
	        /** makes it easier to lookup directories */
	        _this.dirLookup = {};
	        _this.loading = true; // guilty till proven innocent
	        _this.refNames = {
	            __treeroot: '__treeroot',
	            __treeViewScroll: '__treeViewScroll',
	        };
	        _this.handleDrag = function (evt, ui) {
	            _this.setState({ width: ui.deltaX + ui.lastX + resizerWidth });
	        };
	        _this.handleDragStop = function () {
	            var width = _this.state.width;
	            settings.fileTreeWidth.set(width);
	        };
	        _this.setupTree = utils_2.throttle(function (props) {
	            var filePaths = props.filePaths.filter(function (fp) { return fp.type == types.FilePathType.File; }).map(function (fp) { return fp.filePath; });
	            // initial boot up
	            if (!filePaths.length) {
	                return;
	            }
	            _this.loading = false;
	            var rootDirPath = props.rootDir;
	            var rootDir = {
	                name: utils.getFileName(rootDirPath),
	                filePath: rootDirPath,
	                subDirs: [],
	                files: []
	            };
	            // Always expand root
	            _this.state.expansionState[rootDirPath] = true;
	            _this.dirLookup = {};
	            _this.dirLookup[rootDirPath] = rootDir;
	            // if not found creates a new dir and set its parent
	            // (recursively e.g. last was /foo and new is /foo/bar/baz/quz)
	            var createDirAndMakeSureAllParentExits = function (dir) {
	                var dirTree = {
	                    name: utils_1.getFileName(dir),
	                    filePath: dir,
	                    subDirs: [],
	                    files: []
	                };
	                _this.dirLookup[dir] = dirTree;
	                var parentDir = utils_1.getDirectory(dir);
	                var parentDirTree = _this.dirLookup[parentDir];
	                if (!parentDirTree) {
	                    parentDirTree = createDirAndMakeSureAllParentExits(parentDir);
	                }
	                parentDirTree.subDirs.push(dirTree);
	                return dirTree;
	            };
	            for (var _i = 0, filePaths_1 = filePaths; _i < filePaths_1.length; _i++) {
	                var filePath = filePaths_1[_i];
	                var dir = utils_1.getDirectory(filePath);
	                var fileName = utils_1.getFileName(filePath);
	                var subItem = {
	                    name: fileName,
	                    filePath: filePath,
	                };
	                // lookup existing dir
	                var treeDir = _this.dirLookup[dir];
	                if (!treeDir) {
	                    treeDir = createDirAndMakeSureAllParentExits(dir);
	                }
	                treeDir.files.push(subItem);
	            }
	            _this.setState({ treeRoot: rootDir, expansionState: _this.state.expansionState });
	            /** Also add the folders that may have no files */
	            var dirs = props.filePaths.filter(function (fp) { return fp.type == types.FilePathType.Dir; }).map(function (fp) { return fp.filePath; });
	            dirs.forEach(function (dirPath) {
	                var treeDir = _this.dirLookup[dirPath];
	                if (!treeDir) {
	                    createDirAndMakeSureAllParentExits(dirPath);
	                }
	            });
	            /**
	             * keep the selected file paths in sync with all the items that are available
	             */
	            // A map for easier lookup
	            var filePathMap = utils.createMap(filePaths);
	            var oldSelectedPaths = Object.keys(_this.state.selectedPaths);
	            var newSelectedPaths = {};
	            oldSelectedPaths.forEach(function (path) {
	                var isDir = _this.state.selectedPaths[path].isDir;
	                if (!filePathMap[path]) {
	                    return;
	                }
	                newSelectedPaths[path] = { isDir: isDir };
	            });
	            // If there is no selected path select the root
	            if (Object.keys(newSelectedPaths).length === 0) {
	                newSelectedPaths[rootDirPath] = { isDir: true };
	            }
	            _this.setState({ selectedPaths: newSelectedPaths });
	            /**
	             * Loading had focus. Transfer focus to root
	             */
	            if (document.activeElement === _this.refs['loading']) {
	                setTimeout(function () {
	                    var selectedPaths = (_a = {},
	                        _a[_this.state.treeRoot.filePath] = dirSelected,
	                        _a);
	                    _this.setState({ selectedPaths: selectedPaths });
	                    _this.focusOnPath(_this.state.treeRoot.filePath);
	                    var _a;
	                }, 500);
	            }
	        }, 1000);
	        _this.handleToggleDir = function (evt, item) {
	            evt.stopPropagation();
	            var dirPath = item.filePath;
	            var selectedPaths = (_a = {},
	                _a[dirPath] = dirSelected,
	                _a);
	            _this.state.expansionState[dirPath] = !_this.state.expansionState[dirPath];
	            _this.setState({ expansionState: _this.state.expansionState, selectedPaths: selectedPaths });
	            var _a;
	        };
	        _this.handleSelectFile = function (evt, item) {
	            evt.stopPropagation();
	            var filePath = item.filePath;
	            var selectedPaths = (_a = {},
	                _a[filePath] = fileSelected,
	                _a);
	            _this.setState({ selectedPaths: selectedPaths });
	            commands.doOpenOrActivateFileTab.emit({ filePath: filePath });
	            var _a;
	        };
	        _this.state = {
	            width: 200,
	            expansionState: {},
	            selectedPaths: {},
	            treeRoot: { name: 'loading', filePath: 'loading', subDirs: [], files: [] },
	            treeScrollHasFocus: false,
	        };
	        _this.setupTree(props);
	        return _this;
	        // debug
	        // this.state.shown = true; // debug
	    }
	    FileTree.prototype.componentWillReceiveProps = function (props) {
	        this.setupTree(props);
	    };
	    FileTree.prototype.componentDidMount = function () {
	        var _this = this;
	        settings.fileTreeWidth.get().then(function (res) {
	            var width = res || _this.state.width;
	            width = Math.min(window.innerWidth - 100, width);
	            _this.setState({ width: width });
	        });
	        var handleFocusRequestBasic = function (shown) {
	            if (!shown) {
	                state.expandFileTree({});
	            }
	            var selectedFilePaths = Object.keys(_this.state.selectedPaths);
	            var pathToFocus = selectedFilePaths.length > 0 && _this.ref(selectedFilePaths[selectedFilePaths.length - 1])
	                ? selectedFilePaths[selectedFilePaths.length - 1]
	                : _this.state.treeRoot.filePath;
	            _this.focusOnPath(pathToFocus);
	            return false;
	        };
	        this.disposible.add(commands.esc.on(function () {
	            if (_this.state.showHelp) {
	                _this.setState({ showHelp: false });
	                setTimeout(function () { return _this.focusOnPath(_this.state.treeRoot.filePath); }, 150);
	            }
	        }));
	        this.disposible.add(commands.treeViewToggle.on(function () {
	            var shown = _this.props.fileTreeShown;
	            shown ? state.collapseFileTree({}) : state.expandFileTree({});
	            if (!shown) {
	                handleFocusRequestBasic(true);
	            }
	            else {
	                commands.esc.emit({});
	            }
	        }));
	        this.disposible.add(commands.treeViewRevealActiveFile.on(function () {
	            if (!_this.props.fileTreeShown) {
	                state.expandFileTree({});
	            }
	            var selectedTab = appTabsContainer_1.tabState.getSelectedTab();
	            if (selectedTab && selectedTab.url.startsWith('file://')) {
	                var filePath = utils.getFilePathFromUrl(selectedTab.url);
	                // expand the tree to make sure this file is visible
	                var root = _this.state.treeRoot.filePath;
	                var remainderAfterRoot = filePath.substr(root.length + 1 /* for `/` */);
	                var dirPortionsAfterRoot = utils.getDirectory(remainderAfterRoot).split('/');
	                var runningPortion = '';
	                var expanded = {};
	                expanded[root] = true;
	                for (var _i = 0, dirPortionsAfterRoot_1 = dirPortionsAfterRoot; _i < dirPortionsAfterRoot_1.length; _i++) {
	                    var portion = dirPortionsAfterRoot_1[_i];
	                    runningPortion = runningPortion + '/' + portion;
	                    var fullPath = root + runningPortion;
	                    expanded[fullPath] = true;
	                }
	                var expansionState = csx.extend(_this.state.expansionState, expanded);
	                // also only select this node
	                var selectedPaths = (_a = {},
	                    _a[filePath] = fileSelected,
	                    _a);
	                _this.setState({ expansionState: expansionState, selectedPaths: selectedPaths });
	                _this.focusOnPath(filePath);
	            }
	            else {
	                handleFocusRequestBasic(true);
	            }
	            return false;
	            var _a;
	        }));
	        this.disposible.add(commands.treeViewFocus.on(function () {
	            handleFocusRequestBasic(_this.props.fileTreeShown);
	        }));
	        /**
	         * Utility: takes the selected state to the last item selected
	         * If no item selected it selects the root
	         */
	        var goDownToSmallestSelection = function () {
	            var selectedFilePaths = Object.keys(_this.state.selectedPaths);
	            if (selectedFilePaths.length == 0) {
	                var selectedPaths = (_a = {},
	                    _a[_this.state.treeRoot.filePath] = fileSelected,
	                    _a);
	                _this.setState({ selectedPaths: selectedPaths });
	            }
	            else if (selectedFilePaths.length > 1) {
	                var path = selectedFilePaths[selectedFilePaths.length - 1];
	                var selectedPaths = (_b = {},
	                    _b[path] = _this.state.selectedPaths[path],
	                    _b);
	                _this.setState({ selectedPaths: selectedPaths });
	            }
	            else {
	                // already single selection :)
	            }
	            var selectedFilePath = Object.keys(_this.state.selectedPaths)[0];
	            var selectedFilePathDetails = _this.state.selectedPaths[selectedFilePath];
	            return { selectedFilePath: selectedFilePath, isDir: selectedFilePathDetails.isDir };
	            var _a, _b;
	        };
	        /**
	         * Utility : gets you the last item selected if any, otherwise the root dir
	         * Does not modify state
	         */
	        var getLastSelected = function () {
	            var selectedFilePaths = Object.keys(_this.state.selectedPaths);
	            var last = selectedFilePaths[selectedFilePaths.length - 1];
	            if (!last) {
	                return { filePath: _this.state.treeRoot.filePath, isDir: true };
	            }
	            var selectedFilePathDetails = _this.state.selectedPaths[last];
	            return { filePath: last, isDir: selectedFilePathDetails.isDir };
	        };
	        /** Utility : set an item as the only selected */
	        var setAsOnlySelectedNoFocus = function (filePath, isDir) {
	            var selectedPaths = (_a = {},
	                _a[filePath] = { isDir: isDir },
	                _a);
	            _this.setState({ selectedPaths: selectedPaths });
	            var _a;
	        };
	        var setAsOnlySelected = function (filePath, isDir) {
	            setAsOnlySelectedNoFocus(filePath, isDir);
	            _this.focusOnPath(filePath);
	        };
	        /**
	         * Used in handling keyboard for tree items
	         */
	        var treeRoot = this.ref('__treeroot');
	        var handlers = new Mousetrap(treeRoot);
	        /**
	         * file action handlers
	         */
	        handlers.bind(commands.treeAddFile.config.keyboardShortcut, function () {
	            if (_this.loading)
	                return;
	            var lastSelected = getLastSelected();
	            var dirPath = lastSelected.isDir ? lastSelected.filePath : utils.getDirectory(lastSelected.filePath);
	            inputDialog_1.inputDialog.open({
	                header: "Enter a file name",
	                onOk: function (value) {
	                    var filePath = value;
	                    socketClient_1.server.addFile({ filePath: filePath }).then(function (res) {
	                        commands.doOpenOrFocusFile.emit({ filePath: filePath });
	                    });
	                },
	                onEsc: function () {
	                    setTimeout(handleFocusRequestBasic, 150);
	                },
	                filterValue: dirPath + '/',
	            });
	            return false;
	        });
	        handlers.bind(commands.treeAddFolder.config.keyboardShortcut, function () {
	            if (_this.loading)
	                return;
	            var lastSelected = getLastSelected();
	            var dirPath = lastSelected.isDir ? lastSelected.filePath : utils.getDirectory(lastSelected.filePath);
	            inputDialog_1.inputDialog.open({
	                header: "Enter a folder name",
	                onOk: function (value) {
	                    var filePath = value;
	                    socketClient_1.server.addFolder({ filePath: filePath }).then(function (res) {
	                        ui.notifyInfoQuickDisappear('Folder created');
	                    });
	                },
	                onEsc: function () {
	                    setTimeout(handleFocusRequestBasic, 150);
	                },
	                filterValue: dirPath + '/',
	            });
	            return false;
	        });
	        handlers.bind(commands.treeDuplicateFile.config.keyboardShortcut, function () {
	            if (_this.loading)
	                return;
	            var selection = goDownToSmallestSelection();
	            if (!selection) {
	                ui.notifyInfoNormalDisappear('Nothing selected');
	                return false;
	            }
	            var parentDir = utils.getDirectory(selection.selectedFilePath);
	            if (selection.isDir) {
	                inputDialog_1.inputDialog.open({
	                    header: "Enter a new directory name",
	                    onOk: function (value) {
	                        var filePath = value;
	                        socketClient_1.server.duplicateDir({ src: selection.selectedFilePath, dest: filePath });
	                        setAsOnlySelectedNoFocus(filePath, true);
	                        _this.state.expansionState[filePath] = true;
	                        _this.setState({ expansionState: _this.state.expansionState });
	                    },
	                    onEsc: function () {
	                        setTimeout(handleFocusRequestBasic, 150);
	                    },
	                    filterValue: parentDir + '/',
	                });
	            }
	            else {
	                inputDialog_1.inputDialog.open({
	                    header: "Enter a new file name",
	                    onOk: function (value) {
	                        var filePath = value;
	                        socketClient_1.server.duplicateFile({ src: selection.selectedFilePath, dest: filePath });
	                        commands.doOpenOrFocusFile.emit({ filePath: filePath });
	                        setAsOnlySelectedNoFocus(filePath, false);
	                    },
	                    onEsc: function () {
	                        setTimeout(handleFocusRequestBasic, 150);
	                    },
	                    filterValue: parentDir + '/',
	                });
	            }
	            return false;
	        });
	        handlers.bind([commands.treeMoveFile.config.keyboardShortcut, commands.treeRenameFile.config.keyboardShortcut], function () {
	            if (_this.loading)
	                return;
	            var selection = goDownToSmallestSelection();
	            if (!selection) {
	                ui.notifyInfoNormalDisappear('Nothing selected');
	                return false;
	            }
	            inputDialog_1.inputDialog.open({
	                header: "Enter a new location",
	                onOk: function (value) {
	                    var filePath = value;
	                    socketClient_1.server.movePath({ src: selection.selectedFilePath, dest: filePath }).then(function (res) {
	                        if (res.error) {
	                            ui.notifyWarningNormalDisappear("Failed to move: " + res.error);
	                            return;
	                        }
	                        if (selection.isDir) {
	                            setAsOnlySelectedNoFocus(filePath, true);
	                            _this.state.expansionState[filePath] = true;
	                            _this.setState({ expansionState: _this.state.expansionState });
	                            commands.closeFilesDirs.emit({ files: [], dirs: [selection.selectedFilePath] });
	                        }
	                        else {
	                            commands.doOpenOrFocusFile.emit({ filePath: filePath });
	                            setAsOnlySelectedNoFocus(filePath, false);
	                            commands.closeFilesDirs.emit({ files: [selection.selectedFilePath], dirs: [] });
	                        }
	                    });
	                },
	                onEsc: function () {
	                    setTimeout(handleFocusRequestBasic, 150);
	                },
	                filterValue: selection.selectedFilePath,
	            });
	            return false;
	        });
	        handlers.bind([commands.treeDeleteFile.config.keyboardShortcut, "backspace"], function () {
	            if (_this.loading)
	                return;
	            var selectedFilePaths = Object.keys(_this.state.selectedPaths);
	            var selectedFilePathsDetails = selectedFilePaths.map(function (fp) {
	                return {
	                    filePath: fp,
	                    isDir: _this.state.selectedPaths[fp].isDir
	                };
	            });
	            if (selectedFilePaths.length == 0) {
	                ui.notifyInfoNormalDisappear('Nothing selected');
	                return false;
	            }
	            if (selectedFilePaths.some(function (fp) { return fp == _this.state.treeRoot.filePath; })) {
	                ui.notifyWarningNormalDisappear("You cannot delete the root working directory");
	                return false;
	            }
	            inputDialog_1.inputDialog.open({
	                hideInput: true,
	                header: "Delete " + (selectedFilePaths.length > 1 ? selectedFilePaths.length + ' items' : utils.getFileName(selectedFilePaths[0])) + "?",
	                onOk: function () {
	                    var files = selectedFilePathsDetails.filter(function (x) { return !x.isDir; }).map(function (x) { return x.filePath; });
	                    var dirs = selectedFilePathsDetails.filter(function (x) { return x.isDir; }).map(function (x) { return x.filePath; });
	                    socketClient_1.server.deleteFromDisk({ files: files, dirs: dirs }).then(function (res) {
	                        commands.closeFilesDirs.emit({ files: files, dirs: dirs });
	                        // Leave selection in a useful state
	                        var lastSelectedDetails = selectedFilePathsDetails[selectedFilePathsDetails.length - 1].filePath;
	                        setAsOnlySelected(utils.getDirectory(lastSelectedDetails), true);
	                    });
	                },
	                onEsc: function () {
	                    setTimeout(handleFocusRequestBasic, 150);
	                }
	            });
	            return false;
	        });
	        handlers.bind(commands.treeOpenInExplorerFinder.config.keyboardShortcut, function () {
	            if (_this.loading)
	                return;
	            var selection = goDownToSmallestSelection();
	            if (!selection) {
	                ui.notifyInfoNormalDisappear('Nothing selected');
	                return false;
	            }
	            var dirFilePath = selection.selectedFilePath;
	            if (!selection.isDir) {
	                dirFilePath = utils.getDirectory(dirFilePath);
	            }
	            socketClient_1.server.launchDirectory({ filePath: dirFilePath });
	            ui.notifySuccessNormalDisappear("Command to open sent: " + dirFilePath);
	            return false;
	        });
	        handlers.bind(commands.treeOpenInCmdTerminal.config.keyboardShortcut, function () {
	            if (_this.loading)
	                return;
	            var selection = goDownToSmallestSelection();
	            if (!selection) {
	                ui.notifyInfoNormalDisappear('Nothing selected');
	                return false;
	            }
	            var dirFilePath = selection.selectedFilePath;
	            if (!selection.isDir) {
	                dirFilePath = utils.getDirectory(dirFilePath);
	            }
	            socketClient_1.server.launchTerminal({ filePath: dirFilePath });
	            ui.notifySuccessNormalDisappear("Command to open cmd/terminal sent: " + dirFilePath);
	            return false;
	        });
	        /**
	         * navigation handlers
	         */
	        handlers.bind('enter', function () {
	            if (_this.loading)
	                return;
	            var _a = goDownToSmallestSelection(), selectedFilePath = _a.selectedFilePath, isDir = _a.isDir;
	            if (isDir) {
	                _this.state.expansionState[selectedFilePath] = !_this.state.expansionState[selectedFilePath];
	                _this.setState({ expansionState: _this.state.expansionState });
	            }
	            else {
	                commands.doOpenOrFocusFile.emit({ filePath: selectedFilePath });
	            }
	            return false;
	        });
	        handlers.bind('up', function () {
	            if (_this.loading)
	                return;
	            var _a = goDownToSmallestSelection(), selectedFilePath = _a.selectedFilePath, isDir = _a.isDir;
	            // if root do nothing
	            if (selectedFilePath == _this.state.treeRoot.filePath) {
	                return;
	            }
	            // find the parent dir &&
	            // find this in the parent dir
	            var parentDirFilePath = utils.getDirectory(selectedFilePath);
	            var parentDirTreeItem = _this.dirLookup[parentDirFilePath];
	            var indexInParentDir = isDir
	                ? parentDirTreeItem.subDirs.map(function (x) { return x.filePath; }).indexOf(selectedFilePath)
	                : parentDirTreeItem.files.map(function (x) { return x.filePath; }).indexOf(selectedFilePath);
	            /** Goes to the bottom file / folder */
	            var gotoBottomOfFolder = function (closestDir) {
	                while (true) {
	                    if (!_this.state.expansionState[closestDir.filePath]) {
	                        setAsOnlySelected(closestDir.filePath, true);
	                        break;
	                    }
	                    if (closestDir.files.length) {
	                        setAsOnlySelected(closestDir.files[closestDir.files.length - 1].filePath, false);
	                        break;
	                    }
	                    else if (closestDir.subDirs.length) {
	                        closestDir = closestDir.subDirs[closestDir.subDirs.length - 1];
	                        continue;
	                    }
	                    else {
	                        setAsOnlySelected(closestDir.filePath, true);
	                        break;
	                    }
	                }
	            };
	            // if first
	            if (indexInParentDir == 0) {
	                if (isDir) {
	                    setAsOnlySelected(parentDirFilePath, true);
	                }
	                else if (parentDirTreeItem.subDirs.length == 0) {
	                    setAsOnlySelected(parentDirFilePath, true);
	                }
	                else {
	                    gotoBottomOfFolder(parentDirTreeItem.subDirs[parentDirTreeItem.subDirs.length - 1]);
	                }
	            }
	            else if (!isDir) {
	                setAsOnlySelected(parentDirTreeItem.files[indexInParentDir - 1].filePath, false);
	            }
	            else {
	                var closestDir = parentDirTreeItem.subDirs[indexInParentDir - 1];
	                gotoBottomOfFolder(closestDir);
	            }
	            return false;
	        });
	        handlers.bind('down', function () {
	            if (_this.loading)
	                return;
	            var _a = goDownToSmallestSelection(), selectedFilePath = _a.selectedFilePath, isDir = _a.isDir;
	            /** Goes to next sibling on any (recursive) parent folder */
	            var gotoNextSiblingHighUp = function (treeItem) {
	                // Special handling for root. Don't change selection :)
	                if (treeItem.filePath == _this.state.treeRoot.filePath) {
	                    return;
	                }
	                var parentDirFilePath = utils.getDirectory(treeItem.filePath);
	                var parentTreeItem = _this.dirLookup[parentDirFilePath];
	                var indexInParent = parentTreeItem.subDirs.map(function (x) { return x.filePath; }).indexOf(treeItem.filePath);
	                if (indexInParent !== (parentTreeItem.subDirs.length - 1)) {
	                    setAsOnlySelected(parentTreeItem.subDirs[indexInParent + 1].filePath, true);
	                }
	                else if (parentTreeItem.files.length) {
	                    setAsOnlySelected(parentTreeItem.files[0].filePath, false);
	                }
	                else {
	                    gotoNextSiblingHighUp(parentTreeItem);
	                }
	            };
	            if (isDir) {
	                var dirTreeItem = _this.dirLookup[selectedFilePath];
	                // If expanded and has children, select first relevant child
	                if (_this.state.expansionState[selectedFilePath]
	                    && (dirTreeItem.files.length || dirTreeItem.subDirs.length)) {
	                    dirTreeItem.subDirs[0]
	                        ? setAsOnlySelected(dirTreeItem.subDirs[0].filePath, true)
	                        : setAsOnlySelected(dirTreeItem.files[0].filePath, false);
	                }
	                else {
	                    // Else find the next sibling dir
	                    gotoNextSiblingHighUp(dirTreeItem);
	                }
	            }
	            else {
	                var parentDirFilePath = utils.getDirectory(selectedFilePath);
	                var parentTreeItem = _this.dirLookup[parentDirFilePath];
	                var indexInParent = parentTreeItem.files.map(function (f) { return f.filePath; }).indexOf(selectedFilePath);
	                // if not last select next sibling
	                if (indexInParent !== (parentTreeItem.files.length - 1)) {
	                    setAsOnlySelected(parentTreeItem.files[indexInParent + 1].filePath, false);
	                }
	                else {
	                    gotoNextSiblingHighUp(parentTreeItem);
	                }
	            }
	            return false;
	        });
	        handlers.bind('left', function () {
	            if (_this.loading)
	                return;
	            var _a = goDownToSmallestSelection(), selectedFilePath = _a.selectedFilePath, isDir = _a.isDir;
	            if (isDir) {
	                // if expanded then collapse
	                if (_this.state.expansionState[selectedFilePath]) {
	                    delete _this.state.expansionState[selectedFilePath];
	                    _this.setState({ expansionState: _this.state.expansionState });
	                    return;
	                }
	                // if root ... leave
	                if (_this.state.treeRoot.filePath == selectedFilePath) {
	                    return;
	                }
	            }
	            // Goto the parent directory
	            setAsOnlySelected(utils.getDirectory(selectedFilePath), true);
	            return false;
	        });
	        handlers.bind('right', function () {
	            if (_this.loading)
	                return;
	            var _a = goDownToSmallestSelection(), selectedFilePath = _a.selectedFilePath, isDir = _a.isDir;
	            if (isDir) {
	                // just expand
	                _this.state.expansionState[selectedFilePath] = true;
	                _this.setState({ expansionState: _this.state.expansionState });
	                return false;
	            }
	            return false;
	        });
	        handlers.bind('h', function () {
	            _this.setState({ showHelp: !_this.state.showHelp });
	        });
	        handlers.bind('c', function () {
	            var copyButtonRef = _this.ref('copypath');
	            if (!copyButtonRef) {
	                ui.notifyInfoNormalDisappear('Nothing selected');
	                return;
	            }
	            var copypathDom = ReactDOM.findDOMNode(copyButtonRef);
	            copypathDom.click();
	        });
	        /**
	         * TS to js and JS to ts
	         */
	        handlers.bind('t', function () {
	            if (_this.loading)
	                return;
	            var selection = goDownToSmallestSelection();
	            if (!selection) {
	                ui.notifyInfoNormalDisappear('Nothing selected');
	                return false;
	            }
	            var filePath = selection.selectedFilePath;
	            if (selection.isDir ||
	                (!filePath.endsWith('.js')) && !filePath.endsWith('.jsx')) {
	                ui.notifyInfoNormalDisappear('Please select a `.js`/`jsx` file');
	                return false;
	            }
	            var newFilePath = filePath.replace(/\.js$/g, '.ts').replace(/\.jsx$/g, '.tsx');
	            socketClient_1.server.movePath({ src: filePath, dest: newFilePath }).then(function (res) {
	                commands.doOpenOrFocusFile.emit({ filePath: newFilePath });
	                setAsOnlySelectedNoFocus(newFilePath, false);
	                commands.closeFilesDirs.emit({ files: [filePath], dirs: [] });
	                ui.notifySuccessNormalDisappear('File extension changed to be TypeScript');
	            });
	            return false;
	        });
	        handlers.bind('j', function () {
	            if (_this.loading)
	                return;
	            var selection = goDownToSmallestSelection();
	            if (!selection) {
	                ui.notifyInfoNormalDisappear('Nothing selected');
	                return false;
	            }
	            var filePath = selection.selectedFilePath;
	            if (selection.isDir ||
	                (!filePath.endsWith('.ts')) && !filePath.endsWith('.tsx')) {
	                ui.notifyInfoNormalDisappear('Please select a `.ts`/`tsx` file');
	                return false;
	            }
	            var newFilePath = filePath.replace(/\.ts$/g, '.js').replace(/\.tsx$/g, '.jsx');
	            socketClient_1.server.movePath({ src: filePath, dest: newFilePath }).then(function (res) {
	                commands.doOpenOrFocusFile.emit({ filePath: newFilePath });
	                setAsOnlySelectedNoFocus(newFilePath, false);
	                commands.closeFilesDirs.emit({ files: [filePath], dirs: [] });
	                ui.notifySuccessNormalDisappear('File extension changed to be JavaScript');
	            });
	            return false;
	        });
	    };
	    FileTree.prototype.render = function () {
	        var _this = this;
	        var singlePathSelected = Object.keys(this.state.selectedPaths).length == 1
	            && Object.keys(this.state.selectedPaths)[0];
	        var hideStyle = !this.props.fileTreeShown && { display: 'none' };
	        var haveFocus = this.state.treeScrollHasFocus;
	        var helpOpacity = haveFocus ? 1 : 0;
	        return (React.createElement("div", { ref: this.refNames.__treeroot, className: "alm-tree-root", style: csx.extend(csx.flexRoot, csx.horizontal, { width: this.state.width, zIndex: 6 }, hideStyle) },
	            React.createElement("div", { style: csx.extend(csx.flex, csx.vertical, treeListStyle, styles.someChildWillScroll, csx.newLayerParent) },
	                React.createElement("div", { ref: this.refNames.__treeViewScroll, className: treeScrollClassName, style: csx.extend(csx.flex, csx.scroll), tabIndex: 0, onFocus: function () { return _this.setState({ treeScrollHasFocus: true }); }, onBlur: function () { return _this.setState({ treeScrollHasFocus: false }); } }, this.renderDir(this.state.treeRoot)),
	                this.props.filePathsCompleted || React.createElement(robocop_1.Robocop, null),
	                singlePathSelected
	                    && React.createElement("div", { style: csx.extend(csx.content, csx.horizontal, csx.center, csx.centerJustified, { paddingTop: '5px', paddingBottom: '5px', width: this.state.width - 15 + 'px' }) },
	                        React.createElement(clipboard.Clipboard, { ref: 'copypath', text: singlePathSelected }),
	                        React.createElement("span", { className: "hint--top", "data-hint": "Click to copy the file path to clipboard", "data-clipboard-text": singlePathSelected, style: currentSelectedItemCopyStyle, onClick: function () { return ui.notifyInfoQuickDisappear("Path copied to clipboard"); } }, singlePathSelected)),
	                React.createElement("div", { style: csx.extend(csx.content, csx.centerCenter, { fontSize: '.7em', lineHeight: '2em', opacity: helpOpacity, transition: 'opacity .2s' }) },
	                    React.createElement("span", null,
	                        "Tap ",
	                        React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "H"),
	                        " to toggle tree view help")),
	                this.state.showHelp
	                    && React.createElement("div", { style: csx.extend(csx.newLayer, csx.centerCenter, csx.flex, { background: 'rgba(0,0,0,.7)' }), onClick: function () { return _this.setState({ showHelp: false }); } },
	                        React.createElement("div", { style: csx.extend(csx.flexRoot, csx.vertical) },
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "ESC"),
	                                " to hide help"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "A"),
	                                " to add a file"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Shift + A"),
	                                " to add a folder"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "D"),
	                                " to duplicate file / folder"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "M"),
	                                " to move file / folder"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "R"),
	                                " to rename file / folder"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "C"),
	                                " to copy path to clipboard"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "O"),
	                                " to open in explorer/finder"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Shift + O"),
	                                " to open in cmd/terminal"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "T"),
	                                " to change .js to .ts"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "J"),
	                                " to change .ts to .js"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "arrow keys"),
	                                " to browse"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "del or backspace"),
	                                " to delete"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "enter"),
	                                " to open file / expand dir"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle },
	                                    commands.modName,
	                                    " + \\"),
	                                " to toggle tree view"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle },
	                                    "Shift + ",
	                                    commands.modName,
	                                    " + \\"),
	                                " to locate open file in view"),
	                            React.createElement("div", { style: helpRowStyle },
	                                "Tap ",
	                                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle },
	                                    " ",
	                                    commands.modName,
	                                    " + 0"),
	                                " to focus on tree view")))),
	            React.createElement(DraggableCore, { onDrag: this.handleDrag, onStop: this.handleDragStop },
	                React.createElement("div", { style: csx.extend(csx.flexRoot, csx.centerCenter, resizerStyle) },
	                    React.createElement(icon_1.Icon, { name: "ellipsis-v" })))));
	    };
	    FileTree.prototype.renderDir = function (item, depth) {
	        if (depth === void 0) { depth = 0; }
	        var expanded = this.state.expansionState[item.filePath];
	        var sub = expanded ? this.renderDirSub(item, depth) : [];
	        var selected = !!this.state.selectedPaths[item.filePath];
	        return ([React.createElement(TreeNode.Dir, { key: item.filePath, ref: item.filePath, item: item, depth: depth, selected: selected, expanded: expanded, handleToggleDir: this.handleToggleDir, activeProjectFilePathTruthTable: this.props.activeProjectFilePathTruthTable })].concat(sub));
	    };
	    FileTree.prototype.renderDirSub = function (item, depth) {
	        var _this = this;
	        return item.subDirs.map(function (item) { return _this.renderDir(item, depth + 1); })
	            .concat(item.files.map(function (file) { return _this.renderFile(file, depth + 1); }));
	    };
	    FileTree.prototype.renderFile = function (item, depth) {
	        var selected = !!this.state.selectedPaths[item.filePath];
	        return (React.createElement(TreeNode.File, { ref: item.filePath, key: item.filePath, item: item, depth: depth, selected: selected, handleSelectFile: this.handleSelectFile, activeProjectFilePathTruthTable: this.props.activeProjectFilePathTruthTable }));
	    };
	    FileTree.prototype.focusOnPath = function (filePath) {
	        if (!this.ref(filePath))
	            return;
	        this.refs['__treeViewScroll'].focus();
	        this.ref(filePath).focus();
	    };
	    FileTree.prototype.componentWillUpdate = function (nextProps, nextState) {
	        if (nextState.width !== this.state.width
	            || nextProps.fileTreeShown !== this.props.fileTreeShown) {
	            appTabsContainer_1.tabState.debouncedResize();
	        }
	    };
	    FileTree = __decorate([
	        react_redux_1.connect(function (state) {
	            return {
	                filePaths: state.filePaths,
	                filePathsCompleted: state.filePathsCompleted,
	                rootDir: state.rootDir,
	                activeProjectFilePathTruthTable: state.activeProjectFilePathTruthTable,
	                fileTreeShown: state.fileTreeShown,
	            };
	        }),
	        __metadata("design:paramtypes", [Object])
	    ], FileTree);
	    return FileTree;
	}(ui_1.BaseComponent));
	exports.FileTree = FileTree;
	var TreeNode;
	(function (TreeNode) {
	    var Dir = /** @class */ (function (_super) {
	        __extends(Dir, _super);
	        function Dir() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        Dir.prototype.focus = function (filePath) {
	            this.refs['root'].scrollIntoViewIfNeeded(false);
	        };
	        Dir.prototype.render = function () {
	            var _this = this;
	            var _a = this.props, item = _a.item, depth = _a.depth, expanded = _a.expanded;
	            var icon = expanded ? 'folder-open' : 'folder';
	            var selectedStyle = this.props.selected ? treeItemSelectedStyle : {};
	            var inProjectStyle = this.props.activeProjectFilePathTruthTable[item.filePath] ? treeItemInProjectStyle : {};
	            return (React.createElement("div", { className: treeItemClassName, style: csx.extend(selectedStyle, inProjectStyle), key: item.filePath, ref: 'root', tabIndex: -1, onClick: function (evt) { return _this.props.handleToggleDir(evt, item); } },
	                React.createElement("div", { style: { marginLeft: depth * 10 } },
	                    " ",
	                    React.createElement(icon_1.Icon, { name: icon }),
	                    " ",
	                    item.name)));
	        };
	        return Dir;
	    }(React.PureComponent));
	    TreeNode.Dir = Dir;
	    /**
	     * File Name Based Icon
	     */
	    var FileNameBasedIcon = /** @class */ (function (_super) {
	        __extends(FileNameBasedIcon, _super);
	        function FileNameBasedIcon() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        FileNameBasedIcon.prototype.render = function () {
	            var fileName = this.props.fileName.toLowerCase();
	            var ext = utils.getExt(fileName);
	            // Default
	            var iconName = 'file-text-o';
	            if (ext == 'md') {
	                iconName = 'book';
	            }
	            else if (ext == 'json') {
	                iconName = 'database';
	            }
	            else if (ext == 'html' || ext == 'htm') {
	                iconName = 'file-code-o';
	            }
	            else if (ext == 'css' || ext == 'less' || ext == 'scss' || ext == 'sass') {
	                iconName = 'css3';
	            }
	            else if (ext.startsWith('git')) {
	                iconName = 'github';
	            }
	            else if (ext.endsWith('sh') || ext == 'bat' || ext == 'batch') {
	                iconName = 'terminal';
	            }
	            else if (ext.endsWith('coffee')) {
	                iconName = 'coffee';
	            }
	            else if (utils.isTs(fileName)) {
	                iconName = 'rocket';
	            }
	            else if (utils.isJs(fileName)) {
	                iconName = 'plane';
	            }
	            else if (utils.isImage(fileName)) {
	                iconName = 'file-image-o';
	            }
	            var icon = React.createElement(icon_1.Icon, { name: iconName });
	            return React.createElement("div", null,
	                icon,
	                " ",
	                this.props.fileName);
	        };
	        return FileNameBasedIcon;
	    }(React.PureComponent));
	    /** Renders the file item */
	    var File = /** @class */ (function (_super) {
	        __extends(File, _super);
	        function File() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        File.prototype.focus = function () {
	            this.refs['root'].scrollIntoViewIfNeeded(false);
	        };
	        File.prototype.render = function () {
	            var _this = this;
	            var filePath = this.props.item.filePath;
	            var selectedStyle = this.props.selected ? treeItemSelectedStyle : {};
	            var inProjectStyle = this.props.activeProjectFilePathTruthTable[filePath] ? treeItemInProjectStyle : {};
	            /** Determine if generated */
	            var isGenerated = false;
	            if (filePath.endsWith('.js')) {
	                var noExtName = utils.removeExt(filePath);
	                if (filePath.endsWith('.js.map'))
	                    noExtName = utils.removeExt(noExtName);
	                var tsName = noExtName + '.ts';
	                var tsxName = noExtName + '.tsx';
	                isGenerated = !!this.props.activeProjectFilePathTruthTable[tsName] || !!this.props.activeProjectFilePathTruthTable[tsxName];
	            }
	            var isGeneratedStyle = isGenerated ? treeItemIsGeneratedStyle : {};
	            return (React.createElement("div", { className: treeItemClassName, style: csx.extend(selectedStyle, inProjectStyle, isGeneratedStyle), ref: 'root', tabIndex: -1, onClick: function (evt) { return _this.props.handleSelectFile(evt, _this.props.item); } },
	                React.createElement("div", { style: { marginLeft: this.props.depth * 10 } },
	                    React.createElement(FileNameBasedIcon, { fileName: this.props.item.name }))));
	        };
	        return File;
	    }(React.PureComponent));
	    TreeNode.File = File;
	})(TreeNode = exports.TreeNode || (exports.TreeNode = {}));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Just renders an image
	 */
	var ui = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var React = __webpack_require__(2);
	var csx = __webpack_require__(6);
	/**
	 * ViewerJS
	 * https://github.com/fengyuanchen/viewerjs
	 */
	var Viewer = __webpack_require__(389);
	__webpack_require__(363);
	__webpack_require__(365);
	var ImageViewer = /** @class */ (function (_super) {
	    __extends(ImageViewer, _super);
	    function ImageViewer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ImageViewer.prototype.componentDidMount = function () {
	        var root = this.refs['img'];
	        var viewer = new Viewer(root, {
	            toolbar: true,
	            inline: true,
	            navbar: false,
	            button: false,
	            movable: false,
	        });
	        this.disposible.add({
	            dispose: function () { return viewer.destroy(); }
	        });
	    };
	    ImageViewer.prototype.render = function () {
	        var filePath = this.props.filePath;
	        return React.createElement("div", { style: csx.extend(csx.flex, csx.centerCenter), onClick: this.props.onClick },
	            React.createElement("img", { ref: "img", style: { opacity: 0 }, src: utils.imageUrl + "/" + filePath }));
	    };
	    return ImageViewer;
	}(ui.BaseComponent));
	exports.ImageViewer = ImageViewer;


/***/ },
/* 402 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * json2tsd.ts
	 * Created by xperiments on 19/04/14.
	 * From https://github.com/xperiments/json2dts/blob/master/src/json2dts.ts
	 * BAS: 1 minor modification
	 */
	var is;
	(function (is) {
	    // Local references to global functions (better minification)
	    var ObjProto = Object.prototype;
	    var ArrayProto = Array.prototype;
	    var toString = ObjProto.toString;
	    var hasOwn = ObjProto.hasOwnProperty;
	    // in case the browser doesn't have it
	    var index_of = (ArrayProto.indexOf ?
	        function (arr, val) { return arr.indexOf(val); } :
	        function (arr, val) {
	            for (var i = 0, l = arr.length; i < l; i++) {
	                if (arr[i] === val) {
	                    return i;
	                }
	            }
	            return -1;
	        });
	    // Primitives - test for type exactness
	    // typeof is faster; see http://jsperf.com/underscore-js-istype-alternatives/7
	    // typeof does not catch values made with a constructor, but is still faster than to String
	    //   see : http://jsperf.com/is-js
	    function string(s) {
	        return (typeof s === 'string') || s instanceof String;
	    }
	    is.string = string;
	    function number(n) { return (typeof n === 'number') || n instanceof Number; }
	    is.number = number;
	    function boolean(b) { return b === !!b || b instanceof Boolean; }
	    is.boolean = boolean;
	    // non-primitive builtin types
	    function fn(f) { return (typeof f === 'function'); }
	    is.fn = fn;
	    ;
	    // array - delegates to builtin if available
	    is.array = Array.isArray || function (a) { return toString.call(a) === '[object Array]'; };
	    // basically all Javascript types are objects
	    function object(o) { return o === Object(o); }
	    is.object = object;
	    ;
	    // duck typing, because there isn't really a good way to do this
	    function regex(r) { return !!(r && r.test && r.exec && (r.ignoreCase || r.ignoreCase === false)); }
	    is.regex = regex;
	    ;
	    // HTML elements
	    is.element = (typeof HTMLElement !== 'undefined' ?
	        function (e) { return (e instanceof HTMLElement); } :
	        // https://github.com/documentcloud/underscore/blob/master/underscore.js#L836-838
	        function (e) { return !!(e && e.nodeType === 1); });
	    // non-strict type checking
	    // http://dl.dropbox.com/u/35146/js/tests/isNumber.html
	    function numeric(n) { return !isNaN(parseFloat(n)) && isFinite(n); }
	    is.numeric = numeric;
	    ;
	    // plain objects - not a specific type, just an object with key/value pairs
	    // https://github.com/jquery/jquery/blob/c14a6b385fa419ce67f115e853fb4a89d8bd8fad/src/core.js#L425-452
	    function hash(o) {
	        // fail fast for falsy/non-object/HTMLElement/window objects
	        // also check constructor properties - objects don't have their own constructor,
	        // and their constructor does not have its own `isPrototypeOf` function
	        if (!o || typeof o !== 'object' || is.element(o) || (typeof window !== 'undefined' && o === window) ||
	            (o.constructor && !hasOwn.call(o, 'constructor') && !hasOwn.call(o.constructor.prototype, 'isPrototypeOf'))) {
	            return false;
	        }
	        // from jQuery source: speed up the test by cycling to the last property,
	        // since own properties are iterated over first and therefore the last one will
	        // indicate the presence of any prototype properties
	        for (var key in o) { }
	        return (key === undefined || hasOwn.call(o, key));
	    }
	    is.hash = hash;
	    ;
	    // test for containment, in both arrays and objects
	    function inside(container, val) {
	        if (is.array(container)) {
	            return index_of(container, val) > -1;
	        }
	        else if (is.object(container)) {
	            for (var prop in container) {
	                if (hasOwn.call(container, prop) && container[prop] === val) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        else {
	            return false;
	        }
	    }
	    is.inside = inside;
	    ;
	    // test for variable being undefined or null
	    function set(v) { return v !== null && v !== (void 0); }
	    is.set = set;
	    ;
	    // test for having any elements (if an array), any properties (if an object), or falsy-ness
	    function empty(container) {
	        if (is.array(container)) {
	            return container.length === 0;
	        }
	        else if (is.object(container)) {
	            // when an object has a valueOf function that doesn't return an object,
	            // object is empty if value is empty
	            if (is.fn(container.valueOf) && !is.object(container.valueOf())) {
	                return is.empty(container.valueOf());
	            }
	            for (var x in container) {
	                if (hasOwn.call(container, x)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        else {
	            return !container;
	        }
	    }
	    is.empty = empty;
	})(is || (is = {}));
	/**
	 *
	 *  Secure Hash Algorithm (SHA1)
	 *  http://www.webtoolkit.info/
	 *
	 **/
	function SHA1(msg) {
	    function rotate_left(n, s) {
	        var t4 = (n << s) | (n >>> (32 - s));
	        return t4;
	    }
	    ;
	    function lsb_hex(val) {
	        var str = "";
	        var i;
	        var vh;
	        var vl;
	        for (i = 0; i <= 6; i += 2) {
	            vh = (val >>> (i * 4 + 4)) & 0x0f;
	            vl = (val >>> (i * 4)) & 0x0f;
	            str += vh.toString(16) + vl.toString(16);
	        }
	        return str;
	    }
	    ;
	    function cvt_hex(val) {
	        var str = "";
	        var i;
	        var v;
	        for (i = 7; i >= 0; i--) {
	            v = (val >>> (i * 4)) & 0x0f;
	            str += v.toString(16);
	        }
	        return str;
	    }
	    ;
	    function Utf8Encode(string) {
	        string = string.replace(/\r\n/g, "\n");
	        var utftext = "";
	        for (var n = 0; n < string.length; n++) {
	            var c = string.charCodeAt(n);
	            if (c < 128) {
	                utftext += String.fromCharCode(c);
	            }
	            else if ((c > 127) && (c < 2048)) {
	                utftext += String.fromCharCode((c >> 6) | 192);
	                utftext += String.fromCharCode((c & 63) | 128);
	            }
	            else {
	                utftext += String.fromCharCode((c >> 12) | 224);
	                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
	                utftext += String.fromCharCode((c & 63) | 128);
	            }
	        }
	        return utftext;
	    }
	    ;
	    var blockstart;
	    var i, j;
	    var W = new Array(80);
	    var H0 = 0x67452301;
	    var H1 = 0xEFCDAB89;
	    var H2 = 0x98BADCFE;
	    var H3 = 0x10325476;
	    var H4 = 0xC3D2E1F0;
	    var A, B, C, D, E;
	    var temp;
	    msg = Utf8Encode(msg);
	    var msg_len = msg.length;
	    var word_array = new Array();
	    for (i = 0; i < msg_len - 3; i += 4) {
	        j = msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 |
	            msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3);
	        word_array.push(j);
	    }
	    switch (msg_len % 4) {
	        case 0:
	            i = 0x080000000;
	            break;
	        case 1:
	            i = msg.charCodeAt(msg_len - 1) << 24 | 0x0800000;
	            break;
	        case 2:
	            i = msg.charCodeAt(msg_len - 2) << 24 | msg.charCodeAt(msg_len - 1) << 16 | 0x08000;
	            break;
	        case 3:
	            i = msg.charCodeAt(msg_len - 3) << 24 | msg.charCodeAt(msg_len - 2) << 16 | msg.charCodeAt(msg_len - 1) << 8 | 0x80;
	            break;
	    }
	    word_array.push(i);
	    while ((word_array.length % 16) != 14)
	        word_array.push(0);
	    word_array.push(msg_len >>> 29);
	    word_array.push((msg_len << 3) & 0x0ffffffff);
	    for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
	        for (i = 0; i < 16; i++)
	            W[i] = word_array[blockstart + i];
	        for (i = 16; i <= 79; i++)
	            W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
	        A = H0;
	        B = H1;
	        C = H2;
	        D = H3;
	        E = H4;
	        for (i = 0; i <= 19; i++) {
	            temp = (rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5A827999) & 0x0ffffffff;
	            E = D;
	            D = C;
	            C = rotate_left(B, 30);
	            B = A;
	            A = temp;
	        }
	        for (i = 20; i <= 39; i++) {
	            temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1) & 0x0ffffffff;
	            E = D;
	            D = C;
	            C = rotate_left(B, 30);
	            B = A;
	            A = temp;
	        }
	        for (i = 40; i <= 59; i++) {
	            temp = (rotate_left(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8F1BBCDC) & 0x0ffffffff;
	            E = D;
	            D = C;
	            C = rotate_left(B, 30);
	            B = A;
	            A = temp;
	        }
	        for (i = 60; i <= 79; i++) {
	            temp = (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6) & 0x0ffffffff;
	            E = D;
	            D = C;
	            C = rotate_left(B, 30);
	            B = A;
	            A = temp;
	        }
	        H0 = (H0 + A) & 0x0ffffffff;
	        H1 = (H1 + B) & 0x0ffffffff;
	        H2 = (H2 + C) & 0x0ffffffff;
	        H3 = (H3 + D) & 0x0ffffffff;
	        H4 = (H4 + E) & 0x0ffffffff;
	    }
	    var temp2 = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);
	    return temp2.toLowerCase();
	}
	var Types = /** @class */ (function () {
	    function Types() {
	    }
	    Types.STRING = 'string';
	    Types.NUMBER = 'number';
	    Types.BOOLEAN = 'boolean';
	    Types.ARRAY = '[]';
	    return Types;
	}());
	exports.Types = Types;
	var Json2dts = /** @class */ (function () {
	    function Json2dts() {
	        this.is_value_consistent = function (o) {
	            var _this = this;
	            if (this.size(o) == 0) {
	                return true;
	            }
	            else {
	                if (!is.array(o)) {
	                    o = this.values(o);
	                }
	                var n = o[0];
	                var nn = (is.object(n) ? this.generate_signature(n) : typeof n);
	                return Object.keys(o).every(function (key) {
	                    return (is.object(o[key]) ? _this.generate_signature(o[key]) : typeof o[key]) == nn;
	                });
	            }
	        };
	    }
	    Json2dts.prototype.parse = function (obj, objectName, moduleName) {
	        if (objectName === void 0) { objectName = "_RootInterface"; }
	        if (moduleName === void 0) { moduleName = ""; }
	        this.moduleName = moduleName;
	        this.classes = {};
	        this.classesCache = {};
	        this.classesInUse = {};
	        this.analyse_object(obj, objectName);
	        return this.classes;
	    };
	    Json2dts.prototype.getCode = function () {
	        var _this = this;
	        var output;
	        var classes = {};
	        var outputModule = this.moduleName == "" ? false : true;
	        var interfaceTab = outputModule ? "\t" : "";
	        var propertyTab = interfaceTab + "\t";
	        Object.keys(this.classes).map(function (clsName) {
	            output = interfaceTab + "interface " + clsName + '\n' + interfaceTab + '{\n';
	            Object.keys(_this.classes[clsName]).map(function (key) {
	                /** BAS: added a space `:` => `: ` */
	                output += propertyTab + key + ': ' + _this.classes[clsName][key] + ';\n';
	            });
	            output += interfaceTab + '}\n\n';
	            classes[clsName] = output;
	        });
	        output = outputModule ? "module " + this.moduleName + "\n{\n" : "";
	        Object.keys(classes).sort().forEach(function (key) { output += classes[key]; });
	        return output + (outputModule ? "\n}" : "");
	    };
	    Json2dts.prototype.analyse_object = function (obj, objectName) {
	        var _this = this;
	        if (objectName === void 0) { objectName = "json"; }
	        // determine object name
	        objectName = this.getInterfaceType(objectName, obj);
	        // initialize named class object
	        this.classes[objectName] = this.classes[objectName] || {};
	        // loops over all object properties and
	        // determines each property type
	        Object.keys(obj).map(function (key) {
	            var type = "string";
	            var sha = "";
	            var value = obj[key];
	            switch (true) {
	                case is.string(value):
	                    type = Types.STRING;
	                    break;
	                case is.number(value):
	                    type = Types.NUMBER;
	                    break;
	                case is.boolean(value):
	                    type = Types.BOOLEAN;
	                    break;
	                case is.array(value):
	                    // default typed array
	                    type = "any[]";
	                    // if value is consisten over
	                    // all items of the array
	                    if (_this.is_value_consistent(value)) {
	                        // is an empty array
	                        if (_this.size(value) == 0) {
	                            type = "any[]"; // EMPTY ARRAY
	                        }
	                        else {
	                            // consistent value is an object?
	                            if (is.object(value[0])) {
	                                type = _this.getInterfaceType(key, value[0]) + '[]';
	                                _this.analyse_object(value[0], key);
	                            }
	                            else {
	                                type = _this.getBasicType(value[0]) + '[]';
	                            }
	                        }
	                    }
	                    break;
	                case is.object(value) && !is.array(value):
	                    // default object type
	                    type = "any";
	                    // if object is not empty
	                    // set as current type and process it
	                    if (!is.empty(value)) {
	                        type = _this.getInterfaceType(key, value);
	                        _this.analyse_object(value, key);
	                    }
	                    break;
	            }
	            // if key has any special char, quote it.
	            if (_this.hasSpecialChars((key))) {
	                key = '\"' + key + '\"';
	            }
	            _this.classes[objectName][key] = type;
	        });
	    };
	    Json2dts.prototype.objectParser = function (key) {
	    };
	    Json2dts.prototype.getBasicType = function (value) {
	        var type = Types.STRING;
	        switch (true) {
	            case is.string(value):
	                type = Types.STRING;
	                break;
	            case is.number(value):
	                type = Types.NUMBER;
	                break;
	            case is.boolean(value):
	                type = Types.BOOLEAN;
	                break;
	        }
	        return type;
	    };
	    Json2dts.prototype.getInterfaceType = function (key, value) {
	        // get a valid className
	        key = key.replace(/_/gi, ' ').replace(/-/gi, ' ').replace(/\w\S*/g, function (txt) {
	            return txt.charAt(0).toUpperCase() + txt.substr(1);
	        }).replace(/ /gi, '');
	        // check if a definition exist for the current Interface signature
	        var currentObjectSignature = this.generate_signature(value);
	        var isKnownClass = Object.keys(this.classesCache).indexOf(currentObjectSignature) != -1;
	        // its a know type, return it
	        if (isKnownClass)
	            return this.classesCache[currentObjectSignature];
	        // current type name is already used by other Interface
	        if (this.classesInUse[key] != undefined) {
	            // update key count
	            this.classesInUse[key]++;
	            // initialize Interface Name Object
	            this.classesCache[currentObjectSignature] = key + this.classesInUse[key];
	            return this.classesCache[currentObjectSignature];
	        }
	        // current Interface Name was never used
	        this.classesCache[currentObjectSignature] = key;
	        this.classesInUse[key] = 0;
	        return key;
	    };
	    Json2dts.prototype.size = function (obj) {
	        if (obj == null)
	            return 0;
	        return (obj.length === +obj.length) ? obj.length : Object.keys(obj).length;
	    };
	    Json2dts.prototype.values = function (obj) {
	        return Object.keys(obj).map(function (key) { return obj[key]; });
	    };
	    Json2dts.prototype.generate_signature = function (o) {
	        if (is.object(o)) {
	            return SHA1(Object.keys(o).map(function (n) {
	                return n.toLowerCase();
	            }).sort().join('|'));
	        }
	        else {
	            return SHA1(Object.keys(o).map(function (n) {
	                return typeof n;
	            }).sort().join('|'));
	        }
	    };
	    Json2dts.prototype.hasSpecialChars = function (str) {
	        return /[ ~`!#$%\^&*+=\-\[\]\\';,\/{}|\\":<>\?]/g.test(str);
	    };
	    Json2dts.prototype.keysrt = function (key, desc) {
	        if (desc === void 0) { desc = false; }
	        return function (a, b) {
	            return desc ? ~~(a[key] < b[key]) : ~~(a[key] > b[key]);
	        };
	    };
	    return Json2dts;
	}());
	exports.Json2dts = Json2dts;
	function extractLineFeeds(s) {
	    return s.replace(/[^\n]+/g, '');
	}
	function toValidJSON(input, keepLineNumbers) {
	    if (keepLineNumbers === void 0) { keepLineNumbers = false; }
	    var UNESCAPE_MAP = { '\\"': '"', "\\`": "`", "\\'": "'" };
	    var ML_ESCAPE_MAP = { '\n': '\\n', "\r": '\\r', "\t": '\\t', '"': '\\"' };
	    function unescapeQuotes(r) { return UNESCAPE_MAP[r] || r; }
	    return input.replace(/`(?:\\.|[^`])*`|'(?:\\.|[^'])*'|"(?:\\.|[^"])*"|\/\*[^]*?\*\/|\/\/.*\n?/g, // pass 1: remove comments
	    function (s) {
	        if (s.charAt(0) == '/') {
	            return keepLineNumbers ? extractLineFeeds(s) : '';
	        }
	        else {
	            return s;
	        }
	    })
	        .replace(/(?:true|false|null)(?=[^\w_$]|$)|([a-zA-Z_$][\w_$]*)|`((?:\\.|[^`])*)`|'((?:\\.|[^'])*)'|"(?:\\.|[^"])*"|(,)(?=\s*[}\]])/g, // pass 2: requote
	    function (s, identifier, multilineQuote, singleQuote, lonelyComma) {
	        if (lonelyComma) {
	            return '';
	        }
	        else if (identifier != null) {
	            return '"' + identifier + '"';
	        }
	        else if (multilineQuote != null) {
	            return '"' + multilineQuote.replace(/\\./g, unescapeQuotes).replace(/[\n\r\t"]/g, function (r) { return ML_ESCAPE_MAP[r]; }) +
	                '"' + (keepLineNumbers ? extractLineFeeds(multilineQuote) : '');
	        }
	        else if (singleQuote != null) {
	            return '"' + singleQuote.replace(/\\./g, unescapeQuotes).replace(/"/g, '\\"') + '"';
	        }
	        else {
	            return s;
	        }
	    });
	}
	exports.toValidJSON = toValidJSON;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	window.monacoReady = function () {
	    __webpack_require__(466);
	};


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var React = __webpack_require__(2);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var ui = __webpack_require__(1);
	var commands = __webpack_require__(7);
	var types = __webpack_require__(23);
	var clipboard_1 = __webpack_require__(50);
	var icon_1 = __webpack_require__(31);
	var buttons_1 = __webpack_require__(82);
	var inputs_1 = __webpack_require__(396);
	var DraggableCore = ui.DraggableCore;
	var react_redux_1 = __webpack_require__(29);
	var state_1 = __webpack_require__(11);
	var state = __webpack_require__(11);
	var gotoHistory = __webpack_require__(156);
	var appTabsContainer_1 = __webpack_require__(26);
	var settings = __webpack_require__(88);
	var globalErrorCacheClient_1 = __webpack_require__(35);
	var notificationKeyboardStyle = {
	    border: '2px solid',
	    borderRadius: '6px',
	    display: 'inline-block',
	    padding: '5px',
	    background: 'grey',
	};
	var resizerWidth = 5;
	var resizerStyle = {
	    background: 'radial-gradient(#444,transparent)',
	    height: resizerWidth + 'px',
	    cursor: 'ns-resize',
	    color: '#666',
	};
	var MainPanel = /** @class */ (function (_super) {
	    __extends(MainPanel, _super);
	    function MainPanel(props) {
	        var _this = _super.call(this, props) || this;
	        _this.toggleErrors = function () {
	            if (_this.props.errorsExpanded) {
	                state_1.collapseErrors({});
	            }
	            else {
	                state_1.expandErrors({});
	            }
	        };
	        _this.openErrorLocation = function (error) {
	            gotoHistory.gotoError(error);
	        };
	        _this.openFile = function (filePath) {
	            commands.doOpenOrFocusFile.emit({ filePath: filePath });
	        };
	        _this.handleDrag = function (evt, ui) {
	            _this.setState({ height: utils.rangeLimited({ num: _this.state.height - ui.deltaY, min: 100, max: window.innerHeight - 100 }) });
	        };
	        _this.handleStop = function () {
	            var height = _this.state.height;
	            settings.mainPanelHeight.set(height);
	        };
	        _this.state = {
	            height: 250,
	        };
	        return _this;
	    }
	    MainPanel.prototype.componentDidMount = function () {
	        var _this = this;
	        settings.mainPanelHeight.get().then(function (res) {
	            var height = res || _this.state.height;
	            height = Math.min(window.innerHeight - 100, height);
	            _this.setState({ height: height });
	        });
	        this.disposible.add(commands.toggleMessagePanel.on(function () {
	            state.getState().errorsExpanded ? state.collapseErrors({}) : state.expandErrors({});
	        }));
	        this.disposible.add(appTabsContainer_1.tabStateChanged.on(function () {
	            _this.forceUpdate();
	        }));
	        this.disposible.add(globalErrorCacheClient_1.errorsCache.errorsDelta.on(function () {
	            _this.forceUpdate();
	        }));
	    };
	    MainPanel.prototype.render = function () {
	        var errorsUpdate = globalErrorCacheClient_1.errorsCache.getErrorsLimited();
	        var errorPanel = undefined;
	        if (this.props.errorsExpanded) {
	            errorPanel = React.createElement("div", null,
	                React.createElement(DraggableCore, { onDrag: this.handleDrag, onStop: this.handleStop },
	                    React.createElement("div", { style: csx.extend(csx.flexRoot, csx.centerCenter, resizerStyle) },
	                        React.createElement(icon_1.Icon, { name: "ellipsis-h" }))),
	                React.createElement("div", { style: csx.extend(styles.errorsPanel.main, { height: this.state.height }) },
	                    React.createElement("div", { style: styles.errorsPanel.headerSection },
	                        React.createElement("div", { style: csx.horizontal },
	                            React.createElement("div", { style: csx.extend(csx.horizontal, csx.flex, csx.center, { marginRight: '10px' }) },
	                                React.createElement(buttons_1.ButtonBlack, { text: "Show All", onClick: function () { return state.setErrorsDisplayMode(types.ErrorsDisplayMode.all); }, isActive: this.props.errorsDisplayMode == types.ErrorsDisplayMode.all }),
	                                React.createElement(buttons_1.ButtonBlack, { text: "Show Only Open Files", onClick: function () { return state.setErrorsDisplayMode(types.ErrorsDisplayMode.openFiles); }, isActive: this.props.errorsDisplayMode == types.ErrorsDisplayMode.openFiles }),
	                                React.createElement("label", { style: { marginLeft: '10px' } }, "Filter:"),
	                                React.createElement(inputs_1.InputBlack, { style: { marginRight: '10px', maxWidth: '200px' }, onChange: function (value) { return state.setErrorsFilter(value); }, value: this.props.errorsFilter }),
	                                React.createElement(buttons_1.ButtonBlack, { text: "Clear", disabled: !this.props.errorsFilter.trim(), onClick: function () { return state.setErrorsFilter(''); } })),
	                            errorsUpdate.tooMany
	                                && React.createElement("div", { style: styles.errorsPanel.tooMany, className: "hint--bottom-left hint--info", "data-hint": "We only sync the top 50 per file with a limit of 250. That ensures that live linting doesn't slow anything else down." },
	                                    errorsUpdate.totalCount,
	                                    " total. Showing top ",
	                                    errorsUpdate.syncCount,
	                                    "."))),
	                    errorsUpdate.totalCount
	                        ? this.renderErrors()
	                        : React.createElement("div", { style: styles.errorsPanel.success }, "No Errors \u2764")));
	        }
	        return (React.createElement("div", { style: { zIndex: 6 /* force over golden-layout */ } }, errorPanel));
	    };
	    MainPanel.prototype.renderErrors = function () {
	        var errorsToRender = appTabsContainer_1.tabState.errorsByFilePathFiltered().errorsByFilePath;
	        return (React.createElement("div", { style: { overflow: 'auto' } }, Object.keys(errorsToRender)
	            .filter(function (filePath) { return !!errorsToRender[filePath].length; })
	            .map(function (filePath, i) {
	            var errors = errorsToRender[filePath];
	            return React.createElement(ErrorRenders.ErrorsForFilePath, { key: i, errors: errors, filePath: filePath });
	        })));
	    };
	    MainPanel.prototype.componentWillUpdate = function (nextProps, nextState) {
	        if (nextState.height !== this.state.height
	            || nextProps.errorsExpanded !== this.props.errorsExpanded) {
	            appTabsContainer_1.tabState.debouncedResize();
	        }
	    };
	    MainPanel = __decorate([
	        react_redux_1.connect(function (state) {
	            return {
	                errorsExpanded: state.errorsExpanded,
	                activeProject: state.activeProject,
	                activeProjectFiles: state.activeProjectFilePathTruthTable,
	                socketConnected: state.socketConnected,
	                errorsDisplayMode: state.errorsDisplayMode,
	                errorsFilter: state.errorsFilter,
	            };
	        }),
	        __metadata("design:paramtypes", [Object])
	    ], MainPanel);
	    return MainPanel;
	}(ui_1.BaseComponent));
	exports.MainPanel = MainPanel;
	/**
	 * Pure components for rendering errors
	 */
	var ErrorRenders;
	(function (ErrorRenders) {
	    var openErrorLocation = function (error) {
	        gotoHistory.gotoError(error);
	    };
	    var ErrorsForFilePath = /** @class */ (function (_super) {
	        __extends(ErrorsForFilePath, _super);
	        function ErrorsForFilePath() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        ErrorsForFilePath.prototype.render = function () {
	            var _this = this;
	            var codeErrors = this.props.errors;
	            var errors = codeErrors.filter(function (x) { return x.level === 'error'; });
	            var warnings = codeErrors.filter(function (x) { return x.level === 'warning'; });
	            var errorsRendered = 
	            // error before warning
	            errors.concat(warnings)
	                .map(function (e, j) { return (React.createElement(SingleError, { key: "" + j, error: e })); });
	            return React.createElement("div", null,
	                React.createElement("div", { style: styles.errorsPanel.filePath, onClick: function () { return openErrorLocation(_this.props.errors[0]); } },
	                    React.createElement(icon_1.Icon, { name: "file-code-o", style: { fontSize: '.8rem' } }),
	                    "\u00A0",
	                    this.props.filePath,
	                    "(",
	                    !!errors.length && React.createElement("span", { style: { color: styles.errorColor } }, errors.length),
	                    !!(errors.length && warnings.length) && ',',
	                    !!warnings.length && React.createElement("span", { style: { color: styles.warningColor } }, warnings.length),
	                    ")"),
	                React.createElement("div", { style: styles.errorsPanel.perFileList }, errorsRendered));
	        };
	        return ErrorsForFilePath;
	    }(React.PureComponent));
	    ErrorRenders.ErrorsForFilePath = ErrorsForFilePath;
	    var SingleError = /** @class */ (function (_super) {
	        __extends(SingleError, _super);
	        function SingleError() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        SingleError.prototype.render = function () {
	            var e = this.props.error;
	            var style = e.level === 'error'
	                ? styles.errorsPanel.errorDetailsContainer
	                : styles.errorsPanel.warningDetailsContainer;
	            return (React.createElement("div", { style: style, onClick: function () { return openErrorLocation(e); } },
	                React.createElement("div", { style: styles.errorsPanel.errorDetailsContent },
	                    React.createElement("div", { style: styles.errorsPanel.errorMessage },
	                        "\uD83D\uDC1B(",
	                        e.from.line + 1,
	                        ": ",
	                        e.from.ch + 1,
	                        ") ",
	                        e.message,
	                        ' ',
	                        React.createElement(clipboard_1.Clipboard, { text: e.filePath + ":" + (e.from.line + 1) + " " + e.message })),
	                    e.preview ? React.createElement("div", { style: styles.errorsPanel.errorPreview }, e.preview) : '')));
	        };
	        return SingleError;
	    }(React.PureComponent));
	    ErrorRenders.SingleError = SingleError;
	})(ErrorRenders || (ErrorRenders = {}));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var marked = __webpack_require__(240);
	var escapeHtml = __webpack_require__(202);
	/**
	 * Our CSS file
	 */
	__webpack_require__(367);
	/**
	 * Renders markdown
	 */
	var MarkDown = /** @class */ (function (_super) {
	    __extends(MarkDown, _super);
	    function MarkDown(props) {
	        return _super.call(this, props) || this;
	    }
	    MarkDown.prototype.render = function () {
	        var rendered = toHtml(this.props.markdown);
	        return (React.createElement("div", { dangerouslySetInnerHTML: { __html: rendered } }));
	    };
	    return MarkDown;
	}(React.PureComponent));
	exports.MarkDown = MarkDown;
	/** Converts an html string to markdown */
	function toHtml(markdown) {
	    return ("<div class=\"alm-markdown-root\"> " + marked(escapeHtml(markdown))
	        .replace(/a href=/g, "a target='_blank' href=")
	        .trim()
	        .replace(/\n/g, '<br/>') + "</div>");
	}
	exports.toHtml = toHtml;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var onresize = __webpack_require__(105);
	var utils = __webpack_require__(3);
	var events_1 = __webpack_require__(19);
	var Blaster = /** @class */ (function () {
	    function Blaster(cm) {
	        var _this = this;
	        this.cm = cm;
	        this.disposible = new events_1.CompositeDisposible();
	        this.detached = false;
	        this.canvas = null;
	        this.ctx = null;
	        this.initCanvas = function () {
	            var cm = _this.cm;
	            _this.canvas = document.createElement('canvas');
	            cm.getDomNode().parentElement.appendChild(_this.canvas);
	            _this.ctx = _this.canvas.getContext('2d');
	            _this.canvas.style.position = 'absolute';
	            _this.canvas.style.top = "0";
	            _this.canvas.style.left = "0";
	            _this.canvas.style.bottom = "0";
	            _this.canvas.style.right = "0";
	            _this.canvas.style.zIndex = '1';
	            _this.canvas.style.pointerEvents = 'none';
	            var measureCanvas = function () {
	                var parent = cm.getDomNode();
	                _this.canvas.width = parent.clientWidth;
	                _this.canvas.height = parent.clientHeight;
	            };
	            _this.disposible.add(onresize.on(measureCanvas));
	            cm.layout = utils.intercepted({ context: cm, orig: cm.layout, intercept: measureCanvas });
	            measureCanvas();
	        };
	        this.loop = function () {
	            // If unmounted stop
	            if (_this.detached)
	                return;
	            // Setup for next loop
	            requestAnimationFrame(_this.loop);
	            _this.ctx.clearRect(0, 0, _this.canvas.width, _this.canvas.height);
	            _this.drawParticles();
	        };
	        this.particles = [];
	        this.drawParticles = function (timeDelta) {
	            // return if no particles
	            if (!_this.particles.length)
	                return;
	            // animate the particles
	            for (var _i = 0, _a = _this.particles; _i < _a.length; _i++) {
	                var particle = _a[_i];
	                if (particle.effect === Effect.Add) {
	                    _this.effect1(particle);
	                }
	                else if (particle.effect === Effect.Delete) {
	                    _this.effect2(particle);
	                }
	            }
	            // clear out the particles that are no longer relevant post animation
	            _this.particles = _this.particles.filter(function (particle) { return particle && particle.alpha > 0.01 && particle.size > 0.5; });
	        };
	        this.PARTICLE_GRAVITY = 0.08;
	        this.PARTICLE_ALPHA_FADEOUT = 0.96;
	        // spawn particles
	        this.PARTICLE_NUM_RANGE = { min: 5, max: 10 };
	        this.throttledSpawnParticles = utils.throttle(function (effect) {
	            var editor = _this.cm;
	            var cursorPos = editor.getPosition();
	            /** The position relative to dom node of editor */
	            var pos = editor.getScrolledVisiblePosition(cursorPos);
	            /** Get the color for the dom token */
	            var editorNode = editor.getDomNode();
	            var editorNodeRect = editorNode.getBoundingClientRect();
	            var posForNode = {
	                x: editorNodeRect.left + pos.left,
	                y: editorNodeRect.top + pos.top,
	            };
	            var node = document.elementFromPoint(posForNode.x - 5, posForNode.y + 5);
	            var color = getRGBComponents(node);
	            // Now create the particles
	            var numParticles = random(_this.PARTICLE_NUM_RANGE.min, _this.PARTICLE_NUM_RANGE.max);
	            for (var i = 0; i < numParticles; i++) {
	                _this.particles.push(_this.createParticle(pos.left + 15, pos.top - 5, color, effect));
	            }
	        }, 100);
	        this.PARTICLE_VELOCITY_RANGE = {
	            x: [-1, 1],
	            y: [-3.5, -1.5]
	        };
	        this.handleChange = function (change) {
	            // setup particles
	            if (change.text) {
	                _this.throttledSpawnParticles(Effect.Add);
	            }
	            else {
	                _this.throttledSpawnParticles(Effect.Delete);
	            }
	        };
	        this.disposible.add(cm.onDidChangeModelContent(this.handleChange));
	        this.initCanvas();
	        this.loop();
	    }
	    Blaster.prototype.dispose = function () {
	        this.detached = true;
	        this.disposible.dispose();
	    };
	    Blaster.prototype.effect1 = function (particle) {
	        particle.vy += this.PARTICLE_GRAVITY;
	        particle.x += particle.vx;
	        particle.y += particle.vy;
	        particle.alpha *= this.PARTICLE_ALPHA_FADEOUT;
	        this.ctx.fillStyle = 'rgba(' + particle.color[0] + ',' + particle.color[1] + ',' + particle.color[2] + ',' + particle.alpha + ')';
	        this.ctx.fillRect(Math.round(particle.x - 1), Math.round(particle.y - 1), particle.size, particle.size);
	    };
	    // Effect based on Soulwire's demo: http://codepen.io/soulwire/pen/foktm
	    Blaster.prototype.effect2 = function (particle) {
	        particle.x += particle.vx;
	        particle.y += particle.vy;
	        particle.vx *= particle.drag;
	        particle.vy *= particle.drag;
	        particle.theta += random(-0.5, 0.5);
	        particle.vx += Math.sin(particle.theta) * 0.1;
	        particle.vy += Math.cos(particle.theta) * 0.1;
	        particle.size *= 0.96;
	        this.ctx.fillStyle = 'rgba(' + particle.color[0] + ',' + particle.color[1] + ',' + particle.color[2] + ',' + particle.alpha + ')';
	        this.ctx.beginPath();
	        this.ctx.arc(particle.x - particle.size / 2, particle.y - particle.size / 2, particle.size, 0, 2 * Math.PI);
	        this.ctx.fill();
	    };
	    Blaster.prototype.createParticle = function (x, y, color, effect) {
	        var p = {
	            x: x,
	            y: y + 10,
	            alpha: 1,
	            color: color,
	            effect: effect,
	            // modifed below
	            drag: 0,
	            wander: 0,
	            theta: 0,
	            size: 0,
	            vx: 0,
	            vy: 0,
	        };
	        if (effect == Effect.Add) {
	            p.size = random(2, 4);
	            p.vx = this.PARTICLE_VELOCITY_RANGE.x[0] + Math.random() *
	                (this.PARTICLE_VELOCITY_RANGE.x[1] - this.PARTICLE_VELOCITY_RANGE.x[0]);
	            p.vy = this.PARTICLE_VELOCITY_RANGE.y[0] + Math.random() *
	                (this.PARTICLE_VELOCITY_RANGE.y[1] - this.PARTICLE_VELOCITY_RANGE.y[0]);
	        }
	        else if (effect == Effect.Delete) {
	            p.size = random(2, 8);
	            p.drag = 0.92;
	            p.vx = random(-3, 3);
	            p.vy = random(-3, 3);
	            p.wander = 0.15;
	            p.theta = random(0, 360) * Math.PI / 180;
	        }
	        return p;
	    };
	    return Blaster;
	}());
	exports.Blaster = Blaster;
	/**
	 * General Utilities
	 */
	var Effect;
	(function (Effect) {
	    Effect[Effect["Add"] = 1] = "Add";
	    Effect[Effect["Delete"] = 2] = "Delete";
	})(Effect || (Effect = {}));
	/** Get a random number in the min-max range, inclusive */
	function random(min, max) {
	    if (!max) {
	        max = min;
	        min = 0;
	    }
	    return min + ~~(Math.random() * (max - min + 1));
	}
	/** Get the colors of the html node */
	function getRGBComponents(node) {
	    if (node) {
	        try {
	            var color = getComputedStyle(node).color;
	            return color.match(/(\d+), (\d+), (\d+)/).slice(1);
	        }
	        catch (e) {
	            return ['255', '255', '255'];
	        }
	    }
	    else {
	        return ['255', '255', '255'];
	    }
	}
	/**
	 * Registering it with monaco
	 */
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var ToggleBlasterAction = /** @class */ (function (_super) {
	    __extends(ToggleBlasterAction, _super);
	    function ToggleBlasterAction() {
	        var _this = _super.call(this, {
	            id: 'editor.action.toggleBlaster',
	            label: 'Toggle Blaster',
	            alias: 'Toggle Blaster',
	            precondition: EditorContextKeys.Writable,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.CtrlCmd | KeyMod.Alt | KeyCode.KEY_O
	            }
	        }) || this;
	        _this.blaster = null;
	        return _this;
	    }
	    ToggleBlasterAction.prototype.run = function (accessor, editor) {
	        if (!this.blaster) {
	            this.blaster = new Blaster(editor);
	            ui.notifySuccessNormalDisappear('Have fun 🌹!');
	        }
	        else {
	            this.blaster.dispose();
	            this.blaster = null;
	            ui.notifyInfoQuickDisappear('Hope you had fun 💖');
	        }
	    };
	    return ToggleBlasterAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new ToggleBlasterAction());


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var monacoUtils = __webpack_require__(18);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var EditorContextKeys = monaco.EditorContextKeys;
	/* Test:
	const styles = {
	  box-sizing: border-box;
	  outline: none;
	  padding: 0;
	  margin: 0;
	}
	*/
	var CssToTsAction = /** @class */ (function (_super) {
	    __extends(CssToTsAction, _super);
	    function CssToTsAction() {
	        return _super.call(this, {
	            id: 'editor.action.cssToTs',
	            label: 'CSS to TS',
	            alias: 'CSS to TS',
	            precondition: EditorContextKeys.Writable,
	        }) || this;
	    }
	    CssToTsAction.prototype.run = function (accessor, editor) {
	        var filePath = editor.filePath;
	        var selection = editor.getSelection();
	        if (!selection.isEmpty()) {
	            var oldText = editor.getModel().getValueInRange(selection);
	            var _a = convert(oldText), asLines = _a.asLines, asString = _a.asString;
	            // put in the new thing
	            monacoUtils.replaceSelection({ editor: editor, newText: asString });
	            // format the new thing
	            monacoUtils.format({ editor: editor });
	        }
	        else {
	            ui.notifyWarningNormalDisappear('Please select the CSS you want converted to TS and try again 🌹');
	        }
	    };
	    return CssToTsAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new CssToTsAction());
	/**
	 * Take a look at :
	 * https://github.com/reactjs/react-magic
	 * https://www.npmjs.com/package/htmltojsx
	 */
	var htmlToJsx_1 = __webpack_require__(157);
	function convert(content) {
	    var style = new htmlToJsx_1.StyleParser(content);
	    var asLines = style.toJSXString().split(',').map(function (x) { return x.trim(); });
	    var asString = asLines.join(',\n');
	    return { asLines: asLines, asString: asString };
	}
	exports.convert = convert;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Note: a lot of the *on enter* docblocking is done by the `richLanguageConfiguration` `onEnterRules`.
	 *
	 * Here we mostly only implement the `snippets`
	 */
	var events_1 = __webpack_require__(19);
	/**
	 * Note: the order of the snippets is important
	 */
	var snippets = {
	    '////': "//////////////////////\n// {{}}\n//////////////////////",
	    '///': "/**\n * {{}}\n */",
	    '//': "/** {{}} */",
	};
	function setup(editor) {
	    // if (editor) return { dispose: () => null }; // DEBUG : while the feature isn't complete used to disable it
	    var disposible = new events_1.CompositeDisposible();
	    disposible.add(editor.onKeyDown(function (e) {
	        if (e.keyCode === monaco.KeyCode.Tab) {
	            var position = editor.getPosition();
	            var contents = editor.getModel().getLineContent(position.lineNumber).substr(0, position.column - 1);
	            var matchers = Object.keys(snippets);
	            for (var _i = 0, matchers_1 = matchers; _i < matchers_1.length; _i++) {
	                var snippetKey = matchers_1[_i];
	                if (contents.endsWith(snippetKey)) {
	                    e.preventDefault();
	                    e.stopPropagation();
	                    /** Insert the snippet */
	                    var codeSnippet = monaco.CodeSnippet.fromInternal(snippets[snippetKey]);
	                    var overwriteBefore = snippetKey.length;
	                    var overwriteAfter = 0;
	                    monaco.SnippetController.get(editor).run(codeSnippet, overwriteBefore, overwriteAfter, true);
	                    // Don't run any other snippets :)
	                    return;
	                }
	            }
	        }
	        return;
	    }));
	    return disposible;
	}
	exports.setup = setup;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * We thought a lot out how to expose *inline* information.
	 * There was no sane way of having that without keyboard shortcut or dialog overload
	 * We we have `docu`, the single point of useful inforation but only at the cursor location
	 */
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var state = __webpack_require__(11);
	var react_redux_1 = __webpack_require__(29);
	var clipboard = __webpack_require__(50);
	var utils = __webpack_require__(3);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var monacoUtils = __webpack_require__(18);
	var globalErrorCacheClient_1 = __webpack_require__(35);
	var typestyle = __webpack_require__(13);
	var docuClassName = typestyle.style(csx.newLayer, {
	    zIndex: 1,
	    color: '#DDD',
	    padding: '5px',
	    background: '#343333',
	    fontSize: '.8rem',
	    // Place to the right
	    right: '0px',
	    left: 'inherit',
	    // margin on all side to clear CM scroll bars and look good in general
	    margin: '12px',
	    // Overflow y and break in x
	    overflowY: 'auto',
	    wordWrap: 'break-word',
	    // Don't let it get too big
	    width: '30%',
	    maxWidth: '400px',
	    minWidth: '200px',
	    height: '30%',
	    maxHeight: '400px',
	    minHeight: '100px',
	    opacity: 0.7,
	    transition: 'opacity .2s',
	    $nest: {
	        '&:hover': {
	            opacity: 1
	        }
	    }
	});
	var docuOnTopStyle = {
	    top: '0px',
	    bottom: 'inherit'
	};
	var docuOnBottomStyle = {
	    top: 'inherit',
	    bottom: '0px'
	};
	var doctorRow = csx.extend({
	    paddingTop: '3px',
	    paddingBottom: '3px',
	    whiteSpace: 'pre',
	    flexShrink: '0'
	}, csx.flexRoot, csx.center, csx.wrap);
	var fileLinkStyle = {
	    textDecoration: 'underline',
	    cursor: 'pointer',
	    fontFamily: 'monospace',
	    margin: '0px 3px',
	};
	var Doctor = /** @class */ (function (_super) {
	    __extends(Doctor, _super);
	    function Doctor(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleCursorActivity = function () {
	            var cm = _this.props.cm;
	            if (!cm)
	                return; // Still loading
	            var selections = cm.getSelections();
	            if (selections.length !== 1) {
	                if (_this.state.singleCursor) {
	                    _this.setState({ singleCursor: false });
	                }
	                return;
	            }
	            else if (!_this.state.singleCursor) {
	                _this.setState({ singleCursor: true });
	            }
	            var sel = cm.getSelection();
	            var cursor = { line: sel.startLineNumber - 1, ch: sel.startColumn - 1 };
	            var isCursorInTopHalf = monacoUtils.isCursorInTopHalf(cm);
	            if (isCursorInTopHalf) {
	                _this.setState({ onBottom: true, cursor: cursor, doctorInfo: null, searching: true });
	            }
	            else {
	                _this.setState({ onBottom: false, cursor: cursor, doctorInfo: null, searching: true });
	            }
	            _this.updateLazyInformation();
	        };
	        _this.updateLazyInformation = utils.debounce(function () {
	            if (_this.isUnmounted)
	                return;
	            if (!_this.props.showDoctor || !_this.state.singleCursor)
	                return;
	            if (!state.inActiveProjectFilePath(_this.props.filePath))
	                return;
	            var cm = _this.props.cm;
	            socketClient_1.server.getDoctorInfo({ filePath: _this.props.filePath, editorPosition: _this.state.cursor }).then(function (res) {
	                _this.setState({ doctorInfo: res, searching: false });
	            });
	        }, 1000);
	        _this.openLocation = function (filePath, editorPosition) {
	            commands.doOpenOrFocusFile.emit({ filePath: filePath, position: editorPosition });
	        };
	        _this.state = {};
	        return _this;
	    }
	    Doctor.prototype.componentWillUnmount = function () {
	        _super.prototype.componentWillUnmount.call(this);
	    };
	    Doctor.prototype.componentWillReceiveProps = function (props) {
	        if (props.showDoctor && !this.props.showDoctor) {
	            this.handleCursorActivity();
	        }
	        if (!this.props.cm && props.cm) {
	            this.disposible.add(props.cm.onDidChangeCursorPosition(this.handleCursorActivity));
	        }
	    };
	    Doctor.prototype.render = function () {
	        var _this = this;
	        if (!this.props.showDoctor || !this.state.singleCursor || !this.state.cursor) {
	            return React.createElement("div", null);
	        }
	        if (!state.inActiveProjectFilePath(this.props.filePath)) {
	            return React.createElement("div", null);
	        }
	        var rawErrors = globalErrorCacheClient_1.errorsCache.getErrorsForFilePath(this.props.filePath);
	        var errors = rawErrors.filter(function (re) { return re.from.line == _this.state.cursor.line; }).filter(function (re) { return re.from.ch <= _this.state.cursor.ch && _this.state.cursor.ch <= re.to.ch; });
	        var positionStyle = this.state.onBottom ? docuOnBottomStyle : docuOnTopStyle;
	        var doctorInfo = this.state.doctorInfo;
	        var typeInfo;
	        var comment;
	        var references;
	        var definitions;
	        if (doctorInfo && doctorInfo.quickInfo) {
	            typeInfo = React.createElement("div", { style: doctorRow },
	                React.createElement("strong", null, "SIG"),
	                "\u00A0",
	                React.createElement("strong", { style: { fontFamily: 'monospace' } }, doctorInfo.quickInfo.name));
	            comment = doctorInfo.quickInfo.comment &&
	                React.createElement("div", { style: doctorRow },
	                    React.createElement("div", { style: { background: '#222', padding: '3px', fontFamily: 'monospace' } }, doctorInfo.quickInfo.comment));
	        }
	        if (doctorInfo && doctorInfo.references && doctorInfo.references.length) {
	            references = React.createElement("div", { style: doctorRow },
	                React.createElement("strong", null, "REF"),
	                ' ',
	                doctorInfo.references.map(function (item) {
	                    return (React.createElement("span", { style: fileLinkStyle, key: item.filePath + item.position.line, onClick: function () { return _this.openLocation(item.filePath, item.position); } }, utils.getFileName(item.filePath) + ":" + (item.position.line + 1)));
	                }));
	        }
	        if (doctorInfo && doctorInfo.definitions && doctorInfo.definitions.length) {
	            definitions = React.createElement("div", { style: doctorRow },
	                React.createElement("strong", null, "DEF"),
	                ' ',
	                doctorInfo.definitions.map(function (item) {
	                    return (React.createElement("span", { style: fileLinkStyle, key: item.filePath + item.position.line, onClick: function () { return _this.openLocation(item.filePath, item.position); } }, utils.getFileName(item.filePath) + ":" + (item.position.line + 1)));
	                }));
	        }
	        if (doctorInfo && doctorInfo.langHelp) {
	            definitions = React.createElement("div", { style: doctorRow },
	                React.createElement("strong", null, doctorInfo.langHelp.displayName),
	                ' ',
	                React.createElement("span", { style: fileLinkStyle, onClick: function () { return window.open(doctorInfo.langHelp.help, '_blank'); } }, "More"));
	        }
	        return React.createElement("div", { className: docuClassName, style: csx.extend(positionStyle, csx.vertical) },
	            React.createElement("div", { style: csx.vertical },
	                errors.map(function (e) {
	                    return React.createElement("div", { style: { padding: '5px' }, key: e.from.ch },
	                        "\uD83D\uDC1B(",
	                        e.from.line + 1,
	                        ":",
	                        e.from.ch + 1,
	                        ") ",
	                        e.message,
	                        ' ',
	                        React.createElement(clipboard.Clipboard, { text: e.filePath + ":" + (e.from.line + 1) + " " + e.message }));
	                }),
	                typeInfo,
	                comment,
	                references,
	                definitions,
	                this.state.searching && React.createElement("i", null, "Searching..."),
	                this.state.doctorInfo && !this.state.doctorInfo.valid && React.createElement("i", null, "Nothing worthwhile")));
	        {
	        }
	    };
	    Doctor = __decorate([
	        react_redux_1.connect(function (state) {
	            return {
	                showDoctor: state.showDoctor,
	            };
	        }),
	        __metadata("design:paramtypes", [Object])
	    ], Doctor);
	    return Doctor;
	}(ui.BaseComponent));
	exports.Doctor = Doctor;


/***/ },
/* 410 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	/**
	 * Format document on selection based on cursor
	 */
	var FormatBetterAction = /** @class */ (function (_super) {
	    __extends(FormatBetterAction, _super);
	    function FormatBetterAction() {
	        return _super.call(this, {
	            id: 'editor.action.formatBetter',
	            label: 'Format',
	            alias: 'Format',
	            precondition: EditorContextKeys.Focus,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.CtrlCmd | KeyMod.Alt | KeyCode.KEY_L
	            }
	        }) || this;
	    }
	    FormatBetterAction.prototype.run = function (accessor, editor) {
	        var model = editor.getModel();
	        var editorSelection = editor.getSelection();
	        if (editorSelection.isEmpty()) {
	            var formatDocument = editor.getAction('editor.action.formatDocument');
	            return formatDocument.run();
	        }
	        else {
	            var formatSelection = editor.getAction('editor.action.formatSelection');
	            return formatSelection.run();
	        }
	    };
	    return FormatBetterAction;
	}(EditorAction));
	exports.FormatBetterAction = FormatBetterAction;
	CommonEditorRegistry.registerEditorAction(new FormatBetterAction());


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var ui = __webpack_require__(1);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var GitResetAction = /** @class */ (function (_super) {
	    __extends(GitResetAction, _super);
	    function GitResetAction() {
	        return _super.call(this, {
	            id: 'editor.action.gitReset',
	            label: 'Git Soft Reset',
	            alias: 'Git Soft Reset',
	            precondition: EditorContextKeys.Writable,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.CtrlCmd | KeyMod.Alt | KeyCode.KEY_Z
	            }
	        }) || this;
	    }
	    GitResetAction.prototype.run = function (accessor, editor) {
	        socketClient_1.server.gitReset({ filePath: editor.filePath }).then(function (res) {
	            // console.log(res); // DEBUG
	            ui.notifySuccessNormalDisappear('Git soft reset successful');
	        });
	    };
	    return GitResetAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new GitResetAction());


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var ui = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var monacoUtils = __webpack_require__(18);
	var state = __webpack_require__(11);
	var selectListView = __webpack_require__(51);
	var React = __webpack_require__(2);
	var csx = __webpack_require__(6);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var GotoTypeScriptSymbolAction = /** @class */ (function (_super) {
	    __extends(GotoTypeScriptSymbolAction, _super);
	    function GotoTypeScriptSymbolAction() {
	        return _super.call(this, {
	            id: 'editor.action.gotoTypeScriptSymbol',
	            label: 'Goto TypeScript Symbol (Hieroglyph) in file',
	            alias: 'Goto TypeScript Symbol (Hieroglyph) in file',
	            precondition: EditorContextKeys.Writable,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.CtrlCmd | KeyCode.KEY_H
	            }
	        }) || this;
	    }
	    GotoTypeScriptSymbolAction.prototype.run = function (accessor, editor) {
	        var filePath = editor.filePath;
	        if (!state.inActiveProjectFilePath(filePath)) {
	            ui.notifyInfoNormalDisappear('The current file is no in the active project');
	            return;
	        }
	        socketClient_1.server.getNavigateToItemsForFilePath({ filePath: filePath }).then(function (res) {
	            if (!res.items) {
	                ui.notifyInfoNormalDisappear('No TypeScript symbols found for file');
	                return; // potentially show a message
	            }
	            selectListView.selectListView.show({
	                header: "TypeScript symbols (Hieroglyphs) in " + utils.getFileName(filePath),
	                data: res.items,
	                render: function (symbol, matched) {
	                    // NOTE: Code duplicated in `omniSearch.tsx` (except this needs to set font explicitly)
	                    var color = ui.kindToColor(symbol.kind);
	                    var icon = ui.kindToIcon(symbol.kind);
	                    return (React.createElement("div", { style: { fontFamily: 'monospace' } },
	                        React.createElement("div", { style: csx.horizontal },
	                            React.createElement("span", null, matched),
	                            React.createElement("span", { style: csx.flex }),
	                            React.createElement("strong", { style: { color: color } }, symbol.kind),
	                            "\u00A0",
	                            React.createElement("span", { style: csx.extend({ color: color, fontFamily: 'FontAwesome' }) }, icon)),
	                        React.createElement("div", null,
	                            symbol.fileName,
	                            ":",
	                            symbol.position.line + 1)));
	                },
	                textify: function (item) { return item.name; },
	                onSelect: function (item) {
	                    monacoUtils.gotoPosition({ editor: editor, position: item.position });
	                    return '';
	                }
	            });
	        });
	    };
	    return GotoTypeScriptSymbolAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new GotoTypeScriptSymbolAction());


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var monacoUtils = __webpack_require__(18);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var EditorContextKeys = monaco.EditorContextKeys;
	/* Test:
	<!-- Hello world -->
	<div class="awesome" style="border: 1px solid red">
	  <label for="name">Enter your name: </label>
	  <input type="text" id="name" />
	</div>
	<p>Enter your HTML here</p>
	*/
	var HtmlToTsxAction = /** @class */ (function (_super) {
	    __extends(HtmlToTsxAction, _super);
	    function HtmlToTsxAction() {
	        return _super.call(this, {
	            id: 'editor.action.htmlToTsx',
	            label: 'HTML to TSX',
	            alias: 'HTML to TSX',
	            precondition: EditorContextKeys.Writable,
	        }) || this;
	    }
	    HtmlToTsxAction.prototype.run = function (accessor, editor) {
	        var filePath = editor.filePath;
	        var selection = editor.getSelection();
	        if (!selection.isEmpty()) {
	            var indentSize = editor.getModel()._editorOptions ? editor.getModel()._editorOptions.tabSize : 2;
	            var oldText = editor.getModel().getValueInRange(selection);
	            var newText = convert(oldText, indentSize);
	            monacoUtils.replaceSelection({ editor: editor, newText: newText });
	        }
	        else {
	            ui.notifyWarningNormalDisappear('Please select the HTML you want converted to TSX and try again 🌹');
	        }
	    };
	    return HtmlToTsxAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new HtmlToTsxAction());
	/**
	 * Take a look at :
	 * https://github.com/reactjs/react-magic
	 * https://www.npmjs.com/package/htmltojsx
	 */
	var htmlToJsx_1 = __webpack_require__(157);
	function convert(content, indentSize) {
	    var indent = Array(indentSize + 1).join(' ');
	    var converter = new htmlToJsx_1.HTMLtoJSX({ indent: indent, createClass: false });
	    var output = converter.convert(content);
	    return output;
	}
	exports.convert = convert;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var monacoUtils = __webpack_require__(18);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var EditorContextKeys = monaco.EditorContextKeys;
	/* Test:
	{
	  foo: 123,
	  bar: {
	    bas: "Hello",
	    baz: {
	      qux: "World"
	    }
	  }
	}
	*/
	var JsonToDts = /** @class */ (function (_super) {
	    __extends(JsonToDts, _super);
	    function JsonToDts() {
	        return _super.call(this, {
	            id: 'editor.action.jsonToDts',
	            label: 'JSON to TypeScript definition (.d.ts)',
	            alias: 'JSON to TypeScript definition (.d.ts)',
	            precondition: EditorContextKeys.Writable,
	        }) || this;
	    }
	    JsonToDts.prototype.run = function (accessor, editor) {
	        var filePath = editor.filePath;
	        var selection = editor.getSelection();
	        if (!selection.isEmpty()) {
	            var indentSize = editor.getModel()._editorOptions ? editor.getModel()._editorOptions.tabSize : 2;
	            var oldText = editor.getModel().getValueInRange(selection);
	            var newText = convert(oldText);
	            monacoUtils.replaceSelection({ editor: editor, newText: newText });
	            monacoUtils.format({ editor: editor });
	        }
	        else {
	            ui.notifyWarningNormalDisappear('Please select the JavaScript object literal (or json) you want converted to a TypeScript definition and try again 🌹');
	        }
	    };
	    return JsonToDts;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new JsonToDts());
	/**
	 * The beating heart
	 */
	var json2dts_1 = __webpack_require__(402);
	function convert(content) {
	    try {
	        var converter = new json2dts_1.Json2dts();
	        var text2Obj = JSON.parse(json2dts_1.toValidJSON(content));
	        if (typeof text2Obj != "string") {
	            converter.parse(text2Obj, 'RootJson');
	            content = converter.getCode();
	        }
	        else {
	            ui.notifyWarningNormalDisappear('Json2dts Invalid JSON');
	        }
	    }
	    catch (e) {
	        ui.notifyWarningNormalDisappear("Json2dts Invalid JSON error: " + e);
	    }
	    return content;
	}
	exports.convert = convert;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Imports */
	var commands = __webpack_require__(7);
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var utils = __webpack_require__(3);
	var events = __webpack_require__(19);
	var monacoUtils = __webpack_require__(18);
	/** Load jumpy css */
	__webpack_require__(368);
	/**
	 * Setup key characters used for jumpy points
	 */
	var lowerCharacters = [];
	for (var i = 'a'.charCodeAt(0); i <= 'z'.charCodeAt(0); i++) {
	    var key = String.fromCharCode(i);
	    lowerCharacters.push(key);
	}
	exports.keys = [];
	for (var _i = 0, lowerCharacters_1 = lowerCharacters; _i < lowerCharacters_1.length; _i++) {
	    var c1 = lowerCharacters_1[_i];
	    for (var _a = 0, lowerCharacters_2 = lowerCharacters; _a < lowerCharacters_2.length; _a++) {
	        var c2 = lowerCharacters_2[_a];
	        exports.keys.push(c1 + c2);
	    }
	}
	function getWidgetId(wg) {
	    return "jumpy:" + wg.line + ":" + wg.ch;
	}
	/** Gets or creates a state */
	function getState(editor) {
	    return editor._jumpyState || (editor._jumpyState = { widgets: [], shown: false, disposible: new events.CompositeDisposible() });
	}
	exports.getState = getState;
	/**
	 *
	 * The bulk of the logic
	 *
	 */
	function addOverlay(editor) {
	    clearAnyOverlay(editor);
	    /** Create the overlays */
	    var state = createOverlays(editor);
	    /** A clear overlay function just for this editor 🌹 */
	    var clearOverlay = function () { return clearAnyOverlay(editor); };
	    // Subscribe to esc to clear
	    state.disposible.add(commands.esc.on(clearOverlay));
	    /** Subscribe to jump */
	    state.disposible.add(editor.onKeyDown(function (e) {
	        if (e.keyCode >= monaco.KeyCode.KEY_A && e.keyCode <= monaco.KeyCode.KEY_Z) {
	            // We always prevent ascii chars as the user might have mistyped some keystroke
	            e.preventDefault();
	            e.stopPropagation();
	            // The character representation
	            var char = String.fromCharCode(e.browserEvent.which).toLowerCase();
	            // console.log({char}); // DEBUG
	            var state_1 = getState(editor);
	            if (!state_1.key1) {
	                state_1.key1 = char;
	                // remove not matched
	                state_1.widgets.filter(function (wg) { return !wg.keys.startsWith(state_1.key1); }).forEach(function (wg) { return editor.removeContentWidget(wg.monacoWiget); });
	                // only keep matched
	                state_1.widgets = state_1.widgets.filter(function (wg) { return wg.keys.startsWith(state_1.key1); });
	                // remove all if nothing matched
	                if (state_1.widgets.length == 0) {
	                    clearOverlay();
	                }
	            }
	            else {
	                var total_1 = state_1.key1 + char;
	                var matched = state_1.widgets.find(function (wg) { return wg.keys == total_1; });
	                if (matched) {
	                    var position = { lineNumber: matched.line + 1, column: matched.ch + 1 };
	                    editor.setPosition(position);
	                    // We actually allow them to jump one line before / one line after
	                    // So calling this isn't a bad idea. No-op if the line is in view ;)
	                    editor.revealLine(position.lineNumber);
	                }
	                clearOverlay();
	            }
	        }
	        else {
	            clearOverlay();
	        }
	    }));
	    /** Best to exit on these conditions too */
	    state.disposible.add(editor.onDidScrollChange(clearOverlay));
	    state.disposible.add(editor.onDidChangeCursorSelection(clearOverlay));
	    state.disposible.add(editor.onDidBlurEditor(clearOverlay));
	}
	/**
	 * Clears previous overlays if any
	 */
	function clearAnyOverlay(editor) {
	    var state = getState(editor);
	    if (state.shown) {
	        state.widgets.forEach(function (wg) { return editor.removeContentWidget(wg.monacoWiget); });
	        state.widgets = [];
	        state.key1 = null;
	        state.key2 = null;
	        state.shown = false;
	        state.disposible.dispose();
	    }
	}
	/**
	 * Renders the overlays on the editor
	 */
	function createOverlays(editor) {
	    // The model
	    var doc = editor.getModel();
	    // DEBUG
	    // console.log(editor);
	    // window.foo = editor;
	    // The text in viewport
	    var range = monacoUtils.getVisibleLines(editor);
	    var text = doc.getValueInRange(range);
	    /** What we use to split the text */
	    var splitRegex = /^[A-Z]?[0-9a-z]+|^[\{\};]+/;
	    var lineNumbers = [];
	    for (var i = range.startLineNumber; i <= range.endLineNumber; i++) {
	        lineNumbers.push(i);
	    }
	    // keeps track of the next jump point key we can use
	    var keysIndex = 0;
	    var overlayByLines = utils.selectMany(lineNumbers.map(function (lineNumber, i) {
	        var string = doc.getLineContent(lineNumber);
	        var pos = 0;
	        var lineOverlays = [];
	        while (pos < string.length) {
	            var matches = splitRegex.exec(string.substr(pos));
	            if (matches && matches.length) {
	                var matched = matches[0];
	                var name_1 = exports.keys[keysIndex++];
	                var nodeRendered = React.createElement("div", { key: i + ':' + pos, className: "monaco-jumpy", style: {} }, name_1);
	                var node = document.createElement('div');
	                ReactDOM.render(nodeRendered, node);
	                var widget = {
	                    node: node,
	                    line: lineNumber - 1,
	                    ch: pos,
	                    keys: name_1,
	                    // This is setup later
	                    monacoWiget: null,
	                };
	                lineOverlays.push(widget);
	                // we want some minimum space between matches
	                pos += Math.max(matched.length, 2);
	            }
	            else {
	                pos++;
	            }
	        }
	        return lineOverlays;
	    }));
	    // Add to dom + State
	    overlayByLines.forEach(function (wg) {
	        wg.monacoWiget = {
	            allowEditorOverflow: true,
	            getId: function () { return getWidgetId(wg); },
	            getDomNode: function () { return wg.node; },
	            getPosition: function () {
	                return {
	                    position: { lineNumber: wg.line + 1, column: wg.ch + 1 },
	                    preference: [
	                        monaco.editor.ContentWidgetPositionPreference.ABOVE,
	                        monaco.editor.ContentWidgetPositionPreference.BELOW,
	                    ]
	                };
	            }
	        };
	        editor.addContentWidget(wg.monacoWiget);
	    });
	    // Setup state and return
	    var state = getState(editor);
	    state.widgets = overlayByLines;
	    state.shown = true;
	    state.disposible = new events.CompositeDisposible();
	    return state;
	}
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var JumpyAction = /** @class */ (function (_super) {
	    __extends(JumpyAction, _super);
	    function JumpyAction() {
	        return _super.call(this, {
	            id: 'editor.action.jumpy',
	            label: 'Jumpy',
	            alias: 'Jumpy',
	            precondition: EditorContextKeys.Focus,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.CtrlCmd | KeyCode.Enter
	            }
	        }) || this;
	    }
	    JumpyAction.prototype.run = function (accessor, editor) {
	        addOverlay(editor);
	    };
	    return JumpyAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new JumpyAction());


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Original version from https://github.com/alexandrudima/monaco-typescript/blob/1af97f4c0bc7514ea1f1ba62d9098aa883595918/src/languageFeatures.ts
	 *
	 * Modified to
	 * - use our live error pushing
	 * - use `filePath` instead of `uri`
	 */
	var events = __webpack_require__(19);
	var globalErrorCacheClient_1 = __webpack_require__(35);
	__webpack_require__(369);
	var gutterClassName = 'monaco-lint-marker-error';
	var gutterDecorationOptions = {
	    glyphMarginClassName: gutterClassName,
	    isWholeLine: true,
	    hoverMessage: 'Errors exist in code on this line.'
	};
	function codeErrorToMonacoError(codeError) {
	    return {
	        severity: codeError.level === 'error' ? monaco.Severity.Error : monaco.Severity.Warning,
	        message: codeError.message,
	        startLineNumber: codeError.from.line + 1,
	        startColumn: codeError.from.ch + 1,
	        endLineNumber: codeError.to.line + 1,
	        endColumn: codeError.to.ch + 1,
	    };
	}
	function setup(editor) {
	    // if (editor) return { dispose: () => null }; // DEBUG : while the feature isn't complete used to disable it
	    var lastDecorations = [];
	    function performLint() {
	        var filePath = editor.filePath;
	        var model = editor.getModel();
	        var rawErrors = globalErrorCacheClient_1.errorsCache.getErrorsForFilePath(filePath);
	        // console.log('here', rawErrors); // DEBUG
	        // Set inline markers. Monaco also uses these for `f8` next error nav.
	        var markers = rawErrors.map(codeErrorToMonacoError);
	        monaco.editor.setModelMarkers(model, 'alm-linter', markers);
	        // Set gutter decorations
	        var newDecorations = rawErrors.map(function (override) {
	            var result = {
	                range: {
	                    startLineNumber: override.from.line + 1,
	                    endLineNumber: override.to.line + 1,
	                },
	                options: gutterDecorationOptions
	            };
	            return result;
	        });
	        lastDecorations = editor.deltaDecorations(lastDecorations, newDecorations);
	    }
	    // Perform an initial lint
	    performLint();
	    var disposible = new events.CompositeDisposible();
	    // Subscribe for future updates
	    disposible.add(globalErrorCacheClient_1.errorsCache.errorsDelta.on(performLint));
	    /**
	     * Also subscribe to the user clicking the margin
	     */
	    disposible.add(editor.onMouseUp(function (mouseEvent) {
	        if (mouseEvent.target.type === monaco.editor.MouseTargetType.GUTTER_GLYPH_MARGIN
	            && mouseEvent.target.element.className.includes(gutterClassName)) {
	            var position_1 = mouseEvent.target.position;
	            if (position_1) {
	                var rawErrors = globalErrorCacheClient_1.errorsCache.getErrorsForFilePath(editor.filePath);
	                var error = rawErrors.find(function (x) { return x.from.line === position_1.lineNumber - 1; });
	                if (error) {
	                    editor.setPosition({
	                        lineNumber: error.from.line + 1,
	                        column: error.from.ch + 1
	                    });
	                }
	            }
	        }
	    }));
	    return disposible;
	}
	exports.setup = setup;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(19);
	var socketClient_1 = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var state = __webpack_require__(11);
	var commands = __webpack_require__(7);
	__webpack_require__(370);
	var overrideClassName = 'monaco-live-analysis-override';
	var overrideDecorationOptions = {
	    glyphMarginClassName: overrideClassName,
	    isWholeLine: true,
	    hoverMessage: 'Overrides a base class member. Click to navigate.'
	};
	function setup(cm) {
	    // if (cm) return { dispose: () => null }; // DEBUG : while the feature isn't complete used to disable it
	    var lastDecorations = [];
	    var lastServerRes = null;
	    // The key quick fix get logic
	    var refreshLiveAnalysis = function () {
	        // If not active project return
	        if (!state.inActiveProjectFilePath(cm.filePath)) {
	            if (lastDecorations.length) {
	                lastDecorations = cm.deltaDecorations(lastDecorations, []);
	            }
	            return;
	        }
	        // query the server with live analysis
	        socketClient_1.server.getLiveAnalysis({
	            filePath: cm.filePath,
	        }).then(function (res) {
	            lastServerRes = res;
	            var newDecorations = res.overrides.map(function (override) {
	                var result = {
	                    range: {
	                        startLineNumber: override.line + 1,
	                        endLineNumber: override.line + 1,
	                    },
	                    options: overrideDecorationOptions
	                };
	                return result;
	            });
	            lastDecorations = cm.deltaDecorations(lastDecorations, newDecorations);
	        });
	    };
	    var refreshLiveAnalysisDebounced = utils.debounce(refreshLiveAnalysis, 3000);
	    var disposible = new events_1.CompositeDisposible();
	    disposible.add(cm.onDidFocusEditor(refreshLiveAnalysisDebounced));
	    disposible.add(cm.onDidChangeModelContent(refreshLiveAnalysisDebounced));
	    disposible.add(socketClient_1.cast.activeProjectConfigDetailsUpdated.on(function () {
	        refreshLiveAnalysisDebounced();
	    }));
	    /**
	     * Also subscribe to the user clicking the margin
	     */
	    disposible.add(cm.onMouseUp(function (mouseEvent) {
	        if (mouseEvent.target.type === monaco.editor.MouseTargetType.GUTTER_GLYPH_MARGIN
	            && mouseEvent.target.element.className.includes(overrideClassName)) {
	            var position_1 = mouseEvent.target.position;
	            if (position_1 && lastServerRes) {
	                var override = lastServerRes.overrides.find(function (x) { return x.line === (position_1.lineNumber - 1); });
	                if (override) {
	                    commands.doOpenOrFocusFile.emit({
	                        filePath: override.overrides.location.filePath,
	                        position: override.overrides.location.position
	                    });
	                }
	            }
	        }
	    }));
	    return disposible;
	}
	exports.setup = setup;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands = __webpack_require__(7);
	var ui = __webpack_require__(1);
	var uix_1 = __webpack_require__(41);
	var utils = __webpack_require__(3);
	commands.enableLiveDemo.on(function () {
	    var ceditor = uix_1.API.getFocusedCodeEditorIfAny();
	    if (!ceditor || !utils.isTs(ceditor.editor.filePath)) {
	        ui.notifyWarningNormalDisappear('Your current tab needs to be a TypeScript file');
	        return;
	    }
	    var filePath = ceditor.editor.filePath;
	    commands.ensureLiveDemoTab.emit({ filePath: filePath });
	});
	commands.disableLiveDemo.on(function () {
	    commands.closeDemoTab.emit({});
	});
	commands.enableLiveDemoReact.on(function () {
	    var ceditor = uix_1.API.getFocusedCodeEditorIfAny();
	    if (!ceditor || !utils.isTsx(ceditor.editor.filePath)) {
	        ui.notifyWarningNormalDisappear('Your current tab needs to be a TypeScript tsx file');
	        return;
	    }
	    var filePath = ceditor.editor.filePath;
	    commands.ensureLiveDemoReactTab.emit({ filePath: filePath });
	});
	commands.disableLiveDemoReact.on(function () {
	    commands.closeDemoReactTab.emit({});
	});


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var uix = __webpack_require__(41);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var EditorContextKeys = monaco.EditorContextKeys;
	/* Test:
	<!-- Hello world -->
	<div class="awesome" style="border: 1px solid red">
	  <label for="name">Enter your name: </label>
	  <input type="text" id="name" />
	</div>
	<p>Enter your HTML here</p>
	*/
	var RemoveUnusedImportsAction = /** @class */ (function (_super) {
	    __extends(RemoveUnusedImportsAction, _super);
	    function RemoveUnusedImportsAction() {
	        return _super.call(this, {
	            id: 'editor.action.removeUnusedImports',
	            label: 'Remove unused imports',
	            alias: 'Remove unused imports',
	            precondition: EditorContextKeys.Writable,
	        }) || this;
	    }
	    RemoveUnusedImportsAction.prototype.run = function (accessor, editor) {
	        var filePath = editor.filePath;
	        var selection = editor.getSelection();
	        socketClient_1.server.removeUnusedImports({ filePath: editor.filePath }).then(function (refactorings) {
	            // apply refactorings
	            // console.log('Apply refactorings:', refactorings); // DEBUG
	            uix.API.applyRefactorings(refactorings);
	        });
	    };
	    return RemoveUnusedImportsAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new RemoveUnusedImportsAction());


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Provides a new overview of the cotents of the file, *semantically*
	 */
	/** imports */
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var state = __webpack_require__(11);
	var react_redux_1 = __webpack_require__(29);
	var utils = __webpack_require__(3);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var typestyle = __webpack_require__(13);
	var styles = __webpack_require__(10);
	var pure_1 = __webpack_require__(61);
	var monacoUtils_1 = __webpack_require__(18);
	var SemanticViewStyles;
	(function (SemanticViewStyles) {
	    SemanticViewStyles.root = {
	        padding: '5px',
	        background: '#343333',
	        // Font
	        color: '#BBB',
	        fontSize: '.6rem',
	        fontWeight: 'bold',
	        // Overflow
	        overflow: 'auto',
	        // Limit width
	        maxWidth: '200px',
	        opacity: '0.7',
	        transition: 'opacity .2s',
	        ':hover': {
	            opacity: '1'
	        }
	    };
	    SemanticViewStyles.nodeClass = typestyle.style(csx.extend(styles.ellipsis, {
	        paddingTop: '2px',
	        paddingBottom: '3px',
	        paddingLeft: '2px',
	        paddingRight: '2px',
	        // Border which merges with the top
	        marginTop: '-1px',
	        border: '1px solid transparent',
	        cursor: 'pointer',
	        '-webkit-user-select': 'none',
	        transition: 'background .2s',
	        '&:hover': {
	            backgroundColor: '#555'
	        }
	    }));
	    SemanticViewStyles.selectedNodeClass = typestyle.style({
	        border: '1px solid grey',
	        backgroundColor: styles.blackHighlightColor,
	        $nest: {
	            '&:hover': {
	                backgroundColor: styles.blackHighlightColor
	            }
	        }
	    });
	})(SemanticViewStyles || (SemanticViewStyles = {}));
	var SemanticView = /** @class */ (function (_super) {
	    __extends(SemanticView, _super);
	    function SemanticView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleCursorActivity = utils.debounce(function (editor) {
	            if (editor === void 0) { editor = _this.props.editor; }
	            if (!editor)
	                return; // Still loading or maybe unloaded
	            if (!state.inActiveProjectFilePath(_this.props.filePath))
	                return;
	            if (_this.isUnmounted)
	                return;
	            if (!_this.props.showSemanticView)
	                return;
	            var sel = editor.getSelection();
	            var cursor = { line: sel.startLineNumber - 1, ch: sel.startColumn - 1 };
	            /** If first call OR cursor moved */
	            if (!_this.state.cursor || (_this.state.cursor && _this.state.cursor.line !== cursor.line)) {
	                _this.setState({ cursor: cursor });
	                _this.afterComponentDidUpdate(function () {
	                    // Scroll to select node in view if any
	                    var ref = _this.refs[_this.selectedRef];
	                    if (ref) {
	                        ref.scrollIntoViewIfNeeded(true);
	                    }
	                });
	            }
	        }, 1000);
	        _this.gotoNode = function (node) {
	            var cursor = { line: node.start.line, ch: node.start.ch };
	            var editor = _this.props.editor;
	            monacoUtils_1.gotoPosition({ editor: editor, position: cursor });
	            editor.focus();
	            _this.setState({ cursor: cursor });
	        };
	        /** Constantly incrementing so that this points to the last (deepest) selected node :) */
	        _this.selectedRef = 0;
	        _this.isSelected = function (node) {
	            if (!_this.state.cursor)
	                return '';
	            var cursor = _this.state.cursor;
	            if (node.start.line <= cursor.line && node.end.line >= cursor.line) {
	                _this.selectedRef++;
	                return SemanticViewStyles.selectedNodeClass;
	            }
	            return '';
	        };
	        /** If the tree changes its width we need to relayout the editor */
	        _this.lastWidth = 0;
	        /** Loads the tree data */
	        _this.reloadData = function () {
	            if (!_this.props.filePath)
	                return;
	            if (!state.inActiveProjectFilePath(_this.props.filePath))
	                return;
	            socketClient_1.server.getSemanticTree({ filePath: _this.props.filePath }).then(function (res) {
	                _this.afterComponentDidUpdate(function () {
	                    // also relayout the editor if the last width is not the same as new width
	                    var newWidth = ReactDOM.findDOMNode(_this).clientWidth;
	                    if (_this.lastWidth !== newWidth) {
	                        _this.relayoutEditor();
	                        _this.lastWidth = newWidth;
	                    }
	                });
	                _this.setState({ tree: res.nodes });
	            });
	        };
	        _this.state = {
	            tree: []
	        };
	        return _this;
	    }
	    SemanticView.prototype.shouldComponentUpdate = function () {
	        return pure_1.shouldComponentUpdate.apply(this, arguments);
	    };
	    SemanticView.prototype.componentWillUnmount = function () {
	        _super.prototype.componentWillUnmount.call(this);
	    };
	    SemanticView.prototype.componentWillReceiveProps = function (props) {
	        var _this = this;
	        if (props.showSemanticView && !this.props.showSemanticView) {
	            this.handleCursorActivity();
	        }
	        if (!this.props.editor && props.editor) {
	            /** Initial data load */
	            var sel = props.editor.getSelection();
	            var cursor = { line: sel.startLineNumber - 1, ch: sel.endLineNumber - 1 };
	            this.setState({ cursor: cursor });
	            this.reloadData();
	            var reloadDataDebounced_1 = utils.debounce(this.reloadData, 3000);
	            this.disposible.add(commands.fileContentsChanged.on(function (e) {
	                if (e.filePath === props.filePath && _this.props.showSemanticView) {
	                    reloadDataDebounced_1();
	                }
	            }));
	            this.disposible.add(state.subscribeSub((function (s) { return s.showSemanticView; }), function (showSemanticView) {
	                if (showSemanticView) {
	                    reloadDataDebounced_1();
	                }
	            }));
	            this.handleCursorActivity(props.editor);
	            this.disposible.add(props.editor.onDidChangeCursorSelection(function () { return _this.handleCursorActivity(); }));
	        }
	        /**
	         * If just hidden and we have an editor, then the editor needs resizing
	         */
	        if (!props.showSemanticView && this.props.showSemanticView && this.props.editor) {
	            this.afterComponentDidUpdate(function () {
	                _this.relayoutEditor();
	            });
	        }
	    };
	    SemanticView.prototype.render = function () {
	        var _this = this;
	        if (!this.props.showSemanticView || !this.state.cursor) {
	            return React.createElement("div", null);
	        }
	        if (!state.inActiveProjectFilePath(this.props.filePath)) {
	            return React.createElement("div", null);
	        }
	        return React.createElement("div", { style: SemanticViewStyles.root }, this.state.tree.map(function (node) { return _this.renderNode(node, 0); }));
	    };
	    SemanticView.prototype.renderNode = function (node, indent) {
	        var _this = this;
	        var isSelected = this.isSelected(node);
	        var color = ui.kindToColor(node.kind);
	        var ref = isSelected ? this.selectedRef.toString() : null;
	        return [React.createElement("div", { ref: ref, key: node.text, className: SemanticViewStyles.nodeClass + ' ' + isSelected, style: { color: color }, onClick: function (event) { _this.gotoNode(node); event.stopPropagation(); }, "data-start": node.start.line, "data-end": node.end.line },
	                ui.indent(indent),
	                React.createElement("span", { style: { fontFamily: 'FontAwesome' } }, this.getIconForKind(node.kind)),
	                " ",
	                node.text)].concat(node.subNodes.map(function (sn) { return _this.renderNode(sn, indent + 1); }));
	    };
	    SemanticView.prototype.getIconForKind = function (kind) {
	        return ui.kindToIcon(kind);
	    };
	    SemanticView.prototype.relayoutEditor = function () {
	        // We store `top` (and restore it) otherwise the editor jumps around a bit after relayout.
	        var top = this.props.editor.getScrollTop();
	        this.props.editor.layout();
	        this.props.editor.setScrollTop(top);
	    };
	    SemanticView = __decorate([
	        react_redux_1.connect(function (state) {
	            return {
	                showSemanticView: state.showSemanticView,
	            };
	        }),
	        __metadata("design:paramtypes", [Object])
	    ], SemanticView);
	    return SemanticView;
	}(ui.BaseComponent));
	exports.SemanticView = SemanticView;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Renders tested stuff in monaco
	 */
	var clientTestResultsCache_1 = __webpack_require__(59);
	var events = __webpack_require__(19);
	var utils = __webpack_require__(3);
	var types = __webpack_require__(23);
	var json = __webpack_require__(469);
	var typestyle = __webpack_require__(13);
	var styles = __webpack_require__(10);
	var icon_1 = __webpack_require__(31);
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var Position = monaco.Position;
	var keyForMonacoDifferentiation = "alm_tested";
	var lineSeperator = '\n———————————————\n';
	var TestedMonacoStyles;
	(function (TestedMonacoStyles) {
	    var overlayCommon = {
	        padding: '0px 10px',
	        whiteSpace: 'pre',
	        pointerEvents: 'none',
	        /**
	         * This is to match the line height for a line in monaco
	         * Inspected a line in monaco to figure this out
	         * On mac it was 24px
	         * On windows it was 22px.
	         * Going with the small value globally instead of trying to figure it out
	         */
	        lineHeight: '22px',
	    };
	    TestedMonacoStyles.logOverlayClassName = typestyle.style(overlayCommon, {
	        color: styles.monokaiTextColor,
	    });
	    TestedMonacoStyles.errorStackOverlayClassName = typestyle.style(overlayCommon, {
	        color: styles.errorColor,
	    });
	})(TestedMonacoStyles || (TestedMonacoStyles = {}));
	function setup(editor) {
	    // if (editor) return { dispose: () => null }; // DEBUG : while the feature isn't complete used to disable it
	    var hadSomeTestsResults = false;
	    var deltaLogWidgets = new DeltaList({
	        getId: function (log) {
	            return keyForMonacoDifferentiation + " - " + JSON.stringify(log);
	        },
	        onAdd: function (log) {
	            var argsStringifiedAndJoined = log.args.map(function (a) { return json.stringify(a).trim(); })
	                .join(lineSeperator);
	            var nodeRendered = React.createElement("div", { className: TestedMonacoStyles.logOverlayClassName }, argsStringifiedAndJoined);
	            var node = document.createElement('div');
	            ReactDOM.render(nodeRendered, node);
	            var widgetDispose = MonacoInlineWidget.add({
	                editor: editor,
	                frameColor: styles.monokaiTextColor,
	                domNode: node,
	                position: log.testLogPosition.lastPositionInFile,
	                heightInLines: argsStringifiedAndJoined.split('\n').length + 1,
	            });
	            return widgetDispose;
	        },
	        onRemove: function (log, state) { return state.dispose(); },
	    });
	    var deltaTestResultsWidgets = new DeltaList({
	        getId: function (result) {
	            return keyForMonacoDifferentiation + " - " + JSON.stringify(result);
	        },
	        onAdd: function (result) {
	            var disposible = new events.CompositeDisposible();
	            /**
	             * Show pass fail in the editor.
	             * Would prefer in gutter but monaco doesn't allow multiple gutters.
	             * So adding them inline as circles.
	             * They move to the gutter based on our column setting ;)
	             */
	            var dotRendered = React.createElement("div", { className: "hint--right " + (result.status === types.TestStatus.Success ? "hint--success"
	                    : result.status === types.TestStatus.Fail ? "hint--error"
	                        : "hint--info"), style: {
	                    cursor: 'pointer',
	                    padding: '0px 5px',
	                    color: result.status === types.TestStatus.Success ? styles.successColor
	                        : result.status === types.TestStatus.Fail ? styles.errorColor
	                            : styles.highlightColor
	                }, "data-hint": result.status === types.TestStatus.Success ? "Test Success"
	                    : result.status === types.TestStatus.Fail ? "Test Fail: " + result.error.message
	                        : "Test Skipped" },
	                React.createElement(icon_1.Icon, { name: styles.icons.tested }));
	            var dotNode = document.createElement('div');
	            ReactDOM.render(dotRendered, dotNode);
	            var widget = {
	                allowEditorOverflow: false,
	                getId: function () { return keyForMonacoDifferentiation + " - dot - " + JSON.stringify(result); },
	                getDomNode: function () { return dotNode; },
	                getPosition: function () {
	                    return {
	                        position: {
	                            lineNumber: result.testLogPosition.lastPositionInFile.line + 1,
	                            column: /** Show in start of line to keep it easier to scan with eye */ 1
	                        },
	                        preference: [
	                            monaco.editor.ContentWidgetPositionPreference.EXACT
	                        ]
	                    };
	                }
	            };
	            editor.addContentWidget(widget);
	            disposible.add({
	                dispose: function () { return editor.removeContentWidget(widget); }
	            });
	            /**
	             * Show stacks for error ones
	             */
	            if (!result.error) {
	                return disposible;
	            }
	            var trailingStackStringifiedAndJoined = result.error.stack
	                .slice(1)
	                .map(function (a) { return a.filePath + ":" + (a.position.line + 1) + ":" + (a.position.ch + 1); })
	                .join(lineSeperator);
	            var detailsStringifiedAndJoined = result.error.message +
	                (trailingStackStringifiedAndJoined
	                    ? "" + lineSeperator + trailingStackStringifiedAndJoined
	                    : '');
	            var nodeRendered = React.createElement("div", { className: TestedMonacoStyles.errorStackOverlayClassName }, detailsStringifiedAndJoined);
	            var node = document.createElement('div');
	            ReactDOM.render(nodeRendered, node);
	            var widgetDispose = MonacoInlineWidget.add({
	                editor: editor,
	                frameColor: styles.errorColor,
	                domNode: node,
	                position: result.error.testLogPosition.lastPositionInFile,
	                heightInLines: detailsStringifiedAndJoined.split('\n').length + 1,
	            });
	            disposible.add(widgetDispose);
	            return disposible;
	        },
	        onRemove: function (result, state) { return state.dispose(); },
	    });
	    var performLogRefresh = utils.debounce(function () {
	        var filePath = editor.filePath;
	        var model = editor.getModel();
	        var allResults = clientTestResultsCache_1.testResultsCache.getResults();
	        var thisModule = allResults[filePath];
	        if (!thisModule) {
	            if (hadSomeTestsResults) {
	                deltaLogWidgets.delta([]);
	                deltaTestResultsWidgets.delta([]);
	            }
	            hadSomeTestsResults = false;
	            return;
	        }
	        hadSomeTestsResults = true;
	        /**
	         * Update logs for this file
	         * For those found update them
	         * For those not found delete them
	         * For those new add them.
	         *
	         * show logs in this file inline
	         * show logs in external files still inline
	         */
	        deltaLogWidgets.delta(thisModule.logs);
	        /** Also show the test results */
	        deltaTestResultsWidgets.delta(thisModule.testResults);
	        // console.log(thisModule.logs); // DEBUG
	    }, 500);
	    // Perform an initial lint
	    performLogRefresh();
	    var disposible = new events.CompositeDisposible();
	    // Subscribe for future updates
	    disposible.add(clientTestResultsCache_1.testResultsCache.testResultsDelta.on(performLogRefresh));
	    return disposible;
	}
	exports.setup = setup;
	/**
	 * Imagine a data structure that takes `T[]`
	 * and given `getId(): T`
	 *
	 * Calls these on delta for `T[]`
	 *
	 * onAdd => do stuff and give me some state I will call for onRemove
	 * onRemove => do stuff
	 */
	var DeltaList = /** @class */ (function () {
	    function DeltaList(config) {
	        this.config = config;
	        this.map = Object.create(null);
	    }
	    DeltaList.prototype.delta = function (items) {
	        var _this = this;
	        /** for quick lookup */
	        var quickNewItemLookup = utils.createMap(items.map(this.config.getId));
	        /** New dict */
	        var newDict = this.map;
	        newDict = Object.create(null);
	        /** old dict */
	        var oldDict = this.map;
	        items.forEach(function (item) {
	            var id = _this.config.getId(item);
	            /** Added? */
	            if (!oldDict[id]) {
	                var state = _this.config.onAdd(item);
	                newDict[id] = {
	                    item: item,
	                    state: state
	                };
	            }
	            else {
	                newDict[id] = oldDict[id];
	            }
	        });
	        /** Removed? */
	        Object.keys(oldDict).forEach(function (id) {
	            if (!quickNewItemLookup[id]) {
	                _this.config.onRemove(oldDict[id].item, oldDict[id].state);
	            }
	        });
	        this.map = newDict;
	    };
	    return DeltaList;
	}());
	var MonacoInlineWidget;
	(function (MonacoInlineWidget) {
	    ;
	    var ZoneWidget = monacoRequire('vs/editor/contrib/zoneWidget/browser/zoneWidget').ZoneWidget;
	    /** For reference see `gotoError.ts` in monaco source code */
	    var MyMarkerWidget = /** @class */ (function (_super) {
	        __extends(MyMarkerWidget, _super);
	        function MyMarkerWidget(config) {
	            var _this = _super.call(this, config.editor, {
	                frameColor: config.frameColor,
	            }) || this;
	            _this.config = config;
	            _this.create();
	            var position = new Position(config.position.line + 1, config.position.ch + 1);
	            _this.show(position, config.heightInLines);
	            return _this;
	        }
	        MyMarkerWidget.prototype._fillContainer = function (container) {
	            this._parentContainer = container;
	            this._parentContainer.tabIndex = 0;
	            this._parentContainer.setAttribute('role', 'tooltip');
	            this._parentContainer.appendChild(this.config.domNode);
	            /** Because sometimes monaco is leaving text hanging around */
	            this._parentContainer.style.backgroundColor = styles.monokaiBackgroundColor;
	        };
	        MyMarkerWidget.prototype.dispose = function () {
	            _super.prototype.dispose.call(this);
	        };
	        return MyMarkerWidget;
	    }(ZoneWidget));
	    function add(config) {
	        var editor = config.editor;
	        var position = editor.getPosition();
	        var revealPosition = editor.revealPosition;
	        var revealLine = editor.revealLine;
	        editor.revealPosition = function () { return null; };
	        editor.revealLine = function () { return null; };
	        /** Add  */
	        var widget = new MyMarkerWidget(config);
	        /**
	         * Our inline log widgets jump the scroll position. So we needed disable and restore these functions :-/
	         * Also some of these are called asyncly for some reason.
	         * See code in ZoneWidget._showImpl
	         */
	        editor.setPosition(position);
	        editor.revealPosition = revealPosition;
	        editor.revealLine = revealLine;
	        return widget;
	    }
	    MonacoInlineWidget.add = add;
	})(MonacoInlineWidget || (MonacoInlineWidget = {}));


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [0, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils = __webpack_require__(3);
	var autoCloseTag_1 = __webpack_require__(158);
	var monacoUtils_1 = __webpack_require__(18);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var WriteCode = /** @class */ (function (_super) {
	    __extends(WriteCode, _super);
	    function WriteCode() {
	        return _super.call(this, {
	            id: 'editor.action.writeCode',
	            label: 'Write Code',
	            alias: 'Write Code',
	            precondition: EditorContextKeys.Focus,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.CtrlCmd | KeyMod.Shift | KeyCode.KEY_X
	            }
	        }) || this;
	    }
	    WriteCode.prototype.run = function (accessor, editor) {
	        /** Load current contents */
	        var contents = monacoUtils_1.getSelectionOrCurrentLine(editor);
	        /** Replace with nothing */
	        monacoUtils_1.replaceSelection({ editor: editor, newText: '' });
	        /** Send keys one by one */
	        var model = editor.getModel();
	        var currentPos = editor.getSelection().getStartPosition();
	        (function () {
	            return __awaiter(this, void 0, void 0, function () {
	                var i, _i, _a, char;
	                return __generator(this, function (_b) {
	                    switch (_b.label) {
	                        case 0:
	                            autoCloseTag_1.disableAutoClose();
	                            /** Wait a bit before starting. Helps us get a clean start screenshot. */
	                            return [4 /*yield*/, utils.delay(500)];
	                        case 1:
	                            /** Wait a bit before starting. Helps us get a clean start screenshot. */
	                            _b.sent();
	                            i = 0;
	                            _i = 0, _a = contents.split('');
	                            _b.label = 2;
	                        case 2:
	                            if (!(_i < _a.length)) return [3 /*break*/, 8];
	                            char = _a[_i];
	                            monacoUtils_1.writeString({ model: model, str: char, pos: { lineNumber: currentPos.lineNumber, column: currentPos.column } });
	                            if (!!char.match(/\s/g)) return [3 /*break*/, 4];
	                            // 160 words per minute (VERY FAST TYPING!)
	                            // => 10 chars per second
	                            // => 100ms
	                            // + personal taste tweek gives us:
	                            return [4 /*yield*/, utils.delay(120)];
	                        case 3:
	                            // 160 words per minute (VERY FAST TYPING!)
	                            // => 10 chars per second
	                            // => 100ms
	                            // + personal taste tweek gives us:
	                            _b.sent();
	                            return [3 /*break*/, 6];
	                        case 4: // For whitespace
	                        return [4 /*yield*/, utils.delay(20)];
	                        case 5:
	                            _b.sent();
	                            _b.label = 6;
	                        case 6:
	                            /**
	                             * Advance pos
	                             */
	                            currentPos = model.modifyPosition(currentPos, 1);
	                            /**
	                             * Ensure position is well scrolled into
	                             */
	                            editor.revealPosition(currentPos);
	                            _b.label = 7;
	                        case 7:
	                            _i++;
	                            return [3 /*break*/, 2];
	                        case 8:
	                            autoCloseTag_1.enableAutoClose();
	                            return [2 /*return*/];
	                    }
	                });
	            });
	        })();
	    };
	    return WriteCode;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new WriteCode());


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var csx = __webpack_require__(6);
	var ui = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var state = __webpack_require__(11);
	var commands = __webpack_require__(7);
	var Modal = __webpack_require__(28);
	var socketClient_1 = __webpack_require__(5);
	var styles_1 = __webpack_require__(10);
	var codeEditor_1 = __webpack_require__(60);
	var FindReferences = /** @class */ (function (_super) {
	    __extends(FindReferences, _super);
	    function FindReferences(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onChangeSelected = function (event) {
	            var keyStates = ui.getKeyStates(event);
	            if (keyStates.up || keyStates.tabPrevious) {
	                event.preventDefault();
	                var selectedIndex = utils.rangeLimited({ num: _this.state.selectedIndex - 1, min: 0, max: _this.props.data.references.length - 1, loopAround: true });
	                _this.setState({ selectedIndex: selectedIndex });
	            }
	            if (keyStates.down || keyStates.tabNext) {
	                event.preventDefault();
	                var selectedIndex = utils.rangeLimited({ num: _this.state.selectedIndex + 1, min: 0, max: _this.props.data.references.length - 1, loopAround: true });
	                _this.setState({ selectedIndex: selectedIndex });
	            }
	            if (keyStates.enter) {
	                event.preventDefault();
	                _this.openIndex(_this.state.selectedIndex);
	            }
	        };
	        _this.openIndex = function (index) {
	            var def = _this.props.data.references[index];
	            commands.doOpenOrFocusFile.emit({
	                filePath: def.filePath,
	                position: def.position
	            });
	            setTimeout(function () { _this.props.unmount(); });
	        };
	        _this.selectAndRefocus = function (index) {
	            _this.setState({ selectedIndex: index });
	            _this.focus();
	        };
	        _this.focus = function () {
	            var input = ReactDOM.findDOMNode(_this.refs.mainInput);
	            input.focus();
	        };
	        _this.state = {
	            selectedIndex: 0,
	        };
	        return _this;
	    }
	    FindReferences.prototype.componentDidMount = function () {
	        var _this = this;
	        this.disposible.add(commands.esc.on(function () {
	            _this.props.unmount();
	        }));
	        setTimeout(function () {
	            _this.focus();
	            var input = ReactDOM.findDOMNode(_this.refs.mainInput);
	            var len = input.value.length;
	            input.setSelectionRange(0, len);
	        });
	    };
	    FindReferences.prototype.componentDidUpdate = function () {
	        var _this = this;
	        setTimeout(function () {
	            var selected = ReactDOM.findDOMNode(_this.refs.selectedTabTitle);
	            if (selected) {
	                selected.scrollIntoViewIfNeeded(false);
	            }
	        });
	    };
	    FindReferences.prototype.render = function () {
	        var _this = this;
	        var references = this.props.data.references;
	        var selectedPreview = this.props.data.references[this.state.selectedIndex];
	        var filePathsRendered = references.map(function (item, i) {
	            var selected = i == _this.state.selectedIndex;
	            var active = selected ? styles.tabHeaderActive : {};
	            var ref = selected && "selectedTabTitle";
	            return (React.createElement("div", { ref: ref, key: item.filePath + i, style: csx.extend(styles.tabHeader, active, { overflow: 'hidden' }), onClick: function () { return _this.selectAndRefocus(i); }, onDoubleClick: function () { return _this.openIndex(i); } },
	                React.createElement("div", { title: item.filePath, style: { overflow: 'hidden', textOverflow: 'ellipsis' } },
	                    utils.getFileName(item.filePath),
	                    " (line: ",
	                    item.position.line + 1,
	                    ")")));
	        });
	        var previewRendered = React.createElement(codeEditor_1.CodeEditor, { key: selectedPreview.filePath, filePath: selectedPreview.filePath, readOnly: true, preview: selectedPreview.span });
	        return (React.createElement(Modal, { isOpen: true, onRequestClose: this.props.unmount },
	            React.createElement("div", { style: csx.extend(csx.vertical, csx.flex) },
	                React.createElement("div", { style: csx.extend(csx.horizontal, csx.content) },
	                    React.createElement("h4", null, "References"),
	                    React.createElement("div", { style: csx.flex }),
	                    React.createElement("div", { style: { fontSize: '0.9rem', color: 'grey' } },
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Esc"),
	                        " to exit ",
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Enter"),
	                        " to select",
	                        ' ',
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Up / Down"),
	                        " to see usages")),
	                React.createElement("input", { defaultValue: '', style: styles.hiddenInput, type: "text", ref: "mainInput", placeholder: "Filter", onKeyDown: this.onChangeSelected }),
	                React.createElement("div", { style: csx.extend(csx.horizontal, csx.flex, { overflow: 'hidden' }) },
	                    React.createElement("div", { style: { width: '200px', overflow: 'auto' } }, filePathsRendered),
	                    React.createElement("div", { style: csx.extend(csx.flex, csx.flexRoot, styles.modal.previewContainerStyle) }, previewRendered)))));
	    };
	    return FindReferences;
	}(ui.BaseComponent));
	exports.FindReferences = FindReferences;
	var monacoUtils = __webpack_require__(18);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var FindReferencesAction = /** @class */ (function (_super) {
	    __extends(FindReferencesAction, _super);
	    function FindReferencesAction() {
	        return _super.call(this, {
	            id: 'editor.action.findReferencesAction',
	            label: 'TypeScript: Find references',
	            alias: 'TypeScript: Find references',
	            precondition: EditorContextKeys.Focus,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.CtrlCmd | KeyMod.Shift | KeyCode.KEY_B
	            }
	        }) || this;
	    }
	    FindReferencesAction.prototype.run = function (accessor, editor) {
	        var filePath = editor.filePath;
	        if (!state.inActiveProjectFilePath(filePath)) {
	            ui.notifyInfoNormalDisappear('The current file is no in the active project');
	            return;
	        }
	        var position = monacoUtils.getCurrentPosition(editor);
	        socketClient_1.server.getReferences({ filePath: filePath, position: position }).then(function (res) {
	            if (res.references.length == 0) {
	                ui.notifyInfoNormalDisappear('No references for item at cursor location');
	            }
	            else if (res.references.length == 1) {
	                // Go directly 🌹
	                var def = res.references[0];
	                commands.doOpenOrFocusFile.emit({
	                    filePath: def.filePath,
	                    position: def.position
	                });
	            }
	            else {
	                var _a = ui.getUnmountableNode(), node = _a.node, unmount = _a.unmount;
	                ReactDOM.render(React.createElement(FindReferences, { data: res, unmount: unmount }), node);
	            }
	        });
	    };
	    return FindReferencesAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new FindReferencesAction());


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var ui = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var state = __webpack_require__(11);
	var commands = __webpack_require__(7);
	var Modal = __webpack_require__(28);
	var socketClient_1 = __webpack_require__(5);
	var styles_1 = __webpack_require__(10);
	var codeEditor_1 = __webpack_require__(60);
	var GotoDefinition = /** @class */ (function (_super) {
	    __extends(GotoDefinition, _super);
	    function GotoDefinition(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onChangeSelected = function (event) {
	            var keyStates = ui.getKeyStates(event);
	            if (keyStates.up || keyStates.tabPrevious) {
	                event.preventDefault();
	                var selectedIndex = utils.rangeLimited({ num: _this.state.selectedIndex - 1, min: 0, max: _this.props.data.definitions.length - 1, loopAround: true });
	                _this.setState({ selectedIndex: selectedIndex });
	            }
	            if (keyStates.down || keyStates.tabNext) {
	                event.preventDefault();
	                var selectedIndex = utils.rangeLimited({ num: _this.state.selectedIndex + 1, min: 0, max: _this.props.data.definitions.length - 1, loopAround: true });
	                _this.setState({ selectedIndex: selectedIndex });
	            }
	            if (keyStates.enter) {
	                event.preventDefault();
	                _this.openIndex(_this.state.selectedIndex);
	            }
	        };
	        _this.openIndex = function (index) {
	            var def = _this.props.data.definitions[index];
	            commands.doOpenOrFocusFile.emit({
	                filePath: def.filePath,
	                position: def.position
	            });
	            setTimeout(function () { _this.props.unmount(); });
	        };
	        _this.selectAndRefocus = function (index) {
	            _this.setState({ selectedIndex: index });
	            _this.focus();
	        };
	        _this.focus = function () {
	            var input = ReactDOM.findDOMNode(_this.refs.mainInput);
	            input.focus();
	        };
	        _this.state = {
	            selectedIndex: 0,
	        };
	        return _this;
	    }
	    GotoDefinition.prototype.componentDidMount = function () {
	        var _this = this;
	        this.disposible.add(commands.esc.on(function () {
	            _this.props.unmount();
	        }));
	        setTimeout(function () {
	            _this.focus();
	            var input = ReactDOM.findDOMNode(_this.refs.mainInput);
	            var len = input.value.length;
	            input.setSelectionRange(0, len);
	        });
	    };
	    GotoDefinition.prototype.componentDidUpdate = function () {
	        var _this = this;
	        setTimeout(function () {
	            var selected = ReactDOM.findDOMNode(_this.refs.selectedTabTitle);
	            if (selected) {
	                selected.scrollIntoViewIfNeeded(false);
	            }
	        });
	    };
	    GotoDefinition.prototype.render = function () {
	        var _this = this;
	        var definitions = this.props.data.definitions;
	        var selectedPreview = this.props.data.definitions[this.state.selectedIndex];
	        var filePathsRendered = definitions.map(function (item, i) {
	            var selected = i == _this.state.selectedIndex;
	            var active = selected ? styles.tabHeaderActive : {};
	            var ref = selected && "selectedTabTitle";
	            return (React.createElement("div", { ref: ref, key: item.filePath + i, style: csx.extend(styles.tabHeader, active, { overflow: 'hidden' }), onClick: function () { return _this.selectAndRefocus(i); }, onDoubleClick: function () { return _this.openIndex(i); } },
	                React.createElement("div", { title: item.filePath, style: { overflow: 'hidden', textOverflow: 'ellipsis' } },
	                    utils.getFileName(item.filePath),
	                    " (line: ",
	                    item.position.line + 1,
	                    ")")));
	        });
	        var previewRendered = React.createElement(codeEditor_1.CodeEditor, { key: selectedPreview.filePath, filePath: selectedPreview.filePath, readOnly: true, preview: selectedPreview.span });
	        return (React.createElement(Modal, { isOpen: true, onRequestClose: this.props.unmount },
	            React.createElement("div", { style: csx.extend(csx.vertical, csx.flex) },
	                React.createElement("div", { style: csx.extend(csx.horizontal, csx.content) },
	                    React.createElement("h4", null, "Multiple Definitions Found"),
	                    React.createElement("div", { style: csx.flex }),
	                    React.createElement("div", { style: { fontSize: '0.9rem', color: 'grey' } },
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Esc"),
	                        " to exit ",
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Enter"),
	                        " to select",
	                        ' ',
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Up / Down"),
	                        " to see usages")),
	                React.createElement("input", { defaultValue: '', style: styles.hiddenInput, type: "text", ref: "mainInput", placeholder: "Filter", onKeyDown: this.onChangeSelected }),
	                React.createElement("div", { style: csx.extend(csx.horizontal, csx.flex, { overflow: 'hidden' }) },
	                    React.createElement("div", { style: { width: '200px', overflow: 'auto' } }, filePathsRendered),
	                    React.createElement("div", { style: csx.extend(csx.flex, csx.flexRoot, styles.modal.previewContainerStyle) }, previewRendered)))));
	    };
	    return GotoDefinition;
	}(ui_1.BaseComponent));
	exports.GotoDefinition = GotoDefinition;
	var monacoUtils = __webpack_require__(18);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyMod = monaco.KeyMod;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var GotoDefinitionAction = /** @class */ (function (_super) {
	    __extends(GotoDefinitionAction, _super);
	    function GotoDefinitionAction() {
	        return _super.call(this, {
	            id: 'editor.action.gotoDefinition',
	            label: 'TypeScript: Goto Definition',
	            alias: 'TypeScript: Goto Definition',
	            precondition: EditorContextKeys.Focus,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyMod.CtrlCmd | KeyCode.KEY_B
	            }
	        }) || this;
	    }
	    GotoDefinitionAction.prototype.run = function (accessor, editor) {
	        var filePath = editor.filePath;
	        if (!state.inActiveProjectFilePath(filePath)) {
	            ui.notifyInfoNormalDisappear('The current file is no in the active project');
	            return;
	        }
	        var position = monacoUtils.getCurrentPosition(editor);
	        socketClient_1.server.getDefinitionsAtPosition({ filePath: filePath, position: position }).then(function (res) {
	            if (res.definitions.length == 0) {
	                ui.notifyInfoNormalDisappear('No TypeScript definition at cursor location');
	            }
	            else if (res.definitions.length == 1) {
	                // Go directly 🌹
	                var def = res.definitions[0];
	                commands.doOpenOrFocusFile.emit({
	                    filePath: def.filePath,
	                    position: def.position
	                });
	            }
	            else {
	                var _a = ui.getUnmountableNode(), node = _a.node, unmount = _a.unmount;
	                ReactDOM.render(React.createElement(GotoDefinition, { data: res, unmount: unmount }), node);
	            }
	        });
	    };
	    return GotoDefinitionAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new GotoDefinitionAction());


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var ui = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var state = __webpack_require__(11);
	var uix = __webpack_require__(41);
	var commands = __webpack_require__(7);
	var Modal = __webpack_require__(28);
	var socketClient_1 = __webpack_require__(5);
	var styles_1 = __webpack_require__(10);
	var codeEditor_1 = __webpack_require__(60);
	var typestyle = __webpack_require__(13);
	var inputClassName = typestyle.style(styles.modal.inputStyleBase);
	var validationErrorStyle = {
	    color: 'red',
	    fontFamily: 'monospace',
	    fontSize: '1.2rem',
	    padding: '5px',
	};
	var summaryStyle = {
	    padding: '5px',
	    backgroundColor: '#222',
	    color: '#CCC',
	    fontSize: '.8rem',
	};
	var RenameVariable = /** @class */ (function (_super) {
	    __extends(RenameVariable, _super);
	    function RenameVariable(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onChangeFilter = function (e) {
	            var newText = ReactDOM.findDOMNode(_this.refs.mainInput).value;
	            if (newText.replace(/\s/g, '') !== newText.trim()) {
	                _this.setState({ invalidMessage: 'The new variable must not contain a space' });
	            }
	            else if (!newText.trim()) {
	                _this.setState({ invalidMessage: 'Please provide a new name or press esc to abort rename' });
	            }
	            else {
	                _this.setState({ invalidMessage: '' });
	            }
	        };
	        _this.onChangeSelected = function (event) {
	            var keyStates = ui.getKeyStates(event);
	            if (keyStates.up || keyStates.tabPrevious) {
	                event.preventDefault();
	                var selectedIndex = utils.rangeLimited({ num: _this.state.selectedIndex - 1, min: 0, max: _this.state.flattened.length - 1, loopAround: true });
	                _this.setState({ selectedIndex: selectedIndex });
	            }
	            if (keyStates.down || keyStates.tabNext) {
	                event.preventDefault();
	                var selectedIndex = utils.rangeLimited({ num: _this.state.selectedIndex + 1, min: 0, max: _this.state.flattened.length - 1, loopAround: true });
	                _this.setState({ selectedIndex: selectedIndex });
	            }
	            if (keyStates.enter) {
	                event.preventDefault();
	                var newText_1 = ReactDOM.findDOMNode(_this.refs.mainInput).value.trim();
	                var refactorings_1 = {};
	                Object.keys(_this.props.info.locations).map(function (filePath) {
	                    refactorings_1[filePath] = [];
	                    var forPath = refactorings_1[filePath];
	                    _this.props.info.locations[filePath].forEach(function (loc) {
	                        var refactoring = {
	                            filePath: filePath,
	                            span: loc,
	                            newText: newText_1
	                        };
	                        forPath.push(refactoring);
	                    });
	                });
	                uix.API.applyRefactorings(refactorings_1);
	                setTimeout(function () { _this.props.unmount(); });
	            }
	        };
	        _this.selectAndRefocus = function (index) {
	            _this.setState({ selectedIndex: index });
	            _this.focus();
	        };
	        _this.focus = function () {
	            var input = ReactDOM.findDOMNode(_this.refs.mainInput);
	            input.focus();
	        };
	        var flattended = utils.selectMany(Object.keys(props.info.locations).map(function (filePath) {
	            var refs = props.info.locations[filePath].slice().reverse();
	            return refs.map(function (preview, i) {
	                return {
	                    filePath: filePath,
	                    preview: preview,
	                    indexForFilePath: i + 1,
	                    totalForFilePath: refs.length,
	                };
	            });
	        }));
	        _this.state = {
	            selectedIndex: 0,
	            flattened: flattended
	        };
	        return _this;
	    }
	    RenameVariable.prototype.componentDidMount = function () {
	        var _this = this;
	        this.disposible.add(commands.esc.on(function () {
	            _this.props.unmount();
	        }));
	        setTimeout(function () {
	            _this.focus();
	            var input = ReactDOM.findDOMNode(_this.refs.mainInput);
	            var len = input.value.length;
	            input.setSelectionRange(0, len);
	        });
	    };
	    RenameVariable.prototype.componentDidUpdate = function () {
	        var _this = this;
	        setTimeout(function () {
	            var selected = ReactDOM.findDOMNode(_this.refs.selectedTabTitle);
	            if (selected) {
	                selected.scrollIntoViewIfNeeded(false);
	            }
	        });
	    };
	    RenameVariable.prototype.render = function () {
	        var _this = this;
	        var selectedPreview = this.state.flattened[this.state.selectedIndex];
	        var filePathsRendered = this.state.flattened.map(function (item, i) {
	            var selected = i == _this.state.selectedIndex;
	            var active = selected ? styles.tabHeaderActive : {};
	            var ref = selected && "selectedTabTitle";
	            return (React.createElement("div", { ref: ref, key: item.filePath + i, style: csx.extend(styles.tabHeader, active, { overflow: 'hidden' }), onClick: function () { return _this.selectAndRefocus(i); } },
	                React.createElement("div", { title: item.filePath, style: { overflow: 'hidden', textOverflow: 'ellipsis' } },
	                    utils.getFileName(item.filePath),
	                    " (",
	                    item.indexForFilePath,
	                    " of ",
	                    item.totalForFilePath,
	                    ")")));
	        });
	        var previewRendered = React.createElement(codeEditor_1.CodeEditor, { key: selectedPreview.filePath, filePath: selectedPreview.filePath, readOnly: true, preview: selectedPreview.preview });
	        return (React.createElement(Modal, { isOpen: true, onRequestClose: this.props.unmount },
	            React.createElement("div", { style: csx.extend(csx.vertical, csx.flex) },
	                React.createElement("div", { style: csx.extend(csx.horizontal, csx.content) },
	                    React.createElement("h4", null, "Rename"),
	                    React.createElement("div", { style: csx.flex }),
	                    React.createElement("div", { style: { fontSize: '0.9rem', color: 'grey' } },
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Esc"),
	                        " to exit ",
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Enter"),
	                        " to select",
	                        ' ',
	                        React.createElement("code", { style: styles_1.modal.keyStrokeStyle }, "Up / Down"),
	                        " to see usages")),
	                React.createElement("div", { style: csx.extend(styles.padded1TopBottom, csx.vertical, csx.content) },
	                    React.createElement("input", { defaultValue: this.props.info.displayName, className: inputClassName, type: "text", ref: "mainInput", placeholder: "Filter", onChange: this.onChangeFilter, onKeyDown: this.onChangeSelected })),
	                this.state.invalidMessage &&
	                    React.createElement("div", { style: csx.extend(csx.content, validationErrorStyle) }, this.state.invalidMessage),
	                React.createElement("div", { style: csx.extend(csx.content, summaryStyle) },
	                    this.state.flattened.length,
	                    " usages, ",
	                    this.props.alreadyOpenFilePaths.length,
	                    " files open,  ",
	                    this.props.currentlyClosedFilePaths.length,
	                    " files closed"),
	                React.createElement("div", { style: csx.extend(csx.horizontal, csx.flex, { overflow: 'hidden' }) },
	                    React.createElement("div", { style: { width: '200px', overflow: 'auto' } }, filePathsRendered),
	                    React.createElement("div", { style: csx.extend(csx.flex, csx.flexRoot, styles.modal.previewContainerStyle) }, previewRendered)))));
	    };
	    return RenameVariable;
	}(ui_1.BaseComponent));
	exports.RenameVariable = RenameVariable;
	var monacoUtils = __webpack_require__(18);
	var CommonEditorRegistry = monaco.CommonEditorRegistry;
	var EditorAction = monaco.EditorAction;
	var KeyCode = monaco.KeyCode;
	var EditorContextKeys = monaco.EditorContextKeys;
	var RenameVariableAction = /** @class */ (function (_super) {
	    __extends(RenameVariableAction, _super);
	    function RenameVariableAction() {
	        return _super.call(this, {
	            id: 'editor.action.renameVariable',
	            label: 'TypeScript: Rename Variable',
	            alias: 'TypeScript: Rename Variable',
	            precondition: EditorContextKeys.Writable,
	            kbOpts: {
	                kbExpr: EditorContextKeys.TextFocus,
	                primary: KeyCode.F2
	            }
	        }) || this;
	    }
	    RenameVariableAction.prototype.run = function (accessor, editor) {
	        var filePath = editor.filePath;
	        if (!state.inActiveProjectFilePath(filePath)) {
	            ui.notifyInfoNormalDisappear('The current file is no in the active project');
	            return;
	        }
	        var position = monacoUtils.getCurrentPosition(editor);
	        socketClient_1.server.getRenameInfo({ filePath: filePath, position: position }).then(function (res) {
	            if (!res.canRename) {
	                ui.notifyInfoNormalDisappear("Rename not available at cursor location");
	            }
	            else {
	                var filePaths = Object.keys(res.locations);
	                // if there is only a single file path and that is the current and there aren't that many usages
	                // we do the rename inline
	                if (filePaths.length == 1
	                    && filePaths[0] == filePath
	                    && res.locations[filePath].length < 5) {
	                    selectName(editor, res.locations[filePath]);
	                }
	                else {
	                    var _a = uix.API.getClosedVsOpenFilePaths(filePaths), alreadyOpenFilePaths = _a.alreadyOpenFilePaths, currentlyClosedFilePaths = _a.currentlyClosedFilePaths;
	                    var _b = ui.getUnmountableNode(), node = _b.node, unmount = _b.unmount;
	                    ReactDOM.render(React.createElement(RenameVariable, { info: res, alreadyOpenFilePaths: alreadyOpenFilePaths, currentlyClosedFilePaths: currentlyClosedFilePaths, unmount: unmount }), node);
	                }
	            }
	        });
	    };
	    return RenameVariableAction;
	}(EditorAction));
	CommonEditorRegistry.registerEditorAction(new RenameVariableAction());
	/** Selects the locations keeping the current one as the first (to allow easy escape back to current cursor) */
	function selectName(editor, locations) {
	    var ranges = [];
	    var curPos = editor.getSelection();
	    for (var i = 0; i < locations.length; i++) {
	        var ref = locations[i];
	        var from = editor.getModel().getPositionAt(ref.start);
	        var to = editor.getModel().getPositionAt(ref.start + ref.length);
	        var range = new monaco.Range(from.lineNumber, from.column, to.lineNumber, to.column);
	        var selection = {
	            selectionStartLineNumber: from.lineNumber,
	            selectionStartColumn: from.column,
	            positionLineNumber: to.lineNumber,
	            positionColumn: to.column
	        };
	        if (!monaco.Range.containsRange(range, curPos))
	            ranges.push(selection);
	        else
	            ranges.unshift(selection);
	    }
	    editor.setSelections(ranges);
	}


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils = __webpack_require__(3);
	var monacoUtils = __webpack_require__(18);
	var jsonCompletions2_1 = __webpack_require__(433);
	var CompletionAdapter = /** @class */ (function () {
	    function CompletionAdapter() {
	    }
	    Object.defineProperty(CompletionAdapter.prototype, "triggerCharacters", {
	        get: function () {
	            return [' ', ':'];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CompletionAdapter.prototype.provideCompletionItems = function (model, position, token) {
	        var wordInfo = model.getWordUntilPosition(position);
	        var filePath = model.filePath;
	        var prefix = wordInfo.word;
	        var offset = monacoUtils.positionToOffset(model, position);
	        var result = {
	            isIncomplete: false,
	            items: []
	        };
	        if (!utils.isSupportedConfigFileForAutocomplete(filePath)) {
	            return Promise.resolve(result);
	        }
	        return jsonCompletions2_1.getCompletionsAtPosition(model, position).then(function (res) {
	            return res;
	        });
	    };
	    CompletionAdapter.prototype.resolveCompletionItem = function (item, token) {
	        return Promise.resolve(item);
	    };
	    return CompletionAdapter;
	}());
	exports.CompletionAdapter = CompletionAdapter;


/***/ },
/* 427 */
/***/ function(module, exports) {

	// https://github.com/Microsoft/vscode/blob/master/extensions/json/server/src/jsonLocation.ts
	/*---------------------------------------------------------------------------------------------
	 *  Copyright (c) Microsoft Corporation. All rights reserved.
	 *  Licensed under the MIT License. See License.txt in the project root for license information.
	 *--------------------------------------------------------------------------------------------*/
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var JSONLocation = /** @class */ (function () {
	    function JSONLocation(segments) {
	        this.segments = segments;
	    }
	    JSONLocation.prototype.append = function (segment) {
	        return new JSONLocation(this.segments.concat(segment));
	    };
	    JSONLocation.prototype.getSegments = function () {
	        return this.segments;
	    };
	    JSONLocation.prototype.matches = function (segments) {
	        var k = 0;
	        for (var i = 0; k < segments.length && i < this.segments.length; i++) {
	            if (segments[k] === this.segments[i] || segments[k] === '*') {
	                k++;
	            }
	            else if (segments[k] !== '**') {
	                return false;
	            }
	        }
	        return k === segments.length;
	    };
	    JSONLocation.prototype.toString = function () {
	        return '[' + this.segments.join('][') + ']';
	    };
	    return JSONLocation;
	}());
	exports.JSONLocation = JSONLocation;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonFormatter = __webpack_require__(434);
	var DocumentFormattingEditProvider = /** @class */ (function () {
	    function DocumentFormattingEditProvider() {
	    }
	    DocumentFormattingEditProvider.prototype.provideDocumentFormattingEdits = function (model, options, token) {
	        return Promise.resolve(jsonFormatter.format(model, model.getFullModelRange(), options));
	    };
	    return DocumentFormattingEditProvider;
	}());
	exports.DocumentFormattingEditProvider = DocumentFormattingEditProvider;
	var DocumentRangeFormattingEditProvider = /** @class */ (function () {
	    function DocumentRangeFormattingEditProvider() {
	    }
	    DocumentRangeFormattingEditProvider.prototype.provideDocumentRangeFormattingEdits = function (model, range, options, token) {
	        return Promise.resolve(jsonFormatter.format(model, range, options));
	    };
	    return DocumentRangeFormattingEditProvider;
	}());
	exports.DocumentRangeFormattingEditProvider = DocumentRangeFormattingEditProvider;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Had a look at https://github.com/Microsoft/vscode/blob/6e8f6596175fda10b69ee9ba33caf45b5ad7e579/extensions/javascript/src/features/packageJSONContribution.ts#L206
	 *
	 * To figure out how to get this.
	 *
	 * Basically the `jsonc-parser` is really handy:
	 *
	 * ```ts
	 * const doc = Parser.parse(contents);
	 * let node = doc.getNodeFromOffsetEndInclusive(offset);
	 * let location = node.getNodeLocation();
	 * ```
	 * Both `node` and `location` are extremely handy
	 *
	 * Also validation:
	 *
	 ```ts
	 const doc = Parser.parse(contents);
	
	 // TODO: validation :)
	 if (!doc.errors.length) {
	     doc.validate(schema);
	     // console.log('Schema Validation:',doc.errors,doc.warnings);
	 }
	 else {
	     // console.log('Parse Errors:', doc.errors);
	 }
	 ```
	 *
	 */
	var Parser = __webpack_require__(161);
	var packageJsonDependenciesSections = [
	    'dependencies',
	    'devDependencies',
	    'optionalDependencies',
	    'peerDependencies',
	];
	var utils = __webpack_require__(3);
	var socketClient_1 = __webpack_require__(5);
	var ProvideHover = /** @class */ (function () {
	    function ProvideHover() {
	    }
	    ProvideHover.prototype.provideHover = function (model, pos, token) {
	        var wordInfo = model.getWordUntilPosition(pos);
	        var response = {
	            range: {
	                startLineNumber: pos.lineNumber,
	                endLineNumber: pos.lineNumber,
	                startColumn: wordInfo.startColumn,
	                endColumn: wordInfo.endColumn,
	            },
	            contents: [],
	        };
	        var filePath = model.filePath;
	        var fileName = utils.getFileName(filePath).toLowerCase();
	        var offset = model.getOffsetAt(pos);
	        var contents = model.getValue();
	        var doc = Parser.parse(contents);
	        var node = doc.getNodeFromOffsetEndInclusive(offset);
	        var location = node.getNodeLocation();
	        /**
	         * Provide intelligence based on file name
	         */
	        if (fileName === "package.json") {
	            /** Provide latest version hint for depencencies */
	            if (packageJsonDependenciesSections.some(function (section) { return location.matches([section, '*']); })) {
	                var path = location.getSegments(); // e.g. ["devDependencies", "mocha"]
	                var pack = path[path.length - 1];
	                if (typeof pack === 'string') {
	                    return socketClient_1.server.npmLatest({ pack: pack }).then(function (res) {
	                        // console.log(res);
	                        if (!res.description && !res.version)
	                            return response;
	                        res.description && response.contents.push("**" + res.description + "**");
	                        res.version && response.contents.push("Latest version: " + res.version);
	                        return response;
	                    });
	                }
	            }
	        }
	        return utils.resolve(response);
	    };
	    return ProvideHover;
	}());
	exports.ProvideHover = ProvideHover;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tokenization_1 = __webpack_require__(436);
	var autocomplete_1 = __webpack_require__(426);
	var jsonHover_1 = __webpack_require__(429);
	var formatting_1 = __webpack_require__(428);
	function setupMonacoJson() {
	    monaco.languages.register({
	        id: 'json',
	        extensions: ['.json', '.bowerrc', '.jshintrc', '.jscsrc', '.eslintrc', '.babelrc'],
	        aliases: ['JSON', 'json'],
	        mimetypes: ['application/json'],
	    });
	    monaco.languages.onLanguage('json', function () {
	        var languageId = 'json';
	        // Tokenizer
	        monaco.languages.setTokensProvider(languageId, tokenization_1.createTokenizationSupport(true));
	        /** Setup bracket matching etc. */
	        monaco.languages.setLanguageConfiguration(languageId, richEditConfiguration);
	        /** Setup Completion Adapter */
	        monaco.languages.registerCompletionItemProvider(languageId, new autocomplete_1.CompletionAdapter());
	        /** Setup hover support */
	        monaco.languages.registerHoverProvider(languageId, new jsonHover_1.ProvideHover());
	        /** Formatting */
	        monaco.languages.registerDocumentFormattingEditProvider(languageId, new formatting_1.DocumentFormattingEditProvider());
	        monaco.languages.registerDocumentRangeFormattingEditProvider(languageId, new formatting_1.DocumentRangeFormattingEditProvider());
	    });
	}
	exports.setupMonacoJson = setupMonacoJson;
	var richEditConfiguration = {
	    wordPattern: /(-?\d*\.\d\w*)|([^\[\{\]\}\:\"\,\s]+)/g,
	    comments: {
	        lineComment: '//',
	        blockComment: ['/*', '*/']
	    },
	    brackets: [
	        ['{', '}'],
	        ['[', ']']
	    ],
	    autoClosingPairs: [
	        { open: '{', close: '}', notIn: ['string'] },
	        { open: '[', close: ']', notIn: ['string'] },
	        { open: '"', close: '"', notIn: ['string'] }
	    ]
	};


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./alm": 98,
		"./alm.json": 98,
		"./package": 99,
		"./package.json": 99,
		"./tsconfig": 100,
		"./tsconfig.json": 100,
		"./tslint": 101,
		"./tslint.json": 101
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 431;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Based on https://github.com/Microsoft/vscode-json-languageservice/blob/master/src/services/jsonCompletion.ts
	 *
	 * - Redirected dependencies
	 * - I deleted stuff around `jsonContributions` (I have no idea what it is)
	 * - Changed TextModel => monaco.IModel
	 * - Removed any constructor parameters
	 */
	/*---------------------------------------------------------------------------------------------
	 *  Copyright (c) Microsoft Corporation. All rights reserved.
	 *  Licensed under the MIT License. See License.txt in the project root for license information.
	 *--------------------------------------------------------------------------------------------*/
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	/** BAS the function that was provided by vscode-nls */
	var localize_1 = __webpack_require__(85);
	var schemaService = __webpack_require__(435);
	var CompletionItemKind = monaco.languages.CompletionItemKind;
	var Range = monaco.Range;
	/**
	 * BAS: Was simple so I wrote it :)
	 */
	var TextEdit;
	(function (TextEdit) {
	    function replace(range, text) {
	        var result = {
	            range: range,
	            text: text
	        };
	        return result;
	    }
	    TextEdit.replace = replace;
	})(TextEdit || (TextEdit = {}));
	var JSONCompletion = /** @class */ (function () {
	    function JSONCompletion() {
	        this.promise = Promise;
	    }
	    JSONCompletion.prototype.doComplete = function (document, position, doc) {
	        var _this = this;
	        var offset = document.getOffsetAt(position);
	        var node = doc.getNodeFromOffsetEndInclusive(offset);
	        var currentWord = this.getCurrentWord(document, offset);
	        var overwriteRange = null;
	        var filterText = void 0;
	        var result = {
	            items: [],
	            isIncomplete: false
	        };
	        if (node && (node.type === 'string' || node.type === 'number' || node.type === 'boolean' || node.type === 'null')) {
	            var start = document.getPositionAt(node.start);
	            var end = document.getPositionAt(node.end);
	            overwriteRange = new Range(start.lineNumber, start.column, end.lineNumber, end.column);
	            filterText = document.getValue().substring(node.start, offset);
	        }
	        else {
	            var start = document.getPositionAt(offset - currentWord.length);
	            var end = position;
	            overwriteRange = new Range(start.lineNumber, start.column, end.lineNumber, end.column);
	            filterText = document.getValue().substring(offset - currentWord.length, offset);
	        }
	        var proposed = {};
	        var collector = {
	            add: function (suggestion) {
	                if (!proposed[suggestion.label]) {
	                    proposed[suggestion.label] = true;
	                    if (overwriteRange) {
	                        suggestion.textEdit = TextEdit.replace(overwriteRange, suggestion.insertText.toString());
	                        suggestion.filterText = filterText;
	                    }
	                    result.items.push(suggestion);
	                }
	            },
	            setAsIncomplete: function () {
	                result.isIncomplete = true;
	            },
	            error: function (message) {
	                console.error(message);
	            },
	            log: function (message) {
	                console.log(message);
	            }
	        };
	        return schemaService.getSchemaForResource(document.filePath).then(function (schema) {
	            var collectionPromises = [];
	            var addValue = true;
	            var currentKey = '';
	            var currentProperty = null;
	            if (node) {
	                if (node.type === 'string') {
	                    var stringNode = node;
	                    if (stringNode.isKey) {
	                        addValue = !(node.parent && (node.parent.value));
	                        currentProperty = node.parent ? node.parent : null;
	                        currentKey = document.getValue().substring(node.start + 1, node.end - 1);
	                        if (node.parent) {
	                            node = node.parent.parent;
	                        }
	                    }
	                }
	            }
	            // proposals for properties
	            if (node && node.type === 'object') {
	                // don't suggest keys when the cursor is just before the opening curly brace
	                if (node.start === offset) {
	                    return result;
	                }
	                // don't suggest properties that are already present
	                var properties = node.properties;
	                properties.forEach(function (p) {
	                    if (!currentProperty || currentProperty !== p) {
	                        proposed[p.key.value] = true;
	                    }
	                });
	                var isLast = properties.length === 0 || offset >= properties[properties.length - 1].start;
	                if (schema) {
	                    // property proposals with schema
	                    _this.getPropertySuggestions(schema, doc, node, addValue, isLast, collector);
	                }
	                else {
	                    // property proposals without schema
	                    _this.getSchemaLessPropertySuggestions(doc, node, currentKey, currentWord, isLast, collector);
	                }
	            }
	            // proposals for values
	            if (node && (node.type === 'string' || node.type === 'number' || node.type === 'boolean' || node.type === 'null')) {
	                node = node.parent;
	            }
	            if (schema) {
	                // value proposals with schema
	                _this.getValueSuggestions(schema, doc, node, offset, collector);
	            }
	            else {
	                // value proposals without schema
	                _this.getSchemaLessValueSuggestions(doc, node, offset, document, collector);
	            }
	            if (!node) {
	            }
	            else {
	                if ((node.type === 'property') && offset > node.colonOffset) {
	                    var parentKey = node.key.value;
	                    var valueNode = node.value;
	                    if (!valueNode || offset <= valueNode.end) {
	                    }
	                }
	            }
	            return _this.promise.all(collectionPromises).then(function () { return result; });
	        });
	    };
	    JSONCompletion.prototype.getPropertySuggestions = function (schema, doc, node, addValue, isLast, collector) {
	        var _this = this;
	        var matchingSchemas = [];
	        doc.validate(schema.schema, matchingSchemas, node.start);
	        matchingSchemas.forEach(function (s) {
	            if (s.node === node && !s.inverted) {
	                var schemaProperties_1 = s.schema.properties;
	                if (schemaProperties_1) {
	                    Object.keys(schemaProperties_1).forEach(function (key) {
	                        var propertySchema = schemaProperties_1[key];
	                        collector.add({ kind: CompletionItemKind.Property, label: key, insertText: _this.getTextForProperty(key, propertySchema, addValue, isLast), documentation: propertySchema.description || '' });
	                    });
	                }
	            }
	        });
	    };
	    JSONCompletion.prototype.getSchemaLessPropertySuggestions = function (doc, node, currentKey, currentWord, isLast, collector) {
	        var _this = this;
	        var collectSuggestionsForSimilarObject = function (obj) {
	            obj.properties.forEach(function (p) {
	                var key = p.key.value;
	                collector.add({ kind: CompletionItemKind.Property, label: key, insertText: _this.getTextForSimilarProperty(key, p.value), documentation: '' });
	            });
	        };
	        if (node.parent) {
	            if (node.parent.type === 'property') {
	                // if the object is a property value, check the tree for other objects that hang under a property of the same name
	                var parentKey_1 = node.parent.key.value;
	                doc.visit(function (n) {
	                    if (n.type === 'property' && n.key.value === parentKey_1 && n.value && n.value.type === 'object') {
	                        collectSuggestionsForSimilarObject(n.value);
	                    }
	                    return true;
	                });
	            }
	            else if (node.parent.type === 'array') {
	                // if the object is in an array, use all other array elements as similar objects
	                node.parent.items.forEach(function (n) {
	                    if (n.type === 'object' && n !== node) {
	                        collectSuggestionsForSimilarObject(n);
	                    }
	                });
	            }
	        }
	        if (!currentKey && currentWord.length > 0) {
	            collector.add({ kind: CompletionItemKind.Property, label: this.getLabelForValue(currentWord), insertText: this.getTextForProperty(currentWord, null, true, isLast), documentation: '' });
	        }
	    };
	    JSONCompletion.prototype.getSchemaLessValueSuggestions = function (doc, node, offset, document, collector) {
	        var _this = this;
	        var collectSuggestionsForValues = function (value) {
	            if (!value.contains(offset)) {
	                var content = _this.getTextForMatchingNode(value, document);
	                collector.add({ kind: _this.getSuggestionKind(value.type), label: content, insertText: content, documentation: '' });
	            }
	            if (value.type === 'boolean') {
	                _this.addBooleanSuggestion(!value.getValue(), collector);
	            }
	        };
	        if (!node) {
	            collector.add({ kind: this.getSuggestionKind('object'), label: 'Empty object', insertText: '{\n\t{{}}\n}', documentation: '' });
	            collector.add({ kind: this.getSuggestionKind('array'), label: 'Empty array', insertText: '[\n\t{{}}\n]', documentation: '' });
	        }
	        else {
	            if (node.type === 'property' && offset > node.colonOffset) {
	                var valueNode = node.value;
	                if (valueNode && offset > valueNode.end) {
	                    return;
	                }
	                // suggest values at the same key
	                var parentKey_2 = node.key.value;
	                doc.visit(function (n) {
	                    if (n.type === 'property' && n.key.value === parentKey_2 && n.value) {
	                        collectSuggestionsForValues(n.value);
	                    }
	                    return true;
	                });
	            }
	            if (node.type === 'array') {
	                if (node.parent && node.parent.type === 'property') {
	                    // suggest items of an array at the same key
	                    var parentKey_3 = node.parent.key.value;
	                    doc.visit(function (n) {
	                        if (n.type === 'property' && n.key.value === parentKey_3 && n.value && n.value.type === 'array') {
	                            (n.value.items).forEach(function (n) {
	                                collectSuggestionsForValues(n);
	                            });
	                        }
	                        return true;
	                    });
	                }
	                else {
	                    // suggest items in the same array
	                    node.items.forEach(function (n) {
	                        collectSuggestionsForValues(n);
	                    });
	                }
	            }
	        }
	    };
	    JSONCompletion.prototype.getValueSuggestions = function (schema, doc, node, offset, collector) {
	        var _this = this;
	        if (!node) {
	            this.addDefaultSuggestion(schema.schema, collector);
	        }
	        else {
	            var parentKey_4 = null;
	            if (node && (node.type === 'property') && offset > node.colonOffset) {
	                var valueNode = node.value;
	                if (valueNode && offset > valueNode.end) {
	                    return; // we are past the value node
	                }
	                parentKey_4 = node.key.value;
	                node = node.parent;
	            }
	            if (node && (parentKey_4 !== null || node.type === 'array')) {
	                var matchingSchemas = [];
	                doc.validate(schema.schema, matchingSchemas, node.start);
	                matchingSchemas.forEach(function (s) {
	                    if (s.node === node && !s.inverted && s.schema) {
	                        if (s.schema.items) {
	                            _this.addDefaultSuggestion(s.schema.items, collector);
	                            _this.addEnumSuggestion(s.schema.items, collector);
	                        }
	                        if (s.schema.properties) {
	                            var propertySchema = s.schema.properties[parentKey_4];
	                            if (propertySchema) {
	                                _this.addDefaultSuggestion(propertySchema, collector);
	                                _this.addEnumSuggestion(propertySchema, collector);
	                            }
	                        }
	                    }
	                });
	            }
	        }
	    };
	    JSONCompletion.prototype.addBooleanSuggestion = function (value, collector) {
	        collector.add({ kind: this.getSuggestionKind('boolean'), label: value ? 'true' : 'false', insertText: this.getTextForValue(value), documentation: '' });
	    };
	    JSONCompletion.prototype.addNullSuggestion = function (collector) {
	        collector.add({ kind: this.getSuggestionKind('null'), label: 'null', insertText: 'null', documentation: '' });
	    };
	    JSONCompletion.prototype.addEnumSuggestion = function (schema, collector) {
	        var _this = this;
	        if (Array.isArray(schema.enum)) {
	            schema.enum.forEach(function (enm) { return collector.add({ kind: _this.getSuggestionKind(schema.type), label: _this.getLabelForValue(enm), insertText: _this.getTextForValue(enm), documentation: '' }); });
	        }
	        else {
	            if (this.isType(schema, 'boolean')) {
	                this.addBooleanSuggestion(true, collector);
	                this.addBooleanSuggestion(false, collector);
	            }
	            if (this.isType(schema, 'null')) {
	                this.addNullSuggestion(collector);
	            }
	        }
	        if (Array.isArray(schema.allOf)) {
	            schema.allOf.forEach(function (s) { return _this.addEnumSuggestion(s, collector); });
	        }
	        if (Array.isArray(schema.anyOf)) {
	            schema.anyOf.forEach(function (s) { return _this.addEnumSuggestion(s, collector); });
	        }
	        if (Array.isArray(schema.oneOf)) {
	            schema.oneOf.forEach(function (s) { return _this.addEnumSuggestion(s, collector); });
	        }
	    };
	    JSONCompletion.prototype.isType = function (schema, type) {
	        if (Array.isArray(schema.type)) {
	            return schema.type.indexOf(type) !== -1;
	        }
	        return schema.type === type;
	    };
	    JSONCompletion.prototype.addDefaultSuggestion = function (schema, collector) {
	        var _this = this;
	        if (schema.default) {
	            collector.add({
	                kind: this.getSuggestionKind(schema.type),
	                label: this.getLabelForValue(schema.default),
	                insertText: this.getTextForValue(schema.default),
	                detail: localize_1.localize('json.suggest.default', 'Default value'),
	            });
	        }
	        if (Array.isArray(schema.defaultSnippets)) {
	            schema.defaultSnippets.forEach(function (s) {
	                collector.add({
	                    kind: CompletionItemKind.Snippet,
	                    label: _this.getLabelForSnippetValue(s.body),
	                    insertText: _this.getTextForSnippetValue(s.body)
	                });
	            });
	        }
	        if (Array.isArray(schema.allOf)) {
	            schema.allOf.forEach(function (s) { return _this.addDefaultSuggestion(s, collector); });
	        }
	        if (Array.isArray(schema.anyOf)) {
	            schema.anyOf.forEach(function (s) { return _this.addDefaultSuggestion(s, collector); });
	        }
	        if (Array.isArray(schema.oneOf)) {
	            schema.oneOf.forEach(function (s) { return _this.addDefaultSuggestion(s, collector); });
	        }
	    };
	    JSONCompletion.prototype.getLabelForValue = function (value) {
	        var label = JSON.stringify(value);
	        if (label.length > 57) {
	            return label.substr(0, 57).trim() + '...';
	        }
	        return label;
	    };
	    JSONCompletion.prototype.getLabelForSnippetValue = function (value) {
	        var label = JSON.stringify(value);
	        label = label.replace(/\{\{|\}\}/g, '');
	        if (label.length > 57) {
	            return label.substr(0, 57).trim() + '...';
	        }
	        return label;
	    };
	    JSONCompletion.prototype.getTextForValue = function (value) {
	        var text = JSON.stringify(value, null, '\t');
	        text = text.replace(/[\\\{\}]/g, '\\$&');
	        return text;
	    };
	    JSONCompletion.prototype.getTextForSnippetValue = function (value) {
	        return JSON.stringify(value, null, '\t');
	    };
	    JSONCompletion.prototype.getTextForEnumValue = function (value) {
	        var snippet = this.getTextForValue(value);
	        switch (typeof value) {
	            case 'object':
	                if (value === null) {
	                    return '{{null}}';
	                }
	                return snippet;
	            case 'string':
	                return '"{{' + snippet.substr(1, snippet.length - 2) + '}}"';
	            case 'number':
	            case 'boolean':
	                return '{{' + snippet + '}}';
	        }
	        return snippet;
	    };
	    JSONCompletion.prototype.getSuggestionKind = function (type) {
	        if (Array.isArray(type)) {
	            var array = type;
	            type = array.length > 0 ? array[0] : null;
	        }
	        if (!type) {
	            return CompletionItemKind.Value;
	        }
	        switch (type) {
	            case 'string': return CompletionItemKind.Value;
	            case 'object': return CompletionItemKind.Module;
	            case 'property': return CompletionItemKind.Property;
	            default: return CompletionItemKind.Value;
	        }
	    };
	    JSONCompletion.prototype.getTextForMatchingNode = function (node, document) {
	        switch (node.type) {
	            case 'array':
	                return '[]';
	            case 'object':
	                return '{}';
	            default:
	                var content = document.getValue().substr(node.start, node.end - node.start);
	                return content;
	        }
	    };
	    JSONCompletion.prototype.getTextForProperty = function (key, propertySchema, addValue, isLast) {
	        var result = this.getTextForValue(key);
	        if (!addValue) {
	            return result;
	        }
	        result += ': ';
	        if (propertySchema) {
	            var defaultVal = propertySchema.default;
	            if (typeof defaultVal !== 'undefined') {
	                result = result + this.getTextForEnumValue(defaultVal);
	            }
	            else if (propertySchema.enum && propertySchema.enum.length > 0) {
	                result = result + this.getTextForEnumValue(propertySchema.enum[0]);
	            }
	            else {
	                var type = Array.isArray(propertySchema.type) ? propertySchema.type[0] : propertySchema.type;
	                switch (type) {
	                    case 'boolean':
	                        result += '{{false}}';
	                        break;
	                    case 'string':
	                        result += '"{{}}"';
	                        break;
	                    case 'object':
	                        result += '{\n\t{{}}\n}';
	                        break;
	                    case 'array':
	                        result += '[\n\t{{}}\n]';
	                        break;
	                    case 'number':
	                        result += '{{0}}';
	                        break;
	                    case 'null':
	                        result += '{{null}}';
	                        break;
	                    default:
	                        return result;
	                }
	            }
	        }
	        else {
	            result += '{{0}}';
	        }
	        if (!isLast) {
	            result += ',';
	        }
	        return result;
	    };
	    JSONCompletion.prototype.getTextForSimilarProperty = function (key, templateValue) {
	        return this.getTextForValue(key);
	    };
	    JSONCompletion.prototype.getCurrentWord = function (document, offset) {
	        var i = offset - 1;
	        var text = document.getValue();
	        while (i >= 0 && ' \t\n\r\v":{[,'.indexOf(text.charAt(i)) === -1) {
	            i--;
	        }
	        return text.substring(i + 1, offset);
	    };
	    return JSONCompletion;
	}());
	exports.JSONCompletion = JSONCompletion;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Parser = __webpack_require__(161);
	var jsonCompletions_1 = __webpack_require__(432);
	var jsoncompletion = new jsonCompletions_1.JSONCompletion();
	function getCompletionsAtPosition(model, position) {
	    var doc = Parser.parse(model.getValue());
	    var normalCompletions = jsoncompletion.doComplete(model, position, doc);
	    return normalCompletions;
	}
	exports.getCompletionsAtPosition = getCompletionsAtPosition;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * From https://raw.githubusercontent.com/Microsoft/vscode-json-languageservice/master/src/services/jsonFormatter.ts
	 * - Redirected dependencies
	 * - Made `getEol` use editorconfig ;)
	 */
	/*---------------------------------------------------------------------------------------------
	 *  Copyright (c) Microsoft Corporation. All rights reserved.
	 *  Licensed under the MIT License. See License.txt in the project root for license information.
	 *--------------------------------------------------------------------------------------------*/
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var Json = __webpack_require__(84);
	var Position = monaco.Position;
	var Range = monaco.Range;
	/**
	 * BAS: Was simple so I wrote it :)
	 */
	var TextEditReplace;
	(function (TextEditReplace) {
	    function replace(range, text) {
	        var result = {
	            range: range,
	            text: text
	        };
	        return result;
	    }
	    TextEditReplace.replace = replace;
	})(TextEditReplace || (TextEditReplace = {}));
	function format(document, range, options) {
	    var documentText = document.getValue();
	    var initialIndentLevel;
	    var value;
	    var rangeOffset;
	    if (range) {
	        var startPosition = new Position(range.startLineNumber, 0);
	        rangeOffset = document.getOffsetAt(startPosition);
	        var endOffset = document.getOffsetAt(new Position(range.endLineNumber + 1, 0));
	        var endLineStart = document.getOffsetAt(new Position(range.endLineNumber, 0));
	        while (endOffset > endLineStart && isEOL(documentText, endOffset - 1)) {
	            endOffset--;
	        }
	        var endPosition = document.getPositionAt(endOffset);
	        range = new Range(startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column);
	        value = documentText.substring(rangeOffset, endOffset);
	        initialIndentLevel = computeIndentLevel(value, 0, options);
	    }
	    else {
	        value = documentText;
	        var endPosition = document.getPositionAt(value.length);
	        range = new Range(0, 0, endPosition.lineNumber, endPosition.column);
	        initialIndentLevel = 0;
	        rangeOffset = 0;
	    }
	    var eol = getEOL(document);
	    var lineBreak = false;
	    var indentLevel = 0;
	    var indentValue;
	    if (options.insertSpaces) {
	        indentValue = repeat(' ', options.tabSize);
	    }
	    else {
	        indentValue = '\t';
	    }
	    var scanner = Json.createScanner(value, false);
	    function newLineAndIndent() {
	        return eol + repeat(indentValue, initialIndentLevel + indentLevel);
	    }
	    function scanNext() {
	        var token = scanner.scan();
	        lineBreak = false;
	        while (token === Json.SyntaxKind.Trivia || token === Json.SyntaxKind.LineBreakTrivia) {
	            lineBreak = lineBreak || (token === Json.SyntaxKind.LineBreakTrivia);
	            token = scanner.scan();
	        }
	        return token;
	    }
	    var editOperations = [];
	    function addEdit(text, startOffset, endOffset) {
	        if (documentText.substring(startOffset, endOffset) !== text) {
	            var startPos = document.getPositionAt(startOffset);
	            var endPos = document.getPositionAt(endOffset);
	            var replaceRange = new Range(startPos.lineNumber, startPos.column, endPos.lineNumber, endPos.column);
	            editOperations.push(TextEditReplace.replace(replaceRange, text));
	        }
	    }
	    var firstToken = scanNext();
	    if (firstToken !== Json.SyntaxKind.EOF) {
	        var firstTokenStart = scanner.getTokenOffset() + rangeOffset;
	        var initialIndent = repeat(indentValue, initialIndentLevel);
	        addEdit(initialIndent, rangeOffset, firstTokenStart);
	    }
	    while (firstToken !== Json.SyntaxKind.EOF) {
	        var firstTokenEnd = scanner.getTokenOffset() + scanner.getTokenLength() + rangeOffset;
	        var secondToken = scanNext();
	        var replaceContent = '';
	        while (!lineBreak && (secondToken === Json.SyntaxKind.LineCommentTrivia || secondToken === Json.SyntaxKind.BlockCommentTrivia)) {
	            // comments on the same line: keep them on the same line, but ignore them otherwise
	            var commentTokenStart = scanner.getTokenOffset() + rangeOffset;
	            addEdit(' ', firstTokenEnd, commentTokenStart);
	            firstTokenEnd = scanner.getTokenOffset() + scanner.getTokenLength() + rangeOffset;
	            replaceContent = secondToken === Json.SyntaxKind.LineCommentTrivia ? newLineAndIndent() : '';
	            secondToken = scanNext();
	        }
	        if (secondToken === Json.SyntaxKind.CloseBraceToken) {
	            if (firstToken !== Json.SyntaxKind.OpenBraceToken) {
	                indentLevel--;
	                replaceContent = newLineAndIndent();
	            }
	        }
	        else if (secondToken === Json.SyntaxKind.CloseBracketToken) {
	            if (firstToken !== Json.SyntaxKind.OpenBracketToken) {
	                indentLevel--;
	                replaceContent = newLineAndIndent();
	            }
	        }
	        else {
	            switch (firstToken) {
	                case Json.SyntaxKind.OpenBracketToken:
	                case Json.SyntaxKind.OpenBraceToken:
	                    indentLevel++;
	                    replaceContent = newLineAndIndent();
	                    break;
	                case Json.SyntaxKind.CommaToken:
	                case Json.SyntaxKind.LineCommentTrivia:
	                    replaceContent = newLineAndIndent();
	                    break;
	                case Json.SyntaxKind.BlockCommentTrivia:
	                    if (lineBreak) {
	                        replaceContent = newLineAndIndent();
	                    }
	                    else {
	                        // symbol following comment on the same line: keep on same line, separate with ' '
	                        replaceContent = ' ';
	                    }
	                    break;
	                case Json.SyntaxKind.ColonToken:
	                    replaceContent = ' ';
	                    break;
	                case Json.SyntaxKind.NullKeyword:
	                case Json.SyntaxKind.TrueKeyword:
	                case Json.SyntaxKind.FalseKeyword:
	                case Json.SyntaxKind.NumericLiteral:
	                    if (secondToken === Json.SyntaxKind.NullKeyword || secondToken === Json.SyntaxKind.FalseKeyword || secondToken === Json.SyntaxKind.NumericLiteral) {
	                        replaceContent = ' ';
	                    }
	                    break;
	            }
	            if (lineBreak && (secondToken === Json.SyntaxKind.LineCommentTrivia || secondToken === Json.SyntaxKind.BlockCommentTrivia)) {
	                replaceContent = newLineAndIndent();
	            }
	        }
	        var secondTokenStart = scanner.getTokenOffset() + rangeOffset;
	        addEdit(replaceContent, firstTokenEnd, secondTokenStart);
	        firstToken = secondToken;
	    }
	    return editOperations;
	}
	exports.format = format;
	function repeat(s, count) {
	    var result = '';
	    for (var i = 0; i < count; i++) {
	        result += s;
	    }
	    return result;
	}
	function computeIndentLevel(content, offset, options) {
	    var i = 0;
	    var nChars = 0;
	    var tabSize = options.tabSize || 4;
	    while (i < content.length) {
	        var ch = content.charAt(i);
	        if (ch === ' ') {
	            nChars++;
	        }
	        else if (ch === '\t') {
	            nChars += tabSize;
	        }
	        else {
	            break;
	        }
	        i++;
	    }
	    return Math.floor(nChars / tabSize);
	}
	function getEOL(document) {
	    return document._editorOptions.newLineCharacter;
	}
	function isEOL(text, offset) {
	    return '\r\n'.indexOf(text.charAt(offset)) !== -1;
	}


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * From : https://raw.githubusercontent.com/Microsoft/vscode/master/extensions/json/server/src/jsonSchemaService.ts
	 *
	 * The original has a lot of code (around XHRs and looking up schemas mainly) that we do not need
	 *
	 * We simply need the `JSONSchemaService.resolveSchemaContent`
	 * - And the class `ResolvedSchema` (not sure I need this yet, but good container for errors)
	 */
	/*---------------------------------------------------------------------------------------------
	 *  Copyright (c) Microsoft Corporation. All rights reserved.
	 *  Licensed under the MIT License. See License.txt in the project root for license information.
	 *--------------------------------------------------------------------------------------------*/
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var localize_1 = __webpack_require__(85);
	var utils = __webpack_require__(3);
	/**
	 * Register our schemas
	 * Mostly downloaded from http://json.schemastore.org/
	 *
	 * New additions need to
	 * - Download and put in schemas
	 * - Update utils.ts for "supportedConfigFileNames"
	 */
	exports.schemas = [];
	Object.keys(utils.supportedAutocompleteConfigFileNames).forEach(function (fileName) {
	    var rawContent = __webpack_require__(431)("./" + fileName);
	    resolveSchemaContent(rawContent); // Mutates it in place
	    exports.schemas.push({
	        fileName: fileName,
	        content: rawContent
	    });
	});
	function getSchemaForResource(filePath) {
	    var fileName = utils.getFileName(filePath);
	    var schema = exports.schemas.find(function (s) { return s.fileName === fileName; }).content;
	    return Promise.resolve(new ResolvedSchema(schema));
	}
	exports.getSchemaForResource = getSchemaForResource;
	/**
	 * Copied straight out of JSONSchemaService
	 * Resolves *links* in schema definitions
	 * NOTE: Mutates the argument `schema` too!
	 */
	function resolveSchemaContent(schema) {
	    var _this = this;
	    var resolveErrors = [];
	    var findSection = function (schema, path) {
	        if (!path) {
	            return schema;
	        }
	        var current = schema;
	        path.substr(1).split('/').some(function (part) {
	            current = current[part];
	            return !current;
	        });
	        return current;
	    };
	    var resolveLink = function (node, linkedSchema, linkPath) {
	        var section = findSection(linkedSchema, linkPath);
	        if (section) {
	            for (var key in section) {
	                if (section.hasOwnProperty(key) && !node.hasOwnProperty(key)) {
	                    node[key] = section[key];
	                }
	            }
	        }
	        else {
	            resolveErrors.push(localize_1.localize('json.schema.invalidref', '$ref \'{0}\' in {1} can not be resolved.', linkPath, linkedSchema.id));
	        }
	        delete node.$ref;
	    };
	    var resolveExternalLink = function (node, uri, linkPath) {
	        return _this.getOrAddSchemaHandle(uri).getUnresolvedSchema().then(function (unresolvedSchema) {
	            if (unresolvedSchema.errors.length) {
	                var loc = linkPath ? uri + '#' + linkPath : uri;
	                resolveErrors.push(localize_1.localize('json.schema.problemloadingref', 'Problems loading reference \'{0}\': {1}', loc, unresolvedSchema.errors[0]));
	            }
	            resolveLink(node, unresolvedSchema.schema, linkPath);
	            return resolveRefs(node, unresolvedSchema.schema);
	        });
	    };
	    var resolveRefs = function (node, parentSchema) {
	        var toWalk = [node];
	        var seen = [];
	        var openPromises = [];
	        var collectEntries = function () {
	            var entries = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                entries[_i] = arguments[_i];
	            }
	            for (var _a = 0, entries_1 = entries; _a < entries_1.length; _a++) {
	                var entry = entries_1[_a];
	                if (typeof entry === 'object') {
	                    toWalk.push(entry);
	                }
	            }
	        };
	        var collectMapEntries = function () {
	            var maps = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                maps[_i] = arguments[_i];
	            }
	            for (var _a = 0, maps_1 = maps; _a < maps_1.length; _a++) {
	                var map = maps_1[_a];
	                if (typeof map === 'object') {
	                    for (var key in map) {
	                        var entry = map[key];
	                        toWalk.push(entry);
	                    }
	                }
	            }
	        };
	        var collectArrayEntries = function () {
	            var arrays = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                arrays[_i] = arguments[_i];
	            }
	            for (var _a = 0, arrays_1 = arrays; _a < arrays_1.length; _a++) {
	                var array = arrays_1[_a];
	                if (Array.isArray(array)) {
	                    toWalk.push.apply(toWalk, array);
	                }
	            }
	        };
	        while (toWalk.length) {
	            var next = toWalk.pop();
	            if (seen.indexOf(next) >= 0) {
	                continue;
	            }
	            seen.push(next);
	            if (next.$ref) {
	                var segments = next.$ref.split('#', 2);
	                if (segments[0].length > 0) {
	                    openPromises.push(resolveExternalLink(next, segments[0], segments[1]));
	                    continue;
	                }
	                else {
	                    resolveLink(next, parentSchema, segments[1]);
	                }
	            }
	            collectEntries(next.items, next.additionalProperties, next.not);
	            collectMapEntries(next.definitions, next.properties, next.patternProperties, next.dependencies);
	            collectArrayEntries(next.anyOf, next.allOf, next.oneOf, next.items);
	        }
	        return Promise.all(openPromises);
	    };
	    return resolveRefs(schema, schema).then(function (_) { return new ResolvedSchema(schema, resolveErrors); });
	}
	exports.resolveSchemaContent = resolveSchemaContent;
	var ResolvedSchema = /** @class */ (function () {
	    function ResolvedSchema(schema, errors) {
	        if (errors === void 0) { errors = []; }
	        this.schema = schema;
	        this.errors = errors;
	    }
	    ResolvedSchema.prototype.getSection = function (path) {
	        return this.getSectionRecursive(path, this.schema);
	    };
	    ResolvedSchema.prototype.getSectionRecursive = function (path, schema) {
	        var _this = this;
	        if (!schema || path.length === 0) {
	            return schema;
	        }
	        var next = path.shift();
	        if (schema.properties && schema.properties[next]) {
	            return this.getSectionRecursive(path, schema.properties[next]);
	        }
	        else if (schema.patternProperties) {
	            Object.keys(schema.patternProperties).forEach(function (pattern) {
	                var regex = new RegExp(pattern);
	                if (regex.test(next)) {
	                    return _this.getSectionRecursive(path, schema.patternProperties[pattern]);
	                }
	            });
	        }
	        else if (schema.additionalProperties) {
	            return this.getSectionRecursive(path, schema.additionalProperties);
	        }
	        else if (next.match('[0-9]+')) {
	            if (schema.items) {
	                return this.getSectionRecursive(path, schema.items);
	            }
	            else if (Array.isArray(schema.items)) {
	                try {
	                    var index = parseInt(next, 10);
	                    if (schema.items[index]) {
	                        return this.getSectionRecursive(path, schema.items[index]);
	                    }
	                    return null;
	                }
	                catch (e) {
	                    return null;
	                }
	            }
	        }
	        return null;
	    };
	    return ResolvedSchema;
	}());
	exports.ResolvedSchema = ResolvedSchema;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * From https://raw.githubusercontent.com/Microsoft/monaco-json/master/src/tokenization.ts
	 *
	 * Just redirected the jsonc-parser dependency 🌹
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var json = __webpack_require__(84);
	function createTokenizationSupport(supportComments) {
	    return {
	        getInitialState: function () { return new JSONState(null, null, false); },
	        tokenize: function (line, state) {
	            return tokenize(supportComments, line, state, undefined, undefined);
	        }
	    };
	}
	exports.createTokenizationSupport = createTokenizationSupport;
	exports.TOKEN_DELIM_OBJECT = 'punctuation.bracket.json';
	exports.TOKEN_DELIM_ARRAY = 'punctuation.array.json';
	exports.TOKEN_DELIM_COLON = 'punctuation.colon.json';
	exports.TOKEN_DELIM_COMMA = 'punctuation.comma.json';
	exports.TOKEN_VALUE_BOOLEAN = 'support.property-value.keyword.json';
	exports.TOKEN_VALUE_NULL = 'support.property-value.constant.other.json';
	exports.TOKEN_VALUE_STRING = 'support.property-value.string.value.json';
	exports.TOKEN_VALUE_NUMBER = 'support.property-value.constant.numeric.json';
	exports.TOKEN_PROPERTY_NAME = 'support.type.property-name.json';
	exports.TOKEN_COMMENT_BLOCK = 'comment.block.json';
	exports.TOKEN_COMMENT_LINE = 'comment.line.json';
	var JSONState = /** @class */ (function () {
	    function JSONState(state, scanError, lastWasColon) {
	        this._state = state;
	        this.scanError = scanError;
	        this.lastWasColon = lastWasColon;
	    }
	    JSONState.prototype.clone = function () {
	        return new JSONState(this._state, this.scanError, this.lastWasColon);
	    };
	    JSONState.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        if (!other || !(other instanceof JSONState)) {
	            return false;
	        }
	        return this.scanError === other.scanError &&
	            this.lastWasColon === other.lastWasColon;
	    };
	    JSONState.prototype.getStateData = function () {
	        return this._state;
	    };
	    JSONState.prototype.setStateData = function (state) {
	        this._state = state;
	    };
	    return JSONState;
	}());
	function tokenize(comments, line, state, offsetDelta, stopAtOffset) {
	    if (offsetDelta === void 0) { offsetDelta = 0; }
	    // handle multiline strings and block comments
	    var numberOfInsertedCharacters = 0, adjustOffset = false;
	    switch (state.scanError) {
	        case json.ScanError.UnexpectedEndOfString:
	            line = '"' + line;
	            numberOfInsertedCharacters = 1;
	            break;
	        case json.ScanError.UnexpectedEndOfComment:
	            line = '/*' + line;
	            numberOfInsertedCharacters = 2;
	            break;
	    }
	    var scanner = json.createScanner(line), kind, ret, lastWasColon = state.lastWasColon;
	    ret = {
	        tokens: [],
	        endState: state.clone()
	    };
	    while (true) {
	        var offset = offsetDelta + scanner.getPosition(), type = '';
	        kind = scanner.scan();
	        if (kind === json.SyntaxKind.EOF) {
	            break;
	        }
	        // Check that the scanner has advanced
	        if (offset === offsetDelta + scanner.getPosition()) {
	            throw new Error('Scanner did not advance, next 3 characters are: ' + line.substr(scanner.getPosition(), 3));
	        }
	        // In case we inserted /* or " character, we need to
	        // adjust the offset of all tokens (except the first)
	        if (adjustOffset) {
	            offset -= numberOfInsertedCharacters;
	        }
	        adjustOffset = numberOfInsertedCharacters > 0;
	        // brackets and type
	        switch (kind) {
	            case json.SyntaxKind.OpenBraceToken:
	                type = exports.TOKEN_DELIM_OBJECT;
	                lastWasColon = false;
	                break;
	            case json.SyntaxKind.CloseBraceToken:
	                type = exports.TOKEN_DELIM_OBJECT;
	                lastWasColon = false;
	                break;
	            case json.SyntaxKind.OpenBracketToken:
	                type = exports.TOKEN_DELIM_ARRAY;
	                lastWasColon = false;
	                break;
	            case json.SyntaxKind.CloseBracketToken:
	                type = exports.TOKEN_DELIM_ARRAY;
	                lastWasColon = false;
	                break;
	            case json.SyntaxKind.ColonToken:
	                type = exports.TOKEN_DELIM_COLON;
	                lastWasColon = true;
	                break;
	            case json.SyntaxKind.CommaToken:
	                type = exports.TOKEN_DELIM_COMMA;
	                lastWasColon = false;
	                break;
	            case json.SyntaxKind.TrueKeyword:
	            case json.SyntaxKind.FalseKeyword:
	                type = exports.TOKEN_VALUE_BOOLEAN;
	                lastWasColon = false;
	                break;
	            case json.SyntaxKind.NullKeyword:
	                type = exports.TOKEN_VALUE_NULL;
	                lastWasColon = false;
	                break;
	            case json.SyntaxKind.StringLiteral:
	                type = lastWasColon ? exports.TOKEN_VALUE_STRING : exports.TOKEN_PROPERTY_NAME;
	                lastWasColon = false;
	                break;
	            case json.SyntaxKind.NumericLiteral:
	                type = exports.TOKEN_VALUE_NUMBER;
	                lastWasColon = false;
	                break;
	        }
	        // comments, iff enabled
	        if (comments) {
	            switch (kind) {
	                case json.SyntaxKind.LineCommentTrivia:
	                    type = exports.TOKEN_COMMENT_LINE;
	                    break;
	                case json.SyntaxKind.BlockCommentTrivia:
	                    type = exports.TOKEN_COMMENT_BLOCK;
	                    break;
	            }
	        }
	        ret.endState = new JSONState(state.getStateData(), scanner.getTokenError(), lastWasColon);
	        ret.tokens.push({
	            startIndex: offset,
	            scopes: type
	        });
	    }
	    return ret;
	}


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var state = __webpack_require__(11);
	var utils = __webpack_require__(3);
	var snippets_1 = __webpack_require__(443);
	var monacoUtils = __webpack_require__(18);
	__webpack_require__(373);
	/**
	 * Autocomplete
	 */
	var SuggestAdapter = /** @class */ (function () {
	    function SuggestAdapter() {
	    }
	    Object.defineProperty(SuggestAdapter.prototype, "triggerCharacters", {
	        get: function () {
	            return ['.', '('];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SuggestAdapter.prototype.provideCompletionItems = function (model, position, token) {
	        var wordInfo = model.getWordUntilPosition(position);
	        var prefix = wordInfo.word;
	        // NOTE: monaco is a bit touchy about `wordInfo`
	        // e.g. for `test(|` it will  return `wordInfo.word == ""`.
	        // We would rather it give us `(`.
	        // Lets fix that:
	        if (prefix == '' && wordInfo.startColumn > 2) {
	            prefix = model.getLineContent(position.lineNumber).substr(wordInfo.startColumn - 2, 1);
	        }
	        // console.log({ prefix }); // DEBUG
	        var filePath = model.filePath;
	        var offset = monacoUtils.positionToOffset(model, position);
	        if (!state.inActiveProjectFilePath(model.filePath)) {
	            return Promise.resolve([]);
	        }
	        return socketClient_1.server
	            .getCompletionsAtPosition({
	            prefix: prefix,
	            filePath: filePath,
	            position: offset
	        })
	            .then(function (info) {
	            if (!info) {
	                return;
	            }
	            var suggestions = info.completions.map(function (entry) {
	                var result = {
	                    label: entry.name,
	                    kind: SuggestAdapter.convertKind(entry.kind),
	                    // MyCompletionItem
	                    orig: entry,
	                    position: offset,
	                    filePath: filePath,
	                };
	                // Support function completions
	                if (entry.kind === 'snippet') {
	                    result.insertText = entry.insertText;
	                }
	                // For path completions we should create a text edit that eats all the text content
	                // This should work but doesn't (monaco bug). So disabling (= null) for now.
	                if (entry.textEdit) {
	                    // console.log(entry.textEdit, {position}); // DEBUG
	                    result.textEdit = {
	                        range: {
	                            startLineNumber: entry.textEdit.from.line + 1,
	                            startColumn: entry.textEdit.from.ch + 1,
	                            endLineNumber: entry.textEdit.to.line + 1,
	                            endColumn: entry.textEdit.to.ch + 1,
	                        },
	                        text: entry.textEdit.newText,
	                    };
	                    // Need this otherwise monaco tries to filter based on `textEdit`
	                    // and that might remove our entry.
	                    result.filterText = entry.name;
	                }
	                return result;
	            });
	            // add all snips
	            snippets_1.defaultSnippets.forEach(function (item) {
	                var snip = {
	                    label: item.name,
	                    kind: monaco.languages.CompletionItemKind.Snippet,
	                    detail: 'snippet',
	                    documentation: item.description,
	                    insertText: item.template,
	                };
	                suggestions.push(snip);
	            });
	            return suggestions;
	        });
	    };
	    SuggestAdapter.prototype.resolveCompletionItem = function (item, token) {
	        var myItem = item;
	        var filePath = myItem.filePath;
	        var position = myItem.position;
	        /** We have a chance to return `detail` and `documentation` */
	        // If we already have the result return it
	        if (myItem.orig && myItem.orig.display) {
	            return utils.extend(myItem, { detail: myItem.orig.display, documentation: myItem.orig.comment });
	        }
	        if (myItem.detail || myItem.documentation) {
	            return myItem;
	        }
	        // If not a resolvable completion then return orig
	        if (!filePath || !position) {
	            return myItem;
	        }
	        // Otherwise get it from the server
	        return socketClient_1.server
	            .getCompletionEntryDetails({ filePath: filePath, position: position, label: myItem.label })
	            .then(function (res) {
	            // You basically return the same thing with comments if any. If we don't have them just return.
	            if (!res.display && !res.comment) {
	                return myItem;
	            }
	            var detail = res.display, documentation = res.comment;
	            return utils.extend(myItem, { detail: detail, documentation: documentation });
	        });
	    };
	    SuggestAdapter.convertKind = function (kind) {
	        switch (kind) {
	            case Kind.primitiveType:
	            case Kind.keyword:
	                return monaco.languages.CompletionItemKind.Keyword;
	            case Kind.variable:
	            case Kind.localVariable:
	                return monaco.languages.CompletionItemKind.Variable;
	            case Kind.memberVariable:
	            case Kind.memberGetAccessor:
	            case Kind.memberSetAccessor:
	                return monaco.languages.CompletionItemKind.Field;
	            case Kind.function:
	            case Kind.memberFunction:
	            case Kind.constructSignature:
	            case Kind.callSignature:
	            case Kind.indexSignature:
	                return monaco.languages.CompletionItemKind.Function;
	            case Kind.enum:
	                return monaco.languages.CompletionItemKind.Enum;
	            case Kind.module:
	                return monaco.languages.CompletionItemKind.Module;
	            case Kind.class:
	                return monaco.languages.CompletionItemKind.Class;
	            case Kind.interface:
	                return monaco.languages.CompletionItemKind.Interface;
	            case Kind.warning:
	            case Kind.file:
	                return monaco.languages.CompletionItemKind.File;
	        }
	        return monaco.languages.CompletionItemKind.Property;
	    };
	    return SuggestAdapter;
	}());
	exports.SuggestAdapter = SuggestAdapter;
	var Kind = /** @class */ (function () {
	    function Kind() {
	    }
	    Kind.unknown = '';
	    Kind.keyword = 'keyword';
	    Kind.script = 'script';
	    Kind.module = 'module';
	    Kind.class = 'class';
	    Kind.interface = 'interface';
	    Kind.type = 'type';
	    Kind.enum = 'enum';
	    Kind.variable = 'var';
	    Kind.localVariable = 'local var';
	    Kind.function = 'function';
	    Kind.localFunction = 'local function';
	    Kind.memberFunction = 'method';
	    Kind.memberGetAccessor = 'getter';
	    Kind.memberSetAccessor = 'setter';
	    Kind.memberVariable = 'property';
	    Kind.constructorImplementation = 'constructor';
	    Kind.callSignature = 'call';
	    Kind.indexSignature = 'index';
	    Kind.constructSignature = 'construct';
	    Kind.parameter = 'parameter';
	    Kind.typeParameter = 'type parameter';
	    Kind.primitiveType = 'primitive type';
	    Kind.label = 'label';
	    Kind.alias = 'alias';
	    Kind.const = 'const';
	    Kind.let = 'let';
	    Kind.warning = 'warning';
	    Kind.file = 'file';
	    return Kind;
	}());
	exports.Kind = Kind;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var state = __webpack_require__(11);
	var DocumentFormatter = /** @class */ (function () {
	    function DocumentFormatter() {
	    }
	    DocumentFormatter.prototype.provideDocumentFormattingEdits = function (model, options, token) {
	        var filePath = model.filePath;
	        if (!state.inActiveProjectFilePath(model.filePath)) {
	            return Promise.resolve([]);
	        }
	        return socketClient_1.server.formatDocument({
	            filePath: filePath, editorOptions: model._editorOptions
	        }).then(function (res) {
	            if (token.isCancellationRequested)
	                return [];
	            return res.edits.map(formattingEditToSingleEditOperation);
	        });
	    };
	    return DocumentFormatter;
	}());
	exports.DocumentFormatter = DocumentFormatter;
	var DocumentRangeFormatter = /** @class */ (function () {
	    function DocumentRangeFormatter() {
	    }
	    DocumentRangeFormatter.prototype.provideDocumentRangeFormattingEdits = function (model, range, options, token) {
	        var filePath = model.filePath;
	        if (!state.inActiveProjectFilePath(model.filePath)) {
	            return Promise.resolve([]);
	        }
	        return socketClient_1.server.formatDocumentRange({
	            filePath: filePath,
	            editorOptions: model._editorOptions,
	            from: {
	                line: range.startLineNumber - 1,
	                ch: range.startColumn - 1,
	            },
	            to: {
	                line: range.endLineNumber - 1,
	                ch: range.endColumn - 1,
	            }
	        }).then(function (res) {
	            if (token.isCancellationRequested)
	                return [];
	            return res.edits.map(formattingEditToSingleEditOperation);
	        });
	    };
	    return DocumentRangeFormatter;
	}());
	exports.DocumentRangeFormatter = DocumentRangeFormatter;
	var FormatOnTypeAdapter = /** @class */ (function () {
	    function FormatOnTypeAdapter() {
	    }
	    Object.defineProperty(FormatOnTypeAdapter.prototype, "autoFormatTriggerCharacters", {
	        get: function () {
	            return [';', '}', '\n'];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FormatOnTypeAdapter.prototype.provideOnTypeFormattingEdits = function (model, position, ch, options, token) {
	        var filePath = model.filePath;
	        var empty = Promise.resolve([]);
	        if (!state.inActiveProjectFilePath(model.filePath)) {
	            return empty;
	        }
	        /**
	         * If the user just did a docblockr enter
	         * And we insert stuff like `* `
	         * Then ts will remove the trailing space.
	         * We want to keep that so check for it
	         */
	        var lineContent = model.getLineContent(position.lineNumber);
	        if (lineContent.endsWith('* ')
	            || lineContent.endsWith('// ')
	            || lineContent.endsWith('/// ')) {
	            return empty;
	        }
	        return socketClient_1.server.getFormattingEditsAfterKeystroke({
	            filePath: filePath,
	            editorPosition: {
	                line: position.lineNumber - 1,
	                ch: position.column - 1
	            },
	            key: ch,
	            editorOptions: model._editorOptions
	        }).then(function (res) {
	            if (token.isCancellationRequested)
	                return [];
	            return res.edits.map(formattingEditToSingleEditOperation);
	        });
	    };
	    return FormatOnTypeAdapter;
	}());
	exports.FormatOnTypeAdapter = FormatOnTypeAdapter;
	/** Utility */
	function formattingEditToSingleEditOperation(edit) {
	    var result = {
	        range: {
	            startLineNumber: edit.from.line + 1,
	            startColumn: edit.from.ch + 1,
	            endLineNumber: edit.to.line + 1,
	            endColumn: edit.to.ch + 1
	        },
	        text: edit.newText
	    };
	    return result;
	}


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function setupMonacoTypecript() {
	    monaco.languages.register({
	        id: 'typescript',
	        extensions: ['.ts', '.tsx'],
	        aliases: ['TypeScript', 'ts', 'typescript'],
	        mimetypes: ['text/typescript']
	    });
	    monaco.languages.onLanguage('typescript', function () {
	        // Perform any one time setup
	        setupMode('typescript');
	    });
	    monaco.languages.register({
	        id: 'javascript',
	        extensions: ['.js', '.es6', '.jsx'],
	        firstLine: '^#!.*\\bnode',
	        filenames: ['jakefile'],
	        aliases: ['JavaScript', 'javascript', 'js'],
	        mimetypes: ['text/javascript'],
	    });
	    monaco.languages.onLanguage('javascript', function () {
	        // Perform any one time setup
	        setupMode('javascript');
	    });
	}
	exports.setupMonacoTypecript = setupMonacoTypecript;
	var tokenization = __webpack_require__(444);
	var richLanguageConfiguration_1 = __webpack_require__(442);
	var provideDocumentHighlights = __webpack_require__(440);
	var provideHover_1 = __webpack_require__(441);
	var formatting_1 = __webpack_require__(438);
	var autocomplete = __webpack_require__(437);
	function setupMode(modeId) {
	    /** Setup tokenization */
	    var language = modeId === 'typescript' ? tokenization.Language.TypeScript : tokenization.Language.EcmaScript5;
	    monaco.languages.setTokensProvider(modeId, tokenization.createTokenizationSupport(language));
	    /** Setup bracket matching etc. */
	    monaco.languages.setLanguageConfiguration(modeId, richLanguageConfiguration_1.richLanguageConfiguration);
	    /** Setup highlight occurances */
	    monaco.languages.registerDocumentHighlightProvider(modeId, provideDocumentHighlights);
	    /** Setup hover information provider */
	    monaco.languages.registerHoverProvider(modeId, new provideHover_1.ProvideHover());
	    /** Setup formaters */
	    monaco.languages.registerDocumentFormattingEditProvider(modeId, new formatting_1.DocumentFormatter());
	    monaco.languages.registerDocumentRangeFormattingEditProvider(modeId, new formatting_1.DocumentRangeFormatter());
	    monaco.languages.registerOnTypeFormattingEditProvider(modeId, new formatting_1.FormatOnTypeAdapter());
	    /** Setup autocomplete */
	    monaco.languages.registerCompletionItemProvider(modeId, new autocomplete.SuggestAdapter());
	}


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var state = __webpack_require__(11);
	var monacoUtils_1 = __webpack_require__(18);
	function provideDocumentHighlights(model, position, token) {
	    var resource = model.uri;
	    if (!state.inActiveProjectFilePath(model.filePath)) {
	        return Promise.resolve([]);
	    }
	    return monacoUtils_1.onlyLastCallWithDelay(function () { return socketClient_1.server.getOccurrencesAtPosition({
	        filePath: model.filePath,
	        editorPosition: {
	            line: position.lineNumber - 1,
	            ch: position.column - 1,
	        }
	    }); }, token).then(function (res) {
	        // console.log(res.results); DEBUG
	        return res.results.map(function (entry) {
	            return {
	                range: {
	                    startLineNumber: entry.start.line + 1,
	                    startColumn: entry.start.ch + 1,
	                    endLineNumber: entry.end.line + 1,
	                    endColumn: entry.end.ch + 1,
	                },
	                kind: entry.isWriteAccess ? monaco.languages.DocumentHighlightKind.Write : monaco.languages.DocumentHighlightKind.Text
	            };
	        });
	    });
	    // return wireCancellationToken(token, this._worker(resource).then(worker => {
	    // 	return worker.getOccurrencesAtPosition(resource.toString(), this._positionToOffset(resource, position));
	    // }).then(entries => {
	    // 	if (!entries) {
	    // 		return;
	    // 	}
	    // 	return entries.map(entry => {
	    // 		return <monaco.languages.DocumentHighlight>{
	    // 			range: this._textSpanToRange(resource, entry.textSpan),
	    // 			kind: entry.isWriteAccess ? monaco.languages.DocumentHighlightKind.Write : monaco.languages.DocumentHighlightKind.Text
	    // 		};
	    // 	});
	    // }));
	}
	exports.provideDocumentHighlights = provideDocumentHighlights;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketClient_1 = __webpack_require__(5);
	var state = __webpack_require__(11);
	var ProvideHover = /** @class */ (function () {
	    function ProvideHover() {
	    }
	    ProvideHover.prototype.provideHover = function (model, pos, token) {
	        var filePath = model.filePath;
	        if (!state.inActiveProjectFilePath(model.filePath)) {
	            return null;
	        }
	        var position = model.getOffsetAt(pos);
	        return socketClient_1.server.quickInfo({
	            filePath: filePath,
	            position: position
	        }).then(function (res) {
	            // console.log(res); // DEBUG
	            if (!res.valid) {
	                return null;
	            }
	            /** Since we do not show `error` yet just return if no `info` */
	            if (!res.info) {
	                return null;
	            }
	            var result = {
	                range: {
	                    startLineNumber: res.info.range.from.line + 1,
	                    startColumn: res.info.range.from.ch + 1,
	                    endLineNumber: res.info.range.to.line + 1,
	                    endColumn: res.info.range.to.ch + 1,
	                },
	                contents: [
	                    "***" + res.info.name + "***"
	                ]
	            };
	            if (res.info.comment) {
	                result.contents.push('\n\n' + res.info.comment);
	            }
	            return result;
	        });
	    };
	    return ProvideHover;
	}());
	exports.ProvideHover = ProvideHover;


/***/ },
/* 442 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.richLanguageConfiguration = {
	    wordPattern: /(-?\d*\.\d\w*)|([^\`\~\!\@\#\%\^\&\*\(\)\-\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g,
	    comments: {
	        lineComment: '//',
	        blockComment: ['/*', '*/']
	    },
	    brackets: [
	        ['{', '}'],
	        ['[', ']'],
	        ['(', ')']
	    ],
	    onEnterRules: [
	        {
	            // e.g. /** | */
	            beforeText: /^\s*\/\*\*(?!\/)([^\*]|\*(?!\/))*$/,
	            afterText: /^\s*\*\/$/,
	            action: { indentAction: monaco.languages.IndentAction.IndentOutdent, appendText: ' * ' }
	        },
	        {
	            // e.g. /** ...|
	            beforeText: /^\s*\/\*\*(?!\/)([^\*]|\*(?!\/))*$/,
	            action: { indentAction: monaco.languages.IndentAction.None, appendText: ' * ' }
	        },
	        {
	            // e.g.  * ...|
	            beforeText: /^(\t|(\ \ ))*\ \*(\ ([^\*]|\*(?!\/))*)?$/,
	            action: { indentAction: monaco.languages.IndentAction.Indent, appendText: '* ' }
	        },
	        {
	            // e.g.  */|
	            beforeText: /^(\t|(\ \ ))*\ \*\/\s*$/,
	            action: { indentAction: monaco.languages.IndentAction.None, removeText: 1 }
	        },
	        {
	            // e.g. //|
	            beforeText: /^\s*\/\/.*$/,
	            action: { indentAction: monaco.languages.IndentAction.Indent, appendText: '// ' }
	        },
	    ],
	    __electricCharacterSupport: {
	        docComment: { open: '/**', close: ' */' }
	    },
	    autoClosingPairs: [
	        { open: '{', close: '}' },
	        { open: '[', close: ']' },
	        { open: '(', close: ')' },
	        { open: '"', close: '"', notIn: ['string'] },
	        { open: '\'', close: '\'', notIn: ['string', 'comment'] },
	        { open: '`', close: '`' }
	    ]
	};


/***/ },
/* 443 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.defaultSnippets = [
	    {
	        "name": "for",
	        "description": "iterate over array",
	        "template": "for (let {{2:index}} = 0; {{2:index}} < {{1:array}}.length; {{2:index}}++) {\n\t{{}}\n}"
	    },
	    {
	        "name": "fort",
	        "description": "iterate over array with temporary variable",
	        "template": "for (let {{index}} = 0; {{index}} < {{array}}.length; {{index}}++) {\n\tconst {{array_element}} = {{array}}[{{index}}];\n\t{{}}\n}"
	    },
	    {
	        "name": "forin",
	        "description": "iterate using for .. in",
	        "template": "for (const {{2:key}} in {{1:iterable}}) {\n\t{{}}\n}"
	    },
	    {
	        "name": "forof",
	        "description": "iterate using for .. of",
	        "template": "for (const {{2:item}} of {{1:iterable}}) {\n\t{{}}\n}"
	    },
	    {
	        "name": "import",
	        "description": "ES6 style import",
	        "template": "import {{2:name}} from '{{1:path}}';{{}}"
	    },
	    {
	        "name": "importr",
	        "description": "CommonJs Style Import",
	        "template": "import {{1:name}} = require('{{2:path}}');{{}}"
	    },
	    {
	        "name": "interface",
	        "description": "Create a new interface",
	        "template": "interface {{1:Name}} {\n\t{{}}\n}"
	    },
	    {
	        "name": "class",
	        "description": "Create a new class",
	        "template": "class {{1:Name}} {\n\t{{}}\n}"
	    },
	    {
	        "name": "namespace",
	        "description": "Create a new namespace",
	        "template": "namespace {{1:Name}} {\n\t{{}}\n}"
	    },
	    {
	        "name": "do", "description": "do while statement", "template": "do {\n\t{{}}\n} while ({{condition}});"
	    },
	    {
	        "name": "switch",
	        "description": "switch case statement",
	        "template": "switch ({{key}}) {\n\tcase {{value}}:\n\t\t{{}}\n\t\tbreak;\n\n\tdefault:\n\t\tbreak;\n}"
	    },
	    {
	        "name": "if",
	        "description": "if statement",
	        "template": "if ({{condition}}) {\n\t{{}}\n}"
	    },
	    {
	        "name": "ifelse",
	        "description": "if else statement",
	        "template": "if ({{condition}}) {\n\t{{}}\n} else {\n\t\n}"
	    },
	    {
	        "name": "elseif",
	        "description": "else if block",
	        "template": "else if ({{condition}}) {\n\t{{}}\n}"
	    },
	    {
	        "name": "else",
	        "description": "else block",
	        "template": "else {\n\t{{}}\n}"
	    },
	    {
	        "name": "try",
	        "description": "try catch block",
	        "template": "try {\n\t{{}}\n} catch (e) {\n\t// {{todo}}: handle exception\n}"
	    },
	    {
	        "name": "catch",
	        "description": "catch block",
	        "template": "catch (e) {\n\t{{}}// {{todo}}: handle exception\n}"
	    },
	    {
	        "name": "function",
	        "description": "function",
	        "template": "function {{name}}({{args}}) {\n\t{{}}\n}"
	    },
	    {
	        "name": "new",
	        "description": "create new object",
	        "template": "var {{name}} = new {{type}}({{arguments}});"
	    },
	    {
	        "name": "lazy",
	        "description": "lazy creation",
	        "template": "if ({{var}} == null) {\n\t{{var}} = new {{type}}({{arguments}});\n\t{{}}\n}\n\nreturn {{var}};"
	    },
	    {
	        "name": "while",
	        "description": "while loop with condition",
	        "template": "while ({{condition}}) {\n\t{{}}\n}"
	    },
	    {
	        "name": "log",
	        "description": "console.log()",
	        template: "console.log({{}})",
	    },
	    {
	        name: 'exhaustive',
	        description: 'Exhaustive check for discriminated union',
	        template: 'const _exhaustiveCheck: never = {{}};'
	    },
	    {
	        "name": "@author", "description": "author name", "template": "@author {{user}}"
	    },
	    {
	        name: 'ctor',
	        description: 'constructor',
	        template: [
	            "constructor() {",
	            "\t{{}}",
	            "}"
	        ].join('\n'),
	    },
	    {
	        name: 'constructor',
	        description: 'constructor',
	        template: [
	            "constructor() {",
	            "\t{{}}",
	            "}"
	        ].join('\n'),
	    },
	    /**
	     * Snippets for common imports
	     */
	    /** React */
	    {
	        name: 'react',
	        description: 'import React',
	        template: "import * as React from 'react';"
	    },
	    {
	        name: 'reactdom',
	        description: 'import ReactDOM',
	        template: "import * as ReactDOM from 'react-dom';"
	    },
	    {
	        name: 'reactdomserver',
	        description: 'import ReactDOMServer',
	        template: "import * as ReactDOMServer from 'react-dom/server';"
	    }
	];


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Orginal from
	 * https://github.com/alexandrudima/monaco-typescript/blob/1af97f4c0bc7514ea1f1ba62d9098aa883595918/src/tokenization.ts
	 *
	 * Modified to be more powerful
	 * - (filePath aware)
	 * - Changed to use `classifierCache`.
	 */
	var classifierCache = __webpack_require__(86);
	var Language;
	(function (Language) {
	    Language[Language["TypeScript"] = 0] = "TypeScript";
	    Language[Language["EcmaScript5"] = 1] = "EcmaScript5";
	})(Language = exports.Language || (exports.Language = {}));
	function createTokenizationSupport(language) {
	    var classifier = ts.createClassifier(), bracketTypeTable = language === Language.TypeScript ? tsBracketTypeTable : jsBracketTypeTable, tokenTypeTable = language === Language.TypeScript ? tsTokenTypeTable : jsTokenTypeTable;
	    return {
	        getInitialState: function () {
	            return new State({
	                language: language,
	                eolState: ts.EndOfLineState.None,
	                inJsDocComment: false,
	                lineNumber: 0,
	                lineStartIndex: 0,
	            });
	        },
	        tokenize: function (line, state, filePath) { return tokenize(bracketTypeTable, tokenTypeTable, classifier, state, line, filePath); }
	    };
	}
	exports.createTokenizationSupport = createTokenizationSupport;
	var State = /** @class */ (function () {
	    function State(config) {
	        this.language = config.language;
	        this.eolState = config.eolState;
	        this.inJsDocComment = config.inJsDocComment;
	        this.lineNumber = config.lineNumber;
	        this.lineStartIndex = config.lineStartIndex;
	    }
	    State.prototype.clone = function () {
	        return new State(this);
	    };
	    State.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        if (!other || !(other instanceof State)) {
	            return false;
	        }
	        return this.eolState === other.eolState
	            && this.inJsDocComment === other.inJsDocComment
	            && this.lineNumber === other.lineNumber
	            && this.lineStartIndex === other.lineStartIndex;
	    };
	    return State;
	}());
	function tokenize(bracketTypeTable, tokenTypeTable, classifier, state, text, filePath) {
	    // Create result early and fill in tokens
	    var ret = {
	        tokens: [],
	        endState: new State({
	            language: state.language,
	            eolState: ts.EndOfLineState.None,
	            inJsDocComment: false,
	            lineNumber: state.lineNumber + 1,
	            lineStartIndex: state.lineStartIndex + text.length + 1,
	        })
	    };
	    function appendFn(startIndex, type) {
	        if (ret.tokens.length === 0 || ret.tokens[ret.tokens.length - 1].scopes !== type) {
	            ret.tokens.push({
	                startIndex: startIndex,
	                scopes: type
	            });
	        }
	    }
	    var isTypeScript = state.language === Language.TypeScript;
	    if (isTypeScript) {
	        // Note: we are still keeping the classiferCache in sync (from docCache)
	        // But disabled using it here for pref + requirement to use it for hovers
	        // WARNING: we might eventually use the js language to tokenize stuff like `hovers`
	        // So probably only use this function for .ts files
	        // Alternatively we could create a new language 'jshover' and use that for hovers etc
	        return tokenizeTs(state, ret, text, filePath);
	    }
	    if (!isTypeScript && checkSheBang(0, text, appendFn)) {
	        return ret;
	    }
	    var result = classifier.getClassificationsForLine(text, state.eolState, true), offset = 0;
	    ret.endState.eolState = result.finalLexState;
	    ret.endState.inJsDocComment = result.finalLexState === ts.EndOfLineState.InMultiLineCommentTrivia && (state.inJsDocComment || /\/\*\*.*$/.test(text));
	    for (var _i = 0, _a = result.entries; _i < _a.length; _i++) {
	        var entry = _a[_i];
	        var type;
	        if (entry.classification === ts.TokenClass.Punctuation) {
	            // punctions: check for brackets: (){}[]
	            var ch = text.charCodeAt(offset);
	            type = bracketTypeTable[ch] || tokenTypeTable[entry.classification];
	            appendFn(offset, type);
	        }
	        else if (entry.classification === ts.TokenClass.Comment) {
	            // comments: check for JSDoc, block, and line comments
	            if (ret.endState.inJsDocComment || /\/\*\*.*\*\//.test(text.substr(offset, entry.length))) {
	                appendFn(offset, isTypeScript ? 'comment.doc.ts' : 'comment.doc.js');
	            }
	            else {
	                appendFn(offset, isTypeScript ? 'comment.ts' : 'comment.js');
	            }
	        }
	        else {
	            // everything else
	            appendFn(offset, tokenTypeTable[entry.classification] || '');
	        }
	        offset += entry.length;
	    }
	    return ret;
	}
	var tsBracketTypeTable = Object.create(null);
	tsBracketTypeTable['('.charCodeAt(0)] = 'delimiter.parenthesis.ts';
	tsBracketTypeTable[')'.charCodeAt(0)] = 'delimiter.parenthesis.ts';
	tsBracketTypeTable['{'.charCodeAt(0)] = 'delimiter.bracket.ts';
	tsBracketTypeTable['}'.charCodeAt(0)] = 'delimiter.bracket.ts';
	tsBracketTypeTable['['.charCodeAt(0)] = 'delimiter.array.ts';
	tsBracketTypeTable[']'.charCodeAt(0)] = 'delimiter.array.ts';
	var tsTokenTypeTable = Object.create(null);
	tsTokenTypeTable[ts.TokenClass.Identifier] = 'identifier.ts';
	tsTokenTypeTable[ts.TokenClass.Keyword] = 'keyword.ts';
	tsTokenTypeTable[ts.TokenClass.Operator] = 'delimiter.ts';
	tsTokenTypeTable[ts.TokenClass.Punctuation] = 'delimiter.ts';
	tsTokenTypeTable[ts.TokenClass.NumberLiteral] = 'number.ts';
	tsTokenTypeTable[ts.TokenClass.RegExpLiteral] = 'regexp.ts';
	tsTokenTypeTable[ts.TokenClass.StringLiteral] = 'string.ts';
	var jsBracketTypeTable = Object.create(null);
	jsBracketTypeTable['('.charCodeAt(0)] = 'delimiter.parenthesis.js';
	jsBracketTypeTable[')'.charCodeAt(0)] = 'delimiter.parenthesis.js';
	jsBracketTypeTable['{'.charCodeAt(0)] = 'delimiter.bracket.js';
	jsBracketTypeTable['}'.charCodeAt(0)] = 'delimiter.bracket.js';
	jsBracketTypeTable['['.charCodeAt(0)] = 'delimiter.array.js';
	jsBracketTypeTable[']'.charCodeAt(0)] = 'delimiter.array.js';
	var jsTokenTypeTable = Object.create(null);
	jsTokenTypeTable[ts.TokenClass.Identifier] = 'identifier.js';
	jsTokenTypeTable[ts.TokenClass.Keyword] = 'keyword.js';
	jsTokenTypeTable[ts.TokenClass.Operator] = 'delimiter.js';
	jsTokenTypeTable[ts.TokenClass.Punctuation] = 'delimiter.js';
	jsTokenTypeTable[ts.TokenClass.NumberLiteral] = 'number.js';
	jsTokenTypeTable[ts.TokenClass.RegExpLiteral] = 'regexp.js';
	jsTokenTypeTable[ts.TokenClass.StringLiteral] = 'string.js';
	function checkSheBang(deltaOffset, line, appendFn) {
	    if (line.indexOf('#!') === 0) {
	        appendFn(deltaOffset, 'comment.shebang');
	        return true;
	    }
	}
	function tokenizeTs(state, ret, text, filePath) {
	    var classifications = classifierCache.getClassificationsForLine(filePath, state.lineStartIndex, text);
	    // DEBUG classifications
	    // console.log('%c'+text,"font-size: 20px");
	    // console.table(classifications.map(c=> ({ str: c.string, cls: c.classificationTypeName,startInLine:c.startInLine })));
	    var startIndex = 0;
	    var lineHasJSX = filePath.endsWith('x') && classifications.some(function (classification) {
	        return classification.classificationType === ts.ClassificationType.jsxOpenTagName
	            || classification.classificationType === ts.ClassificationType.jsxCloseTagName
	            || classification.classificationType === ts.ClassificationType.jsxSelfClosingTagName
	            || classification.classificationType === ts.ClassificationType.jsxText
	            || classification.classificationType === ts.ClassificationType.jsxAttribute;
	    });
	    classifications.forEach(function (classifiedSpan) {
	        ret.tokens.push({
	            startIndex: startIndex,
	            scopes: getStyleForToken(classifiedSpan, text, startIndex, lineHasJSX) + '.ts'
	        });
	        startIndex = startIndex + classifiedSpan.string.length;
	    });
	    return ret;
	}
	function getStyleForToken(token, 
	/** Full contents of the line */
	line, 
	/** Start position for this token in the line */
	startIndex, 
	/** Only relevant for a `.tsx` file */
	lineHasJSX) {
	    var ClassificationType = ts.ClassificationType;
	    var nextStr; // setup only if needed
	    var loadNextStr = function () { return nextStr || (nextStr = line.substr(startIndex + token.string.length).replace(/\s+/g, '')); };
	    /** used for both variable and its puncutation */
	    var decoratorClassification = 'punctuation.tag';
	    switch (token.classificationType) {
	        case ClassificationType.numericLiteral:
	            return 'constant.numeric';
	        case ClassificationType.stringLiteral:
	            return 'string';
	        case ClassificationType.regularExpressionLiteral:
	            return 'constant.character';
	        case ClassificationType.operator:
	            return 'keyword.operator'; // The atom grammar does keyword+operator and I actually like that
	        case ClassificationType.comment:
	            return 'comment';
	        case ClassificationType.className:
	        case ClassificationType.enumName:
	        case ClassificationType.interfaceName:
	        case ClassificationType.moduleName:
	        case ClassificationType.typeParameterName:
	        case ClassificationType.typeAliasName:
	            return 'variable-2';
	        case ClassificationType.keyword:
	            switch (token.string) {
	                case 'string':
	                case 'number':
	                case 'void':
	                case 'bool':
	                case 'boolean':
	                    return 'variable-2';
	                case 'static':
	                case 'public':
	                case 'private':
	                case 'protected':
	                case 'get':
	                case 'set':
	                    return 'qualifier';
	                case 'function':
	                case 'var':
	                case 'let':
	                case 'const':
	                    return 'qualifier';
	                case 'this':
	                    return 'constant.language';
	                default:
	                    return 'keyword';
	            }
	        case ClassificationType.identifier:
	            var lastToken = line.substr(0, startIndex).trim();
	            if (token.string === "undefined") {
	                return 'keyword';
	            }
	            else if (lastToken.endsWith('@')) {
	                return decoratorClassification;
	            }
	            else if (lastToken.endsWith('type')
	                || lastToken.endsWith('extends')) {
	                return 'variable-2';
	            }
	            else if (lastToken.endsWith('let')
	                || lastToken.endsWith('const')
	                || lastToken.endsWith('var')) {
	                return 'def';
	            }
	            else if (((loadNextStr()).startsWith('(')
	                || nextStr.startsWith('=(')
	                || nextStr.startsWith('=function'))
	                && (!lastToken.endsWith('.'))) {
	                return 'entity.name.function';
	            }
	            else {
	                return 'variable';
	            }
	        case ClassificationType.parameterName:
	            return 'variable.parameter';
	        case ClassificationType.punctuation:
	            // Only get punctuation for JSX. Otherwise these would be operator
	            if (lineHasJSX && (token.string == '>' || token.string == '<' || token.string == '>')) {
	                // NOTE: would be good to get `meta.begin` vs. `meta.end` for tag matching
	                return 'punctuation.definition.meta.tag'; // A nice blue color
	            }
	            if (token.string == '/') {
	                return 'punctuation.definition.meta.end.tag'; // A nice blue color
	            }
	            if (token.string === '{' || token.string === '}')
	                return 'delimiter.bracket';
	            if (token.string === '(' || token.string === ')')
	                return 'delimiter.parenthesis';
	            if (token.string === '=>')
	                return 'operator.keyword';
	            if (token.string === '@')
	                return decoratorClassification;
	            return 'bracket';
	        case ClassificationType.jsxOpenTagName:
	        case ClassificationType.jsxCloseTagName:
	        case ClassificationType.jsxSelfClosingTagName:
	            return 'entity.name.tag';
	        case ClassificationType.jsxAttribute:
	            return 'entity.other.attribute-name';
	        case ClassificationType.jsxAttributeStringLiteralValue:
	            return 'string';
	        case ClassificationType.whiteSpace:
	        default:
	            return null;
	    }
	}


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * When sending edits to the server we *batch them by filePath*.
	 */
	/** imports */
	var socketClient_1 = __webpack_require__(5);
	var utils = __webpack_require__(3);
	/**
	 * The queue of edits by filePath that we still have to send
	 */
	var pendingQueue = Object.create(null);
	function addToQueue(filePath, edit) {
	    // Batch by by filePath and setup for sending later
	    if (!pendingQueue[filePath])
	        pendingQueue[filePath] = [];
	    pendingQueue[filePath].push(edit);
	    // Mark for sending
	    exports.delayedFlushQueue();
	}
	exports.addToQueue = addToQueue;
	function flushQueue() {
	    Object.keys(pendingQueue).forEach(function (filePath) {
	        var edits = pendingQueue[filePath];
	        socketClient_1.server.editFile({ filePath: filePath, edits: edits });
	        /** Clear for future */
	        delete pendingQueue[filePath];
	    });
	}
	exports.flushQueue = flushQueue;
	/**
	 * Note: this delay must be less than any other delays
	 * (e.g. autocomplete throttling should be more than this).
	 * WARNING: making it big breaks `formattingEditsAfterKeystroke`
	 */
	exports.delayedFlushQueue = utils.throttle(flushQueue, 1);


/***/ },
/* 446 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Mostly providing a typed API on top of `search`
	 */
	exports.commands = {
	    search: function (cm, query) { return startSearch(cm, query); },
	    hideSearch: function (cm) { return hideSearch(cm); },
	    findNext: function (cm, query) { return findNextIfNotAlreadyDoing(cm, query); },
	    findPrevious: function (cm, query) { return findPreviousIfNotAlreadyDoing(cm, query); },
	    replaceNext: function (cm, newText) { return simpleReplaceNext(cm, newText); },
	    replacePrevious: function (cm, newText) { return simpleReplacePrevious(cm, newText); },
	    replaceAll: function (cm, newText) { return simpleReplaceAll(cm, newText); },
	};
	var startSearch = function (editor, query) {
	    var ctrl = hackyGetSearchCtrl(editor);
	    var state = ctrl.getState();
	    if (!state.isRevealed) {
	        ctrl.start({
	            forceRevealReplace: true,
	            seedSearchStringFromSelection: false,
	            shouldFocus: 0,
	            shouldAnimate: false,
	        });
	    }
	    var searchString = query.query, isRegex = query.isRegex, isCaseSensitive = query.isCaseSensitive, isFullWord = query.isFullWord;
	    ctrl.setSearchString(searchString);
	    state.change({
	        isRegex: isRegex,
	        matchCase: isCaseSensitive,
	        wholeWord: isFullWord
	    });
	};
	var hideSearch = function (editor) {
	    var ctrl = hackyGetSearchCtrl(editor);
	    ctrl.closeFindWidget();
	};
	var findNextIfNotAlreadyDoing = function (editor, query) {
	    var ctrl = hackyGetSearchCtrl(editor);
	    if (!ctrl.getState().isRevealed) {
	        startSearch(editor, query);
	    }
	    else {
	        ctrl.moveToNextMatch();
	    }
	};
	var findPreviousIfNotAlreadyDoing = function (editor, query) {
	    var ctrl = hackyGetSearchCtrl(editor);
	    if (!ctrl.getState().isRevealed) {
	        startSearch(editor, query);
	    }
	    else {
	        ctrl.moveToPrevMatch();
	    }
	};
	var simpleReplaceNext = function (editor, newText) {
	    var ctrl = hackyGetSearchCtrl(editor);
	    // Set new text
	    hackySetReplaceText(ctrl, newText);
	    // trigger the replace action
	    ctrl.replace();
	};
	var simpleReplacePrevious = function (editor, newText) {
	    var ctrl = hackyGetSearchCtrl(editor);
	    // Set new text
	    hackySetReplaceText(ctrl, newText);
	    // trigger the replace all
	    hackyReplacePrevious(editor, ctrl, newText);
	};
	var simpleReplaceAll = function (editor, newText) {
	    var ctrl = hackyGetSearchCtrl(editor);
	    // Set new text
	    hackySetReplaceText(ctrl, newText);
	    // trigger the replace all
	    ctrl.replaceAll();
	};
	/**
	 * Our interactions with monaco
	 */
	var hackyGetSearchCtrl = function (editor) {
	    /**
	     * HACK
	     * https://github.com/Microsoft/vscode/blob/814f92341aa9d3f772b17bf6d46a4e04f2c96959/src/vs/editor/contrib/find/common/findController.ts#L52-L54
	     */
	    return editor.getContribution('editor.contrib.findController');
	};
	var hackySetReplaceText = function (ctrl, newText) {
	    // HACK to inject at new text:
	    ctrl.getState()._replaceString = newText;
	};
	var hackyReplacePrevious = function (editor, ctrl, newText) {
	    // If it is on a match it should just replace. Othewise it should go the the previous match
	    // HACK: get the model
	    var model = ctrl._model;
	    // HACK: the following is pretty much a duplicate of `replace` from model
	    // HACK: we made public a few `model` functions
	    // But for actions we delegate to `ctrl` ;)
	    if (!model._hasMatches()) {
	        return;
	    }
	    var selection = editor.getSelection();
	    var selectionText = editor.getModel().getValueInRange(selection);
	    if (model._rangeIsMatch(selection)) {
	        // selection sits on a find match => replace it!
	        ctrl.replace();
	        ctrl.moveToPrevMatch();
	    }
	    else {
	        ctrl.moveToPrevMatch();
	    }
	};


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var ui = __webpack_require__(1);
	var Modal = __webpack_require__(28);
	var styles = __webpack_require__(10);
	var utils_1 = __webpack_require__(3);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var fuzzaldrin_1 = __webpack_require__(96);
	var icon_1 = __webpack_require__(31);
	var events_1 = __webpack_require__(19);
	var state = __webpack_require__(11);
	var types = __webpack_require__(23);
	var robocop_1 = __webpack_require__(153);
	var utils = __webpack_require__(3);
	var appTabsContainer_1 = __webpack_require__(26);
	var typestyle = __webpack_require__(13);
	var inputClassName = typestyle.style(styles.modal.inputStyleBase);
	/** Stuff shared by the select list view */
	var selectListView_1 = __webpack_require__(51);
	var SearchMode;
	(function (SearchMode) {
	    /**
	     * Use if the user does something like `👎>` i.e. invalid mode key
	     * This is also used to search for a mode
	     */
	    SearchMode[SearchMode["Unknown"] = 0] = "Unknown";
	    SearchMode[SearchMode["File"] = 1] = "File";
	    SearchMode[SearchMode["Command"] = 2] = "Command";
	    SearchMode[SearchMode["Project"] = 3] = "Project";
	    SearchMode[SearchMode["Symbol"] = 4] = "Symbol";
	    SearchMode[SearchMode["FilesInProject"] = 5] = "FilesInProject";
	})(SearchMode || (SearchMode = {}));
	var selectedStyle = {
	    background: '#545454',
	    color: 'white'
	};
	var listItemStyle = {
	    fontFamily: 'monospace',
	    boxSizing: 'content-box' /** Otherwise the items don't expand to encapsulate children */
	};
	var searchingNameStyle = { marginTop: '0px', marginBottom: '0px', marginLeft: '10px', border: '1px solid grey', padding: '4px 4px', background: 'black' };
	var OmniSearch = /** @class */ (function (_super) {
	    __extends(OmniSearch, _super);
	    function OmniSearch(props) {
	        var _this = _super.call(this, props) || this;
	        _this.mode = SearchMode.File;
	        _this.searchState = new SearchState();
	        _this.wasShown = false;
	        _this.setRawFilterValue = function (value) {
	            // also scroll to the end of the input after loading
	            var input = ReactDOM.findDOMNode(_this.refs.omniSearchInput);
	            if (!input)
	                return;
	            input.value = value;
	            var len = value.length;
	            input.setSelectionRange(len, len);
	        };
	        _this.onChangeFilter = utils_1.debounce(function (e) {
	            var filterValue = ReactDOM.findDOMNode(_this.refs.omniSearchInput).value;
	            _this.searchState.newValue(filterValue);
	        }, 50);
	        _this.incrementSelected = utils_1.debounce(function () {
	            _this.searchState.incrementSelected();
	        }, 0, true);
	        _this.decrementSelected = utils_1.debounce(function () {
	            _this.searchState.decrementSelected();
	        }, 0, true);
	        _this.onChangeSelected = function (event) {
	            var keyStates = ui.getKeyStates(event);
	            if (keyStates.up || keyStates.tabPrevious) {
	                event.preventDefault();
	                _this.decrementSelected();
	            }
	            if (keyStates.down || keyStates.tabNext) {
	                event.preventDefault();
	                _this.incrementSelected();
	            }
	            if (keyStates.enter) {
	                event.preventDefault();
	                _this.searchState.choseIndex(_this.searchState.selectedIndex);
	            }
	        };
	        _this.searchState.stateChanged.on(function () { return _this.forceUpdate(); });
	        _this.searchState.setParentUiRawFilterValue = function (value) {
	            _this.setRawFilterValue(value);
	        };
	        _this.state = _this.propsToState(props);
	        return _this;
	    }
	    OmniSearch.prototype.propsToState = function (props) {
	        return {};
	    };
	    OmniSearch.prototype.componentWillReceiveProps = function (props) {
	        this.setState(this.propsToState(props));
	    };
	    OmniSearch.prototype.componentDidMount = function () {
	        var _this = this;
	        commands.omniFindFile.on(function () {
	            _this.searchState.openOmniSearch(SearchMode.File);
	        });
	        commands.omniFindCommand.on(function () {
	            _this.searchState.openOmniSearch(SearchMode.Command);
	        });
	        commands.omniSelectProject.on(function () {
	            _this.searchState.openOmniSearch(SearchMode.Project);
	        });
	        commands.omniProjectSymbols.on(function () {
	            _this.searchState.openOmniSearch(SearchMode.Symbol);
	        });
	        commands.omniProjectSourcefile.on(function () {
	            _this.searchState.openOmniSearch(SearchMode.FilesInProject);
	        });
	    };
	    OmniSearch.prototype.componentWillUpdate = function () {
	        this.wasShown = this.searchState.isShown;
	    };
	    OmniSearch.prototype.componentDidUpdate = function () {
	        var _this = this;
	        // get the dom node that is selected
	        // make sure its parent scrolls to make this visible
	        setTimeout(function () {
	            if (_this.refs.selected) {
	                var selected = _this.refs.selected;
	                selected.scrollIntoViewIfNeeded(false);
	            }
	            // also keep the input in focus
	            if (_this.searchState.isShown) {
	                var input = _this.refs.omniSearchInput;
	                input.focus();
	                // and scroll to the end if its just been shown
	                if (!_this.wasShown) {
	                    var len = input.value.length;
	                    input.setSelectionRange(len, len);
	                    _this.wasShown = true;
	                }
	            }
	        });
	    };
	    OmniSearch.prototype.render = function () {
	        var renderedResults = this.searchState.renderResults();
	        var searchingName = this.searchState.getSearchingName();
	        return React.createElement(Modal, { isOpen: this.searchState.isShown, onRequestClose: this.searchState.closeOmniSearch },
	            React.createElement("div", { style: csx.extend(csx.vertical, csx.flex) },
	                React.createElement("div", { style: csx.extend(csx.content, csx.horizontal, csx.center) },
	                    React.createElement("h4", { style: { marginTop: '1rem', marginBottom: '1rem' } },
	                        "Omni Search ",
	                        React.createElement(icon_1.Icon, { name: "search" })),
	                    searchingName ? React.createElement("h5", { style: searchingNameStyle }, searchingName) : '',
	                    React.createElement("div", { style: csx.flex }),
	                    React.createElement("div", { style: { fontSize: '0.9rem', color: 'grey' } },
	                        React.createElement("code", { style: styles.modal.keyStrokeStyle }, "Esc"),
	                        " to exit ",
	                        React.createElement("code", { style: styles.modal.keyStrokeStyle }, "Enter"),
	                        " to select")),
	                React.createElement("div", { style: csx.extend(csx.content, styles.padded1TopBottom, csx.vertical) },
	                    React.createElement("input", { defaultValue: this.searchState.rawFilterValue, className: inputClassName, type: "text", ref: "omniSearchInput", placeholder: "Filter", onChange: this.onChangeFilter, onKeyDown: this.onChangeSelected })),
	                this.searchState.optionalMessage(),
	                React.createElement("div", { ref: "searchScroll", className: "scrollContainer", style: csx.extend(csx.vertical, csx.flex, { overflow: 'auto' }) }, renderedResults)));
	    };
	    return OmniSearch;
	}(ui_1.BaseComponent));
	exports.OmniSearch = OmniSearch;
	/**
	 * Omni search has a lot of UI work (debouncing and whatnot) in it,
	 * don't want to sprinkel in all the MODE selection stuff in there as well
	 * So ... created this class
	 * Responsible for taking user input > parsing it and then > returning the rendered search results
	 * Also maintains the selected index within the search results and takes approriate action if user commits to it
	 *
	 * functions marched with "mode" contain mode specific logic
	 */
	var SearchState = /** @class */ (function () {
	    function SearchState() {
	        var _this = this;
	        /**
	         * Current raw user input value
	         */
	        this.rawFilterValue = '';
	        this.parsedFilterValue = '';
	        /**
	         * Various search lists
	         */
	        /** filepath */
	        this.filePaths = [];
	        this.filePathsCompleted = false;
	        /** project */
	        this.availableProjects = [];
	        /** commands */
	        this.commands = commands.commandRegistry;
	        /** symols */
	        this.symbols = [];
	        /** source code files */
	        this.filesPathsInProject = [];
	        /** Modes can use this to store their results */
	        this.filteredValues = [];
	        /**
	         * Current mode
	         */
	        this.mode = SearchMode.File;
	        this.modeDescriptions = []; // set in ctor
	        this.modeMap = {}; // set in ctor
	        /**
	         * showing search results
	         */
	        this.isShown = false;
	        /**
	         * The currently selected search result
	         */
	        this.selectedIndex = 0;
	        /**
	         * if there are new search results the user might care about, or user selection changed or whatever
	         */
	        this.stateChanged = new events_1.TypedEvent();
	        /** If we change the raw user value */
	        this.setParentUiRawFilterValue = function (rawFilterValue) { return null; };
	        /** for performance reasons */
	        this.maxShowCount = 20;
	        /** Mode */
	        this.choseIndex = function (index) {
	            if (_this.mode == SearchMode.Unknown) {
	                var modeDescription = _this.filteredValues[index];
	                _this.rawFilterValue = modeDescription.shortcut + '>';
	                _this.newValue(_this.rawFilterValue);
	                _this.setParentUiRawFilterValue(_this.rawFilterValue);
	                return;
	            }
	            if (_this.mode == SearchMode.File) {
	                var filePath = _this.filteredValues[index];
	                var line = utils.getFilePathLine(_this.parsedFilterValue).line;
	                if (filePath) {
	                    commands.doOpenFile.emit({ filePath: filePath, position: { line: line, ch: 0 } });
	                }
	                _this.closeOmniSearch();
	                return;
	            }
	            if (_this.mode == SearchMode.Command) {
	                var command = _this.filteredValues[index];
	                if (command) {
	                    command.emit({});
	                }
	                if (command !== commands.omniFindFile
	                    && command !== commands.omniFindCommand
	                    && command !== commands.omniSelectProject) {
	                    _this.closeOmniSearch();
	                }
	                return;
	            }
	            if (_this.mode == SearchMode.Project) {
	                var activeProject = _this.filteredValues[index];
	                if (activeProject) {
	                    socketClient_1.server.setActiveProjectConfigDetails(activeProject);
	                    state.setActiveProject(activeProject);
	                    state.setFilePathsInActiveProject([]);
	                }
	                _this.closeOmniSearch();
	                return;
	            }
	            if (_this.mode == SearchMode.Symbol) {
	                var symbol = _this.filteredValues[index];
	                if (symbol) {
	                    commands.doOpenOrFocusFile.emit({ filePath: symbol.filePath, position: symbol.position });
	                }
	                _this.closeOmniSearch();
	                return;
	            }
	            if (_this.mode == SearchMode.FilesInProject) {
	                var filePath = _this.filteredValues[index];
	                var line = utils.getFilePathLine(_this.parsedFilterValue).line;
	                if (filePath) {
	                    commands.doOpenFile.emit({ filePath: filePath, position: { line: line, ch: 0 } });
	                }
	                _this.closeOmniSearch();
	                return;
	            }
	        };
	        /** Mode */
	        this.openOmniSearch = function (mode) {
	            var wasAlreadyShown = _this.isShown;
	            _this.isShown = true;
	            var oldMode = _this.mode;
	            var oldRawFilterValue = _this.rawFilterValue;
	            _this.mode = mode;
	            var description = _this.modeDescriptions.filter(function (x) { return x.mode == mode; })[0];
	            _this.rawFilterValue = description ? description.shortcut + '>' : '';
	            // If already shown would be nice to preserve current user input
	            // And if the new mode is different
	            // And if the new mode is not *search* search mode
	            if (wasAlreadyShown && oldMode !== _this.mode && oldMode !== SearchMode.Unknown) {
	                _this.rawFilterValue = _this.rawFilterValue + oldRawFilterValue.trim().substr(2);
	            }
	            _this.newValue(_this.rawFilterValue, wasAlreadyShown, oldMode !== _this.mode);
	        };
	        this.incrementSelected = function () {
	            _this.selectedIndex = utils_1.rangeLimited({ num: _this.selectedIndex + 1, min: 0, max: _this.filteredValues.length - 1, loopAround: true });
	            _this.stateChanged.emit({});
	        };
	        this.decrementSelected = function () {
	            _this.selectedIndex = utils_1.rangeLimited({ num: _this.selectedIndex - 1, min: 0, max: _this.filteredValues.length - 1, loopAround: true });
	            _this.stateChanged.emit({});
	        };
	        this.closeOmniSearch = function () {
	            _this.isShown = false;
	            _this.rawFilterValue = '';
	            _this.stateChanged.emit({});
	        };
	        commands.esc.on(function () {
	            _this.closeOmniSearch();
	        });
	        this.filePaths = state.getState().filePaths.filter(function (fp) { return fp.type == types.FilePathType.File; }).map(function (fp) { return fp.filePath; });
	        state.subscribeSub(function (state) { return state.filePaths; }, function (filePaths) {
	            _this.filePaths = filePaths.filter(function (fp) { return fp.type == types.FilePathType.File; }).map(function (fp) { return fp.filePath; });
	            _this.updateIfUserIsSearching(SearchMode.File);
	        });
	        this.filePathsCompleted = state.getState().filePathsCompleted;
	        state.subscribeSub(function (state) { return state.filePathsCompleted; }, function (filePathsCompleted) {
	            _this.filePathsCompleted = filePathsCompleted;
	            _this.updateIfUserIsSearching(SearchMode.File);
	        });
	        socketClient_1.server.availableProjects({}).then(function (res) {
	            _this.availableProjects = res;
	        });
	        socketClient_1.cast.availableProjectsUpdated.on(function (res) {
	            _this.availableProjects = res;
	        });
	        this.modeDescriptions = [
	            {
	                mode: SearchMode.File,
	                description: 'Search for a File in the working directory',
	                shortcut: 'f',
	                searchingName: "Files",
	                keyboardShortcut: commands.omniFindFile.config.keyboardShortcut
	            },
	            {
	                mode: SearchMode.Command,
	                description: 'Search for a Command',
	                shortcut: 'c',
	                searchingName: "Commands",
	                keyboardShortcut: commands.omniFindCommand.config.keyboardShortcut
	            },
	            {
	                mode: SearchMode.Project,
	                description: 'Search for a TypeScript Project to work on',
	                shortcut: 'p',
	                searchingName: "Projects",
	                keyboardShortcut: commands.omniSelectProject.config.keyboardShortcut
	            },
	            {
	                mode: SearchMode.Symbol,
	                description: 'Search for Symbols (Hieroglyphs) in active project',
	                shortcut: 'h',
	                searchingName: "Symbols",
	                keyboardShortcut: commands.omniProjectSymbols.config.keyboardShortcut
	            },
	            {
	                mode: SearchMode.FilesInProject,
	                description: 'Search for TypeScript file in active project',
	                shortcut: 't',
	                searchingName: "Files In Project",
	                keyboardShortcut: commands.omniProjectSourcefile.config.keyboardShortcut
	            }
	        ];
	        // setup mode map
	        this.modeDescriptions.forEach(function (md) { return _this.modeMap[md.shortcut] = md.mode; });
	    }
	    /** Mode */
	    SearchState.prototype.renderResults = function () {
	        var _this = this;
	        var renderedResults = [];
	        if (this.mode == SearchMode.File) {
	            var fileList = this.filteredValues;
	            renderedResults = this.createRenderedForList(fileList, function (filePath) {
	                // Create rendered
	                var queryFilePath = utils.getFilePathLine(_this.parsedFilterValue).filePath;
	                var renderedPath = selectListView_1.renderMatchedSegments(filePath, queryFilePath);
	                var renderedFileName = selectListView_1.renderMatchedSegments(utils_1.getFileName(filePath), queryFilePath);
	                return (React.createElement("div", null,
	                    React.createElement("div", null, renderedFileName),
	                    renderedPath));
	            });
	        }
	        if (this.mode == SearchMode.FilesInProject) {
	            var fileList = this.filteredValues;
	            renderedResults = this.createRenderedForList(fileList, function (filePath) {
	                // Create rendered
	                var queryFilePath = utils.getFilePathLine(_this.parsedFilterValue).filePath;
	                var renderedPath = selectListView_1.renderMatchedSegments(filePath, queryFilePath);
	                var renderedFileName = selectListView_1.renderMatchedSegments(utils_1.getFileName(filePath), queryFilePath);
	                return (React.createElement("div", null,
	                    React.createElement("div", null, renderedFileName),
	                    renderedPath));
	            });
	        }
	        if (this.mode == SearchMode.Command) {
	            var filtered = this.filteredValues;
	            renderedResults = this.createRenderedForList(filtered, function (command) {
	                // Create rendered
	                var matched = selectListView_1.renderMatchedSegments(command.config.description, _this.parsedFilterValue);
	                return (React.createElement("div", { style: csx.horizontal },
	                    React.createElement("span", null, matched),
	                    React.createElement("span", { style: csx.flex }),
	                    command.config.keyboardShortcut &&
	                        React.createElement("div", { style: commandKeyStrokeStyle }, commandShortcutToDisplayName(command.config.keyboardShortcut))));
	            });
	        }
	        if (this.mode == SearchMode.Project) {
	            var filteredProjects = this.filteredValues;
	            renderedResults = this.createRenderedForList(filteredProjects, function (project) {
	                // Create rendered
	                var matched = selectListView_1.renderMatchedSegments(project.name, _this.parsedFilterValue);
	                return (React.createElement("div", null, matched));
	            });
	        }
	        if (this.mode == SearchMode.Symbol) {
	            var filtered = this.filteredValues;
	            renderedResults = this.createRenderedForList(filtered, function (symbol) {
	                // Create rendered
	                // NOTE: Code duplicated in `gotoTypeScriptSymbol.tsx`
	                var matched = selectListView_1.renderMatchedSegments(symbol.name, _this.parsedFilterValue);
	                var color = ui.kindToColor(symbol.kind);
	                var icon = ui.kindToIcon(symbol.kind);
	                return (React.createElement("div", null,
	                    React.createElement("div", { style: csx.horizontal },
	                        React.createElement("span", null, matched),
	                        React.createElement("span", { style: csx.flex }),
	                        React.createElement("strong", { style: { color: color } }, symbol.kind),
	                        "\u00A0",
	                        React.createElement("span", { style: csx.extend({ color: color, fontFamily: 'FontAwesome' }) }, icon)),
	                    React.createElement("div", null,
	                        symbol.fileName,
	                        ":",
	                        symbol.position.line + 1)));
	            });
	        }
	        if (this.mode == SearchMode.Unknown) {
	            var filtered = this.filteredValues;
	            renderedResults = this.createRenderedForList(filtered, function (modeDescription) {
	                // Create rendered
	                var matched = selectListView_1.renderMatchedSegments(modeDescription.description, _this.parsedFilterValue);
	                return (React.createElement("div", { style: csx.extend(csx.horizontal) },
	                    React.createElement("div", null,
	                        modeDescription.shortcut,
	                        '>',
	                        " ",
	                        matched),
	                    React.createElement("span", { style: csx.flex }),
	                    React.createElement("div", { style: commandKeyStrokeStyle }, commandShortcutToDisplayName(modeDescription.keyboardShortcut))));
	            });
	        }
	        return renderedResults;
	    };
	    /** Mode */
	    SearchState.prototype.optionalMessage = function () {
	        if (this.mode == SearchMode.File && !this.filePathsCompleted) {
	            var messageStyle = {
	                fontSize: '.6rem',
	                textAlign: 'center',
	                background: '#333',
	                color: "#ddd",
	                padding: '5px',
	                fontWeight: 'bold',
	                boxShadow: 'inset 0 0 6px black',
	            };
	            return (React.createElement("div", { style: csx.content },
	                React.createElement("div", { style: messageStyle },
	                    "Indexing (",
	                    this.filePaths.length,
	                    ")"),
	                React.createElement(robocop_1.Robocop, null)));
	        }
	        return null;
	    };
	    /** Mode */
	    /** This is the heart of the processing .. ensuring state consistency */
	    SearchState.prototype.newValue = function (value, wasShownBefore, modeChanged) {
	        var _this = this;
	        if (wasShownBefore === void 0) { wasShownBefore = true; }
	        if (modeChanged === void 0) { modeChanged = false; }
	        this.rawFilterValue = value;
	        var oldMode = this.mode;
	        // Parse the query to see what type it is
	        this.parsedFilterValue = '';
	        var trimmed = value.trim();
	        if (trimmed.length > 1 && trimmed[1] == '>') {
	            var mode = this.modeMap[trimmed[0]];
	            if (!mode) {
	                this.mode = SearchMode.Unknown;
	                this.parsedFilterValue = trimmed;
	            }
	            else {
	                this.mode = mode;
	                this.parsedFilterValue = trimmed.substr(2);
	            }
	        }
	        else {
	            this.mode = SearchMode.Unknown;
	            this.parsedFilterValue = trimmed;
	        }
	        modeChanged = modeChanged || this.mode !== oldMode;
	        var modeChangedOrJustOpened = modeChanged || !wasShownBefore;
	        var potentiallyRefreshModeData = modeChangedOrJustOpened ?
	            this.refreshModeData() : Promise.resolve({});
	        potentiallyRefreshModeData.then(function () {
	            if (_this.mode == SearchMode.Unknown) {
	                _this.filteredValues = _this.parsedFilterValue
	                    ? selectListView_1.getFilteredItems({ items: _this.modeDescriptions, textify: function (c) { return c.description; }, filterValue: _this.parsedFilterValue })
	                    : _this.modeDescriptions;
	            }
	            if (_this.mode == SearchMode.File) {
	                var filePath = utils.getFilePathLine(_this.parsedFilterValue).filePath;
	                _this.filteredValues = fuzzaldrin_1.filter(_this.filePaths, filePath);
	                _this.filteredValues = _this.filteredValues.slice(0, _this.maxShowCount);
	            }
	            if (_this.mode == SearchMode.FilesInProject) {
	                var filePath = utils.getFilePathLine(_this.parsedFilterValue).filePath;
	                _this.filteredValues = fuzzaldrin_1.filter(_this.filesPathsInProject, filePath);
	            }
	            if (_this.mode == SearchMode.Command) {
	                _this.filteredValues = _this.parsedFilterValue
	                    ? selectListView_1.getFilteredItems({ items: _this.commands, textify: function (c) { return c.config.description; }, filterValue: _this.parsedFilterValue })
	                    : _this.commands;
	            }
	            if (_this.mode == SearchMode.Project) {
	                // only add a virtual project if the active file path is a .ts or .js file that isn't in active project
	                var availableProjects = _this.availableProjects.slice();
	                var tab = appTabsContainer_1.tabState.getSelectedTab();
	                var filePath = tab && utils.getFilePathFromUrl(tab.url);
	                if (filePath
	                    && utils.isJsOrTs(filePath)
	                    && !state.inActiveProjectUrl(tab.url)) {
	                    availableProjects.unshift({
	                        name: "Virtual: " + utils.getFileName(filePath),
	                        isVirtual: true,
	                        tsconfigFilePath: filePath
	                    });
	                }
	                _this.filteredValues = _this.parsedFilterValue
	                    ? selectListView_1.getFilteredItems({ items: availableProjects, textify: function (p) { return p.name; }, filterValue: _this.parsedFilterValue })
	                    : availableProjects;
	            }
	            if (_this.mode == SearchMode.Symbol) {
	                _this.filteredValues = _this.parsedFilterValue
	                    ? selectListView_1.getFilteredItems({ items: _this.symbols, textify: function (p) { return p.name; }, filterValue: _this.parsedFilterValue })
	                    : _this.symbols;
	                _this.filteredValues = _this.filteredValues.slice(0, _this.maxShowCount);
	            }
	            _this.selectedIndex = 0;
	            _this.stateChanged.emit({});
	            if (modeChangedOrJustOpened) {
	                _this.setParentUiRawFilterValue(_this.rawFilterValue);
	            }
	        });
	    };
	    /** Mode */
	    SearchState.prototype.refreshModeData = function () {
	        var _this = this;
	        // If the new mode requires a search we do that here
	        if (this.mode == SearchMode.Symbol) {
	            return socketClient_1.server.getNavigateToItems({}).then(function (res) {
	                _this.symbols = res.items;
	            });
	        }
	        if (this.mode == SearchMode.FilesInProject) {
	            this.filesPathsInProject = state.getState().filePathsInActiveProject;
	        }
	        return Promise.resolve();
	    };
	    SearchState.prototype.getSearchingName = function () {
	        var _this = this;
	        if (this.mode == SearchMode.Unknown) {
	            return 'Modes';
	        }
	        var description = this.modeDescriptions.filter(function (x) { return x.mode == _this.mode; })[0];
	        if (!description)
	            return '';
	        else
	            return description.searchingName;
	    };
	    SearchState.prototype.createRenderedForList = function (items, itemToRender) {
	        var _this = this;
	        return items.map(function (item, index) {
	            var rendered = itemToRender(item);
	            var selected = _this.selectedIndex === index;
	            var style = selected ? selectedStyle : {};
	            var ref = selected && "selected";
	            return (React.createElement("div", { key: index, style: csx.extend(style, styles.padded2, styles.hand, listItemStyle), onClick: function () { return _this.choseIndex(index); }, ref: ref }, rendered));
	        });
	    };
	    SearchState.prototype.updateIfUserIsSearching = function (mode) {
	        if (this.mode == mode && this.isShown) {
	            this.newValue(this.rawFilterValue);
	        }
	    };
	    return SearchState;
	}());
	var commandKeyStrokeStyle = {
	    fontSize: '.7rem',
	    color: '#DDD',
	    background: '#111',
	    paddingLeft: '4px',
	    paddingRight: '4px',
	    border: '2px solid',
	    borderRadius: '4px',
	};
	/** Utility function for command display */
	function commandShortcutToDisplayName(shortcut) {
	    var basic = shortcut
	        .replace(/mod/g, commands.modName)
	        .replace(/alt/g, 'Alt')
	        .replace(/shift/g, 'Shift');
	    var onPlus = basic.split('+');
	    onPlus[onPlus.length - 1] = onPlus[onPlus.length - 1].toUpperCase();
	    return onPlus.join(' + ');
	}


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ui_1 = __webpack_require__(1);
	var react_redux_1 = __webpack_require__(29);
	var ui = __webpack_require__(1);
	__webpack_require__(374);
	var PendingRequestsIndicator = /** @class */ (function (_super) {
	    __extends(PendingRequestsIndicator, _super);
	    function PendingRequestsIndicator() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleClick = function () {
	            console.log(_this.props.pendingRequests);
	            ui.notifyInfoNormalDisappear("Pending Requests: " + _this.props.pendingRequests.join(' 🚴 '));
	        };
	        return _this;
	    }
	    PendingRequestsIndicator.prototype.componentWillReceiveProps = function () {
	    };
	    PendingRequestsIndicator.prototype.render = function () {
	        var pendingRequestsCount = this.props.pendingRequests.length;
	        var style = {
	            opacity: pendingRequestsCount ? 1 : 0,
	            transition: 'opacity .5s',
	            cursor: 'pointer'
	        };
	        var pendingRequestCountStyle = {
	            fontSize: '7px',
	            paddingRight: '2px',
	            color: '#2776b7'
	        };
	        return (React.createElement("span", { style: style, onClick: this.handleClick },
	            React.createElement("span", { style: pendingRequestCountStyle }, pendingRequestsCount),
	            React.createElement("span", { className: "loader" },
	                React.createElement("ul", null,
	                    React.createElement("li", { className: "one" }),
	                    React.createElement("li", { className: "two" }),
	                    React.createElement("li", { className: "three" }),
	                    React.createElement("li", { className: "four" }),
	                    React.createElement("li", { className: "five" })))));
	    };
	    PendingRequestsIndicator = __decorate([
	        react_redux_1.connect(function (state) {
	            return {
	                pendingRequests: state.pendingRequests,
	            };
	        })
	    ], PendingRequestsIndicator);
	    return PendingRequestsIndicator;
	}(ui_1.BaseComponent));
	exports.PendingRequestsIndicator = PendingRequestsIndicator;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var ui = __webpack_require__(1);
	var uix = __webpack_require__(41);
	var csx = __webpack_require__(6);
	var appTabsContainer_1 = __webpack_require__(26);
	var Modal = __webpack_require__(28);
	var omniSearch_1 = __webpack_require__(447);
	var fileTree_1 = __webpack_require__(400);
	var selectListView_1 = __webpack_require__(51);
	var inputDialog_1 = __webpack_require__(83);
	var serverExit_1 = __webpack_require__(450);
	var statusBar_1 = __webpack_require__(453);
	var mainPanel_1 = __webpack_require__(404);
	var findAndReplace_1 = __webpack_require__(155);
	/** Force require  */
	var gotoHistory = __webpack_require__(156);
	var clipboardRing = __webpack_require__(391);
	var configCreator = __webpack_require__(398);
	var settings = __webpack_require__(451);
	var openFileFromServerDisk = __webpack_require__(394);
	var gitAddAllCommitAndPush = __webpack_require__(392);
	var gitFetchLatestAndRebase = __webpack_require__(393);
	var ensureImport = gotoHistory
	    || configCreator
	    || settings
	    || openFileFromServerDisk
	    || gitAddAllCommitAndPush
	    || gitFetchLatestAndRebase
	    || clipboardRing;
	var Root = /** @class */ (function (_super) {
	    __extends(Root, _super);
	    function Root(props) {
	        var _this = _super.call(this, props) || this;
	        _this.toggle = function () {
	            _this.refs.leftNav.toggle();
	        };
	        _this.state = {};
	        return _this;
	    }
	    Root.prototype.componentDidMount = function () {
	        uix.setup();
	    };
	    Root.prototype.render = function () {
	        var toret = React.createElement("div", { id: "root", style: csx.vertical },
	            React.createElement(omniSearch_1.OmniSearch, null),
	            React.createElement(serverExit_1.ServerExit, null),
	            React.createElement(selectListView_1.SelectListView, null),
	            React.createElement(inputDialog_1.InputDialog, null),
	            React.createElement("div", { style: csx.extend(csx.flex, csx.horizontal) },
	                React.createElement(fileTree_1.FileTree, null),
	                React.createElement(appTabsContainer_1.AppTabsContainer, null)),
	            React.createElement(findAndReplace_1.FindAndReplace, null),
	            React.createElement(mainPanel_1.MainPanel, null),
	            React.createElement(statusBar_1.StatusBar, { ref: "statusBar" }));
	        return toret;
	    };
	    return Root;
	}(ui.BaseComponent));
	exports.Root = Root;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var Modal = __webpack_require__(28);
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var socketClient_1 = __webpack_require__(5);
	var ServerExit = /** @class */ (function (_super) {
	    __extends(ServerExit, _super);
	    function ServerExit(props) {
	        var _this = _super.call(this, props) || this;
	        _this.askUserToClose = function () { return ui.notifyInfoQuickDisappear("Please close the browser tab manually"); };
	        _this.state = {
	            isOpen: false
	        };
	        return _this;
	    }
	    ServerExit.prototype.componentDidMount = function () {
	        var _this = this;
	        socketClient_1.cast.serverExiting.on(function () {
	            _this.setState({ isOpen: true });
	            document.title = "Server Exited 🌹";
	        });
	    };
	    ServerExit.prototype.render = function () {
	        return (React.createElement(Modal, { isOpen: this.state.isOpen, onRequestClose: this.askUserToClose },
	            React.createElement("div", { style: csx.extend(csx.centerCenter, csx.flex, { color: 'white', fontSize: '20px' }), onClick: this.askUserToClose }, "The server has exited. Please close this browser tab.")));
	    };
	    return ServerExit;
	}(ui.BaseComponent));
	exports.ServerExit = ServerExit;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Commands to manage settings related stuff
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands = __webpack_require__(7);
	var socketClient_1 = __webpack_require__(5);
	commands.openSettingsFile.on(function () {
	    socketClient_1.server.getSettingsFilePath({}).then(function (res) {
	        commands.doOpenOrFocusFile.emit({ filePath: res.filePath });
	    });
	});


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var redux_1 = __webpack_require__(144);
	/**
	 * Instead of creating a "reducer" (with a switch statement!) + "actionCreator"
	 * You just call `add` to provide a typeSafe "reducer" and we give you a typeSafe "actionCreator"
	 */
	var SimpleRedux = /** @class */ (function () {
	    function SimpleRedux(initialState) {
	        var _this = this;
	        this.initialState = initialState;
	        this._listeners = {};
	        this.getState = function () {
	            return _this.store.getState();
	        };
	        this.subscribe = function (changed) {
	            return { dispose: _this.store.subscribe(function () { return changed(_this.getState()); }) };
	        };
	        this.subscribeSub = function (select, onChange) {
	            var currentState = select(_this.getState());
	            var handleChange = function () {
	                var nextState = select(_this.getState());
	                if (nextState !== currentState) {
	                    currentState = nextState;
	                    onChange(currentState);
	                }
	            };
	            return _this.subscribe(handleChange);
	        };
	        this._reducer = function (state, action) {
	            if (state === void 0) { state = _this.initialState; }
	            if (_this._listeners[action.type])
	                return _this._extendState(state, _this._listeners[action.type](state, action.payload));
	            else
	                return state;
	        };
	        /**
	         * Take every field of fields and put them override them in the complete object
	         * NOTE: this API is a bit reverse of extend because of the way generic constraints work in TypeScript
	         */
	        this.updateFields = function (fields) { return function (complete) {
	            var result = {};
	            for (var id in complete) {
	                result[id] = complete[id];
	            }
	            for (var id in fields) {
	                result[id] = fields[id];
	            }
	            return result;
	        }; };
	        this.store = redux_1.createStore(this._reducer);
	    }
	    SimpleRedux.prototype.add = function (usefulNameForDebugging, reducer) {
	        var _this = this;
	        if (this._listeners[usefulNameForDebugging])
	            throw new Error("REDUX: already have reducer \"" + usefulNameForDebugging + "\"");
	        var dispatcher = function (payload) { return _this.store.dispatch({
	            type: usefulNameForDebugging,
	            payload: payload
	        }); };
	        this._listeners[usefulNameForDebugging] = reducer;
	        return dispatcher;
	    };
	    /**
	     * WARNING: this only supports 1 level of nesting
	     */
	    SimpleRedux.prototype.addSub = function (usefulNameForDebugging, select, reducer) {
	        var _this = this;
	        var dispatcher = function (payload) { return _this.store.dispatch({
	            type: usefulNameForDebugging,
	            payload: payload
	        }); };
	        this._listeners[usefulNameForDebugging] = function (state, payload) {
	            var sub = select(state);
	            for (var key in state) {
	                if (state[key] == sub)
	                    break;
	            }
	            var newSub = reducer(sub, payload);
	            state[key] = newSub;
	            return state;
	        };
	        return dispatcher;
	    };
	    SimpleRedux.prototype._extendState = function (state, newState) {
	        var result = {};
	        for (var key in state) {
	            result[key] = state[key];
	        }
	        for (var key in newState) {
	            result[key] = newState[key];
	        }
	        return result;
	    };
	    // Update the item at index
	    SimpleRedux.prototype.updateArrayItem = function (array, index, item) {
	        return array.map(function (x, i) { return i == index ? item : x; });
	    };
	    return SimpleRedux;
	}());
	exports.SimpleRedux = SimpleRedux;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var React = __webpack_require__(2);
	var ReactDOMServer = __webpack_require__(133);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var ui = __webpack_require__(1);
	var commands = __webpack_require__(7);
	var types = __webpack_require__(23);
	var pendingRequestsIndicator_1 = __webpack_require__(448);
	var icon_1 = __webpack_require__(31);
	var appTabsContainer_1 = __webpack_require__(26);
	var progress_1 = __webpack_require__(397);
	var react_redux_1 = __webpack_require__(29);
	var state_1 = __webpack_require__(11);
	var state = __webpack_require__(11);
	var globalErrorCacheClient_1 = __webpack_require__(35);
	var clientTestResultsCache_1 = __webpack_require__(59);
	var notificationKeyboardStyle = {
	    border: '2px solid',
	    borderRadius: '6px',
	    display: 'inline-block',
	    padding: '5px',
	    background: 'grey',
	};
	var ouputStatusStyle = csx.extend(styles.noSelect, { fontSize: '.6rem' });
	var activeProjectContainerStyle = csx.extend(styles.statusBarSection, styles.hand, styles.noSelect, {
	    border: '1px solid grey',
	    paddingTop: '2px',
	    paddingBottom: '2px',
	    paddingLeft: '4px',
	    paddingRight: '4px',
	    fontSize: '.7rem',
	    marginTop: '1px',
	});
	var projectTipKeboard = ReactDOMServer.renderToString(React.createElement("div", { style: notificationKeyboardStyle }, "Alt+Shift+P"));
	var StatusBar = /** @class */ (function (_super) {
	    __extends(StatusBar, _super);
	    function StatusBar(props) {
	        var _this = _super.call(this, props) || this;
	        _this.toggleErrors = function () {
	            if (_this.props.errorsExpanded) {
	                state_1.collapseErrors({});
	            }
	            else {
	                state_1.expandErrors({});
	            }
	        };
	        _this.toggleFileTree = function () {
	            if (_this.props.fileTreeShown) {
	                state.collapseFileTree({});
	            }
	            else {
	                state.expandFileTree({});
	            }
	        };
	        _this.openErrorLocation = function (error) {
	            commands.doOpenOrFocusFile.emit({ filePath: error.filePath, position: error.from });
	        };
	        _this.openFile = function (filePath) {
	            commands.doOpenOrFocusFile.emit({ filePath: filePath });
	        };
	        _this.giveStar = function () {
	            window.open('https://github.com/alm-tools/alm');
	        };
	        _this.giveRose = function () {
	            window.open('https://twitter.com/basarat');
	        };
	        _this.whatsNew = function () {
	            /** We currently show the diff. Once we have semantic releases we will show release notes */
	            var update = serverState.update;
	            window.open("https://github.com/alm-tools/alm/compare/v" + update.current + "...v" + update.latest);
	        };
	        _this.state = {};
	        return _this;
	    }
	    StatusBar.prototype.componentDidMount = function () {
	        var _this = this;
	        exports.statusBar = this;
	        appTabsContainer_1.tabStateChanged.on(function () { return _this.forceUpdate(); });
	        globalErrorCacheClient_1.errorsCache.errorsDelta.on(function () { return _this.forceUpdate(); });
	        clientTestResultsCache_1.testResultsCache.testResultsDelta.on(function () { return _this.forceUpdate(); });
	    };
	    StatusBar.prototype.render = function () {
	        var _this = this;
	        var tab = appTabsContainer_1.tabState.getSelectedTab();
	        var filePath = tab && utils.getFilePathFromUrl(tab.url);
	        var protocol = tab && utils.getFilePathAndProtocolFromUrl(tab.url).protocol;
	        var activeProjectDetails = this.props.activeProject
	            ? React.createElement("span", { className: "hint--top-right", "data-hint": "Active Project path. Click to open project file", style: activeProjectContainerStyle, onClick: function () {
	                    _this.openFile(_this.props.activeProject.tsconfigFilePath);
	                    ui.notifyInfoNormalDisappear("TIP : You can change the active project using project search <br/> <br/> " + projectTipKeboard, { onClick: function () { return commands.omniSelectProject.emit({}); } });
	                } },
	                React.createElement("span", { style: csx.extend(styles.noSelect, styles.statusBarSuccess, styles.hand, { marginRight: '5px' }) },
	                    React.createElement(icon_1.Icon, { name: "heartbeat" })),
	                this.props.activeProject.isVirtual && React.createElement("span", { style: csx.extend(styles.noSelect, styles.statusBarSuccess, styles.hand, { marginRight: '5px' }) },
	                    React.createElement(icon_1.Icon, { name: "blind" })),
	                this.props.activeProject.name)
	            : React.createElement("span", { className: "hint--top-right", style: csx.extend(styles.statusBarSection, styles.noSelect, styles.statusBarError, styles.hand), onClick: function () { return ui.notifyWarningNormalDisappear("There is no active project. Please select from the available ones <br/> <br/> " + projectTipKeboard, { onClick: function () { return commands.omniSelectProject.emit({}); } }); }, "data-hint": "There is no active TypeScript project. Robots deactivated." },
	                React.createElement(icon_1.Icon, { name: "heartbeat" }));
	        var inActiveProjectSection = !tab
	            ? ''
	            : React.createElement("span", { style: styles.statusBarSection }, state.inActiveProjectUrl(tab.url)
	                ? React.createElement("span", { className: "hint--top-right hint--success", style: csx.extend(styles.noSelect, styles.statusBarSuccess, styles.hand), onClick: function () { return ui.notifySuccessNormalDisappear("The file is a part of the currently active TypeScript project and we are actively providing code intelligence"); }, "data-hint": "File is part of the currently active project. \uD83D\uDCBB providing code intelligence." },
	                    React.createElement(icon_1.Icon, { name: "eye" }))
	                : React.createElement("span", { className: "hint--top-right", style: csx.extend(styles.noSelect, styles.statusBarError, styles.hand), onClick: function () { return ui.notifyWarningNormalDisappear("The file is not a part of the currently active TypeScript project <br/> <br/> " + projectTipKeboard, { onClick: function () { return commands.omniSelectProject.emit({}); } }); }, "data-hint": "File is not a part of the currently active project. Robots deactivated." },
	                    React.createElement(icon_1.Icon, { name: "eye-slash" })));
	        var fileOutput = protocol !== 'file' ? null
	            : !this.props.outputStatusCache[filePath] ? null
	                : this.props.outputStatusCache[filePath];
	        var fileOutputState = fileOutput && fileOutput.state;
	        var openOutputJSFile = function () {
	            commands.doToggleFileTab.emit({ filePath: fileOutput.outputFilePath });
	        };
	        var fileOutputStateRendered = !!fileOutputState
	            && React.createElement("span", { style: styles.statusBarSection },
	                React.createElement("span", { style: csx.extend(ouputStatusStyle) }, fileOutputState === types.JSOutputState.NoJSFile ? null
	                    : fileOutputState === types.JSOutputState.JSOutOfDate ? React.createElement("span", { style: csx.extend(styles.statusBarError, { transition: 'color .5s', cursor: 'pointer' }), onClick: openOutputJSFile }, "\u274C JS Outdated")
	                        : React.createElement("span", { style: csx.extend(styles.statusBarSuccess, { transition: 'color .5s', cursor: 'pointer' }), onClick: openOutputJSFile }, "\u2713 JS Current")));
	        var fileTreeToggleRendered = React.createElement("span", { style: csx.extend(styles.statusBarSection, styles.noSelect, styles.hand), onClick: this.toggleFileTree, className: "hint--top-right", "data-hint": "Click to toggle the file tree \uD83C\uDF32" },
	            React.createElement("span", { style: csx.extend(this.props.fileTreeShown ? { color: 'white' } : { color: 'grey' }, { transition: 'color .4s' }) },
	                React.createElement(icon_1.Icon, { name: "tree" })));
	        var updateRendered = serverState.update
	            && React.createElement("span", { style: csx.extend(styles.statusBarSection) },
	                React.createElement("span", { className: "hint--left hint--error", "data-hint": "Update " + serverState.update.latest + " available (current: " + serverState.update.current + ")" + ". Please run `npm i -g alm`" },
	                    React.createElement(icon_1.Icon, { style: { color: styles.errorColor, cursor: 'pointer' }, name: "wrench", onClick: this.whatsNew })));
	        var errorsUpdate = globalErrorCacheClient_1.errorsCache.getErrorsLimited();
	        var errorFilteringActive = this.props.errorsDisplayMode !== types.ErrorsDisplayMode.all || this.props.errorsFilter.trim();
	        var errorsFilteredCount = appTabsContainer_1.tabState.errorsByFilePathFiltered().errorsFlattened.length;
	        /** Tested */
	        var testResultsStats = clientTestResultsCache_1.testResultsCache.getStats();
	        var failing = !!testResultsStats.failCount;
	        var totalThatRan = testResultsStats.passCount + testResultsStats.failCount;
	        var testStatsRendered = !!testResultsStats.testCount && React.createElement("span", { className: "hint--top-right", "data-hint": "Test Total: " + testResultsStats.testCount + ", Pass: " + testResultsStats.passCount + ", Fail: " + testResultsStats.failCount + ", Skip: " + testResultsStats.skipCount + ", Duration: " + utils.formatMilliseconds(testResultsStats.durationMs), style: csx.extend(activeProjectContainerStyle), onClick: function () {
	                commands.doOpenTestResultsView.emit({});
	            } },
	            React.createElement("span", { style: csx.extend(styles.noSelect, failing ? styles.statusBarError : styles.statusBarSuccess, styles.hand, {
	                    marginRight: '5px',
	                    transition: '.4s color, .4s opacity',
	                    opacity: this.props.testedWorking.working ? 1 : 0.5,
	                }) },
	                React.createElement(icon_1.Icon, { name: styles.icons.tested, spin: this.props.testedWorking.working })),
	            failing
	                ? React.createElement("span", { style: { color: styles.errorColor, fontWeight: 'bold' } },
	                    testResultsStats.failCount,
	                    "/",
	                    totalThatRan,
	                    " fail")
	                : React.createElement("span", { style: { color: styles.successColor, fontWeight: 'bold' } },
	                    testResultsStats.passCount,
	                    "/",
	                    totalThatRan,
	                    " pass"));
	        return (React.createElement("div", null,
	            React.createElement("div", { style: csx.extend(styles.statusBar, csx.horizontal, csx.center, styles.noWrap) },
	                React.createElement("span", { style: csx.extend(styles.statusBarSection, styles.noSelect, styles.hand), onClick: this.toggleErrors, className: "hint--top-right", "data-hint": errorsUpdate.totalCount + " errors. Click to toggle message panel." },
	                    React.createElement("span", { style: csx.extend(errorsUpdate.totalCount ? styles.statusBarError : styles.statusBarSuccess, { transition: 'color .4s' }) },
	                        errorsUpdate.totalCount,
	                        " ",
	                        React.createElement(icon_1.Icon, { name: "times-circle" }),
	                        errorFilteringActive && ' ',
	                        errorFilteringActive && React.createElement("span", null,
	                            "( ",
	                            errorsFilteredCount,
	                            " ",
	                            React.createElement(icon_1.Icon, { name: "filter" }),
	                            ")"))),
	                React.createElement("span", { style: csx.extend(styles.statusBarSection, styles.noSelect, styles.hand) },
	                    React.createElement("span", { className: this.props.tsWorking.working ? "hint--right hint--success" : "hint--right", "data-hint": this.props.tsWorking.working ? "TS Worker Busy" : "TS Worker Idle", style: {
	                            color: this.props.tsWorking.working ? 'white' : 'grey',
	                            transition: 'color .4s'
	                        } },
	                        React.createElement(icon_1.Icon, { name: "rocket" }))),
	                testStatsRendered,
	                fileTreeToggleRendered,
	                activeProjectDetails,
	                inActiveProjectSection,
	                filePath
	                    ? React.createElement("span", { className: "hint--top-right", "data-hint": "Click to copy the file path to clipboard", "data-clipboard-text": filePath.replace(/\//g, commands.windows ? '\\' : '/'), onClick: function () { return ui.notifyInfoQuickDisappear("File path copied to clipboard"); }, style: csx.extend(styles.statusBarSection, styles.noSelect, styles.hand) }, filePath)
	                    : '',
	                fileOutputStateRendered,
	                React.createElement("span", { style: csx.flex }),
	                React.createElement("span", { style: csx.extend(styles.statusBarSection) },
	                    React.createElement(pendingRequestsIndicator_1.PendingRequestsIndicator, null)),
	                this.props.liveBuildResults.builtCount !== this.props.liveBuildResults.totalCount &&
	                    React.createElement("span", { style: csx.extend(styles.statusBarSection) },
	                        React.createElement(progress_1.Progress, { current: this.props.liveBuildResults.builtCount, total: this.props.liveBuildResults.totalCount },
	                            this.props.liveBuildResults.builtCount,
	                            " / ",
	                            this.props.liveBuildResults.totalCount)),
	                React.createElement("span", { style: csx.extend(styles.statusBarSection) }, this.props.socketConnected ?
	                    React.createElement("span", { className: "hint--left hint--success", "data-hint": "Connected to server" },
	                        " ",
	                        React.createElement(icon_1.Icon, { style: { color: styles.successColor, cursor: 'pointer' }, name: "flash", onClick: function () { return ui.notifySuccessNormalDisappear("Connected to alm server"); } }))
	                    : React.createElement("span", { className: "hint--left hint--error", "data-hint": "Disconnected from server" },
	                        " ",
	                        React.createElement(icon_1.Icon, { style: { color: styles.errorColor, cursor: 'pointer' }, name: "spinner", spin: true, onClick: function () { return ui.notifyWarningNormalDisappear("Disconneted from alm server"); } }))),
	                React.createElement("span", { style: csx.extend(styles.statusBarSection, styles.noSelect, styles.hand) },
	                    React.createElement("span", { style: { paddingRight: '2px' }, onClick: this.giveStar, className: "hint--left", "data-hint": "If you like it then you should have put a star on it \uD83C\uDF1F. Also, go here for support. Version: " + serverState.version + ", TypeScript version: " + serverState.typescriptVersion }, "\uD83C\uDF1F"),
	                    React.createElement("span", { onClick: this.giveRose, className: "hint--left", "data-hint": "Your love keep this rose alive \uD83C\uDF39" }, "\uD83C\uDF39")),
	                updateRendered)));
	    };
	    StatusBar = __decorate([
	        react_redux_1.connect(function (state) {
	            return {
	                errorsExpanded: state.errorsExpanded,
	                activeProject: state.activeProject,
	                activeProjectFiles: state.activeProjectFilePathTruthTable,
	                socketConnected: state.socketConnected,
	                outputStatusCache: state.outputStatusCache,
	                liveBuildResults: state.liveBuildResults,
	                fileTreeShown: state.fileTreeShown,
	                errorsDisplayMode: state.errorsDisplayMode,
	                errorsFilter: state.errorsFilter,
	                tsWorking: state.tsWorking,
	                testedWorking: state.testedWorking,
	            };
	        }),
	        __metadata("design:paramtypes", [Object])
	    ], StatusBar);
	    return StatusBar;
	}(ui_1.BaseComponent));
	exports.StatusBar = StatusBar;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var styles = __webpack_require__(10);
	var ErrorMessage = /** @class */ (function (_super) {
	    __extends(ErrorMessage, _super);
	    function ErrorMessage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ErrorMessage.prototype.render = function () {
	        var style = {
	            padding: '20px',
	            fontSize: '1.3rem',
	            fontWeight: 'bold',
	            color: styles.errorColor,
	        };
	        return React.createElement("div", { style: csx.extend(csx.flex, csx.centerCenter, style) }, this.props.text);
	    };
	    return ErrorMessage;
	}(React.PureComponent));
	exports.ErrorMessage = ErrorMessage;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var csx = __webpack_require__(6);
	var ui_1 = __webpack_require__(1);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var commands = __webpack_require__(7);
	var tipStyle = {
	    fontSize: '2rem',
	    color: styles.successColor,
	    fontWeight: 'bold',
	    userSelect: 'none',
	    whiteSpace: 'pre',
	};
	var tipKeyboardStyle = {
	    border: '2px solid',
	    borderRadius: '6px'
	};
	var Tips = /** @class */ (function (_super) {
	    __extends(Tips, _super);
	    function Tips(props) {
	        var _this = _super.call(this, props) || this;
	        _this.tips = [
	            {
	                message: 'Find a file to work with',
	                keyboard: commands.modName + "+P"
	            },
	            {
	                message: 'Set active project',
	                keyboard: "Alt+Shift+P"
	            },
	            {
	                message: 'Close a tab',
	                keyboard: 'Alt+W'
	            },
	            {
	                message: 'Undo close tab',
	                keyboard: 'Alt+Shift+W'
	            },
	            {
	                message: 'Editor keybindings:',
	                keyboard: 'Sublime Text'
	            },
	            {
	                message: 'Editor focus from anywhere',
	                keyboard: 'Escape'
	            }
	        ];
	        _this.state = {
	            selected: 0
	        };
	        return _this;
	    }
	    Tips.prototype.componentDidMount = function () {
	        var _this = this;
	        var next = function () { return utils.rangeLimited({ num: _this.state.selected + 1, min: 0, max: _this.tips.length - 1, loopAround: true }); };
	        var loop = setInterval(function () { return _this.setState({ selected: next() }); }, 5000);
	        this.disposible.add({ dispose: function () { return clearInterval(loop); } });
	    };
	    Tips.prototype.componentWillUnmount = function () {
	        this.disposible.dispose();
	    };
	    Tips.prototype.render = function () {
	        var tip = this.tips[this.state.selected];
	        {
	            /**
	             * To use velocity animation group
	             *  - The first sub element must change ... hence `key` otherwise react reuses DOM
	             *  - The first sub element will be forced to have `display:block`
	             *  	(velocity does that for some reason ... so no flexbox ... we use newLayer)
	             *  - Restore flexbox using newLayer + some flex root
	             */
	        }
	        return (React.createElement("div", { key: this.state.selected, style: csx.extend(csx.newLayer) },
	            React.createElement("span", { style: csx.extend(csx.newLayer, csx.flexRoot) },
	                React.createElement("span", { style: csx.extend(csx.flex, csx.centerCenter, tipStyle) },
	                    tip.message,
	                    "\u00A0",
	                    React.createElement("span", { style: tipKeyboardStyle },
	                        " ",
	                        tip.keyboard,
	                        " ")))));
	    };
	    return Tips;
	}(ui_1.BaseComponent));
	exports.Tips = Tips;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var d3 = __webpack_require__(90);
	var $ = __webpack_require__(36);
	var styles = __webpack_require__(10);
	var errorMessage_1 = __webpack_require__(454);
	var typestyle = __webpack_require__(13);
	var socketContract_1 = __webpack_require__(164);
	exports.noFocusOutlineClassName = typestyle.style(styles.noFocusOutlineBase);
	var EOL = '\n';
	/**
	 * The styles
	 */
	__webpack_require__(358);
	var ASTView = /** @class */ (function (_super) {
	    __extends(ASTView, _super);
	    function ASTView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.display = function (node) {
	            _this.setState({ selectedNode: node });
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            // This layout doesn't need it
	        };
	        _this.focus = function () {
	            _this.refs.root.focus();
	            // if its not there its because an XHR is lagging and it will show up when that xhr completes anyways
	            _this.astViewRenderer && _this.astViewRenderer.update();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	                // TODO
	            },
	            hideSearch: function () {
	                // TODO
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        var _a = utils.getFilePathAndProtocolFromUrl(props.url), protocol = _a.protocol, filePath = _a.filePath;
	        _this.mode = protocol === 'ast' ? socketContract_1.Types.ASTMode.visitor : socketContract_1.Types.ASTMode.children;
	        _this.filePath = filePath;
	        _this.state = {};
	        return _this;
	    }
	    ASTView.prototype.componentDidMount = function () {
	        var _this = this;
	        var reloadData = function () {
	            _this.setState({ error: null });
	            socketClient_1.server.openFile({ filePath: _this.filePath }).then(function (res) {
	                _this.setState({ text: res.contents });
	            });
	            socketClient_1.server.getAST({ mode: _this.mode, filePath: _this.filePath })
	                .then(function (res) {
	                _this.astViewRenderer = new ASTViewRenderer({
	                    rootNode: res.root,
	                    _mainContent: $(_this.refs.graphRoot),
	                    display: _this.display
	                });
	            })
	                .catch(function (err) {
	                _this.setState({
	                    error: "Failed to get the AST details for the file " + _this.filePath + ". Make sure it is in the active project. Change project using Alt+Shift+P."
	                });
	            });
	        };
	        var reloadDataDebounced = utils.debounce(reloadData, 2000);
	        reloadData();
	        this.disposible.add(socketClient_1.cast.activeProjectConfigDetailsUpdated.on(function () {
	            reloadDataDebounced();
	        }));
	        this.disposible.add(commands.fileContentsChanged.on(function (res) {
	            if (res.filePath === _this.filePath) {
	                reloadDataDebounced();
	            }
	        }));
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    ASTView.prototype.render = function () {
	        var node = this.state.selectedNode;
	        var display = node
	            ? ("\n" + node.kind + "\n-------------------- AST --------------------\n" + node.rawJson + "\n-------------------- TEXT -------------------\n" + this.state.text.substring(node.pos, node.end) + "\n                ").trim()
	            : "The selected AST node details will go here";
	        var content = this.state.error
	            ? React.createElement(errorMessage_1.ErrorMessage, { text: this.state.error })
	            : React.createElement("div", { style: csx.extend(csx.flex, csx.horizontal, { maxWidth: '100%' }) },
	                React.createElement("div", { style: csx.extend(csx.flex, csx.scroll), ref: "graphRoot", className: "ast-view" }),
	                React.createElement("div", { style: csx.extend(csx.flex, csx.flexRoot, csx.scroll, styles.padded1, { background: 'white' }) },
	                    React.createElement("pre", { style: csx.extend(csx.flex, { margin: '0px' }) }, display)));
	        return (React.createElement("div", { ref: "root", tabIndex: 0, className: exports.noFocusOutlineClassName, style: csx.extend(csx.horizontal, csx.flex, styles.someChildWillScroll) }, content));
	    };
	    return ASTView;
	}(ui.BaseComponent));
	exports.ASTView = ASTView;
	var ASTViewRenderer = /** @class */ (function () {
	    function ASTViewRenderer(config) {
	        var _this = this;
	        this.config = config;
	        // General D3 utlis
	        this.tree = d3.layout.tree().nodeSize([0, 20]);
	        this.diagonal = d3.svg.diagonal()
	            .projection(function (d) { return [d.y, d.x]; });
	        // vodoo
	        this.i = 0;
	        // layout constants
	        this.margin = { top: 30, right: 20, bottom: 30, left: 20 };
	        this.barHeight = 30;
	        this.duration = 400;
	        /** display details on click */
	        this.select = function (node) {
	            _this.config.display(node);
	            _this.selected = node;
	            _this.update();
	        };
	        this.getWidth = function () { return _this.root.jq.width() - _this.margin.left - _this.margin.right; };
	        this.update = function () {
	            var width = _this.getWidth();
	            // If width is less than 0 means its insignificant to render anyways.
	            // Just return and way for update to be called again when it is significant
	            if (width < 0) {
	                return;
	            }
	            _this.svgRoot.attr("width", width);
	            var barWidth = width * .8;
	            // Compute the flattened node list. TODO use d3.layout.hierarchy.
	            var nodes = _this.tree.nodes(_this.rootNode);
	            var height = Math.max(500, nodes.length * _this.barHeight + _this.margin.top + _this.margin.bottom);
	            _this.svgRoot.transition()
	                .duration(_this.duration)
	                .attr("height", height);
	            d3.select(self.frameElement).transition()
	                .duration(_this.duration)
	                .style("height", height + "px");
	            // Compute the "layout".
	            nodes.forEach(function (n, i) {
	                n.x = i * _this.barHeight;
	            });
	            // Update the nodes…
	            var node = _this.graph.selectAll("g.node")
	                .data(nodes, function (d) { return d.id || (d.id = ++_this.i); });
	            var nodeEnter = node.enter().append("g")
	                .attr("class", "node")
	                .attr("transform", function (d) { return "translate(" + _this.rootNode.depth + "," + _this.rootNode.nodeIndex + ")"; })
	                .style("opacity", 1e-6);
	            // Enter any new nodes at the parent's previous position.
	            nodeEnter.append("rect")
	                .attr("y", -_this.barHeight / 2)
	                .attr("height", _this.barHeight)
	                .attr("width", barWidth)
	                .style("fill", _this.color)
	                .on("click", _this.select);
	            nodeEnter.append("text")
	                .attr("dy", 3.5)
	                .attr("dx", 5.5)
	                .text(function (d) {
	                return d.kind;
	            });
	            // Transition nodes to their new position.
	            nodeEnter.transition()
	                .duration(_this.duration)
	                .attr("transform", function (d) { return "translate(" + d.y + "," + d.x + ")"; })
	                .style("opacity", 1);
	            node.transition()
	                .duration(_this.duration)
	                .attr("transform", function (d) { return "translate(" + d.y + "," + d.x + ")"; })
	                .style("opacity", 1)
	                .select("rect")
	                .style("fill", _this.color);
	            // Transition exiting nodes to the parent's new position.
	            node.exit().transition()
	                .duration(_this.duration)
	                .attr("transform", function (d) { return "translate(" + this.rootNode.nodeIndex + "," + this.rootNode.depth + ")"; })
	                .style("opacity", 1e-6)
	                .remove();
	            // Update the links…
	            var link = _this.graph.selectAll("path.link")
	                .data(_this.tree.links(nodes), function (d) { return d.target.id; });
	            // Enter any new links at the parent's previous position.
	            link.enter().insert("path", "g")
	                .attr("class", "link")
	                .attr("d", function (d) {
	                var o = { x: _this.rootNode.depth, y: _this.rootNode.nodeIndex };
	                return _this.diagonal({ source: o, target: o });
	            })
	                .transition()
	                .duration(_this.duration)
	                .attr("d", _this.diagonal);
	            // Transition links to their new position.
	            link.transition()
	                .duration(_this.duration)
	                .attr("d", _this.diagonal);
	            // Transition exiting nodes to the parent's new position.
	            link.exit().transition()
	                .duration(_this.duration)
	                .attr("d", function (d) {
	                var o = { x: _this.rootNode.depth, y: _this.rootNode.nodeIndex };
	                return _this.diagonal({ source: o, target: o });
	            }).remove();
	        };
	        this.color = function (d) {
	            if (_this.selected == d) {
	                return "rgb(140, 0, 0)";
	            }
	            return d.children ? "#000000" : "rgb(29, 166, 0)";
	        };
	        config._mainContent.html('');
	        this.root = {
	            dom: config._mainContent[0],
	            jq: config._mainContent
	        };
	        this.rootNode = config.rootNode;
	        this.svgRoot = d3.select(this.root.dom).append("svg");
	        this.graph = this.svgRoot.append("g")
	            .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
	        d3.select(this.root.dom).on("resize", this.update);
	        // Kick off by selecting the root node
	        this.select(this.rootNode);
	    }
	    return ASTViewRenderer;
	}());


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * This tab is really a general purpose `filePath` tab
	 * Currently supports
	 * - code
	 * - images
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Imports */
	var ui = __webpack_require__(1);
	var React = __webpack_require__(2);
	var socketClient_1 = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var state_1 = __webpack_require__(11);
	var react_redux_1 = __webpack_require__(29);
	var codeEditor_1 = __webpack_require__(60);
	var imageViewer_1 = __webpack_require__(401);
	/**
	 * This is a thin wrapper around `CodeEditor` with the following key motivations
	 * - All server code must go through here
	 * - All tab type stuff must go through here
	 */
	var Code = /** @class */ (function (_super) {
	    __extends(Code, _super);
	    function Code(props) {
	        var _this = _super.call(this, props) || this;
	        _this.saved = true;
	        _this.resize = function () {
	            _this.refs.editor.resize();
	        };
	        _this.focus = function () {
	            _this.refs.editor.focus();
	        };
	        _this.save = function () {
	            socketClient_1.server.saveFile({ filePath: _this.filePath }).then(function () {
	                _this.saved = true;
	                _this.props.onSavedChanged(true);
	            });
	        };
	        _this.close = function () {
	            socketClient_1.server.closeFile({ filePath: _this.filePath });
	        };
	        _this.gotoPosition = function (position) {
	            _this.refs.editor.gotoPosition(position);
	        };
	        _this.willBlur = function () {
	            _this.refs.editor.willBlur();
	        };
	        _this.search = {
	            doSearch: function (options) {
	                _this.refs.editor.search(options);
	            },
	            hideSearch: function () {
	                _this.refs.editor.hideSearch();
	            },
	            findNext: function (options) {
	                _this.refs.editor.findNext(options);
	            },
	            findPrevious: function (options) {
	                _this.refs.editor.findPrevious(options);
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	                _this.refs.editor.replaceNext(newText);
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	                _this.refs.editor.replacePrevious(newText);
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	                _this.refs.editor.replaceAll(newText);
	            }
	        };
	        _this.filePath = utils.getFilePathFromUrl(props.url);
	        _this.isImage = utils.isImage(_this.filePath);
	        _this.state = {};
	        return _this;
	    }
	    Code.prototype.componentDidMount = function () {
	        var _this = this;
	        socketClient_1.server.getFileStatus({ filePath: this.filePath }).then(function (res) {
	            _this.saved = res.saved;
	            _this.props.onSavedChanged(res.saved);
	        });
	        this.disposible.add(socketClient_1.cast.didStatusChange.on(function (res) {
	            if (res.filePath == _this.filePath) {
	                _this.saved = res.saved;
	                _this.props.onSavedChanged(res.saved);
	            }
	        }));
	        /**
	         * Warning if you allow it to fall through
	         * beware of `this.refs.editor` and `undefined`
	         */
	        if (this.isImage)
	            return;
	        this.props.setCodeEditor(this.refs.editor);
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        this.disposible.add(api.willBlur.on(this.willBlur));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    Code.prototype.componentWillUnmount = function () {
	        this.disposible.dispose();
	    };
	    Code.prototype.render = function () {
	        var _this = this;
	        return (React.createElement(react_redux_1.Provider, { store: state_1.store }, this.isImage
	            ? React.createElement(imageViewer_1.ImageViewer, { filePath: this.filePath, onClick: function () {
	                    _this.props.onFocused();
	                } })
	            : React.createElement(codeEditor_1.CodeEditor, { ref: 'editor', filePath: this.filePath, onFocusChange: function (focus) {
	                    /* Auto save on focus loss */
	                    !focus && !_this.saved && _this.save();
	                    /** Tell tab container of activation */
	                    focus && _this.props.onFocused();
	                } })));
	    };
	    return Code;
	}(ui.BaseComponent));
	exports.Code = Code;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var socketClient_1 = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var d3 = __webpack_require__(90);
	var $ = __webpack_require__(36);
	var styles = __webpack_require__(10);
	var clipboard_1 = __webpack_require__(50);
	var typestyle = __webpack_require__(13);
	var EOL = '\n';
	/**
	 * The styles
	 */
	__webpack_require__(359);
	var controlRootStyle = {
	    pointerEvents: 'none',
	};
	var controlRightStyle = {
	    width: '200px',
	    padding: '10px',
	    overflow: 'auto',
	    wordBreak: 'break-all',
	    pointerEvents: 'all',
	};
	var controlItemClassName = typestyle.style({
	    pointerEvents: 'auto',
	    padding: '.4rem',
	    transition: 'background .2s',
	    background: 'rgba(200,200,200,.05)',
	    $nest: {
	        '&:hover': {
	            background: 'rgba(200,200,200,.25)',
	        }
	    }
	});
	var cycleHeadingStyle = {
	    fontSize: '1.2rem',
	};
	var DependencyView = /** @class */ (function (_super) {
	    __extends(DependencyView, _super);
	    function DependencyView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleKey = function (e) {
	            var unicode = e.charCode;
	            if (String.fromCharCode(unicode).toLowerCase() === "r") {
	                _this.loadData();
	            }
	        };
	        _this.loadData = function () {
	            _this.refs.graphRoot.innerHTML = '';
	            return socketClient_1.server.getDependencies({}).then(function (res) {
	                // Create the graph renderer
	                _this.graphRenderer = new GraphRenderer({
	                    dependencies: res.links,
	                    measureSizeRoot: $(_this.refs.root),
	                    graphRoot: $(_this.refs.graphRoot),
	                    display: function (node) {
	                    }
	                });
	                // get the cycles
	                var cycles = _this.graphRenderer.d3Graph.cycles();
	                _this.setState({ cycles: cycles });
	            });
	        };
	        _this.zoomIn = function (e) {
	            e.preventDefault();
	            if (!_this.graphRenderer)
	                return;
	            _this.graphRenderer.zoomIn();
	        };
	        _this.zoomOut = function (e) {
	            e.preventDefault();
	            if (!_this.graphRenderer)
	                return;
	            _this.graphRenderer.zoomOut();
	        };
	        _this.zoomFit = function (e) {
	            e.preventDefault();
	            if (!_this.graphRenderer)
	                return;
	            _this.graphRenderer.zoomFit();
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            _this.graphRenderer && _this.graphRenderer.resize();
	        };
	        _this.focus = function () {
	            _this.refs.root.focus();
	            // if its not there its because an XHR is lagging and it will show up when that xhr completes anyways
	            _this.graphRenderer && _this.graphRenderer.resize();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	                _this.graphRenderer && _this.graphRenderer.applyFilter(options.query);
	            },
	            hideSearch: function () {
	                _this.graphRenderer && _this.graphRenderer.clearFilter();
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        _this.filePath = utils.getFilePathFromUrl(props.url);
	        _this.state = {
	            cycles: []
	        };
	        return _this;
	    }
	    DependencyView.prototype.componentDidMount = function () {
	        var _this = this;
	        this.loadData();
	        this.disposible.add(socketClient_1.cast.activeProjectConfigDetailsUpdated.on(function () {
	            _this.loadData();
	        }));
	        var focused = function () {
	            _this.props.onFocused();
	        };
	        this.refs.root.addEventListener('focus', focused);
	        this.disposible.add({
	            dispose: function () {
	                _this.refs.root.removeEventListener('focus', focused);
	            }
	        });
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    DependencyView.prototype.render = function () {
	        var hasCycles = !!this.state.cycles.length;
	        var cyclesMessages = hasCycles
	            ? this.state.cycles.map(function (cycle, i) {
	                var cycleText = cycle.join(' ⬅️ ');
	                return (React.createElement("div", { key: i, className: controlItemClassName },
	                    React.createElement("div", { style: cycleHeadingStyle },
	                        " ",
	                        i + 1,
	                        ") Cycle ",
	                        React.createElement(clipboard_1.Clipboard, { text: cycleText })),
	                    React.createElement("div", null, cycleText)));
	            })
	            : React.createElement("div", { key: -1, className: controlItemClassName }, "No cycles \uD83C\uDF39");
	        return (React.createElement("div", { ref: "root", tabIndex: 0, className: "dependency-view", style: csx.extend(csx.vertical, csx.flex, csx.newLayerParent, styles.someChildWillScroll), onKeyPress: this.handleKey },
	            React.createElement("div", { ref: "graphRoot", style: csx.extend(csx.vertical, csx.flex) }),
	            React.createElement("div", { ref: "controlRoot", className: "graph-controls", style: csx.extend(csx.newLayer, csx.horizontal, csx.endJustified, controlRootStyle) },
	                React.createElement("div", { style: csx.extend(csx.vertical, controlRightStyle) },
	                    React.createElement("div", { className: "control-zoom " + controlItemClassName },
	                        React.createElement("a", { className: "control-zoom-in", href: "#", title: "Zoom in", onClick: this.zoomIn }),
	                        React.createElement("a", { className: "control-zoom-out", href: "#", title: "Zoom out", onClick: this.zoomOut }),
	                        React.createElement("a", { className: "control-fit", href: "#", title: "Fit", onClick: this.zoomFit })),
	                    cyclesMessages)),
	            React.createElement("div", { "data-comment": "Tip", style: csx.extend(styles.Tip.root, csx.content) },
	                "Tap ",
	                React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "R"),
	                " to refresh")));
	    };
	    return DependencyView;
	}(ui.BaseComponent));
	exports.DependencyView = DependencyView;
	var prefixes = {
	    circle: 'circle'
	};
	var GraphRenderer = /** @class */ (function () {
	    function GraphRenderer(config) {
	        var _this = this;
	        this.config = config;
	        this.graphWidth = 0;
	        this.graphHeight = 0;
	        // Use elliptical arc path segments to doubly-encode directionality.
	        this.tick = function () {
	            function transform(d) {
	                return "translate(" + d.x + "," + d.y + ")";
	            }
	            _this.links.attr("d", linkArc);
	            _this.nodes.attr("transform", transform);
	            _this.text.attr("transform", transform);
	        };
	        this.applyFilter = utils.debounce(function (val) {
	            if (!val) {
	                _this.clearFilter();
	                return;
	            }
	            else {
	                _this.nodes.classed('filtered-out', true);
	                _this.links.classed('filtered-out', true);
	                _this.text.classed('filtered-out', true);
	                var filteredNodes = _this.graph.selectAll("circle[data-name*=\"" + _this.htmlName({ name: val }) + "\"]");
	                filteredNodes.classed('filtered-out', false);
	                var filteredLinks = _this.graph.selectAll("[data-source*=\"" + _this.htmlName({ name: val }) + "\"][data-target*=\"" + _this.htmlName({ name: val }) + "\"]");
	                filteredLinks.classed('filtered-out', false);
	                var filteredText = _this.graph.selectAll("text[data-name*=\"" + _this.htmlName({ name: val }) + "\"]");
	                filteredText.classed('filtered-out', false);
	            }
	        }, 250);
	        this.clearFilter = function () {
	            _this.nodes.classed('filtered-out', false);
	            _this.links.classed('filtered-out', false);
	            _this.text.classed('filtered-out', false);
	        };
	        /**
	         * Layout
	         */
	        this.resize = function () {
	            _this.graphWidth = _this.config.measureSizeRoot.width();
	            _this.graphHeight = _this.config.measureSizeRoot.height();
	            _this.svgRoot.attr("width", _this.graphWidth)
	                .attr("height", _this.graphHeight);
	            _this.layout.size([_this.graphWidth, _this.graphHeight])
	                .resume();
	        };
	        this.centerGraph = function () {
	            var centerTranslate = [
	                (_this.graphWidth / 4),
	                (_this.graphHeight / 4),
	            ];
	            _this.zoom.translate(centerTranslate);
	            // Render transition
	            _this.transitionScale();
	        };
	        this.zoomIn = function () {
	            _this.zoomCenter(1);
	        };
	        this.zoomOut = function () {
	            _this.zoomCenter(-1);
	        };
	        this.zoomFit = function () {
	            _this.zoom.scale(0.4);
	            _this.centerGraph();
	        };
	        var d3Root = d3.select(config.graphRoot[0]);
	        var self = this;
	        // Compute the distinct nodes from the links.
	        var d3NodeLookup = {};
	        var d3links = config.dependencies.map(function (link) {
	            var source = d3NodeLookup[link.sourcePath] || (d3NodeLookup[link.sourcePath] = { name: link.sourcePath });
	            var target = d3NodeLookup[link.targetPath] || (d3NodeLookup[link.targetPath] = { name: link.targetPath });
	            return { source: source, target: target };
	        });
	        // Calculate all the good stuff
	        this.d3Graph = new D3Graph(d3links);
	        // setup weights based on degrees
	        Object.keys(d3NodeLookup).forEach(function (name) {
	            var node = d3NodeLookup[name];
	            node.weight = self.d3Graph.avgDeg(node);
	        });
	        // Setup zoom
	        this.zoom = d3.behavior.zoom()
	            .scale(0.4)
	            .scaleExtent([.1, 6])
	            .on("zoom", onZoomChanged);
	        this.svgRoot = d3Root.append("svg")
	            .call(this.zoom);
	        this.graph = this.svgRoot
	            .append('svg:g');
	        this.layout = d3.layout.force()
	            .nodes(d3.values(d3NodeLookup))
	            .links(d3links)
	            .gravity(.05)
	            .linkDistance(function (link) { return (self.d3Graph.difference(link)) * 200; })
	            .charge(-900)
	            .on("tick", this.tick)
	            .start();
	        var drag = this.layout.drag()
	            .on("dragstart", dragstart);
	        /** resize initially and setup for resize */
	        this.resize();
	        this.centerGraph();
	        function onZoomChanged() {
	            self.graph.attr("transform", "translate(" + d3.event.translate + ")" + " scale(" + d3.event.scale + ")");
	        }
	        // Per-type markers, as they don't inherit styles.
	        self.graph.append("defs").selectAll("marker")
	            .data(["regular"])
	            .enter().append("marker")
	            .attr("id", function (d) { return d; })
	            .attr("viewBox", "0 -5 10 10")
	            .attr("refX", 15)
	            .attr("refY", -1.5)
	            .attr("markerWidth", 6)
	            .attr("markerHeight", 6)
	            .attr("orient", "auto")
	            .append("path")
	            .attr("d", "M0,-5L10,0L0,5");
	        this.links = self.graph.append("g").selectAll("path")
	            .data(this.layout.links())
	            .enter().append("path")
	            .attr("class", function (d) { return "link"; })
	            .attr("data-target", function (o) { return self.htmlName(o.target); })
	            .attr("data-source", function (o) { return self.htmlName(o.source); })
	            .attr("marker-end", function (d) { return "url(#regular)"; });
	        this.nodes = self.graph.append("g").selectAll("circle")
	            .data(this.layout.nodes())
	            .enter().append("circle")
	            .attr("class", function (d) { return formatClassName(prefixes.circle, d); }) // Store class name for easier later lookup
	            .attr("data-name", function (o) { return self.htmlName(o); }) // Store for easier later lookup
	            .attr("r", function (d) { return Math.max(d.weight, 3); })
	            .classed("inonly", function (d) { return self.d3Graph.inOnly(d); })
	            .classed("outonly", function (d) { return self.d3Graph.outOnly(d); })
	            .classed("circular", function (d) { return self.d3Graph.isCircular(d); })
	            .call(drag)
	            .on("dblclick", dblclick) // Unstick
	            .on("mouseover", function (d) { onNodeMouseOver(d); })
	            .on("mouseout", function (d) { onNodeMouseOut(d); });
	        this.text = self.graph.append("g").selectAll("text")
	            .data(this.layout.nodes())
	            .enter().append("text")
	            .attr("x", 8)
	            .attr("y", ".31em")
	            .attr("data-name", function (o) { return self.htmlName(o); })
	            .text(function (d) { return d.name; });
	        function onNodeMouseOver(d) {
	            // Highlight circle
	            var elm = findElementByNode(prefixes.circle, d);
	            elm.classed("hovering", true);
	            updateNodeTransparencies(d, true);
	        }
	        function onNodeMouseOut(d) {
	            // Highlight circle
	            var elm = findElementByNode(prefixes.circle, d);
	            elm.classed("hovering", false);
	            updateNodeTransparencies(d, false);
	        }
	        var findElementByNode = function (prefix, node) {
	            var selector = '.' + formatClassName(prefix, node);
	            return self.graph.select(selector);
	        };
	        function updateNodeTransparencies(d, fade) {
	            if (fade === void 0) { fade = true; }
	            // clean
	            self.nodes.classed('not-hovering', false);
	            self.nodes.classed('dimmed', false);
	            if (fade) {
	                self.nodes.each(function (o) {
	                    if (!self.d3Graph.isConnected(d, o)) {
	                        this.classList.add('not-hovering');
	                        this.classList.add('dimmed');
	                    }
	                });
	            }
	            // Clean
	            self.graph.selectAll('path.link').attr('data-show', '')
	                .classed('outgoing', false)
	                .attr('marker-end', fade ? '' : 'url(#regular)')
	                .classed('incomming', false)
	                .classed('dimmed', fade);
	            self.links.each(function (o) {
	                if (o.source.name === d.name) {
	                    this.classList.remove('dimmed');
	                    // Highlight target of the link
	                    var elmNodes = self.graph.selectAll('.' + formatClassName(prefixes.circle, o.target));
	                    elmNodes.attr('fill-opacity', 1);
	                    elmNodes.attr('stroke-opacity', 1);
	                    elmNodes.classed('dimmed', false);
	                    // Highlight arrows
	                    var outgoingLink = self.graph.selectAll('path.link[data-source="' + self.htmlName(o.source) + '"]');
	                    outgoingLink.attr('data-show', 'true');
	                    outgoingLink.attr('marker-end', 'url(#regular)');
	                    outgoingLink.classed('outgoing', true);
	                }
	                else if (o.target.name === d.name) {
	                    this.classList.remove('dimmed');
	                    // Highlight arrows
	                    var incommingLink = self.graph.selectAll('path.link[data-target="' + self.htmlName(o.target) + '"]');
	                    incommingLink.attr('data-show', 'true');
	                    incommingLink.attr('marker-end', 'url(#regular)');
	                    incommingLink.classed('incomming', true);
	                }
	            });
	            self.text.classed("dimmed", function (o) {
	                if (!fade)
	                    return false;
	                if (self.d3Graph.isConnected(d, o))
	                    return false;
	                return true;
	            });
	        }
	        // Helpers
	        function formatClassName(prefix, object) {
	            return prefix + '-' + self.htmlName(object);
	        }
	        function dragstart(d) {
	            d.fixed = true; // http://bl.ocks.org/mbostock/3750558
	            d3.event.sourceEvent.stopPropagation(); // http://bl.ocks.org/mbostock/6123708
	            d3.select(this).classed("fixed", true);
	        }
	        function dblclick(d) {
	            d3.select(this).classed("fixed", d.fixed = false);
	        }
	    }
	    /** Modifed from http://bl.ocks.org/linssen/7352810 */
	    GraphRenderer.prototype.zoomCenter = function (direction) {
	        var factor = 0.3, target_zoom = 1, center = [this.graphWidth / 2, this.graphHeight / 2], extent = this.zoom.scaleExtent(), translate = this.zoom.translate(), translate0 = [], l = [], view = { x: translate[0], y: translate[1], k: this.zoom.scale() };
	        target_zoom = this.zoom.scale() * (1 + factor * direction);
	        if (target_zoom < extent[0] || target_zoom > extent[1]) {
	            return false;
	        }
	        translate0 = [(center[0] - view.x) / view.k, (center[1] - view.y) / view.k];
	        view.k = target_zoom;
	        l = [translate0[0] * view.k + view.x, translate0[1] * view.k + view.y];
	        view.x += center[0] - l[0];
	        view.y += center[1] - l[1];
	        this.zoom.scale(view.k);
	        this.zoom.translate([view.x, view.y]);
	        this.transitionScale();
	    };
	    /**
	     * Helpers
	     */
	    GraphRenderer.prototype.htmlName = function (object) {
	        return object.name.replace(/(\.|\/)/gi, '-');
	    };
	    GraphRenderer.prototype.transitionScale = function () {
	        this.graph.transition()
	            .duration(500)
	            .attr("transform", "translate(" + this.zoom.translate() + ")" + " scale(" + this.zoom.scale() + ")");
	    };
	    return GraphRenderer;
	}());
	/**
	 * A class to do analysis on D3 links array
	 * Degree : The number of connections
	 * Bit of a lie about degrees : 0 is changed to 1 intentionally
	 */
	var D3Graph = /** @class */ (function () {
	    function D3Graph(links) {
	        var _this = this;
	        this.links = links;
	        this.inDegLookup = {};
	        this.outDegLookup = {};
	        this.linkedByName = {};
	        this.targetsBySourceName = {};
	        this.circularPaths = [];
	        links.forEach(function (l) {
	            if (!_this.inDegLookup[l.target.name])
	                _this.inDegLookup[l.target.name] = 2;
	            else
	                _this.inDegLookup[l.target.name]++;
	            if (!_this.outDegLookup[l.source.name])
	                _this.outDegLookup[l.source.name] = 2;
	            else
	                _this.outDegLookup[l.source.name]++;
	            // Build linked lookup for quick connection checks
	            _this.linkedByName[l.source.name + "," + l.target.name] = 1;
	            // Build an adjacency list
	            if (!_this.targetsBySourceName[l.source.name])
	                _this.targetsBySourceName[l.source.name] = [];
	            _this.targetsBySourceName[l.source.name].push(l.target);
	        });
	        // Taken from madge
	        this.findCircular();
	    }
	    D3Graph.prototype.inDeg = function (node) {
	        return this.inDegLookup[node.name] ? this.inDegLookup[node.name] : 1;
	    };
	    D3Graph.prototype.outDeg = function (node) {
	        return this.outDegLookup[node.name] ? this.outDegLookup[node.name] : 1;
	    };
	    D3Graph.prototype.avgDeg = function (node) {
	        return (this.inDeg(node) + this.outDeg(node)) / 2;
	    };
	    D3Graph.prototype.isConnected = function (a, b) {
	        return this.linkedByName[a.name + "," + b.name] || this.linkedByName[b.name + "," + a.name] || a.name == b.name;
	    };
	    /** how different are the two nodes in the link */
	    D3Graph.prototype.difference = function (link) {
	        // take file path into account:
	        return utils.relative(link.source.name, link.target.name).split('/').length;
	    };
	    D3Graph.prototype.inOnly = function (node) {
	        return !this.outDegLookup[node.name] && this.inDegLookup[node.name];
	    };
	    D3Graph.prototype.outOnly = function (node) {
	        return !this.inDegLookup[node.name] && this.outDegLookup[node.name];
	    };
	    /**
	    * Get path to the circular dependency.
	    */
	    D3Graph.prototype.getPath = function (parent, unresolved) {
	        var parentVisited = false;
	        return Object.keys(unresolved).filter(function (module) {
	            if (module === parent.name) {
	                parentVisited = true;
	            }
	            return parentVisited && unresolved[module];
	        });
	    };
	    /**
	     * A circular dependency is occurring when we see a software package
	     * more than once, unless that software package has all its dependencies resolved.
	     */
	    D3Graph.prototype.resolver = function (sourceName, resolved, unresolved) {
	        var _this = this;
	        unresolved[sourceName] = true;
	        if (this.targetsBySourceName[sourceName]) {
	            this.targetsBySourceName[sourceName].forEach(function (dependency) {
	                if (!resolved[dependency.name]) {
	                    if (unresolved[dependency.name]) {
	                        _this.circularPaths.push(_this.getPath(dependency, unresolved));
	                        return;
	                    }
	                    _this.resolver(dependency.name, resolved, unresolved);
	                }
	            });
	        }
	        resolved[sourceName] = true;
	        unresolved[sourceName] = false;
	    };
	    /**
	     * Finds all circular dependencies for the given modules.
	     */
	    D3Graph.prototype.findCircular = function () {
	        var _this = this;
	        var resolved = {}, unresolved = {};
	        Object.keys(this.targetsBySourceName).forEach(function (sourceName) {
	            _this.resolver(sourceName, resolved, unresolved);
	        });
	    };
	    ;
	    /** Check if the given module is part of a circular dependency */
	    D3Graph.prototype.isCircular = function (node) {
	        var cyclic = false;
	        this.circularPaths.some(function (path) {
	            if (path.indexOf(node.name) >= 0) {
	                cyclic = true;
	                return true;
	            }
	            return false;
	        });
	        return cyclic;
	    };
	    D3Graph.prototype.cycles = function () {
	        return this.circularPaths;
	    };
	    return D3Graph;
	}());
	/** modified version of http://stackoverflow.com/a/26616564/390330 Takes weight into account */
	function linkArc(d) {
	    var targetX = d.target.x;
	    var targetY = d.target.y;
	    var sourceX = d.source.x;
	    var sourceY = d.source.y;
	    var theta = Math.atan((targetX - sourceX) / (targetY - sourceY));
	    var phi = Math.atan((targetY - sourceY) / (targetX - sourceX));
	    var sinTheta = d.source.weight / 2 * Math.sin(theta);
	    var cosTheta = d.source.weight / 2 * Math.cos(theta);
	    var sinPhi = (d.target.weight - 6) * Math.sin(phi);
	    var cosPhi = (d.target.weight - 6) * Math.cos(phi);
	    // Set the position of the link's end point at the source node
	    // such that it is on the edge closest to the target node
	    if (d.target.y > d.source.y) {
	        sourceX = sourceX + sinTheta;
	        sourceY = sourceY + cosTheta;
	    }
	    else {
	        sourceX = sourceX - sinTheta;
	        sourceY = sourceY - cosTheta;
	    }
	    // Set the position of the link's end point at the target node
	    // such that it is on the edge closest to the source node
	    if (d.source.x > d.target.x) {
	        targetX = targetX + cosPhi;
	        targetY = targetY + sinPhi;
	    }
	    else {
	        targetX = targetX - cosPhi;
	        targetY = targetY - sinPhi;
	    }
	    // Draw an arc between the two calculated points
	    var dx = targetX - sourceX, dy = targetY - sourceY, dr = Math.sqrt(dx * dx + dy * dy);
	    return "M" + sourceX + "," + sourceY + "A" + dr + "," + dr + " 0 0,1 " + targetX + "," + targetY;
	}


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var typeIcon = __webpack_require__(154);
	var gls = __webpack_require__(49);
	var typestyle = __webpack_require__(13);
	var markdown_1 = __webpack_require__(405);
	var styles_1 = __webpack_require__(10);
	var DocumentationViewStyles;
	(function (DocumentationViewStyles) {
	    DocumentationViewStyles.header = typestyle.style({
	        cursor: 'pointer',
	        $nest: {
	            '&:hover': {
	                textDecoration: 'underline'
	            }
	        }
	    });
	    DocumentationViewStyles.folderName = typestyle.style({
	        padding: "2px",
	        fontSize: '.5em',
	        '-webkit-user-select': 'none',
	        maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis'
	    });
	})(DocumentationViewStyles = exports.DocumentationViewStyles || (exports.DocumentationViewStyles = {}));
	var DocumentationView = /** @class */ (function (_super) {
	    __extends(DocumentationView, _super);
	    function DocumentationView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleNodeClick = function (node) {
	            commands.doOpenOrFocusFile.emit({
	                filePath: node.location.filePath,
	                position: node.location.position
	            });
	        };
	        _this.handleRootSelected = function (node) {
	            _this.setState({ selected: node });
	            setTimeout(function () { return _this.filter(); });
	        };
	        _this.handleKey = function (e) {
	            var unicode = e.charCode;
	            if (String.fromCharCode(unicode).toLowerCase() === "r") {
	                _this.loadData();
	            }
	        };
	        _this.loadData = function () {
	            socketClient_1.server.getTopLevelModuleNames({}).then(function (res) {
	                _this.setState({ files: res.files, selected: null });
	                _this.filter();
	            });
	        };
	        _this.filter = function () {
	            var filter = (_this.state.filter || '').toLowerCase();
	            if (!filter) {
	                var filtered_1 = _this.state.files;
	                var selected_1 = _this.state.selected && filtered_1.find(function (f) { return f.name == _this.state.selected.name; });
	                _this.setState({ filtered: filtered_1, selected: selected_1, selectedDoesNotMatchFilter: false });
	                return;
	            }
	            /**
	             * Does the name match or does some subItem name match
	             */
	            var doesNameMatchRecursive = function (type) {
	                return type.name.toLowerCase().indexOf(filter) !== -1 || type.subItems.some(function (t) { return doesNameMatchRecursive(t); });
	            };
	            /**
	             * Only leaves in the subItems that match
	             */
	            var mapChildrenRecursive = function (item) {
	                var subItems = item.subItems
	                    .filter(doesNameMatchRecursive)
	                    .map(mapChildrenRecursive);
	                var result = {
	                    name: item.name,
	                    icon: item.icon,
	                    comment: item.comment,
	                    location: item.location,
	                    subItems: subItems,
	                };
	                return result;
	            };
	            var filtered = _this.state.files
	                .filter(function (f) {
	                return doesNameMatchRecursive(f);
	            })
	                .map(mapChildrenRecursive);
	            _this.setState({ filtered: filtered });
	            // Also filter inside the selected if possible
	            var selected = _this.state.selected && filtered.find(function (f) { return f.name == _this.state.selected.name; });
	            if (_this.state.selected && !selected) {
	                _this.setState({ selectedDoesNotMatchFilter: true });
	            }
	            else {
	                _this.setState({ selected: selected, selectedDoesNotMatchFilter: false });
	            }
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            // Not needed
	        };
	        _this.focus = function () {
	            _this.refs.root.focus();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	                _this.setState({ filter: options.query });
	                _this.filter();
	            },
	            hideSearch: function () {
	                _this.setState({ filter: '' });
	                _this.filter();
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        _this.filePath = utils.getFilePathFromUrl(props.url);
	        _this.state = {
	            filtered: [],
	            files: [],
	            selected: null,
	        };
	        return _this;
	    }
	    DocumentationView.prototype.componentDidMount = function () {
	        var _this = this;
	        /**
	         * Initial load + load on project change
	         */
	        this.loadData();
	        this.disposible.add(socketClient_1.cast.activeProjectFilePathsUpdated.on(function () {
	            _this.loadData();
	        }));
	        /**
	         * If a file is selected and it gets edited, reload the file module information
	         */
	        var isFilePathOfSignificance = function (filePath) { return !!_this.state.selected && _this.state.selected.location.filePath === filePath; };
	        var reloadSelectedDebounced = utils.debounce(function (filePath) {
	            if (!isFilePathOfSignificance(filePath))
	                return;
	            socketClient_1.server.getUpdatedModuleInformation({
	                filePath: filePath
	            }).then(function (res) {
	                if (!isFilePathOfSignificance(filePath))
	                    return;
	                var files = _this.state.files.map(function (f) { return (f.location.filePath === filePath) ? res : f; });
	                _this.setState({ files: files, selected: res });
	                _this.filter();
	            });
	        }, 3000);
	        this.disposible.add(commands.fileContentsChanged.on(function (res) {
	            if (!isFilePathOfSignificance(res.filePath))
	                return;
	            reloadSelectedDebounced(res.filePath);
	        }));
	        /**
	         * Handle focus to inform tab container
	         */
	        var focused = function () {
	            _this.props.onFocused();
	        };
	        this.refs.root.addEventListener('focus', focused);
	        this.disposible.add({
	            dispose: function () {
	                _this.refs.root.removeEventListener('focus', focused);
	            }
	        });
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    DocumentationView.prototype.render = function () {
	        return (React.createElement("div", { ref: "root", tabIndex: 0, style: csx.extend(csx.vertical, csx.flex, csx.newLayerParent, styles.someChildWillScroll, { color: styles.textColor }), onKeyPress: this.handleKey },
	            React.createElement("div", { style: { overflow: 'hidden', padding: '10px 0px 10px 10px', display: 'flex' } },
	                React.createElement(gls.FlexHorizontal, { style: {} },
	                    React.createElement(gls.Content, { style: { width: '200px', overflow: 'auto' } },
	                        React.createElement(typeIcon.SectionHeader, { text: "Files" }),
	                        React.createElement(gls.SmallVerticalSpace, null),
	                        this.renderFiles()),
	                    React.createElement(gls.FlexVertical, { style: { marginLeft: '5px', overflow: 'auto' } },
	                        this.state.selected && this.state.selectedDoesNotMatchFilter &&
	                            React.createElement(gls.Content, { style: { backgroundColor: '#111', padding: '5px' } }, "Note: Nothing in the selected module matches the filter, so showing it all"),
	                        this.state.selected
	                            ? this.renderSelectedNode()
	                            : 'Select a module from the left to view its documentation 🌹',
	                        React.createElement("div", { style: { marginTop: '10px', marginRight: '10px' } },
	                            React.createElement("hr", null),
	                            React.createElement(typeIcon.TypeIconLegend, null)))))));
	    };
	    DocumentationView.prototype.renderFiles = function () {
	        var _this = this;
	        /** For two items in different file paths we render the folder name in between */
	        var toRender = [];
	        var lastKnownFolder = '';
	        this.state.filtered.forEach(function (type) {
	            var folder = utils.getDirectory(type.name);
	            if (folder !== lastKnownFolder) {
	                toRender.push({
	                    folder: folder
	                });
	                lastKnownFolder = folder;
	            }
	            toRender.push({
	                type: type
	            });
	        });
	        return toRender.map(function (item, i) {
	            if (item.type) {
	                var file_1 = item.type;
	                var name_1 = utils.getFileName(file_1.name);
	                var backgroundColor = _this.state.selected && _this.state.selected.name === file_1.name
	                    ? styles_1.blackHighlightColor
	                    : 'transparent';
	                return (React.createElement("div", { title: file_1.name, key: i, style: { cursor: 'pointer', backgroundColor: backgroundColor, paddingTop: '2px', paddingBottom: '2px', paddingLeft: '2px' }, onClick: function () { return _this.handleRootSelected(file_1); } },
	                    React.createElement(typeIcon.DocumentedTypeHeader, { name: name_1, icon: file_1.icon })));
	            }
	            else {
	                var folder = item.folder;
	                return (React.createElement("div", { title: folder, key: i, className: DocumentationViewStyles.folderName }, folder));
	            }
	        });
	    };
	    DocumentationView.prototype.renderSelectedNode = function () {
	        var node = this.state.selected;
	        return this.renderNode(node);
	    };
	    DocumentationView.prototype.renderNode = function (node, i) {
	        var _this = this;
	        if (i === void 0) { i = 0; }
	        return (React.createElement("div", { key: i, style: { paddingTop: '5px' } },
	            React.createElement(gls.InlineBlock, { className: DocumentationViewStyles.header, onClick: function () { return _this.handleNodeClick(node); } },
	                React.createElement(typeIcon.DocumentedTypeHeader, { name: node.name, icon: node.icon })),
	            node.comment &&
	                React.createElement("div", { style: { padding: '5px', backgroundColor: styles_1.blackHighlightColor } },
	                    React.createElement(markdown_1.MarkDown, { markdown: node.comment })),
	            node.subItems && !!node.subItems.length &&
	                React.createElement("div", { style: { border: '1px solid grey', marginTop: '5px', padding: '5px' } }, node.subItems.map(function (n, i) { return _this.renderNode(n, i); }))));
	    };
	    return DocumentationView;
	}(ui.BaseComponent));
	exports.DocumentationView = DocumentationView;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var icon_1 = __webpack_require__(31);
	var Mousetrap = __webpack_require__(63);
	var buttons = __webpack_require__(82);
	var types = __webpack_require__(23);
	var gls = __webpack_require__(49);
	var typestyle = __webpack_require__(13);
	var EOL = '\n';
	/**
	 * The styles
	 */
	var findAndReplace_1 = __webpack_require__(155);
	var inputBlackStyleBase = styles.Input.inputBlackStyleBase;
	var inputBlackClassName = typestyle.style(inputBlackStyleBase);
	var ResultsStyles;
	(function (ResultsStyles) {
	    ResultsStyles.rootClassName = typestyle.style(csx.flex, csx.scroll, styles.padded1, {
	        border: '1px solid grey',
	        $nest: {
	            '&:focus': {
	                outline: 'none',
	                border: '1px solid ' + styles.highlightColor,
	            }
	        }
	    });
	    ResultsStyles.header = csx.extend(styles.padded1, {
	        cursor: 'default',
	        fontSize: '1.5em',
	        fontWeight: 'bold',
	        color: styles.textColor,
	        background: 'black',
	        border: '2px solid grey',
	    });
	    ResultsStyles.preview = {
	        padding: '3px',
	        background: 'black',
	        cursor: 'pointer',
	        userSelect: 'text',
	    };
	    ResultsStyles.selected = {
	        backgroundColor: styles.selectedBackgroundColor
	    };
	    ResultsStyles.noFocusClassName = typestyle.style({
	        $nest: {
	            '&:focus': {
	                outline: 'none'
	            }
	        }
	    });
	})(ResultsStyles || (ResultsStyles = {}));
	var FindAndReplaceView = /** @class */ (function (_super) {
	    __extends(FindAndReplaceView, _super);
	    function FindAndReplaceView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.findInput = function () { return ReactDOM.findDOMNode(_this.refs.find); };
	        _this.replaceInput = function () { return ReactDOM.findDOMNode(_this.refs.replace); };
	        _this.regexInput = function () { return ReactDOM.findDOMNode(_this.refs.regex.refs.input); };
	        _this.caseInsensitiveInput = function () { return ReactDOM.findDOMNode(_this.refs.caseInsensitive.refs.input); };
	        _this.fullWordInput = function () { return ReactDOM.findDOMNode(_this.refs.fullWord.refs.input); };
	        _this.replaceWith = function () { return _this.replaceInput().value; };
	        _this.toggleFilePathExpansion = function (filePath) {
	            _this.state.collapsedState[filePath] = !_this.state.collapsedState[filePath];
	            _this.setState({ collapsedState: _this.state.collapsedState, selected: { filePath: filePath, line: -1 } });
	        };
	        /**
	         * Input Change handlers
	         */
	        _this.fullWordKeyDownHandler = function (e) {
	            var _a = ui.getKeyStates(e), tab = _a.tab, shift = _a.shift, enter = _a.enter;
	            if (tab && !shift) {
	                _this.findInput().focus();
	                e.preventDefault();
	                return;
	            }
	        };
	        _this.findKeyDownHandler = function (e) {
	            var _a = ui.getKeyStates(e), tab = _a.tab, shift = _a.shift, enter = _a.enter, mod = _a.mod;
	            if (shift && tab) {
	                _this.fullWordInput() && _this.fullWordInput().focus();
	                e.preventDefault();
	                return;
	            }
	            /**
	             * Handling commit
	             */
	            if (!_this.state.findQuery) {
	                return;
	            }
	            if (enter) {
	                _this.startSearch();
	            }
	        };
	        _this.findChanged = function () {
	            var val = _this.findInput().value.trim();
	            _this.setState({ findQuery: val });
	        };
	        _this.handleRegexChange = function (e) {
	            var val = e.target.checked;
	            _this.setState({ isRegex: val });
	            _this.startSearch();
	        };
	        _this.handleCaseSensitiveChange = function (e) {
	            var val = e.target.checked;
	            _this.setState({ isCaseSensitive: val });
	            _this.startSearch();
	        };
	        _this.handleFullWordChange = function (e) {
	            var val = e.target.checked;
	            _this.setState({ isFullWord: val });
	            _this.startSearch();
	        };
	        /**
	         * Sends the search query
	         * debounced as state needs to be set before this execs
	         */
	        _this.startSearch = utils.debounce(function () {
	            var config = {
	                query: _this.state.findQuery,
	                isRegex: _this.state.isRegex,
	                isFullWord: _this.state.isFullWord,
	                isCaseSensitive: _this.state.isCaseSensitive,
	                globs: []
	            };
	            socketClient_1.server.startFarming(config);
	            _this.setState({
	                // Clear previous search
	                collapsedState: {},
	                selected: {},
	                // Set new results preemptively
	                results: [],
	                config: config,
	                queryRegex: utils.findOptionsToQueryRegex({
	                    query: config.query,
	                    isRegex: config.isRegex,
	                    isFullWord: config.isFullWord,
	                    isCaseSensitive: config.isCaseSensitive,
	                }),
	                completed: false,
	                farmResultByFilePath: {},
	            });
	        }, 100);
	        _this.cancelAnyRunningSearch = function () {
	            socketClient_1.server.stopFarmingIfRunning({});
	        };
	        _this.openSearchResult = function (filePath, line) {
	            commands.doOpenOrFocusFile.emit({ filePath: filePath, position: { line: line - 1, ch: 0 } });
	            _this.setSelected(filePath, line);
	        };
	        _this.setSelected = function (filePath, line) {
	            _this.setState({ selected: { filePath: filePath, line: line } });
	            _this.focusFilePath(filePath, line);
	        };
	        _this.focusFilePath = function (filePath, line) {
	            _this.resultRef(filePath).focus(filePath, line);
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            // This layout doesn't need it
	        };
	        /** Allows us to focus on input on certain keystrokes instead of search results */
	        _this.focusOnInput = function () { return setTimeout(function () { return _this.findInput().focus(); }, 500); };
	        _this.focus = function () {
	            _this.refs.results.focus();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	                // not needed
	            },
	            hideSearch: function () {
	                // not needed
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        var _a = utils.getFilePathAndProtocolFromUrl(props.url), protocol = _a.protocol, filePath = _a.filePath;
	        _this.filePath = filePath;
	        _this.state = {
	            completed: true,
	            farmResultByFilePath: {},
	            collapsedState: {},
	            selected: {},
	        };
	        return _this;
	    }
	    FindAndReplaceView.prototype.componentDidMount = function () {
	        var _this = this;
	        /**
	         * Keyboard: Focus
	         */
	        this.focusOnInput(); // On initial mount as well :)
	        this.disposible.add(commands.findAndReplace.on(this.focusOnInput));
	        this.disposible.add(commands.findAndReplaceMulti.on(this.focusOnInput));
	        /**
	         * Keyboard: Stop
	         */
	        this.disposible.add(commands.esc.on(function () {
	            // Disabled as esc is used to focus search results as well
	            // this.cancelAnyRunningSearch();
	        }));
	        /**
	         * Initial load && keeping it updated
	         */
	        socketClient_1.server.farmResults({}).then(function (res) {
	            _this.parseResults(res);
	        });
	        this.disposible.add(socketClient_1.cast.farmResultsUpdated.on(function (res) {
	            _this.parseResults(res);
	        }));
	        /**
	         * Handle the keyboard in the search results
	         */
	        var treeRoot = this.refs.results;
	        var handlers = new Mousetrap(treeRoot);
	        var selectFirst = function () {
	            if (_this.state.results && _this.state.results.length) {
	                _this.setSelected(_this.state.results[0].filePath, -1);
	            }
	        };
	        handlers.bind('up', function () {
	            // initial state
	            if (!_this.state.results || !_this.state.results.length)
	                return false;
	            if (!_this.state.selected.filePath) {
	                selectFirst();
	                return false;
	            }
	            /** If we have an actual line go to previous or filePath */
	            if (_this.state.selected.line !== -1) {
	                var relevantResults = _this.state.farmResultByFilePath[_this.state.selected.filePath];
	                var indexInResults = relevantResults
	                    .map(function (x) { return x.line; })
	                    .indexOf(_this.state.selected.line);
	                if (indexInResults === 0) {
	                    _this.setSelected(_this.state.selected.filePath, -1);
	                }
	                else {
	                    _this.setSelected(_this.state.selected.filePath, relevantResults[indexInResults - 1].line);
	                }
	            }
	            else {
	                var filePaths = Object.keys(_this.state.farmResultByFilePath);
	                var filePathIndex = filePaths.indexOf(_this.state.selected.filePath);
	                if (filePathIndex === 0)
	                    return false;
	                var previousFilePath = filePaths[filePathIndex - 1];
	                if (_this.state.collapsedState[previousFilePath]) {
	                    _this.setSelected(previousFilePath, -1);
	                }
	                else {
	                    var results = _this.state.farmResultByFilePath[previousFilePath];
	                    _this.setSelected(previousFilePath, results[results.length - 1].line);
	                }
	            }
	            return false;
	        });
	        handlers.bind('down', function () {
	            if (!_this.state.results || !_this.state.results.length)
	                return false;
	            if (!_this.state.selected.filePath) {
	                selectFirst();
	                return false;
	            }
	            /** If we are on a filePath
	                (collaped) go to next filePath if any
	                (expanded) go to first child */
	            if (_this.state.selected.line === -1) {
	                if (_this.state.collapsedState[_this.state.selected.filePath]) {
	                    var filePaths = Object.keys(_this.state.farmResultByFilePath);
	                    var filePathIndex = filePaths.indexOf(_this.state.selected.filePath);
	                    if (filePathIndex === filePaths.length - 1)
	                        return false;
	                    var nextFilePath = filePaths[filePathIndex + 1];
	                    _this.setSelected(nextFilePath, -1);
	                }
	                else {
	                    var results = _this.state.farmResultByFilePath[_this.state.selected.filePath];
	                    _this.setSelected(results[0].filePath, results[0].line);
	                }
	            }
	            else {
	                var results = _this.state.farmResultByFilePath[_this.state.selected.filePath];
	                var indexIntoResults = results.map(function (x) { return x.line; }).indexOf(_this.state.selected.line);
	                if (indexIntoResults === results.length - 1) {
	                    // Goto next filePath if any
	                    var filePaths = Object.keys(_this.state.farmResultByFilePath);
	                    var filePathIndex = filePaths.indexOf(_this.state.selected.filePath);
	                    if (filePathIndex === filePaths.length - 1)
	                        return false;
	                    var nextFilePath = filePaths[filePathIndex + 1];
	                    _this.setSelected(nextFilePath, -1);
	                }
	                else {
	                    var nextResult = results[indexIntoResults + 1];
	                    _this.setSelected(nextResult.filePath, nextResult.line);
	                }
	            }
	            return false;
	        });
	        handlers.bind('left', function () {
	            /** Just select and collapse the folder irrespective of our current state */
	            if (!_this.state.results || !_this.state.results.length)
	                return false;
	            if (!_this.state.selected.filePath)
	                return false;
	            _this.state.collapsedState[_this.state.selected.filePath] = true;
	            _this.setState({ collapsedState: _this.state.collapsedState });
	            _this.setSelected(_this.state.selected.filePath, -1);
	            return false;
	        });
	        handlers.bind('right', function () {
	            /** Expand only if a filePath root is currently selected  */
	            if (!_this.state.results || !_this.state.results.length)
	                return false;
	            _this.state.collapsedState[_this.state.selected.filePath] = false;
	            _this.setState({ collapsedState: _this.state.collapsedState });
	            return false;
	        });
	        handlers.bind('enter', function () {
	            /** Enter always takes you into the filePath */
	            if (!_this.state.results || !_this.state.results.length)
	                return false;
	            if (!_this.state.selected.filePath) {
	                selectFirst();
	            }
	            _this.openSearchResult(_this.state.selected.filePath, _this.state.selected.line);
	            return false;
	        });
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    FindAndReplaceView.prototype.render = function () {
	        var hasSearch = !!this.state.config;
	        var rendered = (React.createElement("div", { className: ResultsStyles.noFocusClassName, style: csx.extend(csx.vertical, csx.flex, styles.someChildWillScroll) },
	            React.createElement("div", { ref: "results", tabIndex: 0, className: ResultsStyles.rootClassName }, hasSearch
	                ? this.renderSearchResults()
	                : React.createElement("div", { style: ResultsStyles.header }, "No Search")),
	            React.createElement("div", { style: csx.extend(csx.content, styles.padded1) }, this.renderSearchControls())));
	        return rendered;
	    };
	    FindAndReplaceView.prototype.renderSearchControls = function () {
	        return (React.createElement("div", { style: csx.vertical },
	            React.createElement("div", { style: csx.extend(csx.horizontal, csx.center) },
	                React.createElement("div", { style: csx.extend(csx.flex, csx.vertical) },
	                    React.createElement("div", { style: csx.extend(csx.horizontal, csx.center, styles.padded1) },
	                        React.createElement("input", { tabIndex: 1, ref: "find", placeholder: "Find", className: inputBlackClassName, style: csx.extend(findAndReplace_1.inputCodeStyle, csx.flex), onKeyDown: this.findKeyDownHandler, onChange: this.findChanged, defaultValue: '' }))),
	                React.createElement("div", { style: csx.content },
	                    React.createElement("div", { style: csx.extend(csx.horizontal, csx.aroundJustified, styles.padded1) },
	                        React.createElement("label", { style: csx.extend(csx.horizontal, csx.center) },
	                            React.createElement(ui.Toggle, { tabIndex: 3, ref: "regex", onChange: this.handleRegexChange }),
	                            React.createElement("span", { style: findAndReplace_1.searchOptionsLabelStyle }, ".*")),
	                        React.createElement("label", { style: csx.extend(csx.horizontal, csx.center) },
	                            React.createElement(ui.Toggle, { tabIndex: 4, ref: "caseInsensitive", onChange: this.handleCaseSensitiveChange }),
	                            React.createElement("span", { style: findAndReplace_1.searchOptionsLabelStyle }, "Aa")),
	                        React.createElement("label", { style: csx.extend(csx.horizontal, csx.center) },
	                            React.createElement(ui.Toggle, { tabIndex: 5, ref: "fullWord", onKeyDown: this.fullWordKeyDownHandler, onChange: this.handleFullWordChange }),
	                            React.createElement("span", { style: findAndReplace_1.searchOptionsLabelStyle },
	                                React.createElement(icon_1.Icon, { name: "text-width" })))))),
	            React.createElement("div", { style: styles.Tip.root },
	                React.createElement("div", null,
	                    "Controls:",
	                    ' ',
	                    React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Esc"),
	                    " to focus on results",
	                    ' ',
	                    React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Enter"),
	                    " to start/restart search",
	                    ' ',
	                    React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Toggle \uD83D\uDD18 switches"),
	                    " start/restart search"),
	                React.createElement("div", null,
	                    "Results:",
	                    ' ',
	                    React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Up/Down"),
	                    " to go through results",
	                    ' ',
	                    React.createElement("span", { style: styles.Tip.keyboardShortCutStyle }, "Enter"),
	                    " to open a search result"))));
	    };
	    FindAndReplaceView.prototype.renderSearchResults = function () {
	        var _this = this;
	        var filePaths = Object.keys(this.state.farmResultByFilePath);
	        var queryRegex = this.state.queryRegex;
	        var queryRegexStr = (this.state.queryRegex && this.state.queryRegex.toString()) || '';
	        queryRegexStr = queryRegexStr && " (Query : " + queryRegexStr + ") ";
	        return (React.createElement("div", { style: csx.extend(csx.flex, styles.errorsPanel.main, { userSelect: 'none' }) },
	            React.createElement("div", { style: csx.extend(ResultsStyles.header, csx.horizontal) },
	                "Total Results (",
	                this.state.results.length,
	                ")",
	                (this.state.results.length >= types.maxCountFindAndReplaceMultiResults)
	                    && React.createElement("span", { className: "hint--info hint--bottom", "data-hint": "(search limited to " + types.maxCountFindAndReplaceMultiResults + ")" }, "(+)"),
	                !this.state.completed &&
	                    React.createElement("span", null,
	                        React.createElement(gls.SmallHorizontalSpace, null),
	                        React.createElement(buttons.ButtonBlack, { key: "button", onClick: this.cancelAnyRunningSearch, text: "Cancel" })),
	                React.createElement("span", { style: csx.flex }),
	                queryRegexStr),
	            filePaths.map(function (filePath, i) {
	                var results = _this.state.farmResultByFilePath[filePath];
	                var selectedRoot = filePath === _this.state.selected.filePath && _this.state.selected.line == -1;
	                var selectedResultLine = filePath === _this.state.selected.filePath ? _this.state.selected.line : -2 /* -2 means not selected */;
	                return (React.createElement(FileResults.FileResults, { key: i, ref: filePath, filePath: filePath, results: results, queryRegex: _this.state.queryRegex, expanded: !_this.state.collapsedState[filePath], onClickFilePath: _this.toggleFilePathExpansion, openSearchResult: _this.openSearchResult, selectedRoot: selectedRoot, selectedResultLine: selectedResultLine }));
	            })));
	    };
	    /**
	     * Scrolling through results
	     */
	    FindAndReplaceView.prototype.resultRef = function (filePath) {
	        var ref = filePath;
	        return this.refs[ref];
	    };
	    /** Parses results as they come and puts them into the state */
	    FindAndReplaceView.prototype.parseResults = function (response) {
	        // Convert as needed
	        // console.log(response); // DEBUG
	        var results = response.results;
	        var loaded = utils.createMapByKey(results, function (result) { return result.filePath; });
	        var queryRegex = response.config ? utils.findOptionsToQueryRegex({
	            query: response.config.query,
	            isRegex: response.config.isRegex,
	            isFullWord: response.config.isFullWord,
	            isCaseSensitive: response.config.isCaseSensitive,
	        }) : null;
	        // Finally rerender
	        this.setState({
	            results: results,
	            config: response.config,
	            queryRegex: queryRegex,
	            completed: response.completed,
	            farmResultByFilePath: loaded
	        });
	    };
	    return FindAndReplaceView;
	}(ui.BaseComponent));
	exports.FindAndReplaceView = FindAndReplaceView;
	var FileResults;
	(function (FileResults_1) {
	    var FileResults = /** @class */ (function (_super) {
	        __extends(FileResults, _super);
	        function FileResults() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.renderResultsForFilePath = function (results) {
	                return results.map(function (result, i) {
	                    var selectedStyle = _this.props.selectedResultLine === result.line
	                        ? ResultsStyles.selected
	                        : {};
	                    return (React.createElement("div", { key: i, ref: result.filePath + ':' + result.line, tabIndex: 0, className: ResultsStyles.noFocusClassName, style: csx.extend(styles.padded1, {
	                            cursor: 'pointer',
	                            overflow: 'hidden',
	                            textOverflow: 'ellipsis',
	                            whiteSpace: 'pre',
	                        }, selectedStyle), onClick: function (e) { e.stopPropagation(); _this.props.openSearchResult(result.filePath, result.line); } },
	                        utils.padLeft((result.line).toString(), 6),
	                        " : ",
	                        React.createElement("span", { style: ResultsStyles.preview }, _this.renderMatched(result.preview, _this.props.queryRegex))));
	                });
	            };
	            return _this;
	        }
	        FileResults.prototype.render = function () {
	            var _this = this;
	            var selectedStyle = this.props.selectedRoot
	                ? ResultsStyles.selected
	                : {};
	            return (React.createElement("div", { onClick: function () { return _this.props.onClickFilePath(_this.props.filePath); } },
	                React.createElement("div", { ref: this.props.filePath + ':' + -1, tabIndex: 0, className: ResultsStyles.noFocusClassName, style: csx.extend(selectedStyle, styles.errorsPanel.filePath, {
	                        margin: '8px 0px',
	                        padding: '3px'
	                    }) },
	                    !this.props.expanded ? "+" : "-",
	                    " ",
	                    this.props.filePath,
	                    " (",
	                    this.props.results.length,
	                    ")"),
	                !this.props.expanded ? React.createElement("noscript", null) : this.renderResultsForFilePath(this.props.results)));
	        };
	        FileResults.prototype.focus = function (filePath, line) {
	            var dom = this.refs[this.props.filePath + ':' + line];
	            dom.scrollIntoViewIfNeeded(false);
	        };
	        FileResults.prototype.renderMatched = function (preview, queryRegex) {
	            var matched = this.getMatchedSegments(preview, queryRegex);
	            var matchedStyle = { fontWeight: 'bold', color: '#66d9ef' };
	            return matched.map(function (item, i) {
	                return React.createElement("span", { key: i, style: item.matched ? matchedStyle : {} }, item.str);
	            });
	        };
	        FileResults.prototype.getMatchedSegments = function (preview, queryRegex) {
	            var result = [];
	            var match;
	            var previewCollectedIndex = 0;
	            var collectUnmatched = function (matchStart, matchLength) {
	                if (previewCollectedIndex < matchStart) {
	                    result.push({
	                        str: preview.substring(previewCollectedIndex, matchStart),
	                        matched: false
	                    });
	                    previewCollectedIndex = (matchStart + matchLength);
	                }
	            };
	            while (match = queryRegex.exec(preview)) {
	                var matchStart = match.index;
	                var matchLength = match[0].length;
	                // let nextMatchStart = queryRegex.lastIndex; // Since we don't need it
	                // If we have an unmatched string portion that is still not collected
	                // Collect it :)
	                collectUnmatched(matchStart, matchLength);
	                result.push({
	                    str: preview.substr(matchStart, matchLength),
	                    matched: true
	                });
	            }
	            // If we still have some string portion uncollected, collect it
	            if (previewCollectedIndex !== preview.length) {
	                collectUnmatched(preview.length, 0);
	            }
	            return result;
	        };
	        return FileResults;
	    }(React.PureComponent));
	    FileResults_1.FileResults = FileResults;
	})(FileResults || (FileResults = {}));


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Use this as a template for creating a new tab type
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/** imports */
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var socketClient_1 = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var ReactDOM = __webpack_require__(17);
	var React = __webpack_require__(2);
	var types = __webpack_require__(23);
	var gls = __webpack_require__(49);
	var typestyle_1 = __webpack_require__(13);
	var buttons_1 = __webpack_require__(82);
	var indicator_1 = __webpack_require__(152);
	var LiveDemoReactView = /** @class */ (function (_super) {
	    __extends(LiveDemoReactView, _super);
	    function LiveDemoReactView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.filePath = '';
	        _this.reload = function () {
	            // console.log("reload"); // DEBUG
	            if (_this.iframe)
	                _this.iframe.src = _this.getIframeUrl();
	        };
	        _this.getIframeUrl = function () {
	            return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + types.liveDemoMountUrl + "/";
	        };
	        _this.handleKey = function (e) {
	            var unicode = e.charCode;
	            if (String.fromCharCode(unicode).toLowerCase() === "r") {
	            }
	        };
	        _this.filter = function () {
	            // TODO:
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            // Not needed
	        };
	        _this.focus = function () {
	            ReactDOM.findDOMNode(_this).focus();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	            },
	            hideSearch: function () {
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        _this.state = {
	            status: {
	                type: 'bundling'
	            }
	        };
	        _this.filePath = utils.getFilePathFromUrl(props.url);
	        return _this;
	    }
	    LiveDemoReactView.prototype.componentDidMount = function () {
	        var _this = this;
	        this.disposible.add(socketClient_1.cast.liveDemoBuildComplete.on(function (status) {
	            _this.setState({ status: status });
	            if (status.type === 'success') {
	                _this.reload();
	            }
	        }));
	        socketClient_1.server.enableLiveDemoReact({ filePath: this.filePath });
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    LiveDemoReactView.prototype.render = function () {
	        var _this = this;
	        var type = this.state.status.type;
	        var color = type === 'bundling'
	            ? 'yellow'
	            : type === 'success'
	                ? '#0f0'
	                : 'red';
	        return (React.createElement("div", { tabIndex: 0, style: csx.extend(csx.vertical, csx.flex, csx.newLayerParent, styles.someChildWillScroll, { color: styles.textColor }), onKeyPress: this.handleKey, onFocus: this.props.onFocused },
	            React.createElement("div", { className: typestyle_1.style({ height: '30px' }, csx.horizontal, csx.content, csx.center, csx.Box.padding(5)) },
	                React.createElement("div", null,
	                    React.createElement(indicator_1.Indicator, { color: color })),
	                React.createElement("div", { style: { color: '#999', marginLeft: '5px' } }, this.state.status.type),
	                React.createElement(gls.Flex, null),
	                React.createElement(buttons_1.ButtonBlack, { text: "reload", onClick: this.reload })),
	            React.createElement("iframe", { ref: function (ref) { return _this.iframe = ref; }, src: this.getIframeUrl(), style: {
	                    height: 'calc(100% - 30px)',
	                    width: '100%',
	                    border: 'none',
	                    backgroundColor: 'white',
	                } })));
	    };
	    return LiveDemoReactView;
	}(ui.BaseComponent));
	exports.LiveDemoReactView = LiveDemoReactView;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Use this as a template for creating a new tab type
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/** imports */
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var ReactDOM = __webpack_require__(17);
	var indicator_1 = __webpack_require__(152);
	var typestyle_1 = __webpack_require__(13);
	var LiveDemoView = /** @class */ (function (_super) {
	    __extends(LiveDemoView, _super);
	    function LiveDemoView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.output = '';
	        _this.filePath = '';
	        _this.handleKey = function (e) {
	            var unicode = e.charCode;
	            if (String.fromCharCode(unicode).toLowerCase() === "r") {
	            }
	        };
	        _this.filter = function () {
	            // TODO:
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            // Not needed
	        };
	        _this.focus = function () {
	            ReactDOM.findDOMNode(_this).focus();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	            },
	            hideSearch: function () {
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        _this.state = {
	            status: 'running'
	        };
	        _this.filePath = utils.getFilePathFromUrl(props.url);
	        return _this;
	    }
	    LiveDemoView.prototype.componentDidMount = function () {
	        var _this = this;
	        /**
	         * Initial load + load on project change
	         */
	        socketClient_1.server.enableLiveDemo({ filePath: this.filePath });
	        this.disposible.add(socketClient_1.cast.liveDemoData.on(function (data) {
	            if (data.type === 'start') {
	                _this.output = '';
	                _this.setState({ status: 'running' });
	            }
	            else if (data.type === 'data') {
	                _this.output = _this.output + data.data;
	                _this.forceUpdate();
	            }
	            else if (data.type === 'end') {
	                _this.setState({ status: !data.code ? 'done' : 'error' });
	            }
	            else {
	                var _ensure = data;
	            }
	        }));
	        this.disposible.add(commands.ensureLiveDemoTab.on(function (_a) {
	            var filePath = _a.filePath;
	            _this.filePath = filePath;
	            socketClient_1.server.enableLiveDemo({ filePath: filePath });
	        }));
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    LiveDemoView.prototype.render = function () {
	        var color = this.state.status === 'running'
	            ? '#0f0'
	            : this.state.status === 'done'
	                ? '#999'
	                /** Error */
	                : 'red';
	        return (React.createElement("div", { tabIndex: 0, style: csx.extend(csx.vertical, csx.flex, csx.newLayerParent, styles.someChildWillScroll, { color: styles.textColor }), onKeyPress: this.handleKey, onFocus: this.props.onFocused },
	            React.createElement("div", { style: { overflow: 'hidden', display: 'flex', padding: '10px', flexDirection: 'column', height: '100%' } },
	                React.createElement("div", { className: typestyle_1.style({ height: '30px' }, csx.horizontal, csx.content, csx.center, csx.Box.padding(5)) },
	                    React.createElement("div", null,
	                        React.createElement(indicator_1.Indicator, { color: color })),
	                    React.createElement("div", { style: { color: '#999', marginLeft: '10px' } }, this.state.status)),
	                React.createElement("pre", { style: {
	                        overflow: 'auto',
	                        display: 'flex',
	                        flex: '1',
	                        margin: '0px',
	                        padding: '5px',
	                        border: '1px solid #333',
	                    } }, this.output))));
	    };
	    return LiveDemoView;
	}(ui.BaseComponent));
	exports.LiveDemoView = LiveDemoView;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var types = __webpack_require__(23);
	var styles = __webpack_require__(10);
	var clipboard_1 = __webpack_require__(50);
	var gls = __webpack_require__(49);
	var typestyle = __webpack_require__(13);
	var clientTestResultsCache_1 = __webpack_require__(59);
	var icon_1 = __webpack_require__(31);
	var state = __webpack_require__(11);
	var TestedViewStyles;
	(function (TestedViewStyles) {
	    TestedViewStyles.headerClassName = typestyle.style({
	        fontWeight: 'bold',
	        cursor: 'pointer',
	        $nest: {
	            '&:hover': {
	                textDecoration: 'underline'
	            }
	        }
	    });
	    TestedViewStyles.clickable = typestyle.style({
	        cursor: 'pointer',
	        $nest: {
	            '&:hover': {
	                textDecoration: 'underline'
	            }
	        }
	    });
	})(TestedViewStyles = exports.TestedViewStyles || (exports.TestedViewStyles = {}));
	/** Utility */
	var makeReactKeyOutOfPosition = function (position) {
	    return position.line + ':' + position.ch;
	};
	var formatStats = function (stats) {
	    return "\u03A3: " + stats.testCount + " (\u2713: " + stats.passCount + ", \u2718: " + stats.failCount + ", \u25CE: " + stats.skipCount + ") " + utils.formatMilliseconds(stats.durationMs);
	};
	var TestedView = /** @class */ (function (_super) {
	    __extends(TestedView, _super);
	    function TestedView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.ctrls = {};
	        _this.openTestLogPositionInSelectedModule = function (pos) {
	            var filePath = _this.state.selected;
	            commands.doOpenOrFocusFile.emit({
	                filePath: filePath,
	                position: pos.lastPositionInFile,
	            });
	        };
	        _this.openFilePathPosition = function (fpPos) {
	            commands.doOpenOrFocusFile.emit(fpPos);
	        };
	        _this.handleNodeClick = function (node) {
	            commands.doOpenOrFocusFile.emit({
	                filePath: node.location.filePath,
	                position: node.location.position
	            });
	        };
	        _this.handleModuleSelected = function (node) {
	            _this.setState({ selected: node.filePath });
	        };
	        _this.handleKey = function (e) {
	            var unicode = e.charCode;
	            if (String.fromCharCode(unicode).toLowerCase() === "r") {
	                _this.loadData();
	            }
	        };
	        _this.loadData = function () {
	            var results = clientTestResultsCache_1.testResultsCache.getResults();
	            var testResultsStats = clientTestResultsCache_1.testResultsCache.getStats();
	            _this.setState({ tests: results, testResultsStats: testResultsStats });
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            // Not needed
	        };
	        _this.focus = function () {
	            _this.ctrls.root.focus();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	            },
	            hideSearch: function () {
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        _this.state = {
	            tests: Object.create(null),
	            selected: null
	        };
	        return _this;
	    }
	    TestedView.prototype.componentDidMount = function () {
	        var _this = this;
	        /**
	         * Initial load + load on result change
	         */
	        this.loadData();
	        this.disposible.add(clientTestResultsCache_1.testResultsCache.testResultsDelta.on(function () {
	            _this.loadData();
	        }));
	        this.disposible.add(state.subscribeSub(function (s) { return s.testedWorking; }, function (testedWorking) {
	            _this.setState({ testedWorking: testedWorking });
	        }));
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    TestedView.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", { ref: function (root) { return _this.ctrls.root = root; }, onFocus: this.props.onFocused, tabIndex: 0, style: csx.extend(csx.vertical, csx.flex, csx.newLayerParent, styles.someChildWillScroll, { color: styles.textColor }), onKeyPress: this.handleKey },
	            React.createElement(gls.FlexVertical, { style: { overflow: 'hidden', padding: '10px' } },
	                this.renderHeader(),
	                React.createElement(gls.SmallVerticalSpace, null),
	                React.createElement(gls.FlexVertical, null,
	                    React.createElement(gls.FlexHorizontal, null,
	                        React.createElement(gls.ContentVertical, { style: { overflow: 'auto', backgroundColor: styles.blackHighlightColor, padding: '10px', width: '200px' } }, this.renderFiles()),
	                        React.createElement(gls.SmallHorizontalSpace, null),
	                        React.createElement(gls.FlexVertical, { style: { overflow: 'auto', backgroundColor: styles.blackHighlightColor, padding: '10px' } }, this.state.selected
	                            ? this.renderSelectedNode()
	                            : 'Select a module from the left to view results 🌹'))))));
	    };
	    TestedView.prototype.renderHeader = function () {
	        if (!this.state.testResultsStats) {
	            return React.createElement("div", null, "No test runs yet.");
	        }
	        var testResultsStats = clientTestResultsCache_1.testResultsCache.getStats();
	        var failing = !!testResultsStats.failCount;
	        var totalThatRan = testResultsStats.passCount + testResultsStats.failCount;
	        var working = this.state.testedWorking && this.state.testedWorking.working;
	        var summary = formatStats(testResultsStats);
	        var testStatsRendered = !!testResultsStats.testCount && React.createElement("span", null, failing
	            ? React.createElement("span", { style: { color: styles.errorColor, fontWeight: 'bold' } },
	                React.createElement(icon_1.Icon, { name: styles.icons.tested, spin: !!working }),
	                " ",
	                testResultsStats.failCount,
	                "/",
	                totalThatRan,
	                " Tests Failing")
	            : React.createElement("span", { style: { color: styles.successColor, fontWeight: 'bold' } },
	                React.createElement(icon_1.Icon, { name: styles.icons.tested, spin: !!working }),
	                " ",
	                testResultsStats.passCount,
	                "/",
	                totalThatRan,
	                " Tests Passed"));
	        return (React.createElement(gls.ContentHorizontal, null,
	            React.createElement(gls.Content, null, testStatsRendered),
	            React.createElement(gls.Flex, null),
	            React.createElement(gls.Content, null, summary)));
	    };
	    TestedView.prototype.renderFiles = function () {
	        var _this = this;
	        return Object.keys(this.state.tests).map(function (fp, i) {
	            var item = _this.state.tests[fp];
	            var fileName = utils.getFileName(fp);
	            var failing = !!item.stats.failCount;
	            var totalThatRan = item.stats.passCount + item.stats.failCount;
	            return (React.createElement("div", { key: i, title: fp, className: TestedViewStyles.headerClassName, style: csx.extend({
	                    paddingTop: '2px', paddingBottom: '2px', paddingLeft: '2px',
	                    color: failing ? styles.errorColor : styles.successColor,
	                    backgroundColor: _this.state.selected === fp ? styles.selectedBackgroundColor : 'transparent',
	                }, styles.ellipsis), onClick: function () { return _this.handleModuleSelected(item); } },
	                React.createElement(icon_1.Icon, { name: "file-text-o" }),
	                " (",
	                failing ? item.stats.failCount : item.stats.passCount,
	                "/",
	                totalThatRan,
	                ") ",
	                fileName));
	        });
	    };
	    TestedView.prototype.renderSelectedNode = function () {
	        var _this = this;
	        var filePath = this.state.selected;
	        var test = this.state.tests[filePath];
	        if (!test) {
	            return React.createElement("div", null,
	                "The selected filePath: ",
	                filePath,
	                " is no longer in the test restuls");
	        }
	        var someFailing = !!test.stats.failCount;
	        return React.createElement(gls.ContentVerticalContentPadded, { padding: 10 },
	            React.createElement("div", { style: {
	                    color: someFailing ? styles.errorColor : styles.successColor
	                } },
	                React.createElement(gls.InlineBlock, null,
	                    " ",
	                    formatStats(test.stats),
	                    " ")),
	            React.createElement("div", { className: TestedViewStyles.clickable, style: { fontSize: '.8em', textDecoration: 'underline' } },
	                React.createElement("span", { onClick: function () {
	                        commands.doOpenOrFocusFile.emit({
	                            filePath: filePath,
	                        });
	                    } }, filePath)),
	            React.createElement(gls.Content, null, test.suites.map(function (s) { return _this.renderSuite(s); })));
	    };
	    TestedView.prototype.renderSuite = function (suite) {
	        var _this = this;
	        var color = !!suite.stats.failCount ? styles.errorColor
	            : !!suite.stats.passCount ? styles.successColor
	                : styles.highlightColor;
	        return React.createElement("div", { key: makeReactKeyOutOfPosition(suite.testLogPosition.lastPositionInFile), style: {
	                fontSize: '13px',
	                border: "1px solid " + color,
	                marginTop: '5px', padding: '5px'
	            } },
	            React.createElement(gls.InlineBlock, { style: {
	                    color: color
	                } },
	                React.createElement(icon_1.Icon, { name: styles.icons.testedSuite }),
	                " ",
	                React.createElement("span", { className: TestedViewStyles.headerClassName, onClick: function () { return _this.openTestLogPositionInSelectedModule(suite.testLogPosition); } }, suite.description)),
	            React.createElement(gls.SmallVerticalSpace, { space: 10 }),
	            formatStats(suite.stats),
	            React.createElement(gls.SmallVerticalSpace, { space: 10 }),
	            suite.tests.map(function (s) { return _this.renderTest(s); }),
	            React.createElement(gls.SmallVerticalSpace, { space: 10 }),
	            suite.suites.map(function (s) { return _this.renderSuite(s); }));
	    };
	    TestedView.prototype.renderTest = function (test) {
	        var _this = this;
	        return React.createElement("div", { key: makeReactKeyOutOfPosition(test.testLogPosition.lastPositionInFile), style: { padding: '5px' } },
	            React.createElement(gls.InlineBlock, { style: {
	                    color: test.status === types.TestStatus.Success ? styles.successColor
	                        : test.status === types.TestStatus.Fail ? styles.errorColor
	                            : styles.highlightColor
	                } },
	                React.createElement(icon_1.Icon, { name: styles.icons.testedTest }),
	                " ",
	                React.createElement("span", { className: TestedViewStyles.headerClassName, onClick: function () { return _this.openTestLogPositionInSelectedModule(test.testLogPosition); } }, test.description)),
	            "\u00A0\u00A0",
	            React.createElement(gls.InlineBlock, { style: { fontSize: '10px' } }, test.durationMs != undefined ? utils.formatMilliseconds(test.durationMs) : ''),
	            test.status === types.TestStatus.Fail && React.createElement("div", { style: {
	                    padding: '5px',
	                    margin: '5px',
	                    backgroundColor: 'black'
	                } },
	                React.createElement(gls.ContentVerticalContentPadded, { padding: 10 },
	                    React.createElement("div", null,
	                        React.createElement(clipboard_1.Clipboard, { text: test.error.message }),
	                        " ",
	                        test.error.message),
	                    !!test.error.testLogPosition.stack.length && test.error.testLogPosition.stack.map(function (s) {
	                        return React.createElement("div", { key: makeReactKeyOutOfPosition(s.position), style: { fontSize: '11px' }, onClick: function () { return _this.openFilePathPosition(s); } },
	                            React.createElement(icon_1.Icon, { name: "eye" }),
	                            "\u00A0\u00A0",
	                            React.createElement(gls.InlineBlock, { className: TestedViewStyles.clickable },
	                                s.filePath,
	                                ":",
	                                s.position.line + 1,
	                                ":",
	                                s.position.ch + 1));
	                    }))));
	    };
	    return TestedView;
	}(ui.BaseComponent));
	exports.TestedView = TestedView;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * The ts flow features. Allowing you to write code in a `flow` mode
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/** imports */
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var typestyle = __webpack_require__(13);
	var DocumentationViewStyles;
	(function (DocumentationViewStyles) {
	    DocumentationViewStyles.header = typestyle.style({
	        cursor: 'pointer',
	        $nest: {
	            '&:hover': {
	                textDecoration: 'underline'
	            }
	        }
	    });
	    DocumentationViewStyles.folderName = typestyle.style({
	        padding: "2px",
	        fontSize: '.5em',
	        '-webkit-user-select': 'none',
	        maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis'
	    });
	})(DocumentationViewStyles = exports.DocumentationViewStyles || (exports.DocumentationViewStyles = {}));
	var TsFlowView = /** @class */ (function (_super) {
	    __extends(TsFlowView, _super);
	    function TsFlowView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleKey = function (e) {
	            var unicode = e.charCode;
	            if (String.fromCharCode(unicode).toLowerCase() === "r") {
	                _this.loadData();
	            }
	        };
	        _this.filter = function () {
	            // TODO:
	        };
	        _this.loadData = function () {
	            // TODO:
	            // server.getTopLevelModuleNames({}).then(res => {
	            //     this.setState({files:res.files, selected: null});
	            //     this.filter();
	            // })
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            // Not needed
	        };
	        _this.focus = function () {
	            _this.refs.root.focus();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	                _this.setState({ filter: options.query });
	            },
	            hideSearch: function () {
	                _this.setState({ filter: '' });
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        _this.filePath = utils.getFilePathFromUrl(props.url);
	        _this.state = {
	            filter: ''
	        };
	        return _this;
	    }
	    TsFlowView.prototype.componentDidMount = function () {
	        var _this = this;
	        /**
	         * Initial load + load on project change
	         */
	        this.loadData();
	        this.disposible.add(socketClient_1.cast.activeProjectFilePathsUpdated.on(function () {
	            _this.loadData();
	        }));
	        /**
	         * If a file is selected and it gets edited, reload the file module information
	         */
	        var loadDataDebounced = utils.debounce(this.loadData, 3000);
	        this.disposible.add(commands.fileContentsChanged.on(function (res) {
	            if (_this.filePath !== res.filePath)
	                return;
	            loadDataDebounced();
	        }));
	        /**
	         * Handle focus to inform tab container
	         */
	        var focused = function () {
	            _this.props.onFocused();
	        };
	        this.refs.root.addEventListener('focus', focused);
	        this.disposible.add({
	            dispose: function () {
	                _this.refs.root.removeEventListener('focus', focused);
	            }
	        });
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    TsFlowView.prototype.render = function () {
	        return (React.createElement("div", { ref: "root", tabIndex: 0, style: csx.extend(csx.vertical, csx.flex, csx.newLayerParent, styles.someChildWillScroll, { color: styles.textColor }), onKeyPress: this.handleKey },
	            React.createElement("div", { style: { overflow: 'hidden', padding: '10px', display: 'flex' } })));
	    };
	    return TsFlowView;
	}(ui.BaseComponent));
	exports.TsFlowView = TsFlowView;


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ui = __webpack_require__(1);
	var csx = __webpack_require__(6);
	var React = __webpack_require__(2);
	var socketClient_1 = __webpack_require__(5);
	var commands = __webpack_require__(7);
	var utils = __webpack_require__(3);
	var styles = __webpack_require__(10);
	var typeIcon = __webpack_require__(154);
	var gls = __webpack_require__(49);
	var typestyle = __webpack_require__(13);
	var blackHighlightColor = styles.blackHighlightColor;
	var UmlViewStyles;
	(function (UmlViewStyles) {
	    UmlViewStyles.classNameHeaderSection = typestyle.style({
	        border: '1px solid grey',
	        padding: '5px',
	        /** A nice clickable look */
	        cursor: 'pointer',
	        $nest: {
	            '&:hover': {
	                textDecoration: 'underline'
	            }
	        }
	    });
	    UmlViewStyles.classMemberSection = typestyle.style({
	        // Common with header
	        border: '1px solid grey',
	        padding: '5px',
	        cursor: 'pointer',
	        $nest: {
	            '&:hover': {
	                textDecoration: 'underline'
	            }
	        },
	        // To eat top border
	        marginTop: '-1px'
	    });
	})(UmlViewStyles = exports.UmlViewStyles || (exports.UmlViewStyles = {}));
	var UmlView = /** @class */ (function (_super) {
	    __extends(UmlView, _super);
	    function UmlView(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleKey = function (e) {
	            var unicode = e.charCode;
	            if (String.fromCharCode(unicode).toLowerCase() === "r") {
	                _this.loadData();
	            }
	        };
	        _this.filter = function () {
	            // TODO:
	        };
	        _this.loadData = function () {
	            socketClient_1.server.getUmlDiagramForFile({ filePath: _this.filePath }).then(function (res) {
	                // Preserve selected
	                var selected = _this.state.selected && res.classes.find(function (c) { return c.name === _this.state.selected.name; });
	                // otherwise auto select first
	                if (!selected && res.classes.length) {
	                    selected = res.classes[0];
	                }
	                _this.setState({ classes: res.classes, selected: selected });
	                _this.filter();
	            });
	        };
	        /**
	         * TAB implementation
	         */
	        _this.resize = function () {
	            // Not needed
	        };
	        _this.focus = function () {
	            _this.refs.root.focus();
	        };
	        _this.save = function () {
	        };
	        _this.close = function () {
	        };
	        _this.gotoPosition = function (position) {
	        };
	        _this.search = {
	            doSearch: function (options) {
	                _this.setState({ filter: options.query });
	            },
	            hideSearch: function () {
	                _this.setState({ filter: '' });
	            },
	            findNext: function (options) {
	            },
	            findPrevious: function (options) {
	            },
	            replaceNext: function (_a) {
	                var newText = _a.newText;
	            },
	            replacePrevious: function (_a) {
	                var newText = _a.newText;
	            },
	            replaceAll: function (_a) {
	                var newText = _a.newText;
	            }
	        };
	        _this.filePath = utils.getFilePathFromUrl(props.url);
	        _this.state = {
	            filter: '',
	            classes: [],
	            selected: null,
	        };
	        return _this;
	    }
	    UmlView.prototype.componentDidMount = function () {
	        var _this = this;
	        /**
	         * Initial load + load on project change
	         */
	        this.loadData();
	        this.disposible.add(socketClient_1.cast.activeProjectFilePathsUpdated.on(function () {
	            _this.loadData();
	        }));
	        /**
	         * If a file is selected and it gets edited, reload the file module information
	         */
	        var loadDataDebounced = utils.debounce(this.loadData, 3000);
	        this.disposible.add(commands.fileContentsChanged.on(function (res) {
	            if (_this.filePath !== res.filePath)
	                return;
	            loadDataDebounced();
	        }));
	        /**
	         * Handle focus to inform tab container
	         */
	        var focused = function () {
	            _this.props.onFocused();
	        };
	        this.refs.root.addEventListener('focus', focused);
	        this.disposible.add({
	            dispose: function () {
	                _this.refs.root.removeEventListener('focus', focused);
	            }
	        });
	        // Listen to tab events
	        var api = this.props.api;
	        this.disposible.add(api.resize.on(this.resize));
	        this.disposible.add(api.focus.on(this.focus));
	        this.disposible.add(api.save.on(this.save));
	        this.disposible.add(api.close.on(this.close));
	        this.disposible.add(api.gotoPosition.on(this.gotoPosition));
	        // Listen to search tab events
	        this.disposible.add(api.search.doSearch.on(this.search.doSearch));
	        this.disposible.add(api.search.hideSearch.on(this.search.hideSearch));
	        this.disposible.add(api.search.findNext.on(this.search.findNext));
	        this.disposible.add(api.search.findPrevious.on(this.search.findPrevious));
	        this.disposible.add(api.search.replaceNext.on(this.search.replaceNext));
	        this.disposible.add(api.search.replacePrevious.on(this.search.replacePrevious));
	        this.disposible.add(api.search.replaceAll.on(this.search.replaceAll));
	    };
	    UmlView.prototype.render = function () {
	        return (React.createElement("div", { ref: "root", tabIndex: 0, style: csx.extend(csx.vertical, csx.flex, csx.newLayerParent, styles.someChildWillScroll, { color: styles.textColor }), onKeyPress: this.handleKey },
	            React.createElement("div", { style: { overflow: 'hidden', padding: '10px 0px 10px 10px', display: 'flex' } },
	                React.createElement(gls.FlexHorizontal, { style: {} },
	                    React.createElement(gls.Content, { style: { minWidth: '150px', maxWidth: '250px', overflow: 'auto' } },
	                        React.createElement(typeIcon.SectionHeader, { text: "Classes" }),
	                        React.createElement(gls.SmallVerticalSpace, null),
	                        this.state.classes.length
	                            ? this.renderClasses()
	                            : "No classes in file"),
	                    React.createElement(gls.FlexVertical, { style: { marginLeft: '5px', overflow: 'auto' } },
	                        this.state.selected
	                            ? this.renderSelectedClass()
	                            : 'Select a class from the left to view its diagram 🌹 🎼',
	                        React.createElement("div", { style: { marginTop: '10px', marginRight: '10px' } },
	                            React.createElement("hr", null),
	                            React.createElement(typeIcon.TypeIconClassDiagramLegend, null)))))));
	    };
	    UmlView.prototype.renderClasses = function () {
	        var _this = this;
	        return this.state.classes.map(function (c, i) {
	            var backgroundColor = _this.state.selected && _this.state.selected.name === c.name
	                ? blackHighlightColor
	                : 'transparent';
	            return (React.createElement("div", { title: c.name + ' ' + c.location.position.line, key: i, style: { cursor: 'pointer', backgroundColor: backgroundColor, paddingTop: '2px', paddingBottom: '2px', paddingLeft: '2px' }, onClick: function () { return _this.handleClassSelected(c); } },
	                React.createElement(typeIcon.DocumentedTypeHeader, { name: c.name, icon: c.icon })));
	        });
	    };
	    UmlView.prototype.renderSelectedClass = function () {
	        var c = this.state.selected;
	        return React.createElement(gls.Content, { style: { textAlign: 'center' } },
	            React.createElement("code", { style: { fontWeight: 'bold' } }, c.name),
	            React.createElement(gls.SmallVerticalSpace, null),
	            this.renderClass(c));
	    };
	    UmlView.prototype.renderClass = function (c) {
	        var _this = this;
	        var renderSection = function (section, i) {
	            return React.createElement("div", { key: i, style: { border: '1px solid grey', padding: '5px', marginTop: '-1px' } }, section);
	        };
	        return (React.createElement(gls.Content, { style: { textAlign: 'center' } },
	            React.createElement(gls.InlineBlock, { style: { paddingTop: '1px' } },
	                React.createElement("div", { className: UmlViewStyles.classNameHeaderSection, onClick: function () { return _this.handleGotoTypeLocation(c.location); } },
	                    React.createElement(typeIcon.DocumentedTypeHeader, { name: c.name, icon: c.icon })),
	                c.members.map(function (m, i) {
	                    return React.createElement("div", { key: i, className: UmlViewStyles.classMemberSection, onClick: function () { return _this.handleGotoTypeLocation(m.location); } },
	                        React.createElement(typeIcon.DocumentedTypeHeader, { name: m.name, icon: m.icon, visibility: m.visibility, lifetime: m.lifetime, override: !!m.override }));
	                }),
	                !!c.extends &&
	                    React.createElement(gls.Content, null,
	                        React.createElement("code", null, "extends"),
	                        this.renderClass(c.extends)))));
	    };
	    UmlView.prototype.handleClassSelected = function (c) {
	        this.setState({ selected: c });
	    };
	    UmlView.prototype.handleGotoTypeLocation = function (location) {
	        commands.doOpenOrFocusFile.emit({
	            filePath: location.filePath,
	            position: location.position
	        });
	    };
	    return UmlView;
	}(ui.BaseComponent));
	exports.UmlView = UmlView;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Load up TypeScript
	 */
	var _ts = __webpack_require__(167);
	var ensureImport = _ts;
	/**
	 * The main entry point for the front end
	 */
	var root_1 = __webpack_require__(449);
	var commands = __webpack_require__(7);
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(17);
	var ReactDOMServer = __webpack_require__(133);
	var react_redux_1 = __webpack_require__(29);
	var state = __webpack_require__(11);
	var state_1 = __webpack_require__(11);
	var ui = __webpack_require__(1);
	var appTabsContainer_1 = __webpack_require__(26);
	var settings = __webpack_require__(88);
	var clientSession = __webpack_require__(87);
	var types = __webpack_require__(23);
	var globalErrorCacheClient_1 = __webpack_require__(35);
	var clientTestResultsCache_1 = __webpack_require__(59);
	var socketClient_1 = __webpack_require__(5);
	var Modal = __webpack_require__(28);
	// Having jQuery ($) on the console helps us debug certin libs that use jQuery
	var $ = __webpack_require__(36);
	window.$ = $;
	// prevent backspace
	var preventBackspaceNav_1 = __webpack_require__(468);
	preventBackspaceNav_1.preventBackspaceNav();
	// Normalize css
	__webpack_require__(360);
	// Lost connection indicator
	__webpack_require__(366);
	// Load clipboard and enable for all things clipboard
	var Clipboard = __webpack_require__(169);
	new Clipboard('[data-clipboard-text]');
	// Load hint.css for fancy (styleable) titles
	__webpack_require__(357);
	// Setup font awesome
	__webpack_require__(354);
	var afterLoaded = function () {
	    // The main app element
	    var appElement = document.getElementById('app');
	    // Register a modal location
	    Modal.setAppElement(appElement);
	    // Render the main app
	    ReactDOM.render(React.createElement(react_redux_1.Provider, { store: state_1.store },
	        React.createElement(root_1.Root, null)), appElement);
	    // Register commands
	    commands.register();
	    // For testing
	    // server.echo({text:"123",num:345}).then((res)=>console.log(res));
	    // Anything that should mutate the state
	    socketClient_1.server.getErrors({}).then(function (errorsUpdate) {
	        globalErrorCacheClient_1.errorsCache.setErrors(errorsUpdate);
	    });
	    socketClient_1.cast.errorsDelta.on(function (errorsDelta) {
	        if (errorsDelta.initial) {
	            globalErrorCacheClient_1.errorsCache.clearErrors();
	        }
	        globalErrorCacheClient_1.errorsCache.applyDelta(errorsDelta);
	    });
	    socketClient_1.server.getTestResults({}).then(function (results) {
	        clientTestResultsCache_1.testResultsCache.setResults(results);
	    });
	    socketClient_1.cast.testResultsDelta.on(function (testResultsDelta) {
	        clientTestResultsCache_1.testResultsCache.applyTestResultsDelta(testResultsDelta);
	    });
	    socketClient_1.pendingRequestsChanged.on(function (r) {
	        state.setPendingRequests(r.pending);
	    });
	    var firstConnectionState = true;
	    socketClient_1.connectionStatusChanged.on(function (r) {
	        state.setSocketConnected(r.connected);
	        if (firstConnectionState) {
	            $('.alm-connection-status').css('display', 'block');
	            firstConnectionState = false;
	            return;
	        }
	        $('.alm-connection-status').toggleClass('alm-connection-status-active', !r.connected);
	    });
	    socketClient_1.server.getActiveProjectConfigDetails({}).then(function (res) {
	        state.setActiveProject(res);
	    });
	    socketClient_1.cast.activeProjectConfigDetailsUpdated.on(function (res) {
	        state.setActiveProject(res);
	    });
	    socketClient_1.server.activeProjectFilePaths({}).then(function (res) {
	        state.setFilePathsInActiveProject(res.filePaths);
	    });
	    socketClient_1.cast.activeProjectFilePathsUpdated.on(function (res) {
	        state.setFilePathsInActiveProject(res.filePaths);
	    });
	    socketClient_1.server.filePaths({}).then(function (res) {
	        state.setFilePaths({ filePaths: res.filePaths, rootDir: res.rootDir, completed: res.completed });
	    });
	    socketClient_1.cast.filePathsUpdated.on(function (res) {
	        state.setFilePaths({ filePaths: res.filePaths, rootDir: res.rootDir, completed: res.completed });
	    });
	    socketClient_1.server.getCompleteOutputStatusCache({}).then(function (res) {
	        state.completeOuputStatusCacheUpdated(res);
	    });
	    socketClient_1.cast.fileOutputStatusUpdated.on(function (res) {
	        state.fileOuputStatusUpdated(res);
	    });
	    socketClient_1.cast.completeOutputStatusCacheUpdated.on(function (res) {
	        state.completeOuputStatusCacheUpdated(res);
	    });
	    socketClient_1.server.getLiveBuildResults({}).then(function (res) {
	        state.setLiveBuildResults(res);
	    });
	    socketClient_1.cast.liveBuildResults.on(function (res) {
	        state.setLiveBuildResults(res);
	    });
	    socketClient_1.cast.tsWorking.on(function (res) {
	        state.setTSWorking(res);
	    });
	    socketClient_1.cast.testedWorking.on(function (res) {
	        state.setTestedWorking(res);
	    });
	    commands.sync.on(function () {
	        socketClient_1.server.sync({});
	    });
	    commands.build.on(function () {
	        socketClient_1.server.build({});
	    });
	    /** Consolidate the file edit stuff into a single command */
	    socketClient_1.cast.didEdits.on(function (e) { commands.fileContentsChanged.emit({ filePath: e.filePath }); });
	    socketClient_1.cast.savedFileChangedOnDisk.on(function (e) { commands.fileContentsChanged.emit({ filePath: e.filePath }); });
	    commands.toggleDoctor.on(function () {
	        if (!state.inActiveProjectFilePath(appTabsContainer_1.tabState.getSelectedFilePath())) {
	            ui.notifyWarningNormalDisappear('Doctor is only available for files in active project');
	            return;
	        }
	        state.toggleDoctor({});
	    });
	    commands.toggleSemanticView.on(function () {
	        if (!state.inActiveProjectFilePath(appTabsContainer_1.tabState.getSelectedFilePath())) {
	            ui.notifyWarningNormalDisappear('Semantic view is only available for files in active project');
	            return;
	        }
	        state.toggleSemanticView({});
	    });
	    commands.duplicateWindow.on(function () {
	        var width = window.innerWidth;
	        var height = window.innerHeight;
	        window.open(window.location.href.replace(location.href, '') + "#" + types.urlHashNewSession, '', "innerWidth=" + width + ", innerHeight=" + height);
	    });
	    /** Set the window session */
	    socketClient_1.server.getValidSessionId({ sessionId: clientSession.getSessionId() }).then(function (res) {
	        clientSession.setSessionId(res.sessionId);
	        var sessionId = res.sessionId;
	        // Now load all the other settings we want:
	        /**
	         * Pattern:
	         * - Load the setting into redux
	         * - Then keep it updated as redux changes
	         */
	        settings.showDoctor.get().then(function (res) {
	            state.setShowDoctor(res);
	            state.subscribeSub(function (s) { return s.showDoctor; }, function (showDoctor) {
	                settings.showDoctor.set(showDoctor);
	            });
	        });
	        settings.showSemanticView.get().then(function (res) {
	            state.setShowSemanticView(res);
	            state.subscribeSub(function (s) { return s.showSemanticView; }, function (showSemanticView) {
	                settings.showSemanticView.set(showSemanticView);
	            });
	        });
	        settings.errorsExpanded.get().then(function (res) {
	            if (res)
	                state.expandErrors({});
	            else
	                state.collapseErrors({});
	            state.subscribeSub(function (s) { return s.errorsExpanded; }, function (errorsExpanded) {
	                settings.errorsExpanded.set(errorsExpanded);
	            });
	        });
	        settings.errorsDisplayMode.get().then(function (res) {
	            state.setErrorsDisplayMode(res || types.ErrorsDisplayMode.all);
	            state.subscribeSub(function (s) { return s.errorsDisplayMode; }, function (errorsDisplayMode) {
	                settings.errorsDisplayMode.set(errorsDisplayMode);
	            });
	        });
	        settings.fileTreeExpanded.get().then(function (res) {
	            if (res)
	                state.expandFileTree({});
	            else
	                state.collapseFileTree({});
	            state.subscribeSub(function (s) { return s.fileTreeShown; }, function (fileTreeShown) {
	                settings.fileTreeExpanded.set(fileTreeShown);
	            });
	        });
	    });
	};
	afterLoaded();


/***/ },
/* 467 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FAIconName;
	(function (FAIconName) {
	    FAIconName[FAIconName["glass"] = 0] = "glass";
	    FAIconName[FAIconName["music"] = 1] = "music";
	    FAIconName[FAIconName["search"] = 2] = "search";
	    FAIconName[FAIconName["envelopeAlt"] = 3] = "envelopeAlt";
	    FAIconName[FAIconName["heart"] = 4] = "heart";
	    FAIconName[FAIconName["star"] = 5] = "star";
	    FAIconName[FAIconName["starEmpty"] = 6] = "starEmpty";
	    FAIconName[FAIconName["user"] = 7] = "user";
	    FAIconName[FAIconName["film"] = 8] = "film";
	    FAIconName[FAIconName["thLarge"] = 9] = "thLarge";
	    FAIconName[FAIconName["th"] = 10] = "th";
	    FAIconName[FAIconName["thList"] = 11] = "thList";
	    FAIconName[FAIconName["ok"] = 12] = "ok";
	    FAIconName[FAIconName["remove"] = 13] = "remove";
	    FAIconName[FAIconName["zoomIn"] = 14] = "zoomIn";
	    FAIconName[FAIconName["zoomOut"] = 15] = "zoomOut";
	    FAIconName[FAIconName["powerOff"] = 16] = "powerOff";
	    FAIconName[FAIconName["off"] = 17] = "off";
	    FAIconName[FAIconName["signal"] = 18] = "signal";
	    FAIconName[FAIconName["gear"] = 19] = "gear";
	    FAIconName[FAIconName["cog"] = 20] = "cog";
	    FAIconName[FAIconName["trash"] = 21] = "trash";
	    FAIconName[FAIconName["home"] = 22] = "home";
	    FAIconName[FAIconName["fileAlt"] = 23] = "fileAlt";
	    FAIconName[FAIconName["time"] = 24] = "time";
	    FAIconName[FAIconName["road"] = 25] = "road";
	    FAIconName[FAIconName["downloadAlt"] = 26] = "downloadAlt";
	    FAIconName[FAIconName["download"] = 27] = "download";
	    FAIconName[FAIconName["upload"] = 28] = "upload";
	    FAIconName[FAIconName["inbox"] = 29] = "inbox";
	    FAIconName[FAIconName["playCircle"] = 30] = "playCircle";
	    FAIconName[FAIconName["rotateRight"] = 31] = "rotateRight";
	    FAIconName[FAIconName["repeat"] = 32] = "repeat";
	    FAIconName[FAIconName["refresh"] = 33] = "refresh";
	    FAIconName[FAIconName["listAlt"] = 34] = "listAlt";
	    FAIconName[FAIconName["lock"] = 35] = "lock";
	    FAIconName[FAIconName["flag"] = 36] = "flag";
	    FAIconName[FAIconName["headphones"] = 37] = "headphones";
	    FAIconName[FAIconName["volumeOff"] = 38] = "volumeOff";
	    FAIconName[FAIconName["volumeDown"] = 39] = "volumeDown";
	    FAIconName[FAIconName["volumeUp"] = 40] = "volumeUp";
	    FAIconName[FAIconName["qrcode"] = 41] = "qrcode";
	    FAIconName[FAIconName["barcode"] = 42] = "barcode";
	    FAIconName[FAIconName["tag"] = 43] = "tag";
	    FAIconName[FAIconName["tags"] = 44] = "tags";
	    FAIconName[FAIconName["book"] = 45] = "book";
	    FAIconName[FAIconName["bookmark"] = 46] = "bookmark";
	    FAIconName[FAIconName["print"] = 47] = "print";
	    FAIconName[FAIconName["camera"] = 48] = "camera";
	    FAIconName[FAIconName["font"] = 49] = "font";
	    FAIconName[FAIconName["bold"] = 50] = "bold";
	    FAIconName[FAIconName["italic"] = 51] = "italic";
	    FAIconName[FAIconName["textHeight"] = 52] = "textHeight";
	    FAIconName[FAIconName["textWidth"] = 53] = "textWidth";
	    FAIconName[FAIconName["alignLeft"] = 54] = "alignLeft";
	    FAIconName[FAIconName["alignCenter"] = 55] = "alignCenter";
	    FAIconName[FAIconName["alignRight"] = 56] = "alignRight";
	    FAIconName[FAIconName["alignJustify"] = 57] = "alignJustify";
	    FAIconName[FAIconName["list"] = 58] = "list";
	    FAIconName[FAIconName["indentLeft"] = 59] = "indentLeft";
	    FAIconName[FAIconName["indentRight"] = 60] = "indentRight";
	    FAIconName[FAIconName["facetimeVideo"] = 61] = "facetimeVideo";
	    FAIconName[FAIconName["picture"] = 62] = "picture";
	    FAIconName[FAIconName["pencil"] = 63] = "pencil";
	    FAIconName[FAIconName["mapMarker"] = 64] = "mapMarker";
	    FAIconName[FAIconName["adjust"] = 65] = "adjust";
	    FAIconName[FAIconName["tint"] = 66] = "tint";
	    FAIconName[FAIconName["edit"] = 67] = "edit";
	    FAIconName[FAIconName["share"] = 68] = "share";
	    FAIconName[FAIconName["check"] = 69] = "check";
	    FAIconName[FAIconName["move"] = 70] = "move";
	    FAIconName[FAIconName["stepBackward"] = 71] = "stepBackward";
	    FAIconName[FAIconName["fastBackward"] = 72] = "fastBackward";
	    FAIconName[FAIconName["backward"] = 73] = "backward";
	    FAIconName[FAIconName["play"] = 74] = "play";
	    FAIconName[FAIconName["pause"] = 75] = "pause";
	    FAIconName[FAIconName["stop"] = 76] = "stop";
	    FAIconName[FAIconName["forward"] = 77] = "forward";
	    FAIconName[FAIconName["fastForward"] = 78] = "fastForward";
	    FAIconName[FAIconName["stepForward"] = 79] = "stepForward";
	    FAIconName[FAIconName["eject"] = 80] = "eject";
	    FAIconName[FAIconName["chevronLeft"] = 81] = "chevronLeft";
	    FAIconName[FAIconName["chevronRight"] = 82] = "chevronRight";
	    FAIconName[FAIconName["plusSign"] = 83] = "plusSign";
	    FAIconName[FAIconName["minusSign"] = 84] = "minusSign";
	    FAIconName[FAIconName["removeSign"] = 85] = "removeSign";
	    FAIconName[FAIconName["okSign"] = 86] = "okSign";
	    FAIconName[FAIconName["questionSign"] = 87] = "questionSign";
	    FAIconName[FAIconName["infoSign"] = 88] = "infoSign";
	    FAIconName[FAIconName["screenshot"] = 89] = "screenshot";
	    FAIconName[FAIconName["removeCircle"] = 90] = "removeCircle";
	    FAIconName[FAIconName["okCircle"] = 91] = "okCircle";
	    FAIconName[FAIconName["banCircle"] = 92] = "banCircle";
	    FAIconName[FAIconName["arrowLeft"] = 93] = "arrowLeft";
	    FAIconName[FAIconName["arrowRight"] = 94] = "arrowRight";
	    FAIconName[FAIconName["arrowUp"] = 95] = "arrowUp";
	    FAIconName[FAIconName["arrowDown"] = 96] = "arrowDown";
	    FAIconName[FAIconName["mailForward"] = 97] = "mailForward";
	    FAIconName[FAIconName["shareAlt"] = 98] = "shareAlt";
	    FAIconName[FAIconName["resizeFull"] = 99] = "resizeFull";
	    FAIconName[FAIconName["resizeSmall"] = 100] = "resizeSmall";
	    FAIconName[FAIconName["plus"] = 101] = "plus";
	    FAIconName[FAIconName["minus"] = 102] = "minus";
	    FAIconName[FAIconName["asterisk"] = 103] = "asterisk";
	    FAIconName[FAIconName["exclamationSign"] = 104] = "exclamationSign";
	    FAIconName[FAIconName["gift"] = 105] = "gift";
	    FAIconName[FAIconName["leaf"] = 106] = "leaf";
	    FAIconName[FAIconName["fire"] = 107] = "fire";
	    FAIconName[FAIconName["eyeOpen"] = 108] = "eyeOpen";
	    FAIconName[FAIconName["eyeClose"] = 109] = "eyeClose";
	    FAIconName[FAIconName["warningSign"] = 110] = "warningSign";
	    FAIconName[FAIconName["plane"] = 111] = "plane";
	    FAIconName[FAIconName["calendar"] = 112] = "calendar";
	    FAIconName[FAIconName["random"] = 113] = "random";
	    FAIconName[FAIconName["comment"] = 114] = "comment";
	    FAIconName[FAIconName["magnet"] = 115] = "magnet";
	    FAIconName[FAIconName["chevronUp"] = 116] = "chevronUp";
	    FAIconName[FAIconName["chevronDown"] = 117] = "chevronDown";
	    FAIconName[FAIconName["retweet"] = 118] = "retweet";
	    FAIconName[FAIconName["shoppingCart"] = 119] = "shoppingCart";
	    FAIconName[FAIconName["folderClose"] = 120] = "folderClose";
	    FAIconName[FAIconName["folderOpen"] = 121] = "folderOpen";
	    FAIconName[FAIconName["resizeVertical"] = 122] = "resizeVertical";
	    FAIconName[FAIconName["resizeHorizontal"] = 123] = "resizeHorizontal";
	    FAIconName[FAIconName["barChart"] = 124] = "barChart";
	    FAIconName[FAIconName["twitterSign"] = 125] = "twitterSign";
	    FAIconName[FAIconName["facebookSign"] = 126] = "facebookSign";
	    FAIconName[FAIconName["cameraRetro"] = 127] = "cameraRetro";
	    FAIconName[FAIconName["key"] = 128] = "key";
	    FAIconName[FAIconName["gears"] = 129] = "gears";
	    FAIconName[FAIconName["cogs"] = 130] = "cogs";
	    FAIconName[FAIconName["comments"] = 131] = "comments";
	    FAIconName[FAIconName["thumbsUpAlt"] = 132] = "thumbsUpAlt";
	    FAIconName[FAIconName["thumbsDownAlt"] = 133] = "thumbsDownAlt";
	    FAIconName[FAIconName["starHalf"] = 134] = "starHalf";
	    FAIconName[FAIconName["heartEmpty"] = 135] = "heartEmpty";
	    FAIconName[FAIconName["signout"] = 136] = "signout";
	    FAIconName[FAIconName["linkedinSign"] = 137] = "linkedinSign";
	    FAIconName[FAIconName["pushpin"] = 138] = "pushpin";
	    FAIconName[FAIconName["externalLink"] = 139] = "externalLink";
	    FAIconName[FAIconName["signin"] = 140] = "signin";
	    FAIconName[FAIconName["trophy"] = 141] = "trophy";
	    FAIconName[FAIconName["githubSign"] = 142] = "githubSign";
	    FAIconName[FAIconName["uploadAlt"] = 143] = "uploadAlt";
	    FAIconName[FAIconName["lemon"] = 144] = "lemon";
	    FAIconName[FAIconName["phone"] = 145] = "phone";
	    FAIconName[FAIconName["unchecked"] = 146] = "unchecked";
	    FAIconName[FAIconName["checkEmpty"] = 147] = "checkEmpty";
	    FAIconName[FAIconName["bookmarkEmpty"] = 148] = "bookmarkEmpty";
	    FAIconName[FAIconName["phoneSign"] = 149] = "phoneSign";
	    FAIconName[FAIconName["twitter"] = 150] = "twitter";
	    FAIconName[FAIconName["facebook"] = 151] = "facebook";
	    FAIconName[FAIconName["github"] = 152] = "github";
	    FAIconName[FAIconName["unlock"] = 153] = "unlock";
	    FAIconName[FAIconName["creditCard"] = 154] = "creditCard";
	    FAIconName[FAIconName["rss"] = 155] = "rss";
	    FAIconName[FAIconName["hdd"] = 156] = "hdd";
	    FAIconName[FAIconName["bullhorn"] = 157] = "bullhorn";
	    FAIconName[FAIconName["bell"] = 158] = "bell";
	    FAIconName[FAIconName["certificate"] = 159] = "certificate";
	    FAIconName[FAIconName["handRight"] = 160] = "handRight";
	    FAIconName[FAIconName["handLeft"] = 161] = "handLeft";
	    FAIconName[FAIconName["handUp"] = 162] = "handUp";
	    FAIconName[FAIconName["handDown"] = 163] = "handDown";
	    FAIconName[FAIconName["circleArrowLeft"] = 164] = "circleArrowLeft";
	    FAIconName[FAIconName["circleArrowRight"] = 165] = "circleArrowRight";
	    FAIconName[FAIconName["circleArrowUp"] = 166] = "circleArrowUp";
	    FAIconName[FAIconName["circleArrowDown"] = 167] = "circleArrowDown";
	    FAIconName[FAIconName["globe"] = 168] = "globe";
	    FAIconName[FAIconName["wrench"] = 169] = "wrench";
	    FAIconName[FAIconName["tasks"] = 170] = "tasks";
	    FAIconName[FAIconName["filter"] = 171] = "filter";
	    FAIconName[FAIconName["briefcase"] = 172] = "briefcase";
	    FAIconName[FAIconName["fullscreen"] = 173] = "fullscreen";
	    FAIconName[FAIconName["group"] = 174] = "group";
	    FAIconName[FAIconName["link"] = 175] = "link";
	    FAIconName[FAIconName["cloud"] = 176] = "cloud";
	    FAIconName[FAIconName["beaker"] = 177] = "beaker";
	    FAIconName[FAIconName["cut"] = 178] = "cut";
	    FAIconName[FAIconName["copy"] = 179] = "copy";
	    FAIconName[FAIconName["paperclip"] = 180] = "paperclip";
	    FAIconName[FAIconName["paperClip"] = 181] = "paperClip";
	    FAIconName[FAIconName["save"] = 182] = "save";
	    FAIconName[FAIconName["signBlank"] = 183] = "signBlank";
	    FAIconName[FAIconName["reorder"] = 184] = "reorder";
	    FAIconName[FAIconName["listUl"] = 185] = "listUl";
	    FAIconName[FAIconName["listOl"] = 186] = "listOl";
	    FAIconName[FAIconName["strikethrough"] = 187] = "strikethrough";
	    FAIconName[FAIconName["underline"] = 188] = "underline";
	    FAIconName[FAIconName["table"] = 189] = "table";
	    FAIconName[FAIconName["magic"] = 190] = "magic";
	    FAIconName[FAIconName["truck"] = 191] = "truck";
	    FAIconName[FAIconName["pinterest"] = 192] = "pinterest";
	    FAIconName[FAIconName["pinterestSign"] = 193] = "pinterestSign";
	    FAIconName[FAIconName["googlePlusSign"] = 194] = "googlePlusSign";
	    FAIconName[FAIconName["googlePlus"] = 195] = "googlePlus";
	    FAIconName[FAIconName["money"] = 196] = "money";
	    FAIconName[FAIconName["caretDown"] = 197] = "caretDown";
	    FAIconName[FAIconName["caretUp"] = 198] = "caretUp";
	    FAIconName[FAIconName["caretLeft"] = 199] = "caretLeft";
	    FAIconName[FAIconName["caretRight"] = 200] = "caretRight";
	    FAIconName[FAIconName["columns"] = 201] = "columns";
	    FAIconName[FAIconName["sort"] = 202] = "sort";
	    FAIconName[FAIconName["sortDown"] = 203] = "sortDown";
	    FAIconName[FAIconName["sortUp"] = 204] = "sortUp";
	    FAIconName[FAIconName["envelope"] = 205] = "envelope";
	    FAIconName[FAIconName["linkedin"] = 206] = "linkedin";
	    FAIconName[FAIconName["rotateLeft"] = 207] = "rotateLeft";
	    FAIconName[FAIconName["undo"] = 208] = "undo";
	    FAIconName[FAIconName["legal"] = 209] = "legal";
	    FAIconName[FAIconName["dashboard"] = 210] = "dashboard";
	    FAIconName[FAIconName["commentAlt"] = 211] = "commentAlt";
	    FAIconName[FAIconName["commentsAlt"] = 212] = "commentsAlt";
	    FAIconName[FAIconName["bolt"] = 213] = "bolt";
	    FAIconName[FAIconName["sitemap"] = 214] = "sitemap";
	    FAIconName[FAIconName["umbrella"] = 215] = "umbrella";
	    FAIconName[FAIconName["paste"] = 216] = "paste";
	    FAIconName[FAIconName["lightbulb"] = 217] = "lightbulb";
	    FAIconName[FAIconName["exchange"] = 218] = "exchange";
	    FAIconName[FAIconName["cloudDownload"] = 219] = "cloudDownload";
	    FAIconName[FAIconName["cloudUpload"] = 220] = "cloudUpload";
	    FAIconName[FAIconName["userMd"] = 221] = "userMd";
	    FAIconName[FAIconName["stethoscope"] = 222] = "stethoscope";
	    FAIconName[FAIconName["suitcase"] = 223] = "suitcase";
	    FAIconName[FAIconName["bellAlt"] = 224] = "bellAlt";
	    FAIconName[FAIconName["coffee"] = 225] = "coffee";
	    FAIconName[FAIconName["food"] = 226] = "food";
	    FAIconName[FAIconName["fileTextAlt"] = 227] = "fileTextAlt";
	    FAIconName[FAIconName["building"] = 228] = "building";
	    FAIconName[FAIconName["hospital"] = 229] = "hospital";
	    FAIconName[FAIconName["ambulance"] = 230] = "ambulance";
	    FAIconName[FAIconName["medkit"] = 231] = "medkit";
	    FAIconName[FAIconName["fighterJet"] = 232] = "fighterJet";
	    FAIconName[FAIconName["beer"] = 233] = "beer";
	    FAIconName[FAIconName["hSign"] = 234] = "hSign";
	    FAIconName[FAIconName["plusSignAlt"] = 235] = "plusSignAlt";
	    FAIconName[FAIconName["doubleAngleLeft"] = 236] = "doubleAngleLeft";
	    FAIconName[FAIconName["doubleAngleRight"] = 237] = "doubleAngleRight";
	    FAIconName[FAIconName["doubleAngleUp"] = 238] = "doubleAngleUp";
	    FAIconName[FAIconName["doubleAngleDown"] = 239] = "doubleAngleDown";
	    FAIconName[FAIconName["angleLeft"] = 240] = "angleLeft";
	    FAIconName[FAIconName["angleRight"] = 241] = "angleRight";
	    FAIconName[FAIconName["angleUp"] = 242] = "angleUp";
	    FAIconName[FAIconName["angleDown"] = 243] = "angleDown";
	    FAIconName[FAIconName["desktop"] = 244] = "desktop";
	    FAIconName[FAIconName["laptop"] = 245] = "laptop";
	    FAIconName[FAIconName["tablet"] = 246] = "tablet";
	    FAIconName[FAIconName["mobilePhone"] = 247] = "mobilePhone";
	    FAIconName[FAIconName["circleBlank"] = 248] = "circleBlank";
	    FAIconName[FAIconName["quoteLeft"] = 249] = "quoteLeft";
	    FAIconName[FAIconName["quoteRight"] = 250] = "quoteRight";
	    FAIconName[FAIconName["spinner"] = 251] = "spinner";
	    FAIconName[FAIconName["circle"] = 252] = "circle";
	    FAIconName[FAIconName["mailReply"] = 253] = "mailReply";
	    FAIconName[FAIconName["reply"] = 254] = "reply";
	    FAIconName[FAIconName["githubAlt"] = 255] = "githubAlt";
	    FAIconName[FAIconName["folderCloseAlt"] = 256] = "folderCloseAlt";
	    FAIconName[FAIconName["folderOpenAlt"] = 257] = "folderOpenAlt";
	    FAIconName[FAIconName["expandAlt"] = 258] = "expandAlt";
	    FAIconName[FAIconName["collapseAlt"] = 259] = "collapseAlt";
	    FAIconName[FAIconName["smile"] = 260] = "smile";
	    FAIconName[FAIconName["frown"] = 261] = "frown";
	    FAIconName[FAIconName["meh"] = 262] = "meh";
	    FAIconName[FAIconName["gamepad"] = 263] = "gamepad";
	    FAIconName[FAIconName["keyboard"] = 264] = "keyboard";
	    FAIconName[FAIconName["flagAlt"] = 265] = "flagAlt";
	    FAIconName[FAIconName["flagCheckered"] = 266] = "flagCheckered";
	    FAIconName[FAIconName["terminal"] = 267] = "terminal";
	    FAIconName[FAIconName["code"] = 268] = "code";
	    FAIconName[FAIconName["replyAll"] = 269] = "replyAll";
	    FAIconName[FAIconName["mailReplyAll"] = 270] = "mailReplyAll";
	    FAIconName[FAIconName["starHalfFull"] = 271] = "starHalfFull";
	    FAIconName[FAIconName["starHalfEmpty"] = 272] = "starHalfEmpty";
	    FAIconName[FAIconName["locationArrow"] = 273] = "locationArrow";
	    FAIconName[FAIconName["crop"] = 274] = "crop";
	    FAIconName[FAIconName["codeFork"] = 275] = "codeFork";
	    FAIconName[FAIconName["unlink"] = 276] = "unlink";
	    FAIconName[FAIconName["question"] = 277] = "question";
	    FAIconName[FAIconName["info"] = 278] = "info";
	    FAIconName[FAIconName["exclamation"] = 279] = "exclamation";
	    FAIconName[FAIconName["superscript"] = 280] = "superscript";
	    FAIconName[FAIconName["subscript"] = 281] = "subscript";
	    FAIconName[FAIconName["eraser"] = 282] = "eraser";
	    FAIconName[FAIconName["puzzlePiece"] = 283] = "puzzlePiece";
	    FAIconName[FAIconName["microphone"] = 284] = "microphone";
	    FAIconName[FAIconName["microphoneOff"] = 285] = "microphoneOff";
	    FAIconName[FAIconName["shield"] = 286] = "shield";
	    FAIconName[FAIconName["calendarEmpty"] = 287] = "calendarEmpty";
	    FAIconName[FAIconName["fireExtinguisher"] = 288] = "fireExtinguisher";
	    FAIconName[FAIconName["rocket"] = 289] = "rocket";
	    FAIconName[FAIconName["maxcdn"] = 290] = "maxcdn";
	    FAIconName[FAIconName["chevronSignLeft"] = 291] = "chevronSignLeft";
	    FAIconName[FAIconName["chevronSignRight"] = 292] = "chevronSignRight";
	    FAIconName[FAIconName["chevronSignUp"] = 293] = "chevronSignUp";
	    FAIconName[FAIconName["chevronSignDown"] = 294] = "chevronSignDown";
	    FAIconName[FAIconName["html5"] = 295] = "html5";
	    FAIconName[FAIconName["css3"] = 296] = "css3";
	    FAIconName[FAIconName["anchor"] = 297] = "anchor";
	    FAIconName[FAIconName["unlockAlt"] = 298] = "unlockAlt";
	    FAIconName[FAIconName["bullseye"] = 299] = "bullseye";
	    FAIconName[FAIconName["ellipsisHorizontal"] = 300] = "ellipsisHorizontal";
	    FAIconName[FAIconName["ellipsisVertical"] = 301] = "ellipsisVertical";
	    FAIconName[FAIconName["rssSign"] = 302] = "rssSign";
	    FAIconName[FAIconName["playSign"] = 303] = "playSign";
	    FAIconName[FAIconName["ticket"] = 304] = "ticket";
	    FAIconName[FAIconName["minusSignAlt"] = 305] = "minusSignAlt";
	    FAIconName[FAIconName["checkMinus"] = 306] = "checkMinus";
	    FAIconName[FAIconName["levelUp"] = 307] = "levelUp";
	    FAIconName[FAIconName["levelDown"] = 308] = "levelDown";
	    FAIconName[FAIconName["checkSign"] = 309] = "checkSign";
	    FAIconName[FAIconName["editSign"] = 310] = "editSign";
	    FAIconName[FAIconName["externalLinkSign"] = 311] = "externalLinkSign";
	    FAIconName[FAIconName["shareSign"] = 312] = "shareSign";
	    FAIconName[FAIconName["compass"] = 313] = "compass";
	    FAIconName[FAIconName["collapse"] = 314] = "collapse";
	    FAIconName[FAIconName["collapseTop"] = 315] = "collapseTop";
	    FAIconName[FAIconName["expand"] = 316] = "expand";
	    FAIconName[FAIconName["euro"] = 317] = "euro";
	    FAIconName[FAIconName["eur"] = 318] = "eur";
	    FAIconName[FAIconName["gbp"] = 319] = "gbp";
	    FAIconName[FAIconName["dollar"] = 320] = "dollar";
	    FAIconName[FAIconName["usd"] = 321] = "usd";
	    FAIconName[FAIconName["rupee"] = 322] = "rupee";
	    FAIconName[FAIconName["inr"] = 323] = "inr";
	    FAIconName[FAIconName["yen"] = 324] = "yen";
	    FAIconName[FAIconName["jpy"] = 325] = "jpy";
	    FAIconName[FAIconName["renminbi"] = 326] = "renminbi";
	    FAIconName[FAIconName["cny"] = 327] = "cny";
	    FAIconName[FAIconName["won"] = 328] = "won";
	    FAIconName[FAIconName["krw"] = 329] = "krw";
	    FAIconName[FAIconName["bitcoin"] = 330] = "bitcoin";
	    FAIconName[FAIconName["btc"] = 331] = "btc";
	    FAIconName[FAIconName["file"] = 332] = "file";
	    FAIconName[FAIconName["fileText"] = 333] = "fileText";
	    FAIconName[FAIconName["sortByAlphabet"] = 334] = "sortByAlphabet";
	    FAIconName[FAIconName["sortByAlphabetAlt"] = 335] = "sortByAlphabetAlt";
	    FAIconName[FAIconName["sortByAttributes"] = 336] = "sortByAttributes";
	    FAIconName[FAIconName["sortByAttributesAlt"] = 337] = "sortByAttributesAlt";
	    FAIconName[FAIconName["sortByOrder"] = 338] = "sortByOrder";
	    FAIconName[FAIconName["sortByOrderAlt"] = 339] = "sortByOrderAlt";
	    FAIconName[FAIconName["thumbsUp"] = 340] = "thumbsUp";
	    FAIconName[FAIconName["thumbsDown"] = 341] = "thumbsDown";
	    FAIconName[FAIconName["youtubeSign"] = 342] = "youtubeSign";
	    FAIconName[FAIconName["youtube"] = 343] = "youtube";
	    FAIconName[FAIconName["xing"] = 344] = "xing";
	    FAIconName[FAIconName["xingSign"] = 345] = "xingSign";
	    FAIconName[FAIconName["youtubePlay"] = 346] = "youtubePlay";
	    FAIconName[FAIconName["dropbox"] = 347] = "dropbox";
	    FAIconName[FAIconName["stackexchange"] = 348] = "stackexchange";
	    FAIconName[FAIconName["instagram"] = 349] = "instagram";
	    FAIconName[FAIconName["flickr"] = 350] = "flickr";
	    FAIconName[FAIconName["adn"] = 351] = "adn";
	    FAIconName[FAIconName["bitbucket"] = 352] = "bitbucket";
	    FAIconName[FAIconName["bitbucketSign"] = 353] = "bitbucketSign";
	    FAIconName[FAIconName["tumblr"] = 354] = "tumblr";
	    FAIconName[FAIconName["tumblrSign"] = 355] = "tumblrSign";
	    FAIconName[FAIconName["longArrowDown"] = 356] = "longArrowDown";
	    FAIconName[FAIconName["longArrowUp"] = 357] = "longArrowUp";
	    FAIconName[FAIconName["longArrowLeft"] = 358] = "longArrowLeft";
	    FAIconName[FAIconName["longArrowRight"] = 359] = "longArrowRight";
	    FAIconName[FAIconName["apple"] = 360] = "apple";
	    FAIconName[FAIconName["windows"] = 361] = "windows";
	    FAIconName[FAIconName["android"] = 362] = "android";
	    FAIconName[FAIconName["linux"] = 363] = "linux";
	    FAIconName[FAIconName["dribbble"] = 364] = "dribbble";
	    FAIconName[FAIconName["skype"] = 365] = "skype";
	    FAIconName[FAIconName["foursquare"] = 366] = "foursquare";
	    FAIconName[FAIconName["trello"] = 367] = "trello";
	    FAIconName[FAIconName["female"] = 368] = "female";
	    FAIconName[FAIconName["male"] = 369] = "male";
	    FAIconName[FAIconName["gittip"] = 370] = "gittip";
	    FAIconName[FAIconName["sun"] = 371] = "sun";
	    FAIconName[FAIconName["moon"] = 372] = "moon";
	    FAIconName[FAIconName["archive"] = 373] = "archive";
	    FAIconName[FAIconName["bug"] = 374] = "bug";
	    FAIconName[FAIconName["vk"] = 375] = "vk";
	    FAIconName[FAIconName["weibo"] = 376] = "weibo";
	    FAIconName[FAIconName["renren"] = 377] = "renren";
	    FAIconName[FAIconName["copyright"] = 378] = "copyright";
	    FAIconName[FAIconName["at"] = 379] = "at";
	    FAIconName[FAIconName["infoCircle"] = 380] = "infoCircle";
	})(FAIconName = exports.FAIconName || (exports.FAIconName = {}));
	function toFontAwesomeCharCode(iconName) {
	    switch (iconName) {
	        case FAIconName.glass: return "\uf000";
	        case FAIconName.music: return "\uf001";
	        case FAIconName.search: return "\uf002";
	        case FAIconName.envelopeAlt: return "\uf003";
	        case FAIconName.heart: return "\uf004";
	        case FAIconName.star: return "\uf005";
	        case FAIconName.starEmpty: return "\uf006";
	        case FAIconName.user: return "\uf007";
	        case FAIconName.film: return "\uf008";
	        case FAIconName.thLarge: return "\uf009";
	        case FAIconName.th: return "\uf00a";
	        case FAIconName.thList: return "\uf00b";
	        case FAIconName.ok: return "\uf00c";
	        case FAIconName.remove: return "\uf00d";
	        case FAIconName.zoomIn: return "\uf00e";
	        case FAIconName.zoomOut: return "\uf010";
	        case FAIconName.powerOff:
	        case FAIconName.off: return "\uf011";
	        case FAIconName.signal: return "\uf012";
	        case FAIconName.gear:
	        case FAIconName.cog: return "\uf013";
	        case FAIconName.trash: return "\uf014";
	        case FAIconName.home: return "\uf015";
	        case FAIconName.fileAlt: return "\uf016";
	        case FAIconName.time: return "\uf017";
	        case FAIconName.road: return "\uf018";
	        case FAIconName.downloadAlt: return "\uf019";
	        case FAIconName.download: return "\uf01a";
	        case FAIconName.upload: return "\uf01b";
	        case FAIconName.inbox: return "\uf01c";
	        case FAIconName.playCircle: return "\uf01d";
	        case FAIconName.rotateRight:
	        case FAIconName.repeat: return "\uf01e";
	        case FAIconName.refresh: return "\uf021";
	        case FAIconName.listAlt: return "\uf022";
	        case FAIconName.lock: return "\uf023";
	        case FAIconName.flag: return "\uf024";
	        case FAIconName.headphones: return "\uf025";
	        case FAIconName.volumeOff: return "\uf026";
	        case FAIconName.volumeDown: return "\uf027";
	        case FAIconName.volumeUp: return "\uf028";
	        case FAIconName.qrcode: return "\uf029";
	        case FAIconName.barcode: return "\uf02a";
	        case FAIconName.tag: return "\uf02b";
	        case FAIconName.tags: return "\uf02c";
	        case FAIconName.book: return "\uf02d";
	        case FAIconName.bookmark: return "\uf02e";
	        case FAIconName.print: return "\uf02f";
	        case FAIconName.camera: return "\uf030";
	        case FAIconName.font: return "\uf031";
	        case FAIconName.bold: return "\uf032";
	        case FAIconName.italic: return "\uf033";
	        case FAIconName.textHeight: return "\uf034";
	        case FAIconName.textWidth: return "\uf035";
	        case FAIconName.alignLeft: return "\uf036";
	        case FAIconName.alignCenter: return "\uf037";
	        case FAIconName.alignRight: return "\uf038";
	        case FAIconName.alignJustify: return "\uf039";
	        case FAIconName.list: return "\uf03a";
	        case FAIconName.indentLeft: return "\uf03b";
	        case FAIconName.indentRight: return "\uf03c";
	        case FAIconName.facetimeVideo: return "\uf03d";
	        case FAIconName.picture: return "\uf03e";
	        case FAIconName.pencil: return "\uf040";
	        case FAIconName.mapMarker: return "\uf041";
	        case FAIconName.adjust: return "\uf042";
	        case FAIconName.tint: return "\uf043";
	        case FAIconName.edit: return "\uf044";
	        case FAIconName.share: return "\uf045";
	        case FAIconName.check: return "\uf046";
	        case FAIconName.move: return "\uf047";
	        case FAIconName.stepBackward: return "\uf048";
	        case FAIconName.fastBackward: return "\uf049";
	        case FAIconName.backward: return "\uf04a";
	        case FAIconName.play: return "\uf04b";
	        case FAIconName.pause: return "\uf04c";
	        case FAIconName.stop: return "\uf04d";
	        case FAIconName.forward: return "\uf04e";
	        case FAIconName.fastForward: return "\uf050";
	        case FAIconName.stepForward: return "\uf051";
	        case FAIconName.eject: return "\uf052";
	        case FAIconName.chevronLeft: return "\uf053";
	        case FAIconName.chevronRight: return "\uf054";
	        case FAIconName.plusSign: return "\uf055";
	        case FAIconName.minusSign: return "\uf056";
	        case FAIconName.removeSign: return "\uf057";
	        case FAIconName.okSign: return "\uf058";
	        case FAIconName.questionSign: return "\uf059";
	        case FAIconName.infoSign: return "\uf05a";
	        case FAIconName.screenshot: return "\uf05b";
	        case FAIconName.removeCircle: return "\uf05c";
	        case FAIconName.okCircle: return "\uf05d";
	        case FAIconName.banCircle: return "\uf05e";
	        case FAIconName.arrowLeft: return "\uf060";
	        case FAIconName.arrowRight: return "\uf061";
	        case FAIconName.arrowUp: return "\uf062";
	        case FAIconName.arrowDown: return "\uf063";
	        case FAIconName.mailForward:
	        case FAIconName.shareAlt: return "\uf064";
	        case FAIconName.resizeFull: return "\uf065";
	        case FAIconName.resizeSmall: return "\uf066";
	        case FAIconName.plus: return "\uf067";
	        case FAIconName.minus: return "\uf068";
	        case FAIconName.asterisk: return "\uf069";
	        case FAIconName.exclamationSign: return "\uf06a";
	        case FAIconName.gift: return "\uf06b";
	        case FAIconName.leaf: return "\uf06c";
	        case FAIconName.fire: return "\uf06d";
	        case FAIconName.eyeOpen: return "\uf06e";
	        case FAIconName.eyeClose: return "\uf070";
	        case FAIconName.warningSign: return "\uf071";
	        case FAIconName.plane: return "\uf072";
	        case FAIconName.calendar: return "\uf073";
	        case FAIconName.random: return "\uf074";
	        case FAIconName.comment: return "\uf075";
	        case FAIconName.magnet: return "\uf076";
	        case FAIconName.chevronUp: return "\uf077";
	        case FAIconName.chevronDown: return "\uf078";
	        case FAIconName.retweet: return "\uf079";
	        case FAIconName.shoppingCart: return "\uf07a";
	        case FAIconName.folderClose: return "\uf07b";
	        case FAIconName.folderOpen: return "\uf07c";
	        case FAIconName.resizeVertical: return "\uf07d";
	        case FAIconName.resizeHorizontal: return "\uf07e";
	        case FAIconName.barChart: return "\uf080";
	        case FAIconName.twitterSign: return "\uf081";
	        case FAIconName.facebookSign: return "\uf082";
	        case FAIconName.cameraRetro: return "\uf083";
	        case FAIconName.key: return "\uf084";
	        case FAIconName.gears:
	        case FAIconName.cogs: return "\uf085";
	        case FAIconName.comments: return "\uf086";
	        case FAIconName.thumbsUpAlt: return "\uf087";
	        case FAIconName.thumbsDownAlt: return "\uf088";
	        case FAIconName.starHalf: return "\uf089";
	        case FAIconName.heartEmpty: return "\uf08a";
	        case FAIconName.signout: return "\uf08b";
	        case FAIconName.linkedinSign: return "\uf08c";
	        case FAIconName.pushpin: return "\uf08d";
	        case FAIconName.externalLink: return "\uf08e";
	        case FAIconName.signin: return "\uf090";
	        case FAIconName.trophy: return "\uf091";
	        case FAIconName.githubSign: return "\uf092";
	        case FAIconName.uploadAlt: return "\uf093";
	        case FAIconName.lemon: return "\uf094";
	        case FAIconName.phone: return "\uf095";
	        case FAIconName.unchecked:
	        case FAIconName.checkEmpty: return "\uf096";
	        case FAIconName.bookmarkEmpty: return "\uf097";
	        case FAIconName.phoneSign: return "\uf098";
	        case FAIconName.twitter: return "\uf099";
	        case FAIconName.facebook: return "\uf09a";
	        case FAIconName.github: return "\uf09b";
	        case FAIconName.unlock: return "\uf09c";
	        case FAIconName.creditCard: return "\uf09d";
	        case FAIconName.rss: return "\uf09e";
	        case FAIconName.hdd: return "\uf0a0";
	        case FAIconName.bullhorn: return "\uf0a1";
	        case FAIconName.bell: return "\uf0a2";
	        case FAIconName.certificate: return "\uf0a3";
	        case FAIconName.handRight: return "\uf0a4";
	        case FAIconName.handLeft: return "\uf0a5";
	        case FAIconName.handUp: return "\uf0a6";
	        case FAIconName.handDown: return "\uf0a7";
	        case FAIconName.circleArrowLeft: return "\uf0a8";
	        case FAIconName.circleArrowRight: return "\uf0a9";
	        case FAIconName.circleArrowUp: return "\uf0aa";
	        case FAIconName.circleArrowDown: return "\uf0ab";
	        case FAIconName.globe: return "\uf0ac";
	        case FAIconName.wrench: return "\uf0ad";
	        case FAIconName.tasks: return "\uf0ae";
	        case FAIconName.filter: return "\uf0b0";
	        case FAIconName.briefcase: return "\uf0b1";
	        case FAIconName.fullscreen: return "\uf0b2";
	        case FAIconName.group: return "\uf0c0";
	        case FAIconName.link: return "\uf0c1";
	        case FAIconName.cloud: return "\uf0c2";
	        case FAIconName.beaker: return "\uf0c3";
	        case FAIconName.cut: return "\uf0c4";
	        case FAIconName.copy: return "\uf0c5";
	        case FAIconName.paperclip:
	        case FAIconName.paperClip: return "\uf0c6";
	        case FAIconName.save: return "\uf0c7";
	        case FAIconName.signBlank: return "\uf0c8";
	        case FAIconName.reorder: return "\uf0c9";
	        case FAIconName.listUl: return "\uf0ca";
	        case FAIconName.listOl: return "\uf0cb";
	        case FAIconName.strikethrough: return "\uf0cc";
	        case FAIconName.underline: return "\uf0cd";
	        case FAIconName.table: return "\uf0ce";
	        case FAIconName.magic: return "\uf0d0";
	        case FAIconName.truck: return "\uf0d1";
	        case FAIconName.pinterest: return "\uf0d2";
	        case FAIconName.pinterestSign: return "\uf0d3";
	        case FAIconName.googlePlusSign: return "\uf0d4";
	        case FAIconName.googlePlus: return "\uf0d5";
	        case FAIconName.money: return "\uf0d6";
	        case FAIconName.caretDown: return "\uf0d7";
	        case FAIconName.caretUp: return "\uf0d8";
	        case FAIconName.caretLeft: return "\uf0d9";
	        case FAIconName.caretRight: return "\uf0da";
	        case FAIconName.columns: return "\uf0db";
	        case FAIconName.sort: return "\uf0dc";
	        case FAIconName.sortDown: return "\uf0dd";
	        case FAIconName.sortUp: return "\uf0de";
	        case FAIconName.envelope: return "\uf0e0";
	        case FAIconName.linkedin: return "\uf0e1";
	        case FAIconName.rotateLeft:
	        case FAIconName.undo: return "\uf0e2";
	        case FAIconName.legal: return "\uf0e3";
	        case FAIconName.dashboard: return "\uf0e4";
	        case FAIconName.commentAlt: return "\uf0e5";
	        case FAIconName.commentsAlt: return "\uf0e6";
	        case FAIconName.bolt: return "\uf0e7";
	        case FAIconName.sitemap: return "\uf0e8";
	        case FAIconName.umbrella: return "\uf0e9";
	        case FAIconName.paste: return "\uf0ea";
	        case FAIconName.lightbulb: return "\uf0eb";
	        case FAIconName.exchange: return "\uf0ec";
	        case FAIconName.cloudDownload: return "\uf0ed";
	        case FAIconName.cloudUpload: return "\uf0ee";
	        case FAIconName.userMd: return "\uf0f0";
	        case FAIconName.stethoscope: return "\uf0f1";
	        case FAIconName.suitcase: return "\uf0f2";
	        case FAIconName.bellAlt: return "\uf0f3";
	        case FAIconName.coffee: return "\uf0f4";
	        case FAIconName.food: return "\uf0f5";
	        case FAIconName.fileTextAlt: return "\uf0f6";
	        case FAIconName.building: return "\uf0f7";
	        case FAIconName.hospital: return "\uf0f8";
	        case FAIconName.ambulance: return "\uf0f9";
	        case FAIconName.medkit: return "\uf0fa";
	        case FAIconName.fighterJet: return "\uf0fb";
	        case FAIconName.beer: return "\uf0fc";
	        case FAIconName.hSign: return "\uf0fd";
	        case FAIconName.plusSignAlt: return "\uf0fe";
	        case FAIconName.doubleAngleLeft: return "\uf100";
	        case FAIconName.doubleAngleRight: return "\uf101";
	        case FAIconName.doubleAngleUp: return "\uf102";
	        case FAIconName.doubleAngleDown: return "\uf103";
	        case FAIconName.angleLeft: return "\uf104";
	        case FAIconName.angleRight: return "\uf105";
	        case FAIconName.angleUp: return "\uf106";
	        case FAIconName.angleDown: return "\uf107";
	        case FAIconName.desktop: return "\uf108";
	        case FAIconName.laptop: return "\uf109";
	        case FAIconName.tablet: return "\uf10a";
	        case FAIconName.mobilePhone: return "\uf10b";
	        case FAIconName.circleBlank: return "\uf10c";
	        case FAIconName.quoteLeft: return "\uf10d";
	        case FAIconName.quoteRight: return "\uf10e";
	        case FAIconName.spinner: return "\uf110";
	        case FAIconName.circle: return "\uf111";
	        case FAIconName.mailReply:
	        case FAIconName.reply: return "\uf112";
	        case FAIconName.githubAlt: return "\uf113";
	        case FAIconName.folderCloseAlt: return "\uf114";
	        case FAIconName.folderOpenAlt: return "\uf115";
	        case FAIconName.expandAlt: return "\uf116";
	        case FAIconName.collapseAlt: return "\uf117";
	        case FAIconName.smile: return "\uf118";
	        case FAIconName.frown: return "\uf119";
	        case FAIconName.meh: return "\uf11a";
	        case FAIconName.gamepad: return "\uf11b";
	        case FAIconName.keyboard: return "\uf11c";
	        case FAIconName.flagAlt: return "\uf11d";
	        case FAIconName.flagCheckered: return "\uf11e";
	        case FAIconName.terminal: return "\uf120";
	        case FAIconName.code: return "\uf121";
	        case FAIconName.replyAll: return "\uf122";
	        case FAIconName.mailReplyAll: return "\uf122";
	        case FAIconName.starHalfFull:
	        case FAIconName.starHalfEmpty: return "\uf123";
	        case FAIconName.locationArrow: return "\uf124";
	        case FAIconName.crop: return "\uf125";
	        case FAIconName.codeFork: return "\uf126";
	        case FAIconName.unlink: return "\uf127";
	        case FAIconName.question: return "\uf128";
	        case FAIconName.info: return "\uf129";
	        case FAIconName.exclamation: return "\uf12a";
	        case FAIconName.superscript: return "\uf12b";
	        case FAIconName.subscript: return "\uf12c";
	        case FAIconName.eraser: return "\uf12d";
	        case FAIconName.puzzlePiece: return "\uf12e";
	        case FAIconName.microphone: return "\uf130";
	        case FAIconName.microphoneOff: return "\uf131";
	        case FAIconName.shield: return "\uf132";
	        case FAIconName.calendarEmpty: return "\uf133";
	        case FAIconName.fireExtinguisher: return "\uf134";
	        case FAIconName.rocket: return "\uf135";
	        case FAIconName.maxcdn: return "\uf136";
	        case FAIconName.chevronSignLeft: return "\uf137";
	        case FAIconName.chevronSignRight: return "\uf138";
	        case FAIconName.chevronSignUp: return "\uf139";
	        case FAIconName.chevronSignDown: return "\uf13a";
	        case FAIconName.html5: return "\uf13b";
	        case FAIconName.css3: return "\uf13c";
	        case FAIconName.anchor: return "\uf13d";
	        case FAIconName.unlockAlt: return "\uf13e";
	        case FAIconName.bullseye: return "\uf140";
	        case FAIconName.ellipsisHorizontal: return "\uf141";
	        case FAIconName.ellipsisVertical: return "\uf142";
	        case FAIconName.rssSign: return "\uf143";
	        case FAIconName.playSign: return "\uf144";
	        case FAIconName.ticket: return "\uf145";
	        case FAIconName.minusSignAlt: return "\uf146";
	        case FAIconName.checkMinus: return "\uf147";
	        case FAIconName.levelUp: return "\uf148";
	        case FAIconName.levelDown: return "\uf149";
	        case FAIconName.checkSign: return "\uf14a";
	        case FAIconName.editSign: return "\uf14b";
	        case FAIconName.externalLinkSign: return "\uf14c";
	        case FAIconName.shareSign: return "\uf14d";
	        case FAIconName.compass: return "\uf14e";
	        case FAIconName.collapse: return "\uf150";
	        case FAIconName.collapseTop: return "\uf151";
	        case FAIconName.expand: return "\uf152";
	        case FAIconName.euro:
	        case FAIconName.eur: return "\uf153";
	        case FAIconName.gbp: return "\uf154";
	        case FAIconName.dollar:
	        case FAIconName.usd: return "\uf155";
	        case FAIconName.rupee:
	        case FAIconName.inr: return "\uf156";
	        case FAIconName.yen:
	        case FAIconName.jpy: return "\uf157";
	        case FAIconName.renminbi:
	        case FAIconName.cny: return "\uf158";
	        case FAIconName.won:
	        case FAIconName.krw: return "\uf159";
	        case FAIconName.bitcoin:
	        case FAIconName.btc: return "\uf15a";
	        case FAIconName.file: return "\uf15b";
	        case FAIconName.fileText: return "\uf15c";
	        case FAIconName.sortByAlphabet: return "\uf15d";
	        case FAIconName.sortByAlphabetAlt: return "\uf15e";
	        case FAIconName.sortByAttributes: return "\uf160";
	        case FAIconName.sortByAttributesAlt: return "\uf161";
	        case FAIconName.sortByOrder: return "\uf162";
	        case FAIconName.sortByOrderAlt: return "\uf163";
	        case FAIconName.thumbsUp: return "\uf164";
	        case FAIconName.thumbsDown: return "\uf165";
	        case FAIconName.youtubeSign: return "\uf166";
	        case FAIconName.youtube: return "\uf167";
	        case FAIconName.xing: return "\uf168";
	        case FAIconName.xingSign: return "\uf169";
	        case FAIconName.youtubePlay: return "\uf16a";
	        case FAIconName.dropbox: return "\uf16b";
	        case FAIconName.stackexchange: return "\uf16c";
	        case FAIconName.instagram: return "\uf16d";
	        case FAIconName.flickr: return "\uf16e";
	        case FAIconName.adn: return "\uf170";
	        case FAIconName.bitbucket: return "\uf171";
	        case FAIconName.bitbucketSign: return "\uf172";
	        case FAIconName.tumblr: return "\uf173";
	        case FAIconName.tumblrSign: return "\uf174";
	        case FAIconName.longArrowDown: return "\uf175";
	        case FAIconName.longArrowUp: return "\uf176";
	        case FAIconName.longArrowLeft: return "\uf177";
	        case FAIconName.longArrowRight: return "\uf178";
	        case FAIconName.apple: return "\uf179";
	        case FAIconName.windows: return "\uf17a";
	        case FAIconName.android: return "\uf17b";
	        case FAIconName.linux: return "\uf17c";
	        case FAIconName.dribbble: return "\uf17d";
	        case FAIconName.skype: return "\uf17e";
	        case FAIconName.foursquare: return "\uf180";
	        case FAIconName.trello: return "\uf181";
	        case FAIconName.female: return "\uf182";
	        case FAIconName.male: return "\uf183";
	        case FAIconName.gittip: return "\uf184";
	        case FAIconName.sun: return "\uf185";
	        case FAIconName.moon: return "\uf186";
	        case FAIconName.archive: return "\uf187";
	        case FAIconName.bug: return "\uf188";
	        case FAIconName.vk: return "\uf189";
	        case FAIconName.weibo: return "\uf18a";
	        case FAIconName.renren: return "\uf18b";
	        case FAIconName.copyright: return "\uf1f9";
	        case FAIconName.at: return "\uf1fa";
	        case FAIconName.infoCircle: return '\uf05a';
	    }
	}
	exports.toFontAwesomeCharCode = toFontAwesomeCharCode;


/***/ },
/* 468 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Prevent the backspace key from navigating back.
	// http://stackoverflow.com/a/2768256/390330
	exports.preventBackspaceNav = function () {
	    document.addEventListener('keydown', function (event) {
	        var doPrevent = false;
	        if (event.keyCode === 8) {
	            var d = event.srcElement || event.target;
	            if ((d.tagName.toUpperCase() === 'INPUT' &&
	                (d.type.toUpperCase() === 'TEXT' ||
	                    d.type.toUpperCase() === 'PASSWORD' ||
	                    d.type.toUpperCase() === 'FILE' ||
	                    d.type.toUpperCase() === 'SEARCH' ||
	                    d.type.toUpperCase() === 'EMAIL' ||
	                    d.type.toUpperCase() === 'NUMBER' ||
	                    d.type.toUpperCase() === 'DATE')) ||
	                d.tagName.toUpperCase() === 'TEXTAREA') {
	                doPrevent = d.readOnly || d.disabled;
	            }
	            else {
	                doPrevent = true;
	            }
	        }
	        if (doPrevent) {
	            event.preventDefault();
	        }
	    });
	};


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ts = __webpack_require__(150);
	/**
	   * Remove the comments from a json like text.
	   * Comments can be single line comments (starting with # or //) or multiline comments using / * * /
	   *
	   * This method replace comment content by whitespace rather than completely remove them to keep positions in json parsing error reporting accurate.
	   */
	function removeComments(jsonText) {
	    var output = "";
	    var scanner = ts.createScanner(ts.ScriptTarget.ES5, /* skipTrivia */ false, ts.LanguageVariant.Standard, jsonText);
	    var token;
	    while ((token = scanner.scan()) !== ts.SyntaxKind.EndOfFileToken) {
	        switch (token) {
	            case ts.SyntaxKind.SingleLineCommentTrivia:
	            case ts.SyntaxKind.MultiLineCommentTrivia:
	                // replace comments with whitespace to preserve original character positions
	                output += scanner.getTokenText().replace(/\S/g, " ");
	                break;
	            default:
	                output += scanner.getTokenText();
	                break;
	        }
	    }
	    return output;
	}
	/**
	 * Over JSON.parse:
	 * * allows BOM
	 * * allows // /* # comments
	 * * provides a typed error detail on parse error
	 */
	function parse(str) {
	    var content = removeComments(stripBOM(str));
	    try {
	        return { data: json_parse(content) };
	    }
	    catch (e) {
	        var error = e;
	        var indexToPosition = function (index) {
	            var beforeLines = splitlines(content.substr(0, index));
	            return {
	                line: Math.max(beforeLines.length - 1, 0),
	                ch: Math.max(beforeLines[beforeLines.length - 1].length - 1, 0)
	            };
	        };
	        var fromIndex = Math.max(error.at - 1, 0);
	        var toIndex = Math.min(error.at + 1, content.length);
	        return {
	            error: {
	                message: e.message,
	                from: indexToPosition(fromIndex),
	                to: indexToPosition(toIndex),
	                preview: content.substring(fromIndex, toIndex - 1)
	            }
	        };
	    }
	}
	exports.parse = parse;
	function stringify(object, eol) {
	    if (eol === void 0) { eol = '\n'; }
	    var cache = [];
	    var value = JSON.stringify(object, 
	    // fixup circular reference
	    function (key, value) {
	        if (typeof value === 'object' && value !== null) {
	            if (cache.indexOf(value) !== -1) {
	                // Circular reference found, discard key
	                return;
	            }
	            // Store value in our collection
	            cache.push(value);
	        }
	        return value;
	    }, 
	    // indent 2 spaces
	    2);
	    value = value.split('\n').join(eol) + eol;
	    cache = null;
	    return value;
	}
	exports.stringify = stringify;
	function parseErrorToCodeError(filePath, error, source) {
	    return {
	        source: source,
	        filePath: filePath,
	        from: error.from,
	        to: error.to,
	        message: error.message,
	        preview: error.preview,
	        level: 'error'
	    };
	}
	exports.parseErrorToCodeError = parseErrorToCodeError;
	function stripBOM(str) {
	    // Catches EFBBBF (UTF-8 BOM) because the buffer-to-string
	    // conversion translates it to FEFF (UTF-16 BOM)
	    if (typeof str === 'string' && str.charCodeAt(0) === 0xFEFF) {
	        return str.slice(1);
	    }
	    return str;
	}
	function splitlines(string) { return string.split(/\r\n?|\n/); }
	;
	/**
	 * https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
	 * AS IT IS. ONLY MODIFIED WITH TYPE ASSERTSIONS / ANNOTATIONS
	 */
	var json_parse = (function () {
	    "use strict";
	    // This is a function that can parse a JSON text, producing a JavaScript
	    // data structure. It is a simple, recursive descent parser. It does not use
	    // eval or regular expressions, so it can be used as a model for implementing
	    // a JSON parser in other languages.
	    // We are defining the function inside of another function to avoid creating
	    // global variables.
	    var at, // The index of the current character
	    ch, // The current character
	    escapee = {
	        '"': '"',
	        '\\': '\\',
	        '/': '/',
	        b: '\b',
	        f: '\f',
	        n: '\n',
	        r: '\r',
	        t: '\t'
	    }, text, error = function (m) {
	        // Call error when something is wrong.
	        throw {
	            name: 'SyntaxError',
	            message: m,
	            at: at,
	            text: text
	        };
	    }, next = function (c) {
	        // If a c parameter is provided, verify that it matches the current character.
	        if (c && c !== ch) {
	            error("Expected '" + c + "' instead of '" + ch + "'");
	        }
	        // Get the next character. When there are no more characters,
	        // return the empty string.
	        ch = text.charAt(at);
	        at += 1;
	        return ch;
	    }, number = function () {
	        // Parse a number value.
	        var number, string = '';
	        if (ch === '-') {
	            string = '-';
	            next('-');
	        }
	        while (ch >= '0' && ch <= '9') {
	            string += ch;
	            next();
	        }
	        if (ch === '.') {
	            string += '.';
	            while (next() && ch >= '0' && ch <= '9') {
	                string += ch;
	            }
	        }
	        if (ch === 'e' || ch === 'E') {
	            string += ch;
	            next();
	            if (ch === '-' || ch === '+') {
	                string += ch;
	                next();
	            }
	            while (ch >= '0' && ch <= '9') {
	                string += ch;
	                next();
	            }
	        }
	        number = +string;
	        if (!isFinite(number)) {
	            error("Bad number");
	        }
	        else {
	            return number;
	        }
	    }, string = function () {
	        // Parse a string value.
	        var hex, i, string = '', uffff;
	        // When parsing for string values, we must look for " and \ characters.
	        if (ch === '"') {
	            while (next()) {
	                if (ch === '"') {
	                    next();
	                    return string;
	                }
	                if (ch === '\\') {
	                    next();
	                    if (ch === 'u') {
	                        uffff = 0;
	                        for (i = 0; i < 4; i += 1) {
	                            hex = parseInt(next(), 16);
	                            if (!isFinite(hex)) {
	                                break;
	                            }
	                            uffff = uffff * 16 + hex;
	                        }
	                        string += String.fromCharCode(uffff);
	                    }
	                    else if (typeof escapee[ch] === 'string') {
	                        string += escapee[ch];
	                    }
	                    else {
	                        break;
	                    }
	                }
	                else {
	                    string += ch;
	                }
	            }
	        }
	        error("Bad string");
	    }, white = function () {
	        // Skip whitespace.
	        while (ch && ch <= ' ') {
	            next();
	        }
	    }, word = function () {
	        // true, false, or null.
	        switch (ch) {
	            case 't':
	                next('t');
	                next('r');
	                next('u');
	                next('e');
	                return true;
	            case 'f':
	                next('f');
	                next('a');
	                next('l');
	                next('s');
	                next('e');
	                return false;
	            case 'n':
	                next('n');
	                next('u');
	                next('l');
	                next('l');
	                return null;
	        }
	        error("Unexpected '" + ch + "'");
	    }, value, // Place holder for the value function.
	    array = function () {
	        // Parse an array value.
	        var array = [];
	        if (ch === '[') {
	            next('[');
	            white();
	            if (ch === ']') {
	                next(']');
	                return array; // empty array
	            }
	            while (ch) {
	                array.push(value());
	                white();
	                if (ch === ']') {
	                    next(']');
	                    return array;
	                }
	                next(',');
	                white();
	            }
	        }
	        error("Bad array");
	    }, object = function () {
	        // Parse an object value.
	        var key, object = {};
	        if (ch === '{') {
	            next('{');
	            white();
	            if (ch === '}') {
	                next('}');
	                return object; // empty object
	            }
	            while (ch) {
	                key = string();
	                white();
	                next(':');
	                if (Object.hasOwnProperty.call(object, key)) {
	                    error('Duplicate key "' + key + '"');
	                }
	                object[key] = value();
	                white();
	                if (ch === '}') {
	                    next('}');
	                    return object;
	                }
	                next(',');
	                white();
	            }
	        }
	        error("Bad object");
	    };
	    value = function () {
	        // Parse a JSON value. It could be an object, an array, a string, a number,
	        // or a word.
	        white();
	        switch (ch) {
	            case '{':
	                return object();
	            case '[':
	                return array();
	            case '"':
	                return string();
	            case '-':
	                return number();
	            default:
	                return ch >= '0' && ch <= '9'
	                    ? number()
	                    : word();
	        }
	    };
	    // Return the json_parse function. It will have access to all of the above
	    // functions and variables.
	    return function (source, reviver) {
	        var result;
	        text = source;
	        at = 0;
	        ch = ' ';
	        result = value();
	        white();
	        if (ch) {
	            error("Syntax error");
	        }
	        // If there is a reviver function, we recursively walk the new structure,
	        // passing each name/value pair to the reviver function for possible
	        // transformation, starting with a temporary root object that holds the result
	        // in an empty key. If there is not a reviver function, we simply return the
	        // result.
	        return typeof reviver === 'function'
	            ? (function walk(holder, key) {
	                var k, v, value = holder[key];
	                if (value && typeof value === 'object') {
	                    for (k in value) {
	                        if (Object.prototype.hasOwnProperty.call(value, k)) {
	                            v = walk(value, k);
	                            if (v !== undefined) {
	                                value[k] = v;
	                            }
	                            else {
	                                delete value[k];
	                            }
	                        }
	                    }
	                }
	                return reviver.call(holder, key, value);
	            }({ '': result }, ''))
	            : result;
	    };
	}());


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var liner = __webpack_require__(471);
	var events_1 = __webpack_require__(19);
	var toPath = ts.toPath;
	var LineIndex = liner.LineIndex;
	var unorderedRemoveItem = ts.unorderedRemoveItem;
	/** BAS : a function I added, useful as we are working without true fs host */
	var toSimplePath = function (fileName) { return toPath(fileName, '', function (x) { return x; }); };
	/** our compiler settings for simple tokenization */
	var defaultCompilerOptions = {
	    jsx: ts.JsxEmit.React,
	    module: ts.ModuleKind.CommonJS,
	    target: ts.ScriptTarget.Latest,
	    experimentalDecorators: true,
	    noLib: true,
	};
	/**
	 * These classes are modified version of session.ts
	 * Same names but modified to not use `fs` / `sys` / `host`
	 */
	var ScriptInfo = /** @class */ (function () {
	    function ScriptInfo(fileName, content, isOpen) {
	        if (isOpen === void 0) { isOpen = false; }
	        this.fileName = fileName;
	        this.content = content;
	        this.isOpen = isOpen;
	        this.children = []; // files referenced by this file
	        this.path = toSimplePath(fileName);
	        this.svc = ScriptVersionCache.fromString(content);
	    }
	    ScriptInfo.prototype.close = function () {
	        this.isOpen = false;
	    };
	    ScriptInfo.prototype.addChild = function (childInfo) {
	        this.children.push(childInfo);
	    };
	    ScriptInfo.prototype.snap = function () {
	        return this.svc.getSnapshot();
	    };
	    ScriptInfo.prototype.getText = function () {
	        var snap = this.snap();
	        return snap.getText(0, snap.getLength());
	    };
	    ScriptInfo.prototype.getLineInfo = function (line) {
	        var snap = this.snap();
	        return snap.index.lineNumberToInfo(line);
	    };
	    ScriptInfo.prototype.editContent = function (start, end, newText) {
	        this.svc.edit(start, end - start, newText);
	    };
	    ScriptInfo.prototype.getTextChangeRangeBetweenVersions = function (startVersion, endVersion) {
	        return this.svc.getTextChangesBetweenVersions(startVersion, endVersion);
	    };
	    ScriptInfo.prototype.getChangeRange = function (oldSnapshot) {
	        return this.snap().getChangeRange(oldSnapshot);
	    };
	    return ScriptInfo;
	}());
	exports.ScriptInfo = ScriptInfo;
	var ScriptVersionCache = /** @class */ (function () {
	    function ScriptVersionCache() {
	        this.changes = [];
	        this.versions = [];
	        this.minVersion = 0; // no versions earlier than min version will maintain change history
	        this.currentVersion = 0;
	    }
	    // REVIEW: can optimize by coalescing simple edits
	    ScriptVersionCache.prototype.edit = function (pos, deleteLen, insertedText) {
	        this.changes[this.changes.length] = new TextChange(pos, deleteLen, insertedText);
	        if ((this.changes.length > ScriptVersionCache.changeNumberThreshold) ||
	            (deleteLen > ScriptVersionCache.changeLengthThreshold) ||
	            (insertedText && (insertedText.length > ScriptVersionCache.changeLengthThreshold))) {
	            this.getSnapshot();
	        }
	    };
	    ScriptVersionCache.prototype.latest = function () {
	        return this.versions[this.currentVersion];
	    };
	    ScriptVersionCache.prototype.latestVersion = function () {
	        if (this.changes.length > 0) {
	            this.getSnapshot();
	        }
	        return this.currentVersion;
	    };
	    // reload whole script, leaving no change history behind reload
	    ScriptVersionCache.prototype.reload = function (script) {
	        this.currentVersion++;
	        this.changes = []; // history wiped out by reload
	        var snap = new LineIndexSnapshot(this.currentVersion, this);
	        this.versions[this.currentVersion] = snap;
	        snap.index = new LineIndex();
	        var lm = LineIndex.linesFromText(script);
	        snap.index.load(lm.lines);
	        // REVIEW: could use linked list
	        for (var i = this.minVersion; i < this.currentVersion; i++) {
	            this.versions[i] = undefined;
	        }
	        this.minVersion = this.currentVersion;
	    };
	    ScriptVersionCache.prototype.getSnapshot = function () {
	        var snap = this.versions[this.currentVersion];
	        if (this.changes.length > 0) {
	            var snapIndex = this.latest().index;
	            for (var i = 0, len = this.changes.length; i < len; i++) {
	                var change = this.changes[i];
	                snapIndex = snapIndex.edit(change.pos, change.deleteLen, change.insertedText);
	            }
	            snap = new LineIndexSnapshot(this.currentVersion + 1, this);
	            snap.index = snapIndex;
	            snap.changesSincePreviousVersion = this.changes;
	            this.currentVersion = snap.version;
	            this.versions[snap.version] = snap;
	            this.changes = [];
	            if ((this.currentVersion - this.minVersion) >= ScriptVersionCache.maxVersions) {
	                var oldMin = this.minVersion;
	                this.minVersion = (this.currentVersion - ScriptVersionCache.maxVersions) + 1;
	                for (var j = oldMin; j < this.minVersion; j++) {
	                    this.versions[j] = undefined;
	                }
	            }
	        }
	        return snap;
	    };
	    ScriptVersionCache.prototype.getTextChangesBetweenVersions = function (oldVersion, newVersion) {
	        if (oldVersion < newVersion) {
	            if (oldVersion >= this.minVersion) {
	                var textChangeRanges = [];
	                for (var i = oldVersion + 1; i <= newVersion; i++) {
	                    var snap = this.versions[i];
	                    for (var j = 0, len = snap.changesSincePreviousVersion.length; j < len; j++) {
	                        var textChange = snap.changesSincePreviousVersion[j];
	                        textChangeRanges[textChangeRanges.length] = textChange.getTextChangeRange();
	                    }
	                }
	                return ts.collapseTextChangeRangesAcrossMultipleVersions(textChangeRanges);
	            }
	            else {
	                return undefined;
	            }
	        }
	        else {
	            return ts.unchangedTextChangeRange;
	        }
	    };
	    ScriptVersionCache.fromString = function (script) {
	        var svc = new ScriptVersionCache();
	        var snap = new LineIndexSnapshot(0, svc);
	        svc.versions[svc.currentVersion] = snap;
	        snap.index = new LineIndex();
	        var lm = LineIndex.linesFromText(script);
	        snap.index.load(lm.lines);
	        return svc;
	    };
	    ScriptVersionCache.changeNumberThreshold = 8;
	    ScriptVersionCache.changeLengthThreshold = 256;
	    ScriptVersionCache.maxVersions = 8;
	    return ScriptVersionCache;
	}());
	exports.ScriptVersionCache = ScriptVersionCache;
	var LineIndexSnapshot = /** @class */ (function () {
	    function LineIndexSnapshot(version, cache) {
	        this.version = version;
	        this.cache = cache;
	        this.changesSincePreviousVersion = [];
	    }
	    LineIndexSnapshot.prototype.getText = function (rangeStart, rangeEnd) {
	        return this.index.getText(rangeStart, rangeEnd - rangeStart);
	    };
	    LineIndexSnapshot.prototype.getLength = function () {
	        return this.index.root.charCount();
	    };
	    // this requires linear space so don't hold on to these
	    LineIndexSnapshot.prototype.getLineStartPositions = function () {
	        var starts = [-1];
	        var count = 1;
	        var pos = 0;
	        this.index.every(function (ll, s, len) {
	            starts[count++] = pos;
	            pos += ll.text.length;
	            return true;
	        }, 0);
	        return starts;
	    };
	    LineIndexSnapshot.prototype.getLineMapper = function () {
	        var _this = this;
	        return (function (line) {
	            return _this.index.lineNumberToInfo(line).offset;
	        });
	    };
	    LineIndexSnapshot.prototype.getTextChangeRangeSinceVersion = function (scriptVersion) {
	        if (this.version <= scriptVersion) {
	            return ts.unchangedTextChangeRange;
	        }
	        else {
	            return this.cache.getTextChangesBetweenVersions(scriptVersion, this.version);
	        }
	    };
	    LineIndexSnapshot.prototype.getChangeRange = function (oldSnapshot) {
	        var oldSnap = oldSnapshot;
	        return this.getTextChangeRangeSinceVersion(oldSnap.version);
	    };
	    return LineIndexSnapshot;
	}());
	exports.LineIndexSnapshot = LineIndexSnapshot;
	// text change information
	var TextChange = /** @class */ (function () {
	    function TextChange(pos, deleteLen, insertedText) {
	        this.pos = pos;
	        this.deleteLen = deleteLen;
	        this.insertedText = insertedText;
	    }
	    TextChange.prototype.getTextChangeRange = function () {
	        return ts.createTextChangeRange(ts.createTextSpan(this.pos, this.deleteLen), this.insertedText ? this.insertedText.length : 0);
	    };
	    return TextChange;
	}());
	exports.TextChange = TextChange;
	var LSHost = /** @class */ (function () {
	    /**
	     * BAS: add configuration arguments
	     * - projectDirectory,
	     * - compilerOptions
	     */
	    function LSHost(projectDirectory, compilerOptions) {
	        if (compilerOptions === void 0) { compilerOptions = defaultCompilerOptions; }
	        var _this = this;
	        this.projectDirectory = projectDirectory;
	        this.compilerOptions = compilerOptions;
	        this.roots = [];
	        this.getDefaultLibFileName = function () { return null; };
	        // BAS : wired to config. Needed for proper `@types` expansion.
	        // See the child class `LanguageServiceHost` implementation below (with more comments).
	        this.getCurrentDirectory = function () { return _this.projectDirectory; };
	        this.filenameToScript = ts.createMap();
	    }
	    LSHost.prototype.getScriptSnapshot = function (filename) {
	        var scriptInfo = this.getScriptInfo(filename);
	        if (scriptInfo) {
	            return scriptInfo.snap();
	        }
	    };
	    LSHost.prototype.lineAffectsRefs = function (filename, line) {
	        var info = this.getScriptInfo(filename);
	        var lineInfo = info.getLineInfo(line);
	        if (lineInfo && lineInfo.text) {
	            var regex = /reference|import|\/\*|\*\//;
	            return regex.test(lineInfo.text);
	        }
	    };
	    // BAS change this to return active project settings for file
	    LSHost.prototype.getCompilationSettings = function () {
	        return this.compilerOptions;
	    };
	    LSHost.prototype.getScriptFileNames = function () {
	        return this.roots.map(function (root) { return root.fileName; });
	    };
	    LSHost.prototype.getScriptVersion = function (filename) {
	        return this.getScriptInfo(filename).svc.latestVersion().toString();
	    };
	    LSHost.prototype.getScriptIsOpen = function (filename) {
	        return this.getScriptInfo(filename).isOpen;
	    };
	    LSHost.prototype.getScriptInfo = function (filename) {
	        var path = toSimplePath(filename);
	        var scriptInfo = this.filenameToScript.get(path);
	        return scriptInfo;
	    };
	    LSHost.prototype.addRoot = function (info) {
	        if (!this.filenameToScript.has(info.path)) {
	            this.filenameToScript.set(info.path, info);
	            this.roots.push(info);
	        }
	    };
	    LSHost.prototype.removeRoot = function (info) {
	        if (!this.filenameToScript.has(info.path)) {
	            this.filenameToScript.delete(info.path);
	            unorderedRemoveItem(this.roots, info);
	        }
	    };
	    LSHost.prototype.editScript = function (filename, start, end, newText) {
	        var script = this.getScriptInfo(filename);
	        if (script) {
	            script.editContent(start, end, newText);
	            return;
	        }
	        throw new Error("No script with name '" + filename + "'");
	    };
	    /**
	     * Add a file with contents
	     */
	    LSHost.prototype.addScript = function (filePath, contents) {
	        var path = toSimplePath(filePath);
	        if (!this.filenameToScript.has(path)) {
	            var info = new ScriptInfo(filePath, contents);
	            this.addRoot(info);
	        }
	    };
	    /**
	     *  @param line 1 based index
	     */
	    LSHost.prototype.lineToTextSpan = function (filename, line) {
	        var path = toSimplePath(filename);
	        var script = this.filenameToScript.get(path);
	        var index = script.snap().index;
	        var lineInfo = index.lineNumberToInfo(line + 1);
	        var len;
	        if (lineInfo.leaf) {
	            len = lineInfo.leaf.text.length;
	        }
	        else {
	            var nextLineInfo = index.lineNumberToInfo(line + 2);
	            len = nextLineInfo.offset - lineInfo.offset;
	        }
	        return ts.createTextSpan(lineInfo.offset, len);
	    };
	    /**
	     * @param line 1 based index
	     * @param offset 1 based index
	     */
	    LSHost.prototype.lineOffsetToPosition = function (filename, line, offset) {
	        var path = toSimplePath(filename);
	        var script = this.filenameToScript.get(path);
	        var index = script.snap().index;
	        var lineInfo = index.lineNumberToInfo(line);
	        // TODO: assert this offset is actually on the line
	        return (lineInfo.offset + offset - 1);
	    };
	    /**
	     * @param line 1-based index
	     * @param offset 1-based index
	     */
	    LSHost.prototype.positionToLineOffset = function (filename, position) {
	        var path = toSimplePath(filename);
	        var script = this.filenameToScript.get(path);
	        var index = script.snap().index;
	        var lineOffset = index.charOffsetToLineNumberAndPos(position);
	        return { line: lineOffset.line, offset: lineOffset.offset + 1 };
	    };
	    return LSHost;
	}());
	exports.LSHost = LSHost;
	/**
	 * BAS:
	 * This class is my own creation.
	 */
	var LanguageServiceHost = /** @class */ (function (_super) {
	    __extends(LanguageServiceHost, _super);
	    function LanguageServiceHost() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /*
	         * LS host can optionally implement these methods to support getImportModuleCompletionsAtPosition.
	         * Without these methods, only completions for ambient modules will be provided.
	         */
	        _this.readDirectory = ts.sys ? ts.sys.readDirectory : undefined;
	        _this.readFile = ts.sys ? ts.sys.readFile : undefined;
	        _this.fileExists = ts.sys ? ts.sys.fileExists : undefined;
	        /**
	         * getDirectories is also required for full import and type reference completions.
	         * Without it defined, certain completions will not be provided
	         */
	        _this.getDirectories = ts.sys ? ts.sys.getDirectories : undefined;
	        /**
	         * For @types expansion, these two functions are needed.
	         */
	        _this.directoryExists = ts.sys ? ts.sys.directoryExists : undefined;
	        _this.getCurrentDirectory = function () {
	            /**
	             * TODO: use the same path as the path of tsconfig.json (if any)
	             * `undefined` is handled correctly in the compiler source :
	             * https://github.com/Microsoft/TypeScript/blob/02493de5ccd9e8c4c901bb154ba584dee392bd14/src/compiler/moduleNameResolver.ts#L98
	             */
	            return _this.projectDirectory;
	        };
	        /**
	         * We allow incremental loading of resources.
	         * Needed for node_modules and for stuff like `user types a require statement`
	         */
	        _this.incrementallyAddedFile = new events_1.TypedEvent();
	        return _this;
	    }
	    LanguageServiceHost.prototype.removeFile = function (filename) {
	        var script = this.getScriptInfo(filename);
	        this.removeRoot(script);
	    };
	    /**
	     * Basically having setContents ensure long term stability even if stuff does get out of sync due to errors in above implementation
	     */
	    LanguageServiceHost.prototype.setContents = function (filename, contents) {
	        var script = this.getScriptInfo(filename);
	        if (script) {
	            script.svc.reload(contents);
	            return;
	        }
	        throw new Error("No script with name '" + filename + "'");
	    };
	    /**
	     * Note : This can be slow
	     */
	    LanguageServiceHost.prototype.getContents = function (filename) {
	        var script = this.getScriptInfo(filename);
	        if (script) {
	            return script.getText();
	        }
	        throw new Error("No script with name '" + filename + "'");
	    };
	    /** 0 based */
	    LanguageServiceHost.prototype.getPositionOfLineAndCharacter = function (filePath, line, ch) {
	        return this.lineOffsetToPosition(filePath, line + 1, ch + 1);
	    };
	    /** 0 based */
	    LanguageServiceHost.prototype.getLineAndCharacterOfPosition = function (filePath, pos) {
	        var res = this.positionToLineOffset(filePath, pos);
	        return { line: res.line - 1, ch: res.offset - 1 };
	    };
	    /** Like parent EditScript but works on EditorPosition */
	    LanguageServiceHost.prototype.applyCodeEdit = function (fileName, start, end, newText) {
	        var minChar = this.getPositionOfLineAndCharacter(fileName, start.line, start.ch);
	        var limChar = this.getPositionOfLineAndCharacter(fileName, end.line, end.ch);
	        _super.prototype.editScript.call(this, fileName, minChar, limChar, newText);
	    };
	    return LanguageServiceHost;
	}(LSHost));
	exports.LanguageServiceHost = LanguageServiceHost;


/***/ },
/* 471 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Debug = ts.Debug;
	/**
	 *  All the line stuff as it is from session.ts
	 */
	var lineCollectionCapacity = 4;
	var LineIndex = /** @class */ (function () {
	    function LineIndex() {
	        // set this to true to check each edit for accuracy
	        this.checkEdits = false;
	    }
	    LineIndex.prototype.charOffsetToLineNumberAndPos = function (charOffset) {
	        return this.root.charOffsetToLineNumberAndPos(1, charOffset);
	    };
	    LineIndex.prototype.lineNumberToInfo = function (lineNumber) {
	        var lineCount = this.root.lineCount();
	        if (lineNumber <= lineCount) {
	            var lineInfo = this.root.lineNumberToInfo(lineNumber, 0);
	            lineInfo.line = lineNumber;
	            return lineInfo;
	        }
	        else {
	            return {
	                line: lineNumber,
	                offset: this.root.charCount()
	            };
	        }
	    };
	    LineIndex.prototype.load = function (lines) {
	        if (lines.length > 0) {
	            var leaves = [];
	            for (var i = 0, len = lines.length; i < len; i++) {
	                leaves[i] = new LineLeaf(lines[i]);
	            }
	            this.root = LineIndex.buildTreeFromBottom(leaves);
	        }
	        else {
	            this.root = new LineNode();
	        }
	    };
	    LineIndex.prototype.walk = function (rangeStart, rangeLength, walkFns) {
	        this.root.walk(rangeStart, rangeLength, walkFns);
	    };
	    LineIndex.prototype.getText = function (rangeStart, rangeLength) {
	        var accum = "";
	        if ((rangeLength > 0) && (rangeStart < this.root.charCount())) {
	            this.walk(rangeStart, rangeLength, {
	                goSubtree: true,
	                done: false,
	                leaf: function (relativeStart, relativeLength, ll) {
	                    accum = accum.concat(ll.text.substring(relativeStart, relativeStart + relativeLength));
	                }
	            });
	        }
	        return accum;
	    };
	    LineIndex.prototype.getLength = function () {
	        return this.root.charCount();
	    };
	    LineIndex.prototype.every = function (f, rangeStart, rangeEnd) {
	        if (!rangeEnd) {
	            rangeEnd = this.root.charCount();
	        }
	        var walkFns = {
	            goSubtree: true,
	            done: false,
	            leaf: function (relativeStart, relativeLength, ll) {
	                if (!f(ll, relativeStart, relativeLength)) {
	                    this.done = true;
	                }
	            }
	        };
	        this.walk(rangeStart, rangeEnd - rangeStart, walkFns);
	        return !walkFns.done;
	    };
	    LineIndex.prototype.edit = function (pos, deleteLength, newText) {
	        function editFlat(source, s, dl, nt) {
	            if (nt === void 0) { nt = ""; }
	            return source.substring(0, s) + nt + source.substring(s + dl, source.length);
	        }
	        if (this.root.charCount() === 0) {
	            // TODO: assert deleteLength === 0
	            if (newText) {
	                this.load(LineIndex.linesFromText(newText).lines);
	                return this;
	            }
	        }
	        else {
	            var checkText = void 0;
	            if (this.checkEdits) {
	                checkText = editFlat(this.getText(0, this.root.charCount()), pos, deleteLength, newText);
	            }
	            var walker = new EditWalker();
	            if (pos >= this.root.charCount()) {
	                // insert at end
	                pos = this.root.charCount() - 1;
	                var endString = this.getText(pos, 1);
	                if (newText) {
	                    newText = endString + newText;
	                }
	                else {
	                    newText = endString;
	                }
	                deleteLength = 0;
	                walker.suppressTrailingText = true;
	            }
	            else if (deleteLength > 0) {
	                // check whether last characters deleted are line break
	                var e = pos + deleteLength;
	                var lineInfo = this.charOffsetToLineNumberAndPos(e);
	                if ((lineInfo && (lineInfo.offset === 0))) {
	                    // move range end just past line that will merge with previous line
	                    deleteLength += lineInfo.text.length;
	                    // store text by appending to end of insertedText
	                    if (newText) {
	                        newText = newText + lineInfo.text;
	                    }
	                    else {
	                        newText = lineInfo.text;
	                    }
	                }
	            }
	            if (pos < this.root.charCount()) {
	                this.root.walk(pos, deleteLength, walker);
	                walker.insertLines(newText);
	            }
	            if (this.checkEdits) {
	                var updatedText = this.getText(0, this.root.charCount());
	                Debug.assert(checkText == updatedText, "buffer edit mismatch");
	            }
	            return walker.lineIndex;
	        }
	    };
	    LineIndex.buildTreeFromBottom = function (nodes) {
	        var nodeCount = Math.ceil(nodes.length / lineCollectionCapacity);
	        var interiorNodes = [];
	        var nodeIndex = 0;
	        for (var i = 0; i < nodeCount; i++) {
	            interiorNodes[i] = new LineNode();
	            var charCount = 0;
	            var lineCount = 0;
	            for (var j = 0; j < lineCollectionCapacity; j++) {
	                if (nodeIndex < nodes.length) {
	                    interiorNodes[i].add(nodes[nodeIndex]);
	                    charCount += nodes[nodeIndex].charCount();
	                    lineCount += nodes[nodeIndex].lineCount();
	                }
	                else {
	                    break;
	                }
	                nodeIndex++;
	            }
	            interiorNodes[i].totalChars = charCount;
	            interiorNodes[i].totalLines = lineCount;
	        }
	        if (interiorNodes.length === 1) {
	            return interiorNodes[0];
	        }
	        else {
	            return this.buildTreeFromBottom(interiorNodes);
	        }
	    };
	    LineIndex.linesFromText = function (text) {
	        var lineStarts = ts.computeLineStarts(text);
	        if (lineStarts.length === 0) {
	            return { lines: [], lineMap: lineStarts };
	        }
	        var lines = new Array(lineStarts.length);
	        var lc = lineStarts.length - 1;
	        for (var lmi = 0; lmi < lc; lmi++) {
	            lines[lmi] = text.substring(lineStarts[lmi], lineStarts[lmi + 1]);
	        }
	        var endText = text.substring(lineStarts[lc]);
	        if (endText.length > 0) {
	            lines[lc] = endText;
	        }
	        else {
	            lines.length--;
	        }
	        return { lines: lines, lineMap: lineStarts };
	    };
	    return LineIndex;
	}());
	exports.LineIndex = LineIndex;
	var LineNode = /** @class */ (function () {
	    function LineNode() {
	        this.totalChars = 0;
	        this.totalLines = 0;
	        this.children = [];
	    }
	    LineNode.prototype.isLeaf = function () {
	        return false;
	    };
	    LineNode.prototype.updateCounts = function () {
	        this.totalChars = 0;
	        this.totalLines = 0;
	        for (var i = 0, len = this.children.length; i < len; i++) {
	            var child = this.children[i];
	            this.totalChars += child.charCount();
	            this.totalLines += child.lineCount();
	        }
	    };
	    LineNode.prototype.execWalk = function (rangeStart, rangeLength, walkFns, childIndex, nodeType) {
	        if (walkFns.pre) {
	            walkFns.pre(rangeStart, rangeLength, this.children[childIndex], this, nodeType);
	        }
	        if (walkFns.goSubtree) {
	            this.children[childIndex].walk(rangeStart, rangeLength, walkFns);
	            if (walkFns.post) {
	                walkFns.post(rangeStart, rangeLength, this.children[childIndex], this, nodeType);
	            }
	        }
	        else {
	            walkFns.goSubtree = true;
	        }
	        return walkFns.done;
	    };
	    LineNode.prototype.skipChild = function (relativeStart, relativeLength, childIndex, walkFns, nodeType) {
	        if (walkFns.pre && (!walkFns.done)) {
	            walkFns.pre(relativeStart, relativeLength, this.children[childIndex], this, nodeType);
	            walkFns.goSubtree = true;
	        }
	    };
	    LineNode.prototype.walk = function (rangeStart, rangeLength, walkFns) {
	        // assume (rangeStart < this.totalChars) && (rangeLength <= this.totalChars)
	        var childIndex = 0;
	        var child = this.children[0];
	        var childCharCount = child.charCount();
	        // find sub-tree containing start
	        var adjustedStart = rangeStart;
	        while (adjustedStart >= childCharCount) {
	            this.skipChild(adjustedStart, rangeLength, childIndex, walkFns, CharRangeSection.PreStart);
	            adjustedStart -= childCharCount;
	            child = this.children[++childIndex];
	            childCharCount = child.charCount();
	        }
	        // Case I: both start and end of range in same subtree
	        if ((adjustedStart + rangeLength) <= childCharCount) {
	            if (this.execWalk(adjustedStart, rangeLength, walkFns, childIndex, CharRangeSection.Entire)) {
	                return;
	            }
	        }
	        else {
	            // Case II: start and end of range in different subtrees (possibly with subtrees in the middle)
	            if (this.execWalk(adjustedStart, childCharCount - adjustedStart, walkFns, childIndex, CharRangeSection.Start)) {
	                return;
	            }
	            var adjustedLength = rangeLength - (childCharCount - adjustedStart);
	            child = this.children[++childIndex];
	            childCharCount = child.charCount();
	            while (adjustedLength > childCharCount) {
	                if (this.execWalk(0, childCharCount, walkFns, childIndex, CharRangeSection.Mid)) {
	                    return;
	                }
	                adjustedLength -= childCharCount;
	                child = this.children[++childIndex];
	                childCharCount = child.charCount();
	            }
	            if (adjustedLength > 0) {
	                if (this.execWalk(0, adjustedLength, walkFns, childIndex, CharRangeSection.End)) {
	                    return;
	                }
	            }
	        }
	        // Process any subtrees after the one containing range end
	        if (walkFns.pre) {
	            var clen = this.children.length;
	            if (childIndex < (clen - 1)) {
	                for (var ej = childIndex + 1; ej < clen; ej++) {
	                    this.skipChild(0, 0, ej, walkFns, CharRangeSection.PostEnd);
	                }
	            }
	        }
	    };
	    LineNode.prototype.charOffsetToLineNumberAndPos = function (lineNumber, charOffset) {
	        var childInfo = this.childFromCharOffset(lineNumber, charOffset);
	        if (!childInfo.child) {
	            return {
	                line: lineNumber,
	                offset: charOffset,
	            };
	        }
	        else if (childInfo.childIndex < this.children.length) {
	            if (childInfo.child.isLeaf()) {
	                return {
	                    line: childInfo.lineNumber,
	                    offset: childInfo.charOffset,
	                    text: (childInfo.child).text,
	                    leaf: (childInfo.child)
	                };
	            }
	            else {
	                var lineNode = (childInfo.child);
	                return lineNode.charOffsetToLineNumberAndPos(childInfo.lineNumber, childInfo.charOffset);
	            }
	        }
	        else {
	            var lineInfo = this.lineNumberToInfo(this.lineCount(), 0);
	            return { line: this.lineCount(), offset: lineInfo.leaf.charCount() };
	        }
	    };
	    LineNode.prototype.lineNumberToInfo = function (lineNumber, charOffset) {
	        var childInfo = this.childFromLineNumber(lineNumber, charOffset);
	        if (!childInfo.child) {
	            return {
	                line: lineNumber,
	                offset: charOffset
	            };
	        }
	        else if (childInfo.child.isLeaf()) {
	            return {
	                line: lineNumber,
	                offset: childInfo.charOffset,
	                text: (childInfo.child).text,
	                leaf: (childInfo.child)
	            };
	        }
	        else {
	            var lineNode = (childInfo.child);
	            return lineNode.lineNumberToInfo(childInfo.relativeLineNumber, childInfo.charOffset);
	        }
	    };
	    LineNode.prototype.childFromLineNumber = function (lineNumber, charOffset) {
	        var child;
	        var relativeLineNumber = lineNumber;
	        var i;
	        var len;
	        for (i = 0, len = this.children.length; i < len; i++) {
	            child = this.children[i];
	            var childLineCount = child.lineCount();
	            if (childLineCount >= relativeLineNumber) {
	                break;
	            }
	            else {
	                relativeLineNumber -= childLineCount;
	                charOffset += child.charCount();
	            }
	        }
	        return {
	            child: child,
	            childIndex: i,
	            relativeLineNumber: relativeLineNumber,
	            charOffset: charOffset
	        };
	    };
	    LineNode.prototype.childFromCharOffset = function (lineNumber, charOffset) {
	        var child;
	        var i;
	        var len;
	        for (i = 0, len = this.children.length; i < len; i++) {
	            child = this.children[i];
	            if (child.charCount() > charOffset) {
	                break;
	            }
	            else {
	                charOffset -= child.charCount();
	                lineNumber += child.lineCount();
	            }
	        }
	        return {
	            child: child,
	            childIndex: i,
	            charOffset: charOffset,
	            lineNumber: lineNumber
	        };
	    };
	    LineNode.prototype.splitAfter = function (childIndex) {
	        var splitNode;
	        var clen = this.children.length;
	        childIndex++;
	        var endLength = childIndex;
	        if (childIndex < clen) {
	            splitNode = new LineNode();
	            while (childIndex < clen) {
	                splitNode.add(this.children[childIndex++]);
	            }
	            splitNode.updateCounts();
	        }
	        this.children.length = endLength;
	        return splitNode;
	    };
	    LineNode.prototype.remove = function (child) {
	        var childIndex = this.findChildIndex(child);
	        var clen = this.children.length;
	        if (childIndex < (clen - 1)) {
	            for (var i = childIndex; i < (clen - 1); i++) {
	                this.children[i] = this.children[i + 1];
	            }
	        }
	        this.children.length--;
	    };
	    LineNode.prototype.findChildIndex = function (child) {
	        var childIndex = 0;
	        var clen = this.children.length;
	        while ((this.children[childIndex] !== child) && (childIndex < clen))
	            childIndex++;
	        return childIndex;
	    };
	    LineNode.prototype.insertAt = function (child, nodes) {
	        var childIndex = this.findChildIndex(child);
	        var clen = this.children.length;
	        var nodeCount = nodes.length;
	        // if child is last and there is more room and only one node to place, place it
	        if ((clen < lineCollectionCapacity) && (childIndex === (clen - 1)) && (nodeCount === 1)) {
	            this.add(nodes[0]);
	            this.updateCounts();
	            return [];
	        }
	        else {
	            var shiftNode = this.splitAfter(childIndex);
	            var nodeIndex = 0;
	            childIndex++;
	            while ((childIndex < lineCollectionCapacity) && (nodeIndex < nodeCount)) {
	                this.children[childIndex++] = nodes[nodeIndex++];
	            }
	            var splitNodes = [];
	            var splitNodeCount = 0;
	            if (nodeIndex < nodeCount) {
	                splitNodeCount = Math.ceil((nodeCount - nodeIndex) / lineCollectionCapacity);
	                splitNodes = new Array(splitNodeCount);
	                var splitNodeIndex = 0;
	                for (var i = 0; i < splitNodeCount; i++) {
	                    splitNodes[i] = new LineNode();
	                }
	                var splitNode = splitNodes[0];
	                while (nodeIndex < nodeCount) {
	                    splitNode.add(nodes[nodeIndex++]);
	                    if (splitNode.children.length === lineCollectionCapacity) {
	                        splitNodeIndex++;
	                        splitNode = splitNodes[splitNodeIndex];
	                    }
	                }
	                for (var i = splitNodes.length - 1; i >= 0; i--) {
	                    if (splitNodes[i].children.length === 0) {
	                        splitNodes.length--;
	                    }
	                }
	            }
	            if (shiftNode) {
	                splitNodes[splitNodes.length] = shiftNode;
	            }
	            this.updateCounts();
	            for (var i = 0; i < splitNodeCount; i++) {
	                splitNodes[i].updateCounts();
	            }
	            return splitNodes;
	        }
	    };
	    // assume there is room for the item; return true if more room
	    LineNode.prototype.add = function (collection) {
	        this.children[this.children.length] = collection;
	        return (this.children.length < lineCollectionCapacity);
	    };
	    LineNode.prototype.charCount = function () {
	        return this.totalChars;
	    };
	    LineNode.prototype.lineCount = function () {
	        return this.totalLines;
	    };
	    return LineNode;
	}());
	exports.LineNode = LineNode;
	var LineLeaf = /** @class */ (function () {
	    function LineLeaf(text) {
	        this.text = text;
	    }
	    LineLeaf.prototype.setUdata = function (data) {
	        this.udata = data;
	    };
	    LineLeaf.prototype.getUdata = function () {
	        return this.udata;
	    };
	    LineLeaf.prototype.isLeaf = function () {
	        return true;
	    };
	    LineLeaf.prototype.walk = function (rangeStart, rangeLength, walkFns) {
	        walkFns.leaf(rangeStart, rangeLength, this);
	    };
	    LineLeaf.prototype.charCount = function () {
	        return this.text.length;
	    };
	    LineLeaf.prototype.lineCount = function () {
	        return 1;
	    };
	    return LineLeaf;
	}());
	exports.LineLeaf = LineLeaf;
	var CharRangeSection;
	(function (CharRangeSection) {
	    CharRangeSection[CharRangeSection["PreStart"] = 0] = "PreStart";
	    CharRangeSection[CharRangeSection["Start"] = 1] = "Start";
	    CharRangeSection[CharRangeSection["Entire"] = 2] = "Entire";
	    CharRangeSection[CharRangeSection["Mid"] = 3] = "Mid";
	    CharRangeSection[CharRangeSection["End"] = 4] = "End";
	    CharRangeSection[CharRangeSection["PostEnd"] = 5] = "PostEnd";
	})(CharRangeSection = exports.CharRangeSection || (exports.CharRangeSection = {}));
	var BaseLineIndexWalker = /** @class */ (function () {
	    function BaseLineIndexWalker() {
	        this.goSubtree = true;
	        this.done = false;
	    }
	    BaseLineIndexWalker.prototype.leaf = function (rangeStart, rangeLength, ll) {
	    };
	    return BaseLineIndexWalker;
	}());
	var EditWalker = /** @class */ (function (_super) {
	    __extends(EditWalker, _super);
	    function EditWalker() {
	        var _this = _super.call(this) || this;
	        _this.lineIndex = new LineIndex();
	        _this.endBranch = [];
	        _this.state = CharRangeSection.Entire;
	        _this.initialText = "";
	        _this.trailingText = "";
	        _this.suppressTrailingText = false;
	        _this.lineIndex.root = new LineNode();
	        _this.startPath = [_this.lineIndex.root];
	        _this.stack = [_this.lineIndex.root];
	        return _this;
	    }
	    EditWalker.prototype.insertLines = function (insertedText) {
	        if (this.suppressTrailingText) {
	            this.trailingText = "";
	        }
	        if (insertedText) {
	            insertedText = this.initialText + insertedText + this.trailingText;
	        }
	        else {
	            insertedText = this.initialText + this.trailingText;
	        }
	        var lm = LineIndex.linesFromText(insertedText);
	        var lines = lm.lines;
	        if (lines.length > 1) {
	            if (lines[lines.length - 1] == "") {
	                lines.length--;
	            }
	        }
	        var branchParent;
	        var lastZeroCount;
	        for (var k = this.endBranch.length - 1; k >= 0; k--) {
	            this.endBranch[k].updateCounts();
	            if (this.endBranch[k].charCount() === 0) {
	                lastZeroCount = this.endBranch[k];
	                if (k > 0) {
	                    branchParent = this.endBranch[k - 1];
	                }
	                else {
	                    branchParent = this.branchNode;
	                }
	            }
	        }
	        if (lastZeroCount) {
	            branchParent.remove(lastZeroCount);
	        }
	        // path at least length two (root and leaf)
	        var insertionNode = this.startPath[this.startPath.length - 2];
	        var leafNode = this.startPath[this.startPath.length - 1];
	        var len = lines.length;
	        if (len > 0) {
	            leafNode.text = lines[0];
	            if (len > 1) {
	                var insertedNodes = new Array(len - 1);
	                var startNode = leafNode;
	                for (var i = 1, len_1 = lines.length; i < len_1; i++) {
	                    insertedNodes[i - 1] = new LineLeaf(lines[i]);
	                }
	                var pathIndex = this.startPath.length - 2;
	                while (pathIndex >= 0) {
	                    insertionNode = this.startPath[pathIndex];
	                    insertedNodes = insertionNode.insertAt(startNode, insertedNodes);
	                    pathIndex--;
	                    startNode = insertionNode;
	                }
	                var insertedNodesLen = insertedNodes.length;
	                while (insertedNodesLen > 0) {
	                    var newRoot = new LineNode();
	                    newRoot.add(this.lineIndex.root);
	                    insertedNodes = newRoot.insertAt(this.lineIndex.root, insertedNodes);
	                    insertedNodesLen = insertedNodes.length;
	                    this.lineIndex.root = newRoot;
	                }
	                this.lineIndex.root.updateCounts();
	            }
	            else {
	                for (var j = this.startPath.length - 2; j >= 0; j--) {
	                    this.startPath[j].updateCounts();
	                }
	            }
	        }
	        else {
	            // no content for leaf node, so delete it
	            insertionNode.remove(leafNode);
	            for (var j = this.startPath.length - 2; j >= 0; j--) {
	                this.startPath[j].updateCounts();
	            }
	        }
	        return this.lineIndex;
	    };
	    EditWalker.prototype.post = function (relativeStart, relativeLength, lineCollection, parent, nodeType) {
	        // have visited the path for start of range, now looking for end
	        // if range is on single line, we will never make this state transition
	        if (lineCollection === this.lineCollectionAtBranch) {
	            this.state = CharRangeSection.End;
	        }
	        // always pop stack because post only called when child has been visited
	        this.stack.length--;
	        return undefined;
	    };
	    EditWalker.prototype.pre = function (relativeStart, relativeLength, lineCollection, parent, nodeType) {
	        // currentNode corresponds to parent, but in the new tree
	        var currentNode = this.stack[this.stack.length - 1];
	        if ((this.state === CharRangeSection.Entire) && (nodeType === CharRangeSection.Start)) {
	            // if range is on single line, we will never make this state transition
	            this.state = CharRangeSection.Start;
	            this.branchNode = currentNode;
	            this.lineCollectionAtBranch = lineCollection;
	        }
	        var child;
	        function fresh(node) {
	            if (node.isLeaf()) {
	                return new LineLeaf("");
	            }
	            else
	                return new LineNode();
	        }
	        switch (nodeType) {
	            case CharRangeSection.PreStart:
	                this.goSubtree = false;
	                if (this.state !== CharRangeSection.End) {
	                    currentNode.add(lineCollection);
	                }
	                break;
	            case CharRangeSection.Start:
	                if (this.state === CharRangeSection.End) {
	                    this.goSubtree = false;
	                }
	                else {
	                    child = fresh(lineCollection);
	                    currentNode.add(child);
	                    this.startPath[this.startPath.length] = child;
	                }
	                break;
	            case CharRangeSection.Entire:
	                if (this.state !== CharRangeSection.End) {
	                    child = fresh(lineCollection);
	                    currentNode.add(child);
	                    this.startPath[this.startPath.length] = child;
	                }
	                else {
	                    if (!lineCollection.isLeaf()) {
	                        child = fresh(lineCollection);
	                        currentNode.add(child);
	                        this.endBranch[this.endBranch.length] = child;
	                    }
	                }
	                break;
	            case CharRangeSection.Mid:
	                this.goSubtree = false;
	                break;
	            case CharRangeSection.End:
	                if (this.state !== CharRangeSection.End) {
	                    this.goSubtree = false;
	                }
	                else {
	                    if (!lineCollection.isLeaf()) {
	                        child = fresh(lineCollection);
	                        currentNode.add(child);
	                        this.endBranch[this.endBranch.length] = child;
	                    }
	                }
	                break;
	            case CharRangeSection.PostEnd:
	                this.goSubtree = false;
	                if (this.state !== CharRangeSection.Start) {
	                    currentNode.add(lineCollection);
	                }
	                break;
	        }
	        if (this.goSubtree) {
	            this.stack[this.stack.length] = child;
	        }
	        return lineCollection;
	    };
	    // just gather text from the leaves
	    EditWalker.prototype.leaf = function (relativeStart, relativeLength, ll) {
	        if (this.state === CharRangeSection.Start) {
	            this.initialText = ll.text.substring(0, relativeStart);
	        }
	        else if (this.state === CharRangeSection.Entire) {
	            this.initialText = ll.text.substring(0, relativeStart);
	            this.trailingText = ll.text.substring(relativeStart + relativeLength);
	        }
	        else {
	            // state is CharRangeSection.End
	            this.trailingText = ll.text.substring(relativeStart + relativeLength);
	        }
	    };
	    return EditWalker;
	}(BaseLineIndexWalker));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(19);
	var utils_1 = __webpack_require__(3);
	var equal = __webpack_require__(91);
	// What we use to identify a unique error
	var errorKey = function (error) { return error.from.line + ":" + error.from.ch + ":" + error.message; };
	/**
	 * Maintains the list of errors that have been encountered,
	 * and notifies anyone who is concerned of updated values
	 */
	var ErrorsCache = /** @class */ (function () {
	    function ErrorsCache() {
	        var _this = this;
	        /**
	         * When a cache boots up (e.g. server restart). Its good to know if its an initial errors delta
	         * If so the client might want to clear all previous errors
	         */
	        this.initial = true;
	        /**
	         * Event that can be wired up to sync one error cache with another
	         */
	        this.errorsDelta = new events_1.TypedEvent();
	        /**
	         * You can wire up an errors Delta from one cache to this one.
	         */
	        this.applyDelta = function (delta) {
	            // Added:
	            Object.keys(delta.added).forEach(function (fp) {
	                if (!_this._errorsByFilePath[fp])
	                    _this._errorsByFilePath[fp] = delta.added[fp];
	                else
	                    _this._errorsByFilePath[fp] = _this._errorsByFilePath[fp].concat(delta.added[fp]);
	            });
	            // Removed:
	            Object.keys(delta.removed).forEach(function (fp) {
	                var removedErrorsMap = utils_1.createMapByKey(delta.removed[fp], errorKey);
	                _this._errorsByFilePath[fp] = (_this._errorsByFilePath[fp] || []).filter(function (e) { return !removedErrorsMap[errorKey(e)]; });
	            });
	            _this.sendErrors();
	        };
	        /**
	         *  DELTA MAINTAINANCE
	         */
	        this.lastErrorsByFilePath = {};
	        /**
	         * current errors
	         */
	        this._errorsByFilePath = {};
	        /**
	         * debounced as constantly sending errors quickly degrades the web experience
	         */
	        this.sendErrors = utils_1.debounce(function () {
	            // Create a delta
	            var oldErrorsByFilePath = _this.lastErrorsByFilePath;
	            var newErrorsByFilePath = _this._errorsByFilePath;
	            var delta = {
	                added: {},
	                removed: {},
	                initial: _this.initial,
	            };
	            _this.initial = false;
	            // Added:
	            Object.keys(newErrorsByFilePath).forEach(function (filePath) {
	                var newErrors = newErrorsByFilePath[filePath];
	                // All new
	                if (!oldErrorsByFilePath[filePath]) {
	                    delta.added[filePath] = newErrors;
	                }
	                else {
	                    var oldErrors = oldErrorsByFilePath[filePath];
	                    var oldErrorMap_1 = utils_1.createMapByKey(oldErrors, errorKey);
	                    newErrors.forEach(function (ne) {
	                        var newErrorKey = errorKey(ne);
	                        if (!oldErrorMap_1[newErrorKey]) {
	                            if (!delta.added[filePath])
	                                delta.added[filePath] = [];
	                            delta.added[filePath].push(ne);
	                        }
	                    });
	                }
	            });
	            // Removed:
	            Object.keys(oldErrorsByFilePath).forEach(function (filePath) {
	                var oldErrors = oldErrorsByFilePath[filePath];
	                // All gone
	                if (!newErrorsByFilePath[filePath]) {
	                    delta.removed[filePath] = oldErrors;
	                }
	                else {
	                    var newErrors = newErrorsByFilePath[filePath];
	                    var newErrorMap_1 = utils_1.createMapByKey(newErrors, errorKey);
	                    oldErrors.forEach(function (oe) {
	                        var oldErrorKey = errorKey(oe);
	                        if (!newErrorMap_1[oldErrorKey]) {
	                            if (!delta.removed[filePath])
	                                delta.removed[filePath] = [];
	                            delta.removed[filePath].push(oe);
	                        }
	                    });
	                }
	            });
	            // Send out the delta
	            _this.errorsDelta.emit(delta);
	            // Preserve for future delta
	            _this.lastErrorsByFilePath = {};
	            Object.keys(_this._errorsByFilePath).map(function (fp) { return _this.lastErrorsByFilePath[fp] = _this._errorsByFilePath[fp]; });
	        }, 250);
	        /** The pased errors are considered *the only current* errors for the filePath */
	        this.setErrorsByFilePaths = function (filePaths, errors) {
	            var somethingNew = false;
	            // For all found errors add them
	            var errorsByFile = utils_1.createMapByKey(errors, function (e) { return e.filePath; });
	            for (var filePath in errorsByFile) {
	                if (!equal(_this._errorsByFilePath[filePath], errorsByFile[filePath])) {
	                    somethingNew = true;
	                    _this._errorsByFilePath[filePath] = errorsByFile[filePath];
	                }
	            }
	            // For not found errors clear them
	            for (var _i = 0, filePaths_1 = filePaths; _i < filePaths_1.length; _i++) {
	                var filePath = filePaths_1[_i];
	                if (!errorsByFile[filePath] && (_this._errorsByFilePath[filePath] && _this._errorsByFilePath[filePath].length)) {
	                    somethingNew = true;
	                    _this._errorsByFilePath[filePath] = [];
	                }
	            }
	            if (somethingNew) {
	                _this.sendErrors();
	            }
	        };
	        /**
	         * * Sending massive error lists *constantly* can quickly degrade the web experience
	         * - only send 50 errors per file or 200+ errors total
	         */
	        this.getErrorsLimited = function () {
	            var limitedCopy = {};
	            var total = 0;
	            for (var filePath in _this._errorsByFilePath) {
	                var errors = _this._errorsByFilePath[filePath];
	                if (errors.length > 50)
	                    errors = errors.slice(0, 50);
	                limitedCopy[filePath] = errors;
	                total += errors.length;
	                if (total > 200)
	                    break;
	            }
	            var totalCount = Object.keys(_this._errorsByFilePath)
	                .map(function (x) { return _this._errorsByFilePath[x].length; })
	                .reduce(function (acc, i) { return acc + i; }, 0);
	            return { errorsByFilePath: limitedCopy, totalCount: totalCount, syncCount: total, tooMany: total !== totalCount };
	        };
	        /**
	         * Get/Set all the errors for an initial sync between error caches
	         */
	        this.getErrors = function () { return _this._errorsByFilePath; };
	        this.setErrors = function (errorsByFilePath) { return _this._errorsByFilePath = errorsByFilePath; };
	        /** Only used for debugging */
	        this.debugGetErrorsFlattened = function () {
	            return Object.keys(_this._errorsByFilePath)
	                .map(function (x) { return _this._errorsByFilePath[x]; })
	                .reduce(function (acc, x) { return acc.concat(x); }, []);
	        };
	        /**
	         * Clear all errors. Resets the cache.
	         *
	         * Also good or an initial sync.
	         * e.g. when the socket server reboots
	         *   it wants to clear any errors that any connected clicks might have
	         */
	        this.clearErrors = function () {
	            _this._errorsByFilePath = {};
	            _this.sendErrors();
	        };
	        /** Utility to provide a semantic name to *clearing errors*  */
	        this.clearErrorsForFilePath = function (filePath) {
	            _this._errorsByFilePath[filePath] = [];
	            _this.sendErrors();
	        };
	        /** If a source goes down (crashes) and it comes back we want to clear any knowledge of previous errors by source */
	        this.clearErrorsForSource = function (source) {
	            var errorsByFilePath = Object.create(null);
	            for (var filePath in _this._errorsByFilePath) {
	                var errors = _this._errorsByFilePath[filePath];
	                errorsByFilePath[filePath] = errors.filter(function (e) { return e.source !== source; });
	            }
	            _this._errorsByFilePath = errorsByFilePath;
	            _this.sendErrors();
	        };
	        /** Utility to query */
	        this.getErrorsForFilePath = function (filePath) {
	            return _this._errorsByFilePath[filePath] || [];
	        };
	    }
	    return ErrorsCache;
	}());
	exports.ErrorsCache = ErrorsCache;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(19);
	var utils_1 = __webpack_require__(3);
	var equal = __webpack_require__(91);
	// What we use to identify a unique test
	var same = function (a, b) {
	    return equal(a, b);
	};
	/**
	 * Maintains the list of tests that have been encountered,
	 * and notifies anyone who is concerned of updated values
	 */
	var TestResultsCache = /** @class */ (function () {
	    function TestResultsCache() {
	        var _this = this;
	        /**
	         * When a cache boots up (e.g. server restart). Its good to know if its an initial test run
	         * If so the client might want to clear all previous results
	         */
	        this.initial = true;
	        /**
	         * Event that can be wired up to sync one cache with another
	         */
	        this.testResultsDelta = new events_1.TypedEvent();
	        /**
	         * You can wire up an errors Delta from one cache to this one.
	         */
	        this.applyTestResultsDelta = function (delta) {
	            if (delta.initial) {
	                _this.current = delta.updatedModuleMap;
	            }
	            else {
	                Object.keys(delta.updatedModuleMap).forEach(function (filePath) {
	                    _this.current[filePath] = delta.updatedModuleMap[filePath];
	                });
	                delta.clearedModules.forEach(function (fp) {
	                    delete _this.current[fp];
	                });
	            }
	            _this.sendDelta();
	        };
	        /**
	         *  DELTA MAINTAINANCE
	         */
	        this.last = Object.create(null);
	        /**
	         * current errors
	         */
	        this.current = Object.create(null);
	        /**
	         * debounced as constantly sending updates quickly degrades the web experience
	         */
	        this.sendDelta = utils_1.debounce(function () {
	            // TODO Create a delta
	            var last = _this.last;
	            var current = _this.current;
	            var delta = {
	                updatedModuleMap: Object.create(null),
	                clearedModules: [],
	                initial: _this.initial,
	            };
	            _this.initial = false;
	            Object.keys(current).forEach(function (fp) {
	                // Added
	                if (!last[fp]) {
	                    delta.updatedModuleMap[fp] = current[fp];
	                }
	                else if (!same(current[fp], last[fp])) {
	                    delta.updatedModuleMap[fp] = current[fp];
	                }
	            });
	            /** Removed */
	            Object.keys(last).forEach(function (fp) {
	                if (!_this.current[fp]) {
	                    delta.clearedModules.push(fp);
	                }
	            });
	            // Preserve for future delta
	            _this.last = Object.create(null);
	            Object.keys(_this.current).map(function (fp) { return _this.last[fp] = _this.current[fp]; });
	            // Send out the delta
	            _this.testResultsDelta.emit(delta);
	        }, 250);
	        /** The passed results are considered the only ones. All else is cleared */
	        this.setResultsTotal = function (results) {
	            _this.current = Object.create(null);
	            results.forEach(function (res) {
	                _this.current[res.filePath] = res;
	            });
	            _this.sendDelta();
	        };
	        /** Only for one file */
	        this.addResult = function (result) {
	            _this.current[result.filePath] = result;
	            _this.sendDelta();
	        };
	        /**
	         * Clear all results. Resets the cache.
	         *
	         * Also good or an initial sync.
	         * e.g. when the socket server reboots
	         *   it wants to clear any errors that any connected clicks might have
	         */
	        this.clearResults = function () {
	            _this.current = Object.create(null);
	            _this.sendDelta();
	        };
	        /**
	         * Get the last results so you can start listening to new deltas
	         */
	        this.getResults = function () { return _this.last; };
	        /** set after initial sync */
	        this.setResults = function (results) {
	            _this.current = results;
	            _this.sendDelta();
	        };
	        /**
	         * Collects overall stats
	         */
	        this.getStats = function () {
	            var allModules = Object.keys(_this.current).map(function (k) { return _this.current[k]; });
	            var sumReducer = function (arr) { return arr.reduce(function (i, acc) { return acc + i; }, 0); };
	            var result = {
	                testCount: sumReducer(allModules.map(function (x) { return x.stats.testCount; })),
	                passCount: sumReducer(allModules.map(function (x) { return x.stats.passCount; })),
	                failCount: sumReducer(allModules.map(function (x) { return x.stats.failCount; })),
	                skipCount: sumReducer(allModules.map(function (x) { return x.stats.skipCount; })),
	                durationMs: sumReducer(allModules.map(function (x) { return x.stats.durationMs; })),
	            };
	            return result;
	        };
	    }
	    return TestResultsCache;
	}());
	exports.TestResultsCache = TestResultsCache;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var socketLib_1 = __webpack_require__(165);
	var socketIo = io;
	var origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	exports.resolve = Promise.resolve.bind(Promise);
	/** This is your main function to launch the client */
	function run(config) {
	    var client = new Client(config.clientImplementation);
	    var server = client.sendAllToSocket(config.serverContract);
	    var cast = client.setupAllCast(config.cast);
	    var pendingRequestsChanged = new socketLib_1.TypedEvent();
	    client.pendingRequestsChanged = function (pending) { return pendingRequestsChanged.emit({ pending: pending }); };
	    return { client: client, server: server, cast: cast, pendingRequestsChanged: pendingRequestsChanged, connectionStatusChanged: client.connectionStatusChanged };
	}
	exports.run = run;
	var Client = /** @class */ (function (_super) {
	    __extends(Client, _super);
	    function Client(clientImplementation) {
	        var _this = _super.call(this) || this;
	        _this.getSocket = function () { return _this.socket; };
	        _this.connectionStatusChanged = new socketLib_1.TypedEvent();
	        _this.typedEvents = {};
	        _this.socket = io.connect(origin);
	        // Also provide the following services to the server
	        _this.registerAllFunctionsExportedFromAsResponders(clientImplementation);
	        _this.startListening();
	        _this.socket.on(socketLib_1.anycastMessageName, function (msg) {
	            _this.typedEvents[msg.message].emit(msg.data);
	        });
	        var connected = false;
	        setInterval(function () {
	            var newConnected = _this.socket.connected;
	            if (newConnected != connected) {
	                connected = newConnected;
	                _this.connectionStatusChanged.emit({ connected: connected });
	            }
	        }, 2000);
	        return _this;
	    }
	    /**
	     * Each member of `instance` must be a typed event
	     * we wire these up to be emitted in the client if an emit is called on the server
	     */
	    Client.prototype.setupAllCast = function (instance) {
	        var _this = this;
	        Object.keys(instance).forEach(function (name) {
	            // Override the actual emit function with one that sends it on to the server
	            _this.typedEvents[name] = instance[name];
	        });
	        return instance;
	    };
	    return Client;
	}(socketLib_1.RequesterResponder));
	exports.Client = Client;


/***/ },
/* 475 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 476 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 477 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 478 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/